/**
 * 多语言配置
 * zh：中文
 * en：英文
 * id：印尼语
 * kz：哈萨克语
 * th：泰语
 * ug：维吾尔语
 * vi：越南语
 * zh_tc：繁体中文
 * ru：俄语
 * ko：韩语
 * bur：缅甸语
 * ben：孟加拉语
 * tr：土耳其语
 * km：柬埔寨语
 * es：西班牙语
 * ar：阿拉伯语
 */

export default {
  'common.noFace': {
    zh: '无正反',
    en: 'No face',
    id: 'Tidak ada wajah',
    kz: 'Жүйрік бет жоқ',
    th: 'ไม่มีหน้า',
    ug: 'ئادەم بەت ناتۇ',
    vi: 'Không có mặt',
    zh_tc: '無正反',
    ru: 'Без лицевой стороны',
    ko: '얼굴이 없습니다',
    bur: 'မြင်းချိုးမရှိပါ',
    ben: 'কোনো মুখ নেই',
    tr: 'Yüz yok',
    km: 'មិនមានរបស់មាត្រ',
    es: 'Sin cara',
    ar: 'لا يوجد وجه',
  },
  'common.noPermissionTip': {
    zh: '您暂无此功能的使用权限，请购买或续费后再进行操作。',
    en: 'You do not have permission to use this feature. Please purchase or renew to continue.',
    id: 'Anda tidak memiliki izin untuk menggunakan fitur ini. Silakan membeli atau memperpanjang izin untuk melanjutkan.',
    kz: 'Бұл қызметті қолдануға рұқсатыңыз жоқ. Қалыптастыру үшін тіркеліңіз',
    th: 'คุณไม่มีสิทธิใช้งานฟีเจอร์นี้ โปรดซื้อหรือขยายสิทธิใช้งานเพื่อดำเนินการต่อ',
    ug: 'بىر فانک قىلىشقا سىلەر ئىشلەتىشىڭىز، ئىشلەتىشقا قوشۇڭ',
    vi: 'Bạn không có quyền sử dụng tính năng này. Vui lòng mua hoặc gia hạn để tiếp tục.',
    zh_tc: '您暫無此功能的使用權限，請購買或續費後再進行操作。',
    ru: 'У вас нет разрешения на использование этой функции. Пожалуйста, приобретите или продлите для продолжения.',
    ko: '이 기능을 사용할 수 없습니다. 구매 또는 갱신 후 계속하세요.',
    bur: 'ဤဝန်ဆောင်မှုကို အသုံးပြုနိူင်သည်မဟုတ်ပါ။ ပြီးပါးပြီး အသုံးပြုပါ။',
    ben: 'এই বৈশিষ্ট্যটি ব্যবহার করতে আপনার অনুমতি নেই। অনুমতি কেনা বা পুনরায় করা আগে চালিয়ে যান।',
    tr: 'Bu özelliği kullanmak için izininiz yok. Devam etmek için lütfen satın alın veya yenileyin.',
    km: 'អ្នកមិនមានសិទ្ធិសម្រាប់ការប្រើប្រាស់កម្មវិធីនេះ។ សូមជ្រើសរើសចូលរួម ឬការជ្រើសរើសបន្ថែមដើម្បីបន្ត។',
    es: 'No tienes permiso para usar esta función. Por favor, compra o renueva para continuar.',
    ar: 'ليس لديك صلاحية لاستخدام هذه الميزة. يرجى شراء أو تجديد للمتابعة.',
  },
  'common.selected': {
    zh: '选中',
    en: 'Selected',
    id: 'Terpilih',
    kz: 'Таңдалды',
    th: 'เลือก',
    ug: 'تاللانغان',
    vi: 'Đã chọn',
    zh_tc: '選中',
    ru: 'Выбран',
    ko: '선택되다',
    bur: 'ရွေးချယ်ထားသည်',
    ben: 'নির্বাচিত',
    tr: 'Seçildi',
    km: 'បានជ្រើសរើស',
    es: 'Seleccione',
    ar: 'حدد',
  },
  'common.continue': {
    zh: '继续',
    en: 'Continue',
    id: 'Lanjutkan',
    kz: 'Жалғастыру',
    th: 'ต่อไป',
    ug: 'ئاشتۇرۇش',
    vi: 'Tiếp tục',
    zh_tc: '繼續',
    ru: 'Продолжить',
    ko: '계속',
    bur: 'ဆက်လက်',
    ben: 'চালিয়ে যান',
    tr: 'Devam et',
    km: 'បន្ត',
  },
  'common.open1': {
    zh: '打开',
    en: 'Open',
    id: 'Buka',
    kz: 'Ашу',
    th: 'เปิด',
    ug: 'ئېچىش',
    vi: 'Mở',
    zh_tc: '打開',
    ru: 'Открыть',
    ko: '열다',
    bur: 'ဖွင့်ပါ',
    ben: 'খুলুন',
    tr: 'Aç',
    km: 'បើក',
    es: 'Abrir',
    ar: 'فتح',
  },

  'common.doubleClick': {
    zh: '双击',
    en: 'Double-click',
    id: 'Klik Dua Kali',
    kz: 'Екі рет басу',
    th: 'ดับเบิลคลิก',
    ug: 'قوش چېكىش',
    vi: 'Nhấp đúp',
    zh_tc: '雙擊',
    ru: 'Двойной клик',
    ko: '더블 클릭',
    bur: 'နှစ်ချက်နှိပ်ပါ',
    ben: 'ডাবল ক্লিক করুন',
    tr: 'Çift tıkla',
    km: 'ចុចពីរដង',
    es: 'Haga doble clic',
    ar: 'انقر نقرًا مزدوجًا',
  },
  'common.inputKeywordSearch': {
    zh: '输入关键词搜索',
    en: 'Enter keyword search',
    id: 'Masukkan kata kunci pencarian',
    kz: 'Кілт сөзді іздеу енгізіңіз',
    th: 'ป้อนคำค้นหา',
    ug: 'ئاچقۇچلۇق سۆز ئىزدەش كىرگۈزۈڭ',
    vi: 'Nhập từ khóa tìm kiếm',
    zh_tc: '輸入關鍵詞搜索',
    ru: 'Введите ключевое слово для поиска',
    ko: '키워드 검색 입력',
    bur: 'သော့ချက်ကိုရိုက်ထည့်၍ ရှာဖွေပါ',
    ben: 'কীওয়ার্ড লিখে অনুসন্ধান করুন',
    tr: 'Arama anahtar kelimesi girin',
    km: 'បញ្ចូលពាក្យគន្លឹះស្វែងរក',
    es: 'Ingrese la búsqueda por palabra clave',
    ar: 'أدخل البحث عن الكلمات الرئيسية',
  },
  'common.inputKeywordStartSearch': {
    zh: '输入关键字开始搜索',
    en: 'Enter keyword to start search',
    id: 'Masukkan kata kunci untuk memulai pencarian',
    kz: 'Іздеуді бастау үшін кілт сөз енгізіңіз',
    th: 'ป้อนคำค้นหาเพื่อเริ่มการค้นหา',
    ug: 'ئىزدەشنى باشلاش ئۈچۈن ئاچقۇچلۇق سۆز كىرگۈزۈڭ',
    vi: 'Nhập từ khóa để bắt đầu tìm kiếm',
    zh_tc: '輸入關鍵字開始搜索',
    ru: 'Введите ключевое слово для начала поиска',
    ko: '키워드를 입력하여 검색 시작',
    bur: 'ရှာဖွေမှုစတင်ရန် သော့ချက်ထည့်ပါ',
    ben: 'অনুসন্ধান শুরু করতে কীওয়ার্ড লিখুন',
    tr: 'Arama anahtar kelimesi girin',
    km: 'បញ្ចូលពាក្យគន្លឹះដើម្បីចាប់ផ្តើមស្វែងរក',
    es: 'Ingrese la palabra clave para iniciar la búsqueda',
    ar: 'أدخل الكلمة الأساسية لبدء البحث',
  },
  'common.searchHistory': {
    zh: '搜索历史',
    en: 'Search History',
    id: 'Riwayat Pencarian',
    kz: 'Іздеу тарихы',
    th: 'ประวัติการค้นหา',
    ug: 'ئىزدەش تارىخى',
    vi: 'Lịch sử tìm kiếm',
    zh_tc: '搜索歷史',
    ru: 'История поиска',
    ko: '검색 내역',
    bur: 'ရှာဖွေမှုသမိုင်း',
    ben: 'অনুসন্ধানের ইতিহাস',
    tr: 'Arama geçmişi',
    km: 'ប្រវត្តិស្វែងរក',
    es: 'Historial de búsqueda',
    ar: 'سجل البحث',
  },
  'common.clearHistory': {
    zh: '清除历史记录',
    en: 'Clear History',
    id: 'Hapus Riwayat',
    kz: 'Тарихты тазалау',
    th: 'ลบประวัติ',
    ug: 'تارىخنى تازىلاش',
    vi: 'Xóa lịch sử',
    zh_tc: '清除歷史記錄',
    ru: 'Очистить историю',
    ko: '기록 지우기',
    bur: 'သမိုင်းဖျက်ပါ',
    ben: 'ইতিহাস মুছুন',
    tr: 'Geçmişi temizle',
    km: 'លុបប្រវត្តិ',
    es: 'Borrar historial',
    ar: 'مسح التاريخ',
  },
  'common.notFoundRelatedResults': {
    zh: '未找到相关结果',
    en: 'No related results found',
    id: 'Tidak ditemukan hasil terkait',
    kz: 'Байланысты нәтижелер табылмады',
    th: 'ไม่พบผลลัพธ์ที่เกี่ยวข้อง',
    ug: 'مۇناسىۋەتلىك نەتىجە تېپىلمىدى',
    vi: 'Không tìm thấy kết quả liên quan',
    zh_tc: '未找到相關結果',
    ru: 'Не найдено связанных результатов',
    ko: '관련 결과를 찾을 수 없음',
    bur: 'ဆက်စပ်ရလဒ်မတွေ့ပါ',
    ben: 'সম্পর্কিত ফলাফল পাওয়া যায়নি',
    tr: 'İlgili sonuçlar bulunamadı',
    km: 'មិនឃើញលទ្ធផលពាក់ព័ន្ធ',
    es: 'No se encontraron resultados relevantes',
    ar: 'لم يتم العثور على نتائج ذات صلة',
  },
  'common.switch': {
    zh: '切换',
    en: 'Switch',
    id: 'Beralih',
    kz: 'Ауыстыру',
    th: 'สลับ',
    ug: 'ئالماشتۇرۇش',
    vi: 'Chuyển đổi',
    zh_tc: '切換',
    ru: 'Переключить',
    ko: '전환',
    bur: 'ပြောင်းလဲပါ',
    ben: 'পরিবর্তন করুন',
    tr: 'Değiştir',
    km: 'ប្ដូរ',
    es: 'Cambiar',
    ar: 'تبديل',
  },
  'common.searchProductionLine': {
    zh: '设备生产线',
    en: 'Production Line',
    id: 'Jalur Produksi',
    kz: 'Өндіріс желісі',
    th: 'สายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيەسى',
    vi: 'Dây chuyền sản xuất',
    zh_tc: '設備生產線',
    ru: 'Производственная линия',
    ko: '설비 생산 라인',
    bur: 'ထုတ်လုပ်ရေးလိုင်း',
    ben: 'উৎপাদন লাইন',
    tr: 'Üretim Hattı',
    km: 'ខ្សែផលិតកម្ម',
    es: 'Línea de producción de equipos',
    ar: 'خط إنتاج المعدات',
  },
  'common.selectProductionLine': {
    zh: '选择生产线',
    en: 'Select production line',
    id: 'Pilih Jalur Produksi',
    kz: 'Өндіріс желісін таңдаңыз',
    th: 'เลือกสายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيەسىنى تاللاڭ',
    vi: 'Chọn dây chuyền sản xuất',
    zh_tc: '選擇生產線',
    ru: 'Выбрать производственную линию',
    ko: '생산 라인 선택',
    bur: 'ထုတ်လုပ်ရေးလိုင်းရွေးချယ်ပါ',
    ben: 'উৎপাদন লাইন নির্বাচন করুন',
    tr: 'Üretim Hattını Seç',
    km: 'ជ្រើសខ្សែផលិតកម្ម',
    es: 'Seleccionar línea de producción',
    ar: 'حدد خط الإنتاج',
  },
  'common.rotateAngleTip': {
    zh: '旋转{angle}',
    en: 'Rotate {angle}',
    id: 'Putar {angle}',
    kz: '{angle} айналдыру',
    th: 'หมุน {angle}',
    ug: '{angle} ئايلاندۇرۇش',
    vi: 'Xoay {angle}',
    zh_tc: '旋轉{angle}',
    ru: 'Повернуть {angle}',
    ko: '{angle} 회전',
    bur: '{angle} လည်ပတ်ပါ',
    ben: '{angle} ঘুরান',
    tr: '{angle} Döndür',
    km: '{angle} បង្វិល',
    es: 'Girar {angle}',
    ar: 'تدوير {angle}',
  },
  'common.plankText': {
    zh: '板件',
    en: 'Board',
    id: 'Papan',
    kz: 'Тақта',
    th: 'แผ่นไม้',
    ug: 'تاختا',
    vi: 'Tấm ván',
    zh_tc: '板件',
    ru: 'Доска',
    ko: '판재',
    bur: 'ပေါ်ဒ်',
    ben: 'বোর্ড',
    tr: 'Panel',
    km: 'បន្ទះ',
    es: 'Panel',
    ar: 'اللوحة',
  },
  'common.sendToEzSort': {
    zh: '发送至彩标',
    en: 'send to EzSort',
    id: 'Kirim ke EzSort',
    kz: 'EzSort-ке жіберу',
    th: 'ส่งไปยัง EzSort',
    ug: 'EzSort غا ئەۋەتىش',
    vi: 'Gửi đến EzSort',
    zh_tc: '發送至彩標',
    ru: 'Отправить в EzSort',
    ko: '컬러 레이블로 보내기',
    bur: 'EzSort သို့ပေးပို့ပါ',
    ben: 'EzSort এ পাঠান',
    tr: "EzSort'e gönder",
    km: 'ផ្ញើទៅ EzSort',
    es: 'Enviar a etiqueta de color',
    ar: 'إرسال إلى ملصق الألوان',
  },
  'common.downloadEzSort': {
    zh: '下载智绘彩标',
    en: 'Download EzSort',
    id: 'Unduh EzSort',
    kz: 'EzSort жүктеп алу',
    th: 'ดาวน์โหลด EzSort',
    ug: 'EzSort چۈشۈرۈش',
    vi: 'Tải xuống EzSort',
    zh_tc: '下載智繪彩標',
    ru: 'Скачать EzSort',
    ko: '지화 채표 다운로드',
    bur: 'EzSort ဒေါင်းလုပ်လုပ်ပါ',
    ben: 'EzSort ডাউনলোড করুন',
    tr: "EzSort'i indir",
    km: 'ទាញយក EzSort',
    es: 'Descargar Zhihui Color Label',
    ar: 'تنزيل Zhihui Color Label',
  },
  'common.notDownloadTip': {
    zh: '如果智绘彩标未能正常打开，可能是因为您没有下载，请点击下方按钮下载智绘彩标',
    en: 'If EzSort cannot open normally, it may be because you have not downloaded it. Please click the button below to download EzSort',
    id: 'Jika EzSort tidak dapat dibuka dengan normal, mungkin karena Anda belum mengunduhnya. Silakan klik tombol di bawah untuk mengunduh EzSort',
    kz: 'Егер EzSort қалыпты түрде ашылмаса, бұл сіз оны жүктеп алмағандығыңызды білдіруі мүмкін. EzSort жүктеп алу үшін төмендегі түймені басыңыз',
    th: 'หาก EzSort ไม่สามารถเปิดได้ปกติ อาจเป็นเพราะคุณยังไม่ได้ดาวน์โหลด กรุณาคลิกปุ่มด้านล่างเพื่อดาวน์โหลด EzSort',
    ug: 'ئەگەر EzSort نورمال ئېچىلمىسا، چۈشۈرمىگەنلىكىڭىز سەۋەبىدىن بولۇشى مۇمكىن. تۆۋەندىكى كۇنۇپكىنى چېكىپ EzSort چۈشۈرۈڭ',
    vi: 'Nếu EzSort không thể mở bình thường, có thể là vì bạn chưa tải xuống. Vui lòng nhấp vào nút bên dưới để tải xuống EzSort',
    zh_tc:
      '如果智繪彩標未能正常打開，可能是因為您沒有下載，請點擊下方按鈕下載智繪彩標',
    ru: 'Если EzSort не может открыться нормально, возможно, вы не скачали его. Пожалуйста, нажмите кнопку ниже, чтобы скачать EzSort',
    ko: '만약 지화채표가 정상적으로 열리지 않으면 다운로드하지 않았기 때문일 수 있습니다. 아래 단추를 눌러 지화채표를 다운로드하십시오',
    bur: 'EzSort ပုံမှန်မဖွင့်နိုင်ပါက ဒေါင်းလုပ်မလုပ်ရသေးနိုင်ပါ။ EzSort ဒေါင်းလုပ်လုပ်ရန် အောက်ပါခလုတ်ကိုနှိပ်ပါ',
    ben: 'EzSort স্বাভাবিকভাবে খুলতে না পারলে ডাউনলোড না করার কারণ হতে পারে। EzSort ডাউনলোড করতে নিচের বোতামে ক্লিক করুন',
    tr: "EzSort normal açılmazsa, indirmediğiniz anlamına gelebilir. EzSort'i indirmek için aşağıdaki düğmeye tıklayın",
    km: 'បើ EzSort មិនអាចបើកបាន ប្រហែលអ្នកមិនទាន់ទាញយក សូមចុចប៊ូតុងខាងក្រោមដើម្បីទាញយក',
    es: 'Si Zhihua Color Label no se abre normalmente, puede deberse a que no lo ha descargado. Haga clic en el botón a continuación para descargar Zhihui Color Label',
    ar: 'إذا فشل فتح Zhihua Color Label بشكل طبيعي، فقد يكون ذلك بسبب عدم تنزيله. الرجاء النقر فوق الزر أدناه لتنزيل Zhihui Color Label',
  },
  'common.updateTip': {
    zh: '检测到软件更新，请重启柜柜!',
    en: 'Software update detected. Please restart Guigui!',
    id: 'Perbaruan perangkat lunak terdeteksi. Silakan restart Guigui!',
    kz: 'Программалық жаңалдау жəнг edilді. Қосіңіз Guigui!',
    th: 'ตรวจพบการอัปเดตซอฟต์แวร์ กรุณารีบooting Guigui!',
    ug: 'ئۇيغۇرچە يۈرۈشكە ئالغان پىلان كۆرۈلدى. يەنە باشلانغىز Guigui!',
    vi: 'Đã phát hiện cập nhật phần mềm. Vui lòng khởi động lại Guigui!',
    zh_tc: '檢測到軟體更新，請重啟櫃櫃!',
    ru: 'Обнаружено обновление программного обеспечения. Пожалуйста, перезапустите Guigui!',
    ko: '소프트웨어 업데이트가 감지되었습니다. 캐비닛을 다시 시작하십시오.',
    bur: 'ဆော့ဖ်ဝဲအပ်ဒိတ်တွေ့ပါ၊ Guigui ပြန်ဖွင့်ပါ!',
    ben: 'সফটওয়্যার আপডেট পাওয়া গেছে, Guigui পুনরায় চালু করুন!',
    tr: "Yazılım güncellemesi algılandı. Guigui'yi yeniden başlatın!",
    km: 'រកឃើញការអាប់ដេតកម្មវិធី សូមចាប់ផ្តើមឡើងវិញ',
    es: 'Se detectó una actualización de software. ¡Reinicie el gabinete!',
    ar: 'تم اكتشاف تحديث البرنامج، يرجى إعادة تشغيل الخزانة!',
  },
  'common.betaTest': {
    zh: '内测限免',
    en: 'Free during beta testing',
    id: 'Gratis selama uji coba beta',
    kz: 'Бета сынақ кезеңінде тегін',
    th: 'ให้ใช้ฟรีช่วงทดสอบภายใน',
    ug: 'سىناق باسقۇچىدا چەكلىك مۇددەتلىك بېسىمسىز ئىشلىتىشكە بولىدۇ',
    vi: 'Miễn phí trong giai đoạn thử nghiệm nội bộ',
    zh_tc: '內測限免',
    ru: 'Бесплатно во время бета-тестирования',
    ko: '내부 테스트 제한 면제',
    bur: 'Beta စစ်ဆေးမှုကာလ အခမဲ့',
    ben: 'বেটা পরীক্ষার সময় বিনামূল্যে',
    tr: 'Beta test süresi için ücretsiz',
    km: 'ឥតគិតថ្លៃក្នុងអំឡុងពេលសាកល្បង',
    es: 'Gratis para pruebas internas',
    ar: 'مجاني للاختبار الداخلي',
  },
  'common.ersortSpecail': {
    zh: '彩标专属',
    en: 'Exclusive for Color Labels',
    id: 'Eksklusif untuk Label Warna',
    kz: 'Түсті белгілерге арналған',
    th: 'เฉพาะสำหรับป้ายสี',
    ug: 'رەڭلىك بەلگىلەرگە خاس',
    vi: 'Dành riêng cho Nhãn màu',
    zh_tc: '彩標專屬',
    ru: 'Эксклюзивно для цветных меток',
    ko: '컬러 로고 전속',
    bur: 'Color Label အတွက်သီးသန့်',
    ben: 'কালার লেবেলের জন্য একচেটিয়া',
    tr: 'Renk etiketleri için özel',
    km: 'សម្រាប់តែស្លាកពណ៌',
    es: 'Exclusivo para etiqueta de color',
    ar: 'حصريًا لـ Color Label',
  },
  'common.exclusiveFeature': {
    zh: '专属功能',
    en: 'Exclusive Feature',
    id: 'Fitur Eksklusif',
    kz: 'Эксклюзивті функция',
    th: 'ฟีเจอร์พิเศษ',
    ug: 'خاس ئىقتىدار',
    vi: 'Tính năng độc quyền',
    zh_tc: '專屬功能',
    ru: 'Эксклюзивная функция',
    ko: '전용 기능',
    bur: 'သီးသန့်လုပ်ဆောင်ချက်',
    ben: 'এক্সক্লুসিভ ফিচার',
    tr: 'Özel özellik',
    km: 'មុខងារផ្តាច់មុខ',
    es: 'Función exclusiva',
    ar: 'ميزة حصرية',
  },
  'common.elementCanBeDragTip': {
    zh: '元素可被拖动',
    en: 'Element can be dragged',
    id: 'Elemen dapat ditarik',
    kz: 'Элементті сүйреуге болады',
    th: 'องค์ประกอบสามารถลากได้',
    ug: 'ئېلېمېنتتى سۈيرىشگە بولىدۇ',
    vi: 'Phần tử có thể kéo',
    zh_tc: '元素可被拖動',
    ru: 'Элемент можно перетаскивать',
    ko: '요소를 드래그할 수 있습니다.',
    bur: 'အရာဝတ္ထုကို ဆွဲသွားနိုင်သည်',
    ben: 'উপাদানটি টেনে নেওয়া যাবে',
    tr: 'Eleman sürüklenir',
    km: 'ធាតុអាចអូសបាន',
    es: 'Los elementos se pueden arrastrar',
    ar: 'يمكن سحب العناصر',
  },
  'common.checkPlankIsConflict': {
    zh: '正在检测板件状态',
    en: 'Checking plank status',
    id: 'Status pelat sedang diuji. Status pelat sedang diuji. Status pelat sedang diuji. Status pelat sedang diuji.',
    kz: 'Панель күйі тексерілуде',
    th: 'กำลังตรวจสอบสถานะของแผ่น',
    ug: 'ئېغىرچىلىق ھالىتىنى تەكشۈرۈۋاتىدۇ',
    vi: 'Đang kiểm tra trạng thái tấm ván',
    zh_tc: '正在檢測板件狀態',
    ru: 'Проверка состояния доски',
    ko: '보드 상태를 검사하는 중',
    bur: 'ပေါ်ဒ်အခြေအနေစစ်ဆေးနေသည်',
    ben: 'বোর্ডের অবস্থা পরীক্ষা করা হচ্ছে',
    tr: 'Panellerin durumu kontrol ediliyor',
    km: 'កំពុងពិនិត្យស្ថានភាពផ្ទាំង',
    es: 'Detección del estado del tablero',
    ar: 'اكتشاف حالة اللوحة',
  },
  'common.preferenceSaveErr': {
    zh: '偏好设置保存异常',
    en: 'Error saving preferences',
    id: 'Exception in saving preferences',
    kz: 'Қалауларды сақтау қатесі',
    th: 'การตั้งค่าที่ต้องการบันทึกผิดพลาด',
    ug: 'مايىللىق تەڭشەك ساقلاش ئەھۋالى غەيرىي',
    vi: 'Lỗi lưu cài đặt ưu tiên',
    zh_tc: '偏好設定儲存異常',
    ru: 'Ошибка сохранения настроек',
    ko: '환경 설정 저장 예외',
    bur: 'ကြိုက်နှစ်သက်မှုသိမ်းဆည်းမှုအမှားရှိ',
    ben: 'পছন্দ সংরক্ষণে ত্রুটি',
    tr: 'Tercihler kaydedilirken hata oluştu',
    km: 'កំហុសក្នុងការរក្សាទុកការកំណត់ចំណូលចិត្ត',
    es: 'Excepción al guardar preferencias',
    ar: 'استثناء حفظ التفضيلات',
  },
  'common.guimen': {
    zh: '柜门',
    en: 'Cabinet door',
    id: 'Pintu kabinet',
    kz: 'Кабинет есігі',
    th: 'ประตูตู้',
    ug: 'كابىنەت ئىشىكى',
    vi: 'Cửa tủ',
    zh_tc: '櫃門',
    ru: 'Дверь шкафа',
    ko: '장문',
    bur: 'ဗီရိုတံခါး',
    ben: 'আলমারির দরজা',
    tr: 'Kabinet kapısı',
    km: 'ទ្វារទូ',
    es: 'Puerta del gabinete',
    ar: 'باب الخزانة',
  },
  'common.preferenceLoadTip': {
    zh: '正在加载您的偏好设置',
    en: 'Loading your preferences...',
    id: 'Memuat preferensi Anda',
    kz: 'Сіздің қалауларыңыз жүктелуде...',
    th: 'กำลังโหลดการตั้งค่าของคุณ',
    ug: 'مايىللىق تەڭشىكىڭىزنى يۈكلىۋاتىدۇ',
    vi: 'Đang tải cài đặt ưu tiên của bạn...',
    zh_tc: '正在加載您的偏好設置',
    ru: 'Загрузка ваших настроек',
    ko: '환경 설정을 로드하는 중',
    bur: 'သင်၏ကြိုက်နှစ်သက်မှုဆက်တင်တင်နေသည်',
    ben: 'আপনার পছন্দ লোড হচ্ছে',
    tr: 'Tercihler yükleniyor',
    km: 'កំពុងផ្ទុកការកំណត់របស់អ្នក',
    es: 'Cargando su configuración de preferencias',
    ar: 'تحميل إعدادات التفضيلات الخاصة بك',
  },
  'common.preferenceLoadErrTip': {
    zh: '偏好设置加载失败,请刷新重试,避免造成您的偏好设置错误！',
    en: 'Failed to load preferences. Please refresh and try again to avoid incorrect preference settings!',
    id: 'Preferensi gagal memuat, silakan menyegarkan dan mencoba lagi untuk menghindari menyebabkan kesalahan preferensi Anda!',
    kz: 'Қалауларды жүктеу сәтсіз аяқталды. Қате қалауларды болдырмау үшін бетті жаңартып, қайта көріңіз!',
    th: 'การตั้งค่าไม่สามารถโหลดได้โปรดรีเฟรชและลองอีกครั้งเพื่อหลีกเลี่ยงการทำให้เกิดข้อผิดพลาดในการตั้งค่าของคุณ!',
    ug: 'مايىللىق تەڭشەك يۈكلەش مەغلۇپ بولدى، يېڭىلاشنى قايتا سىناڭ!',
    vi: 'Không thể tải cài đặt ưu tiên. Vui lòng làm mới và thử lại để tránh cài đặt ưu tiên không chính xác!',
    zh_tc: '偏好設置加載失敗,請刷新重試,避免造成您的偏好設置錯誤！',
    ru: 'Не удалось загрузить настройки. Пожалуйста, обновите страницу и попробуйте снова, чтобы избежать ошибок в настройках!',
    ko: '환경 설정을 로드하지 못했습니다. 환경 설정 오류가 발생하지 않도록 새로 고치고 다시 시도하십시오!',
    bur: 'ကြိုက်နှစ်သက်မှုဆက်တင်တင်ရောက်မအောင်မြင်ပါ၊ ပြန်လည်စစ်ဆောင်းကြည့်ပါ!',
    ben: 'পছন্দ লোড ব্যর্থ হয়েছে, পুনরায় চেষ্টা করুন এবং পছন্দ সেটিং ভুল না হওয়ার জন্য রিফ্রেশ করুন!',
    tr: 'Tercihler yüklenemedi. Lütfen yeniden yükleyin ve tercihlerinizin hatalı olmaması için yeniden deneyin!',
    km: 'បរាជ័យក្នុងការផ្ទុកការកំណត់ចំណូលចិត្ត សូមធ្វើឱ្យស្រស់ហើយព្យាយាមម្តងទៀត ដើម្បីជៀសវាងការកំណត់មិនត្រឹមត្រូវ!',
    es: 'La configuración de preferencias no se pudo cargar, actualice e intente nuevamente para evitar causar errores en su configuración de preferencias.',
    ar: 'فشل تحميل إعدادات التفضيلات، يرجى التحديث والمحاولة مرة أخرى لتجنب التسبب في أخطاء في إعدادات التفضيلات الخاصة بك!',
  },
  'common.localFileIsBeingWrite': {
    zh: '本地文件写入中',
    en: 'Local file is being written',
    id: 'File lokal sedang ditulis',
    kz: 'Жергілікті файл жазылуда',
    th: 'ไฟล์ท้องถิ่นกำลังเขียน',
    ug: 'يەرلىك ھۆججەت يېزىلىۋاتىدۇ',
    vi: 'Tệp cục bộ đang được ghi',
    zh_tc: '本地文件寫入中',
    ru: 'Локальный файл записывается',
    ko: '로컬 파일 쓰기 중',
    bur: 'ဒေသတွင်းဖိုင်ကို ရေးသွင်းနေသည်',
    ben: 'স্থানীয় ফাইল লেখা হচ্ছে',
    tr: 'Yerel dosya yazılıyor',
    km: 'កំពុងសរសេរឯកសារក្នុងម៉ាស៊ីន',
    es: 'Escritura de archivos locales',
    ar: 'كتابة الملفات المحلية',
  },
  'common.unnamedFile': {
    zh: '未命名文件',
    en: 'Unnamed file',
    id: 'File tanpa nama',
    kz: 'Атауы жоқ файл',
    th: 'ไฟล์ไม่มีชื่อ',
    ug: 'نامسىز ھۆججەت',
    vi: 'Tệp chưa đặt tên',
    zh_tc: '未命名檔案',
    ru: 'Безымянный файл',
    ko: '이름 없는 파일',
    bur: 'အမည်မသိဖိုင်',
    ben: 'নামহীন ফাইল',
    tr: 'Adsız dosya',
    km: 'ឯកសារគ្មានឈ្មោះ',
    es: 'Archivo sin nombre',
    ar: 'ملف بدون اسم',
  },
  'common.taskMonitor': {
    zh: '任务监控',
    en: 'Task Monitoring',
    id: 'Pemantauan tugas',
    kz: 'Тапсырманы бақылау',
    th: 'การตรวจสอบงาน',
    ug: 'ۋەزىپە كۆزەتكۈچ',
    vi: 'Giám sát nhiệm vụ',
    zh_tc: '任務監控',
    ru: 'Мониторинг задач',
    ko: '작업 모니터링',
    bur: 'လုပ်ဆောင်ချက်စောင့်ကြည့်မှု',
    ben: 'কাজ পর্যবেক্ষণ',
    tr: 'Görev izleme',
    km: 'តាមដានភារកិច្ច',
    es: 'Monitoreo de tareas',
    ar: 'مراقبة المهام',
  },
  'common.downloadByType': {
    zh: '下载{type}',
    en: 'Download {type}',
    id: 'Unduh {type}',
    kz: '{type} жүктеу',
    th: 'ดาวน์โหลด {type}',
    ug: '{type} چۈشۈرۈش',
    vi: 'Tải xuống {type}',
    zh_tc: '下載{type}',
    ru: 'Скачать {type}',
    ko: '{type} 다운로드',
    bur: '{type} ဒေါင်းလုပ်လုပ်ပါ',
    ben: '{type} ডাউনলোড করুন',
    tr: '{type} indir',
    km: '{type} ធ្វើចំនុច',
    es: 'Descargar {type}',
    ar: 'تنزيل {type}',
  },
  'common.slotKnifeErr': {
    zh: '缺失槽指定加工刀具，请检查生产线设置！【{msg}】',
    en: 'The slot-specific processing tool is missing. Please check the production line settings! 【{msg}】',
    id: 'Untuk slot yang hilang, alat pemrosesan yang ditentukan, silakan periksa pengaturan jalur produksi! 【{Msg}】',
    kz: 'Ұяшыққа арналған арнайы өңдеу құралы жоқ. Өндіріс желісінің баптауларын тексеріңіз! 【{msg}】',
    th: 'สำหรับเครื่องมือประมวลผลที่ระบุสล็อตที่ขาดหายไปโปรดตรวจสอบการตั้งค่าสายการผลิต! 【 {msg} 】',
    ug: 'ئوچۇق ئورۇنلاشتۇرۇش قورالى يوق، ئىشلەپچىقىرىش لىنىيىسى تەڭشىكىنى تەكشۈرۈڭ! 【{msg}】',
    vi: 'Thiếu dụng cụ gia công cụ thể của rãnh. Vui lòng kiểm tra cài đặt dây chuyền sản xuất! 【{msg}】',
    zh_tc: '缺失槽指定加工刀具，請檢查生產線設置！【{msg}】',
    ru: 'Отсутствует инструмент для обработки конкретного паза. Пожалуйста, проверьте настройки производственной линии! 【{msg}】',
    ko: '특정 슬롯에 대한 가공 도구가 누락되었습니다. 생산 라인 설정을 확인해주세요! 【{msg}】',
    bur: 'ကြိုးသတ်မှတ်ကိရိယာမပါ၊ ထုတ်လုပ်ရေးလိုင်းဆက်တင်ကိုစစ်ဆေးပါ! 【{msg}】',
    ben: 'স্লটের নির্দিষ্ট প্রক্রিয়াকরণ সরঞ্জাম অনুপস্থিত, উৎপাদন লাইন সেটিংস পরীক্ষা করুন! 【{msg}】',
    tr: 'Belirtilen slot için işleme aleti eksik. Lütfen üretim hattı ayarlarını kontrol edin! 【{msg}】',
    km: 'ខ្វះមុខកាត់ដំណើរការរយៈស្នឹង សូមពិនិត្យការកំណត់ខ្សែផលិតកម្ម! 【{msg}】',
    es: 'Falta la herramienta de procesamiento especificada en la ranura, verifique la configuración de la línea de producción. 【{msg}】',
    ar: 'أداة المعالجة المحددة للفتحة مفقودة، يرجى التحقق من إعدادات خط الإنتاج! 【{msg}】',
  },
  'common.anewChooseCatalog': {
    zh: '重新选择目录',
    en: 'Re-select directory',
    id: 'Pilih direktori',
    kz: 'Каталогты қайта таңдау',
    th: 'Reselect Directory',
    ug: 'قىسقۇچنى قايتا تاللاڭ',
    vi: 'Chọn lại thư mục',
    zh_tc: '重新選擇目錄',
    ru: 'Выбрать каталог',
    ko: '디렉토리 다시 선택',
    bur: 'လမ်းညွှန်ကိုပြန်ရွေးပါ',
    ben: 'ডিরেক্টরি পুনরায় নির্বাচন করুন',
    tr: 'Dizin tekrar seç',
    km: 'ជ្រើសថតឡើងវិញ',
    es: 'Vuelva a seleccionar el directorio',
    ar: 'إعادة تحديد الدليل',
  },
  'common.downloadSetting': {
    zh: '下载设置',
    en: 'Download settings',
    id: 'Unduh pengaturan',
    kz: 'Жүктеу параметрлері',
    th: 'ดาวน์โหลดการตั้งค่า',
    ug: 'چۈشۈرۈش تەڭشىكى',
    vi: 'Cài đặt tải xuống',
    zh_tc: '下載設置',
    ru: 'Скачать настройки',
    ko: '다운로드 설정',
    bur: 'ဒေါင်းလုပ်ဆက်တင်',
    ben: 'ডাউনলোড সেটিংস',
    tr: 'İndirme ayarları',
    km: 'ទាញយកការកំណត់',
    es: 'Descargar configuración',
    ar: 'إعدادات التنزيل',
  },
  'common.attention': {
    zh: '注意',
    en: 'Attention',
    id: 'Melihat',
    kz: 'Назар аударыңыз',
    th: 'สังเกต',
    ug: 'دىققەت',
    vi: 'Chú ý',
    zh_tc: '注意',
    ru: 'Внимание',
    ko: '주의',
    bur: 'သတိပြုပါ',
    ben: 'মনোযোগ',
    tr: 'Dikkat',
    km: 'សូមចំណាំ',
    es: 'Nota',
    ar: 'ملاحظة',
  },
  'common.unit': {
    zh: '块',
    en: 'Pieces',
    id: 'bagian',
    kz: 'Единица',
    th: 'ชิ้นส่วน',
    ug: 'دانە',
    vi: 'Khối',
    zh_tc: '塊',
    ru: 'Штук',
    ko: '덩어리',
    bur: 'ခု',
    ben: 'টুকরা',
    tr: 'Adet',
    km: 'ដុំ',
    es: 'Bloquear',
    ar: 'الحظر',
  },
  'common.defaultUse': {
    zh: '默认使用',
    en: 'Default Use',
    id: 'Digunakan secara default',
    kz: 'Әдетті пайдалану',
    th: 'ใช้โดยค่าเริ่มต้น',
    ug: 'سۈكۈتتىكى ئىشلىتىش',
    vi: 'Sử dụng mặc định',
    zh_tc: '默認使用',
    ru: 'По умолчанию использовать',
    ko: '기본 사용',
    bur: 'မူလအသုံးပြုမှု',
    ben: 'ডিফল্ট ব্যবহার',
    tr: 'Varsayılan kullanım',
    km: 'ប្រើលំនាំដើម',
    es: 'Usar de forma predeterminada',
    ar: 'الاستخدام افتراضيًا',
  },
  'common.defaultChooseUse': {
    zh: '默认选用',
    en: 'Default selection',
    id: 'Dipilih secara default',
    kz: 'Әдетті таңдау',
    th: 'เลือกโดยค่าเริ่มต้น',
    ug: 'سۈكۈتتىكى تاللاش',
    vi: 'Chọn mặc định sử dụng',
    zh_tc: '默認選用',
    ru: 'По умолчанию выбрать',
    ko: '기본 선택',
    bur: 'မူလရွေးချယ်မှု',
    ben: 'ডিফল্ট নির্বাচন',
    tr: 'Varsayılan seçim',
    km: 'ជ្រើសលំនាំដើម',
    es: 'Seleccionar de forma predeterminada',
    ar: 'التحديد افتراضيًا',
  },
  'common.requestFail': {
    zh: '请求失败',
    en: 'Request failed',
    id: 'Permintaan gagal',
    kz: 'Сұрау сәтсіз аяқталды',
    th: 'คำขอล้มเหลว',
    ug: 'ئىلتىماس مەغلۇپ بولدى',
    vi: 'Yêu cầu thất bại',
    zh_tc: '請求失敗',
    ru: 'Запрос не выполнен',
    ko: '요청 실패',
    bur: 'တောင်းဆိုမှုမအောင်မြင်',
    ben: 'অনুরোধ ব্যর্থ হয়েছে',
    tr: 'İstek başarısız oldu',
    km: 'សំណើបរាជ័យ',
    es: 'Solicitud fallida',
    ar: 'فشل الطلب',
  },
  'common.downloadDoneByType': {
    zh: '{type}下载完成',
    en: '{type} download completed',
    id: '{type} unduh selesai',
    kz: '{type} жүктеу аяқталды',
    th: '{type} ดาวน์โหลดเสร็จสมบูรณ์',
    ug: '{type} چۈشۈرۈش تاماملاندى',
    vi: 'Đã tải xuống {type} xong',
    zh_tc: '{type}下載完成',
    ru: '{type} загружен',
    ko: '{type} 다운로드 완료',
    bur: '{type} ဒေါင်းလုပ်ပြီးစီးပါပြီ',
    ben: '{type} ডাউনলোড সম্পন্ন হয়েছে',
    tr: '{type} indirildi',
    km: '{type} ធ្វើចំនុច',
    es: '{type} Descarga completada',
    ar: '{type} اكتمل التنزيل',
  },
  'common.sysTip': {
    zh: '系统提示',
    en: 'System Tip',
    id: 'Permintaan sistem',
    kz: 'Жүйе ескертуі',
    th: 'ระบบแจ้งเตือน',
    ug: 'سىستېما ئۇقتۇرۇشى',
    vi: 'Thông báo hệ thống',
    zh_tc: '系統提示',
    ru: 'Системное уведомление',
    ko: '시스템 알림',
    bur: 'စနစ်အကြောင်းကြားချက်',
    ben: 'সিস্টেম বিজ্ঞপ্তি',
    tr: 'Sistem bildirimi',
    km: 'ការជូនដំណឹងប្រព័ន្ធ',
    es: 'Aviso del sistema',
    ar: 'موجه النظام',
  },
  'common.pleaseChoose': {
    zh: '请选择',
    en: 'Please select',
    id: 'Pilih',
    kz: 'Таңдаңыз',
    th: 'โปรดเลือก',
    ug: 'تاللاڭ',
    vi: 'Vui lòng chọn',
    zh_tc: '請選擇',
    ru: 'Пожалуйста, выберите',
    ko: '선택해 주세요',
    bur: 'ကျေးဇူးပြု၍ ရွေးချယ်ပါ',
    ben: 'দয়া করে নির্বাচন করুন',
    tr: 'Lütfen seçin',
    km: 'សូមជ្រើសរើស',
    es: 'Seleccione',
    ar: 'يرجى تحديد',
  },
  'common.confirmDelete': {
    zh: '确认删除',
    en: 'Confirm deletion',
    id: 'Konfirmasi penghapusan',
    kz: 'Жоюды растау',
    th: 'ยืนยันการลบ',
    ug: 'ئۆچۈرۈشنى جەزملەشتۈرۈڭ',
    vi: 'Xác nhận xóa',
    zh_tc: '確認刪除',
    ru: 'Подтвердить удаление',
    ko: '삭제 확인',
    bur: 'ဖျက်ရန်အတည်ပြုပါ',
    ben: 'মুছে ফেলার বিষয়টি নিশ্চিত করুন',
    tr: 'Silmeyi onayla',
    km: 'បញ្ជាក់ការលុប',
    es: 'Confirmar eliminación',
    ar: 'تأكيد الحذف',
  },
  'common.notDataTipByType': {
    zh: '暂无数据，请先{msg}',
    en: 'No data available, please {msg} first',
    id: 'Belum ada data, tolong {msg} pertama',
    kz: 'Деректер жоқ, алдымен {msg} жасаңыз',
    th: 'ยังไม่มีข้อมูลโปรด {msg} ก่อน',
    ug: 'ھازىرچە سانلىق مەلۇمات يوق، ئاۋۋال {msg}',
    vi: 'Chưa có dữ liệu, vui lòng {msg} trước',
    zh_tc: '暫無數據，請先{msg}',
    ru: 'Нет данных, пожалуйста, {msg} сначала',
    ko: '데이터가 없습니다. 먼저 {msg}해주세요',
    bur: 'ဒေတာမရှိသေး၊ ကျေးဇူးပြု၍ {msg} ဦးစွာလုပ်ပါ',
    ben: 'এখনো কোনো ডেটা নেই, প্রথমে {msg} করুন',
    tr: 'Veri yok, lütfen önce {msg} yapın',
    km: 'មិនមានទិន្នន័យទេ សូម {msg} ជាមុន',
    es: 'Aún no hay datos, comience con {msg}',
    ar: 'لا توجد بيانات حتى الآن، يرجى البدء بـ {msg}',
  },
  'common.paginationTotalTip': {
    zh: '第 {current}-{page} 条/总共 {total} 条',
    en: 'Items {current}-{page} of {total} total',
    id: '{current}-{page}/total {total}',
    kz: '{total} элементтің {current}-{page} жолдары',
    th: '{current}-{page}/total {total}',
    ug: '{current}-{page} قۇر / جەمئىي {total} قۇر',
    vi: 'Dòng {current}-{page} trong tổng số {total}',
    zh_tc: '第 {current}-{page} 條/總共 {total} 條',
    ru: 'Элементы {current}-{page} из {total} всего',
    ko: '{current}-{page} /{total} 개',
    bur: '{current}-{page} /{total} ခုလုံး',
    ben: '{current}-{page} টি / মোট {total} টি',
    tr: '{current}-{page} / {total} adet',
    km: '{current}-{page} / {total} គតិ',
    es: '{current}-{page} elementos/Total {total} elementos',
    ar: '{current}-{page} العناصر/إجمالي {total} العناصر',
  },
  'common.chooseAmountData': {
    zh: '已选 {number} 条数据',
    en: 'Selected {number} items of data',
    id: '{number} Data yang dipilih',
    kz: '{number} деректер таңдалды',
    th: '{หมายเลข} เลือกข้อมูล',
    ug: '{number} قۇر سانلىق مەلۇمات تاللاندى',
    vi: 'Đã chọn {number} dữ liệu',
    zh_tc: '已選 {number} 條數據',
    ru: 'Выбрано {number} элементов данных',
    ko: '{number} 개의 데이터 선택',
    bur: '{number} ဒေတာများကိုရွေးချယ်ပြီး',
    ben: '{number} টি ডেটা নির্বাচিত',
    tr: '{number} adet veri seçildi',
    km: '{number} គតិទិន្នន័យតែងតែបានជ្រើសរើស',
    es: 'Datos seleccionados {number}',
    ar: '{number} تم تحديد البيانات',
  },
  'common.moreOperate': {
    zh: '更多',
    en: 'More',
    id: 'Lagi',
    kz: 'Қосымша',
    th: 'มากกว่า',
    ug: 'تېخىمۇ كۆپ',
    vi: 'Thêm',
    zh_tc: '更多',
    ru: 'Больше',
    ko: '더',
    bur: 'ပိုမို',
    ben: 'আরও',
    tr: 'Daha fazla',
    km: 'ចាប់ផ្តើម',
    es: 'Más',
    ar: 'أكثر',
  },
  'common.transferByType': {
    zh: '转移{type}',
    en: 'Transfer {type}',
    id: 'Transfer {type}',
    kz: '{type} ауыстыру',
    th: 'ถ่ายโอน {type}',
    ug: '{type} يۆتكەش',
    vi: 'Chuyển {type}',
    zh_tc: '轉移{type}',
    ru: 'Передать {type}',
    ko: '{type} 전송',
    bur: '{type} လွှဲပြောင်းပါ',
    ben: '{type} স্থানান্তর করুন',
    tr: '{type} transfer et',
    km: '{type} ធ្វើចំនុច',
    es: 'Transferir {type}',
    ar: 'نقل{type}',
  },
  'common.clickCopy': {
    zh: '点击可复制{type}',
    en: 'Click to copy {type}',
    id: 'Klik untuk menyalin {type}',
    kz: '{type} көшіру үшін басыңыз',
    th: 'คลิกเพื่อคัดลอก {type}',
    ug: '{type} نۇسخىلاش ئۈچۈن چېكىڭ',
    vi: 'Nhấp để sao chép {type}',
    zh_tc: '點擊可複製{type}',
    ru: 'Нажмите, чтобы скопировать {type}',
    ko: '{type} 복사',
    bur: '{type} ကူးယူရန် နှိပ်ပါ',
    ben: '{type} কপি করতে ক্লিক করুন',
    tr: '{type} kopyalamak için tıklayın',
    km: 'ចុចដើម្បីចម្លង {type}',
    es: 'Haga clic para copiar {type}',
    ar: 'انقر للنسخ {type}',
  },
  'common.currentLine': {
    zh: '当前行',
    en: 'Current Line',
    id: 'Baris saat ini',
    kz: 'Ағымдағы жол',
    th: 'แถวปัจจุบัน',
    ug: 'نۆۋەتتىكى قۇر',
    vi: 'Dòng hiện tại',
    zh_tc: '當前行',
    ru: 'Текущая строка',
    ko: '현재 행',
    bur: 'လက်ရှိတန်း',
    ben: 'বর্তমান লাইন',
    tr: 'Mevcut satır',
    km: 'ជួរបច្ចុប្បន្ន',
    es: 'Línea actual',
    ar: 'الصف الحالي',
  },
  'common.remark': {
    zh: '备注',
    en: 'Remarks',
    id: 'Komentar',
    kz: 'Ескертпе',
    th: 'คำพูด',
    ug: 'ئىزاھات',
    vi: 'Ghi chú',
    zh_tc: '備註',
    ru: 'Примечание',
    ko: '비고',
    bur: 'မှတ်ချက်',
    ben: 'মন্তব্য',
    tr: 'Notlar',
    km: 'កំណត់ចំណាំ',
    es: 'Comentarios',
    ar: 'ملاحظة',
  },
  'common.customFunction': {
    zh: '定制功能',
    en: 'Custom Function',
    id: 'Fitur Kustom',
    kz: 'Теңшелетін функция',
    th: 'คุณสมบัติที่กำหนดเอง',
    ug: 'خاس ئىقتىدار',
    vi: 'Chức năng tùy chỉnh',
    zh_tc: '定制功能',
    ru: 'Настраиваемая функция',
    ko: '사용자 정의 기능',
    bur: 'စိတ်ကြိုက်လုပ်ဆောင်ချက်',
    ben: 'কাস্টম ফাংশন',
    tr: 'Özel Fonksiyon',
    km: 'មុខងារតាមតម្រូវការ',
    es: 'Función personalizada',
    ar: 'وظائف مخصصة',
  },
  'common.limitedTimeTrial': {
    zh: '限免',
    en: 'LTF',
    id: 'Limited Free',
    kz: 'Limited Free',
    th: 'Limited Free',
    ug: 'Limited Free',
    vi: 'Limited Free',
    zh_tc: '限免',
    ru: 'Limited Free',
    ko: 'Limited Free',
    bur: 'Limited Free',
    ben: 'Limited Free',
    tr: 'Limited Free',
    km: 'Limited Free',
    es: 'Exención limitada',
    ar: 'إعفاء محدود',
  },
  'common.startDate': {
    zh: '开始日期',
    en: 'Start Date',
    id: 'tanggal mulai',
    kz: 'Басталу күні',
    th: 'วันที่เริ่มต้น',
    ug: 'باشلانغان چېسلا',
    vi: 'Ngày bắt đầu',
    zh_tc: '開始日期',
    ru: 'Дата начала',
    ko: '시작 날짜',
    bur: 'စတင်ရက်စွဲ',
    ben: 'শুরুর তারিখ',
    tr: 'Başlangıç tarihi',
    km: 'កាលបរិច្ឆេទចាប់ផ្តើម',
    es: 'Fecha de inicio',
    ar: 'تاريخ البدء',
  },
  'common.endDate': {
    zh: '结束日期',
    en: 'End Date',
    id: 'Tanggal akhir',
    kz: 'Аяқталу күні',
    th: 'วันที่สิ้นสุด',
    ug: 'ئاخىرلاشقان چېسلا',
    vi: 'Ngày kết thúc',
    zh_tc: '結束日期',
    ru: 'Дата окончания',
    ko: '종료일',
    bur: 'ပြီးဆုံးရက်စွဲ',
    ben: 'শেষ তারিখ',
    tr: 'Bitiş tarihi',
    km: 'កាលបរិច្ឆេទបញ្ចប់',
    es: 'Fecha de finalización',
    ar: 'تاريخ الانتهاء',
  },
  'common.startTime': {
    zh: '开始时间',
    en: 'Start time',
    id: 'Waktu mulai',
    kz: 'Басталу уақыты',
    th: 'เวลาเริ่มต้น',
    ug: 'باشلانغان ۋاقتى',
    vi: 'Thời gian bắt đầu',
    zh_tc: '開始時間',
    ru: 'Время начала',
    ko: '시작 시간',
    bur: 'စတင်အချိန်',
    ben: 'শুরুর সময়',
    tr: 'Başlangıç zamanı',
    km: 'ម៉ោងចាប់ផ្តើម',
    es: 'Hora de inicio',
    ar: 'وقت البدء',
  },
  'common.endTime': {
    zh: '结束时间',
    en: 'End time',
    id: 'Waktu akhir',
    kz: 'Аяқталу уақыты',
    th: 'เวลาสิ้นสุด',
    ug: 'ئاخىرلاشقان ۋاقتى',
    vi: 'Thời gian kết thúc',
    zh_tc: '結束時間',
    ru: 'Время окончания',
    ko: '종료 시간',
    bur: 'ပြီးဆုံးအချိန်',
    ben: 'শেষ সময়',
    tr: 'Bitiş zamanı',
    km: 'ម៉ោងបញ្ចប់',
    es: 'Hora de finalización',
    ar: 'وقت النهاية',
  },
  'common.lastMonth': {
    zh: '最近一个月',
    en: 'Last Month',
    id: 'Bulan lalu',
    kz: 'Соңғы ай',
    th: 'เดือนที่แล้ว',
    ug: 'ئۆتكەن ئاي',
    vi: 'Tháng trước',
    zh_tc: '最近一個月',
    ru: 'Последний месяц',
    ko: '최근 한 달',
    bur: 'ပြီးခဲ့သောတစ်လ',
    ben: 'গত এক মাস',
    tr: 'Son aylar',
    km: 'ខែចុងក្រោយ',
    es: 'Último mes',
    ar: 'الشهر الماضي',
  },
  'common.lastSixMonth': {
    zh: '最近半年',
    en: 'Last half year',
    id: 'Enam bulan terakhir',
    kz: 'Соңғы алты ай',
    th: 'หกเดือนที่ผ่านมา',
    ug: 'ئۆتكەن يەتتە ئاي',
    vi: 'Sáu tháng gần đây',
    zh_tc: '最近半年',
    ru: 'Последние полгода',
    ko: '최근 반년',
    bur: 'ပြီးခဲ့သောခြောက်လ',
    ben: 'গত ছয় মাস',
    tr: 'Son altı ay',
    km: 'ប្រាំមួយខែចុងក្រោយ',
    es: 'Último medio año',
    ar: 'الأشهر الستة الماضية',
  },
  'common.lastYear': {
    zh: '最近一年',
    en: 'Last Year',
    id: 'Tahun lalu',
    kz: 'Соңғы жыл',
    th: 'ปีที่แล้ว',
    ug: 'ئۆتكەن يىل',
    vi: 'Năm trước',
    zh_tc: '最近一年',
    ru: 'Последний год',
    ko: '최근 1년',
    bur: 'ပြီးခဲ့သောတစ်နှစ်',
    ben: 'গত এক বছর',
    tr: 'Son yıl',
    km: 'ឆ្នាំចុងក្រោយ',
    es: 'El año pasado',
    ar: 'العام الماضي',
  },
  'common.searchByType': {
    zh: '请输入{type}查询',
    en: 'Please enter {type} to search',
    id: 'Harap masukkan {type} untuk meminta permintaan',
    kz: '{type} енгізіп іздеңіз',
    th: 'โปรดป้อน {type} เพื่อสอบถาม',
    ug: '{type} ئىزدەش ئۈچۈن كىرگۈزۈڭ',
    vi: 'Vui lòng nhập {type} để tìm kiếm',
    zh_tc: '請輸入{type}查詢',
    ru: 'Пожалуйста, введите {type} для поиска',
    ko: '{type} 입력하여 검색',
    bur: 'ရှာဖွေရန် {type} ထည့်ပါ',
    ben: 'অনুসন্ধানের জন্য {type} লিখুন',
    tr: '{type} aramak için lütfen girin',
    km: '{type} ធ្វើចំនុច',
    es: 'Ingrese {type} para consultar',
    ar: 'الرجاء إدخال {type} للاستعلام',
  },
  'common.addTime': {
    zh: '添加时间',
    en: 'Add Time',
    id: 'Tambahkan waktu',
    kz: 'Уақыт қосу',
    th: 'เพิ่มเวลา',
    ug: 'قوشۇلغان ۋاقتى',
    vi: 'Thêm thời gian',
    zh_tc: '添加時間',
    ru: 'Время добавления',
    ko: '시간 추가',
    bur: 'အချိန်ထည့်ပါ',
    ben: 'সময় যোগ করুন',
    tr: 'Zaman ekle',
    km: 'ពេលវេលាបន្ថែម',
    es: 'Agregar hora',
    ar: 'أضف الوقت',
  },
  'common.startArrange': {
    zh: '开始排版',
    en: 'Start Nesting',
    id: 'Mulai tipografi',
    kz: 'Орнатуды бастау',
    th: 'เริ่มการพิมพ์',
    ug: 'تەرتىپلەشنى باشلاڭ',
    vi: 'Bắt đầu điều hình',
    zh_tc: '開始排版',
    ru: 'Начать верстку',
    ko: '조판을 시작하다',
    bur: 'ပြင်ဆင်မှုစတင်ပါ',
    ben: 'টাইপসেটিং শুরু করুন',
    tr: 'Tipografi başlat',
    km: 'ចាប់ផ្តើមរៀបចំ',
    es: 'Iniciar composición',
    ar: 'ابدأ بالتنضيد',
  },
  'common.select': {
    zh: '选择',
    en: 'Select',
    id: 'memilih',
    kz: 'таңдау',
    th: 'เลือก',
    ug: 'تاللاڭ',
    vi: 'Chọn',
    zh_tc: '選擇',
    ru: 'Выбрать',
    ko: '선택',
    bur: 'ရွေးပါ',
    ben: 'নির্বাচন করুন',
    tr: 'Seç',
    km: 'ជ្រើសរើស',
    es: 'Seleccionar',
    ar: 'يختار',
  },
  'common.search': {
    zh: '搜索',
    en: 'Search',
    id: 'Cari',
    kz: 'Іздеу',
    th: 'ค้นหา',
    ug: 'ئىزدەش',
    vi: 'Tìm kiếm',
    zh_tc: '搜索',
    ru: 'Поиск',
    ko: '검색',
    bur: 'ရှာဖွေ',
    ben: 'অনুসন্ধান করুন',
    tr: 'Arama',
    km: 'ធ្វើចំនុច',
    es: 'Buscar',
    ar: 'يبحث',
  },
  'common.name': {
    zh: '名称',
    en: 'Name',
    id: 'nama',
    kz: 'аты',
    th: 'ชื่อ',
    ug: 'ئات',
    vi: 'Tên',
    zh_tc: '名稱',
    ru: 'Название',
    ko: '이름',
    bur: 'အမည်',
    ben: 'নাম',
    tr: 'Ad',
    km: 'ឈ្មោះ',
    es: 'Nombre',
    ar: 'اسم',
  },
  'common.plankNo': {
    zh: '板号',
    en: 'Panel No.',
    id: 'Nomor Dewan',
    kz: 'тақта нөмірі',
    th: 'หมายเลขบอร์ด',
    ug: 'تاختىنىڭ نومۇرى',
    vi: 'Mã ván',
    zh_tc: '板號',
    ru: 'Номер доски',
    ko: '보드 번호',
    bur: 'ပေါ်ဒ်နံပါတ်',
    ben: 'বোর্ড নম্বর',
    tr: 'Plate numarası',
    km: 'ផ្ទះបានជ្រើសរើស',
    es: 'Número de tablero',
    ar: 'رقم اللوحة',
  },
  'common.plankName': {
    zh: '板件名称',
    en: 'Part Name',
    id: 'Nama Dewan',
    kz: 'тақта атауы',
    th: 'ชื่อบอร์ด',
    ug: 'تاختا ئاتى',
    vi: 'Tên ván',
    zh_tc: '板件名稱',
    ru: 'Название доски',
    ko: '보드 이름',
    bur: 'ပေါ်ဒ်အမည်',
    ben: 'বোর্ডের নাম',
    tr: 'Plate adı',
    km: 'ផ្ទះបានជ្រើសរើស',
    es: 'Nombre de tablero',
    ar: 'اسم المجلس',
  },
  'common.orderNo': {
    zh: '订单号',
    en: 'Order number',
    id: 'Nomor pesanan',
    kz: 'тапсырыс нөмірі',
    th: 'หมายเลขสั่งซื้อ',
    ug: 'زاكاز نومۇرى',
    vi: 'Mã đơn hàng',
    zh_tc: '訂單號',
    ru: 'Номер заказа',
    ko: '주문 번호',
    bur: 'အော်ဒါနံပါတ်',
    ben: 'অর্ডার নম্বর',
    tr: 'Sipariş numarası',
    km: 'លេខការបញ្ជាទិញ',
    es: 'Número de pedido',
    ar: 'رقم الطلب',
  },
  'common.order': {
    zh: '订单',
    en: 'Order',
    id: 'Memesan',
    kz: 'тапсырыс',
    th: 'คำสั่ง',
    ug: 'زاكاز',
    vi: 'Đơn hàng',
    zh_tc: '訂單',
    ru: 'Заказ',
    ko: '주문',
    bur: 'အော်ဒါ',
    ben: 'অর্ডার',
    tr: 'Sipariş',
    km: 'ការបញ្ជាទិញ',
    es: 'Orden',
    ar: 'طلب',
  },
  'common.partNameWithoutRoomCabinet': {
    zh: '板件名称(不含房间柜体)',
    en: 'Board name (without room/cabinet)',
    id: 'Nama papan (tanpa ruang/kabinet)',
    kz: 'тақта атауы (бөлме/шкафсыз)',
    th: 'ชื่อบอร์ด (ไม่รวมห้อง/ตู้)',
    ug: 'تاختا ئاتى (ئۆي/كابىنەتسىز)',
    vi: 'Tên ván (không gồm phòng/tủ)',
    zh_tc: '板件名稱(不含房間櫃體)',
    ru: 'Название доски (без комнаты/корпуса)',
    ko: '보드 이름(방/캐비닛 제외)',
    bur: 'ပေါ်ဒ်အမည် (အခန်း/ဗီရိုမပါ)',
    ben: 'বোর্ডের নাম (ঘর/ক্যাবিনেট ছাড়া)',
    tr: 'Plate adı (oda/dolap hariç)',
    km: 'ឈ្មោះបន្ទះ (មិនរួមបន្ទប់/ទូ)',
    es: 'Nombre de tablero (sin sala/gabinete)',
    ar: 'اسم اللوحة (بدون غرفة/خزانة)',
  },
  'common.plankRemark': {
    zh: '板件备注',
    en: 'Part Remark',
    id: 'Catatan pelat',
    kz: 'тақта туралы қосымша ақпарат',
    th: 'โน้ตแผ่น',
    ug: 'تاختا ئىزاھاتى',
    vi: 'Ghi chú ván',
    zh_tc: '板件備註',
    ru: 'Примечание доски',
    ko: '보드 메모',
    bur: 'ပေါ်ဒ်မှတ်ချက်',
    ben: 'বোর্ডের মন্তব্য',
    tr: 'Plate notu',
    km: 'កំណត់ចំណាំផ្ទាំង',
    es: 'Comentarios del panel',
    ar: 'ملاحظات المجلس',
  },
  'common.room': {
    zh: '房间',
    en: 'Room',
    id: 'Ruang',
    kz: 'бөлме',
    th: 'ห้อง',
    ug: 'ئۆي',
    vi: 'Phòng',
    zh_tc: '房間',
    ru: 'Комната',
    ko: '방',
    bur: 'အခန်း',
    ben: 'ঘর',
    tr: 'Oda',
    km: 'បន្ទប់',
    es: 'Sala',
    ar: 'غرفة',
  },
  'common.orderAddress': {
    zh: '项目地址',
    en: 'Project Address',
    id: 'Galeri Proyek',
    kz: 'жобаның мекен-жай',
    th: 'แกลเลอรี่โครงการ',
    ug: 'پروگرامما ئادرېسى',
    vi: 'Địa chỉ dự án',
    zh_tc: '項目地址',
    ru: 'Адрес проекта',
    ko: '프로젝트 주소',
    bur: 'ပရောဂျက်လိပ်စာ',
    ben: 'প্রকল্পের ঠিকানা',
    tr: 'Sipariş adresi',
    km: 'អាសយដ្ឋានគម្រោង',
    es: 'Dirección del proyecto',
    ar: 'عنوان المشروع',
  },
  'common.matCode': {
    zh: '材质',
    en: 'Material code',
    id: 'Bahan',
    kz: 'материал',
    th: 'วัสดุ',
    ug: 'ماتېرىال',
    vi: 'Chất liệu',
    zh_tc: '材質',
    ru: 'Материал',
    ko: '소재',
    bur: 'ပစ္စည်းကုဒ်',
    ben: 'উপকরণ কোড',
    tr: 'Malzeme kodu',
    km: 'សម្ភារៈ',
    es: 'Material',
    ar: 'المادة',
  },
  'common.matCode2': {
    zh: '材料',
    en: 'Material',
    id: 'Bahan',
    kz: 'матеріал',
    th: 'วัสดุ',
    ug: 'ماتېرىال',
    vi: 'Vật liệu',
    zh_tc: '材料',
    ru: 'Материал',
    ko: '재료',
    bur: 'ပစ္စည်း',
    ben: 'উপকরণ',
    tr: 'Malzeme',
    km: 'សម្ភារៈ',
    es: 'Material',
    ar: 'المادة',
  },
  'common.plankMatCode': {
    zh: '板材材质',
    en: 'Board material',
    id: 'Bahan pelat',
    kz: 'тақта матеріал',
    th: 'วัสดุจาน',
    ug: 'تاختا ماتېرىالى',
    vi: 'Chất liệu ván',
    zh_tc: '板材材質',
    ru: 'Материал доски',
    ko: '판재 재질',
    bur: 'ပေါ်ဒ်ပစ္စည်း',
    ben: 'বোর্ডের উপকরণ',
    tr: 'Plate malzeme',
    km: 'សម្ភារៈផ្ទាំង',
    es: 'Material del tablero',
    ar: 'مادة اللوحة',
  },
  'common.count': {
    zh: '数量',
    en: 'Count',
    id: 'kuantitas',
    kz: 'сан',
    th: 'ปริมาณ',
    ug: 'سانى',
    vi: 'Số lượng',
    zh_tc: '數量',
    ru: 'Количество',
    ko: '수량',
    bur: 'အရေအတွက်',
    ben: 'পরিমাণ',
    tr: 'Adet',
    km: 'ចំនួន',
    es: 'Cantidad',
    ar: 'الكمية',
  },
  'common.customer': {
    zh: '客户',
    en: 'Customer',
    id: 'klien',
    kz: 'клиент',
    th: 'ลูกค้า',
    ug: 'خېرىدار',
    vi: 'Khách hàng',
    zh_tc: '客戶',
    ru: 'Клиент',
    ko: '고객',
    bur: 'ဖောက်သည်',
    ben: 'গ্রাহক',
    tr: 'Müşteri',
    km: 'អតិថិជន',
    es: 'Cliente',
    ar: 'العميل',
  },
  'common.customerInfo': {
    zh: '客户资料',
    en: 'Customer information',
    id: 'Informasi pelanggan',
    kz: 'клиент туралы ақпарат',
    th: 'ข้อมูลลูกค้า',
    ug: 'خېرىدار ئۇچۇرى',
    vi: 'Thông tin khách hàng',
    zh_tc: '客戶資料',
    ru: 'Информация о клиенте',
    ko: '고객 자료',
    bur: 'ဖောက်သည်သတင်းအချက်အလက်',
    ben: 'গ্রাহকের তথ্য',
    tr: 'Müşteri bilgileri',
    km: 'ព័ត៌មានអតិថិជន',
    es: 'Información del cliente',
    ar: 'معلومات العميل',
  },
  'common.factoryOrderNo': {
    zh: '工厂单号',
    en: 'Factory order number',
    id: 'Nomor pesanan pabrik',
    kz: 'фабрика тапсырыс нөмірі',
    th: 'หมายเลขคำสั่งซื้อจากโรงงาน',
    ug: 'فابرىكا زاكاز نومۇرى',
    vi: 'Mã đơn hàng nhà máy',
    zh_tc: '工廠單號',
    ru: 'Номер заказа фабрики',
    ko: '공장 번호',
    bur: 'စက်ရုံအော်ဒါနံပါတ်',
    ben: 'কারখানার অর্ডার নম্বর',
    tr: 'Fabrika sipariş numarası',
    km: 'លេខបញ្ជារោងចក្រ',
    es: 'Número de pedido de fábrica',
    ar: 'رقم طلب المصنع',
  },
  'common.roomName': {
    zh: '房间名称',
    en: 'Room',
    id: 'Ruang',
    kz: 'бөлме',
    th: 'ห้อง',
    ug: 'ئۆي ئاتى',
    vi: 'phòng',
    zh_tc: '房間',
    ru: 'Комната',
    ko: '방 이름',
    bur: 'အခန်းအမည်',
    ben: 'ঘরের নাম',
    tr: 'Oda adı',
    km: 'ឈ្មោះបន្ទប់',
    es: 'Nombre de la habitación',
    ar: 'اسم الغرفة',
  },
  'common.color': {
    zh: '颜色',
    en: 'Color',
    id: 'warna',
    kz: 'түс',
    th: 'สี',
    ug: 'رەڭ',
    vi: 'Màu sắc',
    zh_tc: '顏色',
    ru: 'Цвет',
    ko: '색깔',
    bur: 'အရောင်',
    ben: 'রঙ',
    tr: 'Renk',
    km: 'ពណ៌',
    es: 'Color',
    ar: 'اللون',
  },
  'common.plankColor': {
    zh: '板材颜色',
    en: 'Board color',
    id: 'Warna piring',
    kz: 'тақта түсі',
    th: 'สีจาน',
    ug: 'تاختا رەڭگى',
    vi: 'Màu sắc ván',
    zh_tc: '板材顏色',
    ru: 'Цвет доски',
    ko: '판재 색상',
    bur: 'ပေါ်ဒ်အရောင်',
    ben: 'বোর্ডের রঙ',
    tr: 'Plate renk',
    km: 'ពណ៌ផ្ទាំង',
    es: 'Color del tablero',
    ar: 'لون اللوحة',
  },
  'common.plankThick': {
    zh: '板材厚度',
    en: 'Board thickness',
    id: 'Ketebalan pelat',
    kz: 'тақта қалыңдығы',
    th: 'ความหนาของแผ่น',
    ug: 'تاختا قېلىنلىقى',
    vi: 'Độ dày ván',
    zh_tc: '板材厚度',
    ru: 'Толщина доски',
    ko: '판재 두께',
    bur: 'ပေါ်ဒ်အထူ',
    ben: 'বোর্ডের পুরুত্ব',
    tr: 'Plate kalınlığı',
    km: 'កម្រាស់ផ្ទាំង',
    es: 'Grosor del tablero',
    ar: 'سمك اللوحة',
  },
  'common.plankHighGloss': {
    zh: '高光属性',
    en: 'Highlight Properties',
    id: 'Sorot atribut',
    kz: 'Атрибуттарды бөлектеу',
    th: 'ไฮไลต์คุณลักษณะ',
    ug: 'يۇقىرى يالتىراقلىق خاسلىقى',
    vi: 'Đánh dấu các thuộc tính',
    zh_tc: '高光屬性',
    ru: 'Свойства подсветки',
    ko: '하이라이트 속성',
    bur: 'ဂုဏ်သတ္တိမြင့်မားသောအလင်းတန်း',
    ben: 'হাইলাইট বৈশিষ্ট্য',
    tr: 'Highlight özellikleri',
    km: 'លក្ខណៈពន្លឺខ្ពស់',
    es: 'Atributo resaltado',
    ar: 'سمة التمييز',
  },
  'common.thick': {
    zh: '厚度',
    en: 'Thickness',
    id: 'ketebalan',
    kz: 'қалыңдығы',
    th: 'ความหนา',
    ug: 'قېلىنلىق',
    vi: 'Độ dày',
    zh_tc: '厚度',
    ru: 'Толщина',
    ko: '두께',
    bur: 'အထူ',
    ben: 'পুরুত্ব',
    tr: 'Kalınlık',
    km: 'កម្រាស់',
    es: 'Grosor',
    ar: 'السماكة',
  },
  'common.front': {
    zh: '正面',
    en: 'Front',
    id: 'depan',
    kz: 'алдыңғы',
    th: 'ด้านหน้า',
    ug: 'ئالدى',
    vi: 'Mặt trước',
    zh_tc: '正面',
    ru: 'Передняя сторона',
    ko: '정면',
    bur: 'ရှေ့ဘက်မျက်နှာ',
    ben: 'সামনের দিক',
    tr: 'Ön yüz',
    km: 'ផ្ទៃមុខ',
    es: 'Frente',
    ar: 'الواجهة الأمامية',
  },
  'common.back': {
    zh: '反面',
    en: 'Back',
    id: 'Sebaliknya',
    kz: 'артыңғы',
    th: 'ตรงกันข้าม',
    ug: 'ئارقا',
    vi: 'Mặt sau',
    zh_tc: '反面',
    ru: 'Задняя сторона',
    ko: '뒷면',
    bur: 'နောက်ဘက်မျက်နှာ',
    ben: 'পিছনের দিক',
    tr: 'Arka yüz',
    km: 'ផ្ទៃខាងក្រោយ',
    es: 'Reverso',
    ar: 'الجانب العكسي',
  },
  'common.slot': {
    zh: '槽',
    en: 'Slot',
    id: 'alur',
    kz: 'шұңқыр',
    th: 'ร่อง',
    ug: 'ئوچۇق',
    vi: 'Khe',
    zh_tc: '槽',
    ru: 'Канал',
    ko: '구멍',
    bur: 'ကြိုး',
    ben: 'স্লট',
    tr: 'Kanal',
    km: 'រយៈស្នឹង',
    es: 'Ranura',
    ar: 'الفتحة',
  },
  'common.hole': {
    zh: '孔',
    en: 'Hole',
    id: 'lubang',
    kz: 'тесік',
    th: 'รู',
    ug: 'تېشىك',
    vi: 'Lỗ',
    zh_tc: '孔',
    ru: 'Отверстие',
    ko: '구멍',
    bur: 'ပေါက်',
    ben: 'গর্ত',
    tr: 'Delik',
    km: 'រន្ធ',
    es: 'Orificio',
    ar: 'الفتحة',
  },
  'common.hsInfo': {
    zh: '{hole}孔{slot}槽',
    en: '{hole} Hole {slot} Slot',
    id: '{hole} hole {slot} slot',
    kz: '{hole} тесігі {slot} шұңқыр',
    th: '{hole} หลุม {slot} slot',
    ug: '{hole} تېشىك {slot} ئوچۇق',
    vi: '{hole} lỗ {slot} khe',
    zh_tc: '{hole}孔{slot}槽',
    ru: '{hole} отверстие {slot} канал',
    ko: '{hole} 구멍 {slot} 슬롯',
    bur: '{hole} ပေါက် {slot} ကြိုး',
    ben: '{hole} গর্ত {slot} স্লট',
    tr: '{hole} delik {slot} kanal',
    km: '{hole} ផ្ទុកការកំណត់របស់អ្នក',
    es: '{hole} Orificio {slot} Ranura',
    ar: '{hole} الفتحة {slot} الفتحة',
  },
  'common.diameter': {
    zh: '直径',
    en: 'Diameter',
    id: 'diameter',
    kz: 'диаметр',
    th: 'เส้นผ่าศูนย์กลาง',
    ug: 'دىئامېتىر',
    vi: 'Đường kính',
    zh_tc: '直徑',
    ru: 'Диаметр',
    ko: '직경',
    bur: 'အချင်း',
    ben: 'ব্যাস',
    tr: 'Çap',
    km: 'អង្កត់ផ្ចិត',
    es: 'Diámetro',
    ar: 'القطر',
  },
  'common.finishedWidth': {
    zh: '成品宽度',
    en: 'Finished product width',
    id: 'Lebar produk jadi',
    kz: 'тамамшық ені',
    th: 'ความกว้างของผลิตภัณฑ์สำเร็จรูป',
    ug: 'مۇكەممەل كەڭلىك',
    vi: 'Chiều rộng thành phẩm',
    zh_tc: '成品寬度',
    ru: 'Готовая ширина',
    ko: '최종 품목 너비',
    bur: 'ပြီးစီးသောပစ္စည်းအကျယ်',
    ben: 'সম্পন্ন পণ্যের প্রস্থ',
    tr: 'Tamamlandığında genişlik',
    km: 'ទទឹងផលិតផ្សារ',
    es: 'Ancho del producto terminado',
    ar: 'عرض المنتج النهائي',
  },
  'common.finishedHeight': {
    zh: '成品长度',
    en: 'Finished product length',
    id: 'Panjang produk jadi',
    kz: 'тамамшық биіктігі',
    th: 'ความยาวของผลิตภัณฑ์สำเร็จรูป',
    ug: 'مۇكەممەل ئۇزۇنلۇق',
    vi: 'Chiều dài thành phẩm',
    zh_tc: '成品長度',
    ru: 'Готовая длина',
    ko: '최종 품목 길이',
    bur: 'ပြီးစီးသောပစ္စည်းအရှည်',
    ben: 'সম্পন্ন পণ্যের দৈর্ঘ্য',
    tr: 'Tamamlandığında uzunluk',
    km: 'បណ្តោយផលិតផ្សារ',
    es: 'Largo del producto terminado',
    ar: 'طول المنتج النهائي',
  },
  'common.finishedArea': {
    zh: '成品面积(㎡)',
    en: 'Finished product area (㎡)',
    id: 'Luas produk jadi (㎡)',
    kz: 'тамамшық ауданы (㎡)',
    th: 'พื้นที่ผลิตภัณฑ์สำเร็จรูป (㎡)',
    ug: 'مۇكەممەل يەر مەيدانى (㎡)',
    vi: 'Diện tích thành phẩm (㎡)',
    zh_tc: '成品面積(㎡)',
    ru: 'Площадь готового изделия (㎡)',
    ko: '완성품 면적(㎡)',
    bur: 'ပြီးစီးသောပစ္စည်းဧရိယာ (㎡)',
    ben: 'সম্পন্ন পণ্যের ক্ষেত্রফল (㎡)',
    tr: 'Tamamlanmış ürün alanı (㎡)',
    km: 'ផ្ទៃផលិតផ្សារសំរេច (㎡)',
    es: 'Área del producto terminado (㎡)',
    ar: 'مساحة المنتج النهائي (㎡)',
  },
  'common.remarks': {
    zh: '备注信息',
    en: 'Remarks',
    id: 'Catatan',
    kz: 'түсініктеме',
    th: 'หมายเหตุ',
    ug: 'تېكىستۇرا',
    vi: 'Ghi chú',
    zh_tc: '备注信息',
    ru: 'Примечание',
    ko: '메모',
    bur: 'မှတ်ချက်',
    ben: 'মন্তব্য',
    tr: 'Not',
    km: 'ការពិពាហ្ឋដំណឹង',
    es: 'Comentario',
    ar: 'ملاحظات',
  },
  'common.remark1': {
    zh: '备注信息1',
    en: 'Remark 1',
    id: 'Catatan 1',
    kz: 'түсініктеме 1',
    th: 'หมายเหตุ 1',
    ug: 'تېكىستۇرا 1',
    vi: 'Ghi chú 1',
    zh_tc: '备注信息1',
    ru: 'Примечание 1',
    ko: '메모 1',
    bur: 'မှတ်ချက် 1',
    ben: 'মন্তব্য 1',
    tr: 'Not 1',
    km: 'ការពិពាហ្ឋដំណឹង 1',
    es: 'Comentario 1',
    ar: 'ملاحظات 1',
  },
  'common.remark2': {
    zh: '备注信息2',
    en: 'Remark 2',
    id: 'Catatan 2',
    kz: 'түсініктеме 2',
    th: 'หมายเหตุ 2',
    ug: 'تېكىستۇرا 2',
    vi: 'Ghi chú 2',
    zh_tc: '备注信息2',
    ru: 'Примечание 2',
    ko: '메모 2',
    bur: 'မှတ်ချက် 2',
    ben: 'মন্তব্য 2',
    tr: 'Not 2',
    km: 'ការពិពាហ្ឋដំណឹង 2',
    es: 'Comentario 2',
    ar: 'ملاحظات 2',
  },
  'common.remark3': {
    zh: '备注信息3',
    en: 'Remark 3',
    id: 'Catatan 3',
    kz: 'түсініктеме 3',
    th: 'หมายเหตุ 3',
    ug: 'تېكىستۇرا 3',
    vi: 'Ghi chú 3',
    zh_tc: '备注信息3',
    ru: 'Примечание 3',
    ko: '메모 3',
    bur: 'မှတ်ချက် 3',
    ben: 'মন্তব্য 3',
    tr: 'Not 3',
    km: 'ការពិពាហ្ឋដំណឹង 3',
    es: 'Comentario 3',
    ar: 'ملاحظات 3',
  },
  'common.remark4': {
    zh: '备注信息4',
    en: 'Remark 4',
    id: 'Catatan 4',
    kz: 'түсініктеме 4',
    th: 'หมายเหตุ 4',
    ug: 'تېكىستۇرا 4',
    vi: 'Ghi chú 4',
    zh_tc: '备注信息4',
    ru: 'Примечание 4',
    ko: '메모 4',
    bur: 'မှတ်ချက် 4',
    ben: 'মন্তব্য 4',
    tr: 'Not 4',
    km: 'ការពិពាហ្ឋដំណឹង 4',
    es: 'Comentario 4',
    ar: 'ملاحظات 4',
  },
  'common.remark5': {
    zh: '备注信息5',
    en: 'Remark 5',
    id: 'Catatan 5',
    kz: 'түсініктеме 5',
    th: 'หมายเหตุ 5',
    ug: 'تېكىستۇرا 5',
    vi: 'Ghi chú 5',
    zh_tc: '备注信息5',
    ru: 'Примечание 5',
    ko: '메모 5',
    bur: 'မှတ်ချက် 5',
    ben: 'মন্তব্য 5',
    tr: 'Not 5',
    km: 'ការពិពាហ្ឋដំណឹង 5',
    es: 'Comentario 5',
    ar: 'ملاحظات 5',
  },
  'common.remark6': {
    zh: '备注信息6',
    en: 'Remark 6',
    id: 'Catatan 6',
    kz: 'түсініктеме 6',
    th: 'หมายเหตุ 6',
    ug: 'تېكىستۇرا 6',
    vi: 'Ghi chú 6',
    zh_tc: '备注信息6',
    ru: 'Примечание 6',
    ko: '메모 6',
    bur: 'မှတ်ချက် 6',
    ben: 'মন্তব্য 6',
    tr: 'Not 6',
    km: 'ការពិពាហ្ឋដំណឹង 6',
    es: 'Comentario 6',
    ar: 'ملاحظات 6',
  },
  'common.remark7': {
    zh: '备注信息7',
    en: 'Remark 7',
    id: 'Catatan 7',
    kz: 'түсініктеме 7',
    th: 'หมายเหตุ 7',
    ug: 'تېكىستۇرا 7',
    vi: 'Ghi chú 7',
    zh_tc: '备注信息7',
    ru: 'Примечание 7',
    ko: '메모 7',
    bur: 'မှတ်ချက် 7',
    ben: 'মন্তব্য 7',
    tr: 'Not 7',
    km: 'ការពិពាហ្ឋដំណឹង 7',
    es: 'Comentario 7',
    ar: 'ملاحظات 7',
  },
  'common.remark8': {
    zh: '备注信息8',
    en: 'Remark 8',
    id: 'Catatan 8',
    kz: 'түсініктеме 8',
    th: 'หมายเหตุ 8',
    ug: 'تېكىستۇرا 8',
    vi: 'Ghi chú 8',
    zh_tc: '备注信息8',
    ru: 'Примечание 8',
    ko: '메모 8',
    bur: 'မှတ်ချက် 8',
    ben: 'মন্তব্য 8',
    tr: 'Not 8',
    km: 'ការពិពាហ្ឋដំណឹង 8',
    es: 'Comentario 8',
    ar: 'ملاحظات 8',
  },
  'common.remark9': {
    zh: '备注信息9',
    en: 'Remark 9',
    id: 'Catatan 9',
    kz: 'түсініктеме 9',
    th: 'หมายเหตุ 9',
    ug: 'تېكىستۇرا 9',
    vi: 'Ghi chú 9',
    zh_tc: '备注信息9',
    ru: 'Примечание 9',
    ko: '메모 9',
    bur: 'မှတ်ချက် 9',
    ben: 'মন্তব্য 9',
    tr: 'Not 9',
    km: 'ការពិពាហ្ឋដំណឹង 9',
    es: 'Comentario 9',
    ar: 'ملاحظات 9',
  },
  'common.remark10': {
    zh: '备注信息10',
    en: 'Remark 10',
    id: 'Catatan 10',
    kz: 'түсініктеме 10',
    th: 'หมายเหตุ 10',
    ug: 'تېكىستۇرا 10',
    vi: 'Ghi chú 10',
    zh_tc: '备注信息10',
    ru: 'Примечание 10',
    ko: '메모 10',
    bur: 'မှတ်ချက် 10',
    ben: 'মন্তব্য 10',
    tr: 'Not 10',
    km: 'ការពិពាហ្ឋដំណឹង 10',
    es: 'Comentario 10',
    ar: 'ملاحظات 10',
  },
  'common.remark11': {
    zh: '备注信息11',
    en: 'Remark 11',
    id: 'Catatan 11',
    kz: 'түсініктеме 11',
    th: 'หมายเหตุ 11',
    ug: 'تېكىستۇرا 11',
    vi: 'Ghi chú 11',
    zh_tc: '备注信息11',
    ru: 'Примечание 11',
    ko: '메모 11',
    bur: 'မှတ်ချက် 11',
    ben: 'মন্তব্য 11',
    tr: 'Not 11',
    km: 'ការពិពាហ្ឋដំណឹង 11',
    es: 'Comentario 11',
    ar: 'ملاحظات 11',
  },
  'common.remark12': {
    zh: '备注信息12',
    en: 'Remark 12',
    id: 'Catatan 12',
    kz: 'түсініктеме 12',
    th: 'หมายเหตุ 12',
    ug: 'تېكىستۇرا 12',
    vi: 'Ghi chú 12',
    zh_tc: '备注信息12',
    ru: 'Примечание 12',
    ko: '메모 12',
    bur: 'မှတ်ချက် 12',
    ben: 'মন্তব্য 12',
    tr: 'Not 12',
    km: 'ការពិពាហ្ឋដំណឹង 12',
    es: 'Comentario 12',
    ar: 'ملاحظات 12',
  },
  'common.remark13': {
    zh: '备注信息13',
    en: 'Remark 13',
    id: 'Catatan 13',
    kz: 'түсініктеме 13',
    th: 'หมายเหตุ 13',
    ug: 'تېكىستۇرا 13',
    vi: 'Ghi chú 13',
    zh_tc: '备注信息13',
    ru: 'Примечание 13',
    ko: '메모 13',
    bur: 'မှတ်ချက် 13',
    ben: 'মন্তব্য 13',
    tr: 'Not 13',
    km: 'ការពិពាហ្ឋដំណឹង 13',
    es: 'Comentario 13',
    ar: 'ملاحظات 13',
  },
  'common.remark14': {
    zh: '备注信息14',
    en: 'Remark 14',
    id: 'Catatan 14',
    kz: 'түсініктеме 14',
    th: 'หมายเหตุ 14',
    ug: 'تېكىستۇرا 14',
    vi: 'Ghi chú 14',
    zh_tc: '备注信息14',
    ru: 'Примечание 14',
    ko: '메모 14',
    bur: 'မှတ်ချက် 14',
    ben: 'মন্তব্য 14',
    tr: 'Not 14',
    km: 'ការពិពាហ្ឋដំណឹង 14',
    es: 'Comentario 14',
    ar: 'ملاحظات 14',
  },
  'common.remark15': {
    zh: '备注信息15',
    en: 'Remark 15',
    id: 'Catatan 15',
    kz: 'түсініктеме 15',
    th: 'หมายเหตุ 15',
    ug: 'تېكىستۇرا 15',
    vi: 'Ghi chú 15',
    zh_tc: '备注信息15',
    ru: 'Примечание 15',
    ko: '메모 15',
    bur: 'မှတ်ချက် 15',
    ben: 'মন্তব্য 15',
    tr: 'Not 15',
    km: 'ការពិពាហ្ឋដំណឹង 15',
    es: 'Comentario 15',
    ar: 'ملاحظات 15',
  },
  'common.remark16': {
    zh: '备注信息16',
    en: 'Remark 16',
    id: 'Catatan 16',
    kz: 'түсініктеме 16',
    th: 'หมายเหตุ 16',
    ug: 'تېكىستۇرا 16',
    vi: 'Ghi chú 16',
    zh_tc: '备注信息16',
    ru: 'Примечание 16',
    ko: '메모 16',
    bur: 'မှတ်ချက် 16',
    ben: 'মন্তব্য 16',
    tr: 'Not 16',
    km: 'ការពិពាហ្ឋដំណឹង 16',
    es: 'Comentario 16',
    ar: 'ملاحظات 16',
  },
  'common.texture': {
    zh: '纹理',
    en: 'Texture',
    id: 'Tekstur',
    kz: 'текстура',
    th: 'พื้นผิว',
    ug: 'تېكىستۇرا',
    vi: 'Kết cấu bề mặt',
    zh_tc: '紋理',
    ru: 'Текстура',
    ko: '텍스쳐',
    bur: 'ကြောင်းအမျိုးအစား',
    ben: 'টেক্সচার',
    tr: 'Yüzey yapısı',
    km: 'វាល',
    es: 'Textura',
    ar: 'الملمس',
  },
  'common.normal': {
    zh: '竖纹',
    en: 'Vertical texture',
    id: 'Garis vertikal',
    kz: 'тік текстура',
    th: 'เส้นแนวตั้ง',
    ug: 'تىك',
    vi: 'Kết cấu dọc',
    zh_tc: '豎紋',
    ru: 'Вертикальная текстура',
    ko: '세로 무늬',
    bur: 'ဒေါင်လိုက်ကြောင်း',
    ben: 'উল্লম্ব টেক্সচার',
    tr: 'Dikey yapısı',
    km: 'វាលបញ្ឈរ',
    es: 'Veta vertical',
    ar: 'الحبوب العمودية',
  },
  'common.reverse': {
    zh: '横纹',
    en: 'Horizontal texture',
    id: 'Garis horizontal',
    kz: 'қайта текстура',
    th: 'เส้นแนวนอน',
    ug: 'توغرا',
    vi: 'Kết cấu ngang',
    zh_tc: '橫紋',
    ru: 'Горизонтальная текстура',
    ko: '가로무늬',
    bur: 'အလျားလိုက်ကြောင်း',
    ben: 'অনুভূমিক টেক্সচার',
    tr: 'Yatay yapısı',
    km: 'វាលផ្ដេក',
    es: 'Veta horizontal',
    ar: 'الحبوب الأفقية',
  },
  'common.notCare': {
    zh: '无纹理',
    en: 'No texture',
    id: 'Tidak ada tekstur',
    kz: 'текстурасыз',
    th: 'ไม่มีพื้นผิว',
    ug: 'تېكىستۇرا يوق',
    vi: 'Không có kết cấu',
    zh_tc: '無紋理',
    ru: 'Без текстуры',
    ko: '텍스쳐 없음',
    bur: 'ကြောင်းမရှိ',
    ben: 'কোনো টেক্সচার নেই',
    tr: 'Yüzey yapısı yok',
    km: 'គ្មានវាល',
    es: 'Sin textura',
    ar: 'بدون نسيج',
  },
  'common.holeSlotsStastic': {
    zh: '孔槽数量',
    en: 'Hole and Slot Count',
    id: 'Jumlah slot lubang',
    kz: 'тесік-шұңқыр саны',
    th: 'จำนวนช่องหลุม',
    ug: 'تېشىك ۋە ئوچۇق سانى',
    vi: 'Thống kê số lượng lỗ và khe',
    zh_tc: '孔槽數量',
    ru: 'Количество отверстий и каналов',
    ko: '구멍 슬롯 수',
    bur: 'ပေါက်နှင့်ကြိုးအရေအတွက်',
    ben: 'গর্ত ও স্লটের পরিমাণ',
    tr: 'Delik ve Kanal Sayısı',
    km: 'ចំនួនរន្ធនិងរយៈស្នឹង',
    es: 'Número de orificios y ranuras',
    ar: 'عدد الثقوب والفتحات',
  },
  'common.edge.title': {
    zh: '封边',
    en: 'Edge',
    id: 'Segel tepi',
    kz: 'кенет',
    th: 'ปิดผนึกขอบ',
    ug: 'چىگارلاش',
    vi: 'Đóng biên',
    zh_tc: '封邊',
    ru: 'Край',
    ko: '봉인',
    bur: 'အနားပိတ်',
    ben: 'প্রান্ত সিলিং',
    tr: 'Kenar',
    km: 'រុំគែម',
    es: 'Sellado de bordes',
    ar: 'إحكام الحواف',
  },
  'common.edge.info': {
    zh: '封边信息',
    en: 'Edge information',
    id: 'Informasi pemblokiran tepi',
    kz: 'кенет туралы ақпарат',
    th: 'ข้อมูลการบล็อกขอบ',
    ug: 'چىگارلاش ئۇچۇرى',
    vi: 'Thông tin đóng biên',
    zh_tc: '封邊信息',
    ru: 'Информация о крае',
    ko: '봉인 정보',
    bur: 'အနားပိတ်သတင်းအချက်အလက်',
    ben: 'প্রান্ত সিলিং তথ্য',
    tr: 'Kenar bilgileri',
    km: 'ព័ត៌មានរុំគែម',
    es: 'Información sobre sellado de bordes',
    ar: 'الحافة معلومات الختم',
  },
  'common.edge.front': {
    zh: '前封边',
    en: 'Front edge',
    id: 'Segel tepi depan',
    kz: 'алдыңғы кенет',
    th: 'ซีลขอบด้านหน้า',
    ug: 'ئالدى چىگارلاش',
    vi: 'Đóng biên trước',
    zh_tc: '前封邊',
    ru: 'Передний край',
    ko: '전면 모서리',
    bur: 'ရှေ့အနားပိတ်',
    ben: 'সামনের প্রান্ত সিলিং',
    tr: 'Ön kenar',
    km: 'រុំគែមខាងមុខ',
    es: 'Borde delantero',
    ar: 'نطاقات الحافة الأمامية',
  },
  'common.edge.back': {
    zh: '后封边',
    en: 'Back edge',
    id: 'Segel tepi belakang',
    kz: 'артыңғы кенет',
    th: 'ปิดผนึกขอบด้านหลัง',
    ug: 'ئارقا چىگارلاش',
    vi: 'Đóng biên sau',
    zh_tc: '後封邊',
    ru: 'Задний край',
    ko: '후면 모서리',
    bur: 'နောက်အနားပိတ်',
    ben: 'পিছনের প্রান্ত সিলিং',
    tr: 'Arka kenar',
    km: 'រុំគែមខាងក្រោយ',
    es: 'Borde trasero',
    ar: 'نطاقات الحافة الخلفية',
  },
  'common.edge.left': {
    zh: '左封边',
    en: 'Left edge',
    id: 'Blok sisi kiri',
    kz: 'сол kenet',
    th: 'บล็อกด้านซ้าย',
    ug: 'سول چىگارلاش',
    vi: 'Đóng biên trái',
    zh_tc: '左封邊',
    ru: 'Левый край',
    ko: '왼쪽 봉인',
    bur: 'ဘယ်အနားပိတ်',
    ben: 'বাম প্রান্ত সিলিং',
    tr: 'Sol kenar',
    km: 'រុំគែមខាងឆ្វេង',
    es: 'Borde izquierdo',
    ar: 'نطاقات الحافة اليسرى',
  },
  'common.edge.right': {
    zh: '右封边',
    en: 'Right edge',
    id: 'Blok sisi kanan',
    kz: 'оң kenet',
    th: 'บล็อกด้านขวา',
    ug: 'ئوڭ چىگارلاش',
    vi: 'Đóng biên phải',
    zh_tc: '右封邊',
    ru: 'Правый край',
    ko: '오른쪽 봉인',
    bur: 'ညာအနားပိတ်',
    ben: 'ডান প্রান্ত সিলিং',
    tr: 'Sağ kenar',
    km: 'រុំគែមខាងស្តាំ',
    es: 'Borde derecho',
    ar: 'نطاقات الحافة اليمنى',
  },
  'common.edge.up': {
    zh: '上封边',
    en: 'Upper edge',
    id: 'Segel tepi atas',
    kz: 'юғары kenet',
    th: 'ปิดผนึกขอบด้านบน',
    ug: 'يۇقىرى چىگارلاش',
    vi: 'Đóng biên trên',
    zh_tc: '上封邊',
    ru: 'Верхний край',
    ko: '위쪽 봉인 모서리',
    bur: 'အပေါ်အနားပိတ်',
    ben: 'উপরের প্রান্ত সিলিং',
    tr: 'Üst kenar',
    km: 'រុំគែមខាងលើ',
    es: 'Borde superior',
    ar: 'نطاقات الحافة العلوية',
  },
  'common.edge.down': {
    zh: '下封边',
    en: 'Bottom edge',
    id: 'Segel tepi berikutnya',
    kz: 'түшіңгі kenet',
    th: 'ซีลขอบถัดไป',
    ug: 'تۆۋەن چىگارلاش',
    vi: 'Đóng biên dưới',
    zh_tc: '下封邊',
    ru: 'Нижний край',
    ko: '아래 봉인 모서리',
    bur: 'အောက်အနားပိတ်',
    ben: 'নিচের প্রান্ত সিলিং',
    tr: 'Alt kenar',
    km: 'រុំគែមខាងក្រោម',
    es: 'Borde inferior',
    ar: 'نطاقات الحافة السفلية',
  },
  'common.isSpecial': {
    zh: '异形',
    en: 'Special-shaped',
    id: 'Asing',
    kz: 'арнайы',
    th: 'คนต่างด้าว',
    ug: 'ئالاھىدە',
    vi: 'Hình dáng khác',
    zh_tc: '異形',
    ru: 'Нестандартный',
    ko: '에일리언',
    bur: 'အထူးပုံသဏ္ဍာန်',
    ben: 'অনিয়মিত আকৃতি',
    tr: 'Özel şekilli',
    km: 'រាងពិសេស',
    es: 'Forma especial',
    ar: 'شكل خاص',
  },
  'common.notSpecial': {
    zh: '非异形',
    en: 'Not Special',
    id: 'Tidak berbentuk non-ekstra',
    kz: 'арнайы емес',
    th: 'ไม่มีรูป',
    ug: 'ئالاھىدە ئەمەس',
    vi: 'Hình dáng thông thường',
    zh_tc: '非異形',
    ru: 'Нестандартный',
    ko: '비이형',
    bur: 'ပုံမှန်ပုံသဏ္ဍာန်',
    ben: 'সাধারণ আকৃতি',
    tr: 'Özel değil',
    km: 'មិនមែនរាងពិសេស',
    es: 'Forma no especial',
    ar: 'شكل غير خاص',
  },
  'common.textOfDoorPlank': {
    zh: '的门板',
    en: 'Door board',
    id: 'Panel pintu',
    kz: 'есік тақта',
    th: 'แผงประตู',
    ug: 'ئىشىك تاختىسى',
    vi: 'Tấm cửa',
    zh_tc: '的門板',
    ru: 'Дверная доска',
    ko: '문짝',
    bur: 'တံခါးပေါ်ဒ်',
    ben: 'দরজার বোর্ড',
    tr: 'Kapı panosu',
    km: 'បន្ទះទ្វារ',
    es: 'Panel de puerta',
    ar: 'لوحة الباب',
  },
  'common.textOfNotDoorPlank': {
    zh: '的非门板',
    en: 'Not a Door Board',
    id: 'Panel non-pintu',
    kz: 'есік тақта емес',
    th: 'แผงที่ไม่ใช่ประตู',
    ug: 'ئىشىك تاختىسى ئەمەس',
    vi: 'Tấm không phải cửa',
    zh_tc: '的非門板',
    ru: 'Не дверная доска',
    ko: '비문짝',
    bur: 'တံခါးမဟုတ်သောပေါ်ဒ်',
    ben: 'নন-দরজা বোর্ড',
    tr: 'Kapı olmayan pano',
    km: 'បន្ទះមិនមែនទ្វារ',
    es: 'Panel que no es de puerta',
    ar: 'لوحة غير باب',
  },
  'common.isDoorPlank': {
    zh: '门板',
    en: 'Door board',
    id: 'Panel pintu',
    kz: 'есік тақта',
    th: 'แผงประตู',
    ug: 'ئىشىك تاختىسى',
    vi: 'Tấm cửa',
    zh_tc: '門板',
    ru: 'Дверная доска',
    ko: '문짝',
    bur: 'တံခါးပေါ်ဒ်',
    ben: 'দরজার বোর্ড',
    tr: 'Kapı panosu',
    km: 'បន្ទះទ្វារ',
    es: 'Panel de puerta',
    ar: 'لوحة الباب',
  },
  'common.notDoorPlank': {
    zh: '非门板',
    en: 'Not a Door Board',
    id: 'Panel non-pintu',
    kz: 'есік тақта емес',
    th: 'แผงที่ไม่ใช่ประตู',
    ug: 'ئىشىك تاختىسى ئەمەس',
    vi: 'Không phải là tấm cửa',
    zh_tc: '非門板',
    ru: 'Не дверная доска',
    ko: '비문판',
    bur: 'တံခါးပေါ်ဒ်မဟုတ်',
    ben: 'দরজার বোর্ড নয়',
    tr: 'Kapı panosu değil',
    km: 'មិនមែនបន្ទះទ្វារ',
    es: 'Panel sin puerta',
    ar: 'لوحة غير باب',
  },
  'common.width': {
    zh: '宽度',
    en: 'Width',
    id: 'lebar',
    kz: 'ен',
    th: 'ความกว้าง',
    ug: 'كەڭلىك',
    vi: 'Chiều rộng',
    zh_tc: '寬度',
    ru: 'Ширина',
    ko: '너비',
    bur: 'အကျယ်',
    ben: 'প্রস্থ',
    tr: 'Genişlik',
    km: 'ទទឹង',
    es: 'Ancho',
    ar: 'العرض',
  },
  'common.long': {
    zh: '长度',
    en: 'Length',
    id: 'panjang',
    kz: 'биіктігі',
    th: 'ความยาว',
    ug: 'ئۇزۇنلۇق',
    vi: 'Chiều dài',
    zh_tc: '長度',
    ru: 'Длина',
    ko: '길이',
    bur: 'အရှည်',
    ben: 'দৈর্ঘ্য',
    tr: 'Uzunluk',
    km: 'បណ្តោយ',
    es: 'Largo',
    ar: 'الطول',
  },
  'common.plankWidth': {
    zh: '板材宽度',
    en: 'Board width',
    id: 'Lebar piring',
    kz: 'тақта ені',
    th: 'ความกว้างของแผ่น',
    ug: 'تاختا كەڭلىكى',
    vi: 'Chiều rộng ván',
    zh_tc: '板材寬度',
    ru: 'Ширина доски',
    ko: '판재 너비',
    bur: 'ပေါ်ဒ်အကျယ်',
    ben: 'বোর্ডের প্রস্থ',
    tr: 'Panoyun genişliği',
    km: 'ទទឹងផ្ទាំង',
    es: 'Ancho de tablero',
    ar: 'عرض اللوحة',
  },
  'common.plankHeight': {
    zh: '板材长度',
    en: 'Board length',
    id: 'Panjang piring',
    kz: 'тақта биіктігі',
    th: 'ความยาวแผ่น',
    ug: 'تاختا ئۇزۇنلۇقى',
    vi: 'Chiều dài ván',
    zh_tc: '板材長度',
    ru: 'Длина доски',
    ko: '판재 길이',
    bur: 'ပေါ်ဒ်အရှည်',
    ben: 'বোর্ডের দৈর্ঘ্য',
    tr: 'Panoyun uzunluğu',
    km: 'បណ្តោយផ្ទាំង',
    es: 'Largo de tablero',
    ar: 'طول اللوحة',
  },
  'common.shortLong': {
    zh: '短边长度',
    en: 'Short Side Length',
    id: 'Panjang sisi pendek',
    kz: 'қысқа биіктігі',
    th: 'ความยาวด้านสั้น',
    ug: 'قىسقا تەرەپ ئۇزۇنلۇقى',
    vi: 'Chiều dài cạnh ngắn',
    zh_tc: '短邊長度',
    ru: 'Длина короткой стороны',
    ko: '짧은 모서리 길이',
    bur: 'တိုသောဘက်အရှည်',
    ben: 'ছোট দিকের দৈর্ঘ্য',
    tr: 'Kısa kenar uzunluğu',
    km: 'បណ្តោយជ្រុងខ្លី',
    es: 'Corto largo del lado',
    ar: 'طول الجانب القصير',
  },
  'common.shortWidth': {
    zh: '短边宽度',
    en: 'Short Side Width',
    id: 'Lebar sisi pendek',
    kz: 'қысқа ені',
    th: 'ความกว้างด้านสั้น',
    ug: 'قىسقا تەرەپ كەڭلىكى',
    vi: 'Chiều rộng cạnh ngắn',
    zh_tc: '短邊寬度',
    ru: 'Ширина короткой стороны',
    ko: '짧은 모서리 폭',
    bur: 'တိုသောဘက်အကျယ်',
    ben: 'ছোট দিকের প্রস্থ',
    tr: 'Kısa kenar genişliği',
    km: 'ទទឹងជ្រុងខ្លី',
    es: 'Ancho del lado corto',
    ar: 'عرض الجانب القصير',
  },
  'common.plankShape': {
    zh: '板材形状',
    en: 'Plank Shape',
    id: 'Bentuk piring',
    kz: 'Тақтайдың пішіні',
    th: 'รูปแผ่น',
    ug: 'تاختا شەكلى',
    vi: 'Hình dáng ván',
    zh_tc: '板材形狀',
    ru: 'Форма доски',
    ko: '판재 모양',
    bur: 'ပေါ်ဒ်ပုံသဏ္ဍာန်',
    ben: 'বোর্ডের আকৃতি',
    tr: 'Panoyun şekli',
    km: 'រាងផ្ទាំង',
    es: 'Forma de la placa',
    ar: 'شكل اللوحة',
  },
  'common.detail': {
    zh: '详情',
    en: 'Details',
    id: 'Detail',
    kz: 'Толығырақ',
    th: 'รายละเอียด',
    ug: 'تەپسىلات',
    vi: 'Chi tiết',
    zh_tc: '詳情',
    ru: 'Подробнее',
    ko: '상세 정보',
    bur: 'အသေးစိတ်',
    ben: 'বিস্তারিত',
    tr: 'Detaylar',
    km: 'ព័ត៌មានលម្អិត',
    es: 'Detalles',
    ar: 'التفاصيل',
  },
  'common.cancel': {
    zh: '取消',
    en: 'Cancel',
    id: 'Membatalkan',
    kz: 'жокко ету',
    th: 'ยกเลิก',
    ug: 'بىكار قىل',
    vi: 'Hủy',
    zh_tc: '取消',
    ru: 'Отмена',
    ko: '취소',
    bur: 'ပယ်ဖျက်ပါ',
    ben: 'বাতিল করুন',
    tr: 'İptal et',
    km: 'បោះបង់',
    es: 'Cancelar',
    ar: 'إلغاء',
  },
  'common.confirm': {
    zh: '确认',
    en: 'Confirm',
    id: 'mengonfirmasi',
    kz: 'тастықтау',
    th: 'ยืนยัน',
    ug: 'جەزملەشتۈرۈڭ',
    vi: 'Xác nhận',
    zh_tc: '確認',
    ru: 'Подтвердить',
    ko: '확인',
    bur: 'အတည်ပြုပါ',
    ben: 'নিশ্চিত করুন',
    tr: 'Onayla',
    km: 'បញ្ជាក់',
    es: 'Confirmar',
    ar: 'تأكيد',
  },
  'common.alreadyKnow': {
    zh: '我已知晓',
    en: 'I already know',
    id: 'Saya sudah tahu',
    kz: 'Мен бұл жөнүндӓ білеймін',
    th: 'ฉันรู้แล้ว',
    ug: 'مەن بىلىمەن',
    vi: 'Tôi đã biết rồi.',
    zh_tc: '我已瞭解',
    ru: 'Я уже знаю',
    ko: '나는 이미 알고 있다',
    bur: 'ကျွန်တော်သိပြီ',
    ben: 'আমি ইতিমধ্যে জানি',
    tr: 'Zaten biliyorum',
    km: 'ខ្ញុំបានដឹងហើយ',
    es: 'Lo sé',
    ar: 'أعرف',
  },
  'common.Noprompts': {
    zh: '不再提示',
    en: 'No more prompts',
    id: 'Tidak ada lagi peringatan',
    kz: 'Ешқандай көрсеткі бермей',
    th: 'ไม่มีการแจ้งเตือนอีก',
    ug: 'ئۇقتۇرۇش بەرمە',
    vi: 'Không còn gợi ý nữa',
    zh_tc: '不再提示',
    ru: 'Больше не напоминать',
    ko: '더 이상 프롬프트 없음',
    bur: 'နောက်ထပ်မပြတော့',
    ben: 'আর প্রম্পট নয়',
    tr: 'Bir daha gösterme',
    km: 'កុំបង្ហាញទៀត',
    es: 'No volver a preguntar',
    ar: 'لا تطالب مرة أخرى',
  },
  'common.deep': {
    zh: '深度',
    en: 'Depth',
    id: 'kedalaman',
    kz: 'тереңдік',
    th: 'ความลึก',
    ug: 'چوڭقۇرلۇق',
    vi: 'Độ sâu',
    zh_tc: '深度',
    ru: 'Глубина',
    ko: '깊이',
    bur: 'နက်သောနေရာ',
    ben: 'গভীরতা',
    tr: 'Derinlik',
    km: 'ជម្រៅ',
    es: 'Profundidad',
    ar: 'العمق',
  },
  'common.other': {
    zh: '其他',
    en: 'Others',
    id: 'lainnya',
    kz: 'басқа',
    th: 'อื่น',
    ug: 'باشقا',
    vi: 'Khác',
    zh_tc: '其他',
    ru: 'Другое',
    ko: '기타',
    bur: 'အခြား',
    ben: 'অন্যান্য',
    tr: 'Diğer',
    km: 'ផ្សេងៗ',
    es: 'Otros',
    ar: 'أخرى',
  },
  'common.heighGloss': {
    zh: '高光',
    en: 'High gloss',
    id: 'Menyorot',
    kz: 'жоғары глянс',
    th: 'เน้น',
    ug: 'يۇقىرى يالتىراق',
    vi: 'Màu sáng',
    zh_tc: '高光',
    ru: 'Высокий блеск',
    ko: '하이라이터',
    bur: 'မြင့်မားသောဂလော့',
    ben: 'হাই গ্লস',
    tr: 'Yüksek গ্লস',
    km: 'ពន្លឺខ្ពស់',
    es: 'Resaltado',
    ar: 'تمييز',
  },
  'common.heighGlossPlank': {
    zh: '高光板',
    en: 'High-gloss board',
    id: 'Papan Sorotan',
    kz: 'жоғары глянс тақта',
    th: 'ไฮไลต์บอร์ด',
    ug: 'يۇقىرى يالتىراق تاختا',
    vi: 'Ván màu sáng',
    zh_tc: '高光板',
    ru: 'Высокий блеск доски',
    ko: '고광판',
    bur: 'မြင့်မားသောဂလော့ပေါ်ဒ်',
    ben: 'হাই গ্লস বোর্ড',
    tr: 'Yüksek গ্লস বোর্ড',
    km: 'ផ្ទាំងពន្លឺខ្ពស់',
    es: 'Placa resaltada',
    ar: 'لوحة التمييز',
  },
  'common.heighGlossSide': {
    zh: '高光面',
    en: 'High gloss side',
    id: 'Sisi Sorotan',
    kz: 'жоғары глянс жақ',
    th: 'ด้านเน้น',
    ug: 'يۇقىرى يالتىراق ئاڭ',
    vi: 'Mặt màu sáng',
    zh_tc: '高光面',
    ru: 'Высокий блеск сторона',
    ko: '고광면',
    bur: 'မြင့်မားသောဂလော့ပေါ်ဒ်',
    ben: 'হাই গ্লস বোর্ড',
    tr: 'Yüksek গ্লস বোর্ড',
    km: 'ផ្ទាំងពន្លឺខ្ពស់',
    es: 'Placa resaltada',
    ar: 'لوحة التمييز',
  },
  'common.notHeighGloss': {
    zh: '非高光',
    en: 'Not High Gloss',
    id: 'Non-highlight',
    kz: 'жоғары глянс емес',
    th: 'ไม่สูง',
    ug: 'يۇقىرى يالتىراق ئەمەس',
    vi: 'Không phải màu sáng',
    zh_tc: '非高光',
    ru: 'Не высокий блеск',
    ko: '비고광선',
    bur: 'မြင့်မားသောဂလော့မဟုတ်',
    ben: 'হাই গ্লস নয়',
    tr: 'Yüksek গ্লস বোর্ড নয়',
    km: 'មិនមែនពន្លឺខ្ពស់',
    es: 'Sin resaltado',
    ar: 'غير تمييز',
  },
  'common.notHeighGlossPlank': {
    zh: '非高光板',
    en: 'Not a High Gloss Board',
    id: 'Papan non-highlight',
    kz: 'жоғары глянс емес тақта',
    th: 'บอร์ดที่ไม่ได้มีแสงสว่าง',
    ug: 'يۇقىرى يالتىراق تاختا ئەمەس',
    vi: 'Ván không phải màu sáng',
    zh_tc: '非高光板',
    ru: 'Не высокий блеск доски',
    ko: '비고광판',
    bur: 'မြင့်မားသောဂလော့ပေါ်ဒ်မဟုတ်',
    ben: 'হাই গ্লস বোর্ড নয়',
    tr: 'Yüksek গ্লস বোর্ড নয়',
    km: 'មិនមែនផ្ទាំងពន្លឺខ្ពស់',
    es: 'Placa sin alto brillo',
    ar: 'لوحة غير شديدة اللمعان',
  },
  'common.saveSuccess': {
    zh: '保存成功',
    en: 'Save success',
    id: 'Simpan dengan sukses',
    kz: 'сақталды',
    th: 'บันทึกให้สำเร็จ',
    ug: 'ساقلاش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Lưu thành công',
    zh_tc: '保存成功',
    ru: 'Сохранено успешно',
    ko: '저장 성공',
    bur: 'သိမ်းဆည်းအောင်မြင်',
    ben: 'সফলভাবে সংরক্ষিত',
    tr: 'Kaydetme başarılı',
    km: 'រក្សាទុកជោគជ័យ',
    es: 'Guardado exitosamente',
    ar: 'تم الحفظ بنجاح',
  },
  'common.deleteSuccess': {
    zh: '删除成功',
    en: 'Delete success',
    id: 'Hapus dengan sukses',
    kz: 'жойалды',
    th: 'ลบออกได้สำเร็จ',
    ug: 'ئۆچۈرۈش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Xóa thành công',
    zh_tc: '刪除成功',
    ru: 'Удалено успешно',
    ko: '삭제 성공',
    bur: 'ဖျက်ဆီးအောင်မြင်',
    ben: 'সফলভাবে মুছা হয়েছে',
    tr: 'Silme başarılı',
    km: 'លុបជោគជ័យ',
    es: 'Eliminar con éxito',
    ar: 'تم الحذف بنجاح',
  },
  'common.addSuccess': {
    zh: '添加成功',
    en: 'Add success',
    id: 'Ditambahkan dengan sukses',
    kz: 'қосалды',
    th: 'เพิ่มสำเร็จ',
    ug: 'قوشۇش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Thêm thành công',
    zh_tc: '添加成功',
    ru: 'Добавлено успешно',
    ko: '추가 성공',
    bur: 'ထည့်သွင်းအောင်မြင်',
    ben: 'সফলভাবে যোগ করা হয়েছে',
    tr: 'Ekleme başarılı',
    km: 'បន្ថែមជោគជ័យ',
    es: 'Agregar con éxito',
    ar: 'الإضافة بنجاح',
  },
  'common.editSuccess': {
    zh: '修改成功',
    en: 'Edit success',
    id: 'Modifikasi berhasil',
    kz: 'өзгертілді',
    th: 'การดัดแปลงประสบความสำเร็จ',
    ug: 'تەھرىرلەش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Sửa thành công',
    zh_tc: '修改成功',
    ru: 'Изменено успешно',
    ko: '수정 성공',
    bur: 'တည်းဖြတ်အောင်မြင်',
    ben: 'সফলভাবে সম্পাদনা করা হয়েছে',
    tr: 'Düzenleme başarılı',
    km: 'កែប្រែជោគជ័យ',
    es: 'Modificar con éxito',
    ar: 'التعديل بنجاح',
  },
  'common.engraving': {
    zh: '雕刻机',
    en: 'Engraving machine',
    id: 'Mesin ukiran',
    kz: 'оюлу машина',
    th: 'เครื่องแกะสลัก',
    ug: 'ئويما ماشىنىسى',
    vi: 'Máy khắc',
    zh_tc: '雕刻機',
    ru: 'Фрезерный станок',
    ko: '조각기',
    bur: 'အမြစ်ချစက်',
    ben: 'খোদাই মেশিন',
    tr: 'Kesme makinesi',
    km: 'ម៉ាស៊ីនចាក់រូប',
    es: 'Máquina de grabado',
    ar: 'آلة النقش',
  },
  'common.electronicSaw': {
    zh: '电子锯',
    en: 'Electronic Saw',
    id: 'Gergaji elektronik',
    kz: 'электрондық кескіш',
    th: 'เลื่อยอิเล็กทรอนิกส์',
    ug: 'ئېلېكترونلۇق ئارا',
    vi: 'Máy cưa điện tử',
    zh_tc: '電子鋸',
    ru: 'Электропила',
    ko: '전자톱',
    bur: 'ဒီဂျစ်တယ်မြဲ',
    ben: 'ইলেকট্রনিক করাত',
    tr: 'Elektrikli kesme makinesi',
    km: 'រណាអេឡិចត្រូនិច',
    es: 'Sierra electrónica',
    ar: 'المنشار الإلكتروني',
  },
  'common.glassEquip': {
    zh: '玻璃切割机',
    en: 'Glass Cutting Machine',
    id: 'Mesin pemotong kaca',
    kz: 'шыны кескіш машина',
    th: 'เครื่องตัดแก้ว',
    ug: 'ئەينەك كېسىش ماشىنىسى',
    vi: 'Máy cắt kính',
    zh_tc: '玻璃切割機',
    ru: 'Машина для резки стекла',
    ko: '유리 절단기',
    bur: 'မှန်ဖြတ်စက်',
    ben: 'কাচ কাটার মেশিন',
    tr: 'Cam kesme makinesi',
    km: 'ម៉ាស៊ីនកាត់កញ្ចក់',
    es: 'Máquina cortadora de vidrio',
    ar: 'آلة قطع الزجاج',
  },
  'common.labelingMachine': {
    zh: '贴标机',
    en: 'labeling machine',
    id: 'Mesin pelabelan',
    kz: 'Таптама машина',
    th: 'เครื่องติดฉลาก',
    ug: 'بېلگە چاپلاش ماشىنىسى',
    vi: 'Máy dán nhãn',
    zh_tc: '貼標機',
    ru: 'Машина для наклейки этикеток',
    ko: '부착기',
    bur: 'တံဆိပ်ကပ်စက်',
    ben: 'লেবেলিং মেশিন',
    tr: 'Etiket makinesi',
    km: 'ម៉ាស៊ីនបិទស្លាក',
    es: 'Máquina etiquetadora',
    ar: 'آلة وضع الملصقات',
  },
  'common.copy': {
    zh: '复制',
    en: 'Copy',
    id: 'menyalin',
    kz: 'Көшіру',
    th: 'สำเนา',
    ug: 'كۆچۈرۈش',
    vi: 'Sao chép',
    zh_tc: '複製',
    ru: 'Копировать',
    ko: '복사',
    bur: 'ကူးယူပါ',
    ben: 'কপি করুন',
    tr: 'Kopyala',
    km: 'ចម្លង',
    es: 'Copiar',
    ar: 'نسخ',
  },
  'common.paste': {
    zh: '粘贴',
    en: 'Paste',
    id: 'Pasta',
    kz: 'Қою',
    th: 'แปะ',
    ug: 'چاپلا',
    vi: 'Dán',
    zh_tc: '粘貼',
    ru: 'Вставить',
    ko: '붙여넣기',
    bur: 'ကပ်ပါ',
    ben: 'পেস্ট করুন',
    tr: 'Yapıştır',
    km: 'បិទភ្ជាប់',
    es: 'Pegar',
    ar: 'لصق',
  },
  'common.undo': {
    zh: '撤销',
    en: 'Cancel',
    id: 'Menarik kembali',
    kz: 'Кері ал',
    th: 'ถอน',
    ug: 'ئەمەلدىن قالدۇر',
    vi: 'Hủy thao tác',
    zh_tc: '撤銷',
    ru: 'Отменить',
    ko: '취소',
    bur: 'ပြန်ဖျက်ပါ',
    ben: 'পূর্বাবস্থায় ফেরান',
    tr: 'Geri al',
    km: 'មិនធ្វើវិញ',
    es: 'Deshacer',
    ar: 'تراجع',
  },
  'common.move': {
    zh: '移动',
    en: 'Move',
    id: 'bergerak',
    kz: 'Қозғалт',
    th: 'เคลื่อนไหว',
    ug: 'يۆتكەش',
    vi: 'Di chuyển',
    zh_tc: '移動',
    ru: 'Переместить',
    ko: '이동',
    bur: 'ရွှေ့ပါ',
    ben: 'সরান',
    tr: 'Taşı',
    km: 'ផ្លាស់ទី',
    es: 'Mover',
    ar: 'نقل',
  },
  'common.PTP': {
    zh: 'PTP',
    en: 'PTP',
    id: 'PTP',
    kz: 'PTP',
    th: 'PTP',
    ug: 'PTP',
    vi: 'PTP',
    zh_tc: 'PTP',
    ru: 'PTP',
    ko: 'PTP',
    bur: 'PTP',
    ben: 'PTP',
    tr: 'PTP',
    km: 'PTP',
    es: 'PTP',
    ar: 'PTP',
  },
  'common.dock56FDrill': {
    zh: '五六面钻',
    en: '5/6-Face Drilling Machine',
    id: 'Berlian lima sisi',
    kz: 'алтышақтық бұрғалау машина',
    th: 'เพชรห้าหกหก',
    ug: 'بەش/ئالتە يۈزلىك ماتور',
    vi: 'Máy khoan 5-6 mặt',
    zh_tc: '五六面鑽',
    ru: 'Машина для сверления пяти-шести сторон',
    ko: '대여섯 면 드릴',
    bur: 'ငါး/ခြောက်မျက်နှာဖောက်',
    ben: 'পাঁচ/ছয় দিকের ড্রিল মেশিন',
    tr: '5/6-Face Drilling Machine',
    km: 'ម៉ាស៊ីនខ្នាត 5/6 ផ្នែក',
    es: 'Taladro de cinco y seis caras',
    ar: 'مثقاب خماسي ستة جوانب',
  },
  'common.sideHoleDrill': {
    zh: '侧孔机',
    en: 'Side hole drilling machine',
    id: 'Mesin lubang samping',
    kz: 'жақшалық тесік бұрғалау машина',
    th: 'เครื่องหลุมด้านข้าง',
    ug: 'يان تېشىك ماتورى',
    vi: 'Máy khoan lỗ bên',
    zh_tc: '側孔機',
    ru: 'Машина для сверления боковых отверстий',
    ko: '측공기',
    bur: 'ဘေးပေါက်ဖောက်စက်',
    ben: 'পার্শ্ব গর্ত ড্রিল মেশিন',
    tr: 'Side hole drilling machine',
    km: 'ម៉ាស៊ីនរន្ធចិញ្ចឹម',
    es: 'Máquina perforadora lateral',
    ar: 'آلة ثقب جانبي',
  },
  'common.combination': {
    zh: '组合设备',
    en: 'Combination Machine',
    id: 'Peralatan kombinasi',
    kz: 'комбинациялық машина',
    th: 'อุปกรณ์ผสมผสาน',
    ug: 'بىرلەشتۈرۈلگەن قورال',
    vi: 'Thiết bị kết hợp',
    zh_tc: '組合設備',
    ru: 'Машина для комбинирования',
    ko: '콤보 장치',
    bur: 'ပေါင်းစပ်ကိရိယာ',
    ben: 'সমন্বিত যন্ত্রপাতি',
    tr: 'Combination Machine',
    km: 'ឧបករណ៍បន្សំ',
    es: 'Equipo combinado',
    ar: 'مدمج المعدات',
  },
  'common.integration': {
    zh: '一体机',
    en: 'Integration Machine',
    id: 'Mesin all-in-one',
    kz: 'бірліктегі машина',
    th: 'เครื่อง all-in-one',
    ug: 'بىرلەشتۈرۈلگەن',
    vi: 'Thiết bị tích hợp',
    zh_tc: '一體機',
    ru: 'Машина для интеграции',
    ko: '올인원',
    bur: 'ပေါင်းစပ်ထားသောစက်',
    ben: 'অল-ইন-ওয়ান মেশিন',
    tr: 'Integration Machine',
    km: 'ម៉ាស៊ីនរួមបញ្ចូល',
    es: 'Máquina todo en uno',
    ar: 'آلة الكل في واحد',
  },
  'common.standardPlank': {
    zh: '标准大板',
    en: 'Standard Board',
    id: 'Papan besar standar',
    kz: 'стандартты тақта',
    th: 'บอร์ดขนาดใหญ่มาตรฐาน',
    ug: 'ئۆلچەملىك چوڭ تاختا',
    vi: 'Ván tiêu chuẩn lớn',
    zh_tc: '標準大板',
    ru: 'Стандартная большая доска',
    ko: '표준 보드',
    bur: 'ပုံမှန်ကြီးသောပေါ်ဒ်',
    ben: 'আদর্শ বড় বোর্ড',
    tr: 'Standard Board',
    km: 'ផ្ទាំងធំស្តង់ដារ',
    es: 'Tablero grande estándar',
    ar: 'لوحة كبيرة قياسية',
  },
  'common.standardMaterial': {
    zh: '标准板材',
    en: 'Standard Material',
    id: 'Lembar Standar',
    kz: 'Стандартты материал',
    th: 'แผ่นมาตรฐาน',
    ug: 'ئۆلچەملىك تاختا ماتېرىالى',
    vi: 'Vật liệu tiêu chuẩn',
    zh_tc: '標準板材',
    ru: 'Стандартный материал',
    ko: '표준 판재',
    bur: 'ပုံမှန်ပေါ်ဒ်ပစ္စည်း',
    ben: 'আদর্শ উপকরণ',
    tr: 'Standard Material',
    km: 'សម្ភារៈស្តង់ដារ',
    es: 'Tablero estándar',
    ar: 'لوحة قياسية',
  },
  'common.standardMaterialTip': {
    zh: '注：完成大板信息调整后，在柜柜排版生产的用户需要重启柜柜客户端，以应用最新的变更！',
    en: 'Attention: After completing the adjustment of the large board information, users who use cabinet layout production need to restart the cabinet client to apply the latest changes!',
    id: 'CATATAN: Setelah menyelesaikan penyesuaian informasi papan besar, pengguna yang berada dalam produksi tata letak kabinet perlu memulai kembali klien kabinet untuk menerapkan perubahan terbaru!',
    kz: 'Ескерту: Үлкен тақта ақпаратын реттеуді аяқтағаннан кейін, шкафтарды орналастыру өндірісін қолданатын пайдаланушылар ең соңғы өзгерістерді қолдану үшін шкаф клиентін қайта іске қосуы керек!',
    th: 'หมายเหตุ: หลังจากเสร็จสิ้นการปรับข้อมูลบอร์ดขนาดใหญ่ผู้ใช้ที่อยู่ในการผลิตเค้าโครงของคณะรัฐมนตรีจำเป็นต้องรีสตาร์ทไคลเอนต์ตู้เพื่อใช้การเปลี่ยนแปลงล่าสุด!',
    ug: 'ئەسكەرتىش: چوڭ تاختا ئۇچۇرىنى تەڭشەپ بولغاندىن كېيىن، كابىنەت تەرتىپلىگۈچىلەر كابىنەت خېرىدار تەرەپنى قايتا قوزغىتىشى كېرەك!',
    vi: 'Lưu ý: Sau khi hoàn thành việc điều chỉnh thông tin tấm lớn, người dùng sản xuất bố trí tủ cần khởi động lại ứng dụng khách hàng tủ để áp dụng các thay đổi mới nhất!',
    zh_tc:
      '注：完成大板信息調整後，在櫃櫃排版生產的用戶需要重啟櫃櫃客戶端，以應用最新的變更！',
    ru: 'Примечание: После завершения корректировки информации о большой доске пользователи, использующие производство раскроя шкафов, должны перезапустить клиент шкафа для применения последних изменений!',
    ko: '참고: 대판 정보 조정을 완료한 후, 캐비닛 조판 생산의 사용자는 캐비닛 클라이언트를 다시 시작하여 최신 변경을 적용해야 합니다!',
    bur: 'မှတ်ချက်- ကြီးသောပေါ်ဒ်သတင်းအချက်အလက်ပြင်ဆင်ပြီးနောက် ကာဘင်နက်ပြင်ဆင်မှုထုတ်လုပ်မှုအသုံးပြုသောသုံးစွဲသူများသည် နောက်ဆုံးပြောင်းလဲမှုများကိုကျင့်သုံးရန် ကာဘင်နက်ဖောက်သည်ကိုပြန်ဖွင့်ရမည်!',
    ben: 'নোট: বড় বোর্ডের তথ্য সমন্বয় সম্পন্ন করার পর, ক্যাবিনেট লেআউট উৎপাদন ব্যবহারকারীদের সর্বশেষ পরিবর্তন প্রয়োগ করতে ক্যাবিনেট ক্লায়েন্ট পুনরায় চালু করতে হবে!',
    tr: 'Not: Büyük pano bilgilerini ayarlamayı tamamladıktan sonra, kabinet düzeni üretimi kullanan kullanıcılar, en son değişiklikleri uygulamak için kabinet istemcisini yeniden başlatmalıdır!',
    km: '',
    es: 'Nota: Después de completar el ajuste de la información del tablero grande, los usuarios en la producción del diseño del gabinete deben reiniciar el cliente del gabinete para aplicar los últimos cambios.',
    ar: 'ملاحظة: بعد الانتهاء من تعديل معلومات اللوحة الكبيرة، يحتاج المستخدمون في إنتاج تخطيط الخزانة إلى إعادة تشغيل عميل الخزانة لتطبيق أحدث التغييرات!',
  },
  'common.specialMaterial': {
    zh: '特殊板材',
    en: 'Special Material',
    id: 'Piring khusus',
    kz: 'Арнайы материал',
    th: 'จานพิเศษ',
    ug: 'ئالاھىدە تاختا ماتېرىالى',
    vi: 'Vật liệu đặc biệt',
    zh_tc: '特殊板材',
    ru: 'Специальный материал',
    ko: '특수 판재',
    bur: 'အထူးပေါ်ဒ်ပစ္စည်း',
    ben: 'বিশেষ উপকরণ',
    tr: 'Özel Malzeme',
    km: 'សម្ភារៈពិសេស',
    es: 'Tablero especial',
    ar: 'لوحة خاصة',
  },
  'common.specialPlank': {
    zh: '特殊大板',
    en: 'Special Board',
    id: 'Dewan Besar Khusus',
    kz: 'арнайы тақта',
    th: 'กระดานใหญ่พิเศษ',
    ug: 'ئالاھىدە چوڭ تاختا',
    vi: 'Ván đặc biệt lớn,',
    zh_tc: '特殊大板',
    ru: 'Специальная большая доска',
    ko: '특수 대판',
    bur: 'အထူးကြီးသောပေါ်ဒ်',
    ben: 'বিশেষ বড় বোর্ড',
    tr: 'Özel Tahta',
    km: 'បន្ទះពិសេស',
    es: 'Tablero especial grande',
    ar: 'لوحة كبيرة خاصة',
  },
  'common.singlePlank': {
    zh: '单面板',
    en: 'Single-Sided Board',
    id: 'Panel tunggal',
    kz: 'біржақты тақта',
    th: 'แผงเดี่ยว',
    ug: 'بىر تەرەپلىك تاختا',
    vi: 'Ván đơn miệng',
    zh_tc: '單面板',
    ru: 'Однопанельный',
    ko: '단일 패널',
    bur: 'တစ်ဖက်ပေါ်ဒ်',
    ben: 'একমুখী বোর্ড',
    tr: 'Tek Taraflı Levha',
    km: 'ផ្ទៃបាតមួយ',
    es: 'Panel único',
    ar: 'لوحة واحدة',
  },
  'common.previous': {
    zh: '上一个',
    en: 'Prev',
    id: 'Sebelumnya',
    kz: 'алдыңғысі',
    th: 'ก่อนหน้า',
    ug: 'ئالدىنقى',
    vi: 'Trước',
    zh_tc: '上一個',
    ru: 'предыдущий',
    ko: '이전',
    bur: 'ယခင်',
    ben: 'পূর্ববর্তী',
    tr: 'Önceki',
    km: 'មុន',
    es: 'Anterior',
    ar: 'السابق',
  },
  'common.plankInfo': {
    zh: '大板详情',
    en: 'Large board details',
    id: 'Detail Papan Besar',
    kz: 'Үлкен тақта ақпараты',
    th: 'รายละเอียดบอร์ดใหญ่',
    ug: 'چوڭ تاختا تەپسىلاتى',
    vi: 'Chi tiết tấm lớn',
    zh_tc: '大板詳情',
    ru: 'Большая доска Подробнее',
    ko: '보드 상세 정보',
    bur: 'ကြီးသောပေါ်ဒ်အသေးစိတ်',
    ben: 'বড় বোর্ডের বিস্তারিত',
    tr: 'Büyük Tahta Detayları',
    km: 'ព័ត៌មានលម្អិតឥតធំ',
    es: 'Detalles del tablero grande',
    ar: 'تفاصيل لوحة كبيرة',
  },
  'common.moreResult': {
    zh: '更多排版方案',
    en: 'More layout solutions',
    id: 'Lebih banyak solusi pengaturan huruf',
    kz: 'Тексеру шешімінің артық мөлшері',
    th: 'โซลูชันการเรียงพิมพ์เพิ่มเติม',
    ug: 'تېخىمۇ كۆپ تەرتىپلەش پىلانى',
    vi: 'Nhiều giải pháp sắp xếp',
    zh_tc: '更多排版方案',
    ru: 'Больше программ',
    ko: '더 많은 레이아웃 시나리오',
    bur: 'ပိုမိုသောပြင်ဆင်မှုပြားများ',
    ben: 'আরও লেআউট সমাধান',
    tr: 'Daha Fazla Yerleşim Çözümü',
    km: 'ដំណោះស្រាយលេអូតបន្ថែម',
    es: 'Más planos de distribución',
    ar: 'المزيد من خطط التخطيط',
  },
  'common.moreResultTip': {
    zh: '大板中有贴边加工的槽,大板将不会参与重新排版',
    en: 'There are slots for edge processing on the large board, and the large board will not participate in the re-layout.',
    id: 'Ada alur untuk menggiling di pelat besar, dan pelat besar tidak akan berpartisipasi dalam tata letak jenis ulang.',
    kz: 'Үлкен тақтада қабырғадан өңдеу үшін үзілістер бар, және үлкен тақта туралы қайта құрылымдауға қатыспайды.',
    th: 'มีร่องสำหรับการบดในจานขนาดใหญ่และแผ่นขนาดใหญ่จะไม่เข้าร่วมในรูปแบบประเภทใหม่',
    ug: 'چوڭ تاختادا چىگارلاش ئوچۇقى بار بولسا، چوڭ تاختا قايتا تەرتىپلەشكە قاتناشمايدۇ',
    vi: 'Có các lỗ để cắt cạnh trên tấm lớn, và tấm lớn sẽ không tham gia lại sắp xếp.',
    zh_tc: '大板中有貼邊加工的槽,大板將不會參與重新排版',
    ru: 'Большая доска с наклейкой в канавке, большая доска не будет участвовать в переформатировании',
    ko: '판자에 가장자리를 붙여 가공한 슬롯이 있어, 판자는 재조판에 참여하지 않을 것이다',
    bur: 'ကြီးသောပေါ်ဒ်တွင် ကြိုးပြင်ဆင်မှုရှိသောကြောင့် ကြီးသောပေါ်ဒ်ကိုပြန်ပြင်ဆင်မည်မဟုတ်',
    ben: 'বড় বোর্ডে প্রান্ত প্রক্রিয়াকরণের স্লট আছে, তাই বড় বোর্ড পুনরায় লেআউটে অংশগ্রহণ করবে না',
    tr: 'Büyük tahtada kenar işlemesi için yarıklar vardır; büyük tahta yeniden yerleştirmeye katılmayacaktır.',
    km: 'មានរន្ទះសម្រាប់ដំណើរការគែមលើបន្ទះធំ បន្ទះធំហើយនឹងមិនចូលរួមក្នុងការរៀបចំឡើងវិញទេ',
    es: 'En el tablero grande hay ranuras para el procesamiento de ribetes. El tablero grande no participará en el rediseño',
    ar: 'توجد أخاديد لمعالجة اللحامات في اللوحة الكبيرة. لن تشارك اللوحة الكبيرة في إعادة التخطيط',
  },
  'common.ok': {
    zh: '确定',
    en: 'Confirm',
    id: 'Tentu',
    kz: 'Растау',
    th: 'แน่นอน',
    ug: 'جەزملەشتۈرۈڭ',
    vi: 'Xác nhận',
    zh_tc: '確定',
    ru: 'определить',
    ko: '확정',
    bur: 'အတည်ပြုပါ',
    ben: 'নিশ্চিত করুন',
    tr: 'Onayla',
    km: 'បញ្ជាក់',
    es: 'OK',
    ar: 'موافق',
  },
  'common.dispersePaibanTip': {
    zh: '检测到部分大板无法进行分散排版，您可以手动调整或切换排版方案，避免造成跑板！',
    en: 'Some large boards cannot be distributed for layout, you can manually adjust or switch the layout plan to avoid running the board!',
    id: 'Terdeteksi bahwa beberapa papan besar tidak dapat disebarkan dalam tata letak. Anda dapat secara manual menyesuaikan atau mengganti rencana tata letak untuk menghindari menjalankan papan!',
    kz: 'Үлкен тақталардың бір бөлігі құрылымда бөлінбейді, құрылымды қолмен түзету немесе өзгерту мүмкіндігін пайдалануға болады, тақталарды қалайтудан қорғау!',
    th: 'ตรวจพบว่าบอร์ดขนาดใหญ่บางตัวไม่สามารถแยกย้ายกันไปได้ในรูปแบบ คุณสามารถปรับหรือเปลี่ยนแผนเลย์เอาต์ด้วยตนเองเพื่อหลีกเลี่ยงการเรียกใช้บอร์ด!',
    ug: 'بەزى چوڭ تاختىلارنىڭ تارقىتىپ تەرتىپلەشكە بولمايدىغانلىقىنى بايقىدىڭىز، قولدا تەڭشەش ياكى تەرتىپلەش پىلانىنى ئالماشتۇرۇپ، قاچىرىشتىن ساقلىنىڭ!',
    vi: 'Một số tấm lớn không thể được phân bố cho sắp xếp, bạn có thể điều chỉnh thủ công hoặc chuyển đổi kế hoạch sắp xếp để tránh chạy tấm lớn!',
    zh_tc:
      '檢測到部分大板無法進行分散排版，您可以手動調整或切換排版方案，避免造成跑板！',
    ru: 'Обнаружив, что некоторые большие платы не могут быть децентрализованы, вы можете настроить или переключить схему набора вручную, чтобы избежать создания беговой платы!',
    ko: '일부 대판이 분산 조판을 할 수 없다는 것을 감지했습니다. 당신은 수동으로 조판 방안을 조정하거나 전환할 수 있습니다. 달리기 판을 만들지 않도록 할 수 있습니다!',
    bur: 'အချို့ကြီးသောပေါ်ဒ်များကိုဖြန့်ကြက်ပြင်ဆင်၍မရနိုင်ပါ၊ ဖြစ်နိုင်ပါကဆက်တင်ကိုပြင်ဆင်ပါ!',
    ben: 'কিছু বড় বোর্ড বিতরণ করে লেআউট করা সম্ভব নয়, আপনি ম্যানুয়ালি সামঞ্জস্য করতে বা লেআউট পরিকল্পনা পরিবর্তন করতে পারেন!',
    tr: 'Bazı büyük tahtalar dağıtılarak yerleştirilemiyor; manuel ayarlama yapabilir veya yerleşim planını değiştirebilirsiniz, panonun kaymasını önleyin!',
    km: 'បានរកឃើញបន្ទះធំប 일부មិនអាចរៀបចរបាន សូមកែតម្រូវដោយដៃ ឬប្ដូរផែនការរៀបចំ ដើម្បីទប់ស្កាត់បញ្ហា!',
    es: 'Se detecta que algunos tableros grandes no se pueden distribuir ni componer. ¡Puedes ajustar o cambiar manualmente el plano de diseño para evitar estribos!',
    ar: 'تم اكتشاف أن بعض اللوحات الكبيرة لا يمكن توزيعها وتنضيدها. يمكنك ضبط خطة التخطيط أو تبديلها يدويًا لتجنب تشغيل اللوحات!',
  },
  'common.next': {
    zh: '下一个',
    en: 'Next',
    id: 'Berikutnya',
    kz: 'келесісі',
    th: 'ต่อไป',
    ug: 'كېيىنكى',
    vi: 'Tiếp',
    zh_tc: '下一個',
    ru: 'следующий',
    ko: '다음',
    bur: 'နောက်တစ်ခု',
    ben: 'পরবর্তী',
    tr: 'Sonraki',
    km: 'បន្ទាប់',
    es: 'Siguiente',
    ar: 'التالي',
  },
  'common.rate': {
    zh: '利用率',
    en: 'Utilization',
    id: 'Tingkat pemanfaatan',
    kz: 'пайдалану көрсеткіші',
    th: 'อัตราการใช้ประโยชน์',
    ug: 'پايدىلىنىش نىسبىتى',
    vi: 'Tỷ lệ sử dụng',
    zh_tc: '利用率',
    ru: 'Коэффициент использования',
    ko: '활용도',
    bur: 'အသုံးပြုမှုနှုန်း',
    ben: 'ব্যবহারের হার',
    tr: 'Kullanım Oranı',
    km: 'អត្រាការប្រើប្រាស់',
    es: 'Tasa de utilización',
    ar: 'معدل الاستخدام',
  },
  'common.paibanBatch': {
    zh: '排版批次',
    en: 'Layout batch',
    id: 'Batch pengukur huruf',
    kz: 'баспа топтығы',
    th: 'ชุดเรียงพิมพ์',
    ug: 'تەرتىپلەش پارتىيىسى',
    vi: 'đợt đặt chữ',
    zh_tc: '排版批次',
    ru: 'Типографская партия',
    ko: '조판 차수',
    bur: 'ပြင်ဆင်မှုအစု',
    ben: 'লেআউট ব্যাচ',
    tr: 'Yerleşim Partisi',
    km: 'ចុងក្រុមឡេអូត',
    es: 'Lote de composición tipográfica',
    ar: 'دفعة التنضيد',
  },
  'common.return': {
    zh: '返回',
    en: 'Return',
    id: 'kembali',
    kz: 'қайта',
    th: 'กลับ',
    ug: 'قايتىش',
    vi: 'Quay lại',
    zh_tc: '返回',
    ru: 'возвращаться',
    ko: '돌아가다',
    bur: 'ပြန်သွားပါ',
    ben: 'ফিরে যান',
    tr: 'Geri',
    km: 'ត្រលប់',
    es: 'Devolver',
    ar: 'إرجاع',
  },
  'common.FGNo': {
    zh: '合同号',
    en: 'Contract Number',
    id: 'Nomor kontrak',
    kz: 'келісім нөмірі',
    th: 'หมายเลขสัญญา',
    ug: 'تۇزۈش نومۇرى',
    vi: 'Mã hợp đồng',
    zh_tc: '合同號',
    ru: 'Номер контракта',
    ko: '계약 번호',
    bur: 'စာချုပ်နံပါတ်',
    ben: 'চুক্তি নম্বর',
    tr: 'Sözleşme Numarası',
    km: 'លេខកិច្ចសន្យា',
    es: 'Número de contrato',
    ar: 'رقم العقد',
  },
  'common.refresh': {
    zh: '刷新',
    en: 'Refresh',
    id: 'menyegarkan',
    kz: 'жаңарту',
    th: 'รีเฟรช',
    ug: 'يېڭىلاش',
    vi: 'Làm mới',
    zh_tc: '刷新',
    ru: 'обновить',
    ko: '새로 고침',
    bur: 'ပြန်တင်ပါ',
    ben: 'রিফ্রেশ করুন',
    tr: 'Yenile',
    km: 'ធ្វើឱ្យទាន់សម័យ',
    es: 'Actualizar',
    ar: 'تحديث',
  },
  'common.inde': {
    zh: '序号',
    en: 'Serial number',
    id: 'Nomor seri',
    kz: 'нөмірі',
    th: 'หมายเลขซีเรียล',
    ug: 'تەرتىپ نومۇرى',
    vi: 'Số thứ tự',
    zh_tc: '序號',
    ru: 'номер',
    ko: '번호',
    bur: 'အမျိုးအစားနံပါတ်',
    ben: 'ক্রমিক নম্বর',
    tr: 'Sıra Numarası',
    km: 'លេខស៊េរី',
    es: 'Número de serie',
    ar: 'الرقم التسلسلي',
  },
  'common.productionLine': {
    zh: '生产线',
    en: 'Line',
    id: 'Jalur produksi',
    kz: 'производственная линия',
    th: 'สายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Dây chuyền sản xuất',
    zh_tc: '生產線',
    ru: 'Производственная линия',
    ko: '생산 라인',
    bur: 'ထုတ်လုပ်ရေးလိုင်း',
    ben: 'উৎপাদন লাইন',
    tr: 'Üretim Hattı',
    km: 'ខ្សែផលិត',
    es: 'Línea de producción',
    ar: 'خط الإنتاج',
  },
  'common.operation': {
    zh: '操作',
    en: 'Operation',
    id: 'beroperasi',
    kz: 'операция',
    th: 'ดำเนินงาน',
    ug: 'مەشغۇلات',
    vi: 'Hoạt động',
    zh_tc: '操作',
    ru: 'операция',
    ko: '조작',
    bur: 'လုပ်ဆောင်ချက်',
    ben: 'অপারেশন',
    tr: 'İşlem',
    km: 'ប្រតិបត្តិការ',
    es: 'Operación',
    ar: 'التشغيل',
  },
  'common.colorPlaceHolder': {
    zh: '按回车自动创建色卡',
    en: 'Press enter to create a color swatch',
    id: 'Tekan Enter untuk secara otomatis membuat kartu warna',
    kz: 'Ентерді басып, автоматты түрде түстік картасын құру',
    th: 'กด Enter เพื่อสร้างการ์ดสีโดยอัตโนมัติ',
    ug: 'كىرگۈزۈپ ئەنگىرەتسىڭىز، رەڭ كارتىسى ئاپتوماتىك ھاسىل بولىدۇ',
    vi: 'Nhấn Enter để tự động tạo màu',
    zh_tc: '按回車自動創建色卡',
    ru: 'Нажмите обратно, чтобы автоматически создать цветовую карту',
    ko: 'Enter를 눌러 색상 카드 자동 생성',
    bur: 'Enter နှိပ်၍ အရောင်ကတ်အလိုအလျောက်ဖန်တီးပါ',
    ben: 'রঙের কার্ড তৈরি করতে Enter চাপুন',
    tr: 'Renk kartı oluşturmak için Enter tuşuna basın',
    km: 'ចុច Enter ដើម្បីបង្កើតកាតពណ៌',
    es: 'Presione Enter para crear automáticamente una tarjeta de color',
    ar: 'اضغط على Enter لإنشاء بطاقة ألوان تلقائيًا',
  },
  'common.saveAndContinue': {
    zh: '保存并继续',
    en: 'Save and Continue',
    id: 'Simpan dan lanjutkan',
    kz: 'сақтау және жалғастыру',
    th: 'บันทึกและดำเนินการต่อ',
    ug: 'ساقلاپ داۋاملاشتۇرۇڭ',
    vi: 'Lưu và tiếp tục',
    zh_tc: '保存並繼續',
    ru: 'Сохранить и продолжить',
    ko: '저장 및 계속',
    bur: 'သိမ်းဆည်းပြီး ဆက်လက်လုပ်ဆောင်ပါ',
    ben: 'সংরক্ষণ করুন এবং অব্যাহত রাখুন',
    tr: 'Kaydet ve Devam Et',
    km: 'រក្សាទុក និងបន្ត',
    es: 'Guardar y continuar',
    ar: 'حفظ ومتابعة',
  },
  'common.reset': {
    zh: '重置',
    en: 'Reset',
    id: 'Mengatur ulang',
    kz: 'қайта орнату',
    th: 'รีเซ็ต',
    ug: 'قايتا تەڭشەش',
    vi: 'Đặt lại',
    zh_tc: '重置',
    ru: 'Сброс',
    ko: '초기화',
    bur: 'ပြန်သတ်မှတ်ပါ',
    ben: 'রিসেট করুন',
    tr: 'Sıfırla',
    km: 'កំណត់ឡើងវិញ',
    es: 'Restablecer',
    ar: 'إعادة تعيين',
  },
  'common.check': {
    zh: '查询',
    en: 'Query',
    id: 'Pertanyaan',
    kz: 'тексеру',
    th: 'สอบถาม',
    ug: 'سىناش',
    vi: 'Tra cứu',
    zh_tc: '查詢',
    ru: 'запрос',
    ko: '조회',
    bur: 'မေးမြန်းပါ',
    ben: 'অনুসন্ধান করুন',
    tr: 'Sorgula',
    km: 'សំណើ',
    es: 'Consulta',
    ar: 'استعلام',
  },
  'common.inputPlaceholder': {
    zh: '请输入',
    en: 'Please enter',
    id: 'Harap masuk',
    kz: 'кіріңіз',
    th: 'โปรดป้อน',
    ug: 'كىرگۈزۈڭ',
    vi: 'Vui lòng nhập',
    zh_tc: '請輸入',
    ru: 'Пожалуйста, введите',
    ko: '입력하십시오.',
    bur: 'ကျေးဇူးပြု၍ ထည့်ပါ',
    ben: 'দয়া করে লিখুন',
    tr: 'Lütfen girin',
    km: 'សូមបញ្ជូល',
    es: 'Por favor ingrese',
    ar: 'يرجى الإدخال',
  },
  'common.filter': {
    zh: '筛选',
    en: 'Filter',
    id: 'menyaring',
    kz: 'сіру',
    th: 'กรอง',
    ug: 'سۈزگۈچ',
    vi: 'Lọc',
    zh_tc: '篩選',
    ru: 'отбор',
    ko: '선별',
    bur: 'စစ်ထုတ်ပါ',
    ben: 'ফিল্টার করুন',
    tr: 'Filtre',
    km: 'លៃតម្រូវ',
    es: 'Filtrar',
    ar: 'تصفية',
  },
  'common.all': {
    zh: '全部',
    en: 'All',
    id: 'semua',
    kz: 'барлығы',
    th: 'ทั้งหมด',
    ug: 'ھەممىسى',
    vi: 'Tất cả',
    zh_tc: '全部',
    ru: 'все',
    ko: '전부',
    bur: 'အားလုံး',
    ben: 'সব',
    tr: 'Tümü',
    km: 'ទាំងអស់',
    es: 'Todo',
    ar: 'الكل',
  },
  'common.exportPDF': {
    zh: '导出PDF',
    en: 'Export pdf',
    id: 'Ekspor PDF',
    kz: 'PDF экспорттау',
    th: 'PDF ส่งออก',
    ug: 'PDF چىقىرىش',
    vi: 'Xuất PDF',
    zh_tc: '導出PDF',
    ru: 'Экспорт PDF',
    ko: 'PDF 내보내기',
    bur: 'PDF ထုတ်ပါ',
    ben: 'PDF রপ্তানি করুন',
    tr: 'PDF Dışa Aktar',
    km: 'នាំចេញ PDF',
    es: 'Exportar PDF',
    ar: 'تصدير PDF',
  },
  'common.exportPic': {
    zh: '导出图片',
    en: 'Export image',
    id: 'Ekspor gambar',
    kz: 'сурет экспорттау',
    th: 'รูปภาพส่งออก',
    ug: 'رەسىم چىقىرىش',
    vi: 'Xuất hình ảnh',
    zh_tc: '導出圖片',
    ru: 'Экспорт изображений',
    ko: '그림 내보내기',
    bur: 'ဓာတ်ပုံထုတ်ပါ',
    ben: 'ছবি রপ্তানি করুন',
    tr: 'Resmi Dışa Aktar',
    km: 'នាំចេញរូបភាព',
    es: 'Exportar imagen',
    ar: 'تصدير الصورة',
  },
  'common.add': {
    zh: '添加',
    en: 'Add',
    id: 'Tambahkan ke',
    kz: 'қосу',
    th: 'เพิ่ม',
    ug: 'قوشۇش',
    vi: 'Thêm',
    zh_tc: '添加',
    ru: 'добавить',
    ko: '추가',
    bur: 'ထည့်ပါ',
    ben: 'যোগ করুন',
    tr: 'Ekle',
    km: 'បន្ថែម',
    es: 'Agregar',
    ar: 'إضافة',
  },
  'common.edit': {
    zh: '编辑',
    en: 'Edit',
    id: 'edit',
    kz: 'өзгерту',
    th: 'แก้ไข',
    ug: 'تەھرىرلەش',
    vi: 'Sửa',
    zh_tc: '編輯',
    ru: 'редактировать',
    ko: '편집',
    bur: 'တည်းဖြတ်ပါ',
    ben: 'সম্পাদনা করুন',
    tr: 'Düzenle',
    km: 'កែសម្រួល',
    es: 'Editar',
    ar: 'تعديل',
  },
  'common.delete': {
    zh: '删除',
    en: 'Delete',
    id: 'menghapus',
    kz: 'жою',
    th: 'ลบ',
    ug: 'ئۆچۈرۈش',
    vi: 'Xóa',
    zh_tc: '刪除',
    ru: 'удалить',
    ko: '삭제',
    bur: 'ဖျက်ပါ',
    ben: 'মুছুন',
    tr: 'Sil',
    km: 'លុប',
    es: 'Eliminar',
    ar: 'حذف',
  },
  'common.restore': {
    zh: '还原',
    en: 'Restore',
    id: 'mengembalikan',
    kz: 'қалпына келтіру',
    th: 'กู้คืน',
    ug: 'قالدۇق',
    vi: 'Khôi phục',
    zh_tc: '還原',
    ru: 'восстановление',
    ko: '복구',
    bur: 'ပြန်လည်ပါ',
    ben: 'পুনরুদ্ধার করুন',
    tr: 'Geri Al',
    km: 'បង្រៀនម្តងទី២',
    es: 'Restaurar',
    ar: 'استرجاع',
  },
  'common.save': {
    zh: '保存',
    en: 'Save',
    id: 'menyimpan',
    kz: 'сақтау',
    th: 'บันทึก',
    ug: 'ساقلاش',
    vi: 'Lưu',
    zh_tc: '保存',
    ru: 'сохранить',
    ko: '저장',
    bur: 'သိမ်းဆည်းပါ',
    ben: 'সংরক্ষণ করুন',
    tr: 'Kaydet',
    km: 'រក្សាទុក',
    es: 'Guardar',
    ar: 'حفظ',
  },
  'common.saveSetting': {
    zh: '保存设置',
    en: 'Save settings',
    id: 'Simpan Pengaturan',
    kz: 'параметрлерді сақтау',
    th: 'บันทึกการตั้งค่า',
    ug: 'تەڭشەكنى ساقلاش',
    vi: 'Lưu cài đặt',
    zh_tc: '保存設置',
    ru: 'сохранить настройки',
    ko: '설정 저장',
    bur: 'ဆက်တင်သိမ်းဆည်းပါ',
    ben: 'সেটিংস সংরক্ষণ করুন',
    tr: 'Ayarları kaydet',
    km: 'រក្សាទុកការកំណត់',
    es: 'Guarde la configuración',
    ar: 'حفظ الإعدادات',
  },
  'common.isHeightGloss': {
    zh: '请选择是否是高光板',
    en: 'Please select if it is a high-gloss board',
    id: 'Pilih apakah itu papan highlight',
    kz: 'Жоғары глянстық тақта екенін таңдаңыз',
    th: 'โปรดเลือกว่าเป็นบอร์ดไฮไลต์หรือไม่',
    ug: 'يۇقىرى يالتىراق تاختا ئەمەسلىكىنى تاللاڭ',
    vi: 'Vui lòng chọn ván có màu sáng hay không',
    zh_tc: '請選擇是否是高光板',
    ru: 'Выберите высотный',
    ko: '하이라이트인지 여부를 선택하십시오.',
    bur: 'မြင့်မားသောဂလော့ပေါ်ဒ်ဖြစ်မဖြစ်ရွေးချယ်ပါ',
    ben: 'হাই গ্লস বোর্ড কিনা নির্বাচন করুন',
    tr: 'Yüksek parlak levha olup olmadığını seçin',
    km: 'សូមជ្រើសរើសថាជាបន្ទះពន្លឺខ្ពស់ឬអត់',
    es: 'Seleccione si es una placa resaltada',
    ar: 'يرجى تحديد ما إذا كانت لوحة تمييز',
  },
  'common.noSync': {
    zh: '不同步',
    en: 'Not synced',
    id: 'Absen',
    kz: 'синхронization іштемеу',
    th: 'ไม่มา',
    ug: 'ماسلىشمايدۇ',
    vi: 'Không đồng bộ',
    zh_tc: '不同步',
    ru: 'Несинхронизация',
    ko: '동기화 중단',
    bur: 'စင်ခ်မဆောင်ရွက်ဘဲ',
    ben: 'সিঙ্ক নয়',
    tr: 'Senkronize değil',
    km: 'មិនបានសមកាលកម្ម',
    es: 'No sincronizado',
    ar: 'غير متزامنة',
  },
  'common.sync': {
    zh: '同步',
    en: 'Synced',
    id: 'sinkronis',
    kz: 'синхронизация',
    th: 'ซิงโครนัส',
    ug: 'ماسلىشىدۇ',
    vi: 'Đồng bộ',
    zh_tc: '同步',
    ru: 'синхронизация',
    ko: '동기화',
    bur: 'စင်ခ်ဆောင်ရွက်သည်',
    ben: 'সিঙ্ক করুন',
    tr: 'Senkronize',
    km: 'សមកាលកម្ម',
    es: 'Sincronizado',
    ar: 'متزامنة',
  },
  'common.formatSuccess': {
    zh: '{type}成功',
    en: '{type} Successful',
    id: '{type} sukses',
    kz: '{type} тастықталды',
    th: '{type} ความสำเร็จ',
    ug: '{type} مۇۋەپپەقىيەتلىك بولدى',
    vi: '{type} thành công',
    zh_tc: '{type}成功',
    ru: '{type} успешно',
    ko: '{type} 성공',
    bur: '{type} အောင်မြင်',
    ben: '{type} সফল',
    tr: '{type} başarılı',
    km: '{type} ជោគជ័យ',
    es: '{type} Exitoso',
    ar: '{type} ناجح',
  },
  'common.dataLoading': {
    zh: '数据正在加载中......',
    en: 'Data is loading...',
    id: 'Data sedang memuat ...',
    kz: 'Деректер жүктеледі......',
    th: 'ข้อมูลกำลังโหลด ...',
    ug: 'سانلىق مەلۇمات يۈكلىنىۋاتىدۇ......',
    vi: 'Dữ liệu đang tải...',
    zh_tc: '數據正在加載中......',
    ru: 'Данные загружаются. ......',
    ko: '데이터가 로드되고 있습니다......',
    bur: 'ဒေတာတင်နေသည်......',
    ben: 'ডেটা লোড হচ্ছে......',
    tr: 'Veriler yükleniyor...',
    km: 'ទិន្នន័យកំពុងផ្ទុក...',
    es: 'Los datos se están cargando...',
    ar: 'يتم تحميل البيانات...',
  },
  'common.warmTip': {
    zh: '温馨提示',
    en: 'Warm reminder',
    id: 'Tips yang baik',
    kz: 'қызметті кеңес',
    th: 'เคล็ดลับชนิด',
    ug: 'ئەسكەرتىش',
    vi: 'Gợi ý ấm áp',
    zh_tc: '溫馨提示',
    ru: 'Доброе напоминание',
    ko: '친절한 안내',
    bur: 'ကြင်နာသောအကြောင်းကြားချက်',
    ben: 'বন্ধুত্বপূর্ণ অনুস্মারক',
    tr: 'İyi hatırlatma',
    km: 'ការរំលឹក',
    es: 'Recordatorio',
    ar: 'تذكير دافئ',
  },
  'common.importantTip': {
    zh: '重要提示',
    en: 'Important Reminder',
    id: 'Penting',
    kz: 'Маңызды қызметті кеңес',
    th: 'เคล็ดลับที่สำคัญ',
    ug: 'مۇھىم ئەسكەرتىش',
    vi: 'Gợi ý quan trọng',
    zh_tc: '重要提示',
    ru: 'Важные советы',
    ko: '중요한 알림',
    bur: 'အရေးကြီးသောအကြောင်းကြားချက်',
    ben: 'গুরুত্বপূর্ণ অনুস্মারক',
    tr: 'Önemli hatırlatma',
    km: 'ការរំលឹកសំខាន់',
    es: 'Consejo importante',
    ar: 'نصيحة مهمة',
  },
  'common.wellcome': {
    zh: '欢迎使用云排版',
    en: 'Welcome to Cloud Typesetting',
    id: 'Selamat Datang di Tata Letak Cloud',
    kz: 'Қолдануға қош келдіңіз! Кейіптік жобалау',
    th: 'ยินดีต้อนรับสู่ Cloud Layout',
    ug: 'بۇلۇت تەرتىپلىگۈچىگە خۇش ئەمدىڭىز!',
    vi: 'Chào mừng sử dụng Cloud Layout',
    zh_tc: '歡迎使用雲排版',
    ru: 'Добро пожаловать в облако',
    ko: '클라우드 레이아웃 시작',
    bur: 'Cloud Layout သို့ကြိုဆိုပါသည်',
    ben: 'ক্লাউড টাইপসেটিং-এ স্বাগতম',
    tr: 'Bulut dizilimine hoş geldiniz',
    km: 'សូមស្វាគមន៍មកកាន់ការរៀបចំក្នុងពពក',
    es: 'Bienvenido a la composición tipográfica en la nube',
    ar: 'مرحبًا بك في التنضيد السحابي',
  },
  'common.timeOut': {
    zh: '排版超时, 是否重新排版',
    en: 'Typesetting timed out, do you want to typeset again?',
    id: 'Mengatur waktu pengaturan waktu, apakah akan mengetik ulang',
    kz: 'Жобалау уақыты асып кетті, жаңадан жобалау керек пе?',
    th: 'หมดหมดการหมดเวลาไม่ว่าจะพิมพ์ซ้ำ',
    ug: 'تەرتىپلەش ۋاقتىدىن ئاشتى، قايتا تەرتىپلەمسىز؟',
    vi: 'Layout đã hết hạn, có muốn thực hiện lại không?',
    zh_tc: '排版超時, 是否重新排版',
    ru: 'Время ожидания типографии, переформатирование',
    ko: '조판 시간 초과, 재조판 여부',
    bur: 'ပြင်ဆင်မှုကာလကုန်ဆုံးပြီ၊ ပြန်ပြင်ဆင်မည်လား',
    ben: 'লেআউট টাইমআউট হয়েছে, পুনরায় লেআউট করবেন কি?',
    tr: 'Dizilim zaman aşımına uğradı, yeniden dizmek ister misiniz?',
    km: 'រៀបចំហួសម៉ោង តើចង់រៀបចំឡើងវិញទេ?',
    es: 'Tiempo de espera de composición tipográfica, si se debe volver a escribir la composición tipográfica',
    ar: 'انتهت مهلة التنضيد، ما إذا كان سيتم إعادة كتابة التنضيد',
  },
  'common.notSawKnifeTip': {
    zh: '注意：锯切雕刻机未设置“横切锯片”导致无法排版，请前往添加！',
    en: 'Warning: The sawing engraving machine does not have a "Cross-cut Saw Blade" set up, which prevents nesting. Please proceed to add it!',
    id: 'Perhatian: Mesin ukir pemotong gergaji belum mengatur Pisau Gergaji Potong Melintang, sehingga tidak dapat melakukan nesting. Silakan tambahkan!',
    kz: 'Назар аударыңыз: Ара кескіш ою машинасында Көлденең кескіш орнатылмағандықтан, орналастыру жұмысын орындау мүмкін емес. Оны қосыңыз!',
    th: 'หมายเหตุ: เครื่องตัดเลื่อยยังไม่ได้ตั้งค่า ใบเลื่อยตัดขวาง ส่งผลให้ไม่สามารถจัดเรียงแผนการตัดได้ กรุณาไปที่หน้าเพิ่มการตั้งค่า!',
    ug: 'دىققەت: ئەگەر يۆنىلىشى ئويما ماشىنىسىدا "كەڭلىكچە ئەگەر يۆنىلىشى" بەلگىلەنمىگەنلىكتىن، پەسلى قىلىش لايىھىسى تۈزۈلمەيدۇ. ئۆزىڭىز قوشۇپ قويۇڭ!',
    vi: 'Chú ý: Máy khắc cắt cưa chưa thiết lập Lưỡi cưa cắt ngang dẫn đến không thể bố trí sắp xếp. Vui lòng thêm vào!',
    zh_tc: '注意：鋸切雕刻機未設定橫切鋸片導致無法排版，請前往新增！',
    ru: 'Примечание: Пиловая гравировальная машина не устанавливает « поперечную пилу», что приводит к невозможности типографии, пожалуйста, перейдите к добавлению!',
    ko: '참고: 톱질 조각기에서 "가로 자르기 톱날" 을 설정하지 않아 조판을 할 수 없습니다. 추가하러 가십시오!',
    bur: 'သတိပြုပါ- ဖြတ်ညွတ်စက်တွင် "အလျားဖြတ်ဘလေဒ်" မသတ်မှတ်ထားသောကြောင့် ပြင်ဆင်၍မရ၊ ထည့်သွင်းပါ!',
    ben: 'সতর্কতা: করাত কাটার মেশিনে "ক্রস-কাট ব্লেড" সেট করা হয়নি যার ফলে লেআউট করা যাচ্ছে না, যোগ করতে যান!',
    tr: 'Dikkat: Testere kesim oyma makinesinde "Enine kesim testere bıçağı" ayarlı olmadığı için yerleştirme yapılamıyor. Lütfen ekleyin!',
    km: 'សូមចំណាំ៖ ម៉ាស៊ីនចាក់រូបកាត់ដោយរណាមិនបានកំណត់ «ក្បាលរណាកាត់ទទឹង» ទើបមិនអាចរៀបចំបាន សូមទៅបន្ថែម!',
    es: 'Nota: La máquina de sierra y grabado no tiene una "Hoja de sierra transversal" configurada, por lo que no se puede realizar la composición tipográfica. ¡Por favor ve y agrégalo!',
    ar: 'ملاحظة: لا تحتوي آلة النشر والنقش على تم إعداد "شفرة المنشار المتقاطع"، لذا لا يمكن إجراء التنضيد. يرجى الذهاب وإضافته!',
  },
  'common.doorFrameKnifeRadiusErr': {
    zh: '您已开启“锯切雕刻机-门套切割”功能，下料刀半径大于了锯片厚度，无法进行排版！',
    en: 'You have enabled the "Saw Cutting Engraving Machine - Door Frame Cutting" feature. The cutting tool radius is greater than the saw blade thickness, so nesting cannot be performed!',
    id: 'Anda telah mengaktifkan fitur "Mesin Ukir Pemotong Gergaji - Pemotongan Bingkai Pintu". Radius pisau pemotong lebih besar dari ketebalan pisau gergaji, sehingga nesting tidak dapat dilakukan!',
    kz: 'Сіз "Ара кескіш ою машинасы - Есік жақтауы кесу" функциясын қостыңыз. Кесу пышағы радиусы ара кесу қалыңдығынан үлкен, орналастыру орындалмайды!',
    th: 'คุณได้เปิดใช้งานฟังก์ชัน "เครื่องแกะสลักตัดเลื่อย-ตัดวงกบประตู" รัศมีมีดตัดงานใหญ่กว่าความหนาใบเลื่อย จึงไม่สามารถจัดเรียงแผนการตัดได้!',
    ug: 'سىز «ئارا ئويۇش ماشىنىسى-ئىشik قاپلىما كېسىش» ئىقتىدارىنى قوزغىتىپ، تۆۋەن بىچىش پىچىقى رادىئۇسى ئارا پىچاق قېلىنلىقىدىن چوڭ، پەسلى قىلىش ئەمەلگە ئاشمىدى!',
    vi: 'Bạn đã bật tính năng "Máy khắc cắt cưa - Cắt khung cửa". Bán kính dao cắt lớn hơn độ dày lưỡi cưa, không thể bố trí sắp xếp!',
    zh_tc:
      '您已開啟「鋸切雕刻機-門套切割」功能，下料刀半徑大於了鋸片厚度，無法進行排版！',
    ru: 'Вы включили функцию «Пиловая гравировальная машина — резка дверных наличников». Радиус режущего инструмента больше толщины пилы, компоновка невозможна!',
    ko: '"톱질 조각기-문틀 절단" 기능을 활성화했습니다. 하料 칼 반경이 톱날 두께보다 커서 조판할 수 없습니다!',
    bur: 'သင်သည် "ဖြတ်ညွှတ်စက်-တံခါးဘောင်ဖြတ်ခြင်း" လုပ်ဆောင်ချက်ကို ဖွင့်ထားပြီး၊ ဖြတ်ဓားအချင်းသည် ဆောက်ဓားအထူးထက် ကြီးနေသောကြောင့် ပြင်ဆင်၍မရပါ!',
    ben: 'আপনি "করাত কাটার খোদাই মেশিন-ডোর ফ্রেম কাটিং" ফিচার চালু করেছেন। কাটিং ব্লেডের ব্যাসার্ধ করাতের 두께보다 বড়, লেআউট করা যাচ্ছে না!',
    tr: '"Testere kesim oyma makinesi-Kapı kasası kesimi" özelliğini etkinleştirdiniz. Kesim bıçağı yarıçapı testere kalınlığından büyük, yerleştirme yapılamıyor!',
    km: 'អ្នកបានបើកមុខងារ «ម៉ាស៊ីនចាក់រូបកាត់ដោយរណា-កាត់ស៊ុមទ្វារ» កាំបិទកាត់មានកាំរយៈក្រោយធំជាងក្រាស់រណា មិនអាចរៀបចំបាន!',
    es: 'Ha activado la función "Máquina de grabado de sierra-Corte de marco de puerta". El radio del cuchillo de corte es mayor que el grosor de la hoja de sierra, ¡no se puede realizar la composición tipográfica!',
    ar: 'لقد قمت بتفعيل ميزة "آلة النقش بالمنشار - قطع إطار الباب". نصف قطر شفرة القطع أكبر من سمك شفرة المنشار، ولا يمكن إجراء التنضيد!',
  },
  'common.doorFrameIrregularPlankErr': {
    zh: '您已开启“锯切雕刻机-门套切割”功能，该功能暂不支持异形板件排版！',
    en: 'You have enabled the "Saw Cutting Engraving Machine - Door Frame Cutting" feature. This feature does not currently support irregular panel nesting!',
    id: 'Anda telah mengaktifkan fitur "Mesin Ukir Pemotong Gergaji - Pemotongan Bingkai Pintu". Fitur ini sementara tidak mendukung nesting panel tidak beraturan!',
    kz: 'Сіз "Ара кескіш ою машинасы - Есік жақтауы кесу" функциясын қостыңыз. Бұл функция әзірше стандартты емес панельдерді орналастыруды қолдамайды!',
    th: 'คุณได้เปิดใช้งานฟังก์ชัน "เครื่องแกะสลักตัดเลื่อย-ตัดวงกบประตู" ฟังก์ชันนี้ยังไม่รองรับการจัดเรียงแผ่นรูปทรงพิเศษ!',
    ug: 'سىز «ئارا ئoyiۇش ماشىنىسى-ئىشik قاپلىما كېسىش» ئىقتىدارىنى قوزغىتىپ، بۇ ئىقتىدار ھازىرچە غەيرىي شەكىllىك تاختىلarni پەسلى قىلىشنى قوللىمايدۇ!',
    vi: 'Bạn đã bật tính năng "Máy khắc cắt cưa - Cắt khung cửa". Tính năng này tạm thời không hỗ trợ bố trí tấm dạng đặc biệt!',
    zh_tc: '您已開啟「鋸切雕刻機-門套切割」功能，該功能暫不支持異形板件排版！',
    ru: 'Вы включили функцию «Пиловая гравировальная машина — резка дверных наличников». Эта функция пока не поддерживает компоновку нестандартных панелей!',
    ko: '"톱질 조각기-문틀 절단" 기능을 활성화했습니다. 이 기능은 현재 특형 판재 조판을 지원하지 않습니다!',
    bur: 'သင်သည် "ဖြတ်ညွှတ်စက်-တံခါးဘောင်ဖြတ်ခြင်း" လုပ်ဆောင်ချက်ကို ဖွင့်ထားပြီး၊ ဤလုပ်ဆောင်ချက်သည် မမှန်သော ပလက်အမျိုးအစား ပြင်ဆင်မှုကို ယာယီမပံ့ပိုးပါ!',
    ben: 'আপনি "করাত কাটার খোদাই মেশিন-ডোর ফ্রেম কাটিং" ফিচার চালু করেছেন। এই ফিচারটি এখনও অ-reguler প্যানেল লেআউট সমর্থন করে না!',
    tr: '"Testere kesim oyma makinesi-Kapı kasası kesimi" özelliğini etkinleştirdiniz. Bu özellik şu anda düzensiz panel yerleştirmeyi desteklemiyor!',
    km: 'អ្នកបានបើកមុខងារ «ម៉ាស៊ីនចាក់រូបកាត់ដោយរណា-កាត់ស៊ុមទ្វារ» មុខងារនេះមិនទាន់គាំទ្រការរៀបចំបន្ទះរាងមិនប规则ទេ!',
    es: 'Ha activado la función "Máquina de grabado de sierra-Corte de marco de puerta". ¡Esta función no admite actualmente la composición tipográfica de paneles irregulares!',
    ar: 'لقد قمت بتفعيل ميزة "آلة النقش بالمنشار - قطع إطار الباب". هذه الميزة لا تدعم حاليًا تنضيد الألواح غير المنتظمة!',
  },
  'common.warning': {
    zh: '警告',
    en: 'Warning',
    id: 'memperingatkan',
    kz: 'ескерту',
    th: 'เตือน',
    ug: 'ئاگاھلاندۇرۇش',
    vi: 'Cảnh báo',
    zh_tc: '警告',
    ru: 'Предупреждение',
    ko: '경고',
    bur: 'သတိပေးချက်',
    ben: 'সতর্কতা',
    tr: 'Uyarı',
    km: 'ការព្រមាន',
    es: 'Advertencia',
    ar: 'تحذير',
  },
  'common.export': {
    zh: '导出',
    en: 'Export',
    id: 'Ekspor',
    kz: 'экспорттау',
    th: 'ส่งออก',
    ug: 'چىقىرىش',
    vi: 'Xuất',
    zh_tc: '導出',
    ru: 'экспорт',
    ko: '내보내기',
    bur: 'ထုတ်ပါ',
    ben: 'রপ্তানি করুন',
    tr: 'Dışa aktar',
    km: 'នាំចេញ',
    es: 'Exportar',
    ar: 'تصدير',
  },
  'common.mark': {
    zh: '标记',
    en: 'Mark',
    id: 'tanda',
    kz: 'белгілеу',
    th: 'เครื่องหมาย',
    ug: 'بەلگە',
    vi: 'Đánh dấu',
    zh_tc: '標記',
    ru: 'метка',
    ko: '표시',
    bur: 'မှတ်သားပါ',
    ben: 'চিহ্নিত করুন',
    tr: 'İşaretle',
    km: 'សម្គាល់',
    es: 'Marcar',
    ar: 'تمييز',
  },
  'common.noMark': {
    zh: '不标记',
    en: 'Unmarked',
    id: 'Tidak ditandai',
    kz: 'белгілемеу',
    th: 'ไม่ได้ทำเครื่องหมาย',
    ug: 'بەلگە قويما',
    vi: 'Không đánh dấu',
    zh_tc: '不標記',
    ru: 'Не маркировать',
    ko: '표시 안 함',
    bur: 'မမှတ်သားဘဲ',
    ben: 'চিহ্নিত করবেন না',
    tr: 'İşaretsiz',
    km: 'កុំសម្គាល់',
    es: 'Desmarcar',
    ar: 'إلغاء تحديد',
  },
  'common.sawArrange': {
    zh: '锯切排版',
    en: 'Saw Cut',
    id: 'Jenis pemotongan melihat',
    kz: 'кескіш жобалау',
    th: 'เลื่อยประเภทตัด',
    ug: 'ئارا تەرتىپلەش',
    vi: 'Bố trí cưa',
    zh_tc: '鋸切排版',
    ru: 'Пильный набор',
    ko: '조판을 톱질하다',
    bur: 'ဖြတ်ပြင်ဆင်မှု',
    ben: 'করাত লেআউট',
    tr: 'Testere kesim dizilimi',
    km: 'ការរៀបចំកាត់ដោយក្រុម',
    es: 'Diseño de corte de sierra',
    ar: 'تخطيط قطع المنشار',
  },
  'common.directArrange': {
    zh: '直切排版',
    en: 'Straight Cut',
    id: 'Jenis Potong Lurus',
    kz: 'тікелей кескіш жобалау',
    th: 'ประเภทตัดตรง',
    ug: 'تىك تەرتىپلەش',
    vi: 'Bố trí trực tiếp',
    zh_tc: '直切排版',
    ru: 'Прямая типография',
    ko: '직절 조판',
    bur: 'တိုက်ရိုက်ပြင်ဆင်မှု',
    ben: 'সরাসরি লেআউট',
    tr: 'Doğrudan Yerleştirme',
    km: 'ការ​បោះពុម្ព​ផ្ទាល់',
    es: 'Diseño de corte recto',
    ar: 'تخطيط القطع المستقيم',
  },
  'common.area': {
    zh: '面积',
    en: 'Area',
    id: 'daerah',
    kz: 'ауқым',
    th: 'พื้นที่',
    ug: 'يەر مەيدانى',
    vi: 'Diện tích',
    zh_tc: '面積',
    ru: 'площадь',
    ko: '면적',
    bur: 'ဧရိယာ',
    ben: 'এলাকা',
    tr: 'Alan',
    km: 'ផ្ទៃ',
    es: 'Área',
    ar: 'المنطقة',
  },
  'common.plankNum': {
    zh: '板件条码',
    en: 'Part Barcode',
    id: 'Barcode papan',
    kz: 'тақта нөмірі',
    th: 'บาร์โค้ดบอร์ด',
    ug: 'تاختا باركودى',
    vi: 'Mã vạch ván',
    zh_tc: '板件條碼',
    ru: 'Штрих - код',
    ko: '보드 바코드',
    bur: 'ပေါ်ဒ်ဘာကုဒ်',
    ben: 'বোর্ড বারকোড',
    tr: 'Parça Barkodu',
    km: 'លេខកូដរបារ​បន្ទះ',
    es: 'Código de barras del panel',
    ar: 'باركود اللوحة',
  },
  'common.loc': {
    zh: '柜体',
    en: 'Cabinets',
    id: 'Kabinet',
    kz: 'Шкафтар',
    th: 'ตู้',
    ug: 'كابىنەت',
    vi: 'Tủ',
    zh_tc: '櫃體',
    ru: 'корпус',
    ko: '캐비닛',
    bur: 'ဗီရို',
    ben: 'ক্যাবিনেট',
    tr: 'Dolap',
    km: 'ទូ',
    es: 'Gabinete',
    ar: 'الخزانة',
  },
  'common.cutHeight': {
    zh: '下料长度',
    en: 'Cutting length',
    id: 'Panjang pemotongan',
    kz: 'кесу биіктігі',
    th: 'ความยาวการตัด',
    ug: 'ماتېرىال ئۇزۇنلۇقى',
    vi: 'Chiều dài cắt',
    zh_tc: '下料長度',
    ru: 'Длина раскроя',
    ko: '원단 길이',
    bur: 'ဖြတ်ထားသောအရှည်',
    ben: 'কাটার দৈর্ঘ্য',
    tr: 'Kesme Uzunluğu',
    km: 'ប្រវែងកាត់',
    es: 'Longitud de corte',
    ar: 'طول التقطيع',
  },
  'common.cutWidth': {
    zh: '下料宽度',
    en: 'Cutting width',
    id: 'Lebar pemotongan',
    kz: 'кесу ені',
    th: 'ความกว้างของการตัด',
    ug: 'ماتېرىال كەڭلىكى',
    vi: 'Chiều rộng cắt',
    zh_tc: '下料寬度',
    ru: 'Ширина разреза',
    ko: '원본 너비',
    bur: 'ဖြတ်ထားသောအကျယ်',
    ben: 'কাটার প্রস্থ',
    tr: 'Kesme Genişliği',
    km: 'ទទឹងកាត់',
    es: 'Ancho de corte',
    ar: 'عرض التقطيع',
  },
  'common.defaultProduction': {
    zh: '默认生产线',
    en: 'Default Line',
    id: 'Jalur produksi default',
    kz: 'әдетті өндіріс линиясы',
    th: 'สายการผลิตเริ่มต้น',
    ug: 'سۈكۈتتىكى ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Dây chuyền sản xuất mặc định',
    zh_tc: '默認生產線',
    ru: 'Производственная линия по умолчанию',
    ko: '기본 라인',
    bur: 'မူလထုတ်လုပ်ရေးလိုင်း',
    ben: 'ডিফল্ট উৎপাদন লাইন',
    tr: 'Varsayılan Üretim Hattı',
    km: 'ខ្សែផលិតលំនាំដើម',
    es: 'Línea de producción predeterminada',
    ar: 'خط الإنتاج الافتراضي',
  },
  'common.surplusNum': {
    zh: '余料条码',
    en: 'Surplus Barcode',
    id: 'Kode batang bahan surplus',
    kz: 'Артық материалдың штрих-коды',
    th: 'บาร์โค้ดวัสดุส่วนเกิน',
    ug: 'ئەرتۇق ماتېرىيال باركودى',
    vi: 'Mã vạch vật liệu dư',
    zh_tc: '餘料條碼',
    ru: 'Остаточный штрих - код',
    ko: '여분 바코드',
    bur: 'ပိုလျှံပစ္စည်းဘာကုဒ်',
    ben: 'উদ্বৃত্ত বারকোড',
    tr: 'Artık Barkodu',
    km: 'លេខកូដបាក់ទុក',
    es: 'Código de barras de material restante',
    ar: 'باركود المادة المتبقية',
  },
  'common.tip': {
    zh: '提示',
    en: 'Tip',
    id: 'petunjuk',
    kz: 'ұсынысы',
    th: 'คำใบ้',
    ug: 'ئەسكەرتىش',
    vi: 'Gợi ý',
    zh_tc: '提示',
    ru: 'подсказка',
    ko: '힌트',
    bur: 'အကြောင်းကြားချက်',
    ben: 'টিপস',
    tr: 'İpucu',
    km: 'ដំបូន្មាន',
    es: 'Consejos',
    ar: 'نصائح',
  },
  'common.history': {
    zh: '历史记录',
    en: 'History',
    id: 'Sejarah',
    kz: 'тарих',
    th: 'ประวัติศาสตร์',
    ug: 'تارىخ خاتىرىسى',
    vi: 'Lịch sử',
    zh_tc: '歷史記錄',
    ru: 'история',
    ko: '기록',
    bur: 'မှတ်တမ်း',
    ben: 'ইতিহাস রেকর্ড',
    tr: 'Geçmiş',
    km: 'ប្រវត្តិ',
    es: 'Historia',
    ar: 'التاريخ',
  },
  'common.hinge': {
    zh: '铰链孔',
    en: 'Hinge hole',
    id: 'Lubang engsel',
    kz: 'қаптар сақинасы',
    th: 'รูบานพับ',
    ug: 'ئىلمەك تېشىكى',
    vi: 'Lỗ nối cửa',
    zh_tc: '鉸鏈孔',
    ru: 'Шарнирное отверстие',
    ko: '힌지 구멍',
    bur: 'ဟင်းချဉ်ပေါက်',
    ben: 'কব্জার গর্ত',
    tr: 'Menteşe Deliği',
    km: 'រន្ទះបង្វិល',
    es: 'Orificio para bisagra',
    ar: 'فتحة المفصلة',
  },
  'common.hingeScrew': {
    zh: '铰链门板引孔',
    en: 'Hinged door panel pilot holes',
    id: 'Lubang pemandu panel berengsel',
    kz: 'Аспалы есік панелі пилоттық тесіктері',
    th: 'คู่มือแผงบานพับ',
    ug: 'ئىلمەك ئىشىك تاختىسىنىڭ تېشىكى',
    vi: 'Bản lề bảng điều khiển cửa lỗ thí điểm',
    zh_tc: '鉸鏈門板引孔',
    ru: 'Отверстие на шарнирную дверь',
    ko: '경첩 문판 인공',
    bur: 'ဟင်းချဉ်တံခါးပေါ်ဒ်ဖောက်ပေါက်',
    ben: 'কব্জার দরজার বোর্ডের পাইলট গর্ত',
    tr: 'Menteşe Paneli Kılavuz Delikleri',
    km: 'រន្ទះណែនាំកៅស៊ូទ្វារ',
    es: 'Orificio guía de puerta con bisagra',
    ar: 'فتحة دليل الباب المفصلي',
  },
  'common.CCPXHole': {
    zh: '三合一偏心孔',
    en: 'Three-in-one eccentric hole',
    id: 'Lubang eksentrik tiga dalam satu',
    kz: 'Үш бирлик эксцентрик от',
    th: 'รูเยื้องศูนย์สามรวมกัน',
    ug: 'ئۈچ بىرلەشتۈرۈلگەن تەڭپۇڭسىز تېشىك',
    vi: 'Lỗ eccentric ba trong một',
    zh_tc: '三合一偏心孔',
    ru: 'Экстрацентрическое отверстие',
    ko: '삼합일 편심공',
    bur: 'သုံးပေါင်းတစ်ညာသောပေါက်',
    ben: 'তিন-ইন-ওয়ান এক্সেন্ট্রিক গর্ত',
    tr: 'Üçü Bir Eksen Delik',
    km: 'រន្ទះអិកសង់ទ្រិកបីក្នុងមួយ',
    es: 'Orificio excéntrico tres en uno',
    ar: 'فتحة لامركزية ثلاثة في واحد',
  },
  'common.stretchHinge': {
    zh: '拉直器槽和铰链杯孔',
    en: 'Straightener slot and hinge cup hole',
    id: 'Slot pelurus dan lubang cawan engsel',
    kz: 'Түзөткүч слоты жана гишт тамақ отверстие',
    th: 'สล็อตตัวยืดสายและรูปกระป๋องลูกปัด',
    ug: 'تىكلىگۈچى ئوچۇقى ۋە ئىلمەك ئىچى تېشىكى',
    vi: 'Khe straightener và lỗ cốc khớp',
    zh_tc: '拉直器槽與鉸鏈杯孔',
    ru: 'Ручка выпрямителя и отверстие шарнирного стакана',
    ko: '지퍼 슬롯 및 힌지 컵 구멍',
    bur: 'ဆွဲဖြောင့်ကြိုးနှင့်ဟင်းချဉ်ခွက်ပေါက်',
    ben: 'স্ট্রেইটনার স্লট এবং কব্জার কাপ গর্ত',
    tr: 'Düzleştirici yuvası ve menteşe kap deliği',
    km: 'រន្ធស្លុត និង រន្ធពែងចង្កៀង',
    es: 'Ranura para enderezador y orificio para copa de bisagra',
    ar: 'فتحة جهاز فرد الشعر وفتحة كوب المفصلة',
  },
  'common.stretch': {
    zh: '拉直器',
    en: 'Straightener',
    id: 'Pelurus',
    kz: 'тіреуіш',
    th: 'เครื่องยืดสาย',
    ug: 'تىكلىگۈچ',
    vi: 'Kẹp phẳng',
    zh_tc: '拉直器',
    ru: 'Прямое устройство',
    ko: '매직기',
    bur: 'ဆွဲဖြောင့်ကိရိယာ',
    ben: 'স্ট্রেইটনার',
    tr: 'Düzleştirici',
    km: 'ឧបករណ៍ដោះស្មោះ',
    es: 'Enderezador',
    ar: 'جهاز فرد الشعر',
  },
  'common.stretcher': {
    zh: '拉直器槽',
    en: 'Straightener Slot',
    id: 'Slot pelurus',
    kz: 'тіреуіш сақинасы',
    th: 'สล็อต',
    ug: 'تىكلىگۈچ ئوچۇقى',
    vi: 'Khoan kéo phẳng',
    zh_tc: '拉直器槽',
    ru: 'желоб выпрямителя',
    ko: '스트레이트 슬롯',
    bur: 'ဆွဲဖြောင့်ကြိုး',
    ben: 'স্ট্রেইটনার স্লট',
    tr: 'Düzleştirici yuvası',
    km: 'រន្ធស្លុត',
    es: 'Ranura para enderezador',
    ar: 'فتحة جهاز فرد الشعر',
  },
  'common.eccHole': {
    zh: '偏心孔',
    en: 'Eccentric hole',
    id: 'Lubang eksentrik',
    kz: 'эксцентрикалық тесік',
    th: 'รูเยื้องศูนย์',
    ug: 'تەڭپۇڭسىز تېشىك',
    vi: 'Lỗ lệch tâm',
    zh_tc: '偏心孔',
    ru: 'эксцентричное отверстие',
    ko: '편심공',
    bur: 'ညာသောပေါက်',
    ben: 'এক্সেন্ট্রিক গর্ত',
    tr: 'Eksantrik delik',
    km: 'រន្ធមុំអ៊ីសង់ត្រិច',
    es: 'Orificio excéntrico',
    ar: 'فتحة غريب الأطوار',
  },
  'common.preHole': {
    zh: '预埋孔',
    en: 'Pre-embedded Hole',
    id: 'Lubang tertanam',
    kz: 'алдын ала енгізілген тесік',
    th: 'รูฝังล่วงหน้า',
    ug: 'ئالدىن كۆمۈلگەن تېشىك',
    vi: 'Lỗ chôn sẵn',
    zh_tc: '預埋孔',
    ru: 'Предварительное погребение отверстия',
    ko: '사전 매몰구멍',
    bur: 'ကြိုတင်မြှပ်ထားသောပေါက်',
    ben: 'পূর্ব-এমবেডেড গর্ত',
    tr: 'Ön gömülü delik',
    km: 'រន្ធដាក់មុន',
    es: 'Orificio integrado',
    ar: 'فتحة مدمجة',
  },
  'common.clothole': {
    zh: '衣通孔',
    en: 'Clothes rod hole',
    id: 'Pakaian melalui lubang',
    kz: 'киімдік сақинасы',
    th: 'เสื้อผ้าผ่านรู',
    ug: 'كىيىم ئېسىش تېشىكى',
    vi: 'Lỗ đeo quần áo',
    zh_tc: '衣通孔',
    ru: 'Одежда.',
    ko: '의통공',
    bur: 'အဝတ်ဆောင်ပေါက်',
    ben: 'পোশাক রড গর্ত',
    tr: 'Kıyafet çubuğu deliği',
    km: 'រន្ធដាក់ទ្រនាប់សម្លៀកបំពាក់',
    es: 'Orificio pasante para ropa',
    ar: 'فتحة الملابس من خلال الفتحة',
  },
  'common.backPlank': {
    zh: '背板槽',
    en: 'Backboard Slot',
    id: 'Slot pelat belakang',
    kz: 'арқалық тақта сақинасы',
    th: 'สล็อตแผ่นหลัง',
    ug: 'ئارقا تاختا ئوچۇقى',
    vi: 'Khoan tấm đuôi',
    zh_tc: '背板槽',
    ru: 'Паз задней панели',
    ko: '후면판 슬롯',
    bur: 'နောက်ပေါ်ဒ်ကြိုး',
    ben: 'ব্যাকবোর্ড স্লট',
    tr: 'Arka panel yuvası',
    km: 'រន្ធស្លុតផ្ទាំងខាងក្រោយ',
    es: 'Ranura en el panel posterior',
    ar: 'فتحة اللوحة الخلفية',
  },
  'common.ALS': {
    zh: '暗拉手槽',
    en: 'Hidden Pull Slot',
    id: 'Slot pegangan gelap',
    kz: 'қараңғы тұтқасы сақинасы',
    th: 'สล็อตด้ามจับมืด',
    ug: 'يوشۇرۇن قولتۇق',
    vi: 'Khoan tay cầm tối',
    zh_tc: '暗拉手槽',
    ru: 'Тёмная ручка',
    ko: '암암리에 팔짱을 끼다.',
    bur: 'မမြင်ရသောဆွဲသည့်ကြိုး',
    ben: 'হিডেন পুল স্লট',
    tr: 'Gizli çekme yuvası',
    km: 'រន្ធទាញលាក់',
    es: 'Ranura para manija oculta',
    ar: 'فتحة المقبض المخفي',
  },
  'common.doorSlot': {
    zh: '门板金属槽',
    en: 'Door Metal Slot',
    id: 'Alur logam panel pintu',
    kz: 'есик тақта металл сақинасы',
    th: 'แผงประตูร่องโลหะ',
    ug: 'ئىشىك مېتال ئوچۇقى',
    vi: 'Khoan kim loại tấm cửa',
    zh_tc: '門板金屬槽',
    ru: 'Металлический лоток для дверей',
    ko: '문판 금속홈',
    bur: 'တံခါးသတ္တုကြိုး',
    ben: 'দরজার মেটাল স্লট',
    tr: 'Kapı metal yuvası',
    km: 'រន្ធស្លុតលោហៈទ្វារ',
    es: 'Ranura metálica del panel de la puerta',
    ar: 'فتحة معدنية للوحة الباب',
  },
  'common.drawerSlot': {
    zh: '抽屉金属槽',
    en: 'Drawer Metal Slot',
    id: 'Slot logam laci',
    kz: 'тартма металл сақинасы',
    th: 'ลิ้นชักโลหะ',
    ug: 'سۈرۈندۈك مېتال ئوچۇقى',
    vi: 'Khoan kim loại ngăn kéo',
    zh_tc: '抽屜金屬槽',
    ru: 'Металлический лоток ящика',
    ko: '서랍 금속홈',
    bur: 'ဆွဲဆောင်သတ္တုကြိုး',
    ben: 'ড্রয়ারের মেটাল স্লট',
    tr: 'Çekmece metal yuvası',
    km: 'រន្ធស្លុតដ្រាវហ្វ',
    es: 'Ranura metálica del cajón',
    ar: 'فتحة معدنية للدرج',
  },
  'common.lkSlot': {
    zh: '乐扣槽',
    en: 'Lock slot',
    id: 'Slot kunci',
    kz: 'Құлып ойығы',
    th: 'สล็อตล็อค',
    ug: 'لوك ئوچۇقى',
    vi: 'Rãnh khóa',
    zh_tc: '樂扣槽',
    ru: 'Лазурный жёлоб',
    ko: '음악 단추통',
    bur: 'လော့ကြိုး',
    ben: 'লক স্লট',
    tr: 'Kilit yuvası',
    km: 'រន្ធស្លុតចាក់សោ',
    es: 'Ranura para cerradura',
    ar: 'فتحة قفل',
  },
  'common.KC': {
    zh: '裤抽孔',
    en: 'Trousers drawer hole',
    id: 'Hole Tarik Celana',
    kz: 'штантар сақинасы',
    th: 'กางเกงดึงหลุม',
    ug: 'ئىشتىن تېشىك',
    vi: 'Lỗ khoan quần',
    zh_tc: '褲抽孔',
    ru: 'Дыра в брюках.',
    ko: '바지에 구멍이 나다',
    bur: 'ဘောင်းဘီဆွဲပေါက်',
    ben: 'ট্রাউজার ড্রয়ার গর্ত',
    tr: 'Pantolon çekmece deliği',
    km: 'រន្ធដាក់ខោ',
    es: 'Orificio para pantalones',
    ar: 'فتحة سحب السراويل',
  },
  'common.stealth': {
    zh: '隐形件',
    en: 'Invisible component',
    id: 'Bagian yang tidak terlihat',
    kz: 'Көрінбейтін бөлшек',
    th: 'ชิ้นส่วนที่มองไม่เห็น',
    ug: 'يوشۇرۇن بۆلەك',
    vi: 'Bộ phận vô hình',
    zh_tc: '隱形件',
    ru: 'Невидимый элемент',
    ko: '스텔스 부품',
    bur: 'မမြင်နိုင်သောအစိတ်အပိုင်း',
    ben: 'অদৃশ্য উপাদান',
    tr: 'Görünmez bileşen',
    km: 'ឧបករណ៍មិនឃើញ',
    es: 'Partes ocultas',
    ar: 'الأجزاء المخفية',
  },
  'common.lightSlot': {
    zh: '灯槽',
    en: 'Light slot',
    id: 'Palung cahaya',
    kz: 'Жеңіл науа',
    th: 'รางเบา',
    ug: 'چىراق ئوچۇقى',
    vi: 'Máng ánh sáng',
    zh_tc: '燈槽',
    ru: 'Лампа',
    ko: '램프 슬롯',
    bur: 'မီးရောင်ကြိုး',
    ben: 'লাইট স্লট',
    tr: 'Işık yuvası',
    km: 'រន្ធស្លុតពន្លឺ',
    es: 'Ranura para luz',
    ar: 'فتحة الإضاءة',
  },
  'common.ConventionalHole': {
    zh: '常规孔',
    en: 'Conventional hole',
    id: 'Lubang konvensional',
    kz: 'Аdaqаллы бollik',
    th: 'รูปกติ',
    ug: 'عادەتتىكى خانە',
    vi: 'Lỗ thông thường',
    zh_tc: '常規孔',
    ru: 'Обычное отверстие',
    ko: '일반 구멍',
    bur: 'ပုံမှန်ပေါက်',
    ben: 'প্রচলিত গর্ত',
    tr: 'Geleneksel delik',
    km: 'រន្ធសាធារណៈ',
    es: 'Orificio normal',
    ar: 'الفتحة العادية',
  },
  'common.Keyhole': {
    zh: '锁孔',
    en: 'Keyhole',
    id: 'Lubang kunci',
    kz: 'Кілт саңылауы',
    th: 'รูกุญแจ',
    ug: 'قۇلۇپ خانىسى',
    vi: 'Lỗ khóa',
    zh_tc: '鎖孔',
    ru: 'Замочное отверстие',
    ko: '열쇠 구멍',
    bur: 'သော့ပေါက်',
    ben: 'চাবির গর্ত',
    tr: 'Anahtar deliği',
    km: 'រន្ធសោ',
    es: 'Orificio para cerradura',
    ar: 'فتحة المفتاح',
  },
  'common.allHole': {
    zh: '异形板上所有孔',
    en: 'All Holes on the Specialty Board',
    id: 'Semua lubang di papan berbentuk khusus',
    kz: 'арнайы тақтадағы барлық тесіктер',
    th: 'ทุกหลุมบนกระดานรูปพิเศษ',
    ug: 'ئالاھىدە تاختىدىكى بارلىق تېشىكلەر',
    vi: 'Tất cả các lỗ trên ván hình dáng khác',
    zh_tc: '異形板上所有孔',
    ru: 'Все отверстия на панели',
    ko: '이형판의 모든 구멍',
    bur: ' အထူးပုံပေါ်ဒ်ပေါ်ရှိ ပေါက်အားလုံး',
    ben: 'বিশেষ আকৃতির বোর্ডের সমস্ত গর্ত',
    tr: 'Özel tahtadaki tüm delikler',
    km: 'រន្ធទាំងអស់នៅលើក្តារឯកទេស',
    es: 'Todos los orificios en tableros con formas especiales',
    ar: 'جميع الفتحات على ألواح ذات شكل خاص',
  },
  'common.allSlot': {
    zh: '异形板上所有槽',
    en: 'All Slots on the Specialty Board',
    id: 'Semua slot di papan berbentuk khusus',
    kz: 'арнайы тақтадағы барлық сақиналар',
    th: 'สล็อตทั้งหมดบนกระดานรูปพิเศษ',
    ug: 'ئالاھىدە تاختىدىكى بارلىق ئوچۇقلار',
    vi: 'Tất cả các khoan trên ván hình dáng khác',
    zh_tc: '異形板上所有槽',
    ru: 'Все пазы на фасонной панели',
    ko: '이형판의 모든 슬롯',
    bur: ' အထူးပုံပေါ်ဒ်ပေါ်ရှိ ကြိုးအားလုံး',
    ben: 'বিশেষ আকৃতির বোর্ডের সমস্ত স্লট',
    tr: 'Özel tahtadaki tüm yuvalar',
    km: 'រន្ធស្លុតទាំងអស់នៅលើក្តារឯកទេស',
    es: 'Todas las ranuras en tableros con formas especiales',
    ar: 'جميع الفتحات على ألواح ذات شكل خاص',
  },
  'common.freedomAllHoleSlot': {
    zh: '自由异形板上所有孔槽',
    en: 'Freedom All Holes and Slots on the Specialty Board',
    id: 'Semua lubang dan slot di papan berbentuk khusus',
    kz: 'арнайы тақтадағы барлық тесіктер және сақиналар',
    th: 'ทุกหลุมและสล็อตทั้งหมดบนกระดานรูปพิเศษ',
    ug: 'ئالاھىدە تاختىدىكى بارلىق تېشىكلەر және ئوچۇقلار',
    vi: 'Tất cả các lỗ và khoan trên ván hình dáng khác',
    zh_tc: '自由異形板上所有孔槽',
    ru: 'Все отверстия и пазы на фасонной панели',
    ko: '이형판의 모든 구멍과 슬롯',
    bur: ' အထူးပုံပေါ်ဒ်ပေါ်ရှိ ပေါက်အားလုံးနှင့် ကြိုးအားလုံး',
    ben: 'বিশেষ আকৃতির বোর্ডের সমস্ত গর্ত এবং স্লট',
    tr: 'Özel tahtadaki tüm delikler ve yuvalar',
    km: 'រន្ធទាំងអស់នៅលើក្តារឯកទេសជាមួយនឹង រន្ធទាំងអស់នៅលើក្តារឯកទេស',
    es: 'Todos los orificios y ranuras en tableros con formas especiales',
    ar: 'جميع الفتحات والفتحات على ألواح ذات شكل خاص',
  },
  'common.freedomAllHoleSlotTip': {
    zh: '自由异形板：是指异形板外轮廓四角没有一个直角边的异形',
    en: 'Freedom Board: A board with a non-right angle corner',
    id: 'Papan bebas: papan dengan sudut bukan siku',
    kz: 'арнайы тақта: бұрышы бір жақты емес тақта',
    th: 'กระดานรูปพิเศษ: กระดานที่ไม่มีมุมฉาก',
    ug: 'ئالاھىدە تاختى: بىر جايى تاختى بولمىغان تاختى',
    vi: 'Ván hình dáng khác: ván không có góc vuông',
    zh_tc: '自由異形板：是指異形板外四角沒有一個直角邊的異形',
    ru: 'Фасонная панель: панель с углом, не являющимся прямым',
    ko: '이형판: 직각이 아닌 모서리가 있는 이형판',
    bur: ' အထူးပုံပေါ်ဒ်: မြှောက်တန်းတစ်ခုအပြင်အဆင်မရှိသော ပုံပေါ်ဒ်',
    ben: 'বিশেষ আকৃতির বোর্ড: একটি বোর্ড যার কোণ সমকোণ নয়',
    tr: 'Özel tahta: doğru açılı köşe olmayan tahta',
    km: 'ក្តារឯកទេស: ក្តារឯកទេសដែលមានកម្ពុជាមិនជាបឋម',
    es: 'Tablero especial: tablero con un ángulo que no es recto',
    ar: 'لوحة خاصة: لوحة لها زاوية لا تكون قائمة',
  },
  'common.millInfo': {
    zh: '牛角拉手',
    en: 'Horn handle',
    id: 'Pegangan tanduk',
    kz: 'bûріш туралы ақпарат',
    th: 'มือจับแตร',
    ug: 'كالىس قولتۇق',
    vi: 'Sừng bò nắm tay nhau',
    zh_tc: '牛角拉手',
    ru: 'Ручная рука',
    ko: '소뿔이 손을 잡다.',
    bur: 'နွားချောင်းဆွဲလက်ကိုင်',
    ben: 'শিং আকৃতির হ্যান্ডেল',
    tr: 'Boynuz kolu',
    km: 'ចំណុចឡើងលើដៃ',
    es: 'Manija de bocina',
    ar: 'مقبض القرن',
  },
  'common.haiTang': {
    zh: '海棠角',
    en: 'Begonia corner',
    id: 'Tanduk Begonia',
    kz: 'Айгүл бұрышы',
    th: 'ฮอร์น Begonia',
    ug: 'ھاي تاغ بۇرجىكى',
    vi: 'Góc hải đường',
    zh_tc: '海棠角',
    ru: 'Бегония (мыс)',
    ko: '해당각',
    bur: 'ဘီဂိုနိုယာထောင့်',
    ben: 'বিগোনিয়া কোণ',
    tr: 'Begonvil köşesi',
    km: 'ជ្រុងឈាមក្ដៅ',
    es: 'Cuerno de begonia',
    ar: 'قرن بيجونيا',
  },
  'common.FSDrill': {
    zh: '五/六面钻',
    en: 'Five/Six-Face Drilling Machine',
    id: 'Berlian lima/enam sisi',
    kz: 'алтышақтық/бесшақтық бұрғалау машина',
    th: 'เพชรห้า/หกด้าน',
    ug: 'بەش/ئالتە يۈزلىك ماتور',
    vi: 'Máy khoan 5/6 mặt',
    zh_tc: '五/六面鑽',
    ru: 'Пять / шесть буров',
    ko: '5 / 6 면 드릴',
    bur: 'ငါး/ခြောက်မျက်နှာဖောက်',
    ben: 'পাঁচ/ছয় দিকের ড্রিল',
    tr: 'Beş/Altı Yüzlü Delme Makinesi',
    km: 'ម៉ាស៊ីនដោះលក់ប្រាំ/ប្រាំមួយមុខ',
    es: 'Taladro de cinco/seis caras',
    ar: 'المثقاب الخماسي/ السداسي',
  },
  'common.engraving2': {
    zh: '开料机',
    en: 'Engraving Machine',
    id: 'Mesin pemotong',
    kz: 'қырқызу машина',
    th: 'เครื่องตัด',
    ug: 'ماتېرىال كېسىش ماشىنىسى',
    vi: 'Máy chế biến',
    zh_tc: '開料機',
    ru: 'Раскрыватель',
    ko: '원료 공급기',
    bur: 'ပစ္စည်းဖြတ်စက်',
    ben: 'কাটার মেশিন',
    tr: 'Oyma Makinesi',
    km: 'ម៉ាស៊ីនឆ្លាក់',
    es: 'Máquina cortadora',
    ar: 'آلة القطع',
  },
  'common.xyReverse': {
    zh: 'XY轴互换',
    en: 'XY Axis Swap',
    id: 'XY Axis Interchange',
    kz: 'XY осьдері ауысу',
    th: 'การแลกเปลี่ยนแกน xy',
    ug: 'XY گىرادىئېنت ئالماشتۇرۇش',
    vi: 'Đổi trục XY',
    zh_tc: 'XY軸互換',
    ru: 'Обмен осями XY',
    ko: 'XY 축 교환',
    bur: 'XY ဝင်ရိုးပြောင်းလဲ',
    ben: 'XY অক্ষ পরিবর্তন',
    tr: 'XY Ekseni Takas',
    km: 'ការផ្លាស់ប្តូរអ័ក្ស XY',
    es: 'XYIntercambio de ejes',
    ar: 'XYتبادل المحاور',
  },
  'common.autoXYReverse': {
    zh: '孔槽加工设备自动适配互换',
    en: 'Hole slot processing equipment automatic adaptation exchange',
    id: 'Perangkat pemrosesan lubang slot otomatis disesuaikan pertukaran',
    kz: 'Кескіш қабылдау құрылғысын автоматты түрде сәйкестендіру',
    th: 'อุปกรณ์การประมวลผลรูรับอัตโนมัติปรับสอดให้เข้ากับการแลกเปลี่ยน',
    ug: 'تەڭ كېسىكلەر ئۈزىنىش ماتورى ئىقتىدارى گىرادىئېنت ئالماشتۇرۇش',
    vi: 'Thiết bị xử lý lỗ hổng tự động thích hợp trao đổi',
    zh_tc: '孔槽加工設備自動適配互換',
    ru: 'Автоматическая адаптация оборудования для обработки отверстий',
    ko: '구멍 처리 장비 자동 적응 교환',
    bur: 'အထူးပုံပေါ်ဒ်ပေါ်ရှိ ကြိုးအားလုံး',
    ben: 'বিশেষ আকৃতির বোর্ডের সমস্ত স্লট',
    tr: 'Özel tahtadaki tüm yuvalar',
    km: 'រន្ធស្លុតទាំងអស់នៅលើក្តារឯកទេស',
    es: 'Adaptación e intercambio automático del equipo de procesamiento de agujeros',
    ar: 'التكييف والتبادل التلقائي لمعدات معالجة الثقب',
  },
  'common.autoXYReverseTip': {
    zh: '启用后侧孔机和五六面钻的加工数据将自动适配雕刻机的XY轴互换',
    en: 'After enabling, the processing data of five/six-face drill and side hole drilling machine will be automatically adapted to the XY axis swap of the engraving machine',
    id: 'Setelah diaktifkan, data pemrosesan mesin bor lima/enam sisi dan mesin bor sisi akan disesuaikan dengan pertukaran sumbu xy mesin tanda',
    kz: 'Қосулып, алтышақтық бұрғалау машинасының өңдеу мәліметтері және бұрғалау машинасының өңдеу мәліметтері автоматты түрде XY осьтерінің ауысуына сәйкестендіріледі',
    th: 'เมื่อเปิดใช้งาน ข้อมูลการประมวลผลของเครื่องตัดรูรูปห้า/หกด้านและเครื่องตัดรูด้านจะถูกปรับให้เข้ากับการแลกเปลี่ยนแกน xy ของเครื่องตัดรู',
    ug: 'تەڭ قىلىنغاندىن كېيىن، بەش/ئالتە يۈزلۈك ماتورى ئىقتىدارى گىرادىئېنت ئالماشتۇرۇش ئىقتىدارى قوللىنىپ كىرىلىدۇ',
    vi: 'Sau khi bật, dữ liệu xử lý của máy khoan năm/sáu mặt và máy khoan sisi sẽ được tự động thích hợp với việc hoán đổi trục XY của máy khoan',
    zh_tc: '啟用後五六面鑽的加工數據將自動適配雕刻機的XY軸互換',
    ru: 'После включения данные обработки пяти/шестиугольных сверлильных станков и сверлильных станков автоматически адаптируются к обмену осями XY сверлильного станка',
    ko: '5/6 면 드릴의 가공 데이터와 캐비닛 드릴의 가공 데이터가 자동으로 캐비닛 드릴의 XY 축 교환에 적합하게 조정됩니다',
    bur: 'ငါး/ခြောက်မျက်နှာဖောက် နှင့် ကြိုးအားလုံး ပေါ်ဒ်ပေါ်ရှိ ကြိုးအားလုံး',
    ben: 'পাঁচ/ছয় দিকের ড্রিলের প্রক্রিয়া ডেটা ও সাইড হোল মাইনের প্রক্রিয়া ডেটা স্বয়ংক্রিয়ভাবে XY অক্ষ পরিবর্তনের সাথে সামঞ্জস্যপূর্ণ হয়',
    tr: 'Beş/Altı Yüzlü Delme Makinesi ve sıçrama makinesinin XY ekseni takasına uyumlu hale getirilir',
    km: 'ម៉ាស៊ីនដោះលក់ប្រាំ/ប្រាំមួយមុខ និងម៉ាស៊ីនដោះលក់ប្រាំមួយមុខតាមសាកល្បងតាមអ័ក្ស XY នៃម៉ាស៊ីនដោះលក់ប្រាំមួយមុខ',
    es: 'Al habilitar los datos de procesamiento de la máquina perforadora lateral trasera y el taladro de cinco y seis lados se adaptará automáticamente al intercambio de ejes XY de la máquina de grabado',
    ar: 'سوف يتكيف تمكين بيانات المعالجة لآلة الثقب الجانبي الخلفي والمثقاب الخماسي الجوانب تلقائيًا مع تبادل المحور XY لآلة النقش',
  },
  'common.autoXYReverseTip2': {
    zh: '注：PTP暂不支持',
    en: 'Note: PTP is not supported',
    id: 'Catatan: PTP tidak didukung',
    kz: 'Ескерту: PTP қолданбаған',
    th: 'หมายเหตุ: PTP ไม่รองรับ',
    ug: 'تەڭ PTP قوللىنىپ كىرىلىدۇ',
    vi: 'Ghi chú: PTP không được hỗ trợ',
    zh_tc: '注：PTP暫不支持',
    ru: 'Примечание: PTP не поддерживаются',
    ko: '주의: PTP는 지원되지 않습니다',
    bur: 'မှတ်ချက်: PTP မှားနေပါသည်',
    ben: 'PTP সমর্থন না',
    tr: 'PTP desteklenmiyor',
    km: 'PTP មិនបានជោគជ័យ',
    es: 'Nota: PTP aún no es compatible',
    ar: 'ملاحظة: PTP غير مدعوم حتى الآن',
  },
  'common.xyReverseTip': {
    zh: 'XY轴互换功能暂未兼容L型余料缺口正确摆放，请谨慎使用',
    en: 'The XY axis interchange function is currently not compatible with the correct placement of L-shaped residual material gaps. Please use it with caution',
    id: 'Fungsi pertukaran sumbu xy tidak kompatibel dengan lekukan bahan residu tipe-L ditempatkan dengan benar, silakan gunakan dengan hati-hati',
    kz: 'XY ассау айналасу функциясының L-шапағатты қалайтын қалпына келтіруге үйлесімді емес, қақтықты қолданыңыз',
    th: 'ฟังก์ชั่นการแลกเปลี่ยนแกน XY ไม่สามารถใช้งานได้กับวัสดุที่เหลืออยู่ของ L-type อย่างถูกต้องโปรดใช้ด้วยความระมัดระวัง',
    ug: 'XY گىرادىئېنت ئالماشتۇرۇش ئىقتىدارى L شەكلىدىكى قېلىنما چىكىنى توغرا ئورۇنلاشتۇرۇشقا ماسلىشمايدۇ، دىققەت قىلىڭ',
    vi: 'Chức năng trao đổi trục XY tạm thời không tương thích với lỗ hổng dư lượng hình chữ L, hãy sử dụng cẩn thận',
    zh_tc: 'XY軸互換功能暫未兼容L型餘料缺口正確擺放，請謹慎使用',
    ru: 'Функция обмена осями XY пока не совместима с L - образным разрывом, правильно размещайте, будьте осторожны',
    ko: 'XY 축 교환 기능은 아직 호환되지 않은 L형 여분 재료 부족이 정확하게 배치되었으니 신중하게 사용하십시오',
    bur: 'XY ဝင်ရိုးပြောင်းလဲလုပ်ဆောင်ချက်သည် L ပုံပစ္စည်းနှင့်မကိုက်ညီသေး၊ သတိဖြင့်သုံးပါ',
    ben: 'XY অক্ষ পরিবর্তন ফাংশন এখনো L-আকৃতির উদ্বৃত্ত উপকরণের সাথে সামঞ্জস্যপূর্ণ নয়, সাবধানে ব্যবহার করুন',
    tr: 'XY eksen takas işlevi henüz L-şekilli artık malzeme boşluğunun doğru yerleştirilmesi ile uyumlu değil, lütfen dikkatli kullanınız',
    km: 'មុខងារផ្លាស់ប្តូរអ័ក្ស XY មិនឥឡូវដែលឆបគ្នាជាមួយនឹងការដាក់정確នៃគម្រោងលើសនៃរូបធាតុ L ទេ សូមប្រើប្រាស់ដោយប្រុងប្រយ័ត្ន',
    es: 'XY La función de intercambio de ejes aún no es compatible con el material residual tipo L brecha. Úselo con precaución',
    ar: 'XY وظيفة تبديل المحور غير متوافقة بعد مع L اكتب الفجوة المادية المتبقية. يرجى استخدامه بحذر',
  },
  'common.rect': {
    zh: '矩形',
    en: 'Rectangle',
    id: 'persegi panjang',
    kz: 'Тік пішін',
    th: 'สี่เหลี่ยมผืนผ้า',
    ug: 'تىك تۆت بۇلۇڭ',
    vi: 'Hình chữ nhật',
    zh_tc: '矩形',
    ru: 'прямоугольник',
    ko: '직사각형',
    bur: 'ထောင့်မှန်စတုဂံ',
    ben: 'আয়তক্ষেত্র',
    tr: 'Dikdörtgen',
    km: 'ចតុកោណកែង',
    es: 'Rectángulo',
    ar: 'مستطيل',
  },
  'common.Ltype': {
    zh: 'L形',
    en: 'L-shaped',
    id: 'Berbentuk l',
    kz: 'L пішін',
    th: 'รูปตัว L',
    ug: 'L شەكلى',
    vi: 'Hình chữ L',
    zh_tc: 'L形',
    ru: 'L - образный',
    ko: 'L형',
    bur: 'L ပုံသဏ္ဍာန်',
    ben: 'L-আকৃতি',
    tr: 'L-şekli',
    km: 'រាង L',
    es: 'L Forma',
    ar: 'L الشكل',
  },
  'common.archive': {
    zh: 'Archive',
    en: 'Archive',
    id: 'Arsip',
    kz: 'Архив',
    th: 'คลังเก็บเอกสารสำคัญ',
    ug: 'ئارخىپ',
    vi: 'Lưu trữ',
    zh_tc: 'Archive',
    ru: 'Archive',
    ko: 'Archive',
    bur: 'Archive',
    ben: 'আর্কাইভ',
    tr: 'Arşiv',
    km: 'ឯកសារ',
    es: 'Archive',
    ar: 'Archive',
  },
  'common.tellPlaceholder': {
    zh: '请输入手机号',
    en: 'Please enter your phone number',
    id: 'Harap masukkan nomor ponsel Anda',
    kz: 'Ұялы телефон нөміріңізді кіріңіз',
    th: 'กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ',
    ug: 'تېلېفون نومۇرىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập số điện thoại',
    zh_tc: '請輸入手機號',
    ru: 'Пожалуйста, введите номер телефона.',
    ko: '핸드폰 번호를 입력하세요.',
    bur: 'ဖုန်းနံပါတ်ထည့်ပါ',
    ben: 'মোবাইল নম্বর লিখুন',
    tr: 'Lütfen cep telefonu numarası girin',
    km: 'សូមបញ្ចូលលេខទូរស័ព្ទ',
    es: 'Ingrese su número de teléfono móvil',
    ar: 'يرجى إدخال رقم هاتفك المحمول',
  },
  'common.knivesStore': {
    zh: '刀库',
    en: 'Knife Storage',
    id: 'Perpustakaan Alat',
    kz: 'Кескіш қорап',
    th: 'ห้องสมุดเครื่องมือ',
    ug: 'پىچاق ئامبىرى',
    vi: 'Kho dao',
    zh_tc: '刀庫',
    ru: 'магазин инструментов',
    ko: '칼 창고',
    bur: 'ဓားသိုလှောင်ကိုင်',
    ben: 'ছুরি স্টোরেজ',
    tr: 'Bıçak Depolama',
    km: 'ឃ្លាំងកាំបិត',
    es: 'Almacén de herramientas',
    ar: 'مجلة الأدوات',
  },
  'common.roll': {
    zh: '板件翻面',
    en: 'Flip Part',
    id: 'Piring terbalik',
    kz: 'Кескіштің бетін ауыстыру',
    th: 'จานพลิก',
    ug: 'تاختا ئۆرۈلۈش',
    vi: 'Lật ván',
    zh_tc: '板件翻面',
    ru: 'опрокидывание листов',
    ko: '판자 뒤집기',
    bur: 'ပေါ်ဒ်ကိုပြောင်းဘက်',
    ben: 'বোর্ড উল্টানো',
    tr: 'Panoyu çevir',
    km: 'សន្លឹកដែលលាក់',
    es: 'Placa giratoria',
    ar: 'لوحة الوجه',
  },
  'common.pause': {
    zh: '暂停',
    en: 'Pause',
    id: 'berhenti sebentar',
    kz: 'Тынықтау',
    th: 'หยุดชั่วคราว',
    ug: 'ۋاقىتلىق توختىتىش',
    vi: 'Tạm dừng',
    zh_tc: '暫停',
    ru: 'Пауза',
    ko: '일시 정지',
    bur: 'ခဏရပ်ပါ',
    ben: 'বিরতি',
    tr: 'Duraklat',
    km: 'ផ្អាក',
    es: 'Pausa',
    ar: 'إيقاف مؤقت',
  },
  'common.editTrans': {
    zh: '编辑翻译',
    en: 'Edit Translation',
    id: 'Edit dan Terjemahkan',
    kz: 'Тәрҗеме редакторы',
    th: 'แก้ไขและแปล',
    ug: 'تەرجىمىنى تەھرىرلەش',
    vi: 'Sửa dịch',
    zh_tc: '編輯翻譯',
    ru: 'Редактировать перевод',
    ko: '편집 번역',
    bur: 'ဘာသာပြန်တည်းဖြတ်',
    ben: 'অনুবাদ সম্পাদনা',
    tr: 'Çeviriyi Düzenle',
    km: 'កែប្រែលើកលែង',
    es: 'Editar traducción',
    ar: 'تحرير الترجمة',
  },
  'common.translateManager': {
    zh: '翻译管理',
    en: 'Translation Manager',
    id: 'Manajemen Terjemahan',
    kz: 'Аударма басқару',
    th: 'การจัดการการแปล',
    ug: 'تەرجىمە باشقۇرۇش',
    vi: 'Quản lý dịch',
    zh_tc: '翻譯管理',
    ru: 'Управление переводом',
    ko: '번역 관리',
    bur: 'ဘာသာပြန်စီမံ',
    ben: 'অনুবাদ ব্যবস্থাপনা',
    tr: 'Çeviri Yöneticisi',
    km: 'អ្នកគ្រប់គ្រងលើកលែង',
    es: 'Gestión de traducción',
    ar: 'إدارة الترجمة',
  },
  'common.grating': {
    zh: '格栅',
    en: 'Gratings',
    id: 'Gratis',
    kz: 'Тор',
    th: 'กระจก',
    ug: 'تور',
    vi: 'Tôn',
    zh_tc: '格柵',
    ru: 'Решётка',
    ko: '격자',
    bur: 'မျက်နှာကျင်းတော',
    ben: 'গ্রেটিং',
    tr: 'Izgaralar',
    km: 'ឈាលលំនាប់',
    es: 'Rejilla',
    ar: 'الشبكة',
  },
  'common.addressEditErr': {
    zh: '多订单暂不支持修改项目地址',
    en: 'Modification of project addresses is not supported for multiple orders',
    id: 'Modifikasi alamat proyek tidak didukung untuk beberapa pesanan',
    kz: 'Қос тапсырыстарға жобаның мекенжайін өзгертуге болмайды',
    th: 'การปรับเปลี่ยนที่อยู่โครงการไม่ได้รับการสนับสนุนสำหรับคำสั่งซื้อหลายคำสั่ง',
    ug: 'كۆپ زاكاز ھازىرچە پروگرامما ئادرېسىنى ئۆزگەرتىشكە يول قويمايدۇ',
    vi: 'Không hỗ trợ sửa đổi địa chỉ dự án với nhiều đơn hàng',
    zh_tc: '多訂單暫不支持修改項目地址',
    ru: 'Несколько заказов не поддерживают изменение адреса проекта',
    ko: '프로젝트 주소 수정은 다중 주문에서 일시적으로 지원되지 않습니다.',
    bur: 'အော်ဒါများ၌ ပရောဂျက်လိပ်စာ ပြင်ဆင်မှုကိုယာယီမလုပ်နိုင်',
    ben: 'একাধিক অর্ডারে প্রকল্পের ঠিকানা সংশোধন সমর্থিত নয়',
    tr: 'Çok sayıda siparişte proje adresinin değiştirilmesi desteklenmiyor',
    km: 'ការកែប្រែលម្អាងគម្រោងមិនត្រូវបានគាំទ្របន្ថែមទៀតម្សចនៃលេខគណនាចាប់ផ្តើម',
    es: 'Múltiples pedidos no admiten la modificación de la dirección del proyecto',
    ar: 'لا تدعم الطلبات المتعددة تعديل عنوان المشروع',
  },
  'common.customerEditErr': {
    zh: '多订单暂不支持修改客户资料',
    en: 'Modification of customer information is not supported for multiple orders',
    id: 'Beberapa pesanan tidak mendukung memodifikasi informasi pelanggan',
    kz: 'Қос тапсырыстарға клиенттің деректерін өзгертуге болмайды',
    th: 'คำสั่งซื้อหลายคำสั่งไม่สนับสนุนการแก้ไขข้อมูลลูกค้า',
    ug: 'كۆپ زاكاز ھازىرچە خېرىدار ئۇچۇرىنى ئۆزگەرتىشكە يول قويمايدۇ',
    vi: 'Không hỗ trợ sửa đổi thông tin khách hàng với nhiều đơn hàng',
    zh_tc: '多訂單暫不支持修改客戶資料',
    ru: 'Многочисленные заказы не поддерживают изменение данных клиентов',
    ko: '다중 주문은 고객 프로필 수정을 지원하지 않음',
    bur: 'အော်ဒါများ၌ ဖောက်သည်သတင်းမပြင်နိုင်',
    ben: 'একাধিক অর্ডারে গ্রাহকের তথ্য সংশোধন সমর্থিত নয়',
    tr: 'Çok sayıda siparişte müşteri bilgilerinin değiştirilmesi desteklenmiyor',
    km: 'ការកែប្រែលឿនឹងក្នុងលក្ខណៈច្រើនលេខ តម្លៃគាត់មិនត្រូវបានគាំទ្ដ្បា',
    es: 'Múltiples pedidos no Soporte para modificar la información del cliente.',
    ar: 'طلبات متعددة لا تدعم تعديل معلومات العميل.',
  },
  'common.factoryEditErr': {
    zh: '多订单暂不支持修改工厂单号',
    en: 'Modification of factory order numbers is not supported for multiple orders',
    id: 'Modifikasi nomor pesanan pabrik tidak didukung untuk beberapa pesanan',
    kz: 'Қос тапсырыстарға зауыттың номерін өзгертуге болмайды',
    th: 'การปรับเปลี่ยนหมายเลขคำสั่งซื้อจากโรงงานไม่ได้รับการสนับสนุนสำหรับคำสั่งซื้อหลายรายการ',
    ug: 'كۆپ زاكاز ھازىرچە فابرىكا زاكاز نومۇرىنى ئۆزگەرتىشكە يول قويمايدۇ',
    vi: 'Không hỗ trợ sửa đổi đơn hàng nhà máy với nhiều đơn hàng',
    zh_tc: '多訂單暫不支持修改工廠單號',
    ru: 'Несколько заказов не поддерживают изменение заводского номера',
    ko: '다중 주문은 공장 번호의 수정을 지원하지 않습니다.',
    bur: 'အော်ဒါများ၌ စက်ရုံအော်ဒါနံပါတ်မပြင်နိုင်',
    ben: 'একাধিক অর্ডারে কারখানার অর্ডার নম্বর সংশোধন সমর্থিত নয়',
    tr: 'Çok sayıda siparişte fabrika siparişi numarasının değiştirilmesi desteklenmiyor',
    km: 'ការកែប្រែលេខលំដាប់រោងចក្រមិនត្រូវបានគាំទ្បឌើនលេខគណនា',
    es: 'Actualmente, los pedidos múltiples no admiten la modificación del número de pedido de fábrica.',
    ar: 'الطلبات المتعددة لا تدعم حاليًا تعديل رقم طلب المصنع.',
  },
  'common.roomNameEditErr': {
    zh: '多订单暂不支持修改房间名称',
    en: 'Modification of room names is not supported for multiple orders',
    id: 'Memodifikasi nama kamar tidak didukung untuk beberapa pesanan',
    kz: 'Қос тапсырыстарға бөлменің атауын өзгертуге болмайды',
    th: 'การแก้ไขชื่อห้องไม่รองรับสำหรับคำสั่งซื้อหลายคำสั่ง',
    ug: 'كۆپ زاكاز ھازىرچە ئۆي ئاتىنى ئۆزگەرتىشكە يول قويمايدۇ',
    vi: 'Không hỗ trợ sửa đổi tên phòng với nhiều đơn hàng',
    zh_tc: '多訂單暫不支持修改房間名稱',
    ru: 'Несколько заказов не поддерживают изменение названия комнаты',
    ko: '다중 주문은 공간 이름 수정을 지원하지 않습니다.',
    bur: 'အော်ဒါများ၌ အခန်းအမည်မပြင်နိုင်',
    ben: 'একাধিক অর্ডারে ঘরের নাম সংশোধন সমর্থিত নয়',
    tr: 'Çok sayıda siparişte oda adının değiştirilmesi desteklenmiyor',
    km: 'ការកែប្រែលេខឈ្មោះបន្ទប់មិនត្រូវបានគាំទ្បឌើនលេខគណនា',
    es: 'Actualmente no se admite la modificación del nombre de la sala para pedidos múltiples',
    ar: 'تعديل اسم الغرفة غير مدعوم حاليًا للطلبات المتعددة',
  },
  'common.remarkEditErr': {
    zh: '多订单暂不支持修改订单备注',
    en: 'Modification of order remarks is not supported for multiple orders',
    id: 'Beberapa pesanan belum mendukung modifikasi pesanan',
    kz: 'Қос тапсырыстарға тапсырыс ескертуін өзгертуге болмайды',
    th: 'คำสั่งซื้อหลายคำสั่งยังไม่สนับสนุนการปรับเปลี่ยนคำสั่งซื้อ',
    ug: 'كۆپ زاكاز ھازىرچە زاكاز ئىزاھاتىنى ئۆزگەرتىشكە يول قويمايدۇ',
    vi: 'Không hỗ trợ sửa đổi ghi chú đơn hàng với nhiều đơn hàng',
    zh_tc: '多訂單暫不支持修改訂單備註',
    ru: 'Множественные заказы временно не поддерживаются для изменения комментариев к заказам',
    ko: '다중 주문은 당분간 주문 노트 수정을 지원하지 않습니다.',
    bur: 'အော်ဒါများ၌ မှတ်ချက်မပြင်နိုင်',
    ben: 'একাধিক অর্ডারে অর্ডারের মন্তব্য সংশোধন সমর্থিত নয়',
    tr: 'Çok sayıda siparişte sipariş notlarının değiştirilmesi desteklenmiyor',
    km: 'ការកែប្រែលេខទីភ្នាក់ងារមិនត្រូវបានគាំទ្ដួលលេខគណនា',
    es: 'Actualmente no se admite la modificación de notas de pedido para pedidos múltiples',
    ar: 'تعديل ملاحظات الطلب غير مدعوم حاليًا للطلبات المتعددة',
  },
  'common.toMaterialList': {
    zh: '前往开料清单',
    en: 'Go to Material List',
    id: 'Pergi ke Bill of Material',
    kz: 'Қайрау тізіміне өту',
    th: 'ไปที่บิลวัสดุ',
    ug: 'ماتېرىال تىزىملىكىگە يۆتكىلىش',
    vi: 'Đi đến danh sách chế biến',
    zh_tc: '前往開料清單',
    ru: 'Перейти к списку',
    ko: 'BOM으로 이동',
    bur: 'ပစ္စည်းစာရင်းသွားပါ',
    ben: 'উপকরণ তালিকায় যান',
    tr: 'Malzeme Listesine Git',
    km: 'ទៅបញ្ជីសម្ភារ',
    es: 'Ir a la lista de materiales',
    ar: 'انتقل إلى قائمة المواد',
  },
  'common.deleteFail': {
    zh: '删除失败，请稍后重试！',
    en: 'Deletion failed, please try again later!',
    id: 'Penghapusan gagal, coba lagi nanti!',
    kz: 'Жою сәтсіз аяқталды, кейінірек қайталап көріңіз!',
    th: 'การลบล้มเหลวโปรดลองอีกครั้งในภายหลัง!',
    ug: 'ئۆچۈرۈش مەغلۇپ بولدى، كېيىن قايتا سىناڭ!',
    vi: 'Xóa thất bại, vui lòng thử lại sau!',
    zh_tc: '刪除失敗，請稍後重試！',
    ru: 'Ошибка удаления, повторите попытку позже!',
    ko: '삭제에 실패했습니다. 나중에 다시 시도하십시오!',
    bur: 'ဖျက်ဆီးမအောင်မြင်ပါ၊ နောက်မှ ပြန်ကြိုးစားပါ!',
    ben: 'মুছা ব্যর্থ হয়েছে, পরে আবার চেষ্টা করুন!',
    tr: 'Silme başarısız, lütfen daha sonra tekrar deneyin!',
    km: 'ការលុបបាត់មិនបានជោគជ័យ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ!',
    es: 'La eliminación falló, ¡inténtelo nuevamente más tarde!',
    ar: 'فشل الحذف، يرجى المحاولة مرة أخرى لاحقًا!',
  },
  'common.batchRestore': {
    zh: '批量还原',
    en: 'Batch restore',
    id: 'Pulihkan Batch',
    kz: 'Топпен қалпына келтіру',
    th: 'กู้คืนแบทช์',
    ug: 'جەمئىي ئەسلىگە كەلتۈرۈش',
    vi: 'Khôi phục hàng loạt',
    zh_tc: '批量還原',
    ru: 'Пакетное восстановление',
    ko: '일괄 복원',
    bur: 'အစုလိုက်ပြန်လည်ထားရှိပါ',
    ben: 'ব্যাচ পুনরুদ্ধার',
    tr: 'Toplu Geri Yükleme',
    km: 'ស្តារឡើងវិញជាបង្គុំ',
    es: 'Restauración por lotes',
    ar: 'استرجاع جماعي',
  },
  'common.batchDelete': {
    zh: '批量删除',
    en: 'Batch delete',
    id: 'Hapus Batch',
    kz: 'Топпен жою',
    th: 'การลบแบทช์',
    ug: 'جەمئىي ئۆچۈرۈش',
    vi: 'Xóa hàng loạt',
    zh_tc: '批量刪除',
    ru: 'Удаление пакетов',
    ko: '대량 삭제',
    bur: 'အစုလိုက်ဖျက်ပါ',
    ben: 'ব্যাচ মুছুন',
    tr: 'Toplu Silme',
    km: 'លុបបាត់ជាបង្គុំ',
    es: 'Eliminación de lote',
    ar: 'حذف الدفعة',
  },
  'common.workShop': {
    zh: '车间生产',
    en: 'Workshop Production',
    id: 'Produksi lokakarya',
    kz: 'Цех өндірісі',
    th: 'การผลิตเวิร์กช็อป',
    ug: 'فابرىكا ئىشلەپچىقىرىش',
    vi: 'Sản xuất trong xưởng',
    zh_tc: '車間生產',
    ru: 'Ремонтное производство',
    ko: '작업장 생산',
    bur: 'ဝပ်ရှော့ထုတ်လုပ်မှု',
    ben: 'ওয়ার্কশপ উৎপাদন',
    tr: 'İşçi Üretimi',
    km: 'ផលិតកម្មកម្មន្តិក',
    es: 'Producción del taller',
    ar: 'إنتاج ورشة العمل',
  },
  'common.FGAdrress': {
    zh: '项目地址/合同号',
    en: 'Order address/Contract number',
    id: 'Alamat Proyek/Nomor Kontrak',
    kz: 'Жоба мекенжайы/Шарт нөмірі',
    th: 'ที่อยู่โครงการ/หมายเลขสัญญา',
    ug: 'پروگرامما ئادرېسى/تۇزۈش نومۇرى',
    vi: 'Địa chỉ dự án/Mã hợp đồng',
    zh_tc: '項目地址/合同號',
    ru: 'Адрес проекта / номер контракта',
    ko: '프로젝트 주소 / 계약 번호',
    bur: 'ပရောဂျက်လိပ်စာ/စာချုပ်နံပါတ်',
    ben: 'প্রকল্পের ঠিকানা/চুক্তি নম্বর',
    tr: 'Proje Adresi/Sözleşme Numarası',
    km: 'អាសយដ្ឋានគម្រោង/លេខសន្យា',
    es: 'Dirección del proyecto/número de contrato',
    ar: 'عنوان المشروع/رقم العقد',
  },
  'common.cuttingSize': {
    zh: '切割尺寸',
    en: 'Cutting size',
    id: 'Ukuran pemotongan',
    kz: 'Кесу өлшемі',
    th: 'ขนาดตัด',
    ug: 'كېسىش ئۆلچىمى',
    vi: 'Kích thước cắt',
    zh_tc: '切割尺寸',
    ru: 'Размер резания',
    ko: '가공 치수',
    bur: 'ဖြတ်ထားသောအရွယ်အစား',
    ben: 'কাটার আকার',
    tr: 'Kesme Boyutu',
    km: 'ទំហំកង្កាប់',
    es: 'Tamaño de corte',
    ar: 'حجم القطع',
  },
  'common.finishedSize': {
    zh: '成品尺寸',
    en: 'Finished size',
    id: 'Ukuran produk jadi',
    kz: 'Дайын өлшемі',
    th: 'ขนาดผลิตภัณฑ์สำเร็จรูป',
    ug: 'مۇكەممەل ئۆلچىم',
    vi: 'Kích thước thành phẩm',
    zh_tc: '成品尺寸',
    ru: 'Размер готовой продукции',
    ko: '최종 품목 크기',
    bur: 'ပြီးစီးသောပစ္စည်းအရွယ်အစား',
    ben: 'সম্পন্ন পণ্যের আকার',
    tr: 'Tamamlanmış Boyut',
    km: 'ទំហំផលិតផលដែលបានបញ្ចប់',
    es: 'Tamaño del producto terminado',
    ar: 'حجم المنتج النهائي',
  },
  'common.labelImg': {
    zh: '贴标图片',
    en: 'Label Image',
    id: 'Label gambar',
    kz: 'Жапсырма сурет',
    th: 'การติดฉลากรูปภาพ',
    ug: 'بېلگە رەسىم',
    vi: 'Hình ảnh nhãn',
    zh_tc: '貼標圖片',
    ru: 'Изображение с наклейкой',
    ko: '스티커 사진',
    bur: 'တံဆိပ်ကပ်ပုံ',
    ben: 'লেবেলের ছবি',
    tr: 'Etiket Resmi',
    km: 'រូបភាពស្លាក',
    es: 'Imagen de etiquetado',
    ar: 'صورة الملصق',
  },
  'common.layoutImg': {
    zh: '排版图',
    en: 'Typesetting diagram',
    id: 'Penyusunan huruf',
    kz: 'Тәртіп суреті',
    th: 'การเรียงพิมพ์',
    ug: 'تەرتىپلەش رەسىمى',
    vi: 'Hình ảnh bố trí',
    zh_tc: '排版圖',
    ru: 'Типограмма',
    ko: '조판도',
    bur: 'ပြင်ဆင်မှုပုံ',
    ben: 'লেআউট চিত্র',
    tr: 'Tasnif Diyagramı',
    km: 'គ្រោងលម្អាងរូបមន្ត',
    es: 'Dibujo de diseño',
    ar: 'رسم التخطيط',
  },
  'common.file': {
    zh: '文件',
    en: 'File',
    id: 'dokumen',
    kz: 'Файл',
    th: 'เอกสาร',
    ug: 'ھۆججەت',
    vi: 'Tệp',
    zh_tc: '文件',
    ru: 'документ',
    ko: '파일',
    bur: 'ဖိုင်',
    ben: 'ফাইল',
    tr: 'Dosya',
    km: 'ឯកសារ',
    es: 'Archivo',
    ar: 'الملف',
  },
  'common.folder': {
    zh: '文件夹',
    en: 'Folder',
    id: 'Folder',
    kz: 'Қаптама',
    th: 'โฟลเดอร์',
    ug: 'قىسقۇچ',
    vi: 'Thư mục',
    zh_tc: '文件夾',
    ru: 'папка',
    ko: '폴더',
    bur: 'ဖိုင်ဆောင်',
    ben: 'ফোল্ডার',
    tr: 'Klasör',
    km: 'ឯកសារ',
    es: 'Carpeta',
    ar: 'المجلد',
  },
  'common.reName': {
    zh: '重命名',
    en: 'Rename',
    id: 'Ganti nama',
    kz: 'Атауын өзгерту',
    th: 'การเปลี่ยนชื่อ',
    ug: 'ئاتنى ئۆزگەرتىش',
    vi: 'Đổi tên',
    zh_tc: '重命名',
    ru: 'Переименовать',
    ko: '이름 바꾸기',
    bur: 'အမည်ပြောင်းပါ',
    ben: 'নাম পরিবর্তন করুন',
    tr: 'Adını Değiştir',
    km: 'ផ្លាស់ប្តូរឈ្មោះ',
    es: 'Cambiar nombre',
    ar: 'إعادة تسمية',
  },
  'common.to': {
    zh: '至',
    en: 'To',
    id: 'ke',
    kz: 'Кімге',
    th: 'ถึง',
    ug: 'غا',
    vi: 'Đến',
    zh_tc: '至',
    ru: 'до',
    ko: '에',
    bur: 'ကို',
    ben: 'পর্যন্ত',
    tr: 'Kime',
    km: 'ដល់',
    es: 'a',
    ar: 'إلى',
  },
  'common.plankUnit': {
    zh: '张',
    en: 'Sheet',
    id: 'membuka',
    kz: 'Дана',
    th: 'เปิด',
    ug: 'تاختا',
    vi: 'Trang',
    zh_tc: '張',
    ru: 'Чжан',
    ko: '장',
    bur: 'ချပ်',
    ben: 'শীট',
    tr: 'Sayfa',
    km: 'សន្លឹក',
    es: 'Hoja',
    ar: 'الورقة',
  },
  'common.tagTemp': {
    zh: '标签模板',
    en: 'Label Template',
    id: 'Tag Template',
    kz: 'Тегтің үлгісі',
    th: 'แท็กเทมเพลต',
    ug: 'بېلگە قېلىپى',
    vi: 'Mẫu nhãn',
    zh_tc: '標簽模板',
    ru: 'Шаблоны: Метки',
    ko: '태그 템플릿',
    bur: 'တံဆိပ်ပုံစံ',
    ben: 'লেবেল টেমপ্লেট',
    tr: 'Etiket Şablonu',
    km: 'គំរូស្លាក',
    es: 'Plantilla de etiqueta',
    ar: 'قالب الملصق',
  },
  'common.roomRemark': {
    zh: '房间备注',
    en: 'Room Remark',
    id: 'Catatan kamar',
    kz: 'Бөлме туралы ескертпелер',
    th: 'หมายเหตุห้องพัก',
    ug: 'ئۆي ئىزاھاتى',
    vi: 'Ghi chú phòng',
    zh_tc: '房間備註',
    ru: 'Комната примечания',
    ko: '룸 메모',
    bur: 'အခန်းမှတ်ချက်',
    ben: 'ঘরের মন্তব্য',
    tr: 'Odanın Devamında',
    km: 'កំណត់ចំណាំបន្ទប់',
    es: 'Comentarios de la habitación',
    ar: 'ملاحظات الغرفة',
  },
  'common.noModificationPermission': {
    zh: '没有修改权限',
    en: 'No modification permission',
    id: 'Tidak ada izin modifikasi',
    kz: 'Өзгертуге рұқсат жоқ',
    th: 'ไม่มีสิทธิ์ในการปรับเปลี่ยน',
    ug: 'ئۆزگەرتىش ھوقۇقى يوق',
    vi: 'Không có quyền sửa đổi',
    zh_tc: '沒有修改權限',
    ru: 'Нет прав на изменение',
    ko: '수정 권한 없음',
    bur: 'ပြင်ဆင်ခွင့်မရှိ',
    ben: 'সংশোধনের অনুমতি নেই',
    tr: 'Değiştirme İzni Yok',
    km: 'គ្មានការអនុញ្ញាតកែប្រែ',
    es: 'Sin permiso de modificación',
    ar: 'لا يوجد إذن تعديل',
  },
  'common.modificationRecord': {
    zh: '修改记录',
    en: 'Modification record',
    id: 'Ubah catatan',
    kz: 'Жазбаны өзгерту',
    th: 'แก้ไขระเบียน',
    ug: 'ئۆزگەرتىش خاتىرىسى',
    vi: 'Sửa đổi hồ sơ',
    zh_tc: '修改記錄',
    ru: 'Изменить запись',
    ko: '레코드 수정',
    bur: 'ပြင်ဆင်မှုမှတ်တမ်း',
    ben: 'সংশোধনের রেকর্ড',
    tr: 'Değişiklik Kaydı',
    km: 'ឯកសារកែប្រែ',
    es: 'Registro de modificación',
    ar: 'سجل التعديل',
  },
  'common.page': {
    zh: '页',
    en: 'Page',
    id: 'Halaman',
    kz: 'бет',
    th: 'หน้าหนังสือ',
    ug: 'بەت',
    vi: 'trang',
    zh_tc: '頁',
    ru: 'страница',
    ko: '페이지',
    bur: 'စာမျက်နှာ',
    ben: 'পৃষ্ঠা',
    tr: 'Sayfa',
    km: 'ទំព័រ',
    es: 'Página',
    ar: 'الصفحة',
  },
  'common.strip': {
    zh: '条',
    en: 'Strip',
    id: 'mengupas',
    kz: 'жолақ',
    th: 'เปลื้องผ้า',
    ug: 'قۇر',
    vi: 'đường',
    zh_tc: '條',
    ru: 'Статья',
    ko: '조',
    bur: 'ကြောင်း',
    ben: 'স্ট্রিপ',
    tr: 'Şerit',
    km: 'ផ្នែក',
    es: 'Artículo',
    ar: 'المقالة',
  },
  'common.jump': {
    zh: '跳',
    en: 'jump',
    id: 'Melompat',
    kz: 'секіру',
    th: 'กระโดด',
    ug: 'سەكرەش',
    vi: 'nhảy',
    zh_tc: '跳',
    ru: 'прыгать',
    ko: '점프',
    bur: 'ခုန်ပါ',
    ben: 'ঝাঁপ দিন',
    tr: 'Atla',
    km: 'លោត',
    es: 'Saltar',
    ar: 'الانتقال السريع',
  },
  'common.freeAgreement': {
    zh: '软件免责协议',
    en: 'Software disclaimer agreement',
    id: 'Penafian Perangkat Lunak',
    kz: 'Бағдарламалық қамтамасыз етуден бас тарту туралы келісім',
    th: 'ข้อจำกัดความรับผิดชอบซอฟต์แวร์',
    ug: 'يۇمشاق دېتال مەسئۇلىيەتسىزلىك كېلىشىمى',
    vi: 'Giao thức miễn trách nhiệm phần mềm',
    zh_tc: '軟件免責協議',
    ru: 'Соглашение об освобождении программного обеспечения от ответственности',
    ko: '소프트웨어 책임 면제 계약',
    bur: 'ဆော့ဖ်ဝဲမြသင်ကောင်းကြောင်းကာလ',
    ben: 'সফটওয়্যার দায়মুক্তি চুক্তি',
    tr: 'Yazılım Sorumluluk Reddi Anlaşması',
    km: 'កិច្ចព័ន្ធនានyal់លើផ្នែកទ責',
    es: 'Descargo de responsabilidad del software',
    ar: 'إخلاء المسؤولية عن البرنامج',
  },
  'common.preStep': {
    zh: '上一步',
    en: 'Pre step',
    id: 'Sebelumnya',
    kz: 'Алдыңғы',
    th: 'ก่อนหน้า',
    ug: 'ئالدىنقى قەدەم',
    vi: 'Bước trước',
    zh_tc: '上一步',
    ru: 'Предыдущий шаг',
    ko: '이전 단계',
    bur: 'ယခင်အဆင့်',
    ben: 'পূর্ববর্তী ধাপ',
    tr: 'Önceki Adım',
    km: 'ជំហានមុន',
    es: 'Paso anterior',
    ar: 'الخطوة السابقة',
  },
  'common.nextStep': {
    zh: '下一步',
    en: 'Next step',
    id: 'Langkah selanjutnya',
    kz: 'Келесі',
    th: 'ขั้นตอนต่อไป',
    ug: 'كېيىنكى قەدەم',
    vi: 'nextStep',
    zh_tc: '下一步',
    ru: 'следующий шаг',
    ko: '다음 단계',
    bur: 'နောက်အဆင့်',
    ben: 'পরবর্তী ধাপ',
    tr: 'Sonraki Adım',
    km: 'ជំហានបន្ទាប់',
    es: 'Siguiente paso',
    ar: 'الخطوة التالية',
  },
  'common.upload': {
    zh: '上传',
    en: 'Upload',
    id: 'Mengunggah',
    kz: 'жүктеп салу',
    th: 'อัพโหลด',
    ug: 'يۈكلەش',
    vi: 'Tải lên',
    zh_tc: '上傳',
    ru: 'загрузить',
    ko: '업로드',
    bur: 'တင်ပြပါ',
    ben: 'আপলোড করুন',
    tr: 'Yükle',
    km: 'ផ្ទុកឡើង',
    es: 'Cargando',
    ar: 'تحميل',
  },
  'common.uploading': {
    zh: '上传中',
    en: 'Uploading',
    id: 'Mengunggah',
    kz: 'жүктеп салу',
    th: 'การอัพโหลด',
    ug: 'يۈكلىنىۋاتىدۇ',
    vi: 'đang tải lên',
    zh_tc: '上傳中',
    ru: 'Загрузка',
    ko: '업로드 중',
    bur: 'တင်ပြနေသည်',
    ben: 'আপলোড হচ্ছে',
    tr: 'Yükleniyor',
    km: 'កំពុងផ្ទុកឡើង',
    es: 'Cargando',
    ar: 'تحميل',
  },
  'common.iAgree': {
    zh: '我同意',
    en: 'I agree',
    id: 'Saya setuju',
    kz: 'Мен келісемін',
    th: 'ฉันเห็นด้วย',
    ug: 'مەن قوشۇلىمەن',
    vi: 'Tôi đồng ý',
    zh_tc: '我同意',
    ru: 'Согласен.',
    ko: '동의합니다',
    bur: 'ကျွန်တော်သဘောတူသည်',
    ben: 'আমি সম্মত',
    tr: 'Katılıyorum',
    km: 'ខ្ញុំយល់ព្រម',
    es: 'Acepto',
    ar: 'أوافق',
  },
  'common.pleaseSelectPlank': {
    zh: '请至少选择一块板件',
    en: 'Please select at least one board',
    id: 'Pilih setidaknya satu papan',
    kz: 'Кем дегенде бір тақтайшаны таңдауыңызды сұраймын',
    th: 'โปรดเลือกบอร์ดอย่างน้อยหนึ่งบอร์ด',
    ug: 'كەم دېگەندە بىر تاختا تاللاڭ',
    vi: 'Hãy chọn ít nhất một tấm bảng',
    zh_tc: '請至少選擇一塊板件',
    ru: 'Пожалуйста, выберите хотя бы одну доску.',
    ko: '하나 이상의 보드를 선택하십시오.',
    bur: 'အနည်းဆုံးပေါ်ဒ်တစ်ခုရွေးပါ',
    ben: 'অন্তত একটি বোর্ড নির্বাচন করুন',
    tr: 'Lütfen en az bir beyaz tahta seçin',
    km: 'សូមជ្រើសរើសក្តារយ៉ាងតិច១',
    es: 'Seleccione al menos un panel',
    ar: 'يرجى تحديد لوحة واحدة على الأقل',
  },
  'common.saveToStoreTip': {
    zh: '请至少选择一块非裁剪板件',
    en: 'Please select at least one non-cut-out piece',
    id: 'Pilih setidaknya satu bagian yang tidak berpotongan',
    kz: 'Кем дегенде бір кесілмеген тақтайшаны таңдауыңызды сұраймын',
    th: 'โปรดเลือกชิ้นส่วนที่ไม่ตัดอย่างน้อยหนึ่งชิ้น',
    ug: 'كەم دېگەندە بىر تاللانمىغان تاختا تاللاڭ',
    vi: 'Vui lòng chọn ít nhất một tấm không cắt',
    zh_tc: '請至少選擇一塊非裁剪板件',
    ru: 'Пожалуйста, выберите хотя бы одну не обрезанную доску.',
    ko: '트림되지 않은 보드를 하나 이상 선택하십시오.',
    bur: 'အနည်းဆုံးဖြတ်မထားသောပေါ်ဒ်တစ်ခုရွေးပါ',
    ben: 'অন্তত একটি না-কাটা বোর্ড নির্বাচন করুন',
    tr: 'Lütfen en az bir kesilmemiş parça seçin',
    km: 'សូមជ្រើសរើសយ៉ាងតិច១ផ្នែកដែលមិនបានកាត់',
    es: 'Seleccione al menos un panel sin cortar',
    ar: 'يرجى تحديد لوحة واحدة غير مقطوعة على الأقل',
  },
  'common.fileIsNotExist': {
    zh: '文件不存在',
    en: 'file does not exist',
    id: 'File tidak ada',
    kz: 'Файл жоқ',
    th: 'ไฟล์ไม่มีอยู่จริง',
    ug: 'ھۆججەت مەۋجۇت ئەمەس',
    vi: 'Tập tin không tồn tại',
    zh_tc: '文件不存在',
    ru: 'Файл не существует',
    ko: '파일이 없습니다.',
    bur: 'ဖိုင်မရှိပါ',
    ben: 'ফাইলটি বিদ্যমান নেই',
    tr: 'Dosya Yok',
    km: 'ឯកសារមិនមាន',
    es: 'El archivo no existe',
    ar: 'الملف غير موجود',
  },
  'common.selectAll': {
    zh: '全选',
    en: 'Select all',
    id: 'Pilih semua',
    kz: 'Барлығын таңдау',
    th: 'เลือกทั้งหมด',
    ug: 'ھەممىنى تاللाش',
    vi: 'Chọn tất cả',
    zh_tc: '全選',
    ru: 'Полная выборка',
    ko: '모두 선택',
    bur: 'အားလုံးရွေးပါ',
    ben: 'সব নির্বাচন করুন',
    tr: 'Tümünü Seç',
    km: 'ជ្រើសរើសទាំងអស់',
    es: 'Seleccione todo',
    ar: 'حدد الكل',
  },
  'common.pdfTag': {
    zh: 'PDF标签',
    en: 'PDF Tag',
    id: 'Tag PDF',
    kz: 'PDF Тегі',
    th: 'แท็ก PDF',
    ug: 'PDF بېلگە',
    vi: 'Thẻ PDF',
    zh_tc: 'PDF標簽',
    ru: 'Метки PDF',
    ko: 'PDF 레이블',
    bur: 'PDF တံဆိပ်',
    ben: 'PDF লেবেল',
    tr: 'PDF Etiketi',
    km: 'ស្លាក PDF',
    es: 'PDF Etiqueta',
    ar: 'PDF الملصق',
  },
  'common.tagImage': {
    zh: '标签图片',
    en: 'Tag Image',
    id: 'Gambar tag',
    kz: 'Тег суреті',
    th: 'แท็กรูปภาพ',
    ug: 'بېلگە رەسىم',
    vi: 'Hình ảnh thẻ',
    zh_tc: '標簽圖片',
    ru: 'Фотографии с метками',
    ko: '태그 그림',
    bur: 'တံဆိပ်ပုံ',
    ben: 'লেবেলের ছবি',
    tr: 'Etiket Görüntüsü',
    km: 'រូបភាពស្លាក',
    es: 'Imagen de etiqueta',
    ar: 'صورة الملصق',
  },
  'common.guigui': {
    zh: '柜柜',
    en: 'Guigui',
    id: 'Guigui',
    kz: 'guigui',
    th: 'Guigui',
    ug: 'Guigui',
    vi: 'Guigui',
    zh_tc: '櫃櫃',
    ru: 'Guigui',
    ko: 'Guigui',
    bur: 'Guigui',
    ben: 'Guigui',
    tr: 'Guigui',
    km: 'Guigui',
    es: 'Guigui',
    ar: 'Guigui',
  },
  'common.gratingSlot': {
    zh: '格栅槽',
    en: 'Grating Slot',
    id: 'Slot gril',
    kz: 'Торлы ойық',
    th: 'สล็อตกระจิต',
    ug: 'تور ئوچۇقى',
    vi: 'Rãnh lưới',
    zh_tc: '格柵槽',
    ru: 'паз решетки',
    ko: '그리드 슬롯',
    bur: 'မျက်နှာကျင်းကြိုး',
    ben: 'গ্রেটিং স্লট',
    tr: 'Izgara Yuvası',
    km: 'របៀងលំនាប់ក្រឡា',
    es: 'Ranura de rejilla',
    ar: 'فتحة الشبكة',
  },
  'common.deleteTip': {
    zh: '删除该数据后不可恢复，是否确认删除该数据？',
    en: 'After deleting this data, it cannot be recovered. Are you sure you want to delete this data?',
    id: 'Itu tidak dapat dipulihkan setelah menghapus data. Apakah Anda yakin bahwa data dihapus?',
    kz: 'Бұл деректерді жоюдан кейін олар қалпына келтірілмейді, деректерді жоюға жоспарлануда мұрайсыз ба?',
    th: 'ไม่สามารถกู้คืนได้หลังจากลบข้อมูล คุณแน่ใจหรือไม่ว่าข้อมูลถูกลบ?',
    ug: 'بۇ سانلىق مەلۇماتنى ئۆچۈرگەندىن كېيىن قايتا تىكلىنەلمەيدۇ، ئۆچۈرۈشنى جەزملەشتۈرەمسىز؟',
    vi: 'Sau khi xóa dữ liệu này, nó sẽ không thể khôi phục lại, bạn có chắc chắn muốn xóa dữ liệu này không?',
    zh_tc: '刪除該數據後不可恢復，是否確認刪除該數據？',
    ru: 'Данные не могут быть восстановлены после удаления, подтверждается ли удаление данных?',
    ko: '데이터를 삭제한 후 복구할 수 없습니다. 삭제하시겠습니까?',
    bur: 'ဒေတာဖျက်ပြီးမပြန်ရနိုင်ပါ၊ ဖျက်ရန်အတည်ပြုမည်လား?',
    ben: 'এই ডেটা মুছার পর পুনরুদ্ধার করা যাবে না, ডেটা মুছতে নিশ্চিত করবেন কি?',
    tr: 'Veriler silindikten sonra kurtarılamaz, silmeyi onaylamadan emin misiniz?',
    km: 'បន្ទាប់ពីលុបទិន្នន័យនេះ វាមិនអាចបានស្ដារឡើងវិញ តើលុបទិន្នន័យនេះដែរឬទេ?',
    es: 'Estos datos no se pueden restaurar después de eliminarlos. ¿Confirmas eliminar estos datos?',
    ar: 'لا يمكن استعادة هذه البيانات بعد الحذف. هل تؤكد حذف هذه البيانات؟',
  },
  'common.deleteError': {
    zh: '出现未知错误，删除失败',
    en: 'An unknown error occurred and the deletion failed',
    id: 'Terjadi kesalahan yang tidak diketahui, penghapusan gagal',
    kz: 'Có hay không xác nhận việc xóa dữ liệu',
    th: 'เกิดข้อผิดพลาดที่ไม่รู้จักการลบล้มเหลว',
    ug: 'نۆلىمىگەن خاتالىق كۆرۈلدى، ئۆچۈرۈش مەغلۇپ بولدى',
    vi: 'Đã xảy ra lỗi không xác định và xóa không thành công',
    zh_tc: '出現未知錯誤，刪除失敗',
    ru: 'Произошла неизвестная ошибка, ошибка удаления',
    ko: '알 수 없는 오류가 발생하여 삭제에 실패했습니다.',
    bur: 'မသိသောအမှားဖြစ်ပွားပြီး ဖျက်မအောင်မြင်',
    ben: 'অজানা ত্রুটি ঘটেছে এবং মুছা ব্যর্থ হয়েছে',
    tr: 'Bilinmeyen Hata Oluştu ve Silme Başarısız Oldu',
    km: 'ក្រុមហ៊ុនដែលមិនស្គាល់បានកើតឡើង និងលុបបាត់មិនបានជោគជ័យ',
    es: 'Se produjo un error desconocido y la eliminación falló',
    ar: 'حدث خطأ غير معروف وفشل الحذف',
  },
  'common.cancelDelete': {
    zh: '已取消删除',
    en: 'Deletion canceled',
    id: 'Undelete',
    kz: 'Жоюді тоқтатты',
    th: 'ลบล้าง',
    ug: 'ئۆچۈرۈشتىن ۋاز كەچتى',
    vi: 'Đã hủy xóa',
    zh_tc: '已取消刪除',
    ru: 'Отменено Удалено',
    ko: '삭제 취소됨',
    bur: 'ဖျက်ဆီးမှုပယ်ဖျက်ပြီ',
    ben: 'মুছা বাতিল করা হয়েছে',
    tr: 'Silme İptal Edildi',
    km: 'ការលុបបាត់ត្រូវបានលុបចោល',
    es: 'La eliminación se canceló',
    ar: 'تم إلغاء الحذف',
  },
  'common.confirmDeleteTip': {
    zh: '删除后板件将进入页面右下角"板件待排版库-未入库"中，是否确认删除该数据?',
    en: 'After deleting, the board will be entered in the lower right corner of the page in the "Board to be typeset - not stored", whether to confirm the deletion of the data?',
    id: 'Setelah menghapus papan, papan akan memasuki "pelat yang akan diketik perpustakaan-tidak dimasukkan" di sudut kanan bawah halaman. Apakah Anda pasti akan menghapus data?',
    kz: 'Жойғаннан кейін тақта беттің төменгі оң жақ бұрышына «Тақта типтес болуға тиіс – сақталмайды» деген бетке енгізіледі, деректердің жойылғанын растаудың орындылығы бар ма?',
    th: 'หลังจากลบบอร์ดบอร์ดจะเข้าสู่ "จานที่จะพิมพ์ไลบรารี-ไม่ป้อน" ที่มุมล่างขวาของหน้า คุณแน่ใจว่าจะลบข้อมูลได้หรือไม่?',
    ug: 'ئۆچۈرۈلگەندىن كېيىن تاختىلار تەرتىپلەش بۇكىتىگە كىرىدۇ، ئۆچۈرۈشنى جەزملەشتۈرەمسىز؟',
    vi: 'Sau khi xóa, bảng sẽ được nhập vào góc dưới bên phải của trang trong "Bảng được sắp chữ - không được lưu trữ", có xác nhận xóa dữ liệu hay không?',
    zh_tc:
      '刪除後板件將進入頁面右下角"板件待排版庫-未入庫"中，是否確認刪除該數據?',
    ru: 'Удаление задней панели войдет в нижний правый угол страницы в « Библиотека листов, подлежащих набору - не в библиотеку», подтвердит ли удаление данных?',
    ko: '뒷면 보드를 삭제하면 페이지 오른쪽 하단 모서리에 있는 "보드 준비 라이브러리 - 입고되지 않음" 으로 이동합니다. 이 데이터를 삭제하시겠습니까?',
    bur: 'ဖျက်ပြီးနောက် ပေါ်ဒ်သည် "ပြင်ဆင်ရမည့်ဘောင်-မသွင်းရသေး"တွင် ဝင်မည်၊ ဒေတာဖျက်ရန်အတည်ပြုမည်လား?',
    ben: 'মুছার পর বোর্ড "বোর্ড অপেক্ষায়-সংরক্ষিত নয়" বিভাগে প্রবেশ করবে, ডেটা মুছতে নিশ্চিত করবেন কি?',
    tr: 'Silindikten sonra tahta "Yazılacak Board - depolanmadı" bölümüne girecek, silmeyi onaylayın mı?',
    km: 'បន្ទាប់ពីលុបក្ដារនឹងចូលក្នុង "ក្ដាររង់ចាំចងក្រងនៅលើវេទិកា - មិនបានរក្សាទុក" តើលុបទិន្នន័យដែរឬទេ?',
    es: 'Después de la eliminación, el panel ingresará la "Placa que se va a componer en la biblioteca, no almacenada en la biblioteca" en la esquina inferior derecha de la página. ¿Estás seguro de eliminar los datos?',
    ar: 'بعد الحذف، ستدخل اللوحة إلى "اللوحة المراد تنضيدها في المكتبة - غير المخزنة في المكتبة" في الركن الأيمن السفلي من الصفحة. هل أنت متأكد من حذف البيانات؟',
  },
  'common.confirmDeleteBujianTip': {
    zh: '删除后板件将进入页面右下角"补件库"中，是否确认删除该数据?',
    en: 'After deleting, the part will be entered in the lower right corner of the page in the "Parts Library", whether to confirm the deletion of the data?',
    id: 'Setelah menghapus, bagian akan dimasukkan di sudut kanan bawah halaman di "Perpustakaan Suku Cadang", apakah Anda yakin akan menghapus data?',
    kz: 'Жойғаннан кейін бөлік беттің төменгі оң жақ бұрышындағы "Бөлшектер кітапханасына" енгізіледі, деректерді жоюды растайсыз ба?',
    th: 'หลังจากลบชิ้นส่วนจะถูกป้อนที่มุมล่างขวาของหน้าใน "คลังชิ้นส่วน" คุณแน่ใจว่าจะลบข้อมูลหรือไม่?',
    ug: 'ئۆچۈرۈلگەندىن كېيىن قىسىم بەتنىڭ تۆۋەن ئوڭ بۇلۇڭىدىكى "قىسىملار ئامبىرى" غا كىرىدۇ، ئۆچۈرۈشنى جەزملەشتۈرەمسىز؟',
    vi: 'Sau khi xóa, bộ phận sẽ được đưa vào góc dưới bên phải của trang trong "Thư viện Bộ phận", bạn có xác nhận xóa dữ liệu không?',
    zh_tc: '刪除後板件將進入頁面右下角"補件庫"中，是否確認刪除該數據?',
    ru: 'После удаления деталь будет помещена в правый нижний угол страницы в "Библиотеку деталей", подтвердить удаление данных?',
    ko: '삭제 후 부품이 페이지 오른쪽 하단의 "부품 라이브러리"에 추가됩니다. 데이터를 삭제하시겠습니까?',
    bur: 'ဖျက်ပြီးနောက် အစိတ်အပိုင်းသည် "အစိတ်အပိုင်းများ စာကြည့်တိုက်" တွင် ထည့်သွင်းမည်၊ ဒေတာဖျက်ရန် အတည်ပြုမည်လား?',
    ben: 'মুছার পর অংশটি "পার্টস লাইব্রেরি"তে প্রবেশ করবে, ডেটা মুছতে নিশ্চিত করবেন কি?',
    tr: 'Silindikten sonra parça "Parça Kütüphanesi"ne eklenecektir, silmeyi onaylıyor musunuz?',
    km: 'បន្ទាប់ពីលុប ផ្នែកនឹងត្រូវបានបញ្ចូលទៅក្នុង "បណ្ណាល័យផ្នែក" តើអ្នកបញ្ជាក់ការលុបទិន្នន័យដែរឬទេ?',
    es: 'Después de eliminar, la pieza se ingresará en la esquina inferior derecha de la página en la "Biblioteca de Piezas", ¿está seguro de eliminar los datos?',
    ar: 'بعد الحذف، سيتم إدخال القطعة في الركن الأيمن السفلي من الصفحة في "مكتبة القطع"، هل أنت متأكد من حذف البيانات؟',
  },
  'common.confirmSureDeleteTip': {
    zh: '检测到当前待排版库中有相同材质的小板，删除后待排版库对应小板将不会展示，请确认是否继续删除该大板？',
    en: 'It has been detected that there are small boards with the same material in the current layout library. Are you sure you want to continue deleting this large board?',
    id: 'Terdeteksi bahwa ada papan kecil dengan bahan yang sama di perpustakaan tata letak saat ini. Apakah Anda yakin ingin melanjutkan menghapus papan besar ini?',
    kz: 'Ағымдағы орналасу кітапханасында бірдей материалдан жасалған кішігірім тақталар анықталды, осы үлкен тақтаны жоюды жалғастыруды растайсыз ба?',
    th: 'ตรวจพบว่ามีแผ่นเล็กที่มีวัสดุเดียวกันในคลังจัดวาง โปรดยืนยันว่าคุณต้องการลบแผ่นใหญ่ต่อไปหรือไม่?',
    ug: 'نۆۋەتتىكى تەرتىپلەش بۇكىتىدە ئوخشاش ماتېرىيالدىكى كىچىك تاختا بارلىقى بايقىلدى، بۇ چوڭ تاختىنى ئۆچۈرۈشنى جەزملەشتۈرەمسىز؟',
    vi: 'Phát hiện có tấm nhỏ cùng chất liệu trong thư viện chờ bố trí, bạn có chắc chắn muốn tiếp tục xóa tấm lớn này không?',
    zh_tc:
      '檢測到當前待排版庫中有相同材質的小板，刪除後待排版庫對應小板將不會展示，請確認是否繼續刪除該大板？',
    ru: 'Обнаружено, что в текущей библиотеке, готовой к форматированию, есть небольшая доска из того же материала, после удаления будет отображаться соответствующая доска в библиотеке, пожалуйста, убедитесь, что вы продолжаете удалять большую доску?',
    ko: '현재 대기중인 라이브러리에 동일한 재료의 보드가 감지되었습니다. 삭제 후 대기중인 라이브러리의 해당 보드는 표시되지 않습니다. 이 보드를 계속 삭제하시겠습니까?',
    bur: 'လက်ရှိပြင်ဆင်ရမည့်ဘောင်တွင် ဆင်တူပစ္စည်းကိုင်ပေါ်ဒ်ငယ်ရှိပါသည်၊ ဤပေါ်ဒ်ကြီးဆက်ဖျက်ရန်အတည်ပြုမည်လား?',
    ben: 'বর্তমান লেআউট লাইব্রেরিতে একই উপকরণের ছোট বোর্ড আছে, এই বড় বোর্ড মুছতে নিশ্চিত করবেন কি?',
    tr: 'Mevcut mizanpaj kütüphanesinde aynı malzemeden küçük tahtalar bulunmuştur, bu büyük tahtayı silmeye devam etmeyi onaylayan mısınız?',
    km: 'បង្ហាញថារូបរាងដែលរង់ចាំមានក្ដារតូចដែលមានលក្ខណៈដូចគ្នា ដូច្នេះលុបក្ដារធំរឹងឹងនេះដែរឬទេ?',
    es: 'Se detecta que existen pequeños paneles del mismo material en la biblioteca actual para ser tipografiados. Después de la eliminación, los paneles pequeños correspondientes en la biblioteca que se van a componer no se mostrarán. Confirme si desea continuar eliminando el panel grande.',
    ar: 'تم الكشف عن وجود لوحات صغيرة من نفس المادة في المكتبة الحالية ليتم تنضيدها. بعد الحذف، لن يتم عرض اللوحات الصغيرة المقابلة في المكتبة التي سيتم تنضيدها. يرجى تأكيد ما إذا كنت تريد الاستمرار في حذف اللوحة الكبيرة؟',
  },
  'common.deleteEmptyTip': {
    zh: '是否删除此大板',
    en: 'Whether to delete this large board',
    id: 'Apakah akan menghapus papan ini',
    kz: 'Бұл үлкен тақтаны жою керек пе',
    th: 'ไม่ว่าจะลบบอร์ดนี้',
    ug: 'بۇ چوڭ تاختىنى ئۆچۈرەمسىز؟',
    vi: 'Có nên xóa bảng lớn này không',
    zh_tc: '是否刪除此大板',
    ru: 'Удалить эту доску',
    ko: '이 대시보드 삭제 여부',
    bur: 'ဤပေါ်ဒ်ကြီးကိုဖျက်မည်လား',
    ben: 'এই বড় বোর্ড মুছবেন কি?',
    tr: 'Bu Büyük Paneli Silmek İstiyor Musunuz?',
    km: 'តើលុបក្ដារធំនេះដែរឬទេ?',
    es: 'Si se debe eliminar este tablero grande',
    ar: 'هل يجب حذف هذه اللوحة الكبيرة',
  },
  'common.notCanDelete': {
    zh: '裁剪的余料不支持入库',
    en: 'The cropped remaining materials do not support warehousing',
    id: 'Bahan residu yang dipotong tidak mendukung penyimpanan',
    kz: 'Қиып алынған қалған материалдар қоймалауды қолдамайды',
    th: 'วัสดุที่เหลืออยู่ไม่รองรับการจัดเก็บ',
    ug: 'كېسىلگەن قېلىنما ئامبىرىغا كىرگۈزۈشكە بولمايدۇ',
    vi: 'Các nguyên liệu còn lại bị cắt xén không hỗ trợ nhập kho',
    zh_tc: '裁剪的餘料不支持入庫',
    ru: 'Отрезанные остатки не поддерживаются',
    ko: '재단된 여분의 재료는 입고가 지원되지 않습니다.',
    bur: 'ဖြတ်ထားသောပိုလျှံပစ္စည်းကိုသိုလှောင်မှုမှမထည့်နိုင်',
    ben: 'কাটা উদ্বৃত্ত উপকরণ স্টোরেজ সমর্থন করে না',
    tr: 'Kesilen Kalan Malzeme Depolama Desteklemez',
    km: 'ឧបករណ៍ដែលនៅសល់បង្ហាញមិនគាំទ្ដាច្ចុပ្បន្នដ្ឋាននោះទេ',
    es: 'El material restante que se corta no admite el almacenamiento.',
    ar: 'المادة المتبقية التي يتم قطعها لا تدعم التخزين.',
  },
  'common.new': {
    zh: '新增',
    en: 'New',
    id: 'New',
    kz: 'New',
    th: 'New',
    ug: 'New',
    vi: 'New',
    zh_tc: '新增',
    ru: 'New',
    ko: 'New',
    bur: 'New',
    ben: 'New',
    tr: 'New',
    km: 'New',
    es: 'New',
    ar: 'New',
  },
  'common.innerBluneFailure': {
    zh: '内嵌云排版不生效此功能',
    en: 'Inline cloud typesetting does not take effect',
    id: 'Tata letak awan tertanam tidak berlaku.',
    kz: 'қосылды',
    th: 'เค้าโครงเมฆแบบฝังไม่มีผล',
    ug: 'ئىچكى بۇلۇت تەرتىپلىگۈچ بۇ ئىقتىدارغا ئىناۋەتلىك ئەمەس',
    vi: 'Енгізілген бұлтты теру күшіне енбейді.',
    zh_tc: '內嵌雲排版不生效此功能',
    ru: 'Встроенное облако не работает.',
    ko: '내장 클라우드 레이아웃은 이 기능에 적용되지 않습니다.',
    bur: 'ထည့်သွင်းထားသောCloud Layoutသည်ဤလုပ်ဆောင်ချက်ကိုမကျင့်သုံးနိုင်',
    ben: 'এমবেডেড ক্লাউড টাইপসেটিং এই ফাংশনে কার্যকর নয়',
    tr: 'Gömülü Bulut Düzenlemesi Bu Işlevi Etkinleştirmez',
    km: 'ការរៀបចំដែលបង្កប់ក្នុងពពក មិនដំណើរការលើមុខងារនេះទេ',
    es: 'La composición tipográfica en la nube integrada no tiene efecto.',
    ar: 'التنضيد السحابي المضمن لا يصبح ساري المفعول.',
  },
  'common.deleteBigPlankTip': {
    zh: '最后一张大板上存在小板，无法删除！',
    en: 'A large slab must be kept under the current material color thickness and cannot be deleted!',
    id: 'Piring besar harus disimpan di bawah ketebalan warna bahan saat ini dan tidak dapat dihapus!',
    kz: 'Үлкен плитаны материал түсінің ағымдағы қалыңдығының астында ұстау керек және оны жоюға болмайды!',
    th: 'แผ่นขนาดใหญ่จะต้องเก็บไว้ภายใต้ความหนาของสีวัสดุปัจจุบันและไม่สามารถลบได้!',
    ug: 'نۆۋەتتىكى ماتېرىال رەڭگى ۋە قېلىنلىقىدا كەم دېگەندە بىر چوڭ تاختىنى ساقلىشىڭىز كېرەك، ئۆچۈرۈشكە بولمايدۇ!',
    vi: 'Một tấm lớn phải được giữ dưới độ dày màu vật liệu hiện tại và không thể bị xóa!',
    zh_tc: '最後一張大板上存在小板，無法刪除！',
    ru: 'На последней большой доске есть небольшая доска, которую нельзя удалить!',
    ko: '마지막 큰 판에 작은 판이 존재하여 삭제할 수 없습니다!',
    bur: 'နောက်ဆုံးပေါ်ဒ်ကြီးတွင် ပေါ်ဒ်ငယ်ရှိ၍မဖျက်နိုင်!',
    ben: 'শেষ বড় বোর্ডে ছোট বোর্ড আছে, মুছা যাবে না!',
    tr: 'Son Büyük Panelde Küçük Panel Vardır ve Silinemiyor!',
    km: 'នៅលើក្ដារធំចុងក្រោយមានក្ដារតូច មិនអាចលុបបានទេ!',
    es: '¡Hay un tablero pequeño en el último tablero grande y no se puede eliminar!',
    ar: 'توجد لوحة صغيرة في اللوحة الكبيرة الأخيرة ولا يمكن حذفها!',
  },
  'common.continueExport': {
    zh: '忽略，继续输出文件',
    en: 'Ignore and proceed to the output file',
    id: 'Abaikan, terus output file',
    kz: 'Елемеу және шығыс файлына өту',
    th: 'ละเว้นดำเนินการต่อเพื่อส่งออกไฟล์',
    ug: 'پەرۋا قىلما، ھۆججەت چىقىرىشنى داۋاملاشتۇر',
    vi: 'Bỏ qua và tiến hành tệp đầu ra',
    zh_tc: '忽略，繼續輸出文件',
    ru: 'Игнорировать, продолжить вывод файла',
    ko: '무시, 파일 내보내기 재개',
    bur: 'လျစ်လျူရှုပြီး ဖိုင်ထုတ်မည်',
    ben: 'উপেক্ষা করুন এবং ফাইল আউটপুট চালিয়ে যান',
    tr: 'Göz Ardı Et ile Çıkış Dosyasına Devam Et',
    km: 'មិនអើពើ ហើយបន្តផ្នែកលទ្ធផល',
    es: 'Ignorar y continuar generando el archivo',
    ar: 'تجاهل الملف واستمر في إخراجه',
  },
  'common.toCheck': {
    zh: '去检查',
    en: 'Go check',
    id: 'Periksa',
    kz: 'Тексеруге өту',
    th: 'ตรวจสอบ',
    ug: 'تەكشۈرۈشكە بار',
    vi: 'Đi kiểm tra',
    zh_tc: '去檢查',
    ru: 'Проверьте.',
    ko: '검사하러 가다',
    bur: 'စစ်ဆေးသွားပါ',
    ben: 'যাচাই করুন',
    tr: 'Kontrol etmeye git',
    km: 'ទៅពិនិត្យ',
    es: 'Verificar',
    ar: 'تحقق من',
  },
  'common.pleaseCheck': {
    zh: '当前排版结果存在孔槽冲突/飞出小板/深度异常，请检查！',
    en: 'Please check: The current layout result has hole-slot conflict/flying out small plate/depth anomaly. Please check!',
    id: 'Hasil tata letak saat ini memiliki konflik slot lubang/terbang dari piring kecil/kelainan dalam, silakan periksa!',
    kz: 'Көрсөтүлгөн тизме кескин: Эгемендик борбордук панельде тешик жойлашуы/учак майдалары ажырады/тереңдик аномалиясы бар. Баарын текшериңиз!',
    th: 'ผลการจัดวางในปัจจุบันมีความขัดแย้งในช่องโหว่/บินออกจากแผ่นเล็ก ๆ/ความผิดปกติลึกโปรดตรวจสอบ!',
    ug: 'نۆۋەتتىكى تەرتىپلەش نەتىجىسىدە تېشىك/ئوچۇق توقۇنۇشۇش/چىقىپ كەتكەن كىچىك تاختىلار/چوڭقۇرلۇق غەيرىيلىكى بار، تەكشۈرۈڭ!',
    vi: 'Vui lòng kiểm tra: Kết quả sắp xếp hiện tại có xung đột lỗ khe/mảnh nhỏ bay ra/sự bất thường về độ sâu. Xin hãy kiểm tra!',
    zh_tc: '當前排版結果存在孔槽沖突/飛出小板/深度異常，請檢查！',
    ru: 'Текущий результат типографии имеет конфликт отверстий / вылет из маленькой доски / аномалию глубины, пожалуйста, проверьте!',
    ko: '현재 조판 결과에 슬롯 충돌 / 슬롯 밖으로 날아가기 / 깊이 이상이 있습니다. 확인하십시오!',
    bur: 'လက်ရှိပြင်ဆင်မှုတွင် ပေါက်ကြိုးပဋိပက္ခ/ပေါ်ဒ်ငယ်ထွက်ခြင်း/နက်မှုပုံမမှန်ရှိ၊ စစ်ဆေးပါ!',
    ben: 'বর্তমান লেআউটে গর্ত-স্লট দ্বন্দ্ব/ছোট বোর্ড উড়ে যাওয়া/গভীরতা অসামঞ্জস্য আছে, পরীক্ষা করুন!',
    tr: 'Mevcut yerleşim sonucunda delik-kanal çakışması / küçük plakanın dışarı çıkması / derinlik anormalliği var, lütfen kontrol edin!',
    km: 'លទ្ធផលប្លង់បច្ចុប្បន្នមានការប៉ះទង្គិចរន្ធ-រន្ធស្លុត/បន្ទះតូចហោះចេញ/ជម្រៅមិនប្រក្រតី សូមពិនិត្យ!',
    es: 'El resultado del diseño actual tiene conflictos de orificios/salidos del tablero pequeño/profundidad anormal, ¡compruébelo!',
    ar: 'نتيجة التخطيط الحالي بها تعارض في الفتحات/تطاير خارج اللوحة الصغيرة/عمق غير طبيعي، يرجى التحقق!',
  },
  'common.clampHandCheck': {
    zh: '检测到您部分板件的孔槽无法避让夹手位置，请您手动调整',
    en: 'Detected some of your plate hole slot can not avoid the clamp position, please adjust manually',
    id: 'Ditemukan beberapa lubang slot pada panel Anda tidak dapat menghindari posisi klem, silakan atur secara manual',
    kz: 'Кейбір панельдеріңіздегі саңылаулар қысу күйінен аулақ бола алмайтыны анықталды. Оны қолмен реттеңіз.',
    th: 'พบว่าบางชิ้นจากแผ่นกระดานของคุณไม่สามารรถหลีกเลี้ยงตำแหน่งคันกรอบได้ กรุณาปรับเป็นรูปแบบมืออาชีพ',
    ug: 'بەزى تاختىلارنىڭ تېشىك/ئوچۇقلىرىنىڭ قولتۇق ئورنىنى بوشىتىشقا بولمايدىغانلىقىنى بايقىدىڭىز، قولدا تەڭشەڭ',
    vi: 'Phát hiện thấy một số lỗ rãnh trên tấm bảng của bạn không thể tránh được vị trí kẹp tay, vui lòng điều chỉnh thủ công.',
    zh_tc: '檢測到您部分板件的孔槽無法避讓夾手位置，請您手動調整',
    ru: 'Обнаружено, что отверстие в части вашей панели не может избежать положения зажима, пожалуйста, отрегулируйте вручную',
    ko: '일부 플레이트의 구멍 슬롯에서 클립의 위치를 피할 수 없음이 감지되었습니다. 수동으로 조정하십시오.',
    bur: 'ပေါ်ဒ်တချို့၏ပေါက်ကြိုးများသည် ကိုင်ဆွဲနေရာ ရှောင်မနိုင်ကြောင်းတွေ့ပါ၊ ကိုယ်တိုင်ညှိပါ',
    ben: 'কিছু বোর্ডের গর্ত স্লট ক্ল্যাম্প পজিশন এড়াতে পারছে না, ম্যানুয়ালি সামঞ্জস্য করুন',
    tr: 'Bazı parçalarınızdaki delik ve kanalların kelepçe konumundan kaçamadığı tespit edildi, lütfen manuel olarak ayarlayın',
    km: 'បានរកឃើញថារន្ធ និងស្លុតលើបន្ទះខ្លះៗរបស់អ្នកមិនអាចជៀសវាងទីតាំងក្ដាប់បានទេ សូមកែសម្រួលដោយដៃ',
    es: 'Se detecta que los orificios de algunos de sus paneles no pueden evitar la posición de sujeción, ajuste manualmente',
    ar: 'تم اكتشاف أن فتحات بعض اللوحات الخاصة بك لا يمكنها تجنب موضع التثبيت، يرجى الضبط يدويًا',
  },
  'common.conflictPartDetail': {
    zh: '冲突的板件详情',
    en: 'Details of conflicting plates',
    id: 'Detail panel yang bertabrakan',
    kz: 'Thông tin chi tiết về các thành phần xung đột',
    th: 'รายละเอียดของแผ่นกระดานที่มีปัญหา',
    ug: 'توقۇنۇشۇپ قالغان تاختىلارنىڭ تەپسىلاتى',
    vi: 'Тақта мәліметтері қайшы',
    zh_tc: '衝突的板件詳情',
    ru: 'Подробности конфликта',
    ko: '충돌하는 보드 상세 정보',
    bur: 'ပဋိပက္ခဖြစ်နေသောပေါ်ဒ်အသေးစိတ်',
    ben: 'সংঘর্ষরত বোর্ডের বিস্তারিত',
    tr: 'Çakışan parçaların ayrıntıları',
    km: 'ព័ត៌មានលម្អិតនៃបន្ទះដែលប៉ះទង្គិច',
    es: 'Detalles de los paneles en conflicto',
    ar: 'تفاصيل اللوحات المتعارضة',
  },
  'common.colorNotUndefined': {
    zh: '颜色不能为空',
    en: 'The color can not be empty',
    id: 'Warnanya tidak bisa kosong',
    kz: 'Түс бос болуы мүмкін емес',
    th: 'สีไม่สามารถว่างเปล่า',
    ug: 'رەڭ بوش قالمايدۇ',
    vi: 'Màu sắc không được để trống',
    zh_tc: '顏色不能為空',
    ru: 'Цвет не может быть пустым',
    ko: '색상은 비워둘 수 없습니다.',
    bur: 'အရောင်ကိုဗလာမထားနိုင်',
    ben: 'রঙ খালি রাখা যাবে না',
    tr: 'Renk boş olamaz',
    km: 'ពណ៌មិនអាចទទេបានទេ',
    es: 'El color no puede estar vacío',
    ar: 'لا يمكن أن يكون اللون فارغًا',
  },
  'common.materialNotUndefined': {
    zh: '材质不能为空',
    en: 'The material can not be empty',
    id: 'Materi tidak bisa kosong',
    kz: 'Материал бос болмауы керек',
    th: 'วัสดุไม่สามารถว่างเปล่า',
    ug: 'ماتېرىال بوش قالمايدۇ',
    vi: 'Vật liệu không được để trống',
    zh_tc: '材質不能為空',
    ru: 'Материал не может быть пустым.',
    ko: '재료는 비워둘 수 없습니다.',
    bur: 'ပစ္စည်းကိုဗလာမထားနိုင်',
    ben: 'উপকরণ খালি রাখা যাবে না',
    tr: 'Malzeme boş olamaz',
    km: 'សម្ភារៈមិនអាចទទេបានទេ',
    es: 'El material no puede estar vacío',
    ar: 'لا يمكن أن تكون المادة فارغة',
  },
  'common.newSetting': {
    zh: '新功能',
    en: 'New feature',
    id: 'Fitur baru',
    kz: 'қосылды',
    th: 'คุณสมบัติใหม่',
    ug: 'يېڭى ئىقتىدار',
    vi: 'thêm mới',
    zh_tc: '新功能',
    ru: 'Новые функции',
    ko: '새로운 기능',
    bur: 'လုပ်ဆောင်ချက်အသစ်',
    ben: 'নতুন ফিচার',
    tr: 'Yeni özellik',
    km: 'មុខងារថ្មី',
    es: 'Nueva función',
    ar: 'وظيفة جديدة',
  },
  'common.downImageErrTip': {
    zh: '导出图片失败，因开启贴标图片根据大板分为不同文件夹，需勾选小板标签一起导出',
    en: 'Exporting images failed because the enabled labeling feature divides images into different folders based on the large board. You need to select the small board labels to export together.',
    id: 'Gambar ekspor gagal karena gambar pelabelan dibuka dan dibagi menjadi folder yang berbeda sesuai dengan papan besar. Anda perlu memeriksa label papan kecil untuk mengekspornya bersama.',
    kz: 'Фотоны шығару баталды, өйткені улгама тақтадан бөлмелерге бөлінген шыңырақ суреттерді шығару арзандыруы қол жетімді етілді, бірігі міндетті түрде бейне тақталарын таңдау керек',
    th: 'ภาพการส่งออกล้มเหลวเนื่องจากภาพการติดฉลากถูกเปิดและแบ่งออกเป็นโฟลเดอร์ที่แตกต่างกันตามบอร์ดขนาดใหญ่ คุณต้องตรวจสอบฉลากบอร์ดขนาดเล็กเพื่อส่งออกด้วยกัน',
    ug: 'رەسىم چىقىرىش مەغلۇپ بولدى، چوڭ تاختىلارنى ئايرىم قىسقۇچلارغا بۆلۈش تاللانغانلىقتىن، كىچىك تاختا بېلگىسىنىمۇ تاللاش كېرەك',
    vi: 'Xuất hình ảnh thất bại, do đã bật tùy chọn chia hình ảnh dán nhãn thành các thư mục khác nhau dựa trên bảng lớn, cần chọn cùng lúc nhãn của bảng nhỏ để xuất',
    zh_tc:
      '導出圖片失敗，因開啟貼標圖片根據大板分為不同文件夾，需勾選小板標簽一起導出',
    ru: 'Не удалось экспортировать изображение, так как изображение с наклейкой было разделено на разные папки в соответствии',
    ko: '스티커 이미지를 열면 보드에 따라 다른 폴더로 나눌 수 있으므로 보드 레이블을 선택하여 함께 내보내려면 그림 내보내기에 실패했습니다.',
    bur: 'ပုံထုတ်မအောင်မြင်ပါ၊ တံဆိပ်ပုံချပ်ပြီး ဖိုင်ဆောင်ခွဲပြင်ဆင်မှာ ပေါ်ဒ်ငယ်တံဆိပ်ကိုပါထည့်ပါ',
    ben: 'ছবি রপ্তানি ব্যর্থ, লেবেলের ছবি বড় বোর্ড অনুযায়ী বিভিন্ন ফোল্ডারে বিভক্ত, ছোট বোর্ড লেবেলও নির্বাচন করুন',
    tr: 'Resim dışa aktarma başarısız oldu. Etiket resimleri büyük plakaya göre farklı klasörlere ayrıldığı için küçük plaka etiketlerini de birlikte seçmeniz gerekir.',
    km: 'នាំចេញរូបភាពបរាជ័យ ពីព្រោះបានបើកការបែងចែករូបភាពស្លាកតាមបន្ទះធំទៅកាន់ថតផ្សេងៗ ដូច្នេះត្រូវជ្រើសស្លាកបន្ទះតូចនាំចេញជាមួយគ្នា',
    es: 'No se pudo exportar la imagen, debido a que la imagen de etiquetado está dividida en diferentes carpetas según la placa grande, debe verificar la etiqueta de la placa pequeña para exportar juntas',
    ar: 'فشل تصدير الصورة، لأن صورة الملصق مقسمة إلى مجلدات مختلفة وفقًا للوحة الكبيرة، تحتاج إلى التحقق من علامة اللوحة الصغيرة للتصدير معًا',
  },
  'common.downNcErrTip': {
    zh: '下载NC失败，因开启贴标图片根据大板分为不同文件夹，需勾选小板标签一起导出',
    en: 'Downloading NC failed because the enabled labeling feature divides images into different folders based on the large board. You need to select the small board labels to export together.',
    id: 'Unduh NC gagal karena gambar pelabelan dibagi menjadi folder yang berbeda sesuai dengan papan besar. Anda perlu memeriksa label papan kecil untuk mengekspornya bersama.',
    kz: 'NC файлдарын жүктеу баталды, өйткені улгама тақта бойынша суреттерді бөлмелерге бөлу қызметі қосылды. Бірігі міндетті түрде бейне тақталарын таңдау керек.',
    th: 'ดาวน์โหลด NC ล้มเหลวเนื่องจากภาพการติดฉลากแบ่งออกเป็นโฟลเดอร์ที่แตกต่างกันตามบอร์ดขนาดใหญ่ คุณต้องตรวจสอบฉลากบอร์ดขนาดเล็กเพื่อส่งออกด้วยกัน',
    ug: 'NC چۈشۈرۈش مەغلۇپ بولدى، چوڭ تاختىلارنى ئايرىم قىسقۇچلارغا بۆلۈش تاللانغانلىقتىن، كىچىك تاختا بېلگىسىنىمۇ تاللاش كېرەك',
    vi: 'Tải xuống NC thất bại vì tính năng dán nhãn đã được kích hoạt và chia hình ảnh thành các thư mục khác nhau dựa trên bảng lớn. Bạn cần chọn nhãn của bảng nhỏ để xuất cùng lúc.',
    zh_tc:
      '下載NC失敗，因開啟貼標圖片根據大板分為不同文件夾，需勾選小板標簽一起導出',
    ru: 'Не удалось загрузить NC, так как изображение с наклейкой было разделено на разные папки в соответствии',
    ko: 'NC를 다운로드하지 못했습니다. 맵 이미지를 열면 보드에 따라 폴더가 다르기 때문에 보드 레이블을 선택하여 내보내야 합니다',
    bur: 'NC ဒေါင်းလုဒ်မအောင်မြင်ပါ၊ တံဆိပ်ပုံချပ်ပြီး ဖိုင်ဆောင်ခွဲပြင်ဆင်မှာ ပေါ်ဒ်ငယ်တံဆိပ်ကိုပါထည့်ပါ',
    ben: 'NC ডাউনলোড ব্যর্থ, লেবেলের ছবি বড় বোর্ড অনুযায়ী বিভিন্ন ফোল্ডারে বিভক্ত, ছোট বোর্ড লেবেলও নির্বাচন করুন',
    tr: 'NC indirme başarısız oldu. Etiket resimleri büyük plakaya göre farklı klasörlere ayrıldığı için küçük plaka etiketlerini de birlikte seçmeniz gerekir.',
    km: 'ទាញយក NC បរាជ័យ ពីព្រោះបានបើកការបែងចែករូបភាពស្លាកតាមបន្ទះធំទៅកាន់ថតផ្សេងៗ ដូច្នេះត្រូវជ្រើសស្លាកបន្ទះតូចនាំចេញជាមួយគ្នា',
    es: 'La descarga NC falló porque las imágenes etiquetadas están divididas en diferentes carpetas según el tablero grande. Debes verificar la etiqueta del tablero pequeño para exportar juntos.',
    ar: 'التنزيل فشل NC لأن صور العلامات مقسمة إلى مجلدات مختلفة وفقًا للوحة الكبيرة. تحتاج إلى التحقق من ملصق اللوحة الصغيرة للتصدير معًا.',
  },
  'common.downNcErrTipForSurFolder': {
    zh: '下载NC失败，贴标图片根据大板分为不同文件夹和余料大板文件设置不能同时开启',
    en: 'Downloading NC failed because the enabled labeling feature divides images into different folders based on the large board. You need to select the small board labels to export together.',
    id: 'Unduh NC gagal karena gambar pelabelan dibagi menjadi folder yang berbeda sesuai dengan papan besar. Anda perlu memeriksa label papan kecil untuk mengekspornya bersama.',
    kz: 'NC файлдарын жүктеу баталды, өйткені улгама тақта бойынша суреттерді бөлмелерге бөлу қызметі қосылды. Бірігі міндетті түрде бейне тақталарын таңдау керек.',
    th: 'ดาวน์โหลด NC ล้มเหลวเนื่องจากภาพการติดฉลากแบ่งออกเป็นโฟลเดอร์ที่แตกต่างกันตามบอร์ดขนาดใหญ่ คุณต้องตรวจสอบฉลากบอร์ดขนาดเล็กเพื่อส่งออกด้วยกัน',
    ug: 'NC چۈشۈرۈش مەغلۇپ بولدى، چوڭ تاختىلارنى ئايرىم قىسقۇچلارغا بۆلۈش تاللانغانلىقتىن، كىچىك تاختا بېلگىسىنىمۇ تاللاش كېرەك',
    vi: 'Tải xuống NC thất bại vì tính năng dán nhãn đã được kích hoạt và chia hình ảnh thành các thư mục khác nhau dựa trên bảng lớn. Bạn cần chọn nhãn của bảng nhỏ để xuất cùng lúc.',
    zh_tc:
      '下載NC失敗，貼標圖片根據大板分為不同文件夾和餘料大板文件設置不能同時開啟',
    ru: 'Ошибка загрузки NC, изображение с наклейкой разделено на различные папки в соответствии с большой доской, а настройки файла большой доски не могут быть открыты одновременно',
    ko: 'NC 다운로드에 실패했습니다. 스티커 이미지는 보드에 따라 다른 폴더와 여분 보드 파일 설정으로 나뉘어 동시에 열 수 없습니다.',
    bur: 'NC ဒေါင်းလုဒ်မအောင်မြင်ပါ၊ တံဆိပ်ပုံဖိုင်ဆောင်ခွဲနှင့် ပိုလျှံပစ္စည်းဖိုင်သတ်မှတ်ချက် တပြိုင်နက်ဖွင့်၍မရ',
    ben: 'NC ডাউনলোড ব্যর্থ, লেবেলের ছবি বড় বোর্ড অনুযায়ী বিভিন্ন ফোল্ডারে বিভক্ত এবং উদ্বৃত্ত বড় বোর্ড ফাইল সেটিং একসাথে খোলা যাবে না',
    tr: 'NC indirme başarısız oldu. Etiket resimlerini büyük plakaya göre farklı klasörlere ayırma ve artık büyük plaka dosyası ayarı aynı anda etkinleştirilemez.',
    km: 'ទាញយក NC បរាជ័យ ការបែងចែករូបភាពស្លាកតាមបន្ទះធំទៅថតផ្សេងៗ និងការកំណត់ឯកសារបន្ទះធំសំណល់ មិនអាចបើកក្នុងពេលតែមួយបានទេ',
    es: 'La descarga NC falló, las imágenes de etiquetado se dividen en diferentes carpetas según el tablero grande y la configuración del archivo del tablero grande del material restante no se puede abrir al mismo tiempo',
    ar: 'فشل التنزيل NC، وتم تقسيم صور الملصقات إلى مجلدات مختلفة وفقًا للوحة الكبيرة ولا يمكن فتح إعدادات ملفات اللوحة الكبيرة للمادة المتبقية في نفس الوقت',
  },
  'common.yes': {
    zh: '是',
    en: 'Yes',
    id: 'Ya',
    kz: 'Яс',
    th: 'ใช่',
    ug: 'ھەئە',
    vi: 'Có',
    zh_tc: '是',
    ru: 'да',
    ko: '예',
    bur: 'ဟုတ်ကဲ့',
    ben: 'হ্যাঁ',
    tr: 'Evet',
    km: 'បាទ',
    es: 'Sí',
    ar: 'نعم',
  },
  'common.no': {
    zh: '否',
    en: 'No',
    id: 'TIDAK',
    kz: 'Жоқ',
    th: 'เลขที่',
    ug: 'ياق',
    vi: 'Không',
    zh_tc: '否',
    ru: 'Нет',
    ko: '아니',
    bur: 'မဟုတ်ပါ',
    ben: 'না',
    tr: 'Hayır',
    km: 'ទេ',
    es: 'No',
    ar: 'لا',
  },
  'common.checkColorPrint': {
    zh: '当前已开启彩色标签，请使用彩色打印机进行打印哦~',
    en: 'At present, the color label has been turned on, please use the color printer to print~',
    id: 'Label warna saat ini dihidupkan, silakan gunakan printer warna untuk mencetak ~',
    kz: 'Қазіргі уақытта түс белгісі қосылды, басып шығару үшін түсті принтерді пайдалануыңызды сұраймыз©~',
    th: 'เปิดฉลากสีในขณะนี้โปรดใช้เครื่องพิมพ์สีเพื่อพิมพ์ ~',
    ug: 'نۆۋەتتە رەڭلىك بېلگە قوزغىتىلغان، رەڭلىك بېسقۇچنى ئىشلىتىڭ~',
    vi: 'Hiện tại, nhãn màu đã được bật, vui lòng sử dụng máy in màu để in ~',
    zh_tc: '當前已開啟彩色標簽，請使用彩色打印機進行打印哦~',
    ru: 'В настоящее время включена цветная метка, пожалуйста, используйте цветной принтер для печати.',
    ko: '현재 컬러 레이블이 켜져 있습니다. 컬러 프린터를 사용하여 인쇄하십시오.',
    bur: 'လောလောဆယ် အရောင်တံဆိပ်ဖွင့်ထားသည်၊ အရောင်ပရင်တာသုံး၍ပုံနှိပ်ပါ~',
    ben: 'বর্তমানে রঙিন লেবেল চালু আছে, রঙিন প্রিন্টার দিয়ে প্রিন্ট করুন~',
    tr: 'Renkli etiket şu anda açık, lütfen yazdırmak için renkli yazıcı kullanın~',
    km: 'បច្ចុប្បន្នបានបើកស្លាកពណ៌ហើយ សូមប្រើម៉ាស៊ីនបោះពុម្ពពណ៌ដើម្បីបោះពុម្ព~',
    es: 'Las etiquetas de color están habilitadas actualmente, utilice una impresora a color para imprimir ~',
    ar: 'تم تمكين ملصقات الألوان حاليًا، يرجى استخدام طابعة ملونة للطباعة ~',
  },
  'common.colorRules': {
    zh: '开启生成彩色标签后，订单/房间/柜体/门板都会按照颜色进行区分，目前彩色标签对同一类型的数据支持上限为12个，具体规则如下：',
    en: 'After turning on the generation of color labels, orders/rooms/cabinets/door panels will be distinguished by color, and the maximum number of color labels supported for the same type of data is 12, the specific rules are as follows:',
    id: 'Setelah membuka tag warna yang dihasilkan, pesanan/kamar/kabinet/panel pintu akan dibedakan sesuai dengan warnanya. Saat ini, batas atas tag warna untuk jenis data yang sama adalah 12. Aturan spesifiknya adalah sebagai berikut:',
    kz: 'Түрлі-түсті жапсырмалардың буынын қосқаннан кейін тапсырыстар/бөлмелер/шкафтар/есік панельдері түсі бойынша ажыратылады,kазіргі уақытта деректердің бір түрі үшін қолдау көрсетілетін түс белгілерінің ең көп саны 12, нақты ережелер мынадай:',
    th: 'หลังจากเปิดแท็กสีที่สร้างขึ้นคำสั่ง/ห้อง/ตู้/แผงประตูจะแตกต่างกันตามสี ปัจจุบันขีด จำกัด สูงสุดของแท็กสีสำหรับข้อมูลประเภทเดียวกันคือ 12 กฎเฉพาะมีดังนี้:',
    ug: 'رەڭلىك بېلگە قوزغىتىلغاندىن كېيىن، زاكاز/ئۆي/كابىنەت/ئىشىك تاختىسى رەڭ بويىچە ئايرىلىدۇ، ھازىر رەڭلىك بېلگە بىر خىل سانلىق مەلۇماتقا 12 گىچە قوللايدۇ، تۆۋەندىكى قائىدىلەرگە ئەمەل قىلىڭ:',
    vi: 'Sau khi bật tạo nhãn màu, hiện tại, số lượng nhãn màu tối đa được hỗ trợ cho cùng một loại dữ liệu là 12, các quy tắc cụ thể như sau:',
    zh_tc:
      '開啟生成彩色標簽後，訂單/房間/櫃體/門板都會按照顏色進行區分，目前彩色標簽對同一類型的數據支持上限為12個，具體規則如下：',
    ru: 'После открытия сгенерированной цветной вкладки заказ / комната / шкаф / дверная панель будут различаться по цвету, в настоящее время цветная вкладка поддерживает один и тот же тип данных до 12, конкретные правила заключаются в следующем:',
    ko: '컬러 라벨 생성을 켜면 주문/방/캐비닛/문짝이 색상에 따라 구분됩니다. 현재 컬러 라벨은 같은 유형의 데이터에 대한 지원 상한선이 12개입니다. 구체적인 규칙은 다음과 같습니다.',
    bur: 'အရောင်တံဆိပ်ထုတ်ပြည်ပြီးနောက် အော်ဒါ/အခန်း/ဗီရို/တံခါးသည် အရောင်အလိုက်ခွဲခြားမည်၊ တူညီသောဒေတာအမျိုးအစားတွင် အများဆုံး ၁၂ ခုအထိ ပံ့ပိုးသည်',
    ben: 'রঙিন লেবেল তৈরি চালু করার পর, অর্ডার/ঘর/ক্যাবিনেট/দরজা রঙ অনুযায়ী আলাদা হবে, একই ধরনের ডেটার জন্য সর্বোচ্চ ১২টি রঙিন লেবেল সমর্থিত',
    tr: "Renkli etiket oluşturma açıldıktan sonra siparişler/odalar/dolaplar/kapak panelleri renge göre ayrılır. Şu anda aynı tür veri için desteklenen renkli etiket üst sınırı 12'dir. Kurallar aşağıdaki gibidir:",
    km: 'បន្ទាប់ពីបើកការបង្កើតស្លាកពណ៌ ការបញ្ជាទិញ/បន្ទប់/ទូ/បន្ទះទ្វារ នឹងត្រូវបែងចែកតាមពណ៌។ បច្ចុប្បន្ន ស្លាកពណ៌សម្រាប់ទិន្នន័យប្រភេទដូចគ្នា គាំទ្របានអតិបរមា 12 ហើយច្បាប់លម្អិតមានដូចខាងក្រោម៖',
    es: 'Después de activar la generación de etiquetas de color, los pedidos/habitaciones/gabinetes/paneles de puertas se distinguirán por color. Actualmente, la etiqueta de color admite un máximo de 12 datos del mismo tipo. Las reglas específicas son las siguientes:',
    ar: 'بعد تشغيل إنشاء ملصقات الألوان، سيتم تمييز الطلبات/الغرف/الخزائن/ألواح الأبواب حسب اللون. حاليًا، تدعم تسمية الألوان بحد أقصى 12 بيانات من نفس النوع. القواعد المحددة هي كما يلي:',
  },
  'common.greyPart': {
    zh: '右边标签中灰色部分为',
    en: 'The gray part of the label on the right is',
    id: 'Bagian abu -abu dalam label di sebelah kanan adalah',
    kz: 'Жапсырманың оң жағындағы сұр бөлігі',
    th: 'ส่วนสีเทาในฉลากทางด้านขวาคือ',
    ug: 'ئوڭ تەرەپتىكى بوز بۆلەك',
    vi: 'Phần màu xám của nhãn bên phải là',
    zh_tc: '右邊標簽中灰色部分為',
    ru: 'Серая часть правой метки:',
    ko: '오른쪽 탭의 회색 부분은',
    bur: 'ညာဘက်တံဆိပ်တွင် မီးခိုးရောင်အပိုင်းမှာ',
    ben: 'ডানদিকের লেবেলের ধূসর অংশ হলো',
    tr: 'Sağdaki etiketteki gri kısım',
    km: 'ផ្នែកពណ៌ប្រផេះក្នុងស្លាកខាងស្តាំគឺ',
    es: 'La parte gris de la etiqueta a la derecha es el área',
    ar: 'الجزء الرمادي من الملصق على اليمين هو منطقة',
  },
  'common.region': {
    zh: '区域',
    en: 'Area',
    id: 'daerah',
    kz: 'аймақ',
    th: 'พื้นที่',
    ug: 'رايون',
    vi: 'vùng',
    zh_tc: '區域',
    ru: 'регион',
    ko: '지역',
    bur: 'ဒေသ',
    ben: 'অঞ্চল',
    tr: 'Bölge',
    km: 'តំបន់',
    es: 'Area',
    ar: 'Area',
  },
  'common.notSame': {
    zh: '不同{regionName}区域颜色不同',
    en: 'The color of the {regionName} region is different',
    id: 'Daerah yang berbeda dengan warna {regionName} yang berbeda berbeda',
    kz: '{regionName} аймағының түсі әр түрлі',
    th: 'ภูมิภาคต่าง ๆ ที่มีสี {regionName} ต่างกันแตกต่างกัน',
    ug: 'مۇختەلەف {regionName} رايونلارنىڭ رەڭگى مۇختەلەف',
    vi: 'Màu sắc của vùng {regionName} khác nhau',
    zh_tc: '不同{regionName}區域顏色不同',
    ru: 'Цвет {regionName} отличается',
    ko: '{regionName} 지역 색상이 다릅니다',
    bur: 'မတူညီသော {regionName} ဒေသ အရောင်မတူ',
    ben: '{regionName} অঞ্চলের রঙ আলাদা',
    tr: 'Farklı {regionName} bölgelerinin renkleri farklıdır',
    km: 'តំបន់ {regionName} ខុសៗគ្នា មានពណ៌ខុសគ្នា',
    es: 'Diferentes áreas {regionName} tienen diferentes colores',
    ar: 'مناطق {regionName} مختلفة لها ألوان مختلفة',
  },
  'common.doorTip': {
    zh: '灰色为门板板件，白色为非门板板件',
    en: 'Grey is the door panel, white is the non-door panel',
    id: 'Panel pintu abu-abu, putih adalah panel non-pintu',
    kz: 'Сұр — есік панелі, ақ — есіксіз панель',
    th: 'สีเทาคือแผงประตูสีขาวเป็นแผงที่ไม่ใช่ประตู',
    ug: 'بوز بۆلەك ئىشىك تاختىسى، ئاق بۆلەك ئىشىك تاختىسى ئەمەس',
    vi: 'Màu xám là bảng điều khiển cửa, màu trắng là bảng điều khiển không cửa',
    zh_tc: '灰色為門板板件，白色為非門板板件',
    ru: 'Серый для дверных панелей, белый для дверных панелей',
    ko: '회색은 문짝, 흰색은 비문짝이다',
    bur: 'မီးခိုးရောင်မှာ တံခါးပေါ်ဒ်၊ အဖြူရောင်မှာ တံခါးမဟုတ်သောပေါ်ဒ်',
    ben: 'ধূসর হলো দরজার বোর্ড, সাদা হলো দরজা নয় এমন বোর্ড',
    tr: 'Gri kapak panelini, beyaz ise kapak olmayan paneli gösterir',
    km: 'ពណ៌ប្រផេះជាបន្ទះទ្វារ ពណ៌សជាបន្ទះមិនមែនទ្វារ',
    es: 'El gris es el panel de la puerta, el blanco es el panel que no es la puerta',
    ar: 'الرمادي هو لوحة الباب، والأبيض هو اللوحة غير الباب',
  },
  'common.exist': {
    zh: '存在',
    en: 'Existence',
    id: 'ada',
    kz: 'бар',
    th: 'มีอยู่',
    ug: 'بار',
    vi: 'tồn tại',
    zh_tc: '存在',
    ru: 'Наличие',
    ko: '존재',
    bur: 'ရှိပါသည်',
    ben: 'বিদ্যমান',
    tr: 'Var',
    km: 'មាន',
    es: 'Existe',
    ar: 'موجود',
  },
  'common.limitNotEffect': {
    zh: '数据超过12个，彩色标签不生效',
    en: 'If there are more than 12 data, the color label will not take effect',
    id: 'Lebih dari 12 data, label warna tidak berlaku',
    kz: 'Егер 12-ден астам деректер болса, түс белгісі күшіне енбейді',
    th: 'มากกว่า 12 ข้อมูลฉลากสีไม่มีผล',
    ug: 'سانلىق مەلۇمات 12 دىن ئاشقاندا، رەڭلىك بېلگە ئىناۋەتلىك بولمايدۇ',
    vi: 'Nếu có nhiều hơn 12 dữ liệu, nhãn màu sẽ không có hiệu lực',
    zh_tc: '數據超過12個，彩色標簽不生效',
    ru: 'Более 12 данных, цветные метки не действуют',
    ko: '데이터 12개 이상, 컬러 레이블 적용 안 함',
    bur: 'ဒေတာ ၁၂ ထက်ကျော်ပါက အရောင်တံဆိပ်မကျင့်သုံးနိုင်',
    ben: 'ডেটা ১২টির বেশি হলে রঙিন লেবেল কার্যকর হবে না',
    tr: "Veri sayısı 12'yi aşarsa renkli etiket geçerli olmaz",
    km: 'ប្រសិនបើទិន្នន័យលើស 12 ស្លាកពណ៌នឹងមិនមានប្រសិទ្ធភាពទេ',
    es: 'Más de 12 datos, la etiqueta de color no es válida',
    ar: 'أكثر من 12 بيانات، تسمية اللون غير صالحة',
  },
  'common.hoverTip': {
    zh: '当前为bmp后缀的图片，编码格式黑白，无法输出彩色标签图片',
    en: 'Images with the bmp suffix are encoded in black and white, and cannot be output with color labels',
    id: 'Gambar saat ini memiliki akhiran BMP, format pengkodean berwarna hitam dan putih, dan gambar label warna tidak bisa output.',
    kz: 'Bmp жұрнағы бар суреттер қара-ақ түспен кодталады және түс белгілерімен шығарылуы мүмкін емес',
    th: 'ภาพปัจจุบันมีคำต่อท้าย BMP รูปแบบการเข้ารหัสเป็นสีดำและสีขาวและรูปภาพฉลากสีไม่สามารถส่งออกได้',
    ug: 'نۆۋەتتىكى bump كېڭەيتىلگەن رەسىم، كودلاش فورماتى قارا-ئاق، رەڭلىك بېلگە چىقىرىشقا بولمايدۇ',
    vi: 'Hình ảnh có hậu tố bmp được mã hóa bằng màu đen và trắng và không thể xuất ra bằng nhãn màu',
    zh_tc: '當前為bmp後綴的圖片，編碼格式黑白，無法輸出彩色標簽圖片',
    ru: 'Изображения, которые в настоящее время являются суффиксами bmp, кодируются в черно - белом формате и не могут экспортировать изображения с цветными метками',
    ko: '현재 bmp 접미사 그림, 인코딩 형식 흑백, 컬러 라벨 그림을 출력할 수 없습니다',
    bur: 'လောလောဆယ် bmp နောက်ဆက်ပါသောပုံ၊ ကုဒ်ဖော်မတ်မှာ အမဲဖြူ၊ အရောင်တံဆိပ်ပုံမထုတ်နိုင်',
    ben: 'বর্তমানে bmp এক্সটেনশনের ছবি, এনকোডিং ফরম্যাট কালো-সাদা, রঙিন লেবেল ছবি আউটপুট করা যাবে না',
    tr: 'Geçerli resim bmp uzantılıdır; kodlama siyah beyazdır ve renkli etiket resmi üretilemez',
    km: 'រូបភាពបច្ចុប្បន្នមានកន្ទុយឯកសារ bmp ទ្រង់ទ្រាយកូដជាសខ្មៅ ហើយមិនអាចបង្កើតរូបភាពស្លាកពណ៌បានទេ',
    es: 'La imagen actual es un sufijo bmp, el formato de codificación es blanco y negro y la etiqueta de color la imagen no se puede emitir',
    ar: 'الصورة الحالية هي لاحقة bmp، وتنسيق التشفير أبيض وأسود، واللون لا يمكن إخراج صورة الملصق',
  },
  'common.lock': {
    zh: '锁定',
    en: 'Lock',
    id: 'mengunci',
    kz: 'блоктау',
    th: 'การล็อค',
    ug: 'قۇلۇپلاش',
    vi: 'Khóa',
    zh_tc: '鎖定',
    ru: 'блокировка',
    ko: '잠금',
    bur: 'လော့ပါ',
    ben: 'লক করুন',
    tr: 'Kilitle',
    km: 'ចាក់សោ',
    es: 'Bloquear',
    ar: 'القفل',
  },
  'common.unlock': {
    zh: '解锁',
    en: 'Unlock',
    id: 'Membuka kunci',
    kz: 'блоктаудан ажырату',
    th: 'ปลดล็อค',
    ug: 'قۇلۇپ ئېچىش',
    vi: 'Mở khóa',
    zh_tc: '解鎖',
    ru: 'разблокировать',
    ko: '잠금 해제',
    bur: 'ဖွင့်ပါ',
    ben: 'আনলক করুন',
    tr: 'Kilidi aç',
    km: 'ដោះសោ',
    es: 'Desbloquear',
    ar: 'فتح القفل',
  },
  'common.batchLock': {
    zh: '批量锁定/解锁',
    en: 'Batch Lock/Unlock',
    id: 'Batch Lock/Buka Kunci',
    kz: 'томарлау блоктау/блоктаудан ажырату',
    th: 'แบทช์ล็อค/ปลดล็อค',
    ug: 'جەمئىي قۇلۇپلاش/ئېچىش',
    vi: 'Khóa/Mở khóa hàng loạt',
    zh_tc: '批量鎖定/解鎖',
    ru: 'Блокировка / разблокировка пакетов',
    ko: '대량 잠금 / 잠금 해제',
    bur: 'အစုလိုက်လော့/ဖွင့်',
    ben: 'ব্যাচ লক/আনলক',
    tr: 'Toplu kilitle/kilit aç',
    km: 'ចាក់សោ/ដោះសោជាក្រុម',
    es: 'Bloqueo/desbloqueo de lotes',
    ar: 'قفل/فتح دفعة',
  },
  'common.surplusLock': {
    zh: '余料锁定',
    en: 'Surplus Material Lock',
    id: 'Kunci bahan yang tersisa',
    kz: 'қалайтын материалдарды блоктау',
    th: 'ล็อควัสดุที่เหลืออยู่',
    ug: 'قېلىنما قۇلۇپلاش',
    vi: 'Khóa dư liệu',
    zh_tc: '餘料鎖定',
    ru: 'Блокировка излишков',
    ko: '남은 재료 잠금',
    bur: 'ပိုလျှံပစ္စည်းလော့',
    ben: 'উদ্বৃত্ত উপকরণ লক',
    tr: 'Artık malzeme kilidi',
    km: 'ចាក់សោសំណល់សម្ភារៈ',
    es: 'Bloqueo de material restante',
    ar: 'قفل المادة المتبقية',
  },
  'common.surplusUnlock': {
    zh: '余料解锁',
    en: 'Surplus Material Unlock',
    id: 'Bahan yang tersisa tidak dikunci',
    kz: 'қалайтын материалдарды блоктаудан ажырату',
    th: 'ปลดล็อควัสดุที่เหลืออยู่',
    ug: 'قېلىنما قۇلۇپ ئېچىش',
    vi: 'Mở khóa còn lại',
    zh_tc: '餘料解鎖',
    ru: 'Разблокировка излишков',
    ko: '남은 재료 잠금 해제',
    bur: 'ပိုလျှံပစ္စည်းဖွင့်',
    ben: 'উদ্বৃত্ত উপকরণ আনলক',
    tr: 'Artık malzeme kilidini aç',
    km: 'ដោះសោសំណល់សម្ភារៈ',
    es: 'Desbloqueo de material restante',
    ar: 'فتح قفل المادة المتبقية',
  },
  'common.is': {
    zh: '是',
    en: 'Yes',
    id: 'Ya',
    kz: 'Иә',
    th: 'ใช่',
    ug: 'ھەئە',
    vi: 'Vâng',
    zh_tc: '是',
    ru: 'да',
    ko: '예',
    bur: 'ဟုတ်ကဲ့',
    ben: 'হ্যাঁ',
    tr: 'Evet',
    km: 'បាទ',
    es: 'Sí',
    ar: 'نعم',
  },
  'common.not': {
    zh: '否',
    en: 'No',
    id: 'TIDAK',
    kz: 'Жоқ',
    th: 'เลขที่',
    ug: 'ياق',
    vi: 'Không',
    zh_tc: '否',
    ru: 'Нет',
    ko: '아니',
    bur: 'မဟုတ်ပါ',
    ben: 'না',
    tr: 'Hayır',
    km: 'ទេ',
    es: 'No',
    ar: 'لا',
  },
  'common.savingHistory': {
    zh: '正在保存历史文件',
    en: 'Saving history file',
    id: 'Menyimpan file historis',
    kz: 'Тарих файлын сақтау',
    th: 'การบันทึกไฟล์ประวัติ',
    ug: 'تارىخىي ھۆججەت ساقلانماقتا',
    vi: 'Đang lưu trữ tệp lịch sử',
    zh_tc: '正在保存歷史文件',
    ru: 'Сохраняются исторические документы',
    ko: '히스토리 파일 저장 중',
    bur: 'မှတ်တမ်းဖိုင်သိမ်းနေသည်',
    ben: 'ইতিহাস ফাইল সংরক্ষণ করা হচ্ছে',
    tr: 'Geçmiş dosyası kaydediliyor',
    km: 'កំពុងរក្សាទុកឯកសារប្រវត្តិ',
    es: 'Guardado del archivo de historial',
    ar: 'حفظ ملف السجل',
  },
  'common.saveHistorySuccess': {
    zh: '保存历史文件成功',
    en: 'Save history file successfully',
    id: 'Menyimpan file historis dengan sukses',
    kz: 'Тарих файлын сәтті сақтаңыз',
    th: 'การบันทึกไฟล์ประวัติศาสตร์สำเร็จ',
    ug: 'تارىخىي ھۆججەت ساقلاش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Lưu trữ tệp lịch sử thành công',
    zh_tc: '保存歷史文件成功',
    ru: 'Сохранить исторический файл успешно',
    ko: '히스토리 파일을 저장했습니다.',
    bur: 'မှတ်တမ်းဖိုင်သိမ်းဆည်းမှုအောင်မြင်သည်',
    ben: 'ইতিহাস ফাইল সফলভাবে সংরক্ষিত হয়েছে',
    tr: 'Geçmiş dosyası başarıyla kaydedildi',
    km: 'រក្សាទុកឯកសារប្រវត្តិដោយជោគជ័យ',
    es: 'Guardado exitoso del archivo de historial',
    ar: 'حفظ ناجح لملف السجل',
  },
  'common.saveHistoryFail': {
    zh: '保存历史文件失败',
    en: 'Failed to save the history file',
    id: 'Gagal menyimpan file historis',
    kz: 'Тарих файлын сақтау сәтсіз аяқталды',
    th: 'ไม่สามารถบันทึกไฟล์ประวัติศาสตร์',
    ug: 'تارىخىي ھۆججەت ساقلاش مەغلۇپ بولدى',
    vi: 'Lưu lịch sử tệp thất bại',
    zh_tc: '保存歷史文件失敗',
    ru: 'Ошибка сохранения исторического файла',
    ko: '히스토리 파일을 저장하지 못했습니다.',
    bur: 'မှတ်တမ်းဖိုင်သိမ်းဆည်းမှုမအောင်မြင်',
    ben: 'ইতিহাস ফাইল সংরক্ষণ ব্যর্থ হয়েছে',
    tr: 'Geçmiş dosyası kaydedilemedi',
    km: 'រក្សាទុកឯកសារប្រវត្តិបរាជ័យ',
    es: 'No se pudo guardar el archivo de historial',
    ar: 'فشل في حفظ ملف السجل',
  },
  'common.bw': {
    zh: '是否导出黑白标签',
    en: 'Whether to export black and white labels',
    id: 'Apakah akan mengekspor label hitam putih',
    kz: 'Қара-ақ жапсырмаларды экспорттаудың орындылығы',
    th: 'ไม่ว่าจะส่งออกฉลากขาวดำ',
    ug: 'قارا-ئاق بېلگە چىقىرىش ئەمەسلىكىنى تاللاڭ',
    vi: 'Có xuất nhãn đen trắng không',
    zh_tc: '是否導出黑白標簽',
    ru: 'Экспорт черно - белых меток',
    ko: '흑백 태그 내보내기',
    bur: 'အမဲဖြူတံဆိပ်ထုတ်ရန်',
    ben: 'কালো ও সাদা লেবেল রপ্তানি করবেন কি',
    tr: 'Siyah beyaz etiket dışa aktarılsın mı',
    km: 'តើត្រូវនាំចេញស្លាកសខ្មៅឬទេ',
    es: 'Si se exportan etiquetas en blanco y negro',
    ar: 'ما إذا كان سيتم تصدير الملصقات بالأبيض والأسود',
  },
  'common.modular': {
    zh: '单元柜体',
    en: 'Unit cabinets',
    id: 'Kabinet unit',
    kz: 'Бөлімше шкафтары',
    th: 'ตู้',
    ug: 'بىرلىك كابىنەت',
    vi: 'Tủ đơn vị',
    zh_tc: '單元櫃體',
    ru: 'Блочный шкаф',
    ko: '유닛 캐비닛',
    bur: 'ယူနစ်ဗီရို',
    ben: 'ইউনিট ক্যাবিনেট',
    tr: 'Ünite dolabı',
    km: 'ទូឯកតា',
    es: 'Gabinete de la unidad',
    ar: 'خزانة الوحدة',
  },
  'common.autoAdjust': {
    zh: '自动调整',
    en: 'Auto-adjust',
    id: 'Penyesuaian otomatis',
    kz: 'Авто реттеу',
    th: 'การปรับอัตโนมัติ',
    ug: 'ئاپتوماتىك تەڭشەش',
    vi: 'Tự động điều chỉnh',
    zh_tc: '自動調整',
    ru: 'Автонастройка',
    ko: '자동 조정',
    bur: 'အလိုအလျောက်ညှိ',
    ben: 'স্বয়ংক্রিয় সামঞ্জস্য',
    tr: 'Otomatik ayarla',
    km: 'កែសម្រួលដោយស្វ័យប្រវត្តិ',
    es: 'Ajuste automático',
    ar: 'الضبط التلقائي',
  },
  'common.cutOrderTip': {
    zh: '检测到您的【第{errorCutOrdersString}张大板】切割顺序存在错误！请进行调整后再下载NC文件',
    en: 'An error has been detected in your 【{errorCutOrdersString} slab】 cutting order! Please make adjustments before downloading the NC file',
    id: 'Kesalahan dalam urutan pemotongan [{{errorCutordersString} sheet Anda terdeteksi! Harap lakukan penyesuaian sebelum mengunduh file NC',
    kz: '【{errorCutOrdersString}】 плитасында қате анықталды! NC файлын жүктеу алдында түзетулер енгізуіңізді сұраймын',
    th: 'ตรวจพบข้อผิดพลาดในลำดับการตัดของแผ่นงาน [{errorcutordersstring} ของคุณ]! โปรดทำการปรับเปลี่ยนก่อนดาวน์โหลดไฟล์ NC',
    ug: 'سىزنىڭ 【{errorCutOrdersString}】 چوڭ تاختىڭىزنىڭ كېسىش تەرتىپى خاتا، تەھرىرلەپ تەڭشەڭ!',
    vi: 'Một lỗi đã được phát hiện trong lệnh cắt 【{errorCutOrdersString} slab】 của bạn! Vui lòng điều chỉnh trước khi tải xuống tệp NC',
    zh_tc:
      '檢測到您的【第{errorCutOrdersString}張大板】切割順序存在錯誤！請進行調整後再下載NC文件',
    ru: 'Обнаружена ошибка в порядке резки {errorCutOrdersString} листов! Пожалуйста, внесите корректировки перед загрузкой файла NC',
    ko: '{errorCutOrdersString} 대 판의 가공 순서에 오류가 발생했습니다! NC 파일을 다운로드하기 전에 조정하세요',
    bur: 'သင်၏ 【{errorCutOrdersString}နံပါတ်ပေါ်ဒ်ကြီး】 ဖြတ်တောက်မှုအစဉ်တွင် အမှားရှိပါသည်! NC ဖိုင်ဒေါင်းလုဒ်မပြုမီ ညှိပြင်ပါ',
    ben: 'আপনার 【{errorCutOrdersString} নম্বর বড় বোর্ড】 কাটার ক্রমে ত্রুটি পাওয়া গেছে! NC ফাইল ডাউনলোডের আগে সামঞ্জস্য করুন',
    tr: '【{errorCutOrdersString}. büyük plakadaki】 kesim sıralamasında hata tespit edildi! Lütfen ayarladıktan sonra NC dosyasını indirin',
    km: 'បានរកឃើញកំហុសក្នុងលំដាប់កាត់របស់【បន្ទះធំទី {errorCutOrdersString}】! សូមកែសម្រួលសិន រួចទើបទាញយកឯកសារ NC',
    es: '¡Se ha detectado un error en su orden de corte 【第{errorCutOrdersString}张大板】! Realice ajustes antes de descargar el archivo NC',
    ar: 'تم اكتشاف خطأ في ترتيب القطع 【第{errorCutOrdersString}张大板】! يرجى إجراء التعديلات قبل تنزيل ملف NC',
  },
  'common.lockedCutOrderTip': {
    zh: '【第{errorCutOrdersString}张大板】已锁定，请前往手动修改',
    en: '【The {errorCutOrdersString} board】is locked, please go to manually modify it',
    id: '【{ErrorCutordersString} papan besar】 terkunci, silakan ubah secara manual',
    kz: '【{errorCutOrdersString}-арттық тақта】блокланды, өздіктіңіз бұлын өзгерту үшін өтіңіз',
    th: '【 {errorcutordersstring} บอร์ดขนาดใหญ่】ล็อคโปรดไปที่การแก้ไขด้วยตนเอง',
    ug: '【{errorCutOrdersString}】 چوڭ تاختا قۇلۇپلانغان، قولدا تەھرىرلەشكە يۆتكىلىڭ',
    vi: '【Khung lớn thứ {errorCutOrdersString}】đã bị khóa,vui lòng điều chỉnh thủ công',
    zh_tc: '【第{errorCutOrdersString}張大板】已鎖定，請前往手動修改',
    ru: '【{errorCutOrdersString} лист】 заблокирован, пожалуйста, перейдите вручную для его изменения',
    ko: '【{errorCutOrdersString} 대 판】이 잠겨 있습니다. 수동으로 수정하려면 이동하세요',
    bur: '【{errorCutOrdersString}নံပါတ်ပေါ်ဒ်ကြီး】 လော့ချထားပြီ၊ ကိုယ်တိုင်ပြင်ဆင်ရန်သွားပါ',
    ben: '【{errorCutOrdersString} নম্বর বড় বোর্ড】 লক করা হয়েছে, ম্যানুয়ালি সংশোধন করতে যান',
    tr: '【{errorCutOrdersString}. büyük plaka】 kilitlenmiştir, lütfen manuel olarak değiştirin',
    km: '【បន្ទះធំទី {errorCutOrdersString}】ត្រូវបានចាក់សោ សូមទៅកែប្រែដោយដៃ',
    es: '【第{errorCutOrdersString}张大板】 está bloqueado, vaya a modificación manual',
    ar: '【第{errorCutOrdersString}张大板】 مقفل، يرجى الانتقال إلى التعديل اليدوي',
  },
  'common.paibanImgCutOrderTip1': {
    zh: '检测到您的',
    en: 'Detected your',
    id: 'Mendeteksi Anda',
    kz: 'Сіздің анықтағаныңыз',
    th: 'ตรวจพบของคุณ',
    ug: 'بايقىدىڭىز',
    vi: 'Phát hiện của bạn',
    zh_tc: '檢測到您的',
    ru: 'Обнаружен ваш',
    ko: '사용자가 감지됨',
    bur: 'သင်၏',
    ben: 'আপনার',
    tr: 'Sizin',
    km: 'របស់អ្នក',
    es: '¡Se ha detectado un error en su orden de corte',
    ar: 'تم اكتشاف خطأ في أمر القطع',
  },
  'common.paibanImgCutOrderTip': {
    zh: '切割顺序存在错误！请前往排版页调整后再导出排版图文件',
    en: 'there is an error in the cutting sequence! Please go to the layout page to adjust before exporting the layout file',
    id: 'ada kesalahan dalam urutan pemotongan! Silakan pergi ke halaman penataan dan mengekspor ulang file tata letak',
    kz: 'Кесу тәртібінде қате бар! Орналасу файлын экспорттамас бұрын реттеу үшін орналасу бетіне өтіңіз',
    th: 'มีข้อผิดพลาดในลำดับการตัด! โปรดไปที่หน้าเรียงพิมพ์ที่ปรับแล้วส่งออกไฟล์แผนภูมิการพิมพ์',
    ug: 'كېسىش تەرتىپىدە خاتالىق بار! ئورۇنلاشتۇرۇش ھۆججىتىنى چىقىرىشتىن بۇرۇن ئورۇنلاشتۇرۇش بېتىگە بېرىپ تەڭشەڭ',
    vi: 'có một lỗi trong trình tự cắt! Vui lòng truy cập trang sắp chữ để điều chỉnh trước khi xuất tệp sắp chữ',
    zh_tc: '切割順序存在錯誤！ 請前往排版頁調整後再匯出排版圖檔案',
    ru: 'Ошибка в порядке резки! Перейдите на страницу набора, прежде чем экспортировать файл набора',
    ko: '가공 순서에 오류가 있습니다!레이아웃 페이지 조정 후 레이아웃 파일 내보내기',
    bur: 'ဖြတ်တောက်မှုအစဉ်တွင် အမှားရှိ! ပြင်ဆင်မှုပုံဖိုင်ထုတ်မပြုမီ ပြင်ဆင်မှုစာမျက်နှာသွားညှိပါ',
    ben: 'কাটার ক্রমে ত্রুটি আছে! লেআউট ফাইল রপ্তানির আগে লেআউট পেজে গিয়ে সামঞ্জস্য করুন',
    tr: 'Kesim sıralamasında hata var! Lütfen yerleşim sayfasına gidip ayarladıktan sonra yerleşim görsel dosyasını dışa aktarın',
    km: 'មានកំហុសក្នុងលំដាប់កាត់! សូមទៅកាន់ទំព័រប្លង់ ដើម្បីកែសម្រួលសិន ហើយបន្ទាប់មកនាំចេញឯកសាររូបភាពប្លង់',
    es: '! Vaya a la página de diseño para ajustar y luego exporte el archivo de diseño',
    ar: '! يرجى الانتقال إلى صفحة التخطيط لضبط ثم تصدير ملف التخطيط',
  },
  'common.goAdjust': {
    zh: '去调整',
    en: 'Go adjust it',
    id: 'Pergi menyesuaikan',
    kz: 'Реттеу',
    th: 'ไปปรับ',
    ug: 'تەڭشەش',
    vi: 'Đi điều chỉnh',
    zh_tc: '去調整',
    ru: 'Перейти к настройке',
    ko: '조정하다',
    bur: 'ညှိပြင်သွားပါ',
    ben: 'সামঞ্জস্য করতে যান',
    tr: 'Ayarlamaya git',
    km: 'ទៅកែសម្រួល',
    es: 'para ajustar',
    ar: 'لضبط',
  },
  'common.autoAdjustWarning': {
    zh: '当前排版结果不支持自动调整',
    en: 'The current typesetting result does not support automatic adjustment',
    id: 'Hasil tata letak saat ini tidak mendukung penyesuaian otomatis',
    kz: 'Ағымдағы типтеу нәтижесі автоматты реттеуді қолдамайды',
    th: 'ผลลัพธ์เค้าโครงปัจจุบันไม่รองรับการปรับอัตโนมัติ',
    ug: 'نۆۋەتتىكى تەرتىپلەش نەتىجىسى ئاپتوماتىك تەڭشەشكە قوللىمايدۇ',
    vi: 'Kết quả sắp chữ hiện tại không hỗ trợ điều chỉnh tự động',
    zh_tc: '當前排版結果不支持自動調整',
    ru: 'Текущий набор не поддерживает автоматическую настройку',
    ko: '현재 조판 결과는 자동 조정을 지원하지 않습니다',
    bur: 'လက်ရှိပြင်ဆင်မှုရလဒ်သည် အလိုအလျောက်ညှိကိုမပံ့ပိုး',
    ben: 'বর্তমান লেআউট ফলাফল স্বয়ংক্রিয় সামঞ্জস্য সমর্থন করে না',
    tr: 'Geçerli yerleşim sonucu otomatik ayarlamayı desteklemiyor',
    km: 'លទ្ធផលប្លង់បច្ចុប្បន្នមិនគាំទ្រការកែសម្រួលដោយស្វ័យប្រវត្តិទេ',
    es: 'El resultado del diseño actual no admite el ajuste automático',
    ar: 'نتيجة التخطيط الحالية لا تدعم الضبط التلقائي',
  },
  'common.checkNetwork': {
    zh: '请检查网络',
    en: 'Please check your network',
    id: 'Silakan periksa jaringannya',
    kz: 'Интернет байланысыңызды тексеріңіз',
    th: 'โปรดตรวจสอบเครือข่าย',
    ug: 'تورنى تەكشۈرۈڭ',
    vi: 'Vui lòng kiểm tra mạng của bạn',
    zh_tc: '請檢查網絡',
    ru: 'Проверьте сеть.',
    ko: '네트워크를 확인하십시오.',
    bur: 'ကွန်ရက်စစ်ဆေးပါ',
    ben: 'নেটওয়ার্ক পরীক্ষা করুন',
    tr: 'Lütfen ağı kontrol edin',
    km: 'សូមពិនិត្យបណ្តាញ',
    es: 'Consulte la red',
    ar: 'يرجى التحقق من الشبكة',
  },
  'common.moreInfo': {
    zh: '查看更多信息',
    en: 'See more information',
    id: 'Lihat informasi lebih lanjut',
    kz: 'Толығырақ ақпарат',
    th: 'ดูข้อมูลเพิ่มเติม',
    ug: 'تېخىمۇ كۆپ ئۇچۇرلارنى كۆرۈش',
    vi: 'Xem thêm thông tin',
    zh_tc: '查看更多信息',
    ru: 'Узнать больше',
    ko: '추가 정보 보기',
    bur: 'နောက်ထပ်သတင်းအချက်အလက်ကြည့်ပါ',
    ben: 'আরও তথ্য দেখুন',
    tr: 'Daha fazla bilgi görüntüle',
    km: 'មើលព័ត៌មានបន្ថែម',
    es: 'para obtener más información',
    ar: 'لمزيد من المعلومات',
  },
  'common.continueLayout': {
    zh: '继续排版',
    en: 'Continue layout',
    id: 'Lanjutkan mengetik',
    kz: 'Орналасуды жалғастыру',
    th: 'พิมพ์ต่อไป',
    ug: 'تەرتىپلەشنى داۋاملاشتۇرۇش',
    vi: 'Tiếp tục bố trí',
    zh_tc: '繼續排版',
    ru: 'Продолжить набор',
    ko: '조판을 계속하다',
    bur: 'ပြင်ဆင်မှုဆက်လုပ်ပါ',
    ben: 'লেআউট চালিয়ে যান',
    tr: 'Yerleşime devam et',
    km: 'បន្តប្លង់',
    es: 'Continuar con el diseño',
    ar: 'الاستمرار في التخطيط',
  },
  'common.adjustPosition': {
    zh: '调整设置',
    en: 'Adjust position',
    id: 'Sesuaikan Pengaturan',
    kz: 'Орналасуды реттеу',
    th: 'ปรับการตั้งค่า',
    ug: 'تەڭشەش ئورنى',
    vi: 'Điều chỉnh vị trí',
    zh_tc: '調整設置',
    ru: 'Настройка',
    ko: '설정 조정',
    bur: 'ဆက်တင်ညှိပါ',
    ben: 'সেটিং সামঞ্জস্য করুন',
    tr: 'Ayarları düzenle',
    km: 'កែសម្រួលការកំណត់',
    es: 'Ajustar la configuración',
    ar: 'ضبط الإعدادات',
  },
  'common.specialAndFiveSix': {
    zh: '五/六面钻加工板件异形时，开启异形嵌套可能会导致切到板件，请确认是否继续排版？',
    en: 'When processing irregular shapes with five/six-sided drilling, enabling irregular nesting may cause the board to be cut. Please confirm whether to continue the layout?',
    id: 'Saat pengeboran pada pengeboran lima/enam sisi untuk memproses pelat dengan bentuk khusus, menyalakan bentuk khusus yang dapat menyebabkan pemotongan ke pelat. Harap konfirmasi apakah akan terus mengetik?',
    kz: 'Бес/алты жақты бұрғылау арқылы тақталарды өңдеу кезінде, дұрыс емес ұя салуды қосу тақтаның кесіліп кетуіне әкелуі мүмкін. Орналасуды жалғастыруды растайсыз ба?',
    th: 'เมื่อขุดเจาะการขุดเจาะห้า/หกด้านเพื่อประมวลผลแผ่นที่มีรูปร่างพิเศษการเปิดการทำรังรูปร่างพิเศษอาจทำให้การตัดบนแผ่น โปรดยืนยันว่าจะพิมพ์ต่อไปหรือไม่?',
    ug: 'بەش/ئالتە يۈزلىك ماتور ئالاھىدە تاختىلارنى ئىشلەش جەريانىدا، ئالاھىدە تاختىلارنى قوشۇش تاختىنى كېسىشكە ئەگىشىپ قالىشى مۇمكىن، تەرتىپلەشنى داۋاملاشتۇرىسىز؟',
    vi: ' Khi gia công các tấm ván hình dạng không đều với khoan năm/sáu mặt, việc bật lồng ghép hình dạng không đều có thể khiến tấm ván bị cắt. Vui lòng xác nhận có tiếp tục bố trí không?',
    zh_tc:
      '五/六面鑽加工板件異形時，開啟異形嵌套可能會導致切到板件，請確認是否繼續排版？',
    ru: 'При фасонном оформлении листов для обработки пятигранного бурения открытие фасонной вставки может привести к резанию листов, пожалуйста, убедитесь, что типография продолжается?',
    ko: '5 / 6면 드릴링 가공 플레이트가 이형일 경우 이형 네스트를 열면 플레이트가 잘릴 수 있습니다. 레이아웃을 계속하시겠습니까?',
    bur: 'ငါး/ခြောက်မျက်နှာဖောက်ဖြင့် အထူးပုံပေါ်ဒ်ထုတ်ပြုစဉ် အထူးပုံနှင့်ပေါင်းစပ်မှုဖွင့်ပါက ပေါ်ဒ်ကိုဖြတ်မိနိုင်သည်၊ ဆက်ပြင်ဆင်မည်လားအတည်ပြုပါ?',
    ben: 'পাঁচ/ছয় মুখ ড্রিল দিয়ে বিশেষ আকারের বোর্ড প্রক্রিয়া করার সময় বিশেষ আকার নেস্টিং চালু করলে বোর্ড কাটা যেতে পারে, লেআউট চালিয়ে যেতে নিশ্চিত করবেন কি?',
    tr: 'Beş/altı yüzlü delme ile özel şekilli parça işlenirken, özel şekil iç içe yerleştirme açılırsa parçaya kesim gelebilir. Yerleşime devam etmek istediğinizi onaylıyor musunuz?',
    km: 'នៅពេលកែច្នៃបន្ទះរាងពិសេសដោយប្រើការខួងប្រាំ/ប្រាំមួយមុខ ការបើក nested រាងពិសេសអាចបណ្តាលឱ្យកាត់ទៅលើបន្ទះបាន។ សូមបញ្ជាក់ថាតើត្រូវបន្តប្លង់ឬទេ?',
    es: 'Al procesar paneles de formas especiales con perforación de cinco o seis lados, activar el anidamiento de formas especiales puede causar que el panel se corte. Por favor, confirme si desea continuar con la composición tipográfica.',
    ar: 'عند معالجة الألواح ذات الشكل الخاص بالحفر بخمسة/سداسية الجوانب، قد يؤدي تشغيل التعشيش ذو الشكل الخاص إلى قطع اللوحة. يرجى تأكيد ما إذا كنت تريد الاستمرار في التنضيد؟',
  },
  'common.plankPathErr': {
    zh: '板件内部异形数据错误,请检查是否符合刀具规格!板号【{plankIDList}】',
    en: 'Internal plank irregularity error, please check if it meets the tool specifications!【{plankIDList}】',
    id: 'Data bentuk khusus internal papan tidak benar. Silakan periksa apakah itu memenuhi spesifikasi alat! Nomor papan [{plankidlist}]',
    kz: 'Пластина ішінде дұрыс емес деректер қатесі, құралдың сипаттамаларына сәйкес келетінін тексеріңіз!【{plankIDList}】',
    th: 'ข้อมูลรูปร่างพิเศษภายในของบอร์ดไม่ถูกต้อง โปรดตรวจสอบว่าตรงตามข้อกำหนดของเครื่องมือหรือไม่! หมายเลขบอร์ด [{plankidlist}]',
    ug: 'تاختا ئىچىدىكى ئالاھىدە سانلىق مەلۇمات خاتا، قورال ئۆلچىمىگە ماس كېلىدىغانلىقىنى تەكشۈرۈڭ! تاختا نومۇرى 【{plankIDList}】',
    vi: 'Lỗi dữ liệu không đều bên trong tấm, vui lòng kiểm tra xem có phù hợp với thông số kỹ thuật của công cụ không!【{plankIDList}】',
    zh_tc: '板件內部異形數據錯誤,請檢查是否符合刀具規格!板號【{plankIDList}】',
    ru: 'Ошибка данных неправильной формы внутри плиты, пожалуйста, проверьте, соответствует ли она спецификации инструмента! 【{plankIDList}】',
    ko: '내부 플레이트 이형 데이터 오류, 도구 사양에 맞는지 확인하세요! 보드 번호 [{plankidlist}]',
    bur: 'ပေါ်ဒ်ထဲ အထူးပုံဒေတာမှားနေသည်၊ ဓားသတ်မှတ်ချက်နှင့်ကိုက်ညီမညီစစ်ဆေးပါ! ပေါ်ဒ်နံပါတ်【{plankIDList}】',
    ben: 'বোর্ডের অভ্যন্তরীণ বিশেষ আকার ডেটা ত্রুটি, টুল স্পেসিফিকেশনের সাথে মেলে কিনা পরীক্ষা করুন! বোর্ড নম্বর【{plankIDList}】',
    tr: 'Parça içindeki özel şekil verisinde hata var, lütfen alet özelliklerine uygun olup olmadığını kontrol edin! Parça no: 【{plankIDList}】',
    km: 'ទិន្នន័យរាងពិសេសខាងក្នុងបន្ទះមានកំហុស សូមពិនិត្យថាតើសមនឹងលក្ខណៈបច្ចេកទេសឧបករណ៍ឬទេ! លេខបន្ទះ【{plankIDList}】',
    es: 'Los datos internos de forma especial de la placa son incorrectos, verifique si cumple con las especificaciones de la herramienta. Número de placa 【{plankIDList}】',
    ar: 'البيانات الداخلية ذات الشكل الخاص للوحة خاطئة، يرجى التحقق مما إذا كانت تلبي مواصفات الأداة! رقم اللوحة 【{plankIDList}】',
  },
  'common.edgeCheck': {
    zh: '系统检测到存在大板的修边被修改，请重新排版确保生产准确',
    en: 'System detects that the trimming of the large board has been altered; please re-layout to ensure production accuracy',
    id: 'Sistem mendeteksi bahwa pemotongan papan besar telah diubah; silakan ulang susunan untuk memastikan akurasi produksi',
    kz: 'Система тексеруі түрде анықтады, көп бөлімдің қысқартуы өзгертілген; жүйесін жаңартыңыз, өңдеу арқылы дұрысдықты жоқыңыз',
    th: 'ระบบตรวจสอบพบว่าการตัดของแผ่นกระดานขนาดใหญ่ถูกแก้ไข โปรดจัดวางใหม่เพื่อความแม่นยำการผลิต',
    ug: 'سىستېما چوڭ تاختىلارنىڭ چىگارلىرى ئۆزگەرتكەنلىكىنى بايقىدى، ئىشلەپچىقىرىشنىڭ توغرا بولۇشى ئۈچۈن قايتا تەرتىپلەڭ',
    vi: 'Hệ thống phát hiện thay đổi trong việc cắt lát của chân khung lớn; vui lòng sắp xếp lại bố cục để đảm bảo chính xác sản xuất',
    zh_tc: '系統檢測到存在大板的修邊被修改，請重新排版確保生產準確',
    ru: 'Система обнаружила наличие больших панелей, которые были изменены, пожалуйста, переформатируйте, чтобы обеспечить точное производство',
    ko: '시스템이 대판이 존재하는 수정된 모서리를 감지하였으니, 다시 조판하여 생산이 정확한지 확인하십시오',
    bur: 'ပေါ်ဒ်ကြီး၏ ဘေးဖြတ်မှုပြင်ဆင်ထားကြောင်းစနစ်ရှာဖွေတွေ့ရသည်၊ ထုတ်လုပ်မှုတိကျမှုသေချာစေရန် ပြန်ပြင်ဆင်ပါ',
    ben: 'সিস্টেম বড় বোর্ডের ট্রিমিং পরিবর্তন সনাক্ত করেছে, উৎপাদন নির্ভুলতা নিশ্চিত করতে পুনরায় লেআউট করুন',
    tr: 'Sistem, büyük plakanın kenar düzeltmesinin değiştirildiğini algıladı. Üretim doğruluğunu sağlamak için lütfen yeniden yerleştirin',
    km: 'ប្រព័ន្ធបានរកឃើញថាការកាត់ជ្រុងរបស់បន្ទះធំត្រូវបានកែប្រែ សូមប្លង់ឡើងវិញ ដើម្បីធានាភាពត្រឹមត្រូវក្នុងការផលិត',
    es: 'El sistema ha detectado que se ha modificado el recorte de la placa grande; vuelva a diseñarlo para garantizar una producción precisa',
    ar: 'اكتشف النظام أنه تم تعديل تشذيب اللوحة الكبيرة، يرجى إعادة التخطيط لضمان دقة الإنتاج',
  },
  'common.iKnow': {
    zh: '我知道了',
    en: 'I got it',
    id: 'Saya mengerti',
    kz: 'Мен білім жасамын',
    th: 'ฉันเข้าใจแล้ว',
    ug: 'مەن بىلدىم',
    vi: 'Tôi đã hiểu rồi',
    zh_tc: '我知道了',
    ru: 'Я понял.',
    ko: '알았어',
    bur: 'သိပြီပါပြီ',
    ben: 'বুঝলাম',
    tr: 'Anladım',
    km: 'ខ្ញុំយល់ហើយ',
    es: 'Entiendo',
    ar: 'أفهم',
  },
  'common.versionErrTip': {
    zh: '请更新柜柜至最新版本!',
    en: 'Please update the cabinet to the latest version versionErrTip!',
    id: 'Silakan perbarui kabinet ke versi terbaru!',
    kz: 'Сауда автоматын соңғы нұсқасына жаңартыңыз!',
    th: 'กรุณาอัปเดตระบบตู้เป็นเวอร์ชันล่าสุด!',
    ug: 'كابىنەتنى ئەڭ يېڭى نۇسخىغا يېڭىلاڭ!',
    vi: 'Xin cập nhật nội các đến phiên bản mới nhất!',
    zh_tc: '請更新櫃櫃至最新版本!',
    ru: 'Пожалуйста, обновите шкаф до последней версии!',
    ko: '캐비닛을 최신 버전으로 업데이트하십시오!',
    bur: 'ဗီရိုဆော့ဖ်ဝဲကို နောက်ဆုံးဗားရှင်းသို့ အပ်ဒိတ်ပြုပါ!',
    ben: 'ক্যাবিনেট সফটওয়্যার সর্বশেষ সংস্করণে আপডেট করুন!',
    tr: "Lütfen Guigui'yi en son sürüme güncelleyin!",
    km: 'សូមធ្វើបច្ចុប្បន្នភាព Guigui ទៅកំណែចុងក្រោយបំផុត!',
    es: '¡Actualice el gabinete a la última versión!',
    ar: 'يرجى تحديث الخزانة إلى أحدث إصدار!',
  },
  'common.annualFeeExpired': {
    zh: '您的年费已到期，请进行续费!',
    en: 'Your annual subscription has expired, please renew!',
    id: 'Langganan tahunan Anda telah berakhir, silakan perbarui!',
    kz: 'Сіздің жылдық төлем мерзіміңіз өтіп кетті, жаңартуды өтінеміз!',
    th: 'กรุณาตรวจสอบการติดตามการชำระเงินของคุณ หากมีการชำระเงินที่ครบกำหนด กรุณาตรวจสอบการชำระเงินของคุณ หากมีการชำระเงินที่ครบกำหนด กรุณาตรวจสอบการชำระเงินของคุณ หากมีการชำระเงินที่ครบกำหนด',
    ug: 'يىللىق ھەققىڭىز ۋاقتى توشتى، تۆلەشنى داۋاملاشتۇرۇڭ!',
    vi: 'Lệ phí hàng năm của bạn đã hết hạn, xin vui lòng gia hạn!',
    zh_tc: '您的年費已到期，請進行續費!',
    ru: 'Ваш годовой сбор истек, пожалуйста, сделайте продление!',
    ko: '당신의 연회비가 이미 만기가 되었으니, 갱신하십시오!',
    bur: 'သင်၏နှစ်စဉ်ကြေးကုန်ဆုံးပြီ၊ သက်တမ်းတိုးပါ!',
    ben: 'আপনার বার্ষিক ফি মেয়াদ উত্তীর্ণ হয়েছে, অনুগ্রহ করে নবায়ন করুন!',
    tr: 'Yıllık aboneliğinizin süresi doldu, lütfen yenileyin!',
    km: 'ថ្លៃប្រចាំឆ្នាំរបស់អ្នកបានផុតកំណត់ សូមបន្តបង់!',
    es: 'Su cuota anual ha caducado, ¡renuévela!',
    ar: 'انتهت صلاحية الرسوم السنوية، يرجى التجديد!',
  },
  'common.holeEquipment': {
    zh: '打孔设备{num}',
    en: 'Drilling Equipment{num}',
    id: 'Peralatan Pengeboran {num}',
    kz: 'Бұрғылау жабдығы {num}',
    th: 'อุปกรณ์เจาะ {num}',
    ug: 'تېشىش ئۈسكۈنىسى {num}',
    vi: 'Thiết bị khoan {num}',
    zh_tc: '打孔設備{num}',
    ru: 'Сверлильное оборудование {num}',
    ko: '드릴 장비 {num}',
    bur: 'အပေါက်ဖောက်ကိရိယာ {num}',
    ben: 'ড্রিলিং যন্ত্রপাতি {num}',
    tr: 'Delme ekipmanı {num}',
    km: 'ឧបករណ៍ខួង {num}',
    es: 'Equipo de perforación {num}',
    ar: 'معدات الحفر {num}',
  },
  'common.customizedService': {
    zh: '支持定制化服务，打造您的专属生产方案',
    en: 'Support customized services to create your exclusive production plan',
    id: 'Dukung layanan yang disesuaikan untuk membuat rencana produksi eksklusif Anda',
    kz: 'Теңшелетін қызметтерді қолдау, сіздің жеке өндірістік жоспарыңызды жасаңыз',
    th: 'รองรับบริการที่กำหนดเองเพื่อสร้างแผนการผลิตเฉพาะของคุณ',
    ug: 'خاسلاشتۇرۇلغان مۇلازىمەتنى قوللاپ قويۇش، ئۆزىڭىزگە خاس ئىشلەپچىقىرىش پىلانىڭىزنى قۇرۇڭ',
    vi: 'Hỗ trợ dịch vụ tùy chỉnh để tạo kế hoạch sản xuất độc quyền của bạn',
    zh_tc: '支持定制化服務，打造您的專屬生產方案',
    ru: 'Поддержка индивидуального обслуживания, создание вашего эксклюзивного производственного решения',
    ko: '맞춤형 서비스를 지원하여 고객의 고유한 프로덕션 솔루션 구축',
    bur: 'စိတ်ကြိုက်ပြင်ဆင်မှုဝန်ဆောင်မှုပံ့ပိုး၊ သင်၏ထူးခြားသောထုတ်လုပ်မှုစီမံချက်ဖန်တီးပါ',
    ben: 'কাস্টমাইজড সেবা সমর্থন করে, আপনার বিশেষ উৎপাদন পরিকল্পনা তৈরি করুন',
    tr: 'Size özel üretim planınızı oluşturmak için özelleştirilmiş hizmetleri destekler',
    km: 'គាំទ្រសេវាកម្មប្ដូរតាមតម្រូវការ ដើម្បីបង្កើតផែនការផលិតផ្ទាល់ខ្លួនរបស់អ្នក',
    es: 'Servicios personalizados de soporte para crear su plan de producción exclusivo',
    ar: 'دعم الخدمات المخصصة لإنشاء خطة الإنتاج الحصرية الخاصة بك',
  },
  'common.exampleCombination1': {
    zh: '雕刻机+五/六面钻+侧孔机组合',
    en: 'Engraving machine + Five/Six-side drill + Side hole machine combination',
    id: 'Mesin ukir + Bor lima/enam sisi + Kombinasi mesin lubang samping',
    kz: 'Ою машинасы + Бес/алты жақты бұрғылау + Бүйірлік тесік машинасының комбинациясы',
    th: 'เครื่องแกะสลัก + เครื่องเจาะห้า/หกด้าน + การรวมเครื่องเจาะรูด้านข้าง',
    ug: 'نەقىش ماشىنىسى + بەش/ئالتە يان ماشىنىسى + يان تۆشۈك ماشىنىسىنىڭ بىرلەشمىسى',
    vi: 'Máy khắc + Máy khoan năm/sáu mặt + Kết hợp máy khoan lỗ bên',
    zh_tc: '雕刻機+五/六面鑽+側孔機組合',
    ru: 'Скульптор + пятигранное / шестигранное сверло + боковое отверстие',
    ko: '조각기 + 5/6면 드릴 + 측공기 조합',
    bur: 'နှိပ်ချပ်စက် + ငါး/ခြောက်မျက်နှာဖောက် + ဘေးပေါက်ဖောက်စက် ပေါင်းစပ်မှု',
    ben: 'খোদাই মেশিন + পাঁচ/ছয় মুখ ড্রিল + সাইড হোল মেশিন সমন্বয়',
    tr: 'Oyma makinesi + beş/altı yüzlü matkap + yan delik makinesi kombinasyonu',
    km: 'ការរួមបញ្ចូលម៉ាស៊ីនឆ្លាក់ + ម៉ាស៊ីនខួងប្រាំ/ប្រាំមួយមុខ + ម៉ាស៊ីនរន្ធចំហៀង',
    es: 'Máquina de grabado + combinación de taladro de cinco/seis lados + máquina perforadora lateral',
    ar: 'آلة النقش + مثقاب خماسي/سادسي الجوانب + مجموعة ماكينة ثقب جانبي',
  },
  'common.exampleCombination2': {
    zh: '电子锯+五/六面钻+侧孔机组合',
    en: 'Electronic saw + Five/Six-side drill + Side hole machine combination',
    id: 'Gergaji elektronik + Bor lima/enam sisi + Kombinasi mesin lubang samping',
    kz: 'Электрондық ара + Бес/алты жақты бұрғылау + Бүйірлік тесік машинасының комбинациясы',
    th: 'เลื่อยไฟฟ้า + เครื่องเจาะห้า/หกด้าน + การรวมเครื่องเจาะรูด้านข้าง',
    ug: 'ئېلېكتر ئەر + بەش/ئالتە يان ماشىنىسى + يان تۆشۈك ماشىنىسىنىڭ بىرلەشمىسى',
    vi: 'Cưa điện + Máy khoan năm/sáu mặt + Kết hợp máy khoan lỗ bên',
    zh_tc: '電子鋸+五/六面鑽+側孔機組合',
    ru: 'Электронная пила + пятигранное / шестигранное сверло + боковое отверстие',
    ko: '전자톱 + 5/6면 드릴 + 측공기 조합',
    bur: 'ဓားပုတ်မြောင်းစက် + ငါး/ခြောက်မျက်နှာဖောက် + ဘေးပေါက်ဖောက်စက် ပေါင်းစပ်မှု',
    ben: 'ইলেকট্রনিক করাত + পাঁচ/ছয় মুখ ড্রিল + সাইড হোল মেশিন সমন্বয়',
    tr: 'Elektronik testere + beş/altı yüzlü matkap + yan delik makinesi kombinasyonu',
    km: 'ការរួមបញ្ចូលម៉ាស៊ីនកាត់អេឡិចត្រូនិក + ម៉ាស៊ីនខួងប្រាំ/ប្រាំមួយមុខ + ម៉ាស៊ីនរន្ធចំហៀង',
    es: 'Sierra electrónica + combinación de taladro de cinco/seis lados + máquina perforadora lateral',
    ar: 'منشار إلكتروني + مثقاب خماسي/سداسي الجوانب + مجموعة ماكينة ثقب جانبي',
  },
  'common.exampleCombination3': {
    zh: '全自动一体生产线+五/六面钻组合',
    en: 'Fully automatic integrated production line + Five/Six-side drill combination',
    id: 'Lini produksi terintegrasi otomatis penuh + Kombinasi bor lima/enam sisi',
    kz: 'Толық автоматты біріктірілген өндірістік желі + Бес/алты жақты бұрғылау комбинациясы',
    th: 'สายการผลิตแบบบูรณาการอัตโนมัติเต็มรูปแบบ + การรวมเครื่องเจาะห้า/หกด้าน',
    ug: 'پۈتۈنلەي ئاپتوماتىك بىرلەشتۈرۈلگەن ئىشلەپچىقىرىش لىنىيىسى + بەش/ئالتە يان ماشىنىسىنىڭ بىرلەشمىسى',
    vi: 'Dây chuyền sản xuất tích hợp tự động hoàn toàn + Kết hợp máy khoan năm/sáu mặt',
    zh_tc: '全自動一體生產線+五/六面鑽組合',
    ru: 'Полностью автоматизированная производственная линия + пятигранная / шестигранная буровая комбинация',
    ko: '전자동 일체형 생산라인 + 5/6면 드릴 조합',
    bur: 'အပြည့်အဝအလိုအလျောက်ထုတ်လုပ်မှုလိုင်း + ငါး/ခြောက်မျက်နှာဖောက် ပေါင်းစပ်မှု',
    ben: 'সম্পূর্ণ স্বয়ংক্রিয় সমন্বিত উৎপাদন লাইন + পাঁচ/ছয় মুখ ড্রিল সমন্বয়',
    tr: 'Tam otomatik entegre üretim hattı + beş/altı yüzlü matkap kombinasyonu',
    km: 'ការរួមបញ្ចូលខ្សែផលិតកម្មស្វ័យប្រវត្តិពេញលេញ + ម៉ាស៊ីនខួងប្រាំ/ប្រាំមួយមុខ',
    es: 'Línea de producción integrada completamente automática + combinación de taladro de cinco/seis lados',
    ar: 'خط إنتاج متكامل أوتوماتيكي بالكامل + مجموعة مثقاب خماسي/سادسي',
  },
  'common.feedback': {
    zh: '可以直接向您的柜柜软件销售或售后人员反馈您的需求',
    en: 'You can directly provide your requirements to the Guigui software sales or after-sales service staff',
    id: 'Anda dapat langsung memberikan kebutuhan Anda kepada penjualan perangkat lunak Guigui atau staf layanan purna jual',
    kz: 'Сіз өзіңіздің қажеттіліктеріңізді Guigui бағдарламалық жасақтамасының сатушысына немесе сатудан кейінгі қызмет көрсету қызметкеріне тікелей хабарлай аласыз',
    th: 'คุณสามารถแจ้งความต้องการของคุณโดยตรงกับฝ่ายขายซอฟต์แวร์ Guigui หรือเจ้าหน้าที่บริการหลังการขาย',
    ug: 'ئىھتىياجىڭىزنى بىۋاسىتە گۇيگۇي يۇمشاق دېتال سېتىش ياكى ساتقاندىن كېيىنكى مۇلازىمەت خادىملىرىغا بىلدۈرەلەيسىز',
    vi: 'Bạn có thể trực tiếp cung cấp yêu cầu của mình cho nhân viên bán hàng hoặc nhân viên dịch vụ sau bán hàng của phần mềm Guigui',
    zh_tc: '可以直接向您的櫃櫃軟件銷售或售後人員反饋您的需求',
    ru: 'Вы можете напрямую сообщить о своих потребностях продавцу программного обеспечения или послепродажному персоналу.',
    ko: '귀하의 캐비닛 소프트웨어 판매 또는 판매 후 직원에게 귀하의 요구를 직접 피드백할 수 있습니다.',
    bur: 'သင်၏လိုအပ်ချက်ကို Guigui ဆော့ဖ်ဝဲရောင်းချသူ သို့မဟုတ် ဝန်ဆောင်မှုဝန်ထမ်းသို့တိုက်ရိုက်အကြောင်းကြားနိုင်သည်',
    ben: 'আপনার প্রয়োজনীয়তা সরাসরি Guigui সফটওয়্যার বিক্রয় বা বিক্রয়োত্তর সেবা কর্মীদের কাছে জানাতে পারেন',
    tr: 'İhtiyaçlarınızı doğrudan Guigui yazılım satış veya satış sonrası personeline iletebilirsiniz',
    km: 'អ្នកអាចផ្តល់តម្រូវការរបស់អ្នកដោយផ្ទាល់ទៅបុគ្គលិកផ្នែកលក់ ឬបន្ទាប់ពីលក់របស់កម្មវិធី Guigui',
    es: 'Puede informar directamente sus necesidades al personal de ventas o posventa del software de su gabinete',
    ar: 'يمكنك تقديم تعليقات مباشرة على احتياجاتك إلى موظفي مبيعات برامج الخزانة أو موظفي ما بعد البيع لديك',
  },
  'common.markModifiedBoards': {
    zh: '标识修改过的小板',
    en: 'Mark modified small boards',
    id: 'Tandai papan kecil yang dimodifikasi',
    kz: 'Өзгертілген шағын тақталарды белгілеу',
    th: 'ระบุแผ่นเล็กที่แก้ไขแล้ว',
    ug: 'تەھرىرلەنگەن كىچىك تاختىلارنى بەلگىلەش',
    vi: 'Đánh dấu các tấm nhỏ đã được sửa đổi',
    zh_tc: '標識修改過的小板',
    ru: 'Измененная табличка',
    ko: '수정된 보드를 식별합니다.',
    bur: 'ပြင်ဆင်ထားသောပေါ်ဒ်ငယ်ကိုမှတ်သားပါ',
    ben: 'পরিবর্তিত ছোট বোর্ড চিহ্নিত করুন',
    tr: 'Değiştirilen küçük plakaları işaretle',
    km: 'សម្គាល់បន្ទះតូចដែលបានកែប្រែ',
    es: 'Mark el tablero pequeño modificado',
    ar: 'وضع علامة على السبورة الصغيرة المعدلة',
  },
  'common.showMoveStep': {
    zh: '自定义键盘移动步长',
    en: 'Custom keyboard move step',
    id: 'Atur langkah gerakan keyboard',
    kz: 'Жобалау клавиатурасын қозғалыс қадамын белгілеу',
    th: 'ตั้งค่าขั้นตอนการย้ายคีย์บอร์ด',
    ug: 'تېشىك چىقىرىش قۇرىلىقىنى بەلگىلەش',
    vi: 'Đặt bước di chuyển bàn phím',
    zh_tc: '自定義鍵盤移動步長',
    ru: 'Настраивать шаг движения клавиатуры',
    ko: '키보드 이동 단계 설정',
    bur: 'ငိုင်းကူးကိုက်လိုက်ကိုက်အောင်မြင်စွာဖောင့်ပါ',
    ben: 'কীবোর্ড চালিয়ে যাওয়া ধাপ নির্দিষ্ট করুন',
    tr: 'Klavye hareket adımını belirle',
    km: 'កែប្រែការវិញ្ញាណិតការផ្លាស់ប្តូរ',
    es: 'Establecer paso de movimiento del teclado',
    ar: 'تحديد خطوة التحريك على لوحة المفاتيح',
  },
  'common.moveStep': {
    zh: '键盘移动步长',
    en: 'Keyboard move step',
    id: 'Langkah gerakan keyboard',
    kz: 'Жобалау клавиатурасын қозғалыс қадамы',
    th: 'ขั้นตอนการย้ายคีย์บอร์ด',
    ug: 'تېشىك چىقىرىش قۇرىلىقى',
    vi: 'Bước di chuyển bàn phím',
    zh_tc: '鍵盤移動步長',
    ru: 'Шаг движения клавиатуры',
    ko: '키보드 이동 단계',
    bur: 'ငိုင်းကူးကိုက်လိုက်ကိုက်အောင်မြင်စွာဖောင့်ပါ',
    ben: 'কীবোর্ড চালিয়ে যাওয়া ধাপ',
    tr: 'Klavye hareket adımı',
    km: 'ការផ្លាស់ប្តូរការវិញ្ញាណិត',
    es: 'Paso de movimiento del teclado',
    ar: 'خطوة التحريك على لوحة المفاتيح',
  },
  'common.existChangeBoards': {
    zh: '存在变更的小板',
    en: 'There are changed small boards',
    id: 'Ada papan kecil yang berubah',
    kz: 'Өзгертілген шағын тақталар бар',
    th: 'มีแผ่นเล็กที่เปลี่ยนแปลง',
    ug: 'ئۆزگەرتىلگەن كىچىك تاختىلار مەۋجۇت',
    vi: 'Өзгертілген шағын тақталар бар',
    zh_tc: '存在變更的小板',
    ru: 'Существуют видоизмененные панели',
    ko: '변경된 보드가 있습니다.',
    bur: 'ပြောင်းလဲမှုရှိသောပေါ်ဒ်ငယ်ရှိပါသည်',
    ben: 'পরিবর্তিত ছোট বোর্ড আছে',
    tr: 'Değişiklik bulunan küçük plakalar var',
    km: 'មានបន្ទះតូចដែលមានការផ្លាស់ប្តូរ',
    es: 'Placas pequeñas cambiadas',
    ar: 'لوحات صغيرة تم تغييرها',
  },
  'common.crossMaterialBoard': {
    zh: '跨材质颜色小板',
    en: 'Cross-material color board',
    id: 'Papan silang material & warna',
    kz: 'Материал-түс аралас тақта',
    th: 'แผ่นเล็กข้ามวัสดุและสี',
    ug: 'ماتېرىيال ۋە رەڭدىن ھالقىغان كىچىك تاختا',
    vi: 'Bảng xuyên vật liệu màu',
    zh_tc: '跨材質顏色小板',
    ru: 'Панель другого материала/цвета',
    ko: '다른 재질·색상 보드',
    bur: 'ဖြတ်ကျော်ပစ္စည်းနှင့် အရောင်ဘုတ်',
    ben: 'ক্রস-ম্যাটেরিয়াল রঙ বোর্ড',
    tr: 'Çapraz malzeme-renk plakası',
    km: 'ក្តារឆ្លងសម្ភារៈពណ៌',
    es: 'Tablero cruzado material-color',
    ar: 'لوحة عبر المواد والألوان',
  },
  'common.skipCrossMaterialTip': {
    zh: '本次排版不再提示',
    en: "Don't show again for this layout",
    id: 'Jangan tampilkan lagi untuk layout ini',
    kz: 'Бұл орналасымда қайталап көрсетпеу',
    th: 'ไม่ต้องแจ้งอีกในการจัดวางนี้',
    ug: 'بۇ ئورۇنلاشتۇرۇلۇشتا قايتا كۆرسەتمەڭ',
    vi: 'Không hiển thị lại trong lần sắp xếp này',
    zh_tc: '本次排版不再提示',
    ru: 'Не показывать снова для этой раскладки',
    ko: '이번 배치에서 다시 표시하지 않기',
    bur: 'ဤအထွက်တွင် နောက်တစ်ကြိမ် မပြသပါ',
    ben: 'এই বিন্যাসে আর দেখাবেন না',
    tr: 'Bu düzende bir daha gösterme',
    km: 'មិនបង្ហាញម្តងទៀតក្នុងការរៀបចំនេះ',
    es: 'No mostrar de nuevo en este diseño',
    ar: 'عدم الإظهار مرة أخرى في هذا التخطيط',
  },
  'common.crossMaterialConfirmTip': {
    zh: '您目前正在跨不同材质或颜色挪动小板，{highlight}，是否继续完成挪动？',
    en: 'You are currently moving a small board across different materials or colors. {highlight} Continue?',
    id: 'Anda sedang memindahkan papan kecil melintasi material atau warna yang berbeda. {highlight} Lanjutkan?',
    kz: 'Сіз қазір кіші тақтаны әртүрлі материал немесе түс арқылы жылжытып жатырсыз. {highlight} Жалғастырасыз ба?',
    th: 'คุณกำลังย้ายแผ่นเล็กข้ามวัสดุหรือสีที่แตกต่าง {highlight} ดำเนินการต่อ?',
    ug: 'سىز ھازىر ئوخشىمىغان ماتېرىيال ياكى رەڭدىن ھالقىپ كىچىك تاختا يۆتكەۋاتىسىز، {highlight}، داۋاملاشتۇرامسىز؟',
    vi: 'Bạn đang di chuyển bảng nhỏ qua vật liệu hoặc màu sắc khác nhau. {highlight} Tiếp tục?',
    zh_tc:
      '您目前正在跨不同材質或顏色挪動小板，{highlight}，是否繼續完成挪動？',
    ru: 'Вы перемещаете малую панель через разные материалы или цвета. {highlight} Продолжить?',
    ko: '다른 재질이나 색상으로 소형 보드를 이동하고 있습니다. {highlight} 계속하시겠습니까?',
    bur: 'သင်သည် မတူညီးသော ပစ္စည်းများ သို့မဟုတ် အရောင်များဖြတ်ကျော်၍ အသေးစားဘုတ်ကို ရွှေ့နေသည်။ {highlight} ဆက်လုပ်မလား?',
    ben: 'আপনি বর্তমানে ভিন্ন উপাদান বা রঙের মধ্য দিয়ে ছোট বোর্ড সরাচ্ছেন। {highlight} চালিয়ে যাবেন?',
    tr: 'Farklı malzeme veya renkler arasında küçük bir levha taşıyorsunuz. {highlight} Devam edilsin mi?',
    km: 'អ្នកកំពុងផ្លាស់ទីក្តារតូចឆ្លងកាត់សម្ភារៈឬពណ៌ខុសគ្នា។ {highlight} បន្ត?',
    es: 'Está moviendo una tabla pequeña entre diferentes materiales o colores. {highlight} ¿Continuar?',
    ar: 'أنت حاليًا نقل لوحة صغيرة عبر مواد أو ألوان مختلفة. {highlight} هل تريد المتابعة؟',
  },
  'common.crossMaterialConfirmTipHighlight': {
    zh: '挪动后生产出的小板可能和拆单的小板材质颜色不一致',
    en: 'The produced board may have inconsistent material/color with the split order',
    id: 'Papan yang dihasilkan mungkin tidak konsisten dengan pesanan split',
    kz: 'Шығарылған тақта бөлінген тапсырыспен сәйкес келмеуі мүмкін',
    th: 'แผ่นที่ผลิตอาจไม่ตรงกับวัสดุ/สีของคำสั่งแยก',
    ug: 'يۆتكەلگەندىن كېيىن ئىشلەپچىقىرىلغان تاختا بىلەن پارچىلاش بۇيرۇقىنىڭ ماتېرىيال رەڭگى بىردەك بولماسلىقى مۇمكىن',
    vi: 'Bảng được sản xuất có thể không nhất quán với đơn hàng tách',
    zh_tc: '挪動後生產出的小板可能和拆單的小板材質顏色不一致',
    ru: 'Произведенная панель может не совпадать с материалом/цветом разделенного заказа',
    ko: '생산된 보드가 분할 주문의 재질/색상과 일치하지 않을 수 있습니다',
    bur: 'ထုတ်လုပ်ထားသော ဘုတ်သည် ခွဲခြမ်းစာတမ်းနှင့် မကိုက်ညီဖြစ်နိုင်သည်',
    ben: 'উৎপাদিত বোর্ড বিভক্ত অর্ডারের সাথে অসঙ্গতিপূর্ণ হতে পারে',
    tr: 'Üretilen levha bölünmüş siparişle tutarsız olabilir',
    km: 'ក្តារដែលផលិតអាចមិនត្រូវនឹងការបំបែកការបញ្ជាទិញ',
    es: 'La tabla producida puede ser inconsistente con el pedido dividido',
    ar: 'قد لا تتطابق اللوحة المنتجة مع أمر التقسيم',
  },
  'common.exportHoleSlotPDF': {
    zh: '导出孔槽图',
    en: 'Export hole and slot diagram',
    id: 'Ekspor Gambar Slot',
    kz: 'Тесіктер мен ойықтардың сызбасын экспорттау',
    th: 'ส่งออกแผนภูมิช่องหลุม',
    ug: 'تېشىك-ئويۇق چىزمىسىنى ئېكسپورت قىلىش',
    vi: 'Xuất khẩu sơ đồ khe lỗ',
    zh_tc: '導出孔槽圖',
    ru: 'Рисунок выходного отверстия',
    ko: '구멍 슬롯 그림 내보내기',
    bur: 'ပေါက်ကြိုးဇယားထုတ်ပါ',
    ben: 'গর্ত-স্লট চিত্র রপ্তানি করুন',
    tr: 'Delik ve kanal diyagramını dışa aktar',
    km: 'នាំចេញគំនូសរន្ធ និងស្លុត',
    es: 'Exportar diagrama de ranura de orificios',
    ar: 'مخطط فتحة ثقب التصدير',
  },
  'common.pdfFormat': {
    zh: 'PDF格式',
    en: 'PDF Format',
    id: 'Format PDF',
    kz: 'PDF форматы',
    th: 'รูปแบบ PDF',
    ug: 'PDF فورماتى',
    vi: 'Định dạng PDF',
    zh_tc: 'PDF格式',
    ru: 'Формат PDF',
    ko: 'PDF 형식',
    bur: 'PDF ဖော်မတ်',
    ben: 'PDF ফরম্যাট',
    tr: 'PDF biçimi',
    km: 'ទ្រង់ទ្រាយ PDF',
    es: 'Formato PDF',
    ar: 'تنسيق PDF',
  },
  'common.dxfFormat': {
    zh: 'DXF格式',
    en: 'DXF Format',
    id: 'Format DXF',
    kz: 'DXF форматы',
    th: 'รูปแบบ DXF',
    ug: 'DXF فورماتى',
    vi: 'Định dạng DXF',
    zh_tc: 'DXF格式',
    ru: 'Формат DXF',
    ko: 'DXF 형식',
    bur: 'DXF ဖော်မတ်',
    ben: 'DXF ফরম্যাট',
    tr: 'DXF biçimi',
    km: 'ទ្រង់ទ្រាយ DXF',
    es: 'Formato DXF',
    ar: 'تنسيق DXF',
  },
  'common.specialShapeKnivesInfo': {
    zh: '异形选刀提示',
    en: 'Cutting Tool Settings',
    id: 'Pengaturan alat pemotongan',
    kz: 'Бұрғылау жабдықтарын таңдау',
    th: 'การตั้งค่าอุปกรณ์ตัด',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Cài đặt công cụ cắt',
    zh_tc: '異形選刀提示',
    ru: 'Экзотический выбор ножей',
    ko: '이형 선택 팁',
    bur: 'အထူးပုံဓားရွေးချယ်မှုအကြောင်းကြားချက်',
    ben: 'বিশেষ আকারের কাটিং টুল সেটিং',
    tr: 'Özel şekil bıçak seçimi uyarısı',
    km: 'ការជូនដំណឹងជ្រើសរើសកាំបិតរាងពិសេស',
    es: 'Consejos de selección de herramientas con formas especiales',
    ar: 'نصائح حول اختيار الأداة ذات الشكل الخاص',
  },
  'common.specialShapeKnivesInfoTips': {
    zh: '第{stockNum}块板件:',
    en: 'Small board {stockNum}:',
    id: 'Papan kecil {stockNum}:',
    kz: 'Шағын тақта {stockNum}:',
    th: 'แผ่นเล็ก {stockNum}:',
    ug: 'كىچىك تاختى {stockNum}:',
    vi: 'Tấm nhỏ {stockNum}:',
    zh_tc: '第{stockNum}塊板件:',
    ru: 'Панель {stockNum}:',
    ko: '보드 {stockNum}:',
    bur: '{stockNum} နံပါတ်ပေါ်ဒ်:',
    ben: '{stockNum} নম্বর বোর্ড:',
    tr: '{stockNum}. parça:',
    km: 'បន្ទះទី {stockNum}:',
    es: '{stockNum} parte de la placa:',
    ar: '{stockNum} جزء اللوحة:',
  },
  'common.specialShapeKnivesInfoTips2': {
    zh: '开启了异形自动选择刀具，排版数据异常，请从开料清单重新排版，或者关闭异形自动选刀功能',
    en: 'The automatic selection of cutting tools has been enabled, the layout data is abnormal, please re-layout from the cutting list, or disable the automatic selection of cutting tools',
    id: 'Pengaturan alat pemotongan otomatis telah diaktifkan, data tata letak tidak normal, silakan lakukan penyesuaian ulang dari daftar pemotongan, atau nonaktifkan pengaturan alat pemotongan otomatis',
    kz: 'Бұрғылау жабдықтарын таңдау режимі қосылған, тақталардың орналасуы дұрыс емес, қайта орналастыруды қайталаңыз немесе бұрғылау жабдықтарын таңдау режимін өшіріңіз',
    th: 'การตั้งค่าอุปกรณ์ตัดอัตโนมัติได้เปิดใช้งานแล้ว ข้อมูลการจัดวางตำแหน่งไม่ถูกต้อง โปรดปรับเปลี่ยนจากรายการตัดอีกครั้ง หรือปิดการตั้งค่าอุปกรณ์ตัดอัตโนมัติ',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى ئىشلەتكىلى بولغاندىن كېيىن، تاختىلارنىڭ ئورنى ئۆزگەرتىلگەن، ياكى تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسىنى ئەڭ يېڭىلاڭ',
    vi: 'Đã bật chức năng tự động chọn công cụ cắt, dữ liệu bố trí không hợp lệ, vui lòng điều chỉnh lại từ danh sách cắt hoặc tắt chức năng tự động chọn công cụ cắt',
    zh_tc:
      '開啟了異形自動選擇刀具，排版數據異常，請從開料清單重新排版，或者關閉異形自動選刀功能',
    ru: 'Включите инструмент автоматического выбора фасона, данные набора ненормальные, пожалуйста, переформатируйте из открытого списка или отключите функцию автоматического выбора фасона',
    ko: '이형 자동 선택 공구가 켜져 있고 레이아웃 데이터가 이상하므로 BOM에서 재레이아웃하거나 이형 자동 선택 기능을 해제하십시오.',
    bur: 'အထူးပုံအလိုအလျောက်ဓားရွေးချယ်မှုဖွင့်ထားပြီး ပြင်ဆင်မှုဒေတာမမှန်ကန်ပါ၊ ဖြတ်တောက်စာရင်းမှ ပြန်ပြင်ဆင်ပါ သို့မဟုတ် အထူးပုံဓားအလိုအလျောက်ရွေးချယ်မှုပိတ်ပါ',
    ben: 'বিশেষ আকারের স্বয়ংক্রিয় কাটিং টুল নির্বাচন চালু আছে, লেআউট ডেটা অস্বাভাবিক, কাটার তালিকা থেকে পুনরায় লেআউট করুন বা স্বয়ংক্রিয় টুল নির্বাচন বন্ধ করুন',
    tr: 'Özel şekil için otomatik takım seçimi açıldı, yerleşim verisi anormal. Lütfen kesim listesinden yeniden yerleştirin veya özel şekil için otomatik takım seçimini kapatın',
    km: 'បានបើកការជ្រើសរើសឧបករណ៍កាត់រាងពិសេសដោយស្វ័យប្រវត្តិ ទិន្នន័យប្លង់មានភាពមិនប្រក្រតី សូមប្លង់ឡើងវិញពីបញ្ជីកាត់ ឬបិទមុខងារជ្រើសរើសឧបករណ៍កាត់ស្វ័យប្រវត្តិសម្រាប់រាងពិសេស',
    es: 'La selección automática de herramientas con formas especiales está activada, los datos de diseño son anormales, vuelva a diseñar desde la lista de materiales o desactive la función de selección automática de herramientas con formas especiales',
    ar: 'يتم تشغيل التحديد التلقائي للأداة ذات الشكل الخاص، وبيانات التخطيط غير طبيعية، يرجى إعادة التخطيط من قائمة المواد، أو إيقاف تشغيل وظيفة التحديد التلقائي للأداة ذات الشكل الخاص',
  },
  'common.default': {
    zh: '默认',
    en: 'Default',
    id: 'Pengaturan default',
    kz: 'Бастапқы',
    th: 'การพิมพ์ดีดคลาวด์',
    ug: 'بۇلۇت تەرتىپلىگۈچ',
    vi: 'Mặc định',
    zh_tc: '預設',
    ru: 'по умолчанию',
    ko: '기본',
    bur: 'မူလ',
    ben: 'ডিফল্ট',
    tr: 'Varsayılan',
    km: 'លំនាំដើម',
    es: 'Predeterminado',
    ar: 'الافتراضي',
  },
  'common.exportLanguage': {
    zh: '导出语言',
    en: 'Export language type',
    id: 'Bahasa Ekspor',
    kz: 'Экспорт тілі',
    th: 'ภาษาส่งออก',
    ug: 'چىقىرىش تىلى',
    vi: 'Ngôn ngữ xuất',
    zh_tc: '匯出語言',
    ru: 'Язык экспорта',
    ko: '언어 내보내기',
    bur: 'ထုတ်ပြည်ဘာသာစကား',
    ben: 'রপ্তানি ভাষা',
    tr: 'Dışa aktarma dili',
    km: 'ភាសានាំចេញ',
    es: 'Idioma de exportación',
    ar: 'لغة التصدير',
  },
  'common.exportLanguageTip': {
    zh: '注意：部分文字信息导出pdf无法翻译',
    en: 'Attention: Some text elements cannot be translated when exported to PDF.',
    id: 'Catatan: Beberapa elemen teks tidak dapat diterjemahkan saat diekspor ke PDF.',
    kz: 'Ескерту: PDF түрінде шығарған кезде кейбір мәтін элементтерін аудару мүмкін емес.',
    th: 'หมายเหตุ: องค์ประกอบข้อความบางส่วนไม่สามารถแปลได้เมื่อส่งออกเป็น PDF',
    ug: 'ئەسكەرتىش: PDF قا چىقارغاندا، بەزى تېكىست ئېلېمېنتلىرىنى تەرجىمە قىلالمايدۇ.',
    vi: 'Lưu ý: Một số thành phần văn bản không thể dịch khi xuất sang PDF.',
    zh_tc: '注意：部分文字內容在導出PDF時無法翻譯',
    ru: 'Примечание: часть текстовой информации экспортируется в pdf не может быть переведена',
    ko: '참고: 일부 텍스트 정보 내보내기 pdf를 번역할 수 없습니다.',
    bur: 'သတိ: PDF ထုတ်ပြည်တွင် စာသားတချို့ကိုဘာသာမပြန်နိုင်',
    ben: 'নোট: PDF রপ্তানিতে কিছু টেক্সট অনুবাদ করা যাবে না',
    tr: 'Not: Bazı metin bilgiler PDF olarak dışa aktarılırken çevrilemez',
    km: 'ចំណាំ៖ ខ្លឹមសារអត្ថបទខ្លះ មិនអាចបកប្រែបាននៅពេលនាំចេញជា PDF',
    es: 'Nota: Parte de la información de texto no se puede traducir cuando se exporta a pdf',
    ar: 'ملاحظة: لا يمكن ترجمة بعض المعلومات النصية عند تصديرها إلى pdf',
  },
  'common.highGlossNameTip': {
    zh: '从柜柜同步的高光板可以被描述为其他文案，不影响其高光属性',
    en: 'The high-gloss panels synchronized from the cabinet can be described with other copy without affecting their high-gloss properties.',
    id: 'Panel kilap tinggi yang disinkronkan dari kabinet dapat dideskripsikan dengan teks lain tanpa memengaruhi sifat kilap tingginya.',
    kz: 'Шкафтан синхрондалған жалтыр тақталар басқа мәтінмен сипатталуы мүмкін, бірақ олардың жалтыр қасиеттері өзгермейді.',
    th: 'แผ่นไฮไลต์ที่ซิงค์จากตู้สามารถอธิบายด้วยข้อความอื่นได้โดยไม่影響คุณสมบัติไฮไลต์ของมัน',
    ug: 'كابىنەتتىن سىنخرونلاشقان يورۇق تاختىلار باشقا تېكىست بىلەن سۈپەتلەنسىمۇ بولىدۇ، ئۇلارنىڭ يورۇق خۇسۇسىيىتىگە تەسىر كۆرسەتمەيدۇ.',
    vi: 'Các tấm bóng cao cấp được đồng bộ từ tủ có thể được mô tả bằng văn bản khác mà không ảnh hưởng đến đặc tính bóng cao của chúng.',
    zh_tc: '從櫃櫃同步的高光板可以被描述為其他文案，不影響其高光屬性',
    ru: 'Высокие световые панели, синхронизированные из шкафа, могут быть описаны как другие копии, не влияющие на их свойства высокого света',
    ko: '캐비닛에서 동기화된 하이라이트 패널은 하이라이트 속성에 영향을 주지 않고 다른 문서로 설명될 수 있습니다.',
    bur: 'ဗီရိုမှ Sync လုပ်ထားသောဟိုင်းဂလော့ပေါ်ဒ်ကို အခြားစာသားဖြင့်ဖော်ပြနိုင်သည်၊ ဟိုင်းဂလော့ဂုဏ်သတ္တိကိုမထိခိုက်',
    ben: 'ক্যাবিনেট থেকে সিঙ্ক করা হাই-গ্লস বোর্ড অন্য টেক্সট দিয়ে বর্ণনা করা যেতে পারে, হাই-গ্লস বৈশিষ্ট্য প্রভাবিত হবে না',
    tr: 'Dolaptan senkronize edilen parlak paneller başka metinlerle açıklanabilir; bu, parlaklık özelliğini etkilemez',
    km: 'បន្ទះរលោងខ្ពស់ដែលសមកាលកម្មពីទូ អាចត្រូវបានពិពណ៌នាដោយអត្ថបទផ្សេងៗ ដោយមិនប៉ះពាល់ដល់លក្ខណៈរលោងរបស់វា',
    es: 'El tablero de resaltado sincronizado desde el gabinete se puede describir como otra escritura, lo que no afecta sus atributos de resaltado',
    ar: 'يمكن وصف لوحة التمييز التي تمت مزامنتها من الخزانة بأنها كتابة نصوص أخرى، مما لا يؤثر على سمات التمييز الخاصة بها',
  },
  'common.mixPaibanPlanSetting': {
    zh: '混排方案设置',
    en: 'Mix Paiban Plan Setting',
    id: 'Pengaturan Tata Letak Campuran',
    kz: 'Бұрғылау жоспарын орнату',
    th: 'การตั้งค่าการจัดวางตำแหน่งผสม',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسىنى تەڭشەش',
    vi: 'Bố trí hỗn hợp chương trình',
    zh_tc: '混排方案設置',
    ru: 'Параметры смешанной схемы',
    ko: '혼합 배열 시나리오 설정',
    bur: 'ပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်သတ်မှတ်ချက်',
    ben: 'মিশ্র লেআউট পরিকল্পনা সেটিং',
    tr: 'Karışık yerleşim planı ayarı',
    km: 'ការកំណត់ផែនការប្លង់ចម្រុះ',
    es: 'Configuración del plan de mezcla',
    ar: 'إعدادات خطة الخلط',
  },
  'common.mixPaibanPlanSettingTip': {
    zh: '系统检测混排方案设置发生改变，请重新选择本次混排方案！',
    en: 'System detected that the mix paiban plan setting has changed, please re-select the current mix paiban plan!',
    id: 'Sistem mendeteksi bahwa pengaturan tata letak campuran telah berubah, silakan pilih ulang tata letak campuran saat ini!',
    kz: 'Бұрғылау жоспарын орнату өзгертілген, өзіңіздің бұрғылау жоспарын таңдаңыз!',
    th: 'ระบบตรวจสอบว่าการตั้งค่าการจัดวางตำแหน่งผสมได้เปิดใช้งานแล้ว โปรดเลือกการจัดวางตำแหน่งผสมปัจจุบัน!',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسىنى تەڭشەش',
    vi: 'Hệ thống phát hiện thay đổi trong việc cắt lát của chân khung lớn; vui lòng sắp xếp lại bố cục để đảm bảo chính xác sản xuất',
    zh_tc: '系統檢測混排方案設置發生改變，請重新選擇本次混排方案！',
    ru: 'Системное обнаружение изменений в настройках схемы смешивания, пожалуйста, выберите эту схему смешивания!',
    ko: '시스템 검사 혼합 배열 방안 설정이 변경되었습니다. 이번 혼합 배열 방안을 다시 선택하십시오!',
    bur: 'ပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်သတ်မှတ်ချက်ပြောင်းလဲကြောင်းစနစ်ရှာဖွေတွေ့ရသည်၊ ဤကြိမ်ပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်ပြန်ရွေးပါ!',
    ben: 'সিস্টেম মিশ্র লেআউট পরিকল্পনা সেটিং পরিবর্তন সনাক্ত করেছে, এই মিশ্র লেআউট পরিকল্পনা পুনরায় নির্বাচন করুন!',
    tr: 'Sistem karışık yerleşim planı ayarının değiştiğini algıladı, lütfen bu kez kullanılacak planı yeniden seçin!',
    km: 'ប្រព័ន្ធបានរកឃើញថាការកំណត់ផែនការប្លង់ចម្រុះបានផ្លាស់ប្តូរ សូមជ្រើសផែនការប្លង់ចម្រុះសម្រាប់លើកនេះឡើងវិញ!',
    es: 'El sistema detecta que la configuración del plan de mezcla ha cambiado, ¡vuelva a seleccionar este plan de mezcla!',
    ar: 'يكتشف النظام أن إعدادات خطة الخلط قد تغيرت، يرجى إعادة تحديد خطة الخلط هذه!',
  },
  'common.mixPaibanPlanSettingOk': {
    zh: '设置混排方案',
    en: 'Set Mix Paiban Plan',
    id: 'Set Mix Paiban Plan',
    kz: 'Бұрғылау жоспарын орнату',
    th: 'ตั้งค่าการจัดวางตำแหน่งผสม',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسىنى تەڭشەش',
    vi: 'Bố trí hỗn hợp chương trình',
    zh_tc: '設置混排方案',
    ru: 'Установить схему смешивания',
    ko: '혼합 배열 설정',
    bur: 'ပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်သတ်မှတ်ပါ',
    ben: 'মিশ্র লেআউট পরিকল্পনা সেট করুন',
    tr: 'Karışık yerleşim planını ayarla',
    km: 'កំណត់ផែនការប្លង់ចម្រុះ',
    es: 'Establecer el esquema de disposición mixta',
    ar: 'تعيين نظام الترتيب المختلط',
  },
  'common.mixPaibanPlanSettingCancel': {
    zh: '不用,直接排版',
    en: 'No, direct layout',
    id: 'No, direct layout',
    kz: 'Жоқ, тікелей орналастыру',
    th: 'ไม่, จัดวางตำแหน่งโดยตรง',
    ug: 'ياق, تەڭشەش',
    vi: 'Không, bố trí trực tiếp',
    zh_tc: '不用,直接排版',
    ru: 'Нет, прямая типография',
    ko: '아뇨, 그냥 조판해요',
    bur: 'မလိုဘဲ တိုက်ရိုက်ပြင်ဆင်ပါ',
    ben: 'না, সরাসরি লেআউট করুন',
    tr: 'Hayır, doğrudan yerleştir',
    km: 'ទេ ប្លង់ដោយផ្ទាល់',
    es: 'No es necesario, composición tipográfica directamente',
    ar: 'لا حاجة، التنضيد مباشرة',
  },
  'common.noMixPaibanPlan': {
    zh: '暂无可用混排方案',
    en: 'No available mix paiban plan',
    id: 'No available mix paiban plan',
    kz: 'Бұрғылау жоспары жоқ',
    th: 'ไม่มีการจัดวางตำแหน่งผสมที่มีอยู่',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى يوق',
    vi: 'Không có bố trí hỗn hợp chương trình',
    zh_tc: '暫無可用混排方案',
    ru: 'Отсутствует схема смешивания',
    ko: '사용 가능한 혼합 배열 스키마 없음',
    bur: 'အသုံးပြုနိုင်သောပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်မရှိ',
    ben: 'ব্যবহারযোগ্য মিশ্র লেআউট পরিকল্পনা নেই',
    tr: 'Kullanılabilir karışık yerleşim planı yok',
    km: 'មិនមានផែនការប្លង់ចម្រុះដែលអាចប្រើបានទេ',
    es: 'Actualmente no hay ningún esquema de disposición mixta disponible',
    ar: 'لا يوجد حاليًا نظام ترتيب مختلط متاح',
  },
  'common.mixColors': {
    zh: '混排颜色',
    en: 'Mix Colors',
    id: 'Mix Colors',
    kz: 'Бұрғылау түстері',
    th: 'สีผสม',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Bố trí hỗn hợp màu sắc',
    zh_tc: '混排顏色',
    ru: 'Смешанные цвета',
    ko: '혼합 색상',
    bur: 'အရောင်ရောပြင်ဆင်မှု',
    ben: 'মিশ্র রঙ লেআউট',
    tr: 'Karışık renkler',
    km: 'ពណ៌ចម្រុះ',
    es: 'Color de disposición mixta',
    ar: 'لون الترتيب المختلط',
  },
  'common.mixPai': {
    zh: '混排',
    en: 'Mix Paiban',
    id: 'Mix Paiban',
    kz: 'Бұрғылау',
    th: 'ผสม',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Bố trí hỗn hợp',
    zh_tc: '混排',
    ru: 'Смешанный ряд',
    ko: '혼합',
    bur: 'ရောပြင်ဆင်',
    ben: 'মিশ্র লেআউট',
    tr: 'Karışık yerleşim',
    km: 'ប្លង់ចម្រុះ',
    es: 'Disposición mixta',
    ar: 'الترتيب المختلط',
  },
  'common.plan': {
    zh: '方案',
    en: 'Plan',
    id: 'Plan',
    kz: 'Жоспар',
    th: 'การจัดวางตำแหน่ง',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Bố trí hỗn hợp',
    zh_tc: '方案',
    ru: 'решение',
    ko: '방안',
    bur: 'စီမံချက်',
    ben: 'পরিকল্পনা',
    tr: 'Plan',
    km: 'ផែនការ',
    es: 'Esquema',
    ar: 'المخطط',
  },
  'common.mixPaibanTitle': {
    zh: '不同颜色小板排一起',
    en: 'Different Color Small Boards to be Placed Together',
    id: 'Different Color Small Boards to be Placed Together',
    kz: 'Бұрғылау түстері бірге орналасуы',
    th: 'สีผสมต่างกันบนแผ่นเล็ก',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Bố trí hỗn hợp màu sắc',
    zh_tc: '不同顏色小板排一起',
    ru: 'Разные цветные доски вместе.',
    ko: '서로 다른 색깔의 작은 판자를 한데 배열하다.',
    bur: 'မတူညီသောအရောင်ပေါ်ဒ်ငယ်ကိုတပြိုင်နက်ပြင်ဆင်ပါ',
    ben: 'বিভিন্ন রঙের ছোট বোর্ড একসাথে সাজান',
    tr: 'Farklı renklerdeki küçük plakaları birlikte yerleştir',
    km: 'ដាក់បន្ទះតូចពណ៌ខុសៗគ្នារួមគ្នា',
    es: 'Organice tableros pequeños de diferentes colores juntos',
    ar: 'ترتيب الألواح الصغيرة ذات الألوان المختلفة معًا',
  },
  'common.mixColorsTip': {
    zh: '可以定义哪些颜色的板件能够作为同一种颜色排在一张大板上进行生产，同时不改变板件的原本颜色信息。',
    en: 'It is possible to define which color parts can be produced as the same color on a large board, while not changing the original color information of the parts.',
    id: 'It is possible to define which color parts can be produced as the same color on a large board, while not changing the original color information of the parts.',
    kz: 'Бұрғылау түстері бірге орналасуы мүмкін, бірақ олардың бұрғылау түстері өзгермейді.',
    th: 'สามารถกำหนดสีของส่วนที่สามารถผลิตเป็นสีเดียวกันบนแผ่นใหญ่ได้ โดยไม่ส่งผลกระทบต่อสีต้นฉบับของส่วน',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Có thể định nghĩa các tấm nhỏ có thể được sản xuất cùng màu sắc trên một tấm lớn, trong khi không thay đổi thông tin màu sắc gốc của các tấm nhỏ.',
    zh_tc:
      '可以定義哪些顏色的板件能夠作為同一種顏色排在同一張大板上進行生產，同時不改變板件的原本顏色信息。',
    ru: 'Можно определить, какие цвета могут быть изготовлены на одной большой доске в качестве одного и того же цвета без изменения первоначальной информации о цвете панели.',
    ko: '판재의 원래 색상 정보를 변경하지 않고 동일한 색상으로 큰 판에 배치할 수 있는 색상의 판재를 정의할 수 있습니다.',
    bur: 'မည်သည့်အရောင်ပေါ်ဒ်ကိုတူညီသောအရောင်အဖြစ် ပေါ်ဒ်ကြီးပေါ်တွင်ထုတ်လုပ်နိုင်သည်ကိုသတ်မှတ်နိုင်သည်၊ ပေါ်ဒ်၏ မူလအရောင်သတင်းကိုမပြောင်းသော',
    ben: 'কোন রঙের বোর্ড একই রঙ হিসেবে একটি বড় বোর্ডে উৎপাদন করা যাবে তা নির্ধারণ করা যায়, বোর্ডের মূল রঙ তথ্য পরিবর্তন না করে',
    tr: 'Parçaların orijinal renk bilgisini değiştirmeden, hangi renk parçaların aynı renk olarak aynı büyük plakada üretilebileceğini tanımlayabilirsiniz.',
    km: 'អ្នកអាចកំណត់ថាបន្ទះពណ៌ណាខ្លះអាចត្រូវបានផលិតជាពណ៌តែមួយនៅលើបន្ទះធំតែមួយ ដោយមិនផ្លាស់ប្តូរព័ត៌មានពណ៌ដើមរបស់បន្ទះឡើយ',
    es: 'Puede definir qué colores de paneles se pueden organizar en un panel grande del mismo color para producción sin cambiar la información de color original de los paneles.',
    ar: 'يمكنك تحديد ألوان اللوحات التي يمكن ترتيبها على لوحة كبيرة من نفس اللون للإنتاج دون تغيير معلومات اللون الأصلية للوحات.',
  },
  'common.mixColorsTip2': {
    zh: '添加方案后需要在开料清单中开启才会生效',
    en: 'After adding a plan, it needs to be enabled in the cutting list to take effect',
    id: 'After adding a plan, it needs to be enabled in the cutting list to take effect',
    kz: 'Жоспарды қосудан кейін кесу тізімінде қосылуы тиіс',
    th: 'หลังจากเพิ่มการจัดวางตำแหน่ง ต้องเปิดใช้งานในรายการตัดเพื่อให้มีผล',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Sau khi thêm chương trình, cần bật trong danh sách cắt để có hiệu lực',
    zh_tc: '添加方案后需要在開料清單中開啟才會生效',
    ru: 'После добавления схемы необходимо включить в список открытых материалов, прежде чем она вступит в силу.',
    ko: '프로젝트를 추가한 후에는 BOM을 열어야 적용됩니다.',
    bur: 'စီမံချက်ထည့်ပြီးနောက် ဖြတ်တောက်စာရင်းတွင်ဖွင့်မှသာ အကျိုးသက်ရောက်မည်',
    ben: 'পরিকল্পনা যোগ করার পর কাটার তালিকায় সক্রিয় করতে হবে',
    tr: 'Plan eklendikten sonra etkili olması için kesim listesinde etkinleştirilmelidir',
    km: 'បន្ទាប់ពីបន្ថែមផែនការ ត្រូវបើកវានៅក្នុងបញ្ជីកាត់ ទើបមានប្រសិទ្ធភាព',
    es: 'Después de agregar el esquema, es necesario activarlo en la lista de materiales para que surta efecto',
    ar: 'بعد إضافة المخطط، يجب تشغيله في قائمة المواد ليصبح ساري المفعول',
  },
  'common.mixColorsTip3': {
    zh: '异色封边功能存在冲突暂时无法同时生效该功能',
    en: 'The different color edge function exists in conflict and cannot be enabled at the same time',
    id: 'Fungsi tepi warna berbeda ada konflik dan tidak dapat diaktifkan secara bersamaan',
    kz: 'Бұрғылау түстері бірге орналасуы мүмкін, бірақ олардың бұрғылау түстері өзгермейді.',
    th: 'ฟังก์ชันการตัดขอบสีต่างกันมีความขัดแย้งและไม่สามารถเปิดใช้งานได้พร้อมกัน',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Chức năng cắt tỉa màu sắc khác có xung đột và không thể được bật cùng lúc',
    zh_tc: '異色封邊功能存在衝突暫時無法同時生效該功能',
    ru: 'Функция гетерохроматического уплотнения не работает одновременно.',
    ko: '이색 봉인 기능에 충돌이 있어 일시적으로 이 기능을 동시에 적용할 수 없습니다',
    bur: 'ကွဲပြားသောအရောင်ဘေးပိတ်ဆို့လုပ်ဆောင်ချက်တွင် ပဋိပက္ခရှိ၍ တပြိုင်နက်မကျင့်သုံးနိုင်',
    ben: 'ভিন্ন রঙের এজ সিলিং ফাংশনে দ্বন্দ্ব আছে, একসাথে কার্যকর করা যাবে না',
    tr: 'Farklı renk kenar bantlama işleviyle çakışma var, bu işlev geçici olarak aynı anda etkin olamaz',
    km: 'មុខងារបិទគែមពណ៌ខុសមានការប៉ះទង្គិច ដូច្នេះបច្ចុប្បន្នមិនអាចមានប្រសិទ្ធភាពជាមួយគ្នាបានទេ',
    es: 'Hay un conflicto entre las funciones de borde de diferentes colores y la función no puede ser efectiva al mismo tiempo',
    ar: 'هناك تعارض بين وظائف نطاقات الحواف ذات الألوان المختلفة ولا يمكن أن تكون الوظيفة فعالة في نفس الوقت',
  },
  'common.mixErrTip': {
    zh: '混排方案缺失必填项，请检查',
    en: 'Mix paiban plan missing required fields, please check',
    id: 'Pengaturan tata letak campuran tidak lengkap, silakan periksa',
    kz: 'Бұрғылау жоспарының міндетті өрістері жоқ, тексеріңіз',
    th: 'การจัดวางตำแหน่งผสมขาดค่าที่จำเป็น โปรดตรวจสอบ',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسىنىڭ مەلەماتىياللارى قىممىتى بوش قالمايدۇ, قىلىشنى تەڭشەڭ',
    vi: 'Chương trình bố trí hỗn hợp thiếu trường bắt buộc, vui lòng kiểm tra',
    zh_tc: '混排方案缺失必填項，請檢查',
    ru: 'Программа смешивания отсутствовала, проверьте',
    ko: '혼합 배열에 필수 항목이 없습니다. 확인하십시오.',
    bur: 'ပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်တွင် မဖြစ်မနေဖြည့်ရမည့်အကွက်လျော့ပါ',
    ben: 'মিশ্র লেআউট পরিকল্পনায় প্রয়োজনীয় ফিল্ড নেই, পরীক্ষা করুন',
    tr: 'Karışık yerleşim planında zorunlu alanlar eksik, lütfen kontrol edin',
    km: 'ផែនការប្លង់ចម្រុះខ្វះធាតុចាំបាច់ សូមពិនិត្យ',
    es: 'Al esquema de disposición mixta le faltan elementos requeridos, verifique',
    ar: 'مخطط الترتيب المختلط يفتقد العناصر المطلوبة، يرجى التحقق من',
  },
  'common.addPlan': {
    zh: '添加方案',
    en: 'Add Plan',
    id: 'Add Plan',
    kz: 'Жоспар қосу',
    th: 'เพิ่มการจัดวางตำแหน่ง',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Thêm chương trình',
    zh_tc: '添加方案',
    ru: 'Добавить программу',
    ko: '스키마 추가',
    bur: 'စီမံချက်ထည့်ပါ',
    ben: 'পরিকল্পনা যোগ করুন',
    tr: 'Plan ekle',
    km: 'បន្ថែមផែនការ',
    es: 'Agregar esquema',
    ar: 'إضافة مخطط',
  },
  'common.chooseMatcode': {
    zh: '选择材质',
    en: 'Choose Material',
    id: 'Choose Material',
    kz: 'Материалды таңдау',
    th: 'เลือกวัสดุ',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Chọn vật liệu',
    zh_tc: '選擇材質',
    ru: 'Выберите материал',
    ko: '재료 선택',
    bur: 'ပစ္စည်းရွေးပါ',
    ben: 'উপকরণ নির্বাচন করুন',
    tr: 'Malzeme seç',
    km: 'ជ្រើសសម្ភារៈ',
    es: 'Seleccionar material',
    ar: 'حدد مادة',
  },
  'common.chooseColor': {
    zh: '选择颜色',
    en: 'Choose Color',
    id: 'Choose Color',
    kz: 'Түсті таңдау',
    th: 'เลือกสี',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Chọn màu sắc',
    zh_tc: '選擇顏色',
    ru: 'Выбор цвета',
    ko: '색상 선택',
    bur: 'အရောင်ရွေးပါ',
    ben: 'রঙ নির্বাচন করুন',
    tr: 'Renk seç',
    km: 'ជ្រើសពណ៌',
    es: 'Seleccionar color',
    ar: 'حدد اللون',
  },
  'common.defineColor': {
    zh: '将选中颜色定义为',
    en: 'Define as',
    id: 'Define as',
    kz: 'Түсті анықтау',
    th: 'กำหนดเป็น',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Định nghĩa là',
    zh_tc: '將選中顏色定義為',
    ru: 'Выберите цвет',
    ko: '선택한 색상을',
    bur: 'ရွေးချယ်ထားသောအရောင်ကို သတ်မှတ်ပါ',
    ben: 'নির্বাচিত রঙকে হিসেবে সংজ্ঞায়িত করুন',
    tr: 'Seçilen rengi şöyle tanımla',
    km: 'កំណត់ពណ៌ដែលបានជ្រើសជា',
    es: 'Defina el color seleccionado como',
    ar: 'حدد اللون المحدد كـ',
  },
  'common.confirmDeletePlan': {
    zh: '确定要删除该方案吗',
    en: 'Confirm to Delete the Plan',
    id: 'Confirm to Delete the Plan',
    kz: 'Жоспарды өшіруді растау',
    th: 'ยืนยันการลบการจัดวางตำแหน่ง',
    ug: 'تاختى ئىشلەپچىقىرىش ئىشلەپچىقىرىش لىنىيىسى',
    vi: 'Xác nhận xóa chương trình',
    zh_tc: '確定要刪除該方案嗎',
    ru: 'Удалить программу?',
    ko: '이 스키마를 삭제하시겠습니까?',
    bur: 'ဤစီမံချက်ကိုဖျက်ရန်သေချာပါသလား',
    ben: 'এই পরিকল্পনা মুছতে নিশ্চিত করবেন কি',
    tr: 'Bu planı silmek istediğinizi onaylıyor musunuz?',
    km: 'តើអ្នកប្រាកដជាចង់លុបផែនការនេះមែនទេ',
    es: '¿Está seguro de que desea eliminar el esquema?',
    ar: 'هل أنت متأكد من أنك تريد حذف المخطط',
  },
  'common.trimmingMethod': {
    zh: '修边方式',
    en: 'Trimming method',
    id: 'Metode pemangkasan',
    kz: 'Қиып алу әдісі',
    th: 'วิธีการตัดขอบ',
    ug: 'قىر قىلىش ئۇسۇلى',
    vi: 'Phương pháp cắt tỉa',
    zh_tc: '修邊方式',
    ru: 'Порядок обрезки',
    ko: '모서리 손질 방식',
    bur: 'ဘေးဖြတ်နည်းလမ်း',
    ben: 'ট্রিমিং পদ্ধতি',
    tr: 'Kenar düzeltme yöntemi',
    km: 'វិធីកាត់ជ្រុង',
    es: 'Método de recorte',
    ar: 'طريقة التشذيب',
  },
  'common.followStandardTrim': {
    zh: '跟随原片中标准板材的修边值',
    en: 'Follow the trimming value of the standard board in the original panel',
    id: 'Ikuti nilai pemangkasan dari papan standar pada papan asli',
    kz: 'Негізгі тақтадағы стандартты материалдың қиып алу мәнін пайдалану',
    th: 'ตามค่าการตัดขอบของแผ่นมาตรฐานในแผ่นต้นฉบับ',
    ug: 'ئەسلى تاختىدىكى ئۆلچەملىك تاختىنىڭ قىر قىمмитигә ئەگەش',
    vi: 'Theo giá trị cắt tỉa của tấm tiêu chuẩn trong tấm gốc',
    zh_tc: '跟隨原片中標準板材的修邊值',
    ru: 'Следуйте за значением обрезки стандартной пластины в оригинале',
    ko: '원판 중의 표준 판재의 수선값을 따르다',
    bur: 'မူရင်းချပ်ရှိ စံပေါ်ဒ်၏ ဘေးဖြတ်တန်ဖိုးကိုလိုက်ပါ',
    ben: 'মূল বোর্ডে স্ট্যান্ডার্ড বোর্ডের ট্রিমিং মান অনুসরণ করুন',
    tr: 'Orijinal plakadaki standart panelin kenar düzeltme değerini takip et',
    km: 'អនុវត្តតាមតម្លៃកាត់ជ្រុងរបស់បន្ទះស្តង់ដារនៅក្នុងបន្ទះដើម',
    es: 'Siga el valor de recorte de la placa estándar en la película original',
    ar: 'اتبع قيمة التشذيب للوحة القياسية في الفيلم الأصلي',
  },
  'common.trimToast': {
    zh: '注意：您使用了余料自定义修边功能，仅可选则锯切排版',
    en: 'Attention: You are using the custom trimming feature for leftover materials, only saw cutting layout can be selected',
    id: 'Perhatian: Anda menggunakan fungsi pemangkasan khusus untuk sisa bahan, hanya dapat memilih tata letak pemotongan gergaji',
    kz: 'Назар аударыңыз: Сіз қалдық материалдың жеке қиып алу функциясын қолдандыңыз, тек аралау орналастыруды таңдауға болады',
    th: 'หมายเหตุ: คุณกำลังใช้ฟังก์ชันการตัดขอบแบบกำหนดเองของวัสดุส่วนเกิน สามารถเลือกได้เฉพาะการจัดวางแบบตัดเลื่อยเท่านั้น',
    ug: 'دىققەت: سىز ئارتۇق ماتېرىيالنىڭ ئۆزگىچە قىر تەڭشەش ئىقتىدارىنى ئىشلىتىۋاتىسىز، پەقەت ئارقا تاقتا تەرتىپلەشنى تاللىيالايسىز',
    vi: 'Lưu ý: Bạn đang sử dụng chức năng cắt tỉa tuỳ chỉnh cho vật liệu dư, chỉ có thể chọn bố cục cưa cắt',
    zh_tc: '注意：您使用了餘料自定義修邊功能，僅可選擇鋸切排版',
    ru: 'Примечание: Вы используете функцию настройки обрезки излишков, только при выборе пилы',
    ko: '참고: 남은 재료의 사용자 정의 모서리 수정 기능을 사용하였으며, 옵션으로 조판을 톱질할 수 있습니다.',
    bur: 'သတိ: ပိုလျှံပစ္စည်းကိုယ်တိုင်ဘေးဖြတ်ချက်လုပ်ဆောင်မှုသုံးနေ၊ ဓားပုတ်မြောင်းပြင်ဆင်မှုသာရွေးနိုင်',
    ben: 'নোট: আপনি উদ্বৃত্ত উপকরণের কাস্টম ট্রিমিং ফিচার ব্যবহার করছেন, শুধুমাত্র করাত কাটার লেআউট নির্বাচন করা যাবে',
    tr: 'Not: Artık malzeme için özel kenar düzeltme özelliğini kullanıyorsunuz; yalnızca testere kesim yerleşimi seçilebilir',
    km: 'ចំណាំ៖ អ្នកកំពុងប្រើមុខងារកាត់ជ្រុងផ្ទាល់ខ្លួនសម្រាប់សំណល់សម្ភារៈ ដូច្នេះអាចជ្រើសបានតែប្លង់កាត់ដោយម៉ាស៊ីនអារប៉ុណ្ណោះ',
    es: 'Nota: Ha utilizado la función de recorte personalizado del material restante, que solo es opcional para aserrado y diseño',
    ar: 'ملاحظة: لقد استخدمت وظيفة التشذيب المخصصة للمادة المتبقية، وهي اختيارية فقط للنشر والتخطيط',
  },
  'common.individualTrimValue': {
    zh: '单独设置修边值',
    en: 'Set trimming value individually',
    id: 'Atur nilai pemangkasan secara terpisah',
    kz: 'Қиып алу мәнін жеке орнату',
    th: 'ตั้งค่าค่าการตัดขอบแยกต่างหาก',
    ug: 'قىر قىممىتىنى ئايرىم بەلگىلەش',
    vi: 'Thiết lập giá trị cắt tỉa riêng biệt',
    zh_tc: '單獨設定修邊值',
    ru: 'Установить значение кромки отдельно',
    ko: '모서리 수정 값을 개별적으로 설정하려면 다음과 같이 하십시오.',
    bur: 'ဘေးဖြတ်တန်ဖိုးသီးခြားသတ်မှတ်ပါ',
    ben: 'ট্রিমিং মান পৃথকভাবে সেট করুন',
    tr: 'Kenar düzeltme değerini ayrı ayrı ayarla',
    km: 'កំណត់តម្លៃកាត់ជ្រុងដោយឡែក',
    es: 'Establezca el valor de recorte de forma independiente',
    ar: 'اضبط قيمة التشذيب بشكل مستقل',
  },
  'common.topTrimEmptyToast': {
    zh: '上修边不能为空!',
    en: 'Top trimming value cannot be empty',
    id: 'Nilai pemangkasan atas tidak boleh kosong',
    kz: 'Жоғарғы қиып алу мәні бос болмауы керек',
    th: 'ค่าการตัดขอบบนต้องไม่เว้นว่าง',
    ug: 'ئۈستى قىر بوش قالمايدۇ',
    vi: 'Giá trị cắt trên không được để trống',
    zh_tc: '上修邊不能為空',
    ru: 'Верхний ремонт не может быть пустым!',
    ko: '가장자리를 비워서는 안 된다!',
    bur: 'အပေါ်ဘေးဖြတ်မှုဗလာမဖြစ်ရ!',
    ben: 'উপরের ট্রিমিং মান খালি রাখা যাবে না!',
    tr: 'Üst kenar düzeltme boş olamaz!',
    km: 'តម្លៃកាត់ជ្រុងខាងលើមិនអាចទទេបានទេ!',
    es: '¡El recorte superior no puede estar vacío!',
    ar: 'لا يمكن أن يكون التشذيب العلوي فارغًا!',
  },
  'common.bottomTrimEmptyToast': {
    zh: '下修边不能为空!',
    en: 'Bottom trimming value cannot be empty',
    id: 'Nilai pemangkasan bawah tidak boleh kosong',
    kz: 'Төменгі қиып алу мәні бос болмауы керек',
    th: 'ค่าการตัดขอบล่างต้องไม่เว้นว่าง',
    ug: 'ئاستى قىر بوش قالمايدۇ',
    vi: 'Giá trị cắt dưới không được để trống',
    zh_tc: '下修邊不能為空',
    ru: 'Нижний ремонт не может быть пустым!',
    ko: '아래쪽 가장자리는 비워둘 수 없습니다!',
    bur: 'အောက်ဘေးဖြတ်မှုဗလာမဖြစ်ရ!',
    ben: 'নিচের ট্রিমিং মান খালি রাখা যাবে না!',
    tr: 'Alt kenar düzeltme boş olamaz!',
    km: 'តម្លៃកាត់ជ្រុងខាងក្រោមមិនអាចទទេបានទេ!',
    es: '¡El recorte inferior no puede estar vacío!',
    ar: 'لا يمكن أن يكون التشذيب السفلي فارغًا!',
  },
  'common.leftTrimEmptyToast': {
    zh: '左修边不能为空!',
    en: 'Left trimming value cannot be empty',
    id: 'Nilai pemangkasan kiri tidak boleh kosong',
    kz: 'Сол қиып алу мәні бос болмауы керек',
    th: 'ค่าการตัดขอบซ้ายต้องไม่เว้นว่าง',
    ug: 'سول قىر بوش قالمايدۇ',
    vi: 'Giá trị cắt trái không được để trống',
    zh_tc: '左修邊不能為空',
    ru: 'Левая сторона не может быть пустой!',
    ko: '왼쪽 가장자리는 비워둘 수 없습니다!',
    bur: 'ဘယ်ဘေးဖြတ်မှုဗလာမဖြစ်ရ!',
    ben: 'বাম ট্রিমিং মান খালি রাখা যাবে না!',
    tr: 'Sol kenar düzeltme boş olamaz!',
    km: 'តម្លៃកាត់ជ្រុងខាងឆ្វេងមិនអាចទទេបានទេ!',
    es: '¡El recorte izquierdo no puede estar vacío!',
    ar: 'لا يمكن أن يكون التشذيب الأيسر فارغًا!',
  },
  'common.rightTrimEmptyToast': {
    zh: '右修边不能为空!',
    en: 'Right trimming value cannot be empty',
    id: 'Nilai pemangkasan kanan tidak boleh kosong',
    kz: 'Оң қиып алу мәні бос болмауы керек',
    th: 'ค่าการตัดขอบขวาต้องไม่เว้นว่าง',
    ug: 'ئوڭ قىر بوش قالمايدۇ',
    vi: 'Giá trị cắt phải không được để trống',
    zh_tc: '右修邊不能為空',
    ru: 'Правая сторона не может быть пустой!',
    ko: '오른쪽 가장자리는 비워둘 수 없습니다!',
    bur: 'ညာဘေးဖြတ်မှုဗလာမဖြစ်ရ!',
    ben: 'ডান ট্রিমিং মান খালি রাখা যাবে না!',
    tr: 'Sağ kenar düzeltme boş olamaz!',
    km: 'តម្លៃកាត់ជ្រុងខាងស្តាំមិនអាចទទេបានទេ!',
    es: '¡El recorte correcto no puede estar vacío!',
    ar: 'لا يمكن أن يكون التشذيب الصحيح فارغًا!',
  },
  'common.topTrimBlurToast': {
    zh: '请输入上修边值',
    en: 'Please enter the top trimming value',
    id: 'Silakan masukkan nilai pemangkasan atas',
    kz: 'Жоғарғы қиып алу мәнін енгізіңіз',
    th: 'กรุณากรอกค่าการตัดขอบบน',
    ug: 'ئۈستى قىر قىممىتىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập giá trị cắt trên',
    zh_tc: '請輸入上修邊值',
    ru: 'Введите значение кромки',
    ko: '업스트림 모서리 값을 입력하십시오.',
    bur: 'အပေါ်ဘေးဖြတ်တန်ဖိုးထည့်ပါ',
    ben: 'উপরের ট্রিমিং মান লিখুন',
    tr: 'Lütfen üst kenar düzeltme değerini girin',
    km: 'សូមបញ្ចូលតម្លៃកាត់ជ្រុងខាងលើ',
    es: 'Ingrese el valor de recorte superior',
    ar: 'يرجى إدخال قيمة التشذيب العلوية',
  },
  'common.bottomTrimBlurToast': {
    zh: '请输入下修边值',
    en: 'Please enter the bottom trimming value',
    id: 'Silakan masukkan nilai pemangkasan bawah',
    kz: 'Төменгі қиып алу мәнін енгізіңіз',
    th: 'กรุณากรอกค่าการตัดขอบล่าง',
    ug: 'ئاستى قىر قىممىتىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập giá trị cắt dưới',
    zh_tc: '請輸入下修邊值',
    ru: 'Введите значение кромки',
    ko: '모서리 수정 값을 입력하십시오.',
    bur: 'အောက်ဘေးဖြတ်တန်ဖိုးထည့်ပါ',
    ben: 'নিচের ট্রিমিং মান লিখুন',
    tr: 'Lütfen alt kenar düzeltme değerini girin',
    km: 'សូមបញ្ចូលតម្លៃកាត់ជ្រុងខាងក្រោម',
    es: 'Ingrese el valor de recorte inferior',
    ar: 'يرجى إدخال قيمة التشذيب السفلية',
  },
  'common.leftTrimBlurToast': {
    zh: '请输入左修边值',
    en: 'Please enter the left trimming value',
    id: 'Silakan masukkan nilai pemangkasan kiri',
    kz: 'Сол қиып алу мәнін енгізіңіз',
    th: 'กรุณากรอกค่าการตัดขอบซ้าย',
    ug: 'سول قىر قىممىتىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập giá trị cắt trái',
    zh_tc: '請輸入左修邊值',
    ru: 'Введите значение левого края',
    ko: '왼쪽 트림 모서리 값을 입력하십시오.',
    bur: 'ဘယ်ဘေးဖြတ်တန်ဖိုးထည့်ပါ',
    ben: 'বাম ট্রিমিং মান লিখুন',
    tr: 'Lütfen sol kenar düzeltme değerini girin',
    km: 'សូមបញ្ចូលតម្លៃកាត់ជ្រុងខាងឆ្វេង',
    es: 'Ingrese el valor de recorte izquierdo',
    ar: 'يرجى إدخال قيمة التشذيب اليسرى',
  },
  'common.rightTrimBlurToast': {
    zh: '请输入右修边值',
    en: 'Please enter the right trimming value',
    id: 'Silakan masukkan nilai pemangkasan kanan',
    kz: 'Оң қиып алу мәнін енгізіңіз',
    th: 'กรุณากรอกค่าการตัดขอบขวา',
    ug: 'ئوڭ قىر قىممىتىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập giá trị cắt phải',
    zh_tc: '請輸入右修邊值',
    ru: 'Введите значение правого края',
    ko: '오른쪽 수정 모서리 값을 입력하십시오.',
    bur: 'ညာဘေးဖြတ်တန်ဖိုးထည့်ပါ',
    ben: 'ডান ট্রিমিং মান লিখুন',
    tr: 'Lütfen sağ kenar düzeltme değerini girin',
    km: 'សូមបញ្ចូលតម្លៃកាត់ជ្រុងខាងស្តាំ',
    es: 'Ingrese el valor de recorte derecho',
    ar: 'يرجى إدخال قيمة التشذيب اليمنى',
  },
  'common.effectToast': {
    zh: '1.自定义修边功能仅对焊接板生效',
    en: 'The custom trimming feature only takes effect for welded boards',
    id: 'Fungsi pemangkasan khusus hanya berlaku untuk papan las',
    kz: 'Жеке қиып алу функциясы тек дәнекерленген тақталарға қолданылады',
    th: 'ฟังก์ชันการตัดขอบแบบกำหนดเองจะมีผลเฉพาะกับแผ่นเชื่อมเท่านั้น',
    ug: 'ئۆزگىچە قىر تەڭشەش ئىقتىدارى پەقەت يېپىشتۇرۇلغان تاختىغا ئىشلىيدۇ',
    vi: 'Chức năng cắt tỉa tuỳ chỉnh chỉ có hiệu lực với bảng hàn',
    zh_tc: '自定義修邊功能僅對 焊接板 生效',
    ru: 'Пользовательские функции обрезки вступают в силу только для сварных пластин',
    ko: '1. 사용자 정의 모서리 수정 기능은 용접판에만 적용됩니다.',
    bur: '၁.ကိုယ်တိုင်ဘေးဖြတ်လုပ်ဆောင်မှုသည် ဂေါ်ဒင်ပေါ်ဒ်ကိုသာ အကျိုးသက်ရောက်မည်',
    ben: '১. কাস্টম ট্রিমিং ফিচার শুধুমাত্র ওয়েল্ডেড বোর্ডে কার্যকর',
    tr: '1. Özel kenar düzeltme özelliği yalnızca kaynaklı levhalar için geçerlidir',
    km: '1. មុខងារកាត់ជ្រុងផ្ទាល់ខ្លួន មានប្រសិទ្ធភាពតែលើបន្ទះផ្សារប៉ុណ្ណោះ',
    es: '1. La función de recorte personalizado solo es efectiva para placas soldadas',
    ar: '1. وظيفة التشذيب المخصصة فعالة فقط للألواح الملحومة',
  },
  'common.defaultTrimSetting': {
    zh: '余料默认修边设置',
    en: 'Default leftover trimming setting',
    id: 'Pengaturan pemangkasan bawaan sisa bahan',
    kz: 'Қалдықтар үшін әдепкі қырын орнату',
    th: 'การตั้งค่าการตัดขอบวัสดุเหลือมาตรฐาน',
    ug: 'قالدۇق ماتېرىيال ئۈچۈن ئادەتتىكى قىر تەڭشىكى',
    vi: 'Cài đặt cắt tỉa mặc định cho vật liệu thừa',
    zh_tc: '餘料預設修邊設定',
    ru: 'Параметры обрезки по умолчанию',
    ko: '남은 재료 기본 모서리 설정',
    bur: 'ပိုလျှံပစ္စည်းမူလဘေးဖြတ်သတ်မှတ်ချက်',
    ben: 'উদ্বৃত্ত উপকরণের ডিফল্ট ট্রিমিং সেটিং',
    tr: 'Artık malzeme varsayılan kenar düzeltme ayarı',
    km: 'ការកំណត់កាត់ជ្រុងលំនាំដើមសម្រាប់សំណល់សម្ភារៈ',
    es: 'Configuración de recorte predeterminada para los materiales restantes',
    ar: 'إعدادات التشذيب الافتراضية للمواد المتبقية',
  },
  'common.enterHere': {
    zh: '这里输入',
    en: 'Enter here',
    id: 'Masukkan di sini',
    kz: 'Міне, шур',
    th: 'ป้อนที่นี่',
    ug: 'بۇ يەرگە كىرىڭ',
    vi: 'Nhập vào đây',
    zh_tc: '這裡輸入',
    ru: 'введите здесь',
    ko: '여기 입력',
    bur: 'ဤနေရာတွင်ထည့်ပါ',
    ben: 'এখানে লিখুন',
    tr: 'Buraya girin',
    km: 'បញ្ចូលនៅទីនេះ',
    es: 'Ingrese aquí',
    ar: 'أدخل هنا',
  },
  'home.head.production': {
    zh: '产品介绍',
    en: 'Product Introduction',
    id: 'PENDAHULUAN PRODUK',
    kz: 'Өнімді таныстыру',
    th: 'การแนะนำผลิตภัณฑ์',
    ug: 'مەھسۇلات تونۇشتۇرۇش',
    vi: 'Giới thiệu sản phẩm',
    zh_tc: '產品介紹',
    ru: 'Описание продукта',
    ko: '제품 소개',
    bur: 'ကုန်ပစ္စည်းမိတ်ဆက်',
    ben: 'পণ্য পরিচিতি',
    tr: 'Ürün Tanıtımı',
    km: 'ការណែនាំផលិតផល',
    es: 'Introducción del producto',
    ar: 'مقدمة المنتج',
  },
  'home.head.resolve': {
    zh: '解决方案',
    en: 'Solutions',
    id: 'Larutan',
    kz: 'Шешімдер',
    th: 'สารละลาย',
    ug: 'چەت ئەل ھەل قىلىش',
    vi: 'Giải pháp',
    zh_tc: '解決方案',
    ru: 'решение',
    ko: '솔루션',
    bur: 'ဖြေရှင်းချက်',
    ben: 'সমাধান',
    tr: 'Cozumler',
    km: 'ដំណោះស្រាយ',
    es: 'Solución',
    ar: 'الحل',
  },
  'home.head.about': {
    zh: '关于我们',
    en: 'About Us',
    id: 'tentang kami',
    kz: 'Біз туралы',
    th: 'เกี่ยวกับเรา',
    ug: 'بىز ھەققىدە',
    vi: 'Về chúng tôi',
    zh_tc: '關於我們',
    ru: 'О нас',
    ko: '회사 소개',
    bur: 'ကျွန်ုပ်တို့အကြောင်း',
    ben: 'আমাদের সম্পর্কে',
    tr: 'Hakkimizda',
    km: 'អំពីពួកយើង',
    es: 'Acerca de nosotros',
    ar: 'من نحن',
  },
  'home.head.equipment': {
    zh: '机器设备',
    en: 'Equipment',
    id: 'Mesin dan peralatan',
    kz: 'Машиналар жабдықтары',
    th: 'เครื่องจักรและอุปกรณ์',
    ug: 'ماشىنا قوراللىرى',
    vi: 'Thiết bị máy móc',
    zh_tc: '機器設備',
    ru: 'Машины и оборудование',
    ko: '기계 설비',
    bur: 'စက်ကိရိယာ',
    ben: 'যন্ত্রপাতি ও সরঞ্জাম',
    tr: 'Ekipman',
    km: 'ឧបករណ៍',
    es: 'Maquinaria y equipo',
    ar: 'الآلات والمعدات',
  },
  'home.head.tell': {
    zh: '投诉电话',
    en: 'Complaint Hotline',
    id: 'Nomor telepon keluhan',
    kz: 'Шикаять телефон',
    th: 'หมายเลขโทรศัพท์ร้องเรียน',
    ug: 'شىكايەت تېلېفونى',
    vi: 'Điện thoại khiếu nại',
    zh_tc: '投訴電話',
    ru: 'Жалобы по телефону',
    ko: '신고 전화',
    bur: 'တိုင်ကြားဖုန်းနံပါတ်',
    ben: 'অভিযোগ হটলাইন',
    tr: 'Sikayet Hatti',
    km: 'ទូរស័ព្ទបណ្តឹង',
    es: 'Línea directa de quejas',
    ar: 'الخط الساخن للشكاوى',
  },
  'home.head.enter': {
    zh: '进入云排版',
    en: 'Enter Cloud Typesetting',
    id: 'Masukkan tata letak cloud',
    kz: 'Бұлт баспашылық кіріңіз',
    th: 'ป้อนเค้าโครงเมฆ',
    ug: 'بۇلۇت تەرتىپلىگۈچكە كىرىش',
    vi: 'Đi vào Bán hình đám mây',
    zh_tc: '進入雲排版',
    ru: 'Введите облачную версию',
    ko: '클라우드 레이아웃에 들어가기',
    bur: 'Cloud Layout ကိုဝင်ပါ',
    ben: 'ক্লাউড টাইপসেটিং-এ প্রবেশ করুন',
    tr: 'Bulut Dizgisine Gir',
    km: 'ចូលទៅកាន់ការរៀបប្លង់លើពពក',
    es: 'Ingrese a la composición tipográfica en la nube',
    ar: 'أدخل التنضيد السحابي',
  },
  'home.swiper.case1.tag': {
    zh: '全新升级版',
    en: 'Newly Upgraded Version',
    id: 'Versi yang ditingkatkan baru',
    kz: 'Жаңа жаңарту версиясы',
    th: 'เวอร์ชันอัพเกรดใหม่',
    ug: 'يېڭىلانغان نۇسخا',
    vi: 'Phiên bản nâng cấp hoàn toàn mới',
    zh_tc: '全新升級版',
    ru: 'Новое обновление',
    ko: '새로운 업그레이드',
    bur: 'အသစ်အဆင့်မြှင့်ဗားရှင်း',
    ben: 'নতুন আপগ্রেড সংস্করণ',
    tr: 'Yeni Yukseltildi',
    km: 'កំណែអាប់ដេតថ្មី',
    es: 'Nueva versión mejorada',
    ar: 'نسخة مطورة جديدة',
  },
  'home.swiper.case1.subTitle': {
    zh: '机器的智能大脑',
    en: 'The Intelligent Brain of Machines',
    id: 'Otak mesin yang cerdas',
    kz: 'Машинаның интеллектуалды ми',
    th: 'สมองอัจฉริยะของเครื่องจักร',
    ug: 'ماشىنىنىڭ ئەقىللىق مېڭىسى',
    vi: 'Trí tuệ của máy móc',
    zh_tc: '機器的智能大腦',
    ru: 'Умный мозг машины.',
    ko: '기계의 지능적인 두뇌',
    bur: 'စက်ကိရိယာ၏ ဉာဏ်ကြီးရှင်',
    ben: 'মেশিনের বুদ্ধিমান মস্তিষ্ক',
    tr: 'Makinelerin Akilli Beyni',
    km: 'ខួរក្បាលឆ្លាតវៃរបស់ម៉ាស៊ីន',
    es: 'El cerebro inteligente de la máquina',
    ar: 'العقل الذكي للآلة',
  },
  'home.swiper.case1.description': {
    zh: '改革行业的云端在线排版优化软件',
    en: 'A cloud-based online typesetting optimization software revolutionizing the industry',
    id: 'Mereformasi perangkat lunak optimasi tata letak online cloud industri',
    kz: 'Өнеркәсіптік бастырақті онлайн баспашылық оптималдау бағдарламалық жасақтамасы',
    th: 'การปฏิรูปซอฟต์แวร์การเพิ่มประสิทธิภาพเค้าโครงออนไลน์คลาวด์ของอุตสาหกรรม',
    ug: 'سەنئەتنى ئۆزگەرتىدىغان بۇلۇت تەرتىپلىگۈچ يۇمشاق دېتال',
    vi: 'Phần mềm cải cách ngành công nghiệp để tối ưu hóa bán hình trực tuyến trên đám mây',
    zh_tc: '改革行業的雲端在線排版優化軟件',
    ru: 'Программное обеспечение для оптимизации облачной онлайн - типографии в реформированной отрасли',
    ko: '업계의 클라우드 온라인 레이아웃 최적화 소프트웨어 개혁',
    bur: 'လုပ်ငန်းကို ပြောင်းလဲနေသော Cloud အွန်လိုင်းပြင်ဆင်မှုဆော့ဖ်ဝဲ',
    ben: 'শিল্পকে বিপ্লব করা ক্লাউড অনলাইন টাইপসেটিং অপ্টিমাইজেশন সফটওয়্যার',
    tr: 'Sektoru donusturen bulut tabanli cevrim ici dizgi optimizasyon yazilimi',
    km: 'កម្មវិធីបង្កើនប្រសិទ្ធភាពការរៀបប្លង់អនឡាញលើពពក ដែលកំពុងផ្លាស់ប្តូរឧស្សាហកម្ម',
    es: 'Software de optimización de la composición tipográfica en línea en la nube que revoluciona la industria',
    ar: 'برنامج تحسين التنضيد السحابي عبر الإنترنت الذي يحدث ثورة في الصناعة',
  },
  'home.swiper.case2.title': {
    zh: '柜体生产',
    en: 'Cabinet Production',
    id: 'Produksi Kabinet',
    kz: 'Шкафтар өндірісі',
    th: 'การผลิตคณะรัฐมนตรี',
    ug: 'كابىنەت ئىشلەپچىقىرىش',
    vi: 'Sản xuất tủ',
    zh_tc: '櫃體生產',
    ru: 'Производство шкафов',
    ko: '캐비닛 생산',
    bur: 'ဗီရိုထုတ်လုပ်မှု',
    ben: 'ক্যাবিনেট উৎপাদন',
    tr: 'Dolap Uretimi',
    km: 'ការផលិតទូ',
    es: 'Producción de gabinetes',
    ar: 'إنتاج الخزانات',
  },
  'home.swiper.case2.subTitle': {
    zh: '技术革新',
    en: 'Technological Innovation',
    id: 'Inovasi Teknologi',
    kz: 'Технологиялық жаңартулар',
    th: 'นวัตกรรมเทคโนโลยี',
    ug: 'تېخنىكا يېڭىلىنىشى',
    vi: 'Công nghệ đổi mới',
    zh_tc: '技術革新',
    ru: 'Технические новшества',
    ko: '기술 혁신',
    bur: 'နည်းပညာဆန်းသစ်ထွင်မှု',
    ben: 'প্রযুক্তি উদ্ভাবন',
    tr: 'Teknolojik Yenilik',
    km: 'នវានុវត្តន៍បច្ចេកវិទ្យា',
    es: 'Innovación técnica',
    ar: 'الابتكار الفني',
  },
  'home.swiper.case2.description': {
    zh: '支持多种贴标机、开料机、侧孔机、五面PTP、五/六面钻对接',
    en: 'Supports integration with various labeling machines, cutting machines, side-hole machines, five-sided PTP, and five/six-sided drilling machines',
    id: 'Mendukung beberapa mesin pelabelan, mesin pemotong, mesin lubang samping, PTP lima sisi, koneksi pengeboran lima sisi',
    kz: 'Көптеген этикеткалеу машиналар, кескіш машиналар, جانболы отық машиналары, бесжақты PTP, бес/алтышақты бұрғалау машиналармен қосу',
    th: 'รองรับเครื่องฉลากหลายเครื่องเครื่องตัดเครื่องรูด้านข้าง PTP ห้าด้านการเชื่อมต่อการขุดเจาะห้าด้าน',
    ug: 'نۇرغۇن خىل بېلگە چاپلاش ماشىنىسى، ماتېرىال كېسىش ماشىنىسى، يان تېشىك ماتورى، بەش يۈزلىك PTP، بەش/ئالتە يۈزلىك ماتورلارنى قوللايدۇ',
    vi: 'Hỗ trợ nhiều loại máy dán nhãn, máy chạy đuôi, máy khoan bên, máy PTP năm mặt, máy khoan năm/sáu mặt',
    zh_tc: '支持多種貼標機、開料機、側孔機、五面PTP、五/六面鑽對接',
    ru: 'Поддержка различных маркировочных машин, распылителей, боковых отверстий, пятистороннего PTP, стыковки пятистороннего / шестистороннего бурения',
    ko: '다양한 부착기, 원료 공급기, 측면 구멍 기계, 5면 PTP, 5면 / 6면 드릴 도킹 지원',
    bur: 'တံဆိပ်ကပ်စက်၊ ဖြတ်တောက်စက်၊ ဘေးပေါက်ဖောက်စက်၊ ငါးမျက်နှာ PTP၊ ငါး/ခြောက်မျက်နှာဖောက်ပေါင်းစပ်မှုကိုပံ့ပိုး',
    ben: 'বিভিন্ন লেবেলিং মেশিন, কাটিং মেশিন, সাইড হোল মেশিন, পাঁচ মুখ PTP, পাঁচ/ছয় মুখ ড্রিল সংযোগ সমর্থন করে',
    tr: 'Cesitli etiketleme makineleri, kesim makineleri, yan delik makineleri, bes yuzlu PTP ve bes/alti yuzlu delme makineleriyle entegrasyonu destekler',
    km: 'គាំទ្រការតភ្ជាប់ជាមួយម៉ាស៊ីនបិទស្លាក ម៉ាស៊ីនកាត់ ម៉ាស៊ីនរន្ធចំហៀង PTP ប្រាំមុខ និងម៉ាស៊ីនខួងប្រាំ/ប្រាំមួយមុខជាច្រើនប្រភេទ',
    es: 'Admite una variedad de máquinas etiquetadoras, cortadoras, máquinas perforadoras laterales, de cinco lados PTP, taladros de cinco/seis lados acoplamiento',
    ar: 'يدعم مجموعة متنوعة من آلات وضع العلامات، وآلات القطع، وآلات الفتحات الجانبية، وخمسة الجوانب PTP، إرساء الحفر الخماسي/ السداسي',
  },
  'home.swiper.case3.title': {
    zh: '工业大脑',
    en: 'Industrial Brain',
    id: 'Otak Industri',
    kz: 'Өнеркәсіптік ми',
    th: 'สมองอุตสาหกรรม',
    ug: 'سانائەت مېڭىسى',
    vi: 'Trí tuệ công nghiệp',
    zh_tc: '工業大腦',
    ru: 'Промышленный мозг',
    ko: '산업 두뇌',
    bur: 'စက်မှုဦးနှောက်',
    ben: 'শিল্প মস্তিষ্ক',
    tr: 'Endustriyel Beyin',
    km: 'ខួរក្បាលឧស្សាហកម្ម',
    es: 'Cerebro industrial',
    ar: 'الدماغ الصناعي',
  },
  'home.swiper.case3.subTitle': {
    zh: '解决方案',
    en: 'Solutions',
    id: 'Larutan',
    kz: 'Шешімдер',
    th: 'สารละลาย',
    ug: 'چەت ئەل ھەل قىلىش',
    vi: 'Giải pháp',
    zh_tc: '解決方案',
    ru: 'решение',
    ko: '솔루션',
    bur: 'ဖြေရှင်းချက်',
    ben: 'সমাধান',
    tr: 'Cozumler',
    km: 'ដំណោះស្រាយ',
    es: 'Solución',
    ar: 'الحل',
  },
  'home.swiper.case3.description': {
    zh: '智能排版算法获得板材更高利用率',
    en: 'Intelligent typesetting algorithm achieves higher material utilization rates',
    id: 'Algoritma pengaturan huruf yang cerdas untuk mendapatkan tingkat pemanfaatan dewan yang lebih tinggi',
    kz: 'Интеллектуалды баспашылық алгоритмі тақта материалдарды тиімдірек пайдалануға мүмкіндік береді',
    th: 'อัลกอริทึมการเรียงพิมพ์อัจฉริยะเพื่อให้ได้อัตราการใช้งานที่สูงขึ้นของบอร์ด',
    ug: 'ئەقىللىق تەرتىپلەش ئالگورىتىمى تاختىنى تېخىمۇ يۇقىرى پايدىلىنىش نىسبىتىگە ئېرىشتۈرىدۇ',
    vi: 'Thuật toán bán hình thông minh giúp đạt được tỉ lệ sử dụng ván cao hơn',
    zh_tc: '智能排版算法獲得板材更高利用率',
    ru: 'Интеллектуальные алгоритмы получают более высокий коэффициент использования листов',
    ko: '지능형 레이아웃 알고리즘으로 판재 활용도 향상',
    bur: 'ဉာဏ်ပညာပြင်ဆင်မှုအယ်လဂိုရီသမ်ဖြင့် ပေါ်ဒ်အသုံးချမှုနှုန်းပိုမြင့်',
    ben: 'বুদ্ধিমান টাইপসেটিং অ্যালগরিদম দিয়ে বোর্ড উপকরণের উচ্চতর ব্যবহার হার অর্জন',
    tr: 'Akilli dizgi algoritmasi daha yuksek malzeme kullanim orani saglar',
    km: 'ក្បួនដោះស្រាយរៀបប្លង់ឆ្លាតវៃ ធ្វើឱ្យអត្រាប្រើប្រាស់បន្ទះកាន់តែខ្ពស់',
    es: 'El algoritmo de composición tipográfica inteligente obtiene una mayor tasa de utilización de los tableros',
    ar: 'تحصل خوارزمية التنضيد الذكية على معدل استخدام أعلى للوحات',
  },
  'home.statistics.today': {
    zh: '今日排班量',
    en: "Today's Scheduling",
    id: 'Volume shift hari ini',
    kz: 'Бүгінгі күннің жұмыс плані',
    th: 'ปริมาณการเปลี่ยนแปลงของวันนี้',
    ug: 'بۈگۈنكى تەرتىپلەش مىقدارى',
    vi: 'Lượng phân ban hôm nay',
    zh_tc: '今日排班量',
    ru: 'Сегодняшняя смена.',
    ko: '오늘 배차량',
    bur: 'ယနေ့ပြင်ဆင်မှုအရေအတွက်',
    ben: 'আজকের শিডিউলিং পরিমাণ',
    tr: 'Bugunku Dizgi Miktari',
    km: 'បរិមាណប្លង់ថ្ងៃនេះ',
    es: 'Volumen de turno de hoy',
    ar: 'حجم التحول اليوم',
  },
  'home.statistics.toMounth': {
    zh: '当月排版量',
    en: 'Monthly layout volume',
    id: 'Volume tata letak bulanan',
    kz: 'Бүгінгі айдің жұмыс плані',
    th: 'ปริมาณเค้าโครงรายเดือน',
    ug: 'بۇ ئاينىڭ تەرتىپلەش مىقدارى',
    vi: 'Lượng phân ban trong tháng',
    zh_tc: '當月排版量',
    ru: 'Ежемесячный тираж',
    ko: '당월 조판량',
    bur: 'ဤလ ပြင်ဆင်မှုအရေအတွက်',
    ben: 'এই মাসের লেআউট পরিমাণ',
    tr: 'Aylik Dizgi Miktari',
    km: 'បរិមាណប្លង់ប្រចាំខែ',
    es: 'Volumen de composición tipográfica mensual',
    ar: 'حجم التنضيد الشهري',
  },
  'home.statistics.outturn': {
    zh: '出材率',
    en: 'Yield Rate',
    id: 'Hasil material',
    kz: 'Өнімділік көрсеткіші',
    th: 'ผลผลิตวัสดุ',
    ug: 'ماتېرىال چىقىم نىسبىتى',
    vi: 'Tỷ lệ xuất tài nguyên',
    zh_tc: '出材率',
    ru: 'Коэффициент выхода',
    ko: '출재율',
    bur: 'ပစ္စည်းထွက်နှုန်း',
    ben: 'উপকরণ ফলন হার',
    tr: 'Verim Orani',
    km: 'អត្រាទិន្នផល',
    es: 'Rendimiento del material',
    ar: 'إنتاجية المواد',
  },
  'home.statistics.cumulative': {
    zh: '累计用户',
    en: 'Cumulative Users',
    id: 'Pengguna Kumulatif',
    kz: 'Жалпы пайдаланушылар саны',
    th: 'ผู้ใช้ที่สะสม',
    ug: 'جەمئىي ئىشلەتكۈچى',
    vi: 'Người dùng tích lũy',
    zh_tc: '累計用戶',
    ru: 'Совокупные пользователи',
    ko: '누적 사용자',
    bur: 'စုစုပေါင်းအသုံးပြုသူ',
    ben: 'সঞ্চিত ব্যবহারকারী',
    tr: 'Kumulatif Kullanicilar',
    km: 'អ្នកប្រើប្រាស់សរុប',
    es: 'Usuarios acumulativos',
    ar: 'المستخدمين التراكميين',
  },
  'home.intro.title': {
    zh: '企业级大数据 云端在线排版软件',
    en: 'Enterprise-grade Big Data Cloud-based Online Typesetting Software',
    id: 'Perangkat Lunak Tata Letak Online Data Besar Level Enterprise',
    kz: 'Корпоративтік біг деректері Бұлт онлайн баспашылық бағдарламалық жасақтамасы',
    th: 'ซอฟต์แวร์เค้าโครงออนไลน์ขนาดใหญ่ระดับองค์กร',
    ug: 'كارخانىلار دەرىجىلىك چوڭ سانلىق مەلۇمات بۇلۇت تەرتىپلىگۈچ يۇمشاق دېتالى',
    vi: 'Phần mềm phân ban trực tuyến trên đám mây với dữ liệu lớn cấp doanh nghiệp',
    zh_tc: '企業級大數據 雲端在線排版軟件',
    ru: 'Корпоративное облачное программное обеспечение для форматирования больших данных',
    ko: '엔터프라이즈급 빅 데이터 클라우드 온라인 레이아웃 소프트웨어',
    bur: 'ကုမ္ပဏီအဆင့်빅ဒေတာ Cloud အွန်လိုင်းပြင်ဆင်မှုဆော့ဖ်ဝဲ',
    ben: 'এন্টারপ্রাইজ-গ্রেড বিগ ডেটা ক্লাউড অনলাইন টাইপসেটিং সফটওয়্যার',
    tr: 'Kurumsal duzey buyuk veri bulut tabanli cevrim ici dizgi yazilimi',
    km: 'កម្មវិធីរៀបប្លង់អនឡាញលើពពកកម្រិតសហគ្រាសសម្រាប់ទិន្នន័យធំ',
    es: 'Big data a nivel empresarial Software de composición tipográfica en línea en la nube',
    ar: 'برنامج التنضيد عبر الإنترنت السحابي للبيانات الضخمة على مستوى المؤسسة',
  },
  'home.intro.subTitle': {
    zh: ' 洞察行业态势，聚焦客户需求，赋能企业数字化转型升级，推动互联网家具生产自动化产业变革 针对现有板式家具行业生产场景，推出AI辅助算法，持续为企业实现贡献新增长 ',
    en: 'Insights into industry trends, focusing on customer needs, enabling digital transformation and upgrading of enterprises, driving the automation of the internet furniture production industry. Introducing AI-assisted algorithms for the existing panel furniture industry production scenarios, continuously contributing to new growth for enterprises.',
    id: 'Wawasan tentang tren industri, fokus pada kebutuhan pelanggan, memberdayakan perusahaan untuk mengubah dan meningkatkan secara digital, dan mempromosikan transformasi industri otomatisasi produksi furnitur internet. Menanggapi skenario produksi industri furnitur panel yang ada, algoritma yang dibantu AI diluncurkan untuk terus menyumbangkan pertumbuhan baru ke perusahaan',
    kz: 'Өнеркәсіптік ситуацияны бақылау, клиенттердің қажеттіліктеріне назар аудару, корпоративтік цифрлық трансформация мен автоматтандыруды іске асыру, Интернет-өнімдер өндірісінің индустриялық өзгерістеріне иішінарыс. Қазіргі板式 мебел өнімділіктеріне арналған AI қосымша алгоритмдері ұсынылады, олар корпоративтік өсімге жеткізуге мүмкіндік береді',
    th: 'ข้อมูลเชิงลึกเกี่ยวกับแนวโน้มของอุตสาหกรรมมุ่งเน้นไปที่ความต้องการของลูกค้าช่วยให้ผู้ประกอบการเปลี่ยนและอัพเกรดแบบดิจิทัลและส่งเสริมการเปลี่ยนแปลงของอุตสาหกรรมการผลิตเฟอร์นิเจอร์อินเทอร์เน็ต ในการตอบสนองต่อสถานการณ์การผลิตของอุตสาหกรรมเฟอร์นิเจอร์แผงที่มีอยู่อัลกอริทึม AI ช่วยให้เปิดตัวเพื่อดำเนินการต่อเพื่อการเติบโตใหม่ให้กับองค์กร',
    ug: 'سانائەت ھالىتىنى چۈشىنىش، خېرىدار ئېھتىياجىغا دىققەت قىلىش، كارخانىلارنى رقابەتلەشتۈرۈشكە ياردەم بېرىش، ئۈنۈملۈك ئىشلەپچىقىرىش ساھەسىدە ئۆزگىرىشلەرنى قوزغىتىش، ئەقىللىق ئالگورىتىم ئارقىلىق كارخانىلارغا تېخىمۇ كۆپ پايدا ئېلىپ كېلىش',
    vi: 'Thông thái ngành công nghiệp, tập trung vào nhu cầu khách hàng, trao quyền cho doanh nghiệp chuyển đổi kỹ thuật số, đẩy mạnh cách mạng sản xuất đồ nội thất trực tuyến. Đối với hiện trạng sản xuất ngành đồ nội thất bảng hiện có, giới thiệu thuật toán hỗ trợ AI, liên tục đóng góp tăng trưởng mới cho doanh nghiệp',
    zh_tc:
      ' 洞察行業態勢，聚焦客戶需求，賦能企業數字化轉型升級，推動互聯網家具生產自動化產業變革 針對現有板式家具行業生產場景，推出AI輔助算法，持續為企業實現貢獻新增長 ',
    ru: 'Понимание ситуации в отрасли, сосредоточение внимания на потребностях клиентов, расширение возможностей предприятий для цифровой трансформации и модернизации, содействие преобразованию индустрии автоматизации производства мебели в Интернете для существующих сценариев производства мебели из листовых панелей, внедрение алгоритмов помощи ИИ, непрерывное внесение вклада в предприятия для достижения нового роста',
    ko: '업계 태세를 통찰하고 고객의 수요에 초점을 맞추며 기업의 디지털 전환 업그레이드를 부여하고 인터넷 가구 생산 자동화 산업 변혁을 추진하여 기존 판식 가구 업계 생산 장면에 맞추어 AI 보조 알고리즘을 출시하여 기업의 새로운 성장을 지속적으로 공헌한다',
    bur: 'လုပ်ငန်းလမ်းကြောင်းကိုနားလည်ပြီး ဖောက်သည်လိုအပ်ချက်ကိုဦးတည်ကာ ကုမ္ပဏီဒစ်ဂျစ်တယ်အပြောင်းအလဲကိုခွန်အားပေးကာ AI ကူညီသောအယ်လဂိုရီသမ်ဖြင့် ကုမ္ပဏီတိုးတက်မှုအသစ်ကိုဆက်လက်ပံ့ပိုး',
    ben: 'শিল্পের গতিপ্রকৃতি বিশ্লেষণ করে, গ্রাহকের চাহিদায় মনোযোগ দিয়ে, কোম্পানির ডিজিটাল রূপান্তরকে শক্তিশালী করে AI সহায়তা অ্যালগরিদম দিয়ে কোম্পানির নতুন বৃদ্ধি নিশ্চিত করে',
    tr: 'Sektor trendlerini analiz eder, musteri ihtiyaclarina odaklanir, isletmelerin dijital donusumunu guclendirir ve internet mobilya uretim otomasyonunu ileri tasir. Mevcut panel mobilya uretim senaryolari icin AI destekli algoritmalar sunarak isletmelere surekli yeni buyume katkisi saglar.',
    km: 'យល់ដឹងអំពីនិន្នាការឧស្សាហកម្ម ផ្តោតលើតម្រូវការអតិថិជន ពង្រឹងការប្រែប្រួលឌីជីថលរបស់សហគ្រាស ជំរុញការផ្លាស់ប្តូរឧស្សាហកម្មផលិតគ្រឿងសង្ហារឹមអ៊ីនធឺណិតដោយស្វ័យប្រវត្តិ ហើយសម្រាប់សេណារីយ៉ូផលិតគ្រឿងសង្ហារឹមបន្ទះដែលមានស្រាប់ បានណែនាំក្បួនដោះស្រាយជំនួយដោយ AI ដើម្បីបន្តនាំមកនូវកំណើនថ្មីសម្រាប់សហគ្រាស',
    es: 'Información sobre las tendencias de la industria, centrándose en las necesidades de los clientes, potenciando la transformación y actualización digital de las empresas y promoviendo la transformación de la industria de automatización de la producción de muebles en Internet En respuesta a los escenarios de producción existentes de los muebles con paneles industria, se lanzan algoritmos auxiliares AI para continuar contribuyendo con un nuevo crecimiento a la empresa',
    ar: 'رؤى حول اتجاهات الصناعة، مع التركيز على احتياجات العملاء، وتمكين التحول الرقمي للمؤسسات وترقيتها، وتعزيز التحول في صناعة أتمتة إنتاج الأثاث عبر الإنترنت استجابة لسيناريوهات الإنتاج الحالية صناعة الأثاث اللوحي، AI يتم إطلاق الخوارزميات المساعدة لمواصلة المساهمة في نمو جديد للمؤسسة',
  },
  'home.intro.menue.case1.title': {
    zh: '在线排版',
    en: 'Online typesetting',
    id: 'Tipografi online',
    kz: 'Онлайн баспашылық',
    th: 'ตัวอักษรออนไลน์',
    ug: 'توردا تەرتىپلەش',
    vi: 'Phân ban trực tuyến',
    zh_tc: '在線排版',
    ru: 'Онлайновая типография',
    ko: '온라인 조판',
    bur: 'အွန်လိုင်းပြင်ဆင်မှု',
    ben: 'অনলাইন টাইপসেটিং',
    tr: 'Cevrim Ici Dizgi',
    km: 'ការរៀបប្លង់អនឡាញ',
    es: 'Composición tipográfica en línea',
    ar: 'التنضيد عبر الإنترنت',
  },
  'home.intro.menue.case1.subTitle': {
    zh: '任何时刻均可排版',
    en: 'Typesetting at any time',
    id: 'Ketik kapan saja',
    kz: 'Кез келген уақытта баспашылық жасауға болады',
    th: 'พิมพ์ในเวลาใดก็ได้',
    ug: 'ھەر قانداق ۋاقىتتا تەرتىپلەش',
    vi: 'Phân ban bất cứ lúc nào',
    zh_tc: '任何時刻均可排版',
    ru: 'Их можно печатать в любое время.',
    ko: '언제든지 조판할 수 있다',
    bur: 'မည်သည့်အချိန်မဆိုပြင်ဆင်နိုင်',
    ben: 'যেকোনো সময় টাইপসেটিং করা যাবে',
    tr: 'Her Zaman Dizgi Yapilabilir',
    km: 'អាចរៀបប្លង់បានគ្រប់ពេល',
    es: 'La composición tipográfica se puede realizar en cualquier momento',
    ar: 'يمكن إجراء التنضيد في أي وقت',
  },
  'home.intro.menue.case1.description': {
    zh: '无需下载软件，任何时刻均可排版,远程操控不必依赖于电脑',
    en: 'No need to download software, typesetting can be done at any time, remote control without relying on a computer.',
    id: 'Tidak perlu mengunduh perangkat lunak, itu dapat diketik kapan saja, remote control tidak harus bergantung pada komputer',
    kz: 'Бағдарламалық жасақтама жүктемей, кез келген уақытта баспашылық жасауға болады, компьютерге байланыс болмай-ақ кіріңіз',
    th: 'ไม่จำเป็นต้องดาวน์โหลดซอฟต์แวร์สามารถพิมพ์ได้ตลอดเวลารีโมทควบคุมไม่จำเป็นต้องพึ่งพาคอมพิวเตอร์',
    ug: 'يۇمشاق دېتال چۈشۈرۈشنىڭ ھاجىتى يوق، ھەر قانداق ۋاقىتتا تەرتىپلەشكە بولىدۇ، كومپيۇتېردىن مۇستەقىل',
    vi: 'Không cần tải xuống phần mềm, có thể phân ban bất cứ lúc nào, điều khiển từ xa không phụ thuộc vào máy tính',
    zh_tc: '無需下載軟件，任何時刻均可排版,遠程操控不必依賴於電腦',
    ru: 'Нет необходимости загружать программное обеспечение, вы можете редактировать его в любое время, удаленное управление не должно зависеть от компьютера',
    ko: '소프트웨어를 다운로드할 필요 없이, 언제든지 조판할 수 있으며, 원격 조종은 컴퓨터에 의존할 필요가 없다',
    bur: 'ဆော့ဖ်ဝဲဒေါင်းလုဒ်မလိုဘဲ မည်သည့်အချိန်မဆိုပြင်ဆင်နိုင်၊ ကွန်ပျူတာပေါ်မမှီခို',
    ben: 'সফটওয়্যার ডাউনলোড ছাড়াই যেকোনো সময় টাইপসেটিং করা যায়, রিমোট কন্ট্রোলে কম্পিউটারের উপর নির্ভর করতে হয় না',
    tr: 'Yazilim indirmenize gerek yok; istediginiz zaman dizgi yapabilir, uzaktan kontrolu bilgisayara bagli kalmadan gerceklestirebilirsiniz.',
    km: 'មិនចាំបាច់ទាញយកកម្មវិធី អាចរៀបប្លង់បានគ្រប់ពេល ហើយអាចបញ្ជាពីចម្ងាយដោយមិនចាំបាច់ពឹងផ្អែកលើកុំព្យូទ័រ',
    es: 'No es necesario descargar software, la composición tipográfica se puede realizar en cualquier momento, el control remoto no necesita depender de una computadora',
    ar: 'لا حاجة لتنزيل البرامج، يمكن إجراء التنضيد في أي وقت، ولا يحتاج التحكم عن بعد إلى الاعتماد على الكمبيوتر',
  },
  'home.intro.menue.case2.title': {
    zh: '多线生产',
    en: 'Multi-line Production',
    id: 'Produksi multi-line',
    kz: 'Көптін өнімділік',
    th: 'การผลิตหลายบรรทัด',
    ug: 'كۆپ لىنىيە ئىشلەپچىقىرىش',
    vi: 'Sản xuất đa dòng',
    zh_tc: '多線生產',
    ru: 'Многолинейное производство',
    ko: '다선 생산',
    bur: 'မျောမည်းထုတ်လုပ်မှု',
    ben: 'মাল্টি-লাইন উৎপাদন',
    tr: 'Cok Hatli Uretim',
    km: 'ការផលិតច្រើនខ្សែ',
    es: 'Producción de múltiples líneas',
    ar: 'الإنتاج متعدد الخطوط',
  },
  'home.intro.menue.case2.subTitle': {
    zh: '生产线快速切换',
    en: 'Quick switching between production lines',
    id: 'Sakelar cepat dari jalur produksi',
    kz: 'Өнімділік сызықты тез ауыстыру',
    th: 'สวิตช์ด่วนของสายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيىسىنى تېز ئالماشتۇرۇش',
    vi: 'Chuyển đổi nhanh chóng giữa các dòng sản xuất',
    zh_tc: '生產線快速切換',
    ru: 'Быстрое переключение производственных линий',
    ko: '빠른 생산 라인 전환',
    bur: 'ထုတ်လုပ်မှုလိုင်းမြန်မြန်ပြောင်း',
    ben: 'উৎপাদন লাইন দ্রুত পরিবর্তন',
    tr: 'Uretim Hatlari Arasinda Hizli Gecis',
    km: 'ប្ដូរខ្សែផលិតកម្មយ៉ាងរហ័ស',
    es: 'Cambio rápido de líneas de producción',
    ar: 'التبديل السريع لخطوط الإنتاج',
  },
  'home.intro.menue.case2.description': {
    zh: '支持多条生产线同时快速加工，生产线之间可以进行快速切换',
    en: 'Supports rapid processing on multiple production lines simultaneously, with quick switching between production lines.',
    id: 'Mendukung beberapa jalur produksi untuk diproses dengan cepat pada saat yang sama, dan dapat dengan cepat beralih di antara jalur produksi',
    kz: 'Көптеген өнімділік сызықтарын бір мезгілде тез өңдеуге және ауыстыруге қол жетімді',
    th: 'รองรับสายการผลิตหลายสายเพื่อดำเนินการอย่างรวดเร็วในเวลาเดียวกันและสามารถสลับระหว่างสายการผลิตได้อย่างรวดเร็ว',
    ug: 'بىر ۋاقىتتا نۇرغۇن ئىشلەپچىقىرىش لىنىيىسىنى قوللايدۇ، ئىشلەپچىقىرىش لىنىيىسىنى تېز ئالماشتۇرۇشقا بولىدۇ',
    vi: 'Hỗ trợ nhiều dòng sản xuất chế biến nhanh chóng đồng thời, có thể chuyển đổi nhanh chóng giữa các dòng sản xuất',
    zh_tc: '支持多條生產線同時快速加工，生產線之間可以進行快速切換',
    ru: 'Поддержка быстрой одновременной обработки нескольких производственных линий, быстрое переключение между производственными линиями',
    ko: '여러 생산 라인이 동시에 신속하게 가공되도록 지원하여 생산 라인 간에 신속한 전환이 가능합니다.',
    bur: 'တပြိုင်နက်ထုတ်လုပ်မှုလိုင်းများကိုပံ့ပိုး၊ ထုတ်လုပ်မှုလိုင်းများကြားမြန်မြန်ပြောင်းနိုင်',
    ben: 'একসাথে একাধিক উৎপাদন লাইন সমর্থন করে, উৎপাদন লাইনের মধ্যে দ্রুত স্যুইচ করা যায়',
    tr: 'Birden fazla uretim hattinda ayni anda hizli islemeyi destekler ve hatlar arasinda hizli gecis saglar.',
    km: 'គាំទ្រការកែច្នៃលឿនលើខ្សែផលិតកម្មជាច្រើនក្នុងពេលតែមួយ ហើយអាចប្ដូររវាងខ្សែផលិតកម្មបានយ៉ាងរហ័ស',
    es: 'Admite el procesamiento rápido de múltiples líneas de producción al mismo tiempo y puede rápidamente cambiar entre líneas de producción',
    ar: 'يدعم المعالجة السريعة لخطوط الإنتاج المتعددة في في نفس الوقت، ويمكن التبديل بسرعة بين خطوط الإنتاج',
  },
  'home.intro.menue.case3.title': {
    zh: '精细生产',
    en: 'Precise Production',
    id: 'Produksi yang baik',
    kz: 'Ең нәзік өнімділік',
    th: 'การผลิตที่ดี',
    ug: 'نەق تەرتىپلەش',
    vi: 'Sản xuất chi tiết',
    zh_tc: '精細生產',
    ru: 'Тщательное производство',
    ko: '정밀 생산',
    bur: 'တိကျသောထုတ်လုပ်မှု',
    ben: 'নির্ভুল উৎপাদন',
    tr: 'Hassas Uretim',
    km: 'ការផលិតច្បាស់លាស់',
    es: 'Producción fina',
    ar: 'الإنتاج الدقيق',
  },
  'home.intro.menue.case3.subTitle': {
    zh: '精细排版，精细参数设置',
    en: 'Precise typesetting and parameter settings',
    id: 'Tata letak halus, pengaturan parameter halus',
    kz: 'Ең назик баспашылық, параметрлерді назик баптау',
    th: 'เค้าโครงที่ดีการตั้งค่าพารามิเตอร์ที่ดี',
    ug: 'نەق تەرتىپلەش، نەق پارامېتىر تەڭشەش',
    vi: 'Phân ban chi tiết, cài đặt tham số chi tiết',
    zh_tc: '精細排版，精細參數設置',
    ru: 'Тщательная типография, тонкие параметры',
    ko: '세밀한 레이아웃, 세밀한 매개변수 설정',
    bur: 'တိကျသောပြင်ဆင်မှု၊ တိကျသောဘောင်သတ်မှတ်ချက်',
    ben: 'নির্ভুল লেআউট, নির্ভুল প্যারামিটার সেটিং',
    tr: 'Hassas Dizgi ve Parametre Ayarlari',
    km: 'ការរៀបប្លង់លម្អិត និងការកំណត់ប៉ារ៉ាម៉ែត្រលម្អិត',
    es: 'Composición tipográfica fina, configuración de parámetros fina',
    ar: 'التنضيد الدقيق وإعدادات المعلمات الدقيقة',
  },
  'home.intro.menue.case3.description': {
    zh: '精细排版，精细参数设置，让板件生产变得更加精确化',
    en: 'Precise typesetting and precise parameter settings, making panel production more accurate.',
    id: 'Tata letak halus dan pengaturan parameter halus untuk membuat produksi papan lebih akurat',
    kz: 'Ең назик баспашылық, параметрлерді назик баптау, тақталар өнімділігін назик етуге мүмкіндік береді',
    th: 'เค้าโครงที่ดีและการตั้งค่าพารามิเตอร์ที่ดีเพื่อให้การผลิตบอร์ดมีความแม่นยำมากขึ้น',
    ug: 'نەق تەرتىپلەش، نەق پارامېتىر تەڭشەش، تاختىلارنى تېخىمۇ توغرا ئىشلەپچىقىرىشقا بولىدۇ',
    vi: 'Phân ban chi tiết, cài đặt tham số chi tiết, làm cho sản xuất tấm trở nên chính xác hơn',
    zh_tc: '精細排版，精細參數設置，讓板件生產變得更加精確化',
    ru: 'Тщательная типография, тонкая настройка параметров, чтобы сделать производство листов более точным',
    ko: '정밀 조판, 정밀 파라미터 설정으로 판재 생산을 더욱 정밀하게 하다',
    bur: 'တိကျသောပြင်ဆင်မှုနှင့် တိကျသောဘောင်သတ်မှတ်ချက်ဖြင့် ပေါ်ဒ်ထုတ်လုပ်မှုပိုတိကျ',
    ben: 'নির্ভুল টাইপসেটিং এবং নির্ভুল প্যারামিটার সেটিং দিয়ে বোর্ড উৎপাদন আরও নির্ভুল করুন',
    tr: 'Hassas dizgi ve hassas parametre ayarlari, panel uretimini daha dogru hale getirir.',
    km: 'ការរៀបប្លង់លម្អិត និងការកំណត់ប៉ារ៉ាម៉ែត្រលម្អិត ធ្វើឱ្យការផលិតបន្ទះកាន់តែត្រឹមត្រូវ',
    es: 'La composición tipográfica fina y la configuración precisa de los parámetros hacen que la producción de paneles sea más precisa',
    ar: 'التنضيد الدقيق وإعدادات المعلمات الدقيقة تجعل إنتاج اللوحة أكثر دقة',
  },
  'home.intro.menue.case4.title': {
    zh: '自定义生产',
    en: 'Custom Production',
    id: 'Produksi Kustom',
    kz: 'Жеке өнімділік',
    th: 'การผลิตแบบกำหนดเอง',
    ug: 'خاس ئىشلەپچىقىرىش',
    vi: 'Sản xuất tùy chỉnh',
    zh_tc: '自定義生產',
    ru: 'Пользовательское производство',
    ko: '맞춤형 프로덕션',
    bur: 'ကိုယ်ပိုင်ပုံစံထုတ်လုပ်မှု',
    ben: 'কাস্টম উৎপাদন',
    tr: 'Ozel Uretim',
    km: 'ការផលិតតាមបំណង',
    es: 'Producción personalizada',
    ar: 'إنتاج مخصص',
  },
  'home.intro.menue.case4.subTitle': {
    zh: '自定义标签、五六面钻、余料形状',
    en: 'Custom labels, five/six-sided drilling, scrap shapes',
    id: 'Label khusus, latihan lima dan enam sisi, bentuk bahan residu',
    kz: 'Жеке этикеткалар, бес/алтышақты бурғылау, қалдық пішін',
    th: 'ฉลากที่กำหนดเองการฝึกซ้อมห้าและหกด้านรูปทรงวัสดุที่เหลืออยู่',
    ug: 'خاس بېلگە، بەش/ئالتە يۈزلىك ماتور، قېلىنما شەكلى',
    vi: 'Nhãn tùy chỉnh, máy khoan năm/sáu mặt, hình dạng dư liệu',
    zh_tc: '自定義標簽、五六面鑽、餘料形狀',
    ru: 'Настройка этикетки, пятигранное сверло, форма остатка',
    ko: '사용자 정의 레이블, 5, 6면 드릴, 여분 형태',
    bur: 'ကိုယ်ပိုင်တံဆိပ်၊ ငါး/ခြောက်မျက်နှာဖောက်၊ ပိုလျှံပစ္စည်းပုံသဏ္ဍာန်',
    ben: 'কাস্টম লেবেল, পাঁচ/ছয় মুখ ড্রিল, উদ্বৃত্ত আকৃতি',
    tr: 'Ozel Etiketler, Bes/Alti Yuzlu Delme, Artik Malzeme Sekilleri',
    km: 'ស្លាកផ្ទាល់ខ្លួន ការខួងប្រាំ/ប្រាំមួយមុខ និងរាងសំណល់សម្ភារៈ',
    es: 'Etiquetas personalizadas, taladros de cinco y seis lados personalizados y formas de material residual',
    ar: 'ملصقات مخصصة، ومثاقب مخصصة خماسية وسداسية الجوانب، وأشكال المواد المتبقية',
  },
  'home.intro.menue.case4.description': {
    zh: '自定义标签，自定义五六面钻，自定义余料形状，组合设备加工',
    en: 'Custom labels, custom five/six-sided drilling, custom scrap shapes, combined equipment processing.',
    id: 'Label Kustom, Latihan Lima dan Enam Sisi Kustom, Bentuk Bahan Residual Kustom, Pemrosesan Peralatan Gabungan',
    kz: 'Жеке этикеткалар, жеке бес/алтышақты бурғылау, жеке қалдық пішін, комбинациялық жабдықтармен өңдеу',
    th: 'ฉลากที่กำหนดเอง, การฝึกซ้อมห้าและหกด้านที่กำหนดเอง, รูปร่างวัสดุตกค้างที่กำหนดเอง, การประมวลผลอุปกรณ์รวม',
    ug: 'خاس بېلگە، خاس بەش/ئالتە يۈزلىك ماتور، خاس قېلىنما شەكلى، بىرلەشتۈرۈلگەن قورال ئىشلەش',
    vi: 'Nhãn tùy chỉnh, máy khoan năm/sáu mặt tùy chỉnh, hình dạng dư liệu tùy chỉnh, kết hợp các thiết bị chế biến',
    zh_tc: '自定義標簽，自定義五六面鑽，自定義餘料形狀，組合設備加工',
    ru: 'Настройка этикетки, Настройка пятигранного бурения, Настройка формы остатка, Комбинированная обработка оборудования',
    ko: '사용자 정의 라벨, 사용자 정의 5, 6면 드릴, 사용자 정의 여분 모양, 조합 설비 가공',
    bur: 'ကိုယ်ပိုင်တံဆိပ်၊ ကိုယ်ပိုင်ငါး/ခြောက်မျက်နှာဖောက်၊ ကိုယ်ပိုင်ပိုလျှံပုံသဏ္ဍာန်၊ ပေါင်းစပ်ကိရိယာထုတ်လုပ်မှု',
    ben: 'কাস্টম লেবেল, কাস্টম পাঁচ/ছয় মুখ ড্রিল, কাস্টম উদ্বৃত্ত আকৃতি, সম্মিলিত সরঞ্জাম প্রক্রিয়াকরণ',
    tr: 'Ozel etiketler, ozel bes/alti yuzlu delme, ozel artik malzeme sekilleri ve kombine ekipman isleme destegi.',
    km: 'គាំទ្រស្លាកផ្ទាល់ខ្លួន ការខួងប្រាំ/ប្រាំមួយមុខផ្ទាល់ខ្លួន រាងសំណល់សម្ភារៈផ្ទាល់ខ្លួន និងការកែច្នៃដោយឧបករណ៍រួមបញ្ចូល',
    es: 'Etiquetas personalizadas, taladros de cinco y seis lados personalizados, formas de material residual personalizado y procesamiento de equipos combinados',
    ar: 'ملصقات مخصصة، ومثاقب مخصصة خماسية وسداسية الجوانب، وأشكال مخصصة للمواد المتبقية، ومعالجة المعدات المجمعة',
  },
  'home.fangan.title': {
    zh: '行业专业解决方案',
    en: 'Industry Professional Solutions',
    id: 'Solusi Profesional di Industri',
    kz: 'Өнеркәсіптік кәсіпорындарға арналған профессионалды шешімдер',
    th: 'โซลูชั่นมืออาชีพในอุตสาหกรรม',
    ug: 'سانائەت تەجرىبىلىك چەت ئەل ھەل قىلىش',
    vi: 'Giải pháp chuyên nghiệp trong ngành',
    zh_tc: '行業專業解決方案',
    ru: 'Профессиональные отраслевые решения',
    ko: '업계 전문 솔루션',
    bur: 'လုပ်ငန်းကျွမ်းကျင်သောဖြေရှင်းချက်',
    ben: 'শিল্প পেশাদার সমাধান',
    tr: 'Sektor Icin Profesyonel Cozumler',
    km: 'ដំណោះស្រាយវិជ្ជាជីវៈសម្រាប់ឧស្សាហកម្ម',
    es: 'Soluciones profesionales de la industria',
    ar: 'حلول احترافية للصناعة',
  },
  'home.fangan.subTitle': {
    zh: ' 低成本，高产值，智能算法提高板件利用率，兼容多种设计软件，为用户提供最优生产方案 ',
    en: 'Low cost, high output value, intelligent algorithms increase panel utilization, compatible with various design software, providing users with the optimal production plan.',
    id: 'Biaya rendah, nilai output tinggi, algoritma cerdas meningkatkan pemanfaatan papan, kompatibel dengan berbagai perangkat lunak desain, memberikan solusi produksi terbaik kepada pengguna',
    kz: ' Төменгі бағасымен, жоғары өнімділікпен, интеллектуалды алгоритмдер арқылы тақта материалдарды тиімдірек пайдалануға болады. Бұл шешімдер көптеген дизайн бағдарламалармен үйлесімділікке ие және өнімділікті арттыруға мүмкіндік береді ',
    th: 'ค่าใช้จ่ายต่ำค่าเอาท์พุทสูงอัลกอริทึมอัจฉริยะปรับปรุงการใช้งานบอร์ดเข้ากันได้กับซอฟต์แวร์การออกแบบที่หลากหลายทำให้ผู้ใช้มีโซลูชันการผลิตที่ดีที่สุด',
    ug: 'تۆۋەن خىراجەت، يۇقىرى مەھسۇلات، ئەقىللىق ئالگورىتىم تاختىنى تېخىمۇ يۇقىرى پايدىلىنىش نىسبىتىگە ئېرىشتۈرىدۇ، نۇرغۇن خىل لايىھىلەش يۇمشاق دېتىلىرىنى قوللايدۇ، ئىشلەتكۈچىلەرگە ئەڭ ياخشى ئىشلەپچىقىرىش پىلانىنى تەمىنلەيدۇ',
    vi: 'Chi phí thấp, sản lượng cao, thuật toán thông minh tăng cường tỷ lệ sử dụng tấm, tương thích với nhiều phần mềm thiết kế, cung cấp cho người dùng giải pháp sản xuất tối ưu',
    zh_tc:
      ' 低成本，高產值，智能算法提高板件利用率，兼容多種設計軟件，為用戶提供最優生產方案 ',
    ru: 'Низкая стоимость, высокая производительность, интеллектуальные алгоритмы для улучшения использования панелей, совместимые с различными программными средствами проектирования, для пользователей, чтобы обеспечить оптимальное производство',
    ko: '낮은 비용, 높은 생산성, 지능형 알고리즘으로 보드 활용도를 높이고 다양한 디자인 소프트웨어와 호환되며 사용자에게 최적의 생산 방안을 제공합니다.',
    bur: 'ကုန်ကျစရိတ်နည်း၊ ထုတ်ကုန်တန်ဖိုးမြင့်၊ ဉာဏ်ပညာအယ်လဂိုရီသမ်ဖြင့် ပေါ်ဒ်အသုံးချမှုနှုန်းတိုးတက်ကာ ဒီဇိုင်းဆော့ဖ်ဝဲများနှင့်ကိုက်ညီ',
    ben: 'কম খরচ, উচ্চ উৎপাদন মূল্য, বুদ্ধিমান অ্যালগরিদম বোর্ড ব্যবহার বাড়ায়, বিভিন্ন ডিজাইন সফটওয়্যারের সাথে সামঞ্জস্যপূর্ণ',
    tr: 'Dusuk maliyet, yuksek verim; akilli algoritmalar panel kullanimini artirir, cesitli tasarim yazilimlariyla uyumludur ve kullanicilara en uygun uretim planini sunar.',
    km: 'ចំណាយទាប តម្លៃផលិតកម្មខ្ពស់ ក្បួនដោះស្រាយឆ្លាតវៃបង្កើនអត្រាប្រើប្រាស់បន្ទះ សមស្របជាមួយកម្មវិធីរចនាជាច្រើន និងផ្តល់ផែនការផលិតល្អបំផុតដល់អ្នកប្រើប្រាស់',
    es: 'Bajo costo, alto valor de producción, algoritmos inteligentes mejoran la utilización del panel y son compatibles con múltiples software de diseño para brindar a los usuarios soluciones de producción óptimas',
    ar: 'تكلفة منخفضة، وقيمة إخراج عالية، وخوارزميات ذكية تعمل على تحسين استخدام اللوحة، ومتوافقة مع برامج التصميم المتعددة لتزويد المستخدمين بالإنتاج الأمثل الحلول',
  },
  'home.fangan.menue.case1.title': {
    zh: '线上接单生产一体化',
    en: 'Integrated Online Order Reception and Production',
    id: 'Integrasi Produksi Pengambilan Pesanan Online',
    kz: 'Онлайн ордерлік өндіріс біріктірілу',
    th: 'การรวมการผลิตแบบสั่งซื้อออนไลน์',
    ug: 'توردا زاكاز قوبۇل قىلىش ۋە ئىشلەپچىقىرىش بىرلەشتۈرۈش',
    vi: 'Hòan thành sản xuất đơn hàng trực tuyến',
    zh_tc: '線上接單生產一體化',
    ru: 'Интеграция линейного производства',
    ko: '온라인 주문 생산 일체화',
    bur: 'အွန်လိုင်းအော်ဒါ-ထုတ်လုပ်မှုပေါင်းစပ်',
    ben: 'অনলাইন অর্ডার রিসেপশন ও উৎপাদন একীভূত',
    tr: 'Cevrim Ici Siparis ve Uretim Entegrasyonu',
    km: 'ការរួមបញ្ចូលការទទួលបញ្ជាទិញអនឡាញ និងការផលិត',
    es: 'En línea toma de pedidos e integración de producción',
    ar: 'تلقي الطلبات عبر الإنترنت وتكامل الإنتاج',
  },
  'home.fangan.menue.case1.description': {
    zh: ' 远程线上操作，跨越空间阻碍，随时输出订单同步工厂，设计生产同步完成 ',
    en: 'Remote online operation, overcoming spatial obstacles, orders can be synchronized to the factory at any time, design and production completed synchronously.',
    id: 'Operasi online jarak jauh, hambatan lintas ruang, pesanan output kapan saja, dan desain lengkap dan sinkronisasi produksi',
    kz: ' Қашықтан онлайн операциялар, кеңістіктің шектеулерін асып, кез келген уақытта ордерлерді зауытқа жіберу және дизайн мен өндіріс синхрондықтай бастау',
    th: 'การดำเนินการออนไลน์ระยะไกลอุปสรรคข้ามอวกาศคำสั่งเอาท์พุทได้ตลอดเวลาและการออกแบบการออกแบบและการซิงโครไนซ์การผลิตที่สมบูรณ์',
    ug: 'ئىشلەپچىقىرىش بىلەن بىر ۋاقىتتا زاكاز قوبۇل قىلىش، لايىھىلەش بىلەن ئىشلەپچىقىرىشنى بىر ۋاقىتتا تاماملايدۇ',
    vi: 'Thao tác trực tuyến từ xa, vượt qua trở ngại không gian, đồng bộ hóa đơn hàng đến nhà máy bất cứ lúc nào, thiết kế và sản xuất hoàn thành đồng bộ',
    zh_tc:
      ' 遠程線上操作，跨越空間阻礙，隨時輸出訂單同步工廠，設計生產同步完成 ',
    ru: 'Удаленная онлайновая работа, преодоление пространственных препятствий, выход заказов в любое время синхронизация завода, проектирование и производство синхронизация завершения',
    ko: '원격 온라인 조작, 공간 장애를 뛰어넘고, 수시로 주문 동시 공장을 수출하고, 설계 생산 동시 완성',
    bur: 'ဝေးလဲသောအွန်လိုင်းလုပ်ဆောင်မှု၊ အချိန်မရွေးအော်ဒါကိုစက်ရုံသို့ပေးပို့နိုင်၊ ဒီဇိုင်းနှင့်ထုတ်လုပ်မှုတပြိုင်နက်ပြီးဆုံး',
    ben: 'রিমোট অনলাইন অপারেশন, যেকোনো সময় অর্ডার কারখানায় সিঙ্ক্রোনাইজ, ডিজাইন ও উৎপাদন একসাথে সম্পন্ন',
    tr: 'Uzaktan cevrim ici islem, mekan engellerini asar; siparisler her an fabrikaya senkronize edilir ve tasarim ile uretim es zamanli tamamlanir.',
    km: 'ប្រតិបត្តិការអនឡាញពីចម្ងាយ ឆ្លងកាត់ឧបសគ្គផ្នែកលំហ អាចបញ្ជូនការបញ្ជាទិញទៅរោងចក្របានគ្រប់ពេល ហើយការរចនា និងការផលិតត្រូវបានបញ្ចប់ស្របពេលគ្នា',
    es: 'Operación remota en línea, superación de obstáculos de espacio, emisión de pedidos en cualquier momento para sincronizar la fábrica y finalización del diseño y la producción simultáneamente',
    ar: 'التشغيل عبر الإنترنت عن بعد، والتغلب على عوائق المساحة، وإخراج الطلبات في أي وقت لمزامنة المصنع، واستكمال التصميم والإنتاج في وقت واحد',
  },
  'home.fangan.menue.case2.title': {
    zh: '一键切换生产线',
    en: 'One-click Switching between Production Lines',
    id: 'Jalur produksi switching satu klik',
    kz: 'Бір батырмамен өндіріс желісі ауысу',
    th: 'สายการผลิตสลับคลิกเดียว',
    ug: 'بىر تۇتاش ئىشلەپچىقىرىش لىنىيىسىنى ئالماشتۇرۇش',
    vi: 'Chuyển đổi dây chuyền sản xuất bằng một nút',
    zh_tc: '一鍵切換生產線',
    ru: 'Переключить производственную линию',
    ko: '원클릭으로 생산 라인을 전환하다.',
    bur: 'တစ်ချက်နှိပ်ပြောင်းထုတ်လုပ်မှုလိုင်း',
    ben: 'এক ক্লিকে উৎপাদন লাইন পরিবর্তন',
    tr: 'Uretim Hatlari Arasinda Tek Tikla Gecis',
    km: 'ប្ដូរខ្សែផលិតកម្មដោយចុចម្តង',
    es: 'Cambio de líneas de producción con un solo clic',
    ar: 'تبديل خطوط الإنتاج بنقرة واحدة',
  },
  'home.fangan.menue.case2.description': {
    zh: '自定义生产线，支持多生产线，多类型设备对接',
    en: 'Customizable production lines, supporting multiple production lines and multiple types of equipment docking.',
    id: 'Jalur produksi khusus, mendukung beberapa jalur produksi, dan docking peralatan multi-tipe',
    kz: 'Өзіндікеше ондіріс желісі, бірнеше өндіріс желісі мен көптілік құрылғыларды біріктіруге қолдайды',
    th: 'สายการผลิตที่กำหนดเองรองรับสายการผลิตหลายสายและการเชื่อมต่ออุปกรณ์หลายประเภท',
    ug: 'خاس ئىشلەپچىقىرىش لىنىيىسى، نۇرغۇن ئىشلەپچىقىرىش لىنىيىسى، نۇرغۇن خىل قوراللارنى قوللايدۇ',
    vi: 'Dây chuyền sản xuất tùy chỉnh, hỗ trợ nhiều dây chuyền sản xuất, kết nối nhiều loại thiết bị',
    zh_tc: '自定義生產線，支持多生產線，多類型設備對接',
    ru: 'Настройка производственных линий, поддержка многопроизводственных линий, стыковка многотипного оборудования',
    ko: '맞춤형 라인, 다중 라인 지원, 다중 유형 장치 도킹',
    bur: 'ကိုယ်ပိုင်ထုတ်လုပ်မှုလိုင်း၊ ထုတ်လုပ်မှုလိုင်းများနှင့် ကိရိယာအမျိုးအစားများပံ့ပိုး',
    ben: 'কাস্টমাইজযোগ্য উৎপাদন লাইন, একাধিক উৎপাদন লাইন এবং একাধিক ধরনের সরঞ্জাম সংযোগ সমর্থন',
    tr: 'Ozellestirilebilir uretim hatlari; birden fazla hatti ve farkli turde ekipman baglantilarini destekler.',
    km: 'ខ្សែផលិតកម្មអាចប្ដូរតាមតម្រូវការ គាំទ្រខ្សែផលិតកម្មច្រើន និងការតភ្ជាប់ឧបករណ៍ច្រើនប្រភេទ',
    es: 'Líneas de producción personalizadas, que admiten múltiples líneas de producción y acoplamiento de equipos de varios tipos',
    ar: 'خطوط إنتاج مخصصة، ودعم خطوط إنتاج متعددة ورسو المعدات متعددة الأنواع',
  },
  'home.fangan.menue.case3.title': {
    zh: '智能算法提高板材利用率',
    en: 'Intelligent Algorithm Improves Panel Utilization',
    id: 'Algoritma cerdas meningkatkan pemanfaatan dewan',
    kz: 'Интеллектуалды алгоритмдер тақта материалдарды тиімдірек пайдалануға мүмкіндік береді',
    th: 'อัลกอริทึมอัจฉริยะปรับปรุงการใช้งานบอร์ด',
    ug: 'ئەقىللىق ئالگورىتىم تاختىنى تېخىمۇ يۇقىرى پايدىلىنىش نىسبىتىگە ئېرىشتۈرىدۇ',
    vi: 'Thuật toán thông minh tăng cường tỷ lệ sử dụng tấm',
    zh_tc: '智能算法提高板材利用率',
    ru: 'Интеллектуальные алгоритмы улучшают использование листов',
    ko: '지능 알고리즘으로 판재 이용률 향상',
    bur: 'ဉာဏ်ပညာအယ်လဂိုရီသမ်ဖြင့် ပေါ်ဒ်အသုံးချမှုနှုန်းတိုး',
    ben: 'বুদ্ধিমান অ্যালগরিদমে বোর্ড উপকরণ ব্যবহার হার বৃদ্ধি',
    tr: 'Akilli Algoritma Panel Kullanimini Artirir',
    km: 'ក្បួនដោះស្រាយឆ្លាតវៃបង្កើនអត្រាប្រើប្រាស់បន្ទះ',
    es: 'El algoritmo inteligente mejora la utilización de las planchas',
    ar: 'تعمل الخوارزمية الذكية على تحسين استخدام اللوحة',
  },
  'home.fangan.menue.case3.description': {
    zh: '传统算法板材利用率低，智能算法精细参数设置，定制生产方案',
    en: 'Traditional algorithms have low panel utilization, intelligent algorithms provide precise parameter settings, customized production plans.',
    id: 'Pemanfaatan Dewan Algoritma Tradisional Rendah, Pengaturan Parameter Baik Algoritma Cerdas, Rencana Produksi Kustomisasi',
    kz: 'Традиционалды алгоритмдерде тақта материалдарды пайдаланудың тиімділігі төмен. Интеллектуалды алгоритмдермен параметрлерді нарықтай баптау және өнімділікті арттыруға арналған шешімдер',
    th: 'การใช้ประโยชน์จากบอร์ดอัลกอริทึมแบบดั้งเดิมอยู่ในระดับต่ำอัลกอริทึมอัลกอริทึมการตั้งค่าพารามิเตอร์ที่ดีแผนการผลิตที่กำหนดเอง',
    ug: 'ئەنئەنىۋى ئالگورىتىمدە تاختىنى پايدىلىنىش نىسبىتى تۆۋەن، ئەقىللىق ئالگورىتىمدە نەق پارامېتىر تەڭشەش، خاس ئىشلەپچىقىرىش پىلانى',
    vi: 'Thuật toán truyền thống có tỷ lệ sử dụng tấm thấp, thuật toán thông minh có cài đặt tham số chi tiết, cung cấp giải pháp sản xuất tùy chỉnh',
    zh_tc: '傳統算法板材利用率低，智能算法精細參數設置，定制生產方案',
    ru: 'Низкое использование традиционных алгоритмических панелей, тонкие параметры интеллектуальных алгоритмов, индивидуальные производственные схемы',
    ko: '전통적인 알고리즘 판재 이용률이 낮고, 스마트 알고리즘 정밀 파라미터 설정, 맞춤형 생산 방안',
    bur: 'ရိုးရာအယ်လဂိုရီသမ်ပေါ်ဒ်အသုံးချမှုနှုန်းနိမ့်၊ ဉာဏ်ပညာအယ်လဂိုရီသမ်တိကျသောဘောင်သတ်မှတ်ချက်ဖြင့် ကိုယ်ပိုင်ထုတ်လုပ်မှုစီမံချက်',
    ben: 'প্রচলিত অ্যালগরিদমে বোর্ড ব্যবহার হার কম, বুদ্ধিমান অ্যালগরিদমে নির্ভুল প্যারামিটার সেটিং, কাস্টমাইজড উৎপাদন পরিকল্পনা',
    tr: 'Geleneksel algoritmalarda panel kullanim orani dusuktur; akilli algoritmalar hassas parametre ayarlari ve ozellestirilmis uretim planlari sunar.',
    km: 'ក្បួនដោះស្រាយបុរាណមានអត្រាប្រើប្រាស់បន្ទះទាប ខណៈដែលក្បួនដោះស្រាយឆ្លាតវៃផ្តល់ការកំណត់ប៉ារ៉ាម៉ែត្រលម្អិត និងផែនការផលិតតាមបំណង',
    es: 'El algoritmo tradicional tiene una baja utilización de las planchas, un algoritmo inteligente de configuración fina de parámetros y un plan de producción personalizado',
    ar: 'تتميز الخوارزمية التقليدية باستخدام منخفض للوحة، وإعداد خوارزمية ذكية للمعلمات الدقيقة، وخطة إنتاج مخصصة',
  },
  'home.fangan.menue.case4.title': {
    zh: '专业切割方案',
    en: 'Professional Cutting Solutions',
    id: 'Rencana pemotongan profesional',
    kz: 'Профессиональды кесу шесімі',
    th: 'แผนการตัดมืออาชีพ',
    ug: 'تەجرىبىلىك كېسىش پىلانى',
    vi: 'Giải pháp cắt tấm chuyên nghiệp',
    zh_tc: '專業切割方案',
    ru: 'Программа профессиональной резки',
    ko: '전문 절단 시나리오',
    bur: 'ကျွမ်းကျင်သောဖြတ်တောက်မှုစီမံချက်',
    ben: 'পেশাদার কাটিং সমাধান',
    tr: 'Profesyonel Kesim Cozumleri',
    km: 'ដំណោះស្រាយកាត់ជំនាញវិជ្ជាជីវៈ',
    es: 'Solución de corte profesional',
    ar: 'حل القطع الاحترافي',
  },
  'home.fangan.menue.case4.description': {
    zh: '优化切割顺序、下刀点，让路径更短切割更稳',
    en: 'Optimize cutting sequence and cutting points, making the path shorter and cutting more stable.',
    id: 'Optimalkan urutan pemotongan dan titik pemotongan untuk membuat jalur lebih pendek dan lebih stabil',
    kz: 'Кесу реттілігі мен кесу бастамасын оптималдау, кесу жолдарын қысқа және кесудің тұрақтылығын арттыру',
    th: 'เพิ่มประสิทธิภาพลำดับการตัดและจุดตัดเพื่อให้เส้นทางสั้นลงและมีเสถียรภาพมากขึ้น',
    ug: 'كېسىش تەرتىپى، كېسىش نۇقتىسىنى ئەڭ ياخشىلاشتۇرۇش، يولنى قىسقارتىش ۋە كېسىشنى مۇقىم قىلىش',
    vi: 'Tối ưu hóa thứ tự cắt, điểm cắt, làm cho đường đi ngắn hơn, cắt ổn định hơn',
    zh_tc: '優化切割順序、下刀點，讓路徑更短切割更穩',
    ru: 'Оптимизируйте порядок резки, точку падения, так что путь короче и резка более стабильна',
    ko: '패스가 짧고 안정적으로 가공되도록 가공 순서, 언더컷 점 최적화',
    bur: 'ဖြတ်တောက်မှုအစဉ်နှင့် ဖြတ်တောက်မှုနေရာကိုကောင်းမွန်အောင်ပြုလုပ်ပြီး လမ်းကြောင်းပိုတိုကာ ဖြတ်တောက်မှုပိုတည်ငြိမ်',
    ben: 'কাটার ক্রম ও কাটার বিন্দু অপ্টিমাইজ করে পথ ছোট এবং কাটা আরও স্থিতিশীল করুন',
    tr: 'Kesim sirasini ve baslangic noktalarini optimize ederek yolu kisaltir ve kesimi daha stabil hale getirir.',
    km: 'បង្កើនប្រសិទ្ធភាពលំដាប់កាត់ និងចំណុចចាប់កាត់ ធ្វើឱ្យផ្លូវខ្លីជាងមុន និងការកាត់មានស្ថិរភាពជាងមុន',
    es: 'Optimice la secuencia de corte y el punto de corte para hacer que la ruta de corte sea más corta y estable',
    ar: 'تحسين تسلسل القطع ونقطة القطع لجعل مسار القطع أقصر وأكثر استقرارًا',
  },
  'home.aboutUs.title1': {
    zh: '新格尔人居科技',
    en: 'Xingeer Human Settlements Technology',
    id: 'Teknologi Tempat Tinggal Manusia Xingeer',
    kz: 'Шинэгэр Үй-Жай Технологиясы',
    th: 'เทคโนโลยีที่อยู่อาศัยของมนุษย์ Xingeer',
    ug: 'يېڭى گېر ئىنسان تۇرمۇش تېخنىكىسى',
    vi: 'Công nghệ nghị định cư Tân Giác',
    zh_tc: '新格爾人居科技',
    ru: 'Технология « Нью - Гэл»',
    ko: '뉴 겔 주거 기술',
    bur: 'Xingeer မানবဂေဟာနည်းပညာ',
    ben: 'Xingeer মানব বসতি প্রযুক্তি',
    tr: 'Xingeer Yasam Teknolojisi',
    km: 'បច្ចេកវិទ្យាលំនៅឋានមនុស្ស Xingeer',
    es: 'Xinger Habitat Technology',
    ar: 'Xinger Habitat Technology',
  },
  'home.aboutUs.subTitle': {
    zh: '家具生产业变革创领者',
    en: 'Leader in the Transformation of the Furniture Manufacturing Industry',
    id: 'Pemimpin dalam transformasi industri produksi furnitur',
    kz: 'Өрек жасау өнеркәсіптің трансформациялық лидер',
    th: 'ผู้นำในการเปลี่ยนแปลงของอุตสาหกรรมการผลิตเฟอร์นิเจอร์',
    ug: 'ئۆي جىھازلىرى سانائىتىنىڭ ئۆزگىرىشچان قۇرغۇچىسى',
    vi: 'Nhà lãnh đạo trong cuộc cách mạng sản xuất đồ nội thất',
    zh_tc: '家具生產業變革創領者',
    ru: 'Менеджеры мебельной индустрии',
    ko: '가구 산업 변혁의 창시자',
    bur: 'မိုဘိုင်ထုတ်လုပ်မှုလုပ်ငန်းပြောင်းလဲမှုဦးဆောင်သူ',
    ben: 'আসবাবপত্র উৎপাদন শিল্পের রূপান্তর নেতা',
    tr: 'Mobilya Uretim Sektorunde Donusumun Oncusu',
    km: 'អ្នកដឹកនាំការផ្លាស់ប្តូរនៃឧស្សាហកម្មផលិតគ្រឿងសង្ហារឹម',
    es: 'Líder en la transformación de la industria de producción de muebles',
    ar: 'شركة رائدة في تحويل صناعة إنتاج الأثاث',
  },
  'home.aboutUs.description': {
    zh: '新格尔企业，专注实现传统家具生产业的互联网变革',
    en: 'Xingeer Enterprise, focused on realizing the internet transformation of the traditional furniture manufacturing industry.',
    id: 'Xingeer Enterprise berfokus pada mewujudkan transformasi internet industri produksi furnitur tradisional',
    kz: 'Шинэгер компаниясы традиционалды өрек жасау өнеркәсібін интернетке трансформациялауға маманданған',
    th: 'Xingeer Enterprise มุ่งเน้นไปที่การตระหนักถึงการเปลี่ยนแปลงทางอินเทอร์เน็ตของอุตสาหกรรมการผลิตเฟอร์นิเจอร์แบบดั้งเดิม',
    ug: 'يېڭى گېر كارخانىسى، ئەنئەنىۋى ئۆي جىھازلىرى سانائىتىنى ئىنتېرنېت ئارقىلىق ئۆزگەرتىشكە دىققەت قىلىدۇ',
    vi: 'Doanh nghiệp Tân Giác, chuyên chú thực hiện cuộc cách mạng internet trong ngành sản xuất đồ nội thất truyền thống',
    zh_tc: '新格爾企業，專注實現傳統家具生產業的互聯網變革',
    ru: 'Компания New Geel Enterprise, специализирующаяся на интернет - изменениях в традиционном производстве мебели',
    ko: '신겔 기업, 전통 가구 산업 의 인터넷 변혁 에 집중 하다',
    bur: 'Xingeer ကုမ္ပဏီ၊ ရိုးရာမိုဘိုင်ထုတ်လုပ်မှုလုပ်ငန်း၏ ဆက်သွယ်ရေးအပြောင်းအလဲကိုဦးတည်',
    ben: 'Xingeer কোম্পানি, ঐতিহ্যবাহী আসবাবপত্র উৎপাদন শিল্পের ইন্টারনেট রূপান্তর বাস্তবায়নে মনোযোগী',
    tr: 'Xingeer, geleneksel mobilya uretim sektorunun internet tabanli donusumunu gerceklestirmeye odaklanmistir.',
    km: 'សហគ្រាស Xingeer ផ្តោតលើការធ្វើឱ្យមានការប្រែប្រួលតាមអ៊ីនធឺណិតសម្រាប់ឧស្សាហកម្មផលិតគ្រឿងសង្ហារឹមបុរាណ',
    es: 'Xinger Enterprise, que se centra en realizar la transformación de Internet de la industria de producción de muebles tradicional',
    ar: 'Xinger Enterprise، مع التركيز على تحقيق التحول عبر الإنترنت لصناعة إنتاج الأثاث التقليدي',
  },
  'home.aboutUs.culture.case1.title': {
    zh: '企业宗旨',
    en: 'Enterprise Purpose',
    id: 'Tujuan perusahaan',
    kz: 'Корпоративтік мақсаты',
    th: 'วัตถุประสงค์ขององค์กร',
    ug: 'كارخانا مەقسىتى',
    vi: 'Mục đích kinh doanh',
    zh_tc: '企業宗旨',
    ru: 'Цель предприятия',
    ko: '기업의 목적',
    bur: 'ကုမ္ပဏီမူရင်းရည်ရွယ်ချက်',
    ben: 'কোম্পানির উদ্দেশ্য',
    tr: 'Kurumsal Amac',
    km: 'គោលបំណងសហគ្រាស',
    es: 'Propósito corporativo',
    ar: 'غرض الشركة',
  },
  'home.aboutUs.culture.case1.subTitle': {
    zh: '帮助工厂，三倍增长',
    en: 'Help factories achieve triple growth',
    id: 'Membantu pabrik tumbuh tiga kali lipat',
    kz: 'Заводтарға үш есе өсім беру',
    th: 'ช่วยให้โรงงานเติบโตสาม',
    ug: 'فابرىكىلارغا ياردەم بېرىش، ئۈچ ھەسسە ئاشۇرۇش',
    vi: 'Giúp nhà máy tăng trưởng ba lần',
    zh_tc: '幫助工廠，三倍增長',
    ru: 'Помочь заводу, утроить рост',
    ko: '3배 증가한 공장 지원',
    bur: 'စက်ရုံကိုကူညီ၊ သုံးဆတိုးတက်',
    ben: 'কারখানাকে সাহায্য করুন, তিনগুণ বৃদ্ধি',
    tr: 'Fabrikalarin Uc Kat Buyumesine Yardim Etmek',
    km: 'ជួយរោងចក្រឲ្យរីកចម្រើនបីដង',
    es: 'Ayudar a las fábricas a triplicarse',
    ar: 'مساعدة المصانع على النمو ثلاثة أضعاف',
  },
  'home.aboutUs.culture.case2.title': {
    zh: '文化价值观',
    en: 'Cultural Values',
    id: 'Nilai Budaya',
    kz: 'Культуралық құндылықтар',
    th: 'ค่าวัฒนธรรม',
    ug: 'مەدەنىيەت قىممەت قارىشى',
    vi: 'Giá trị văn hóa',
    zh_tc: '文化價值觀',
    ru: 'Культурные ценности',
    ko: '문화적 가치관',
    bur: 'ယဉ်ကျေးမှုတန်ဖိုးများ',
    ben: 'সাংস্কৃতিক মূল্যবোধ',
    tr: 'Kulturel Degerler',
    km: 'តម្លៃវប្បធម៌',
    es: 'Valores culturales',
    ar: 'القيم الثقافية',
  },
  'home.aboutUs.culture.case2.subTitle': {
    zh: '以客户为中心，以奋斗者为本，艰苦奋斗，造福人民',
    en: 'Customer-centered, based on the efforts of employees, hard work, benefiting the people',
    id: 'Berpusat pada pelanggan, berjuang untuk orang-orang, bekerja keras dan bermanfaat bagi orang-orang',
    kz: 'Клиенттерге бағытталған, еңбекшілерге негізделген, қиын еңбекпен, халққа файда әкелу',
    th: 'ลูกค้าเป็นศูนย์กลางมุ่งมั่นเพื่อคนทำงานหนักและเป็นประโยชน์ต่อผู้คน',
    ug: 'خېرىدارغا مەركەزلەشكەن، كۈرەشچانلارغا ئاساسلانغان، قاتتىق كۈرەش قىلىش، خەلقنىڭ پايدىسىنى قوغداش',
    vi: 'Duy trì khách hàng là trung tâm, lấy người lao động là cốt lõi, nhân vật khổ sở, mang lại phúc lợi cho nhân dân',
    zh_tc: '以客戶為中心，以奮鬥者為本，艱苦奮鬥，造福人民',
    ru: 'Клиенты как центр, борцы как центр, упорная борьба на благо людей',
    ko: '고객을 중심으로, 분투자의 근본으로, 간고분투하여 인민을 행복하게 하다',
    bur: 'ဖောက်သည်ကိုဗဟိုပြု၊ ကြိုးစားသူကိုအခြေပြု၊ ကြိုးကြိုးစားစားလုပ်ဆောင်ကာ လူမှုဖူလုံရေးဆောင်ရွက်',
    ben: 'গ্রাহককেন্দ্রিক, কর্মীদের প্রচেষ্টার উপর ভিত্তি করে, কঠোর পরিশ্রম, মানুষের উপকার করা',
    tr: 'Musteri odakli, emek verenleri temel alan, cok calisan ve topluma fayda saglayan anlayis',
    km: 'ផ្តោតលើអតិថិជន យកអ្នកខិតខំប្រឹងប្រែងជាមូលដ្ឋាន ប្រឹងប្រែងយ៉ាងលំបាក និងផ្តល់អត្ថប្រយោជន៍ដល់ប្រជាជន',
    es: 'Centrado en el cliente, orientado al esfuerzo, trabajo duro y beneficio de las personas',
    ar: 'التركيز على العملاء، وتوجيه المجتهد، والعمل الجاد، والاستفادة الناس',
  },
  'home.aboutUs.culture.case3.title': {
    zh: '指导思想',
    en: 'Guiding Ideology',
    id: 'Ideologi membimbing',
    kz: 'Нұсқаулық бағыт',
    th: 'แนวทางอุดมการณ์',
    ug: 'يېتەكچى پىكىر',
    vi: 'Hướng dẫn tư tưởng',
    zh_tc: '指導思想',
    ru: 'Руководящая идеология',
    ko: '지도 사상',
    bur: 'လမ်းညွှန်အတွေးအခေါ်',
    ben: 'গাইডিং আদর্শ',
    tr: 'Yonlendirici Dusunce',
    km: 'គំនិតណែនាំ',
    es: 'Ideología rectora',
    ar: 'الأيديولوجية التوجيهية',
  },
  'home.aboutUs.culture.case3.subTitle': {
    zh: '群众路线，搭建具有销售力、产品力、组织力的精英团队',
    en: 'Mass line, building an elite team with sales force, product force, and organizational force',
    id: 'Jalur massal, membangun tim elit dengan penjualan, produk, dan kekuatan organisasi',
    kz: 'Халык жолымен, сатуу, өнімділік, ұйымдастықпен біріктірілген элита командасын құру',
    th: 'Mass Line สร้างทีมชั้นยอดด้วยยอดขายผลิตภัณฑ์และความแข็งแกร่งขององค์กร',
    ug: 'خەلق يولى، سېتىش كۈچى، مەھسۇلات كۈچى، تەشكىل كۈچىگە ئىگە ئەلا گۇرۇپپا قۇرۇش',
    vi: 'Đường lối quần chúng, xây dựng đội ngũ ưu tú có khả năng bán hàng, sản phẩm, tổ chức',
    zh_tc: '群眾路線，搭建具有銷售力、產品力、組織力的精英團隊',
    ru: 'Массовые маршруты, создание элитной команды с способностью продавать, производительностью, организационной силой',
    ko: '대중 노선, 판매력, 제품력, 조직력을 갖춘 엘리트 팀 구축',
    bur: 'ပြည်သူ့လမ်းကြောင်း၊ ရောင်းချမှုကြိုးကြိုးစားစား၊ ထုတ်ကုန်ကြိုးကြိုးစားစား၊ ဖွဲ့စည်းမှုကြိုးကြိုးစားစားဖြင့် ထူးချွန်ဆဲဆဲအဖွဲ့တည်ဆောက်',
    ben: 'গণ লাইন, বিক্রয় শক্তি, পণ্য শক্তি, সাংগঠনিক শক্তি সম্পন্ন এলিট টিম গড়ুন',
    tr: 'Kitle cizgisi anlayisiyla; satis, urun ve organizasyon gucune sahip seckin bir ekip kurmak',
    km: 'ប្រើប្រាស់ផ្លូវមហាជន ដើម្បីបង្កើតក្រុមឆ្នើមដែលមានសមត្ថភាពផ្នែកលក់ ផលិតផល និងការរៀបចំ',
    es: 'Línea de masas, construya un equipo de élite con poder de ventas, poder de producto y poder organizacional',
    ar: 'الخط الشامل، بناء فريق النخبة مع قوة المبيعات، وقوة المنتج، والقوة التنظيمية',
  },
  'home.aboutUs.feature.case1': {
    zh: '专业团队维护',
    en: 'Professional Team Maintenance',
    id: 'Pemeliharaan Tim Profesional',
    kz: 'Кәсіби топтық техникалық қызметтеу',
    th: 'การบำรุงรักษาทีมงานระดับมืออาชีพ',
    ug: 'تەجرىبىلىك گۇرۇپپا قوغداش',
    vi: 'Đoàn ngũ chuyên nghiệp bảo trì',
    zh_tc: '專業團隊維護',
    ru: 'Техническое обслуживание профессиональных групп',
    ko: '전문 팀 유지 관리',
    bur: 'ကျွမ်းကျင်သောအဖွဲ့ထိန်းသိမ်း',
    ben: 'পেশাদার টিম রক্ষণাবেক্ষণ',
    tr: 'Profesyonel Ekip Bakimi',
    km: 'ការថែទាំដោយក្រុមជំនាញ',
    es: 'Mantenimiento del equipo profesional',
    ar: 'صيانة الفريق المحترف',
  },
  'home.aboutUs.feature.case2': {
    zh: '持续更新迭代',
    en: 'Continuous Updates and Iterations',
    id: 'Pembaruan dan iterasi berkelanjutan',
    kz: 'Үнемі жаңарту және итерлеу',
    th: 'การอัปเดตและการทำซ้ำอย่างต่อเนื่อง',
    ug: 'دائىم يېڭىلىنىپ تۇرۇش',
    vi: 'Cập nhật và thay thế liên tục',
    zh_tc: '持續更新迭代',
    ru: 'Постоянно обновлять итерацию',
    ko: '지속적인 업데이트 반복',
    bur: 'ဆက်လက်အပ်ဒိတ်ပြောင်းလဲ',
    ben: 'ক্রমাগত আপডেট ও পুনরাবৃত্তি',
    tr: 'Surekli Guncelleme ve Yineleme',
    km: 'ការអាប់ដេត និងកែលម្អជាបន្តបន្ទាប់',
    es: 'Actualizaciones e iteraciones continuas',
    ar: 'التحديثات والتكرارات المستمرة',
  },
  'home.aboutUs.feature.case3': {
    zh: '一对一售后服务',
    en: 'One-on-one After-sales Service',
    id: 'Layanan purna jual satu-ke-satu',
    kz: 'Бір-біріне қарастық кезімді қызмет көрсету',
    th: 'บริการหลังการขายแบบหนึ่งต่อหนึ่ง',
    ug: 'بىرەر-بىر ياردەم',
    vi: 'Dịch vụ hậu mãi một-đến-một',
    zh_tc: '一對一售後服務',
    ru: 'Одноразовое послепродажное обслуживание',
    ko: '일대일 애프터서비스',
    bur: 'တစ်ဆက်တစ်တည်းဝန်ဆောင်မှု',
    ben: 'এক-এক আফটার-সেলস সেবা',
    tr: 'Bire Bir Satis Sonrasi Hizmet',
    km: 'សេវាកម្មបន្ទាប់ពីលក់មួយទល់មួយ',
    es: 'Servicio posventa personalizado',
    ar: 'خدمة ما بعد البيع الفردية',
  },
  'home.aboutUs.feature.case4': {
    zh: '功能定制服务',
    en: 'Customized Functionality Service',
    id: 'Layanan Kustomisasi Fungsional',
    kz: 'Функцияларды жекешелендіру қызмет',
    th: 'บริการปรับแต่งฟังก์ชั่น',
    ug: 'ئىقتىدار خاس تەمىنلەش',
    vi: 'Dịch vụ tùy chỉnh chức năng',
    zh_tc: '功能定制服務',
    ru: 'Услуги по настройке функций',
    ko: '기능 사용자 정의 서비스',
    bur: 'လုပ်ဆောင်ချက်ကိုယ်ပိုင်ဝန်ဆောင်မှု',
    ben: 'কাস্টমাইজড ফাংশন সেবা',
    tr: 'Ozel Fonksiyon Hizmeti',
    km: 'សេវាកម្មប្ដូរមុខងារ',
    es: 'Servicio de personalización de funciones',
    ar: 'خدمة تخصيص الوظائف',
  },
  'home.cooperation.title': {
    zh: '精诚合作 共创未来',
    en: 'Sincere Cooperation, Creating a Shared Future',
    id: 'Bekerja sama dengan tulus untuk menciptakan masa depan bersama',
    kz: 'Қатты ынтымақтастық, болашақтықтық құру',
    th: 'ร่วมมืออย่างจริงใจเพื่อสร้างอนาคตร่วมกัน',
    ug: 'ئىناق ھەمكارلىق، بىرلىكتە كەلگۈسىنى قۇرۇش',
    vi: 'Hợp tác chân thành, cùng tạo ra tương lai',
    zh_tc: '精誠合作 共創未來',
    ru: 'Честное сотрудничество ради будущего.',
    ko: '성심성의껏 협력하여 미래를 함께 창조하다.',
    bur: 'ပေါင်းစပ်ဆောင်ရွက်ပြီး အနာဂတ်ဖန်တီး',
    ben: 'আন্তরিক সহযোগিতায় ভবিষ্যৎ গড়ি',
    tr: 'Samimi Is Birligiyle Gelecegi Birlikte Insaa Edelim',
    km: 'សហការដោយស្មោះត្រង់ បង្កើតអនាគតរួមគ្នា',
    es: 'Cooperación sincera para crear el futuro',
    ar: 'التعاون الصادق لخلق المستقبل',
  },
  'home.cooperation.subTitle': {
    zh: ' 对接设备品牌覆盖90%国内共产常用设备，107554位商家与我们同行 ',
    en: 'The docking equipment brands cover 90% of the commonly used domestic industrial equipment, with 107,554 merchants joining us.',
    id: 'Merek peralatan docking mencakup 90% peralatan umum yang digunakan di Cina, dan 107.554 pedagang bepergian bersama kami',
    kz: 'Құрылғы брендтерінің 90% ішкі қоммунистік құрал-жабдықтарға қосылады, 107554 сандық саудагерлер бізбен бірге істеп жатыр ',
    th: 'แบรนด์อุปกรณ์เชื่อมต่อครอบคลุม 90% ของอุปกรณ์ทั่วไปที่ใช้ในประเทศจีนและพ่อค้า 107,554 คนเดินทางไปกับเรา',
    ug: 'جۇڭگونىڭ 90% دىن ئارتۇق ئادەتتىكى قوراللىرىنى قوللايدۇ، 107554 تىجارەتچى بىز بىلەن بىللە',
    vi: 'Đối tác thiết bị phủ 90% thiết bị phổ biến trong nước, 107554 doanh nghiệp cùng tiến với chúng tôi',
    zh_tc: ' 對接設備品牌覆蓋90%國內工廠常用設備，107554位商家與我們同行 ',
    ru: 'Бренд стыковочного оборудования покрывает 90% отечественного коммунистического оборудования, 107 554 продавца идут с нами',
    ko: '도킹 설비 브랜드는 90% 의 국내 공산 상용 설비를 커버하고, 107554명의 상인이 우리와 동행한다',
    bur: 'ဆက်ချိတ်ကိရိယာဘရင်ဒ်သည် ပြည်တွင်းဆောင်ပြိုးကိရိယာ ၉၀% ကိုခြုံငုံ၊ ကုန်သည် ၁၀၇,၅၅၄ ဦးနှင့်အတူ',
    ben: 'ডকিং সরঞ্জাম ব্র্যান্ড দেশীয় ৯০% সাধারণ সরঞ্জাম কভার করে, ১০৭,৫৫৪ জন ব্যবসায়ী আমাদের সাথে',
    tr: "Baglanti kurulan ekipman markalari, yurt icinde yaygin kullanilan ekipmanlarin %90'ini kapsar; 107554 isletme bizimle birlikte ilerliyor.",
    km: 'ម៉ាកឧបករណ៍ដែលភ្ជាប់គ្របដណ្តប់ 90% នៃឧបករណ៍ដែលប្រើជាទូទៅក្នុងស្រុក ហើយមានពាណិជ្ជករ 107,554 រូបដើរជាមួយយើង',
    es: 'La marca de equipos de acoplamiento cubre el 90% de los equipos de uso común del Partido Comunista nacional, y 107,554 comerciantes están con nosotros',
    ar: 'تغطي العلامة التجارية لمعدات الإرساء 90٪ من المعدات شائعة الاستخدام في الحزب الشيوعي المحلي، ويتواجد معنا 107.554 تاجرًا',
  },
  'home.footer.contact.title': {
    zh: '联系我们',
    en: 'Contact us',
    id: 'Hubungi kami',
    kz: 'Бізбен байланысыңыз',
    th: 'ติดต่อเรา',
    ug: 'بىز بىلەن ئالاقىلىشىڭ',
    vi: 'Liên hệ với chúng tôi',
    zh_tc: '聯繫我們',
    ru: 'Свяжитесь с нами',
    ko: '연락처',
    bur: 'ကျွန်ုပ်တို့ကိုဆက်သွယ်ပါ',
    ben: 'আমাদের সাথে যোগাযোগ করুন',
    tr: 'Bize Ulasin',
    km: 'ទាក់ទងមកយើង',
    es: 'Contáctanos',
    ar: 'اتصل بنا',
  },
  'home.footer.contact.adrres': {
    zh: '地址：江苏省无锡市滨湖区绣溪50号',
    en: 'Address: No. 50 Xiuxi, Binhu District, Wuxi City, Jiangsu Province',
    id: 'Alamat: No. 50 Xiuxi, Distrik Binhu, Kota Wuxi, Provinsi Jiangsu',
    kz: 'Адресі: Цзянсу қаласының Биньху ауданыңіздеги Сюйси 50-ші көшесі',
    th: 'ที่อยู่: หมายเลข 50 Xiuxi, Binhu District, Wuxi City, Jiangsu Province',
    ug: 'ئادرېس: جياڭسۇ ئۆلكىسى، وۇشى شەھىرى، بىنخۇ رايونى، شىۇشى 50-خەنزۇچە',
    vi: 'Địa chỉ: 50 Hạm Thùy, Quận Bīn Hú, Vô Sĩ, Giang Tô',
    zh_tc: '地址：江蘇省無錫市濱湖區繡溪50號',
    ru: 'Адрес: район Биньху, город Уси, провинция Цзянсу',
    ko: '주소: 강소성 무석시 빈호구 수계50호',
    bur: 'လိပ်စာ - Jiangsu ပြည်နယ် Wuxi မြို့ Binhu ဒေသ Xiuxi အမှတ် ၅၀',
    ben: 'ঠিকানা: জিয়াংসু প্রদেশ, উশি শহর, বিনহু জেলা, শিউশি নং ৫০',
    tr: 'Adres: Jiangsu Eyaleti, Wuxi Sehri, Binhu Bolgesi, Xiuxi No.50',
    km: 'អាសយដ្ឋាន៖ លេខ 50 Xiuxi សង្កាត់ Binhu ទីក្រុង Wuxi ខេត្ត Jiangsu',
    es: 'Dirección: Piso 16, Edificio 1, No. 50, Xiuxi, Distrito de Binhu, Ciudad de Wuxi, Provincia de Jiangsu',
    ar: 'العنوان: الطابق 16، المبنى 1، رقم 50، Xiuxi، Binhu District، مدينة Wuxi، مقاطعة Jiangsu',
  },
  'home.footer.contact.subAdrres': {
    zh: 'K-park服务中心1号楼16楼',
    en: 'K-park Service Center, Building 1, 16th Floor',
    id: 'Lantai 16, Bangunan 1, Pusat Layanan K-Park',
    kz: 'K-park сервис орталығы 1-ші ғимараттың 16-ші қабат',
    th: 'ชั้น 16 อาคาร 1, ศูนย์บริการ K-Park',
    ug: 'K-park مۇلازىمەت مەركىزى 1-بىنا 16-قەۋەت',
    vi: 'Tầng 16, Tòa nhà 1, Trung tâm dịch vụ K-park',
    zh_tc: 'K-park服務中心1號樓16樓',
    ru: 'K - Park Service Center, дом 1, 16.',
    ko: 'K-Park 서비스센터 1호동 16층',
    bur: 'K-park ဝန်ဆောင်မှုဌာန အဆောင် ၁ ၁၆ ထပ်',
    ben: 'K-park সার্ভিস সেন্টার ১ নম্বর ভবন ১৬ তলা',
    tr: "K-park Hizmet Merkezi, 1 No'lu Bina, 16. Kat",
    km: 'អគារ 1 ជាន់ទី 16 មជ្ឈមណ្ឌលសេវាកម្ម K-park',
    es: 'K-park Centro de servicio Edificio 1',
    ar: 'K-park مبنى مركز الخدمة 1',
  },
  'home.footer.contact.tell': {
    zh: '电话',
    en: 'Telephone',
    id: 'Telepon',
    kz: 'Телефон',
    th: 'โทรศัพท์',
    ug: 'تېلېفون',
    vi: 'Điện thoại',
    zh_tc: '電話',
    ru: 'телефон',
    ko: '전화',
    bur: 'ဖုန်းနံပါတ်',
    ben: 'টেলিফোন',
    tr: 'Telefon',
    km: 'ទូរស័ព្ទ',
    es: 'Teléfono',
    ar: 'الهاتف',
  },
  'home.footer.business.title': {
    zh: '新格尔核心业务',
    en: "Xin Ge Er's Core Business",
    id: 'Xingele Core Business',
    kz: 'Шинэгердің негізгі бизнесі',
    th: 'ธุรกิจหลักของ Xingele',
    ug: 'يېڭى گېرنىڭ ئاساسلىق تىجارىتى',
    vi: 'Các dịch vụ chính của Tân Cách',
    zh_tc: '新格爾核心業務',
    ru: 'Основные операции & lt; & lt; Нойгель & gt; & gt;',
    ko: '뉴 그릴 핵심 사업',
    bur: 'Xingeer အဓိကလုပ်ငန်း',
    ben: 'Xingeer মূল ব্যবসা',
    tr: 'Xingeer Temel Is Alanlari',
    km: 'អាជីវកម្មស្នូលរបស់ Xingeer',
    es: 'Negocio principal de Xinger',
    ar: 'Xinger Core Business',
  },
  'home.footer.business.department1': {
    zh: '门窗软件事业部',
    en: 'Door and Window Software Department',
    id: 'Departemen Bisnis Pintu dan Windows Perangkat Lunak',
    kz: 'Есік-шарпа шбақ бағдарламалық қамтамасыз ету бөлімі',
    th: 'แผนกธุรกิจซอฟต์แวร์ Door and Windows',
    ug: 'دېرەزە-ئىشىك يۇمشاق دېتال بۆلۈمى',
    vi: 'Bộ phận phần mềm cửa sổ và cửa ra vào',
    zh_tc: '門窗軟件事業部',
    ru: 'Отдел оконного программного обеспечения',
    ko: '도어 윈도우 소프트웨어 사업부',
    bur: 'တံခါး-ဝင်းဒိုးဆော့ဖ်ဝဲဌာန',
    ben: 'দরজা ও জানালা সফটওয়্যার বিভাগ',
    tr: 'Kapi ve Pencere Yazilim Departmani',
    km: 'នាយកដ្ឋានកម្មវិធីទ្វារ និងបង្អួច',
    es: 'División de software para puertas y ventanas',
    ar: 'قسم برمجيات الأبواب والنوافذ',
  },
  'home.footer.business.department2': {
    zh: '家具软件事业部',
    en: 'Furniture Software Department',
    id: 'Departemen bisnis perangkat lunak furnitur',
    kz: 'Өрек бағдарламалық қамтамасыз ету бөлімі',
    th: 'แผนกธุรกิจซอฟต์แวร์เฟอร์นิเจอร์',
    ug: 'ئۆي جىھازلىرى يۇمشاق دېتال بۆلۈمى',
    vi: 'Bộ phận phần mềm đồ nội thất',
    zh_tc: '家具軟件事業部',
    ru: 'Министерство мебельного программного обеспечения',
    ko: '가구 소프트웨어 사업부',
    bur: 'မိုဘိုင်ဆော့ဖ်ဝဲဌာန',
    ben: 'আসবাবপত্র সফটওয়্যার বিভাগ',
    tr: 'Mobilya Yazilim Departmani',
    km: 'នាយកដ្ឋានកម្មវិធីគ្រឿងសង្ហារឹម',
    es: 'División de software para muebles',
    ar: 'قسم برمجيات الأثاث',
  },
  'home.footer.business.department3': {
    zh: '装配建筑事业部',
    en: 'Prefabricated Construction Department',
    id: 'Departemen Majelis dan Konstruksi',
    kz: 'Құрылыс-монтаж бөлімі',
    th: 'กรมสมัชชาและก่อสร้าง',
    ug: 'يىغما بىنا بۆلۈمى',
    vi: 'Bộ phận xây dựng phù hợp',
    zh_tc: '裝配建築事業部',
    ru: 'Министерство сборочного строительства',
    ko: '조립건축사업부',
    bur: 'ပြင်ဆင်တပ်ဆင်ဆောက်လုပ်ရေးဌာန',
    ben: 'প্রিফেব্রিকেটেড নির্মাণ বিভাগ',
    tr: 'Prefabrik Yapi Departmani',
    km: 'នាយកដ្ឋានសំណង់តំឡើងជាស្រេច',
    es: 'División de construcción de ensamblaje',
    ar: 'قسم بناء التجميع',
  },
  'home.footer.business.department4': {
    zh: '新格尔总部官网',
    en: "Xin Ge Er's Official Website",
    id: 'Situs Resmi Markas Xingele',
    kz: 'Шинэгердің штаб-пәтерінің официалды сайты',
    th: 'เว็บไซต์ทางการของสำนักงานใหญ่ของ Xingele',
    ug: 'يېڭى گېر باش شىتابى رەسىمىي تور بېتى',
    vi: 'Trang web chính của Tân Cách',
    zh_tc: '新格爾總部官網',
    ru: 'Официальный сайт штаб - квартиры',
    ko: '뉴 그릴 본사 홈페이지',
    bur: 'Xingeer 本部官方ဝက်ဘ်ဆိုဒ်',
    ben: 'Xingeer সদর দপ্তরের অফিশিয়াল ওয়েবসাইট',
    tr: 'Xingeer Resmi Merkez Web Sitesi',
    km: 'គេហទំព័រផ្លូវការរបស់ទីស្នាក់ការកណ្ដាល Xingeer',
    es: 'Sitio web oficial de la sede de Xinger',
    ar: 'الموقع الرسمي للمقر الرئيسي لشركة Xinger',
  },
  'home.footer.brand.title': {
    zh: '新格尔旗下品牌',
    en: "Xin Ge Er's Affiliate Brands",
    id: 'Merek di bawah Xingele',
    kz: 'Шинэгердің саубақ брендтері',
    th: 'แบรนด์ภายใต้ Xingele',
    ug: 'يېڭى گېر تۈرلىرى',
    vi: 'Các thương hiệu của Tân Cách',
    zh_tc: '新格爾旗下品牌',
    ru: 'Марки компании New Girl',
    ko: '뉴 겔 산하 브랜드',
    bur: 'Xingeer ဘရင်ဒ်များ',
    ben: 'Xingeer সহযোগী ব্র্যান্ড',
    tr: 'Xingeer Markalari',
    km: 'ម៉ាកសញ្ញាក្រោម Xingeer',
    es: 'Marcas de Xinger',
    ar: 'Xinger Brands',
  },
  'home.footer.brand.brand1': {
    zh: '材神金服',
    en: 'Cai Shen Jin Fu',
    id: 'Dewa Bahan',
    kz: 'Цайшэнь цзиньфу',
    th: 'เทพเจ้าแห่งวัสดุ',
    ug: 'تېرىلغۇ مالىيە',
    vi: 'Tài thần Kim Phục',
    zh_tc: '材神金服',
    ru: 'Золотой костюм бога',
    ko: '재신금복',
    bur: 'Cai Shen Jin Fu',
    ben: 'Cai Shen Jin Fu',
    tr: 'Cai Shen Jin Fu',
    km: 'Cai Shen Jin Fu',
    es: 'Caishen Financial Services',
    ar: 'Caishen Financial Services',
  },
  'home.footer.brand.brand2': {
    zh: '门图网',
    en: 'Mentu.com',
    id: 'Jaringan peta pintu',
    kz: 'Менту ван',
    th: 'เครือข่ายแผนที่ประตู',
    ug: 'ئىشىك تورى',
    vi: 'Môn Toánet',
    zh_tc: '門圖網',
    ru: 'Сеть дверей',
    ko: '문도망',
    bur: 'Mentu.com',
    ben: 'Mentu.com',
    tr: 'Mentu.com',
    km: 'Mentu.com',
    es: 'Mentu.com',
    ar: 'Mentu.com',
  },
  'home.footer.brand.brand3': {
    zh: '鼎鑫投资',
    en: 'Ding Xin Investment',
    id: 'Investasi Dingxin',
    kz: 'Динксин инвестишн',
    th: 'การลงทุน dingxin',
    ug: 'دىڭشىن سېلىم',
    vi: 'Đinh Hân Đầu tư',
    zh_tc: '鼎鑫投資',
    ru: 'Инвестиции ↑',
    ko: '정흠투자',
    bur: 'Ding Xin ရင်းနှီးမြှုပ်နှံမှု',
    ben: 'Ding Xin বিনিয়োগ',
    tr: 'Ding Xin Yatirim',
    km: 'ការវិនិយោគ Ding Xin',
    es: 'Dingxin Investment',
    ar: 'Dingxin Investment',
  },
  'home.footer.brand.brand4': {
    zh: '三张图科技',
    en: 'San Zhang Tu Technology',
    id: 'Tiga gambar teknologi',
    kz: 'Саньчжанту технология',
    th: 'สามรูปภาพของเทคโนโลยี',
    ug: 'ئۈچ رەسىم تېخنىكىسى',
    vi: 'Tam Tranh Khoa học',
    zh_tc: '三張圖科技',
    ru: 'Три технологии.',
    ko: '3장 도과학기술',
    bur: 'San Zhang Tu နည်းပညာ',
    ben: 'San Zhang Tu প্রযুক্তি',
    tr: 'San Zhang Tu Teknoloji',
    km: 'បច្ចេកវិទ្យា San Zhang Tu',
    es: 'Sanzhangtu Technology',
    ar: 'Sanzhangtu Technology',
  },
  'home.footer.brand.brand5': {
    zh: '上海粉墨科技',
    en: 'Shanghai Fen Mo Technology',
    id: 'Teknologi Shanghai Pink',
    kz: 'Шанхай фэньмò технология',
    th: 'เทคโนโลยีสีชมพูเซี่ยงไฮ้',
    ug: 'شاڭخەي پودۇ تېخنىكىسى',
    vi: 'Thanh Mô Công nghệ Thượng Hải',
    zh_tc: '上海粉墨科技',
    ru: 'Шанхайская технология',
    ko: '상해 분묵 과학기술',
    bur: 'Shanghai Fen Mo နည်းပညာ',
    ben: 'Shanghai Fen Mo প্রযুক্তি',
    tr: 'Shanghai Fen Mo Teknoloji',
    km: 'បច្ចេកវិទ្យា Shanghai Fen Mo',
    es: 'Shanghai Fenmo Technology',
    ar: 'Shanghai Fenmo Technology',
  },
  'home.footer.organization.title': {
    zh: '新格尔全球分支机构',
    en: "Xin Ge Er's Global Branches",
    id: 'Xingere Global Branch',
    kz: 'Шинэгердің жұмыс істеу орындары',
    th: 'สาขา Xingere Global',
    ug: 'يېڭى گېر دۇنيا بويىچە شۆبەلىرى',
    vi: 'Các chi nhánh toàn cầu của Tân Cách',
    zh_tc: '新格爾全球分支機構',
    ru: 'Глобальное отделение & lt; & lt; Нойгель & gt; & gt;',
    ko: '뉴 겔 글로벌 지사',
    bur: 'Xingeer ကမ္ဘာတစ်ဝှမ်းဌာနများ',
    ben: 'Xingeer বৈশ্বিক শাখা',
    tr: 'Xingeer Global Subeleri',
    km: 'សាខាសកលរបស់ Xingeer',
    es: 'Xingeer Global Branches',
    ar: 'فروع Xingeer العالمية',
  },
  'home.footer.organization.organization1': {
    zh: '新格尔-华南局（佛山分公司）',
    en: 'Xin Ge Er - South China Bureau (Foshan Branch)',
    id: 'Xingele-South China Bureau (Cabang Foshan)',
    kz: 'Шинэгер-Жаньяй бюросы (Фошань филиалы)',
    th: 'สำนัก Xingele-South China (สาขา Foshan)',
    ug: 'يېڭى گېر-جەنۇبىي شىتاب (فوشان شۆبىسى)',
    vi: 'Tân Cách - Cục Nam Trung Quốc (Công ty chi nhánh Phú Xiên)',
    zh_tc: '新格爾-華南局（佛山分公司）',
    ru: 'Бюро Сингер - Южный Китай (филиал Фошань)',
    ko: '신겔-화남국 (불산지사)',
    bur: 'Xingeer-দক္ষিণ ဘ​ပ​ (Foshan ဌာနခွဲ)',
    ben: 'Xingeer - দক্ষিণ চীন ব্যুরো (ফোশান শাখা)',
    tr: 'Xingeer - Guney Cin Bolgesi (Foshan Subesi)',
    km: 'Xingeer - ការិយាល័យភាគខាងត្បូងចិន (សាខា Foshan)',
    es: 'Xingeer-South China Bureau (Foshan Branch)',
    ar: 'مكتب Xingeer-جنوب الصين (فرع فوشان)',
  },
  'home.footer.organization.organization2': {
    zh: '新格尔-北方局（临沂分公司）',
    en: 'Xin Ge Er - North Bureau (Linyi Branch)',
    id: 'Xingele-Northern Bureau (cabang Linyi)',
    kz: 'Шинэгер-Шығыс бюросы (Линьи филиалы)',
    th: 'สำนัก Xingele-Northern (สาขา Linyi)',
    ug: 'يېڭى گېر-شىمالىي شىتاب (لىنيى شۆبىسى)',
    vi: 'Tân Cách - Cục Bắc Phương (Công ty chi nhánh Lâm Yên)',
    zh_tc: '新格爾-北方局（臨沂分公司）',
    ru: 'Сингер - Северное бюро (Линьийский филиал)',
    ko: '신겔-북방국 (림기지사)',
    bur: 'Xingeer-မြောက် ဘ​ပ​ (Linyi ဌာနခွဲ)',
    ben: 'Xingeer - উত্তর ব্যুরো (লিনি শাখা)',
    tr: 'Xingeer - Kuzey Bolgesi (Linyi Subesi)',
    km: 'Xingeer - ការិយាល័យភាគខាងជើង (សាខា Linyi)',
    es: 'Xingeer-Northern Bureau (Linyi Branch)',
    ar: 'مكتب Xingeer-Northern (فرع Linyi)',
  },
  'home.footer.organization.organization3': {
    zh: '新格尔-西南局（成都分公司）',
    en: 'Xin Ge Er - Southwest Bureau (Chengdu Branch)',
    id: 'Biro Xingele-Southwest (Cabang Chengdu)',
    kz: 'Шинэгер-Жантық бюросы (Чэнду филиалы)',
    th: 'สำนัก Xingele-Southwest (สาขาเฉิงตู)',
    ug: 'يېڭى گېر-جەنۇبىي غەربىي شىتاب (چەندۇ شۆبىسى)',
    vi: 'Tân Cách - Cục Tây Nam (Công ty chi nhánh Thành Đô)',
    zh_tc: '新格爾-西南局（成都分公司）',
    ru: 'Сингер - Юго - Западное бюро (Чэндуский филиал)',
    ko: '신겔-서남국 (성도지사)',
    bur: 'Xingeer-အနောက်တောင် ဘ​ပ​ (Chengdu ဌာနခွဲ)',
    ben: 'Xingeer - দক্ষিণ-পশ্চিম ব্যুরো (চেংদু শাখা)',
    tr: 'Xingeer - Guneybati Bolgesi (Chengdu Subesi)',
    km: 'Xingeer - ការិយាល័យភាគនិរតី (សាខា Chengdu)',
    es: 'Xingeer-Southwest Bureau (Chengdu Branch)',
    ar: 'مكتب Xingeer-الجنوب الغربي (فرع تشنغدو)',
  },
  'home.footer.organization.organization4': {
    zh: '新格尔-柜柜西部服务中心',
    en: 'Xin Ge Er - GG Western Service Center',
    id: 'Xingele-Coffee Cabinet Western Service Center',
    kz: 'Шинэгер-Гуigui батыс сервис орталығы',
    th: 'ศูนย์บริการ Xingele-Coffee Cabinet Western',
    ug: 'يېڭى گېر-كابىنەت غەربىي مۇلازىمەت مەركىزى',
    vi: 'Tân Cách - Trung tâm dịch vụ phía Tây của Quì Quì',
    zh_tc: '新格爾-櫃櫃西部服務中心',
    ru: 'Нойгель - Западный сервисный центр',
    ko: '뉴 그릴 - 캐비닛 서부 서비스 센터',
    bur: 'Xingeer-ဗီရို အနောက်ဝန်ဆောင်မှုဌာန',
    ben: 'Xingeer - GG পশ্চিম সার্ভিস সেন্টার',
    tr: 'Xingeer - GG Bati Hizmet Merkezi',
    km: 'Xingeer - មជ្ឈមណ្ឌលសេវាកម្មភាគខាងលិច GG',
    es: 'Xingeer - Centro de servicio Cabinet West',
    ar: 'Xingeer - مركز خدمة مجلس الوزراء الغربي',
  },
  'home.footer.organization.organization5': {
    zh: '新格尔-柜柜东部服务中心',
    en: 'Xin Ge Er - GG Eastern Service Center',
    id: 'Xingele-Coffer Eastern Service Center',
    kz: 'Шинэгер-Гуigui шығыс сервис орталығы',
    th: 'ศูนย์บริการ Eastern Xingele-Coffer',
    ug: 'يېڭى گېر-كابىنەت شەرقىي مۇلازىمەت مەركىزى',
    vi: 'Tân Cách - Trung tâm dịch vụ phía Đông của Quì Quì',
    zh_tc: '新格爾-櫃櫃東部服務中心',
    ru: 'Нойгель - Восточный сервисный центр',
    ko: '뉴 그릴 - 캐비닛 동부 서비스 센터',
    bur: 'Xingeer-ဗီရို အရှေ့ဝန်ဆောင်မှုဌာန',
    ben: 'Xingeer - GG পূর্ব সার্ভিস সেন্টার',
    tr: 'Xingeer - GG Dogu Hizmet Merkezi',
    km: 'Xingeer - មជ្ឈមណ្ឌលសេវាកម្មភាគខាងកើត GG',
    es: 'Xingeer - Centro de servicio Cabinet East',
    ar: 'Xingeer - مركز خدمة مجلس الوزراء الشرقي',
  },
  'home.footer.organization.organization6': {
    zh: '新格尔-代理商集群',
    en: 'Xin Ge Er - Agent Cluster',
    id: 'Xingele-Agent Cluster',
    kz: 'Шинэгер-агенттер топтығы',
    th: 'คลัสเตอร์ Xingele-Agent',
    ug: 'يېڭى گېر-دىللىكلار توپلىمى',
    vi: 'Tân Cách - Hệ thống đại lý',
    zh_tc: '新格爾-代理商集群',
    ru: 'Новогерско - агентский кластер',
    ko: '뉴 겔 - 대리점 클러스터',
    bur: 'Xingeer-ကိုယ်စားလှယ်အုပ်စု',
    ben: 'Xingeer - এজেন্ট ক্লাস্টার',
    tr: 'Xingeer - Temsilci Kumesi',
    km: 'Xingeer - ក្រុមតំណាងចែកចាយ',
    es: 'Xinger - Grupo de agentes',
    ar: 'Xinger - مجموعة الوكيل',
  },
  'home.footer.organization.organization7': {
    zh: '新格尔-国际市场部',
    en: 'Xin Ge Er - International Market Department',
    id: 'Departemen Pemasaran Xingele-International',
    kz: 'Шинэгер-халықаралық нарық бөлімі',
    th: 'แผนกการตลาดของ Xingele-International',
    ug: 'يېڭى گېر-خەلقئارا سېتىش بۆلۈمى',
    vi: 'Tân Cách - Bộ phận thị trường quốc tế',
    zh_tc: '新格爾-國際市場部',
    ru: 'Нью - Гэлл - Департамент международных рынков',
    ko: '뉴 겔 - 국제 마케팅 부서',
    bur: 'Xingeer-နိုင်ငံတကာဈေးကွက်ဌာန',
    ben: 'Xingeer - আন্তর্জাতিক বাজার বিভাগ',
    tr: 'Xingeer - Uluslararasi Pazar Departmani',
    km: 'Xingeer - នាយកដ្ឋានទីផ្សារអន្តរជាតិ',
    es: 'Xinger - Departamento de marketing internacional',
    ar: 'Xinger - قسم التسويق الدولي',
  },
  'home.footer.follow.title': {
    zh: '扫扫"关注柜柜"',
    en: 'Scan to Follow GG',
    id: 'Pindai "Ikuti Kabinet"',
    kz: 'Гуigui-діңізге шықырыңыз',
    th: 'สแกน "ติดตามคณะรัฐมนตรี"',
    ug: '"كابىنەت" نى ئىزلىش',
    vi: 'Quét để "Theo dõi Quì Quì"',
    zh_tc: '掃掃"關注櫃櫃"',
    ru: 'подметать "Шкаф внимания"',
    ko: '"관심 캐비닛" 청소',
    bur: '"ဗီရိုကိုကြည့်ရှုရန်" စကင်ဖတ်ပါ',
    ben: '"ক্যাবিনেট অনুসরণ করুন" স্ক্যান করুন',
    tr: '"GG\'yi Takip Et" icin Tara',
    km: 'ស្កេនដើម្បី "តាមដាន GG"',
    es: 'Escanear "Seguir gabinetes"',
    ar: 'مسح "الخزائن التالية"',
  },
  'home.footer.friendLink.link1': {
    zh: '新格尔软件',
    en: 'Xin Ge Er Software',
    id: 'Perangkat Lunak Xingele',
    kz: 'Шинэгер бағдарламалық қамтамасыз ету',
    th: 'ซอฟต์แวร์ Xingele',
    ug: 'يېڭى گېر يۇمشاق دېتال',
    vi: 'Phần mềm Tân Cách',
    zh_tc: '新格爾軟件',
    ru: 'Новое программное обеспечение Гейла',
    ko: '새로운 겔 소프트웨어',
    bur: 'Xingeer ဆော့ဖ်ဝဲ',
    ben: 'Xingeer সফটওয়্যার',
    tr: 'Xingeer Yazilim',
    km: 'កម្មវិធី Xingeer',
    es: 'Software Xinger',
    ar: 'برنامج Xinger',
  },
  'home.footer.friendLink.link2': {
    zh: 'K秀导购软件',
    en: 'K Show Purchasing Software',
    id: 'K Perangkat Lunak Panduan Belanja',
    kz: 'K шоу сауда-сатық бағдарламалық қамтамасыз ету',
    th: 'K Show Shopping Software Software',
    ug: 'K秀 سېتىش ياردەمچى يۇمشاق دېتال',
    vi: 'Phần mềm K Show Đạo hàng',
    zh_tc: 'K秀導購軟件',
    ru: 'Программное обеспечение K - шоу',
    ko: 'K 쇼 구매 안내 소프트웨어',
    bur: 'K Show ဆိုင်ပြသည့်ဆော့ဖ်ဝဲ',
    ben: 'K Show কেনাকাটা সফটওয়্যার',
    tr: 'K Show Satin Alma Yazilimi',
    km: 'កម្មវិធីណែនាំការទិញ K Show',
    es: 'K Mostrar software de guía de compras',
    ar: 'K عرض برنامج دليل التسوق',
  },
  'home.footer.friendLink.link3': {
    zh: '门图网',
    en: 'Mentu.com',
    id: 'Jaringan peta pintu',
    kz: 'Менту ван',
    th: 'เครือข่ายแผนที่ประตู',
    ug: 'ئىشىك تورى',
    vi: 'Môn Toánet',
    zh_tc: '門圖網',
    ru: 'Сеть дверей',
    ko: '문도망',
    bur: 'Mentu.com',
    ben: 'Mentu.com',
    tr: 'Mentu.com',
    km: 'Mentu.com',
    es: 'Mentu.com',
    ar: 'Mentu.com',
  },
  'home.footer.friendLink.link4': {
    zh: '全铝柜软件',
    en: 'All Aluminum Cabinet Software',
    id: 'Perangkat Lunak Kabinet All-Aluminium',
    kz: 'Толық алюминий шкаф бағдарламалық қамтамасыз ету',
    th: 'ซอฟต์แวร์ตู้อลูมิเนียมทั้งหมด',
    ug: 'پۈتۈن ئېلۇمىن كابىنەت يۇمشاق دېتال',
    vi: 'Phần mềm tủ toàn nhôm',
    zh_tc: '全鋁櫃軟件',
    ru: 'Программное обеспечение полностью алюминиевого шкафа',
    ko: '전체 알루미늄 캐비닛 소프트웨어',
    bur: 'ဗီရိုအလုံးစုံ အလူမီနမ်ဆော့ဖ်ဝဲ',
    ben: 'সম্পূর্ণ অ্যালুমিনিয়াম ক্যাবিনেট সফটওয়্যার',
    tr: 'Tum Aluminyum Dolap Yazilimi',
    km: 'កម្មវិធីទូអាលុយមីញ៉ូមទាំងមូល',
    es: 'Software para gabinetes totalmente de aluminio',
    ar: 'برنامج الخزانة المصنوع بالكامل من الألومنيوم',
  },
  'home.footer.friendLink.link5': {
    zh: 'ZOL软件下载',
    en: 'ZOL Software Download',
    id: 'Unduh Perangkat Lunak Zol',
    kz: 'ZOL бағдарламалық қамтамасыз ету жүктеу',
    th: 'ดาวน์โหลดซอฟต์แวร์ ZOL',
    ug: 'ZOL يۇمشاق دېتال چۈشۈرۈش',
    vi: 'Tải xuống phần mềm ZOL',
    zh_tc: 'ZOL軟件下載',
    ru: 'Скачать программное обеспечение ZOL',
    ko: 'ZOL 소프트웨어 다운로드',
    bur: 'ZOL ဆော့ဖ်ဝဲဒေါင်းလုဒ်',
    ben: 'ZOL সফটওয়্যার ডাউনলোড',
    tr: 'ZOL Yazilim Indirme',
    km: 'ទាញយកកម្មវិធី ZOL',
    es: 'ZOL Descarga de software',
    ar: 'ZOL تنزيل البرنامج',
  },
  'home.footer.friendLink.link6': {
    zh: '华军软件园',
    en: 'Hua Jun Software Park',
    id: 'Taman Perangkat Lunak Huajun',
    kz: 'Хуа цзюнь бағдарламалық қамтамасыз ету орталығы',
    th: 'สวนซอฟต์แวร์ Huajun',
    ug: 'خۇا جون يۇمشاق دېتال باغچىسى',
    vi: 'Hoa Quân Phần mềm',
    zh_tc: '華軍軟件園',
    ru: 'Китайский парк программного обеспечения',
    ko: '화군소프트웨어원',
    bur: 'Hua Jun ဆော့ဖ်ဝဲပတ်ဝန်းကျင်',
    ben: 'Hua Jun সফটওয়্যার পার্ক',
    tr: 'Hua Jun Yazilim Parki',
    km: 'សួនកម្មវិធី Hua Jun',
    es: 'Huajun Software Park',
    ar: 'Huajun Software Park',
  },
  'home.footer.friendLink.link7': {
    zh: '下载之家',
    en: 'Download.com',
    id: 'Unduh rumah',
    kz: 'Жүктеу үй',
    th: 'ดาวน์โหลดบ้าน',
    ug: 'چۈشۈرۈش ئۆيى',
    vi: 'Trang tải xuống',
    zh_tc: '下載之家',
    ru: 'Загрузить дом',
    ko: '다운로드 홈',
    bur: 'ဒေါင်းလုဒ်အိမ်',
    ben: 'ডাউনলোড হোম',
    tr: 'Indirme Ana Sayfasi',
    km: 'គេហទំព័រទាញយក',
    es: 'Inicio de descargas',
    ar: 'تنزيل الصفحة الرئيسية',
  },
  'home.footer.friendLink.link8': {
    zh: 'ZOL软件下载',
    en: 'ZOL Software Download',
    id: 'Unduh Perangkat Lunak Zol',
    kz: 'ZOL бағдарламалық қамтамасыз ету жүктеу',
    th: 'ดาวน์โหลดซอฟต์แวร์ ZOL',
    ug: 'ZOL يۇمشاق دېتال چۈشۈرۈش',
    vi: 'Tải xuống phần mềm ZOL',
    zh_tc: 'ZOL軟件下載',
    ru: 'Скачать программное обеспечение ZOL',
    ko: 'ZOL 소프트웨어 다운로드',
    bur: 'ZOL ဆော့ဖ်ဝဲဒေါင်းလုဒ်',
    ben: 'ZOL সফটওয়্যার ডাউনলোড',
    tr: 'ZOL Yazilim Indirme',
    km: 'ទាញយកកម្មវិធី ZOL',
    es: 'ZOL Descarga de software',
    ar: 'ZOL تنزيل البرنامج',
  },
  'home.footer.friendLink.link9': {
    zh: '绿色资源网',
    en: 'Green Resource Network',
    id: 'Jaringan Sumber Daya Hijau',
    kz: 'Жасыл ресурстар тобы',
    th: 'เครือข่ายทรัพยากรสีเขียว',
    ug: 'يېشىل سىرتقى تور',
    vi: 'Tài nguyên xanh',
    zh_tc: '綠色資源網',
    ru: 'Сеть & lt; & lt; Зеленые ресурсы & gt; & gt;',
    ko: '녹색자원망',
    bur: 'အစိမ်းရောင်အရင်းအမြစ်ကွန်ယက်',
    ben: 'সবুজ রিসোর্স নেটওয়ার্ক',
    tr: 'Yesil Kaynak Agi',
    km: 'បណ្តាញធនធានបៃតង',
    es: 'Green Resource Network',
    ar: 'Green Resource Network',
  },
  'home.footer.friendLink.link10': {
    zh: '衣柜加盟',
    en: 'Wardrobe Franchise',
    id: 'Waralaba Lemari',
    kz: 'Кішеньдіңізге қосылу',
    th: 'แฟรนไชส์ตู้เสื้อผ้า',
    ug: 'كېيىم دولىسىغا قوشۇلىش',
    vi: 'Tủ quần áo tham gia',
    zh_tc: '衣櫃加盟',
    ru: 'Шкаф присоединяется',
    ko: '옷장 가맹',
    bur: 'အဝတ်သေတ္တာပါဝင်',
    ben: 'পোশাক ক্যাবিনেট ফ্র্যাঞ্চাইজ',
    tr: 'Gardrop Bayiligi',
    km: 'ហ្វ្រេនឆាយទូខោអាវ',
    es: 'Franquicia de vestuario',
    ar: 'خزانة الملابس امتياز',
  },
  'home.footer.friendLink.link11': {
    zh: '家居加盟',
    en: 'Home Franchise',
    id: 'Waralaba rumah',
    kz: 'Үй жихазына қосылу',
    th: 'แฟรนไชส์บ้าน',
    ug: 'ئۆي جىھازلىرىغا قوشۇلىش',
    vi: 'Đoàn kết nội thất',
    zh_tc: '家居加盟',
    ru: 'Домой Присоединение',
    ko: '가정 가맹',
    bur: 'အိမ်မိုဘိုင်ပါဝင်',
    ben: 'হোম ফ্র্যাঞ্চাইজ',
    tr: 'Ev Mobilyasi Bayiligi',
    km: 'ហ្វ្រេនឆាយគ្រឿងសង្ហារឹមផ្ទះ',
    es: 'Inicio Franquicia de mobiliario',
    ar: 'امتياز تأثيث المنزل',
  },
  'home.footer.friendLink.link12': {
    zh: '美标卫浴加盟',
    en: 'American Standard Bathroom Franchise',
    id: 'Waralaba kamar mandi standar Amerika',
    kz: 'Мэйбiao вэнэй қосылу',
    th: 'แฟรนไชส์ห้องน้ำมาตรฐานอเมริกัน',
    ug: 'ئامېرىكا ئۆلچىملىك ھامامغا قوشۇلىش',
    vi: 'Đoàn kết vệ sinh Mỹ tiêu',
    zh_tc: '美標衛浴加盟',
    ru: 'Красивые ванны присоединяются',
    ko: '미표 목욕탕 가맹',
    bur: 'ရေချိုးခန်းပါဝင်',
    ben: 'আমেরিকান স্ট্যান্ডার্ড বাথরুম ফ্র্যাঞ্চাইজ',
    tr: 'American Standard Banyo Bayiligi',
    km: 'ហ្វ្រេនឆាយបន្ទប់ទឹក American Standard',
    es: 'Franquicia de baño American Standard',
    ar: 'امتياز الحمامات الأمريكية',
  },
  'login.title': {
    zh: '登录',
    en: 'Login',
    id: 'Masuk',
    kz: 'Кіру',
    th: 'เข้าสู่ระบบ',
    ug: 'كىرىش',
    vi: 'Đăng nhập',
    zh_tc: '登錄',
    ru: 'Войти',
    ko: '로그인',
    bur: 'ဝင်ရောက်ပါ',
    ben: 'লগইন',
    tr: 'Giris',
    km: 'ចូល',
    es: 'Iniciar sesión',
    ar: 'تسجيل الدخول',
  },
  'login.tell': {
    zh: '手机号',
    en: 'Phone number',
    id: 'Nomor telepon',
    kz: 'Ұялы телефон нөмірі',
    th: 'หมายเลขโทรศัพท์',
    ug: 'تېلېفون نومۇرى',
    vi: 'Số điện thoại',
    zh_tc: '手機號',
    ru: 'номер телефона',
    ko: '휴대폰 번호',
    bur: 'ဖုန်းနံပါတ်',
    ben: 'ফোন নম্বর',
    tr: 'Telefon Numarasi',
    km: 'លេខទូរស័ព្ទ',
    es: 'Número de teléfono móvil',
    ar: 'رقم الهاتف المحمول',
  },
  'login.password': {
    zh: '密码',
    en: 'Password',
    id: 'kata sandi',
    kz: 'Құпия сөз',
    th: 'รหัสผ่าน',
    ug: 'پارول',
    vi: 'Mật khẩu',
    zh_tc: '密碼',
    ru: 'пароль',
    ko: '비밀번호',
    bur: 'စကားဝှက်',
    ben: 'পাসওয়ার্ড',
    tr: 'Sifre',
    km: 'ពាក្យសម្ងាត់',
    es: 'Contraseña',
    ar: 'كلمة المرور',
  },
  'login.passwordPlaceholder': {
    zh: '请输入密码',
    en: 'Please enter the password',
    id: 'Harap masukkan kata sandi Anda',
    kz: 'Құпия сөзді кіріңіз',
    th: 'กรุณากรอกรหัสผ่านของคุณ',
    ug: 'پارولنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập mật khẩu',
    zh_tc: '請輸入密碼',
    ru: 'Введите пароль',
    ko: '비밀번호를 입력하세요',
    bur: 'စကားဝှက်ထည့်ပါ',
    ben: 'পাসওয়ার্ড লিখুন',
    tr: 'Lutfen sifrenizi girin',
    km: 'សូមបញ្ចូលពាក្យសម្ងាត់',
    es: 'Por favor ingrese la contraseña',
    ar: 'الرجاء إدخال كلمة المرور',
  },
  'login.forget': {
    zh: '忘记密码',
    en: 'Forgot password?',
    id: 'Lupakan kata sandinya',
    kz: 'Құпия сөзді ұмыттым',
    th: 'ลืมรหัสผ่าน',
    ug: 'پارولۇمنى ئۇنتۇپ قالدۇم',
    vi: 'Quên mật khẩu',
    zh_tc: '忘記密碼',
    ru: 'Забыли пароль',
    ko: '암호를 잊었습니다.',
    bur: 'စကားဝှက်မေ့ပျောက်',
    ben: 'পাসওয়ার্ড ভুলে গেছেন?',
    tr: 'Sifremi Unuttum',
    km: 'ភ្លេចពាក្យសម្ងាត់',
    es: 'Olvidé mi contraseña',
    ar: 'نسيت كلمة المرور',
  },
  'login.registerAccount': {
    zh: '注册账号',
    en: 'Register account',
    id: 'Daftar akun',
    kz: 'Құжатты тіркелу',
    th: 'ลงทะเบียนบัญชี',
    ug: 'ھېساباتتىن ئۆتۈش',
    vi: 'Đăng ký tài khoản',
    zh_tc: '註冊帳號',
    ru: 'Регистрационный счет',
    ko: '계정 등록',
    bur: 'အကောင့်မှတ်ပုံတင်ပါ',
    ben: 'অ্যাকাউন্ট নিবন্ধন করুন',
    tr: 'Hesap Kaydet',
    km: 'ចុះឈ្មោះគណនី',
    es: 'Registrar cuenta',
    ar: 'تسجيل الحساب',
  },
  'login.backLog': {
    zh: '返回登录',
    en: 'Go Back to Login',
    id: 'Kembali ke login',
    kz: 'Кіруге қайта оралу',
    th: 'กลับสู่การเข้าสู่ระบบ',
    ug: 'كىرىشكە قايتىش',
    vi: 'Quay lại đăng nhập',
    zh_tc: '返回登錄',
    ru: 'Вернуться в Регистрация',
    ko: '로그인으로 돌아가기',
    bur: 'ဝင်ရောက်မှုသို့ပြန်သွား',
    ben: 'লগইনে ফিরে যান',
    tr: 'Girise Don',
    km: 'ត្រឡប់ទៅការចូល',
    es: 'Volver a iniciar sesión',
    ar: 'العودة إلى تسجيل الدخول',
  },
  'login.verifyCode': {
    zh: '验证码',
    en: 'Verification code',
    id: 'Kode verifikasi',
    kz: 'Тексеру код',
    th: 'รหัสการตรวจสอบ',
    ug: 'دەلىللەش كودى',
    vi: 'Mã xác nhận',
    zh_tc: '驗證碼',
    ru: 'капча',
    ko: '인증 코드',
    bur: 'အတည်ပြုကုဒ်',
    ben: 'যাচাইকরণ কোড',
    tr: 'Dogrulama Kodu',
    km: 'លេខកូដផ្ទៀងផ្ទាត់',
    es: 'Código de verificación',
    ar: 'رمز التحقق',
  },
  'login.getVerifyCode': {
    zh: '获取验证码',
    en: 'Get verification code',
    id: 'Dapatkan kode verifikasi',
    kz: 'Тексеру кодты алу',
    th: 'รับรหัสการยืนยัน',
    ug: 'دەلىللەش كودىنى ئېلىش',
    vi: 'Nhận mã xác nhận',
    zh_tc: '獲取驗證碼',
    ru: 'Получить код подтверждения',
    ko: '인증 코드 가져오기',
    bur: 'အတည်ပြုကုဒ်ရယူပါ',
    ben: 'যাচাইকরণ কোড পান',
    tr: 'Dogrulama Kodunu Al',
    km: 'ទទួលលេខកូដផ្ទៀងផ្ទាត់',
    es: 'Obtener código de verificación',
    ar: 'الحصول على رمز التحقق',
  },
  'login.verifyCodeErr': {
    zh: '验证码错误',
    en: 'Verification code error',
    id: 'Kode verifikasi salah',
    kz: 'Тексеру коды қате',
    th: 'รหัสการยืนยันผิดพลาด',
    ug: 'دەلىللەش كودى خاتىر',
    vi: 'Mã xác nhận không đúng',
    zh_tc: '驗證碼錯誤',
    ru: 'Неверный код проверки',
    ko: '인증 코드 오류',
    bur: 'အတည်ပြုကုဒ်မှား',
    ben: 'যাচাইকরণ কোড ভুল',
    tr: 'Dogrulama Kodu Hatali',
    km: 'លេខកូដផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវ',
    es: 'Error de código de verificación',
    ar: 'خطأ في رمز التحقق',
  },
  'login.confimPassword': {
    zh: '确认密码',
    en: 'Confirm password',
    id: 'Konfirmasi Kata Sandi',
    kz: 'Құпия сөзді тастықтау',
    th: 'ยืนยันรหัสผ่าน',
    ug: 'پارولنى جەزملەشتۈرۈش',
    vi: 'Xác nhận mật khẩu',
    zh_tc: '確認密碼',
    ru: 'Подтверждение пароля',
    ko: '암호 확인',
    bur: 'စကားဝှက်အတည်ပြုပါ',
    ben: 'পাসওয়ার্ড নিশ্চিত করুন',
    tr: 'Sifreyi Onayla',
    km: 'បញ្ជាក់ពាក្យសម្ងាត់',
    es: 'Confirmar contraseña',
    ar: 'تأكيد كلمة المرور',
  },
  'login.confimPasswordPlaceholder': {
    zh: '请确认密码',
    en: 'Please confirm your password',
    id: 'Harap konfirmasi kata sandi Anda',
    kz: 'Құпия сөзді тастықтайңыз',
    th: 'โปรดยืนยันรหัสผ่านของคุณ',
    ug: 'پارولنى جەزملەشتۈرۈڭ',
    vi: 'Vui lòng xác nhận mật khẩu',
    zh_tc: '請確認密碼',
    ru: 'Подтвердите пароль.',
    ko: '비밀번호 확인',
    bur: 'စကားဝှက်အတည်ပြုပါ',
    ben: 'পাসওয়ার্ড নিশ্চিত করুন',
    tr: 'Lutfen Sifrenizi Onaylayin',
    km: 'សូមបញ្ជាក់ពាក្យសម្ងាត់',
    es: 'Por favor confirme la contraseña',
    ar: 'يرجى تأكيد كلمة المرور',
  },
  'login.editPassword': {
    zh: '修改密码',
    en: 'Change password',
    id: 'Ubah Kata Sandi',
    kz: 'Құпия сөзді өзгерту',
    th: 'แก้ไขรหัสผ่าน',
    ug: 'پارولنى ئۆزگەرتىش',
    vi: 'Chỉnh sửa mật khẩu',
    zh_tc: '修改密碼',
    ru: 'изменить пароль',
    ko: '암호 수정',
    bur: 'စကားဝှက်ပြောင်းပါ',
    ben: 'পাসওয়ার্ড পরিবর্তন করুন',
    tr: 'Sifreyi Degistir',
    km: 'ប្តូរពាក្យសម្ងាត់',
    es: 'Cambiar contraseña',
    ar: 'تغيير كلمة المرور',
  },
  'login.register': {
    zh: '注册',
    en: 'Register',
    id: 'daftar',
    kz: 'Тіркелу',
    th: 'ลงทะเบียน',
    ug: 'تىزىملاش',
    vi: 'Đăng ký tài khoản',
    zh_tc: '註冊',
    ru: 'регистрация',
    ko: '등록',
    bur: 'မှတ်ပုံတင်ပါ',
    ben: 'নিবন্ধন করুন',
    tr: 'Kaydol',
    km: 'ចុះឈ្មោះ',
    es: 'Registrarse',
    ar: 'تسجيل',
  },
  'login.reSend': {
    zh: '后重新获取',
    en: 'Get a new code',
    id: 'Acrequire setelahnya',
    kz: 'соңынан қайта алу',
    th: 'หลังจากนั้นอีกครั้งหลังจากนั้น',
    ug: 'قايتا ئېلىش',
    vi: 'Giây sau nhận lại',
    zh_tc: '後重新獲取',
    ru: 'После повторного приобретения',
    ko: '나중에 다시 가져오기',
    bur: 'နောက်ပြန်ယူပါ',
    ben: 'পরে পুনরায় নিন',
    tr: 'Tekrar Al',
    km: 'ទទួលម្តងទៀត',
    es: 'y volver a obtener',
    ar: 'وإعادة الحصول على',
  },
  'login.loginLoadText': {
    zh: '正在登录中,请稍等...',
    en: 'Logging in, please wait...',
    id: 'Masuk, tunggu ...',
    kz: 'Кіру процесіне кірісіңіз, солтүшіңіз...',
    th: 'เข้าสู่ระบบโปรดรอ ...',
    ug: 'كىرىش جەريانىدا، سەل تۇرۇڭ...',
    vi: 'Đang đăng nhập, vui lòng đợi...',
    zh_tc: '正在登錄中,請稍等...',
    ru: 'В процессе входа, пожалуйста, подождите. Это...',
    ko: '로그인 중입니다. 잠시만 기다려 주십시오...',
    bur: 'ဝင်ရောက်နေပါသည်၊ ခဏစောင့်ပါ...',
    ben: 'লগইন হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    tr: 'Giris yapiliyor, lutfen bekleyin...',
    km: 'កំពុងចូល សូមរង់ចាំ...',
    es: 'Inicie sesión, espere...',
    ar: 'تسجيل الدخول، يرجى الانتظار...',
  },
  'login.loadingPageTextL': {
    zh: '登录成功,正在加载页面结构中...',
    en: 'Login successful, loading page structure...',
    id: 'Login berhasil, struktur halaman sedang memuat ...',
    kz: 'Кіру сәтті, беттің құрылымын жүктеуде...',
    th: 'เข้าสู่ระบบสำเร็จโครงสร้างหน้ากำลังโหลด ...',
    ug: 'مۇۋەپپەقىيەتلىك كىردى، بەت قۇرۇلمىسى يۈكلىنىۋاتىدۇ...',
    vi: 'Đăng nhập thành công, đang tải trang...',
    zh_tc: '登錄成功,正在加載頁面結構中...',
    ru: 'Войти успешно, загружается структура страницы. Это...',
    ko: '로그인했습니다. 페이지 구조를 로드하는 중입니다...',
    bur: 'ဝင်ရောက်မှုအောင်မြင်ပြီ၊ စာမျက်နှာဖွဲ့စည်းပုံတင်နေပါသည်...',
    ben: 'লগইন সফল, পেজ স্ট্রাকচার লোড হচ্ছে...',
    tr: 'Giris basarili, sayfa yapisi yukleniyor...',
    km: 'ចូលបានជោគជ័យ កំពុងផ្ទុករចនាសម្ព័ន្ធទំព័រ...',
    es: 'Inicie sesión correctamente, cargando estructura de página...',
    ar: 'تسجيل الدخول بنجاح، جارٍ تحميل بنية الصفحة...',
  },
  'login.loginSuccess': {
    zh: '登录成功',
    en: 'Login successfully',
    id: 'Login berhasil',
    kz: 'Кіру сәтті',
    th: 'เข้าสู่ระบบสำเร็จ',
    ug: 'مۇۋەپپەقىيەتلىك كىردى',
    vi: 'Đăng nhập thành công',
    zh_tc: '登錄成功',
    ru: 'Вход выполнен успешно',
    ko: '로그인 성공',
    bur: 'ဝင်ရောက်မှုအောင်မြင်သည်',
    ben: 'লগইন সফল হয়েছে',
    tr: 'Giris Basarili',
    km: 'ចូលបានជោគជ័យ',
    es: 'Inicie sesión correctamente',
    ar: 'تسجيل الدخول بنجاح',
  },
  'login.tellErr': {
    zh: '手机号码格式不正确',
    en: 'Invalid phone number format',
    id: 'Format nomor ponsel yang salah',
    kz: 'Ұялы телефон нөмірінің пішімі дұрыс емес',
    th: 'รูปแบบหมายเลขโทรศัพท์มือถือที่ไม่ถูกต้อง',
    ug: 'تېلېفون نومۇرى توغرا ئەمەس',
    vi: 'Định dạng số điện thoại không đúng',
    zh_tc: '手機號碼格式不正確',
    ru: 'Номера телефонов неправильные.',
    ko: '핸드폰 번호의 형식이 정확하지 않다.',
    bur: 'ဖုန်းနံပါတ်ဖော်မတ်မမှန်ကန်',
    ben: 'ফোন নম্বরের ফরম্যাট সঠিক নয়',
    tr: 'Telefon numarasi formati hatali',
    km: 'ទម្រង់លេខទូរស័ព្ទមិនត្រឹមត្រូវ',
    es: 'El formato del número de teléfono móvil es incorrecto',
    ar: 'تنسيق رقم الهاتف المحمول غير صحيح',
  },
  'login.passwordErr': {
    zh: '请输入密码',
    en: 'Please enter the password',
    id: 'Harap masukkan kata sandi Anda',
    kz: 'Құпия сөзді кіріңіз',
    th: 'กรุณากรอกรหัสผ่านของคุณ',
    ug: 'پارولنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập mật khẩu',
    zh_tc: '請輸入密碼',
    ru: 'Введите пароль',
    ko: '비밀번호를 입력하세요',
    bur: 'စကားဝှက်ထည့်ပါ',
    ben: 'পাসওয়ার্ড লিখুন',
    tr: 'Lutfen sifreyi girin',
    km: 'សូមបញ្ចូលពាក្យសម្ងាត់',
    es: 'Por favor ingrese la contraseña',
    ar: 'الرجاء إدخال كلمة المرور',
  },
  'main.head.title': {
    zh: '云排版',
    en: 'Bluen',
    id: 'Bluen',
    kz: 'Bluen',
    th: 'Bluen',
    ug: 'Bluen',
    vi: 'Bluen',
    zh_tc: '雲排版',
    ru: 'Bluen',
    ko: 'Bluen',
    bur: 'Bluen',
    ben: 'Bluen',
    tr: 'Bluen',
    km: 'Bluen',
    es: 'Bluen',
    ar: 'Bluen',
  },
  'main.head.subTitle': {
    zh: '省时，省料，省力气',
    en: 'Save time, materials, and effort',
    id: 'Save time, materials, and effort',
    kz: 'Save time, materials, and effort',
    th: 'Save time, materials, and effort',
    ug: 'Save time, materials, and effort',
    vi: 'Save time, materials, and effort',
    zh_tc: '省時，省料，省力氣',
    ru: 'Save time, materials, and effort',
    ko: 'Save time, materials, and effort',
    bur: 'Save time, materials, and effort',
    ben: 'Save time, materials, and effort',
    tr: 'Save time, materials, and effort',
    km: 'Save time, materials, and effort',
    es: 'Ahorre tiempo, material y esfuerzo',
    ar: 'توفير الوقت والمواد والجهد',
  },
  'main.head.task': {
    zh: '接任务',
    en: 'New Task',
    id: 'Mengambil tugas',
    kz: 'Місія алу',
    th: 'รับงาน',
    ug: 'ۋەزىپە قوبۇل قىلىش',
    vi: 'Nhận nhiệm vụ',
    zh_tc: '接任務',
    ru: 'Принять задание.',
    ko: '임무를 맡다',
    bur: 'တာဝန်ယူပါ',
    ben: 'টাস্ক গ্রহণ করুন',
    tr: 'Gorev Al',
    km: 'ទទួលភារកិច្ច',
    es: 'Aceptar tareas',
    ar: 'قبول المهام',
  },
  'main.head.arrange': {
    zh: '排版',
    en: 'Nest',
    id: 'penyusunan huruf',
    kz: 'Орнату',
    th: 'การเรียงพิมพ์',
    ug: 'تەرتىپلەش',
    vi: 'Điều hình',
    zh_tc: '排版',
    ru: 'верстка',
    ko: '편집',
    bur: 'ပြင်ဆင်မှု',
    ben: 'টাইপসেটিং',
    tr: 'Dizgi',
    km: 'ការរៀបប្លង់',
    es: 'Composición tipográfica',
    ar: 'التنضيد',
  },
  'main.head.surplus': {
    zh: '余料',
    en: 'Offcuts',
    id: 'Bahan yang tersisa',
    kz: 'Қалдық материал',
    th: 'วัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىال',
    vi: 'Yếu tố dư thừa',
    zh_tc: '餘料',
    ru: 'Оставшиеся материалы',
    ko: '여분',
    bur: 'ပိုလျှံပစ္စည်း',
    ben: 'উদ্বৃত্ত উপকরণ',
    tr: 'Artik Malzeme',
    km: 'សំណល់សម្ភារៈ',
    es: 'Materiales restantes',
    ar: 'المواد المتبقية',
  },
  'main.head.setting': {
    zh: '设置',
    en: 'Settings',
    id: 'mendirikan',
    kz: 'Құрамды орноту',
    th: 'ตั้งค่า',
    ug: 'تەڭشەش',
    vi: 'Cài đặt',
    zh_tc: '設置',
    ru: 'настройка',
    ko: '설정',
    bur: 'ဆက်တင်',
    ben: 'সেটিংস',
    tr: 'Ayarlar',
    km: 'ការកំណត់',
    es: 'Configuración',
    ar: 'الإعدادات',
  },
  'main.head.find': {
    zh: '发现',
    en: 'Discover',
    id: 'Menemukan',
    kz: 'Табу',
    th: 'ค้นพบ',
    ug: 'ئىزدەش',
    vi: 'Khám phá',
    zh_tc: '發現',
    ru: 'Обнаружено',
    ko: '발견',
    bur: 'ရှာဖွေတွေ့ရှိ',
    ben: 'আবিষ্কার করুন',
    tr: 'Kesfet',
    km: 'ស្វែងរក',
    es: 'Descubrir',
    ar: 'اكتشف',
  },
  'main.head.upgrade': {
    zh: '立即升级',
    en: 'Upgrade now',
    id: 'Tingkatkan sekarang',
    kz: 'жаңарту',
    th: 'อัพเกรดตอนนี้',
    ug: 'دەرھال يۇقىرى كۆتۈرۈش',
    vi: 'Nâng cấp ngay',
    zh_tc: '立即升級',
    ru: 'Немедленное повышение',
    ko: '지금 업그레이드',
    bur: 'ချက်ချင်းအဆင့်မြှင့်',
    ben: 'এখনই আপগ্রেড করুন',
    tr: 'Simdi Yukselt',
    km: 'ធ្វើបច្ចុប្បន្នភាពឥឡូវនេះ',
    es: 'Actualizar ahora',
    ar: 'الترقية الآن',
  },
  'main.head.editNickName': {
    zh: '修改昵称',
    en: 'Edit nickname',
    id: 'Ubah nama panggilan',
    kz: 'Атауды өзгерту',
    th: 'แก้ไขชื่อเล่น',
    ug: 'تەخەللۇس ئۆزگەرتىش',
    vi: 'Chỉnh sửa biệt danh',
    zh_tc: '修改暱稱',
    ru: 'Изменить псевдоним',
    ko: '닉네임 수정',
    bur: 'နာမည်ခေါ်ဝေါ်ပြင်',
    ben: 'ডাকনাম সম্পাদনা করুন',
    tr: 'Takma Adi Duzenle',
    km: 'កែប្រែឈ្មោះហៅក្រៅ',
    es: 'Modificar apodo',
    ar: 'تعديل اللقب',
  },
  'main.head.editPassword': {
    zh: '修改密码',
    en: 'Change password',
    id: 'Ubah Kata Sandi',
    kz: 'Құпия сөзді өзгерту',
    th: 'แก้ไขรหัสผ่าน',
    ug: 'پارول ئۆزگەرتىش',
    vi: 'Chỉnh sửa mật khẩu',
    zh_tc: '修改密碼',
    ru: 'изменить пароль',
    ko: '암호 수정',
    bur: 'စကားဝှက်ပြင်',
    ben: 'পাসওয়ার্ড পরিবর্তন করুন',
    tr: 'Sifreyi Degistir',
    km: 'កែប្រែពាក្យសម្ងាត់',
    es: 'Cambiar contraseña',
    ar: 'تغيير كلمة المرور',
  },
  'main.head.logout': {
    zh: '退出登录',
    en: 'Log out',
    id: 'Keluar',
    kz: 'Кіруден шығу',
    th: 'ออกจากระบบ',
    ug: 'تىزىمدىن چىقىش',
    vi: 'Thoát đăng nhập',
    zh_tc: '退出登錄',
    ru: 'Выйти из системы',
    ko: '로그인 종료',
    bur: 'ထွက်သွားပါ',
    ben: 'লগআউট করুন',
    tr: 'Cikis Yap',
    km: 'ចាកចេញ',
    es: 'Cerrar sesión',
    ar: 'تسجيل الخروج',
  },
  'main.head.notice': {
    zh: '公告',
    en: 'Announcement',
    id: 'pengumuman',
    kz: 'Жарнама',
    th: 'ประกาศ',
    ug: 'ئۇقتۇرۇش',
    vi: 'Thông báo',
    zh_tc: '公告',
    ru: 'Объявление',
    ko: '공지',
    bur: 'ကြေငြာချက်',
    ben: 'ঘোষণা',
    tr: 'Duyuru',
    km: 'សេចក្តីជូនដំណឹង',
    es: 'Anuncio',
    ar: 'إعلان',
  },
  'main.head.enterOfficial': {
    zh: '前往官网',
    en: 'Visit the Official Website',
    id: 'Kunjungi situs web resmi',
    kz: 'Официалды сайтына кіру',
    th: 'ไปที่เว็บไซต์อย่างเป็นทางการ',
    ug: 'رەسىمىي تور بېتىغا بارىش',
    vi: 'Đi đến trang web chính thức',
    zh_tc: '前往官網',
    ru: 'Перейти на официальный сайт',
    ko: '공식 홈페이지로 이동',
    bur: 'တရားဝင်ဝက်ဘ်ဆိုဒ်သွား',
    ben: 'অফিশিয়াল ওয়েবসাইটে যান',
    tr: 'Resmi Siteye Git',
    km: 'ចូលទៅកាន់គេហទំព័រផ្លូវការ',
    es: 'Ir al sitio web oficial',
    ar: 'انتقل إلى الموقع الرسمي',
  },
  'main.head.equipment': {
    zh: '机器设备',
    en: 'Equipment',
    id: 'Mesin dan peralatan',
    kz: 'Машиналар және құрылғылар',
    th: 'เครื่องจักรและอุปกรณ์',
    ug: 'ماشىنا قوراللىرى',
    vi: 'Thiết bị máy móc',
    zh_tc: '機器設備',
    ru: 'Машины и оборудование',
    ko: '기계 설비',
    bur: 'စက်ကိရိယာ',
    ben: 'যন্ত্রপাতি ও সরঞ্জাম',
    tr: 'Ekipman',
    km: 'ឧបករណ៍',
    es: 'Maquinaria y equipo',
    ar: 'الآلات والمعدات',
  },
  'main.head.help': {
    zh: '帮助',
    en: 'Help',
    id: 'membantu',
    kz: 'Қолдау',
    th: 'ช่วย',
    ug: 'ياردەم',
    vi: 'Trợ giúp',
    zh_tc: '幫助',
    ru: 'помощь',
    ko: '도움',
    bur: 'ကူညီမှု',
    ben: 'সাহায্য',
    tr: 'Yardim',
    km: 'ជំនួយ',
    es: 'Ayuda',
    ar: 'مساعدة',
  },
  'main.head.importFunc': {
    zh: '查看专属功能',
    en: 'View exclusive features',
    id: 'Lihat fitur ekslusif',
    kz: 'Мағлуматтан тыс қосымша құрылыстарды қараңыз',
    th: 'ดูคุณลักษณะเฉพาะเจาะจง',
    ug: 'خەصەنەتلىق ئۇسلۇپلارنى كۆرۈش',
    vi: 'Xem các tính năng đặc biệt',
    zh_tc: '查看專屬功能',
    ru: 'Посмотреть эксклюзивные функции',
    ko: '고유 기능 보기',
    bur: 'သီးသန့်လုပ်ဆောင်ချက်ကြည့်ပါ',
    ben: 'বিশেষ ফিচার দেখুন',
    tr: 'Ozel Ozellikleri Goster',
    km: 'មើលមុខងារពិសេស',
    es: 'Ver funciones exclusivas',
    ar: 'عرض الوظائف الحصرية',
  },
  'main.head.enterThinkerOfficial': {
    zh: '进入新格尔官网',
    en: 'Enter the Xin Ge Er Official Website',
    id: 'Masukkan situs web resmi Xingele',
    kz: 'Жинэрдің официалды сайтына кіру',
    th: 'ป้อนเว็บไซต์ทางการของ Xingele',
    ug: 'يېڭى گېر رەسىمىي تور بېتىغا كىرىش',
    vi: 'Đi vào trang web chính thức của Tân Nghi La',
    zh_tc: '進入新格爾官網',
    ru: 'Доступ к официальному сайту Новой Зеландии',
    ko: '뉴 겔 공식 홈페이지 입장',
    bur: 'Xingeer တရားဝင်ဝက်ဘ်ဆိုဒ်ဝင်ပါ',
    ben: 'Xingeer অফিশিয়াল ওয়েবসাইটে প্রবেশ করুন',
    tr: 'Xingeer Resmi Sitesine Gir',
    km: 'ចូលទៅកាន់គេហទំព័រផ្លូវការរបស់ Xingeer',
    es: 'Ingresar al sitio web oficial de Xinger',
    ar: 'أدخل موقع Xinger الرسمي',
  },
  'main.head.history': {
    zh: '保存历史',
    en: 'Save history',
    id: 'Simpan riwayat',
    kz: 'Қалптықтық сақтау',
    th: 'บันทึกประวัติศาสตร์',
    ug: 'تارىخنى ساقلاش',
    vi: 'Lịch sử lưu trữ',
    zh_tc: '保存歷史',
    ru: 'Сохранить историю',
    ko: '기록 저장',
    bur: 'မှတ်တမ်းသိမ်းပါ',
    ben: 'ইতিহাস সংরক্ষণ',
    tr: 'Gecmisi Kaydet',
    km: 'រក្សាទុកប្រវត្តិ',
    es: 'Guardar historial',
    ar: 'حفظ التاريخ',
  },
  'main.head.plankManager': {
    zh: '原片管理',
    en: 'Raw Panel',
    id: 'Manajemen Film Asli',
    kz: 'Бастапқы материалдарды басқару',
    th: 'การจัดการภาพยนตร์ดั้งเดิม',
    ug: 'ئەسلى تاختا باشقۇرۇش',
    vi: 'Quản lý nguyên tấm',
    zh_tc: '原片管理',
    ru: 'Управление оригиналами',
    ko: '원본 관리',
    bur: 'မူရင်းပေါ်ဒ်စီမံ',
    ben: 'মূল বোর্ড ব্যবস্থাপনা',
    tr: 'Stok Yonetimi',
    km: 'ការគ្រប់គ្រងបន្ទះដើម',
    es: 'Gestión de películas originales',
    ar: 'إدارة الأفلام الأصلية',
  },
  'main.head.tagManager': {
    zh: '标签管理',
    en: 'Label Mgmt',
    id: 'Manajemen tag',
    kz: 'Тексеруді басқару',
    th: 'การจัดการแท็ก',
    ug: 'بېلگە باشقۇرۇش',
    vi: 'Quản lý thẻ',
    zh_tc: '標籤管理',
    ru: 'Управление метками',
    ko: '태그 관리',
    bur: 'တံဆိပ်စီမံ',
    ben: 'লেবেল ব্যবস্থাপনা',
    tr: 'Etiket Yonetimi',
    km: 'ការគ្រប់គ្រងស្លាក',
    es: 'Gestión de etiquetas',
    ar: 'إدارة العلامات',
  },
  'main.head.suplumentManager': {
    zh: '补件和待排版库',
    en: 'Replacement & Nest Pool',
    id: 'Perpustakaan Pengisian dan Tata Letak',
    kz: 'Толтыру материалдарды басқару',
    th: 'ห้องสมุดการเติมเต็มและเค้าโครง',
    ug: 'تاماملىغۇچى ۋە تەرتىپلەش بۇكىتى',
    vi: 'Quản lý phụ kiện',
    zh_tc: '補件和待排版庫',
    ru: 'Библиотека дополнений и форматов',
    ko: '패치 및 예약된 라이브러리',
    bur: 'ဖြည့်ဆည်းပြင်ဆင်မှုဘောင်',
    ben: 'পরিপূরক ও অপেক্ষাধীন লেআউট লাইব্রেরি',
    tr: 'Ek Parca ve Bekleyen Dizgi Kutuphanesi',
    km: 'បណ្ណាល័យគ្រឿងបន្លាស់ និងរង់ចាំប្លង់',
    es: 'Piezas complementarias y biblioteca para componer',
    ar: 'الأجزاء التكميلية والمكتبة التي سيتم تنضيدها',
  },
  'main.head.fileManager': {
    zh: '文件管理',
    en: 'File Mgmt',
    id: 'Manajemen file',
    kz: 'Файлдарды басқару',
    th: 'การจัดการไฟล์',
    ug: 'ھۆججەت باشقۇرۇش',
    vi: 'Quản lý file',
    zh_tc: '文件管理',
    ru: 'Управление документацией',
    ko: '파일 관리',
    bur: 'ဖိုင်စီမံ',
    ben: 'ফাইল ব্যবস্থাপনা',
    tr: 'Dosya Yonetimi',
    km: 'ការគ្រប់គ្រងឯកសារ',
    es: 'Gestión de archivos',
    ar: 'إدارة الملفات',
  },
  'main.head.productionLine': {
    zh: '设备对接',
    en: 'Device Link',
    id: 'Docking peralatan',
    kz: 'Құрылғылармен қосылу',
    th: 'อุปกรณ์เชื่อมต่อ',
    ug: 'قوراللار بىرلەشتۈرۈش',
    vi: 'Kết nối thiết bị',
    zh_tc: '設備對接',
    ru: 'Стыковка оборудования',
    ko: '장치 버트',
    bur: 'ကိရိယာချိတ်ဆက်',
    ben: 'সরঞ্জাম সংযোগ',
    tr: 'Ekipman Entegrasyonu',
    km: 'ការភ្ជាប់ឧបករណ៍',
    es: 'Acoplamiento de equipos',
    ar: 'إرساء المعدات',
  },
  'main.head.workeShop': {
    zh: '云端生产',
    en: 'Cloud Production',
    id: 'Produksi di Cloud',
    kz: 'Бұлттық өндіріс',
    th: 'การผลิตบนคลาวด์',
    ug: 'بۇلۇتتىكى ئىشلەپچىقىرىش',
    vi: 'Sản xuất trên nền tảng đám mây',
    zh_tc: '雲端生產',
    ru: 'Облачное производство',
    ko: '클라우드 프로덕션',
    bur: 'Cloud ထုတ်လုပ်မှု',
    ben: 'ক্লাউড উৎপাদন',
    tr: 'Bulut Uretimi',
    km: 'ផលិតកម្មលើពពក',
    es: 'Producción en la nube',
    ar: 'الإنتاج السحابي',
  },
  'main.head.useLesson': {
    zh: '使用教程',
    en: 'Usage Tutorial',
    id: 'Tutorial Penggunaan',
    kz: 'Қолдану оқулығы',
    th: 'การสอนการใช้งาน',
    ug: 'ئىشلىتىش دەرسلىكى',
    vi: 'Hướng dẫn sử dụng',
    zh_tc: '使用教程',
    ru: 'Использование учебного пособия',
    ko: '자습서 사용',
    bur: 'အသုံးပြုနည်းသင်ခန်းစာ',
    ben: 'ব্যবহার টিউটোরিয়াল',
    tr: 'Kullanim Egitimi',
    km: 'មេរៀនប្រើប្រាស់',
    es: 'Tutorial de uso',
    ar: 'البرنامج التعليمي للاستخدام',
  },
  'main.head.videoLesson': {
    zh: '视频教程',
    en: 'Video tutorial',
    id: 'Tutorial video',
    kz: 'Видео оқулығы',
    th: 'การสอนวิดีโอ',
    ug: 'سىنلىق دەرس',
    vi: 'Hướng dẫn bằng video',
    zh_tc: '視頻教程',
    ru: 'видеоурок',
    ko: '비디오 자습서',
    bur: 'ဗီဒီယိုသင်ခန်းစာ',
    ben: 'ভিডিও টিউটোরিয়াল',
    tr: 'Video Egitimi',
    km: 'វីដេអូសិក្សា',
    es: 'Videotutorial',
    ar: 'فيديو تعليمي',
  },
  'main.head.prolineManager': {
    zh: '生产线管理',
    en: 'Line Mgmt',
    id: 'Manajemen Jalur Produksi',
    kz: 'Өндіріс желісін басқару',
    th: 'การจัดการสายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيىسى باشقۇرۇش',
    vi: 'Quản lý dây chuyền sản xuất',
    zh_tc: '生產線管理',
    ru: 'Управление производственными линиями',
    ko: '생산라인 관리',
    bur: 'ထုတ်လုပ်မှုလိုင်းစီမံ',
    ben: 'উৎপাদন লাইন ব্যবস্থাপনা',
    tr: 'Uretim Hatti Yonetimi',
    km: 'ការគ្រប់គ្រងខ្សែផលិតកម្ម',
    es: 'Gestión de línea de producción',
    ar: 'إدارة خط الإنتاج',
  },
  'main.head.materialManager': {
    zh: '板件管理',
    en: 'Panel Mgmt',
    id: 'Manajemen Dewan',
    kz: 'Материалдарды басқару',
    th: 'ผู้บริหารคณะกรรมการ',
    ug: 'تاختا باشقۇرۇش',
    vi: 'Quản lý vật liệu',
    zh_tc: '板件管理',
    ru: 'Управление панелями',
    ko: '보드 관리',
    bur: 'ပေါ်ဒ်စီမံ',
    ben: 'বোর্ড ব্যবস্থাপনা',
    tr: 'Parca Yonetimi',
    km: 'ការគ្រប់គ្រងបន្ទះ',
    es: 'Gestión de paneles',
    ar: 'إدارة اللوحة',
  },
  'main.head.productManual': {
    zh: '产品手册',
    en: 'Product Manual',
    id: 'Manual produk',
    kz: 'продукт менюсى',
    th: 'คู่มือผลิตภัณฑ์',
    ug: 'مەھسۇلات قوللانمىسى',
    vi: 'Hướng dẫn sản phẩm',
    zh_tc: '產品手冊',
    ru: 'Руководство по эксплуатации',
    ko: '제품 브로셔',
    bur: 'ကုန်ပစ္စည်းလမ်းညွှန်',
    ben: 'পণ্য ম্যানুয়াল',
    tr: 'Urun Kilavuzu',
    km: 'សៀវភៅណែនាំផលិតផល',
    es: 'Manual del producto',
    ar: 'دليل المنتج',
  },
  'main.head.medialRelated': {
    zh: '梯度发布',
    en: 'Gradient-related',
    id: 'Terkait gradien',
    kz: 'Градиентке қатысты',
    th: 'ที่เกี่ยวข้องกับเกรเดียนต์',
    ug: 'ئۇيغۇرچە ئەرەب يېزىقى',
    vi: 'Liên quan đến gradient',
    zh_tc: '梯度相關',
    ru: 'Выпуск градиента',
    ko: '그라데이션 게시',
    bur: 'တဆင့်ထုတ်ပြည်',
    ben: 'গ্রেডিয়েন্ট রিলিজ',
    tr: 'Kademeli Yayin',
    km: 'ការចេញផ្សាយជាដំណាក់កាល',
    es: 'Liberación de gradiente',
    ar: 'إصدار التدرج',
  },
  'main.sideBar.title': {
    zh: '生产优化',
    en: 'Production Optimize',
    id: 'Optimasi produksi',
    kz: 'Өндіріс оптималдау',
    th: 'การเพิ่มประสิทธิภาพการผลิต',
    ug: 'ئىشلەپچىقىرىش ئەڭ ياخشىلاش',
    vi: 'Tối ưu hóa sản xuất',
    zh_tc: '生產優化',
    ru: 'Оптимизация производства',
    ko: '생산 최적화',
    bur: 'ထုတ်လုပ်မှုကောင်းမွန်အောင်',
    ben: 'উৎপাদন অপ্টিমাইজেশন',
    tr: 'Uretim Optimizasyonu',
    km: 'ការបង្កើនប្រសិទ្ធភាពផលិតកម្ម',
    es: 'Optimización de producción',
    ar: 'تحسين الإنتاج',
  },
  'main.sideBar.materialList': {
    zh: '开料清单',
    en: 'Cut List',
    id: 'Daftar materi',
    kz: 'Материалдар тізімі',
    th: 'รายการวัสดุ',
    ug: 'ماتېرىال تىزىملىكى',
    vi: 'Danh sách nguyên liệu',
    zh_tc: '開料清單',
    ru: 'Открытый список',
    ko: '커팅 리스트',
    bur: 'ဖြတ်တောက်စာရင်း',
    ben: 'কাটার তালিকা',
    tr: 'Kesim Listesi',
    km: 'បញ្ជីកាត់',
    es: 'Lista de corte de materiales',
    ar: 'قائمة قطع المواد',
  },
  'main.sideBar.paibanTask': {
    zh: '排版任务',
    en: 'Nest Tasks',
    id: 'Tugas Tata Letak',
    kz: 'Татып түсіру тапсырмасы',
    th: 'งานจัดวางหน้า',
    ug: 'تەرتىپلەش تاپسىرىسى',
    vi: 'Nhiệm vụ điều hình',
    zh_tc: '排版任務',
    ru: 'Задание набора',
    ko: '조판 작업',
    bur: 'ပြင်ဆင်မှုစီမံချက်',
    ben: 'টাইপসেটিং কাজ',
    tr: 'Dizgi Görev',
    km: 'ការគ្រប់គ្រងប្លង់',
  },
  'main.sideBar.paibanResult': {
    zh: '排版方案',
    en: 'Nest Scheme',
    id: 'Rencana Pengesahan Penetapan',
    kz: 'Орнату жоспары',
    th: 'แผนการเรียงลำดับ',
    ug: 'تەرتىپلەش پىلانى',
    vi: 'Kế hoạch điều hình',
    zh_tc: '排版方案',
    ru: 'Типограмма',
    ko: '조판 방안',
    bur: 'ပြင်ဆင်မှုစီမံချက်',
    ben: 'লেআউট পরিকল্পনা',
    tr: 'Dizgi Plani',
    km: 'ផែនការប្លង់',
    es: 'Plan de composición tipográfica',
    ar: 'خطة التنضيد',
  },
  'main.sideBar.printTag': {
    zh: '打印标签',
    en: 'Print Labels',
    id: 'Label cetak',
    kz: 'Тексеруді басып шығару',
    th: 'พิมพ์ฉลาก',
    ug: 'بېلگە بېسىش',
    vi: 'In nhãn',
    zh_tc: '打印標籤',
    ru: 'Печать тегов',
    ko: '레이블 인쇄',
    bur: 'တံဆိပ်ပုံနှိပ်ပါ',
    ben: 'লেবেল প্রিন্ট করুন',
    tr: 'Etiket Yazdir',
    km: 'បោះពុម្ពស្លាក',
    es: 'Impresión de etiquetas',
    ar: 'ملصقات الطباعة',
  },
  'main.sideBar.history': {
    zh: '保存历史',
    en: 'Save History',
    id: 'Simpan riwayat',
    kz: 'Қалптықтық сақтау',
    th: 'บันทึกประวัติศาสตร์',
    ug: 'تارىخنى ساقلاش',
    vi: 'Lịch sử lưu trữ',
    zh_tc: '保存歷史',
    ru: 'Сохранить историю',
    ko: '기록 저장',
    bur: 'မှတ်တမ်းသိမ်းပါ',
    ben: 'ইতিহাস সংরক্ষণ',
    tr: 'Gecmisi Kaydet',
    km: 'រក្សាទុកប្រវត្តិ',
    es: 'Guardar historial',
    ar: 'حفظ التاريخ',
  },
  'main.sideBar.limitDate': {
    zh: '限免',
    en: 'LTF',
    id: 'Limited Free',
    kz: 'Limited Free',
    th: 'Limited Free',
    ug: 'Limited Free',
    vi: 'Limited Free',
    zh_tc: '限免',
    ru: 'Limited Free',
    ko: 'Limited Free',
    bur: 'Limited Free',
    ben: 'Limited Free',
    tr: 'Limited Free',
    km: 'Limited Free',
    es: 'Exención limitada',
    ar: 'إعفاء محدود',
  },
  'main.sideBar.surplusManager': {
    zh: '余料管理',
    en: 'Surplus Stock',
    id: 'Manajemen materi yang tersisa',
    kz: 'Қалдық материалдарды басқару',
    th: 'การจัดการวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىال باشقۇرۇش',
    vi: 'Quản lý yếu tố dư thừa',
    zh_tc: '餘料管理',
    ru: 'Управление излишками',
    ko: '여분 관리',
    bur: 'ပိုလျှံပစ္စည်းစီမံ',
    ben: 'উদ্বৃত্ত ব্যবস্থাপনা',
    tr: 'Artik Malzeme Yonetimi',
    km: 'ការគ្រប់គ្រងសំណល់សម្ភារៈ',
    es: 'Gestión de materiales restantes',
    ar: 'إدارة المواد المتبقية',
  },
  'main.sideBar.translateManager': {
    zh: '翻译管理',
    en: 'Translate Management',
    id: 'Manajemen Terjemahan',
    kz: 'Тексеру кодын басқару',
    th: 'การจัดการการแปล',
    ug: 'تەرجىمە باشقۇرۇش',
    vi: 'Quản lý dịch thuật',
    zh_tc: '翻譯管理',
    ru: 'Управление переводом',
    ko: '번역 관리',
    bur: 'ဘာသာပြန်စီမံ',
    ben: 'অনুবাদ ব্যবস্থাপনা',
    tr: 'Ceviri Yonetimi',
    km: 'ការគ្រប់គ្រងការបកប្រែ',
    es: 'Gestión de traducción',
    ar: 'إدارة الترجمة',
  },
  'main.sideBar.moreSettings': {
    zh: '更多设置',
    en: 'More settings',
    id: 'Lebih banyak pengaturan',
    kz: 'Қосымша параметрлер',
    th: 'การตั้งค่าเพิ่มเติม',
    ug: 'تېخىمۇ كۆپ تەڭشەش',
    vi: 'Thêm cài đặt',
    zh_tc: '更多設置',
    ru: 'Больше настроек',
    ko: '추가 설정',
    bur: 'နောက်ထပ်ဆက်တင်',
    ben: 'আরও সেটিংস',
    tr: 'Daha Fazla Ayar',
    km: 'ការកំណត់បន្ថែម',
    es: 'Más configuraciones',
    ar: 'المزيد من الإعدادات',
  },
  'main.sideBar.deepSeekTitle': {
    zh: '咨询顾问',
    en: 'Consulting consultant',
    id: 'Penasihat Konsultasi',
    kz: 'Кеңес беруші',
    th: 'ที่ปรึกษาการให้คำปรึกษา',
    ug: 'مەسلىھەتچى',
    vi: 'Сәлеметсіз бе! Күзгүді соңғы нұсқасына жаңартыңыз.',
    zh_tc: '諮詢顧問',
    ru: 'Консультанты',
    ko: '컨설턴트',
    bur: 'အကြံပေးပုဂ္ဂိုလ်',
    ben: 'পরামর্শদাতা',
    tr: 'Danisman',
    km: 'អ្នកប្រឹក្សា',
    es: 'Consultores',
    ar: 'الاستشاريون',
  },
  'main.sideBar.paibanCommune': {
    zh: '排版交流群',
    en: 'Nest Group',
    id: 'Grup Diskusi Tata Letak',
    kz: 'Жазуды реттеу пікірталас тобы',
    th: 'กลุ่มสนทนาเกี่ยวกับการจัดเรียงหน้า',
    ug: 'بەت تەرتىپلەش مۇنازىرە گۇرۇپپىسى',
    vi: 'Nhóm thảo luận về Dàn trang',
    zh_tc: '排版交流群組',
    ru: 'Группа обмена наборами',
    ko: '조판 교류군',
    bur: 'ပြင်ဆင်မှုဆွေးနွေးအဖွဲ့',
    ben: 'টাইপসেটিং আলোচনা গ্রুপ',
    tr: 'Dizgi Tartisma Grubu',
    km: 'ក្រុមពិភាក្សាប្លង់',
    es: 'Grupo de intercambio de composición tipográfica',
    ar: 'مجموعة تبادل التنضيد',
  },
  'main.allRead': {
    zh: '全部已读',
    en: 'All Read',
    id: 'Semua dibaca',
    kz: 'Бәрі оқып шықты',
    th: 'อ่านทั้งหมด',
    ug: 'ھەممىسى ئوقۇلدى',
    vi: 'Tất cả đã đọc',
    zh_tc: '全部已讀',
    ru: 'Все прочитано',
    ko: '모두 읽음',
    bur: 'အားလုံးဖတ်ပြီး',
    ben: 'সব পঠিত',
    tr: 'Hepsi Okundu',
    km: 'អានទាំងអស់រួច',
    es: 'Todo leído',
    ar: 'تمت قراءة الكل',
  },
  'main.learnMore': {
    zh: '了解详情',
    en: 'Learn More',
    id: 'Pelajari lebih lanjut',
    kz: 'Толық мәлімет',
    th: 'เรียนรู้เพิ่มเติม',
    ug: 'تېخىمۇ كۆپ بىلىش',
    vi: 'Xem chi tiết',
    zh_tc: '了解詳情',
    ru: 'Узнать подробности',
    ko: '자세히 보기',
    bur: 'အသေးစိတ်ကြည့်ပါ',
    ben: 'বিস্তারিত জানুন',
    tr: 'Daha Fazla Bilgi',
    km: 'ស្វែងយល់បន្ថែម',
    es: 'Más información',
    ar: 'اعرف المزيد',
  },
  'main.noticeEmpty': {
    zh: '暂无公告....',
    en: 'No Announcements Available...',
    id: 'Belum ada pengumuman ...',
    kz: 'Жарнамалар жоқ...',
    th: 'ยังไม่มีการประกาศ ...',
    ug: 'ھازىرچە ئۇقتۇرۇش يوق....',
    vi: 'Chưa có thông báo....',
    zh_tc: '暫無公告....',
    ru: 'Нет объявлений. И...',
    ko: '잠시 공고가 없다....',
    bur: 'ကြေငြာချက်မရှိသေး....',
    ben: 'এখনো কোনো ঘোষণা নেই....',
    tr: 'Henuz duyuru yok....',
    km: 'មិនទាន់មានសេចក្តីជូនដំណឹងទេ....',
    es: 'Ningún anuncio aún....',
    ar: 'لا يوجد إعلان حتى الآن....',
  },
  'main.noticeErr': {
    zh: '获取详细公告内容错误',
    en: 'Error Fetching Detailed Announcements',
    id: 'Kesalahan mendapatkan konten pengumuman terperinci',
    kz: 'Жарнама мазмұнын алуда қателік',
    th: 'ข้อผิดพลาดรับเนื้อหาประกาศโดยละเอียด',
    ug: 'ئۇقتۇرۇش مەزمۇنىنى ئېلىش خاتالىقى',
    vi: 'Lỗi khi lấy chi tiết thông báo',
    zh_tc: '獲取詳細公告內容錯誤',
    ru: 'Ошибка получения подробных объявлений',
    ko: '자세한 공지 내용 가져오기 오류',
    bur: 'ကြေငြာချက်အသေးစိတ်ရယူမှုအမှား',
    ben: 'বিস্তারিত ঘোষণা নেওয়ায় ত্রুটি',
    tr: 'Ayrintili duyuru icerigi alinirken hata',
    km: 'មានកំហុសក្នុងការទទួលយកខ្លឹមសារសេចក្តីជូនដំណឹងលម្អិត',
    es: 'Obtener anuncio detallado Error de contenido',
    ar: 'احصل على خطأ محتوى إعلان تفصيلي',
  },
  'main.feedBack.tab1': {
    zh: '提交反馈',
    en: 'Submit feedback',
    id: 'Kirimkan umpan balik',
    kz: 'Пікірді беріңіз',
    th: 'ส่งข้อเสนอแนะ',
    ug: 'ئەرز قويۇش',
    vi: 'Gửi phản hồi',
    zh_tc: '提交反饋',
    ru: 'Представление отзывов',
    ko: '피드백 제출',
    bur: 'တုံ့ပြန်ချက်တင်ပြပါ',
    ben: 'মতামত জমা দিন',
    tr: 'Geri Bildirim Gonder',
    km: 'ដាក់ស្នើមតិត្រឡប់',
    es: 'Enviar comentarios',
    ar: 'إرسال تعليقات',
  },
  'main.feedBack.tab2': {
    zh: '反馈记录',
    en: 'Feedback record',
    id: 'Catatan umpan balik',
    kz: 'Пікірлер тізімі',
    th: 'บันทึกข้อเสนอแนะ',
    ug: 'ئەرز خاتىرىسى',
    vi: 'Lịch sử phản hồi',
    zh_tc: '反饋記錄',
    ru: 'Запись обратной связи',
    ko: '피드백 레코드',
    bur: 'တုံ့ပြန်ချက်မှတ်တမ်း',
    ben: 'মতামতের রেকর্ড',
    tr: 'Geri Bildirim Kaydi',
    km: 'កំណត់ត្រាមតិត្រឡប់',
    es: 'Registro de comentarios',
    ar: 'سجل التعليقات',
  },
  'main.feedBack.type': {
    zh: '意见类型',
    en: 'Feedback type',
    id: 'Jenis komentar',
    kz: 'Пікір түрі',
    th: 'ประเภทของความคิดเห็น',
    ug: 'پىكر تىپى',
    vi: 'Loại ý kiến',
    zh_tc: '意見類型',
    ru: 'Тип замечания',
    ko: '의견 유형',
    bur: 'အကြံပြုချက်အမျိုးအစား',
    ben: 'মতামতের ধরন',
    tr: 'Geri Bildirim Turu',
    km: 'ប្រភេទមតិ',
    es: 'Tipo de comentario',
    ar: 'نوع التعليق',
  },
  'main.feedBack.typePlaceholder': {
    zh: '请选择功能',
    en: 'Please select a feature',
    id: 'Pilih suatu fungsi',
    kz: 'Қызметті функцияны таңдаңыз',
    th: 'โปรดเลือกฟังก์ชั่น',
    ug: 'ئىقتىدارنى تاللاڭ',
    vi: 'Vui lòng chọn chức năng',
    zh_tc: '請選擇功能',
    ru: 'Выберите функцию',
    ko: '기능 선택',
    bur: 'လုပ်ဆောင်ချက်ရွေးပါ',
    ben: 'ফাংশন নির্বাচন করুন',
    tr: 'Lutfen bir ozellik secin',
    km: 'សូមជ្រើសមុខងារ',
    es: 'Seleccione la función',
    ar: 'يرجى اختيار الوظيفة',
  },
  'main.feedBack.description': {
    zh: '描述',
    en: 'Description',
    id: 'menggambarkan',
    kz: 'Сипаттама',
    th: 'อธิบาย',
    ug: 'تەسۋىرلەش',
    vi: 'Mô tả',
    zh_tc: '描述',
    ru: 'описание',
    ko: '묘사',
    bur: 'ဖော်ပြချက်',
    ben: 'বিবরণ',
    tr: 'Aciklama',
    km: 'ការពិពណ៌នា',
    es: 'Descripción',
    ar: 'الوصف',
  },
  'main.feedBack.descriptionPlaceholder': {
    zh: 'hi～请填写不少于15字的详细使用场景描述，以便我们更好地为您提供帮助，感谢配合！',
    en: 'Hi! Please provide a detailed usage scenario description of at least 15 words to help us better assist you. Thank you for your cooperation!',
    id: 'Hai ~ Harap isi deskripsi skenario penggunaan terperinci tidak kurang dari 15 kata sehingga kami dapat membantu Anda dengan lebih baik. Terima kasih atas kerja sama Anda!',
    kz: 'хайр! Толық пайдалану сценарийін сипаттау үшін 15 аз емес әріптерді толтыруңыз, біз сізге жақсы көмек көрсетеміз, спасибо!',
    th: 'สวัสดี ~ โปรดกรอกคำอธิบายสถานการณ์การใช้โดยละเอียดไม่น้อยกว่า 15 คำเพื่อให้เราสามารถช่วยคุณได้ดีขึ้น ขอบคุณสำหรับความร่วมมือ!',
    ug: 'ئەسسالامۇ ئەلەيكۇم، كەم دېگەندە 15 خەتلىك ئىشلىتىش مۇھىتىنى تەسۋىرلەڭ، بىزگە ياردەم بېرىشىڭىز ئۈچۈن رەھمەت!',
    vi: 'Hi～Vui lòng điền mô tả chi tiết không dưới 15 ký tự về trường hợp sử dụng để chúng tôi có thể hỗ trợ bạn tốt hơn, cảm ơn sự hợp tác!',
    zh_tc:
      'hi～請填寫不少於15字的詳細使用場景描述，以便我們更好地為您提供幫助，感謝配合！',
    ru: 'hi - Пожалуйста, заполните подробное описание сценария использования не менее 15 слов, чтобы мы могли лучше помочь вам, спасибо за сотрудничество!',
    ko: 'hi~15자 이상의 상세한 사용 장면 설명을 기입하여 우리가 당신에게 더 잘 도움을 제공할 수 있도록 해 주십시오. 협조해 주셔서 감사합니다!',
    bur: 'ကျွန်ုပ်တို့ကိုပိုမိုကောင်းမွန်စွာကူညီနိုင်ရန် အနည်းဆုံးစကားလုံး ၁၅ လုံးပါသောအသုံးပြုနည်းဖော်ပြချက်ဖြည့်ပါ',
    ben: 'আমাদের আরও ভালোভাবে সাহায্য করতে সক্ষম হতে কমপক্ষে ১৫ শব্দের বিস্তারিত ব্যবহারের দৃশ্যকল্প বিবরণ দিন',
    tr: 'Merhaba~ Lutfen en az 15 kelimelik ayrintili kullanim senaryosu aciklamasi girin, boylece size daha iyi yardim edebiliriz. Is birliginiz icin tesekkur ederiz!',
    km: 'សួស្តី~ សូមបំពេញការពិពណ៌នាសេណារីយ៉ូការប្រើប្រាស់លម្អិតយ៉ាងហោចណាស់ 15 ពាក្យ ដើម្បីឱ្យយើងអាចជួយអ្នកបានកាន់តែល្អ សូមអរគុណសម្រាប់កិច្ចសហការ!',
    es: 'Hola ~ Complete una descripción detallada del escenario de uso de no menos de 15 palabras para que podamos ayudarlo mejor. ¡Gracias por su cooperación!',
    ar: 'مرحبًا ~ يرجى ملء وصف تفصيلي لسيناريو الاستخدام لا يقل عن 15 كلمة حتى نتمكن من مساعدتك بشكل أفضل. شكرا لتعاونكم!',
  },
  'main.feedBack.uploadPic': {
    zh: '添加图片，最多可添加6张，单张图片大小不超过10M）',
    en: 'Add Pictures (Max 6 images, each no larger than 10MB)',
    id: 'Tambahkan gambar, hingga 6 gambar dapat ditambahkan, dan ukuran satu gambar tidak boleh melebihi 10m)',
    kz: 'Суреттерді қосу, ең көп 6 суретті, әр суреттің көлемі 10 МБ-ден аспайды)',
    th: 'เพิ่มรูปภาพได้มากถึง 6 รูปภาพและขนาดของภาพเดียวจะต้องไม่เกิน 10m)',
    ug: 'رەسىم قوشۇش (ئەڭ كۆپ 6 دانە، ھەر بىر رەسىم 10M دىن ئاشمايدۇ)',
    vi: 'Thêm hình ảnh, tối đa có thể thêm 6 bức ảnh, dung lượng của mỗi bức ảnh không quá 10M',
    zh_tc: '添加圖片，最多可添加6張，單張圖片大小不超過10M）',
    ru: 'Добавить изображение можно до 6, размер одного изображения не превышает 10 м)',
    ko: '그림 추가, 최대 6장, 단일 사진 크기 10M 미만)',
    bur: 'ပုံထည့်ပါ၊ အများဆုံး ၆ ပုံ၊ တပုံအရွယ်အစား ၁၀M မကျော်',
    ben: 'ছবি যোগ করুন, সর্বোচ্চ ৬টি, প্রতিটি ছবির আকার ১০MB-এর বেশি নয়',
    tr: "Resim ekle (en fazla 6 resim, her biri 10 MB'i gecmemelidir)",
    km: 'បន្ថែមរូបភាព (អាចបន្ថែមបានច្រើនបំផុត 6 សន្លឹក ហើយរូបភាពនីមួយៗមិនលើស 10MB)',
    es: 'Agregar imágenes, se pueden agregar hasta 6, el tamaño de una sola imagen no excede los 10 M)',
    ar: 'إضافة صور، يمكن إضافة ما يصل إلى 6 صور، حجم الصورة الواحدة لا يتجاوز 10 ميجا)',
  },
  'main.feedBack.tell': {
    zh: '联系电话',
    en: 'Contact number',
    id: 'Nomor kontak',
    kz: 'Қолдану телефоны',
    th: 'หมายเลขติดต่อ',
    ug: 'ئالاقىلىشىش تېلېفونى',
    vi: 'Số điện thoại liên lạc',
    zh_tc: '聯繫電話',
    ru: 'Контактный телефон',
    ko: '연락처',
    bur: 'ဆက်သွယ်ရေးဖုန်းနံပါတ်',
    ben: 'যোগাযোগের নম্বর',
    tr: 'Iletisim Numarasi',
    km: 'លេខទំនាក់ទំនង',
    es: 'Número de contacto',
    ar: 'رقم الاتصال',
  },
  'main.feedBack.submit': {
    zh: '提交',
    en: 'Submit',
    id: 'kirim',
    kz: 'Беріңіз',
    th: 'ส่ง',
    ug: 'تاپشۇرۇش',
    vi: 'Gửi',
    zh_tc: '提交',
    ru: 'отправить',
    ko: '제출',
    bur: 'တင်ပြပါ',
    ben: 'জমা দিন',
    tr: 'Gonder',
    km: 'ដាក់ស្នើ',
    es: 'Enviar',
    ar: 'إرسال',
  },
  'main.feedBack.admin': {
    zh: '云排版管理员：',
    en: 'Cloud Typesetting Administrator:',
    id: 'Administrator pengaturan huruf cloud:',
    kz: 'Бұлттарды орастыру әкімшісі:',
    th: 'ผู้ดูแลระบบประเภทคลาวด์:',
    ug: 'بۇلۇت تەرتىپلىگۈچ باشقۇرغۇچى:',
    vi: 'Quản trị viên Điều hình đám mây:',
    zh_tc: '雲排版管理員：',
    ru: 'Облачный редактор:',
    ko: '클라우드 레이아웃 관리자:',
    bur: 'Cloud Layout စီမံခန့်ခွဲသူ:',
    ben: 'ক্লাউড টাইপসেটিং প্রশাসক:',
    tr: 'Bulut Dizgi Yoneticisi:',
    km: 'អ្នកគ្រប់គ្រងការរៀបប្លង់លើពពក៖',
    es: 'Administrador de composición tipográfica en la nube:',
    ar: 'مسؤول التنضيد السحابي:',
  },
  'main.feedBack.picTip': {
    zh: '图片:(单击展开查看图片详情)',
    en: 'Image: (Click to expand and view image details)',
    id: 'Gambar: (klik untuk memperluas untuk melihat detail gambar)',
    kz: 'Сурет: (суреттішекті ашу)',
    th: 'รูปภาพ: (คลิกเพื่อขยายเพื่อดูรายละเอียดรูปภาพ)',
    ug: 'رەسىم: (رەسىم تەپسىلاتىنى كۆرۈش ئۈچۈن چېكىڭ)',
    vi: 'Hình ảnh: (Nhấn để mở rộng xem chi tiết hình ảnh)',
    zh_tc: '圖片:(單擊展開查看圖片詳情)',
    ru: 'Фото: (Нажмите для расширения, чтобы увидеть детали изображения)',
    ko: '사진: (사진 상세 정보를 보려면 확장 클릭)',
    bur: 'ပုံ: (ပုံအသေးစိတ်ကြည့်ရန်နှိပ်ပါ)',
    ben: 'ছবি: (ছবির বিস্তারিত দেখতে ক্লিক করুন)',
    tr: 'Resim: (ayrintilari gormek icin tiklayin)',
    km: 'រូបភាព៖ (ចុចដើម្បីពង្រីក និងមើលព័ត៌មានលម្អិត)',
    es: 'Imagen: (Haga clic para ampliar para ver los detalles de la imagen)',
    ar: 'الصورة: (انقر للتوسيع لعرض تفاصيل الصورة)',
  },
  'main.feedBack.empty': {
    zh: '暂无反馈数据',
    en: 'No Feedback Data Available',
    id: 'Belum ada data umpan balik',
    kz: 'Пікірлер деректері жоқ',
    th: 'ยังไม่มีข้อมูลข้อเสนอแนะ',
    ug: 'ھازىرچە ئەرز سانلىق مەلۇماتى يوق',
    vi: 'Chưa có dữ liệu phản hồi',
    zh_tc: '暫無反饋數據',
    ru: 'Нет данных обратной связи',
    ko: '피드백 데이터 없음',
    bur: 'တုံ့ပြန်ချက်ဒေတာမရှိသေး',
    ben: 'এখনো কোনো মতামত ডেটা নেই',
    tr: 'Geri bildirim verisi yok',
    km: 'មិនទាន់មានទិន្នន័យមតិត្រឡប់ទេ',
    es: 'Sin datos de comentarios',
    ar: 'لا توجد بيانات ملاحظات',
  },
  'main.feedBack.picErr': {
    zh: '单张图片大小不超过10M',
    en: 'Each image should not exceed 10MB',
    id: 'Ukuran satu gambar tidak boleh melebihi 10m',
    kz: 'Әр суреттің көлемі 10 МБ-ден аспайды',
    th: 'ขนาดของภาพเดียวไม่ควรเกิน 10m',
    ug: 'ھەر بىر رەسىم 10M دىن ئاشمايدۇ',
    vi: 'Dung lượng của mỗi bức ảnh không quá 10M',
    zh_tc: '單張圖片大小不超過10M',
    ru: 'Размер изображения не превышает 10 м',
    ko: '한 장의 그림 크기는 10M을 넘지 않는다',
    bur: 'တပုံအရွယ်အစား ၁၀M မကျော်ရ',
    ben: 'প্রতিটি ছবির আকার ১০MB-এর বেশি হওয়া উচিত নয়',
    tr: "Her resim 10 MB'i gecmemelidir",
    km: 'រូបភាពនីមួយៗមិនអាចលើស 10MB បានទេ',
    es: 'El tamaño de una sola imagen no excede los 10 M',
    ar: 'حجم الصورة الواحدة لا يتجاوز 10 ميجا',
  },
  'main.feedBack.contentErr': {
    zh: '字数应在 15 到 300 之间',
    en: 'The number of characters should be between 15 and 300',
    id: 'Jumlah kata harus antara 15 dan 300',
    kz: 'Әріптер саны 15 - 300 аралығында болуы тиіс',
    th: 'จำนวนคำควรอยู่ระหว่าง 15 ถึง 300',
    ug: 'خەت سانى 15 دىن 300 گىچە بولۇشى كېرەك',
    vi: 'Số ký tự phải trong khoảng 15 đến 300',
    zh_tc: '字數應在 15 到 300 之間',
    ru: 'Количество слов должно быть от 15 до 300.',
    ko: '글자 수는 15에서 300 사이여야 한다',
    bur: 'စာလုံးအရေအတွက် ၁၅ မှ ၃၀၀ ကြား',
    ben: 'অক্ষর সংখ্যা ১৫ থেকে ৩০০ এর মধ্যে হতে হবে',
    tr: 'Karakter sayisi 15 ile 300 arasinda olmalidir',
    km: 'ចំនួនតួអក្សរត្រូវនៅចន្លោះ 15 ដល់ 300',
    es: 'El número de palabras debe estar entre 15 y 300',
    ar: 'يجب أن يكون عدد الكلمات بين 15 و300',
  },
  'main.feedBack.necessary': {
    zh: '该选项必填',
    en: 'This field is required',
    id: 'Opsi ini diperlukan',
    kz: 'Бұл параметрді толтыру керек',
    th: 'ตัวเลือกนี้เป็นสิ่งจำเป็น',
    ug: 'بۇ تاللاش زۆرۈر',
    vi: 'Tùy chọn này là bắt buộc',
    zh_tc: '該選項必填',
    ru: 'Эта опция должна быть заполнена',
    ko: '이 옵션은 필수입니다.',
    bur: 'ဤရွေးချယ်မှုမဖြစ်မနေဖြည့်ရမည်',
    ben: 'এই ক্ষেত্রটি পূরণ করা বাধ্যতামূলক',
    tr: 'Bu alan zorunludur',
    km: 'ជម្រើសនេះត្រូវបំពេញជាចាំបាច់',
    es: 'Esta opción es obligatoria',
    ar: 'هذا الخيار مطلوب',
  },
  'taskPage.tab1': {
    zh: '生产任务',
    en: 'Production Task',
    id: 'Tugas produksi',
    kz: 'Өндірістік тапсырыс',
    th: 'งานผลิต',
    ug: 'ئىشلەپچىقىرىش ۋەزىپىسى',
    vi: 'Nhiệm vụ sản xuất',
    zh_tc: '生產任務',
    ru: 'Производственные задачи',
    ko: '생산 임무',
    bur: 'ထုတ်လုပ်မှုတာဝန်',
    ben: 'উৎপাদন টাস্ক',
    tr: 'Uretim Gorevi',
    km: 'ភារកិច្ចផលិតកម្ម',
    es: 'Tarea de producción',
    ar: 'مهمة الإنتاج',
  },
  'taskPage.tab2': {
    zh: '批量生产队列',
    en: 'Mass production queue',
    id: 'Antrian produksi massal',
    kz: 'Серілік өндіріс кезектесі',
    th: 'คิวการผลิตจำนวนมาก',
    ug: 'جەمئىي ئىشلەپچىقىرىش قۇرۇلمىسى',
    vi: 'Hàng loạt sản xuất',
    zh_tc: '批量生產隊列',
    ru: 'Очередь серийного производства',
    ko: '대량 생산 대기열',
    bur: 'အစုလိုက်ထုတ်လုပ်မှုတန်းစီ',
    ben: 'ব্যাচ উৎপাদন কিউ',
    tr: 'Toplu Uretim Kuyrugu',
    km: 'ជួរផលិតកម្មច្រើន',
    es: 'Cola de producción en masa',
    ar: 'قائمة انتظار الإنتاج الضخم',
  },
  'taskPage.filter.title': {
    zh: '筛选',
    en: 'Filter',
    id: 'menyaring',
    kz: 'Сүзгілеу',
    th: 'กรอง',
    ug: 'سۈزگۈچ',
    vi: 'Lọc',
    zh_tc: '篩選',
    ru: 'отбор',
    ko: '선별',
    bur: 'စစ်ထုတ်ပါ',
    ben: 'ফিল্টার',
    tr: 'Filtrele',
    km: 'តម្រង',
    es: 'Filtrar',
    ar: 'تصفية',
  },
  'taskPage.filter.unArrange': {
    zh: '未排版',
    en: 'Not formatted',
    id: 'Tidak diketik',
    kz: 'Орнатусіз',
    th: 'ไม่ได้พิมพ์',
    ug: 'تەرتىپلەنمىگەن',
    vi: 'Chưa điều hình',
    zh_tc: '未排版',
    ru: 'Без типографии',
    ko: '미조판',
    bur: 'မပြင်ဆင်ရသေး',
    ben: 'লেআউট করা হয়নি',
    tr: 'Henuz Dizilmedi',
    km: 'មិនទាន់រៀបប្លង់',
    es: 'Sin composición tipográfica',
    ar: 'عدم التنضيد',
  },
  'taskPage.filter.arranged': {
    zh: '已排版',
    en: 'Arranged',
    id: 'Diketik',
    kz: 'Орнату',
    th: 'ที่พิมพ์ออกมา',
    ug: 'تەرتىپلەنگەن',
    vi: 'Đã điều hình',
    zh_tc: '已排版',
    ru: 'Серия',
    ko: '조판됨',
    bur: 'ပြင်ဆင်ပြီး',
    ben: 'লেআউট করা হয়েছে',
    tr: 'Dizildi',
    km: 'បានរៀបប្លង់',
    es: 'Composición tipográfica',
    ar: 'التنضيد',
  },
  'taskPage.filter.allArranged': {
    zh: '全部已排版',
    en: 'All Arranged',
    id: 'Semua telah diketik',
    kz: 'Барлығы орналастырылды',
    th: 'ทั้งหมดได้รับการพิมพ์',
    ug: 'ھەممىسى تەرتىپلەنگەن',
    vi: 'Tất cả đã được bố trí',
    zh_tc: '全部已排版',
    ru: 'Все напечатано',
    ko: '모두 조판됨',
    bur: 'အားလုံးပြင်ဆင်ပြီး',
    ben: 'সব লেআউট করা হয়েছে',
    tr: 'Hepsi Dizildi',
    km: 'ទាំងអស់បានរៀបប្លង់',
    es: 'Toda composición tipográfica',
    ar: 'التنضيد الكامل',
  },
  'taskPage.filter.preLayout': {
    zh: '预排版',
    en: 'Pre-layout',
    id: 'Pra-tipe',
    kz: 'Алдын ала орналастыру',
    th: 'ก่อนประเภท',
    ug: 'ئالدىن تەرتىپلەش',
    vi: 'Bố trí trước',
    zh_tc: '預排版',
    ru: 'Предварительная типография',
    ko: '사전 조판',
    bur: 'ကြိုတင်ပြင်ဆင်မှု',
    ben: 'প্রি-লেআউট',
    tr: 'On Dizgi',
    km: 'ប្លង់មុន',
    es: 'Composición previa',
    ar: 'التنضيد المسبق',
  },
  'taskPage.search.placeholder': {
    zh: '请输入搜索内容',
    en: 'Please enter the search content',
    id: 'Harap masukkan konten pencarian',
    kz: 'Іздеу мазмұнын енгізу',
    th: 'กรุณากรอกเนื้อหาการค้นหา',
    ug: 'ئىزدەش مەزمۇنىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập nội dung tìm kiếm',
    zh_tc: '請輸入搜索內容',
    ru: 'Введите содержимое поиска',
    ko: '검색 내용을 입력하십시오.',
    bur: 'ရှာဖွေမည့်အကြောင်းအရာထည့်ပါ',
    ben: 'অনুসন্ধানের বিষয়বস্তু লিখুন',
    tr: 'Lutfen arama icerigini girin',
    km: 'សូមបញ្ចូលមាតិកាស្វែងរក',
    es: 'Ingrese el contenido de la búsqueda',
    ar: 'يرجى إدخال محتوى البحث',
  },
  'taskPage.search.orderName': {
    zh: '订单名称',
    en: 'Order name',
    id: 'Nama pesanan',
    kz: 'Тапсырыс атауы',
    th: 'ชื่อสั่งซื้อ',
    ug: 'زاكاز ئاتى',
    vi: 'Tên đơn hàng',
    zh_tc: '訂單名稱',
    ru: 'Название заказа',
    ko: '주문 이름',
    bur: 'အော်ဒါအမည်',
    ben: 'অর্ডারের নাম',
    tr: 'Siparis Adi',
    km: 'ឈ្មោះការបញ្ជាទិញ',
    es: 'Nombre del pedido',
    ar: 'اسم الطلب',
  },
  'taskPage.search.sender': {
    zh: '发送人',
    en: 'Sender',
    id: 'Pengirim',
    kz: 'Жіберуші',
    th: 'ผู้ส่ง',
    ug: 'ئەۋەتكۈچى',
    vi: 'Người gửi',
    zh_tc: '發送人',
    ru: 'Отправитель',
    ko: '보낸 사람',
    bur: 'ပေးပို့သူ',
    ben: 'প্রেরক',
    tr: 'Gonderen',
    km: 'អ្នកផ្ញើ',
    es: 'Remitente',
    ar: 'المرسل',
  },
  'taskPage.importTask': {
    zh: '导入任务',
    en: 'Import Task',
    id: 'Impor Tugas',
    kz: 'Тапсырыс імпорту',
    th: 'งานนำเข้า',
    ug: 'ۋەزىپە ئەكىرىش',
    vi: 'Nhập nhiệm vụ',
    zh_tc: '導入任務',
    ru: 'Импорт задач',
    ko: '작업 가져오기',
    bur: 'တာဝန်တင်သွင်းပါ',
    ben: 'টাস্ক আমদানি করুন',
    tr: 'Gorevi Ice Aktar',
    km: 'នាំចូលភារកិច្ច',
    es: 'Tarea de importación',
    ar: 'مهمة الاستيراد',
  },
  'taskPage.refuseTask': {
    zh: '拒绝任务',
    en: 'Refuse task',
    id: 'Tolak tugas',
    kz: 'Тапсырысті қабылдамау',
    th: 'ปฏิเสธงาน',
    ug: 'ۋەزىپىنى رەت قىلىش',
    vi: 'Từ chối nhiệm vụ',
    zh_tc: '拒絕任務',
    ru: 'Отказ от задания',
    ko: '작업 거부',
    bur: 'တာဝန်ငြင်းဆိုပါ',
    ben: 'টাস্ক প্রত্যাখ্যান করুন',
    tr: 'Gorevi Reddet',
    km: 'បដិសេធភារកិច្ច',
    es: 'Tarea de rechazo',
    ar: 'رفض المهمة',
  },
  'taskPage.refreshList': {
    zh: '刷新列表',
    en: 'Refresh list',
    id: 'Segarkan daftar',
    kz: 'Тізімді жаңарту',
    th: 'รีเฟรชรายการ',
    ug: 'تىزىملىكنى يېڭىلاش',
    vi: 'Tân trang danh sách',
    zh_tc: '刷新列表',
    ru: 'Обновить список',
    ko: '목록 새로 고침',
    bur: 'စာရင်းပြောင်းသစ်ပါ',
    ben: 'তালিকা রিফ্রেশ করুন',
    tr: 'Listeyi Yenile',
    km: 'ផ្ទុកបញ្ជីឡើងវិញ',
    es: 'Actualizar lista',
    ar: 'تحديث القائمة',
  },
  'taskPage.refuseRecord': {
    zh: '拒绝记录',
    en: 'Refusal Record',
    id: 'Tolak catatan',
    kz: 'Қабылдамай тіркеу',
    th: 'ปฏิเสธบันทึก',
    ug: 'رەت قىلىش خاتىرىسى',
    vi: 'Lịch sử từ chối',
    zh_tc: '拒絕記錄',
    ru: 'Отказ в записи',
    ko: '레코드 거부',
    bur: 'ငြင်းဆိုမှုမှတ်တမ်း',
    ben: 'প্রত্যাখ্যানের রেকর্ড',
    tr: 'Ret Kaydi',
    km: 'កំណត់ត្រាបដិសេធ',
    es: 'Registro de rechazo',
    ar: 'رفض السجل',
  },
  'taskPage.taskCard.sender': {
    zh: '导入的料单',
    en: 'imported material list',
    id: 'Daftar materi yang diimpor',
    kz: 'Імпортталған материалдар тізімі',
    th: 'รายการวัสดุที่นำเข้า',
    ug: 'ئەكىرىلگەن ماتېرىال تىزىملىكى',
    vi: 'Đơn hàng nhập liệu',
    zh_tc: '導入的料單',
    ru: 'Импортированные накладные',
    ko: '가져온 커팅 리스트',
    bur: 'တင်သွင်းထားသောပစ္စည်းစာရင်း',
    ben: 'আমদানি করা উপকরণ তালিকা',
    tr: 'Ice Aktarilan Malzeme Listesi',
    km: 'បញ្ជីសម្ភារៈដែលបាននាំចូល',
    es: 'Lista de materiales importada',
    ar: 'قائمة المواد المستوردة',
  },
  'taskPage.taskCard.delivery': {
    zh: '交期',
    en: 'Delivery date',
    id: 'Tanggal pengiriman',
    kz: 'Келісімдеуіші мерзім',
    th: 'วันที่จัดส่ง',
    ug: 'يەتكۈزۈش ۋاقتى',
    vi: 'Ngày giao hàng',
    zh_tc: '交期',
    ru: 'срок поставки',
    ko: '납기',
    bur: 'ပို့ဆောင်ရမည့်ရက်',
    ben: 'ডেলিভারি তারিখ',
    tr: 'Teslim Tarihi',
    km: 'កាលបរិច្ឆេទដឹកជញ្ជូន',
    es: 'Fecha de entrega',
    ar: 'تاريخ التسليم',
  },
  'taskPage.taskCard.delete': {
    zh: '删除',
    en: 'Delete',
    id: 'menghapus',
    kz: 'Жою',
    th: 'ลบ',
    ug: 'ئۆچۈرۈش',
    vi: 'Xóa',
    zh_tc: '刪除',
    ru: 'удалить',
    ko: '삭제',
    bur: 'ဖျက်ပါ',
    ben: 'মুছুন',
    tr: 'Sil',
    km: 'លុប',
    es: 'Eliminar',
    ar: 'حذف',
  },
  'taskPage.taskCard.addToBatch': {
    zh: '加入批量',
    en: 'Add to Batch',
    id: 'Tambahkan ke batch',
    kz: 'Серілікке қосу',
    th: 'เพิ่มลงในแบทช์',
    ug: 'جەمئىيگە قوشۇش',
    vi: 'Thêm vào hàng loạt',
    zh_tc: '加入批量',
    ru: 'Добавить партию',
    ko: '대량 추가',
    bur: 'အစုလိုက်ထည့်ပါ',
    ben: 'ব্যাচে যোগ করুন',
    tr: 'Partiye Ekle',
    km: 'បន្ថែមទៅជាក្រុម',
    es: 'Agregar al lote',
    ar: 'إضافة إلى الدفعة',
  },
  'taskPage.taskCard.save': {
    zh: '存档',
    en: 'Save',
    id: 'Arsip',
    kz: 'Архивдеу',
    th: 'คลังเก็บเอกสารสำคัญ',
    ug: 'ساقلاش',
    vi: 'Lưu trữ',
    zh_tc: '存檔',
    ru: 'архив',
    ko: '아카이빙',
    bur: 'သိမ်းဆည်းပါ',
    ben: 'সংরক্ষণ করুন',
    tr: 'Arsivle',
    km: 'រក្សាទុកក្នុងបណ្ណសារ',
    es: 'Archivo',
    ar: 'الأرشيف',
  },
  'taskPage.taskCard.arrange': {
    zh: '直接排版',
    en: 'Directly arrange',
    id: 'Tata letak langsung',
    kz: 'Тікелей орнату',
    th: 'เค้าโครงโดยตรง',
    ug: 'بىۋاستە تەرتىپلەش',
    vi: 'Điều hình trực tiếp',
    zh_tc: '直接排版',
    ru: 'Прямая типография',
    ko: '직접 조판',
    bur: 'တိုက်ရိုက်ပြင်ဆင်ပါ',
    ben: 'সরাসরি লেআউট করুন',
    tr: 'Dogrudan Diz',
    km: 'រៀបប្លង់ដោយផ្ទាល់',
    es: 'Composición tipográfica directa',
    ar: 'التنضيد المباشر',
  },
  'taskPage.taskCard.deleteTitle': {
    zh: '删除任务',
    en: 'Delete Task',
    id: 'Hapus tugas',
    kz: 'Тапсырысты жою',
    th: 'ลบงาน',
    ug: 'ۋەزىپىنى ئۆچۈرۈش',
    vi: 'Xóa nhiệm vụ',
    zh_tc: '刪除任務',
    ru: 'Удалить задачу',
    ko: '작업 삭제',
    bur: 'တာဝန်ဖျက်ပါ',
    ben: 'টাস্ক মুছুন',
    tr: 'Gorevi Sil',
    km: 'លុបភារកិច្ច',
    es: 'Eliminar tarea',
    ar: 'حذف المهمة',
  },
  'taskPage.taskCard.checkDetail': {
    zh: '点击查看详情',
    en: 'Click to view details',
    id: 'Klik untuk melihat detailnya',
    kz: 'Егжейінің ақпараттарын қарау үшін басыңыз',
    th: 'คลิกเพื่อดูรายละเอียด',
    ug: 'تەپسىلاتىنى كۆرۈش ئۈچۈن چېكىڭ',
    vi: 'Nhấn để xem chi tiết',
    zh_tc: '點擊查看詳情',
    ru: 'Нажмите для просмотра деталей',
    ko: '자세한 내용을 보려면 클릭하십시오.',
    bur: 'အသေးစိတ်ကြည့်ရန်နှိပ်ပါ',
    ben: 'বিস্তারিত দেখতে ক্লিক করুন',
    tr: 'Ayrintilari Gormek Icin Tiklayin',
    km: 'ចុចដើម្បីមើលព័ត៌មានលម្អិត',
    es: 'Haga clic para ver detalles',
    ar: 'انقر لعرض التفاصيل',
  },
  'taskPage.taskCard.refuse': {
    zh: '拒绝',
    en: 'Refuse',
    id: 'menolak',
    kz: 'Қабылдамай',
    th: 'ปฏิเสธ',
    ug: 'رەت قىلىش',
    vi: 'Từ chối',
    zh_tc: '拒絕',
    ru: 'отказ',
    ko: '거절',
    bur: 'ငြင်းဆိုပါ',
    ben: 'প্রত্যাখ্যান করুন',
    tr: 'Reddet',
    km: 'បដិសេធ',
    es: 'Rechazar',
    ar: 'رفض',
  },
  'taskPage.taskCard.refuseTime': {
    zh: '拒绝时间',
    en: 'Refusal Time',
    id: 'Tolak waktu',
    kz: 'Қабылдамай уақыты',
    th: 'ปฏิเสธเวลา',
    ug: 'رەت قىلىش ۋاقتى',
    vi: 'Thời gian từ chối',
    zh_tc: '拒絕時間',
    ru: 'Время отказа',
    ko: '거부 시간',
    bur: 'ငြင်းဆိုသည့်အချိန်',
    ben: 'প্রত্যাখ্যানের সময়',
    tr: 'Ret Zamani',
    km: 'ពេលវេលាបដិសេធ',
    es: 'Hora de rechazo',
    ar: 'وقت الرفض',
  },
  'taskPage.taskCard.refuseReason': {
    zh: '拒绝原因',
    en: 'Reason for Refusal',
    id: 'Alasan penolakan',
    kz: 'Қабылдамай себебі',
    th: 'เหตุผลในการปฏิเสธ',
    ug: 'رەت قىلىش سەۋەبى',
    vi: 'Lý do từ chối',
    zh_tc: '拒絕原因',
    ru: 'Причины отказа',
    ko: '거부 이유',
    bur: 'ငြင်းဆိုသည့်အကြောင်း',
    ben: 'প্রত্যাখ্যানের কারণ',
    tr: 'Ret Nedeni',
    km: 'ហេតុផលបដិសេធ',
    es: 'Motivo de rechazo',
    ar: 'سبب الرفض',
  },
  'taskPage.taskCard.refuseTask': {
    zh: '拒收任务',
    en: 'Refuse Task',
    id: 'Tolak tugas',
    kz: 'Тапсырысты қабылдау',
    th: 'ปฏิเสธงาน',
    ug: 'ۋەزىپىنى رەت قىلىش',
    vi: 'Từ chối nhận nhiệm vụ',
    zh_tc: '拒收任務',
    ru: 'Отказ от задания',
    ko: '거부 임무',
    bur: 'တာဝန်ငြင်းဆိုပါ',
    ben: 'টাস্ক গ্রহণ করতে অস্বীকার',
    tr: 'Gorevi Reddet',
    km: 'បដិសេធទទួលភារកិច្ច',
    es: 'Rechazar tarea',
    ar: 'رفض المهمة',
  },
  'taskPage.taskCard.refuseTaskPlaceholder': {
    zh: '请输入拒收原因',
    en: 'Please enter the reason for refusal',
    id: 'Harap masukkan alasan penolakan',
    kz: 'Қабылдау себебін енгізіңіз',
    th: 'โปรดป้อนเหตุผลในการปฏิเสธ',
    ug: 'رەت قىلىش سەۋەبىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập lý do từ chối',
    zh_tc: '請輸入拒收原因',
    ru: 'Пожалуйста, укажите причину отказа.',
    ko: '거부 이유를 입력하십시오.',
    bur: 'ငြင်းဆိုသည့်အကြောင်းထည့်ပါ',
    ben: 'প্রত্যাখ্যানের কারণ লিখুন',
    tr: 'Lutfen ret nedenini girin',
    km: 'សូមបញ្ចូលហេតុផលបដិសេធ',
    es: 'Ingrese el motivo del rechazo',
    ar: 'يرجى إدخال سبب الرفض',
  },
  'taskPage.taskCard.addErr': {
    zh: '添加失败,请稍后重试!',
    en: 'Failed to add, please try again later!',
    id: 'Menambahkan gagal, coba lagi nanti!',
    kz: 'Қосу сәтсіз, кейінірек қайталап көріңіз!',
    th: 'การเพิ่มล้มเหลวโปรดลองอีกครั้งในภายหลัง!',
    ug: 'قوشۇش مەغلۇپ بولدى، كېيىن قايتا سىناڭ!',
    vi: 'Thêm thất bại, vui lòng thử lại sau!',
    zh_tc: '添加失敗,請稍後重試!',
    ru: 'Добавить неудачу, попробуйте позже!',
    ko: '추가에 실패했습니다. 나중에 다시 시도하십시오!',
    bur: 'ထည့်သွင်းမှုမအောင်မြင်ပါ၊ နောက်မှပြန်ကြိုးစားပါ!',
    ben: 'যোগ করতে ব্যর্থ হয়েছে, পরে আবার চেষ্টা করুন!',
    tr: 'Ekleme basarisiz oldu, lutfen daha sonra tekrar deneyin!',
    km: 'បន្ថែមបរាជ័យ សូមព្យាយាមម្តងទៀតពេលក្រោយ!',
    es: 'Error al agregar, ¡inténtelo nuevamente más tarde!',
    ar: 'فشلت الإضافة، يرجى المحاولة مرة أخرى لاحقًا!',
  },
  'taskPage.batchNo': {
    zh: '批次号',
    en: 'batch number',
    id: 'Nomor batch',
    kz: 'Серілік нөмірі',
    th: 'หมายเลขแบทช์',
    ug: 'پارتىيە نومۇرى',
    vi: 'Số lô',
    zh_tc: '批次號',
    ru: 'номер партии',
    ko: '로트 번호',
    bur: ' အစုနံပါတ်',
    ben: 'ব্যাচ নম্বর',
    tr: 'Parti Numarasi',
    km: 'លេខបាច់',
    es: 'Número de lote',
    ar: 'رقم الدُفعة',
  },
  'taskPage.batchArrange': {
    zh: '批量排版',
    en: 'Batch layout',
    id: 'Tata letak batch',
    kz: 'Серілік орнату',
    th: 'เค้าโครงแบทช์',
    ug: 'جەمئىي تەرتىپلەش',
    vi: 'Điều hình hàng loạt',
    zh_tc: '批量排版',
    ru: 'Массовая типография',
    ko: '대량 조판',
    bur: 'အစုလိုက်ပြင်ဆင်မှု',
    ben: 'ব্যাচ লেআউট',
    tr: 'Toplu Dizgi',
    km: 'ប្លង់ជាក្រុម',
    es: 'Diseño de lote',
    ar: 'تخطيط الدُفعة',
  },
  'taskPage.clearBatch': {
    zh: '清空队列',
    en: 'Clear the queue',
    id: 'Hapus antriannya',
    kz: 'Кезектесті босатау',
    th: 'ล้างคิว',
    ug: 'قۇرۇلمىنى تازىلاش',
    vi: 'Xóa hàng loạt',
    zh_tc: '清空隊列',
    ru: 'Очистить очередь',
    ko: '대기열 비우기',
    bur: 'တန်းစီဆေးကြောပါ',
    ben: 'কিউ পরিষ্কার করুন',
    tr: 'Kuyrugu Temizle',
    km: 'សម្អាតជួរ',
    es: 'Borrar cola',
    ar: 'مسح قائمة الانتظار',
  },
  'taskPage.taskCount': {
    zh: '当前任务数量:',
    en: 'Current task count:',
    id: 'Jumlah tugas saat ini:',
    kz: 'Қазіргі тапсырыстар саны: ',
    th: 'จำนวนงานปัจจุบัน:',
    ug: 'نۆۋەتتىكى ۋەزىپە سانى:',
    vi: 'Số lượng nhiệm vụ hiện tại:',
    zh_tc: '當前任務數量:',
    ru: 'Количество текущих задач:',
    ko: '현재 작업 수:',
    bur: 'လက်ရှိတာဝန်အရေအတွက်:',
    ben: 'বর্তমান টাস্কের সংখ্যা:',
    tr: 'Mevcut Gorev Sayisi:',
    km: 'ចំនួនភារកិច្ចបច្ចុប្បន្ន៖',
    es: 'Número actual de tareas:',
    ar: 'العدد الحالي للمهام:',
  },
  'taskPage.checkAllTask': {
    zh: '查看所有料单',
    en: 'View all material lists',
    id: 'Lihat semua daftar material',
    kz: 'Барлық материалдар тізімін қарау',
    th: 'ดูรายการวัสดุทั้งหมด',
    ug: 'بارلىق ماتېرىال تىزىملىكىنى كۆرۈش',
    vi: 'Xem tất cả đơn hàng',
    zh_tc: '查看所有料單',
    ru: 'Посмотреть все листы',
    ko: '모든 커팅 리스트 보기',
    bur: 'ပစ္စည်းစာရင်းအားလုံးကြည့်ပါ',
    ben: 'সমস্ত উপকরণ তালিকা দেখুন',
    tr: 'Tum Malzeme Listelerini Goster',
    km: 'មើលបញ្ជីសម្ភារៈទាំងអស់',
    es: 'Ver toda la lista de materiales',
    ar: 'عرض جميع قائمة المواد',
  },
  'taskPage.clearSuccess': {
    zh: '清除成功',
    en: 'Clearing succeeded',
    id: 'Berhasil dibersihkan',
    kz: 'Босату табысты',
    th: 'เคลียร์สำเร็จ',
    ug: 'تازىلاش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Xóa thành công',
    zh_tc: '清除成功',
    ru: 'Удалить',
    ko: '지우기 성공',
    bur: 'ဆေးကြောမှုအောင်မြင်သည်',
    ben: 'সাফ করা সফল হয়েছে',
    tr: 'Temizleme Basarili',
    km: 'សម្អាតបានជោគជ័យ',
    es: 'Borrar exitosamente',
    ar: 'المسح بنجاح',
  },
  'taskPage.record.batchNo': {
    zh: '批次',
    en: 'batch',
    id: 'kelompok',
    kz: 'Серілік нөмірі',
    th: 'ชุด',
    ug: 'پارتىيە',
    vi: 'Lô',
    zh_tc: '批次',
    ru: 'Партии',
    ko: '배치',
    bur: 'အစုနံပါတ်',
    ben: 'ব্যাচ',
    tr: 'Parti',
    km: 'បាច់',
    es: 'Lote',
    ar: 'الدُفعة',
  },
  'taskPage.record.saveDate': {
    zh: '保存时间',
    en: 'Save time',
    id: 'Hemat waktu',
    kz: 'Архивдеу мерзімі',
    th: 'ประหยัดเวลา',
    ug: 'ساقلاش ۋاقتى',
    vi: 'Ngày lưu trữ',
    zh_tc: '保存時間',
    ru: 'сохранение времени',
    ko: '저장 시간',
    bur: 'သိမ်းဆည်းသည့်အချိန်',
    ben: 'সংরক্ষণের সময়',
    tr: 'Kaydetme Zamani',
    km: 'ពេលវេលារក្សាទុក',
    es: 'Ahorre tiempo',
    ar: 'توفير الوقت',
  },
  'taskPage.record.materialList': {
    zh: '料单',
    en: 'Material list',
    id: 'Daftar materi',
    kz: 'Материалдар тізімі',
    th: 'รายการวัสดุ',
    ug: 'ماتېرىال تىزىملىكى',
    vi: 'Đơn hàng liệu',
    zh_tc: '料單',
    ru: 'Список материалов',
    ko: '재료 명세서',
    bur: 'ပစ္စည်းစာရင်း',
    ben: 'উপকরণ তালিকা',
    tr: 'Malzeme Listesi',
    km: 'បញ្ជីសម្ភារៈ',
    es: 'Lista de materiales',
    ar: 'قائمة المواد',
  },
  'taskPage.record.arrangedRecord': {
    zh: '排版方案',
    en: 'Nest Scheme',
    id: 'Rencana Pengesahan Penetapan',
    kz: 'Орнату жоспар',
    th: 'แผนการเรียงลำดับ',
    ug: 'تەرتىپلەش پىلانى',
    vi: 'Kế hoạch điều hình',
    zh_tc: '排版方案',
    ru: 'Типограмма',
    ko: '조판 방안',
    bur: 'ပြင်ဆင်မှုစီမံချက်',
    ben: 'লেআউট পরিকল্পনা',
    tr: 'Dizgi Plani',
    km: 'ផែនការប្លង់',
    es: 'Plan de composición tipográfica',
    ar: 'خطة التنضيد',
  },
  'taskPage.record.searchPlaceholder': {
    zh: '请输入批次号',
    en: 'Please enter the batch number',
    id: 'Harap masukkan nomor batch',
    kz: 'Серілік нөмірін енгізу',
    th: 'กรุณากรอกหมายเลขแบทช์',
    ug: 'پارتىيە نومۇرىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập số lô',
    zh_tc: '請輸入批次號',
    ru: 'Введите номер партии.',
    ko: '배치 번호를 입력하십시오.',
    bur: 'အစုနံပါတ်ထည့်ပါ',
    ben: 'ব্যাচ নম্বর লিখুন',
    tr: 'Lutfen parti numarasini girin',
    km: 'សូមបញ្ចូលលេខបាច់',
    es: 'Por favor ingrese el número de lote',
    ar: 'الرجاء إدخال رقم الدفعة',
  },
  'taskPage.record.tipText': {
    zh: '是否删除该条存档?',
    en: 'Delete this archive or not?',
    id: 'Haruskah saya menghapus arsip?',
    kz: 'Бұл архивті жою ма?',
    th: 'ฉันควรลบที่เก็บถาวรหรือไม่?',
    ug: 'بۇ ساقلاشنى ئۆچۈرەمسىز؟',
    vi: 'Bạn có muốn xóa lưu trữ này?',
    zh_tc: '是否刪除該條存檔?',
    ru: 'Удалить ли архив этой статьи?',
    ko: '이 아카이브를 삭제하시겠습니까?',
    bur: 'ဤသိမ်းဆည်းမှုကိုဖျက်မည်လား?',
    ben: 'এই আর্কাইভটি মুছবেন কি?',
    tr: 'Bu arsivi silmek istiyor musunuz?',
    km: 'តើអ្នកចង់លុបបណ្ណសារនេះឬទេ?',
    es: '¿Quiere eliminar este archivo?',
    ar: 'هل تريد حذف هذا الأرشيف؟',
  },
  'taskPage.errTip': {
    zh: '无可加工的任务数据,请前往任务列表添加!',
    en: 'No task data available for processing, please go to the task list to add!',
    id: 'Tidak ada data tugas untuk diproses, silakan buka daftar tugas untuk menambahkannya!',
    kz: 'Құжаттарды өңдеу үшін мүмкіндіктер жоқ, тапсырыс тізіміне өту үшін қосу керек!',
    th: 'ไม่มีข้อมูลงานที่ต้องดำเนินการโปรดไปที่รายการงานเพื่อเพิ่ม!',
    ug: 'ئىشلەپچىقىرىشقا بولىدىغان ۋەزىپە سانلىق مەلۇماتى يوق، ۋەزىپە تىزىملىكىگە قوشۇڭ!',
    vi: 'Không có dữ liệu nhiệm vụ để chế biến, vui lòng đi đến danh sách nhiệm vụ để thêm!',
    zh_tc: '無可加工的任務數據,請前往任務列表添加!',
    ru: 'Необработанные данные миссии, пожалуйста, перейдите к списку задач для добавления!',
    ko: '가공할 수 있는 작업 데이터가 없습니다. 작업 목록으로 가서 추가하십시오!',
    bur: 'လုပ်ဆောင်နိုင်သောတာဝန်ဒေတာမရှိ၊ တာဝန်စာရင်းသွားထည့်ပါ!',
    ben: 'প্রক্রিয়াযোগ্য কোনো টাস্ক ডেটা নেই, টাস্ক তালিকায় যোগ করুন!',
    tr: 'Islenebilir gorev verisi yok, lutfen gorev listesine gidip ekleyin!',
    km: 'មិនមានទិន្នន័យភារកិច្ចដែលអាចដំណើរការបានទេ សូមទៅកាន់បញ្ជីភារកិច្ចដើម្បីបន្ថែម!',
    es: 'No hay datos de tareas para procesar, ¡vaya a la lista de tareas para agregarlos!',
    ar: 'لا توجد بيانات مهمة للمعالجة، يرجى الانتقال إلى قائمة المهام لإضافتها!',
  },
  'taskPage.emptyErr': {
    zh: '该任务订单没有板件数据，无法进行排版生产！',
    en: 'The task order has no plank data, unable to proceed with layout production!',
    id: 'Pesanan tugas ini tidak memiliki data papan dan tidak dapat diketik dan diproduksi!',
    kz: 'Тапсырыс төлемінде тақталардың мәліметтері жоқ, жасау бағдарламасына жалдау көрсетілмейді!',
    th: 'ใบสั่งงานนี้ไม่มีข้อมูลบอร์ดและไม่สามารถพิมพ์และผลิตได้!',
    ug: 'بۇ ۋەزىپىدە تاختا سانلىق مەلۇماتى يوق، تەرتىپلەپ ئىشلەپچىقىرىشقا بولمايدۇ!',
    vi: 'Đơn hàng này không có dữ liệu tấm gỗ, không thể tiến hành điều hình sản xuất!',
    zh_tc: '該任務訂單沒有板件數據，無法進行排版生產！',
    ru: 'Заказ миссии не имеет данных о доске, не может быть типографским производством!',
    ko: '이 작업 주문은 보드 데이터가 없어서 조판 생산을 진행할 수 없습니다!',
    bur: 'ဤတာဝန်အော်ဒါတွင်ပေါ်ဒ်ဒေတာမရှိ၊ ပြင်ဆင်မှုထုတ်လုပ်မှုမလုပ်နိုင်!',
    ben: 'এই টাস্ক অর্ডারে কোনো বোর্ড ডেটা নেই, লেআউট উৎপাদন চালিয়ে যেতে পারছে না!',
    tr: 'Bu gorev siparisinde panel verisi yok, dizgi uretimi yapilamaz!',
    km: 'ការបញ្ជាទិញភារកិច្ចនេះមិនមានទិន្នន័យបន្ទះទេ មិនអាចធ្វើប្លង់ផលិតកម្មបានទេ!',
    es: '¡Esta orden de tarea no tiene datos de panel y no se puede escribir ni producir!',
    ar: 'لا يحتوي أمر المهمة هذا على بيانات لوحة ولا يمكن كتابته وإنتاجه!',
  },
  'taskPage.operationSuccess': {
    zh: '操作成功',
    en: 'Operation successful',
    id: 'Operasi berhasil',
    kz: 'Орындалу сәтті',
    th: 'การดำเนินการสำเร็จ',
    ug: 'مەشغۇلات مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Thao tác thành công',
    zh_tc: '操作成功',
    ru: 'Операция успешна',
    ko: '작업 성공',
    bur: 'လုပ်ဆောင်မှုအောင်မြင်သည်',
    ben: 'অপারেশন সফল হয়েছে',
    tr: 'Islem Basarili',
    km: 'ប្រតិបត្តិការជោគជ័យ',
    es: 'Operación exitosa',
    ar: 'تمت العملية بنجاح',
  },
  'taskPage.operationFail': {
    zh: '操作失败,请稍后重试!',
    en: 'Operation failed, please try again later!',
    id: 'Operasi gagal, coba lagi nanti!',
    kz: 'Орындалу сәтсіз, кейінірек қайталап көріңіз!',
    th: 'การดำเนินการล้มเหลวโปรดลองอีกครั้งในภายหลัง!',
    ug: 'مەشغۇلات مەغلۇپ بولدى، كېيىن قايتا سىناڭ!',
    vi: 'Thao tác thất bại, vui lòng thử lại sau!',
    zh_tc: '操作失敗,請稍後重試!',
    ru: 'Операция не удалась, попробуйте позже!',
    ko: '작업이 실패했습니다. 나중에 다시 시도하십시오.',
    bur: 'လုပ်ဆောင်မှုမအောင်မြင်ပါ၊ နောက်မှပြန်ကြိုးစားပါ!',
    ben: 'অপারেশন ব্যর্থ হয়েছে, পরে আবার চেষ্টা করুন!',
    tr: 'Islem Basarisiz oldu, lutfen daha sonra tekrar deneyin!',
    km: 'ប្រតិបត្តិការបរាជ័យ សូមព្យាយាមម្តងទៀតពេលក្រោយ!',
    es: 'Operación fallida, ¡inténtelo nuevamente más tarde!',
    ar: 'فشلت العملية، يرجى المحاولة مرة أخرى لاحقًا!',
  },
  'taskPage.saveSuccess': {
    zh: '存档成功',
    en: 'Save successful',
    id: 'Arsip berhasil',
    kz: 'Сақтау сәтті',
    th: 'เก็บถาวรให้สำเร็จ',
    ug: 'ساقلاش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Lưu trữ thành công',
    zh_tc: '存檔成功',
    ru: 'Архив успешно',
    ko: '아카이브 성공',
    bur: 'သိမ်းဆည်းမှုအောင်မြင်သည်',
    ben: 'সংরক্ষণ সফল হয়েছে',
    tr: 'Arsivleme Basarili',
    km: 'រក្សាទុកក្នុងបណ្ណសារបានជោគជ័យ',
    es: 'Archivado exitoso',
    ar: 'تم الأرشفة بنجاح',
  },
  'taskPage.plankMaxLimit': {
    zh: '小板数量超过最大排版上限',
    en: 'The number of small planks exceeds the maximum layout limit',
    id: 'Jumlah papan kecil melebihi batas tata letak maksimum',
    kz: 'Кіші тақталардың саны ең көп бағдарлама шектесінен асып кетті',
    th: 'จำนวนบอร์ดขนาดเล็กเกินขีด จำกัด เค้าโครงสูงสุด',
    ug: 'كىچىك تاختا سانى ئەڭ يۇقىرى تەرتىپلەش چېكىدىن ئاشتى',
    vi: 'Số lượng tấm gỗ nhỏ vượt quá giới hạn tối đa điều hình',
    zh_tc: '小板數量超過最大排版上限',
    ru: 'Количество листов превышает максимальный лимит',
    ko: '널빤지 수량이 최대 조판 상한선을 초과하다',
    bur: 'ပေါ်ဒ်ငယ်အရေအတွက် အများဆုံးပြင်ဆင်မှုကန့်သတ်ချက်ကျော်လွန်သည်',
    ben: 'ছোট বোর্ডের সংখ্যা সর্বোচ্চ লেআউট সীমা অতিক্রম করেছে',
    tr: 'Kucuk panel sayisi maksimum dizgi limitini asti',
    km: 'ចំនួនបន្ទះតូចលើសកម្រិតប្លង់អតិបរមា',
    es: 'El número de tableros pequeños excede el límite máximo de composición tipográfica',
    ar: 'عدد اللوحات الصغيرة يتجاوز الحد الأقصى للتنضيد',
  },
  'taskPage.batchWorning': {
    zh: '请分批次进行生产',
    en: 'Please produce in batches',
    id: 'Silakan lakukan produksi dalam batch',
    kz: 'Бағдарламаны бөлек өндіру керек',
    th: 'กรุณาทำการผลิตเป็นแบทช์',
    ug: 'پارتىيە بويىچە ئىشلەپچىقىرىشنى تەشەببۇس قىلىڭ',
    vi: 'Vui lòng sản xuất theo lô',
    zh_tc: '請分批次進行生產',
    ru: 'Пожалуйста, сделайте это партиями.',
    ko: '차수로 나누어 생산해 주십시오',
    bur: 'ကျေးဇူးပြု၍ အစုအဖွဲ့ဖြင့်ထုတ်လုပ်ပါ',
    ben: 'অনুগ্রহ করে ব্যাচে উৎপাদন করুন',
    tr: 'Lutfen partiler halinde uretim yapin',
    km: 'សូមផលិតជាបាច់ៗ',
    es: 'Produzca en lotes',
    ar: 'يرجى الإنتاج على دفعات',
  },
  'taskPage.batchEmptyErr': {
    zh: '订单列表没有板件数据，无法进行批量生产！',
    en: 'No plank data in the order list, unable to proceed with batch production!',
    id: 'Daftar pesanan tidak memiliki data papan dan tidak dapat diproduksi secara massal!',
    kz: 'Тапсырыс тізімінде тақталар мәліметтері жоқ, бөлек өндіруді жалдау мүмкін емес!',
    th: 'รายการคำสั่งซื้อไม่มีข้อมูลบอร์ดและไม่สามารถผลิตได้จำนวนมาก!',
    ug: 'زاكاز تىزىملىكىدە تاختا سانلىق مەلۇماتى يوق، جەمئىي ئىشلەپچىقىرىشقا بولمايدۇ!',
    vi: 'Danh sách đơn hàng không có dữ liệu tấm gỗ, không thể tiến hành sản xuất hàng loạt!',
    zh_tc: '訂單列表沒有板件數據，無法進行批量生產！',
    ru: 'Список заказов не имеет данных о досках, не может быть массового производства!',
    ko: '주문 목록에 보드 데이터가 없어 대량 생산이 불가능합니다!',
    bur: 'အော်ဒါစာရင်းတွင်ပေါ်ဒ်ဒေတာမရှိ၊ အစုလိုက်ထုတ်လုပ်မှုမလုပ်နိုင်!',
    ben: 'অর্ডার তালিকায় কোনো বোর্ড ডেটা নেই, ব্যাচ উৎপাদন চালিয়ে যাওয়া যাচ্ছে না!',
    tr: 'Siparis listesinde panel verisi yok, toplu uretim yapilamaz!',
    km: 'បញ្ជីការបញ្ជាទិញមិនមានទិន្នន័យបន្ទះទេ មិនអាចធ្វើផលិតកម្មជាក្រុមបានទេ!',
    es: 'La lista de pedidos no tiene datos de tableros y no se puede realizar la producción en masa.',
    ar: 'لا تحتوي قائمة الطلبات على بيانات اللوحة، ولا يمكن تنفيذ الإنتاج الضخم!',
  },
  'taskPage.noRoomTip': {
    zh: '不存在房间，无法进行批量生产！',
    en: 'No rooms exist, unable to proceed with batch production!',
    id: 'Tidak ada ruang dan tidak bisa diproduksi secara massal!',
    kz: 'Оданыштар жоқ, бөлекше өндіруге мүмкін емес!',
    th: 'ไม่มีที่ว่างและไม่สามารถผลิตได้มากมาย!',
    ug: 'ئۆي مەۋجۇت ئەمەس، جەمئىي ئىشلەپچىقىرىشقا بولمايدۇ!',
    vi: 'Không có phòng để tiến hành sản xuất hàng loạt!',
    zh_tc: '不存在房間，無法進行批量生產！',
    ru: 'Нет комнаты, не может быть массового производства!',
    ko: '방이 존재하지 않아 대량 생산을 진행할 수 없습니다!',
    bur: 'အခန်းမရှိ၊ အစုလိုက်ထုတ်လုပ်မှုမလုပ်နိုင်!',
    ben: 'কোনো রুম নেই, ব্যাচ উৎপাদন চালিয়ে যাওয়া যাচ্ছে না!',
    tr: 'Oda bulunmuyor, toplu uretim yapilamaz!',
    km: 'មិនមានបន្ទប់ទេ មិនអាចធ្វើផលិតកម្មជាក្រុមបានទេ!',
    es: '¡Sin una habitación, la producción en masa es imposible!',
    ar: 'الإنتاج الضخم مستحيل بدون غرفة!',
  },
  'taskPage.refuseHistory': {
    zh: '拒绝历史',
    en: 'Refuse history',
    id: 'Menolak sejarah',
    kz: 'Қабылдау тарихы',
    th: 'ปฏิเสธประวัติ',
    ug: 'رەت قىلىش تارىخى',
    vi: 'Lịch sử từ chối',
    zh_tc: '拒絕歷史',
    ru: 'Отказ от истории',
    ko: '거부 기록',
    bur: 'ငြင်းဆိုမှုမှတ်တမ်း',
    ben: 'প্রত্যাখ্যানের ইতিহাস',
    tr: 'Ret Gecmisi',
    km: 'ប្រវត្តិបដិសេធ',
    es: 'Historial de rechazos',
    ar: 'سجل الرفض',
  },
  'materialPage.specialProcess': {
    zh: '特殊工艺',
    en: 'Special Process',
    id: 'Proses Khususс',
    kz: 'Арнайы процесс',
    th: 'กระบวนการพิเศษ',
    ug: 'ئالاھىدە جەريان',
    vi: 'Quy trình đặc biệt',
    zh_tc: '特殊工藝',
    ru: 'Специальные технологии',
    ko: '특수 공예',
    bur: 'အထူးလုပ်ငန်းစဉ်',
    ben: 'বিশেষ প্রক্রিয়া',
    tr: 'Ozel Islem',
    km: 'ដំណើរការពិសេស',
    es: 'Proceso especial',
    ar: 'عملية خاصة',
  },
  'materialPage.distanceFromTop': {
    zh: '距上',
    en: 'Distance from top',
    id: 'Jarak dari atas',
    kz: 'Жоғарғы шекарадан қашықтық',
    th: 'ระยะห่างจากบน',
    ug: 'يۇقىرىدىن ئارىلىق',
    vi: 'Khoảng cách từ trên xuống',
    zh_tc: '距上',
    ru: 'На расстоянии',
    ko: '거리 위',
    bur: 'အပေါ်မှ အကွာ',
    ben: 'উপর থেকে দূরত্ব',
    tr: 'Ustten Mesafe',
    km: 'ចម្ងាយពីខាងលើ',
    es: 'Desde arriba',
    ar: 'من الأعلى',
  },
  'materialPage.distanceFromRight': {
    zh: '距右',
    en: 'Distance from right',
    id: 'Jarak dari kanan',
    kz: 'Оң жақ шекарадан қашықтық',
    th: 'ระยะห่างจากขวา',
    ug: 'ئوڭدىن ئارىلىق',
    vi: 'Khoảng cách từ phải sang',
    zh_tc: '距右',
    ru: 'Расстояние вправо',
    ko: '오른쪽',
    bur: 'ညာမှ အကွာ',
    ben: 'ডান থেকে দূরত্ব',
    tr: 'Sagdan Mesafe',
    km: 'ចម្ងាយពីខាងស្តាំ',
    es: 'Desde la derecha',
    ar: 'من اليمين',
  },
  'materialPage.hingeData': {
    zh: '铰链数据',
    en: 'Hinge Data',
    id: 'Data sambungan',
    kz: 'Шарнир деректері',
    th: 'ข้อมูลของขอบประตู',
    ug: 'ئىلمەك سانلىق مەلۇماتى',
    vi: 'Dữ liệu bản lề',
    zh_tc: '鉸鏈數據',
    ru: 'Данные петли',
    ko: '힌지 데이터',
    bur: 'ဟင်းချဉ်ဒေတာ',
    ben: 'কব্জার ডেটা',
    tr: 'Mentese Verisi',
    km: 'ទិន្នន័យហ៊ីង',
    es: 'Datos de bisagra',
    ar: 'بيانات المفصلة',
  },
  'materialPage.labelBackProcTip': {
    zh: '本次更新已对大板反面贴标方式进行优化，现在按照标签上的信息直接封边，打孔拉槽即可，望您知晓!',
    en: 'This update has optimized the labeling method on the back of the large board. Now, you can directly seal the edges and punch slots according to the information on the label. Please be informed!',
    id: 'Pembaruan ini telah mengoptimalkan metode pengaitan pada bagian belakang papan besar. Sekarang, Anda dapat langsung menutup sisi dan membuat lubang sesuai dengan informasi pada label. Silakan informasikan!',
    kz: 'Бұл апдейлама большай панелнің артындағы белгілік методын оптималдаştırdı. Энди, белгінін ізе бойынша тегіп, дырластап және патықластап көрсеткен боласыз. Білесіз деп тұлаганмын!',
    th: 'การอัปเดตนี้ได้ปรับปรุงวิธีการติดป้ายบนด้านหลังของแผ่นกระดานขนาดใหญ่ ตอนนี้คุณสามารถปิดขอบและตัดร่องตามข้อมูลบนป้ายได้โปรดทราบ!',
    ug: 'بۇ يېڭىلاشتا چوڭ تاختىنىڭ ئارقا تەرىپىدىكى بېلگە ئۇسۇلى ئەڭ ياخشىلانغان، ھازىر بېلگىدىكى ئۇچۇر بويىچە چىگارلاش، تېشىك ئېچىش ۋە ئوچۇق ئېچىش كېرەك!',
    vi: 'Bản cập nhật này đã tối ưu hóa phương pháp dán nhãn mặt sau của tấm lớn. Bây giờ, bạn có thể chỉ cần dán mép và đục lỗ theo thông tin trên nhãn. Xin vui lòng biết!',
    zh_tc:
      '本次更新已對大板反面貼標方式進行優化，現在按照標籤上的信息直接封邊，打孔拉槽即可，望您知曉!',
    ru: 'Это обновление оптимизировало обратный способ маркировки большой доски, теперь в соответствии с информацией на этикетке непосредственно запечатать край, перфорировать канавку можно, надеюсь, вы знаете!',
    ko: '이번 업데이트는 이미 대판 뒷면 부착 방식을 최적화하였습니다. 현재 라벨의 정보에 따라 직접 테두리를 봉하고 구멍을 뚫어 슬롯을 당기면 됩니다. 당신이 알기를 바랍니다!',
    bur: 'ဤနောက်ဆုံးအပ်ဒိတ်တွင် ပေါ်ဒ်ကြီးအကျောတံဆိပ်ကပ်နည်းကိုကောင်းမွန်အောင်ပြုလုပ်ထားသည်',
    ben: 'এই আপডেটে বড় বোর্ডের পিছনে লেবেল করার পদ্ধতি অপ্টিমাইজ করা হয়েছে, এখন লেবেলের তথ্য অনুযায়ী সরাসরি এজ সিল করুন',
    tr: 'Bu guncellemede buyuk panelin arka yuz etiketleme yontemi optimize edildi. Artik etiket bilgisini izleyerek dogrudan kenar bantlama, delik acma ve kanal cekme yapabilirsiniz. Bilginize!',
    km: 'ការអាប់ដេតនេះបានបង្កើនប្រសិទ្ធភាពវិធីបិទស្លាកនៅផ្នែកខាងក្រោយនៃបន្ទះធំ។ ឥឡូវនេះ អ្នកអាចបិទគែម ខួងរន្ធ និងបើកស្លុតដោយផ្ទាល់តាមព័ត៌មានលើស្លាកបាន សូមជ្រាប!',
    es: 'Esta actualización ha optimizado el método de etiquetado en la parte posterior del tablero grande. Ahora siga la información de la etiqueta para sellar directamente el borde y perforar agujeros y tirar de las ranuras. ¡Espero que lo sepas!',
    ar: 'قام هذا التحديث بتحسين طريقة وضع العلامات على الجزء الخلفي من اللوحة الكبيرة. اتبع الآن المعلومات الموجودة على الملصق لإغلاق الحافة مباشرة وثقب الثقوب وسحب الأخاديد. أتمنى أن تعرف!',
  },
  'materialPage.openDir': {
    zh: '开门方向',
    en: 'Opening direction',
    id: 'Arah pembukaan pintu',
    kz: 'Есіктің ашылу бағыты',
    th: 'ทิศทางการเปิดประตู',
    ug: 'ئېچىش يۆنىلىشى',
    vi: 'Hướng mở cửa',
    zh_tc: '開門方向',
    ru: 'Направление открытия.',
    ko: '문 여는 방향',
    bur: 'တံခါးဖွင့်ဘက်',
    ben: 'দরজা খোলার দিক',
    tr: 'Acilis Yonu',
    km: 'ទិសបើកទ្វារ',
    es: 'Dirección de apertura de la puerta',
    ar: 'اتجاه فتح الباب',
  },
  'materialPage.edgeEmptyTip': {
    zh: '修边值不能为空',
    en: 'Trim value cannot be empty',
    id: 'Nilai batas tidak bisa kosong',
    kz: 'Қию мәні бос болмауы керек',
    th: 'ค่าขอบเขตไม่สามารถว่างเปล่า',
    ug: 'چىگارلاش قىممىتى بوش قالمايدۇ',
    vi: 'Giá trị cạnh không thể bỏ trống',
    zh_tc: '修邊值不能為空',
    ru: 'Ремонт не может быть пустым',
    ko: '모서리 수정 값은 비워둘 수 없습니다.',
    bur: 'ဘေးဖြတ်တန်ဖိုးဗလာမဖြစ်ရ',
    ben: 'ট্রিমিং মান খালি রাখা যাবে না',
    tr: 'Kenar payi bos olamaz',
    km: 'តម្លៃកាត់ជ្រុងមិនអាចទទេបានទេ',
    es: 'El valor de recorte no puede estar vacío',
    ar: 'لا يمكن أن تكون قيمة التشذيب فارغة',
  },
  'materialPage.edgeNumberLimit': {
    zh: '修边值只能输入数字',
    en: 'Trim value can only be a number',
    id: 'Hanya angka yang dapat dimasukkan dalam nilai finishing',
    kz: 'Қию мәні тек сан болуы керек',
    th: 'สามารถป้อนตัวเลขได้เฉพาะในค่าการตกแต่ง',
    ug: 'چىگارلاش قىممىتىگە پەقەت رەقەم كىرگۈزۈشكە بولىدۇ',
    vi: 'Giá trị cạnh chỉ có thể là số',
    zh_tc: '修邊值只能輸入數字',
    ru: 'Значение кромки можно вводить только в цифры.',
    ko: '모서리 수정 값은 숫자만 입력할 수 있습니다.',
    bur: 'ဘေးဖြတ်တန်ဖိုးတွင် ကိန်းဂဏန်းသာ ထည့်နိုင်သည်',
    ben: 'ট্রিমিং মান শুধুমাত্র সংখ্যা হতে পারে',
    tr: 'Kenar payina sadece sayi girilebilir',
    km: 'តម្លៃកាត់ជ្រុងអាចបញ្ចូលបានតែជាលេខប៉ុណ្ណោះ',
    es: 'El valor de recorte solo se puede ingresar como números',
    ar: 'يمكن إدخال قيمة التشذيب كأرقام فقط',
  },
  'materialPage.chooseSurplusQuantity': {
    zh: '可用余料共 {total} 种，已选 {quantity} 种',
    en: 'There are {total} types of available surplus materials, {quantity} types selected',
    id: 'Ada {total} jenis bahan residu yang tersedia, dan {kuantitas} tipe telah dipilih',
    kz: 'Қол жетімді артық материалдардың {total} түрі бар, {quantity} түрі таңдалды',
    th: 'มีวัสดุตกค้าง {ทั้งหมด} ประเภทและประเภท {ปริมาณ} ได้รับการเลือก',
    ug: 'ئىشلىتىشكە بولىدىغان قېلىنما {total} خىل، تاللانغان {quantity} خىل',
    vi: 'Có tổng cộng {total} loại vật liệu dư có sẵn, đã chọn {quantity} loại',
    zh_tc: '可用餘料共 {total} 種，已選 {quantity} 種',
    ru: 'Доступно {total} типов остаточных материалов, выбрано {quantity} типов',
    ko: '사용 가능한 잔여 자재 {total} 종류, {quantity} 종류 선택',
    bur: 'အသုံးပြုနိုင်သောပိုလျှံပစ္စည်း {total} မျိုး ရှိသည်၊ {quantity} မျိုးရွေးချယ်ပြီး',
    ben: 'ব্যবহারযোগ্য উদ্বৃত্ত উপকরণ মোট {total} ধরন, {quantity} ধরন নির্বাচিত',
    tr: 'Kullanilabilir artik malzeme toplam {total} tur, secilen {quantity} tur',
    km: 'សម្ភារៈសំណល់ដែលអាចប្រើបានមានសរុប {total} ប្រភេទ បានជ្រើស {quantity} ប្រភេទ',
    es: 'Hay {total} tipos de materiales restantes disponibles, se han seleccionado {quantity} tipos',
    ar: 'هناك أنواع {total} من المواد المتبقية المتاحة، تم تحديد أنواع {quantity}',
  },
  'materialPage.noCanSaveInfo': {
    zh: '没有可以保存的信息',
    en: 'No information can be saved',
    id: 'Tidak ada informasi untuk disimpan',
    kz: 'Сақтау мүмкіндігі жоқ ақпарат',
    th: 'ไม่มีข้อมูลที่จะบันทึก',
    ug: 'ساقلىنىدىغان ئۇچۇر يوق',
    vi: 'Không có thông tin có thể được lưu',
    zh_tc: '沒有可以保存的信息',
    ru: 'Нет информации, которую можно сохранить',
    ko: '저장할 정보가 없습니다.',
    bur: 'သိမ်းဆည်းနိုင်သောသတင်းမရှိ',
    ben: 'সংরক্ষণযোগ্য কোনো তথ্য নেই',
    tr: 'Kaydedilebilecek bilgi yok',
    km: 'មិនមានព័ត៌មានអាចរក្សាទុកបានទេ',
    es: 'No hay información que se pueda guardar',
    ar: 'لا توجد معلومات يمكن حفظها',
  },
  'materialPage.chooseBujianStoreQuantity': {
    zh: '共 {total} 块补件，可顺带补件板件共 {quantity} 块，已选 {chooseQuantity} 块',
    en: 'There are {total} supplementary pieces, {quantity} supplementary planks can be included, {chooseQuantity} planks selected',
    id: 'Ada {total} blok untuk pengisian ulang, dan papan dapat diisi ulang dalam blok total {kuantitas}, dan blok {{{choosequantity} telah dipilih.',
    kz: 'Барлығы {total} қосымша бөлік, {quantity} тақтайларды қосуға болады, таңдалғаны {chooseQuantity} тақтай',
    th: 'มีบล็อก {Total} สำหรับการเติมเต็มและสามารถเติมเต็มบอร์ดได้ในบล็อกทั้งหมด {ปริมาณ} และบล็อก {เลือก Quantity} ได้รับการเลือก',
    ug: 'جەمئىي {total} دانە تاماملىغۇچى، ئىشلىتىشكە بولىدىغان تاماملىغۇچى تاختىسى {quantity} دانە، تاللانغان {chooseQuantity} دانە',
    vi: 'Có tổng cộng {total} tấm bổ sung, {quantity} tấm có thể bổ sung thêm, đã chọn {chooseQuantity} tấm',
    zh_tc:
      '共 {total} 塊補件，可順帶補件板件共 {quantity} 塊，已選 {chooseQuantity} 塊',
    ru: 'Доступно {total} типов дополнений, {quantity} типов дополнений можно добавить, выбрано {chooseQuantity} типов',
    ko: '총 {total} 개의 보수 판, {quantity} 개의 보수 판을 포함할 수 있으며, {chooseQuantity} 개의 판이 선택되었습니다.',
    bur: 'ဖြည့်ဆည်းပစ္စည်း {total} ချပ်ရှိသည်၊ ဖြည့်ဆည်းပေါ်ဒ်ငယ် {quantity} ချပ်ပါနိုင်သည်၊ {chooseQuantity} ချပ်ရွေးပြီး',
    ben: 'মোট {total} টি পরিপূরক, {quantity} টি পরিপূরক বোর্ড যোগ করা যাবে, {chooseQuantity} টি নির্বাচিত',
    tr: 'Toplam {total} tamamlayici parca var, birlikte eklenebilecek tamamlayici panel {quantity} adet, secilen {chooseQuantity} adet',
    km: 'មានគ្រឿងបំពេញសរុប {total} បន្ទះ អាចបន្ថែមបន្ទះគ្រឿងបំពេញបានសរុប {quantity} បន្ទះ បានជ្រើស {chooseQuantity} បន្ទះ',
    es: 'Un total de {total} piezas de patchwork, un total de {quantity} piezas de paneles que se pueden parchar por cierto, {chooseQuantity} piezas han sido seleccionadas',
    ar: 'إجمالي {total} قطع الترقيع، إجمالي {quantity} قطع الألواح التي يمكن ترقيعها بالمناسبة، تم تحديد {chooseQuantity} قطع',
  },
  'materialPage.isConfirmPushToAwaitStore': {
    zh: '是否确认将所选板件添加到待排版库?',
    en: 'Are you sure you want to add the selected planks to the awaiting layout warehouse?',
    id: 'Apakah Anda pasti akan menambahkan papan yang dipilih ke perpustakaan untuk diketik?',
    kz: 'Таңдалған тақтайларды орналастыруды күту қоймасына қосуға сенімдісіз бе?',
    th: 'คุณแน่ใจว่าจะเพิ่มบอร์ดที่เลือกลงในไลบรารีที่จะพิมพ์หรือไม่?',
    ug: 'تاللانغان تاختىلارنى تەرتىپلەش كۇتۇپخانىسىغا قوشۇشنى جەزملەشتۈرەمسىز؟',
    vi: 'Bạn có chắc chắn muốn thêm các tấm ván đã chọn vào kho chờ xếp ván không?',
    zh_tc: '是否確認將所選板件添加到待排版庫?',
    ru: 'Подтверждаете ли вы добавление выбранной панели в библиотеку, подлежащую набору?',
    ko: '선택한 보드를 보류 중인 라이브러리에 추가하시겠습니까?',
    bur: 'ရွေးချယ်ထားသောပေါ်ဒ်ကို ပြင်ဆင်ရန်ဘောင်သို့ ထည့်ရန်သေချာပါသလား?',
    ben: 'নির্বাচিত বোর্ডগুলো অপেক্ষাধীন লেআউট ওয়্যারহাউসে যোগ করতে নিশ্চিত করবেন কি?',
    tr: 'Secilen panelleri bekleyen dizgi kutuphanesine eklemek istediginizi onayliyor musunuz?',
    km: 'តើអ្នកបញ្ជាក់ថាចង់បន្ថែមបន្ទះដែលបានជ្រើសទៅក្នុងបណ្ណាល័យរង់ចាំប្លង់មែនទេ?',
    es: '¿Está seguro de agregar los paneles seleccionados a la biblioteca para componerlos?',
    ar: 'هل أنت متأكد من إضافة اللوحات المحددة إلى المكتبة ليتم تنضيدها؟',
  },
  'materialPage.enterAutoCreateMatCode': {
    zh: '按回车将自动创建材质',
    en: 'Press Enter to auto-create material',
    id: 'Tekan Enter untuk membuat materi secara otomatis',
    kz: 'Материалды автоматты түрде жасау үшін Enter басыңыз',
    th: 'กด Enter เพื่อสร้างวัสดุโดยอัตโนมัติ',
    ug: 'Enter كۇنۇپكىسىنى باسسىڭىز ماتېرىيال ئاپتوماتىك قۇرۇلىدۇ',
    vi: 'Nhấn Enter để tự động tạo vật liệu',
    zh_tc: '按回車將自動創建材質',
    ru: 'Нажмите обратно, чтобы создать материал автоматически.',
    ko: '롤백을 누르면 재료가 자동으로 생성됩니다.',
    bur: 'Enter နှိပ်ပါက ပစ္စည်းကိုအလိုအလျောက်ဖန်တီးမည်',
    ben: 'Enter চাপলে স্বয়ংক্রিয়ভাবে উপকরণ তৈরি হবে',
    tr: "Enter'a basildiginda malzeme otomatik olusturulur",
    km: 'ចុច Enter ដើម្បីបង្កើតសម្ភារៈដោយស្វ័យប្រវត្តិ',
    es: 'Presione Enter para crear material automáticamente',
    ar: 'اضغط على Enter لإنشاء المادة تلقائيًا',
  },
  'materialPage.chooseAwaitStoreQuantity': {
    zh: '共 {total} 块待排版库小板，可顺带排版的板件共 {quantity} 块，已选 {chooseQuantity} 块',
    en: 'There are {total} small planks in the awaiting layout warehouse, {quantity} planks can be included in the layout, {chooseQuantity} planks selected',
    id: 'Ada {total} blok secara total. Papan yang akan diketik adalah blok {kuantitas}. Blok {pilihan}} telah dipilih.',
    kz: 'Орналастыруды күту қоймасында {total} шағын тақтай бар, орналастыруға {quantity} тақтай қосуға болады, таңдалғаны {chooseQuantity} тақтай',
    th: 'มีบล็อกทั้งหมด {ทั้งหมด} บอร์ดที่จะพิมพ์คือบล็อก {ปริมาณ} เลือกบล็อก {เลือก Quantity} แล้ว',
    ug: 'جەمئىي {total} دانە تەرتىپلەش بۇكىتىدىكى كىچىك تاختىلار، ئىشلىتىشكە بولىدىغان تاختىلار {quantity} دانە، تاللانغان {chooseQuantity} دانە',
    vi: 'Có tổng cộng {total} tấm nhỏ trong kho chờ xếp ván, {quantity} tấm có thể đưa vào xếp ván, đã chọn {chooseQuantity} tấm',
    zh_tc:
      '共 {total} 塊待排版庫小板，可順帶排版的板件共 {quantity} 塊，已選 {chooseQuantity} 塊',
    ru: 'В библиотеке ожидания набора {total} малых панелей, {quantity} панелей можно включить в набор, выбрано {chooseQuantity} панелей',
    ko: '총 {total} 개의 보류 중인 라이브러리 소판, {quantity} 개의 판을 포함할 수 있으며, {chooseQuantity} 개의 판이 선택되었습니다.',
    bur: 'ပြင်ဆင်ရန်ဘောင်တွင် ပေါ်ဒ်ငယ် {total} ချပ်ရှိသည်၊ ပြင်ဆင်မှုထည့်နိုင်သော ပေါ်ဒ် {quantity} ချပ်ရှိသည်၊ {chooseQuantity} ချပ်ရွေးပြီး',
    ben: 'অপেক্ষাধীন লেআউট ওয়্যারহাউসে {total} টি ছোট বোর্ড আছে, লেআউটে {quantity} টি অন্তর্ভুক্ত করা যাবে, {chooseQuantity} টি নির্বাচিত',
    tr: 'Bekleyen dizgi kutuphanesinde toplam {total} kucuk panel var, birlikte dizilebilecek panel {quantity} adet, secilen {chooseQuantity} adet',
    km: 'មានបន្ទះតូចក្នុងបណ្ណាល័យរង់ចាំប្លង់សរុប {total} បន្ទះ អាចប្លង់រួមបាន {quantity} បន្ទះ បានជ្រើស {chooseQuantity} បន្ទះ',
    es: 'Un total de {total} paneles pequeños en la biblioteca para componer, un total de {quantity} paneles que se pueden componer, bloques {chooseQuantity} seleccionados',
    ar: 'إجمالي {total} اللوحات الصغيرة في المكتبة المراد تنضيدها، إجمالي {quantity} اللوحات التي يمكن تنضيدها، كتل {chooseQuantity} المحددة',
  },
  'materialPage.defaultFold': {
    zh: '板件数据默认收起',
    en: 'Parts Data Default Collapsed',
    id: 'Data papan ditutup secara default',
    kz: 'Панельдік деректер әдепкі бойынша жабылады',
    th: 'ข้อมูลบอร์ดถูกปิดโดยค่าเริ่มต้น',
    ug: 'تاختا سانلىق مەلۇماتى سۈكۈتتىكى يىغىلىدۇ',
    vi: 'Dữ liệu tấm bảng được ẩn theo mặc định',
    zh_tc: '板件數據默認收起',
    ru: 'Убрать данные по умолчанию',
    ko: '보드 데이터 기본 축소',
    bur: 'ပေါ်ဒ်ဒေတာ မူရင်းကြောင်းလိပ်',
    ben: 'বোর্ড ডেটা ডিফল্ট ভাঁজ করা',
    tr: 'Panel Verileri Varsayilan Olarak Katli',
    km: 'ទិន្នន័យបន្ទះត្រូវបានបត់ជាលំនាំដើម',
    es: 'Los datos del panel se contraen de forma predeterminada',
    ar: 'يتم طي بيانات اللوحة افتراضيًا',
  },
  'materialPage.startArrange': {
    zh: '开始排版',
    en: 'Start Nesting',
    id: 'Mulai tipografi',
    kz: 'Орнатуды бастау',
    th: 'เริ่มการพิมพ์',
    ug: 'تەرتىپلەشنى باشلاڭ',
    vi: 'Bắt đầu điều hình',
    zh_tc: '開始排版',
    ru: 'Начать типографию',
    ko: '조판을 시작하다',
    bur: 'ပြင်ဆင်မှုစတင်ပါ',
    ben: 'লেআউট শুরু করুন',
    tr: 'Dizgiyi Baslat',
    km: 'ចាប់ផ្តើមប្លង់',
    es: 'Iniciar composición',
    ar: 'ابدأ بالتنضيد',
  },
  'materialPage.importMaterial': {
    zh: '导入开料清单',
    en: 'Import Cut List',
    id: 'Impor Bill of Material',
    kz: 'Материалдар тізімін імпорту',
    th: 'นำเข้าบิลวัสดุ',
    ug: 'ماتېرىال تىزىملىكىنى ئەكىرىش',
    vi: 'Nhập danh sách tài liệu cắt gỗ',
    zh_tc: '導入開料清單',
    ru: 'Импорт списка открытых материалов',
    ko: '커팅 리스트 가져오기',
    bur: 'ဖြတ်တောက်စာရင်းတင်သွင်းပါ',
    ben: 'কাটার তালিকা আমদানি করুন',
    tr: 'Kesim Listesini Ice Aktar',
    km: 'នាំចូលបញ្ជីកាត់',
    es: 'Importar la lista de corte',
    ar: 'استيراد قائمة القطع',
  },
  'materialPage.saveToHistory': {
    zh: '保存至历史',
    en: 'Save to History',
    id: 'Simpan ke Sejarah',
    kz: 'Тарихқа сақтау',
    th: 'บันทึกประวัติศาสตร์',
    ug: 'تارىخقا ساقلاش',
    vi: 'Lưu vào lịch sử',
    zh_tc: '保存至歷史',
    ru: 'Сохранить в историю',
    ko: '역사에 저장',
    bur: 'မှတ်တမ်းသို့သိမ်းပါ',
    ben: 'ইতিহাসে সংরক্ষণ করুন',
    tr: 'Gecmise Kaydet',
    km: 'រក្សាទុកទៅប្រវត្តិ',
    es: 'Guardar en el historial',
    ar: 'حفظ في التاريخ',
  },
  'materialPage.addPlank': {
    zh: '添加板件',
    en: 'Add board',
    id: 'Tambahkan papan',
    kz: 'Панельді қосу',
    th: 'เพิ่มบอร์ด',
    ug: 'تاختا قوشۇش',
    vi: 'Thêm tấm gỗ',
    zh_tc: '添加板件',
    ru: 'Добавить панель',
    ko: '보드 추가',
    bur: 'ပေါ်ဒ်ထည့်ပါ',
    ben: 'বোর্ড যোগ করুন',
    tr: 'Panel Ekle',
    km: 'បន្ថែមបន្ទះ',
    es: 'Agregar paneles',
    ar: 'إضافة لوحات',
  },
  'materialPage.addBujian': {
    zh: '添加补件',
    en: 'Add a replacement part',
    id: 'Tambahkan bahan pengganti',
    kz: 'Қосымша қойым қойылымына қосу',
    th: 'เพิ่มเอกสารเพิ่มเติม',
    ug: 'قوشۇمچە بۆلەك قوشۇش',
    vi: 'Thêm giấy tờ bổ sung',
    zh_tc: '添加補件',
    ru: 'Добавить дополнение',
    ko: '패치 추가',
    bur: 'ဖြည့်ဆည်းပစ္စည်းထည့်ပါ',
    ben: 'পরিপূরক যোগ করুন',
    tr: 'Tamamlayici Parca Ekle',
    km: 'បន្ថែមគ្រឿងបំពេញ',
    es: 'Agregar parche',
    ar: 'إضافة تصحيح',
  },
  'materialPage.deletePlank': {
    zh: '删除板件',
    en: 'Delete Part',
    id: 'Hapus papan',
    kz: 'Панельді жою',
    th: 'ลบบอร์ด',
    ug: 'تاختا ئۆچۈرۈش',
    vi: 'Xóa tấm gỗ',
    zh_tc: '刪除板件',
    ru: 'Удалить панель',
    ko: '보드 삭제',
    bur: 'ပေါ်ဒ်ဖျက်ပါ',
    ben: 'বোর্ড মুছুন',
    tr: 'Panel Sil',
    km: 'លុបបន្ទះ',
    es: 'Eliminar paneles',
    ar: 'حذف اللوحات',
  },
  'materialPage.batchEdit': {
    zh: '批量修改',
    en: 'Batch Edit',
    id: 'Modifikasi batch',
    kz: 'Топтық өңдеу',
    th: 'การดัดแปลงแบทช์',
    ug: 'جەمئىي تەھرىرلەش',
    vi: 'Sửa đổi hàng loạt',
    zh_tc: '批量修改',
    ru: 'Пакетное изменение',
    ko: '대량 수정',
    bur: 'အစုလိုက်ပြင်ဆင်ပါ',
    ben: 'ব্যাচ পরিবর্তন করুন',
    tr: 'Toplu Duzenle',
    km: 'កែប្រែជាក្រុម',
    es: 'Modificación por lotes',
    ar: 'تعديل الدفعة',
  },
  'materialPage.moreSetting': {
    zh: '更多设置',
    en: 'More settings',
    id: 'Lebih banyak pengaturan',
    kz: 'Қосымша орноту',
    th: 'การตั้งค่าเพิ่มเติม',
    ug: 'تېخىمۇ كۆپ تەڭشەش',
    vi: 'Cài đặt thêm',
    zh_tc: '更多設置',
    ru: 'Больше настроек',
    ko: '추가 설정',
    bur: 'နောက်ထပ်ဆက်တင်',
    ben: 'আরও সেটিংস',
    tr: 'Daha Fazla Ayar',
    km: 'ការកំណត់បន្ថែម',
    es: 'Más configuraciones',
    ar: 'المزيد من الإعدادات',
  },
  'materialPage.plankSize': {
    zh: '板件尺寸',
    en: 'Part Size',
    id: 'Ukuran piring',
    kz: 'Панельдің өлшемдері',
    th: 'ขนาดแผ่น',
    ug: 'تاختا ئۆلچىمى',
    vi: 'Kích thước tấm gỗ',
    zh_tc: '板件尺寸',
    ru: 'Размеры листов',
    ko: '보드 크기',
    bur: 'ပေါ်ဒ်အရွယ်အစား',
    ben: 'বোর্ডের আকার',
    tr: 'Panel Boyutu',
    km: 'ទំហំបន្ទះ',
    es: 'Tamaño del panel',
    ar: 'حجم اللوحة',
  },
  'materialPage.plankSize2': {
    zh: '尺寸(长*宽*厚)',
    en: 'Size (Length * Width * Thick)',
    id: 'Dimensi (panjang*lebar*ketebalan)',
    kz: 'Өлшемдер (Ұзындығы * Ені * Қалыңдығы)',
    th: 'ขนาด (ความยาว*ความกว้าง*ความหนา)',
    ug: 'ئۆلچەم (ئۇزۇنلۇق*كەڭلىك*قېلىنلىق)',
    vi: 'Kích thước (Dài * Rộng * Dày)',
    zh_tc: '尺寸(長*寬*厚)',
    ru: 'Размер (длина * ширина * толщина)',
    ko: '크기 (길이 * 폭 * 두께)',
    bur: 'အရွယ်အစား (အရှည် * အကျယ် * အထူ)',
    ben: 'আকার (দৈর্ঘ্য * প্রস্থ * পুরুত্ব)',
    tr: 'Boyut (Uzunluk*Genislik*Kalınlık)',
    km: 'ទំហំ (បណ្តោយ*ទទឹង*កម្រាស់)',
    es: 'Dimensiones (largo*ancho*grosor)',
    ar: 'الأبعاد (الطول*العرض*السمك)',
  },
  'materialPage.searchPlaceholder': {
    zh: '搜索板件名称/板号',
    en: 'Search Panel Name/Panel Number',
    id: 'Pencarian nama papan/nomor papan',
    kz: 'Панельдің атауы/панель нөміріні іздеу',
    th: 'ชื่อคณะกรรมการค้นหา/หมายเลขบอร์ด',
    ug: 'تاختا ئاتى/تاختا نومۇرى ئىزدەش',
    vi: 'Tìm kiếm tên tấm gỗ/hộp',
    zh_tc: '搜索板件名稱/板號',
    ru: 'Имя панели поиска / номер панели',
    ko: '검색 보드 이름 / 보드 번호',
    bur: 'ပေါ်ဒ်အမည်/ပေါ်ဒ်နံပါတ်ရှာပါ',
    ben: 'বোর্ডের নাম/বোর্ড নম্বর অনুসন্ধান করুন',
    tr: 'Panel adi/panel numarasi ara',
    km: 'ស្វែងរកឈ្មោះបន្ទះ/លេខបន្ទះ',
    es: 'Buscar nombre de placa/número de placa',
    ar: 'اسم لوحة البحث/رقم اللوحة',
  },
  'materialPage.checkArranged': {
    zh: '查看排版',
    en: 'View Layout',
    id: 'Lihat tata letaknya',
    kz: 'Орнатуды қарау',
    th: 'ดูเลย์เอาต์',
    ug: 'تەرتىپلەشنى كۆرۈش',
    vi: 'Xem điều hình',
    zh_tc: '查看排版',
    ru: 'Просмотреть набор',
    ko: '조판 보기',
    bur: 'ပြင်ဆင်မှုကြည့်ပါ',
    ben: 'লেআউট দেখুন',
    tr: 'Dizgiyi Gor',
    km: 'មើលប្លង់',
    es: 'Ver composición tipográfica',
    ar: 'عرض التنضيد',
  },
  'materialPage.checkErr': {
    zh: '未进行排版, 无法查看!',
    en: 'No arrangement has been made, unable to view!',
    id: 'Tidak diketik, tidak bisa dilihat!',
    kz: 'Орнатуды жасалмады, қарауға болмайды!',
    th: 'ไม่พิมพ์ไม่สามารถดูได้!',
    ug: 'تەرتىپلەنمىگەن، كۆرەلمەيسىز!',
    vi: 'Chưa điều hình, không thể xem!',
    zh_tc: '未進行排版, 無法查看!',
    ru: 'Не проведена типография, невозможно просмотреть!',
    ko: '조판이 진행되지 않아 볼 수 없습니다!',
    bur: 'ပြင်ဆင်မှုမလုပ်ရသေး၊ မကြည့်နိုင်!',
    ben: 'লেআউট করা হয়নি, দেখা যাচ্ছে না!',
    tr: 'Dizgi yapilmadi, goruntulenemiyor!',
    km: 'មិនទាន់ធ្វើប្លង់ទេ មិនអាចមើលបាន!',
    es: '¡Sin composición tipográfica, no se puede ver!',
    ar: 'لا يوجد تنضيد، لا يمكن عرضه!',
  },
  'materialPage.downloadSheet': {
    zh: '下载样表',
    en: 'Download  template',
    id: 'Unduh Tabel Sampel',
    kz: 'Үлгі парақ жүктеу',
    th: 'ดาวน์โหลดตารางตัวอย่าง',
    ug: 'نۇمۇنىە چۈشۈرۈش',
    vi: 'Tải xuống mẫu bảng',
    zh_tc: '下載樣表',
    ru: 'Загрузить таблицу образцов',
    ko: '샘플 테이블 다운로드',
    bur: 'နမူနာဇယားဒေါင်းလုဒ်',
    ben: 'টেমপ্লেট ডাউনলোড করুন',
    tr: 'Ornek Tabloyu Indir',
    km: 'ទាញយកតារាងគំរូ',
    es: 'Descargar tabla de muestra',
    ar: 'تنزيل جدول العينة',
  },
  'materialPage.downloadSheetShowScientific': {
    zh: '下载样表（展示科学计数法）',
    en: 'Download  template (showing Scientific notation)',
    id: 'Unduh Tabel Sampel (Menampilkan Metode Notasi Ilmiah)',
    kz: 'Үлгі парағын жүктеу (ғылыми нотацияны көрсету)',
    th: 'ดาวน์โหลดตารางตัวอย่าง (การแสดงวิธีสัญลักษณ์ทางวิทยาศาสตร์)',
    ug: 'نۇمۇنىە چۈشۈرۈش (ئىلمىي كۆرسىتىش)',
    vi: 'Tải về mẫu (cho thấy phương pháp đếm khoa học)',
    zh_tc: '下載樣表（展示科學計數法）',
    ru: 'Загрузить таблицу образцов (показать метод научного подсчета)',
    ko: '샘플 테이블 다운로드 (과학 계수법 보여주기)',
    bur: 'နမူနာဇယားဒေါင်းလုဒ် (သိပ္ပံကိန်းဂဏန်းနည်းပြ)',
    ben: 'নমুনা টেবিল ডাউনলোড করুন (বৈজ্ঞানিক স্বরলিপি প্রদর্শন)',
    tr: 'Ornek Tabloyu Indir (Bilimsel Gosterimle)',
    km: 'ទាញយកតារាងគំរូ (បង្ហាញជាទម្រង់វិទ្យាសាស្ត្រ)',
    es: 'Descargar tabla de muestra (que muestra notación científica)',
    ar: 'تنزيل جدول العينة (يظهر التدوين العلمي)',
  },
  'materialPage.exportHoleSlotPDF': {
    zh: '导出板件孔槽图',
    en: 'Export Panel Hole and Slot Diagram',
    id: 'Diagram slot lubang pelat ekspor',
    kz: 'Панельдің тесіктері-жұмсақ шабаларын экспорттау',
    th: 'ไดอะแกรมช่องส่งออกแผ่น',
    ug: 'تاختا تېشىك-ئوچۇق رەسىمىنى چىقىرىش',
    vi: 'Xuất hình ảnh các lỗ và khe của tấm gỗ',
    zh_tc: '導出板件孔槽圖',
    ru: 'Диаграмма отверстий для экспортируемых элементов',
    ko: '보드 부품 구멍 슬롯 다이어그램 내보내기',
    bur: 'ပေါ်ဒ်ပေါက်ကြိုးပုံထုတ်ပါ',
    ben: 'বোর্ডের গর্ত-স্লট চিত্র রপ্তানি করুন',
    tr: 'Panel Delik ve Kanal Cizimini Disa Aktar',
    km: 'នាំចេញគំនូសរន្ធ និងរន្ធបន្ទះ',
    es: 'Exportar diagrama de orificios y ranuras de la placa',
    ar: 'مخطط تصدير ثقب اللوحة والأخدود',
  },
  'materialPage.style1': {
    zh: '样式一',
    en: 'Style 1',
    id: 'Gaya satu',
    kz: 'Стиль 1',
    th: 'สไตล์หนึ่ง',
    ug: 'ئۇسلۇب 1',
    vi: 'Kiểu 1',
    zh_tc: '樣式一',
    ru: 'Стиль 1',
    ko: '스타일 1',
    bur: 'ပုံစံ ၁',
    ben: 'স্টাইল ১',
    tr: 'Stil 1',
    km: 'រចនាប័ទ្ម 1',
    es: 'Estilo uno',
    ar: 'النمط الأول',
  },
  'materialPage.style2': {
    zh: '样式二',
    en: 'Style 2',
    id: 'Gaya 2',
    kz: 'Стиль 2',
    th: 'สไตล์ 2',
    ug: 'ئۇسلۇب 2',
    vi: 'Kiểu 2',
    zh_tc: '樣式二',
    ru: 'Стиль 2',
    ko: '스타일 2',
    bur: 'ပုံစံ ၂',
    ben: 'স্টাইল ২',
    tr: 'Stil 2',
    km: 'រចនាប័ទ្ម 2',
    es: 'Estilo dos',
    ar: 'النمط الثاني',
  },
  'materialPage.style2PDF': {
    zh: '样式二(PDF)',
    en: 'Style 2 (PDF)',
    id: 'Gaya 2 (PDF)',
    kz: 'Стиль 2 (PDF)',
    th: 'สไตล์ 2 (PDF)',
    ug: 'ئۇسلۇب 2 (PDF)',
    vi: 'Kiểu 2 (PDF)',
    zh_tc: '樣式二(PDF)',
    ru: 'Стиль 2 (PDF)',
    ko: '스타일 2 (PDF)',
    bur: 'ပုံစံ ၂ (PDF)',
    ben: 'স্টাইল ২ (PDF)',
    tr: 'Stil 2 (PDF)',
    km: 'រចនាប័ទ្ម 2 (PDF)',
    es: 'Estilo 2 (PDF)',
    ar: 'النمط الثاني (PDF)',
  },
  'materialPage.style2DXF': {
    zh: '样式二(DXF)',
    en: 'Style 2 (DXF)',
    id: 'Gaya 2 (DXF)',
    kz: 'Стиль 2 (DXF)',
    th: 'สไตล์ 2 (DXF)',
    ug: 'ئۇسلۇب 2 (DXF)',
    vi: 'Kiểu 2 (DXF)',
    zh_tc: '樣式二(DXF)',
    ru: 'Стиль 2 (DXF)',
    ko: '스타일 2 (DXF)',
    bur: 'ပုံစံ ၂ (DXF)',
    ben: 'স্টাইল ২ (DXF)',
    tr: 'Stil 2 (DXF)',
    km: 'រចនាប័ទ្ម 2 (DXF)',
    es: 'Estilo 2 (DXF)',
    ar: 'النمط الثاني (DXF)',
  },
  'materialPage.style3': {
    zh: '样式三',
    en: 'Style 3',
    id: 'Gaya tiga',
    kz: 'Стиль 3',
    th: 'สไตล์สาม',
    ug: 'ئۇسلۇب 3',
    vi: 'Kiểu 3',
    zh_tc: '樣式三',
    ru: 'Стиль 3',
    ko: '스타일 3',
    bur: 'ပုံစံ ၃',
    ben: 'স্টাইল ৩',
    tr: 'Stil 3',
    km: 'រចនាប័ទ្ម 3',
    es: 'Estilo tres',
    ar: 'النمط الثالث',
  },
  'materialPage.importNoCover': {
    zh: '料单导入不覆盖',
    en: 'Import Material List without Overwriting',
    id: 'Tidak menimpa impor',
    kz: 'Материалдар тізіміңіздің імпортуі қаптамау',
    th: 'ไม่มีการนำเข้าเขียนทับ',
    ug: 'ماتېرىال تىزىملىكى ئەكىرىش قاپلىمايدۇ',
    vi: 'Nhập danh sách tài liệu không ghi đè',
    zh_tc: '料單導入不覆蓋',
    ru: 'Импорт листа не покрывается',
    ko: '원단 가져오기는 덮어쓰지 않음',
    bur: 'ပစ္စည်းစာရင်းတင်သွင်းချိန်မဖုံးကွယ်',
    ben: 'উপকরণ তালিকা আমদানিতে ওভাররাইট করা হবে না',
    tr: 'Malzeme Listesi Ice Aktarma Uzerine Yazmaz',
    km: 'ការនាំចូលបញ្ជីសម្ភារៈនឹងមិនសរសេរជាន់ទេ',
    es: 'La importación de la lista de materiales no está cubierta',
    ar: 'لم يتم تغطية استيراد قائمة المواد',
  },
  'materialPage.openBujianPlankRecommend': {
    zh: '开启补件小板推荐',
    en: 'Open the patch panel recommended',
    id: 'Disarankan untuk membuka papan suplemen',
    kz: 'Patch Miniplate ұсынысын ашу',
    th: 'แนะนำให้เปิดบอร์ดเสริม',
    ug: 'تاماملىغۇچى كىچىك تاختىنى تەۋسىيە قىلىشنى قوزغىتىش',
    vi: 'Mở các tấm nhỏ được đề nghị',
    zh_tc: '開啟補件小板推薦',
    ru: 'Открываем дополнения, рекомендуем.',
    ko: '패치 보드 오픈 추천',
    bur: 'ဖြည့်ဆည်းပေါ်ဒ်ငယ်အကြံပြုချက်ဖွင့်ပါ',
    ben: 'পরিপূরক ছোট বোর্ডের পরামর্শ চালু করুন',
    tr: 'Tamamlayici Kucuk Panel Onerisini Ac',
    km: 'បើកការណែនាំបន្ទះតូចគ្រឿងបំពេញ',
    es: 'Habilitar la recomendación de paneles pequeños para piezas suplementarias',
    ar: 'تمكين التوصية بالألواح الصغيرة للأجزاء التكميلية',
  },
  'materialPage.openAwaitStorePlankRecommend': {
    zh: '开启待排版库小板推荐',
    en: 'Open the library to be formatted small board recommendation',
    id: 'Buka papan kecil untuk rekomendasi perpustakaan tata letak',
    kz: 'Түрге жататын кітапхананың ұсыным тақтасын ашу',
    th: 'เปิดบอร์ดขนาดเล็กสำหรับคำแนะนำห้องสมุดเค้าโครง',
    ug: 'تەرتىپلەش بۇكىتىدىكى كىچىك تاختىنى تەۋسىيە قىلىشنى قوزغىتىش',
    vi: 'Mở sẵn sàng để sắp xếp bảng giới thiệu',
    zh_tc: '開啟待排版庫小板推薦',
    ru: 'Откройте библиотеку для просмотра.',
    ko: '보류 중인 라이브러리 보드 추천 열기',
    bur: 'ပြင်ဆင်ရန်ဘောင်ပေါ်ဒ်ငယ်အကြံပြုချက်ဖွင့်ပါ',
    ben: 'অপেক্ষাধীন লেআউট লাইব্রেরির ছোট বোর্ডের পরামর্শ চালু করুন',
    tr: 'Bekleyen Dizgi Kutuphanesi Kucuk Panel Onerisini Ac',
    km: 'បើកការណែនាំបន្ទះតូចនៃបណ្ណាល័យរង់ចាំប្លង់',
    es: 'Habilitar la recomendación de paneles pequeños en la biblioteca para ser tipografiados',
    ar: 'تمكين التوصية بالألواح الصغيرة في المكتبة ليتم تنضيدها',
  },
  'materialPage.openSurplusPlankRecommend': {
    zh: '开启余料大板推荐',
    en: 'Open the remaining material large board recommended',
    id: 'Disarankan untuk membuka pelat material yang tersisa',
    kz: 'Қалған материал плитасын ашу ұсынылады',
    th: 'แนะนำให้เปิดแผ่นวัสดุที่เหลืออยู่',
    ug: 'قالدۇق چوڭ تاختىنى تەۋسىيە قىلىشنى قوزغىتىش',
    vi: 'Mở dư liệu tấm đề nghị',
    zh_tc: '開啟餘料大板推薦',
    ru: 'Открываем доску рекомендуем.',
    ko: '여분 대판 오픈 추천',
    bur: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးအကြံပြုချက်ဖွင့်ပါ',
    ben: 'উদ্বৃত্ত বড় বোর্ডের পরামর্শ চালু করুন',
    tr: 'Artik Buyuk Panel Onerisini Ac',
    km: 'បើកការណែនាំបន្ទះធំនៃសម្ភារៈសំណល់',
    es: 'Habilitar la recomendación de paneles grandes paneles con material restante',
    ar: 'تمكين توصية لوحات كبيرة مع المواد المتبقية',
  },
  'materialPage.pushToAwaitStore': {
    zh: '存入待排版库',
    en: 'Store in the library to be formatted',
    id: 'Simpan di perpustakaan yang to-type',
    kz: 'Түрге жататын кітапханадағы депозит',
    th: 'บันทึกไว้ในห้องสมุดประเภท TO-TYPE',
    ug: 'تەرتىپلەش بۇكىتىغا ساقلاش',
    vi: 'Gửi vào kho để sắp xếp',
    zh_tc: '存入待排版庫',
    ru: 'Хранить в библиотеке',
    ko: '예약된 라이브러리에 저장',
    bur: 'ပြင်ဆင်ရန်ဘောင်တွင်သိမ်းပါ',
    ben: 'অপেক্ষাধীন লেআউট লাইব্রেরিতে সংরক্ষণ করুন',
    tr: 'Bekleyen Dizgi Kutuphanesine Kaydet',
    km: 'រក្សាទុកទៅបណ្ណាល័យរង់ចាំប្លង់',
    es: 'Guardar en la biblioteca para componer',
    ar: 'احفظها في المكتبة ليتم تنضيدها',
  },
  'materialPage.setTableHead': {
    zh: '设置开料清单表头',
    en: 'Set Material List Header',
    id: 'Menyiapkan header Bill of Material',
    kz: 'Материалдар тізімінің таблица бастығы орнату',
    th: 'การตั้งค่าส่วนหัวของบิลวัสดุ',
    ug: 'ماتېرىال تىزىملىكى بېشىنى تەڭشەش',
    vi: 'Cài đặt tiêu đề danh sách tài liệu cắt gỗ',
    zh_tc: '設置開料清單表頭',
    ru: 'Настройка заголовка списка открытых материалов',
    ko: '커팅 리스트 헤더 설정',
    bur: 'ဖြတ်တောက်စာရင်းဇယားခေါင်းစဉ်သတ်မှတ်ပါ',
    ben: 'কাটার তালিকার শিরোনাম সেট করুন',
    tr: 'Kesim Listesi Basligini Ayarla',
    km: 'កំណត់ក្បាលតារាងបញ្ជីកាត់',
    es: 'Establecer el encabezado de la lista de corte',
    ar: 'قم بتعيين رأس قائمة القطع',
  },
  'materialPage.syncConfirm': {
    zh: '柜柜与云排版原片数据不一致！是否同步为柜柜原片数据？',
    en: 'The original data between the cabinet system and the cloud arranging system is inconsistent! Do you want to synchronize with the cabinet system?',
    id: 'Data kabinet kabinet dan tata letak cloud film asli tidak konsisten! Apakah data asli blok kabinet?',
    kz: 'Қоршау мен Бұлттарды орастырудағы панельдердің деректері сәйкес келмейді! Қоршау деректеріне синхрондеуді тұра ма?',
    th: 'ข้อมูลของตู้เก็บของและฟิล์มดั้งเดิมของเมฆเค้าโครงนั้นไม่สอดคล้องกัน! ข้อมูลต้นฉบับของบล็อกตู้หรือไม่?',
    ug: 'كابىنەت بىلەن بۇلۇت تەرتىپلىگۈچتىكى ئەسلى تاختا سانلىق مەلۇماتى ئوخشاش ئەمەس! كابىنەتتىكى ئەسلى تاختا سانلىق مەلۇماتى بىلەن ماسلىشىدۇ؟',
    vi: 'Dữ liệu nguyên liệu của Quì Quì và Điều hình trên đám mây không khớp! Đồng bộ hóa với dữ liệu nguyên liệu của Quì Quì?',
    zh_tc: '櫃櫃與雲排版原片數據不一致！是否同步為櫃櫃原片數據？',
    ru: 'Шкафы не совпадают с данными облачной типографии! Синхронизировать исходные данные для шкафа?',
    ko: '캐비닛과 클라우드 레이아웃 원본 데이터가 일치하지 않습니다!캐비닛 원본 데이터로 동기화합니까?',
    bur: 'ဗီရိုနှင့် Cloud Layout ပေါ်ဒ်ဒေတာမကိုက်ညီ! ဗီရိုပေါ်ဒ်ဒေတာနှင့်ကိုက်ညှိမည်လား?',
    ben: 'ক্যাবিনেট এবং ক্লাউড টাইপসেটিং মূল শীট ডেটা অসামঞ্জস্যপূর্ণ! ক্যাবিনেটের মূল শীট ডেটার সাথে সিঙ্ক্রোনাইজ করবেন কি?',
    tr: 'Dolap sistemi ile bulut dizgi orijinal panel verileri tutarsiz! Dolap sisteminin orijinal panel verileriyle senkronize etmek ister misiniz?',
    km: 'ទិន្នន័យសន្លឹកដើមរបស់ប្រព័ន្ធទូ និងប្លង់ពពកមិនស្របគ្នាទេ! តើត្រូវធ្វើសមកាលកម្មទៅជាទិន្នន័យសន្លឹកដើមរបស់ប្រព័ន្ធទូឬ?',
    es: '¡Los datos del gabinete y la pieza original de composición tipográfica en la nube son inconsistentes! ¿Está sincronizado con los datos de la película original del gabinete?',
    ar: 'بيانات الخزانة والقطعة الأصلية من التنضيد السحابي غير متسقة! هل تتم مزامنتها مع بيانات الفيلم الأصلية للخزانة؟',
  },
  'materialPage.handleSync': {
    zh: '注：可在原片管理中进行手动同步',
    en: 'Attention: Manual synchronization can be performed in the original sheet management',
    id: 'Catatan: Sinkronisasi manual dapat dilakukan dalam manajemen film asli',
    kz: 'Ескерту: Панельдерді басқаруда қолмен синхрондеуді істеуге болады',
    th: 'หมายเหตุ: การซิงโครไนซ์แบบแมนนวลสามารถทำได้ในการจัดการภาพยนตร์ต้นฉบับ',
    ug: 'ئەسكەرتىش: ئەسلى تاختا باشقۇرۇشتا قولدا ماسلىشتۇرۇشقا بولىدۇ',
    vi: 'Chú ý: Có thể đồng bộ hóa thủ công trong quản lý nguyên liệu',
    zh_tc: '注：可在原片管理中進行手動同步',
    ru: 'Примечание: ручная синхронизация может быть выполнена в управлении оригиналом',
    ko: '참고: 원본 관리에서 수동 동기화 가능',
    bur: 'မှတ်ချက် - မူရင်းပေါ်ဒ်စီမံတွင် ကိုယ်တိုင်ကိုက်ညှိနိုင်သည်',
    ben: 'নোট: মূল শীট ব্যবস্থাপনায় ম্যানুয়াল সিঙ্ক্রোনাইজেশন করা যাবে',
    tr: 'Not: Orijinal panel yonetiminde manuel senkronizasyon yapilabilir',
    km: 'ចំណាំ៖ អាចធ្វើសមកាលកម្មដោយដៃក្នុងការគ្រប់គ្រងសន្លឹកដើម',
    es: 'Nota: La sincronización manual se puede realizar en la gestión de la película original',
    ar: 'ملاحظة: يمكن إجراء المزامنة اليدوية في إدارة الفيلم الأصلي',
  },
  'materialPage.noMoreTip': {
    zh: '不再提示',
    en: 'No more prompts',
    id: 'Tidak ada lagi yang diminta',
    kz: 'Дараамай ескерту',
    th: 'ไม่มีพรอมต์อีกต่อไป',
    ug: 'تېخىمۇ ئۇقتۇرۇش بەرمە',
    vi: 'Không còn thông báo nữa',
    zh_tc: '不再提示',
    ru: 'Больше никаких подсказок',
    ko: '더 이상 프롬프트 없음',
    bur: 'နောက်ထပ်မဆိုင်',
    ben: 'আর প্রম্পট নেই',
    tr: 'Bir Daha Hatirlatma',
    km: 'កុំរំលឹកម្តងទៀត',
    es: 'No volver a preguntar',
    ar: 'لا تطالب مرة أخرى',
  },
  'materialPage.checkMore': {
    zh: '查看更多',
    en: 'View more',
    id: 'Lihat lebih banyak',
    kz: 'Қосымша қарау',
    th: 'ดูเพิ่มเติม',
    ug: 'تېخىمۇ كۆپ كۆرۈش',
    vi: 'Xem thêm',
    zh_tc: '查看更多',
    ru: 'Посмотреть больше',
    ko: '자세히 보기',
    bur: 'နောက်ထပ်ကြည့်ပါ',
    ben: 'আরও দেখুন',
    tr: 'Daha Fazlasini Goster',
    km: 'មើលបន្ថែម',
    es: 'Ver más',
    ar: 'عرض المزيد',
  },
  'materialPage.noHistory': {
    zh: '暂无保存历史…',
    en: 'No Saved History...',
    id: 'Tidak ada sejarah untuk dilestarikan ...',
    kz: 'Тарихқа сақталмаған деректер жоқ...',
    th: 'ไม่มีประวัติที่จะรักษา ...',
    ug: 'ھازىرچە ساقلانغان تارىخ يوق…',
    vi: 'Hiện tại chưa có lịch sử lưu trữ...',
    zh_tc: '暫無保存歷史…',
    ru: 'Без сохранения истории...',
    ko: '보존 내역 없음...',
    bur: 'သိမ်းဆည်းထားသောမှတ်တမ်းမရှိသေး...',
    ben: 'সংরক্ষিত ইতিহাস নেই...',
    tr: 'Kayitli Gecmis Yok...',
    km: 'មិនទាន់មានប្រវត្តិដែលបានរក្សាទុកទេ...',
    es: 'Aún no hay historial de guardado...',
    ar: 'لا يوجد سجل حفظ حتى الآن...',
  },
  'materialPage.sameOrder': {
    zh: '存在已导出生产文件的订单，请注意重复生产问题！',
    en: 'There are orders with exported production files, please pay attention to duplicate production issues!',
    id: 'Ada pesanan yang telah mengekspor file produksi, harap perhatikan masalah produksi duplikat!',
    kz: 'Өнім файлды экспорттаған тапсырыс бар, қайталап өнім шығаруға тықсуыдын ескерту!',
    th: 'มีคำสั่งซื้อที่ส่งออกไฟล์การผลิตโปรดให้ความสนใจกับปัญหาการผลิตซ้ำ!',
    ug: 'ئىشلەپچىقىرىش ھۆججىتى چىقىرىلغان زاكاز بار، قايتا ئىشلەپچىقىرىش مەسىلىسىگە دىققەت قىلىڭ!',
    vi: 'Có đơn hàng đã xuất file sản xuất, hãy chú ý đến vấn đề sản xuất lặp!',
    zh_tc: '存在已導出生產文件的訂單，請注意重複生產問題！',
    ru: 'Есть заказы, которые экспортировали производственную документацию, обратите внимание на проблему дублирования производства!',
    ko: '내보낸 프로덕션 파일에 대한 주문이 있습니다. 반복 프로덕션 문제에 주의하십시오.',
    bur: 'ထုတ်လုပ်မှုဖိုင်ထုတ်ပြီးသောအော်ဒါရှိသည်၊ ထပ်ဆင့်ထုတ်လုပ်မှုပြဿနာကိုသတိပြုပါ!',
    ben: 'উৎপাদন ফাইল রপ্তানি করা অর্ডার আছে, অনুগ্রহ করে ডুপ্লিকেট উৎপাদনের সমস্যায় মনোযোগ দিন!',
    tr: 'Uretim dosyasi disa aktarilmis siparisler var, lutfen tekrarli uretim sorununa dikkat edin!',
    km: 'មានការបញ្ជាទិញដែលបាននាំចេញឯកសារផលិតកម្មរួច សូមប្រយ័ត្នបញ្ហាផលិតកម្មស្ទួន!',
    es: 'Hay pedidos con archivos de producción exportados, ¡preste atención a problemas de producción duplicados!',
    ar: 'هناك طلبات تحتوي على ملفات إنتاج مُصدَّرة، يرجى الانتباه إلى مشكلات الإنتاج المكررة!',
  },
  'materialPage.markOrder': {
    zh: '是否在订单页面标记已生产？',
    en: 'Mark as Produced on the Order Page?',
    id: 'Apakah produksi ditandai pada halaman pesanan?',
    kz: 'Тапсырыс бетінде өнімді белгілеу ма?',
    th: 'การผลิตมีการทำเครื่องหมายไว้ในหน้าคำสั่งซื้อหรือไม่?',
    ug: 'زاكاز بېتىدە ئىشلەپچىقىرىلغانلىقىنى بەلگىلىمەمسىز؟',
    vi: 'Có ghi dấu đã sản xuất trên trang đơn hàng?',
    zh_tc: '是否在訂單頁面標記已生產？',
    ru: 'Отмечено ли производство на странице заказа?',
    ko: '주문 페이지에 생산됨을 표시하시겠습니까?',
    bur: 'အော်ဒါစာမျက်နှာတွင် ထုတ်လုပ်ပြီးကိုမှတ်မည်လား?',
    ben: 'অর্ডার পেজে উৎপাদিত হিসেবে চিহ্নিত করবেন কি?',
    tr: 'Siparis sayfasinda uretildi olarak isaretlemek istiyor musunuz?',
    km: 'តើត្រូវសម្គាល់ថាបានផលិតនៅទំព័រការបញ្ជាទិញឬទេ?',
    es: '¿Quieres marcar la producción en la página del pedido?',
    ar: 'هل تريد وضع علامة على الإنتاج في صفحة الطلب؟',
  },
  'materialPage.editErrTip': {
    zh: '多订单暂不支持修改信息',
    en: 'Multi-order modifications are not supported at this time',
    id: 'Beberapa pesanan tidak mendukung informasi modifikasi',
    kz: 'Көптеген тапсырысдерді ақпаратты өңдеуге қол жетімді емес',
    th: 'คำสั่งซื้อหลายคำสั่งไม่สนับสนุนข้อมูลการแก้ไข',
    ug: 'كۆپ زاكاز ھازىرچە ئۇچۇرنى ئۆزگەرتىشكە يول قويمايدۇ',
    vi: 'Đa đơn hàng hiện tại không hỗ trợ sửa đổi thông tin',
    zh_tc: '多訂單暫不支持修改信息',
    ru: 'Несколько заказов временно не поддерживают изменение информации',
    ko: '다중 주문은 정보 수정을 지원하지 않습니다.',
    bur: 'အော်ဒါများတွင် သတင်းပြင်ဆင်ချိန်ကာလမပံ့ပိုး',
    ben: 'একাধিক অর্ডারে তথ্য সংশোধন সমর্থিত নয়',
    tr: 'Coklu siparisler icin bilgi duzenleme simdilik desteklenmiyor',
    km: 'បច្ចុប្បន្នមិនគាំទ្រការកែព័ត៌មានសម្រាប់ការបញ្ជាទិញច្រើនទេ',
    es: 'Actualmente, varios pedidos no admiten la modificación de información',
    ar: 'الطلبات المتعددة لا تدعم حاليًا تعديل المعلومات',
  },
  'materialPage.autoSaveSuccess': {
    zh: '已自动保存至历史!',
    en: 'Autosaved to History!',
    id: 'Secara otomatis disimpan ke sejarah!',
    kz: 'Автоматты түрде тарихқа сақталды!',
    th: 'บันทึกไว้ในประวัติศาสตร์โดยอัตโนมัติ!',
    ug: 'ئاپتوماتىك تارىخقا ساقلاندى!',
    vi: 'Đã tự động lưu vào lịch sử!',
    zh_tc: '已自動保存至歷史!',
    ru: 'Автоматически сохранены в истории!',
    ko: '자동으로 역사에 저장되었습니다!',
    bur: 'မှတ်တမ်းသို့အလိုအလျောက်သိမ်းဆည်းပြီ!',
    ben: 'ইতিহাসে স্বয়ংক্রিয়ভাবে সংরক্ষিত হয়েছে!',
    tr: 'Gecmise otomatik kaydedildi!',
    km: 'បានរក្សាទុកទៅប្រវត្តិដោយស្វ័យប្រវត្តិ!',
    es: '¡Se guarda automáticamente en el historial!',
    ar: 'يتم حفظها تلقائيًا في التاريخ!',
  },
  'materialPage.goAdd': {
    zh: '前往添加',
    en: 'Go to Add',
    id: 'Pergi ke Add',
    kz: 'Қосу барады',
    th: 'ไปเพิ่ม',
    ug: 'قوشۇشقا بارىش',
    vi: 'Đi đến trang thêm',
    zh_tc: '前往添加',
    ru: 'Перейти к Добавить',
    ko: '추가로 이동',
    bur: 'ထည့်ရာသွားပါ',
    ben: 'যোগ করতে যান',
    tr: 'Eklemeye Git',
    km: 'ទៅបន្ថែម',
    es: 'Ir a agregar',
    ar: 'انتقل إلى الإضافة',
  },
  'materialPage.noProductionLine': {
    zh: '该条记录的生产线已被删除，请前往开料清单重新排版',
    en: 'The production line for this record has been deleted. Please rearrange in the Material List',
    id: 'Jalur produksi catatan ini telah dihapus. Silakan buka daftar materi untuk mengetikkan ulang.',
    kz: 'Бұл жазбаның өндірістік желісі жойылған, материалдар тізіміні қайтадан орнатуға болады',
    th: 'สายการผลิตของบันทึกนี้ถูกลบไปแล้ว โปรดไปที่รายการวัสดุเพื่อพิมพ์ใหม่',
    ug: 'بۇ خاتىرىدىكى ئىشلەپچىقىرىش لىنىيىسى ئۆچۈرۈلگەن، ماتېرىال تىزىملىكىگە بارىپ قايتا تەرتىپلەڭ',
    vi: 'Dây chuyền sản xuất của biên bản này đã bị xóa, vui lòng đi đến danh sách tài liệu cắt gỗ để điều hình lại',
    zh_tc: '該條記錄的生產線已被刪除，請前往開料清單重新排版',
    ru: 'Эта запись о производственной линии была удалена, пожалуйста, перейдите к списку открытых материалов для переформатирования',
    ko: '기록된 생산 라인이 삭제되었으므로 커팅 리스트 재배열로 이동하십시오.',
    bur: 'ဤမှတ်တမ်း၏ ထုတ်လုပ်မှုလိုင်းကိုဖျက်ထားသည်၊ ဖြတ်တောက်စာရင်းသွား ပြန်ပြင်ဆင်ပါ',
    ben: 'এই রেকর্ডের উৎপাদন লাইন মুছে দেওয়া হয়েছে, কাটার তালিকায় যেয়ে পুনরায় লেআউট করুন',
    tr: 'Bu kaydin uretim hatti silinmis, lutfen kesim listesine gidip yeniden dizin',
    km: 'ខ្សែផលិតកម្មនៃកំណត់ត្រានេះត្រូវបានលុប សូមទៅកាន់បញ្ជីកាត់ដើម្បីរៀបប្លង់ឡើងវិញ',
    es: 'La línea de producción de este disco ha sido eliminada, vaya a la lista de materiales para volver a diseñarlo',
    ar: 'تم حذف خط الإنتاج لهذا السجل، يرجى الانتقال إلى قائمة المواد لإعادة التخطيط',
  },
  'materialPage.fileErr': {
    zh: '解析文件内容失败，请确认文件内容!',
    en: 'Failed to parse file content. Please confirm the file content!',
    id: 'Parsing konten file gagal, harap konfirmasi konten file!',
    kz: 'Файл мазмұнын талдау сәтсіз, файл мазмұнын тексеріңіз!',
    th: 'การแยกวิเคราะห์เนื้อหาไฟล์ล้มเหลวโปรดยืนยันเนื้อหาไฟล์!',
    ug: 'ھۆججەت مەزمۇنىنى تەھلىل قىلىش مەغلۇپ بولدى، ھۆججەت مەزمۇنىنى جەزملەشتۈرۈڭ!',
    vi: 'Thất bại trong việc phân tích nội dung tệp, vui lòng kiểm tra nội dung tệp!',
    zh_tc: '解析文件內容失敗，請確認文件內容!',
    ru: 'Ошибка анализа содержимого файла, пожалуйста, подтвердите содержимое файла!',
    ko: '파일 내용을 처리하지 못했습니다. 파일 내용을 확인하십시오!',
    bur: 'ဖိုင်အကြောင်းအရာပိုင်းခွဲမှုမအောင်မြင်ပါ၊ ဖိုင်အကြောင်းအရာကိုအတည်ပြုပါ!',
    ben: 'ফাইল বিষয়বস্তু পার্স ব্যর্থ, ফাইল বিষয়বস্তু নিশ্চিত করুন!',
    tr: 'Dosya icerigi ayrıştırilamadi, lutfen dosya icerigini kontrol edin!',
    km: 'បកស្រាយខ្លឹមសារឯកសារបរាជ័យ សូមបញ្ជាក់ខ្លឹមសារឯកសារ!',
    es: 'No se pudo analizar el contenido del archivo, ¡confirme el contenido del archivo!',
    ar: 'فشل تحليل محتوى الملف، يرجى تأكيد محتوى الملف!',
  },
  'materialPage.noCheckData': {
    zh: '没有查询到数据!',
    en: 'No data found!',
    id: 'Tidak ada data yang ditemukan!',
    kz: 'Деректер табылмады!',
    th: 'ไม่พบข้อมูล!',
    ug: 'سانلىق مەلۇمات تېپىلمىدى!',
    vi: 'Không tìm thấy dữ liệu!',
    zh_tc: '沒有查詢到數據!',
    ru: 'Нет запросов на данные!',
    ko: '데이터가 검색되지 않았습니다!',
    bur: 'ဒေတာမတွေ့ပါ!',
    ben: 'কোনো ডেটা পাওয়া যায়নি!',
    tr: 'Veri bulunamadi!',
    km: 'រកមិនឃើញទិន្នន័យទេ!',
    es: '¡No se consultaron datos!',
    ar: 'لم يتم الاستعلام عن أي بيانات!',
  },
  'materialPage.noArrangeTip': {
    zh: '无法直接查看排版方案,请点击开始排版！',
    en: 'Cannot view the arrangement plan directly. Please click "Start Arranging"!',
    id: 'Jika Anda tidak dapat melihat paket tata letak secara langsung, silakan klik untuk memulai tata letak!',
    kz: 'Орнатуды тікелей қарауға болмайды, орнатуды бастауға таңдау!',
    th: 'หากคุณไม่สามารถดูแผนเลย์เอาต์ได้โดยตรงโปรดคลิกเพื่อเริ่มเค้าโครง!',
    ug: 'تەرتىپلەش پىلانىنى بىۋاستە كۆرەلمەيسىز، تەرتىپلەشنى باشلاڭ!',
    vi: 'Không thể xem trực tiếp điều hình, vui lòng nhấn Bắt đầu điều hình!',
    zh_tc: '無法直接查看排版方案,請點擊開始排版！',
    ru: 'Невозможно увидеть программу набора напрямую, нажмите, чтобы начать набор!',
    ko: '조판 방안을 직접 볼 수 없습니다. 조판 시작을 클릭하세요!',
    bur: 'ပြင်ဆင်မှုစီမံချက်ကိုတိုက်ရိုက်မကြည့်နိုင်ပါ၊ ပြင်ဆင်မှုစတင်ပါကိုနှိပ်ပါ!',
    ben: 'লেআউট পরিকল্পনা সরাসরি দেখা যাচ্ছে না, লেআউট শুরু করুন ক্লিক করুন!',
    tr: "Dizgi plani dogrudan goruntulenemez, lutfen Dizgiyi Baslat'a tiklayin!",
    km: 'មិនអាចមើលផែនការប្លង់ដោយផ្ទាល់បានទេ សូមចុចចាប់ផ្តើមប្លង់!',
    es: 'No se puede ver directamente el plano de diseño, ¡haga clic para iniciar el diseño!',
    ar: 'غير قادر على عرض خطة التخطيط مباشرة، يرجى النقر لبدء التخطيط!',
  },
  'materialPage.tooOld': {
    zh: '五六面钻设置过老',
    en: 'The five-six-sided drilling settings are too old',
    id: 'Berlian lima dan enam sisi terlalu tua',
    kz: 'Алтыжақты бұрғылау орнотуы ескі',
    th: 'เพชรห้าและหกด้านเก่าเกินไป',
    ug: 'بەش/ئالتە يۈزلىك ماتور تەڭشىكى بەك ئەسكىچە',
    vi: 'Cài đặt máy khoan 5/6 mặt quá cũ',
    zh_tc: '五六面鑽設置過老',
    ru: '5 - 6 Старение.',
    ko: '5, 6면 드릴이 너무 오래 설치되었습니다.',
    bur: 'ငါး/ခြောက်မျက်နှာဖောက်ဆက်တင်ဟောင်းနွမ်းနေသည်',
    ben: 'পাঁচ/ছয় মুখ ড্রিলের সেটিং খুব পুরনো',
    tr: 'Bes/Alti yuz matkap ayari cok eski',
    km: 'ការកំណត់ខួងប្រាំ/ប្រាំមួយផ្ទៃចាស់ពេក',
    es: 'Las configuraciones de perforación de cinco o seis lados son demasiado antiguas',
    ar: 'إعدادات الحفر الجانبية الخمسة أو الستة قديمة جدًا',
  },
  'materialPage.contactUs': {
    zh: '请联系售后人员重新对接',
    en: 'Please contact our after-sales personnel for reconnection',
    id: 'Silakan hubungi staf layanan purna jual untuk terhubung kembali dengan',
    kz: 'Техникалық қызмет көрсетушімен байланысып, қайтадан орнату',
    th: 'กรุณาติดต่อเจ้าหน้าที่บริการหลังการขายเพื่อเชื่อมต่อกับ',
    ug: 'سېتىشتىن كېيىنكى مۇلازىمەت خادىمى بىلەن ئالاقىلىشىپ قايتا بىرلەشتۈرۈڭ',
    vi: 'Vui lòng liên hệ với nhân viên hậu mãi để kết nối lại',
    zh_tc: '請聯繫售後人員重新對接',
    ru: 'Пожалуйста, свяжитесь с продавцом для повторной стыковки.',
    ko: '판매 후 담당자에게 연락하여 다시 도킹하십시오.',
    bur: 'ကျေးဇူးပြု၍ ဝန်ဆောင်မှုဝန်ထမ်းနှင့်ဆက်သွယ်ပြန်ချိတ်ဆက်ပါ',
    ben: 'অনুগ্রহ করে বিক্রয়োত্তর কর্মীদের সাথে যোগাযোগ করুন পুনরায় সংযোগ করতে',
    tr: 'Lutfen tekrar baglanti icin satis sonrasi ekiple iletisime gecin',
    km: 'សូមទាក់ទងបុគ្គលិកបន្ទាប់ពីការលក់ ដើម្បីភ្ជាប់ឡើងវិញ',
    es: 'Comuníquese con el personal de posventa para volver a conectarse',
    ar: 'يرجى الاتصال بموظفي ما بعد البيع لإعادة الاتصال',
  },
  'materialPage.pathErr': {
    zh: '板件内部存在异常数据（板号：{errorPathPlankID}），请检查！',
    en: 'There is abnormal data inside the panel (Panel Number: {errorPathPlankID}). Please check!',
    id: 'Ada data abnormal di dalam papan (nomor papan: {errorpathplankid}), silakan periksa!',
    kz: 'Панель ішінде абайлы деректер бар (панель нөмірі: {errorPathPlankID}), тексеріңіз!',
    th: 'มีข้อมูลที่ผิดปกติภายในบอร์ด (หมายเลขบอร์ด: {ErrorPathPlankId}) โปรดตรวจสอบ!',
    ug: 'تاختا ئىچىدە غەيرىي سانلىق مەلۇمات بار (تاختا نومۇرى: {errorPathPlankID})، تەكشۈرۈڭ!',
    vi: 'Tìm thấy dữ liệu bất thường bên trong tấm gỗ (hộp: {errorPathPlankID}), vui lòng kiểm tra!',
    zh_tc: '板件內部存在異常數據（板號：{errorPathPlankID}），請檢查！',
    ru: 'Внутри панели обнаружены нестандартные данные (номер панели: {errorPathPlankID}). Пожалуйста, проверьте!',
    ko: '보드 내부에 비정상 데이터가 있습니다 (보드 번호: {errorPathPlankID}). 확인하세요!',
    bur: 'ပေါ်ဒ်တွင်းတွင် မမှန်ကန်သောဒေတာရှိသည် (ပေါ်ဒ်နံပါတ်: {errorPathPlankID})၊ စစ်ဆေးပါ!',
    ben: 'বোর্ডের ভেতরে অস্বাভাবিক ডেটা আছে (বোর্ড নম্বর: {errorPathPlankID}), পরীক্ষা করুন!',
    tr: 'Panel icinde anormal veri var (Panel Numarasi: {errorPathPlankID}), lutfen kontrol edin!',
    km: 'មានទិន្នន័យមិនប្រក្រតីនៅក្នុងបន្ទះ (លេខបន្ទះ៖ {errorPathPlankID}) សូមពិនិត្យ!',
    es: 'Hay datos anormales dentro de la placa (número de placa: {errorPathPlankID}), ¡compruébelo!',
    ar: 'هناك بيانات غير طبيعية داخل اللوحة (رقم اللوحة: {errorPathPlankID})، يرجى التحقق!',
  },
  'materialPage.sizeErr': {
    zh: '存在过大板件！小板尺寸：{width}-{height}',
    en: 'There is abnormal data inside the panel, please check! Panel size：{width}-{height}',
    id: 'Piring besar yang berlebihan! Ukuran papan kecil: {width}-{height}',
    kz: 'Тақтада әдеттен тыс деректер бар, тексеріңіз! Кішкентай тақта өлшемі：{width}-{height}',
    th: 'แผ่นขนาดใหญ่มากเกินไป! ขนาดบอร์ดขนาดเล็ก: {width}-{ความสูง}',
    ug: 'بەك چوڭ تاختا بار! كىچىك تاختا ئۆلچىمى: {width}-{height}',
    vi: 'Bảng điều khiển có dữ liệu bất thường, vui lòng kiểm tra! Kích thước tấm nhỏ：{width}-{height}',
    zh_tc: '存在過大板件！小板尺寸：{width}-{height}',
    ru: 'Внутри панели обнаружены нестандартные данные, пожалуйста, проверьте! Размер панели: {width}-{height}',
    ko: '너무 큰 보드가 있습니다! 작은 보드 크기: {width}-{height}',
    bur: 'ကြီးလွန်းသောပေါ်ဒ်ရှိသည်! ပေါ်ဒ်ငယ်အရွယ်အစား: {width}-{height}',
    ben: 'অতিরিক্ত বড় বোর্ড আছে! ছোট বোর্ডের আকার: {width}-{height}',
    tr: 'Asiri buyuk panel mevcut! Kucuk panel boyutu: {width}-{height}',
    km: 'មានបន្ទះធំពេក! ទំហំបន្ទះតូច៖ {width}-{height}',
    es: '¡Existe un panel de gran tamaño! Tamaño de placa pequeña: {width}-{height}',
    ar: 'توجد لوحة كبيرة الحجم! حجم اللوحة الصغيرة: {width}-{height}',
  },
  'materialPage.noKnife': {
    zh: '未设置下料刀直径, 请前往雕刻机设置刀具!',
    en: 'The cutting tool diameter has not been set. Please go to the engraving machine to set the tool!',
    id: 'Diameter alat pemotong tidak diatur, silakan pergi ke mesin ukiran untuk mengatur alat!',
    kz: 'Кескіш діаметрі орнатылмаған, орама машинасына кескіш орнатуға барады!',
    th: 'เส้นผ่านศูนย์กลางของเครื่องมือตัดไม่ได้ตั้งค่าโปรดไปที่เครื่องแกะสลักเพื่อตั้งค่าเครื่องมือ!',
    ug: 'ماتېرىال كېسىش پىچاق دىئامېتىرى تەڭشەلمىگەن، ماتېرىال كېسىش ماشىنىسى تەڭشىكىگە بارىپ پىچاق تەڭشەڭ!',
    vi: 'Chưa cài đặt đường kính dao cắt, vui lòng đi đến máy khắc để cài đặt dao!',
    zh_tc: '未設置下料刀直徑, 請前往雕刻機設置刀具!',
    ru: 'Не установите диаметр разрезного ножа, пожалуйста, идите в гравировальную машину, чтобы установить нож!',
    ko: '원단 공구 지름이 설정되지 않았습니다. 조각기로 가서 공구를 설정하십시오!',
    bur: 'ဖြတ်ဓားဖြင်တ်မသတ်မှတ်ရသေး၊ ကြွပ်ကော်စက်သွားဓားသတ်မှတ်ပါ!',
    ben: 'কাটার ছুরির ব্যাস সেট করা হয়নি, খোদাই মেশিনে গিয়ে টুল সেট করুন!',
    tr: 'Kesim bicagi capi ayarlanmamis, lutfen oyma makinesinde bicagi ayarlayin!',
    km: 'មិនទាន់កំណត់អង្កត់ផ្ចិតកាំបិតកាត់ទេ សូមទៅកាន់ម៉ាស៊ីនឆ្លាក់ដើម្បីកំណត់ឧបករណ៍!',
    es: 'El diámetro de la cuchilla de corte no está configurado, ¡vaya a la máquina de grabado para configurar la cuchilla!',
    ar: 'لم يتم ضبط قطر سكين القطع، يرجى الذهاب إلى آلة النقش لضبط السكين!',
  },
  'materialPage.noKnifeDiameter': {
    zh: '该生产线下料刀（{name}）直径为空，请前往添加对应刀径',
    en: 'The production line cutting knife ({name}) diameter is empty, please go to add the corresponding knife diameter',
    id: 'Diameter pisau pemotong lini produksi ({name}) kosong, silakan pergi untuk menambahkan diameter pisau yang sesuai',
    kz: 'Өндірістік желі кескіш пышағының ({name}) диаметрі бос, сәйкес пышақ диаметрін қосуға өтіңіз',
    th: 'เส้นผ่านศูนย์กลางของเครื่องมือตัดสายการผลิต ({name}) ว่างเปล่าโปรดไปเพิ่มเส้นผ่านศูนย์กลางของเครื่องมือที่สอดคล้องกัน',
    ug: 'ئىشلەپچىقىرىش لىنىيىسى كېسىش پىچاقنىڭ ({name}) دىئامېتىرى بوش، سەپلىك پىچاق دىئامېتىرىنى قوشۇشقا ئۆتۈڭ',
    vi: 'Đường kính dao cắt dây chuyền sản xuất ({name}) trống, vui lòng đi thêm đường kính dao tương ứng',
    zh_tc: '該生產線下料刀（{name}）直徑為空，請前往添加對應刀徑',
    ru: 'Диаметр ножа производственной линии ({name}) пуст, пожалуйста, добавьте соответствующий диаметр ножа',
    ko: '생산 라인 재료 공구 ({name}) 지름이 비어 있습니다. 해당 재료 공구 지름을 추가하세요',
    bur: 'ဤထုတ်လုပ်မှုလိုင်း ဖြတ်ဓား ({name}) ဖြင်တ်ဗလာဖြစ်နေသည်၊ သင့်လျော်သောဓားဖြင်တ်ထည့်ရာသွားပါ',
    ben: 'উৎপাদন লাইনের কাটার ছুরি ({name}) ব্যাস খালি, সংশ্লিষ্ট ছুরির ব্যাস যোগ করতে যান',
    tr: 'Bu uretim hattindaki kesim bicaginin ({name}) capi bos, lutfen ilgili bicak capini ekleyin',
    km: 'អង្កត់ផ្ចិតកាំបិតកាត់ ({name}) នៃខ្សែផលិតកម្មនេះទទេ សូមទៅបន្ថែមអង្កត់ផ្ចិតកាំបិតដែលត្រូវគ្នា',
    es: 'El diámetro de la cuchilla de corte ({name}) de la línea de producción está vacío, vaya a agregar el diámetro de herramienta correspondiente',
    ar: 'قطر سكين القطع ({name}) لخط الإنتاج فارغ، يرجى الانتقال إلى إضافة قطر الأداة المقابلة',
  },
  'materialPage.openDifferentMaterialCuttingKnives': {
    zh: '已开启不同材质下料刀',
    en: 'Different material cutting knives have been enabled',
    id: 'Pisau pemotong material berbeda telah diaktifkan',
    kz: 'Өзгеше материал кескіш пышақтары қосылды',
    th: 'เปิดใช้งานเครื่องมือตัดวัสดุที่แตกต่างกันแล้ว',
    ug: 'ئوخشىمىغان ماتېرىيال كېسىش پىچاقلىرى قوزغىتىلدى',
    vi: 'Đã bật dao cắt vật liệu khác nhau',
    zh_tc: '已開啟不同材質下料刀',
    ru: 'Открываются ножи из разных материалов.',
    ko: '다른 재료의 재료 공구가 열렸습니다',
    bur: 'ကွဲပြားသောပစ္စည်း ဖြတ်ဓားဖွင့်ထားပြီ',
    ben: 'বিভিন্ন উপকরণের কাটার ছুরি সক্রিয় করা হয়েছে',
    tr: 'Farkli malzeme kesim bicaklari etkinlestirildi',
    km: 'បានបើកកាំបិតកាត់សម្រាប់សម្ភារៈផ្សេងៗ',
    es: 'Se habilitan diferentes cuchillas de corte de material',
    ar: 'تم تمكين سكاكين قطع المواد المختلفة',
  },
  'materialPage.sendFactorySuccess': {
    zh: '发送至车间成功',
    en: 'Successfully sent to the workshop',
    id: 'Berhasil dikirim ke lokakarya',
    kz: 'Үйіштерге тапсырыс беруді сәтті',
    th: 'ส่งไปยังเวิร์กช็อปสำเร็จ',
    ug: 'فابرىكىغا ئەۋەتىش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Gửi đến nhà máy thành công',
    zh_tc: '發送至車間成功',
    ru: 'Отправить в мастерскую успешно',
    ko: '작업장으로 전송 성공',
    bur: 'ဝပ်ရှော့သို့ပေးပို့မှုအောင်မြင်သည်',
    ben: 'ওয়ার্কশপে সফলভাবে পাঠানো হয়েছে',
    tr: 'Atolyeye gonderme basarili',
    km: 'ផ្ញើទៅសិក្ខាសាលាបានជោគជ័យ',
    es: 'Enviado exitosamente al taller',
    ar: 'تم إرسالها بنجاح إلى ورشة العمل',
  },
  'materialPage.sendFactoryErr': {
    zh: '发送车间失败，请联系售后人员请求帮助',
    en: 'Failed to send to the workshop. Please contact our after-sales personnel for assistance',
    id: 'Lokakarya pengiriman gagal, silakan hubungi staf setelah penjualan untuk bantuan',
    kz: 'Үйіштерге тапсырыс беруді сәтсіз, техникалық қызмет көрсетушімен байланысып көмек сұраңыз',
    th: 'การประชุมเชิงปฏิบัติการการจัดส่งล้มเหลวโปรดติดต่อเจ้าหน้าที่หลังการขายเพื่อขอความช่วยเหลือ',
    ug: 'فابرىكىغا ئەۋەتىش مەغلۇپ بولدى، سېتىشتىن كېيىنكى مۇلازىمەت خادىمى بىلەن ئالاقىلىشىڭ',
    vi: 'Gửi đến nhà máy thất bại, vui lòng liên hệ với nhân viên hậu mãi để được trợ giúp',
    zh_tc: '發送車間失敗，請聯繫售後人員請求幫助',
    ru: 'Не удалось отправить цех, пожалуйста, свяжитесь с послепродажным персоналом, чтобы попросить помощи',
    ko: '작업장을 보내는 데 실패했습니다. 영업 담당자에게 문의하여 도움을 요청하십시오.',
    bur: 'ဝပ်ရှော့ပေးပို့မှုမအောင်မြင်ပါ၊ ဝန်ဆောင်မှုဝန်ထမ်းနှင့်ဆက်သွယ်ကူညီတောင်းပါ',
    ben: 'ওয়ার্কশপে পাঠাতে ব্যর্থ, বিক্রয়োত্তর কর্মীদের সাথে যোগাযোগ করুন',
    tr: 'Atolyeye gonderme basarisiz oldu, lutfen yardim icin satis sonrasi ekiple iletisime gecin',
    km: 'ផ្ញើទៅសិក្ខាសាលាបរាជ័យ សូមទាក់ទងបុគ្គលិកបន្ទាប់ពីការលក់សម្រាប់ជំនួយ',
    es: 'No se pudo enviar al taller, comuníquese con el personal de posventa para obtener ayuda',
    ar: 'فشل الإرسال إلى ورشة العمل، يرجى الاتصال بموظفي ما بعد البيع للحصول على المساعدة',
  },
  'materialPage.createTaskCard': {
    zh: '是否创建对应的任务卡片?',
    en: 'Do you want to create a corresponding task card?',
    id: 'Apakah kartu tugas yang sesuai dibuat?',
    kz: 'Қайталап тапсырыс картасын yaratу ма?',
    th: 'การ์ดงานที่สอดคล้องกันถูกสร้างขึ้นหรือไม่',
    ug: 'ماس ۋەزىپە كارتا قۇرامسىز؟',
    vi: 'Có tạo thẻ nhiệm vụ tương ứng?',
    zh_tc: '是否創建對應的任務卡片?',
    ru: 'Создать соответствующую карту задач?',
    ko: '해당 작업 카드를 만드시겠습니까?',
    bur: 'သင့်ဆောင်တာဝန်ကတ်ဖန်တီးမည်လား?',
    ben: 'সংশ্লিষ্ট টাস্ক কার্ড তৈরি করবেন কি?',
    tr: 'Ilgili gorev kartini olusturmak istiyor musunuz?',
    km: 'តើត្រូវបង្កើតកាតភារកិច្ចដែលត្រូវគ្នាឬទេ?',
    es: '¿Quiere crear la tarjeta de tarea correspondiente?',
    ar: 'هل تريد إنشاء بطاقة المهمة المقابلة؟',
  },
  'materialPage.surplusStatistics': {
    zh: '可用余料共',
    en: 'Total available surplus material is',
    id: 'Total bahan residu dapat digunakan',
    kz: 'Қолданылатын қалдық материалдар',
    th: 'สามารถใช้วัสดุที่เหลือทั้งหมดได้',
    ug: 'ئىشلىتىشكە بولىدىغان قېلىنما جەمئىي',
    vi: 'Tổng số dư liệu có thể sử dụng là',
    zh_tc: '可用餘料共',
    ru: 'Всего имеющихся остатков',
    ko: '사용 가능한 여분',
    bur: 'အသုံးပြုနိုင်သောပိုလျှံပစ္စည်းစုစုပေါင်း',
    ben: 'ব্যবহারযোগ্য উদ্বৃত্ত উপকরণ মোট',
    tr: 'Kullanilabilir Artik Malzeme Toplami',
    km: 'សម្ភារៈសំណល់ដែលអាចប្រើបានសរុប',
    es: 'Se han seleccionado un total de',
    ar: 'تم اختيار إجمالي',
  },
  'materialPage.surplusStatistics2': {
    zh: '已选',
    en: 'Selected',
    id: 'Terpilih',
    kz: 'таңдалды',
    th: 'ที่เลือก',
    ug: 'تاللانغان',
    vi: 'Đã chọn',
    zh_tc: '已選',
    ru: 'Выбранные',
    ko: '선택됨',
    bur: 'ရွေးချယ်ပြီး',
    ben: 'নির্বাচিত',
    tr: 'Secildi',
    km: 'បានជ្រើស',
    es: 'materiales restantes disponibles',
    ar: 'من المواد المتبقية المتوفرة',
  },
  'materialPage.suplementStatistic': {
    zh: '块补件，可顺带补件板件共',
    en: 'supplements, can be accompanied by supplement boards in total ',
    id: 'Pengisian blok, dapat digunakan secara keseluruhan',
    kz: 'қосымшалар, жалған барлығымен қосымша тақталарымен бірге',
    th: 'การเติมเต็มบล็อกสามารถใช้งานได้โดยรวม',
    ug: 'دانە تاماملىغۇچى، ئىشلىتىشكە بولىدىغان تاماملىغۇچى تاختىسى جەمئىي',
    vi: 'Có {total} tấm gỗ bổ sung, có thể sử dụng cùng với {useable} tấm gỗ khác, đã chọn {selected} tấm',
    zh_tc: '塊補件，可順帶補件板件共',
    ru: 'Блоки, которые можно использовать вместе с дополнительными панелями, всего',
    ko: '블록 보수, 보수 판과 함께 사용할 수 있습니다',
    bur: 'ချပ်ဖြည့်ဆည်းပစ္စည်း၊ ဖြည့်ဆည်းပေါ်ဒ်ငယ်ပါနိုင်သောအားလုံး',
    ben: 'টি পরিপূরক, পরিপূরক বোর্ড সহ মোট',
    tr: 'tamamlayici parca, birlikte kullanilabilecek tamamlayici panel toplami',
    km: 'បន្ទះគ្រឿងបំពេញ អាចរួមបញ្ចូលបន្ទះគ្រឿងបំពេញសរុប',
    es: '. Se puede parchear un total de [[6]] piezas de mosaico y se puede parchear un total de',
    ar: '. يمكن ترقيع إجمالي [[6]] قطعة من الترقيع، ويمكن ترقيع إجمالي',
  },
  'materialPage.expand': {
    zh: '展开',
    en: 'Expand',
    id: 'Memperluas',
    kz: 'Кеңейту',
    th: 'ขยาย',
    ug: 'يېيىش',
    vi: 'Mở rộng',
    zh_tc: '展開',
    ru: 'развернуть',
    ko: '펼치다',
    bur: 'ဖြန့်ပြပါ',
    ben: 'প্রসারিত করুন',
    tr: 'Genislet',
    km: 'ពង្រីក',
    es: '. Expandir',
    ar: '. توسيع',
  },
  'materialPage.packUp': {
    zh: '收起',
    en: 'Collapse',
    id: 'Menutup',
    kz: 'Қайтарату',
    th: 'ปิด',
    ug: 'يىغىش',
    vi: 'Thu gọn',
    zh_tc: '收起',
    ru: 'свернуть',
    ko: '집어치우다',
    bur: 'ခေါင်းလောင်းပါ',
    ben: 'সংকুচিত করুন',
    tr: 'Daralt',
    km: 'បង្រួម',
    es: 'Contraer',
    ar: 'طي',
  },
  'materialPage.importErr': {
    zh: '请选择正确的文件!',
    en: 'Please select the correct file!',
    id: 'Pilih file yang benar!',
    kz: 'Дұрыс файл таңдаңыз!',
    th: 'โปรดเลือกไฟล์ที่ถูกต้อง!',
    ug: 'توغرا ھۆججەت تاللاڭ!',
    vi: 'Vui lòng chọn tệp chính xác!',
    zh_tc: '請選擇正確的文件!',
    ru: 'Пожалуйста, выберите правильный документ!',
    ko: '올바른 파일을 선택하십시오!',
    bur: 'မှန်ကန်သောဖိုင်ရွေးပါ!',
    ben: 'সঠিক ফাইল নির্বাচন করুন!',
    tr: 'Lutfen dogru dosyayi secin!',
    km: 'សូមជ្រើសឯកសារត្រឹមត្រូវ!',
    es: '¡Seleccione el archivo correcto!',
    ar: 'الرجاء تحديد الملف الصحيح!',
  },
  'materialPage.sendLoadingText': {
    zh: '正在处理并发送NC文件......',
    en: 'Processing and sending NC files...',
    id: 'Memproses dan mengirim file NC ...',
    kz: 'NC файлін өңдеу және жіберуде...',
    th: 'การประมวลผลและส่งไฟล์ NC ...',
    ug: 'NC ھۆججىتىنى بىر تەرەپ قىلىپ ئەۋەتىۋاتىدۇ......',
    vi: 'Đang xử lý và gửi tệp NC...',
    zh_tc: '正在處理並發送NC文件......',
    ru: 'Обрабатывается и отправляется файл NC. ......',
    ko: 'NC 파일을 처리하고 보내는 중......',
    bur: 'NC ဖိုင်ကိုလုပ်ဆောင်ပြီးပေးပို့နေသည်......',
    ben: 'NC ফাইল প্রক্রিয়া করে পাঠানো হচ্ছে......',
    tr: 'NC dosyalari isleniyor ve gonderiliyor......',
    km: 'កំពុងដំណើរការ និងផ្ញើឯកសារ NC......',
    es: 'Procesando y enviando archivos NC...',
    ar: 'معالجة وإرسال ملفات NC...',
  },
  'materialPage.arrangeLoading': {
    zh: '共计',
    en: 'A total of',
    id: 'total',
    kz: 'Барлығы',
    th: 'ทั้งหมด',
    ug: 'جەمئىي',
    vi: 'Cộng có',
    zh_tc: '共計',
    ru: 'всего',
    ko: '총계',
    bur: 'စုစုပေါင်း',
    ben: 'মোট',
    tr: 'Toplam',
    km: 'សរុប',
    es: 'Total',
    ar: 'الإجمالي',
  },
  'materialPage.arrangeLoading2': {
    zh: '张小板正在优化排版中......',
    en: 'panels are being optimized for arrangement...',
    id: 'Zhang Xiaoban mengoptimalkan tata letak ...',
    kz: 'Шағын панельдердің орнатуын оңтайландыруда...',
    th: 'Zhang Xiaoban กำลังเพิ่มประสิทธิภาพเค้าโครง ...',
    ug: 'دانە كىچىك تاختا تەرتىپلەشتە......',
    vi: 'tấm gỗ nhỏ đang được tối ưu hóa điều hình...',
    zh_tc: '張小板正在優化排版中......',
    ru: 'Панель находится в процессе оптимизации. ......',
    ko: '장소판은 조판을 최적화하는 중이다......',
    bur: 'ချပ်ပေါ်ဒ်ငယ် ပြင်ဆင်မှုကောင်းမွန်အောင်ပြုလုပ်နေသည်......',
    ben: 'টি ছোট বোর্ড লেআউট অপ্টিমাইজ করা হচ্ছে......',
    tr: 'adet kucuk panel dizgi icin optimize ediliyor......',
    km: 'បន្ទះតូចកំពុងត្រូវបានបង្កើនប្រសិទ្ធភាពសម្រាប់ប្លង់......',
    es: 'Se están optimizando tableros pequeños para la composición tipográfica...',
    ar: 'يتم تحسين اللوحات الصغيرة للتنضيد...',
  },
  'materialPage.dealing': {
    zh: '正在处理中...',
    en: 'Processing...',
    id: 'Pengolahan...',
    kz: 'Өңдеуде...',
    th: 'กำลังประมวลผล...',
    ug: 'بىر تەرەپ قىلىۋاتىدۇ...',
    vi: 'Đang xử lý...',
    zh_tc: '正在處理中...',
    ru: 'В процессе обработки. Это...',
    ko: '처리 중입니다...',
    bur: 'လုပ်ဆောင်နေသည်...',
    ben: 'প্রক্রিয়াকরণ হচ্ছে...',
    tr: 'Isleniyor...',
    km: 'កំពុងដំណើរការ...',
    es: 'Procesando...',
    ar: 'المعالجة...',
  },
  'materialPage.deleteConfirm': {
    zh: '删除后，余料将被移入余料回收站。确认要删除该余料吗？',
    en: 'After deletion, the leftover material will be moved to the Recycle Bin. Are you sure you want to delete this material?',
    id: 'Setelah dihapus, material sisa akan dipindahkan ke Tempat Sampah. Apakah Anda yakin ingin menghapus material sisa ini?',
    kz: 'Өшіргеннен кейін, қалдық материал қайта өңдеу жәшігіне жіберіледі. Бұл материалды өшіргіңіз келетініне сенімдісіз бе?',
    th: 'เมื่อทำการลบแล้ว วัสดุเหลือจะถูกย้ายไปยังถังรีไซเคิล ยืนยันการลบวัสดุเหลือนี้หรือไม่?',
    ug: 'ئۆچۈرۈلگەندىن كېيىن ئېرتىق ماتېرىيال قايتا ئىشلىتىش قۇتىسىغا يۆتكىلەيدۇ. بۇ ئېرتىق ماتېرىيالنى راست يولدىن ئۆچۈرەمسىز؟',
    vi: 'Sau khi xóa, vật liệu thừa sẽ được chuyển vào thùng rác. Bạn có chắc chắn muốn xóa vật liệu thừa này không?',
    zh_tc: '刪除後，餘料將被移入餘料回收站。是否確認刪除此餘料？',
    ru: 'После удаления остаток будет перемещен в Корзину. Вы уверены, что хотите удалить этот остаток?',
    ko: '삭제 후 남은 자재는 휴지통으로 이동됩니다. 이 자재를 정말 삭제하시겠습니까?',
    bur: 'ဖျက်လိုက်ပါက ပိုလျှံပစ္စည်းသည် အမှိုက်ပုံးသို့ ရွှေ့ပေးပါမည်။ ဤပိုလျှံပစ္စည်းကိုဖျက်ရန်သေချာပါသလား။',
    ben: 'মুছে ফেলার পর উদ্বৃত্ত উপকরণটি রিসাইকেল বিনে যাবে। আপনি কি এটি মুছে ফেলতে চান?',
    tr: 'Silindikten sonra kalan malzeme Geri Dönüşüm Kutusuna taşınacaktır. Bu malzemeyi silmek istediğinize emin misiniz?',
    km: 'បន្ទាប់ពីលុប សម្ភារៈសំណល់នឹងត្រូវបានផ្លាស់ទីទៅធុងសំរាម។ តើអ្នកប្រាកដថាចង់លុបសម្ភារៈនេះទេ?',
    es: 'Después de eliminarlo, el material sobrante se moverá a la papelera de reciclaje. ¿Estás seguro de que quieres eliminar este material sobrante?',
    ar: 'بعد الحذف، سيتم نقل المادة المتبقية إلى سلة المحذوفات. هل أنت متأكد أنك تريد حذف هذه المادة المتبقية؟',
  },
  'materialPage.copyTip': {
    zh: '即将对选中余料进行复制操作',
    en: 'About to copy the selected leftover material',
    id: 'Akan menyalin material sisa yang dipilih',
    kz: 'Таңдалған қалдық материалды көшіру әрекеті орындалады',
    th: 'กำลังจะทำการคัดลอกวัสดุที่เลือกไว้',
    ug: 'تاللانغان ئېرتىق ماتېرىيالنى كۆچۈرۈش مەشغۇلاتى باشلىنىدۇ',
    vi: 'Sắp thực hiện thao tác sao chép vật liệu còn lại đã chọn',
    zh_tc: '即將對選中餘料進行複製操作',
    ru: 'Будет выполнена операция копирования выбранного остатка.',
    ko: '선택한 나머지 항목에 대한 복제 작업 진행 중',
    bur: 'ရွေးချယ်ထားသောပိုလျှံပစ္စည်းကိုကူးယူမည်',
    ben: 'নির্বাচিত উদ্বৃত্ত উপকরণ কপি করা হবে',
    tr: 'Secilen artik malzeme kopyalanmak uzere',
    km: 'ជិតធ្វើការចម្លងសម្ភារៈសំណល់ដែលបានជ្រើស',
    es: 'Los materiales restantes seleccionados se copiarán pronto',
    ar: 'سيتم نسخ المواد المتبقية المحددة قريبًا',
  },
  'materialPage.copyTip2': {
    zh: '请确认需要复制的数量',
    en: 'Please confirm the quantity to be copied',
    id: 'Harap konfirmasi jumlah yang akan disalin',
    kz: 'Көшіру қажет санды растаңыз',
    th: 'โปรดยืนยันจำนวนที่ต้องการคัดลอก',
    ug: 'كۆچۈرۈش كېرەك بولغان ساننى جەزملەڭ',
    vi: 'Vui lòng xác nhận số lượng cần sao chép',
    zh_tc: '請確認需要複製的數量',
    ru: 'Подтвердите количество копий',
    ko: '복제할 수량을 확인하십시오.',
    bur: 'ကူးယူမည့်အရေအတွက်ကိုအတည်ပြုပါ',
    ben: 'কপি করার পরিমাণ নিশ্চিত করুন',
    tr: 'Lutfen kopyalanacak miktari onaylayin',
    km: 'សូមបញ្ជាក់បរិមាណដែលត្រូវចម្លង',
    es: 'Confirme la cantidad a copiar',
    ar: 'يرجى تأكيد الكمية المراد نسخها',
  },
  'materialPage.surplusHead.shape': {
    zh: '形状',
    en: 'Shape',
    id: 'membentuk',
    kz: 'Көрінісі',
    th: 'รูปร่าง',
    ug: 'شەكىل',
    vi: 'Hình dạng',
    zh_tc: '形狀',
    ru: 'форма',
    ko: '모양',
    bur: 'ပုံသဏ္ဍာန်',
    ben: 'আকৃতি',
    tr: 'Sekil',
    km: 'រូបរាង',
    es: 'Forma',
    ar: 'الشكل',
  },
  'materialPage.surplusHead.type': {
    zh: '类型',
    en: 'Type',
    id: 'jenis',
    kz: 'Түрі',
    th: 'พิมพ์',
    ug: 'تىپ',
    vi: 'Loại',
    zh_tc: '類型',
    ru: 'тип',
    ko: '유형',
    bur: 'အမျိုးအစား',
    ben: 'ধরন',
    tr: 'Tur',
    km: 'ប្រភេទ',
    es: 'Tipo',
    ar: 'النوع',
  },
  'materialPage.surplusHead.remark': {
    zh: '备注',
    en: 'Remarks',
    id: 'Komentar',
    kz: 'Ескерту',
    th: 'คำพูด',
    ug: 'ئىزاھات',
    vi: 'Ghi chú',
    zh_tc: '備註',
    ru: 'примечание',
    ko: '비고',
    bur: 'မှတ်ချက်',
    ben: 'মন্তব্য',
    tr: 'Not',
    km: 'ចំណាំ',
    es: 'Comentarios',
    ar: 'ملاحظة',
  },
  'materialPage.surplusHead.area': {
    zh: '面积(m²)',
    en: 'Area(m²)',
    id: 'Area',
    kz: 'Өлшем (м²)',
    th: 'พื้นที่ (m²)',
    ug: 'يەر مەيدانى(m²)',
    vi: 'Diện tích (m²)',
    zh_tc: '面積(m²)',
    ru: 'Площадь (м²)',
    ko: '면적(m²)',
    bur: 'ဧရိယာ(m²)',
    ben: 'ক্ষেত্রফল(m²)',
    tr: 'Alan(m²)',
    km: 'ផ្ទៃក្រឡា(m²)',
    es: 'Área (m²)',
    ar: 'المساحة (م²)',
  },
  'materialPage.surplusHead.area1': {
    zh: '面积',
    en: 'Area',
    id: 'Pembaruan ini telah mengoptimalkan metode pengaitan pada bagian belakang papan besar. Sekarang, Anda dapat langsung menutup sisi dan membuat lubang sesuai dengan informasi pada label. Silakan informasikan!',
    kz: 'Өлшем',
    th: 'พื้นที่',
    ug: 'يەر مەيدانى',
    vi: 'Diện tích',
    zh_tc: '面積',
    ru: 'площадь',
    ko: '면적',
    bur: 'ဧရိယာ',
    ben: 'ক্ষেত্রফল',
    tr: 'Alan',
    km: 'ផ្ទៃក្រឡា',
    es: 'Área',
    ar: 'المنطقة',
  },
  'materialPage.surplusTip': {
    zh: '暂无可用余料，您可以先去',
    en: 'There is no available surplus material at the moment. You can go to',
    id: 'Tidak ada bahan yang tersisa yang tersedia, Anda bisa pergi dulu',
    kz: 'Қолданылатын қалдық материалдар жоқ, алдын ала',
    th: 'ไม่มีวัสดุที่เหลืออยู่คุณสามารถไปก่อน',
    ug: 'ئىشلىتىشكە بولىدىغان قېلىنما يوق، ئاۋۋال',
    vi: 'Không có vật liệu dư thừa nào. Bạn có thể đi đến',
    zh_tc: '暫無可用餘料，您可以先去',
    ru: 'Пока нет свободных остатков, вы можете пойти первым',
    ko: '잠시 쓸만한 여분이 없으니, 당신은 먼저 가셔도 됩니다.',
    bur: 'အသုံးပြုနိုင်သောပိုလျှံပစ္စည်းမရှိသေး၊ ကြိုတင်သွားနိုင်သည်',
    ben: 'এখন ব্যবহারযোগ্য উদ্বৃত্ত উপকরণ নেই, আপনি প্রথমে যেতে পারেন',
    tr: 'Su anda kullanilabilir artik malzeme yok, once sunaya gidebilirsiniz',
    km: 'បច្ចុប្បន្នមិនមានសម្ភារៈសំណល់ដែលអាចប្រើបានទេ អ្នកអាចទៅកាន់',
    es: 'No hay material restante disponible, puede ir a',
    ar: 'لا توجد مواد متبقية متاحة، يمكنك الانتقال إلى',
  },
  'materialPage.creatSurplus': {
    zh: '新建余料',
    en: 'Create New Surplus',
    id: 'Bahan baru yang tersisa',
    kz: 'Қалдық материал жаңадан құру',
    th: 'วัสดุที่เหลืออยู่ใหม่',
    ug: 'يېڭى قېلىنما قۇرۇش',
    vi: 'Tạo Dư thừa',
    zh_tc: '新建餘料',
    ru: 'Новые излишки',
    ko: '새 잉여 재료',
    bur: 'ပိုလျှံပစ္စည်းအသစ်ဖန်တီးပါ',
    ben: 'নতুন উদ্বৃত্ত উপকরণ তৈরি করুন',
    tr: 'Yeni Artik Malzeme Olustur',
    km: 'បង្កើតសម្ភារៈសំណល់ថ្មី',
    es: 'Crear un nuevo material restante',
    ar: 'إنشاء مادة متبقية جديدة',
  },
  'materialPage.orderInfo': {
    zh: '订单信息',
    en: 'Order information',
    id: 'Informasi pesanan',
    kz: 'Тапсырыс ақпараты',
    th: 'สั่งซื้อข้อมูล',
    ug: 'زاكاز ئۇچۇرى',
    vi: 'Thông tin Đơn hàng',
    zh_tc: '訂單信息',
    ru: 'Информация о заказе',
    ko: '주문 정보',
    bur: 'အော်ဒါသတင်း',
    ben: 'অর্ডার তথ্য',
    tr: 'Siparis Bilgisi',
    km: 'ព័ត៌មានការបញ្ជាទិញ',
    es: 'Información del pedido',
    ar: 'معلومات الطلب',
  },
  'materialPage.suplement.statistic': {
    zh: '共{total}块补件，可顺带补件板件共{useable}块，已选{selected}块',
    en: 'There are {total} replacement parts in total, {useable} of which can be used as spare panels, and {selected} have been selected.',
    id: 'Total {total} blok digunakan, dan total {} blok} digunakan. {Pilihan} blok dipilih.',
    kz: 'Жалпы {total} پارça толықтырушы материал, {useable} پارча толықтырушы материалды бірге жіберуге болады, {selected} парча таңдалды',
    th: 'มีการใช้บล็อกทั้งหมด {Total} และใช้บล็อกทั้งหมด {useable}} {เลือกบล็อกที่เลือก}',
    ug: 'جەمئىي{total}دانە تاماملىغۇچى، ئىشلىتىشكە بولىدىغان تاماملىغۇچى تاختىسى {useable}دانە، تاللانغان{selected}دانە',
    vi: 'Tổng cộng {total} bộ phận bổ sung, {useable} có thể được giao cùng, {selected} đã chọn',
    zh_tc: '共{total}塊補件，可順帶補件板件共{useable}塊，已選{selected}塊',
    ru: 'Всего {total} дополнений, из которых {useable} можно использовать в качестве дополнительных панелей, и {selected} выбраны',
    ko: '총 {total} 개의 보수 판, {useable} 개의 보수 판을 포함할 수 있으며, {selected} 개의 판이 선택되었습니다.',
    bur: 'ဖြည့်ဆည်းပစ္စည်း {total} ချပ်၊ ဖြည့်ဆည်းပေါ်ဒ် {useable} ချပ်ပါနိုင်သည်၊ {selected} ချပ်ရွေးပြီး',
    ben: 'মোট {total} টি পরিপূরক, {useable} টি পরিপূরক বোর্ড সহ পাঠানো যাবে, {selected} টি নির্বাচিত',
    tr: 'Toplam {total} tamamlayici parca var, {useable} tamamlayici panel birlikte kullanilabilir, {selected} secildi',
    km: 'មានគ្រឿងបំពេញសរុប {total} បន្ទះ អាចប្រើរួមបាន {useable} បន្ទះ បានជ្រើស {selected} បន្ទះ',
    es: 'Un total de {total} piezas de patchwork, se pueden parchar un total de {useable} piezas de paneles, {selected} piezas han sido seleccionadas',
    ar: 'إجمالي {total} قطع الترقيع، إجمالي {useable} يمكن تصحيح قطع الألواح، تم تحديد {selected} القطع',
  },
  'materialPage.suplement.exportSuplement': {
    zh: '导出补件清单',
    en: 'Export Replacement Parts List',
    id: 'Ekspor daftar suplemen',
    kz: 'Толықтырушы материалдар тізімін экспорттау',
    th: 'ส่งออกรายการเสริม',
    ug: 'تاماملىغۇچى تىزىملىكىنى چىقىرىش',
    vi: 'Xuất danh sách bổ sung',
    zh_tc: '導出補件清單',
    ru: 'Экспорт списка дополнений',
    ko: '패치 목록 내보내기',
    bur: 'ဖြည့်ဆည်းစာရင်းထုတ်ပါ',
    ben: 'পরিপূরক তালিকা রপ্তানি করুন',
    tr: 'Tamamlayici Parca Listesini Disa Aktar',
    km: 'នាំចេញបញ្ជីគ្រឿងបំពេញ',
    es: 'Exportar la lista de patchwork',
    ar: 'تصدير قائمة الترقيع',
  },
  'materialPage.suplement.suplementLoading': {
    zh: '补件数据加载中',
    en: 'Loading Replacement Parts Data',
    id: 'Data suplemen sedang memuat',
    kz: 'Толуктырушы материалдар деректері жүктеледі',
    th: 'ข้อมูลเสริมกำลังโหลด',
    ug: 'تاماملىغۇچى سانلىق مەلۇماتى يۈكلىنىۋاتىدۇ',
    vi: 'Đang tải dữ liệu bổ sung',
    zh_tc: '補件數據加載中',
    ru: 'Данные дополнения загружаются',
    ko: '패치 데이터 로드 중',
    bur: 'ဖြည့်ဆည်းဒေတာတင်နေသည်',
    ben: 'পরিপূরক ডেটা লোড হচ্ছে',
    tr: 'Tamamlayici Parca Verileri Yukleniyor',
    km: 'កំពុងផ្ទុកទិន្នន័យគ្រឿងបំពេញ',
    es: 'Cargando datos de parches',
    ar: 'تحميل بيانات التصحيح',
  },
  'materialPage.suplement.exportSuplementIng': {
    zh: '补件清单正在导出',
    en: 'Exporting Supplement List',
    id: 'Daftar suplemen sedang diekspor',
    kz: 'Қосымша тізімді экспорттау',
    th: 'รายการอาหารเสริมกำลังถูกส่งออก',
    ug: 'تاماملىغۇچى تىزىملىكى چىقىرىلىۋاتىدۇ',
    vi: 'Đang xuất danh sách bổ sung',
    zh_tc: '補件清單正在導出',
    ru: 'Список дополнений экспортируется',
    ko: '패치 목록 내보내기 중',
    bur: 'ဖြည့်ဆည်းစာရင်းထုတ်နေသည်',
    ben: 'পরিপূরক তালিকা রপ্তানি হচ্ছে',
    tr: 'Tamamlayici Parca Listesi Disa Aktariliyor',
    km: 'កំពុងនាំចេញបញ្ជីគ្រឿងបំពេញ',
    es: 'La lista de parches se está exportando',
    ar: 'يتم تصدير قائمة التصحيح',
  },
  'materialPage.suplement.noMatchSup': {
    zh: '未能匹配到可使用的补件数据',
    en: 'No matching usable supplemental data found',
    id: 'Gagal mencocokkan data suplemen yang tersedia',
    kz: 'Пайдаланылуға қолдау келтіретін қосымша деректер табылмады',
    th: 'ไม่สามารถจับคู่ข้อมูลเสริมที่มีอยู่ได้',
    ug: 'ئىشلىتىشكە بولىدىغان تاماملىغۇچى سانلىق مەلۇماتى تېپىلمىدى',
    vi: 'Không tìm thấy dữ liệu bổ sung phù hợp',
    zh_tc: '未能匹配到可使用的補件數據',
    ru: 'Не удалось согласовать данные с имеющимися дополнениями',
    ko: '사용 가능한 패치 데이터와 일치하지 않음',
    bur: 'အသုံးပြုနိုင်သောဖြည့်ဆည်းဒေတာမတွေ့ပါ',
    ben: 'ব্যবহারযোগ্য পরিপূরক ডেটা পাওয়া যায়নি',
    tr: 'Kullanilabilir eslesen tamamlayici veri bulunamadi',
    km: 'រកមិនឃើញទិន្នន័យគ្រឿងបំពេញដែលអាចប្រើបានទេ',
    es: 'No se pudieron coincidir los datos de parche utilizables',
    ar: 'فشلت مطابقة بيانات التصحيح القابلة للاستخدام',
  },
  'materialPage.suplement.exportTip': {
    zh: '请至少选中一块补件再进行导出',
    en: 'Please select at least one supplement before exporting',
    id: 'Pilih setidaknya satu pengisian sebelum mengekspor',
    kz: 'Экспорттау алдында кем дегенде бір қосымша таңдаңыз',
    th: 'โปรดเลือกการเติมเต็มอย่างน้อยหนึ่งครั้งก่อนส่งออก',
    ug: 'كەم دېگەندە بىر تاماملىغۇچى تاللاپ چىقىرىڭ',
    vi: 'Vui lòng chọn ít nhất một bộ phận bổ sung trước khi xuất',
    zh_tc: '請至少選中一塊補件再進行導出',
    ru: 'Выберите хотя бы одно дополнение для экспорта',
    ko: '하나 이상의 패치를 선택한 다음 내보내기',
    bur: 'ဖြည့်ဆည်းပစ္စည်းအနည်းဆုံးတစ်ခုရွေးပြီးထုတ်ပါ',
    ben: 'রপ্তানির আগে অন্তত একটি পরিপূরক নির্বাচন করুন',
    tr: 'Lutfen disa aktarmadan once en az bir tamamlayici parca secin',
    km: 'សូមជ្រើសគ្រឿងបំពេញយ៉ាងហោចណាស់មួយ មុននឹងនាំចេញ',
    es: 'Seleccione al menos un parche antes de exportar',
    ar: 'يرجى تحديد رقعة واحدة على الأقل قبل التصدير',
  },
  'materialPage.empty': {
    zh: '暂无板件数据',
    en: 'No panel data available',
    id: 'Belum ada data papan',
    kz: 'Панельдердің деректері жоқ',
    th: 'ยังไม่มีข้อมูลบอร์ด',
    ug: 'ھازىرچە تاختا سانلىق مەلۇماتى يوق',
    vi: 'Không có dữ liệu bảng',
    zh_tc: '暫無板件數據',
    ru: 'Нет данных',
    ko: '보드 데이터 없음',
    bur: 'ပေါ်ဒ်ဒေတာမရှိသေး',
    ben: 'কোনো বোর্ড ডেটা নেই',
    tr: 'Panel Verisi Yok',
    km: 'មិនមានទិន្នន័យបន្ទះទេ',
    es: 'Aún no hay datos de placa',
    ar: 'لا توجد بيانات لوحة حتى الآن',
  },
  'materialPage.paibanSetting.title': {
    zh: '排版设置',
    en: 'Nesting Settings',
    id: 'Penyusunan huruf',
    kz: 'Орнатуды орноту',
    th: 'การเรียงพิมพ์',
    ug: 'تەرتىپلەش تەڭشىكى',
    vi: 'Cài đặt Bố trí',
    zh_tc: '排版設置',
    ru: 'Параметры набора',
    ko: '조판 설정',
    bur: 'ပြင်ဆင်မှုဆက်တင်',
    ben: 'লেআউট সেটিংস',
    tr: 'Dizgi Ayarlari',
    km: 'ការកំណត់ប្លង់',
    es: 'Configuración de diseño',
    ar: 'إعدادات التخطيط',
  },
  'materialPage.paibanSetting.createTask': {
    zh: '创建排版任务',
    en: 'Create Nest Task',
    id: 'Buat Tugas Penyusunan Huruf',
    kz: 'Орнату тапсырысын құру',
    th: 'สร้างงานการเรียงพิมพ์',
    ug: 'تەرتىپلەش تاپسىرىسىنى ئىشلاش',
    vi: 'Tạo Nhiệm vụ Bố trí',
    zh_tc: '創建排版任務',
    ru: 'Создать задачу набора',
    ko: '조판 작업 생성',
    bur: 'ပြင်ဆင်မှုဆက်တင်အလိုအလျောက်ဖြတ်',
    ben: 'লেআউট কাজ সৃষ্টি',
    tr: 'Dizgi Görev Oluştur',
    km: 'បង្កើតការបង្កើតប្លង់',
  },
  'materialPage.paibanSetting.selectProduction': {
    zh: '生产线选择',
    en: 'Production Line',
    id: 'Pemilihan lini produksi',
    kz: 'Өндірістік желі таңдау',
    th: 'การเลือกสายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيىسى تاللاش',
    vi: 'Chọn Dây chuyền Sản xuất',
    zh_tc: '生產線選擇',
    ru: 'Выбор производственных линий',
    ko: '생산라인 선택',
    bur: 'ထုတ်လုပ်မှုလိုင်းရွေးချယ်ပါ',
    ben: 'উৎপাদন লাইন নির্বাচন',
    tr: 'Uretim Hatti Secimi',
    km: 'ជ្រើសរើសខ្សែផលិតកម្ម',
    es: 'Selección de línea de producción',
    ar: 'اختيار خط الإنتاج',
  },
  'materialPage.paibanSetting.arrangeWay': {
    zh: '排版方案选择',
    en: 'Nesting Mode',
    id: 'Pemilihan Solusi Pengesahan',
    kz: 'Орнату схемасы таңдау',
    th: 'การเลือกโซลูชันการเรียงพิมพ์',
    ug: 'تەرتىپلەش پىلانى تاللاش',
    vi: 'Chọn Phương pháp Bố trí',
    zh_tc: '排版方案選擇',
    ru: 'Выбор типографского варианта',
    ko: '레이아웃 옵션',
    bur: 'ပြင်ဆင်မှုစီမံချက်ရွေးချယ်ပါ',
    ben: 'লেআউট পরিকল্পনা নির্বাচন',
    tr: 'Dizgi Plani Secimi',
    km: 'ជ្រើសរើសផែនការប្លង់',
    es: 'Selección de esquema de diseño',
    ar: 'اختيار مخطط التخطيط',
  },
  'materialPage.paibanSetting.suitText': {
    zh: '适用于：',
    en: '',
    id: 'Berlaku untuk：',
    kz: 'Қолданылады：',
    th: 'ใช้ได้กับ：',
    ug: 'ئىشلىتىش：',
    vi: 'Áp dụng cho：',
    zh_tc: '適用於：',
    ru: 'подходит для：',
    ko: '적용 가능한：',
    bur: 'သင့်တော်သည်：',
    ben: 'উপযুক্ত：',
    tr: 'Icin Uygun：',
    km: 'សមស្របសម្រាប់：',
    es: 'Aplicable a：',
    ar: 'ينطبق على：',
  },
  'materialPage.paibanSetting.surplusTrimTip': {
    zh: '注意：您使用了余料自定义修边功能，仅可选择锯切排版',
    en: 'Attention: You have used the custom trimming function for surplus materials, only sawing layout can be selected',
    id: 'Catatan: Anda telah menggunakan fungsi pemangkasan kustom untuk bahan sisa, hanya tata letak gergaji yang dapat dipilih',
    kz: 'Ескерту: Сіз қалдық материалдар үшін теңшелетін кесу функциясын пайдаландыңыз, тек ара кесу орналастыруын таңдауға болады',
    th: 'หมายเหตุ: คุณได้ใช้ฟังก์ชันการตัดแต่งแบบกำหนดเองสำหรับวัสดุส่วนเกิน สามารถเลือกเค้าโครงเลื่อยเท่านั้น',
    ug: 'ئەسكەرتىش: سىز قوشۇمچە ماتېرىياللار ئۈچۈن ئىختىيارىي كېسىش فۇنكسىيىسىنى ئىشلىتىپ قالدىڭىز، پەقەت ئارا كېسىش تەرتىپلەشىنى تاللىيالايسىز',
    vi: 'Lưu ý: Bạn đã sử dụng chức năng cắt tùy chỉnh cho vật liệu thừa, chỉ có thể chọn bố trí cưa',
    zh_tc: '注意：您使用了餘料自定義修邊功能，僅可選擇鋸切排版',
    ru: 'Примечание: Вы используете функцию настройки обрезки излишков, вы можете выбрать только пилу',
    ko: '참고: 남은 재료의 사용자 정의 모서리 수정 기능을 사용하여 조판 톱질만 선택할 수 있습니다.',
    bur: 'သတိ: ပိုလျှံပစ္စည်းကိုယ်တိုင်ဘေးဖြတ်လုပ်ဆောင်မှုသုံးနေ၊ ဓားပုတ်မြောင်းပြင်ဆင်မှုသာရွေးနိုင်',
    ben: 'নোট: আপনি উদ্বৃত্ত উপকরণের কাস্টম ট্রিমিং ফিচার ব্যবহার করছেন, শুধুমাত্র করাত কাটার লেআউট নির্বাচন করা যাবে',
    tr: 'Not: Artik malzeme icin ozel kirpma ozelligini kullandiniz, yalnizca testere kesim dizgisi secilebilir',
    km: 'ចំណាំ៖ អ្នកបានប្រើមុខងារកាត់គែមផ្ទាល់ខ្លួនសម្រាប់សម្ភារៈសំណល់ ដូច្នេះអាចជ្រើសបានតែប្លង់កាត់ដោយរណារ',
    es: 'Nota: Ha utilizado la función de recorte personalizado de material residual, solo se puede seleccionar el diseño de aserrado',
    ar: 'ملاحظة: لقد استخدمت وظيفة التشذيب المخصصة للمواد المتبقية، ويمكن تحديد تخطيط النشر فقط',
  },
  'materialPage.paibanSetting.suitEquipmentNormal': {
    zh: '常规雕刻机',
    en: 'For standard engravers',
    id: 'Mesin ukiran konvensional',
    kz: 'Қалыпты орама машина',
    th: 'เครื่องแกะสลักทั่วไป',
    ug: 'ئادەتتىكى ماتېرىال كېسىش ماشىنىسى',
    vi: 'Máy Khắc thông thường',
    zh_tc: '常規雕刻機',
    ru: 'Обычная гравировальная машина',
    ko: '일반 조각기',
    bur: 'ပုံမှန်ကြွပ်ကော်စက်',
    ben: 'সাধারণ খোদাই মেশিন',
    tr: 'Standart Oyma Makinesi',
    km: 'ម៉ាស៊ីនឆ្លាក់ធម្មតា',
    es: 'Máquina de grabado convencional',
    ar: 'آلة النقش التقليدية',
  },
  'materialPage.paibanSetting.suitEquipmentSpecial': {
    zh: '玻璃切割机、锯片切割机',
    en: 'For glass & saw blade cutters',
    id: 'Mesin pemotong kaca, mesin pemotong pisau gergaji',
    kz: 'Шыны кескіш машина, пісік кескіш машина',
    th: 'เครื่องตัดแก้วเครื่องตัดใบมีด',
    ug: 'ئەينەك كېسىش ماشىنىسى، ئارا ماشىنىسى',
    vi: 'Máy Cắt Kính, Máy Cắt Gỗ',
    zh_tc: '玻璃切割機、鋸片切割機',
    ru: 'Стеклорежущий станок',
    ko: '유리 절단기, 톱날 절단기',
    bur: 'မှန်ဖြတ်စက်၊ ဓားရွက်ဖြတ်စက်',
    ben: 'কাচ কাটার মেশিন, করাত মেশিন',
    tr: 'Cam Kesim Makinesi, Testere Kesim Makinesi',
    km: 'ម៉ាស៊ីនកាត់កញ្ចក់ ម៉ាស៊ីនកាត់ដោយផ្លិតរណារ',
    es: 'Vidrio máquina cortadora, máquina cortadora de hojas de sierra',
    ar: 'آلة قطع الزجاج، آلة قطع شفرة المنشار',
  },
  'materialPage.paibanSetting.lessRoll': {
    zh: '少翻板',
    en: 'Min Flips',
    id: 'Lebih sedikit cetak ulang',
    kz: 'Аз айналдыру',
    th: 'พิมพ์ซ้ำน้อยลง',
    ug: 'ئاز ئۆرۈلۈش',
    vi: 'Ít Lật',
    zh_tc: '少翻板',
    ru: 'Меньше копий',
    ko: '적게 복제하다',
    bur: 'ပြောင်းဘက်နည်းနည်း',
    ben: 'কম উল্টানো',
    tr: 'Daha Az Cevirme',
    km: 'បង្វិលតិច',
    es: 'Menos copias',
    ar: 'نسخ أقل',
  },
  'materialPage.paibanSetting.computedSpecial': {
    zh: '计算异形',
    en: 'Calculate Shapes',
    id: 'Hitung bentuknya',
    kz: 'Кешелікті есептеу',
    th: 'คำนวณรูปร่าง',
    ug: 'ئالاھىدە ھېسابلاش',
    vi: 'Tính toán Đặc biệt',
    zh_tc: '計算異形',
    ru: 'Расчетный гетероморфизм',
    ko: '이형을 계산하다',
    bur: 'အထူးပုံတွက်ချက်ပါ',
    ben: 'বিশেষ আকৃতি গণনা করুন',
    tr: 'Ozel Sekilleri Hesapla',
    km: 'គណនារាងមិនទៀងទាត់',
    es: 'Cálculo de formas especiales',
    ar: 'حساب الأشكال الخاصة',
  },
  'materialPage.paibanSetting.specialTip': {
    zh: '影响排版速度',
    en: 'Slower',
    id: 'Mempengaruhi kecepatan tata letak',
    kz: 'Төмен жылдамдық',
    th: 'มีอิทธิพลต่อความเร็วของเค้าโครง',
    ug: 'تەرتىپلەش سۈرئىتىگە تەسىر قىلىدۇ',
    vi: 'Tốc độ thấp',
    zh_tc: '影響排版速度',
    ru: 'Влияние на скорость набора',
    ko: '조판 속도에 영향을 주다',
    bur: 'ပြင်ဆင်မှုအမြန်နှုန်းကိုသက်ရောက်',
    ben: 'লেআউট গতিকে প্রভাবিত করে',
    tr: 'Dizgi Hizini Etkiler',
    km: 'ប៉ះពាល់ដល់ល្បឿនប្លង់',
    es: 'Afecta la velocidad de composición',
    ar: 'يؤثر على سرعة التنضيد',
  },
  'materialPage.paibanSetting.irregularNesting': {
    zh: '异形嵌套',
    en: 'Irregular Nesting',
    id: 'Bersarang khusus',
    kz: 'Анықтылықсыз Күміс',
    th: 'การทำรังพิเศษ',
    ug: 'ئالاھىدە تۈزۈلۈش',
    vi: 'Săn lùng bất quy tắc',
    zh_tc: '異形嵌套',
    ru: 'Экзотическая вставка',
    ko: '이형 중첩',
    bur: 'အထူးပုံပေါင်းစပ်',
    ben: 'অনিয়মিত নেস্টিং',
    tr: 'Duzensiz Ic Ice Dizilim',
    km: 'ការរៀបចំជាន់គ្នាមិនទៀងទាត់',
    es: 'Anidamiento de formas especiales',
    ar: 'تداخل الأشكال الخاصة',
  },
  'materialPage.paibanSetting.primaryNesting': {
    zh: '普通嵌套',
    en: 'Basic Nest',
    id: 'Bersarang normal',
    kz: 'Бастапқы Күміс',
    th: 'การทำรังปกติ',
    ug: 'ئادەتتىكى تۈزۈلۈش',
    vi: 'Săn lùng chính',
    zh_tc: '普通嵌套',
    ru: 'Обычная вставка',
    ko: '일반 중첩',
    bur: 'ပုံမှန်ပေါင်းစပ်',
    ben: 'প্রাথমিক নেস্টিং',
    tr: 'Normal Ic Ice Dizilim',
    km: 'ការរៀបចំជាន់គ្នាធម្មតា',
    es: 'Anidamiento normal',
    ar: 'التداخل العادي',
  },
  'materialPage.paibanSetting.specialShapedPanel': {
    zh: '异形嵌普通板',
    en: 'Shape + Standard',
    id: 'Papan biasa tertanam berbentuk khusus',
    kz: 'Арнайы Шәке',
    th: 'บอร์ดธรรมดาที่มีรูปทรงพิเศษ',
    ug: 'ئالاھىدە تۈزۈلگەن ئادەتتىكى تاختا',
    vi: 'Bảng hình dạng đặc biệt',
    zh_tc: '異形嵌普通板',
    ru: 'фасонная вставка',
    ko: '이형감 일반판',
    bur: 'အထူးပုံပုံမှန်ပေါ်ဒ်ပေါင်းစပ်',
    ben: 'বিশেষ আকৃতির সাধারণ বোর্ড নেস্টিং',
    tr: 'Ozel Sekilli Paneli Normal Panele Gom',
    km: 'បន្ទះរាងពិសេសជាន់ក្នុងបន្ទះធម្មតា',
    es: 'Forma especial incrustado en tablero ordinario',
    ar: 'الشكل الخاص المضمن في اللوحة العادية',
  },
  'materialPage.paibanSetting.limitedTimeTrial': {
    zh: '限免',
    en: 'LTF',
    id: 'Limited Free',
    kz: 'Limited Free',
    th: 'Limited Free',
    ug: 'Limited Free',
    vi: 'Limited Free',
    zh_tc: '限免',
    ru: 'Limited Free',
    ko: 'Limited Free',
    bur: 'Limited Free',
    ben: 'Limited Free',
    tr: 'Limited Free',
    km: 'Limited Free',
    es: 'Exención limitada',
    ar: 'إعفاء محدود',
  },
  'materialPage.paibanSetting.seniorShape': {
    zh: '高级嵌套',
    en: 'Advanced Nest',
    id: 'Sarang lanjutan',
    kz: 'Басшылық Шәке',
    th: 'การทำรังขั้นสูง',
    ug: 'ئالى تۈزۈلۈش',
    vi: 'Hình dạng cao cấp',
    zh_tc: '高級嵌套',
    ru: 'Расширенная вставка',
    ko: '고급 중첩',
    bur: 'မြင့်မားသောပေါင်းစပ်',
    ben: 'উন্নত নেস্টিং',
    tr: 'Gelismis Ic Ice Dizilim',
    km: 'ការរៀបចំជាន់គ្នាកម្រិតខ្ពស់',
    es: 'Anidamiento avanzado',
    ar: 'التداخل المتقدم',
  },
  'materialPage.paibanSetting.heteromorphicInlay': {
    zh: '异形嵌异形',
    en: 'Shape + Shape',
    id: 'Bentuk khusus tertanam',
    kz: 'Өзгеріс Шәке',
    th: 'รูปร่างพิเศษฝัง',
    ug: 'ئالاھىدە تۈزۈلگەن ئالاھىدە تاختا',
    vi: 'Phông lắp vào dị hình',
    zh_tc: '異形嵌異形',
    ru: 'Асимметричная мозаика',
    ko: '이형감이형',
    bur: 'အထူးပုံအထူးပုံပေါင်းစပ်',
    ben: 'বিশেষ আকৃতির ভেতরে বিশেষ আকৃতি নেস্টিং',
    tr: 'Ozel Sekilli Ic Ice Gomulu',
    km: 'ការដាក់បញ្ចូលរាងមិនទៀងទាត់ក្នុងរាងមិនទៀងទាត់',
    es: 'Forma especial incrustado en forma especial',
    ar: 'الشكل الخاص المضمن في الأشكال الخاصة',
  },
  'materialPage.paibanSetting.autoCutSurplus': {
    zh: '余料自动裁剪',
    en: 'Auto Trim Offcuts',
    id: 'Pemotongan bahan residu otomatis',
    kz: 'Қалдық материал автоматты кесу',
    th: 'การตัดวัสดุที่เหลือโดยอัตโนมัติ',
    ug: 'قالدۇق ماتېرىال ئاپتوماتىك كېسىش',
    vi: 'Tự động Cắt Vật liệu dư thừa',
    zh_tc: '餘料自動裁剪',
    ru: 'Автообрезка излишков',
    ko: '남은 재료는 자동으로 재단한다.',
    bur: 'ပိုလျှံပစ္စည်းအလိုအလျောက်ဖြတ်',
    ben: 'উদ্বৃত্ত উপকরণ স্বয়ংক্রিয় কাটা',
    tr: 'Artik Malzemeyi Otomatik Kes',
    km: 'កាត់សម្ភារៈសំណល់ដោយស្វ័យប្រវត្តិ',
    es: 'Recorte automático del material restante',
    ar: 'الاقتصاص التلقائي للمواد المتبقية',
  },
  'materialPage.paibanSetting.cutWay': {
    zh: '裁剪方式',
    en: 'Cutting Method',
    id: 'Metode penanaman',
    kz: 'Кесу әдісі',
    th: 'วิธีการปลูกพืช',
    ug: 'كېسىش ئۇسۇلى',
    vi: 'Phương pháp Cắt',
    zh_tc: '裁剪方式',
    ru: 'Способ обрезки',
    ko: '재단 방식',
    bur: 'ဖြတ်တောက်နည်း',
    ben: 'কাটার পদ্ধতি',
    tr: 'Kesim Yontemi',
    km: 'វិធីកាត់',
    es: 'Método de recorte',
    ar: 'طريقة الاقتصاص',
  },
  'materialPage.paibanSetting.maxRect': {
    zh: '裁剪为最大矩形',
    en: 'Cut into Maximum Rectangle',
    id: 'Dipotong ke persegi panjang terbesar',
    kz: 'Ең үлкен тікбұрышты кесу',
    th: 'ถูกครอบตัดเป็นสี่เหลี่ยมที่ใหญ่ที่สุด',
    ug: 'ئەڭ چوڭ تۆت تەرەپلىك شەكلىگە كېسىش',
    vi: 'Cắt thành Hình chữ nhật Tối đa',
    zh_tc: '裁剪為最大矩形',
    ru: 'Вырезать максимальный прямоугольник',
    ko: '최대 사각형으로 자르기',
    bur: 'အများဆုံးတစ်ထောင့်မှန်ဖြတ်',
    ben: 'সর্বোচ্চ আয়তক্ষেত্রে কাটুন',
    tr: 'Maksimum Dikdortgene Kes',
    km: 'កាត់ជាចតុកោណកែងអតិបរមា',
    es: 'Recortar al rectángulo más grande',
    ar: 'الاقتصاص إلى أكبر مستطيل',
  },
  'materialPage.paibanSetting.fixedRect': {
    zh: '裁剪为固定尺寸',
    en: 'Cut into Fixed Size',
    id: 'Potong ke ukuran tetap',
    kz: 'Фиксирленген өлшемге кесу',
    th: 'ตัดเป็นขนาดคงที่',
    ug: 'مۇقىم ئۆلچەمگە كېسىش',
    vi: 'Cắt thành Kích thước Cố định',
    zh_tc: '裁剪為固定尺寸',
    ru: 'Вырезать в фиксированный размер',
    ko: '고정 치수로 자르기',
    bur: 'သတ်မှတ်အရွယ်ဖြတ်',
    ben: 'নির্দিষ্ট আকারে কাটুন',
    tr: 'Sabit Boyuta Kes',
    km: 'កាត់ជាទំហំថេរ',
    es: 'Recortar a un tamaño fijo',
    ar: 'الاقتصاص إلى حجم ثابت',
  },
  'materialPage.paibanSetting.minRectSetting': {
    zh: '裁剪最小尺寸',
    en: 'Cutting Minimum Size',
    id: 'Ukuran minimum untuk pemangkasan',
    kz: 'Ең кіші өлшемге кесу',
    th: 'ขนาดขั้นต่ำสำหรับการปลูกพืช',
    ug: 'ئەڭ كىچىك ئۆلچەمگە كېسىش',
    vi: 'Cài đặt Kích thước Cắt Tối thiểu',
    zh_tc: '裁剪最小尺寸',
    ru: 'Минимальный размер',
    ko: '최소 크기 자르기',
    bur: 'အနည်းဆုံးဖြတ်အရွယ်',
    ben: 'সর্বনিম্ন কাটার আকার',
    tr: 'Minimum Kesim Boyutu',
    km: 'ទំហំកាត់អប្បបរមា',
    es: 'Recortar al mínimo tamaño',
    ar: 'المحاصيل إلى الحد الأدنى للحجم',
  },
  'materialPage.paibanSetting.firstCutL': {
    zh: '裁剪优先生成L形余料',
    en: 'Prioritize L-shaped remnant generation',
    id: 'Potong bahan residu berbentuk L',
    kz: 'L-пішінді қалдықты бірінші орындау',
    th: 'ตัดวัสดุตกค้างรูปตัว L',
    ug: 'L شەكلىدىكى قېلىنما ئاۋۋال ھاسىل قىلىش',
    vi: 'Ưu tiên tạo ra phế liệu hình chữ L',
    zh_tc: '裁剪優先生成L形餘料',
    ru: 'Приоритетное формирование L - образного остатка',
    ko: '자르기 우선 L형 여분 생성',
    bur: 'ဖြတ်တောက်မှုL ပုံပိုလျှံပစ္စည်းဦးစားပေးဖန်တီး',
    ben: 'কাটায় L-আকারের উদ্বৃত্ত তৈরিকে অগ্রাধিকার দিন',
    tr: 'Oncelikle L Sekilli Artik Olustur',
    km: 'ផ្តល់អាទិភាពបង្កើតសំណល់រាង L',
    es: 'El corte da prioridad a la generación de L restos en forma',
    ar: 'القطع يعطي الأولوية لتوليد L بقايا على شكل',
  },
  'materialPage.paibanSetting.firstCutLTip': {
    zh: '开启后会优先将满足条件的矩形板组合裁剪为L形余料',
    en: 'When enabled, it will prioritize cutting rectangular sheets into L-shaped remnants if conditions are met',
    id: 'Setelah membuka, kombinasi pelat persegi panjang yang memenuhi kondisi akan dipotong menjadi bahan residu berbentuk L.',
    kz: 'Қосылған кезде шарттарға сай тікбұрышты парақтарды L-пішінді қалдыққа кесуді бірінші орынға қояды',
    th: 'หลังจากเปิดการรวมกันของแผ่นรูปสี่เหลี่ยมผืนผ้าที่ตรงกับเงื่อนไขจะถูกตัดเป็นวัสดุที่ตกค้างรูปตัว L',
    ug: 'قوزغىتىلغاندا، شەرتنى قاندۇرىدىغان تۆت تەرەپلىك تاختىلارنى L شەكلىدىكى قېلىنما شەكلىگە كېسىش ئاۋۋاللىقى بېرىلىدۇ',
    vi: 'Khi bật, nó sẽ ưu tiên cắt các tấm hình chữ nhật thành phế liệu hình chữ L nếu các điều kiện được đáp ứng',
    zh_tc: '開啟後會優先將滿足條件的矩形板組合裁剪為L形餘料',
    ru: 'После открытия приоритет отдается выполнимой комбинации прямоугольных пластин в L - образный остаток.',
    ko: '오픈 후 우선 조건을 만족하는 직사각형 판의 조합을 L자형 여분으로 재단합니다',
    bur: 'ဖွင့်ပြီးနောက် သင့်ဆောင်ထောင့်မှန်ပေါ်ဒ်ကို L ပုံပိုလျှံပစ္စည်းဖြစ်အောင်ဦးစားပေးဖြတ်မည်',
    ben: 'চালু হলে শর্ত পূরণকারী আয়তক্ষেত্রাকার বোর্ডগুলোকে L-আকারের উদ্বৃত্তে কাটাকে অগ্রাধিকার দেওয়া হবে',
    tr: 'Acildiginda, kosullari saglayan dikdortgen paneller once L seklinde artik malzemeye kesilir',
    km: 'បន្ទាប់ពីបើក វានឹងផ្តល់អាទិភាពកាត់បន្ទះចតុកោណដែលបំពេញលក្ខខណ្ឌឱ្យក្លាយជាសំណល់រាង L',
    es: '. Cuando se activa, las combinaciones de placas rectangulares que cumplan las condiciones se cortarán en restos con forma de L',
    ar: '. عند التشغيل، سيتم قطع مجموعات الألواح المستطيلة التي تستوفي الشروط إلى L بقايا على شكل',
  },
  'materialPage.paibanSetting.shortLine': {
    zh: '短边大于',
    en: 'Short Side Longer than',
    id: 'Sisi pendek lebih besar dari',
    kz: 'Қысқа жақ',
    th: 'ด้านสั้นมากกว่า',
    ug: 'قىسقا تەرەپ چوڭراق',
    vi: 'Đoạn Ngắn Lớn hơn',
    zh_tc: '短邊大於',
    ru: 'Короткая сторона больше',
    ko: '짧은 모서리가 보다 큽니다.',
    bur: 'တိုဘောင်ထက်ကြီး',
    ben: 'ছোট বাহু এর চেয়ে বড়',
    tr: 'Kisa Kenar Buyuklugu',
    km: 'ជ្រុងខ្លីធំជាង',
    es: 'El lado corto es mayor que',
    ar: 'الجانب القصير أكبر من',
  },
  'materialPage.paibanSetting.longLine': {
    zh: '长边大于',
    en: 'Long Side Longer than',
    id: 'Sisi panjangnya lebih besar dari',
    kz: 'Ұзын жақ',
    th: 'ด้านยาวมีขนาดใหญ่กว่า',
    ug: 'ئۇزۇن تەرەپ چوڭراق',
    vi: 'Đoạn Dài Lớn hơn',
    zh_tc: '長邊大於',
    ru: 'Длинная сторона больше',
    ko: '긴 모서리가 보다 큽니다.',
    bur: 'ရှည်ဘောင်ထက်ကြီး',
    ben: 'লম্বা বাহু এর চেয়ে বড়',
    tr: 'Uzun Kenar Buyuklugu',
    km: 'ជ្រុងវែងធំជាង',
    es: 'El lado largo es mayor que',
    ar: 'الجانب الطويل أكبر من',
  },
  'materialPage.paibanSetting.setDifferentThickness': {
    zh: '设置不同厚度板件最小裁剪尺寸',
    en: 'Set Minimum Cutting Size for Boards of Different Thicknesses',
    id: 'Atur Ukuran Pemotongan Minimum untuk Papan dengan Ketebalan Berbeda',
    kz: 'Әртүрлі қалыңдықтағы тақталардың ең кіші кесу өлшемін орнату',
    th: 'ตั้งค่าขนาดการตัดขั้นต่ำสำหรับแผ่นที่มีความหนาต่างกัน',
    ug: 'ئۆلچەملىك قېلىنلىق تاختىلارنىڭ ئەڭ كىچىك كېسىش ئۆلچىمىنى تەڭشەش',
    vi: 'Cài đặt Kích thước Cắt Tối thiểu cho Độ dày Khác nhau',
    zh_tc: '設置不同厚度板件最小裁剪尺寸',
    ru: 'Минимальный размер обрезки листов различной толщины',
    ko: '다른 두께의 판재 최소 트림 크기 설정하기',
    bur: 'ကွဲပြားသောအထူပေါ်ဒ်အနည်းဆုံးဖြတ်အရွယ်သတ်မှတ်ပါ',
    ben: 'বিভিন্ন পুরুত্বের বোর্ডের সর্বনিম্ন কাটার আকার সেট করুন',
    tr: 'Farkli Kalinliktaki Paneller Icin Minimum Kesim Boyutu Ayarla',
    km: 'កំណត់ទំហំកាត់អប្បបរមាសម្រាប់បន្ទះដែលមានកម្រាស់ខុសៗគ្នា',
    es: 'Establezca el tamaño mínimo de corte de placas con diferentes espesores',
    ar: 'تعيين الحد الأدنى لحجم القطع للألواح ذات السماكات المختلفة',
  },
  'materialPage.paibanSetting.defaultRuleTip': {
    zh: '当板件厚度没有命中规则时，按照默认规则裁剪',
    en: 'When the board thickness does not match the rule, cut according to the default rule',
    id: 'Ketika ketebalan papan tidak sesuai dengan aturan, potong sesuai aturan default',
    kz: 'Тақта қалыңдығы ережеге сәйкес келмеген жағдайда, әдепкі ережеге сәйкес кесіңіз',
    th: 'เมื่อความหนาของแผ่นไม่ตรงกับกฎ ให้ตัดตามกฎเริ่มต้น',
    ug: 'تاختا قېلىنلىقى قائىدىگە ماس كەلمىگەن ۋاقىتتا، ئەسلى قائىدىگە ئاساسەن كېسىش',
    vi: 'Khi độ dày của tấm không khớp với quy tắc, cắt theo quy tắc mặc định',
    zh_tc: '當板件厚度沒有命中規則時，按照默認規則裁剪',
    ru: 'Если толщина пластины не соответствует правилу попадания, вырезайте по умолчанию',
    ko: '보드 두께에 명중 규칙이 없는 경우 기본 규칙에 따라 자르기',
    bur: 'ပေါ်ဒ်အထူပြည်မီသောစည်းမျဉ်းမရှိသောအခါ မူရင်းစည်းမျဉ်းနှင့်ဖြတ်ပါ',
    ben: 'বোর্ডের পুরুত্ব নিয়মের সাথে না মিললে ডিফল্ট নিয়ম অনুযায়ী কাটুন',
    tr: 'Panel kalinligi kurala uymadiginda varsayilan kurala gore kesin',
    km: 'នៅពេលកម្រាស់បន្ទះមិនត្រូវនឹងច្បាប់ សូមកាត់តាមច្បាប់លំនាំដើម',
    es: 'Cuando el espesor de la placa no coincida con la regla, se cortará de acuerdo con las reglas predeterminadas',
    ar: 'عندما لا يتطابق سمك اللوحة مع القاعدة، سيتم قطعها وفقًا للقواعد الافتراضية',
  },
  'materialPage.paibanSetting.panelThickness': {
    zh: '大板厚度',
    en: 'Panel Thickness',
    id: 'Ketebalan panel',
    kz: 'Панель қалыңдығы',
    th: 'ความหนาของแผ่น',
    ug: 'تاختا قېلىنلىقى',
    vi: 'Độ dày Tấm',
    zh_tc: '大板厚度',
    ru: 'Толщина плиты',
    ko: '판자 두께',
    bur: 'ပေါ်ဒ်ကြီးအထူ',
    ben: 'বড় বোর্ডের পুরুত্ব',
    tr: 'Buyuk Panel Kalinligi',
    km: 'កម្រាស់បន្ទះធំ',
    es: 'Espesor de placa grande',
    ar: 'سمك اللوحة الكبيرة',
  },
  'materialPage.paibanSetting.duplicateMinCutSize': {
    zh: '当前厚度已存在相同的最小裁剪尺寸',
    en: 'The current thickness already has the same minimum cutting size',
    id: 'Ketebalan saat ini sudah memiliki ukuran pemotongan minimum yang sama',
    kz: 'Ағымдағы қалыңдықта бірдей ең кіші кесу өлшемі бар',
    th: 'ความหนาปัจจุบันมีขนาดการตัดขั้นต่ำเหมือนกันอยู่แล้ว',
    ug: 'ھازىرقى قېلىنلىق بويىچە ئوخشاش ئەڭ كىچىك كېسىش ئۆلچىمى مەۋجۇت',
    vi: 'Độ dày hiện tại đã có kích thước cắt tối thiểu giống nhau',
    zh_tc: '當前厚度已存在相同的最小裁剪尺寸',
    ru: 'В настоящее время существует такой же минимальный размер разреза.',
    ko: '현재 두께에 최소 트림 치수가 동일합니다.',
    bur: 'လက်ရှိအထူတွင် တူညီသောအနည်းဆုံးဖြတ်အရွယ်ရှိပြီး',
    ben: 'বর্তমান পুরুত্বে ইতিমধ্যে একই সর্বনিম্ন কাটার আকার আছে',
    tr: 'Bu kalinlik icin ayni minimum kesim boyutu zaten mevcut',
    km: 'កម្រាស់បច្ចុប្បន្នមានទំហំកាត់អប្បបរមាដូចគ្នារួចហើយ',
    es: 'Ya existe el mismo tamaño mínimo de recorte para la espesor actual',
    ar: 'نفس الحد الأدنى لحجم القطع موجود بالفعل لـ سمك الحالي',
  },
  'materialPage.paibanSetting.templateEmpty': {
    zh: '“设置不同厚度板件最小裁剪尺寸”模板数据不能为空！',
    en: 'Template data for setting minimum cutting size for boards of different thicknesses cannot be empty!',
    id: 'Data template untuk mengatur ukuran pemotongan minimum untuk papan dengan ketebalan berbeda tidak boleh kosong!',
    kz: 'Әртүрлі қалыңдықтағы тақталардың ең кіші кесу өлшемін орнату үлгі деректері бос болмауы керек!',
    th: 'ข้อมูลเทมเพลตสำหรับการตั้งค่าขนาดการตัดขั้นต่ำสำหรับแผ่นที่มีความหนาต่างกันต้องไม่ว่างเปล่า!',
    ug: 'ئۆلچەملىك قېلىنلىق تاختىلارنىڭ ئەڭ كىچىك كېسىش ئۆلچىمى قېلىپ سانلىق مەلۇماتى بوش بولسا بولمايدۇ!',
    vi: 'Dữ liệu mẫu cho việc cài đặt kích thước cắt tối thiểu cho các tấm có độ dày khác nhau không được để trống!',
    zh_tc: '「設置不同厂度板件最小裁剪尺寸」模板數據不能為空！',
    ru: '« Установите минимальный размер обрезки листов различной толщины» Данные шаблона не могут быть пустыми!',
    ko: '"다른 두께의 보드 최소 트림 크기 설정" 템플릿 데이터는 비워둘 수 없습니다.',
    bur: '"ကွဲပြားသောအထူပေါ်ဒ်အနည်းဆုံးဖြတ်အရွယ်သတ်မှတ်" ပုံစံဒေတာဗလာမဖြစ်ရ!',
    ben: '"বিভিন্ন পুরুত্বের বোর্ডের সর্বনিম্ন কাটার আকার সেট করুন" টেমপ্লেট ডেটা খালি রাখা যাবে না!',
    tr: '"Farkli kalinliktaki paneller icin minimum kesim boyutu ayarla" sablon verisi bos olamaz!',
    km: '"កំណត់ទំហំកាត់អប្បបរមាសម្រាប់បន្ទះកម្រាស់ខុសៗគ្នា" ទិន្នន័យគំរូមិនអាចទទេបានទេ!',
    es: '¡Los datos de la plantilla de "Establecer el tamaño mínimo de corte de placas con diferentes espesores" no pueden estar vacíos!',
    ar: 'لا يمكن أن تكون بيانات القالب "تعيين الحد الأدنى لحجم القطع للألواح ذات السماكات المختلفة" فارغة!',
  },
  'materialPage.paibanSetting.duplicateThicknessData': {
    zh: '“设置不同厚度板件最小裁剪尺寸”模板数据中存在重复的厚度数据！',
    en: 'Duplicate thickness data exists in the template for setting minimum cutting size for boards of different thicknesses!',
    id: 'Data ketebalan yang duplikat ada dalam template untuk mengatur ukuran pemotongan minimum untuk papan dengan ketebalan berbeda!',
    kz: 'Әртүрлі қалыңдықтағы тақталардың ең кіші кесу өлшемін орнату үлгі деректерінде қайталанатын қалыңдық деректері бар!',
    th: 'ข้อมูลความหนาที่ซ้ำกันมีอยู่ในเทมเพลตสำหรับการตั้งค่าขนาดการตัดขั้นต่ำสำหรับแผ่นที่มีความหนาต่างกัน!',
    ug: 'ئۆلچەملىك قېلىنلىق تاختىلارنىڭ ئەڭ كىچىك كېسىش ئۆلچىمى قېلىپ سانلىق مەلۇماتىدا قايتما قېلىنلىق مەلۇماتى مەۋجۇت!',
    vi: 'Dữ liệu độ dày trùng lặp tồn tại trong mẫu cài đặt kích thước cắt tối thiểu cho các tấm có độ dày khác nhau!',
    zh_tc: '「設置不同厂度板件最小裁剪尺寸」模板數據中存在重複的厂度數據！',
    ru: 'В данных шаблона « Установите минимальный размер обрезки листов различной толщины» есть повторяющиеся данные толщины!',
    ko: '"다양한 두께의 보드 최소 트림 크기 설정" 템플릿 데이터에 중복된 두께 데이터가 있습니다.',
    bur: '"ကွဲပြားသောအထူပေါ်ဒ်အနည်းဆုံးဖြတ်အရွယ်သတ်မှတ်" ပုံစံဒေတာတွင် ထပ်နေသောအထူဒေတာရှိသည်!',
    ben: '"বিভিন্ন পুরুত্বের বোর্ডের সর্বনিম্ন কাটার আকার সেট করুন" টেমপ্লেট ডেটায় পুনরাবৃত্ত পুরুত্ব ডেটা আছে!',
    tr: '"Farkli kalinliktaki paneller icin minimum kesim boyutu ayarla" sablonunda yinelenen kalinlik verisi var!',
    km: '"កំណត់ទំហំកាត់អប្បបរមាសម្រាប់បន្ទះកម្រាស់ខុសៗគ្នា" មានទិន្នន័យកម្រាស់ស្ទួនក្នុងគំរូ!',
    es: '¡Hay datos de espesor duplicados en los datos de la plantilla de "Establecer el tamaño mínimo de corte de placas con diferentes espesores"!',
    ar: 'توجد بيانات سمك مكررة في بيانات القالب الخاصة بـ "تعيين الحد الأدنى لحجم القطع للألواح ذات السماكات المختلفة"!',
  },
  'materialPage.paibanSetting.atLeastOne': {
    zh: '至少保留一项!',
    en: 'At least one item must be retained!',
    id: 'Setidaknya satu item harus dipertahankan!',
    kz: 'Ең болмағанда бір элемент сақталуы керек!',
    th: 'ต้องเก็บไว้อย่างน้อยหนึ่งรายการ!',
    ug: 'ئەڭ ئاز بولغاندا بىر تالنى ساقلاڭ!',
    vi: 'Ít nhất phải giữ lại một mục!',
    zh_tc: '至少保留一項!',
    ru: 'Сохранить хотя бы одну!',
    ko: '하나 이상 유지!',
    bur: 'အနည်းဆုံးတစ်ခုသိမ်းထားပါ!',
    ben: 'অন্তত একটি আইটেম রাখতে হবে!',
    tr: 'En Az Bir Tane Birakilmali!',
    km: 'យ៉ាងហោចណាស់ត្រូវរក្សាទុកមួយ!',
    es: '¡Conserva al menos un artículo!',
    ar: 'احتفظ بعنصر واحد على الأقل!',
  },
  'materialPage.paibanSetting.maxAddFive': {
    zh: '最多添加五个!',
    en: 'You can add up to five!',
    id: 'Anda hanya dapat menambahkan hingga lima item!',
    kz: 'Ең көп дегенде бес элемент қосуға болады!',
    th: 'คุณสามารถเพิ่มได้สูงสุดห้ารายการ!',
    ug: 'ئەڭ كۆپ بولغاندا بەشنى قوشالايسىز!',
    vi: 'Bạn chỉ có thể thêm tối đa năm mục!',
    zh_tc: '最多添加五個!',
    ru: 'Добавьте максимум пять!',
    ko: '최대 5개 추가!',
    bur: 'အများဆုံးငါးခုထည့်နိုင်သည်!',
    ben: 'সর্বোচ্চ পাঁচটি যোগ করা যাবে!',
    tr: 'En Fazla Bes Tane Eklenebilir!',
    km: 'អាចបន្ថែមបានច្រើនបំផុតប្រាំ!',
    es: '¡Suma hasta cinco!',
    ar: 'أضف ما يصل إلى خمسة!',
  },
  'materialPage.paibanSetting.surplusTemplate': {
    zh: '余料常用模版',
    en: 'Common Scrap Templates',
    id: 'Template umum untuk bahan yang tersisa',
    kz: 'Қалдық материалдардың жиі қолданылатын үлгілер',
    th: 'เทมเพลตทั่วไปสำหรับวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىال ئادەتتىكى قېلىپ',
    vi: 'Mẫu Vật liệu dư thừa Thông thường',
    zh_tc: '餘料常用模版',
    ru: 'Обычные шаблоны',
    ko: '여분 재료 상용 템플릿',
    bur: 'ပိုလျှံပစ္စည်းအသုံးများသောပုံစံ',
    ben: 'উদ্বৃত্ত উপকরণের সাধারণ টেমপ্লেট',
    tr: 'Artik Malzeme Ortak Sablonu',
    km: 'គំរូសម្ភារៈសំណល់ដែលប្រើញឹកញាប់',
    es: 'Plantillas comunes para los materiales restantes',
    ar: 'قوالب مشتركة للمواد المتبقية',
  },
  'materialPage.paibanSetting.add': {
    zh: '添加',
    en: 'Add',
    id: 'Tambahkan ke',
    kz: 'Қосу',
    th: 'เพิ่ม',
    ug: 'قوشۇش',
    vi: 'Thêm',
    zh_tc: '添加',
    ru: 'добавить',
    ko: '추가',
    bur: 'ထည့်ပါ',
    ben: 'যোগ করুন',
    tr: 'Ekle',
    km: 'បន្ថែម',
    es: 'Agregar',
    ar: 'إضافة',
  },
  'materialPage.paibanSetting.templateErr': {
    zh: '选择裁剪为常用尺寸，需要选择至少一个数据模板',
    en: 'When selecting "Cut into Common Size", at least one data template must be selected.',
    id: 'Pilih tanaman ke ukuran umum dan perlu memilih setidaknya satu templat data',
    kz: 'Үлгілердің кемісіңізді таңдаңыз',
    th: 'เลือก Crop เป็นขนาดทั่วไปและจำเป็นต้องเลือกเทมเพลตข้อมูลอย่างน้อยหนึ่งแบบ',
    ug: 'ئادەتتىكى ئۆلچەمگە كېسىش تاللانغاندا، كەم دېگەندە بىر سانلىق مەلۇمات قېلىپى تاللىشىڭىز كېرەك',
    vi: 'Khi chọn kích thước cắt thông thường, bạn cần chọn ít nhất một mẫu dữ liệu',
    zh_tc: '選擇裁剪為常用尺寸，需要選擇至少一個數據模板',
    ru: 'Выберите обычный размер для обрезки и выберите хотя бы один шаблон данных',
    ko: '자르기를 일반 크기로 선택하려면 데이터 템플릿을 하나 이상 선택해야 합니다.',
    bur: 'ပုံမှန်အရွယ်ဖြတ်ရွေးချယ်ချိန် ဒေတာပုံစံတစ်ခုရွေးထားရမည်',
    ben: 'সাধারণ আকারে কাটা নির্বাচন করার সময় কমপক্ষে একটি ডেটা টেমপ্লেট নির্বাচন করতে হবে',
    tr: 'Ortak boyuta kesmeyi secmek icin en az bir veri sablonu secilmelidir',
    km: 'នៅពេលជ្រើសកាត់ជាទំហំទូទៅ ត្រូវជ្រើសគំរូទិន្នន័យយ៉ាងហោចណាស់មួយ',
    es: 'Seleccione el corte a tamaños comunes, debe seleccionar al menos una plantilla de datos',
    ar: 'حدد القطع للأحجام المشتركة، تحتاج إلى تحديد قالب بيانات واحد على الأقل',
  },
  'materialPage.paibanSetting.cutLong': {
    zh: '裁剪长度',
    en: 'Cutting Length',
    id: 'Panjang tanaman',
    kz: 'Кесу ұзындығы',
    th: 'ความยาวของพืช',
    ug: 'كېسىش ئۇزۇنلۇقى',
    vi: 'Chiều dài Cắt',
    zh_tc: '裁剪長度',
    ru: 'Длина обрезки',
    ko: '길이 자르기',
    bur: 'ဖြတ်အရှည်',
    ben: 'কাটার দৈর্ঘ্য',
    tr: 'Kesim Uzunlugu',
    km: 'ប្រវែងកាត់',
    es: 'Longitud de corte',
    ar: 'طول القطع',
  },
  'materialPage.paibanSetting.cutWidth': {
    zh: '裁剪宽度',
    en: 'Cutting Width',
    id: 'Lebar tanaman',
    kz: 'Кесу ені',
    th: 'ความกว้างของพืช',
    ug: 'كېسىش كەڭلىكى',
    vi: 'Chiều rộng Cắt',
    zh_tc: '裁剪寬度',
    ru: 'Ширина обрезки',
    ko: '트림 폭',
    bur: 'ဖြတ်အကျယ်',
    ben: 'কাটার প্রস্থ',
    tr: 'Kesim Genisligi',
    km: 'ទទឹងកាត់',
    es: 'Ancho de corte',
    ar: 'عرض القطع',
  },
  'materialPage.paibanSetting.baseInfo': {
    zh: '基本信息',
    en: 'Basic information',
    id: 'Informasi dasar',
    kz: 'Негізгі ақпарат',
    th: 'ข้อมูลพื้นฐาน',
    ug: 'ئاساسلىق ئۇچۇر',
    vi: 'Thông tin Cơ bản',
    zh_tc: '基本信息',
    ru: 'Основная информация',
    ko: '기본 정보',
    bur: 'အခြေခံသတင်းအချက်အလက်',
    ben: 'মূল তথ্য',
    tr: 'Temel Bilgiler',
    km: 'ព័ត៌មានមូលដ្ឋាន',
    es: 'Información básica',
    ar: 'المعلومات الأساسية',
  },
  'materialPage.paibanSetting.continue': {
    zh: '确认并继续',
    en: 'Confirm and Continue',
    id: 'Konfirmasi dan lanjutkan',
    kz: 'Тастықтап, жалғастыру',
    th: 'ยืนยันและดำเนินการต่อ',
    ug: 'جەزملەشتۈرۈپ داۋاملاشتۇرۇش',
    vi: 'Xác nhận và Tiếp tục',
    zh_tc: '確認並繼續',
    ru: 'Подтвердить и продолжить',
    ko: '확인 및 계속',
    bur: 'အတည်ပြုပြီးဆက်လုပ်',
    ben: 'নিশ্চিত করুন এবং চালিয়ে যান',
    tr: 'Onayla ve Devam Et',
    km: 'បញ្ជាក់ និងបន្ត',
    es: 'Confirmar y continuar',
    ar: 'التأكيد والمتابعة',
  },
  'materialPage.paibanSetting.standardSelect': {
    zh: '标准大板选择',
    en: 'Std Panel',
    id: 'Pilihan Papan Besar Standar',
    kz: 'Стандартты үлкен плитканы таңдау',
    th: 'การเลือกบอร์ดขนาดใหญ่มาตรฐาน',
    ug: 'ئۆلچەملىك چوڭ تاختا تاللاش',
    vi: 'Tiêu chuẩn lựa chọn tấm lớn',
    zh_tc: '標準大板選擇',
    ru: 'Выбор стандартной доски',
    ko: '표준 보드 선택',
    bur: 'စံပေါ်ဒ်ကြီးရွေးချယ်',
    ben: 'স্ট্যান্ডার্ড বড় বোর্ড নির্বাচন',
    tr: 'Standart Buyuk Panel Secimi',
    km: 'ជ្រើសរើសបន្ទះធំស្តង់ដារ',
    es: 'Selección de tableros grandes estándar',
    ar: 'اختيار اللوحة الكبيرة القياسية',
  },
  'materialPage.paibanSetting.customPlankOrder': {
    zh: '自定义大板排版顺序',
    en: 'Custom Panel Order',
    id: 'Kustomisasi urutan tata letak papan besar',
    kz: 'Таңдауыңызша үлкен тақта бөлімдеу реті',
    th: 'ปรับแต่งคำสั่งเลย์เอาต์ของบอร์ดขนาดใหญ่',
    ug: 'خاس چوڭ تاختا تەرتىپلەش تەرتىپى',
    vi: 'Tuỳ chỉnh thứ tự sắp đặt bảng lớn',
    zh_tc: '自定義大板排版順序',
    ru: 'Настройка порядка форматирования больших панелей',
    ko: '대판 조판 순서 사용자 정의',
    bur: 'ပေါ်ဒ်ကြီးပြင်ဆင်မှုအစဉ်ကိုယ်ပိုင်သတ်မှတ်',
    ben: 'বড় বোর্ড লেআউট ক্রম কাস্টমাইজ করুন',
    tr: 'Buyuk Panel Dizgi Sirasini Ozellestir',
    km: 'ប្ដូរលំដាប់ប្លង់បន្ទះធំតាមបំណង',
    es: 'Orden de diseño de tableros grandes personalizado',
    ar: 'ترتيب تخطيط اللوحة الكبيرة المخصص',
  },
  'materialPage.paibanSetting.customPlankOrderDetail': {
    zh: '未排小板清单',
    en: 'UnArranged small board list',
    id: 'Tidak terdaftar di papan kecil',
    kz: 'Жоқ болып тұрған кіші тақта тізімі',
    th: 'ไม่ได้อยู่ในบอร์ดขนาดเล็ก',
    ug: 'تەرتىپلەنمىگەن كىچىك تاختا تىزىملىكى',
    vi: 'Danh sách bảng nhỏ chưa sắp xếp',
    zh_tc: '未排小板清單',
    ru: 'Перечень неотредактированных досок',
    ko: '소판 목록 없음',
    bur: 'မပြင်ဆင်ရသေးသောပေါ်ဒ်ငယ်စာရင်း',
    ben: 'অসজ্জিত ছোট বোর্ডের তালিকা',
    tr: 'Dizilmemis Kucuk Panel Listesi',
    km: 'បញ្ជីបន្ទះតូចដែលមិនទាន់ប្លង់',
    es: 'Lista de tableros pequeños sin organizar',
    ar: 'قائمة اللوحات الصغيرة غير المرتبة',
  },
  'materialPage.paibanSetting.customPlankOrderTip': {
    zh: '内嵌云排版不生效此功能',
    en: 'The embedded cloud layout does not take effect for this feature',
    id: 'Tata letak awan tertanam tidak berlaku.',
    kz: 'Ішке қосылған ауыл кеңістігі бұл функция үшін іске асырылмайды',
    th: 'เค้าโครงเมฆแบบฝังไม่มีผล',
    ug: 'ئىچكى بۇلۇت تەرتىپلىگۈچ بۇ ئىقتىدارغا ئىناۋەتلىك ئەمەس',
    vi: 'Chức năng nhúng bản đồ mây không có hiệu lực cho tính năng này',
    zh_tc: '內嵌雲排版不生效此功能',
    ru: 'Встроенное облако не работает.',
    ko: '내장 클라우드 레이아웃은 이 기능에 적용되지 않습니다.',
    bur: 'ထည့်သွင်းထားသောCloud Layout ဤလုပ်ဆောင်ချက်ကိုမကျင့်သုံးနိုင်',
    ben: 'এমবেডেড ক্লাউড লেআউট এই ফিচারে কার্যকর নয়',
    tr: 'Gomulu bulut dizgisi bu ozellikte gecerli degildir',
    km: 'ប្លង់ពពកដែលភ្ជាប់មកជាមួយ មិនមានប្រសិទ្ធភាពសម្រាប់មុខងារនេះទេ',
    es: 'La composición tipográfica en la nube integrada no tiene efecto.',
    ar: 'التنضيد السحابي المضمن لا يصبح ساري المفعول.',
  },
  'materialPage.paibanSetting.customPlankOrderBrandTip': {
    zh: '待排版订单存在品牌色卡板件，默认使用此功能',
    en: 'Orders pending layout contain brand color card boards, this feature is enabled by default',
    id: 'Pesanan yang menunggu tata letak berisi papan kartu warna merek, fitur ini diaktifkan secara default',
    kz: 'Бөлімдеуді күтіп тұрған тапсырыстарда бренд түсті карта тақталары бар, бұл функция әдепкі бойынша қосылады',
    th: 'คำสั่งซื้อที่รอการจัดเลย์เอาต์มีแผ่นการ์ดสีของแบรนด์ ฟังก์ชันนี้เปิดใช้งานโดยค่าเริ่มต้น',
    ug: 'تەرتىپلەشنى ساقلاۋاتقان زاكاسلاردا ماركا رەڭ كارتا تاختىسى بار، بۇ ئىقتىدار سۈكۈتتىكى ھالەتتە ئىشلىتىلىدۇ',
    vi: 'Đơn hàng chờ sắp xếp có tấm thẻ màu thương hiệu, tính năng này được bật theo mặc định',
    zh_tc: '待排版訂單存在品牌色卡板件，默認使用此功能',
    ru: 'В заказах, ожидающих раскладки, присутствуют плиты с фирменной цветовой картой, эта функция используется по умолчанию',
    ko: '조판 대기 주문에 브랜드 색상 카드 보드가 있어 이 기능이 기본으로 사용됩니다',
    bur: 'ပြင်ဆင်ရန်စောင့်ဆိုင်းနေသောအော်ဒါတွင်အမှတ်တံဆိပ်အရောင်ကတ်ပြားများရှိ၍ဤလုပ်ဆောင်ချက်ကိုပုံသေအသုံးပြုသည်',
    ben: 'লেআউটের অপেক্ষায় থাকা অর্ডারে ব্র্যান্ড কালার কার্ড বোর্ড রয়েছে, এই ফিচারটি ডিফল্টভাবে ব্যবহৃত হয়',
    tr: 'Dizgi bekleyen siparislerde marka renk karti panelleri var, bu ozellik varsayilan olarak kullanilir',
    km: 'ការបញ្ជាទិញដែលរង់ចាំប្លង់មានបន្ទះកាតពណ៌ម៉ាក មុខងារនេះត្រូវបានប្រើតាមលំនាំដើម',
    es: 'Los pedidos pendientes de diseño contienen tableros de tarjeta de color de marca, esta función se usa de forma predeterminada',
    ar: 'تحتوي الطلبات المعلقة للتخطيط على ألواح بطاقات ألوان العلامة التجارية، يتم استخدام هذه الميزة افتراضيًا',
  },
  'materialPage.paibanSetting.surplusPlank': {
    zh: '剩余小板清单',
    en: 'Remaining small board list',
    id: 'Daftar papan kecil yang tersisa',
    kz: 'Қалып құрылған кіші тақта тізімі',
    th: 'รายชื่อบอร์ดขนาดเล็กที่เหลืออยู่',
    ug: 'قالدۇق كىچىك تاختا تىزىملىكى',
    vi: 'Danh sách bảng nhỏ còn lại',
    zh_tc: '剩餘小板清單',
    ru: 'Список оставшихся листов',
    ko: '남은 슬레이트 목록',
    bur: 'ကျန်ပေါ်ဒ်ငယ်စာရင်း',
    ben: 'অবশিষ্ট ছোট বোর্ডের তালিকা',
    tr: 'Kalan Kucuk Panel Listesi',
    km: 'បញ្ជីបន្ទះតូចដែលនៅសល់',
    es: 'Lista de tableros pequeños restantes',
    ar: 'قائمة اللوحات الصغيرة المتبقية',
  },
  'materialPage.paibanSetting.overSizePlank': {
    zh: '超尺板件清单',
    en: 'Oversized plate list',
    id: 'Daftar bagian papan ukuran super',
    kz: 'Үлкен өлшемді тақта нәрсесі тізімі',
    th: 'รายชื่อชิ้นส่วนบอร์ดขนาดใหญ่',
    ug: 'چوڭ ئۆلچەملىك تاختا تىزىملىكى',
    vi: 'Danh sách các mảnh gỗ vượt quy định kích thước',
    zh_tc: '超尺板件清單',
    ru: 'Перечень надлинейных панелей',
    ko: '하이퍼스케일 인벤토리',
    bur: 'အကြီးလွန်ပေါ်ဒ်ငယ်စာရင်း',
    ben: 'অতিরিক্ত আকারের বোর্ডের তালিকা',
    tr: 'Asiri Buyuk Panel Listesi',
    km: 'បញ្ជីបន្ទះលើសទំហំ',
    es: 'Lista de tableros de gran tamaño',
    ar: 'قائمة لوحات كبيرة الحجم',
  },
  'materialPage.paibanSetting.plankOrder': {
    zh: '排版顺序',
    en: 'Layout order',
    id: 'Pesanan pengukur huruf',
    kz: 'Бөлімдеу реті',
    th: 'คำสั่งเรียงลำดับ',
    ug: 'تەرتىپلەش تەرتىپى',
    vi: 'Thứ tự typography',
    zh_tc: '排版順序',
    ru: 'Порядок набора',
    ko: '조판 순서',
    bur: 'ပြင်ဆင်မှုအစဉ်',
    ben: 'লেআউট ক্রম',
    tr: 'Dizgi Sirasi',
    km: 'លំដាប់ប្លង់',
    es: 'Secuencia de diseño',
    ar: 'تسلسل التخطيط',
  },
  'materialPage.paibanSetting.plankType': {
    zh: '板材类型',
    en: 'Board type',
    id: 'Jenis pelat',
    kz: 'Тақта түрі',
    th: 'ประเภทจาน',
    ug: 'تاختا ماتېرىالى تىپى',
    vi: 'Loại tấm',
    zh_tc: '板材類型',
    ru: 'Типы листов',
    ko: '판재 유형',
    bur: 'ပေါ်ဒ်အမျိုးအစား',
    ben: 'বোর্ডের ধরন',
    tr: 'Panel Turu',
    km: 'ប្រភេទបន្ទះ',
    es: 'Tipo de tablero',
    ar: 'نوع اللوحة',
  },
  'materialPage.paibanSetting.plankSize': {
    zh: '板材尺寸',
    en: 'Board size',
    id: 'Ukuran piring',
    kz: 'Тақта өлшемдері',
    th: 'ขนาดแผ่น',
    ug: 'تاختا ئۆلچىمى',
    vi: 'Kích thước tấm',
    zh_tc: '板材尺寸',
    ru: 'Размеры листов',
    ko: '판재 크기',
    bur: 'ပေါ်ဒ်အရွယ်အစား',
    ben: 'বোর্ডের আকার',
    tr: 'Panel Boyutu',
    km: 'ទំហំបន្ទះ',
    es: 'Tamaño del tablero',
    ar: 'حجم اللوحة',
  },
  'materialPage.paibanSetting.plankEdgeOff': {
    zh: '修边值',
    en: 'Trim',
    id: 'Nilai perbatasan',
    kz: 'Қысқарту мәні',
    th: 'มูลค่าชายแดน',
    ug: 'چىگارلاش قىممىتى',
    vi: 'Giá trị cắt tỉa',
    zh_tc: '修邊值',
    ru: 'значение обрезки',
    ko: '모서리 값 수정하기',
    bur: 'ဘေးဖြတ်တန်ဖိုး',
    ben: 'ট্রিমিং মান',
    tr: 'Kenar Kirpma Degeri',
    km: 'តម្លៃកាត់គែម',
    es: 'Valor de corte',
    ar: 'قيمة القطع',
  },
  'materialPage.paibanSetting.amount': {
    zh: '下料数量',
    en: 'Quantity of cutting materials',
    id: 'Kuantitas memotong',
    kz: 'Құрту саны',
    th: 'การตัดปริมาณ',
    ug: 'ماتېرىال سانى',
    vi: 'Số lượng xả',
    zh_tc: '下料數量',
    ru: 'Количество раскроек',
    ko: '공급 수량',
    bur: 'ဖြတ်တောက်အရေအတွက်',
    ben: 'কাটার পরিমাণ',
    tr: 'Kesim Miktari',
    km: 'បរិមាណកាត់',
    es: 'Cantidad de corte',
    ar: 'كمية القطع',
  },
  'materialPage.paibanSetting.amountMax': {
    zh: '下料数量最大',
    en: 'Maximum cutting quantity',
    id: 'Jumlah maksimum pelepasan',
    kz: 'Құрту саны максималды',
    th: 'ปริมาณสูงสุดของการปลดปล่อย',
    ug: 'ئەڭ كۆپ ماتېرىال سانى',
    vi: 'Số lượng xả tối đa',
    zh_tc: '下料數量最大',
    ru: 'Наибольшее количество загрузок.',
    ko: '공급 수량이 가장 크다.',
    bur: 'ဖြတ်တောက်အရေအတွက်အများဆုံး',
    ben: 'সর্বোচ্চ কাটার পরিমাণ',
    tr: 'Maksimum Kesim Miktari',
    km: 'បរិមាណកាត់អតិបរមា',
    es: 'El número máximo de espacios en blanco',
    ar: 'الحد الأقصى لعدد الفراغات',
  },
  'materialPage.paibanSetting.numAndOverSizeTip': {
    zh: '存在小板超尺且大板用量不足无法排版',
    en: 'There are small boards that exceed the size limit and insufficient large boards that cannot be typeset',
    id: 'Ada papan kecil yang melebihi penggaris dan papan besar tidak cukup untuk mengetik',
    kz: 'Кіші тақталар өлшемінен асып, үлкен тақталардың қолданған мөлшері жеткіліксіз, бөлімдеу мүмкін емес',
    th: 'มีบอร์ดขนาดเล็กที่เกินไม้บรรทัดและบอร์ดขนาดใหญ่ไม่เพียงพอที่จะพิมพ์',
    ug: 'چوڭ ئۆلچەملىك تاختىلار يېتەرلىك بولمىغانلىقى ياكى تەرتىپلەشكە بولمايدىغان كىچىك تاختىلار بار',
    vi: 'Có bảng nhỏ và bảng lớn không đủ để sắp chữ',
    zh_tc: '存在小板超尺且大板用量不足無法排版',
    ru: 'Есть небольшой размер, и большая доска не может быть напечатана.',
    ko: '소판 초척이 존재하고 대판 사용량이 부족하여 조판할 수 없다',
    bur: 'ပေါ်ဒ်ငယ်ကြီးလွန်ပြီး ပေါ်ဒ်ကြီးပမာဏမလုံလောက်၍ မပြင်ဆင်နိုင်',
    ben: 'ছোট বোর্ড আকার সীমা অতিক্রম করেছে এবং বড় বোর্ডের পরিমাণ অপর্যাপ্ত, লেআউট করা যাচ্ছে না',
    tr: 'Asiri buyuk kucuk paneller var ve buyuk panel miktari yetersiz, dizgi yapilamaz',
    km: 'មានបន្ទះតូចលើសទំហំ ហើយបរិមាណបន្ទះធំមិនគ្រប់គ្រាន់ ដូច្នេះមិនអាចធ្វើប្លង់បាន',
    es: 'Hay placas pequeñas que son de gran tamaño y la cantidad de placas grandes es insuficiente para la composición tipográfica',
    ar: 'هناك لوحات صغيرة كبيرة الحجم وكمية اللوحات الكبيرة غير كافية للتنضيد',
  },
  'materialPage.paibanSetting.numErrorTip': {
    zh: '大板用量不足无法排版',
    en: 'Insufficient usage of large boards to layout',
    id: 'Penggunaan papan besar yang tidak cukup tidak dapat diketik',
    kz: 'Үлкен тақталардың қолданған мөлшері жеткіліксіз, бөлімдеу мүмкін емес',
    th: 'ไม่สามารถใช้บอร์ดขนาดใหญ่ได้ไม่เพียงพอ',
    ug: 'چوڭ تاختىلار يېتەرلىك بولمىغانلىقى تەرتىپلەشكە بولمايدۇ',
    vi: 'Không dùng đủ bảng để sắp chữ',
    zh_tc: '大板用量不足無法排版',
    ru: 'Недостаточно большой набор не доступен.',
    ko: '널빤지 용량이 부족하여 조판할 수 없다',
    bur: 'ပေါ်ဒ်ကြီးပမာဏမလုံလောက်၍ မပြင်ဆင်နိုင်',
    ben: 'বড় বোর্ডের ব্যবহার অপর্যাপ্ত, লেআউট করা যাচ্ছে না',
    tr: 'Buyuk panel miktari yetersiz, dizgi yapilamaz',
    km: 'បរិមាណបន្ទះធំមិនគ្រប់គ្រាន់ មិនអាចធ្វើប្លង់បាន',
    es: 'No hay placas grandes suficientes para la composición tipográfica',
    ar: 'لا توجد لوحات كبيرة كافية للتنضيد',
  },
  'materialPage.paibanSetting.overSizeTip': {
    zh: '存在小板超尺无法排版',
    en: 'There is a small board that exceeds the size limit and cannot be typeset',
    id: 'Ada papan kecil yang tidak bisa diketik',
    kz: 'Кіші тақталар өлшемінен асып, бөлімдеу мүмкін емес',
    th: 'มีบอร์ดขนาดเล็กที่ไม่สามารถพิมพ์ได้',
    ug: 'چوڭ ئۆلچەملىك تاختىلار بار تەرتىپلەشكە بولمايدۇ',
    vi: 'Có những tấm nhỏ không thể sắp chữ',
    zh_tc: '存在小板超尺無法排版',
    ru: 'Есть маленькие доски, которые не могут быть напечатаны.',
    ko: '소판 초자가 존재하여 조판할 수 없습니다',
    bur: 'ပေါ်ဒ်ငယ်ကြီးလွန်၍ မပြင်ဆင်နိုင်',
    ben: 'ছোট বোর্ড আকার সীমা অতিক্রম করেছে, লেআউট করা যাচ্ছে না',
    tr: 'Asiri buyuk kucuk panel mevcut, dizgi yapilamaz',
    km: 'មានបន្ទះតូចលើសទំហំ មិនអាចធ្វើប្លង់បាន',
    es: 'Hay placas pequeñas que son de gran tamaño y no se pueden componer',
    ar: 'توجد لوحات صغيرة كبيرة الحجم ولا يمكن تنضيدها',
  },
  'materialPage.paibanSetting.restPartList': {
    zh: '未排小板清单',
    en: 'Unarranged Small Board List',
    id: 'Tidak terdaftar di papan kecil',
    kz: 'Таңдалмаған кіші тақталар тізімі',
    th: 'ไม่ได้อยู่ในบอร์ดขนาดเล็ก',
    ug: 'تەرتىپلەنمىگەن كىچىك تاختا تىزىملىكى',
    vi: 'Danh sách bảng nhỏ chưa bố trí',
    zh_tc: '未排小板清單',
    ru: 'Перечень неотредактированных досок',
    ko: '소판 목록 없음',
    bur: 'မပြင်ဆင်ရသေးသောပေါ်ဒ်ငယ်စာရင်း',
    ben: 'অসজ্জিত ছোট বোর্ডের তালিকা',
    tr: 'Dizilmemis Kucuk Panel Listesi',
    km: 'បញ្ជីបន្ទះតូចដែលមិនទាន់ប្លង់',
    es: 'Lista de tableros pequeños sin organizar',
    ar: 'قائمة اللوحات الصغيرة غير المرتبة',
  },
  'materialPage.paibanSetting.layoutOrder': {
    zh: '排版顺序',
    en: 'Layout Order',
    id: 'Pesanan pengukur huruf',
    kz: 'Орналастыру тәртібі',
    th: 'คำสั่งเรียงลำดับ',
    ug: 'تەرتىپلەش تەرتىپى',
    vi: 'Thứ tự bố trí',
    zh_tc: '排版順序',
    ru: 'Порядок набора',
    ko: '조판 순서',
    bur: 'ပြင်ဆင်မှုအစဉ်',
    ben: 'লেআউট ক্রম',
    tr: 'Dizgi Sirasi',
    km: 'លំដាប់ប្លង់',
    es: 'Secuencia de diseño',
    ar: 'تسلسل التخطيط',
  },
  'materialPage.paibanSetting.arrangeAmount': {
    zh: '下料数量',
    en: 'Cutting Quantity',
    id: 'Kuantitas memotong',
    kz: 'Кесу саны',
    th: 'การตัดปริมาณ',
    ug: 'ماتېرىال سانى',
    vi: 'Số lượng cắt',
    zh_tc: '下料數量',
    ru: 'Количество раскроек',
    ko: '공급 수량',
    bur: 'ဖြတ်တောက်အရေအတွက်',
    ben: 'কাটার পরিমাণ',
    tr: 'Kesim Miktari',
    km: 'បរិមាណកាត់',
    es: 'Cantidad de corte',
    ar: 'كمية القطع',
  },
  'materialPage.paibanSetting.specialShapeTip': {
    zh: '异形余料不能使用锯切排版',
    en: 'Special-shaped surplus materials cannot use sawing layout',
    id: 'Bahan sisa bentuk khusus tidak dapat menggunakan tata letak pemotongan',
    kz: 'Арнайы пішінді қалдық материалдар кесу орналастыруын пайдалана алмайды',
    th: 'วัสดุเหลือรูปทรงพิเศษไม่สามารถใช้การจัดเรียงการตัด',
    ug: 'ئالاھىدە شەكىللىك قالدۇق ماتېرىاللار كەسىش تەرتىپلەشىنى ئىشلىتەلمەيدۇ',
    vi: 'Vật liệu thừa có hình dạng đặc biệt không thể sử dụng bố trí cắt',
    zh_tc: '異形餘料不能使用鋸切排版',
    ru: 'Ассортимент не может быть запрещён.',
    ko: '이형 여분 재료는 톱으로 조판을 잘라서는 안 된다.',
    bur: 'အထူးပုံပိုလျှံပစ္စည်းတွင် ဓားပုတ်မြောင်းပြင်ဆင်မှုမသုံးနိုင်',
    ben: 'বিশেষ আকৃতির উদ্বৃত্ত উপকরণে করাত কাটার লেআউট ব্যবহার করা যাবে না',
    tr: 'Ozel sekilli artik malzeme testere kesim dizgisinde kullanilamaz',
    km: 'សម្ភារៈសំណល់រាងពិសេសមិនអាចប្រើប្លង់កាត់ដោយរណារបានទេ',
    es: 'Los restos de formas especiales no se pueden componer mediante aserrado',
    ar: 'لا يمكن تنضيد بقايا الأشكال الخاصة بالنشر',
  },
  'materialPage.paibanSetting.surplusConflictTip': {
    zh: '裁剪余料与板件轮廓冲突，请重新裁剪',
    en: 'Surplus cutting conflicts with panel outline, please recut',
    id: 'Pemotongan bahan sisa bertentangan dengan garis panel, silakan potong ulang',
    kz: 'Қалдық материалдарды кесу панель контурымен қайшылықта, қайта кесіңіз',
    th: 'การตัดวัสดุเหลือขัดแย้งกับโครงร่างแผ่น กรุณาตัดใหม่',
    ug: 'قالدۇق ماتېرىاللارنى كەسىش تاختا كونتورى بىلەن توقۇنۇش، قايتا كەسىڭ',
    vi: 'Cắt vật liệu thừa xung đột với đường viền tấm, vui lòng cắt lại',
    zh_tc: '裁剪餘料與板件輪廓衝突，請重新裁剪',
    ru: 'Разрежьте остаточный материал и контур пластины, пожалуйста, перекройте',
    ko: '나머지 재료 자르기가 보드 아웃라인과 충돌합니다. 다시 자르십시오.',
    bur: 'ဖြတ်တောက်ပိုလျှံပစ္စည်းနှင့်ပေါ်ဒ်ကြမ်းတမ်းပဋိပက္ခ ဖြစ်သည်၊ ပြန်ဖြတ်ပါ',
    ben: 'উদ্বৃত্ত কাটা বোর্ডের কনটুরের সাথে দ্বন্দ্ব, পুনরায় কাটুন',
    tr: 'Artik malzeme kesimi panel konturu ile cakışiyor, lutfen yeniden kesin',
    km: 'ការកាត់សម្ភារៈសំណល់ប៉ះទង្គិចជាមួយគ្រោងបន្ទះ សូមកាត់ម្តងទៀត',
    es: 'Los restos recortados entran en conflicto con el contorno del panel, vuelva a cortar',
    ar: 'تتعارض بقايا التشذيب مع الخطوط العريضة للوحة، يرجى إعادة القطع',
  },
  'materialPage.filter.title': {
    zh: '板件筛选',
    en: 'Panel Filtering',
    id: 'Filter pelat',
    kz: 'Панельдерді сүзгілеу',
    th: 'ตัวกรองแผ่น',
    ug: 'تاختا تىزىملىكى تىزىملىكى',
    vi: 'Lọc Bảng',
    zh_tc: '板件篩選',
    ru: 'Скрининг панелей',
    ko: '보드 필터링',
    bur: 'ပေါ်ဒ်စစ်ထုတ်',
    ben: 'বোর্ড ফিল্টার',
    tr: 'Panel Filtreleme',
    km: 'តម្រងបន្ទះ',
    es: 'Filtro de panel',
    ar: 'مرشح اللوحة',
  },
  'materialPage.filter.search': {
    zh: '搜索',
    en: 'Search',
    id: 'mencari',
    kz: 'Іздеу',
    th: 'ค้นหา',
    ug: 'ئىزدەش',
    vi: 'Tìm kiếm',
    zh_tc: '搜索',
    ru: 'поиск',
    ko: '검색',
    bur: 'ရှာပါ',
    ben: 'অনুসন্ধান করুন',
    tr: 'Ara',
    km: 'ស្វែងរក',
    es: 'Buscar',
    ar: 'يبحث',
  },
  'materialPage.filter.all': {
    zh: '全选',
    en: 'Select all',
    id: 'Pilih semua',
    kz: 'Бәріні таңдау',
    th: 'เลือกทั้งหมด',
    ug: 'ھەممىسى',
    vi: 'Chọn tất cả',
    zh_tc: '全選',
    ru: 'Полная выборка',
    ko: '모두 선택',
    bur: 'အားလုံးရွေး',
    ben: 'সব নির্বাচন করুন',
    tr: 'Tumunu Sec',
    km: 'ជ្រើសទាំងអស់',
    es: 'Seleccione todo',
    ar: 'حدد الكل',
  },
  'materialPage.filter.diskSize': {
    zh: '排版历史数据空间已使用',
    en: 'The space used by the layout history data has been used',
    id: 'Ruang yang digunakan oleh data historis tata letak telah digunakan',
    kz: 'Тізімге жатқан тізім үстелінің кеңістігі пайдаланылған',
    th: 'พื้นที่ที่ใช้โดยข้อมูลประวัติการจัดเรียงถูกใช้',
    ug: 'تەرتىپ لوحەتلىرى تىزىملىكى قوشۇش قالدۇق ماتېرىاللارنى ئىشلىتەلمەيدۇ',
    vi: 'Không gian đã sử dụng bởi dữ liệu lịch sử bố trí đã được sử dụng',
    zh_tc: '排版歷史數據空間已使用',
    ru: 'Пространство, используемое для хранения истории макета, уже использовано',
    ko: '레이아웃 기록 데이터 공간이 이미 사용되었습니다.',
    bur: 'ပေါ်ဒ်စစ်ထုတ်မှုပယ်ဖျက်',
    ben: 'বোর্ড ফিল্টার বাতিল করুন',
    tr: 'Filtreyi Iptal Et',
    km: 'បោះបង់តម្រង',
    es: 'El espacio utilizado por los datos de historial de diseño ya ha sido utilizado',
    ar: 'تم استخدام مساحة البيانات التاريخية للتنسيق',
  },
  'materialPage.filter.resetFilter': {
    zh: '取消筛选',
    en: 'Cancel Filtering',
    id: 'Batalkan filter',
    kz: 'Сүзгілеуді жою',
    th: 'ยกเลิกตัวกรอง',
    ug: 'تىزىملىكى تىزىملىكى',
    vi: 'Đặt lại Bộ lọc',
    zh_tc: '取消篩選',
    ru: 'Отменить фильтрацию',
    ko: '필터링 해제',
    bur: 'စစ်ထုတ်မှုပယ်ဖျက်',
    ben: 'ফিল্টার বাতিল করুন',
    tr: 'Filtreyi Iptal Et',
    km: 'បោះបង់តម្រង',
    es: 'Cancelar filtro',
    ar: 'إلغاء عامل التصفية',
  },
  'materialPage.edit.title': {
    zh: '批量修改',
    en: 'Batch Edit',
    id: 'Modifikasi batch',
    kz: 'Көпшілікті өзгерту',
    th: 'การดัดแปลงแบทช์',
    ug: 'تەھرىرلەش',
    vi: 'Chỉnh sửa Nhóm',
    zh_tc: '批量修改',
    ru: 'Пакетное изменение',
    ko: '대량 수정',
    bur: 'အစုလိုက်ပြင်ဆင်',
    ben: 'ব্যাচ পরিবর্তন',
    tr: 'Toplu Duzenleme',
    km: 'កែប្រែជាក្រុម',
    es: 'Modificación por lotes',
    ar: 'تعديل الدفعة',
  },
  'materialPage.edit.target': {
    zh: '修改对象',
    en: 'Modify object',
    id: 'Ubah objek',
    kz: 'Өзгерту объекті',
    th: 'ปรับเปลี่ยนวัตถุ',
    ug: 'تەھرىرلەش ئىشلەتكۈچى',
    vi: 'Chỉnh sửa Mục tiêu',
    zh_tc: '修改對象',
    ru: 'Изменить объект',
    ko: '객체 수정',
    bur: 'ပြင်ဆင်မည့်အရာ',
    ben: 'পরিবর্তনের লক্ষ্য',
    tr: 'Duzenlenecek Nesne',
    km: 'វត្ថុដែលត្រូវកែប្រែ',
    es: 'Modificar objetos',
    ar: 'تعديل الكائنات',
  },
  'materialPage.edit.onlineSelectRow': {
    zh: '仅选中行',
    en: 'Only select the row',
    id: 'Hanya baris yang dipilih',
    kz: 'Тек таңдалған жолдар',
    th: 'เลือกแถวเท่านั้น',
    ug: 'ئىچكى قۇر',
    vi: 'Chỉ chọn Các hàng đã chọn',
    zh_tc: '僅選中行',
    ru: 'Выбрать только среднюю',
    ko: '행만 선택',
    bur: 'ရွေးချယ်ထားသောကြောင်းသာ',
    ben: 'শুধুমাত্র নির্বাচিত সারি',
    tr: 'Yalnizca Secili Satirlar',
    km: 'តែជួរដែលបានជ្រើស',
    es: 'Seleccionar solo filas',
    ar: 'تحديد الصفوف فقط',
  },
  'materialPage.edit.allRow': {
    zh: '全部行',
    en: 'All Rows',
    id: 'Semua',
    kz: 'Барлық жолдар',
    th: 'ทั้งหมด',
    ug: 'ھەممىسى',
    vi: 'Tất cả Các hàng',
    zh_tc: '全部行',
    ru: 'Все.',
    ko: '모든 행',
    bur: 'ကြောင်းအားလုံး',
    ben: 'সব সারি',
    tr: 'Tum Satirlar',
    km: 'ជួរទាំងអស់',
    es: 'Todas las filas',
    ar: 'جميع الصفوف',
  },
  'materialPage.edit.editKey': {
    zh: '需修改内容',
    en: 'Contents to be modified',
    id: 'Perlu memodifikasi konten',
    kz: 'Өзгерту керектілігі',
    th: 'จำเป็นต้องแก้ไขเนื้อหา',
    ug: 'تەھرىرلەش ئىشلەتكۈچى',
    vi: 'Nội dung để Chỉnh sửa',
    zh_tc: '需修改內容',
    ru: 'Необходимо изменить содержание',
    ko: '컨텐트 수정 필요',
    bur: 'ပြင်ဆင်မည့်အကြောင်းအရာ',
    ben: 'পরিবর্তন করতে হবে এমন বিষয়বস্তু',
    tr: 'Duzenlenecek Icerik',
    km: 'មាតិកាដែលត្រូវកែប្រែ',
    es: 'Necesita modificar el contenido',
    ar: 'تحتاج إلى تعديل المحتوى',
  },
  'materialPage.edit.editValue': {
    zh: '修改为',
    en: 'Modify to',
    id: 'Dimodifikasi menjadi',
    kz: 'Өзгерту дегенде',
    th: 'ดัดแปลงเป็น',
    ug: 'تەھرىرلەش',
    vi: 'Chỉnh sửa thành',
    zh_tc: '修改為',
    ru: 'Изменить следующим образом:',
    ko: '다음으로 수정',
    bur: 'ပြင်ဆင်ရန်',
    ben: 'এতে পরিবর্তন করুন',
    tr: 'Sununla Degistir',
    km: 'កែប្រែជា',
    es: 'Modificar a',
    ar: 'التعديل إلى',
  },
  'materialPage.edit.warningTip': {
    zh: '注意 ：修改后将自动清除孔槽和异形',
    en: 'Attention: the hole groove and irregular shape will be automatically cleared after modification',
    id: 'Catatan: Setelah modifikasi, slot lubang dan bentuk khusus akan secara otomatis dihapus.',
    kz: 'Ескерту: Өзгертуден кейін тесіктір мен кескіштер ауыстырады',
    th: 'หมายเหตุ: หลังจากการดัดแปลงสล็อตรูและรูปร่างพิเศษจะถูกล้างโดยอัตโนมัติ',
    ug: 'ئاساسى: تەھرىرلەشنىڭدىن كېيىن قوزغىتىلغان قۇرۇلار ۋاقىتتا تاختىلار قوزغىتىلغانلىقى قىلىنىپ تاختىلار قوزغىتىلغانلىقى قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىلىنىپ قىل',
    vi: 'Lưu ý: Chỉnh sửa sẽ tự động xóa các lỗ, khe và hình dạng không đều',
    zh_tc: '注意 ：修改後將自動清除孔槽和異形',
    ru: 'Примечание: после внесения изменений отверстия и фасоны будут автоматически очищены',
    ko: '참고: 수정하면 구멍 슬롯 및 이형이 자동으로 지워집니다.',
    bur: 'သတိ: ပြင်ဆင်ပြီးနောက် ပေါက်ကြိုးနှင့်အထူးပုံကိုအလိုအလျောက်ဖယ်ရှားမည်',
    ben: 'সতর্কতা: পরিবর্তনের পর গর্ত-স্লট এবং বিশেষ আকৃতি স্বয়ংক্রিয়ভাবে সাফ হবে',
    tr: 'Dikkat: Degisiklikten sonra delik, kanal ve ozel sekiller otomatik olarak temizlenecektir',
    km: 'ចំណាំ៖ បន្ទាប់ពីកែប្រែ រន្ធ ចង្អូរ និងរាងពិសេស នឹងត្រូវសម្អាតដោយស្វ័យប្រវត្តិ',
    es: 'Nota: Después de la modificación, los agujeros y las formas especiales se borrarán automáticamente',
    ar: 'ملاحظة: بعد التعديل، سيتم مسح الثقوب والأشكال الخاصة تلقائيًا',
  },
  'materialPage.edit.allEdge': {
    zh: '全部封边',
    en: 'All Edges',
    id: 'Semua segel perbatasan',
    kz: 'Барлық жағалар',
    th: 'ตราประทับชายแดนทั้งหมด',
    ug: 'ตราประทับชายแดนทั้งหมด',
    vi: 'Tất cả Các cạnh',
    zh_tc: '全部封邊',
    ru: 'Все края',
    ko: '모서리 모두 닫기',
    bur: 'ဘောင်အားလုံးပိတ်ဆို့',
    ben: 'সব প্রান্ত বন্ধ করুন',
    tr: 'Tum Kenarlari Bantla',
    km: 'បិទគែមទាំងអស់',
    es: 'Todas las bandas de borde',
    ar: 'جميع نطاقات الحواف',
  },
  'materialPage.add.title': {
    zh: '添加板件',
    en: 'Add board',
    id: 'Tambahkan papan',
    kz: 'Панельді қосу',
    th: 'เพิ่มบอร์ด',
    ug: 'تاختا قۇرۇش',
    vi: 'Thêm Bảng',
    zh_tc: '添加板件',
    ru: 'Добавить панель',
    ko: '보드 추가',
    bur: 'ပေါ်ဒ်ထည့်ပါ',
    ben: 'বোর্ড যোগ করুন',
    tr: 'Panel Ekle',
    km: 'បន្ថែមបន្ទះ',
    es: 'Agregar paneles',
    ar: 'إضافة لوحات',
  },
  'materialPage.add.continue': {
    zh: '确认并继续',
    en: 'Confirm and continue',
    id: 'Konfirmasi dan lanjutkan',
    kz: 'Тастықтап, жалғастыру',
    th: 'ยืนยันและดำเนินการต่อ',
    ug: 'تەھرىرلەش ئىقتىدارىنى تاقاش',
    vi: 'Xác nhận và Tiếp tục',
    zh_tc: '確認並繼續',
    ru: 'Подтвердить и продолжить',
    ko: '확인 및 계속',
    bur: 'အတည်ပြုပြီးဆက်လုပ်',
    ben: 'নিশ্চিত করুন এবং চালিয়ে যান',
    tr: 'Onayla ve Devam Et',
    km: 'បញ្ជាក់ និងបន្ត',
    es: 'Confirmar y continuar',
    ar: 'التأكيد والمتابعة',
  },
  'materialPage.add.matCodeErr': {
    zh: '材质不能为空',
    en: 'The material cannot be empty',
    id: 'Materi tidak bisa kosong',
    kz: 'Материалды код бос болмайды',
    th: 'วัสดุไม่สามารถว่างเปล่า',
    ug: 'ماتېرىيال بوش قالمايدۇ',
    vi: 'Vật liệu không thể để trống',
    zh_tc: '材質不能為空',
    ru: 'Материал не может быть пустым.',
    ko: '재료는 비워둘 수 없습니다.',
    bur: 'ပစ္စည်းဗလာမဖြစ်ရ',
    ben: 'উপকরণ খালি রাখা যাবে না',
    tr: 'Malzeme bos olamaz',
    km: 'សម្ភារៈមិនអាចទទេបានទេ',
    es: 'El material no puede estar vacío',
    ar: 'لا يمكن أن تكون المادة فارغة',
  },
  'materialPage.add.thickErr': {
    zh: '厚度不能为空',
    en: 'Thickness cannot be empty',
    id: 'Ketebalan tidak bisa kosong',
    kz: 'Қалыңдық бос болмайды',
    th: 'ความหนาไม่สามารถว่างเปล่า',
    ug: 'قېلىنلىق بوش قالمايدۇ',
    vi: 'Độ dày không thể để trống',
    zh_tc: '厚度不能為空',
    ru: 'Толщина не должна быть пустой.',
    ko: '두께는 비워둘 수 없습니다.',
    bur: 'အထူဗလာမဖြစ်ရ',
    ben: 'পুরুত্ব খালি রাখা যাবে না',
    tr: 'Kalinlik bos olamaz',
    km: 'កម្រាស់មិនអាចទទេបានទេ',
    es: 'El espesor no puede estar vacío',
    ar: 'لا يمكن أن يكون السمك فارغًا',
  },
  'materialPage.add.colorErr': {
    zh: '颜色不能为空',
    en: 'The color cannot be empty',
    id: 'Warnanya tidak bisa kosong',
    kz: 'Түс бос болмайды',
    th: 'สีไม่สามารถว่างเปล่า',
    ug: 'رەڭگى بوش قالمايدۇ',
    vi: 'Màu sắc không thể để trống',
    zh_tc: '顏色不能為空',
    ru: 'Цвет не может быть пустым',
    ko: '색상은 비워둘 수 없습니다.',
    bur: 'အရောင်ဗလာမဖြစ်ရ',
    ben: 'রঙ খালি রাখা যাবে না',
    tr: 'Renk bos olamaz',
    km: 'ពណ៌មិនអាចទទេបានទេ',
    es: 'El color no puede estar vacío',
    ar: 'لا يمكن أن يكون اللون فارغًا',
  },
  'materialPage.add.longErr': {
    zh: '成品长度不能为空',
    en: 'The length of the finished product cannot be empty',
    id: 'Panjang produk jadi tidak bisa kosong',
    kz: 'Жабдықтардың ұзындығы бос болмайды',
    th: 'ความยาวของผลิตภัณฑ์สำเร็จรูปไม่สามารถว่างเปล่าได้',
    ug: 'تاختى ئۇزۇنلۇقى بوش قالمايدۇ',
    vi: 'Chiều dài hoàn thành không thể để trống',
    zh_tc: '成品長度不能為空',
    ru: 'Длина изделия не должна быть пустой.',
    ko: '최종 품목 길이는 비워둘 수 없습니다.',
    bur: 'ပြီးစီးသောကုန်ပစ္စည်းအရှည်ဗလာမဖြစ်ရ',
    ben: 'সম্পন্ন পণ্যের দৈর্ঘ্য খালি রাখা যাবে না',
    tr: 'Bitmis urun uzunlugu bos olamaz',
    km: 'ប្រវែងផលិតផលសម្រេចមិនអាចទទេបានទេ',
    es: 'La longitud del producto terminado no puede estar vacía',
    ar: 'لا يمكن أن يكون طول المنتج النهائي فارغًا',
  },
  'materialPage.add.widthErr': {
    zh: '成品宽度不能为空',
    en: 'Finished product width cannot be empty',
    id: 'Lebar produk jadi tidak bisa kosong',
    kz: 'Жабдықтардың ені бос болмайды',
    th: 'ความกว้างของผลิตภัณฑ์สำเร็จรูปไม่สามารถว่างเปล่าได้',
    ug: 'تاختى كەڭلىكى بوش قالمايدۇ',
    vi: 'Chiều rộng hoàn thành không thể để trống',
    zh_tc: '成品寬度不能為空',
    ru: 'Ширина изделия не должна быть пустой.',
    ko: '최종 품목 너비는 비워둘 수 없습니다.',
    bur: 'ပြီးစီးသောကုန်ပစ္စည်းအကျယ်ဗလာမဖြစ်ရ',
    ben: 'সম্পন্ন পণ্যের প্রস্থ খালি রাখা যাবে না',
    tr: 'Bitmis urun genisligi bos olamaz',
    km: 'ទទឹងផលិតផលសម្រេចមិនអាចទទេបានទេ',
    es: 'El ancho del producto terminado no puede estar vacío',
    ar: 'لا يمكن أن يكون عرض المنتج النهائي فارغًا',
  },
  'materialPage.add.countErr': {
    zh: '数量至少为1',
    en: 'The quantity must be at least 1',
    id: 'Angka setidaknya 1',
    kz: 'Саны кем дегенде 1 болуы керек',
    th: 'จำนวนอย่างน้อย 1',
    ug: 'ئەڭ كىچىك كېسىش ئۆلچىمى بىر',
    vi: 'Số lượng phải ít nhất là 1',
    zh_tc: '數量至少為1',
    ru: 'Количество не менее 1',
    ko: '최소 1 개',
    bur: 'အရေအတွက်အနည်းဆုံး ၁ ဖြစ်ရမည်',
    ben: 'পরিমাণ কমপক্ষে ১ হতে হবে',
    tr: 'Miktar en az 1 olmali',
    km: 'បរិមាណត្រូវតែយ៉ាងហោចណាស់ 1',
    es: 'La cantidad debe ser al menos 1',
    ar: 'يجب أن تكون الكمية على الأقل 1',
  },
  'materialPage.delete.tip': {
    zh: '删除该数据后不可恢复，是否确认删除该数据？',
    en: 'The data cannot be restored after deletion. Are you sure you want to delete it? ',
    id: 'Itu tidak dapat dipulihkan setelah menghapus data. Apakah Anda yakin bahwa data dihapus?',
    kz: 'Бұл деректерді жоюдан кейін қалпына келтіруге болмайды, деректерді жоюға тастықтанасыз ба?',
    th: 'ไม่สามารถกู้คืนได้หลังจากลบข้อมูล คุณแน่ใจหรือไม่ว่าข้อมูลถูกลบ?',
    ug: 'بۇ سانلىق مەلۇمات ئۆچۈرۈلگەندىن كېيىن ئەسلىگە كەلتۈرگىلى بولمايدۇ، راستلا بۇ سانلىق مەلۇماتنى ئۆچۈرەمسىز؟',
    vi: 'Dữ liệu này không thể khôi phục sau khi xóa. Bạn có chắc chắn muốn xóa không?',
    zh_tc: '刪除該數據後不可恢復，是否確認刪除該數據？',
    ru: 'Данные не могут быть восстановлены после удаления, подтверждается ли удаление данных?',
    ko: '데이터를 삭제한 후 복구할 수 없습니다. 삭제하시겠습니까?',
    bur: 'ဤဒေတာဖျက်ပြီးမပြန်ရနိုင်ပါ၊ ဖျက်ရန်အတည်ပြုမည်လား?',
    ben: 'এই ডেটা মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন কি?',
    tr: 'Bu veri silindikten sonra geri yuklenemez, silmeyi onayliyor musunuz?',
    km: 'បន្ទាប់ពីលុបទិន្នន័យនេះ វាមិនអាចស្ដារឡើងវិញបានទេ តើអ្នកបញ្ជាក់លុបឬ?',
    es: 'Estos datos no se pueden restaurar después de eliminarlos. ¿Confirmas eliminar estos datos?',
    ar: 'لا يمكن استعادة هذه البيانات بعد الحذف. هل تؤكد حذف هذه البيانات؟',
  },
  'materialPage.delete.errTip': {
    zh: '请先至少选中一个板件再进行此操作!',
    en: 'Please select at least one board before performing this operation!',
    id: 'Pilih setidaknya satu papan sebelum melakukan operasi ini!',
    kz: 'Бұл операцияны жасау үшін кем дегенде бір панельді таңдаңыз!',
    th: 'โปรดเลือกบอร์ดอย่างน้อยหนึ่งบอร์ดก่อนดำเนินการนี้!',
    ug: 'بۇ مەشغۇلاتنى ئىجرا قىلىشتىن بۇرۇن ئەڭ ئاز دېگەندە بىر تاختىنى تاللاڭ!',
    vi: 'Vui lòng chọn ít nhất một bảng trước khi thực hiện thao tác này!',
    zh_tc: '請先至少選中一個板件再進行此操作!',
    ru: 'Пожалуйста, выберите хотя бы одну панель для этой операции!',
    ko: '이 작업을 수행하려면 먼저 하나 이상의 보드를 선택하십시오.',
    bur: 'ဤလုပ်ဆောင်မှုမပြုမီ ပေါ်ဒ်အနည်းဆုံးတစ်ခုရွေးပါ!',
    ben: 'এই অপারেশন করার আগে অন্তত একটি বোর্ড নির্বাচন করুন!',
    tr: 'Lutfen once bu islemi yapmadan en az bir panel secin!',
    km: 'សូមជ្រើសបន្ទះយ៉ាងហោចណាស់មួយ មុនពេលធ្វើប្រតិបត្តិការនេះ!',
    es: '¡Seleccione al menos un panel antes de realizar esta operación!',
    ar: 'يرجى تحديد لوحة واحدة على الأقل قبل إجراء هذه العملية!',
  },
  'materialPage.delete.errTip1': {
    zh: '请至少选中一个板件再进行排版',
    en: 'Please select at least one board before performing the layout',
    id: 'Pilih setidaknya satu papan dan ketik',
    kz: 'Тексеру жасау үшін кем дегенде бір панельді таңдаңыз',
    th: 'โปรดเลือกอย่างน้อยหนึ่งบอร์ดและพิมพ์',
    ug: 'تەرتىپلەشتىن بۇرۇن ئەڭ ئاز دېگەندە بىر تاختىنى تاللاڭ',
    vi: 'Vui lòng chọn ít nhất một bảng trước khi thực hiện sắp xếp',
    zh_tc: '請至少選中一個板件再進行排版',
    ru: 'Пожалуйста, выберите хотя бы одну панель для повторного оформления.',
    ko: '하나 이상의 보드를 선택한 다음 레이아웃하십시오.',
    bur: 'ပြင်ဆင်မှုမပြုမီ ပေါ်ဒ်အနည်းဆုံးတစ်ခုရွေးပါ',
    ben: 'লেআউটের আগে অন্তত একটি বোর্ড নির্বাচন করুন',
    tr: 'Lutfen dizgiden once en az bir panel secin',
    km: 'សូមជ្រើសបន្ទះយ៉ាងហោចណាស់មួយ មុនពេលធ្វើប្លង់',
    es: 'Seleccione al menos una placa antes de componer',
    ar: 'الرجاء تحديد لوحة واحدة على الأقل قبل التنضيد',
  },
  'materialPage.delete.confirm': {
    zh: '确认删除',
    en: 'Confirm deletion',
    id: 'Konfirmasi penghapusan',
    kz: 'Деректерді жою',
    th: 'ยืนยันการลบ',
    ug: 'ئۆچۈرۈشنى جەزملەش',
    vi: 'Xác nhận Xóa',
    zh_tc: '確認刪除',
    ru: 'Подтвердите удаление',
    ko: '삭제 확인',
    bur: 'ဖျက်ဆီးမှုအတည်ပြု',
    ben: 'মুছা নিশ্চিত করুন',
    tr: 'Silmeyi Onayla',
    km: 'បញ្ជាក់ការលុប',
    es: 'Confirmar eliminación',
    ar: 'تأكيد الحذف',
  },
  'materialPage.restore.confirm': {
    zh: '确认还原',
    en: 'Confirm restoration',
    id: 'Konfirmasi pemulihan',
    kz: 'Қалпына келтіруді растау',
    th: 'ยืนยันการกู้คืน',
    ug: 'ئەسلىگە كەلتۈرۈشنى جەزملەش',
    vi: 'Xác nhận khôi phục',
    zh_tc: '確認還原',
    ru: 'Подтвердить восстановление',
    ko: '복원 확인',
    bur: 'ပြန်လည်ထားရှိမှုအတည်ပြု',
    ben: 'পুনরুদ্ধার নিশ্চিত করুন',
    tr: 'Geri yüklemeyi onayla',
    km: 'បញ្ជាក់ការស្តារឡើងវិញ',
    es: 'Confirmar restauración',
    ar: 'تأكيد الاستعادة',
  },
  'materialPage.restoreConfirm': {
    zh: '还原后，余料将移回余料清单或余料库。确认要还原该余料吗？',
    en: 'After restoration, the leftover material will be moved back to the surplus list or surplus stock. Are you sure you want to restore this leftover?',
    id: 'Setelah dipulihkan, material sisa akan dipindahkan kembali ke daftar atau gudang sisa. Apakah Anda yakin ingin memulihkan material sisa ini?',
    kz: 'Қалпына келтірілгеннен кейін, қалдық материал қалдықтар тізіміне немесе қоймасына қайтарылады. Бұл қалдық материалды қалпына келтіруге сенімдісіз бе?',
    th: 'หลังจากคืนค่าแล้ว วัสดุเหลือจะถูกย้ายกลับไปยังรายการหรือคลังวัสดุเหลือ คุณแน่ใจหรือไม่ว่าต้องการคืนค่าวัสดุเหลือนี้?',
    ug: 'ئەسلىگە كەلتۈرۈلگەن كېيىن، ئېرتىق ماتېرىياللار ئېرتىق تىزىم ياكى ئېرتىق قورۇمىسىغا قايتۇرىلىدۇ. بۇ ئېرتىق ماتېرىيالنى راستلا ئەسلىگە كەلتۈرمەكچىمۇسىز؟',
    vi: 'Sau khi khôi phục, vật liệu thừa sẽ được chuyển lại vào danh sách hoặc kho vật liệu thừa. Bạn có chắc chắn muốn khôi phục vật liệu thừa này không?',
    zh_tc: '還原後，餘料將移回餘料清單或餘料庫。是否確認還原此餘料？',
    ru: 'После восстановления остаток будет возвращён в список остатков или на склад остатков. Вы уверены, что хотите восстановить этот остаток?',
    ko: '복원 후 남은 자재는 남은 자재 목록이나 창고로 이동됩니다. 이 자재를 정말 복원하시겠습니까?',
    bur: 'ပြန်လည်ထားရှိပြီးနောက် ပိုလျှံပစ္စည်းသည် ပိုလျှံပစ္စည်းစာရင်း သို့မဟုတ် သိုလှောင်ရုံသို့ ပြန်ရွှေ့ပါမည်။ ဤပစ္စည်းကို ပြန်လည်ထားရှိရန် သေချာပါသလား။',
    ben: 'পুনরুদ্ধারের পর উদ্বৃত্ত উপকরণটি উদ্বৃত্ত তালিকায় বা উদ্বৃত্ত গুদামে ফিরিয়ে নেওয়া হবে। আপনি কি এই উপকরণটি পুনরুদ্ধার করতে চান?',
    tr: 'Geri yüklendikten sonra kalan malzeme, artık listesine veya stokuna geri taşınacaktır. Bu malzemeyi geri yüklemek istediğinize emin misiniz?',
    km: 'បន្ទាប់ពីស្តារឡើងវិញ សម្ភារៈសំណល់នឹងត្រូវបានផ្លាស់ទីទៅបញ្ជីឬឃ្លាំងសំណល់វិញ។ តើអ្នកប្រាកដថាចង់ស្តារសម្ភារៈនេះទេ?',
    es: 'Después de la restauración, el material sobrante se moverá de nuevo a la lista o almacén de sobrantes. ¿Estás seguro de que quieres restaurar este material sobrante?',
    ar: 'بعد الاستعادة، سيتم نقل المادة المتبقية إلى قائمة أو مستودع المواد المتبقية. هل أنت متأكد أنك تريد استعادة هذه المادة المتبقية؟',
  },
  'materialPage.restoreBatchConfirm': {
    zh: '确认要还原选中的余料吗？',
    en: 'Are you sure you want to restore the selected leftover materials?',
    id: 'Apakah Anda yakin ingin memulihkan material sisa yang dipilih?',
    kz: 'Таңдалған қалдық материалдарды қалпына келтіргіңіз келетініне сенімдісіз бе?',
    th: 'ยืนยันการกู้คืนวัสดุเหลือที่เลือกหรือไม่?',
    ug: 'تاللانغان ئېرتىق ماتېرىياللارنى ئەسلىگە كەلتۈرەمسىز؟',
    vi: 'Bạn có chắc chắn muốn khôi phục các vật liệu thừa đã chọn không?',
    zh_tc: '確認要還原選中的餘料嗎？',
    ru: 'Вы уверены, что хотите восстановить выбранные остатки?',
    ko: '선택한 남은 자재를 복원하시겠습니까?',
    bur: 'ရွေးချယ်ထားသော ပိုလျှံပစ္စည်းများကို ပြန်လည်ထားရှိရန် သေချာပါသလား။',
    ben: 'নির্বাচিত উদ্বৃত্ত উপকরণগুলি পুনরুদ্ধার করতে চান?',
    tr: 'Seçilen kalan malzemeleri geri yüklemek istediğinize emin misiniz?',
    km: 'តើអ្នកប្រាកដថាចង់ស្តារសម្ភារៈសំណល់ដែលបានជ្រើសរើសទេ?',
    es: '¿Estás seguro de que quieres restaurar los materiales sobrantes seleccionados?',
    ar: 'هل أنت متأكد أنك تريد استعادة المواد المتبقية المحددة؟',
  },
  'materialPage.save.errTip': {
    zh: '没有可以保存的信息!',
    en: 'There is no information to save!',
    id: 'Tidak ada informasi untuk disimpan!',
    kz: 'Сақтайтын деректер жоқ!',
    th: 'ไม่มีข้อมูลที่จะบันทึก!',
    ug: 'ساقلاشقا سانلىق مەلۇمات يوق!',
    vi: 'Không có thông tin để lưu!',
    zh_tc: '沒有可以保存的信息!',
    ru: 'Нет информации, которую можно сохранить!',
    ko: '저장할 정보가 없습니다!',
    bur: 'သိမ်းဆည်းနိုင်သောသတင်းမရှိ!',
    ben: 'সংরক্ষণ করার কোনো তথ্য নেই!',
    tr: 'Kaydedilecek bilgi yok!',
    km: 'មិនមានព័ត៌មានអាចរក្សាទុកបានទេ!',
    es: '¡No hay información que se pueda guardar!',
    ar: 'لا توجد معلومات يمكن حفظها!',
  },
  'materialPage.save.title': {
    zh: '保存方案',
    en: 'Save Scheme',
    id: 'Simpan rencananya',
    kz: 'Схема сақтау',
    th: 'บันทึกแผน',
    ug: 'پىلاننى ساقلاش',
    vi: 'Lưu giải pháp',
    zh_tc: '保存方案',
    ru: 'Сохранить программу',
    ko: '스키마 저장',
    bur: 'စီမံချက်သိမ်းပါ',
    ben: 'পরিকল্পনা সংরক্ষণ করুন',
    tr: 'Şemayı Kaydet',
    km: 'រក្សាទុកគ្រោងការណ៍',
    es: 'Guardar plan',
    ar: 'حفظ الخطة',
  },
  'materialPage.save.subTitle': {
    zh: '(注：历史仅保存一年)',
    en: '(Attention: history is only saved for one year)',
    id: '(Catatan: Sejarah hanya disimpan selama satu tahun)',
    kz: '(Ескерту: Жабық сақтайтын деректер бір жылға сақтайды)',
    th: '(หมายเหตุ: ประวัติจะถูกบันทึกไว้เป็นเวลาหนึ่งปีเท่านั้น)',
    ug: '(دىققەت: تارىخىي خاتىرە پەقەت بىر يىل ساقلىنىدۇ)',
    vi: '(Chú ý: lịch sử chỉ lưu trữ trong một năm)',
    zh_tc: '(注：歷史僅保存一年)',
    ru: '(Примечание: История хранится только один год)',
    ko: '(참고: 기록은 1년만 저장됨)',
    bur: '(မှတ်ချက်: မှတ်တမ်းတစ်နှစ်သာသိမ်းသည်)',
    ben: '(নোট: ইতিহাস শুধুমাত্র এক বছর সংরক্ষিত হয়)',
    tr: '(Dikkat: Geçmiş yalnızca bir yıl saklanır)',
    km: '(ចំណាំ៖ ប្រវត្តិរក្សាទុកត្រឹមមួយឆ្នាំប៉ុណ្ណោះ)',
    es: '(Nota: El historial solo se guarda durante un año)',
    ar: '(ملاحظة: يتم حفظ السجل لمدة عام واحد فقط)',
  },
  'materialPage.save.name': {
    zh: '方案名称',
    en: 'Scheme Name',
    id: 'Nama program',
    kz: 'Схема атауы',
    th: 'ชื่อโปรแกรม',
    ug: 'پروگرامما نامى',
    vi: 'Tên giải pháp',
    zh_tc: '方案名稱',
    ru: 'Название программы',
    ko: '스키마 이름',
    bur: 'စီမံချက်အမည်',
    ben: 'পরিকল্পনার নাম',
    tr: 'Şema Adı',
    km: 'ឈ្មោះគ្រោងការណ៍',
    es: 'Nombre del plan',
    ar: 'اسم الخطة',
  },
  'materialPage.save.historyName': {
    zh: '历史方案',
    en: 'Historical scheme',
    id: 'Rencana Sejarah',
    kz: 'Жабық схема',
    th: 'แผนประวัติศาสตร์',
    ug: 'تارىخىي پىلان',
    vi: 'Giải pháp lịch sử',
    zh_tc: '歷史方案',
    ru: 'Историческая программа',
    ko: '히스토리 시나리오',
    bur: 'ဂတိသမ်စီမံချက်',
    ben: 'ঐতিহাসিক পরিকল্পনা',
    tr: 'Tarihsel şema',
    km: 'គ្រោងការណ៍ប្រវត្តិសាស្ត្រ',
    es: 'Plan histórico',
    ar: 'الخطة التاريخية',
  },
  'materialPage.save.successTip': {
    zh: '保存成功!',
    en: 'Save successfully!',
    id: 'Simpan dengan sukses!',
    kz: 'Сақтау сәтті!',
    th: 'ประหยัดได้สำเร็จ!',
    ug: 'مۇۋەپپەقىيەتلىك ساقلاندى!',
    vi: 'Lưu thành công!',
    zh_tc: '保存成功!',
    ru: 'Сохранить успешно!',
    ko: '저장 성공!',
    bur: 'သိမ်းဆည်းမှုအောင်မြင်သည်!',
    ben: 'সংরক্ষণ সফল হয়েছে!',
    tr: 'Başarıyla kaydedildi!',
    km: 'រក្សាទុកជោគជ័យ!',
    es: '¡Guardado exitosamente!',
    ar: 'تم الحفظ بنجاح!',
  },
  'materialPage.save.fieldTip': {
    zh: '保存失败!',
    en: 'Save failed!',
    id: 'Menyimpan Gagal!',
    kz: 'Сақтау сәтсіз!',
    th: 'การออมล้มเหลว!',
    ug: 'ساقلاش مەغلۇپ بولدى!',
    vi: 'Lưu thất bại!',
    zh_tc: '保存失敗!',
    ru: 'Ошибка сохранения!',
    ko: '저장 실패!',
    bur: 'သိမ်းဆည်းမှုမအောင်မြင်ပါ!',
    ben: 'সংরক্ষণ ব্যর্থ হয়েছে!',
    tr: 'Kaydetme başarısız!',
    km: 'រក្សាទុកបរាជ័យ!',
    es: '¡Error al guardar!',
    ar: 'فشل الحفظ!',
  },
  'materialPage.exportErr': {
    zh: '暂无板件,无法进行导出',
    en: 'No board is available for export at the moment',
    id: 'Belum ada papan, ekspor tidak dapat dilakukan',
    kz: 'Панельдер жоқ, экспорттау мүмкін емес',
    th: 'ยังไม่มีบอร์ดไม่สามารถส่งออกได้',
    ug: 'تاختا يوق، چىقىرىشقا بولمايدۇ',
    vi: 'Hiện chưa có tấm gỗ, không thể xuất',
    zh_tc: '暫無板件,無法進行導出',
    ru: 'Нет панелей, невозможно экспортировать',
    ko: '판넬 없음, 내보낼 수 없음',
    bur: 'ပေါ်ဒ်မရှိ၊ ထုတ်မနိုင်',
    ben: 'কোনো বোর্ড নেই, রপ্তানি করা যাচ্ছে না',
    tr: 'Şu anda dışa aktarılacak pano yok',
    km: 'មិនមានក្តារអាចនាំចេញបានទេ',
    es: 'No hay placa, no se puede exportar',
    ar: 'لا توجد لوحة، لا يمكن تصديرها',
  },
  'materialPage.exportPicErr': {
    zh: '导出板件孔槽图时遇到未知错误，请联系我们解决',
    en: 'An unknown error occurred while exporting the board hole slot diagram. Please contact us for resolution',
    id: 'Kesalahan yang tidak diketahui ditemui saat mengekspor diagram slot lubang pelat, silakan hubungi kami untuk menyelesaikannya',
    kz: 'Панельдердің тесіктір шемасын экспорттау кезінде белгісіз хата كелді, бізбен хабарласыңыз',
    th: 'พบข้อผิดพลาดที่ไม่รู้จักเมื่อส่งออกไดอะแกรมสล็อตรูของแผ่นโปรดติดต่อเราเพื่อแก้ไข',
    ug: 'تاختا ئېغىز رەسىمىنى چىقىرىشتا نامەلۇم خاتالىق كۆرۈلدى، زەھمەت بولسا بىز بىلەن ئالاقىلىشىڭ',
    vi: 'Gặp lỗi không xác định khi xuất hình ảnh khe chân của tấm gỗ, vui lòng liên hệ với chúng tôi để giải quyết',
    zh_tc: '導出板件孔槽圖時遇到未知錯誤，請聯繫我們解決',
    ru: 'Неизвестная ошибка при экспорте рисунка отверстий панели, пожалуйста, свяжитесь с нами, чтобы исправить',
    ko: '보드 구멍 슬롯 다이어그램을 내보내는 중 알 수 없는 오류가 발생했습니다. 해결 방법을 문의하십시오.',
    bur: 'ပေါ်ဒ်ပေါက်ကြိုးပုံထုတ်ချိန်အမည်မသိအမှားကြုံပါသည်၊ ကျွန်ုပ်တို့ကိုဆက်သွယ်ပါ',
    ben: 'বোর্ড গর্ত-স্লট চিত্র রপ্তানিকালে অজানা ত্রুটি ঘটেছে, আমাদের সাথে যোগাযোগ করুন',
    tr: 'Pano delik yuvası diyagramı dışa aktarılırken bilinmeyen bir hata oluştu. Lütfen çözüm için bizimle iletişime geçin',
    km: 'បានជួបប្រទះកំហុសមិនស្គាល់នៅពេលនាំចេញដ្យាក្រាមរន្ធក្តារ សូមទាក់ទងយើងខ្ញុំដើម្បីដោះស្រាយ',
    es: 'Se encontró un error desconocido al exportar el diagrama de orificios y ranuras de la placa; contáctenos para solucionarlo',
    ar: 'تمت مواجهة خطأ غير معروف عند تصدير فتحة اللوحة ومخطط الفتحة، يرجى الاتصال بنا للحصول على الحل',
  },
  'materialPage.plankNotFound': {
    zh: '未查询到相关板件!请确认是否绘制板件!',
    en: 'No relevant board found! Please confirm whether to draw the board!',
    id: 'Tidak ada papan yang relevan yang ditemukan! Harap konfirmasi apakah akan menggambar papan!',
    kz: 'Панельдерді таба алмады! Панельдерді сызуды тастықтайсыз ба?',
    th: 'ไม่พบบอร์ดที่เกี่ยวข้อง! โปรดยืนยันว่าจะวาดบอร์ด!',
    ug: 'مۇناسىۋەتلىك تاختا تېپىلمىدى! تاختا سىزىشنى جەزملەڭ!',
    vi: 'Không tìm thấy tấm gỗ liên quan! Vui lòng xác nhận đã vẽ tấm gỗ chưa!',
    zh_tc: '未查詢到相關板件!請確認是否繪製板件!',
    ru: 'Соответствующая доска не найдена! Убедитесь, что вы рисуете панель!',
    ko: '관련 보드가 검색되지 않았습니다!판넬을 그릴지 확인하세요!',
    bur: 'သက်ဆိုင်ရာပေါ်ဒ်မတွေ့ပါ! ပေါ်ဒ်ဆွဲပြီးမပြီးအတည်ပြုပါ!',
    ben: 'সংশ্লিষ্ট বোর্ড পাওয়া যায়নি! বোর্ড আঁকা হয়েছে কিনা নিশ্চিত করুন!',
    tr: 'İlgili pano bulunamadı! Lütfen panoyu çizip çizmediğinizi onaylayın!',
    km: 'រកមិនឃើញក្តារពាក់ព័ន្ធទេ! សូមបញ្ជាក់ថាតើគូសក្តាររួចឬនៅ!',
    es: '¡No se encontraron paneles relevantes! ¡Por favor confirme si desea dibujar los paneles!',
    ar: 'لم يتم العثور على اللوحات ذات الصلة! يرجى تأكيد ما إذا كان سيتم رسم اللوحات!',
  },
  'materialPage.noPlankName': {
    zh: '未找到板件名称',
    en: 'No board name found',
    id: 'Tidak ada nama papan yang ditemukan',
    kz: 'Панельдің атауы табылмады',
    th: 'ไม่พบชื่อบอร์ด',
    ug: 'تاختا نامى تېپىلمىدى',
    vi: 'Không tìm thấy tên tấm gỗ',
    zh_tc: '未找到板件名稱',
    ru: 'Имя панели не найдено',
    ko: '보드 이름을 찾을 수 없습니다.',
    bur: 'ပေါ်ဒ်အမည်မတွေ့ပါ',
    ben: 'বোর্ডের নাম পাওয়া যায়নি',
    tr: 'Pano adı bulunamadı',
    km: 'រកមិនឃើញឈ្មោះក្តារទេ',
    es: 'Nombre del panel no encontrado',
    ar: 'لم يتم العثور على اسم اللوحة',
  },
  'materialPage.plankDataErr': {
    zh: '板件数据错误，请仔细检查，避免生产损失',
    en: 'The plank data is incorrect. Please check carefully to avoid production losses',
    id: 'Kesalahan data papan, silakan periksa dengan cermat untuk menghindari kerugian produksi',
    kz: 'Панельдердің деректері қателік бар, мұқият тексеріңіз, өндіріске залал келмесін дегенді қамтамасыз етуіңіз',
    th: 'ข้อผิดพลาดข้อมูลบอร์ดโปรดตรวจสอบอย่างรอบคอบเพื่อหลีกเลี่ยงการสูญเสียการผลิต',
    ug: 'تاختا سانلىق مەلۇمات خاتالىقى، ئىشلەپچىقىرىش زىيانىدىن ساقلىنىش ئۈچۈن دىققەت بىلەن تەكشۈرۈڭ',
    vi: 'Dữ liệu tấm gỗ không chính xác, vui lòng kiểm tra kỹ, để tránh tổn thất sản xuất',
    zh_tc: '板件數據錯誤，請仔細檢查，避免生產損失',
    ru: 'Ошибка данных на досках, проверьте внимательно, чтобы избежать производственных потерь',
    ko: '판넬 데이터 오류, 생산 손실을 방지하기 위해 자세히 확인하십시오.',
    bur: 'ပေါ်ဒ်ဒေတာမှားနေသည်၊ ထုတ်လုပ်မှုဆုံးရှုံးမှုကိုရှောင်ရှားရန်သေချာစစ်ဆေးပါ',
    ben: 'বোর্ড ডেটা ভুল, উৎপাদন ক্ষতি এড়াতে সাবধানে পরীক্ষা করুন',
    tr: 'Pano verileri hatalı. Üretim kayıplarını önlemek için lütfen dikkatlice kontrol edin',
    km: 'ទិន្នន័យក្តារមានកំហុស សូមពិនិត្យដោយប្រុងប្រយ័ត្នដើម្បីជៀសវាងការខាតបង់ផលិតកម្ម',
    es: 'Los datos del panel son incorrectos, verifique cuidadosamente para evitar pérdidas de producción',
    ar: 'بيانات اللوحة خاطئة، يرجى التحقق بعناية لتجنب خسائر الإنتاج',
  },
  'materialPage.exportThreeViewErr': {
    zh: '导出孔槽三视图失败,请联系售后处理',
    en: 'Failed to export the three views of the hole slot. Please contact after-sales for handling',
    id: 'Tiga tampilan slot lubang gagal, silakan hubungi layanan purna jual',
    kz: 'Тесіктір шемасының үш көрінісіні экспорттау сәтсіз, техникалық қызметке хабарласыңыз',
    th: 'สามมุมมองของสล็อตหลุมล้มเหลวโปรดติดต่อบริการหลังการขาย',
    ug: 'ئۈچ تەرەپلىك ئېغىز كۆرۈنۈشىنى چىقىرىش مەغلۇپ بولدى، زەھمەت بولسا مۇلازىمەت بىلەن ئالاقىلىشىڭ',
    vi: 'Xuất hình ảnh tam chiếu khe chân thất bại, vui lòng liên hệ với hậu mãi để xử lý',
    zh_tc: '導出孔槽三視圖失敗,請聯繫售後處理',
    ru: 'Невозможно экспортировать три вида отверстий, свяжитесь с послепродажной обработкой',
    ko: '구멍 슬롯 3개 뷰를 내보내지 못했습니다. 사후 처리에 문의하십시오.',
    bur: 'ပေါက်ကြိုးသုံးဘက်မြင်ကွင်းထုတ်မှုမအောင်မြင်ပါ၊ အရောင်းပြီးနောက်ဝန်ဆောင်မှုကိုဆက်သွယ်ပါ',
    ben: 'গর্ত-স্লট ত্রিভিউ রপ্তানি ব্যর্থ হয়েছে, বিক্রয়োত্তর সেবায় যোগাযোগ করুন',
    tr: 'Delik yuvası üç görünüm dışa aktarma başarısız oldu. Lütfen satış sonrası hizmetle iletişime geçin',
    km: 'ការនាំចេញទិដ្ឋភាពបីរន្ធបរាជ័យ សូមទាក់ទងសេវាក្រោយការលក់',
    es: 'No se pudieron exportar tres vistas de orificios y ranuras, comuníquese con el servicio posventa',
    ar: 'فشل تصدير ثلاث طرق عرض للثقوب والفتحات، يرجى الاتصال بخدمة ما بعد البيع',
  },
  'materialPage.heighGlossWarning': {
    zh: '注意：材质为高光板时，修改材质后板件将无法恢复成高光板！',
    en: 'Attention: When the material is a high gloss plate, the plate cannot be restored to a high gloss plate after modifying the material!',
    id: 'CATATAN: Ketika materi adalah highlighter, papan tidak akan dapat mengembalikannya ke stabilo setelah memodifikasi materi!',
    kz: 'Ескерту: Материалдың мазасы жоғары бағыты болған кезде, материалды өзгертудің кейін плақтарды мазадан көтеру мүмкін емес!',
    th: 'หมายเหตุ: เมื่อวัสดุเป็นปากกาเน้นข้อความบอร์ดจะไม่สามารถกู้คืนไปยังปากกาเน้นข้อความได้หลังจากแก้ไขวัสดุ!',
    ug: 'دىققەت: ماتېرىيال يۇقىرى يالتىراق بولغاندا، تەھرىرلەنگەندىن كېيىن تاختا ئەسلىگە كەلتۈرۈلمەيدۇ!',
    vi: 'Chú ý: Khi chất liệu là tấm gỗ có độ bóng cao, sau khi thay đổi chất liệu, tấm gỗ sẽ không thể khôi phục lại độ bóng cao!',
    zh_tc: '注意：材質為高光板時，修改材質後板件將無法恢復成高光板！',
    ru: 'Примечание: когда материал является высокой световой пластиной, изменение задней панели материала не сможет восстановить высокую световую пластину!',
    ko: '참고: 재료가 고광판인 경우 재료를 수정한 후 판재를 고광판으로 복원할 수 없습니다!',
    bur: 'သတိ: ပစ္စည်းသည်မြင့်မားသောဝင်းပတ်ပေါ်ဒ်ဖြစ်သောအခါ ပစ္စည်းပြင်ဆင်ပြီးနောက်ပေါ်ဒ်ကိုမြင့်မားသောဝင်းပတ်ပေါ်ဒ်သို့ပြန်မရနိုင်ပါ!',
    ben: 'নোট: উপকরণ হাই গ্লস বোর্ড হলে, উপকরণ পরিবর্তনের পরে বোর্ডটি হাই গ্লস বোর্ডে পুনরুদ্ধার করা যাবে না!',
    tr: 'Dikkat: Malzeme parlak yüzeyli plaka olduğunda, malzemeyi değiştirdikten sonra pano parlak yüzeyli plakaya geri yüklenemez!',
    km: 'ចំណាំ៖ នៅពេលសម្ភារៈជាក្តារភ្លឺ ក្តារមិនអាចស្តារឡើងវិញជាក្តារភ្លឺបានទេបន្ទាប់ពីកែប្រែសម្ភារៈ!',
    es: 'Nota: Cuando el material es un tablero de alto brillo, el tablero no se restaurará a un tablero de alto brillo después de modificar el material.',
    ar: 'ملاحظة: عندما تكون المادة عبارة عن لوحة شديدة اللمعان، لن تتم استعادة اللوحة إلى لوحة شديدة اللمعان بعد تعديل المادة!',
  },
  'materialPage.reset': {
    zh: '恢复默认',
    en: 'Restore default',
    id: 'Kembalikan default',
    kz: 'Кез-келгенді қалпына келтіру',
    th: 'กู้คืนค่าเริ่มต้น',
    ug: 'ئەسلىگە قايتۇرۇش',
    vi: 'Khôi phục mặc định',
    zh_tc: '恢復默認',
    ru: 'восстановить по умолчанию',
    ko: '기본 복원',
    bur: 'မူရင်းပြန်ထားပါ',
    ben: 'ডিফল্ট পুনরুদ্ধার করুন',
    tr: 'Varsayılanı geri yükle',
    km: 'ស្តារលំនាំដើម',
    es: 'Restaurar valor predeterminado',
    ar: 'استعادة الافتراضي',
  },
  'materialPage.settingHead.title': {
    zh: '设置开料清单表头',
    en: 'Set the header of the cutting list',
    id: 'Menyiapkan header Bill of Material',
    kz: 'Кескіштердің тізімдіңіздің басты қисмы',
    th: 'การตั้งค่าส่วนหัวของบิลวัสดุ',
    ug: 'ماتېرىيال ھېسابات باشلىقى تەڭشىكى',
    vi: 'Cài đặt tiêu đề danh sách tài nguyên mở rộng',
    zh_tc: '設置開料清單表頭',
    ru: 'Настройка заголовка списка открытых материалов',
    ko: '커팅 리스트 헤더 설정',
    bur: 'ဖြတ်တောက်စာရင်းဇယားခေါင်းစဉ်သတ်မှတ်ပါ',
    ben: 'কাটার তালিকার শিরোনাম সেট করুন',
    tr: 'Kesim listesi başlığını ayarla',
    km: 'កំណត់ក្បាលរបារបញ្ជីកាត់',
    es: 'Establecer el encabezado de la lista de corte',
    ar: 'قم بتعيين رأس قائمة القطع',
  },
  'materialPage.settingHead.head': {
    zh: '表头',
    en: 'Header',
    id: 'Header',
    kz: 'Басты қисм',
    th: 'ส่วนหัว',
    ug: 'باشلىق',
    vi: 'Tiêu đề',
    zh_tc: '表頭',
    ru: 'Часы',
    ko: '표두',
    bur: 'ဇယားခေါင်းစဉ်',
    ben: 'সারণী শিরোনাম',
    tr: 'Başlık',
    km: 'ក្បាលរបារ',
    es: 'Encabezado',
    ar: 'الرأس',
  },
  'materialPage.settingHead.customHeadName': {
    zh: '自定义表头名',
    en: 'Custom header name',
    id: 'Nama header kustom',
    kz: 'Жеке басты қисм атауы',
    th: 'ชื่อหัวตารางที่กำหนดเอง',
    ug: 'ئۆزلەشتۈرۈلگەن باشلىق نامى',
    vi: 'Tên tiêu đề tùy chỉnh',
    zh_tc: '自定義表頭名',
    ru: 'Пользовательское название заголовка',
    ko: '사용자 지정 머리글 이름',
    bur: 'စိတ်ကြိုက်ဇယားခေါင်းစဉ်အမည်',
    ben: 'কাস্টম শিরোনামের নাম',
    tr: 'Özel başlık adı',
    km: 'ឈ្មោះក្បាលរបារផ្ទាល់ខ្លួន',
    es: 'Personalizar nombre del encabezado',
    ar: 'تخصيص اسم الرأس',
  },
  'materialPage.settingHead.example': {
    zh: '样例',
    en: 'sample',
    id: 'Mencicipi',
    kz: 'Үлгі',
    th: 'ตัวอย่าง',
    ug: 'مىسال',
    vi: 'Mẫu',
    zh_tc: '樣例',
    ru: 'Пример',
    ko: '예제',
    bur: 'နမူနာ',
    ben: 'নমুনা',
    tr: 'Örnek',
    km: 'គំរូ',
    es: 'Ejemplo',
    ar: 'مثال',
  },
  'materialPage.settingHead.tip': {
    zh: ' 操作提示：可左右拖动 表头数据标签 位置 ',
    en: ' Operation tips: Drag the header data label left and right to change its position ',
    id: 'Tip Operasi: Anda dapat menyeret posisi label data tabel kiri dan kanan',
    kz: 'Қолдану сүзі: Басты қисмнің деректер таңбашасын сол жаққа немесе оң жаққа сүйретуге болады',
    th: 'เคล็ดลับการดำเนินงาน: คุณสามารถลากตำแหน่งป้ายข้อมูลตารางซ้ายและขวา',
    ug: 'ئىشلەتكۈچى ئۇچۇرى: جەدۋەل باشلىقىنىڭ ئورنىنى سول ياكى ئوڭغا سۆرەپ ئۆزگەرتەلەيسىز',
    vi: 'Ghi chú: Có thể kéo trái-phải để thay đổi vị trí nhãn dữ liệu tiêu đề',
    zh_tc: ' 操作提示：可左右拖動 表頭數據標籤 位置 ',
    ru: 'Советы по действию: можно перетаскивать заголовок таблицы влево и вправо',
    ko: '작업 팁: 머리글 데이터 레이블 위치를 좌우로 드래그할 수 있습니다.',
    bur: 'လုပ်ဆောင်မှုအကြံပြု: ဇယားခေါင်းဒေတာဆိပ်ကမ်းကိုဘယ်ညာဆွဲဆောင်နိုင်သည်',
    ben: 'পরিচালনা টিপস: সারণী শিরোনাম ডেটা লেবেলের অবস্থান বাম-ডানে টেনে পরিবর্তন করা যায়',
    tr: 'İşlem ipucu: Başlık veri etiketini konumunu değiştirmek için sola veya sağa sürükleyebilirsiniz',
    km: 'ព័ត៌មានប្រតិបត្តិការ៖ អាចអូសស្លាកទិន្នន័យក្បាលរបារឆ្វេងស្តាំដើម្បីផ្លាស់ប្តូរទីតាំង',
    es: 'Consejos de operación: Puede arrastrar la etiqueta de datos del encabezado hacia la izquierda y hacia la derecha. Posición',
    ar: 'تلميحات العملية: يمكنك سحب تسمية بيانات الرأس إلى اليسار واليمين. الموضع',
  },
  'materialPage.settingHead.headerNameEmpty': {
    zh: '表头不能为空',
    en: 'Header name cannot be empty',
    id: 'Nama header tidak boleh kosong',
    kz: 'Тақырып бос болмауы керек',
    th: 'หัวตารางต้องไม่ว่างเปล่า',
    ug: 'جەدۋەل باشلىقى بوش قالسا بولمايدۇ',
    vi: 'Tiêu đề không được để trống',
    zh_tc: '表頭不能為空',
    ru: 'Заголовок не может быть пустым',
    ko: '머리글은 비워둘 수 없습니다',
    bur: 'ခေါင်းစဉ်အလွတ်မဖြစ်ရပါ',
    ben: 'শিরোনাম খালি রাখা যাবে না',
    tr: 'Başlık boş olamaz',
    km: 'ក្បាលរបារមិនអាចទទេបានទេ',
    es: 'El encabezado no puede estar vacío',
    ar: 'لا يمكن أن يكون الرأس فارغًا',
  },
  'materialPage.settingHead.duplicateHeader': {
    zh: '存在重复表头',
    en: 'Duplicate header name',
    id: 'Nama header duplikat',
    kz: 'Қайталанатын тақырып бар',
    th: 'มีหัวตารางซ้ำ',
    ug: 'تەكرارلانغان جەدۋەل باشلىقى',
    vi: 'Tiêu đề bị trùng lặp',
    zh_tc: '存在重複表頭',
    ru: 'Дублирующийся заголовок',
    ko: '중복된 머리글입니다',
    bur: 'ပြန်လည်ခေါင်းစဉ်ရှိသည်',
    ben: 'সারণী শিরোনামের সদৃশ আছে',
    tr: 'Yinelenen başlık',
    km: 'មានក្បាលរបារស្ទួន',
    es: 'Hay un encabezado duplicado',
    ar: 'يوجد رأس مكرر',
  },
  'materialPage.copyLine': {
    zh: '点击可在下方复制当前行',
    en: 'Click to copy the current line below',
    id: 'Klik untuk menyalin baris saat ini di bawah ini',
    kz: 'Төмендегіге тегін қоймасын шертуңыз',
    th: 'คลิกเพื่อคัดลอกบรรทัดปัจจุบันด้านล่าง',
    ug: 'ھازىرقى قۇرنى كۆچۈرۈش ئۈچۈن چېكىڭ',
    vi: 'Nhấn để sao chép dòng hiện tại ở bên dưới',
    zh_tc: '點擊可在下方複製當前行',
    ru: 'Нажмите, чтобы скопировать текущую строку ниже.',
    ko: '현재 줄을 복사하려면 누르십시오',
    bur: 'ကလစ်နှိပ်ပြီးအောက်တွင်လက်ရှိကြောင်းကူးယူနိုင်သည်',
    ben: 'ক্লিক করে নিচে বর্তমান সারি কপি করুন',
    tr: 'Mevcut satırı aşağıya kopyalamak için tıklayın',
    km: 'ចុចដើម្បីចម្លងជួរបច្ចុប្បន្នទៅខាងក្រោម',
    es: 'Haga clic para copiar la fila actual debajo',
    ar: 'انقر لنسخ الصف الحالي أدناه',
  },
  'materialPage.copySuccess': {
    zh: '复制{name}数据成功',
    en: 'Copying {name} data succeeded',
    id: 'Menyalin {name} Data berhasil',
    kz: '{name} деректері копирілді',
    th: 'การคัดลอกข้อมูล {name} สำเร็จ',
    ug: '{name} سانلىق مەلۇماتنى كۆچۈرۈش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Sao chép dữ liệu {name} thành công',
    zh_tc: '複製{name}數據成功',
    ru: 'Успешно скопированы данные {name}',
    ko: '{name} 데이터 복사 성공',
    bur: '{name} ဒေတာကူးယူမှုအောင်မြင်သည်',
    ben: '{name} ডেটা কপি সফল হয়েছে',
    tr: '{name} verisi kopyalama başarılı',
    km: 'ចម្លងទិន្នន័យ {name} ជោគជ័យ',
    es: 'Copie los datos de {name} correctamente',
    ar: 'انسخ بيانات {name} بنجاح',
  },
  'materialPage.arranging': {
    zh: '共计{count}张小板正在优化排版中......',
    en: 'A total of {count} small boards are being optimized for layout...',
    id: 'Total {Count} Zhang Xiaoban sedang dioptimalkan dan diketik ...',
    kz: 'Жалпы {count} кіші кескіштің оптималдау қалыптасуда......',
    th: '{count} Zhang Xiaoban ทั้งหมดได้รับการปรับให้เหมาะสมและพิมพ์ ...',
    ug: 'جەمئىي {count} كىچىك تاختا مۇۋەپپەقىيەتلىك تەرتىپلەندى ۋە بېسىلىۋاتىدۇ...',
    vi: 'Tổng cộng có {count} tấm gỗ nhỏ đang được tối ưu hóa bố cục...',
    zh_tc: '共計{count}張小板正在優化排版中......',
    ru: 'Всего {count} досок размером менее 1220 мм находятся в процессе оптимизации раскроя...',
    ko: '{count} 장의 작은 보드가 조판을 최적화하는 중입니다...',
    bur: 'စုစုပေါင်း {count} ချပ်ငယ်ပေါ်ဒ် ပြင်ဆင်မှုကောင်းမွန်အောင်ပြုလုပ်နေသည်......',
    ben: 'মোট {count} টি ছোট বোর্ড লেআউট অপ্টিমাইজ করা হচ্ছে......',
    tr: 'Toplam {count} küçük pano yerleşim için optimize ediliyor......',
    km: 'សរុបក្តារតូច {count} កំពុងបង្កើនប្រសិទ្ធភាពរចនាសម្ព័ន្ធ......',
    es: 'Un total de {count} tableros pequeños se están optimizando para la composición tipográfica...',
    ar: 'يتم تحسين إجمالي {count} اللوحات الصغيرة للتنضيد...',
  },
  'materialPage.overSize.title': {
    zh: '板件超尺',
    en: 'Board oversize',
    id: 'Penguasa super untuk piring',
    kz: 'Кескіштің өлшемі асыпты',
    th: 'ผู้ปกครองซุปเปอร์',
    ug: 'ئارتۇق چوڭ تاختا',
    vi: 'Tấm gỗ quá lớn',
    zh_tc: '板件超尺',
    ru: 'Метаметр для пластин',
    ko: '판재 초척',
    bur: 'ပေါ်ဒ်ကြီးလွန်',
    ben: 'বোর্ড অতিরিক্ত আকার',
    tr: 'Pano boyutu aşımı',
    km: 'ក្តារលើសវិមាត្រ',
    es: 'Panel sobredimensionado',
    ar: 'لوحة كبيرة الحجم',
  },
  'materialPage.overSize.subTitle': {
    zh: '超尺板件清单',
    en: 'Oversized plate list',
    id: 'Daftar bagian papan ukuran super',
    kz: 'Өлшемі асыпты кескіштердің тізімі',
    th: 'รายชื่อชิ้นส่วนบอร์ดขนาดใหญ่',
    ug: 'چوڭ ئۆلچەملىك تاختا بۆلەك تىزىملىكى',
    vi: 'Danh sách tấm gỗ quá lớn',
    zh_tc: '超尺板件清單',
    ru: 'Перечень надлинейных панелей',
    ko: '하이퍼스케일 인벤토리',
    bur: 'အကြီးလွန်ပေါ်ဒ်ငယ်စာရင်း',
    ben: 'অতিরিক্ত আকারের বোর্ড তালিকা',
    tr: 'Büyük boyutlu pano listesi',
    km: 'បញ្ជីក្តារលើសវិមាត្រ',
    es: 'Lista de tableros de gran tamaño',
    ar: 'قائمة لوحات كبيرة الحجم',
  },
  'materialPage.overSize.overSizeTip': {
    zh: '板件超尺提示',
    en: 'Plate oversize prompt',
    id: 'Tips untuk piring dengan penguasa tambahan',
    kz: 'Кескіштің өлшемі асыпты туралы ескерту',
    th: 'เคล็ดลับสำหรับเพลตที่มีไม้บรรทัดพิเศษ',
    ug: 'ئالاھىدە چوڭ تاختا ئۈچۈن ئۇچۇر',
    vi: 'Thông báo tấm gỗ quá lớn',
    zh_tc: '板件超尺提示',
    ru: 'Гиперлинейка панелей',
    ko: '보드 하이퍼바이트 힌트',
    bur: 'ပေါ်ဒ်ကြီးလွန်သတိပေးချက်',
    ben: 'বোর্ড অতিরিক্ত আকারের সতর্কবার্তা',
    tr: 'Pano boyutu aşımı uyarısı',
    km: 'ការជូនដំណឹងក្តារលើសវិមាត្រ',
    es: 'Aviso sobre tamaño del panel',
    ar: 'مطالبة لوحة كبيرة الحجم',
  },
  'materialPage.overSize.nonWorkInfo': {
    zh: '无法加工的板件详情',
    en: 'Details of the unprocessable board',
    id: 'Detail pelat yang belum diproses',
    kz: 'Өңдеуге болмайды кескіштердің деректері',
    th: 'รายละเอียดของแผ่นที่ยังไม่ผ่านกระบวนการ',
    ug: 'تەرتىپلەنمىگەن تاختا تەپسىلاتى',
    vi: 'Chi tiết tấm gỗ không thể chế tạo',
    zh_tc: '無法加工的板件詳情',
    ru: 'Невозможно обработать детали',
    ko: '가공할 수 없는 플레이트 상세 정보',
    bur: 'လုပ်မနိုင်သောပေါ်ဒ်အသေးစိတ်',
    ben: 'প্রক্রিয়া করা যাচ্ছে না এমন বোর্ডের বিস্তারিত',
    tr: 'İşlenemeyen pano detayları',
    km: 'ព័ត៌មានលម្អិតក្តារមិនអាចដំណើរការបាន',
    es: 'Detalles de los paneles que no se pueden procesar',
    ar: 'تفاصيل اللوحات التي لا يمكن معالجتها',
  },
  'materialPage.overSize.mergeFrameDoorWholeTip': {
    zh: '注意：本部件是组合加工的骨骼门整体',
    en: 'Note: This part is a whole of the merged frame door',
    id: 'Catatan: Bagian ini adalah keseluruhan dari pintu frame yang digabungkan',
    kz: 'Өзіндік кескіштердің бірігуіне арналған кескіштердің бөлшектері',
    th: 'รายละเอียดของแผ่นที่ยังไม่ผ่านกระบวนการ',
    ug: 'تەپسىلاتى ئېلەكلىك تاختا تەڭشەك قوشۇڭ',
    vi: 'Chi tiết tấm gỗ không thể chế tạo',
    zh_tc: '注意：本部件為組合加工的骨骼門整體',
    ru: 'Примечание: этот компонент является целым для слияния дверных рам',
    ko: '주의: 이 부품은 프레임 도어 병합 처리의 전체입니다',
    bur: 'မှတ်ချက်: ဤအစိတ်အပိုင်းသည်အရိုးတံခါးတစ်ခုလုံးအတွက်ပေါင်းစပ်လုပ်ငန်းဖြစ်သည်',
    ben: 'দ্রষ্টব্য: এই প্যার্ট একটি মার্জ প্রসেসিং ফ্রেম ডোর সম্পূর্ণ',
    tr: 'Not: Bu parça birleştirilmiş çerçeve kapının tamamıdır',
    km: 'មានការព័ត៌មាត្រ: សន្លឹកនេះគឺជាកន្ទការបង្ហាញនៃរបារពិន្ទុដែលបានបង្ហាញជាមួយគ្នា',
    es: 'Nota: Este componente es una puerta esqueleto completa que procesado en combinación',
    ar: 'ملاحظة: هذا المكون هو باب هيكلي كامل تمت معالجته معًا',
  },
  'materialPage.overSize.conflictWorkInfo': {
    zh: '冲突的板件详情',
    en: 'Details of the conflicting plates',
    id: 'Detail Dewan Konflik',
    kz: 'Қарама-қайшы тақтайшалардың бөлшектері',
    th: 'รายละเอียดคณะกรรมการความขัดแย้ง',
    ug: 'توقۇنۇش تاختا تەپسىلاتى',
    vi: 'Chi tiết của các tấm xung đột',
    zh_tc: '衝突的板件詳情',
    ru: 'Подробности конфликта',
    ko: '충돌하는 보드 상세 정보',
    bur: 'ပဋိပက္ခဖြစ်နေသောပေါ်ဒ်အသေးစိတ်',
    ben: 'সাংঘর্ষিক বোর্ডের বিস্তারিত',
    tr: 'Çakışan panoların detayları',
    km: 'ព័ត៌មានលម្អិតក្តារជម្លោះ',
    es: 'Detalles de los paneles en conflicto',
    ar: 'تفاصيل اللوحات المتعارضة',
  },
  'materialPage.overSize.warning': {
    zh: '检测到有小板尺寸过长，导致无法排版！请调整小板尺寸或添加对应尺寸原片',
    en: 'It is detected that the small board size is too long, resulting in an inability to format! Please adjust the small board size or add corresponding size originals',
    id: 'Terdeteksi bahwa papan kecil terlalu panjang, yang membuatnya tidak mungkin untuk mengetik! Harap sesuaikan ukuran papan kecil atau tambahkan lembar asli ukuran yang sesuai',
    kz: 'Кіші кескіштердің өлшемі тым ұзын, қалыптастыруға болмайды! Кіші кескіштердің өлшеміні өзгертіңіз немесе тиісті өлшемдігіттіңіз қосыңыз',
    th: 'ตรวจพบว่าบอร์ดขนาดเล็กนั้นยาวเกินไปซึ่งทำให้มันเป็นไปไม่ได้ที่จะพิมพ์! โปรดปรับขนาดของบอร์ดขนาดเล็กหรือเพิ่มแผ่นต้นฉบับขนาดที่สอดคล้องกัน',
    ug: 'كىچىك تاختا ئۇزۇنلۇقى نورمالدىن ئېشىپ كەتكەن، تەرتىپلەشكە بولمايدۇ! زەھمەت بولسا كىچىك تاختا ئۆلچىمىنى ئۆزگەرتىڭ ياكى ماس كېلىدىغان چوڭ تاختا قوشۇڭ',
    vi: 'Phát hiện có kích thước tấm gỗ nhỏ quá dài, dẫn đến không thể bố cục! Vui lòng điều chỉnh kích thước tấm gỗ nhỏ hoặc thêm tấm nguyên liệu có kích thước tương ứng',
    zh_tc:
      '檢測到有小板尺寸過長，導致無法排版！請調整小板尺寸或添加對應尺寸原片',
    ru: 'Было обнаружено, что размер доски слишком длинный, что привело к невозможности типографии! Измените размер панели или добавьте оригинал соответствующего размера.',
    ko: '판자 크기가 너무 긴 것이 감지되어 조판이 불가능합니다!보드 크기를 조정하거나 해당 크기 원본을 추가하십시오.',
    bur: 'ပေါ်ဒ်ငယ်အရွယ်ရှည်လွန်ကြောင်းစစ်ဆေးတွေ့ရှိ၍ မပြင်ဆင်နိုင်! ပေါ်ဒ်ငယ်အရွယ်ညှိပေးပါ သို့မဟုတ် သင့်တော်သောအရွယ်မူရင်းချပ်ထည့်ပါ',
    ben: 'ছোট বোর্ডের আকার অত্যধিক দীর্ঘ হওয়ায় লেআউট করা যাচ্ছে না! ছোট বোর্ডের আকার ঠিক করুন বা সংশ্লিষ্ট আকারের মূল শীট যোগ করুন',
    tr: 'Küçük pano boyutunun çok uzun olduğu tespit edildi, yerleşim yapılamıyor! Lütfen küçük pano boyutunu ayarlayın veya uygun boyutta orijinal levha ekleyin',
    km: 'រកឃើញថាវិមាត្រក្តារតូចវែងពេក មិនអាចរៀបចំបាន! សូមកែតម្រូវវិមាត្រក្តារតូច ឬបន្ថែមសន្លឹកដើមវិមាត្រដែលត្រូវគ្នា',
    es: '¡Se detectó un pequeño panel que era demasiado largo, lo que hacía imposible la composición tipográfica! Ajuste el tamaño del tablero pequeño o agregue la pieza original del tamaño correspondiente',
    ar: 'تم اكتشاف لوحة صغيرة كانت طويلة جدًا، مما يجعل من المستحيل تنضيدها! يرجى ضبط حجم اللوحة الصغيرة أو إضافة القطعة الأصلية بالحجم المقابل',
  },
  'materialPage.overSize.checkInfo': {
    zh: '查看板件详情',
    en: 'View the details of the board',
    id: 'Lihat detail papan',
    kz: 'Кескіштердің деректеріні қараңыз',
    th: 'ดูรายละเอียดของบอร์ด',
    ug: 'تاختا تەپسىلاتىنى كۆرۈش',
    vi: 'Xem chi tiết tấm gỗ',
    zh_tc: '查看板件詳情',
    ru: 'Посмотреть подробнее',
    ko: '보드 상세 정보 보기',
    bur: 'ပေါ်ဒ်အသေးစိတ်ကြည့်ပါ',
    ben: 'বোর্ডের বিস্তারিত দেখুন',
    tr: 'Pano detaylarını görüntüle',
    km: 'មើលព័ត៌មានលម្អិតក្តារ',
    es: 'para ver los detalles del tablero.',
    ar: 'لعرض تفاصيل اللوحة',
  },
  'materialPage.overSize.tipContent': {
    zh: '系统检查到排版小板中存在超尺板件，下面是特殊板材添加建议，可以手动修改板材长宽后点击表格下方<span class="bold color-0">“一键添加”</span>按钮，快速添加后继续排版，也可以在<span class="bold color-0">原片设置-特殊板材</span>手动添加板件 ',
    en: 'The system has detected that there are oversized plates in the layout template. Below are suggestions for adding special plates. You can manually modify the length and width of the plates and click the One-click Add button below the table to quickly add them and continue with the layout. Alternatively, you can manually add plates in the Original Sheet Settings - Special Plates',
    id: 'Sistem memeriksa apakah ada papan super berukuran di papan tata letak. Di bawah ini adalah saran untuk menambahkan papan khusus. Anda dapat memodifikasi panjang dan lebar papan secara manual dan mengklik tombol <span class = "Bold Color-0"> "satu klik tambah" di bagian bawah tabel. Setelah dengan cepat menambahkan, Anda dapat terus mengetik. Anda juga dapat menambahkan papan secara manual di <span class = "Bold Color-0"> Papan khusus lembar-lembar </span>',
    kz: 'Система кіші кескіштердің қалыптасуында өлшемі асыпты кескіштерді табады. Кескіштердің кеңді мен бейіктігіңізді өзгертеңіз, содан кейін табліцаның астындағы “Бірден қосу” батырмасын басып, қалыптасуды тездіріңіз немесе “Оригиналды кескіштер - Әрікеше кескіштер” дегенге кіріңіз және кескіштерді қосыңыз',
    th: 'ระบบตรวจสอบว่ามีบอร์ดขนาดใหญ่ในบอร์ดเลย์เอาต์ ด้านล่างนี้เป็นคำแนะนำสำหรับการเพิ่มบอร์ดพิเศษ คุณสามารถปรับเปลี่ยนความยาวและความกว้างของบอร์ดด้วยตนเองและคลิกปุ่ม <span class = "BOLD COLOR-0"> "เพิ่มการเพิ่มหนึ่งคลิก" ที่ด้านล่างของตาราง หลังจากเพิ่มอย่างรวดเร็วคุณสามารถพิมพ์ต่อไป นอกจากนี้คุณยังสามารถเพิ่มบอร์ดด้วยตนเองใน <span class = "bold color-0"> กระดานการตั้งค่าชีตดั้งเดิม-พิเศษ </span>',
    ug: 'سىستېما تاختا تەرتىپىدە چوڭ ئۆلچەملىك تاختا بارلىقىنى بايقىدى. تۆۋەندىكىسى ئالاھىدە چوڭ تاختا قوشۇش ئۇچۇرى. ئۆلچەمنى قولدا ئۆزگەرتىپ، جەدۋەل ئاستىدىكى <span class = "BOLD COLOR-0">"بىر چېكىش بىلەن قوشۇش"</span> كۇنۇپكىسىنى بېسىڭ. تېز قوشقاندىن كېيىن داۋاملىق تەرتىپلەشكە بولىدۇ. يەنە <span class = "bold color-0">"ئاساسىي-ئالاھىدە تاختا تەڭشەك تاختىسى"</span>دىن قولدا قوشالايسىز.',
    vi: 'Hệ thống phát hiện có tấm gỗ nhỏ trong bố cục có kích thước quá lớn, dưới đây là gợi ý thêm tấm đặc biệt, có thể sửa đổi kích thước tấm gỗ bằng tay sau đó nhấn nút <span class="bold color-0">“Thêm nhanh”</span> ở dưới bảng, để nhanh chóng thêm tiếp tục bố cục, hoặc cũng có thể thêm tấm gỗ bằng tay tại <span class="bold color-0">Cài đặt tấm nguyên liệu - Tấm đặc biệt</span>',
    zh_tc:
      '系統檢查到排版小板中存在超尺板件，下面是特殊板材添加建議，可以手動修改板材長寬後點擊表格下方<span class="bold color-0">"一鍵添加"</span>按鈕，快速添加後繼續排版，也可以在<span class="bold color-0">原片設置-特殊板材</span>手動添加板件 ',
    ru: 'Система проверяет наличие надлинейных пластин в наборной доске, ниже приведены специальные рекомендации по добавлению пластины, вы можете вручную изменить длину и ширину пластины после нажатия кнопки < span class = "bold color - 0" под таблицей < span class = "bold color - 0" > "Добавление одним нажатием" < / span >, после быстрого добавления продолжить типографию, или вы можете сделать это в < span class = "bold color - 0" > Настройка оригинала - специальная пластина < / span >',
    ko: '시스템은 조판 소판에 초척 판재가 존재하는 것을 검사했다. 아래는 특수 판재 첨가 건의이다. 판재 길이와 폭을 수동으로 수정한 후 표 아래의 <span class="bold color-0">"원클릭 추가"</span> 버튼을 클릭하여 빠르게 추가한 후 계속 조판하거나 <span class="bold color-0"> 원판 설정-특수 판재 <span> 수동으로',
    bur: 'စနစ်သည်ပြင်ဆင်မှုပေါ်ဒ်ငယ်တွင်ကြီးလွန်သောပေါ်ဒ်ရှိကြောင်းစစ်ဆေးတွေ့ရှိ၍ အထူးပေါ်ဒ်ထည့်ရန်အကြံပြုချက်ပေးပါသည်',
    ben: 'সিস্টেম লেআউট ছোট বোর্ডে অতিরিক্ত আকারের বোর্ড শনাক্ত করেছে, বিশেষ বোর্ড যোগ করার পরামর্শ দেওয়া হচ্ছে',
    tr: 'Sistem yerleşim şablonunda büyük boyutlu panolar tespit etti. Özel panolar ekleme önerileri aşağıdadır. Panoların uzunluk ve genişliğini manuel olarak değiştirip tablonun altındaki Tek Tıkla Ekle düğmesine tıklayabilir veya Orijinal Levha Ayarları - Özel Panolar bölümünden manuel ekleyebilirsiniz',
    km: 'ប្រព័ន្ធរកឃើញក្តារលើសវិមាត្រក្នុងក្តារតូចរៀបចំ ខាងក្រោមជាការណែនាំបន្ថែមក្តារពិសេស អាចកែប្រែប្រវែងទទឹងក្តារដោយដៃ រួចចុចប៊ូតុង "បន្ថែមមួយចុច" ខាងក្រោមតារាង ឬបន្ថែមក្តារដោយដៃនៅការកំណត់សន្លឹកដើម-ក្តារពិសេស',
    es: 'El sistema detecta que hay paneles de gran tamaño en la tabla de composición. Las siguientes son sugerencias para agregar paneles especiales. Puede modificar manualmente la longitud y el ancho de los paneles y hacer clic en el botón <span class="bold color-0"> "Agregar con un clic" </span> debajo de la tabla para agregar y continuar con la composición rápidamente. También puede agregar paneles manualmente en <span class="bold color-0"> Configuración original - Paneles especiales </span>',
    ar: 'يكتشف النظام وجود لوحات كبيرة الحجم في لوحة التنضيد. فيما يلي اقتراحات لإضافة لوحات خاصة. يمكنك تعديل طول اللوحات وعرضها يدويًا والنقر فوق الزر <span class="bold color-0"> "إضافة بنقرة واحدة" </span> الموجود أسفل الجدول لإضافة التنضيد ومواصلته بسرعة. يمكنك أيضًا إضافة اللوحات يدويًا في <span class="bold color-0"> الإعدادات الأصلية - اللوحات الخاصة </span>',
  },
  'materialPage.overSize.add': {
    zh: '一键添加',
    en: 'One-click add',
    id: 'Tambahkan dengan satu klik',
    kz: 'Бірден қосу',
    th: 'เพิ่มด้วยคลิกเดียว',
    ug: 'بىر چېكىش بىلەن قوشۇش',
    vi: 'Thêm nhanh',
    zh_tc: '一鍵添加',
    ru: 'Один нажатие',
    ko: '클릭 한 번으로 추가',
    bur: 'တစ်ကလစ်ထည့်',
    ben: 'এক ক্লিকে যোগ করুন',
    tr: 'Tek tıkla ekle',
    km: 'បន្ថែមមួយចុច',
    es: 'Agregar con un clic',
    ar: 'إضافة بنقرة واحدة',
  },
  'materialPage.overSize.addPlank': {
    zh: '添加原片',
    en: 'Add original piece',
    id: 'Tambahkan film asli',
    kz: 'Оригиналды кескішті қосу',
    th: 'เพิ่มภาพยนตร์ต้นฉบับ',
    ug: 'ئەسلى تاختا قوشۇش',
    vi: 'Thêm tấm nguyên liệu',
    zh_tc: '添加原片',
    ru: 'Добавить оригинал',
    ko: '원본 추가',
    bur: 'မူရင်းချပ်ထည့်ပါ',
    ben: 'মূল শীট যোগ করুন',
    tr: 'Orijinal levha ekle',
    km: 'បន្ថែមសន្លឹកដើម',
    es: 'Agregar original',
    ar: 'إضافة الأصل',
  },
  'materialPage.overSize.error': {
    zh: '板件超尺，排版失败',
    en: 'The board is oversized, and the layout failed',
    id: 'Dewan adalah penguasa super, tata letak gagal',
    kz: 'Кескіштің өлшемі асыпты, қалыптасу сәтсіз',
    th: 'บอร์ดคือ Super Ruler, เค้าโครงล้มเหลว',
    ug: 'تاختا چوڭ ئۆلچەملىك، تەرتىپلەش مەغلۇپ بولدى',
    vi: 'Tấm gỗ quá lớn, bố cục thất bại',
    zh_tc: '板件超尺，排版失敗',
    ru: 'Гиперлинейка панелей, неудачная типография',
    ko: '판자 초과, 조판 실패',
    bur: 'ပေါ်ဒ်ကြီးလွန်၍ ပြင်ဆင်မှုမအောင်မြင်',
    ben: 'বোর্ড অতিরিক্ত আকার, লেআউট ব্যর্থ হয়েছে',
    tr: 'Pano boyutu aşımı, yerleşim başarısız',
    km: 'ក្តារលើសវិមាត្រ រចនាសម្ព័ន្ធបរាជ័យ',
    es: 'El tablero excede el tamaño y la tipografía falla',
    ar: 'اللوحة تجاوزت الحجم وفشل التنضيد',
  },
  'materialPage.overSize.successTip': {
    zh: '板件添加成功！正在重新排版',
    en: 'Plate added successfully! Re-formatting',
    id: 'Dewan ditambahkan dengan sukses! Diketik ulang',
    kz: 'Кескіштіңіз қосты! Қалыптасуда...',
    th: 'คณะกรรมการได้รับการเพิ่มสำเร็จ! พิมพ์ใหม่',
    ug: 'تاختا مۇۋەپپەقىيەتلىك قوشۇلدى! قايتا تەرتىپلەڭ',
    vi: 'Thêm tấm gỗ thành công! Đang bố cục lại',
    zh_tc: '板件添加成功！正在重新排版',
    ru: 'Добавлен успешно! Переформатируется.',
    ko: '보드 추가 성공!재레이아웃 중',
    bur: 'ပေါ်ဒ်ထည့်မှုအောင်မြင်သည်! ပြန်ပြင်ဆင်နေသည်',
    ben: 'বোর্ড সফলভাবে যোগ করা হয়েছে! পুনরায় লেআউট করা হচ্ছে',
    tr: 'Pano başarıyla eklendi! Yeniden yerleştiriliyor',
    km: 'បន្ថែមក្តារជោគជ័យ! កំពុងរៀបចំឡើងវិញ',
    es: '¡El tablero se agregó exitosamente! Reformateo',
    ar: 'تمت إضافة اللوحة بنجاح! إعادة التنسيق',
  },
  'materialPage.overSize.warningTip': {
    zh: '请填写板件的长宽！',
    en: 'Please fill in the length and width of the board!',
    id: 'Silakan isi panjang dan lebar papan!',
    kz: 'Кескіштің кендігіңізді толтыруңыз!',
    th: 'กรุณาเติมความยาวและความกว้างของบอร์ด!',
    ug: 'تاختا ئۇزۇنلۇقى ۋە كەڭلىكىنى تولدۇرۇڭ!',
    vi: 'Vui lòng điền kích thước dài và rộng của tấm gỗ!',
    zh_tc: '請填寫板件的長寬！',
    ru: 'Пожалуйста, заполните доску шириной!',
    ko: '판본의 너비를 기입해 주십시오!',
    bur: 'ပေါ်ဒ်အရှည်အကျယ်ဖြည့်ပါ!',
    ben: 'বোর্ডের দৈর্ঘ্য ও প্রস্থ পূরণ করুন!',
    tr: 'Lütfen panonun uzunluk ve genişliğini doldurun!',
    km: 'សូមបំពេញប្រវែងនិងទទឹងក្តារ!',
    es: '¡Rellene el largo y el ancho del tablero!',
    ar: 'يرجى ملء طول وعرض اللوحة!',
  },
  'materialPage.arrangeErr': {
    zh: '板件内部数据存在异常，无法进行排版生产',
    en: 'There are anomalies in the internal data of the board, and it is impossible to arrange production',
    id: 'Ada kelainan dalam data internal papan dan tidak dapat diketik dan diproduksi',
    kz: 'Кескіштердің ішкі деректері асыпты, қалыптасу және өндірісуге болмайды',
    th: 'มีความผิดปกติในข้อมูลภายในของบอร์ดและไม่สามารถพิมพ์และผลิตได้',
    ug: 'تاختا ئىچكى سانلىق مەلۇماتىدا خاتالىق بار، تەرتىپلەشكە ۋە ئىشلەپچىقىرىشقا بولمايدۇ',
    vi: 'Dữ liệu bên trong tấm gỗ có bất thường, không thể tiến hành bố cục sản xuất',
    zh_tc: '板件內部數據存在異常，無法進行排版生產',
    ru: 'Внутренние данные пластины ненормальны, невозможно выполнить типографское производство',
    ko: '판넬 내부 데이터에 이상이 있어 조판 생산을 진행할 수 없습니다',
    bur: 'ပေါ်ဒ်အတွင်းဒေတာပုံမမှန်ကြောင်းရှိ၍ ပြင်ဆင်မှုလုပ်ငန်းလုပ်မနိုင်',
    ben: 'বোর্ডের অভ্যন্তরীণ ডেটায় অস্বাভাবিকতা আছে, লেআউট উৎপাদন করা সম্ভব নয়',
    tr: 'Pano iç verilerinde anormallikler var, yerleşim üretimi yapılamıyor',
    km: 'ទិន្នន័យខាងក្នុងក្តារមានភាពមិនធម្មតា មិនអាចផលិតរចនាសម្ព័ន្ធបានទេ',
    es: 'Hay una anomalía en los datos internos del panel y no se puede realizar la producción tipográfica',
    ar: 'هناك خلل في البيانات الداخلية للوحة، ولا يمكن تنفيذ عملية التنضيد',
  },
  'materialPage.nonDelete': {
    zh: '不可删除',
    en: 'Cannot Delete',
    id: 'Tidak dapat dihapus',
    kz: 'Жою мүмкін емес',
    th: 'ไม่ลบ',
    ug: 'ئۆچۈرۈلمىدى',
    vi: 'Không thể xóa',
    zh_tc: '不可刪除',
    ru: 'Невозможно удалить',
    ko: '삭제 불가능',
    bur: 'မဖျက်နိုင်',
    ben: 'মুছা যাবে না',
    tr: 'Silinemez',
    km: 'មិនអាចលុបបានទេ',
    es: 'No se puede eliminar',
    ar: 'لا يمكن حذفها',
  },
  'materialPage.addOverSizeTip': {
    zh: '存在超尺，请重新添加',
    en: 'Oversize exists, please add it again',
    id: 'Ada penguasa tambahan, tambahkan lagi',
    kz: 'Үлкен өлшем бар, оны қайта қосыңыз.',
    th: 'มีไม้บรรทัดพิเศษโปรดเพิ่มอีกครั้ง',
    ug: 'ئالاھىدە چوڭ تاختا بار، قايتا قوشۇڭ',
    vi: 'Có kích thước quá khổ, vui lòng thêm lại',
    zh_tc: '存在超尺，請重新添加',
    ru: 'Наличие суперфутов, пожалуйста, добавьте снова',
    ko: '하이퍼바이트가 있습니다. 다시 추가하십시오.',
    bur: 'ကြီးလွန်မှုရှိသည်၊ ထပ်မံထည့်ပါ',
    ben: 'অতিরিক্ত আকার আছে, পুনরায় যোগ করুন',
    tr: 'Boyut aşımı mevcut, lütfen tekrar ekleyin',
    km: 'មានវិមាត្រលើស សូមបន្ថែមម្តងទៀត',
    es: 'Hay un tamaño excesivo, agréguelo nuevamente',
    ar: 'هناك حجم كبير، يرجى إضافته مرة أخرى',
  },
  'materialPage.addPlankSuccess': {
    zh: '添加特殊大板成功',
    en: 'Add Special Board successfully',
    id: 'Menambahkan papan khusus dengan sukses',
    kz: 'Арнайы тақта сәтті қосылды',
    th: 'การเพิ่มบอร์ดพิเศษให้สำเร็จ',
    ug: 'ئالاھىدە چوڭ تاختا قوشۇش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Thêm thành công tấm bảng đặc biệt',
    zh_tc: '添加特殊大板成功',
    ru: 'Добавить специальную доску успешно',
    ko: '특수 대판 추가 성공',
    bur: 'အထူးပေါ်ဒ်ကြီးထည့်မှုအောင်မြင်သည်',
    ben: 'বিশেষ বড় বোর্ড সফলভাবে যোগ করা হয়েছে',
    tr: 'Özel büyük pano başarıyla eklendi',
    km: 'បន្ថែមក្តារធំពិសេសជោគជ័យ',
    es: 'Se agregó con éxito un tablero grande especial',
    ar: 'تمت إضافة لوحة كبيرة خاصة بنجاح',
  },
  'materialPage.addPlankFail': {
    zh: '添加特殊大板失败',
    en: 'Failure to add special board',
    id: 'Gagal menambahkan papan khusus',
    kz: 'Арнайы үлкен тақта қосылмады',
    th: 'ไม่สามารถเพิ่มบอร์ดพิเศษ',
    ug: 'ئالاھىدە چوڭ تاختا قوشۇش مەغلۇپ بولدى',
    vi: 'Thêm tấm bảng đặc biệt không thành công',
    zh_tc: '添加特殊大板失敗',
    ru: 'Ошибка добавления специальной большой платы',
    ko: '특수 대시보드 추가 실패',
    bur: 'အထူးပေါ်ဒ်ကြီးထည့်မှုမအောင်မြင်ပါ',
    ben: 'বিশেষ বড় বোর্ড যোগ করা ব্যর্থ হয়েছে',
    tr: 'Özel büyük pano ekleme başarısız',
    km: 'បន្ថែមក្តារធំពិសេសបរាជ័យ',
    es: 'No se pudo agregar un tablero grande especial',
    ar: 'فشل في إضافة لوحة كبيرة خاصة',
  },
  'materialPage.paibanFeedback': {
    zh: '排版反馈',
    en: 'Layout Feedback',
    id: 'Penyusunan Huruf',
    kz: 'Панельдердің қалыптасуы',
    th: 'การตอบรับการจัดเรียง',
    ug: 'تەرتىپلەش بازا ئىنكاسى',
    vi: 'Bố trí phản hồi',
    zh_tc: '排版回饋',
    ru: 'Отзывы о типографии',
    ko: '조판 피드백',
    bur: 'ပြင်ဆင်မှုတုံ့ပြန်ချက်',
    ben: 'লেআউট ফিডব্যাক',
    tr: 'Yerleşim geri bildirimi',
    km: 'មតិការតបរចនាសម្ព័ន្ធ',
    es: 'Comentarios de composición',
    ar: 'ملاحظات التنضيد',
  },
  'materialPage.cuttingAndPaoban': {
    zh: '切割跑板',
    en: 'Cutting and Paoban',
    id: 'Pemotongan dan Penyusunan Huruf',
    kz: 'Панельдердің қалыптасуы',
    th: 'การตัดและการจัดเรียง',
    ug: 'كېسىش ۋە تەرتىپلەش',
    vi: 'Cắt và Bố trí',
    zh_tc: '切割跑板',
    ru: 'режущий бегун',
    ko: '주판을 절단하다',
    bur: 'ဖြတ်တောက်ပြင်ဆင်မှု',
    ben: 'কাটা এবং পাওবান',
    tr: 'Kesim ve yerleşim',
    km: 'កាត់និងរៀបចំ',
    es: 'Cortar el estribo',
    ar: 'لوحة تشغيل مقطوعة',
  },
  'materialPage.lowUtilizationRate': {
    zh: '利用率低',
    en: 'Low Utilization Rate',
    id: 'Tingkat Pemanfaatan Rendah',
    kz: 'Панельдердің қалыптасуы',
    th: 'อัตราการใช้งานต่ำ',
    ug: 'ئىشلەتتىش نىسبىتى تۆۋەن',
    vi: 'Tỷ lệ sử dụng thấp',
    zh_tc: '利用率低',
    ru: 'Низкий коэффициент использования',
    ko: '활용도가 낮음',
    bur: 'အသုံးချမှုနှုန်းနိမ့်',
    ben: 'কম ব্যবহারের হার',
    tr: 'Düşük kullanım oranı',
    km: 'អត្រាប្រើប្រាស់ទាប',
    es: 'Baja utilización',
    ar: 'استخدام منخفض',
  },
  'materialPage.unreasonableLayout': {
    zh: '排版不合理',
    en: 'Unreasonable Layout',
    id: 'Penyusunan Huruf Tidak Rasional',
    kz: 'Панельдердің қалыптасуы',
    th: 'การจัดเรียงไม่สมบูรณ์',
    ug: 'تەرتىپلەش ماس كەلمەيدۇ',
    vi: 'Bố trí không hợp lý',
    zh_tc: '排版不合理',
    ru: 'Печать неразумна.',
    ko: '조판이 불합리하다.',
    bur: 'ပြင်ဆင်မှုမသင့်တော်',
    ben: 'অযৌক্তিক লেআউট',
    tr: 'Mantıksız yerleşim',
    km: 'រចនាសម្ព័ន្ធមិនសមហេតុផល',
    es: 'Composición tipográfica irrazonable',
    ar: 'تنضيد غير معقول',
  },
  'materialPage.feedbackSuccessTip': {
    zh: '反馈成功!',
    en: 'Feedback Success!',
    id: 'Berhasil mengirimkan umpan balik!',
    kz: 'Панельдердің қалыптасуы',
    th: 'การตอบรับการจัดเรียงให้สำเร็จ!',
    ug: 'تەرتىپلەش بازا ئىنكاسى مۇۋەپپەقىيەتلىك بولدى!',
    vi: 'Phản hồi thành công!',
    zh_tc: '回饋成功！',
    ru: 'Обратная связь удалась!',
    ko: '피드백 성공!',
    bur: 'တုံ့ပြန်ချက်အောင်မြင်သည်!',
    ben: 'ফিডব্যাক সফল হয়েছে!',
    tr: 'Geri bildirim başarılı!',
    km: 'មតិការតបជោគជ័យ!',
    es: '¡Comentarios exitosos!',
    ar: 'ردود الفعل ناجحة!',
  },
  'materialPage.feedbackFailTip': {
    zh: '反馈失败!',
    en: 'Feedback Failed!',
    id: 'Gagal mengirimkan umpan balik!',
    kz: 'Панельдердің қалыптасуы',
    th: 'การตอบรับการจัดเรียงไม่สำเร็จ!',
    ug: 'تەرتىپلەش بازا ئىنكاسى مەغلۇپ بولدى!',
    vi: 'Phản hồi thất bại!',
    zh_tc: '回饋失敗！',
    ru: 'Ошибка обратной связи!',
    ko: '피드백 실패!',
    bur: 'တုံ့ပြန်ချက်မအောင်မြင်ပါ!',
    ben: 'ফিডব্যাক ব্যর্থ হয়েছে!',
    tr: 'Geri bildirim başarısız!',
    km: 'មតិការតបបរាជ័យ!',
    es: '¡Error en la retroalimentación!',
    ar: 'فشل التعليق!',
  },
  'materialPage.mixedLayoutScheme': {
    zh: '本次混排方案',
    en: 'Mixed Nest Plan',
    id: 'Skema penggabungan ini',
    kz: 'Бұл қосылыстар схемасы',
    th: 'การจัดเรียงประเภทผสมนี้',
    ug: 'بىرلىك ھېسابلاش سىستېمى',
    vi: 'Bố trí phản hồi',
    zh_tc: '本次混排方案',
    ru: 'Нынешняя схема смешивания',
    ko: '이번 혼합 배열 방안',
    bur: 'ဤကြိမ်ရောနှောပြင်ဆင်မှုစီမံချက်',
    ben: 'এই মিশ্র লেআউট পরিকল্পনা',
    tr: 'Bu karışık yerleşim şeması',
    km: 'គ្រោងការណ៍រចនាសម្ព័ន្ធលាយលក្ខណ៍នេះ',
    es: 'Este plano de disposición mixta',
    ar: 'خطة الترتيب المختلط هذه',
  },
  'arrangedPage.subtleDownloadCheckTip': {
    zh: '板件数据已发生变化，但未保存方案，请点击确定保存方案，再进行后续操作',
    en: 'The board data has changed but the plan has not been saved. Please click OK to save the plan before proceeding with subsequent operations',
    id: 'Data papan telah berubah tetapi rencana belum disimpan. Silakan klik OK untuk menyimpan rencana sebelum melanjutkan operasi selanjutnya',
    kz: 'Тақта деректері өзгерген, бірақ жоспар сақталмаған. Кейінгі операцияларды жалғастыру үшін алдымен жоспарды сақтау үшін OK басыңыз',
    th: 'ข้อมูลแผ่นได้เปลี่ยนแปลงแล้ว แต่ยังไม่ได้บันทึกแผน โปรดคลิกตกลงเพื่อบันทึกแผนก่อนดำเนินการต่อ',
    ug: 'تاختا بۆلەك سانلىق مەلۇماتى ئۆزگەرگەن، ئەمما پىلان ساقلانمىغان، كېيىنكى مەشغۇلاتنى داۋاملاشتۇرۇش ئۈچۈن ئاۋۋال پىلاننى ساقلاش ئۈچۈن جەزملە بېسىڭ',
    vi: 'Dữ liệu tấm đã thay đổi nhưng chưa lưu kế hoạch. Vui lòng nhấp OK để lưu kế hoạch trước khi tiếp tục các thao tác tiếp theo',
    zh_tc:
      '板件數據已發生變化，但未保存方案，請點擊確定保存方案，再進行後續操作',
    ru: 'Данные панели изменились, но не сохранен план, нажмите, чтобы определить план сохранения, а затем выполнить последующие действия',
    ko: '보드 데이터가 변경되었지만 스키마를 저장하지 않았습니다. 스키마 확인 을 클릭한 다음 다음 작업을 수행하십시오.',
    bur: 'ပေါ်ဒ်ဒေတာပြောင်းလဲသွားသော်လည်း စီမံချက်မသိမ်းရသေး၊ စီမံချက်သိမ်းရန်အတည်ပြုပြီးဆက်လုပ်ပါ',
    ben: 'বোর্ড ডেটা পরিবর্তিত হয়েছে কিন্তু পরিকল্পনা সংরক্ষিত হয়নি, পরবর্তী অপারেশনের আগে পরিকল্পনা সংরক্ষণ নিশ্চিত করুন',
    tr: 'Pano verileri değişti ancak plan kaydedilmedi. Sonraki işlemlere devam etmeden önce lütfen planı kaydetmek için Tamam butonuna tıklayın',
    km: 'ទិន្នន័យក្តារបានផ្លាស់ប្តូរ ប៉ុន្តែគ្រោងការណ៍មិនទាន់រក្សាទុក សូមចុចយល់ព្រមដើម្បីរក្សាទុកគ្រោងការណ៍ រួចធ្វើប្រតិបត្តិការបន្ត',
    es: 'Los datos del panel han cambiado, pero el plano no se ha guardado. Haga clic en Aceptar para guardar el plan antes de continuar con operaciones posteriores',
    ar: 'تم تغيير بيانات اللوحة، ولكن لم يتم حفظ الخطة. الرجاء النقر فوق "موافق" لحفظ الخطة قبل متابعة العمليات اللاحقة',
  },
  'arrangedPage.paibanRequestFailed': {
    zh: '排版请求失败，请重试',
    en: 'Layout request failed, please try again',
    id: 'Permintaan tata letak gagal, silakan coba lagi',
    kz: 'Жобалау сұранысы сәтсіз аяқталды, қайталап көріңіз',
    th: 'คำขอจัดวางล้มเหลว โปรดลองอีกครั้ง',
    ug: 'تىزىش تەلەپ قىلىش مەغلۇپ بولدى، قايتا سىناڭ',
    vi: 'Yêu cầu xếp bản thất bại, vui lòng thử lại',
    zh_tc: '排版請求失敗，請重試',
    ru: 'Запрос на раскладку не выполнен, повторите попытку',
    ko: '배치 요청이 실패했습니다. 다시 시도해 주세요',
    bur: 'အပြင်အဆင် တောင်းဆိုမှု မအောင်မြင်ပါ၊ ထပ်မံကြိုးစားပါ',
    ben: 'লেআউট অনুরোধ ব্যর্থ হয়েছে, আবার চেষ্টা করুন',
    tr: 'Dizilim isteği başarısız oldu, lütfen tekrar deneyin',
    km: 'សំណើរៀបចំប្លង់បរាជ័យ សូមព្យាយាមម្តងទៀត',
    es: 'La solicitud de composición falló, inténtalo de nuevo',
    ar: 'فشل طلب الترتيب، يرجى المحاولة مرة أخرى',
  },
  'arrangedPage.accordingPlankCountOrder': {
    zh: '按照大板数量由高到低排序',
    en: 'Sort by large board count from high to low',
    id: 'Urutkan berdasarkan jumlah papan besar dari tinggi ke rendah',
    kz: 'Үлкен тақталардың санына сәйкес жоғарыдан төменге қарай сұрыптау',
    th: 'เรียงลำดับตามจำนวนแผ่นใหญ่จากสูงไปต่ำ',
    ug: 'چوڭ تاختا سانىغا قارىتا يۇقىرىدىن تۆۋەنگە تەرتىپلەش',
    vi: 'Sắp xếp theo số lượng tấm lớn từ cao xuống thấp',
    zh_tc: '按照大板數量由高到低排序',
    ru: 'Сортировка по количеству больших панелей от высокого до низкого',
    ko: '높은 보드에서 낮은 보드로 정렬',
    bur: 'ပေါ်ဒ်ကြီးအရေအတွက်ကိုမြင့်မှနိမ့်သို့စီရင်',
    ben: 'বড় বোর্ডের সংখ্যা অনুযায়ী উচ্চ থেকে নিম্নে সাজান',
    tr: 'Büyük pano sayısına göre yüksekten düşüğe sırala',
    km: 'រៀបតាមចំនួនក្តារធំពីខ្ពស់ទៅទាប',
    es: 'Ordenar por el número de tableros grandes de mayor a menor',
    ar: 'الترتيب حسب عدد اللوحات الكبيرة من الأعلى إلى الأدنى',
  },
  'arrangedPage.editOrder': {
    zh: '编辑序号',
    en: 'Edit sequence number',
    id: 'Edit nomor urut',
    kz: 'Реттік нөмірді өңдеу',
    th: 'แก้ไขหมายเลขลำดับ',
    ug: 'تەرتىپ نومۇرىنى تەھرىرلەش',
    vi: 'Chỉnh sửa số thứ tự',
    zh_tc: '編輯序號',
    ru: 'Изменить серийный номер',
    ko: '일련번호 편집',
    bur: 'အစဉ်နံပါတ်တည်းဖြတ်',
    ben: 'ক্রম নম্বর সম্পাদনা করুন',
    tr: 'Sıra numarasını düzenle',
    km: 'កែសម្រួលលេខរៀង',
    es: 'Editar número de serie',
    ar: 'تحرير الرقم التسلسلي',
  },
  'arrangedPage.dragOrder': {
    zh: '拖动排序',
    en: 'Drag to sort',
    id: 'Seret untuk mengurutkan',
    kz: 'Сұрыптау үшін сүйрету',
    th: 'ลากเพื่อเรียงลำดับ',
    ug: 'تەرتىپلەش ئۈچۈن سۆرەش',
    vi: 'Kéo để sắp xếp',
    zh_tc: '拖動排序',
    ru: 'Сортировка перетаскиванием',
    ko: '드래그 정렬',
    bur: 'ဆွဲဆောင်စီရင်',
    ben: 'টেনে সাজান',
    tr: 'Sıralamak için sürükle',
    km: 'អូសដើម្បីរៀបចំ',
    es: 'Arrastrar para ordenar',
    ar: 'السحب للفرز',
  },
  'arrangedPage.inputOrder': {
    zh: '输入顺序',
    en: 'Input sequence',
    id: 'Masukkan urutan',
    kz: 'Ретті енгізу',
    th: 'ป้อนลำดับ',
    ug: 'تەرتىپ كىرگۈزۈش',
    vi: 'Nhập thứ tự',
    zh_tc: '輸入順序',
    ru: 'Порядок ввода',
    ko: '입력 순서',
    bur: 'အစဉ်ထည့်သွင်း',
    ben: 'ক্রম ইনপুট করুন',
    tr: 'Giriş sırası',
    km: 'បញ្ចូលលំដាប់',
    es: 'Orden de entrada',
    ar: 'ترتيب الإدخال',
  },
  'arrangedPage.editOrderTip': {
    zh: '顺序调整',
    en: 'Adjust sequence',
    id: 'Sesuaikan urutan',
    kz: 'Ретті реттеу',
    th: 'ปรับลำดับ',
    ug: 'تەرتىپنى تەڭشەش',
    vi: 'Điều chỉnh thứ tự',
    zh_tc: '順序調整',
    ru: 'Последовательность',
    ko: '순서 조정',
    bur: 'အစဉ်ညှိ',
    ben: 'ক্রম সামঞ্জস্য করুন',
    tr: 'Sırayı ayarla',
    km: 'កែតម្រូវលំដាប់',
    es: 'Ajuste de secuencia',
    ar: 'تعديل التسلسل',
  },
  'arrangedPage.range': {
    zh: '范围',
    en: 'Range',
    id: 'Rentang',
    kz: 'Ауқым',
    th: 'ช่วง',
    ug: 'دائىرە',
    vi: 'Phạm vi',
    zh_tc: '範圍',
    ru: 'диапазон',
    ko: '범위',
    bur: 'နယ်ပယ်',
    ben: 'পরিসর',
    tr: 'Aralık',
    km: 'ជួរ',
    es: 'Rango',
    ar: 'النطاق',
  },
  'arrangedPage.unsupportRotateTip': {
    zh: '部分大板已旋转，暂不支持重新排版，已旋转大板序号：',
    en: 'Some boards have been rotated and re-layout is not currently supported. Rotated board numbers:',
    id: 'Beberapa papan telah diputar, saat ini tidak mendukung penataan ulang. Nomor papan yang telah diputar:',
    kz: 'Кейбір тақталар айналдырылған, қайта орналастыру қазіргі уақытта қолдау көрсетілмейді. Айналдырылған тақта нөмірлері:',
    th: 'แผ่นบางแผ่นได้รับการหมุนแล้ว และไม่รองรับการจัดเรียงใหม่ในขณะนี้ หมายเลขแผ่นที่หมุนแล้ว:',
    ug: 'بەزى چوڭ تاختىلار ئايلاندۇرۇلغان، ھازىرچە قايتا تەرتىپلەشكە قوللىمايدۇ، ئايلاندۇرۇلغان چوڭ تاختىلارنىڭ نومۇرى:',
    vi: 'Một số tấm đã được xoay, hiện tại không hỗ trợ sắp xếp lại. Số tấm đã xoay:',
    zh_tc: '部分大板已旋轉，暫不支持重新排版，已旋轉大板序號：',
    ru: 'Некоторые большие доски были повернуты, временно не поддерживается переформатирование, повернуты большие серийные номера:',
    ko: '대판 일부가 회전되어 재레이아웃이 지원되지 않습니다. 대판 일련 번호가 회전되었습니다.',
    bur: 'ပေါ်ဒ်ကြီးအချို့လှည့်ထားပြီး ပြန်ပြင်ဆင်မှုကိုယာယီမထောက်ခံ၊ လှည့်ပြီးပေါ်ဒ်ကြီးအစဉ်နံပါတ်:',
    ben: 'কিছু বড় বোর্ড ঘোরানো হয়েছে এবং পুনরায় লেআউট এখন সমর্থিত নয়। ঘোরানো বড় বোর্ডের ক্রম নম্বর:',
    tr: 'Bazı büyük panolar döndürülmüş, yeniden yerleşim şu anda desteklenmiyor. Döndürülmüş büyük pano numaraları:',
    km: 'ក្តារធំមួយចំនួនត្រូវបានបង្វិល ការរៀបចំឡើងវិញមិនត្រូវបានគាំទ្រនាពេលបច្ចុប្បន្នទេ។ លេខក្តារធំដែលបានបង្វិល៖',
    es: 'Algunos tableros grandes se han rotado y no se admite el cambio de diseño por el momento. El número de serie del tablero rotado es:',
    ar: 'تم تدوير بعض اللوحات الكبيرة ولا يتم دعم إعادة التخطيط في الوقت الحالي. الرقم التسلسلي للوحة المدورة هو:',
  },
  'arrangedPage.slotErrTip': {
    zh: '当前板件存有贴边加工的槽，不支持重新排版！',
    en: 'The current panel has edge machining grooves, and re-layout is not supported!',
    id: 'Papan saat ini memiliki alur untuk pemrosesan pegangan, dan tidak mendukung tata letak jenis ulang!',
    kz: 'Ағымдағы панельде жиекті өңдеу үшін ойықтар бар, қайта орналастыру қолдау көрсетілмейді!',
    th: 'บอร์ดปัจจุบันมีร่องสำหรับการประมวลผลที่ยึดและไม่รองรับเค้าโครงประเภทใหม่!',
    ug: 'نۆۋەتتىكى تاختا بۆلەكلىرى چېگرا ئىشلەنگەن ئويۇقى بار، قايتا تەرتىپلەشكە قوللىمايدۇ!',
    vi: 'Tấm hiện tại có rãnh gia công cạnh, không hỗ trợ sắp xếp lại!',
    zh_tc: '當前板件存有貼邊加工的槽，不支持重新排版！',
    ru: 'Текущая доска имеет паз для обработки с наклейкой, не поддерживает переформатирование!',
    ko: '현재 플레이트에는 가장자리를 붙여 가공한 슬롯이 있으며 재배열은 지원되지 않습니다!',
    bur: 'လက်ရှိပေါ်ဒ်တွင်ဘောင်ကပ်ထမ်းဆောင်ရွက်သောချောင်းများရှိ၍ ပြန်ပြင်ဆင်မှုကိုမထောက်ခံ!',
    ben: 'বর্তমান বোর্ডে প্রান্ত প্রক্রিয়াকরণের খাঁজ আছে, পুনরায় লেআউট সমর্থিত নয়!',
    tr: 'Mevcut panelde kenar işleme olukları var, yeniden yerleşim desteklenmiyor!',
    km: 'ក្តារបច្ចុប្បន្នមានរន្ធដំណើរការគែម ការរៀបចំឡើងវិញមិនត្រូវបានគាំទ្រទេ!',
    es: '¡El tablero actual tiene ranuras para el procesamiento de ribetes y no se admite el rediseño!',
    ar: 'تحتوي اللوحة الحالية على أخاديد لمعالجة الحشو وإعادة التخطيط غير مدعومة!',
  },
  'arrangedPage.lockedPaibanTip': {
    zh: '大板被锁定，无法重新排版',
    en: 'The board is locked and cannot be rearranged.',
    id: 'Papan terkunci dan tidak dapat diurutkan ulang.',
    kz: 'Тақта құлыпталған, оны қайта орналастыру мүмкін емес.',
    th: 'แผ่นกระดานถูกล็อก ไม่สามารรถประเภทใหม่',
    ug: 'چوڭ تاختا قۇلۇپلانغان، قايتا تەرتىپلەشكە بولمايدۇ',
    vi: 'Bảng đã bị khóa và không thể sắp xếp lại.',
    zh_tc: '大板被鎖定，無法重新排版',
    ru: 'Большая доска заблокирована и не может быть переформатирована',
    ko: '대판이 잠겨서 다시 조판할 수 없습니다',
    bur: 'ပေါ်ဒ်ကြီးကိုလော့ပိတ်ထားသဖြင့်ပြန်ပြင်ဆင်မနိုင်',
    ben: 'বড় বোর্ড লক করা আছে, পুনরায় লেআউট করা যাবে না',
    tr: 'Büyük pano kilitli, yeniden yerleştirilemez',
    km: 'ក្តារធំត្រូវបានចាក់សោ មិនអាចរៀបចំឡើងវិញបានទេ',
    es: 'El tablero grande está bloqueado y no se puede volver a diseñar',
    ar: 'اللوحة الكبيرة مقفلة ولا يمكن إعادة تخطيطها',
  },
  'arrangedPage.batchBujianErrTip': {
    zh: '当前板件不存在料单原始数据中，可在补件/待排版库中选择重新排版',
    en: 'The current part does not exist in the original material list data, you can select it from the replenishment/awaiting layout library for re-layout',
    id: 'Papan saat ini tidak ada dalam data asli lembar material. Anda dapat memilih tipe ulang di perpustakaan suplemen/tipe.',
    kz: 'Ағымдағы бөлшек бастапқы материалдар тізімі деректерінде жоқ, оны қайта жоспарлау үшін қосымша/жоспарлауды күтіп тұрған кітапханадан таңдауға болады',
    th: 'บอร์ดปัจจุบันไม่มีอยู่ในข้อมูลต้นฉบับของแผ่นวัสดุ คุณสามารถเลือกประเภทใหม่ในไลบรารีเสริม/ประเภท TO-TYPE',
    ug: 'نۆۋەتتىكى تاختا بۆلەكلىرى ماتېرىيال تىزىمىدىكى ئەسلى سانلىق مەلۇماتلاردا يوق، قوشۇمچە بۆلەك/ساقلىنىدىغان تەرتىپلەش ئامبىرىدىن قايتا تەرتىپلەشنى تاللىيالايسىز',
    vi: 'Phần hiện tại không tồn tại trong dữ liệu danh sách vật liệu gốc, bạn có thể chọn từ thư viện bổ sung/đang chờ bố trí để bố trí lại',
    zh_tc: '當前板件不存在料單原始數據中，可在補件/待排版庫中選擇重新排版',
    ru: 'Текущая доска не существует в исходных данных листа, вы можете выбрать переформатирование в библиотеке дополнений / форматирования',
    ko: '현재 플레이트 부품은 원본 원본 원본 데이터에 존재하지 않으므로 패치 / 릴리스 대기 라이브러리에서 재레이아웃을 선택할 수 있습니다.',
    bur: 'လက်ရှိပေါ်ဒ်သည်ပစ္စည်းစာရင်းမူရင်းဒေတာတွင်မရှိ၊ ဖြည့်ဆည်းပစ္စည်း/ပြင်ဆင်ရန်ကြိုဆောင်ဒေတာဘင်မှပြန်ပြင်ဆင်မှုကိုရွေးနိုင်',
    ben: 'বর্তমান বোর্ড মূল উপকরণ তালিকায় নেই, পরিপূরক/লেআউট অপেক্ষায় লাইব্রেরি থেকে পুনরায় লেআউট নির্বাচন করুন',
    tr: 'Mevcut parça orijinal malzeme listesi verisinde yok, yeniden yerleşim için tamamlama/bekleyen yerleşim kütüphanesinden seçebilirsiniz',
    km: 'ផ្នែកក្តារបច្ចុប្បន្នមិនមានក្នុងទិន្នន័យបញ្ជីសម្ភារៈដើម អាចជ្រើសរើសពីបណ្ណាល័យបន្ថែម/រង់ចាំរៀបចំដើម្បីរៀបចំឡើងវិញ',
    es: 'El tablero actual no existe en los datos originales de la lista de materiales. Puede optar por volver a diseñar en la biblioteca de suplementos/diseños futuros.',
    ar: 'اللوحة الحالية غير موجودة في البيانات الأصلية لفاتورة المواد. يمكنك اختيار إعادة التخطيط في مكتبة الملحق/التخطيط المطلوب.',
  },
  'arrangedPage.useFolderIsNot': {
    zh: '检测到您的文件下载保存位置"{type}"不存在 ! 请检查该文件夹是否被删除，如果使用的是移动U盘请检查U盘连接是否正确',
    en: 'It is detected that the file download save location "{type}" does not exist! Please check if the file has been deleted. If using a USB drive, please ensure it is properly connected',
    id: 'Lokasi unduhan dan penghematan file Anda terdeteksi oleh "{type}" tidak ada! Silakan periksa apakah foldernya telah dihapus. Jika Anda menggunakan drive USB seluler, silakan periksa apakah drive USB terhubung dengan benar.',
    kz: 'Файлды жүктеу сақталатын орын "{type}" жоқ екені анықталды! Файлдың жойылғанын тексеріңіз. Егер USB дискісін пайдалансаңыз, оның дұрыс қосылғанын тексеріңіз',
    th: 'ตำแหน่งของการดาวน์โหลดและบันทึกไฟล์ของคุณถูกตรวจพบโดย "{type}" ไม่มีอยู่! โปรดตรวจสอบว่าโฟลเดอร์ถูกลบหรือไม่ หากคุณใช้ไดรฟ์ USB มือถือโปรดตรวจสอบว่าไดรฟ์ USB เชื่อมต่ออย่างถูกต้องหรือไม่',
    ug: 'سىزنىڭ ھۆججەت چۈشۈرۈش ساقلاش ئورنىڭىز "{type}" تېپىلمىدى! بۇ قىسقۇچ ئۆچۈرۈلگەن-يوقلۇقىنى تەكشۈرۈڭ، ئەگەر يۆتكەلىدىغان U دىسكىنى ئىشلەتسىڭىز U دىسكا ئۇلانمىسىنى تەكشۈرۈڭ',
    vi: 'Phát hiện vị trí lưu tệp tải xuống "{type}" không tồn tại! Vui lòng kiểm tra xem tệp có bị xóa không. Nếu sử dụng ổ USB, vui lòng đảm bảo rằng nó đã được kết nối đúng cách',
    zh_tc:
      '檢測到您的文件下載保存位置"{type}"不存在 ! 請檢查該文件夾是否被刪除，如果使用的是移動U盤請檢查U盤連接是否正確',
    ru: 'Обнаружено, что место сохранения файла "{type}" не существует! Пожалуйста, проверьте, не был ли файл удален. Если вы используете USB-накопитель, пожалуйста, проверьте, правильно ли он подключен',
    ko: '파일 다운로드 저장 위치 "{type}"가 존재하지 않습니다! 파일이 삭제되었는지 확인하세요. USB 드라이브를 사용하는 경우 USB 드라이브가 제대로 연결되어 있는지 확인하세요',
    bur: 'ဖိုင်ဒေါင်းလုတ်သိမ်းဆည်းနေရာ "{type}" မရှိကြောင်းစစ်ဆေးတွေ့ရှိ! ဖိုင်တွဲဖျက်သိမ်းခြင်းရှိမရှိစစ်ဆေးပါ',
    ben: 'ফাইল ডাউনলোড সংরক্ষণের অবস্থান "{type}" নেই বলে পাওয়া গেছে! ফোল্ডার মুছা হয়েছে কিনা পরীক্ষা করুন',
    tr: 'Dosya indirme kayıt konumunuz "{type}" mevcut değil! Lütfen klasörün silinip silinmediğini kontrol edin. USB sürücü kullanıyorsanız bağlantıyı kontrol edin',
    km: 'រកឃើញថាទីតាំងរក្សាទុកអានឯកសាររបស់អ្នក "{type}" មិនមានទេ! សូមពិនិត្យមើលថាតើថតត្រូវបានលុបឬនៅ។ ប្រើ USB សូមពិនិត្យការភ្ជាប់',
    es: '¡Se ha detectado que la ubicación de descarga y guardado de su archivo "{type}" no existe! Compruebe si la carpeta se ha eliminado. Si está utilizando un disco móvil U, verifique si el disco U está conectado correctamente',
    ar: 'تم اكتشاف أن موقع تنزيل الملف وحفظه "{type}" غير موجود! يرجى التحقق مما إذا تم حذف المجلد. إذا كنت تستخدم قرصًا محمولًا U، فيرجى التحقق مما إذا كان القرص U متصلاً بشكل صحيح',
  },
  'arrangedPage.useFolderIsNot1': {
    zh: '检测到您并未设置文件下载位置，请先选择目录',
    en: 'It is detected that you have not set a file download location, please select a directory first',
    id: 'Terdeteksi bahwa Anda belum mengatur lokasi unduhan file, silakan pilih direktori terlebih dahulu.',
    kz: 'Файл жүктеу орнын орнатпағаныңыз анықталды, алдымен каталогты таңдаңыз',
    th: 'ตรวจพบว่าคุณยังไม่ได้ตั้งค่าตำแหน่งดาวน์โหลดไฟล์โปรดเลือกไดเรกทอรีก่อน',
    ug: 'ھۆججەت چۈشۈرۈش ئورنىنى تەڭشەمىگەنلىكىڭىزنى بايقىدىم، ئاۋۋال مۇندەرىجىنى تاللاڭ',
    vi: 'Phát hiện bạn chưa đặt vị trí tải tệp, vui lòng chọn thư mục trước',
    zh_tc: '檢測到您並未設置文件下載位置，請先選擇目錄',
    ru: 'Если вы не установили местоположение загрузки файла, выберите каталог',
    ko: '파일 다운로드 위치를 설정하지 않은 것을 감지했습니다. 먼저 디렉터리를 선택하십시오.',
    bur: 'ဖိုင်ဒေါင်းလုတ်တည်နေရာမသတ်မှတ်ရသေးကြောင်းစစ်ဆေးတွေ့ရှိ၊ ဦးစွာဖိုင်တွဲရွေးပါ',
    ben: 'ফাইল ডাউনলোড অবস্থান সেট করা হয়নি বলে পাওয়া গেছে, প্রথমে ডিরেক্টরি নির্বাচন করুন',
    tr: 'Dosya indirme konumu ayarlanmadığı tespit edildi, lütfen önce bir dizin seçin',
    km: 'រកឃើញថាអ្នកមិនបានកំណត់ទីតាំងអានឯកសារទេ សូមជ្រើសរើសថតមុន',
    es: 'Se detecta que no ha configurado la ubicación de descarga del archivo, seleccione primero el directorio',
    ar: 'تم اكتشاف أنك لم تقم بتعيين موقع تنزيل الملف، يرجى تحديد الدليل أولاً',
  },
  'arrangedPage.downloadNC': {
    zh: '下载NC',
    en: 'Download NC',
    id: 'Unduh NC',
    kz: 'NC жүктеу',
    th: 'ดาวน์โหลด NC',
    ug: 'NC چۈشۈرۈش',
    vi: 'Tải xuống NC',
    zh_tc: '下載NC',
    ru: 'Скачать NC',
    ko: 'NC 다운로드',
    bur: 'NC ဒေါင်းလုတ်',
    ben: 'NC ডাউনলোড করুন',
    tr: 'NC indir',
    km: 'ទាញយក NC',
    es: 'Descargue NC',
    ar: 'تنزيل NC',
  },
  'arrangedPage.downloadNC1': {
    zh: '下载NC文件',
    en: 'Download NC file',
    id: 'Unduh File NC',
    kz: 'NC файлын жүктеу',
    th: 'ดาวน์โหลดไฟล์ NC',
    ug: 'NC ھۆججىتىنى چۈشۈرۈش',
    vi: 'Tải xuống tệp NC',
    zh_tc: '下載NC文件',
    ru: 'Скачать NC файл',
    ko: 'NC 파일 다운로드',
    bur: 'NC ဖိုင်ဒေါင်းလုတ်',
    ben: 'NC ফাইল ডাউনলোড করুন',
    tr: 'NC dosyası indir',
    km: 'ទាញយកឯកសារ NC',
    es: 'Descargue el archivo NC',
    ar: 'تنزيل ملف NC',
  },
  'arrangedPage.reArrange': {
    zh: '重新排版',
    en: 'Re-arrange',
    id: 'Jenis ulang',
    kz: 'Қалыптасуды қайтадан орноту',
    th: 'ประเภทใหม่',
    ug: 'قايتا تەرتىپلەش',
    vi: 'Bố cục lại',
    zh_tc: '重新排版',
    ru: 'Переформатирование',
    ko: '재조판',
    bur: 'ပြန်ပြင်ဆင်',
    ben: 'পুনরায় লেআউট করুন',
    tr: 'Yeniden yerleştir',
    km: 'រៀបចំឡើងវិញ',
    es: 'Recomponga',
    ar: 'إعادة التنضيد',
  },
  'arrangedPage.reArrangeSpecifiedMaterialGroup': {
    zh: '指定板件组重新排版',
    en: 'Specified Panel Groups Re-layout',
    id: 'Atur ulang grup panel yang ditentukan',
    kz: 'Көрсетілген тақта топтарын қайта орналастыру',
    th: 'จัดเรียงกลุ่มแผ่นงานที่ระบุใหม่',
    ug: 'بەلگىلىك تاختا گۇرۇپپىسىنى قايتا تەرتىپلەش',
    vi: 'Bố cục lại nhóm tấm gỗ được chỉ định',
    zh_tc: '指定板件組重新排版',
    ru: 'Переформатировать указанные группы панелей',
    ko: '지정된 패널 그룹 재조판',
    bur: 'သတ်မှတ်ထားသော ပေါ်ဒ်အုပ်စုများကို ပြန်လည်အပြင်အဆင်လုပ်ပါ',
    ben: 'নির্দিষ্ট প্যানেল গ্রুপ পুনরায় সাজান',
    tr: 'Belirtilen panel gruplarını yeniden düzenle',
    km: 'រៀបចំក្រុមបន្ទះដែលបានបញ្ជាក់ឡើងវិញ',
    es: 'Reorganizar grupos de paneles especificados',
    ar: 'إعادة تنضيد مجموعات الألواح المحددة',
  },
  'arrangedPage.specifiedMaterialRelayoutMoreResultTip': {
    zh: '指定板件组重新排版后，将不再提供更多排版结果',
    en: 'After specified panel groups are re-laid out, more layout results will no longer be provided',
    id: 'Setelah grup panel yang ditentukan diatur ulang, hasil tata letak tambahan tidak akan disediakan lagi',
    kz: 'Көрсетілген тақта топтары қайта орналастырылғаннан кейін, қосымша орналастыру нәтижелері ұсынылмайды',
    th: 'หลังจากจัดเรียงกลุ่มแผ่นงานที่ระบุใหม่แล้ว จะไม่มีผลลัพธ์การจัดเรียงเพิ่มเติมอีก',
    ug: 'بەلگىلىك تاختا گۇرۇپپىسى قايتا تەرتىپلەنگەندىن كېيىن، تېخىمۇ كۆپ تەرتىپلەش نەتىجىسى تەمىنلەنمەيدۇ',
    vi: 'Sau khi bố cục lại nhóm tấm gỗ được chỉ định, sẽ không còn cung cấp thêm kết quả bố cục',
    zh_tc: '指定板件組重新排版後，將不再提供更多排版結果',
    ru: 'После переформатирования указанных групп панелей дополнительные результаты раскладки предоставляться не будут',
    ko: '지정된 패널 그룹을 다시 배치한 후에는 더 이상 추가 배치 결과가 제공되지 않습니다',
    bur: 'သတ်မှတ်ထားသော ပေါ်ဒ်အုပ်စုများကို ပြန်လည်အပြင်အဆင်လုပ်ပြီးနောက် နောက်ထပ်အပြင်အဆင်ရလဒ်များကို မပေးတော့ပါ',
    ben: 'নির্দিষ্ট প্যানেল গ্রুপ পুনরায় সাজানোর পরে আর কোনও অতিরিক্ত লেআউট ফলাফল দেওয়া হবে না',
    tr: 'Belirtilen panel grupları yeniden düzenlendikten sonra daha fazla yerleşim sonucu sunulmayacaktır',
    km: 'បន្ទាប់ពីរៀបចំក្រុមបន្ទះដែលបានបញ្ជាក់ឡើងវិញ នឹងមិនផ្តល់លទ្ធផលរៀបចំបន្ថែមទៀតទេ',
    es: 'Después de reorganizar los grupos de paneles especificados, ya no se proporcionarán más resultados de diseño',
    ar: 'بعد إعادة تنضيد مجموعات الألواح المحددة، لن يتم توفير المزيد من نتائج التنضيد',
  },
  'arrangedPage.searchMaterialGroup': {
    zh: '搜索板件组',
    en: 'Search Panel Groups',
    id: 'Cari grup panel',
    kz: 'Тақта топтарын іздеу',
    th: 'ค้นหากลุ่มแผ่นงาน',
    ug: 'تاختا گۇرۇپپىسى ئىزدەش',
    vi: 'Tìm kiếm nhóm tấm gỗ',
    zh_tc: '搜索板件組',
    ru: 'Поиск групп панелей',
    ko: '패널 그룹 검색',
    bur: 'ပေါ်ဒ်အုပ်စုများကို ရှာပါ',
    ben: 'প্যানেল গ্রুপ অনুসন্ধান করুন',
    tr: 'Panel gruplarını ara',
    km: 'ស្វែងរកក្រុមបន្ទះ',
    es: 'Buscar grupos de paneles',
    ar: 'البحث عن مجموعات الألواح',
  },
  'arrangedPage.saveToHistory': {
    zh: '保存至历史',
    en: 'Save to History',
    id: 'Simpan ke Sejarah',
    kz: 'Тарихқа сақтау',
    th: 'บันทึกประวัติศาสตร์',
    ug: 'تارىخقا ساقلاش',
    vi: 'Lưu vào lịch sử',
    zh_tc: '保存至歷史',
    ru: 'Сохранить в историю',
    ko: '역사에 저장',
    bur: 'မှတ်တမ်းသို့သိမ်းပါ',
    ben: 'ইতিহাসে সংরক্ষণ করুন',
    tr: 'Geçmişe kaydet',
    km: 'រក្សាទុកទៅប្រវត្តិ',
    es: 'Guardar en el historial',
    ar: 'حفظ في التاريخ',
  },
  'arrangedPage.moreSetting': {
    zh: '更多',
    en: 'More',
    id: 'Lagi',
    kz: 'Қосымша',
    th: 'มากกว่า',
    ug: 'تېخىمۇ كۆپ',
    vi: 'Thêm',
    zh_tc: '更多',
    ru: 'больше',
    ko: '더',
    bur: 'နောက်ထပ်',
    ben: 'আরও',
    tr: 'Daha fazla',
    km: 'បន្ថែម',
    es: 'Más',
    ar: 'أكثر',
  },
  'arrangedPage.cutIndexRe': {
    zh: '使用快捷键 ctrl+z 撤销上一步操作',
    en: 'Use shortcut key ctrl+z to undo the previous operation',
    id: 'Gunakan pintasan ctrl+z untuk membatalkan langkah sebelumnya',
    kz: 'ctrl+z қылып бұрынғы әрекетін қайтару үшін',
    th: 'ใช้ปุ่มลัด ctrl+z เพื่อยกเลิกการดำเนินการก่อนหน้า',
    ug: 'ctrl+z ئىچىقىش قىلىش ئارقا قوشۇلۇقىنى قايتىش',
    vi: 'Sử dụng phím tắt ctrl+z để hủy bước trước',
    zh_tc: '使用快捷鍵 ctrl+z 撤銷上一步操作',
    ru: 'Используйте клавишу ctrl+z для отмены предыдущего действия',
    ko: 'ctrl+z 키를 사용하여 이전 작업을 취소하십시오',
    bur: 'မှတ်ချက်ကိုဖယ်ရှားရန် ctrl+z ကိုအသုံးပြုပါ',
    ben: 'ctrl+z কী ব্যবহার করে পূর্ববর্তী কাজ বাতিল করুন',
    tr: 'ctrl+z tuşunu kullanarak önceki işlemi geri alın',
    km: 'ប្រសិទ្ធភាពលំដាប់ ctrl+z ដើម្បីបង់ប្រាក់សំបុត្រដែលមុន',
    es: 'Use el atajo de teclado ctrl+z para deshacer el paso anterior',
    ar: 'استخدم سرعة المفتاح ctrl+z للتراجع عن الخطوة السابقة',
  },
  'arrangedPage.followExportTag': {
    zh: '下载NC顺带导出标签文件',
    en: 'Download NC with Label File Export',
    id: 'Unduh NC dan Ekspor File Tag',
    kz: 'NC жүктеу кезінде етикеттер файлды экспорттау',
    th: 'ดาวน์โหลดไฟล์แท็ก NC และส่งออก',
    ug: 'NC چۈشۈرۈش بىلەن بەلگە ھۆججىتىنى چىقىرىش',
    vi: 'Tải xuống NC cùng với xuất tệp nhãn',
    zh_tc: '下載NC順帶導出標籤文件',
    ru: 'Скачать файл метки NC',
    ko: 'NC 스트립 내보내기 레이블 파일 다운로드',
    bur: 'NC ဒေါင်းလုတ်ကိုဆိပ်ကမ်းဖိုင်ထုတ်ပါ',
    ben: 'NC ডাউনলোডের সাথে লেবেল ফাইল রপ্তানি করুন',
    tr: 'NC indirirken etiket dosyası dışa aktar',
    km: 'ទាញយក NC រួមជាមួយនាំចេញឯកសារស្លាក',
    es: 'Descargue NC y exporte el archivo de etiqueta',
    ar: 'تنزيل NC وتصدير ملف التسمية',
  },
  'arrangedPage.followExportPaibanImg': {
    zh: '下载NC顺带导出排版图文件',
    en: 'Download the NC file and export the layout drawing file simultaneously',
    id: 'Unduh NC dan ekspor file tata letak sekaligus',
    kz: 'NC экспорттау орналасу файлын жүктеп алыңыз',
    th: 'ดาวน์โหลดไฟล์ NC Ladyband ส่งออกแผนภูมิการพิมพ์',
    ug: 'NC ئېكسپورت ئورۇنلاشتۇرۇش ھۆججىتىنى چۈشۈرۈڭ',
    vi: 'Tải tập tin biểu đồ sắp chữ NC',
    zh_tc: '下載NC順帶匯出排版圖檔案',
    ru: 'Скачать NC для экспорта файлов диаграмм',
    ko: 'NC 스트립 내보내기 레이아웃 파일 다운로드',
    bur: 'NC ဒေါင်းလုတ်ကိုပြင်ဆင်မှုပုံဖိုင်ထုတ်ပါ',
    ben: 'NC ডাউনলোডের সাথে লেআউট চিত্র ফাইল রপ্তানি করুন',
    tr: 'NC indirirken yerleşim çizim dosyasını dışa aktar',
    km: 'ទាញយក NC រួមជាមួយនាំចេញឯកសាររូបភាពរចនាសម្ព័ន្ធ',
    es: 'Descargue NC y exporte el archivo de dibujo de diseño',
    ar: 'تنزيل NC وتصديره ملف رسم التخطيط',
  },
  'arrangedPage.followExportWorkerShop': {
    zh: '下载NC顺带导出采购单',
    en: 'Download NC and export purchase order at the same time',
    id: 'Unduh surat pembelian ekspor NC',
    kz: 'NC импортты сатып алу тапсырысын жүктеп алыңыз',
    th: 'ดาวน์โหลดแบบฟอร์มการสั่งซื้อ NC',
    ug: 'NC ئىمپورت سېتىۋېلىش زاكازنى چۈشۈرۈڭ',
    vi: 'Tải xuống lệnh mua hàng xuất khẩu ngẫu nhiên NC',
    zh_tc: '下載NC順帶匯出採購單',
    ru: 'Скачать NC Экспорт заказа на поставку',
    ko: 'NC 온보드 내보내기 요청서 다운로드',
    bur: 'NC ဒေါင်းလုတ်ကိုဝယ်ယူမှုစာရင်းထုတ်ပါ',
    ben: 'NC ডাউনলোডের সাথে ক্রয় আদেশ রপ্তানি করুন',
    tr: 'NC indirirken satın alma siparişini dışa aktar',
    km: 'ទាញយក NC រួមជាមួយនាំចេញការបញ្ជាទិញ',
    es: 'Descargar NC y exportar la orden de compra',
    ar: 'تنزيل NC وتصدير أمر الشراء',
  },
  'arrangedPage.tagTemplateSelect': {
    zh: '标签模板选择',
    en: 'Label Template Selection',
    id: 'Pilihan Tag Template',
    kz: 'Етикеттер шаблонды таңдау',
    th: 'การเลือกแท็กเทมเพลต',
    ug: 'بەلگە قېلىپىنى تاللاش',
    vi: 'Chọn mẫu nhãn',
    zh_tc: '標籤模板選擇',
    ru: 'Выбор шаблонов меток',
    ko: '태그 템플릿 선택',
    bur: 'ဆိပ်ကမ်းပုံစံရွေးချယ်',
    ben: 'লেবেল টেমপ্লেট নির্বাচন',
    tr: 'Etiket şablonu seçimi',
    km: 'ការជ្រើសរើសគំរូស្លាក',
    es: 'Selección de plantilla de etiqueta',
    ar: 'اختيار قالب الملصق',
  },
  'arrangedPage.showCuttingSequence': {
    zh: '显示切割顺序',
    en: 'Show Cutting Sequence',
    id: 'Tampilkan pesanan pemotongan',
    kz: 'Кесу sırасын көрсету',
    th: 'แสดงคำสั่งตัด',
    ug: 'كېسىش تەرتىپىنى كۆرسەت',
    vi: 'Hiển thị trình tự cắt',
    zh_tc: '顯示切割順序',
    ru: 'Показать порядок резки',
    ko: '가공 순서 표시하기',
    bur: 'ဖြတ်တောက်အစဉ်ပြသ',
    ben: 'কাটার ক্রম দেখান',
    tr: 'Kesim sırasını göster',
    km: 'បង្ហាញលំដាប់កាត់',
    es: 'Mostrar orden de corte',
    ar: 'عرض أمر القطع',
  },
  'arrangedPage.showPlankSize': {
    zh: '显示小板尺寸',
    en: 'Show Sheet Size',
    id: 'Tampilkan ukuran papan kecil',
    kz: 'Кіші кескіштің өлшемін көрсету',
    th: 'แสดงขนาดบอร์ดขนาดเล็ก',
    ug: 'كىچىك تاختا ئۆلچىمىنى كۆرسەت',
    vi: 'Hiển thị kích thước tấm gỗ nhỏ',
    zh_tc: '顯示小板尺寸',
    ru: 'Показать размер панели',
    ko: '보드 크기 표시',
    bur: 'ပေါ်ဒ်ငယ်အရွယ်ပြသ',
    ben: 'ছোট বোর্ডের আকার দেখান',
    tr: 'Küçük pano boyutunu göster',
    km: 'បង្ហាញវិមាត្រក្តារតូច',
    es: 'Mostrar tamaño de placa pequeña',
    ar: 'عرض حجم اللوحة الصغيرة',
  },
  'arrangedPage.sendToFactory.title': {
    zh: '发至车间',
    en: 'Send to Workshop for Production',
    id: 'Kirim ke lokakarya',
    kz: 'Өңдеу цехіне жіберу',
    th: 'ส่งไปยังเวิร์กช็อป',
    ug: 'سېلىق زاۋۇتىغا يوللاش',
    vi: 'Gửi đến xưởng',
    zh_tc: '發至車間',
    ru: 'В мастерскую',
    ko: '작업장으로 보내다',
    bur: 'လုပ်ငန်းခွင်သို့ပေးပို့',
    ben: 'কর্মশালায় পাঠান',
    tr: 'Üretim için atölyeye gönder',
    km: 'ផ្ញើទៅរោងចក្រសម្រាប់ផលិតកម្ម',
    es: 'Enviar al taller',
    ar: 'إرسال إلى ورشة العمل',
  },
  'arrangedPage.sendToFactory.fileType': {
    zh: '标签文件类型',
    en: 'Label File Type',
    id: 'Jenis File Tag',
    kz: 'Етикеттер файл түрі',
    th: 'ประเภทไฟล์แท็ก',
    ug: 'بەلگە ھۆججەت تىپى',
    vi: 'Loại tệp nhãn',
    zh_tc: '標籤文件類型',
    ru: 'Тип файла метки',
    ko: '태그 파일 유형',
    bur: 'ဆိပ်ကမ်းဖိုင်အမျိုးအစား',
    ben: 'লেবেল ফাইলের ধরন',
    tr: 'Etiket dosya türü',
    km: 'ប្រភេទឯកសារស្លាក',
    es: 'Tipo de archivo de etiqueta',
    ar: 'نوع ملف الملصق',
  },
  'arrangedPage.checkData': {
    zh: '正在检查数据完整性...',
    en: 'Checking data integrity...',
    id: 'Memeriksa integritas data ...',
    kz: 'Деректердің толықтығын тексеру...',
    th: 'การตรวจสอบความสมบูรณ์ของข้อมูล ...',
    ug: 'سانلىق مەلۇمات تولۇقلىقىنى تەكشۈرۈۋاتىدۇ...',
    vi: 'Đang kiểm tra tính toàn vẹn của dữ liệu...',
    zh_tc: '正在檢查數據完整性...',
    ru: 'Проверяется целостность данных. Это...',
    ko: '데이터 무결성을 확인하는 중입니다...',
    bur: 'ဒေတာပြည့်စုံမှုစစ်ဆေးနေသည်...',
    ben: 'ডেটার অখণ্ডতা পরীক্ষা করা হচ্ছে...',
    tr: 'Veri bütünlüğü kontrol ediliyor...',
    km: 'កំពុងពិនិត្យភាពពេញលេញនៃទិន្នន័យ...',
    es: 'Verificar la integridad de los datos...',
    ar: 'التحقق من سلامة البيانات...',
  },
  'arrangedPage.dataLoading': {
    zh: '正在努力加载中......',
    en: 'Loading...',
    id: 'Bekerja untuk memuat ...',
    kz: 'Жүктеу...',
    th: 'ทำงานเพื่อโหลด ...',
    ug: 'يۈكلىنىۋاتىدۇ......',
    vi: 'Đang nỗ lực tải dữ liệu...',
    zh_tc: '正在努力加載中......',
    ru: 'Работает над загрузкой. ......',
    ko: '로드하려고 노력 중입니다......',
    bur: 'တင်ဆောင်နေသည်......',
    ben: 'লোড হচ্ছে......',
    tr: 'Yükleniyor...',
    km: 'កំពុងផ្ទុក......',
    es: 'Cargando...',
    ar: 'تحميل...',
  },
  'arrangedPage.addToBujianStore': {
    zh: '正在添加进补件仓库...',
    en: 'Adding to Spare Parts Warehouse...',
    id: 'Menambahkan ke gudang pengisian ...',
    kz: 'Қосымша қойым қойылымына қосу...',
    th: 'เพิ่มเข้าไปในคลังสินค้าที่เติมเต็ม ...',
    ug: 'قوشۇمچە بۆلەك ئامبىرىغا قوشۇۋاتىدۇ...',
    vi: 'Đang thêm vào kho phụ kiện...',
    zh_tc: '正在添加進補件倉庫...',
    ru: 'Добавляется склад запасных частей. Это...',
    ko: '진일보물 창고를 추가하는 중입니다...',
    bur: 'ဖြည့်ဆည်းပစ္စည်းဂိုဒေါင်သို့ထည့်နေသည်...',
    ben: 'সরবরাহ গুদামে যোগ করা হচ্ছে...',
    tr: 'Yedek parça deposuna ekleniyor...',
    km: 'កំពុងបន្ថែមទៅឃ្លាំងគ្រឿងបន្ថែម...',
    es: 'Agregando almacén de piezas...',
    ar: 'إضافة مستودع قطع غيار...',
  },
  'arrangedPage.updateTaskStatus': {
    zh: '正在更新任务状态...',
    en: 'Updating Task Status...',
    id: 'Perbarui status tugas ...',
    kz: 'Тапсырыс мәртебесін жаңарту...',
    th: 'อัปเดตสถานะงาน ...',
    ug: 'ۋەزىپە ھالىتىنى يېڭىلاۋاتىدۇ...',
    vi: 'Đang cập nhật trạng thái nhiệm vụ...',
    zh_tc: '正在更新任務狀態...',
    ru: 'Обновляется статус миссии. Это...',
    ko: '작업 상태를 업데이트하는 중입니다...',
    bur: 'တာဝန်အခြေအနေအပ်ဒိတ်လုပ်နေသည်...',
    ben: 'কাজের অবস্থা আপডেট হচ্ছে...',
    tr: 'Görev durumu güncelleniyor...',
    km: 'កំពុងធ្វើបច្ចុប្បន្នភាពស្ថានភាពភារកិច្ច...',
    es: 'Actualizando estado de la tarea...',
    ar: 'تحديث حالة المهمة...',
  },
  'arrangedPage.sending': {
    zh: '正在发送至车间',
    en: 'Sending to workshop...',
    id: 'Kirim ke lokakarya',
    kz: 'Цехке жіберу...',
    th: 'ส่งไปยังเวิร์กช็อป',
    ug: 'سېلىق زاۋۇتىغا يوللىنىۋاتىدۇ',
    vi: 'Đang gửi đến xưởng',
    zh_tc: '正在發送至車間',
    ru: 'Отправляется в мастерскую.',
    ko: '작업장으로 보내는 중',
    bur: 'လုပ်ငန်းခွင်သို့ပေးပို့နေသည်',
    ben: 'কর্মশালায় পাঠানো হচ্ছে',
    tr: 'Atölyeye gönderiliyor...',
    km: 'កំពុងផ្ញើទៅរោងចក្រ',
    es: 'Enviando al taller',
    ar: 'إرسال إلى ورشة العمل',
  },
  'arrangedPage.waitLoadding': {
    zh: '等待',
    en: 'Waiting',
    id: 'Tunggu',
    kz: 'Күтеу',
    th: 'รอ',
    ug: 'ساقلاۋاتىدۇ',
    vi: 'Đang chờ',
    zh_tc: '等待',
    ru: 'ожидание',
    ko: '기다림',
    bur: 'စောင့်ဆိုင်း',
    ben: 'অপেক্ষা করছে',
    tr: 'Bekleniyor',
    km: 'រង់ចាំ',
    es: 'Esperando',
    ar: 'انتظار',
  },
  'arrangedPage.loadding': {
    zh: '正在',
    en: 'Loading',
    id: 'Sedang berlangsung',
    kz: 'Жүзеге асыру...',
    th: 'การดำเนินการ',
    ug: 'يۈكلىنىۋاتىدۇ',
    vi: 'Đang',
    zh_tc: '正在',
    ru: 'в процессе',
    ko: '진행 중',
    bur: 'ဆောင်ရွက်နေသည်',
    ben: 'চলছে',
    tr: 'Yükleniyor',
    km: 'កំពុង',
    es: 'Actualmente',
    ar: 'حاليًا',
  },
  'arrangedPage.finish': {
    zh: '完成',
    en: 'Finished',
    id: 'Menyelesaikan',
    kz: 'Ақырындау',
    th: 'เสร็จ',
    ug: 'تامام',
    vi: 'Hoàn thành',
    zh_tc: '完成',
    ru: 'завершить',
    ko: '완료',
    bur: 'ပြီးဆုံး',
    ben: 'সম্পন্ন',
    tr: 'Tamamlandı',
    km: 'បានបញ្ចប់',
    es: 'Completando',
    ar: 'إكمال',
  },
  'arrangedPage.loadSetting': {
    zh: '加载设置',
    en: 'Load Settings',
    id: 'Pengaturan Memuat',
    kz: 'Қалайтын жүктеу',
    th: 'กำลังโหลดการตั้งค่า',
    ug: 'تەڭشەكنى يۈكلەش',
    vi: 'Tải cài đặt',
    zh_tc: '加載設置',
    ru: 'Настройки загрузки',
    ko: '로드 설정',
    bur: 'ဆက်တင်တင်ဆောင်',
    ben: 'সেটিংস লোড করুন',
    tr: 'Ayarları yükle',
    km: 'ផ្ទុកការកំណត់',
    es: 'Cargando configuraciones',
    ar: 'تحميل الإعدادات',
  },
  'arrangedPage.loadPreference': {
    zh: '加载偏好设置',
    en: 'Load Preferences',
    id: 'Preferensi pemuatan',
    kz: 'Арақашты жүктеу',
    th: 'การตั้งค่าการโหลด',
    ug: 'ئارزۇ تەڭشەكلىرىنى يۈكلەش',
    vi: 'Tải cài đặt tùy chọn',
    zh_tc: '加載偏好設置',
    ru: 'Загрузить настройки предпочтений',
    ko: '로드 환경 설정',
    bur: 'ဦးစားပေးဆက်တင်တင်ဆောင်',
    ben: 'পছন্দের সেটিংস লোড করুন',
    tr: 'Tercihleri yükle',
    km: 'ផ្ទុកចំណូលចិត្ត',
    es: 'Cargando preferencias',
    ar: 'تحميل التفضيلات',
  },
  'arrangedPage.dealTemplate': {
    zh: '处理模板',
    en: 'Process Template',
    id: 'Templat pemrosesan',
    kz: 'Шаблонды өңдеу',
    th: 'เทมเพลตการประมวลผล',
    ug: 'قېلىپنى بىر تەرەپ قىلىش',
    vi: 'Xử lý mẫu',
    zh_tc: '處理模板',
    ru: 'Обработка шаблонов',
    ko: '템플릿 작업',
    bur: 'ပုံစံပြင်ဆင်',
    ben: 'টেমপ্লেট প্রক্রিয়া করুন',
    tr: 'Şablonu işle',
    km: 'ដំណើរការគំរូ',
    es: 'Procesando plantillas',
    ar: 'قوالب المعالجة',
  },
  'arrangedPage.initTagData': {
    zh: '初始化标签数据',
    en: 'Initialize Tag Data',
    id: 'Inisialisasi data tag',
    kz: 'Етикеттер деректерді ініциализациялау',
    th: 'เริ่มต้นข้อมูลแท็ก',
    ug: 'بەلگە سانلىق مەلۇماتىنى باشلاش',
    vi: 'Khởi tạo dữ liệu nhãn',
    zh_tc: '初始化標籤數據',
    ru: 'Инициализация данных метки',
    ko: '레이블 데이터 초기화',
    bur: 'ဆိပ်ကမ်းဒေတာစတင်',
    ben: 'ট্যাগ ডেটা আরম্ভ করুন',
    tr: 'Etiket verisini başlat',
    km: 'ចាប់ផ្តើមទិន្នន័យស្លាក',
    es: 'Inicializando datos de etiquetas',
    ar: 'تهيئة بيانات الملصق',
  },
  'arrangedPage.prepareDrawData': {
    zh: '准备标签绘制数据',
    en: 'Prepare Label Drawing Data',
    id: 'Siapkan Data Gambar Label',
    kz: 'Етикеттерді сызу деректерін дайындау',
    th: 'เตรียมข้อมูลการวาดฉลาก',
    ug: 'بەلگە سىزىش سانلىق مەلۇماتىنى تەييارلاش',
    vi: 'Chuẩn bị dữ liệu vẽ nhãn',
    zh_tc: '準備標籤繪製數據',
    ru: 'Подготовка данных для построения меток',
    ko: '레이블 드로잉 데이터 준비',
    bur: 'ဆိပ်ကမ်းဆွဲဒေတာပြင်ဆင်',
    ben: 'লেবেল ড্রইং ডেটা প্রস্তুত করুন',
    tr: 'Etiket çizim verisini hazırla',
    km: 'រៀបចំទិន្នន័យគូសស្លាក',
    es: 'Preparando datos de dibujo de etiquetas',
    ar: 'تحضير بيانات رسم الملصق',
  },
  'arrangedPage.drawDataText': {
    zh: '标签绘制数据',
    en: 'Label drawing data',
    id: 'Tag Menggambar Data',
    kz: 'Белгілерді суреттеу деректері',
    th: 'แท็กข้อมูลการวาด',
    ug: 'بەلگە سىزىش سانلىق مەلۇماتى',
    vi: 'Dữ liệu vẽ nhãn',
    zh_tc: '標籤繪製數據',
    ru: 'Данные построения меток',
    ko: '레이블 드로잉 데이터',
    bur: 'ဆိပ်ကမ်းဆွဲဒေတာ',
    ben: 'লেবেল ড্রইং ডেটা',
    tr: 'Etiket çizim verisi',
    km: 'ទិន្នន័យគូសស្លាក',
    es: 'Datos de dibujo de etiquetas',
    ar: 'بيانات رسم الملصق',
  },
  'arrangedPage.genPdfTagFile': {
    zh: '生成PDF标签文件',
    en: 'Generate PDF Tag File',
    id: 'Menghasilkan file tag pdf',
    kz: 'PDF етикеттер файлді генерау',
    th: 'สร้างไฟล์แท็ก PDF',
    ug: 'PDF بەلگە ھۆججىتىنى ھاسىل قىلىش',
    vi: 'Tạo file nhãn PDF',
    zh_tc: '生成PDF標籤文件',
    ru: 'Создать файл метки PDF',
    ko: 'PDF 태그 파일 생성하기',
    bur: 'PDF ဆိပ်ကမ်းဖိုင်ဖန်တီး',
    ben: 'PDF লেবেল ফাইল তৈরি করুন',
    tr: 'PDF etiket dosyası oluştur',
    km: 'បង្កើតឯកសារស្លាក PDF',
    es: 'Generando PDF archivo de etiquetas',
    ar: 'إنشاء ملف ملصق PDF',
  },
  'arrangedPage.genPicTagFile': {
    zh: '生成标签图片文件',
    en: 'Generate a label image file',
    id: 'Hasilkan file gambar tag',
    kz: 'Жапсырма кескін файлын жасау',
    th: 'สร้างไฟล์รูปภาพแท็ก',
    ug: 'بەلگە رەسىم ھۆججىتىنى ھاسىل قىلىش',
    vi: 'Tạo file hình ảnh nhãn',
    zh_tc: '生成標籤圖片文件',
    ru: 'Создать файл изображения метки',
    ko: '태그 그림 파일 생성',
    bur: 'ဆိပ်ကမ်းပုံဖိုင်ဖန်တီး',
    ben: 'লেবেল ছবির ফাইল তৈরি করুন',
    tr: 'Etiket resim dosyası oluştur',
    km: 'បង្កើតឯកសាររូបភាពស្លាក',
    es: 'Generar archivo de imagen de etiqueta',
    ar: 'إنشاء ملف صورة التسمية',
  },
  'arrangedPage.uploadFile': {
    zh: '上传文件',
    en: 'Upload file',
    id: 'Unggah file',
    kz: 'Файлды жүктеу',
    th: 'อัปโหลดไฟล์',
    ug: 'ھۆججەت يۈكلەش',
    vi: 'Tải lên file',
    zh_tc: '上傳文件',
    ru: 'Загрузить файл',
    ko: '파일 업로드',
    bur: 'ဖိုင်တင်ဆောင်',
    ben: 'ফাইল আপলোড করুন',
    tr: 'Dosya yükle',
    km: 'ផ្ទុកឯកសារឡើង',
    es: 'Cargar archivo',
    ar: 'تحميل الملف',
  },
  'arrangedPage.dealNCFile': {
    zh: '处理NC文件',
    en: 'Process NC File',
    id: 'Memproses file NC',
    kz: 'NC файлды өңдеу',
    th: 'ประมวลผลไฟล์ NC',
    ug: 'NC ھۆججىتىنى بىر تەرەپ قىلىش',
    vi: 'Xử lý file NC',
    zh_tc: '處理NC文件',
    ru: 'Обработка NC - файлов',
    ko: 'NC 파일 작업',
    bur: 'NC ဖိုင်ပြင်ဆင်',
    ben: 'NC ফাইল প্রক্রিয়া করুন',
    tr: 'NC dosyasını işle',
    km: 'ដំណើរការឯកសារ NC',
    es: 'Procesar archivo NC',
    ar: 'معالجة NC الملف',
  },
  'arrangedPage.zipFile': {
    zh: '生成本地压缩文件',
    en: 'Generate Local Zip File',
    id: 'Menghasilkan file terkompresi lokal',
    kz: 'Жергілікті жип файлді генерау',
    th: 'สร้างไฟล์บีบอัดในเครื่อง',
    ug: 'يەرلىك قىسقا ھۆججەت ھاسىل قىلىش',
    vi: 'Tạo file nén địa phương',
    zh_tc: '生成本地壓縮文件',
    ru: 'Создать локальный сжатый файл',
    ko: '로컬 압축 파일 생성',
    bur: 'ဒေသဆိုင်ရာချုံ့ဖိုင်ဖန်တီး',
    ben: 'স্থানীয় সংকুচিত ফাইল তৈরি করুন',
    tr: 'Yerel zip dosyası oluştur',
    km: 'បង្កើតឯកសារបង្គត់ក្នុងតំបន់',
    es: 'Generar archivo comprimido local',
    ar: 'إنشاء ملف مضغوط محلي',
  },
  'arrangedPage.plankCount': {
    zh: '大板数量',
    en: 'Panels',
    id: 'Jumlah papan besar',
    kz: 'Өріктегіш кескіштердің саны',
    th: 'จำนวนบอร์ดขนาดใหญ่',
    ug: 'چوڭ تاختا سانى',
    vi: 'Số lượng tấm lớn',
    zh_tc: '大板數量',
    ru: 'Количество больших панелей',
    ko: '대판 수량',
    bur: 'ပေါ်ဒ်ကြီးအရေအတွက်',
    ben: 'বড় বোর্ডের সংখ্যা',
    tr: 'Büyük levha sayısı',
    km: 'ចំនួនផ្ទាំងធំ',
    es: 'Número de tableros grandes',
    ar: 'عدد اللوحات الكبيرة',
  },
  'arrangedPage.rollCount': {
    zh: '翻板次数',
    en: 'Flips',
    id: 'Jumlah cetak ulang',
    kz: 'Қайтадан орноту сан',
    th: 'จำนวนการพิมพ์ซ้ำ',
    ug: 'تەتۈرلەش سانى',
    vi: 'Số lần lật bản',
    zh_tc: '翻板次數',
    ru: 'Количество копий',
    ko: '리메이크 횟수',
    bur: 'ပြောင်းဘက်အကြိမ်ရေ',
    ben: 'উল্টানোর সংখ্যা',
    tr: 'Tekrar baskı sayısı',
    km: 'ចំនួនដងកែប្រែ',
    es: 'Número de copias',
    ar: 'عدد النسخ',
  },
  'arrangedPage.totalRate': {
    zh: '整体优化率',
    en: 'Nesting Rate',
    id: 'Tingkat optimasi keseluruhan',
    kz: 'Жалпы оңтайландыру шығырлылыгі',
    th: 'อัตราการเพิ่มประสิทธิภาพโดยรวม',
    ug: 'ئومۇمىي ئۈنۈملۈك نىسبىتى',
    vi: 'Tỷ lệ tối ưu hóa tổng thể',
    zh_tc: '整體優化率',
    ru: 'Общий коэффициент оптимизации',
    ko: '전체 최적화율',
    bur: 'ကာလပြည့်ကောင်းမွန်မှုနှုန်း',
    ben: 'সার্বিক অপ্টিমাইজেশন হার',
    tr: 'Genel optimizasyon oranı',
    km: 'អត្រាប្រសើរឡើងសរុប',
    es: 'Tasa de optimización general',
    ar: 'معدل التحسين الإجمالي',
  },
  'arrangedPage.rate': {
    zh: '优化率',
    en: 'Optimization Rate',
    id: 'Tingkat optimasi',
    kz: 'Оңтайландыру шығырлылыгі',
    th: 'อัตราการเพิ่มประสิทธิภาพ',
    ug: 'ئۈنۈملۈك نىسبىتى',
    vi: 'Tỷ lệ tối ưu hóa',
    zh_tc: '優化率',
    ru: 'Коэффициент оптимизации',
    ko: '최적화율',
    bur: 'ကောင်းမွန်မှုနှုန်း',
    ben: 'অপ্টিমাইজেশন হার',
    tr: 'Optimizasyon oranı',
    km: 'អត្រាប្រសើរឡើង',
    es: 'Tasa de optimización',
    ar: 'معدل التحسين',
  },
  'arrangedPage.useArea': {
    zh: '已优化面积',
    en: 'Nested Area',
    id: 'Area yang dioptimalkan',
    kz: 'Оңтайландырылған аудан',
    th: 'พื้นที่ที่ได้รับการปรับปรุง',
    ug: 'ئۈنۈملۈك ئىشلەنگەن يەر',
    vi: 'Diện tích đã được tối ưu',
    zh_tc: '已優化面積',
    ru: 'Оптимизированная площадь',
    ko: '최적화된 영역',
    bur: 'ကောင်းမွန်အောင်ပြုလုပ်ပြီးဧရိယာ',
    ben: 'অপ্টিমাইজ করা ক্ষেত্রফল',
    tr: 'Optimize edilmiş alan',
    km: 'ផ្ទៃដីដែលបានប្រសើរឡើង',
    es: 'Área optimizada',
    ar: 'المساحة المحسنة',
  },
  'arrangedPage.materialList': {
    zh: '料单',
    en: 'Material list',
    id: 'Daftar materi',
    kz: 'Материалдар тізімі',
    th: 'รายการวัสดุ',
    ug: 'ماتېرىيال تىزىمى',
    vi: 'Danh sách nguyên liệu',
    zh_tc: '料單',
    ru: 'Список материалов',
    ko: '재료 명세서',
    bur: 'ပစ္စည်းစာရင်း',
    ben: 'উপকরণ তালিকা',
    tr: 'Malzeme listesi',
    km: 'បញ្ជីសម្ភារៈ',
    es: 'Lista de materiales',
    ar: 'قائمة المواد',
  },
  'arrangedPage.saveSurplus': {
    zh: '余料入库',
    en: 'Save Scrap Material',
    id: 'Bahan yang tersisa ke gudang',
    kz: 'Қалдықтарды қоймаға сақтау',
    th: 'วัสดุที่เหลืออยู่ในคลังสินค้า',
    ug: 'قالدۇق ماتېرىياللارنى ئامبارغا ساقلاش',
    vi: 'Nhập kho dư liệu',
    zh_tc: '餘料入庫',
    ru: 'Склад излишков',
    ko: '남은 재료를 입고하다.',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်သွင်း',
    ben: 'উদ্বৃত্ত উপকরণ গুদামে রাখুন',
    tr: 'Artık malzemeyi depoya al',
    km: 'រក្សាទុកសម្ភារៈសល់ចូលឃ្លាំង',
    es: 'Materiales restantes almacenados',
    ar: 'المواد المتبقية المخزنة',
  },
  'arrangedPage.workeShop': {
    zh: '采购单',
    en: 'Purchase Order',
    id: 'Pesanan pembelian',
    kz: 'Сатып алу ордері',
    th: 'ใบสั่งซื้อ',
    ug: 'سېتىۋېلىش تىزىمى',
    vi: 'Đơn mua hàng',
    zh_tc: '採購單',
    ru: 'Закупочные заказы',
    ko: '구매서',
    bur: 'ဝယ်ယူမှုစာရင်း',
    ben: 'ক্রয় আদেশ',
    tr: 'Satın alma siparişi',
    km: 'បញ្ជាទិញ',
    es: 'Orden de compra',
    ar: 'أمر الشراء',
  },
  'arrangedPage.batchTagging': {
    zh: '批量补标签',
    en: 'Batch tagging',
    id: 'Label tambahan batch',
    kz: 'Тегтерді көлемді толықтыру',
    th: 'ฉลากแพทช์จำนวนมาก',
    ug: 'توپلاش بەلگە تولدۇرۇش',
    vi: 'Bổ sung nhãn hàng loạt',
    zh_tc: '批量補標籤',
    ru: 'Товарные вкладки',
    ko: '대량 태그 보정',
    bur: 'အစုလိုက်ဆိပ်ကမ်းဖြည့်ပါ',
    ben: 'ব্যাচ লেবেল পরিপূরক',
    tr: 'Toplu etiket tamamlama',
    km: 'បំពេញស្លាកជាក្រុម',
    es: 'Reetiquetado por lotes',
    ar: 'إعادة تسمية الدفعة',
  },
  'arrangedPage.batchTaggingTip': {
    zh: '请在下方选择需要补打标签的板件',
    en: 'Please select the panel below that requires additional labeling',
    id: 'Silakan pilih pelat yang membutuhkan label tambahan di bawah ini',
    kz: 'Төмендегі панельдерді таңдап, таңбалау керек',
    th: 'โปรดเลือกชิ้นส่วนของบอร์ดที่ต้องการเติมฉลากด้านล่าง',
    ug: 'ئىشتىيىل يۈزلەرنى تاللاڭ',
    vi: 'Vui lòng chọn bảng bên dưới để được dán nhãn',
    zh_tc: '請在下方選擇需要補打標籤的板件',
    ru: 'Внизу выберите лист, на котором необходимо заполнить этикетку.',
    ko: '아래에서 레이블을 추가할 보드를 선택하십시오.',
    bur: 'အောက်တွင်ဆိပ်ကမ်းထပ်ကြိုက်မည့်ပေါ်ဒ်ကိုရွေးပါ',
    ben: 'নিচে থেকে অতিরিক্ত লেবেল প্রয়োজন এমন বোর্ড নির্বাচন করুন',
    tr: 'Aşağıdan ek etiket gerektiren levhaları seçin',
    km: 'សូមជ្រើសរើសផ្ទាំងដែលត្រូវការស្លាកបន្ថែមខាងក្រោម',
    es: 'Seleccione los paneles que deben reetiquetarse a continuación',
    ar: 'يرجى تحديد الألواح التي تحتاج إلى إعادة تسمية أدناه',
  },
  'arrangedPage.holeSlotErr': {
    zh: '检测到板件存在孔槽深度异常!',
    en: 'Detected abnormal hole slot depth on the board piece!',
    id: 'Kedalaman lubang pelat yang abnormal terdeteksi!',
    kz: 'Кескіштердің ішіндегі отындар мен саңылаулардің тереңдігінің асыптысы байқалды!',
    th: 'ตรวจพบความลึกของรูผิดปกติของแผ่น!',
    ug: 'تاختا بۆلەكلىرىدىن تېشىك/ئويۇق چوڭقۇرلۇقى بۇزۇلۇشى بايقىلدى!',
    vi: 'Đã phát hiện tấm gỗ có độ sâu khe/lỗ bất thường!',
    zh_tc: '檢測到板件存在孔槽深度異常!',
    ru: 'Обнаружена аномальная глубина отверстия в пластине!',
    ko: '플레이트 부품에 구멍 슬롯 깊이 예외가 발견되었습니다!',
    bur: 'ပေါ်ဒ်တွင်ပေါက်ကြိုးနက်မှုပုံမမှန်ရှိကြောင်းစစ်ဆေးတွေ့ရှိ!',
    ben: 'বোর্ডে গর্ত-স্লটের গভীরতায় অস্বাভাবিকতা পাওয়া গেছে!',
    tr: 'Parçada anormal delik/oluk derinliği tespit edildi!',
    km: 'រកឃើញជម្រៅរណ្តៅ/រន្ធ​មិនប្រក្រតីនៅលើផ្ទាំង!',
    es: '¡Se detecta que el panel tiene un orificio y una profundidad de ranura anormales!',
    ar: 'تم اكتشاف أن اللوحة بها ثقب وعمق فتحة غير طبيعي!',
  },
  'arrangedPage.knivesErr': {
    zh: '检测到板件找不到加工刀具!',
    en: "The processing tool can't be found when the plate is detected!",
    id: 'Alat pemrosesan terdeteksi bahwa pelat tidak ditemukan!',
    kz: 'Пластина үшін өңдеу құралын табу мүмкін емес екені анықталды!',
    th: 'ตรวจพบเครื่องมือประมวลผลว่าไม่พบแผ่น!',
    ug: 'تاختا بۆلەكلىرىنى ئىشلەش پىچاقلىرى تېپىلمىدى!',
    vi: 'Phát hiện bảng không tìm thấy dụng cụ gia công!',
    zh_tc: '檢測到板件找不到加工刀具!',
    ru: 'Мы не можем найти обработанный нож!',
    ko: '판넬에서 가공 공구를 찾을 수 없음이 감지되었습니다!',
    bur: 'ပေါ်ဒ်ငယ်တွင်လုပ်ဆောင်ရေးဓားမတွေ့ကြောင်းစစ်ဆေးတွေ့ရှိ!',
    ben: 'বোর্ড প্রক্রিয়াকরণের সরঞ্জাম পাওয়া যাচ্ছে না বলে পাওয়া গেছে!',
    tr: 'Parça algılandığında işleme takımı bulunamıyor!',
    km: 'រកមិនឃើញឧបករណ៍ដំណើរការពេលរកឃើញផ្ទាំង!',
    es: '¡Se detecta que el panel no puede encontrar la herramienta de procesamiento!',
    ar: 'تم اكتشاف عدم تمكن اللوحة من العثور على أداة المعالجة!',
  },
  'arrangedPage.checkDetail': {
    zh: '查看详情',
    en: 'Check details',
    id: 'Periksa detailnya',
    kz: 'Егжектілікті қарау',
    th: 'ตรวจสอบรายละเอียด',
    ug: 'تەپسىلاتىنى كۆرۈش',
    vi: 'Xem chi tiết',
    zh_tc: '查看詳情',
    ru: 'Подробнее',
    ko: '자세히 보기',
    bur: 'အသေးစိတ်ကြည့်ပါ',
    ben: 'বিস্তারিত দেখুন',
    tr: 'Ayrıntıları görüntüle',
    km: 'មើលព័ត៌មានលម្អិត',
    es: 'Ver detalles',
    ar: 'عرض التفاصيل',
  },
  'arrangedPage.deepErr.title': {
    zh: '板件孔槽深度异常',
    en: 'Abnormal Depth of Board Hole Slot',
    id: 'Kedalaman abnormal slot lubang pelat',
    kz: 'Кескіштің отындар мен саңылауларінің тереңдігінің асыптысы',
    th: 'ความลึกที่ผิดปกติของช่องเสียบหลุม',
    ug: 'تاختا بۆلەكلىرى تېشىك/ئويۇق چوڭقۇرلۇقى بۇزۇلۇشى',
    vi: 'Độ sâu khe/lỗ tấm gỗ bất thường',
    zh_tc: '板件孔槽深度異常',
    ru: 'Аномальная глубина отверстия пластины',
    ko: '판자 구멍 슬롯 깊이 예외',
    bur: 'ပေါ်ဒ်ပေါက်ကြိုးနက်မှုပုံမမှန်',
    ben: 'বোর্ড গর্ত-স্লটের গভীরতায় অস্বাভাবিকতা',
    tr: 'Levha delik/oluk derinliği anormalliği',
    km: 'ជម្រៅរណ្តៅ/រន្ធ​ផ្ទាំងមិនប្រក្រតី',
    es: 'Profundidad anormal del orificio del panel',
    ar: 'عمق ثقب غير طبيعي للوحة',
  },
  'arrangedPage.deepErr.errStatistic': {
    zh: '次小板有{count}处异常',
    en: '{count} abnormalities found on the sub-board',
    id: 'Ada kelainan di papan kedua',
    kz: 'Кіші кескіштердің {count} жерінде асыптысы бар',
    th: 'มีความผิดปกติในบอร์ดที่สอง',
    ug: '{count} دانە كىچىك تاختا بۇزۇلۇش بار',
    vi: 'Có {count} điểm bất thường ở tấm nhỏ',
    zh_tc: '次小板有{count}處異常',
    ru: 'На {count} местах на поддоске обнаружены аномалии',
    ko: '{count} 개의 보수 판에 예외가 발생했습니다',
    bur: 'ပေါ်ဒ်ငယ်တွင် {count} နေရာ ပုံမမှန်ရှိ',
    ben: 'ছোট বোর্ডে {count} টি অস্বাভাবিকতা আছে',
    tr: 'Alt levhada {count} anomali',
    km: 'ផ្ទាំងរងមានភាពមិនប្រក្រតី {count} កន្លែង',
    es: 'La placa secundaria tiene {count} anormalidad',
    ar: 'لوحة شبه صغيرة بها {count} شذوذ',
  },
  'arrangedPage.deepErr.errText': {
    zh: '异常部分',
    en: 'Abnormal Part',
    id: 'Bagian pengecualian',
    kz: 'Асыптық бөлік',
    th: 'ส่วนยกเว้น',
    ug: 'بۇزۇلغان بۆلەك',
    vi: 'Bộ phận bất thường',
    zh_tc: '異常部分',
    ru: 'Необычная часть',
    ko: '예외 부분',
    bur: 'ပုံမမှန်သောအပိုင်း',
    ben: 'অস্বাভাবিক অংশ',
    tr: 'Anormal bölüm',
    km: 'ផ្នែកមិនប្រក្រតី',
    es: 'Parte anormal',
    ar: 'جزء غير طبيعي',
  },
  'arrangedPage.deepErr.markErrPart': {
    zh: '框出异常部分',
    en: 'Mark the Abnormal Part',
    id: 'Kotak bagian pengecualian',
    kz: 'Асыптық бөлікті қоршау',
    th: 'กล่องออกส่วนข้อยกเว้น',
    ug: 'بۇزۇلغان بۆلەكنى بەلگىلەش',
    vi: 'Đánh dấu bộ phận bất thường',
    zh_tc: '框出異常部分',
    ru: 'Вставка аномалий',
    ko: '예외 부분 상자',
    bur: 'ပုံမမှန်သောအပိုင်းကိုဘောင်ဆွဲပါ',
    ben: 'অস্বাভাবিক অংশ চিহ্নিত করুন',
    tr: 'Anormal bölümü çerçevele',
    km: 'ដាក់ស៊ុមលើផ្នែកមិនប្រក្រតី',
    es: 'Enmarque la parte anormal',
    ar: 'تأطير الجزء غير الطبيعي',
  },
  'arrangedPage.warningTip': {
    zh: ' 双面加工的高光板：先加工 <span class="font-style">高光面</span> , 再加工 <span class="font-style">哑光面</span>; 单面加工的高光板：直接加工 <span class="font-style">哑光面</span>',
    en: 'For double-sided polished boards: Process the <span class="font-style">glossy side</span> first, then process the <span class="font-style">matte side</span>; For single-sided polished boards: Process the <span class="font-style">matte side</span> directly.',
    id: 'Pelat Double-Sided High-Gloss: Proses Pertama <Span class = "Font-style"> Permukaan gloss tinggi </span>, lalu proses <span class = "font-style"> permukaan matte </span>; Pelat Klos Tinggi Single-Side: Proses Langsung <Span Class = "Font-Style"> Permukaan Matte </span>',
    kz: 'Екі жақты өңделген глаукоз қаптамасы: алдымен глаукоз беті өңдеңіз, содан кейін матты бет өңдеңіз; Бір жақты өңделген глаукоз қаптамасы: тікелей матты бет өңдеңіз',
    th: 'แผ่นมันวาวสูงสองด้าน: กระบวนการแรก <span class = "รูปแบบฟอนต์"> พื้นผิวมันวาวสูง </span> จากนั้นประมวลผล <span class = "รูปแบบฟอนต์"> พื้นผิวด้าน </span>; แผ่นมันวาวสูงด้านเดียว: ประมวลผลโดยตรง <span class = "รูปแบบฟอนต์"> พื้นผิวด้าน </span>',
    ug: 'ئىككى تەرەپلىك ئىشلەنگەن يورۇق تاختا: ئاۋۋال <span class="font-style">يورۇق تەرەپ</span>نى ئىشلەڭ، ئاندىن <span class="font-style">قورۇق تەرەپ</span>نى ئىشلەڭ; بىر تەرەپلىك ئىشلەنگەن يورۇق تاختا: بىۋاسىتە <span class="font-style">قورۇق تەرەپ</span>نى ئىشلەڭ',
    vi: 'Đối với tấm gỗ có bề mặt sáng hai mặt: xử lý trước <span class="font-style">mặt sáng</span>, sau đó xử lý <span class="font-style">mặt mờ</span>; Đối với tấm gỗ có bề mặt sáng một mặt: xử lý trực tiếp <span class="font-style">mặt mờ</span>',
    zh_tc:
      ' 雙面加工的高光板：先加工 <span class="font-style">高光面</span> , 再加工 <span class="font-style">啞光面</span>; 單面加工的高光板：直接加工 <span class="font-style">啞光面</span>',
    ru: 'Двойная обработка высокооптических панелей: сначала обработать < span class = "font - style" > высокооптическую поверхность < / span >, затем обработать < span class = "font - style" > матовую поверхность < / span >; Односторонне обработанная высокооптическая пластина: прямая обработка < span class = "font - style" > матовая поверхность < / span >',
    ko: '양면 가공된 고광판: <span class="font-style"> 고광면 </span>을 먼저 가공하고 <span class="font-style"> 무광면 </span>을 가공한다.단면 가공의 고광판: 직접 가공 <span class="font-style"> 무광면 </span>',
    bur: 'နှစ်ဖက်လုပ်ဆောင်ပေါ်ဒ်: ဦးစွာ မြင့်မားသောဝင်းပတ်မျက်နှာကိုလုပ်ဆောင်ပြီး မှိုင်းမျက်နှာကိုလုပ်ဆောင်; တစ်ဖက်တည်းလုပ်ဆောင်ပေါ်ဒ်: မှိုင်းမျက်နှာကိုတိုက်ရိုက်လုပ်ဆောင်',
    ben: 'দ্বিপার্শ্বিক প্রক্রিয়াকরণ: প্রথমে গ্লসি পৃষ্ঠ প্রক্রিয়া করুন, তারপর ম্যাট পৃষ্ঠ; একপাশের প্রক্রিয়াকরণ: ম্যাট পৃষ্ঠ সরাসরি প্রক্রিয়া করুন',
    tr: 'Çift yüz yüksek parlak levhalar: Önce <span class="font-style">parlak yüzü</span> işleyin, ardından <span class="font-style">mat yüzü</span>; Tek yüz yüksek parlak levhalar: Doğrudan <span class="font-style">mat yüzü</span> işleyin.',
    km: 'ផ្ទាំងរលោងពីរមុខ៖ ដំណើរការ <span class="font-style">ផ្ទៃរលោង</span> មុន រួចដំណើរការ <span class="font-style">ផ្ទៃម៉ាត</span>។ ផ្ទាំងរលោងមុខតែមួយ៖ ដំណើរការ <span class="font-style">ផ្ទៃម៉ាត</span> ដោយផ្ទាល់។',
    es: 'Tablero procesado de alto brillo de doble cara: procese <span class="font-style">superficie de alto brillo</span> primero, luego procese <span class="font-style">superficie mate</span>; tablero de alto brillo procesado por una sola cara: procese directamente <span class="font-style">superficie mate</span>',
    ar: 'لوح عالي اللمعان معالج على الوجهين: معالجة <span class="font-style">السطح عالي اللمعان</span> أولاً، ثم معالجة <span class="font-style"> السطح غير اللامع</span>؛ لوحة عالية اللمعان معالجة من جانب واحد: معالجة مباشرة <span class="font-style">سطح غير لامع</span>',
  },
  'arrangedPage.showDetail.tip1': {
    zh: '单击选择单个板件',
    en: 'Click part to view label',
    id: 'Klik untuk memilih satu papan',
    kz: 'Бір кескішті таңдау үшін бір рет шертіңіз',
    th: 'คลิกเพื่อเลือกบอร์ดเดียว',
    ug: 'بىر تاختا بۆلەكنى تاللاش ئۈچۈن بىر قېتىم چېكىڭ',
    vi: 'Nhấn để chọn một tấm gỗ',
    zh_tc: '單擊選擇單個板件',
    ru: 'Нажмите для выбора отдельных панелей',
    ko: '클릭하여 개별 보드 선택',
    bur: 'ကလစ်တစ်ချက်နှိပ်ပြီးပေါ်ဒ်တစ်ချပ်ရွေးပါ',
    ben: 'ক্লিক করে একটি বোর্ড নির্বাচন করুন',
    tr: 'Tek tıklamayla tek levha seçin',
    km: 'ចុចដើម្បីជ្រើសរើសផ្ទាំងតែមួយ',
    es: 'Haga clic para seleccionar un solo tablero',
    ar: 'انقر لتحديد لوحة واحدة',
  },
  'arrangedPage.showDetail.tip2': {
    zh: '查看板件标签',
    en: '',
    id: 'Lihat label papan',
    kz: 'Кескіштің этикеттерін қараңыз',
    th: 'ดูฉลากบอร์ด',
    ug: 'تاختا بۆلەك بەلگىسىنى كۆرۈش',
    vi: 'Xem nhãn tấm gỗ',
    zh_tc: '查看板件標籤',
    ru: 'Посмотреть вкладку',
    ko: '보드 레이블 보기',
    bur: 'ပေါ်ဒ်ဆိပ်ကမ်းကြည့်ပါ',
    ben: 'বোর্ডের লেবেল দেখুন',
    tr: 'Levha etiketini görüntüle',
    km: 'មើលស្លាកផ្ទាំង',
    es: 'Ver etiquetas del tablero',
    ar: 'عرض علامات اللوحة',
  },
  'arrangedPage.arrangeTip': {
    zh: '(已支持异形嵌套排版)',
    en: '(Supports shape nesting)',
    id: '(Mendukung pengaturan huruf slinging berbentuk lebar)',
    kz: '(Қалыптасуды атайын пішімделгенді қолдайды)',
    th: '(การจัดเรียงการเรียงลำดับรังรูปกว้างที่รองรับ)',
    ug: '(ئۆزگىچە شەكىللىك تەرتىپلەشنى قوللايدۇ)',
    vi: '(Đã hỗ trợ bố cục lồng nhau cho tấm hình dị)',
    zh_tc: '(已支持異形嵌套排版)',
    ru: '(Поддерживается фасонная вставка)',
    ko: '(이형 네스트된 레이아웃은 지원됨)',
    bur: '(အထူးပုံပေါင်းစပ်ပြင်ဆင်မှုကိုထောက်ခံပြီ)',
    ben: '(অনিয়মিত নেস্টেড লেআউট সমর্থিত হয়েছে)',
    tr: '(Düzensiz iç içe yerleşimi desteklenir)',
    km: '(គាំទ្រការរៀបចំផ្ទាល់រូបខាងក្នុង)',
    es: '(se admite diseño anidado con formas especiales)',
    ar: '(يتم دعم التخطيط المتداخل ذو الشكل الخاص)',
  },
  'arrangedPage.plankOpration': {
    zh: '板件操作',
    en: 'Part Ops',
    id: 'Operasi pelat',
    kz: 'Кескіштің операциясы',
    th: 'การทำงานของแผ่น',
    ug: 'تاختا بۆلەك مەشغۇلاتى',
    vi: 'Thao tác tấm gỗ',
    zh_tc: '板件操作',
    ru: 'Операции с панелями',
    ko: '보드 작업',
    bur: 'ပေါ်ဒ်လုပ်ဆောင်မှု',
    ben: 'বোর্ড অপারেশন',
    tr: 'Levha işlemleri',
    km: 'ប្រតិបត្តិការផ្ទាំង',
    es: 'Operación del panel',
    ar: 'تشغيل اللوحة',
  },
  'arrangedPage.rotate': {
    zh: '旋转90度',
    en: 'Rotate 90°',
    id: 'Putar 90 derajat',
    kz: '90 градусқа айналдыру',
    th: 'หมุน 90 องศา',
    ug: '90 گرادۇس بۇرۇش',
    vi: 'Xoay 90 độ',
    zh_tc: '旋轉90度',
    ru: 'Повернуть на 90 градусов',
    ko: '90도 회전',
    bur: '၉၀ ဒီဂရီလှည့်',
    ben: '৯০ ডিগ্রি ঘোরান',
    tr: '90° döndür',
    km: 'បង្វិល ៩០ ដឺក្រេ',
    es: 'Girar 90 grados',
    ar: 'تدوير 90 درجة',
  },
  'arrangedPage.notCare': {
    zh: '板件无纹理',
    en: 'No Grain',
    id: 'Tidak ada tekstur di papan tulis',
    kz: 'Кескіштің текстури жоқ',
    th: 'ไม่มีพื้นผิวบนกระดาน',
    ug: 'تاختا بۆلەكتە تۈزۈلمە بار',
    vi: 'Tấm gỗ không có họa tiết',
    zh_tc: '板件無紋理',
    ru: 'Пластинка без текстуры',
    ko: '판넬 텍스쳐 없음',
    bur: 'ပေါ်ဒ်ကြောင်းမဲမရှိ',
    ben: 'বোর্ডে কোনো টেক্সচার নেই',
    tr: 'Levhada doku yok',
    km: 'ផ្ទាំងគ្មានសរសរ',
    es: 'El panel no tiene textura',
    ar: 'اللوحة لا تحتوي على نسيج',
  },
  'arrangedPage.editRemark': {
    zh: '编辑备注',
    en: 'Edit Remark',
    id: 'Edit Catatan',
    kz: 'Ескертуді өңдеу',
    th: 'แก้ไขบันทึกย่อ',
    ug: 'ئىزاھاتنى تەھرىرلەش',
    vi: 'Biên tập chú thích',
    zh_tc: '編輯備註',
    ru: 'Изменить примечание',
    ko: '편집 메모',
    bur: 'မှတ်ချက်တည်းဖြတ်',
    ben: 'মন্তব্য সম্পাদনা করুন',
    tr: 'Notu düzenle',
    km: 'កែសម្រួលកំណត់សម្គាល់',
    es: 'Editar notas',
    ar: 'تحرير الملاحظات',
  },
  'arrangedPage.clearRemark': {
    zh: '清空备注',
    en: 'Clear remarks',
    id: 'Catatan yang jelas',
    kz: 'Ескертуді тазалау',
    th: 'ล้างบันทึกย่อ',
    ug: 'ئىزاھاتنى تازىلاش',
    vi: 'Xóa chú thích',
    zh_tc: '清空備註',
    ru: 'Очистить примечание',
    ko: '메모 비우기',
    bur: 'မှတ်ချက်ရှင်းပြ',
    ben: 'মন্তব্য মুছুন',
    tr: 'Notu temizle',
    km: 'សម្អាតកំណត់សម្គាល់',
    es: 'Borrar notas',
    ar: 'مسح الملاحظات',
  },
  'arrangedPage.recalcIndex': {
    zh: '重新计算下刀点和切割顺序',
    en: 'Recalc Cut Points & Order',
    id: 'Hitung ulang titik potong dan pemotongan',
    kz: 'Кескіштің кесу орнын және кесу реттілігін қайта есептеу',
    th: 'คำนวณจุดตัดและคำสั่งตัดใหม่',
    ug: 'كېسىش نۇقتىسى ۋە كېسىش تەرتىپىنى قايتا ھېسابلاش',
    vi: 'Tính toán lại điểm cắt và trình tự cắt',
    zh_tc: '重新計算下刀點和切割順序',
    ru: 'Перерасчет точки падения и последовательности резки',
    ko: '다음 가공점 및 가공 순서 다시 계산하기',
    bur: 'ဓားချဉ်ပြင်ဆင်နှင့်ဖြတ်တောက်အစဉ်ပြန်တွက်ချက်',
    ben: 'ছুরি পয়েন্ট এবং কাটার ক্রম পুনরায় গণনা করুন',
    tr: 'Kesim başlangıcı ve sırasını yeniden hesapla',
    km: 'គណនាឡើងវិញចំណុចកាត់ និងលំដាប់ការកាត់',
    es: 'Recalcular el punto de corte y la secuencia de corte',
    ar: 'إعادة حساب نقطة القطع وتسلسل القطع',
  },
  'arrangedPage.recalcIndexSuccess': {
    zh: '重新计算下刀点和切割顺序成功',
    en: 'Recalculation of the drop point and cutting sequence successfully',
    id: 'Menghitung ulang titik potong dan pemotongan dengan sukses',
    kz: 'Түсіру нүктесін қайта есептеу және кесу тізбегін сәтті жүргізу',
    th: 'คำนวณจุดตัดและคำสั่งตัดได้สำเร็จ',
    ug: 'كېسىش نۇقتىسى ۋە كېسىش تەرتىپىنى قايتا ھېسابلاش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Tính toán lại điểm rơi và trình tự cắt thành công',
    zh_tc: '重新計算下刀點和切割順序成功',
    ru: 'Перерасчет точки падения и последовательности резания успешно',
    ko: '다음 공구 점 및 가공 순서 계산 성공',
    bur: 'ဓားချဉ်ပြင်ဆင်နှင့်ဖြတ်တောက်အစဉ်ပြန်တွက်ချက်မှုအောင်မြင်',
    ben: 'ছুরি পয়েন্ট এবং কাটার ক্রম পুনরায় গণনা সফল হয়েছে',
    tr: 'Kesim başlangıcı ve sırası yeniden hesaplandı',
    km: 'គណនាឡើងវិញចំណុចកាត់ និងលំដាប់ការកាត់បានជោគជ័យ',
    es: 'Recalcular el punto de corte y la secuencia de corte exitosamente',
    ar: 'إعادة حساب نقطة القطع وتسلسل القطع بنجاح',
  },
  'arrangedPage.storageArea.title': {
    zh: '板件暂存区',
    en: 'Temporary board piece storage area',
    id: 'Area penyimpanan sementara',
    kz: 'Кескіштердің айналма сақтау орны',
    th: 'แผ่นพื้นที่จัดเก็บชั่วคราว',
    ug: 'تاختا بۆلەك ساقلىغۇچى',
    vi: 'Khu vực tạm lưu tấm gỗ',
    zh_tc: '板件暫存區',
    ru: 'зона временного хранения листов',
    ko: '보드 부품 임시 저장 영역',
    bur: 'ပေါ်ဒ်ယာယီသိမ်းဆည်းနယ်',
    ben: 'বোর্ড অস্থায়ী সংরক্ষণ এলাকা',
    tr: 'Levha geçici alanı',
    km: 'តំបន់ផ្ទុកផ្ទាំងអាចបណ្ដោះអាសន្ន',
    es: 'Área de almacenamiento temporal de la placa',
    ar: 'منطقة التخزين المؤقتة للوحة',
  },
  'arrangedPage.storageArea.empty': {
    zh: '无板件暂存',
    en: 'No board pieces stored',
    id: 'Bagian tanpa papan disimpan sementara',
    kz: 'Кескіштердің айналма сақтау орны бос',
    th: 'ชิ้นส่วนที่ไม่มีบอร์ดจัดเก็บชั่วคราว',
    ug: 'تاختا بۆلەك ساقلانمىغان',
    vi: 'Không có tấm gỗ tạm lưu',
    zh_tc: '無板件暫存',
    ru: 'Бесплатное временное хранение',
    ko: '보드 없음 임시 저장',
    bur: 'ပေါ်ဒ်ယာယီသိမ်းဆည်းမရှိ',
    ben: 'কোনো বোর্ড অস্থায়ীভাবে সংরক্ষিত নেই',
    tr: 'Geçici levha yok',
    km: 'គ្មានផ្ទាំងផ្ទុកអាចបណ្ដោះអាសន្ន',
    es: 'Sin almacenamiento temporal de la placa',
    ar: 'لا يوجد تخزين مؤقت للوحة',
  },
  'arrangedPage.storageArea.storageTip': {
    zh: '可将板件拖至此处进行板件暂存',
    en: 'Drag board pieces here to temporarily store them',
    id: 'Anda dapat menyeret pelat di sini untuk penyimpanan pelat sementara',
    kz: 'Кескіштерді осы орынға сүйретуге болады',
    th: 'คุณสามารถลากเพลตได้ที่นี่เพื่อจัดเก็บจานชั่วคราว',
    ug: 'تاختا بۆلەكنى بۇ يەرگە سۆرەپ ساقلىيالايسىز',
    vi: 'Bạn có thể kéo tấm gỗ đến đây để tạm lưu',
    zh_tc: '可將板件拖至此處進行板件暫存',
    ru: 'Можно перетащить листы сюда для временного хранения.',
    ko: '슬레이트 보관을 위해 슬레이트를 여기로 끌 수 있습니다.',
    bur: 'ပေါ်ဒ်ကိုဤနေရာသို့ဆွဲဆောင်ယာယီသိမ်းဆည်းနိုင်',
    ben: 'বোর্ড এখানে টেনে অস্থায়ীভাবে সংরক্ষণ করুন',
    tr: 'Levhaları geçici depolamak için buraya sürükleyin',
    km: 'អូសផ្ទាំងមកទីនេះដើម្បីផ្ទុកអាចបណ្ដោះអាសន្ន',
    es: 'Puede arrastrar la placa aquí para guardarla temporalmente',
    ar: 'يمكنك سحب اللوحة هنا لحفظ اللوحة مؤقتًا',
  },
  'arrangedPage.subtleArrange': {
    zh: '精细排版',
    en: 'Fine layout',
    id: 'Tata letak yang bagus',
    kz: 'Теккіл қалыптасу',
    th: 'เค้าโครงที่ดี',
    ug: 'نەپىس تەرتىپلەش',
    vi: 'Bố cục chi tiết',
    zh_tc: '精細排版',
    ru: 'Тщательная типография',
    ko: '세밀한 조판',
    bur: 'ပြင်ဆင်မှုနှင့်ကောင်းမွန်',
    ben: 'সূক্ষ্ম লেআউট',
    tr: 'İnce yerleşim',
    km: 'ការរៀបចំលម្អិត',
    es: 'Composición tipográfica fina',
    ar: 'التنضيد الدقيق',
  },
  'arrangedPage.addPlank': {
    zh: '添加大板',
    en: 'Add large sheet',
    id: 'Tambahkan papan besar',
    kz: 'Өріктегіш кескішті қосу',
    th: 'เพิ่มบอร์ดขนาดใหญ่',
    ug: 'چوڭ تاختا قوشۇش',
    vi: 'Thêm tấm lớn',
    zh_tc: '添加大板',
    ru: 'Добавить большую доску',
    ko: '대시보드 추가',
    bur: 'ပေါ်ဒ်ကြီးထည့်',
    ben: 'বড় বোর্ড যোগ করুন',
    tr: 'Büyük levha ekle',
    km: 'បន្ថែមផ្ទាំងធំ',
    es: 'Agregar placa grande',
    ar: 'إضافة لوحة كبيرة',
  },
  'arrangedPage.deletePlank': {
    zh: '删除大板',
    en: 'Delete large sheet',
    id: 'Hapus papan besar',
    kz: 'Өріктегіш кескішті өшіру',
    th: 'ลบบอร์ดขนาดใหญ่',
    ug: 'چوڭ تاختا ئۆچۈرۈش',
    vi: 'Xóa tấm lớn',
    zh_tc: '刪除大板',
    ru: 'Удалить большую доску',
    ko: '보드 삭제',
    bur: 'ပေါ်ဒ်ကြီးဖျက်',
    ben: 'বড় বোর্ড মুছুন',
    tr: 'Büyük levha sil',
    km: 'លុបផ្ទាំងធំ',
    es: 'Eliminar placa grande',
    ar: 'حذف لوحة كبيرة',
  },
  'arrangedPage.deletePlankErr': {
    zh: '当前大板存在小板, 不可删除大板!',
    en: 'Cannot delete the large sheet as there are smaller sheets on it!',
    id: 'Ada papan kecil saat ini, dan papan besar tidak dapat dihapus!',
    kz: 'Өріктегіш кескіштің кіші кескіштер бар, өріктегіш кескішті өшіруге болмайды!',
    th: 'ปัจจุบันมีบอร์ดขนาดเล็กและไม่สามารถลบบอร์ดขนาดใหญ่ได้!',
    ug: 'نۆۋەتتىكى چوڭ تاختىدا كىچىك تاختا بار, چوڭ تاختا ئۆچۈرۈلمەيدۇ!',
    vi: 'Tấm lớn hiện tại có tấm nhỏ, không thể xóa tấm lớn!',
    zh_tc: '當前大板存在小板, 不可刪除大板!',
    ru: 'В настоящее время большая доска существует, не может удалить большую доску!',
    ko: '현재 대판에 소판이 존재하므로 대판을 삭제할 수 없습니다!',
    bur: 'လက်ရှိပေါ်ဒ်ကြီးတွင်ပေါ်ဒ်ငယ်ရှိ၍ ပေါ်ဒ်ကြီးမဖျက်နိုင်!',
    ben: 'বর্তমান বড় বোর্ডে ছোট বোর্ড আছে, বড় বোর্ড মুছা যাবে না!',
    tr: 'Bu büyük levhada küçük levha var; büyük levha silinemez!',
    km: 'ផ្ទាំងធំមានផ្ទាំងតូច មិនអាចលុបផ្ទាំងធំ!',
    es: 'Hay tablas pequeñas en la tabla grande actual y en la tabla grande ¡No se puede eliminar!',
    ar: 'توجد لوحات صغيرة في اللوحة الكبيرة الحالية، و لا يمكن حذف اللوحة الكبيرة!',
  },
  'arrangedPage.useSurplus.title': {
    zh: '使用余料',
    en: 'Use scrap material',
    id: 'Gunakan bahan residu',
    kz: 'Қалдықтарды пайдалану',
    th: 'ใช้วัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىياللارنى ئىشلەت',
    vi: 'Sử dụng dư liệu',
    zh_tc: '使用餘料',
    ru: 'Использование остатков',
    ko: '남은 재료를 사용하다',
    bur: 'ပိုလျှံပစ္စည်းသုံး',
    ben: 'উদ্বৃত্ত উপকরণ ব্যবহার করুন',
    tr: 'Artık malzemeyi kullan',
    km: 'ប្រើសម្ភារៈសល់',
    es: 'Utilice el material restante',
    ar: 'استخدم المواد المتبقية',
  },
  'arrangedPage.dragWarning': {
    zh: '请将板件拖动至大板上!',
    en: 'Please drag the board piece onto the large sheet!',
    id: 'Harap seret piring ke pelat besar!',
    kz: 'Кескішті өріктегіш кескішке сүйретуңіз!',
    th: 'กรุณาลากจานไปที่จานขนาดใหญ่!',
    ug: 'تاختا بۆلەكنى چوڭ تاختىغا سۆرەڭ!',
    vi: 'Vui lòng kéo tấm gỗ đến tấm lớn!',
    zh_tc: '請將板件拖動至大板上!',
    ru: 'Пожалуйста, перетащите доску на большую доску!',
    ko: '대시보드로 드래그하십시오.',
    bur: 'ပေါ်ဒ်ကိုပေါ်ဒ်ကြီးပေါ်ဆွဲဆောင်ပါ!',
    ben: 'বোর্ডকে বড় বোর্ডের উপরে টেনে নিয়ে যান!',
    tr: 'Lütfen levhayı büyük levhaya sürükleyin!',
    km: 'សូមអូសផ្ទាំងទៅផ្ទាំងធំ!',
    es: '¡Por favor arrastre el tablero al tablero grande!',
    ar: 'يرجى سحب اللوحة إلى اللوحة الكبيرة!',
  },
  'arrangedPage.areaWarning': {
    zh: '无法放置板件,留意空余空间大小',
    en: 'Unable to place the board piece. Please check the available space.',
    id: 'Tidak dapat menempatkan papan, perhatikan ukuran ruang cadangan',
    kz: 'Кескішті орналастыруға болмайды, бос орынның көлеміне назар аударыңыз',
    th: 'ไม่สามารถวางบอร์ดได้ให้ความสนใจกับขนาดของพื้นที่ว่าง',
    ug: 'تاختا بۆلەك قويۇلمىدى, بوش ئورۇن چوڭلۇقىغا دىققەت قىلىڭ',
    vi: 'Không thể đặt tấm gỗ, chú ý kích thước không gian trống',
    zh_tc: '無法放置板件,留意空餘空間大小',
    ru: 'Невозможно разместить панель, обратите внимание на размер свободного пространства',
    ko: '플레이트를 배치할 수 없습니다. 여유 공간 크기에 유의하십시오.',
    bur: 'ပေါ်ဒ်ချနိုင်မည်မဟုတ်ပါ၊ နေရာထားရှိမှုကိုအာရုံစိုက်ပါ',
    ben: 'বোর্ড স্থাপন করা যাচ্ছে না, খালি জায়গার আকার লক্ষ্য করুন',
    tr: 'Levha yerleştirilemiyor; boş alan boyutuna dikkat edin',
    km: 'មិនអាចដាក់ផ្ទាំងបានទេ សូមមើលទំហំកន្លែងទំនេរ',
    es: 'No se puede colocar la tabla, preste atención al tamaño del espacio libre',
    ar: 'لا يمكن وضع اللوحة، انتبه إلى حجم المساحة الحرة',
  },
  'arrangedPage.subtlePage.cut': {
    zh: '余料裁剪',
    en: 'Scrap cutting',
    id: 'Pemotongan bahan yang tersisa',
    kz: 'Қалдықтарды кесу',
    th: 'การตัดวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىياللارنى كېسىش',
    vi: 'Cắt dư liệu',
    zh_tc: '餘料裁剪',
    ru: 'Резка остатков',
    ko: '여분 재단',
    bur: 'ပိုလျှံပစ္စည်းဖြတ်',
    ben: 'উদ্বৃত্ত উপকরণ কাটা',
    tr: 'Artık malzeme kesimi',
    km: 'កាត់សម្ភារៈសល់',
    es: 'Corte de material restante',
    ar: 'قطع المواد المتبقية',
  },
  'arrangedPage.subtlePage.lineTip': {
    zh: '如果手动裁剪有误可以ctrl+z返回上一裁剪点位',
    en: 'If the manual cutting is incorrect, you can use ctrl+z to return to the previous cutting point',
    id: 'Jika pemotongan manual salah, Anda dapat menggunakan ctrl+z untuk kembali ke titik pemotongan sebelumnya',
    kz: 'Егер кесудің қолмен орындалуы қате болса, ctrl+z арқылы алдыңғы кесу нүктесіне қайта оралуға болады',
    th: 'ถ้าการตัดด้วยมือผิดพลาด คุณสามารถใช้ ctrl+z เพื่อกลับไปที่จุดตัดก่อนหน้า',
    ug: 'قالدۇق ماتېرىياللارنى كېسىشتىن ئىشلىتىش قىتىم بولسا, ctrl+z ئارقا قالدۇق ماتېرىياللارنى كېسىشتىن قايتۇرۇش قىلىشقا بولىدۇ',
    vi: 'Nếu cắt thủ công sai, bạn có thể sử dụng ctrl+z để quay lại điểm cắt trước đó',
    zh_tc: '如果手動裁剪有誤可以ctrl+z返回上一裁剪點位',
    ru: 'Если ручная резка неверна, вы можете использовать ctrl+z, чтобы вернуться к предыдущей точке резки',
    ko: '수동 절단이 잘못된 경우 ctrl+z를 사용하여 이전 절단 지점으로 돌아갈 수 있습니다',
    bur: 'ပေါ်ဒ်ကြီးပေါ်တွင်သာဖြတ်နိုင်၍ ပေါ်ဒ်ငယ်ကိုမထိနိုင်!',
    ben: 'বোর্ড লেআউটের অপেক্ষায় অঞ্চল',
    tr: 'Artık malzeme kesimi',
    km: 'កាត់សម្ភារៈសល់',
    es: 'Corte de material restante',
    ar: 'قطع المواد المتبقية',
  },
  'arrangedPage.subtlePage.cancelCut': {
    zh: '结束裁剪',
    en: 'Cancel cutting',
    id: 'Akhiri potongannya',
    kz: 'Кесуді тоқтату',
    th: 'จบการตัด',
    ug: 'كېسىشتىن ۋاز كېچىش',
    vi: 'Hủy cắt',
    zh_tc: '結束裁剪',
    ru: 'Завершение обрезки',
    ko: '자르기 종료',
    bur: 'ဖြတ်တောက်ဆုံးနားပြ',
    ben: 'কাটা শেষ করুন',
    tr: 'Kesimi bitir',
    km: 'បញ្ចប់ការកាត់',
    es: 'Corte final',
    ar: 'قطع النهاية',
  },
  'arrangedPage.subtlePage.cutPoint': {
    zh: '余料裁剪吸附点',
    en: 'Scrap cutting adsorption point',
    id: 'Titik adsorpsi pemotongan bahan yang tersisa',
    kz: 'Қалдықтарды кесудің сүйреу нүктесі',
    th: 'จุดดูดซับวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال كېسىش يېپىشىش نۇقتىسى',
    vi: 'Điểm hấp thụ cắt dư liệu',
    zh_tc: '餘料裁剪吸附點',
    ru: 'конгруэнтная отсоса остаточной обрезки',
    ko: '남은 재료 재단 흡착점',
    bur: 'ပိုလျှံပစ္စည်းဖြတ်ဆွဲဆောင်မှတ်',
    ben: 'উদ্বৃত্ত কাটার শোষণ বিন্দু',
    tr: 'Artık kesim yapışma noktası',
    km: 'ចំណុចរុញរបស់ការកាត់សល់',
    es: 'Punto de succión de corte de material restante',
    ar: 'نقطة شفط قطع المواد المتبقية',
  },
  'arrangedPage.subtlePage.storageArea': {
    zh: '板件待排板区',
    en: 'Temporary storage area',
    id: 'Bagian pelat yang harus diatur',
    kz: 'Айналма сақтау орны',
    th: 'ชิ้นส่วนจานที่จะจัดเรียง',
    ug: 'تاختا بۆلەك ساقلىغۇچى',
    vi: 'Khu vực tạm lưu',
    zh_tc: '板件待排板區',
    ru: 'зона заготовки листов',
    ko: '플레이트 부품 대기열 플레이트 영역',
    bur: 'ပေါ်ဒ်ပြင်ဆင်ရန်ကြိုဆောင်ဧရိယာ',
    ben: 'বোর্ড লেআউটের অপেক্ষায় অঞ্চল',
    tr: 'Levha yerleşim bekleme alanı',
    km: 'តំបន់ផ្ទាំងរង់ចាំការរៀបចំ',
    es: 'Área de espera de la tabla',
    ar: 'منطقة انتظار اللوحة',
  },
  'arrangedPage.subtlePage.cutErr': {
    zh: '只能在大板上进行切割, 不能触碰小板!',
    en: 'Cutting can only be performed on the large sheet, and cannot touch the smaller sheets!',
    id: 'Anda hanya bisa memotong piring besar dan tidak bisa menyentuh piring kecil!',
    kz: 'Кесу тек өріктегіш кескіштегі болады, кіші кескіштерге жамау болмайды!',
    th: 'คุณสามารถตัดบนแผ่นขนาดใหญ่และไม่สามารถสัมผัสแผ่นเล็ก ๆ ได้!',
    ug: 'پەقەت چوڭ تاختىدا كېسىشكە بولىدۇ, كىچىك تاختىغا تەگكۈزمەڭ!',
    vi: 'Chỉ có thể cắt trên tấm lớn, không được chạm vào tấm nhỏ!',
    zh_tc: '只能在大板上進行切割, 不能觸碰小板!',
    ru: 'Разрезать можно только на большой доске, не прикасаясь к ней!',
    ko: '큰 판자에서만 절단할 수 있고 작은 판을 건드려서는 안 된다!',
    bur: 'ပေါ်ဒ်ကြီးပေါ်တွင်သာဖြတ်နိုင်၍ ပေါ်ဒ်ငယ်ကိုမထိနိုင်!',
    ben: 'শুধুমাত্র বড় বোর্ডে কাটা যাবে, ছোট বোর্ড স্পর্শ করা যাবে না!',
    tr: 'Kesim yalnızca büyük levhada yapılabilir; küçük levhaya dokunmayın!',
    km: 'កាត់បានតែលើផ្ទាំងធំ មិនត្រូវប៉ះផ្ទាំងតូច!',
    es: 'Solo se puede cortar en la tabla grande. ¡No toques el tablero pequeño!',
    ar: 'لا يمكن القطع إلا على اللوحة الكبيرة. لا تلمس اللوحة الصغيرة!',
  },
  'arrangedPage.subtlePage.saveErr': {
    zh: '请先选择一个裁剪的余料',
    en: 'Please select a scrap material to cut first',
    id: 'Pilih bahan potong',
    kz: 'Қалдықтарды кесу үшін бір кескіш таңдаңыз',
    th: 'กรุณาเลือกวัสดุตัด',
    ug: 'ئاۋۋال بىر كېسىلگەن قالدۇق ماتېرىيال تاللاڭ',
    vi: 'Vui lòng chọn một dư liệu để cắt trước',
    zh_tc: '請先選擇一個裁剪的餘料',
    ru: 'Пожалуйста, выберите отрезанный остаток.',
    ko: '먼저 재단할 여분의 재료를 선택하십시오.',
    bur: 'ဦးစွာဖြတ်ရမည့်ပိုလျှံပစ္စည်းတစ်ခုရွေးပါ',
    ben: 'প্রথমে একটি কাটার উদ্বৃত্ত উপকরণ নির্বাচন করুন',
    tr: 'Önce kesilecek bir artık malzeme seçin',
    km: 'សូមជ្រើសរើសសម្ភារៈសល់ដើម្បីកាត់មុន',
    es: 'Primero seleccione un material recortado',
    ar: 'يرجى تحديد المادة المقطوعة أولاً',
  },
  'arrangedPage.subtlePage.cutErr2': {
    zh: '只能在大板上进行切割, 不可超出大板!',
    en: 'Cutting can only be performed on the main board and cannot exceed the main board!',
    id: 'Cut hanya bisa dilakukan di piring besar dan tidak bisa melebihi pelat besar!',
    kz: 'Үлкен бағанада тексеру жасалады, бағанадан тыс қалмайды!',
    th: 'ตัดสามารถทำได้บนแผ่นขนาดใหญ่และไม่เกินแผ่นขนาดใหญ่!',
    ug: 'پەقەت چوڭ تاختىدا كېسىشكە بولىدۇ, چوڭ تاختىدىن چىقىپ كەتمەڭ!',
    vi: 'Chỉ có thể cắt trên tấm lớn, không được vượt quá tấm lớn!',
    zh_tc: '只能在大板上進行切割, 不可超出大板!',
    ru: 'Разрезать можно только на большой доске, не выходя за ее пределы!',
    ko: '널빤지에서만 절단할 수 있고, 널빤지를 초과해서는 안 된다!',
    bur: 'ပေါ်ဒ်ကြီးပေါ်တွင်သာဖြတ်နိုင်၍ ပေါ်ဒ်ကြီးကျော်မနိုင်!',
    ben: 'শুধুমাত্র বড় বোর্ডে কাটা যাবে, বড় বোর্ড অতিক্রম করা যাবে না!',
    tr: 'Kesim yalnızca büyük levhada yapılabilir; büyük levhayı aşmayın!',
    km: 'កាត់បានតែលើផ្ទាំងធំ កុំហួសផ្ទាំងធំ!',
    es: '¡El corte solo se puede realizar en el tablero grande, no más allá del tablero grande!',
    ar: 'لا يمكن إجراء القطع إلا على اللوحة الكبيرة، وليس خارج اللوحة الكبيرة!',
  },
  'arrangedPage.subtlePage.selectTip': {
    zh: '请选择一个裁剪的余料板件',
    en: 'Please select a surplus material plank for cutting',
    id: 'Pilih potongan cadangan',
    kz: 'Таңдаңыз түс қылу қалдық плақтар',
    th: 'กรุณาเลือกชิ้นส่วนสำรอง',
    ug: 'بىر كېسىلگەن قالدۇق ماتېرىيال تاللاڭ',
    vi: 'Vui lòng chọn một tấm dư liệu để cắt',
    zh_tc: '請選擇一個裁剪的餘料板件',
    ru: 'Пожалуйста, выберите отрезанный лист.',
    ko: '자른 나머지 원단을 선택하십시오.',
    bur: 'ဖြတ်ရမည့်ပိုလျှံပစ္စည်းပေါ်ဒ်တစ်ခုရွေးပါ',
    ben: 'কাটার জন্য একটি উদ্বৃত্ত উপকরণ বোর্ড নির্বাচন করুন',
    tr: 'Kesim için bir artık levha parçası seçin',
    km: 'សូមជ្រើសរើសផ្ទាំងសម្ភារៈសល់ដើម្បីកាត់',
    es: 'Seleccione un panel remanente cortado',
    ar: 'يرجى تحديد لوحة القطع المتبقية',
  },
  'arrangedPage.subtlePage.noCutPath': {
    zh: '异形部分不能裁剪矩形',
    en: 'Irregular parts cannot cut rectangles',
    id: 'Bentuknya tidak dapat dipotong menjadi persegi panjang',
    kz: 'Қалыпты бөлімдер қвадратты қиып алу мүмкін емес',
    th: 'รูปร่างไม่สามารถตัดเป็นสี่เหลี่ยมได้',
    ug: 'ئۆزگىچە شەكىللىك بۆلەكلەر تۆت تەرەپلىك كېسىلمەيدۇ',
    vi: 'Phần ngoài hình không thể cắt hình chữ nhật',
    zh_tc: '異形部分不能裁剪矩形',
    ru: 'Нельзя вырезать прямоугольник.',
    ko: '이형 부분은 직사각형을 자를 수 없다',
    bur: 'အထူးပုံအပိုင်းတွင်တစ်ထောင့်မှန်မဖြတ်နိုင်',
    ben: 'অনিয়মিত অংশে আয়তক্ষেত্র কাটা যাবে না',
    tr: 'Özel şekilli bölümler dikdörtgen kesilemez',
    km: 'ផ្នែករាងមិនធម្មតាមិនអាចកាត់ចតុកោណបាន',
    es: 'Las piezas con formas especiales no se pueden cortar en rectángulos',
    ar: 'لا يمكن قطع الأجزاء ذات الشكل الخاص إلى مستطيلات',
  },
  'arrangedPage.subtlePage.cutOperate': {
    zh: '余料裁剪操作',
    en: 'Remaining material cutting operation',
    id: 'Operasi pemotongan material yang tersisa',
    kz: 'қалайтын материалдарды қиып шығару әрекеті',
    th: 'การดำเนินการตัดวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال كېسىش مەشغۇلاتى',
    vi: 'Hoạt động cắt dư',
    zh_tc: '餘料裁剪操作',
    ru: 'Операции по обрезке остатков',
    ko: '여분 재료 재단 작업',
    bur: 'ပိုလျှံပစ္စည်းဖြတ်တောက်လုပ်ဆောင်မှု',
    ben: 'উদ্বৃত্ত উপকরণ কাটার অপারেশন',
    tr: 'Artık malzeme kesim işlemi',
    km: 'ប្រតិបត្តិការកាត់សម្ភារៈសល់',
    es: 'Operación de corte del material restante',
    ar: 'عملية قطع المواد المتبقية',
  },
  'arrangedPage.subtlePage.line': {
    zh: '手动描边',
    en: 'Manual stroke',
    id: 'Stroke manual',
    kz: 'қолмен қоршау',
    th: 'จังหวะด้วยตนเอง',
    ug: 'قولدا سىزىش',
    vi: 'Manual stroke',
    zh_tc: '手動描邊',
    ru: 'Ручное обрезание',
    ko: '수동으로 모서리 그리기',
    bur: 'လက်ဖြင့်ဘောင်ဆွဲ',
    ben: 'ম্যানুয়াল স্ট্রোক',
    tr: 'Manuel kontur',
    km: 'គូរសង់ដៃ',
    es: 'Trazo manual',
    ar: 'ضربة يدوية',
  },
  'arrangedPage.subtlePage.cutErrtip': {
    zh: '裁剪点位存在交叉问题，请重新裁剪',
    en: 'There is a cross problem with the cutting point, please re-cut',
    id: 'Ada masalah persilangan pada titik pemotongan, silakan potong ulang',
    kz: 'Кесу нүктесінде қиылысу мәселесі бар, қайта кесіңіз',
    th: 'มีปัญหาการตัดกันที่จุดตัด กรุณาตัดใหม่',
    ug: 'كېسىش نۇقتىسىدا كېسىشىش مەسىلىسى بار، قايتا كېسىڭ',
    vi: 'Có vấn đề giao nhau tại điểm cắt, vui lòng cắt lại',
    zh_tc: '裁剪點位存在交叉問題，請重新裁剪',
    ru: 'В точке резки есть перекрестные проблемы, пожалуйста, перекройте',
    ko: '자르기 지점의 교차 문제가 있습니다. 다시 자르십시오.',
    bur: 'ဖြတ်တောက်မှတ်တွင်ကျော်မြောက်ပြဿနာရှိ၊ ပြန်ဖြတ်ပါ',
    ben: 'কাটার বিন্দুতে ছেদ সমস্যা আছে, পুনরায় কাটুন',
    tr: 'Kesim noktalarında kesişim var; yeniden kesin',
    km: 'មានចំណុចកាត់ឆ្លងគ្នា សូមកាត់ឡើងវិញ',
    es: 'Hay un problema de corte transversal en el punto de corte, vuelva a recortar',
    ar: 'هناك مشكلة في القطع العرضي عند نقطة القطع، يرجى إعادة القص',
  },
  'arrangedPage.subtlePage.cutErrtip2': {
    zh: '裁剪点位将超出点位限制:9，请重新裁剪',
    en: 'The cutting point will exceed the point limit: 9, please re-cut',
    id: 'Titik pemotongan akan melebihi batas titik: 9, silakan potong ulang',
    kz: 'Кесу нүктесі нүкте шектеуін асып кетеді: 9, қайта кесіңіз',
    th: 'จุดตัดจะเกินขีดจำกัดจุด: 9 กรุณาตัดใหม่',
    ug: 'كېسىش نۇقتىسى نۇقتا چەكلىمىنى ئاشىدۇ: 9، قايتا كېسىڭ',
    vi: 'Điểm cắt sẽ vượt quá giới hạn điểm: 9, vui lòng cắt lại',
    zh_tc: '裁剪點位將超出點位限制:9，請重新裁剪',
    ru: 'Точки обрезки будут превышать лимит точки: 9, пожалуйста, перекройте',
    ko: '자르기 위치 제한 초과: 9, 다시 자르십시오.',
    bur: 'ဖြတ်တောက်မှတ်သည် ၉ မှတ်ကန့်သတ်ကျော်လွန်မည်၊ ပြန်ဖြတ်ပါ',
    ben: 'কাটার বিন্দু সীমা ৯ অতিক্রম করবে, পুনরায় কাটুন',
    tr: 'Kesim noktası sınırı aşacak: 9; yeniden kesin',
    km: 'ចំណុចកាត់នឹងហួសកំណត់ ៩ សូមកាត់ឡើងវិញ',
    es: 'El punto de corte excederá el límite de puntos: 9, vuelva a recortar',
    ar: 'ستتجاوز نقطة القطع الحد الأقصى للنقطة: 9، يرجى إعادة القص',
  },
  'arrangedPage.shortCut': {
    zh: '快捷键',
    en: 'Shortcut keys',
    id: 'Kunci Pintasan',
    kz: 'Қысқа шықымдар',
    th: 'คีย์ทางลัด',
    ug: 'تېزلەتمە',
    vi: 'Phím tắt',
    zh_tc: '快捷鍵',
    ru: 'Комбинации клавиш',
    ko: '단축키',
    bur: 'ကီးဘုတ်အမြန်',
    ben: 'কীবোর্ড শর্টকাট',
    tr: 'Kısayollar',
    km: 'ផ្លូវកាត់',
    es: 'Teclas de acceso directo',
    ar: 'مفاتيح الاختصار',
  },
  'arrangedPage.updownRoll': {
    zh: '上下滑动',
    en: 'Scroll up and down',
    id: 'Menggesek ke atas dan ke bawah',
    kz: 'Жоғары-төмен слайд',
    th: 'ปัดขึ้นและลง',
    ug: 'ئۈستە-ئاستا سۆرەش',
    vi: 'Trượt lên xuống',
    zh_tc: '上下滑動',
    ru: 'Сверху - вниз',
    ko: '위아래로 미끄러지다',
    bur: 'အပေါ်အောက်ဆလိုက်',
    ben: 'উপরে নিচে স্ক্রল করুন',
    tr: 'Yukarı-aşağı kaydır',
    km: 'រំកិលឡើយចុះ',
    es: 'Deslizar hacia arriba y hacia abajo',
    ar: 'التمرير لأعلى ولأسفل',
  },
  'arrangedPage.leftRightRoll': {
    zh: '左右滑动',
    en: 'Scroll left and right',
    id: 'Geser ke kiri dan kanan',
    kz: 'Сол-оң слайд',
    th: 'เลื่อนไปทางซ้ายและขวา',
    ug: 'سول-ئوڭ سۆرەش',
    vi: 'Trượt trái phải',
    zh_tc: '左右滑動',
    ru: 'Скользящее влево и вправо',
    ko: '좌우 슬라이딩',
    bur: 'ဘယ်ညာဆလိုက်',
    ben: 'বাম ডানে স্ক্রল করুন',
    tr: 'Sol-sağ kaydır',
    km: 'រំកិលឆ្វេងស្ដាំ',
    es: 'Deslizar hacia la izquierda y hacia la derecha',
    ar: 'اسحب لليسار واليمين',
  },
  'arrangedPage.zoomScale': {
    zh: '放大缩小',
    en: 'Zoom in and out',
    id: 'Zoom masuk dan keluar',
    kz: 'Чоңайту-кішірейту',
    th: 'ซูมเข้าและออก',
    ug: 'چوڭايتىش-كىچىكلەشتۈرۈش',
    vi: 'Phóng to thu nhỏ',
    zh_tc: '放大縮小',
    ru: 'Увеличить',
    ko: '확대 축소',
    bur: 'ချဲ့ကျုံ့',
    ben: 'জুম ইন আউট করুন',
    tr: 'Yakınlaştır-uzaklaştır',
    km: 'ពង្រីក និងបង្រួម',
    es: 'Acercar y alejar',
    ar: 'تكبير وتصغير',
  },
  'arrangedPage.dragCanvas': {
    zh: '拖动页面',
    en: 'Drag the page',
    id: 'Seret halaman',
    kz: 'Бетті сүйрету',
    th: 'ลากหน้า',
    ug: 'بەتنى سۆرەش',
    vi: 'Kéo trang',
    zh_tc: '拖動頁面',
    ru: 'Перетащите страницу',
    ko: '페이지 드래그',
    bur: 'စာမျက်နှာဆွဲဆောင်',
    ben: 'পেজ টেনে নিয়ে যান',
    tr: 'Sayfayı sürükleyin',
    km: 'អូសទំព័រ',
    es: 'Arrastrar página',
    ar: 'اسحب الصفحة',
  },
  'arrangedPage.mouseRoll': {
    zh: '鼠标滚轮',
    en: 'Mouse scroll wheel',
    id: 'Roda gulir tikus',
    kz: 'Мышыңыздың роликтікі',
    th: 'ล้อเลื่อนเมาส์',
    ug: 'چاشقىنەك گۈلدۈرمىسى',
    vi: 'Cuộn chuột',
    zh_tc: '鼠標滾輪',
    ru: 'Колесо мыши',
    ko: '마우스 휠',
    bur: 'မောက်စ်ဘီး',
    ben: 'মাউস স্ক্রোল হুইল',
    tr: 'Fare tekerleği',
    km: 'កង់រមូរកណ្ដុរ',
    es: 'Rueda del mouse',
    ar: 'عجلة الماوس',
  },
  'arrangedPage.mouseRight': {
    zh: '鼠标右键',
    en: 'Right mouse button',
    id: 'Tombol mouse kanan',
    kz: 'Мышыңыздың оң батырмақ',
    th: 'ปุ่มเมาส์ขวา',
    ug: 'چاشقىنەك ئوڭ كۇنپۇكا',
    vi: 'Nhân chuột phải',
    zh_tc: '鼠標右鍵',
    ru: 'Правая кнопка мыши',
    ko: '마우스 오른쪽 버튼',
    bur: 'မောက်စ်ညာ',
    ben: 'মাউসের ডান বোতাম',
    tr: 'Sağ tık',
    km: 'ចុចកណ្ដុរស្ដាំ',
    es: 'Botón derecho del mouse',
    ar: 'زر الماوس الأيمن',
  },
  'arrangedPage.mouseMultiSelect': {
    zh: '多选板件',
    en: 'Multi-select board pieces',
    id: 'Pilih beberapa papan sekaligus',
    kz: 'Кескіштерді бір мезгілде таңдау',
    th: 'เลือกกระดานหลายๆ รายการพร้อมกัน',
    ug: 'بۆلەكتى ئۆزى بىر ۋاقىتта تاشلاندۇرۇش',
    vi: 'Chọn nhiều tấm gỗ cùng một lúc',
    zh_tc: '多選板件',
    ru: 'Выбор нескольких панелей одновременно',
    ko: '보드 파트를 여러 개 선택',
    bur: 'ပေါ်ဒ်ပါတ်များကို တစ်ခါတည်းထပ်နှစ်ချက်ကလစ်',
    ben: 'বোর্ড পার্টসকে একই সময়ে চয়ন করুন',
    tr: 'Birden fazla levhayı seçin',
    km: 'ជ្រើសរើសផ្ទាំងពីរចុងក្រោយ',
    es: 'Seleccionar varias hojas a la vez',
    ar: 'اختيار أكثر من لوحة في وقت واحد',
  },
  'arrangedPage.mouseLeft': {
    zh: '鼠标左键',
    en: 'Left mouse button',
    id: 'Tombol mouse kiri',
    kz: 'Мышыңыздың сол батырмақ',
    th: 'ปุ่มเมาส์ซ้าย',
    ug: 'چاشقىنەك سول كۇنپۇكا',
    vi: 'Nhân chuột trái',
    zh_tc: '鼠標左鍵',
    ru: 'Левая кнопка мыши',
    ko: '마우스 왼쪽 버튼',
    bur: 'မောက်စ်အမြန်',
    ben: 'মাউসের বাম বোতাম',
    tr: 'Sol tık',
    km: 'ចុចកណ្ដុរឆ្វេង',
    es: 'Botón izquierdo del mouse',
    ar: 'زر الماوس الأيسر',
  },
  'arrangedPage.doublePlank': {
    zh: '双击大板',
    en: 'Double-click the large sheet',
    id: 'Klik dua kali di papan besar',
    kz: 'Өріктегіш кескішті екі рет шақыру',
    th: 'ดับเบิลคลิกที่กระดานใหญ่',
    ug: 'چوڭ تاختىنى قوش چېكىش',
    vi: 'Nhân đúp tấm lớn',
    zh_tc: '雙擊大板',
    ru: 'Двойной щелчок по доске',
    ko: '보드를 두 번 클릭합니다.',
    bur: 'ပေါ်ဒ်ကြီးကိုနှစ်ချက်ကလစ်',
    ben: 'বড় বোর্ডে ডাবল ক্লিক করুন',
    tr: 'Büyük levhaya çift tıklayın',
    km: 'ចុចពីរដងលើផ្ទាំងធំ',
    es: 'Haga doble clic en el tablero',
    ar: 'انقر نقرًا مزدوجًا على اللوحة',
  },
  'arrangedPage.keyboard': {
    zh: '键盘',
    en: 'Keyboard',
    id: 'keyboard',
    kz: 'Клавиатура',
    th: 'คีย์บอร์ด',
    ug: 'ھەرپ تاختا',
    vi: 'Bàn phím',
    zh_tc: '鍵盤',
    ru: 'клавиатура',
    ko: '키보드',
    bur: 'ကီးဘုတ်',
    ben: 'কীবোর্ড',
    tr: 'Klavye',
    km: 'ក្ដារចុច',
    es: 'Teclado',
    ar: 'لوحة المفاتيح',
  },
  'arrangedPage.picSymble': {
    zh: '图例',
    en: 'Legend',
    id: 'legenda',
    kz: 'Сүретті белгі',
    th: 'ตำนาน',
    ug: 'رەسىم مىساللىرى',
    vi: 'Bản đồ',
    zh_tc: '圖例',
    ru: 'Легенда',
    ko: '범례',
    bur: 'ပုံသင်္ကေတ',
    ben: 'কিংবদন্তি',
    tr: 'Lejant',
    km: 'រូបភាពណែនាំ',
    es: 'Leyenda',
    ar: 'وسيلة الإيضاح',
  },
  'arrangedPage.funished': {
    zh: '成品',
    en: 'Finished product',
    id: 'Produk jadi',
    kz: 'Жазық',
    th: 'สินค้าสำเร็จรูป',
    ug: 'مەھسۇلات',
    vi: 'Sản phẩm hoàn thành',
    zh_tc: '成品',
    ru: 'готовое изделие',
    ko: '최종 품목',
    bur: 'ပြီးစီးသောပစ္စည်း',
    ben: 'সম্পন্ন পণ্য',
    tr: 'Tamamlanmış ürün',
    km: 'ផលិតផលសម្រេច',
    es: 'Producto terminado',
    ar: 'المنتج النهائي',
  },
  'arrangedPage.holeSlotConflict1': {
    zh: '孔槽冲突',
    en: 'Hole and slot conflict',
    id: 'Konflik lubang',
    kz: 'Отындар мен саңылаулардың қақтығысы',
    th: 'ความขัดแย้งของหลุม',
    ug: 'تېشىك/ئويۇق توقۇنۇشى',
    vi: 'Xung đột khe/lỗ',
    zh_tc: '孔槽衝突',
    ru: 'Конфликт с отверстиями',
    ko: '구멍 슬롯 충돌',
    bur: 'ပေါက်ကြိုးပဋိပက္ခ',
    ben: 'গর্ত-স্লট সংঘাত',
    tr: 'Delik-oluk çakışması',
    km: 'ការប៉ះទង្គិចរណ្តៅ-រន្ធ',
    es: 'Conflicto entre orificios y ranuras',
    ar: 'تعارض الفتحة والفتحة',
  },
  'arrangedPage.plankErr': {
    zh: '板件冲突',
    en: 'Board piece conflict',
    id: 'Konflik piring',
    kz: 'Кескіштердің қақтығысы',
    th: 'ความขัดแย้งของแผ่น',
    ug: 'تاختا بۆلەك توقۇنۇشى',
    vi: 'Xung đột tấm gỗ',
    zh_tc: '板件衝突',
    ru: 'Конфликт панелей',
    ko: '보드 충돌',
    bur: 'ပေါ်ဒ်ပဋိပက္ခ',
    ben: 'বোর্ড সংঘাত',
    tr: 'Levha çakışması',
    km: 'ការប៉ះទង្គិចផ្ទាំង',
    es: 'Conflicto entre paneles',
    ar: 'تعارض اللوحة',
  },
  'arrangedPage.frontSlot': {
    zh: '正面拉槽',
    en: 'Front slot',
    id: 'Slot tarik depan',
    kz: 'Алдыңғы жақта саңылау',
    th: 'ช่องดึงด้านหน้า',
    ug: 'ئالدىنقى تەرەپ ئويۇقى',
    vi: 'Khe mặt trước',
    zh_tc: '正面拉槽',
    ru: 'лобовая вытяжка',
    ko: '정면 슬롯',
    bur: 'ရှေ့မျက်နှာဆွဲချောင်း',
    ben: 'সামনের স্লট',
    tr: 'Ön yüz oluk',
    km: 'រន្ធខាងមុខ',
    es: 'Ranura frontal',
    ar: 'الأخدود الأمامي',
  },
  'arrangedPage.backSlot': {
    zh: '反面拉槽',
    en: 'Back slot',
    id: 'Slot tarik terbalik',
    kz: 'Артыңғы жақта саңылау',
    th: 'สล็อตดึงย้อนกลับ',
    ug: 'ئارقا تەرەپ ئويۇقى',
    vi: 'Khe mặt sau',
    zh_tc: '反面拉槽',
    ru: 'Обратная вытяжка',
    ko: '후면 당김 슬롯',
    bur: 'နောက်မျက်နှာဆွဲချောင်း',
    ben: 'পিছনের স্লট',
    tr: 'Arka yüz oluk',
    km: 'រន្ធខាងក្រោយ',
    es: 'Ranura inversa',
    ar: 'الأخدود العكسي',
  },
  'arrangedPage.frontHole': {
    zh: '正面孔位',
    en: 'Front hole',
    id: 'Posisi wajah depan',
    kz: 'Алдыңғы жақта отын',
    th: 'ตำแหน่งของหน้าด้านหน้า',
    ug: 'ئالدىنقى تەرەپ تېشىكى',
    vi: 'Vị trí lỗ mặt trước',
    zh_tc: '正面孔位',
    ru: 'Позиция переднего отверстия',
    ko: '전면 구멍 비트',
    bur: 'ရှေ့မျက်နှာပေါက်',
    ben: 'সামনের গর্ত',
    tr: 'Ön yüz delik',
    km: 'រណ្តៅខាងមុខ',
    es: 'Posición frontal',
    ar: 'الموضع الأمامي',
  },
  'arrangedPage.backHole': {
    zh: '反面孔位',
    en: 'Back hole',
    id: 'Posisi wajah terbalik',
    kz: 'Артыңғы жақта отын',
    th: 'ตำแหน่งใบหน้าย้อนกลับ',
    ug: 'ئارقا تەرەپ تېشىكى',
    vi: 'Vị trí lỗ mặt sau',
    zh_tc: '反面孔位',
    ru: 'Отрицательное положение отверстия',
    ko: '후면 구멍 비트',
    bur: 'နောက်မျက်နှာပေါက်',
    ben: 'পিছনের গর্ত',
    tr: 'Arka yüz delik',
    km: 'រណ្តៅខាងក្រោយ',
    es: 'Posición de cara negativa',
    ar: 'موضع الوجه السلبي',
  },
  'arrangedPage.resetScale': {
    zh: '重置缩放',
    en: 'Reset zoom',
    id: 'Setel ulang zoom',
    kz: 'Өлшемді қайта орноту',
    th: 'รีเซ็ตซูม',
    ug: 'چوڭ-كىچىكلىكنى قايتا تەڭشەش',
    vi: 'Đặt lại tỷ lệ phóng to',
    zh_tc: '重置縮放',
    ru: 'Сбросить масштаб',
    ko: '줌 재설정',
    bur: 'ချဲ့ကျုံ့မူရင်းပြန်',
    ben: 'জুম রিসেট করুন',
    tr: 'Yakınlaştırmayı sıfırla',
    km: 'កំណត់ការពង្រីកឡើងវិញ',
    es: 'Restablecer escala',
    ar: 'إعادة تعيين القياس',
  },
  'arrangedPage.maxLong': {
    zh: '最长',
    en: 'Maximum length',
    id: 'terpanjang',
    kz: 'Ең ұзын',
    th: 'ยาวนานที่สุด',
    ug: 'ئەڭ ئۇزۇن',
    vi: 'Dài nhất',
    zh_tc: '最長',
    ru: 'самый длинный',
    ko: '최장',
    bur: 'အရှည်ဆုံး',
    ben: 'সর্বোচ্চ দৈর্ঘ্য',
    tr: 'Maksimum uzunluk',
    km: 'វែងបំផុត',
    es: 'Más larga',
    ar: 'الأطول',
  },
  'arrangedPage.tempErr': {
    zh: '添加失败,模板位置不正确或模板过大!',
    en: 'Failed to add. Template position is incorrect or template is too large!',
    id: 'Gagal menambahkan, posisi template yang salah atau template terlalu besar!',
    kz: 'Қосу сәтсіз, шаблонның орналасуы дұрыс емес немесе шаблон тым үлкен!',
    th: 'ไม่สามารถเพิ่มตำแหน่งเทมเพลตที่ไม่ถูกต้องหรือเทมเพลตขนาดใหญ่เกินไป!',
    ug: 'قوشۇش مەغلۇپ بولدى, قېلىپ ئورنى خاتا ياكى قېلىپ بەك چوڭ!',
    vi: 'Thêm thất bại, vị trí mẫu không chính xác hoặc mẫu quá lớn!',
    zh_tc: '添加失敗,模板位置不正確或模板過大!',
    ru: 'Ошибка добавления, неправильное расположение шаблона или слишком большой шаблон!',
    ko: '추가에 실패했습니다. 템플릿 위치가 잘못되었거나 너무 큽니다!',
    bur: 'ထည့်မှုမအောင်မြင်၊ ပုံစံနေရာမမှန်ကန် သို့မဟုတ် ပုံစံကြီးလွန်!',
    ben: 'যোগ করতে ব্যর্থ, টেমপ্লেট অবস্থান সঠিক নয় বা টেমপ্লেট অনেক বড়!',
    tr: 'Ekleme başarısız; şablon konumu hatalı veya şablon çok büyük!',
    km: 'បន្ថែមបរាជ័យ ទីតាំងគំរូមិនត្រឹមត្រូវ ឬគំរូធំពេក!',
    es: 'Error al agregar, la posición de la plantilla es incorrecta o la plantilla es demasiado grande.',
    ar: 'فشلت الإضافة، موضع القالب غير صحيح أو أن القالب كبير جدًا!',
  },
  'arrangedPage.sendErr': {
    zh: '发送车间失败，请检查标签模板与板件数据是否正确之后重新发送',
    en: 'Failed to send to workshop, please check if the tag template and plank data are correct before resending',
    id: 'Lokakarya pengiriman gagal. Silakan periksa apakah template label dan data papan sudah benar sebelum mengirimnya lagi.',
    kz: 'Цехке жіберу сәтсіз, тегіннің үлгісі мен плақ түзетілгені дұрыс па, содан кейін қайта жіберіңіз',
    th: 'การประชุมเชิงปฏิบัติการการส่งล้มเหลว โปรดตรวจสอบว่าเทมเพลตฉลากและข้อมูลบอร์ดนั้นถูกต้องก่อนที่จะส่งอีกครั้งหรือไม่',
    ug: 'سېلىق زاۋۇتىغا يوللاش مەغلۇپ بولدى، بەلگە قېلىپى ۋە تاختا بۆلەك سانلىق مەلۇماتىنى تەكشۈرۈپ قايتا يوللاڭ',
    vi: 'Gửi thất bại đến xưởng, vui lòng kiểm tra mẫu nhãn và dữ liệu tấm gỗ là chính xác trước khi gửi lại',
    zh_tc: '發送車間失敗，請檢查標籤模板與板件數據是否正確之後重新發送',
    ru: 'Ошибка отправки в цехе, проверьте правильность шаблона метки и данных шаблона после отправки',
    ko: '작업장을 보내는 데 실패했습니다. 레이블 템플릿과 보드 데이터가 올바른지 확인한 후 다시 보내십시오.',
    bur: 'လုပ်ငန်းခွင်ပေးပို့မှုမအောင်မြင်၊ ဆိပ်ကမ်းပုံစံနှင့်ပေါ်ဒ်ဒေတာမှန်ကန်မှုစစ်ဆေးပြီးပြန်ပေးပို့ပါ',
    ben: 'কর্মশালায় পাঠানো ব্যর্থ, লেবেল টেমপ্লেট ও বোর্ড ডেটা সঠিক কিনা যাচাই করে পুনরায় পাঠান',
    tr: 'Atölyeye gönderilemedi; etiket şablonu ve levha verilerini kontrol edip yeniden gönderin',
    km: 'ផ្ញើទៅរោងចក្រមិនបានជោគជ័យ សូមពិនិត្យគំរូស្លាក និងទិន្នន័យផ្ទាំងរួចផ្ញើឡើងវិញ',
    es: 'No se pudo enviar al taller, verifique si la plantilla de etiqueta y los datos del panel son correctos antes de enviar nuevamente',
    ar: 'فشل الإرسال إلى ورشة العمل، يرجى التحقق مما إذا كان قالب الملصق وبيانات اللوحة صحيحة قبل الإرسال مرة أخرى',
  },
  'arrangedPage.someTips': {
    zh: '您正在限时试用云排版异形余料/异形嵌套功能，请注意规避生产问题！',
    en: 'You are currently using the trial version of cloud layout for irregular scrap/irregular nesting, please be careful to avoid production problems!',
    id: 'Anda sedang mencoba fungsi sisa bahan tidak beraturan/penyusunan tidak beraturan cloud layout untuk waktu terbatas, harap perhatikan untuk menghindari masalah produksi!',
    kz: 'Сіз бұлттық орналастырудың дұрыс емес қалдықтар/дұрыс емес кірістіру функциясын уақытша сынап жатырсыз, өндіріс мәселелерін болдырмауға назар аударыңыз!',
    th: 'คุณกำลังทดลองใช้ฟังก์ชันเศษวัสดุผิดปกติ/การซ้อนทับผิดปกติของ cloud layout ในระยะเวลาจำกัด โปรดระวังเพื่อหลีกเลี่ยงปัญหาการผลิต!',
    ug: 'سىز بۇلۇت تەرتىپلەشتىكى ئۆزگىچە قېپىل/ئۆزگىچە كىرگۈزۈش ئىقتىدارىنى ۋاقىتلىق سىناشقا ئېلىپ بارىسىز، ئىشلەپچىقىرىش مەسىلىلىرىدىن ساقلىنىڭ!',
    vi: 'Bạn đang dùng thử chức năng phế liệu không đều/lồng ghép không đều của cloud layout trong thời gian giới hạn, vui lòng chú ý tránh các vấn đề sản xuất!',
    zh_tc: '您正在限時試用雲排版異形餘料/異形嵌套功能，請注意規避生產問題！',
    ru: 'Вы экспериментируете с облачным набором гетероморфных остатков / гетероморфных вложенных функций в течение ограниченного времени, обратите внимание, чтобы избежать производственных проблем!',
    ko: '클라우드 레이아웃 이형 여분 / 이형 중첩 기능을 한시적으로 시험해 보고 있습니다. 생산 문제를 피하십시오.',
    bur: 'Cloud Layout အထူးပုံပိုလျှံ/အထူးပုံပေါင်းစပ်လုပ်ဆောင်ချက်ကိုကန့်သတ်ကာလသုံးနေသည်၊ ထုတ်လုပ်မှုပြဿနာများကိုရှောင်ကြဉ်ပါ!',
    ben: 'আপনি সীমিত সময়ের জন্য ক্লাউড লেআউটের অনিয়মিত স্ক্র্যাপ/নেস্টিং ফিচার ব্যবহার করছেন, উৎপাদন সমস্যা এড়াতে সতর্ক থাকুন!',
    tr: 'Bulut yerleşim düzensiz artık/iç içe yerleşim deniyorsunuz; üretim risklerinden kaçının!',
    km: 'អ្នកកំពុងសាកល្បងមុខងារការរៀបចំក្នុងពពកសម្រាប់សម្ភារៈសល់/ការរួមបញ្ចូលរាងមិនធម្មតា សូមប្រយ័ត្នពីបញ្ហាក្នុងផលិតកម្ម!',
    es: 'Está probando la función de anidamiento de formas especiales/remanentes de formas especiales de composición tipográfica en la nube por un tiempo limitado, ¡preste atención para evitar problemas de producción!',
    ar: 'أنت تحاول التنضيد السحابي لبقايا ذات شكل خاص/وظيفة تداخل ذات شكل خاص لفترة محدودة، يرجى الانتباه لتجنب مشاكل الإنتاج!',
  },
  'arrangedPage.nestingTips': {
    zh: '【高级异形嵌套排版】功能-限免体验已到期，如需继续使用，请联系销售人员购买！',
    en: 'The limited-time free trial for [Advanced Irregular Nesting Layout] has expired. To continue using it, please contact sales to purchase!',
    id: 'Uji coba gratis terbatas untuk [Tata Letak Penyusunan Bentuk Tidak Beraturan Lanjutan] telah berakhir. Untuk terus menggunakan, silakan hubungi tim sales untuk membeli!',
    kz: '【Жетілдірілген дұрыс емес кірістіру орналастыру】 функциясының уақытша тегін сынақ мерзімі аяқталды. Жалғастыру үшін сату бөліміне хабарласып сатып алыңыз!',
    th: 'การทดลองใช้ฟรีแบบจำกัดเวลาสำหรับ [การจัดวางการซ้อนทับรูปทรงพิเศษขั้นสูง] หมดอายุแล้ว หากต้องการใช้งานต่อ โปรดติดต่อฝ่ายขายเพื่อซื้อ!',
    ug: '【ئىلغار ئۆزگىچە كىرگۈزۈش تەرتىپلەش】 ئىقتىدارىنىڭ ۋاقىتلىق ھەقسىز سىناش مۇددىتى توشتى، داۋاملىق ئىشلىتىش ئۈچۈن سېتىش خادىملىرى بىلەن ئالاقىلىشىپ سېتىۋېلىڭ!',
    vi: 'Thời gian dùng thử miễn phí có hạn cho [Bố cục lồng ghép hình dạng đặc biệt nâng cao] đã hết hạn. Để tiếp tục sử dụng, vui lòng liên hệ bộ phận kinh doanh để mua!',
    zh_tc:
      '【高級異形嵌套排版】功能-限免體驗已到期，如需繼續使用，請聯繫銷售人員購買！',
    ru: 'Ограниченная по времени бесплатная пробная версия функции [Расширенная вложенная верстка нестандартных форм] истекла. Чтобы продолжить использование, обратитесь к отделу продаж для покупки!',
    ko: '[고급 이형 중첩 레이아웃] 기능의 한시 무료 체험이 만료되었습니다. 계속 사용하려면 영업 담당자에게 문의하여 구매해 주세요!',
    bur: '[Advanced Irregular Nesting Layout] အတွက် ကန့်သတ်ကာလ အခမဲ့စမ်းသပ်မှု သက်တမ်းကုန်သွားပါပြီ။ ဆက်လက်အသုံးပြုရန် အရောင်းဌာနကို ဆက်သွယ်ဝယ်ယူပါ!',
    ben: '[Advanced Irregular Nesting Layout]-এর সীমিত সময়ের বিনামূল্যে ট্রায়াল শেষ হয়েছে। চালিয়ে যেতে সেলস টিমের সঙ্গে যোগাযোগ করে কিনুন!',
    tr: '[Gelişmiş Düzensiz İç İçe Yerleşim] özelliği için sınırlı süreli ücretsiz deneme süresi doldu. Kullanmaya devam etmek için satış ekibiyle iletişime geçip satın alın!',
    km: 'ការសាកល្បងឥតគិតថ្លៃមានកំណត់សម្រាប់ [ការរៀបចំការរួមបញ្ចូលរាងមិនធម្មតាកម្រិតខ្ពស់] បានផុតកំណត់ហើយ។ ដើម្បីបន្តប្រើ សូមទាក់ទងផ្នែកលក់ដើម្បីទិញ!',
    es: 'La prueba gratuita por tiempo limitado de [Diseño de anidamiento de formas especiales avanzado] ha expirado. Para seguir usándola, contacte con ventas para comprarla.',
    ar: 'انتهت الفترة التجريبية المجانية المحدودة لوظيفة [تخطيط التداخل للأشكال الخاصة المتقدم]. للاستمرار في الاستخدام، يرجى الاتصال بفريق المبيعات للشراء!',
  },
  'arrangedPage.frameDoorTip': {
    zh: '检测到本次排版有合并的骨骼门，注意骨骼门二次加工前需要先封边再上雕刻机切割！',
    en: 'The current layout detects merged skeleton gates. Note that before secondary processing, the edges of the skeleton gates must be sealed before cutting with the engraving machine!',
    id: 'Terdeteksi bahwa layout ini memiliki pintu rangka yang digabungkan, harap perhatikan bahwa pintu rangka perlu disekat sebelum proses pengolahan kedua di mesin pemotong!',
    kz: 'Құрамдас рамка қақпалары анықталды, қақпаны қайта өңдеу алдында қақпаны қабықшамен қаптау керек!',
    th: 'ตรวจพบว่าการจัดวางนี้มีประตูรูปตัวที่ผสมกัน โปรดทราบว่าประตูรูปตัวต้องถูกปิดกั้นก่อนการประมวลผลครั้งที่สองบนเครื่องตัดกลึง!',
    ug: 'تاختا بۆلەكلىرىدىن تېشىك/ئويۇق توقۇنۇشى ياكى كىچىك تاختىدىن چىقىپ كەتكەنلىكى بايقىلدى!',
    vi: 'Phát hiện xung đột lỗ khe: Tấm bảng có xung đột lỗ khe hoặc mảnh nhỏ bay ra',
    zh_tc:
      '檢測到本次排版有合并的骨骼門，注意骨骼門二次加工前需要先封邊再上雕刻機切割！',
    ru: 'Обнаружено, что в этом расположении есть склеенные рамковые двери, обратите внимание, что рамковые двери необходимо закрыть перед вторичной обработкой на станке для резки!',
    ko: '이 레이아웃에는 병합된 프레임 문이 있음을 감지했습니다. 프레임 문은 재처리 전에 폐쇄되어야 합니다!',
    bur: 'ာတ်ပုံဖော်မတ်တွင် ပေါင်းစပ်ထားသော အရိုးတံကို တွေ့ရှိပါသည်။ အရိုးတံကို ဒုတိယအကြိမ် ပြုပြင်ခြင်းမပြုမီ ကုလားထိပ်ခတ်ခြင်းကို ဦးစွာပြုလုပ်ပြီးမှသာ ထွင်းထုစက်ဖြင့် ဖြတ်တောက်ရန် လိုအပ်ကြောင်း သတိပြုပါ။',
    ben: 'ফ্রেম ডোর কাটার ক্রম সঠিক নয়, ছুরি পয়েন্ট এবং কাটার ক্রম পুনরায় গণনা করতে ক্লিক করুন!',
    tr: 'Kafes kapısı işleme sırasında uyarı göster',
    km: 'បង្កើតបង្អួចព្រមានពេលបង្រួមទូរទូទាត់',
    es: 'Se detecta que el tablero tiene conflictos de orificios y ranuras/el tablero pequeño sale volando',
    ar: 'تم اكتشاف أن اللوحة بها تعارض في الفتحات والفتحات/تطير اللوحة الصغيرة للخارج',
  },
  'arrangedPage.cutOrderErr': {
    zh: '切割顺序不正确，请点击重新计算下刀点和切割顺序！',
    en: 'Incorrect cutting order, please click to recalculate the knife point and cutting order!',
    id: 'Pesanan pemotongan tidak benar, silakan klik untuk menghitung ulang titik pemotongan dan pesanan pemotongan!',
    kz: 'Кесу тәртібі дұрыс емес, қайдан кесетін нүктелер мен кесу тәртібін қайта есептеу үшін басыңыз!',
    th: 'คำสั่งตัดไม่ถูกต้องโปรดคลิกเพื่อคำนวณจุดตัดและคำสั่งตัด!',
    ug: 'كېسىش تەرتىپى خاتا، كېسىش نۇقتىسى ۋە كېسىش تەرتىپىنى قايتا ھېسابلاڭ!',
    vi: 'Thứ tự cắt không chính xác, vui lòng nhấn để tính toán lại điểm cắt và thứ tự cắt!',
    zh_tc: '切割順序不正確，請點擊重新計算下刀點和切割順序！',
    ru: 'Порядок резки неправильный, нажмите, чтобы пересчитать точку падения и порядок резки!',
    ko: '절단 순서가 정확하지 않습니다. 클릭하여 칼점과 절단 순서를 다시 계산하세요!',
    bur: 'ဖြတ်တောက်အစဉ်မမှန်ကန်ပါ၊ ဓားချဉ်ပြင်ဆင်နှင့်ဖြတ်တောက်အစဉ်ပြန်တွက်ချက်ရန်ကလစ်နှိပ်ပါ!',
    ben: 'কাটার ক্রম সঠিক নয়, ছুরি পয়েন্ট এবং কাটার ক্রম পুনরায় গণনা করতে ক্লিক করুন!',
    tr: 'Kesim sırası yanlış; kesim noktası ve sırasını yeniden hesaplamak için tıklayın!',
    km: 'លំដាប់ការកាត់មិនត្រឹមត្រូវ សូមចុចដើម្បីគណនាឡើងវិញចំណុចកាត់ និងលំដាប់!',
    es: 'La secuencia de corte es incorrecta, haga clic para volver a calcular el punto de corte y la secuencia de corte.',
    ar: 'تسلسل القطع غير صحيح، الرجاء النقر لإعادة حساب نقطة القطع وتسلسل القطع!',
  },
  'arrangedPage.holeSlotConflict': {
    zh: '检测到板件存在孔槽冲突/飞出小板',
    en: 'Board has hole-slot conflict or flying out small plate',
    id: 'Terdeteksi bahwa konflik lubang dan slot pelat terbang keluar dari pelat kecil',
    kz: 'Тешик жойлашуы кескин: Борбордук панельде тешик жойлашуы же учак майдалары ажырады',
    th: 'ตรวจพบว่าความขัดแย้งของหลุมและสล็อตของจานนั้นบินออกจากแผ่นเล็ก ๆ',
    ug: 'تاختا بۆلەكلىرىدىن تېشىك/ئويۇق توقۇنۇشى ياكى كىچىك تاختىدىن چىقىپ كەتكەنلىكى بايقىلدى!',
    vi: 'Phát hiện xung đột lỗ khe: Tấm bảng có xung đột lỗ khe hoặc mảnh nhỏ bay ra',
    zh_tc: '檢測到板件存在孔槽衝突/飛出小板',
    ru: 'Обнаружен конфликт между отверстиями / вылет листов',
    ko: '보드 부품에 구멍 슬롯 충돌 / 플라이아웃 감지',
    bur: 'ပေါ်ဒ်တွင်ပေါက်ကြိုးပဋိပက္ခ/ပေါ်ဒ်ငယ်ပျံထွက်ကြောင်းစစ်ဆေးတွေ့ရှိ',
    ben: 'বোর্ডে গর্ত-স্লট সংঘাত/ছোট বোর্ড উড়ে বের হওয়া পাওয়া গেছে',
    tr: 'Delik-oluk çakışması veya küçük levha fırlaması algılandı',
    km: 'រកឃើញប៉ះទង្គិចរណ្តៅ-រន្ធ ឬផ្ទាំងតូចរំដោះ',
    es: 'Se detecta que el tablero tiene conflictos de orificios y ranuras/el tablero pequeño sale volando',
    ar: 'تم اكتشاف أن اللوحة بها تعارض في الفتحات والفتحات/تطير اللوحة الصغيرة للخارج',
  },
  'arrangedPage.exportSetting': {
    zh: '导出设置',
    en: 'Export Settings',
    id: 'Pengaturan Ekspor',
    kz: 'Експорттау параметрлері',
    th: 'การตั้งค่าการส่งออก',
    ug: 'چىقىرىش تەڭشەكلىرى',
    vi: 'Cài đặt xuất',
    zh_tc: '導出設置',
    ru: 'Параметры экспорта',
    ko: '내보내기 설정',
    bur: 'ထုတ်ပြင်ဆင်ဆက်တင်',
    ben: 'রপ্তানি সেটিংস',
    tr: 'Dışa aktarma ayarları',
    km: 'ការកំណត់នាំចេញ',
    es: 'Configuración de exportación',
    ar: 'إعدادات التصدير',
  },
  'arrangedPage.currentTagTemp': {
    zh: '当前标签模板',
    en: 'Current Tag Template',
    id: 'Templat label saat ini',
    kz: 'Ағымдағы тег үлгісі',
    th: 'เทมเพลตป้ายกำกับปัจจุบัน',
    ug: 'نۆۋەتتىكى خەتكۈچ قېلىپى',
    vi: 'Mẫu nhãn hiện tại',
    zh_tc: '當前標籤範本',
    ru: 'Шаблоны тегов',
    ko: '현재 태그 템플릿',
    bur: 'လက်ရှိဆိပ်ကမ်းပုံစံ',
    ben: 'বর্তমান ট্যাগ টেমপ্লেট',
    tr: 'Geçerli etiket şablonu',
    km: 'គំរូស្លារបច្ចុប្បន្ន',
    es: 'Plantilla de etiqueta actual',
    ar: 'قالب الملصق الحالي',
  },
  'arrangedPage.specialPaibanErr': {
    zh: '有板件具有特殊工艺或贴边加工槽，暂不支持重新排版！',
    en: 'Some planks have special processes, re-layout is not supported for now!',
    id: 'Bagian berlapis memiliki proses khusus atau alur pemrosesan tepi, dan diketik ulang belum didukung!',
    kz: 'Плақтардан кейін көрсетілген белгілі мамандар бар, әрекетті қайта аспаптай алмас!',
    th: 'ชิ้นส่วนที่ชุบมีกระบวนการพิเศษหรือร่องประมวลผลขอบและยังไม่ได้รับการสนับสนุนอีกครั้ง!',
    ug: 'تاختا بۆلەكلىرى ئالاھىدە پىروگرامما ياكى چېگرا ئىشلەنگەن ئويۇقلارغا ئىگە، نۆۋەتتە قايتا تەرتىپلەشكە قوللىمايدۇ!',
    vi: 'Có tấm gỗ có công nghệ đặc biệt, không hỗ trợ bố cục lại!',
    zh_tc: '有板件具有特殊工藝或貼邊加工槽，暫不支持重新排版！',
    ru: 'Есть пластины со специальной технологией или наклейкой для обработки канавки, временно не поддерживается переформатирование!',
    ko: '특수 프로세스 또는 테두리 가공 슬롯이 있는 보드 부품은 재레이아웃이 일시적으로 지원되지 않습니다!',
    bur: 'ပေါ်ဒ်တွင်အထူးလုပ်ငန်းစဉ်သို့မဟုတ်ဘောင်ကပ်ချောင်းရှိ၍ ပြန်ပြင်ဆင်မှုကိုယာယီမထောက်ခံ!',
    ben: 'কিছু বোর্ডে বিশেষ প্রক্রিয়া আছে, এখন পুনরায় লেআউট সমর্থিত নয়!',
    tr: 'Özel işlem veya kenar oluklu levhalar var; yeniden yerleşim şimdilik desteklenmiyor!',
    km: 'មានផ្ទាំងដែលមានដំណើរការពិសេស ឬរន្ធគែម មិនទាន់គាំទ្រការរៀបចំឡើងវិញ!',
    es: 'Algunos tableros tienen procesos especiales o ranuras de procesamiento de ribetes, ¡y el re-diseño no es compatible por el momento!',
    ar: 'تحتوي بعض اللوحات على عمليات خاصة أو أخاديد معالجة ملحومة، ولا يتم دعم إعادة التخطيط في الوقت الحالي!',
  },
  'arrangedPage.moreResult': {
    zh: '更多结果',
    en: 'More Results',
    id: 'Lebih banyak hasil',
    kz: 'Көбірек нәтиже',
    th: 'ผลลัพธ์เพิ่มเติม',
    ug: 'تېخىمۇ كۆپ نەتىجە',
    vi: 'Nhiều kết quả hơn',
    zh_tc: '更多結果',
    ru: 'Больше результатов',
    ko: '더 많은 결과',
    bur: 'ပိုမိုသောရလဒ်များ',
    ben: 'আরও ফলাফল',
    tr: 'Daha fazla sonuç',
    km: 'លទ្ធផលបន្ថែម',
    es: 'Más resultados',
    ar: 'المزيد من النتائج',
  },
  'arrangedPage.moreResultTip': {
    zh: '大板中有贴边加工的槽,大板将不会参与重新排版',
    en: 'The large panel has a slot for edge processing, so it will not participate in re-layout',
    id: 'Ada alur untuk menggiling di pelat besar, dan pelat besar tidak akan berpartisipasi dalam tata letak jenis ulang.',
    kz: 'Улуу панельде қырғау үшін шаруашылық бар, сондықтан улуу панель қайта орналастыруда қатысмайды',
    th: 'มีร่องสำหรับการบดในจานขนาดใหญ่และแผ่นขนาดใหญ่จะไม่เข้าร่วมในรูปแบบประเภทใหม่',
    ug: 'چوڭ تاختىدا چېگرا ئىشلەنگەن ئويۇق بار بولسا، چوڭ تاختا قايتا تەرتىپلەشكە قاتناشمايدۇ',
    vi: 'Bảng lớn có khe được gia công ở cạnh, bảng lớn sẽ không tham gia vào việc sắp xếp lại',
    zh_tc: '大板中有貼邊加工的槽,大板將不會參與重新排版',
    ru: 'Большая доска с наклейкой в канавке, большая доска не будет участвовать в переформатировании',
    ko: '판자에 가장자리를 붙여 가공한 슬롯이 있어, 판자는 재조판에 참여하지 않을 것이다',
    bur: 'ပေါ်ဒ်ကြီးတွင်ဘောင်ကပ်ချောင်းရှိပါက ပေါ်ဒ်ကြီးသည်ပြန်ပြင်ဆင်မှုတွင်မပါဝင်',
    ben: 'বড় বোর্ডে প্রান্ত প্রক্রিয়াকরণের খাঁজ থাকলে, বড় বোর্ড পুনরায় লেআউটে অংশগ্রহণ করবে না',
    tr: 'Büyük levhada kenar işleme oluğu var; büyük levha yeniden yerleşime katılmaz',
    km: 'ផ្ទាំងធំមានរន្ធកែគែម ផ្ទាំងធំនឹងមិនចូលរួមការរៀបចំឡើងវិញ',
    es: 'En el tablero grande hay ranuras para el procesamiento de ribetes. El tablero grande no participará en el rediseño',
    ar: 'توجد أخاديد لمعالجة اللحامات في اللوحة الكبيرة. لن تشارك اللوحة الكبيرة في إعادة التخطيط',
  },
  'arrangedPage.batchBujian': {
    zh: '批量补件',
    en: 'Batch Patching',
    id: 'Pengisian Batch',
    kz: 'Жиынтықты толтыру',
    th: 'การเติมเต็มชุด',
    ug: 'بىر قانچە قوشۇمچە بۆلەك',
    vi: 'Bổ sung hàng loạt',
    zh_tc: '批量補件',
    ru: 'Пакетное дополнение',
    ko: '대량 패치',
    bur: 'အစုလိုက်ဖြည့်ဆည်း',
    ben: 'ব্যাচ পরিপূরক',
    tr: 'Toplu parça tamamlama',
    km: 'បំពេញគ្រឿងជាក្រុម',
    es: 'Parche por lotes',
    ar: 'التصحيح الدفعي',
  },
  'arrangedPage.batchOperation': {
    zh: '批量操作',
    en: 'Batch Operation',
    id: 'Operasi Batch',
    kz: 'Жиынтық операция',
    th: 'การดำเนินการแบบกลุ่ม',
    ug: 'بىر قانچە ئىشلەش',
    vi: 'Thao tác hàng loạt',
    zh_tc: '批量操作',
    ru: 'Массовые операции',
    ko: '대량 작업',
    bur: 'အစုလိုက်လုပ်ဆောင်မှု',
    ben: 'ব্যাচ অপারেশন',
    tr: 'Toplu işlem',
    km: 'ប្រតិបត្តិការជាក្រុម',
    es: 'Operación por lotes',
    ar: 'التشغيل المجمع',
  },
  'arrangedPage.batchEditPlankSize': {
    zh: '批量修改大板尺寸',
    en: 'Batch Edit Large Plank Size',
    id: 'Ubah Ukuran Papan Besar Secara Batch',
    kz: 'Үлкен тақта өлшемін топтық өзгерту',
    th: 'แก้ไขขนาดแผ่นใหญ่เป็นชุด',
    ug: 'چوڭ تاختا ئۆلچىمىنى توپ ھالدا ئۆزگەرتىش',
    vi: 'Thay đổi kích thước tấm lớn hàng loạt',
    zh_tc: '批量修改大板尺寸',
    ru: 'Изменить размер большой доски',
    ko: '대시보드 크기 대량 수정',
    bur: 'ပေါ်ဒ်ကြီးအရွယ်အစုလိုက်ပြင်ဆင်',
    ben: 'বড় বোর্ডের আকার ব্যাচে পরিবর্তন করুন',
    tr: 'Büyük levha boyutunu toplu düzenle',
    km: 'កែទំហំផ្ទាំងធំជាក្រុម',
    es: 'Modificación por lotes de tamaño de tablero grande',
    ar: 'التعديل الدفعي لحجم اللوحة الكبير',
  },
  'arrangedPage.editPlankSize': {
    zh: '修改尺寸',
    en: 'Edit Size',
    id: 'Edit Ukuran',
    kz: 'Өлшемді өзгерту',
    th: 'แก้ไขขนาด',
    ug: 'ئۆلچەم ئۆزگەرتىش',
    vi: 'Sửa kích thước',
    zh_tc: '修改尺寸',
    ru: 'Изменить размер',
    ko: '치수 수정',
    bur: 'အရွယ်ပြင်ဆင်',
    ben: 'আকার পরিবর্তন করুন',
    tr: 'Boyutu düzenle',
    km: 'កែទំហំ',
    es: 'Modificar tamaño',
    ar: 'تعديل الحجم',
  },
  'arrangedPage.editWay': {
    zh: '修改方式',
    en: 'Edit Method',
    id: 'Cara Edit',
    kz: 'Өзгерту әдісі',
    th: 'วิธีการแก้ไข',
    ug: 'ئۆزگەرتىش ئۇسۇلى',
    vi: 'Cách sửa',
    zh_tc: '修改方式',
    ru: 'Изменения',
    ko: '수정 방법',
    bur: 'ပြင်ဆင်နည်း',
    ben: 'পরিবর্তনের পদ্ধতি',
    tr: 'Düzenleme yöntemi',
    km: 'វិធីកែ',
    es: 'Método de modificación',
    ar: 'طريقة التعديل',
  },
  'arrangedPage.editByType': {
    zh: '按类型修改',
    en: 'Edit by Type',
    id: 'Edit Berdasarkan Tipe',
    kz: 'Түрі бойынша өзгерту',
    th: 'แก้ไขตามประเภท',
    ug: 'تىپى بويىچە ئۆزگەرتىش',
    vi: 'Sửa theo loại',
    zh_tc: '按類型修改',
    ru: 'Изменить по типу',
    ko: '유형별 수정',
    bur: 'အမျိုးအစားအလိုက်ပြင်ဆင်',
    ben: 'ধরন অনুযায়ী পরিবর্তন করুন',
    tr: 'Türe göre düzenle',
    km: 'កែតាមប្រភេទ',
    es: 'Modificar por tipo',
    ar: 'تعديل حسب النوع',
  },
  'arrangedPage.editByPlankNumber': {
    zh: '按大板号修改',
    en: 'Edit by Plank Number',
    id: 'Edit Berdasarkan Nomor Papan Besar',
    kz: 'Тақта нөмірі бойынша өзгерту',
    th: 'แก้ไขตามหมายเลขแผ่นใหญ่',
    ug: 'تاختا نومۇرى بويىچە ئۆزگەرتىش',
    vi: 'Sửa theo số tấm lớn',
    zh_tc: '按大板號修改',
    ru: 'Изменить по номеру доски',
    ko: '대판 번호로 수정',
    bur: 'ပေါ်ဒ်ကြီးနံပါတ်အလိုက်ပြင်ဆင်',
    ben: 'বোর্ড নম্বর অনুযায়ী পরিবর্তন করুন',
    tr: 'Büyük levha numarasına göre düzenle',
    km: 'កែតាមលេខផ្ទាំងធំ',
    es: 'Modificar por número de placa',
    ar: 'تعديل حسب رقم اللوحة',
  },
  'arrangedPage.editContent': {
    zh: '修改内容',
    en: 'Edit Content',
    id: 'Konten Edit',
    kz: 'Өзгерту мазмұны',
    th: 'เนื้อหาที่แก้ไข',
    ug: 'ئۆزگەرتىش مەزمۇنى',
    vi: 'Nội dung sửa',
    zh_tc: '修改內容',
    ru: 'Изменить содержание',
    ko: '컨텐트 수정',
    bur: 'ပြင်ဆင်အကြောင်းအရာ',
    ben: 'পরিবর্তনের বিষয়বস্তু',
    tr: 'İçeriği düzenle',
    km: 'កែមាតិកា',
    es: 'Modificar contenido',
    ar: 'تعديل المحتوى',
  },
  'arrangedPage.editContentTip': {
    zh: '请选择需要修改的大板类型',
    en: 'Please select the large plank type to edit',
    id: 'Silakan pilih jenis papan besar yang perlu diedit',
    kz: 'Өзгертілуі керек үлкен тақта түрін таңдаңыз',
    th: 'กรุณาเลือกประเภทแผ่นใหญ่ที่ต้องการแก้ไข',
    ug: 'ئۆزگەرتىشكە تېگىشلىك چوڭ تاختا تىپىنى تاللاڭ',
    vi: 'Vui lòng chọn loại tấm lớn cần sửa',
    zh_tc: '請選擇需要修改的大板類型',
    ru: 'Выберите тип панели, который необходимо изменить',
    ko: '수정할 보드 유형을 선택하십시오.',
    bur: 'ပြင်ဆင်ရမည့်ပေါ်ဒ်ကြီးအမျိုးအစားရွေးပါ',
    ben: 'পরিবর্তন করতে হবে এমন বড় বোর্ডের ধরন নির্বাচন করুন',
    tr: 'Düzenlenecek büyük levha türünü seçin',
    km: 'សូមជ្រើសរើសប្រភេទផ្ទាំងធំដែលត្រូវកែ',
    es: 'Seleccione el tipo de placa que necesita modificarse',
    ar: 'يرجى تحديد نوع اللوحة التي تحتاج إلى تعديل',
  },
  'arrangedPage.editContentTip1': {
    zh: '请选择需要修改的大板号',
    en: 'Please select the large plank number to edit',
    id: 'Silakan pilih nomor papan besar yang perlu diedit',
    kz: 'Өзгертілуі керек үлкен тақта нөмірін таңдаңыз',
    th: 'กรุณาเลือกหมายเลขแผ่นใหญ่ที่ต้องการแก้ไข',
    ug: 'ئۆزگەرتىشكە تېگىشلىك چوڭ تاختا نومۇرىنى تاللاڭ',
    vi: 'Vui lòng chọn số tấm lớn cần sửa',
    zh_tc: '請選擇需要修改的大板號',
    ru: 'Выберите номер доски, который необходимо изменить.',
    ko: '수정할 보드 번호를 선택하십시오.',
    bur: 'ပြင်ဆင်ရမည့်ပေါ်ဒ်ကြီးနံပါတ်ရွေးပါ',
    ben: 'পরিবর্তন করতে হবে এমন বড় বোর্ডের নম্বর নির্বাচন করুন',
    tr: 'Düzenlenecek büyük levha numarasını seçin',
    km: 'សូមជ្រើសរើសលេខផ្ទាំងធំដែលត្រូវកែ',
    es: 'Seleccione el número de placa que necesita modificarse',
    ar: 'يرجى تحديد رقم اللوحة التي تحتاج إلى تعديل',
  },
  'arrangedPage.editStart': {
    zh: '起始',
    en: 'Start',
    id: 'Mulai',
    kz: 'Басталуы',
    th: 'เริ่มต้น',
    ug: 'باشلىنىش',
    vi: 'Bắt đầu',
    zh_tc: '起始',
    ru: 'начало',
    ko: '시작',
    bur: 'စတင်',
    ben: 'শুরু',
    tr: 'Başlangıç',
    km: 'ចាប់ផ្តើម',
    es: 'Inicio',
    ar: 'البداية',
  },
  'arrangedPage.editEnd': {
    zh: '结尾',
    en: 'End',
    id: 'Akhir',
    kz: 'Аяқталуы',
    th: 'สิ้นสุด',
    ug: 'ئاخىرلاش',
    vi: 'Kết thúc',
    zh_tc: '結尾',
    ru: 'Конец',
    ko: '결말',
    bur: 'ဆုံးနေရာ',
    ben: 'শেষ',
    tr: 'Bitiş',
    km: 'បញ្ចប់',
    es: 'Final',
    ar: 'النهاية',
  },
  'arrangedPage.bigPlank': {
    zh: '大板',
    en: 'Large plank',
    id: 'Papan Besar',
    kz: 'Үлкен тақта',
    th: 'แผ่นใหญ่',
    ug: 'چوڭ تاختا',
    vi: 'Tấm lớn',
    zh_tc: '大板',
    ru: 'Большая доска',
    ko: '판자',
    bur: 'ပေါ်ဒ်ကြီး',
    ben: 'বড় বোর্ড',
    tr: 'Büyük levha',
    km: 'ផ្ទាំងធំ',
    es: 'Placa grande',
    ar: 'لوحة كبيرة',
  },
  'arrangedPage.editSize': {
    zh: '尺寸修改为',
    en: 'Size Changed To',
    id: 'Ukuran Diubah Menjadi',
    kz: 'Өлшем өзгертілді',
    th: 'ขนาดแก้ไขเป็น',
    ug: 'ئۆلچەم ئۆزگەرتىلدى',
    vi: 'Kích thước sửa thành',
    zh_tc: '尺寸修改為',
    ru: 'Изменить размер',
    ko: '치수 수정',
    bur: 'အရွယ်ပြင်ဆင်ရန်',
    ben: 'আকার পরিবর্তন করুন',
    tr: 'Boyut şu şekilde değiştirildi',
    km: 'ទំហំត្រូវបានកែទៅ',
    es: 'Modifique el tamaño a',
    ar: 'تعديل الحجم إلى',
  },
  'arrangedPage.bigPlankWidth': {
    zh: '大板宽度',
    en: 'Large Plank Width',
    id: 'Lebar Papan Besar',
    kz: 'Үлкен тақта ені',
    th: 'ความกว้างแผ่นใหญ่',
    ug: 'چوڭ تاختا كەڭلىكى',
    vi: 'Chiều rộng tấm lớn',
    zh_tc: '大板寬度',
    ru: 'Ширина панели',
    ko: '널빤지 너비',
    bur: 'ပေါ်ဒ်ကြီးအကျယ်',
    ben: 'বড় বোর্ডের প্রস্থ',
    tr: 'Büyük levha genişliği',
    km: 'ទទឹងផ្ទាំងធំ',
    es: 'Ancho de placa grande',
    ar: 'عرض اللوحة الكبيرة',
  },
  'arrangedPage.bigPlankHeight': {
    zh: '大板长度',
    en: 'Large Plank Length',
    id: 'Panjang Papan Besar',
    kz: 'Үлкен тақта ұзындығы',
    th: 'ความยาวแผ่นใหญ่',
    ug: 'چوڭ تاختا ئۇزۇنلۇقى',
    vi: 'Chiều dài tấm lớn',
    zh_tc: '大板長度',
    ru: 'Длина большой доски',
    ko: '판자 길이',
    bur: 'ပေါ်ဒ်ကြီးအရှည်',
    ben: 'বড় বোর্ডের দৈর্ঘ্য',
    tr: 'Büyük levha uzunluğu',
    km: 'បណ្តោយផ្ទាំងធំ',
    es: 'Longitud de placa grande',
    ar: 'طول اللوحة الكبيرة',
  },
  'arrangedPage.bigPlankLengthMarking': {
    zh: '大板长度标识',
    en: 'Large Plank Length Marking',
    id: 'Penanda Panjang Papan Besar',
    kz: 'Үлкен тақта ұзындығының белгісі',
    th: 'เครื่องหมายความยาวแผ่นใหญ่',
    ug: 'چوڭ تاختا ئۇزۇنلۇقى بەلگىسى',
    vi: 'Đánh dấu chiều dài tấm lớn',
    zh_tc: '大板長度標識',
    ru: 'Маркировка длины большой доски',
    ko: '대판 길이 표식',
    bur: 'ပေါ်ဒ်ကြီးအရှည်သတ်မှတ်ချက်',
    ben: 'বড় বোর্ডের দৈর্ঘ্য চিহ্নিতকরণ',
    tr: 'Büyük levha uzunluk işareti',
    km: 'សញ្ញាបណ្តោយផ្ទាំងធំ',
    es: 'Identificación de longitud de placa grande',
    ar: 'تحديد طول اللوحة الكبيرة',
  },
  'arrangedPage.markedAs': {
    zh: '标识为',
    en: 'Marked As',
    id: 'Ditandai Sebagai',
    kz: 'Белгіленген',
    th: 'ทำเครื่องหมายเป็น',
    ug: 'بەلگە سۈپىتىدە',
    vi: 'Được đánh dấu là',
    zh_tc: '標識為',
    ru: 'Идентифицировать как',
    ko: '으로 식별',
    bur: 'အဖြစ်သတ်မှတ်',
    ben: 'হিসেবে চিহ্নিত',
    tr: 'Şu şekilde işaretlendi',
    km: 'សម្គាល់ជា',
    es: 'Identificado como',
    ar: 'تم تحديدها كما',
  },
  'arrangedPage.maxAddTen': {
    zh: '最多添加10个',
    en: 'Maximum 10 items can be added',
    id: 'Maksimal menambahkan 10 item',
    kz: 'Ең көбі 10 элемент қосуға болады',
    th: 'เพิ่มได้สูงสุด 10 รายการ',
    ug: 'ئەڭ كۆپ 10 تۈر قوشقىلى بولىدۇ',
    vi: 'Tối đa thêm 10 mục',
    zh_tc: '最多添加10個',
    ru: 'Добавить максимум 10',
    ko: '최대 10개 추가',
    bur: 'အများဆုံး ၁၀ ခုထည့်နိုင်',
    ben: 'সর্বোচ্চ ১০টি যোগ করা যাবে',
    tr: 'En fazla 10 eklenebilir',
    km: 'អាចបន្ថែมបានអតិបរមា ១០',
    es: 'Agregar hasta 10',
    ar: 'أضف ما يصل إلى 10',
  },
  'arrangedPage.minValue': {
    zh: '最小值',
    en: 'Minimum value',
    id: 'Nilai Minimum',
    kz: 'Ең төменгі мән',
    th: 'ค่าต่ำสุด',
    ug: 'ئەڭ كىچىك قىممەت',
    vi: 'Giá trị tối thiểu',
    zh_tc: '最小值',
    ru: 'минимальное значение',
    ko: '최소값',
    bur: 'အနည်းဆုံးတန်ဖိုး',
    ben: 'সর্বনিম্ন মান',
    tr: 'Minimum değer',
    km: 'តម្លៃអប្បបរមា',
    es: 'Valor mínimo',
    ar: 'الحد الأدنى للقيمة',
  },
  'arrangedPage.differentKnifeErr': {
    zh: '有不同下料刀的大板被选中，无法修改尺寸',
    en: 'Large planks with different cutting knives are selected, size cannot be modified',
    id: 'Papan besar dengan pisau pemotong berbeda dipilih, ukuran tidak dapat diubah',
    kz: 'Әртүрлі кесу пышағы бар үлкен тақталар таңдалған, өлшемді өзгерту мүмкін емес',
    th: 'มีแผ่นใหญ่ที่มีมีดตัดต่างกันถูกเลือก ไม่สามารถแก้ไขขนาดได้',
    ug: 'ئوخشىمىغان كېسىش پىچاقى بار چوڭ تاختا تاللاندى، ئۆلچەم ئۆزگەرتىشكە بولمايدۇ',
    vi: 'Có tấm lớn với dao cắt khác nhau được chọn, không thể sửa kích thước',
    zh_tc: '有不同下料刀的大板被選中，無法修改尺寸',
    ru: 'Большая доска с разными ножами для раскраски выбрана, размер не может быть изменен',
    ko: '다른 언더레이가 있는 보드가 선택되어 치수를 수정할 수 없습니다.',
    bur: 'ကွဲပြားသောဖြတ်ဓားရှိသောပေါ်ဒ်ကြီးများကိုရွေးထားသဖြင့်အရွယ်ပြင်ဆင်မနိုင်',
    ben: 'ভিন্ন কাটার ছুরি সহ বড় বোর্ড নির্বাচিত হয়েছে, আকার পরিবর্তন করা যাবে না',
    tr: 'Farklı kesim bıçaklarına sahip büyük levhalar seçili; boyut değiştirilemez',
    km: 'បានជ្រើសរើសផ្ទាំងធំដែលមានកាំបិតកាត់ខុសគ្នា មិនអាចកែទំហំបានទេ',
    es: 'Se seleccionan placas grandes con diferentes cuchillas de corte y el tamaño no se puede modificar',
    ar: 'يتم تحديد لوحات كبيرة بسكاكين قطع مختلفة ولا يمكن تعديل الحجم',
  },
  'arrangedPage.noEditablePlank': {
    zh: '没有符合条件的大板可修改',
    en: 'No eligible large planks to modify',
    id: 'Tidak ada papan besar yang memenuhi syarat untuk diubah',
    kz: 'Өзгертуге жарамды үлкен тақта жоқ',
    th: 'ไม่มีแผ่นใหญ่ที่ตรงตามเงื่อนไขให้แก้ไข',
    ug: 'ئۆزگەرتكىلى بولىدىغان شەرتكە لايىق چوڭ تاختا يوق',
    vi: 'Không có tấm lớn đủ điều kiện để sửa đổi',
    zh_tc: '沒有符合條件的大板可修改',
    ru: 'Нет подходящих больших досок для изменения',
    ko: '수정할 수 있는 조건에 맞는 대형 보드가 없습니다',
    bur: 'ပြင်ဆင်နိုင်သော သတ်မှတ်ချက်နှင့်ကိုက်ညီသည့် ပေါ်ဒ်ကြီး မရှိပါ',
    ben: 'পরিবর্তন করার মতো যোগ্য বড় বোর্ড নেই',
    tr: 'Değiştirilebilecek uygun büyük levha yok',
    km: 'គ្មានផ្ទាំងធំដែលត្រូវនឹងលក្ខខណ្ឌសម្រាប់កែប្រែទេ',
    es: 'No hay placas grandes elegibles para modificar',
    ar: 'لا توجد ألواح كبيرة مؤهلة للتعديل',
  },
  'arrangedPage.skipBrandPlankTip': {
    zh: '选中范围内有{count}张品牌大板不支持修改尺寸，已跳过',
    en: 'There are {count} brand large planks in the selected range that do not support size modification and have been skipped',
    id: 'Ada {count} papan besar bermerek dalam rentang yang dipilih yang tidak mendukung perubahan ukuran dan telah dilewati',
    kz: 'Таңдалған ауқымда өлшемді өзгертуді қолдамайтын {count} брендтік үлкен тақта бар, олар өткізіп жіберілді',
    th: 'ในช่วงที่เลือกมีแผ่นใหญ่แบรนด์ {count} แผ่นที่ไม่รองรับการแก้ไขขนาดและถูกข้ามไปแล้ว',
    ug: 'تاللانغان دائىرىدە ئۆلچەم ئۆزگەرتىشنى قوللىمايدىغان {count} تال ماركىلىق چوڭ تاختا بار، ئاتلاپ كېتىلدى',
    vi: 'Trong phạm vi đã chọn có {count} tấm lớn thương hiệu không hỗ trợ sửa kích thước và đã bị bỏ qua',
    zh_tc: '選中範圍內有{count}張品牌大板不支持修改尺寸，已跳過',
    ru: 'В выбранном диапазоне есть {count} брендовых больших досок, которые не поддерживают изменение размера и были пропущены',
    ko: '선택한 범위에 크기 수정을 지원하지 않는 브랜드 대형 보드가 {count}개 있어 건너뛰었습니다',
    bur: 'ရွေးချယ်ထားသောအတိုင်းအတာအတွင်း အရွယ်အစားပြင်ဆင်ခြင်းကို မပံ့ပိုးသော အမှတ်တံဆိပ်ပေါ်ဒ်ကြီး {count} ခုရှိပြီး ကျော်သွားပါပြီ',
    ben: 'নির্বাচিত পরিসরে {count}টি ব্র্যান্ড বড় বোর্ড আছে যা আকার পরিবর্তন সমর্থন করে না এবং বাদ দেওয়া হয়েছে',
    tr: 'Seçili aralıkta boyut değişikliğini desteklemeyen {count} marka büyük levha var ve atlandı',
    km: 'ក្នុងជួរដែលបានជ្រើសរើសមានផ្ទាំងធំម៉ាក {count} ផ្ទាំងដែលមិនគាំទ្រការកែទំហំ ហើយត្រូវបានរំលង',
    es: 'Hay {count} placas grandes de marca en el rango seleccionado que no admiten la modificación de tamaño y se han omitido',
    ar: 'يوجد {count} لوح كبير من العلامة التجارية في النطاق المحدد لا يدعم تعديل الحجم وتم تخطيه',
  },
  'arrangedPage.nonBrandToBrandTip': {
    zh: '该小板不能拖动至品牌色卡大板!',
    en: 'This part cannot be dragged onto a branded swatch plank!',
    id: 'Papan kecil ini tidak dapat diseret ke papan besar kartu warna bermerek!',
    kz: 'Бұл шағын тақтаны брендтік түс картасы бар үлкен тақтаға сүйреуге болмайды!',
    th: 'แผ่นเล็กนี้ไม่สามารถลากไปยังแผ่นใหญ่การ์ดสีแบรนด์ได้!',
    ug: 'بۇ كىچىك تاختىنى ماركىلىق رەڭ كارتىسى چوڭ تاختىغا سۆرەشكە بولمايدۇ!',
    vi: 'Tấm nhỏ này không thể kéo lên tấm lớn thẻ màu thương hiệu!',
    zh_tc: '該小板不能拖動至品牌色卡大板!',
    ru: 'Эту маленькую панель нельзя перетащить на большую панель с фирменной цветовой картой!',
    ko: '이 작은 보드는 브랜드 색상 카드 대형 보드로 드래그할 수 없습니다!',
    bur: 'ဤပေါ်ဒ်ငယ်ကို အမှတ်တံဆိပ်အရောင်ကတ်ပေါ်ဒ်ကြီးသို့ ဆွဲယူ၍မရပါ!',
    ben: 'এই ছোট বোর্ডটি ব্র্যান্ড কালার কার্ড বড় বোর্ডে টেনে আনা যাবে না!',
    tr: 'Bu küçük levha markalı renk kartı büyük levhaya sürüklenemez!',
    km: 'ផ្ទាំងតូចនេះមិនអាចអូសទៅផ្ទាំងធំកាតពណ៌ម៉ាកបានទេ!',
    es: '¡Esta placa pequeña no se puede arrastrar a la placa grande de tarjeta de color de marca!',
    ar: 'لا يمكن سحب هذا اللوح الصغير إلى اللوح الكبير لبطاقة ألوان العلامة التجارية!',
  },
  'arrangedPage.brandToNonBrandTip': {
    zh: '该小板不能拖动至非品牌色卡大板!',
    en: 'This part cannot be dragged onto a non-branded swatch plank!',
    id: 'Papan kecil ini tidak dapat diseret ke papan besar kartu warna non-merek!',
    kz: 'Бұл шағын тақтаны брендтік емес түс картасы бар үлкен тақтаға сүйреуге болмайды!',
    th: 'แผ่นเล็กนี้ไม่สามารถลากไปยังแผ่นใหญ่การ์ดสีที่ไม่ใช่แบรนด์ได้!',
    ug: 'بۇ كىچىك تاختىنى ماركىسىز رەڭ كارتىسى چوڭ تاختىغا سۆرەشكە بولمايدۇ!',
    vi: 'Tấm nhỏ này không thể kéo lên tấm lớn thẻ màu không phải thương hiệu!',
    zh_tc: '該小板不能拖動至非品牌色卡大板!',
    ru: 'Эту маленькую панель нельзя перетащить на большую панель без фирменной цветовой карты!',
    ko: '이 작은 보드는 비브랜드 색상 카드 대형 보드로 드래그할 수 없습니다!',
    bur: 'ဤပေါ်ဒ်ငယ်ကို အမှတ်တံဆိပ်မဟုတ်သော အရောင်ကတ်ပေါ်ဒ်ကြီးသို့ ဆွဲယူ၍မရပါ!',
    ben: 'এই ছোট বোর্ডটি নন-ব্র্যান্ড কালার কার্ড বড় বোর্ডে টেনে আনা যাবে না!',
    tr: 'Bu küçük levha markasız renk kartı büyük levhaya sürüklenemez!',
    km: 'ផ្ទាំងតូចនេះមិនអាចអូសទៅផ្ទាំងធំកាតពណ៌មិនមែនម៉ាកបានទេ!',
    es: '¡Esta placa pequeña no se puede arrastrar a la placa grande de tarjeta de color sin marca!',
    ar: 'لا يمكن سحب هذا اللوح الصغير إلى اللوح الكبير لبطاقة ألوان غير العلامة التجارية!',
  },
  'arrangedPage.brandToOtherBrandTip': {
    zh: '该小板不能拖动至其他品牌色卡大板!',
    en: 'This part cannot be dragged onto a different branded swatch plank!',
    id: 'Papan kecil ini tidak dapat diseret ke papan besar kartu warna merek lain!',
    kz: 'Бұл шағын тақтаны басқа брендтік түс картасы бар үлкен тақтаға сүйреуге болмайды!',
    th: 'แผ่นเล็กนี้ไม่สามารถลากไปยังแผ่นใหญ่การ์ดสีแบรนด์อื่นได้!',
    ug: 'بۇ كىچىك تاختىنى باشقا ماركىلىق رەڭ كارتىسى چوڭ تاختىغا سۆرەشكە بولمايدۇ!',
    vi: 'Tấm nhỏ này không thể kéo lên tấm lớn thẻ màu thương hiệu khác!',
    zh_tc: '該小板不能拖動至其他品牌色卡大板!',
    ru: 'Эту маленькую панель нельзя перетащить на большую панель другой фирменной цветовой карты!',
    ko: '이 작은 보드는 다른 브랜드 색상 카드 대형 보드로 드래그할 수 없습니다!',
    bur: 'ဤပေါ်ဒ်ငယ်ကို အခြားအမှတ်တံဆိပ်အရောင်ကတ်ပေါ်ဒ်ကြီးသို့ ဆွဲယူ၍မရပါ!',
    ben: 'এই ছোট বোর্ডটি অন্য ব্র্যান্ড কালার কার্ড বড় বোর্ডে টেনে আনা যাবে না!',
    tr: 'Bu küçük levha başka markalı renk kartı büyük levhaya sürüklenemez!',
    km: 'ផ្ទាំងតូចនេះមិនអាចអូសទៅផ្ទាំងធំកាតពណ៌ម៉ាកផ្សេងបានទេ!',
    es: '¡Esta placa pequeña no se puede arrastrar a la placa grande de tarjeta de color de otra marca!',
    ar: 'لا يمكن سحب هذا اللوح الصغير إلى اللوح الكبير لبطاقة ألوان علامة تجارية أخرى!',
  },
  'arrangedPage.editNo': {
    zh: '号',
    en: 'No.',
    id: 'No.',
    kz: '№',
    th: 'หมายเลข',
    ug: 'نومۇر',
    vi: 'Số',
    zh_tc: '號',
    ru: 'номер',
    ko: '호',
    bur: 'နံပါတ်',
    ben: 'নম্বর',
    tr: 'No.',
    km: 'លេខ',
    es: 'No.',
    ar: 'No.',
  },
  'arrangedPage.editAllPlank': {
    zh: '所有大板',
    en: 'All Large Planks',
    id: 'Semua Papan Besar',
    kz: 'Барлық үлкен тақталар',
    th: 'แผ่นใหญ่ทั้งหมด',
    ug: 'بارلىق چوڭ تاختا',
    vi: 'Tất cả tấm lớn',
    zh_tc: '所有大板',
    ru: 'Все большие доски',
    ko: '모든 보드',
    bur: 'ပေါ်ဒ်ကြီးအားလုံး',
    ben: 'সব বড় বোর্ড',
    tr: 'Tüm büyük levhalar',
    km: 'ផ្ទាំងធំទាំងអស់',
    es: 'Todas las placas grandes',
    ar: 'جميع اللوحات الكبيرة',
  },
  'arrangedPage.editBigPartSize': {
    zh: '大板尺寸修改',
    en: 'Large board size modification',
    id: 'Modifikasi Ukuran Papan Besar',
    kz: 'Үлкен тақта өлшемін өзгерту',
    th: 'แก้ไขขนาดแผ่นใหญ่',
    ug: 'چوڭ تاختا ئۆلچەم ئۆزگەرتىش',
    vi: 'Sửa kích thước tấm lớn',
    zh_tc: '大板尺寸修改',
    ru: 'Изменить размер доски',
    ko: '대시보드 크기 수정',
    bur: 'ပေါ်ဒ်ကြီးအရွယ်ပြင်ဆင်မှု',
    ben: 'বড় বোর্ডের আকার পরিবর্তন',
    tr: 'Büyük levha boyut düzenlemesi',
    km: 'កែទំហំផ្ទាំងធំ',
    es: 'Modificación del tamaño de la placa grande',
    ar: 'تعديل حجم اللوحة الكبيرة',
  },
  'arrangedPage.disPlaySetting': {
    zh: '显示设置',
    en: 'Display setting',
    id: 'Tampilkan Pengaturan',
    kz: 'Көрсету түрін тандау',
    th: 'แสดงการตั้งค่า',
    ug: 'كۆرسىتىش تەڭشەكلىرى',
    vi: 'Hiển thị thiết lập',
    zh_tc: '顯示設置',
    ru: 'Настройки отображения',
    ko: '디스플레이 설정',
    bur: 'ပြသဆက်တင်',
    ben: 'প্রদর্শন সেটিংস',
    tr: 'Görüntü ayarı',
    km: 'ការកំណត់បង្ហាញ',
    es: 'Configuración de visualización',
    ar: 'إعدادات العرض',
  },
  'arrangedPage.stored': {
    zh: '已入库',
    en: 'Be in storage',
    id: 'Telah dimasukkan ke dalam gudang',
    kz: 'Жиі қойылды',
    th: 'ได้ถูกนำไปใส่ในคลังสินค้า',
    ug: 'ئامبارغا ساقلانغان',
    vi: 'Đã nhập kho',
    zh_tc: '已入庫',
    ru: 'На складе',
    ko: '입고 완료',
    bur: 'ဂိုဒေါင်သွင်းပြီး',
    ben: 'গুদামে রাখা হয়েছে',
    tr: 'Depoda',
    km: 'រក្សាទុកឃ្លាំងហើយ',
    es: 'Ya almacenado',
    ar: 'مخزنة بالفعل',
  },
  'arrangedPage.onlySurplus': {
    zh: '只看余料',
    en: 'View Only Surplus',
    id: 'Lihat saja bahan yang tersisa',
    kz: 'Тек қалдық',
    th: 'เพียงแค่ดูวัสดุที่เหลืออยู่',
    ug: 'پەقەت قالدۇق ماتېرىياللارنى كۆرسەت',
    vi: 'Chỉ xem dư liệu',
    zh_tc: '只看餘料',
    ru: 'Смотреть только остатки',
    ko: '남은 재료만 보다.',
    bur: 'ပိုလျှံပစ္စည်းသာကြည့်',
    ben: 'শুধুমাত্র উদ্বৃত্ত দেখুন',
    tr: 'Yalnızca artık malzemeyi göster',
    km: 'មើលតែសម្ភារៈសល់',
    es: 'Ver solo el material restante',
    ar: 'عرض المادة المتبقية فقط',
  },
  'arrangedPage.UnuseSurplus': {
    zh: '余料不参与利用率计算',
    en: 'Utilization rate does not include excess material',
    id: 'Bahan yang tersisa tidak berpartisipasi dalam perhitungan tingkat pemanfaatan',
    kz: 'Пайдалану коэффициенті қалған материалды есептемейді',
    th: 'วัสดุที่เหลืออยู่ไม่ได้มีส่วนร่วมในการคำนวณอัตราการใช้ประโยชน์',
    ug: 'قالدۇق ماتېرىياللار پايدىلىنىش نىسبىتىگە كىرمەيدۇ',
    vi: 'Tỷ lệ sử dụng không tính vật liệu dư',
    zh_tc: '餘料不參與利用率計算',
    ru: 'Излишки не учитываются при расчете коэффициента использования',
    ko: '남은 재료는 이용률 계산에 참여하지 않는다',
    bur: 'ပိုလျှံပစ္စည်းအသုံးချနှုန်းတွက်ချက်မှုတွင်မပါဝင်',
    ben: 'উদ্বৃত্ত উপকরণ ব্যবহারের হার গণনায় অন্তর্ভুক্ত নয়',
    tr: 'Artık malzeme kullanım oranına dahil edilmez',
    km: 'សម្ភារៈសល់មិនចូលរួមក្នុងការគណនាអត្រាប្រើប្រាស់',
    es: 'El material restante no participa en el cálculo de utilización',
    ar: 'لا تشارك المادة المتبقية في حساب الاستخدام',
  },
  'arrangedPage.usePlankAdsorption': {
    zh: '板件吸附功能',
    en: 'Plank adsorption function',
    id: 'Fungsi adsorpsi plat',
    kz: 'Тақтайдың адсорбциялық функциясы',
    th: 'ฟังก์ชั่นการดูดซับแผ่น',
    ug: 'تاختا بۆلەك يېپىشىش ئىقتىدارى',
    vi: 'Chức năng hấp thụ ván',
    zh_tc: '板件吸附功能',
    ru: 'адсорбционная функция пластины',
    ko: '판재 흡착 기능',
    bur: 'ပေါ်ဒ်ဆွဲဆောင်မှုလုပ်ဆောင်ချက်',
    ben: 'বোর্ড শোষণ ফিচার',
    tr: 'Levha yapışma özelliği',
    km: 'មុខងារស្រូបផ្ទាំង',
    es: 'Adsorción del panel función',
    ar: 'وظيفة امتصاص اللوحة',
  },
  'arrangedPage.dataDefaultCollapsed': {
    zh: '数据默认收起',
    en: 'Data is collapsed by default',
    id: 'Data ditutup secara default',
    kz: 'Дереккізді түсіндірілген деректер жабылған',
    th: 'ข้อมูลถูกปิดโดยค่าเริ่มต้น',
    ug: 'سانلىق مەلۇمات سۈكۈتتىن قاتلايدۇ',
    vi: 'Dữ liệu mặc',
    zh_tc: '數據默認收起',
    ru: 'Сброс данных по умолчанию',
    ko: '데이터 기본 축소',
    bur: 'ဒေတာမူရင်းကျုံ့ထား',
    ben: 'ডিফল্টে ডেটা ভাঁজ করা',
    tr: 'Veriler varsayılan olarak daraltılmış',
    km: 'ទិន្នន័យបិទលំនាំដើម',
    es: 'Los datos están contraídos de forma predeterminada',
    ar: 'يتم طي البيانات افتراضيًا',
  },
  'arrangedPage.unit': {
    zh: '块',
    en: 'Pieces',
    id: 'bagian',
    kz: 'Единица',
    th: 'ชิ้นส่วน',
    ug: 'دانە',
    vi: 'Khối',
    zh_tc: '塊',
    ru: 'блок',
    ko: '덩어리',
    bur: 'ချပ်',
    ben: 'টুকরো',
    tr: 'adet',
    km: 'ដុំ',
    es: 'Bloquear',
    ar: 'الحظر',
  },
  'arrangedPage.cutSurplus': {
    zh: '切余料',
    en: 'Cut Surplus',
    id: 'Potong bahan yang tersisa',
    kz: 'Қалдықты кесу',
    th: 'ตัดวัสดุที่เหลือออก',
    ug: 'قالدۇق ماتېرىياللارنى كېسىش',
    vi: 'Cắt dư liệu',
    zh_tc: '切餘料',
    ru: 'Остаток',
    ko: '남은 재료를 썰다',
    bur: 'ပိုလျှံပစ္စည်းဖြတ်',
    ben: 'উদ্বৃত্ত কাটুন',
    tr: 'Artık malzemeyi kes',
    km: 'កាត់សម្ភារៈសល់',
    es: 'Resto',
    ar: 'الباقي',
  },
  'arrangedPage.frontWarningTip': {
    zh: '双面加工的高光板：先加工<span class="font-style">哑光面</span> , 再加工<span class="font-style">高光面</span><span>; &nbsp; 单面加工的高光板：直接加工 </span <span class="font-style">高光面</span>',
    en: 'For double-sided processing gloss board: process <span class="font-style">matte surface</span> first, then process <span class="font-style">glossy surface</span>; &nbsp; For single-sided processing gloss board: process directly <span class="font-style">glossy surface</span>',
    id: 'Pelat Double-Side High-Gloss: Proses Pertama Permukaan Matte, lalu proses pelat gloss tinggi; Pelat gloss tinggi satu sisi: Langsung memproses permukaan gloss tinggi',
    kz: 'Екі жаға өңдеу: Әріптің мәтінін аяқтап, сәтті өңдеу<span class="font-style">матты</span>, кейін<span class="font-style"> мәтін</span>ты өңдеу<span>; &nbsp; Бір жаға өңдеу: дәл<span class="font-style"> мәтінді</span> өңдеу',
    th: 'แผ่นเงาสูงสองด้าน: ประมวลผลพื้นผิวด้านแรกจากนั้นประมวลผลเพลตมันวาวสูง แผ่นเงาวาวสูงด้านเดียว: ประมวลผลพื้นผิวมันวาวสูงโดยตรง',
    ug: 'ئىككى تەرەپلىك ئىشلەنگەن يورۇق تاختا: ئاۋۋال <span class="font-style">قورۇق تەرەپ</span>نى ئىشلەڭ، ئاندىن <span class="font-style">يورۇق تەرەپ</span>نى ئىشلەڭ<span>; &nbsp; بىر تەرەپلىك ئىشلەنگەن يورۇق تاختا: بىۋاسىتە </span <span class="font-style">يورۇق تەرەپ</span>نى ئىشلەڭ',
    vi: 'Đối với tấm gỗ có bề mặt sáng hai mặt: xử lý trước <span class="font-style">mặt mờ</span>, sau đó xử lý <span class="font-style">mặt sáng</span><span>; &nbsp; Đối với tấm gỗ có bề mặt sáng một mặt: xử lý trực tiếp </span <span class="font-style">mặt sáng</span>',
    zh_tc:
      '雙面加工的高光板：先加工<span class="font-style">啞光面</span> , 再加工<span class="font-style">高光面</span><span>; &nbsp; 單面加工的高光板：直接加工 </span <span class="font-style">高光面</span>',
    ru: 'Двойная обработка высокооптических панелей: сначала обработать < span class = "font - style" > матовую поверхность < / span >, затем обработать < span class = "font - style" > высокооптическую поверхность < / span > < span >;  &nbsp; Односторонне обработанная высокооптическая пластина: прямая обработка < / span < span class = "font - style" > Высокая световая поверхность < / span >',
    ko: '양면 가공된 고광판: <span class="font-style"> 무광면 </span>을 먼저 가공한 다음 <span class="font-style"> 고광면 </span> <span>을 가공한다. &nbsp;단면 가공을 위한 고광판: 직접 가공 </span <span class="font-style"> 고광면 </span>',
    bur: 'နှစ်ဖက်လုပ်ဆောင်ပေါ်ဒ်: ဦးစွာ မှိုင်းမျက်နှာကိုလုပ်ဆောင်ပြီး မြင့်မားသောဝင်းပတ်မျက်နှာကိုလုပ်ဆောင်; တစ်ဖက်တည်း: မြင့်မားသောဝင်းပတ်မျက်နှာကိုတိုက်ရိုက်လုပ်ဆောင်',
    ben: 'দ্বিপার্শ্বিক প্রক্রিয়াকরণ: প্রথমে ম্যাট পৃষ্ঠ, তারপর গ্লসি পৃষ্ঠ; একপাশের: গ্লসি পৃষ্ঠ সরাসরি প্রক্রিয়া করুন',
    tr: 'Çift yüz parlak levha: Önce <span class="font-style">mat yüzey</span>, sonra <span class="font-style">parlak yüzey</span>; Tek yüz parlak levha: Doğrudan <span class="font-style">parlak yüzey</span> işleyin.',
    km: 'ផ្ទាំងរលោងពីរមុខ៖ ដំណើរការ <span class="font-style">ផ្ទៃម៉ាត</span> មុន រួច <span class="font-style">ផ្ទៃរលោង</span>។ ផ្ទាំងរលោងមុខតែមួយ៖ ដំណើរការ <span class="font-style">ផ្ទៃរលោង</span> ដោយផ្ទាល់។',
    es: 'Tablero procesado de alto brillo de doble cara: procese primero <span class="font-style">superficie mate</span> y luego procese <span class="font-style">superficie de alto brillo</span><span>; Tablero de alto brillo procesado por una cara: procese directamente </span <span class="font-style">superficie de alto brillo</span>',
    ar: 'لوح عالي اللمعان مُعالج على الوجهين: معالجة <span class="font-style">السطح غير اللامع أولاً</span>، ثم معالجة <span class="font-style">السطح عالي اللمعان</span><span>؛ لوح عالي اللمعان معالج من جانب واحد: معالجة مباشرة </span <span class="font-style">سطح عالي اللمعان</span>',
  },
  'arrangedPage.selectTip': {
    zh: '请在下方选择需要补件的小板!',
    en: 'Please select planks that need to be patched below',
    id: 'Pilih papan kecil di bawah ini untuk membutuhkan suplemen!',
    kz: 'Төмендегіде күнделікті жапқа қосу қажет плақтарды таңдаңыз',
    th: 'โปรดเลือกบอร์ดขนาดเล็กด้านล่างเพื่อต้องการอาหารเสริม!',
    ug: 'تۆۋەندىن قوشۇمچە بۆلەك تاللاڭ!',
    vi: 'Vui lòng chọn tấm nhỏ cần bổ sung ở phía dưới!',
    zh_tc: '請在下方選擇需要補件的小板!',
    ru: 'Пожалуйста, выберите нижнюю панель, которая требует дополнения!',
    ko: '아래에서 패치가 필요한 보드를 선택하십시오!',
    bur: 'အောက်တွင်ဖြည့်ဆည်းရမည့်ပေါ်ဒ်ငယ်ရွေးပါ!',
    ben: 'নিচে থেকে পরিপূরক প্রয়োজন এমন ছোট বোর্ড নির্বাচন করুন!',
    tr: 'Aşağıdan ek parça gerektiren küçük levhaları seçin',
    km: 'សូមជ្រើសរើសផ្ទាំងតូចដែលត្រូវការបំពេញខាងក្រោម',
    es: '¡Seleccione el tablero pequeño que necesita suplementos a continuación!',
    ar: 'يرجى تحديد اللوحة الصغيرة التي تحتاج إلى مكملات أدناه!',
  },
  'arrangedPage.plankKeyWordPlaceholder': {
    zh: '请输入板件名称或板号',
    en: 'Enter Part Name / No.',
    id: 'Harap masukkan nama papan atau nomor papan',
    kz: 'Плақтың атауын немесе нөмірін енгізіңіз',
    th: 'กรุณากรอกชื่อบอร์ดหรือหมายเลขบอร์ด',
    ug: 'تاختا بۆلەك نامى ياكى نومۇرىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập tên tấm gỗ hoặc số tấm',
    zh_tc: '請輸入板件名稱或板號',
    ru: 'Введите имя или номер панели',
    ko: '보드 이름 또는 보드 번호를 입력하십시오.',
    bur: 'ပေါ်ဒ်အမည် သို့မဟုတ် ပေါ်ဒ်နံပါတ်ထည့်ပါ',
    ben: 'বোর্ডের নাম বা নম্বর লিখুন',
    tr: 'Levha adı veya numarasını girin',
    km: 'សូមបញ្ចូលឈ្មោះផ្ទាំង ឬលេខផ្ទាំង',
    es: 'Por favor ingrese el nombre o número de placa de la placa',
    ar: 'يرجى إدخال اسم اللوحة أو رقم اللوحة',
  },
  'arrangedPage.surplusStoreSuccess': {
    zh: '入库成功',
    en: 'Surplus stored successfully',
    id: 'Berhasil memasuki gudang',
    kz: 'Жапкан сәтті қойылды',
    th: 'เข้าสู่คลังสินค้าได้สำเร็จ',
    ug: 'ئامبارغا ساقلاش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Nhập kho thành công',
    zh_tc: '入庫成功',
    ru: 'Хранилище успешно',
    ko: '입고 성공',
    bur: 'ဂိုဒေါင်သွင်းမှုအောင်မြင်',
    ben: 'গুদামে রাখা সফল হয়েছে',
    tr: 'Depoya alma başarılı',
    km: 'រក្សាទុកឃ្លាំងបានជោគជ័យ',
    es: 'Almacenamiento exitoso',
    ar: 'التخزين الناجح',
  },
  'arrangedPage.editCutOrder': {
    zh: '修改切割顺序',
    en: 'Edit cutting order',
    id: 'Ubah Pesanan Pemotongan',
    kz: 'Кесу тәртібін өңдеу',
    th: 'ปรับเปลี่ยนลำดับการตัด',
    ug: 'كېسىش تەرتىپىنى تەھرىرلەش',
    vi: 'Sửa đổi thứ tự cắt',
    zh_tc: '修改切割順序',
    ru: 'Изменить порядок резки',
    ko: '가공 순서 수정하기',
    bur: 'ဖြတ်တောက်အစဉ်ပြင်ဆင်',
    ben: 'কাটার ক্রম পরিবর্তন করুন',
    tr: 'Kesim sırasını düzenle',
    km: 'កែលំដាប់ការកាត់',
    es: 'Modifique la secuencia de corte',
    ar: 'تعديل تسلسل القطع',
  },
  'arrangedPage.setCutPoint': {
    zh: '设置下刀点',
    en: 'Set knife point',
    id: 'Atur titik cut-down',
    kz: 'Қойым кесу нүктесін көрсету',
    th: 'ตั้งจุดตัดลง',
    ug: 'كېسىش نۇقتىسىنى تەڭشەش',
    vi: 'Đặt điểm cắt',
    zh_tc: '設置下刀點',
    ru: 'Установите точку падения.',
    ko: '다음 공구 점 설정하기',
    bur: 'ဓားချဉ်ပြင်ဆင်သတ်မှတ်',
    ben: 'ছুরি পয়েন্ট সেট করুন',
    tr: 'Bıçak iniş noktasını ayarla',
    km: 'កំណត់ចំណុចចុះដារ',
    es: 'Establezca el punto de corte',
    ar: 'ضبط نقطة القطع',
  },
  'arrangedPage.specialPaibanChangeErr': {
    zh: '有板件具有特殊工艺或贴边加工的槽，暂不支持切换排版方案！',
    en: 'Some planks have special processes, layout switching is not supported for now!',
    id: 'Bagian berlapis memiliki proses khusus atau alur pemrosesan bekas, dan skema tata letak switching belum didukung!',
    kz: 'Плақтардан кейін көрсетілген белгілі мамандар бар, әрекетті аспаптап алмас!',
    th: 'ชิ้นส่วนที่ชุบมีกระบวนการพิเศษหรือร่องการประมวลผล Welt และรูปแบบเค้าโครงสลับยังไม่รองรับ!',
    ug: 'تاختا بۆلەكلىرى ئالاھىدە پىروگرامما ياكى چېگرا ئىشلەنگەن ئويۇقلارغا ئىگە، نۆۋەتتە تەرتىپلەش پىلانىنى ئالماشتۇرۇشقا قوللىمايدۇ!',
    vi: 'Có tấm gỗ có công nghệ đặc biệt, không hỗ trợ chuyển đổi bố cục!',
    zh_tc: '有板件具有特殊工藝或貼邊加工的槽，暫不支持切換排版方案！',
    ru: 'Есть панели со специальными процессами или пазами для боковой обработки, которые временно не поддерживают переключение схемы набора!',
    ko: '특수 공정 또는 모서리를 붙여 가공한 슬롯이 있는 판재는 조판 스키마 전환이 일시적으로 지원되지 않습니다!',
    bur: 'ပေါ်ဒ်တွင်အထူးလုပ်ငန်းစဉ်သို့မဟုတ်ဘောင်ကပ်ချောင်းရှိ၍ ပြင်ဆင်မှုစီမံချက်ပြောင်းခြင်းကိုယာယီမထောက်ခံ!',
    ben: 'বোর্ডে বিশেষ প্রক্রিয়া আছে, লেআউট স্কিম পরিবর্তন এখন সমর্থিত নয়!',
    tr: 'Özel işlem veya kenar oluklu levhalar var; yerleşim şeması değiştirme şimdilik desteklenmiyor',
    km: 'មានផ្ទាំងមានដំណើរការពិសេស ឬរន្ធគែម មិនទាន់គាំទ្រការប្ដូរផែនការរៀបចំ',
    es: 'Hay placas con procesos o ranuras especiales para el procesamiento de ribetes. ¡No se admite cambiar el esquema de diseño en este momento!',
    ar: 'هناك ألواح ذات عمليات خاصة أو أخاديد لمعالجة اللحام. تبديل مخطط التخطيط غير مدعوم في الوقت الحالي!',
  },
  'arrangedPage.storedSuccess': {
    zh: '补件成功！选中板件已经放入补件管理!',
    en: 'Patching successful! Selected planks have been added to patch management!',
    id: 'Pengisian yang sukses! Dewan yang dipilih telah ditempatkan di manajemen pengisian!',
    kz: 'Жапкан сәтті толтырылды! Таңдалған плақтар қосымша құрылымдықтарға қойылды!',
    th: 'การเติมเต็มที่ประสบความสำเร็จ! บอร์ดที่เลือกได้ถูกวางไว้ในการจัดการการเติมเต็ม!',
    ug: 'قوشۇمچە بۆلەك مۇۋەپپەقىيەتلىك بولدى! تاللانغان تاختا بۆلەكلىرى قوشۇمچە بۆلەك باشقۇرۇشىغا سېلىندى!',
    vi: 'Bổ sung thành công! Tấm gỗ đã chọn đã được đưa vào quản lý bổ sung!',
    zh_tc: '補件成功！選中板件已經放入補件管理!',
    ru: 'Дополнение успешно! Выберите панель для управления дополнениями!',
    ko: '패치 성공!선택된 위젯은 이미 위젯 관리에 넣었습니다!',
    bur: 'ဖြည့်ဆည်းမှုအောင်မြင်! ရွေးချယ်ထားသောပေါ်ဒ်ကိုဖြည့်ဆည်းစီမံချက်တွင်ထည့်ပြီး!',
    ben: 'পরিপূরক সফল! নির্বাচিত বোর্ড পরিপূরক ব্যবস্থাপনায় রাখা হয়েছে!',
    tr: 'Ek parça başarılı! Seçilen levhalar ek parça yönetimine eklendi',
    km: 'បំពេញបានជោគជ័យ! ផ្ទាំងដែលបានជ្រើសរើសត្រូវបានដាក់ចូលការគ្រប់គ្រងបំពេញ',
    es: '¡Reemplazo exitoso! ¡El panel seleccionado ha sido puesto en la gestión de repuestos!',
    ar: 'تم الاستبدال بنجاح! تم وضع اللوحة المحددة في إدارة قطع الغيار!',
  },
  'arrangedPage.noSurplus': {
    zh: '未查询到可用余料',
    en: 'No available surplus found',
    id: 'Tidak ada bahan yang tersisa yang ditemukan',
    kz: 'Қол жетімді қалдық табылмады',
    th: 'ไม่พบวัสดุที่เหลืออยู่',
    ug: 'ئىشلىتىشكە بولىدىغان قالدۇق ماتېرىيال تېپىلمىدى',
    vi: 'Không tìm thấy dư liệu có thể sử dụng',
    zh_tc: '未查詢到可用餘料',
    ru: 'Не найден доступный остаток',
    ko: '사용 가능한 여분의 재료가 질의되지 않았습니다.',
    bur: 'အသုံးပြုနိုင်သောပိုလျှံပစ္စည်းမတွေ့ပါ',
    ben: 'ব্যবহারযোগ্য উদ্বৃত্ত পাওয়া যায়নি',
    tr: 'Kullanılabilir artık bulunamadı',
    km: 'រកមិនឃើញសម្ភារៈសល់ដែលប្រើបាន',
    es: 'No se consultaron materiales restantes disponibles',
    ar: 'لم يتم الاستعلام عن أي مواد متبقية متاحة',
  },
  'arrangedPage.selectErrTip': {
    zh: '余料板件不可补件,请先选择正常小板',
    en: 'Surplus planks cannot be patched, please select normal planks first',
    id: 'Pelat yang tersisa tidak diizinkan untuk diisi ulang, silakan pilih piring kecil normal terlebih dahulu',
    kz: 'Қалдық плақтарды қосу мүмкін емес, тегін плақтарды таңдаңыз',
    th: 'แผ่นที่เหลือไม่ได้รับอนุญาตให้เติมโปรดเลือกแผ่นเล็ก ๆ ปกติก่อน',
    ug: 'قالدۇق ماتېرىيال تاختا بۆلەكلىرى قوشۇمچە بۆلەك بولالمايدۇ، ئاۋۋال نورمال كىچىك تاختا تاللاڭ',
    vi: 'Tấm dư liệu không thể bổ sung, vui lòng chọn tấm nhỏ bình thường trước',
    zh_tc: '餘料板件不可補件,請先選擇正常小板',
    ru: 'Оставшиеся пластины не могут быть дополнены, сначала выберите нормальную пластину',
    ko: '남은 원판 부품은 보충할 수 없습니다. 먼저 일반 소판을 선택하십시오.',
    bur: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကိုဖြည့်ဆည်းမနိုင်၊ ပုံမှန်ပေါ်ဒ်ငယ်ကိုဦးစွာရွေးပါ',
    ben: 'উদ্বৃত্ত বোর্ডে পরিপূরক করা যাবে না, প্রথমে স্বাভাবিক ছোট বোর্ড নির্বাচন করুন',
    tr: 'Artık levhalar tamamlanamaz; önce normal küçük levha seçin',
    km: 'ផ្ទាំងសល់មិនអាចបំពេញបានទេ សូមជ្រើសរើសផ្ទាំងតូចធម្មតាមុន',
    es: 'Los materiales restantes no se pueden reparar, seleccione primero el tablero pequeño normal',
    ar: 'لا يمكن إصلاح المواد المتبقية، يرجى اختيار اللوحة الصغيرة العادية أولاً',
  },
  'arrangedPage.noRoomIDTip': {
    zh: '该板件没有房间ID,无法进行补件入库,请先选择其他小板',
    en: 'This plank does not have a room ID, cannot be patched, please select other planks first',
    id: 'Papan ini tidak memiliki ID kamar dan tidak dapat diisi ulang. Pilih papan lain terlebih dahulu',
    kz: 'Осы плақтарда өнім ID жоқ, себебі қаптамаға қосу мүмкін емес, төмендегі плақтарды таңдаңыз',
    th: 'บอร์ดนี้ไม่มีรหัสห้องและไม่สามารถเติมเต็มได้ กรุณาเลือกบอร์ดอื่นก่อน',
    ug: 'بۇ تاختا بۆلەكنىڭ بۆلەك ID سى يوق، قوشۇمچە بۆلەك ئامبارغا ساقلىيالمايدۇ، ئاۋۋال باشقا كىچىك تاختا تاللاڭ',
    vi: 'Tấm gỗ này không có ID phòng, không thể bổ sung và nhập kho, vui lòng chọn tấm nhỏ khác trước',
    zh_tc: '該板件沒有房間ID,無法進行補件入庫,請先選擇其他小板',
    ru: 'Эта доска не имеет идентификатора комнаты, не может быть пополнена в хранилище, сначала выберите другую доску',
    ko: '이 보드에는 공간 ID가 없으므로 패치 입고 작업을 수행할 수 없습니다. 먼저 다른 보드를 선택하십시오.',
    bur: 'ဤပေါ်ဒ်တွင်အခန်း ID မရှိ၍ ဖြည့်ဆည်းဂိုဒေါင်သွင်းမနိုင်၊ အခြားပေါ်ဒ်ငယ်ကိုဦးစွာရွေးပါ',
    ben: 'এই বোর্ডে রুম আইডি নেই, পরিপূরক গুদামে রাখা যাবে না, প্রথমে অন্য ছোট বোর্ড নির্বাচন করুন',
    tr: 'Bu levhada oda ID yok; tamamlama depoya alınamaz, önce başka küçük levha seçin',
    km: 'ផ្ទាំងនេះគ្មានលេខកន្លែង មិនអាចបំពេញចូលឃ្លាំងបាន សូមជ្រើសរើសផ្ទាំងតូចផ្សេងមុន',
    es: 'Este panel no tiene espacio ID y las piezas de reparación no se pueden colocar en el almacén. Seleccione primero otras tablas pequeñas',
    ar: 'لا تحتوي هذه اللوحة على غرفة ID، ولا يمكن وضع قطع الإصلاح في المستودع. يرجى اختيار لوحات صغيرة أخرى أولا',
  },
  'arrangedPage.noPlank': {
    zh: '未找到板件',
    en: 'Plank not found',
    id: 'Tidak ada papan yang ditemukan',
    kz: 'Плақтар табылмады',
    th: 'ไม่พบบอร์ด',
    ug: 'تاختا بۆلەك تېپىلمىدى',
    vi: 'Không tìm thấy tấm gỗ',
    zh_tc: '未找到板件',
    ru: 'Доска не найдена',
    ko: '보드를 찾을 수 없음',
    bur: 'ပေါ်ဒ်မတွေ့ပါ',
    ben: 'বোর্ড পাওয়া যায়নি',
    tr: 'Levha bulunamadı',
    km: 'រកមិនឃើញផ្ទាំង',
    es: 'Placa no encontrada',
    ar: 'لم يتم العثور على اللوحة',
  },
  'arrangedPage.noPaibanData': {
    zh: '无排版数据，无法进行',
    en: 'No layout data, unable to proceed',
    id: 'Tidak ada data pengaturan huruf, tidak dapat dilakukan',
    kz: 'Аспаптама деректері жоқ, аспаптау мүмкін емес',
    th: 'ไม่มีข้อมูลการเรียงพิมพ์ไม่สามารถทำได้',
    ug: 'تەرتىپلەش سانلىق مەلۇماتى يوق، ئىشلەتكىلى بولمايدۇ',
    vi: 'Không có dữ liệu bố cục, không thể tiến hành',
    zh_tc: '無排版數據，無法進行',
    ru: 'Данные без типографии, не могут быть выполнены',
    ko: '조판 데이터 없음, 진행 불가',
    bur: 'ပြင်ဆင်မှုဒေတာမရှိ၊ ဆောင်ရွက်မနိုင်',
    ben: 'কোনো লেআউট ডেটা নেই, এগিয়ে যাওয়া যাচ্ছে না',
    tr: 'Yerleşim verisi yok; işlem yapılamıyor',
    km: 'គ្មានទិន្នន័យរៀបចំ មិនអាចបន្តបាន',
    es: 'No hay datos de composición, no se puede continuar',
    ar: 'لا توجد بيانات تنضيد، لا يمكن المتابعة',
  },
  'arrangedPage.historyNameErr': {
    zh: '请输入方案名称',
    en: 'Please enter the plan name',
    id: 'Harap masukkan nama rencana',
    kz: 'Құжат атын енгізіңіз',
    th: 'กรุณากรอกชื่อแผน',
    ug: 'پىلان نامىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập tên bố cục',
    zh_tc: '請輸入方案名稱',
    ru: 'Введите имя программы',
    ko: '스키마 이름을 입력하십시오.',
    bur: 'စီမံချက်အမည်ထည့်ပါ',
    ben: 'পরিকল্পনার নাম লিখুন',
    tr: 'Plan adını girin',
    km: 'សូមបញ្ចូលឈ្មោះផែនការ',
    es: 'Ingrese el nombre del plan',
    ar: 'الرجاء إدخال اسم الخطة',
  },
  'arrangedPage.tempErrTip': {
    zh: '检测到您未添加五/六面钻所用模板，从而无法导出五/六面钻加工文件,注意：添加完成后需要重新排版',
    en: 'Detected that you have not added templates for five/six-sided drilling, thus unable to export five/six-sided drilling processing files. Attention: After adding, you need to re-layout',
    id: 'Terdeteksi bahwa Anda tidak menambahkan templat yang digunakan untuk bor lima/enam sisi, sehingga file pemrosesan bor lima/enam sisi tidak dapat diekspor. Catatan: Anda perlu mengetik ulang setelah penambahan selesai.',
    kz: 'Сіз бес / алты жаға жүйесін қолданбай алдыңғыдай өтінішті плақтар үшін шаблондарды қоспай қалдықтың әдепкі қосымша жұмыс жасауды қаламаймыз, ескертіп: қосу аяқталған кейін өтінішті аспаптап көріңіз',
    th: 'ตรวจพบว่าคุณไม่ได้เพิ่มเทมเพลตที่ใช้สำหรับการฝึกซ้อมห้า/หกด้านเพื่อไม่สามารถส่งออกไฟล์สว่านห้า/หกด้านได้ หมายเหตุ: คุณต้องพิมพ์ใหม่อีกครั้งหลังจากการเพิ่มเสร็จสิ้น',
    ug: 'بەش/ئالتە تەرەپلىك ئېگىزلىك ماتور قېلىپىنى قوشمىغانلىقىڭىزنى بايقىدىم، شۇڭا بەش/ئالتە تەرەپلىك ئېگىزلىك ماتور ئىشلەش ھۆججىتىنى چىقىرىپ بولمايدۇ. دىققەت: قوشۇپ بولغاندىن كېيىن قايتا تەرتىپلەش زۆرۈر!',
    vi: 'Chúng tôi phát hiện bạn chưa thêm mẫu dùng cho máy khoan 5/6 mặt, vì vậy không thể xuất tập tin gia công máy khoan 5/6 mặt. Lưu ý: bạn cần bố cục lại sau khi thêm mẫu',
    zh_tc:
      '檢測到您未添加五/六面鑽所用模板，從而無法導出五/六面鑽加工文件,注意：添加完成後需要重新排版',
    ru: 'Обнаружено, что вы не добавили шаблон для пятигранного бурения, чтобы экспортировать файл обработки пятигранного бурения, обратите внимание: после добавления требуется переформатирование',
    ko: '5면 / 6면 드릴을 추가하지 않은 템플릿이 발견되어 5면 / 6면 드릴링 가공 파일을 내보낼 수 없습니다. 참고: 추가가 완료되면 다시 조판해야 합니다.',
    bur: 'ငါးဖက်/ခြောက်ဖက်တူးစက်ပုံစံမထည့်ရသေး၍ ထုတ်လုပ်ဖိုင်မထုတ်နိုင်ပါ',
    ben: 'পাঁচ/ছয়-পার্শ্বিক ড্রিলিং টেমপ্লেট যোগ করা হয়নি, তাই ড্রিলিং ফাইল রপ্তানি করা যাচ্ছে না',
    tr: '5/6 yüz delik şablonu eklenmediği için işleme dosyası dışa aktarılamıyor. Not: ekledikten sonra yeniden yerleşim gerekir',
    km: 'មិនបានបន្ថែមគំរូសម្រាប់ដីសគី ៥/៦ ផ្ទៃ ដូចនេះមិនអាចនាំចេញឯកសារដំណើរការបាន។ សម្គាល់៖ ក្រោយបន្ថែមត្រូវរៀបចំឡើងវិញ',
    es: 'Se detecta que no ha agregado la plantilla para brocas de cinco/seis lados, por lo que los archivos de procesamiento de brocas de cinco/seis lados no se pueden exportar. Nota: Debe volver a diseñar después de completar la adición',
    ar: 'تم اكتشاف أنك لم تقم بإضافة القالب للمثاقب الخماسية/السداسية، لذلك لا يمكن تصدير ملفات معالجة الحفر الخماسية/السداسية. ملاحظة: تحتاج إلى إعادة التخطيط بعد اكتمال الإضافة',
  },
  'arrangedPage.changeDataTip': {
    zh: '注意：检测到您的数据有变更是否新建一个历史文件，保存此次变更内容？',
    en: 'Attention: Detected changes in your data, whether to create a new history file, and save this change content?',
    id: 'Catatan: Apakah Anda membuat file historis baru untuk menyimpan konten perubahan ini ketika Anda mendeteksi bahwa data Anda telah berubah?',
    kz: 'Ескертіп көріңіз: деректеріңізде өзгерістер табылды, жаңа тарихтар файлын құру үшін үшін сақтаңыз',
    th: 'หมายเหตุ: คุณสร้างไฟล์ประวัติศาสตร์ใหม่เพื่อบันทึกเนื้อหาของการเปลี่ยนแปลงนี้เมื่อคุณตรวจพบว่าข้อมูลของคุณมีการเปลี่ยนแปลงหรือไม่?',
    ug: 'دىققەت: سانلىق مەلۇمات ئۆزگەرگەنلىكىنى بايقىدىم، بۇ ئۆزگەرتىش مەزمۇنىنى ساقلايدىغان يېڭى تارىخ ھۆججىتى قۇرامسىز؟',
    vi: 'Lưu ý: Chúng tôi phát hiện dữ liệu của bạn đã thay đổi. Bạn có muốn tạo một tệp lịch sử mới để lưu trữ thay đổi này không?',
    zh_tc: '注意：檢測到您的數據有變更是否新建一個歷史文件，保存此次變更內容？',
    ru: 'Примечание: Обнаружено ли изменение в ваших данных Создать новый исторический файл для сохранения этого изменения?',
    ko: '참고: 데이터가 변경되었음을 감지하여 새 히스토리 파일을 만들어 변경 내용을 저장하시겠습니까?',
    bur: 'သတိ: ဒေတာပြောင်းလဲမှုရှိကြောင်းစစ်ဆေးတွေ့ရှိ၊ ဤပြောင်းလဲမှုသိမ်းဆည်းဖို့မှတ်တမ်းဖိုင်အသစ်ဖန်တီးမည်လား?',
    ben: 'নোট: ডেটা পরিবর্তন পাওয়া গেছে, এই পরিবর্তন সংরক্ষণ করতে নতুন ইতিহাস ফাইল তৈরি করবেন?',
    tr: 'Verilerinizde değişiklik algılandı; bu değişiklikleri kaydetmek için yeni bir geçmiş dosyası oluşturulsun mu?',
    km: 'រកឃើញទិន្នន័យរបស់អ្នកបានផ្លាស់ប្ដូរ បង្កើតឯកសារប្រវត្តិថ្មីដើម្បីរក្សារបៀបនេះឬទេ?',
    es: 'Nota: Se detecta que sus datos han cambiado. ¿Quieres crear un nuevo archivo de historial para guardar este cambio?',
    ar: 'ملاحظة: تم اكتشاف أن بياناتك قد تغيرت. هل تريد إنشاء ملف محفوظات جديد لحفظ هذا التغيير؟',
  },
  'arrangedPage.upgrade': {
    zh: '升级',
    en: 'Upgrade',
    id: 'meningkatkan',
    kz: 'Жаңарту',
    th: 'อัพเกรด',
    ug: 'يېڭىلاش',
    vi: 'Nâng cấp',
    zh_tc: '升級',
    ru: 'обновление',
    ko: '업그레이드',
    bur: 'အဆင့်မြှင့်',
    ben: 'আপগ্রেড করুন',
    tr: 'Yükselt',
    km: 'ធ្វើឱ្យទាន់សម័យ',
    es: 'Actualización',
    ar: 'ترقية',
  },
  'arrangedPage.upgradeTip': {
    zh: '，您可以点击下方按钮去升级版本',
    en: ', you can click the button below to upgrade',
    id: ', Anda dapat mengklik tombol di bawah ini untuk meningkatkan versi',
    kz: ', төмендегі түймеге басып жаңартуға болады',
    th: 'คุณสามารถคลิกปุ่มด้านล่างเพื่ออัพเกรดเวอร์ชัน',
    ug: '، تۆۋەندىكى توپچىنى چېكىپ نەشرىنى يېڭىلىيالايسىز',
    vi: 'Bạn có thể nhấn nút bên dưới để nâng cấp phiên bản',
    zh_tc: '，您可以點擊下方按鈕去升級版本',
    ru: 'Вы можете нажать кнопку ниже, чтобы обновить версию',
    ko: ', 당신은 아래 단추를 클릭하여 버전을 업그레이드할 수 있습니다',
    bur: '၊ အောက်ပါခလုတ်ကိုနှိပ်ပြီးဗားရှင်းအဆင့်မြှင့်နိုင်',
    ben: ', নিচের বোতামে ক্লিক করে সংস্করণ আপগ্রেড করতে পারবেন',
    tr: ', sürümü yükseltmek için aşağıdaki düğmeye tıklayabilirsiniz',
    km: ' អ្នកអាចចុចប៊ូតុងខាងក្រោមដើម្បីធ្វើឱ្យជំនាន់ទាន់សម័យ',
    es: ', puede hacer clic en el botón a continuación para actualizar la versión',
    ar: '، يمكنك النقر على الزر أدناه لترقية الإصدار',
  },
  'arrangedPage.plankOverEdge': {
    zh: '下载NC失败！请检查是否有板件重叠或板件在大板外',
    en: 'Failed to download NC! Please check if there is overlap between planks or if the planks are outside the large plank',
    id: 'Unduh NC Gagal! Silakan periksa apakah pelat yang tumpang tindih atau pelat berada di luar pelat besar',
    kz: 'NC файл жүктеу сәтсіз! Плақтардың бірінше көліңіз жақты олтандықта немесе плақтардың шеттерін тексеріңіз',
    th: 'NC ดาวน์โหลดล้มเหลว! โปรดตรวจสอบว่าแผ่นซ้อนทับกันหรือแผ่นอยู่ด้านนอกแผ่นขนาดใหญ่',
    ug: 'NC چۈشۈرۈش مەغلۇپ بولدى! تاختا بۆلەكلىرىنىڭ ئۈستىمە-ئۈستىمە ياكى چوڭ تاختىدىن چىقىپ كەتكەنلىكىنى تەكشۈرۈڭ',
    vi: 'Tải xuống NC thất bại! Vui lòng kiểm tra xem có tấm gỗ chồng lên nhau hoặc nằm ngoài tấm lớn không',
    zh_tc: '下載NC失敗！請檢查是否有板件重疊或板件在大板外',
    ru: 'Ошибка загрузки NC! Пожалуйста, проверьте, есть ли накладки или панели снаружи.',
    ko: 'NC 다운로드 실패!판재가 중첩되거나 판재가 큰 판 밖에 있는지 확인하십시오',
    bur: 'NC ဒေါင်းလုတ်မအောင်မြင်! ပေါ်ဒ်ထပ်နေသည် သို့မဟုတ် ပေါ်ဒ်ကြီးပြင်ပတွင်ရှိနေသည်ကိုစစ်ဆေးပါ',
    ben: 'NC ডাউনলোড ব্যর্থ! বোর্ড ওভারল্যাপ বা বোর্ড বড় বোর্ডের বাইরে আছে কিনা পরীক্ষা করুন',
    tr: 'NC indirilemedi! Levha çakışması veya levhanın büyük levha dışında olup olmadığını kontrol edin',
    km: 'ទាញយកNCបរាជ័យ! សូមពិនិត្យផ្ទាំងជាន់គ្នា ឬនៅក្រៅផ្ទាំងធំ',
    es: '¡La descarga NC falló! Verifique si hay paneles superpuestos o paneles fuera del panel grande',
    ar: 'فشل تنزيل NC! يرجى التحقق مما إذا كانت هناك لوحات أو لوحات متداخلة خارج اللوحة الكبيرة',
  },
  'arrangedPage.useSurplusTip': {
    zh: '是否扣减余料',
    en: 'Whether to deduct surplus',
    id: 'Apakah akan mengurangi bahan yang tersisa',
    kz: 'Қалдықты кестеу керек пе',
    th: 'ไม่ว่าจะลดวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىياللارنى چىقىرىۋېتىشكە رازىمۇ؟',
    vi: 'Có muốn khấu trừ dư liệu không?',
    zh_tc: '是否扣減餘料',
    ru: 'Вычет остатков',
    ko: '여분 감액 여부',
    bur: 'ပိုလျှံပစ္စည်းနှုတ်မည်လား',
    ben: 'উদ্বৃত্ত কাটা হবে কি',
    tr: 'Artık malzeme düşülsün mü?',
    km: 'តើដកសម្ភារៈសល់ឬទេ?',
    es: 'Si se debe deducir el material restante',
    ar: 'ما إذا كان سيتم خصم المادة المتبقية',
  },
  'arrangedPage.noDataExport': {
    zh: '没有可以导出的排版数据',
    en: 'No layout data available for export',
    id: 'Tidak ada data tipografi yang diekspor',
    kz: 'Експортталатын аспаптық деректер жоқ',
    th: 'ไม่มีข้อมูลการพิมพ์ส่งออก',
    ug: 'چىقىرىشقا بولىدىغان تەرتىپلەش سانلىق مەلۇماتى يوق',
    vi: 'Không có dữ liệu bố cục có thể xuất',
    zh_tc: '沒有可以導出的排版數據',
    ru: 'Нет данных, которые можно экспортировать',
    ko: '내보낼 수 있는 조판 데이터가 없습니다.',
    bur: 'ထုတ်နိုင်သောပြင်ဆင်မှုဒေတာမရှိ',
    ben: 'রপ্তানির জন্য কোনো লেআউট ডেটা নেই',
    tr: 'Dışa aktarılacak yerleşim verisi yok',
    km: 'គ្មានទិន្នន័យរៀបចំដែលនាំចេញបាន',
    es: 'No hay datos de composición tipográfica que se puedan exportar',
    ar: 'لا توجد بيانات تنضيد يمكن تصديرها',
  },
  'arrangedPage.noPlankExport': {
    zh: '没有可以导出的小板数据',
    en: 'No planks available for export',
    id: 'Tidak ada data papan kecil yang dapat diekspor',
    kz: 'Експортталатын плақтардың деректері жоқ',
    th: 'ไม่มีข้อมูลบอร์ดขนาดเล็กที่สามารถส่งออกได้',
    ug: 'چىقىرىشقا بولىدىغان كىچىك تاختا سانلىق مەلۇماتى يوق',
    vi: 'Không có dữ liệu tấm nhỏ có thể xuất',
    zh_tc: '沒有可以導出的小板數據',
    ru: 'Нет данных, которые можно экспортировать',
    ko: '내보낼 수 있는 보드가 없습니다.',
    bur: 'ထုတ်နိုင်သောပေါ်ဒ်ငယ်ဒေတာမရှိ',
    ben: 'রপ্তানির জন্য কোনো ছোট বোর্ড ডেটা নেই',
    tr: 'Dışa aktarılacak küçük levha verisi yok',
    km: 'គ្មានទិន្នន័យផ្ទាំងតូចដែលនាំចេញបាន',
    es: 'No hay datos de paneles pequeños que se puedan exportar',
    ar: 'لا توجد بيانات لوحة صغيرة يمكن تصديرها',
  },
  'arrangedPage.lockTip1': {
    zh: '点击进行解锁，解锁后可以',
    en: 'Click to unlock, after unlocking you can',
    id: 'Klik untuk membuka kunci, setelah membuka kunci',
    kz: 'Шығу үшін басыңыз, шығудан кейін бағанышты редакциялауға болады',
    th: 'คลิกเพื่อปลดล็อกหลังจากปลดล็อค',
    ug: 'قۇلۇپنى ئېچىش ئۈچۈن چېكىڭ، قۇلۇپ ئېچىلغاندىن كېيىن',
    vi: 'Nhấn để mở khóa, sau khi mở khóa bạn có thể',
    zh_tc: '點擊進行解鎖，解鎖後可以',
    ru: 'Нажмите для разблокировки, после разблокировки можно',
    ko: '클릭하여 잠금 해제, 잠금 해제 후 가능',
    bur: 'ကလစ်နှိပ်ပြီးလော့ဖွင့်မည်၊ ဖွင့်ပြီးနောက်',
    ben: 'ক্লিক করে আনলক করুন, আনলকের পরে',
    tr: 'Kilidi açmak için tıklayın; açtıktan sonra',
    km: 'ចុចដើម្បីដោះសោ បន្ទាប់ពីដោះសោអាច',
    es: 'Haga clic para desbloquear. Después de desbloquear, puede',
    ar: 'انقر لفتح. بعد إلغاء القفل، يمكنك',
  },
  'arrangedPage.lockTip2': {
    zh: '编辑小板位置和属性',
    en: 'edit plank position and attributes',
    id: 'Edit Posisi dan Properti Papan',
    kz: 'Бағанышты плақтардың орны мен атрибуттарын редакциялау',
    th: 'แก้ไขตำแหน่งและคุณสมบัติของคณะกรรมการ',
    ug: 'كىچىك تاختا ئورنى ۋە خاسلىقىنى تەھرىرلەيدۇ',
    vi: 'sửa đổi vị trí và thuộc tính tấm nhỏ',
    zh_tc: '編輯小板位置和屬性',
    ru: 'Изменить расположение и атрибуты панели',
    ko: '보드 위치 및 속성 편집',
    bur: 'ပေါ်ဒ်ငယ်တည်နေရာနှင့်ထူးဆန်းချက်ကိုတည်းဖြတ်နိုင်',
    ben: 'ছোট বোর্ডের অবস্থান ও বৈশিষ্ট্য সম্পাদনা করা যাবে',
    tr: 'küçük levha konumunu ve özelliklerini düzenleyebilirsiniz',
    km: 'កែតំណែង និងលក្ខណៈផ្ទាំងតូចបាន',
    es: 'editar la ubicación y los atributos del panel pequeño',
    ar: 'تعديل موقع وسمات اللوحة الصغيرة',
  },
  'arrangedPage.unlockTip1': {
    zh: '点击进行锁定，锁定后不可进行',
    en: 'Click to lock, once locked, it cannot be accessed',
    id: 'Klik untuk mengunci, itu tidak dapat dikunci setelah mengunci',
    kz: 'Басқанда блоктау, блоктағаннан кейін әлі өтілмейді',
    th: 'คลิกเพื่อล็อคไม่สามารถล็อคได้หลังจากล็อค',
    ug: 'قۇلۇپلاش ئۈچۈن چېكىڭ، قۇلۇپلانغاندىن كېيىن',
    vi: 'Nhấp để khóa, không thể thực hiện sau khi khóa',
    zh_tc: '點擊進行鎖定，鎖定後不可進行',
    ru: 'Нажмите для блокировки, которая не может быть выполнена после блокировки',
    ko: '클릭하여 잠금 진행, 잠금 후 진행불가',
    bur: 'ကလစ်နှိပ်ပြီးလော့ပိတ်မည်၊ ပိတ်ပြီးနောက်မဆောင်ရွက်နိုင်',
    ben: 'ক্লিক করে লক করুন, লকের পরে করা যাবে না',
    tr: 'Kilitlemek için tıklayın; kilitlendikten sonra',
    km: 'ចុចដើម្បីចាក់សោ ក្រោយចាក់សោមិនអាច',
    es: 'Haga clic para bloquear. Después de bloquear, no puede editar la ubicación ni los atributos del panel pequeño',
    ar: 'انقر للقفل. بعد القفل لا يمكنك تعديل موقع وسمات اللوحة الصغيرة',
  },
  'arrangedPage.unlockTip2': {
    zh: '小板位置和属性的编辑',
    en: 'edit the position and attributes of the small board',
    id: 'Pengeditan posisi dan atribut papan',
    kz: 'қысқартының орны мен қасиеттерін түзету',
    th: 'การแก้ไขตำแหน่งบอร์ดและคุณลักษณะ',
    ug: 'كىچىك تاختا ئورنى ۋە خاسلىقىنى تەھرىرلەشمەيدۇ',
    vi: 'chỉnh sửa vị trí và thuộc tính bảng nhỏ',
    zh_tc: '小板位置和屬性的編輯',
    ru: 'Изменить расположение и атрибуты панели',
    ko: '보드 위치 및 속성 편집',
    bur: 'ပေါ်ဒ်ငယ်တည်နေရာနှင့်ထူးဆန်းချက်တည်းဖြတ်မှု',
    ben: 'ছোট বোর্ডের অবস্থান ও বৈশিষ্ট্যের সম্পাদনা',
    tr: 'küçük levha konumu ve özellik düzenlemesi yapılamaz',
    km: 'កែតំណែង និងលក្ខណៈផ្ទាំងតូចបានទេ',
    es: 'edit the position and attributes of the small board',
    ar: 'edit the position and attributes of the small board',
  },
  'arrangedPage.plankLockErr': {
    zh: '该大板已被锁定无法放置',
    en: 'This large plank has been locked and cannot be placed',
    id: 'Piring besar telah dikunci dan tidak dapat ditempatkan',
    kz: 'Бұл үлкен бағана құлыпталған, оны орналастыру мүмкін емес',
    th: 'แผ่นขนาดใหญ่ถูกล็อคและไม่สามารถวางได้',
    ug: 'بۇ چوڭ تاختا قۇلۇپلانغان، قويۇشقا بولمايدۇ',
    vi: 'Tấm lớn này đã bị khóa không thể đặt',
    zh_tc: '該大板已被鎖定無法放置',
    ru: 'Большая доска заблокирована и не может быть размещена.',
    ko: '대판이 잠겨 배치할 수 없습니다.',
    bur: 'ဤပေါ်ဒ်ကြီးကိုလော့ပိတ်ထားသဖြင့်ချနိုင်မည်မဟုတ်',
    ben: 'এই বড় বোর্ড লক করা হয়েছে, স্থাপন করা যাবে না',
    tr: 'Bu büyük levha kilitli; yerleştirilemez',
    km: 'ផ្ទាំងធំនេះចាក់សោ មិនអាចដាក់បាន',
    es: 'El panel grande se ha bloqueado y no se puede colocar',
    ar: 'تم قفل اللوحة الكبيرة ولا يمكن وضعها',
  },
  'arrangedPage.lockPartEditTip': {
    zh: '板件被锁定，无法编辑',
    en: 'Plank is locked and cannot be edited',
    id: 'Piring terkunci dan tidak dapat diedit',
    kz: 'Плақтар құлыпталған, оларды редакциялау мүмкін емес',
    th: 'แผ่นถูกล็อคและไม่สามารถแก้ไขได้',
    ug: 'تاختا بۆلەك قۇلۇپلانغان، تەھرىرلەشكە بولمايدۇ',
    vi: 'Tấm gỗ bị khóa, không thể sửa',
    zh_tc: '板件被鎖定，無法編輯',
    ru: 'Пластина заблокирована и не может быть отредактирована',
    ko: '보드가 잠겨 편집할 수 없습니다.',
    bur: 'ပေါ်ဒ်ကိုလော့ပိတ်ထားသဖြင့်တည်းဖြတ်မနိုင်',
    ben: 'বোর্ড লক করা আছে, সম্পাদনা করা যাবে না',
    tr: 'Levha kilitli; düzenlenemez',
    km: 'ផ្ទាំងចាក់សោ មិនអាចកែបាន',
    es: 'El panel está bloqueado y no se puede editar',
    ar: 'اللوحة مقفلة ولا يمكن تحريرها',
  },
  'arrangedPage.glassEquipmentTip': {
    zh: '生产线为玻璃切割机时，板件无法被移动',
    en: 'When the production line is a glass cutting machine, the plank cannot be moved',
    id: 'Saat jalur produksi adalah mesin pemotong kaca, pelat tidak dapat dipindahkan',
    kz: 'Өнім қуғыштық машинасы болған жағдайда плақтар жылжытпай алмайды',
    th: 'เมื่อสายการผลิตเป็นเครื่องตัดแก้วแผ่นไม่สามารถเคลื่อนย้ายได้',
    ug: 'ئىشلەپچىقىرىش لىنىيىسى ئەينەك كېسىش ماشىنىسى بولسا، تاختا بۆلەك يۆتكىلىشكە بولمايدۇ',
    vi: 'Khi dây chuyền là máy cắt thủy tinh, tấm gỗ không thể di chuyển',
    zh_tc: '生產線為玻璃切割機時，板件無法被移動',
    ru: 'Когда производственной линией является стеклорезка, лист не может быть перемещен',
    ko: '생산 라인이 유리 절단기일 때 판재를 이동할 수 없다',
    bur: 'ထုတ်လုပ်မှုလိုင်းသည်မှန်ဖြတ်စက်ဖြစ်သောအခါ ပေါ်ဒ်ကိုရွှေ့မနိုင်',
    ben: 'উৎপাদন লাইন কাচ কাটার মেশিন হলে বোর্ড সরানো যাবে না',
    tr: 'Üretim hattı cam kesim makinesi ise levha taşınamaz',
    km: 'នៅពេលបន្ទាត់ផលិតកម្មជាម៉ាស៊ីនកាត់កញ្ចក់ ផ្ទាំងមិនអាចផ្លាស់ទី',
    es: 'Cuando la línea de producción es una máquina cortadora de vidrio, el panel no se puede mover',
    ar: 'عندما يكون خط الإنتاج عبارة عن آلة قطع زجاج، لا يمكن تحريك اللوحة',
  },
  'arrangedPage.expandedTip': {
    zh: '板件存在拉槽特殊工艺，不支持编辑操作！',
    en: 'Special processing for panel slotting, editing operation not supported!',
    id: 'Proses pemotongan panel khusus, operasi pengeditan tidak didukung!',
    kz: 'Панельді ойық өңдеу ерекше, өңдеу операциясы қолдау көрсетілмейді!',
    th: 'การประเภทใหม่ของแผ่นกระดานถูกล็อก ไม่สามารรถประเภทใหม่',
    ug: 'تاختا بۆلەكتە ئويۇق ئالاھىدە پىروگراممىسى بار، تەھرىرلەشكە قوللىمايدۇ!',
    vi: 'Gia công rãnh tấm đặc biệt, không hỗ trợ thao tác chỉnh sửa!',
    zh_tc: '板件存在拉槽特殊工藝，不支持編輯操作！',
    ru: 'Пластина имеет специальную технологию вытягивания канавки, не поддерживает редактирование операции!',
    ko: '슬롯을 당기는 특수 프로세스가 있는 보드 부품은 편집 작업을 지원하지 않습니다!',
    bur: 'ပေါ်ဒ်တွင်ဆွဲချောင်းအထူးလုပ်ငန်းစဉ်ရှိ၍ တည်းဖြတ်မှုကိုမထောက်ခံ!',
    ben: 'বোর্ডে বিশেষ স্লটিং প্রক্রিয়া আছে, সম্পাদনা অপারেশন সমর্থিত নয়!',
    tr: 'Levhanın özel oluk işlemi var; düzenleme desteklenmiyor',
    km: 'ផ្ទាំងមានដំណើរការរន្ធពិសេស មិនគាំទ្រប្រតិបត្តិការកែ',
    es: '¡El panel tiene un proceso de ranura especial y no admite operaciones de edición!',
    ar: 'تتميز اللوحة بعملية أخدود خاصة ولا تدعم عمليات التحرير!',
  },
  'arrangedPage.sameWidthPlankTip': {
    zh: '开启了锯片排版,板件无法移动',
    en: 'The panel has a special grooving process and needs to be rearranged!',
    id: 'Panel memiliki proses pemotongan khusus dan perlu diurutkan ulang!',
    kz: 'Көліңіз жақты олтандықта өңдеу, өңдеу операциясы қолдау көрсетілмейді!',
    th: 'แผ่นกระดานมีการประเภทใหม่ที่ต้องปรับใหม่!',
    ug: 'تاختا بۆلەكتە ئويۇق ئالاھىدە پىروگراممىسى بار، قايتا تەرتىپلەش زۆرۈر!',
    vi: 'Đã bật chức năng cắt tấm có cùng chiều rộng, tấm gỗ không thể di chuyển!',
    zh_tc: '開啟了鋸片相同寬度排版,板件無法移動',
    ru: 'Включен набор пил, панель не может двигаться',
    ko: '앤티앨리어싱이 켜져 있어 보드를 이동할 수 없음',
    bur: 'ဓားရွက်ပြင်ဆင်မှုဖွင့်ထားသဖြင့်ပေါ်ဒ်ကိုရွှေ့မနိုင်',
    ben: 'করাত কাটার লেআউট চালু করা হয়েছে, বোর্ড সরানো যাবে না',
    tr: 'Aynı bıçak genişliği yerleşimi açık; levha taşınamaz',
    km: 'បានបើកការរៀបចំដារដូចគ្នា ផ្ទាំងមិនអាចផ្លាស់ទី',
    es: 'Cuando el diseño de la hoja de sierra está activado, la tabla no se puede mover.',
    ar: 'عند تشغيل تخطيط شفرة المنشار، لا يمكن للوحة التحرك.',
  },
  'arrangedPage.expandedArrangeTip': {
    zh: '板件存在拉槽特殊工艺，需要重新排版！',
    en: 'The panel has a special grooving process and needs to be rearranged!',
    id: 'Panel memiliki proses pemotongan khusus dan perlu diurutkan ulang!',
    kz: 'Панельде арнайы ойық жасау процесі бар, оны қайта орналастыру қажет!',
    th: 'แผ่นกระดานมีการประเภทใหม่ที่ต้องปรับใหม่!',
    ug: 'تاختا بۆلەكتە ئويۇق ئالاھىدە پىروگراممىسى بار، قايتا تەرتىپلەش زۆرۈر!',
    vi: 'Tấm có quy trình rãnh đặc biệt, cần sắp xếp lại!',
    zh_tc: '板件存在拉槽特殊工藝，需要重新排版！',
    ru: 'Пластина имеет специальную технологию вытягивания канавок, необходимо перепечатать!',
    ko: '판재에는 슬롯을 당기는 특수 공예가 존재하므로 다시 조판해야 한다!',
    bur: 'ပေါ်ဒ်တွင်ဆွဲချောင်းအထူးလုပ်ငန်းစဉ်ရှိ၍ ပြန်ပြင်ဆင်ရန်လိုအပ်!',
    ben: 'বোর্ডে বিশেষ স্লটিং প্রক্রিয়া আছে, পুনরায় লেআউট প্রয়োজন!',
    tr: 'Özel oluk işlemi var; yeniden yerleşim gerekir',
    km: 'ផ្ទាំងមានដំណើរការរន្ធពិសេស ត្រូវការរៀបចំឡើងវិញ',
    es: '¡El tablero tiene un proceso de ranurado especial y es necesario volver a diseñarlo!',
    ar: 'اللوحة لديها عملية أخدود خاصة وتحتاج إلى إعادة تخطيط!',
  },
  'arrangedPage.dragErrTip': {
    zh: '无法放置, 请核对板件材质、颜色和厚度属性!',
    en: 'Cannot place, please check plank material, color, and thickness attributes!',
    id: 'Itu tidak dapat ditempatkan, silakan periksa sifat material, warna dan ketebalan piring!',
    kz: 'Орналастыру мүмкін емес, плақтардың материалын, түсін және міндеттілігін тексеріңіз!',
    th: 'ไม่สามารถวางได้โปรดตรวจสอบวัสดุสีและความหนาของจาน!',
    ug: 'قويۇلمىدى, تاختا بۆلەك ماتېرىيالى، رەڭگى ۋە قېلىنلىق خاسلىقىنى تەكشۈرۈڭ!',
    vi: 'Không thể đặt, vui lòng kiểm tra thuộc tính chất liệu, màu sắc và độ dày của tấm gỗ!',
    zh_tc: '無法放置, 請核對板件材質、顏色和厚度屬性!',
    ru: 'Невозможно разместить, проверьте свойства материала, цвета и толщины панели!',
    ko: '배치할 수 없습니다. 보드 재료, 색상 및 두께 속성을 확인하십시오!',
    bur: 'ချနိုင်မည်မဟုတ်ပါ၊ ပေါ်ဒ်ပစ္စည်း၊ အရောင်နှင့်အထူကိုစစ်ဆေးပါ!',
    ben: 'স্থাপন করা যাচ্ছে না, বোর্ডের উপকরণ, রঙ ও পুরুত্ব যাচাই করুন!',
    tr: 'Yerleştirilemez; levha malzeme, renk ve kalınlığını kontrol edin',
    km: 'មិនអាចដាក់បាន សូមពិនិត្យសម្ភារៈ ពណ៌ និងកម្រាស់ផ្ទាំង',
    es: 'No se puede colocar, verifique las propiedades del material, el color y el grosor de la placa.',
    ar: 'غير قادر على التركيب، يرجى التحقق من مادة اللوحة وخصائص اللون والسمك!',
  },
  'arrangedPage.subtleSaveTip': {
    zh: '当前已对板件操作但未保存,是否退出?',
    en: 'Changes have been made to the plank but not saved, do you want to exit?',
    id: 'Dewan telah dioperasikan tetapi belum disimpan. Apakah itu keluar?',
    kz: 'Ағымдағы аспаптарды өңдеу жасалды, бірақ сақталған жоқ, шығу керек пе?',
    th: 'คณะกรรมการดำเนินการแล้ว แต่ยังไม่ได้รับการบันทึก ออกจาก?',
    ug: 'نۆۋەتتە تاختا بۆلەك مەشغۇلاتى قىلىنغان ئەمما ساقلانمىغان، چىقىسىز؟',
    vi: 'Hiện tại đã có thao tác trên tấm gỗ nhưng chưa lưu, bạn có muốn thoát không?',
    zh_tc: '當前已對板件操作但未保存,是否退出?',
    ru: 'В настоящее время выполнена операция на панели, но не сохранена, выйти?',
    ko: '현재 대시보드에 대해 작업했지만 저장되지 않았습니다. 종료하시겠습니까?',
    bur: 'ပေါ်ဒ်ကိုလုပ်ဆောင်ပြီးမသိမ်းရသေး၊ ထွက်မည်လား?',
    ben: 'বোর্ডে অপারেশন করা হয়েছে কিন্তু সংরক্ষণ হয়নি, বের হবেন?',
    tr: 'Levhada kaydedilmemiş değişiklik var; çıkmak istiyor musunuz?',
    km: 'មានការប្ដូរលើផ្ទាំងដែលមិនទាន់រក្សា ចេញឬទេ?',
    es: 'La placa ha sido operada pero no guardada. ¿Quieres salir?',
    ar: 'تم تشغيل اللوحة ولكن لم يتم حفظها. هل تريد الخروج؟',
  },
  'arrangedPage.rollTip': {
    zh: '大板上存在通孔/通槽，不建议翻版！',
    en: 'There are through holes/slots on the large plank, flipping is not recommended!',
    id: 'Ada melalui lubang/palung di piring besar, dan tidak disarankan untuk mencetak ulang!',
    kz: 'Үлкен бағандарда отвор/шығыс бар, торға бұрылуға ұсынылмайды!',
    th: 'มีผ่านรู/รางบนจานขนาดใหญ่และไม่แนะนำให้พิมพ์ซ้ำ!',
    ug: 'چوڭ تاختىدا ئۆتۈش تېشىكى/ئويۇقى بار، تەتۈرلەشكە تەۋسىيە قىلمايمىز!',
    vi: 'Có lỗ thông/khe thông trên tấm lớn, không khuyến khích đảo ngược!',
    zh_tc: '大板上存在通孔/通槽，不建議翻版！',
    ru: 'На большой доске есть сквозные отверстия / проходные канавки, не рекомендуется копировать!',
    ko: '널빤지에 구멍 / 슬롯이 있어 리메이크를 권장하지 않습니다!',
    bur: 'ပေါ်ဒ်ကြီးတွင်ဖောက်ပေါက်/ဖောက်ချောင်းရှိ၍ ပြောင်းဘက်ကိုမအကြံပြု!',
    ben: 'বড় বোর্ডে থ্রু হোল/স্লট আছে, উল্টানো সুপারিশ করা হয় না!',
    tr: 'Büyük levhada tam delik/oluk var; ters çevirme önerilmez',
    km: 'លើផ្ទាំងធំមានរណ្តៅ/រន្ធភ្លោះ មិនបានណែនាំឱ្យបញ្ច្រាស',
    es: 'Hay orificios pasantes/ranuras pasantes en la placa grande, por lo que no se recomienda copiar.',
    ar: 'توجد ثقوب/فتحات على اللوحة الكبيرة، لذا لا ينصح بالنسخ!',
  },
  'arrangedPage.glossRollErr': {
    zh: '高光板禁止翻板',
    en: 'Glossy planks are prohibited from rolling',
    id: 'Papan gloss tinggi dilarang',
    kz: 'Сәнгі аспаптар торға бұрылмайды',
    th: 'ห้ามใช้บอร์ดมันวาวสูง',
    ug: 'يورۇق تاختا تەتۈرلەشكە چەك قويۇلدى',
    vi: 'Tấm gỗ có bề mặt sáng không được đảo ngược',
    zh_tc: '高光板禁止翻板',
    ru: 'Высокоскоростные панели запрещены',
    ko: '고광판 뒤집기 금지.',
    bur: 'မြင့်မားသောဝင်းပတ်ပေါ်ဒ်ပြောင်းဘက်တားမြစ်',
    ben: 'গ্লসি বোর্ড উল্টানো নিষিদ্ধ',
    tr: 'Parlak levhaların çevrilmesi yasaktır',
    km: 'ផ្ទាំងរលោងហាមមិនឱ្យបញ្ច្រាស',
    es: 'Está prohibido voltear la placa resaltada',
    ar: 'لوحة التمييز ممنوعة من الانقلاب',
  },
  'arrangedPage.lockDeleteErr': {
    zh: '板件被锁定，无法删除',
    en: 'Plank is locked and cannot be deleted',
    id: 'Piring terkunci dan tidak dapat dihapus',
    kz: 'Плақтар құлыпталған, оларды жою мүмкін емес',
    th: 'แผ่นถูกล็อคและไม่สามารถลบได้',
    ug: 'تاختا بۆلەك قۇلۇپلانغان، ئۆچۈرۈشكە بولمايدۇ',
    vi: 'Tấm gỗ bị khóa, không thể xóa',
    zh_tc: '板件被鎖定，無法刪除',
    ru: 'Панель заблокирована и не может быть удалена',
    ko: '보드가 잠겨서 삭제할 수 없습니다.',
    bur: 'ပေါ်ဒ်ကိုလော့ပိတ်ထားသဖြင့်ဖျက်မနိုင်',
    ben: 'বোর্ড লক করা আছে, মুছা যাবে না',
    tr: 'Levha kilitli; silinemez',
    km: 'ផ្ទាំងចាក់សោ មិនអាចលុប',
    es: 'La placa está bloqueada y no se puede eliminar',
    ar: 'اللوحة مقفلة ولا يمكن حذفها',
  },
  'arrangedPage.deleteConfirmTip': {
    zh: '删除操作不可恢复',
    en: 'Deletion operation cannot be undone',
    id: 'Hapus operasi tidak dipulihkan',
    kz: 'Жою операциясы қайтарымсыз емес',
    th: 'การลบการดำเนินการจะไม่ถูกกู้คืน',
    ug: 'ئۆچۈرۈش ھەرىكىتىنى قايتۇرۇشقا بولمايدۇ',
    vi: 'Thao tác xóa không thể khôi phục',
    zh_tc: '刪除操作不可恢復',
    ru: 'Операция удаления не может быть восстановлена',
    ko: '삭제 작업을 복구할 수 없습니다.',
    bur: 'ဖျက်ဆီးမှုလုပ်ဆောင်ချက်ပြန်ရမည်မဟုတ်',
    ben: 'মুছার অপারেশন পুনরুদ্ধার করা যাবে না',
    tr: 'Silme işlemi geri alınamaz',
    km: 'ប្រតិបត្តិការលុបមិនអាចស្ដារឡើងវិញ',
    es: 'La operación de eliminación no se puede recuperar',
    ar: 'لا يمكن استرداد عملية الحذف',
  },
  'arrangedPage.deleteContinueTip': {
    zh: '你还要继续吗？',
    en: 'Do you want to continue?',
    id: 'Apakah Anda ingin melanjutkan?',
    kz: 'Сіз жалғасаңыз ба?',
    th: 'คุณต้องการดำเนินการต่อหรือไม่?',
    ug: 'تېخىمۇ داۋاملاشتۇرامسىز؟',
    vi: 'Bạn có muốn tiếp tục không?',
    zh_tc: '你還要繼續嗎？',
    ru: 'Ты продолжаешь?',
    ko: '계속 할 거야?',
    bur: 'ဆက်လုပ်မည်လား?',
    ben: 'চালিয়ে যেতে চান?',
    tr: 'Devam etmek istiyor musunuz?',
    km: 'តើចង់បន្តទៀតទេ?',
    es: '¿Quieres continuar?',
    ar: 'هل تريد المتابعة؟',
  },
  'arrangedPage.deleteConfirm': {
    zh: '请确认是否删除',
    en: 'Please confirm deletion',
    id: 'Harap konfirmasi apakah akan menghapus',
    kz: 'Жоюды растау қажет',
    th: 'โปรดยืนยันว่าจะลบหรือไม่',
    ug: 'ئۆچۈرۈشنى جازالامسىز؟',
    vi: 'Vui lòng xác nhận xóa',
    zh_tc: '請確認是否刪除',
    ru: 'Подтвердите удаление',
    ko: '삭제 여부를 확인하십시오.',
    bur: 'ဖျက်ဆီးမည်ကိုအတည်ပြုပါ',
    ben: 'মুছা নিশ্চিত করুন',
    tr: 'Silmeyi onaylayın',
    km: 'សូមបញ្ជាក់ការលុប',
    es: 'Confirme si desea eliminar',
    ar: 'يرجى تأكيد ما إذا كنت تريد الحذف',
  },
  'arrangedPage.selectPlankTip': {
    zh: '请先选中板件再进行此操作',
    en: 'Please select plank before performing this operation',
    id: 'Pilih papan terlebih dahulu sebelum melakukan operasi ini',
    kz: 'Плақтарды таңдаңыз және осы әрекетті орындаңыз',
    th: 'โปรดเลือกบอร์ดก่อนก่อนดำเนินการนี้',
    ug: 'بۇ مەشغۇلاتنى ئىجرا قىلىش ئۈچۈن ئاۋۋال تاختا بۆلەكنى تاللاڭ',
    vi: 'Vui lòng chọn tấm gỗ trước khi tiến hành thao tác này',
    zh_tc: '請先選中板件再進行此操作',
    ru: 'Пожалуйста, выберите панель для этой операции.',
    ko: '이 작업을 수행하려면 먼저 위젯을 선택하십시오.',
    bur: 'ဤလုပ်ဆောင်မှုမပြုမီ ပေါ်ဒ်ကိုဦးစွာရွေးပါ',
    ben: 'এই অপারেশনের আগে প্রথমে বোর্ড নির্বাচন করুন',
    tr: 'Bu işlemden önce levha seçin',
    km: 'សូមជ្រើសរើសផ្ទាំងមុនប្រតិបត្តិការនេះ',
    es: 'Seleccione la placa antes de realizar esta operación',
    ar: 'يرجى تحديد اللوحة قبل إجراء هذه العملية',
  },
  'arrangedPage.storeFailTip': {
    zh: '余料入库失败！请检查是否有板件重叠或板件在大板外',
    en: 'Surplus storage failed! Please check if there is overlap between planks or if the planks are outside the large plank',
    id: 'Bahan yang tersisa gagal memasuki gudang! Silakan periksa apakah pelat yang tumpang tindih atau pelat berada di luar pelat besar',
    kz: 'Қалдықтарды кестеу сәтсіз! Плақтардың бірінше көліңіз жақты олтандықта немесе плақтардың шеттерін тексеріңіз',
    th: 'วัสดุที่เหลือไม่สามารถเข้าคลังสินค้าได้! โปรดตรวจสอบว่าแผ่นซ้อนทับกันหรือแผ่นอยู่ด้านนอกแผ่นขนาดใหญ่',
    ug: 'قالدۇق ماتېرىياللارنى ئامبارغا ساقلاش مەغلۇپ بولدى! تاختا بۆلەكلىرىنىڭ ئۈستىمە-ئۈستىمە ياكى چوڭ تاختىدىن چىقىپ كەتكەنلىكىنى تەكشۈرۈڭ',
    vi: 'Nhập kho dư liệu thất bại! Vui lòng kiểm tra xem có tấm gỗ chồng lên nhau hoặc nằm ngoài tấm lớn không',
    zh_tc: '餘料入庫失敗！請檢查是否有板件重疊或板件在大板外',
    ru: 'Сбор остатков не удался! Пожалуйста, проверьте, есть ли накладки или панели снаружи.',
    ko: '남은 재료 입고 실패!판재가 중첩되거나 판재가 큰 판 밖에 있는지 확인하십시오',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်သွင်းမှုမအောင်မြင်! ပေါ်ဒ်ထပ်နေသည် သို့မဟုတ် ပေါ်ဒ်ကြီးပြင်ပတွင်ရှိနေသည်ကိုစစ်ဆေးပါ',
    ben: 'উদ্বৃত্ত গুদামে রাখা ব্যর্থ! বোর্ড ওভারল্যাপ বা বোর্ড বড় বোর্ডের বাইরে আছে কিনা পরীক্ষা করুন',
    tr: 'Artık depoya alınamadı! Çakışma veya levhanın büyük levha dışında olup olmadığını kontrol edin',
    km: 'សម្ភារៈសល់រក្សាឃ្លាំងមិនបានជោគជ័យ! ពិនិត្យជាន់គ្នា ឬនៅក្រៅផ្ទាំងធំ',
    es: '¡Falló el almacenamiento del material restante! Compruebe si hay paneles superpuestos o paneles fuera del panel grande',
    ar: 'فشل تخزين المواد المتبقية! يرجى التحقق مما إذا كانت هناك ألواح أو ألواح متداخلة خارج اللوحة الكبيرة',
  },
  'arrangedPage.repeatStoreErr': {
    zh: '当前裁剪的余料板件已经进行过入库',
    en: 'The current surplus plank has been stored before',
    id: 'Pelat material residu yang saat ini dipotong telah dimasukkan ke dalam gudang',
    kz: 'Ағымдағы кесілген қалдық плақтар алдында кестелген',
    th: 'แผ่นวัสดุที่เหลืออยู่ในปัจจุบันได้ถูกนำไปใส่ในคลังสินค้า',
    ug: 'نۆۋەتتىكى كېسىلگەن قالدۇق ماتېرىيال تاختا بۆلەك ئامبارغا ساقلانغان',
    vi: 'Tấm dư liệu cắt hiện tại đã được nhập kho',
    zh_tc: '當前裁剪的餘料板件已經進行過入庫',
    ru: 'В настоящее время вырезанные остатки уже находятся на складе.',
    ko: '현재 트림된 나머지 원단은 이미 입고되었다',
    bur: 'လက်ရှိဖြတ်ထားသောပိုလျှံပစ္စည်းပေါ်ဒ်ကိုဂိုဒေါင်သွင်းပြီးသားဖြစ်သည်',
    ben: 'বর্তমানে কাটা উদ্বৃত্ত বোর্ড ইতিমধ্যে গুদামে রাখা হয়েছে',
    tr: 'Bu kesilen artık levha zaten depoya alınmış',
    km: 'ផ្ទាំងសល់ដែលកាត់ហើយបានរក្សាឃ្លាំងរួចហើយ',
    es: 'Los paneles de material restante actualmente cortados se han almacenado',
    ar: 'تم وضع ألواح المواد المتبقية المقطوعة حاليًا في التخزين',
  },
  'arrangedPage.surplusStoreFail': {
    zh: '入库失败, 请检查板件是否为矩形或L形板件!',
    en: 'Storage failed, please check if the plank is rectangular or L-shaped!',
    id: 'Jika penyimpanan gagal, silakan periksa apakah pelatnya persegi panjang atau piring berbentuk L!',
    kz: 'Кестеу сәтсіз! Плақтардың түрі және L-формасын тексеріңіз!',
    th: 'หากการจัดเก็บล้มเหลวโปรดตรวจสอบว่าจานเป็นแผ่นรูปสี่เหลี่ยมผืนผ้าหรือรูปตัว L!',
    ug: 'ئامبارغا ساقلاش مەغلۇپ بولدى, تاختا بۆلەك تۆت تەرەپلىك ياكى L شەكىللىك تاختا ئەمەسلىكىنى تەكشۈرۈڭ!',
    vi: 'Nhập kho thất bại, vui lòng kiểm tra xem tấm gỗ có hình chữ nhật hoặc chữ L không!',
    zh_tc: '入庫失敗, 請檢查板件是否為矩形或L形板件!',
    ru: 'Ошибка входа в хранилище, проверьте, является ли элемент панели прямоугольным или L - образным!',
    ko: '입고 실패. 보드가 직사각형 또는 L 보드인지 확인하십시오!',
    bur: 'ဂိုဒေါင်သွင်းမှုမအောင်မြင်၊ ပေါ်ဒ်သည်တစ်ထောင့်မှန် သို့မဟုတ် L ပုံဖြစ်မဖြစ်စစ်ဆေးပါ!',
    ben: 'গুদামে রাখা ব্যর্থ, বোর্ড আয়তক্ষেত্রাকার বা L-আকৃতির কিনা পরীক্ষা করুন!',
    tr: 'Depoya alınamadı; levhaların dikdörtgen veya L şeklinde olduğunu kontrol edin',
    km: 'រក្សាឃ្លាំងមិនបានជោគជ័យ សូមពិនិត្យផ្ទាំងជាចតុកោណ ឬរូបរាងL',
    es: '¡Falló el almacenamiento, verifique si los paneles son rectangulares o con forma L!',
    ar: 'فشل التخزين، يرجى التحقق مما إذا كانت الألواح مستطيلة أو ألواح على شكل L!',
  },
  'arrangedPage.plankConfilictErr': {
    zh: '不支持在此处放置点位,将会和其他板件产生冲突',
    en: 'Cannot place points here, will conflict with other planks',
    id: 'Itu tidak didukung untuk menempatkan poin di sini, yang akan bertentangan dengan piring lain.',
    kz: 'Осы ауданға бағанышты орнатуға қолдау көрсетілмейді, ол тағы да плақтармен қайшылық пайдалайды',
    th: 'ไม่ได้รับการสนับสนุนให้วางจุดที่นี่ซึ่งจะขัดแย้งกับแผ่นอื่น ๆ',
    ug: 'بۇ نۇقتىغا قويۇشقا بولمايدۇ, باشقا تاختا بۆلەكلەر بىلەن توقۇنۇشۇپ كېتىدۇ',
    vi: 'Không hỗ trợ đặt điểm ở đây, sẽ gây xung đột với các tấm gỗ khác',
    zh_tc: '不支持在此處放置點位,將會和其他板件產生衝突',
    ru: 'Не поддерживается размещение точек здесь, это будет противоречить другим панелям',
    ko: '여기에 점을 배치하는 것은 지원되지 않으며 다른 보드와 충돌할 수 있습니다.',
    bur: 'ဤနေရာတွင်ချနိုင်မည်မဟုတ်ပါ၊ အခြားပေါ်ဒ်များနှင့်ပဋိပက္ခဖြစ်မည်',
    ben: 'এখানে পয়েন্ট স্থাপন সমর্থিত নয়, অন্য বোর্ডের সাথে সংঘাত হবে',
    tr: 'Bu konuma nokta konulamaz; diğer levhalarla çakışır',
    km: 'មិនគាំទ្រដាក់ចំណុចនៅទីនេះ នឹងប៉ះទង្គិចផ្ទាំងផ្សេង',
    es: 'No se admite la colocación de puntos aquí y entrará en conflicto con otros paneles',
    ar: 'وضع النقاط هنا غير مدعوم وسيتعارض مع اللوحات الأخرى',
  },
  'arrangedPage.surplusErrTip': {
    zh: '不支持在此处放置点位,会产生一个错误的余料',
    en: 'Cannot place points here, will produce an incorrect surplus',
    id: 'Tidak didukung untuk menempatkan poin di sini, bahan residu kesalahan akan dihasilkan',
    kz: 'Мұнда нүктелер орнатуға қолдау көрсетілмейді, жарамсыз қалдық жасайды',
    th: 'ไม่ได้รับการสนับสนุนให้วางจุดที่นี่จะมีการสร้างวัสดุที่ตกค้างผิดพลาด',
    ug: 'بۇ نۇقتىغا قويۇشقا بولمايدۇ, خاتا قالدۇق ماتېرىيال ھاسىل قىلىدۇ',
    vi: 'Không hỗ trợ đặt điểm ở đây, sẽ tạo ra dư liệu không đúng',
    zh_tc: '不支持在此處放置點位,會產生一個錯誤的餘料',
    ru: 'Не поддерживается размещение точки здесь, что создает неправильный остаток',
    ko: '여기에 지점을 배치하는 것은 지원되지 않으며 오류가 발생할 수 있습니다.',
    bur: 'ဤနေရာတွင်ချနိုင်မည်မဟုတ်ပါ၊ မမှန်ကန်သောပိုလျှံပစ္စည်းဖန်တီးမည်',
    ben: 'এখানে পয়েন্ট স্থাপন সমর্থিত নয়, একটি ভুল উদ্বৃত্ত তৈরি হবে',
    tr: 'Bu konuma nokta konulamaz; hatalı artık oluşur',
    km: 'មិនគាំទ្រដាក់ចំណុចនៅទីនេះ នឹងបង្កើតសម្ភារៈសល់ខុស',
    es: 'No se admite la colocación de puntos aquí y se producirá un material remanente incorrecto',
    ar: 'وضع النقاط هنا غير مدعوم وسينتج عنه مادة متبقية غير صحيحة',
  },
  'arrangedPage.changeArrageSuccess': {
    zh: '成功切换排版方案',
    en: 'Successfully switched layout scheme',
    id: 'Beralih Skema Tata Letak dengan sukses',
    kz: 'Аспапты өзгерту сәтті',
    th: 'เปลี่ยนรูปแบบเค้าโครงสำเร็จ',
    ug: 'تەرتىپلەش پىلانىنى مۇۋەپپەقىيەتلىك ئالماشتۇردى',
    vi: 'Bố cục thành công',
    zh_tc: '成功切換排版方案',
    ru: 'Успешное переключение программы',
    ko: '레이아웃 스키마를 성공적으로 전환했습니다.',
    bur: 'ပြင်ဆင်မှုစီမံချက်ပြောင်းလဲမှုအောင်မြင်',
    ben: 'লেআউট পরিকল্পনা সফলভাবে পরিবর্তিত হয়েছে',
    tr: 'Yerleşim şeması başarıyla değiştirildi',
    km: 'ប្ដូរផែនការរៀបចំបានជោគជ័យ',
    es: 'Se cambió con éxito el esquema de diseño',
    ar: 'تم تبديل مخطط التخطيط بنجاح',
  },
  'arrangedPage.trialProduction.trialProductionSample': {
    zh: '试生产样品柜',
    en: 'Trial production sample cabinet',
    id: 'Kabinet sampel produksi percobaan',
    kz: 'Өндіріс алдындағы сынамалар шкафы',
    th: 'ตู้เก็บตัวอย่างทดลองใช้',
    ug: 'سىناقلىق ئىشلەپچىقىرىش قابىسى',
    vi: 'Thử nghiệm mẫu tủ',
    zh_tc: '試生產樣品櫃',
    ru: 'Шкаф пробного производства',
    ko: '시제품 견본함',
    bur: 'စမ်းသပ်ထုတ်လုပ်မှုနမူနာဗိုင်တိုက်',
    ben: 'পরীক্ষামূলক উৎপাদন নমুনা ক্যাবিনেট',
    tr: 'Deneme üretim örnek dolabı',
    km: 'ទូគំរូផលិតកម្មសាកល្បង',
    es: 'Gabinete de muestras de producción de prueba',
    ar: 'خزانة عينة الإنتاج التجريبي',
  },
  'arrangedPage.trialProduction.trialProduced': {
    zh: '我已试生产',
    en: 'I have tried production',
    id: 'Saya sudah mencoba produksi',
    kz: 'Сынақ өндірісін жүргіздім',
    th: 'ฉันได้ลองผลิต',
    ug: 'مەن سىناقلىق ئىشلەپچىقاردىم',
    vi: 'Tôi đã thử nghiệm sản xuất',
    zh_tc: '我已試生產',
    ru: 'Я попробовал производство.',
    ko: '나는 이미 시험 생산을 했다',
    bur: 'ကျွန်ုပ်စမ်းသပ်ထုတ်လုပ်ပြီး',
    ben: 'আমি পরীক্ষামূলক উৎপাদন করেছি',
    tr: 'Deneme üretim yaptım',
    km: 'ខ្ញុំបានសាកល្បងផលិត',
    es: 'He probado la producción',
    ar: 'لقد حاولت الإنتاج',
  },
  'arrangedPage.trialProduction.trialWarning': {
    zh: '{fontStyleStart}若{fontStyleEnd}因您未进行样品柜的生产验证，而造成对自身、他人及云排版软件的全部损失与不利后果将由您个人承担全部责任',
    en: '{fontStyleStart}If{fontStyleEnd} due to your failure to verify the production of the sample cabinet, all losses and adverse consequences to yourself, others and cloud typesetting software will be borne by you personally',
    id: '{fontStyleStart}Jika{fontStyleEnd} Anda gagal melakukan verifikasi produksi kabinet sampel, semua kerugian dan konsekuensi yang merugikan bagi diri Anda sendiri, orang lain dan perangkat lunak tata letak cloud akan ditanggung oleh Anda sendiri',
    kz: '{fontStyleStart}Егер{fontStyleEnd} сіз өзіңізге, басқаларға және үлгі шкафтың өндірісін тексермеуіңізден туындаған бұлтты теру бағдарламалық жасақтамасына барлық шығындар мен қолайсыз салдарлар үшін ғана жауап бересіз',
    th: '{fontStyleStart}ถ้า{fontStyleEnd}คุณล้มเหลวในการตรวจสอบการผลิตของตู้ตัวอย่าง คุณจะแบกรับความสูญเสียและผลกระทบที่ไม่พึงประสงค์ทั้งหมดต่อตัวคุณเองอื่น ๆ และซอฟต์แวร์เลย์เอาต์คลาวด์',
    ug: 'سىناقلىق قابا ئىشلەپچىقىرىپ تەكشۈرمىگەنلىكىڭىز سەۋەبىدىن سىزگە، باشقىلارغا ۋە بۇلۇت تەرتىپلەش يۇمشاق دېتالىغا كەلتۈرۈلگەن بارلىق زىيان ۋە يارامسىز ئەھۋاللارغا سىز شەخسىي جىددىي جاۋابكار بولىسىز',
    vi: '{fontStyleStart}Nếu{fontStyleEnd} bạn không làm mẫu tủ sản xuất xác nhận, và gây ra cho bản thân mình, những người khác và phần mềm phân loại đám mây tất cả thiệt hại và hậu quả bất lợi của phần mềm sẽ là cá nhân của bạn chịu đầy đủ trách nhiệm',
    zh_tc:
      '{fontStyleStart}若{fontStyleEnd}因您未進行樣品櫃的生產驗證，而造成對自身、他人及雲排版軟件的全部損失與不利後果將由您個人承擔全部責任',
    ru: '{fontStyleStart}Если{fontStyleEnd} вы не прошли проверку производства шкафа для образцов, вы несете личную ответственность за все потери и неблагоприятные последствия для себя, других лиц и облачного программного обеспечения',
    ko: '{fontStyleStart}만약{fontStyleEnd} 견본 캐비닛의 생산 검증을 하지 않았기 때문에 자신, 타인 및 클라우드 조판 소프트웨어에 대한 모든 손실과 불리한 결과는 귀하 개인이 모든 책임을 집니다.',
    bur: '{fontStyleStart}အကယ်၍{fontStyleEnd} သင်သည် နမူနာစင်္ကြံအတွက် ထုတ်လုပ်မှု အတည်ပြုချက်ပြုလုပ်ခြင်းကို မပြုလုပ်ခြင်းကြောင့် သင်ကိုယ်တိုင်၊ တခြားသူများနှင့် တိမ်သား တိုက်ချက်ဆော့ဖ်ဝဲတို့အပေါ် ကျန်ရစ်သော အကျိုးဆိုမှုနှင့် မကောင်းသောဆိုးကျိုးအားလုံးအတွက် တာဝန်သည် သင်ကိုယ်တိုင်မှ သာလျှင် အပြည့်အဝ ရှိပါသည်။',
    ben: '{fontStyleStart}যদি{fontStyleEnd} আপনি নমুনা ক্যাবিনেটের উৎপাদন যাচাইকরণ না করার কারণে নিজের, অন্যদের এবং ক্লাউড টাইপসেটিং সফটওয়্যারের জন্য যেকোনো ক্ষতি ও প্রতিকূল পরিণতি ঘটে, তার সমস্ত দায়ভার আপনাকে ব্যক্তিগতভাবে বহন করতে হবে।',
    tr: '{fontStyleStart}Eğer{fontStyleEnd} örnek dolap üretim doğrulamasını yapmamanız nedeniyle kendiniz, başkaları ve bulut dizgi yazılımı üzerinde doğan tüm zarar ve olumsuz sonuçların sorumluluğu tamamen şahsen size aittir.',
    km: '{fontStyleStart}ប្រសិនបើ{fontStyleEnd} អ្នកមិនបានអនុវត្តការផ្ទៀងផ្ទាត់ការផលិតទូគំរូ ដែលបណ្តាលឱ្យមានការខាតបង់ទាំងអស់ និងផលអវិជ្ជមានចំពោះខ្លួនអ្នក អ្នកដទៃ និងសុហ្វវែររៀបចំពុម្ពអក្សរពពក ទំនួលខានុស័យទាំងមូលគឺជារបស់អ្នកផ្ទាល់។',
    es: '{fontStyleStart}Si {fontStyleEnd} no realiza la verificación de producción del gabinete de muestras, será el único responsable de todas las pérdidas y consecuencias adversas para usted, otros y el software de publicación en la nube',
    ar: '{fontStyleStart}إذا فشلت {fontStyleEnd} في إجراء التحقق من إنتاج خزانة العينة، فستكون وحدك المسؤول عن جميع الخسائر والعواقب الضارة التي تلحق بنفسك، الآخرين وبرامج النشر السحابي',
  },
  'arrangedPage.trialProduction.trialSlotTip': {
    zh: '试生产时请仔细检测正反面孔槽的大小、深度、所在面、以及所在位置是否正确',
    en: 'Please carefully check the size, depth, location, and position of the holes and grooves on both sides during trial production to ensure they are correct',
    id: 'Selama produksi uji coba, silakan periksa apakah ukuran, kedalaman, permukaan, dan lokasi slot wajah depan dan belakang sudah benar.',
    kz: 'Түнімдеу жүктелгенде, түрлі қатынау жолағындағы таспа шараптарының өлшемін, ұзындығын, орналасқан жақтарын және орналасқан жерін тексеріңіз',
    th: 'ในระหว่างการผลิตทดลองโปรดตรวจสอบอย่างระมัดระวังว่าขนาดความลึกพื้นผิวและที่ตั้งของช่องด้านหน้าและด้านหลังนั้นถูกต้องหรือไม่',
    ug: 'سىناقلىق ئىشلەپچىقىرىشتا ئالدىنقى-ئارقا تەرەپ تېشىك/ئويۇق چوڭ-كىچىكلىكى، چوڭقۇرلۇقى، ئورنى ۋە ئورۇنلاشقان تەرەپنى ئىنچىكە تەكشۈرۈڭ،',
    vi: 'Khi sản xuất thử, hãy kiểm tra cẩn thận kích thước, độ sâu, vị trí và vị trí của khe cắm khuôn mặt chính xác',
    zh_tc:
      '試生產時請仔細檢測正反面孔槽的大小、深度、所在面、以及所在位置是否正確',
    ru: 'При пробном производстве тщательно проверьте размер, глубину, расположение и правильное расположение канавки с положительным и отрицательным отверстиями',
    ko: '프로덕션 시 정반대면 슬롯의 크기, 깊이, 면 및 위치가 올바른지 확인합니다',
    bur: 'စမ်းသပ်ထုတ်လုပ်ချိန်ရှေ့နောက်မျက်နှာပေါက်ကြိုးအရွယ်၊ နက်မှု၊ မျက်နှာနှင့်တည်နေရာမမှန်ကန်မှုစစ်ဆေးပါ',
    ben: 'পরীক্ষামূলক উৎপাদনে সামনে ও পিছনের গর্ত-স্লটের আকার, গভীরতা, অবস্থান সঠিক কিনা যাচাই করুন',
    tr: 'Deneme üretimde ön ve arka yüzdeki delik/oluk boyutunu, derinliğini, hangi yüzde ve konumunu dikkatlice kontrol edin',
    km: 'នៅពេលផលិតសាកល្បង សូមពិនិត្យយ៉ាងប្រុងប្រយ័ត្នទំហំ ជម្រៅ ផ្ទៃ និងតំណែងរណ្តៅ/រន្ធមុខនិងក្រោយ',
    es: 'Durante la producción de prueba, verifique cuidadosamente si el tamaño, la profundidad, la superficie y la ubicación de las ranuras frontal y posterior son correctos',
    ar: 'أثناء الإنتاج التجريبي، يرجى التحقق بعناية مما إذا كان حجم الفتحات الأمامية والخلفية وعمقها وسطحها وموقعها صحيحًا',
  },
  'arrangedPage.trialProduction.trialSlotTip1': {
    zh: '避免出现柜体镜像',
    en: 'avoid cabinet mirroring',
    id: 'Hindari mirroring kabinet',
    kz: 'қабыздың түрлі түндетуін қалайп жатқызу',
    th: 'หลีกเลี่ยงการมิเรอร์ของตู้',
    ug: 'قابا سۈرەتنىڭ ئەكس ئەھۋالىدىن ساقلىنىڭ',
    vi: 'tránh gương nội các',
    zh_tc: '避免出現櫃體鏡像',
    ru: 'Избегайте зеркального отражения шкафа.',
    ko: '캐비닛 미러링 방지',
    bur: 'ဗိုင်ပုံကြောင်းပျောက်ကြောင်းမဖြစ်ရ',
    ben: 'ক্যাবিনেট মিরর ইমেজ এড়িয়ে চলুন',
    tr: 'dolap ayna görüntüsünü önleyin',
    km: 'ជៀសវាងរូបឆ្លុះទូ',
    es: 'para evitar la duplicación del gabinete',
    ar: 'لتجنب انعكاس الخزانة',
  },
  'arrangedPage.trialProduction.trialSlotTip2': {
    zh: '的问题',
    en: 'problem',
    id: 'Masalahnya',
    kz: 'Сұрақ',
    th: 'ปัญหา',
    ug: 'مەسىلىسى',
    vi: 'câu hỏi',
    zh_tc: '的問題',
    ru: 'Вопрос',
    ko: '의 문제',
    bur: 'ပြဿနာ',
    ben: 'সমস্যা',
    tr: 'sorunu',
    km: 'បញ្ហា',
    es: 'pregunta',
    ar: 'سؤال',
  },
  'arrangedPage.trialProduction.pleaseUploadTrial': {
    zh: '请上传组装好后的试生产样品柜照片',
    en: 'Please upload the photo of the assembled sample cabinet for trial production',
    id: 'Harap unggah foto kabinet sampel produksi percobaan yang dirakit',
    kz: 'Құрастырылған прототип шкафының суретін кері жүктеуіңізді сұраймын',
    th: 'กรุณาอัปโหลดรูปภาพของคณะรัฐมนตรีตัวอย่างการผลิตทดลองประกอบ',
    ug: 'سىناقلىق ئىشلەپچىقىرىلغان قابا رەسىمىنى يۈكلەڭ',
    vi: 'Xin vui lòng tải lên hình ảnh thử nghiệm sau khi lắp ráp ',
    zh_tc: '請上傳組裝好後的試生產樣品櫃照片',
    ru: 'Пожалуйста, загрузите фотографии из шкафа для пробных образцов после сборки.',
    ko: '조립된 시제품 견본함 사진 올려주세요.',
    bur: 'တပ်ဆင်ပြီးသောစမ်းသပ်ထုတ်လုပ်မှုနမူနာဗိုင်ဓာတ်ပုံတင်ပါ',
    ben: 'একত্রিত নমুনা ক্যাবিনেটের ছবি আপলোড করুন',
    tr: 'Monte edilmiş deneme üretim örnek dolabının fotoğrafını yükleyin',
    km: 'សូមផ្ទុករូបភាពទូគំរូសាកល្បងបន្ទាប់ពីដំឡើងរួច',
    es: 'Cargue fotos del gabinete de muestra de producción de prueba ensamblado',
    ar: 'يرجى تحميل صور لخزانة عينة الإنتاج التجريبي المجمعة',
  },
  'arrangedPage.trialProduction.uploadTrial': {
    zh: '上传样品柜',
    en: 'Upload sample cabinet',
    id: 'Unggah Kabinet Sampel',
    kz: 'Үлгі шкафын кері жүктеу',
    th: 'อัพโหลดตัวอย่างตู้',
    ug: 'قابا رەسىمىنى يۈكلەش',
    vi: 'Tải lên mẫu tủ',
    zh_tc: '上傳樣品櫃',
    ru: 'Загрузить шкаф для образцов',
    ko: '샘플 캐비닛 업로드',
    bur: 'နမူနာဗိုင်တင်ဆောင်',
    ben: 'নমুনা ক্যাবিনেট আপলোড করুন',
    tr: 'Örnek dolabı yükle',
    km: 'ផ្ទុកទូគំរូ',
    es: 'Cargue gabinete de muestra',
    ar: 'تحميل خزانة العينة',
  },
  'arrangedPage.awaitPlankStore.store': {
    zh: '板件待排板库',
    en: 'Board warehouse',
    id: 'Bagian papan yang akan diatur di Perpustakaan Dewan',
    kz: 'Тақтайшалар тақтай қоймасында орналасуға тиіс',
    th: 'ชิ้นส่วนบอร์ดที่จะจัดในห้องสมุดบอร์ด',
    ug: 'تاختا بۆلەك ساقلىغۇچى',
    vi: 'Hội đồng quản trị bảng xếp hàng',
    zh_tc: '板件待排板庫',
    ru: 'хранилище листовых материалов',
    ko: '판재 대기열 판고',
    bur: 'ပေါ်ဒ်ပြင်ဆင်ရန်ကြိုဆိုင်ဒေတာဘင်',
    ben: 'বোর্ড লেআউটের অপেক্ষায় গুদাম',
    tr: 'Levha sıra bekleme ambarı',
    km: 'ឃ្លាំងផ្ទាំងរង់ចាំរៀបចំ',
    es: 'Biblioteca de paneles para diseño',
    ar: 'مكتبة اللوحات للتخطيط',
  },
  'arrangedPage.awaitPlankStore.notTip': {
    zh: '不再提示未入库',
    en: 'No longer indicates that it is not in the library',
    id: 'Tidak ada lagi yang diminta yang belum dimasukkan',
    kz: 'Сақтауға қойылмағанын енді талап етпейді',
    th: 'ไม่มีการแจ้งเตือนอีกต่อไปว่ายังไม่ได้ป้อน',
    ug: 'ئامبارغا ساقلانمىغانلىقىنى كۆرسەتمە',
    vi: 'Không còn nhắc đến việc không được đưa vào kho',
    zh_tc: '不再提示未入庫',
    ru: 'Больше не напоминать о незарегистрированном',
    ko: '입고되지 않았다는 메시지가 표시되지 않음',
    bur: 'ဂိုဒေါင်မသွင်းရသေးကြောင်းမပြတော့',
    ben: 'গুদামে রাখা হয়নি বলে আর প্রম্পট করবে না',
    tr: 'Depoya alınmadı uyarısını bir daha gösterme',
    km: 'កុំរៀបរាប់ទៀតពីមិនទាន់រក្សាឃ្លាំង',
    es: 'No más mensajes por no estar en stock',
    ar: 'لا توجد مطالبات أخرى بعدم تخزينها',
  },
  'arrangedPage.awaitPlankStore.justLookCurrent': {
    zh: '仅看当前订单小板',
    en: 'Just look at the current order small board',
    id: 'Hanya lihat papan pesanan saat ini',
    kz: 'Тек ағымдағы тапсырыс тақтасын қарап шығыңыз',
    th: 'ดูเฉพาะบอร์ดคำสั่งซื้อปัจจุบัน',
    ug: 'پەقەت نۆۋەتتىكى زاكاز كىچىك تاختىنى كۆرسەت',
    vi: 'Chỉ nhìn vào bảng đặt hàng hiện thời',
    zh_tc: '僅看當前訂單小板',
    ru: 'Смотреть только текущий заказ',
    ko: '현재 주문 보드만 보기',
    bur: 'လက်ရှိမှာယူမှုပေါ်ဒ်ငယ်သာကြည့်',
    ben: 'শুধুমাত্র বর্তমান অর্ডারের ছোট বোর্ড দেখুন',
    tr: 'Yalnızca geçerli sipariş küçük levhaları',
    km: 'មើលតែផ្ទាំងតូចនៃការបញ្ជាទិញបច្ចុប្បន្ន',
    es: 'Solo vea los paneles pequeños del pedido actual',
    ar: 'عرض اللوحات الصغيرة بالطلب الحالي فقط',
  },
  'arrangedPage.awaitPlankStore.notInPushStorage': {
    zh: '未入库',
    en: 'Not put in storage',
    id: 'Tidak termasuk dalam gudang',
    kz: 'Қордаланбаған',
    th: 'ไม่รวมอยู่ในคลังสินค้า',
    ug: 'ئامبارغا ساقلانمىغان',
    vi: 'Không có trong kho',
    zh_tc: '未入庫',
    ru: 'Не на складе',
    ko: '입고되지 않음',
    bur: 'ဂိုဒေါင်မသွင်းရသေး',
    ben: 'গুদামে রাখা হয়নি',
    tr: 'Depoda değil',
    km: 'មិនទាន់រក្សាឃ្លាំង',
    es: 'No disponible',
    ar: 'لم يتم وضعها في المخزون',
  },
  'arrangedPage.awaitPlankStore.beInStorage': {
    zh: '已入库',
    en: 'Be in storage',
    id: 'Telah dimasukkan ke dalam gudang',
    kz: 'Қоймалау',
    th: 'ได้ถูกนำไปใส่ในคลังสินค้า',
    ug: 'ئامبارغا ساقلانغان',
    vi: 'Đã được lưu trữ',
    zh_tc: '已入庫',
    ru: 'На складе',
    ko: '입고 완료',
    bur: 'ဂိုဒေါင်သွင်းပြီး',
    ben: 'গুদামে রাখা হয়েছে',
    tr: 'Depoda',
    km: 'រក្សាទុកឃ្លាំងហើយ',
    es: 'Ya almacenado',
    ar: 'مخزنة بالفعل',
  },
  'arrangedPage.awaitPlankStore.searchPlaceholder': {
    zh: '输入订单搜索待排版库小板',
    en: 'Enter an order to search the library panel',
    id: 'Masukkan pesanan untuk mencari papan kecil dari perpustakaan yang berkepentingan',
    kz: 'Түрге жататын кітапхана тақтасын іздеу үшін тапсырыс пішінін енгізіңіз',
    th: 'ป้อนคำสั่งซื้อเพื่อค้นหาบอร์ดขนาดเล็กของห้องสมุด TO-type',
    ug: 'زاكاز ئىزدەپ تەرتىپلەش ئامبىرىدىكى كىچىك تاختىنى تېپىڭ',
    vi: 'Nhập đơn đặt hàng tìm kiếm các bảng nhỏ để sắp xếp',
    zh_tc: '輸入訂單搜索待排版庫小板',
    ru: 'Введите заказ для поиска в библиотеке',
    ko: '주문을 입력하여 예약된 라이브러리 보드를 검색합니다.',
    bur: 'မှာယူမှုထည့်ပြီးပြင်ဆင်ရန်ကြိုဆိုင်ဒေတာဘင်ပေါ်ဒ်ငယ်ရှာ',
    ben: 'অর্ডার লিখে লেআউট অপেক্ষায় লাইব্রেরির ছোট বোর্ড অনুসন্ধান করুন',
    tr: 'Sipariş girerek sıra bekleme ambarında ara',
    km: 'បញ្ចូលបញ្ជាទិញដើម្បីស្វែងរកផ្ទាំងតូចក្នុងឃ្លាំងរង់ចាំ',
    es: 'Ingrese el orden para buscar paneles pequeños de la biblioteca para escribir',
    ar: 'أدخل طلبًا للبحث عن اللوحات الصغيرة من المكتبة المراد كتابتها',
  },
  'arrangedPage.awaitPlankStore.plankUploading': {
    zh: '板件保存中',
    en: 'The board is saved',
    id: 'Dewan diselamatkan',
    kz: 'Тақтайша сақталуда',
    th: 'กระดานจะถูกบันทึกไว้',
    ug: 'تاختا بۆلەك ساقلانىۋاتىدۇ',
    vi: 'Bảo quản các mảng',
    zh_tc: '板件保存中',
    ru: 'Пластинка сохранена.',
    ko: '보드 저장 중',
    bur: 'ပေါ်ဒ်သိမ်းဆည်းနေသည်',
    ben: 'বোর্ড সংরক্ষণ হচ্ছে',
    tr: 'Levha kaydediliyor',
    km: 'កំពុងរក្សាផ្ទាំង',
    es: 'Los paneles se están guardando',
    ar: 'يتم حفظ اللوحات',
  },
  'arrangedPage.awaitPlankStore.oneClickStorage': {
    zh: '一键存入待排板库',
    en: 'One click to save to the waiting board library',
    id: 'Penyimpanan satu klik untuk diurutkan',
    kz: 'Реттелуі тиіс тақта кітапханасына сақтау орнын бір нұқу',
    th: 'ที่เก็บข้อมูลเดียวที่จะจัดเรียง',
    ug: 'بىر كۇنپۇكا بىلەن تەرتىپلەش ئامبىرىغا ساقلاش',
    vi: 'Một phím được gửi vào kho hàng chờ đợi',
    zh_tc: '一鍵存入待排板庫',
    ru: 'Клавиша для ввода в хранилище',
    ko: '클릭 한 번으로 대기판 라이브러리에 저장',
    bur: 'တစ်ကလစ်ဖြင့်ပြင်ဆင်ရန်ကြိုဆောင်ဒေတာဘင်တွင်သိမ်း',
    ben: 'এক ক্লিকে অপেক্ষামাণ লেআউট লাইব্রেরিতে সংরক্ষণ করুন',
    tr: 'Tek tıkla sıra bekleme ambarına kaydet',
    km: 'ចុចមួយដងរក្សាចូលឃ្លាំងរង់ចាំ',
    es: 'Almacenamiento con un solo clic en la biblioteca para diseño',
    ar: 'تخزين بنقرة واحدة في المكتبة للتخطيط',
  },
  'arrangedPage.awaitPlankStore.notUsePlank': {
    zh: '暂无可用小板',
    en: 'No board available',
    id: 'Tidak ada papan kecil yang tersedia',
    kz: 'Кішкентай тақтайшалар жоқ',
    th: 'ไม่มีบอร์ดขนาดเล็ก',
    ug: 'ھازىرچە ئىشلىتىشكە بولىدىغان كىچىك تاختا يوق',
    vi: 'Không có bảng điều khiển',
    zh_tc: '暫無可用小板',
    ru: 'Нет доступных панелей',
    ko: '사용 가능한 슬레이트 없음',
    bur: 'ယာယီအသုံးပြုနိုင်သောပေါ်ဒ်ငယ်မရှိ',
    ben: 'ব্যবহারযোগ্য কোনো ছোট বোর্ড নেই',
    tr: 'Kullanılabilir küçük levha yok',
    km: 'មិនមានផ្ទាំងតូចដែលប្រើបានជាបណ្តោះអាសន្ន',
    es: 'No hay paneles pequeños disponibles',
    ar: 'لا تتوفر لوحات صغيرة',
  },
  'arrangedPage.awaitPlankStore.notPlank': {
    zh: '无板件暂存',
    en: 'No board is temporarily stored',
    id: 'Bagian tanpa papan disimpan sementara',
    kz: 'Пластинка қойылымының болмауы',
    th: 'ชิ้นส่วนที่ไม่มีบอร์ดจัดเก็บชั่วคราว',
    ug: 'تاختا بۆلەك ساقلانمىغان',
    vi: 'Không có tấm tạm thời lưu trữ',
    zh_tc: '無板件暫存',
    ru: 'Бесплатное временное хранение',
    ko: '보드 없음 임시 저장',
    bur: 'ပေါ်ဒ်ယာယီသိမ်းဆည်းမရှိ',
    ben: 'কোনো বোর্ড অস্থায়ীভাবে সংরক্ষিত নেই',
    tr: 'Geçici levha yok',
    km: 'គ្មានផ្ទាំងផ្ទុកអាចបណ្តោះអាសន្ន',
    es: 'Sin almacenamiento temporal de la placa',
    ar: 'لا يوجد تخزين مؤقت للوحة',
  },
  'arrangedPage.awaitPlankStore.dragPlankInHere': {
    zh: '可将板件拖至此处进行板件暂存',
    en: 'You can drag the board here to temporarily store the board',
    id: 'Anda dapat menyeret pelat di sini untuk penyimpanan pelat sementara',
    kz: 'Тақтайшаларды тақтай қою үшін осында апаруға болады',
    th: 'คุณสามารถลากเพลตได้ที่นี่เพื่อจัดเก็บจานชั่วคราว',
    ug: 'تاختا بۆلەكنى بۇ يەرگە سۆرەپ ساقلىيالايسىز',
    vi: 'Tấm có thể được kéo đến đây để lưu trữ tấm tạm thời',
    zh_tc: '可將板件拖至此處進行板件暫存',
    ru: 'Можно перетащить листы сюда для временного хранения.',
    ko: '슬레이트 보관을 위해 슬레이트를 여기로 끌 수 있습니다.',
    bur: 'ပေါ်ဒ်ကိုဤနေရာသို့ဆွဲဆောင်ပြီးယာယီသိမ်းဆည်းနိုင်',
    ben: 'বোর্ড এখানে টেনে এনে অস্থায়ীভাবে সংরক্ষণ করুন',
    tr: 'Levhaları geçici saklamak için buraya sürükleyin',
    km: 'អូសផ្ទាំងមកទីនេះដើម្បីផ្ទុកជាបណ្តោះអាសន្ន',
    es: 'Puede arrastrar la placa aquí para guardarla temporalmente',
    ar: 'يمكنك سحب اللوحة هنا لحفظ اللوحة مؤقتًا',
  },
  'arrangedPage.awaitPlankStore.surplusCannotBeStorage': {
    zh: '余料不能入库',
    en: 'Surplus materials cannot be stored',
    id: 'Bahan yang tersisa tidak dapat disimpan',
    kz: 'Қалдықтар сақтауға қойыла алмайды',
    th: 'ไม่สามารถเก็บวัสดุที่เหลืออยู่ได้',
    ug: 'قالدۇق ماتېرىياللار ئامبارغا ساقلانمايدۇ',
    vi: 'Dư liệu không thể vào kho',
    zh_tc: '餘料不能入庫',
    ru: 'Остаток нельзя складировать',
    ko: '남은 재료는 입고할 수 없다.',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်သွင်းမနိုင်',
    ben: 'উদ্বৃত্ত উপকরণ গুদামে রাখা যাবে না',
    tr: 'Artık malzeme depoya alınamaz',
    km: 'សម្ភារៈសល់មិនអាចរក្សាឃ្លាំង',
    es: 'Los materiales restantes no se pueden poner en el almacén',
    ar: 'لا يمكن وضع المواد المتبقية في المستودع',
  },
  'arrangedPage.awaitPlankStore.plankHasBeenDeduction': {
    zh: '小板已被扣减或不存在原始数据，无法入库',
    en: 'The small board has been reduced or there is no original data, can not be stored',
    id: 'Dewan telah dikurangkan atau tidak ada data asli dan tidak dapat disimpan dalam database.',
    kz: 'Шағын тақта шегерілді немесе бастапқы деректер жоқ және қоймада сақтала алмайды',
    th: 'บอร์ดได้ถูกหักออกหรือไม่มีข้อมูลต้นฉบับและไม่สามารถเก็บไว้ในฐานข้อมูล',
    ug: 'كىچىك تاختا چىقىرىۋېتىلگەن ياكى ئەسلى سانلىق مەلۇماتى يوق، ئامبارغا ساقلاش مۇمكىن ئەمەس',
    vi: 'Bảng nhỏ đã được rút hoặc không có dữ liệu thô, không thể được lưu trữ',
    zh_tc: '小板已被扣減或不存在原始數據，無法入庫',
    ru: 'Скрыты или отсутствуют исходные данные, которые не могут быть сохранены',
    ko: '보드가 분리되었거나 원본 데이터가 존재하지 않아 입고할 수 없음',
    bur: 'ပေါ်ဒ်ငယ်ကိုနှုတ်ယူပြီးသို့မဟုတ်မူရင်းဒေတာမရှိ၍ ဂိုဒေါင်သွင်းမနိုင်',
    ben: 'ছোট বোর্ড হ্রাস করা হয়েছে বা মূল ডেটা নেই, গুদামে রাখা যাবে না',
    tr: 'Küçük levha düşüldü veya kaynak veri yok; depoya alınamaz',
    km: 'ផ្ទាំងតូចត្រូវបានកាត់ចេញ ឬគ្មានទិន្នន័យដើម មិនអាចរក្សាឃ្លាំង',
    es: 'Los paneles pequeños han sido deducidos o no hay datos originales y no se pueden poner en el almacén',
    ar: 'تم خصم اللوحات الصغيرة أو لا توجد بيانات أصلية ولا يمكن وضعها في المستودع',
  },
  'arrangedPage.awaitPlankStore.plankLoadErr': {
    zh: '板件信息加载失败',
    en: 'Failed to load board information. Procedure',
    id: 'Informasi papan gagal memuat',
    kz: 'Тақта ақпараты жүктелмеді',
    th: 'ข้อมูลบอร์ดไม่สามารถโหลดได้',
    ug: 'تاختا بۆلەك سانلىق مەلۇماتىنى يۈكلەش مەغلۇپ بولدى',
    vi: 'Lỗi tải thông tin bảng',
    zh_tc: '板件信息加載失敗',
    ru: 'Ошибка загрузки информации',
    ko: '보드 정보 로드 실패',
    bur: 'ပေါ်ဒ်သတင်းတင်ဆောင်မအောင်မြင်',
    ben: 'বোর্ড তথ্য লোড ব্যর্থ হয়েছে',
    tr: 'Levha bilgisi yüklenemedi',
    km: 'ផ្ទុកព័ត៌មានផ្ទាំងបរាជ័យ',
    es: 'Error al cargar la información del panel',
    ar: 'فشل تحميل معلومات اللوحة',
  },
  'arrangedPage.awaitPlankStore.taskTitle': {
    zh: '上传待排版库内板件',
    en: 'Upload the board to be typeset in the library',
    id: 'Unggah papan di perpustakaan untuk diketik',
    kz: 'Пластиналарды типтес болу үшін кітапханаға кері жүктеу',
    th: 'อัปโหลดบอร์ดในห้องสมุดที่จะพิมพ์',
    ug: 'تەرتىپلەش ئامبىرىدىكى تاختا بۆلەكنى يۈكلەش',
    vi: 'Tải lên các mảng để sắp xếp thư viện',
    zh_tc: '上傳待排版庫內板件',
    ru: 'Загрузка панелей в репозиторий',
    ko: '보류 중인 라이브러리 내 보드 업로드',
    bur: 'ပြင်ဆင်ရန်ကြိုဆိုင်ဒေတာဘင်ပေါ်ဒ်တင်ဆောင်',
    ben: 'লেআউট অপেক্ষায় লাইব্রেরির বোর্ড আপলোড করুন',
    tr: 'Sıra bekleme ambarındaki levhaları yükle',
    km: 'ផ្ទុកផ្ទាំងនៅក្នុងឃ្លាំងរង់ចាំ',
    es: 'Cargar los paneles en la biblioteca para mecanografiarlos',
    ar: 'تحميل اللوحات في المكتبة المراد كتابتها',
  },
  'arrangedPage.awaitPlankStore.dataGenErr': {
    zh: '数据生成错误',
    en: 'Data generation error',
    id: 'Kesalahan pembuatan data',
    kz: 'Деректерді генерациялау қателері',
    th: 'ข้อผิดพลาดในการสร้างข้อมูล',
    ug: 'سانلىق مەلۇمات ھاسىل قىلىش خاتالىقى',
    vi: 'Lỗi sản xuất dữ liệu',
    zh_tc: '數據生成錯誤',
    ru: 'Ошибка генерации данных',
    ko: '데이터 생성 오류',
    bur: 'ဒေတာဖန်တီးမှုအမှား',
    ben: 'ডেটা তৈরির ত্রুটি',
    tr: 'Veri üretim hatası',
    km: 'កំហុសបង្កើតទិន្នន័យ',
    es: 'Error de generación de datos',
    ar: 'خطأ في إنشاء البيانات',
  },
  'arrangedPage.awaitPlankStore.pushSuccess': {
    zh: '入库成功',
    en: 'Warehousing success',
    id: 'Berhasil memasuki gudang',
    kz: 'Қоймалау сәтті өтті',
    th: 'เข้าสู่คลังสินค้าได้สำเร็จ',
    ug: 'ئامبارغا ساقلاش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Kho lưu trữ thành công',
    zh_tc: '入庫成功',
    ru: 'Хранилище успешно',
    ko: '입고 성공',
    bur: 'ဂိုဒေါင်သွင်းမှုအောင်မြင်',
    ben: 'গুদামে রাখা সফল হয়েছে',
    tr: 'Depoya alma başarılı',
    km: 'រក្សាឃ្លាំងបានជោគជ័យ',
    es: 'Almacenamiento exitoso',
    ar: 'التخزين الناجح',
  },
  'arrangedPage.awaitPlankStore.pushErr': {
    zh: '出现未知错误，入库失败',
    en: 'An unknown error occurred. The repository failed',
    id: 'Terjadi kesalahan yang tidak diketahui dan gagal memasuki database',
    kz: 'Белгісіз қате орын алды және қоймалау жаңылысы',
    th: 'เกิดข้อผิดพลาดที่ไม่รู้จักและไม่สามารถป้อนฐานข้อมูลได้',
    ug: 'نۆۋەتسىز خاتالىق كۆرۈلدى، ئامبارغا ساقلاش مەغلۇپ بولدى',
    vi: 'Lỗi không xác định, lỗi nhập cảnh',
    zh_tc: '出現未知錯誤，入庫失敗',
    ru: 'Произошла неизвестная ошибка, не удалось войти в хранилище',
    ko: '알 수 없는 오류가 발생하여 입고 실패',
    bur: 'အမည်မသိအမှားဖြစ်ပွား၍ ဂိုဒေါင်သွင်းမှုမအောင်မြင်',
    ben: 'অজানা ত্রুটি ঘটেছে, গুদামে রাখা ব্যর্থ',
    tr: 'Bilinmeyen hata; depoya alınamadı',
    km: 'មានកំហុសមិនស្គាល់ រក្សាឃ្លាំងបរាជ័យ',
    es: 'Ocurrió un error desconocido y el almacén falló',
    ar: 'حدث خطأ غير معروف وفشل المستودع',
  },
  'arrangedPage.awaitPlankStore.awaitBoxExistPlank': {
    zh: '待排版库存在未入库小板，建议入库后再操作！',
    en: 'The inventory to be typeset is in the small board that has not been stored, it is recommended to operate after storage',
    id: 'Perpustakaan tata letak tidak termasuk dalam papan kecil, dan disarankan untuk mengoperasikannya setelah memasuki perpustakaan.',
    kz: 'Егер дестелеу мүкәммалы сақтауға қойылмаған шағын тақтада болса, қоймадан кейін пайдалану ұсынылады',
    th: 'ห้องสมุดเลย์เอาต์ไม่รวมอยู่ในบอร์ดขนาดเล็กและขอแนะนำให้ทำงานหลังจากเข้าสู่ห้องสมุด',
    ug: 'تەرتىپلەش ئامبىرىدا ئامبارغا ساقلانمىغان كىچىك تاختا بار، ئامبارغا ساقلىغاندىن كېيىن مەشغۇلات قىلىش تەۋسىيە قىلىنىدۇ',
    vi: 'Sẵn sàng để sắp xếp hàng tồn kho trong các bảng nhỏ không được nhập, được đề nghị để hoạt động sau khi nhập',
    zh_tc: '待排版庫存在未入庫小板，建議入庫後再操作！',
    ru: 'Товарно - материальные запасы, подлежащие сортировке, хранятся на незарегистрированных досках, и рекомендуется использовать их после складирования',
    ko: '조판 재고가 아직 입고되지 않은 보드에 있으니, 입고된 후에 다시 조작하는 것이 좋습니다.',
    bur: 'ပြင်ဆင်ရန်ကြိုဆိုင်ဒေတာဘင်တွင်ဂိုဒေါင်မသွင်းရသေးသောပေါ်ဒ်ငယ်ရှိ၍ ဂိုဒေါင်သွင်းပြီးမှဆောင်ရွက်ရန်အကြံပြု',
    ben: 'লেআউট অপেক্ষামাণ লাইব্রেরিতে গুদামে না রাখা ছোট বোর্ড আছে, গুদামে রাখার পরে অপারেশন করার পরামর্শ দেওয়া হচ্ছে',
    tr: 'Sıra bekleme ambarında depoya alınmamış küçük levhalar var; önce depoya almanız önerilir',
    km: 'ឃ្លាំងរង់ចាំមានផ្ទាំងតូចមិនទាន់រក្សាឃ្លាំង សូមរក្សាឃ្លាំងមុនប្រតិបត្តិការ',
    es: 'El stock a componer no está en el almacén. Se recomienda operar después de ingresar al almacén',
    ar: 'المخزون المراد تنضيده غير موجود في المستودع. يوصى بالعمل بعد دخول المستودع',
  },
  'arrangedPage.awaitPlankStore.pushAndOutput': {
    zh: '入库并输出',
    en: 'Stock and export',
    zh_tc: '入庫並輸出',
  },
  'arrangedPage.awaitPlankStore.mergeFrameDoorWholeTip': {
    zh: '本部件为骨骼门整体组件，入库后系统将自动拆解为单块板件进行管理',
    en: 'This part is a whole of the merged frame door component, and after storage, the system will automatically disassemble it into single block parts for management',
    id: 'Bagian ini adalah komponen pintu frame yang digabungkan, dan setelah penyimpanan, sistem akan secara otomatis memecahkannya menjadi blok-blok individu untuk pengelolaan',
    kz: 'Өзіндік кескіштердің бірігуіне арналған кескіштердің бөлшектері',
    th: 'ส่วนนี้เป็นส่วนของประตูเฟรมที่ผสานกัน และหลังจากการเก็บรักษา ระบบจะทำการแยกออกเป็นส่วนๆ เพื่อการจัดการ',
    ug: 'تەپسىلاتى ئېلەكلىك تاختا تەڭشەك قوشۇڭ، ئامبارغا ساقلىغاندىن كېيىن ئامبارغا ساقلاش مۇۋەپپەقىيەتلىك بولىدۇ',
    vi: 'Phần này là một phần của cửa khung được gộp lại, và sau khi lưu trữ, hệ thống sẽ tự động phân rã nó thành các khối riêng lẻ để quản lý',
    zh_tc: '本部件為骨骼門整體組件，入庫後系統將自動拆解為單塊板件進行管理',
    ru: 'Этот компонент является целым для слияния дверных рам, и после сохранения система автоматически разбивает его на отдельные блоки для управления',
    ko: '이 부품은 프레임 도어 병합 처리의 전체입니다, 저장 후 시스템은 자동으로 분해하여 개별 블록으로 관리합니다',
    bur: 'ဤအစိတ်အပိုင်းသည်အရိုးတံခါးတစ်ခုလုံးအစိတ်အပိုင်းဖြစ်ပြီးနောက်တွင်စနစ်သည်စီမံခန့်ခွဲမှုအတွက်တစ်ခုတည်းပန',
    ben: 'এই প্যার্ট একটি সংযুক্ত ফ্রেম ডোর সম্পূর্ণ উপাদান, এবং সংরক্ষণ করার পরে, সিস্টেমটি স্বয়ংক্রিয়ভাবে এটিকে একটি একক ব্লকে বিভাজন করবে এবং ম্যানেজ করবে',
    tr: 'Bu parça birleşmiş çerçeve kapı bileşeni, depoya kaydedildikten sonra sistem otomatik olarak tek parçaya bölünür ve yönetilir',
    km: 'ផ្ទាំងនៅក្នុងឃ្លាំងរង់ចាំមានផ្ទាំងតូចមិនទាន់រក្សាឃ្លាំង សូមរក្សាឃ្លាំងមុនប្រតិបត្តិការ',
    es: 'Este componente es un componente integral de la puerta esquelética. Después del almacenamiento, el sistema lo desmontará automáticamente en paneles individuales para su gestión.',
    ar: 'هذا المكون هو جزء لا يتجزأ من الباب الهيكلي. بعد التخزين، سيقوم النظام تلقائيًا بتفكيكه إلى لوحات فردية للإدارة.',
  },
  'arrangedPage.awaitPlankStore.checkPlankStatus': {
    zh: '正在校验板件状态...',
    en: 'Checking board status...',
    id: 'Memverifikasi status papan ...',
    kz: 'Басқарманың мәртебесін есептеу...',
    th: 'ตรวจสอบสถานะของคณะกรรมการ ...',
    ug: 'تاختا بۆلەك ھالىتىنى تەكشۈرۈۋاتىدۇ...',
    vi: 'Đang kiểm tra trạng thái hội đồng quản trị …',
    zh_tc: '正在校驗板件狀態...',
    ru: 'Проверяется состояние панели. Это...',
    ko: '보드 상태를 검사하는 중입니다...',
    bur: 'ပေါ်ဒ်အခြေအနေစစ်ဆေးနေသည်...',
    ben: 'বোর্ডের অবস্থা যাচাই করা হচ্ছে...',
    tr: 'Levha durumu doğrulanıyor...',
    km: 'កំពុងពិនិត្យស្ថានភាពផ្ទាំង...',
    es: 'Verificando el estado de la placa...',
    ar: 'التحقق من حالة اللوحة...',
  },
  'arrangedPage.batchSetCut': {
    zh: '批量设置下刀点',
    en: 'Batch Set Cut Points',
    id: 'Atur titik cut-down dalam batch',
    kz: 'Топтық кесу нүктелерін орнату',
    th: 'ตั้งจุดตัดลงในแบทช์',
    ug: 'كېسىش نۇقتىسىنى بىر قانچە تاللاش',
    vi: 'Đặt điểm cắt hàng loạt',
    zh_tc: '批量設置下刀點',
    ru: 'Установить точку сброса',
    ko: '다음 공구 점 대량 설정',
    bur: 'ဓားချဉ်ပြင်ဆင်အစုလိုက်သတ်မှတ်',
    ben: 'ব্যাচে ছুরি পয়েন্ট সেট করুন',
    tr: 'Toplu bıçak iniş noktası ayarı',
    km: 'កំណត់ចំណុចចុះដារជាក្រុម',
    es: 'Configuración por lotes de puntos de corte',
    ar: 'الإعداد الدفعي لنقاط القطع',
  },
  'arrangedPage.applyTo': {
    zh: '适用于:',
    en: '',
    id: 'Berlaku untuk:',
    kz: 'Қолдану:',
    th: 'ใช้ได้กับ:',
    ug: 'ئىشلىتىش دائىرىسى:',
    vi: 'Áp dụng cho:',
    zh_tc: '適用於:',
    ru: 'подходит для:',
    ko: '적용 가능한:',
    bur: 'သင့်တော်သည်:',
    ben: 'প্রযোজ্য:',
    tr: 'Geçerlidir:',
    km: 'អាចអនុវត្តចំពោះ:',
    es: 'Aplicable a:',
    ar: 'ينطبق على:',
  },
  'arrangedPage.ncDownloadLifeText.checkData': {
    zh: '正在检测数据',
    en: 'Checking data',
    id: 'Data sedang terdeteksi',
    kz: 'Деректерді тексеру',
    th: 'ตรวจพบข้อมูล',
    ug: 'سانلىق مەلۇماتنى تەكشۈرۈۋاتىدۇ',
    vi: 'Đang kiểm tra dữ liệu',
    zh_tc: '正在檢測數據',
    ru: 'Проверяем данные.',
    ko: '데이터 테스트 중',
    bur: 'ဒေတာစစ်ဆေးနေသည်',
    ben: 'ডেটা পরীক্ষা করা হচ্ছে',
    tr: 'Veri kontrol ediliyor',
    km: 'កំពុងពិនិត្យទិន្នន័យ',
    es: 'Detectando datos',
    ar: 'اكتشاف البيانات',
  },
  'arrangedPage.ncDownloadLifeText.checkDone': {
    zh: '数据检测完成',
    en: 'Data check completed',
    id: 'Deteksi data selesai',
    kz: 'Деректерді тексеру аяқталды',
    th: 'การตรวจจับข้อมูลเสร็จสมบูรณ์',
    ug: 'سانلىق مەلۇمات تەكشۈرۈش تامام',
    vi: 'Kiểm tra dữ liệu hoàn thành',
    zh_tc: '數據檢測完成',
    ru: 'Проверка данных завершена',
    ko: '데이터 테스트 완료',
    bur: 'ဒေတာစစ်ဆေးမှုပြည့်စုံ',
    ben: 'ডেটা পরীক্ষা সম্পন্ন',
    tr: 'Veri kontrolü tamamlandı',
    km: 'ការពិនិត្យទិន្នន័យបានបញ្ចប់',
    es: 'Detección de datos completada',
    ar: 'اكتمل اكتشاف البيانات',
  },
  'arrangedPage.ncDownloadLifeText.checkDataText': {
    zh: '数据检测',
    en: 'Data Detection',
    id: 'Deteksi Data',
    kz: 'Деректерді анықтау',
    th: 'การตรวจจับข้อมูล',
    ug: 'سانلىق مەلۇمات تەكشۈرۈش',
    vi: 'Phát hiện dữ liệu',
    zh_tc: '數據檢測',
    ru: 'Обнаружение данных',
    ko: '데이터 검색',
    bur: 'ဒေတာစစ်ဆေး',
    ben: 'ডেটা সনাক্তকরণ',
    tr: 'Veri kontrolü',
    km: 'ការពិនិត្យទិន្នន័យ',
    es: 'Detección de datos',
    ar: 'اكتشاف البيانات',
  },
  'arrangedPage.ncDownloadLifeText.loadSetting': {
    zh: '正在加载设置',
    en: 'Loading settings',
    id: 'Pengaturan Memuat',
    kz: 'Параметрлерді жүктеу',
    th: 'กำลังโหลดการตั้งค่า',
    ug: 'تەڭشەكنى يۈكلەۋاتىدۇ',
    vi: 'Đang tải cài đặt',
    zh_tc: '正在加載設置',
    ru: 'Настройки загрузки',
    ko: '설정 로드 중',
    bur: 'ဆက်တင်တင်ဆောင်နေသည်',
    ben: 'সেটিংস লোড হচ্ছে',
    tr: 'Ayarlar yükleniyor',
    km: 'កំពុងផ្ទុកការកំណត់',
    es: 'Cargando configuraciones',
    ar: 'إعدادات التحميل',
  },
  'arrangedPage.ncDownloadLifeText.settingLoadDone': {
    zh: '设置加载完成',
    en: 'Settings loaded',
    id: 'Pengaturan pemuatan selesai',
    kz: 'Параметрлер жүктелді',
    th: 'การตั้งค่าการโหลดเสร็จสมบูรณ์',
    ug: 'تەڭشەك يۈكلەش تامام',
    vi: 'Cài đặt tải xong',
    zh_tc: '設置加載完成',
    ru: 'Настройка Загрузка завершена',
    ko: '설정 로드 완료',
    bur: 'ဆက်တင်တင်ဆောင်မှုပြည့်စုံ',
    ben: 'সেটিংস লোড সম্পন্ন',
    tr: 'Ayarlar yüklendi',
    km: 'ផ្ទុកការកំណត់បានបញ្ចប់',
    es: 'Carga de configuraciones completada',
    ar: 'اكتمل تحميل الإعدادات',
  },
  'arrangedPage.ncDownloadLifeText.loadSettingText': {
    zh: '设置加载',
    en: 'Settings Loading',
    id: 'Mengatur pemuatan',
    kz: 'Деректерді анықтау',
    th: 'การตั้งค่าการโหลด',
    ug: 'تەڭشەك يۈكلەش',
    vi: 'Tải cài đặt',
    zh_tc: '設置加載',
    ru: 'Настройка загрузки',
    ko: '로드 설정',
    bur: 'ဆက်တင်တင်ဆောင်',
    ben: 'সেটিংস লোড',
    tr: 'Ayar yükleme',
    km: 'ផ្ទុកការកំណត់',
    es: 'Carga de configuraciones',
    ar: 'تحميل الإعدادات',
  },
  'arrangedPage.ncDownloadLifeText.downloadNc': {
    zh: '正在下载NC',
    en: 'Downloading NC',
    id: 'Mengunduh NC',
    kz: 'NC жүктеу',
    th: 'ดาวน์โหลด NC',
    ug: 'NC نى چۈشۈرۈۋاتىدۇ',
    vi: 'Đang tải xuống NC',
    zh_tc: '正在下載NC',
    ru: 'Скачать NC',
    ko: 'NC 다운로드 중',
    bur: 'NC ဒေါင်းလုတ်နေသည်',
    ben: 'NC ডাউনলোড হচ্ছে',
    tr: 'NC indiriliyor',
    km: 'កំពុងទាញយកNC',
    es: 'Descarga NC',
    ar: 'التنزيل NC',
  },
  'arrangedPage.ncDownloadLifeText.ncDownloadDone': {
    zh: 'NC下载完成',
    en: 'NC download completed',
    id: 'NC Download selesai',
    kz: 'NC жүктеу аяқталды',
    th: 'NC ดาวน์โหลดเสร็จสมบูรณ์',
    ug: 'NC چۈشۈرۈش تامام',
    vi: 'Tải xuống NC hoàn thành',
    zh_tc: 'NC下載完成',
    ru: 'NC Скачать полностью',
    ko: 'NC 다운로드 완료',
    bur: 'NC ဒေါင်းလုတ်ပြည့်စုံ',
    ben: 'NC ডাউনলোড সম্পন্ন',
    tr: 'NC indirme tamamlandı',
    km: 'ទាញយកNCបានបញ្ចប់',
    es: 'NC Descarga completa',
    ar: 'NC اكتمل التنزيل',
  },
  'arrangedPage.ncDownloadLifeText.downloadText': {
    zh: '下载NC',
    en: 'Download NC',
    id: 'Unduh NC',
    kz: 'NC жүктеп алу',
    th: 'ดาวน์โหลด NC',
    ug: 'NC چۈشۈرۈش',
    vi: 'Tải xuống NC',
    zh_tc: '下載NC',
    ru: 'Скачать NC',
    ko: 'NC 다운로드',
    bur: 'NC ဒေါင်းလုတ်',
    ben: 'NC ডাউনলোড',
    tr: 'NC indir',
    km: 'ទាញយកNC',
    es: 'Descargue NC',
    ar: 'تنزيل NC',
  },
  'arrangedPage.ncDownloadLifeText.loadPreferenceSetting': {
    zh: '正在加载偏好设置',
    en: 'Loading preference settings',
    id: 'Preferensi pemuatan',
    kz: 'Қалаулы параметрлерді жүктеу',
    th: 'การตั้งค่าการโหลด',
    ug: 'ئارزۇ تەڭشەكلىرىنى يۈكلەۋاتىدۇ',
    vi: 'Đang tải cài đặt tùy chọn',
    zh_tc: '正在加載偏好設置',
    ru: 'Загружаются настройки предпочтений',
    ko: '환경 설정을 로드하는 중',
    bur: 'ဦးစားပေးဆက်တင်တင်ဆောင်နေသည်',
    ben: 'পছন্দের সেটিংস লোড হচ্ছে',
    tr: 'Tercih ayarları yükleniyor',
    km: 'កំពុងផ្ទុកការកំណត់ចំណូលចិត្ត',
    es: 'Carga de configuraciones de preferencias',
    ar: 'تحميل إعدادات التفضيلات',
  },
  'arrangedPage.ncDownloadLifeText.PreferenceSettingLoadDone': {
    zh: '偏好设置加载完成',
    en: 'Preference settings loaded',
    id: 'Preferensi Memuat Lengkap',
    kz: 'Қалаулы параметрлер жүктелді',
    th: 'การตั้งค่าการโหลดเสร็จสมบูรณ์',
    ug: 'ئارزۇ تەڭشەكلىرى يۈكلەش تامام',
    vi: 'Cài đặt tùy chọn tải xong',
    zh_tc: '偏好設置加載完成',
    ru: 'Настройки предпочтений для завершения загрузки',
    ko: '환경 설정 로드 완료',
    bur: 'ဦးစားပေးဆက်တင်တင်ဆောင်မှုပြည့်စုံ',
    ben: 'পছন্দের সেটিংস লোড সম্পন্ন',
    tr: 'Tercih ayarları yüklendi',
    km: 'ផ្ទុកការកំណត់ចំណូលចិត្តបានបញ្ចប់',
    es: 'Carga de preferencias completada',
    ar: 'اكتمل تحميل التفضيلات',
  },
  'arrangedPage.ncDownloadLifeText.loadPreferenceText': {
    zh: '加载偏好设置',
    en: 'Load Preferences',
    id: 'Preferensi pemuatan',
    kz: 'Қалауларды жүктеу',
    th: 'การตั้งค่าการโหลด',
    ug: 'ئارزۇ تەڭشەكلىرىنى يۈكلەش',
    vi: 'Tải các tùy chọn',
    zh_tc: '加載偏好設置',
    ru: 'Загрузить настройки предпочтений',
    ko: '로드 환경 설정',
    bur: 'ဦးစားပေးဆက်တင်တင်ဆောင်',
    ben: 'পছন্দ লোড করুন',
    tr: 'Tercihleri yükle',
    km: 'ផ្ទុកការកំណត់ចំណូលចិត្ត',
    es: 'Cargando preferencias',
    ar: 'تحميل التفضيلات',
  },
  'arrangedPage.ncDownloadLifeText.dealTemp': {
    zh: '正在处理模板',
    en: 'Processing template',
    id: 'Bekerja dengan template',
    kz: 'Үлгіні өңдеу',
    th: 'ทำงานกับแม่แบบ',
    ug: 'قېلىپنى بىر تەرەپ قىلىۋاتىدۇ',
    vi: 'Đang xử lý mẫu',
    zh_tc: '正在處理模板',
    ru: 'Обрабатываются шаблоны',
    ko: '템플릿 작업 중',
    bur: 'ပုံစံပြင်ဆင်နေသည်',
    ben: 'টেমপ্লেট প্রক্রিয়া হচ্ছে',
    tr: 'Şablon işleniyor',
    km: 'កំពុងដំណើរការគំរូ',
    es: 'Procesamiento de plantillas',
    ar: 'المعالجة القوالب',
  },
  'arrangedPage.ncDownloadLifeText.TempDealDone': {
    zh: '模板处理完成',
    en: 'Template processing completed',
    id: 'Pemrosesan template selesai',
    kz: 'Үлгіні өңдеу аяқталды',
    th: 'การประมวลผลแม่แบบเสร็จสมบูรณ์',
    ug: 'قېلىپ بىر تەرەپ قىلىش تامام',
    vi: 'Xử lý mẫu hoàn thành',
    zh_tc: '模板處理完成',
    ru: 'Обработка шаблонов завершена',
    ko: '템플릿 처리 완료',
    bur: 'ပုံစံပြင်ဆင်မှုပြည့်စုံ',
    ben: 'টেমপ্লেট প্রক্রিয়া সম্পন্ন',
    tr: 'Şablon işleme tamamlandı',
    km: 'ដំណើរការគំរូបានបញ្ចប់',
    es: 'Procesamiento de plantilla completado',
    ar: 'اكتملت معالجة القالب',
  },
  'arrangedPage.ncDownloadLifeText.dealTempText': {
    zh: '处理模板',
    en: 'Process Template',
    id: 'Templat pemrosesan',
    kz: 'Үлгіні өңдеу',
    th: 'เทมเพลตการประมวลผล',
    ug: 'قېلىپ بىر تەرەپ قىلىش',
    vi: 'Xử lý mẫu',
    zh_tc: '處理模板',
    ru: 'Обработка шаблонов',
    ko: '템플릿 작업',
    bur: 'ပုံစံပြင်ဆင်',
    ben: 'টেমপ্লেট প্রক্রিয়া',
    tr: 'Şablonu işle',
    km: 'ដំណើរការគំរូ',
    es: 'Procesando plantillas',
    ar: 'قوالب المعالجة',
  },
  'arrangedPage.ncDownloadLifeText.beBeingGenTagFile': {
    zh: '正在生成{fileType}文件',
    en: 'Generating {fileType} file',
    id: 'Menghasilkan file {filetype}',
    kz: '{fileType} файлын жасау',
    th: 'การสร้างไฟล์ {fileType}',
    ug: '{fileType} ھۆججىتى ھاسىل قىلىنىۋاتىدۇ',
    vi: 'Đang tạo tệp {fileType}',
    zh_tc: '正在生成{fileType}文件',
    ru: 'Создание файла {fileType}',
    ko: '{fileType} 파일 생성 중',
    bur: '{fileType} ဖိုင်ဖန်တီးနေသည်',
    ben: '{fileType} ফাইল তৈরি হচ্ছে',
    tr: '{fileType} dosyası oluşturuluyor',
    km: 'កំពុងបង្កើតឯកសារ {fileType}',
    es: 'Generación de archivos {fileType}',
    ar: 'إنشاء ملفات {fileType}',
  },
  'arrangedPage.ncDownloadLifeText.genTagFileDone': {
    zh: '生成{fileType}文件完成',
    en: '{fileType} file generated',
    id: 'Menghasilkan file {filetype} untuk menyelesaikan',
    kz: '{fileType} файлы жасалды',
    th: 'สร้างไฟล์ {fileType} ให้เสร็จสมบูรณ์',
    ug: '{fileType} ھۆججىتى ھاسىل قىلىش تامام',
    vi: 'Tạo tệp {fileType} hoàn thành',
    zh_tc: '生成{fileType}文件完成',
    ru: 'Создание файла {fileType} завершено',
    ko: '{fileType} 파일 생성 완료',
    bur: '{fileType} ဖိုင်ဖန်တီးမှုပြည့်စုံ',
    ben: '{fileType} ফাইল তৈরি সম্পন্ন',
    tr: '{fileType} dosyası oluşturuldu',
    km: 'បានបង្កើតឯកសារ {fileType}',
    es: 'Generación de archivos {fileType} completado',
    ar: 'اكتمل إنشاء ملفات {fileType}',
  },
  'arrangedPage.ncDownloadLifeText.genTagFileText': {
    zh: '生成{fileType}文件',
    en: 'Generate {fileType} file',
    id: 'Menghasilkan file {filetype}',
    kz: '{fileType} файлын жасау',
    th: 'สร้างไฟล์ {fileType}',
    ug: '{fileType} ھۆججىتى ھاسىل قىلىش',
    vi: 'Tạo tệp {fileType}',
    zh_tc: '生成{fileType}文件',
    ru: 'Создание файла {fileType}',
    ko: '{fileType} 파일 생성',
    bur: '{fileType} ဖိုင်ဖန်တီး',
    ben: '{fileType} ফাইল তৈরি করুন',
    tr: '{fileType} dosyası oluştur',
    km: 'បង្កើតឯកសារ {fileType}',
    es: 'Generación de archivos {fileType}',
    ar: 'إنشاء ملفات {fileType}',
  },
  'arrangedPage.ncDownloadLifeText.zip': {
    zh: '正在生成本地压缩文件',
    en: 'Generating local zip file',
    id: 'Menghasilkan file terkompresi lokal',
    kz: 'Жергілікті сығылған файлды жасау',
    th: 'สร้างไฟล์บีบอัดในเครื่อง',
    ug: 'يەرلىك قىسقا ھۆججەت ھاسىل قىلىنىۋاتىدۇ',
    vi: 'Đang tạo tệp nén cục bộ',
    zh_tc: '正在生成本地壓縮文件',
    ru: 'Создается локальный сжатый файл',
    ko: '로컬 압축 파일 생성 중',
    bur: 'ဒေသဆိုင်ရာချုံ့ဖိုင်ဖန်တီးနေသည်',
    ben: 'স্থানীয় সংকুচিত ফাইল তৈরি হচ্ছে',
    tr: 'Yerel sıkıştırılmış dosya oluşturuluyor',
    km: 'កំពុងបង្កើតឯកសារបង្គត់ក្នុងម៉ាស៊ីន',
    es: 'Generación de archivos comprimidos locales',
    ar: 'إنشاء ملفات مضغوطة محلية',
  },
  'arrangedPage.ncDownloadLifeText.zipDone': {
    zh: '生成本地压缩文件完成',
    en: 'Local zip file generated',
    id: 'Menghasilkan file terkompresi lokal untuk diselesaikan',
    kz: 'Жергілікті сығылған файл жасалды',
    th: 'สร้างไฟล์บีบอัดในเครื่องเพื่อให้เสร็จสมบูรณ์',
    ug: 'يەرلىك قىسقا ھۆججەت ھاسىل قىلىش تامام',
    vi: 'Tạo tệp nén cục bộ hoàn thành',
    zh_tc: '生成本地壓縮文件完成',
    ru: 'Создание локального сжатого файла завершено',
    ko: '로컬 압축 파일 생성 완료',
    bur: 'ဒေသဆိုင်ရာချုံ့ဖိုင်ဖန်တီးမှုပြည့်စုံ',
    ben: 'স্থানীয় সংকুচিত ফাইল তৈরি সম্পন্ন',
    tr: 'Yerel sıkıştırılmış dosya oluşturuldu',
    km: 'បានបង្កើតឯកសារបង្គត់ក្នុងម៉ាស៊ីន',
    es: 'Generación de archivos comprimidos locales completada',
    ar: 'اكتمل إنشاء ملفات مضغوطة محلية',
  },
  'arrangedPage.ncDownloadLifeText.genZipText': {
    zh: '生成压缩文件',
    en: 'Generate a compressed file',
    id: 'Menghasilkan file terkompresi',
    kz: 'Сығылған файлды жасау',
    th: 'สร้างไฟล์ที่ถูกบีบอัด',
    ug: 'قىسقا ھۆججەت ھاسىل قىلىش',
    vi: 'Tạo tệp nén',
    zh_tc: '生成壓縮文件',
    ru: 'Создание сжатого файла',
    ko: '압축 파일 생성',
    bur: 'ချုံ့ဖိုင်ဖန်တီး',
    ben: 'সংকুচিত ফাইল তৈরি করুন',
    tr: 'Sıkıştırılmış dosya oluştur',
    km: 'បង្កើតឯកសារបង្គត់',
    es: 'Generación de archivos comprimidos',
    ar: 'إنشاء ملفات مضغوطة',
  },
  'arrangedPage.ncDownloadLifeText.fileTypeText': {
    zh: '图片',
    en: 'Image',
    id: 'gambar',
    kz: 'Сурет',
    th: 'รูปภาพ',
    ug: 'رەسىم',
    vi: 'Hình ảnh',
    zh_tc: '圖片',
    ru: 'изображение',
    ko: '사진',
    bur: 'ဓာတ်ပုံ',
    ben: 'ছবি',
    tr: 'Görüntü',
    km: 'រូបភាព',
    es: 'Imagen',
    ar: 'صورة',
  },
  'arrangedPage.surplusCommonTemp': {
    zh: '余料常用模版',
    en: 'Surplus Common Template',
    id: 'Template umum untuk bahan yang tersisa',
    kz: 'Қалған жалпы үлгі',
    th: 'เทมเพลตทั่วไปสำหรับวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىياللارنىڭ كۆپ ئىشلىتىلىدىغان قېلىپى',
    vi: 'Mẫu thừa phổ biến',
    zh_tc: '餘料常用模版',
    ru: 'Обычные шаблоны',
    ko: '여분 재료 상용 템플릿',
    bur: 'ပိုလျှံပစ္စည်းအသုံးများသောပုံစံ',
    ben: 'উদ্বৃত্ত উপকরণের সাধারণ টেমপ্লেট',
    tr: 'Artık malzeme ortak şablonu',
    km: 'គំរូសម្ភារៈសល់ទូទៅ',
    es: 'Plantillas comunes para los materiales restantes',
    ar: 'قوالب مشتركة للمواد المتبقية',
  },
  'arrangedPage.plankErrTip': {
    zh: '当前用料方案存在小板没有可用大板进行排版!',
    en: 'The current material plan has small boards with no available large boards for layout!',
    id: 'Ada papan kecil dan tidak ada papan besar yang dapat digunakan untuk tata letak!',
    kz: 'Ағымдағы материал жоспары бойынша кіші тақтайшаны орналастыруға жарамды үлкен тақтайша жоқ!',
    th: 'มีบอร์ดขนาดเล็กและไม่สามารถใช้บอร์ดขนาดใหญ่สำหรับเค้าโครงได้!',
    ug: 'نۆۋەتتىكى ماتېرىيال پىلانىدا تەرتىپلەشكە بولىدىغان چوڭ تاختا يوق كىچىك تاختا بار!',
    vi: 'Kế hoạch vật liệu hiện tại có bảng nhỏ không có bảng lớn có sẵn để bố trí!',
    zh_tc: '當前用料方案存在小板沒有可用大板進行排版!',
    ru: 'Текущая схема использования имеет небольшие доски, которые не могут быть напечатаны большими досками!',
    ko: '현재 재료 사용 방안에 작은 판이 존재하여 큰 판으로 조판할 수 없습니다!',
    bur: 'လက်ရှိပစ္စည်းစီမံချက်တွင်ပြင်ဆင်နိုင်သောပေါ်ဒ်ကြီးမရှိသောပေါ်ဒ်ငယ်ရှိသည်!',
    ben: 'বর্তমান উপকরণ পরিকল্পনায় ছোট বোর্ড আছে কিন্তু লেআউটের জন্য বড় বোর্ড নেই!',
    tr: 'Mevcut malzeme planında, yerleşime uygun büyük levhası olmayan küçük levhalar var',
    km: 'ផែនការសម្ភារៈមានផ្ទាំងតូចគ្មានផ្ទាំងធំសម្រាប់រៀបចំ',
    es: '¡Hay placas pequeñas en el plan de materiales actual y no hay placas grandes disponibles para la composición tipográfica!',
    ar: 'توجد لوحات صغيرة في خطة المواد الحالية ولا تتوفر لوحات كبيرة للتنضيد!',
  },
  'arrangedPage.brandPlankErrTip': {
    zh: '当前用料方案存在品牌小板没有可用品牌大板进行排版!',
    en: 'The current material plan has brand parts with no available brand sheets for layout!',
    id: 'Ada komponen merek tanpa papan merek yang tersedia untuk tata letak!',
    kz: 'Ағымдағы материал жоспарында орналастыруға қолжетімді бренд тақтасы жоқ бренд бөлшектері бар!',
    th: 'แผนวัสดุปัจจุบันมีชิ้นส่วนแบรนด์ที่ไม่มีแผ่นแบรนด์สำหรับจัดเลย์เอาต์!',
    ug: 'نۆۋەتتىكى ماتېرىيال پىلانىدا تەرتىپلەشكە بولىدىغان ماركا چوڭ تاختىسى يوق ماركا كىچىك تاختىسى بار!',
    vi: 'Kế hoạch vật liệu hiện tại có tấm nhỏ thương hiệu nhưng không có tấm thương hiệu khả dụng để bố trí!',
    zh_tc: '當前用料方案存在品牌小板沒有可用品牌大板進行排版!',
    ru: 'В текущем плане материалов есть брендовые детали без доступных брендовых листов для раскладки!',
    ko: '현재 재료 계획에 사용할 수 있는 브랜드 대판이 없는 브랜드 소판이 있습니다!',
    bur: 'လက်ရှိပစ္စည်းစီမံချက်တွင် ပြင်ဆင်ရန် အမှတ်တံဆိပ်ပေါ်ဒ်ကြီးမရှိသော အမှတ်တံဆိပ်ပေါ်ဒ်ငယ်များရှိသည်!',
    ben: 'বর্তমান উপকরণ পরিকল্পনায় এমন ব্র্যান্ড অংশ আছে যার জন্য কোনো উপলব্ধ ব্র্যান্ড বোর্ড নেই!',
    tr: 'Mevcut malzeme planında yerleşime uygun marka levhası olmayan marka parçalar var!',
    km: 'ផែនការសម្ភារៈបច្ចុប្បន្នមានផ្នែកម៉ាកដែលមិនមានផ្ទាំងម៉ាកសម្រាប់រៀបចំ!',
    es: 'El plan de materiales actual tiene piezas de marca sin placas de marca disponibles para el diseño!',
    ar: 'توجد أجزاء ذات علامة تجارية في خطة المواد الحالية ولا تتوفر لها ألواح علامة تجارية للتخطيط!',
  },
  'arrangedPage.overSizeTip': {
    zh: '大板数量不够或超尺',
    en: 'Insufficient large boards or oversized',
    id: 'Jumlah papan besar yang tidak mencukupi atau melebihi penguasa',
    kz: 'Үлкен тақталардың саны жеткіліксіз немесе өлшемі үлкен',
    th: 'บอร์ดขนาดใหญ่จำนวนไม่เพียงพอหรือสูงกว่าไม้บรรทัด',
    ug: 'چوڭ تاختا سانى يېتەرسىز ياكى چوڭلۇقى چەكتىن ئاشتى',
    vi: 'Số lượng bảng lớn không đủ hoặc quá khổ',
    zh_tc: '大板數量不夠或超尺',
    ru: 'Недостаточно большой или большой размер.',
    ko: '대판 수량이 부족하거나 초과자',
    bur: 'ပေါ်ဒ်ကြီးအရေအတွက်မလုံလောက် သို့မဟုတ် ကြီးလွန်',
    ben: 'বড় বোর্ডের পরিমাণ অপর্যাপ্ত বা অতিরিক্ত আকার',
    tr: 'Büyük levha yetersiz veya ölçü aşımı',
    km: 'ផ្ទាំងធំមិនគ្រប់គ្រាន់ ឬលើសខ្នាត',
    es: 'El número de planchas grandes es insuficiente o está sobredimensionado',
    ar: 'عدد اللوحات الكبيرة غير كافٍ أو كبير الحجم',
  },
  'arrangedPage.uselessPart': {
    zh: '当前大板上无可用小板，请重新排版',
    en: 'No usable small boards on the current large board, please re-layout',
    id: 'Saat ini tidak ada papan kecil yang tersedia di papan besar, harap tata ulang',
    kz: 'Ағымдағы үлкен тақтада пайдалануға жарамды шағын тақта жоқ, қайта орналастырыңыз',
    th: 'ขณะนี้ไม่มีบอร์ดขนาดเล็กบนกระดานขนาดใหญ่ กรุณาจัดวางใหม่',
    ug: 'نۆۋەتتىكى چوڭ تاختىدا ئىشلىتىشكە بولىدىغان كىچىك تاختا يوق، قايتا تەرتىپلەڭ',
    vi: 'Không có bảng nhỏ nào có thể sử dụng trên bảng lớn hiện tại, vui lòng sắp xếp lại',
    zh_tc: '當前大板上無可用小板，請重新排版',
    ru: 'На текущей большой доске нет доступных малых досок, пожалуйста, переверстайте',
    ko: '현재 보드에 사용 가능한 보드가 없습니다. 다시 배치해 주세요.',
    bur: 'လက်ရှိပေါ်ဒ်ကြီးတွင်အသုံးပြုနိုင်သောပေါ်ဒ်ငယ်မရှိ၊ ကျေးဇူးပြု၍ပြန်စီစဉ်ပါ',
    ben: 'বর্তমান বড় বোর্ডে ব্যবহারযোগ্য কোনো ছোট বোর্ড নেই, অনুগ্রহ করে পুনরায় লেআউট করুন',
    tr: 'Geçerli büyük levhada kullanılabilir küçük levha yok, lütfen yeniden düzenleyin',
    km: 'លើផ្ទាំងធំបច្ចុប្បន្នគ្មានផ្ទាំងតូចប្រើបាន សូមរៀបចំឡើងវិញ',
    es: 'Actualmente no hay planchas pequeñas disponibles en la plancha grande',
    ar: 'لا يوجد حاليًا أي لوحات صغيرة متوفرة على اللوحة الكبيرة',
  },
  'arrangedPage.splitArranged': {
    zh: '小板数量过多，请重新排版或分批次进行排版',
    en: 'Too many small boards, please re-layout or arrange in batches',
    id: 'Ada terlalu banyak papan kecil, harap tata ulang atau susun dalam batch',
    kz: 'Кішкене тақталар тым көп, қайта орналастырыңыз немесе топтап орналастырыңыз',
    th: 'มีบอร์ดขนาดเล็กมากเกินไป กรุณาจัดวางใหม่หรือจัดวางเป็นชุด',
    ug: 'كىچىك تاختا سانى بەك كۆپ، قايتا تەرتىپلەڭ ياكى بىر قانچە قېتىم تەرتىپلەڭ',
    vi: 'Số lượng bảng nhỏ quá nhiều, vui lòng sắp xếp lại hoặc sắp xếp theo từng đợt',
    zh_tc: '小板數量過多，請重新排版或分批次進行排版',
    ru: 'Слишком много листов, пожалуйста, переверстайте или печатайте партиями',
    ko: '널빤지의 수량이 너무 많으니, 다시 조판하거나 차수로 나누어 조판하는 것을 건의합니다.',
    bur: 'ပေါ်ဒ်ငယ်အရေအတွက်များလွန်း၍ ပြန်စီစဉ်ရန်သို့မဟုတ်အပိုင်းများပိုင်းပြင်ဆင်ရန်အကြံပြု',
    ben: 'ছোট বোর্ডের পরিমাণ অনেক বেশি, পুনরায় লেআউট করুন বা ব্যাচে লেআউট করার পরামর্শ দেওয়া হচ্ছে',
    tr: 'Çok fazla küçük levha; lütfen yeniden düzenleyin veya partiler halinde yerleştirin',
    km: 'ផ្ទាំងតូចច្រើនពេក សូមរៀបចំឡើងវិញ ឬរៀបចំជាក្រុម',
    es: 'Número de planchas pequeñas demasiado grande, por favor, reformate o compóngalas en lotes',
    ar: 'عدد اللوحات الصغيرة كبير جدًا، يرجى إعادة التنضيد أو تنضيدها بالدفعات',
  },
  'arrangedPage.arrangedErrTip': {
    zh: '排版失败，存在大板数量不足或小板超尺',
    en: 'Layout failed due to insufficient large boards or oversized small boards',
    id: 'Pengesahan huruf gagal, tidak ada cukup banyak papan besar atau papan kecil yang melebihi penguasa',
    kz: 'Үлкен тақталардың жеткіліксіздігі немесе шағын тақталардың үлкендігі салдарынан орналасу сәтсіз аяқталды',
    th: 'การเรียงพิมพ์ล้มเหลวมีบอร์ดขนาดใหญ่หรือบอร์ดขนาดเล็กจำนวนไม่เพียงพอ',
    ug: 'تەرتىپلەش مەغلۇپ بولدى، چوڭ تاختا سانى يېتەرسىز ياكى كىچىك تاختا چوڭلۇقى چەكتىن ئاشقانلىقىنى بايقىدى',
    vi: 'Bố trí thất bại do số lượng bảng lớn không đủ hoặc bảng nhỏ quá khổ',
    zh_tc: '排版失敗，存在大板數量不足或小板超尺',
    ru: 'Ошибка набора, есть недостаточное количество больших досок или ультрафутов маленьких досок',
    ko: '조판 실패, 대판 수량 부족 또는 소판 초자 존재',
    bur: 'ပြင်ဆင်မှုမအောင်မြင်၊ ပေါ်ဒ်ကြီးအရေအတွက်မလုံလောက် သို့မဟုတ် ပေါ်ဒ်ငယ်ကြီးလွန်ကြောင်းစစ်ဆေးတွေ့ရှိ',
    ben: 'লেআউট ব্যর্থ, বড় বোর্ডের অপর্যাপ্ততা বা ছোট বোর্ডের অতিরিক্ত আকার পাওয়া গেছে',
    tr: 'Yerleşim başarısız; büyük levha yetersiz veya küçük levha ölçü aşımı',
    km: 'រៀបចំបរាជ័យ៖ ផ្ទាំងធំមិនគ្រប់គ្រាន់ ឬផ្ទាំងតូចលើសខ្នាត',
    es: 'Falló la tipografía, no hay número suficiente de planchas grandes o las planchas pequeñas están sobredimensionadas',
    ar: 'فشلت عملية التنضيد، لا يوجد عدد كافٍ من اللوحات الكبيرة أو اللوحات الصغيرة كبيرة الحجم',
  },
  'arrangedPage.knivesModalTitle': {
    zh: '存在孔槽找不到刀具',
    en: 'There are slots that cannot find tools',
    id: 'Alat tidak dapat ditemukan di slot lubang',
    kz: 'Тесік ұясы бар және құралды табу мүмкін емес',
    th: 'ไม่พบเครื่องมือในช่องหลุม',
    ug: 'تېشىك/ئويۇقنى ئىشلەش پىچاقلىرى تېپىلمىدى',
    vi: 'Có lỗ khoét nhưng không tìm thấy dao cụ',
    zh_tc: '存在孔槽找不到刀具',
    ru: 'Нет отверстий. Нож не найден.',
    ko: '구멍 슬롯이 있어 공구를 찾을 수 없습니다.',
    bur: 'ပေါက်/ချောင်းတွင်ဓားရှာမတွေ့',
    ben: 'গর্ত/স্লটে টুল খুঁজে পাওয়া যাচ্ছে না',
    tr: 'Bazı delik/oluklarda takım bulunamıyor',
    km: 'មានរណ្តៅ/រន្ធរកមិនឃើញឧបករណ៍',
    es: 'Hay agujeros y no se puede encontrar la herramienta',
    ar: 'توجد ثقوب ولا يمكن العثور على الأداة',
  },
  'arrangedPage.cannotDownloadByKnivesErr': {
    zh: '无法下载NC，系统检测存在以下孔槽找不到刀具',
    en: 'Cannot download NC, the system detects that there are slots that cannot find tools',
    id: 'NC tidak dapat diunduh, sistem mendeteksi bahwa lubang berikut ada, alat tidak dapat ditemukan',
    kz: 'NC жүктеп алу мүмкін болмаса, жүйе келесі тесіктер мен ұяларды анықтайды және құралды таба алмайды.',
    th: 'ไม่สามารถดาวน์โหลด NC ได้ระบบตรวจพบว่ามีรูต่อไปนี้เครื่องมือไม่สามารถหาได้',
    ug: 'NC چۈشۈرۈشكە بولمايدۇ، سىستېما تۆۋەندىكى تېشىك/ئويۇقنى ئىشلەش پىچاقلىرىنى تېپىلمىدى',
    vi: 'Không thể tải xuống NC, hệ thống phát hiện các lỗ rãnh sau không tìm thấy dao cụ',
    zh_tc: '無法下載NC，系統檢測存在以下孔槽找不到刀具',
    ru: 'Невозможно загрузить NC, система обнаруживает наличие следующих отверстий и не может найти нож',
    ko: '다음 구멍 슬롯에서 공구를 찾을 수 없음을 감지한 NC를 다운로드할 수 없습니다.',
    bur: 'NC ဒေါင်းလုတ်မနိုင်၊ အောက်ပါပေါက်/ချောင်းတွင်ဓားရှာမတွေ့',
    ben: 'NC ডাউনলোড করা যাচ্ছে না, সিস্টেম নিচের গর্ত/স্লটে টুল খুঁজে পাচ্ছে না',
    tr: 'NC indirilemiyor; aşağıdaki delik/oluklarda takım bulunamadı',
    km: 'មិនអាចទាញយក NC បានទេ; ប្រព័ន្ធរកឃើញរណ្តៅ/រន្ធខាងក្រោមគ្មានឧបករណ៍',
    es: 'No se puede descargar NC, el sistema detecta que no se pueden encontrar los siguientes orificios y ranuras y no se puede encontrar la herramienta',
    ar: 'غير قادر على التنزيل NC، اكتشف النظام أن لا يمكن العثور على الثقوب والشقوق التالية ولا يمكن العثور على الأداة',
  },
  'arrangedPage.viewPart': {
    zh: '查看问题小板',
    en: 'View problem board',
    id: 'Lihat papan pertanyaan',
    kz: 'Мәселелер тақтасын қараңыз',
    th: 'ตรวจสอบกระดานคำถาม',
    ug: 'مەسىلىلىك كىچىك تاختىنى كۆرۈش',
    vi: 'Xem bảng câu hỏi',
    zh_tc: '查看問題小板',
    ru: 'Посмотреть вопрос на доске',
    ko: '문제 보드 보기',
    bur: 'ပြဿနာပေါ်ဒ်ငယ်ကြည့်',
    ben: 'সমস্যার বোর্ড দেখুন',
    tr: 'Sorunlu levhayı görüntüle',
    km: 'មើលផ្ទាំងដែលមានបញ្ហា',
    es: 'Vea el tablero pequeño problemático',
    ar: 'عرض المشكلة لوحة صغيرة',
  },
  'arrangedPage.deductionModalTitle': {
    zh: '请选择扣减对象',
    en: 'Please select the deduction object',
    id: 'Pilih objek pengurangan',
    kz: 'Тындау объектін таңдаңыз',
    th: 'โปรดเลือกวัตถุหัก',
    ug: 'چىقىرىۋېتىش نىشانىنى تاللاڭ',
    vi: 'Hãy chọn đối tượng khấu trừ',
    zh_tc: '請選擇扣減對象',
    ru: 'Выберите объект вычета',
    ko: '공제 객체를 선택하십시오.',
    bur: 'နှုတ်ရမည့်အရာရွေးပါ',
    ben: 'কর্তনের বস্তু নির্বাচন করুন',
    tr: 'Lütfen kesinti nesnesini seçin',
    km: 'សូមជ្រើសរើសគោលដៅកាត់ចេញ',
    es: 'Seleccione el objeto de deducción',
    ar: 'يرجى تحديد كائن الاستقطاع',
  },
  'arrangedPage.bujianDeduction': {
    zh: '扣减补件小板',
    en: 'Deduct and supplement small boards',
    id: 'Kurangi papan suplemen',
    kz: 'Тындау жоламаға кіші платка',
    th: 'ลดบอร์ดเสริม',
    ug: 'قوشۇمچە بۆلەك كىچىك تاختىسىنى چىقىرىۋېتىش',
    vi: 'Tấm bổ sung khấu trừ',
    zh_tc: '扣減補件小板',
    ru: 'Маленькая накладка',
    ko: '패치 소판',
    bur: 'ဖြည့်ဆည်းပေါ်ဒ်ငယ်နှုတ်',
    ben: 'পরিপূরক ছোট বোর্ড কর্তন করুন',
    tr: 'Ek parça küçük levhayı düşür',
    km: 'កាត់ចេញផ្ទាំងតូចបំពេញ',
    es: 'Deducción de tablero pequeño de piezas suplementarias',
    ar: 'خصم الأجزاء التكميلية لوحة صغيرة',
  },
  'arrangedPage.paibanDeduction': {
    zh: '扣减暂存区小板',
    en: 'Deduction of temporary storage area small board',
    id: 'Mengurangi area penyimpanan sementara papan kecil',
    kz: 'Тындау уақытша сақтау аймағының кіші платка',
    th: 'หักพื้นที่จัดเก็บชั่วคราวบอร์ดขนาดเล็ก',
    ug: 'ساقلىغۇچىدىكى كىچىك تاختىنى چىقىرىۋېتىش',
    vi: 'Khu vực dàn dựng khấu trừ',
    zh_tc: '扣減暫存區小板',
    ru: 'Минус панель резервной зоны',
    ko: '잠금 영역 슬레이트 공제',
    bur: 'ယာယီသိမ်းဆည်းနေရာပေါ်ဒ်ငယ်နှုတ်',
    ben: 'অস্থায়ী স্টোরেজ এলাকার ছোট বোর্ড কর্তন করুন',
    tr: 'Geçici alandaki küçük levhayı düşür',
    km: 'កាត់ចេញផ្ទាំងតូចនៅតំបន់ផ្ទុកជាបណ្តោះអាសន្ន',
    es: 'Deducción del tablero pequeño del área de almacenamiento temporal',
    ar: 'خصم لوحة صغيرة لمنطقة التخزين المؤقتة',
  },
  'arrangedPage.surplusDeduction': {
    zh: '扣减余料大板',
    en: 'Deduction of surplus material large board',
    id: 'Mengurangi pelat besar bahan residu',
    kz: 'Қалысқы материалдарды тындау үлкен платка',
    th: 'หักวัสดุที่เหลือแผ่นขนาดใหญ่',
    ug: 'قالدۇق ماتېرىيال چوڭ تاختىسىنى چىقىرىۋېتىش',
    vi: 'Tấm lớn cho khấu trừ vật liệu dư',
    zh_tc: '扣減餘料大板',
    ru: 'Ограниченная накладка',
    ko: '남은 재료의 널빤지를 깎다',
    bur: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးနှုတ်',
    ben: 'উদ্বৃত্ত উপকরণের বড় বোর্ড কর্তন করুন',
    tr: 'Artık malzeme büyük levhayı düşür',
    km: 'កាត់ចេញផ្ទាំងធំសម្ភារៈសល់',
    es: 'Deducción del tablero de material restante',
    ar: 'خصم لوحة المواد المتبقية',
  },
  'arrangedPage.unlockPaiban': {
    zh: '解除参与排版余料的锁定',
    en: 'Unlock the remaining materials involved in typesetting',
    id: 'Buka kunci bahan yang tersisa yang terlibat dalam tata letak',
    kz: 'Тypes жүйесіне қосылған қалысқы материалдардың блоктауды алып тастау',
    th: 'ปลดล็อกวัสดุที่เหลืออยู่ที่เกี่ยวข้องในเลย์เอาต์',
    ug: 'تەرتىپلەشكە قاتناشقان قالدۇق ماتېرىياللارنىڭ قۇلۇپىنى ئېچىش',
    vi: 'Mở khóa phần còn lại của typography',
    zh_tc: '解除參與排版餘料的鎖定',
    ru: 'Снятие блокировки остатков, участвующих в наборе',
    ko: '조판에 참여한 나머지 재료의 잠금을 해제하다',
    bur: 'ပြင်ဆင်မှုတွင်ပါဝင်သောပိုလျှံပစ္စည်းလော့ဖြည်',
    ben: 'লেআউটে অংশগ্রহণকারী উদ্বৃত্তের লক খুলুন',
    tr: 'Yerleşime dahil artığın kilidini kaldır',
    km: 'ដោះសោសម្ភារៈសល់ដែលចូលរួមរៀបចំ',
    es: 'Desbloquee el material restante que participa en la composición tipográfica',
    ar: 'فتح المواد المتبقية المشاركة في التنضيد',
  },
  'arrangedPage.maintain': {
    zh: '维持参与排版余料的锁定',
    en: 'Maintain the lock of remaining materials involved in typesetting',
    id: 'Pertahankan penguncian bahan residu yang terlibat dalam pengaturan huruf',
    kz: 'Тypes жүйесіне қосылған қалысқы материалдардың блоктауды сақтау',
    th: 'รักษาการล็อควัสดุตกค้างที่เกี่ยวข้องกับการเรียงพิมพ์',
    ug: 'تەرتىپلەشكە قاتناشقان قالدۇق ماتېرىياللارنىڭ قۇلۇپىنى ساقلاپ قىلىش',
    vi: 'Duy trì khóa phần còn lại của kiểu chữ tham gia',
    zh_tc: '維持參與排版餘料的鎖定',
    ru: 'Поддерживать блокировку остатков, участвующих в наборе',
    ko: '조판에 참여한 나머지 재료의 잠금을 유지하다',
    bur: 'ပြင်ဆင်မှုတွင်ပါဝင်သောပိုလျှံပစ္စည်းလော့ထိန်းသိမ်း',
    ben: 'লেআউটে অংশগ্রহণকারী উদ্বৃত্তের লক বজায় রাখুন',
    tr: 'Yerleşime dahil artığın kilidini koru',
    km: 'រក្សាសោសម្ភារៈសល់ដែលចូលរួមរៀបចំ',
    es: 'Mantenga el bloqueo del material restante que participa en la composición tipográfica',
    ar: 'الحفاظ على قفل المادة المتبقية المشاركة في التنضيد',
  },
  'arrangedPage.lockModalText': {
    zh: '存在使用余料大板被其他订单占用，是否重新排版',
    en: 'Is there a need to rearrange the layout of the leftover large board that has been occupied by other orders',
    id: 'Ada sepiring besar bahan residu yang digunakan untuk ditempati oleh pesanan lain. Apakah ini diketik ulang?',
    kz: 'Қалысқы материалдардың үлкен платкаға қосу түрде басқа тапсырыстармен арналған, тypes жүйесін қайта жасау керек пе',
    th: 'มีวัสดุตกค้างขนาดใหญ่ที่เคยครอบครองโดยคำสั่งซื้ออื่น ๆ มันพิมพ์ใหม่อีกครั้งหรือไม่?',
    ug: 'ئىشلىتىلىۋاتقان قالدۇق ماتېرىيال چوڭ تاختىسى باشقا زاكازغا ئىگە، قايتا تەرتىپلىسەن؟',
    vi: 'Có sử dụng các tấm lớn còn lại bị chiếm dụng bởi các đơn đặt hàng khác, có nên sắp xếp lại hay không',
    zh_tc: '存在使用餘料大板被其他訂單佔用，是否重新排版',
    ru: 'Наличие избыточной платы, занятой другими заказами, переиздание',
    ko: '사용 잔재 대판이 다른 주문서에 의해 점용되고 있는데, 재조판 여부',
    bur: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးကိုအခြားမှာယူမှုများသုံးနေ၍ ပြင်ဆင်မှုပြန်လုပ်မည်လား',
    ben: 'ব্যবহৃত উদ্বৃত্ত বড় বোর্ড অন্য অর্ডার দখল করেছে, পুনরায় লেআউট করবেন?',
    tr: 'Kullanılan artık levha başka siparişte; yeniden yerleştirilsin mi?',
    km: 'ផ្ទាំងសល់ប្រើឡើវិញត្រូវបានការបញ្ជារផ្សេងប្រើ តើរៀបចំឡើងវិញឬទេ?',
    es: 'Hay un material restante tablero ocupado por otros pedidos, si se debe volver a diseñar',
    ar: 'هناك مادة متبقية اللوحة مشغولة بأوامر أخرى، سواء لإعادة التخطيط',
  },
  'arrangedPage.lockNewSModalText': {
    zh: '当前使用余料大板被其他订单占用，是否继续下载NC',
    en: 'The current surplus material board is occupied by other orders. Do you want to continue downloading NC',
    id: 'Saat ini menggunakan pelat besar bahan residu ditempati oleh pesanan lain. Haruskah saya terus mengunduh NC?',
    kz: 'Ағымдағы қалысқы материалдардың үлкен платка басқа тапсырыстармен арналған, NC-файлдарды жүктеп алуды жалғастыру керек пе',
    th: 'ขณะนี้ใช้วัสดุที่เหลืออยู่จำนวนมากถูกครอบครองโดยคำสั่งซื้ออื่น ๆ ฉันควรดาวน์โหลด NC ต่อไปหรือไม่?',
    ug: 'نۆۋەتتە ئىشلىتىلىۋاتقان قالدۇق ماتېرىيال چوڭ تاختىسى باشقا زاكازغا ئىگە، NC نى داۋاملىق چۈشۈرەمسىز؟',
    vi: 'Hiện tại sử dụng tấm lớn dư liệu bị các đơn đặt hàng khác chiếm dụng, có nên tiếp tục tải NC không',
    zh_tc: '當前使用餘料大板被其他訂單佔用，是否繼續下載NC',
    ru: 'Текущее использование избыточной платы занято другими заказами, продолжать загрузку NC',
    ko: '현재 사용된 여분의 대판이 다른 주문에 의해 점용되고 있습니다. NC 다운로드 지속 여부',
    bur: 'လက်ရှိပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးကိုအခြားမှာယူမှုများသုံးနေ၍ NC ဆက်ဒေါင်းလုတ်မည်လား',
    ben: 'বর্তমান উদ্বৃত্ত বড় বোর্ড অন্য অর্ডার দখল করেছে, NC ডাউনলোড চালিয়ে যাবেন?',
    tr: 'Artık levha başka siparişte; NC indirmeye devam edilsin mi?',
    km: 'ផ្ទាំងសល់ត្រូវការបញ្ជារផ្សេងប្រើ តើបន្តទាញយក NC ឬទេ?',
    es: 'El tablero de material restante actualmente utilizado está ocupado por otros pedidos. Quieres continuar descargando NC',
    ar: 'لوحة المواد المتبقية المستخدمة حاليًا مشغولة بأوامر أخرى. هل تريد متابعة التنزيل NC',
  },
  'arrangedPage.rePaibanWarn': {
    zh: '余料大板被其他订单占用，可用大板不足，请到开料清单重新排版',
    en: 'The surplus large boards are occupied by other orders, and there is a shortage of available large boards. Please go to the material list to reformat',
    id: 'Piring besar bahan residu ditempati oleh pesanan lain, dan pelat besar tidak mencukupi. Silakan pergi ke daftar materi untuk mengaturnya kembali.',
    kz: 'Қалысқы материалдардың үлкен платка басқа тапсырыстармен арналған, қолжетерлік үлкен платка жеткіліксіз, ашу жайлық тізіміне қайта types жасау үшін қарай',
    th: 'แผ่นวัสดุที่เหลือขนาดใหญ่จะถูกครอบครองโดยคำสั่งซื้ออื่น ๆ และแผ่นขนาดใหญ่ไม่เพียงพอ โปรดไปที่รายการวัสดุเพื่อจัดเรียงใหม่',
    ug: 'ئىشلىتىلىۋاتقان قالدۇق ماتېرىيال چوڭ تاختىسى باشقا زاكازغا ئىگە، ئىشلىتىشكە بولىدىغان چوڭ تاختا يېتەرسىز، ماتېرىيال تىزىمىغا بېرىپ قايتا تەرتىپلەڭ',
    vi: 'Các tấm lớn còn lại được chiếm dụng bởi các đơn đặt hàng khác, không đủ các tấm lớn có sẵn, vui lòng sắp xếp lại danh sách mở',
    zh_tc: '餘料大板被其他訂單佔用，可用大板不足，請到開料清單重新排版',
    ru: 'Оставшаяся большая доска занята другими заказами, может быть недостаточно большой доски, пожалуйста, переформатируйте список открытых материалов',
    ko: '나머지 대판은 기타 주문서에 점용되어 사용 가능한 대판이 부족하니, 개료 명세서에 가서 다시 조판하십시오.',
    bur: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးကိုအခြားမှာယူမှုသုံးနေ၍ ပေါ်ဒ်ကြီးမလုံလောက်၊ ကုန်ကြမ်းစာရင်းတွင်ပြင်ဆင်မှုပြန်လုပ်ပါ',
    ben: 'উদ্বৃত্ত বড় বোর্ড অন্য অর্ডার দখল করেছে, বড় বোর্ড অপর্যাপ্ত, উপকরণ তালিকায় পুনরায় লেআউট করুন',
    tr: 'Artık levha başka siparişte; kullanılabilir büyük levha yetersiz, kesim listesinden yeniden yerleştirin',
    km: 'ផ្ទាំងសល់ត្រូវបានការបញ្ជារផ្សេងចាប់យោ ផ្ទាំងធំមិនគ្រប់គ្រាន់ សូមរៀបចំឡើងវិញពីបញ្ជីកាត់',
    es: 'Los tableros grandes restantes están ocupados por otros pedidos y no hay suficientes tableros grandes disponibles. Vaya a la lista de cortes para volver a diseñar',
    ar: 'اللوحات الكبيرة المتبقية مشغولة بأوامر أخرى، ولا يوجد ما يكفي من اللوحات الكبيرة المتوفرة. يرجى الانتقال إلى قائمة القطع لإعادة التخطيط',
  },
  'arrangedPage.sawRePaiban': {
    zh: '注意：您使用的是锯片切割，新增了异形板件排版，需要重新排版才可以输出NC文件',
    en: 'Attention: You are using a saw blade for cutting, and have added a layout for irregular plates. You need to reformat them to output NC files',
    id: 'Catatan: Anda menggunakan pemotongan bilah gergaji, dan tata letak pelat berbentuk khusus telah ditambahkan. Anda perlu mengetik ulang file NC untuk menjadi output.',
    kz: 'Аларым беріңіз: Сіз құрыш дәңгейіні қолданудасыз, қайшылық плиттардың түрлі құрылымын қосдыңыз, NC файлды жіберу үшін қайта түрлендіру керек',
    th: 'หมายเหตุ: คุณกำลังใช้การตัดใบเลื่อยและมีการเพิ่มเค้าโครงแผ่นรูปทรงพิเศษ คุณต้องพิมพ์ไฟล์ NC อีกครั้งเพื่อส่งออก',
    ug: 'دىققەت: سىز ھەرە پىچاق كېسىشنى ئىشلىتىۋاتىسىز، ئۆزگىچە شەكىللىك تاختا بۆلەك تەرتىپلەش قوشۇلدى، NC ھۆججىتىنى چىقىرىش ئۈچۈن قايتا تەرتىپلەش كېرەك',
    vi: 'Lưu ý: bạn đang sử dụng lưỡi cưa cắt, thêm bảng điều khiển đặc biệt sắp chữ, cần phải sắp xếp lại để xuất ra các tập tin NC',
    zh_tc:
      '注意：您使用的是鋸片切割，新增了異形板件排版，需要重新排版才可以輸出NC文件',
    ru: 'Примечание: Вы используете пиломатериалы для резки, добавлен фасонный набор панелей, требуется переформатирование для вывода NC - файлов',
    ko: '참고: 앤티앨리어싱을 사용하며 NC 파일을 내보내려면 레이아웃을 다시 작성해야 하는 이형 플레이트 레이아웃이 추가되었습니다.',
    bur: 'သတိ: ဓားရွက်ဖြင့်ဖြတ်ကာကျဉ်းချောင်းပေါ်ဒ်ပြင်ဆင်မှုထပ်ထည့်ပြီ၊ NC ဖိုင်ထုတ်ဖို့ပြင်ဆင်မှုပြန်လုပ်ရမည်',
    ben: 'মনোযোগ: করাত দিয়ে কাটা ব্যবহার করা হচ্ছে, অনিয়মিত বোর্ড লেআউট যোগ করা হয়েছে, NC ফাইল আউটপুট করতে পুনরায় লেআউট প্রয়োজন',
    tr: 'Dikkat: Testere ile kesim kullanıyorsunuz; düzensiz parça yerleşimi eklendi, NC çıktısı için yeniden yerleştirme gerekir',
    km: 'កត់សម្គាល់៖ ប្រើកាំបិតកាត់ បានបន្ថែមការរៀបចំផ្ទាំងរាងមិនធម្មតា ត្រូវរៀបចំឡើងវិញដើម្បីទាញយក NC',
    es: 'Nota: está utilizando una hoja de sierra para cortar y se ha agregado un diseño de tabla con una forma especial. Debe volver a diseñar antes de poder generar el archivo NC',
    ar: 'ملاحظة: أنت تستخدم شفرة منشار للقطع، وقد تمت إضافة تخطيط لوحة ذات شكل خاص. تحتاج إلى إعادة التخطيط قبل أن تتمكن من إخراج ملف NC',
  },
  'arrangedPage.togglePlankTip': {
    zh: '板件存在拉槽特殊工艺或特殊异形板，不支持正反面切换操作！',
    en: 'The plank has a special grooving process and does not support front and back switching!',
    id: 'Papan memiliki proses khusus slot tarik, tidak mendukung operasi pergantian sisi depan dan belakang!',
    kz: 'Тақтайда арнайы ойық жасау процесі бар, алдыңғы және артқы жағын ауыстыруға болмайды!',
    th: 'แผ่นมีกระบวนการพิเศษในการดึงร่อง ไม่รองรับการสลับด้านหน้าและด้านหลัง!',
    ug: 'تاختا بۆلەكتە ئويۇق ئالاھىدە پىروگراممىسى بار، ئالدىنقى-ئارقا تەرەپ ئالماشتۇرۇشقا قوللىمايدۇ!',
    vi: 'Tấm ván có quy trình rãnh đặc biệt, không hỗ trợ thao tác chuyển đổi mặt trước và sau!',
    zh_tc: '板件存在拉槽特殊工藝，不支持正反面切換操作！',
    ru: 'Пластина имеет специальную технологию вытягивания канавки, не поддерживает операции положительного и отрицательного переключения!',
    ko: '판재 부품에 슬롯 당기기 특수 공정이 존재하므로 정면과 후면 전환 작업을 지원하지 않습니다!',
    bur: 'ပေါ်ဒ်တွင်ဆွဲချောင်းအထူးလုပ်ငန်းစဉ်ရှိ၍ ရှေ့နောက်ပြောင်းကိုမထောက်ခံ!',
    ben: 'বোর্ডে বিশেষ স্লটিং প্রক্রিয়া আছে, সামনে ও পিছনে বদলানো সমর্থিত নয়!',
    tr: 'Özel oluk nedeniyle ön-arka yüz değiştirme desteklenmiyor',
    km: 'ផ្ទាំងមានរន្ធពិសេស មិនគាំទ្រប្តូរផ្ទៃមុខ/ក្រោយ',
    es: '. Los paneles tienen un proceso de ranura especial y las operaciones de cambio frontal y posterior no son compatibles.',
    ar: 'تتمتع اللوحات بعملية أخدود خاصة، ولا يتم دعم عمليات التبديل الأمامية والخلفية!',
  },
  'arrangedPage.stepCuttingMsg': {
    zh: '分层切割深度必须小于板件厚度',
    en: 'The layered cutting depth must be less than the board thickness',
    id: 'Kedalaman pemotongan berlapis harus lebih kecil dari ketebalan papan',
    kz: 'Қабаттап кесу тереңдігі тақтаның қалыңдығынан кіші болуы керек',
    th: 'ความลึกในการตัดเป็นชั้นต้องน้อยกว่าความหนาของแผ่น',
    ug: 'قەۋەتلىك كېسىش چوڭقۇرلۇقى تاختا قېلىنلىقىدىن كىچىك بولۇشى كېرەك',
    vi: 'Độ sâu cắt phân lớp phải nhỏ hơn độ dày của tấm',
    zh_tc: '分層切割深度必須小於板件厚度',
    ru: 'Глубина слоистой резки должна быть меньше толщины пластины',
    ko: '계층형 컷 깊이는 보드 두께보다 작아야 합니다.',
    bur: 'ထပ်ဆင့်ဖြတ်နက်သည်ပေါ်ဒ်အထူထက်နည်းရမည်',
    ben: 'স্তরযুক্ত কাটার গভীরতা বোর্ডের পুরুত্বের চেয়ে কম হতে হবে',
    tr: 'Katmanlı kesim derinliği levha kalınlığından küçük olmalı',
    km: 'ជម្រៅកាត់ជាន់ទ្រែត្រូវតិចជាងកម្រាស់ផ្ទាំង',
    es: 'La profundidad del corte en capas debe ser menor que el espesor de la placa',
    ar: 'يجب أن يكون عمق القطع ذو الطبقات أقل من سمك اللوحة',
  },
  'arrangedPage.stepCuttingMsg2': {
    zh: '分层切割深度只能输入大于0的数字',
    en: 'The layered cutting depth can only be a number greater than 0',
    id: 'Kedalaman pemotongan berlapis hanya dapat memasukkan angka yang lebih besar dari 0',
    kz: 'Қабаттап кесу тереңдігі тек 0-ден үлкен сан болуы керек',
    th: 'ความลึกในการตัดเป็นชั้นต้องป้อนตัวเลขที่มากกว่า 0 เท่านั้น',
    ug: 'قەۋەتلىك كېسىش چوڭقۇرلۇقى 0 دىن چوڭ سان بولۇشى كېرەك',
    vi: 'Độ sâu cắt phân lớp chỉ có thể nhập số lớn hơn 0',
    zh_tc: '分層切割深度只能輸入大於0的數字',
    ru: 'Глубина стратификации может вводить только цифры больше 0.',
    ko: '계층형 컷 깊이는 0보다 큰 숫자만 입력할 수 있습니다.',
    bur: 'ထပ်ဆင့်ဖြတ်နက်တွင်သုည(0)ထက်ကြီးသောနံပါတ်သာထည့်နိုင်',
    ben: 'স্তরযুক্ত কাটার গভীরতায় শুধুমাত্র 0-এর চেয়ে বড় সংখ্যা লেখা যাবে',
    tr: "Katmanlı kesim derinliği yalnızca 0'dan büyük bir sayı olabilir",
    km: 'ជម្រៅកាត់ជាន់ទ្រែត្រូវជាលេខធំជាង ០ ប៉ុណ្ណោះ',
    es: 'La profundidad del corte en capas solo se puede ingresar como un número mayor que 0',
    ar: 'لا يمكن إدخال عمق القطع ذو الطبقات إلا كرقم أكبر من 0',
  },
  'arrangedPage.flipPlankTip': {
    zh: '已开启孔槽分流开料机加工单面板，不允许翻板操作！',
    en: 'The flip operation is not allowed because the hole slot engraving process of the single-panel processing machine is enabled!',
    id: 'Operasi pembalikan tidak diizinkan karena proses pemotongan slot lubang pemotongan mesin pemotongan papan tunggal diaktifkan!',
    kz: 'Қалысқы материалдардың үлкен платка басқа тапсырыстармен арналған, қолжетерлік үлкен платка жеткіліксіз, ашу жайлық тізіміне қайта types жасау үшін қарай',
    th: 'การสลับด้านหน้าและด้านหลังไม่รองรับเนื่องจากกระบวนการดึงร่องช่องหลุมการตัดเครื่องตัดแผ่นที่เปิดใช้งาน!',
    ug: 'تەرتىپلەشكە قاتناشقان قالدۇق ماتېرىيال چوڭ تاختىسى باشقا زاكازغا ئىگە، پىچاق كېسىش كىلىشىش تەرتىپلەشكە بولمايدۇ!',
    vi: 'Đã bật quy trình rãnh khoét trên máy cắt tấm đơn, không hỗ trợ thao tác đảo ngược!',
    zh_tc: '已開啟孔槽分流開料機加工單面板，不允許翻板操作！',
    ru: 'Открыл отверстие канавки шунт машина для обработки одной панели, не допускается работа опрокидывания!',
    ko: '구멍 슬롯 분류 원료 공급기 가공 단일 패널이 열렸습니다. 판을 뒤집는 작업은 허용되지 않습니다!',
    bur: 'ပေါက်/ချောင်းခွဲစင်ဖြတ်စက်တစ်ဖက်ပေါ်ဒ်ဖွင့်ထားသဖြင့်ပြောင်းဘက်ခွင့်မပြု!',
    ben: 'গর্ত-স্লট বিভাজন কাটার মেশিনে এককলেখ বোর্ড প্রক্রিয়া চালু করা হয়েছে, উল্টানো অপারেশন অনুমোদিত নয়!',
    tr: 'Delik-akış panel işlemi açık; levha çevirme yapılamaz',
    km: 'បានបើកដំណើរការរណ្តៅ/រន្ធបំបែក មិនអាចបញ្ច្រាសផ្ទាំង',
    es: '¡La máquina de corte por ranura se ha encendido para procesar un solo panel y no se permite la operación de giro de la placa!',
    ar: 'تم تشغيل آلة القطع المنقسمة ذات الفتحة لمعالجة لوحة واحدة، ولا يُسمح بعملية تدوير اللوحة!',
  },
  'arrangedPage.genNoCutTagNotSupportExportPic': {
    zh: '已开启生成不下料板件标签，暂不支持导出图片',
    en: 'Generate no-cut tag is enabled, export image is not supported',
    id: 'Tag tanpa potong diaktifkan, ekspor gambar tidak didukung',
    kz: 'Кесілмеген тег қосу қосылған, сурет экспорттау қолдау көрсетілмейді',
    th: 'เปิดใช้งานแท็กไม่ตัดแล้ว ไม่รองรับการส่งออกรูปภาพ',
    ug: 'كەسمەس تېگ قوشۇش قوزغىتىلدى، رەسىم چىقىرىش قوللاش قىلىنمايدۇ',
    vi: 'Đã bật tạo nhãn không cắt, không hỗ trợ xuất hình ảnh',
    zh_tc: '已開啟生成不下料板件標籤，暫不支持導出圖片',
    ru: 'Открыта вкладка для создания несмываемых элементов, пока не поддерживается экспорт изображений',
    ko: '원판 부품 태그 생성이 켜져 있으며 그림 내보내기가 지원되지 않음',
    bur: 'မဖြတ်ပေါ်ဒ်တံဆိပ်ဖန်တီးဖွင့်ထားသဖြင့်ဓာတ်ပုံထုတ်ကိုယာယီမထောက်ခံ',
    ben: 'নো-কাট ট্যাগ তৈরি চালু আছে, ছবি রপ্তানি সমর্থিত নয়',
    tr: 'Kesilmez etiket oluşturma açık; görüntü dışa aktarımı desteklenmiyor',
    km: 'បានបើកបង្កើតស្លាកផ្ទាំងមិនកាត់ មិនទាន់គាំទ្រនាំចេញរូប',
    es: 'Se ha habilitado la generación de etiquetas para piezas de placa sin cortar. Por el momento no se admite la exportación de imágenes.',
    ar: 'تم تمكين إنشاء ملصقات لأجزاء اللوحة غير المقطوعة. تصدير الصور غير مدعوم في الوقت الحالي.',
  },
  'arrangedPage.allSmallPlanksAreNoCutNotInLayout': {
    zh: '当前小板均为不下料板件，不参与排版',
    en: 'All small planks are no-cut planks and do not participate in layout',
    id: 'Semua papan kecil adalah papan tanpa potong dan tidak berpartisipasi dalam tata letak',
    kz: 'Барлық кіші тақталар кесілмеген тақталар және орналастыруға қатыспайды',
    th: 'แผ่นเล็กทั้งหมดเป็นแผ่นไม่ตัดและไม่เข้าร่วมในการจัดวาง',
    ug: 'بارلىق كىچىك تاختىلار كەسمەس تاختىلار بولۇپ، تەرتىپلەشكە قاتنىشمايدۇ',
    vi: 'Tất cả các tấm nhỏ đều là tấm không cắt và không tham gia bố cục',
    zh_tc: '當前小板均為不下料板件，不參與排版',
    ru: 'В настоящее время доски не являются частью досок, не участвуют в наборе',
    ko: '현재 소판은 모두 재료를 넣지 않고 조판에 참여하지 않는다',
    bur: 'လက်ရှိပေါ်ဒ်ငယ်အားလုံးသည်မဖြတ်ပေါ်ဒ်ဖြစ်၍ ပြင်ဆင်မှုတွင်မပါဝင်',
    ben: 'সব ছোট বোর্ড নো-কাট বোর্ড, লেআউটে অংশগ্রহণ করে না',
    tr: 'Tüm küçük levhalar kesilmez; yerleşime dahil değil',
    km: 'ផ្ទាំងតូចទាំងអស់ជាផ្ទាំងមិនកាត់ មិនចូលរួមរៀបចំ',
    es: 'Las planchas pequeñas actuales son todas planchas sin cortar y no participan en la composición tipográfica.',
    ar: 'اللوحات الصغيرة الحالية كلها لوحات غير مقطعة ولا تشارك في التنضيد.',
  },
  'arrangedPage.canStillExportHoleSlotOrPrintTag': {
    zh: '您仍可继续导出孔槽加工文件，或打印标签',
    en: 'You can still export hole and slot processing files, or print tags',
    id: 'Anda masih dapat mengekspor file pemrosesan lubang dan slot, atau mencetak tag',
    kz: 'Сіз әлі де тесік пен ойық өңдеу файлдарын экспорттауға немесе тегтерді басып шығаруға болады',
    th: 'คุณยังสามารถส่งออกไฟล์การประมวลผลรูและช่อง หรือพิมพ์แท็กได้',
    ug: 'سىز يەنىلا تۆشۈك ۋە ئۆيۈك بىر تەرەپ قىلىش ھۆججەتلىرىنى چىقىرىپ ياكى تېگ بېسىپ چىقىرىپ بېرەلەيسىز',
    vi: 'Bạn vẫn có thể xuất tệp xử lý lỗ và khe, hoặc in nhãn',
    zh_tc: '您仍可繼續導出孔槽加工文件，或打印標籤',
    ru: 'Вы все еще можете продолжать экспортировать файлы обработки отверстий или распечатывать теги',
    ko: '구멍 슬롯 가공 파일을 내보내거나 레이블을 인쇄할 수 있습니다.',
    bur: 'ပေါက်/ချောင်းဖိုင်ထုတ်ခြင်း သို့မဟုတ် တံဆိပ်ရိုက်နှိပ်ခြင်းဆက်လုပ်နိုင်',
    ben: 'আপনি এখনও গর্ত ও স্লট প্রক্রিয়াকরণ ফাইল রপ্তানি করতে বা ট্যাগ মুদ্রণ করতে পারবেন',
    tr: 'Delik/oluk işleme dosyasını dışa aktarmaya veya etiket yazdırmaya devam edebilirsiniz',
    km: 'អ្នកអាចបន្តនាំចេញឯកសារដំណើរការរណ្តៅ/រន្ធ ឬបោះពុម្ពស្លាក',
    es: 'Aún puedes continuar exportando archivos de procesamiento de agujeros o imprimiendo etiquetas.',
    ar: 'لا يزال بإمكانك الاستمرار في تصدير ملفات معالجة الثقب أو طباعة الملصقات.',
  },
  'arrangedPage.desMaterialNoCutNotSupportSwitchLine': {
    zh: '当前生产线已开启指定小板材质不下料，暂不支持直接切换生产线',
    en: 'Current production line has enabled designated small plank material no-cut, direct line switching is not supported',
    id: 'Garis produksi saat ini telah mengaktifkan material papan kecil yang ditentukan tanpa potong, pengalihan garis langsung tidak didukung',
    kz: 'Ағымдағы өндіріс желісі көрсетілген кіші тақта материалын кесілмеген ретінде қосқан, тікелей желі ауыстыру қолдау көрсетілмейді',
    th: 'สายการผลิตปัจจุบันได้เปิดใช้งานวัสดุแผ่นเล็กที่กำหนดไว้ไม่ตัด การสลับสายโดยตรงไม่ได้รับการสนับสนุน',
    ug: 'نۆۋەتتىكى ئىشلەپچىقىرىش سىزىمى بەلگىلەنگەن كىچىك تاختا ماتېرىيالىنى كەسمەس دەپ قوزغىتىپ قويغان، بىۋاستە سىزىم ئالماشتۇرۇش قوللاش قىلىنمايدۇ',
    vi: 'Dây chuyền sản xuất hiện tại đã bật vật liệu tấm nhỏ được chỉ định không cắt, không hỗ trợ chuyển đổi dây chuyền trực tiếp',
    zh_tc: '當前生產線已開啟指定小板材質不下料，暫不支持直接切換生產線',
    ru: 'Текущая производственная линия была открыта для указанного материала, пока не поддерживается прямое переключение производственной линии',
    ko: '현재 생산라인이 이미 열려 있어 지정된 슬레이트 재료가 원료를 공급하지 않으며, 직접 생산라인 전환은 잠시 지원되지 않습니다.',
    bur: 'လက်ရှိထုတ်လုပ်မှုလိုင်းတွင်သတ်မှတ်ပေါ်ဒ်ငယ်ပစ္စည်းမဖြတ်ဖွင့်ထားသဖြင့်ထုတ်လုပ်မှုလိုင်းတိုက်ရိုက်ပြောင်းမထောက်ခံ',
    ben: 'বর্তমান উৎপাদন লাইনে নির্দিষ্ট ছোট বোর্ড উপকরণ নো-কাট সক্ষম করা হয়েছে, সরাসরি লাইন পরিবর্তন সমর্থিত নয়',
    tr: 'Belirlenmiş küçük levha malzemesi kesilmez modu açık; doğrudan hat değiştirme desteklenmiyor',
    km: 'បើកម៉ូដផ្ទាំងតូចបានកំណត់មិនកាត់ មិនគាំទ្រប្ដូរបន្ទាត់ផ្ទាល់',
    es: 'La línea de producción actual ha sido encendida. El material de placa pequeña especificado no se corta. Por el momento no se admite el cambio directo de la línea de producción.',
    ar: 'تم تشغيل خط الإنتاج الحالي. لم يتم قطع مادة اللوحة الصغيرة المحددة. التبديل المباشر لخط الإنتاج غير مدعوم في الوقت الحالي.',
  },
  'arrangedPage.desMaterialNoCutSettingChanged': {
    zh: '系统检测到指定小板材质不下料的设置被修改，请重新排版确保生产准确',
    en: 'System detected that the setting for designated small plank material no-cut has been modified, please re-layout to ensure production accuracy',
    id: 'Sistem mendeteksi bahwa pengaturan material papan kecil yang ditentukan tanpa potong telah dimodifikasi, harap tata ulang untuk memastikan akurasi produksi',
    kz: 'Жүйе көрсетілген кіші тақта материалын кесілмеген параметрлерінің өзгертілгенін анықтады, өндірістің дәлдігін қамтамасыз ету үшін қайта орналастырыңыз',
    th: 'ระบบตรวจพบว่าการตั้งค่าวัสดุแผ่นเล็กที่กำหนดไว้ไม่ตัดถูกแก้ไข กรุณาจัดวางใหม่เพื่อให้แน่ใจว่าการผลิตมีความถูกต้อง',
    ug: 'سىستېما بەلگىلەنگەن كىچىك تاختا ماتېرىيالىنى كەسمەس تەڭشىكىنىڭ ئۆزگەرتىلگەنلىكىنى بايقىدى، ئىشلەپچىقىرىشنىڭ توغرا بولۇشىنى كاپالەتلەش ئۈچۈن قايتا تەرتىپلەڭ',
    vi: 'Hệ thống phát hiện cài đặt vật liệu tấm nhỏ được chỉ định không cắt đã được sửa đổi, vui lòng bố cục lại để đảm bảo độ chính xác sản xuất',
    zh_tc: '系統檢測到指定小板材質不下料的設置被修改，請重新排版確保生產準確',
    ru: 'Система обнаруживает, что настройки указанного материала панели не были изменены, пожалуйста, переформатируйте, чтобы убедиться, что производство точно',
    ko: '지정한 슬래브 재료의 재료가 들어가지 않는 설정이 수정된 것을 감지했습니다. 정확한 생산을 위해 재조판하십시오.',
    bur: 'သတ်မှတ်ပေါ်ဒ်ငယ်ပစ္စည်းမဖြတ်ဆက်တင်ပြောင်းလဲကြောင်းစစ်ဆေးတွေ့ရှိ၊ ထုတ်လုပ်မှုတိကျမှုသေချာစေဖို့ပြင်ဆင်မှုပြန်လုပ်ပါ',
    ben: 'নির্দিষ্ট ছোট বোর্ড উপকরণ নো-কাট সেটিং পরিবর্তিত হয়েছে, উৎপাদন নির্ভুলতা নিশ্চিত করতে পুনরায় লেআউট করুন',
    tr: 'Sistem belirlenmiş küçük levha kesilmez ayarının değiştiğini algıladı; üretim doğruluğu için yeniden yerleştirin',
    km: 'ប្រព័ន្ធរកឃើញការកំណត់ផ្ទាំងតូចមិនកាត់បានផ្លាស់ប្ដូរ សូមរៀបចំឡើងវិញដើម្បីភាពត្រឹមត្រូវ',
    es: 'El sistema ha detectado que se ha modificado la configuración de no cortar el material de placa pequeña especificado. Vuelva a diseñar para garantizar una producción precisa',
    ar: 'اكتشف النظام أنه تم تعديل إعداد عدم قطع مادة اللوحة الصغيرة المحددة. يرجى إعادة التخطيط لضمان دقة الإنتاج',
  },
  'arrangedPage.continueDownload': {
    zh: '继续下载',
    en: 'Continue Download',
    id: 'Lanjutkan Unduh',
    kz: 'Жүктеуді жалғастыру',
    th: 'ดาวน์โหลดต่อ',
    ug: 'چۈشۈرۈشنى داۋاملاشتۇرۇش',
    vi: 'Tiếp tục tải xuống',
    zh_tc: '繼續下載',
    ru: 'Продолжить загрузку',
    ko: '다운로드 계속',
    bur: 'ဆက်ဒေါင်းလုတ်',
    ben: 'ডাউনলোড চালিয়ে যান',
    tr: 'İndirmeye devam et',
    km: 'បន្តទាញយក',
    es: 'Continuar descargando',
    ar: 'متابعة التنزيل',
  },
  'arrangedPage.desMaterialNoCutErrorTip': {
    zh: '指定小板材质不下料的板件中存在分配到雕刻机加工的孔槽/异形，本次下载孔槽/异形均分配到五六面钻加工，是否继续下载文件',
    en: 'There are holes/slots/shapes assigned to engraving machine processing in the planks with designated small plank material no-cut. All holes/slots/shapes in this download are assigned to 5/6-sided drill processing. Do you want to continue downloading the file?',
    id: 'Ada lubang, slot dan bentuk tidak beraturan yang ditugaskan ke pemrosesan mesin ukir dalam papan dengan material papan kecil yang ditentukan tanpa potong. Semua lubang, slot dan bentuk tidak beraturan dalam unduhan ini ditugaskan ke pemrosesan bor 5/6 sisi. Apakah Anda ingin melanjutkan mengunduh file?',
    kz: 'Белгіленген кіші тақтай материалы кесілмеген тақтайларда ою машинасына берілген тесіктер/оңықтар/бітік пішіндер бар. Осы жүктемедегі барлық тесіктер/оңықтар/бітік пішіндер бес/алты жақты бұрғылауға берілген. Файлды жүктеуді жалғастырғыңыз келе ме?',
    th: 'มีรู ช่อง และรูปร่างพิเศษที่กำหนดให้เครื่องแกะสลักประมวลผลในแผ่นที่มีวัสดุแผ่นเล็กที่กำหนดไว้ไม่ตัด รู ช่อง และรูปร่างพิเศษทั้งหมดในการดาวน์โหลดครั้งนี้ถูกกำหนดให้สว่าน 5/6 ด้านประมวลผล คุณต้องการดาวน์โหลดไฟล์ต่อไปหรือไม่?',
    ug: 'There are holes/slots/shapes assigned to engraving machine processing in the planks with designated small plank material no-cut. All holes/slots/shapes in this download are assigned to 5/6-sided drill processing. Do you want to continue downloading the file?',
    vi: 'Có lỗ, khe và hình dạng không đều được phân bổ cho xử lý máy khắc trong các tấm có vật liệu tấm nhỏ được chỉ định không cắt. Tất cả lỗ, khe và hình dạng không đều trong lần tải xuống này được phân bổ cho xử lý khoan 5/6 mặt. Bạn có muốn tiếp tục tải xuống tệp không?',
    zh_tc:
      '指定小板材質不下料的板件中存在分配到雕刻機加工的孔槽/異形，本次下載孔槽/異形均分配到五六面鑽加工，是否繼續下載文件',
    ru: 'Укажите, что материал листовой пластины не загружается в пластине, где есть отверстие / фасон, выделенный для обработки гравировальной машины, загрузочный отверстие / фасон распределяются на пять или шесть сторон обработки бурения, продолжать загрузку файла',
    ko: '조각기 머시닝에 할당된 슬롯 / 이형이 슬롯 재료에 재료가 들어가지 않는 슬롯 / 이형에 있음을 지정합니다. 이번 다운로드 슬롯 / 이형은 모두 5, 6면 드릴링에 할당됩니다. 파일 다운로드 지속 여부',
    bur: 'သတ်မှတ်ပေါ်ဒ်ငယ်ပစ္စည်းမဖြတ်တွင်ထွင်းဆာင်းစက်ဆောင်ရွက်ရသောပေါက်/ချောင်းရှိ၊ ဤဒေါင်းလုတ်တွင်ပေါက်/ချောင်းအားလုံးငါးခြမ်း/ခြောက်ခြမ်းထွင်းဆာင်းဆောင်ရွက်ဖို့ပြောင်းသည်',
    ben: 'নির্দিষ্ট নো-কাট বোর্ডে খোদাই মেশিনে বরাদ্দ গর্ত/স্লট আছে, এবার ডাউনলোডে সব ৫/৬-পার্শ্বিক ড্রিলিংয়ে বরাদ্দ করা হচ্ছে, ফাইল ডাউনলোড চালিয়ে যাবেন?',
    tr: 'Kesilmez malzemeli levhalar oyma makinesine atanmış delik/oluk/şekil içeriyor; bu indirmede hepsi 5/6 yüz matkaba yönlendirildi. Dosya indirmeye devam edilsin mi?',
    km: 'មានរណ្តៅ/រន្ធ/រាងបញ្ជូលម៉ាស៊ីនចិញ្ចៀននៅលើផ្ទាំងមិនកាត់។ ការទាញយកនេះគ្របទាំងអស់ទៅដីសគី ៥/៦ ផ្ទៃ។ បន្តទាញយកឯកសារឬទេ?',
    es: 'Hay agujeros/formas especiales asignadas a la máquina de grabado en los paneles especificados para no cortar el material de la placa pequeña. Todos los agujeros/formas especiales de esta descarga están asignados a perforaciones de cinco o seis lados. ¿Desea continuar descargando el archivo?',
    ar: 'توجد ثقوب/أشكال خاصة مخصصة لآلة النقش في اللوحات المحددة بحيث لا يتم قطع مادة اللوحة الصغيرة. تم تخصيص جميع الثقوب/الأشكال الخاصة الموجودة في هذا التنزيل للحفر بخمسة أو ستة جوانب. هل تريد مواصلة تنزيل الملف',
  },
  'paibanImg.title': {
    zh: '排版图管理',
    en: 'Nest Drawing Mgmt',
    id: 'Manajemen tipografi',
    kz: 'Макет басқару',
    th: 'การจัดการแผนภูมิการพิมพ์',
    ug: 'بېسىش سىزىمى باشقۇرۇشى',
    vi: 'Quản lý Typographic',
    zh_tc: '排版圖管理',
    ru: 'Управление типографскими диаграммами',
    ko: '조판도 관리',
    bur: 'ပြင်ဆင်မှုပုံစံစီမံ',
    ben: 'লেআউট ডায়াগ্রাম ব্যবস্থাপনা',
    tr: 'Yerleşim diyagramı yönetimi',
    km: 'ការគ្រប់គ្រងរូបរៀបចំ',
    es: 'Gestión de diseño',
    ar: 'إدارة التخطيط',
  },
  'paibanImg.exportCustomPaibanImg': {
    zh: '导出自定义排版图',
    en: 'Export custom layout diagram',
    id: 'Ekspor tata letak khusus',
    kz: 'Пайдаланушы таңдаған макет суретін экспорттау',
    th: 'ส่งออกแผนภูมิการพิมพ์ที่กำหนดเอง',
    ug: 'ئىشلەتكۈچى بەلگىلىگەن تەرتىپلەش رەسىمىنى ئېكسپورت قىلىش',
    vi: 'Xuất biểu đồ kiểu chữ tùy chỉnh',
    zh_tc: '匯出自定義排版圖',
    ru: 'Экспорт настраиваемой типографики',
    ko: '사용자 지정 배열도 내보내기',
    bur: 'စိတ်ကြိုက်ပြင်ဆင်မှုပုံဓာတ်ထုတ်',
    ben: 'কাস্টম লেআউট ডায়াগ্রাম রপ্তানি করুন',
    tr: 'Özel yerleşim diyagramını dışa aktar',
    km: 'នាំចេញរូបរៀបចំតម្លាប់ខ្លួនឯង',
    es: 'Exportar diseño personalizado',
    ar: 'تصدير تخطيط مخصص',
  },
  'paibanImg.customPaibanImg': {
    zh: '自定义排版图',
    en: 'Customized layout diagram',
    id: 'Tata letak khusus',
    kz: 'Жекелей реттелген кескін',
    th: 'แผนภูมิการพิมพ์ที่กำหนดเอง',
    ug: 'ئۆزلەشتۈرۈلگەن تەرتىپلەش رەسىمى',
    vi: 'Biểu đồ kiểu chữ tùy chỉnh',
    zh_tc: '自定義排版圖',
    ru: 'Настройка графика',
    ko: '사용자 지정 조판도',
    bur: 'စိတ်ကြိုက်ပြင်ဆင်မှုပုံ',
    ben: 'কাস্টম লেআউট ডায়াগ্রাম',
    tr: 'Özel yerleşim diyagramı',
    km: 'រូបរៀបចំតម្លាប់ខ្លួនឯង',
    es: 'Diseño personalizado',
    ar: 'تخطيط مخصص',
  },
  'paibanImg.isCustomName': {
    zh: '自定义排版图名',
    en: 'Customized layout name',
    id: 'Nama tata letak khusus',
    kz: 'Жекелей реттелген кескін аты',
    th: 'ชื่อแผนภาพการพิมพ์ที่กำหนดเอง',
    ug: 'ئۆزلەشتۈرۈلگەن تەرتىپلەش ئاتى',
    vi: 'Tên biểu đồ kiểu chữ tùy chỉnh',
    zh_tc: '自定義排版圖名',
    ru: 'Название настраиваемого типографики',
    ko: '사용자 지정 조판도 이름',
    bur: 'စိတ်ကြိုက်ပြင်ဆင်မှုပုံအမည်',
    ben: 'কাস্টম লেআউট ডায়াগ্রাম নাম',
    tr: 'Özel yerleşim adı',
    km: 'ឈ្មោះរូបរៀបចំតម្លាប់ខ្លួនឯង',
    es: 'Nombre de diseño personalizado',
    ar: 'اسم تخطيط مخصص',
  },
  'paibanImg.template': {
    zh: '排版图模板',
    en: 'Layout template',
    id: 'Templat grafik tipografi',
    kz: 'Құрастыру схемасының шаблоны',
    th: 'เทมเพลตแผนภาพการพิมพ์',
    ug: 'تەڭشەلەش قىرماق قۇرال',
    vi: 'Bản mẫu thiết kế trang bốc',
    zh_tc: '排版圖範本',
    ru: 'Шаблоны: типографики',
    ko: '조판 템플릿',
    bur: 'ပြင်ဆင်မှုပုံပုံစံ',
    ben: 'লেআউট টেমপ্লেট',
    tr: 'Yerleşim şablonu',
    km: 'គំរូរូបរៀបចំ',
    es: 'Plantilla de diseño',
    ar: 'قالب تخطيط',
  },
  'paibanImg.addTem': {
    zh: '添加模板',
    en: 'Add template',
    id: 'Tambahkan Template',
    kz: 'шаблон қосу',
    th: 'เพิ่มแม่แบบ',
    ug: 'مۇثال قوشۇش',
    vi: 'Thêm mẫu',
    zh_tc: '添加範本',
    ru: 'Добавить шаблон',
    ko: '템플릿 추가',
    bur: 'ပုံစံထည့်',
    ben: 'টেমপ্লেট যোগ করুন',
    tr: 'Şablon ekle',
    km: 'បន្ថែមគំរូ',
    es: 'Agregar plantilla',
    ar: 'إضافة قالب',
  },
  'paibanImg.canvasIndexSearch': {
    zh: '大板序号搜索',
    en: 'Large board number search',
    id: 'Pencarian nomor seri papan besar',
    kz: 'Бақтанын нөмірін іздеу',
    th: 'ค้นหาหมายเลขบอร์ดใหญ่',
    ug: 'بەلگە نۇمۇرىنى ئەراز قىلىش',
    vi: 'Tìm kiếm số sê-ri bảng lớn',
    zh_tc: '大板序號蒐索',
    ru: 'Поиск по серийному номеру',
    ko: '보드 번호 검색',
    bur: 'ပေါ်ဒ်ကြီးနံပါတ်ရှာ',
    ben: 'বড় বোর্ড সিরিয়াল নম্বর অনুসন্ধান',
    tr: 'Büyük levha sıra numarası ara',
    km: 'ស្វែងរកលេខលំដាប់ផ្ទាំងធំ',
    es: 'Búsqueda de número de serie de placa grande',
    ar: 'بحث عن رقم تسلسلي كبير للوحة',
  },
  'paibanImg.symbol': {
    zh: '排版图标识',
    en: 'Layout icon recognition',
    id: 'Identifikasi Grafik Tipografi',
    kz: 'Қойын басылымын көрсеткіштері',
    th: 'ความรู้เกี่ยวกับไอคอนการพิมพ์',
    ug: 'چاپ ھەققىدە تەرەپپۇلۇش',
    vi: 'Biểu thượng đồ dàn bố',
    zh_tc: '排版圖標識',
    ru: 'Значок набора',
    ko: '조판도 표식',
    bur: 'ပြင်ဆင်မှုပုံအမှတ်အသား',
    ben: 'লেআউট ডায়াগ্রাম আইকন',
    tr: 'Yerleşim diyagramı simgesi',
    km: 'សញ្ញារូបរៀបចំ',
    es: 'Identificación de diseño',
    ar: 'تحديد التخطيط',
  },
  'paibanImg.frontSlot': {
    zh: '正面槽',
    en: 'Front slot',
    id: 'Slot depan',
    kz: 'Қарсы шығанақ',
    th: 'ช่องด้านหน้า',
    ug: 'مەھىل جەڭىسى',
    vi: 'Góc xốp mặt trước',
    zh_tc: '正面槽',
    ru: 'лобовой желоб',
    ko: '전면 슬롯',
    bur: 'ရှေ့ချောင်း',
    ben: 'সামনের স্লট',
    tr: 'Ön oluk',
    km: 'រន្ធខាងមុខ',
    es: 'Ranura frontal',
    ar: 'الفتحة الأمامية',
  },
  'paibanImg.backSlot': {
    zh: '反面槽',
    en: 'Reverse slot',
    id: 'Slot belakang',
    kz: 'Теріс шығанақ',
    th: 'ร่องย้อนกลับ',
    ug: 'تەرەپ شىغاناق',
    vi: 'Vốt mặt phản',
    zh_tc: '反面槽',
    ru: 'Обратный жёлоб',
    ko: '후면 슬롯',
    bur: 'နောက်ချောင်း',
    ben: 'পিছনের স্লট',
    tr: 'Arka oluk',
    km: 'រន្ធខាងក្រោយ',
    es: 'Ranura posterior',
    ar: 'الفتحة الخلفية',
  },
  'paibanImg.frontHole': {
    zh: '正面孔',
    en: 'Front hole',
    id: 'Lubang depan',
    kz: 'ең қарсы құбыр',
    th: 'รูด้านหน้า',
    ug: 'مەۋجۇت قېلىپ',
    vi: 'Lỗ mặt trước',
    zh_tc: '正面孔',
    ru: 'Правильное лицо',
    ko: '전면 구멍',
    bur: 'ရှေ့ပေါက်',
    ben: 'সামনের গর্ত',
    tr: 'Ön delik',
    km: 'រណ្តៅខាងមុខ',
    es: 'Cara frontal',
    ar: 'الوجه الأمامي',
  },
  'paibanImg.backHole': {
    zh: '反面孔',
    en: 'Back hole',
    id: 'Lubang belakang',
    kz: 'Артқы жарқырау',
    th: 'คานกันน้ำ',
    ug: 'ئارقا تەشۋىق',
    vi: 'Mặt đối diện',
    zh_tc: '反面孔',
    ru: 'Противоположное лицо',
    ko: '반면',
    bur: 'နောက်ပေါက်',
    ben: 'পিছনের গর্ত',
    tr: 'Arka delik',
    km: 'រណ្តៅខាងក្រោយ',
    es: 'Cara posterior',
    ar: 'الوجه الخلفي',
  },
  'paibanImg.printNum': {
    zh: '打印一张纸最多展示',
    en: 'Print one sheet of paper for maximum display',
    id: 'Mencetak satu kertas maksimal tampilan',
    kz: 'Бір парақ қағазды ең көп көрсету',
    th: 'พิมพ์แผ่นกระดาษแสดงสูงสุด',
    ug: 'بىر پارچە قەغەزنى ئەڭ كۆپ كۆرسىتىش',
    vi: 'In một tờ giấy để hiển thị nhiều nhất',
    zh_tc: '列印一張紙最多展示',
    ru: 'Показать максимум на листе бумаги',
    ko: '용지 한 장 인쇄 최대 전시',
    bur: 'စာရွက်တစ်ရွက်ရိုက်တွင်အများဆုံးပြသမှု',
    ben: 'একটি কাগজ মুদ্রণে সর্বোচ্চ প্রদর্শন',
    tr: 'Bir sayfada en çok gösterim',
    km: 'បង្ហាញបានច្រើនបំផុតក្នុងក្រដាសមួយ',
    es: 'Imprimir una hoja de papel para mostrar como máximo',
    ar: 'طباعة ورقة واحدة لعرضها على الأكثر',
  },
  'paibanImg.printUnit': {
    zh: '张排版图',
    en: 'A Layout Diagram',
    id: 'Sebuah diagram tata letak',
    kz: 'Бір парақ орналастыру сызбасы',
    th: 'แผนผังการจัดวางหนึ่งแผ่น',
    ug: 'بىر پارچە تەرتىپ خەرىتىسى',
    vi: 'Một t tờ bố c cục đồ',
    zh_tc: '張排版圖',
    ru: 'Карта',
    ko: '조판도 한 장',
    bur: 'ပြင်ဆင်မှုပုံတစ်ပုံ',
    ben: 'একটি লেআউট ডায়াগ্রাম',
    tr: 'yerleşim diyagramı (sayı birimi)',
    km: 'រូបរៀបចំ (ឯកតា)',
    es: 'dibujos de diseño',
    ar: 'الرسومات التخطيطية',
  },
  'paibanImg.edit': {
    zh: '排版图模板编辑',
    en: 'Layout template editing',
    id: 'Editor Templat Grafik',
    kz: 'Орналасу үлгісінің өңдеуі',
    th: 'แก้ไขเทมเพลตแผนภูมิการพิมพ์',
    ug: 'ئورۇنلاشتۇرۇش خەرىتىسى قېلىپىنى تەھرىرلەش',
    vi: 'Bản đồ thiết kế mẫu',
    zh_tc: '排版圖範本編輯',
    ru: 'Редактор шаблонов',
    ko: '조판 템플릿 편집',
    bur: 'ပြင်ဆင်မှုပုံပုံစံတည်းဖြတ်',
    ben: 'লেআউট টেমপ্লেট সম্পাদনা',
    tr: 'Yerleşim şablonu düzenleme',
    km: 'កែគំរូរូបរៀបចំ',
    es: 'Edición de plantilla de diseño',
    ar: 'تحرير قالب التخطيط',
  },
  'paibanImg.temName': {
    zh: '模板名称',
    en: 'Template name',
    id: 'Nama Templat',
    kz: 'Үлгі атауы',
    th: 'ชื่อแม่แบบ',
    ug: 'قېلىپ نامى',
    vi: 'Tên mẫu',
    zh_tc: '範本名稱',
    ru: 'Имя шаблона',
    ko: '템플릿 이름',
    bur: 'ပုံစံအမည်',
    ben: 'টেমপ্লেটের নাম',
    tr: 'Şablon adı',
    km: 'ឈ្មោះគំរូ',
    es: 'Nombre de plantilla',
    ar: 'اسم القالب',
  },
  'paibanImg.rotate': {
    zh: '排版图旋转',
    en: 'Layout rotation',
    id: 'Putar grafik tipografi',
    kz: 'Типографиялық айналу',
    th: 'การหมุนรูปแบบการจัดวาง',
    ug: 'تىپنىڭ ئايلىنىشى',
    vi: 'Quay đồ án bố trí',
    zh_tc: '排版圖旋轉',
    ru: 'Поворот типографики',
    ko: '조판도 회전',
    bur: 'ပြင်ဆင်မှုပုံလှည့်',
    ben: 'লেআউট ডায়াগ্রাম ঘূর্ণন',
    tr: 'Yerleşim diyagramını döndür',
    km: 'បង្វិលរូបរៀបចំ',
    es: 'Rotación de diseño',
    ar: 'تدوير التخطيط',
  },
  'paibanImg.showOverflow': {
    zh: '文字溢出板件时标识线展示小板数据',
    en: 'When the text overflows from the board, the identification line displays the data of the small board',
    id: 'Baris identifikasi menampilkan data panel kecil saat teks melempah',
    kz: 'Мәтін тақтадан асып кеткенде, сәйкестендіру жолы тақта деректерін көрсетеді',
    th: 'บรรทัดโลโก้แสดงข้อมูลบอร์ดขนาดเล็กเมื่อคำหกชิ้นส่วนบอร์ด',
    ug: 'تېكىست تاختاينى بېسىپ چۈشكەندە، پەرقلەندۈرۈش لىنىيىسى تاختاي سانلىق مەلۇماتلىرىنى كۆرسىتىدۇ',
    vi: 'Các đường nhận dạng hiển thị dữ liệu bảng nhỏ khi văn bản tràn',
    zh_tc: '文字溢出板件時標識線展示小板數據',
    ru: 'Показывать данные на панели при переполнении текста',
    ko: '텍스트가 위젯을 넘을 때 식별선은 위젯 데이터를 보여줍니다.',
    bur: 'စာသားပေါ်ဒ်မကြာ့သောအခါသတ်မှတ်မျဉ်းသည်ပေါ်ဒ်ငယ်ဒေတာပြသ',
    ben: 'টেক্সট বোর্ড থেকে উপচে পড়লে পরিচয় লাইন ছোট বোর্ডের ডেটা দেখায়',
    tr: 'Metin taşarsa işaret çizgisi küçük levha verisini gösterir',
    km: 'នៅពេលអក្សរលើសផ្ទាំង បន្ទាត់សម្គាល់បង្ហាញទិន្នន័យផ្ទាំងតូច',
    es: 'Cuando el texto desborda el tablero, la línea de identificación muestra los datos del tablero pequeño',
    ar: 'عندما يفيض النص على اللوحة، يعرض سطر التعريف بيانات اللوحة الصغيرة',
  },
  'paibanImg.showHoleSlot': {
    zh: '展示孔槽信息',
    en: 'Display hole slot information',
    id: 'Tampilkan informasi slot lubang',
    kz: 'Тесік және ұяшық ақпаратын көрсетеді',
    th: 'แสดงข้อมูลช่องหลุม',
    ug: 'تۆشۈك ۋە ئورۇن ئۇچۇرىنى كۆرسىتىدۇ',
    vi: 'Hiển thị thông tin khe lỗ',
    zh_tc: '展示孔槽資訊',
    ru: 'Показать информацию о пазе',
    ko: '구멍 슬롯 정보 표시하기',
    bur: 'ပေါက်/ချောင်းသတင်းပြ',
    ben: 'গর্ত স্লটের তথ্য দেখান',
    tr: 'Delik ve oluk bilgisini göster',
    km: 'បង្ហាញព័ត៌មានរណ្តៅ និងរន្ធ',
    es: 'Muestra la información de orificios y ranuras',
    ar: 'يعرض معلومات الفتحة والفتحة',
  },
  'paibanImg.bigPartCss': {
    zh: '大板排版图样式调整',
    en: 'Style adjustment of large board layout diagram',
    id: 'Penyesuaian gaya tipografi papan besar',
    kz: 'Үлкен тақтаның орналасу стилін реттеу',
    th: 'การปรับรูปแบบแผนภูมิการพิมพ์ขนาดใหญ่',
    ug: 'چوڭ تاختاي ئورۇنلاشتۇرۇش ئۇسلۇبىنى تەڭشەش',
    vi: 'Điều chỉnh kiểu bản vẽ lớn',
    zh_tc: '大板排版圖樣式調整',
    ru: 'Корректировка стиля',
    ko: '대판 조판도 스타일 조정',
    bur: 'ပေါ်ဒ်ကြီးပြင်ဆင်မှုပုံပုံစံချိန်ညှိ',
    ben: 'বড় বোর্ড লেআউট ডায়াগ্রামের স্টাইল সামঞ্জস্য',
    tr: 'Büyük levha yerleşim stilini ayarla',
    km: 'កែរចនារូបផ្ទាំងធំ',
    es: 'Ajusta el estilo del diagrama de diseño del tablero grande',
    ar: 'يضبط نمط مخطط التخطيط للوحة الكبيرة',
  },
  'paibanImg.partCss': {
    zh: '小板排版图样式调整',
    en: 'Style adjustment of small board layout diagram',
    id: 'Penyesuaian gaya tipografi papan kecil',
    kz: 'Шағын тақтаның орналасу стилін реттеу',
    th: 'การปรับรูปแบบกราฟฟิกการเรียงพิมพ์บนจานขนาดเล็ก',
    ug: 'كىچىك تاختاينىڭ ئورۇنلاشتۇرۇش ئۇسلۇبىنى تەڭشەش',
    vi: 'Điều chỉnh kiểu bản vẽ sắt xếp nhỏ',
    zh_tc: '小板排版圖樣式調整',
    ru: 'Настройка стиля',
    ko: '소판 조판도 스타일 조정',
    bur: 'ပေါ်ဒ်ငယ်ပြင်ဆင်မှုပုံပုံစံချိန်ညှိ',
    ben: 'ছোট বোর্ড লেআউট ডায়াগ্রামের স্টাইল সামঞ্জস্য',
    tr: 'Küçük levha yerleşim stilini ayarla',
    km: 'កែរចនារូបផ្ទាំងតូច',
    es: 'Ajusta el estilo del diagrama de diseño del tablero pequeño',
    ar: 'يضبط نمط مخطط التخطيط للوحة الصغيرة',
  },
  'paibanImg.addTemTip': {
    zh: '最多只能添加10个排版图模板！',
    en: 'You can only add up to 10 typeset layout templates!',
    id: 'Hanya bisa menambahkan hingga 10 template tipografi!',
    kz: 'Ең көбі 10 теру үлгісін қосуға болады!',
    th: 'สามารถเพิ่มเทมเพลตแผนภูมิตัวอักษรได้สูงสุด 10 แบบเท่านั้น!',
    ug: 'ئەڭ كۆپ بولغاندا پەقەت 10 خىل خەت بېسىش قېلىپىنى قوشقىلى بولىدۇ!',
    vi: 'Chỉ có thể thêm tối đa 10 mẫu hình ảnh trình bày!',
    zh_tc: '最多只能添加10個排版圖範本！',
    ru: 'Добавьте до 10 шаблонов!',
    ko: '최대 10개의 레이아웃 템플릿만 추가할 수 있습니다!',
    bur: 'ပြင်ဆင်မှုပုံပုံစံ ၁၀ ခုသာထည့်နိုင်!',
    ben: 'সর্বোচ্চ ১০টি লেআউট টেমপ্লেট যোগ করা যাবে!',
    tr: 'En fazla 10 yerleşim şablonu eklenebilir',
    km: 'អាចបន្ថែមគំរូរូបរៀបចំអតិបរមា ១០',
    es: '¡Solo se pueden agregar 10 plantillas de diagrama de diseño como máximo!',
    ar: 'يمكن إضافة 10 قوالب مخطط تخطيطي فقط على الأكثر!',
  },
  'paibanImg.exportTip': {
    zh: '请至少勾选一个排版图模板导出！',
    en: 'Please select at least one layout template for export!',
    id: 'Silakan pilih setidaknya satu template tipografi untuk diekspor!',
    kz: 'Экспорттау үшін кем дегенде бір орналасу үлгісін белгілеңіз!',
    th: 'กรุณาเลือกอย่างน้อยหนึ่งแม่แบบแผนภูมิพิมพ์เพื่อส่งออก!',
    ug: 'ئېكسپورت ئۈچۈن كەم دېگەندە بىر ئورۇنلاشتۇرۇش قېلىپىنى چېكىڭ!',
    vi: 'Hãy chọn ít nhất một mẫu sơ đồ trình bày để xuất!',
    zh_tc: '請至少勾選一個排版圖範本匯出！',
    ru: 'Выберите хотя бы один шаблон типографики для экспорта!',
    ko: '적어도 하나의 레이아웃 템플릿 내보내기를 선택하십시오.',
    bur: 'ပြင်ဆင်မှုပုံပုံစံတစ်ခုနှင့်အထက်ရွေးပြီးထုတ်ပါ!',
    ben: 'রপ্তানির জন্য কমপক্ষে একটি লেআউট টেমপ্লেট নির্বাচন করুন!',
    tr: 'Dışa aktarmak için en az bir şablon seçin',
    km: 'សូមជ្រើសរើសគំរូយ៉ាងហោចណាមួយដើម្បីនាំចេញ',
    es: '¡Marque al menos una plantilla de diseño para exportar!',
    ar: 'يرجى التحقق من قالب تخطيط واحد على الأقل للتصدير!',
  },
  'paibanImg.editSaveTip': {
    zh: '请确认必填项都填写后，再保存！',
    en: 'Please confirm that all required fields are filled in before saving!',
    id: 'Pastikan semua bidang yang diperlukan diisi dan simpan!',
    kz: 'Сақтау алдында барлық қажетті заттардың толтырылғанын растаңыз!',
    th: 'กรุณายืนยันว่า หลังจากกรอกข้อมูลที่จำเป็นแล้ว กรุณาบันทึกอีกครั้ง!',
    ug: 'بارلىق لازىملىق بۇيۇملارنىڭ تېجەشتىن بۇرۇن تولدۇرۇلغانلىقىنى جەزملەشتۈرۈڭ!',
    vi: 'Vui lòng xác nhận rằng tất cả các mục bắt buộc đã được điền trước khi lưu!',
    zh_tc: '請確認必填項都填寫後，再保存！',
    ru: 'Пожалуйста, убедитесь, что все необходимые заполнения будут заполнены, а затем сохранены!',
    ko: '필수 항목을 모두 기입한 후 저장하시기 바랍니다!',
    bur: 'ဖြည့်ရမည့်အချက်အားလုံးဖြည့်ပြီးမှသိမ်းပါ!',
    ben: 'সব আবশ্যক ক্ষেত্র পূরণ করার পরে সংরক্ষণ করুন!',
    tr: 'Kaydetmeden önce zorunlu alanların doldurulduğunu doğrulayın',
    km: 'សូមបញ្ជាក់បានបំពេញវាលចាំបាច់មុនរក្សា',
    es: '¡Confirme que todos los campos obligatorios estén completos antes de guardar!',
    ar: 'يرجى التأكد من ملء جميع الحقول المطلوبة قبل الحفظ!',
  },
  'paibanImg.exportDXF': {
    zh: '导出DXF',
    en: 'Export DXF',
    id: 'Ekspor DXF',
    kz: 'DXF экспорттау',
    th: 'DXF ส่งออก',
    ug: 'DXF چىقىرىش',
    vi: 'Xuất DXF',
    zh_tc: '導出DXF',
    ru: 'Экспорт DXF',
    ko: 'DXF 내보내기',
    bur: 'DXF ထုတ်ပါ',
    ben: 'DXF রপ্তানি করুন',
    tr: 'DXF Dışa Aktar',
    km: 'នាំចេញ DXF',
    es: 'Exportar DXF',
    ar: 'تصدير DXF',
  },
  'paibanImg.exportDxfGeneral': {
    zh: '二维通用DXF',
    en: '2D General DXF',
    id: 'DXF Umum 2D',
    kz: '2D жалпы DXF',
    th: 'DXF ทั่วไป 2D',
    ug: '2D ئومۇمىي DXF',
    vi: 'DXF 2D thông dụng',
    zh_tc: '二維通用 DXF',
    ru: 'Универсальный 2D DXF',
    ko: '2D 일반 DXF',
    bur: '2D အထွေထွေ DXF',
    ben: '2D সাধারণ DXF',
    tr: '2D Genel DXF',
    km: 'DXF ទូទៅ 2D',
    es: 'DXF general 2D',
    ar: 'DXF عام ثنائي الأبعاد',
  },
  'paibanImg.exportDxf3d': {
    zh: '三维专用DXF',
    en: '3D Dedicated DXF',
    id: 'DXF Khusus 3D',
    kz: '3D арнайы DXF',
    th: 'DXF เฉพาะ 3D',
    ug: '3D مەخسۇس DXF',
    vi: 'DXF chuyên dụng 3D',
    zh_tc: '三維專用DXF',
    ru: 'Специализированный 3D DXF',
    ko: '3D 전용 DXF',
    bur: '3D သီးသန့် DXF',
    ben: '3D বিশেষ DXF',
    tr: '3D Özel DXF',
    km: 'DXF ពិសេស 3D',
    es: 'DXF especializado 3D',
    ar: 'DXF مخصص ثلاثي الأبعاد',
  },
  'paibanImg.exportDxfGeneralTip': {
    zh: '适用于手工加工看图切割或检查排版结果',
    en: 'Suitable for manual processing, visual cutting, or checking layout results',
    id: 'Cocok untuk pemrosesan manual, melihat gambar untuk pemotongan, atau memeriksa hasil tata letak',
    kz: 'Қолмен өңдеуге, сызба бойынша кесуге немесе орналастыру нәтижесін тексеруге жарайды',
    th: 'เหมาะสำหรับการ加工ด้วยมือ การดูแบบเพื่อตัด หรือการตรวจสอบผลการจัดวาง',
    ug: 'قولدا پىششىقلاپ ئىشلەش، رەسىمگە قاراپ كېسىش ياكى جايلاشتۇرۇش نەتىجىسىنى تەكشۈرۈشكە ماس كېلىدۇ',
    vi: 'Phù hợp để gia công thủ công, xem bản vẽ để cắt hoặc kiểm tra kết quả bố trí',
    zh_tc: '適用於手工加工看圖切割或檢查排版結果',
    ru: 'Подходит для ручной обработки, резки по чертежу или проверки результатов раскроя',
    ko: '수동 가공, 도면을 보며 절단하거나 배치 결과를 확인하는 데 적합합니다',
    bur: 'လက်ဖြင့်加工ခြင်း၊ ပုံကြည့်၍ ဖြတ်တောက်ခြင်း သို့မဟုတ် အပြင်အဆင်ရလဒ်ကို စစ်ဆေးခြင်းအတွက် သင့်တော်သည်',
    ben: 'হাতে প্রক্রিয়াকরণ, নকশা দেখে কাটা বা লেআউটের ফলাফল পরীক্ষা করার জন্য উপযুক্ত',
    tr: 'Elle işleme, çizime bakarak kesim yapma veya yerleşim sonuçlarını kontrol etme için uygundur',
    km: 'សមស្របសម្រាប់កែច្នៃដោយដៃ កាត់តាមគំនូរ ឬពិនិត្យលទ្ធផលរៀបចំ',
    es: 'Adecuado para el procesamiento manual, cortar consultando el dibujo o comprobar el resultado de la distribución',
    ar: 'مناسب للمعالجة اليدوية أو القطع بالاعتماد على الرسم أو فحص نتائج التخطيط',
  },
  'paibanImg.exportDxf3dTip': {
    zh: '适用于导入三方系统进行生产，已支持辉亚激光切割一体机',
    en: 'Suitable for importing into third-party systems for production; supports Huiya laser cutting integrated machines',
    id: 'Cocok untuk diimpor ke sistem pihak ketiga untuk produksi; mendukung mesin pemotong laser terintegrasi Huiya',
    kz: 'Өндіру үшін үшінші тарап жүйелеріне импорттауға жарайды; Huiya лазерлік кесу біріктірілген станоктарына қолдау көрсетіледі',
    th: 'เหมาะสำหรับนำเข้าไปยังระบบของบุคคลที่สามเพื่อการผลิต รองรับเครื่องตัดเลเซอร์แบบครบวงจร Huiya',
    ug: 'ئىشلەپچىقىرىش ئۈچۈن ئۈچىنچى تەرەپ سىستېمىسىغا ئىمپورت قىلىشقا ماس كېلىدۇ؛ Huiya لازېر كېسىش بىر گەۋدىلەشكەن ماشىنىسىنى قوللايدۇ',
    vi: 'Phù hợp để nhập vào hệ thống bên thứ ba để sản xuất; đã hỗ trợ máy cắt laser tích hợp Huiya',
    zh_tc: '適用於導入第三方系統進行生產，已支持輝亞激光切割一體機',
    ru: 'Подходит для импорта в сторонние системы для производства; поддерживает интегрированные лазерные станки Huiya',
    ko: '타사 시스템으로 가져와 생산하는 데 적합하며 Huiya 레이저 절단 일체형 기계를 지원합니다',
    bur: 'ထုတ်လုပ်ရန် တတိယပါတီစနစ်များသို့ ထည့်သွင်းရန် သင့်တော်သည်။ Huiya လေဆာဖြတ်တောက်ရေး ပေါင်းစပ်စက်ကို ပံ့ပိုးသည်',
    ben: 'উৎপাদনের জন্য তৃতীয় পক্ষের সিস্টেমে আমদানি করার উপযোগী; Huiya লেজার কাটিং ইন্টিগ্রেটেড মেশিন সমর্থিত',
    tr: 'Üretim için üçüncü taraf sistemlere aktarılmaya uygundur; Huiya lazer kesim entegre makinelerini destekler',
    km: 'សមស្របសម្រាប់នាំចូលទៅប្រព័ន្ធភាគីទីបីសម្រាប់ផលិតកម្ម គាំទ្រម៉ាស៊ីនកាត់ឡាស៊ែររួមបញ្ចូល Huiya',
    es: 'Adecuado para importar a sistemas de terceros para la producción; compatible con máquinas integradas de corte láser Huiya',
    ar: 'مناسب للاستيراد إلى أنظمة خارجية للإنتاج؛ يدعم آلات القطع بالليزر المتكاملة من Huiya',
  },
  'historyPage.matchErrBySpecialTip1': {
    zh: '以下特殊大板已无法找到匹配项，排版页重新排版将会存在问题，如果此历史使用了混排方案，请忽略此提示',
    en: 'The following special boards can no longer find matching items, there will be problems with re-layout on the layout page',
    id: 'Papan khusus berikut tidak dapat lagi menemukan item yang cocok, akan ada masalah dengan tata letak ulang di halaman tata letak',
    kz: 'Келесі арнайы тақталар сәйкес келетін элементтерді таба алмайды, макет бетінде қайта макет жасауда мәселелер болады',
    th: 'แผ่นพิเศษต่อไปนี้ไม่สามารถหารายการที่ตรงกันได้อีกต่อไป จะมีปัญหาในการจัดเลย์เอาต์ใหม่ในหน้าเลย์เอาต์',
    ug: 'تۆۋەندىكى ئالاھىدە تاختايلار ئەندى ماسلىشىدىغان تۈرلەرنى تاپالمايدۇ، جايلاشتۇرۇش بېتىدە قايتا جايلاشتۇرۇشتا مەسىلە بولىدۇ',
    vi: 'Các tấm đặc biệt sau không thể tìm thấy mục phù hợp, sẽ có vấn đề khi bố cục lại trên trang bố cục',
    zh_tc: '以下特殊大板已無法找到匹配項，排版頁重新排版將會存在問題',
    ru: 'Следующие специальные большие панели больше не могут найти совпадения, будет проблема с переформатированием страницы набора, если в этой истории используется схема смешивания, игнорируйте этот совет',
    ko: '다음 특수 보드에서 일치하는 항목을 찾을 수 없습니다. 조판 페이지를 다시 조판하는 데 문제가 있을 것입니다. 만약 이 역사가 혼합 배열을 사용했다면 이 힌트를 무시하십시오',
    bur: 'အောက်ပါအထူးပေါ်ဒ်ကြီးများသင့်တော်သောအရာမတွေ့တော့ပါ၊ ပြင်ဆင်မှုစာမျက်နှာပြန်လုပ်ရာတွင်ပြဿနာဖြစ်မည်',
    ben: 'নিচের বিশেষ বড় বোর্ডগুলো আর মিলকারী আইটেম খুঁজে পাচ্ছে না, লেআউট পেজে পুনরায় লেআউটে সমস্যা হবে',
    tr: 'Aşağıdaki özel büyük levhalar için eşleşme yok; yerleşim sayfasında yeniden yerleştirmede sorun olabilir. Karma şema kullanıldıysa bu uyarıyı yok sayın',
    km: 'ផ្ទាំងធំពិសេសខាងក្រោមរកមិនឃើញគូ—រៀបចំឡើងវិញនឹងមានបញ្ហា។ ប្រើផែនការលាយឡំ សូមមិនអើពើការព្រមាននេះ',
    es: 'No se puede encontrar ninguna coincidencia para los siguientes tableros especiales y habrá problemas al volver a diseñar la página de diseño. Si se utiliza un esquema de diseño mixto en este historial, ignore este mensaje',
    ar: 'لا يمكن العثور على تطابق للوحات الخاصة التالية، وستكون هناك مشاكل في إعادة التخطيط على صفحة التخطيط. إذا تم استخدام نظام تخطيط مختلط في هذا التاريخ، يرجى تجاهل هذه المطالبة',
  },
  'historyPage.specialPlankInfoErrTip2': {
    zh: '特殊大板信息获取出错，将影响排版页重新排版功能',
    en: 'Error in obtaining special board information, which will affect the re-layout function of the layout page',
    id: 'Kesalahan dalam memperoleh informasi papan khusus, yang akan mempengaruhi fungsi tata letak ulang halaman tata letak',
    kz: 'Арнайы тақта туралы ақпарат алуда қате, бұл макет бетінің қайта макет функциясына әсер етеді',
    th: 'ข้อผิดพลาดในการรับข้อมูลแผ่นพิเศษ ซึ่งจะส่งผลต่อฟังก์ชันการจัดเลย์เอาต์ใหม่ของหน้าเลย์เอาต์',
    ug: 'ئالاھىدە تاختا ئۇچۇرىنى ئېلىشتا خاتالىق، بۇ جايلاشتۇرۇش بېتىنىڭ قايتا جايلاشتۇرۇش ئىقتىدارىغا تەسىر كۆرسىتىدۇ',
    vi: 'Lỗi khi lấy thông tin tấm đặc biệt, điều này sẽ ảnh hưởng đến chức năng bố cục lại của trang bố cục',
    zh_tc: '特殊大板信息獲取出錯，將影響排版頁重新排版功能',
    ru: 'Ошибка получения информации на специальной большой доске повлияет на функцию переформатирования страниц',
    ko: '특수 대판 정보 획득 오류, 조판 페이지 재조판 기능에 영향',
    bur: 'အထူးပေါ်ဒ်ကြီးသတင်းရယူတွင်အမှားဖြစ်ပွား၊ ပြင်ဆင်မှုစာမျက်နှာပြန်ပြင်လုပ်ဆောင်ချက်ကိုထိခိုက်မည်',
    ben: 'বিশেষ বোর্ডের তথ্য পাওয়ায় ত্রুটি, লেআউট পেজের পুনরায় লেআউট ফিচারকে প্রভাবিত করবে',
    tr: 'Özel büyük levha bilgisi alınamadı; yerleşim sayfasının yeniden yerleştirme işlevi etkilenir',
    km: 'ទទួលព័ត៌មានផ្ទាំងធំពិសេសមិនបានសម្រេច នឹងប៉ះពាល់មុខងាររៀបចំឡើងវិញ',
    es: 'Se produjo un error al obtener información especial del tablero, lo que afectará la función de re-diseño en la página de diseño',
    ar: 'حدث خطأ في الحصول على معلومات اللوحة الخاصة، مما سيؤثر على وظيفة إعادة التخطيط في صفحة التخطيط',
  },
  'historyPage.download': {
    zh: '下载本地',
    en: 'Download Locally',
    id: 'Unduh secara lokal',
    kz: 'Жергілікті жүктеу',
    th: 'ดาวน์โหลดในพื้นที่',
    ug: 'يەرلىككە چۈشۈرۈش',
    vi: 'Tải xuống máy',
    zh_tc: '下載本地',
    ru: 'Загрузить локально',
    ko: '로컬 다운로드',
    bur: 'ဒေသဒေါင်းလုတ်',
    ben: 'স্থানীয়ভাবে ডাউনলোড করুন',
    tr: 'Yerel indir',
    km: 'ទាញយកក្នុងម៉ាស៊ីន',
    es: 'Descargar local',
    ar: 'التنزيل المحلي',
  },
  'historyPage.allType': {
    zh: '全部保存',
    en: 'Save All',
    id: 'Simpan semua',
    kz: 'Барлық сақтау',
    th: 'บันทึกทั้งหมด',
    ug: 'ھەممىنى ساقلاش',
    vi: 'Lưu tất cả',
    zh_tc: '全部保存',
    ru: 'Сохранить все',
    ko: '모두 저장',
    bur: 'အားလုံးသိမ်း',
    ben: 'সব সংরক্ষণ করুন',
    tr: 'Tümünü kaydet',
    km: 'រក្សាទាំងអស់',
    es: 'Guardar todo',
    ar: 'حفظ الكل',
  },
  'historyPage.handleSave': {
    zh: '手动保存',
    en: 'Manual Save',
    id: 'Simpan secara manual',
    kz: 'Қолмен сақтау',
    th: 'บันทึกด้วยตนเอง',
    ug: 'قولدا ساقلاش',
    vi: 'Lưu thủ công',
    zh_tc: '手動保存',
    ru: 'Сохранить вручную',
    ko: '수동 저장',
    bur: 'လက်ဖြင့်သိမ်း',
    ben: 'ম্যানুয়াল সেভ',
    tr: 'Manuel kaydet',
    km: 'រក្សាដោយដៃ',
    es: 'Guardar manualmente',
    ar: 'الحفظ يدويًا',
  },
  'historyPage.specialPlank': {
    zh: '特',
    en: 'Special',
    id: 'Spesial',
    kz: 'Қарапайым',
    th: 'พิเศษ',
    ug: 'ئالاھىدە',
    vi: 'Đặc biệt',
    zh_tc: '特',
    ru: 'Особый',
    ko: '특별한',
    bur: 'အထူး',
    ben: 'বিশেষ',
    tr: 'Özel',
    km: 'ការពិន្ទុ',
    es: 'Especial',
    ar: 'خاص',
  },
  'historyPage.surplusPlank': {
    zh: '余',
    en: 'Surplus',
    id: 'Surplus',
    kz: 'Қалдық',
    th: 'คงเหลือ',
    ug: 'ئالاھىدە',
    vi: 'Dư',
    zh_tc: '余',
    ru: 'Избыточный',
    ko: '여분',
    bur: 'အကျိုးသက်သာ',
    ben: 'অতিরিক্ত',
    tr: 'Fazla',
    km: 'បន្ថែម',
    es: 'Excedente',
    ar: 'زائد',
  },
  'historyPage.autoSave': {
    zh: '自动保存',
    en: 'Auto Save',
    id: 'Simpan secara otomatis',
    kz: 'Автоматты сақтау',
    th: 'บันทึกโดยอัตโนมัติ',
    ug: 'ئاپتوماتىك ساقلاش',
    vi: 'Lưu tự động',
    zh_tc: '自動保存',
    ru: 'Автосохранение',
    ko: '자동 저장',
    bur: 'အလိုအလျောက်သိမ်း',
    ben: 'স্বয়ংক্রিয় সেভ',
    tr: 'Otomatik kaydet',
    km: 'រក្សាស្វ័យប្រវត្តិ',
    es: 'Guardar automáticamente',
    ar: 'الحفظ تلقائيًا',
  },
  'historyPage.allArrange': {
    zh: '全部排版',
    en: 'All Layout',
    id: 'Semua pengaturan huruf',
    kz: 'Барлық қалыптасу',
    th: 'การพิมพ์ทั้งหมด',
    ug: 'ھەممە تەرتىپلەش',
    vi: 'Bố cục tất cả',
    zh_tc: '全部排版',
    ru: 'Весь набор',
    ko: '전체 조판',
    bur: 'အားလုံးပြင်ဆင်',
    ben: 'সব লেআউট',
    tr: 'Tüm yerleşim',
    km: 'រៀបចំទាំងអស់',
    es: 'Todo el diseño',
    ar: 'كل التخطيط',
  },
  'historyPage.searchPlaceholder': {
    zh: '搜索订单名称 / 排版批次 / 订单号',
    en: 'Search order name / layout batch / order number',
    id: 'Cari nama pesanan / batch tata letak / nomor pesanan',
    kz: 'Тапсырыс атауы / басып шығару топтамасы / тапсырыс нөмірі бойынша іздеу',
    th: 'ค้นหาชื่อคำสั่งซื้อ / แบตช์การจัดหน้า / เลขที่คำสั่งซื้อ',
    ug: 'زاكاز نامى / تىزىش تۈركۈمى / زاكاز نومۇرى بويىچە ئىزدەش',
    vi: 'Tìm kiếm tên đơn hàng / đợt sắp chữ / số đơn hàng',
    zh_tc: '搜索訂單名稱 / 排版批次 / 訂單號',
    ru: 'Поиск по названию заказа / партии вёрстки / номеру заказа',
    ko: '주문명 / 조판 배치 / 주문번호 검색',
    bur: 'မှာယူမှုအမည် / နေရာချထားမှုအသုတ် / မှာယူမှုနံပါတ်ဖြင့် ရှာဖွေပါ',
    ben: 'অর্ডারের নাম / লেআউট ব্যাচ / অর্ডার নম্বর অনুসন্ধান করুন',
    tr: 'Sipariş adı / dizgi partisi / sipariş numarası ara',
    km: 'ស្វែងរកឈ្មោះការបញ្ជាទិញ / ការជ្រើសរើសបាច់រៀបចំ / លេខការបញ្ជាទិញ',
    es: 'Buscar nombre de pedido / lote de maquetación / número de pedido',
    ar: 'البحث باسم الطلب / دفعة التخطيط / رقم الطلب',
  },
  'historyPage.saveHistoryName': {
    zh: '保存历史名称',
    en: 'Saved history name',
    id: 'Nama riwayat tersimpan',
    kz: 'Сақталған тарих атауы',
    th: 'ชื่อประวัติที่บันทึก',
    ug: 'ساقلانغان تارىخ نامى',
    vi: 'Tên lịch sử đã lưu',
    zh_tc: '儲存歷史名稱',
    ru: 'Название сохранённой истории',
    ko: '저장 이력 이름',
    bur: 'သိမ်းဆည်းထားသော မှတ်တမ်းအမည်',
    ben: 'সংরক্ষিত ইতিহাসের নাম',
    tr: 'Kaydedilen geçmiş adı',
    km: 'ឈ្មោះប្រវត្តិដែលបានរក្សាទុក',
    es: 'Nombre del historial guardado',
    ar: 'اسم السجل المحفوظ',
  },

  'historyPage.trailProduction.title': {
    zh: '试生产样品柜',
    en: 'Trial production sample cabinet',
    id: 'Kabinet sampel produksi percobaan',
    kz: 'Сынақ өндіріс үлгі шкаф',
    th: 'ตู้เก็บตัวอย่างทดลองใช้',
    ug: 'سىناقلىق ئىشلەپچىقىرىش قابىسى',
    vi: 'Tủ mẫu thử sản xuất',
    zh_tc: '試生產樣品櫃',
    ru: 'Шкаф пробного производства',
    ko: '시제품 견본함',
    bur: 'စမ်းသပ်ထုတ်လုပ်မှုနမူနာဗိုင်တိုက်',
    ben: 'পরীক্ষামূলক উৎপাদন নমুনা ক্যাবিনেট',
    tr: 'Deneme üretim örnek dolabı',
    km: 'ទូគំរូផលិតកម្មសាកល្បង',
    es: 'Gabinete de muestras de producción de prueba',
    ar: 'خزانة عينة الإنتاج التجريبي',
  },
  'historyPage.trailProduction.lastTime': {
    zh: '上次试生产日期',
    en: 'Last Trial Production Date',
    id: 'Tanggal Produksi Percobaan Terakhir',
    kz: 'Ақырғы сынақ өндіріс күні',
    th: 'วันที่ผลิตทดลองใช้ครั้งล่าสุด',
    ug: 'ئەڭ ئاخىرقى سىناقلىق ئىشلەپچىقىرىش ۋاقتى',
    vi: 'Ngày thử sản xuất lần cuối',
    zh_tc: '上次試生產日期',
    ru: 'Дата последнего испытания',
    ko: '마지막 파일럿 날짜',
    bur: 'ယခင်စမ်းသပ်ထုတ်လုပ်မှုရက်',
    ben: 'সর্বশেষ পরীক্ষামূলক উৎপাদনের তারিখ',
    tr: 'Son deneme üretim tarihi',
    km: 'កាលបរិច្ឆេទសាកល្បងផលិតចុងក្រោយ',
    es: 'Última fecha de producción de prueba',
    ar: 'تاريخ الإنتاج التجريبي الأخير',
  },
  'historyPage.trailProduction.recordList': {
    zh: '试生产记录',
    en: 'Trial Production Records',
    id: 'Catatan Produksi Percobaan',
    kz: 'Сынақ өндіріс жазбалары',
    th: 'บันทึกการผลิตทดลองใช้',
    ug: 'سىناقلىق ئىشلەپچىقىرىش خاتىرىسى',
    vi: 'Lịch sử thử sản xuất',
    zh_tc: '試生產記錄',
    ru: 'Протокол пробного производства',
    ko: '시험 생산 기록',
    bur: 'စမ်းသပ်ထုတ်လုပ်မှုမှတ်တမ်း',
    ben: 'পরীক্ষামূলক উৎপাদন রেকর্ড',
    tr: 'Deneme üretim kayıtları',
    km: 'កំណត់ត្រាសាកល្បងផលិត',
    es: 'Registro de producción de prueba',
    ar: 'سجل الإنتاج التجريبي',
  },
  'historyPage.trailProduction.start': {
    zh: '开始试生产',
    en: 'Start Trial Production',
    id: 'Mulai produksi percobaan',
    kz: 'Сынақ өндірісін бастау',
    th: 'เริ่มการผลิตทดลองใช้',
    ug: 'سىناقلىق ئىشلەپچىقىرىشنى باشلاش',
    vi: 'Bắt đầu thử sản xuất',
    zh_tc: '開始試生產',
    ru: 'Начать пробное производство',
    ko: '시험 생산을 시작하다',
    bur: 'စမ်းသပ်ထုတ်လုပ်မှုစတင်',
    ben: 'পরীক্ষামূলক উৎপাদন শুরু করুন',
    tr: 'Deneme üretimini başlat',
    km: 'ចាប់ផ្តើមសាកល្បងផលិត',
    es: 'Iniciar producción de prueba',
    ar: 'بدء الإنتاج التجريبي',
  },
  'historyPage.trailProduction.date': {
    zh: '时间',
    en: 'Time',
    id: 'waktu',
    kz: 'Уақыт',
    th: 'เวลา',
    ug: 'ۋاقىت',
    vi: 'Thời gian',
    zh_tc: '時間',
    ru: 'время',
    ko: '시간',
    bur: 'အချိန်',
    ben: 'সময়',
    tr: 'Zaman',
    km: 'ពេលវេលា',
    es: 'Hora',
    ar: 'الوقت',
  },
  'historyPage.trailProduction.outputFrom': {
    zh: '输出位置',
    en: 'Output Location',
    id: 'Lokasi Output',
    kz: 'Шығу орны',
    th: 'ตำแหน่งเอาต์พุต',
    ug: 'چىقىرىش ئورنى',
    vi: 'Vị trí xuất',
    zh_tc: '輸出位置',
    ru: 'Выходное положение',
    ko: '출력 위치',
    bur: 'ထုတ်ရာနေရာ',
    ben: 'আউটপুট অবস্থান',
    tr: 'Çıktı konumu',
    km: 'ទីតាំងចេញ',
    es: 'Posición de salida',
    ar: 'موضع الإخراج',
  },
  'historyPage.trailProduction.empty': {
    zh: '暂无数据',
    en: 'No Data Available',
    id: 'Belum ada data',
    kz: 'Деректер жоқ',
    th: 'ยังไม่มีข้อมูล',
    ug: 'ھازىرچە سانلىق مەلۇمات يوق',
    vi: 'Không có dữ liệu',
    zh_tc: '暫無數據',
    ru: 'Нет данных',
    ko: '데이터 없음',
    bur: 'ဒေတာမရှိသေး',
    ben: 'কোনো ডেটা নেই',
    tr: 'Veri yok',
    km: 'គ្មានទិន្នន័យ',
    es: 'Aún no hay datos',
    ar: 'لا توجد بيانات حتى الآن',
  },
  'historyPage.trailProduction.record': {
    zh: '上传的试生产样品柜图片记录',
    en: 'Uploaded Trial Production Sample Cabinet Image Records',
    id: 'Catatan gambar yang diunggah dari Kabinet Sampel Produksi Percobaan',
    kz: 'Жүктелген сынақ өндіріс үлгі шкаф суреттерінің жазбалары',
    th: 'บันทึกรูปภาพที่อัปโหลดของคณะรัฐมนตรีตัวอย่างการผลิตทดลองใช้',
    ug: 'يۈكلەنگەن سىناقلىق ئىشلەپچىقىرىش قابا رەسىم خاتىرىسى',
    vi: 'Lịch sử ảnh tủ mẫu thử sản xuất đã tải lên',
    zh_tc: '上傳的試生產樣品櫃圖片記錄',
    ru: 'Загрузка фотографий из шкафа пробного производства',
    ko: '업로드된 시제품 견본함 사진 기록',
    bur: 'တင်ဆောင်ထားသောစမ်းသပ်ထုတ်လုပ်မှုနမူနာဗိုင်ဓာတ်ပုံမှတ်တမ်း',
    ben: 'আপলোড করা পরীক্ষামূলক নমুনা ক্যাবিনেটের ছবি রেকর্ড',
    tr: 'Yüklenen deneme üretim örnek dolabı görüntü kayıtları',
    km: 'កំណត់ត្រារូបទូគំរូសាកល្បងដែលបានផ្ទុក',
    es: 'Registro de imagen de gabinete de muestra de producción de prueba cargado',
    ar: 'سجل صورة خزانة نموذج الإنتاج التجريبي الذي تم تحميله',
  },
  'historyPage.trailProduction.tip1': {
    zh: '注意：当前试生产订单使用的是默认生产数据',
    en: 'Attention: The current trial production order is using default production data',
    id: 'Catatan: Urutan produksi uji coba saat ini menggunakan data produksi default',
    kz: 'Назар аударыңыз: Қазіргі сынақ өндірісі тапсырысы әдепкі өндірістік деректерді пайдаланады',
    th: 'หมายเหตุ: ใบสั่งการผลิตทดลองใช้ปัจจุบันใช้ข้อมูลการผลิตเริ่มต้น',
    ug: 'دىققەت: نۆۋەتتىكى سىناقلىق زاكاز سۈكۈتتىكى ئىشلەپچىقىرىش سانلىق مەلۇماتىنى ئىشلىتىۋاتىدۇ',
    vi: 'Lưu ý: Đơn hàng thử nghiệm hiện tại đang sử dụng dữ liệu sản xuất mặc định',
    zh_tc: '注意：當前試生產訂單使用的是默認生產數據',
    ru: 'Примечание: Текущие заказы на пробное производство используют производственные данные по умолчанию',
    ko: '참고: 현재 파일럿 주문은 기본 프로덕션 데이터를 사용합니다.',
    bur: 'သတိ: လက်ရှိစမ်းသပ်ထုတ်လုပ်မှုမှာယူမှုသည်မူရင်းထုတ်လုပ်မှုဒေတာကိုသုံးနေသည်',
    ben: 'নোট: বর্তমান পরীক্ষামূলক উৎপাদন অর্ডার ডিফল্ট উৎপাদন ডেটা ব্যবহার করছে',
    tr: 'Dikkat: Geçerli deneme üretim siparişi varsayılan üretim verilerini kullanıyor',
    km: 'កត់សម្គាល់៖ ការបញ្ជារសាកល្បងប្រើទិន្នន័យផលិតលំនាំដើម',
    es: 'Nota: La orden de producción de prueba actual utiliza los datos de producción predeterminados',
    ar: 'ملاحظة: يستخدم أمر الإنتاج التجريبي الحالي بيانات الإنتاج الافتراضية',
  },
  'historyPage.trailProduction.tip2': {
    zh: '注意：当前试生产订单使用的并不是最新的工艺设置参数，可前往试生产房间重新保存！',
    en: 'Attention: The current trial production order is not using the latest process settings parameters. You can go to the trial production room to save them again!',
    id: 'Catatan: Urutan produksi uji coba saat ini tidak menggunakan parameter pengaturan proses terbaru, sehingga Anda dapat pergi ke ruang produksi uji coba untuk menyimpannya lagi!',
    kz: 'Назар аударыңыз: Қазіргі сынақ өндірісі тапсырысы ең соңғы технологиялық параметрлерді пайдаланбайды, сынақ өндіріс бөлмесіне өтіп, қайта сақтауға болады!',
    th: 'หมายเหตุ: ใบสั่งการผลิตทดลองใช้ปัจจุบันไม่ได้ใช้พารามิเตอร์การตั้งค่ากระบวนการล่าสุดดังนั้นคุณสามารถไปที่ห้องผลิตทดลองเพื่อบันทึกอีกครั้ง!',
    ug: 'دىققەت: نۆۋەتتىكى سىناقلىق زاكاز ئەڭ يېڭى پىروگرامما تەڭشەكلىرىنى ئىشلىتىۋاتمىدى، سىناقلىق ئۆيگە بېرىپ قايتا ساقلىسىڭىز بولىدۇ!',
    vi: 'Lưu ý: Đơn hàng thử nghiệm hiện tại không sử dụng các tham số cài đặt công nghệ mới nhất, bạn có thể đến phòng thử nghiệm để lưu lại!',
    zh_tc:
      '注意：當前試生產訂單使用的並不是最新的工藝設置參數，可前往試生產房間重新保存！',
    ru: 'Примечание: Текущий заказ на пробное производство не использует последние параметры технологических параметров, вы можете пойти в комнату пробного производства, чтобы восстановить!',
    ko: '참고: 현재 파일럿 주문은 최신 공정 설정 매개변수를 사용하는 것이 아니므로 파일럿 룸에서 다시 저장할 수 있습니다.',
    bur: 'သတိ: လက်ရှိစမ်းသပ်ထုတ်လုပ်မှုမှာယူမှုသည်နောက်ဆုံးလုပ်ငန်းစဉ်ဆက်တင်ကိုမသုံးပါ၊ စမ်းသပ်ထုတ်လုပ်မှုအခန်းကိုသွားပြီးပြန်သိမ်းနိုင်!',
    ben: 'নোট: বর্তমান পরীক্ষামূলক উৎপাদন অর্ডার সর্বশেষ প্রক্রিয়া সেটিং ব্যবহার করছে না, পরীক্ষামূলক রুমে গিয়ে পুনরায় সংরক্ষণ করুন!',
    tr: 'Dikkat: Deneme üretim siparişi en güncel proses parametrelerini kullanmıyor; deneme odasına gidip yeniden kaydedin',
    km: 'កត់សម្គាល់៖ ការបញ្ជារសាកល្បងមិនប្រើប៉ារ៉ាម៉ែត្រដំណើរការចុងក្រោយ ចូលបន្ទប់សាកល្បងដើម្បីរក្សាឡើងវិញ',
    es: 'Nota: La orden de producción de prueba actual no utiliza los últimos parámetros de configuración del proceso. ¡Puedes ir a la sala de producción de prueba para guardarlo nuevamente!',
    ar: 'ملاحظة: لا يستخدم أمر الإنتاج التجريبي الحالي أحدث معلمات إعداد العملية. يمكنك الذهاب إلى غرفة الإنتاج التجريبي لحفظه مرة أخرى!',
  },
  'historyPage.trailProduction.download': {
    zh: '下载加工文件',
    en: 'Download the processing file',
    id: 'Unduh file pemrosesan',
    kz: 'Өңдеу файлын жүктеу',
    th: 'ดาวน์โหลดไฟล์ประมวลผล',
    ug: 'ئىشلەش ھۆججىتىنى چۈشۈرۈش',
    vi: 'Tải xuống tập tin gia công',
    zh_tc: '下載加工文件',
    ru: 'Загрузить файл обработки',
    ko: '가공 파일 다운로드',
    bur: 'ဖြည်ပြင်ဆင်ဖိုင်ဒေါင်းလုတ်',
    ben: 'প্রক্রিয়াকরণ ফাইল ডাউনলোড করুন',
    tr: 'İşleme dosyasını indir',
    km: 'ទាញយកឯកសារដំណើរការ',
    es: 'Descargar archivos de procesamiento',
    ar: 'تنزيل ملفات المعالجة',
  },
  'historyPage.deleteTip': {
    zh: '是否确认删除以下历史记录？',
    en: 'Are you sure you want to delete the following history records?',
    id: 'Apakah Anda pasti akan menghapus sejarah berikut?',
    kz: 'Толық тарихи жазбаларды жоюға жоспарлануда мұрайсыз ба?',
    th: 'คุณแน่ใจว่าจะลบประวัติต่อไปนี้หรือไม่?',
    ug: 'تۆۋەندىكى تارىخ خاتىرىسىنى ئۆچۈرۈشنى جازالامسىز؟',
    vi: 'Bạn có chắc chắn muốn xóa lịch sử sau đây không?',
    zh_tc: '是否確認刪除以下歷史記錄？',
    ru: 'Подтверждаете ли вы удаление следующих исторических записей?',
    ko: '다음 히스토리를 삭제하시겠습니까?',
    bur: 'အောက်ပါမှတ်တမ်းများဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'নিম্নলিখিত ইতিহাস রেকর্ড মুছে ফেলতে নিশ্চিত করবেন?',
    tr: 'Aşağıdaki geçmiş kayıtlarını silmeyi onaylıyor musunuz?',
    km: 'បញ្ជាក់លុបកំណត់ត្រាប្រវត្តិខាងក្រោម?',
    es: '¿Está seguro de eliminar los siguientes registros del historial?',
    ar: 'هل أنت متأكد من حذف سجلات التاريخ التالية؟',
  },
  'historyPage.startDate': {
    zh: '开始日期',
    en: 'Start Date',
    id: 'tanggal mulai',
    kz: 'Басталу күні',
    th: 'วันที่เริ่มต้น',
    ug: 'باشلانغان ۋاقىت',
    vi: 'Ngày bắt đầu',
    zh_tc: '開始日期',
    ru: 'Дата начала',
    ko: '시작 날짜',
    bur: 'စတင်ရက်',
    ben: 'শুরুর তারিখ',
    tr: 'Başlangıç tarihi',
    km: 'កាលបរិច្ឆេទចាប់ផ្តើម',
    es: 'Fecha de inicio',
    ar: 'تاريخ البدء',
  },
  'historyPage.endDate': {
    zh: '结束日期',
    en: 'End Date',
    id: 'Tanggal akhir',
    kz: 'Аяқталу күні',
    th: 'วันที่สิ้นสุด',
    ug: 'ئاخىرلاشقان ۋاقىت',
    vi: 'Ngày kết thúc',
    zh_tc: '結束日期',
    ru: 'дата окончания',
    ko: '종료일',
    bur: 'ပြီးဆုံးရက်',
    ben: 'শেষ তারিখ',
    tr: 'Bitiş tarihi',
    km: 'កាលបរិច្ឆេទបញ្ចប់',
    es: 'Fecha de finalización',
    ar: 'تاريخ الانتهاء',
  },
  'historyPage.lastWeek': {
    zh: '最近一周',
    en: 'Last Week',
    id: 'Minggu terakhir',
    kz: 'Соңғы апта',
    th: 'สัปดาห์ที่แล้ว',
    ug: 'ئەڭ يېقىنقى بىر ھەپتە',
    vi: 'Tuần gần đây',
    zh_tc: '最近一周',
    ru: 'Неделя',
    ko: '최근 일주일',
    bur: 'ယခင်တစ်ပတ်',
    ben: 'গত এক সপ্তাহ',
    tr: 'Son bir hafta',
    km: 'មួយសប្តាហ៍ចុងក្រោយ',
    es: 'La semana pasada',
    ar: 'الأسبوع الماضي',
  },
  'historyPage.lastMonth': {
    zh: '最近一月',
    en: 'Last Month',
    id: 'Bulan lalu',
    kz: 'Соңғы ай',
    th: 'เดือนที่แล้ว',
    ug: 'ئەڭ يېقىنقى بىر ئاي',
    vi: 'Tháng gần đây',
    zh_tc: '最近一月',
    ru: 'Последний месяц',
    ko: '최근 1월',
    bur: 'ယခင်တစ်လ',
    ben: 'গত এক মাস',
    tr: 'Son bir ay',
    km: 'មួយខែចុងក្រោយ',
    es: 'El mes pasado',
    ar: 'الشهر الماضي',
  },
  'historyPage.lastSeason': {
    zh: '最近三月',
    en: 'Last Three Months',
    id: 'Maret lalu',
    kz: 'Соңғы үш ай',
    th: 'เดือนมีนาคมที่ผ่านมา',
    ug: 'ئەڭ يېقىنقى ئۈچ ئاي',
    vi: 'Ba tháng gần đây',
    zh_tc: '最近三月',
    ru: 'Последний март',
    ko: '최근 3월',
    bur: 'ယခင်သုံးလ',
    ben: 'গত তিন মাস',
    tr: 'Son üç ay',
    km: 'បីខែចុងក្រោយ',
    es: 'Los últimos tres meses',
    ar: 'الأشهر الثلاثة الأخيرة',
  },
  'historyPage.toArrangePage': {
    zh: '正在前往排版页面',
    en: 'Navigating to Layout Page',
    id: 'Pergi ke halaman tata letak',
    kz: 'Тәртіп бетіне өту',
    th: 'ไปที่หน้าเค้าโครง',
    ug: 'تەرتىپلەش بېتىگە يۆتكىلىۋاتىدۇ',
    vi: 'Đang chuyển đến trang bố cục',
    zh_tc: '正在前往排版頁面',
    ru: 'Перейти на страницу',
    ko: '조판 페이지로 이동 중',
    bur: 'ပြင်ဆင်မှုစာမျက်နှာသို့သွားနေသည်',
    ben: 'লেআউট পেজে যাওয়া হচ্ছে',
    tr: 'Yerleşim sayfasına gidiliyor',
    km: 'កំពុងទៅទំព័ររៀបចំ',
    es: 'Dirigiéndose a la página de composición tipográfica',
    ar: 'التوجه إلى صفحة التنضيد',
  },
  'historyPage.notArrangedTip': {
    zh: '该条记录没有进行过排版, 请先前往开料清单!',
    en: 'This record has not been arranged yet, please go to the material list first!',
    id: 'Catatan ini belum diketik, silakan pergi ke daftar materi terlebih dahulu!',
    kz: 'Бұл жазбада тәртіп жасалмаған, алдымен материалдар тізіміне өтіңіз!',
    th: 'บันทึกนี้ยังไม่ได้รับการพิมพ์โปรดไปที่รายการวัสดุก่อน!',
    ug: 'بۇ خاتىرىدە تەرتىپلەش ئەمەلگە ئاشمىغان، ئاۋۋال ماتېرىيال تىزىمىغا بېرىڭ!',
    vi: 'Bản ghi này chưa được bố cục, vui lòng đi đến danh sách nguyên liệu!',
    zh_tc: '該條記錄沒有進行過排版, 請先前往開料清單!',
    ru: 'Эта запись не была напечатана, пожалуйста, перейдите к списку открытых материалов!',
    ko: '이 기록은 조판을 한 적이 없으니, 먼저 BOM으로 가십시오!',
    bur: 'ဤမှတ်တမ်းသည်ပြင်ဆင်မှုမလုပ်ဖူးသေး၊ ကုန်ကြမ်းစာရင်းကိုဦးစွာသွားပါ!',
    ben: 'এই রেকর্ড এখনো লেআউট করা হয়নি, প্রথমে উপকরণ তালিকায় যান!',
    tr: 'Bu kayıt yerleştirilmedi; önce kesim listesine gidin',
    km: 'កំណត់ត្រានេះមិនធ្វើរៀបចំ សូមទៅបញ្ជីកាត់មុន',
    es: 'Este registro no ha sido compuesto, ¡vaya primero a la lista de materiales!',
    ar: 'لم يتم تنضيد هذا السجل، يرجى الانتقال إلى قائمة المواد أولاً!',
  },
  'historyPage.toMaterialPage': {
    zh: '正在前往开料清单页面',
    en: 'Navigating to Material List Page',
    id: 'Pergi ke halaman Bill of Material',
    kz: 'Материалдар тізімі бетіне өту',
    th: 'ไปที่หน้า Bill of Material',
    ug: 'ماتېرىيال تىزىمى بېتىگە يۆتكىلىۋاتىدۇ',
    vi: 'Đang chuyển đến trang danh sách nguyên liệu',
    zh_tc: '正在前往開料清單頁面',
    ru: 'Перейти на страницу списка',
    ko: '커팅 리스트 페이지로 이동 중',
    bur: 'ကုန်ကြမ်းစာရင်းစာမျက်နှာသို့သွားနေသည်',
    ben: 'উপকরণ তালিকা পেজে যাওয়া হচ্ছে',
    tr: 'Kesim listesi sayfasına gidiliyor',
    km: 'កំពុងទៅទំព័របញ្ជីកាត់',
    es: 'Dirigiéndose a la página de lista de materiales',
    ar: 'التوجه إلى صفحة قائمة المواد',
  },
  'historyPage.lessSelectTip': {
    zh: '请至少选中一条记录再进行此操作',
    en: 'Please select at least one record before performing this action',
    id: 'Pilih setidaknya satu catatan sebelum melakukan operasi ini',
    kz: 'Бұл әрекетті орындау үшін кем дегенде бір жазбаны таңдаңыз',
    th: 'โปรดเลือกอย่างน้อยหนึ่งระเบียนก่อนดำเนินการนี้',
    ug: 'بۇ مەشغۇلاتنى ئىجرا قىلىش ئۈچۈن ئەلۋەتتە بىر خاتىرىنى تاللاڭ',
    vi: 'Vui lòng chọn ít nhất một bản ghi để tiến hành thao tác này',
    zh_tc: '請至少選中一條記錄再進行此操作',
    ru: 'Пожалуйста, выберите хотя бы одну запись для этой операции.',
    ko: '이 작업을 수행하려면 레코드를 하나 이상 선택하십시오.',
    bur: 'ဤလုပ်ဆောင်မှုမပြုမီ မှတ်တမ်းတစ်ခုနှင့်အထက်ရွေးပါ',
    ben: 'এই অপারেশন করার আগে কমপক্ষে একটি রেকর্ড নির্বাচন করুন',
    tr: 'Bu işlem için en az bir kayıt seçin',
    km: 'ជ្រើសរើសយ៉ាងហោចណាមួយកំណត់ត្រាមុនធ្វើ',
    es: 'Seleccione al menos un registro antes de realizar esta operación',
    ar: 'يرجى تحديد سجل واحد على الأقل قبل إجراء هذه العملية',
  },
  'historyPage.downloadNc': {
    zh: '下载加工文件',
    en: 'Download Processing File',
    id: 'Unduh file pemrosesan',
    kz: 'Өңдеу файлын жүктеу',
    th: 'ดาวน์โหลดไฟล์ประมวลผล',
    ug: 'ئىشلەش ھۆججىتىنى چۈشۈرۈش',
    vi: 'Tải xuống tệp xử lý',
    zh_tc: '下載加工文件',
    ru: 'Загрузить файл обработки',
    ko: '가공 파일 다운로드',
    bur: 'ဖြည်ပြင်ဆင်ဖိုင်ဒေါင်းလုတ်',
    ben: 'প্রক্রিয়াকরণ ফাইল ডাউনলোড করুন',
    tr: 'İşleme dosyasını indir',
    km: 'ទាញយកឯកសារដំណើរការ',
    es: 'Descargar archivos de procesamiento',
    ar: 'تنزيل ملفات المعالجة',
  },
  'workShopPage.warningTip': {
    zh: '该功能为限时试用，请合理安排您的订单生产！',
    en: 'This feature is a limited-time trial. Please arrange your order production reasonably!',
    id: 'Fungsi ini adalah uji coba waktu terbatas, atur produksi pesanan Anda secara wajar!',
    kz: 'Бұл функциясы уақытша сынақты, тапсырыс өндірісінің рационалдықтыны қамтамасыз етіңіз!',
    th: 'ฟังก์ชั่นนี้เป็นการทดลองใช้เวลา จำกัด โปรดจัดเรียงคำสั่งซื้อของคุณอย่างสมเหตุสมผล!',
    ug: 'بۇ ئىقتىدار ۋاقىتلىق سىناشقا ئېرىشىشكە بولىدۇ، زاكازلىرىڭىزنى مۇناسىۋەتلىك تەرتىپلەڭ!',
    vi: 'Chức năng này là dùng thử giới hạn thời gian, vui lòng sắp xếp sản xuất đơn hàng của bạn hợp lý!',
    zh_tc: '該功能為限時試用，請合理安排您的訂單生產！',
    ru: 'Эта функция для ограниченного времени тестирования, пожалуйста, рационально организуйте производство вашего заказа!',
    ko: '이 기능은 한시적으로 시험적으로 사용할 수 있습니다. 주문 생산을 합리적으로 안배해 주십시오!',
    bur: 'ဤလုပ်ဆောင်ချက်သည်အချိန်ကန့်သတ်စမ်းသပ်ဖြစ်သည်၊ မှာယူမှုထုတ်လုပ်မှုကိုသင့်တော်အောင်စီစဉ်ပါ!',
    ben: 'এই ফিচার সীমিত সময়ের ট্রায়াল, আপনার অর্ডার উৎপাদন যুক্তিসঙ্গতভাবে সাজান!',
    tr: 'Bu özellik süreli denemedir; sipariş üretiminizi makul planlayın',
    km: 'មុខងារនេះជាការសាកល្បងកំណត់ពេល សូមរៀបចំការផលិតការបញ្ជារឲ្យសមរម្យ',
    es: 'Esta función es una prueba por tiempo limitado, ¡organice la producción de su pedido de manera razonable!',
    ar: 'هذه الوظيفة تجريبية لفترة محدودة، يرجى ترتيب إنتاج طلبك بشكل معقول!',
  },
  'workShopPage.fileManager': {
    zh: '生产文件管理',
    en: 'Production File Management',
    id: 'Manajemen File Produksi',
    kz: 'Өндіріс файлдарын басқару',
    th: 'การจัดการไฟล์การผลิต',
    ug: 'ئىشلەپچىقىرىش ھۆججەت باشقۇرۇش',
    vi: 'Quản lý tệp sản xuất',
    zh_tc: '生產文件管理',
    ru: 'Управление производственной документацией',
    ko: '프로덕션 파일 관리',
    bur: 'ထုတ်လုပ်မှုဖိုင်စီမံ',
    ben: 'উৎপাদন ফাইল ব্যবস্থাপনা',
    tr: 'Üretim dosyası yönetimi',
    km: 'ការគ្រប់គ្រងឯកសារផលិត',
    es: 'Gestión de archivos de producción',
    ar: 'إدارة ملف الإنتاج',
  },
  'workShopPage.selected': {
    zh: '已选中',
    en: 'selected',
    id: 'Terpilih',
    kz: 'таңдалды',
    th: 'ที่เลือก',
    ug: 'تاللانغان',
    vi: 'Đã chọn',
    zh_tc: '已選中',
    ru: 'Выбран',
    ko: '선택됨',
    bur: 'ရွေးချယ်ပြီး',
    ben: 'নির্বাচিত',
    tr: 'seçildi',
    km: 'បានជ្រើសរើស',
    es: 'Seleccionado',
    ar: 'المحدد',
  },
  'workShopPage.suplement': {
    zh: '补件',
    en: 'Supplement Warehouse',
    id: 'Penambahan',
    kz: 'Қосымша бөлшектер қоймасы',
    th: 'การเติมเต็ม',
    ug: 'قوشۇمچە بۆلەك',
    vi: 'Bù thiếu phụ tùng',
    zh_tc: '補件',
    ru: 'Дополнение',
    ko: '패치',
    bur: 'ဖြည့်ဆည်း',
    ben: 'পরিপূরক',
    tr: 'Tamamlama deposu',
    km: 'ឃ្លាំងបំពេញ',
    es: 'Piezas de reposición',
    ar: 'أجزاء التجديد',
  },
  'workShopPage.size': {
    zh: '尺寸',
    en: 'Size',
    id: 'ukuran',
    kz: 'Өлшем',
    th: 'ขนาด',
    ug: 'ئۆلچەم',
    vi: 'Kích thước',
    zh_tc: '尺寸',
    ru: 'размер',
    ko: '치수',
    bur: 'အတိုင်းအတာ',
    ben: 'আকার',
    tr: 'Boyut',
    km: 'ទំហំ',
    es: 'Tamaño',
    ar: 'الحجم',
  },
  'workShopPage.saveToStore': {
    zh: '添加进补件仓库',
    en: 'Add to Supplement Warehouse',
    id: 'Tambahkan ke gudang pengisian',
    kz: 'Қосымша бөлшектер қоймасына қосу',
    th: 'เพิ่มไปยังคลังสินค้าเติมเต็ม',
    ug: 'قوشۇمچە بۆلەك ئامبىرىغا قوشۇش',
    vi: 'Thêm vào kho bù thiếu phụ tùng',
    zh_tc: '添加進補件倉庫',
    ru: 'Добавить в хранилище',
    ko: '엔트리 웨어하우스 추가',
    bur: 'ဖြည့်ဆည်းဂိုဒေါင်ထည့်',
    ben: 'পরিপূরক গুদামে যোগ করুন',
    tr: 'Tamamlama deposuna ekle',
    km: 'បន្ថែមទៅឃ្លាំងបំពេញ',
    es: 'Agregar almacén de piezas de reposición',
    ar: 'إضافة مستودع قطع الغيار',
  },
  'workShopPage.enterArrange': {
    zh: '正在进入排版...',
    en: 'Entering Layout...',
    id: 'Memasuki tipografi ...',
    kz: 'Түзетуге кіріп жатыр...',
    th: 'เข้าสู่การพิมพ์ ...',
    ug: 'تەرتىپلەشكە كىرىشۋاتىدۇ...',
    vi: 'Đang chuyển đến trang bố cục...',
    zh_tc: '正在進入排版...',
    ru: 'Входит в типографию. Это...',
    ko: '조판에 들어가고 있습니다...',
    bur: 'ပြင်ဆင်မှုတွင်ဝင်နေသည်...',
    ben: 'লেআউটে প্রবেশ হচ্ছে...',
    tr: 'Yerleşime giriliyor...',
    km: 'កំពុងចូលរៀបចំ...',
    es: 'Ingresando tipografía...',
    ar: 'الدخول إلى التنضيد...',
  },
  'workShopPage.deleteTip': {
    zh: '删除该数据后不可恢复，是否确认删除该数据？',
    en: 'After deleting this data, it cannot be restored. Are you sure you want to delete this data?',
    id: 'Itu tidak dapat dipulihkan setelah menghapus data. Apakah Anda yakin bahwa data dihapus?',
    kz: 'Бұл деректерді жоюдан кейін олар қалпына келтірілмейді, деректерді жоюға жоспарлануда мұрайсыз ба?',
    th: 'ไม่สามารถกู้คืนได้หลังจากลบข้อมูล คุณแน่ใจหรือไม่ว่าข้อมูลถูกลบ?',
    ug: 'بۇ سانلىق مەلۇماتنى ئۆچۈرگەندىن كېيىن قايتۇرۇشقا بولمايدۇ، ئۆچۈرۈشنى جازالامسىز؟',
    vi: 'Sau khi xóa dữ liệu này, nó sẽ không thể khôi phục lại, bạn có chắc chắn muốn xóa dữ liệu này không?',
    zh_tc: '刪除該數據後不可恢復，是否確認刪除該數據？',
    ru: 'Данные не могут быть восстановлены после удаления, подтверждается ли удаление данных?',
    ko: '데이터를 삭제한 후 복구할 수 없습니다. 삭제하시겠습니까?',
    bur: 'ဒေတာဖျက်ပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'ডেটা মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tr: 'Bu veri silindikten sonra geri yüklenemez. Silmeyi onaylıyor musunuz?',
    km: 'ទិន្នន័យនេះលុបរួចមិនអាចស្តារឡើងវិញ បញ្ជាក់លុប?',
    es: 'Estos datos no se pueden restaurar después de eliminarlos. ¿Confirmas eliminar estos datos?',
    ar: 'لا يمكن استعادة هذه البيانات بعد الحذف. هل تؤكد حذف هذه البيانات؟',
  },
  'workShopPage.arrangeTip': {
    zh: '正在解析补件数据,请稍等...',
    en: 'Analyzing supplement data, please wait...',
    id: 'Resolusi data suplemen, harap tunggu ...',
    kz: 'Қосымша бөлшектерді талдайды, ұсталыңыз...',
    th: 'ความละเอียดของข้อมูลเสริมโปรดรอ ...',
    ug: 'قوشۇمچە بۆلەك سانلىق مەلۇماتىنى تەھلىل قىلىۋاتىدۇ، سەل ساقلاڭ...',
    vi: 'Đang phân tích dữ liệu bù thiếu phụ tùng, vui lòng đợi...',
    zh_tc: '正在解析補件數據,請稍等...',
    ru: 'Анализируются данные дополнения, пожалуйста, подождите. Это...',
    ko: '패치 데이터를 처리하는 중입니다. 잠시만 기다려 주십시오...',
    bur: 'ဖြည့်ဆည်းဒေတာပြင်ဆင်နေသည်၊ ခဏစောင့်ပါ...',
    ben: 'পরিপূরক ডেটা বিশ্লেষণ করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    tr: 'Ek parça verisi çözümleniyor, lütfen bekleyin...',
    km: 'កំពុងញែកទិន្នន័យបំពេញ សូមរង់ចាំ...',
    es: 'Analizando datos de reposición, espere...',
    ar: 'تحليل بيانات التجديد، يرجى الانتظار...',
  },
  'workShopPage.store': {
    zh: '补件仓库',
    en: 'Supplement Warehouse',
    id: 'Gudang Pengisian',
    kz: 'Қосымша бөлшектер қоймасы',
    th: 'คลังสินค้าที่เติมเต็ม',
    ug: 'قوشۇمچە بۆلەك ئامبىرى',
    vi: 'Kho bù thiếu phụ tùng',
    zh_tc: '補件倉庫',
    ru: 'Запасной склад',
    ko: '보충 창고',
    bur: 'ဖြည့်ဆည်းဂိုဒေါင်',
    ben: 'পরিপূরক গুদাম',
    tr: 'Tamamlama deposu',
    km: 'ឃ្លាំងបំពេញ',
    es: 'Almacén de piezas de reposición',
    ar: 'مستودع قطع الغيار',
  },
  'workShopPage.downloadFile': {
    zh: '下载生产文件',
    en: 'Download Production File',
    id: 'Unduh file produksi',
    kz: 'Өнім файлын жүктеу',
    th: 'ดาวน์โหลดไฟล์การผลิต',
    ug: 'ئىشلەپچىقىرىش ھۆججىتىنى چۈشۈرۈش',
    vi: 'Tải xuống tệp sản xuất',
    zh_tc: '下載生產文件',
    ru: 'Загрузка производственных документов',
    ko: '프로덕션 파일 다운로드',
    bur: 'ထုတ်လုပ်မှုဖိုင်ဒေါင်းလုတ်',
    ben: 'উৎপাদন ফাইল ডাউনলোড করুন',
    tr: 'Üretim dosyasını indir',
    km: 'ទាញយកឯកសារផលិត',
    es: 'Descargar archivos de producción',
    ar: 'تنزيل ملفات الإنتاج',
  },
  'workShopPage.notBujianFile': {
    zh: '找不到补件文件',
    en: 'Supplementary file not found',
    id: 'File suplemen tidak dapat ditemukan',
    kz: 'Қосымша файл табылмады',
    th: 'ไม่พบไฟล์เสริม',
    ug: 'قوشۇمچە بۆلەك ھۆججىتى تېپىلمىدى',
    vi: 'Không tìm thấy tệp bổ sung',
    zh_tc: '找不到補件文件',
    ru: 'Файл дополнения не найден',
    ko: '패치 파일을 찾을 수 없습니다.',
    bur: 'ဖြည့်ဆည်းဖိုင်မတွေ့ပါ',
    ben: 'পরিপূরক ফাইল পাওয়া যায়নি',
    tr: 'Ek parça dosyası bulunamadı',
    km: 'រកមិនឃើញឯកសារបំពេញ',
    es: 'Archivos de reposición no encontrados',
    ar: 'لم يتم العثور على ملفات التجديد',
  },
  'workShopPage.productLineDelete': {
    zh: '该生产线已被删除,无法下载NC文件!',
    en: 'This production line has been deleted, NC file download unavailable!',
    id: 'Baris produksi telah dihapus dan file NC tidak dapat diunduh!',
    kz: 'Бұл өндірістік желі жойылды, NC файлын жүктеу мүмкін емес!',
    th: 'สายการผลิตถูกลบและไม่สามารถดาวน์โหลดไฟล์ NC ได้!',
    ug: 'بۇ ئىشلەپچىقىرىش لىنىيىسى ئۆچۈرۈلگەن، NC ھۆججىتىنى چۈشۈرەلمەيسىز!',
    vi: 'Dòng sản xuất này đã bị xóa, không thể tải xuống tệp NC!',
    zh_tc: '該生產線已被刪除,無法下載NC文件!',
    ru: 'Производственная линия была удалена, и файл NC не может быть загружен!',
    ko: '생산 라인이 삭제되어 NC 파일을 다운로드할 수 없습니다!',
    bur: 'ဤထုတ်လုပ်မှုလိုင်းကိုဖျက်ပြီး၊ NC ဖိုင်ဒေါင်းလုတ်မနိုင်!',
    ben: 'এই উৎপাদন লাইন মুছে ফেলা হয়েছে, NC ফাইল ডাউনলোড করা যাবে না!',
    tr: 'Bu üretim hattı silindi; NC dosyası indirilemez!',
    km: 'បន្ទាត់ផលិតនេះត្រូវបានលុប មិនអាចទាញយក NC!',
    es: 'La línea de producción ha sido eliminada y el archivo NC ¡No se puede descargar!',
    ar: 'تم حذف خط الإنتاج وملف NC لا يمكن تحميلها!',
  },
  'basePlankManager.saveTip': {
    zh: '注：按回车进行保存',
    en: 'Attention: Press Enter to save',
    id: 'Catatan: Tekan Enter untuk menyimpan',
    kz: 'Ескерту: Қайта басу арқылы сақтау',
    th: 'หมายเหตุ: กด Enter เพื่อบันทึก',
    ug: 'ئەسكەرتىش: ساقلاش ئۈچۈن Enter كۇنپۇكىنى بېسىڭ',
    vi: 'Chú ý: Nhấn Enter để lưu',
    zh_tc: '注：按回車進行保存',
    ru: 'Примечание: Сохранение по возврату автомобиля',
    ko: '참고: 캐리지 리턴별로 저장',
    bur: 'မှတ်ချက်: Enter နှိပ်ပြီးသိမ်း',
    ben: 'নোট: সংরক্ষণ করতে Enter চাপুন',
    tr: 'Not: Kaydetmek için Enter tuşuna basın',
    km: 'ចំណាំ៖ ចុច Enter ដើម្បីរក្សា',
    es: 'Nota: Presione Enter para guardar',
    ar: 'ملاحظة: اضغط على Enter لحفظ',
  },
  'basePlankManager.offsetSize': {
    zh: '修边尺寸',
    en: 'Trimming Size',
    id: 'Ukuran trim',
    kz: 'Кескіштің өлшемі',
    th: 'ขนาดตัดแต่ง',
    ug: 'چېگرا كېسىش ئۆلچىمى',
    vi: 'Kích thước chiết rìa',
    zh_tc: '修邊尺寸',
    ru: 'Размер обрезки',
    ko: '모서리 치수 고치기',
    bur: 'ขอบ ဘောင်ဖြတ်အတိုင်းအတာ',
    ben: 'ট্রিমিং সাইজ',
    tr: 'Kenar düzeltme ölçüsü',
    km: 'ទំហំកាត់គែម',
    es: 'Tamaño de recorte',
    ar: 'حجم التشذيب',
  },
  'basePlankManager.overSizeTip': {
    zh: '尺寸过大时，自动选用更大尺寸规格大板进行排版',
    en: 'Auto use larger panels for oversized parts',
    id: 'Ketika ukurannya terlalu besar, papan ukuran dan ukuran yang lebih besar akan dipilih secara otomatis untuk tata letak.',
    kz: 'Өлшемі тым үлкен болған кезде, автоматты түрде үлкен өлшемді кескіштің қалыптасуын таңдайды',
    th: 'เมื่อขนาดมีขนาดใหญ่เกินไปบอร์ดขนาดและขนาดที่ใหญ่กว่าจะถูกเลือกโดยอัตโนมัติสำหรับเค้าโครง',
    ug: 'ئۆلچەم بەك چوڭ بولسا، ئاۋۋال ئۆلچىمى چوڭراق چوڭ تاختا تاللىنىپ تەرتىپلىنىدۇ',
    vi: 'Khi kích thước quá lớn, hệ thống sẽ tự động chọn tấm lớn hơn để bố cục',
    zh_tc: '尺寸過大時，自動選用更大尺寸規格大板進行排版',
    ru: 'Когда размер слишком большой, автоматически выбирайте большие размеры для набора',
    ko: '사이즈가 너무 크면, 자동으로 더 큰 사이즈 규격의 대판을 선택하여 조판한다.',
    bur: 'အတိုင်းအတာကြီးလွန်သောအခါ ပေါ်ဒ်ကြီးအရွယ်ကြီးကိုအလိုအလျောက်ရွေးပြင်ဆင်',
    ben: 'আকার অনেক বড় হলে, স্বয়ংক্রিয়ভাবে বড় আকারের বড় বোর্ড নির্বাচন করে লেআউট করুন',
    tr: 'Ölçü çok büyükse yerleşim için otomatik olarak daha büyük levha seçilir',
    km: 'នៅពេលខ្នាតធំពេក ប្រព័ន្ធរើសផ្ទាំងធំធ្វើរៀបចំស្វ័យប្រវត្តិ',
    es: 'Cuando el tamaño es demasiado grande, se seleccionará automáticamente una placa de mayor tamaño para la composición tipográfica',
    ar: 'عندما يكون الحجم كبيرًا جدًا، سيتم تحديد لوحة ذات حجم أكبر تلقائيًا للتنضيد',
  },
  'basePlankManager.addTip': {
    zh: '排版时如果板件超尺，弹出自动添加特殊大板弹窗',
    en: 'If the board piece exceeds the allowed size during layout, a popup will appear to automatically add a special large sheet',
    id: 'Jika papan dikuasai selama tata letak, jendela pop-up papan besar khusus akan ditambahkan secara otomatis ke pop up.',
    kz: 'Қалыптасу кезінде кескіштің өлшемі тым үлкен болса, автоматты түрде арнайы үлкен кескіштің қосу диалогтық пенересісіні ашады',
    th: 'หากบอร์ดสิ้นสุดลงในระหว่างการจัดวางหน้าต่างป๊อปอัพบอร์ดขนาดใหญ่พิเศษจะถูกเพิ่มเข้ามาในป๊อปอัพโดยอัตโนมัติ',
    ug: 'ئەگەر تاختا بۆلەك ئۆلچىمى چەكتىن ئاشسا، ئالاھىدە چوڭ تاختا قوشۇش سۆزلىشىش كۆزنىكى ئېچىلىدۇ',
    vi: 'Khi bố cục, nếu chi tiết bàn quá lớn, hiện cửa sổ tự động thêm tấm lớn đặc biệt',
    zh_tc: '排版時如果板件超尺，彈出自動添加特殊大板彈窗',
    ru: 'При наборе, если панель превышает фут, всплывающее окно автоматически добавляет специальную большую панель',
    ko: '조판 시 판재가 초자를 초과하면, 튀어나와 자동으로 특수 대판 탄창을 추가합니다',
    bur: 'ပြင်ဆင်ချိန်ပေါ်ဒ်ကြာ့သောအခါ အထူးပေါ်ဒ်ကြီးအလိုအလျောက်ထည့်ရောက်မည်',
    ben: 'লেআউটে বোর্ড বেশি বড় হলে, বিশেষ বড় বোর্ড স্বয়ংক্রিয়ভাবে যোগ করার পপআপ আসবে',
    tr: 'Yerleşimde parça ölçü aşımında özel büyük levha ekleme penceresi açılır',
    km: 'នៅពេលរៀបចំលើសខ្នាត បង្ហាញប្រអប់បន្ថែមផ្ទាំងធំពិសេស',
    es: 'Si la placa es demasiado grande durante la composición tipográfica, aparecerá una ventana emergente para agregar automáticamente una placa grande especial',
    ar: 'إذا كانت اللوحة كبيرة الحجم أثناء التنضيد، ستظهر نافذة منبثقة لإضافة لوحة كبيرة خاصة تلقائيًا',
  },
  'basePlankManager.defaultOversizePlankValue': {
    zh: '设置超尺特殊大板的默认添加尺寸',
    en: 'Set the default size for oversized special sheets',
    id: 'Atur ukuran bahan khusus yang lebih besar secara default',
    kz: 'Үлкен өлшемді арнайы кескіштің үлкен өлшемін автоматты түрде таңдауды орнатыңыз',
    th: 'ตั้งค่าขนาดของวัสดุพิเศษที่ใหญ่กว่าค่าเริ่มต้น',
    ug: 'چوڭ تاختا قوشۇش سۆزلىشىشىنىڭ چوڭراق چوڭ تاختىنى ئاۋال ئىشلىتىڭ',
    vi: 'Thiết lập kích thước tấm lớn đặc biệt mặc định',
    zh_tc: '設置超尺特殊大板的默認添加尺寸',
    ru: 'Установите размеры больших специальных листов по умолчанию',
    ko: '대판 특수 대판의 기본 추가 크기 설정',
    bur: 'ကြာ့ပေါ်ဒ်ကြီးသည်ကြာ့ပေါ်ဒ်ငယ်သာပြင်ဆင်တဲ့အခါအထူးပေါ်ဒ်ကြီးအလိုအလျောက်ထည့်ရောက်မည်',
    ben: 'অতিরিক্ত আকারের বড় বোর্ড শুধুমাত্র অতিরিক্ত আকারের ছোট বোর্ড সাজায়',
    tr: 'Ölçü aşımı büyük levhalar yalnızca ölçü aşımı küçük levhaları sıralar',
    km: 'ផ្ទាំងធំលើសខ្នាតរៀបតែផ្ទាំងតូចលើសខ្នាត',
    es: 'Establecer el tamaño predeterminado de las placas grandes especiales',
    ar: 'تعيين الحجم الافتراضي للوحات الكبيرة الخاصة',
  },
  'basePlankManager.onlyLayoutTooBig': {
    zh: '超尺大板只排超尺小板',
    en: 'Oversize panels only for oversize parts',
    id: 'Piring besar ukuran ekstra hanya berbaris dengan piring kecil ukuran ekstra',
    kz: 'Тек үлкен өлшемді панельдер үлкен өлшемді кіші панельдер үшін орналастырылады',
    th: 'แผ่นขนาดใหญ่ขนาดพิเศษจะเรียงรายไปด้วยแผ่นเล็กขนาดพิเศษ',
    ug: 'چەكتىن ئاشقان چوڭ تاختا پەقەت چەكتىن ئاشقان كىچىك تاختىلارنى تەرتىپلەيدۇ',
    vi: 'Chỉ bố trí các tấm quá kích thước cho các tấm nhỏ quá kích thước',
    zh_tc: '超尺大板只排超尺小板',
    ru: 'Сверхфутовые доски',
    ko: '초척 대판은 초척 소판만 배열한다',
    bur: 'ကြာ့ပေါ်ဒ်ကြီးသည်ကြာ့ပေါ်ဒ်ငယ်သာပြင်ဆင်',
    ben: 'অতিরিক্ত আকারের বড় বোর্ড শুধুমাত্র অতিরিক্ত আকারের ছোট বোর্ড সাজায়',
    tr: 'Ölçü aşımı büyük levhalar yalnızca ölçü aşımı küçük levhaları sıralar',
    km: 'ផ្ទាំងធំលើសខ្នាតរៀបតែផ្ទាំងតូចលើសខ្នាត',
    es: 'Las placas grandes de gran tamaño solo organizarán placas pequeñas de gran tamaño',
    ar: 'ستقوم اللوحات الكبيرة كبيرة الحجم بترتيب اللوحات الصغيرة كبيرة الحجم فقط',
  },
  'basePlankManager.settingRemark': {
    zh: '注：原此处功能调整到右侧设置内',
    en: 'Attention: the function here is adjusted to the right setting',
    id: 'Catatan: Fungsi asli di sini disesuaikan dengan pengaturan yang tepat',
    kz: 'Ескертпе: Мұндағы бастапқы функция оң жақтағы параметрлерге реттеледі.',
    th: 'หมายเหตุ: ฟังก์ชั่นดั้งเดิมที่นี่ถูกปรับให้เข้ากับการตั้งค่าที่ถูกต้อง',
    ug: 'ئەسكەرتىش: بۇ يەردىكى ئىقتىدار ئوڭ تەرەپتىكى تەڭشەككە يۆتكەلدى',
    vi: 'Lưu ý: Chức năng ban đầu ở đây đã được điều chỉnh sang phần cài đặt bên phải.',
    zh_tc: '注：原此處功能調整到右側設置內',
    ru: 'Примечание: Функция здесь настроена в настройках справа',
    ko: '참고: 원래 이 기능은 오른쪽 설정으로 조정됨',
    bur: 'မှတ်ချက်: မူလဤနေရာလုပ်ဆောင်ချက်ကိုညာဘက်ဆက်တင်တွင်ပြောင်းထားသည်',
    ben: 'নোট: মূল এখানকার ফিচার ডানদিকের সেটিংসে সামঞ্জস্য করা হয়েছে',
    tr: 'Not: Bu bölümdeki işlev sağ ayarlara taşındı',
    km: 'ចំណាំ៖ មុខងារនៅទីនេះបានផ្លាស់ទៅការកំណត់ខាងស្តាំ',
    es: 'Nota: La función original aquí se ajusta a la configuración de la derecha',
    ar: 'ملاحظة: تم ضبط الوظيفة الأصلية هنا على الإعدادات الموجودة على اليمين',
  },
  'basePlankManager.searchPlaceholder': {
    zh: '搜索板材材质/颜色',
    en: 'Search for board material/color',
    id: 'Cari materi/warna papan',
    kz: 'Кескістің матеріал/түсті іздеу',
    th: 'ค้นหาวัสดุบอร์ด/สี',
    ug: 'تاختا ماتېرىيالى/رەڭگىنى ئىزدەش',
    vi: 'Tìm kiếm chất liệu/màu sắc tấm',
    zh_tc: '搜索板材材質/顏色',
    ru: 'Поиск материалов / цвета',
    ko: '판재 재료 / 색상 검색',
    bur: 'ပေါ်ဒ်ပစ္စည်း/အရောင်ရှာ',
    ben: 'বোর্ডের উপকরণ/রঙ অনুসন্ধান করুন',
    tr: 'Levha malzeme/rengi ara',
    km: 'ស្វែងរកសម្ភារៈ/ពណ៌ផ្ទាំង',
    es: 'Buscar material/color de placa',
    ar: 'مادة/لون لوحة البحث',
  },
  'basePlankManager.syncData': {
    zh: '同步柜柜数据',
    en: 'Synchronize cabinet data',
    id: 'Sinkronisasi data kabinet',
    kz: 'Шкафтардың деректерін синхрондау',
    th: 'ซิงโครไนซ์ข้อมูลตู้',
    ug: 'كابىنېت سانلىق مەلۇماتىنى ماس قىلىش',
    vi: 'Đồng bộ hóa dữ liệu tủ',
    zh_tc: '同步櫃櫃數據',
    ru: 'Данные из шкафа синхронизации',
    ko: '캐비닛 데이터 동기화',
    bur: 'ဗိုင်ဒေတာစင်ခ်',
    ben: 'ক্যাবিনেট ডেটা সিঙ্ক্রোনাইজ করুন',
    tr: 'Guigui dolap verilerini eşitle',
    km: 'សមកាលកម្មទិន្នន័យទូ Guigui',
    es: 'Sincronizar datos del gabinete',
    ar: 'مزامنة بيانات الخزانة',
  },
  'basePlankManager.syncDataM': {
    zh: '同步柜门数据',
    en: 'Synchronize cabinet door data',
    id: 'Sinkronisasi Data Pintu Kabinet',
    kz: 'ئىشىك قابىلىقىنى ماس قىلىش',
    th: 'ซิงโครไนซ์ข้อมูลประตูตู้',
    ug: 'ئىشىك سانلىق مەلۇماتىنى ماس قىلىش',
    vi: 'Đồng bộ hóa dữ liệu cửa tủ',
    zh_tc: '同步櫃門數據',
    ru: 'Синхронизация данных',
    ko: '캐비닛 문 데이터 동기화',
    bur: 'ဗိုင်တံခါးဒေတာစင်ခ်',
    ben: 'ক্যাবিনেট দরজার ডেটা সিঙ্ক্রোনাইজ করুন',
    tr: 'Dolap kapısı verilerini eşitle',
    km: 'សមកាលកម្មទិន្នន័យទ្វារទូ',
    es: 'Sincronizar datos de la puerta del gabinete',
    ar: 'مزامنة بيانات باب الخزانة',
  },
  'basePlankManager.deletePlank': {
    zh: '删除特殊大板',
    en: 'Delete special large sheet',
    id: 'Hapus papan khusus',
    kz: 'Арнайы үлкен кескіштің жою',
    th: 'ลบบอร์ดพิเศษ',
    ug: 'ئالاھىدە چوڭ تاختا ئۆچۈرۈش',
    vi: 'Xóa tấm lớn đặc biệt',
    zh_tc: '刪除特殊大板',
    ru: 'Удалить специальную доску',
    ko: '특수 대시보드 삭제',
    bur: 'အထူးပေါ်ဒ်ကြီးဖျက်',
    ben: 'বিশেষ বড় বোর্ড মুছুন',
    tr: 'Özel büyük levha sil',
    km: 'លុបផ្ទាំងធំពិសេស',
    es: 'Eliminar placa grande especial',
    ar: 'حذف لوحة كبيرة خاصة',
  },
  'basePlankManager.addPlank': {
    zh: '新建特殊板材',
    en: 'Create new special sheet',
    id: 'Dewan Khusus Baru',
    kz: 'Жаңа арнайы кескіштің құру',
    th: 'บอร์ดพิเศษใหม่',
    ug: 'ئالاھىدە تاختا قۇرۇش',
    vi: 'Tạo mới tấm đặc biệt',
    zh_tc: '新建特殊板材',
    ru: 'Новые специальные листы',
    ko: '특수 판재를 새로 짓다.',
    bur: 'အထူးပေါ်ဒ်အသစ်ဆောက်',
    ben: 'নতুন বিশেষ বোর্ড তৈরি করুন',
    tr: 'Yeni özel levha oluştur',
    km: 'បង្កើតផ្ទាំងពិសេសថ្មី',
    es: 'Crear nueva placa especial',
    ar: 'إنشاء لوحة خاصة جديدة',
  },
  'basePlankManager.matCodePlaceholder': {
    zh: '请选择板材',
    en: 'Please select a board material',
    id: 'Pilih piring',
    kz: 'Кескістің матеріалін таңдаңыз',
    th: 'กรุณาเลือกจาน',
    ug: 'تاختا ماتېرىيالىنى تاللاڭ',
    vi: 'Vui lòng chọn chất liệu tấm',
    zh_tc: '請選擇板材',
    ru: 'Пожалуйста, выберите доску.',
    ko: '판재를 선택하세요',
    bur: 'ပေါ်ဒ်ရွေးပါ',
    ben: 'বোর্ডের উপকরণ নির্বাচন করুন',
    tr: 'Levha seçin',
    km: 'សូមជ្រើសរើសផ្ទាំង',
    es: 'Seleccione la placa',
    ar: 'يرجى تحديد اللوحة',
  },
  'basePlankManager.thickPlaceHolder': {
    zh: '请选择厚度',
    en: 'Please select a thickness',
    id: 'Pilih ketebalannya',
    kz: 'Кескістің қалыңдығын таңдаңыз',
    th: 'โปรดเลือกความหนา',
    ug: 'قېلىنلىقىنى تاللاڭ',
    vi: 'Vui lòng chọn độ dày',
    zh_tc: '請選擇厚度',
    ru: 'Выберите толщину',
    ko: '두께를 선택하십시오.',
    bur: 'အထူရွေးပါ',
    ben: 'পুরুত্ব নির্বাচন করুন',
    tr: 'Kalınlık seçin',
    km: 'សូមជ្រើសរើសកម្រាស់',
    es: 'Seleccione el grosor',
    ar: 'يرجى تحديد السمك',
  },
  'basePlankManager.widthErr': {
    zh: '板材宽度不能为空',
    en: 'Board width cannot be empty',
    id: 'Lebar pelat tidak bisa kosong',
    kz: 'Кескістің ені бос болмау',
    th: 'ความกว้างของแผ่นไม่สามารถว่างเปล่า',
    ug: 'تاختا كەڭلىكى بوش قالمايدۇ',
    vi: 'Chiều rộng tấm không được để trống',
    zh_tc: '板材寬度不能為空',
    ru: 'Ширина листа не должна быть пустой.',
    ko: '판재 너비는 비워둘 수 없습니다.',
    bur: 'ပေါ်ဒ်အကျယ်မဟာမဆ',
    ben: 'বোর্ডের প্রস্থ খালি রাখা যাবে না',
    tr: 'Levha genişliği boş olamaz',
    km: 'ទទឹងផ្ទាំងមិនអាចទទេ',
    es: 'El ancho de la placa no puede estar vacío',
    ar: 'لا يمكن أن يكون عرض اللوحة فارغًا',
  },
  'basePlankManager.heightErr': {
    zh: '板材长度不能为空',
    en: 'Board length cannot be empty',
    id: 'Panjang pelat tidak bisa kosong',
    kz: 'Кескістің ұзындығы бос болмау',
    th: 'ความยาวของแผ่นไม่สามารถว่างเปล่า',
    ug: 'تاختا ئۇزۇنلۇقى بوش قالمايدۇ',
    vi: 'Chiều dài tấm không được để trống',
    zh_tc: '板材長度不能為空',
    ru: 'Длина листа не должна быть пустой.',
    ko: '판재 길이는 비워둘 수 없습니다.',
    bur: 'ပေါ်ဒ်အရှည်မဟာမဆ',
    ben: 'বোর্ডের দৈর্ঘ্য খালি রাখা যাবে না',
    tr: 'Levha uzunluğu boş olamaz',
    km: 'ប្រវែងផ្ទាំងមិនអាចទទេ',
    es: 'La longitud de la placa no puede estar vacía',
    ar: 'لا يمكن أن يكون طول اللوحة فارغًا',
  },
  'basePlankManager.matCodeErr': {
    zh: '板材材质不能为空',
    en: 'Board material cannot be empty',
    id: 'Bahan papan tidak bisa kosong',
    kz: 'Кескістің матеріалы бос болмау',
    th: 'วัสดุของบอร์ดไม่สามารถว่างเปล่าได้',
    ug: 'تاختا ماتېرىيالى بوش قالمايدۇ',
    vi: 'Chất liệu tấm không được để trống',
    zh_tc: '板材材質不能為空',
    ru: 'Материал не должен быть пустым.',
    ko: '판재 재질은 비워둘 수 없습니다.',
    bur: 'ပေါ်ဒ်ပစ္စည်းမဟာမဆ',
    ben: 'বোর্ডের উপকরণ খালি রাখা যাবে না',
    tr: 'Levha malzemesi boş olamaz',
    km: 'សម្ភារៈផ្ទាំងមិនអាចទទេ',
    es: 'El material de la placa no puede estar vacío',
    ar: 'لا يمكن أن تكون مادة اللوحة فارغة',
  },
  'basePlankManager.colorErr': {
    zh: '板材颜色不能为空',
    en: 'Board color cannot be empty',
    id: 'Warna pelat tidak bisa kosong',
    kz: 'Кескістің түсі бос болмау',
    th: 'สีของแผ่นไม่สามารถว่างเปล่า',
    ug: 'تاختا رەڭگى بوش قالمايدۇ',
    vi: 'Màu sắc tấm không được để trống',
    zh_tc: '板材顏色不能為空',
    ru: 'Цвет листа не должен быть пустым.',
    ko: '판재 색상은 비워둘 수 없습니다.',
    bur: 'ပေါ်ဒ်အရောင်မဟာမဆ',
    ben: 'বোর্ডের রং খালি রাখা যাবে না',
    tr: 'Levha rengi boş olamaz',
    km: 'ពណ៌ផ្ទាំងមិនអាចទទេ',
    es: 'El color de la placa no puede estar vacío',
    ar: 'لا يمكن أن يكون لون اللوحة فارغًا',
  },
  'basePlankManager.editPlank': {
    zh: '编辑板材',
    en: 'Edit sheet',
    id: 'Edit papan',
    kz: 'Кескістің өңдеу',
    th: 'แก้ไขบอร์ด',
    ug: 'تاختا تەھرىرلەش',
    vi: 'Chỉnh sửa tấm',
    zh_tc: '編輯板材',
    ru: 'Редактирование панелей',
    ko: '판재 편집',
    bur: 'ပေါ်ဒ်တည်းဖြတ်',
    ben: 'বোর্ড সম্পাদনা করুন',
    tr: 'Levhayı düzenle',
    km: 'កែផ្ទាំង',
    es: 'Editar placa',
    ar: 'تحرير اللوحة',
  },
  'basePlankManager.deleteTip': {
    zh: '删除该数据后不可恢复，是否确认删除该数据？',
    en: 'After deleting this data, it cannot be recovered. Are you sure you want to delete this data?',
    id: 'Itu tidak dapat dipulihkan setelah menghapus data. Apakah Anda yakin bahwa data dihapus?',
    kz: 'Бұл деректерді жоюдан кейін олар қалпына келтірілмейді, деректерді жоюға жоспарлануда мұрайсыз ба?',
    th: 'ไม่สามารถกู้คืนได้หลังจากลบข้อมูล คุณแน่ใจหรือไม่ว่าข้อมูลถูกลบ?',
    ug: 'بۇ سانلىق مەلۇماتنى ئۆچۈرگەندىن كېيىن قايتۇرۇشقا بولمايدۇ، ئۆچۈرۈشنى جازالامسىز؟',
    vi: 'Sau khi xóa dữ liệu này, nó sẽ không thể khôi phục lại, bạn có chắc chắn muốn xóa dữ liệu này không?',
    zh_tc: '刪除該數據後不可恢復，是否確認刪除該數據？',
    ru: 'Данные не могут быть восстановлены после удаления, подтверждается ли удаление данных?',
    ko: '데이터를 삭제한 후 복구할 수 없습니다. 삭제하시겠습니까?',
    bur: 'ဒေတာဖျက်ပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'ডেটা মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tr: 'Bu veri silindikten sonra geri alınamaz. Silmeyi onaylıyor musunuz?',
    km: 'ទិន្នន័យនេះលុបរួចមិនអាចស្តារ បញ្ជាក់លុប?',
    es: 'Estos datos no se pueden restaurar después de eliminarlos. ¿Confirmas eliminar estos datos?',
    ar: 'لا يمكن استعادة هذه البيانات بعد الحذف. هل تؤكد حذف هذه البيانات؟',
  },
  'basePlankManager.plankKnifeSelect': {
    zh: '原片下料刀选择',
    en: 'Original sheet cutting knife selection',
    id: 'Pilihan pisau pemotongan lembar asli',
    kz: 'Оригиналды кескістің кесу пышағыны таңдаңыз',
    th: 'การเลือกมีดตัดแผ่นเดิม',
    ug: 'ئەسلى تاختا كېسىش پىچاق تاللاش',
    vi: 'Chọn dao cắt nguyên tấm',
    zh_tc: '原片下料刀選擇',
    ru: 'Выбор ножа для раскройки оригинала',
    ko: '원판 재료 칼 선택',
    bur: 'မူရင်းပေါ်ဒ်ဓားရွေးချယ်',
    ben: 'মূল তক্তার কাটার ছুরি নির্বাচন',
    tr: 'Ham levha kesim bıçağı seçimi',
    km: 'ជ្រើសរើសដារកាត់ផ្ទាំងដើម',
    es: 'Selección de cuchilla de corte original',
    ar: 'اختيار سكين القطع الأصلي',
  },
  'basePlankManager.plankKnifeSelectTip': {
    zh: '当板件命中多条规则时，板材厚度优先级大于板材材质',
    en: 'When a plate part hits multiple rules, the priority of plate thickness is higher than that of plate material.',
    id: 'Ketika suku panel memenuhi beberapa aturan, prioritas ketebalan lempeng lebih tinggi daripada jenis bahan lempeng',
    kz: 'Панель элементі бірнеше қауіптерге сейімленгенде, панельдің толығының ағымдылығы панель материалынан жоғары болады',
    th: 'เมื่อชิ้นผนังถูกขาดกฎหลาย條 ความลึกของผนังมีความสำคัญสูงกว่าสถาปัตยกรรมของผนัง',
    ug: 'پلاك تاشيقانچە قانۇنلارغا تۇغۇش كۈنچە، پلاكا تۇزۇلۇش تۇپلىقلىقى پلاكا مادىيلىقىدىن ئۈزۈك تارىخچىلىق قىلىدۇ',
    vi: 'Khi một bộ phận tấm gặp nhiều quy tắc, ưu tiên độ dày của tấm vượt trội hơn chất liệu của tấm.',
    zh_tc: '當板件命中多條規則時，板材厚度優先級大於板材材質',
    ru: 'Когда пластина попадает в несколько правил, приоритет толщины пластины больше, чем материал пластины',
    ko: '판재가 여러 규칙에 명중할 때, 판재의 두께 우선순위는 판재 재질보다 크다',
    bur: 'ပေါ်ဒ်အပိုင်းဥပဒေများတိုက်ဆိုင်သောအခါ ပေါ်ဒ်အထူဦးစားပိုကြီး',
    ben: 'বোর্ডের অংশ একাধিক নিয়মের সাথে মিললে, বোর্ডের পুরুত্বের অগ্রাধিকার উপকরণের চেয়ে বেশি',
    tr: 'Birden fazla kural eşleşince levha kalınlığı, malzemeden önceliklidir',
    km: 'នៅពេលត្រូវច្បាប់ច្រើន កម្រាស់ផ្ទាំងមានអាទិភាពខ្ពស់ជាងសម្ភារៈ',
    es: 'Cuando una placa cumple con varias reglas, el grosor de la placa tiene prioridad sobre el material de la placa',
    ar: 'عندما تصل اللوحة إلى قواعد متعددة، تكون لسمك اللوحة الأولوية فوق مادة اللوحة',
  },
  'basePlankManager.knifeSelectTip': {
    zh: '注： 内嵌排版暂不支持此功能',
    en: 'Attention: This feature is not supported for nested layout',
    id: 'Catatan: Fitur ini belum didukung dalam pengaturan huruf tertanam',
    kz: 'Ескерту: Ішкі қалыптасуда осы функция қолданылмайды',
    th: 'หมายเหตุ: คุณสมบัตินี้ยังไม่รองรับในการเรียงพิมพ์แบบฝังตัว',
    ug: 'ئەسكەرتىش: ئىچكى تەرتىپلەش بۇ ئىقتىدارنى قوللىمايدۇ',
    vi: 'Chú ý: Bố cục nhúng hiện tại không hỗ trợ chức năng này',
    zh_tc: '注： 內嵌排版暫不支持此功能',
    ru: 'Примечание: Встроенный набор временно не поддерживает эту функцию',
    ko: '참고: 인라인 레이아웃은 이 기능을 지원하지 않습니다.',
    bur: 'မှတ်ချက်: ထည့်ရောက်ပြင်ဆင်မှုသည်ဤလုပ်ဆောင်ချက်ကိုမထောက်ခံ',
    ben: 'নোট: এমবেডেড লেআউট এই ফিচার সমর্থন করে না',
    tr: 'Not: İç içe yerleşimde bu işlev desteklenmez',
    km: 'ចំណាំ៖ រៀបចំខាងក្នុងមិនគាំទ្រមុខងារនេះ',
    es: 'Nota: La composición tipográfica en línea actualmente no admite esta función',
    ar: 'ملاحظة: التنضيد المضمن لا يدعم حاليًا هذه الوظيفة',
  },
  'basePlankManager.knife': {
    zh: '下料刀具',
    en: 'Cutting Tool',
    id: 'Alat pemotongan',
    kz: 'Кесу пышағы',
    th: 'เครื่องมือตัด',
    ug: 'كېسىش پىچاقلىرى',
    vi: 'Dao cắt',
    zh_tc: '下料刀具',
    ru: 'Раскроющий нож',
    ko: '원단 공구',
    bur: 'ဖြတ်ဓား',
    ben: 'কাটার ছুরি',
    tr: 'Kesim takımı',
    km: 'ឧបករណ៍កាត់',
    es: 'Herramienta de corte',
    ar: 'أداة التقطيع',
  },
  'basePlankManager.matcodeInput': {
    zh: '请输入板材材质',
    en: 'Please enter the board material',
    id: 'Harap masukkan materi papan',
    kz: 'Кескістің матеріалын енгізіңіз',
    th: 'โปรดป้อนเนื้อหาของบอร์ด',
    ug: 'تاختا ماتېرىيالىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập chất liệu tấm',
    zh_tc: '請輸入板材材質',
    ru: 'Пожалуйста, введите материал.',
    ko: '판재 재료를 입력하세요',
    bur: 'ပေါ်ဒ်ပစ္စည်းရိုက်ထည့်ပါ',
    ben: 'বোর্ডের উপকরণ লিখুন',
    tr: 'Levha malzemesini girin',
    km: 'បញ្ចូលសម្ភារៈផ្ទាំង',
    es: 'Ingrese el material de la placa',
    ar: 'يرجى إدخال مادة اللوحة',
  },
  'basePlankManager.thickInput': {
    zh: '请输入板材厚度',
    en: 'Please enter the board thickness',
    id: 'Harap masukkan ketebalan papan',
    kz: 'Кескістің қалыңдығын енгізіңіз',
    th: 'โปรดป้อนความหนาของบอร์ด',
    ug: 'تاختا قېلىنلىقىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập độ dày tấm',
    zh_tc: '請輸入板材厚度',
    ru: 'Введите толщину листа.',
    ko: '판재 두께를 입력하세요',
    bur: 'ပေါ်ဒ်အထူရိုက်ထည့်ပါ',
    ben: 'বোর্ডের পুরুত্ব লিখুন',
    tr: 'Levha kalınlığını girin',
    km: 'បញ្ចូលកម្រាស់ផ្ទាំង',
    es: 'Ingrese el espesor de la placa',
    ar: 'يرجى إدخال سمك اللوحة',
  },
  'basePlankManager.default': {
    zh: '系统默认',
    en: 'System Default',
    id: 'Default Sistem',
    kz: 'Системаның әдеттісі',
    th: 'ค่าเริ่มต้นของระบบ',
    ug: 'سىستېما سۈكۈتى',
    vi: 'Mặc định hệ thống',
    zh_tc: '系統默認',
    ru: 'Система по умолчанию',
    ko: '시스템 기본',
    bur: 'စနစ်မူရင်း',
    ben: 'সিস্টেম ডিফল্ট',
    tr: 'Sistem varsayılanı',
    km: 'លំនាំប្រព័ន្ធ',
    es: 'Predeterminado del sistema',
    ar: 'النظام الافتراضي',
  },
  'basePlankManager.unessential': {
    zh: '此列为:非必填项',
    en: 'This column is optional',
    id: 'Kolom ini adalah: tidak diperlukan',
    kz: 'Бұл бағаны: міндетті емес',
    th: 'คอลัมน์นี้คือ: ไม่ต้องการ',
    ug: 'بۇ تىزىملىك: تولۇق كىرگۈزۈش شەرت ئەمەس',
    vi: 'Cột này: Không bắt buộc điền',
    zh_tc: '此列為:非必填項',
    ru: 'Это указано как: необязательное заполнение',
    ko: '이 열은 필수가 아닙니다.',
    bur: 'ဤကော်လံ: မဖြည့်ရမည်မဟုတ်',
    ben: 'এই কলামটি ঐচ্ছিক',
    tr: 'Bu sütun: zorunlu değil',
    km: 'ជួរនេះ៖ មិនចាំបាច់',
    es: 'Esta columna es: opcional',
    ar: 'هذا العمود: اختياري',
  },
  'basePlankManager.emptyTip': {
    zh: '注意：不填写此项时匹配原片时将不区分此项数据！',
    en: 'Attention: If this item is not filled in, it will not be distinguished when matching the original sheet!',
    id: 'Catatan: Jika Anda tidak mengisi item ini, Anda tidak akan membedakan item ini saat mencocokkan karya asli!',
    kz: 'Ескерту: Бұл бағаны толтырмау кезде оригиналды кескістің сәйкестігін бос қалдырылады!',
    th: 'หมายเหตุ: หากคุณไม่กรอกรายการนี้คุณจะไม่แยกความแตกต่างของรายการนี้เมื่อจับคู่ชิ้นส่วนต้นฉบับ!',
    ug: 'ئەسكەرتىش: بۇ جەدۋەلنى تولدۇرمىسىڭىز، ئەسلى تاختا ماسلىشىشتا بۇ تۈرگە پەرۋا قىلمايدۇ!',
    vi: 'Chú ý: Khi không điền vào cột này, khớp phù hợp nguyên tấm sẽ không phân biệt dữ liệu cột này!',
    zh_tc: '注意：不填寫此項時匹配原片時將不區分此項數據！',
    ru: 'Примечание: При совпадении оригинала без заполнения этого элемента эти данные не будут различаться!',
    ko: '참고: 이 항목을 입력하지 않을 때 원본과 일치할 때 이 데이터를 구분하지 않습니다!',
    bur: 'သတိ: ဤကော်လံမဖြည့်ပါကမူရင်းနှင့်တိုက်ဆိုင်ရာဤဒေတာကိုမခွဲမပြ!',
    ben: 'নোট: এই আইটেম পূরণ না করলে মূল শীট মিলের সময় এই ডেটা আলাদা করা হবে না!',
    tr: 'Not: Bu alan boşsa ham levha eşleştirmede bu veri dikkate alınmaz',
    km: 'ចំណាំ៖ បើមិនបំពេញ ពេលផ្គូផ្ទាំងដើមនឹងមិនបែងចែកទិន្នន័យនេះ',
    es: 'Nota: Si este elemento no se completa, estos datos no se distinguirán cuando coincidan con la pieza original.',
    ar: 'ملاحظة: إذا لم يتم ملء هذا العنصر، فلن يتم تمييز هذه البيانات عند مطابقة القطعة الأصلية!',
  },
  'basePlankManager.defaultUse': {
    zh: '默认选用',
    en: 'Default selection',
    id: 'Dipilih secara default',
    kz: 'Әдеттісімен таңдаңыз',
    th: 'เลือกโดยค่าเริ่มต้น',
    ug: 'سۈكۈتتىكى تاللاش',
    vi: 'Chọn mặc định',
    zh_tc: '默認選用',
    ru: 'Выбор по умолчанию',
    ko: '기본 선택',
    bur: 'မူရင်းရွေး',
    ben: 'ডিফল্ট নির্বাচন',
    tr: 'Varsayılan seçim',
    km: 'ជ្រើសលំនាំដើម',
    es: 'Seleccionar de forma predeterminada',
    ar: 'التحديد افتراضيًا',
  },
  'basePlankManager.editMatcode': {
    zh: '编辑材质',
    en: 'Edit Material',
    id: 'Edit materi',
    kz: 'Матеріалын өңдеу',
    th: 'แก้ไขวัสดุ',
    ug: 'ماتېرىيال تەھرىرلەش',
    vi: 'Chỉnh sửa chất liệu',
    zh_tc: '編輯材質',
    ru: 'Редактирование материалов',
    ko: '재료 편집',
    bur: 'ပစ္စည်းတည်းဖြတ်',
    ben: 'উপকরণ সম্পাদনা করুন',
    tr: 'Malzemeyi düzenle',
    km: 'កែសម្ភារៈ',
    es: 'Editar material',
    ar: 'تحرير المادة',
  },
  'basePlankManager.syncTip': {
    zh: '将获取{fromMc}中数据并覆盖现有云排版中原片管理数据，是否同步？',
    en: 'Will get data from {fromMc} and overwrite the original sheet management data in the existing cloud layout. Do you want to synchronize?',
    id: 'Data dalam {frommc} akan diperoleh dan menimpa data tata letak cloud zhongyuan yang ada. Apakah itu disinkronkan?',
    kz: '{fromMc} деректерін аліп, қазіргі болмашы кескістің басқару деректеріне ауыстырады, синхрондауды жоспарлануда мурайсыз ба?',
    th: 'ข้อมูลใน {frommc} จะได้รับและเขียนทับข้อมูลการจัดการชิ้นเมฆเมฆ zhongyuan ที่มีอยู่ มันซิงโครไนซ์หรือไม่?',
    ug: '{fromMc} دىكى سانلىق مەلۇماتنى ئېلىپ، بۇلۇت تەرتىپلەشتىكى ئەسلى تاختا باشقۇرۇش سانلىق مەلۇماتىنى ئۆزگەرتىدۇ، ماس قىلامسىز؟',
    vi: 'Sẽ lấy dữ liệu từ {fromMc} và ghi đè lên dữ liệu quản lý nguyên tấm của bố cục đám mây hiện có, có đồng bộ hóa không?',
    zh_tc: '將獲取{fromMc}中數據並覆蓋現有雲排版中原片管理數據，是否同步？',
    ru: 'Будет получены данные из {fromMc} и заменены данными управления исходными листами в существующем облачном макете. Синхронизировать?',
    ko: '{fromMc}에서 데이터를 가져와 기존 클라우드 레이아웃의 원본 관리 데이터를 덮어쓰고 동기화할까요?',
    bur: '{fromMc}ဒေတာယူ၍ ယာယီဆာဗာပြင်ဆင်မှုမူရင်းပေါ်ဒ်စီမံဒေတာကိုအစားထိုးမည်၊ ချိတ်ဆက်မည်လား?',
    ben: '{fromMc} থেকে ডেটা নিয়ে বিদ্যমান ক্লাউড লেআউটের মূল শীট ম্যানেজমেন্ট ডেটা ওভাররাইট করবে, সিঙ্ক্রোনাইজ করবেন?',
    tr: '{fromMc} verileri alınacak ve mevcut bulut yerleşimindeki ham levha yönetimi verilerinin üzerine yazılacak. Eşitlensin mi?',
    km: 'នឹងយកទិន្នន័យពី {fromMc} និងសរសេរជាន់លើទិន្នន័យគ្រប់គ្រងផ្ទាំងដើមនៅក្នុងរៀបចំពពក សមកាលឬទេ?',
    es: 'Los datos en {fromMc} se adquirirán y sobrescribirán con los datos de gestión de la película originales en el diseño de nube existente. ¿Está sincronizado?',
    ar: 'سيتم الحصول على البيانات الموجودة في {fromMc} واستبدالها ببيانات إدارة الفيلم الأصلية في التخطيط السحابي الحالي. هل هو متزامن؟',
  },
  'basePlankManager.sameErr': {
    zh: '已存在相同的数据',
    en: 'The same data already exists',
    id: 'Data yang sama sudah ada',
    kz: 'Бұл деректердің оқшаш деректері бар',
    th: 'มีข้อมูลเดียวกันอยู่แล้ว',
    ug: 'ئوخشاش سانلىق مەلۇمات مەۋجۇت',
    vi: 'Dữ liệu tương tự đã tồn tại',
    zh_tc: '已存在相同的數據',
    ru: 'Такие же данные уже существуют.',
    ko: '동일한 데이터가 이미 있음',
    bur: 'တူညီသောဒေတာရှိပြီး',
    ben: 'একই ডেটা ইতিমধ্যে বিদ্যমান',
    tr: 'Aynı veri zaten var',
    km: 'មានទិន្នន័យដូចគ្នារួចហើយ',
    es: 'Los mismos datos ya existen',
    ar: 'نفس البيانات موجودة بالفعل',
  },
  'basePlankManager.cancelDelete': {
    zh: '已取消删除',
    en: 'Deletion canceled',
    id: 'Undelete',
    kz: 'Жоюді тоқтатты',
    th: 'ลบล้าง',
    ug: 'ئۆچۈرۈشتىن ۋاز كەچتى',
    vi: 'Đã hủy xóa',
    zh_tc: '已取消刪除',
    ru: 'Отменено Удалено',
    ko: '삭제 취소됨',
    bur: 'ဖျက်ဆီးမှုဖျက်သိမ်း',
    ben: 'মুছে ফেলা বাতিল করা হয়েছে',
    tr: 'Silme iptal edildi',
    km: 'បានលុបការលុប',
    es: 'La eliminación se canceló',
    ar: 'تم إلغاء الحذف',
  },
  'basePlankManager.syncErr': {
    zh: '同步失败',
    en: 'Synchronization failed',
    id: 'Sinkronisasi gagal',
    kz: 'Синхрондау сәтсіз',
    th: 'การซิงโครไนซ์ล้มเหลว',
    ug: 'ماس قىلىش مەغلۇپ بولدى',
    vi: 'Đồng bộ hóa thất bại',
    zh_tc: '同步失敗',
    ru: 'Ошибка синхронизации',
    ko: '동기화 실패',
    bur: 'ချိတ်ဆက်မမှုမအောင်မြင်',
    ben: 'সিঙ্ক্রোনাইজেশন ব্যর্থ হয়েছে',
    tr: 'Eşitleme başarısız',
    km: 'សមកាលកម្មបរាជ័យ',
    es: 'Sincronización fallida',
    ar: 'فشل المزامنة',
  },
  'basePlankManager.syncSuccess': {
    zh: '同步成功',
    en: 'Synchronization successful',
    id: 'Sinkronisasi berhasil',
    kz: 'Синхрондау сәтті',
    th: 'การซิงโครไนซ์ประสบความสำเร็จ',
    ug: 'ماس قىلىش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Đồng bộ hóa thành công',
    zh_tc: '同步成功',
    ru: 'Синхронизация завершена',
    ko: '동기화 성공',
    bur: 'ချိတ်ဆက်မှုအောင်မြင်',
    ben: 'সিঙ্ক্রোনাইজেশন সফল হয়েছে',
    tr: 'Eşitleme başarılı',
    km: 'សមកាលកម្មជោគជ័យ',
    es: 'Sincronización exitosa',
    ar: 'المزامنة ناجحة',
  },
  'basePlankManager.syncDataTip': {
    zh: '同步{fromMc}数据',
    en: 'Synchronize ${fromMc} data',
    id: 'Menyinkronkan data {frommc}',
    kz: '${fromMc} деректерін синхрондау',
    th: 'ซิงโครไนซ์ {frommc} ข้อมูล',
    ug: '{fromMc} سانلىق مەلۇماتىنى ماس قىلىش',
    vi: 'Đồng bộ hóa dữ liệu từ ${fromMc}',
    zh_tc: '同步{fromMc}數據',
    ru: 'Синхронизация данных {fromMc}',
    ko: '{fromMc} 데이터 동기화',
    bur: '{fromMc}ဒေတာချိတ်ဆက်',
    ben: '{fromMc} ডেটা সিঙ্ক্রোনাইজ করুন',
    tr: '{fromMc} verilerini eşitle',
    km: 'សមកាលកម្មទិន្នន័យ {fromMc}',
    es: 'Sincronizar {fromMc} datos',
    ar: 'مزامنة {fromMc} البيانات',
  },
  'basePlankManager.editErrTip': {
    zh: '存在未填写的信息, 请核对!',
    en: 'There are unfilled information, please check!',
    id: 'Ada informasi yang tidak terisi, silakan periksa!',
    kz: 'Толтырмау деректер бар, тексеріңіз!',
    th: 'มีข้อมูลที่ไม่สำเร็จโปรดตรวจสอบ!',
    ug: 'تولدۇرۇلمىغان ئۇچۇر بار، تەكشۈرۈڭ!',
    vi: 'Có thông tin chưa điền, vui lòng kiểm tra!',
    zh_tc: '存在未填寫的信息, 請核對!',
    ru: 'Наличие незаполненной информации, пожалуйста, проверьте!',
    ko: '기입하지 않은 정보가 존재하니 확인하세요!',
    bur: 'မဖြည့်ရသေးသောသတင်းရှိ၊ စစ်ဆေးပါ!',
    ben: 'পূরণ না করা তথ্য আছে, পরীক্ষা করুন!',
    tr: 'Doldurulmamış bilgiler var, kontrol edin!',
    km: 'មានព័ត៌មានមិនទាន់បំពេញ សូមពិនិត្យ!',
    es: 'Hay información sin completar, ¡verifíquela!',
    ar: 'هناك معلومات غير مملوءة، يرجى التحقق!',
  },
  'basePlankManager.numberCheck': {
    zh: '{type}只能输入数字!',
    en: '{type} can only input numbers!',
    id: '{type} hanya bisa memasukkan angka!',
    kz: '{type} тек сан кіргізілуі тиіс!',
    th: '{type} สามารถป้อนหมายเลขเท่านั้น!',
    ug: '{type} پەقەت رەقەم كىرگۈزۈشكە بولىدۇ!',
    vi: '{type} chỉ được nhập số!',
    zh_tc: '{type}只能輸入數字!',
    ru: '{type} может содержать только цифры!',
    ko: '{type}는 숫자만 입력할 수 있습니다!',
    bur: '{type}တွင်ကိန်းဂဏန်းသာထည့်နိုင်!',
    ben: '{type} শুধুমাত্র সংখ্যা লেখা যাবে!',
    tr: '{type} yalnızca sayı girilebilir',
    km: '{type} បញ្ចូលបានតែលេខ',
    es: '{type} ¡Solo se pueden ingresar números!',
    ar: '{type} يمكن إدخال الأرقام فقط!',
  },
  'basePlankManager.deleteStandardPlate': {
    zh: '删除标准板材',
    en: 'Removal of standard plate',
    id: 'Hapus papan standar',
    kz: 'Стандартты тақтаны жояды',
    th: 'ลบบอร์ดมาตรฐาน',
    ug: 'ئۆلچەملىك تاختا ئۆچۈرۈش',
    vi: 'Loại bỏ các tấm tiêu chuẩn',
    zh_tc: '刪除標準板材',
    ru: 'Удалить стандартный лист',
    ko: '표준 판재 삭제',
    bur: 'မမာတ်ပေါ်ဒ်ဖျက်',
    ben: 'মানক বোর্ড মুছুন',
    tr: 'Standart levha kaldır',
    km: 'ដកផ្ទាំងស្តង់ដារ',
    es: 'Eliminar placa estándar',
    ar: 'حذف اللوحة القياسية',
  },
  'basePlankManager.createStandardPlate': {
    zh: '新建标准板材',
    en: 'New standard board',
    id: 'Papan Standar Baru',
    kz: 'Жаңа стандартты тақтайшалар',
    th: 'บอร์ดมาตรฐานใหม่',
    ug: 'ئۆلچەملىك تاختا قۇرۇش',
    vi: 'Bảng tiêu chuẩn mới',
    zh_tc: '新建標準板材',
    ru: 'Новые стандартные листы',
    ko: '새 표준 판재',
    bur: 'မမာတ်ပေါ်ဒ်အသစ်ဆောက်',
    ben: 'নতুন মানক বোর্ড',
    tr: 'Yeni standart levha',
    km: 'ផ្ទាំងស្តង់ដារថ្មី',
    es: 'Crear nueva placa estándar',
    ar: 'إنشاء لوحة قياسية جديدة',
  },
  'basePlankManager.editStandardPlate': {
    zh: '编辑标准板材',
    en: 'Edit Standard Plate',
    id: 'Edit papan standar',
    kz: 'Стандартты тақтаны өңдеу',
    th: 'แก้ไขบอร์ดมาตรฐาน',
    ug: 'ئۆلچەملىك تاختا تەھرىرلەش',
    vi: 'Chỉnh sửa bảng tiêu chuẩn',
    zh_tc: '編輯標準板材',
    ru: 'Редактирование стандартных панелей',
    ko: '표준 판재 편집',
    bur: 'မမာတ်ပေါ်ဒ်တည်းဖြတ်',
    ben: 'মানক বোর্ড সম্পাদনা করুন',
    tr: 'Standart levhayı düzenle',
    km: 'កែផ្ទាំងស្តង់ដារ',
    es: 'Editar placa estándar',
    ar: 'تحرير اللوحة القياسية',
  },
  'basePlankManager.trimmingDimension': {
    zh: '修边尺寸',
    en: 'Trimming Dimension',
    id: 'Ukuran trim',
    kz: 'Жиегін кесу өлшемі',
    th: 'ขนาดตัดแต่ง',
    ug: 'چېگرا كېسىش ئۆلچىمى',
    vi: 'Kích thước cắt bớt',
    zh_tc: '修邊尺寸',
    ru: 'Размер обрезки',
    ko: '모서리 치수 고치기',
    bur: 'ဘောင်ဖြတ်အတိုင်းအတာ',
    ben: 'ট্রিমিং আকার',
    tr: 'Kenar düzeltme boyutu',
    km: 'ទំហំកាត់គែម',
    es: 'Tamaño de recorte',
    ar: 'حجم التشذيب',
  },
  'basePlankManager.front': {
    zh: '上',
    en: 'Top',
    id: 'Atas',
    kz: 'жоғары ',
    th: 'ด้านบน',
    ug: 'ئۈستى',
    vi: 'trước ',
    zh_tc: '上',
    ru: 'вверх',
    ko: '상',
    bur: 'အပေါ်',
    ben: 'উপরে',
    tr: 'Üst',
    km: 'លើ',
    es: 'Anterior',
    ar: 'السابق',
  },
  'basePlankManager.back': {
    zh: '下',
    en: 'Bottom ',
    id: 'Bawah',
    kz: 'төмен ',
    th: 'ด้านล่าง',
    ug: 'ئاستى',
    vi: 'trên ',
    zh_tc: '下',
    ru: 'вниз',
    ko: '아래',
    bur: 'အောက်',
    ben: 'নিচে',
    tr: 'Alt',
    km: 'ក្រោម',
    es: 'Siguiente',
    ar: 'التالي',
  },
  'basePlankManager.left': {
    zh: '左',
    en: 'Left ',
    id: 'Kiri',
    kz: 'сол ',
    th: 'ด้านซ้าย',
    ug: 'سول',
    vi: 'trái ',
    zh_tc: '左',
    ru: 'левый',
    ko: '왼쪽',
    bur: 'ဘယ်',
    ben: 'বাম',
    tr: 'Sol',
    km: 'ឆ្វេង',
    es: 'Izquierda',
    ar: 'اليسار',
  },
  'basePlankManager.right': {
    zh: '右',
    en: 'Right ',
    id: 'Kanan',
    kz: 'оң ',
    th: 'ด้านขวา',
    ug: 'ئوڭ',
    vi: 'phải ',
    zh_tc: '右',
    ru: 'право',
    ko: '오른쪽',
    bur: 'ညာ',
    ben: 'ডান',
    tr: 'Sağ',
    km: 'ស្តាំ',
    es: 'Derecha',
    ar: 'اليمين',
  },
  'basePlankManager.frontTrim': {
    zh: '上修边',
    en: 'Top Trimming',
    id: 'Atas pemotongan',
    kz: 'жоғары өңдеу',
    th: 'ด้านบนตัดแต่ง',
    ug: 'ئۈستى چېگرا كېسىش',
    vi: 'sửa bờ trước',
    zh_tc: '上修邊',
    ru: 'Верхняя обрезка',
    ko: '가장자리를 고치다',
    bur: 'အပေါ်ဘောင်ဖြတ်',
    ben: 'উপরের ট্রিমিং',
    tr: 'Üst kenar düzeltme',
    km: 'កាត់គែមលើ',
    es: 'Recorte superior',
    ar: 'التشذيب العلوي',
  },
  'basePlankManager.backTrim': {
    zh: '下修边',
    en: 'Bottom Trimming',
    id: 'Bawah pemotongan',
    kz: 'төмен өңдеу',
    th: 'ด้านล่างตัดแต่ง',
    ug: 'ئاستى چېگرا كېسىش',
    vi: 'sửa bờ trên',
    zh_tc: '下修邊',
    ru: 'Нижняя обрезка',
    ko: '테두리를 깎다',
    bur: 'အောက်ဘောင်ဖြတ်',
    ben: 'নিচের ট্রিমিং',
    tr: 'Alt kenar düzeltme',
    km: 'កាត់គែមក្រោម',
    es: 'Recorte inferior',
    ar: 'التشذيب السفلي',
  },
  'basePlankManager.leftTrim': {
    zh: '左修边',
    en: 'Left Trimming',
    id: 'Kiri pemotongan',
    kz: 'сол жақ өңдеу',
    th: 'ด้านซ้ายตัดแต่ง',
    ug: 'سول چېگرا كېسىش',
    vi: 'sửa bờ trái',
    zh_tc: '左修邊',
    ru: 'Левый сюйбянь',
    ko: '왼쪽 모서리',
    bur: 'ဘယ်ဘောင်ဖြတ်',
    ben: 'বাম ট্রিমিং',
    tr: 'Sol kenar düzeltme',
    km: 'កាត់គែមឆ្វេង',
    es: 'Recorte izquierdo',
    ar: 'التشذيب الأيسر',
  },
  'basePlankManager.rightTrim': {
    zh: '右修边',
    en: 'Right Trimming',
    id: 'Kanan pemotongan',
    kz: 'оң жақ өңдеу',
    th: 'ด้านขวาตัดแต่ง',
    ug: 'ئوڭ چېگرا كېسىش',
    vi: 'sửa bờ phải',
    zh_tc: '右修邊',
    ru: 'Правая обрезка',
    ko: '오른쪽 가장자리',
    bur: 'ညာဘောင်ဖြတ်',
    ben: 'ডান ট্রিমিং',
    tr: 'Sağ kenar düzeltme',
    km: 'កាត់គែមស្តាំ',
    es: 'Recorte derecho',
    ar: 'التشذيب الأيمن',
  },
  'basePlankManager.customTrim': {
    zh: '自定义修边值',
    en: 'Custom Trimming Value',
    id: 'Nilai pemotongan khusus',
    kz: 'өңдеу мәні таңдауыңызша',
    th: 'ค่าตัดแต่งที่กำหนดเอง',
    ug: 'ئىختىيارى چېگرا كېسىش قىممىتى',
    vi: 'Giá trị sửa bờ tùy chỉnh',
    zh_tc: '自定義修邊值',
    ru: 'Изменить значение кромки',
    ko: '모서리 수정 값 사용자 정의',
    bur: 'စိတ်ကြိုက်ဘောင်ဖြတ်တန်ဖိုး',
    ben: 'কাস্টম ট্রিমিং মান',
    tr: 'Özel kenar düzeltme değeri',
    km: 'តម្លៃកាត់គែមតម្លាប់ខ្លួនឯង',
    es: 'El valor de recorte personalizado',
    ar: 'قيمة التشذيب المخصصة',
  },
  'basePlankManager.trimValue': {
    zh: '修边值',
    en: 'Trim',
    id: 'Nilai pemotongan',
    kz: 'өңдеу мәні',
    th: 'ค่าตัดแต่ง',
    ug: 'چېگرا كېسىش قىممىتى',
    vi: 'Giá trị sửa bờ',
    zh_tc: '修邊值',
    ru: 'значение обрезки',
    ko: '모서리 값 수정하기',
    bur: 'ဘောင်ဖြတ်တန်ဖိုး',
    ben: 'ট্রিমিং মান',
    tr: 'Kenar düzeltme değeri',
    km: 'តម្លៃកាត់គែម',
    es: 'Valor de corte',
    ar: 'قيمة القطع',
  },
  'basePlankManager.notEmpty': {
    zh: '{type}不能为空!',
    en: '{type} cannot be empty!',
    id: '{type} tidak boleh kosong!',
    kz: '{type} бос болуы мүмкін емес!',
    th: '{type} ไม่สามารถว่างได้!',
    ug: '{type} بوش قالمايدۇ!',
    vi: '{type} không được để trống!',
    zh_tc: '{type}不能為空!',
    ru: '{type} не может быть пустым!',
    ko: '{type}는 비어 있을 수 없습니다!',
    bur: '{type}မဟာမဆ!',
    ben: '{type} খালি রাখা যাবে না!',
    tr: '{type} boş olamaz',
    km: '{type} មិនអាចទទេ',
    es: '{type} no puede estar vacío.',
    ar: '{type} لا يمكن أن يكون فارغًا!',
  },
  'basePlankManager.edgeDir': {
    zh: '修边({type})',
    en: 'Trimming ({type})',
    id: 'Pemotongan ({type})',
    kz: 'өңдеу ({type})',
    th: 'ตัดแต่ง ({type})',
    ug: 'چېگرا كېسىش ({type})',
    vi: 'sửa bờ ({type})',
    zh_tc: '修邊({type})',
    ru: 'Обрезка ({type})',
    ko: '모서리 수정 ({type})',
    bur: 'ဘောင်ဖြတ်({type})',
    ben: 'ট্রিমিং ({type})',
    tr: 'Kenar düzeltme ({type})',
    km: 'កាត់គែម ({type})',
    es: 'Recorte ({type})',
    ar: 'التشذيب ({type})',
  },
  'basePlankManager.brandPlank': {
    zh: '品牌大板',
    en: 'Brand Sheet',
    id: 'Papan Merek',
    kz: 'Бренд тақтасы',
    th: 'แผ่นแบรนด์',
    ug: 'ماركا تاختىسى',
    vi: 'Tấm thương hiệu',
    zh_tc: '品牌大板',
    ru: 'Фирменный лист',
    ko: '브랜드 대판',
    bur: 'အမှတ်တံဆိပ်ပေါ်ဒ်',
    ben: 'ব্র্যান্ড বোর্ড',
    tr: 'Marka Levha',
    km: 'ផ្ទាំងម៉ាក',
    es: 'Placa de marca',
    ar: 'لوحة العلامة التجارية',
  },
  'basePlankManager.brandPlankTip': {
    zh: '注：品牌大板删除与修改在柜柜客户端板材资源库进行操作',
    en: 'Note: Deletion and modification of brand sheets are performed in the Cabinet client board resource library',
    id: 'Catatan: Penghapusan dan modifikasi papan merek dilakukan di pustaka sumber daya papan klien Cabinet',
    kz: 'Ескерту: Бренд тақталарын жою және өзгерту Cabinet клиентінің тақта ресурс кітапханасында орындалады',
    th: 'หมายเหตุ: การลบและการแก้ไขแผ่นแบรนด์ดำเนินการในคลังทรัพยากรแผ่นบอร์ดของไคลเอนต์ Cabinet',
    ug: 'ئەسكەرتىش: ماركا تاختىسىنى ئۆچۈرۈش ۋە ئۆزگەرتىش Cabinet خېرىدار تاختا بايلىق ئامبىرىدا ئېلىپ بېرىلىدۇ',
    vi: 'Chú ý: Việc xóa và chỉnh sửa tấm thương hiệu được thực hiện trong thư viện tài nguyên tấm của ứng dụng Cabinet',
    zh_tc: '注：品牌大板刪除與修改在櫃櫃客戶端板材資源庫進行操作',
    ru: 'Примечание: Удаление и изменение фирменных листов выполняется в библиотеке ресурсов плит клиента Cabinet',
    ko: '참고: 브랜드 대판의 삭제 및 수정은 Cabinet 클라이언트 보드 리소스 라이브러리에서 진행됩니다',
    bur: 'မှတ်ချက်: အမှတ်တံဆိပ်ပေါ်ဒ်ဖျက်ခြင်းနှင့်ပြင်ဆင်ခြင်းကို Cabinet client ပေါ်ဒ်အရင်းအမြစ်စာကြည့်တိုက်တွင်ဆောင်ရွက်သည်',
    ben: 'নোট: ব্র্যান্ড বোর্ডের মুছে ফেলা ও পরিবর্তন Cabinet ক্লায়েন্ট বোর্ড রিসোর্স লাইব্রেরিতে সম্পন্ন হয়',
    tr: 'Not: Marka levhalarin silinmesi ve degistirilmesi Cabinet istemci panel kaynak kutuphanesinde yapilir',
    km: 'ចំណាំ: ការលុបនិងការកែប្រែផ្ទាំងម៉ាកត្រូវបានធ្វើនៅក្នុងបណ្ណាល័យធនធានផ្ទាំងរបស់កម្មវិធី Cabinet',
    es: 'Nota: La eliminación y modificación de placas de marca se realizan en la biblioteca de recursos de placas del cliente Cabinet',
    ar: 'ملاحظة: يتم حذف وتعديل ألواح العلامة التجارية في مكتبة موارد ألواح عميل Cabinet',
  },
  'basePlankManager.brand': {
    zh: '品牌',
    en: 'Brand',
    id: 'Merek',
    kz: 'Бренд',
    th: 'แบรนด์',
    ug: 'ماركا',
    vi: 'Thương hiệu',
    zh_tc: '品牌',
    ru: 'Бренд',
    ko: '브랜드',
    bur: 'အမှတ်တံဆိပ်',
    ben: 'ব্র্যান্ড',
    tr: 'Marka',
    km: 'ម៉ាក',
    es: 'Marca',
    ar: 'العلامة التجارية',
  },
  'basePlankManager.supplier': {
    zh: '供应商',
    en: 'Supplier',
    id: 'Pemasok',
    kz: 'Жеткізуші',
    th: 'ซัพพลายเออร์',
    ug: 'تەمىنلىگۈچى',
    vi: 'Nhà cung cấp',
    zh_tc: '供應商',
    ru: 'Поставщик',
    ko: '공급업체',
    bur: 'ထောက်ပံ့သူ',
    ben: 'সরবরাহকারী',
    tr: 'Tedarikçi',
    km: 'អ្នកផ្គត់ផ្គង់',
    es: 'Proveedor',
    ar: 'المورد',
  },
  'basePlankManager.brandPlaceholder': {
    zh: '请选择品牌',
    en: 'Please select brand',
    id: 'Silakan pilih merek',
    kz: 'Бренд таңдаңыз',
    th: 'กรุณาเลือกแบรนด์',
    ug: 'ماركا تاللاڭ',
    vi: 'Vui lòng chọn thương hiệu',
    zh_tc: '請選擇品牌',
    ru: 'Выберите бренд',
    ko: '브랜드를 선택하세요',
    bur: 'အမှတ်တံဆိပ်ရွေးပါ',
    ben: 'ব্র্যান্ড নির্বাচন করুন',
    tr: 'Marka seçin',
    km: 'សូមជ្រើសម៉ាក',
    es: 'Seleccione marca',
    ar: 'يرجى اختيار العلامة التجارية',
  },
  'basePlankManager.supplierPlaceholder': {
    zh: '请选择供应商',
    en: 'Please select supplier',
    id: 'Silakan pilih pemasok',
    kz: 'Жеткізуші таңдаңыз',
    th: 'กรุณาเลือกซัพพลายเออร์',
    ug: 'تەمىنلىگۈچى تاللاڭ',
    vi: 'Vui lòng chọn nhà cung cấp',
    zh_tc: '請選擇供應商',
    ru: 'Выберите поставщика',
    ko: '공급업체를 선택하세요',
    bur: 'ထောက်ပံ့သူရွေးပါ',
    ben: 'সরবরাহকারী নির্বাচন করুন',
    tr: 'Tedarikçi seçin',
    km: 'សូមជ្រើសអ្នកផ្គត់ផ្គង់',
    es: 'Seleccione proveedor',
    ar: 'يرجى اختيار المورد',
  },
  'basePlankManager.brandInput': {
    zh: '请输入品牌',
    en: 'Please input brand',
    id: 'Silakan masukkan merek',
    kz: 'Бренд енгізіңіз',
    th: 'กรุณากรอกแบรนด์',
    ug: 'ماركا كىرگۈزۈڭ',
    vi: 'Vui lòng nhập thương hiệu',
    zh_tc: '請輸入品牌',
    ru: 'Введите бренд',
    ko: '브랜드를 입력하세요',
    bur: 'အမှတ်တံဆိပ်ထည့်ပါ',
    ben: 'ব্র্যান্ড লিখুন',
    tr: 'Marka girin',
    km: 'សូមបញ្ចូលម៉ាក',
    es: 'Ingrese marca',
    ar: 'يرجى إدخال العلامة التجارية',
  },
  'basePlankManager.supplierInput': {
    zh: '请输入供应商',
    en: 'Please input supplier',
    id: 'Silakan masukkan pemasok',
    kz: 'Жеткізуші енгізіңіз',
    th: 'กรุณากรอกซัพพลายเออร์',
    ug: 'تەمىنلىگۈچى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập nhà cung cấp',
    zh_tc: '請輸入供應商',
    ru: 'Введите поставщика',
    ko: '공급업체를 입력하세요',
    bur: 'ထောက်ပံ့သူထည့်ပါ',
    ben: 'সরবরাহকারী লিখুন',
    tr: 'Tedarikçi girin',
    km: 'សូមបញ្ចូលអ្នកផ្គត់ផ្គង់',
    es: 'Ingrese proveedor',
    ar: 'يرجى إدخال المورد',
  },
  'basePlankManager.addBrandPlank': {
    zh: '新建品牌板材',
    en: 'Add Brand Sheet',
    id: 'Tambah Papan Merek',
    kz: 'Бренд тақтасын қосу',
    th: 'เพิ่มแผ่นแบรนด์',
    ug: 'ماركا تاختىسى قوشۇش',
    vi: 'Thêm tấm thương hiệu',
    zh_tc: '新建品牌板材',
    ru: 'Добавить фирменный лист',
    ko: '브랜드 대판 추가',
    bur: 'အမှတ်တံဆိပ်ပေါ်ဒ်ထည့်ပါ',
    ben: 'ব্র্যান্ড বোর্ড যোগ করুন',
    tr: 'Marka levha ekle',
    km: 'បន្ថែមផ្ទាំងម៉ាក',
    es: 'Agregar placa de marca',
    ar: 'إضافة لوحة العلامة التجارية',
  },
  'basePlankManager.deleteBrandPlank': {
    zh: '删除品牌大板',
    en: 'Delete Brand Sheet',
    id: 'Hapus Papan Merek',
    kz: 'Бренд тақтасын жою',
    th: 'ลบแผ่นแบรนด์',
    ug: 'ماركا تاختىسىنى ئۆچۈرۈش',
    vi: 'Xóa tấm thương hiệu',
    zh_tc: '刪除品牌大板',
    ru: 'Удалить фирменный лист',
    ko: '브랜드 대판 삭제',
    bur: 'အမှတ်တံဆိပ်ပေါ်ဒ်ဖျက်ပါ',
    ben: 'ব্র্যান্ড বোর্ড মুছুন',
    tr: 'Marka levha sil',
    km: 'លុបផ្ទាំងម៉ាក',
    es: 'Eliminar placa de marca',
    ar: 'حذف لوحة العلامة التجارية',
  },
  'basePlankManager.editBrandPlank': {
    zh: '编辑品牌板材',
    en: 'Edit Brand Sheet',
    id: 'Edit Papan Merek',
    kz: 'Бренд тақтасын өңдеу',
    th: 'แก้ไขแผ่นแบรนด์',
    ug: 'ماركا تاختىسىنى تەھرىرلەش',
    vi: 'Sửa tấm thương hiệu',
    zh_tc: '編輯品牌板材',
    ru: 'Редактировать фирменный лист',
    ko: '브랜드 대판 편집',
    bur: 'အမှတ်တံဆိပ်ပေါ်ဒ်ပြင်ပါ',
    ben: 'ব্র্যান্ড বোর্ড সম্পাদনা করুন',
    tr: 'Marka levha düzenle',
    km: 'កែសម្រួលផ្ទាំងម៉ាក',
    es: 'Editar placa de marca',
    ar: 'تحرير لوحة العلامة التجارية',
  },
  'basePlankManager.searchBrandPlaceholder': {
    zh: '搜索品牌/供应商/板材材质/颜色',
    en: 'Search brand/supplier/material/color',
    id: 'Cari merek/pemasok/material/warna',
    kz: 'Бренд/жеткізуші/материал/түс іздеу',
    th: 'ค้นหาแบรนด์/ซัพพลายเออร์/วัสดุ/สี',
    ug: 'ماركا/تەمىنلىگۈچى/ماتېرىيال/رەڭ ئىزدەش',
    vi: 'Tìm thương hiệu/nhà cung cấp/chất liệu/màu sắc',
    zh_tc: '搜索品牌/供應商/板材材質/顏色',
    ru: 'Поиск бренда/поставщика/материала/цвета',
    ko: '브랜드/공급업체/재질/색상 검색',
    bur: 'အမှတ်တံဆိပ်/ထောက်ပံ့သူ/ပစ္စည်း/အရောင် ရှာဖွေပါ',
    ben: 'ব্র্যান্ড/সরবরাহকারী/উপাদান/রঙ খুঁজুন',
    tr: 'Marka/tedarikçi/malzeme/renk ara',
    km: 'ស្វែងរកម៉ាក/អ្នកផ្គត់ផ្គង់/វត្ថុធាតុ/ពណ៌',
    es: 'Buscar marca/proveedor/material/color',
    ar: 'البحث عن العلامة التجارية/المورد/المادة/اللون',
  },
  'bujianAndStore.bujianStore': {
    zh: '补件仓库',
    en: 'Bujian Warehouse',
    id: 'Gudang Pengisian',
    kz: 'Қосалқы бөлшектер қоймасы',
    th: 'คลังสินค้าที่เติมเต็ม',
    ug: 'قوشۇمچە بۆلەك ئامبىرى',
    vi: 'Kho bổ sung',
    zh_tc: '補件倉庫',
    ru: 'Запасной склад',
    ko: '보충 창고',
    bur: 'ဖြည့်ဆည်းဂိုဒေါင်',
    ben: 'পরিপূরক গুদাম',
    tr: 'Bujian deposu',
    km: 'ឃ្លាំង Bujian',
    es: 'Almacén de piezas de reposición',
    ar: 'مستودع قطع الغيار',
  },
  'bujianAndStore.awaitStore': {
    zh: '板件待排版库',
    en: 'Plank Awaiting Layout Warehouse',
    id: 'Papan untuk diketik perpustakaan',
    kz: 'Тақтайларды орналастыруды күту қоймасы',
    th: 'บอร์ดที่จะพิมพ์ไลบรารี',
    ug: 'تەرتىپلەشكە ساقلىنىدىغان تاختا بۆلەك ئامبىرى',
    vi: 'Kho chờ xếp ván',
    zh_tc: '板件待排版庫',
    ru: 'Библиотека печатных материалов',
    ko: '릴리즈 준비 라이브러리',
    bur: 'ပေါ်ဒ်ပြင်ဆင်စောင့်ဆိုင်း',
    ben: 'বোর্ড লেআউট অপেক্ষার গুদাম',
    tr: 'Yerleşim bekleyen levha deposu',
    km: 'ឃ្លាំងផ្ទាំងរង់ចាំរៀបចំ',
    es: 'Biblioteca de diseño de paneles',
    ar: 'مكتبة تخطيط اللوحة',
  },
  'bujianAndStore.depositAwaitStore': {
    zh: '存入待排版库',
    en: 'Deposit into Awaiting Layout Warehouse',
    id: 'Simpan di perpustakaan yang to-type',
    kz: 'Орналастыруды күту қоймасына сақтау',
    th: 'บันทึกไว้ในห้องสมุดประเภท TO-TYPE',
    ug: 'ساقلىنىدىغان تەرتىپلەش ئامبىرىغا ساقلاش',
    vi: 'Lưu vào kho chờ xếp ván',
    zh_tc: '存入待排版庫',
    ru: 'Хранить в библиотеке',
    ko: '예약된 라이브러리에 저장',
    bur: 'ပြင်ဆင်စောင့်ဆိုင်းဂိုဒေါင်ထည့်',
    ben: 'লেআউট অপেক্ষার গুদামে জমা দিন',
    tr: 'Yerleşim bekleyen depoya kaydet',
    km: 'រក្សាទៅឃ្លាំងរង់ចាំរៀបចំ',
    es: 'Guardar en la biblioteca para componer',
    ar: 'احفظها في المكتبة ليتم تنضيدها',
  },
  'bujianAndStore.pushToAwaitStore': {
    zh: '放入待排版库',
    en: 'Push to Awaiting Layout Warehouse',
    id: 'Masukkan ke dalam perpustakaan untuk diketik',
    kz: 'Орналастыруды күту қоймасына салу',
    th: 'ใส่ไว้ในห้องสมุดที่จะพิมพ์',
    ug: 'ساقلىنىدىغان تەرتىپلەش ئامبىرىغا قويۇش',
    vi: 'Đưa vào kho chờ xếp ván',
    zh_tc: '放入待排版庫',
    ru: 'Поместить в библиотеку',
    ko: '예약된 라이브러리에 넣기',
    bur: 'ပြင်ဆင်စောင့်ဆိုင်းဂိုဒေါင်ထဲထည့်',
    ben: 'লেআউট অপেক্ষার গুদামে রাখুন',
    tr: 'Yerleşim bekleyen depoya koy',
    km: 'ដាក់ទៅឃ្លាំងរង់ចាំរៀបចំ',
    es: 'Colóquelo en la biblioteca para componer',
    ar: 'ضعه في المكتبة ليتم التنضيد',
  },
  'bujianAndStore.useTwoTableArrange': {
    zh: '使用两个表单排版',
    en: 'Use Two Tables for Layout',
    id: 'Gunakan dua bentuk untuk mengetik',
    kz: 'Екі кестені пайдаланып орналастыру',
    th: 'ใช้สองรูปแบบในการพิมพ์',
    ug: 'ئىككى جەدۋەل ئارقىلىق تەرتىپلەش',
    vi: 'Sử dụng hai bảng để xếp ván',
    zh_tc: '使用兩個表單排版',
    ru: 'Использовать две формы',
    ko: '양식 레이아웃 2개 사용',
    bur: 'ဖောင်နှစ်ခုဖြင့်ပြင်ဆင်',
    ben: 'দুটি ফর্ম দিয়ে লেআউট করুন',
    tr: 'İki form ile yerleşim',
    km: 'រៀបចំដោយទម្រង់ពីរ',
    es: 'Utilice dos formularios para componer',
    ar: 'استخدم نموذجين للتنضيد',
  },
  'bujianAndStore.confirmUseTwoTableTip': {
    zh: '当前选中小板包含补件库和待排版库小板是否继续排版？',
    en: 'The selected small planks include both the Bujian and Awaiting Layout warehouses. Do you want to continue with the layout?',
    id: 'Papan kecil yang saat ini dipilih berisi perpustakaan tambahan dan perpustakaan yang toype. Akankah papan kecil terus mengetik?',
    kz: 'Ағымдағы таңдалған шағын тақтайлар қосалқы бөлшектер қоймасы мен орналастыруды күту қоймасынан тұрады. Орналастыруды жалғастыруды қалайсыз ба?',
    th: 'บอร์ดขนาดเล็กที่เลือกในปัจจุบันมีห้องสมุดเสริมและห้องสมุด TO-type บอร์ดขนาดเล็กจะยังคงพิมพ์ต่อไปหรือไม่?',
    ug: 'تاللانغان كىچىك تاختىلار قوشۇمچە بۆلەك ئامبىرى ۋە ساقلىنىدىغان تەرتىپلەش ئامبىرىدىكى كىچىك تاختىلارنى ئۆز ئىچىگە ئالىدۇ، تەرتىپلەشنى داۋاملاشتۇرامسىز؟',
    vi: 'Các tấm nhỏ được chọn hiện tại bao gồm cả kho bổ sung và kho chờ xếp ván. Bạn có muốn tiếp tục xếp ván không?',
    zh_tc: '當前選中小板包含補件庫和待排版庫小板是否繼續排版？',
    ru: 'Продолжает ли текущая выделенная панель, содержащая библиотеку дополнений и библиотеку для форматирования?',
    ko: '현재 선택한 보드에 트위닝 라이브러리와 예약된 라이브러리가 포함되어 있습니다. 계속 정렬하시겠습니까?',
    bur: 'ရွေးချယ်ထားသောပေါ်ဒ်ငယ်တွင်ဖြည့်ဆည်းဂိုဒေါင်နှင့်ပြင်ဆင်စောင့်ဆိုင်းဂိုဒေါင်ပေါ်ဒ်ပါဝင်သည်',
    ben: 'বর্তমানে নির্বাচিত ছোট বোর্ডে পরিপূরক গুদাম এবং অপেক্ষার গুদামের বোর্ড অন্তর্ভুক্ত, লেআউট চালিয়ে যাবেন?',
    tr: 'Seçili küçük levhalar hem ek parça hem yerleşim bekleyen depodan; yerleşime devam edilsin mi?',
    km: 'ផ្ទាំងតូចដែលជ្រើសមានទាំងឃ្លាំងបំពេញ និងរង់ចាំរៀបចំ បន្តរៀបចំឬទេ?',
    es: 'La pequeña pizarra actualmente seleccionada contiene la biblioteca de parches y la biblioteca para componer. ¿Quieres seguir escribiendo la pizarra?',
    ar: 'تحتوي اللوحة الصغيرة المحددة حاليًا على مكتبة التصحيح والمكتبة المراد تنضيدها. هل تريد الاستمرار في تنضيد اللوحة الصغيرة؟',
  },
  'bujianAndStore.confirmAddPlankToAwaitStore': {
    zh: '是否确认将所选板件添加到待排版库？',
    en: 'Are you sure you want to add the selected planks to the Awaiting Layout warehouse?',
    id: 'Apakah Anda pasti akan menambahkan papan yang dipilih ke perpustakaan untuk diketik?',
    kz: 'Таңдалған тақтайларды орналастыруды күту қоймасына қосуға сенімдісіз бе?',
    th: 'คุณแน่ใจว่าจะเพิ่มบอร์ดที่เลือกลงในไลบรารีที่จะพิมพ์หรือไม่?',
    ug: 'تاللانغان تاختا بۆلەكلەرنى ساقلىنىدىغان تەرتىپلەش ئامبىرىغا قوشۇشنى جازالامسىز؟',
    vi: 'Bạn có chắc chắn muốn thêm các tấm ván đã chọn vào kho chờ xếp ván không?',
    zh_tc: '是否確認將所選板件添加到待排版庫？',
    ru: 'Подтверждаете ли вы добавление выбранной панели в библиотеку, подлежащую набору?',
    ko: '선택한 보드를 보류 중인 라이브러리에 추가하시겠습니까?',
    bur: 'ရွေးချယ်ထားသောပေါ်ဒ်ကိုပြင်ဆင်စောင့်ဆိုင်းဂိုဒေါင်ထည့်ရမည်ကိုအတည်ပြုလား?',
    ben: 'নির্বাচিত বোর্ডগুলো লেআউট অপেক্ষার গুদামে যোগ করতে নিশ্চিত করবেন?',
    tr: 'Seçili levhalar yerleşim bekleyen depoya eklensin mi?',
    km: 'បញ្ជាក់បន្ថែមផ្ទាំងដែលជ្រើសទៅឃ្លាំងរង់ចាំរៀបចំ?',
    es: '¿Está seguro de agregar el panel seleccionado a la biblioteca de diseños?',
    ar: 'هل أنت متأكد من إضافة اللوحة المحددة إلى مكتبة التخطيط؟',
  },
  'bujianAndStore.pushStoreSuccess': {
    zh: '入库成功',
    en: 'Successfully added to warehouse',
    id: 'Berhasil memasuki gudang',
    kz: 'Қоймаға сәтті қосылды',
    th: 'เข้าสู่คลังสินค้าได้สำเร็จ',
    ug: 'ئامبارغا ساقلاش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Nhập kho thành công',
    zh_tc: '入庫成功',
    ru: 'Хранилище успешно',
    ko: '입고 성공',
    bur: 'ဂိုဒေါင်ဝင်မှုအောင်မြင်',
    ben: 'গুদামে সফলভাবে যোগ করা হয়েছে',
    tr: 'Depoya giriş başarılı',
    km: 'ចូលឃ្លាំងជោគជ័យ',
    es: 'Almacenamiento exitoso',
    ar: 'التخزين الناجح',
  },
  'bujianAndStore.dataGenErr': {
    zh: '数据生成错误',
    en: 'Data generation error',
    id: 'Kesalahan pembuatan data',
    kz: 'Деректерді жасау қатесі',
    th: 'ข้อผิดพลาดในการสร้างข้อมูล',
    ug: 'سانلىق مەلۇمات ھاسىل قىلىش خاتالىقى',
    vi: 'Lỗi tạo dữ liệu',
    zh_tc: '數據生成錯誤',
    ru: 'Ошибка генерации данных',
    ko: '데이터 생성 오류',
    bur: 'ဒေတာထုတ်လုပ်မှုအမှား',
    ben: 'ডেটা তৈরিতে ত্রুটি',
    tr: 'Veri oluşturma hatası',
    km: 'កំហុសបង្កើតទិន្នន័យ',
    es: 'Error de generación de datos',
    ar: 'خطأ في إنشاء البيانات',
  },
  'bujianAndStore.unknownErr': {
    zh: '出现未知错误，入库失败',
    en: 'Unknown error occurred, failed to add to warehouse',
    id: 'Terjadi kesalahan yang tidak diketahui dan gagal memasuki database',
    kz: 'Белгісіз қате пайда болды, қоймаға қосу сәтсіз аяқталды',
    th: 'เกิดข้อผิดพลาดที่ไม่รู้จักและไม่สามารถป้อนฐานข้อมูลได้',
    ug: 'نۆۋەتسىز خاتالىق كۆرۈلدى، ئامبارغا ساقلاش مەغلۇپ بولدى',
    vi: 'Đã xảy ra lỗi không xác định, nhập kho thất bại',
    zh_tc: '出現未知錯誤，入庫失敗',
    ru: 'Произошла неизвестная ошибка, не удалось войти в хранилище',
    ko: '알 수 없는 오류가 발생하여 입고 실패',
    bur: 'အမည်မသိအမှားဖြစ်ပွားသဖြင့်ဂိုဒေါင်ဝင်မသွားပါ',
    ben: 'অজানা ত্রুটি ঘটেছে, গুদামে যোগ করা ব্যর্থ হয়েছে',
    tr: 'Bilinmeyen hata; depoya eklenemedi',
    km: 'កំហុសមិនស្គាល់ ចូលឃ្លាំងបរាជ័យ',
    es: 'Ocurrió un error desconocido y el almacén falló',
    ar: 'حدث خطأ غير معروف وفشل المستودع',
  },
  'surplusPage.surplusMaterial': {
    zh: '余料清单',
    en: 'Surplus Material List',
    id: 'Daftar bahan yang tersisa',
    kz: 'Қалған материалдар тізімі',
    th: 'รายการวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال تىزىملىكى',
    vi: 'Danh sách vật liệu thừa',
    zh_tc: '餘料清單',
    ru: 'Перечень излишков',
    ko: '남은 커팅 리스트',
    bur: 'ပိုလျှံပစ္စည်းစာရင်း',
    ben: 'উদ্বৃত্ত উপকরণ তালিকা',
    tr: 'Artık malzeme listesi',
    km: 'បញ្ជីសម្ភារៈសល់',
    es: 'Lista de materiales restantes',
    ar: 'قائمة المواد المتبقية',
  },
  'surplusPage.surplusStore': {
    zh: '余料库',
    en: 'Surplus Material Warehouse',
    id: 'Gudang bahan yang tersisa',
    kz: 'Қалған материалдар қоймасы',
    th: 'คลังสินค้าวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال ئامبىرى',
    vi: 'Kho vật liệu thừa',
    zh_tc: '餘料庫',
    ru: 'Склад излишков',
    ko: '잉여 재료 창고',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်',
    ben: 'উদ্বৃত্ত উপকরণ গুদাম',
    tr: 'Artık malzeme deposu',
    km: 'ឃ្លាំងសម្ភារៈសល់',
    es: 'Biblioteca de materiales restantes',
    ar: 'مكتبة المواد المتبقية',
  },
  'surplusPage.recycleBin': {
    zh: '余料回收站',
    en: 'Surplus Recycle Bin',
    id: 'Tempat sampah bahan yang tersisa',
    kz: 'Қалған материалдардың қалдықтары',
    th: 'ขยะวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال ئامبىرى ئاۋالاتى',
    vi: 'Thùng rác vật liệu thừa',
    zh_tc: '餘料回收站',
    ru: 'Склад излишков',
    ko: '잉여 재료 창고',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အသစ်ဆောက်',
    ben: 'উদ্বৃত্ত উপকরণ গুদাম',
    tr: 'Artık malzeme deposu',
    km: 'ឃ្លាំងសម្ភារៈសល់',
    es: 'Biblioteca de materiales restantes',
    ar: 'مكتبة المواد المتبقية',
  },
  'surplusPage.recycleBinTip': {
    zh: '余料数据放入回收站超过90天后会自动清除',
    en: 'Surplus material data will be automatically deleted after being in the recycle bin for more than 90 days',
    id: 'Data material sisa di recycle bin akan dihapus otomatis setelah lebih dari 90 hari',
    kz: 'Қалдық материалдар деректері қалдықтар жәшігіне салынғаннан кейін 90 күн өткен соң автоматты түрде жойылады',
    th: 'ข้อมูลวัสดุที่เหลือจะถูกลบโดยอัตโนมัติหากอยู่ในถังขยะเกิน 90 วัน',
    ug: 'قالدۇق ماتېرىيال سانلىق مەلۇماتى قايتا ئىشلىتىش قۇتىسىدا 90 كۈن قىپ قالسا ئاپتوماتىك يۆچىلىدۇ',
    vi: 'Dữ liệu vật liệu thừa trong thùng rác sẽ tự động bị xóa sau hơn 90 ngày',
    zh_tc: '餘料數據放入回收站超過90天後會自動清除',
    ru: 'Данные избыточных материалов в корзине будут автоматически удалены по истечении 90 дней',
    ko: '여분 자재 데이터는 휴지통에 90일 이상 있으면 자동으로 삭제됩니다',
    bur: 'ပိုလျှံပစ္စည်းဒေတာကို အမှိုက်ပုံးတွင် ၉၀ ရက်ကျော်ထားလျှင် အလိုအလျောက် ဖျက်သိမ်းမည်',
    ben: 'অতিরিক্ত উপকরণের ডেটা ৯০ দিন ধরে রিসাইকেল বিনে থাকলে স্বয়ংক্রিয়ভাবে মুছে ফেলা হবে',
    tr: 'Artık malzeme verileri 90 gün boyunca geri dönüşüm kutusunda kaldıktan sonra otomatik olarak silinir',
    km: 'ទិន្នន័យសម្ភារៈសល់នៅក្នុងធុងសំរាមនឹងត្រូវលុបដោយស្វ័យប្រវត្តិ បន្ទាប់ពីមួយរយៈ ៩០ ថ្ងៃ',
    es: 'Los datos de materiales sobrantes se eliminarán automáticamente después de estar más de 90 días en la papelera de reciclaje',
    ar: 'سيتم حذف بيانات المواد الزائدة من سلة المهملات تلقائياً بعد مرور 90 يوماً',
  },
  'surplusPage.deleteReason-0': {
    zh: '手动删除',
    en: 'Manual deletion',
    id: 'Penghapusan manual',
    kz: 'Қолмен жою',
    th: 'ลบด้วยตนเอง',
    ug: 'قول بىلەن ئۆچۈرۈش',
    vi: 'Xóa thủ công',
    zh_tc: '手動刪除',
    ru: 'Удаление вручную',
    ko: '수동 삭제',
    bur: 'ကိုယ်တိုင်ဖျက်ခြင်း',
    ben: 'ম্যানুয়ালি মুছে ফেলা',
    tr: 'Elle yapılan silme',
    km: 'លុបដោយដៃ',
    es: 'Eliminación manual',
    ar: 'حذف يدوي',
  },
  'surplusPage.deleteReason-1': {
    zh: '排版扣减',
    en: 'Typesetting deduction',
    id: 'Pengurangan karena typesetting',
    kz: 'Беттеу шегерімі',
    th: 'หักลดจากการจัดหน้ากระดาษ',
    ug: 'بېتىنى تەرتىپلەشتە كېمەيتىش',
    vi: 'Khấu trừ dàn trang',
    zh_tc: '排版扣減',
    ru: 'Вычет при верстке',
    ko: '조판 공제',
    bur: 'စာမျက်နှာချပ်နည်းခြင်း',
    ben: 'টাইপসেটিং কাটছাঁট',
    tr: 'Dizgi kesintisi',
    km: 'កាត់បន្ថយដោយ​តម្រៀប​ទំព័រ',
    es: 'Deducción por composición',
    ar: 'خصم تركيب النص',
  },
  'surplusPage.deleteReason-2': {
    zh: '柜柜移动端操作出库',
    en: 'Outbound via Guigui mobile operation',
    id: 'Pengeluaran melalui operasi seluler Guigui',
    kz: 'Guigui мобильді операция арқылы қоймадан шығару',
    th: 'ดำเนินการออกจากคลังด้วยแอป Guigui บนมือถือ',
    ug: 'Guigui مەبلىغىدىكى يېڭى چىقىم',
    vi: 'Xuất kho qua thao tác di động Guigui',
    zh_tc: '櫃櫃移動端操作出庫',
    ru: 'Отгрузка через мобильную операцию Guigui',
    ko: 'Guigui 모바일 작업 출고',
    bur: 'Guigui မိုဘိုင်းအပ်ပလီကေးရှင်းမှ ထုတ်ယူမှု',
    ben: 'Guigui মোবাইল অপারেশনের মাধ্যমে আউটবাউন্ড',
    tr: 'Guigui mobil işlemi ile stok çıkışı',
    km: 'ចេញឃ្លាំងតាមប្រតិបត្តិការ Guigui មូបាញ់',
    es: 'Salida mediante operación móvil de Guigui',
    ar: 'إخراج عبر عملية Guigui المحمولة',
  },
  'surplusPage.surplusShape': {
    zh: '余料形状',
    en: 'Surplus Shape',
    id: 'Bentuk bahan yang tersisa',
    kz: 'Қалған материалдардың пішіні',
    th: 'รูปร่างวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال شەكلى',
    vi: 'Hình dạng vật liệu thừa',
    zh_tc: '餘料形狀',
    ru: 'форма остатка',
    ko: '여분 형태',
    bur: 'ပိုလျှံပစ္စည်းပုံသဏ္ဍာန်',
    ben: 'উদ্বৃত্তের আকৃতি',
    tr: 'Artık malzeme şekli',
    km: 'រូបរាងសម្ភារៈសល់',
    es: 'Forma del material restante',
    ar: 'شكل المادة المتبقية',
  },
  'surplusPage.batchTransfer': {
    zh: '批量转移',
    en: 'Batch Transfer',
    id: 'Transfer batch',
    kz: 'Жаппай ауыстыру',
    th: 'การถ่ายโอนแบทช์',
    ug: 'بىر قانچە يۆتكەش',
    vi: 'Chuyển hàng loạt',
    zh_tc: '批量轉移',
    ru: 'Массовая передача',
    ko: '대량 전송',
    bur: 'အပိုင်းလိုက်လွှဲ',
    ben: 'ব্যাচ ট্রান্সফার',
    tr: 'Toplu aktarım',
    km: 'ផ្ទេរជាក្រុម',
    es: 'Transferencia por lotes',
    ar: 'نقل الدفعة',
  },
  'surplusPage.createNewSurplusStore': {
    zh: '新建余料库',
    en: 'Create New Surplus Warehouse',
    id: 'Gudang Bahan Surplus Baru',
    kz: 'Жаңа қалған материалдар қоймасын құру',
    th: 'คลังสินค้าวัสดุส่วนเกินใหม่',
    ug: 'يېڭى قالدۇق ماتېرىيال ئامبىرى قۇرۇش',
    vi: 'Tạo kho thừa mới',
    zh_tc: '新建餘料庫',
    ru: 'Новый склад',
    ko: '새 잉여 재료 창고',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အသစ်ဆောက်',
    ben: 'নতুন উদ্বৃত্ত গুদাম তৈরি করুন',
    tr: 'Yeni artık malzeme deposu',
    km: 'ឃ្លាំងសល់ថ្មី',
    es: 'Crear una nueva biblioteca de materiales restantes',
    ar: 'إنشاء مكتبة مواد متبقية جديدة',
  },
  'surplusPage.pushStoreSetting': {
    zh: '余料入库设置',
    en: 'Surplus Storage Settings',
    id: 'Pengaturan penyimpanan material yang tersisa',
    kz: 'Қалған материалдарды сақтау параметрлері',
    th: 'การตั้งค่าการจัดเก็บวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال ئامبارغا ساقلاش تەڭشەكلىرى',
    vi: 'Cài đặt lưu trữ vật liệu thừa',
    zh_tc: '餘料入庫設置',
    ru: 'Параметры складирования излишков',
    ko: '남은 재료 입고 설정',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်ဆက်တင်',
    ben: 'উদ্বৃত্ত স্টোরেজ সেটিংস',
    tr: 'Artık malzeme depo ayarları',
    km: 'ការកំណត់ចូលឃ្លាំងសល់',
    es: 'Configuración de almacenamiento de materiales restantes',
    ar: 'إعدادات تخزين المواد المتبقية',
  },
  'surplusPage.surplusStoreName': {
    zh: '余料库名',
    en: 'Surplus Warehouse Name',
    id: 'Nama silo',
    kz: 'Қалған материалдар қоймасының атауы',
    th: 'ชื่อของไซโล',
    ug: 'قالدۇق ماتېرىيال ئامبىرى ئىسمى',
    vi: 'Tên kho thừa',
    zh_tc: '餘料庫名',
    ru: 'Название склада',
    ko: '남은 재료 창고 이름',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အမည်',
    ben: 'উদ্বৃত্ত গুদামের নাম',
    tr: 'Artık depo adı',
    km: 'ឈ្មោះឃ្លាំងសល់',
    es: 'Nombre de la biblioteca de materiales restantes',
    ar: 'اسم مكتبة المواد المتبقية',
  },
  'surplusPage.surplusStoreName2': {
    zh: '余料库名称',
    en: 'Surplus Warehouse Name',
    id: 'Nama Gudang Bahan Surplus',
    kz: 'Қалған материалдар қоймасының атауы',
    th: 'ชื่อคลังสินค้าวัสดุส่วนเกิน',
    ug: 'قالدۇق ماتېرىيال ئامبىرى ئىسمى',
    vi: 'Tên kho thừa',
    zh_tc: '餘料庫名稱',
    ru: 'Название склада',
    ko: '남은 라이브러리 이름',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အမည်',
    ben: 'উদ্বৃত্ত গুদামের নাম',
    tr: 'Artık depo adı',
    km: 'ឈ្មោះឃ្លាំងសល់',
    es: 'Nombre de la biblioteca de materiales restantes',
    ar: 'اسم مكتبة المواد المتبقية',
  },
  'surplusPage.addSurplusStore': {
    zh: '添加余料库',
    en: 'Add Surplus Warehouse',
    id: 'Tambahkan sisa gudang material',
    kz: 'Қалған материалдар қоймасын қосу',
    th: 'เพิ่มคลังสินค้าวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال ئامبىرى قوشۇش',
    vi: 'Thêm kho thừa',
    zh_tc: '添加餘料庫',
    ru: 'Добавить склад',
    ko: '남은 재료 라이브러리 추가',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ထည့်',
    ben: 'উদ্বৃত্ত গুদাম যোগ করুন',
    tr: 'Artık depo ekle',
    km: 'បន្ថែមឃ្លាំងសល់',
    es: 'Agregar biblioteca de materiales restantes',
    ar: 'إضافة مكتبة المواد المتبقية',
  },
  'surplusPage.inventoryCeiling': {
    zh: '库存上限',
    en: 'Inventory Ceiling',
    id: 'Tutup stok',
    kz: 'Қойма шегі',
    th: 'หมวกสต็อก',
    ug: 'ئامبار چېكى',
    vi: 'Giới hạn tồn kho',
    zh_tc: '庫存上限',
    ru: 'Верхний предел запасов',
    ko: '재고 상한',
    bur: 'ကုန်ပစ္စည်းအမြင့်ဆုံးကန့်သတ်',
    ben: 'স্টক সর্বোচ্চ সীমা',
    tr: 'Stok üst sınırı',
    km: 'ដែនកំណត់ស្តុកអតិបរមា',
    es: 'Límite de existencias',
    ar: 'حد المخزون',
  },
  'surplusPage.autoTransferTip': {
    zh: '删除后余料库内余料会自动转移到余料清单',
    en: 'After deletion, surplus materials in the warehouse will be automatically transferred to the surplus material list',
    id: 'Setelah dihapus, bahan residu di gudang bahan residu akan secara otomatis ditransfer ke daftar bahan residu.',
    kz: 'Жойылғаннан кейін, қоймадағы қалған материалдар автоматты түрде қалған материалдар тізіміне ауыстырылады',
    th: 'หลังจากการลบวัสดุที่เหลือในคลังสินค้าวัสดุที่เหลือจะถูกถ่ายโอนไปยังรายการวัสดุที่เหลือโดยอัตโนมัติ',
    ug: 'ئۆچۈرۈلگەندىن كېيىن قالدۇق ماتېرىيال ئامبىرىدىكى قالدۇقلار ئاپتوماتىك ھالدا قالدۇق ماتېرىيال تىزىملىكىگە يۆتكىلىدۇ',
    vi: 'Sau khi xóa, vật liệu thừa trong kho sẽ tự động chuyển sang danh sách vật liệu thừa',
    zh_tc: '刪除後餘料庫內餘料會自動轉移到餘料清單',
    ru: 'После удаления остатки в хранилище автоматически переходят в список остатков.',
    ko: '삭제 후 남은 저장소의 남은 재료는 자동으로 남은 재료로 이동됩니다.',
    bur: 'ဖျက်ပြီးနောက်ပိုလျှံပစ္စည်းဂိုဒေါင်မှပိုလျှံပစ္စည်းသည်အလိုအလျောက်ပိုလျှံပစ္စည်းစာရင်းသို့ပြောင်းသည်',
    ben: 'মুছার পরে, গুদামের উদ্বৃত্ত স্বয়ংক্রিয়ভাবে উদ্বৃত্ত উপকরণ তালিকায় স্থানান্তরিত হবে',
    tr: 'Silindikten sonra depodaki artıklar otomatik olarak artık malzeme listesine aktarılır',
    km: 'បន្ទាប់ពីលុប សម្ភារៈសល់ក្នុងឃ្លាំងនឹងផ្ទេរទៅបញ្ជីសល់ស្វ័យប្រវត្តិ',
    es: 'Después de la eliminación, los materiales restantes en el El almacén se transferirá automáticamente a la lista de materiales restantes',
    ar: 'بعد الحذف، المواد المتبقية في سيتم نقل المستودع تلقائيًا إلى قائمة المواد المتبقية',
  },
  'surplusPage.asIndexPushStore': {
    zh: '按照仓库存放情况顺序入库',
    en: 'Store in order according to warehouse storage conditions',
    id: 'Masukkan gudang agar penyimpanan',
    kz: 'Қойманың сақталу жағдайына сәйкес тәртіппен сақтау',
    th: 'เข้าสู่คลังสินค้าตามลำดับการจัดเก็บ',
    ug: 'ئامبار ساقلاش ئەھۋالى بويىچە تەرتىپلىك ساقلاش',
    vi: 'Lưu trữ theo thứ tự theo tình trạng lưu trữ kho',
    zh_tc: '按照倉庫存放情況順序入庫',
    ru: 'Хранить в порядке складирования',
    ko: '창고 보관 상황 순서에 따라 입고하다.',
    bur: 'ဂိုဒေါင်သိမ်းဆည်းမှုအစဉ်အတိုင်းဝင်',
    ben: 'গুদামে সংরক্ষণের ক্রম অনুযায়ী সংরক্ষণ করুন',
    tr: 'Depo doluluk durumuna göre sırayla depoya al',
    km: 'ចូលឃ្លាំងតាមលំដាប់ស្ថានភាពផ្ទុក',
    es: 'y se almacenará en orden de acuerdo con la situación de almacenamiento del almacén',
    ar: 'وتخزينه بالترتيب وفقًا لحالة تخزين المستودع',
  },
  'surplusPage.pushToSurplusMaterial': {
    zh: '存入余料清单',
    en: 'Store in Surplus Material List',
    id: 'Simpan daftar materi yang tersisa',
    kz: 'Қалған материалдар тізіміне сақтау',
    th: 'บันทึกรายการวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال تىزىملىكىگە ساقلاش',
    vi: 'Lưu vào danh sách vật liệu thừa',
    zh_tc: '存入餘料清單',
    ru: 'Перечень складированных излишков',
    ko: '남은 커팅 리스트 저장',
    bur: 'ပိုလျှံပစ္စည်းစာရင်းသိမ်း',
    ben: 'উদ্বৃত্ত উপকরণ তালিকায় সংরক্ষণ করুন',
    tr: 'Artık malzeme listesine kaydet',
    km: 'រក្សាទៅបញ្ជីសម្ភារៈសល់',
    es: 'Almacene los materiales restantes en la lista',
    ar: 'تخزين المواد المتبقية في القائمة',
  },
  'surplusPage.surplusStoreTable.number': {
    zh: '编号',
    en: 'Number',
    id: 'nomor seri',
    kz: 'Нөмір',
    th: 'หมายเลขซีเรียล',
    ug: 'نومۇرى',
    vi: 'Số thứ tự',
    zh_tc: '編號',
    ru: 'номер',
    ko: '번호',
    bur: 'နံပါတ်',
    ben: 'নম্বর',
    tr: 'Numara',
    km: 'លេខ',
    es: 'Número',
    ar: 'الرقم',
  },
  'surplusPage.surplusStoreTable.name': {
    zh: '余料库名称',
    en: 'Surplus Warehouse Name',
    id: 'Nama Gudang Bahan Surplus',
    kz: 'Қалған материалдар қоймасының атауы',
    th: 'ชื่อคลังสินค้าวัสดุส่วนเกิน',
    ug: 'قالدۇق ماتېرىيال ئامبىرى ئىسمى',
    vi: 'Tên kho thừa',
    zh_tc: '餘料庫名稱',
    ru: 'Название склада',
    ko: '남은 라이브러리 이름',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အမည်',
    ben: 'উদ্বৃত্ত গুদামের নাম',
    tr: 'Artık depo adı',
    km: 'ឈ្មោះឃ្លាំងសល់',
    es: 'Nombre de la biblioteca de materiales restantes',
    ar: 'اسم مكتبة المواد المتبقية',
  },
  'surplusPage.surplusStoreTable.quantity': {
    zh: '已存余料数量(个)',
    en: 'Stored Surplus Quantity (pcs)',
    id: 'Jumlah bahan yang tersisa (potongan)',
    kz: 'Сақталған қалған материалдар саны (дана)',
    th: 'ปริมาณวัสดุที่เหลืออยู่ (ชิ้น)',
    ug: 'ساقلانغان قالدۇق ماتېرىيال سانى(دانە)',
    vi: 'Số lượng vật liệu thừa đã lưu (cái)',
    zh_tc: '已存餘料數量(個)',
    ru: 'Количество хранимых остатков (шт)',
    ko: '남은 재료 수량 (개)',
    bur: 'သိမ်းဆည်းထားသောပိုလျှံပစ္စည်းအရေအတွက်(ခု)',
    ben: 'সংরক্ষিত উদ্বৃত্তের পরিমাণ (পিস)',
    tr: 'Saklanan artık adet (adet)',
    km: 'ចំនួនសល់ដែលបានរក្សា (ឯកតា)',
    es: 'Cantidad de materiales restantes almacenados (unidades)',
    ar: 'كمية المواد المتبقية المخزنة (وحدات)',
  },
  'surplusPage.surplusStoreTable.capacity': {
    zh: '余料库存上限(个)',
    en: 'Surplus Inventory Ceiling (pcs)',
    id: 'Batas atas inventaris material yang tersisa (potongan)',
    kz: 'Қалған материалдар қоймасы шегі (дана)',
    th: 'ขีด จำกัด สูงสุดของสินค้าคงคลังวัสดุที่เหลืออยู่ (ชิ้น)',
    ug: 'قالدۇق ماتېرىيال ئامبىرى چېكى(دانە)',
    vi: 'Giới hạn tồn kho vật liệu thừa (cái)',
    zh_tc: '餘料庫存上限(個)',
    ru: 'Верхний предел запасов излишков (шт)',
    ko: '잔재 재고 상한선 (개)',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ကုန်ပစ္စည်းကန့်သတ်(ခု)',
    ben: 'উদ্বৃত্ত গুদামের স্টক সর্বোচ্চ সীমা (পিস)',
    tr: 'Artık stok üst sınırı (adet)',
    km: 'ដែនកំណត់ស្តុកសល់អតិបរមា (ឯកតា)',
    es: 'Límite de inventario de material restante (unidades)',
    ar: 'حد مخزون المواد المتبقية (وحدات)',
  },
  'surplusPage.surplusStoreTable.rules': {
    zh: '余料入库规则',
    en: 'Rules for surplus material storage',
    id: 'Aturan penyimpanan material yang tersisa',
    kz: 'Қалыпты құрама жинақтау ережелері',
    th: 'กฎการจัดเก็บวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال ئامبارغا ساقلاش قائىدىسى',
    vi: 'Quy tắc nhập kho nguyên liệu dư',
    zh_tc: '餘料入庫規則',
    ru: 'Правила складирования излишков',
    ko: '잉여 재료 입고 규칙',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်စည်းမျဉ်း',
    ben: 'উদ্বৃত্ত স্টোরেজের নিয়মাবলী',
    tr: 'Artık malzeme depo kuralları',
    km: 'ច្បាប់ចូលឃ្លាំងសល់',
    es: 'Reglas de almacenamiento de material restante',
    ar: 'قواعد تخزين المواد المتبقية',
  },
  'surplusPage.surplusStoreTable.remark': {
    zh: '备注',
    en: 'Remarks',
    id: 'Komentar',
    kz: 'Ескертпе',
    th: 'คำพูด',
    ug: 'ئىزاھات',
    vi: 'Ghi chú',
    zh_tc: '備註',
    ru: 'примечание',
    ko: '비고',
    bur: 'မှတ်ချက်',
    ben: 'মন্তব্য',
    tr: 'Not',
    km: 'កំណត់សម្គាល់',
    es: 'Comentarios',
    ar: 'ملاحظة',
  },
  'surplusPage.surplusStoreTable.operation': {
    zh: '操作',
    en: 'Operation',
    id: 'beroperasi',
    kz: 'Операция',
    th: 'ดำเนินงาน',
    ug: 'مەشغۇلات',
    vi: 'Thao tác',
    zh_tc: '操作',
    ru: 'операция',
    ko: '조작',
    bur: 'လုပ်ဆောင်မှု',
    ben: 'অপারেশন',
    tr: 'İşlem',
    km: 'ប្រតិបត្តិការ',
    es: 'Operación',
    ar: 'التشغيل',
  },
  'surplusPage.editSurplusStore': {
    zh: '编辑余料库',
    en: 'Edit Surplus Warehouse',
    id: 'Edit Perpustakaan Surplus',
    kz: 'Қалған материалдар қоймасын өңдеу',
    th: 'แก้ไขห้องสมุดส่วนเกิน',
    ug: 'قالدۇق ماتېرىيال ئامبىرىنى تەھرىرلەش',
    vi: 'Chỉnh sửa kho thừa',
    zh_tc: '編輯餘料庫',
    ru: 'Редактировать остаточную библиотеку',
    ko: '남은 라이브러리 편집',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်တည်းဖြတ်',
    ben: 'উদ্বৃত্ত গুদাম সম্পাদনা করুন',
    tr: 'Artık depoyu düzenle',
    km: 'កែឃ្លាំងសល់',
    es: 'Editar la biblioteca de materiales restantes',
    ar: 'تحرير مكتبة المواد المتبقية',
  },
  'surplusPage.addSurplus': {
    zh: '添加余料',
    en: 'Add Scrap',
    id: 'Tambahkan bahan yang tersisa',
    kz: 'Қалдықтарды қосу',
    th: 'เพิ่มวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال قوشۇش',
    vi: 'Thêm dư liệu',
    zh_tc: '添加餘料',
    ru: 'Добавить остатки',
    ko: '여분 을 첨가 하다',
    bur: 'ပိုလျှံပစ္စည်းထည့်',
    ben: 'উদ্বৃত্ত যোগ করুন',
    tr: 'Artık malzeme ekle',
    km: 'បន្ថែមសម្ភារៈសល់',
    es: 'Agregar el material restante',
    ar: 'إضافة المادة المتبقية',
  },
  'surplusPage.importSurplus': {
    zh: '导入余料',
    en: 'Import Scrap',
    id: 'Impor bahan yang tersisa',
    kz: 'Қалдықтарды импорттау',
    th: 'นำเข้าวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال يۆتكەش',
    vi: 'Nhập dư liệu',
    zh_tc: '導入余料',
    ru: 'Импорт остатков',
    ko: '남은 재료 가져오기',
    bur: 'ပိုလျှံပစ္စည်းတင်သွင်း',
    ben: 'উদ্বৃত্ত আমদানি করুন',
    tr: 'Artık malzeme içe aktar',
    km: 'នាំចូលសម្ភារៈសល់',
    es: 'Importar el material restante',
    ar: 'استيراد المادة المتبقية',
  },
  'surplusPage.downloadSurplusTemplate': {
    zh: '下载余料导入模板',
    en: 'Download Scrap Import Template',
    id: 'Unduh template bahan residu',
    kz: 'Қалдықтарды импорттау мәндемесін жүктеп алу',
    th: 'ดาวน์โหลดแม่แบบนำเข้าวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال يۆتكەش مەنبەلىكى تەڭشەكلىرىنى ئايرىش',
    vi: 'Tải xuống mẫu nhập dư liệu',
    zh_tc: '下載余料導入模板',
    ru: 'Загрузить шаблон импорта остатков',
    ko: '남은 자료 가져오기 템플릿 다운로드',
    bur: 'ပိုလျှံပစ္စည်းတင်သွင်းပုံစံဒေါင်းလုတ်',
    ben: 'উদ্বৃত্ত আমদানি টেমপ্লেট ডাউনলোড করুন',
    tr: 'Artık içe aktarma şablonunu indir',
    km: 'ទាញយកគំរូនាំចូលសល់',
    es: 'Descargar la plantilla de importación de material restante',
    ar: 'تنزيل قالب استيراد المواد المتبقية',
  },
  'surplusPage.batchExportSurplus': {
    zh: '导出当前余料清单',
    en: 'Export Current Scrap List',
    id: 'Ekspor daftar bahan residu saat ini',
    kz: 'Қалдықтардың бүкіл тізімін шығару',
    th: 'ส่งออกรายการวัสดุที่เหลืออยู่ปัจจุบัน',
    ug: 'قالدۇق ماتېرىيال تىزىملىكىنى ئايرىش',
    vi: 'Xuất hiện danh sách dư liệu hiện tại',
    zh_tc: '導出當前余料清單',
    ru: 'Экспорт текущего списка остатков',
    ko: '현재 남은 커팅 리스트 내보내기',
    bur: 'လက်ရှိပိုလျှံပစ္စည်းစာရင်းထုတ်',
    ben: 'বর্তমান উদ্বৃত্ত তালিকা রপ্তানি করুন',
    tr: 'Geçerli artık listesini dışa aktar',
    km: 'នាំចេញបញ្ជីសល់បច្ចុប្បន្ន',
    es: 'Exportar la lista actual de materiales restantes',
    ar: 'تصدير قائمة المواد المتبقية الحالية',
  },
  'surplusPage.surplusBatchImportExport': {
    zh: '余料批量导入导出',
    en: 'Surplus Batch Import Export',
    id: 'Impor/ekspor bahan residu secara batch',
    kz: 'Қалдықтарды импорттау/шығару',
    th: 'นำเข้า/ส่งออกวัสดุที่เหลืออยู่ตามล็อต',
    ug: 'قالدۇق ماتېرىيال تىزىملىكىنى يۆتكەش يا ئايرىش',
    vi: 'Nhập/xuất dư liệu thừa theo lô',
    zh_tc: '余料批量導入導出',
    ru: 'Экспорт избыточных партий',
    ko: '남은 재료 대량 가져오기 내보내기',
    bur: 'ပိုလျှံပစ္စည်းအပိုင်းလိုက်တင်သွင်းထုတ်',
    ben: 'উদ্বৃত্ত ব্যাচ আমদানি রপ্তানি',
    tr: 'Artık malzeme toplu içe/dışa aktarma',
    km: 'នាំចូល/នាំចេញសល់ជាក្រុម',
    es: 'Importar y exportar por lotes el material restante',
    ar: 'استيراد وتصدير دفعة من المواد المتبقية',
  },
  'surplusPage.surplusMaterialStorageCode': {
    zh: '余料入库码',
    en: 'Surplus Material Storage Code',
    id: 'Kode Penyimpanan Bahan Sisa',
    kz: 'Артық материал сақтау коды',
    th: 'รหัสการจัดเก็บวัสดุส่วนเกิน',
    ug: 'قوشۇمچە ماتېرىيال ساقلاش كودى',
    vi: 'Mã nhập kho vật liệu thừa',
    zh_tc: '餘料入庫碼',
    ru: 'Код складирования излишков',
    ko: '잔재 입고 코드',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်ကုဒ်',
    ben: 'উদ্বৃত্ত উপকরণ স্টোরেজ কোড',
    tr: 'Artık malzeme depo kodu',
    km: 'កូដចូលឃ្លាំងសល់',
    es: 'Código de almacenamiento de material restante',
    ar: 'رمز تخزين المواد المتبقية',
  },
  'surplusPage.generateQRCodeSuccess': {
    zh: '生成二维码成功',
    en: 'QR Code generated successfully',
    id: 'Kode QR berhasil dibuat',
    kz: 'QR код сәтті жасалды',
    th: 'สร้าง QR Code สำเร็จ',
    ug: 'QR كودى مۇۋەپپەقىيەتلىك يارىتىلدى',
    vi: 'Tạo mã QR thành công',
    zh_tc: '生成二維碼成功',
    ru: 'Создание QR - кода успешно',
    ko: 'QR코드 생성 성공',
    bur: 'QR ကုဒ်ဖန်တီးအောင်မြင်',
    ben: 'QR কোড সফলভাবে তৈরি হয়েছে',
    tr: 'QR kodu oluşturuldu',
    km: 'បង្កើតកូដ QR ជោគជ័យ',
    es: 'Generar exitosamente el código QR',
    ar: 'إنشاء رمز الاستجابة السريعة بنجاح',
  },
  'surplusPage.generateQRCodeFailed': {
    zh: '生成二维码失败',
    en: 'Failed to generate QR Code',
    id: 'Gagal membuat kode QR',
    kz: 'QR код жасау сәтсіз аяқталды',
    th: 'สร้าง QR Code ล้มเหลว',
    ug: 'QR كودى يارىتىش مەغلۇپ بولدى',
    vi: 'Tạo mã QR thất bại',
    zh_tc: '生成二維碼失敗',
    ru: 'Ошибка создания QR - кода',
    ko: 'QR코드 생성 실패',
    bur: 'QR ကုဒ်ဖန်တီးမမှုမအောင်မြင်',
    ben: 'QR কোড তৈরি করতে ব্যর্থ হয়েছে',
    tr: 'QR kodu oluşturulamadı',
    km: 'បង្កើតកូដ QR បរាជ័យ',
    es: 'No se pudo generar el código QR',
    ar: 'فشل في إنشاء رمز الاستجابة السريعة',
  },
  'surplusPage.refreshQRCode': {
    zh: '刷新二维码',
    en: 'Refresh QR Code',
    id: 'Segarkan Kode QR',
    kz: 'QR кодын жаңарту',
    th: 'รีเฟรช QR Code',
    ug: 'QR كودىنى يېڭىلاش',
    vi: 'Làm mới mã QR',
    zh_tc: '刷新二維碼',
    ru: 'Обновить QR - код',
    ko: 'QR코드 새로 고침',
    bur: 'QR ကုဒ်သစ်ကို',
    ben: 'QR কোড রিফ্রেশ করুন',
    tr: 'QR kodunu yenile',
    km: 'ធ្វើកូដ QR ឡើងវិញ',
    es: 'Actualizar el código QR',
    ar: 'تحديث رمز الاستجابة السريعة',
  },
  'surplusPage.refreshQRCodeFailed': {
    zh: '刷新二维码失败',
    en: 'Failed to refresh QR Code',
    id: 'Gagal menyegarkan kode QR',
    kz: 'QR кодын жаңарту сәтсіз аяқталды',
    th: 'รีเฟรช QR Code ล้มเหลว',
    ug: 'QR كودىنى يېڭىلاش مەغلۇپ بولدى',
    vi: 'Làm mới mã QR thất bại',
    zh_tc: '刷新二維碼失敗',
    ru: 'Ошибка обновления QR - кода',
    ko: 'QR코드 새로 고침 실패',
    bur: 'QR ကုဒ်သစ်ကိုမမှုမအောင်မြင်',
    ben: 'QR কোড রিফ্রেশ করতে ব্যর্থ হয়েছে',
    tr: 'QR kodu yenilenemedi',
    km: 'ធ្វើកូដ QR ឡើងវិញបរាជ័យ',
    es: 'No se pudo actualizar el código QR',
    ar: 'فشل تحديث رمز الاستجابة السريعة',
  },
  'surplusPage.cancelRefresh': {
    zh: '已取消刷新',
    en: 'Refresh cancelled',
    id: 'Pembaruan dibatalkan',
    kz: 'Жаңарту жойылды',
    th: 'ยกเลิกการรีเฟรช',
    ug: 'يېڭىلاش ئەمەلدىن قالدۇرۇلدى',
    vi: 'Đã hủy làm mới',
    zh_tc: '已取消刷新',
    ru: 'Обновление отменено.',
    ko: '새로 고침 취소됨',
    bur: 'သစ်ကိုဖျက်သိမ်း',
    ben: 'রিফ্রেশ বাতিল করা হয়েছে',
    tr: 'Yenileme iptal edildi',
    km: 'បានលុបការធ្វើឡើងវិញ',
    es: 'Actualización cancelada',
    ar: 'تم إلغاء التحديث',
  },
  'surplusPage.refreshQRCodeTip': {
    zh: '是否刷新二维码，刷新后当前二维码会失效。',
    en: 'Are you sure you want to refresh the QR code? The current QR code will become invalid after refresh.',
    id: 'Apakah Anda yakin ingin menyegarkan kode QR? Kode QR saat ini akan menjadi tidak valid setelah disegarkan.',
    kz: 'QR кодын жаңартқыңыз келе ме? Жаңартудан кейін ағымдағы QR код жарамсыз болады.',
    th: 'คุณต้องการรีเฟรช QR Code หรือไม่? QR Code ปัจจุบันจะหมดอายุหลังจากรีเฟรช',
    ug: 'QR كودىنى يېڭىلاشنى خالامسىز؟ يېڭىلاشتىن كېيىن نۆۋەتتىكى QR كودى ئىناۋەتسىز بولىدۇ.',
    vi: 'Bạn có muốn làm mới mã QR không? Mã QR hiện tại sẽ không còn hiệu lực sau khi làm mới.',
    zh_tc: '是否刷新二維碼，刷新後當前二維碼會失效。',
    ru: 'Обновить ли QR - код, текущий QR - код будет недействительным после обновления.',
    ko: 'QR코드를 새로 고칠지 여부, 새로 고침 후 현재 QR코드가 무효화됩니다.',
    bur: 'QR ကုဒ်သစ်ကိုမည်လား၊ သစ်ပြီးနောက်လက်ရှိ QR ကုဒ်မသုံးနိုင်တော့ပါ။',
    ben: 'QR কোড রিফ্রেশ করবেন? রিফ্রেশের পরে বর্তমান QR কোড অকার্যকর হয়ে যাবে।',
    tr: 'QR kodunu yenilemek istiyor musunuz? Yenilemeden sonra mevcut kod geçersiz olur.',
    km: 'ធ្វើកូដ QR ឡើងវិញឬ? កូដបច្ចុប្បន្ននឹងអស់សុពលភាពបន្ទាប់ពីធ្វើឡើងវិញ។',
    es: 'Si se actualiza el código QR. Después de actualizar, el código QR actual dejará de ser válido.',
    ar: 'ما إذا كان سيتم تحديث رمز الاستجابة السريعة. بعد التحديث، سيصبح رمز الاستجابة السريعة الحالي غير صالح.',
  },
  'surplusPage.refreshQRCodeConfirm': {
    zh: '确定',
    en: 'Confirm',
    id: 'Konfirmasi',
    kz: 'Растау',
    th: 'ยืนยัน',
    ug: 'جەزملەش',
    vi: 'Xác nhận',
    zh_tc: '確定',
    ru: 'определить',
    ko: '확정',
    bur: 'အတည်ပြု',
    ben: 'নিশ্চিত করুন',
    tr: 'Onayla',
    km: 'បញ្ជាក់',
    es: 'OK',
    ar: 'موافق',
  },
  'surplusPage.refreshQRCodeCancel': {
    zh: '取消',
    en: 'Cancel',
    id: 'Batal',
    kz: 'Болдырмау',
    th: 'ยกเลิก',
    ug: 'بىكار قىلىش',
    vi: 'Hủy',
    zh_tc: '取消',
    ru: 'отменить',
    ko: '취소',
    bur: 'ဖျက်သိမ်း',
    ben: 'বাতিল করুন',
    tr: 'İptal',
    km: 'បោះបង់',
    es: 'Cancelar',
    ar: 'إلغاء',
  },
  'surplusPage.wechatScanTip': {
    zh: '打开微信扫码可以手动添加余料入库使用',
    en: 'Open WeChat to scan QR code for manual surplus material storage',
    id: 'Buka WeChat untuk memindai QR code untuk menambahkan bahan sisa secara manual',
    kz: 'Артық материалды қолмен сақтау үшін WeChat ашып QR кодын сканерлеңіз',
    th: 'เปิด WeChat เพื่อสแกน QR Code เพื่อเพิ่มวัสดุส่วนเกินด้วยตนเอง',
    ug: 'قوشۇمچە ماتېرىيالنى قولدا ساقلاش ئۈچۈن WeChat ئېچىپ QR كودىنى سىكانىرلاش',
    vi: 'Mở WeChat để quét mã QR để thêm thủ công vật liệu thừa vào kho',
    zh_tc: '打開微信掃碼可以手動添加餘料入庫使用',
    ru: 'Открывая микросхему, можно вручную добавлять остатки в хранилище.',
    ko: '위챗을 열고 코드를 스캔하면 수동으로 여분의 재료를 추가하여 입고하여 사용할 수 있다',
    bur: 'WeChat ဖွင့်ပြီး QR ကုဒ်စကင်ဖတ်ကာပိုလျှံပစ္စည်းဂိုဒေါင်ကိုကိုယ်တိုင်ထည့်နိုင်',
    ben: 'WeChat খুলে QR কোড স্ক্যান করে ম্যানুয়ালি উদ্বৃত্ত উপকরণ গুদামে যোগ করতে পারবেন',
    tr: 'WeChat ile tarayıp artık malzemeyi elle depoya ekleyebilirsiniz',
    km: 'បើក WeChat ស្កេន QR ដើម្បីបន្ថែមសម្ភារៈសល់ដោយដៃចូលឃ្លាំង',
    es: 'Abra WeChat y escanee el código QR para agregar manualmente el material restante al almacén para su uso',
    ar: 'افتح WeChat وامسح رمز الاستجابة السريعة لإضافة المواد المتبقية يدويًا إلى المستودع لاستخدامها',
  },
  'surplusPage.deletSurplus': {
    zh: '删除余料',
    en: 'Delete Scrap',
    id: 'Hapus bahan yang tersisa',
    kz: 'Қалдықтарды жою',
    th: 'ลบวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال ئۆچۈرۈش',
    vi: 'Xóa dư liệu',
    zh_tc: '刪除餘料',
    ru: 'Удалить остатки',
    ko: '남은 재료를 삭제하다.',
    bur: 'ပိုလျှံပစ္စည်းဖျက်',
    ben: 'উদ্বৃত্ত মুছুন',
    tr: 'Artık malzemeyi sil',
    km: 'លុបសម្ភារៈសល់',
    es: 'Eliminar el material restante',
    ar: 'حذف المادة المتبقية',
  },
  'surplusPage.editSurplus': {
    zh: '修改余料',
    en: 'Edit Surplus',
    id: 'Ubah bahan yang tersisa',
    kz: 'Қалдықты өзгерту',
    th: 'ปรับเปลี่ยนวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيالنى تەھرىرلەش',
    vi: 'Chỉnh sửa dư liệu',
    zh_tc: '修改餘料',
    ru: 'Изменение остатков',
    ko: '남은 재료 수정',
    bur: 'ပိုလျှံပစ္စည်းပြင်',
    ben: 'উদ্বৃত্ত সম্পাদনা করুন',
    tr: 'Artık malzemeyi düzenle',
    km: 'កែសម្ភារៈសល់',
    es: 'Modificar el material restante',
    ar: 'تعديل المادة المتبقية',
  },
  'surplusPage.surplusNoRoll': {
    zh: '启用余料不翻板加工',
    en: 'Enable Scrap Processing Without Re-rolling',
    id: 'Aktifkan bahan residu tanpa mencetak ulang',
    kz: 'Қалдықтарды қайтадан кесуді іске қосу',
    th: 'เปิดใช้งานวัสดุที่เหลือโดยไม่ต้องพิมพ์ซ้ำ',
    ug: 'قالدۇق ماتېرىيال تەتۈرلەشمەسلىك ئىقتىدارىنى قوزغىتىش',
    vi: 'Kích hoạt chế biến dư liệu không đảo ván',
    zh_tc: '啟用餘料不翻板加工',
    ru: 'Включить обработку без копирования',
    ko: '남은 재료는 복제하지 않고 가공한다.',
    bur: 'ပိုလျှံပစ္စည်းပြန်မဖြတ်စီမံမှုဖွင့်',
    ben: 'উদ্বৃত্ত পুনর্মুদ্রণ ছাড়া প্রক্রিয়াকরণ সক্ষম করুন',
    tr: 'Yeniden haddelenmeden artık malzeme işlemesini etkinleştir',
    km: 'បើកដំណើរការសម្ភារៈសល់ដោយមិនបត់បែនឡើងវិញ',
    es: 'Habilitar el material restante sin copiar',
    ar: 'تمكين المادة المتبقية دون نسخ',
  },
  'surplusPage.type.all': {
    zh: '全部形状',
    en: 'All Shapes',
    id: 'Semua bentuk',
    kz: 'Барлық пішіндер',
    th: 'รูปร่างทั้งหมด',
    ug: 'ھەممە شەكىل',
    vi: 'Tất cả hình dạng',
    zh_tc: '全部形狀',
    ru: 'Все формы',
    ko: '모든 모양',
    bur: 'ပုံသဏ္ဍာန်အားလုံး',
    ben: 'সব আকৃতি',
    tr: 'Tüm şekiller',
    km: 'រូបរាងទាំងអស់',
    es: 'Todas las formas',
    ar: 'جميع الأشكال',
  },
  'surplusPage.allMatcode': {
    zh: '全部材质',
    en: 'All Materials',
    id: 'Semua bahan',
    kz: 'Барлық матеріалдар',
    th: 'วัสดุทั้งหมด',
    ug: 'ھەممە ماتېرىيال',
    vi: 'Tất cả chất liệu',
    zh_tc: '全部材質',
    ru: 'Все материалы',
    ko: '모든 재료',
    bur: 'ပစ္စည်းအားလုံး',
    ben: 'সব উপকরণ',
    tr: 'Tüm malzemeler',
    km: 'សម្ភារៈទាំងអស់',
    es: 'Todos los materiales',
    ar: 'جميع المواد',
  },
  'surplusPage.allThick': {
    zh: '全部厚度',
    en: 'All Thicknesses',
    id: 'Semua ketebalan',
    kz: 'Барлық қалыңдықтар',
    th: 'ความหนาทั้งหมด',
    ug: 'ھەممە قېلىنلىق',
    vi: 'Tất cả độ dày',
    zh_tc: '全部厚度',
    ru: 'Полная толщина',
    ko: '전체 두께',
    bur: 'အထူအားလုံး',
    ben: 'সব পুরুত্ব',
    tr: 'Tüm kalınlıklar',
    km: 'កម្រាស់ទាំងអស់',
    es: 'Todos los espesores',
    ar: 'جميع السماكات',
  },
  'surplusPage.surplusName': {
    zh: '余料名称',
    en: 'Scrap Name',
    id: 'Nama bahan yang tersisa',
    kz: 'Қалдықтар атауы',
    th: 'ชื่อของวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال ئىسمى',
    vi: 'Tên dư liệu',
    zh_tc: '餘料名稱',
    ru: 'Название остатка',
    ko: '나머지 재료 이름',
    bur: 'ပိုလျှံပစ္စည်းအမည်',
    ben: 'উদ্বৃত্তের নাম',
    tr: 'Artık malzeme adı',
    km: 'ឈ្មោះសម្ភារៈសល់',
    es: 'Nombre del material restante',
    ar: 'اسم المادة المتبقية',
  },
  'surplusPage.rectSurplus': {
    zh: '矩形余料',
    en: 'Rectangular Surplus',
    id: 'Bahan residu persegi panjang',
    kz: 'Тікбұрышты қалдық',
    th: 'วัสดุที่เหลือเป็นรูปสี่เหลี่ยมผืนผ้า',
    ug: 'تۆت تەرەپلىك قالدۇق ماتېرىيال',
    vi: 'Dư liệu hình chữ nhật',
    zh_tc: '矩形餘料',
    ru: 'прямоугольный остаток',
    ko: '직사각형 여분',
    bur: 'ဆေးကွက်ပုံပိုလျှံပစ္စည်း',
    ben: 'আয়তাকার উদ্বৃত্ত',
    tr: 'Dikdörtgen artık',
    km: 'សម្ភារៈសល់រាងចតុកោណ',
    es: 'Material restante rectangular',
    ar: 'المادة المتبقية مستطيلة',
  },
  'surplusPage.LTypeSurplus': {
    zh: 'L形余料',
    en: 'L-shaped Surplus',
    id: 'Bahan residu berbentuk L.',
    kz: 'L-тәрізді қалдық',
    th: 'วัสดุตกค้างรูปตัว L',
    ug: 'L شەكىللىك قالدۇق ماتېرىيال',
    vi: 'Dư liệu hình chữ L',
    zh_tc: 'L形餘料',
    ru: 'Л - образный остаток',
    ko: 'L형 여분',
    bur: 'L ပုံသဏ္ဍာန်ပိုလျှံပစ္စည်း',
    ben: 'L আকৃতির উদ্বৃত্ত',
    tr: 'L şeklinde artık',
    km: 'សម្ភារៈសល់រាង L',
    es: 'L material remanente con forma',
    ar: 'L مادة متبقية ذات شكل',
  },
  'surplusPage.noMatchSup': {
    zh: '未查询到相关数据',
    en: 'No relevant data found',
    id: 'Tidak ada data yang relevan yang ditemukan',
    kz: 'Қатысты деректер табылмады',
    th: 'ไม่พบข้อมูลที่เกี่ยวข้อง',
    ug: 'ئۇچۇر تېپىلمىدى',
    vi: 'Không tìm thấy dữ liệu liên quan',
    zh_tc: '未查詢到相關數據',
    ru: 'Соответствующие данные не запрашивались',
    ko: '관련 데이터가 질의되지 않았습니다.',
    bur: 'သက်ဆိုင်ရာဒေတာမတွေ့',
    ben: 'সংশ্লিষ্ট ডেটা পাওয়া যায়নি',
    tr: 'İlgili veri bulunamadı',
    km: 'រកមិនឃើញទិន្នន័យពាក់ព័ន្ធ',
    es: 'No se encontraron datos relevantes',
    ar: 'لم يتم العثور على بيانات ذات صلة',
  },
  'surplusPage.jumpTo': {
    zh: '跳至',
    en: 'Jump to',
    id: 'Melompat ke',
    kz: 'Өту',
    th: 'ข้ามไป',
    ug: 'بۇ يەرگە سەكرەش',
    vi: 'Chuyển đến',
    zh_tc: '跳至',
    ru: 'Перейти',
    ko: '다음으로 건너뛰기',
    bur: 'ကျော်သွား',
    ben: 'যান',
    tr: 'Git',
    km: 'ទៅ',
    es: 'Saltar a',
    ar: 'انتقل إلى',
  },
  'surplusPage.page': {
    zh: '页',
    en: 'Page',
    id: 'Halaman',
    kz: 'Бет',
    th: 'หน้าหนังสือ',
    ug: 'بەت',
    vi: 'Trang',
    zh_tc: '頁',
    ru: 'страница',
    ko: '페이지',
    bur: 'စာမျက်နှာ',
    ben: 'পৃষ্ঠা',
    tr: 'Sayfa',
    km: 'ទំព័រ',
    es: 'Página',
    ar: 'الصفحة',
  },
  'surplusPage.newMatcode': {
    zh: '新建材质',
    en: 'Create New Material',
    id: 'Bahan bangunan baru',
    kz: 'Жаңа материал жасау',
    th: 'วัสดุก่อสร้างใหม่',
    ug: 'يېڭى ماتېرىيال قۇرۇش',
    vi: 'Tạo mới chất liệu',
    zh_tc: '新建材質',
    ru: 'Новые материалы',
    ko: '새 재료',
    bur: 'ပစ္စည်းအသစ်ဆောက်',
    ben: 'নতুন উপকরণ তৈরি করুন',
    tr: 'Yeni malzeme oluştur',
    km: 'បង្កើតសម្ភារៈថ្មី',
    es: 'Nuevo material',
    ar: 'مادة جديدة',
  },
  'surplusPage.newColor': {
    zh: '新建颜色',
    en: 'Create New Color',
    id: 'Buat Warna Baru',
    kz: 'Жаңа түс жасау',
    th: 'สร้างสีใหม่',
    ug: 'يېڭى رەڭ قۇرۇش',
    vi: 'Tạo mới màu sắc',
    zh_tc: '新建顏色',
    ru: 'Новый цвет',
    ko: '새 색상',
    bur: 'အရောင်အသစ်ဆောက်',
    ben: 'নতুন রঙ তৈরি করুন',
    tr: 'Yeni renk oluştur',
    km: 'បង្កើតពណ៌ថ្មី',
    es: 'Nuevo color',
    ar: 'لون جديد',
  },
  'surplusPage.autoCreateColor': {
    zh: '按回车将自动创建色卡',
    en: 'Press Enter to automatically create a color card',
    id: 'Tekan Enter untuk secara otomatis membuat kartu warna',
    kz: 'Enter батырмасын басқанда автоматты түрде түстік карта жасалады',
    th: 'กด Enter เพื่อสร้างการ์ดสีโดยอัตโนมัติ',
    ug: 'Enter كۇنپۇكىنى بېسىپ رەڭ خىتىنى ئاپتوماتىك قۇرالايسىز',
    vi: 'Nhấn Enter để tự động tạo màu sẵn',
    zh_tc: '按回車將自動創建色卡',
    ru: 'Нажмите обратно, чтобы автоматически создать цветовую карту',
    ko: 'Enter 키를 누르면 색상 카드가 자동으로 생성됩니다.',
    bur: 'Enter နှိပ်ပြီးအလိုအလျောက်အရောင်ကဒ်ဖန်တီး',
    ben: 'Enter চাপলে স্বয়ংক্রিয়ভাবে রঙ কার্ড তৈরি হবে',
    tr: 'Enter tuşuna basınca renk kartı otomatik oluşturulur',
    km: 'ចុច Enter ដើម្បីបង្កើតកាតពណ៌ស្វ័យប្រវត្តិ',
    es: 'Presione Enter para crear automáticamente una tarjeta de color',
    ar: 'اضغط على Enter لإنشاء بطاقة ألوان تلقائيًا',
  },
  'surplusPage.nameLimit': {
    zh: '余料名称最多输入10个字',
    en: 'Surplus name can contain up to 10 characters',
    id: 'Masukkan hingga 10 kata dengan nama materi yang tersisa',
    kz: 'Қалдық атауы ең көп дегенде 10 таңбадан тұруы мүмкін',
    th: 'ป้อนมากถึง 10 คำในชื่อวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال ئىمى ئەڭ كۆپ 10 ھەرپ كىرگۈزۈشكە بولىدۇ',
    vi: 'Tên dư liệu tối đa 10 ký tự',
    zh_tc: '餘料名稱最多輸入10個字',
    ru: 'Введите до 10 имен.',
    ko: '나머지 재료 이름 최대 10자 입력',
    bur: 'ပိုလျှံပစ္စည်းအမည်တွင်စကားလုံး ၁၀ လုံးသာထည့်နိုင်',
    ben: 'উদ্বৃত্তের নামে সর্বোচ্চ ১০ অক্ষর লেখা যাবে',
    tr: 'Artık ad en fazla 10 karakter',
    km: 'ឈ្មោះសល់អតិបរមា ១០ តួអក្សរ',
    es: 'Ingrese hasta 10 caracteres para el nombre del material remanente',
    ar: 'أدخل ما يصل إلى 10 أحرف لاسم المادة المتبقية',
  },
  'surplusPage.nameLimitNameErr': {
    zh: '余料名称不能为空',
    en: 'Surplus name cannot be empty',
    id: 'Nama materi yang tersisa tidak bisa kosong',
    kz: 'Қалдық атауы бос болмауы керек',
    th: 'ชื่อวัสดุที่เหลือไม่สามารถว่างเปล่า',
    ug: 'قالدۇق ماتېرىيال ئىسمى بوش قالمايدۇ',
    vi: 'Tên dư liệu không được để trống',
    zh_tc: '餘料名稱不能為空',
    ru: 'Название не может быть пустым.',
    ko: '나머지 재료 이름은 비워둘 수 없습니다.',
    bur: 'ပိုလျှံပစ္စည်းအမည်မဟာမဆ',
    ben: 'উদ্বৃত্তের নাম খালি রাখা যাবে না',
    tr: 'Artık ad boş olamaz',
    km: 'ឈ្មោះសល់មិនអាចទទេ',
    es: 'El nombre del material remanente no puede estar vacío',
    ar: 'لا يمكن أن يكون اسم المادة المتبقية فارغًا',
  },
  'surplusPage.tempLongTip': {
    zh: '板材长度只能输入数字',
    en: 'Plank length can only contain numbers',
    id: 'Hanya angka yang dapat dimasukkan dalam panjang papan',
    kz: 'Тақтай ұзындығы тек сандардан тұруы керек',
    th: 'สามารถป้อนตัวเลขได้ตามความยาวของบอร์ดเท่านั้น',
    ug: 'تاختا ئۇزۇنلۇقى پەقەت رەقەم كىرگۈزۈشكە بولىدۇ',
    vi: 'Chiều dài tấm chỉ được nhập số',
    zh_tc: '板材長度只能輸入數字',
    ru: 'Длина листа может быть только цифрами.',
    ko: '판재 길이는 숫자만 입력할 수 있습니다.',
    bur: 'ပေါ်ဒ်အရှည်တွင်ကိန်းဂဏန်းသာထည့်နိုင်',
    ben: 'বোর্ডের দৈর্ঘ্যে শুধুমাত্র সংখ্যা লেখা যাবে',
    tr: 'Levha uzunluğunda yalnızca sayı',
    km: 'ប្រវែងផ្ទាំងបញ្ចូលបានតែលេខ',
    es: 'Solo se pueden ingresar números para la longitud de la placa',
    ar: 'يمكن إدخال أرقام فقط بطول اللوحة',
  },
  'surplusPage.minLongLimit': {
    zh: '短边长度只能输入数字',
    en: 'Short side length can only contain numbers',
    id: 'Hanya angka yang dapat dimasukkan dalam panjang sisi pendek',
    kz: 'Қысқа жақ ұзындығы тек сандардан тұруы керек',
    th: 'สามารถป้อนตัวเลขได้ในระยะสั้น ๆ',
    ug: 'قىسقا تەرەپ ئۇزۇنلۇقى پەقەت رەقەم كىرگۈزۈشكە بولىدۇ',
    vi: 'Chiều dài cạnh ngắn chỉ được nhập số',
    zh_tc: '短邊長度只能輸入數字',
    ru: 'Короткая длина может вводить только цифры.',
    ko: '짧은 모서리 길이는 숫자만 입력할 수 있습니다.',
    bur: 'တိုတောင်းဘက်အရှည်တွင်ကိန်းဂဏန်းသာထည့်နိုင်',
    ben: 'ছোট বাহুর দৈর্ঘ্যে শুধুমাত্র সংখ্যা লেখা যাবে',
    tr: 'Kısa kenar uzunluğunda yalnızca sayı',
    km: 'ប្រវែងគែមខ្លីបញ្ចូលបានតែលេខ',
    es: 'Solo números se puede ingresar para la longitud del lado corto',
    ar: 'يمكن إدخال أرقام فقط تم إدخاله لطول الجانب القصير',
  },
  'surplusPage.minLongEmptyTip': {
    zh: '短边长度不能为空',
    en: 'Short side length cannot be empty',
    id: 'Panjang sisi pendek tidak bisa kosong',
    kz: 'Қысқа жақ ұзындығы бос болмауы керек',
    th: 'ความยาวด้านสั้นไม่สามารถว่างเปล่าได้',
    ug: 'قىسقا تەرەپ ئۇزۇنلۇقى بوش قالمايدۇ',
    vi: 'Chiều dài cạnh ngắn không được để trống',
    zh_tc: '短邊長度不能為空',
    ru: 'Длина короткая не может быть пустой.',
    ko: '짧은 모서리 길이는 비워둘 수 없습니다.',
    bur: 'တိုတောင်းဘက်အရှည်မဟာမဆ',
    ben: 'ছোট বাহুর দৈর্ঘ্য খালি রাখা যাবে না',
    tr: 'Kısa kenar uzunluğu boş olamaz',
    km: 'ប្រវែងគែមខ្លីមិនអាចទទេ',
    es: 'La longitud del lado corto no puede estar vacía',
    ar: 'لا يمكن أن يكون طول الجانب القصير فارغًا',
  },
  'surplusPage.minLongLimitMax': {
    zh: '短边长度不能超过板材长度',
    en: 'Short side length cannot exceed plank length',
    id: 'Panjang sisi pendek tidak dapat melebihi panjang papan',
    kz: 'Қысқа жақ ұзындығы тақтай ұзындығынан аспауы керек',
    th: 'ความยาวของด้านสั้นไม่เกินความยาวของบอร์ด',
    ug: 'قىسقا تەرەپ ئۇزۇنلۇقى تاختا ئۇزۇنلۇقىدىن ئاشمايدۇ',
    vi: 'Chiều dài cạnh ngắn không được vượt quá chiều dài tấm',
    zh_tc: '短邊長度不能超過板材長度',
    ru: 'Длина короткая не должна превышать длину листа.',
    ko: '짧은 모서리 길이는 판재 길이를 초과할 수 없다',
    bur: 'တိုတောင်းဘက်အရှည်သည်ပေါ်ဒ်အရှည်ကိုမကျော်နိုင်',
    ben: 'ছোট বাহুর দৈর্ঘ্য বোর্ডের দৈর্ঘ্য অতিক্রম করতে পারবে না',
    tr: 'Kısa kenar uzunluğu levha uzunluğunu aşamaz',
    km: 'ប្រវែងគែមខ្លីមិនអាចលើសប្រវែងផ្ទាំង',
    es: 'La longitud del lado corto no puede exceder la longitud de la placa',
    ar: 'لا يمكن أن يتجاوز طول الجانب القصير طول اللوحة',
  },
  'surplusPage.widthLimit': {
    zh: '板材宽度只能输入数字',
    en: 'Plank width can only contain numbers',
    id: 'Hanya angka yang dapat dimasukkan dalam lebar papan',
    kz: 'Тақтай ені тек сандардан тұруы керек',
    th: 'สามารถป้อนตัวเลขได้เท่านั้นในความกว้างของบอร์ด',
    ug: 'تاختا كەڭلىكى پەقەت رەقەم كىرگۈزۈشكە بولىدۇ',
    vi: 'Chiều rộng tấm chỉ được nhập số',
    zh_tc: '板材寬度只能輸入數字',
    ru: 'Ширина листа может быть только цифрами.',
    ko: '판재 너비는 숫자만 입력할 수 있다',
    bur: 'ပေါ်ဒ်အကျယ်တွင်ကိန်းဂဏန်းသာထည့်နိုင်',
    ben: 'বোর্ডের প্রস্থে শুধুমাত্র সংখ্যা লেখা যাবে',
    tr: 'Levha genişliğinde yalnızca sayı',
    km: 'ទទឹងផ្ទាំងបញ្ចូលបានតែលេខ',
    es: 'El ancho de la placa solo puede ingresar números',
    ar: 'يمكن لعرض اللوحة إدخال أرقام فقط',
  },
  'surplusPage.minWidthLimit': {
    zh: '短边宽度只能输入数字',
    en: 'Short side width can only contain numbers',
    id: 'Hanya angka yang dapat dimasukkan dalam lebar sisi pendek',
    kz: 'Қысқа жақ ені тек сандардан тұруы керек',
    th: 'สามารถป้อนตัวเลขได้เฉพาะในความกว้างด้านสั้น ๆ',
    ug: 'قىسقا تەرەپ كەڭلىكى پەقەت رەقەم كىرگۈزۈشكە بولىدۇ',
    vi: 'Chiều rộng cạnh ngắn chỉ được nhập số',
    zh_tc: '短邊寬度只能輸入數字',
    ru: 'Короткая ширина может вводить только цифры.',
    ko: '짧은 모서리 너비는 숫자만 입력할 수 있습니다.',
    bur: 'တိုတောင်းဘက်အကျယ်တွင်ကိန်းဂဏန်းသာထည့်နိုင်',
    ben: 'ছোট বাহুর প্রস্থে শুধুমাত্র সংখ্যা লেখা যাবে',
    tr: 'Kısa kenar genişliğinde yalnızca sayı',
    km: 'ទទឹងគែមខ្លីបញ្ចូលបានតែលេខ',
    es: 'El ancho del lado corto solo puede ingresar números',
    ar: 'يمكن لعرض الجانب القصير إدخال أرقام فقط',
  },
  'surplusPage.minWidthEmptyLimit': {
    zh: '短边宽度不能为空',
    en: 'Short side width cannot be empty',
    id: 'Lebar sisi pendek tidak bisa kosong',
    kz: 'Қысқа жақ ені бос болмауы керек',
    th: 'ความกว้างด้านสั้นไม่สามารถว่างเปล่าได้',
    ug: 'قىسقا تەرەپ كەڭلىكى بوش قالمايدۇ',
    vi: 'Chiều rộng cạnh ngắn không được để trống',
    zh_tc: '短邊寬度不能為空',
    ru: 'Короткая сторона не может быть пустой.',
    ko: '짧은 모서리 너비는 비워둘 수 없습니다.',
    bur: 'တိုတောင်းဘက်အကျယ်မဟာမဆ',
    ben: 'ছোট বাহুর প্রস্থ খালি রাখা যাবে না',
    tr: 'Kısa kenar genişliği boş olamaz',
    km: 'ទទឹងគែមខ្លីមិនអាចទទេ',
    es: 'El ancho del lado corto no puede estar vacío',
    ar: 'لا يمكن أن يكون عرض الجانب القصير فارغًا',
  },
  'surplusPage.minWidthLimitMax': {
    zh: '短边宽度不能超过板材宽度',
    en: 'Short side width cannot exceed plank width',
    id: 'Lebar sisi pendek tidak dapat melebihi lebar papan',
    kz: 'Қысқа жақ ені тақтай енінен аспауы керек',
    th: 'ความกว้างของด้านสั้นไม่เกินความกว้างของบอร์ด',
    ug: 'قىسقا تەرەپ كەڭلىكى تاختا كەڭلىكىدىن ئاشمايدۇ',
    vi: 'Chiều rộng cạnh ngắn không được vượt quá chiều rộng tấm',
    zh_tc: '短邊寬度不能超過板材寬度',
    ru: 'Ширина короткая не должна превышать ширины листа.',
    ko: '짧은 모서리 너비는 판재 너비를 초과할 수 없다',
    bur: 'တိုတောင်းဘက်အကျယ်သည်ပေါ်ဒ်အကျယ်ကိုမကျော်နိုင်',
    ben: 'ছোট বাহুর প্রস্থ বোর্ডের প্রস্থ অতিক্রম করতে পারবে না',
    tr: 'Kısa kenar genişliği levha genişliğini aşamaz',
    km: 'ទទឹងគែមខ្លីមិនអាចលើសទទឹងផ្ទាំង',
    es: 'El ancho del lado corto no puede exceder el ancho de la placa',
    ar: 'لا يمكن أن يتجاوز عرض الجانب القصير عرض اللوحة',
  },
  'surplusPage.thickLimit': {
    zh: '板材厚度只能输入数字',
    en: 'Plank thickness can only contain numbers',
    id: 'Hanya angka yang dapat dimasukkan dalam ketebalan papan',
    kz: 'Тақтай қалыңдығы тек сандардан тұруы керек',
    th: 'สามารถป้อนตัวเลขได้เท่านั้นในความหนาของบอร์ด',
    ug: 'تاختا قېلىنلىقى پەقەت رەقەم كىرگۈزۈشكە بولىدۇ',
    vi: 'Độ dày tấm chỉ được nhập số',
    zh_tc: '板材厚度只能輸入數字',
    ru: 'Толщина листа может быть только цифрами.',
    ko: '판재 두께는 숫자만 입력할 수 있습니다.',
    bur: 'ပေါ်ဒ်အထူတွင်ကိန်းဂဏန်းသာထည့်နိုင်',
    ben: 'বোর্ডের পুরুত্বে শুধুমাত্র সংখ্যা লেখা যাবে',
    tr: 'Levha kalınlığında yalnızca sayı',
    km: 'កម្រាស់ផ្ទាំងបញ្ចូលបានតែលេខ',
    es: 'El espesor de la placa solo puede ingresar números',
    ar: 'يمكن لسمك اللوحة إدخال أرقام فقط',
  },
  'surplusPage.thickEmptyLimit': {
    zh: '板材厚度不能为空',
    en: 'Plank thickness cannot be empty',
    id: 'Ketebalan pelat tidak bisa kosong',
    kz: 'Тақтай қалыңдығы бос болмауы керек',
    th: 'ความหนาของแผ่นไม่สามารถว่างเปล่า',
    ug: 'تاختا قېلىنلىقى بوش قالمايدۇ',
    vi: 'Độ dày tấm không được để trống',
    zh_tc: '板材厚度不能為空',
    ru: 'Толщина листа не должна быть пустой.',
    ko: '판재 두께는 비워둘 수 없다',
    bur: 'ပေါ်ဒ်အထူမဟာမဆ',
    ben: 'বোর্ডের পুরুত্ব খালি রাখা যাবে না',
    tr: 'Levha kalınlığı boş olamaz',
    km: 'កម្រាស់ផ្ទាំងមិនអាចទទេ',
    es: 'El espesor de la placa no puede estar vacío',
    ar: 'لا يمكن أن يكون سمك اللوحة فارغًا',
  },
  'surplusPage.countInputLimit': {
    zh: '数量只能为正整数',
    en: 'Quantity must be a positive integer',
    id: 'Jumlahnya hanya bisa menjadi bilangan bulat positif',
    kz: 'Саны оң бүтін сан болуы керек',
    th: 'จำนวนสามารถเป็นจำนวนเต็มบวกเท่านั้น',
    ug: 'سان پەقەت پۈتۈن سان كىرگۈزۈشكە بولىدۇ',
    vi: 'Số lượng chỉ được là số nguyên dương',
    zh_tc: '數量只能為正整數',
    ru: 'Количество может быть только положительным.',
    ko: '수량은 양의 정수만 가능합니다.',
    bur: 'အရေအတွက်သည်ဒဿမမရသောအပေါင်းကိန်းသာဖြစ်နိုင်',
    ben: 'পরিমাণ অবশ্যই ধনাত্মক পূর্ণসংখ্যা হতে হবে',
    tr: 'Miktar yalnızca pozitif tam sayı',
    km: 'បរិមាណត្រូវជាគត់ធម្មជាតិវិជ្ជមាន',
    es: 'La cantidad solo puede ser un número entero positivo',
    ar: 'يمكن أن تكون الكمية عددًا صحيحًا موجبًا فقط',
  },
  'surplusPage.countEmptyLimit': {
    zh: '数量不能为空',
    en: 'Quantity cannot be empty',
    id: 'Kuantitasnya tidak bisa kosong',
    kz: 'Саны бос болмауы керек',
    th: 'ปริมาณไม่สามารถว่างเปล่า',
    ug: 'سان بوش قالمايدۇ',
    vi: 'Số lượng không được để trống',
    zh_tc: '數量不能為空',
    ru: 'Количество не может быть пустым.',
    ko: '수량은 비워둘 수 없습니다.',
    bur: 'အရေအတွက်မဟာမဆ',
    ben: 'পরিমাণ খালি রাখা যাবে না',
    tr: 'Miktar boş olamaz',
    km: 'បរិមាណមិនអាចទទេ',
    es: 'La cantidad no puede estar vacía',
    ar: 'لا يمكن أن تكون الكمية فارغة',
  },
  'surplusPage.remarkMaxlimit': {
    zh: '备注最多输入50个字',
    en: 'Remarks can contain up to 50 characters',
    id: 'Masukkan hingga 50 kata dalam catatan',
    kz: 'Ескертулер ең көп дегенде 50 таңбадан тұруы мүмкін',
    th: 'ป้อนคำศัพท์ได้มากถึง 50 คำในบันทึกย่อ',
    ug: 'ئىزاھات ئەڭ كۆپ 50 ھەرپ كىرگۈزۈشكە بولىدۇ',
    vi: 'Ghi chú tối đa 50 ký tự',
    zh_tc: '備註最多輸入50個字',
    ru: 'Введите до 50 слов.',
    ko: '메모 최대 50자 입력',
    bur: 'မှတ်ချက်တွင်စကားလုံး ၅၀ လုံးသာထည့်နိုင်',
    ben: 'মন্তব্যে সর্বোচ্চ ৫০ অক্ষর লেখা যাবে',
    tr: 'Not en fazla 50 karakter',
    km: 'កំណត់សម្គាល់អតិបរមា ៥០ តួ',
    es: 'Se pueden ingresar comentarios de hasta 50 caracteres',
    ar: 'يمكن إدخال الملاحظات حتى 50 حرفًا',
  },
  'surplusPage.orderAddressMaxlimit': {
    zh: '来源订单地址最多输入100个字',
    en: 'The source order address can be up to 100 characters',
    id: 'Masukkan hingga 100 kata dari alamat pesanan sumber',
    kz: 'Дереккөз тапсырыс мекенжайы 100 таң',
    th: 'ป้อนคำศัพท์ได้มากถึง 100 คำจากที่อยู่ลำดับต้นทาง',
    ug: 'مەنبەلىك زاكاز ئادرېسى ئەڭ كۆپ 100 ھەرپ كىرگۈزۈشكە بولىدۇ',
    vi: 'Địa chỉ đơn hàng nguồn có thể nhập tối đa 100 ký tự',
    zh_tc: '來源訂單地址最多輸入100個字',
    ru: 'Введите до 100 слов в адрес заказа.',
    ko: '소스 주문 주소 최대 100자 입력',
    bur: 'မူရင်းမှာယူမှုလိပ်စာတွင်စကားလုံး ၁၀၀ သာထည့်နိုင်',
    ben: 'উৎস অর্ডারের ঠিকানায় সর্বোচ্চ ১০০ অক্ষর লেখা যাবে',
    tr: 'Kaynak sipariş adresi en fazla 100 karakter',
    km: 'អាសយដ្ឋានការបញ្ជារប្រភពអតិបរមា ១០០ តួ',
    es: 'La dirección del pedido de origen se puede ingresar de hasta 100 caracteres',
    ar: 'يمكن إدخال عنوان أمر المصدر حتى 100 حرف',
  },
  'surplusPage.orderIdMaxlimit': {
    zh: '来源订单号最多输入100个字',
    en: 'The source order number can be up to 100 characters',
    id: 'Masukkan hingga 100 kata dari nomor pesanan sumber',
    kz: 'Дереккөз тапсырыс нөмірі 100 таң',
    th: 'ป้อนคำศัพท์ได้มากถึง 100 คำ',
    ug: 'مەنبەلىك زاكاز نومۇرى ئەڭ كۆپ 100 ھەرپ كىرگۈزۈشكە بولىدۇ',
    vi: 'Số đơn hàng nguồn có thể nhập tối đa 100 ký tự',
    zh_tc: '來源訂單號最多輸入100個字',
    ru: 'Введите до 100 слов в номер заказа.',
    ko: '소스 주문 번호 최대 100자 입력',
    bur: 'မူရင်းမှာယူမှုနံပါတ်တွင်စကားလုံး ၁၀၀ သာထည့်နိုင်',
    ben: 'উৎস অর্ডার নম্বরে সর্বোচ্চ ১০০ অক্ষর লেখা যাবে',
    tr: 'Kaynak sipariş no en fazla 100 karakter',
    km: 'លេខការបញ្ជារប្រភពអតិបរមា ១០០ តួ',
    es: 'El número de pedido de origen se puede ingresar de hasta 100 caracteres',
    ar: 'يمكن إدخال رقم أمر المصدر حتى 100 حرف',
  },
  'surplusPage.createTime': {
    zh: '添加时间',
    en: 'Creation Time',
    id: 'Tambahkan waktu',
    kz: 'Thời gian thêm',
    th: 'เพิ่มเวลา',
    ug: 'قوشۇلغان ۋاقىت',
    vi: 'Thời gian thêm',
    zh_tc: '添加時間',
    ru: 'Добавить время',
    ko: '시간 추가',
    bur: 'ထည့်ဝင်ချိန်',
    ben: 'যোগ করার সময়',
    tr: 'Eklenme zamanı',
    km: 'ពេលវេលាបន្ថែម',
    es: 'Agregar hora',
    ar: 'أضف الوقت',
  },
  'surplusPage.deleteTime': {
    zh: '删除时间',
    en: 'Delete Time',
    id: 'Hapus Waktu',
    kz: 'Silinme vakati',
    th: 'ลบเวลา',
    ug: 'ئېچىلىش ۋاقىتى',
    vi: 'Thời gian xóa',
    zh_tc: '刪除時間',
    ru: 'Время удаления',
    ko: '삭제 시간',
    bur: 'ဖယ်ရှားသည့် အချိန်',
    ben: 'মুছে ফেলার সময়',
    tr: 'Silme zamanı',
    km: 'ពេលវេលាលុប',
    es: 'Tiempo de eliminación',
    ar: 'وقت الحذف',
  },
  'surplusPage.deleteReason': {
    zh: '删除原因',
    en: 'Delete Reason',
    id: 'Alasan Penghapusan',
    kz: 'Silinme səbəbi',
    th: 'เหตุผลการลบ',
    ug: 'ئېچىلىش سببى',
    vi: 'Lý do xóa',
    zh_tc: '刪除原因',
    ru: 'Причина удаления',
    ko: '삭제 이유',
    bur: 'ဖယ်ရှားသည့် မှတ်ချက်',
    ben: 'মুছে ফেলার কারণ',
    tr: 'Silme nedeni',
    km: 'ការលុបសម្រាប់ការសម្រាប់',
    es: 'Razón de eliminación',
    ar: 'سبب الحذف',
  },
  'surplusPage.branchName': {
    zh: '所在余料库',
    en: 'Surplus Material Warehouse',
    id: 'Gudang bahan yang tersisa',
    kz: 'Kho dư liệu',
    th: 'คลังสินค้าวัสดุที่เหลืออยู่',
    ug: 'تەۋە بولغان قالدۇق ماتېرىيال ئامبىرى',
    vi: 'Kho dư liệu',
    zh_tc: '所在餘料庫',
    ru: 'Склад остаточных материалов',
    ko: '소재 여분 재료 창고',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ရှိသောနေရာ',
    ben: 'যে উদ্বৃত্ত গুদামে আছে',
    tr: 'Bulunduğu artık deposu',
    km: 'ឃ្លាំងសល់ដែលស្ថិតនៅ',
    es: 'Almacén de material residual',
    ar: 'مستودع المواد المتبقية',
  },
  'surplusPage.orderAddress': {
    zh: '来源订单地址',
    en: 'Source order address',
    id: 'Alamat Pesanan Sumber',
    kz: 'Дереккөз тапсырыс мекенжайы',
    th: 'ที่อยู่ลำดับต้นทาง',
    ug: 'مەنبەلىك زاكاز ئادرېسى',
    vi: 'Địa chỉ đơn hàng nguồn',
    zh_tc: '來源訂單地址',
    ru: 'Адрес заказа источника',
    ko: '소스 주문 주소',
    bur: 'မူရင်းမှာယူမှုလိပ်စာ',
    ben: 'উৎস অর্ডারের ঠিকানা',
    tr: 'Kaynak sipariş adresi',
    km: 'អាសយដ្ឋានការបញ្ជារប្រភព',
    es: 'Dirección del pedido de origen',
    ar: 'عنوان أمر المصدر',
  },
  'surplusPage.orderId': {
    zh: '来源订单号',
    en: 'Source order number',
    id: 'Nomor pesanan sumber',
    kz: 'Дереккөз тапсырыс нөмірі',
    th: 'หมายเลขลำดับต้นทาง',
    ug: 'مەنبەلىك زاكاز نومۇرى',
    vi: 'Số đơn hàng nguồn',
    zh_tc: '來源訂單號',
    ru: 'Номер заказа источника',
    ko: '소스 주문 번호',
    bur: 'မူရင်းမှာယူမှုနံပါတ်',
    ben: 'উৎস অর্ডার নম্বর',
    tr: 'Kaynak sipariş numarası',
    km: 'លេខការបញ្ជារប្រភព',
    es: 'Número de pedido de origen',
    ar: 'رقم أمر المصدر',
  },
  'surplusPage.lockStatus': {
    zh: '锁定状态',
    en: 'Locked State',
    id: 'Keadaan terkunci',
    kz: 'блоктау күйі',
    th: 'สถานะล็อค',
    ug: 'قۇلۇپلاش ھالىتى',
    vi: 'Trạng thái khóa',
    zh_tc: '鎖定狀態',
    ru: 'Состояние блокировки',
    ko: '잠금 상태',
    bur: 'လော့ချထားသောအခြေအနေ',
    ben: 'লক অবস্থা',
    tr: 'Kilit durumu',
    km: 'ស្ថានភាពសោ',
    es: 'Estado de bloqueo',
    ar: 'حالة القفل',
  },
  'surplusPage.lockOrder': {
    zh: '锁定订单',
    en: 'Locked Order',
    id: 'Pesanan kunci',
    kz: 'тапсырысты блоктау',
    th: 'คำสั่งล็อค',
    ug: 'زاكازنى قۇلۇپلاش',
    vi: 'Lệnh khóa',
    zh_tc: '鎖定訂單',
    ru: 'Заблокировать заказ',
    ko: '주문 잠금',
    bur: 'မှာယူမှုလော့ချ',
    ben: 'লক করা অর্ডার',
    tr: 'Kilitli sipariş',
    km: 'ការបញ្ជារចាក់សោ',
    es: 'Orden de bloqueo',
    ar: 'أمر القفل',
  },
  'surplusPage.enableSurplusLock': {
    zh: '启用余料锁定功能',
    en: 'Enable the surplus material locking feature',
    id: 'Aktifkan fungsi penguncian bahan residu',
    kz: 'Қалысқан материалдарды бұғаттау функциясын іске қосу',
    th: 'เปิดใช้งานฟังก์ชั่นการล็อควัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال قۇلۇپلاش ئىقتىدارىنى قوزغىتىش',
    vi: 'Bật chức năng khóa vật liệu dư thừa',
    zh_tc: '啟用餘料鎖定功能',
    ru: 'Включить функцию блокировки остатков',
    ko: '여분 잠금 사용',
    bur: 'ပိုလျှံပစ္စည်းလော့ချလုပ်ဆောင်ချက်ဖွင့်',
    ben: 'উদ্বৃত্ত উপকরণ লকিং ফিচার সক্ষম করুন',
    tr: 'Artık malzeme kilidini etkinleştir',
    km: 'បើកមុខងារចាក់សោសម្ភារៈសល់',
    es: 'Habilitar la función de bloqueo de material restante',
    ar: 'تمكين وظيفة قفل المواد المتبقية',
  },
  'surplusPage.isCloseSurplusLock': {
    zh: '功能关闭后所有余料都会解除锁定，是否继续',
    en: 'After the feature is turned off, all surplus materials will be unlocked. Do you wish to continue',
    id: 'Setelah fungsi dimatikan, semua bahan residu akan dibuka. Apakah akan melanjutkan',
    kz: 'Функцияны өшірілгеннен кейін барлық қалысқан материалдар бұғатталып тасталады, жалғастырмақсыз ба',
    th: 'หลังจากปิดฟังก์ชั่นวัสดุที่เหลือทั้งหมดจะถูกปลดล็อค ไม่ว่าจะดำเนินการต่อ',
    ug: 'ئىقتىدار تاقىلغاندىن كېيىن بارلىق قالدۇق ماتېرىياللارنىڭ قۇلۇپى ئېچىلىدۇ، داۋاملاشتۇرامسىز',
    vi: 'Sau khi tắt chức năng, tất cả vật liệu dư thừa sẽ bị mở khóa, bạn có muốn tiếp tục không',
    zh_tc: '功能關閉後所有餘料都會解除鎖定，是否繼續',
    ru: 'После того, как функция выключена, все остаточные материалы будут разблокированы, продолжать ли',
    ko: '기능이 꺼지면 나머지 모든 재료의 잠금이 해제됩니다. 계속 진행하시겠습니까?',
    bur: 'လုပ်ဆောင်ချက်ပိတ်ပြီးနောက်ပိုလျှံပစ္စည်းအားလုံးလော့ချဖြေ၊ ဆက်မည်လား',
    ben: 'ফিচার বন্ধ করলে সব উদ্বৃত্ত আনলক হবে, চালিয়ে যাবেন?',
    tr: 'Kapatılınca tüm artıkların kilidi açılır. Devam edilsin mi?',
    km: 'បន្ទាប់ពីបិទ សម្ភារៈសល់ទាំងអស់នឹងដោះសោ បន្តឬទេ?',
    es: 'Después de desactivar la función, todos los materiales restantes se desbloqueado. ¿Quieres continuar?',
    ar: 'بعد إيقاف تشغيل الوظيفة، سيتم إيقاف جميع المواد المتبقية مقفلة. هل تريد الاستمرار؟',
  },
  'surplusPage.confirm': {
    zh: '确认关闭',
    en: 'Confirm to close',
    id: 'Konfirmasi untuk menutup',
    kz: 'Жауапты түрде жабу',
    th: 'ยืนยันที่จะปิด',
    ug: 'جازالاش',
    vi: 'Xác nhận tắt',
    zh_tc: '確認關閉',
    ru: 'Подтвердить закрытие',
    ko: '종료 확인',
    bur: 'ပိတ်သည်ကိုအတည်ပြု',
    ben: 'বন্ধ করতে নিশ্চিত করুন',
    tr: 'Kapatmayı onayla',
    km: 'បញ្ជាក់ការបិទ',
    es: 'Confirmar para cerrar',
    ar: 'تأكيد الإغلاق',
  },
  'surplusPage.surplusTransfer': {
    zh: '余料转移',
    en: 'Transfer of surplus materials',
    id: 'Transfer materi yang tersisa',
    kz: 'Қалысқы материалдарды түрлендіру',
    th: 'การถ่ายโอนวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال يۆتكەش',
    vi: 'Chuyển số dư',
    zh_tc: '餘料轉移',
    ru: 'Перенос остатков',
    ko: '남은 재료 이동',
    bur: 'ပိုလျှံပစ္စည်းပြောင်းရွှေ့',
    ben: 'উদ্বৃত্ত স্থানান্তর',
    tr: 'Artık malzeme aktarımı',
    km: 'ផ្ទេរសម្ភារៈសល់',
    es: 'Transferencia de material restante',
    ar: 'نقل المواد المتبقية',
  },
  'surplusPage.targetSurplusStore': {
    zh: '目标余料库',
    en: 'Target surplus material warehouse',
    id: 'Gudang bahan residual target',
    kz: 'Мақсатты қалысқы материалдар қоймасы',
    th: 'เป้าหมายคลังสินค้าวัสดุตกค้าง',
    ug: 'نىشان قالدۇق ماتېرىيال ئامبىرى',
    vi: 'Kho dự trữ mục tiêu',
    zh_tc: '目標餘料庫',
    ru: 'целевой склад',
    ko: '목표 잉여 재료 창고',
    bur: 'ပစ်မှတ်ပိုလျှံပစ္စည်းဂိုဒေါင်',
    ben: 'লক্ষ্য উদ্বৃত্ত গুদাম',
    tr: 'Hedef artık deposu',
    km: 'ឃ្លាំងសល់គោលដៅ',
    es: 'Biblioteca de material restante de destino',
    ar: 'مكتبة المواد المتبقية المستهدفة',
  },
  'surplusPage.enableSurLockTip': {
    zh: '开启后，每次排版都会锁定使用的余料，防止其他订单占用',
    en: 'After activation, the remaining material used for each typesetting will be locked to prevent it from being occupied by other orders',
    id: 'Setelah menyala, setiap tata letak akan mengunci bahan yang tersisa yang digunakan untuk mencegah pesanan lain dari menempati.',
    kz: 'Активация алдында, әрбір нүктелікте қолданылатын қалдырылған материалдар бұған түрде блокталады, басқа тапсырмалар оларды алмауға тырысады',
    th: 'หลังจากเปิดทุกเลย์เอาต์จะล็อควัสดุที่เหลือที่ใช้เพื่อป้องกันไม่ให้คำสั่งซื้ออื่น ๆ จากการครอบครอง',
    ug: 'قوزغىتىلغاندىن كېيىن، ھەر قېتىملىق تەرتىپلەشتە ئىشلىتىلگەن قالدۇق ماتېرىياللار قۇلۇپلىنىدۇ، باشقا زاكازلارنىڭ ئىشلىتىشىدىن ساقلىنىدۇ',
    vi: 'Kích hoạt sau đó, mỗi lần sắp đặt in sẽ khóa lại vật liệu dư thừa đã sử dụng để ngăn chặn các đơn hàng khác sử dụng',
    zh_tc: '開啟後，每次排版都會鎖定使用的餘料，防止其他訂單佔用',
    ru: 'После включения каждый набор блокирует используемые остатки, чтобы предотвратить использование других заказов',
    ko: '오픈 후, 매번 조판할 때마다 남은 재료를 잠그고, 기타 주문의 점용을 방지한다',
    bur: 'ဖွင့်ပြီးနောက်ပြင်ဆင်မှုတိုင်းတွင်အသုံးပြုသောပိုလျှံပစ္စည်းကိုလော့ချကာအခြားမှာယူမှုမသုံးနိုင်အောင်ကာကွယ်',
    ben: 'সক্ষম করলে প্রতিটি লেআউটে ব্যবহৃত উদ্বৃত্ত লক হবে, অন্য অর্ডার ব্যবহার করা থেকে বিরত রাখবে',
    tr: 'Açıkken her yerleşimde kullanılan artık kilitlenir; başka siparişler kullanamaz',
    km: 'បើករួច រៀបចំរាល់ដងសម្ភារៈសល់ដែលប្រើនឹងចាក់សោ ការបញ្ជារផ្សេងមិនអាចប្រើ',
    es: 'Después de abrir, los materiales restantes utilizados se bloquearán para cada composición tipográfica para evitar que otros pedidos ocupen',
    ar: 'بعد الفتح، سيتم قفل المواد المتبقية المستخدمة لكل تنضيد لمنع أوامر أخرى من شغلها',
  },
  'surplusPage.addMainRule': {
    zh: '添加主规则',
    en: 'Add main rule',
    id: 'Tambah Aturan Utama',
    kz: 'Негізгі قانونды қосу',
    th: 'เพิ่มกฎหลัก',
    ug: 'ئاساسىي قائىدە قوشۇش',
    vi: 'Thêm quy tắc chính',
    zh_tc: '添加主規則',
    ru: 'Добавить главное правило',
    ko: '주 규칙 추가',
    bur: 'မူလစည်းမျဉ်းထည့်',
    ben: 'প্রধান নিয়ম যোগ করুন',
    tr: 'Ana kural ekle',
    km: 'បន្ថែមច្បាប់ចម្បង',
    es: 'Agregar regla principal',
    ar: 'إضافة قاعدة رئيسية',
  },
  'surplusPage.surplusRules': {
    zh: '余料入库规则',
    en: 'Rules for surplus material storage',
    id: 'Aturan Penyimpanan Sisa Bahan ',
    kz: 'Қалыпты құрама барысындау ережелері',
    th: 'กฎการนำเข้าวัสดุที่เหลือ',
    ug: 'قالدۇق ماتېرىيال ئامبارغا ساقلاش قائىدىسى',
    vi: 'Quy tắc nhập kho nguyên liệu dư',
    zh_tc: '餘料入庫規則',
    ru: 'Правила складирования излишков',
    ko: '잉여 재료 입고 규칙',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်စည်းမျဉ်း',
    ben: 'উদ্বৃত্ত স্টোরেজ নিয়মাবলী',
    tr: 'Artık malzeme depo kuralları',
    km: 'ច្បាប់ចូលឃ្លាំងសម្ភារៈសល់',
    es: 'Reglas de almacenamiento de material restante',
    ar: 'قواعد تخزين المواد المتبقية',
  },
  'surplusPage.mainRulesTip': {
    zh: '主规则之间是或的关系，即只要满足一个主规则，余料就会入库',
    en: 'The relationship between master rules is either or, which means that as long as one master rule is met, the remaining materials will be stored in the warehouse',
    id: 'Aturan utama adalah hubungan atau, yaitu jika hanya memenuhi satu aturan utama, sisa akan disimpan',
    kz: 'Негізгі قواعد аралығында ‘немесе’ қосылым бар, ж.ә. бір негізгі قواعды тығықтық алса, қалдық материалдар қоймасына кіретін болады',
    th: 'กฎหลักเป็นความสัมพันธ์หรือ นั่นคือ ตราบใดที่สามารถพอสังเกตได้ตามกฎหลักใดก็ตาม วัสดุที่เหลือจะถูกนำเข้า',
    ug: 'ئاساسىي قائىدىلەر ياكى مۇناسىۋىتىدە، يەنى بىر ئاساسىي قائىدىنى قاندۇرغاندا، قالدۇق ماتېرىيال ئامبارغا ساقلانىدۇ',
    vi: 'Có hoặc mối quan hệ giữa các quy tắc chính, tức là bất cứ khi nào một quy tắc chính được đáp ứng, số dư sẽ được đưa vào kho',
    zh_tc: '主規則之間是或的關係，即只要滿足一個主規則，餘料就會入庫',
    ru: 'Отношения между первичными правилами да или, т.е. до тех пор, пока выполняется одно основное правило, остатки будут храниться',
    ko: '주규칙 간의 예 또는 관계, 즉 하나의 주규칙을 만족시키면 나머지 재료가 입고된다',
    bur: 'မူလစည်းမျဉ်းများကြားသည်သို့မဟုတ်ဆက်ဆံရေးဖြစ်ပြီးမူလစည်းမျဉ်းတစ်ခုကိုဖြည့်ဆည်းပေးနိုင်လျှင်ဂိုဒေါင်ဝင်မည်',
    ben: 'প্রধান নিয়মগুলির মধ্যে অথবা সম্পর্ক, অর্থাৎ যেকোনো একটি প্রধান নিয়ম পূরণ হলেই উদ্বৃত্ত গুদামে যাবে',
    tr: 'Ana kurallar VEYA ilişkisindedir; bir ana kural sağlanırsa malzeme depoya girer',
    km: 'ច្បាប់ចម្បងជាទំនាក់ទំនង OR បំពេញមួយគឺចូលឃ្លាំង',
    es: 'Existe una relación OR entre las reglas principales, es decir, siempre que se cumpla una regla principal, el material restante se colocará en el almacén',
    ar: 'توجد علاقة OR بين القواعد الرئيسية، أي أنه طالما تم استيفاء قاعدة رئيسية واحدة، سيتم وضع المواد المتبقية في المستودع',
  },
  'surplusPage.mainRulesTip1': {
    zh: '添加规则后，命中规则的余料会优先存放到该仓库，该仓库满后会存入其他空闲余料仓',
    en: 'After adding the rule, the remaining materials that hit the rule will be prioritized for storage in that warehouse, and when the warehouse is full, they will be stored in other available remaining material bins',
    id: 'Setelah menambahkan aturan, sisa yang memenuhi aturan akan disimpan terlebih dahulu di gudang tersebut, dan setelah gudang tersebut penuh, akan disimpan di gudang sisa lainnya yang kosong',
    kz: 'Күйін қосулынан кейін, күйіне сәйкес келген қалдырылған материалдар бұл қуелгаға негізгі реттеуінде сақталады, ол қуелга толық болған соң, басқа бос қалдырылған материалдар қуелгасына сақталады',
    th: 'หลังจากเพิ่มกฎ วัสดุที่เหลือที่ตรงกับกฎจะถูกจัดเก็บไว้ในคลังนี้ก่อน โดยที่เมื่อคลังนี้เต็มแล้ว จะถูกนำไปจัดเก็บในคลังว่างอื่นๆ',
    ug: 'قائىدە قوشقاندىن كېيىن، قائىدىگە ماس كەلگەن قالدۇق ماتېرىيال ئاۋۋال بۇ ئامبارغا ساقلانىدۇ، بۇ ئامبار تولغاندىن كېيىن باشقا بوش قالدۇق ماتېرىيال ئامبىرىغا ساقلانىدۇ',
    vi: 'Sau khi quy tắc được thêm vào, số dư của quy tắc truy cập được ưu tiên lưu trữ trong kho đó, khi nó đầy, sẽ được lưu trữ trong các thùng dư khác',
    zh_tc:
      '添加規則後，命中規則的餘料會優先存放到該倉庫，該倉庫滿後會存入其他空閒餘料倉',
    ru: 'После добавления правил излишки, попавшие в правила, будут храниться в первую очередь на этом складе, который после его заполнения будет помещен в другие свободные склады',
    ko: '규칙을 추가한 후, 명중 규칙의 남은 재료는 우선적으로 이 창고에 보관되며, 이 창고가 가득 차면 기타 빈 남은 재료 창고에 보관된다',
    bur: 'စည်းမျဉ်းထည့်ပြီးနောက်ဂိုဒေါင်ကိုပထမဦးဆုံးသိမ်းဆည်းမည်',
    ben: 'নিয়ম যোগের পরে, নিয়ম মেনে চলা উদ্বৃত্ত প্রথমে সেই গুদামে সংরক্ষিত হবে',
    tr: 'Kural eklendikten sonra eşleşen artıklar önce bu depoya alınır; dolunca diğer boş depolara gider',
    km: 'បន្ទាប់ពីបន្ថែមច្បាប់ សល់ដែលត្រូវគ្នាចូលឃ្លាំងនេះមុន ពេញហើយទៅឃ្លាំងទំនេរ',
    es: 'Después de agregar una regla, los materiales restantes que cumplan la regla se almacenarán primero en este almacén. Cuando el almacén esté lleno se almacenará en otros almacenes libres de materiales restantes.',
    ar: 'بعد إضافة قاعدة، سيتم تخزين المواد المتبقية التي وصلت إلى القاعدة في هذا المستودع أولاً. عندما يمتلئ المستودع، سيتم تخزينه في مستودعات المواد المتبقية المجانية الأخرى.',
  },
  'surplusPage.rule': {
    zh: '规则',
    en: 'Rule',
    id: 'Aturan',
    kz: 'қағида',
    th: 'กฎ',
    ug: 'قائىدە',
    vi: 'Quy tắc',
    zh_tc: '規則',
    ru: 'правило',
    ko: '규칙',
    bur: 'စည်းမျဉ်း',
    ben: 'নিয়ম',
    tr: 'Kural',
    km: 'ច្បាប់',
    es: 'Regla',
    ar: 'القاعدة',
  },
  'surplusPage.addSubRule': {
    zh: '添加子规则',
    en: 'Add sub rules',
    id: 'Tambah Aturan Sub',
    kz: 'Өріктік түрдеңізді қосу',
    th: 'เพิ่มกฎย่อย',
    ug: 'تارماق قائىدە قوشۇش',
    vi: 'Thêm quy tắc con',
    zh_tc: '添加子規則',
    ru: 'Добавить правило',
    ko: '하위 규칙 추가',
    bur: 'ကြားဖြတ်စည်းမျဉ်းထည့်',
    ben: 'উপ-নিয়ম যোগ করুন',
    tr: 'Alt kural ekle',
    km: 'បន្ថែមច្បាប់រង',
    es: 'Agregar subregla',
    ar: 'أضف قاعدة فرعية',
  },
  'surplusPage.subRuleTip': {
    zh: '子规则之间是且的关系，即需要同时满足主规则下的所有子规则，才会入库',
    en: 'The relationship between sub rules is a AND, which means that all AND rules under the main rule need to be satisfied simultaneously in order to be stored',
    id: 'Aturan sub adalah hubungan dan, yaitu harus memenuhi semua aturan sub di bawah aturan utama, baru akan disimpan',
    kz: 'Өрістер арасыnda және қатыстығы бар, т.е. барлық және шарттардың барлығын тұйықтықта тұрғанда ғана қойылып, жинаққа қосылады',
    th: 'กฎย่อยเป็นความสัมพันธ์และ นั่นคือ ต้องมีการตอบสนองกฎย่อยทั้งหมดภายใต้กฎหลักก่อนที่วัสดุที่เหลือจะถูกนำเข้า',
    ug: 'تارماق قائىدىلەر ۋە مۇناسىۋىتىدە، يەنى ئاساسىي قائىدىدىكى بارلىق تارماق قائىدىلەرنى قاندۇرغاندا، ئامبارغا ساقلانىدۇ',
    vi: 'Quan hệ giữa các quy tắc con là và, tức là cần đồng thời thỏa mãn tất cả và quy tắc dưới quy tắc chính, mới có thể nhập kho',
    zh_tc: '子規則之間是且的關係，即需要同時滿足主規則下的所有子規則，才會入庫',
    ru: 'Взаимосвязь между подзаконными актами есть и должна быть выполнена одновременно со всеми подзаконными актами в рамках основного правила, прежде чем они будут введены в хранилище.',
    ko: '하위 규칙 간에는 및 의 관계가 있습니다. 즉, 주 규칙 아래의 모든 하위 규칙을 동시에 충족해야 라이브러리에 들어갈 수 있습니다.',
    bur: 'ကြားဖြတ်စည်းမျဉ်းများကြားသည်နှင့်ဆက်ဆံရေးဖြစ်ပြီးမူလစည်းမျဉ်းအောက်ကြားဖြတ်စည်းမျဉ်းအားလုံးကိုဖြည့်ဆည်းမှသာဂိုဒေါင်ဝင်မည်',
    ben: 'উপ-নিয়মগুলির মধ্যে এবং সম্পর্ক, প্রধান নিয়মের অধীনে সব উপ-নিয়ম একই সাথে পূরণ হলেই গুদামে যাবে',
    tr: 'Alt kurallar VE ilişkisindedir; ana kural altındaki tüm alt kurallar aynı anda sağlanmalıdır',
    km: 'ច្បាប់រងជា AND ត្រូវបំពេញទាំងអស់ក្រោមច្បាប់ចម្បងទើបចូលឃ្លាំង',
    es: 'La relación entre las subreglas es y, es decir, todas las subreglas bajo la regla principal deben cumplirse al mismo tiempo antes de poder colocarse en el almacén',
    ar: 'العلاقة بين القواعد الفرعية هي، أي أن جميع القواعد الفرعية ضمن القاعدة الرئيسية يجب استيفاؤها في نفس الوقت قبل وضعها في المستودع',
  },
  'surplusPage.bigPlankMatCode': {
    zh: '大板材质',
    en: 'Large board material',
    id: 'Kode Material Plat Besar',
    kz: 'Үлкен плитка материалы',
    th: 'วัสดุแผ่นใหญ่',
    ug: 'چوڭ تاختا ماتېرىيالى',
    vi: 'Vật liệu tấm lớn',
    zh_tc: '大板材質',
    ru: 'Большой материал',
    ko: '판재',
    bur: 'ပေါ်ဒ်ကြီးပစ္စည်း',
    ben: 'বড় বোর্ডের উপকরণ',
    tr: 'Büyük levha malzemesi',
    km: 'សម្ភារៈផ្ទាំងធំ',
    es: 'Material de tablero grande',
    ar: 'مادة اللوحة الكبيرة',
  },
  'surplusPage.bigPlankThick': {
    zh: '大板厚度',
    en: 'Thickness of the large board',
    id: 'Ketebalan Plat Besar',
    kz: 'Құдыр пінді',
    th: 'ความหนาของแผ่นใหญ่',
    ug: 'چوڭ تاختا قېلىنلىقى',
    vi: 'Độ dày tấm lớn',
    zh_tc: '大板厚度',
    ru: 'Толщина плиты',
    ko: '판자 두께',
    bur: 'ပေါ်ဒ်ကြီးအထူ',
    ben: 'বড় বোর্ডের পুরুত্ব',
    tr: 'Büyük levha kalınlığı',
    km: 'កម្រាស់ផ្ទាំងធំ',
    es: 'Espesor de placa grande',
    ar: 'سمك اللوحة الكبيرة',
  },
  'surplusPage.bigPlankColor': {
    zh: '大板颜色',
    en: 'Large board color',
    id: 'Warna Plat Besar ',
    kz: 'Құрылғының түсі',
    th: 'สีของแผ่นใหญ่',
    ug: 'چوڭ تاختا رەڭگى',
    vi: 'Bảng màu lớn',
    zh_tc: '大板顏色',
    ru: 'Цвет большой доски',
    ko: '널빤지 색',
    bur: 'ပေါ်ဒ်ကြီးအရောင်',
    ben: 'বড় বোর্ডের রঙ',
    tr: 'Büyük levha rengi',
    km: 'ពណ៌ផ្ទាំងធំ',
    es: 'Color de tablero grande',
    ar: 'لون اللوحة الكبيرة',
  },
  'surplusPage.greaterEqual': {
    zh: '大于等于',
    en: 'Greater than or equal',
    id: 'Lebih dari atau sama dengan ',
    kz: 'жоқық үшін де',
    th: 'มากกว่าหรือเท่ากับ',
    ug: 'چوڭ ياكى تەڭ',
    vi: 'Lớn hơn bằng',
    zh_tc: '大於等於',
    ru: 'Больше чем равно',
    ko: '보다 큼',
    bur: 'ကြီးသည်သို့မဟုတ်ညီမျှ',
    ben: 'বড় বা সমান',
    tr: 'Büyük veya eşit',
    km: 'ធំជាងឬស្មើ',
    es: 'Mayor o igual a',
    ar: 'أكبر من أو يساوي',
  },
  'surplusPage.lessEqual': {
    zh: '小于等于',
    en: 'Less than or equal',
    id: ' Kurang dari atau sama dengan ',
    kz: 'кем дегенде жақсы қалады',
    th: 'น้อยกว่าหรือเท่ากับ',
    ug: 'كىچىك ياكى تەڭ',
    vi: 'Nhỏ hơn bằng',
    zh_tc: '小於等於',
    ru: 'Меньше чем равно',
    ko: '보다 작음',
    bur: 'သေးသည်သို့မဟုတ်ညီမျှ',
    ben: 'ছোট বা সমান',
    tr: 'Küçük veya eşit',
    km: 'តូចជាងឬស្មើ',
    es: 'Menor o igual a',
    ar: 'أقل من أو يساوي',
  },
  'surplusPage.capNumberCheck': {
    zh: '库存上限只能输入整数!',
    en: 'The inventory limit can only be entered as an integer!',
    id: 'Batas Stok Hanya Boleh Diisi dengan Angka Bulat! ',
    kz: 'Склад асайының жоғарғысы жолық саның енгізілуі керек!',
    th: 'จำนวนสินค้าที่สามารถนำเข้าได้ต้องเป็นจำนวนเต็มเท่านั้น!',
    ug: 'ئامبار چېكى پەقەت پۈتۈن سان كىرگۈزۈشكە بولىدۇ!',
    vi: 'Giới hạn tồn kho chỉ có thể được nhập vào số nguyên!',
    zh_tc: '庫存上限只能輸入整數!',
    ru: 'Верхний предел запасов может вводить только целое число!',
    ko: '재고 상한선은 정수만 입력할 수 있습니다!',
    bur: 'ကုန်ပစ္စည်းအမြင့်ဆုံးကန့်သတ်တွင်ကိန်းဂဏန်းသာထည့်နိုင်!',
    ben: 'স্টক সর্বোচ্চ সীমায় শুধুমাত্র পূর্ণসংখ্যা লেখা যাবে!',
    tr: 'Stok üst sınırı yalnızca tam sayı olabilir',
    km: 'ដែនកំណត់ស្តុកអតិបរមាបញ្ចូលបានតែគត់ធម្មជាតិ',
    es: '¡El límite superior del inventario solo se puede ingresar como un número entero!',
    ar: 'لا يمكن إدخال الحد الأعلى للمخزون إلا كعدد صحيح!',
  },
  'surplusPage.capEmptyCheck': {
    zh: '库存上限不能为空!',
    en: 'The inventory limit cannot be empty!',
    id: 'Batas Stok Tidak Boleh Kosong!',
    kz: 'Складдың шегі жоқ бола алмайды!',
    th: 'จำนวนสินค้าที่สามารถนำเข้าได้ไม่สามารถเป็นเปล่าได้!',
    ug: 'ئامبار چېكى بوش قالمايدۇ!',
    vi: 'Hàng tồn kho không được để trống!',
    zh_tc: '庫存上限不能為空!',
    ru: 'Верхний предел запасов не может быть пустым!',
    ko: '재고 상한선은 비워둘 수 없습니다!',
    bur: 'ကုန်ပစ္စည်းအမြင့်ဆုံးကန့်သတ်မဟာမဆ!',
    ben: 'স্টক সর্বোচ্চ সীমা খালি রাখা যাবে না!',
    tr: 'Stok üst sınırı boş olamaz',
    km: 'ដែនកំណត់ស្តុកអតិបរមាមិនអាចទទេ',
    es: '¡El límite superior del inventario no puede estar vacío!',
    ar: 'لا يمكن أن يكون الحد الأعلى للمخزون فارغًا!',
  },
  'surplusPage.surNameEmptyCheck': {
    zh: '余料库名称不能为空!',
    en: 'The name of the surplus material warehouse cannot be empty!',
    id: 'Nama Gudang Sisa Tidak Boleh Kosong!',
    kz: 'Қалып жатық атауы бос бола алмайды!',
    th: 'ชื่อคลังวัสดุที่เหลือไม่สามารถเป็นเปล่าได้!',
    ug: 'قالدۇق ماتېرىيال ئامبىرى ئىسمى بوش قالمايدۇ!',
    vi: 'Tên kho dự liệu không thể là trống!',
    zh_tc: '餘料庫名稱不能為空!',
    ru: 'Название хранилища не может быть пустым!',
    ko: '남은 재료 창고 이름은 비워둘 수 없습니다!',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အမည်မဟာမဆ!',
    ben: 'উদ্বৃত্ত গুদামের নাম খালি রাখা যাবে না!',
    tr: 'Artık depo adı boş olamaz',
    km: 'ឈ្មោះឃ្លាំងសល់មិនអាចទទេ',
    es: '¡El nombre de la biblioteca de materiales restante no puede estar vacío!',
    ar: 'لا يمكن أن يكون اسم مكتبة المواد المتبقية فارغًا!',
  },
  'surplusPage.mainRuleLimit': {
    zh: '主规则已达上限',
    en: 'The main rule has reached the upper limit',
    id: 'Batas Aturan Utama Telah Tercapai ',
    kz: 'Негізгі قانونның шегіне қарайды',
    th: 'กฎหลักได้ถึงขีดจำกัดสูงสุดแล้ว',
    ug: 'ئاساسىي قائىدە چېكىگە يەتكەن',
    vi: 'Quy tắc chính đã đạt đến giới hạn',
    zh_tc: '主規則已達上限',
    ru: 'Главное правило вышло на верхний предел.',
    ko: '주 규칙이 이미 상한에 도달하였습니다',
    bur: 'မူလစည်းမျဉ်းကန့်သတ်ချက်ရောက်ပြီ',
    ben: 'প্রধান নিয়ম সর্বোচ্চ সীমায় পৌঁছেছে',
    tr: 'Ana kural üst sınıra ulaştı',
    km: 'ច្បាប់ចម្បងដល់ដែនកំណត់អតិបរមា',
    es: 'La regla principal ha alcanzado el límite superior',
    ar: 'وصلت القاعدة الرئيسية إلى الحد الأعلى',
  },
  'surplusPage.delMainRuleTip': {
    zh: '是否删除本主规则',
    en: 'Do you want to delete this main rule',
    id: 'Apakah menghapus aturan utama ini?',
    kz: 'Бұл мәнін өшіру керек пе, жоқ па',
    th: 'ต้องการลบกฎหลักนี้หรือไม่',
    ug: 'بۇ ئاساسىي قائىدىنى ئۆچۈرەمسىز',
    vi: 'Loại bỏ quy tắc chính này',
    zh_tc: '是否刪除本主規則',
    ru: 'Удалить главное правило',
    ko: '기본 규칙 삭제 여부',
    bur: 'ဤမူလစည်းမျဉ်းကိုဖျက်ဆီးမည်လား',
    ben: 'এই প্রধান নিয়ম মুছতে চান?',
    tr: 'Bu ana kural silinsin mi?',
    km: 'លុបច្បាប់ចម្បងនេះឬ?',
    es: '¿Quieres eliminar esta regla principal?',
    ar: 'هل تريد حذف هذه القاعدة الرئيسية؟',
  },
  'surplusPage.matCodeEmptyCheck': {
    zh: '大板材质不能为空!',
    en: 'The material of the large board cannot be empty!',
    id: 'Kode Material Plat Besar Tidak Boleh Kosong!',
    kz: 'Дайна платформасының материалы бос болуы мүмкін емес!',
    th: 'วัสดุแผ่นใหญ่ไม่สามารถเป็นเปล่าได้!',
    ug: 'چوڭ تاختا ماتېرىيالى بوش قالمايدۇ!',
    vi: 'Các vật liệu bảng lớn không được trống!',
    zh_tc: '大板材質不能為空!',
    ru: 'Материал не может быть пустым!',
    ko: '널빤지 소재는 비워둘 수 없습니다!',
    bur: 'ပေါ်ဒ်ကြီးပစ္စည်းမဟာမဆ!',
    ben: 'বড় বোর্ডের উপকরণ খালি রাখা যাবে না!',
    tr: 'Büyük levha malzemesi boş olamaz',
    km: 'សម្ភារៈផ្ទាំងធំមិនអាចទទេ',
    es: '¡El material del plato grande no puede estar vacío!',
    ar: 'لا يمكن أن تكون مادة الطبق الكبير فارغة!',
  },
  'surplusPage.thickEmptyCheck': {
    zh: '大板厚度不能为空!',
    en: 'The thickness of the large board cannot be empty!',
    id: 'Ketebalan Plat Besar Tidak Boleh Kosong!',
    kz: 'Дайына қалыңдығы бос болуы мүмкін емес!',
    th: 'ความหนาของแผ่นใหญ่ไม่สามารถเป็นเปล่าได้!',
    ug: 'چوڭ تاختا قېلىنلىقى بوش قالمايدۇ!',
    vi: 'Độ dày của tấm lớn không thể rỗng!',
    zh_tc: '大板厚度不能為空!',
    ru: 'Толщина доски не может быть пустой!',
    ko: '널빤지 두께는 비워둘 수 없습니다!',
    bur: 'ပေါ်ဒ်ကြီးအထူမဟာမဆ!',
    ben: 'বড় বোর্ডের পুরুত্ব খালি রাখা যাবে না!',
    tr: 'Büyük levha kalınlığı boş olamaz',
    km: 'កម្រាស់ផ្ទាំងធំមិនអាចទទេ',
    es: '¡El grosor del plato grande no puede estar vacío!',
    ar: 'سمك اللوحة الكبيرة لا يمكن أن يكون فارغاً!',
  },
  'surplusPage.textureEmptyCheck': {
    zh: '大板颜色不能为空!',
    en: 'The color of the large board cannot be empty!',
    id: 'Warna Plat Besar Tidak Boleh Kosong! ',
    kz: 'Дайна көрінісі бос болуы мүмкін емес!',
    th: 'สีของแผ่นใหญ่ไม่สามารถเป็นเปล่าได้!',
    ug: 'چوڭ تاختا رەڭگى بوش قالمايدۇ!',
    vi: 'Màu bảng lớn không được để trống!',
    zh_tc: '大板顏色不能為空!',
    ru: 'Большие цвета не могут быть пустыми!',
    ko: '널빤지 색상은 비워둘 수 없습니다!',
    bur: 'ပေါ်ဒ်ကြီးအရောင်မဟာမဆ!',
    ben: 'বড় বোর্ডের রঙ খালি রাখা যাবে না!',
    tr: 'Büyük levha rengi boş olamaz',
    km: 'ពណ៌ផ្ទាំងធំមិនអាចទទេ',
    es: '¡El color del plato grande no puede estar vacío!',
    ar: 'لا يمكن أن يكون لون الطبق الكبير فارغًا!',
  },
  'surplusPage.enableWarehouseSecondCon': {
    zh: '启用余料入库二次确认',
    en: 'Enable secondary confirmation of surplus material storage',
    id: 'Aktifkan Konfirmasi Pendukung Penyimpanan Sisa',
    kz: 'Қалыпты құрамының реттеуін қайта растауды іске қосу',
    th: 'เปิดใช้งานการยืนยันการนำเข้าวัสดุที่เหลือครั้งที่สอง',
    ug: 'ئارتۇق ماتېرىيال ئامبارغا سېلىشنى ئىككى قېتىم تەستىقلاش ئىقتىدارىنى قوزغاتۇش',
    vi: 'Cho phép xác nhận số dư vào kho',
    zh_tc: '啟用餘料入庫二次確認',
    ru: 'Включить вторичное подтверждение складирования',
    ko: '남은 재료 입고 2차 확인 사용',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်ဒုတိယအတည်ပြုချက်ဖွင့်',
    ben: 'উদ্বৃত্ত গুদামে সংরক্ষণের দ্বিতীয় নিশ্চিতকরণ সক্ষম করুন',
    tr: 'Artık depo için ikinci onayı etkinleştir',
    km: 'បើកការបញ្ជាក់ទីពីរសម្រាប់ចូលឃ្លាំងសល់',
    es: 'Habilitar confirmación secundaria del almacenamiento de material restante',
    ar: 'تمكين التأكيد الثانوي لتخزين المواد المتبقية',
  },
  'surplusPage.surplusWarehouseConfirm': {
    zh: '余料入库确认',
    en: 'Confirmation of surplus material storage',
    id: 'Konfirmasi Penyimpanan Sisa',
    kz: 'Қалыпты құрамының рұқсатты түсіну',
    th: 'ยืนยันการนำเข้าวัสดุที่เหลือ',
    ug: 'ئارتۇق ماتېرىيال ئامبارغا سېلىشنى تەستىقلاش',
    vi: 'Xác nhận số dư vào kho',
    zh_tc: '餘料入庫確認',
    ru: 'Подтверждение складирования',
    ko: '남은 재료 입고 확인',
    bur: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်အတည်ပြုချက်',
    ben: 'উদ্বৃত্ত গুদামে সংরক্ষণ নিশ্চিতকরণ',
    tr: 'Artık malzeme depo onayı',
    km: 'ការបញ្ជាក់ចូលឃ្លាំងសល់',
    es: 'Confirmación de almacenamiento de material restante',
    ar: 'تأكيد تخزين المواد المتبقية',
  },
  'surplusPage.surplusWarehouseConfirm1': {
    zh: '入库确认',
    en: 'Warehouse confirmation',
    id: 'Konfirmasi Penyimpanan',
    kz: 'жинақтауды растау',
    th: 'ยืนยันการนำเข้า',
    ug: 'سېلىشنى تەستىقلاش',
    vi: 'Xác nhận nhập kho',
    zh_tc: '入庫確認',
    ru: 'Подтверждение складирования',
    ko: '입고 확인',
    bur: 'ဂိုဒေါင်ဝင်အတည်ပြုချက်',
    ben: 'গুদামে যোগ করার নিশ্চিতকরণ',
    tr: 'Depo onayı',
    km: 'ការបញ្ជាក់ចូលឃ្លាំង',
    es: 'Confirmación de almacenamiento',
    ar: 'تأكيد التخزين',
  },
  'surplusPage.closeSurplusConfirm': {
    zh: '关闭入库确认（可在余料管理页面设置中重新开启）',
    en: 'Close inventory confirmation (can be reopened in the settings of the surplus material management page)',
    id: 'Tutup Konfirmasi Penyimpanan (Dapat diaktifkan kembali di pengaturan halaman penyimpanan sisa)',
    kz: 'Хранение тіркелуін растауын сөндіру (қалайпын басқару бетінде қайта қосуға болады)',
    th: 'ปิดการยืนยันการนำเข้า（สามารถเปิดใช้งานอีกครั้งได้ในหน้าตั้งค่าการจัดการวัสดุที่เหลือ）',
    ug: 'سېلىشنى تەستىقلاش ئىقتىدارىنى تاقاش (ئارتۇق ماتېرىيال باشقۇرۇش بەتتە تەڭشىكىدە قايتا ئېچىش مۇمكىن)',
    vi: 'Tắt xác nhận nhập kho (có thể mở lại trong cài đặt trang quản lý dư lượng)',
    zh_tc: '關閉入庫確認（可在餘料管理頁面設定中重新開啟）',
    ru: 'Закрыть подтверждение входа в хранилище (может быть перезапущено в настройках страницы управления остатками)',
    ko: '입고 확인 닫기 (여분 관리 페이지 설정에서 다시 열 수 있음)',
    bur: 'ဂိုဒေါင်ဝင်အတည်ပြုချက်ပိတ်(ပိုလျှံပစ္စည်းစီမံမှုစာမျက်နှာတွင်ပြန်ဖွင့်နိုင်)',
    ben: 'গুদামে যোগ নিশ্চিতকরণ বন্ধ করুন (উদ্বৃত্ত ব্যবস্থাপনা পেজে পুনরায় চালু করা যাবে)',
    tr: 'Depo onayını kapat (artık yönetim sayfası ayarlarından yeniden açılabilir)',
    km: 'បិទការបញ្ជាក់ចូលឃ្លាំង (បើកឡើងវិញនៅការកំណត់ទំព័រគ្រប់គ្រងសល់)',
    es: 'Desactivar la confirmación de almacenamiento (se puede volver a habilitar en la configuración de la página de administración de material restante)',
    ar: 'إيقاف تشغيل تأكيد التخزين (يمكن إعادة تمكينه في إعدادات صفحة إدارة المواد المتبقية)',
  },
  'surplusPage.position': {
    zh: '存放位置',
    en: 'Position',
    id: 'Posisi Penyimpanan ',
    kz: 'Қалыпқа жатық орны',
    th: 'ตำแหน่งที่จัดเก็บ',
    ug: 'ئورۇن',
    vi: 'Nơi cất giữ',
    zh_tc: '存放位置',
    ru: 'Место хранения',
    ko: '보관 위치',
    bur: 'သိမ်းဆည်းနေရာ',
    ben: 'সংরক্ষণের স্থান',
    tr: 'Saklama konumu',
    km: 'ទីតាំងរក្សា',
    es: 'Ubicación de almacenamiento',
    ar: 'موقع التخزين',
  },
  'surplusPage.nameRepeatTip': {
    zh: '已存在当前余料名，请修改后重新入库',
    en: 'The current remaining material name already exists. Please modify it and re-enter the inventory',
    id: 'Sudah ada nama sisa saat ini, silakan ubah dan lakukan penyimpanan ulang ',
    kz: 'Бұл қалдықтың атауы бар болып тұр, өзгертіп, қайта сақтаңыз',
    th: 'มีชื่อวัสดุที่เหลือในปัจจุบัน กรุณาแก้ไขและนำเข้าอีกครั้ง',
    ug: 'ھازىر ئارتۇق ماتېرىيال ئىسمى مەۋجۇت، تەھرىرلەپ قايتا ئامبارغا سېلىڭ',
    vi: 'Tên tài liệu hiện tại đã tồn tại, vui lòng nhập lại kho sau khi sửa đổi',
    zh_tc: '已存在當前餘料名，請修改後重新入庫',
    ru: 'Текущее имя остатка уже существует, пожалуйста, измените и перезапустите в хранилище',
    ko: '현재 남은 재료 이름이 이미 존재합니다. 수정한 후 다시 입고해 주십시오',
    bur: 'ပိုလျှံပစ္စည်းအမည်ရှိပြီး၊ ပြင်ဆင်ပြီးဂိုဒေါင်ပြန်ဝင်ပါ',
    ben: 'বর্তমান উদ্বৃত্তের নাম ইতিমধ্যে বিদ্যমান, সংশোধন করে পুনরায় গুদামে যোগ করুন',
    tr: 'Bu artık adı zaten var; düzenleyip yeniden depoya alın',
    km: 'មានឈ្មោះសល់នេះរួច សូមកែហើយចូលឃ្លាំងឡើងវិញ',
    es: 'El nombre del material remanente actual ya existe, modifíquelo y vuelva a ingresar al almacén',
    ar: 'اسم المادة المتبقية الحالي موجود بالفعل، يرجى تعديله وإعادة إدخال المستودع',
  },
  'surplusPage.surLimitTip': {
    zh: '当前余料库已达上限或不满足入库规则',
    en: 'The current surplus material warehouse has reached the upper limit or does not meet the storage rules',
    id: 'Gudang sisa saat ini telah mencapai batas atau tidak memenuhi aturan penyimpanan ',
    kz: 'Ағымдағы қалдық қоймасы шекті мөлшерге жетті немесе кіріс көрсеткіштеріне сәйкес келмейді',
    th: 'คลังวัสดุที่เหลือในปัจจุบันได้ถึงขีดจำกัดสูงสุดหรือไม่ตรงกับกฎการนำเข้า',
    ug: 'ھازىر ئارتۇق ماتېرىيال ئامبىرىنىڭ چەكلىمىسىگە يەتتى ياكى سېلىش قائىدىسىگە ئۇيغۇن ئەمەس',
    vi: 'KhKho dự trữ hiện tại đã đạt giới hạn hoặc không đáp ứng quy tắc nhập kho',
    zh_tc: '當前餘料庫已達上限或不滿足入庫規則',
    ru: 'Текущие складские запасы достигли верхнего предела или не соответствуют правилам складирования',
    ko: '현재 남은 재료 창고가 이미 상한선에 도달하였거나 입고 규칙을 만족시키지 않음',
    bur: 'လက်ရှိပိုလျှံပစ္စည်းဂိုဒေါင်ကန့်သတ်ချက်ရောက်ပြီ သို့မဟုတ် ဂိုဒေါင်ဝင်စည်းမျဉ်းမပြည့်မီ',
    ben: 'বর্তমান উদ্বৃত্ত গুদাম সর্বোচ্চ সীমায় পৌঁছেছে বা স্টোরেজ নিয়ম পূরণ করে না',
    tr: 'Artık depo dolu veya depo kurallarını karşılamıyor',
    km: 'ឃ្លាំងសល់ដល់ដែនកំណត់ឬមិនបំពេញច្បាប់ចូលឃ្លាំង',
    es: 'La biblioteca de material remanente actual ha alcanzado el límite superior o no cumple con las reglas de almacenamiento',
    ar: 'وصلت مكتبة المواد المتبقية الحالية إلى الحد الأعلى أو لا تستوفي قواعد التخزين',
  },
  'surplusPage.surFailTip': {
    zh: '入库失败，存在余料名称重复或余料仓存放达到上限或不满足入库规则',
    en: 'Storage failed, there are duplicate names of remaining materials or the storage capacity of the remaining material bin has reached the upper limit or does not meet the storage rules',
    id: 'Penyimpanan gagal, ada nama sisa yang berulang atau gudang sisa telah mencapai batas atau tidak memenuhi aturan penyimpanan',
    kz: 'Кіру сәтсіз болды, қалдықтар атауы қайталанады немесе қалдықтар сағына сақтау шегіне жетті немесе кіру ережелерін қанағаттандырмайды',
    th: 'การนำเข้าล้มเหลว มีชื่อวัสดุที่เหลือที่ซ้ำกันหรือคลังวัสดุที่เหลือถูกเก็บมากกว่าขีดจำกัดสูงสุดหรือไม่ตรงกับกฎการนำเข้า',
    ug: 'سېلىش مەغلۇپ بولدى، چۈنكى ئارتۇق ماتېرىيال ئىسمى تەكرارلاندى ياكى ئامبارنىڭ چەكلىمىسىگە يەتتى ياكى سېلىش قائىدىسىگە ئۇيغۇن ئەمەس',
    vi: 'Nhập kho không thành công, tồn tại trùng lặp tên của vật liệu dư hoặc lưu trữ thùng dư đạt đến giới hạn trên hoặc không đáp ứng các quy tắc nhập kho',
    zh_tc: '入庫失敗，存在餘料名稱重複或餘料倉存放達到上限或不滿足入庫規則',
    ru: 'Ошибка складирования, наличие повторяющихся имен излишков или хранение излишков в бункере до верхнего предела или не соответствует правилам складирования',
    ko: '입고 실패, 잉여 재료 이름 중복 또는 잉여 재료 창고 보관이 상한선에 도달하거나 입고 규칙을 만족시키지 못함',
    bur: 'ဂိုဒေါင်ဝင်မမှုမအောင်မြင်၊ ပိုလျှံပစ္စည်းအမည်တူညီမှုရှိသည် သို့မဟုတ် ဂိုဒေါင်ကန့်သတ်ချက်ရောက်ပြီ သို့မဟုတ် စည်းမျဉ်းမပြည့်မီ',
    ben: 'গুদামে যোগ ব্যর্থ, উদ্বৃত্ত নাম ডুপ্লিকেট বা গুদাম সীমায় পৌঁছেছে বা স্টোরেজ নিয়ম পূরণ করে না',
    tr: 'Depoya alınamadı: yinelenen ad, kapasite üst sınırı veya kurallar uyumsuz',
    km: 'ចូលឃ្លាំងបរាជ័យ៖ ឈ្មោះស្ទួន ឬពេញ ឬមិនត្រូវច្បាប់',
    es: 'El almacenamiento falló, hay un nombre duplicado del material restante o el almacenamiento del silo de material restante ha alcanzado el límite superior o no cumple con las reglas de almacenamiento',
    ar: 'فشل التخزين، أو يوجد اسم مكرر للمادة المتبقية أو أن تخزين صومعة المواد المتبقية قد وصل إلى الحد الأعلى أو لا يستوفي قواعد التخزين',
  },
  'surplusPage.surplusExistTip': {
    zh: '部分余料板件已经在库中，此次操作失败',
    en: 'Some remaining materials have already been stored, this operation failed',
    id: 'Beberapa bahan residu telah disimpan, operasi ini gagal',
    kz: 'Бір қатар қалдық материалдар қоймасында бар, бұл әрекет сәтсіз болды',
    th: 'บางส่วนของวัสดุที่เหลืออยู่ถูกนำเข้าไปแล้ว การดำเนินการนี้ล้มเหลว',
    ug: 'بىر قەتتە ئارتۇق ماتېرىيال ئامبارى قالدۇق ماتېرىيال ئامبارىدا كۆرۈلگەن، ئۇ ئىشلىتىش مەغلۇپ بولدى',
    vi: 'Một số vật liệu dư đã tồn tại trong kho, thao tác này không thành công',
    zh_tc: '部分餘料板件已經在庫中，此次操作失敗',
    ru: 'Часть излишков уже в хранилище, операция не удалась',
    ko: '일부 남은 원판 부품이 이미 라이브러리에 있으므로 이번 작업은 실패했습니다.',
    bur: 'ပိုလျှံပစ္စည်းအချို့ဂိုဒေါင်ထဲရှိပြီးဖြစ်ပြီးဤလုပ်ဆောင်မှုမအောင်မြင်',
    ben: 'কিছু উদ্বৃত্ত ইতিমধ্যে গুদামে আছে, এই অপারেশন ব্যর্থ হয়েছে',
    tr: 'Bazı artık parçalar zaten depoda; işlem başarısız',
    km: 'សម្ភារៈសល់មួយចំនួននៅក្នុងឃ្លាំងរួច ប្រតិបត្តិការបរាជ័យ',
    es: 'Algunos paneles de material restante ya están en la biblioteca, esta operación falló',
    ar: 'بعض لوحات المواد المتبقية موجودة بالفعل في المكتبة، وقد فشلت هذه العملية',
  },
  'surplusPage.surplusExistTip2': {
    zh: '当前余料板件已经在库中，无法进行入库',
    en: 'The current remaining material has already been stored, this operation failed',
    id: 'Bahan residu saat ini telah disimpan, operasi ini gagal',
    kz: 'Қалдық материалдар қоймасында бар, бұл әрекет сәтсіз болды',
    th: 'วัสดุที่เหลืออยู่ในปัจจุบันถูกนำเข้าไปแล้ว ไม่สามารถนำเข้าได้',
    ug: 'ھازىر ئارتۇق ماتېرىيال ئامبارى قالدۇق ماتېرىيال ئامبارىدا كۆرۈلگەن، سېلىش قوزغىتىلمىغان',
    vi: 'Vật liệu dư hiện tại đã tồn tại trong kho, không thể nhập kho',
    zh_tc: '當前餘料板件已經在庫中，無法進行入庫',
    ru: 'В настоящее время остаточный материал уже находится в хранилище и не может быть складирован',
    ko: '현재 남은 원판 부품이 이미 라이브러리에 있으므로 입고할 수 없습니다.',
    bur: 'လက်ရှိပိုလျှံပစ္စည်းဂိုဒေါင်ထဲရှိပြီးဂိုဒေါင်ဝင်မနိုင်',
    ben: 'বর্তমান উদ্বৃত্ত ইতিমধ্যে গুদামে আছে, গুদামে যোগ করা যাবে না',
    tr: 'Mevcut artık parça zaten depoda; depoya alınamaz',
    km: 'សម្ភារៈសល់បច្ចុប្បន្ននៅក្នុងឃ្លាំងរួច មិនអាចចូលឃ្លាំង',
    es: 'Los paneles de material restante actuales ya están en la biblioteca y no se pueden almacenar',
    ar: 'الحالي لوحات المواد المتبقية موجودة بالفعل في المكتبة ولا يمكن تخزينها',
  },
  'surplusPage.currentPage': {
    zh: '当前页',
    en: 'Current Page',
    id: 'Halaman Saat Ini',
    kz: 'Қазіргі бет',
    th: 'หน้าปัจจุบัน',
    ug: 'ھازىر بەت',
    vi: 'Trang hiện tại',
    zh_tc: '當前頁',
    ru: 'Текущая страница',
    ko: '현재 페이지',
    bur: 'လက်ရှိစာမျက်နှာ',
    ben: 'বর্তমান পৃষ্ঠা',
    tr: 'Geçerli sayfa',
    km: 'ទំព័របច្ចុប្បន្ន',
    es: 'Página actual',
    ar: 'الصفحة الحالية',
  },
  'surplusPage.totalPage': {
    zh: '选择所有',
    en: 'Select All',
    id: 'Pilih Semua',
    kz: 'Барлығын таңдау',
    th: 'เลือกทั้งหมด',
    ug: 'تولۇقلاش',
    vi: 'Chọn tất cả',
    zh_tc: '全選所有',
    ru: 'Выбрать все',
    ko: '모두 선택',
    bur: 'အားလုံးရွေး',
    ben: 'সব নির্বাচন করুন',
    tr: 'Tümünü seç',
    km: 'ជ្រើសទាំងអស់',
    es: 'Seleccionar todo',
    ar: 'حدد الكل',
  },
  'printPage.goto': {
    zh: '立即前往',
    en: 'Go immediately',
    id: 'Pergi sekarang',
    kz: 'Дереу бару',
    th: 'ไปทันที',
    ug: 'دەرھال بېرىش',
    vi: 'Đi ngay',
    zh_tc: '立即前往',
    ru: 'Немедленно отправляйтесь',
    ko: '즉시 이동',
    bur: 'ချက်ချင်းသွား',
    ben: 'এখনই যান',
    tr: 'Hemen git',
    km: 'ទៅភ្លាមៗ',
    es: 'Ir ahora',
    ar: 'اذهب الآن',
  },
  'printPage.surplusSizeTittle': {
    zh: '余料尺寸过小提示',
    en: 'Surplus Size Too Small Warning',
    id: 'Peringatan Ukuran Sisa Terlalu Kecil',
    kz: 'Қалдық өлшемі тым кішкентай ескерту',
    th: 'คำเตือนขนาดเศษวัสดุเล็กเกินไป',
    ug: 'قالدۇق ماتېرىيال ئۆلچىمى بەك كىچىك ئاگاھلاندۇرۇش',
    vi: 'Cảnh báo kích thước vật liệu thừa quá nhỏ',
    zh_tc: '餘料尺寸過小提示',
    ru: 'Небольшой размер остатка',
    ko: '남은 재료 치수 팁',
    bur: 'ပိုလျှံပစ္စည်းအတိုင်းအတာသေးငယ်သတိပေး',
    ben: 'উদ্বৃত্তের আকার অনেক ছোট সতর্কবার্তা',
    tr: 'Artık boyut çok küçük uyarısı',
    km: 'ការព្រមានទំហំសល់តូចពេក',
    es: 'Recuerde que el tamaño del material restante es demasiado pequeño',
    ar: 'تذكير بأن حجم المادة المتبقية صغير جدًا',
  },
  'printPage.surplusSizeErrTip': {
    zh: '余料尺寸过小，请前往对应生产线设置余料最小尺寸！',
    en: 'The surplus size is too small. Please go to the corresponding production line to set the minimum surplus size!',
    id: 'Ukuran sisa terlalu kecil, silakan pergi ke jalur produksi yang sesuai untuk mengatur ukuran minimum sisa!',
    kz: 'Қалдық өлшемі тым кішкентай, қалдықтың ең кіші өлшемін орнату үшін сәйкес өндіріс желісіне өтіңіз!',
    th: 'ขนาดเศษวัสดุเล็กเกินไป กรุณาไปที่สายการผลิตที่เกี่ยวข้องเพื่อตั้งค่าขนาดเศษวัสดุขั้นต่ำ!',
    ug: 'قالدۇق ماتېرىيال ئۆلچىمى بەك كىچىك، قالدۇق ماتېرىيالنىڭ ئەڭ كىچىك ئۆلچىمىنى تەڭشەش ئۈچۈن مۇناسىۋەتلىك ئىشلەپچىقىرىش لىنىيىسىگە بېرىڭ!',
    vi: 'Kích thước vật liệu thừa quá nhỏ, vui lòng đến dây chuyền sản xuất tương ứng để đặt kích thước tối thiểu của vật liệu thừa!',
    zh_tc: '餘料尺寸過小，請前往對應生產線設置餘料最小尺寸！',
    ru: 'Размер остатка слишком мал, пожалуйста, идите на соответствующую производственную линию, чтобы установить минимальный размер остатка!',
    ko: '남은 재료의 사이즈가 너무 작으니, 해당 생산 라인에 가서 남은 재료의 최소 사이즈를 설정하세요!',
    bur: 'ပိုလျှံပစ္စည်းအတိုင်းအတာသေးငယ်လွန်းသည်၊ သင့်တော်သောထုတ်လုပ်မှုလိုင်းတွင်အနည်းဆုံးအတိုင်းအတာသတ်မှတ်ပါ!',
    ben: 'উদ্বৃত্তের আকার অনেক ছোট, সংশ্লিষ্ট উৎপাদন লাইনে ন্যূনতম আকার সেট করুন!',
    tr: 'Artık boyut çok küçük; ilgili üretim hattında minimum artık boyutunu ayarlayın',
    km: 'ទំហំសល់តូចពេក សូមទៅបន្ទាត់ផលិតកំណត់ទំហំអប្បបរមា',
    es: 'El tamaño del material restante es demasiado pequeño, vaya a la línea de producción correspondiente para establecer el tamaño mínimo del material restante.',
    ar: 'حجم المادة المتبقية صغير جدًا، يرجى الانتقال إلى خط الإنتاج المقابل لتعيين الحد الأدنى لحجم المادة المتبقية!',
  },
  'printPage.opacityTip': {
    zh: '由智绘彩标提供技术支持',
    en: 'Technically supported by EZsort',
    id: 'Didukung secara teknis oleh EZsort',
    kz: 'Техникалық қолдауды EZsort ұсынады',
    th: 'ได้รับการสนับสนุนทางเทคนิคโดย EZsort',
    ug: 'تېخنىكىلىق قوللاش EZsort تەمىنلەيدۇ',
    vi: 'Được hỗ trợ kỹ thuật bởi EZsort',
    zh_tc: '由智繪彩標提供技術支持',
    ru: 'Техническая поддержка со стороны & lt; & lt; умных карт & gt; & gt;',
    ko: '지능형 컬러 레이블에 의한 기술 지원',
    bur: 'ဇိနိဘဲဆွဲကာလူနာဦးစောင်မထောက်ခဲ',
    ben: 'EZsort দ্বারা প্রযুক্তিগত সহায়তা প্রদত্ত',
    tr: 'Teknik destek: EZsort',
    km: 'គាំទ្របច្ចេកទេសដោយ EZsort',
    es: 'Soporte técnico proporcionado por Zhihui Color Label',
    ar: 'الدعم الفني المقدم من Zhihui Color Label',
  },
  'printPage.opacityTip2': {
    zh: '当前账号未购买智绘彩标;如已购买,请在彩标软件内绑定柜柜账号',
    en: 'The current account has not purchased Smart Color Labels; if already purchased, please bind the cabinet account in the Color Label software',
    id: 'Akun saat ini belum membeli Smart Color Label; jika sudah membeli, harap hubungkan akun kabinet di perangkat lunak Color Label',
    kz: 'Ағымдағы тіркелгі Smart Color Labels сатып алмаған; егер сатып алған болсаңыз, Color Label бағдарламасында шкаф тіркелгісін байланыстырыңыз',
    th: 'บัญชีปัจจุบันยังไม่ได้ซื้อ Smart Color Labels หากซื้อแล้ว โปรดผูกบัญชีตู้ในซอฟต์แวร์ Color Label',
    ug: 'نۆۋەتتىكى ھېسابات Smart Color Labels سېتىۋالمىغان؛ ئەگەر سېتىۋالغان بولسىڭىز، Color Label يۇمشاق دېتالىدا كابىنېت ھېساباتىنى باغلاڭ',
    vi: 'Tài khoản hiện tại chưa mua Nhãn màu thông minh; nếu đã mua, vui lòng liên kết tài khoản tủ trong phần mềm Nhãn màu',
    zh_tc: '當前帳號未購買智繪彩標;如已購買,請在彩標軟體內綁定櫃櫃帳號',
    ru: 'Текущий аккаунт не покупает смарт - карты; Если вы уже купили, пожалуйста, свяжите учетную запись шкафа в программном обеспечении лотереи',
    ko: '현재 계정은 지화채표를 구매하지 않았습니다.구매한 경우 컬러 레이블 소프트웨어에 캐비닛 계정 바인딩',
    bur: 'လက်ရှိအကောင့်ကိုးကျောင်းကာလူနာမ၀ယ်ရသေး',
    ben: 'বর্তমান অ্যাকাউন্ট Smart Color Labels কেনেনি; কিনলে Color Label সফটওয়্যারে ক্যাবিনেট অ্যাকাউন্ট বাঁধুন',
    tr: 'Hesapta Smart Color Labels yok; satın alındıysa Color Label yazılımında dolap hesabını bağlayın',
    km: 'គណនីមិនទាន់ទិញ Smart Color Labels បើទិញរួច សូមភ្ជាប់គណនីទូនៅកម្មវិធី Color Label',
    es: 'La cuenta actual no ha comprado Zhihui Color Label; si lo compró, vincule la cuenta del gabinete en el software de etiquetas de color',
    ar: 'لم يقم الحساب الحالي بشراء Zhihui Color Label؛ إذا تم شراؤه، يرجى ربط حساب الخزانة في برنامج تسمية الألوان',
  },
  'printPage.loadFontTip': {
    zh: '正在加载所需字体资源文件，请稍等',
    en: 'Loading required font resource files, please wait',
    id: 'Memuat file sumber font yang diperlukan, silakan tunggu',
    kz: 'Қажетті қаріп ресурстық файлдарын жүктеу, күте тұрыңыз',
    th: 'กำลังโหลดไฟล์ทรัพยากรฟอนต์ที่จำเป็น กรุณารอสักครู่',
    ug: 'كېرەكلىك يېزىق رەسۇرس ھۆججىتى يۈكلىنىۋاتىدۇ، سەل كۈتۈڭ',
    vi: 'Đang tải tệp tài nguyên phông chữ cần thiết, vui lòng đợi',
    zh_tc: '正在載入所需字體資源文件，請稍候',
    ru: 'Загружается файл требуемых ресурсов шрифта, пожалуйста, подождите',
    ko: '필요한 글꼴 에셋 파일을 로드하는 중입니다. 잠시만 기다려 주십시오.',
    bur: 'လိုအပ်သောဖောင့်ဖိုင်တင်နေသည်ခဏစောင့်ပါ',
    ben: 'প্রয়োজনীয় ফন্ট রিসোর্স ফাইল লোড হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন',
    tr: 'Gerekli yazı tipi kaynakları yükleniyor, lütfen bekleyin',
    km: 'កំពុងផ្ទុកធនធានពុម្ពអក្សរ សូមរង់ចាំ',
    es: 'Cargando el archivo de recursos de fuente requerido, espere',
    ar: 'تحميل ملف مورد الخط المطلوب، يرجى الانتظار',
  },
  'printPage.leftAlign': {
    zh: '左对齐',
    en: 'Left Align',
    id: 'Kiri cetak',
    kz: 'Солға туралау',
    th: 'จัดตำแหน่งตามด้านซ้าย',
    ug: 'سولغا توغرىلاش',
    vi: 'Căn trái',
    zh_tc: '左對齊',
    ru: 'Выравнивание по левому краю',
    ko: '왼쪽 정렬',
    bur: 'ဘယ်ဘက်ညှိ',
    ben: 'বাম সারিবদ্ধ',
    tr: 'Sola hizala',
    km: 'តម្រឹមឆ្វេង',
    es: 'Alineación izquierda',
    ar: 'المحاذاة اليسرى',
  },
  'printPage.rightAlign': {
    zh: '右对齐',
    en: 'Right Align',
    id: 'Kanan cetak',
    kz: 'Оңға туралау',
    th: 'จัดตำแหน่งตามด้านขวา',
    ug: 'ئوڭغا توغرىلاش',
    vi: 'Căn phải',
    zh_tc: '右對齊',
    ru: 'Выравнивание по правому краю',
    ko: '오른쪽 정렬',
    bur: 'ညာဘက်ညှိ',
    ben: 'ডান সারিবদ্ধ',
    tr: 'Sağa hizala',
    km: 'តម្រឹមស្តាំ',
    es: 'Alineación derecha',
    ar: 'المحاذاة اليمنى',
  },
  'printPage.topAlign': {
    zh: '上对齐',
    en: 'Top Align',
    id: 'Atas cetak',
    kz: 'Жоғарғы туралау',
    th: 'จัดตำแหน่งตามด้านบน',
    ug: 'ئۈستىگە توغرىلاش',
    vi: 'Căn trên',
    zh_tc: '上對齊',
    ru: 'Выровнять вверх',
    ko: '위쪽 정렬',
    bur: 'အပေါ်ညှိ',
    ben: 'উপরে সারিবদ্ধ',
    tr: 'Üste hizala',
    km: 'តម្រឹមលើ',
    es: 'Alineación superior',
    ar: 'المحاذاة العلوية',
  },
  'printPage.bottomAlign': {
    zh: '下对齐',
    en: 'Bottom Align',
    id: 'Bawah cetak',
    kz: 'Төменгі туралау',
    th: 'จัดตำแหน่งตามด้านล่าง',
    ug: 'ئاستىغا توغرىلاش',
    vi: 'Căn dưới',
    zh_tc: '下對齊',
    ru: 'Выровнять снизу',
    ko: '아래 정렬',
    bur: 'အောက်ညှိ',
    ben: 'নিচে সারিবদ্ধ',
    tr: 'Alta hizala',
    km: 'តម្រឹមក្រោម',
    es: 'Alineación inferior',
    ar: 'محاذاة سفلية',
  },
  'printPage.horizontalAlign': {
    zh: '横向居中对齐',
    en: 'Horizontal Center Align',
    id: 'Cetak horisontal tengah',
    kz: 'Көлденең орталық туралау',
    th: 'จัดตำแหน่งตามด้านซ้ายและขวา',
    ug: 'توغرا ئوتتۇرىغا توغرىلاش',
    vi: 'Căn giữa ngang',
    zh_tc: '橫向居中對齊',
    ru: 'Горизонтальное выравнивание',
    ko: '가로로 가운데 맞춤',
    bur: 'အလျားလိုက်အလယ်ညှိ',
    ben: 'অনুভূমিক কেন্দ্র সারিবদ্ধ',
    tr: 'Yatay ortala',
    km: 'តម្រឹមកណ្តាលផ្ដេក',
    es: 'Alineación central horizontal',
    ar: 'محاذاة أفقية للمركز',
  },
  'printPage.verticalAlign': {
    zh: '竖向居中对齐',
    en: 'Vertical Center Align',
    id: 'Cetak vertikal tengah',
    kz: 'Тік орталық туралау',
    th: 'จัดตำแหน่งตามด้านบนและล่าง',
    ug: 'تىك ئوتتۇرىغا توغرىلاش',
    vi: 'Căn giữa dọc',
    zh_tc: '豎向居中對齊',
    ru: 'Выровнять вертикально - посередине',
    ko: '세로 중심 정렬',
    bur: 'ထောင်လိုက်အလယ်ညှိ',
    ben: 'উল্লম্ব কেন্দ্র সারিবদ্ধ',
    tr: 'Dikey ortala',
    km: 'តម្រឹមកណ្តាលបញ្ឈរ',
    es: 'Alineación central vertical',
    ar: 'محاذاة عمودية للمركز',
  },
  'printPage.horizontalSplit': {
    zh: '横向均分',
    en: 'Horizontal Equal Division',
    id: 'Pembagian horisontal sama rata',
    kz: 'Көлденең тең бөлу',
    th: 'จัดตำแหน่งตามด้านซ้ายและขวา',
    ug: 'توغرا تەڭ بۆلۈش',
    vi: 'Chia đều ngang',
    zh_tc: '橫向均分',
    ru: 'Горизонтальное равномерное распределение',
    ko: '가로 균분',
    bur: 'အလျားလိုက်တူညီကွဲ',
    ben: 'অনুভূমিক সমান বিভাজন',
    tr: 'Yatay eşit böl',
    km: 'ចែកស្មើផ្ដេក',
    es: 'División horizontal',
    ar: 'تقسيم أفقي',
  },
  'printPage.verticalSplit': {
    zh: '竖向均分',
    en: 'Vertical Equal Division',
    id: 'Pembagian vertikal sama rata',
    kz: 'Тік тең бөлу',
    th: 'จัดตำแหน่งตามด้านบนและล่าง',
    ug: 'تىك تەڭ بۆلۈش',
    vi: 'Chia đều dọc',
    zh_tc: '豎向均分',
    ru: 'Вертикальное равноденствие',
    ko: '세로 균분',
    bur: 'ထောင်လိုက်တူညီကွဲ',
    ben: 'উল্লম্ব সমান বিভাজন',
    tr: 'Dikey eşit böl',
    km: 'ចែកស្មើបញ្ឈរ',
    es: 'División vertical',
    ar: 'تقسيم عمودي',
  },
  'printPage.norTag': {
    zh: '常规原片标签',
    en: 'Normal Tag',
    id: 'Tag asli biasa',
    kz: 'Дәстүрлі түпнұсқ',
    th: 'ฉลากตัวอย่าง',
    ug: 'ئاساسىي بەلگىسى ھاسىلى',
    vi: 'Nhãn gốc thông thường',
    zh_tc: '常規原片標籤',
    ru: 'Обычная этикетка оригинала',
    ko: '일반 원본 레이블',
    bur: 'ပုံမှန်မူရင်းပေါ်ဒ်တံဆိပ်',
    ben: 'সাধারণ মূল শীট লেবেল',
    tr: 'Normal etiket',
    km: 'ស្លាកធម្មតា',
    es: 'Etiqueta original normal',
    ar: 'تسمية أصلية عادية',
  },
  'printPage.surTag': {
    zh: '余料大板标签',
    en: 'Surplus Tag',
    id: 'Tag bahan residu',
    kz: 'Қалдық үлкен тақтай',
    th: 'ฉลากวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال بەلگىسى ھاسىلى',
    vi: 'Dư liệu tấm nhãn',
    zh_tc: '餘料大板標籤',
    ru: 'Большие накладки',
    ko: '여분 대판 라벨',
    bur: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးတံဆိပ်',
    ben: 'উদ্বৃত্ত বড় বোর্ড লেবেল',
    tr: 'Artık büyük levha etiketi',
    km: 'ស្លាកផ្ទាំងធំសល់',
    es: 'Etiqueta de material restante',
    ar: 'تسمية المادة المتبقية',
  },
  'printPage.genTag': {
    zh: '生成标签',
    en: 'Generate tag',
    id: 'Menghasilkan tag',
    kz: 'Жасау тегі',
    th: 'สร้างฉลาก',
    ug: 'بەلگە ھاسىل قىلىش',
    vi: 'Tạo ra các nhãn hiệu',
    zh_tc: '生成標籤',
    ru: 'Создать метку',
    ko: '태그 생성',
    bur: 'တံဆိပ်ဖန်တီး',
    ben: 'ট্যাগ তৈরি করুন',
    tr: 'Etiket oluştur',
    km: 'បង្កើតស្លាក',
    es: 'Generar etiqueta',
    ar: 'إنشاء تسمية',
  },
  'printPage.all': {
    zh: '全选',
    en: 'Select all',
    id: 'Pilih semua',
    kz: 'Барлығын таңдау',
    th: 'เลือกทั้งหมด',
    ug: 'تولۇقلاش',
    vi: 'chọn tất cả',
    zh_tc: '全選',
    ru: 'Полная выборка',
    ko: '모두 선택',
    bur: 'အားလုံးရွေး',
    ben: 'সব নির্বাচন করুন',
    tr: 'Tümünü seç',
    km: 'ជ្រើសរើសទាំងអស់',
    es: 'Seleccione todo',
    ar: 'حدد الكل',
  },
  'printPage.deleteWarning': {
    zh: '温馨提示',
    en: 'Warm reminder',
    id: 'Tips yang baik',
    kz: 'Қайырлы ескерту',
    th: 'เคล็ดลับชนิด',
    ug: 'ئەسكەرتىش',
    vi: 'Gợi ý ấm áp',
    zh_tc: '溫馨提示',
    ru: 'Доброе напоминание',
    ko: '친절한 안내',
    bur: 'ဖြေရှင်းချက်',
    ben: 'বিজ্ঞপ্তি',
    tr: 'Nazik hatırlatma',
    km: 'ការរំលឹកដ៏កក់ក្តៅ',
    es: 'Recordatorio',
    ar: 'تذكير دافئ',
  },
  'printPage.print': {
    zh: '打印',
    en: 'print',
    id: 'Mencetak',
    kz: 'Қашықтыру',
    th: 'พิมพ์',
    ug: 'بېسىپ چىقىرىش',
    vi: 'In',
    zh_tc: '打印',
    ru: 'печать',
    ko: '인쇄',
    bur: 'ရိုက်နှိပ်',
    ben: 'মুদ্রণ করুন',
    tr: 'Yazdır',
    km: 'បោះពុម្ព',
    es: 'Imprimir',
    ar: 'طباعة',
  },
  'printPage.defaultTemplate': {
    zh: '默认模版（60 x 40）',
    en: 'Default Template（60 x 40）',
    id: 'Template default (60 x 40)',
    kz: 'Әдетті шаблон（60 x 40）',
    th: 'เทมเพลตเริ่มต้น (60 x 40)',
    ug: 'سۈكۈتتىكى قېلىپ (60 x 40)',
    vi: 'Mẫu mặc định（60 x 40）',
    zh_tc: '默認模版（60 x 40）',
    ru: 'Шаблоны по умолчанию (60 x 40)',
    ko: '기본 템플릿(60 x 40)',
    bur: 'မူရင်းပုံစံ（60 x 40）',
    ben: 'ডিফল্ট টেমপ্লেট（60 x 40）',
    tr: 'Varsayılan şablon (60 x 40)',
    km: 'ពុម្ពដើម (60 x 40)',
    es: 'Plantilla predeterminada (60 x 40)',
    ar: 'القالب الافتراضي (60 × 40)',
  },
  'printPage.editTemplate': {
    zh: '编辑模板',
    en: 'Edit Template',
    id: 'Edit Template',
    kz: 'Шаблонды өңдеу',
    th: 'แก้ไขเทมเพลต',
    ug: 'قېلىپ تەھرىرلەش',
    vi: 'Chỉnh sửa mẫu',
    zh_tc: '編輯模板',
    ru: 'Изменить шаблон',
    ko: '템플릿 편집',
    bur: 'ပုံစံတည်းဖြတ်',
    ben: 'টেমপ্লেট সম্পাদনা করুন',
    tr: 'Şablonu düzenle',
    km: 'កែសម្រួលពុម្ព',
    es: 'Editar plantilla',
    ar: 'تحرير القالب',
  },
  'printPage.deleteTip': {
    zh: '删除该模板后不可恢复，是否确认删除该模板？',
    en: 'Deleting this template cannot be restored. Are you sure you want to delete it?',
    id: 'Itu tidak dapat dipulihkan setelah menghapus template. Apakah Anda pasti akan menghapus template?',
    kz: 'Шаблонды жоюдан кейін оны қалпына келтіруге болмайды, шаблонды жоюға жоспарлануда мурайсыз ба?',
    th: 'ไม่สามารถกู้คืนได้หลังจากลบเทมเพลต คุณแน่ใจว่าจะลบเทมเพลตได้หรือไม่?',
    ug: 'بۇ قېلىپنى ئۆچۈرگەندىن كېيىن قايتۇرۇشقا بولمايدۇ، ئۆچۈرۈشنى جازالامسىز؟',
    vi: 'Mẫu sẽ không thể khôi phục sau khi xóa, bạn có chắc chắn muốn xóa mẫu này?',
    zh_tc: '刪除該模板後不可恢復，是否確認刪除該模板？',
    ru: 'После удаления шаблона он не может быть восстановлен, подтверждается ли удаление шаблона?',
    ko: '템플릿을 삭제한 후 복구할 수 없습니다. 삭제하시겠습니까?',
    bur: 'ပုံစံဖျက်ပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tr: 'Bu şablon silindikten sonra geri yüklenemez. Silmek istediğinizden emin misiniz?',
    km: 'ការលុបពុម្ពនេះមិនអាចស្តារឡើងវិញបានទេ។ តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    es: 'No se puede restaurar la eliminación de esta plantilla. ¿Estás seguro de eliminar esta plantilla?',
    ar: 'لا يمكن استعادة حذف هذا القالب. هل أنت متأكد من حذف هذا القالب؟',
  },
  'printPage.tagSetting': {
    zh: '标签设置',
    en: 'Label Setting',
    id: 'Pengaturan Tag',
    kz: 'Тегтерді орнату',
    th: 'การตั้งค่าแท็ก',
    ug: 'بەلگە تەڭشەكلىرى',
    vi: 'Cài đặt nhãn',
    zh_tc: '標籤設置',
    ru: 'Настройки метки',
    ko: '레이블 설정',
    bur: 'တံဆိပ်ဆက်တင်',
    ben: 'লেবেল সেটিংস',
    tr: 'Etiket ayarları',
    km: 'ការកំណត់ស្លាក',
    es: 'Configuración de etiquetas',
    ar: 'إعدادات الملصقات',
  },
  'printPage.rememberSetting': {
    zh: '修改后将记住设置',
    en: 'The setting will be remembered after modification',
    id: 'Setelah modifikasi, pengaturan akan diingat',
    kz: 'Орнатудан кейін орнатуларды сақтайды',
    th: 'หลังจากการแก้ไขการตั้งค่าจะถูกจดจำ',
    ug: 'ئۆزگەرتىلگەندىن كېيىن تەڭشەكلەر ساقلانىدۇ',
    vi: 'Cài đặt sẽ được ghi nhớ sau khi thay đổi',
    zh_tc: '修改後將記住設置',
    ru: 'После внесения изменений запоминаются параметры',
    ko: '수정 후 설정에 유의하기',
    bur: 'ပြင်ဆင်ပြီးနောက်ဆက်တင်မှတ်ထားမည်',
    ben: 'সংশোধনের পরে সেটিং মনে রাখা হবে',
    tr: 'Değişiklikten sonra ayar hatırlanacak',
    km: 'ការកំណត់នឹងត្រូវបានចងចាំបន្ទាប់ពីកែប្រែ',
    es: 'La configuración se recordará después de la modificación',
    ar: 'سيتم تذكر الإعدادات بعد التعديل',
  },
  'printPage.genCutingTag': {
    zh: '生成裁剪余料板件标签',
    en: 'Generate the label for the cutting board',
    id: 'Hasilkan label kliping',
    kz: 'Кесу бөлшектеріне тегтерді құру',
    th: 'สร้างฉลากตัด',
    ug: 'كېسىلگەن تاختا بەلگىسى ھاسىل قىلىش',
    vi: 'Tạo nhãn các phần đã cắt',
    zh_tc: '生成裁剪板件標籤',
    ru: 'Создать метку обрезки',
    ko: '트림된 원단 탭 생성하기',
    bur: 'ဖြတ်တောက်ပိုလျှံပစ္စည်းပေါ်ဒ်တံဆိပ်ဖန်တီး',
    ben: 'কাটা বোর্ডের লেবেল তৈরি করুন',
    tr: 'Kesim tahtası parçası etiketi oluştur',
    km: 'បង្កើតស្លាកផ្ទាំងកាត់',
    es: 'Generar etiquetas para paneles recortados',
    ar: 'إنشاء ملصقات للألواح المشذبة',
  },
  'printPage.genSurplusTag': {
    zh: '生成余料板件标签',
    en: 'Generate surplus tag',
    id: 'Menghasilkan label bahan residu',
    kz: 'Қалдықтарға тегтерді құру',
    th: 'สร้างฉลากวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال بەلگىسى ھاسىل قىلىش',
    vi: 'Tạo nhãn dư liệu',
    zh_tc: '生成餘料標籤',
    ru: 'Создать этикетку',
    ko: '남은 원판 부품 레이블 생성하기',
    bur: 'ပိုလျှံပစ္စည်းပေါ်ဒ်တံဆိပ်ဖန်တီး',
    ben: 'উদ্বৃত্ত বোর্ডের লেবেল তৈরি করুন',
    tr: 'Artık malzeme etiketi oluştur',
    km: 'បង្កើតស្លាកសម្ភារៈសល់',
    es: 'Generar etiquetas para paneles restantes',
    ar: 'إنشاء ملصقات للألواح المتبقية',
  },
  'printPage.genPlankTag': {
    zh: '生成大板标签',
    en: 'Generate a large board tag',
    id: 'Menghasilkan label papan besar',
    kz: 'Кескіштерге тегтерді құру',
    th: 'สร้างฉลากบอร์ดขนาดใหญ่',
    ug: 'چوڭ تاختا بەلگىسى ھاسىل قىلىش',
    vi: 'Tạo nhãn tấm lớn',
    zh_tc: '生成大板標籤',
    ru: 'Создание больших вкладок',
    ko: '대시보드 레이블 생성',
    bur: 'ပေါ်ဒ်ကြီးတံဆိပ်ဖန်တီး',
    ben: 'বড় বোর্ডের লেবেল তৈরি করুন',
    tr: 'Büyük tahta etiketi oluştur',
    km: 'បង្កើតស្លាកផ្ទាំងធំ',
    es: 'Generar etiquetas para paneles grandes',
    ar: 'إنشاء ملصقات للألواح الكبيرة',
  },
  'printPage.genPartTag': {
    zh: '生成小板标签',
    en: 'Generate Small Plate Labels',
    id: 'Menghasilkan tag papan kecil',
    kz: 'Кіші тақта белгілерін жасау',
    th: 'สร้างแท็กบอร์ดขนาดเล็ก',
    ug: 'كىچىك تاختا بەلگىسى ھاسىل قىلىش',
    vi: 'Tạo nhãn đĩa nhỏ',
    zh_tc: '生成小板標籤',
    ru: 'Создать вкладку',
    ko: '보드 레이블 생성하기',
    bur: 'ပေါ်ဒ်ငယ်တံဆိပ်ဖန်တီး',
    ben: 'ছোট বোর্ডের লেবেল তৈরি করুন',
    tr: 'Küçük tahta etiketi oluştur',
    km: 'បង្កើតស្លាកផ្ទាំងតូច',
    es: 'Generar etiquetas para paneles pequeños',
    ar: 'إنشاء ملصقات للألواح الصغيرة',
  },
  'printPage.genNoCutTag': {
    zh: '生成不下料板件标签',
    en: 'Generate no-cut plank tag',
    id: 'Menghasilkan tag papan tidak memotong',
    kz: 'Кесбейтін тақта белгісін жасау',
    th: 'สร้างแท็กแผ่นที่ไม่ตัด',
    ug: 'كەسمەس تاختا بەلگىسى ھاسىل قىلىش',
    vi: 'Tạo nhãn tấm không cắt',
    zh_tc: '生成不下料板件標籤',
    ru: 'Создать вкладку',
    ko: '원판 부품 레이블을 생성할 수 없음',
    bur: 'မဖြတ်ပေါ်ဒ်တံဆိပ်ဖန်တီး',
    ben: 'নো-কাট বোর্ডের লেবেল তৈরি করুন',
    tr: 'Kesilmeyen tahta etiketi oluştur',
    km: 'បង្កើតស្លាកផ្ទាំងមិនកាត់',
    es: 'Generar etiquetas para paneles sin cortar',
    ar: 'إنشاء ملصقات للألواح غير المقطوعة',
  },
  'printPage.tagPosition': {
    zh: '贴标位置',
    en: 'Label Position',
    id: 'Lokasi Pelabelan',
    kz: 'Тегтерді орналастыру орны',
    th: 'ตำแหน่งการติดฉลาก',
    ug: 'بەلگە قويۇش ئورنى',
    vi: 'Vị trí nhãn',
    zh_tc: '貼標位置',
    ru: 'Местоположение метки',
    ko: '부착 위치',
    bur: 'တံဆိပ်ကပ်နေရာ',
    ben: 'লেবেল অবস্থান',
    tr: 'Etiket konumu',
    km: 'ទីតាំងស្លាក',
    es: 'Posición de etiquetado',
    ar: 'موضع الملصقات',
  },
  'printPage.tagPositionTip': {
    zh: '(贴标机才需填写下方X/Y坐标)',
    en: '(Only the labeling machine needs to fill in the X/Y coordinates below)',
    id: '(Mesin pelabelan perlu mengisi koordinat x/y di bawah)',
    kz: '(Тегтерді орналастыру машинасына туалды X/Y координаталарын толтыру керек)',
    th: '(เครื่องติดฉลากต้องเติมในพิกัด X/Y ด้านล่าง)',
    ug: '(بەلگە قويغۇچ ماشىنىلا تۆۋەندىكى X/Y كوئوردىناتلىرىنى تولدۇرۇش زۆرۈر)',
    vi: '(Chỉ cần điền vào tọa độ X/Y nếu sử dụng máy dánh nhãn)',
    zh_tc: '(貼標機才需填寫下方X/Y座標)',
    ru: '(Для маркировки машины необходимо заполнить координаты X / Y ниже)',
    ko: '(아래 X/Y 좌표는 어댑터에 입력해야 함)',
    bur: '(တံဆိပ်ကပ်စက်သာX/Yကိုဩဒိနိတ်ဖြည့်ရမည်)',
    ben: '(শুধুমাত্র লেবেলিং মেশিনের জন্য নিচের X/Y স্থানাঙ্ক পূরণ করতে হবে)',
    tr: '(Yalnızca etiketleme makinesi aşağıdaki X/Y koordinatlarını doldurmalıdır)',
    km: '(មានតែម៉ាស៊ីនដាក់ស្លាកប៉ុណ្ណោះដែលត្រូវបំពេញកូអរដោនេ X/Y ខាងក្រោម)',
    es: '(Solo para máquinas etiquetadoras, debe completar el X/Y coordenadas a continuación.)',
    ar: '(فقط بالنسبة لآلات وضع الملصقات، تحتاج إلى ملء البيانات الإحداثيات X/Y أدناه.)',
  },
  'printPage.Xposition': {
    zh: 'X坐标',
    en: 'X coordinate',
    id: 'X Koordinat',
    kz: 'X координата',
    th: 'พิกัด x',
    ug: 'X كوئوردىناتى',
    vi: 'Tọa độ X',
    zh_tc: 'X座標',
    ru: 'Координаты X',
    ko: 'X 좌표',
    bur: 'X ကိုဩဒိနိတ်',
    ben: 'X স্থানাঙ্ক',
    tr: 'X koordinatı',
    km: 'កូអរដោនេ X',
    es: 'XCoordenadas',
    ar: 'Xالإحداثيات',
  },
  'printPage.Yposition': {
    zh: 'Y坐标',
    en: 'Y coordinate',
    id: 'Koordinat y',
    kz: 'Y координата',
    th: 'Y Coordinates',
    ug: 'Y كوئوردىناتى',
    vi: 'Tọa độ Y',
    zh_tc: 'Y座標',
    ru: 'Координаты Y',
    ko: 'Y 좌표',
    bur: 'Y ကိုဩဒိနိတ်',
    ben: 'Y স্থানাঙ্ক',
    tr: 'Y koordinatı',
    km: 'កូអរដោនេ Y',
    es: 'YCoordenadas',
    ar: 'Yالإحداثيات',
  },
  'printPage.genPlankSuffix': {
    zh: '大板标签生成下料文件名后缀',
    en: 'The suffix of the file name for the large board label generation',
    id: 'Label papan besar menghasilkan akhiran nama file',
    kz: 'Кескіштерге тегтерді орналастыру үшін файл аты суфіксі',
    th: 'ฉลากบอร์ดขนาดใหญ่สร้างชื่อไฟล์ต่อท้าย',
    ug: 'چوڭ تاختا بەلگىسى ھاسىل قىلغاندا ھۆججەت نامى قوشۇمچىسى',
    vi: 'Hậu tố tên tệp của nhãn tấm lớn',
    zh_tc: '大板標籤生成下料文件名後綴',
    ru: 'Большие вкладки создают суффикс имени файла',
    ko: '보드 레이블은 원본 파일 이름 접미어를 생성합니다.',
    bur: 'ပေါ်ဒ်ကြီးတံဆိပ်ဖန်တီးချိန်ဖိုင်အမည်နောက်ဆက်',
    ben: 'বড় বোর্ড লেবেল জেনারেট করার ফাইলের নামের সাফিক্স',
    tr: 'Büyük tahta etiketi için dosya adı son eki',
    km: 'បច្ច័យឈ្មោះឯកសារសម្រាប់ស្លាកផ្ទាំងធំ',
    es: 'Sufijo del nombre del archivo de borrado de generación de etiquetas de placa grande',
    ar: 'إنشاء علامة لوحة كبيرة مما يؤدي إلى طمس لاحقة اسم الملف',
  },
  'printPage.arrangeMirror': {
    zh: '标签图镜像',
    en: 'Label image mirror',
    id: 'Tag Image Mirror',
    kz: 'Тегтердің суреттеріні көзге айналдыру',
    th: 'Tag Image Mirror',
    ug: 'بەلگە رەسىمىنى ئەكس ئەتتۈرۈش',
    vi: 'Hình ảnh nhãn phản chiếu',
    zh_tc: '標籤圖鏡像',
    ru: 'Отражение диаграммы вкладок',
    ko: '탭 이미지 미러링',
    bur: 'တံဆိပ်ပုံမှန်ပြောင်းပြန်',
    ben: 'লেবেল ইমেজ মিরর',
    tr: 'Etiket görüntüsü aynalama',
    km: 'រូបភាពស្លាកឆ្លុះ',
    es: 'Espejo de imagen de etiqueta',
    ar: 'مرآة صورة الملصق',
  },
  'printPage.drillPlankBase': {
    zh: '五六面钻放板基准',
    en: 'Five or six drill-and-place plate benchmarks',
    id: 'Pengeboran lima sisi dan referensi pelat',
    kz: 'Бес-алты жақталық бұралу үстелдің базасы',
    th: 'การขุดเจาะห้าหกด้านและการอ้างอิงแผ่น',
    ug: 'بەش/ئالتە تەرەپلىك ئېگىزلىك ماتور تاختا ئاساسى',
    vi: 'Chuẩn mực đặt tấm của máy khoan 5-6 mặt',
    zh_tc: '五六面鑽放板基準',
    ru: 'пятигранная опора',
    ko: '5, 6면 드릴 방판 기준',
    bur: 'ငါးချက်ခြောက်မျက်နှာတွင်းထွင်းပြားအခြေခံ',
    ben: 'পাঁচ বা ছয় ড্রিল-এন্ড-প্লেস প্লেট বেঞ্চমার্ক',
    tr: 'Beş veya altı yüz delik yerleştirme plakası referansı',
    km: 'ស្តង់ដារដាក់ផ្ទាំងសម្រាប់រន្ធដោតប្រាំ ឬប្រាំមួយមុខ',
    es: 'Referencia de colocación y perforación de cinco o seis lados',
    ar: 'مسند الحفر والوضع بخمسة أو ستة جوانب',
  },
  'printPage.drillPlankBaseTip': {
    zh: '获取放板基准数据错误，请稍后再试！',
    en: 'Failed to retrieve base data for plank placement. Please try again later!',
    id: 'Gagal mengambil data dasar untuk peletakan papan. Silakan coba lagi nanti!',
    kz: 'Тақта орналастырудың негізгі деректерін алу сәтсіз аяқталды. Кейінірек қайталап көріңіз!',
    th: 'ไม่สามารถดึงข้อมูลฐานสำหรับการวางแผ่นได้ กรุณาลองใหม่ภายหลัง!',
    ug: 'تاختا قويۇشنىڭ ئاساسلىق سانلىق مەلۇماتىنى قازىۋالغىلى بولمىدى، كېيىن قايتا سىناڭ!',
    vi: 'Lấy dữ liệu cơ sở để đặt ván thất bại, vui lòng thử lại sau!',
    zh_tc: '獲取放板基準數據錯誤，請稍後再試！',
    ru: 'Ошибка получения базовых данных на листе загрузки, попробуйте позже!',
    ko: '플레이트 기준 데이터 가져오기 오류, 나중에 다시 시도하십시오!',
    bur: 'ပြားချထားမှုအခြေခံဒေတာမရ၊ နောက်မှပြန်ကြိုးစားပါ!',
    ben: 'প্ল্যাঙ্ক প্লেসমেন্টের বেস ডেটা পেতে ব্যর্থ, পরে আবার চেষ্টা করুন!',
    tr: 'Plaka yerleştirme temel verileri alınamadı. Lütfen daha sonra tekrar deneyin!',
    km: 'មិនអាចទាញយកទិន្នន័យមូលដ្ឋានសម្រាប់ដាក់ផ្ទាំងបានទេ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ!',
    es: 'Error al obtener los datos de referencia de colocación de la placa, ¡inténtelo de nuevo más tarde!',
    ar: 'خطأ في الحصول على بيانات مسند وضع اللوحة، يرجى المحاولة مرة أخرى لاحقًا!',
  },
  'printPage.suitAuto': {
    zh: '标签排序适应自动上下料：',
    en: 'Label sorting adapts to automatic loading and unloading:',
    id: 'Penyortiran tag beradaptasi dengan pemuatan dan pembongkaran otomatis:',
    kz: 'Тегтерді автоматты түрде жоғалту/қосуға бейімделу:',
    th: 'การจัดเรียงแท็กปรับให้เข้ากับการโหลดและขนถ่ายอัตโนมัติ:',
    ug: 'بەلگە تەرتىپى ئاپتوماتىك يۈكلىمىگە ماسلىشىدۇ:',
    vi: 'Sắp xếp nhãn phù hợp với tự động đặt/hạ tám:',
    zh_tc: '標籤排序適應自動上下料：',
    ru: 'Сортировка этикеток для автоматической загрузки:',
    ko: '라벨 정렬은 자동 상하 재료에 적합합니다.',
    bur: 'တံဆိပ်စီမှုအလိုအလျောက်အပေါ်အောက်နှင့်ကိုက်ညီ:',
    ben: 'লেবেল সর্টিং অটো লোড/আনলোডের সাথে মানানসই:',
    tr: 'Etiket sıralaması otomatik yükleme/boşaltmaya uyarlanır:',
    km: 'ការរៀបចំស្លាកសម្របទៅនឹងការផ្ទុក/ចុះសម្ភារៈស្វ័យប្រវត្តិ៖',
    es: 'La clasificación de etiquetas se adapta a la carga y descarga automática:',
    ar: 'يتم تكييف فرز الملصقات للتحميل والتفريغ التلقائي:',
  },
  'printPage.colorLabel': {
    zh: '生成彩色标签',
    en: 'Generate color labels',
    id: 'Menghasilkan tag warna',
    kz: 'Түс белгілерін жасау',
    th: 'สร้างแท็กสี',
    ug: 'رەڭلىك بەلگە ھاسىل قىلىش',
    vi: 'Tạo nhãn màu',
    zh_tc: '生成彩色標籤',
    ru: 'Создание цветных меток',
    ko: '색상 레이블 생성',
    bur: 'အရောင်တံဆိပ်များဖန်တီး',
    ben: 'রঙিন লেবেল তৈরি করুন',
    tr: 'Renkli etiket oluştur',
    km: 'បង្កើតស្លាកពណ៌',
    es: 'Generar etiquetas de color',
    ar: 'إنشاء ملصقات ملونة',
  },
  'printPage.colorRevert': {
    zh: '生成小板反色标签',
    en: 'Generate reversed color labels for small boards',
    id: 'Membuat tag warna refleks panel kecil',
    kz: 'Кіші тақырыптың түсін қарама-қарсы етіп белгілеу',
    th: 'สร้างฉลากเปลี่ยนสีจานเล็ก ๆ',
    ug: 'كۆپىك نەقىرىزىتىگە ئەسلى قىلغان ئىشارەتچە تىزىم',
    vi: 'Tạo nhãn màu phản chiếu cho tấm nhỏ',
    zh_tc: '生成小板反色標籤',
    ru: 'Создать метку',
    ko: '슬레이트 색상 반전 레이블 생성하기',
    bur: 'ပေါ်ဒ်ငယ်ပြောင်းပြန်အရောင်တံဆိပ်ဖန်တီး',
    ben: 'ছোট বোর্ডের জন্য উল্টো রঙের লেবেল তৈরি করুন',
    tr: 'Küçük tahtalar için ters renkli etiket oluştur',
    km: 'បង្កើតស្លាកពណ៌បញ្ច្រាសសម្រាប់ផ្ទាំងតូច',
    es: 'Generar etiquetas de color inverso para paneles pequeños',
    ar: 'إنشاء ملصقات ألوان عكسية للألواح الصغيرة',
  },
  'printPage.displayEnAndZh': {
    zh: '房间/柜体/板件名展示中英文',
    en: 'Display room/cabinet/panel name in English and Chinese',
    id: 'Tampilkan nama ruang/kabinet/panel dalam bahasa Inggris dan Cina',
    kz: 'Бөлме/шкаф/панель атауын ағылшын және қытай тілдерінде көрсету',
    th: 'แสดงชื่อห้อง/ตู้/แผ่นเป็นภาษาอังกฤษและภาษาจีน',
    ug: 'ئۆي/كابينېت/قانچە نامىنى ئىنگلىزچە ۋە خەنزۇچە كۆرسىتىش',
    vi: 'Hiển thị tên phòng/tủ/panel bằng tiếng Anh và tiếng Trung',
    zh_tc: '房間/櫃體/板件名展示中英文',
    ru: 'Название комнаты / шкафа / доски Показать на английском языке',
    ko: '방/캐비닛/판본명 전시 중영문',
    bur: 'အခန်း/ကက်ဘိန/ပြားအမည်ကိုအင်္ဂလိပ်တရုတြသခြင်း',
    ben: 'রুম/ক্যাবিনেট/প্যানেল নাম ইংরেজি ও চীনে দেখান',
    tr: 'Oda/dolap/panel adını İngilizce ve Çince göster',
    km: 'បង្ហាញឈ្មោះបន្ទប់/ទូ/ផ្ទាំងជាភាសាអង់គ្លេស និងចិន',
    es: 'Visualización del nombre de habitación/gabinete/panel en chino e inglés',
    ar: 'عرض اسم الغرفة/الخزانة/اللوحة باللغتين الصينية والإنجليزية',
  },
  'printPage.displayEnAndZhTip': {
    zh: '仅支持默认的房间/柜体名/板件名，修改为自定义名称后该功能不生效',
    en: 'Only supports default room/cabinet/panel names. This feature will not work after modifying to custom names',
    id: 'Hanya mendukung nama ruang/kabinet/panel default. Fitur ini tidak akan berfungsi setelah diubah ke nama kustom',
    kz: 'Тек әдепкі бөлме/шкаф/панель атауларын қолдайды. Жеке атауларға өзгерткеннен кейін бұл мүмкіндік жұмыс істемейді',
    th: 'รองรับเฉพาะชื่อห้อง/ตู้/แผ่นเริ่มต้นเท่านั้น ฟีเจอร์นี้จะไม่ทำงานหลังจากแก้ไขเป็นชื่อที่กำหนดเอง',
    ug: 'پەقەت سۈكۈتتىكى ئۆي/كابينېت/قانچە ناملىرىنى قوللايدۇ. ئىختىيارى نامغا ئۆزگەرتكەندىن كېيىن بۇ ئىقتىدار ئىشلەمەيدۇ',
    vi: 'Chỉ hỗ trợ tên phòng/tủ/panel mặc định. Tính năng này sẽ không hoạt động sau khi sửa thành tên tùy chỉnh',
    zh_tc: '僅支持默認的房間/櫃體名/板件名，修改為自定義名稱後該功能不生效',
    ru: 'Поддерживаются только имена комнат / шкафов / панелей по умолчанию, и эта функция не вступает в силу после изменения имени',
    ko: '기본 공간 / 캐비닛 이름 / 보드 이름만 지원되며 사용자 정의 이름으로 수정하면 이 기능은 적용되지 않습니다.',
    bur: 'မူရင်းအခန်း/ကက်ဘိန/ပြားအမည်သာပံ့ပိုး၊ စိတ်ကြိုက်ပြင်ပြီးနောက်မအလုပ်လုပ်',
    ben: 'শুধুমাত্র ডিফল্ট রুম/ক্যাবিনেট/প্যানেল নাম সমর্থন, কাস্টম নামে পরিবর্তনের পর এই ফিচার কাজ করবে না',
    tr: 'Yalnızca varsayılan oda/dolap/panel adları desteklenir; özel adlara geçince bu özellik çalışmaz',
    km: 'គាំទ្រតែឈ្មោះបន្ទប់/ទូ/ផ្ទាំងលំនាំដើមប៉ុណ្ណោះ។ បន្ទាប់ពីប្តូរទៅឈ្មោះផ្ទាល់ខ្លួន មុខងារនេះមិនដំណើរការទេ',
    es: 'Solo admite el nombre predeterminado de habitación/gabinete/panel. Esta función no tiene efecto después de cambiar a un nombre personalizado',
    ar: 'يدعم فقط اسم الغرفة/الخزانة/اسم اللوحة الافتراضي. لا تصبح هذه الوظيفة نافذة المفعول بعد التغيير إلى اسم مخصص',
  },
  'printPage.up': {
    zh: '向上',
    en: 'upward',
    id: 'ke atas',
    kz: 'Жоғару',
    th: 'ขึ้น',
    ug: 'ئۈستىگە',
    vi: 'Lên',
    zh_tc: '向上',
    ru: 'вверх',
    ko: '위로',
    bur: 'အပေါ်သို့',
    ben: 'উপরে',
    tr: 'Yukarı',
    km: 'ឡើងលើ',
    es: 'Arriba',
    ar: 'لأعلى',
  },
  'printPage.down': {
    zh: '向下',
    en: 'downward',
    id: 'turun',
    kz: 'Төмен',
    th: 'ลง',
    ug: 'ئاستىغا',
    vi: 'Xuống',
    zh_tc: '向下',
    ru: 'Вниз',
    ko: '아래로',
    bur: 'အောက်သို့',
    ben: 'নিচে',
    tr: 'Aşağı',
    km: 'ចុះក្រោម',
    es: 'Abajo',
    ar: 'لأسفل',
  },
  'printPage.default': {
    zh: '默认',
    en: 'Default',
    id: 'bawaan',
    kz: 'Әдетті',
    th: 'ค่าเริ่มต้น',
    ug: 'سۈكۈتتىكى',
    vi: 'Mặc định',
    zh_tc: '默認',
    ru: 'по умолчанию',
    ko: '기본',
    bur: 'မူရင်း',
    ben: 'ডিফল্ট',
    tr: 'Varsayılan',
    km: 'លំនាំដើម',
    es: 'Predeterminado',
    ar: 'الافتراضي',
  },
  'printPage.printSetting': {
    zh: '打印设置',
    en: 'Print Settings',
    id: 'Pengaturan cetak',
    kz: 'Қашықтыру орнату',
    th: 'การตั้งค่าการพิมพ์',
    ug: 'بېسىپ چىقىرىش تەڭشەكلىرى',
    vi: 'Cài đặt in',
    zh_tc: '打印設置',
    ru: 'Параметры печати',
    ko: '인쇄 설정',
    bur: 'ရိုက်နှိပ်ဆက်တင်',
    ben: 'প্রিন্ট সেটিংস',
    tr: 'Yazdırma ayarları',
    km: 'ការកំណត់បោះពុម្ព',
    es: 'Configuración de impresión',
    ar: 'إعدادات الطباعة',
  },
  'printPage.oneToMore': {
    zh: '一张多页',
    en: 'One page with multiple pages',
    id: 'Beberapa halaman per gambar',
    kz: 'Бір бетті көбірек бетке бölшектеу',
    th: 'หลายหน้าต่อภาพ',
    ug: 'بىر بەتتە كۆپ بەت',
    vi: 'Một trang nhiều trang',
    zh_tc: '一張多頁',
    ru: 'Несколько страниц.',
    ko: '여러 페이지',
    bur: 'တစ်ချပ်များစွာစာမျက်နှာ',
    ben: 'এক পৃষ্ঠায় একাধিক পৃষ্ঠা',
    tr: 'Bir sayfada birden çok',
    km: 'ច្រើនទំព័រក្នុងមួយសន្លឹក',
    es: 'Varias páginas por página',
    ar: 'صفحات متعددة لكل صفحة',
  },
  'printPage.perPage': {
    zh: '每张',
    en: 'Each',
    id: 'Setiap',
    kz: 'Әр бет',
    th: 'แต่ละ',
    ug: 'ھەر بەتكە',
    vi: 'Mỗi trang',
    zh_tc: '每張',
    ru: 'Каждый',
    ko: '매 장',
    bur: 'အချပ်ချင်း',
    ben: 'প্রতি',
    tr: 'Her biri',
    km: 'ក្នុងមួយ',
    es: 'por hoja',
    ar: 'لكل ورقة',
  },
  'printPage.coloumn': {
    zh: '列',
    en: 'column',
    id: 'Daftar',
    kz: 'Столбец',
    th: 'รายการ',
    ug: 'ئىستون',
    vi: 'Cột',
    zh_tc: '列',
    ru: 'ряд',
    ko: '열',
    bur: 'ကော်လံ',
    ben: 'কলাম',
    tr: 'Sütun',
    km: 'ជួរឈរ',
    es: 'columnas',
    ar: 'أعمدة',
  },
  'printPage.tagMargin': {
    zh: '标签间隙',
    en: 'Label Gap',
    id: 'Label Gap',
    kz: 'Тегтер арас',
    th: 'ช่องว่างฉลาก',
    ug: 'بەلگە ئارىلىقى',
    vi: 'Khoảng cách nhãn',
    zh_tc: '標籤間隙',
    ru: 'Разрыв между метками',
    ko: '레이블 간격',
    bur: 'တံဆိပ်ကြားအကွာအဝေး',
    ben: 'লেবেল ফাঁক',
    tr: 'Etiket aralığı',
    km: 'គម្លាតស្លាក',
    es: 'espacio entre etiquetas',
    ar: 'فجوة التسمية',
  },
  'printPage.coloumnMargin': {
    zh: '列间距',
    en: 'Column spacing',
    id: 'Jarak kolom',
    kz: 'Столбец арасы',
    th: 'ระยะห่างคอลัมน์',
    ug: 'ئىستون ئارىلىقى',
    vi: 'Khoảng cách giữa các cột',
    zh_tc: '列間距',
    ru: 'Расстояние между столбцами',
    ko: '열 간격',
    bur: 'ကော်လံကြားအကွာအဝေး',
    ben: 'কলামের মধ্যে ফাঁক',
    tr: 'Sütun aralığı',
    km: 'គម្លាតជួរឈរ',
    es: 'espacio entre columnas',
    ar: 'تباعد الأعمدة',
  },
  'printPage.specialMark': {
    zh: '特殊标记',
    en: 'special mark',
    id: 'Tanda khusus',
    kz: 'Арнайы белгі',
    th: 'เครื่องหมายพิเศษ',
    ug: 'ئالاھىدە بەلگە',
    vi: 'Điểm đặc biệt',
    zh_tc: '特殊標記',
    ru: 'Специальные метки',
    ko: '특수 태그',
    bur: 'အထူးမှတ်သားချက်',
    ben: 'বিশেষ চিহ্ন',
    tr: 'Özel işaret',
    km: 'សញ្ញាពិសេស',
    es: 'marca especial',
    ar: 'علامة خاصة',
  },
  'printPage.opacity': {
    zh: '透明度',
    en: 'transparency',
    id: 'transparansi',
    kz: 'Ашықтық',
    th: 'ความโปร่งใส',
    ug: 'شەپسىزلىك',
    vi: 'Độ mờ',
    zh_tc: '透明度',
    ru: 'Транспарентность',
    ko: '투명도',
    bur: 'အပြင်အပြင်',
    ben: 'স্বচ্ছতা',
    tr: 'Şeffaflık',
    km: 'ភាពថ្លា',
    es: 'transparencia',
    ar: 'الشفافية',
  },
  'printPage.opacityTip3': {
    zh: 'BMP格式的图片需要选择真彩才支持透明度',
    en: 'BMP format images need to select true color to support transparency',
    id: 'BMP format images need to select true color to support transparency',
    kz: 'BMP форматты суреттерде ашықтықты қолдау үшін шын түсті таңдаңыз',
    th: 'BMP รูปภาพต้องเลือกสีจริงเพื่อรองรับความโปร่งใส',
    ug: 'BMP قۇرۇلۇق رەسىمىدا شەپسىزلىك ئىشلەتكەن بولىدۇ',
    vi: 'Hình ảnh BMP cần chọn màu thật để hỗ trợ độ mờ',
    zh_tc: 'BMP格式的圖片需要選擇真彩才支持透明度',
    ru: 'Фотографии в формате BMP требуют выбора цвета для обеспечения прозрачности',
    ko: 'BMP 형식의 그림은 투명도를 지원하기 위해 실제 색상을 선택해야 합니다.',
    bur: 'BMP ပုံသည်အပြင်အပြင် support ရန် true color ရွေးရမည်',
    ben: 'BMP ফরম্যাট ইমেজে স্বচ্ছতার জন্য ট্রু কালার সিলেক্ট করতে হবে',
    tr: 'BMP görsellerinde şeffaflık için gerçek renk seçilmelidir',
    km: 'រូបភាពទ្រង់ទ្រាយ BMP ត្រូវជ្រើសពណ៌ពិតប្រាកដដើម្បីគាំទ្រភាពថ្លា',
    es: 'Las imágenes en el formato BMP deben seleccionar un color verdadero para admitir la transparencia',
    ar: 'تحتاج الصور بتنسيق BMP إلى تحديد اللون الحقيقي لدعم الشفافية',
  },
  'printPage.suite': {
    zh: '自适应',
    en: 'Adaptive',
    id: 'Adaptif',
    kz: 'Аутоматты бейімделу',
    th: 'ปรับตัวได้',
    ug: 'ئۆزلۈكىدىن ماسلىشىش',
    vi: 'Tự động thích nghi',
    zh_tc: '自適應',
    ru: 'Самоадаптация',
    ko: '적응성',
    bur: 'အလိုအလျောက်ညှိ',
    ben: 'অ্যাডাপ্টিভ',
    tr: 'Uyarlanabilir',
    km: 'សម្របខ្លួន',
    es: 'Adaptable',
    ar: 'التكيف',
  },
  'printPage.svgListTip': {
    zh: '未开启生成小板标签，请在左侧勾选',
    en: 'The small board label generation is not enabled. Please check the box on the left.',
    id: 'Tag papan generasi tidak diaktifkan, silakan periksa di sebelah kiri',
    kz: 'Кішкентай тақта жапсырмасын жасау қосылмаған. Сол жақтағы ұяшықты таңдаңыз.',
    th: 'ไม่เปิดใช้งานแท็กบอร์ดรุ่นโปรดตรวจสอบทางด้านซ้าย',
    ug: 'كىچىك تاختا بەلگىسى ھاسىل قىلىش قوزغىتىلمىغان، سول تەرەپتە تاللاڭ',
    vi: 'Chưa bật chức năng tạo nhãn tấm ván nhỏ, vui lòng chọn ô ở bên trái.',
    zh_tc: '未開啟生成小板標籤，請在左側勾選',
    ru: 'Не открывать вкладку для создания панели, отметьте слева',
    ko: '스몰 보드 생성 탭을 열지 않았습니다. 왼쪽에서 선택하십시오.',
    bur: 'ပေါ်ဒ်ငယ်တံဆိပ်ဖန်တီးမဖွင့်ရ၊ ဘယ်ဘက်တွင်ရွေးပါ',
    ben: 'ছোট বোর্ড লেবেল জেনারেশন চালু নেই, বামে চেকবক্সে টিক দিন',
    tr: 'Küçük tahta etiketi oluşturma açık değil; soldan işaretleyin',
    km: 'មិនបានបើកបង្កើតស្លាកផ្ទាំងតូចទេ សូមធីកខាងឆ្វេង',
    es: 'La generación de etiquetas de tablero pequeño no está habilitada, verifique',
    ar: 'لم يتم تمكين إنشاء علامات اللوحة الصغيرة، يرجى التحقق من',
  },
  'printPage.size': {
    zh: '大小',
    en: 'Size',
    id: 'ukuran',
    kz: 'Өлшем',
    th: 'ขนาด',
    ug: 'چوڭ-كىچىكلىكى',
    vi: 'Kích thước',
    zh_tc: '大小',
    ru: 'размер',
    ko: '크기',
    bur: 'အရွယ်အစား',
    ben: 'আকার',
    tr: 'Boyut',
    km: 'ទំហំ',
    es: 'Tamaño',
    ar: 'الحجم',
  },
  'printPage.lightSide': {
    zh: '见光边',
    en: 'See the light side',
    id: 'Tepi cahaya',
    kz: 'Көрінетін кескіш',
    th: 'ขอบของแสง',
    ug: 'يورۇتۇش چېگرىسى',
    vi: 'Bên nhìn thấy',
    zh_tc: '見光邊',
    ru: 'Увидеть край света',
    ko: '광변 을 보다',
    bur: 'အလင်းမျက်နှာစာ',
    ben: 'আলোর দিক দেখা',
    tr: 'Görünen ışık kenarı',
    km: 'គែមឃើញពន្លឺ',
    es: 'Borde visible',
    ar: 'الحافة المرئية',
  },
  'printPage.locFrontSide': {
    zh: '柜体前边',
    en: 'front side of the cabinet',
    id: 'Depan kabinet',
    kz: 'Шкафтың алдыңғы жағы',
    th: 'ด้านหน้าของตู้',
    ug: 'قابا ئالدىنقى چېگرىسى',
    vi: 'Mặt trước tủ',
    zh_tc: '櫃體前邊',
    ru: 'передняя сторона шкафа',
    ko: '캐비닛 앞',
    bur: 'ကက်ဘိနက်ရှေ့မျက်နှာ',
    ben: 'ক্যাবিনেটের সামনের দিক',
    tr: 'Dolabın ön yüzü',
    km: 'មុខខាងមុខរបស់ទូ',
    es: 'Frente del gabinete',
    ar: 'واجهة الخزانة',
  },
  'printPage.openSide': {
    zh: '开门方向',
    en: 'Opening direction',
    id: 'Arah pembukaan pintu',
    kz: 'Ешуішін ашу дірексія',
    th: 'ทิศทางการเปิดประตู',
    ug: 'ئېچىش يۆنىلىشى',
    vi: 'Hướng mở cửa',
    zh_tc: '開門方向',
    ru: 'Направление открытия.',
    ko: '문 여는 방향',
    bur: 'တံခါးဖွင့်ရာဘက်',
    ben: 'দরজা খোলার দিক',
    tr: 'Açılış yönü',
    km: 'ទិសបើក',
    es: 'Dirección de apertura de la puerta',
    ar: 'اتجاه فتح الباب',
  },
  'printPage.extraTip': {
    zh: ' 提示：首次使用直接打印时，请在打印机设置中新增一张使用的该尺寸且长、宽对调的纸张，然后使用新增纸张进行打印（例：原纸张尺寸60×40，新增纸尺寸40×60） ',
    en: ' Attention: When using direct printing for the first time, please add a new sheet of paper with the same size and reversed length and width in the printer settings, and then use the new paper for printing. For example, the original paper size is 60×40, and the new paper size is 40×60',
    id: 'Kiat: Saat Anda menggunakan pencetakan langsung untuk pertama kalinya, silakan tambahkan selembar kertas dengan ukuran dan panjang dan lebar yang sama seperti yang digunakan dalam pengaturan printer, dan kemudian gunakan kertas baru untuk dicetak (Contoh: Ukuran kertas asli 60 × 40, ukuran kertas baru 40 × 60)',
    kz: ' Ескерту: Ешіңізді бірден басып шығаруға тырысқанда, принтердің параметрлерінде қолданылатын өлшемді және оның ені мен кескішін қалпына келтіруішінмен жаңа парақатты қосыңыз, содан кейін жаңа парақатты басып шығаруға болады (мысалы: алдын ала парақат өлшемі 60×40, жаңа парақат өлшемі 40×60)',
    th: 'เคล็ดลับ: เมื่อคุณใช้การพิมพ์โดยตรงเป็นครั้งแรกโปรดเพิ่มแผ่นกระดาษที่มีขนาดและความยาวและความกว้างเท่ากันกับที่ใช้ในการตั้งค่าเครื่องพิมพ์จากนั้นใช้กระดาษใหม่เพื่อพิมพ์ (ตัวอย่าง: ขนาดกระดาษดั้งเดิม 60 × 40 ขนาดกระดาษใหม่ 40 × 60)',
    ug: 'ئەسكەرتىش: بىرىنچى قېتىم بىۋاسىتە بېسىپ چىقىرىشتا، بېسىپ چىقىرىش تەڭشەكلىرىدە بۇ ئۆلچەمدە ۋە ئۇزۇنلۇقى، كەڭلىكى ئالماشتۇرۇلغان يېڭى قەغەز قوشۇڭ، ئاندىن يېڭى قوشۇلغان قەغەز بىلەن بېسىپ چىقىرىڭ (مىسال: ئەسلى قەغەز ئۆلچىمى 60×40 بولسا، يېڭى قەغەز ئۆلچىمى 40×60 قىلىپ قوشۇڭ)',
    vi: 'Chú ý: Khi sử dụng trực tiếp để in lần đầu tiên, vui lòng thêm một tờ giấy với kích thước sử dụng và chiều dài/chiều rộng điều chỉnh trong cài đặt máy in, sau đó sử dụng giấy mới để in (ví dụ: kích thước giấy gốc 60×40, kích thước giấy mới 40×60).',
    zh_tc:
      ' 提示：首次使用直接打印時，請在打印機設置中新增一張使用的該尺寸且長、寬對調的紙張，然後使用新增紙張進行打印（例：原紙張尺寸60×40，新增紙尺寸40×60） ',
    ru: 'Совет: При первом использовании прямой печати добавьте в настройки принтера новый лист бумаги этого размера, длинный и широкий, а затем распечатайте его с помощью новой бумаги (например, оригинальный размер бумаги 60×40, новый размер бумаги 40×60).',
    ko: '팁: 직접 인쇄를 처음 사용할 경우 프린터 설정에 해당 크기와 길이, 너비가 조정된 용지를 추가한 다음 새 용지를 사용하여 인쇄합니다 (예: 원래 용지 크기 60 × 40, 새 용지 크기 40 × 60).',
    bur: 'ပထမဆုံးတိုက်ရိုက်ရိုက်နှိပ်သုံးသည့်အခါပရင့်တာဆက်တင်တွင်အရွယ်တူအလျားအကျယ်ပြောင်းထားသောစာရွက်ထည့်ပြီးထိုစာရွက်ဖြင့်ရိုက်ပါ',
    ben: 'প্রথমবার ডাইরেক্ট প্রিন্ট ব্যবহার করলে প্রিন্টার সেটিংসে একই সাইজ ও লম্বা-চওড়া উলটানো কাগজ যোগ করুন, তারপর নতুন কাগজে প্রিন্ট করুন',
    tr: ' İpucu: Doğrudan yazdırmayı ilk kez kullanırken yazıcı ayarlarına, aynı boyutta ancak uzunluk ve genişliği ters çevrilmiş yeni bir kağıt ekleyin; ardından bu kağıtla yazdırın (örn. eski 60×40, yeni 40×60).',
    km: ' កំណត់សម្គាល់៖ នៅពេលប្រើការបោះពុម្ពផ្ទាល់លើកដំបូង សូមបន្ថែមក្រដាសថ្មីក្នុងការកំណត់ម៉ាស៊ីនបោះពុម្ពដែលមានទំហំដូចគ្នាប៉ុន្តែប្តូរបណ្តោយ និងទទឹង រួចប្រើក្រដាសនោះដើម្បីបោះពុម្ព (ឧ. ដើម 60×40 ថ្មី 40×60)។',
    es: 'Consejo: cuando utilice la impresión directa por primera vez, agregue un papel nuevo de este tamaño con longitud y ancho intercambiados en la configuración de la impresora y luego use el papel nuevo para imprimir (por ejemplo: tamaño de papel original). 60×40, nuevo tamaño de papel 40×60)',
    ar: 'نصيحة: عند استخدام الطباعة المباشرة لأول مرة، يرجى إضافة ورقة جديدة بهذا الحجم مع تبديل الطول والعرض في إعدادات الطابعة، ثم استخدم الورق الجديد للطباعة (على سبيل المثال: حجم الورق الأصلي) 60×40، حجم الورق الجديد 40×60)',
  },
  'printPage.noMore': {
    zh: '没有更多了',
    en: 'No more',
    id: 'Tidak lebih',
    kz: 'Бөлімдердің барлығы көрсетілген',
    th: 'ไม่มีอีกต่อไป',
    ug: 'تېخىمۇ كۆپ يوق',
    vi: 'Không có nữa',
    zh_tc: '沒有更多了',
    ru: 'Больше нет',
    ko: '더 이상 없어요',
    bur: 'နောက်ထပ်မရှိ',
    ben: 'আর নেই',
    tr: 'Başka yok',
    km: 'គ្មានទៀតហើយ',
    es: 'No más',
    ar: 'لا مزيد من',
  },
  'printPage.prepareData': {
    zh: '准备数据中...',
    en: 'Preparing data...',
    id: 'Siapkan data ...',
    kz: 'Деректер дайындалуда...',
    th: 'เตรียมข้อมูล ...',
    ug: 'سانلىق مەلۇمات تەييارلىنىۋاتىدۇ...',
    vi: 'Đang chuẩn bị dữ liệu...',
    zh_tc: '準備數據中...',
    ru: 'Готовьте данные. Это...',
    ko: '데이터 준비 중...',
    bur: 'ဒေတာပြင်ဆင်နေသည်...',
    ben: 'ডেটা প্রস্তুত করা হচ্ছে...',
    tr: 'Veriler hazırlanıyor...',
    km: 'កំពុងរៀបចំទិន្នន័យ...',
    es: 'Preparando datos...',
    ar: 'جارٍ إعداد البيانات...',
  },
  'printPage.genTagFile': {
    zh: '标签生成中，请勿进行页面切换、最小化浏览器、上下滚动标签等操作！',
    en: 'Generating tags, please do not switch pages, minimize the browser, or scroll the tags up and down!',
    id: 'Saat pembuatan tag sedang dihasilkan, tolong jangan lakukan switching halaman, meminimalkan browser, menggulir tag ke atas dan ke bawah, dll.!',
    kz: 'Тегтер жасалуда, беттерді ауыстырмаңыз, браузерді кішірейтпеңіз, тегтерді жоғары-төмен айналдырмаңыз!',
    th: 'เมื่อสร้างการสร้างแท็กโปรดอย่าทำการสลับเพจลดเบราว์เซอร์ย่อเลื่อนแท็กขึ้นและลง ฯลฯ !',
    ug: 'بەلگە ھاسىل قىلىنىۋاتىدۇ، بەتنى ئالماشتۇرماڭ، تور كۆرگۈچنى كىچىكلەتمەڭ، بەلگىنى ئۈستە-ئاستا قىلىپ سۈرەپ قويماڭ!',
    vi: 'Đang tạo nhãn, vui lòng không chuyển đổi trang, thu nhỏ trình duyệt, cuộn nhãn lên/xuống!',
    zh_tc: '標籤生成中，請勿進行頁面切換、最小化瀏覽器、上下滾動標籤等操作！',
    ru: 'При создании тегов, не выполняйте переключение страниц, минимизацию браузера, прокрутку вверх и вниз тегов и другие действия!',
    ko: '탭 생성 중, 페이지 전환, 브라우저 최소화, 탭 위아래로 스크롤 등을 하지 마십시오!',
    bur: 'တံဆိပ်ဖန်တီးနေသည်၊ စာမျက်နှာပြောင်းခြင်း၊ ဘရောက်ဆာခေါက်ခြင်း၊ တံဆိပ်အပေါ်အောက်လှိမ့်ခြင်းမပြုပါနှင့်!',
    ben: 'ট্যাগ জেনারেট হচ্ছে, পেজ সুইচ, ব্রাউজার মিনিমাইজ বা ট্যাগ উপরে-নিচে স্ক্রল করবেন না!',
    tr: 'Etiketler oluşturuluyor; sayfa değiştirmeyin, tarayıcıyı küçültmeyin veya etiketleri kaydırmayın!',
    km: 'កំពុងបង្កើតស្លាក សូមកុំប្តូរទំព័រ បង្រួមកម្មវិធីរុករក ឬរំកិលស្លាកឡើងចុះ!',
    es: 'Se están generando etiquetas. ¡No cambie de página, minimice el navegador, no se desplace hacia arriba o hacia abajo por las etiquetas, etc.!',
    ar: 'يتم الآن إنشاء الملصقات. يرجى عدم تبديل الصفحات، أو تصغير المتصفح، أو التمرير لأعلى أو لأسفل، وما إلى ذلك!',
  },
  'printPage.waitGen': {
    zh: '请等待标签加载完成后再进行下载',
    en: 'Please wait for the tags to load completely before downloading',
    id: 'Harap tunggu tag dimuat sebelum mengunduh',
    kz: 'Тегтердің жүктелуін күтіп, содан кейін жүктеуді орындаңыз',
    th: 'โปรดรอให้แท็กโหลดก่อนดาวน์โหลด',
    ug: 'بەلگە يۈكلەنگەندىن كېيىن چۈشۈرۈڭ',
    vi: 'Vui lòng đợi nhãn tải hoàn thành trước khi tải xuống',
    zh_tc: '請等待標籤加載完成後再進行下載',
    ru: 'Пожалуйста, подождите, пока метка не будет загружена.',
    ko: '라벨 로드가 완료될 때까지 기다린 후 다운로드하십시오.',
    bur: 'တံဆိပ်များပြည့်စုံစွာလာမှဒေါင်းလုတ်ပါ',
    ben: 'ট্যাগ সম্পূর্ণ লোড হওয়ার পর ডাউনলোড করুন',
    tr: 'İndirmeden önce etiketlerin tamamen yüklenmesini bekleyin',
    km: 'សូមរង់ចាំឱ្យស្លាកផ្ទុករួចរាល់មុនពេលទាញយក',
    es: 'Espere a que se complete la carga de la etiqueta antes de descargarla',
    ar: 'برجاء الانتظار حتى يكتمل تحميل الملصق قبل التنزيل',
  },
  'printPage.tempLoading': {
    zh: '标签模板加载中,请稍后',
    en: 'Loading tag template, please wait',
    id: 'Template tag sedang dimuat, harap tunggu',
    kz: 'Тег үлгісі жүктелуде, күтіңіз',
    th: 'เทมเพลตแท็กกำลังโหลดโปรดรอ',
    ug: 'بەلگە قېلىپى يۈكلىنىۋاتىدۇ، سەل ساقلاڭ',
    vi: 'Đang tải mẫu nhãn, vui lòng chờ',
    zh_tc: '標籤模板加載中,請稍後',
    ru: 'Шаблоны вкладок загружены позже',
    ko: '태그 템플릿 로드 중, 나중에',
    bur: 'တံဆိပ်ပုံစံလာနေသည်၊ ခဏစောင့်ပါ',
    ben: 'ট্যাগ টেমপ্লেট লোড হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন',
    tr: 'Etiket şablonu yükleniyor, lütfen bekleyin',
    km: 'កំពុងផ្ទុកពុម្ពស្លាក សូមរង់ចាំ',
    es: 'La plantilla de etiqueta se está cargando, espere',
    ar: 'جارٍ تحميل قالب الملصق، برجاء الانتظار',
  },
  'printPage.front': {
    zh: '前',
    en: 'Front',
    id: 'maju',
    kz: 'Алдыңғы',
    th: 'ซึ่งไปข้างหน้า',
    ug: 'ئالدى',
    vi: 'Trước',
    zh_tc: '前',
    ru: 'перед',
    ko: '앞',
    bur: 'ရှေ့',
    ben: 'সামনে',
    tr: 'Ön',
    km: 'ខាងមុខ',
    es: 'Anterior',
    ar: 'السابق',
  },
  'printPage.open': {
    zh: '开',
    en: 'Open',
    id: 'membuka',
    kz: 'Ашу',
    th: 'เปิด',
    ug: 'ئېچىش',
    vi: 'Mở',
    zh_tc: '開',
    ru: 'открыть',
    ko: '열다',
    bur: 'ဖွင့်',
    ben: 'খুলুন',
    tr: 'Aç',
    km: 'បើក',
    es: 'Abrir',
    ar: 'فتح',
  },
  'printPage.toEdit': {
    zh: '前往编辑',
    en: 'Go to Edit',
    id: 'Pergi ke Edit',
    kz: 'Өңдеуге өту',
    th: 'ไปแก้ไข',
    ug: 'تەھرىرلەشكە يۆتكەلەڭ',
    vi: 'Chuyển đến chỉnh sửa',
    zh_tc: '前往編輯',
    ru: 'Перейти к редактору',
    ko: '편집으로 이동',
    bur: 'တည်းဖြတ်သို့သွား',
    ben: 'এডিটে যান',
    tr: 'Düzenlemeye git',
    km: 'ទៅកែសម្រួល',
    es: 'Ir a editar',
    ar: 'اذهب للتحرير',
  },
  'printPage.simplifyOneCodeTip': {
    zh: '注意：此标签模板设置的条形码属性不支持使用“简易条码“功能，请修改条码属性（推荐条码属性：CODE128）',
    en: 'Attention: The barcode properties set in this tag template do not support the "Simple Barcode" function, please modify the barcode properties (recommended barcode property: CODE128)',
    id: 'Catatan: Atribut barcode yang ditetapkan oleh template tag ini tidak mendukung penggunaan fungsi "barcode sederhana". Harap Ubah Atribut Barcode (Atribut Barcode yang Disarankan: Code128)',
    kz: 'Назар аударыңыз: бұл тег үлгісіндегі штрих-код қасиеті "Қарапайым штрих-код" функциясын қолдамайды, штрих-код қасиетін өзгертіңіз (ұсынылған штрих-код қасиеті: CODE128)',
    th: 'หมายเหตุ: แอตทริบิวต์บาร์โค้ดที่ตั้งค่าโดยเทมเพลตแท็กนี้ไม่รองรับการใช้ฟังก์ชัน "บาร์โค้ดแบบง่าย" โปรดแก้ไขแอตทริบิวต์บาร์โค้ด (แอตทริบิวต์บาร์โค้ดที่แนะนำ: Code128)',
    ug: 'ئەسكەرتىش: بۇ بەلگە قېلىپىدا بەلگىلەنگەن سىزىق كود خاسلىقى "ئاددى سىزىق كود" ئىقتىدارىنى قوللىمايدۇ، سىزىق كود خاسلىقىنى ئۆزگەرتىڭ (تەۋسىيە قىلىنغان سىزىق كود خاسلىقى: CODE128)',
    vi: 'Chú ý: Thuộc tính mã vạch của mẫu nhãn này không hỗ trợ chức năng "Mã vạch đơn giản", vui lòng sửa đổi thuộc tính mã vạch (Thuộc tính mã vạch khuyến nghị: CODE128)',
    zh_tc:
      '注意：此標籤模板設置的條形碼屬性不支持使用"簡易條碼"功能，請修改條碼屬性（推薦條碼屬性：CODE128）',
    ru: 'Примечание: Свойства штрих - кода, установленные в этом шаблоне вкладки, не поддерживают использование функции « Простой штрих - код», измените свойства штрих - кода (рекомендуется свойство штрих - кода: CODE128)',
    ko: '참고: 이 태그 템플릿에 설정된 바코드 속성은 "간단한 바코드" 기능을 지원하지 않습니다. 바코드 속성을 수정하십시오(권장 바코드 속성: CODE128)',
    bur: 'ဤတံဆိပ်ပုံစံ၏ဘားကုဒ်ဆက်တင်သည်ရိုးရှင်းဘားကုဒ်ကိုမပံ့ပိုး၊ ဘားကုဒ်ဆက်တင်ပြင်ပါ(အကြံပြု CODE128)',
    ben: 'এই ট্যাগ টেমপ্লেটের বারকোড প্রপার্টি সিম্পল বারকোড সাপোর্ট করে না, বারকোড প্রপার্টি পরিবর্তন করুন (প্রস্তাবিত: CODE128)',
    tr: 'Dikkat: Bu etiket şablonundaki barkod özellikleri Basit Barkod işlevini desteklemez; barkod özelliklerini değiştirin (önerilen: CODE128)',
    km: 'ចំណាំ៖ លក្ខណៈបាកូដនៃពុម្ពស្លាកនេះមិនគាំទ្រមុខងារ «បាកូដសាមញ្ញ» ទេ សូមកែលក្ខណៈបាកូដ (ណែនាំ៖ CODE128)',
    es: 'Nota: Los atributos de código de barras establecidos en esta plantilla de etiqueta no admiten la función "Código de barras simple". Modifique los atributos del código de barras (atributos de código de barras recomendados: CODE128)',
    ar: 'ملاحظة: سمات الباركود المعينة في قالب الملصق هذا لا تدعم وظيفة "الرمز الشريطي البسيط"، يرجى تعديل سمات الباركود (سمات الباركود الموصى بها: CODE128)',
  },
  'printPage.plankTemp': {
    zh: '小板标签模板',
    en: 'Small Plank Tag Template',
    id: 'Template label papan kecil',
    kz: 'Шағын тақта тегінің үлгісі',
    th: 'เทมเพลตฉลากบอร์ดขนาดเล็ก',
    ug: 'كىچىك تاختا بەلگە قېلىپى',
    vi: 'Mẫu nhãn tấm nhỏ',
    zh_tc: '小板標籤模板',
    ru: 'Шаблоны: Метки',
    ko: '보드 레이블 템플릿',
    bur: 'ပေါ်ဒ်ငယ်တံဆိပ်ပုံစံ',
    ben: 'ছোট বোর্ড ট্যাগ টেমপ্লেট',
    tr: 'Küçük tahta etiket şablonu',
    km: 'ពុម្ពស្លាកផ្ទាំងតូច',
    es: 'Plantilla de etiqueta de placa pequeña',
    ar: 'قالب ملصق اللوحة الصغيرة',
  },
  'printPage.surplusTemp': {
    zh: '余料标签模板',
    en: 'Surplus Material Tag Template',
    id: 'Template label material yang tersisa',
    kz: 'Қалдық тегінің үлгісі',
    th: 'เทมเพลตฉลากวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال بەلگە قېلىپى',
    vi: 'Mẫu nhãn dư liệu',
    zh_tc: '餘料標籤模板',
    ru: 'Шаблоны: Оставшиеся метки',
    ko: '남은 재료 레이블 템플릿',
    bur: 'ပိုလျှံပစ္စည်းတံဆိပ်ပုံစံ',
    ben: 'উদ্বৃত্ত উপকরণ ট্যাগ টেমপ্লেট',
    tr: 'Artık malzeme etiket şablonu',
    km: 'ពុម្ពស្លាកសម្ភារៈសល់',
    es: 'Plantilla de etiqueta de material restante',
    ar: 'قالب ملصق المادة المتبقية',
  },
  'printPage.enableSubTag': {
    zh: '开启副标签',
    en: 'Enable Sub Label',
    id: 'Aktifkan label sekunder',
    kz: 'Қосалқы белгіні қосу',
    th: 'เปิดใช้งานป้ายรอง',
    ug: 'قوشۇمچە بەلگىنى ئېچىش',
    vi: 'Bật nhãn phụ',
    zh_tc: '開啟副標籤',
    ru: 'Включить дополнительную этикетку',
    ko: '부 라벨 사용',
    bur: 'အရန်တံဆိပ် ဖွင့်ရန်',
    ben: 'সাব লেবেল চালু করুন',
    tr: 'Alt etiketi etkinleştir',
    km: 'បើកស្លាកបន្ទាប់',
    es: 'Habilitar etiqueta secundaria',
    ar: 'تفعيل الملصق الثانوي',
  },
  'printPage.enableSubTagTip': {
    zh: '可以在更多设置-小板副标签设置-设置副标签生成的生效数据源，开启后只有设置的数据源在副标签上有值，才会生成副标签，反之则不生成副标签',
    en: 'You can go to More Settings > Small Panel Sub Label Settings > Set Effective Data Sources for Sub Label Generation. After enabling, a sub-label is generated only when the configured data source has a value on the sub-label; otherwise it will not be generated.',
    id: 'Anda dapat mengatur di Pengaturan Lainnya > Pengaturan label sekunder papan kecil > Atur sumber data efektif untuk pembuatan label sekunder. Setelah diaktifkan, label sekunder hanya dibuat jika sumber data yang diatur memiliki nilai pada label sekunder; jika tidak, tidak akan dibuat.',
    kz: 'Қосымша параметрлер > Шағын тақта қосалқы белгісін орнату > Қосалқы белгі жасаудың қолданылатын дереккөзін орнату бөлімінен баптауға болады. Қосқаннан кейін тек орнатылған дереккөздің қосалқы белгіде мәні болса ғана қосалқы белгі жасалады, әйтпесе жасалмайды.',
    th: 'สามารถตั้งค่าได้ที่ การตั้งค่าเพิ่มเติม > ตั้งค่าป้ายรองของแผ่นเล็ก > ตั้งค่าแหล่งข้อมูลที่มีผลสำหรับการสร้างป้ายรอง หลังจากเปิดใช้งาน จะสร้างป้ายรองเฉพาะเมื่อแหล่งข้อมูลที่ตั้งไว้มีค่าบนป้ายรอง มิฉะนั้นจะไม่สร้าง',
    ug: 'تېخىمۇ كۆپ تەڭشەك > كىچىك تاختا قوشۇمچە بەلگە تەڭشىكى > قوشۇمچە بەلگە ھاسىل قىلىشقا كۈچكە ئىگە سانلىق مەلۇمات مەنبەسىنى تەڭشەش ئارقىلىق تەڭشىسىڭىز بولىدۇ. ئېچىلغاندىن كېيىن، پەقەت تەڭشەلگەن مەنبە قوشۇمچە بەلگىدە قىممەتكە ئىگە بولغاندىلا قوشۇمچە بەلگە ھاسىل بولىدۇ، بولمىسا ھاسىل بولمايدۇ.',
    vi: 'Bạn có thể thiết lập tại Cài đặt khác > Cài đặt nhãn phụ tấm nhỏ > Thiết lập nguồn dữ liệu hiệu lực cho việc tạo nhãn phụ. Sau khi bật, chỉ khi nguồn dữ liệu đã cấu hình có giá trị trên nhãn phụ thì mới tạo nhãn phụ; ngược lại sẽ không tạo.',
    zh_tc:
      '可以在更多設置-小板副標籤設置-設置副標籤生成的生效數據源，開啟後只有設置的數據源在副標籤上有值，才會生成副標籤，反之則不生成副標籤',
    ru: 'Можно настроить в разделе «Дополнительные настройки» > «Настройки дополнительной этикетки малой плиты» > «Настройка действующего источника данных для генерации дополнительной этикетки». После включения дополнительная этикетка создается только если у заданного источника данных есть значение на дополнительной этикетке, иначе не создается.',
    ko: '더보기 설정 > 소판 부 라벨 설정 > 부 라벨 생성에 적용할 데이터 소스 설정에서 구성할 수 있습니다. 활성화 후 설정한 데이터 소스가 부 라벨에 값이 있을 때만 부 라벨이 생성되며, 그렇지 않으면 생성되지 않습니다.',
    bur: 'နောက်ထပ် ဆက်တင်များ > အကွက်ငယ် အရန်တံဆိပ် ဆက်တင် > အရန်တံဆိပ် ထုတ်လုပ်ရန် အကျိုးသက်ရောက်သော ဒေတာရင်းမြစ် သတ်မှတ်ရန် တွင် သတ်မှတ်နိုင်သည်။ ဖွင့်ပြီးနောက် သတ်မှတ်ထားသော ဒေတာရင်းမြစ်တွင် အရန်တံဆိပ်ပေါ် တန်ဖိုးရှိမှသာ အရန်တံဆိပ် ထုတ်လုပ်မည်၊ မဟုတ်ပါက ထုတ်လုပ်မည်မဟုတ်ပါ။',
    ben: 'আরও সেটিংস > ছোট প্যানেলের সাব লেবেল সেটিং > সাব লেবেল তৈরির কার্যকর ডেটা সোর্স সেট করুন থেকে সেট করা যায়। চালু করার পর শুধুমাত্র সেট করা ডেটা সোর্সের সাব লেবেলে মান থাকলেই সাব লেবেল তৈরি হবে, অন্যথায় তৈরি হবে না।',
    tr: 'Diğer ayarlar > Küçük levha alt etiketi ayarları > Alt etiket oluşturma için geçerli veri kaynağını ayarla bölümünden ayarlayabilirsiniz. Açıldıktan sonra yalnızca ayarlanan veri kaynağının alt etikette değeri varsa alt etiket oluşturulur; aksi halde oluşturulmaz.',
    km: 'អាចកំណត់នៅ ការកំណត់បន្ថែម > ការកំណត់ស្លាកបន្ទាប់ផ្ទាំងតូច > កំណត់ប្រភពទិន្នន័យដែលមានប្រសិទ្ធភាពសម្រាប់ការបង្កើតស្លាកបន្ទាប់។ បន្ទាប់ពីបើក ស្លាកបន្ទាប់នឹងត្រូវបានបង្កើតតែនៅពេលប្រភពទិន្នន័យដែលបានកំណត់មានតម្លៃនៅលើស្លាកបន្ទាប់ បើមិនដូច្នោះទេនឹងមិនបង្កើត។',
    es: 'Puede configurarlo en Más ajustes > Configuración de etiqueta secundaria de panel pequeño > Configurar la fuente de datos efectiva para la generación de etiqueta secundaria. Tras activarlo, solo se genera la etiqueta secundaria si la fuente de datos configurada tiene valor en ella; de lo contrario, no se genera.',
    ar: 'يمكن الضبط من المزيد من الإعدادات > إعدادات الملصق الثانوي للوح الصغير > تعيين مصدر البيانات الفعال لإنشاء الملصق الثانوي. بعد التفعيل يُنشأ الملصق الثانوي فقط عندما يكون لمصدر البيانات المضبوط قيمة على الملصق الثانوي، وإلا فلن يُنشأ.',
  },
  'printPage.goSet': {
    zh: '去设置',
    en: 'Go to Settings',
    id: 'Pergi ke pengaturan',
    kz: 'Параметрлерге өту',
    th: 'ไปที่การตั้งค่า',
    ug: 'تەڭشەككە بېرىش',
    vi: 'Đi tới cài đặt',
    zh_tc: '去設置',
    ru: 'Перейти к настройкам',
    ko: '설정으로 이동',
    bur: 'ဆက်တင်သို့ သွားရန်',
    ben: 'সেটিংসে যান',
    tr: 'Ayarlara git',
    km: 'ទៅកាន់ការកំណត់',
    es: 'Ir a ajustes',
    ar: 'الانتقال إلى الإعدادات',
  },
  'printPage.mainTag': {
    zh: '小板主标签',
    en: 'Small Panel Main Label',
    id: 'Label utama papan kecil',
    kz: 'Шағын тақта негізгі белгісі',
    th: 'ป้ายหลักของแผ่นเล็ก',
    ug: 'كىچىك تاختا ئاساسىي بەلگە',
    vi: 'Nhãn chính tấm nhỏ',
    zh_tc: '小板主標籤',
    ru: 'Основная этикетка малой плиты',
    ko: '소판 메인 라벨',
    bur: 'အကွက်ငယ် ပင်မတံဆိပ်',
    ben: 'ছোট প্যানেলের মূল লেবেল',
    tr: 'Küçük levha ana etiketi',
    km: 'ស្លាកមេផ្ទាំងតូច',
    es: 'Etiqueta principal de panel pequeño',
    ar: 'الملصق الرئيسي للوح الصغير',
  },
  'printPage.subTag': {
    zh: '小板副标签',
    en: 'Small Panel Sub Label',
    id: 'Label sekunder papan kecil',
    kz: 'Шағын тақта қосалқы белгісі',
    th: 'ป้ายรองของแผ่นเล็ก',
    ug: 'كىچىك تاختا قوشۇمچە بەلگە',
    vi: 'Nhãn phụ tấm nhỏ',
    zh_tc: '小板副標籤',
    ru: 'Дополнительная этикетка малой плиты',
    ko: '소판 부 라벨',
    bur: 'အကွက်ငယ် အရန်တံဆိပ်',
    ben: 'ছোট প্যানেলের সাব লেবেল',
    tr: 'Küçük levha alt etiketi',
    km: 'ស្លាកបន្ទាប់ផ្ទាំងតូច',
    es: 'Etiqueta secundaria de panel pequeño',
    ar: 'الملصق الثانوي للوح الصغير',
  },
  'printPage.downloadSubTagTip': {
    zh: '导出的标签带副标，自动贴标生产线暂时无法生成副标，是否继续输出？',
    en: 'The exported labels include a sub-label. The automatic labeling production line cannot generate sub-labels for now. Continue outputting?',
    id: 'Label yang diekspor memiliki label sekunder. Jalur produksi pelabelan otomatis sementara tidak dapat menghasilkan label sekunder. Lanjutkan output?',
    kz: 'Экспортталған белгілерде қосалқы белгі бар. Автоматты жапсыру өндірістік желісі әзірге қосалқы белгі жасай алмайды. Шығаруды жалғастырасыз ба?',
    th: 'ฉลากที่ส่งออกมีป้ายรอง สายการผลิตติดฉลากอัตโนมัติยังไม่สามารถสร้างป้ายรองได้ในขณะนี้ ต้องการส่งออกต่อหรือไม่?',
    ug: 'چىقىرىلغان بەلگىدە قوشۇمچە بەلگە بار، ئاپتوماتىك چاپلاش ئىشلەپچىقىرىش لىنىيىسى ۋاقتىنچە قوشۇمچە بەلگە ھاسىل قىلالمايدۇ. داۋاملىق چىقىرامسىز؟',
    vi: 'Nhãn xuất ra có nhãn phụ, dây chuyền dán nhãn tự động tạm thời không thể tạo nhãn phụ. Bạn có muốn tiếp tục xuất không?',
    zh_tc: '導出的標籤帶副標，自動貼標生產線暫時無法生成副標，是否繼續輸出？',
    ru: 'Экспортируемые этикетки содержат дополнительную этикетку. Автоматическая линия этикетирования временно не может создавать дополнительные этикетки. Продолжить вывод?',
    ko: '내보낸 라벨에 서브 라벨이 포함되어 있습니다. 자동 라벨링 생산 라인은 현재 서브 라벨을 생성할 수 없습니다. 계속 출력하시겠습니까?',
    bur: 'ထုတ်ယူသော တံဆိပ်တွင် အရန်တံဆိပ် ပါရှိသည်။ အလိုအလျောက် တံဆိပ်ကပ် စက်လိုင်းသည် လက်ရှိတွင် အရန်တံဆိပ် ထုတ်လုပ်၍ မရသေးပါ။ ဆက်လက် ထုတ်မည်လား။',
    ben: 'রপ্তানি করা লেবেলে সাব লেবেল আছে। স্বয়ংক্রিয় লেবেলিং প্রোডাকশন লাইন আপাতত সাব লেবেল তৈরি করতে পারে না। আউটপুট চালিয়ে যেতে চান?',
    tr: 'Dışa aktarılan etiketlerde alt etiket var. Otomatik etiketleme üretim hattı şu anda alt etiket oluşturamıyor. Çıktıya devam etmek istiyor musunuz?',
    km: 'ស្លាកដែលនាំចេញមានស្លាកបន្ទាប់។ ខ្សែសង្វាក់ផលិតកម្មបិទស្លាកស្វ័យប្រវត្តិបច្ចុប្បន្នមិនអាចបង្កើតស្លាកបន្ទាប់បានទេ។ តើអ្នកចង់បន្តនាំចេញទេ?',
    es: 'Las etiquetas exportadas incluyen una etiqueta secundaria. La línea de producción de etiquetado automático no puede generar etiquetas secundarias por el momento. ¿Desea continuar con la salida?',
    ar: 'تحتوي الملصقات المُصدَّرة على ملصق ثانوي، ولا تستطيع خط إنتاج الملصقات التلقائي إنشاء الملصقات الثانوية حالياً. هل تريد متابعة الإخراج؟',
  },
  'printPage.embeddedSubTagTip': {
    zh: '内嵌暂不支持副标签功能，请打开网页端云排版后使用',
    en: 'Embedded sub-label function is not supported. Please open the web-based cloud layout to use it.',
    id: 'Fungsi label sekunder tidak didukung. Silakan buka layout awan web untuk menggunakan fungsi tersebut.',
    kz: 'Қосалқы белгі функциясы қолдануға мүмкін емес. Қосалқы белгі функциясын қолдану үшін веб-негізделген айналасуды ашыңыз.',
    th: 'ฟังก์ชันป้ายรองไม่รองรับ โปรดเปิดการจัดวางออนไลน์เว็บเพื่อใช้งาน',
    ug: 'قوشۇمچە بەلگە قوشۇمچە بەلگە ھاسىل قىلالمايدۇ. قوشۇمچە بەلگە ھاسىل قىلالمايدۇ قويالايسىز، قوشۇمچە بەلگە ھاسىل قىلالمايدۇ قويالايسىز',
    vi: 'Chức năng nhãn phụ không được hỗ trợ. Vui lòng mở bố cục đám mây trên web để sử dụng',
    zh_tc: '內嵌暫不支持副標籤功能，請打開網頁端雲排版後使用',
    ru: 'Функция дополнительной этикетки не поддерживается. Откройте веб-основанный макет в облаке, чтобы использовать его.',
    ko: '부 라벨 기능은 지원되지 않습니다. 웹 기반 클라우드 레이아웃을 열어 사용하세요.',
    bur: 'အရန်တံဆိပ် ဖွင့်ရန် မရရှိပါ။ အရန်တံဆိပ် ဖွင့်ရန် မရရှိပါ။ အရန်တံဆိပ် ဖွင့်ရန် မရရှိပါ။',
    ben: 'সাব লেবেল ফাংশন সমর্থিত নয়। সাব লেবেল ফাংশন সমর্থিত নয়। সাব লেবেল ফাংশন সমর্থিত নয়।',
    tr: 'Alt etiket fonksiyonu desteklenmiyor. Lütfen web tabanlı bulut düzenini açarak kullanın.',
    km: 'ស្លាកបន្ទាប់សម្រួលមិនបានជោគជ័យ។ សូមបើកសម្លាកមានសម្រួលរបស់អ៊ីនធឺណិតដើម្បីប្រើសម្រួលនេះ។',
    es: 'La función de etiqueta secundaria no está soportada. Por favor, abra el diseño en la nube para usarlo.',
    ar: 'الوظيفة الثانوية للملصق غير مدعومة. يرجى فتح التصميم الإلكتروني للملصق لاستخدامه.',
  },
  'printPage.subTagPerSaveTip': {
    zh: '副标签权限已过期，请关闭副标签后重新保存',
    en: 'The secondary label permission has expired. Please close the secondary label and save again.',
    id: 'Izin label sekunder telah kadaluarsa. Silakan tutup label sekunder dan simpan kembali.',
    kz: 'Қосалқы белгі құқығы өтілді. Қосалқы белгіні қосуды қайтадан қолданыңыз.',
    th: 'สิทธิ์ป้ายรองได้สิ้นสุด โปรดปิดป้ายรองและบันทึกใหม่',
    ug: 'قوشۇمچە بەلگە قوشۇمچە بەلگە ھاسىل قىلالمايدۇ. قوشۇمچە بەلگە ھاسىل قىلالمايدۇ قويالايسىز، قوشۇمچە بەلگە ھاسىل قىلالمايدۇ قويالايسىز',
    vi: 'Quyền nhãn phụ đã hết hạn. Vui lòng đóng nhãn phụ và lưu lại',
    zh_tc: '副標籤權限已過期，請關閉副標籤後重新保存',
    ru: 'Права дополнительной этикетки истекли. Пожалуйста, закройте дополнительную этикетку и сохраните снова.',
    ko: '서브 라벨 권한이 만료되었습니다. 서브 라벨을 닫고 다시 저장하세요.',
    bur: 'အရန်တံဆိပ် အကူအညီပြုလုပ်ထားသည်။ အရန်တံဆိပ်ကိုပိတ်ပြီးတော့ပြီးမှာယူပါ။',
    ben: 'সাব লেবেল অনুমতি শেষ হয়েছে। সাব লেবেল বন্ধ করে এবং পুনরায় সংরক্ষণ করুন',
    tr: 'Alt etiket izni süresi doldu. Lütfen alt etiketi kapatın ve yeniden kaydedin.',
    km: 'ស្លាកបន្ទាប់សម្រួលមិនបានជោគជ័យ។ សូមបើកស្លាកបន្ទាប់សម្រួលដើម្បីរក្សាទុកម្តងទុកទៀត។',
    es: 'El permiso de etiqueta secundaria ha expirado. Por favor, cierre la etiqueta secundaria y guárdelo de nuevo.',
    ar: 'تمت إنتهاء صلاحية الملصق الثانوي. يرجى إغلاق الملصق الثانوي وحفظه مرة أخرى.',
  },
  'printPage.subTagPerexportTip': {
    zh: '输出生产文件包含付费的副标签权限，该功能已过期需关闭后重新输出',
    en: 'The exported production file contains paid secondary label permissions. This feature has expired and needs to be closed and output again.',
    id: 'Label sekunder yang dibayar termasuk dalam file produksi. Fitur ini telah kadaluarsa dan perlu ditutup dan dikeluarkan kembali.',
    kz: 'Экспортируемый производственный файл содержит платные права дополнительной этикетки. Эта функция истекла и требует закрытия и повторного вывода.',
    th: 'ฉลากที่ส่งออกมีสิทธิ์ป้ายรองที่ต้องจ่าย ฟังก์ชันนี้หมดอายุและต้องปิดและส่งออกอีกครั้ง',
    ug: 'چىقىرىلغان بەلگىدە قوشۇمچە بەلگە قوشۇمچە بەلگە ھاسىل قىلالمايدۇ. قوشۇمچە بەلگە ھاسىل قىلالمايدۇ قويالايسىز، قوشۇمچە بەلگە ھاسىل قىلالمايدۇ قويالايسىز',
    vi: 'Nhãn xuất ra có nhãn phụ, dây chuyền dán nhãn tự động tạm thời không thể tạo nhãn phụ. Bạn có muốn tiếp tục xuất không?',
    zh_tc: '導出的生產文件包含付費的副標籤權限，該功能已過期需關閉後重新輸出',
    ru: 'Экспортируемый производственный файл содержит платные права дополнительной этикетки. Эта функция истекла и требует закрытия и повторного вывода.',
    ko: '내보낸 생산 파일에 지불 서브 라벨 권한이 포함되어 있습니다. 이 기능은 만료되었으며 닫고 다시 출력해야 합니다.',
    bur: 'ထုတ်ယူသော ပရိုဒူးရေးသားစက်ကို အရန်တံဆိပ် အကူအညီပြုလုပ်ထားသည်။ အရန်တံဆိပ်ကိုပိတ်ပြီးတော့ပြီးမှာယူပါ။',
    ben: 'রপ্তানি করা প্রোডাকশন ফাইলে প্যায়াবলী সাব লেবেল অনুমতি রয়েছে। এই ফাংশনটি শেষ হয়েছে এবং পুনরায় বন্ধ করে এবং সংরক্ষণ করুন',
    tr: 'Dışa aktarılan üretim dosyasında ödeme yapılan alt etiket izni içerir. Bu özellik süresi doldu ve yeniden kapatılması ve çıktıya çıkarılması gerekiyor.',
    km: 'ស្លាកដែលនាំចេញមានស្លាកបន្ទាប់សម្រួលមិនបានជោគជ័យ។ សូមបើកស្លាកបន្ទាប់សម្រួលដើម្បីរក្សាទុកម្តងទុកទៀត។',
    es: 'El archivo de producción exportado contiene permisos de etiqueta secundaria pagados. Esta función ha expirado y necesita cerrarse y volver a salir.',
    ar: 'تحتوي ملف الإنتاج المُصدَّر على صلاحيات ملصق ثانوي تسدد. تمت إنتهاء هذه الميزة ويجب إغلاقها وإخراجها مرة أخرى.',
  },
  'printPage.tempNamePlaceHolder': {
    zh: '请输入模板名称',
    en: 'Please enter the template name',
    id: 'Harap masukkan nama template',
    kz: 'Үлгінің атауын енгізіңіз',
    th: 'กรุณากรอกชื่อเทมเพลต',
    ug: 'قېلىپ نامىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập tên mẫu',
    zh_tc: '請輸入模板名稱',
    ru: 'Введите имя шаблона',
    ko: '템플릿 이름을 입력하십시오.',
    bur: 'ပုံစံအမည်ထည့်ပါ',
    ben: 'টেমপ্লেটের নাম লিখুন',
    tr: 'Şablon adını girin',
    km: 'សូមបញ្ចូលឈ្មោះពុម្ព',
    es: 'Ingrese el nombre de la plantilla',
    ar: 'يرجى إدخال اسم القالب',
  },
  'printPage.editTip': {
    zh: '您可以根据自身需求拖动左侧按钮至右边标签纸上来完成标签模板的编辑',
    en: 'You can edit the tag template by dragging the buttons from the left to the tag paper on the right according to your needs',
    id: 'Anda dapat menyelesaikan pengeditan template label dengan menyeret tombol kiri ke kertas label kanan sesuai dengan kebutuhan Anda',
    kz: 'Өз қажеттіліктеріңізге сәйкес сол жақтағы түймелерді оң жақтағы тег қағазына жылжытып, тег үлгісін өңдеуді аяқтауға болады',
    th: 'คุณสามารถแก้ไขเทมเพลตฉลากได้โดยการลากปุ่มซ้ายไปยังกระดาษฉลากด้านขวาตามความต้องการของคุณ',
    ug: 'ئۆز ئېھتىياجىڭىزغا قاراپ بەلگە قېلىپىنى تەھرىرلەش ئۈچۈن سول تەرەپتىىكى توپچىلارنى بەلگە قەغىزىگە سۆرەپ قويالايسىز',
    vi: 'Bạn có thể kéo các nút bên trái vào nhãn bên phải để chỉnh sửa mẫu nhãn theo nhu cầu',
    zh_tc: '您可以根據自身需求拖動左側按鈕至右邊標籤紙上來完成標籤模板的編輯',
    ru: 'Вы можете перетащить левую кнопку на правую вкладку, чтобы выполнить редактирование шаблона вкладки',
    ko: '원하는 대로 왼쪽 단추를 오른쪽 탭 용지로 드래그하여 탭 템플릿 편집을 완료할 수 있습니다.',
    bur: 'ဘယ်ဘက်ခလုတ်များကိုညာဘက်တံဆိပ်စက္ကူပေါ်သို့ဆွဲချပြီးတံဆိပ်ပုံစံတည်းဖြတ်ပါ',
    ben: 'বামের বাটন ডান দিকের লেবেল পেপারে টেনে এনে চাহিদা অনুযায়ী লেবেল টেমপ্লেট এডিট করুন',
    tr: 'İhtiyacınıza göre soldaki düğmeleri sağdaki etiket kağıdına sürükleyerek şablonu düzenleyebilirsiniz',
    km: 'អ្នកអាចអូសប៊ូតុងខាងឆ្វេងទៅក្រដាសស្លាកខាងស្តាំតាមតម្រូវការដើម្បីកែពុម្ព',
    es: 'Puede arrastrar el botón izquierdo al papel de etiqueta derecho para completar la edición de la plantilla de etiqueta según sus propias necesidades',
    ar: 'يمكنك سحب الزر الأيسر إلى ورق الملصق الأيمن لإكمال تحرير قالب الملصق وفقًا لاحتياجاتك الخاصة',
  },
  'printPage.oneCode': {
    zh: '条码',
    en: 'Barcode',
    id: 'Barcode',
    kz: 'Штрих-код',
    th: 'บาร์โค้ด',
    ug: 'سىزىق كود',
    vi: 'Mã vạch',
    zh_tc: '條碼',
    ru: 'штрих-код',
    ko: '바코드',
    bur: 'ဘားကုဒ်',
    ben: 'বারকোড',
    tr: 'Barkod',
    km: 'បាកូដ',
    es: 'Código de barras',
    ar: 'باركود',
  },
  'printPage.image': {
    zh: '图像',
    en: 'Image',
    id: 'gambar',
    kz: 'Кескін',
    th: 'ภาพ',
    ug: 'رەسىم',
    vi: 'Hình ảnh',
    zh_tc: '圖像',
    ru: 'Изображения',
    ko: '이미지',
    bur: 'ပုံ',
    ben: 'ইমেজ',
    tr: 'Görüntü',
    km: 'រូបភាព',
    es: 'Imagen',
    ar: 'صورة',
  },
  'printPage.arrow': {
    zh: '箭头',
    en: 'panah',
    id: 'panah',
    kz: 'көрсеткіш',
    th: 'ลูกศร',
    ug: 'ئوق',
    vi: 'Mũi tên',
    zh_tc: '箭頭',
    ru: 'стрелка',
    ko: '화살표',
    bur: 'မြှား',
    ben: 'তীর',
    tr: 'Ok',
    km: 'ព្រួញ',
    es: 'Flecha',
    ar: 'سهم',
  },
  'printPage.editPage.digitLimitation': {
    zh: '位数限制',
    en: 'digit limitation',
    id: 'Batasan digit',
    kz: 'сан шектеуі',
    th: 'จำกัดจำนวนหลัก',
    ug: 'سان چەكلىمىسى',
    vi: 'giới hạn chữ số',
    zh_tc: '位數限制',
    ru: 'Ограничение числа цифр',
    ko: '자릿수 제한',
    bur: 'ဂဏန်းကန့်သတ်ချက်',
    ben: 'অঙ্কের সীমা',
    tr: 'Basamak sınırı',
    km: 'កំណត់ចំនួនខ្ទង់',
    es: 'Límite de dígitos',
    ar: 'حد الأرقام',
  },
  'printPage.editPage.title': {
    zh: '标签模版编辑',
    en: 'Label Template Editing',
    id: 'Pengeditan Tag Template',
    kz: 'Тегтердің шаблонды өңдеу',
    th: 'การแก้ไขเทมเพลตแท็ก',
    ug: 'بەلگە قېلىپى تەھرىرلەش',
    vi: 'Chỉnh sửa mẫu nhãn',
    zh_tc: '標籤模版編輯',
    ru: 'Редактор шаблонов меток',
    ko: '태그 템플릿 편집',
    bur: 'တံဆိပ်ပုံစံတည်းဖြတ်',
    ben: 'লেবেল টেমপ্লেট এডিটিং',
    tr: 'Etiket şablonu düzenleme',
    km: 'កែសម្រួលពុម្ពស្លាក',
    es: 'Edición de plantilla de etiqueta',
    ar: 'تحرير قالب التسمية',
  },
  'printPage.editPage.reset': {
    zh: '恢复默认',
    en: 'Restore default',
    id: 'Kembalikan default',
    kz: 'Әдетті параметрлерге қалпына келтіру',
    th: 'กู้คืนค่าเริ่มต้น',
    ug: 'سۈكۈتتىكىگە قايتۇرۇش',
    vi: 'Khôi phục mặc định',
    zh_tc: '恢復默認',
    ru: 'восстановить по умолчанию',
    ko: '기본 복원',
    bur: 'မူရင်းပြန်ထား',
    ben: 'ডিফল্ট পুনরুদ্ধার করুন',
    tr: 'Varsayılana döndür',
    km: 'ស្តារលំនាំដើម',
    es: 'Restaurar valor predeterminado',
    ar: 'استعادة الافتراضي',
  },
  'printPage.editPage.exit': {
    zh: '退出编辑',
    en: 'Exit Editing',
    id: 'EXIT EDIT',
    kz: 'Өңдеуді тоқтату',
    th: 'ออกจากการแก้ไข',
    ug: 'تەھرىرلەشتىن چىقىش',
    vi: 'Thoát chỉnh sửa',
    zh_tc: '退出編輯',
    ru: 'Выход из редактирования',
    ko: '편집 종료',
    bur: 'တည်းဖြတ်မှထွက်',
    ben: 'এডিটিং থেকে বেরুন',
    tr: 'Düzenlemeden çık',
    km: 'ចាកចេញពីការកែសម្រួល',
    es: 'Salir de la edición',
    ar: 'الخروج من التحرير',
  },
  'printPage.editPage.tagInfo': {
    zh: '标签信息',
    en: 'Tag Information',
    id: 'Informasi tag',
    kz: 'Тегтердің ақпараті',
    th: 'แท็กข้อมูล',
    ug: 'بەلگە ئۇچۇرى',
    vi: 'Thông tin nhãn',
    zh_tc: '標籤信息',
    ru: 'Информация о вкладке',
    ko: '태그 정보',
    bur: 'တံဆိပ်အချက်အလက်',
    ben: 'ট্যাগ তথ্য',
    tr: 'Etiket bilgisi',
    km: 'ព័ត៌មានស្លាក',
    es: 'Información de etiqueta',
    ar: 'معلومات التسمية',
  },
  'printPage.editPage.tagName': {
    zh: '标签名称',
    en: 'Tag Name',
    id: 'Nama tag',
    kz: 'Тегтің атауы',
    th: 'ชื่อแท็ก',
    ug: 'بەلگە ئىسمى',
    vi: 'Tên nhãn',
    zh_tc: '標籤名稱',
    ru: 'Название метки',
    ko: '라벨 이름',
    bur: 'တံဆိပ်အမည်',
    ben: 'ট্যাগের নাম',
    tr: 'Etiket adı',
    km: 'ឈ្មោះស្លាក',
    es: 'Nombre de etiqueta',
    ar: 'اسم التسمية',
  },
  'printPage.editPage.tagSize': {
    zh: '标签尺寸',
    en: 'Tag Size',
    id: 'Ukuran label',
    kz: 'Тегтің өлшемі',
    th: 'ขนาดฉลาก',
    ug: 'بەلگە ئۆلچىمى',
    vi: 'Kích thước nhãn',
    zh_tc: '標籤尺寸',
    ru: 'Размер этикетки',
    ko: '레이블 크기',
    bur: 'တံဆိပ်အရွယ်',
    ben: 'ট্যাগ সাইজ',
    tr: 'Etiket boyutu',
    km: 'ទំហំស្លាក',
    es: 'Tamaño de etiqueta',
    ar: 'حجم التسمية',
  },
  'printPage.editPage.tagData': {
    zh: '标签数据',
    en: 'Tag Data',
    id: 'Tag data',
    kz: 'Тегтердің деректері',
    th: 'แท็กข้อมูล',
    ug: 'بەلگە سانلىق مەلۇماتى',
    vi: 'Dữ liệu nhãn',
    zh_tc: '標籤數據',
    ru: 'Данные метки',
    ko: '태그 데이터',
    bur: 'တံဆိပ်ဒေတာ',
    ben: 'ট্যাগ ডেটা',
    tr: 'Etiket verisi',
    km: 'ទិន្នន័យស្លាក',
    es: 'Datos de etiqueta',
    ar: 'بيانات التسمية',
  },
  'printPage.editPage.dragTip': {
    zh: '按住鼠标左键拖出数据标签',
    en: 'Drag with the left mouse button to create a data tag',
    id: 'Tahan tombol kiri mouse untuk menyeret keluar label data',
    kz: 'Қолмен бастап, деректердің тегтерін сүйреп тастаңыз',
    th: 'กดปุ่มเมาส์ซ้ายค้างไว้เพื่อลากฉลากข้อมูล',
    ug: 'چاۋاك چاشقىنەكنى باسىۋالغان ھالدا سانلىق مەلۇمات بەلگىسىنى سۆرەپ قويۇڭ',
    vi: 'Nhấn chuột trái kéo ra nhãn dữ liệu',
    zh_tc: '按住鼠標左鍵拖出數據標籤',
    ru: 'Нажмите левую кнопку мыши, чтобы вытащить вкладку',
    ko: '마우스 왼쪽 버튼을 누른 채 데이터 레이블 드래그',
    bur: 'ဒေတာတံဆိပ်ထုတ်ရန်မောက်စ်ဘယ်ဘက်နှိပ်ဆွဲပါ',
    ben: 'ডেটা ট্যাগ তৈরি করতে বাম মাউস বাটন চেপে টানুন',
    tr: 'Veri etiketi oluşturmak için sol fare düğmesini basılı tutup sürükleyin',
    km: 'ចុចទុកប៊ូតុងខាងឆ្វេងនៃកណ្តុររួចអូសដើម្បីបង្កើតស្លាកទិន្នន័យ',
    es: 'Mantenga presionado el botón izquierdo del mouse y arrastre la etiqueta de datos',
    ar: 'اضغط باستمرار على زر الماوس الأيسر واسحب تسمية البيانات',
  },
  'printPage.editPage.dataTip': {
    zh: '请在右侧属性栏选择数据信息',
    en: 'Select data information from the property panel on the right',
    id: 'Pilih informasi data di bilah properti di sebelah kanan',
    kz: 'Деректердің ақпараттарын оң жақтағы հատтада таңдаңыз',
    th: 'โปรดเลือกข้อมูลข้อมูลในแถบคุณสมบัติทางด้านขวา',
    ug: 'ئوڭ تەرەپتىكى خاسلىق بىلەتلىكىدىن سانلىق مەلۇمات تاللاڭ',
    vi: 'Vui lòng chọn dữ liệu bên phải',
    zh_tc: '請在右側屬性欄選擇數據信息',
    ru: 'Выберите данные в правой панели свойств',
    ko: '오른쪽 속성 표시줄에서 데이터 정보를 선택하십시오.',
    bur: 'ညာဘက်ပြဋ္ဌာန်းချက်တန်းမှဒေတာရွေးပါ',
    ben: 'ডান প্রপার্টি প্যানেল থেকে ডেটা তথ্য নির্বাচন করুন',
    tr: 'Veri bilgisini sağdaki özellik panelinden seçin',
    km: 'ជ្រើសរើសព័ត៌មានទិន្នន័យពីផ្ទាំងលក្ខណៈខាងស្តាំ',
    es: 'Seleccione la información de datos en la barra de propiedades derecha',
    ar: 'يرجى تحديد معلومات البيانات في شريط الخصائص الأيمن',
  },
  'printPage.editPage.text': {
    zh: '文本',
    en: 'Text',
    id: 'teks',
    kz: 'Мәтін',
    th: 'ข้อความ',
    ug: 'تېكىست',
    vi: 'Văn bản',
    zh_tc: '文本',
    ru: 'текст',
    ko: '텍스트',
    bur: 'စာသား',
    ben: 'টেক্সট',
    tr: 'Metin',
    km: 'អត្ថបទ',
    es: 'Texto',
    ar: 'النص',
  },
  'printPage.editPage.dataSource': {
    zh: '数据信息',
    en: 'Data Source',
    id: 'Informasi data',
    kz: 'Деректердің ақпараттар',
    th: 'ข้อมูลข้อมูล',
    ug: 'سانلىق مەلۇمات مەنبەسى',
    vi: 'Dữ liệu thông tin',
    zh_tc: '數據信息',
    ru: 'данные и информация',
    ko: '데이터 정보',
    bur: 'ဒေတာအချက်အလက်',
    ben: 'ডেটা সোর্স',
    tr: 'Veri kaynağı',
    km: 'ប្រភពទិន្នន័យ',
    es: 'Información de datos',
    ar: 'معلومات البيانات',
  },
  'printPage.editPage.graph': {
    zh: '图形',
    en: 'Graphic',
    id: 'Grafik',
    kz: 'График',
    th: 'กราฟิก',
    ug: 'گرافىك',
    vi: 'Hình ảnh đồ họa',
    zh_tc: '圖形',
    ru: 'График',
    ko: '그래픽',
    bur: 'ဂရပ်ဖစ်',
    ben: 'গ্রাফিক',
    tr: 'Grafik',
    km: 'ក្រាហ្វិក',
    es: 'Gráficos',
    ar: 'الرسومات',
  },
  'printPage.editPage.typograpyPic': {
    zh: '排版图',
    en: 'Typesetting diagram',
    id: 'Penyusunan huruf',
    kz: 'Қалыптасу суреті',
    th: 'การเรียงพิมพ์',
    ug: 'تەرتىپ رەسىمى',
    vi: 'Hình ảnh bản in',
    zh_tc: '排版圖',
    ru: 'Типограмма',
    ko: '조판도',
    bur: 'အစီအစဉ်တကျပုံ',
    ben: 'টাইপসেটিং ডায়াগ্রাম',
    tr: 'Dizgi diyagramı',
    km: 'រូបរាងការរៀបចំ',
    es: 'Dibujo de diseño',
    ar: 'رسم التخطيط',
  },
  'printPage.editPage.barCode': {
    zh: '条形码',
    en: 'Barcode',
    id: 'Barcode',
    kz: 'Штрих-код',
    th: 'บาร์โค้ด',
    ug: 'سىزىق كود',
    vi: 'Mã vạch',
    zh_tc: '條形碼',
    ru: 'штрих-код',
    ko: '바코드',
    bur: 'ဘားကုဒ်',
    ben: 'বারকোড',
    tr: 'Barkod',
    km: 'បាកូដ',
    es: 'Código de barras',
    ar: 'الرمز الشريطي',
  },
  'printPage.editPage.QRCode': {
    zh: '二维码',
    en: 'QR Code',
    id: 'Kode QR',
    kz: 'Құрлы штрих-код',
    th: 'รหัส QR',
    ug: 'QR كود',
    vi: 'Mã QR',
    zh_tc: '二維碼',
    ru: 'QR-код',
    ko: 'QR 코드',
    bur: 'QR ကုဒ်',
    ben: 'QR কোড',
    tr: 'QR kodu',
    km: 'កូដ QR',
    es: 'Código QR',
    ar: 'رمز الاستجابة السريعة',
  },
  'printPage.editPage.plankMark': {
    zh: '板件标记',
    en: 'Plate Mark',
    id: 'Tanda pelat',
    kz: 'Кескіштің белгісі',
    th: 'การทำเครื่องหมายจาน',
    ug: 'تاختا بەلگىسى',
    vi: 'Đánh dấu tấm',
    zh_tc: '板件標記',
    ru: 'Маркировка листов',
    ko: '보드 태그',
    bur: 'ပြားမှတ်သားချက်',
    ben: 'প্লেট মার্ক',
    tr: 'Plaka işareti',
    km: 'សញ្ញាផ្ទាំង',
    es: 'Marca del panel',
    ar: 'علامة اللوحة',
  },
  'printPage.editPage.holeSlotPic': {
    zh: '孔槽图',
    en: 'Hole and Slot Diagram',
    id: 'Diagram slot lubang',
    kz: 'Тешіктің суреті',
    th: 'ไดอะแกรมช่องเสียบ',
    ug: 'تېشىك/ئويۇق رەسىمى',
    vi: 'Hình ảnh lỗ khoan',
    zh_tc: '孔槽圖',
    ru: 'пазовая диаграмма',
    ko: '구멍 차트',
    bur: 'အပေါက်ချောင်းပုံ',
    ben: 'হোল ও স্লট ডায়াগ্রাম',
    tr: 'Delik ve oluk diyagramı',
    km: 'រូបរណ្តៅ និងរណ្តៅ',
    es: 'Diagrama de orificios y ranuras',
    ar: 'مخطط الفتحات والفتحات',
  },
  'printPage.editPage.edgeBandPic': {
    zh: '封边图',
    en: 'Edge Banding Diagram',
    id: 'Diagram tepi',
    kz: 'Жақтау жолағы сызбасы',
    th: 'แผนภาพขอบ',
    ug: 'چەت سىزىقى رەسىمى',
    vi: 'Sơ đồ viền cạnh',
    zh_tc: '封邊圖',
    ru: 'Боковая диаграмма',
    ko: '봉인도',
    bur: 'အစွန်းပြားပုံ',
    ben: 'এজ ব্যান্ডিং ডায়াগ্রাম',
    tr: 'Kenar bantlama diyagramı',
    km: 'រូបបំណុលគែម',
    es: 'Diagrama de bandas de borde',
    ar: 'مخطط نطاقات الحواف',
  },
  'printPage.editPage.visibleEdgePic': {
    zh: '见光边',
    en: 'Visible edge',
    id: 'Tepi terlihat',
    kz: 'Жарықтың шығыны көрсету',
    th: 'แสดงเห็นขอบแสง',
    ug: 'كۆرۈنۈش يان تەرەپ',
    vi: 'Hiển thị cạnh thấu sáng',
    zh_tc: '見光邊',
    ru: 'Увидеть край света',
    ko: '광변 을 보다',
    bur: 'အလင်းမျက်နှာစာ',
    ben: 'দৃশ্যমান এজ',
    tr: 'Görünen kenar',
    km: 'គែមដែលឃើញ',
    es: 'Borde visible',
    ar: 'الحافة المرئية',
  },
  'printPage.editPage.holeSlotPicZoom': {
    zh: '孔槽图缩放',
    en: 'Hole Slot Picture Zoom',
    id: 'Zoom Diagram Slot Lubang',
    kz: 'Тесік ойық суретін үлкейту',
    th: 'การซูมไดอะแกรมช่องเสียบ',
    ug: 'تېشىك/ئويۇق رەسىمىنى زوم قىلىش',
    vi: 'Phóng to hình ảnh lỗ khoan',
    zh_tc: '孔槽圖縮放',
    ru: 'Масштаб диаграммы',
    ko: '구멍 슬롯 그림 배율 조정',
    bur: 'အပေါက်ချောင်းပုံချဲ့',
    ben: 'হোল স্লট পিকচার জুম',
    tr: 'Delik/oluk görseli yakınlaştırma',
    km: 'ពង្រីករូបរណ្តៅ/រណ្តៅ',
    es: 'Escala del diagrama de orificios y ranuras',
    ar: 'قياس مخطط الفتحات والفتحات',
  },
  'printPage.editPage.rotateDeg': {
    zh: '旋转角度',
    en: 'Rotation Angle',
    id: 'Sudut rotasi',
    kz: 'Бұрылу бұрышы',
    th: 'มุมหมุน',
    ug: 'بۇرۇش پەللىسى',
    vi: 'Góc xoay',
    zh_tc: '旋轉角度',
    ru: 'угол поворота',
    ko: '회전 각도',
    bur: 'လည်ချောင်းထောင့်',
    ben: 'রোটেশন অ্যাঙ্গেল',
    tr: 'Dönüş açısı',
    km: 'មុំបង្វិល',
    es: 'Ángulo de rotación',
    ar: 'زاوية الدوران',
  },
  'printPage.editPage.colorDeep': {
    zh: '颜色深度',
    en: 'Color Depth',
    id: 'Kedalaman warna',
    kz: 'Түстің қанықтығы',
    th: 'ความลึกสี',
    ug: 'رەڭ چوڭقۇرلۇقى',
    vi: 'Độ sâu màu',
    zh_tc: '顏色深度',
    ru: 'Глубина цвета',
    ko: '색상 깊이',
    bur: 'အရောင်အနက်',
    ben: 'রঙের গভীরতা',
    tr: 'Renk derinliği',
    km: 'ជម្រៅពណ៌',
    es: 'Profundidad de color',
    ar: 'عمق الألوان',
  },
  'printPage.editPage.surplusMark': {
    zh: '余料标识',
    en: 'Surplus Material Mark',
    id: 'Tanda materi yang tersisa',
    kz: 'Қалдық белгісі',
    th: 'เครื่องหมายวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال بەلگىسى',
    vi: 'Đánh dấu dư liệu',
    zh_tc: '餘料標識',
    ru: 'Маркировка остатков',
    ko: '남은 재료 표식',
    bur: 'ပိုလျှံပစ္စည်းမှတ်သား',
    ben: 'উদ্বৃত্ত উপকরণ মার্ক',
    tr: 'Artık malzeme işareti',
    km: 'សញ្ញាសម្ភារៈសល់',
    es: 'Identificación del material restante',
    ar: 'تحديد المادة المتبقية',
  },
  'printPage.editPage.surplusSizePic': {
    zh: '余料尺寸图',
    en: 'Surplus Material Size Picture',
    id: 'Diagram ukuran bahan yang tersisa',
    kz: 'Қалдық өлшем суреті',
    th: 'ไดอะแกรมขนาดวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال ئۆلچەم رەسىمى',
    vi: 'Hình ảnh kích thước dư liệu',
    zh_tc: '餘料尺寸圖',
    ru: 'График остаточных размеров',
    ko: '남은 재료 치수도',
    bur: 'ပိုလျှံပစ္စည်းအရွယ်ပုံ',
    ben: 'উদ্বৃত্ত উপকরণ সাইজ ছবি',
    tr: 'Artık malzeme boyut görseli',
    km: 'រូបទំហំសម្ភារៈសល់',
    es: 'Diagrama de tamaño del material restante',
    ar: 'مخطط حجم المادة المتبقية',
  },
  'printPage.editPage.dataSize': {
    zh: '数据尺寸',
    en: 'Data Size',
    id: 'Ukuran data',
    kz: 'Деректер өлшемі',
    th: 'ขนาดข้อมูล',
    ug: 'سانلىق مەلۇمات ئۆلچىمى',
    vi: 'Kích thước dữ liệu',
    zh_tc: '數據尺寸',
    ru: 'Размер данных',
    ko: '데이터 크기',
    bur: 'ဒေတာအရွယ်',
    ben: 'ডেটা সাইজ',
    tr: 'Veri boyutu',
    km: 'ទំហំទិន្នន័យ',
    es: 'Tamaño de los datos',
    ar: 'حجم البيانات',
  },
  'printPage.editPage.extraList': {
    zh: '附加清单',
    en: 'Additional List',
    id: 'Daftar tambahan',
    kz: 'Қосымша тізім',
    th: 'รายการเพิ่มเติม',
    ug: 'قوشۇمچە تىزىملىك',
    vi: 'Danh sách phụ',
    zh_tc: '附加清單',
    ru: 'Дополнительный список',
    ko: '추가 목록',
    bur: 'အပိုစာရင်း',
    ben: 'অতিরিক্ত তালিকা',
    tr: 'Ek liste',
    km: 'បញ្ជីបន្ថែម',
    es: 'Lista adicional',
    ar: 'قائمة إضافية',
  },
  'printPage.editPage.QRCodeFormat': {
    zh: '二维码格式',
    en: 'QR Code Format',
    id: 'Format Kode QR',
    kz: 'QR код форматы',
    th: 'รูปแบบรหัส QR',
    ug: 'QR كود فورماتى',
    vi: 'Định dạng mã QR',
    zh_tc: '二維碼格式',
    ru: 'Формат QR - кода',
    ko: 'QR코드 형식',
    bur: 'QR ကုဒ်ဖော်မတ်',
    ben: 'QR কোড ফরম্যাট',
    tr: 'QR kodu biçimi',
    km: 'ទ្រង់ទ្រាយកូដ QR',
    es: 'Formato de código QR',
    ar: 'تنسيق رمز الاستجابة السريعة',
  },
  'printPage.editPage.formatQR': {
    zh: 'QR格式',
    en: 'QR Format',
    id: 'Format QR',
    kz: 'QR форматы',
    th: 'รูปแบบ QR',
    ug: 'QR فورماتى',
    vi: 'Định dạng QR',
    zh_tc: 'QR格式',
    ru: 'Формат QR',
    ko: 'QR 형식',
    bur: 'QR ဖော်မတ်',
    ben: 'QR ফরম্যাট',
    tr: 'QR biçimi',
    km: 'ទ្រង់ទ្រាយ QR',
    es: 'Formato QR',
    ar: 'QR التنسيق',
  },
  'printPage.editPage.formatDM': {
    zh: 'DM格式',
    en: 'DM Format',
    id: 'Format DM',
    kz: 'DM форматы',
    th: 'รูปแบบ DM',
    ug: 'DM فورماتى',
    vi: 'Định dạng DM',
    zh_tc: 'DM格式',
    ru: 'Формат DM',
    ko: 'DM 형식',
    bur: 'DM ဖော်မတ်',
    ben: 'DM ফরম্যাট',
    tr: 'DM biçimi',
    km: 'ទ្រង់ទ្រាយ DM',
    es: 'Formato DM',
    ar: 'DM التنسيق',
  },
  'printPage.editPage.locIndex': {
    zh: '柜体序号',
    en: 'Cabinet Index',
    id: 'Nomor Seri Kabinet',
    kz: 'Кабинет индексі',
    th: 'หมายเลขซีเรียล',
    ug: 'قابا تەرتىپ نومۇرى',
    vi: 'Số thứ tự tủ',
    zh_tc: '櫃體序號',
    ru: 'Номер шкафа',
    ko: '캐비닛 번호',
    bur: 'ကက်ဘိနက်အစဉ်နံပါတ်',
    ben: 'ক্যাবিনেট সূচক',
    tr: 'Dolap sıra numarası',
    km: 'លេខលំដាប់ទូ',
    es: 'Número de serie del gabinete',
    ar: 'الرقم التسلسلي للخزانة',
  },
  'printPage.editPage.plankFrontSign': {
    zh: '面板标记',
    en: 'Panel Mark',
    id: 'Penanda panel',
    kz: 'Панель белгісі',
    th: 'เครื่องหมายแผง',
    ug: 'ئالدىنقى تەرەپ بەلگىسى',
    vi: 'Đánh dấu mặt trước tấm',
    zh_tc: '面板標記',
    ru: 'Маркировка панели',
    ko: '패널 태그',
    bur: 'ပြားရှေ့မျက်နှာမှတ်',
    ben: 'প্যানেল মার্ক',
    tr: 'Panel işareti',
    km: 'សញ្ញាបន្ទះ',
    es: 'Marca del panel',
    ar: 'علامة اللوحة',
  },
  'printPage.editPage.genNCSuffix': {
    zh: '生成NC后缀',
    en: 'Generate NC Suffix',
    id: 'Menghasilkan akhiran NC',
    kz: 'NC жалғауын жасау',
    th: 'สร้างคำต่อท้าย NC',
    ug: 'NC قوشۇمچىسى ھاسىل قىلىش',
    vi: 'Tạo hậu tố NC',
    zh_tc: '生成NC後綴',
    ru: 'Создать суффикс NC',
    ko: 'NC 접미어 생성하기',
    bur: 'NC နောက်ဆက်ဖန်တီး',
    ben: 'NC সাফিক্স জেনারেট করুন',
    tr: 'NC son eki oluştur',
    km: 'បង្កើតបច្ច័យ NC',
    es: 'Generar sufijo NC',
    ar: 'إنشاء NC لاحقة',
  },
  'printPage.editPage.table': {
    zh: '表格',
    en: 'Table',
    id: 'lembaran',
    kz: 'Кесте',
    th: 'แผ่น',
    ug: 'جەدۋەل',
    vi: 'Bảng',
    zh_tc: '表格',
    ru: 'таблица',
    ko: '표',
    bur: 'ဇယား',
    ben: 'টেবিল',
    tr: 'Tablo',
    km: 'តារាង',
    es: 'Tabla',
    ar: 'الجدول',
  },
  'printPage.editPage.inputPlaceholder': {
    zh: '请双击输入文本',
    en: 'Double-click to enter text',
    id: 'Harap klik dua kali untuk memasukkan teks',
    kz: 'Мәтінді енгізу үшін екішерті басыңыз',
    th: 'โปรดคลิกสองครั้งเพื่อป้อนข้อความ',
    ug: 'تېكىست كىرگۈزۈش ئۈچۈن قوش چېكىڭ',
    vi: 'Vui lòng nhịp đúp để nhập văn bản',
    zh_tc: '請雙擊輸入文本',
    ru: 'Двойной щелчок для ввода текста',
    ko: '입력 텍스트를 두 번 클릭하십시오.',
    bur: 'စာသားထည့်ရန်နှစ်ချက်နှိပ်ပါ',
    ben: 'টেক্সট লিখতে ডাবল-ক্লিক করুন',
    tr: 'Metin girmek için çift tıklayın',
    km: 'ចុចពីរដងដើម្បីបញ្ចូលអត្ថបទ',
    es: 'Haga doble clic para ingresar texto',
    ar: 'يرجى النقر نقرًا مزدوجًا لإدخال النص',
  },
  'printPage.editPage.attribute': {
    zh: '属性',
    en: 'Attribute',
    id: 'milik',
    kz: 'Қасиеттер',
    th: 'คุณสมบัติ',
    ug: 'خاسلىق',
    vi: 'Thuộc tính',
    zh_tc: '屬性',
    ru: 'свойство',
    ko: '속성',
    bur: 'ဂုဏ်သတ္တိ',
    ben: 'অ্যাট্রিবিউট',
    tr: 'Özellik',
    km: 'លក្ខណៈ',
    es: 'Propiedades',
    ar: 'الخصائص',
  },
  'printPage.editPage.fontFamily': {
    zh: '字体类型',
    en: 'Font Family',
    id: 'Jenis font',
    kz: 'Қаріптің түрі',
    th: 'ประเภทตัวอักษร',
    ug: 'خەت نۇسخا تىپى',
    vi: 'Khoảng trực tiếp',
    zh_tc: '字體類型',
    ru: 'Тип шрифта',
    ko: '글꼴 유형',
    bur: 'ဖောင့်အမျိုးအစား',
    ben: 'ফন্ট ফ্যামিলি',
    tr: 'Yazı tipi ailesi',
    km: 'គ្រួសារពុម្ពអក្សរ',
    es: 'Tipo de fuente',
    ar: 'نوع الخط',
  },
  'printPage.editPage.fontSize': {
    zh: '字体大小',
    en: 'Font Size',
    id: 'Ukuran font',
    kz: 'Қариптің кемелді',
    th: 'ขนาดตัวอักษร',
    ug: 'خەت نۇسخا چوڭلۇقى',
    vi: 'Kích thước chữ',
    zh_tc: '字體大小',
    ru: 'Размер шрифта',
    ko: '글꼴 크기',
    bur: 'ဖောင့်အရွယ်',
    ben: 'ফন্ট সাইজ',
    tr: 'Yazı tipi boyutu',
    km: 'ទំហំពុម្ពអក្សរ',
    es: 'Tamaño de fuente',
    ar: 'حجم الخط',
  },
  'printPage.editPage.fontWeight': {
    zh: '字体加粗',
    en: 'Font Weight',
    id: 'Font yang lebih tebal',
    kz: 'Қариптің қалınдығы',
    th: 'ตัวอักษรหนา',
    ug: 'خەت نۇسخا قېلىنلىقى',
    vi: 'Đen chữ',
    zh_tc: '字體加粗',
    ru: 'Широкий шрифт',
    ko: '글자 굵게',
    bur: 'ဖောင့်ထူ',
    ben: 'ফন্ট ওয়েট',
    tr: 'Yazı tipi kalınlığı',
    km: 'កម្រាស់ពុម្ពអក្សរ',
    es: 'Fuente negrita',
    ar: 'غامق',
  },
  'printPage.editPage.flipOverProcessing': {
    zh: '翻面加工',
    en: 'Flip Over Processing',
    id: 'Pemrosesan sisi balik',
    kz: 'Бетті аударып өңдеу',
    th: 'การประมวลผลพลิกด้าน',
    ug: 'ئەكسى يۈزنى بىر تەرەپ قىلىش',
    vi: 'Gia công lật mặt',
    zh_tc: '翻面加工',
    ru: 'Обработка переворота',
    ko: '뒤집기 가공',
    bur: 'မျက်နှာပြင်လှန်လုပ်ဆောင်ခြင်း',
    ben: 'ফ্লিপ ওভার প্রসেসিং',
    tr: 'Çevirme işlemi',
    km: 'ដំណើរការបញ្ច្រាស',
    es: 'Procesamiento de volteo',
    ar: 'معالجة الوجه الآخر',
  },
  'printPage.editPage.showSideMachiningSequenceDiagramBorder': {
    zh: '显示图例内框',
    en: 'Show Side Machining Sequence Diagram Border',
    id: 'Tampilkan batas diagram urutan pemrosesan sisi',
    kz: 'Беттің шетіндегі өңдеу тізбегі диаграммасын көрсету',
    th: 'แสดงขอบกราฟิกลำดับการประมวลผลด้าน',
    ug: 'ئەكسى يۈزىنىڭ ئارىلىقى ھېسىتىڭىزىنى كۆرسىتىش',
    vi: 'Hiển thị biểu đồ dãy xử lý bề mặt',
    zh_tc: '显示图例内框',
    ru: 'Показать границу диаграммы последовательности обработки стороны',
    ko: '측면 가공 순서 도표 테두리 표시',
    bur: 'မျက်နှာပြင်လှန်လုပ်ဆောင်ခြင်းနှင့်အတူတူမျက်နှာပြင်လှန်လုပ်ဆောင်ခြင်းနှင့်အတူတူ',
    ben: 'ফ্লিপ ওভার প্রসেসিং এবং একই মতো ফ্লিপ ওভার প্রসেসিং',
    tr: 'Çevirme işlemi ve aynı şekilde çevirme işlemi',
    km: 'ដំណើរការបញ្ច្រាស និងដំណើរការបញ្ច្រាស ដូចគ្នា',
    es: 'Mostrar diagrama de secuencia de procesamiento de lado',
    ar: 'إظهار حدود المخطط التسلسلي للمعالجة الجانبية',
  },
  'printPage.editPage.showSideMachiningSequenceNumber': {
    zh: '显示数字加工顺序',
    en: 'Show Side Machining Sequence Number',
    id: 'Tampilkan nomor urutan pemrosesan sisi',
    kz: 'Беттің шетіндегі өңдеу тізбегінің нөмірін көрсету',
    th: 'แสดงหมายเลขลำดับการประมวลผลด้าน',
    ug: 'ئەكسى يۈزىنىڭ ئارىلىقى ھېسىتىڭىزىنى كۆرسىتىش',
    vi: 'Hiển thị số thứ tự xử lý bề mặt',
    zh_tc: '显示数字加工顺序',
    ru: 'Показать номер последовательности обработки стороны',
    ko: '측면 가공 순서 번호 표시',
    bur: 'မျက်နှာပြင်လှန်လုပ်ဆောင်ခြင်းနှင့်အတူတူမျက်နှာပြင်လှန်လုပ်ဆောင်ခြင်းနှင့်အတူတူ',
    ben: 'ফ্লিপ ওভার প্রসেসিং এবং একই মতো ফ্লিপ ওভার প্রসেসিং',
    tr: 'Çevirme işlemi ve aynı şekilde çevirme işlemi',
    km: 'ដំណើរការបញ្ច្រាស និងដំណើរការបញ្ច្រាស ដូចគ្នា',
    es: 'Mostrar número de secuencia de procesamiento de lado',
    ar: 'إظهار رقم التسلسل للمعالجة الجانبية',
  },
  'printPage.editPage.autoRow': {
    zh: '自动换行',
    en: 'Auto Wrap Text',
    id: 'Bungkus garis otomatis',
    kz: 'Автоматты түрде жаңа жол құру',
    th: 'การห่อเส้นอัตโนมัติ',
    ug: 'ئاپتوماتىك قۇر قويۇش',
    vi: 'Chuyển dòng tự động',
    zh_tc: '自動換行',
    ru: 'Автоматический перенос строк',
    ko: '자동 줄 바꿈',
    bur: 'အလိုအလျောက်အကြောင်းပြန်း',
    ben: 'অটো র্যাপ টেক্সট',
    tr: 'Metni otomatik kaydır',
    km: 'រុញអត្ថបទស្វ័យប្រវត្តិ',
    es: 'Ajuste de texto',
    ar: 'التفاف الخط',
  },
  'printPage.editPage.rowMargin': {
    zh: '行间距',
    en: 'Row Spacing',
    id: 'Jarak garis',
    kz: 'Жолдар арас',
    th: 'ระยะห่างของเส้น',
    ug: 'قۇر ئارىلىقى',
    vi: 'Khoảng cách giữa các dòng',
    zh_tc: '行間距',
    ru: 'Расстояние между строками',
    ko: '행 간격',
    bur: 'အတန်းကြားအကွာ',
    ben: 'রো স্পেসিং',
    tr: 'Satır aralığı',
    km: 'គម្លាតបន្ទាត់',
    es: 'interlineado',
    ar: 'تباعد الأسطر',
  },
  'printPage.editPage.autoFontSize': {
    zh: '溢出自动调整字体大小',
    en: 'Automatically Adjust Font Size on Overflow',
    id: 'Ubah Ulang Font Ubah Ulang Secara Otomatis',
    kz: 'Қорытпаған мәтіндің кемелді автоматты түрде реттелу',
    th: 'ปรับขนาดฟอนต์ล้นโดยอัตโนมัติ',
    ug: 'چىقىپ كەتكەندە خەت نۇسخا چوڭلۇقىنى ئاپتوماتىك تەڭشەش',
    vi: 'Tự động điều chỉnh kích thước chữ khi dữ liệu quá nhiều',
    zh_tc: '溢出自動調整字體大小',
    ru: 'Автоматическое изменение размера шрифта',
    ko: '오버플로우 자동 글꼴 크기 조정',
    bur: 'ပြည့်လျှံသည့်အခါဖောင့်အရွယ်အလိုအလျောက်ညှိ',
    ben: 'ওভারফ্লোতে ফন্ট সাইজ স্বয়ংক্রিয় সমন্বয়',
    tr: 'Taşmada yazı tipi boyutunu otomatik ayarla',
    km: 'ពេលលើសកំណត់ទំហំពុម្ពអក្សរស្វ័យប្រវត្តិ',
    es: 'Ajustar automáticamente el tamaño de fuente para desbordamiento',
    ar: 'ضبط حجم الخط تلقائيًا للتجاوز',
  },
  'printPage.editPage.statisticsDimension': {
    zh: '统计维度',
    en: 'Statistical Dimensions',
    id: 'Dimensi statistik',
    kz: ' Статистикалық өлшемдер',
    th: 'มิติทางสถิติ',
    ug: 'ستاتىستىكا ئۆلچىمى',
    vi: 'Kích thước thống kê',
    zh_tc: '統計維度',
    ru: 'Статистическое измерение',
    ko: '통계 차원',
    bur: 'စာရင်းအင်းအတိုင်းအတာ',
    ben: 'স্ট্যাটিস্টিক্যাল ডাইমেনশন',
    tr: 'İstatistik boyutları',
    km: 'វិមាត្រស្ថិតិ',
    es: 'Dimensiones estadísticas',
    ar: 'الأبعاد الإحصائية',
  },
  'printPage.editPage.noLimit': {
    zh: '不限',
    en: 'Unrestricted',
    id: 'Tidak ada batasan',
    kz: 'Сінірсиз',
    th: 'ไม่ จำกัด',
    ug: 'چەكلىمىسىز',
    vi: 'Không giới hạn',
    zh_tc: '不限',
    ru: 'без ограничений',
    ko: '무제',
    bur: 'ကန့်သတ်ချက်မရှိ',
    ben: 'সীমাহীন',
    tr: 'Sınırsız',
    km: 'គ្មានកំណត់',
    es: 'Ilimitado',
    ar: 'غير محدود',
  },
  'printPage.editPage.sameOrderNo': {
    zh: '同订单',
    en: 'Same Order',
    id: 'Pesanan yang sama',
    kz: ' Жекелей тапсырыс',
    th: 'คำสั่งเดียวกัน',
    ug: 'بىر زاكاز',
    vi: 'Cùng đơn hàng',
    zh_tc: '同訂單',
    ru: 'Тот же заказ',
    ko: '동일 주문',
    bur: 'တူညီမှာယူမှု',
    ben: 'একই অর্ডার',
    tr: 'Aynı sipariş',
    km: 'ការកម្មង់ដូចគ្នា',
    es: 'Mismo orden',
    ar: 'نفس الترتيب',
  },
  'printPage.editPage.sameRoom': {
    zh: '同房间',
    en: 'Same Room',
    id: 'Kamar yang sama',
    kz: 'Жекелей төбес',
    th: 'ห้องเดียวกัน',
    ug: 'بىر ئۆي',
    vi: 'Cùng phòng',
    zh_tc: '同房間',
    ru: 'В одной комнате',
    ko: '같은 방',
    bur: 'တူညီအခန်း',
    ben: 'একই রুম',
    tr: 'Aynı oda',
    km: 'បន្ទប់ដូចគ្នា',
    es: 'Misma habitación',
    ar: 'نفس الغرفة',
  },
  'printPage.editPage.sameWardrobe': {
    zh: '同柜体',
    en: 'Same Wardrobe',
    id: 'Kabinet yang sama',
    kz: 'Жекелей кабинет',
    th: 'ตู้เดียวกัน',
    ug: 'بىر قابا',
    vi: 'Cùng tủ',
    zh_tc: '同櫃體',
    ru: 'Шкаф',
    ko: '같은 캐비닛',
    bur: 'တူညီကက်ဘိနက်',
    ben: 'একই ওয়ারড্রোব',
    tr: 'Aynı dolap',
    km: 'ទូដូចគ្នា',
    es: 'Mismo gabinete',
    ar: 'نفس الخزانة',
  },
  'printPage.editPage.alignWay': {
    zh: '对齐方式',
    en: 'Alignment',
    id: 'Penyelarasan',
    kz: 'Қарастыру әдісі',
    th: 'การจัดตำแหน่ง',
    ug: 'توغرىلاش ئۇسۇلى',
    vi: 'Cách cách liên kết',
    zh_tc: '對齊方式',
    ru: 'Выравнивание',
    ko: '정렬',
    bur: 'ညှိချက်နည်း',
    ben: 'অ্যালাইনমেন্ট',
    tr: 'Hizalama',
    km: 'ការតម្រឹម',
    es: 'Alineación',
    ar: 'المحاذاة',
  },
  'printPage.editPage.JustifyLeft': {
    zh: '居左对齐',
    en: 'Left-Aligned',
    id: 'Sejajarkan kiri',
    kz: 'Сол жаққа қарастыру',
    th: 'จัดแนวซ้าย',
    ug: 'سولغا توغرىلاش',
    vi: 'Căn trái',
    zh_tc: '居左對齊',
    ru: 'Выровнять слева',
    ko: '왼쪽 정렬',
    bur: 'ဘယ်ညှိ',
    ben: 'বাম-সারিবদ্ধ',
    tr: 'Sola hizalı',
    km: 'តម្រឹមឆ្វេង',
    es: 'Alineado a la izquierda',
    ar: 'محاذاة إلى اليسار',
  },
  'printPage.editPage.JustifyRight': {
    zh: '居右对齐',
    en: 'Right-Aligned',
    id: 'Sejajar dengan benar',
    kz: 'Оң жаққа қарастыру',
    th: 'จัดตำแหน่งขวา',
    ug: 'ئوڭغا توغرىلاش',
    vi: 'Căn phải',
    zh_tc: '居右對齊',
    ru: 'Выровнять справа',
    ko: '오른쪽 정렬',
    bur: 'ညာညှိ',
    ben: 'ডান-সারিবদ্ধ',
    tr: 'Sağa hizalı',
    km: 'តម្រឹមស្តាំ',
    es: 'Alineado a la derecha',
    ar: 'محاذاة إلى اليمين',
  },
  'printPage.editPage.JustifyCenter': {
    zh: '居中对齐',
    en: 'Centered',
    id: 'Pusat Align',
    kz: 'Ортаға қарастыру',
    th: 'จัดตำแหน่งศูนย์',
    ug: 'ئوتتۇرىغا توغرىلاش',
    vi: 'Căn giữa',
    zh_tc: '居中對齊',
    ru: 'Выравнивание по центру',
    ko: '가운데 맞춤',
    bur: 'အလယ်ညှိ',
    ben: 'কেন্দ্র-সারিবদ্ধ',
    tr: 'Ortalanmış',
    km: 'តម្រឹមកណ្តាល',
    es: 'Alineado al centro',
    ar: 'محاذاة للوسط',
  },
  'printPage.editPage.otherOpration': {
    zh: '其他操作',
    en: 'Other Operations',
    id: 'Operasi Lainnya',
    kz: 'Басқа операциялар',
    th: 'การดำเนินการอื่น ๆ',
    ug: 'باشقا مەشغۇلات',
    vi: 'Hành động khác',
    zh_tc: '其他操作',
    ru: 'Другие операции',
    ko: '추가 작업',
    bur: 'အခြားလုပ်ဆောင်ချက်',
    ben: 'অন্যান্য অপারেশন',
    tr: 'Diğer işlemler',
    km: 'ប្រតិបត្តិការផ្សេងទៀត',
    es: 'Otras operaciones',
    ar: 'عمليات أخرى',
  },
  'printPage.editPage.attributeReset': {
    zh: '参数重置',
    en: 'Reset Attributes',
    id: 'Parameter Reset',
    kz: 'Қасиеттерді қалпына келтіру',
    th: 'รีเซ็ตพารามิเตอร์',
    ug: 'پارامېتىرنى قايتا تەڭشەش',
    vi: 'Thiết lập lại tham số',
    zh_tc: '參數重置',
    ru: 'Сброс параметров',
    ko: '매개변수 재설정',
    bur: 'ပါရာမီတာပြန်ထား',
    ben: 'অ্যাট্রিবিউট রিসেট',
    tr: 'Özellikleri sıfırla',
    km: 'កំណត់លក្ខណៈឡើងវិញ',
    es: 'Restablecimiento de parámetros',
    ar: 'إعادة تعيين المعلمة',
  },
  'printPage.editPage.barCodeSize': {
    zh: '条码尺寸',
    en: 'Barcode Size',
    id: 'Ukuran barcode',
    kz: 'Штрих-кодтың өлшемі',
    th: 'ขนาดบาร์โค้ด',
    ug: 'سىزىق كود ئۆلچىمى',
    vi: 'Kích thước mã vạch',
    zh_tc: '條碼尺寸',
    ru: 'Размер штрих - кода',
    ko: '바코드 크기',
    bur: 'ဘားကုဒ်အရွယ်',
    ben: 'বারকোড সাইজ',
    tr: 'Barkod boyutu',
    km: 'ទំហំបាកូដ',
    es: 'Tamaño del código de barras',
    ar: 'حجم الرمز الشريطي',
  },
  'printPage.editPage.installPic': {
    zh: '安装图',
    en: 'Installation Diagram',
    id: 'Diagram instalasi',
    kz: 'Қорынту суреті',
    th: 'แผนภาพการติดตั้ง',
    ug: 'ئورنىتىش رەسىمى',
    vi: 'Hình ảnh lắp đặt',
    zh_tc: '安裝圖',
    ru: 'установочный чертеж',
    ko: '설치 다이어그램',
    bur: 'တပ်ဆင်ပုံ',
    ben: 'ইনস্টলেশন ডায়াগ্রাম',
    tr: 'Kurulum şeması',
    km: 'រូបដំឡើង',
    es: 'Diagrama de instalación',
    ar: 'مخطط التثبيت',
  },
  'printPage.editPage.plankCode2': {
    zh: '板件条码(noMark)',
    en: 'Plate Barcode (noMark)',
    id: 'Papan Barcode (Nomark)',
    kz: 'Кескіштің штрих-код (noMark)',
    th: 'บอร์ดบาร์โค้ด (Nomark)',
    ug: 'تاختا سىزىق كودى (noMark)',
    vi: 'Mã vạch tấm (noMark)',
    zh_tc: '板件條碼(noMark)',
    ru: 'Штрих - код панели (noMark)',
    ko: '보드 바코드(noMark)',
    bur: 'ပြားဘားကုဒ်(noMark)',
    ben: 'প্লেট বারকোড (noMark)',
    tr: 'Plaka barkodu (noMark)',
    km: 'បាកូដផ្ទាំង (noMark)',
    es: 'Código de barras del panel (noMark)',
    ar: 'الرمز الشريطي للوحة (noMark)',
  },
  'printPage.editPage.frontCode': {
    zh: '正面条码',
    en: 'Front Barcode',
    id: 'Kode mie positif',
    kz: 'Алдыңғы жақ штрих-код',
    th: 'รหัสก๋วยเตี๋ยวบวก',
    ug: 'ئالدىنقى تەرەپ سىزىق كودى',
    vi: 'Mã vạch mặt trước',
    zh_tc: '正面條碼',
    ru: 'Положительный штрих - код',
    ko: '전면 바코드',
    bur: 'ရှေ့မျက်နှာဘားကုဒ်',
    ben: 'সামনের বারকোড',
    tr: 'Ön barkod',
    km: 'បាកូដមុខ',
    es: 'Código de barras frontal',
    ar: 'الرمز الشريطي الأمامي',
  },
  'printPage.editPage.backCode': {
    zh: '反面条码',
    en: 'Back Barcode',
    id: 'Kode mie terbalik',
    kz: 'Арқа жақ штрих-код',
    th: 'รหัสก๋วยเตี๋ยวย้อนกลับ',
    ug: 'ئارقا تەرەپ سىزىق كودى',
    vi: 'Mã vạch mặt sau',
    zh_tc: '反麵條碼',
    ru: 'Отрицательный штрих - код',
    ko: '후면 바코드',
    bur: 'အနောက်မျက်နှာဘားကုဒ်',
    ben: 'পিছনের বারকোড',
    tr: 'Arka barkod',
    km: 'បាកូដក្រោយ',
    es: 'Código de barras inverso',
    ar: 'الرمز الشريطي العكسي',
  },
  'printPage.editPage.orderRemark': {
    zh: '订单备注',
    en: 'Order Remark',
    id: 'Catatan pesanan',
    kz: 'Тапсырыс туралы ескерту',
    th: 'บันทึกการสั่งซื้อ',
    ug: 'زاكاز ئىزاھاتى',
    vi: 'Ghi chú đơn hàng',
    zh_tc: '訂單備註',
    ru: 'Примечания к заказам',
    ko: '주문 노트',
    bur: 'မှာယူမှုမှတ်ချက်',
    ben: 'অর্ডার মন্তব্য',
    tr: 'Sipariş notları',
    km: 'កំណត់ចំណាំការកម្មង់',
    es: 'Comentarios del pedido',
    ar: 'ملاحظات الطلب',
  },
  'printPage.editPage.NCFileName': {
    zh: '下料文件名',
    en: 'Cutting File Name',
    id: 'Memotong nama file',
    kz: 'Кескіштің файлының аты',
    th: 'ตัดชื่อไฟล์',
    ug: 'كېسىش ھۆججەت ئىسمى',
    vi: 'Tên tệp tách liệu',
    zh_tc: '下料文件名',
    ru: 'Загрузить имя файла',
    ko: '원본 파일 이름',
    bur: 'ဖြတ်တောက်ဖိုင်အမည်',
    ben: 'কাটিং ফাইলের নাম',
    tr: 'Kesim dosya adı',
    km: 'ឈ្មោះឯកសារកាត់',
    es: 'Nombre del archivo en blanco',
    ar: 'اسم الملف الفارغ',
  },
  'printPage.editPage.NCFileNameTip': {
    zh: '下料文件名请勿包含中文且长度不可超过10位',
    en: 'The NC file name should not contain Chinese characters and should not exceed 10 characters in length',
    id: 'Jangan termasuk Cina dalam nama file dan panjang tidak boleh melebihi 10 digit.',
    kz: 'NC файл атауында қытай символдары болмауы және ұзындығы 10 символдан аспауы тиіс',
    th: 'อย่ารวมภาษาจีนในชื่อไฟล์และความยาวต้องไม่เกิน 10 หลัก',
    ug: 'كېسىش ھۆججەت ئىسمىدە خەنزۇچە بولماسلىقى ۋە ئۇزۇنلۇقى 10 ھەرپتىن ئاشماسلىقى كېرەك',
    vi: 'Tên tệp tách liệu không chứa tiếng Trung và độ dài không quá 10 ký tự',
    zh_tc: '下料文件名請勿包含中文且長度不可超過10位',
    ru: 'Название файла не должно содержать китайский и не должно превышать 10 бит.',
    ko: '원본 파일 이름은 중국어를 포함하지 마십시오. 길이는 10자리를 초과할 수 없습니다.',
    bur: 'ဖြတ်တောက်ဖိုင်အမည်တွင်တရုတ်မပါရ၊ အရှည်၁၀လုံးထက်မပိုရ',
    ben: 'NC ফাইলের নামে চীনা অক্ষর থাকবে না এবং দৈর্ঘ্য ১০ অক্ষরের বেশি হবে না',
    tr: 'NC dosya adı Çince karakter içermemeli ve uzunluğu 10 karakteri geçmemelidir',
    km: 'ឈ្មោះឯកសារ NC មិនគួរមានអក្សរចិន និងមិនវែងជាង ១០ តួទេ',
    es: 'El nombre del archivo en blanco no debe contener caracteres chinos y no puede exceder los 10 dígitos de longitud',
    ar: 'يجب ألا يحتوي اسم الملف الفارغ على أحرف صينية ولا يمكن أن يتجاوز طوله 10 أرقام',
  },
  'printPage.editPage.showOpenSide': {
    zh: '显示开门方向',
    en: 'Show Door Opening Direction',
    id: 'Tunjukkan arah pembukaan pintu',
    kz: 'Қақпа ашу бағытын көрсету',
    th: 'แสดงทิศทางการเปิดประตู',
    ug: 'ئېچىش يۆنىلىشىنى كۆرسەت',
    vi: 'Hiển thị hướng mở cửa',
    zh_tc: '顯示開門方向',
    ru: 'Показать направление открытия',
    ko: '문 여는 방향 표시',
    bur: 'တံခါးဖွင့်ရာဘက်ပြသ',
    ben: 'দরজা খোলার দিক দেখান',
    tr: 'Kapı açılış yönünü göster',
    km: 'បង្ហាញទិសបើកទ្វារ',
    es: 'Mostrar la dirección de apertura de la puerta',
    ar: 'اتجاه فتح باب العرض',
  },
  'printPage.editPage.limitFixed': {
    zh: '限制小数点位数',
    en: 'Limit Decimal Places',
    id: 'Batasi jumlah titik desimal',
    kz: 'Десятич сандық орнын шектеу',
    th: 'จำกัด จำนวนจุดทศนิยม',
    ug: 'دېتال نۇقتىسىنى چەكلەش',
    vi: 'Giới hạn số chữ số sau dấu phẩy',
    zh_tc: '限制小數點位數',
    ru: 'Количество десятичных знаков',
    ko: '소수점 자릿수 제한',
    bur: 'ဒဿမနေရာကန့်သတ်',
    ben: 'দশমিক স্থান সীমিত করুন',
    tr: 'Ondalık basamak sayısını sınırla',
    km: 'កំណត់ចំនួនខ្ទង់ទសភាគ',
    es: 'Limitar el número de puntos decimales',
    ar: 'الحد من عدد النقاط العشرية',
  },
  'printPage.editPage.showFrontHS': {
    zh: '显示正面孔槽',
    en: 'Show Front Hole Slot',
    id: 'Tampilkan slot wajah depan',
    kz: 'Алдыңғы түйіндік-ойықтарды көрсету',
    th: 'แสดงช่องด้านหน้า',
    ug: 'ئالدىنقى تەرەپ تېشىك/ئويۇقىنى كۆرسەت',
    vi: 'Hiển thị lỗ khoan mặt trước',
    zh_tc: '顯示正面孔槽',
    ru: 'Показать лобовое отверстие',
    ko: '전면 구멍 슬롯 표시',
    bur: 'ရှေ့မျက်နှာအပေါက်ချောင်းပြသ',
    ben: 'সামনের হোল স্লট দেখান',
    tr: 'Ön yüz delik/olukları göster',
    km: 'បង្ហាញរណ្តៅ/រណ្តៅមុខ',
    es: 'Mostrar las ranuras frontales',
    ar: 'عرض الفتحات الأمامية',
  },
  'printPage.editPage.showBackHS': {
    zh: '显示反面孔槽',
    en: 'Show Back Hole Slot',
    id: 'Tunjukkan slot wajah terbalik',
    kz: 'Артқы түйіндік-ойықтарды көрсету',
    th: 'แสดงสล็อตใบหน้าย้อนกลับ',
    ug: 'ئارقا تەرەپ تېشىك/ئويۇقىنى كۆرسەت',
    vi: 'Hiển thị lỗ khoan mặt sau',
    zh_tc: '顯示反面孔槽',
    ru: 'Показать отверстие с обратной стороны',
    ko: '후면 구멍 슬롯 표시',
    bur: 'အနောက်မျက်နှာအပေါက်ချောင်းပြသ',
    ben: 'পিছনের হোল স্লট দেখান',
    tr: 'Arka yüz delik/olukları göster',
    km: 'បង្ហាញរណ្តៅ/រណ្តៅក្រោយ',
    es: 'Mostrar la ranura inversa',
    ar: 'إظهار الفتحة العكسية',
  },
  'printPage.editPage.showPartEdge': {
    zh: '显示板件封边',
    en: 'Show Panel Edge Banding',
    id: 'Tampilkan viền cạnh tấm',
    kz: 'Панель жиегін көрсету',
    th: 'แสดง viền cạnh tấm',
    ug: 'تاختا ئۆلچىمىنى كۆرسەت',
    vi: 'Hiển thị viền cạnh tấm',
    zh_tc: '顯示板件封邊',
    ru: 'Закрытие панелей',
    ko: '보드 막대 모서리 표시하기',
    bur: 'ပြားအစွန်းပြားပြသ',
    ben: 'প্যানেল এজ ব্যান্ডিং দেখান',
    tr: 'Plaka bantlamayı göster',
    km: 'បង្ហាញការបំណុលគែមផ្ទាំង',
    es: 'Bandas de borde del panel de visualización',
    ar: 'نطاق حافة لوحة العرض',
  },
  'printPage.editPage.showPlankSize': {
    zh: '显示板件尺寸',
    en: 'Show Plank Size',
    id: 'Ukuran panel tampilan',
    kz: 'Панельдің өлшемін көрсету',
    th: 'ขนาดแผงแสดง',
    ug: 'تاختا ئۆلچىمىنى كۆرسەت',
    vi: 'Hiển thị kích thước tấm',
    zh_tc: '顯示板件尺寸',
    ru: 'Показать размер панели',
    ko: '보드 크기 표시하기',
    bur: 'ပြားအရွယ်ပြသ',
    ben: 'প্ল্যাঙ্ক সাইজ দেখান',
    tr: 'Plaka boyutunu göster',
    km: 'បង្ហាញទំហំផ្ទាំង',
    es: 'Tamaño del panel de visualización',
    ar: 'حجم لوحة العرض',
  },
  'printPage.editPage.tempNamePlaceholder': {
    zh: '请输入标签名',
    en: 'Please enter the label name',
    id: 'Harap masukkan nama tag',
    kz: 'Тег атауын енгізіңіз',
    th: 'กรุณากรอกชื่อแท็ก',
    ug: 'بەلگە ئىسمىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập tên nhãn',
    zh_tc: '請輸入標籤名',
    ru: 'Введите имя метки',
    ko: '태그 이름을 입력하십시오.',
    bur: 'တံဆိပ်အမည်ထည့်ပါ',
    ben: 'লেবেলের নাম লিখুন',
    tr: 'Etiket adını girin',
    km: 'សូមបញ្ចូលឈ្មោះស្លាក',
    es: 'Ingrese el nombre de la etiqueta',
    ar: 'يرجى إدخال اسم العلامة',
  },
  'printPage.editPage.deleteAreaTip': {
    zh: '请选择要删除的区块',
    en: 'Please select the area to delete',
    id: 'Pilih blok yang akan dihapus',
    kz: 'Жою кеңесін таңдаңыз',
    th: 'โปรดเลือกบล็อกเพื่อลบ',
    ug: 'ئۆچۈرۈلىدىغان رايوننى تاللاڭ',
    vi: 'Vui lòng chọn khu vực để xóa',
    zh_tc: '請選擇要刪除的區塊',
    ru: 'Выберите блок для удаления',
    ko: '삭제할 청크를 선택하십시오.',
    bur: 'ဖျက်မည့်နေရာရွေးပါ',
    ben: 'মুছতে চাওয়া অঞ্চল নির্বাচন করুন',
    tr: 'Silinecek alanı seçin',
    km: 'សូមជ្រើសតំបន់ដែលត្រូវលុប',
    es: 'Seleccione el bloque que desea eliminar',
    ar: 'يرجى تحديد الكتلة المراد حذفها',
  },
  'printPage.editPage.suitShunt': {
    zh: '适配孔槽分流设置',
    en: 'Suit Shunt Setting',
    id: 'Pengaturan shunt yang cocok',
    kz: 'Бекіту түйіндік-ойықтарды бөлуді таңдаңыз',
    th: 'ตั้งค่าส่งออกที่เหมาะสม',
    ug: 'تەرەپ تېشىك/ئويۇق بىرىمەن قۇرۇلىش تاللاش',
    vi: 'Cài đặt phân luồng phù hợp',
    zh_tc: '適配孔槽分流設置',
    ru: 'Настройка адаптации слотов',
    ko: '맞춤 구멍 슬롯 분기 설정',
    bur: 'ပြားအပေါက်ချောင်းပြသ',
    ben: 'প্যানেল এজ ব্যান্ডিং দেখান',
    tr: 'Plaka bantlamayı göster',
    km: 'បង្ហាញការបំណុលគែមផ្ទាំង',
    es: 'Bandas de borde del panel de visualización',
    ar: 'نطاق حافة لوحة العرض',
  },
  'printPage.editPage.suitShuntTip': {
    zh: '勾选后,孔槽分流后无后道工序加工的孔槽板件便不生成条码',
    en: 'After selecting, the pieces of hole slots that have no subsequent processes after分流 will not generate barcodes',
    id: 'Setelah memilih, bagian lubang yang tidak memiliki proses berikutnya setelah分流 tidak akan menghasilkan barcode',
    kz: 'Бекітуден кейін өңдеуге қатыспайтын түйіндік-ойықтардың бөліктері штрих-код жасамайды',
    th: 'หลังจากเลือก ส่วนของช่องรูและช่องว่างที่ไม่มีการดำเนินการต่อหลังจะไม่สร้างบาร์โค้ด',
    ug: 'بىرىمەن قۇرۇلىشتىن كىيىن ئەڭ كىرىشى قۇرۇلىش قاتارىنىڭ بىرىمەن كىيىن سىزىق كودنى قىلمايدۇ',
    vi: 'Sau khi chọn, các bộ phận lỗ khoan không có quy trình sau đó sẽ không tạo mã vạch',
    zh_tc: '勾選後,孔槽分流後無後道工序加工的孔槽板件便不生成條碼',
    ru: 'После выбора, части отверстий, которые не имеют последующей обработки после分流, не будут генерировать штрих-коды',
    ko: '선택 후, 후속 공정이 없는 구멍 슬롯 부품은 바코드를 생성하지 않습니다.',
    bur: 'ပြုပြင်ခြင်းနောက် နောက်ဆက်စက်မရှိသော ပြားအပေါက်ချောင်းပြားများကို ဘားကုဒ်များမထုတ်လိုက်ပါ',
    ben: 'পিছনের কাজ না থাকলে, হোল স্লট প্যানেল বারকোড তৈরি করা হবে না',
    tr: 'Seçildikten sonra, sonraki işlemi olmayan delik/oluk parçaları barkod oluşturmaz',
    km: 'បង្ហាញការបំណុលគែមផ្ទាំងដែលមិនមានការបំណុលគែមផ្ទាំងបន្ទាប់',
    es: 'Después de seleccionar, las piezas de ranuras que no tienen procesos posteriores después de la bifurcación no generarán códigos de barras',
    ar: 'بعد الاختيار ، لا يتم إنشاء رموز الشريطية للأجزاء التي لا تحتوي على عمليات لاحقة بعد التفرع',
  },
  'printPage.editPage.noHoleSlot': {
    zh: '无孔槽也显示条码',
    en: 'Show Barcode Even without Hole and Slot',
    id: 'Tidak ada slot lubang juga menampilkan barcode',
    kz: 'Тешіксіз де штрих-код көрсетілуішін таңдаңыз',
    th: 'ไม่มีช่องรูแสดงบาร์โค้ด',
    ug: 'تېشىك/ئويۇق بولمىسىمۇ سىزىق كودنى كۆرسەت',
    vi: 'Hiển thị mã vạch khi không có lỗ khoan',
    zh_tc: '無孔槽也顯示條碼',
    ru: 'Беспорядочный слот также показывает штрих - код.',
    ko: '구멍 없는 슬롯에도 바코드 표시',
    bur: 'အပေါက်ချောင်းမရှိလည်းဘားကုဒ်ပြသ',
    ben: 'হোল ও স্লট না থাকলেও বারকোড দেখান',
    tr: 'Delik/oluk olmasa da barkodu göster',
    km: 'បង្ហាញបាកូដទោះបីគ្មានរណ្តៅ/រណ្តៅ',
    es: 'El código de barras también se muestra para ranuras sin orificios',
    ar: 'يتم عرض الرمز الشريطي أيضًا للفتحات غير المثقوبة',
  },
  'printPage.editPage.rotate': {
    zh: '旋转条码',
    en: 'Rotate Barcode',
    id: 'Barcode berputar',
    kz: 'Штрих-кодты айналу',
    th: 'บาร์โค้ดหมุน',
    ug: 'سىزىق كودنى بۇرۇش',
    vi: 'Xoay mã vạch',
    zh_tc: '旋轉條碼',
    ru: 'Ротационный штрих - код',
    ko: '회전 바코드',
    bur: 'ဘားကုဒ်လည်ပါ',
    ben: 'বারকোড ঘোরান',
    tr: 'Barkodu döndür',
    km: 'បង្វិលបាកូដ',
    es: 'Girar el código de barras',
    ar: 'تدوير الرمز الشريطي',
  },
  'printPage.editPage.barcodeAtrribute': {
    zh: '条码属性',
    en: 'Barcode Attributes',
    id: 'Atribut Barcode',
    kz: 'Штрих-кодтың қасиеттері',
    th: 'แอตทริบิวต์บาร์โค้ด',
    ug: 'سىزىق كود خاسلىقى',
    vi: 'Thuộc tính mã vạch',
    zh_tc: '條碼屬性',
    ru: 'Свойства штрих - кода',
    ko: '바코드 속성',
    bur: 'ဘားကုဒ်ဂုဏ်သတ္တိ',
    ben: 'বারকোড অ্যাট্রিবিউট',
    tr: 'Barkod özellikleri',
    km: 'លក្ខណៈបាកូដ',
    es: 'Propiedades del código de barras',
    ar: 'خصائص الرمز الشريطي',
  },
  'printPage.editPage.imgSize': {
    zh: '图像尺寸',
    en: 'Image Size',
    id: 'Ukuran gambar',
    kz: 'Суреттің өлшемі',
    th: 'ขนาดภาพ',
    ug: 'رەسىم ئۆلچىمى',
    vi: 'Kích thước hình ảnh',
    zh_tc: '圖像尺寸',
    ru: 'Размер изображения',
    ko: '이미지 크기',
    bur: 'ပုံအရွယ်',
    ben: 'ইমেজ সাইজ',
    tr: 'Görüntü boyutu',
    km: 'ទំហំរូបភាព',
    es: 'Tamaño de imagen',
    ar: 'حجم الصورة',
  },
  'printPage.editPage.graphStyle': {
    zh: '图形样式',
    en: 'Graph Style',
    id: 'Grafik Style',
    kz: 'График стилі',
    th: 'รูปแบบกราฟ',
    ug: 'رەسىم ئۆلچىمى',
    vi: 'Kiểu hình ảnh',
    zh_tc: '圖形樣式',
    ru: 'Графический стиль',
    ko: '그래픽 스타일',
    bur: 'ဂရပ်ဖစ်စတိုင်း',
    ben: 'গ্রাফ স্টাইল',
    tr: 'Grafik stili',
    km: 'ស្តាយល់ក្រាហ្វិក',
    es: 'Estilo gráfico',
    ar: 'نمط الرسم',
  },
  'printPage.editPage.noEdgeDisplay': {
    zh: '封边为0不显示',
    en: 'Do Not Display if Edge is 0',
    id: 'Tepi adalah 0 dan tidak akan ditampilkan',
    kz: 'Кескістің шеті 0 болса штрих-код көрсетілмейді',
    th: 'ขอบคือ 0 และจะไม่แสดง',
    ug: 'چېگرا كېسىش 0 بولسا كۆرسەتمە',
    vi: 'Không hiển thị nếu cạnh đóng biên bằng 0',
    zh_tc: '封邊為0不顯示',
    ru: 'Закрыть & 0 без показа',
    ko: '봉인 모서리가 0이면 표시되지 않습니다.',
    bur: 'အစွန်းပြား၀ဖြစ်လျှင်မပြသ',
    ben: 'এজ ০ হলে দেখাবেন না',
    tr: 'Bant 0 ise gösterme',
    km: 'បំណុល ០ កុំបង្ហាញ',
    es: 'Las bandas de borde son 0 y no se muestran',
    ar: 'نطاق الحافة هو 0 ولا يتم عرضه',
  },
  'printPage.editPage.allEdgeNoDisplay': {
    zh: '封边不显示',
    en: 'Edge banding is not displayed',
    id: 'Pemblokiran tepi tidak ditampilkan',
    kz: 'Жиектерді топтау көрсетілмейді',
    th: 'การปิดกั้นขอบไม่แสดง',
    ug: 'چېگرا كېسىشنى كۆرسەتمە',
    vi: 'Dải cạnh không được hiển thị',
    zh_tc: '封邊不顯示',
    ru: 'Закрытие не отображается',
    ko: '봉인 모서리가 표시되지 않음',
    bur: 'အစွန်းပြားမပြသ',
    ben: 'এজ ব্যান্ডিং দেখানো হয় না',
    tr: 'Bantlamayı gösterme',
    km: 'កុំបង្ហាញការបំណុលគែម',
    es: 'Las bandas de borde no se muestran',
    ar: 'لا يتم عرض نطاق الحافة',
  },
  'printPage.editPage.isShowDiffEdgeColor': {
    zh: '显示各封边颜色',
    en: 'Show different edge colors',
    id: 'Tampilkan warna tepi yang berbeda',
    kz: 'Әртүрлі жиек түстерін көрсету',
    th: 'แสดงสีขอบที่แตกต่างกัน',
    ug: 'ھەر خىل چېگرا رەڭگىنى كۆرسەت',
    vi: 'Hiển thị màu cạnh khác nhau',
    zh_tc: '顯示各封邊顏色',
    ru: 'Показать цвета на каждой стороне',
    ko: '각 봉인 모서리 색상 표시',
    bur: 'အစွန်းပြားအရောင်များပြသ',
    ben: 'বিভিন্ন এজ রঙ দেখান',
    tr: 'Her bant rengini göster',
    km: 'បង្ហាញពណ៌បំណុលគែមរៀងរាល់',
    es: 'Muestra cada borde color de banda',
    ar: 'عرض كل منهما لون نطاق الحافة',
  },
  'printPage.editPage.hideSameEdgeColorAsPlank': {
    zh: '单边颜色与板件相同时不显示',
    en: 'Hide edge color when same as plank color',
    id: 'Sembunyikan warna tepi saat sama dengan warna papan',
    kz: 'Панель түстерімен сәйкес кезде жиек түстері көрсетілмейді',
    th: 'ขอบคือ 0 และจะไม่แสดง',
    ug: 'چېگرا كېسىش 0 بولسا كۆرسەتمە',
    vi: 'Không hiển thị màu cạnh khi cùng màu với màu tấm',
    zh_tc: '單邊顏色與板件相同时不顯示',
    ru: 'Скрыть цвет на каждой стороне, когда он такой же, как цвет панели',
    ko: '판자 색상과 같을 때 봉인 모서리 색상 숨기기',
    bur: 'ပေါ်ဒ်အရောင်များအတူတူဖြစ်လျှင်အစွန်းပြားအရောင်များမပြသ',
    ben: 'প্লেট রঙ সমান হলে এজ রঙ দেখাবেন না',
    tr: 'Bant rengi panele eşitse gösterme',
    km: 'កុំបង្ហាញពណ៌បᆆណុលគែមរៀងរាល់ដែលសមាជិកជាមួយនឹងពណ៌បᆆណុលគែម',
    es: 'Ocultar color de borde cuando es el mismo que el color de la placa',
    ar: 'إخفاء لون الحافة عندما يكون مساويا للون اللوح',
  },
  'printPage.editPage.hideSameEdgeColorAsPlankTip': {
    zh: '内嵌云排版暂不支持',
    en: 'Not yet supported in embedded cloud layout',
    id: 'Tata letak awan tertanam belum didukung',
    kz: 'Кіріктірілген бұлт пішімдеуі әзірге қолдау көрсетілмейді',
    th: 'เค้าโครงเมฆแบบฝังยังไม่รองรับ',
    ug: 'ئىچكى بۇلۇت تەرتىپلىگۈچ ۋاقتىنچە قوللىمايدۇ',
    vi: 'Sắp xếp đám mây nhúng tạm thời chưa hỗ trợ',
    zh_tc: '內嵌雲排版暫不支持',
    ru: 'Встроенная облачная вёрстка пока не поддерживается',
    ko: '내장 클라우드 조판은 당분간 지원하지 않습니다',
    bur: 'ထည့်သွင်းမိုးတိမ်တပ်ဆင်ခြင်းသည်ယာယီမပံ့ပိုးပါ',
    ben: 'এমবেডেড ক্লাউড লেআউট এখনও সমর্থিত নয়',
    tr: 'Gömülü bulut düzeni henüz desteklenmiyor',
    km: 'ការរៀបចំក្នុងពពកខ្ចប់មិនទាន់គាំទ្រទេ',
    es: 'La composición tipográfica en la nube integrada aún no es compatible',
    ar: 'التنضيد السحابي المضمن غير مدعوم مؤقتًا',
  },
  'printPage.editPage.imgRotate': {
    zh: '图片旋转',
    en: 'Image Rotation',
    id: 'Rotasi Gambar',
    kz: 'Суретті айналдыру',
    th: 'การหมุนภาพ',
    ug: 'رەسىمنى بۇرۇش',
    vi: 'Xoay hình ảnh',
    zh_tc: '圖片旋轉',
    ru: 'Изображение вращается',
    ko: '그림 회전',
    bur: 'ပုံလည်ပါ',
    ben: 'ইমেজ রোটেশন',
    tr: 'Görüntüyü döndür',
    km: 'បង្វិលរូបភាព',
    es: 'Rotación de imagen',
    ar: 'تدوير الصورة',
  },
  'printPage.editPage.circleD': {
    zh: '圆框直径',
    en: 'Circle Frame Diameter',
    id: 'Diameter bingkai lingkaran',
    kz: 'Дөңгелек жақтау диаметрі',
    th: 'เส้นผ่านศูนย์กลางเฟรมวงกลม',
    ug: 'دۆڭگىرەك چەمبەر قۇرۇش',
    vi: 'Đường kính khung tròn',
    zh_tc: '圓框直徑',
    ru: 'Диаметр рамы',
    ko: '원형 상자 지름',
    bur: 'အဝိုင်းဘောင်အချင်း',
    ben: 'বৃত্ত ফ্রেমের ব্যাস',
    tr: 'Daire çerçeve çapı',
    km: 'អង្កត់ផ្ចិតក្រុងរង្វង់',
    es: 'Diámetro del marco circular',
    ar: 'قطر إطار الدائرة',
  },
  'printPage.editPage.roomNo': {
    zh: '房间编号',
    en: 'Room Number',
    id: 'Nomor kamar',
    kz: 'Бөлме нөмірі',
    th: 'หมายเลขห้องพัก',
    ug: 'ئۆي نومۇرى',
    vi: 'Số phòng',
    zh_tc: '房間編號',
    ru: 'Номер комнаты',
    ko: '방 번호',
    bur: 'အခန်းနံပါတ်',
    ben: 'রুম নম্বর',
    tr: 'Oda numarası',
    km: 'លេខបន្ទប់',
    es: 'Número de habitación',
    ar: 'رقم الغرفة',
  },
  'printPage.editPage.roomOrder': {
    zh: '柜体序号（按房间排序）',
    en: 'Cabinet Order (Sorted by Room)',
    id: 'Nomor kabinet (diurutkan berdasarkan kamar)',
    kz: 'Шкаф нөмірі (бөлме бойынша реттеу)',
    th: 'หมายเลขตู้ (จัดเรียงตามห้อง)',
    ug: 'قابا تەرتىپ نومۇرى (ئۆي بويىچە تەرتىپلەش)',
    vi: 'Thứ tự tủ (Sắp xếp theo phòng)',
    zh_tc: '櫃體序號（按房間排序）',
    ru: 'Номер шкафа (по номеру)',
    ko: '캐비닛 번호 (방별 정렬)',
    bur: 'ကက်ဘိနက်အစဉ်(အခန်းအလိုက်စီ)',
    ben: 'ক্যাবিনেট অর্ডার (রুম অনুযায়ী সর্ট)',
    tr: 'Dolap sırası (odaya göre sıralı)',
    km: 'លំដាប់ទូ (តម្រៀបតាមបន្ទប់)',
    es: 'Número de gabinete (ordenado por habitación)',
    ar: 'رقم الخزانة (مرتبة حسب الغرفة)',
  },
  'printPage.editPage.alphabetically': {
    zh: '按字母排序',
    en: 'Sort Alphabetically',
    id: 'Urutkan berdasarkan huruf',
    kz: 'Әріп бойынша сұрыптау',
    th: 'จัดเรียงด้วยตัวอักษร',
    ug: 'ھەرپ تەرتىپى بويىچە',
    vi: 'Sắp xếp theo bảng chữ cái',
    zh_tc: '按字母排序',
    ru: 'Сортировать по буквам',
    ko: '알파벳순',
    bur: 'က္ခရာစဉ်အတိုင်း',
    ben: 'বর্ণানুক্রমে সর্ট করুন',
    tr: 'Alfabetik sırala',
    km: 'តម្រៀបតាមអក្សរ',
    es: 'Ordenar por letras',
    ar: 'الترتيب حسب الحروف',
  },
  'printPage.editPage.numberOrder': {
    zh: '按数字排序',
    en: 'Sort Numerically',
    id: 'Urutkan berdasarkan nomor',
    kz: 'Сан бойынша сұрыптау',
    th: 'เรียงลำดับตามหมายเลข',
    ug: 'سان تەرتىپى بويىچە',
    vi: 'Sắp xếp theo số',
    zh_tc: '按數字排序',
    ru: 'Сортировка по числам',
    ko: '숫자별 정렬',
    bur: 'ကိန်းဂဏန်းစဉ်အတိုင်း',
    ben: 'সংখ্যা অনুযায়ী সর্ট করুন',
    tr: 'Sayısal sırala',
    km: 'តម្រៀបតាមលេខ',
    es: 'Ordenar por números',
    ar: 'الترتيب حسب الأرقام',
  },
  'printPage.editPage.specialMarkup': {
    zh: '特殊标记符号',
    en: 'Special Marking Symbols',
    id: 'Simbol tanda khusus',
    kz: 'Ерекше белгілеу белгілері',
    th: 'สัญลักษณ์เครื่องหมายพิเศษ',
    ug: 'ئالاھىدە بەلگە بەلگىسى',
    vi: 'Ký hiệu đánh dấu đặc biệt',
    zh_tc: '特殊標記符號',
    ru: 'Специальные символы',
    ko: '특수 태그 기호',
    bur: 'အထူးမှတ်သားသင်္ကေတ',
    ben: 'বিশেষ মার্কিং চিহ্ন',
    tr: 'Özel işaretleme sembolleri',
    km: 'និមិត្តសញ្ញាសម្គាល់ពិសេស',
    es: 'Símbolos de marcas especiales',
    ar: 'رموز العلامات الخاصة',
  },
  'printPage.editPage.smallPlateMarking': {
    zh: '小板标记',
    en: 'Small plate marking',
    id: 'Tanda papan kecil',
    kz: 'Кіші тақтаның белгісі',
    th: 'สัญลักษณ์ตู้สั้น',
    ug: 'ئەڭ كۆڭەڭ قالدۇق ماتېرىيال بەلگىسى',
    vi: 'Đánh dấu tấm nhỏ',
    zh_tc: '小板標記',
    ru: 'Маркировка панелей',
    ko: '마커',
    bur: 'ပေါ်ဒ်ငယ်မှတ်သား',
    ben: 'ছোট প্লেট মার্কিং',
    tr: 'Küçük plaka işareti',
    km: 'សម្គាល់ផ្ទាំងតូច',
    es: 'Marca de tablero pequeño',
    ar: 'علامة اللوحة الصغيرة',
  },
  'printPage.editPage.arrow': {
    zh: '箭头',
    en: 'Arrow',
    id: 'Panah',
    kz: 'Жіп',
    th: 'ลูกศร',
    ug: 'كۆرگۈچى',
    vi: 'Mũi tên',
    zh_tc: '箭頭',
    ru: 'стрелка',
    ko: '화살표',
    bur: 'မြှား',
    ben: 'তীর',
    tr: 'Ok',
    km: 'ព្រួញ',
    es: 'Flecha',
    ar: 'سهم',
  },
  'printPage.editPage.triangle': {
    zh: '三角角标',
    en: 'Triangle',
    id: 'Segitiga',
    kz: 'Үшбұрыш',
    th: 'สามเหลี่ยม',
    ug: 'ئەڭ كۆڭەڭ',
    vi: 'Tam giác',
    zh_tc: '三角角標',
    ru: 'Треугольник',
    ko: '삼각 각표',
    bur: 'တြိဂံထောင့်မှတ်',
    ben: 'ত্রিভুজ',
    tr: 'Üçgen köşe işareti',
    km: 'សញ្ញាមុំត្រីកោណ',
    es: 'Marca de esquina triangular',
    ar: 'علامة الزاوية المثلثة',
  },
  'printPage.editPage.sixSideDrillPlankBase': {
    zh: '五六面钻放板基准',
    en: 'Six-sided drilling placement base',
    id: 'Dasar pemposisi bor enam sisi',
    kz: 'Алты жақты пішімдеу негізі',
    th: 'ฐานการวางตู้สว่านหกด้าน',
    ug: 'ئالتە تەرەپلىك ماتور مۇندەرىجىسى',
    vi: 'Cơ sở đặt tấm sáu mặt',
    zh_tc: '五六面鑽放板基準',
    ru: 'пятигранная опора',
    ko: '5, 6면 드릴 방판 기준',
    bur: 'ငါးချက်ခြောက်မျက်နှာတွင်းထွင်းပြားအခြေခံ',
    ben: 'ছয় পাশ ড্রিলিং প্লেসমেন্ট বেস',
    tr: 'Altı yüz delik yerleştirme tabanı',
    km: 'មូលដ្ឋានដាក់ផ្ទាំងរន្ធដោតប្រាំមួយមុខ',
    es: 'Referencia de colocación y perforación de cinco o seis lados',
    ar: 'مسند الحفر والوضع بخمسة أو ستة جوانب',
  },
  'printPage.editPage.boldSettingTip': {
    zh: 'PDF黑体不支持',
    en: 'PDF bold font is not supported',
    id: 'PDF bold font is not supported',
    kz: 'PDF қалың қаріпі қолдау көрсетпейді',
    th: 'PDF ฟอนต์คันตรงไม่รองรับ',
    ug: 'بەلگە PDF قېلىن خەت نۇسخا تەڭشىكىنى قوللىمايدۇ',
    vi: 'Phông chữ đậm trong PDF không được hỗ trợ',
    zh_tc: '標籤PDF不支持',
    ru: 'Не поддерживается жирным шрифтом PDF',
    ko: 'PDF 블랙은 지원되지 않습니다.',
    bur: 'PDF ထူဖောင့်မပံ့ပိုး',
    ben: 'PDF বোল্ড ফন্ট সাপোর্ট করা হয় না',
    tr: 'PDF kalın yazı tipi desteklenmiyor',
    km: 'ពុម្ពអក្សរទူ PDF មិនគាំទ្រ',
    es: 'PDF El cuerpo negro no es compatible',
    ar: 'PDF الجسم الأسود غير مدعوم',
  },
  'printPage.editPage.frontEdge': {
    zh: '显示柜体前边',
    en: 'Display the front of the cabinet',
    id: 'Tampilkan depan kabinet',
    kz: 'Экранды шығының алдын ақылы',
    th: 'แสดงด้านหน้าของตู้',
    ug: 'كۆرسەت كۈچۈك ئالدى',
    vi: 'Hiển thị mặt trước của tủ',
    zh_tc: '顯示櫃體前邊',
    ru: 'Показать переднюю часть шкафа',
    ko: '캐비닛 앞 보이기',
    bur: 'ကက်ဘိနက်ရှေ့မျက်နှာပြသ',
    ben: 'ক্যাবিনেটের সামনের দিক দেখান',
    tr: 'Dolabın önünü göster',
    km: 'បង្ហាញមុខទូ',
    es: 'Mostrar el lado frontal del gabinete',
    ar: 'إظهار الجانب الأمامي للخزانة',
  },
  'printPage.editPage.visibleEdge': {
    zh: '显示见光边',
    en: 'Display visible edge',
    id: 'Tampilkan pinggir terlihat',
    kz: 'Жарықтың шығыны көрсету',
    th: 'แสดงเห็นขอบแสง',
    ug: 'كۆرۈنۈش ئىچىدە يۈزۈك كەنار',
    vi: 'Hiển thị cạnh thấu sáng',
    zh_tc: '顯示見光邊',
    ru: 'Показать & край света',
    ko: '광선 모서리 표시',
    bur: 'အလင်းမျက်နှာစာပြသ',
    ben: 'দৃশ্যমান এজ দেখান',
    tr: 'Görünen ışık kenarını göster',
    km: 'បង្ហាញគែមឃើញពន្លឺ',
    es: 'Mostrar el borde visible',
    ar: 'إظهار الحافة الظاهرة',
  },
  'printPage.editPage.lineCount': {
    zh: '每行字数',
    en: 'Number of characters per line',
    id: 'Jumlah karakter per baris',
    kz: 'Бір жолдағы символдар саны',
    th: 'จำนวนอักขระต่อบรรทัด',
    ug: 'بىر خانا قىسمى ئىچىدە خەرپلەر سانى',
    vi: 'Số ký tự trên mỗi dòng',
    zh_tc: '每行字數',
    ru: 'Количество слов в строке',
    ko: '행당 단어 수',
    bur: 'တစ်ကြောင်းစာလုံးအရေအတွက်',
    ben: 'প্রতি লাইনে অক্ষরের সংখ্যা',
    tr: 'Satır başına karakter sayısı',
    km: 'ចំនួនតួអក្សរក្នុងមួយបន្ទាត់',
    es: 'Número de palabras por línea',
    ar: 'عدد الكلمات في كل سطر',
  },
  'printPage.autoSaveToHistory': {
    zh: '已自动保存至历史!',
    en: 'Automatically saved to history!',
    id: 'Secara otomatis disimpan ke sejarah!',
    kz: 'Тарихқа автоматты түрде сақталды!',
    th: 'บันทึกไว้ในประวัติศาสตร์โดยอัตโนมัติ!',
    ug: 'ئاپتوماتىك تارىخقا ساقلاندى!',
    vi: 'Đã tự động lưu vào lịch sử!',
    zh_tc: '已自動保存至歷史!',
    ru: 'Автоматически сохранены в истории!',
    ko: '자동으로 역사에 저장되었습니다!',
    bur: 'သမိုင်းသို့အလိုအလျောက်သိမ်းပြီး!',
    ben: 'ইতিহাসে স্বয়ংক্রিয়ভাবে সংরক্ষিত হয়েছে!',
    tr: 'Geçmişe otomatik kaydedildi!',
    km: 'បានរក្សាទុកទៅប្រវត្តិស្វ័យប្រវត្តិ!',
    es: '¡Se guarda automáticamente en el historial!',
    ar: 'يتم حفظها تلقائيًا في التاريخ!',
  },
  'printPage.firstPrintTip': {
    zh: '首次使用直接打印时，请在打印机设置中新增一张使用的该尺寸且长、宽对调的纸张，然后使用新增纸张进行打印',
    en: 'When using direct printing for the first time, please add a new paper size with swapped length and width in the printer settings, then use the newly added paper for printing',
    id: 'Saat Anda menggunakan pencetakan langsung untuk pertama kalinya, tambahkan selembar kertas dengan ukuran dan panjang dan lebar yang sama seperti yang digunakan dalam pengaturan printer, dan kemudian cetak dengan kertas baru.',
    kz: 'Тікелей басып шығаруды бірінші рет пайдаланғанда, басып шығару параметрлерінде ұзындығы мен ені ауыстырылған жаңа қағаз өлшемін қосып, содан кейін жаңадан қосылған қағазды пайдаланыңыз',
    th: 'เมื่อคุณใช้การพิมพ์โดยตรงเป็นครั้งแรกให้เพิ่มแผ่นกระดาษที่มีขนาดและความยาวและความกว้างเท่ากันกับที่ใช้ในการตั้งค่าเครื่องพิมพ์แล้วพิมพ์ด้วยกระดาษใหม่',
    ug: 'بىرىنچى قېتىم بىۋاسىتە بېسىپ چىقىرىشتا، بېسىپ چىقىرىش تەڭشەكلىرىدە بۇ ئۆلچەمدە ۋە ئۇزۇنلۇقى، كەڭلىكى ئالماشتۇرۇلغان يېڭى قەغەز قوشۇڭ، ئاندىن يېڭى قوشۇلغان قەغەز بىلەن بېسىپ چىقىرىڭ',
    vi: 'Khi sử dụng in trực tiếp lần đầu tiên, vui lòng thêm kích thước giấy mới với chiều dài và chiều rộng hoán đổi trong cài đặt máy in, sau đó sử dụng giấy mới thêm để in',
    zh_tc:
      '首次使用直接打印時，請在打印機設置中新增一張使用的該尺寸且長、寬對調的紙張，然後使用新增紙張進行打印',
    ru: 'При первом использовании прямой печати добавьте в настройки принтера бумагу этого размера, длинную и широкую, а затем используйте новую бумагу для печати.',
    ko: '직접 인쇄를 처음 사용할 때는 프린터 설정에 해당 크기와 길이, 너비가 조정된 용지를 추가한 다음 새 용지를 사용하여 인쇄합니다.',
    bur: 'ပထမဆုံးတိုက်ရိုက်ရိုက်နှိပ်သုံးသည့်အခါပရင့်တာဆက်တင်တွင်အလျားအကျယ်ပြောင်းထားသောစာရွက်အသစ်ထည့်ပြီးထိုစာရွက်ဖြင့်ရိုက်ပါ',
    ben: 'প্রথমবার ডাইরেক্ট প্রিন্ট ব্যবহার করলে প্রিন্টার সেটিংসে লম্বা-চওড়া উলটানো নতুন কাগজ যোগ করুন, তারপর সেই কাগজে প্রিন্ট করুন',
    tr: 'Doğrudan yazdırmayı ilk kullanımda yazıcı ayarlarına uzunluk ve genişliği yer değiştirmiş yeni bir kağıt ekleyin, ardından bu kağıtla yazdırın',
    km: 'នៅពេលប្រើបោះពុម្ពផ្ទាល់លើកដំបូង សូមបន្ថែមក្រដាសថ្មីដែលប្តូរបណ្តោយ និងទទឹងក្នុងការកំណត់ម៉ាស៊ីនបោះពុម្ព រួចបោះពុម្ពដោយប្រើក្រដាសនោះ',
    es: 'Cuando utilice la impresión directa por primera vez, agregue un nuevo papel de este tamaño con longitud y ancho intercambiados en la configuración de la impresora y luego use el nuevo papel para imprimir',
    ar: 'عند استخدام الطباعة المباشرة لأول مرة، يرجى إضافة ورقة جديدة بهذا الحجم مع تبديل الطول والعرض في إعدادات الطابعة، ثم استخدام الورقة الجديدة للطباعة',
  },
  'printPage.tagDownloading': {
    zh: '标签正在下载中...',
    en: 'The label is downloading...',
    id: 'Tag sedang diunduh ...',
    kz: 'Белгісі жүктелуде...',
    th: 'มีการดาวน์โหลดแท็ก ...',
    ug: 'بەلگە چۈشۈرۈلىۋاتىدۇ...',
    vi: 'Đang tải nhãn...',
    zh_tc: '標籤正在下載中...',
    ru: 'Метки загружаются. Это...',
    ko: '태그는 다운로드 중입니다...',
    bur: 'တံဆိပ်ဒေါင်းလုတ်ဆွဲနေသည်...',
    ben: 'লেবেল ডাউনলোড হচ্ছে...',
    tr: 'Etiket indiriliyor...',
    km: 'កំពុងទាញយកស្លាក...',
    es: 'Las etiquetas se están descargando...',
    ar: 'يتم الآن تنزيل الملصقات...',
  },
  'printPage.cutLaveEnd': {
    zh: '余料标签在每张大板后面生成',
    en: 'Cut-off labels are generated behind each large slab',
    id: 'Nama label untuk setiap lembar besar dibuat di belakang setiap lembar besar',
    kz: 'Қалдық жапсырмалары әрбір үлкен тақтаның артында жасалады',
    th: 'ป้ายตัดออกจะถูกสร้างที่ด้านหลังของแต่ละแผ่นกระดานขนาดใหญ่',
    ug: 'قالدۇق ماتېرىيال بېلگىسى ھەر بىر چوڭ تاختا ئارقىسىدا ھاسىل بولىدۇ',
    vi: 'Nhãn vật liệu dư được tạo phía sau mỗi tấm lớn',
    zh_tc: '餘料標籤在每張大板後面生成',
    ru: 'Оставшиеся метки создаются за каждой большой доской.',
    ko: '남은 재료 라벨은 각 큰 판 뒤에서 생성된다',
    bur: 'ပိုလျှံတံဆိပ်များကိုတစ်ချပ်စီပေါ်ဒ်ကြီးနောက်တွင်ဖန်တီး',
    ben: 'কাট-অফ লেবেল প্রতিটি বড় স্ল্যাবের পিছনে তৈরি হয়',
    tr: 'Kesim artığı etiketleri her büyük plakanın arkasında oluşturulur',
    km: 'ស្លាកសម្ភារៈកាត់ត្រូវបានបង្កើតនៅពីក្រោយផ្ទាំងធំនីមួយៗ',
    es: 'Las etiquetas del material restante se generan detrás de cada tablero grande',
    ar: 'يتم إنشاء ملصقات المواد المتبقية خلف كل لوحة كبيرة',
  },
  'printPage.deleteTemplate': {
    zh: '删除模板',
    en: 'Delete Template',
    id: 'Hapus Template',
    kz: 'Шаблонды өшіру',
    th: 'ลบรูปแบบ',
    ug: 'قېلىپ ئۆچۈرۈش',
    vi: 'Xóa mẫu',
    zh_tc: '刪除模板',
    ru: 'Удалить шаблон',
    ko: '템플릿 삭제',
    bur: 'ပုံစံဖျက်ဆီး',
    ben: 'রুপান্তর মুছতে নিশ্চিত করবেন',
    tr: 'Şablonu kaldır',
    km: 'លុបពុម្ពក្រុម',
    es: 'Eliminar plantilla',
    ar: 'حذف القالب',
  },
  'printPage.copyTemplateRenderUrl': {
    zh: '复制模板链接',
    en: 'Copy Template Link',
    id: 'Salin Tautan Template',
    kz: 'Шаблонтың сілтемесін көшіріңіз',
    th: 'คัดลอกลิงค์แบบ',
    ug: 'قېلىپ تەھرىرلەش سىلەتمەسىنى كۆچۈرۈش',
    vi: 'Sao chép liên kết mẫu',
    zh_tc: '複製模板連結',
    ru: 'Скопировать ссылку шаблона',
    ko: '템플릿 링크 복사',
    bur: 'ပုံစံဖျက်ဆီး',
    ben: 'টেমপ্লেট লিঙ্ক কপি করুন',
    tr: 'Şablon bağlantısını kopyala',
    km: 'ពុម្ព URL ដូចគ្នា',
    es: 'Copiar enlace de plantilla',
    ar: 'نسخ رابط القالب',
  },
  'printPage.noPermission': {
    zh: '导入模板中已关闭以下无权限功能',
    en: 'The imported template has closed the following features without permission',
    id: 'Template yang diimpor telah menutup fitur berikut tanpa izin',
    kz: 'Шаблонтың сілтемесін көшіруге рұқсаты жоқ, шаблонты жоюға жоспарлануда мурайсыз ба?',
    th: 'รูปแบบที่นำเข้ามีคุณสมบัติที่ปิดไม่มีสิทธิ์',
    ug: 'قېلىپ تەھرىرلەش سىلەتمەسىنى كۆچۈرۈش يوق, قېلىپ ئۆچۈرۈشنى جازالامسىز؟',
    vi: 'Mẫu nhập khẩu đã đóng các tính năng không có quyền',
    zh_tc: '導入模板中已關閉以下無權限功能',
    ru: 'Шаблон, у которого нет разрешения на копирование ссылки',
    ko: '템플릿 링크 복사 권한이 없습니다, 템플릿을 삭제하시겠습니까?',
    bur: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'টেমপ্লেট লিঙ্ক কপি করার অনুমতি নেই, টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tr: 'Şablon bağlantısını kopyalamaya izin yok, şablonu silmek istediğinizden emin misiniz?',
    km: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    es: 'Las siguientes funciones no autorizadas se han desactivado en la plantilla importada',
    ar: 'تم إيقاف الوظائف غير المصرح بها التالية في القالب المستورد',
  },
  'printPage.moreOperation': {
    zh: '更多操作',
    en: 'More Operation',
    id: 'Operasi Lebih Banyak',
    kz: 'Көбірек әрекеттер',
    th: 'การดำเนินการมากกว่า',
    ug: 'كۈبۈر ئىشلەتكۈچىلەر',
    vi: 'Thêm hành động',
    zh_tc: '更多操作',
    ru: 'Больше действий',
    ko: '더 많은 작업',
    bur: 'ပိုမိုလုပ်ဆောင်ချက်များ',
    ben: 'আরও কাজ করুন',
    tr: 'Daha fazla işlem',
    km: 'ការដំណើរការច្រើនទៀត',
    es: 'Más operaciones',
    ar: 'المزيد من العمليات',
  },
  'printPage.importTemplate': {
    zh: '导入模板',
    en: 'Import Template',
    id: 'Impor Template',
    kz: 'Шаблонды импорттау',
    th: 'นำเข้าเทมเพลต',
    ug: 'قېلىپ تەھرىرلەش',
    vi: 'Nhập mẫu',
    zh_tc: '導入模板',
    ru: 'Импорт шаблона',
    ko: '템플릿 가져오기',
    bur: 'ပုံစံဖျက်ဆီး',
    ben: 'টেমপ্লেট আমদানি করুন',
    tr: 'Şablonu içe aktar',
    km: 'ពុម្ពដូចគ្នាដូចគ្នា',
    es: 'Importar plantilla',
    ar: 'استيراد القالب',
  },
  'printPage.importTemplateLink': {
    zh: '将标签模板链接地址粘贴至下方输入框中，即可完成模板导入',
    en: 'Paste the label template link address into the input box below, and the template can be imported',
    id: 'Salin tautan template ke kotak input di bawah ini, dan template dapat diimpor',
    kz: 'Шаблонтың сілтемесін көшіріңіз, шаблонды импорттауға рұқсаты жоқ, шаблонды жоюға жоспарлануда мурайсыз ба?',
    th: 'รูปแบบที่นำเข้ามีคุณสมบัติที่ปิดไม่มีสิทธิ์',
    ug: 'قېلىپ تەھرىرلەش سىلەتمەسىنى كۆچۈرۈش يوق, قېلىپ ئۆچۈرۈشنى جازالامسىز؟',
    vi: 'Sao chép liên kết mẫu vào hộp văn bản bên dưới để hoàn thành việc nhập mẫu',
    zh_tc: '將標籤模板連結地址粘貼至下方輸入框中，即可完成模板導入',
    ru: 'Скопируйте ссылку шаблона в поле ниже, чтобы импортировать шаблон',
    ko: '템플릿 링크 주소를 입력 상자에 붙여넣으면 템플릿을 가져올 수 있습니다',
    bur: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'টেমপ্লেট লিঙ্ক কপি করুন, টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tr: 'Şablon bağlantısını kopyala, şablonu silmek istediğinizden emin misiniz?',
    km: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    es: 'Pegue la dirección del enlace de la plantilla de etiqueta en el cuadro de entrada a continuación para completar la importación de la plantilla',
    ar: 'الصق عنوان رابط قالب التسمية في مربع الإدخال أدناه لإكمال استيراد القالب',
  },
  'printPage.importTemplateLinkPlaceholder': {
    zh: '请输入模板链接',
    en: 'Please enter the template link',
    id: 'Silakan masukkan tautan template',
    kz: 'Шаблонтың сілтемесін көшіріңіз',
    th: 'รูปแบบที่นำเข้ามีคุณสมบัติที่ปิดไม่มีสิทธิ์',
    ug: 'قېلىپ تەھرىرلەش سىلەتمەسىنى كۆچۈرۈش يوق, قېلىپ ئۆچۈرۈشنى جازالامسىز؟',
    vi: 'Sao chép liên kết mẫu vào hộp văn bản bên dưới để hoàn thành việc nhập mẫu',
    zh_tc: '請輸入模板連結',
    ru: 'Скопируйте ссылку шаблона в поле ниже, чтобы импортировать шаблон',
    ko: '템플릿 링크 주소를 입력 상자에 붙여넣으면 템플릿을 가져올 수 있습니다',
    bur: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'টেমপ্লেট লিঙ্ক কপি করুন, টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tr: 'Şablon bağlantısını kopyala, şablonu silmek istediğinizden emin misiniz?',
    km: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    es: 'Ingrese el enlace de la plantilla',
    ar: 'يرجى إدخال رابط القالب',
  },
  'printPage.noDeleteTemplate': {
    zh: '默认模板不能删除',
    en: 'The default template cannot be deleted',
    id: 'Template default tidak dapat dihapus',
    kz: 'Негізгі шаблон жоюға рұқсаты жоқ',
    th: 'ไม่สามารถลบเทมเพลตค่าเริ่มต้นได้',
    ug: 'ئاساسىي قېلىپ ئۆچۈرۈش يوق',
    vi: 'Mẫu mặc định không thể xóa',
    zh_tc: '默認模板不能刪除',
    ru: 'Шаблон по умолчанию не может быть удален',
    ko: '기본 템플릿을 삭제할 수 없습니다',
    bur: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tr: 'Varsayılan şablon silinemez',
    km: 'ពុម្ពដូចគ្នាមិនអាចលុបបាន',
    es: 'La plantilla predeterminada no se puede eliminar',
    ar: 'لا يمكن حذف القالب الافتراضي',
  },
  'printPage.tip1': {
    zh: '当前模板暂无可复制链接',
    en: 'The current template has no copy link',
    id: 'Template saat ini tidak memiliki tautan salin',
    kz: 'Қазіргі шаблонда сілтеме көшіру мүмкін емес',
    th: 'รูปแบบปัจจุบันไม่มีลิงค์คัดลอก',
    ug: 'ھازىر قېلىپ سىلەتمەسىنى كۆچۈرۈش يوق',
    vi: 'Mẫu hiện tại không có liên kết sao chép',
    zh_tc: '當前模板暫無可複製連結',
    ru: 'Ссылка для копирования шаблона отсутствует',
    ko: '현재 템플릿에 복사 링크가 없습니다',
    bur: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tr: 'Şablon bağlantısını kopyalamaya izin yok',
    km: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    es: 'No hay ningún enlace de copia para la plantilla actual',
    ar: 'لا يوجد رابط نسخ للقالب الحالي',
  },
  'printPage.tip2': {
    zh: '已复制当前模板数据链接。',
    en: 'The current template data link has been copied.',
    id: 'Tautan data template saat ini telah disalin.',
    kz: 'Қазіргі шаблонның деректер сілтемесі көшірілді.',
    th: 'ลิงค์ข้อมูลเทมเพลตปัจจุบันได้ถูกคัดลอก',
    ug: 'ھازىر قېلىپ ھاسىل چۈشۈرۈلگەن',
    vi: 'Liên kết dữ liệu mẫu hiện tại đã được sao chép',
    zh_tc: '已複製當前模板數據連結。',
    ru: 'Ссылка на данные шаблона скопирована',
    ko: '현재 템플릿 데이터 링크가 복사되었습니다',
    bur: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tr: 'Şablon bağlantısını kopyalamaya izin yok',
    km: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    es: 'El enlace de datos de la plantilla actual ha sido copiado.',
    ar: 'تم نسخ رابط بيانات القالب الحالي.',
  },
  'printPage.tip3': {
    zh: '复制模板链接失败，请稍后重试',
    en: 'Failed to copy template link, please try again later',
    id: 'Gagal menyalin tautan template, silakan coba lagi nanti',
    kz: 'Шаблонтың сілтемесін көшіру сәтсіз аяқталды, әзірлеуіміз келесі ретте қайталана алады',
    th: 'การคัดลอกลิงค์แบบล้มเหลว, กรุณาลองใหม่ในภายหลัง',
    ug: 'قېلىپ تەھرىرلەش سىلەتمەسىنى كۆچۈرۈش يوق, كۈتۈمگە سىناق كۆچۈرۈش',
    vi: 'Sao chép liên kết mẫu thất bại, vui lòng thử lại sau',
    zh_tc: '複製模板連結失敗，請稍後重試',
    ru: 'Ссылка на шаблон не может быть скопирована, пожалуйста, попробуйте позже',
    ko: '템플릿 링크 복사 실패, 나중에 다시 시도하십시오',
    bur: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    ben: 'টেমপ্লেট লিঙ্ক কপি করার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tr: 'Şablon bağlantısını kopyalamaya izin yok',
    km: 'ពុម្ព URL ដូចគ្នាមិនមានសិទ្ធិ, តើអ្នកប្រាកដថាចង់លុបវាឬ?',
    es: 'No se pudo copiar el enlace de la plantilla, inténtelo nuevamente más tarde',
    ar: 'فشل نسخ رابط القالب، يرجى المحاولة مرة أخرى لاحقًا',
  },
  'printPage.tip4': {
    zh: '无法识别导入模板链接，请重新下载后导入',
    en: 'Unable to recognize the imported template link. Please download it again and import.',
    id: 'Tautan template impor tidak dapat dikenali. Silakan unduh ulang lalu impor.',
    kz: 'Импортталған шаблон сілтемесі танылмады, қайта жүктеп алып қайта импорттаңыз.',
    th: 'ไม่สามารถระบุลิงก์เทมเพลตที่นำเข้าได้ โปรดดาวน์โหลดใหม่แล้วนำเข้าอีกครั้ง',
    ug: 'ئەكىرىلگەن قېلىپ ئۇلانمىسىنى تونۇيالمىدى، قايتا چۈشۈرۈپ ئاندىن ئەكىرىڭ.',
    vi: 'Không thể nhận diện liên kết mẫu đã nhập. Vui lòng tải lại rồi nhập lại.',
    zh_tc: '無法識別導入模板連結，請重新下載後導入',
    ru: 'Не удалось распознать ссылку импортируемого шаблона. Пожалуйста, скачайте снова и импортируйте.',
    ko: '가져온 템플릿 링크를 인식할 수 없습니다. 다시 다운로드한 후 가져와 주세요.',
    bur: 'တင်သွင်းထားသော ပုံစံလင့်ခ်ကို မသိရှိနိုင်ပါ။ ထပ်မံဒေါင်းလုဒ်လုပ်ပြီး ပြန်တင်သွင်းပါ။',
    ben: 'ইমপোর্ট করা টেমপ্লেট লিংক সনাক্ত করা যায়নি, অনুগ্রহ করে আবার ডাউনলোড করে ইমপোর্ট করুন।',
    tr: 'İçe aktarılan şablon bağlantısı tanınamadı. Lütfen yeniden indirip tekrar içe aktarın.',
    km: 'មិនអាចស្គាល់តំណពុម្ពដែលបាននាំចូលទេ សូមទាញយកឡើងវិញ ហើយនាំចូលម្តងទៀត។',
    es: 'No se puede reconocer el enlace de la plantilla de importación, descárguelo nuevamente e impórtelo.',
    ar: 'غير قادر على التعرف على رابط استيراد القالب، يرجى تنزيله مرة أخرى واستيراده.',
  },
  'fileManagerPage.folderClassifyByTextureColorThickSize': {
    zh: '根据颜色、材质、厚度、大板尺寸归为不同文件夹(贴标文件一起)',
    en: 'Classify into different folders by material, color, thickness, and large board size (including labeling files)',
    id: 'Klasifikasikan ke dalam folder yang berbeda berdasarkan material, warna, ketebalan, dan ukuran papan besar (termasuk file pelabelan)',
    kz: 'Материал, түс, қалыңдық және үлкен тақта өлшемі бойынша әртүрлі қалталарға жіктеу (белгілеу файлдарымен бірге)',
    th: 'จัดหมวดหมู่เป็นโฟลเดอร์ต่างๆ ตามวัสดุ สี ความหนา และขนาดบอร์ดใหญ่ (รวมไฟล์ติดป้าย)',
    ug: 'ماتېرىيال، رەڭ، قىلىنلىقى ۋە چوڭ تاختا ئۆلچىمى بويىچە تۈرلۈك مۇندەرىجىلەرگە تەقسىملەش (بەلگە قويۇش ھۆججەتلىرى بىلەن بىللە)',
    vi: 'Phân loại vào các thư mục khác nhau theo chất liệu, màu sắc, độ dày và kích thước tấm lớn (bao gồm cả tệp dán nhãn)',
    zh_tc: '根據材質，顏色，厚度，大板尺寸歸為不同文件夾(貼標文件一起)',
    ru: 'В зависимости от цвета, материала, толщины, размера большой доски, сгруппированы в разные папки (файлы с наклейкой вместе)',
    ko: '색상, 재료, 두께, 대시보드 크기에 따라 다른 폴더로 분류 (레이블 파일 포함)',
    bur: 'အရောင်၊ ပစ္စည်း၊ အထူ၊ ပေါ်ဒ်ကြီးအရွယ်အလိုက်မတူသောဖိုလ်ဒါများခွဲခြား(တံဆိပ်ဖိုင်ပါ)',
    ben: 'উপকরণ, রঙ, পুরুত্ব ও বড় বোর্ড সাইজ অনুযায়ী আলাদা ফোল্ডারে শ্রেণীবিন্যাস (লেবেলিং ফাইল সহ)',
    tr: 'Malzeme, renk, kalınlık ve büyük plaka boyutuna göre farklı klasörlere ayırın (etiket dosyaları dahil)',
    km: 'ចាត់ថ្នាក់ទៅថតផ្សេងៗតាមសម្ភារៈ ពណ៌ កម្រាស់ និងទំហំផ្ទាំងធំ (រួមទាំងឯកសារស្លាក)',
    es: 'Clasificados en diferentes carpetas según el color, material, grosor y tamaño del tablero (etiquetar archivos juntos)',
    ar: 'تم تصنيفها إلى مجلدات مختلفة وفقًا للون والمادة والسمك وحجم اللوحة (وضع العلامات على الملفات معًا)',
  },
  'fileManagerPage.notOpeFolderPermission': {
    zh: '未授权操作此目录',
    en: 'Unauthorized operation of directory',
    id: 'Operasi Direktori ini yang tidak sah',
    kz: 'Каталогпен рұқсат етілмеген әрекет',
    th: 'การดำเนินงานที่ไม่ได้รับอนุญาตของไดเรกทอรีนี้',
    ug: 'بۇ مۇندەرىجىگە ئىشلىتىش ھوقۇقى يوق',
    vi: 'Thao tác thư mục không được ủy quyền',
    zh_tc: '未授權操作此目錄',
    ru: 'Не разрешено использовать этот каталог',
    ko: '이 디렉토리에 대한 권한이 부여되지 않았습니다.',
    bur: 'ဤဒိုင်ရက်ကတိုးကိုလုပ်ဆောင်ခွင့်မရ',
    ben: 'এই ডিরেক্টরিতে অপারেশনের অনুমতি নেই',
    tr: 'Bu dizin için yetkisiz işlem',
    km: 'ប្រតិបត្តិការគ្មានការអនុញ្ញាតលើថតនេះ',
    es: 'Operación no autorizada de este directorio',
    ar: 'التشغيل غير المصرح به لهذا الدليل',
  },
  'fileManagerPage.notFindFolder': {
    zh: '无法在当前客户端检测到此目录',
    en: 'The current directory cannot be detected on the current client',
    id: 'Direktori ini tidak dapat dideteksi pada klien saat ini',
    kz: 'Ағымдағы каталог ағымдағы клиентте анықталмады',
    th: 'ไดเรกทอรีนี้ไม่สามารถตรวจพบได้ในไคลเอนต์ปัจจุบัน',
    ug: 'نۆۋەتتىكى كلېنتتا بۇ مۇندەرىجىنى تەكشۈرەلمىدى',
    vi: 'Không thể phát hiện thư mục hiện tại trên máy khách hiện tại',
    zh_tc: '無法在當前客戶端檢測到此目錄',
    ru: 'Невозможно обнаружить этот каталог в текущем клиенте',
    ko: '현재 클라이언트에서 이 디렉토리를 감지할 수 없습니다.',
    bur: 'လက်ရှိကလိုင်းယင့်တွင်ဤဒိုင်ရက်ကတိုးမတွေ့နိုင်',
    ben: 'বর্তমান ক্লায়েন্টে এই ডিরেক্টরি সনাক্ত করা যাচ্ছে না',
    tr: 'Bu dizin geçerli istemcide algılanamıyor',
    km: 'មិនអាចរកឃើញថតនេះនៅលើកម្មវិធីអតិថិជនបច្ចុប្បន្ន',
    es: 'No se puede detectar este directorio en el cliente actual',
    ar: 'غير قادر على اكتشاف هذا الدليل في العميل الحالي',
  },
  'fileManagerPage.productLineUniversal': {
    zh: '所有生产线通用',
    en: 'Universal for all production lines',
    id: 'Semua jalur produksi bersifat universal',
    kz: 'Барлық өндіріс желілеріне бірдей қолданылады',
    th: 'สายการผลิตทั้งหมดเป็นสากล',
    ug: 'بارلىق ئىشلەپچىقىرىش لىنىيىلىرىگە قوللىنىدۇ',
    vi: 'Phổ biến cho tất cả các dây chuyền sản xuất',
    zh_tc: '所有生產線通用',
    ru: 'Все производственные линии',
    ko: '모든 생산 라인 공통',
    bur: 'ထုတ်လုပ်မှုလိုင်းအားလုံးအတွက်ယေဘုယျ',
    ben: 'সব প্রোডাকশন লাইনের জন্য ইউনিভার্সাল',
    tr: 'Tüm üretim hatları için geçerli',
    km: 'សម្រាប់បណ្តាខ្សែផលិតកម្មទាំងអស់',
    es: 'Común a todas las líneas de producción',
    ar: 'مشترك في جميع خطوط الإنتاج',
  },
  'fileManagerPage.effectCondition': {
    zh: '此设置更改后需重新排版才可生效',
    en: 'This setting change will take effect only after re-layout',
    id: 'Pengaturan ini perlu diperbaiki sebelum dapat berlaku setelah mengubahnya',
    kz: 'Бұл параметр өзгергеннен кейін қайта орналасу ғана күшіне енеді',
    th: 'การตั้งค่านี้จะต้องมีการพิมพ์ซ้ำอีกครั้งก่อนที่จะมีผลหลังจากเปลี่ยน',
    ug: 'بۇ تەڭشەك ئۆزگەرتىلگەندىن كېيىن قايتا تەرتىپلەش زۆرۈر',
    vi: 'Thay đổi cài đặt này sẽ chỉ có hiệu lực sau khi sắp xếp lại',
    zh_tc: '此設置更改後需重新排版才可生效',
    ru: 'Для вступления в силу изменения этой настройки требуется переформатирование.',
    ko: '이 설정은 변경된 후 다시 조판해야 적용됩니다.',
    bur: 'ဤဆက်တင်ပြောင်းပြီးနောက်ပြန်စီရန်လိုအပ်',
    ben: 'এই সেটিং পরিবর্তন পুনরায় লেআউটের পরেই কার্যকর হবে',
    tr: 'Bu ayar yalnızca yeniden yerleşimden sonra geçerli olur',
    km: 'ការផ្លាស់ប្តូរការកំណត់នេះមានប្រសិទ្ធភាពតែបន្ទាប់ពីរៀបចំឡើងវិញប៉ុណ្ណោះ',
    es: 'Esta configuración debe volver a escribirse antes de que pueda surtir efecto',
    ar: 'يجب إعادة كتابة هذا الإعداد قبل أن يصبح ساري المفعول',
  },
  'fileManagerPage.addPath': {
    zh: '添加路径',
    en: 'Add path',
    id: 'Tambahkan jalur',
    kz: 'Жолды қосу',
    th: 'เพิ่มเส้นทาง',
    ug: 'يول قوشۇش',
    vi: 'Thêm đường dẫn',
    zh_tc: '添加路徑',
    ru: 'Добавить путь',
    ko: '경로 추가',
    bur: 'လမ်းကြောင်းထည့်',
    ben: 'পাথ যোগ করুন',
    tr: 'Yol ekle',
    km: 'បន្ថែមផ្លូវ',
    es: 'Agregar ruta',
    ar: 'إضافة مسار',
  },
  'fileManagerPage.downloadPositionChangeByType': {
    zh: '生成文件下载位置已更换为{type}',
    en: 'The download location for the generated files has been changed to {type}',
    id: 'Lokasi unduhan file yang dihasilkan telah diubah menjadi {type}',
    kz: 'Жасалған файлдардың жүктеу орны {type} болып өзгертілді',
    th: 'ตำแหน่งดาวน์โหลดของไฟล์ที่สร้างขึ้นถูกเปลี่ยนเป็น {type}',
    ug: 'ھۆججەت چۈشۈرۈش ئورنى {type} غا ئۆزگەرتىلدى',
    vi: 'Vị trí tải xuống cho các tệp đã tạo đã được thay đổi thành {type}',
    zh_tc: '生成文件下載位置已更換為{type}',
    ru: 'Расположение загрузки сгенерированных файлов изменено на {type}',
    ko: '생성된 파일의 다운로드 위치가 {type}로 변경되었습니다',
    bur: 'ဖန်တီးဖိုင်ဒေါင်းလုတ်နေရာကို{type}သို့ပြောင်းပြီး',
    ben: 'জেনারেট ফাইলের ডাউনলোড অবস্থান {type} এ পরিবর্তন করা হয়েছে',
    tr: 'Oluşturulan dosyaların indirme konumu {type} olarak değiştirildi',
    km: 'ទីតាំងទាញយកឯកសារដែលបានបង្កើតត្រូវបានប្តូរទៅ {type}',
    es: 'La ubicación de descarga del archivo generado se ha cambiado a {type}',
    ar: 'تم تغيير موقع تنزيل الملف الذي تم إنشاؤه إلى {type}',
  },
  'fileManagerPage.isDeleteFolder': {
    zh: '是否确认删除使用过的文件存储位置?',
    en: 'Are you sure you want to delete the used file storage location?',
    id: 'Apakah Anda pasti akan menghapus lokasi penyimpanan file yang digunakan?',
    kz: 'Пайдаланылған файл сақтау орнын жоюға сенімдісіз бе?',
    th: 'คุณแน่ใจว่าจะลบตำแหน่งที่เก็บไฟล์ที่ใช้แล้วหรือไม่?',
    ug: 'ئىشلىتىلگەن ھۆججەت ساقلاش ئورنىنى ئۆچۈرۈشنى جازالامسىز?',
    vi: 'Bạn có chắc chắn muốn xóa vị trí lưu trữ tệp đã sử dụng không?',
    zh_tc: '是否確認刪除使用過的文件存儲位置?',
    ru: 'Подтвердить удаление использованного места хранения файлов?',
    ko: '사용한 파일의 저장 위치를 삭제하시겠습니까?',
    bur: 'အသုံးပြုပြီးဖိုင်သိမ်းနေရာကိုဖျက်မည်ကိုအတည်ပြုလား?',
    ben: 'ব্যবহৃত ফাইল স্টোরেজ অবস্থান মুছতে নিশ্চিত করবেন?',
    tr: 'Kullanılan dosya depolama konumunu silmek istediğinizden emin misiniz?',
    km: 'តើអ្នកប្រាកដថាចង់លុបទីតាំងរក្សាទុកឯកសារដែលបានប្រើ?',
    es: '¿Está seguro de eliminar el ¿Ubicación de almacenamiento de archivos utilizada?',
    ar: 'هل أنت متأكد من الحذف موقع تخزين الملفات المستخدمة؟',
  },
  'fileManagerPage.netWorkIsNotSafe': {
    zh: '您的网络环境似乎不安全，我们无法启用此功能，您可以反馈给我们',
    en: 'Your network environment seems to be unsafe, we cannot enable this feature, you can provide feedback to us',
    id: 'Lingkungan jaringan Anda tampaknya tidak aman dan kami tidak dapat mengaktifkan fitur ini, Anda dapat memberi umpan balik kepada kami',
    kz: 'Сіздің желі ортаңыз қауіпсіз емес сияқты, біз бұл мүмкіндікті қосып алмаймыз, сіз бізге кері байланыс жасай аласыз',
    th: 'สภาพแวดล้อมเครือข่ายของคุณดูเหมือนไม่ปลอดภัยและเราไม่สามารถเปิดใช้งานคุณสมบัตินี้ได้คุณสามารถตอบกลับเราได้',
    ug: 'تور مۇھىتىڭىز بىخەتەر ئەمەسكەن، بۇ ئىقتىدارنى قوزغىتالمايمىز، بىزگە ئۇقتۇرۇپ بېرەلەيسىز',
    vi: 'Môi trường mạng của bạn dường như không an toàn, chúng tôi không thể kích hoạt tính năng này, bạn có thể phản hồi với chúng tôi',
    zh_tc: '您的網絡環境似乎不安全，我們無法啟用此功能，您可以反饋給我們',
    ru: 'Ваша сетевая среда кажется небезопасной, мы не можем включить эту функцию, и вы можете вернуться к нам',
    ko: '네트워크 환경이 안전하지 않은 것 같습니다. 이 기능을 사용할 수 없습니다. 피드백해 주십시오.',
    bur: 'သင့်ကွန်ယက်ပတ်ဝန်းကျင်မလုံခြုံဟုထင်ရ၊ ဤလုပ်ဆောင်ချက်ဖွင့်၍မရ၊ ကျွန်ုပ်တို့ထံပြန်ကြားနိုင်',
    ben: 'আপনার নেটওয়ার্ক পরিবেশ নিরাপদ মনে হচ্ছে না, এই ফিচার চালু করা যাচ্ছে না, আমাদের ফিডব্যাক দিতে পারেন',
    tr: 'Ağ ortamınız güvenli görünmüyor; bu özelliği etkinleştiremiyoruz, bize geri bildirim gönderebilirsiniz',
    km: 'បរិយាកាសបណ្តាញរបស់អ្នកមិនមានសុវត្ថិភាពទេ យើងមិនអាចបើកមុខងារនេះបានទេ អ្នកអាចផ្តល់មតិយើង',
    es: 'Su entorno de red parece no ser seguro y no podemos habilitar esta función. Puede enviarnos su opinión',
    ar: 'يبدو أن بيئة الشبكة الخاصة بك غير آمنة ولا يمكننا تمكين هذه الوظيفة. يمكنك تزويدنا بملاحظاتك',
  },
  'fileManagerPage.NotSupportBrowse': {
    zh: '您的浏览器暂不支持此功能，请下载最新版<a href="https://www.microsoft.com/zh-cn/edge/download" target="_blank" >Edge</a>浏览器使用',
    en: 'Your browser does not currently support this feature. Please download the latest version of the <a href="https://www.microsoft.com/en-us/edge/download" target="_blank">Edge</a> browser to use it.',
    id: 'Browser Anda belum mendukung fitur ini. Silakan unduh versi terbaru <a href = "https://www.microsoft.com/zh-cn/edge/download" target = "_ blank"> edge </a> Untuk menggunakan browser',
    kz: 'Сіздің браузеріңіз бұл функцияны қолдамайды. Пайдалану үшін <a href="https://www.microsoft.com/kk-kz/edge/download" target="_blank">Edge</a> браузерінің ең соңғы нұсқасын жүктеп алыңыз.',
    th: 'เบราว์เซอร์ของคุณยังไม่รองรับคุณสมบัตินี้ โปรดดาวน์โหลดเวอร์ชันล่าสุดของ <a href = "https://www.microsoft.com/zh-cn/edge/download" target = "_ blank"> edge </a> เพื่อใช้เบราว์เซอร์',
    ug: 'تور كۆرگۈچىڭىز بۇ ئىقتىدارنى قوللىمايدۇ، ئەڭ يېڭى <a href="https://www.microsoft.com/zh-cn/edge/download" target="_blank" >Edge</a> تور كۆرگۈچىنى چۈشۈرۈپ ئىشلىتىڭ',
    vi: 'Trình duyệt của bạn hiện không hỗ trợ tính năng này. Vui lòng tải xuống phiên bản mới nhất của trình duyệt <a href="https://www.microsoft.com/vi-vn/edge/download" target="_blank">Edge</a> để sử dụng.',
    zh_tc:
      '您的瀏覽器暫不支持此功能，請下載最新版<a href="https://www.microsoft.com/zh-cn/edge/download" target="_blank" >Edge</a>瀏覽器使用',
    ru: 'Ваш браузер пока не поддерживает эту функцию, загрузите последнюю версию < a href = > https://www.microsoft.com/zh-cn/edge/download "target =" blank "> Edge < / a > Использование браузера',
    ko: '브라우저에서 이 기능을 지원하지 않습니다. 최신 버전인 <a href="https://www.microsoft.com/zh-cn/edge/download"target="_blank">Edge</a> 브라우저 사용',
    bur: 'သင့်ဘရောက်ဆားသည်ဤလုပ်ဆောင်ချက်ကိုမပံ့ပိုးသေး၊ နောက်ဆုံး Edge ဘရောက်ဆားဒေါင်းပါ',
    ben: 'আপনার ব্রাউজার এই ফিচার সাপোর্ট করে না, সর্বশেষ Edge ব্রাউজার ডাউনলোড করে ব্যবহার করুন',
    tr: 'Tarayıcınız bu özelliği desteklemiyor. Kullanmak için <a href="https://www.microsoft.com/en-us/edge/download" target="_blank">Edge</a> tarayıcısının en son sürümünü indirin.',
    km: 'កម្មវិធីរុករករបស់អ្នកមិនគាំទ្រមុខងារនេះទេ។ សូមទាញយកកំណែចុងក្រោយនៃកម្មវិធីរុករក <a href="https://www.microsoft.com/en-us/edge/download" target="_blank">Edge</a> ដើម្បីប្រើ។',
    es: 'Su navegador aún no admite esta función. Descargue la última versión <a href="https://www.microsoft.com/zh-cn/edge/download" target="_blank" >Edge</a> para usar el navegador',
    ar: 'متصفحك لا يدعم هذه الوظيفة حتى الآن. يرجى تنزيل أحدث إصدار <a href="https://www.microsoft.com/zh-cn/edge/download" target="_blank" > Edge </a> لاستخدام المتصفح',
  },
  'fileManagerPage.notSupportDisk': {
    zh: '不可选用系统级别目录,如【桌面】【C盘】',
    en: 'System-level directories such as [Desktop] and [C Drive] cannot be selected',
    id: 'Direktori tingkat sistem tidak dapat dipilih, seperti [desktop] [C drive]',
    kz: '[Жұмыс үстелі] және [C дискісі] сияқты жүйелік деңгейдегі каталогтарды таңдай алмайсыз',
    th: 'ไม่สามารถเลือกไดเรกทอรีระดับระบบเช่น [เดสก์ท็อป] [C ไดรฟ์]',
    ug: 'سىستېما دەرىجىلىك مۇندەرىجىلەرنى تاللىيالمايسىز، مەسىلەن 【ئۈستەل】【C دىسك】',
    vi: 'Không thể chọn các thư mục cấp hệ thống như [Desktop] và [Ổ đĩa C]',
    zh_tc: '不可選用系統級別目錄,如【桌面】【C盤】',
    ru: 'Не может быть выбран каталог системного уровня, например [рабочий стол] [CPD]',
    ko: '[데스크톱] [C디스크] 와 같은 시스템 수준 디렉토리는 선택할 수 없습니다.',
    bur: 'စနစ်အဆင့်ဒိုင်ရက်ကတိုးရွေးမရ(ဥပမာ ဒက်စ်တော့၊ C ဒရိုက်)',
    ben: 'সিস্টেম-লেভেল ডিরেক্টরি যেমন [ডেস্কটপ] [C ড্রাইভ] নির্বাচন করা যাবে না',
    tr: '[Masaüstü] ve [C sürücüsü] gibi sistem düzeyi dizinler seçilemez',
    km: 'មិនអាចជ្រើសថតកម្រិតប្រព័ន្ធដូចជា [ផ្ទៃតុ] និង [ថាស C] បានទេ',
    es: 'Los directorios a nivel del sistema no son opcionales, como 【桌面】【C盘】',
    ar: 'الدلائل على مستوى النظام ليست اختيارية، مثل 【桌面】 【C盘】',
  },
  'fileManagerPage.useFolderDownload': {
    zh: '生产文件以解压后的形式下载',
    en: 'Production files are downloaded in an unzipped format',
    id: 'File produksi diunduh dalam bentuk dekompresi',
    kz: 'Өндірістік файлдар қысылмаған пішімде жүктеледі',
    th: 'ไฟล์การผลิตจะถูกดาวน์โหลดในรูปแบบของการบีบอัด',
    ug: 'ئىشلەپچىقىرىش ھۆججىتىنى پىششىقلانمىغان ھالدا چۈشۈرۈش',
    vi: 'Tệp sản xuất được tải xuống dưới dạng giải nén',
    zh_tc: '生產文件以解壓後的形式下載',
    ru: 'Загрузка производственных документов в распакованном виде',
    ko: '프로덕션 파일은 압축 해제 후 다운로드됨',
    bur: 'ထုတ်လုပ်ဖိုင်များကိုဖြည့်ပြီးပုံစံဖြင့်ဒေါင်းလုတ်',
    ben: 'প্রোডাকশন ফাইল আনজিপ ফরম্যাটে ডাউনলোড হয়',
    tr: 'Üretim dosyaları sıkıştırılmamış biçimde indirilir',
    km: 'ឯកសារផលិតកម្មត្រូវបានទាញយកដោយគ្មានការបង្ហាប់',
    es: 'Los archivos de producción se descargan en forma descomprimida',
    ar: 'يتم تنزيل ملفات الإنتاج في شكل غير مضغوط',
  },
  'fileManagerPage.downloadPosition': {
    zh: '下载文件位置',
    en: 'Download file location',
    id: 'Unduh lokasi file',
    kz: 'Файл жүктеу орны',
    th: 'ดาวน์โหลดตำแหน่งไฟล์',
    ug: 'ھۆججەت چۈشۈرۈش ئورنى',
    vi: 'Vị trí tải xuống tệp',
    zh_tc: '下載文件位置',
    ru: 'Загрузить расположение файла',
    ko: '다운로드 파일 위치',
    bur: 'ဖိုင်ဒေါင်းလုတ်နေရာ',
    ben: 'ডাউনলোড ফাইল অবস্থান',
    tr: 'Dosya indirme konumu',
    km: 'ទីតាំងទាញយកឯកសារ',
    es: 'Descargar ubicación del archivo',
    ar: 'تنزيل موقع الملف',
  },
  'fileManagerPage.changeUseFolder': {
    zh: '更改',
    en: 'Change',
    id: 'Mengubah',
    kz: 'Өзгерту',
    th: 'เปลี่ยน',
    ug: 'ئۆزگەرتىش',
    vi: 'Thay đổi',
    zh_tc: '更改',
    ru: 'изменить',
    ko: '변경',
    bur: 'ပြောင်းပါ',
    ben: 'পরিবর্তন করুন',
    tr: 'Değiştir',
    km: 'ប្តូរ',
    es: 'Cambiar',
    ar: 'تغيير',
  },
  'fileManagerPage.folderNameSetting': {
    zh: '文件夹设置',
    en: 'Folder Settings',
    id: 'Pengaturan Folder',
    kz: 'Қапшық параметрлері',
    th: 'การตั้งค่าโฟลเดอร์',
    ug: 'مۇندەرىجە تەڭشىكى',
    vi: 'Thiết lập thư mục',
    zh_tc: '文件夾設置',
    ru: 'Параметры папок',
    ko: '폴더 설정',
    bur: 'ဖိုလ်ဒါဆက်တင်',
    ben: 'ফোল্ডার সেটিংস',
    tr: 'Klasör ayarları',
    km: 'ការកំណត់ថត',
    es: 'Configuración de carpetas',
    ar: 'إعدادات المجلدات',
  },
  'fileManagerPage.mainFolder': {
    zh: '一级文件夹',
    en: 'Primary Folder',
    id: 'Folder Level 1',
    kz: 'Бірінші деңгейдегі қапшық',
    th: 'โฟลเดอร์ระดับ 1',
    ug: 'بىرىنچى دەرىجىلىك مۇندەرىجە',
    vi: 'Thư mục cấp 1',
    zh_tc: '一級文件夾',
    ru: 'Папка первого уровня',
    ko: '레벨 1 폴더',
    bur: 'ပထမအဆင့်ဖိုလ်ဒါ',
    ben: 'প্রাইমারি ফোল্ডার',
    tr: 'Birincil klasör',
    km: 'ថតដំបូង',
    es: 'Carpeta de primer nivel',
    ar: 'مجلد المستوى الأول',
  },
  'fileManagerPage.exportNameSetting': {
    zh: '导出加工文件按订单号命名',
    en: 'Export Processed Files with Order Number Naming',
    id: 'Ekspor memproses file untuk menyebutkan nama dengan nomor pesanan',
    kz: 'Экспортталған өңдеу файлдарыні тапсырыс нөміріне сәйкес атау',
    th: 'ส่งออกไฟล์ประมวลผลเพื่อตั้งชื่อตามหมายเลขคำสั่งซื้อ',
    ug: 'ئىشلەش ھۆججىتىنى زاكاز نومۇرى بويىچە ئاتاش',
    vi: 'Tên xuất tệp chế biến theo số đơn hàng',
    zh_tc: '導出加工文件按訂單號命名',
    ru: 'Экспорт файлов обработки по номеру заказа',
    ko: '주문 번호에 따라 가공 파일 이름 내보내기',
    bur: 'ထုတ်ကုန်ဖိုင်များကိုမှာယူမှုနံပါတ်ဖြင့်အမည်ပေး',
    ben: 'অর্ডার নম্বর দিয়ে এক্সপোর্ট প্রসেসড ফাইল নেমিং',
    tr: 'İşlenmiş dosyaları sipariş numarasına göre dışa aktar',
    km: 'នាំចេញឯកសារដែលបានដំណើរការដោយដាក់ឈ្មោះតាមលេខការកម្មង់',
    es: 'El archivo de procesamiento exportado se nombra según el número de pedido',
    ar: 'تتم تسمية ملف المعالجة المصدر وفقًا لرقم الطلب',
  },
  'fileManagerPage.fileMax': {
    zh: '文件名最多为',
    en: 'Maximum File Name Length',
    id: 'Nama file maksimum adalah',
    kz: 'Файл атауының ең көп',
    th: 'ชื่อไฟล์สูงสุดคือ',
    ug: 'ھۆججەت ئىسمى ئەڭ كۆپ',
    vi: 'Tên tệp có tối đa',
    zh_tc: '文件名最多為',
    ru: 'Наименование файла максимум',
    ko: '파일 이름은 최대',
    bur: 'ဖိုင်အမည်အများဆုံး',
    ben: 'ফাইলের নাম সর্বোচ্চ',
    tr: 'Dosya adı en fazla',
    km: 'ឈ្មោះឯកសារអតិបរមា',
    es: 'El nombre de archivo máximo es',
    ar: 'الحد الأقصى لاسم الملف هو',
  },
  'fileManagerPage.char': {
    zh: '字符',
    en: 'Characters',
    id: 'karakter',
    kz: 'Символ',
    th: 'อักขระ',
    ug: 'ھەرپ',
    vi: 'kí tự',
    zh_tc: '字符',
    ru: 'символ',
    ko: '문자',
    bur: 'စာလုံး',
    ben: 'অক্ষর',
    tr: 'Karakter',
    km: 'តួអក្សរ',
    es: 'caracteres',
    ar: 'أحرف',
  },
  'fileManagerPage.overTip': {
    zh: '超过部分不显示（标签图压缩包和json文件将跟随一级文件夹命名） ',
    en: 'Excess part will not be displayed (Label graphics zip and json files will follow the primary folder naming)',
    id: 'Bagian berlebih tidak akan ditampilkan (paket kompresi gambar tag dan file JSON akan mengikuti nama folder tingkat pertama)',
    kz: 'Қосымша бөліктер көрсетілмейді (таг суреттерінің қысқартмасы мен json файлдары бірінші деңгейдегі қапшық атауына сәйкес атайды)',
    th: 'ส่วนที่มากเกินไปจะไม่ปรากฏขึ้น (แพ็คเกจการบีบอัดภาพแท็กและไฟล์ JSON จะเป็นไปตามชื่อโฟลเดอร์ระดับแรก)',
    ug: 'چەكتىن ئاشقان قىسمى كۆرسەتمەيدۇ (بەلگە رەسىم قىسقا ھۆججىتى ۋە json ھۆججىتى بىرىنچى دەرىجىلىك مۇندەرىجە ئاتى بويىچە ئاتىلىدۇ)',
    vi: 'Nội dung vượt quá sẽ không hiển thị (bộ nén hình ảnh nhãn và tệp json sẽ theo tên thư mục cấp 1)',
    zh_tc: '超過部分不顯示（標籤圖壓縮包和json文件將跟隨一級文件夾命名） ',
    ru: 'Больше, чем часть не отображается (пакет сжатия тегов и файл json будут названы в папке первого уровня)',
    ko: '섹션 이상이 표시되지 않음 (맵 압축 팩과 json 파일은 레벨 1 폴더 이름을 따름)',
    bur: 'ကျော်လွန်သောအပမပြသ(တံဆိပ်ပုံzipနှင့်jsonဖိုင်များသည်ပထမအဆင့်ဖိုလ်ဒါအမည်လိုက်မည်)',
    ben: 'অতিরিক্ত অংশ দেখানো হবে না (লেবেল গ্রাফিক্স জিপ ও json ফাইল প্রাইমারি ফোল্ডার নেমিং অনুসরণ করবে)',
    tr: 'Fazla kısım gösterilmez (etiket zip ve json dosyaları birincil klasör adını izler)',
    km: 'ផ្នែកលើសមិនបង្ហាញ (ឯកសារ zip រូបស្លាក និង json នឹងធ្វើតាមឈ្មោះថតដំបូង)',
    es: 'La parte sobrante no se mostrará (el paquete comprimido del mapa de etiquetas y el archivo json recibirán el nombre de la carpeta de primer nivel)',
    ar: 'لن يتم عرض الجزء الزائد (سيتم تسمية الحزمة المضغوطة لخريطة التسمية وملف json على اسم مجلد المستوى الأول)',
  },
  'fileManagerPage.example': {
    zh: '样例',
    en: 'Example',
    id: 'Mencicipi',
    kz: 'Үлгі',
    th: 'ตัวอย่าง',
    ug: 'مىسال',
    vi: 'Ví dụ',
    zh_tc: '樣例',
    ru: 'Пример',
    ko: '예제',
    bur: 'နမူနာ',
    ben: 'উদাহরণ',
    tr: 'Örnek',
    km: 'ឧទាហរណ៍',
    es: 'Ejemplo',
    ar: 'مثال',
  },
  'fileManagerPage.engravingFolder': {
    zh: '雕刻机文件夹',
    en: 'Engraving Machine Folder',
    id: 'Folder Mesin Ukiran',
    kz: 'Оюл машинасы қапшық',
    th: 'โฟลเดอร์เครื่องแกะสลัก',
    ug: 'ئويما ماشىنىسى مۇندەرىجىسى',
    vi: 'Thư mục máy khắc',
    zh_tc: '雕刻機文件夾',
    ru: 'Папка Скульптор',
    ko: '조각기 폴더',
    bur: 'ထွင်းထားစက်ဖိုလ်ဒါ',
    ben: 'এনগ্রেভিং মেশিন ফোল্ডার',
    tr: 'Oyma makinesi klasörü',
    km: 'ថតម៉ាស៊ីនចុកចាក់',
    es: 'Carpeta de la máquina de grabado',
    ar: 'مجلد آلة النقش',
  },
  'fileManagerPage.electronicSawFolder': {
    zh: '电子锯文件夹',
    en: 'Electronic Saw Folder',
    id: 'Folder gergaji elektronik',
    kz: 'Электронды пил машинасы қапшық',
    th: 'โฟลเดอร์เลื่อยอิเล็กทรอนิกส์',
    ug: 'ئېلېكترون ماكا مۇندەرىجىسى',
    vi: 'Thư mục máy cưa điện tử',
    zh_tc: '電子鋸文件夾',
    ru: 'Папка электронной пилы',
    ko: '전자 톱 폴더',
    bur: 'အီလက်ထရွန်းနစ်လွှဖိုလ်ဒါ',
    ben: 'ইলেকট্রনিক স saw ফোল্ডার',
    tr: 'Elektronik testere klasörü',
    km: 'ថតម៉ាស៊ីនរណាអេឡិចត្រូនិក',
    es: 'Carpeta de la sierra electrónica',
    ar: 'مجلد المنشار الإلكتروني',
  },
  'fileManagerPage.labellingFolder': {
    zh: '贴标机文件夹',
    en: 'Labeling Machine Folder',
    id: 'Folder Mesin Pelabelan',
    kz: 'Етикеткалау машинасы қапшық',
    th: 'โฟลเดอร์เครื่องฉลาก',
    ug: 'بەلگە قويغۇچ ماشىنا مۇندەرىجىسى',
    vi: 'Thư mục máy ghi nhãn',
    zh_tc: '貼標機文件夾',
    ru: 'Папка',
    ko: '어댑터 폴더',
    bur: 'တံဆိပ်ကပ်စက်ဖိုလ်ဒါ',
    ben: 'লেবেলিং মেশিন ফোল্ডার',
    tr: 'Etiketleme makinesi klasörü',
    km: 'ថតម៉ាស៊ីនដាក់ស្លាក',
    es: 'Carpeta de la máquina de etiquetado',
    ar: 'مجلد آلة وضع العلامات',
  },
  'fileManagerPage.sideHoleDrillFolder': {
    zh: '侧孔机文件夹',
    en: 'Side Hole Drilling Machine Folder',
    id: 'Folder mesin lubang samping',
    kz: 'Жақ таңбалау машинасы қапшық',
    th: 'โฟลเดอร์เครื่อง Hole Side',
    ug: 'يان تېشىك ماتور مۇندەرىجىسى',
    vi: 'Thư mục máy khoan lỗ bên',
    zh_tc: '側孔機文件夾',
    ru: 'Папка бокового отверстия',
    ko: '측면 구멍 머신 폴더',
    bur: 'ဘေးတွင်းထွင်းစက်ဖိုလ်ဒါ',
    ben: 'সাইড হোল ড্রিলিং মেশিন ফোল্ডার',
    tr: 'Yan delik makinesi klasörü',
    km: 'ថតម៉ាស៊ីនរណ្តៅចំហៀង',
    es: 'Carpeta de la máquina de orificio lateral',
    ar: 'مجلد آلة الفتحة الجانبية',
  },
  'fileManagerPage.fiveDrillFolder': {
    zh: '五面钻文件夹',
    en: 'Five-Sided Drilling Machine Folder',
    id: 'Folder bor lima sisi',
    kz: 'Бес таңбалау машинасы қапшық',
    th: 'โฟลเดอร์สว่านห้าด้าน',
    ug: 'بەش تەرەپلىك ماتور مۇندەرىجىسى',
    vi: 'Thư mục máy khoan năm mặt',
    zh_tc: '五面鑽文件夾',
    ru: 'Папка с пятигранным сверлом',
    ko: '5면 드릴 폴더',
    bur: 'ငါးမျက်နှာတွင်းထွင်းဖိုလ်ဒါ',
    ben: 'পাঁচ-পাশ ড্রিলিং মেশিন ফোল্ডার',
    tr: 'Beş yüz delik makinesi klasörü',
    km: 'ថតម៉ាស៊ីនរណ្តៅប្រាំមុខ',
    es: 'Carpeta de diamantes de cinco caras',
    ar: 'مجلد ماسي خماسي الجوانب',
  },
  'fileManagerPage.sixDrillFolder': {
    zh: '六面钻文件夹',
    en: 'Six-Sided Drilling Machine Folder',
    id: 'Folder bor enam sisi',
    kz: 'Алты таңбалау машинасы қапшық',
    th: 'โฟลเดอร์สว่านหกด้าน',
    ug: 'ئالتە تەرەپلىك ماتور مۇندەرىجىسى',
    vi: 'Thư mục máy khoan sáu mặt',
    zh_tc: '六面鑽文件夾',
    ru: 'Папка с шестигранным сверлом',
    ko: '육면 드릴 폴더',
    bur: 'ခြောက်မျက်နှာတွင်းထွင်းဖိုလ်ဒါ',
    ben: 'ছয়-পাশ ড্রিলিং মেশিন ফোল্ডার',
    tr: 'Altı yüz delik makinesi klasörü',
    km: 'ថតម៉ាស៊ីនរណ្តៅប្រាំមួយមុខ',
    es: 'Carpeta de diamantes de seis caras',
    ar: 'مجلد ماسي سداسي الجوانب',
  },
  'fileManagerPage.PTPFolder': {
    zh: 'PTP文件夹',
    en: 'PTP Folder',
    id: 'Folder PTP',
    kz: 'PTP қапшық',
    th: 'โฟลเดอร์ PTP',
    ug: 'PTP مۇندەرىجىسى',
    vi: 'Thư mục PTP',
    zh_tc: 'PTP文件夾',
    ru: 'Папка PTP',
    ko: 'PTP 폴더',
    bur: 'PTP ဖိုလ်ဒါ',
    ben: 'PTP ফোল্ডার',
    tr: 'PTP klasörü',
    km: 'ថត PTP',
    es: 'PTP carpeta',
    ar: 'PTP مجلد',
  },
  'fileManagerPage.labellingTagFolder': {
    zh: '贴标图片文件夹',
    en: 'Labeling Image Folder',
    id: 'Folder gambar label',
    kz: 'Етикетка суреттері қапшық',
    th: 'โฟลเดอร์รูปภาพฉลาก',
    ug: 'بەلگە رەسىم مۇندەرىجىسى',
    vi: 'Thư mục hình ảnh ghi nhãn',
    zh_tc: '貼標圖片文件夾',
    ru: 'Каталог изображений',
    ko: '맵 이미지 폴더',
    bur: 'တံဆိပ်ပုံဖိုလ်ဒါ',
    ben: 'লেবেলিং ইমেজ ফোল্ডার',
    tr: 'Etiket görüntü klasörü',
    km: 'ថតរូបភាពស្លាក',
    es: 'Carpeta de imágenes de etiquetado',
    ar: 'مجلد صور الملصقات',
  },
  'fileManagerPage.surplusFolder': {
    zh: '余料文件大板设置',
    en: 'Surplus file large board Settings',
    id: 'Pengaturan file lembar besar sisa',
    kz: 'Қалдық файлдардың үлкен тақтасы',
    th: 'ตั้งค่าขนาดแผ่นกระดานที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال ھۆججىتى چوڭ تاختا تەڭشىكى',
    vi: 'Dư liệu tập tin tấm cài đặt',
    zh_tc: '餘料文件大板設置',
    ru: 'Параметры больших панелей для остаточных файлов',
    ko: '남은 재료 파일 대시보드 설정',
    bur: 'ပိုလျှံဖိုင်ပေါ်ဒ်ကြီးဆက်တင်',
    ben: 'উদ্বৃত্ত ফাইল বড় বোর্ড সেটিংস',
    tr: 'Artık malzeme dosyası büyük plaka ayarı',
    km: 'ការកំណត់ផ្ទាំងធំសម្រាប់ឯកសារសល់',
    es: 'Configuración del tablero de archivo de material restante',
    ar: 'إعداد لوحة ملفات المواد المتبقية',
  },
  'fileManagerPage.surplusBigPlankSetting': {
    zh: '余料大板下料文件/标签图片/贴标文件单独放置',
    en: 'Spare material large board cutting files/label pictures/labeling files are placed separately',
    id: 'File pemotongan lembar besar sisa/gambar label/file label ditempatkan secara terpisah',
    kz: 'Қалдық үлкен тақтай кесу файлы, таңба суреттері және жапсырма файлдары жеке орналастырылған',
    th: 'ตั้งค่าขนาดแผ่นกระดานที่เหลืออยู่',
    ug: 'قالدۇق چوڭ تاختا كېسىش ھۆججىتى/بېلگە رەسىمى/بېلگە چاپلاش ھۆججىتى ئايرىم ئورۇنلاشتۇرۇلىدۇ',
    vi: 'Dư liệu tấm tập tin/nhãn hình ảnh/nhãn tập tin được đặt riêng biệt',
    zh_tc: '餘料大板下料文件/標籤圖片/貼標文件單獨放置',
    ru: 'Размещение файла раскраски / изображения метки / файла наклейки отдельно',
    ko: '남은 대판 원단 파일 / 태그 이미지 / 태그 파일 별도 배치',
    bur: 'ပိုလျှံပေါ်ဒ်ကြီးဖြတ်ဖိုင်/တံဆိပ်ပုံ/တံဆိပ်ဖိုင်သပ်ခြားထား',
    ben: 'স্পেয়ার ম্যাটেরিয়াল বড় বোর্ড কাটিং ফাইল/লেবেল ছবি/লেবেলিং ফাইল আলাদা রাখা হয়',
    tr: 'Artık büyük plaka kesim dosyaları/etiket görselleri/etiket dosyaları ayrı konur',
    km: 'ឯកសារកាត់ផ្ទាំងធំសល់ រូបស្លាក និងឯកសារស្លាកដាក់ដាច់ដោយឡែក',
    es: 'El archivo de borrado del tablero de material restante/imagen de etiqueta/archivo de etiquetado se colocan por separado',
    ar: 'يتم وضع ملف إفراغ لوحة المواد المتبقية/صورة الملصق/ملف الملصق بشكل منفصل',
  },
  'fileManagerPage.surplusBigPlankSettingTip': {
    zh: '开启后余料的NC文件，标签图片和贴标文件会单独放在一个文件夹里',
    en: 'After opening, the remaining NC files, label pictures and labeling files will be placed in a separate folder',
    id: 'Setelah membuka, file NC sisa, gambar label dan file label akan ditempatkan dalam folder terpisah',
    kz: 'Іске қосылғаннан кейін қалдықтардың NC файлы, таңба суреттері және жапсырма файлдары жеке бір папкада орналастырылады',
    th: 'หลังจากเปิดการตั้งค่า ไฟล์ NC ที่เหลืออยู่ รูปภาพฉลาก และไฟล์ฉลากจะถูกวางในโฟลเดอร์ที่แยกกัน',
    ug: 'قوزغاتقاندىن كېيىن قالدۇق ماتېرىيالنىڭ NC ھۆججىتى، بېلگە رەسىمى ۋە بېلگە چاپلاش ھۆججىتى ئايرىم بىر قىسقۇچقا ئورۇنلاشتۇرۇلىدۇ',
    vi: 'Sau khi mở các tập tin NC, ảnh dán nhãn và tập tin dán nhãn sẽ được đặt riêng biệt trong một thư mục',
    zh_tc: '開啟後餘料的NC文件，標籤圖片和貼標文件會單獨放在一個文件夾裡',
    ru: 'После открытия остаточного файла NC, изображение метки и файл метки будут помещены в отдельную папку',
    ko: '여분의 NC 파일을 열면 태그 이미지와 태그 파일이 하나의 폴더에 별도로 배치됩니다.',
    bur: 'ဖွင့်ပြီးနောက်ပိုလျှံ NC ဖိုင်၊ တံဆိပ်ပုံနှင့်တံဆိပ်ဖိုင်များကိုသပ်ဖိုလ်ဒါတွင်ထား',
    ben: 'চালু করার পর উদ্বৃত্ত NC ফাইল, লেবেল ছবি ও লেবেলিং ফাইল আলাদা ফোল্ডারে রাখা হবে',
    tr: 'Açıldığında artık NC dosyaları, etiket görselleri ve etiket dosyaları ayrı bir klasörde toplanır',
    km: 'បន្ទាប់ពីបើក ឯកសារ NC សល់ រូបស្លាក និងឯកសារស្លាកនឹងដាក់ក្នុងថតដាច់ដោយឡែក',
    es: 'Después de abrir, el archivo NC del material restante, la imagen de etiqueta y el archivo de etiquetado se colocarán en una carpeta separada',
    ar: 'بعد الفتح، سيتم وضع ملف NC الخاص بالمادة المتبقية وصورة الملصق وملف الملصق في مجلد منفصل',
  },
  'fileManagerPage.folderMergeSetting': {
    zh: '文件夹合并设置',
    en: 'Folder Merging Settings',
    id: 'Pengaturan gabungan folder',
    kz: 'Қапшықтарды біріктіру орнату',
    th: 'การตั้งค่าการผสานโฟลเดอร์',
    ug: 'مۇندەرىجە بىرلەشتۈرۈش تەڭشىكى',
    vi: 'Thiết lập hợp nhất thư mục',
    zh_tc: '文件夾合併設置',
    ru: 'Параметры объединения папок',
    ko: '폴더 병합 설정',
    bur: 'ဖိုလ်ဒါပေါင်းစည်းဆက်တင်',
    ben: 'ফোল্ডার মার্জিং সেটিংস',
    tr: 'Klasör birleştirme ayarları',
    km: 'ការកំណត់បញ្ចូលថត',
    es: 'Configuración de combinación de carpetas',
    ar: 'إعدادات دمج المجلدات',
  },
  'fileManagerPage.folderMerge': {
    zh: '文件夹合并',
    en: 'Folder Merging',
    id: 'Gabungan folder',
    kz: 'Қапшықтарды біріктіру',
    th: 'โฟลเดอร์ผสาน',
    ug: 'مۇندەرىجە بىرلەشتۈرۈش',
    vi: 'Hợp nhất thư mục',
    zh_tc: '文件夾合併',
    ru: 'Объединение папок',
    ko: '폴더 병합',
    bur: 'ဖိုလ်ဒါပေါင်းစည်း',
    ben: 'ফোল্ডার মার্জিং',
    tr: 'Klasör birleştirme',
    km: 'ការបញ្ចូលថត',
    es: 'Combinación de carpetas',
    ar: 'دمج المجلدات',
  },
  'fileManagerPage.mergeName': {
    zh: '合并名称',
    en: 'Merged Name',
    id: 'Gabungkan nama',
    kz: 'Біріктіру атау',
    th: 'ชื่อผสาน',
    ug: 'بىرلەشتۈرۈلگەن نام',
    vi: 'Tên hợp nhất',
    zh_tc: '合併名稱',
    ru: 'Имя объединения',
    ko: '병합 이름',
    bur: 'ပေါင်းစည်းအမည်',
    ben: 'মার্জড নাম',
    tr: 'Birleştirilmiş ad',
    km: 'ឈ្មោះបញ្ចូលគ្នា',
    es: 'Nombre de combinación',
    ar: 'دمج الاسم',
  },
  'fileManagerPage.subMergeFolder': {
    zh: ' 按照材质颜色厚度合并到子文件夹',
    en: 'Merge into subfolders based on material, color, and thickness:',
    id: 'Gabungkan menjadi subfolder dengan ketebalan warna material',
    kz: 'Материалдің түсі, түсі және қалыңдығы бойынша кіші қапшыққа біріктіру:',
    th: 'รวมเข้ากับโฟลเดอร์ย่อยด้วยความหนาของสีวัสดุ',
    ug: 'ماتېرىيال رەڭ قېلىنلىقى بويىچە تارماق مۇندەرىجىگە بىرلەشتۈرۈش',
    vi: 'Hợp nhất theo chất liệu, màu sắc, độ dày vào thư mục con:',
    zh_tc: ' 按照材質顏色厚度合併到子文件夾',
    ru: 'Объединить в подкаталоги по толщине цвета материала',
    ko: '재료 색상 두께에 따라 하위 폴더로 결합',
    bur: 'ပစ္စည်း၊ အရောင်၊ အထူအလိုက်ဆက်ဖိုလ်ဒါသို့ပေါင်းစည်း',
    ben: 'উপকরণ, রঙ ও পুরুত্ব অনুযায়ী সাবফোল্ডারে মার্জ করুন',
    tr: 'Malzeme, renk ve kalınlığa göre alt klasörlere birleştir:',
    km: 'បញ្ចូលទៅថតរងតាមសម្ភារៈ ពណ៌ និងកម្រាស់៖',
    es: 'Combinación en subcarpetas según el color y el grosor del material',
    ar: 'الدمج في المجلدات الفرعية حسب لون المادة وسمكها',
  },
  'fileManagerPage.subFolderName': {
    zh: '子文件夹名称',
    en: 'Subfolder Name',
    id: 'Nama subfolder',
    kz: 'Кіші қапшық атауы',
    th: 'ชื่อโฟลเดอร์ย่อย',
    ug: 'تارماق مۇندەرىجە ئىسمى',
    vi: 'Tên thư mục con',
    zh_tc: '子文件夾名稱',
    ru: 'Имя папки',
    ko: '하위 폴더 이름',
    bur: 'ဆက်ဖိုလ်ဒါအမည်',
    ben: 'সাবফোল্ডার নাম',
    tr: 'Alt klasör adı',
    km: 'ឈ្មោះថតរង',
    es: 'Nombre de subcarpeta',
    ar: 'اسم المجلد الفرعي',
  },
  'fileManagerPage.splitChar': {
    zh: '分割符',
    en: 'Separator',
    id: 'Karakter pemisahan',
    kz: 'Бөлшектің белгісі',
    th: 'การแยกอักขระ',
    ug: 'ئايرىغۇچ',
    vi: 'Dấu phân cách',
    zh_tc: '分割符',
    ru: 'Разделитель',
    ko: '분할자',
    bur: 'ခွဲခြားသင်္ကေတ',
    ben: 'সেপারেটর',
    tr: 'Ayırıcı',
    km: 'សញ្ញាបំបែក',
    es: 'Delimitador',
    ar: 'المحدد',
  },
  'fileManagerPage.splitTip': {
    zh: '（不支持输入 / : ? < > | . ” * 等字符）',
    en: '(Unsupported characters include / : ? < > | . ” *)',
    id: '(Karakter input seperti /:? <> . ” * Tidak didukung)',
    kz: '（/ : ? < > | . ” * және басқа да символдар енгізуге болмайды)',
    th: '(ไม่รองรับอักขระอินพุตเช่น /:? <> .” * ไม่รองรับ)',
    ug: '( / : ? < > . ” * قاتارلىق ھەرپلەرنى كىرگۈزۈشكە بولمايدۇ)',
    vi: '(Không hỗ trợ nhập kí tự như / : ? < > | . ” * ...)',
    zh_tc: '（不支持輸入 / : ? < > | . ” * 等字符）',
    ru: '(Не поддерживается ввод /:? < > <... > > * и другие символы)',
    ko: '(/:? < >. "* 등의 문자는 지원되지 않음)',
    bur: '( / : ? < > | . " * စသည်ထည့်မရ)',
    ben: '( / : ? < > | . " * ইত্যাদি অক্ষর সাপোর্ট করা হয় না)',
    tr: '(/ : ? < > | . " * gibi karakterler desteklenmez)',
    km: '(មិនគាំទ្រតួអក្សរដូចជា / : ? < > | . " *)',
    es: '(No admite entrada / : ? < > | . ” * y otros caracteres)',
    ar: '(لا تدعم الإدخال / : ? < > | . ” * وأحرف أخرى)',
  },
  'fileManagerPage.folderAutoAdd': {
    zh: '文件夹数自增起始数值',
    en: 'Automatic Increment Starting Value for Folder Count',
    id: 'Jumlah folder ditingkatkan dengan nilai awal',
    kz: 'Қапшық санының автоматты түрде өсу бастапқы мәні',
    th: 'จำนวนโฟลเดอร์เพิ่มขึ้นตามค่าเริ่มต้น',
    ug: 'مۇندەرىجە سانى ئاپتوماتىك ئاشۇرۇش باشلانغۇچ سانى',
    vi: 'Tự động tăng số thư mục bắt đầu từ',
    zh_tc: '文件夾數自增起始數值',
    ru: 'Начальное значение увеличения числа папок',
    ko: '폴더 수 증가 시작 값',
    bur: 'ဖိုလ်ဒါအရေအတွက်အလိုအလျောက်တိုးစရာဂဏန်း',
    ben: 'ফোল্ডার কাউন্ট অটো ইনক্রিমেন্ট স্টার্ট ভ্যালু',
    tr: 'Klasör sayısı otomatik artış başlangıç değeri',
    km: 'តម្លៃចាប់ផ្តើមដើម្បីបង្កើនចំនួនថតស្វ័យប្រវត្តិ',
    es: 'El número de carpetas aumenta desde el valor inicial',
    ar: 'يزيد عدد المجلدات من قيمة البداية',
  },
  'fileManagerPage.resetTip': {
    zh: '(每日零点重置为起始数值)',
    en: '(Resets to the starting value at midnight every day)',
    id: '(Setel ulang ke nilai awal setiap hari)',
    kz: '(Күн сайын таңертеңге бастапқы мәнге қайта орнату)',
    th: '(รีเซ็ตเป็นค่าเริ่มต้นทุกวัน)',
    ug: '(ھەر كۈنى 00:00 دا باشلانغۇچ سانغا قايتۇرىدۇ)',
    vi: '(Đặt lại về số bắt đầu mỗi ngày lúc 00:00)',
    zh_tc: '(每日零點重置為起始數值)',
    ru: '(Ежедневный сброс нуля на исходное значение)',
    ko: '(매일 0점을 시작 값으로 재설정)',
    bur: '(နေ့စဉ်သုညအချိန်တွင်စရာဂဏန်းသို့ပြန်ထား)',
    ben: '(প্রতিদিন মধ্যরাতে স্টার্ট ভ্যালুতে রিসেট হয়)',
    tr: '(Her gün gece yarısı başlangıç değerine sıfırlanır)',
    km: '(រាល់ថ្ងៃម៉ោងសូន្យធ្វើឡើងវិញទៅតម្លៃចាប់ផ្តើម)',
    es: '(Restablece al valor inicial en cero todos los días)',
    ar: '(إعادة الضبط إلى قيمة البداية عند الصفر كل يوم)',
  },
  'fileManagerPage.emptyErrTip': {
    zh: '信息不能为空',
    en: 'Information cannot be empty',
    id: 'Informasi tidak bisa kosong',
    kz: 'ئۇچۇر بوش قالمايدۇ',
    th: 'ข้อมูลไม่สามารถว่างเปล่า',
    ug: 'ئۇچۇر بوش قالمايدۇ',
    vi: 'Thông tin không được để trống',
    zh_tc: '信息不能為空',
    ru: 'Информация не может быть пустой',
    ko: '정보는 비워둘 수 없습니다.',
    bur: 'အချက်အလက်မဟာမဆ',
    ben: 'তথ্য খালি রাখা যাবে না',
    tr: 'Bilgi boş olamaz',
    km: 'ព័ត៌មានមិនអាចទទេ',
    es: 'La información no puede estar vacía',
    ar: 'لا يمكن أن تكون المعلومات فارغة',
  },
  'fileManagerPage.repeatErrTip': {
    zh: '文件名称重复',
    en: 'File name duplicate',
    id: 'Nama file duplikat',
    kz: 'ھۆججەت ئىسمى قايتىلانغان',
    th: 'ชื่อไฟล์ที่ซ้ำกัน',
    ug: 'ھۆججەت ئىسمى قايتىلانغان',
    vi: 'Tên tệp đã trùng lặp',
    zh_tc: '文件名稱重複',
    ru: 'Имя файла повторяется',
    ko: '파일 이름 중복',
    bur: 'ဖိုင်အမည်ထပ်နေသည်',
    ben: 'ফাইলের নাম ডুপ্লিকেট',
    tr: 'Dosya adı yineleniyor',
    km: 'ឈ្មោះឯកសារស្ទួន',
    es: 'Nombre de archivo duplicado',
    ar: 'اسم ملف مكرر',
  },
  'fileManagerPage.mergeDataTip': {
    zh: '必须存在板件材质颜色厚度长宽或者文件数自增或者板件材质颜色厚度',
    en: 'The board material color thickness length and width or file number increase or board material color thickness must exist',
    id: 'Warna, ketebalan, panjang dan lebar bahan papan atau jumlah file harus ditingkatkan secara otomatis.',
    kz: 'Төсі, қалыңдығы, ұзындығы және ені немесе файл саны автоматты түрде өсуі керек',
    th: 'สีความหนาความยาวและความกว้างของวัสดุบอร์ดหรือจำนวนไฟล์จะต้องเพิ่มขึ้นโดยอัตโนมัติ',
    ug: 'تاختا ماتېرىيالى رەڭ قېلىنلىقى ئۇزۇنلۇقى كەڭلىكى ياكى ھۆججەت سانى ئاپتوماتىك ئاشۇرۇش مەۋجۇت بولۇشى كېرەك',
    vi: 'Phải có thông tin về chất liệu, màu sắc, độ dày, chiều dài, chiều rộng của tấm hoặc tự động tăng số tệp',
    zh_tc: '必須存在板件材質顏色厚度長寬或者文件數自增或者板件材質顏色厚度',
    ru: 'Должен быть материал пластины толщина цвета длина ширина или увеличение числа файлов или толщина цвета пластины',
    ko: '판재 재료 색상 두께 가로세로 또는 파일 수 증가 또는 판재 재료 색상 두께가 있어야 합니다.',
    bur: 'ပြားပစ္စည်းအရောင်အထူအလျားအကျယ် သို့မဟုတ် ဖိုင်အရေအတွက်တိုး သို့မဟုတ် ပြားပစ္စည်းအရောင်အထူ ရှိရမည်',
    ben: 'বোর্ড উপকরণ রঙ পুরুত্ব দৈর্ঘ্য প্রস্থ বা ফাইল নম্বর বৃদ্ধি বা বোর্ড উপকরণ রঙ পুরুত্ব থাকতে হবে',
    tr: 'Plaka malzemesi, renk, kalınlık, uzunluk/genişlik veya dosya sayısı artışı veya malzeme-renk-kalınlık bilgisi olmalıdır',
    km: 'ត្រូវមានសម្ភារៈផ្ទាំង ពណ៌ កម្រាស់ បណ្តោយ/ទទឹង ឬការបង្កើនចំនួនឯកសារ ឬសម្ភារៈ-ពណ៌-កម្រាស់',
    es: 'El material de la placa, el color, el grosor, el largo y el ancho deben existir o el número de archivos aumenta automáticamente o el grosor del color del material de la placa',
    ar: 'يجب أن تكون مادة اللوحة واللون والسمك والطول والعرض موجودة أو يزيد عدد الملفات تلقائيًا أو سمك لون مادة اللوحة',
  },
  'fileManagerPage.engravingFileSetting': {
    zh: '雕刻机文件设置',
    en: 'Carving machine file settings',
    id: 'Pengaturan File Mesin Ukir',
    kz: 'Сүйектеу файлын орнату',
    th: 'การตั้งค่าไฟล์เครื่องแกะสลัก',
    ug: 'تىزىقلىتىش ماشىنىسىسى فائلىلىرى سىتىمىسى',
    vi: 'Cài đặt tệp máy khắc',
    zh_tc: '雕刻機文件設置',
    ru: 'Настройка файла гравировальной машины',
    ko: '조각기 파일 설정',
    bur: 'ထွင်းထားစက်ဖိုင်ဆက်တင်',
    ben: 'ক্যারভিং মেশিন ফাইল সেটিংস',
    tr: 'Oyma makinesi dosya ayarları',
    km: 'ការកំណត់ឯកសារម៉ាស៊ីនចុកចាក់',
    es: 'Configuración del archivo de la máquina de grabado',
    ar: 'إعدادات ملف آلة النقش',
  },
  'fileManagerPage.engravingSplitZF': {
    zh: '将雕刻机正/反面文件用不同文件夹放置',
    en: 'Place the front/back files of the engraving machine in different folders',
    id: 'Tempatkan file positif / balik mesin ukir dengan folder yang berbeda',
    kz: 'Терезелектің алдыңғы/артқы файлдарын ажыратып папкаларға салыңыз',
    th: 'วางไฟล์บวก / กลับของเครื่องแกะสลักด้วยโฟลเดอร์ที่แตกต่างกัน',
    ug: 'تەسىرلىك ماشىنىنىڭ ئوتتۇرى/ئارقىلىق كۆرسىتىدىكى فائىلدارنى بىر-بىرىدىن باشقا تالارغا ساقلاڭ',
    vi: 'Đặt các tập tin mặt trước/mặt sau của máy chạm khắc vào các thư mục khác nhau',
    zh_tc: '將雕刻機正/反面文件用不同文件夾放置',
    ru: 'Поместить положительные / отрицательные файлы гравировальной машины в разные папки',
    ko: '조각기 양면 / 후면 파일을 다른 폴더로 배치',
    bur: 'ထွင်းစက်ရှေ့/အနောက်ဖိုင်များကိုမတူသောဖိုလ်ဒါများတွင်ထား',
    ben: 'এনগ্রেভিং মেশিনের সামনে/পিছনের ফাইল আলাদা ফোল্ডারে রাখুন',
    tr: 'Oyma makinesinin ön/arka dosyalarını farklı klasörlerde saklayın',
    km: 'រក្សាទុកឯកសារមុខ/ក្រោយរបស់ម៉ាស៊ីនចុកចាក់ក្នុងថតផ្សេងគ្នា',
    es: 'Coloque los archivos frontales y posteriores de la máquina de grabado en diferentes carpetas',
    ar: 'ضع الملفات الأمامية/الخلفية لآلة النقش في مجلدات مختلفة',
  },
  'fileManagerPage.engravingSplitZFTip': {
    zh: '适用于壹贰叁自动贴标机，',
    en: 'Suitable for 123 automatic labeling machines,',
    id: 'Berlaku untuk mesin label otomatis satu dua tiga,',
    kz: 'Бір, Екі, Үш автоматты этикеттеу машинасына сай келеді,',
    th: 'เหมาะสำหรับหนึ่งสองสามเครื่องติดฉลากอัตโนมัติ,',
    ug: 'بىر، ئىككى، ئۈچ ئاپتوماتلىق تېيەكلىتىش ماشىنىسى ئۈچۈن قۇشۇلۇشى مۇمكىن',
    vi: 'Dùng cho máy dán nhãn tự động 123,',
    zh_tc: '適用於壹貳叄自動貼標機，',
    ru: 'Подходит для автоматической маркировки,',
    ko: '1, 2, 3 자동 부착기에 적용,',
    bur: '၁၂၃အလိုအလျောက်တံဆိပ်ကပ်စက်အတွက်သင့်လျော်',
    ben: '১২৩ অটোমেটিক লেবেলিং মেশিনের জন্য উপযুক্ত',
    tr: '123 otomatik etiketleme makineleri için uygundur',
    km: 'សមស្របសម្រាប់ម៉ាស៊ីនស្លាកស្វ័យប្រវត្តិ ១២៣',
    es: 'Aplicable a la máquina etiquetadora automática 123,',
    ar: 'ينطبق على آلة وضع العلامات الأوتوماتيكية 123،',
  },
  'fileManagerPage.engravingSplitWorkstation': {
    zh: '雕刻机按工位分文件夹',
    en: 'Carving machine by workstation folder',
    id: 'Mesin ukir berdasarkan posisi kerja',
    kz: 'Гравировальная машина позиция бойынша папкаларға бөлінеді',
    th: 'เครื่องกัดตามตำแหน่งงาน',
    ug: 'تەسىرلىك ماشىنىسى بىر-بىرىدىن باشقا قىسىقىسىغا ساقلاڭ',
    vi: 'Máy chạm khắc theo vị trí làm việc',
    zh_tc: '雕刻機按工位分文件夾',
    ru: 'Гравировальная машина позиция бойынша папкаларға бөлінеді',
    ko: '조각기 위치별 폴더',
    bur: 'ထွင်းစက်ရှေ့/အနောက်ဖိုင်များကိုမတူသောဖိုလ်ဒါများတွင်ထား',
    ben: 'এনগ্রেভিং মেশিনের কাজস্থান অনুযায়ী ফোল্ডার',
    tr: 'Oyma makinesi pozisyonuna göre klasörler',
    km: 'ម៉ាស៊ីនចុកចាក់ក្នុងថតផ្សេងគ្នាតាមផាក្រិត',
    es: 'Máquina de grabado por posición de trabajo',
    ar: 'آلة النقش حسب موقع العمل',
  },
  'fileManagerPage.engravingSplitWorkstationTip': {
    zh: '注：仅支持雕刻机和锯切雕刻机',
    en: 'Note: Only supported for engraving machines and sawing engraving machines',
    id: 'Catatan: Hanya didukung untuk mesin ukir dan mesin ukir sawing',
    kz: 'Гравировальная машина и машина для резки гравировальной машины поддерживается',
    th: 'หมายเหตุ: รองรับเฉพาะเครื่องกัดและเครื่องกัดตัด',
    ug: 'تەسىرلىك ماشىنىسى ۋە ئوتتۇرلىك ماشىنىسى ئۈچۈن قۇشۇلۇشى مۇمكىن',
    vi: 'Chỉ hỗ trợ cho máy chạm khắc và máy chạm khắc cắt',
    zh_tc: '注：僅支持雕刻機和鋸切雕刻機',
    ru: 'Гравировальная машина и машина для резки гравировальной машины поддерживается',
    ko: '조각기와 절단 조각기만 지원',
    bur: 'ထွင်းစက်ရှေ့/အနောက်ဖိုင်များကိုမတူသောဖိုလ်ဒါများတွင်ထား',
    ben: 'এনগ্রেভিং মেশিন এবং সাউইং এনগ্রেভিং মেশিনের জন্য উপযুক্ত',
    tr: 'Oyma makinesi ve kesme oyma makinesi desteklenir',
    km: 'ម៉ាស៊ីនចុកចាក់ និង ម៉ាស៊ីនចុកចាក់បានជោគជ័យ',
    es: 'Se admite la máquina de grabado y la máquina de grabado de corte',
    ar: 'يدعم الآلة النقش والآلة النقش القطع',
  },
  'fileManagerPage.holeFileSetting': {
    zh: '打孔文件设置',
    en: 'Punch file settings',
    id: 'Pengaturan file lubang',
    kz: 'Босқын файл параметрлерін орнату',
    th: 'การตั้งค่าไฟล์เจาะรู',
    ug: 'بېكىتىش دۆكىمىنى تەڭشەك',
    vi: 'Thiết lập tệp đục lỗ',
    zh_tc: '打孔文件設置',
    ru: 'Параметры перфорации файла',
    ko: '펀치 파일 설정',
    bur: 'အပေါက်ဖိုင်ဆက်တင်',
    ben: 'পাঞ্চ ফাইল সেটিংস',
    tr: 'Delik dosyası ayarları',
    km: 'ការកំណត់ឯកសាររណ្តៅ',
    es: 'Configuración del archivo de perforación',
    ar: 'إعدادات ملف التثقيب',
  },
  'fileManagerPage.holeFileSingle': {
    zh: '打孔文件按不同订单分文件夹单独放置',
    en: 'Punching files are placed separately in folders according to different orders',
    id: 'File punching ditempatkan secara terpisah dalam subfolder dalam urutan yang berbeda',
    kz: 'Берілген тапсырыстар бойынша түрлі папкаларда құралдың тесік қию файлдарын жеке орналастырыңыз',
    th: 'ไฟล์เจาะรูแยกโฟลเดอร์ตามลำดับที่แตกต่างกัน',
    ug: 'كۆچۈرۈش فايللىرىنى تەكىن فولدرلارغا باشقا ئەمرلەر بويىچە جەدەل قۇйۇڭ',
    vi: 'Tập tin đục lỗ được đặt riêng biệt trong các thư mục theo từng đơn hàng khác nhau',
    zh_tc: '打孔文件按不同訂單分文件夾單獨放置',
    ru: 'Размещение перфорированных файлов в отдельных папках по различным заказам',
    ko: '펀치 파일은 주문에 따라 폴더별로 개별적으로 배치됩니다.',
    bur: 'အပေါက်ဖိုင်များကိုမတူမှာယူမှုအလိုက်ဖိုလ်ဒါခွဲသပ်ထား',
    ben: 'পাঞ্চিং ফাইল ভিন্ন অর্ডার অনুযায়ী ফোল্ডারে আলাদা রাখা হয়',
    tr: 'Delik dosyaları farklı siparişlere göre ayrı klasörlerde konur',
    km: 'ឯកសាររណ្តៅដាក់ដាច់ដោយឡែកតាមការកម្មង់ផ្សេងៗ',
    es: 'Los archivos de perforación se colocan por separado en carpetas según diferentes pedidos',
    ar: 'يتم وضع ملفات التثقيب بشكل منفصل في المجلدات حسب ترتيب مختلف',
  },
  'moreSettings.generalSetting': {
    zh: '通用设置',
    en: 'General setting',
    id: 'Pengaturan Umum',
    kz: 'Жалпы параметрлер',
    th: 'การตั้งค่าทั่วไป',
    ug: 'ئادەتتىكى تەڭشەك',
    vi: 'Thiết lập chung',
    zh_tc: '通用設定',
    ru: 'Общие настройки',
    ko: '일반 설정',
    bur: 'ယေဘုယျဆက်တင်',
    ben: 'সাধারণ সেটিং',
    tr: 'Genel ayarlar',
    km: 'ការកំណត់ទូទៅ',
    es: 'Configuración general',
    ar: 'الإعدادات العامة',
  },
  'moreSettings.outSyncTip': {
    zh: '云排版原片数据与柜柜不同步时生成提示弹窗',
    en: 'When the cloud typesetting original film data is not synchronized with the cabinet cabinet, a pop-up window is generated',
    id: 'Hasilkan jendela pop-up saat Data Film Asli Tata Letak Cloud tidak disinkronkan dengan kabinet kabinet',
    kz: 'Бұлтты типтеудің бастапқы деректері шкафпен синхрондалмаған кезде қалқымалы терезе жасалады',
    th: 'สร้างหน้าต่างป๊อปอัพเมื่อข้อมูลฟิล์มดั้งเดิมของคลาวด์ไม่ได้ซิงโครไนซ์กับตู้เก็บของ',
    ug: 'بۇلۇت تەرتىپلەش ئەسلى تاختا سانلىق مەلۇماتى كابىنېت بىلەن ماسلىشمايدىكەن ئەسكەرتىش سۆزلىشىش كۆزنىكى ھاسىل قىلىش',
    vi: 'Tạo ra một gợi ý khi dữ liệu gốc không đồng bộ với tủ',
    zh_tc: '雲排版原片數據與櫃櫃不同步時生成提示彈窗',
    ru: 'При несинхронизации данных с шкафом создается окно подсказки',
    ko: '클라우드 레이아웃 원본 데이터가 캐비닛과 동기화되지 않을 때 알림 탄창 생성',
    bur: 'ကလောက်ဒ်ပြင်ဆင်ဒေတာနှင့်ကက်ဘိနက်မကိုက်ညီသည့်အခါအကြံပြုပေါ်ပြကာပွင့်',
    ben: 'ক্লাউড টাইপসেটিং অরিজিনাল ডেটা ক্যাবিনেটের সাথে সিঙ্ক না থাকলে প্রম্পট পপআপ তৈরি হয়',
    tr: 'Bulut dizgi özgün film verisi dolapla senkron değilken uyarı penceresi göster',
    km: 'បង្ហាញបង្អួចព្រមានពេលទិន្នន័យហ្វីលមូលដ្ឋានក្លោដរៀបចំមិនសមកាលជាមួយទូ',
    es: 'Se genera una ventana emergente cuando los datos de la pieza original de la composición tipográfica en la nube no están sincronizados con el gabinete',
    ar: 'يتم إنشاء نافذة منبثقة سريعة عندما تكون بيانات القطعة الأصلية للتنضيد السحابي غير متزامنة مع الخزانة',
  },
  'moreSettings.secondarySwitchShow': {
    zh: '雕刻机设置中开关控制的二级内容关闭开关后依旧展示',
    en: 'The secondary content of the switch control in the engraving machine setting is still displayed after the switch is turned off',
    id: 'Kandungan sekunder dari kontrol sakelar di pengaturan mesin ukiran masih ditampilkan setelah mematikan sakelar.',
    kz: 'Ою машинасының параметрлерінде ажыратқышпен басқарылатын қайталама мазмұн ажыратқыш өшірілгеннен кейін әлі де көрсетіледі',
    th: 'เนื้อหาที่สองของการควบคุมสวิตช์ในการตั้งค่าเครื่องแกะสลักจะยังคงปรากฏขึ้นหลังจากปิดสวิตช์',
    ug: 'ئويما ماشىنىسى تەڭشىكىدىكى كونترول قىلغۇچنىڭ ئىككىنچى دەرىجىلىك مەزمۇنى كونترول قىلغۇچ تاقىلغاندىمۇ كۆرسىتىلىدۇ',
    vi: 'Khắc máy thiết lập chuyển mạch điều khiển nội dung thứ hai tắt chuyển tiếp sau khi hiển thị',
    zh_tc: '雕刻機設定中開關控制的二級內容關閉開關後依舊展示',
    ru: 'Содержание второго уровня, управляемое переключателем в настройках гравировальной машины, все еще отображается после выключения переключателя',
    ko: '조각기 설정 중 스위치 제어의 2단계 내용 스위치 해제 후 여전히 전시',
    bur: 'ထွင်းစက်ဆက်တင်ရှိခလုတ်ထိန်းချုပ်သောဒုတိယအကြောင်းအရာပိတ်ပြီးနောက်ပြသ',
    ben: 'এনগ্রেভিং মেশিন সেটিংয়ে সুইচ কন্ট্রোলের সেকেন্ডারি কন্টেন্ট সুইচ বন্ধের পরও দেখায়',
    tr: 'Oyma ayarındaki anahtarın kapattığı alt içerik yine de gösterilir',
    km: 'មាតិការងដែលគ្រប់គ្រងដោយប៊ូតុងក្នុងការកំណត់ចុកចាក់ នៅតែបង្ហាញបន្ទាប់ពីបិទ',
    es: 'El contenido secundario controlado por el interruptor en la configuración de la máquina de grabado aún se muestra después de que se apaga el interruptor',
    ar: 'لا يزال المحتوى الثانوي الذي يتم التحكم فيه بواسطة المفتاح في إعدادات آلة النقش معروضًا بعد إيقاف تشغيل المفتاح',
  },
  'moreSettings.isFrameDoorTip': {
    zh: '骨骼门加工时生成提示弹窗',
    en: 'Generates prompt pop-ups when processing frame doors',
    id: 'Menghasilkan pop-up prompt saat memproses pintu rangka',
    kz: 'Рамка қақпасын өңдегенде ескерту терезесі жасалады',
    th: 'สร้างหน้าต่างป๊อปอัพพร้อมท์เมื่อประมวลผลประตูรูปตัว',
    ug: 'رامка قاقپاسى تەڭشەشكىدىكى ھاسىل قىلىنغان كۆزنىكى ھاسىل قىلىنىدۇ',
    vi: 'Tạo cửa sổ nhắc nhở khi xử lý cửa khung',
    zh_tc: '骨骼門加工時生成提示彈窗',
    ru: 'При обработке рамковых дверей создается подсказка',
    ko: '프레임 문 가공 시 프롬프트 탄창 생성',
    bur: 'ကက်ဘိနက်ပစ္စည်းများကို ဘယ်လိုလုပ်ဆောင်ချင်သည်ဆိုပါက အကြံပြုပေါ်ပြသည်',
    ben: 'ফ্রেম ডোর প্রক্রিয়াকরণ সময় প্রম্পট পপআপ তৈরি হয়',
    tr: 'Kafes kapısı işleme sırasında uyarı göster',
    km: 'បង្កើតបង្អួចព្រមានពេលបង្រួមទូរទូទាត់',
    es: 'Se genera una ventana emergente cuando se procesan puertas de marco',
    ar: 'يتم إنشاء نافذة منبثقة سريعة عندما يتم معالجة أبواب الأطار',
  },
  'moreSettings.exPaibanTip': {
    zh: '使用异形余料/异形嵌套排版时生成提示弹窗',
    en: 'Generates prompt pop-ups when using irregular scrap/irregular nesting typography',
    id: 'Menghasilkan pop-up prompt saat menggunakan tata letak sisa bahan tidak beraturan/penyusunan tidak beraturan',
    kz: 'Бұлттық орналастырудың дұрыс емес қалдықтар/дұрыс емес кірістіру функциясын пайдаланғанда ескерту терезесі жасалады',
    th: 'สร้างป๊อปอัพพร้อมท์เมื่อใช้การจัดวางเศษวัสดุผิดปกติ/การซ้อนทับผิดปกติ',
    ug: 'بۇلۇت تەرتىپلەشتىكى ئۆزگىچە قېپىل/ئۆزگىچە كىرگۈزۈش ئىشلىتىلگەندە ئەسكەرتىش سۆزلىشىش كۆزنىكى ھاسىل قىلىش',
    vi: 'Tạo cửa sổ nhắc nhở khi sử dụng bố cục phế liệu không đều/lồng ghép không đều',
    zh_tc: '使用異形餘料/異形嵌套排版時生成提示彈窗',
    ru: 'Создание подсказок при наборе',
    ko: '이형 여분 / 이형 중첩 레이아웃 사용 시 힌트 탄창 생성',
    bur: 'အသွင်ပိုလျှံ/အသွင်နစ်စတင်ပြင်ဆင်သုံးသည့်အခါအကြံပြုပေါ်ပြ',
    ben: 'ইরেগুলার স্ক্র্যাপ/ইরেগুলার নেস্টিং টাইপোগ্রাফি ব্যবহার করলে প্রম্পট পপআপ তৈরি হয়',
    tr: 'Düzensiz artık/düzensiz iç içe yerleşim kullanılırken uyarı penceresi oluştur',
    km: 'បង្កើតបង្អួចព្រមានពេលប្រើការរៀបចំសម្ភារៈសល់/ខ្នាតមិនទៀងលាក់គ្នា',
    es: 'Se genera una ventana emergente cuando se utiliza material remanente de forma especial/composición tipográfica anidada de forma especial',
    ar: 'يتم إنشاء نافذة منبثقة سريعة عند استخدام مادة متبقية ذات شكل خاص/تنضيد متداخل ذو شكل خاص',
  },
  'moreSettings.isDesMaterialNoCutTip': {
    zh: '指定小板材质不下料的板件,有分配到雕刻机的孔槽/异形时生成提示弹窗',
    en: 'For specified small board materials that are not cut, when there are holes/slots/shapes assigned to the engraving machine, a prompt pop-up window will be generated',
    id: 'Untuk bahan papan kecil yang ditentukan yang tidak dipotong, ketika ada lubang, slot atau bentuk tidak beraturan yang ditugaskan ke mesin ukiran, jendela pop-up prompt akan dihasilkan',
    kz: 'Кесілмеген кіші тақтай материалдары үшін, ою машинасына тағайындалған тесіктер, ойықтар немесе бітік пішіндер болған кезде, ескерту терезесі жасалады',
    th: 'สำหรับวัสดุแผ่นเล็กที่ระบุที่ไม่ตัด เมื่อมีรู ช่อง หรือรูปร่างพิเศษที่กำหนดให้กับเครื่องแกะสลัก จะสร้างหน้าต่างป๊อปอัพพร้อมท์',
    ug: 'بەلگىلەنگەن كىچىك تاختا ماتېرىياللىرى كېسىلمىگەن بولسا، ئويما ماشىنىسىغا تەقسىم قىلىنغان تۇيۇق، ئوچۇقلار ۋە ئۆزگىچە شەكىللەر بولغاندا، ئەسكەرتىش سۆزلىشىش كۆزنىكى ھاسىل قىلىنىدۇ',
    vi: 'Đối với vật liệu tấm nhỏ được chỉ định không được cắt, khi có lỗ, khe hoặc hình dạng không đều được gán cho máy khắc, cửa sổ nhắc nhở sẽ được tạo ra',
    zh_tc: '指定小板材質不下料的板件，有分配到雕刻機的孔槽/異形時生成提示彈窗',
    ru: 'Укажите панель, материал которой не загружается, с отверстием, выделенным гравировальной машине / фасадом, чтобы создать подсказку всплывающего окна',
    ko: '조각기에 할당된 구멍 슬롯 / 이형이 있는 경우 프롬프트 탄창을 생성하는 슬래브 재료가 재료에 들어가지 않는 판재를 지정합니다.',
    bur: 'သတ်မှတ်ပေါ်ဒ်ငယ်ပစ္စည်းမဖြတ်သောပြား၊ ထွင်းစက်သို့အပေါက်ချောင်း/အသွင်တာဝန်ပေးသည့်အခါအကြံပြုပေါ်ပြ',
    ben: 'নির্দিষ্ট ছোট বোর্ড উপকরণ কাটা হয় না এমন প্লেটে, এনগ্রেভিং মেশিনে অ্যাসাইন করা হোল/স্লট/শেপ থাকলে প্রম্পট পপআপ তৈরি হবে',
    tr: 'Kesilmeyen küçük plaka malzemesinde oyma makinesine atanmış delik/oluk/şekil varken uyarı göster',
    km: 'បង្ហាញព្រមានពេលផ្ទាំងតូចដែលមិនកាត់មានរណ្តៅ/រណ្តៅ/រូបរាងចាត់ទៅម៉ាស៊ីនចុកចាក់',
    es: 'Se genera una ventana emergente cuando el material de la placa pequeña no está cortado y hay agujeros/formas especiales asignadas al grabado máquina',
    ar: 'يتم إنشاء نافذة منبثقة سريعة عندما لا يتم قطع مادة اللوحة الصغيرة، وهناك ثقوب/أشكال خاصة مخصصة لها آلة النقش',
  },
  'moreSettings.surpTagThresholdTextHalf1': {
    zh: '当余料（非裁剪余料）面积小于',
    en: 'When the area of the surplus material (not cutting surplus material) is less than',
    id: 'Apabila luas sisa bahan (bukan sisa pemotongan) kurang dari',
    kz: 'Кiçik бөлік материалының (кесілген көппе материалынан бөлік) аянты',
    th: 'หากพื้นที่สี่เหลี่ยมผืนผ้าของสิ่งที่เหลือจากการตัดสวิตช์น้อยกว่า',
    ug: 'قالدۇق ماتېرىيال (كېسىلمىگەن قالدۇق) يەر كۆلىمى',
    vi: 'Khi diện tích của vật liệu thừa (không phải vật liệu thừa sau khi cắt) nhỏ hơn',
    zh_tc: '當餘料（非裁剪餘料）面積小於',
    ru: 'Когда остаточная (не обрезанная) площадь меньше',
    ko: '남은 재료 (비재단 남은 재료) 면적이',
    bur: 'ပိုလျှံ(ဖြတ်မဟုတ်သောပိုလျှံ)ဧရိယာသည်ထို့ထက်ငယ်သည့်အခါ',
    ben: 'যখন উদ্বৃত্ত উপকরণের (কাটিং নয়) ক্ষেত্রফল এর চেয়ে কম',
    tr: 'Artık malzeme (kesim artığı değil) alanı şundan küçük olduğunda',
    km: 'ពេលផ្ទៃសម្ភារៈសល់ (មិនមែនសល់កាត់) តូចជាង',
    es: 'Cuando el área del material remanente (material remanente no cortado) es menor que',
    ar: 'عندما تكون مساحة المادة المتبقية (المواد المتبقية غير المقطوعة) أقل من',
  },
  'moreSettings.surpTagThresholdTextHalf2': {
    zh: '不生成余料标签',
    en: ' do not generate a surplus material label',
    id: 'Tidak menghasilkan label sisa',
    kz: 'дан кішкентай болганда, бөлік материалының таңбағын жасамай.',
    th: 'ไม่สร้างแท็กวัสดุเหลือใช้',
    ug: 'دىكىن چىقىرىلغاندا قالدۇق ماتېرىيال بەلگىسى ھاسىل قىلمايدۇ',
    vi: 'không tạo nhãn hiệu vật liệu thừa',
    zh_tc: '不生成餘料標籤',
    ru: 'Не создавать этикетку остаточного материала',
    ko: '남은 재료 라벨 생성 안 함',
    bur: 'ပိုလျှံတံဆိပ်မဖန်တီး',
    ben: 'উদ্বৃত্ত উপকরণ লেবেল তৈরি করবেন না',
    tr: 'artık malzeme etiketi oluşturulmaz',
    km: 'មិនបង្កើតស្លាកសម្ភារៈសល់',
    es: 'No genere etiquetas de material residual',
    ar: 'لا تقم بإنشاء ملصقات للمواد المتبقية',
  },
  'moreSettings.innerShapeToolMatch': {
    zh: '雕刻机加工内部异形自动选择合适刀具',
    en: 'Carving machine automatically selects the appropriate tool for internal irregular shapes',
    id: 'Mesin ukiran memilih alat yang sesuai untuk memproses bentuk internal tidak rata',
    kz: 'Кескіш машинасында ішкі кескіш бөлшектердің өңдеуі үшін қажетті құралды автоматты түрде таңдайды',
    th: 'เครื่องตัดสวิตช์อัตโนมัติเลือกเครื่องมือที่เหมาะสมสำหรับการประมวลผลรูปร่างภายในที่ไม่ราบ',
    ug: 'كېسىش ئۈسكۈنىسىدىكى تاختا ئۆزگىچە شەكىللىك بۆلەكلەرنى ئىشلەش',
    vi: 'Máy khắc tự động chọn công cụ phù hợp cho các hình dạng bên trong không phẳng',
    zh_tc: '雕刻機加工內部異形自動選擇合適刀具',
    ru: 'Скульптор обрабатывает внутреннюю фасон автоматически выбирая подходящий инструмент',
    ko: '조각기 가공 내부 이형 자동 선택 적합한 공구',
    bur: 'ထွင်းစက်အတွင်းအသွင်အတွက်သင့်လျော်သောကိရိယာအလိုအလျောက်ရွေး',
    ben: 'ক্যারভিং মেশিন ভিতরের অনিয়মিত শেপের জন্য উপযুক্ত টুল অটোমেটিক সিলেক্ট করে',
    tr: 'Oyma makinesi iç düzensiz şekiller için uygun takımı otomatik seçer',
    km: 'ម៉ាស៊ីនចុកចាក់ជ្រើសឧបករណ៍សមស្របស្វ័យប្រវត្តិសម្រាប់រូបរាងមិនទៀងខាងក្នុង',
    es: 'La máquina de grabado selecciona automáticamente la herramienta adecuada para procesar formas especiales internas',
    ar: 'تقوم آلة النقش تلقائيًا بتحديد الأداة المناسبة لمعالجة الأشكال الخاصة الداخلية',
  },
  'moreSettings.innerShapeToolMatchTip': {
    zh: '(雕刻机加工比下料刀直径小的内部异形，出现尺寸错误无法加工的情况时可启用此功能)',
    en: '（When the carving machine processes internal irregular shapes smaller than the cutting tool diameter, the size error cannot be processed. This function can be enabled to solve the problem）',
    id: '（Ketika mesin ukiran memproses bentuk internal yang lebih kecil dari diameter alat pemotong, ukuran kesalahan tidak dapat diproses. Fungsi ini dapat diaktifkan untuk memecahkan masalah）',
    kz: 'Кескіш машинасында ішкі кескіш бөлшектердің өңдеуі үшін қажетті құралды автоматты түрде таңдайды',
    th: '（เมื่อเครื่องตัดประมวลผลรูปร่างภายในที่มีขนาดเล็กกว่ารัศมีของเครื่องมือตัดสวิตช์จะไม่สามารถประมวลผลได้ ฟังก์ชั่นนี้สามารถเปิดใช้งานเพื่อแก้ไขปัญหา）',
    ug: '（كېسىش ئۈسكۈنىسىدىكى تاختا ئۆزگىچە شەكىللىك بۆلەكلەرنى ئىشلەش）',
    vi: '（Khi máy khắc xử lý các hình dạng bên trong nhỏ hơn đường kính của công cụ cắt, kích thước lỗ không thể được xử lý. Chức năng này có thể được bật để giải quyết vấn đề）',
    zh_tc:
      '（雕刻機加工比下料刀直徑小的內部異形，出現尺寸錯誤無法加工的情況時可啟用此功能）',
    ru: '(Скульптор обрабатывает внутреннюю фасонку с меньшим диаметром, чем резец, и эта функция может быть включена, если ошибка размера не может быть обработана)',
    ko: '(조각기 가공은 원단보다 지름이 작은 내부 이형으로 치수 오류로 가공할 수 없는 경우 활성화할 수 있습니다.)',
    bur: '(ထွင်းစက်ဖြတ်ကိရိယာအချင်းထက်သေးသောအတွင်းအသွင်ကိုပြုသည့်အခါအရွယ်အမှားမပြုနိုင်ပါက ဤလုပ်ဆောင်ချက်ဖွင့်နိုင်)',
    ben: '(ক্যারভিং মেশিন কাটিং টুল ব্যাসের চেয়ে ছোট ভিতরের অনিয়মিত শেপ প্রসেস করলে সাইজ এরর প্রসেস করা যায় না, এই ফাংশন চালু করে সমাধান করা যাবে)',
    tr: '(İç düzensiz şekil, kesim takım çapından küçük olduğunda boyut hatası/işlenememe olursa bu özellik açılabilir)',
    km: '(ពេលរូបរាងមិនទៀងខាងក្នុងតូចជាងអង្កត់ផ្ចិតមុខកាត់ ហើយមានកំហុសទំហំ/មិនអាចដំណើរការ អាចបើកមុខងារនេះ)',
    es: '(La máquina de grabado procesa formas especiales internas con un diámetro más pequeño que la cuchilla de corte. Esta función se puede habilitar cuando ocurre un error de tamaño y no se puede procesar)',
    ar: '(تقوم آلة النقش بمعالجة الأشكال الخاصة الداخلية بقطر أصغر من سكين التقطيع. يمكن تمكين هذه الوظيفة عند حدوث خطأ في الحجم ولا يمكن معالجتها)',
  },
  'moreSettings.innerShapeToolMatchTip2': {
    zh: '注意：启用后将会使用最小铣槽刀，请合理设置最小铣槽刀的"刀具长度"和"单次最大加工深度”,仅在云排版生效',
    en: 'Attention: After enabling, the carving machine will use the smallest slot cutter, please set the "tool length" and "maximum single processing depth" of the smallest slot cutter carefully, only valid in cloud settings',
    id: 'Catatan: Setelah diaktifkan, mesin ukiran akan menggunakan pisau slot terkecil, silakan atur "panjang pisau" dan "kedalaman maksimum pemrosesan tunggal" pisau slot terkecil dengan hati-hati, hanya berlaku di pengaturan cloud',
    kz: 'Ескерту: Қосылғаннан кейін, кескіш машинасы ең кіші қапшық құралын қолданады, қапшық құралының "қапшық ұзындығы" және "бір реттік ең үлкен өңдеу тереңдігі" параметрлерін қалайсыз, тек қана қалқымалы типтеуде қолданылады',
    th: 'หมายเหตุ: หลังจากเปิดใช้งาน เครื่องตัดจะใช้เครื่องมือตัดสวิตช์ที่มีขนาดเล็กที่สุด โปรดตั้งค่า "ความยาวของเครื่องมือ" และ "ความลึกการประมวลผลสูงสุดของมีด" ของเครื่องมือตัดสวิตช์ที่มีขนาดเล็กที่สุดอย่างระมัดระวัง มีผลกับการตั้งค่าในระบบคลาวด์เท่านั้น',
    ug: 'ئاگاھلاندۇرۇش: قوزغىتىلغاندىن كېيىن، كېسىش ئۈسكۈنىسى ھەرپ قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇ',
    vi: 'Lưu ý: Sau khi bật, máy khắc sẽ sử dụng công cụ cắt có kích thước nhỏ nhất, vui lòng thiết lập cẩn thận "chiều dài công cụ" và "độ sâu tối đa của công cụ" của công cụ cắt có kích thước nhỏ nhất, chỉ có hiệu lực trong cài đặt cloud',
    zh_tc:
      '注意：啟用後將會使用最小銑槽刀，請合理設定最小銑槽刀的"刀具長度"和"單次最大加工深度"，僅在雲排版生效',
    ru: 'Примечание: После включения будет использоваться наименьшая фреза, пожалуйста, разумно установите минимальную фрезу "длина инструмента" и "однократную максимальную глубину обработки", только в облачной типографии',
    ko: '참고: 사용으로 설정하면 최소 밀링 슬롯 공구가 사용됩니다. 최소 밀링 슬롯 공구의 공구 길이와 단일 최대 가공 깊이를 적절하게 설정하여 클라우드 레이아웃에만 적용합니다.',
    bur: 'သတိပြု-ဖွင့်ပြီးနောက်အနည်းဆုံးမီးလ်လင်ချောင်းကိရိယာသုံးမည်၊ အနည်းဆုံးမီးလ်လင်ချောင်းကိရိယာအလျားနှင့်အကြိမ်တစ်ချက်အများဆုံးပြုအနက်သတ်မှတ်ပါ၊ ကလောက်ဒ်ပြင်ဆင်တွင်သာသက်ရောက်',
    ben: 'নোট: চালু করার পর ক্যারভিং মেশিন সবচেয়ে ছোট স্লট কাটার ব্যবহার করবে, সবচেয়ে ছোট স্লট কাটারের টুল লেন্থ ও ম্যাক্স সিঙ্গেল প্রসেসিং ডেপথ সাবধানে সেট করুন, শুধুমাত্র ক্লাউড সেটিংসে ভ্যালিড',
    tr: 'Dikkat: Açıldığında en küçük oluk frezesi kullanılır; en küçük oluk frezesinin takım uzunluğu ve tek seferde maksimum işleme derinliğini uygun ayarlayın; yalnızca bulut dizgide geçerlidir',
    km: 'ចំណាំ៖ បន្ទាប់ពីបើកនឹងប្រើមុខកាត់រណ្តៅតូបតូចបំផុត សូមកំណត់ប្រវែងឧបករណ៍ និងជម្រៅដំណើរការអតិបរមាក្នុងមួយដងឱ្យសមរម្យ មានប្រសិទ្ធភាពតែក្នុងការរៀបចំក្លោដ',
    es: 'Nota: Después de habilitarla, se utilizará la fresa de ranura más pequeña. Configure razonablemente la "longitud de la herramienta" y la "profundidad de procesamiento máxima única" de la fresa de ranura más pequeña. Solo tiene efecto en el diseño de la nube',
    ar: 'ملاحظة: بعد التمكين، سيتم استخدام أصغر قطع فتحة الطحن. يرجى ضبط "طول الأداة" و"أقصى عمق معالجة فردي" لأصغر قاطعة طحن ذات فتحة معقولة. يسري مفعوله فقط في التخطيط السحابي',
  },
  'moreSettings.surNotLayout': {
    zh: '定义余料大板不排指定板件',
    en: 'Define the excess material large board without arranging specified board components',
    id: 'Mendefinisikan sisa papan besar tanpa menyusun papan yang ditentukan',
    kz: 'Мәтінің қазақша аудармасы: “Қалдық үлкен тақтайлар белгілі бір тақтай бөлшектерін орналастырмайды',
    th: 'กำหนดส่วนที่เหลือ แผ่นใหญ่ไม่แถวชิ้นส่วนแผ่นที่ระบุ',
    ug: 'ئابىرىز بۇلغان يۇقىرى پانېللەرنىڭ ئەھمىيەتلىك پارچىلارىنى تەقدىم قىلمايدىغان قايدە',
    vi: 'Định nghĩa: Cốp pha thừa lớn không bố trí theo bộ phận chỉ định',
    zh_tc: '定義餘料大板不排指定板件',
    ru: 'Определить остаточную пластину',
    ko: '남은 재료를 정의하는 대판은 지정된 판재를 배열하지 않는다',
    bur: 'ပိုလျှံပေါ်ဒ်ကြီးတွင်သတ်မှတ်ပြားမစီအောင်သတ်မှတ်',
    ben: 'উদ্বৃত্ত বড় বোর্ড নির্দিষ্ট বোর্ড কম্পোনেন্ট না সাজিয়ে সংজ্ঞায়িত করুন',
    tr: 'Artık büyük plakada belirtilen plaka parçalarını yerleştirme',
    km: 'កំណត់ផ្ទាំងធំសល់មិនរៀបផ្ទាំងដែលបានចង្អុលចោទ',
    es: 'La definición de una placa grande con material residual no alinea la placa especificada.',
    ar: 'تحديد لوحة كبيرة تحتوي على مادة متبقية لا يؤدي إلى محاذاة اللوحة المحددة.',
  },
  'moreSettings.surNotLayoutTip': {
    zh: '开启后1.余料大板不能排小板名称包含下方名称的小板 2.在排版时可以选择本次排版是否生效该功能',
    en: 'After activation, 1. The leftover large board cannot be arranged, and the name of the small board containing the name below. 2. During typesetting, you can choose whether this function will be effective for this typesetting',
    id: 'Setelah diaktifkan 1. Papan besar sisa tidak dapat menyusun papan kecil yang berisi nama di bawah ini 2. Anda dapat memilih apakah tipografi ini berfungsi saat tipografi',
    kz: 'Ашылғаннан кейін: 1. Қалдықтың үлкен тақтасында кіші тақталарды орнатпау керек, олардың атаулары төмендегі атауларды қамтиды. 2. Таңдау кезінде, бұл реттегі таңдаудың осы функцияларын қолдануды қолданушы таңдауы мүмкін.',
    th: 'หลังจากเปิด 1. แผ่นใหญ่ที่เหลือไม่สามารถจัดเรียงแผ่นเล็ก ๆ ที่มีชื่อด้านล่าง 2. เมื่อเรียงพิมพ์สามารถเลือกได้ว่าการพิมพ์นี้มีผลหรือไม่ฟังก์ชัน',
    ug: 'بەلگى ئاخىرىشىدىن:1.قالىقلانغان ئۇزۇن تېمىنىڭ ئىچىگە كىرگەن قىسىملىق تېمىلارنى قايتۇرۇشقا بۆلەكلىرى قوشۇلمىدۇ.2.تېمىلارنى تەرتىپ قويسىلغاندا، مۇۋاپىق بولغان تېمىلارنىڭ ئۇلارنى قوشۇش بىلەن بەلكە تەشۋىق قىلىش كېرەكلىكىنى تاللاش مۇمكىن.',
    vi: 'Sau khi bật:1.Các tấm lớn từ vật liệu thừa không được xếp các tấm nhỏ có tên chứa các tên bên dưới.2.Khi sắp xếp, bạn có thể chọn xem chức năng này có hiệu lực trong lần sắp xếp hiện tại hay không.',
    zh_tc:
      '開啟後1.餘料大板不能排小板名稱包含下方名稱的小板 2.在排版時可以選擇本次排版是否生效該功能',
    ru: 'После открытия 1. лист с остатками не может быть указан в списке с именами панелей с именами ниже. При наборе вы можете выбрать, вступает ли эта типография в силу.',
    ko: '오픈 후 1.여분 대판은 소판 이름을 배열할 수 없습니다.아래 이름의 소판을 포함합니다.2.조판 시 이번 조판에 이 기능이 적용되는지 여부를 선택할 수 있습니다',
    bur: 'ဖွင့်ပြီးနောက်၁.ပိုလျှံပေါ်ဒ်ကြီးတွင်အောက်ပါအမည်ပါပေါ်ဒ်ငယ်မစီနိုင် ၂.ပြင်ဆင်ချိန်တွင်ဤပြင်ဆင်တွင်ဤလုပ်ဆောင်ချက်သက်ရောက်မှုရွေးနိုင်',
    ben: 'চালু করার পর ১.উদ্বৃত্ত বড় বোর্ডে নিচের নামযুক্ত ছোট বোর্ড সাজানো যাবে না ২.টাইপসেটিংয়ের সময় এই টাইপসেটিংয়ে এই ফাংশন কার্যকর কিনা বেছে নিতে পারবেন',
    tr: 'Açılınca: 1) Artık büyük plaka, aşağıdaki adları içeren küçük plakaları sıraya alamaz. 2) Dizgi sırasında bu işlevin bu sefer geçerli olup olmayacağını seçebilirsiniz',
    km: 'បន្ទាប់ពីបើក៖ ១) ផ្ទាំងធំសល់មិនអាចរៀបផ្ទាំងតូចដែលមានឈ្មោះខាងក្រោម ២) ពេលរៀបចំអាចជ្រើសថាមុខងារនេះអនុវត្តសម្រាប់ដងនេះឬអត់',
    es: 'Después de abrir, 1. El material restante no se puede colocar en el plato grande. El nombre de la placa pequeña contiene el nombre a continuación. 2. Al componer, puede elegir si esta función es válida para esta composición',
    ar: 'بعد الفتح، 1. لا يمكن ترتيب المواد المتبقية في اللوحة الكبيرة. يحتوي اسم اللوحة الصغيرة على الاسم أدناه. 2. عند التنضيد، يمكنك اختيار ما إذا كانت هذه الوظيفة صالحة لهذا التنضيد',
  },
  'moreSettings.addPlank': {
    zh: '添加板件名',
    en: 'Add board name',
    id: 'Tambahkan Nama Papan',
    kz: 'Қосымша тақтай атауын қосу',
    th: 'เพิ่มชื่อบอร์ด',
    ug: 'بۈلگۈ ناھىيىسى قوشۇش',
    vi: 'Thêm tên tấm ván',
    zh_tc: '添加板件名',
    ru: 'Добавить имя панели',
    ko: '보드 이름 추가',
    bur: 'ပြားအမည်ထည့်',
    ben: 'বোর্ডের নাম যোগ করুন',
    tr: 'Plaka adı ekle',
    km: 'បន្ថែមឈ្មោះផ្ទាំង',
    es: 'Agregar un nombre de placa',
    ar: 'أضف اسم لوحة',
  },
  'moreSettings.addPlankTip': {
    zh: '至少添加一个小板名称',
    en: 'Add at least one board name',
    id: 'Menambahkan setidaknya satu nama panel kecil',
    kz: 'Taqyrybyń engizu üshin kem degende bir kischikentay taqyrybyń engiziniz',
    th: 'เพิ่มชื่อกระดานขนาดเล็กอย่างน้อยหนึ่งชื่อ',
    ug: 'كەم ئىكەنلىكىدىن بىر يېخشىمە پانېل ئاتىنى قوشۇڭ',
    vi: 'Tối thiểu hãy thêm tên của một tấm nhỏ',
    zh_tc: '至少添加一個小板名稱',
    ru: 'Добавить хотя бы одно имя',
    ko: '보드 이름 하나 이상 추가',
    bur: 'အနည်းဆုံးပေါ်ဒ်ငယ်အမည်တစ်ခုထည့်ပါ',
    ben: 'কমপক্ষে একটি ছোট বোর্ডের নাম যোগ করুন',
    tr: 'En az bir küçük plaka adı ekleyin',
    km: 'បន្ថែមឈ្មោះផ្ទាំងតូចយ៉ាងហោចណាស់មួយ',
    es: 'Agregar al menos un nombre de placa pequeña',
    ar: 'أضف اسم لوحة صغيرة واحدة على الأقل',
  },
  'moreSettings.thisInput': {
    zh: '这里输入',
    en: 'Enter here',
    id: 'Masukkan di sini',
    kz: 'Бұл жерде енгізу',
    th: 'ป้อนที่นี่',
    ug: 'ئۇنۇتماقچى',
    vi: 'Nhập ở đây',
    zh_tc: '這裡輸入',
    ru: 'введите здесь',
    ko: '여기 입력',
    bur: 'ဤနေရာတွင်ထည့်ပါ',
    ben: 'এখানে লিখুন',
    tr: 'Buraya girin',
    km: 'បញ្ចូលនៅទីនេះ',
    es: 'Ingrese aquí',
    ar: 'أدخل هنا',
  },
  'moreSettings.surNotLayoutMat': {
    zh: '余料不排指定小板',
    en: 'Surplus materials are not arranged on designated small boards',
    id: 'Sisa tidak menyusun papan kecil',
    kz: 'Қалдық құбырда белгіленген кіші тақтайша түсіру қажет емес',
    th: 'ส่วนที่เหลือไม่ใช่แถวระบุแผ่นเล็ก ๆ',
    ug: 'قالمىغان ماتېرىياللارنى ئىپادىلەشتۈرۈمەسلىكە ئەھمىيەتلىك كىچىك پارچىلارنى چىقارمايلى',
    vi: 'Cắt bỏ vật liệu thừa, không đặt các tấm nhỏ được chỉ định',
    zh_tc: '餘料不排指定小板',
    ru: 'Оставшийся материал не указан на доске',
    ko: '남은 재료는 지정된 판자를 배열하지 않는다.',
    bur: 'ပိုလျှံသည်သတ်မှတ်ပေါ်ဒ်ငယ်မစီ',
    ben: 'উদ্বৃত্ত নির্দিষ্ট ছোট বোর্ডে সাজানো হয় না',
    tr: 'Artık malzeme belirtilen küçük plakalara yerleştirilmez',
    km: 'សម្ភារៈសល់មិនរៀបលើផ្ទាំងតូចដែលបានកំណត់',
    es: 'El material restante no está dispuesto para especificar una placa pequeña',
    ar: 'لم يتم ترتيب المادة المتبقية لتحديد لوحة صغيرة',
  },
  'moreSettings.subTagSetting': {
    zh: '小板副标签设置',
    en: 'Small Panel Sub Label Settings',
    id: 'Pengaturan label sekunder papan kecil',
    kz: 'Шағын тақта қосалқы белгісін орнату',
    th: 'ตั้งค่าป้ายรองของแผ่นเล็ก',
    ug: 'كىچىك تاختا قوشۇمچە بەلگە تەڭشىكى',
    vi: 'Cài đặt nhãn phụ tấm nhỏ',
    zh_tc: '小板副標籤設置',
    ru: 'Настройки дополнительной этикетки малой плиты',
    ko: '소판 부 라벨 설정',
    bur: 'အကွက်ငယ် အရန်တံဆိပ် ဆက်တင်',
    ben: 'ছোট প্যানেলের সাব লেবেল সেটিং',
    tr: 'Küçük levha alt etiketi ayarları',
    km: 'ការកំណត់ស្លាកបន្ទាប់ផ្ទាំងតូច',
    es: 'Configuración de etiqueta secundaria de panel pequeño',
    ar: 'إعدادات الملصق الثانوي للوح الصغير',
  },
  'moreSettings.subTagDataSource': {
    zh: '设置副标签生成的生效数据源',
    en: 'Set Effective Data Sources for Sub Label Generation',
    id: 'Atur sumber data efektif untuk pembuatan label sekunder',
    kz: 'Қосалқы белгі жасаудың қолданылатын дереккөзін орнату',
    th: 'ตั้งค่าแหล่งข้อมูลที่มีผลสำหรับการสร้างป้ายรอง',
    ug: 'قوشۇمچە بەلگە ھاسىل قىلىشقا كۈچكە ئىگە سانلىق مەلۇمات مەنبەسىنى تەڭشەش',
    vi: 'Thiết lập nguồn dữ liệu hiệu lực cho việc tạo nhãn phụ',
    zh_tc: '設置副標籤生成的生效數據源',
    ru: 'Настройка действующего источника данных для генерации дополнительной этикетки',
    ko: '부 라벨 생성에 적용할 데이터 소스 설정',
    bur: 'အရန်တံဆိပ် ထုတ်လုပ်ရန် အကျိုးသက်ရောက်သော ဒေတာရင်းမြစ် သတ်မှတ်ရန်',
    ben: 'সাব লেবেল তৈরির কার্যকর ডেটা সোর্স সেট করুন',
    tr: 'Alt etiket oluşturma için geçerli veri kaynağını ayarla',
    km: 'កំណត់ប្រភពទិន្នន័យដែលមានប្រសិទ្ធភាពសម្រាប់ការបង្កើតស្លាកបន្ទាប់',
    es: 'Configurar la fuente de datos efectiva para la generación de etiqueta secundaria',
    ar: 'تعيين مصدر البيانات الفعال لإنشاء الملصق الثانوي',
  },
  'moreSettings.subTagDataSourceTip': {
    zh: '开启后可以把控制副标签生成的数据源添加进来，当副标签上有该数据源时，且数据源存在值时，就会生成副标签',
    en: 'After enabling, you can add data sources that control sub-label generation. A sub-label is generated when the sub-label contains that data source and the data source has a value.',
    id: 'Setelah diaktifkan, Anda dapat menambahkan sumber data yang mengontrol pembuatan label sekunder. Label sekunder akan dibuat jika label sekunder memiliki sumber data tersebut dan sumber data memiliki nilai.',
    kz: 'Қосқаннан кейін қосалқы белгі жасауды басқаратын дереккөздерді қосуға болады. Қосалқы белгіде сол дереккөз болса және дереккөзде мән болса, қосалқы белгі жасалады.',
    th: 'เมื่อเปิดใช้งาน สามารถเพิ่มแหล่งข้อมูลที่ควบคุมการสร้างป้ายรองได้ เมื่อป้ายรองมีแหล่งข้อมูลนั้นและแหล่งข้อมูลมีค่า จะสร้างป้ายรอง',
    ug: 'ئېچىلغاندىن كېيىن قوشۇمچە بەلگە ھاسىل قىلىشنى كونترول قىلىدىغان سانلىق مەلۇمات مەنبەسىنى قوشالايسىز. قوشۇمچە بەلگىدە بۇ مەنبە بولسا ۋە مەنبەدە قىممەت بولسا، قوشۇمچە بەلگە ھاسىل بولىدۇ.',
    vi: 'Sau khi bật, bạn có thể thêm nguồn dữ liệu điều khiển việc tạo nhãn phụ. Khi nhãn phụ có nguồn dữ liệu đó và nguồn dữ liệu có giá trị, nhãn phụ sẽ được tạo.',
    zh_tc:
      '開啟後可以把控制副標籤生成的數據源添加進來，當副標籤上有該數據源時，且數據源存在值時，就會生成副標籤',
    ru: 'После включения можно добавить источники данных, управляющие генерацией дополнительной этикетки. Дополнительная этикетка создается, если на ней есть этот источник данных и у источника есть значение.',
    ko: '활성화하면 부 라벨 생성을 제어하는 데이터 소스를 추가할 수 있습니다. 부 라벨에 해당 데이터 소스가 있고 값이 있으면 부 라벨이 생성됩니다.',
    bur: 'ဖွင့်ပြီးနောက် အရန်တံဆိပ် ထုတ်လုပ်မှုကို ထိန်းချုပ်သော ဒေတာရင်းမြစ်များကို ထည့်နိုင်သည်။ အရန်တံဆိပ်တွင် ထိုဒေတာရင်းမြစ်ရှိပြီး တန်ဖိုးရှိပါက အရန်တံဆိပ် ထုတ်လုပ်မည်။',
    ben: 'চালু করার পর সাব লেবেল তৈরি নিয়ন্ত্রণকারী ডেটা সোর্স যোগ করা যায়। সাব লেবেলে সেই ডেটা সোর্স থাকলে এবং মান থাকলে সাব লেবেল তৈরি হবে।',
    tr: 'Açıldıktan sonra alt etiket oluşturmayı kontrol eden veri kaynakları eklenebilir. Alt etikette bu veri kaynağı varsa ve değeri varsa alt etiket oluşturulur.',
    km: 'បន្ទាប់ពីបើក អ្នកអាចបន្ថែមប្រភពទិន្នន័យដែលគ្រប់គ្រងការបង្កើតស្លាកបន្ទាប់។ នៅពេលស្លាកបន្ទាប់មានប្រភពទិន្នន័យនោះ និងមានតម្លៃ ស្លាកបន្ទាប់នឹងត្រូវបានបង្កើត។',
    es: 'Tras activarlo, puede añadir fuentes de datos que controlan la generación de la etiqueta secundaria. Se genera cuando la etiqueta secundaria tiene esa fuente y la fuente tiene un valor.',
    ar: 'بعد التفعيل يمكن إضافة مصادر بيانات تتحكم في إنشاء الملصق الثانوي. يُنشأ الملصق الثانوي عندما يحتوي على مصدر البيانات هذا ويكون للمصدر قيمة.',
  },
  'moreSettings.addSubTagDataSource': {
    zh: '添加数据源',
    en: 'Add Data Source',
    id: 'Tambah Sumber Data',
    kz: 'Дереккөз қосу',
    th: 'เพิ่มแหล่งข้อมูล',
    ug: 'سانلىق مەلۇمات مەنبەسى قوشۇش',
    vi: 'Thêm nguồn dữ liệu',
    zh_tc: '添加數據源',
    ru: 'Добавить источник данных',
    ko: '데이터 소스 추가',
    bur: 'ဒေတာရင်းမြစ် ထည့်ရန်',
    ben: 'ডেটা সোর্স যোগ করুন',
    tr: 'Veri kaynağı ekle',
    km: 'បន្ថែមប្រភពទិន្នន័យ',
    es: 'Agregar fuente de datos',
    ar: 'إضافة مصدر بيانات',
  },
  'moreSettings.addSubTagDataSourceTip': {
    zh: '不允许添加重复数据源',
    en: 'Duplicate data sources are not allowed',
    id: 'Sumber data duplikat tidak diizinkan',
    kz: 'Қайталанатын дереккөз қосуға болмайды',
    th: 'ไม่อนุญาตให้เพิ่มแหล่งข้อมูลซ้ำ',
    ug: 'تەكرار سانلىق مەلۇمات مەنبەسى قوشۇشقا بولمايدۇ',
    vi: 'Không cho phép thêm nguồn dữ liệu trùng lặp',
    zh_tc: '不允許添加重複數據源',
    ru: 'Нельзя добавлять повторяющиеся источники данных',
    ko: '중복 데이터 소스는 추가할 수 없습니다',
    bur: 'ထပ်နေသော ဒေတာရင်းမြစ် ထည့်၍မရပါ',
    ben: 'ডুপ্লিকেট ডেটা সোর্স যোগ করা যাবে না',
    tr: 'Yinelenen veri kaynağı eklenemez',
    km: 'មិនអនុញ្ញាតឱ្យបន្ថែមប្រភពទិន្នន័យស្ទួន',
    es: 'No se permite agregar fuentes de datos duplicadas',
    ar: 'لا يُسمح بإضافة مصادر بيانات مكررة',
  },
  'moreSettings.addSubTagDataSourceTip1': {
    zh: '请至少添加一个数据源',
    en: 'Please add at least one data source',
    id: 'Silakan tambahkan setidaknya satu sumber data',
    kz: 'Кемінде бір дереккөз қосыңыз',
    th: 'โปรดเพิ่มแหล่งข้อมูลอย่างน้อยหนึ่งรายการ',
    ug: 'كەم دېگەندە بىر سانلىق مەلۇمات مەنبەسى قوشۇڭ',
    vi: 'Vui lòng thêm ít nhất một nguồn dữ liệu',
    zh_tc: '請至少添加一個數據源',
    ru: 'Добавьте хотя бы один источник данных',
    ko: '데이터 소스를 하나 이상 추가하세요',
    bur: 'အနည်းဆုံး ဒေတာရင်းမြစ် တစ်ခု ထည့်ပါ',
    ben: 'অন্তত একটি ডেটা সোর্স যোগ করুন',
    tr: 'Lütfen en az bir veri kaynağı ekleyin',
    km: 'សូមបន្ថែមប្រភពទិន្នន័យយ៉ាងហោចណាស់មួយ',
    es: 'Agregue al menos una fuente de datos',
    ar: 'يرجى إضافة مصدر بيانات واحد على الأقل',
  },
  'moreSettings.addSubTagDataSourceTip2': {
    zh: '数据源不能为空，请选择',
    en: 'Data source cannot be empty, please select',
    id: 'Sumber data tidak boleh kosong, silakan pilih',
    kz: 'Дереккөз бос болмауы керек, таңдаңыз',
    th: 'แหล่งข้อมูลต้องไม่ว่าง โปรดเลือก',
    ug: 'سانلىق مەلۇمات مەنبەسى بوش بولماسلىقى كېرەك، تاللاڭ',
    vi: 'Nguồn dữ liệu không được để trống, vui lòng chọn',
    zh_tc: '數據源不能為空，請選擇',
    ru: 'Источник данных не может быть пустым, выберите значение',
    ko: '데이터 소스는 비워둘 수 없습니다. 선택하세요',
    bur: 'ဒေတာရင်းမြစ် အလွတ်မဖြစ်ရပါ၊ ရွေးချယ်ပါ',
    ben: 'ডেটা সোর্স খালি রাখা যাবে না, অনুগ্রহ করে নির্বাচন করুন',
    tr: 'Veri kaynağı boş olamaz, lütfen seçin',
    km: 'ប្រភពទិន្នន័យមិនអាចទទេបានទេ សូមជ្រើសរើស',
    es: 'La fuente de datos no puede estar vacía, selecciónela',
    ar: 'لا يمكن أن يكون مصدر البيانات فارغًا، يرجى الاختيار',
  },
  'lineManager.add': {
    zh: '添加生产线',
    en: 'Add Production Line',
    id: 'Tambahkan jalur produksi',
    kz: 'Өндіріс желісіні қосу',
    th: 'เพิ่มสายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيىسى قوشۇش',
    vi: 'Thêm dây chuyền sản xuất',
    zh_tc: '添加生產線',
    ru: 'Добавить производственную линию',
    ko: '생산라인 추가',
    bur: 'ထုတ်လုပ်မှုလိုင်းထည့်',
    ben: 'প্রোডাকশন লাইন যোগ করুন',
    tr: 'Üretim hattı ekle',
    km: 'បន្ថែមខ្សែផលិតកម្ម',
    es: 'Agregar una línea de producción',
    ar: 'أضف خط إنتاج',
  },
  'lineManager.engraving': {
    zh: '开料设备',
    en: 'Cutting Equipment',
    id: 'Peralatan pemotongan',
    kz: 'Кескіш машина',
    th: 'อุปกรณ์ตัด',
    ug: 'كېسىش ئۈسكۈنىسى',
    vi: 'Thiết bị cắt gọt',
    zh_tc: '開料設備',
    ru: 'Загрузочное оборудование',
    ko: '원료 공급 설비',
    bur: 'ဖြတ်တောက်စက်ပစ္စည်း',
    ben: 'কাটিং ইকুইপমেন্ট',
    tr: 'Kesim ekipmanı',
    km: 'ឧបករណ៍កាត់',
    es: 'Equipo de corte',
    ar: 'معدات القطع',
  },
  'lineManager.holeSlotEquip': {
    zh: '孔槽加工设备',
    en: 'H&S Equipment',
    id: 'Peralatan pemrosesan slot lubang',
    kz: 'Тесік және слотты өңдеу машина',
    th: 'อุปกรณ์แปรรูปช่องเสียบหลุม',
    ug: 'تېشىك/ئويۇق ئىشلەش ئۈسكۈنىسى',
    vi: 'Thiết bị gia công lỗ và khe',
    zh_tc: '孔槽加工設備',
    ru: 'Оборудование для обработки отверстий',
    ko: '구멍 슬롯 가공 장치',
    bur: 'အပေါက်ချောင်းပြုပြင်စက်',
    ben: 'H&S ইকুইপমেন্ট',
    tr: 'Delik ve oluk işleme ekipmanı',
    km: 'ឧបករណ៍ដំណើរការរណ្តៅ និងរណ្តៅ',
    es: 'Equipo de procesamiento de orificios',
    ar: 'معدات معالجة الفتحات',
  },
  'lineManager.workSetting': {
    zh: '加工设置',
    en: 'Processing Settings',
    id: 'Pengaturan pemrosesan',
    kz: 'Өңдеу параметрлер',
    th: 'การตั้งค่าการประมวลผล',
    ug: 'ئىشلەش تەڭشىكى',
    vi: 'Thiết lập gia công',
    zh_tc: '加工設置',
    ru: 'Параметры обработки',
    ko: '가공 설정',
    bur: 'ပြုပြင်ဆက်တင်',
    ben: 'প্রসেসিং সেটিংস',
    tr: 'İşleme ayarları',
    km: 'ការកំណត់ដំណើរការ',
    es: 'Configuraciones de procesamiento',
    ar: 'إعدادات المعالجة',
  },
  'lineManager.noUse': {
    zh: '未启用',
    en: 'Not Enabled',
    id: 'Tidak diaktifkan',
    kz: 'Қолданылмайды',
    th: 'ไม่เปิดใช้งาน',
    ug: 'قوزغىتىلمىغان',
    vi: 'Chưa kích hoạt',
    zh_tc: '未啟用',
    ru: 'не включен',
    ko: '활성화되지 않음',
    bur: 'မဖွင့်ရသေး',
    ben: 'সক্ষম নেই',
    tr: 'Etkin değil',
    km: 'មិនបានបើក',
    es: 'No habilitado',
    ar: 'غير ممكّنة',
  },
  'lineManager.warningTip': {
    zh: '* 注意：下列功能设置后，后续请不要在柜柜客户端设备对接页面进行保存，避免参数重置！',
    en: '* Attention: After setting the following functions, please do not save on the cabinet client device docking page to avoid resetting the parameters!',
    id: '* Catatan: Setelah mengatur fungsi -fungsi berikut, jangan simpan di halaman docking perangkat klien kabinet di masa depan untuk menghindari mengatur ulang parameter!',
    kz: '* Ескерту: Төмендегі функцияларды орнатқаннан кейін, кескіш клиенттерімен қосылу бетінде сақтамаңыз, параметрлерді қалпына келтіруге болмайды!',
    th: '* หมายเหตุ: หลังจากตั้งค่าฟังก์ชั่นต่อไปนี้โปรดอย่าบันทึกบนหน้าอุปกรณ์เชื่อมต่ออุปกรณ์ไคลเอนต์ตู้ในอนาคตเพื่อหลีกเลี่ยงการรีเซ็ตพารามิเตอร์!',
    ug: '* دىققەت: تۆۋەندىكى ئىقتىدارلارنى تەڭشەپ بولغاندىن كېيىن، كابىنېت كلېنت ئۈسكۈنىسىنى باغلاش بېتىدە ساقلاشنى قايتا قىلماڭ، پارامېتىرلارنىڭ قايتا تەڭشىلىشىدىن ساقلىنىڭ!',
    vi: '* Chú ý: Sau khi thiết lập các chức năng sau, vui lòng không lưu tại trang kết nối thiết bị của khách hàng Khung Khung để tránh thiết lập lại thông số!',
    zh_tc:
      '* 注意：下列功能設置後，後續請不要在櫃櫃客戶端設備對接頁面進行保存，避免參數重置！',
    ru: '* Примечание: После настройки следующих функций, пожалуйста, не сохраняйте страницу стыковки клиентского устройства шкафа, избегайте сброса параметров!',
    ko: '* 참고: 다음 기능을 설정한 후에는 캐비닛 클라이언트 장치 도킹 페이지에 저장하지 마십시오. 매개 변수 재설정을 피하십시오!',
    bur: '*သတိပြု-အောက်ပါလုပ်ဆောင်ချက်ဆက်တင်ပြီးနောက်ကက်ဘိနက်ကလိုင်းယင့်ဒီဗိုင်းစ်စာမျက်နှာတွင်မသိမ်းပါနှင့်၊ ပါရာမီတာပြန်ထားခြင်းကိုရှောင်ပါ!',
    ben: '*নোট: নিচের ফাংশন সেট করার পর ক্যাবিনেট ক্লায়েন্ট ডিভাইস ডকিং পেজে সেভ করবেন না, প্যারামিটার রিসেট এড়াতে!',
    tr: '* Dikkat: Aşağıdaki işlevler ayarlandıktan sonra dolap istemci cihaz eşleştirme sayfasında kaydetmeyin; parametre sıfırlanmasını önleyin!',
    km: '* ចំណាំ៖ បន្ទាប់ពីកំណត់មុខងារខាងក្រោម កុំរក្សាទុកនៅទំព័រភ្ជាប់ឧបករណ៍កម្មវិធីអតិថិជនទូ ដើម្បីជៀសវាងការកំណត់ប៉ារ៉ាម៉ែត្រឡើងវិញ!',
    es: '* Nota: Después de configurar las siguientes funciones, no las guarde en la página de acoplamiento del dispositivo cliente del gabinete para evitar el reinicio de parámetros.',
    ar: '* ملاحظة: بعد ضبط الوظائف التالية، يرجى عدم حفظها على صفحة إرساء جهاز عميل الخزانة لتجنب إعادة تعيين المعلمة!',
  },
  'lineManager.engravingSetting': {
    zh: '开料机设置',
    en: 'Cutting Machine Settings',
    id: 'Pengaturan mesin pemotong',
    kz: 'Кескіш машина параметрлер',
    th: 'การตั้งค่าเครื่องตัด',
    ug: 'كېسىش ئۈسكۈنىسى تەڭشىكى',
    vi: 'Thiết lập máy cắt gọt',
    zh_tc: '雕刻機設置',
    ru: 'Настройка открывающей машины',
    ko: '원료 공급기 설치',
    bur: 'ဖြတ်တောက်စက်ဆက်တင်',
    ben: 'কাটিং মেশিন সেটিংস',
    tr: 'Kesim makinesi ayarları',
    km: 'ការកំណត់ម៉ាស៊ីនកាត់',
    es: 'Configuración de la máquina cortadora',
    ar: 'إعدادات ماكينة القطع',
  },
  'lineManager.workWay': {
    zh: '加工方式',
    en: 'Processing Method',
    id: 'Metode pemrosesan',
    kz: 'Өңдеу әдісі',
    th: 'วิธีการประมวลผล',
    ug: 'ئىشلەش ئۇسۇلى',
    vi: 'Cách thức gia công',
    zh_tc: '加工方式',
    ru: 'Обработка',
    ko: '가공 방식',
    bur: 'ပြုပြင်နည်း',
    ben: 'প্রসেসিং মেথড',
    tr: 'İşleme yöntemi',
    km: 'វិធីដំណើរការ',
    es: 'Método de procesamiento',
    ar: 'طريقة المعالجة',
  },
  'lineManager.cutedSpecial': {
    zh: '加工的特殊孔槽：',
    en: 'Special Holes and Slots for Processing:',
    id: 'Slot lubang khusus untuk diproses:',
    kz: 'Өңделген тесік және слоттары:',
    th: 'ช่องโหว่พิเศษสำหรับการประมวลผล:',
    ug: 'ئىشلەنگەن ئالاھىدە تېشىك/ئويۇق:',
    vi: 'Lỗ và khe đặc biệt được gia công:',
    zh_tc: '加工的特殊孔槽：',
    ru: 'Специальные отверстия для обработки:',
    ko: '가공을 위한 특수 구멍 슬롯:',
    bur: 'ပြုပြင်သောအထူးအပေါက်ချောင်းများ:',
    ben: 'প্রসেসিংয়ের জন্য বিশেষ হোল ও স্লট:',
    tr: 'İşlenecek özel delik/oluklar:',
    km: 'រណ្តៅ និងរណ្តៅពិសេសសម្រាប់ដំណើរការ៖',
    es: 'Ranuras de orificios especiales procesadas:',
    ar: 'معالجة فتحات الفتحات الخاصة:',
  },
  'lineManager.noWork': {
    zh: '此选项对五/六面钻默认模板不生效',
    en: 'This option does not apply to the default template for five/six-sided drilling',
    id: 'Opsi ini tidak berlaku pada template default bor lima/enam sisi.',
    kz: 'Бұл параметр бес/алты таңбалау машинасының әдетті шаблонына әсер етпейді',
    th: 'ตัวเลือกนี้ไม่มีผลกับเทมเพลตเริ่มต้นของการฝึกซ้อมห้า/หกด้าน',
    ug: 'بۇ تاللاش بەش/ئالتە تەرەپلىك ماتور سۈكۈتتىكى قېلىپىغا تەسىر قىلمايدۇ',
    vi: 'Tùy chọn này không có hiệu lực với mẫu mực mặc định của máy khoan năm/sáu mặt',
    zh_tc: '此選項對五/六面鑽默認模板不生效',
    ru: 'Этот параметр не работает для шаблонов по умолчанию для пятигранного бурения',
    ko: '이 옵션은 5 / 6 드릴 기본 템플릿에 적용되지 않습니다.',
    bur: 'ဤရွေးချယ်မှုငါး/ခြောက်မျက်နှာတွင်းထွင်းမူရင်းပုံစံတွင်မသက်ရောက်',
    ben: 'এই অপশন পাঁচ/ছয়-পাশ ড্রিলিংয়ের ডিফল্ট টেমপ্লেটে প্রযোজ্য নয়',
    tr: 'Bu seçenek beş/altı yüz delik varsayılan şablonunda geçerli değildir',
    km: 'ជម្រើសនេះមិនអនុវត្តលើពុម្ពលំនាំដើមរណ្តៅប្រាំ/ប្រាំមួយមុខទេ',
    es: 'Esta opción no es efectiva para la plantilla predeterminada de perforación de cinco/seis lados',
    ar: 'هذا الخيار غير فعال بالنسبة للقالب الافتراضي للحفر الخماسي/السداسي',
  },
  'lineManager.onlyCut': {
    zh: '仅下料',
    en: 'Only Cutting',
    id: 'Potong saja',
    kz: 'Тек кескіш',
    th: 'ตัดออกเท่านั้น',
    ug: 'پەقەت كېسىش',
    vi: 'Chỉ cắt gọt',
    zh_tc: '僅下料',
    ru: 'Только раскрой.',
    ko: '재료만',
    bur: 'ဖြတ်တောက်ချက်သာ',
    ben: 'শুধুমাত্র কাটিং',
    tr: 'Yalnızca kesim',
    km: 'តែកាត់ប៉ុណ្ណោះ',
    es: 'Solo corte',
    ar: 'التقطيع فقط',
  },
  'lineManager.onlyFrontHoleSlot': {
    zh: '仅加工板件正面孔槽',
    en: 'Only Process Front Holes and Slots of Boards',
    id: 'Hanya alur wajah depan piring',
    kz: 'Тек панельдің алдыңғы жағындағы тесік және слоттары',
    th: 'เฉพาะร่องหน้าด้านหน้าของจาน',
    ug: 'پەقەت تاختا ئالدىنقى تەرەپ تېشىك/ئويۇقىنى ئىشلەش',
    vi: 'Chỉ gia công lỗ và khe mặt trước của tấm',
    zh_tc: '僅加工板件正面孔槽',
    ru: 'Только передние отверстия для обработки листов',
    ko: '플레이트 전면 구멍 슬롯만 가공',
    bur: 'ပြားရှေ့မျက်နှာအပေါက်ချောင်းသာပြု',
    ben: 'শুধুমাত্র বোর্ডের সামনের হোল ও স্লট প্রসেস করুন',
    tr: 'Yalnızca plakanın ön yüzündeki delik/oluklar işlenir',
    km: 'ដំណើរការតែរណ្តៅ និងរណ្តៅមុខផ្ទាំង',
    es: 'Solo procesa los orificios frontales y posteriores de la placa',
    ar: 'معالجة الفتحات الأمامية والخلفية للوحة فقط',
  },
  'lineManager.onlyHoleSlot': {
    zh: '仅加工板件正反面孔槽',
    en: 'Only Process Front and Back Holes and Slots of Boards',
    id: 'Hanya alur wajah depan dan belakang dari bagian pelat',
    kz: 'Тек панельдің алдыңғы және артқы жағындағы тесік және слоттары',
    th: 'เฉพาะด้านหน้าและด้านหลังร่องของชิ้นส่วนแผ่น',
    ug: 'پەقەت تاختا ئالدىنقى-ئارقا تەرەپ تېشىك/ئويۇقىنى ئىشلەش',
    vi: 'Chỉ gia công lỗ và khe mặt trước và sau của tấm',
    zh_tc: '僅加工板件正反面孔槽',
    ru: 'Только для обработки листов с положительной и отрицательной стороны отверстия',
    ko: '가공 플레이트만 페이스 슬롯 양수 반대',
    bur: 'ပြားရှေ့အနောက်အပေါက်ချောင်းသာပြု',
    ben: 'শুধুমাত্র বোর্ডের সামনে ও পিছনের হোল ও স্লট প্রসেস করুন',
    tr: 'Yalnızca plakanın ön ve arka delik/olukları işlenir',
    km: 'ដំណើរការរណ្តៅ និងរណ្តៅមុខ និងក្រោយផ្ទាំង',
    es: 'Solo procesa los orificios frontales y posteriores de la placa',
    ar: 'معالجة الفتحات الأمامية والخلفية للوحة فقط',
  },
  'lineManager.sideHoleSetting': {
    zh: '侧孔机设置',
    en: 'Side Hole Machine Settings',
    id: 'Pengaturan mesin lubang samping',
    kz: 'Жақ таңбалау машина параметрлер',
    th: 'การตั้งค่าเครื่อง Hole ด้านข้าง',
    ug: 'يان تېشىك ماتور تەڭشىكى',
    vi: 'Thiết lập máy khoan lỗ bên',
    zh_tc: '側孔機設置',
    ru: 'Настройка бокового отверстия',
    ko: '측면 구멍 기계 설정',
    bur: 'ဘေးတွင်းထွင်းစက်ဆက်တင်',
    ben: 'সাইড হোল মেশিন সেটিংস',
    tr: 'Yan delik makinesi ayarları',
    km: 'ការកំណត់ម៉ាស៊ីនរណ្តៅចំហៀង',
    es: 'Configuración de la máquina de orificios laterales',
    ar: 'إعدادات ماكينة الفتحات الجانبية',
  },
  'lineManager.cutHoleSlot': {
    zh: '加工的孔槽',
    en: 'Processed Holes and Slots',
    id: 'Alur lubang olahan',
    kz: 'Өңделген тесік және слоттары',
    th: 'ร่องหลุมแปรรูป',
    ug: 'ئىشلەنگەن تېشىك/ئويۇق',
    vi: 'Lỗ và khe được gia công',
    zh_tc: '加工的孔槽',
    ru: 'Обработанные отверстия',
    ko: '가공된 슬롯',
    bur: 'ပြုပြင်ထားသောအပေါက်ချောင်းများ',
    ben: 'প্রসেসড হোল ও স্লট',
    tr: 'İşlenen delik ve oluklar',
    km: 'រណ្តៅ និងរណ្តៅដែលបានដំណើរការ',
    es: 'Ranuras de orificios procesados',
    ar: 'فتحات الفتحات المعالجة',
  },
  'lineManager.minSize': {
    zh: '短边尺寸',
    en: 'Short side dimension',
    id: 'Ukuran sisi pendek',
    kz: 'Қысқа жақ өлшемі',
    th: 'ขนาดสั้น',
    ug: 'قىسقا تەرەپ ئۆلچىمى',
    vi: 'Kích thước cạnh ngắn',
    zh_tc: '短邊尺寸',
    ru: 'Короткие боковые размеры',
    ko: '짧은 모서리 치수',
    bur: 'တိုတောင်းဘက်အရွယ်',
    ben: 'ছোট বাহুর মাত্রা',
    tr: 'Kısa kenar boyutu',
    km: 'ទំហំគែមខ្លី',
    es: 'Tamaño del lado corto',
    ar: 'حجم الجانب القصير',
  },
  'lineManager.maxSize': {
    zh: '长边尺寸',
    en: 'Long side dimension',
    id: 'Ukuran sisi panjang',
    kz: 'Ұзын жақ өлшемі',
    th: 'ขนาดด้านยาว',
    ug: 'ئۇزۇن تەرەپ ئۆلچىمى',
    vi: 'Kích thước cạnh dài',
    zh_tc: '長邊尺寸',
    ru: 'Длинный размер',
    ko: '긴 모서리 치수',
    bur: 'ရှည်ဘက်အရွယ်',
    ben: 'লম্বা বাহুর মাত্রা',
    tr: 'Uzun kenar boyutu',
    km: 'ទំហំគែមវែង',
    es: 'Tamaño del lado largo',
    ar: 'حجم الجانب الطويل',
  },
  'lineManager.minSize2': {
    zh: 'mm的板上的所有',
    en: 'All on the mm board',
    id: 'Semua slot lubang dan bagian berbentuk khusus di pelat mm',
    kz: 'мм аралық панельде барлығы',
    th: 'ช่องหลุมทั้งหมดและชิ้นส่วนที่มีรูปร่างพิเศษบนแผ่น MM',
    ug: 'mm دىكى تاختىدىكى بارلىق تېشىك/ئويۇق ۋە ئۆزگىچە شەكىللىك بۆلەكلەر',
    vi: 'Tất cả trên bảng mm',
    zh_tc: 'mm的板上的所有孔槽和異形部分',
    ru: 'Все на панели mm',
    ko: 'mm의 보드에 있는 모든',
    bur: 'mm ပေါ်ဒ်ပေါ်ရှိအားလုံး',
    ben: 'mm বোর্ডের সব',
    tr: 'mm plakadaki tüm',
    km: 'ទាំងអស់នៅលើផ្ទាំង mm',
    es: 'mm Todas las',
    ar: 'مم جميع',
  },
  'lineManager.minSize3': {
    zh: '和异形部分',
    en: 'And the Alien Part',
    id: 'Dan bagian Alien',
    kz: 'қиші және түрлі бөлім',
    th: 'และส่วนที่มีรูปร่างพิเศษ',
    ug: 'ۋە ئالاھىدە شەكىل قىسمى',
    vi: 'Phần Alien',
    zh_tc: '和異形部分',
    ru: '& Экзотическая часть',
    ko: '및 이형 부분',
    bur: 'နှင့်အသွင်အစိတ်အပိုင်း',
    ben: 'ও অ্যালিয়েন পার্ট',
    tr: 've düzensiz kısımlar',
    km: 'និងផ្នែករូបរាងមិនទៀង',
    es: 'y piezas con formas especiales',
    ar: 'والأجزاء ذات الشكل الخاص',
  },
  'lineManager.onlyFrontHoleSlotTip': {
    zh: '的排版页仅正面有孔槽的小板',
    en: 'Only Process Front Holes and Slots of Boards',
    id: 'Hanya alur wajah depan piring',
    kz: 'Панельдің алдыңғы жағындағы тесік және слоттары',
    th: 'ช่องหลุมและช่องสล็อตด้านหน้าของจาน',
    ug: 'جەنتە تاختا ئالدىنقى تەرەپ تېشىك/ئويۇقىنى ئىشلەش',
    vi: 'Chỉ gia công lỗ và khe mặt trước của tấm',
    zh_tc: '排版頁僅正面有孔槽的小板',
    ru: 'Набор страниц только на досках с отверстиями спереди',
    ko: '의 레이아웃 페이지 전면에 구멍 슬롯이 있는 보드만',
    bur: 'ပြင်ဆင်စာမျက်နှာတွင်ရှေ့မျက်နှာအပေါက်ချောင်းရှိပေါ်ဒ်ငယ်သာ',
    ben: 'লেআউট পেজে শুধুমাত্র সামনের দিকে হোল স্লট আছে এমন বোর্ড',
    tr: 'Dizgi sayfasında yalnızca önde delik/oluk olan küçük plakalar',
    km: 'ទំព័ររៀបចំមានតែផ្ទាំងតូចដែលមានរណ្តៅមុខ',
    es: 'página de diseño en el tablero Solo tableros pequeños con ranuras para orificios en el frente',
    ar: 'صفحة التخطيط على اللوحة فقط الألواح الصغيرة ذات فتحات الفتحات في المقدمة',
  },
  'lineManager.onlyFrontHoleSlotTip2': {
    zh: '不包含侧孔侧槽',
    en: 'Not Include Side Holes and Slots',
    id: 'Tidak termasuk slot lubang samping',
    kz: 'Сыртқы тесік және слоттарын қоса алмау',
    th: 'ไม่รวมช่องหลุมและช่องสล็อตด้านข้าง',
    ug: 'سەرتە تېشىك/ئويۇقلارنى قوشۇڭ',
    vi: 'Không bao gồm lỗ và khe bên',
    zh_tc: '不包含側孔槽',
    ru: 'Не содержит боковых отверстий',
    ko: '측면 구멍 측면 슬롯 없음',
    bur: 'ဘေးအပေါက်ဘေးချောင်းမပါ',
    ben: 'সাইড হোল ও স্লট অন্তর্ভুক্ত নয়',
    tr: 'Yan delik/yan oluk dahil değil',
    km: 'មិនរួមបញ្ចូលរណ្តៅ និងរណ្តៅចំហៀង',
    es: 'No incluye orificios laterales Ranuras laterales',
    ar: 'لا تتضمن فتحات جانبية فتحات جانبية',
  },
  'lineManager.holeAndSlot': {
    zh: '孔和槽',
    en: 'Holes and slots',
    id: 'Lubang dan slot',
    kz: 'Торық және қазылыс',
    th: 'รูปร่างพิเศษ',
    ug: 'تېشىك ۋە ئوچۇق',
    vi: 'Lỗ và rãnh',
    zh_tc: '孔和槽',
    ru: 'отверстие и паз',
    ko: '구멍 및 슬롯',
    bur: 'အပေါက်နှင့်ချောင်း',
    ben: 'হোল ও স্লট',
    tr: 'Delik ve oluk',
    km: 'រណ្តៅ និងរណ្តៅ',
    es: 'Orificios y ranuras',
    ar: 'الثقوب والفتحات',
  },
  'lineManager.empty': {
    zh: '空',
    en: 'Empty',
    id: 'Kosong',
    kz: 'бос',
    th: 'ว่าง',
    ug: 'بوش',
    vi: 'Trống rỗng',
    zh_tc: '空',
    ru: 'пустота',
    ko: '빈',
    bur: 'ဗလာ',
    ben: 'খালি',
    tr: 'Boş',
    km: 'ទទេ',
    es: 'Vacío',
    ar: 'فارغة',
  },
  'lineManager.singleHole': {
    zh: '单孔',
    en: 'Single Hole',
    id: 'Lubang tunggal',
    kz: 'Бір тесік',
    th: 'หลุมเดียว',
    ug: 'يەككە تېشىك',
    vi: 'Lỗ đơn',
    zh_tc: '單孔',
    ru: 'Одноотверстие',
    ko: '단일 구멍',
    bur: 'အပေါက်တစ်ခု',
    ben: 'সিঙ্গেল হোল',
    tr: 'Tek delik',
    km: 'រណ្តៅតែមួយ',
    es: 'Orificio único',
    ar: 'فتحة واحدة',
  },
  'lineManager.singleSlot': {
    zh: '单槽',
    en: 'Single Slot',
    id: 'Slot tunggal',
    kz: 'Бір слот',
    th: 'ช่องเดี่ยว',
    ug: 'يەككە ئويۇق',
    vi: 'Khe đơn',
    zh_tc: '單槽',
    ru: 'Одиночный слот',
    ko: '단일 슬롯',
    bur: 'ချောင်းတစ်ခု',
    ben: 'সিঙ্গেল স্লট',
    tr: 'Tek oluk',
    km: 'រណ្តៅតែមួយ',
    es: 'Ranura única',
    ar: 'فتحة واحدة',
  },
  'lineManager.diameterRange': {
    zh: '孔直径范围',
    en: 'Hole Diameter Range',
    id: 'Rentang Diameter Lubang',
    kz: 'Тесіктің диаметрінің диапазоні',
    th: 'ช่วงเส้นผ่านศูนย์กลางของรู',
    ug: 'تېشىك دىئامېتىر دائىرىسى',
    vi: 'Phạm vi điện tính lỗ',
    zh_tc: '孔直徑範圍',
    ru: 'Диаметр отверстия',
    ko: '구멍 지름 범위',
    bur: 'အပေါက်အချင်းအကွာအဝေး',
    ben: 'হোল ডায়ামিটার রেঞ্জ',
    tr: 'Delik çap aralığı',
    km: 'ជួរអង្កត់ផ្ចិតរណ្តៅ',
    es: 'Rango de diámetro de orificio',
    ar: 'نطاق قطر الفتحة',
  },
  'lineManager.hDeepRange': {
    zh: '孔深度范围',
    en: 'Hole Depth Range',
    id: 'Kisaran kedalaman lubang',
    kz: 'Тесіктің тереңдігінің диапазоні',
    th: 'ช่วงความลึกของรู',
    ug: 'تېشىك چوڭقۇرلۇق دائىرىسى',
    vi: 'Phạm vi độ sâu lỗ',
    zh_tc: '孔深度範圍',
    ru: 'Диапазон глубины отверстия',
    ko: '구멍 깊이 범위',
    bur: 'အပေါက်အနက်အကွာအဝေး',
    ben: 'হোল ডেপথ রেঞ্জ',
    tr: 'Delik derinlik aralığı',
    km: 'ជួរជម្រៅរណ្តៅ',
    es: 'Rango de profundidad de orificio',
    ar: 'نطاق عمق الفتحة',
  },
  'lineManager.widthRange': {
    zh: '槽宽度范围',
    en: 'Slot Width Range',
    id: 'Kisaran lebar slot',
    kz: 'Слоттың кеңдігінің диапазоні',
    th: 'ช่วงความกว้างของสล็อต',
    ug: 'ئويۇق كەڭلىك دائىرىسى',
    vi: 'Phạm vi chiều rộng khe',
    zh_tc: '槽寬度範圍',
    ru: 'Диапазон ширины паза',
    ko: '슬롯 너비 범위',
    bur: 'ချောင်းအကျယ်အကွာအဝေး',
    ben: 'স্লট প্রস্থ রেঞ্জ',
    tr: 'Oluk genişlik aralığı',
    km: 'ជួរទទឹងរណ្តៅ',
    es: 'Rango de ancho de ranura',
    ar: 'نطاق عرض الفتحة',
  },
  'lineManager.sDeepRange': {
    zh: '槽深度范围',
    en: 'Slot Depth Range',
    id: 'Kisaran kedalaman alur',
    kz: 'Слоттың тереңдігінің диапазоні',
    th: 'ช่วงความลึกของร่อง',
    ug: 'ئويۇق چوڭقۇرلۇق دائىرىسى',
    vi: 'Phạm vi độ sâu khe',
    zh_tc: '槽深度範圍',
    ru: 'Диапазон глубины желоба',
    ko: '슬롯 깊이 범위',
    bur: 'ချောင်းအနက်အကွာအဝေး',
    ben: 'স্লট ডেপথ রেঞ্জ',
    tr: 'Oluk derinlik aralığı',
    km: 'ជួរជម្រៅរណ្តៅ',
    es: 'Rango de profundidad de ranura',
    ar: 'نطاق عمق الفتحة',
  },
  'lineManager.to': {
    zh: '到',
    en: 'to',
    id: 'tiba',
    kz: '—',
    th: 'มาถึง',
    ug: 'غىچە',
    vi: 'đến',
    zh_tc: '到',
    ru: 'до',
    ko: '에',
    bur: 'သို့',
    ben: 'প্রতি',
    tr: '-e kadar',
    km: 'ដល់',
    es: 'a',
    ar: 'إلى',
  },
  'lineManager.specialHS': {
    zh: '特殊孔槽和异形',
    en: 'Special Holes, Slots, and Shapes',
    id: 'Slot lubang khusus dan bentuk khusus',
    kz: 'Бұрмақ бөлшектер мен бұрмақ слоттары',
    th: 'ช่องโหว่พิเศษและรูปร่างพิเศษ',
    ug: 'ئالاھىدە تېشىك/ئويۇق ۋە ئۆزگىچە شەكىللەر',
    vi: 'Lỗ, khe đặc biệt và hình không phù hợp',
    zh_tc: '特殊孔槽和異形',
    ru: 'Специальные отверстия и фасоны',
    ko: '특수 구멍 슬롯 및 이형',
    bur: 'အထူးအပေါက်ချောင်းနှင့်အသွင်',
    ben: 'বিশেষ হোল, স্লট ও শেপ',
    tr: 'Özel delik, oluk ve şekiller',
    km: 'រណ្តៅ រណ្តៅ និងរូបរាងពិសេស',
    es: 'Ranuras de orificios especiales y formas especiales',
    ar: 'فتحات الفتحات الخاصة والأشكال الخاصة',
  },
  'lineManager.allowRoll': {
    zh: '允许开料机翻版加工特殊孔槽',
    en: 'Allow Cutting Machine to Process Special Holes and Slots by Turning Over the Board',
    id: 'Memungkinkan mesin pemotong untuk mencetak ulang dan memproses alur lubang khusus',
    kz: 'Кескіш машинаның бұрмақ бөлшектер мен бұрмақ слоттары өңдеуіне рұқсат ету',
    th: 'อนุญาตให้เครื่องตัดพิมพ์ซ้ำและประมวลผลร่องรูพิเศษ',
    ug: 'كېسىش ئۈسكۈنىسىنىڭ ئالاھىدە تېشىك/ئويۇقنى تەتۈرلەپ ئىشلەشىگە يول قويۇش',
    vi: 'Cho phép máy cắt gọt đảo mặt gia công lỗ, khe đặc biệt',
    zh_tc: '允許雕刻機翻版加工特殊孔槽',
    ru: 'Разрешить распылителю переделывать специальные отверстия',
    ko: '원료 공급 기계가 특수 슬롯을 복사하여 가공하는 것을 허용한다',
    bur: 'ဖြတ်စက်ပြားလှန်ပြီးအထူးအပေါက်ချောင်းပြုခွင့်ပြု',
    ben: 'কাটিং মেশিন বোর্ড উলটিয়ে বিশেষ হোল ও স্লট প্রসেস করার অনুমতি দিন',
    tr: 'Kesim makinesinin plakayı çevirerek özel delik/oluk işlemesine izin ver',
    km: 'អនុញ្ញាតឱ្យម៉ាស៊ីនកាត់ដំណើរការរណ្តៅពិសេសដោយបង្វិលផ្ទាំង',
    es: 'Permite que la máquina de corte duplique y procese ranuras de orificios especiales',
    ar: 'السماح لآلة القطع بتكرار فتحات الفتحات الخاصة ومعالجتها',
  },
  'lineManager.engravingPath': {
    zh: '开料机上加工板件异形部分',
    en: 'Process Special Parts of Boards on the Cutting Machine',
    id: 'Memproses bagian pelat pada mesin pemotong',
    kz: 'Кескіш машинасында панельдің бұрмақ бөлшектері өңделу',
    th: 'ประมวลผลชิ้นส่วนแผ่นบนเครื่องตัด',
    ug: 'كېسىش ئۈسكۈنىسىدىكى تاختا ئۆزگىچە شەكىللىك بۆلەكلەرنى ئىشلەش',
    vi: 'Gia công phần hình không phù hợp trên máy cắt gọt',
    zh_tc: '雕刻機上加工板件異形部分',
    ru: 'фасонная графитовая носовая летательного аппарата для обработки листов на распылителе',
    ko: '원료 공급기에서 판재 이형 부분을 가공하다.',
    bur: 'ဖြတ်စက်ပေါ်ပြားအသွင်အစိတ်အပိုင်းပြု',
    ben: 'কাটিং মেশিনে বোর্ডের বিশেষ পার্ট প্রসেস করুন',
    tr: 'Kesim makinesinde plaka düzensiz kısımlarının işlenmesi',
    km: 'ដំណើរការផ្នែករូបរាងមិនទៀងនៅលើម៉ាស៊ីនកាត់',
    es: 'Procesamiento de piezas de forma especial de la placa en la máquina de corte',
    ar: 'معالجة الأجزاء ذات الشكل الخاص من اللوحة على آلة القطع',
  },
  'lineManager.curve_range': {
    zh: '异形部分长边大于',
    en: 'Long side of special shape part greater than',
    id: 'Sisi panjang bagian berbentuk khusus lebih besar dari',
    kz: 'Бұрмақ бөліктің ұзын жағы үлкен',
    th: 'ด้านยาวของส่วนที่มีรูปร่างพิเศษมากกว่า',
    ug: 'ئۆزگىچە شەكىللىك بۆلەكنىڭ ئۇزۇن تەرىپى چوڭ بولغان',
    vi: 'Cạnh dài của phần hình không phù hợp lớn hơn',
    zh_tc: '異形部分長邊大於',
    ru: 'Внешняя часть длиннее',
    ko: '이형 부분은 길이가 더 큽니다.',
    bur: 'အသွင်အစိတ်အပိုင်းရှည်ဘက်ထို့ထက်ကြီး',
    ben: 'বিশেষ শেপ পার্টের লম্বা বাহু এর চেয়ে বড়',
    tr: 'Düzensiz kısmın uzun kenarı şundan büyük',
    km: 'គែមវែងនៃផ្នែករូបរាងមិនទៀងធំជាង',
    es: 'Todas las piezas de forma especial de la placa con el lado largo de la pieza de forma especial más grande que',
    ar: 'جميع الأجزاء ذات الشكل الخاص من اللوحة مع الجانب الطويل للجزء ذي الشكل الخاص أكبر من',
  },
  'lineManager.curve_range2': {
    zh: '的板件所有异形部分',
    en: 'all special shape parts of the board',
    id: 'semua bagian berbentuk khusus dari papan',
    kz: 'панельдің барлық бұрмақ бөліктері',
    th: 'ส่วนที่มีรูปร่างพิเศษทั้งหมดของแผ่น',
    ug: 'تاختىدىكى بارلىق ئۆزگىچە شەكىللىك بۆلەكلەر',
    vi: 'của tất cả các phần hình không phù hợp trên tấm',
    zh_tc: '的板件所有異形部分',
    ru: 'Все фасонные части панели',
    ko: '의 모든 판넬 이형 부분',
    bur: 'ပြား၏အသွင်အစိတ်အပိုင်းအားလုံး',
    ben: 'বোর্ডের সব বিশেষ শেপ পার্ট',
    tr: 'plakanın tüm düzensiz kısımları',
    km: 'ផ្នែករូបរាងមិនទៀងទាំងអស់នៃផ្ទាំង',
    es: 'all special shape parts of the board',
    ar: 'all special shape parts of the board',
  },
  'lineManager.curveArea': {
    zh: '异形面积',
    en: 'Area of irregular shape',
    id: 'Luas bentuk aneh',
    kz: 'Тұсқان шакылдың ауданы',
    th: 'พื้นที่รูปผิดรูปแบบ',
    ug: 'يېقىپچە بۇرۇشلۇقلىق شەكىلنىڭ سۈرئىتى ',
    vi: '异形面积',
    zh_tc: '異形面積',
    ru: 'Экзотическая площадь',
    ko: '이형면적',
    bur: 'အသွင်ဧရိယာ',
    ben: 'অনিয়মিত শেপের ক্ষেত্রফল',
    tr: 'Düzensiz alan',
    km: 'ផ្ទៃរូបរាងមិនទៀង',
    es: 'Área de forma especial',
    ar: 'منطقة ذات شكل خاص',
  },
  'lineManager.drillSetting': {
    zh: '五六面钻设置',
    en: 'Five/Six-Sided Drilling Settings',
    id: 'Pengaturan bor lima sisi',
    kz: 'Бес/алты таңбалау машина параметрлер',
    th: 'การตั้งค่าสว่านห้าหกหก',
    ug: 'بەش/ئالتە تەرەپلىك ماتور تەڭشىكى',
    vi: 'Thiết lập máy khoan năm/sáu mặt',
    zh_tc: '五六面鑽設置',
    ru: 'Настройка пятигранного бурения',
    ko: '5, 6면 드릴 설정',
    bur: 'ငါး/ခြောက်မျက်နှာတွင်းထွင်းဆက်တင်',
    ben: 'পাঁচ/ছয়-পাশ ড্রিলিং সেটিংস',
    tr: 'Beş/altı yüz delik ayarları',
    km: 'ការកំណត់រណ្តៅប្រាំ/ប្រាំមួយមុខ',
    es: 'Engastes de diamantes de cinco o seis lados',
    ar: 'ترصيع ماسي بخمسة أو ستة جوانب',
  },
  'lineManager.engravingCuted': {
    zh: '开料机上已加工孔槽在五/六面钻上',
    en: 'Processed Holes and Slots on the Cutting Machine for Five/Six-Sided Drilling',
    id: 'Slot lubang yang diproses pada mesin pemotong dibor di sisi kelima/keenam',
    kz: 'Кескіш машинасында өңделген тесік және слоттары бес/алты таңбалау машинасында',
    th: 'สล็อตรูที่ประมวลผลบนเครื่องตัดจะถูกเจาะในด้านที่ห้า/หก',
    ug: 'كېسىش ئۈسكۈنىسىدىكى ئىشلەنگەن تېشىك/ئويۇق بەش/ئالتە تەرەپلىك ماتوردا',
    vi: 'Lỗ, khe đã gia công trên máy cắt gọt sẽ',
    zh_tc: '雕刻機上已加工孔槽在五/六面鑽上',
    ru: 'Обработанные отверстия на распылителе на пятигранном',
    ko: '원료 공급기에서 이미 가공된 구멍 슬롯은 5 / 6면 드릴에 있다',
    bur: 'ဖြတ်စက်ပေါ်ပြုပြီးအပေါက်ချောင်းများငါး/ခြောက်မျက်နှာတွင်းထွင်းတွင်ရှိ',
    ben: 'কাটিং মেশিনে প্রসেসড হোল ও স্লট পাঁচ/ছয়-পাশ ড্রিলে',
    tr: 'Kesim makinesinde işlenmiş delik/oluklar beş/altı yüz delikte',
    km: 'រណ្តៅ និងរណ្តៅដែលបានដំណើរការនៅម៉ាស៊ីនកាត់នៅលើរណ្តៅប្រាំ/ប្រាំមួយមុខ',
    es: 'Las ranuras de los orificios procesadas en la máquina cortadora están en la broca de cinco/seis caras',
    ar: 'فتحات الثقب التي تتم معالجتها على آلة القطع موجودة في المثقاب الخماسي/ السداسي',
  },
  'lineManager.engravingCutedSpecial': {
    zh: '开料机上已加工的异形在五/六面钻上',
    en: 'Processed Special Parts of Boards on the Cutting Machine for Five/Six-Sided Drilling',
    id: 'Bagian khusus yang diproses pada mesin pemotong dibor di sisi kelima/keenam',
    kz: 'Кескіш машинасында өңделген бұрмақ бөліктері бес/алты таңбалау машинасында',
    th: 'ส่วนที่มีรูปร่างพิเศษที่ประมวลผลบนเครื่องตัดจะถูกเจาะในด้านที่ห้า/หก',
    ug: 'كېسىش ئۈسكۈنىسىدىكى بۇرۇشلۇقلىق بەلىكى بېتى بەش/ئالتە تەرەپلىك ماتوردا',
    vi: 'Phần đặc biệt đã được xử lý trên máy cắt gọt sẽ',
    zh_tc: '雕刻機上已加工的異形部分在五/六面鑽上',
    ru: 'Обработанные фасонные части панели на пятигранном',
    ko: '원료 공급기에서 이미 가공된 이형 부분은 5 / 6면 드릴에 있다',
    bur: 'အသွင်ဧရိယာအစိတ်အပိုင်းအားလုံးဖြတ်စက်ပေါ်ပြုပြီးရှိ',
    ben: 'বোর্ডের সব বিশেষ শেপ পার্ট কাটিং মেশিনে প্রসেসড হোল ও স্লট পাঁচ/ছয়-পাশ ড্রিলে',
    tr: 'Düzensiz kısımlar işlenmiş kısımlar beş/altı yüz delikte',
    km: 'រណ្តៅ និងរណ្តៅដែលបានដំណើរការនៅម៉ាស៊ីនកាត់នៅលើរណ្តៅប្រាំ/ប្រាំមួយមុខ',
    es: 'Las partes especiales procesadas en la máquina cortadora están en la broca de cinco/seis caras',
    ar: 'الأجزاء الخاصة التي تتم معالجتها على آلة القطع موجودة في المثقاب الخماسي/ السداسي',
  },
  'lineManager.genCuttingPath': {
    zh: '生成切割数据',
    en: 'Generate Cutting Data',
    id: 'Menghasilkan data pemotongan',
    kz: 'Кесу деректерін қалыптастыру',
    th: 'สร้างข้อมูลการตัด',
    ug: 'كېسىش سانلىق مەلۇماتىنى ھاسىل قىلىش',
    vi: 'Tạo dữ liệu cắt',
    zh_tc: '生成切割數據',
    ru: 'Формирование данных раскроя',
    ko: '절단 데이터 생성',
    bur: 'ဖြတ်တောက်ချက်ဒေတာဖန်တီးပါ',
    ben: 'কাটিং ডেটা জেনারেট করুন',
    tr: 'Kesim verisi oluştur',
    km: 'បង្កើតទិន្នន័យកាត់',
    es: 'Generar datos de corte',
    ar: 'إنشاء بيانات القطع',
  },
  'lineManager.otherCuted': {
    zh: '其他设备已加工的孔槽在五/六面钻上',
    en: 'Holes and slots processed by other equipment on the five/six-side drill',
    id: 'Lubang dan slot yang diproses oleh peralatan lain pada bor lima/enam sisi',
    kz: 'Басқа жабдықтармен өңделген тесіктер мен ойықтар бес/алты жақты бұрғылауда',
    th: 'รูและร่องที่ประมวลผลโดยอุปกรณ์อื่นบนเครื่องเจาะห้า/หกด้าน',
    ug: 'باشقا ئۈسكۈنىلەر تەرىپىدىن ئىشلەنگەن تۆشۈكلەر ۋە ئويۇقلار بەش/ئالتە يان ماتوردا',
    vi: 'Các lỗ và rãnh được xử lý bởi thiết bị khác trên máy khoan năm/sáu mặt',
    zh_tc: '其他設備已加工的孔槽在五/六面鑽上',
    ru: 'Прочее оборудование обработанные отверстия на 5 / 6 поверхности',
    ko: '기타 장비의 가공된 구멍 슬롯은 5 / 6면 드릴에 있습니다.',
    bur: 'အခြားစက်ပြုပြင်ထားအပေါက်ချောင်းများငါး/ခြောက်မျက်နှာတွင်းထွင်းတွင်ရှိ',
    ben: 'অন্য ইকুইপমেন্টে প্রসেসড হোল ও স্লট পাঁচ/ছয়-পাশ ড্রিলে',
    tr: 'Diğer ekipmanın işlediği delik/oluklar beş/altı yüz delikte',
    km: 'រណ្តៅ និងរណ្តៅដែលឧបករណ៍ផ្សេងដំណើរការនៅរណ្តៅប្រាំ/ប្រាំមួយមុខ',
    es: 'Las ranuras de los orificios procesadas por otros equipos están en la broca de cinco/seis caras',
    ar: 'فتحات الثقب التي تتم معالجتها بواسطة معدات أخرى موجودة في المثقاب الخماسي/ السداسي',
  },
  'lineManager.noGen': {
    zh: '不生成',
    en: 'Do Not Generate',
    id: 'Tidak dihasilkan',
    kz: 'Қалыптысу жоқ',
    th: 'ไม่ได้สร้าง',
    ug: 'ھاسىل قىلمايدۇ',
    vi: 'Không tạo',
    zh_tc: '不生成',
    ru: 'Не создается',
    ko: '생성되지 않음',
    bur: 'မဖန်တီး',
    ben: 'জেনারেট করবেন না',
    tr: 'Oluşturulmaz',
    km: 'កុំបង្កើត',
    es: 'No generar',
    ar: 'لا تولد',
  },
  'lineManager.genCut': {
    zh: '生成并加工',
    en: 'Generate and Process',
    id: 'Menghasilkan dan memproses',
    kz: 'Қалыптысу және өңдеу',
    th: 'สร้างและดำเนินการ',
    ug: 'ھاسىل قىلىپ ئىشلەيدۇ',
    vi: 'Tạo và gia công',
    zh_tc: '生成並加工',
    ru: 'Формирование и обработка',
    ko: '생성 및 가공',
    bur: 'ဖန်တီးပြီးပြု',
    ben: 'জেনারেট ও প্রসেস করুন',
    tr: 'Oluştur ve işle',
    km: 'បង្កើត និងដំណើរការ',
    es: 'Generar y procesar',
    ar: 'تولد وتعالج',
  },
  'lineManager.genNoCut': {
    zh: '生成但不加工',
    en: 'Generate But Do Not Process',
    id: 'Menghasilkan tetapi tidak diproses',
    kz: 'Қалыптысу, бірақ өңдеу жоқ',
    th: 'สร้าง แต่ไม่ได้ดำเนินการ',
    ug: 'ھاسىل قىلىدۇ ئەمما ئىشلىمەيدۇ',
    vi: 'Tạo nhưng không gia công',
    zh_tc: '生成但不加工',
    ru: 'Создано, но не обработано',
    ko: '생성되지만 가공되지 않음',
    bur: 'ဖန်တီးပြီးမပြု',
    ben: 'জেনারেট করুন কিন্তু প্রসেস করবেন না',
    tr: 'Oluştur ama işleme',
    km: 'បង្កើតប៉ុន្តែមិនដំណើរការ',
    es: 'Generar pero no procesar',
    ar: 'تولد لكن لا تعالج',
  },
  'lineManager.cutTip': {
    zh: ' 注：此选项仅对自定义的五六面钻文件生效',
    en: 'Attention: This option only applies to custom five/six-sided drilling files',
    id: 'Catatan: Opsi ini hanya efektif untuk file bor lima dan enam sisi khusus',
    kz: ' Ескерту: Бұл параметр тек өзіңіздің бес/алты таңбалау машина файлына әсер етеді',
    th: 'หมายเหตุ: ตัวเลือกนี้มีผลเฉพาะสำหรับไฟล์สว่านห้าและหกด้านที่กำหนดเอง',
    ug: 'ئەسكەرتىش: بۇ تاللاش پەقەت ئىختىيارى بەش/ئالتە تەرەپلىك ماتور ھۆججىتىگە تەسىر قىلىدۇ',
    vi: 'Chú ý: Tùy chọn này chỉ có hiệu lực với tệp máy khoan năm/sáu mặt tùy chỉnh',
    zh_tc: ' 注：此選項僅對自定義的五六面鑽文件生效',
    ru: 'Примечание: Эта опция действительна только для пользовательских файлов пятигранного бурения',
    ko: '참고: 이 옵션은 사용자 정의 5, 6면 드릴링 파일에만 적용됩니다.',
    bur: 'သတိပြု-ဤရွေးချယ်မှုသည်စိတ်ကြိုက်ငါး/ခြောက်မျက်နှာတွင်းထွင်းဖိုင်များတွင်သာသက်ရောက်',
    ben: 'নোট: এই অপশন শুধুমাত্র কাস্টম পাঁচ/ছয়-পাশ ড্রিলিং ফাইলে প্রযোজ্য',
    tr: ' Not: Bu seçenek yalnızca özelleştirilmiş beş/altı yüz delik dosyalarında geçerlidir',
    km: ' ចំណាំ៖ ជម្រើសនេះមានប្រសិទ្ធភាពតែសម្រាប់ឯកសាររណ្តៅប្រាំ/ប្រាំមួយមុខផ្ទាល់ខ្លួន',
    es: 'Nota: Esta opción solo tiene efecto para limas de perforación personalizadas de cinco y seis caras',
    ar: 'ملاحظة: يسري هذا الخيار فقط على ملفات الحفر المخصصة ذات الخماسية أو السداسية',
  },
  'lineManager.maxShortSize': {
    zh: '最大短边尺寸',
    en: 'Maximum Short Side Length',
    id: 'Ukuran sisi pendek maksimum',
    kz: 'Ең үлкен қысқа яқтың өлшемі',
    th: 'ขนาดสั้นที่สุด',
    ug: 'ئەڭ چوڭ قىسقا تەرەپ ئۆلچىمى',
    vi: 'Kích thước cạnh ngắn tối đa',
    zh_tc: '最大短邊尺寸',
    ru: 'Максимально короткий размер',
    ko: '최대 짧은 모서리 크기',
    bur: 'အများဆုံးတိုတောင်းဘက်အရွယ်',
    ben: 'সর্বোচ্চ ছোট বাহুর দৈর্ঘ্য',
    tr: 'Maksimum kısa kenar boyutu',
    km: 'ទំហំគែមខ្លីអតិបរមា',
    es: 'Tamaño máximo del lado corto',
    ar: 'الحد الأقصى لحجم الجانب القصير',
  },
  'lineManager.maxLongSize': {
    zh: '最大长边尺寸',
    en: 'Maximum Long Side Size',
    id: 'Ukuran sisi panjang maksimum',
    kz: 'Ең ұзын жақ өлшемі',
    th: 'ขนาดด้านความยาวสูงสุด',
    ug: 'ئەڭ چوڭ ئۇزۇن تەرەپ ئۆلچىمى',
    vi: 'Kích thước cạnh dài tối đa',
    zh_tc: '最大長邊尺寸',
    ru: 'Максимальная длина края',
    ko: '최대 긴 모서리 크기',
    bur: 'အများဆုံးရှည်ဘက်အရွယ်',
    ben: 'সর্বোচ্চ লম্বা বাহুর সাইজ',
    tr: 'Maksimum uzun kenar boyutu',
    km: 'ទំហំគែមវែងអតិបរមា',
    es: 'Tamaño máximo del lado largo',
    ar: 'الحد الأقصى لحجم الجانب الطويل',
  },
  'lineManager.normalSlot': {
    zh: '普通槽',
    en: 'Regular Slot',
    id: 'Slot normal',
    kz: 'Қалыпты слот',
    th: 'ช่องปกติ',
    ug: 'نورمال ئويۇق',
    vi: 'Khe thông thường',
    zh_tc: '普通槽',
    ru: 'Обычный лоток',
    ko: '일반 슬롯',
    bur: 'ပုံမှန်ချောင်း',
    ben: 'নিয়মিত স্লট',
    tr: 'Normal oluk',
    km: 'រណ្តៅធម្មតា',
    es: 'Ranura ordinaria',
    ar: 'الفتحة العادية',
  },
  'lineManager.specialSlot': {
    zh: '特殊槽',
    en: 'Special Slot',
    id: 'Slot khusus',
    kz: 'Бұрмақ слот',
    th: 'ช่องพิเศษ',
    ug: 'ئالاھىدە ئويۇق',
    vi: 'Khe đặc biệt',
    zh_tc: '特殊槽',
    ru: 'Специальный лоток',
    ko: '특수 슬롯',
    bur: 'အထူးချောင်း',
    ben: 'বিশেষ স্লট',
    tr: 'Özel oluk',
    km: 'រណ្តៅពិសេស',
    es: 'Ranura especial',
    ar: 'الفتحة الخاصة',
  },
  'lineManager.combinSetting': {
    zh: '组合设备设置',
    en: 'Combined Equipment Settings',
    id: 'Pengaturan Perangkat Kombinasi',
    kz: 'Комбинациялық жабдықтар параметрлер',
    th: 'การตั้งค่าอุปกรณ์รวมกัน',
    ug: 'بىرلەشتۈرۈلگەن ئۈسكۈنىلەر تەڭشىكى',
    vi: 'Thiết lập thiết bị kết hợp',
    zh_tc: '組合設備設置',
    ru: 'Параметры комбинированного устройства',
    ko: '콤보 장치 설정',
    bur: 'ပေါင်းစည်းစက်ဆက်တင်',
    ben: 'কম্বাইন্ড ইকুইপমেন্ট সেটিংস',
    tr: 'Birleşik ekipman ayarları',
    km: 'ការកំណត់ឧបករណ៍រួមបញ្ចូល',
    es: 'Configuración de equipo combinado',
    ar: 'إعدادات المعدات المجمعة',
  },
  'lineManager.allowShortSize': {
    zh: '允许短边尺寸',
    en: 'Allow Short Side Length',
    id: 'Izinkan ukuran sisi pendek',
    kz: 'Қысқа яқтың өлшеміне рұқсат ету',
    th: 'ให้ขนาดสั้น',
    ug: 'قىسقا تەرەپ ئۆلچىمىگە يول قويۇش',
    vi: 'Cho phép kích thước cạnh ngắn',
    zh_tc: '允許短邊尺寸',
    ru: 'Разрешить короткие боковые размеры',
    ko: '짧은 모서리 치수 허용',
    bur: 'တိုတောင်းဘက်အရွယ်ခွင့်ပြု',
    ben: 'ছোট বাহুর দৈর্ঘ্য অনুমতি দিন',
    tr: 'Kısa kenar boyutuna izin ver',
    km: 'អនុញ្ញាតទំហំគែមខ្លី',
    es: 'Permitir tamaño de lado corto',
    ar: 'السماح بحجم جانبي قصير',
  },
  'lineManager.equipment1': {
    zh: '设备一',
    en: 'Equipment 1',
    id: 'Peralatan satu',
    kz: 'Бірінші жабдық',
    th: 'อุปกรณ์หนึ่ง',
    ug: 'ئۈسكۈنى 1',
    vi: 'Thiết bị 1',
    zh_tc: '設備一',
    ru: 'Оборудование I',
    ko: '장치 1',
    bur: 'စက်တစ်',
    ben: 'ইকুইপমেন্ট ১',
    tr: 'Ekipman 1',
    km: 'ឧបករណ៍ ១',
    es: 'Equipo uno',
    ar: 'الجهاز الأول',
  },
  'lineManager.equipment2': {
    zh: '设备二',
    en: 'Equipment 2',
    id: 'Peralatan 2',
    kz: 'Екінші жабдық',
    th: 'อุปกรณ์ 2',
    ug: 'ئۈسكۈنى 2',
    vi: 'Thiết bị 2',
    zh_tc: '設備二',
    ru: 'Оборудование II',
    ko: '장치 2',
    bur: 'စက်နှစ်',
    ben: 'ইকুইপমেন্ট ২',
    tr: 'Ekipman 2',
    km: 'ឧបករណ៍ ២',
    es: 'Equipo dos',
    ar: 'الجهاز الثاني',
  },
  'lineManager.noSameTip': {
    zh: '注：两个设备不能选择一样',
    en: 'Attention: The two equipment cannot be the same',
    id: 'Catatan: Hal yang sama tidak dapat dipilih untuk kedua perangkat.',
    kz: ' Ескерту: Екі жабдықты да бірдей таңдауға болмайды',
    th: 'หมายเหตุ: ไม่สามารถเลือกได้เหมือนกันสำหรับอุปกรณ์ทั้งสอง',
    ug: 'ئەسكەرتىش: ئىككى ئۈسكۈنىنى بىر خىل تاللىيالمايسىز',
    vi: 'Chú ý: Không thể chọn hai thiết bị giống nhau',
    zh_tc: '注：兩個設備不能選擇一樣',
    ru: 'Примечание: Два устройства не могут выбрать одно и то же',
    ko: '참고: 두 장치는 동일하게 선택할 수 없습니다.',
    bur: 'သတိပြု-စက်နှစ်ခုတူညီရွေးမရ',
    ben: 'নোট: দুটি ইকুইপমেন্ট একই হতে পারবে না',
    tr: 'Not: İki ekipman aynı seçilemez',
    km: 'ចំណាំ៖ ឧបករណ៍ពីរមិនអាចដូចគ្នាបានទេ',
    es: 'Nota: No se pueden seleccionar dos equipos iguales',
    ar: 'ملاحظة: لا يمكن تحديد جهازين بنفس الوقت',
  },
  'lineManager.workRange': {
    zh: '设备一可加工孔槽范围',
    en: 'Processing Range for Equipment 1',
    id: 'Rentang slot lubang mesin peralatan',
    kz: 'Бірінші жабдықтың өңдеу диапазоні',
    th: 'ช่วงสล็อตรูอุปกรณ์อุปกรณ์',
    ug: 'ئۈسكۈنى 1 ئىشلەيدىغان تېشىك/ئويۇق دائىرىسى',
    vi: 'Phạm vi gia công của thiết bị 1',
    zh_tc: '設備一可加工孔槽範圍',
    ru: 'Оборудование I',
    ko: '장치 1 가공 가능한 구멍 슬롯 범위',
    bur: 'စက်တစ်ပြုနိုင်သောအပေါက်ချောင်းအကွာအဝေး',
    ben: 'ইকুইপমেন্ট ১-এর প্রসেসিং রেঞ্জ',
    tr: 'Ekipman 1 delik/oluk işleme aralığı',
    km: 'ជួរដំណើរការរណ្តៅ និងរណ្តៅសម្រាប់ឧបករណ៍ ១',
    es: 'El equipo uno puede procesar el rango de ranuras de orificios',
    ar: 'جهاز يمكن معالجة نطاق فتحة الفتحة',
  },
  'lineManager.rangeWarning': {
    zh: '注：仅可设置设备一加工范围，非设备一加工范围将全部在设备二上加工，请谨慎操作！',
    en: 'Attention: Only the processing range for Equipment 1 can be set. All non-Equipment 1 processing ranges will be processed on Equipment 2. Please proceed with caution!',
    id: 'Catatan: Hanya rentang pemrosesan peralatan yang dapat ditetapkan, dan semua rentang pemrosesan peralatan yang akan diproses pada peralatan dua. Harap beroperasi dengan hati -hati!',
    kz: ' Ескерту: Тек бірінші жабдықтың оңдеу диапазонды таңдауға болады. Бірінші жабдықтың оңдеу диапазонынан тыс болатын бөлшектер екінші жабдықта оңделуге болады. мұны мұқият істеу!',
    th: 'หมายเหตุ: เฉพาะช่วงการประมวลผลของอุปกรณ์ที่สามารถตั้งค่าได้และช่วงการประมวลผลทั้งหมดของอุปกรณ์หนึ่งจะถูกประมวลผลบนอุปกรณ์ที่สอง กรุณาใช้งานด้วยความระมัดระวัง!',
    ug: 'ئەسكەرتىش: پەقەت ئۈسكۈنى 1 نىڭ ئىشلەش دائىرىسىنى تەڭشەيدۇ، ئۈسكۈنى 1 نىڭ ئىشلەش دائىرىسىدىن سىرتتىكىلەرنىڭ ھەممىسى ئۈسكۈنى 2 دىكى ئىشلىنىدۇ، دىققەتلىك ئىشلەڭ!',
    vi: 'Chú ý: Chỉ có thể thiết lập phạm vi gia công của thiết bị 1, phạm vi ngoài phạm vi của thiết bị 1 sẽ được gia công hoàn toàn trên thiết bị 2, vui lòng thao tác cẩn thận!',
    zh_tc:
      '注：僅可設置設備一加工範圍，非設備一加工範圍將全部在設備二上加工，請謹慎操作！',
    ru: 'Примечание: Можно установить только один диапазон обработки оборудования, а не один диапазон обработки оборудования будет полностью обработан на втором устройстве, пожалуйста, будьте осторожны!',
    ko: '참고: 설비 1가공 범위만 설정할 수 있으며, 비설비 1가공 범위는 전부 설비 2에서 가공할 것이니, 신중하게 조작하세요!',
    bur: 'သတိပြု-သာစက်တစ်ပြုအကွာအဝေးသတ်မှတ်နိုင်၊ စက်တစ်မဟုတ်အကွာအဝေးအားလုံးစက်နှစ်တွင်ပြုမည်၊ သတိထားပါ!',
    ben: 'নোট: শুধুমাত্র ইকুইপমেন্ট ১-এর প্রসেসিং রেঞ্জ সেট করা যাবে। নন-ইকুইপমেন্ট ১ রেঞ্জ সব ইকুইপমেন্ট ২-তে প্রসেস হবে। সাবধানে এগিয়ে যান!',
    tr: 'Not: Yalnızca Ekipman 1 işleme aralığı ayarlanabilir; Ekipman 1 dışındaki tümü Ekipman 2 üzerinde işlenir, dikkatli işlem yapın!',
    km: 'ចំណាំ៖ អាចកំណត់តែជួរដំណើរការឧបករណ៍ ១ ជួរក្រៅឧបករណ៍ ១ ទាំងអស់ដំណើរការនៅឧបករណ៍ ២ សូមប្រយ័ត្ន!',
    es: 'Nota: Solo se puede configurar el rango de procesamiento del equipo uno, el rango de procesamiento que no sea el equipo uno se procesará en el equipo dos, ¡opere con precaución!',
    ar: 'ملاحظة: يمكن تعيين نطاق معالجة واحد فقط للمعدات، وستتم معالجة نطاق معالجة واحد غير المعدات على الجهاز الثاني، يرجى العمل بحذر!',
  },
  'lineManager.deleteWarning': {
    zh: '删除该生产线后不可恢复（该生产线下所有设置都将删除），是否确认删除该生产线？',
    en: 'After deleting this production line, it cannot be recovered (all settings for this production line will be deleted). Are you sure you want to delete this production line?',
    id: 'Setelah menghapus jalur produksi, itu tidak dapat dipulihkan (semua pengaturan di bawah jalur produksi akan dihapus). Apakah Anda pasti akan menghapus jalur produksi?',
    kz: 'Бұл өндіріс желісіні жоюдан кейін қалпына келтіруге болмайды (желісінің барлық параметрлері жойылады), онда жоюды тастықтайсыз ба?',
    th: 'หลังจากลบสายการผลิตจะไม่สามารถกู้คืนได้ (การตั้งค่าทั้งหมดภายใต้สายการผลิตจะถูกลบ) คุณแน่ใจว่าจะลบสายการผลิตได้หรือไม่?',
    ug: 'بۇ ئىشلەپچىقىرىش لىنىيىسىنى ئۆچۈرگەندىن كېيىن قايتۇرۇشقا بولمايدۇ (بۇ لىنىيەدىكى بارلىق تەڭشەكلەر ئۆچۈرۈلىدۇ)، ئۆچۈرۈشنى جازالامسىز؟',
    vi: 'Xóa dây chuyền sản xuất này sẽ không thể khôi phục (tất cả thiết lập của dây chuyền sản xuất này sẽ bị xóa), bạn có chắc chắn muốn xóa dây chuyền sản xuất này?',
    zh_tc:
      '刪除該生產線後不可恢復（該生產線下所有設置都將刪除），是否確認刪除該生產線？',
    ru: 'Невозможно восстановить после удаления производственной линии (все настройки под этой линией будут удалены), подтверждается ли удаление производственной линии?',
    ko: '이 생산라인을 삭제한 후 복구할 수 없습니다. 이 생산라인의 모든 설정은 삭제됩니다. 이 생산라인을 삭제하시겠습니까?',
    bur: 'ဤထုတ်လုပ်မှုလိုင်းဖျက်ပြီးပြန်မရနိုင်(ဤလိုင်းအောက်ဆက်တင်အားလုံးဖျက်မည်)၊ ဖျက်မည်ကိုအတည်ပြုလား?',
    ben: 'এই প্রোডাকশন লাইন মুছার পর পুনরুদ্ধার করা যাবে না (এই লাইনের সব সেটিং মুছে যাবে)। এই প্রোডাকশন লাইন মুছতে নিশ্চিত করবেন?',
    tr: 'Bu üretim hattı silindikten sonra geri yüklenemez (altındaki tüm ayarlar silinir). Silmek istediğinizden emin misiniz?',
    km: 'លុបខ្សែផលិតកម្មនេះមិនអាចស្តារឡើងវិញ (ការកំណត់ទាំងអស់ក្រោមវាត្រូវលុប)។ តើអ្នកប្រាកដថាចង់លុប?',
    es: 'La eliminación de esta línea de producción no se puede restaurar (se eliminarán todas las configuraciones de esta línea de producción). ¿Está seguro de eliminar esta línea de producción?',
    ar: 'لا يمكن استعادة حذف خط الإنتاج هذا (سيتم حذف جميع الإعدادات الموجودة ضمن خط الإنتاج هذا). هل أنت متأكد من حذف خط الإنتاج هذا؟',
  },
  'lineManager.top': {
    zh: '顶部',
    en: 'Top',
    id: 'atas',
    kz: 'Жоғарғы',
    th: 'สูงสุด',
    ug: 'ئۈستى',
    vi: 'Đầu',
    zh_tc: '頂部',
    ru: 'верх',
    ko: '상단',
    bur: 'ထိပ်',
    ben: 'শীর্ষ',
    tr: 'Üst',
    km: 'ខាងលើ',
    es: 'Arriba',
    ar: 'الأعلى',
  },
  'lineManager.inputCheck': {
    zh: '{msg}最小值不能大于最大值',
    en: 'The minimum value of {msg} cannot be greater than the maximum value',
    id: '{msg} nilai minimum tidak boleh lebih besar dari nilai maksimum',
    kz: '{msg} ең кішісі зортық мәннен аспайды',
    th: '{msg} ค่าต่ำสุดไม่สามารถมากกว่าค่าสูงสุด',
    ug: '{msg} ئەڭ كىچىك قىممەت ئەڭ چوڭ قىممەتتىن چوڭ بولالمايدۇ',
    vi: '{msg} Giá trị tối thiểu không được lớn hơn giá trị tối đa',
    zh_tc: '{msg}最小值不能大於最大值',
    ru: 'Минимальное значение {msg} не может быть больше максимального значения',
    ko: '{msg} 최소값은 최대값보다 커서는 안됩니다',
    bur: '{msg}အနည်းဆုံးသည်အများဆုံးထက်မကြီးနိုင်',
    ben: '{msg}-এর ন্যূনতম মান সর্বোচ্চ মানের চেয়ে বড় হতে পারবে না',
    tr: '{msg} minimum değeri maksimumdan büyük olamaz',
    km: 'តម្លៃអប្បបរមា {msg} មិនអាចធំជាងតម្លៃអតិបរមា',
    es: '{msg} El valor mínimo no puede ser mayor que el valor máximo',
    ar: '{msg} لا يمكن أن تكون القيمة الدنيا أكبر من القيمة القصوى',
  },
  'lineManager.lockTip': {
    zh: '生产线已锁定,禁止操作!',
    en: 'The production line is locked and cannot be operated!',
    id: 'Jalur produksi terkunci, operasi dilarang!',
    kz: 'Өндіріс желісі бұғатталды, операцияларға тысыңыз!',
    th: 'สายการผลิตถูกล็อคการดำเนินการเป็นสิ่งต้องห้าม!',
    ug: 'ئىشلەپچىقىرىش لىنىيىسى قۇلۇپلانغان، مەشغۇلاتقا چەك قويۇلدى!',
    vi: 'Dây chuyền sản xuất đã bị khóa, không được thao tác!',
    zh_tc: '生產線已鎖定,禁止操作!',
    ru: 'Производственная линия заблокирована, операция запрещена!',
    ko: '생산 라인이 잠겼습니다. 작동 금지!',
    bur: 'ထုတ်လုပ်မှုလိုင်းလော့ချထားပြီး၊ လုပ်ဆောင်ချက်မပြုရ!',
    ben: 'প্রোডাকশন লাইন লক করা আছে, অপারেশন নিষিদ্ধ!',
    tr: 'Üretim hattı kilitli, işlem yasak!',
    km: 'ខ្សែផលិតកម្មជាប់សោ ហាមដំណើរការ!',
    es: '¡La línea de producción ha sido bloqueada y las operaciones están prohibidas!',
    ar: 'تم قفل خط الإنتاج وتم حظر العمليات!',
  },
  'lineManager.reNameTip': {
    zh: '默认生产线不可修改名字',
    en: 'The default production line cannot be renamed',
    id: 'Nama jalur produksi default tidak dapat dimodifikasi',
    kz: 'Әдетті өндіріс желісінің атауын өзгертеуге болмайды',
    th: 'ไม่สามารถแก้ไขชื่อของสายการผลิตเริ่มต้นได้',
    ug: 'سۈكۈتتىكى ئىشلەپچىقىرىش لىنىيىسىنىڭ ئىسمىنى ئۆزگەرتىشكە بولمايدۇ',
    vi: 'Dây chuyền sản xuất mặc định không thể sửa đổi tên',
    zh_tc: '默認生產線不可修改名字',
    ru: 'Производственные линии по умолчанию не могут изменять имена',
    ko: '기본 라인은 이름을 수정할 수 없습니다.',
    bur: 'မူရင်းထုတ်လုပ်မှုလိုင်းအမည်ပြင်မရ',
    ben: 'ডিফল্ট প্রোডাকশন লাইনের নাম পরিবর্তন করা যাবে না',
    tr: 'Varsayılan üretim hattının adı değiştirilemez',
    km: 'មិនអាចប្តូរឈ្មោះខ្សែផលិតកម្មលំនាំដើម',
    es: 'El nombre de la línea de producción predeterminada no se puede modificar',
    ar: 'لا يمكن تعديل اسم خط الإنتاج الافتراضي',
  },
  'lineManager.permissonTip': {
    zh: '身份信息已过期,请重新从柜柜打开此页面!',
    en: 'Your identity has expired. Please reopen this page from the cabinet!',
    id: 'Informasi identitas telah kedaluwarsa, buka halaman ini dari kabinet lagi!',
    kz: 'Кімلیک bilgisi үтіп кетті, қайтадан кабинеттен осы бетті ашу!',
    th: 'ข้อมูลตัวตนหมดอายุโปรดเปิดหน้านี้จากตู้อีกครั้ง!',
    ug: 'كىملىك ئۇچۇرى ئەسلىگە كەلگەن، كابىنېتتىن بۇ بەتنى قايتا ئېچىڭ!',
    vi: 'Thông tin nhận dạng đã hết hạn, vui lòng mở lại trang này từ Khung Khung!',
    zh_tc: '身份信息已過期,請重新從櫃櫃打開此頁面!',
    ru: 'Идентификационные данные истекли, пожалуйста, откройте эту страницу снова из шкафа!',
    ko: '신원 정보가 만료되었습니다. 이 페이지를 캐비닛에서 다시 열어 주십시오!',
    bur: 'အထောက်အထားသက်တမ်းကုန်ပြီ၊ ကက်ဘိနက်မှဤစာမျက်နှာပြန်ဖွင့်ပါ!',
    ben: 'আপনার আইডেন্টিটি মেয়াদ উত্তীর্ণ। ক্যাবিনেট থেকে এই পেজ আবার খুলুন!',
    tr: 'Kimlik bilgisi süresi doldu; lütfen bu sayfayı dolaptan yeniden açın',
    km: 'ព័ត៌មានអត្តសញ្ញាណផុតកំណត់ សូមបើកទំព័រនេះឡើងវិញពីទូ',
    es: 'La información de identidad ha caducado, vuelva a abrir esta página desde el gabinete.',
    ar: 'انتهت صلاحية معلومات الهوية، يرجى إعادة فتح هذه الصفحة من الخزانة!',
  },
  'lineManager.permissonErr': {
    zh: '暂无此权限, 请升级账号版本!',
    en: 'You do not have this permission. Please upgrade your account version!',
    id: 'Belum ada izin seperti itu, silakan tingkatkan versi akun!',
    kz: 'Бұл рұқсат сізге берілмеген, аккаунт нұсқасын жаңарту!',
    th: 'ยังไม่มีการอนุญาตดังกล่าวโปรดอัปเกรดเวอร์ชันบัญชี!',
    ug: 'ھازىرچە بۇ ھوقۇق يوق، ھېسابات نەشرىنى يۇقىرى كۆتۈرۈڭ!',
    vi: 'Không có quyền truy cập, vui lòng nâng cấp phiên bản tài khoản!',
    zh_tc: '暫無此權限, 請升級賬號版本!',
    ru: 'Без этого права, пожалуйста, обновите версию учетной записи!',
    ko: '이 권한이 없습니다. 계정 버전을 업그레이드하세요!',
    bur: 'ဤခွင့်ပြုချက်မရှိသေး၊ အကောင့်ဗားရှင်းမြှင့်ပါ!',
    ben: 'আপনার এই অনুমতি নেই। অ্যাকাউন্ট সংস্করণ আপগ্রেড করুন!',
    tr: 'Bu izin yok; lütfen hesap sürümünü yükseltin!',
    km: 'មិនមានការអនុញ្ញាតនេះ សូមដំឡើងកំណែគណនី!',
    es: 'Aún no tienes este permiso, ¡actualiza la versión de la cuenta!',
    ar: 'ليس لديك هذا الإذن بعد، يرجى ترقية إصدار الحساب!',
  },
  'lineManager.permissionOneMacErr': {
    zh: '您当前可使用的一体机生产线条数为{idx}条，如需增加，请联系销售人员！',
    en: 'You currently have access to {idx} production line for the integrated machine. If you need to add more, please contact the salesperson!',
    id: 'Jumlah lini produksi all-in-one yang dapat Anda gunakan adalah {idx}. Jika Anda perlu menambahkannya, silakan hubungi tenaga penjualan!',
    kz: 'Сіз қазір қол жетімді бір бұйрыq құрылғының жинақ саныңыз {idx} болып тұр. Қосу керек болса, satıcıға хабарласыңыз!',
    th: 'จำนวนสายการผลิต all-in-one ที่คุณสามารถใช้ได้คือ {idx} หากคุณต้องการเพิ่มโปรดติดต่อพนักงานขาย!',
    ug: 'ھازىر ئىشلىتەلەيدىغان بىرلىك ماشىنا ئىشلەپچىقىرىش لىنىيىسى سانى {idx}، ئەگەر كۆپەيتىشنىز زۆرۈر بولسا، سېتىش خادىمى بىلەن ئالاقىلىشىڭ!',
    vi: 'Bạn hiện tại có thể sử dụng {idx} dòng sản xuất cho máy tích hợp. Nếu cần thêm, vui lòng liên hệ với nhân viên bán hàng!',
    zh_tc:
      '您當前可使用的一體機生產線條數為{idx}條，如需增加，請聯繫銷售人員！',
    ru: 'У вас есть доступ к {idx} линиям производства для интегрированного оборудования. Если вам нужно добавить больше, пожалуйста, свяжитесь с продавцом!',
    ko: '통합 기기에 대한 접근 권한이 {idx}개 있습니다. 더 추가하려면 판매 담당자에게 문의하세요!',
    bur: 'လက်ရှိအသုံးပြုနိုင်သောတစ်ကိုယ်ရည်စက်ထုတ်လုပ်မှုလိုင်းအရေအတွက်မှာ{idx}ကြောင်း၊ တိုးလိုပါကအရောင်းဝန်ထမ်းနှင့်ဆက်သွယ်ပါ!',
    ben: 'আপনার বর্তমানে ইন্টিগ্রেটেড মেশিনের জন্য {idx}টি প্রোডাকশন লাইন অ্যাক্সেস আছে। আর যোগ করতে চাইলে সেলসপারসনের সাথে যোগাযোগ করুন!',
    tr: 'Şu anda entegre makine için {idx} üretim hattı kullanabilirsiniz; artırmak için satışla iletişime geçin',
    km: 'បច្ចុប្បន្នអ្នកអាចប្រើខ្សែផលិតកម្ម {idx} សម្រាប់ម៉ាស៊ីនរួមបញ្ចូល បង្កើនបន្ថែមសូមទាក់ទងលក់',
    es: 'El número de líneas de producción todo en uno que puedes utilizar actualmente es {idx}. Si necesita aumentarlo, comuníquese con el personal de ventas.',
    ar: 'عدد خطوط الإنتاج المتكاملة التي يمكنك استخدامها حاليًا هو {idx}. إذا كنت بحاجة إلى زيادته، يرجى الاتصال بموظفي المبيعات!',
  },
  'lineManager.permissionSawErr': {
    zh: '没有锯切雕刻机使用权限，请联系销售购买全铝锯切补充包后使用',
    en: 'You do not have permission to use the cutting machine, please contact the after-sales service to purchase the full-aluminum cutting and disassembly production supplement package!',
    id: 'Tidak ada izin pemotongan mesin ukir, silakan hubungi layanan purna jual untuk membeli paket tambahan pemotongan elektronik!',
    kz: 'Бұл кескіш машинасының қолжетерлік емес, қосымша құрылғыны сатып алу үшін қолдау көрсету!',
    th: 'ไม่มีสิทธิ์ใช้เครื่องตัดกระจก โปรดติดต่อผู้ขายเพื่อซื้อสิทธิ์เพิ่มเติม!',
    ug: 'بۇ تاللاش بەش/ئالتە تەرەپلىك ماتور سۈكۈتتىكى قېلىپىغا تەسىر قىلمايدۇ',
    vi: 'Không có quyền truy cập máy cắt gọt, vui lòng liên hệ với nhân viên bán hàng để mua gói bổ sung sản xuất cắt gọt điện tử!',
    zh_tc: '沒有鋸切雕刻機使用權限，請聯繫銷售購買全鋁鋸切補充包後使用',
    ru: 'Нет прав на использование пилы гравировальной машины, пожалуйста, свяжитесь с продажей, чтобы купить полный алюминиевый пильный дополнительный пакет для использования',
    ko: '톱질 조각기 사용 권한 없음, 판매에 연락하여 알루미늄 톱질 보충팩 구매 후 사용',
    bur: 'ဆောက်ဖြတ်ထွင်းစက်အသုံးပြုခွင့်မရှိ၊ အရောင်းနှင့်ဆက်သွယ်ပြီးပြည့်အလူမီနီယံဆောက်ဖြတ်ဖြည့်ပါယူပြီးသုံးပါ',
    ben: 'কাটিং মেশিন ব্যবহারের অনুমতি নেই, সেলসের সাথে যোগাযোগ করে ফুল-অ্যালুমিনিয়াম কাটিং সাপ্লিমেন্ট প্যাক কিনে ব্যবহার করুন',
    tr: 'Testere/oyma kullanım izniniz yok; tam alüminyum testere kesim ek paketi için satışla iletişime geçin',
    km: 'គ្មានការអនុញ្ញាតប្រើម៉ាស៊ីនរណា/ចុកចាក់ ទាក់ទងលក់ដើម្បីទិញកញ្ចប់បន្ថែមកាត់អាលុយមីញ៉ូមពេញលេញ',
    es: 'No tiene permiso para utilizar la máquina de corte y grabado. Comuníquese con ventas para comprar el paquete complementario de aserrado totalmente de aluminio antes de usarlo.',
    ar: 'ليس لديك الإذن باستخدام آلة النشر والنقش. يرجى الاتصال بالمبيعات لشراء حزمة ملحقات النشر المصنوعة بالكامل من الألومنيوم قبل استخدامها.',
  },
  'lineManager.getAuthError': {
    zh: '获取设备权限失败！',
    en: 'Failed to obtain device permissions!',
    id: 'Gagal mendapatkan izin perangkat!',
    kz: 'Құрылғы рұқсатын алу сәтсіз болды!',
    th: 'ไม่สามารถขอสิทธิ์การเข้าถึงอุปกรณ์ได้!',
    ug: 'ئۈسكۈنە ئىجازەت ئېلىش مەغلۇپ بولدى!',
    vi: 'Không thể lấy quyền truy cập thiết bị!',
    zh_tc: '獲取設備權限失敗！',
    ru: 'Ошибка получения прав на устройство!',
    ko: '장치 권한을 가져오지 못했습니다!',
    bur: 'စက်ခွင့်ပြုချက်ရယူမှုမအောင်!',
    ben: 'ডিভাইস অনুমতি পেতে ব্যর্থ!',
    tr: 'Cihaz izinleri alınamadı!',
    km: 'មិនអាចទទួលបានការអនុញ្ញាតឧបករណ៍!',
    es: '¡No se pudieron obtener permisos del dispositivo!',
    ar: 'فشل الحصول على أذونات الجهاز!',
  },
  'lineManager.sawAddNumber': {
    zh: '您当前可使用的电子锯生产线条数已用完，如需增加，请联系销售！',
    en: 'Your available e-saw production lines have been used up. If you need to increase the limit, please contact sales!',
    id: 'Jumlah lini produksi gergaji elektronik yang tersedia telah habis. Jika perlu menambah, silakan hubungi penjualan!',
    kz: 'Сіздің қолданылатын электронды ара құралдар желісінің шегі таусылды. Қосымша қажет болса, сату бөліміне хабарласыңыз!',
    th: 'จำนวนไลน์ผลิตเลื่อยไฟฟ้าที่คุณใช้ได้หมดแล้ว หากต้องการเพิ่ม กรุณาติดต่อฝ่ายขาย!',
    ug: 'سىزنىڭ ئىشلىتەلىىدىغان ئېلېكترون پارچە سانائىتى قۇرىسى تۈگىدى. ئەگەر كۆپەيتىش زۆرۈر بولسا، ساتىش بۆلۈمى بىلەن ئالاقىلىشىڭ!',
    vi: 'Số dây chuyền sản xuất cưa điện tử hiện có của bạn đã hết. Nếu cần tăng thêm, vui lòng liên hệ bộ phận bán hàng!',
    zh_tc: '您當前可使用的電子鋸生產線條數已用完，如需增加，請聯繫銷售！',
    ru: 'Количество линий по производству электронных пил, которые вы можете использовать в настоящее время, исчерпано, и если вам нужно увеличить, свяжитесь с продажами!',
    ko: '당신이 현재 사용할 수 있는 전자톱 생산 라인 수가 이미 다 떨어졌습니다. 추가하려면 판매에 연락하세요!',
    bur: 'လက်ရှိအသုံးပြုနိုင်သောအီလက်ထရွန်းနစ်ဆောထုတ်လုပ်မှုလိုင်းအရေအတွက်ကုန်ပြီ၊ တိုးလိုပါကအရောင်းနှင့်ဆက်သွယ်ပါ!',
    ben: 'আপনার উপলব্ধ ই-স saw প্রোডাকশন লাইন শেষ। সীমা বাড়াতে চাইলে সেলসের সাথে যোগাযোগ করুন!',
    tr: 'Kullanılabilir elektronik testere üretim hatlarınız doldu; artırmak için satışla iletişime geçin',
    km: 'ខ្សែផលិតកម្មរណាអេឡិចត្រូនិកដែលអាចប្រើបានរបស់អ្នកអស់ហើយ បង្កើនសូមទាក់ទងលក់',
    es: 'El número de líneas de producción de sierras electrónicas actualmente disponibles para usted se ha agotado. Si necesita aumentar, ¡póngase en contacto con ventas!',
    ar: 'تم استنفاد عدد خطوط إنتاج المنشار الإلكتروني المتوفرة لديكم حالياً. إذا كنت بحاجة إلى زيادة، يرجى الاتصال بالمبيعات!',
  },
  'lineManager.newLine': {
    zh: '新建生产线{idx}',
    en: 'New Production Line {idx}',
    id: 'Buat jalur produksi baru {idx}',
    kz: 'Жаңа өндіріс желісі {idx}',
    th: 'สร้างสายการผลิตใหม่ {idx}',
    ug: 'يېڭى ئىشلەپچىقىرىش لىنىيىسى {idx}',
    vi: 'Tạo dây chuyền sản xuất mới {idx}',
    zh_tc: '新建生產線{idx}',
    ru: 'Создание новой линии производства {idx}',
    ko: '새로운 생산 라인 {idx}',
    bur: 'ထုတ်လုပ်မှုလိုင်းအသစ်{idx}',
    ben: 'নতুন প্রোডাকশন লাইন {idx}',
    tr: 'Yeni üretim hattı {idx}',
    km: 'ខ្សែផលិតកម្មថ្មី {idx}',
    es: 'Nueva línea de producción {idx}',
    ar: 'خط إنتاج جديد {idx}',
  },
  'lineManager.deleteCheck': {
    zh: '不能全部删除',
    en: 'Cannot delete all',
    id: 'Tidak bisa menghapus semua',
    kz: 'Бәрін де жоюға болмайды',
    th: 'ไม่สามารถลบทั้งหมดได้',
    ug: 'ھەممىنى ئۆچۈرەلمەيسىز',
    vi: 'Không thể xóa tất cả',
    zh_tc: '不能全部刪除',
    ru: 'Не все можно удалить',
    ko: '모두 삭제할 수 없음',
    bur: 'အားလုံးဖျက်မရ',
    ben: 'সব মুছতে পারবেন না',
    tr: 'Tümünü silmek mümkün değil',
    km: 'មិនអាចលុបទាំងអស់',
    es: 'No se pueden eliminar todas',
    ar: 'لا يمكن حذف الكل',
  },
  'lineManager.deving': {
    zh: '开发中',
    en: 'Under Development',
    id: 'Dalam pengembangan',
    kz: 'Қазіргіде әзірлеуде',
    th: 'อยู่ระหว่างการพัฒนา',
    ug: 'ئىجاد قىلىنىۋاتىدۇ',
    vi: 'Đang phát triển',
    zh_tc: '開發中',
    ru: 'В стадии разработки',
    ko: '개발 중',
    bur: 'ဖွံ့ဖြိုးဆဲ',
    ben: 'ডেভেলপমেন্ট চলছে',
    tr: 'Geliştirme aşamasında',
    km: 'កំពុងអភិវឌ្ឍ',
    es: 'En desarrollo',
    ar: 'قيد التطوير',
  },
  'lineManager.combinTip': {
    zh: '请点击下方组合设备设置进行设置',
    en: 'Please set up the combined equipment below',
    id: 'Silakan klik yang berikut untuk menggabungkan pengaturan perangkat untuk mengatur',
    kz: 'Өңдеу құрылғыларының комбинациясын орнату үшін төмендегі орнына басыңыз',
    th: 'โปรดคลิกที่สิ่งต่อไปนี้เพื่อรวมการตั้งค่าอุปกรณ์เพื่อตั้งค่า',
    ug: 'تۆۋەندىكى بىرلەشتۈرۈلگەن ئۈسكۈنىلەر تەڭشىكىنى چېكىپ تەڭشەڭ',
    vi: 'Vui lòng nhấn vào thiết lập thiết bị kết hợp bên dưới để cài đặt',
    zh_tc: '請點擊下方組合設備設置進行設置',
    ru: 'Нажмите ниже для настройки комбинации устройств',
    ko: '아래 콤보 장치 설정을 클릭하여 설정하세요',
    bur: 'အောက်ပါပေါင်းစည်းစက်ဆက်တင်ကိုနှိပ်ပြီးသတ်မှတ်ပါ',
    ben: 'নিচের কম্বাইন্ড ইকুইপমেন্ট সেট আপ করতে ক্লিক করুন',
    tr: 'Aşağıdaki birleşik ekipman ayarına tıklayarak yapılandırın',
    km: 'សូមចុចការកំណត់ឧបករណ៍រួមបញ្ចូលខាងក្រោមដើម្បីកំណត់',
    es: 'Haga clic en la configuración del equipo combinado a continuación para configurar',
    ar: 'يرجى النقر فوق إعدادات المعدات المجمعة أدناه لإعداد',
  },
  'lineManager.noUseEquip': {
    zh: '未启用加工设备',
    en: 'Processing Equipment Not Enabled',
    id: 'Pemrosesan peralatan tidak diaktifkan',
    kz: 'Өңдеу құрылғысы іске қосылмаған',
    th: 'ไม่เปิดใช้งานอุปกรณ์ประมวลผล',
    ug: 'ئىشلەپچىقىرىش ئۈسكۈنىسى قوزغىتىلمىغان',
    vi: 'Thiết bị gia công chưa được kích hoạt',
    zh_tc: '未啟用加工設備',
    ru: 'Оборудование не включено',
    ko: '머시닝 장치 사용 안 함',
    bur: 'ပြုပြင်စက်မဖွင့်ရသေး',
    ben: 'প্রসেসিং ইকুইপমেন্ট সক্ষম নেই',
    tr: 'İşleme ekipmanı etkin değil',
    km: 'ឧបករណ៍ដំណើរការមិនបានបើក',
    es: 'El equipo de procesamiento no está habilitado',
    ar: 'لم يتم تمكين معدات المعالجة',
  },
  'lineManager.equipmentSelectTip': {
    zh: '组合设备选择了开料机时，开料设备不能选择电子锯',
    en: 'When selecting combined equipment with a cutting machine, the cutting equipment cannot be set to an electronic saw',
    id: 'Ketika mesin pemotong dipilih untuk peralatan gabungan, mesin pemotong tidak dapat memilih gergaji elektronik.',
    kz: 'Комбинациялық жабдықтарда кескіш машина таңдалған болса, кескіш машинасы электронды пісіру машинасы таңдалуыға болмайды',
    th: 'เมื่อเลือกเครื่องตัดสำหรับอุปกรณ์รวมเครื่องตัดไม่สามารถเลือกเลื่อยอิเล็กทรอนิกส์ได้',
    ug: 'بىرلەشتۈرۈلگەن ئۈسكۈنىلەر كېسىش ئۈسكۈنىسىنى تاللىغاندا، كېسىش ئۈسكۈنىسى ئېلېكترون ماكانى تاللىيالمايدۇ',
    vi: 'Khi thiết bị kết hợp chọn máy cắt gọt, thiết bị cắt gọt không thể chọn máy cưa điện tử',
    zh_tc: '組合設備選擇了雕刻機時，開料設備不能選擇電子鋸',
    ru: 'Когда комбинированное оборудование выбирает распылитель, распылитель не может выбрать электронную пилу',
    ko: '조립 설비가 원료 공급기를 선택했을 때, 원료 공급 설비는 전자톱을 선택할 수 없다',
    bur: 'ပေါင်းစည်းစက်တွင်ဖြတ်စက်ရွေးသည့်အခါဖြတ်စက်သည်အီလက်ထရွန်းနစ်ဆောမရွေးနိုင်',
    ben: 'কম্বাইন্ড ইকুইপমেন্টে কাটিং মেশিন নির্বাচন করলে কাটিং ইকুইপমেন্ট ইলেকট্রনিক স saw নির্বাচন করতে পারবে না',
    tr: 'Birleşik ekipmanda kesim makinesi seçildiğinde kesim ekipmanı elektronik testere olamaz',
    km: 'ពេលជ្រើសម៉ាស៊ីនកាត់ក្នុងឧបករណ៍រួម ឧបករណ៍កាត់មិនអាចជារណាអេឡិចត្រូនិក',
    es: 'Cuando se selecciona la máquina de corte para el equipo combinado, el equipo de corte no puede seleccionar la sierra electrónica',
    ar: 'عند تحديد آلة القطع لمعدات التجميع، لا يمكن لمعدات القطع تحديد المنشار الإلكتروني',
  },
  'lineManager.lineLoading': {
    zh: '数据加载中',
    en: 'Data Loading',
    id: 'Data sedang memuat',
    kz: 'Деректер жүктеледі',
    th: 'ข้อมูลกำลังโหลด',
    ug: 'سانلىق مەلۇمات يۈكلىنىۋاتىدۇ',
    vi: 'Dữ liệu đang tải',
    zh_tc: '數據加載中',
    ru: 'Данные загружаются',
    ko: '데이터 로드 중',
    bur: 'ဒေတာလာနေသည်',
    ben: 'ডেটা লোড হচ্ছে',
    tr: 'Veri yükleniyor',
    km: 'កំពុងផ្ទុកទិន្នន័យ',
    es: 'Se están cargando datos',
    ar: 'يتم تحميل البيانات',
  },
  'lineManager.strenchType': {
    zh: '拉直器槽类型',
    en: 'Straightener Slot Type',
    id: 'Jenis slot pelurus',
    kz: 'Түзеткіш слот типі',
    th: 'ประเภทสล็อตเส้นตรง',
    ug: 'توغرا ئويۇق تىپى',
    vi: 'Loại khe máy kéo thẳng',
    zh_tc: '拉直器槽類型',
    ru: 'Тип выпрямителя',
    ko: '스트레이트 슬롯 유형',
    bur: 'ဆွဲဖြောင့်ချောင်းအမျိုးအစား',
    ben: 'স্ট্রেইটনার স্লট টাইপ',
    tr: 'Düzleştirici oluk tipi',
    km: 'ប្រភេទរណ្តៅឧបករណ៍ទាញផ្តិត',
    es: 'Tipo de ranura enderezadora',
    ar: 'نوع فتحة جهاز فرد الشعر',
  },
  'lineManager.aioProcessTip': {
    zh: '您已启用"一体机"设备，加工方式默认为加工板件正反面孔槽',
    en: 'You have enabled the "All-in-One" device, processing mode defaults to processing both sides of the planks with holes and slots',
    id: 'Anda telah mengaktifkan perangkat "all-in-one", dan metode pemrosesan adalah memproses alur wajah depan dan belakang dari bagian pelat secara default',
    kz: 'Сіз "Барлығын бірден" құрылғысын қосқансыз, өңдеу режимі әдепкі бойынша тақтайлардың екі жағын да тесіктермен және ойықтармен өңдеу болып табылады',
    th: 'คุณได้เปิดใช้งานอุปกรณ์ "all-in-one" และวิธีการประมวลผลคือการประมวลผลร่องด้านหน้าและด้านหลังของชิ้นส่วนแผ่นตามค่าเริ่มต้น',
    ug: 'سىز "بىرلىك ماشىنا" ئۈسكۈنىسىنى قوزغىتىپ قويدىڭىز، ئىشلەش ئۇسۇلى سۈكۈتتىكى تاختا ئالدىنقى-ئارقا تەرەپ تېشىك/ئويۇقىنى ئىشلەش',
    vi: 'Bạn đã bật thiết bị "Tất cả trong một", chế độ xử lý mặc định là xử lý các lỗ và rãnh trên cả hai mặt của tấm ván',
    zh_tc: '您已啟用"一體機"設備，加工方式默認為加工板件正反面孔槽',
    ru: 'Вы включили устройство « One Machines», способ обработки по умолчанию для обработки листов с положительным и отрицательным отверстием',
    ko: '올인원 장치를 활성화했습니다. 기본값은 가공 플레이트 부품의 양수 얼굴 슬롯입니다.',
    bur: 'သင့်သည်တစ်ကိုယ်ရည်စက်ဖွင့်ပြီး၊ ပြုပြင်နည်းမူရင်းသည်ပြားရှေ့အနောက်အပေါက်ချောင်းပြု',
    ben: 'আপনি অল-ইন-ওয়ান ডিভাইস সক্ষম করেছেন, প্রসেসিং মোড ডিফল্টে বোর্ডের দুদিকের হোল ও স্লট প্রসেস করে',
    tr: 'Tüm-bir arada cihazı etkinleştirdiniz; varsayılan işleme plakanın ön ve arka delik/oluklarıdır',
    km: 'អ្នកបានបើកឧបករណ៍រួមបញ្ចូល របៀបដំណើរការលំនាំដើមគឺរណ្តៅ និងរណ្តៅមុខ និងក្រោយផ្ទាំង',
    es: 'Ha habilitado el dispositivo "máquina todo en uno" y el método de procesamiento predeterminado es procesar los orificios frontal y posterior de la placa',
    ar: 'لقد قمت بتمكين جهاز "الجهاز متعدد الإمكانات"، وتكون طريقة المعالجة افتراضية لمعالجة الفتحات الأمامية والخلفية للوحة',
  },
  'lineManager.aioProcessTip2': {
    zh: '启用一体机后在雕刻机部分加工的特殊孔槽',
    en: 'After enabling the All-in-One, special holes and slots will be processed in the carving machine section',
    id: 'Alur lubang khusus yang diproses di mesin ukiran setelah mesin all-in-one diaktifkan',
    kz: 'Барлығын қосқаннан кейін арнайы тесіктер мен ойықтар кесу машинасы бөлімінде өңделеді',
    th: 'ร่องรูพิเศษที่ประมวลผลในเครื่องแกะสลักหลังจากเปิดใช้งานเครื่อง all-in-one',
    ug: 'بىرلىك ماشىنىسى قوزغىتىلغاندا ئويما قىسمىدىكى ئىشلەنگەن ئالاھىدە تېشىك/ئويۇق',
    vi: 'Sau khi bật thiết bị Tất cả trong một, các lỗ và rãnh đặc biệt sẽ được xử lý trong phần máy khắc',
    zh_tc: '啟用一體機後在雕刻機部分加工的特殊孔槽',
    ru: 'Специальные отверстия, обработанные частично гравировальной машиной после включения монолитной машины',
    ko: '올인원 사용 후 조각기 부분에서 가공된 특수 슬롯',
    bur: 'တစ်ကိုယ်ရည်စက်ဖွင့်ပြီးနောက်ထွင်းစက်အပိုင်းတွင်ပြုသောအထူးအပေါက်ချောင်းများ',
    ben: 'অল-ইন-ওয়ান সক্ষম করার পর ক্যারভিং মেশিন সেকশনে বিশেষ হোল ও স্লট প্রসেস হবে',
    tr: 'Tüm-bir arada açıldıktan sonra oyma bölümünde işlenen özel delik/oluklar',
    km: 'រណ្តៅ និងរណ្តៅពិសេសដែលដំណើរការនៅផ្នែកចុកចាក់បន្ទាប់ពីបើករួមបញ្ចូល',
    es: 'Ranuras de orificios especiales procesadas en el grabado pieza de la máquina después de habilitar la máquina todo en uno',
    ar: 'فتحات ثقب خاصة تتم معالجتها في جزء آلة النقش بعد تمكين الجهاز متعدد الإمكانات',
  },
  'lineManager.aioProcessTip3': {
    zh: '注意：该功能不兼容启用XY轴互换的雕刻机 请谨慎使用',
    en: 'Attention: This function is not compatible with carving machines that have enabled the XY axis swap function. Please use with caution',
    id: 'Catatan: Fungsi ini tidak kompatibel dengan mesin ukiran yang memungkinkan pertukaran sumbu XY. Harap gunakan dengan hati -hati.',
    kz: 'Ескерту: Бұл функция XY осін ауыстыру функциясын қосқан кесу машиналарымен үйлесімді емес. Оны мұқият қолданыңыз',
    th: 'หมายเหตุ: ฟังก์ชั่นนี้เข้ากันได้กับเครื่องแกะสลักที่เปิดใช้งานการแลกเปลี่ยนแกน XY โปรดใช้ด้วยความระมัดระวัง',
    ug: 'دىققەت: بۇ ئىقتىدار XY ئوچنى ئالماشتۇرۇلغان ئويما ماشىنىسى بىلەن ماسلىشمايدۇ، دىققەتلىك ئىشلىتىڭ',
    vi: 'Lưu ý: Chức năng này không tương thích với các máy khắc đã bật chức năng hoán đổi trục XY. Vui lòng sử dụng cẩn thận',
    zh_tc: '注意：該功能不兼容啟用XY軸互換的雕刻機 請謹慎使用',
    ru: 'Примечание: Эта функция несовместима с гравировальной машиной, которая включает обмен осями XY. Используйте ее с осторожностью.',
    ko: '참고: 이 기능은 XY 축 교환이 활성화된 조각기와 호환되지 않으므로 주의해서 사용하십시오.',
    bur: 'သတိပြု-ဤလုပ်ဆောင်ချက်သည် XY ဝင်ရိုးပြောင်းဖွင့်ထားသောထွင်းစက်နှင့်မကိုက်ညီ၊ သတိထားသုံးပါ',
    ben: 'নোট: এই ফাংশন XY অক্ষ সোয়াপ সক্ষম ক্যারভিং মেশিনের সাথে সামঞ্জস্যপূর্ণ নয়। সাবধানে ব্যবহার করুন',
    tr: 'Dikkat: Bu işlev XY eksen takası açık oyma makineleriyle uyumlu değildir; dikkatli kullanın',
    km: 'ចំណាំ៖ មុខងារនេះមិនសមស្របនឹងម៉ាស៊ីនចុកចាក់ដែលបើកប្តូរអ័ក្ស XY ទេ សូមប្រយ័ត្ន',
    es: 'Nota: Esta función no es compatible con máquinas de grabado que habilitan el intercambio de ejes XY. Úselo con precaución',
    ar: 'ملاحظة: هذه الوظيفة غير متوافقة مع آلات النقش التي تتيح تبادل المحاور XY. يرجى الاستخدام بحذر',
  },
  'lineManager.specialHoleTip': {
    zh: '注意：使用以上“加工的特殊孔槽”的功能时请将“通孔打孔方式”和“通槽打穿方式”设置为一次打穿',
    en: 'Attention: When using the above "special hole slot processing" function, please set the "through-hole drilling method" and "through-slot penetration method" to drill through at once',
    id: 'CATATAN: Saat menggunakan fungsi di atas dari "slot lubang khusus yang diproses", silakan atur "melalui metode pukulan lubang" dan "melalui metode meninju slot" untuk ditinju pada satu waktu.',
    kz: 'Ескерту: Жоғарыдағы "арнайы тесіктерді өңдеу" функциясын қолданған кезде "сквозное сверление" және "сквозное фрезерование" параметрлерін бір рет бұрғылап өту үшін орнатыңыз',
    th: 'หมายเหตุ: เมื่อใช้ฟังก์ชั่นด้านบนของ "ช่องโหว่พิเศษที่ประมวลผล" โปรดตั้งค่า "ผ่านวิธีการเจาะรู" และ "ผ่านวิธีการเจาะช่องสล็อต" ที่จะเจาะในครั้งเดียว',
    ug: 'دىققەت: يۇقىرىدىكى "ئىشلەنگەن ئالاھىدە تېشىك/ئويۇق" ئىقتىدارىنى ئىشلەتكەندە، "ئۆتۈش تېشىكى ئېچىش ئۇسۇلى" ۋە "ئۆتۈش ئويۇقى ئېچىش ئۇسۇلى" نى بىر قېتىمدا ئېچىش قىلىپ تەڭشەڭ',
    vi: 'Lưu ý: Khi sử dụng chức năng "xử lý lỗ rãnh đặc biệt" trên, vui lòng đặt "phương pháp khoan lỗ thông" và "phương pháp xuyên rãnh" để khoan qua một lần',
    zh_tc:
      '注意：使用以上"加工的特殊孔槽"的功能時請將"通孔打孔方式"和"通槽打穿方式"設置為一次打穿',
    ru: 'ПРИМЕЧАНИЕ: При использовании вышеуказанных функций « обработанных специальных отверстий» установите « способ перфорации сквозного отверстия» и « способ перфорации сквозного отверстия» для однократного пробоя',
    ko: '참고: 위의 가공된 특수 구멍 슬롯 기능을 사용할 때는 구멍 뚫기 및 구멍 뚫기 를 한 번에 뚫기 로 설정합니다.',
    bur: 'သတိပြု-အထက်ပြုပြင်သောအထူးအပေါက်ချောင်းသုံးသည့်အခါအပေါက်ဖောက်နည်းနှင့်ချောင်းဖောက်နည်းကိုတစ်ကြိမ်ဖောက်သတ်မှတ်ပါ',
    ben: 'নোট: উপরের বিশেষ হোল স্লট প্রসেসিং ব্যবহার করলে থ্রু-হোল ড্রিলিং ও থ্রু-স্লট পেনিট্রেশন একবারে ড্রিল থ্রু সেট করুন',
    tr: 'Dikkat: Yukarıdaki özel delik/oluk işlemini kullanırken delikten geçirme ve oluktan geçirme yöntemlerini bir seferde tam delme olacak şekilde ayarlayın',
    km: 'ចំណាំ៖ ពេលប្រើមុខងារដំណើរការរណ្តៅពិសេសខាងលើ សូមកំណត់វិធីរណ្តៅរន្ធដោត និងរណ្តៅឆ្លងជាការរណ្តៅមួយដង',
    es: 'Nota: Cuando utilice la función anterior "Ranuras de orificios especiales procesadas", configure el "Método de perforación de orificios pasantes" y el "Método de perforación de ranuras" en una perforación única',
    ar: 'ملاحظة: عند استخدام وظيفة "معالجة فتحات الفتحات الخاصة" المذكورة أعلاه، يرجى ضبط "طريقة التثقيب عبر الفتحة" و"طريقة التثقيب عبر الفتحة" على التثقيب لمرة واحدة',
  },
  'lineManager.specialHoleTip2': {
    zh: '注意：使用以上“加工的特殊孔槽”的功能时请将雕刻机“通孔打孔方式”和“通槽打穿方式”设置为一次打穿',
    en: 'Attention: When using the above "special hole slot processing" function, please set the carving machine’s "through-hole drilling method" and "through-slot penetration method" to drill through at once',
    id: 'Catatan: Saat menggunakan fungsi "slot lubang khusus yang diproses di atas, silakan atur mesin ukiran" melalui metode pengeboran lubang "dan" melalui metode pengeboran alur "untuk ditinju pada satu waktu.',
    kz: 'Ескерту: Жоғарыдағы "арнайы тесіктерді өңдеу" функциясын қолданған кезде кесу машинасының "сквозное сверление" және "сквозное фрезерование" параметрлерін бір рет бұрғылап өту үшін орнатыңыз',
    th: 'หมายเหตุ: เมื่อใช้ฟังก์ชั่น "ช่องโหว่พิเศษที่ประมวลผลข้างต้นข้างต้นโปรดตั้งค่าเครื่องแกะสลัก" ด้วยวิธีการขุดเจาะรู "และ" ผ่านวิธีการขุดเจาะร่อง "ที่จะเจาะในครั้งเดียว',
    ug: 'دىققەت: يۇقىرىدىكى "ئىشلەنگەن ئالاھىدە تېشىك/ئويۇق" ئىقتىدارىنى ئىشلەتكەندە، ئويما ماشىنىسىدىكى "ئۆتۈش تېشىكى ئېچىش ئۇسۇلى" ۋە "ئۆتۈش ئويۇقى ئېچىش ئۇسۇلى" نى بىر قېتىمدا ئېچىش قىلىپ تەڭشەڭ',
    vi: 'Lưu ý: Khi sử dụng chức năng "xử lý lỗ rãnh đặc biệt" trên, vui lòng đặt máy khắc "phương pháp khoan lỗ thông" và "phương pháp xuyên rãnh" để khoan qua một lần',
    zh_tc:
      '注意：使用以上"加工的特殊孔槽"的功能時請將雕刻機"通孔打孔方式"和"通槽打穿方式"設置為一次打穿',
    ru: 'Примечание: При использовании вышеуказанных функций « обработанных специальных отверстий» установите гравировальный станок « способ перфорации сквозного отверстия» и « способ перфорации сквозного отверстия» для однократного пробоя',
    ko: '참고: 위의 가공된 특수 구멍 슬롯 기능을 사용할 때는 조각기 구멍 뚫기 및 구멍 뚫기 를 한 번에 뚫기 로 설정하십시오.',
    bur: 'သတိပြု-အထက်ပြုပြင်သောအထူးအပေါက်ချောင်းသုံးသည့်အခါထွင်းစက်အပေါက်ဖောက်နည်းနှင့်ချောင်းဖောက်နည်းကိုတစ်ကြိမ်ဖောက်သတ်မှတ်ပါ',
    ben: 'নোট: উপরের বিশেষ হোল স্লট প্রসেসিং ব্যবহার করলে ক্যারভিং মেশিনের থ্রু-হোল ও থ্রু-স্লট একবারে ড্রিল থ্রু সেট করুন',
    tr: 'Dikkat: Yukarıdaki özel delik/oluk işlemini kullanırken oyma makinesinde delikten geçirme ve oluktan geçirme yöntemlerini bir seferde tam delme olacak şekilde ayarlayın',
    km: 'ចំណាំ៖ ពេលប្រើមុខងារខាងលើ សូមកំណត់នៅម៉ាស៊ីនចុកចាក់វិធីរណ្តៅរន្ធដោត និងរណ្តៅឆ្លងជារណ្តៅមួយដង',
    es: 'Nota: Cuando utilice la función "Ranuras de orificios especiales procesadas" anterior, configure el "Método de perforación de orificios pasantes" y el "Método de perforación de ranuras pasantes" de la máquina de grabado en una perforación de una sola vez',
    ar: 'ملاحظة: عند استخدام وظيفة "معالجة فتحات الفتحات الخاصة" المذكورة أعلاه، يرجى ضبط "طريقة الحفر عبر الفتحة" و"طريقة التثقيب عبر الفتحة" على التثقيب لمرة واحدة فقط',
  },
  'lineManager.fiveSixNotTake': {
    zh: '此选项对五/六面钻默认模板不生效',
    en: 'This option does not apply to the default templates for five/six-sided drilling',
    id: 'Opsi ini tidak berlaku pada template default bor lima/enam sisi.',
    kz: 'Бұл параметр бес/алты жағынан бұрғылау үшін әдепкі шаблондарға қолданылмайды',
    th: 'ตัวเลือกนี้ไม่มีผลกับเทมเพลตเริ่มต้นของการฝึกซ้อมห้า/หกด้าน',
    ug: 'بۇ تاللاش بەش/ئالتە تەرەپلىك ماتور سۈكۈتتىكى قېلىپىغا تەسىر قىلمايدۇ',
    vi: 'Tùy chọn này không áp dụng cho các mẫu khoan mặc định năm/sáu mặt',
    zh_tc: '此選項對五/六面鑽默認模板不生效',
    ru: 'Этот параметр не работает для шаблонов по умолчанию для пятигранного бурения',
    ko: '이 옵션은 5 / 6 드릴 기본 템플릿에 적용되지 않습니다.',
    bur: 'ဤရွေးချယ်မှုငါး/ခြောက်မျက်နှာတွင်းထွင်းမူရင်းပုံစံတွင်မသက်ရောက်',
    ben: 'এই অপশন পাঁচ/ছয়-পাশ ড্রিলিংয়ের ডিফল্ট টেমপ্লেটে প্রযোজ্য নয়',
    tr: 'Bu seçenek beş/altı yüz delik varsayılan şablonlarında geçerli değildir',
    km: 'ជម្រើសនេះមិនអនុវត្តលើពុម្ពលំនាំដើមរណ្តៅប្រាំ/ប្រាំមួយមុខទេ',
    es: 'Esta opción no es efectiva para la plantilla predeterminada de perforación de cinco/seis lados',
    ar: 'هذا الخيار غير فعال بالنسبة للقالب الافتراضي للحفر الخماسي/السداسي',
  },
  'lineManager.onlyFrontSide': {
    zh: '仅加工正面',
    en: 'Process front side only',
    id: 'Proses hanya depan',
    kz: 'Тек алдыңғы жағын өңдеу',
    th: 'ดำเนินการด้านหน้าเท่านั้น',
    ug: 'پەقەت ئالدىنقى تەرەپنى ئىشلەش',
    vi: 'Chỉ gia công mặt trước',
    zh_tc: '僅加工正面',
    ru: 'Обрабатывается только спереди.',
    ko: '전면만 가공',
    bur: 'ရှေ့မျက်နှာသာပြု',
    ben: 'শুধুমাত্র সামনের দিক প্রসেস করুন',
    tr: 'Yalnızca ön yüzü işle',
    km: 'ដំណើរការតែមុខ',
    es: 'Procese solo el frente lado.',
    ar: 'معالجة فقط الجانب الأمامي.',
  },
  'lineManager.onlyBackSide': {
    zh: '仅加工反面',
    en: 'Process back side only',
    id: 'Memproses sisi terbalik saja',
    kz: 'Тек артқы жағын өңдеу',
    th: 'ประมวลผลด้านย้อนกลับเท่านั้น',
    ug: 'پەقەت ئارقا تەرەپنى ئىشلەش',
    vi: 'Chỉ gia công mặt sau',
    zh_tc: '僅加工反面',
    ru: 'Обрабатывается только обратная сторона',
    ko: '후면만 가공',
    bur: 'အနောက်မျက်နှာသာပြု',
    ben: 'শুধুমাত্র পিছনের দিক প্রসেস করুন',
    tr: 'Yalnızca arka yüzü işle',
    km: 'ដំណើរការតែក្រោយ',
    es: 'Sólo se procesa el reverso',
    ar: 'تتم معالجة الجانب العكسي فقط',
  },
  'lineManager.less': {
    zh: '小于',
    en: 'Less than',
    id: 'Kurang dari',
    kz: 'Кіші',
    th: 'น้อยกว่า',
    ug: 'كىچىك',
    vi: 'Nhỏ hơn',
    zh_tc: '小於',
    ru: 'меньше',
    ko: '미만',
    bur: 'ထို့ထက်ငယ်',
    ben: 'এর চেয়ে কম',
    tr: 'Daha küçük',
    km: 'តូចជាង',
    es: 'Menos de',
    ar: 'أقل من',
  },
  'lineManager.equal': {
    zh: '等于',
    en: 'Equal to',
    id: 'setara',
    kz: 'Тең',
    th: 'เท่ากัน',
    ug: 'تەڭ',
    vi: 'Bằng',
    zh_tc: '等於',
    ru: 'Равно',
    ko: '같음',
    bur: 'ညီမျှ',
    ben: 'সমান',
    tr: 'Eşittir',
    km: 'ស្មើ',
    es: 'igual a',
    ar: 'يساوي',
  },
  'lineManager.greater': {
    zh: '大于',
    en: 'Greater than',
    id: 'Lebih besar dari',
    kz: 'Үлкен',
    th: 'สูงกว่า',
    ug: 'چوڭ',
    vi: 'Lớn hơn',
    zh_tc: '大於',
    ru: 'более',
    ko: '보다 크다',
    bur: 'ထို့ထက်ကြီး',
    ben: 'এর চেয়ে বড়',
    tr: 'Büyüktür',
    km: 'ធំជាង',
    es: 'mayor que',
    ar: 'أكبر من',
  },
  'lineManager.or': {
    zh: '或',
    en: 'Or',
    id: 'atau',
    kz: 'Немесе',
    th: 'หรือ',
    ug: 'ياكى',
    vi: 'Hoặc',
    zh_tc: '或',
    ru: 'или',
    ko: '또는',
    bur: 'သို့မဟုတ်',
    ben: 'অথবা',
    tr: 'Veya',
    km: 'ឬ',
    es: 'o',
    ar: 'أو',
  },
  'lineManager.and': {
    zh: '且',
    en: 'And',
    id: 'Dan',
    kz: 'Және',
    th: 'และ',
    ug: 'ۋە',
    vi: 'Và',
    zh_tc: '且',
    ru: 'А',
    ko: '그리고',
    bur: 'နှင့်',
    ben: 'এবং',
    tr: 'Ve',
    km: 'និង',
    es: 'y',
    ar: 'و',
  },
  'lineManager.bothFrontBack': {
    zh: '加工正面和反面',
    en: 'Process both front and back sides',
    id: 'Memproses bagian depan dan sebaliknya',
    kz: 'Алдыңғы және артқы жағын өңдеу',
    th: 'ประมวลผลด้านหน้าและด้านหลัง',
    ug: 'ئالدىنقى ۋە ئارقا تەرەپنى ئىشلەش',
    vi: 'Gia công cả mặt trước và mặt sau',
    zh_tc: '加工正面和反面',
    ru: 'Обработка спереди и сзади',
    ko: '전면 및 후면 가공하기',
    bur: 'ရှေ့အနောက်နှစ်ဘက်ပြု',
    ben: 'সামনে ও পিছনে উভয় দিক প্রসেস করুন',
    tr: 'Ön ve arka yüzleri işle',
    km: 'ដំណើរការទាំងមុខ និងក្រោយ',
    es: 'procesamiento frontal y posterior',
    ar: 'معالجة أمامية وخلفية',
  },
  'lineManager.shareDataErrTip': {
    zh: '此条数据由{operatorPhone}应用,ip:{actionIp}',
    en: 'This data is applied by {operatorPhone} , IP: {actionIP}',
    id: 'Bagian data ini diterapkan oleh {OperatorPhone}, IP: {actip}',
    kz: 'Бұл деректер {operatorPhone} арқылы қолданылады, ip: {actionIp}',
    th: 'ข้อมูลชิ้นนี้ใช้โดย {operatorphone}, ip: {actionip}',
    ug: 'بۇ سانلىق مەلۇماتنى {operatorPhone} ئىشلەتكەن، IP: {actionIp}',
    vi: 'Dữ liệu này được tạo bởi ứng dụng {operatorPhone}, ip: {actionIp}',
    zh_tc: '此條數據由{operatorPhone}應用,ip:{actionIp}',
    ru: 'Эти данные применяются {operatorPhone}, IP: {actionIp}',
    ko: '이 데이터는 {operatorPhone}에서 적용되었으며, IP: {actionIp}',
    bur: 'ဤဒေတာကို{operatorPhone}အသုံးပြု၊ ip:{actionIp}',
    ben: 'এই ডেটা {operatorPhone} দ্বারা অ্যাপ্লাই করা, IP: {actionIp}',
    tr: 'Bu kayıt {operatorPhone} uygulamasıyla, IP: {actionIp}',
    km: 'ទិន្នន័យនេះអនុវត្តដោយ {operatorPhone}, IP៖ {actionIp}',
    es: 'Estos datos son aplicados por {operatorPhone}, ip: {actionIp}',
    ar: 'يتم تطبيق هذه البيانات بواسطة {operatorPhone}، ip: {actionIp}',
  },
  'lineManager.restoreParams': {
    zh: '还原参数',
    en: 'Restore parameters',
    id: 'Pulihkan parameter',
    kz: 'Параметрлерді қалпына келтіру',
    th: 'กู้คืนพารามิเตอร์',
    ug: 'پارامېتىرنى قايتا تەڭشەش',
    vi: 'Khôi phục tham số',
    zh_tc: '還原參數',
    ru: 'Параметры восстановления',
    ko: '복원 매개변수',
    bur: 'ပါရာမီတာပြန်ထား',
    ben: 'প্যারামিটার পুনরুদ্ধার করুন',
    tr: 'Parametreleri geri yükle',
    km: 'ស្តារប៉ារ៉ាម៉ែត្រ',
    es: 'Restaurar parámetros',
    ar: 'استعادة المعلمات',
  },
  'lineManager.loadMore': {
    zh: '加载更多',
    en: 'Load more',
    id: 'Memuat lebih banyak',
    kz: 'Көбірек жазыңыз',
    th: 'โหลดมากขึ้น',
    ug: 'تېخىمۇ كۆپ يۈكلەش',
    vi: 'Tải thêm',
    zh_tc: '加載更多',
    ru: 'Загрузить больше',
    ko: '추가 로드',
    bur: 'နောက်ထပ်လာမှု',
    ben: 'আরো লোড করুন',
    tr: 'Daha fazla yükle',
    km: 'ផ្ទុកបន្ថែម',
    es: 'Cargar más',
    ar: 'تحميل المزيد',
  },
  'lineManager.currentCombinationEquipment': {
    zh: '当前选择组合设备，开料设备不允许切换到玻璃切割机',
    en: 'The currently selected combination equipment does not allow the cutting equipment to switch to a glass cutting machine',
    id: 'Peralatan kombinasi yang dipilih saat ini tidak mengizinkan peralatan pemotong beralih ke mesin pemotong kaca',
    kz: 'Қазіргі таңдалған жабдықтар комбинациясы кесу жабдығын шыны кесу машинасына ауыстыруға мүмкіндік бермейді',
    th: 'อุปกรณ์รวมที่เลือกในปัจจุบันไม่อนุญาตให้อุปกรณ์ตัดเปลี่ยนเป็นเครื่องตัดกระจก',
    ug: 'ھازىر تاللانغان بىرلەشمە ئۈسكۈنىسى، كېسىش ئۈسكۈنىسىنى شېشى كېسىش ماتورغا ئالماشتۇرۇشقا يول قويمايدۇ',
    vi: 'Thiết bị kết hợp được chọn hiện tại không cho phép thiết bị cắt chuyển sang máy cắt kính',
    zh_tc: '當前選擇組合設備，開料設備不允許切換到玻璃切割機',
    ru: 'Текущий выбор комбинированного оборудования, открывающее устройство не позволяет переключаться на стеклорезку',
    ko: '현재 조합 장치를 선택하여 재료 공급 장치를 유리 절단기로 전환할 수 없습니다.',
    bur: 'လက်ရှိရွေးထားပေါင်းစည်းစက်ရှိသည့်အခါဖြတ်စက်သည်ဖန်ဖြတ်စက်သို့ပြောင်းခွင့်မရှိ',
    ben: 'বর্তমানে নির্বাচিত কম্বাইন্ড ইকুইপমেন্ট কাটিং ইকুইপমেন্টকে গ্লাস কাটিং মেশিনে সুইচ করতে দেয় না',
    tr: 'Birleşik ekipman seçiliyken kesim ekipmanı cam kesim makinesine geçirilemez',
    km: 'ពេលជ្រើសឧបករណ៍រួមបញ្ចូល ឧបករណ៍កាត់មិនអាចប្តូរទៅម៉ាស៊ីនកាត់កញ្ចក់',
    es: 'Equipo combinado actualmente seleccionado, el equipo de corte no permite cambiar a máquina cortadora de vidrio',
    ar: 'المعدات المركبة المحددة حاليًا، معدات القطع لا تسمح بالتبديل إلى آلة قطع الزجاج',
  },
  'lineManager.selectEquipmentType': {
    zh: '请选择设备类型',
    en: 'Please select the equipment type',
    id: 'Silakan pilih jenis peralatan',
    kz: 'Жабдық түрін таңдаңыз',
    th: 'กรุณาเลือกประเภทอุปกรณ์',
    ug: 'ئۈسكۈنىسى تۈرىنى تاللاڭ',
    vi: 'Vui lòng chọn loại thiết bị',
    zh_tc: '請選擇設備類型',
    ru: 'Выберите тип устройства',
    ko: '장치 유형을 선택하십시오.',
    bur: 'စက်အမျိုးအစားရွေးပါ',
    ben: 'ইকুইপমেন্ট টাইপ নির্বাচন করুন',
    tr: 'Ekipman türünü seçin',
    km: 'សូមជ្រើសប្រភេទឧបករណ៍',
    es: 'Seleccione el tipo de equipo',
    ar: 'يرجى تحديد نوع المعدات',
  },
  'lineManager.ruleRemark': {
    zh: '规则备注',
    en: 'Rule Remark',
    id: 'Catatan aturan',
    kz: 'Қағида ескертуі',
    th: 'หมายเหตุกฎ',
    ug: 'قۇرال نۇسخە',
    vi: 'Quy tắc nhận xét',
    zh_tc: '規則備註',
    ru: 'Примечания к правилам',
    ko: '규칙 설명',
    bur: 'စည်းမျဉ်းမှတ်ချက်',
    ben: 'রুল রিমার্ক',
    tr: 'Kural notu',
    km: 'កំណត់ចំណាំច្បាប់',
    es: 'Notas de regla',
    ar: 'ملاحظات القاعدة',
  },
  'lineManager.remarkPlaceholder': {
    zh: '这是一个备注信息，可以备注这条规则加工哪些工艺，避免遗忘，填写后保存生产线生效',
    en: 'This is a note information, can note this rule for processing which technology, avoid forgetting',
    id: 'Ini adalah informasi catatan, dapat menulis catatan aturan ini untuk memproses teknologi apa, agar tidak lupa',
    kz: 'Бұл қағида ескертуі бір мәлімет болып табылады, бұл қағида ескертуі қандай технологияларды өңдеуге болатынын еске түсіреді, ұмытпауға болады',
    th: 'นี่คือข้อมูลหมายเหตุ สามารถหมายเหตุกฎนี้ประมวลผลบนเทมเพลตใด เพื่อหลีกเลี่ยงการลืม',
    ug: 'بۇ قۇرال نۇسخە بىر مەلۇمات بولۇپ، بۇ قۇرال نۇسخە قانداق ئىشلەنگەن پروگراممىنى ئىشلەتكەندە، يۇقىرى قىلمايدۇ',
    vi: 'Đây là một thông tin ghi chú, có thể ghi chú quy tắc này gia công những công nghệ nào, tránh quên',
    zh_tc: '這是一個備註信息，可以備註這條規則加工哪些工藝，避免遺忘',
    ru: 'Это аннотированная информация, которая может указать, какие процессы обрабатывает это правило, чтобы избежать забвения, после заполнения сохранить производственную линию в действии',
    ko: '이것은 이 규칙이 어떤 공예를 가공하는지 비고하여 잊어버리지 않도록 하고, 기입한 후 생산 라인을 보존하여 효력을 발생시킬 수 있는 비고 정보이다',
    bur: 'ဤစည်းမျဉ်းမည်သည့်ပညာပြုသည်ကိုမှတ်ထားနိုင်သည်၊ မေ့ခြင်းကိုရှောင်ပါ၊ ဖြည့်ပြီးထုတ်လုပ်မှုလိုင်းသိမ်းပြီးသက်ရောက်',
    ben: 'এটি একটি নোট তথ্য, এই রুল কোন প্রযুক্তি প্রসেস করে তা নোট করতে পারেন, ভুলে যাওয়া এড়ান, লাইন সেভ করার পর প্রোডাকশন লাইনে কার্যকর হবে',
    tr: 'Kural notu: hangi işlemlerin uygulandığını yazın; unutmamak için. Doldurup üretim hattını kaydedince geçerli olur',
    km: 'កំណត់ចំណាំសម្រាប់ច្បាប់នេះ អាចកត់ដំណើរការណាខ្លះ ដើម្បីកុំភ្លេច។ បំពេញរួចរក្សាទុកខ្សែផលិតកម្មទើបមានប្រសិទ្ធភាព',
    es: 'Esta es una nota informativa. Puede anotar qué procesos procesa esta regla para evitar olvidarlos. Después de completar, guarde la línea de producción para que entre en vigor',
    ar: 'هذه معلومات ملاحظة. يمكنك ملاحظة العمليات التي تتم معالجتها بواسطة هذه القاعدة لتجنب النسيان. بعد ملئ البيانات، احفظ خط الإنتاج ليصبح ساري المفعول',
  },
  'cuttingDock.title': {
    zh: '开料对接',
    en: 'Cutting Machine Docking',
    id: 'Memotong docking',
    kz: 'Кескіш машинаны қосу',
    th: 'ตัดการเชื่อมต่อ',
    ug: 'قېپىش مۇناسىۋىتى',
    vi: 'Đối tiếp Khai Liệu',
    zh_tc: '開料對接',
    ru: 'стыковка с открытой загрузкой',
    ko: '재료 도킹',
    bur: 'ဖြတ်တောက်ချိတ်ဆက်',
    ben: 'কাটিং মেশিন ডকিং',
    tr: 'Kesim makinesi eşleştirme',
    km: 'ការភ្ជាប់ម៉ាស៊ីនកាត់',
    es: 'Apertura y acoplamiento',
    ar: 'الفتح والإرساء',
  },
  'cuttingDock.autoStockCode': {
    zh: '自动上下料代码',
    en: 'Automatic loading and unloading code',
    id: 'Kode pemuatan dan pembongkaran otomatis',
    kz: 'Автоматтық жоғары және төменгі материалдарды қосу код',
    th: 'รหัสการโหลดและขนถ่ายอัตโนมัติ',
    ug: 'ئاپتوماتىك ماتېرىيال كودى',
    vi: 'Mã tự động lên/xuống liệu',
    zh_tc: '自動上下料代碼',
    ru: 'Автоматически загружать код',
    ko: '자동 위아래 소스 코드',
    bur: 'အလိုအလျောက်အပေါ်အောက်ပစ္စည်းကုဒ်',
    ben: 'অটোমেটিক লোডিং ও আনলোডিং কোড',
    tr: 'Otomatik yükleme/boşaltma kodu',
    km: 'កូដផ្ទុក/ចុះសម្ភារៈស្វ័យប្រវត្តិ',
    es: 'Código de carga y descarga automática',
    ar: 'رمز التحميل والتفريغ التلقائي',
  },
  'cuttingDock.stationStart': {
    zh: '工位开始',
    en: 'Station Start',
    id: 'Workstation dimulai',
    kz: 'Станция басталу',
    th: 'เวิร์กสเตชันเริ่มต้นขึ้น',
    ug: 'باشلانغۇچ پوچتا',
    vi: 'Bán vị bắt đầu',
    zh_tc: '工位開始',
    ru: 'Начало работы',
    ko: '작업 위치 시작',
    bur: 'အလုပ်ဌာနစတင်',
    ben: 'স্টেশন স্টার্ট',
    tr: 'İstasyon başlangıcı',
    km: 'ការចាប់ផ្តើមកន្លែងធ្វើការ',
    es: 'Inicio de estación',
    ar: 'بدء المحطة',
  },
  'cuttingDock.stationStartCode1': {
    zh: '工位1开始代码',
    en: 'Station 1 Start Code',
    id: 'Workstation 1 Mulai Kode',
    kz: '1-стансия басталу коды',
    th: 'เวิร์กสเตชัน 1 รหัสเริ่มต้น',
    ug: 'پوچتا 1 باشلانغۇچ كودى',
    vi: 'Mã bắt đầu bán vị 1',
    zh_tc: '工位1開始代碼',
    ru: 'Станция 1 Начальный код',
    ko: '작업 위치 1 시작 코드',
    bur: 'အလုပ်ဌာန၁စတင်ကုဒ်',
    ben: 'স্টেশন ১ স্টার্ট কোড',
    tr: 'İstasyon 1 başlangıç kodu',
    km: 'កូដចាប់ផ្តើមកន្លែង ១',
    es: 'Código de inicio de estación 1',
    ar: 'رمز بدء المحطة 1',
  },
  'cuttingDock.stationStartCode1Placeholder': {
    zh: '输入工位1开始代码',
    en: 'Enter Station 1 Start Code',
    id: 'Masukkan Kode Mulai Workstation 1',
    kz: '1-стансия басталу кодын енгізу',
    th: 'ป้อนรหัสเริ่มต้นของเวิร์กสเตชัน 1',
    ug: 'پوچتا 1 باشلانغۇچ كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã bắt đầu bán vị 1',
    zh_tc: '輸入工位1開始代碼',
    ru: 'Введите начальный код станции 1',
    ko: '작업 위치 1 시작 코드 입력',
    bur: 'အလုပ်ဌာန၁စတင်ကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ১ স্টার্ট কোড লিখুন',
    tr: 'İstasyon 1 başlangıç kodunu girin',
    km: 'បញ្ចូលកូដចាប់ផ្តើមកន្លែង ១',
    es: 'Ingrese el código de inicio de estación 1',
    ar: 'أدخل رمز بدء المحطة 1',
  },
  'cuttingDock.stationStartCode2': {
    zh: '工位2开始代码',
    en: 'Station 2 Start Code',
    id: 'Workstation 2 Mulai Kode',
    kz: '2-стансия басталу коды',
    th: 'เวิร์กสเตชัน 2 รหัสเริ่มต้น',
    ug: 'پوچتا 2 باشلانغۇچ كودى',
    vi: 'Mã bắt đầu bán vị 2',
    zh_tc: '工位2開始代碼',
    ru: 'Станция 2 Начальный код',
    ko: '작업 위치 2 시작 코드',
    bur: 'အလုပ်ဌာန၂စတင်ကုဒ်',
    ben: 'স্টেশন ২ স্টার্ট কোড',
    tr: 'İstasyon 2 başlangıç kodu',
    km: 'កូដចាប់ផ្តើមកន្លែង ២',
    es: 'Código de inicio de estación 2',
    ar: 'رمز بدء المحطة 2',
  },
  'cuttingDock.stationStartCode2Placeholder': {
    zh: '输入工位2开始代码',
    en: 'Enter Station 2 Start Code',
    id: 'Masukkan Kode Mulai Workstation 2',
    kz: '2-стансия басталу кодын енгізу',
    th: 'ป้อนรหัสเริ่มต้นของเวิร์กสเตชัน 2',
    ug: 'پوچتا 2 باشلانغۇچ كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã bắt đầu bán vị 2',
    zh_tc: '輸入工位2開始代碼',
    ru: 'Введите код ввода 2.',
    ko: '작업 위치 2 시작 코드 입력',
    bur: 'အလုပ်ဌာန၂စတင်ကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ২ স্টার্ট কোড লিখুন',
    tr: 'İstasyon 2 başlangıç kodunu girin',
    km: 'បញ្ចូលកូដចាប់ផ្តើមកន្លែង ២',
    es: 'Ingrese el código de inicio de estación 2',
    ar: 'أدخل رمز بدء المحطة 2',
  },
  'cuttingDock.stationEnd': {
    zh: '工位结束',
    en: 'Station End',
    id: 'Workstation berakhir',
    kz: 'Стансия аяқталу',
    th: 'เวิร์กสเตชันสิ้นสุดลง',
    ug: 'پوچتا ئاخىرلاشقۇچ',
    vi: 'Bán vị kết thúc',
    zh_tc: '工位結束',
    ru: 'Конец рабочего места',
    ko: '작업 위치 종료',
    bur: 'အလုပ်ဌာနပြီး',
    ben: 'স্টেশন এন্ড',
    tr: 'İstasyon bitişi',
    km: 'ការបញ្ចប់កន្លែងធ្វើការ',
    es: 'Fin de estación',
    ar: 'نهاية المحطة',
  },
  'cuttingDock.stationEndCode1': {
    zh: '工位1结束代码',
    en: 'Station 1 End Code',
    id: 'Workstation 1 Kode Akhir',
    kz: '1-стансия аяқталу коды',
    th: 'เวิร์กสเตชัน 1 รหัสปลาย',
    ug: 'پوچتا 1 ئاخىرلاشقۇچ كودى',
    vi: 'Mã kết thúc bán vị 1',
    zh_tc: '工位1結束代碼',
    ru: 'Код окончания позиции 1',
    ko: '작업 위치 1 종료 코드',
    bur: 'အလုပ်ဌာန၁ပြီးကုဒ်',
    ben: 'স্টেশন ১ এন্ড কোড',
    tr: 'İstasyon 1 bitiş kodu',
    km: 'កូដបញ្ចប់កន្លែង ១',
    es: 'Código final de estación 1',
    ar: 'رمز نهاية المحطة 1',
  },
  'cuttingDock.stationEndCode1Placeholder': {
    zh: '输入工位1结束代码',
    en: 'Enter Station 1 End Code',
    id: 'Masukkan Kode Akhir Workstation 1',
    kz: '1-стансия аяқталу кодын енгізу',
    th: 'ป้อนรหัสสิ้นสุดของเวิร์กสเตชัน 1',
    ug: 'پوچتا 1 ئاخىرلاشقۇچ كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã kết thúc bán vị 1',
    zh_tc: '輸入工位1結束代碼',
    ru: 'Введите код окончания рабочего места 1',
    ko: '작업 위치 1 종료 코드 입력',
    bur: 'အလုပ်ဌာန၁ပြီးကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ১ এন্ড কোড লিখুন',
    tr: 'İstasyon 1 bitiş kodunu girin',
    km: 'បញ្ចូលកូដបញ្ចប់កន្លែង ១',
    es: 'Ingrese el código final de estación 1',
    ar: 'أدخل رمز نهاية المحطة 1',
  },
  'cuttingDock.stationEndCode2': {
    zh: '工位2结束代码',
    en: 'Station 2 End Code',
    id: 'Workstation 2 Kode Akhir',
    kz: '2-стансия аяқталу коды',
    th: 'เวิร์กสเตชัน 2 รหัสจบ',
    ug: 'پوچتا 2 ئاخىرلاشقۇچ كودى',
    vi: 'Mã kết thúc bán vị 2',
    zh_tc: '工位2結束代碼',
    ru: 'Станция 2 Конечный код',
    ko: '작업 공간 2 종료 코드',
    bur: 'အလုပ်ဌာန၂ပြီးကုဒ်',
    ben: 'স্টেশন ২ এন্ড কোড',
    tr: 'İstasyon 2 bitiş kodu',
    km: 'កូដបញ្ចប់កន្លែង ២',
    es: 'Código final de estación 2',
    ar: 'رمز نهاية المحطة 2',
  },
  'cuttingDock.stationEndCode2Placeholder': {
    zh: '输入工位2结束代码',
    en: 'Enter Station 2 End Code',
    id: 'Masukkan Kode Akhir Workstation 2',
    kz: '2-стансия аяқталу кодын енгізу',
    th: 'ป้อนรหัสสิ้นสุดของเวิร์กสเตชัน 2',
    ug: 'پوچتا 2 ئاخىرلاشقۇچ كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã kết thúc bán vị 2',
    zh_tc: '輸入工位2結束代碼',
    ru: 'Введите код окончания позиции 2',
    ko: '작업 공간 2 종료 코드 입력',
    bur: 'အလုပ်ဌာန၂ပြီးကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ২ এন্ড কোড লিখুন',
    tr: 'İstasyon 2 bitiş kodunu girin',
    km: 'បញ្ចូលកូដបញ្ចប់កន្លែង ២',
    es: 'Ingrese el código final de estación 2',
    ar: 'أدخل رمز نهاية المحطة 2',
  },
  'cuttingDock.frontBackStart': {
    zh: '正反面开始',
    en: 'Front and Back Start',
    id: 'Mulailah di depan dan belakang',
    kz: 'Алдыңғы және артқы бет басталу',
    th: 'เริ่มต้นที่ด้านหน้าและด้านหลัง',
    ug: 'ئالدى-ئارقا باشلانغۇچ',
    vi: 'Bán mặt bắt đầu',
    zh_tc: '正反面開始',
    ru: 'Начинается с противоположной стороны.',
    ko: '앞뒷면 시작',
    bur: 'ရှေ့အနောက်စတင်',
    ben: 'সামনে ও পিছনে স্টার্ট',
    tr: 'Ön-arka başlangıç',
    km: 'ចាប់ផ្តើមមុខ-ក្រោយ',
    es: 'Inicio frontal y posterior',
    ar: 'البداية الأمامية والخلفية',
  },
  'cuttingDock.frontBackEnd': {
    zh: '正反面结束',
    en: 'Front and Back End',
    id: 'Ujung depan dan belakang',
    kz: 'Алдыңғы және артқы бет аяқталу',
    th: 'ด้านหน้าและด้านหลัง',
    ug: 'ئالدى-ئارقا ئاخىرلاشقۇچ',
    vi: 'Bán mặt kết thúc',
    zh_tc: '正反面結束',
    ru: 'Положительный и отрицательный конец',
    ko: '앞뒷면 끝',
    bur: 'ရှေ့အနောက်ပြီး',
    ben: 'সামনে ও পিছনে এন্ড',
    tr: 'Ön-arka bitiş',
    km: 'បញ្ចប់មុខ-ក្រោយ',
    es: 'Extremo frontal y posterior',
    ar: 'النهاية الأمامية والخلفية',
  },
  'cuttingDock.frontStartCode': {
    zh: '正面开始代码',
    en: 'Front Start Code',
    id: 'Kode Mulai Depan',
    kz: 'Алдыңғы бет басталу коды',
    th: 'รหัสเริ่มต้น',
    ug: 'ئالدى باشلانغۇچ كودى',
    vi: 'Mã bắt đầu mặt trước',
    zh_tc: '正面開始代碼',
    ru: 'Положительный код начала',
    ko: '전면 시작 코드',
    bur: 'ရှေ့မျက်နှာစတင်ကုဒ်',
    ben: 'ফ্রন্ট স্টার্ট কোড',
    tr: 'Ön yüz başlangıç kodu',
    km: 'កូដចាប់ផ្តើមមុខ',
    es: 'Código inicial frontal',
    ar: 'رمز البداية الأمامية',
  },
  'cuttingDock.frontStartCodePlaceholder': {
    zh: '输入正面开始代码',
    en: 'Enter Front Start Code',
    id: 'Masukkan kode start depan',
    kz: 'Алдыңғы бет басталу кодын енгізу',
    th: 'ป้อนรหัสเริ่มต้น',
    ug: 'ئالدى باشلانغۇچ كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã bắt đầu mặt trước',
    zh_tc: '輸入正面開始代碼',
    ru: 'Введите код начала спереди',
    ko: '전면 시작 코드 입력',
    bur: 'ရှေ့မျက်နှာစတင်ကုဒ်ထည့်ပါ',
    ben: 'ফ্রন্ট স্টার্ট কোড লিখুন',
    tr: 'Ön yüz başlangıç kodunu girin',
    km: 'បញ្ចូលកូដចាប់ផ្តើមមុខ',
    es: 'Ingrese el código inicial inicial',
    ar: 'أدخل رمز البداية الأمامية',
  },
  'cuttingDock.frontEndCode': {
    zh: '正面结束代码',
    en: 'Front End Code',
    id: 'Kode ujung depan',
    kz: 'Алдыңғы бет аяқталу коды',
    th: 'รหัสส่วนหน้า',
    ug: 'ئالدى ئاخىرلاشقۇچ كودى',
    vi: 'Mã kết thúc mặt trước',
    zh_tc: '正面結束代碼',
    ru: 'Код положительного конца',
    ko: '전면 종료 코드',
    bur: 'ရှေ့မျက်နှာပြီးကုဒ်',
    ben: 'ফ্রন্ট এন্ড কোড',
    tr: 'Ön yüz bitiş kodu',
    km: 'កូដបញ្ចប់មុខ',
    es: 'Código final frontal',
    ar: 'رمز النهاية الأمامية',
  },
  'cuttingDock.frontEndCodePlaceholder': {
    zh: '输入正面结束代码',
    en: 'Enter Front End Code',
    id: 'Masukkan kode ujung depan',
    kz: 'Алдыңғы бет аяқталу кодын енгізу',
    th: 'ป้อนรหัสปลายด้านหน้า',
    ug: 'ئالدى ئاخىرلاشقۇچ كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã kết thúc mặt trước',
    zh_tc: '輸入正面結束代碼',
    ru: 'Введите код положительного конца',
    ko: '전면 종료 코드 입력',
    bur: 'ရှေ့မျက်နှာပြီးကုဒ်ထည့်ပါ',
    ben: 'ফ্রন্ট এন্ড কোড লিখুন',
    tr: 'Ön yüz bitiş kodunu girin',
    km: 'បញ្ចូលកូដបញ្ចប់មុខ',
    es: 'Ingrese el código final frontal',
    ar: 'أدخل رمز البداية الأمامية',
  },
  'cuttingDock.backStartCode': {
    zh: '反面开始代码',
    en: 'Back Start Code',
    id: 'Kode Mulai Terbalik',
    kz: 'Артқы бет басталу коды',
    th: 'รหัสเริ่มย้อนกลับ',
    ug: 'ئارقا باشلانغۇچ كودى',
    vi: 'Mã bắt đầu mặt sau',
    zh_tc: '反面開始代碼',
    ru: 'Код обратного начала',
    ko: '후면 시작 코드',
    bur: 'အနောက်မျက်နှာစတင်ကုဒ်',
    ben: 'ব্যাক স্টার্ট কোড',
    tr: 'Arka yüz başlangıç kodu',
    km: 'កូដចាប់ផ្តើមក្រោយ',
    es: 'Código inicial inverso',
    ar: 'رمز البداية العكسية',
  },
  'cuttingDock.backStartCodePlaceholder': {
    zh: '输入反面开始代码',
    en: 'Enter Back Start Code',
    id: 'Masukkan kode start terbalik',
    kz: 'Артқы бет басталу кодын енгізу',
    th: 'ป้อนรหัสเริ่มย้อนกลับ',
    ug: 'ئارقا باشلانغۇچ كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã bắt đầu mặt sau',
    zh_tc: '輸入反面開始代碼',
    ru: 'Введите обратный начальный код',
    ko: '후면 시작 코드 입력',
    bur: 'အနောက်မျက်နှာစတင်ကုဒ်ထည့်ပါ',
    ben: 'ব্যাক স্টার্ট কোড লিখুন',
    tr: 'Arka yüz başlangıç kodunu girin',
    km: 'បញ្ចូលកូដចាប់ផ្តើមក្រោយ',
    es: 'Ingrese el código inicial inverso',
    ar: 'أدخل رمز البداية العكسية',
  },
  'cuttingDock.backEndCode': {
    zh: '反面结束代码',
    en: 'Back End Code',
    id: 'Kode akhir terbalik',
    kz: 'Артқы бет аяқталу коды',
    th: 'รหัสปลายย้อนกลับ',
    ug: 'ئارقا ئاخىرلاشقۇچ كودى',
    vi: 'Mã kết thúc mặt sau',
    zh_tc: '反面結束代碼',
    ru: 'Код обратного конца',
    ko: '후면 끝 코드',
    bur: 'အနောက်မျက်နှာပြီးကုဒ်',
    ben: 'ব্যাক এন্ড কোড',
    tr: 'Arka yüz bitiş kodu',
    km: 'កូដបញ្ចប់ក្រោយ',
    es: 'Código de fin inverso',
    ar: 'رمز النهاية العكسية',
  },
  'cuttingDock.backEndCodePlaceholder': {
    zh: '输入反面结束代码',
    en: 'Enter Back End Code',
    id: 'Masukkan kode akhir terbalik',
    kz: 'Артқы бет аяқталу кодын енгізу',
    th: 'ป้อนรหัสปลายย้อนกลับ',
    ug: 'ئارقا ئاخىرلاشقۇچ كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã kết thúc mặt sau',
    zh_tc: '輸入反面結束代碼',
    ru: 'Введите обратный код конца',
    ko: '후면 끝 코드 입력',
    bur: 'အနောက်မျက်နှာပြီးကုဒ်ထည့်ပါ',
    ben: 'ব্যাক এন্ড কোড লিখুন',
    tr: 'Arka yüz bitiş kodunu girin',
    km: 'បញ្ចូលកូដបញ្ចប់ក្រោយ',
    es: 'Ingrese el código de fin inverso',
    ar: 'أدخل رمز النهاية العكسية',
  },
  'cuttingDock.plankStart': {
    zh: '板件翻面开始',
    en: 'Plank Turn Start',
    id: 'Piring dihidupkan',
    kz: 'Планканың ішіна бұрылуы басталу',
    th: 'จานเปิดอยู่',
    ug: 'تاختا ئۆرۈلۈش باشلانغۇچ',
    vi: 'Bàn khung lật mặt bắt đầu',
    zh_tc: '板件翻面開始',
    ru: 'Начинается опрокидывание листов.',
    ko: '보드 뒤집기 시작',
    bur: 'ပြားလှန်စတင်',
    ben: 'প্ল্যাঙ্ক টার্ন স্টার্ট',
    tr: 'Plaka çevirme başlangıcı',
    km: 'ចាប់ផ្តើមបង្វិលផ្ទាំង',
    es: 'Giro de placa inicial',
    ar: 'تدوير لوحة البداية',
  },
  'cuttingDock.plankEnd': {
    zh: '板件翻面结束',
    en: 'Plank Turn End',
    id: 'Piring dibatalkan',
    kz: 'Планканың ішіна бұрылуы аяқталу',
    th: 'จานถูกพลิกคว่ำ',
    ug: 'تاختا ئۆرۈلۈش ئاخىرلاشقۇچ',
    vi: 'Bàn khung lật mặt kết thúc',
    zh_tc: '板件翻面結束',
    ru: 'Конец опрокидывания пластины',
    ko: '보드 뒤집기 끝',
    bur: 'ပြားလှန်ပြီး',
    ben: 'প্ল্যাঙ্ক টার্ন এন্ড',
    tr: 'Plaka çevirme bitişi',
    km: 'បញ្ចប់បង្វិលផ្ទាំង',
    es: 'Giro de placa final',
    ar: 'تدوير لوحة النهاية',
  },
  'cuttingDock.plankRollCode1': {
    zh: '工位1翻面代码',
    en: 'Station 1 Turn Code',
    id: 'Workstation 1 Kode Flip',
    kz: '1-стансияның ішіне бұрылу коды',
    th: 'เวิร์กสเตชัน 1 รหัสพลิก',
    ug: 'پوچتا 1 ئۆرۈلۈش كودى',
    vi: 'Mã lật mặt bán vị 1',
    zh_tc: '工位1翻面代碼',
    ru: 'Код поворота позиции 1',
    ko: '작업 위치 1 뒤집기 코드',
    bur: 'အလုပ်ဌာန၁လှန်ကုဒ်',
    ben: 'স্টেশন ১ টার্ন কোড',
    tr: 'İstasyon 1 çevirme kodu',
    km: 'កូដបង្វិលកន្លែង ១',
    es: 'Código de giro de estación 1',
    ar: 'رمز تحويل المحطة 1',
  },
  'cuttingDock.plankRollCode1Placeholder': {
    zh: '输入工位1翻面代码',
    en: 'Enter Station 1 Turn Code',
    id: 'Masukkan stasiun kerja 1 kode flip',
    kz: '1-стансияның ішіне бұрылу кодын енгізу',
    th: 'ป้อนรหัสการทำงาน 1',
    ug: 'پوچتا 1 ئۆرۈلۈش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã lật mặt bán vị 1',
    zh_tc: '輸入工位1翻面代碼',
    ru: 'Введите код поворота позиции 1',
    ko: '작업 위치 1 뒤집기 코드 입력',
    bur: 'အလုပ်ဌာန၁လှန်ကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ১ টার্ন কোড লিখুন',
    tr: 'İstasyon 1 çevirme kodunu girin',
    km: 'បញ្ចូលកូដបង្វិលកន្លែង ១',
    es: 'Ingrese código de giro de estación 1',
    ar: 'أدخل رمز تحويل المحطة 1',
  },
  'cuttingDock.plankRollCode2': {
    zh: '工位2翻面代码',
    en: 'Station 2 Turn Code',
    id: 'Workstation 2 Flip Code',
    kz: '2-стансияның ішіне бұрылу коды',
    th: 'เวิร์กสเตชัน 2 รหัสพลิก',
    ug: 'پوچتا 2 ئۆرۈلۈش كودى',
    vi: 'Mã lật mặt bán vị 2',
    zh_tc: '工位2翻面代碼',
    ru: 'Код поворота позиции 2',
    ko: '작업 위치 2 뒤집기 코드',
    bur: 'အလုပ်ဌာန၂လှန်ကုဒ်',
    ben: 'স্টেশন ২ টার্ন কোড',
    tr: 'İstasyon 2 çevirme kodu',
    km: 'កូដបង្វិលកន្លែង ២',
    es: 'Código de giro de estación 2',
    ar: 'رمز تحويل المحطة 2',
  },
  'cuttingDock.plankRollCode2Placeholder': {
    zh: '输入工位2翻面代码',
    en: 'Enter Station 2 Turn Code',
    id: 'Masukkan stasiun kerja 2 kode flip',
    kz: '2-стансияның ішіне бұрылу кодын енгізу',
    th: 'ป้อนรหัส FLIP WORK STATION 2',
    ug: 'پوچتا 2 ئۆرۈلۈش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã lật mặt bán vị 2',
    zh_tc: '輸入工位2翻面代碼',
    ru: 'Введите код поворота 2.',
    ko: '작업 위치 2 뒤집기 코드 입력',
    bur: 'အလုပ်ဌာန၂လှန်ကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ২ টার্ন কোড লিখুন',
    tr: 'İstasyon 2 çevirme kodunu girin',
    km: 'បញ្ចូលកូដបង្វិលកន្លែង ២',
    es: 'Ingrese código de giro de estación 2',
    ar: 'أدخل رمز تحويل المحطة 2',
  },
  'cuttingDock.autoBaitingCode': {
    zh: '自动下料代码',
    en: 'Auto Feeding Code',
    id: 'Kode pelepasan otomatis',
    kz: 'Автоматтық кескіш коды',
    th: 'รหัสคายประจุอัตโนมัติ',
    ug: 'ئاپتوماتىك ماتېرىيال چۈشۈرۈش كودى',
    vi: 'Mã tự động xuống liệu',
    zh_tc: '自動下料代碼',
    ru: 'Код автоматической раскройки',
    ko: '자동 공급 코드',
    bur: 'အလိုအလျောက်အောက်ပစ္စည်းကုဒ်',
    ben: 'অটো ফিডিং কোড',
    tr: 'Otomatik parça düşürme kodu',
    km: 'កូដចុះសម្ភារៈស្វ័យប្រវត្តិ',
    es: 'Código de borrado automático',
    ar: 'رمز التفريغ التلقائي',
  },
  'cuttingDock.autoBaitingCode1': {
    zh: '工位1下料代码',
    en: 'Station 1 Feeding Code',
    id: 'Kode pemotongan workstation 1',
    kz: '1-стансияның автоматтық кескіш коды',
    th: 'เวิร์กสเตชัน 1 รหัสตัด',
    ug: 'پوچتا 1 ماتېرىيال چۈشۈرۈش كودى',
    vi: 'Mã xuống liệu bán vị 1',
    zh_tc: '工位1下料代碼',
    ru: 'Станция 1 Код раскрутки',
    ko: '작업 위치 1 원료 코드',
    bur: 'အလုပ်ဌာန၁အောက်ပစ္စည်းကုဒ်',
    ben: 'স্টেশন ১ ফিডিং কোড',
    tr: 'İstasyon 1 parça düşürme kodu',
    km: 'កូដចុះសម្ភារៈកន្លែង ១',
    es: 'Código de borrado de la estación 1',
    ar: 'رمز مسح المحطة 1',
  },
  'cuttingDock.autoBaitingCode1Placeholder': {
    zh: '输入工位1下料代码',
    en: 'Enter Station 1 Feeding Code',
    id: 'Masukkan stasiun kerja 1 kode pemotongan',
    kz: '1-стансияның автоматтық кескіш кодын енгізу',
    th: 'ป้อนรหัสการตัดที่ทำงาน 1',
    ug: 'پوچتا 1 ماتېرىيال چۈشۈرۈش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã xuống liệu bán vị 1',
    zh_tc: '輸入工位1下料代碼',
    ru: 'Введите код загрузки станции 1',
    ko: '작업 위치 1 공급 코드 입력',
    bur: 'အလုပ်ဌာန၁အောက်ပစ္စည်းကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ১ ফিডিং কোড লিখুন',
    tr: 'İstasyon 1 parça düşürme kodunu girin',
    km: 'បញ្ចូលកូដចុះសម្ភារៈកន្លែង ១',
    es: 'Ingrese el código de borrado para la estación 1',
    ar: 'أدخل رمز مسح المحطة 1',
  },
  'cuttingDock.autoBaitingCode2': {
    zh: '工位2下料代码',
    en: 'Station 2 Feeding Code',
    id: 'Kode pemotongan workstation 2',
    kz: '2-стансияның автоматтық кескіш коды',
    th: 'เวิร์กสเตชัน 2 รหัสตัด',
    ug: 'پوچتا 2 ماتېرىيال چۈشۈرۈش كودى',
    vi: 'Mã xuống liệu bán vị 2',
    zh_tc: '工位2下料代碼',
    ru: 'Станция 2 Код раскрутки',
    ko: '작업 위치 2 원료 코드',
    bur: 'အလုပ်ဌာန၂အောက်ပစ္စည်းကုဒ်',
    ben: 'স্টেশন ২ ফিডিং কোড',
    tr: 'İstasyon 2 parça düşürme kodu',
    km: 'កូដចុះសម្ភារៈកន្លែង ២',
    es: 'Código de borrado de la estación 2',
    ar: 'رمز مسح المحطة 2',
  },
  'cuttingDock.autoBaitingCode2Placeholder': {
    zh: '输入工位2下料代码',
    en: 'Enter Station 2 Feeding Code',
    id: 'Masukkan stasiun kerja 2 kode pelepasan',
    kz: '2-стансияның автоматтық кескіш кодын енгізу',
    th: 'ป้อนรหัสการปลดปล่อย 2',
    ug: 'پوچتا 2 ماتېرىيال چۈشۈرۈش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã xuống liệu bán vị 2',
    zh_tc: '輸入工位2下料代碼',
    ru: 'Введите код загрузки 2.',
    ko: '작업 위치 2 공급 코드 입력',
    bur: 'အလုပ်ဌာန၂အောက်ပစ္စည်းကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ২ ফিডিং কোড লিখুন',
    tr: 'İstasyon 2 parça düşürme kodunu girin',
    km: 'បញ្ចូលកូដចុះសម្ភារៈកន្លែង ២',
    es: 'Ingrese el código de supresión de la estación 2',
    ar: 'أدخل رمز مسح المحطة 2',
  },
  'cuttingDock.thickMarkPermission': {
    zh: '您当前无大板厚度标识权限，请联系销售购买后使用',
    en: 'You currently do not have Big Plank Thickness Mark permission. Please contact sales to purchase before use',
    id: 'Anda saat ini tidak memiliki izin penandaan ketebalan papan besar, silakan hubungi penjualan untuk membeli sebelum digunakan',
    kz: 'Сізде үлкен плита қалыңдығы белгісі рұқсаты жоқ, пайдалану үшін сату бөліміне хабарласыңыз',
    th: 'คุณไม่มีสิทธิ์การทำเครื่องหมายความหนาของแผ่นใหญ่ในขณะนี้ กรุณาติดต่อฝ่ายขายเพื่อซื้อก่อนใช้งาน',
    ug: 'سىزنىڭ ھازىر چوڭ تاختا قېلىنلىقى بەلگىسى ھوقۇقىڭىز يوق، سېتىش بىلەن ئالاقىلىشىپ سېتىۋېلىپ ئاندىن ئىشلىتىڭ',
    vi: 'Bạn hiện không có quyền đánh dấu độ dày tấm lớn, vui lòng liên hệ bộ phận bán hàng để mua trước khi sử dụng',
    zh_tc: '您當前無大板厚度標識權限，請聯繫銷售購買後使用',
    ru: 'У вас нет разрешения на маркировку толщины большой плиты. Пожалуйста, свяжитесь с отделом продаж для покупки',
    ko: '현재 대판 두께 표시 권한이 없습니다. 판매팀에 문의하여 구매 후 사용하세요',
    bur: 'သင်သည် လက်ရှိတွင် အကြီးပြားအထူအမှတ်အသား ခွင့်ပြုချက်မရှိပါ၊ အသုံးမပြုမီ အရောင်းနှင့် ဆက်သွယ်၍ ဝယ်ယူပါ',
    ben: 'আপনার বর্তমানে বড় প্ল্যাক পুরুত্ব চিহ্নের অনুমতি নেই, ব্যবহারের আগে বিক্রয়ের সাথে যোগাযোগ করে কিনুন',
    tr: 'Şu anda Büyük pano kalınlığı işareti izniniz yok, kullanmadan önce satış ile iletişime geçerek satın alın',
    km: 'អ្នកបច្ចុប្បន្នមិនមានសិទ្ធិសម្គាល់កម្រាស់បន្ទះធំទេ សូមទាក់ទងផ្នែកលក់ដើម្បីទិញមុនពេលប្រើ',
    es: 'Actualmente no tiene permiso de Marcar el grosor de la placa grande. Contacte a ventas para comprar antes de usar',
    ar: 'ليس لديك حالياً صلاحية وضع علامة السمك الكبير للبلاطة، يرجى الاتصال بالمبيعات للشراء قبل الاستخدام',
  },
  'cuttingDock.thickMark': {
    zh: '大板厚度标识',
    en: 'Big Plank Thickness Mark',
    id: 'Marking tebal papan besar',
    kz: 'Үлкен плита қалыңдығы белгісі',
    th: 'การทำเครื่องหมายความหนาแน่นของแผ่นใหญ่',
    ug: 'چوڭ تاختا قېلىنلىقى بەلگىسى',
    vi: 'Đánh dấu độ dày của tấm lớn',
    zh_tc: '大板厚度標識',
    ru: 'Маркировка толщины большой плиты',
    ko: '대판 두께 표시',
    bur: 'မကြီးမြတ်သည်မှားနားချက်',
    ben: 'বড় প্লাক প্রস্থ চিহ্নিত করুন',
    tr: 'Büyük pano kalınlığı işareti',
    km: 'ការជ្រើសយកកម្រិតចម្លើយរបស់កម្ពុជា',
    es: 'Marcar el grosor de la placa grande',
    ar: 'وضع علامة السمك الكبير للبلاطة',
  },
  'cuttingDock.preStartEquipment': {
    zh: '预启动设备',
    en: 'Pre-Start Equipment',
    id: 'Perangkat pra-awal',
    kz: 'Алдын ала іске қосу жабдық',
    th: 'อุปกรณ์ก่อนเริ่ม',
    ug: 'ئالدىن قوزغاتقۇچ قورال',
    vi: 'Thiết bị khởi động trước',
    zh_tc: '預啟動設備',
    ru: 'Предпусковое оборудование',
    ko: '사전 부팅 장치',
    bur: 'ကြိုတင်စတင်စက်',
    ben: 'প্রি-স্টার্ট ইকুইপমেন্ট',
    tr: 'Ön başlatma ekipmanı',
    km: 'ឧបករណ៍ចាប់ផ្តើមមុន',
    es: 'Dispositivo de prearranque',
    ar: 'معدات ما قبل التشغيل',
  },
  'cuttingDock.firstKnifePreCode': {
    zh: '首刀预启动代码提前',
    en: 'First Knife Pre-Start Code Advance',
    id: 'Kode pra-awal pisau pertama terlebih dahulu',
    kz: 'Бірінші кескіш алдын ала іске қосу коды',
    th: 'รหัสก่อนเริ่มต้นมีดล่วงหน้าล่วงหน้า',
    ug: 'بىرىنچى پىچاق ئالدىن قوزغاتقۇچ كودى',
    vi: 'Mã khởi động trước của dao đầu tiên',
    zh_tc: '首刀預啟動代碼提前',
    ru: 'Загрузить код заранее',
    ko: '첫 번째 사전 부팅 코드 이전',
    bur: 'ပထမဓားကြိုတင်စတင်ကုဒ်ကြိုထား',
    ben: 'ফার্স্ট নাইফ প্রি-স্টার্ট কোড অ্যাডভান্স',
    tr: 'İlk bıçak ön başlatma kodu öne alınır',
    km: 'កូដចាប់ផ្តើមមុននៃដាក់ដំបូងឱ្យមុន',
    es: 'El código de preinicio del primer cuchillo está avanzado.',
    ar: 'رمز التشغيل المسبق للأداة الأولى مقدمًا',
  },
  'cuttingDock.secondKnifePreCode': {
    zh: '第二把刀及后续刀预启动代码提前',
    en: 'Second and Subsequent Knifes Pre-Start Code Advance',
    id: 'Pisau kedua dan kode pra-awal pisau berikutnya adalah sebelumnya',
    kz: 'Екінші және одан әрбір кескіш алдын ала іске қосу коды',
    th: 'มีดที่สองและมีดเริ่มต้นก่อนหน้านี้ล่วงหน้า',
    ug: 'ئىككىنچى پىچاق ۋە كېيىنكى پىچاقلار ئالدىن قوزغاتقۇچ كودى',
    vi: 'Mã khởi động trước của dao thứ hai và sau đó',
    zh_tc: '第二把刀及後續刀預啟動代碼提前',
    ru: 'Код предварительного запуска второго и последующего ножей.',
    ko: '보조 및 후속 칼 사전 부팅 코드',
    bur: 'ဒုတိယနှင့်နောက်ဓားကြိုတင်စတင်ကုဒ်ကြိုထား',
    ben: 'সেকেন্ড ও পরবর্তী নাইফ প্রি-স্টার্ট কোড অ্যাডভান্স',
    tr: 'İkinci ve sonraki bıçaklar ön başlatma kodu öne alınır',
    km: 'កូដចាប់ផ្តើមមុននៃដាក់ទីពីរ និងបន្ទាប់ឱ្យមុន',
    es: 'Se avanza el código de preinicio de la segunda cuchilla y de las cuchillas posteriores.',
    ar: 'رموز التشغيل المسبق للأداة الثانية والأداة اللاحقة مقدمًا',
  },
  'cuttingDock.rowInsert': {
    zh: '行插入',
    en: 'Row Insert',
    id: 'Penyisipan baris',
    kz: 'Сатыр енгізу',
    th: 'การแทรกเส้น',
    ug: 'قۇر قىستۇرۇش',
    vi: 'Chèn hàng',
    zh_tc: '行插入',
    ru: 'Вставить строку',
    ko: '행 삽입',
    bur: 'အတန်းထည့်',
    ben: 'রো ইনসার্ট',
    tr: 'Satır ekleme',
    km: 'បញ្ចូលជួរដេក',
    es: 'Inserción de fila',
    ar: 'إدخال الخط',
  },
  'cuttingDock.pumpPause': {
    zh: '真空泵暂停',
    en: 'Vacuum Pump Pause',
    id: 'Jeda pompa vakum',
    kz: 'Вакуумдық сорғы тынықтау',
    th: 'ปั๊มสูญญากาศหยุดชั่วคราว',
    ug: 'ۋاكۇم پومپا توختىتىش',
    vi: 'Tạm dừng bơm chân không',
    zh_tc: '真空泵暫停',
    ru: 'Вакуумный насос выключен.',
    ko: '진공 펌프 정지',
    bur: 'ဗက်ကြူးပမ်ခဏရပ်',
    ben: 'ভ্যাকুয়াম পাম্প পজ',
    tr: 'Vakum pompası duraklatma',
    km: 'ផ្អាកប៉ំបូមសុញ្ញាកាស',
    es: 'Bomba de vacío en pausa',
    ar: 'إيقاف مضخة التفريغ مؤقتًا',
  },
  'cuttingDock.pumpPauseTip': {
    zh: '注意：单工位设备需要将工位1和工位2都填上相同的"自动上料代码" 和"双面加工正面注释代码"',
    en: 'Attention: Simplex equipment is required to fill in the same "Automatic feeding code" and "Double-sided Machining front Note Code" for both stations 1 and 2.',
    id: 'Catatan: Peralatan stasiun tunggal membutuhkan "kode pemuatan otomatis" yang sama dan "kode komentar frontal pemrosesan dua sisi" untuk mengisi stasiun 1 dan stasiun 2.',
    kz: 'Ескерту: Бір станциялық жабдық үшін 1 және 2 станциялар бірдей «автоматты жүктеу коды» және «екі жақты өңдеудің алдыңғы түсініктеме коды» арқылы толтырылуы керек.',
    th: 'หมายเหตุ: อุปกรณ์สถานีเดียวต้องการ "รหัสการโหลดอัตโนมัติ" และ "รหัสความคิดเห็นด้านหน้าแบบสองด้าน" เพื่อเติมทั้งสถานี 1 และสถานี 2',
    ug: 'دىققەت: بىر پوچتالىق قوراللاردا پوچتا 1 ۋە پوچتا 2 گە ئوخشاش "ئاپتوماتىك ماتېرىيال كودى" ۋە "ئىككى تەرەپلىك ئىشلەش ئالدى ئىزاھات كودى" نى تولدۇرۇش كېرەك',
    vi: 'Lưu ý: đơn vị thiết bị cần phải được điền vào vị trí 1 và vị trí 2 cùng một "tự động nạp mã" và "hai mặt xử lý tích cực chú thích mã"',
    zh_tc:
      '注意：單工位設備需要將工位1和工位2都填上相同的"自動上料代碼" 和"雙面加工正面註釋代碼"',
    ru: 'Примечание: Однопозиционное оборудование должно заполнять как рабочее место 1, так и рабочее место 2 одним и тем же « кодом автоматической загрузки» и « кодом интерпретации передней части двухсторонней обработки».',
    ko: '참고: 단일 작업 비트 장치는 작업 비트 1과 작업 비트 2를 동일한 자동 재료 공급 코드와 양면 가공 전면 주석 코드로 채워야 합니다.',
    bur: 'သတိပြု-အလုပ်ဌာနတစ်ခုစက်တွင်ဌာန၁နှင့်၂နှစ်ခုလုံးတူညီသောအလိုအလျောက်အပေါ်ပစ္စည်းကုဒ်နှင့်နှစ်ဘက်ပြုရှေ့မှတ်ချက်ကုဒ်ထည့်ရမည်',
    ben: 'নোট: সিমপ্লেক্স ইকুইপমেন্টের জন্য স্টেশন ১ ও ২ উভয়েই একই অটোমেটিক ফিডিং কোড ও ডাবল-সাইডেড মেশিনিং ফ্রন্ট নোট কোড পূরণ করতে হবে',
    tr: 'Dikkat: Tek istasyonlu cihazlarda istasyon 1 ve 2ye aynı otomatik yükleme kodu ve çift taraflı ön yüz not kodunu girin',
    km: 'ចំណាំ៖ ឧបករណ៍កន្លែងតែមួយត្រូវបំពេញកន្លែង ១ និង ២ ដោយកូដផ្ទុកដោយស្វ័យប្រវត្តិ និងកូដកំណត់ចំណាំមុខដំណើរការពីរមុខដូចគ្នា',
    es: 'Nota: Para equipos de una sola estación, la estación 1 y la estación 2 deben completarse con el mismo "código de carga automática" y "código de comentario frontal de procesamiento de doble cara".',
    ar: 'ملاحظة: تحتاج معدات المحطة الواحدة إلى ملء نفس "التحميل التلقائي" "رمز التعليق الأمامي للمعالجة على الوجهين" لكل من المحطة 1 والمحطة 2',
  },
  'cuttingDock.pumpPause2Tip': {
    zh: '注意：单工位设备需要将工位1和工位2都填上相同的"真空泵暂停代码"',
    en: 'Attention: Simplex equipment needs to be filled with the same "vacuum pump pause code" for both stations 1 and 2.',
    id: 'Catatan: Peralatan stasiun tunggal perlu mengisi stasiun 1 dan stasiun 2 dengan "kode suspensi pompa vakum" yang sama',
    kz: 'Ескертпе: Бір станциялық жабдық үшін 1-станция да, 2-станция да бірдей «вакуумдық сорғыны кідірту кодымен» толтырылуы керек.',
    th: 'หมายเหตุ: อุปกรณ์สถานีเดียวจำเป็นต้องเติมทั้งสถานี 1 และสถานี 2 ด้วย "รหัสช่วงล่างปั๊มสูญญากาศเดียวกัน" เดียวกัน',
    ug: 'دىققەت: بىر پوچتالىق قوراللاردا پوچتا 1 ۋە پوچتا 2 گە ئوخشاش "ۋاكۇم پومپا توختىتىش كودى" نى تولدۇرۇش كېرەك',
    vi: 'Lưu ý: thiết bị đơn vị cần phải điền vào vị trí 1 và vị trí 2 cùng một "mã ngừng bơm chân không"',
    zh_tc: '注意：單工位設備需要將工位1和工位2都填上相同的"真空泵暫停代碼"',
    ru: 'Примечание: однопозиционное оборудование должно заполнять как рабочее место 1, так и рабочее место 2 одним и тем же « кодом остановки вакуумного насоса».',
    ko: '참고: 단일 작업 공간 장치는 작업 공간 1과 작업 공간 2를 모두 동일한"진공 펌프 일시 중지 코드"로 채워야 합니다.',
    bur: 'သတိပြု-အလုပ်ဌာနတစ်ခုစက်တွင်ဌာန၁နှင့်၂နှစ်ခုလုံးတူညီသောဗက်ကြူးပမ်ခဏရပ်ကုဒ်ထည့်ရမည်',
    ben: 'নোট: সিমপ্লেক্স ইকুইপমেন্টের জন্য স্টেশন ১ ও ২ উভয়েই একই ভ্যাকুয়াম পাম্প পজ কোড পূরণ করতে হবে',
    tr: 'Dikkat: Tek istasyonlu cihazlarda istasyon 1 ve 2ye aynı vakum pompası duraklatma kodunu girin',
    km: 'ចំណាំ៖ ឧបករណ៍កន្លែងតែមួយត្រូវបំពេញកន្លែង ១ និង ២ ដោយកូដផ្អាកប៉ំបូមសុញ្ញាកាសដូចគ្នា',
    es: 'Nota: Para equipos de una sola estación, tanto la estación 1 como la estación 2 deben completarse con el mismo "código de pausa de la bomba de vacío".',
    ar: 'ملاحظة: تحتاج معدات المحطة الواحدة إلى ملء نفس "رمز إيقاف مضخة التفريغ" لكل من المحطة 1 والمحطة 2',
  },
  'cuttingDock.pumpPauseCode1': {
    zh: '工位1真空泵暂停代码',
    en: 'Station 1 Vacuum Pump Pause Code',
    id: 'Kode suspensi pompa vakum 1 workstation 1',
    kz: '1-стансияның вакуумдық сорғы тынықтау коды',
    th: 'เวิร์กสเตชัน 1 รหัสช่วงล่างปั๊มสูญญากาศ',
    ug: 'پوچتا 1 ۋاكۇم پومپا توختىتىش كودى',
    vi: 'Mã tạm dừng bơm chân không bán vị 1',
    zh_tc: '工位1真空泵暫停代碼',
    ru: 'Станция 1 Код остановки вакуумного насоса',
    ko: '작업 공간 1 진공 펌프 일시 정지 코드',
    bur: 'အလုပ်ဌာန၁ဗက်ကြူးပမ်ခဏရပ်ကုဒ်',
    ben: 'স্টেশন ১ ভ্যাকুয়াম পাম্প পজ কোড',
    tr: 'İstasyon 1 vakum pompası duraklatma kodu',
    km: 'កូដផ្អាកប៉ំបូមសុញ្ញាកាសកន្លែង ១',
    es: 'Código de pausa de la bomba de vacío de la estación 1',
    ar: 'رمز إيقاف مضخة التفريغ للمحطة 1',
  },
  'cuttingDock.pumpPauseCode1Placeholder': {
    zh: '请填写工位1的真空泵暂停代码',
    en: 'Please enter the vacuum pump pause code for Station 1',
    id: 'Silakan isi kode suspensi pompa vakum stasiun 1',
    kz: '1-стансияның вакуумдық сорғы тынықтау кодын енгізу',
    th: 'กรุณากรอกรหัสช่วงล่างปั๊มสุญญากาศของสถานี 1',
    ug: 'پوچتا 1 ۋاكۇم پومپا توختىتىش كودىنى تولدۇرۇڭ',
    vi: 'Vui lòng điền mã tạm dừng bơm chân không bán vị 1',
    zh_tc: '請填寫工位1的真空泵暫停代碼',
    ru: 'Пожалуйста, заполните код остановки вакуумного насоса на станции 1.',
    ko: '작업 공간 1의 진공 펌프 일시 정지 코드를 기입해 주십시오',
    bur: 'အလုပ်ဌာန၁ဗက်ကြူးပမ်ခဏရပ်ကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ১-এর ভ্যাকুয়াম পাম্প পজ কোড লিখুন',
    tr: 'İstasyon 1 vakum duraklatma kodunu girin',
    km: 'បំពេញកូដផ្អាកប៉ំបូមសុញ្ញាកាសកន្លែង ១',
    es: 'Complete el código de pausa de la bomba de vacío para la estación 1',
    ar: 'يرجى ملء رمز إيقاف مضخة التفريغ للمحطة 1',
  },
  'cuttingDock.pumpPauseCode2': {
    zh: '工位2真空泵暂停代码',
    en: 'Station 2 Vacuum Pump Pause Code',
    id: 'Kode Suspensi Workstation 2 Vakum',
    kz: '2-стансияның вакуумдық сорғы тынықтау коды',
    th: 'เวิร์กสเตชัน 2 รหัสช่วงล่างปั๊มสูญญากาศ',
    ug: 'پوچتا 2 ۋاكۇم پومپا توختىتىش كودى',
    vi: 'Mã tạm dừng bơm chân không bán vị 2',
    zh_tc: '工位2真空泵暫停代碼',
    ru: 'Код остановки вакуумного насоса 2',
    ko: '작업 공간 2 진공 펌프 일시 정지 코드',
    bur: 'အလုပ်ဌာန၂ဗက်ကြူးပမ်ခဏရပ်ကုဒ်',
    ben: 'স্টেশন ২ ভ্যাকুয়াম পাম্প পজ কোড',
    tr: 'İstasyon 2 vakum pompası duraklatma kodu',
    km: 'កូដផ្អាកប៉ំបូមសុញ្ញាកាសកន្លែង ២',
    es: 'Código de pausa de la bomba de vacío de la estación 2',
    ar: 'رمز إيقاف مضخة التفريغ للمحطة 2',
  },
  'cuttingDock.pumpPauseCode2Placeholder': {
    zh: '请填写工位2的真空泵暂停代码',
    en: 'Please enter the vacuum pump pause code for Station 2',
    id: 'Harap isi kode suspensi pompa vakum stasiun 2',
    kz: '2-стансияның вакуумдық сорғы тынықтау кодын енгізу',
    th: 'กรุณากรอกรหัสช่วงล่างปั๊มสุญญากาศของสถานี 2',
    ug: 'پوچتا 2 ۋاكۇم پومپا توختىتىش كودىنى تولدۇرۇڭ',
    vi: 'Vui lòng điền mã tạm dừng bơm chân không bán vị 2',
    zh_tc: '請填寫工位2的真空泵暫停代碼',
    ru: 'Пожалуйста, заполните код остановки вакуумного насоса на станции 2.',
    ko: '작업 공간 2의 진공 펌프 일시 중지 코드를 입력하십시오.',
    bur: 'အလုပ်ဌာန၂ဗက်ကြူးပမ်ခဏရပ်ကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ২-এর ভ্যাকুয়াম পাম্প পজ কোড লিখুন',
    tr: 'İstasyon 2 vakum duraklatma kodunu girin',
    km: 'បំពេញកូដផ្អាកប៉ំបូមសុញ្ញាកាសកន្លែង ២',
    es: 'Complete el código de pausa de la bomba de vacío para la estación 2',
    ar: 'يرجى ملء رمز إيقاف مضخة التفريغ للمحطة 2',
  },
  'cuttingDock.annotationCode1': {
    zh: '工位1双面加工正面注释代码',
    en: 'Annotation code for double-sided processing (front) of workstation 1',
    id: 'Workstation 1 Kode Anotasi Frontal Pemrosesan Sisi Ganda',
    kz: '1-ші орынның екі жақты өңдеуіш алдың жақ түсініктеме коды',
    th: 'เวิร์กสเตชัน 1 รหัสคำอธิบายประกอบหน้าผากสองด้าน',
    ug: 'پوچتا 1 ئىككى تەرەپلىك ئىشلەش ئالدى ئىزاھات كودى',
    vi: 'Mã chú thích mặt trước bán vị kép 1',
    zh_tc: '工位1雙面加工正面註釋代碼',
    ru: 'Позиция 1 Двойная обработка фронтального кода комментариев',
    ko: '가공 비트 1 양면 머시닝 전면 주석 코드',
    bur: 'အလုပ်ဌာန၁နှစ်ဘက်ပြုရှေ့မှတ်ချက်ကုဒ်',
    ben: 'স্টেশন ১ ডাবল-সাইডেড প্রসেসিং (ফ্রন্ট) অ্যানোটেশন কোড',
    tr: 'İstasyon 1 çift taraflı işleme ön yüz not kodu',
    km: 'កូដកំណត់ចំណាំមុខដំណើរការពីរមុខកន្លែង ១',
    es: 'Código de comentario frontal de procesamiento de doble cara de la estación 1',
    ar: 'رمز التعليق الأمامي للمعالجة على الوجهين للمحطة 1',
  },
  'cuttingDock.annotationCode1Tip': {
    zh: '适用于自动上料正面不同指令的设备',
    en: 'Suitable for equipment with different commands for automatic loading (front)',
    id: 'Cocok untuk peralatan dengan instruksi yang berbeda di bagian depan makan otomatis',
    kz: 'Әртүрлі командалармен автоматтық қосуға арналған жабдыққа сәйкес келеді',
    th: 'เหมาะสำหรับอุปกรณ์ที่มีคำแนะนำที่แตกต่างกันเกี่ยวกับด้านหน้าการให้อาหารอัตโนมัติ',
    ug: 'ئاپتوماتىك ماتېرىيال ئالدى ئوخشاش بولمىغان بۇيرۇقلارغا ئىشلىتىلىدۇ',
    vi: 'Thích hợp cho thiết bị có chỉ lệnh khác nhau khi tự động lên liệu mặt trước',
    zh_tc: '適用於自動上料正面不同指令的設備',
    ru: 'Оборудование для автоматической загрузки различных команд спереди',
    ko: '정면의 다른 명령을 자동으로 전달하는 장치',
    bur: 'အလိုအလျောက်အပေါ်ပစ္စည်းရှေ့မျက်နှာညီညွတ်မှုမတူသောစက်များအတွက်သင့်လျော်',
    ben: 'অটোমেটিক লোডিং (ফ্রন্ট) এর জন্য ভিন্ন কমান্ড আছে এমন ইকুইপমেন্টের জন্য উপযুক্ত',
    tr: 'Otomatik yüklemede ön yüzde farklı komutlar kullanan cihazlar için uygundur',
    km: 'សមស្របសម្រាប់ឧបករណ៍ដែលមានពាក្យបញ្ជាខុសគ្នានៅមុខពេលផ្ទុកស្វ័យប្រវត្តិ',
    es: 'Equipo adecuado para diferentes instrucciones para la carga automática del anverso',
    ar: 'المعدات المناسبة لتعليمات مختلفة للتحميل التلقائي للجانب الأمامي',
  },
  'cuttingDock.annotationCode1Placeholder': {
    zh: '输入工位1双面加工正面注释代码',
    en: 'Enter the annotation code for double-sided processing (front) of workstation 1',
    id: 'Masukkan kode anotasi frontal pemrosesan dua sisi untuk workstation 1',
    kz: '1-ші орынның екі жақты өңдеуіш алдың жақ түсініктеме коды енгізіңіз',
    th: 'ป้อนรหัสคำอธิบายประกอบด้านหน้าของการประมวลผลสองด้านสำหรับเวิร์กสเตชัน 1',
    ug: 'پوچتا 1 ئىككى تەرەپلىك ئىشلەش ئالدى ئىزاھات كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã chú thích mặt trước bán vị kép 1',
    zh_tc: '輸入工位1雙面加工正面註釋代碼',
    ru: 'Введите позицию 1 Двойная обработка фронтального кода комментариев',
    ko: '가공 위치 1 양면 머시닝 전면 주석 코드 입력',
    bur: 'အလုပ်ဌာန၁နှစ်ဘက်ပြုရှေ့မှတ်ချက်ကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ১ ডাবল-সাইডেড প্রসেসিং (ফ্রন্ট) অ্যানোটেশন কোড লিখুন',
    tr: 'İstasyon 1 çift taraflı ön yüz not kodunu girin',
    km: 'បញ្ចូលកូដកំណត់ចំណាំមុខដំណើរការពីរមុខកន្លែង ១',
    es: 'Ingrese el código de comentario frontal para el procesamiento a doble cara en la estación 1',
    ar: 'أدخل رمز التعليق الأمامي للمعالجة على الوجهين في المحطة 1',
  },
  'cuttingDock.annotationCode2': {
    zh: '工位2双面加工正面注释代码',
    en: 'Annotation code for double-sided processing (front) of workstation 2',
    id: 'Kode anotasi frontal pemrosesan dua sisi pemrosesan',
    kz: '2-ші орынның екі жақты өңдеуіш алдың жақ түсініктеме коды',
    th: 'เวิร์กสเตชัน 2 รหัสคำอธิบายประกอบหน้าผากสองด้าน',
    ug: 'پوچتا 2 ئىككى تەرەپلىك ئىشلەش ئالدى ئىزاھات كودى',
    vi: 'Mã chú thích mặt trước bán vị kép 2',
    zh_tc: '工位2雙面加工正面註釋代碼',
    ru: 'Позиция 2 Двойная обработка фронтального кода комментариев',
    ko: '가공 위치 2 양면 머시닝 전면 주석 코드',
    bur: 'အလုပ်ဌာန၂နှစ်ဘက်ပြုရှေ့မှတ်ချက်ကုဒ်',
    ben: 'স্টেশন ২ ডাবল-সাইডেড প্রসেসিং (ফ্রন্ট) অ্যানোটেশন কোড',
    tr: 'İstasyon 2 çift taraflı işleme ön yüz not kodu',
    km: 'កូដកំណត់ចំណាំមុខដំណើរការពីរមុខកន្លែង ២',
    es: 'Código de comentario frontal para el procesamiento a doble cara en la estación 2',
    ar: 'رمز التعليق الأمامي للمعالجة على الوجهين في المحطة 2',
  },
  'cuttingDock.annotationCode2Placeholder': {
    zh: '输入工位2双面加工正面注释代码',
    en: 'Enter the annotation code for double-sided processing (front) of workstation 2',
    id: 'Masukkan kode anotasi depan untuk pemrosesan dua sisi workstation 2',
    kz: '2-ші орынның екі жақты өңдеуіш алдың жақ түсініктеме коды енгізіңіз',
    th: 'ป้อนรหัสคำอธิบายประกอบด้านหน้าสำหรับการประมวลผลสองด้านของเวิร์กสเตชัน 2',
    ug: 'پوچتا 2 ئىككى تەرەپلىك ئىشلەش ئالدى ئىزاھات كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã chú thích mặt trước bán vị kép 2',
    zh_tc: '輸入工位2雙面加工正面註釋代碼',
    ru: 'Введите позицию 2, двухстороннюю обработку фронтального кода комментариев.',
    ko: '가공 위치 2 양면 머시닝 전면 주석 코드 입력',
    bur: 'အလုပ်ဌာန၂နှစ်ဘက်ပြုရှေ့မှတ်ချက်ကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ২ ডাবল-সাইডেড প্রসেসিং (ফ্রন্ট) অ্যানোটেশন কোড লিখুন',
    tr: 'İstasyon 2 çift taraflı ön yüz not kodunu girin',
    km: 'បញ្ចូលកូដកំណត់ចំណាំមុខដំណើរការពីរមុខកន្លែង ២',
    es: 'Ingrese el código de comentario frontal para el procesamiento a doble cara en la estación 2',
    ar: 'أدخل رمز التعليق الأمامي للمعالجة على الوجهين في المحطة 2',
  },
  'cuttingDock.upSpeedTip': {
    zh: '请填写共边加速速度',
    en: 'Please enter the common edge acceleration speed',
    id: 'Silakan isi kecepatan akselerasi dari tepi yang sama',
    kz: 'Қосалқы жылдамдығын толтыруңыз',
    th: 'กรุณาเติมความเร็วการเร่งความเร็วของขอบเดียวกัน',
    ug: 'ئورتاق چېگرا تېزلىكىنى تولدۇرۇڭ',
    vi: 'Vui lòng điền vào tốc độ tăng cộng cạnh',
    zh_tc: '請填寫共邊加速速度',
    ru: 'Заполните общую скорость ускорения.',
    ko: '공통 가속도를 입력하십시오.',
    bur: 'အပြိုင်အစွန်းအရှိန်မြန်နှုန်းထည့်ပါ',
    ben: 'কমন এজ অ্যাকসেলারেশন স্পিড লিখুন',
    tr: 'Ortak kenar hızlanma hızını girin',
    km: 'សូមបំពេញល្បឿនបង្កើនល្បឿនគែមរួម',
    es: 'Complete la velocidad de aceleración del borde común',
    ar: 'يرجى ملء سرعة تسريع الحافة المشتركة',
  },
  'cuttingDock.cutThickTip': {
    zh: '请填写共边切割厚度',
    en: 'Please enter the common edge cutting thickness',
    id: 'Harap isi ketebalan pemotongan tepi yang umum',
    kz: 'Қосалқы кесу қалыңдығын толтыруңыз',
    th: 'กรุณาเติมความหนาของการตัดขอบทั่วไป',
    ug: 'ئورتاق چېگرا قېلىنلىقىنى تولدۇرۇڭ',
    vi: 'Vui lòng điền vào độ dày cắt cạnh chung',
    zh_tc: '請填寫共邊切割厚度',
    ru: 'Пожалуйста, заполните общую толщину резки.',
    ko: '공통 모서리 컷 두께를 입력하십시오.',
    bur: 'အပြိုင်အစွန်းဖြတ်အထူထည့်ပါ',
    ben: 'কমন এজ কাটিং বেধ লিখুন',
    tr: 'Ortak kenar kesim kalınlığını girin',
    km: 'សូមបំពេញកម្រាស់កាត់គែមរួម',
    es: 'Complete el espesor de corte del borde común',
    ar: 'يرجى ملء سمك قطع الحافة المشتركة',
  },
  'cuttingDock.sizeErrTip': {
    zh: '请在贴标机中设置导出排版图的正确尺寸!',
    en: 'Please set the correct size for the exported layout in the labeling machine!',
    id: 'Harap atur ukuran tata letak ekspor yang benar di mesin pelabelan!',
    kz: 'Этикеткалау машинасында бастырушы планшеттің дұрыс өлшемін орнатуңыз!',
    th: 'โปรดตั้งค่าขนาดที่ถูกต้องของเค้าโครงส่งออกในเครื่องฉลาก!',
    ug: 'بەلگە قويغۇچتا تەڭشەلگەن چوڭلۇقنى توغرا تەڭشەڭ!',
    vi: 'Vui lòng đặt kích thước chính xác của bản in điều hướng trong máy dán nhãn!',
    zh_tc: '請在貼標機中設置導出排版圖的正確尺寸!',
    ru: 'Пожалуйста, установите правильный размер для экспорта типографики в маркер!',
    ko: '레이블을 내보낼 올바른 크기를 레이블에 설정하십시오.',
    bur: 'ပြင်ဆင်စာမျက်နှာပုံထုတ်မှုအရွယ်အစားကိုတံဆိပ်စက်တွင်သတ်မှတ်ပါ!',
    ben: 'লেবেলিং মেশিনে এক্সপোর্ট লেআউটের সঠিক সাইজ সেট করুন!',
    tr: 'Lütfen etiketleme makinesinde dışa aktarılan yerleşimin doğru boyutunu ayarlayın!',
    km: 'សូមកំណត់ទំហំត្រឹមត្រូវនៃរូបរៀបចំដែលនាំចេញនៅក្នុងម៉ាស៊ីនស្លាក!',
    es: '¡Establezca el tamaño correcto del diagrama de diseño de exportación en la máquina etiquetadora!',
    ar: 'يرجى ضبط الحجم الصحيح لمخطط تخطيط التصدير في آلة وضع العلامات!',
  },
  'cuttingDock.offEdgeKnifeDiameter': {
    zh: '请输入修边刀具直径',
    en: 'Please enter the trimming knife diameter',
    id: 'Harap masukkan diameter alat pemangkasan',
    kz: 'Кескіштің кескіш бıрақ диаметріні толтыруңыз',
    th: 'โปรดป้อนเส้นผ่านศูนย์กลางเครื่องมือตัดแต่ง',
    ug: 'چېگرا پىچاق دىئامېتىرىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập đường kính dao hàng cạnh',
    zh_tc: '請輸入修邊刀具直徑',
    ru: 'Введите диаметр обрезки.',
    ko: '모서리 공구 지름을 입력하십시오.',
    bur: 'အစွန်းပြင်ဓားအချင်းထည့်ပါ',
    ben: 'ট্রিমিং নাইফ ডায়ামিটার লিখুন',
    tr: 'Kenar düzeltme bıçağı çapını girin',
    km: 'សូមបញ្ចូលអង្កត់ផ្ចិតមុខកាត់កែគែម',
    es: 'Ingrese el diámetro de la herramienta de recorte',
    ar: 'يرجى إدخال قطر أداة التشذيب',
  },
  'cuttingDock.slowDownSpeedTip': {
    zh: '切割转角减速输入参数错误',
    en: 'Error in entering the deceleration parameter for cutting corners',
    id: 'Parameter input deselerasi sudut pemotongan salah',
    kz: 'Кесу көлемін кеміту жолында тездету параметрлері дұрыс емес',
    th: 'พารามิเตอร์อินพุตการชะลอการลดมุมไม่ถูกต้อง',
    ug: 'قېپىش بۇلۇڭ تۆۋەندىتىش كىرگۈزۈش پارامېتىرى خاتا',
    vi: 'Nhập tham số giảm tốc độ góc cắt không chính xác',
    zh_tc: '切割轉角減速輸入參數錯誤',
    ru: 'Ошибка ввода параметров замедления углового сечения',
    ko: '컷 모서리 감속 입력 매개변수 오류',
    bur: 'ထောင့်ဖြတ်လျော့နှေးမှုထည့်သွင်းပါရာမီတာမှား',
    ben: 'কাটিং কর্নার ডিসেলারেশন ইনপুট প্যারামিটার ত্রুটি',
    tr: 'Köşe kesim yavaşlatma parametresi girişi hatalı',
    km: 'កំហុសបញ្ចូលប៉ារ៉ាម៉ែត្រយឺតនៅមុំកាត់',
    es: 'Parámetros de entrada incorrectos para la desaceleración de la esquina de corte',
    ar: 'معلمات الإدخال الخاطئة لتباطؤ زاوية القطع',
  },
  'cuttingDock.permissionErr': {
    zh: '当前为免费版, 无法保存',
    en: 'This is the free version, saving is not allowed',
    id: 'Versi gratis saat ini, tidak dapat disimpan',
    kz: 'Қазіргі тапсырмалық нұсқада, сақтауға болмайды',
    th: 'ปัจจุบันเวอร์ชันฟรีไม่สามารถบันทึกได้',
    ug: 'ھازىر ھەقسىز نۇسخا، ساقلىيالمايدۇ',
    vi: 'Hiện tại là phiên bản miễn phí, không thể lưu trữ',
    zh_tc: '當前為免費版, 無法保存',
    ru: 'Текущая бесплатная версия, не может быть сохранена',
    ko: '현재 무료 버전으로 저장할 수 없습니다.',
    bur: 'လက်ရှိအခမဲ့ဗားရှင်း၊ သိမ်းမရ',
    ben: 'এটি ফ্রি সংস্করণ, সেভ করার অনুমতি নেই',
    tr: 'Ücretsiz sürüm; kayıt yapılamaz',
    km: 'កំណែឥតគិតថ្លៃ មិនអាចរក្សាទុក',
    es: 'Esta es actualmente una versión gratuita y no se puede guardar',
    ar: 'هذا حاليًا إصدار مجاني ولا يمكن حفظه',
  },
  'cuttingDock.labellingTempErr': {
    zh: '请选择贴标机模板',
    en: 'Please select a labeling machine template',
    id: 'Pilih template mesin pelabelan',
    kz: 'Этикеткалау машинасының шаблонды таңдаңыз',
    th: 'โปรดเลือกเทมเพลตเครื่องฉลาก',
    ug: 'بەلگە قويغۇچ قېلىپىنى تاللاڭ',
    vi: 'Vui lòng chọn mẫu máy dán nhãn',
    zh_tc: '請選擇貼標機模板',
    ru: 'Выберите шаблон',
    ko: '부착기 템플릿을 선택하십시오.',
    bur: 'တံဆိပ်စက်ပုံစံရွေးပါ',
    ben: 'লেবেলিং মেশিন টেমপ্লেট নির্বাচন করুন',
    tr: 'Etiket makinesi şablonu seçin',
    km: 'សូមជ្រើសពុម្ពម៉ាស៊ីនស្លាក',
    es: 'Seleccione la plantilla de la máquina etiquetadora',
    ar: 'يرجى تحديد قالب آلة وضع العلامات',
  },
  'cuttingDock.autoRollInputTip': {
    zh: '开启标签自动旋转，需输入有效值',
    en: 'To enable automatic label rotation, a valid value must be entered',
    id: 'Nyalakan tag untuk berputar secara otomatis, dan Anda harus memasukkan nilai yang valid',
    kz: 'Етикетка автоматты түрде айналуды қосу үшін, тиімді мәнді енгізіңіз',
    th: 'เปิดแท็กเพื่อหมุนโดยอัตโนมัติและคุณต้องป้อนค่าที่ถูกต้อง',
    ug: 'بەلگە ئاپتوماتىك ئۆرۈلۈشىنى قوزغىتىش ئۈچۈن، ئىناۋەتلىك قىممەت كىرگۈزۈڭ',
    vi: 'Bật tự động xoay nhãn, cần nhập giá trị hợp lệ',
    zh_tc: '開啟標籤自動旋轉，需輸入有效值',
    ru: 'Открыть вкладку для автоматического вращения, введите действительное значение',
    ko: '탭 자동 회전을 켜려면 유효한 값을 입력해야 합니다',
    bur: 'တံဆိပ်အလိုအလျောက်လည်ဖွင့်ရန်တန်ဖိုးထည့်ရမည်',
    ben: 'অটোমেটিক লেবেল রোটেশন চালু করতে বৈধ মান লিখতে হবে',
    tr: 'Etiket otomatik dönüş için geçerli değer girin',
    km: 'បើកការបង្វិលស្លាកស្វ័យប្រវត្តិត្រូវបញ្ចូលតម្លៃត្រឹមត្រូវ',
    es: 'Active la rotación automática de etiquetas, se debe ingresar un valor válido',
    ar: 'تشغيل التدوير التلقائي للملصق، يجب إدخال قيمة صالحة',
  },
  'cuttingDock.offlineTempFormat': {
    zh: '当前贴标机文件格式已下线, 请确认',
    en: 'The current labeling machine file format has been discontinued. Please confirm',
    id: 'Format file mesin pelabelan saat ini telah offline, harap konfirmasi',
    kz: 'Қазіргі этикеткалау машинасының файл пішімі қолданылмайды, растаңыз',
    th: 'รูปแบบไฟล์เครื่องฉลากปัจจุบันได้รับการออฟไลน์โปรดยืนยัน',
    ug: 'نۆۋەتتىكى بەلگە قويغۇچ ھۆججەت فورماتى ئۈزۈلگەن، جەزملەڭ',
    vi: 'Định dạng tệp máy dán nhãn hiện tại đã ngừng hoạt động, vui lòng xác nhận',
    zh_tc: '當前貼標機文件格式已下線, 請確認',
    ru: 'Текущий формат файла наклейки отключен, пожалуйста, подтвердите',
    ko: '현재 부착기 파일 형식이 오프라인 상태입니다. 확인하십시오.',
    bur: 'လက်ရှိတံဆိပ်စက်ဖိုင်ဖော်မတ်ပယ်ဖျက်ပြီး၊ အတည်ပြုပါ',
    ben: 'বর্তমান লেবেলিং মেশিন ফাইল ফরম্যাট বন্ধ, নিশ্চিত করুন',
    tr: 'Mevcut etiket dosya biçimi kullanımdan kaldırıldı; onaylayın',
    km: 'ទ្រង់ទ្រាយឯកសារម៉ាស៊ីនស្លាកបច្ចុប្បន្នបានផ្តាច់ សូមបញ្ជាក់',
    es: 'El formato de archivo actual de la máquina etiquetadora está fuera de línea, confirme',
    ar: 'تنسيق ملف آلة وضع العلامات الحالي غير متصل، يرجى تأكيد',
  },
  'cuttingDock.autoStockCode1': {
    zh: '工位1自动上料代码',
    en: 'Station 1 automatic feeding code',
    id: 'Stasiun 1 kode pemuatan otomatis',
    kz: '1-орын автоматтық жүктеме коды',
    th: 'สถานี 1 รหัสโหลดอัตโนมัติ',
    ug: 'پوچتا 1 ئاپتوماتىك ماتېرىيال كودى',
    vi: 'Mã tự động nạp liệu vị trí 1',
    zh_tc: '工位1自動上料代碼',
    ru: 'Станция 1 Автоматическая загрузка кода',
    ko: '작업 위치 1 자동 공급 코드',
    bur: 'အလုပ်ဌာန၁အလိုအလျောက်အပေါ်ပစ္စည်းကုဒ်',
    ben: 'স্টেশন ১ অটোমেটিক ফিডিং কোড',
    tr: 'İstasyon 1 otomatik yükleme kodu',
    km: 'កូដផ្ទុកដោយស្វ័យប្រវត្តិកន្លែង ១',
    es: 'Código de alimentación automática de la estación 1',
    ar: 'رمز التغذية التلقائي للمحطة 1',
  },
  'cuttingDock.autoStockCode1PlaceHolder': {
    zh: '输入工位1自动上料代码',
    en: 'Enter the automatic feeding code for Station 1',
    id: 'Masukkan kode pemuatan workstation 1 otomatis',
    kz: '1-орын автоматтық жүктеме кодын енгізіңіз',
    th: 'ป้อนรหัสการโหลดอัตโนมัติของเวิร์กสเตชัน 1',
    ug: 'پوچتا 1 ئاپتوماتىك ماتېرىيال كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã tự động nạp liệu vị trí 1',
    zh_tc: '輸入工位1自動上料代碼',
    ru: 'Введите код автоматической загрузки станции 1',
    ko: '작업 위치 1 자동 공급 코드 입력',
    bur: 'အလုပ်ဌာန၁အလိုအလျောက်အပေါ်ပစ္စည်းကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ১ অটোমেটিক ফিডিং কোড লিখুন',
    tr: 'İstasyon 1 otomatik yükleme kodunu girin',
    km: 'បញ្ចូលកូដផ្ទុកដោយស្វ័យប្រវត្តិកន្លែង ១',
    es: 'Ingrese la alimentación automática de la estación 1 código',
    ar: 'أدخل التغذية التلقائية للمحطة 1 كود',
  },
  'cuttingDock.autoStockCode2PlaceHolder': {
    zh: '输入工位2自动上料代码',
    en: 'Enter the automatic feeding code for Station 2',
    id: 'Masukkan kode pemuatan otomatis workstation 2',
    kz: '2-орын автоматтық жүктеме кодын енгізіңіз',
    th: 'ป้อนรหัสการโหลดอัตโนมัติของเวิร์กสเตชัน 2',
    ug: 'پوچتا 2 ئاپتوماتىك ماتېرىيال كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã tự động nạp liệu vị trí 2',
    zh_tc: '輸入工位2自動上料代碼',
    ru: 'Введите код автоматической загрузки 2',
    ko: '작업 위치 2 자동 공급 코드 입력',
    bur: 'အလုပ်ဌာန၂အလိုအလျောက်အပေါ်ပစ္စည်းကုဒ်ထည့်ပါ',
    ben: 'স্টেশন ২ অটোমেটিক ফিডিং কোড লিখুন',
    tr: 'İstasyon 2 otomatik yükleme kodunu girin',
    km: 'បញ្ចូលកូដផ្ទុកដោយស្វ័យប្រវត្តិកន្លែង ២',
    es: 'Ingrese el código de alimentación automática de la estación 2',
    ar: 'أدخل كود التغذية التلقائية للمحطة 2',
  },
  'cuttingDock.autoStockCode2': {
    zh: '工位2自动上料代码',
    en: 'Station 2 automatic feeding code',
    id: 'Stasiun 2 kode pemuatan otomatis',
    kz: '2-орын автоматтық жүктеме коды',
    th: 'รหัสการโหลดอัตโนมัติสถานี 2',
    ug: 'پوچتا 2 ئاپتوماتىك ماتېرىيال كودى',
    vi: 'Mã tự động nạp liệu vị trí 2',
    zh_tc: '工位2自動上料代碼',
    ru: 'Станция 2 Автоматическая загрузка кода',
    ko: '작업 위치 2 자동 공급 코드',
    bur: 'အလုပ်ဌာန၂အလိုအလျောက်အပေါ်ပစ္စည်းကုဒ်',
    ben: 'স্টেশন ২ অটোমেটিক ফিডিং কোড',
    tr: 'İstasyon 2 otomatik yükleme kodu',
    km: 'កូដផ្ទុកដោយស្វ័យប្រវត្តិកន្លែង ២',
    es: 'Código de carga automática de la estación 2',
    ar: 'رمز التحميل التلقائي للمحطة 2',
  },
  'cuttingDock.pauseCode': {
    zh: '暂停代码',
    en: 'Pause code',
    id: 'Kode jeda',
    kz: 'Тынықтау коды',
    th: 'รหัสหยุดชั่วคราว',
    ug: 'توختىتىش كودى',
    vi: 'Mã tạm dừng',
    zh_tc: '暫停代碼',
    ru: 'Приостановить код',
    ko: '코드 일시 중지',
    bur: 'ခဏရပ်ကုဒ်',
    ben: 'পজ কোড',
    tr: 'Duraklatma kodu',
    km: 'កូដផ្អាក',
    es: 'Código de pausa',
    ar: 'رمز الإيقاف المؤقت',
  },
  'cuttingDock.pauseCodePlaceHolder': {
    zh: '输入暂停代码',
    en: 'Enter the pause code',
    id: 'Masukkan kode jeda',
    kz: 'Тынықтау кодын енгізіңіз',
    th: 'ป้อนรหัสหยุดชั่วคราว',
    ug: 'توختىتىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã tạm dừng',
    zh_tc: '輸入暫停代碼',
    ru: 'Введите код паузы',
    ko: '일시 중지 코드 입력',
    bur: 'ခဏရပ်ကုဒ်ထည့်ပါ',
    ben: 'পজ কোড লিখুন',
    tr: 'Duraklatma kodunu girin',
    km: 'បញ្ចូលកូដផ្អាក',
    es: 'Ingresar código de pausa',
    ar: 'أدخل رمز الإيقاف المؤقت',
  },
  'cuttingDock.cuttingToolMaxDepthTip': {
    zh: '刀库{errKey}刀中单次最大加工深度不能大于刀具长度',
    en: 'The maximum machining depth of the {errKey} knife in the knife library cannot be greater than the length of the cutting tool',
    id: 'Kedalaman pemotongan maksimum {errKey} pisau dalam perpustakaan pisau tidak boleh lebih besar dari panjang pisau',
    kz: 'Кескіштер қоймасындағы {errKey} кескішінің ең үлкен бір реттік қатауы кескіш ұзындығынан үлкен болуы мүмкін емес',
    th: 'ความลึกการประมวลผลสูงสุดของ {errKey} มีดในห้องมีดไม่สามารถมากกว่าความยาวของมีด',
    ug: 'قۇر قويغۇچتا {errKey} قۇر قويغۇچتا ئىشلەش ئالدى ئىزاھات كودى قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا قۇر قويغۇچتا ق ',
    vi: 'Kedalaman pemotongan maksimum {errKey} pisau dalam perpustakaan pisau tidak boleh lebih besar dari panjang pisau',
    zh_tc: '刀庫{errKey}刀中單次最大加工深度不能大於刀具長度',
    ru: 'Максимальная глубина обработки {errKey} ножа в библиотеке ножей не может быть больше длины ножа',
    ko: '{errKey} 칼 라이브러리에서 한 번의 최대 가공 깊이는 칼 길이보다 커서는 안됩니다',
    bur: 'ဓားသိုက်{errKey}ဓားတွင်တစ်ကြိမ်အများဆုံးပြုပြင်အနက်သည်ဓားအရှည်ထက်မကြီးရ',
    ben: 'নাইফ লাইব্রেরিতে {errKey} নাইফের একবারের সর্বোচ্চ মেশিনিং গভীরতা কাটিং টুলের দৈর্ঘ্যের চেয়ে বড় হতে পারবে না',
    tr: 'Bıçak kütüphanesindeki {errKey} bıçağının tek seferdeki maksimum işleme derinliği bıçak uzunluğundan büyük olamaz',
    km: 'ក្នុងឃ្លាំងដាក់ឧបករណ៍កាត់ {errKey} ជម្រៅដំណើរការអតិបរមាក្នុងមួយដងមិនអាចធំជាងប្រវែងឧបករណ៍កាត់',
    es: 'Almacén de herramientas {errKey} La profundidad máxima de procesamiento individual en la herramienta no puede ser mayor que la longitud de la herramienta',
    ar: 'مجلة الأدوات {errKey} لا يمكن أن يكون الحد الأقصى لعمق المعالجة الفردي في الأداة أكبر من طول الأداة',
  },
  'cuttingDock.cuttingParams.title': {
    zh: '切割参数',
    en: 'Cutting Parameters',
    id: 'Parameter pemotongan',
    kz: 'Кескіш параметрі',
    th: 'การตัดพารามิเตอร์',
    ug: 'قېپىش پارامېتىرلىرى',
    vi: 'Các tham số cắt',
    zh_tc: '切割參數',
    ru: 'параметры резки',
    ko: '가공 매개변수',
    bur: 'ဖြတ်တောက်ပါရာမီတာ',
    ben: 'কাটিং প্যারামিটার',
    tr: 'Kesim parametreleri',
    km: 'ប៉ារ៉ាម៉ែត្រកាត់',
    es: 'Parámetros de corte',
    ar: 'معلمات القطع',
  },
  'cuttingDock.cuttingParams.stationWidth': {
    zh: '台面宽度',
    en: 'Station Width',
    id: 'Lebar stasiun',
    kz: 'Станок ені',
    th: 'ความกว้างของพื้นที่ทำงาน',
    ug: 'قۇر قويغۇچتا چوڭلۇقى',
    vi: 'Chiều rộng của bàn làm việc',
    zh_tc: '台面寬度',
    ru: 'ширина станка',
    ko: '작업 면적 너비',
    bur: 'ပြင်သစ်ကြီးအလျား',
    ben: 'কাটিং প্যারামিটার',
    tr: 'İş alanı genişliği',
    km: 'កម្រិតកាត់កាត់',
    es: 'Ancho de la estación',
    ar: 'عرض المكان',
  },
  'cuttingDock.cuttingParams.stationWidthTip': {
    zh: '使用余料大板时，宽度方向只能在设置的尺寸范围内排小板',
    en: 'When using surplus large panels, the width direction can only be arranged within the set size range',
    id: 'Ketika menggunakan panel besar sisa, arah lebar hanya dapat disusun dalam rentang ukuran yang ditetapkan',
    kz: 'Қалдық үлкен плиталарды қолданған кезде, ені бағытында тек қабылданған өлшем шегінде орналастыруға болады',
    th: 'เมื่อใช้แผ่นขนาดใหญ่ที่เหลือจากการตัด ทิศทางความกว้างสามารถจัดเรียงได้เฉพาะในช่วงขนาดที่กำหนดเท่านั้น',
    ug: 'قالدۇق چوڭ تاختا ئىشلەتكەندە، كەڭلىك يۆنىلىشىدە پەقەت تەڭشەلگەن ئۆلچەم دائىرىسىدە كىچىك تاختىلارنى رەتكە تىزىشقا بولىدۇ',
    vi: 'Khi sử dụng tấm lớn từ phôi thừa, hướng chiều rộng chỉ có thể xếp tấm nhỏ trong phạm vi kích thước đã đặt',
    zh_tc: '使用餘料大板時，寬度方向只能在設置的尺寸範圍內排小板',
    ru: 'При использовании крупных панелей из остатков расположение мелких панелей по ширине допускается только в заданном диапазоне размеров',
    ko: '자투리 대판을 사용할 때 폭 방향으로는 설정된 치수 범위 내에서만 소판을 배치할 수 있습니다',
    bur: 'ပိုလျှံပစ္စည်းကြီးဘုတ်ကိုအသုံးပြုသည့်အခါ အကျယ်ဦးတည်ချက်တွင် သတ်မှတ်ထားသောအရွယ်အစားအကွာအဝေးအတွင်းသာ အသေးဘုတ်များကို စီစဉ်နိုင်သည်',
    ben: 'উদ্বৃত্ত বড় প্যানেল ব্যবহার করার সময়, প্রস্থ দিকে শুধুমাত্র নির্ধারিত আকারের সীমার মধ্যে ছোট প্যানেল সাজানো যায়',
    tr: 'Artık büyük levha kullanılırken, genişlik yönünde küçük levhalar yalnızca ayarlanan boyut aralığında yerleştirilebilir',
    km: 'នៅពេលប្រើបន្ទះធំពីសម្ភារៈសល់ ទិសដៅទទឹងអាចរៀបចំបន្ទះតូចបានតែក្នុងជួរទំហំដែលបានកំណត់ប៉ុណ្ណោះ',
    es: 'Al usar paneles grandes de sobrante, la dirección del ancho solo puede disponer paneles pequeños dentro del rango de tamaño establecido',
    ar: 'عند استخدام الألواح الكبيرة من البقايا، يمكن ترتيب الألواح الصغيرة في اتجاه العرض فقط ضمن نطاق الحجم المحدد',
  },
  'cuttingDock.cuttingParams.holeSlotMainSide': {
    zh: '孔槽集中面',
    en: 'Concentrated Face of Holes and Slots',
    id: 'Slot lubang permukaan terkonsentrasi',
    kz: 'Тесік және ойықтықтардің шоғырлануы',
    th: 'พื้นผิวที่เข้มข้น',
    ug: 'تەشىك-ئارقا مەركەز تەرەپ',
    vi: 'Mặt tập trung của lỗ khoan và khe',
    zh_tc: '孔槽集中面',
    ru: 'концентратор отверстия',
    ko: '구멍 슬롯 집중면',
    bur: 'အပေါက်ချောင်းစုစည်းမျက်နှာ',
    ben: 'হোল ও স্লট কনসেন্ট্রেটেড ফেস',
    tr: 'Delik ve olukların yoğun olduğu yüz',
    km: 'ផ្ទៃប្រមូលរណ្តៅ និងរណ្តៅជង្ហុក',
    es: 'Superficie de concentración de orificios',
    ar: 'سطح تركيز الثقب',
  },
  'cuttingDock.cuttingParams.holeMainSide': {
    zh: '孔集中面',
    en: 'Concentrated Face of Holes',
    id: 'Permukaan konsentrasi lubang',
    kz: 'Тесік шоғырлануы',
    th: 'พื้นผิวความเข้มข้นของรู',
    ug: 'تەشىك مەركەز تەرەپ',
    vi: 'Mặt tập trung của lỗ khoan',
    zh_tc: '孔集中面',
    ru: 'концентратор отверстия',
    ko: '구멍 집중면',
    bur: 'အပေါက်စုစည်းမျက်နှာ',
    ben: 'হোল কনসেন্ট্রেটেড ফেস',
    tr: 'Deliklerin yoğun olduğu yüz',
    km: 'ផ្ទៃប្រមូលរណ្តៅ',
    es: 'Superficie de concentración de orificios',
    ar: 'سطح تركيز الفتحة',
  },
  'cuttingDock.cuttingParams.slotMainSide': {
    zh: '槽集中面',
    en: 'Concentrated Face of Slots',
    id: 'Groove permukaan terkonsentrasi',
    kz: 'Ойықтық шоғырлануы',
    th: 'พื้นผิวเข้ม',
    ug: 'ئارقا مەركەز تەرەپ',
    vi: 'Mặt tập trung của khe',
    zh_tc: '槽集中面',
    ru: 'концентратор паза',
    ko: '슬롯 집중면',
    bur: 'ချောင်းစုစည်းမျက်နှာ',
    ben: 'স্লট কনসেন্ট্রেটেড ফেস',
    tr: 'Olukların yoğun olduğu yüz',
    km: 'ផ្ទៃប្រមូលរណ្តៅជង្ហុក',
    es: 'Superficie de concentración de ranuras',
    ar: 'سطح تركيز الفتحة',
  },
  'cuttingDock.cuttingParams.workPriority': {
    zh: '(功能优先级：特殊孔槽加工面自定义>打穿孔槽所在面跟随该小板上未穿孔槽>孔槽分流中设置的特殊孔槽优先排在大板正面>槽集中面>孔集中面)',
    en: '(Functional Priority: The face with punching holes and slots follows the unpunched holes and slots on the small board > Special slots set in the slot diversion are prioritized on the front side of the large panel > Concentrated Face of Slots > Concentrated Face of Holes)',
    id: '(Fungsi Prioritas: Permukaan di mana slot berlubang terletak mengikuti slot yang tidak diperkuat pada pelat kecil> pelurus dan lubang cangkir engsel ditempatkan di belakang pelat besar untuk memproses> permukaan konsentrasi alur> permukaan konsentrasi lubang)',
    kz: '(Қызметтілік басымдығы: кесу тесіктері мен ойықтықтарды картаданың осы бетіндегі тесіктерге сәйкес кесу > Ойық бөлінісінде орнатылған арнайы ойықтар үлкен тақтаның алдыңғы жағында басымдыққа ие > Ойықтық шоғырлануы > Тесік шоғырлануы)',
    th: '(ลำดับความสำคัญของฟังก์ชั่น: พื้นผิวที่มีช่องเสียบที่มีรูพรุนตามช่องสล็อตที่ไม่มีรูพรุนบนแผ่นเล็ก ๆ > เครื่องหนีบผมและรูของรูบานพับจะถูกวางไว้ที่ด้านหลังของแผ่นขนาดใหญ่เพื่อประมวลผล> พื้นผิวความเข้มข้นของร่อง> พื้นผิวความเข้มข้นของรู)',
    ug: '(فۇنكسىيە ئەھمىيەت تەرتىپى: ئالاھىدە تەشىك-ئارقا ئىشلەش تەرەپ ئىختىيارى>ئېچىلغان تەشىك-ئارقالار ئۇ تاختىدا ئېچىلمىغان تەشىك-ئارقالارغا ئەگەشىدۇ>تەشىك-ئارقا تارقىتىش تەڭشىكىدىكى ئالاھىدە تەشىك-ئارقالار چوڭ تاختىنىڭ ئالدى تەرىپىگە ئالدىنقى قاتاردا تەڭشەيدۇ>ئارقا مەركەز تەرەپ>تەشىك مەركەز تەرەپ)',
    vi: '(Ưu tiên chức năng: mặt có lỗ khoan/khe sẽ đi theo tấm nhỏ chưa có lỗ khoan/khe > Các rãnh đặc biệt được đặt trong sự phân luồng rãnh được ưu tiên ở mặt trước của tấm lớn > mặt tập trung của khe > mặt tập trung của lỗ khoan)',
    zh_tc:
      '(功能優先級：打穿孔槽所在面跟隨該小板上未穿孔槽>拉直器和鉸鏈杯孔放在大板反面加工>孔槽分流中設置的特殊孔槽優先排在大板正面>槽集中面>孔集中面)',
    ru: '(Функциональный приоритет: Настройка поверхности обработки специального отверстия > Расположение пробивного отверстия следует за непробиваемым отверстием на этой пластине > Специальные отверстия, установленные в шунте отверстия, имеют приоритет на лицевой стороне большой пластины > концентратор отверстия > концентратор отверстия)',
    ko: '(기능 우선 순위: 특수 구멍 슬롯 가공면 사용자 지정 > 구멍 뚫기 슬롯 소재 면은 이 보드에 구멍이 뚫리지 않은 슬롯을 따릅니다. > 구멍 슬롯 분류에 설정된 특수 구멍 슬롯은 대판 정면 > 슬롯 집중면 > 구멍 집중면에 우선적으로 배치됩니다.)',
    bur: '(လုပ်ဆောင်ချက်ဦးစားပေး-အထူးအပေါက်ချောင်းပြုမျက်နှာစိတ်ကြိုက်>ဖောက်အပေါက်ချောင်းရှိမျက်နှာထိုပေါ်ဒ်ငယ်ပေါ်မဖောက်ထားအပေါက်ချောင်းလိုက်>အပေါက်ချောင်းခွဲရာတွင်သတ်မှတ်အထူးအပေါက်ချောင်းကြီးပြားရှေ့တွင်ဦးစား>ချောင်းစုမျက်နှာ>အပေါက်စုမျက်နှာ)',
    ben: '(ফাংশনাল প্রায়োরিটি: পাঞ্চিং হোল ও স্লটের ফেস ছোট বোর্ডের আনপাঞ্চড হোল স্লট অনুসরণ করে > স্লট ডাইভারশনে সেট বিশেষ স্লট বড় প্যানেলের সামনে প্রায়োরিটি > স্লট কনসেন্ট্রেটেড ফেস > হোল কনসেন্ট্রেটেড ফেস)',
    tr: '(İşlev önceliği: özel delik/oluk işleme yüzeyi özelleştirmesi > delinmiş delik/olukların bulunduğu yüz, küçük plakadaki delinmemiş delik/oluklara göre izler > oluk yönlendirmede ayarlanan özel delik/oluklar büyük plaka ön yüzünde önceliklidir > oluk yoğun yüzü > delik yoğun yüzü)',
    km: '(អាទិភាពមុខងារ៖ កំណត់ផ្ទៃដំណើរការរណ្តៅពិសេសផ្ទាល់ខ្លួន > ផ្ទៃមានរណ្តៅរអិសដែលបានរណ្តៅធ្វើតាមរណ្តៅរអិសមិនទាន់រណ្តៅនៅផ្ទាំងតូច > រណ្តៅរអិសពិសេសក្នុងការបែងចែករណ្តៅរអិសត្រូវរៀបមុខផ្ទាំងធំជាមុនសិន > ផ្ទៃប្រមូលរណ្តៅរអិស > ផ្ទៃប្រមូលរណ្តៅ)',
    es: '(Prioridad de función: Personalizar la superficie especial de procesamiento de orificios y ranuras > El lado donde se encuentra la ranura perforada sigue la ranura sin perforar en la placa pequeña > Las ranuras de orificios especiales configuradas en el orificio y la desviación de ranura tienen prioridad en el frente de la placa grande > Superficie de concentración de ranura > Superficie de concentración de orificios)',
    ar: '(أولوية الوظيفة: تخصيص الفتحة الخاصة وسطح معالجة الفتحة > يتبع الجانب الذي توجد فيه الفتحة المثقوبة فتحة غير مثقوبة على اللوحة الصغيرة > يتم إعطاء الأولوية لفتحات الثقب الخاصة الموجودة في الفتحة وتحويل الفتحة على الجزء الأمامي من اللوحة الكبيرة > سطح تركيز الفتحة > سطح تركيز الفتحة)',
  },
  'cuttingDock.cuttingParams.holeSlotSet': {
    zh: '打穿孔槽加工设置',
    en: 'Punching slot processing settings',
    id: 'Pengaturan pemotongan slot berlubang',
    kz: 'Тишек сондырау бассейни ишлеу настройкалары',
    th: 'ตั้งค่าการประมวลผลสล็อตที่มีรูพรุน',
    ug: 'ئېچىلغان تەشىك-ئارقا ئىشلەش تەڭشىكى',
    vi: 'Cài đặt xử lý rãnh khoan',
    zh_tc: '打穿孔槽加工設置',
    ru: 'Параметры обработки в прорезях',
    ko: '구멍 뚫기 슬롯 가공 설정',
    bur: 'ဖောက်အပေါက်ချောင်းပြုဆက်တင်',
    ben: 'পাঞ্চিং স্লট প্রসেসিং সেটিংস',
    tr: 'Delinmiş delik/oluk işleme ayarı',
    km: 'ការកំណត់ដំណើរការរណ្តៅដែលបានរណ្តៅ',
    es: 'Configuración de procesamiento de ranuras de perforación y perforación',
    ar: 'إعدادات معالجة فتحة التثقيب والتثقيب',
  },
  'cuttingDock.cuttingParams.hingeRollWork': {
    zh: '拉直器和铰链杯孔放到大板反面加工',
    en: 'Straightener and Hinge Cup Holes are Processed on the Reverse Side of the Large Board',
    id: 'Lubang pelurus dan cangkir engsel ditempatkan di bagian belakang piring besar untuk diproses',
    kz: 'Тіктегіш пен шарнирлік ойықтықтарды ірі картаның артқы бетінде кесу',
    th: 'มีการวางรูถ้วยและบานพับไว้ที่ด้านหลังของแผ่นขนาดใหญ่เพื่อประมวลผล',
    ug: 'تۇتاشتۇرغۇچ ۋە سانجىق كۆزى تەشىكىنى چوڭ تاختىنىڭ ئارقا تەرىپىگە قويۇش',
    vi: 'Đặt lỗ khoan của chân thẳng và vòi nối ở mặt sau của tấm lớn để gia công',
    zh_tc: '拉直器和鉸鏈杯孔放到大板反面加工',
    ru: 'Выпрямитель и отверстие в шарнирном стакане для обработки на обратной стороне большой пластины',
    ko: '지퍼 및 경첩 컵 구멍을 대형 플레이트 후면에 배치하여 가공',
    bur: 'ဆွဲဖြောင့်နှင့်ချိန်းခွက်အပေါက်ကိုကြီးပြားအနောက်တွင်ပြု',
    ben: 'স্ট্রেইটনার ও হিঞ্জ কাপ হোল বড় বোর্ডের উল্টো পাশে প্রসেস করা হয়',
    tr: 'Düzleştirici ve menteşe kovan delikleri büyük plakanın ters yüzünde işlenir',
    km: 'រណ្តៅឧបករណ៍ទាញផ្តិត និងពែងចង្កឹះដំណើរការនៅផ្ទៃខាងក្រោយផ្ទាំងធំ',
    es: 'Coloque los orificios del enderezador y de la copa de bisagra en la parte posterior de la placa grande para su procesamiento',
    ar: 'ضع فتحات الكوب والمفصلة على الجانب الخلفي من اللوحة الكبيرة للمعالجة',
  },
  'cuttingDock.cuttingParams.followWork': {
    zh: '打穿孔槽所在面跟随该小板上未穿孔槽',
    en: 'The face with punching holes and slots follows the unpunched holes and slots on the small board',
    id: 'Permukaan slot berlubang mengikuti slot yang tidak diperoleh pada pelat kecil.',
    kz: 'Кесу тесіктері мен ойықтықтарды картаданың осы бетіндегі тесіктерге сәйкес кесу',
    th: 'พื้นผิวของสล็อตที่มีรูพรุนจะตามสล็อตที่ไม่มีรูพรุนบนแผ่นเล็ก ๆ',
    ug: 'ئېچىلغان تەشىك-ئارقالار ئۇ تاختىدا ئېچىلمىغان تەشىك-ئارقالارغا ئەگەشىدۇ',
    vi: 'Mặt có lỗ khoan/khe đi theo tấm nhỏ chưa có lỗ khoan/khe',
    zh_tc: '打穿孔槽所在面跟隨該小板上未穿孔槽',
    ru: 'Пробиваемые отверстия следуют за панелью без отверстий.',
    ko: '구멍 뚫기 슬롯의 소재면은 이 판자의 구멍 뚫지 않은 슬롯을 따른다',
    bur: 'ဖောက်အပေါက်ချောင်းရှိမျက်နှာထိုပေါ်ဒ်ငယ်ပေါ်မဖောက်ထားအပေါက်ချောင်းလိုက်',
    ben: 'পাঞ্চিং হোল ও স্লটের ফেস ছোট বোর্ডের আনপাঞ্চড হোল স্লট অনুসরণ করে',
    tr: 'Delinmiş delik/oluk yüzü, küçük plakadaki delinmemiş delik/oluklara göre izler',
    km: 'ផ្ទៃរណ្តៅដែលបានរណ្តៅធ្វើតាមរណ្តៅមិនទាន់រណ្តៅនៅផ្ទាំងតូចនោះ',
    es: 'El lado donde se encuentra la ranura perforada sigue la ranura sin perforar en la placa pequeña',
    ar: 'يتبع الجانب الذي توجد فيه الفتحة المثقوبة الفتحة غير المثقبة على اللوحة الصغيرة',
  },
  'cuttingDock.cuttingParams.autoMatchSide': {
    zh: '按比例分配正反面孔槽',
    en: 'Allocate Front and Back Holes and Slots Proportionally',
    id: 'Mendistribusikan alur wajah positif dan negatif secara proporsional',
    kz: 'Ортақ-қарамақтық ойықтық пен тесіктерді пропорционалды қарай бөлшектеу',
    th: 'แจกจ่ายร่องใบหน้าที่เป็นบวกและลบตามสัดส่วน',
    ug: 'نىسبەت بويىچە ئالدى-ئارقا تەشىك-ئارقالارنى تەقسىملەش',
    vi: 'Phân chia tỷ lệ mặt trước và sau của lỗ khoan/khe',
    zh_tc: '按比例分配正反面孔槽',
    ru: 'Пропорционально распределить положительное и отрицательное отверстие',
    ko: '양수 얼굴 반전 슬롯 비례 지정',
    bur: 'အချိုးကျရှေ့အနောက်အပေါက်ချောင်းခွဲဝေ',
    ben: 'সামনে ও পিছনের হোল ও স্লট আনুপাতিকভাবে বরাদ্দ করুন',
    tr: 'Ön ve arka delik/olukları orantılı dağıt',
    km: 'ចែករណ្តៅមុខ និងក្រោយតាមសមាមាត្រ',
    es: 'Asigne proporcionalmente las ranuras de orificios frontal y posterior',
    ar: 'بشكل متناسب تخصيص فتحات الفتحات الأمامية والخلفية',
  },
  'cuttingDock.cuttingParams.backHSRate': {
    zh: '反面孔槽占比',
    en: 'Proportion of Holes and Slots on the Reverse Side',
    id: 'Proporsi slot wajah terbalik',
    kz: 'Артқы бетіндегі ойықтық пен тесіктердің қарай болушыны',
    th: 'สัดส่วนสล็อตใบหน้าย้อนกลับ',
    ug: 'ئارقا تەرەپ تەشىك-ئارقا نىسبىتى',
    vi: 'Tỷ lệ lỗ khoan/khe ở mặt sau',
    zh_tc: '反面孔槽佔比',
    ru: 'Доля отверстий с обратной стороны',
    ko: '후면 구멍 슬롯 비율',
    bur: 'အနောက်မျက်နှာအပေါက်ချောင်းရာခိုင်နှုန်း',
    ben: 'উল্টো পাশের হোল ও স্লটের অনুপাত',
    tr: 'Arka yüz delik/oluk oranı',
    km: 'សមាមាត្ររណ្តៅក្រោយ',
    es: 'Proporción de ranura inversa',
    ar: 'نسبة الفتحات العكسية',
  },
  'cuttingDock.cuttingParams.matchTip': {
    zh: '高光板、开启计算异形或对纹的排版方案都不会生效此设置',
    en: '(This setting will not be effective for high-gloss boards, or for opening and calculating abnormal layout plans, or for pattern matching)',
    id: '(Pengaturan ini tidak akan berlaku ketika papan highlight, skema tata letak yang memungkinkan perhitungan bentuk, atau pencocokan pola)',
    kz: '（Жарық панелі, атайын пішімді планшеттерді есептеудің орналасу схемасы немесе үлгіні сәйкестендіру осы параметрді қолданбайды）',
    th: '(การตั้งค่านี้จะไม่มีผลเมื่อบอร์ดไฮไลต์, รูปแบบเค้าโครงที่ช่วยให้การคำนวณรูปร่าง, หรือการจับคู่ลวดลาย)',
    ug: 'يورۇق تاختا، ئالاھىدە شەكىللىك تەڭشەلگەن تەڭشەكلەر ياكى نەقىش ماسلاشتۇرۇش بۇ تەڭشەكنى ئىشلەتمەيدۇ',
    vi: '（Cài đặt này sẽ không có hiệu lực đối với các bản in với bảng cao ánh, tính toán các bản in hình dị hình khác nhau, hoặc ghép mẫu）',
    zh_tc: '高光板、開啟計算異形或對紋的排版方案都不會生效此設置',
    ru: 'Эта настройка не сработает ни на высокой световой панели, ни при включении схемы набора для вычисления фасонов, ни при подборе рисунка.',
    ko: '이 설정은 하이라이터, 컴퓨팅 이형 레이아웃 또는 패턴 매칭을 켜도 적용되지 않습니다.',
    bur: 'အမြှီးပြား, အသွင်တွက်ချက်လျှောက်ထုံးဖွင့်သည့်အခါ သို့မဟုတ် ပုံစံကိုက်ညီခြင်းတွင် ဤဆက်တင်မသက်ရောက်',
    ben: '(এই সেটিং হাই-গ্লস বোর্ড, অ্যাবনরমাল লেআউট প্ল্যান খুলে হিসাবের ক্ষেত্রে, বা প্যাটার্ন ম্যাচিংয়ের ক্ষেত্রে কার্যকর হবে না)',
    tr: '(Parlak panel, anormal şekil hesaplamalı yerleşim veya desen eşleştirme açıksa bu ayar geçerli olmaz)',
    km: '(ការកំណត់នេះមិនដំណើរការសម្រាប់ផ្ទាំងរលកពន្លឺ, ផែនការរៀបចំដែលបើកគណនារូបរាងមិនធម្មតា, ឬការផ្គូផ្គងលំនាំ)',
    es: 'El tablero de alto brillo, el esquema de composición tipográfica que activa formas especiales calculadas o la coincidencia de patrones no tendrán efecto.',
    ar: 'لن يتم تفعيل اللوحة شديدة اللمعان، أو نظام التنضيد الذي يقوم بتشغيل الأشكال الخاصة المحسوبة، أو مطابقة الأنماط.',
  },
  'cuttingDock.cuttingParams.specIalHoleAndSlotSurface': {
    zh: '特殊孔槽加工面自定义',
    en: 'Custom definition of machining surfaces for special slots and holes',
    id: 'Pengaturan permukaan pemotongan khusus untuk slot dan lubang khusus',
    kz: 'Специальные слоты и отверстия для пользовательской определения обрабатываемых поверхностей',
    th: 'การตั้งค่าการประมวลผลสล็อตที่มีรูพรุน',
    ug: 'ئالاھىدە تەشىك-ئارقا ئىشلەش تەرەپ ئىختىيارى',
    vi: 'Định nghĩa tùy chỉnh bề mặt gia công cho khe hố đặc biệt',
    zh_tc: '特殊孔槽加工面自訂',
    ru: 'Настройка поверхности обработки специальных отверстий',
    ko: '특수 구멍 슬롯 가공면 사용자화',
    bur: 'အထူးအပေါက်ချောင်းပြုမျက်နှာစိတ်ကြိုက်',
    ben: 'বিশেষ স্লট ও হোলের মেশিনিং সারফেস কাস্টম সংজ্ঞা',
    tr: 'Özel delik/oluk işleme yüzeyi özelleştirmesi',
    km: 'កំណត់ផ្ទៃដំណើរការរណ្តៅ និងរណ្តៅជង្ហុកពិសេសផ្ទាល់ខ្លួន',
    es: 'Personalización de la superficie de procesamiento de ranura de orificio especial',
    ar: 'تخصيص سطح معالجة فتحة ثقب خاص',
  },
  'cuttingDock.cuttingParams.specialRuleTip': {
    zh: '请选择特殊孔槽',
    en: 'This field cannot be empty.',
    id: 'Tempat ini tidak boleh kosong',
    kz: 'Бұл орын бұралуы мүмкін',
    th: 'ที่นี้ไม่สามารถเป็นค่าว่างได้',
    ug: 'بۇ يەر بۇخايلايمەيدۇ',
    vi: 'Nơi này không được để trống',
    zh_tc: '請選擇特殊孔槽',
    ru: 'Выберите специальные отверстия',
    ko: '특수 슬롯을 선택하십시오.',
    bur: 'အထူးအပေါက်ချောင်းရွေးပါ',
    ben: 'এই ফিল্ড খালি রাখা যাবে না।',
    tr: 'Lütfen özel delik/oluk seçin',
    km: 'សូមជ្រើសរណ្តៅ និងរណ្តៅជង្ហុកពិសេស',
    es: 'Seleccione una ranura de orificio especial',
    ar: 'يرجى تحديد فتحة ثقب خاصة',
  },
  'cuttingDock.cuttingParams.specialSlotsHoles': {
    zh: '孔槽类型',
    en: 'Hole and slot type',
    id: 'Jenis lubang dan slot',
    kz: 'Бollikтер мен slotтар т tipi',
    th: 'ประเภทรูและ',
    ug: 'خانە-سلات تىپى',
    vi: 'Loại lỗ và khe',
    zh_tc: '孔槽類型',
    ru: 'Тип отверстия',
    ko: '구멍 슬롯 유형',
    bur: 'အပေါက်ချောင်းအမျိုးအစား',
    ben: 'হোল ও স্লট টাইপ',
    tr: 'Delik ve oluk türü',
    km: 'ប្រភេទរណ្តៅ និងរណ្តៅជង្ហុក',
    es: 'Tipo de ranura de orificio',
    ar: 'نوع فتحة الثقب',
  },
  'cuttingDock.cuttingParams.holeType': {
    zh: '孔类型',
    en: 'Hole Type',
    id: 'Jenis Lubang',
    kz: 'Тесік түрі',
    th: 'ประเภทรู',
    ug: 'تېشىك تۈرى',
    vi: 'Loại lỗ',
    zh_tc: '孔類型',
    ru: 'Тип отверстия',
    ko: '구멍 유형',
    bur: 'အပေါက်အမျိုးအစား',
    ben: 'হোল টাইপ',
    tr: 'Delik türü',
    km: 'ប្រភេទរណ្តៅ',
    es: 'Tipo de orificio',
    ar: 'نوع الفتحة',
  },
  'cuttingDock.cuttingParams.specialRules': {
    zh: '规则',
    en: 'Rule',
    id: 'Aturan',
    kz: 'Қандай',
    th: 'กฎ',
    ug: 'نىزام',
    vi: 'Quy tắc',
    zh_tc: '規則',
    ru: 'правило',
    ko: '규칙',
    bur: 'စည်းမျဉ်း',
    ben: 'রুল',
    tr: 'Kural',
    km: 'ច្បាប់',
    es: 'Regla',
    ar: 'القاعدة',
  },
  'cuttingDock.cuttingParams.normalHole': {
    zh: '常规孔',
    en: 'Conventional hole',
    id: 'Lubang konvensional',
    kz: 'Аdaqаллы бollik',
    th: 'รูปกติ',
    ug: 'عادەتتىكى خانە',
    vi: 'Lỗ thông thường',
    zh_tc: '常規孔',
    ru: 'Обычное отверстие',
    ko: '일반 구멍',
    bur: 'ပုံမှန်အပေါက်',
    ben: 'কনভেনশনাল হোল',
    tr: 'Geleneksel delik',
    km: 'រណ្តៅធម្មតា',
    es: 'Orificio normal',
    ar: 'الفتحة العادية',
  },
  'cuttingDock.cuttingParams.normalSlot': {
    zh: '常规槽',
    en: 'Conventional slot',
    id: 'Slot konvensional',
    kz: 'Аdaqаллы slot',
    th: 'ปกติ',
    ug: 'عادەتتىكى سلا ',
    vi: 'Khe thông thường',
    zh_tc: '常規槽',
    ru: 'Обычный паз',
    ko: '일반 슬롯',
    bur: 'ပုံမှန်ချောင်း',
    ben: 'কনভেনশনাল স্লট',
    tr: 'Geleneksel oluk',
    km: 'រណ្តៅជង្ហុកធម្មតា',
    es: 'Ranura regular',
    ar: 'الفتحة العادية',
  },
  'cuttingDock.cuttingParams.holeDiam': {
    zh: '孔直径',
    en: 'Hole diameter',
    id: 'Diameter lubang',
    kz: 'БollikтеңбASI',
    th: 'диаметร์รู',
    ug: 'خانە دىامىترى',
    vi: 'Đường kính lỗ',
    zh_tc: '孔直徑',
    ru: 'Диаметр отверстия',
    ko: '구멍 지름',
    bur: 'အပေါက်အချင်း',
    ben: 'হোল ডায়ামিটার',
    tr: 'Delik çapı',
    km: 'អង្កត់ផ្ចិតរណ្តៅ',
    es: 'Diámetro del orificio',
    ar: 'قطر الثقب',
  },
  'cuttingDock.cuttingParams.slotLongSide': {
    zh: '槽长边',
    en: 'Slot long side',
    id: 'Sisi panjang slot',
    kz: 'SlotтеңбASI ұзengi сirtі',
    th: 'ด้านยาวของ slots',
    ug: 'سلات تىن شىرىن يەر',
    vi: 'Cạnh dài của khe',
    zh_tc: '槽長邊',
    ru: 'Длина паза',
    ko: '슬롯 길이 모서리',
    bur: 'ချောင်းရှည်ဘက်',
    ben: 'স্লট লং সাইড',
    tr: 'Oluk uzun kenarı',
    km: 'ជង្ហុករណ្តៅវែង',
    es: 'Lado largo de la ranura',
    ar: 'فتحة الجانب الطويل',
  },
  'cuttingDock.cuttingParams.slotShortSide': {
    zh: '槽短边',
    en: 'Slot short side',
    id: 'Sisi pendek slot',
    kz: 'SlotтеңбASIқ singі сirtі',
    th: 'ด้านสั้นของ slots',
    ug: 'سلات قىسقى يەر',
    vi: 'Cạnh ngắn của khe',
    zh_tc: '槽短邊',
    ru: 'Короткая кромка паза',
    ko: '슬롯 짧은 모서리',
    bur: 'ချောင်းတိုဘက်',
    ben: 'স্লট শর্ট সাইড',
    tr: 'Oluk kısa kenarı',
    km: 'ជង្ហុករណ្តៅខ្លី',
    es: 'Lado corto de la ranura',
    ar: 'الجانب القصير للفتحة',
  },
  'cuttingDock.cuttingParams.FixedmachSurface': {
    zh: '固定加工面',
    en: 'Fixed machining surface',
    id: 'Permukaan pemrosesan tetap',
    kz: 'Туруктуу обрабатываемая поверхность',
    th: 'ผิวการ 가 가 กะ สพา สถาน ที่ ที่มีค่าเป็นคงที่',
    ug: 'مۇقىم ئىشلەش تەرەپ',
    vi: 'Bề mặt gia công cố định',
    zh_tc: '固定加工面',
    ru: 'неподвижная поверхность обработки',
    ko: '가공면 고정',
    bur: 'ပုံသေပြုပြင်မျက်နှာ',
    ben: 'ফিক্সড মেশিনিং সারফেস',
    tr: 'Sabit işleme yüzeyi',
    km: 'ផ្ទៃដំណើរការថេរ',
    es: 'Superficie de procesamiento fija',
    ar: 'سطح المعالجة الثابت',
  },
  'cuttingDock.cuttingParams.deleteRuleTip': {
    zh: '是否删除该规则',
    en: 'Whether to delete this rule',
    id: 'Apakah Anda ingin menghapus aturan ini?',
    kz: 'Бу қоида жойдан алуы барбы',
    th: 'คุณต้องการลบกฎนี้หรือไม่?',
    ug: 'بۇ قائىدىنى ئۆچۈرەمسىز',
    vi: 'Có nên xóa quy tắc này không',
    zh_tc: '是否刪除該規則',
    ru: 'Исключить ли это правило',
    ko: '규칙 삭제 여부',
    bur: 'ဤစည်းမျဉ်းဖျက်မလား',
    ben: 'এই রুল মুছবেন?',
    tr: 'Bu kural silinsin mi?',
    km: 'លុបច្បាប់នេះឬ?',
    es: 'Si se elimina esta regla',
    ar: 'ما إذا كان سيتم حذف هذه القاعدة',
  },
  'cuttingDock.cuttingParams.blankFront': {
    zh: '大板正面',
    en: 'Front side of the large board',
    id: 'Sisi depan piringan besar',
    kz: 'Большой доски фронтальная сторона',
    th: 'ด้านหน้าของแผ่นใหญ่',
    ug: 'چوڭ تاختىنىڭ ئالدى تەرىپى',
    vi: 'Mặt trước của tấm lớn',
    zh_tc: '大板正面',
    ru: 'Большой фасад',
    ko: '판자 정면',
    bur: 'ကြီးပြားရှေ့မျက်နှာ',
    ben: 'বড় বোর্ডের সামনের দিক',
    tr: 'Büyük plaka ön yüzü',
    km: 'មុខផ្ទាំងធំ',
    es: 'Frente de placa grande',
    ar: 'واجهة اللوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.blankBack': {
    zh: '大板反面',
    en: 'Back side of the large board',
    id: 'Sisi belakang piringan besar',
    kz: 'Большой доски задняя сторона',
    th: 'ด้านหลังของแผ่นใหญ่',
    ug: 'چوڭ تاختىنىڭ ئارقا تەرىپى',
    vi: 'Mặt sau của tấm lớn',
    zh_tc: '大板反面',
    ru: 'Обратная сторона большой доски',
    ko: '널빤지 뒷면',
    bur: 'ကြီးပြားအနောက်မျက်နှာ',
    ben: 'বড় বোর্ডের পিছনের দিক',
    tr: 'Büyük plaka arka yüzü',
    km: 'ក្រោយផ្ទាំងធំ',
    es: 'Reverso de placa grande',
    ar: 'الجانب العكسي للوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.addRules': {
    zh: '添加规则',
    en: 'Add rule',
    id: 'Tambahkan aturan',
    kz: 'Үйләм қоида',
    th: 'เพิ่มกฎ',
    ug: 'قائىدە قوشۇش',
    vi: 'Thêm quy tắc',
    zh_tc: '新增規則',
    ru: 'Добавить правило',
    ko: '규칙 추가',
    bur: 'စည်းမျဉ်းထည့်',
    ben: 'রুল যোগ করুন',
    tr: 'Kural ekle',
    km: 'បន្ថែមច្បាប់',
    es: 'Agregar regla',
    ar: 'أضف قاعدة',
  },
  'cuttingDock.cuttingParams.addRulesTip': {
    zh: '当同一块小板命中多个规则时，生效序号最靠前的规则，可拖拽任意行改变规则顺序',
    en: 'When the same small board matches multiple rules, the rule with the earliest effective sequence number takes effect, You can drag any row to change the rule order',
    id: 'Ketika beberapa aturan dipenuhi oleh piringan kecil yang sama, aturan dengan nomor urut efektif terawal berlaku. Anda dapat menyeret baris mana saja untuk mengubah urutan aturan.',
    kz: 'Бир идишке бир нече каражат тушса, иштелип чыккан номери эң алдыңкы каражат жооп берет. Бир өртебе сүйрөп, каражаттын тартибин өзгөртсө болот',
    th: 'เมื่อแผ่นวงจรขนาดเล็กแผ่นเดียวกันตรงกับหลายกฎ กฎที่มีลำดับก่อนหน้าจะมีผลบังคับใช้ และสามารถลากแถวใดก็ได้เพื่อเปลี่ยนลำดับของกฎ',
    ug: 'بىر تاختا بىر قانچە قائىدىگە ئۇچرىغاندا، تەرتىپ نومۇرى ئەڭ ئالدىدا بولغان قائىدە ئىشلىنىدۇ، ئىستىگە ئەگەشىپ ھەر قانداق قۇرنى ئۆزگەرتسىڭىز بولىدۇ',
    vi: 'Khi cùng một tấm bảng nhỏ phù hợp với nhiều quy tắc, quy tắc có số thứ tự hiệu lực đầu tiên sẽ được áp dụng, Kéo và thả bất kỳ hàng nào để thay đổi thứ tự quy tắc',
    zh_tc:
      '當同一塊小板命中多個規則時，生效序號最靠前的規則，可拖曳任意行改變規則順序',
    ru: 'Когда одна и та же доска попадает в несколько правил, правило, которое имеет самый высокий серийный номер, может перетаскивать любую строку, чтобы изменить порядок правил',
    ko: '동일한 보드가 여러 규칙을 명중시킬 때 가장 앞에 있는 일련 번호가 적용되므로 임의의 행을 드래그하여 규칙 순서를 변경할 수 있습니다.',
    bur: 'တူညီပေါ်ဒ်ငယ်တစ်ခုတည်းတွင်စည်းမျဉ်းများစွာထိသည့်အခါအစီအစဉ်အရှိဆုံးစည်းမျဉ်းသက်ရောက်၊ အတန်းဆွဲပြောင်းနိုင်သည်',
    ben: 'একই ছোট বোর্ড একাধিক রুল মিললে সর্বপ্রথম সিরিয়ালের রুল কার্যকর হয়, যেকোনো সারি টেনে রুল অর্ডার বদলাতে পারেন',
    tr: 'Aynı küçük plaka birden çok kurala uyduğunda en küçük geçerli sıra numaralı kural uygulanır; sırayı değiştirmek için satırları sürükleyebilirsiniz',
    km: 'ពេលផ្ទាំងតូចតែមួយត្រូវនឹងច្បាប់ច្រើន ច្បាប់ដែលមានលេខលំដាប់ដំណើរការតូចបំផុតត្រូវបានអនុវត្ត អាចអូសជួរដើម្បីផ្លាស់ប្តូរលំដាប់ច្បាប់',
    es: 'Cuando la misma placa pequeña Si llega a varias reglas, la regla con el número de serie más alto entrará en vigor. Puede arrastrar cualquier fila para cambiar el orden de las reglas',
    ar: 'عندما تضرب نفس اللوحة الصغيرة قواعد متعددة، وتصبح القاعدة ذات الرقم التسلسلي الأعلى سارية المفعول. يمكنك سحب أي صف لتغيير ترتيب القواعد',
  },
  'cuttingDock.cuttingParams.highGlossSetting': {
    zh: '高光板设置',
    en: 'High-Gloss Board Settings',
    id: 'Sorotan pengaturan papan',
    kz: 'Жарық панелі параметрлері',
    th: 'ไฮไลต์การตั้งค่าบอร์ด',
    ug: 'يورۇق تاختا تەڭشىكى',
    vi: 'Cài đặt bảng cao ánh',
    zh_tc: '高光板設置',
    ru: 'Настройка световой панели',
    ko: '고광택 패널 설정',
    bur: 'အမြှီးပြားဆက်တင်',
    ben: 'হাই-গ্লস বোর্ড সেটিংস',
    tr: 'Parlak panel ayarları',
    km: 'ការកំណត់ផ្ទាំងរលកពន្លឺ',
    es: 'Configuración del tablero resaltado',
    ar: 'إعدادات لوحة التمييز',
  },
  'cuttingDock.cuttingParams.heighGlossFront': {
    zh: '排版时小板高光面排在大板',
    en: 'Small Boards with High-Gloss Faces are Arranged on the Large Board During Layout',
    id: 'Saat mengetik, papan kecil memiliki permukaan gloss tinggi dan diatur di papan besar',
    kz: 'Орналасу кезінде кіші панельдің жарық беті ірі панельге орналастырылады',
    th: 'เมื่อพิมพ์บอร์ดขนาดเล็กมีพื้นผิวมันวาวสูงและจัดเรียงบนกระดานขนาดใหญ่',
    ug: 'تەڭشەيدىغاندا تاختىنىڭ يورۇق تەرىپى چوڭ تاختىنىڭ',
    vi: 'Trang trí tấm nhỏ có mặt cao ánh ở mặt trước của tấm lớn',
    zh_tc: '排版時小板高光面排在大板',
    ru: 'При наборе листы расположены на больших досках.',
    ko: '조판할 때 소판의 고광면이 큰 판에 배열되어 있다',
    bur: 'ပြင်ဆင်စာမျက်နှာတွင်ပေါ်ဒ်ငယ်အမြှီးမျက်နှာကြီးပြားပေါ်စီ',
    ben: 'লেআউটের সময় ছোট বোর্ডের হাই-গ্লস ফেস বড় বোর্ডে সাজানো হয়',
    tr: 'Yerleşimde küçük plakanın parlak yüzü büyük plakaya yerleştirilir',
    km: 'ពេលរៀបចំ ផ្ទៃរលកពន្លឺនៃផ្ទាំងតូចត្រូវដាក់នៅផ្ទាំងធំ',
    es: 'Al componer, el lado resaltado del tablero pequeño se organiza antes que el tablero grande',
    ar: 'عند التنضيد، يتم ترتيب الجانب المميز من اللوحة الصغيرة قبل اللوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.highGlossPlankNoRotate': {
    zh: '高光板不转板',
    en: 'High-Gloss Board No Rotate',
    id: 'Papan gloss tidak diputar',
    kz: 'Жарық панелі айналмайтын',
    th: 'บอร์ดมันวาวไม่หมุน',
    ug: 'يورۇق تاختى ئايلانمايدۇ',
    vi: 'Tấm bề mặt bóng cao không xoay',
    zh_tc: '高光板不轉板',
    ru: 'Панель с высоким блеском не вращается',
    ko: '고광면 패널 회전 안 함',
    bur: 'အမြှီးပြားဆက်တင်မှားနေသည်',
    ben: 'হাই-গ্লস বোর্ড না ঘুরা',
    tr: 'Parlak yüzlü pano dönmez',
    km: 'ផ្ទាំងរលកពន្លឺមិនដាក់ជាមួយ',
    es: 'La superficie de alto brillo no gira',
    ar: 'لوحة التمييز لا تدور',
  },
  'cuttingDock.cuttingParams.highGlossAutoRoll': {
    zh: '仅带有反面孔槽的大板自动翻面',
    en: 'Only large boards with back holes and slots automatically flip',
    id: 'Hanya papan besar dengan lubang dan slot belakang yang membalik otomatis',
    kz: 'Тек артқы тесіктері мен ойықтары бар ірі панельдер ғана автоматты түрде аударылады',
    th: 'เฉพาะบอร์ดขนาดใหญ่ที่มีรูและช่องด้านหลังพลิกอัตโนมัติ',
    ug: 'پەقەت ئارقا تەرىپىدىكى تۆشۈك ۋە ئارقىسى بار چوڭ تاختا ئۆزلۈكىدىن ئايلاندۇرۇلىدۇ',
    vi: 'Chỉ các tấm lớn có lỗ và rãnh mặt sau tự động lật',
    zh_tc: '僅帶有反面孔槽的大板自動翻面',
    ru: 'Автоматизированное опрокидывание больших пластин только с обратными отверстиями',
    ko: '후면 구멍 슬롯만 있는 대판 자동 뒤집기',
    bur: 'အနောက်မျက်နှာအပေါက်ချောင်းရှိကြီးပြားသာအလိုအလျောက်လှန်',
    ben: 'শুধুমাত্র পিছনের হোল ও স্লট আছে এমন বড় বোর্ড অটো ফ্লিপ',
    tr: 'Yalnızca arka yüzde delik/oluk olan büyük plakalar otomatik çevrilir',
    km: 'ផ្ទាំងធំដែលមានរណ្តៅ/រណ្តៅជង្ហុកនៅក្រោយប៉ុណ្ណោះបង្វិលស្វ័យប្រវត្តិ',
    es: 'Solo los tableros grandes con ranuras invertidas se voltean automáticamente',
    ar: 'يتم قلب اللوحات الكبيرة فقط ذات الفتحات العكسية تلقائيًا',
  },
  'cuttingDock.cuttingParams.highGlossAutoRollTip': {
    zh: "<span class='color-o-4'>（启用后仅反面孔槽的大板排版时将会自动翻面，变为单面板。配合自定义文件名“高光面翻面放板“数据使用）</span>",
    en: '<span class=\'color-o-4\'>(After enabling, only large boards with back holes and slots will automatically flip during layout, becoming single-sided boards. Use with the custom file name "Flip and place high-gloss surface board" data)</span>',
    id: '<span class=\'color-o-4\'>(Setelah diaktifkan, hanya papan besar dengan lubang dan slot belakang yang akan membalik otomatis saat mengatur, menjadi papan satu sisi. Gunakan bersama dengan data nama file kustom "Balik dan letakkan papan permukaan gloss tinggi")</span>',
    kz: '<span class=\'color-o-4\'>(Қосқаннан кейін тек артқы тесіктері мен ойықтары бар ірі панельдер орналастыру кезінде автоматты түрде аударылады, бір жақты панельге айналады. Теңшелетін файл атауындағы "Жарық бетін аударып, панельді орналастыру" деректерімен бірге қолданыңыз)</span>',
    th: '<span class=\'color-o-4\'>(หลังจากเปิดใช้งาน เฉพาะบอร์ดขนาดใหญ่ที่มีรูและช่องด้านหลังจะพลิกอัตโนมัติเมื่อจัดวาง กลายเป็นบอร์ดหน้าเดียว ใช้ร่วมกับข้อมูลชื่อไฟล์ที่กำหนดเอง "พลิกและวางบอร์ดพื้นผิวมันวาว")</span>',
    ug: '<span class=\'color-o-4\'>（ئىشلەتكەندىن كېيىن پەقەت ئارقا تەرىپىدىكى تۆشۈك ۋە ئارقىسى بار چوڭ تاختا رەتلەنگەندە ئۆزلۈكىدىن ئايلىنىدۇ، بىر تەرەپلىك تاختىغا ئۆزگىرىدۇ. ئىختىيارى ھۆججەت نامىدىكى "يورۇق تەرىپىنى ئايلاندۇرۇپ تاختا قويۇش" سانلىق مەلۇماتى بىلەن بىرگە ئىشلىتىڭ）</span>',
    vi: '<span class=\'color-o-4\'>(Sau khi bật, chỉ các tấm lớn có lỗ và rãnh mặt sau sẽ tự động lật khi sắp xếp, trở thành tấm một mặt. Sử dụng cùng với dữ liệu tên tệp tùy chỉnh "Lật và đặt tấm bề mặt bóng cao")</span>',
    zh_tc:
      '<span class=\'color-o-4\'>（啟用後僅反面孔槽的大板排版時將會自動翻面，變為單面板。配合自定義文件名"高光面翻面放板"數據使用）</span>',
    ru: '<span class=\'color-o-4\'>(После включения только большие доски с обратными отверстиями и отверстиями автоматически переворачиваются при размещении, становятся односторонними досками. Используйте вместе с данными имени файла "Высокоразрядный откидной лист")</span>',
    ko: '<span class=\'color-o-4\'>(활성화 후 반면 구멍 슬롯이 있는 대판 조판 시 자동으로 뒤집히며, 단면 보드로 변환됩니다. 사용자 정의 파일 이름 "고광면 뒤집기 널빤지" 데이터와 함께 사용하세요）</span>',
    bur: "<span class='color-o-4'>(ဖွင့်ပြီးနောက်အနောက်မျက်နှာအပေါက်ချောင်းရှိကြီးပြားသာပြင်ဆင်စာတွင်အလိုအလျောက်လှန်ပြီးတစ်မျက်နှာပြားဖြစ်မည်)</span>",
    ben: "<span class='color-o-4'>(সক্ষম করার পর শুধুমাত্র পিছনের হোল স্লটের বড় বোর্ড লেআউটে অটো ফ্লিপ হবে, সিঙ্গেল-সাইডেড বোর্ড। কাস্টম ফাইলের নাম ডেটার সাথে ব্যবহার করুন)</span>",
    tr: "<span class='color-o-4'>(Açıldığında yalnızca arka delik/oluklu büyük plakalar yerleşimde otomatik çevrilir ve tek yüzlü plaka olur. Özel dosya adı verisi «Parlak yüz çevirerek plaka yerleştirme» ile birlikte kullanın)</span>",
    km: "<span class='color-o-4'>(បើករួច ផ្ទាំងធំដែលមានរណ្តៅ/រណ្តៅជង្ហុកនៅក្រោយប៉ុណ្ណោះនឹងបង្វិលស្វ័យប្រវត្តិពេលរៀបចំ ក្លាយជាផ្ទាំងមួយមុខ។ ប្រើរួមជាមួយទិន្នន័យឈ្មោះឯកសារផ្ទាល់ខ្លួន «បង្វិលផ្ទៃរលកពន្លឺដាក់ផ្ទាំង»)</span>",
    es: '<span class=\'color-o-4\'> (Después de habilitar, solo el tablero grande con la ranura invertida se volteará automáticamente y se convertirá en un solo panel durante la composición tipográfica. Úselo con los datos del nombre de archivo personalizado "Alto brillo"). Tablero de giro lateral") </span>',
    ar: '<span class=\'color-o-4\'> (بعد التمكين، سيتم قلب اللوحة الكبيرة فقط ذات الأخدود العكسي تلقائيًا وتحويلها إلى لوحة واحدة أثناء التنضيد. استخدمها مع بيانات اسم الملف المخصص "عالي" لوح الوجه الجانبي اللامع") </span>',
  },
  'cuttingDock.cuttingParams.customHighGlossReverse': {
    zh: '高光面翻面放板',
    en: 'Flip and place high-gloss surface board',
    id: 'Balik dan letakkan papan permukaan gloss tinggi',
    kz: 'Жарық бетін аударып, панельді орналастыру',
    th: 'พลิกและวางบอร์ดพื้นผิวมันวาว',
    ug: 'يورۇق تەرىپىنى ئايلاندۇرۇپ تاختا قويۇش',
    vi: 'Lật và đặt tấm có bề mặt bóng cao',
    zh_tc: '高光面翻面放板',
    ru: 'Высокоразрядный откидной лист',
    ko: '고광면 뒤집기 널빤지',
    bur: 'အမြှီးမျက်နှာလှန်ပြားထား',
    ben: 'হাই-গ্লস সারফেস ফ্লিপ করে বোর্ড রাখুন',
    tr: 'Parlak yüz çevirerek plaka yerleştirme',
    km: 'បង្វិលផ្ទៃរលកពន្លឺដាក់ផ្ទាំង',
    es: 'Dé la vuelta a la superficie de alto brillo y coloque el tablero',
    ar: 'اقلب السطح شديد اللمعان وضع اللوحة',
  },
  'cuttingDock.cuttingParams.sideSlotPut': {
    zh: '靠边板槽放置',
    en: 'Place Slots Close to the Edge',
    id: 'Tempatkan alur pelat tepi',
    kz: 'Жақын панельге ойықтықтарды орналастыру',
    th: 'วางร่องจานขอบ',
    ug: 'چېگرا تاختا ئارقىسىنى قويۇش',
    vi: 'Đặt khe của tấm nằm gần cạnh',
    zh_tc: '靠邊板槽放置',
    ru: 'Размещение в боковой канавке',
    ko: '측면 슬롯 배치',
    bur: 'အစွန်းပြားချောင်းထား',
    ben: 'এজের কাছাকাছি স্লট প্লেস করুন',
    tr: 'Kenara yakın plaka oluk yerleşimi',
    km: 'ដាក់រណ្តៅជង្ហុកផ្ទាំងជិតគែម',
    es: 'Colóquelo junto a la ranura del tablero de borde',
    ar: 'ضعها بجوار فتحة لوحة الحافة',
  },
  'cuttingDock.cuttingParams.optimize': {
    zh: '功能优化中',
    en: 'Undergoing Functional Optimization',
    id: 'Optimasi fungsional',
    kz: 'Қызметтілік оптималдауды орындауда',
    th: 'การเพิ่มประสิทธิภาพการทำงาน',
    ug: 'فۇنكسىيە ئۈنۈملۈك تەڭشەشتە',
    vi: 'Đang tối ưu hóa chức năng',
    zh_tc: '功能優化中',
    ru: 'Функциональная оптимизация.',
    ko: '기능 최적화 중',
    bur: 'လုပ်ဆောင်ချက်အကောင်းဆုံးဖြစ်နေသည်',
    ben: 'ফাংশনাল অপ্টিমাইজেশন চলছে',
    tr: 'İşlev iyileştiriliyor',
    km: 'កំពុងបង្កើនប្រសិទ្ធភាពមុខងារ',
    es: 'La función se está optimizando',
    ar: 'يتم تحسين الوظيفة',
  },
  'cuttingDock.cuttingParams.sysDefault': {
    zh: '系统默认',
    en: 'System Default',
    id: 'Default Sistem',
    kz: 'Системаның әдетті параметрлері',
    th: 'ค่าเริ่มต้นของระบบ',
    ug: 'سىستېما سۈكۈتتىكى',
    vi: 'Mặc định của hệ thống',
    zh_tc: '系統默認',
    ru: 'Система по умолчанию',
    ko: '시스템 기본',
    bur: 'စနစ်မူရင်း',
    ben: 'সিস্টেম ডিফল্ট',
    tr: 'Sistem varsayılanı',
    km: 'លំនាំប្រព័ន្ធ',
    es: 'Predeterminado del sistema',
    ar: 'النظام الافتراضي',
  },
  'cuttingDock.cuttingParams.plankInSide': {
    zh: '大板内侧',
    en: 'Inner Side of Large Board',
    id: 'Di dalam piring besar',
    kz: 'Ірі панельдің ішкі жағы',
    th: 'ภายในจานขนาดใหญ่',
    ug: 'چوڭ تاختىنىڭ ئىچكى تەرىپى',
    vi: 'Bên trong của tấm lớn',
    zh_tc: '大板內側',
    ru: 'Внутренняя сторона большой доски',
    ko: '널빤지 안쪽',
    bur: 'ကြီးပြားအတွင်းဘက်',
    ben: 'বড় বোর্ডের ভিতরের দিক',
    tr: 'Büyük plaka iç taraf',
    km: 'ខាងក្នុងផ្ទាំងធំ',
    es: 'El interior del tablero grande',
    ar: 'الجزء الداخلي من اللوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.plankOutSide': {
    zh: '大板外侧',
    en: 'Outer Side of Large Board',
    id: 'Di luar piring besar',
    kz: 'Ірі панельдің сыртқы жағы',
    th: 'นอกจานขนาดใหญ่',
    ug: 'چوڭ تاختىنىڭ تاشقى تەرىپى',
    vi: 'Bên ngoài của tấm lớn',
    zh_tc: '大板外側',
    ru: 'Внешняя сторона большой доски',
    ko: '대판 바깥쪽',
    bur: 'ကြီးပြားအပြင်ဘက်',
    ben: 'বড় বোর্ডের বাইরের দিক',
    tr: 'Büyük plaka dış taraf',
    km: 'ខាងក្រៅផ្ទាំងធំ',
    es: 'El exterior del tablero grande',
    ar: 'الجزء الخارجي من اللوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.specialNotWork': {
    zh: '该功能不对异形板件生效',
    en: 'This feature does not apply to abnormally shaped board pieces',
    id: 'Fungsi ini tidak berlaku pada piring berbentuk khusus',
    kz: 'Бұл функсиял ерекше пішімді планшеттерге қолданылмайды',
    th: 'ฟังก์ชั่นนี้ไม่มีผลกับแผ่นรูปทรงพิเศษ',
    ug: 'بۇ فۇنكسىيە ئالاھىدە شەكىللىك تاختىلارغا ئىشلەتمەيدۇ',
    vi: 'Chức năng này không có hiệu lực đối với các tấm hình dị hình',
    zh_tc: '該功能不對異形板件生效',
    ru: 'Эта функция не работает на фасонных панелях.',
    ko: '이 기능은 이형 플레이트에 적용되지 않습니다.',
    bur: 'ဤလုပ်ဆောင်ချက်အသွင်းပြားတွင်မသက်ရောက်',
    ben: 'এই ফিচার অ্যাবনরমাল শেপড বোর্ড পিসে প্রযোজ্য নয়',
    tr: 'Bu işlev anormal şekilli plakalara uygulanmaz',
    km: 'មុខងារនេះមិនអនុវត្តលើផ្ទាំងរូបរាងមិនធម្មតា',
    es: 'Esta función no tiene efecto en paneles con formas especiales',
    ar: 'لا تسري هذه الوظيفة على اللوحات ذات الشكل الخاص',
  },
  'cuttingDock.cuttingParams.commonSide': {
    zh: '共边切割',
    en: 'Common Edge Cutting',
    id: 'Pemotongan tepi umum',
    kz: 'Ортақ кесу',
    th: 'การตัดขอบทั่วไป',
    ug: 'ئورتاق چېگرا قېپىش',
    vi: 'Cắt theo cạnh chung',
    zh_tc: '共邊切割',
    ru: 'Совместная резка',
    ko: '공통 모서리 컷',
    bur: 'အပြိုင်အစွန်းဖြတ်',
    ben: 'কমন এজ কাটিং',
    tr: 'Ortak kenar kesim',
    km: 'កាត់គែមរួម',
    es: 'Corte de borde común',
    ar: 'قطع الحواف الشائعة',
  },
  'cuttingDock.cuttingParams.commonSetting': {
    zh: '共边设置',
    en: 'Common edge setting',
    id: 'Pengaturan tepi umum',
    kz: 'Бірдей бұрышты орнату',
    th: 'การตั้งค่าขอบร่วม',
    ug: 'ئورتاق تەڭشەش',
    vi: 'Thiết lập chung',
    zh_tc: '共邊設置',
    ru: 'Общие настройки',
    ko: '공통 모서리 설정',
    bur: 'အပြိုင်အစွန်းဆက်တင်',
    ben: 'কমন এজ সেটিং',
    tr: 'Ortak kenar ayarları',
    km: 'ការកំណត់គែមរួម',
    es: 'Configuración de borde común',
    ar: 'إعداد الحواف الشائعة',
  },
  'cuttingDock.cuttingParams.plankThickRange': {
    zh: '板件厚度小于等于',
    en: 'The Thickness of the Board Piece is Less than or Equal to',
    id: 'Ketebalan pelat kurang dari atau sama',
    kz: 'Панельдің қалыңдығы аз болса да',
    th: 'ความหนาของจานน้อยกว่าหรือเท่ากับ',
    ug: 'تاختا قېلىنلىقى كىچىك ياكى تەڭ',
    vi: 'Độ dày của tấm nhỏ không quá',
    zh_tc: '板件厚度小於等於',
    ru: 'Толщина листов меньше равной',
    ko: '판재 두께가 같음 이하',
    bur: 'ပြားအထူသည်ထို့ထက်ငယ်သို့မဟုတ်ညီမျှ',
    ben: 'বোর্ড পিসের বেধ এর চেয়ে কম বা সমান',
    tr: 'Plaka kalınlığı şundan küçük veya eşit',
    km: 'កម្រាស់ផ្ទាំងតូចជាងឬស្មើ',
    es: 'Utilice corte de borde común cuando el espesor de la placa sea menor o igual a',
    ar: 'استخدم قطع الحواف الشائعة عندما يكون سمك اللوحة أقل من أو يساوي',
  },
  'cuttingDock.cuttingParams.useCommonSide': {
    zh: '时采用共边切割',
    en: 'Use Common Edge Cutting When',
    id: 'Gunakan pemotongan tepi yang umum',
    kz: 'ортақ кесуді қолдану',
    th: 'ใช้การตัดขอบทั่วไป',
    ug: 'بولغاندا ئورتاق چېگرا قېپىش ئىشلىتىلىدۇ',
    vi: 'Sử dụng cắt theo cạnh chung khi',
    zh_tc: '時採用共邊切割',
    ru: 'При совместном обрезании',
    ko: '공통 모서리 컷 사용',
    bur: 'သည့်အခါအပြိုင်အစွန်းဖြတ်သုံး',
    ben: 'কখন কমন এজ কাটিং ব্যবহার করবেন',
    tr: 'Ortak kenar kesimi uygulanır',
    km: 'ប្រើកាត់គែមរួម',
    es: 'Use Common Edge Cutting When',
    ar: 'Use Common Edge Cutting When',
  },
  'cuttingDock.cuttingParams.zeroTip': {
    zh: '排版间隙需手动改为0，加工至已切割边时抬刀跳过该边，此功能开启后，将不支持斜下刀加工，请注意！',
    en: 'The layout gap needs to be manually changed to 0, and the tool will lift when processing to the already cut edge to skip it, after enabling this feature, oblique down-cutting processing will not be supported.',
    id: '(Kesenjangan tata letak perlu diubah secara manual menjadi 0. Saat memproses sampai tepi telah dipotong, angkat pisau untuk melewatkan tepi)',
    kz: 'Орналасу арақашықтығы 0 болуына қолдану керек, кесу бұрынғы кесу қабылдаған жағадан ауысуға болады, бұл функсияны қосқаннан кейін, бұрынғы кесудің бұрылышпен кесуді қолдануға болмайды.',
    th: '(ช่องว่างเค้าโครงจะต้องเปลี่ยนด้วยตนเองเป็น 0 เมื่อประมวลผลจนกว่าขอบจะถูกตัดให้ยกมีดเพื่อข้ามขอบ)',
    ug: 'تەڭشەش بوشلۇقىنى قولدا 0 گە ئۆزگەرتەڭ، قېپىلغان چېگرىغا يەتكەندە پىچاقنى كۆتۈرۈپ ئۇ چېگرىدىن ئۆتۈڭ، بۇ فۇنكسىيە قوزغىتىلغاندىن كېيىن، ئېگىل پىچاق بىلەن ئىشلەش قوللىنىلمايدۇ، دىققەت قىلىڭ!',
    vi: 'Khoảng cách giữa các tấm cần được thay đổi thủ công thành 0, khi gia công đến cạnh đã cắt thì máy sẽ ngang dao để bỏ qua cạnh đó, khi chức năng này được bật, sẽ không hỗ trợ gia công nghiêng dao.',
    zh_tc:
      '排版間隙需手動改為0，加工至已切割邊時抬刀跳過該邊，此功能開啟後，將不支持斜下刀加工，請注意！',
    ru: 'Разрыв между наборами должен быть изменен вручную на 0, обработан до разрезанной стороны, когда поднять нож через эту сторону, эта функция включена, не будет поддерживать обработку наклонного ножа, обратите внимание!',
    ko: '조판 간격은 수동으로 0으로 변경해야 합니다. 절단된 모서리로 가공할 때 바이트가 모서리를 건너뜁니다. 이 기능이 켜지면 사선 가공이 지원되지 않습니다. 주의하세요!',
    bur: 'ပြင်ဆင်ခြားနားချက်ကိုလက်ဖြင့်၀သို့ပြောင်းပါ၊ ဖြတ်ပြီးအစွန်းသို့ပြုသည့်အခါဓားမြှောက်ကျော်ပါ၊ ဤလုပ်ဆောင်ချက်ဖွင့်ပြီးနောက်ဓားစောင်းမပြုပါနှင့်၊ သတိပြုပါ!',
    ben: 'লেআউট গ্যাপ হাতে ০ করতে হবে, ইতিমধ্যে কাটা এজ পর্যন্ত প্রসেস করলে টুল লিফট করে এজ স্কিপ করুন, এই ফিচার চালু হলে অবলিক ডাউন-কাটিং সাপোর্ট করা হবে না।',
    tr: 'Yerleşim aralığını elle 0 yapın; zaten kesilmiş kenara gelindiğinde bıçak kaldırılıp o kenar atlanır. Bu işlev açıkken eğik aşağı inme kesimi desteklenmez!',
    km: 'ចន្លោះរៀបចំត្រូវប្តូរដោយដៃទៅ ០ ពេលដំណើរការដល់គែមដែលបានកាត់រួច លើកឧបករណ៍កាត់រំលងគែមនោះ។ បើកមុខងារនេះហើយ មិនគាំទ្រការកាត់ចុះអាក្សត់!',
    es: 'El espacio de composición tipográfica debe cambiarse manualmente a 0. Al procesar hasta el borde cortado, levante la cuchilla para saltar el borde. Una vez activada esta función, no se admitirá el procesamiento con cuchilla oblicua. ¡Tenga en cuenta!',
    ar: 'يجب تغيير فجوة التنضيد يدويًا إلى 0. عند المعالجة إلى حافة القطع، ارفع السكين لتخطي الحافة. بعد تشغيل هذه الوظيفة، لن يتم دعم معالجة السكين المائل. يرجى الملاحظة!',
  },
  'cuttingDock.cuttingParams.useTip': {
    zh: '此功能开启后，将不支持斜下刀加工，请注意！',
    en: 'After enabling this feature, oblique down-cutting processing will not be supported. Please note!',
    id: 'Setelah fungsi ini dihidupkan, pemotongan ke bawah tidak akan didukung, harap perhatikan!',
    kz: 'Бұл функсияны қосқаннан кейін, бұрынғы кесудің бұрылышпен кесуді қолдануға болмайды, ескеріңіз!',
    th: 'หลังจากเปิดใช้งานฟังก์ชั่นนี้การตัดลงจะไม่ได้รับการสนับสนุนโปรดให้ความสนใจ!',
    ug: 'بۇ فۇنكسىيە قوزغىتىلغاندىن كېيىن، ئېگىل پىچاق بىلەن ئىشلەش قوللىنىلمايدۇ، دىققەت قىلىڭ!',
    vi: 'Khi chức năng này được bật, sẽ không hỗ trợ gia công nghiêng dao, vui lòng lưu ý!',
    zh_tc: '此功能開啟後，將不支持斜下刀加工，請注意！',
    ru: 'После включения этой функции обработка наклонного ножа не будет поддерживаться, обратите внимание!',
    ko: '이 기능을 켜면 사선 가공이 지원되지 않습니다. 주의하세요!',
    bur: 'ဤလုပ်ဆောင်ချက်ဖွင့်ပြီးနောက်ဓားစောင်းမပြုပါနှင့်၊ သတိပြုပါ!',
    ben: 'এই ফিচার চালু করার পর অবলিক ডাউন-কাটিং সাপোর্ট করা হবে না। নোট করুন!',
    tr: 'Bu işlev açıldıktan sonra eğik aşağı inme kesimi desteklenmez; dikkat!',
    km: 'បើកមុខងារនេះរួច មិនគាំទ្រការកាត់ចុះអាក្សត់ សូមចំណាំ!',
    es: 'Después de activar esta función, no se admitirá el procesamiento de herramientas de corte oblicuo, ¡tenga en cuenta!',
    ar: 'بعد تشغيل هذه الوظيفة، لن يتم دعم معالجة أداة القطع المائل، يرجى ملاحظة ذلك!',
  },
  'cuttingDock.cuttingParams.commonSpeed': {
    zh: '共边加速',
    en: 'Common Edge Acceleration',
    id: 'Percepatan tepi umum',
    kz: 'Ортақ кесу жылдамдығы',
    th: 'การเร่งความเร็วของขอบทั่วไป',
    ug: 'ئورتاق تېزلىتىش',
    vi: 'Tốc độ tăng chung',
    zh_tc: '共邊加速',
    ru: 'Комбинированное ускорение',
    ko: '공통 모서리 가속',
    bur: 'အပြိုင်အစွန်းအရှိန်မြန်',
    ben: 'কমন এজ অ্যাকসেলারেশন',
    tr: 'Ortak kenar hızlandırma',
    km: 'បង្កើនល្បឿនគែមរួម',
    es: 'Aceleración de borde común',
    ar: 'تسريع الحافة المشتركة',
  },
  'cuttingDock.cuttingParams.highSpeed': {
    zh: '高速擦铣速度',
    en: 'High-Speed Milling Speed',
    id: 'Kecepatan penggilingan berkecepatan tinggi',
    kz: 'Жоғары жылдамдықпен кесу жылдамдығы',
    th: 'ความเร็วการโม่ความเร็วสูง',
    ug: 'يۇقىرى سۈرئەتلىك سىلىشتۇرۇش سۈرئىتى',
    vi: 'Tốc độ cát cao',
    zh_tc: '高速擦銑速度',
    ru: 'Скорость фрезерования',
    ko: '고속 밀링 속도',
    bur: 'အမြန်ပွတ်မီးဖြတ်အမြန်နှုန်း',
    ben: 'হাই-স্পিড মিলিং স্পিড',
    tr: 'Yüksek hız süpürme freze hızı',
    km: 'ល្បឿនម៉ាស៊ីនកិនលឿនខ្ពស់',
    es: 'Velocidad de rectificado y fresado de alta velocidad',
    ar: 'سرعة طحن وطحن عالية السرعة',
  },
  'cuttingDock.cuttingParams.min': {
    zh: '分钟',
    en: 'Minute',
    id: 'menit',
    kz: 'минут',
    th: 'นาที',
    ug: 'مىنۇت',
    vi: 'phút',
    zh_tc: '分鐘',
    ru: 'минута',
    ko: '분',
    bur: 'မိနစ်',
    ben: 'মিনিট',
    tr: 'Dakika',
    km: 'នាទី',
    es: 'Minutos',
    ar: 'الدقائق',
  },
  'cuttingDock.cuttingParams.notWorkTip': {
    zh: '当板材加工满足共边切割时，共边加速则不生效',
    en: 'Common edge acceleration will not be effective when the board processing meets the conditions for common edge cutting',
    id: '(Ketika pemrosesan pelat memenuhi pemotongan tepi yang umum, akselerasi tepi umum tidak akan berlaku)',
    kz: 'Панельдің кесуі ортақ кесуге сәйкес болса, ортақ кесудің жылдамдығы қолданылмайды',
    th: '(เมื่อการประมวลผลแผ่นตรงกับการตัดขอบทั่วไปการเร่งความเร็วขอบทั่วไปจะไม่เกิดขึ้น)',
    ug: 'تاختا ماتېرىيالى ئورتاق چېگرا قېپىش شەرتلىرىگە توغرا كەلگەندە، ئورتاق تېزلىتىش ئىشلەتمەيدۇ',
    vi: 'Khi gia công tấm đáp ứng cắt theo cạnh chung, tốc độ tăng chung sẽ không có hiệu lực',
    zh_tc: '當板材加工滿足共邊切割時，共邊加速則不生效',
    ru: 'Когда обработка листов соответствует общей обрезке, общее ускорение не вступает в силу',
    ko: '판재 가공이 공변 절단을 만족시킬 때, 공변 가속은 효력이 발생하지 않는다',
    bur: 'ပြားပြုသည့်အခါအပြိုင်အစွန်းဖြတ်ပြည့်မီသည့်အခါအပြိုင်အစွန်းအရှိန်မသက်ရောက်',
    ben: 'বোর্ড প্রসেসিং কমন এজ কাটিং শর্ত পূরণ করলে কমন এজ অ্যাকসেলারেশন কার্যকর হবে না',
    tr: 'Plaka işleme ortak kenar kesim koşullarını sağladığında ortak kenar hızlandırma etkisiz olur',
    km: 'ពេលដំណើរការផ្ទាំងត្រូវនឹងការកាត់គែមរួម ការបង្កើនល្បឿនគែមរួមមិនមានប្រសិទ្ធភាព',
    es: 'Cuando el procesamiento de la placa coincide con el corte de borde común, la aceleración de borde común no tendrá efecto',
    ar: 'عندما تتوافق معالجة اللوحة مع قطع الحافة المشتركة، لن يسري مفعول تسريع الحافة المشتركة',
  },
  'cuttingDock.cuttingParams.changeStartPoint': {
    zh: '双工位起始点切换',
    en: 'Double-Station Starting Point Switching',
    id: 'Beralih dari titik awal stasiun ganda',
    kz: 'Екі жұмыс орның бастамашы нүктелерін ауыстыру',
    th: 'การสลับจุดเริ่มต้นของสถานีคู่',
    ug: 'ئىككى پوچتا باشلانغۇچ نۇقتا ئالماشتۇرۇش',
    vi: 'Chuyển điểm bắt đầu hai vị trí',
    zh_tc: '雙工位起始點切換',
    ru: 'Двойное переключение начальной точки',
    ko: '이중 작업 시작점 전환',
    bur: 'နှစ်ဌာနအစပြုအမှတ်ပြောင်း',
    ben: 'ডাবল-স্টেশন স্টার্টিং পয়েন্ট সুইচিং',
    tr: 'Çift istasyon başlangıç noktası değiştirme',
    km: 'ប្តូរចំណុចចាប់ផ្តើមពីរកន្លែង',
    es: 'Cambio del punto de inicio de estación dual',
    ar: 'تبديل نقطة البداية للمحطة المزدوجة',
  },
  'cuttingDock.cuttingParams.changeStartPointTip': {
    zh: '启用双工位起始点切换后，与XY轴互换功能不兼容，请谨慎使用',
    en: 'After enabling double-station starting point switching, it is not compatible with the XY axis swap function. Please use cautiously.',
    id: 'Setelah mengaktifkan sakelar titik awal stasiun ganda, tidak sesuai dengan fungsi pertukaran sumbu XY. Harap gunakan dengan hati -hati',
    kz: 'Екі жұмыс орның бастамашы нүктелерін ауыстыруды қосқаннан кейін XY осьсімен ауысу функциясымен үйлесімсіз болады, мұны мұқият қолдану',
    th: 'หลังจากเปิดใช้งานสวิตช์ของจุดเริ่มต้นสองสถานีแล้วมันก็เข้ากันไม่ได้กับฟังก์ชั่นการแลกเปลี่ยนแกน XY โปรดใช้ด้วยความระมัดระวัง',
    ug: 'ئىككى پوچتا باشلانغۇچ نۇقتا ئالماشتۇرۇشنى قوزغىتىش بىلەن، XY ئوكۇل ئالماشتۇرۇش فۇنكسىيىسى بىلەن ماسلاشمايدۇ، دىققەت قىلىڭ',
    vi: 'Sau khi kích hoạt chuyển điểm bắt đầu hai vị trí, chức năng này sẽ không tương thích với chức năng hoán đổi trục XY, hãy sử dụng cẩn thận',
    zh_tc: '啟用雙工位起始點切換後，與XY軸互換功能不兼容，請謹慎使用',
    ru: 'При включении двумерного переключения начальной точки, несовместимого с функцией обмена осями XY, используйте осторожно',
    ko: '듀얼 비트 시작점 전환이 활성화되면 XY 축 교환 기능과 호환되지 않으므로 주의해서 사용하십시오.',
    bur: 'နှစ်ဌာနအစပြုအမှတ်ပြောင်းဖွင့်ပြီးနောက် XY ဝင်ရိုးပြောင်းလုပ်ဆောင်ချက်နှင့်မကိုက်ညီ၊ သတိထားသုံးပါ',
    ben: 'ডাবল-স্টেশন স্টার্ট পয়েন্ট সুইচ চালু করার পর XY অক্ষ সোয়াপ ফাংশনের সাথে সামঞ্জস্যপূর্ণ নয়। সাবধানে ব্যবহার করুন।',
    tr: 'Çift istasyon başlangıç değiştirme açıldığında XY eksen değişimi ile uyumlu değildir; dikkatli kullanın',
    km: 'បើកការប្តូរចំណុចចាប់ផ្តើមពីរកន្លែងរួច មិនសមស្របនឹងការប្តូរ XY សូមប្រើប្រយ័ត្ន',
    es: 'Después de habilitar el cambio del punto de inicio de la estación dual, es incompatible con la función de intercambio de ejes XY, utilícela con precaución',
    ar: 'بعد تمكين تبديل نقطة بداية المحطة المزدوجة، فهو غير متوافق مع وظيفة تبادل المحور XY، يرجى استخدامه بحذر',
  },
  'cuttingDock.cuttingParams.flatOffset': {
    zh: '机台平面偏移',
    en: 'Machine Plane Offset',
    id: 'Offset Pesawat Mesin',
    kz: 'Машина плосколығының ауысу',
    th: 'เครื่องชดเชยระนาบเครื่องจักร',
    ug: 'ماشىنا يۈزى ئۆزگەرتىش',
    vi: 'Biến mất mặt phẳng của máy',
    zh_tc: '機台平面偏移',
    ru: 'смещение в плоскости станка',
    ko: '테이블 평면 오프셋',
    bur: 'စက်ပြင်ညီရွေ့',
    ben: 'মেশিন প্লেন অফসেট',
    tr: 'Tezgâh düzlemi ofseti',
    km: 'ការរអិលផ្ទៃប៉ាន់ដីម៉ាស៊ីន',
    es: 'Desplazamiento del plano de la máquina',
    ar: 'إزاحة مستوى الآلة',
  },
  'cuttingDock.cuttingParams.xRowChange': {
    zh: 'X轴坐标基准对调',
    en: 'X-Axis Coordinate Reference Swap',
    id: 'Penyelarasan referensi koordinat sumbu x',
    kz: 'X осьінің координат бастық нүктелерін ауыстыру',
    th: 'การจัดตำแหน่งอ้างอิงพิกัดแกน x',
    ug: 'X ئوكۇل كوئوردىنات ئاساسىنى ئالماشتۇرۇش',
    vi: 'Hoán đổi cơ sở tọa độ trục X',
    zh_tc: 'X軸坐標基準對調',
    ru: 'Коррекция координат по оси X',
    ko: 'X축 좌표 데이텀 쌍',
    bur: 'X ဝင်ရိုးကိုဩဒီနိတ်အခြေပြောင်း',
    ben: 'X-অক্ষ কোঅর্ডিনেট রেফারেন্স সোয়াপ',
    tr: 'X ekseni koordinat referansını değiştir',
    km: 'ប្តូរមូលដ្ឋានកូអរដោនេ X',
    es: 'X Intercambio de datos de coordenadas del eje',
    ar: 'X مبادلة إسناد إحداثيات المحور',
  },
  'cuttingDock.cuttingParams.bigplankPointChange': {
    zh: '大板反面坐标基准对调',
    en: 'Swap the reference coordinates on the back of the large board',
    id: 'Penyesuaian referensi koordinat terbalik dari pelat besar',
    kz: 'Үлкен тақтаның артқы жағының координаталық негіздерін ауыстыру',
    th: 'การปรับการอ้างอิงพิกัดแบบย้อนกลับของแผ่นขนาดใหญ่',
    ug: 'چوڭ تاختىنىڭ ئارقا تەرىپى كوئوردىنات ئاساسىنى ئالماشتۇرۇش',
    vi: 'Hoán đổi tọa độ gốc ở mặt sau của bảng lớn',
    zh_tc: '大板反面坐標基準對調',
    ru: 'Точка отсчета координат',
    ko: '대시보드 후면 좌표 데이텀 쌍',
    bur: 'ကြီးပြားအနောက်မျက်နှာကိုဩဒီနိတ်အခြေပြောင်း',
    ben: 'বড় বোর্ডের পিছনের রেফারেন্স কোঅর্ডিনেট সোয়াপ করুন',
    tr: 'Büyük plaka arka yüz koordinat referansını değiştir',
    km: 'ប្តូរមូលដ្ឋានកូអរដោនេផ្ទៃក្រោយផ្ទាំងធំ',
    es: 'Intercambio de datos de coordenadas de la parte posterior de la placa grande',
    ar: 'مبادلة إسناد الإحداثيات الخلفية للوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.reverseXRowChange': {
    zh: 'X坐标对调',
    en: 'Swap X-Axis coordinates',
    id: 'X Kontras koordinat',
    kz: 'X координаттарын ауыстыру',
    th: 'x ประสานความคมชัด',
    ug: 'X كوئوردىنات ئالماشتۇرۇش',
    vi: 'Hoán đổi tọa độ X',
    zh_tc: 'X坐標對調',
    ru: 'Координаты X',
    ko: 'X 좌표 조정',
    bur: 'X ကိုဩဒီနိတ်ပြောင်း',
    ben: 'X-অক্ষ কোঅর্ডিনেট সোয়াপ করুন',
    tr: 'X koordinatlarını değiştir',
    km: 'ប្តូរកូអរដោនេ X',
    es: 'X Intercambio de coordenadas',
    ar: 'X مبادلة الإحداثيات',
  },
  'cuttingDock.cuttingParams.changebigplankPointTips': {
    zh: '启用该功能后与"XY轴互换、双工位起始点切换"功能不兼容，请谨慎使用',
    en: 'After enabling this feature, it is not compatible with the "XY axis swap" and "dual station start point switch" functions. Please use cautiously.',
    id: 'Setelah mengaktifkan fungsi ini, tidak kompatibel dengan fungsi "XY Axis Interchange, Dual-Station Start Start Switching". Harap gunakan dengan hati -hati',
    kz: 'Бұл функцияны іске қосқаннан кейін "XY осін алмастыру" және "екі жұмыс орнының бастапқы нүктесін ауыстыру" функцияларымен үйлесімді емес. Оны абайлап қолданыңыз.',
    th: 'หลังจากเปิดใช้งานฟังก์ชั่นนี้มันจะเข้ากันไม่ได้กับฟังก์ชั่นการสลับจุดเริ่มต้นของจุดเริ่มต้น "XY โปรดใช้ด้วยความระมัดระวัง',
    ug: 'بۇ فۇنكسىيەنى قوزغىتىش بىلەن "XY ئوكۇل ئالماشتۇرۇش، ئىككى پوچتا باشلانغۇچ نۇقتا ئالماشتۇرۇش" فۇنكسىيىسى بىلەن ماسلاشمايدۇ، دىققەت قىلىڭ',
    vi: 'Sau khi kích hoạt tính năng này, nó không tương thích với các chức năng "hoán đổi trục XY" và "chuyển đổi điểm bắt đầu hai vị trí". Hãy sử dụng cẩn thận.',
    zh_tc: '啟用該功能後與"XY軸互換、雙工位起始點切換"功能不兼容，請謹慎使用',
    ru: 'Включение этой функции несовместимо с функцией « Обмен осями XY, переключение точек начала с двумя станциями», используйте ее с осторожностью',
    ko: '이 기능이 활성화되면 XY 축 교환, 이중 작업 시작점 전환 기능과 호환되지 않으므로 주의해서 사용하십시오.',
    bur: 'ဤလုပ်ဆောင်ချက်ဖွင့်ပြီးနောက် XY ဝင်ရိုးပြောင်းနှင့်နှစ်ဌာနအစပြုအမှတ်ပြောင်းနှင့်မကိုက်ညီ၊ သတိထားသုံးပါ',
    ben: 'এই ফিচার চালু করার পর এটি XY অক্ষ সোয়াপ ও ডুয়াল স্টেশন স্টার্ট পয়েন্ট সুইচ ফাংশনের সাথে সামঞ্জস্যপূর্ণ নয়। সাবধানে ব্যবহার করুন।',
    tr: 'Bu işlev açıldığında «XY eksen değişimi» ve «çift istasyon başlangıç değiştirme» ile uyumlu değildir; dikkatli kullanın',
    km: 'បើកមុខងារនេះរួច មិនសមស្របនឹង«ប្តូរ XY» និង«ប្តូរចំណុចចាប់ផ្តើមពីរកន្លែង» សូមប្រើប្រយ័ត្ន',
    es: 'Después de habilitar esta función, es incompatible con el "XY intercambio de ejes, cambio de punto de inicio dúplex" función, úsela con precaución',
    ar: 'بعد تمكين هذه الوظيفة، فهي غير متوافقة مع تبادل المحور "XY، وظيفة تبديل نقطة البداية المزدوجة، يرجى استخدامها بحذر',
  },
  'cuttingDock.cuttingParams.reverseYRowChange': {
    zh: 'Y坐标对调',
    en: 'Swap Y-Axis coordinates',
    id: 'Koordinat y',
    kz: 'Y координаттарын ауыстыру',
    th: 'Y Coordinates',
    ug: 'Y كوئوردىنات ئالماشتۇرۇش',
    vi: 'Hoán đổi tọa độ Y',
    zh_tc: 'Y坐標對調',
    ru: 'Коррекция Y - координат',
    ko: 'Y 좌표 대조',
    bur: 'Y ကိုဩဒီနိတ်ပြောင်း',
    ben: 'Y-অক্ষ কোঅর্ডিনেট সোয়াপ করুন',
    tr: 'Y koordinatlarını değiştir',
    km: 'ប្តូរកូអរដោនេ Y',
    es: 'Y Intercambio de coordenadas',
    ar: 'Y تبديل الإحداثيات',
  },
  'cuttingDock.cuttingParams.plankMirrorTip': {
    zh: '在开料机上加工的板件镜像时使用此功能',
    en: 'Use this feature when mirroring board pieces processed on the cutting machine',
    id: 'Gunakan fungsi ini saat mirroring plate yang diproses pada pengumpan',
    kz: 'Панельді кесу машинасында镜像 кесу кезінде осы функцияны қолдану',
    th: 'ใช้ฟังก์ชั่นนี้เมื่อทำมิเรอร์เพลตที่ประมวลผลบนตัวป้อน',
    ug: 'ئۆيۈچۈدە ئىشلەنگەن تاختىلار ئەكس ئەتەۋاتقاندا بۇ فۇنكسىيەنى ئىشلىتىڭ',
    vi: 'Sử dụng chức năng này khi hình ảnh của tấm được gia công trên máy cắt phải được phản hành',
    zh_tc: '在開料機上加工的板件鏡像時使用此功能',
    ru: 'Используйте эту функцию при зеркальном отображении листов, обработанных на открывающей машине',
    ko: '이 기능은 원료 공급기에서 가공된 판재 대칭복사에 사용됩니다.',
    bur: 'ဖြတ်စက်ပေါ်ပြုထားသောပြားများမှန်တွင်းပြုသည့်အခါဤလုပ်ဆောင်ချက်သုံးပါ',
    ben: 'কাটিং মেশিনে প্রসেস করা বোর্ড পিস মিরর করার সময় এই ফিচার ব্যবহার করুন',
    tr: 'Kesim makinesinde işlenen plakaları aynalarken bu işlevi kullanın',
    km: 'ប្រើមុខងារនេះពេលច្រឹបផ្ទាំងដែលដំណើរការនៅម៉ាស៊ីនកាត់',
    es: 'Utilice esta función cuando refleje la placa procesada en la máquina de corte',
    ar: 'استخدم هذه الوظيفة عند عكس اللوحة المعالجة على آلة القطع',
  },
  'cuttingDock.cuttingParams.notSameSize': {
    zh: '双工位台面不同尺寸',
    en: 'Different Sizes for Double-Station Tables',
    id: 'Countertops stasiun ganda ukuran berbeda',
    kz: 'Екі жұмыс орның үстелдің өлшемдері бір-бірінен әртүрлі',
    th: 'เคาน์เตอร์สองสถานีขนาดต่างกัน',
    ug: 'ئىككى پوچتا يۈزى ئوخشاش بولمىغان چوڭلۇقتا',
    vi: 'Hai vị trí có kích thước khác nhau',
    zh_tc: '雙工位台面不同尺寸',
    ru: 'Двухместный стол разных размеров',
    ko: '더블 비트 테이블 다른 크기',
    bur: 'နှစ်ဌာနစားပွဲမျက်နှာအရွယ်မတူ',
    ben: 'ডাবল-স্টেশন টেবিল ভিন্ন সাইজ',
    tr: 'Çift istasyon tezgâhı farklı boyutlar',
    km: 'តុពីរកន្លែងមានទំហំខុសគ្នា',
    es: 'Diferentes tamaños de la mesa de estación doble',
    ar: 'أحجام مختلفة لطاولة المحطة المزدوجة',
  },
  'cuttingDock.cuttingParams.maxSize1': {
    zh: '工位一最大尺寸',
    en: 'Maximum Size for Station 1',
    id: 'Workstation satu ukuran maksimal',
    kz: 'Бірінші жұмыс орның ең үлкен өлшемі',
    th: 'เวิร์กสเตชันขนาดสูงสุดหนึ่งขนาด',
    ug: 'پوچتا 1 ئەڭ چوڭ چوڭلۇقى',
    vi: 'Kích thước tối đa của vị trí 1',
    zh_tc: '工位一最大尺寸',
    ru: 'Максимальный размер.',
    ko: '작업 공간 1 최대 크기',
    bur: 'အလုပ်ဌာန၁အများဆုံးအရွယ်',
    ben: 'স্টেশন ১ সর্বোচ্চ সাইজ',
    tr: 'İstasyon 1 maksimum boyutu',
    km: 'ទំហំអតិបរមាកន្លែង ១',
    es: 'Tamaño máximo de la estación uno',
    ar: 'الحد الأقصى لحجم المحطة الأولى',
  },
  'cuttingDock.cuttingParams.notSameSizeTip': {
    zh: '启用双工位台面不同尺寸后，与双工位文件合并功能不兼容，请谨慎使用',
    en: 'After enabling different sizes for double-station tables, it is not compatible with the double-station file merging function. Please use cautiously.',
    id: '(Setelah mengaktifkan berbagai ukuran meja stasiun ganda, tidak sesuai dengan fungsi penggabungan file stasiun ganda, silakan gunakan dengan hati-hati)',
    kz: 'Екі жұмыс орның үстелдің өлшемдері бір-бірінен әртүрлі болса, екі жұмыс орның файлдарын біріктіру функциясымен үйлесімсіз болады, мұны мұқият қолдану',
    th: '(หลังจากเปิดใช้งานเคาน์เตอร์คู่ที่แตกต่างกันแล้วมันไม่เข้ากันกับฟังก์ชั่นการรวมไฟล์ Dual-Station โปรดใช้ด้วยความระมัดระวัง)',
    ug: 'ئىككى پوچتا يۈزى ئوخشاش بولمىغان چوڭلۇقنى قوزغىتىش بىلەن، ئىككى پوچتا ھۆججەت بىرلەشتۈرۈش فۇنكسىيىسى بىلەن ماسلاشمايدۇ، دىققەت قىلىڭ',
    vi: 'Sau khi kích hoạt hai vị trí có kích thước khác nhau, chức năng này sẽ không tương thích với chức năng hợp nhất hai vị trí, hãy sử dụng cẩn thận',
    zh_tc: '啟用雙工位台面不同尺寸後，與雙工位文件合併功能不兼容，請謹慎使用',
    ru: 'После включения двух рабочих столов разных размеров, функция объединения с двумя рабочими документами несовместима, используйте осторожно',
    ko: '듀얼 비트 테이블의 다른 크기가 활성화되면 듀얼 비트 파일 병합 기능과 호환되지 않으므로 주의해서 사용하십시오.',
    bur: 'နှစ်ဌာနစားပွဲအရွယ်မတူဖွင့်ပြီးနောက်နှစ်ဌာနဖိုင်ပေါင်းခြင်းနှင့်မကိုက်ညီ၊ သတိထားသုံးပါ',
    ben: 'ডাবল-স্টেশন টেবিল ভিন্ন সাইজ চালু করার পর ডাবল-স্টেশন ফাইল মার্জ ফাংশনের সাথে সামঞ্জস্যপূর্ণ নয়। সাবধানে ব্যবহার করুন।',
    tr: 'Farklı boyutlu çift istasyon tezgâhı açıldığında çift istasyon dosya birleştirme ile uyumlu değildir; dikkatli kullanın',
    km: 'បើកតុពីរកន្លែងទំហំខុសរួច មិនសមស្របនឹងការរួមឯកសារពីរកន្លែង សូមប្រើប្រយ័ត្ន',
    es: 'Después de habilitar diferentes tamaños de la mesa de estación doble, es incompatible con la función de fusión de archivos de estación doble, úsela con precaución',
    ar: 'بعد تمكين أحجام مختلفة لجدول المحطة المزدوجة، فهي غير متوافقة مع وظيفة دمج ملفات المحطة المزدوجة، يرجى استخدامها بحذر',
  },
  'cuttingDock.cuttingParams.maxSize2': {
    zh: '工位二最大尺寸',
    en: 'Maximum Size for Station 2',
    id: 'Workstation 2 ukuran maksimum',
    kz: 'Бі�ұрақтың ең үлкен өлшемі',
    th: 'เวิร์กสเตชัน 2 ขนาดสูงสุด',
    ug: 'پوچتا 2 ئەڭ چوڭ چوڭلۇقى',
    vi: 'Kích thước tối đa của vị trí 2',
    zh_tc: '工位二最大尺寸',
    ru: 'Второй максимальный размер',
    ko: '작업 공간 2 최대 크기',
    bur: 'အလုပ်ဌာန၂အများဆုံးအရွယ်',
    ben: 'স্টেশন ২ সর্বোচ্চ সাইজ',
    tr: 'İstasyon 2 maksimum boyutu',
    km: 'ទំហំអតិបរមាកន្លែង ២',
    es: 'Tamaño máximo de la estación dos',
    ar: 'الحد الأقصى لحجم المحطة الثانية',
  },
  'cuttingDock.cuttingParams.autoSelectTip': {
    zh: '双工位设备两个台面尺寸不同时使用此功能将会自动选择对应工位加工大板',
    en: 'When using this feature with different sizes for the two tables of a double-station machine, it will automatically select the corresponding station for processing large boards.',
    id: '(Jika dua meja dari peralatan stasiun ganda berbeda dalam ukuran yang sama, fungsi ini akan dipilih secara otomatis untuk memproses pelat besar di stasiun yang sesuai)',
    kz: 'Екі жұмыс орнының үстелінің өлшемдері бір-бірінен әртүрлі болғанда, осы функцияны қолданса, відповідің жұмыс орны ірі панельді кесуге автоматты түрде таңдалады',
    th: '(หากโต๊ะสองโต๊ะของอุปกรณ์สองสถานีมีขนาดเท่ากันฟังก์ชั่นนี้จะถูกเลือกโดยอัตโนมัติเพื่อประมวลผลแผ่นขนาดใหญ่ในสถานีที่สอดคล้องกัน)',
    ug: 'ئىككى پوچتالىق قوراللارنىڭ ئىككى يۈزىنىڭ چوڭلۇقى ئوخشاش بولمىغاندا بۇ فۇنكسىيەنى ئىشلەتسىڭىز، ئۇ ئوخشاش بولمىغان پوچتىلارغا ئەگەشىپ چوڭ تاختىلارنى ئاپتوماتىك تاللايدۇ',
    vi: 'Khi hai bàn máy có kích thước khác nhau, sử dụng chức năng này sẽ tự động chọn vị trí để gia công tấm lớn',
    zh_tc: '雙工位設備兩個台面尺寸不同時使用此功能將會自動選擇對應工位加工大板',
    ru: 'Двухпозиционное оборудование, два рабочих стола разных размеров при использовании этой функции автоматически выберет соответствующее место для обработки больших панелей',
    ko: '더블 비트 장치 두 테이블 크기가 동시에 사용되지 않음 이 기능은 자동으로 해당 비트 가공 대판을 선택합니다',
    bur: 'နှစ်ဌာနစက်နှစ်စားပွဲအရွယ်မတူသည့်အခါဤလုပ်ဆောင်ချက်သုံးပါကသက်ဆိုင်ရာဌာနကြီးပြားပြုရန်အလိုအလျောက်ရွေးမည်',
    ben: 'ডাবল-স্টেশন মেশিনের দুটি টেবিলের সাইজ ভিন্ন হলে এই ফিচার ব্যবহার করলে বড় বোর্ড প্রসেসের জন্য সংশ্লিষ্ট স্টেশন অটো সিলেক্ট হবে।',
    tr: 'Çift istasyon cihazında iki tezgâh boyutu farklıyken bu işlev büyük plaka için uygun istasyonu otomatik seçer',
    km: 'ពេលឧបករណ៍ពីរកន្លែងមានតុពីរទំហំខុស មុខងារនេះនឹងជ្រើសកន្លែងសម្រាប់ដំណើរការផ្ទាំងធំស្វ័យប្រវត្តិ',
    es: 'Cuando las dos estaciones de trabajo de Los equipos de doble estación son de diferentes tamaños, al utilizar esta función se seleccionará automáticamente la estación correspondiente para procesar la placa grande.',
    ar: 'عندما تكون محطتي العمل لمعدات المحطة المزدوجة ذات أحجام مختلفة، فإن استخدام هذه الوظيفة سوف يقوم تلقائيًا باختيار المحطة المقابلة لمعالجة اللوحة الكبيرة.',
  },
  'cuttingDock.cuttingParams.bigFlatLimit': {
    zh: '大工位只加工小工位无法加工的大板：',
    en: 'The large station only processes large boards that cannot be processed by the small station:',
    id: 'Stasiun besar hanya memproses pelat besar yang tidak dapat diproses oleh stasiun kecil:',
    kz: 'Үлкен жұмыс орны кіші жұмыс орны кеспейтін ірі панельдерді кесуге тән:',
    th: 'สถานีขนาดใหญ่ประมวลผลเฉพาะแผ่นขนาดใหญ่ที่ไม่สามารถประมวลผลได้โดยสถานีเล็ก ๆ :',
    ug: 'چوڭ پوچتا پەقەت كىچىك پوچتا ئىشلەيەلمەيدىغان چوڭ تاختىلارنى ئىشلەيدۇ:',
    vi: 'Vị trí lớn chỉ gia công tấm lớn mà vị trí nhỏ không thể gia công:',
    zh_tc: '大工位只加工小工位無法加工的大板：',
    ru: 'Большие рабочие места обрабатывают только большие панели, которые не могут быть обработаны небольшими рабочими местами:',
    ko: '큰 작업공간은 작은 작업공간에서 가공할 수 없는 큰 판만 가공합니다.',
    bur: 'ကြီးဌာနသာကြီးပြားပြုသည်-ငယ်ဌာနမပြုနိုင်သောကြီးပြား:',
    ben: 'বড় স্টেশন শুধুমাত্র সেই বড় বোর্ড প্রসেস করে যা ছোট স্টেশন প্রসেস করতে পারে না:',
    tr: 'Büyük istasyon yalnızca küçük istasyonun işleyemediği büyük plakaları işler:',
    km: 'កន្លែងធំដំណើរការតែផ្ទាំងធំដែលកន្លែងតូចមិនអាចដំណើរការ៖',
    es: 'La estación grande solo procesa placas grandes que no pueden ser procesadas por la estación pequeña:',
    ar: 'تقوم المحطة الكبيرة فقط بمعالجة الألواح الكبيرة التي لا يمكن معالجتها بواسطة المحطة الصغيرة:',
  },
  'cuttingDock.cuttingParams.surplusSetting': {
    zh: '余料设置',
    en: 'Scrap Settings',
    id: 'Pengaturan materi yang tersisa',
    kz: 'Қалдық орналасу',
    th: 'การตั้งค่าวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيال تەڭشىكى',
    vi: 'Cài đặt dư thừa',
    zh_tc: '餘料設置',
    ru: 'Параметры остатка',
    ko: '여분 설치',
    bur: 'အကြွင်းဆက်တင်',
    ben: 'স্ক্র্যাপ সেটিংস',
    tr: 'Artık malzeme ayarları',
    km: 'ការកំណត់សម្ភារៈនៅសល់',
    es: 'Configuración del material restante',
    ar: 'إعداد المواد المتبقية',
  },
  'cuttingDock.cuttingParams.surplusPosition': {
    zh: '余料摆放位置',
    en: 'Scrap Placement Position',
    id: 'Penempatan bahan yang tersisa',
    kz: 'Қалдық орналасу нүктесі',
    th: 'การจัดวางวัสดุที่เหลืออยู่',
    ug: 'قالدۇق ماتېرىيالنى قويۇش ئورنى',
    vi: 'Vị trí đặt dư thừa',
    zh_tc: '餘料擺放位置',
    ru: 'Место расположения излишков',
    ko: '여분의 재료 배치 위치',
    bur: 'အကြွင်းထားရာနေရာ',
    ben: 'স্ক্র্যাপ প্লেসমেন্ট পজিশন',
    tr: 'Artık malzeme yerleşim konumu',
    km: 'ទីតាំងដាក់សម្ភារៈនៅសល់',
    es: 'Colocación del material restante',
    ar: 'وضع المواد المتبقية',
  },
  'cuttingDock.cuttingParams.cutHoleWay': {
    zh: '切割打孔方式',
    en: 'Cutting and Drilling Method',
    id: 'Metode pemotongan dan meninju',
    kz: 'Тесіктің кесу әдісі',
    th: 'การตัดและการเจาะ',
    ug: 'قېپىش-تەشىك ئېچىش ئۇسۇلى',
    vi: 'Cách cắt đục lỗ',
    zh_tc: '切割打孔方式',
    ru: 'Порезка',
    ko: '가공 펀치 방식',
    bur: 'ဖြတ်ဖောက်အပေါက်နည်း',
    ben: 'কাটিং ও ড্রিলিং পদ্ধতি',
    tr: 'Kesim ve delme yöntemi',
    km: 'វិធីកាត់ និងរណ្តៅ',
    es: 'Método de corte y punzonado',
    ar: 'طريقة القطع والتثقيب',
  },
  'cuttingDock.cuttingParams.knifeFlat': {
    zh: '对刀基准面',
    en: 'Knife Reference Plane',
    id: 'Tatap muka',
    kz: 'Қашықтың сүреу бастық нүқтасы',
    th: 'หน้าตา',
    ug: 'پىچاق ئاساسى يۈزى',
    vi: 'Điểm chuẩn mài dao',
    zh_tc: '對刀基準面',
    ru: 'Противоположный базис',
    ko: '대시 데이텀 면',
    bur: 'ဓားအခြေပြင်မျက်နှာ',
    ben: 'নাইফ রেফারেন্স প্লেন',
    tr: 'Bıçak referans düzlemi',
    km: 'ផ្ទៃយោងឧបករណ៍កាត់',
    es: 'Plano de referencia de configuración de la herramienta',
    ar: 'المستوى المرجعي لإعداد الأداة',
  },
  'cuttingDock.cuttingParams.flat': {
    zh: '台面',
    en: 'Table Surface',
    id: 'Mesa',
    kz: 'Үстел',
    th: 'เมซา',
    ug: 'يۈز',
    vi: 'Bàn máy',
    zh_tc: '台面',
    ru: 'столешница',
    ko: '테이블',
    bur: 'စားပွဲမျက်နှာ',
    ben: 'টেবিল সারফেস',
    tr: 'Tezgâh yüzeyi',
    km: 'ផ្ទៃតុ',
    es: 'Superficie de la mesa',
    ar: 'سطح الطاولة',
  },
  'cuttingDock.cuttingParams.plankFlat': {
    zh: '大板表面',
    en: 'Large Board Surface',
    id: 'Permukaan pelat besar',
    kz: 'Ірі панельдің беті',
    th: 'พื้นผิวแผ่นขนาดใหญ่',
    ug: 'چوڭ تاختىنىڭ يۈزى',
    vi: 'Bề mặt tấm lớn',
    zh_tc: '大板表面',
    ru: 'Большая поверхность',
    ko: '판자 표면',
    bur: 'ကြီးပြားမျက်နှာ',
    ben: 'লার্জ বোর্ড সারফেস',
    tr: 'Büyük plaka yüzeyi',
    km: 'ផ្ទៃផ្ទាំងធំ',
    es: 'Superficie de la placa grande',
    ar: 'سطح اللوحة الكبير',
  },
  'cuttingDock.cuttingParams.freeHeightZ': {
    zh: '空闲时Z高度',
    en: 'Z Height When Idle',
    id: 'Z Tinggi Dalam Idle',
    kz: 'Бос уақытта Z бейіктігі',
    th: 'ความสูง z ในการไม่ได้ใช้งาน',
    ug: 'بوش ۋاقىتتىكى Z ئېگىزلىكى',
    vi: 'Chiều cao Z khi không hoạt động',
    zh_tc: '空閒時Z高度',
    ru: 'Высота Z в свободное время',
    ko: '유휴 시 Z 높이',
    bur: 'အချည်းနှီးZ အမြင့်',
    ben: 'আইডলে Z হাইট',
    tr: 'Boşta Z yüksekliği',
    km: 'កម្ពស់ Z ពេលទំនេរ',
    es: 'Inactivo Z Altura',
    ar: 'خامل Z الارتفاع',
  },
  'cuttingDock.cuttingParams.relativeHeight': {
    zh: '相对大板上表面高度',
    en: 'Relative Height to the Upper Surface of the Large Board',
    id: 'Relatif terhadap ketinggian permukaan atas pelat besar',
    kz: 'Ірі панельдің бетіне қарайгі бейіктігі',
    th: 'สัมพันธ์กับความสูงของพื้นผิวด้านบนของแผ่นขนาดใหญ่',
    ug: 'چوڭ تاختىنىڭ ئۈستى يۈزىگە نىسبەتەن ئېگىزلىك',
    vi: 'Chiều cao tương đối với bề mặt trên của tấm lớn',
    zh_tc: '相對大板上表面高度',
    ru: 'Относительно большая высота верхней поверхности',
    ko: '대판 표면 높이 대비',
    bur: 'ကြီးပြားအပေါ်မျက်နှာအမြင့်နှင့်နှိုင်းရှည်',
    ben: 'বড় বোর্ডের উপরের সারফেসের সাপেক্ষে উচ্চতা',
    tr: 'Büyük plaka üst yüzeyine göre göreli yükseklik',
    km: 'កម្ពស់ធៀបនឹងផ្ទៃលើផ្ទាំងធំ',
    es: 'Relativa a la altura de la superficie superior de la placa grande',
    ar: 'بالنسبة إلى ارتفاع السطح العلوي للوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.cutDeepZ': {
    zh: '切透量Z深度',
    en: 'Cutting Depth in Z Axis',
    id: 'Potong throughput z kedalaman',
    kz: 'Кесу тереңдігінің Z бейіктігі',
    th: 'ตัดปริมาณความลึก Z',
    ug: 'ئېچىش چوڭلۇقى Z چوڭلۇقى',
    vi: 'Chiều sâu cắt Z',
    zh_tc: '切透量Z深度',
    ru: 'Проницаемость Z глубина',
    ko: '절투량 Z 깊이',
    bur: 'ဖြတ်ဖောက်Z အနက်',
    ben: 'কাটিং ডেপথ Z অক্ষ',
    tr: 'Tam kesim Z derinliği',
    km: 'ជម្រៅ Z កាត់ឆ្លង',
    es: 'Cantidad de corte Z Profundidad',
    ar: 'كمية القطع Z العمق',
  },
  'cuttingDock.cuttingParams.cutDeepH': {
    zh: '通孔打孔方式',
    en: 'Through-Hole Drilling Method',
    id: 'Melalui metode pengeboran lubang',
    kz: 'Толық тесіктің кесу әдісі',
    th: 'ผ่านวิธีการขุดเจาะรู',
    ug: 'ئېچىلغان تەشىك ئېچىش ئۇسۇلى',
    vi: 'Cách đục lỗ thông',
    zh_tc: '通孔打孔方式',
    ru: 'способ перфорации через отверстие',
    ko: '펀치 방식',
    bur: 'အပေါက်ဖောက်နည်း',
    ben: 'থ্রু-হোল ড্রিলিং পদ্ধতি',
    tr: 'Delikten geçirme delme yöntemi',
    km: 'វិធីរណ្តៅឆ្លងរណ្តៅ',
    es: 'Método de perforación pasante',
    ar: 'طريقة التثقيب من خلال الثقب',
  },
  'cuttingDock.cuttingParams.setDisableDoubleSidedThroughHole': {
    zh: '设置不生效翻面两次打穿孔',
    en: 'Set disable double-sided through hole drilling',
    id: 'Setel nonaktifkan pengeboran lubang tembus dua sisi',
    kz: 'Екі жақты тесік бұрғылауды өшіруді орнату',
    th: 'ตั้งค่าปิดการเจาะรูทะลุสองด้าน',
    ug: 'ئىككى تەرەپلىك تېشىش ئۇقۇمىنى ئۆچۈرۈش تەڭشىكى',
    vi: 'Thiết lập tắt khoan lỗ xuyên hai mặt',
    zh_tc: '設置不生效翻面兩次打穿孔',
    ru: 'Параметры не вступят в силу',
    ko: '설정이 유효하지 않음 뒤집기 두 번 천공',
    bur: 'နှစ်ဘက်ဖောက်နှစ်ကြိမ်လှန်ဖောက်မသက်ရောက်သတ်မှတ်',
    ben: 'ডাবল-সাইডেড থ্রু হোল ড্রিলিং নিষ্ক্রিয় সেট করুন',
    tr: 'Çift taraflı iki kez çevirerek delikten geçirmeyi devre dışı bırak (ayar)',
    km: 'កំណត់មិនឱ្យរណ្តៅឆ្លងពីរមុខដោយបង្វិលពីរដងមានប្រសិទ្ធភាព',
    es: 'La configuración no es efectiva. Voltee y perfore dos veces',
    ar: 'الإعداد غير فعال. اقلب وثقب مرتين',
  },
  'cuttingDock.cuttingParams.addHolesToRulesDisableDoubleSided': {
    zh: '将对应通孔（打穿的孔）添加到下方规则后，不生效翻面两次打穿',
    en: 'After adding the corresponding through-holes (holes drilled all the way through) to the rules below, flipping twice to drill through will not take effect',
    id: 'Setelah menambahkan lubang tembus yang sesuai (lubang yang menembus) ke aturan di bawah, membalik dua kali untuk mengebor tembus tidak akan berlaku',
    kz: 'Сәйкес өткізгіш тесіктерді (толық бұрғыланған тесік) төмендегі ережелерге қосқаннан кейін, екі рет аударып тесіп өту күшін жояды',
    th: 'หลังจากเพิ่มรูทะลุที่สอดคล้อง (รูที่เจาะทะลุ) ลงในกฎด้านล่างแล้ว การพลิกหน้าสองครั้งเพื่อเจาะทะลุจะไม่มีผล',
    ug: 'مۇناسىۋەتلىك ئۆتكەن تېشىكنى (تولۇق تېشىلغان تېشىك) تۆۋەندىكى قائىدىگە قوشقاندىن كېيىن، ئۆرۈلۈپ ئىككى قېتىم ئېچىش كۈچكە ئىگە بولمايدۇ',
    vi: 'Sau khi thêm các lỗ thông (lỗ xuyên thủng) tương ứng vào quy tắc bên dưới, đục lỗ hai lần bằng cách lật mặt sẽ không có hiệu lực',
    zh_tc: '將對應通孔（打穿的孔）添加到下方規則後，不生效翻面兩次打穿',
    ru: 'После добавления соответствующих сквозных отверстий (отверстий насквозь) в правила ниже, переворот дважды для пробивки не вступит в силу',
    ko: '해당 관통공(뚫린 구멍)을 아래 규칙에 추가한 후, 뒤집어 두 번 꿰뚫기가 적용되지 않습니다',
    bur: 'အောက်ပါစည်းမျဉ်းသို့ သက်ဆိုင်ရာ ချိတ်ဆက်ပေါက် (ပြည့်စုံစွာဖောက်ထားသော အပေါက်) ထည့်ပြီးနောက် လှန်နှစ်ကြိမ်ဖောက်ခြင်း မသက်ရောက်ပါ',
    ben: 'নিচের নিয়মে সংশ্লিষ্ট থ্রু-হোল (সম্পূর্ণ ভেদ করা গর্ত) যোগ করার পর, দুইবার উল্টিয়ে ড্রিল থ্রু কার্যকর হবে না',
    tr: 'Karşılık gelen delik geçişlerini (delinen delikler) aşağıdaki kurallara ekledikten sonra, iki kez çevirerek delikten geçirme uygulanmaz',
    km: 'បន្ថែមរន្ធឆ្លង (រន្ធដែលចូលទៅដល់) ដែលត្រូវគ្នាទៅច្បាប់ខាងក្រោមរួច ការរណ្តៅឆ្លងដោយបង្វិលពីរដងមិនអនុវត្ត',
    es: 'Después de agregar los orificios pasantes correspondientes (orificios perforados de punta a punta) a las reglas inferiores, voltear y perforar dos veces no tendrá efecto',
    ar: 'بعد إضافة الثقوب المارّة المقابلة (الثقوب المثقوبة بالكامل) إلى القواعد أدناه، لن يكون قلب اللوحة وثقبها مرتين ساري المفعول',
  },
  'cuttingDock.cuttingParams.onceThrough': {
    zh: '一次打穿',
    en: 'Drill Through Once',
    id: 'Meninju sekaligus',
    kz: 'Бір рет кесу',
    th: 'เจาะผ่านทันที',
    ug: 'بىر قېتىم ئېچىش',
    vi: 'Đục lỗ một lần',
    zh_tc: '一次打穿',
    ru: 'Пробей один раз.',
    ko: '한 번에 꿰뚫다',
    bur: 'တစ်ကြိမ်ဖောက်',
    ben: 'একবারে ড্রিল থ্রু করুন',
    tr: 'Tek seferde delikten geçir',
    km: 'រណ្តៅឆ្លងមួយដង',
    es: 'Una vez',
    ar: 'مرة واحدة خلال',
  },
  'cuttingDock.cuttingParams.rollThrough': {
    zh: '翻面两次打穿',
    en: 'Drill Through by Turning Over Twice',
    id: 'Balikkan wajah dua kali',
    kz: 'Екі рет ауысу кесу',
    th: 'พลิกหน้าสองครั้ง',
    ug: 'ئۆرۈلۈپ ئىككى قېتىم ئېچىش',
    vi: 'Đục lỗ hai lần bằng cách lật mặt',
    zh_tc: '翻面兩次打穿',
    ru: 'Перевернутый дважды.',
    ko: '뒤집어 두 번 꿰뚫다.',
    bur: 'လှန်နှစ်ကြိမ်ဖောက်',
    ben: 'দুইবার উল্টিয়ে ড্রিল থ্রু করুন',
    tr: 'İki kez çevirerek delikten geçir',
    km: 'រណ្តៅឆ្លងដោយបង្វិលពីរដង',
    es: 'Voltear y perforar dos veces',
    ar: 'اقلب وثقب مرتين',
  },
  'cuttingDock.cuttingParams.cutDeepS': {
    zh: '通槽打穿方式',
    en: 'Through-Slot Drilling Method',
    id: 'Cara menembus melalui alur',
    kz: 'Толық ойықтықтың кесу әдісі',
    th: 'วิธีเจาะผ่านร่อง',
    ug: 'ئېچىلغان ئارقا ئېچىش ئۇسۇلى',
    vi: 'Cách đục khe thông',
    zh_tc: '通槽打穿方式',
    ru: 'Пробиваемый способ',
    ko: '통홈 뚫기 방식',
    bur: 'ချောင်းဖောက်နည်း',
    ben: 'থ্রু-স্লট ড্রিলিং পদ্ধতি',
    tr: 'Oluk delikten geçirme yöntemi',
    km: 'វិធីរណ្តៅជង្ហុកឆ្លង',
    es: 'Método de perforación de orificio pasante',
    ar: 'طريقة التثقيب عبر الفتحة',
  },
  'cuttingDock.cuttingParams.plankCutDirection': {
    zh: '小板切割方向',
    en: 'Cutting Direction of Small Boards',
    id: 'Arah pemotongan pelat kecil',
    kz: 'Кіші панельдің кесу бағыты',
    th: 'ทิศทางการตัดแผ่นเล็ก ๆ',
    ug: 'كىچىك تاختا قېپىش يۆنىلىشى',
    vi: 'Hướng cắt tấm nhỏ',
    zh_tc: '小板切割方向',
    ru: 'Направление разреза листов',
    ko: '소판 절단 방향',
    bur: 'ပေါ်ဒ်ငယ်ဖြတ်ဦးတည်ချက်',
    ben: 'ছোট বোর্ডের কাটিং দিক',
    tr: 'Küçük plaka kesim yönü',
    km: 'ទិសកាត់ផ្ទាំងតូច',
    es: 'Dirección de corte de placa pequeña',
    ar: 'اتجاه قطع اللوحة الصغيرة',
  },
  'cuttingDock.cuttingParams.clockDirSwitch': {
    zh: '自定义铣孔铣槽/内部异形切割方向',
    en: 'Custom Milling Hole/Slot and Internal Profile Cutting Direction',
    id: 'Pengaturan tepi umum',
    kz: 'Теңшеу тесігі/ойығы және ішкі профильді кесу бағытын теңшеу',
    th: 'ตั้งค่าการตัดขอบทั่วไป',
    ug: 'مىل تەشىك/ئارقا/ئىچكى ئالاھىدە شەكىللىك قېپىش يۆنىلىشىنى ئۆزگەرتىش',
    vi: 'Hướng cắt lỗ/rãnh phay và cắt hình dạng bên trong tùy chỉnh',
    zh_tc: '自定義銑孔銑槽/內部異形切割方向',
    ru: 'Настройка направления фрезерных отверстий / внутренней фасонной резки',
    ko: '밀링 구멍 밀링 슬롯 / 내부 이형 컷 방향 사용자화',
    bur: 'စိတ်ကြိုက်မီးအပေါက်/ချောင်းနှင့်အတွင်းအသွင်းဖြတ်ဦးတည်ချက်ပြောင်း',
    ben: 'কাস্টম মিলিং হোল/স্লট ও ইন্টারনাল প্রোফাইল কাটিং দিক',
    tr: 'Özel freze delik/oluk ve iç profil kesim yönü',
    km: 'ទិសរណ្តៅជង្ហុក/រណ្តៅ និងកាត់រូបរាងខាងក្នុងតាមបំណង',
    es: 'Ranura de fresado personalizada/dirección de corte interna de forma especial',
    ar: 'فتحة الطحن المخصصة لفتحة الطحن / اتجاه القطع الداخلي ذو الشكل الخاص',
  },
  'cuttingDock.cuttingParams.millHoleSlotDir': {
    zh: '铣孔铣槽方向',
    en: 'Milling Hole/Slot Direction',
    id: 'Pengaturan arah phay lubang/slot',
    kz: ' Теңшеу тесігі/ойығы бағыты',
    th: 'การตั้งค่าการตัดขอบทั่วไป',
    ug: 'مىل تەشىك/ئارقا يۆنىلىشى',
    vi: 'Hướng phay lỗ/rãnh',
    zh_tc: '銑孔銑槽方向',
    ru: 'направление фрезерных пазов',
    ko: '밀링 구멍 밀링 슬롯 방향',
    bur: 'မီးအပေါက်ချောင်းဦးတည်ချက်',
    ben: 'মিলিং হোল/স্লট দিক',
    tr: 'Freze delik/oluk yönü',
    km: 'ទិសរណ្តៅរណ្តៅជង្ហុក',
    es: 'Dirección de ranura de fresado de orificio',
    ar: 'اتجاه فتحة الطحن لفتحة الطحن',
  },
  'cuttingDock.cuttingParams.millInternalCurveDir': {
    zh: '内部异形切割方向',
    en: 'Internal Profile Cutting Direction',
    id: 'Pengaturan arah profil dalam',
    kz: 'Ішкі профильді кесу бағыты',
    th: 'ตั้งค่าการตัดขอบทั่วไป',
    ug: 'ئىچكى ئالاھىدە شەكىللىك قېپىش يۆنىلىشى',
    vi: 'Hướng cắt hình dạng bên trong',
    zh_tc: '內部異形切割方向',
    ru: 'направление внутренней фасонной резки',
    ko: '내부 이형 컷 방향',
    bur: 'အတွင်းအသွင်းဖြတ်ဦးတည်ချက်',
    ben: 'ইন্টারনাল প্রোফাইল কাটিং দিক',
    tr: 'İç profil kesim yönü',
    km: 'ទិសកាត់រូបរាងខាងក្នុង',
    es: 'Dirección de corte interna de forma especial',
    ar: 'اتجاه القطع الداخلي ذو الشكل الخاص',
  },
  'cuttingDock.cuttingParams.sDirection': {
    zh: '顺时针',
    en: 'Clockwise',
    id: 'Searah jarum jam',
    kz: 'Сәулеткеш бағыт',
    th: 'ตามเข็มนาฬิกา',
    ug: 'سائەت يۆنىلىشى',
    vi: 'Đoàn tròn',
    zh_tc: '順時針',
    ru: 'по часовой стрелке',
    ko: '시계 바늘',
    bur: 'နာရီလက်တံဦးတည်ချက်',
    ben: 'ঘড়ির কাঁটার দিক',
    tr: 'Saat yönü',
    km: 'តាមទិសនាឡិកា',
    es: 'En el sentido de las agujas del reloj',
    ar: 'في اتجاه عقارب الساعة',
  },
  'cuttingDock.cuttingParams.nDirection': {
    zh: '逆时针',
    en: 'Counterclockwise',
    id: 'Berlawanan arah jarum jam',
    kz: 'Сәулеткеш бағыттың керісі',
    th: 'ทวนเข็มนาฬิกา',
    ug: 'سائەت يۆنىلىشىگە تەتۈر',
    vi: 'Đoàn trục',
    zh_tc: '逆時針',
    ru: 'против часовой стрелки',
    ko: '반시계 방향',
    bur: 'နာရီလက်တံပြောင်းပြန်',
    ben: 'ঘড়ির কাঁটার বিপরীত',
    tr: 'Saat yönünün tersi',
    km: 'ច្រាសទិសនាឡិកា',
    es: 'En sentido antihorario',
    ar: 'عكس اتجاه عقارب الساعة',
  },
  'cuttingDock.cuttingParams.curveReplenish': {
    zh: '圆弧插补指令切割弧形板',
    en: 'Arc Interpolation Instruction for Cutting Arc-Shaped Boards',
    id: 'Perintah interpolasi busur untuk memotong pelat busur',
    kz: 'Арқалық толтыру кесу командасы арқалық панельдерді кесуге',
    th: 'คำสั่งการแก้ไขอาร์คเพื่อตัดแผ่นอาร์ค',
    ug: 'دۆڭگىلەك قېپىش بۇيرۇقى بىلەن دۆڭگىلەك تاختىلارنى قېپىش',
    vi: 'Cách cắt bằng chỉ dẫn hoàn cung cho tấm hình cung',
    zh_tc: '圓弧插補指令切割弧形板',
    ru: 'Директива по дуговой вставке',
    ko: '호 보간 명령 절단 호형판',
    bur: 'အဝိုင်းထည့်ချက်ဖြတ်ချွန်းပြား',
    ben: 'আর্ক শেপ বোর্ড কাটার জন্য আর্ক ইন্টারপোলেশন ইনস্ট্রাকশন',
    tr: 'Yay enterpolasyon komutu ile yay şekilli plaka kesimi',
    km: 'កាត់ផ្ទាំងរូបចង្កូមដោយពាក្យបញ្ជាបញ្ចូលរង្វង់',
    es: 'Comando de interpolación de arco para cortar la placa de arco',
    ar: 'أمر الاستيفاء القوسي لقطع الألواح القوسية',
  },
  'cuttingDock.cuttingParams.curveReplenishTip': {
    zh: '弧形板件切割出现锯齿时可选用该功能',
    en: 'Use this function when sawtooth appears during cutting of arc-shaped pieces',
    id: 'Fungsi ini dapat digunakan saat gerigi muncul dalam pemotongan pelat melengkung',
    kz: 'Арқалық панельдерді кесуде заңбырлар пайда болса, осы функцияны қолдану',
    th: 'ฟังก์ชั่นนี้สามารถใช้ได้เมื่อ serrations ปรากฏในการตัดของแผ่นโค้ง',
    ug: 'دۆڭگىلەك تاختىلار قېپىشتە تىشچىلىق پەيدا بولسا بۇ فۇنكسىيەنى تاللاڭ',
    vi: 'Khi cắt tấm hình cung xuất hiện răng saw có thể sử dụng chức năng này',
    zh_tc: '弧形板件切割出現鋸齒時可選用該功能',
    ru: 'Эта функция может быть выбрана при появлении зазубренных дисков',
    ko: '원형 판넬 가공에 톱니가 나타나는 경우 이 기능을 사용할 수 있습니다.',
    bur: 'ချွန်းပြားဖြတ်သည့်အခါအစွန်းညီပေါ်လာပါကဤလုပ်ဆောင်ချက်ရွေးနိုင်',
    ben: 'আর্ক শেপ পিস কাটার সময় স sawটুথ দেখা দিলে এই ফাংশন ব্যবহার করুন',
    tr: 'Yay şekilli plaka kesiminde tırtıklanma olursa bu işlevi seçin',
    km: 'ពេលកាត់ផ្ទាំងរូបចង្កូមមានធ្មេញរមាស អាចប្រើមុខងារនេះ',
    es: 'Esta función se puede utilizar cuando aparece un diente de sierra en el corte de la placa de arco',
    ar: 'يمكن استخدام هذه الوظيفة عندما يظهر سن المنشار في قطع الألواح القوسية',
  },
  'cuttingDock.cuttingParams.noGen': {
    zh: '不生成G17/G18/G19面指令',
    en: 'Do Not Generate G17/G18/G19 Plane Instructions',
    id: 'Tidak ada perintah wajah G17/G18/G19',
    kz: 'G17/G18/G19 бетінің командасын жасамау',
    th: 'ไม่มีการสร้างคำสั่ง G17/G18/G19',
    ug: 'G17/G18/G19 يۈز بۇيرۇقىنى ئەمەلدىن قالدۇرماڭ',
    vi: 'Không tạo lệnh mặt G17/G18/G19',
    zh_tc: '不生成G17/G18/G19面指令',
    ru: 'Не генерировать инструкции G17 / G18 / G19',
    ko: 'G17/G18/G19 면 명령이 생성되지 않음',
    bur: 'G17/G18/G19 မျက်နှာညွှန်ကြားချက်မဖန်တီး',
    ben: 'G17/G18/G19 প্লেন ইনস্ট্রাকশন জেনারেট করবেন না',
    tr: 'G17/G18/G19 düzlem komutları üretme',
    km: 'មិនបង្កើតពាក្យបញ្ជាផ្ទៃ G17/G18/G19',
    es: 'No generar G17/G18/G19 comando de superficie',
    ar: 'لا تولد G17/G18/G19 الأمر السطحي',
  },
  'cuttingDock.cuttingParams.arcInstruction': {
    zh: '圆弧插补指令前缀',
    en: 'Arc machining command prefix',
    id: 'Awalan instruksi interpolasi busur',
    kz: 'Шеңісті өңдеу командаларының алдындағы белгі',
    th: 'คำแนะนำคำแนะนำการแก้ไขอาร์ค',
    ug: 'دۆڭگىلەك قېپىش بۇيرۇقى ئالدى قوشۇمچىسى',
    vi: 'Tiền tố lệnh gia công đường tròn',
    zh_tc: '圓弧插補指令前綴',
    ru: 'Префикс команды дуговой вставки',
    ko: '호 보간 명령 접두사',
    bur: 'အဝိုင်းထည့်ချက်ညွှန်ကြားချက်ရှေ့ဆက်',
    ben: 'আর্ক মেশিনিং কমান্ড প্রিফিক্স',
    tr: 'Yay işleme komutu öneki',
    km: 'បុព្វបទពាក្យបញ្ជាដំណើរការរង្វង់',
    es: 'Prefijo del comando de interpolación de arco',
    ar: 'بادئة أمر الاستيفاء القوسي',
  },
  'cuttingDock.cuttingParams.example': {
    zh: '示例',
    en: 'example',
    id: 'Contoh',
    kz: 'мисал',
    th: 'ตัวอย่าง',
    ug: 'مىسال: G17G03 X100 Y100',
    vi: 'ví dụ',
    zh_tc: '示例',
    ru: 'Примеры',
    ko: '예시',
    bur: 'ဥပမာ',
    ben: 'উদাহরণ',
    tr: 'Örnek',
    km: 'ឧទាហរណ៍',
    es: 'Ejemplo',
    ar: 'مثال',
  },
  'cuttingDock.cuttingParams.arcExample': {
    zh: 'G17G03 X100 Y100',
    en: 'G17G03 X100 Y100',
    id: 'G17G03 X100 Y100',
    kz: 'G17G03 X100 Y100',
    th: 'G17G03 X100 Y100',
    ug: 'G17G03 X100 Y100',
    vi: 'G17G03 X100 Y100',
    zh_tc: 'G17G03 X100 Y100',
    ru: 'G17G03 X100 Y100',
    ko: 'G17G03 X100 Y100',
    bur: 'G17G03 X100 Y100',
    ben: 'G17G03 X100 Y100',
    tr: 'G17G03 X100 Y100',
    km: 'G17G03 X100 Y100',
    es: 'G17G03 X100 Y100',
    ar: 'G17G03 X100 Y100',
  },
  'cuttingDock.cuttingParams.curveCutTip': {
    zh: '圆弧切割用I、J表示',
    en: 'Arc cutting is represented by I and J',
    id: 'Pemotongan busur diwakili oleh i dan j',
    kz: 'Арқалық кесуде I, J белгілері қолданылады',
    th: 'การตัดส่วนโค้งแสดงโดย I และ J',
    ug: 'دۆڭگىلەك قېپىشتە I، J بىلەن ئىپادىلەيدۇ',
    vi: 'Cắt hoàn cung bằng I, J',
    zh_tc: '圓弧切割用I、J表示',
    ru: 'Дуговая резка обозначена I и J.',
    ko: '호 가공은 I, J로 표현됩니다.',
    bur: 'အဝိုင်းဖြတ်ခြင်းကို I၊ J ဖြင့်ပြ',
    ben: 'আর্ক কাটিং I ও J দ্বারা প্রকাশিত',
    tr: 'Yay kesimi I ve J ile gösterilir',
    km: 'កាត់រង្វង់ប្រើ I និង J',
    es: 'El corte de arco se representa mediante I, J',
    ar: 'يتم تمثيل القطع القوسي بواسطة I، J',
  },
  'cuttingDock.cuttingParams.coverRate': {
    zh: '铣槽时切割重叠率为：',
    en: 'The Overlap Rate for Milling Slots Is:',
    id: 'Laju tumpang tindih pemotongan selama alur penggilingan adalah:',
    kz: 'Ойықтық кесу кезінде кесудің қапталушылығы:',
    th: 'อัตราการตัดซ้อนกันระหว่างร่องสีคือ:',
    ug: 'مىل ئارقىسى قېپىشتە قېپىش قاپلىشىش نىسبىتى:',
    vi: 'Tỷ lệ chồng chéo khi cắt khe:',
    zh_tc: '銑槽時切割重疊率為：',
    ru: 'Коэффициент перекрытия при фрезеровании составляет:',
    ko: '슬롯 밀링 시 컷 중첩률은 다음과 같습니다.',
    bur: 'မီးချောင်းဖြတ်သည့်အခါဖြတ်ထပ်နှုန်း:',
    ben: 'মিলিং স্লটের ওভারল্যাপ রেট:',
    tr: 'Oluk frezelenirken kesim örtüşme oranı:',
    km: 'អត្រាស្ទូចស្រទាប់ពេលកិនរណ្តៅជង្ហុក៖',
    es: 'Tasa de superposición de corte al fresar ranuras:',
    ar: 'معدل تداخل القطع عند فتحات الطحن:',
  },
  'cuttingDock.cuttingParams.roughTip': {
    zh: '刀具铣槽时槽内部有余留毛刺时使用该功能',
    en: 'Use this function when there are burrs inside the slot during milling',
    id: 'Gunakan fungsi ini saat ada gerombolan residual di dalam alur saat menggiling alur pahat',
    kz: 'Қалдық пен ойықтық ішінде кесуде заңбырлар пайда болса, осы функцияны қолдану',
    th: 'ใช้ฟังก์ชั่นนี้เมื่อมีเสี้ยนที่เหลืออยู่ภายในร่องเมื่อกัดร่องเครื่องมือ',
    ug: 'پىچاق مىل ئارقىسى قېپىشتە ئارقىدا قالدۇق پىچاق قالسا بۇ فۇنكسىيەنى ئىشلىتىڭ',
    vi: 'Sử dụng chức năng này khi dao cắt khe còn có chích cọc bên trong khe',
    zh_tc: '刀具銑槽時槽內部有餘留毛刺時使用該功能',
    ru: 'Используйте эту функцию, когда внутри канавки остаётся заусенец.',
    ko: '이 기능은 공구가 슬롯을 밀링할 때 슬롯 내부에 가시가 남아 있을 때 사용됩니다.',
    bur: 'ဓားမီးချောင်းသည့်အခါချောင်းအတွင်းအကြွင်းမျက်နှာရှိပါကဤလုပ်ဆောင်ချက်သုံးပါ',
    ben: 'মিলিংয়ের সময় স্লটের ভিতরে বুর থাকলে এই ফাংশন ব্যবহার করুন',
    tr: 'Takım oluk frezelenirken oluk içinde tırnak/burrs kalırsa bu işlevi kullanın',
    km: 'ប្រើមុខងារនេះពេលកិនរណ្តៅជង្ហុកមានស្នាមក្នុងរណ្តៅ',
    es: 'Utilice esta función cuando quedan rebabas dentro de la ranura cuando la herramienta está fresando ranuras',
    ar: 'استخدم هذه الوظيفة عندما يكون هناك نتوءات متبقية داخل الفتحة عندما تقوم الأداة بطحن الفتحات',
  },
  'cuttingDock.cuttingParams.clearCurve': {
    zh: '铣槽时未拉穿的槽自动清理圆角：',
    en: 'Automatic Rounding of Slots That Are Not Completely Milled Through:',
    id: 'Secara otomatis membersihkan sudut bundar dari slot yang tidak ditarik selama penggilingan:',
    kz: 'Ойықтық кесуде толтырушы кесуде тегіс бұрыштар автоматты түрде тазалау:',
    th: 'ทำความสะอาดมุมโค้งมนโดยอัตโนมัติที่ไม่ได้ดึงระหว่างการกัด:',
    ug: 'مىل ئارقىسى قېپىشتە تارتىلمىغان ئارقالارنى ئاپتوماتىك تازىلاش:',
    vi: 'Khi cắt khe chưa thông sẽ tự động làm sạch góc tròn:',
    zh_tc: '銑槽時未拉穿的槽自動清理圓角：',
    ru: 'Неоткрытые при фрезеровании пазы автоматически очищают закругленные углы:',
    ko: '슬롯을 밀링할 때 잡아당기지 않은 슬롯은 자동으로 필렛을 정리합니다.',
    bur: 'မီးချောင်းသည့်အခါမဆွဲထားသောချောင်းများကိုအဝိုင်းထောင့်အလိုအလျောက်ရှင်း:',
    ben: 'যে স্লট সম্পূর্ণ মিল থ্রু নয় সেগুলোর অটো রাউন্ডিং:',
    tr: 'Freze oluk sırasında tam açılmamış oluklarda köşeleri otomatik temizle:',
    km: 'ពេលកិនរណ្តៅជង្ហុក រណ្តៅមិនទាន់ឆ្លង សម្អាតមុំរង្វង់ស្វ័យប្រវត្តិ៖',
    es: 'Limpia automáticamente los filetes de las ranuras que no se han extraído durante el fresado de ranuras:',
    ar: 'قم تلقائيًا بتنظيف شرائح الفتحات التي لم يتم سحبها خلال أثناء طحن الفتحة:',
  },
  'cuttingDock.cuttingParams.curveUseTip': {
    zh: '在铣槽时需要清理圆角选用此功能，注意该功能不对连接件生效',
    en: 'Select this function when rounding is needed during slot milling. Note that this function does not apply to connectors.',
    id: 'Fungsi ini diperlukan untuk membersihkan sudut bundar saat menggiling slot. Harap dicatat bahwa fungsi ini tidak berlaku pada konektor.',
    kz: 'Ойықтық кесуде тегіс бұрыштар тазалау үшін осы функцияны қолдану, ескерту: осы функция жалғаушыларға қолданылмайды',
    th: 'ฟังก์ชั่นนี้จำเป็นสำหรับการทำความสะอาดมุมโค้งมนเมื่อโม่สล็อต โปรดทราบว่าฟังก์ชั่นนี้ไม่มีผลกับตัวเชื่อมต่อ',
    ug: 'مىل ئارقىسى قېپىشتە دۆڭگىلەك بۇلۇڭلارنى تازىلاش ئۈچۈن بۇ فۇنكسىيەنى تاللاڭ، دىققەت: بۇ فۇنكسىيە باغلانما ئۈچۈن ئىشلەتمەيدۇ',
    vi: 'Khi cần làm sạch góc tròn khi cắt khe, sử dụng chức năng này, chú ý chức năng này không áp dụng cho các mối nối',
    zh_tc: '在銑槽時需要清理圓角選用此功能，注意該功能不對連接件生效',
    ru: 'При фрезеровании канавки необходимо очистить закругленный угол, выберите эту функцию, обратите внимание, что она не работает на соединении',
    ko: '슬롯을 밀링할 때 필렛을 정리해야 합니다. 이 기능은 연결 부품에 적용되지 않습니다.',
    bur: 'မီးချောင်းသည့်အခါအဝိုင်းထောင့်ရှင်းရန်ဤလုပ်ဆောင်ချက်ရွေးပါ၊ ဤလုပ်ဆောင်ချက်ချိတ်ဆက်ပစ္စည်းတွင်မသက်ရောက်',
    ben: 'স্লট মিলিংয়ের সময় রাউন্ডিং দরকার হলে এই ফাংশন সিলেক্ট করুন। নোট: এই ফাংশন কানেক্টরে প্রযোজ্য নয়।',
    tr: 'Oluk frezelenirken köşe temizliği gerekiyorsa bu işlevi seçin; bağlantı parçalarına uygulanmaz',
    km: 'ពេលកិនរណ្តៅជង្ហុកត្រូវសម្អាតមុំរង្វង់ ជ្រើសមុខងារនេះ មិនអនុវត្តលើផ្នែកភ្ជាប់',
    es: 'Seleccione esta función cuando necesite limpiar los filetes al fresar ranuras. Tenga en cuenta que esta función no tiene efecto en los conectores',
    ar: 'حدد هذه الوظيفة عندما تحتاج إلى تنظيف الشرائح عند طحن الفتحات. لاحظ أن هذه الوظيفة لا تسري على الموصلات',
  },
  'cuttingDock.cuttingParams.slotCutWay': {
    zh: '铣槽走刀方式',
    en: 'Slot Milling Toolpath',
    id: 'Metode perkakas slot penggilingan',
    kz: 'Ойықтық кесудің кесу бағыты',
    th: 'วิธีการโม่สล็อตเครื่องมือ',
    ug: 'مىل ئارقىسى قېپىش ئۇسۇلى',
    vi: 'Cách di chuyển dao khi cắt khe',
    zh_tc: '銑槽走刀方式',
    ru: 'фрезерный режим подачи',
    ko: '밀링 슬롯 패스 방법',
    bur: 'မီးချောင်းဓားသွားနည်း',
    ben: 'স্লট মিলিং টুলপাথ',
    tr: 'Oluk freze kesim yolu',
    km: 'វិធីដំណើរឧបករណ៍កិនរណ្តៅជង្ហុក',
    es: 'Método de avance del fresado de ranuras',
    ar: 'طريقة تغذية الطحن الشقيّ',
  },
  'cuttingDock.cuttingParams.outToIn': {
    zh: '从外向内铣槽',
    en: 'Mill Slots from Outside to Inside',
    id: 'Slot penggilingan dari luar ke dalam',
    kz: 'Сырттан ішке ойықтық кесу',
    th: 'โม่สล็อตจากภายนอกไปด้านใน',
    ug: 'تاشقىدىن ئىچكىگە مىل ئارقىسى قېپىش',
    vi: 'Cắt khe từ ngoài vào trong',
    zh_tc: '從外向內銑槽',
    ru: 'Выфрезерование канавок изнутри',
    ko: '바깥쪽에서 안쪽으로 밀링 슬롯',
    bur: 'အပြင်မှအတွင်းသို့မီးချောင်း',
    ben: 'বাইরে থেকে ভিতরে মিল স্লট',
    tr: 'Dıştan içe oluk frezele',
    km: 'កិនរណ្តៅជង្ហុកពីក្រៅចូលក្នុង',
    es: 'Fresado de la ranura de afuera hacia adentro',
    ar: 'طحن الأخدود من الخارج إلى الداخل',
  },
  'cuttingDock.cuttingParams.inToOut': {
    zh: '从内向外铣槽',
    en: 'Mill Slots from Inside to Outside',
    id: 'Slot penggilingan dari dalam ke luar',
    kz: 'Ішке сыртқа ойықтық кесу',
    th: 'โม่สล็อตจากด้านในไปด้านนอก',
    ug: 'ئىچكىدىن تاشقىغا مىل ئارقىسى قېپىش',
    vi: 'Cắt khe từ trong đến ngoài',
    zh_tc: '從內向外銑槽',
    ru: 'Фрезерный желоб изнутри наружу',
    ko: '내부 밀링 슬롯',
    bur: 'အတွင်းမှအပြင်သို့မီးချောင်း',
    ben: 'ভিতরে থেকে বাইরে মিল স্লট',
    tr: 'İçten dışa oluk frezele',
    km: 'កិនរណ្តៅជង្ហុកពីក្នុងចេញក្រៅ',
    es: 'Fresado de la ranura de adentro hacia afuera',
    ar: 'طحن الأخدود من الداخل إلى الخارج',
  },
  'cuttingDock.cuttingParams.zShapProcess': {
    zh: '通槽上下Z字形铣槽',
    en: 'Zigzag through groove',
    id: 'Slot penggilingan berbentuk Z atas dan ke bawah untuk slot melalui',
    kz: 'Жогору және төменгі Z әріптің түсінік ішіндегі штыртқа айналдыру сұйықтасу жолы',
    th: 'ขึ้นและลงช่องโหว่รูปตัว Z สำหรับการลอบ',
    ug: 'ئېچىلغان ئارقالار ئۈستى-ئاستى Z شەكىللىك مىل ئارقىسى قېپىش',
    vi: 'Trên và dưới khe',
    zh_tc: '通槽上下Z字形銑槽',
    ru: 'верхний и нижний Z - образные фрезерные пазы',
    ko: '슬롯 상하 Z자형 밀링 슬롯',
    bur: 'ချောင်းဖောက်အပေါ်အောက်Z ပုံစံမီးချောင်း',
    ben: 'থ্রু গ্রুভে জিগজ্যাগ আপ-ডাউন Z শেপ মিলিং',
    tr: 'Geçiş olukta üst-alt Z şeklinde freze',
    km: 'កិនរណ្តៅជង្ហុកឆ្លងរូប Z លើក្រោម',
    es: 'Fresado de la ranura de arriba a abajo Z',
    ar: 'طحن الأخدود من الأعلى إلى الأسفل Z',
  },
  'cuttingDock.cuttingParams.zShapProcessTip': {
    zh: '仅针对前后拉透通槽铣槽生效，刀路径重叠率默认为刀半径',
    en: 'Only for the front and back pull through slot milling, the tool path overlap rate defaults to the tool radius',
    id: 'Hanya efektif untuk alur alur tarik-tarik depan dan belakang alur, laju tumpang tindih jalur pahat default ke jari-jari pahat',
    kz: 'Кірісті және көшірілген жолдар үшін әріптің толығындауына бейімделген, ножның жол жолмен қайталану деңгейі ножның радиусына тең болады',
    th: 'มีประสิทธิภาพเฉพาะสำหรับร่องการกัดร่องด้านหน้าและด้านหลัง',
    ug: 'پەقەت ئالدىن-ئارقا تارتىلغان ئېچىلغان ئارقالار مىل ئارقىسى قېپىشتە ئىشلىتىلىدۇ، پىچاق يولى قاپلىشىش نىسبىتى سۈكۈتتىكى پىچاق رادىئۇسى',
    vi: 'Chỉ cho trước và sau thông qua khe mill khe có hiệu lực, đường chéo mặc định là bán kính dao',
    zh_tc: '僅針對前後拉透通槽銑槽生效，刀路徑重疊率默認為刀半徑',
    ru: 'Только для переднего и заднего вытягивания канавки действует, скорость перекрытия пути ножа по умолчанию радиус ножа',
    ko: '공구 경로 중첩률은 전면 및 후면 밀어내기 슬롯 밀링 슬롯에만 적용되며 기본적으로 공구 반지름입니다.',
    bur: 'ရှေ့အနောက်ဆွဲဖောက်ချောင်းမီးချောင်းတွင်သာသက်ရောက်၊ ဓားလမ်းထပ်နှုန်းမူရင်းဓားအချင်းဝ',
    ben: 'শুধুমাত্র সামনে-পিছনে পুল থ্রু স্লট মিলিংয়ের জন্য প্রযোজ্য, টুল পাথ ওভারল্যাপ রেট ডিফল্ট টুল রেডিয়াস',
    tr: 'Yalnızca önden-arkadan çekilerek açılan geçiş oluk frezelemede geçerlidir; takım yolu örtüşmesi varsayılan olarak takım yarıçapıdır',
    km: 'មានប្រសិទ្ធភាពតែសម្រាប់កិនរណ្តៅជង្ហុកឆ្លងដែលទាញពីមុខ-ក្រោយ អត្រាស្ទូចផ្លូវឧបករណ៍លំនាំដើមគឺកាំឧបករណ៍',
    es: 'Sólo es eficaz para el fresado de ranuras de tracción delantera y trasera. La tasa de superposición de la trayectoria de la herramienta tiene por defecto el radio de la herramienta',
    ar: 'إنه فعال فقط للسحب الأمامي والخلفي من خلال الطحن بالفتحة. معدل تداخل مسار الأداة الافتراضي هو نصف قطر الأداة',
  },
  'cuttingDock.cuttingParams.zSlotCuttingOverlapRate': {
    zh: 'Z字形铣槽切割重叠率为',
    en: 'Z-shaped slot cutting overlap rate',
    id: 'Tingkat tumpang tindih dari pemotongan alur penggilingan berbentuk Z adalah',
    kz: 'Z тірінің жұлдыздық жіптерінің қатынасы',
    th: 'อัตราการทับซ้อนของการตัดร่องรูปตัว Z คือ',
    ug: 'Z شەكىللىك مىل ئارقىسى قېپىشتە قاپلىشىش نىسبىتى',
    vi: 'Tỷ lệ chồng lấn cắt khe Z',
    zh_tc: 'Z字形銑槽切割重疊率為',
    ru: 'Z - образная фрезерная канавка',
    ko: 'Z자형 밀링 슬롯 컷의 중첩률은 다음과 같습니다.',
    bur: 'Z ပုံစံမီးချောင်းဖြတ်ထပ်နှုန်း',
    ben: 'Z-শেপ স্লট কাটিং ওভারল্যাপ রেট',
    tr: 'Z şekilli oluk kesim örtüşme oranı',
    km: 'អត្រាស្ទូចកាត់រណ្តៅជង្ហុករូប Z',
    es: 'Z. La tasa de superposición del corte de ranuras de fresado de fuentes es',
    ar: 'Z. معدل التداخل لقطع فتحة طحن الخط هو',
  },
  'cuttingDock.cuttingParams.zSlotCuttingOverlapRateTip': {
    zh: '当前重叠率可能导致加工速度变慢，请试机后再加工。',
    en: 'Current overlap rate may cause processing speed to slow down, please try again after the machine is started.',
    id: 'Laju tumpang tindih pemotongan alur penggilingan berbentuk Z dapat menyebabkan kecepatan pemrosesan menjadi lebih lambat, silakan coba lagi setelah mesin dihidupkan.',
    kz: 'Z тірінің жұлдыздық жіптерінің қатынасы өндіріс жылдамдығын баяулата алады, өндірістік құрылғыны іске қосудан кейін қайтадан өңдеуді қайталаңыз.',
    th: 'อัตราการทับซ้อนของการตัดร่องรูปตัว Z อาจทำให้ความเร็วการประมวลผลช้าลง โปรดลองใหม่หลังจากเปิดเครื่อง',
    ug: 'Z شەكىللىك مىل ئارقىسى قېپىشتە قاپلىشىش نىسبىتى ئۇزۇن قىيىنىڭ ئىشلەش سۈرئىتىنى ساقلاشى مۇمكىن',
    vi: 'Tỷ lệ chồng lấn cắt khe Z có thể làm cho tốc độ gia công chậm lại, vui lòng thử lại sau khi máy được bật.',
    zh_tc: '當前重疊率可能导致加工速度变慢，请试机后再加工。',
    ru: 'Текущая скорость перекрытия может привести к замедлению обработки, пожалуйста, проверьте машину после переработки.',
    ko: '현재 중첩률로 인해 가공 속도가 느려질 수 있습니다. 시험 삼아 가공하십시오.',
    bur: 'လက်ရှိထပ်နှုန်းကပြုပြင်အမြန်နှုန်းနှေးစေနိုင်၊ စက်စမ်းပြီးနောက်ပြုပါ။',
    ben: 'বর্তমান ওভারল্যাপ রেটে প্রসেসিং স্পিড কমে যেতে পারে, মেশিন চালু করার পর আবার চেষ্টা করুন।',
    tr: 'Mevcut örtüşme oranı işlem hızını düşürebilir; makineyi denedikten sonra işleyin',
    km: 'អត្រាស្ទូចបច្ចុប្បន្នអាចធ្វើឱ្យល្បឿនដំណើរការយឺត សូមសាកល្បងម៉ាស៊ីនរួចរួចដំណើរការ',
    es: '. La tasa de superposición actual puede hacer que la velocidad de procesamiento disminuya. Pruebe la máquina antes de procesarla.',
    ar: '. قد يتسبب معدل التداخل الحالي في إبطاء سرعة المعالجة. يرجى اختبار الجهاز قبل المعالجة.',
  },
  'cuttingDock.cuttingParams.slotWorkLimit': {
    zh: '(仅在铣槽走刀层数>1时生效)',
    en: '(Only Effective When the Number of Layers for Slot Milling > 1)',
    id: '(Hanya efektif ketika jumlah lapisan pemotongan alur penggilingan adalah> 1)',
    kz: '(Ойықтық кесудің кесу қатламдары > 1 болса ғана қолданылады)',
    th: '(มีผลบังคับใช้เฉพาะเมื่อจำนวนเลเยอร์ของการตัดร่องสีมิลลิ่งคือ> 1)',
    ug: '(پەقەت مىل ئارقىسى قېپىش قاتلام سانى>1 بولغاندا ئىشلىنىدۇ)',
    vi: '(Chỉ có hiệu lực khi lớp cắt khe > 1)',
    zh_tc: '(僅在銑槽走刀層數>1時生效)',
    ru: '(Действует только в том случае, если слой фрезы > 1)',
    ko: '(밀링 슬롯 패스 레벨 수가 1 이상인 경우에만 적용)',
    bur: '(မီးချောင်းဓားသွားအလွှာအရေအတွက်>1 သည့်အခါသာသက်ရောက်)',
    ben: '(শুধুমাত্র স্লট মিলিংয়ের লেয়ার সংখ্যা > ১ হলে কার্যকর)',
    tr: '(Yalnızca oluk kesim katman sayısı>1 iken geçerli)',
    km: '(មានប្រសិទ្ធភាពតែពេលចំនួនស្រទាប់ដំណើរកាត់រណ្តៅជង្ហុក > ១)',
    es: '(Solo efectivo cuando el número de pasadas de fresado de ranura es >1)',
    ar: '(فعال فقط عندما يكون عدد ممرات طحن الأخدود أكبر من 1)',
  },
  'cuttingDock.cuttingParams.minKnifeChange': {
    zh: '加工减少换刀',
    en: 'Processing Reduce Knife Change',
    id: 'Pemotongan Reduksi Perubahan Pahat',
    kz: 'Кесуде кесу қанатты басталу қаптауын азайту',
    th: 'การตัดลงที่กำหนดเอง',
    ug: 'قېپىشتە ئېگىل پىچاق قېتىلىشى',
    vi: 'Cắt giảm thay dao',
    zh_tc: '加工减少換刀',
    ru: 'Уменьшение количества смен инструмента при обработке',
    ko: '가공 감소 교체 도구',
    bur: 'ဖြတ်သည့်အခါဓားစောင်းချအမြန်နှုန်းအကောင်းဆုံးဖြစ်အောင်',
    ben: 'প্রসেসিং কম কাটিং ক্যানভার',
    tr: 'İşlemde kesim kırılması azaltma',
    km: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
    es: 'Reducción de cambio de herramienta en el procesamiento',
    ar: 'تقليل تغيير القطعة أثناء المعالجة',
  },
  'cuttingDock.cuttingParams.preventBreakage': {
    zh: '边缘槽隔条防断',
    en: 'Edge Slot Separator Breakage Prevention',
    id: 'Pencegahan Patah Separator Slot Tepi',
    kz: 'Жиектік ойық аралық жолағының үзілуін болдырмау',
    th: 'ป้องกันการขาดของคานคั่นร่องขอบ',
    ug: 'گىرۋەك ئارقا ئايرىغۇچ ئۈزۈلۈشنىڭ ئالدىنى ئېلىش',
    vi: 'Chống đứt thanh ngăn rãnh cạnh',
    zh_tc: '邊緣槽隔條防斷',
    ru: 'Предотвращение облома перемычки краевого паза',
    ko: '가장자리 슬롯 격판 파손 방지',
    bur: 'အနားချောင်းခြားသားပြားကျိုးခြင်းကာကွယ်',
    ben: 'প্রান্ত স্লট বিভাজক ভাঙন প্রতিরোধ',
    tr: 'Kenar oluk ayırıcı kırılma önleme',
    km: 'ការពារការបាក់របាំងរណ្តៅជង្ហុកគែម',
    es: 'Prevención de rotura del separador de ranura de borde',
    ar: 'منع كسر فاصل أخدود الحافة',
  },
  'cuttingDock.cuttingParams.preventBreakageTip': {
    zh: '该设置仅对排版时位于正面的槽有效，可与“特殊孔槽加工面自定义”功能配合使用',
    en: 'This setting only applies to slots on the front side during nesting, and can be used with "Custom definition of machining surfaces for special slots and holes"',
    id: 'Pengaturan ini hanya berlaku untuk slot di sisi depan saat layout, dan dapat digunakan bersama fungsi "Pengaturan permukaan pemotongan khusus untuk slot dan lubang khusus"',
    kz: 'Бұл параметр тек орналастыру кезінде алдыңғы беттегі ойықтарға қолданылады және «Арнайы ойықтар мен тесіктердің өңдеу бетін теңшеу» функциясымен бірге қолданылуы мүмкін',
    th: 'การตั้งค่านี้ใช้ได้เฉพาะกับร่องที่อยู่ด้านหน้าเมื่อจัดวาง และสามารถใช้ร่วมกับฟังก์ชัน "การตั้งค่าพื้นผิวการประมวลผลรูและร่องพิเศษแบบกำหนดเอง"',
    ug: 'بۇ تەڭشەك پەقەت ئورۇنلاشتۇرۇش ۋاقتىدا ئالدى تەرەپتىكى ئارقالارغا كۈچكە ئىگە، «ئالاھىدە تەشىك-ئارقا ئىشلەش تەرەپ ئىختىيارى» ئىقتىدارى بىلەن بىرلىكتە ئىشلىتىشكە بولىدۇ',
    vi: 'Cấu hình này chỉ có hiệu lực với các rãnh nằm ở mặt trước khi xếp bản, có thể dùng kèm chức năng "Định nghĩa tùy chỉnh bề mặt gia công cho khe hố đặc biệt"',
    zh_tc:
      '該設置僅對排版時位於正面的槽有效，可與「特殊孔槽加工面自定義」功能配合使用',
    ru: 'Эта настройка действует только для пазов на лицевой стороне при раскладке и может использоваться вместе с функцией «Настройка поверхности обработки специальных отверстий»',
    ko: '이 설정은 네스팅 시 전면에 위치한 슬롯에만 적용되며, "특수 구멍 슬롯 가공면 사용자화" 기능과 함께 사용할 수 있습니다',
    bur: 'ဤဆက်တင်သည် အစီအစဉ်ချစဉ်တွင် ရှေ့မျက်နှာရှိ ချောင်းများအတွက်သာ သက်ရောက်ပြီး "အထူးအပေါက်ချောင်းပြုမျက်နှာစိတ်ကြိုက်" လုပ်ဆောင်ချက်နှင့် ပူးတွဲအသုံးပြုနိုင်သည်',
    ben: 'এই সেটিং কেবল নেস্টিংয়ের সময় সামনের দিকের স্লটগুলিতে প্রযোজ্য, এবং "বিশেষ স্লট ও হোলের মেশিনিং সারফেস কাস্টম সংজ্ঞা" ফাংশনের সাথে ব্যবহার করা যায়',
    tr: 'Bu ayar yalnızca yerleştirme sırasında ön yüzde bulunan oluklar için geçerlidir ve "Özel delik/oluk işleme yüzeyi özelleştirmesi" işleviyle birlikte kullanılabilir',
    km: 'ការកំណត់នេះមានប្រសិទ្ធភាពតែសម្រាប់រណ្តៅជង្ហុកនៅផ្ទៃខាងមុខពេលរៀបបន្ទះ ហើយអាចប្រើជាមួយមុខងារ "កំណត់ផ្ទៃដំណើរការរណ្តៅ និងរណ្តៅជង្ហុកពិសេសផ្ទាល់ខ្លួន"',
    es: 'Esta configuración solo es válida para ranuras en la cara frontal durante el anidado, y puede usarse junto con la función "Personalización de la superficie de procesamiento de ranura de orificio especial"',
    ar: 'هذا الإعداد يسري فقط على الأخاديد الموجودة على الوجه الأمامي أثناء الترقيم، ويمكن استخدامه مع وظيفة "تخصيص سطح معالجة فتحة ثقب خاص"',
  },
  'cuttingDock.cuttingParams.preventBreakageTip1': {
    zh: '可解决槽位若过于靠近板材边缘，切割时该处的隔断条（即剩余连接部分）会因应力集中而容易断裂的情况',
    en: 'Can solve the situation where the slot is too close to the edge of the panel, and the separator bar (the remaining connection part) at this position will easily break due to stress concentration when cutting',
    id: 'Dapat menyelesaikan situasi di mana slot terlalu dekat dengan tepi panel, dan separator bar (bagian sambungan yang tersisa) pada posisi ini akan mudah patah karena konsentrasi tegangan saat pemotongan',
    kz: 'Ойық тақта жиегіне тым жақын орналасқанда, кесу кезінде сол жердегі бөлімше (қалған байланыс бөлігі) кернеудің шоғырлануынан оңай үзілетін жағдайды шеше алады',
    th: 'สามารถแก้ไขปัญหาที่ร่องอยู่ใกล้ขอบแผ่นมากเกินไป ทำให้ตัวคั่น (ส่วนเชื่อมต่อที่เหลือ) ที่ตำแหน่งนี้แตกหักง่ายเนื่องจากความเค้นกระจุกตัวขณะตัด',
    ug: 'ئارقا تاختا گىرۋىكىگە بەك يېقىن بولغاندا، كېسىش جەريانىدا شۇ ئورۇندىكى ئايرىغۇچ (قالغان ئۇلىنىش قىسمى) كۈچ بېسىمىنىڭ مەركەزلىشىشى سەۋەبىدىن ئاسان ئۈزۈلۈپ كېتىدىغان ئەھۋالنى ھەل قىلالايدۇ',
    vi: 'Có thể giải quyết tình trạng khe hố quá gần cạnh tấm, khiến đoạn liên kết còn lại tại vị trí này dễ bị đứt do tập trung ứng suất khi cắt',
    zh_tc:
      '可解決槽位若過於靠近板材邊緣，切割時該處的隔斷條（即剩餘連接部分）會因應力集中而容易斷裂的情況',
    ru: 'Может решить ситуацию, когда паз слишком близко к краю панели, и перемычка (оставшаяся соединительная часть) в этом месте легко ломается из‑за концентрации напряжений при резке',
    ko: '슬롯이 판재 가장자리에 너무 가까운 경우, 절삭 시 해당 위치의 분리대(남은 연결 부분)가 응력 집중으로 인해 쉽게 끊어지는 문제를 해결할 수 있습니다',
    bur: 'ချောင်းသည် ပျဉ်ပြားအစွန်းနှင့် အလွန်နီးကပ်နေပါက ဖြတ်တောက်စဉ် ထိုနေရာရှိ ခွဲတန်း (ကျန်ရှိသော ချိတ်ဆက်အပိုင်း) သည် ဖိအားစုစည်းမှုကြောင့် အလွယ်တကူ ကျိုးပျက်နိုင်သော အခြေအနေကို ဖြေရှင်းနိုင်သည်',
    ben: 'স্লট প্যানেলের কিনারার খুব কাছে হলে কাটার সময় সেই স্থানের বিভাজক বার (অবশিষ্ট সংযোগ অংশ) চাপের ঘনত্বের কারণে সহজে ভেঙে যাওয়ার সমস্যা সমাধান করতে পারে',
    tr: 'Oluk panel kenarına çok yakın olduğunda, kesim sırasında bu konumdaki ayırıcı çubuğun (kalan bağlantı kısmının) gerilim yoğunlaşması nedeniyle kolayca kırılması sorununu çözebilir',
    km: 'អាចដោះស្រាយបញ្ហានៅពេលរណ្តៅជង្ហុកនៅជិតគែមបន្ទះពេក ហើយពេលកាត់ របារបំបែក (ផ្នែកតភ្ជាប់ដែលនៅសល់) នៅទីតាំងនោះងាយបែកដោយសារការប្រមូលផ្តុំសម្ពាធ',
    es: 'Puede resolver la situación en la que la ranura está demasiado cerca del borde del panel y, al cortar, la barra separadora (la parte de conexión restante) en esa posición se rompe fácilmente por concentración de tensiones',
    ar: 'يمكن حل حالة اقتراب الأخدود كثيرًا من حافة اللوح، حيث ينكسر الفاصل (الجزء المتبقي من الوصلة) في ذلك الموضع بسهولة بسبب تركز الإجهاد أثناء القطع',
  },
  'cuttingDock.cuttingParams.preventBreakageDistance': {
    zh: '距板件边缘',
    en: 'Distance from Panel Edge',
    id: 'Jarak dari Tepi Panel',
    kz: 'Тақта жиегінен қашықтық',
    th: 'ระยะห่างจากขอบแผ่น',
    ug: 'تاختا گىرۋىكىگە بولغان ئارلىق',
    vi: 'Khoảng cách từ cạnh tấm',
    zh_tc: '距板件邊緣',
    ru: 'Расстояние от края панели',
    ko: '판재 가장자리까지의 거리',
    bur: 'ပျဉ်ပြားအစွန်းမှအကွာအဝေး',
    ben: 'প্যানেল প্রান্ত থেকে দূরত্ব',
    tr: 'Panel kenarından mesafe',
    km: 'ចម្ងាយពីគែមបន្ទះ',
    es: 'Distancia al borde del panel',
    ar: 'المسافة من حافة اللوح',
  },
  'cuttingDock.cuttingParams.preventBreakageLength': {
    zh: '靠边部分长度',
    en: 'Edge Section Length',
    id: 'Panjang Bagian Tepi',
    kz: 'Жиекке жақын бөліктің ұзындығы',
    th: 'ความยาวส่วนชิดขอบ',
    ug: 'گىرۋەككە يېقىن قىسىمنىڭ ئۇزۇنلۇقى',
    vi: 'Chiều dài phần sát cạnh',
    zh_tc: '靠邊部分長度',
    ru: 'Длина прикромочного участка',
    ko: '가장자리 구간 길이',
    bur: 'အစွန်းနီးအပိုင်းအရှည်',
    ben: 'প্রান্তবর্তী অংশের দৈর্ঘ্য',
    tr: 'Kenara yakın bölüm uzunluğu',
    km: 'ប្រវែងផ្នែកជិតគែម',
    es: 'Longitud de la sección del borde',
    ar: 'طول الجزء المحاذي للحافة',
  },
  'cuttingDock.cuttingParams.preventBreakageSlot': {
    zh: '的槽',
    en: 'slots',
    id: 'slot',
    kz: 'ойықтар',
    th: 'ร่อง',
    ug: 'ئارقا',
    vi: 'rãnh',
    zh_tc: '的槽',
    ru: 'пазы',
    ko: '슬롯',
    bur: 'ချောင်း',
    ben: 'স্লট',
    tr: 'oluklar',
    km: 'រណ្តៅជង្ហុក',
    es: 'ranuras',
    ar: 'أخاديد',
  },
  'cuttingDock.cuttingParams.preventBreakageCutDeep': {
    zh: '首次切割深度',
    en: 'First Cut Depth',
    id: 'Kedalaman Potongan Pertama',
    kz: 'Алғашқы кесу тереңдігі',
    th: 'ความลึกการตัดครั้งแรก',
    ug: 'تۇنجى كېسىش چوڭقۇرلۇقى',
    vi: 'Độ sâu cắt lần đầu',
    zh_tc: '首次切削深度',
    ru: 'Глубина первого реза',
    ko: '최초 절삭 깊이',
    bur: 'ပထမအကြိမ်ဖြတ်အနက်',
    ben: 'প্রথম কাটের গভীরতা',
    tr: 'İlk kesim derinliği',
    km: 'ជម្រៅកាត់លើកដំបូង',
    es: 'Profundidad del primer corte',
    ar: 'عمق القطع الأول',
  },
  'cuttingDock.cuttingParams.workSpeedOp': {
    zh: '加工速度优化',
    en: 'Processing Speed Optimization',
    id: 'Kecepatan pemrosesan yang dioptimalkan',
    kz: 'Кесу жылдамдығіні оңтайландыру',
    th: 'ความเร็วในการประมวลผลที่ดีที่สุด',
    ug: 'ئىشلەش سۈرئىتى ئۈنۈملۈك تەڭشەش',
    vi: 'Tối ưu hóa tốc độ gia công',
    zh_tc: '加工速度優化',
    ru: 'Оптимизация скорости обработки',
    ko: '가공 속도 최적화',
    bur: 'ပြုပြင်အမြန်နှုန်းအကောင်းဆုံးဖြစ်အောင်',
    ben: 'প্রসেসিং স্পিড অপ্টিমাইজেশন',
    tr: 'İşlem hızı optimizasyonu',
    km: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
    es: 'Optimización de la velocidad de procesamiento',
    ar: 'تحسين سرعة المعالجة',
  },
  'cuttingDock.cuttingParams.obliqueCut': {
    zh: '切割时斜下刀',
    en: 'Oblique Downward Cutting During Cutting',
    id: 'Memotong ujung tombak',
    kz: 'Кесу кезінде кесу қанатты басталу',
    th: 'ตัดขอบตัดลง',
    ug: 'قېپىشتە ئېگىل پىچاق',
    vi: 'Cắt bằng dao nghiêng',
    zh_tc: '切割時斜下刀',
    ru: 'Наклонить нож при резке',
    ko: '가공 시 바이트 각도',
    bur: 'ဖြတ်သည့်အခါဓားစောင်းချ',
    ben: 'কাটার সময় অবলিক ডাউনওয়ার্ড কাটিং',
    tr: 'Kesimde eğik aşağı inme',
    km: 'កាត់ចុះអាក្សត់ពេលកាត់',
    es: 'Cuchilla inclinada durante el corte',
    ar: 'السكين المائل أثناء القطع',
  },
  'cuttingDock.cuttingParams.obliqueCutTip': {
    zh: '未指定板厚时，则对所有板厚小板生效',
    en: 'When the plate thickness is not specified, it takes effect for all plate thickness small plates',
    id: 'Ketika ketebalan papan tidak ditentukan, efektif untuk semua ketebalan papan kecil',
    kz: 'Плита қалыңдығы белгісіз болса, барлық плита қалыңдығы кіші плиталар үшін әсер етеді',
    th: 'เมื่อความหนาของแผ่นไม้ไม่ระบุ จะมีผลต่อทุกความหนาของแผ่นไม้',
    ug: 'پلات қалыңдығы белгісіз болса, барлық плита қалыңдығы кіші плиталар үшін әсер етеді',
    vi: 'Khi chiều dày của tấm không được xác định, hiệu lực cho tất cả các tấm có chiều dày nhỏ',
    zh_tc: '未指定板厚時，則對所有板厚小板生效',
    ru: 'Когда толщина плиты не указана, она действует для всех плит с толщиной меньше',
    ko: '판재 두께가 지정되지 않은 경우, 모든 판재 두께가 작은 판재에 적용됩니다',
    bur: 'ဓားစောင်းအမြန်နှုန်းအကောင်းဆုံးဖြစ်အောင်',
    ben: 'কাটিং স্পিড অপ্টিমাইজেশন',
    tr: 'Eğik aşağı inme hızı optimizasyonu',
    km: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
    es: 'Cuando el espesor de la placa no está especificado, se aplica a todas las placas con espesor menor',
    ar: 'عندما لا يتم تحديد سمك اللوح، فإنه ينطبق على جميع الألواح ذات السمك الأصغر',
  },
  'cuttingDock.cuttingParams.obliqueThickLabel': {
    zh: '自定义斜下刀生效板厚',
    en: 'Custom Oblique Cutting Effective Thickness',
    id: 'Ketebalan efektif pemotongan miring yang disesuaikan',
    kz: 'Кесу қанатты басталудың тиімді қалыңдығын өзгерту',
    th: 'ความหนาที่มีผลของการตัดลงที่กำหนดเอง',
    ug: 'ئىختىيارىي ئېگىل پىچاق ئۈنۈملۈك تاختا قېلىنلىقى',
    vi: 'Chiều dày hiệu lực cắt nghiêng tùy chỉnh',
    zh_tc: '自定義斜下刀生效板厚',
    ru: 'Пользовательская эффективная толщина наклонного реза',
    ko: '사용자 지정 사선 하향 커팅 유효 판재 두께',
    bur: 'စိတ်ကြိုက်ဓားစောင်းအကျိုးသက်ရောက်သောပျဉ်အထူ',
    ben: 'কাস্টম অবলিক কাটিং কার্যকর প্লেট বেধ',
    tr: 'Özel eğik aşağı inme etkili levha kalınlığı',
    km: 'កម្រាស់បន្ទះមានប្រសិទ្ធភាពនៃការកាត់ទ្រេតផ្ទាល់ខ្លួន',
    es: 'Espesor efectivo personalizado para corte oblicuo',
    ar: 'سمك اللوح الفعال المخصص للقطع المائل',
  },
  'cuttingDock.cuttingParams.obliqueThick': {
    zh: '自定义斜下刀生成的板件厚度',
    en: 'Custom Oblique Cutting Thickness',
    id: 'Ketebalan pemotongan miring yang disesuaikan',
    kz: 'Кесу қанатты басталу қалыңдығын өзгерту',
    th: 'ความหนาของการตัดลงที่กำหนดเอง',
    ug: 'قېپىشتە ئېگىل پىچاق قېتىلىشى',
    vi: 'Chiều dày cắt nghiêng tùy chỉnh',
    zh_tc: '自定義斜下刀生成的板件厚度',
    ru: 'Изменение толщины наклонного реза',
    ko: '베벨 커스텀 머시닝 속도',
    bur: 'ဓားစောင်းအမြန်နှုန်းအကောင်းဆုံးဖြစ်အောင်',
    ben: 'অবলিক কাটিং স্পিড অপ্টিমাইজেশন',
    tr: 'Eğik aşağı inme hızı optimizasyonu',
    km: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
  },
  'cuttingDock.cuttingParams.backObliqueThick': {
    zh: '自定义反面修边斜下刀的板件厚度',
    en: 'Custom Backside Trimming Oblique Cutting Thickness',
    id: 'Ketebalan pemotongan miring yang disesuaikan',
    kz: 'Арқалық кесуде кесу қанатты басталу қалыңдығын өзгерту',
    th: 'ความหนาของการตัดลงที่กำหนดเอง',
    ug: 'ئارقا چېگرا ئېگىل پىچاق قېتىلىشى',
    vi: 'Chiều dày cắt nghiêng tùy chỉnh',
    zh_tc: '自定義反面修边斜下刀的板件厚度',
    ru: 'Изменение толщины наклонного реза',
    ko: '베벨 커스텀 머시닝 속도',
    bur: 'ဓားစောင်းအမြန်နှုန်းအကောင်းဆုံးဖြစ်အောင်',
    ben: 'অবলিক কাটিং স্পিড অপ্টিমাইজেশন',
    tr: 'Eğik aşağı inme hızı optimizasyonu',
    km: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
  },
  'cuttingDock.cuttingParams.effectiveThickness': {
    zh: '生效厚度',
    en: 'Effective Thickness',
    id: 'Ketebalan efektif',
    kz: 'Қанатты басталу қалыңдығы',
    th: 'ความหนาที่มีผล',
    ug: 'ئېگىل پىچاق قېتىلىشى',
    vi: 'Chiều dày hiệu quả',
    zh_tc: '生效厚度',
    ru: 'Эффективная толщина',
    ko: '효과적인 두께',
    bur: 'အနှုန်းအကောင်းဆုံးဖြစ်အောင်',
    ben: 'কাটিং স্পিড অপ্টিমাইজেশন',
    tr: 'Eğik aşağı inme hızı optimizasyonu',
    km: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការ',
  },
  'cuttingDock.cuttingParams.effectiveThicknessTip': {
    zh: '生效厚度不能为空，请输入！',
    en: 'Effective Thickness cannot be empty, please enter!',
    id: 'Ketebalan efektif tidak boleh kosong, silakan masukkan!',
    kz: 'Қанатты басталу қалыңдығы болуы керек, қою!',
    th: 'ความหนาที่มีผลไม่สามารถว่างได้, กรุณาป้อน!',
    ug: 'ئېگىل پىچاق قېتىلىشى بولمايدۇ, كىرىش!',
    vi: 'Chiều dày hiệu quả không được để trống, vui lòng nhập!',
    zh_tc: '生效厚度不能為空，請輸入！',
    ru: 'Эффективная толщина не может быть пустой, пожалуйста, введите!',
    ko: '효과적인 두께는 비어있을 수 없습니다, 입력해주세요!',
    bur: 'အနှုန်းအကောင်းဆုံးဖြစ်အောင်မှားနိုင်ပါသည်, ရိုက်ထည့်ပါ!',
    ben: 'কাটিং স্পিড অপ্টিমাইজেশন হতে পারে না, প্রবেশ করুন!',
    tr: 'Eğik aşağı inme hızı optimizasyonu boş olamaz, lütfen giriniz!',
    km: 'ការបង្កើនប្រសិទ្ធភាពល្បឿនដំណើរការមិនអាចជ្រើសរើសគ្នាទេ, សូមបញ្ចូល!',
  },
  'cuttingDock.cuttingParams.effectiveThicknessDuplicateTip': {
    zh: '生效厚度不能重复，请修改',
    en: 'Effective thickness cannot be duplicated, please modify',
    id: 'Ketebalan efektif tidak boleh duplikat, silakan ubah',
    kz: 'Қанатты басталу қалыңдығы қайталанбауы керек, өзгертіңіз',
    th: 'ความหนาที่มีผลต้องไม่ซ้ำกัน กรุณาแก้ไข',
    ug: 'ئېگىل پىچاق قېتىلىشى تەكرار بولمايدۇ، ئۆزگەرتىڭ',
    vi: 'Chiều dày hiệu quả không được trùng lặp, vui lòng sửa',
    zh_tc: '生效厚度不能重複，請修改',
    ru: 'Эффективная толщина не может повторяться, измените значение',
    ko: '효과적인 두께는 중복될 수 없습니다. 수정해 주세요',
    bur: 'အနှုန်းအကောင်းဆုံးဖြစ်အောင်ထံမဖြစ်ရပါ၊ ပြင်ဆင်ပါ',
    ben: 'কার্যকর পুরুত্ব ডুপ্লিকেট হতে পারে না, সংশোধন করুন',
    tr: 'Etkin kalınlık tekrarlanamaz, lütfen düzenleyin',
    km: 'កម្រាស់មានប្រសិទ្ធមិនអាចស្ទួនគ្នា សូមកែប្រែ',
  },
  'cuttingDock.cuttingParams.obliqueCutData': {
    zh: '斜下刀距离',
    en: 'Oblique Downward Cutting Distance',
    id: 'Jarak potong miring ke bawah',
    kz: 'Қиғаш төмен қию қашықтығы',
    th: 'ระยะตัดเฉียงลง',
    ug: 'ئېگىل تۆۋەن پىچاق ئارىلىقى',
    vi: 'Khoảng cách cắt nghiêng xuống',
    zh_tc: '斜下刀距離',
    ru: 'Расстояние наклонного врезания',
    ko: '사선 하강 거리',
    bur: 'ဓားစောင်းအကွာအဝေး',
    ben: 'তির্যক নিম্নমুখী কাটিং দূরত্ব',
    tr: 'Eğik aşağı inme mesafesi',
    km: 'ចម្ងាយចុះអាក្សត់',
    es: 'Distancia de la cuchilla inclinada',
    ar: 'مسافة السكين المائلة',
  },
  'cuttingDock.cuttingParams.backOblique': {
    zh: '反面修边斜下刀',
    en: 'Oblique Downward Cutting for Backside Trimming',
    id: 'Membalikkan pemangkasan secara diagonal diturunkan',
    kz: 'Арқалық кесуде кесу қанатты басталу',
    th: 'ลดการตัดทอนลงในแนวทแยงมุม',
    ug: 'ئارقا چېگرا ئېگىل پىچاق',
    vi: 'Điều chỉnh cạnh bằng dao nghiêng ở mặt sau',
    zh_tc: '反面修邊斜下刀',
    ru: 'Наклонение боковой кромки',
    ko: '뒷면 트림 각도 각도',
    bur: 'အနောက်မျက်နှာအစွန်းပြင်ဓားစောင်းချ',
    ben: 'পিছনের দিক ট্রিমিংয়ের জন্য অবলিক ডাউনওয়ার্ড কাটিং',
    tr: 'Arka yüz kenar düzeltmede eğik aşağı inme',
    km: 'កាត់ចុះអាក្សត់កែគែមផ្ទៃក្រោយ',
    es: 'Cuchilla inclinada para el corte posterior',
    ar: 'السكين المائل للتقليم الخلفي',
  },
  'cuttingDock.cuttingParams.obliqueSpeed': {
    zh: '斜下刀速度',
    en: 'Oblique Cutting Speed',
    id: 'Kecepatan down-down',
    kz: 'Кесу қанатты басталу жылдамдығы',
    th: 'ความเร็วลง',
    ug: 'ئېگىل پىچاق سۈرئىتى',
    vi: 'Tốc độ cắt bằng dao nghiêng',
    zh_tc: '斜下刀速度',
    ru: 'Скорость наклона',
    ko: '사선 속도',
    bur: 'ဓားစောင်းအမြန်နှုန်း',
    ben: 'অবলিক কাটিং স্পিড',
    tr: 'Eğik aşağı inme hızı',
    km: 'ល្បឿនចុះអាក្សត់',
    es: 'Velocidad de la cuchilla inclinada',
    ar: 'سرعة السكين المائلة',
  },
  'cuttingDock.cuttingParams.obliqueSpeedTip': {
    zh: '切割下料和反面修边',
    en: 'Cutting down and backside trimming',
    id: 'Pemotongan dan pemangkasan sisi belakang',
    kz: 'Қию және арқалық кесу',
    th: 'ตัดลบลงและตัดทอนหน้าข้าง',
    ug: 'ئېگىل پىچاق كەسىش چۈشۈش',
    vi: 'Cắt xuống và điều chỉnh cạnh bằng dao nghiêng',
    zh_tc: '切割下料和反面修邊',
    ru: 'Скорость наклона',
    ko: '사선 속도',
    bur: 'ဓားစောင်းအမြန်နှုန်း',
    ben: 'অবলিক কাটিং স্পিড',
    tr: 'Eğik aşağı inme hızı',
    km: 'ល្បឿនចុះអាក្សត់',
    es: 'Velocidad de la cuchilla inclinada',
    ar: 'سرعة السكين المائلة',
  },
  'cuttingDock.cuttingParams.arcSpeed': {
    zh: '曲线加工速度',
    en: 'Curve Processing Speed',
    id: 'Kecepatan pemesinan kurva',
    kz: 'Арқалық кесу жылдамдыгі',
    th: 'ความเร็วการตัดเฉือนโค้ง',
    ug: 'قىيپىس ئىشلەش سۈرئىتى',
    vi: 'Tốc độ gia công đường cong',
    zh_tc: '曲線加工速度',
    ru: 'Скорость обработки кривых',
    ko: '커브 머시닝 속도',
    bur: 'မျဉ်းကွေးပြုပြင်အမြန်နှုန်း',
    ben: 'কার্ভ প্রসেসিং স্পিড',
    tr: 'Eğri işleme hızı',
    km: 'ល្បឿនដំណើរការខ្សែកោង',
    es: 'Velocidad de procesamiento de la curva',
    ar: 'سرعة المعالجة المنحنية',
  },
  'cuttingDock.cuttingParams.cuttingPreDistance': {
    zh: '下刀提前距离',
    en: 'Distance to Advance Before Cutting',
    id: 'Keluar dari pisau sebelumnya',
    kz: 'Кесу алдын ала қашықтығы',
    th: 'ออกจากมีดล่วงหน้า',
    ug: 'پىچاق چۈشۈش ئالدىدىن ماسىپا',
    vi: 'Khoảng cách cắt trước',
    zh_tc: '下刀提前距離',
    ru: 'Расстояние до выхода ножа',
    ko: '칼을 내려 거리를 앞당기다',
    bur: 'ဓားချမတိုင်မီအကွာအဝေး',
    ben: 'কাটার আগে অ্যাডভান্স দূরত্ব',
    tr: 'Kesimden önce bıçak öne alma mesafesi',
    km: 'ចម្ងាយដាក់ឧបករណ៍កាត់មុនពេលកាត់',
    es: 'Distancia de avance del cortador',
    ar: 'مسافة تقدم القاطع',
  },
  'cuttingDock.cuttingParams.backKnife': {
    zh: '切割收刀减速',
    en: 'Deceleration Before Cutting Ends',
    id: 'Memotong pisau untuk mengurangi kecepatan',
    kz: 'Кесудің соққысын төмендету',
    th: 'ตัดมีดเพื่อลดความเร็ว',
    ug: 'قېپىش پىچاق تۆۋەندىتىش',
    vi: 'Tốc độ giảm tốc khi thu dao',
    zh_tc: '切割收刀減速',
    ru: 'редуктор резания',
    ko: '절단 커터 감속',
    bur: 'ဖြတ်ဓားကောက်နှေးမှု',
    ben: 'কাটিং শেষের আগে ডিসেলারেশন',
    tr: 'Kesimde bıçak çekme yavaşlatma',
    km: 'យឺតពេលទាញឧបករណ៍កាត់ចេញពីការកាត់',
    es: 'Desaceleración de la retracción del corte',
    ar: 'تباطؤ تراجع القطع',
  },
  'cuttingDock.cuttingParams.openKnifeSpeed': {
    zh: '收刀速度',
    en: 'Speed for Cutting End',
    id: 'Kecepatan pengumpulan pisau',
    kz: 'Соққысын ашу жылдамдыгі',
    th: 'ความเร็วในการรวบรวมมีด',
    ug: 'پىچاق تۆۋەندىتىش سۈرئىتى',
    vi: 'Tốc độ thu dao',
    zh_tc: '收刀速度',
    ru: 'Скорость захвата',
    ko: '칼을 거두는 속도',
    bur: 'ဓားကောက်အမြန်နှုန်း',
    ben: 'কাটিং এন্ডের জন্য স্পিড',
    tr: 'Bıçak çekme hızı',
    km: 'ល្បឿនទាញឧបករណ៍កាត់',
    es: 'Velocidad de retracción del cortador',
    ar: 'القاطع سرعة التراجع',
  },
  'cuttingDock.cuttingParams.retractionCompensation': {
    zh: '切割收刀距离补偿',
    en: 'Retraction Compensation',
    id: 'Kompensasi pengambilan pisau',
    kz: 'Кесу соққысының төмендету',
    th: 'การปรับปรุงการตัดมีด',
    ug: 'قېپىش پىچاق تۆۋەندىتىش',
    vi: 'قېپىش پىچاق تۆۋەندىتىش',
    zh_tc: '切割收刀距離補償',
    ru: 'компенсация расстояния резания',
    ko: '가공 마무리 거리 보정',
    bur: 'ဖြတ်ဓားကောက်အကွာအဝေးပြန်လည်ထူထောင်',
    ben: 'রিট্র্যাকশন কমপেনসেশন',
    tr: 'Kesim bıçak çekme mesafesi telafisi',
    km: 'ការសងចម្ងាយទាញឧបករណ៍កាត់',
    es: 'Compensación de distancia de retracción de corte',
    ar: 'تعويض مسافة تراجع القطع',
  },
  'cuttingDock.cuttingParams.retractionCompensationTip': {
    zh: '最大值20',
    en: 'Maximum value 20',
    id: 'Nilai maksimum 20',
    kz: 'Мәні ең үлкен 20',
    th: 'ค่าสูงสุด 20',
    ug: 'قېلىنلىقى ئەڭ يۈزى 20',
    vi: 'Giá trị tối đa 20',
    zh_tc: '最大值20',
    ru: 'Максимальное 20',
    ko: '최대 20',
    bur: 'အများဆုံးတန်ဖိုး၂၀',
    ben: 'সর্বোচ্চ মান ২০',
    tr: 'Maksimum değer 20',
    km: 'តម្លៃអតិបរមា ២០',
    es: 'Valor máximo 20',
    ar: 'القيمة القصوى 20',
  },
  'cuttingDock.cuttingParams.cutCornerSlow': {
    zh: '切割转角减速',
    en: 'Deceleration When Cutting Corners',
    id: 'Pengurangan sudut pemotongan',
    kz: 'Бұрыштар кесуде жылдамдыгі төмендету',
    th: 'การลดมุมตัด',
    ug: 'قېپىش بۇلۇڭ تۆۋەندىتىش',
    vi: 'Tốc độ giảm tốc khi cắt góc',
    zh_tc: '切割轉角減速',
    ru: 'замедление по углу резки',
    ko: '절단 모서리 감속',
    bur: 'ဖြတ်ထောင့်နှေးမှု',
    ben: 'কাটিং কর্নারে ডিসেলারেশন',
    tr: 'Kesim köşesinde yavaşlatma',
    km: 'យឺតនៅមុំកាត់',
    es: 'Desaceleración de esquina de corte',
    ar: 'تباطؤ زاوية القطع',
  },
  'cuttingDock.cuttingParams.addRow': {
    zh: '新增',
    en: 'Add row',
    id: 'Baru',
    kz: 'Қосымша',
    th: 'ใหม่',
    ug: 'يېڭى قۇر قوشۇش',
    vi: 'Thêm mới',
    zh_tc: '新增',
    ru: 'добавленный',
    ko: '추가',
    bur: 'အသစ်ထည့်',
    ben: 'সারি যোগ করুন',
    tr: 'Satır ekle',
    km: 'បន្ថែមជួរ',
    es: 'Se agregó',
    ar: 'تمت إضافة',
  },
  'cuttingDock.cuttingParams.bettwenDistance': {
    zh: '转角前后距离',
    en: 'Distance Before and After Corners',
    id: 'Jarak sebelum dan sesudah sudut',
    kz: 'Бұрыштардың алды-артқыштарі',
    th: 'ระยะทางก่อนและหลังมุม',
    ug: 'بۇلۇڭ ئالدى-ئارقا ماسىپا',
    vi: 'Khoảng cách trước và sau góc',
    zh_tc: '轉角前後距離',
    ru: 'Расстояние до и после поворота',
    ko: '모퉁이 전후 거리',
    bur: 'ထောင့်ရှေ့နောက်အကွာအဝေး',
    ben: 'কর্নারের আগে ও পরের দূরত্ব',
    tr: 'Köşe öncesi ve sonrası mesafe',
    km: 'ចម្ងាយមុន និងក្រោយមុំ',
    es: 'Distancia antes y después de la esquina',
    ar: 'المسافة قبل وبعد الزاوية',
  },
  'cuttingDock.cuttingParams.cuttingSpeed': {
    zh: '切割速度',
    en: 'Cutting Speed',
    id: 'Kecepatan pemotongan',
    kz: 'Кесу жылдамдыгі',
    th: 'ความเร็วในการตัด',
    ug: 'قېپىش سۈرئىتى',
    vi: 'Tốc độ cắt',
    zh_tc: '切割速度',
    ru: 'Скорость резания',
    ko: '절단 속도',
    bur: 'ဖြတ်အမြန်နှုန်း',
    ben: 'কাটিং স্পিড',
    tr: 'Kesim hızı',
    km: 'ល្បឿនកាត់',
    es: 'Velocidad de corte',
    ar: 'سرعة القطع',
  },
  'cuttingDock.cuttingParams.stepCutting': {
    zh: '分层切割',
    en: 'Layer Cut',
    id: 'Pemotongan berlapis',
    kz: 'Қатламдық кесу',
    th: 'การตัดชั้น',
    ug: 'قاتلام قېپىش',
    vi: 'Cắt tầng',
    zh_tc: '分層切割',
    ru: 'Слойная резка',
    ko: '계층형 컷',
    bur: 'အလွှာခွဲဖြတ်',
    ben: 'লেয়ার্ড কাটিং',
    tr: 'Katmanlı kesim',
    km: 'កាត់ជាស្រទាប់',
    es: 'Corte en capas',
    ar: 'القطع متعدد الطبقات',
  },
  'cuttingDock.cuttingParams.splitSlot': {
    zh: '槽切割两次',
    en: 'Cut Slots in Two Steps',
    id: 'Potong alur dua kali',
    kz: 'Ойықтық екі рет кесу',
    th: 'ตัดร่องสองครั้ง',
    ug: 'ئارقا قېپىش ئىككى قېتىم',
    vi: 'Cắt khe hai lần',
    zh_tc: '槽切割兩次',
    ru: 'Дважды разрезать.',
    ko: '슬롯 두 번 절단',
    bur: 'ချောင်းနှစ်ကြိမ်ဖြတ်',
    ben: 'স্লট দুই ধাপে কাটুন',
    tr: 'Oluk iki aşamada kesilir',
    km: 'កាត់រណ្តៅជង្ហុកពីរដំណាក់កាល',
    es: 'Corte de ranura dos veces',
    ar: 'قطع الأخدود مرتين',
  },
  'cuttingDock.cuttingParams.splitPlank': {
    zh: '的小板切割两次',
    en: 'Cut Small Boards Twice',
    id: 'Potong papan kecil dua kali',
    kz: 'Кіші панельдің екі рет кесуі',
    th: 'การตัดจานเล็ก ๆ สองครั้ง',
    ug: 'قېپىش ئىككى قېتىم تاختىنىڭ قېپىشى',
    vi: 'của tấm nhỏ cắt hai lần',
    zh_tc: '的小板切割兩次',
    ru: 'Порезать доску дважды.',
    ko: '의 보드를 두 번 절단합니다.',
    bur: 'ပေါ်ဒ်ငယ်နှစ်ကြိမ်ဖြတ်',
    ben: 'ছোট বোর্ড দুইবার কাটুন',
    tr: 'küçük plakayı iki kez kes',
    km: 'កាត់ផ្ទាំងតូចពីរដង',
    es: 'La placa pequeña se corta dos veces',
    ar: 'يتم قطع اللوحة الصغيرة مرتين',
  },
  'cuttingDock.cuttingParams.splitPlank2': {
    zh: '小板切割两次',
    en: 'Cut Small Boards Twice',
    id: 'Potong papan kecil dua kali',
    kz: 'Кіші панельдің екі рет кесуі',
    th: 'การตัดจานเล็ก ๆ สองครั้ง',
    ug: 'قېپىش ئىككى قېتىم تاختىنىڭ قېپىشى',
    vi: 'tấm nhỏ cắt hai lần',
    zh_tc: '小板切割兩次',
    ru: 'Отрежьте доску дважды.',
    ko: '판자를 두 번 절단하다.',
    bur: 'ပေါ်ဒ်ငယ်နှစ်ကြိမ်ဖြတ်',
    ben: 'ছোট বোর্ড দুইবার কাটুন',
    tr: 'Küçük plakayı iki kez kes',
    km: 'កាត់ផ្ទាំងតូចពីរដង',
    es: 'La placa pequeña se corta dos veces',
    ar: 'يتم قطع اللوحة الصغيرة مرتين',
  },
  'cuttingDock.cuttingParams.minSafeThick': {
    zh: '厚度大于',
    en: 'Thickness Greater Than',
    id: 'Ketebalan lebih besar dari',
    kz: 'Қалыңдығы көп',
    th: 'ความหนามากกว่า',
    ug: 'تاختى ئىككى قېتىم',
    vi: 'Độ dày lớn hơn',
    zh_tc: '厚度大於',
    ru: 'Толщина больше',
    ko: '두께 초과',
    bur: 'အထူသည်ထို့ထက်ကြီး',
    ben: 'বেধ এর চেয়ে বড়',
    tr: 'Kalınlık şundan büyük',
    km: 'កម្រាស់ធំជាង',
    es: 'El espesor es mayor que',
    ar: 'السمك أكبر من',
  },
  'cuttingDock.cuttingParams.splitPlankTip': {
    zh: '（异形板件不生效此功能）',
    en: '(Irregular boards do not take effect for this feature)',
    id: '（Papan tidak berbentuk khusus tidak berlaku untuk fungsi ini）',
    kz: '（Құрамды панельдің кесуде қолданылмайды）',
    th: '（จานพิเศษไม่มีผลกับฟังก์ชั่นนี้）',
    ug: '（ئارقا قېپىش ئىككى قېتىم）',
    vi: '（Tấm hình dạng đặc biệt không có hiệu lực cho chức năng này）',
    zh_tc: '（異形板件不生效此功能）',
    ru: '(Эта функция не действует на фасонных панелях)',
    ko: '(이형 보드에는 적용되지 않음)',
    bur: '(အသွင်းပြားတွင်မသက်ရောက်)',
    ben: '(অনিয়মিত বোর্ডে এই ফিচার প্রযোজ্য নয়)',
    tr: '(Anormal şekilli plakalarda bu işlev geçerli değildir)',
    km: '(មុខងារនេះមិនអនុវត្តលើផ្ទាំងរូបរាងមិនធម្មតា)',
    es: '(esta función no tiene efecto para placas con formas especiales)',
    ar: '(لا تسري هذه الوظيفة على الألواح ذات الشكل الخاص)',
  },
  'cuttingDock.cuttingParams.splitPlankTip2': {
    zh: '（不兼容：收刀补偿）',
    en: '(Incompatible: Knife Compensation)',
    id: '(Tidak kompatibel: Pengimbangan Pisau)',
    kz: '(Қамтамасыз етілмейді: Кесу кезіндегі қалдық кесімі)',
    th: '(ไม่สามารถใช้งานได้: ความสูญเสียของการตัด)',
    ug: '(Қамтамасыз етілмейді: Кесу кезіндегі қалдық кесімі)',
    vi: '(Không tương thích: Bù phần trả về)',
    zh_tc: '（不兼容：收刀補償）',
    ru: '(Несовместимо: компенсация резания)',
    ko: '(호환되지 않음: 커팅 커팅 보상)',
    bur: '(မကောင်းမွန်သည်: ကံပြန်လည်ချိန်ဆက်မှု)',
    ben: '(অসমর্থ: কাটিং কাটিং প্রতিফল)',
    tr: '(Uyumsuz: Kesim bıçak çekme ödemesi)',
    km: '(មិនត្រូវបានប្រើ: កាត់លើកលើកការផ្ទាល់ខ្ទង់)',
    es: '(No compatible: compensación de cierre de cuchilla)',
    ar: '(غير متوافق: تعويض القطعة)',
  },
  'cuttingDock.cuttingParams.cutPlankMethod': {
    zh: '切板方式',
    en: 'Cut Plank Method',
    id: 'Metode pemotongan papan',
    kz: 'Панельдің кесу әдісі',
    th: 'วิธีการตัดจาน',
    ug: 'قېپىش قېتىم قېپىش әдісі',
    vi: 'Cách cắt tấm',
    zh_tc: '切板方式',
    ru: 'Метод резки панели',
    ko: '판자 자르기 방법',
    bur: 'ပေါ်ဒ်ငယ်နှစ်ကြိမ်ဖြတ်',
    ben: 'ছোট বোর্ড দুইবার কাটুন',
    tr: 'Küçük plakayı iki kez kes',
    km: 'កាត់ផ្ទាំងតូចពីរដង',
    es: 'La placa pequeña se corta dos veces',
    ar: 'يتم قطع اللوحة الصغيرة مرتين',
  },
  'cuttingDock.cuttingParams.cutPlankMethodTip': {
    zh: '四边切两次',
    en: 'Four Sides Cut Twice',
    id: 'Potong empat sisi dua kali',
    kz: 'Төрт қабырғасынан кесу',
    th: 'ตัดสี่ด้านสองครั้ง',
    ug: 'قېپىش ئىككى قېتىم تاختىنىڭ قېپىشى',
    vi: 'Cắt bốn cạnh hai lần',
    zh_tc: '四邊切兩次',
    ru: 'Резка четырех сторон дважды',
    ko: '네 면을 두 번 자르다',
    bur: 'လေးနှစ်ကြိမ်ဖြတ်',
    ben: 'চার দিক দুইবার কাটুন',
    tr: 'Dört tarafı iki kez kes',
    km: 'កាត់រណ្តៅជង្ហុកពីរដំណាក់កាល',
    es: 'La placa se corta dos veces en los cuatro lados',
    ar: 'يتم قطع اللوحة مرتين في الأربعة أضلاع',
  },
  'cuttingDock.cuttingParams.cutPlankMethodTip2': {
    zh: '仅最后一条边切两次',
    en: 'Only the last side cut twice',
    id: 'Hanya sisi terakhir yang dipotong dua kali',
    kz: 'Соңғы қабырғасынан кесу',
    th: 'เฉพาะด้านสุดท้ายที่ตัดสองครั้ง',
    ug: 'قېپىش ئىككى قېتىم تاختىنىڭ قېپىشى',
    vi: 'Chỉ cắt một cạnh cuối và hai lần',
    zh_tc: '僅最後一條邊切兩次',
    ru: 'Резка только последнего края дважды',
    ko: '마지막 변만 한 번 자르고 두 번 자르다',
    bur: 'နောက်ဆုံးနှစ်ကြိမ်ဖြတ်',
    ben: 'শেষ বাহু একবার কাটুন এবং দুইবার কাটুন',
    tr: 'Son kenardan bir kez ve iki kez kes',
    km: 'កាត់រណ្តៅជង្ហុកពីរដំណាក់កាល',
    es: 'La placa se corta dos veces en el último lado',
    ar: 'يتم قطع اللوحة مرتين في الضلع الأخير',
  },
  'cuttingDock.cuttingParams.specialShapCut': {
    zh: '异形板件切两次',
    en: 'Special Shape Cutting Twice',
    id: 'Potong piring khusus dua kali',
    kz: 'Құрамды панель екі рет кесу',
    th: 'ตัดจานพิเศษสองครั้ง',
    ug: 'ئارقا قېپىش ئىككى قېتىم',
    vi: 'Cắt tấm hình dạng đặc biệt hai lần',
    zh_tc: '異形板件切兩次',
    ru: 'Отрезать фасонную пластину дважды',
    ko: '이형판 부품을 두 번 자르다',
    bur: 'အသွင်းပြားနှစ်ကြိမ်ဖြတ်',
    ben: 'বিশেষ শেপ দুইবার কাটুন',
    tr: 'Anormal şekilli plaka iki kez kesilir',
    km: 'កាត់ផ្ទាំងរូបរាងមិនធម្មតាពីរដង',
    es: 'La placa con formas especiales se corta dos veces',
    ar: 'يتم قطع اللوحة ذات الشكل الخاص مرتين',
  },
  'cuttingDock.cuttingParams.specialShapCutTip': {
    zh: '（启用后所有异形板件都会切两次）',
    en: '(After enabling, all irregular boards will be cut twice)',
    id: '（Papan tidak berbentuk khusus tidak berlaku untuk fungsi ini）',
    kz: '（Құрамды панельдің кесуде қолданылмайды）',
    th: '（หลังจากเปิดใช้งานฟังก์ชั่นนี้จะตัดจานพิเศษทั้งหมดสองครั้ง）',
    ug: '（ئارقا قېپىش ئىككى قېتىم）',
    vi: '（Sau khi kích hoạt, tất cả các tấm hình dạng đặc biệt sẽ được cắt hai lần）',
    zh_tc: '（啟用後所有異形板件都會切兩次）',
    ru: '(После включения все фасонные панели разрезаются дважды)',
    ko: '(활성화되면 모든 이형판 부품이 두 번 잘립니다.)',
    bur: '(ဖွင့်ပြီးနောက်အသွင်းပြားအားလုံးနှစ်ကြိမ်ဖြတ်မည်)',
    ben: '(সক্ষম করার পর সব অনিয়মিত বোর্ড দুইবার কাটা হবে)',
    tr: '(Açıldığında tüm anormal şekilli plakalar iki kez kesilir)',
    km: '(បើករួច ផ្ទាំងរូបរាងមិនធម្មតាទាំងអស់នឹងកាត់ពីរដង)',
    es: '(todas las placas con formas especiales se cortarán dos veces cuando esté habilitada)',
    ar: '(جميع الألواح ذات الشكل الخاص سيتم قطعها مرتين عند التمكين)',
  },
  'cuttingDock.cuttingParams.bridgeRetention': {
    zh: '搭桥留点法',
    en: 'Bridge Retention Point Method',
    id: 'Metode jembatan dengan titik penahan',
    kz: 'Көпірлі тірек нүктесі әдісі',
    th: 'วิธีเชื่อมสะพานและจุดยึด',
    ug: 'كۆۋرۈك قويۇپ نۇقتا قالدۇرۇش ئۇسۇلى',
    vi: 'Phương pháp cầu nối giữ điểm',
    zh_tc: '搭橋留點法',
    ru: 'Метод мостиков с точками удержания',
    ko: '브릿지 유지점 방식',
    bur: 'တံတားချိတ်ဆက် အမှတ်ထားနည်း',
    ben: 'ব্রিজ রিটেনশন পয়েন্ট পদ্ধতি',
    tr: 'Köprü tutma noktası yöntemi',
    km: 'វិធីសាស្ត្រស្ពានរក្សាចំណុច',
    es: 'Método de puente con puntos de retención',
    ar: 'طريقة جسر نقاط الإبقاء',
  },
  'cuttingDock.cuttingParams.bridgeRetentionTip': {
    zh: '（注意：1、该功能暂不支持外部异形板  2、不支持斜下刀  3、生成连接桥板件最小尺寸30mm）',
    en: '(Note: 1. This feature does not currently support external irregular boards. 2. It does not support oblique downward cutting. 3. The minimum part size for generating connecting bridges is 30mm.)',
    id: '(Catatan: 1. Fitur ini sementara tidak mendukung papan berbentuk khusus eksternal. 2. Tidak mendukung pemotongan miring ke bawah. 3. Ukuran minimum papan untuk menghasilkan jembatan penghubung adalah 30mm.)',
    kz: '(Ескерту: 1. Бұл функция әзірге сыртқы пішінді тақталарды қолдамайды. 2. Қиғаш төмен кесуді қолдамайды. 3. Байланыстырушы көпір жасалатын тақтаның ең кіші өлшемі 30мм.)',
    th: '(หมายเหตุ: 1. ฟังก์ชันนี้ยังไม่รองรับแผ่นรูปทรงพิเศษภายนอก 2. ไม่รองรับการตัดเฉียงลง 3. ขนาดขั้นต่ำของแผ่นสำหรับสร้างสะพานเชื่อมคือ 30mm)',
    ug: '(دىققەت: 1. بۇ ئىقتىدار ۋاقتىنچە سىرتقى ئالاھىدە شەكىللىك تاختىلارنى قوللىمايدۇ. 2. ئېگىل پىچاقنى قوللىمايدۇ. 3. ئۇلىنىش كۆۋرۈكى ھاسىل قىلىدىغان تاختىنىڭ ئەڭ كىچىك ئۆلچىمى 30mm.)',
    vi: '(Lưu ý: 1. Tính năng này tạm thời không hỗ trợ tấm dị hình bên ngoài. 2. Không hỗ trợ cắt dao nghiêng. 3. Kích thước tối thiểu của tấm để tạo cầu nối là 30mm.)',
    zh_tc:
      '（注意：1、該功能暫不支持外部異形板  2、不支持斜下刀  3、生成連接橋板件最小尺寸30mm）',
    ru: '(Примечание: 1. Эта функция временно не поддерживает внешние фасонные панели. 2. Не поддерживает наклонную подачу ножа. 3. Минимальный размер детали для создания соединительного мостика — 30 мм.)',
    ko: '(주의: 1. 이 기능은 현재 외부 이형판을 지원하지 않습니다. 2. 사선 하향 절단을 지원하지 않습니다. 3. 연결 브릿지 생성 판재의 최소 크기는 30mm입니다.)',
    bur: '(မှတ်ချက်: 1. ဤလုပ်ဆောင်ချက်သည် ပြင်ပအသွင်းပြားများကို ယာယီမပံ့ပိုးပါ။ 2. ဓားစောင်းချခြင်းကို မပံ့ပိုးပါ။ 3. ချိတ်ဆက်တံတားထုတ်လုပ်မည့် ပြားအနည်းဆုံးအရွယ်အစားမှာ 30mm ဖြစ်သည်။)',
    ben: '(দ্রষ্টব্য: 1. এই ফাংশনটি সাময়িকভাবে বাইরের অনিয়মিত বোর্ড সমর্থন করে না। 2. অবলিক ডাউনওয়ার্ড কাটিং সমর্থন করে না। 3. সংযোগকারী ব্রিজ তৈরির জন্য পার্টের ন্যূনতম আকার 30mm।)',
    tr: '(Not: 1. Bu özellik geçici olarak dış anormal şekilli panoları desteklemez. 2. Eğik aşağı kesimi desteklemez. 3. Bağlantı köprüsü oluşturmak için parça minimum boyutu 30mm.)',
    km: '(ចំណាំ: 1. មុខងារនេះបណ្ដោះអាសន្នមិនគាំទ្រផ្ទាំងរូបរាងមិនធម្មតាខាងក្រៅ។ 2. មិនគាំទ្រការកាត់ចុះអាក្សត់។ 3. ទំហំអប្បបរមានៃផ្ទាំងសម្រាប់បង្កើតស្ពានតភ្ជាប់គឺ 30mm។)',
    es: '(Nota: 1. Esta función temporalmente no admite placas con formas especiales externas. 2. No admite corte oblicuo hacia abajo. 3. El tamaño mínimo de la pieza para generar puentes de conexión es 30mm.)',
    ar: '(ملاحظة: 1. هذه الميزة لا تدعم حالياً الألواح ذات الأشكال الخاصة الخارجية. 2. لا تدعم التقطيع المائل نحو الأسفل. 3. الحد الأدنى لحجم اللوح لإنشاء جسر الربط هو 30مم.)',
  },
  'cuttingDock.cuttingParams.bridgeRetentionDesc': {
    zh: '可解决当板件内部存在大量挖空区域时，切割路径容易因支撑不足而导致板材抖动或跑板的情况',
    en: 'Helps prevent board jitter or run-off when large hollow areas inside the board cause insufficient support for the cutting path.',
    id: 'Dapat menyelesaikan masalah getaran atau bergesernya papan saat jalur pemotongan kurang ditopang karena banyak area kosong di dalam papan.',
    kz: 'Тақта ішіндегі көптеген қуыс аймақтар тірек жеткіліксіз болғанда, кесу жолының дірілдеуін немесе жылжуын болдырмауға көмектеседі.',
    th: 'ช่วยแก้ปัญหาแผ่นสั่นหรือเลื่อนเมื่อมีพื้นที่เจาะกลวงจำนวนมากภายในแผ่น ทำให้เส้นทางตัดขาดการรองรับ',
    ug: 'تاختا ئىچىدە كۆپ بوشلۇق بولۇپ تىرەك يېتىشمىگەندە، كېسىش يولىنىڭ تىترەش ياكى يۆتكىلىش مەسىلىسىنى ھەل قىلىدۇ.',
    vi: 'Giúp giải quyết tình trạng tấm rung hoặc lệch khi trong tấm có nhiều vùng khoét rỗng khiến đường cắt thiếu điểm tựa.',
    zh_tc:
      '可解決當板件內部存在大量挖空區域時，切割路徑容易因支撐不足而導致板材抖動或跑板的情況',
    ru: 'Помогает устранить вибрацию или смещение плиты, когда внутри много вырезов и траектории резки не хватает опоры.',
    ko: '판재 내부에 많은 중공 영역이 있어 절단 경로의 지지가 부족할 때 발생하는 떨림이나 밀림 문제를 해결할 수 있습니다.',
    bur: 'ဘုတ်အတွင်း အခေါင်းပေါက်များများရှိ၍ ဖြတ်လမ်းကြောင်းအား ထောက်ပံ့မှုမလုံလောက်သည့်အခါ ဘုတ်တုန်ခါခြင်း သို့မဟုတ် ရွေ့လျားခြင်းကို ကူညီဖြေရှင်းပေးသည်။',
    ben: 'বোর্ডের ভিতরে প্রচুর ফাঁকা এলাকা থাকায় কাটিং পথে পর্যাপ্ত সাপোর্ট না থাকলে বোর্ড কাঁপা বা সরে যাওয়ার সমস্যা সমাধানে সাহায্য করে।',
    tr: 'Levha içinde çok sayıda oyuk alan varken kesim yolu yeterli destek alamadığında levhanın titremesi veya kayması sorununu çözmeye yardımcı olur.',
    km: 'ជួយដោះស្រាយបញ្ហាផ្ទាំងញ័រ ឬរអិល នៅពេលមានតំបន់ប្រហោងច្រើនក្នុងផ្ទាំង ធ្វើឱ្យផ្លូវកាត់ខ្វះការទ្រទ្រង់។',
    es: 'Ayuda a evitar la vibración o el desplazamiento de la placa cuando hay muchas zonas vacías internas y la trayectoria de corte carece de soporte.',
    ar: 'يساعد في حل اهتزاز اللوح أو انزياحه عندما توجد مناطق مجوفة كثيرة داخله فتفتقر مسار القطع إلى الدعم الكافي.',
  },
  'cuttingDock.cuttingParams.bridgePunchArea': {
    zh: '打穿部分超过总面积',
    en: 'Punched area exceeds total area',
    id: 'Bagian yang ditembus melebihi total area',
    kz: 'Тесілген бөлік жалпы ауданнан асады',
    th: 'ส่วนที่เจาะทะลุเกินพื้นที่ทั้งหมด',
    ug: 'تېشىلغان قىسىم ئومۇمىي يۈزىدىن ئېشىپ كەتسە',
    vi: 'Phần đục thủng vượt quá tổng diện tích',
    zh_tc: '打穿部分超過總面積',
    ru: 'Площадь сквозной вырезки превышает общую площадь',
    ko: '관통 부분이 전체 면적을 초과',
    bur: 'ထိုးဖောက်ထားသောအပိုင်းသည် စုစုပေါင်းဧရိယာထက်ကျော်လွန်',
    ben: 'ছিদ্রকৃত অংশ মোট ক্ষেত্রফলের বেশি',
    tr: 'Delinen kısım toplam alanı aşıyor',
    km: 'ផ្នែកដែលចោះឆ្លងលើសផ្ទៃសរុប',
    es: 'La parte perforada supera el área total',
    ar: 'الجزء المخترق يتجاوز المساحة الإجمالية',
  },
  'cuttingDock.cuttingParams.bridgeSize': {
    zh: '连接桥尺寸',
    en: 'Bridge Size',
    id: 'Ukuran jembatan',
    kz: 'Көпір өлшемі',
    th: 'ขนาดสะพานเชื่อม',
    ug: 'كۆۋرۈك چوڭلۇقى',
    vi: 'Kích thước cầu nối',
    zh_tc: '連接橋尺寸',
    ru: 'Размер мостика',
    ko: '연결 브릿지 크기',
    bur: 'ချိတ်ဆက်တံတားအရွယ်အစား',
    ben: 'ব্রিজের আকার',
    tr: 'Köprü boyutu',
    km: 'ទំហំស្ពានតភ្ជាប់',
    es: 'Tamaño del puente',
    ar: 'حجم جسر الوصل',
  },
  'cuttingDock.cuttingParams.bridgeGenMethod': {
    zh: '生成方式',
    en: 'Generation Method',
    id: 'Metode pembuatan',
    kz: 'Қалыптастыру тәсілі',
    th: 'วิธีสร้าง',
    ug: 'ھاسىل قىلىش ئۇسۇلى',
    vi: 'Cách tạo',
    zh_tc: '生成方式',
    ru: 'Способ генерации',
    ko: '생성 방식',
    bur: 'ဖန်တီးပုံစံ',
    ben: 'জেনারেট পদ্ধতি',
    tr: 'Oluşturma yöntemi',
    km: 'វិធីបង្កើត',
    es: 'Método de generación',
    ar: 'طريقة التوليد',
  },
  'cuttingDock.cuttingParams.bridgeAddTip': {
    zh: '最多添加10条数据',
    en: 'Add up to 10 items',
    id: 'Tambahkan hingga 10 data',
    kz: 'Ең көбі 10 жазба қосуға болады',
    th: 'เพิ่มได้สูงสุด 10 รายการ',
    ug: 'ئەڭ كۆپ بولغاندا 10 تال سانلىق مەلۇمات قوشۇش',
    vi: 'Thêm tối đa 10 dữ liệu',
    zh_tc: '最多添加10條數據',
    ru: 'Можно добавить не более 10 записей',
    ko: '최대 10개의 데이터 추가',
    bur: 'အများဆုံး ၁၀ ခု ထည့်နိုင်သည်',
    ben: 'সর্বোচ্চ ১০টি ডেটা যোগ করুন',
    tr: 'En fazla 10 veri ekleyebilirsiniz',
    km: 'បន្ថែមបានអតិបរមា 10 ទិន្នន័យ',
    es: 'Añadir hasta 10 datos',
    ar: 'أضف حتى 10 بيانات',
  },
  'cuttingDock.cuttingParams.bridgeCount': {
    zh: '连接桥数',
    en: 'Number of Bridges',
    id: 'Jumlah jembatan',
    kz: 'Көпір саны',
    th: 'จำนวนสะพานเชื่อม',
    ug: 'كۆۋرۈك سانى',
    vi: 'Số lượng cầu nối',
    zh_tc: '連接橋數',
    ru: 'Количество мостиков',
    ko: '연결 브릿지 수',
    bur: 'ချိတ်ဆက်တံတားအရေအတွက်',
    ben: 'ব্রিজের সংখ্যা',
    tr: 'Köprü sayısı',
    km: 'ចំនួនស្ពានតភ្ជាប់',
    es: 'Número de puentes',
    ar: 'عدد جسور الوصل',
  },
  'cuttingDock.cuttingParams.bridgePlankLength': {
    zh: '板件长度(L)',
    en: 'Board Length (L)',
    id: 'Panjang papan (L)',
    kz: 'Тақта ұзындығы (L)',
    th: 'ความยาวแผ่น (L)',
    ug: 'تاختا ئۇزۇنلۇقى (L)',
    vi: 'Chiều dài tấm (L)',
    zh_tc: '板件長度(L)',
    ru: 'Длина плиты (L)',
    ko: '판재 길이(L)',
    bur: 'ဘုတ်အရှည် (L)',
    ben: 'বোর্ডের দৈর্ঘ্য (L)',
    tr: 'Levha uzunluğu (L)',
    km: 'ប្រវែងផ្ទាំង (L)',
    es: 'Longitud de la placa (L)',
    ar: 'طول اللوح (L)',
  },
  'cuttingDock.cuttingParams.maxWH': {
    zh: '长或宽小于',
    en: 'Length or Width less than',
    id: 'Panjang atau lebar lebih kecil dari',
    kz: 'Ұзындық немесе ені аз',
    th: 'ความยาวหรือความกว้างมีขนาดเล็กกว่า',
    ug: 'ئۇزۇن ياكى كەڭلىكى كىچىك',
    vi: 'Chiều dài hoặc chiều rộng nhỏ hơn',
    zh_tc: '長或寬小於',
    ru: 'Длина или ширина меньше',
    ko: '길이 또는 너비 이하',
    bur: 'အရှည်သို့မဟုတ်အကျယ်သည်ထို့ထက်ငယ်',
    ben: 'দৈর্ঘ্য বা প্রস্থ এর চেয়ে কম',
    tr: 'Uzunluk veya genişlik şundan küçük',
    km: 'ប្រវែងឬទទឹងតូចជាង',
    es: 'La longitud o el ancho es menor que',
    ar: 'الطول أو العرض أقل من',
  },
  'cuttingDock.cuttingParams.areaLimit': {
    zh: '且面积小于',
    en: 'And Area less than',
    id: 'Dan area ini lebih kecil dari',
    kz: 'Және алаңдық аз',
    th: 'และพื้นที่เล็กกว่า',
    ug: 'ھەمدە يۈزى كىچىك',
    vi: 'Và diện tích nhỏ hơn',
    zh_tc: '且面積小於',
    ru: 'Площадь меньше',
    ko: '면적이 작음',
    bur: 'နှင့်ဧရိယာသည်ထို့ထက်ငယ်',
    ben: 'ও ক্ষেত্রফল এর চেয়ে কম',
    tr: 've alan şundan küçük',
    km: 'និងក្រឡាតូចជាង',
    es: 'y el área es menor que',
    ar: 'والمساحة أقل من',
  },
  'cuttingDock.cuttingParams.secondDeep': {
    zh: '第二次切割深度',
    en: 'Second Cutting Depth',
    id: 'Kedalaman pemotongan kedua',
    kz: 'Екінші рет кесу тереңдігі',
    th: 'ความลึกการตัดครั้งที่สอง',
    ug: 'ئىككىنچى قېتىم قېپىش چوڭلۇقى',
    vi: 'Chiều sâu cắt lần thứ hai',
    zh_tc: '第二次切割深度',
    ru: 'глубина второй резки',
    ko: '두 번째 컷 깊이',
    bur: 'ဒုတိယဖြတ်အနက်',
    ben: 'দ্বিতীয় কাটিং গভীরতা',
    tr: 'İkinci kesim derinliği',
    km: 'ជម្រៅកាត់លើកទីពីរ',
    es: 'La segunda profundidad de corte',
    ar: 'عمق القطع الثاني',
  },
  'cuttingDock.cuttingParams.splitPlankThickSetting': {
    zh: '开料分层切割设置',
    en: 'Sizing layered cutting settings',
    id: 'Pengaturan pemotongan berlapis',
    kz: 'Қабатты кесу параметрлерін өлшемдеу',
    th: 'การตั้งค่าการตัดแบบแบ่งชั้น',
    ug: 'تاختا قېپىش قاتلام قېپىش تەڭشىكى',
    vi: 'Định cỡ cài đặt cắt theo lớp',
    zh_tc: '開料分層切割設置',
    ru: 'Настройка слоистой резки',
    ko: '가공소재 계층형 가공 설정',
    bur: 'ဖြတ်တောက်အလွှာခွဲဖြတ်ဆက်တင်',
    ben: 'সাইজিং লেয়ার্ড কাটিং সেটিংস',
    tr: 'Ham kesim katmanlı kesim ayarları',
    km: 'ការកំណត់កាត់ជាស្រទាប់ពេលកាត់វត្ថុធាតុ',
    es: 'Configuración de corte de la capa de corte',
    ar: 'إعدادات قطع طبقة القطع',
  },
  'cuttingDock.cuttingParams.saveCustomSpeedTip': {
    zh: '加工速度不能为空',
    en: 'Processing speed cannot be empty',
    id: 'Kecepatan pengolahan tidak boleh kosong',
    kz: 'Өңдеу жылдамдығы бос болмауы керек',
    th: 'ความเร็วในการแปรรูปต้องไม่ว่างเปล่า',
    ug: 'قېپىش سۈرئىتى بولمايدىغان',
    vi: 'Tốc độ gia công không được để trống',
    zh_tc: '加工速度不能為空',
    ru: 'Скорость обработки не может быть пустой.',
    ko: '가공 속도는 비워둘 수 없습니다.',
    bur: 'ပြုပြင်အမြန်နှုန်းဗလာမရ',
    ben: 'প্রসেসিং স্পিড খালি থাকতে পারবে না',
    tr: 'İşlem hızı boş olamaz',
    km: 'ល្បឿនដំណើរការមិនអាចទទេ',
    es: 'La velocidad de procesamiento no puede ser vacía',
    ar: 'لا يمكن أن تكون سرعة المعالجة فارغة',
  },
  'cuttingDock.cuttingParams.saveLayeredCuttingTip': {
    zh: '开料分层切割三次分层切割的总和必须等于板件厚度',
    en: 'The sum of the three layered cuts must be equal to the thickness of the plate',
    id: 'Jumlah dari tiga lapisan pemotongan pemotongan harus sama dengan ketebalan pelat',
    kz: 'Үш қабатты кесінділердің қосындысы пластинаның қалыңдығына тең болуы тиіс',
    th: 'ผลรวมของการตัดการตัดทั้งสามชั้นจะต้องเท่ากับความหนาของแผ่น',
    ug: 'تاختا قېپىش قاتلام قېپىشتە ئۈچ قاتلام قېپىشنىڭ جەمئىي تاختىنىڭ قېلىنلىقىغا تەڭ بولۇشى كېرەك',
    vi: 'Tổng của ba lớp cắt phải bằng với độ dày của tấm',
    zh_tc: '開料分層切割三次分層切割的總和必須等於板件厚度',
    ru: 'Сумма трех стратифицированных разрезов должна быть равна толщине пластины.',
    ko: '가공소재 계층 가공 3차 계층 가공의 합계는 판재 두께와 같아야 합니다.',
    bur: 'ဖြတ်တောက်အလွှာခွဲဖြတ်သုံးလွှာစုစုပေါင်းပြားအထူနှင့်ညီရမည်',
    ben: 'তিন লেয়ার কাটের সমষ্টি প্লেটের বেধের সমান হতে হবে',
    tr: 'Üç katmanlı kesimlerin toplamı plaka kalınlığına eşit olmalıdır',
    km: 'ផលបូកកាត់បីស្រទាប់ត្រូវស្មើកម្រាស់ផ្ទាំង',
    es: 'La suma de tres cortes en capas para el corte en capas debe ser igual al espesor de la placa',
    ar: 'يجب أن يكون مجموع قصاصات الطبقات الثلاث للقطع ذو الطبقات مساويًا لسمك اللوحة',
  },
  'cuttingDock.cuttingParams.saveLayeredRepeatTip': {
    zh: '开料分层切割不建议同一个材质高光属性厚度设置不同的分层数据，请删除多余数据！',
    en: 'It is not recommended to set different layered data for the thickness of the highlight attribute of the same material, please delete the redundant data!',
    id: 'Tidak disarankan untuk mengatur data berlapis yang berbeda untuk memotong dan melapisi bahan yang sama dengan ketebalan atribut highlight. Harap hapus kelebihan data!',
    kz: 'Бір материалдың бөлектеу атрибутының қалыңдығына әр түрлі қабатты деректерді орнату ұсынылмайды, артық деректерді жоюыңызды өтінемін!',
    th: 'ไม่แนะนำให้ตั้งค่าข้อมูลเลเยอร์ที่แตกต่างกันสำหรับการตัดและเลเยอร์ของวัสดุเดียวกันด้วยความหนาของคุณลักษณะไฮไลต์ โปรดลบข้อมูลส่วนเกิน!',
    ug: 'تاختا قېپىش قاتلام قېپىشتە بىر ماتېرىيال يورۇق خاسلىقى قېلىنلىقىغا ئوخشاش بولمىغان قاتلام سانلىق مەلۇماتلىرىنى تەڭشەش تەۋسىيە قىلىنمايدۇ، قوشۇمچە سانلىق مەلۇماتلارنى ئۆچۈرۈڭ!',
    vi: 'Không nên đặt dữ liệu phân lớp khác nhau cho độ dày của thuộc tính đánh dấu của cùng một vật liệu, vui lòng xóa dữ liệu thừa!',
    zh_tc:
      '開料分層切割不建議同一個材質高光屬性厚度設置不同的分層數據，請刪除多餘數據！',
    ru: 'Слойная резка открытого материала не рекомендуется, чтобы толщина свойства высокого света одного и того же материала устанавливала разные слои данных, пожалуйста, удалите лишние данные!',
    ko: '원단 계층 컷은 동일한 재료의 하이라이트 속성 두께에 대해 다른 계층 데이터를 설정하는 것이 권장되지 않습니다. 중복 데이터를 제거하십시오!',
    bur: 'တူညီပစ္စည်းအမြှီးအထူတွင်မတူညီအလွှာဒေတာမသတ်မှတ်ရန်အကြံပြု၊ ပိုဒေတာဖျက်ပါ!',
    ben: 'একই ম্যাটেরিয়ালের হাইলাইট অ্যাট্রিবিউট বেধের জন্য ভিন্ন লেয়ার ডেটা সেট না করার পরামর্শ। অতিরিক্ত ডেটা মুছুন!',
    tr: 'Aynı malzeme için parlak özellik kalınlığında farklı katman verileri önerilmez; fazla verileri silin!',
    km: 'មិនសូមណែនាំឱ្យកំណត់ទិន្នន័យស្រទាប់ខុសគ្នាសម្រាប់ទម្លាប់រលកពន្លឺនៃវត្ថុធាតុដូចគ្នា សូមលុបទិន្នន័យលើស!',
    es: 'No se recomienda establecer diferentes datos en capas para el espesor del atributo de resaltado del mismo material durante el corte en capas. ¡Elimine los datos redundantes!',
    ar: 'لا يوصى بتعيين بيانات طبقات مختلفة لسمك سمة تمييز المادة نفسها أثناء قطع الطبقات. يرجى حذف البيانات الزائدة!',
  },
  'cuttingDock.cuttingParams.splitPlankThick': {
    zh: '不同板厚分层切割',
    en: 'Layered Cutting for Different Board Thicknesses',
    id: 'Pemotongan berlapis dengan ketebalan pelat yang berbeda',
    kz: 'Әр қатламда кесу әртүрлі қалыңдықта',
    th: 'การตัดความหนาของแผ่นที่แตกต่างกัน',
    ug: 'ئوخشاش بولمىغان تاختا قېلىنلىقى قاتلام قېپىش',
    vi: 'Cắt tầng khác nhau theo độ dày tấm',
    zh_tc: '不同板厚分層切割',
    ru: 'Толщина слоя различных пластин',
    ko: '서로 다른 두께 계층형 절단',
    bur: 'မတူညီပြားအထူအလွှာခွဲဖြတ်',
    ben: 'ভিন্ন বোর্ড বেধের জন্য লেয়ার্ড কাটিং',
    tr: 'Farklı kalınlıkta katmanlı kesim',
    km: 'កាត់ជាស្រទាប់តាមកម្រាស់ផ្ទាំងខុសគ្នា',
    es: 'Corte en capas de diferentes espesores de placa',
    ar: 'قطع طبقات بسماكات مختلفة للوحة',
  },
  'cuttingDock.cuttingParams.movePlankSetting': {
    zh: '防跑板设置',
    en: 'Anti-slip board settings',
    id: 'Pengaturan Papan Anti-Run',
    kz: 'Тайғанауға қарсы тақта параметрлері',
    th: 'การตั้งค่าคณะกรรมการต่อต้านการวิ่ง',
    ug: 'تاختا قاچىشىنىڭ ئالدىنى ئېلىش تەڭشىكى',
    vi: 'Cài đặt bảng chống trượt',
    zh_tc: '防跑板設置',
    ru: 'Настройка панели защиты',
    ko: '달리기 방지판 설정',
    bur: 'ပြားမပြေးအောင်ဆက်တင်',
    ben: 'অ্যান্টি-স্লিপ বোর্ড সেটিংস',
    tr: 'Plaka kayması önleme ayarları',
    km: 'ការកំណត់ការការពារផ្ទាំងរុញចេញ',
    es: 'Configuración de placa antideslizante',
    ar: 'إعدادات اللوحة المضادة للتشغيل',
  },
  'cuttingDock.cuttingParams.newCutSequence': {
    zh: '新版切割算法',
    en: 'New cutting algorithm',
    id: 'Versi baru dari algoritma pemotongan',
    kz: 'Жаңа кесу алгоритмі',
    th: 'อัลกอริทึมการตัดเวอร์ชันใหม่',
    ug: 'يېڭى قېپىش ئالگورىتمى',
    vi: 'Thuật toán cắt mới',
    zh_tc: '新版切割算法',
    ru: 'Новый алгоритм резки',
    ko: '새 절단 알고리즘',
    bur: 'ဖြတ်အယ်လ်ဂိုရီသမ်အသစ်',
    ben: 'নতুন কাটিং অ্যালগরিদম',
    tr: 'Yeni kesim algoritması',
    km: 'អាល់ហ្គូរីដ្ឋានកាត់ថ្មី',
    es: 'Nueva versión del algoritmo de corte',
    ar: 'إصدار جديد من خوارزمية القطع',
  },
  'cuttingDock.cuttingParams.newCutSequenceText': {
    zh: '默认大板中心真空吸力最强，此块区域小板最后切',
    en: 'By default, the center of the large slab has the strongest vacuum suction, and the small slabs in this area are cut last',
    id: 'Gaya hisap vakum di tengah pelat besar adalah yang terkuat, dan pelat kecil di daerah ini akhirnya dipotong',
    kz: 'Әдепкі бойынша, үлкен тақтаның ортасындағы вакуумдық сорғыш күші ең күшті, бұл аймақтағы кіші тақталар соңында кесіледі',
    th: 'แรงดูดสูญญากาศที่อยู่ตรงกลางของแผ่นขนาดใหญ่นั้นแข็งแกร่งที่สุดและในที่สุดก็มีจานเล็ก ๆ ในพื้นที่นี้',
    ug: 'سۈكۈتتىكى چوڭ تاختىنىڭ مەركىزى ۋاكۇم ئېلىش كۈچى ئەڭ كۈچلۈك، بۇ رايوندىكى كىچىك تاختا ئاخىرىدا قېپىلىدۇ',
    vi: 'Theo mặc định, trung tâm của tấm lớn có lực hút chân không mạnh nhất, và các tấm nhỏ ở khu vực này sẽ được cắt cuối cùng',
    zh_tc: '默認大板中心真空吸力最強，此塊區域小板最後切',
    ru: 'По умолчанию самое сильное вакуумное всасывание в центре большой пластины, последняя резка этой области',
    ko: '기본 대판 중심 진공 흡입력이 가장 강하며, 이 영역 소판은 마지막에 잘라냅니다.',
    bur: 'မူရင်းကြီးပြားဗဟိုဗက်ကြူးစုပ်အားအပြင်းဆုံး၊ ဤနေရာပေါ်ဒ်ငယ်နောက်ဆုံးဖြတ်',
    ben: 'ডিফল্টে বড় স্ল্যাবের কেন্দ্রে ভ্যাকুয়াম সাকশন সবচেয়ে শক্তিশালী, এই অঞ্চলের ছোট স্ল্যাব শেষে কাটা হয়',
    tr: 'Varsayılan olarak büyük plakanın merkezinde vakum çekişi en güçlüdür; bu bölgedeki küçük plakalar en son kesilir',
    km: 'លំនាំដើម កណ្តាលផ្ទាំងធំមានការច្របាក់សុញ្ញាកាសខ្លាំងបំផុត ផ្ទាំងតូចនៅតំបន់នេះកាត់ចុងក្រោយ',
    es: 'De forma predeterminada, la succión de vacío es más fuerte en el centro de la placa grande y las placas pequeñas en esta área se cortan al final',
    ar: 'افتراضيًا، يكون الشفط الفراغي أقوى في وسط اللوحة الكبيرة، ويتم قطع الألواح الصغيرة في هذه المنطقة أخيرًا',
  },
  'cuttingDock.cuttingParams.positionTip': {
    zh: '点击相应区域可以进行选择',
    en: 'Click on the corresponding area to select',
    id: 'Klik pada area yang sesuai untuk membuat pilihan',
    kz: 'Таңдау үшін сәйкес ауданды басыңыз',
    th: 'คลิกที่พื้นที่ที่สอดคล้องกันเพื่อทำการเลือก',
    ug: 'ئالاقىدار رايوننى تاللاپ تاللاش ئېلىپ بارالايدۇ',
    vi: 'Nhấp vào khu vực tương ứng để chọn',
    zh_tc: '點擊相應區域可以進行選擇',
    ru: 'Нажмите на соответствующую область, чтобы выбрать',
    ko: '해당 영역을 클릭하여 선택 가능',
    bur: 'သက်ဆိုင်ရာနေရာကိုနှိပ်ပြီးရွေးနိုင်',
    ben: 'সংশ্লিষ্ট অঞ্চলে ক্লিক করে সিলেক্ট করুন',
    tr: 'İlgili alana tıklayarak seçim yapabilirsiniz',
    km: 'ចុចតំបន់ដែលត្រូវគ្នាដើម្បីជ្រើស',
    es: 'Haga clic en el área correspondiente para seleccionar',
    ar: 'انقر فوق المنطقة المقابلة لتحديد',
  },
  'cuttingDock.cuttingParams.suctionPosition': {
    zh: '真空强吸力位置',
    en: 'Vacuum strong suction position',
    id: 'Posisi hisap vakum',
    kz: 'Құбылыс пішінің күшті қабылдамасы',
    th: 'ตำแหน่งดูดสูญญากาศ',
    ug: 'ۋاكۇم كۈچلۈك ئېلىش ئورنى',
    vi: 'Vị trí lực hút mạnh của chân không',
    zh_tc: '真空強吸力位置',
    ru: 'вакуумное положение тяги',
    ko: '진공 강흡력 위치',
    bur: 'ဗက်ကြူးပြင်းစုပ်နေရာ',
    ben: 'ভ্যাকুয়াম স্ট্রং সাকশন পজিশন',
    tr: 'Güçlü vakum çekiş konumu',
    km: 'ទីតាំងច្របាក់សុញ្ញាកាសខ្លាំង',
    es: 'Posición de succión de vacío fuerte',
    ar: 'موضع شفط قوي',
  },
  'cuttingDock.cuttingParams.strongArea': {
    zh: '强吸力区',
    en: 'Strong suction area',
    id: 'Zona pengisapan yang kuat',
    kz: 'Құрғау аймағы',
    th: 'เขตดูดที่แข็งแกร่ง',
    ug: 'كۈچلۈك ئېلىش رايونى',
    vi: 'Vùng hút mạnh',
    zh_tc: '強吸力區',
    ru: 'зона сильного всасывания',
    ko: '강한 흡입력 영역',
    bur: 'ပြင်းစုပ်ဧရိယာ',
    ben: 'স্ট্রং সাকশন এরিয়া',
    tr: 'Güçlü çekiş bölgesi',
    km: 'តំបន់ច្របាក់ខ្លាំង',
    es: 'Área de succión fuerte',
    ar: 'منطقة شفط قوية',
  },
  'cuttingDock.cuttingParams.minSuctionPlank': {
    zh: '最小可吸住板件',
    en: 'Minimum suction board',
    id: 'Pelat hisap minimum',
    kz: 'Эң кіші қабылданатын дошка',
    th: 'แผ่นดูดขั้นต่ำ',
    ug: 'ئەڭ كىچىك تۇتۇشقا بولىدىغان تاختا',
    vi: 'Tấm có thể hấp thụ tối thiểu',
    zh_tc: '最小可吸住板件',
    ru: 'Минимальная всасываемая пластина',
    ko: '최소 흡착 가능 플레이트',
    bur: 'အနည်းဆုံးစုပ်ထားနိုင်ပြား',
    ben: 'সর্বনিম্ন সাকশন বোর্ড',
    tr: 'Tutulabilen minimum plaka',
    km: 'ផ្ទាំងតូបរមាដែលច្របាក់បាន',
    es: 'Placa de succión mínima',
    ar: 'الحد الأدنى من لوحة الشفط',
  },
  'cuttingDock.cuttingParams.safeWidth': {
    zh: '宽度',
    en: 'Width',
    id: 'lebar',
    kz: 'Ені',
    th: 'ความกว้าง',
    ug: 'كەڭلىك',
    vi: 'Chiều rộng',
    zh_tc: '寬度',
    ru: 'ширина',
    ko: '너비',
    bur: 'အကျယ်',
    ben: 'প্রস্থ',
    tr: 'Genişlik',
    km: 'ទទឹង',
    es: 'Ancho',
    ar: 'العرض',
  },
  'cuttingDock.cuttingParams.safeHeight': {
    zh: '长度',
    en: 'Length',
    id: 'panjang',
    kz: 'Биіктігі',
    th: 'ความยาว',
    ug: 'ئۇزۇنلۇق',
    vi: 'Độ cao',
    zh_tc: '長度',
    ru: 'длина',
    ko: '길이',
    bur: 'အရှည်',
    ben: 'দৈর্ঘ্য',
    tr: 'Uzunluk',
    km: 'ប្រវែង',
    es: 'Largo',
    ar: 'الطول',
  },
  'cuttingDock.cuttingParams.safeTip': {
    zh: '吸不住板件会先切',
    en: 'Will cut first if the board cannot be held securely',
    id: 'Pelat akan dipotong terlebih dahulu jika Anda tidak dapat menyerapnya',
    kz: 'Табан нұсқаны тұтынбаса ал бірінші резке қалдыратын',
    th: 'จานจะถูกตัดก่อนหากคุณไม่สามารถดูดซับได้',
    ug: 'تۇتالمايدىغان تاختا ئالدى بىلەن قېپىلىدۇ',
    vi: 'Sẽ cắt trước nếu không thể giữ chắc tấm bảng',
    zh_tc: '吸不住板件會先切',
    ru: 'Если мы не сможем отсосать пластину, мы сначала разрежем ее.',
    ko: '빨아들이지 않으면 판재를 먼저 잘라요.',
    bur: 'စုပ်မထားနိုင်ပြားကိုအရင်ဖြတ်',
    ben: 'বোর্ড নিরাপদে ধরে রাখতে না পারলে আগে কাটা হবে',
    tr: 'Tutulamayan plakalar önce kesilir',
    km: 'ផ្ទាំងដែលច្របាក់មិនបាននឹងកាត់មុន',
    es: 'Si la placa no se puede succionar, se cortará primero',
    ar: 'إذا لم يكن من الممكن امتصاص اللوحة، فسيتم قطعها أولاً',
  },
  'cuttingDock.cuttingParams.scattered_layout': {
    zh: '小板分散排版',
    en: 'Small board scatter layout',
    id: 'Tata Letak Papan Kecil Tersebar',
    kz: 'Кішкентай табандарды бөліп орналастыру',
    th: 'บอร์ดขนาดเล็กเลย์เอาต์กระจัดกระจาย',
    ug: 'كىچىك تاختا تارقالغان تەڭشەش',
    vi: 'Bảng nhỏ phân tán',
    zh_tc: '小板分散排版',
    ru: 'Дисперсионный набор листов',
    ko: '소판 분산 조판',
    bur: 'ပေါ်ဒ်ငယ်ပြန့်ကျဲပြင်ဆင်',
    ben: 'ছোট বোর্ড স্ক্যাটার লেআউট',
    tr: 'Küçük plakalar dağıtık yerleşim',
    km: 'រៀបចំផ្ទាំងតូចរាយ',
    es: 'Composición tipográfica dispersa de placa pequeña',
    ar: 'تنضيد اللوحة الصغيرة المشتتة',
  },
  'cuttingDock.cuttingParams.lastCutPointEnable': {
    zh: '大板上最后切割小板下刀点自定义',
    en: 'Customize cutting point for last-cut part on large board',
    id: 'Kustomisasi titik potong papan kecil potongan terakhir pada papan besar',
    kz: 'Үлкен тақтадағы соңғы кесілген кішкентай тақтаның кесу нүктесін баптау',
    th: 'ปรับแต่งจุดลงมีดของแผ่นเล็กที่ตัดสุดท้ายบนแผ่นใหญ่',
    ug: 'چوڭ تاختا ئۈستىدىكى ئاخىرقى كېسىلگەن كىچىك تاختىنىڭ كېسىش نۇقتىسىنى بەلگىلەش',
    vi: 'Tùy chỉnh điểm cắt cho bảng nhỏ cắt cuối cùng trên bảng lớn',
    zh_tc: '大板上最後切割小板下刀點自定義',
    ru: 'Настройка точки входа последней вырезаемой детали на большом листе',
    ko: '대판에서 마지막 절단 소판 하강점 사용자 정의',
    bur: 'ကြီးမားသောဘုတ်ပေါ်ရှိ နောက်ဆုံးဖြတ်ရေးသေးငယ်သောဘုတ်၏ ဖြတ်ရေးအစက် စိတ်ကြိုက်ချိန်ညှိ',
    ben: 'বড় বোর্ডে শেষ কাটা ছোট বোর্ডের কাটিং পয়েন্ট কাস্টমাইজ',
    tr: 'Büyük plakadaki son kesilen küçük plaka kesim noktası özelleştirme',
    km: 'កំណត់ផ្ទាល់ខ្លួនចំណុចកាត់ក្តារតូចកាត់ចុងក្រោយនៅលើក្តារធំ',
    es: 'Personalizar punto de corte de la última placa pequeña cortada en la placa grande',
    ar: 'تخصيص نقطة القطع للوحة الصغيرة المقطوعة أخيرًا على اللوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.lastCutPointEnableTip': {
    zh: '启用后每张大板上最后切割的小板下刀点会按照设置的点位生成下刀点',
    en: 'When enabled, the cutting point of the last cut small board on each large plank will be generated according to the set point position',
    id: 'Jika diaktifkan, titik potong papan kecil potongan terakhir pada setiap papan besar akan dihasilkan sesuai posisi titik yang ditetapkan',
    kz: 'Қосылғанда, әрбір үлкен тақтадағы соңғы кесілген кішкентай тақтаның кесу нүктесі белгіленген нүкте бойынша жасалады',
    th: 'เมื่อเปิดใช้งาน จุดตัดของแผ่นเล็กที่ตัดสุดท้ายบนแผ่นใหญ่แต่ละแผ่นจะถูกสร้างตามตำแหน่งจุดที่ตั้งค่า',
    ug: 'ئېچىلغاندىن كېيىن، ھەر بىر چوڭ تاختا ئۈستىدىكى ئاخىرقى كېسىلگەن كىچىك تاختا كېسىش نۇقتىسى بەلگىلەنگەن نۇقتا ئورنى بويىچە ھاسىل بولىدۇ',
    vi: 'Khi bật, điểm cắt của bảng nhỏ cắt cuối cùng trên mỗi bảng lớn sẽ được tạo theo vị trí điểm đã đặt',
    zh_tc: '啟用後每塊大板上最後切割的小板下刀點會按照設置的點位生成下刀點',
    ru: 'При включении точка входа последней вырезаемой детали на каждом большом листе будет генерироваться по заданной позиции точки',
    ko: '활성화 시, 각 대판의 마지막 절단 소판 하강점이 설정된 점 위치에 따라 생성됩니다',
    bur: 'ဖွင့်လျှင်၊ ကြီးမားသောဘုတ်တိုင်းပေါ်ရှိ နောက်ဆုံးဖြတ်ရေးသေးငယ်သောဘုတ်၏ ဖြတ်ရေးအစက်သည် သတ်မှတ်ထားသောအစက်နေရာအရ ဖြစ်ပေါ်လာမည်',
    ben: 'সক্রিয় করলে, প্রতিটি বড় বোর্ডের শেষ কাটা ছোট বোর্ডের কাটিং পয়েন্ট সেট করা পয়েন্ট অবস্থান অনুযায়ী তৈরি হবে',
    tr: 'Etkinleştirildiğinde, her büyük plakadaki son kesilen küçük plakanın kesim noktası, ayarlanan nokta konumuna göre oluşturulacaktır',
    km: 'ពេលបើក ចំណុចកាត់នៃក្តារតូចកាត់ចុងក្រោយលើក្តារធំនីមួយៗនឹងត្រូវបង្កើតឡើងតាមទីតាំងចំណុចដែលកំណត់',
    es: 'Cuando está activado, el punto de corte de la última placa pequeña cortada en cada placa grande se generará según la posición del punto configurado',
    ar: 'عند التمكين، سيتم إنشاء نقطة القطع للوحة الصغيرة المقطوعة أخيرًا على كل لوحة كبيرة وفقًا لموضع النقطة المحدد',
  },
  'cuttingDock.cuttingParams.lastCutPoint': {
    zh: '下刀点位置',
    en: 'Cutting point position',
    id: 'Posisi titik potong',
    kz: 'Кесу нүктесінің орны',
    th: 'ตำแหน่งจุดตัด',
    ug: 'كېسىش نۇقتىسىنىڭ ئورنى',
    vi: 'Vị trí điểm cắt',
    zh_tc: '下刀點位置',
    ru: 'Положение точки входа',
    ko: '하강점 위치',
    bur: 'ဖြတ်ရေးအစက်တည်နေရာ',
    ben: 'কাটিং পয়েন্ট অবস্থান',
    tr: 'Kesim noktası konumu',
    km: 'ទីតាំងចំណុចកាត់',
    es: 'Posición del punto de corte',
    ar: 'موضع نقطة القطع',
  },
  'cuttingDock.cuttingParams.lastCutPointTip': {
    zh: '开启后，每块大板最后切割的小板将使用此下刀点',
    en: 'When enabled, the last cut small board on each large plank will use this cutting point',
    id: 'Jika diaktifkan, papan kecil potongan terakhir pada setiap papan besar akan menggunakan titik potong ini',
    kz: 'Қосылғанда, әрбір үлкен тақтадағы соңғы кесілген кішкентай тақта осы кесу нүктесін пайдаланады',
    th: 'เมื่อเปิดใช้งาน แผ่นเล็กที่ตัดสุดท้ายบนแผ่นใหญ่แต่ละแผ่นจะใช้จุดตัดนี้',
    ug: 'ئېچىلغاندىن كېيىن، ھەر بىر چوڭ تاختا ئۈستىدىكى ئاخىرقى كېسىلگەن كىچىك تاختا مۇشۇ كېسىش نۇقتىسىنى ئىشلىتىدۇ',
    vi: 'Khi bật, bảng nhỏ cắt cuối cùng trên mỗi bảng lớn sẽ sử dụng điểm cắt này',
    zh_tc: '開啟後，每塊大板最後切割的小板將使用此下刀點',
    ru: 'При включении последняя вырезаемая деталь на каждом большом листе будет использовать эту точку входа',
    ko: '활성화 시, 각 대판의 마지막 절단 소판이 이 하강점을 사용합니다',
    bur: 'ဖွင့်လျှင်၊ ကြီးမားသောဘုတ်တိုင်းပေါ်ရှိ နောက်ဆုံးဖြတ်ရေးသေးငယ်သောဘုတ်သည် ဤဖြတ်ရေးအစက်ကို အသုံးပြuilderွာမည်',
    ben: 'সক্রিয় করলে, প্রতিটি বড় বোর্ডের শেষ কাটা ছোট বোর্ড এই কাটিং পয়েন্ট ব্যবহার করবে',
    tr: 'Etkinleştirildiğinde, her büyük plakadaki son kesilen küçük plaka bu kesim noktasını kullanacaktır',
    km: 'ពេលបើក ក្តារតូចកាត់ចុងក្រោយនៅលើក្តារធំនីមួយៗនឹងប្រើចំណុចកាត់នេះ',
    es: 'Cuando está activado, la última placa pequeña cortada en cada placa grande usará este punto de corte',
    ar: 'عند التمكين، ستستخدم اللوحة الصغيرة المقطوعة أخيرًا على كل لوحة كبيرة نقطة القطع هذه',
  },
  'cuttingDock.cuttingParams.leftTop': {
    zh: '左上角',
    en: 'Top-left',
    id: 'Kiri atas',
    kz: 'Жоғарғы сол жақ',
    th: 'ซ้ายบน',
    ug: 'سول ئۈستى',
    vi: 'Trên cùng bên trái',
    zh_tc: '左上角',
    ru: 'Верхний левый',
    ko: '왼쪽 상단',
    bur: 'ဘယ်အပေါ်',
    ben: 'উপরে-বাম',
    tr: 'Sol üst',
    km: 'ខាងឆ្វង់លើ',
    es: 'Superior izquierda',
    ar: 'أعلى اليسار',
  },
  'cuttingDock.cuttingParams.rightTop': {
    zh: '右上角',
    en: 'Top-right',
    id: 'Kanan atas',
    kz: 'Жоғарғы оң жақ',
    th: 'ขวาบน',
    ug: 'ئوڭ ئۈستى',
    vi: 'Trên cùng bên phải',
    zh_tc: '右上角',
    ru: 'Верхний правый',
    ko: '오른쪽 상단',
    bur: 'ညာအပေါ်',
    ben: 'উপরে-ডান',
    tr: 'Sağ üst',
    km: 'ខាងស្តាំលើ',
    es: 'Superior derecha',
    ar: 'أعلى اليمين',
  },
  'cuttingDock.cuttingParams.leftBottom': {
    zh: '左下角',
    en: 'Bottom-left',
    id: 'Kiri bawah',
    kz: 'Төменгі сол жақ',
    th: 'ซ้ายล่าง',
    ug: 'سول ئاستى',
    vi: 'Dưới cùng bên trái',
    zh_tc: '左下角',
    ru: 'Нижний левый',
    ko: '왼쪽 하단',
    bur: 'ဘယ်အောက်',
    ben: 'নিচে-বাম',
    tr: 'Sol alt',
    km: 'ខាងឆ្វង់ក្រោម',
    es: 'Inferior izquierda',
    ar: 'أسفل اليسار',
  },
  'cuttingDock.cuttingParams.rightBottom': {
    zh: '右下角',
    en: 'Bottom-right',
    id: 'Kanan bawah',
    kz: 'Төменгі оң жақ',
    th: 'ขวาล่าง',
    ug: 'ئوڭ ئاستى',
    vi: 'Dưới cùng bên phải',
    zh_tc: '右下角',
    ru: 'Нижний правый',
    ko: '오른쪽 하단',
    bur: 'ညာအောက်',
    ben: 'নিচে-ডান',
    tr: 'Sağ alt',
    km: 'ខាងស្តាំក្រោម',
    es: 'Inferior derecha',
    ar: 'أسفل اليمين',
  },
  'cuttingDock.cuttingParams.specifyTheMaterial': {
    zh: '指定材质',
    en: 'Specify the material',
    id: 'Bahan yang ditentukan',
    kz: 'Материалды анықтаңыз',
    th: 'วัสดุที่กำหนด',
    ug: 'ماتېرىيالنى بەلگىلەش',
    vi: 'Xác định chất liệu',
    zh_tc: '指定材質',
    ru: 'Назначенный материал',
    ko: '재료 지정',
    bur: 'ပစ္စည်းသတ်မှတ်',
    ben: 'ম্যাটেরিয়াল নির্দিষ্ট করুন',
    tr: 'Malzemeyi belirt',
    km: 'កំណត់វត្ថុធាតុ',
    es: 'Especificar material',
    ar: 'تحديد المادة',
  },
  'cuttingDock.cuttingParams.shapeSecondCutenable': {
    zh: '异形板二次切割',
    en: 'Secondary cutting of profiled plate',
    id: 'Pemotongan kedua plat berbentuk khusus',
    kz: 'Қосымша көзге сатылған талбанның екінші кезде сатылуы',
    th: 'การตัดผงก์รูปผสมครั้งที่สอง',
    ug: 'خىلاپ شەكللىك پلاستنىكى ئىككىنچى قېتىم резىيەتلىش',
    vi: 'Cắt lại miếng đám dạng đặc biệt',
    zh_tc: '異形板二次切割',
    ru: 'Вторичная резка фасонных пластин',
    ko: '이형판 2차 절단',
    bur: 'အသွင်းပြားဒုတိယဖြတ်',
    ben: 'প্রোফাইলড প্লেটের সেকেন্ডারি কাটিং',
    tr: 'Anormal plaka ikinci kesim',
    km: 'កាត់លើកពីរសម្រាប់ផ្ទាំងរូបរាងមិនធម្មតា',
    es: 'Corte secundario de placa de forma especial',
    ar: 'القطع الثانوي للوحة ذات الشكل الخاص',
  },
  'cuttingDock.cuttingParams.addMaterial': {
    zh: '添加材质',
    en: 'Add material',
    id: 'Tambahkan bahan',
    kz: 'Материал қосу',
    th: 'เพิ่มวัสดุ',
    ug: 'ماتېرىيال قوشۇش',
    vi: 'Thêm vật liệu',
    zh_tc: '新增材質',
    ru: 'Добавить материал',
    ko: '재료 추가',
    bur: 'ပစ္စည်းထည့်',
    ben: 'ম্যাটেরিয়াল যোগ করুন',
    tr: 'Malzeme ekle',
    km: 'បន្ថែមវត្ថុធាតុ',
    es: 'Agregar material',
    ar: 'إضافة مادة',
  },
  'cuttingDock.cuttingParams.plankMaterial': {
    zh: '板件材质',
    en: 'Panel material',
    id: 'Bahan papan',
    kz: 'Панель материал',
    th: 'วัสดุแผ่นไม้',
    ug: 'تاختا ماتېرىيالى',
    vi: 'Chất liệu tấm ván',
    zh_tc: '板件材質',
    ru: 'Материал панели',
    ko: '판재 재료',
    bur: 'ပြားပစ္စည်း',
    ben: 'প্যানেল ম্যাটেরিয়াল',
    tr: 'Plaka malzemesi',
    km: 'វត្ថុធាតុផ្ទាំង',
    es: 'Material de placa',
    ar: 'مادة اللوحة',
  },
  'cuttingDock.cuttingParams.specifyTheMaterialTip': {
    zh: '启用后满足表格材质的板件才会生效二次切割功能',
    en: 'After enabling, the secondary cutting function will only take effect for the panels that meet the material requirements of the table.',
    id: 'Setelah diaktifkan, fungsi pemotongan kedua hanya akan berlaku untuk panel yang memenuhi persyaratan bahan dari tabel.',
    kz: 'Қосу қıldıңнан кейін, көшірші қысқару функциясы толық мәліметтердің материал талаптарын қамтамасын қабылдайтын панелдер үчүн ғана әсер қажет.',
    th: 'หลังจากเปิดใช้งาน เฉพาะแผ่นที่ตรงตามวัสดุในตารางเท่านั้นจะเปิดใช้งานฟังก์ชันการตัดครั้งที่สอง',
    ug: 'قوزغىتىلغاندا جەدۋەل ماتېرىيالىغا توغرا كېلىدىغان تاختىلار ئىككىنچى قېتىم قېپىش فۇنكسىيىسىنى ئىشلەيدۇ',
    vi: 'Sau khi kích hoạt, chức năng cắt thứ cấp chỉ sẽ có hiệu lực đối với các tấm ván đáp ứng yêu cầu vật liệu của bảng.',
    zh_tc: '啟用後滿足表格材質的板件才會生效二次切割功能',
    ru: 'Функция вторичной резки вступает в силу после включения панелей, удовлетворяющих материалу формы',
    ko: '사용으로 설정하면 테이블 재료에 맞는 보드에 2차 가공 기능이 적용됩니다.',
    bur: 'ဖွင့်ပြီးနောက်ဇယားပစ္စည်းနှင့်ပြည့်မီပြားများသာဒုတိယဖြတ်သက်ရောက်',
    ben: 'সক্ষম করার পর টেবিলের ম্যাটেরিয়াল শর্ত পূরণকারী প্যানেলেই সেকেন্ডারি কাটিং কার্যকর হবে',
    tr: 'Açıldığında yalnızca tablodaki malzeme koşulunu sağlayan plakalarda ikinci kesim uygulanır',
    km: 'បើករួច ការកាត់លើកពីរមានប្រសិទ្ធភាពតែលើផ្ទាំងដែលត្រូវនឹងវត្ថុធាតុក្នុងតារាង',
    es: 'Después de habilitarla, la función de corte secundario solo será eficaz para paneles que cumplan con el material de la mesa',
    ar: 'بعد تمكينها، ستكون وظيفة القطع الثانوية فعالة فقط للألواح التي تفي بمواد الجدول',
  },
  'cuttingDock.cuttingParams.dispersePaibanTipOne': {
    zh: '启用后每张大板上会至少排一张满足最小可吸住尺寸的板件',
    en: 'After enabling, at least one panel that meets the minimum size that can be absorbed will be arranged on each large board',
    id: '1. Setelah aktivasi, setidaknya satu pelat pada setiap papan besar akan memenuhi ukuran minimum yang dapat diserap.',
    kz: '1. Қосу қıldıңнан кейін, әңгімедегі материал талаптарын қамтамасын қабылдайтын панелдер үчүн ғана әсер қажет.',
    th: '1. หลังจากการเปิดใช้งานอย่างน้อยหนึ่งแผ่นในแต่ละบอร์ดขนาดใหญ่จะเป็นไปตามขนาดที่ดูดซับได้ขั้นต่ำ',
    ug: 'قوزغىتىلغاندا ھەر بىر چوڭ تاختىدا ئەڭ كىچىك تۇتۇشقا بولىدىغان چوڭلۇقتىكى بىر تاختا بولىدۇ',
    vi: 'Sau khi kích hoạt, trên mỗi bảng lớn sẽ có ít nhất một tấm đáp ứng kích thước tối thiểu có thể hấp thụ',
    zh_tc: '1、啟用後每張大板上會至少一張滿足最小可吸住尺寸的板件',
    ru: 'После включения на каждой большой доске будет по крайней мере одна пластина, соответствующая минимальному размеру всасывания.',
    ko: '활성화되면 각 보드에 최소 흡입 가능 크기를 충족하는 보드가 하나 이상 배치됩니다.',
    bur: 'ဖွင့်ပြီးနောက်ကြီးပြားတစ်ချပ်တွင်အနည်းဆုံးစုပ်ထားနိုင်အရွယ်ပြည့်မီပြားတစ်ချပ်စီစီမည်',
    ben: 'সক্ষম করার পর প্রতিটি বড় বোর্ডে সর্বনিম্ন সাকশন সাইজ পূরণকারী অন্তত একটি প্যানেল সাজানো হবে',
    tr: '1. Açıldığında her büyük plakada en az bir adet minimum tutulabilir boyutu sağlayan plaka yerleştirilir',
    km: '១. បើករួច លើផ្ទាំងធំគ្រប់សន្លឹកមានយ៉ាងហោចណាស់មួយផ្ទាំងដែលត្រូវទំហំច្របាក់តូបរមា',
    es: '. Después de habilitarlo, se colocará al menos un panel que cumpla con el tamaño mínimo de succión en cada tablero grande',
    ar: '. بعد تمكينه، سيتم ترتيب لوحة واحدة على الأقل تلبي الحد الأدنى لحجم الشفط على كل لوحة كبيرة',
  },
  'cuttingDock.cuttingParams.dispersePaibanTipTwo': {
    zh: '2、注意使用后可能会增加大板量',
    en: 'Attention After using, the amount of large boards may increase',
    id: '2. Perhatikan kemungkinan meningkatkan volume pelat besar setelah digunakan',
    kz: '2. Қосу қıldıңнан кейін, әңгімедегі материал талаптарын қамтамасын қабылдайтын панелдер үчүн ғана әсер қажет.',
    th: '2. ให้ความสนใจกับความเป็นไปได้ในการเพิ่มปริมาณแผ่นขนาดใหญ่หลังการใช้งาน',
    ug: '2، ئىشلىتىلگەندە چوڭ تاختا مىقدارى ئاشىشى مۇمكىن',
    vi: 'Lưu ý: Sau khi sử dụng, số lượng bảng lớn có thể tăng',
    zh_tc: '2、注意使用後可能會增加大板量',
    ru: '2) Обратите внимание, что после использования может увеличиться количество пластин',
    ko: '2、사용 후 대판량이 증가할 수 있으니 주의하세요',
    bur: '၂、သုံးပြီးနောက်ကြီးပြားအရေအတွက်တိုးနိုင်သတိပြုပါ',
    ben: 'নোট: ব্যবহারের পর বড় বোর্ডের পরিমাণ বাড়তে পারে',
    tr: '2. Kullanımdan sonra büyük plaka miktarı artabilir; dikkat',
    km: '២. ប្រើរួច ចំនួនផ្ទាំងធំអាចកើន សូមចំណាំ',
    es: '2. Tenga en cuenta que la cantidad de paneles grandes puede aumentar después del uso',
    ar: '2. لاحظ أن كمية الألواح الكبيرة قد تزيد بعد الاستخدام',
  },
  'cuttingDock.cuttingParams.totalThickLimit': {
    zh: '三次分层切割的总和必须等于板件厚度',
    en: 'The Sum of Three-Layer Cutting Must Equal the Thickness of the Board Piece',
    id: 'Jumlah dari tiga lapisan pemotongan harus sama dengan ketebalan pelat',
    kz: 'Үш рет қатламдық кесудің толық қалыңдығы панельдің қалыңдығына тең болуы тиіс',
    th: 'ผลรวมของการตัดทั้งสามชั้นจะต้องเท่ากับความหนาของแผ่น',
    ug: 'ئۈچ قاتلام قېپىشنىڭ جەمئىي تاختىنىڭ قېلىنلىقىغا تەڭ بولۇشى كېرەك',
    vi: 'Tổng độ dày của ba tầng cắt phải bằng với độ dày tấm',
    zh_tc: '三次分層切割的總和必須等於板件厚度',
    ru: 'Сумма тройной стратификации должна быть равна толщине пластины.',
    ko: '세 번째 계층 컷의 합계는 보드 두께와 같아야 합니다.',
    bur: 'သုံးလွှာဖြတ်စုစုပေါင်းပြားအထူနှင့်ညီရမည်',
    ben: 'তিন লেয়ার কাটের সমষ্টি বোর্ড পিসের বেধের সমান হতে হবে',
    tr: 'Üç katmanlı kesimlerin toplamı plaka kalınlığına eşit olmalıdır',
    km: 'ផលបូកកាត់បីស្រទាប់ត្រូវស្មើកម្រាស់ផ្ទាំង',
    es: 'La suma de los tres cortes en capas debe ser igual al grosor del tablero',
    ar: 'يجب أن يكون مجموع القطع الثلاثة ذات الطبقات مساويًا لسمك اللوحة',
  },
  'cuttingDock.cuttingParams.offsetFollowStep': {
    zh: '修边也跟随分层切割',
    en: 'Trimming Also Follows Layered Cutting',
    id: 'Pemangkasan tepi juga diikuti oleh pemotongan lapisan',
    kz: 'Солтү кесу де қатламдық кесуге сәйкес келеді',
    th: 'การตัดขอบตามด้วยการตัดเลเยอร์',
    ug: 'چېگرا قېپىشمۇ قاتلام قېپىشكە ئەگەشىدۇ',
    vi: 'Điều chỉnh cạnh cũng theo cắt tầng',
    zh_tc: '修邊也跟隨分層切割',
    ru: 'Ремонт также сопровождается слоистой резкой.',
    ko: '트림된 모서리도 계층형 컷을 따릅니다.',
    bur: 'အစွန်းပြင်သည်အလွှာခွဲဖြတ်ကိုလိုက်',
    ben: 'ট্রিমিংও লেয়ার্ড কাটিং অনুসরণ করে',
    tr: 'Kenar düzeltme de katmanlı kesimi izler',
    km: 'ការកែគែមក៏ធ្វើតាមការកាត់ជាស្រទាប់',
    es: 'El recorte también sigue al corte en capas',
    ar: 'يتبع التشذيب أيضًا قطع الطبقات',
  },
  'cuttingDock.cuttingParams.longPlankTip1': {
    zh: '1、开启或关闭此功能后保存历史中的排版记录在下载NC时需进行重新排版',
    en: '1. After enabling or disabling this feature, layout records saved in history require re-layout when downloading NC.',
    id: '1. Setelah mengaktifkan atau menonaktifkan fungsi ini, catatan tata letak yang tersimpan dalam riwayat perlu ditata ulang saat mengunduh NC.',
    kz: '1. Бұл функцияны қосқаннан немесе өшіргеннен кейін тарихта сақталған орналасу жазбалары NC жүктеген кезде қайта орналастырылуы керек',
    th: '1. หลังจากเปิดหรือปิดฟังก์ชันนี้ บันทึกการจัดเลย์เอาต์ในประวัติที่บันทึกไว้ต้องจัดเลย์เอาต์ใหม่เมื่อดาวน์โหลด NC',
    ug: '1، بۇ فۇنكسىيەنى قوزغىتىش ياكى ئۆچۈرگەندىن كېيىن تارىختا ساقلانغان تەڭشەش خاتىرىلىرى NC چۈشۈرگەندە قايتا تەڭشەش تەلەپ قىلىنىدۇ',
    vi: '1. Sau khi bật hoặc tắt chức năng này, các bản ghi bố trí đã lưu trong lịch sử cần bố trí lại khi tải xuống NC',
    zh_tc: '1、開啟或關閉此功能後保存歷史中的排版記錄在下載NC時需進行重新排版',
    ru: '1. После включения или отключения этой функции записи раскладки, сохранённые в истории, при загрузке NC требуют повторной раскладки',
    ko: '1. 이 기능을 켜거나 끈 후, 기록에 저장된 조판 기록은 NC를 다운로드할 때 다시 조판해야 합니다',
    bur: '၁、ဤလုပ်ဆောင်ချက်ဖွင့်/ပိတ်ပြီးနောက်သမိုင်းတွင် သိမ်းထားသော ပြင်ဆင်မှတ်တမ်းများကို NC ဆွဲသည့်အခါ ပြန်ပြင်ဆင်ရမည်',
    ben: '১. এই ফিচার চালু/বন্ধ করার পর ইতিহাসে সংরক্ষিত লেআউট রেকর্ড NC ডাউনলোডের সময় পুনরায় লেআউট করা প্রয়োজন।',
    tr: '1. Bu işlev açılıp kapatıldıktan sonra geçmişte kayıtlı yerleşim kayıtları NC indirilirken yeniden yerleştirilmelidir',
    km: '១. បើក/បិទមុខងារនេះរួច កំណត់ត្រារៀបចំដែលបានរក្សាទុកក្នុងប្រវត្តិ ត្រូវរៀបចំឡើងវិញនៅពេលទាញយក NC',
    es: '1. Tras activar o desactivar esta función, los registros de diseño guardados en el historial requieren un nuevo diseño al descargar NC.',
    ar: '1. بعد تشغيل هذه الوظيفة أو إيقافها، تتطلب سجلات التخطيط المحفوظة في السجل إعادة التخطيط عند تنزيل NC.',
  },
  'cuttingDock.cuttingParams.longPlankTip2': {
    zh: '2、启用该功能后必须在【开料对接-真空泵暂停】中设置真空泵暂停代码，否则无法解决长板切割弯曲的问题',
    en: '2. After enabling this feature, you must set the vacuum pump pause code in [Cutting Machine Docking - Vacuum Pump Pause]; otherwise bending when cutting long boards cannot be resolved.',
    id: '2. Setelah mengaktifkan fungsi ini, Anda harus mengatur kode jeda pompa vakum di [Memotong docking - Jeda pompa vakum]; jika tidak, masalah lentur saat memotong pelat panjang tidak dapat diselesaikan.',
    kz: '2. Бұл функция іске қосылғаннан кейін [Кескіш машинаны қосу - Вакуумдық сорғыны тоқтату] бөлімінде вакуумдық сорғыны тоқтату кодын орнату керек, әйтпесе ұзын панельді кескендегі іілу мәселесін шешу мүмкін емес',
    th: '2. หลังจากเปิดใช้งานฟังก์ชันนี้ คุณต้องตั้งรหัสหยุดชั่วคราวของปั๊มสูญญากาศใน [ตัดการเชื่อมต่อ - ปั๊มสูญญากาศหยุดชั่วคราว] มิฉะนั้นจะแก้ปัญหาแผ่นยาวโค้งขณะตัดไม่ได้',
    ug: '2، بۇ فۇنكسىيە قوزغىتىلغاندىن كېيىن چوقۇم 【قېپىش مۇناسىۋىتى-ۋاكۇم پومپا توختىتىش】 دىكى ۋاكۇم پومپا توختىتىش كودىنى تەڭشەڭ، بولمىسا ئۇزۇن تاختا قېپىش ئېگىلىش مەسىلىسىنى ھەل قىلالمايدۇ',
    vi: '2. Sau khi bật chức năng này, phải thiết lập mã tạm dừng bơm chân không trong [Đối tiếp Khai Liệu - Tạm dừng bơm chân không]; nếu không không thể giải quyết vấn đề cong khi cắt tấm dài',
    zh_tc:
      '2、啟用該功能後必須在【開料對接-真空泵暫停】中設置真空泵暫停代碼，否則無法解決長板切割彎曲的問題',
    ru: '2. После включения этой функции необходимо установить код паузы вакуумного насоса в разделе «стыковка с открытой загрузкой — Вакуумный насос выключен», иначе не удастся решить проблему изгиба длинной пластины при резке',
    ko: '2. 이 기능을 활성화한 후 반드시 [재료 도킹 - 진공 펌프 정지]에서 진공 펌프 일시정지 코드를 설정해야 하며, 그렇지 않으면 장판 절단 시 휨 문제를 해결할 수 없습니다',
    bur: '၂、ဤလုပ်ဆောင်ချက်ဖွင့်ပြီးနောက်ဖြတ်တောက်ချိတ်ဆက်-ဗက်ကြူးပမ်ခဏရပ်တွင်ဗက်ကြူးပမ်ခဏရပ်ကုဒ်သတ်မှတ်ရမည်၊ မဟုတ်ရှည်ပြားဖြတ်ကွေးမရ',
    ben: '২. এই ফিচার সক্ষম করার পর [কাটিং মেশিন ডকিং - ভ্যাকুয়াম পাম্প পজ]-এ ভ্যাকুয়াম পাম্প পজ কোড সেট করতে হবে, নাহলে লং বোর্ড কাটার বেন্ড সমস্যা সমাধান হবে না।',
    tr: '2. Bu işlev açıldıktan sonra [Kesim makinesi eşleştirme - Vakum pompası duraklatma] bölümünde vakum duraklatma kodu ayarlanmalıdır; aksi halde uzun plaka eğilmesi giderilemez',
    km: '២. បើកមុខងារនេះរួច ត្រូវកំណត់កូដផ្អាកប៉ំបូមសុញ្ញាកាសនៅ [ការភ្ជាប់ម៉ាស៊ីនកាត់ - ផ្អាកប៉ំបូមសុញ្ញាកាស] បើមិនដូច្នោះទេ មិនអាចដោះស្រាយការបត់ផ្ទាំងវែងបាន',
    es: '2. Tras activar esta función, debe configurar el código de pausa de la bomba de vacío en [Apertura y acoplamiento - Pausa de bomba de vacío]; de lo contrario, no se puede resolver el problema de flexión al cortar placas largas.',
    ar: '2. بعد تمكين هذه الوظيفة، يجب ضبط رمز إيقاف مضخة التفريغ مؤقتًا في [الفتح والإرساء - إيقاف مضخة التفريغ]، وإلا لا يمكن حل مشكلة انحناء اللوح الطويل عند القطع.',
  },
  'cuttingDock.cuttingParams.longPlankTip3': {
    zh: '3、下方已开启的筛选条件按层级依次校验，只有满足上一级筛选条件的板件，才可进入下一级筛选条件进行判定',
    en: "3. The filter conditions enabled below are validated sequentially by level; only boards that meet the previous level's filter conditions can proceed to the next level's filter conditions for evaluation.",
    id: '3. Kondisi filter yang diaktifkan di bawah divalidasi secara berurutan menurut tingkat; hanya papan yang memenuhi kondisi filter tingkat sebelumnya yang dapat masuk ke kondisi filter tingkat berikutnya untuk dinilai.',
    kz: '3. Төменде қосылған сүзгі шарттары деңгей бойынша ретімен тексеріледі; алдыңғы деңгейдің сүзгі шарттарын қанағаттандырған панельдер ғана келесі деңгейдің сүзгі шарттарына өтіп, бағалануға жатады.',
    th: '3. เงื่อนไขการกรองที่เปิดใช้งานด้านล่างจะตรวจสอบตามลำดับชั้น มีเพียงแผ่นที่ตรงตามเงื่อนไขการกรองของระดับก่อนหน้าเท่านั้นที่จะเข้าสู่เงื่อนไขการกรองของระดับถัดไปเพื่อพิจารณา',
    ug: '3، تۆۋەندى قوزغىتىلغان سۈزگۈچ شەرتلىرى قاتلام بويىچە تەرتىپلىك تەكشۈرۈلىدۇ، پەقەت ئالدىنقى دەرىجىدىكى سۈزگۈچ شەرتلىرىگە ماس كېلىدىغان تاختا لاشەلەرلا كېيىنكى دەرىجىدىكى سۈزگۈچ شەرتلىرىگە كىرىپ باھالىنىدۇ',
    vi: '3. Các điều kiện lọc đã bật bên dưới được kiểm tra tuần tự theo từng cấp; chỉ các tấm thỏa mãn điều kiện lọc của cấp trước mới được đưa vào điều kiện lọc của cấp tiếp theo để đánh giá.',
    zh_tc:
      '3、下方已開啟的篩選條件按層級依次校驗，只有滿足上一級篩選條件的板件，才可進入下一級篩選條件進行判定',
    ru: '3. Включённые ниже условия фильтрации проверяются последовательно по уровням; только панели, соответствующие условиям фильтрации предыдущего уровня, могут перейти к условиям фильтрации следующего уровня для оценки.',
    ko: '3. 아래에서 활성화된 필터 조건은 계층별로 순서대로 검증되며, 이전 단계의 필터 조건을 충족한 보드만 다음 단계의 필터 조건으로 들어가 판정됩니다.',
    bur: '၃、အောက်တွင်ဖွင့်ထားသော စစ်ထုတ်မှုအခြေအနေများကို အဆင့်လိုက် စနစ်တကျ စစ်ဆေးသည်၊ ယခင်အဆင့်စစ်ထုတ်မှုအခြေအနေများနှင့် ကိုက်ညီသည့်ပြားများသာ နောက်အဆင့်စစ်ထုတ်မှုအခြေအနေသို့ ဝင်ရောက်စိစစ်ခံရသည်။',
    ben: '৩. নিচে সক্রিয় ফিল্টার শর্তগুলো স্তর অনুযায়ী যাচাই হয়; কেবল যেসব বোর্ড পূর্ববর্তী স্তরের ফিল্টার শর্ত পূরণ করে, সেগুলোই পরবর্তী স্তরের ফিল্টার শর্তে প্রবেশ করে মূল্যায়ন করা যায়।',
    tr: '3. Aşağıda etkin filtre koşulları seviye seviye sırayla doğrulanır; yalnızca bir önceki seviyenin filtre koşullarını karşılayan plakalar, bir sonraki seviyenin filtre koşullarına geçerek değerlendirilir.',
    km: '៣. លក្ខខណ្ឌចម្រោះដែលបើកខាងក្រោមត្រូវផ្ទៀងផ្ទាត់តាមជាន់ជាលំដាប់ មានតែផ្ទាំងដែលបំពេញលក្ខខណ្ឌចម្រោះនៃជាន់មុនប៉ុណ្ណោះដែលអាចចូលទៅលក្ខខណ្ឌចម្រោះជាន់បន្ទាប់ដើម្បីវាយតម្លៃ។',
    es: '3. Las condiciones de filtro activadas abajo se validan secuencialmente por niveles; solo las piezas que cumplan las condiciones de filtro del nivel anterior pueden pasar a las condiciones de filtro del siguiente nivel para su evaluación.',
    ar: '3. تُفحص شروط التصفية المفعّلة أدناه بالتتابع حسب المستويات؛ لا تُقيَّم الألواح إلا إذا استوفت شروط تصفية المستوى السابق قبل الدخول إلى شروط تصفية المستوى التالي.',
  },
  'cuttingDock.cuttingParams.secondCutting': {
    zh: '二次切割对象',
    en: 'Secondary cutting object',
    id: 'Objek pemotongan sekunder',
    kz: 'Екінші рет кесу объекті',
    th: 'วัตถุตัดทุติยภูมิ',
    ug: 'ئىككىنچى قېتىم قېپىش نىشانى',
    vi: 'Đối tượng cắt gọt lần hai',
    zh_tc: '二次切割對象',
    ru: 'Объект вторичной резки',
    ko: '객체 2차 가공',
    bur: 'ဒုတိယဖြတ်ပစ်မှတ်',
    ben: 'সেকেন্ডারি কাটিং অবজেক্ট',
    tr: 'İkinci kesim hedefi',
    km: 'គោលដៅកាត់លើកទីពីរ',
    es: 'Tableros regulares de objetos de corte secundario',
    ar: 'الألواح العادية لأشياء القطع الثانوية',
  },
  'cuttingDock.cuttingParams.normalPlank': {
    zh: '的常规板',
    en: 'Regular board',
    id: 'Dewan reguler',
    kz: 'қалыпты панельдің',
    th: 'บอร์ดทั่วไป',
    ug: 'نورمال تاختا',
    vi: 'tấm thông thường',
    zh_tc: '的常規板',
    ru: 'Обычная доска',
    ko: '일반 보드',
    bur: 'ပုံမှန်ပြား',
    ben: 'নিয়মিত বোর্ড',
    tr: 'standart plaka',
    km: 'ផ្ទាំងធម្មតា',
    es: 'Regular board',
    ar: 'Regular board',
  },
  'cuttingDock.cuttingParams.normalPlankTip': {
    zh: '常规板：柜体中横竖隔板等非柜门的板件和开料清单中直接添加的板件',
    en: 'Regular board: boards such as cross and vertical partitions in the cabinet body, and boards added directly in the material cutting list, excluding cabinet doors.',
    id: 'Papan konvensional: Partisi horizontal dan vertikal di badan kabinet dan pintu dan papan non-kabinet lainnya ditambahkan langsung ke daftar material',
    kz: 'қалыпты панель: шкафтің ішкі және сыртқы ірі панельдері және кесу тізімінде тікелей қосылған панельдер',
    th: 'บอร์ดทั่วไป: พาร์ทิชันแนวนอนและแนวตั้งในตัวตู้และประตูและบอร์ดที่ไม่ใช่รถตู้อื่น ๆ เพิ่มโดยตรงในรายการวัสดุ',
    ug: 'نورمال تاختا: قابنىڭ ئىچىدىكى توغرا-توغرا بولمىغان تاختا ۋە قاب ئىچىگە قوشۇلغان تاختا',
    vi: 'Tấm thông thường: các tấm ngăn ngang, dọc trong tủ, các tấm không phải là cửa tủ, và các tấm được thêm trực tiếp vào danh sách cắt gọt',
    zh_tc: '常規板：櫃體中橫豎隔板等非櫃門的板件和開料清單中直接添加的板件',
    ru: 'Обычные панели: панели для дверей, не относящихся к шкафу, такие как поперечные и вертикальные перегородки в шкафу, и панели, добавленные непосредственно в список открытых материалов',
    ko: '일반판: 캐비닛에 가로세로 칸막이 등 캐비닛 문이 아닌 판재와 개료 명세서에 직접 추가된 판재',
    bur: 'ပုံမှန်ပြား-ကက်ဘိနက်အတွင်းအလျားလိုက်ထောင်လိုက်ကား၊ ဖြတ်တောက်စာရင်းတွင်တိုက်ရိုက်ထည့်ထားပြား၊ ကက်ဘိနတံခါးမပါ',
    ben: 'নিয়মিত বোর্ড: ক্যাবিনেট বডিতে ক্রস ও ভার্টিক্যাল পার্টিশন ইত্যাদি নন-ক্যাবিনেট দরজা বোর্ড এবং কাটিং লিস্টে সরাসরি যোগ করা বোর্ড',
    tr: 'Standart plaka: gövdede yatay/dikey bölmeler gibi dolap kapısı olmayan parçalar ve kesim listesine doğrudan eklenen plakalar',
    km: 'ផ្ទាំងធម្មតា៖ ផ្ទាំងដូចជាបន្ទាត់ផ្តេក/បញ្ឈរក្នុងទូ និងផ្ទាំងដែលបន្ថែមដោយផ្ទាល់ទៅបញ្ជីកាត់ មិនរួមបញ្ចូលទ្វារទូ',
    es: 'Tableros regulares: paneles que no sean puertas de gabinete, como particiones horizontales y verticales en el gabinete y paneles agregados directamente en la lista de corte',
    ar: 'الألواح العادية: ألواح أخرى غير أبواب الخزانات مثل الأقسام الأفقية والرأسية في الخزانة والألواح المضافة مباشرة في قائمة القطع',
  },
  'cuttingDock.cuttingParams.designatedTarget': {
    zh: '指定对象',
    en: 'Designated objects',
    id: 'Objek yang ditentukan',
    kz: 'Белгіленген объектілер',
    th: 'วัตถุที่กำหนด',
    ug: 'بەلگىلەنگەن نەرسە',
    vi: 'Đối tượng chỉ định',
    zh_tc: '指定對象',
    ru: 'Указанные объекты',
    ko: '지정 대상',
    bur: 'သတ်မှတ်အရာဝတ္ထု',
    ben: 'নির্দিষ্ট অবজেক্ট',
    tr: 'Belirlenen nesneler',
    km: 'វត្ថុដែលបានកំណត់',
    es: 'Objetos designados',
    ar: 'الكائنات المحددة',
  },
  'cuttingDock.cuttingParams.filterLevel1Label': {
    zh: '一级筛选',
    en: 'Level 1 filter',
    id: 'Filter tingkat 1',
    kz: '1-деңгей сүзгі',
    th: 'การกรองระดับ 1',
    ug: 'بىرىنچى دەرىجىلىك سۈزگۈچ',
    vi: 'Lọc cấp 1',
    zh_tc: '一級篩選',
    ru: 'Фильтр 1 уровня',
    ko: '1차 필터',
    bur: 'အဆင့်တစ်စစ်ထုတ်',
    ben: 'প্রথম স্তর ফিল্টার',
    tr: '1. seviye filtre',
    km: 'តម្រង់កម្រិត១',
    es: 'Filtro nivel 1',
    ar: 'تصفية المستوى 1',
  },
  'cuttingDock.cuttingParams.filterLevel1Category': {
    zh: '板件类型',
    en: 'board type',
    id: 'jenis papan',
    kz: 'тақта түрі',
    th: 'ประเภทบอร์ด',
    ug: 'تاختا تىپى',
    vi: 'loại tấm',
    zh_tc: '板件類型',
    ru: 'тип панели',
    ko: '보드 유형',
    bur: 'ပြားအမျိုးအစား',
    ben: 'বোর্ড ধরন',
    tr: 'plaka tipi',
    km: 'ប្រភេទផ្ទាំង',
    es: 'tipo de panel',
    ar: 'نوع اللوحة',
  },
  'cuttingDock.cuttingParams.filterLevel2Label': {
    zh: '二级筛选',
    en: 'Level 2 filter',
    id: 'Filter tingkat 2',
    kz: '2-деңгей сүзгі',
    th: 'การกรองระดับ 2',
    ug: 'ئىككىنچى دەرىجىلىك سۈزگۈچ',
    vi: 'Lọc cấp 2',
    zh_tc: '二級篩選',
    ru: 'Фильтр 2 уровня',
    ko: '2차 필터',
    bur: 'အဆင့်နှစ်စစ်ထုတ်',
    ben: 'দ্বিতীয় স্তর ফিল্টার',
    tr: '2. seviye filtre',
    km: 'តម្រង់កម្រិត២',
    es: 'Filtro nivel 2',
    ar: 'تصفية المستوى 2',
  },
  'cuttingDock.cuttingParams.filterLevel2Category': {
    zh: '尺寸限制',
    en: 'size limits',
    id: 'batas ukuran',
    kz: 'өлшем шектеулері',
    th: 'จำกัดขนาด',
    ug: 'ئۆلچەم چەكلىمىسى',
    vi: 'giới hạn kích thước',
    zh_tc: '尺寸限制',
    ru: 'ограничение размеров',
    ko: '크기 제한',
    bur: 'အရွယ်အစားကန့်သတ်',
    ben: 'আকার সীমা',
    tr: 'boyut sınırı',
    km: 'កំណត់ទំហំ',
    es: 'límite de tamaño',
    ar: 'قيود الحجم',
  },
  'cuttingDock.cuttingParams.filterLevel3Label': {
    zh: '三级筛选',
    en: 'Level 3 filter',
    id: 'Filter tingkat 3',
    kz: '3-деңгей сүзгі',
    th: 'การกรองระดับ 3',
    ug: 'ئۈچىنچى دەرىجىلىك سۈزگۈچ',
    vi: 'Lọc cấp 3',
    zh_tc: '三級篩選',
    ru: 'Фильтр 3 уровня',
    ko: '3차 필터',
    bur: 'အဆင့်သုံးစစ်ထုတ်',
    ben: 'তৃতীয় স্তর ফিল্টার',
    tr: '3. seviye filtre',
    km: 'តម្រង់កម្រិត៣',
    es: 'Filtro nivel 3',
    ar: 'تصفية المستوى 3',
  },
  'cuttingDock.cuttingParams.filterLevel3Category': {
    zh: '其他',
    en: 'other',
    id: 'lainnya',
    kz: 'басқа',
    th: 'อื่นๆ',
    ug: 'باشقا',
    vi: 'khác',
    zh_tc: '其他',
    ru: 'прочее',
    ko: '기타',
    bur: 'အခြား',
    ben: 'অন্যান্য',
    tr: 'diğer',
    km: 'ផ្សេងៗ',
    es: 'otros',
    ar: 'أخرى',
  },
  'cuttingDock.cuttingParams.specifiedBoardForceEnable': {
    zh: '忽略尺寸/其他筛选条件，强制启用',
    en: 'Ignore size/other filters, force enable',
    id: 'Abaikan ukuran/filter lain, paksa aktifkan',
    kz: 'Өлшем/басқа сүзгілерді елемеу, мәжбүрлі қосу',
    th: 'ละเว้นขนาด/เงื่อนไขอื่น บังคับเปิดใช้',
    ug: 'ئۆلچەم/باشقا سۈزگۈچ شەرتلىرىنى ئۆتكۈزۈۋېتىش، مەجبۇرىي قوزغىتىش',
    vi: 'Bỏ qua kích thước/bộ lọc khác, bắt buộc bật',
    zh_tc: '忽略尺寸/其他篩選條件，強制啟用',
    ru: 'Игнорировать размер/другие фильтры, принудительно включить',
    ko: '크기/기타 필터 무시, 강제 활성화',
    bur: 'အရွယ်အစား/အခြားစစ်ထုတ်မှုကို လျစ်လျူရှု၊ အတင်းဖွင့်',
    ben: 'আকার/অন্যান্য ফিল্টার উপেক্ষা করে জোর করে চালু',
    tr: 'Boyut/diğer filtreleri yoksay, zorla etkinleştir',
    km: 'មិនអើពើទំហំ/តម្រង់ផ្សេង បង្ខំបើក',
    es: 'Ignorar tamaño/otros filtros, forzar activación',
    ar: 'تجاهل الحجم/شروط التصفية الأخرى، التفعيل الإجباري',
  },
  'cuttingDock.cuttingParams.curveMaterialFilterTip': {
    zh: '（勾选「异形板」后，板件必须先满足为异形板件的前置条件，才可进入后续材质筛选环节进行判定）',
    en: '(After checking "Irregular board", the board must first be irregular before material filtering applies)',
    id: '(Setelah centang "Papan tidak beraturan", papan harus memenuhi syarat papan tidak beraturan sebelum filter material)',
    kz: '(«Дөрекі емес тақта» белгіленгеннен кейін, материал сүзгісіне дейін тақта дөрекі емес болуы керек)',
    th: '(หลังเลือก "แผ่นรูปทรงพิเศษ" ต้องเป็นแผ่นรูปทรงพิเศษก่อนจึงจะกรองวัสดุได้)',
    ug: '(«غەيرىي شەكىللىك تاختا» نى تاللىغاندىن كېيىن، ماتېرىيال سۈزگۈچىگە كىرىشتىن بۇرۇن تاختا غەيرىي شەكىللىك بولۇشى كېرەك)',
    vi: '(Sau khi chọn "Tấm hình dạng đặc biệt", tấm phải là tấm đặc biệt trước khi lọc vật liệu)',
    zh_tc:
      '（勾選「異形板」後，板件必須先滿足為異形板件的前置條件，才可進入後續材質篩選環節進行判定）',
    ru: '(После выбора «Фигурная панель» панель должна быть фигурной до фильтрации по материалу)',
    ko: '(「이형 보드」 선택 후, 재질 필터 전에 이형 보드 조건을 먼저 만족해야 함)',
    bur: '(「ပုံသဏ္ဌာန်မမှန်ပြား」ရွေးပြီးနောက် ပစ္စည်းစစ်ထုတ်မီ ပုံသဏ္ဌာန်မမှန်ပြားဖြစ်ရမည်)',
    ben: '("অসম প্যানেল" চেক করার পর উপাদান ফিল্টারের আগে অসম প্যানেল হতে হবে)',
    tr: '("Düzensiz plaka" işaretlendikten sonra malzeme filtresinden önce düzensiz plaka olmalı)',
    km: '(បន្ទាប់ពីជ្រើស «ផ្ទាំងរាងមិនធម្មតា» ត្រូវជាផ្ទាំងរាងមិនធម្មតាមុនតម្រង់សម្ភារ)',
    es: '(Tras marcar "Panel irregular", debe ser irregular antes del filtro de material)',
    ar: '(بعد تحديد «لوحة غير منتظمة»، يجب أن تكون اللوحة غير منتظمة قبل تصفية المادة)',
  },
  'cuttingDock.cuttingParams.cuttingSettings': {
    zh: '切割设置',
    en: 'Cutting settings',
    id: 'Pengaturan pemotongan',
    kz: 'Кесу параметрлері',
    th: 'การตั้งค่าการตัด',
    ug: 'كېسىش تەڭشىكى',
    vi: 'Cài đặt cắt',
    zh_tc: '切割設置',
    ru: 'Настройки резки',
    ko: '절단 설정',
    bur: 'ဖြတ်သတ်မှုဆက်တင်',
    ben: 'কাটিং সেটিং',
    tr: 'Kesim ayarları',
    km: 'ការកំណត់កាត់',
    es: 'Configuración de corte',
    ar: 'إعدادات القطع',
  },
  'cuttingDock.cuttingParams.plankSizeLimitSuffix': {
    zh: '的板件',
    en: ' boards',
    id: ' papan',
    kz: ' тақталар',
    th: ' แผ่น',
    ug: ' تاختا',
    vi: ' tấm',
    zh_tc: '的板件',
    ru: ' панели',
    ko: ' 보드',
    bur: ' ပြား',
    ben: ' বোর্ড',
    tr: ' plakalar',
    km: ' ផ្ទាំង',
    es: ' paneles',
    ar: ' لوحات',
  },
  'cuttingDock.cuttingParams.specifiedBoard': {
    zh: '指定板名切割',
    en: 'Specify board name cutting',
    id: 'Tentukan nama pemotongan papan',
    kz: 'Тақта атауын кесуді көрсетіңіз',
    th: 'ระบุชื่อบอร์ดตัด',
    ug: 'تاختاي نامىنى كېسىشنى بەلگىلەڭ',
    vi: 'Chỉ định cắt tên tấm',
    zh_tc: '指定板名切割',
    ru: 'Укажите имя панели для резки',
    ko: '보드 이름 가공 지정하기',
    bur: 'ပြားအမည်သတ်မှတ်ဖြတ်',
    ben: 'বোর্ড নাম কাটিং নির্দিষ্ট করুন',
    tr: 'Plaka adına göre kesim',
    km: 'កាត់តាមឈ្មោះផ្ទាំង',
    es: 'Especifique el nombre del panel para cortar',
    ar: 'حدد اسم اللوحة للقطع',
  },
  'cuttingDock.cuttingParams.specifiedBoardTip': {
    zh: '开启后当板件名称中包含下方添加的板件名则生效二次切割',
    en: 'After activation, if the board name includes the board name added below, it will take effect for secondary cutting',
    id: 'Pemotongan kedua berlaku setelah dibuka jika nama pelat berisi nama pelat yang ditambahkan di bawah ini',
    kz: 'Ашылғаннан кейін, пластина атауы төменде қосылған пластина атауын қосқанда, қайталама кесу күшіне енеді',
    th: 'การตัดทุติยภูมิจะมีผลเมื่อชื่อของบอร์ดเพิ่มด้านล่างรวมอยู่ในชื่อของบอร์ดหลังจากเปิด',
    ug: 'ئېچىلغاندىن كېيىن، تەخسە ئىسمى تۆۋەندە قوشۇلغان تەخسە نامىنى ئۆز ئىچىگە ئالغاندا، ئىككىلەمچى كېسىش كۈچكە ئىگە بولىدۇ',
    vi: 'Khi tên tấm được thêm vào bên dưới được bao gồm trong tên tấm, cắt thứ cấp có hiệu lực',
    zh_tc: '開啟後當板件名稱中包含下方添加的板件名則生效二次切割',
    ru: 'После открытия, когда имя панели содержит имя панели, добавленное ниже, вступает в силу вторичная резка',
    ko: '열려 있는 경우 아래에 추가된 보드 이름이 보드 이름 내에 포함되면 2차 가공이 적용됩니다.',
    bur: 'ဖွင့်ပြီးပြားအမည်တွင်အောက်ထည့်ထားပြားအမည်ပါသည့်အခါဒုတိယဖြတ်သက်ရောက်',
    ben: 'চালু করার পর বোর্ড নামে নিচে যোগ করা বোর্ড নাম থাকলে সেকেন্ডারি কাটিং কার্যকর হবে',
    tr: 'Açıldığında plaka adı aşağıya eklenen adı içeriyorsa ikinci kesim uygulanır',
    km: 'បើករួច ពេលឈ្មោះផ្ទាំងមានឈ្មោះដែលបន្ថែមខាងក្រោម ការកាត់លើកពីរមានប្រសិទ្ធភាព',
    es: 'Después de activarlo, el corte secundario tendrá efecto cuando el nombre del panel contenga el nombre del panel agregado a continuación.',
    ar: 'بعد تشغيلها، سيصبح القطع الثانوي ساري المفعول عندما يحتوي اسم اللوحة على تمت إضافة اسم اللوحة أدناه.',
  },
  'cuttingDock.cuttingParams.addPlankName': {
    zh: '添加板件名',
    en: 'Add board name',
    id: 'Tambahkan Nama Papan',
    kz: 'Тақта атын қосыңыз',
    th: 'เพิ่มชื่อบอร์ด',
    ug: 'تاختاي نامىنى قوشۇڭ',
    vi: 'Thêm tên bảng',
    zh_tc: '添加板件名',
    ru: 'Добавить имя панели',
    ko: '보드 이름 추가',
    bur: 'ပြားအမည်ထည့်',
    ben: 'বোর্ড নাম যোগ করুন',
    tr: 'Plaka adı ekle',
    km: 'បន្ថែមឈ្មោះផ្ទាំង',
    es: 'Agregar un nombre de placa',
    ar: 'أضف اسم لوحة',
  },
  'cuttingDock.cuttingParams.plankNameEmpty': {
    zh: '板件名不能为空，请输入',
    en: 'Board name cannot be empty, please enter',
    id: 'Nama papan tidak boleh kosong, silakan masukkan',
    kz: 'Тақта атауы бос болмауы керек, енгізіңіз',
    th: 'ชื่อบอร์ดไม่สามารถเว้นว่างได้ กรุณากรอก',
    ug: 'تەخسە نامى بوش بولسا بولمايدۇ، كىرگۈزۈڭ',
    vi: 'Tên bảng không được để trống, vui lòng nhập',
    zh_tc: '板件名不能為空，請輸入',
    ru: 'Имя панели не может быть пустым, введите',
    ko: '보드 이름은 비워둘 수 없습니다. 입력하십시오.',
    bur: 'ပြားအမည်ဗလာမရ၊ ထည့်ပါ',
    ben: 'বোর্ড নাম খালি থাকতে পারবে না, লিখুন',
    tr: 'Plaka adı boş olamaz; girin',
    km: 'ឈ្មោះផ្ទាំងមិនអាចទទេ សូមបញ្ចូល',
    es: 'El nombre de la placa no puede estar vacío, ingrese',
    ar: 'لا يمكن أن يكون اسم اللوحة فارغًا، يرجى إدخال',
  },
  'cuttingDock.cuttingParams.plankNameRequired': {
    zh: '请至少添加一个板件名',
    en: 'Please add at least one board name',
    id: 'Silakan tambahkan setidaknya satu nama papan',
    kz: 'Кем дегенде бір тақта атауын қосыңыз',
    th: 'กรุณาเพิ่มชื่อบอร์ดอย่างน้อยหนึ่งรายการ',
    ug: 'ھەئقەللا بىر تەخسە نامى قوشۇڭ',
    vi: 'Vui lòng thêm ít nhất một tên bảng',
    zh_tc: '請至少添加一個板件名',
    ru: 'Пожалуйста, добавьте хотя бы одно имя панели',
    ko: '하나 이상의 보드 이름을 추가하십시오.',
    bur: 'အနည်းဆုံးပြားအမည်တစ်ခုထည့်ပါ',
    ben: 'অন্তত একটি বোর্ড নাম যোগ করুন',
    tr: 'En az bir plaka adı ekleyin',
    km: 'សូមបន្ថែមយ៉ាងហោចណាស់មួយឈ្មោះផ្ទាំង',
    es: 'Agregue al menos un nombre de placa',
    ar: 'يرجى إضافة اسم لوحة واحد على الأقل',
  },
  'cuttingDock.cuttingParams.plankLongLimit': {
    zh: '当长板长边超过',
    en: 'The long side exceeds',
    id: 'Ketika sisi panjang papan melebihi',
    kz: 'Ұазырлы бұрышты асқан',
    th: 'เมื่อด้านยาวของบอร์ดเกินกว่า',
    ug: 'ئۇزۇن تاختا ئۇزۇن چېگرىسى ئاشقاندا',
    vi: 'Cạnh dài vượt quá',
    zh_tc: '當長板長邊超過',
    ru: 'Когда длинные края превышают',
    ko: '널빤지 길이가 길면',
    bur: 'ရှည်ပြားရှည်ဘက်ကျော်သည့်အခါ',
    ben: 'লং সাইড অতিক্রম করলে',
    tr: 'Uzun plakanın uzun kenarı şunu aştığında',
    km: 'ពេលគែមវែងនៃផ្ទាំងវែងលើស',
    es: 'Cuando el lado largo de la placa larga excede',
    ar: 'عندما يتجاوز الجانب الطويل من اللوحة الطويلة',
  },
  'cuttingDock.cuttingParams.plankShortLimit': {
    zh: '短边超过',
    en: 'The short side exceeds',
    id: 'Sisi pendek melebihi',
    kz: 'Қысқа егісі',
    th: 'ด้านสั้นเกินกว่า',
    ug: 'قىسقا چېگرىسى ئاشقاندا',
    vi: 'chiều ngắn vượt quá',
    zh_tc: '短邊超過',
    ru: 'Краткое превышение',
    ko: '짧은 모서리 초과',
    bur: 'တိုဘက်ကျော်',
    ben: 'শর্ট সাইড অতিক্রম করলে',
    tr: 'Kısa kenar şunu aştığında',
    km: 'ពេលគែមខ្លីលើស',
    es: 'El lado corto excede',
    ar: 'يتجاوز الجانب القصير',
  },
  'cuttingDock.cuttingParams.cuttingSplit': {
    zh: '分两次切割',
    en: 'Cut in two steps',
    id: 'Potong dua kali',
    kz: 'Екі рет кесу',
    th: 'ตัดสองครั้ง',
    ug: 'ئىككى قېتىم قېپىش',
    vi: 'Cắt gọt hai lần',
    zh_tc: '分兩次切割',
    ru: 'Разделить на две части',
    ko: '두 차례로 나누어 절단하다.',
    bur: 'နှစ်ကြိမ်ခွဲဖြတ်',
    ben: 'দুই ধাপে কাটুন',
    tr: 'İki aşamada kes',
    km: 'កាត់ពីរដំណាក់កាល',
    es: 'Corte en dos veces',
    ar: 'القطع مرتين',
  },
  'cuttingDock.cuttingParams.longExpand': {
    zh: '首次切割放量：长边放量',
    en: 'First cutting allowance: Long side allowance',
    id: 'Volume Potong Pertama: Volume Sisi Panjang',
    kz: 'Бірінші рет кесудің кеңейту дережесі: uzun егіс кеңейту',
    th: 'ปริมาตรการตัดครั้งแรก: ปริมาตรด้านข้างยาว',
    ug: 'بىرىنچى قېتىم قېپىش كېڭەيتىش: ئۇزۇن چېگرا كېڭەيتىش',
    vi: 'Điều chỉnh chiều dài lần đầu tiên:',
    zh_tc: '首次切割放量：長邊放量',
    ru: 'Выбросы при первой резки: выбросы при длинной кромке',
    ko: '첫 번째 컷 방량: 긴 모서리 방량',
    bur: 'ပထမဖြတ်ထပ်မံ-ရှည်ဘက်ထပ်မံ',
    ben: 'প্রথম কাটিং অ্যালাওয়্যান্স: লং সাইড অ্যালাওয়্যান্স',
    tr: 'İlk kesim payı: uzun kenar payı',
    km: 'ការបញ្ចេញលើកទីមួយ៖ បញ្ចេញគែមវែង',
    es: 'Primer peso de corte: peso del lado largo',
    ar: 'وزن القطع الأول: وزن الجانب الطويل',
  },
  'cuttingDock.cuttingParams.firstExpand': {
    zh: '首次切割放量',
    en: 'First cutting allowance',
    id: 'Volume pemotongan pertama',
    kz: 'Алғашқы кесуде кеңейту',
    th: 'ปริมาณการตัดครั้งแรก',
    ug: 'بىرىنچى قېتىم قېپىش كېڭەيتىش',
    vi: 'Lần cắt đầu tiên thêm kích thước',
    zh_tc: '首次切割放量',
    ru: 'Первый разрез',
    ko: '첫 번째 컷 배치',
    bur: 'ပထမဖြတ်ထပ်မံ',
    ben: 'প্রথম কাটিং অ্যালাওয়্যান্স',
    tr: 'İlk kesim payı',
    km: 'ការបញ្ចេញលើកទីមួយ',
    es: 'Primer peso de corte',
    ar: 'وزن القطع الأول',
  },
  'cuttingDock.cuttingParams.longExpandTip': {
    zh: '长边放量',
    en: 'Long edge allowance',
    id: 'Volume Sisi Panjang',
    kz: 'Ұзын жағын кеңейту',
    th: 'ระดับเสียงยาว',
    ug: 'ئۇزۇن چېگرا كېڭەيتىش',
    vi: 'Thêm kích thước cạnh dài',
    zh_tc: '長邊放量',
    ru: 'Длиннобоковой выброс',
    ko: '장변 방량',
    bur: 'ရှည်ဘက်ထပ်မံ',
    ben: 'লং এজ অ্যালাওয়্যান্স',
    tr: 'Uzun kenar payı',
    km: 'ការបញ្ចេញគែមវែង',
    es: 'Peso del lado largo',
    ar: 'وزن الجانب الطويل',
  },
  'cuttingDock.cuttingParams.longLimit': {
    zh: '长边超过',
    en: 'Long edge exceeds',
    id: 'Sisi panjang melebihi',
    kz: 'Ұзын жағы асып кетсе',
    th: 'ด้านยาวเกินกว่า',
    ug: 'ئۇزۇن چېگرا ئاشقاندا',
    vi: 'Cạnh dài vượt quá',
    zh_tc: '長邊超過',
    ru: 'Длинное превышение',
    ko: '길이 초과',
    bur: 'ရှည်ဘက်ကျော်',
    ben: 'লং এজ অতিক্রম করলে',
    tr: 'Uzun kenar şunu aştığında',
    km: 'ពេលគែមវែងលើស',
    es: 'El lado largo excede',
    ar: 'يتجاوز الجانب الطويل',
  },
  'cuttingDock.cuttingParams.cuttingSplitTip': {
    zh: '长板分两次切割条件',
    en: 'Condition for cutting long boards in two passes',
    id: 'Piring panjang dipotong dalam dua kali',
    kz: 'Ұзын тақтайды екі рет кесу шарты',
    th: 'แผ่นยาวจะถูกตัดเป็นสองครั้ง',
    ug: 'ئۇزۇن تاختا ئىككى قېتىم قېپىش شەرتى',
    vi: 'Điều kiện cắt bảng dài thành hai lần',
    zh_tc: '長板分兩次切割條件',
    ru: 'Условия двухкратной резки длинных пластин',
    ko: '장판을 두 번에 걸쳐 절단 조건',
    bur: 'ရှည်ပြားနှစ်ကြိမ်ဖြတ်အခြေအနေ',
    ben: 'লং বোর্ড দুই পাসে কাটার শর্ত',
    tr: 'Uzun plaka iki aşamada kesim koşulu',
    km: 'លក្ខខណ្ឌកាត់ផ្ទាំងវែងពីរដំណាក់កាល',
    es: 'Condiciones de corte de tabla larga en dos',
    ar: 'ظروف قطع اللوحة الطويلة في قسمين',
  },
  'cuttingDock.cuttingParams.shortExpand': {
    zh: '短边放量',
    en: 'Short side allowance',
    id: 'Volume sisi pendek',
    kz: 'Қысқа егіс кеңейту',
    th: 'ระดับเสียงสั้น ๆ',
    ug: 'قىسقا چېگرا كېڭەيتىش',
    vi: 'Điều chỉnh chiều ngắn',
    zh_tc: '短邊放量',
    ru: 'Краткобоковой выброс',
    ko: '단변 방량',
    bur: 'တိုဘက်ထပ်မံ',
    ben: 'শর্ট সাইড অ্যালাওয়্যান্স',
    tr: 'Kısa kenar payı',
    km: 'ការបញ្ចេញគែមខ្លី',
    es: 'Aumenta el volumen en el lado corto.',
    ar: 'زيادة الصوت في الجانب القصير',
  },
  'cuttingDock.cuttingParams.expandTip': {
    zh: '长/短边尺寸各增加X mm，异形长板长短边放量皆为长边放量值',
    en: 'Increase the long/short side dimensions by x mm each. For irregular long boards, the long side allowance applies to both sides.',
    id: '(Ukuran sisi panjang/pendek meningkat x mm, dan panjang dan sisi pendek dari pelat panjang berbentuk khusus semuanya meningkat di sisi panjang)',
    kz: 'ұзын/қысқа егістің өлшемдері әрқайсысы x мм-ге қосымша, ірі панельдің ірі және кіші егісінің кеңейту дережесі бірдей',
    th: '(ขนาดของความยาว/สั้นเพิ่มขึ้น x มม. และความยาวและด้านสั้นของแผ่นยาวรูปทรงพิเศษจะเพิ่มขึ้นโดยด้านยาว)',
    ug: 'ئۇزۇن/قىسقا چېگرا چوڭلۇقى ھەر بىرى X mm غا كېڭىيىدۇ، ئالاھىدە شەكىللىك ئۇزۇن تاختىلارنىڭ ئۇزۇن/قىسقا چېگرا كېڭەيتىش قىممىتى ئۇزۇن چېگرا كېڭەيتىش قىممىتى بىلەن ئوخشاش',
    vi: 'Chiều dài/ngắn tăng thêm x mm, các tấm dài có hình dạng khác đều tăng chiều dài',
    zh_tc: '長/短邊尺寸各增加X mm，異形長板長短邊放量皆為長邊放量值',
    ru: 'Длинные / короткие боковые размеры увеличены на X мм, а длинные и короткие боковые выбросы - на длинные края',
    ko: '길이/짧은 모서리 크기는 각각 X mm씩 증가하며, 이형 장판의 길이와 짧은 모서리 방량은 모두 긴 모서리 방량값이다',
    bur: 'ရှည်/တိုဘက်အရွယ်တစ်ခုစီ x mm တိုး၊ အသွင်းရှည်ပြားရှည်တိုထပ်မံနှစ်ခုလုံးရှည်ဘက်ထပ်မံတန်ဖိုး',
    ben: 'লং/শর্ট সাইড ডাইমেনশন প্রতিটি x mm বাড়ান। অনিয়মিত লং বোর্ডের জন্য উভয় পাশে লং সাইড অ্যালাওয়্যান্স প্রযোজ্য।',
    tr: 'Uzun/kısa kenar boyutlarına her biri X mm eklenir; anormal uzun plakada kısa ve uzun kenar payı uzun kenar payı değeridir',
    km: 'ទំហំគែមវែង/ខ្លីបង្កើនរៀងគ្នា X mm សម្រាប់ផ្ទាំងវែងរូបរាងមិនធម្មតា បញ្ចេញគែមខ្លី និងវែងគឺតម្លៃបញ្ចេញគែមវែង',
    es: 'Las dimensiones del lado largo/corto aumentan cada una en X mm. Las longitudes de los lados largo y corto del tablero largo de forma especial son ambas la longitud del lado largo',
    ar: 'تتم زيادة أبعاد الجانب الطويل/القصير بمقدار X مم. أطوال الجوانب الطويلة والقصيرة للوحة الطويلة ذات الشكل الخاص هي طول الجانب الطويل',
  },
  'cuttingDock.cuttingParams.pumpOffWay': {
    zh: '真空关闭方式',
    en: 'Vacuum shutdown method',
    id: 'Metode shutdown vakum',
    kz: 'Вакуумдық сорғыны тоқтату тәсілі',
    th: 'วิธีการปิดเครื่องดูดฝุ่น',
    ug: 'ۋاكۇم ئۆچۈرۈش ئۇسۇلى',
    vi: 'Cách tắt chân không',
    zh_tc: '真空關閉方式',
    ru: 'Режим вакуумного закрытия',
    ko: '진공 폐쇄 방식',
    bur: 'ဗက်ကြူးပိတ်နည်း',
    ben: 'ভ্যাকুয়াম শাটডাউন পদ্ধতি',
    tr: 'Vakum kapatma yöntemi',
    km: 'វិធីបិទសុញ្ញាកាស',
    es: 'Método de cierre al vacío',
    ar: 'طريقة الإغلاق الفراغي',
  },
  'cuttingDock.cuttingParams.afterOnePlank': {
    zh: '单块长板切割后',
    en: 'After cutting a single long board',
    id: 'Setelah memotong satu pelat panjang',
    kz: 'Бір ірі панельді кесуден кейін',
    th: 'หลังจากตัดแผ่นยาวเดียว',
    ug: 'بىر ئۇزۇن تاختا قېپىلغاندىن كېيىن',
    vi: 'Sau khi cắt gọt một tấm dài',
    zh_tc: '單塊長板切割後',
    ru: 'После резки одной длинной пластины',
    ko: '단일 장판 절단 후',
    bur: 'ရှည်ပြားတစ်ချပ်ဖြတ်ပြီးနောက်',
    ben: 'একটি লং বোর্ড কাটার পর',
    tr: 'Tek uzun plaka kesildikten sonra',
    km: 'បន្ទាប់ពីកាត់ផ្ទាំងវែងមួយសន្លឹក',
    es: 'Después de cortar un solo tablero largo',
    ar: 'بعد قطع لوحة طويلة واحدة',
  },
  'cuttingDock.cuttingParams.afterAllPlank': {
    zh: '整张大板切割后',
    en: 'After cutting the entire large board',
    id: 'Setelah memotong seluruh pelat',
    kz: 'Бүкіл ірі панельді кесуден кейін',
    th: 'หลังจากตัดทั้งจาน',
    ug: 'پۈتۈن چوڭ تاختا قېپىلغاندىن كېيىن',
    vi: 'Sau khi cắt gọt toàn bộ tấm lớn',
    zh_tc: '整張大板切割後',
    ru: 'После того, как разрезать всю доску',
    ko: '전체 대판을 절단한 후',
    bur: 'ကြီးပြားတစ်ချပ်လုံးဖြတ်ပြီးနောက်',
    ben: 'সম্পূর্ণ বড় বোর্ড কাটার পর',
    tr: 'Tüm büyük plaka kesildikten sonra',
    km: 'បន្ទាប់ពីកាត់ផ្ទាំងធំទាំងមួយសន្លឹក',
    es: 'Después de cortar todo el tablero grande',
    ar: 'بعد قطع اللوحة الكبيرة بأكملها',
  },
  'cuttingDock.cuttingParams.numberFixed': {
    zh: '小数保留位数',
    en: 'Number of decimal places to keep',
    id: 'Jumlah tempat desimal dicadangkan',
    kz: 'Кіші сандардың ұсталу дережесі',
    th: 'จำนวนทศนิยมที่สงวนไว้',
    ug: 'ئونلۇق سان ساقلاش بېتى',
    vi: 'Số chữ số giữ nguyên',
    zh_tc: '小數保留位數',
    ru: 'Число зарезервированных десятичных знаков',
    ko: '소수점 보존 자릿수',
    bur: 'ဒသမနေရာထားရှိသည့်အရေအတွက်',
    ben: 'দশমিক স্থান সংরক্ষণের সংখ্যা',
    tr: 'Ondalık basamak sayısı',
    km: 'ចំនួនខ្ទង់ទសភាគ',
    es: 'Número de decimales',
    ar: 'عدد المنازل العشرية',
  },
  'cuttingDock.cuttingParams.bufferCode': {
    zh: '下刀缓冲指令设置',
    en: 'Buffer command for the surface of the board when starting the cut',
    id: 'Menyiapkan perintah buffer',
    kz: 'Кесудің соққысы панельдің беткісінің буферлік командасы',
    th: 'การตั้งค่าคำสั่งบัฟเฟอร์',
    ug: 'پىچاق چۈشۈش توختىتىش بۇيرۇقى تەڭشىكى',
    vi: 'Chỉ dẫn làm mịn bề mặt tấm trước khi cắt gọt',
    zh_tc: '下刀緩衝指令設置',
    ru: 'Настройка буферной команды',
    ko: '언더 버퍼 명령 설정',
    bur: 'ဓားချချောမောညွှန်ကြားချက်ဆက်တင်',
    ben: 'কাট শুরুতে বোর্ড সারফেসের বাফার কমান্ড',
    tr: 'Bıçak inişi tampon komutu ayarı',
    km: 'ការកំណត់ពាក្យបញ្ជាប៊ឺហ្វរពេលចុះឧបករណ៍កាត់',
    es: 'Configuración del comando de búfer de corte',
    ar: 'إعداد أمر المخزن المؤقت للقاطع',
  },
  'cuttingDock.cuttingParams.layoutGap': {
    zh: '排版间隙设置',
    en: 'Layout gap setting',
    id: 'Pengaturan kesenjangan yang mengeset',
    kz: 'Панельдердің орналасу аралығы',
    th: 'การตั้งค่าช่องว่างการเรียงพิมพ์',
    ug: 'تەڭشەش بوشلۇقى تەڭشىكى',
    vi: 'Cài đặt khoảng cách bố trí',
    zh_tc: '排版間隙設置',
    ru: 'Настройка промежутка между наборами',
    ko: '조판 클리어런스 설정',
    bur: 'ပြင်ဆင်ခြားနားချက်ဆက်တင်',
    ben: 'লেআউট গ্যাপ সেটিং',
    tr: 'Yerleşim aralığı ayarı',
    km: 'ការកំណត់ចន្លោះរៀបចំ',
    es: 'Configuración del espacio de composición tipográfica',
    ar: 'إعداد فجوة التنضيد',
  },
  'cuttingDock.cuttingParams.layoutGapTip': {
    zh: '注意：排版间隙设置为0可能会出现排版重叠',
    en: 'Attention: Setting the layout gap to 0 may cause layout overlap',
    id: 'CATATAN: Kesenjangan yang setel diatur ke 0 dapat menyebabkan pengesahan huruf tumpang tindih',
    kz: 'Назар аударыңыз: Орналасу алшақтығын 0-ге орнату орналасудың қабаттасуына әкелуі мүмкін',
    th: 'หมายเหตุ: การตั้งค่าช่องว่างการตั้งครรภ์เป็น 0 อาจทำให้เกิดการเรียงลำดับการทับซ้อนกัน',
    ug: 'دىققەت: تەڭشەش بوشلۇقى 0 گە تەڭشەلگەندە تەڭشەش قاپلىشىشى مۇمكىن',
    vi: 'Lưu ý: Cài đặt khoảng cách bố trí là 0 có thể gây chồng chéo bố trí',
    zh_tc: '注意：排版間隙設置為0可能會出現排版重疊',
    ru: 'Примечание: Разрыв между наборами, установленный на 0, может перекрываться',
    ko: '참고: 레이아웃 간격을 0으로 설정하면 레이아웃이 겹칠 수 있습니다.',
    bur: 'သတိပြု-ပြင်ဆင်ခြားနားချက်၀သတ်မှတ်ပါကပြင်ဆင်ထပ်နိုင်သည်',
    ben: 'নোট: লেআউট গ্যাপ ০ সেট করলে লেআউট ওভারল্যাপ হতে পারে',
    tr: 'Dikkat: Yerleşim aralığı 0 yapılırsa yerleşim üst üste binebilir',
    km: 'ចំណាំ៖ កំណត់ចន្លោះរៀបចំជា ០ អាចធ្វើឱ្យរៀបចំស្ទូចគ្នា',
    es: 'Nota: Establecer el espacio de composición tipográfica en 0 puede causar superposición de tipografía.',
    ar: 'ملاحظة: قد يؤدي ضبط فجوة التنضيد إلى 0 إلى تداخل التنضيد.',
  },
  'cuttingDock.cuttingParams.wasteCutting': {
    zh: '废料自动截断',
    en: 'Automatic waste truncation',
    id: 'Pemotongan limbah otomatis',
    kz: 'Қалдықтарды автоматты түрде кесу',
    th: 'การตัดขยะอัตโนมัติ',
    ug: 'خورا ماتېرىيال ئاپتوماتىك كېسىش',
    vi: 'Tự động cắt gọt phế liệu',
    zh_tc: '廢料自動截斷',
    ru: 'Автоматическое удаление отходов',
    ko: '폐기물 자동 절단',
    bur: 'အကြွင်းအလိုအလျောက်ဖြတ်',
    ben: 'অটোমেটিক waste ট্রাঙ্কেশন',
    tr: 'Atık otomatik kesim',
    km: 'កាត់សម្ភារៈចោលស្វ័យប្រវត្តិ',
    es: 'Corte automático de desechos',
    ar: 'قطع الخردة تلقائيًا',
  },
  'cuttingDock.cuttingParams.zkPointCustomize': {
    zh: 'Z扣斜孔加工旋转基准点自定义',
    en: 'Z-Knuckle Slant Hole Machining Rotation Reference Point Customization',
    id: 'Titik referensi rotasi yang disesuaikan untuk pemesinan lubang z-buckle miring',
    kz: 'Z-түймесінің көлбеу тесігін өңдеудің айналу нүктесін теңшеу',
    th: 'จุดอ้างอิงการหมุนที่กำหนดเองสำหรับการตัดเฉือนหลุม z-buckle',
    ug: 'Z قۇلۇق ئېگىل چېگرا ئىشلەش ئۆزگەرتىش ئاساس نۇقتىسى ئىختىيارى',
    vi: 'Tùy chỉnh điểm tham chiếu xoay gia công lỗ xiên khóa Z',
    zh_tc: 'Z扣斜孔加工旋轉基準點自定義',
    ru: 'Настройка опорной точки вращения для обработки наклонных отверстий Z',
    ko: 'Z-버클 사접 구멍만들기 회전 데이텀 점 사용자화',
    bur: 'Z ချိန်းစောင်းအပေါက်ပြုလည်ခြင်းအခြေအမှတ်စိတ်ကြိုက်',
    ben: 'Z-নকল স্ল্যান্ট হোল মেশিনিং রোটেশন রেফারেন্স পয়েন্ট কাস্টমাইজেশন',
    tr: 'Z kilit eğik delik işleme dönüş referans noktası özelleştirme',
    km: 'កំណត់ចំណុចយោងបង្វិលដំណើរការរណ្តៅអាក្សត់ Z ផ្ទាល់ខ្លួន',
    es: 'Z Personalización del punto de referencia de rotación de mecanizado de orificio oblicuo de botón',
    ar: 'Z تخصيص النقطة المرجعية لدوران الثقب المائل بالزر',
  },
  'cuttingDock.cuttingParams.sawSetting': {
    zh: '锯切设置',
    en: 'Saw Cutting Settings',
    id: 'Melihat pengaturan pemotongan',
    kz: 'Аралау параметрлері',
    th: 'เห็นการตั้งค่าการตัด',
    ug: 'ئارقا كېسىش تەڭشىكى',
    vi: 'Cài đặt cưa cắt',
    zh_tc: '鋸切設置',
    ru: 'Параметры пилы',
    ko: '톱질 설정',
    bur: 'ဆောက်ဖြတ်ဆက်တင်',
    ben: 'স saw কাটিং সেটিংস',
    tr: 'Testere kesim ayarları',
    km: 'ការកំណត់កាត់រណា',
    es: 'Configuración de aserrado',
    ar: 'إعدادات النشر',
  },
  'cuttingDock.cuttingParams.cuttingLimit': {
    zh: '截断尺寸大于',
    en: 'Truncate size larger than',
    id: 'Ukuran cutoff lebih besar dari',
    kz: 'Кесудің кесу дережесі',
    th: 'ขนาดตัดมากกว่า',
    ug: 'كېسىش چوڭلۇقى چوڭ',
    vi: 'Kích thước cắt gọt lớn hơn',
    zh_tc: '截斷尺寸大於',
    ru: 'Размер отсечения больше',
    ko: '절단 크기가 보다 큽니다.',
    bur: 'ဖြတ်အရွယ်သည်ထို့ထက်ကြီး',
    ben: 'ট্রাঙ্কেট সাইজ এর চেয়ে বড়',
    tr: 'Kesim boyutu şundan büyük',
    km: 'ទំហំកាត់ធំជាង',
    es: 'Corte de desechos mayores que',
    ar: 'قطع الخردة الأكبر من',
  },
  'cuttingDock.cuttingParams.waste': {
    zh: '的废料',
    en: 'of waste',
    id: 'Buang -buang',
    kz: 'қалдықтар',
    th: 'เสียจาก',
    ug: 'خورا ماتېرىيال',
    vi: 'phế liệu',
    zh_tc: '的廢料',
    ru: 'Отходы',
    ko: '의 폐기물',
    bur: 'အကြွင်း',
    ben: 'বর্জ্য',
    tr: 'atık',
    km: 'សម្ភារៈចោល',
    es: 'of waste',
    ar: 'of waste',
  },
  'cuttingDock.cuttingParams.wasteSizeLimit': {
    zh: '最小尺寸不得小于100mm',
    en: 'The minimum size must not be less than 100mm',
    id: 'Ukuran minimum tidak boleh kurang dari 100mm',
    kz: 'Ең кіші өлшемі 100 мм-ден кем болмайды',
    th: 'ขนาดขั้นต่ำจะต้องไม่น้อยกว่า 100 มม.',
    ug: 'ئەڭ كىچىك چوڭلۇقى 100mm دىن كىچىك بولماسلىقى كېرەك',
    vi: 'Kích thước nhỏ nhất không được nhỏ hơn 100mm',
    zh_tc: '最小尺寸不得小於100mm',
    ru: 'Минимальный размер не должен быть меньше 100 мм.',
    ko: '최소 크기는 100mm 이하여야 합니다.',
    bur: 'အနည်းဆုံးအရွယ်၁၀၀mm ထက်မငယ်ရ',
    ben: 'সর্বনিম্ন সাইজ ১০০mm এর চেয়ে কম হতে পারবে না',
    tr: 'Minimum boyut 100 mm’den küçük olamaz',
    km: 'ទំហំតូបរមាមិនអាចតូចជាង ១០០ mm',
    es: 'El tamaño mínimo no debe ser inferior a 100 mm',
    ar: 'يجب ألا يقل الحجم الأدنى عن 100 مم',
  },
  'cuttingDock.cuttingParams.topLeft': {
    zh: '左边、上边',
    en: 'Left and top sides',
    id: 'Kiri, atas',
    kz: 'Сол жақ, жоғарғы жақ',
    th: 'ซ้าย, ด้านบน',
    ug: 'سول، ئۈستى',
    vi: 'Bên trái, bên trên',
    zh_tc: '左邊、上邊',
    ru: 'Слева, сверху.',
    ko: '왼쪽, 위',
    bur: 'ဘယ်၊ အပေါ်',
    ben: 'বাম ও উপরের দিক',
    tr: 'Sol, üst',
    km: 'ឆ្វេង លើ',
    es: 'Izquierda, arriba',
    ar: 'اليسار، العلوي',
  },
  'cuttingDock.cuttingParams.topLeftD': {
    zh: '左上角',
    en: 'Top left corner',
    id: 'Sudut kiri atas',
    kz: 'Сол жоғарғы көше',
    th: 'มุมซ้ายบน',
    ug: 'سول ئۈستى بۇلۇڭ',
    vi: 'Góc trên trái',
    zh_tc: '左上角',
    ru: 'левый верхний угол',
    ko: '왼쪽 위',
    bur: 'ဘယ်အပေါ်ထောင့်',
    ben: 'বাম উপরের কোণ',
    tr: 'Sol üst köşe',
    km: 'មុំឆ្វេងលើ',
    es: 'Esquina superior izquierda',
    ar: 'الزاوية اليسرى العليا',
  },
  'cuttingDock.cuttingParams.bottomLeft': {
    zh: '左边、下边',
    en: 'Left and bottom sides',
    id: 'Kiri, bawah',
    kz: 'Сол жақ, төменгі жақ',
    th: 'ซ้ายล่าง',
    ug: 'سول، ئاستى',
    vi: 'Bên trái, bên dưới',
    zh_tc: '左邊、下邊',
    ru: 'Слева, внизу.',
    ko: '왼쪽, 아래',
    bur: 'ဘယ်၊ အောက်',
    ben: 'বাম ও নিচের দিক',
    tr: 'Sol, alt',
    km: 'ឆ្វេង ក្រោម',
    es: 'Izquierda, inferior',
    ar: 'اليسار، السفلي',
  },
  'cuttingDock.cuttingParams.bottomLeftD': {
    zh: '左下角',
    en: 'Bottom left corner',
    id: 'Sudut kiri bawah',
    kz: 'Сол төменгі köше',
    th: 'มุมซ้ายล่าง',
    ug: 'سول ئاستى بۇلۇڭ',
    vi: 'Góc dưới trái',
    zh_tc: '左下角',
    ru: 'Нижний левый угол',
    ko: '왼쪽 아래',
    bur: 'ဘယ်အောက်ထောင့်',
    ben: 'বাম নিচের কোণ',
    tr: 'Sol alt köşe',
    km: 'មុំឆ្វេងក្រោម',
    es: 'Esquina inferior izquierda',
    ar: 'الزاوية اليسرى السفلية',
  },
  'cuttingDock.cuttingParams.topRight': {
    zh: '右边、上边',
    en: 'Right and top sides',
    id: 'Benar, atasnya',
    kz: 'Үңгі жақ, жоғарғы жақ',
    th: 'ขวาบนสุด',
    ug: 'ئوڭ، ئۈستى',
    vi: 'Bên phải, bên trên',
    zh_tc: '右邊、上邊',
    ru: 'Справа, сверху.',
    ko: '오른쪽, 위',
    bur: 'ညာ၊ အပေါ်',
    ben: 'ডান ও উপরের দিক',
    tr: 'Sağ, üst',
    km: 'ស្តាំ លើ',
    es: 'Derecha, arriba',
    ar: 'اليمين، أعلى',
  },
  'cuttingDock.cuttingParams.topRightD': {
    zh: '右上角',
    en: 'Top right corner',
    id: 'Sudut kanan atas',
    kz: 'Үңгі жоғарғы köше',
    th: 'มุมขวาบน',
    ug: 'ئوڭ ئۈستى بۇلۇڭ',
    vi: 'Góc trên phải',
    zh_tc: '右上角',
    ru: 'Верхний правый угол',
    ko: '오른쪽 위',
    bur: 'ညာအပေါ်ထောင့်',
    ben: 'ডান উপরের কোণ',
    tr: 'Sağ üst köşe',
    km: 'មុំស្តាំលើ',
    es: 'Esquina superior derecha',
    ar: 'الزاوية اليمنى العليا',
  },
  'cuttingDock.cuttingParams.bottomRight': {
    zh: '右边、下边',
    en: 'Right and bottom sides',
    id: 'Kanan, bawah',
    kz: 'Үңгі жақ, төменгі жақ',
    th: 'ขวาล่าง',
    ug: 'ئوڭ، ئاستى',
    vi: 'Bên phải, bên dưới',
    zh_tc: '右邊、下邊',
    ru: 'Справа, внизу.',
    ko: '오른쪽, 아래',
    bur: 'ညာ၊ အောက်',
    ben: 'ডান ও নিচের দিক',
    tr: 'Sağ, alt',
    km: 'ស្តាំ ក្រោម',
    es: 'Borde inferior derecho',
    ar: 'الحافة اليمنى، الحافة السفلية',
  },
  'cuttingDock.cuttingParams.bottomRightD': {
    zh: '右下角',
    en: 'Bottom right corner',
    id: 'Sudut kanan bawah',
    kz: 'Үңгі төменгі köше',
    th: 'มุมขวาล่าง',
    ug: 'ئوڭ ئاستى بۇلۇڭ',
    vi: 'Góc dưới phải',
    zh_tc: '右下角',
    ru: 'Нижний правый угол',
    ko: '오른쪽 아래',
    bur: 'ညာအောက်ထောင့်',
    ben: 'ডান নিচের কোণ',
    tr: 'Sağ alt köşe',
    km: 'មុំស្តាំក្រោម',
    es: 'Esquina inferior derecha',
    ar: 'الزاوية اليمنى السفلى',
  },
  'cuttingDock.cuttingParams.firstTime': {
    zh: '第一次',
    en: 'First time',
    id: 'Pertama',
    kz: 'Бірінші рет',
    th: 'อันดับแรก',
    ug: 'بىرىنچى قېتىم',
    vi: 'Lần đầu tiên',
    zh_tc: '第一次',
    ru: 'первый раз',
    ko: '첫 번째',
    bur: 'ပထမကြိမ်',
    ben: 'প্রথমবার',
    tr: 'Birinci',
    km: 'លើកទីមួយ',
    es: 'Primera vez',
    ar: 'المرة الأولى',
  },
  'cuttingDock.cuttingParams.secondTime': {
    zh: '第二次',
    en: 'Second time',
    id: 'Kedua kalinya',
    kz: 'Екінші рет',
    th: 'ครั้งที่สอง',
    ug: 'ئىككىنچى قېتىم',
    vi: 'Lần thứ hai',
    zh_tc: '第二次',
    ru: 'Второй раз',
    ko: '두 번째',
    bur: 'ဒုတိယကြိမ်',
    ben: 'দ্বিতীয়বার',
    tr: 'İkinci',
    km: 'លើកទីពីរ',
    es: 'Segunda vez',
    ar: 'المرة الثانية',
  },
  'cuttingDock.cuttingParams.thirdTime': {
    zh: '第三次',
    en: 'Third time',
    id: 'Ketiga kalinya',
    kz: 'Үшінші рет',
    th: 'ครั้งที่สาม',
    ug: 'ئۈچىنچى قېتىم',
    vi: 'Lần thứ ba',
    zh_tc: '第三次',
    ru: 'Третий раз',
    ko: '세 번째',
    bur: 'တတိယကြိမ်',
    ben: 'তৃতীয়বার',
    tr: 'Üçüncü',
    km: 'លើកទីបី',
    es: 'Tercera vez',
    ar: 'المرة الثالثة',
  },
  'cuttingDock.cuttingParams.startCutting': {
    zh: '切割开始',
    en: 'Cutting started',
    id: 'Pemotongan dimulai',
    kz: 'Кесуді бастау',
    th: 'การตัดเริ่มต้น',
    ug: 'قېپىش باشلانغۇچ',
    vi: 'Bắt đầu cắt gọt',
    zh_tc: '切割開始',
    ru: 'Начинается резка',
    ko: '가공 시작',
    bur: 'ဖြတ်စတင်',
    ben: 'কাটিং স্টার্টেড',
    tr: 'Kesim başladı',
    km: 'ការកាត់ចាប់ផ្តើម',
    es: 'Inicio del corte',
    ar: 'بداية القطع',
  },
  'cuttingDock.cuttingParams.thickRange': {
    zh: '厚度 ≥',
    en: 'Thickness ≥',
    id: 'Ketebalan ≥',
    kz: 'Қалыңдықтың ≥',
    th: 'ความหนา≥',
    ug: 'قېلىنلىق ≥',
    vi: 'Độ dày ≥',
    zh_tc: '厚度 ≥',
    ru: 'Толщина ≥',
    ko: '두께 ≥',
    bur: 'အထူ ≥',
    ben: 'বেধ ≥',
    tr: 'Kalınlık ≥',
    km: 'កម្រាស់ ≥',
    es: 'Espesor ≥',
    ar: 'السُمك ≥',
  },
  'cuttingDock.cuttingParams.longCut': {
    zh: '长板加工',
    en: 'Long board processing',
    id: 'Pemrosesan Longboard',
    kz: 'Ұзақ тақта өңдеу',
    th: 'การประมวลผล longboard',
    ug: 'ئۇزۇن تاختا ئىشلەش',
    vi: 'Gia công tấm dài',
    zh_tc: '長板加工',
    ru: 'Длиннолистовая обработка',
    ko: '장판 가공',
    bur: 'ရှည်ပြားပြု',
    ben: 'লং বোর্ড প্রসেসিং',
    tr: 'Uzun plaka işleme',
    km: 'ដំណើរការផ្ទាំងវែង',
    es: 'Procesamiento de placas largas',
    ar: 'معالجة اللوحة الطويلة',
  },
  'cuttingDock.cuttingParams.edgeSetting': {
    zh: '修边设置',
    en: 'Edge trimming settings',
    id: 'Pengaturan Pemangkasan',
    kz: 'Кеңістікті орнату',
    th: 'การตั้งค่าการตัดแต่ง',
    ug: 'چېگرا تەڭشىكى',
    vi: 'Cài đặt điều chỉnh cạnh',
    zh_tc: '修邊設置',
    ru: 'Настройка кромки',
    ko: '모서리 설정 고치기',
    bur: 'အစွန်းပြင်ဆက်တင်',
    ben: 'এজ ট্রিমিং সেটিংস',
    tr: 'Kenar düzeltme ayarları',
    km: 'ការកំណត់កែគែម',
    es: 'Ajustes de recorte',
    ar: 'إعدادات القطع',
  },
  'cuttingDock.cuttingParams.cuttingOrder': {
    zh: '切割顺序：',
    en: 'Cutting order:',
    id: 'Pesanan pemotongan:',
    kz: 'Кесу реттілігі:',
    th: 'คำสั่งตัด:',
    ug: 'قېپىش تەرتىپى:',
    vi: 'Thứ tự cắt gọt:',
    zh_tc: '切割順序：',
    ru: 'Порядок резки:',
    ko: '가공 순서:',
    bur: 'ဖြတ်အစဉ်:',
    ben: 'কাটিং অর্ডার:',
    tr: 'Kesim sırası:',
    km: 'លំដាប់កាត់៖',
    es: 'Secuencia de corte:',
    ar: 'تسلسل القطع:',
  },
  'cuttingDock.cuttingParams.cuttingOrderTip': {
    zh: '此方式存在跑板风险，请谨慎使用',
    en: 'There is a risk of board running with this method, please use it carefully',
    id: 'Metode ini memiliki risiko menjalankan papan, silakan gunakan dengan hati -hati',
    kz: 'Бұл әдісте тақтадан тыс болу дурыны бар, оқиша пайдалану',
    th: 'วิธีนี้มีความเสี่ยงในการเรียกใช้บอร์ดโปรดใช้ด้วยความระมัดระวัง',
    ug: 'بۇ ئۇسۇل تاختا قاچىش خەتەرلىك، دىققەت قىلىڭ',
    vi: 'Cách này có nguy cơ gây ra sự cố, vui lòng sử dụng thận trọng',
    zh_tc: '此方式存在跑板風險，請謹慎使用',
    ru: 'Этот способ сопряжен с риском беговой доски, используйте его с осторожностью.',
    ko: '이 방식은 주판 위험이 있으니, 신중하게 사용하시기 바랍니다.',
    bur: 'ဤနည်းတွင်ပြားပြေးအန္တရာယ်ရှိ၊ သတိထားသုံးပါ',
    ben: 'এই পদ্ধতিতে বোর্ড রান করার ঝুঁকি আছে, সাবধানে ব্যবহার করুন',
    tr: 'Bu yöntemde plaka kayması riski vardır; dikkatli kullanın',
    km: 'វិធីនេះមានហានិភ័យផ្ទាំងរុញ សូមប្រើប្រយ័ត្ន',
    es: 'Este método tiene el riesgo de estribos, utilícelo con precaución',
    ar: 'تحتوي هذه الطريقة على خطر تشغيل الألواح، يرجى استخدامها بحذر',
  },
  'cuttingDock.cuttingParams.plankFirst': {
    zh: '先切小板',
    en: 'Cut small boards first',
    id: 'Potong papan terlebih dahulu',
    kz: 'Кіші тақталарды алдымен кесу',
    th: 'ตัดบอร์ดก่อน',
    ug: 'ئالدى بىلەن كىچىك تاختا قېپىش',
    vi: 'Cắt tấm nhỏ trước',
    zh_tc: '先切小板',
    ru: 'Сперва разрезать доску.',
    ko: '먼저 판자를 자르다',
    bur: 'ပေါ်ဒ်ငယ်အရင်ဖြတ်',
    ben: 'ছোট বোর্ড আগে কাটুন',
    tr: 'Önce küçük plakaları kes',
    km: 'កាត់ផ្ទាំងតូចមុន',
    es: 'Corte las placas pequeñas primero',
    ar: 'قطع الألواح الصغيرة أولاً',
  },
  'cuttingDock.cuttingParams.wasteFirst': {
    zh: '先切废料',
    en: 'Cut waste material first',
    id: 'Potong limbah terlebih dahulu',
    kz: 'Қалдықтарды алдымен кесу',
    th: 'ตัดของเสียก่อน',
    ug: 'ئالدى بىلەن خورا ماتېرىيال قېپىش',
    vi: 'Cắt phế liệu trước',
    zh_tc: '先切廢料',
    ru: 'Первичная резка отходов',
    ko: '폐기물을 먼저 썰다',
    bur: 'အကြွင်းအရင်ဖြတ်',
    ben: 'বর্জ্য আগে কাটুন',
    tr: 'Önce atığı kes',
    km: 'កាត់សម្ភារៈចោលមុន',
    es: 'Corte los restos primero',
    ar: 'قطع القصاصات أولاً',
  },
  'cuttingDock.cuttingParams.offTip': {
    zh: '关闭时将跟随切割参数中修边设置',
    en: 'When turned off, it will follow the trimming settings in the cutting parameters',
    id: 'Saat ditutup, pengaturan pemangkasan akan diikuti dalam parameter pemotongan.',
    kz: 'Жабу кезінде кесу параметрлеріндегі кесу параметрлеріне сәйкес келеді',
    th: 'เมื่อปิดการตั้งค่าการตัดแต่งจะถูกติดตามในพารามิเตอร์การตัด',
    ug: 'ئۆچۈرۈلگەندە قېپىش پارامېتىرلىرىدىكى چېگرا تەڭشىكىگە ئەگەشىدۇ',
    vi: 'Khi tắt, sẽ theo cài đặt điều chỉnh cạnh trong thông số cắt gọt',
    zh_tc: '關閉時將跟隨切割參數中修邊設置',
    ru: 'При закрытии настройка кромки будет следовать параметрам резки',
    ko: '닫으면 가공 매개변수에서 모서리 셋업 따르기',
    bur: 'ပိတ်သည့်အခါဖြတ်ပါရာမီတာအစွန်းပြင်ဆက်တင်ကိုလိုက်မည်',
    ben: 'বন্ধ থাকলে কাটিং প্যারামিটারের ট্রিমিং সেটিং অনুসরণ করবে',
    tr: 'Kapalıyken kesim parametrelerindeki kenar düzeltme ayarlarını izler',
    km: 'ពេលបិទនឹងធ្វើតាមការកំណត់កែគែមក្នុងប៉ារ៉ាម៉ែត្រកាត់',
    es: 'Cuando está cerrado, seguirá las configuraciones de recorte en los parámetros de corte',
    ar: 'عند إغلاقه، سيتبع إعدادات التشذيب في معلمات القطع',
  },
  'cuttingDock.cuttingParams.edgeCutDirection': {
    zh: '修边方向',
    en: 'Trimming Direction',
    id: 'Arah pemangkasan',
    kz: 'Кесу бағыты',
    th: 'การตัดทิศทาง',
    ug: 'چېگرا قېپىش يۆنىلىشى',
    vi: 'Hướng điều chỉnh cạnh',
    zh_tc: '修邊方向',
    ru: 'направление обрезки',
    ko: '모서리 수정 방향',
    bur: 'အစွန်းပြင်ဦးတည်ချက်',
    ben: 'ট্রিমিং দিক',
    tr: 'Kenar düzeltme yönü',
    km: 'ទិសកែគែម',
    es: 'Dirección de recorte',
    ar: 'اتجاه التشذيب',
  },
  'cuttingDock.cuttingParams.lGapTip': {
    zh: 'L形余料大板缺口摆放位置自动调整在定位气缸对角方向，高光余料大板除外，同时与xy轴互换功能不兼容',
    en: 'The placement position of the gap in the L-shaped surplus material large plate is automatically adjusted in the diagonal direction of the positioning cylinder, except for the high gloss surplus material large plate, which is not compatible with the xy axis interchange function',
    id: 'Posisi pelat besar berlekuk dari bahan residu berbentuk L secara otomatis disesuaikan dalam arah diagonal silinder penentuan posisi, kecuali untuk pelat besar bahan residu gloss tinggi, yang tidak kompatibel dengan fungsi pertukaran sumbu XY.',
    kz: 'L-жүйесіндегі қалыңыздың үлкен плитка жоғалуының орналасуын автоматты түрде және сақтау құрлығының құршығына түрде сақтау, өңдеуілік қалыңыздың үлкен плиткасын бөлек, сондай-ақ, XY аспының алмастыру функциясымен қатысуға тиіс емес',
    th: 'ตำแหน่งของแผ่นวัสดุที่ตกค้างรูปตัว L ขนาดใหญ่จะถูกปรับโดยอัตโนมัติในทิศทางเส้นทแยงมุมของกระบอกสูบตำแหน่งยกเว้นแผ่นขนาดใหญ่ที่มีวัสดุเหลือเฟือสูงซึ่งเข้ากันไม่ได้กับฟังก์ชั่นการแลกเปลี่ยน XY-Axis',
    ug: 'L شەكىللىك قالدۇق ماتېرىيال چوڭ تاختىسىدىكى بوشلۇق ئورنى ئۆز-ئارا بېسىش سىلىندىرىسىنىڭ قارشى تەرەپكىچە ئاپتوماتىك تەڭشىلىدۇ، يورۇق قالدۇق ماتېرىياللار بۇنىڭ سىرتىدا، ھەمدە xy ئوكۇل ئالماشتۇرۇش فۇنكسىيىسى بىلەن ماسلاشمايدۇ',
    vi: 'Vị trí đặt lỗ hổng của tấm dư lượng hình chữ L tự động điều chỉnh theo hướng chéo của xi lanh định vị, ngoại trừ tấm dư lượng cao, đồng thời không tương thích với chức năng hoán đổi trục xy',
    zh_tc:
      'L形餘料大板缺口擺放位置自動調整在定位氣缸對角方向，高光餘料大板除外，同時與xy軸互換功能不兼容',
    ru: 'Положение расположения зазора на большой пластине L - образного остаточного материала автоматически регулируется в диагональном направлении цилиндра позиционирования, за исключением высокой остаточной пластины, и несовместимо с функцией обмена осями xy',
    ko: 'L형 여분 재료 대판 틈새 배치 위치는 자동으로 위치 실린더 대각 방향으로 조정되며, 고광 여분 재료 대판은 제외되며, 동시에 xy축 교환 기능과 호환되지 않는다',
    bur: 'L အသွင်းအကြွင်းကြီးပြားချိုင့်ထားနေရာကိုတည်နေရာဆီလင်ဒါထောင့်ချိုးဦးတည်ချက်တွင်အလိုအလျောက်ညှိ၊ အမြှီးအကြွင်းကြီးပြားမပါ၊ xy ဝင်ရိုးပြောင်းနှင့်မကိုက်ညီ',
    ben: 'L-আকৃতির সারপ্লাস বড় প্লেটের গ্যাপ প্লেসমেন্ট পজিশন পজিশনিং সিলিন্ডারের তির্যক দিকে অটো অ্যাডজাস্ট, হাই গ্লস সারপ্লাস বড় প্লেট ছাড়া, xy অক্ষ ইন্টারচেঞ্জ ফাংশনের সাথে সামঞ্জস্যপূর্ণ নয়',
    tr: 'L şeklinde artık malzeme büyük plakadaki boşluk konumu, parlak artık hariç, konumlama silindirinin çapraz yönünde otomatik ayarlanır; xy eksen değişimi ile uyumlu değildir',
    km: 'ទីតាំងដាក់ចន្លោះនៅផ្ទាំងធំសម្ភារៅនៅសល់រូប L កែស្វ័យប្រវត្តិតាមទិសទ្រេតនៃស៊ីលីនដែរកំណត់ទីតាំង លើកលែងផ្ទាំងធំសម្ភារៅនៅសល់រលកពន្លឺ មិនសមស្របនឹងការប្តូរ xy',
    es: 'L La posición del espacio de la placa de material restante en forma de L se ajusta automáticamente en la dirección diagonal del cilindro de posicionamiento, excepto la placa de material restante de alto brillo. También es incompatible con la función de intercambio del eje xy',
    ar: 'L يتم ضبط موضع فجوة لوحة المواد المتبقية على شكل L تلقائيًا في الاتجاه القطري لأسطوانة تحديد الموضع، باستثناء لوحة المواد المتبقية عالية اللمعان. كما أنه غير متوافق مع وظيفة تبادل المحور xy',
  },
  'cuttingDock.cuttingParams.cylinderDir': {
    zh: '定位气缸方向',
    en: 'Positioning cylinder direction',
    id: 'Arah silinder penentuan posisi',
    kz: 'Сырлымның бағытын орнату',
    th: 'การตั้งค่าทิศทางของกระบอกสูบตำแหน่ง',
    ug: 'بېسىش سىلىندىرىسى يۆنىلىشى',
    vi: 'Định vị hướng xi lanh',
    zh_tc: '定位氣缸方向',
    ru: 'ориентация цилиндра',
    ko: '실린더 방향 지정',
    bur: 'တည်နေရာဆီလင်ဒါဦးတည်ချက်',
    ben: 'পজিশনিং সিলিন্ডার দিক',
    tr: 'Konumlama silindiri yönü',
    km: 'ទិសស៊ីលីនដែរកំណត់ទីតាំង',
    es: 'Dirección del cilindro de posicionamiento',
    ar: 'تحديد اتجاه الأسطوانة',
  },
  'cuttingDock.cuttingParams.onlyLong': {
    zh: '只修长边',
    en: 'Trim only long edges',
    id: 'Hanya sisi ramping',
    kz: 'Қашықты болшаты төнделу',
    th: 'ด้านเรียวเท่านั้น',
    ug: 'پەقەت ئۇزۇن چېگرىنى چېگرىلاش',
    vi: 'Chỉ điều chỉnh chiều dài',
    zh_tc: '只修長邊',
    ru: 'Только длинные края.',
    ko: '길쭉한 테두리만',
    bur: 'ရှည်ဘက်သာပြင်',
    ben: 'শুধুমাত্র লং এজ ট্রিম করুন',
    tr: 'Yalnızca uzun kenarı düzelt',
    km: 'កែតែគែមវែង',
    es: 'Solo se recortan los lados largos',
    ar: 'يتم قطع الجوانب الطويلة فقط',
  },
  'cuttingDock.cuttingParams.backCutOrder': {
    zh: '反面修边顺序',
    en: 'Back side trimming order',
    id: 'Reverse Tripming Order',
    kz: 'Қарсы тараптағы шетті кесу тәртібі',
    th: 'ลำดับการตัดแต่งย้อนกลับ',
    ug: 'ئارقا چېگرا قېپىش تەرتىپى',
    vi: 'Thứ tự điều chỉnh cạnh mặt sau',
    zh_tc: '反面修邊順序',
    ru: 'Отрицательная последовательность обрезки',
    ko: '뒷면 트림 순서',
    bur: 'အနောက်မျက်နှာအစွန်းပြင်အစဉ်',
    ben: 'পিছনের দিক ট্রিমিং অর্ডার',
    tr: 'Arka yüz kenar düzeltme sırası',
    km: 'លំដាប់កែគែមផ្ទៃក្រោយ',
    es: 'Secuencia de recorte inversa',
    ar: 'تسلسل التشذيب العكسي',
  },
  'cuttingDock.cuttingParams.backFirst': {
    zh: '反面最开始修边',
    en: 'Trim back side first',
    id: 'Bagian depan sebaliknya adalah yang pertama',
    kz: 'Қарсы тараптағы шетті кесудің алғашқы қатар',
    th: 'ด้านหน้าของด้านหลังเป็นอันดับแรก',
    ug: 'ئارقا ئەڭ ئالدى بىلەن چېگرىلاش',
    vi: 'Điều chỉnh cạnh mặt sau trước',
    zh_tc: '反面最開始修邊',
    ru: 'На обратной стороне начинается ремонт.',
    ko: '뒷면 모서리 손질 시작',
    bur: 'အနောက်မျက်နှာအစပြင်ပြန်',
    ben: 'পিছনের দিক আগে ট্রিম করুন',
    tr: 'Önce arka yüzü düzelt',
    km: 'កែផ្ទៃក្រោយមុន',
    es: 'Inicialmente se recorta la parte posterior',
    ar: 'يتم تشذيب الجانب الخلفي في البداية',
  },
  'cuttingDock.cuttingParams.backSecond': {
    zh: '反面孔槽加工后修边',
    en: 'Trim back side after hole and slot processing',
    id: 'Reverse Face Groove Processing dan Tripming',
    kz: 'Қарсы тараптағы тесік пен ойықтар өңделгеннен кейін шетті кесу',
    th: 'ย้อนกลับการประมวลผลและตัดแต่งร่องหน้า',
    ug: 'ئارقا تەشىك-ئارقا ئىشلەنگەندىن كېيىن چېگرىلاش',
    vi: 'Điều chỉnh cạnh sau khi gia công lỗ, khe',
    zh_tc: '反面孔槽加工後修邊',
    ru: 'Обрезка задних отверстий',
    ko: '후면 구멍 슬롯 가공 후 모서리 고치기',
    bur: 'အနောက်မျက်နှာအပေါက်ချောင်းပြုပြီးနောက်အစွန်းပြင်',
    ben: 'হোল ও স্লট প্রসেসিংয়ের পর পিছনের দিক ট্রিম করুন',
    tr: 'Arka delik/oluk işlendikten sonra kenar düzelt',
    km: 'កែគែមបន្ទាប់ពីដំណើរការរណ្តៅ/រណ្តៅជង្ហុកក្រោយ',
    es: 'y la parte posterior se recorta después del procesamiento de la ranura.',
    ar: 'ويتم تشذيب الجانب الخلفي بعد معالجة الأخدود.',
  },
  'cuttingDock.cuttingParams.frontReCut': {
    zh: '正面再修边',
    en: 'Re-trim front side',
    id: 'Retouch bagian depan',
    kz: 'Алғашқы тараптағы шетті қайта кесу',
    th: 'ปรับด้านหน้า',
    ug: 'ئالدى قايتا چېگرىلاش',
    vi: 'Điều chỉnh cạnh mặt trước lại',
    zh_tc: '正面再修邊',
    ru: 'Перекройка фасада',
    ko: '정면 재수선',
    bur: 'ရှေ့မျက်နှာပြန်ပြင်',
    ben: 'ফ্রন্ট সাইড আবার ট্রিম করুন',
    tr: 'Ön yüzü yeniden düzelt',
    km: 'កែផ្ទៃមុខម្តងទៀត',
    es: 'Volver a recortar el lado frontal',
    ar: 'إعادة تشذيب الجانب الأمامي',
  },
  'cuttingDock.cuttingParams.frontReCutTip': {
    zh: '让定位气缸边更光滑，防止有痕迹',
    en: 'To make the positioning cylinder edge smoother and prevent marks',
    id: '(Buat tepi silinder posisi lebih halus untuk mencegah jejak)',
    kz: 'Өрістету қылім шеттерін жылмақ етіп, із-қалдықтарды болдырмау үшін',
    th: '(ทำให้ขอบทรงกระบอกที่ราบรื่นขึ้นเพื่อป้องกันร่องรอย)',
    ug: 'بېسىش سىلىندىرىسى چېگرىسىنى تەڭشەپ، ئىز قالدۇرماسلىق',
    vi: 'Làm mịn hơn缸định vị, ngăn ngừa dấu tích',
    zh_tc: '讓定位氣缸邊更光滑，防止有痕跡',
    ru: 'Сделайте край цилиндра более гладким, чтобы не было следов.',
    ko: '위치 지정 실린더 모서리를 매끄럽게 하여 흔적 방지',
    bur: 'တည်နေရာဆီလင်ဒါအစွန်းချောအောင်လုပ်၊ မှတ်တိုင်မရအောင်',
    ben: 'পজিশনিং সিলিন্ডার এজ মসৃণ করতে ও দাগ এড়াতে',
    tr: 'Konumlama silindiri kenarını daha pürüzsüz yapmak ve iz bırakmayı önlemek için',
    km: 'ដើម្បីធ្វើគែមស៊ីលីនដែរកំណត់ទីតាំងឱ្យរលូន និងការពារស្នាម',
    es: 'hace que el borde del cilindro de posicionamiento sea más suave y evita marcas',
    ar: 'يجعل تحديد موضع حافة الأسطوانة أكثر سلاسة ويمنع العلامات',
  },
  'cuttingDock.cuttingParams.useNewCut': {
    zh: '启用新版修边规则',
    en: 'Enable new trimming rules',
    id: 'Aktifkan versi baru aturan pemangkasan tepi',
    kz: 'Жаңа шетті кесу ережелерін іске қосу',
    th: 'เปิดใช้งานกฎการตัดแต่งขอบรุ่นใหม่',
    ug: 'يېڭى چېگرا قائىدىسىنى قوزغىتىش',
    vi: 'Kích hoạt quy tắc điều chỉnh cạnh mới',
    zh_tc: '啟用新版修邊規則',
    ru: 'Включить новые правила обрезки',
    ko: '새 모서리 수정 규칙 사용',
    bur: 'အစွန်းပြင်စည်းမျဉ်းအသစ်ဖွင့်',
    ben: 'নতুন ট্রিমিং রুল সক্ষম করুন',
    tr: 'Yeni kenar düzeltme kurallarını kullan',
    km: 'ប្រើច្បាប់កែគែមថ្មី',
    es: 'Habilite la nueva versión de las reglas de recorte',
    ar: 'تمكين الإصدار الجديد من قواعد التشذيب',
  },
  'cuttingDock.cuttingParams.newCutTip': {
    zh: '在双面加工大板的正面会多修一个修边尺寸时使用此功能',
    en: 'Use this function when an additional trimming dimension is required on the front side of double-sided processing of large panels',
    id: 'Gunakan fungsi ini ketika bagian depan pelat besar dua sisi akan diperbaiki dengan satu ukuran pemangkasan lagi.',
    kz: 'Екі тараптағы ірі тақтаның алғашқы тараптағы шетті кесудің қосымша өлшеміні пайдалану үшін',
    th: 'ใช้ฟังก์ชั่นนี้เมื่อด้านหน้าของแผ่นขนาดใหญ่สองด้านจะได้รับการซ่อมแซมด้วยขนาดการตัดแต่งอีกหนึ่งขนาด',
    ug: 'ئىككى تەرەپلىك ئىشلەنگەن چوڭ تاختىنىڭ ئالدى تەرىپىدە بىر چېگرا چوڭلۇقىدىن ئارتۇق چېگرىلاش كېرەك بولغاندا بۇ فۇنكسىيەنى ئىشلىتىڭ',
    vi: 'Sử dụng chức năng này khi hai mặt của tấm lớn sẽ được sửa chữa khi một cạnh kích thước',
    zh_tc: '在雙面加工大板的正面會多修一個修邊尺寸時使用此功能',
    ru: 'Эта функция используется при двухсторонней обработке фасада с большим размером обрезки.',
    ko: '이 기능은 양면 머시닝 보드의 전면에서 모서리 치수를 하나 더 수정할 때 사용됩니다.',
    bur: 'နှစ်ဘက်ပြုကြီးပြားရှေ့မျက်နှာတွင်အစွန်းပြင်အရွယ်တစ်ခုထပ်ပြင်သည့်အခါသုံးပါ',
    ben: 'ডাবল-সাইডেড প্রসেসিং বড় প্যানেলের সামনের দিকে একটি অতিরিক্ত ট্রিমিং ডাইমেনশন দরকার হলে এই ফাংশন ব্যবহার করুন',
    tr: 'Çift taraflı büyük plaka işlemde ön yüzde ek bir kenar payı gerektiğinde bu işlevi kullanın',
    km: 'ប្រើមុខងារនេះពេលដំណើរការផ្ទាំងធំពីរមុខត្រូវការកែគែមបន្ថែមនៅមុខ',
    es: 'Utilice esta función cuando se recortará un tamaño de recorte adicional en el lado frontal de una placa grande durante el procesamiento de doble cara',
    ar: 'استخدم هذه الوظيفة عندما سيتم قطع حجم تشذيب إضافي على الجانب الأمامي للوحة كبيرة أثناء المعالجة على الوجهين',
  },
  'cuttingDock.cuttingParams.fixedTip': {
    zh: '注意：保留位数为0或1可能会存在排版重叠',
    en: 'Attention: Keeping the decimal places to 0 or 1 may cause overlapping in layout',
    id: 'CATATAN: Mungkin ada teseettings yang tumpang tindih ketika jumlah digit yang ditahan adalah 0 atau 1.',
    kz: 'Назар аударыңыз: Қалдық мәні 0 немесе 1 болған жағдайда орналасу қателері болуы мүмкін',
    th: 'หมายเหตุ: อาจมีการเรียงพิมพ์ที่ทับซ้อนกันเมื่อจำนวนตัวเลขที่เก็บไว้คือ 0 หรือ 1',
    ug: 'دىققەت: ئونلۇق سان ساقلاش بېتى 0 ياكى 1 بولغاندا تەڭشەش قاپلىشىشى مۇمكىن',
    vi: 'Lưu ý: Giữ số chữ số thập phân ở mức 0 hoặc 1 có thể gây chồng chéo bố cục',
    zh_tc: '注意：保留位數為0或1可能會存在排版重疊',
    ru: 'Примечание: количество зарезервированных цифр 0 или 1 может дублировать набор',
    ko: '참고: 예약된 자릿수가 0 또는 1이면 레이아웃이 겹칠 수 있습니다.',
    bur: 'သတိပြု-ထားရှိသည့်နေရာသည်၀သို့မဟုတ်၁ပါကပြင်ဆင်ထပ်နိုင်သည်',
    ben: 'নোট: দশমিক স্থান ০ বা ১ রাখলে লেআউটে ওভারল্যাপ হতে পারে',
    tr: 'Dikkat: Ondalık basamak 0 veya 1 tutulursa yerleşim üst üste binebilir',
    km: 'ចំណាំ៖ រក្សាខ្ទង់ទសភាគ ០ ឬ ១ អាចធ្វើឱ្យរៀបចំស្ទូចគ្នា',
    es: 'Nota: Puede haber superposición tipográfica cuando los dígitos reservados son 0 o 1',
    ar: 'ملاحظة: قد يكون هناك تداخل في التنضيد عندما تكون الأرقام المحجوزة 0 أو 1',
  },
  'cuttingDock.cuttingParams.cuttingSlow': {
    zh: '下料板件表面缓冲',
    en: 'Buffer on the surface of cutting parts',
    id: 'Buffer permukaan pelat pemotongan',
    kz: 'Тақтаның беткі қабатын баяу кесу',
    th: 'ตัดบัฟเฟอร์พื้นผิวแผ่น',
    ug: 'ماتېرىيال چۈشۈرۈلگەن تاختا يۈزىدىكى توختىتىش',
    vi: 'Bề mặt tấm cắt chậm',
    zh_tc: '下料板件表面緩衝',
    ru: 'Буферизация поверхности нижней пластины',
    ko: '하단 패널 부품 표면 버퍼',
    bur: 'ဖြတ်ဖောက်သည်းပြားထဲသို့ တားဆီးခြင်း',
    ben: 'কাটিং পাতার পৃষ্ঠতল ভোলাম',
    tr: 'Kesilen parçaların yüzeyinde tampon',
    km: 'បម្រុងនៅលើផ្ទៃនៃផ្នែកកាត់',
    es: 'Amortiguamiento de la superficie de la placa ciega',
    ar: 'التخزين المؤقت لسطح اللوحة الفارغة',
  },
  'cuttingDock.cuttingParams.holeSlow': {
    zh: '打孔板件表面缓冲',
    en: 'Buffer on the surface of punching parts',
    id: 'Meninju bantal permukaan pelat',
    kz: 'Тақтаның беткі қабатын баяу тесіп өту',
    th: 'การเจาะพื้นผิวพื้นผิว',
    ug: 'تەشىك ئېچىلغان تاختا يۈزىدىكى توختىتىش',
    vi: 'Bề mặt tấm đục lỗ chậm',
    zh_tc: '打孔板件表面緩衝',
    ru: 'Буферизация поверхности перфоратора',
    ko: '펀치 플레이트 서피스 버퍼',
    bur: 'သော့ချိတ်ချိတ်သည်ပြားထဲသို့ တားဆီးခြင်း',
    ben: 'পাতার পৃষ্ঠতল ভোলাম',
    tr: 'Delinen parçaların yüzeyinde tampon',
    km: 'បម្រុងនៅលើផ្ទៃនៃផ្នែកដែលមានរន្ធ',
    es: 'Amortiguamiento de la superficie de la placa perforada',
    ar: 'سطح اللوحة المثقبة التخزين المؤقت',
  },
  'cuttingDock.cuttingParams.slotSlow': {
    zh: '拉槽/铣孔/铣槽板件表面缓冲',
    en: 'Buffer on the surface of grooving/milling holes/milling slots parts',
    id: 'Menarik alur/lubang penggilingan/buffer permukaan pelat alur milling',
    kz: 'Тақтаның беткі қабатын баяу арна/құбыр/тесікті өңдеу',
    th: 'ดึงร่อง/รูบัฟเฟอร์พื้นผิวร่อง/การกัด',
    ug: 'ئارقا تارتىش/مىل تەشىك/مىل ئارقا تاختىسى يۈزىدىكى توختىتىش',
    vi: 'Bề mặt tấm rãnh/ phay lỗ/ phay rãnh chậm',
    zh_tc: '拉槽/銑孔/銑槽板件表面緩衝',
    ru: 'Буферизация поверхности пластин с вытяжными пазами / фрезерными отверстиями / фрезерными пазами',
    ko: '슬롯 / 밀링 구멍 / 밀링 슬롯 플레이트 서피스 버퍼',
    bur: 'အကူဝင်/မီးလ်ချိတ်/မီးလ်အကူဝင် ပြားထဲသို့ တားဆီးခြင်း',
    ben: 'কাটিং ও ড্রিলিং পদ্ধতি',
    tr: 'Oluk / freze deliği / freze oluk parçalarının yüzeyinde tampon',
    km: 'បម្រុងនៅលើផ្ទៃនៃផ្នែករណ្តៅ / កាត់រណ្តៅ / កាត់រណ្តៅ',
    es: 'Ranurado/fresado/ranurado de la superficie del panel',
    ar: 'التخزين المؤقت لسطح لوحة الحز/الطحن/الحز',
  },
  'cuttingDock.cuttingParams.slowCode': {
    zh: '缓冲指令使用',
    en: 'Usage of buffer commands',
    id: 'Penggunaan instruksi buffering',
    kz: 'Баяу командасын қолдану',
    th: 'การใช้คำแนะนำบัฟเฟอร์',
    ug: 'توختىتىش بۇيرۇقى ئىشلىتىش',
    vi: 'Sử dụng mã đệm',
    zh_tc: '緩衝指令使用',
    ru: 'Использование буферных команд',
    ko: '버퍼 명령 사용',
    bur: 'တားဆီးချက်များအသုံးပြုခြင်း',
    ben: 'ঐচ্ছিক কমান্ড ব্যবহার',
    tr: 'Tampon komutlarının kullanımı',
    km: 'ការប្រើប្រាស់ពាក្យបញ្ជាបម្រុង',
    es: 'Uso del comando de almacenamiento',
    ar: 'استخدام أمر التخزين المؤقت',
  },
  'cuttingDock.cuttingParams.code': {
    zh: '指令',
    en: 'Command',
    id: 'petunjuk',
    kz: 'Команда',
    th: 'คำแนะนำ',
    ug: 'بۇيرۇق',
    vi: 'Mã lệnh',
    zh_tc: '指令',
    ru: 'инструкция',
    ko: '명령',
    bur: 'ညွှန်ကြားချက်',
    ben: 'কমান্ড',
    tr: 'Komut',
    km: 'ពាក្យបញ្ជា',
    es: 'Comando',
    ar: 'الأمر',
  },
  'cuttingDock.cuttingParams.bufferOffset': {
    zh: '板件表面缓冲高度偏移',
    en: 'Buffer height offset of the surface of the part',
    id: 'Offset tinggi bantal permukaan pelat',
    kz: 'Тақтаның беткі қабатының биіктігін бұрышын өзгерту',
    th: 'การปรับค่าบัฟเฟอร์ความสูงของพื้นผิวพื้นผิว',
    ug: 'تاختا يۈزىدىكى توختىتىش قىلىش',
    vi: 'Độ cao bề mặt tấm đệm chậm',
    zh_tc: '板件表面緩衝高度偏移',
    ru: 'Смещение высоты буфера поверхности детали',
    ko: '플레이트 서피스 버퍼 높이 오프셋',
    bur: 'ပြားထဲသို့ တားဆီးခြင်းအရွယ်အစားကို ပြောင်းလဲခြင်း',
    ben: 'পাতার পৃষ্ঠতল ভোলাম উচ্চতা অফসেট',
    tr: 'Parça yüzeyi tampon yüksekliği ofseti',
    km: 'ការផ្លាស់ទីកម្ពស់បម្រុងនៅលើផ្ទៃផ្នែក',
    es: 'Desplazamiento de la altura del almacenamiento de la superficie del panel',
    ar: 'إزاحة ارتفاع التخزين المؤقت لسطح اللوحة',
  },
  'cuttingDock.cuttingParams.zkRotatePoint': {
    zh: '旋转基准点',
    en: 'Rotation reference point',
    id: 'Putar titik referensi',
    kz: 'Айналу нүктесі',
    th: 'หมุนจุดอ้างอิง',
    ug: 'ئۆزگەرتىش ئاساس نۇقتىسى',
    vi: 'Điểm gốc xoay',
    zh_tc: '旋轉基準點',
    ru: 'Точка опоры вращения',
    ko: '데이텀 점 회전하기',
    bur: 'လည်ပတ်ရည်ညွှန်းအမှတ်',
    ben: 'ঘূর্ণন রেফারেন্স বিন্দু',
    tr: 'Döndürme referans noktası',
    km: 'ចំណុចយោងបង្វិល',
    es: 'Punto de referencia de rotación',
    ar: 'النقطة المرجعية للدوران',
  },
  'cuttingDock.cuttingParams.zkRotateDir': {
    zh: '旋转角度递增方向',
    en: 'Rotation angle increment direction',
    id: 'Arah kenaikan sudut rotasi',
    kz: 'Айналу бұрышының көбею бағыты',
    th: 'ทิศทางการเพิ่มมุมการหมุน',
    ug: 'ئۆزگەرتىش بۇلۇڭى ئاشقۇچ',
    vi: 'Hướng tăng góc xoay',
    zh_tc: '旋轉角度遞增方向',
    ru: 'Увеличить направление угла вращения',
    ko: '회전 각도 증가 방향',
    bur: 'လည်ပတ်ထောင့်တိုးမြှင့်ခြင်းဦးတည်ချက်',
    ben: 'ঘূর্ণন কোণ বৃদ্ধি দিক',
    tr: 'Dönüş açısı artış yönü',
    km: 'ទិសដៅកើននៃមុំបង្វិល',
    es: 'Dirección de incremento del ángulo de rotación',
    ar: 'اتجاه زيادة زاوية الدوران',
  },
  'cuttingDock.cuttingParams.restSizeLimit': {
    zh: '剩余尺寸小于',
    en: 'Remaining size of surplus is less than',
    id: 'Ukuran yang tersisa dari bahan yang tersisa lebih kecil dari',
    kz: 'Қалдық материалдың қалған өлшем аз',
    th: 'ขนาดที่เหลือของวัสดุที่เหลือมีขนาดเล็กกว่า',
    ug: 'قالدۇق چوڭلۇقى كىچىك',
    vi: 'Kích thước phần còn lại của vật liệu còn lại nhỏ hơn',
    zh_tc: '餘料剩餘尺寸小於',
    ru: 'Остальной размер меньше',
    ko: '남은 치수',
    bur: 'ကျန်ရှိအရွယ်အစားထက်နည်းသည်',
    ben: 'অবশিষ্ট আকারের চেয়ে কম',
    tr: 'Kalan boyut şundan küçük',
    km: 'ទំហំដែលនៅសល់តូចជាង',
    es: 'El tamaño restante es menor que',
    ar: 'الحجم المتبقي أقل من',
  },
  'cuttingDock.cuttingParams.useSaw': {
    zh: '使用锯片',
    en: 'Use saw blade',
    id: 'Menggunakan bilah gergaji',
    kz: 'Ара пышағын қолдану',
    th: 'ใช้ใบเลื่อย',
    ug: 'ئارقا كېسىش پىچىقىنى ئىشلىتىش',
    vi: 'Sử dụng lưỡi cưa',
    zh_tc: '使用鋸片',
    ru: 'Использовать пилу',
    ko: '톱날 사용',
    bur: 'ဆားကြိတ်ဓားသုံးပါ',
    ben: 'করাত ব্লেড ব্যবহার করুন',
    tr: 'Testere bıçağı kullan',
    km: 'ប្រើកាំបិទរណ្តៅ',
    es: 'Utilice una hoja de sierra',
    ar: 'استخدم شفرة المنشار',
  },
  'cuttingDock.cuttingParams.unGenSawPath': {
    zh: '不生成纵向锯片切割路径',
    en: 'Do not generate longitudinal saw blade cutting path',
    id: 'Tidak ada jalur pemotongan bilah gergaji longitudinal yang dihasilkan',
    kz: 'Ұзындық кесу жолын жасамау',
    th: 'ไม่มีเส้นทางตัดใบเลื่อยตามยาว',
    ug: 'بويۇن كېسىش ئارقا كېسىش يولىنى ئەمەلدىن قالدۇرماڭ',
    vi: 'Không tạo đường cắt lưỡi cưa dọc',
    zh_tc: '不生成縱向鋸片切割路徑',
    ru: 'Не генерировать путь продольной резки пилы',
    ko: '세로 톱날 가공 경로가 생성되지 않음',
    bur: 'အလျားလိုက်ဆားကြိတ်လမ်းမဖြစ်စေရ',
    ben: 'অনুদৈর্ঘ্য করাত ব্লেড কাটিং পথ তৈরি করবেন না',
    tr: 'Boyuna testere kesim yolu oluşturma',
    km: 'កុំបង្កើតផ្លូវកាត់រណ្តៅតាមបណ្តោយ',
    es: 'No genere una trayectoria de corte longitudinal de la hoja de sierra',
    ar: 'لا تنشئ مسار قطع طولي لنصل المنشار',
  },
  'cuttingDock.cuttingParams.suitMachine': {
    zh: '适用于全铝焊接板加工',
    en: 'Suitable for full aluminum welding plate processing',
    id: 'Cocok untuk memproses semua pelat yang dilas aluminium',
    kz: 'Толық алюминий дәнекерлеу тақтасын өңдеу үшін жарамды',
    th: 'เหมาะสำหรับการประมวลผลแผ่นเชื่อมอะลูมิเนียมทั้งหมด',
    ug: 'پۈتۈن ئالىومىن پىچىلغان تاختا ئىشلەشكە ماس كېلىدۇ',
    vi: 'Phù hợp cho gia công tấm hàn nhôm toàn bộ',
    zh_tc: '適用於全鋁焊接板加工',
    ru: 'Подходит для обработки полностью алюминиевых сварных пластин',
    ko: '전체 알루미늄 용접판 가공용',
    bur: 'အလူမီနီယမ်အပြည့်ပေါင်းချောင်းပြားပြုပြင်ခြင်းနှင့်ကိုက်ညီသည်',
    ben: 'সম্পূর্ণ অ্যালুমিনিয়াম ওয়েল্ডিং প্লেট প্রক্রিয়াকরণের জন্য উপযুক্ত',
    tr: 'Tam alüminyum kaynaklı plaka işlemeye uygundur',
    km: 'សមស្របសម្រាប់ការដំណើរការផ្ទាំងអាលុយមីញ៉ូមដែលផ្សារពេញលេញ',
    es: 'Adecuado para aluminio procesamiento de placa soldada',
    ar: 'مناسبة لمعالجة الألواح الملحومة المصنوعة بالكامل من الألومنيوم',
  },
  'cuttingDock.cuttingParams.plankBack': {
    zh: '大板后侧',
    en: 'Back of the large plank',
    id: 'Sisi belakang piring besar',
    kz: 'Үлкен тақтаның артқы жағы',
    th: 'ด้านหลังของแผ่นขนาดใหญ่',
    ug: 'چوڭ تاختىنىڭ ئارقا تەرىپى',
    vi: 'Mặt sau của tấm ván lớn',
    zh_tc: '大板後側',
    ru: 'Задняя сторона большой доски',
    ko: '대판 뒷면',
    bur: 'ကြီးမားသောပြားနောက်ဘက်',
    ben: 'বড় তক্তার পিছনের দিক',
    tr: 'Büyük levhın arka tarafı',
    km: 'ខាងក្រោយនៃផ្ទាំងធំ',
    es: 'Lado posterior del tablero grande',
    ar: 'الجانب الخلفي من اللوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.plankLeft': {
    zh: '大板左侧',
    en: 'Left side of the large plank',
    id: 'Sisi kiri papan',
    kz: 'Үлкен тақтаның сол жағы',
    th: 'ด้านซ้ายของบอร์ด',
    ug: 'چوڭ تاختىنىڭ سول تەرىپى',
    vi: 'Mặt trái của tấm ván lớn',
    zh_tc: '大板左側',
    ru: 'Большая доска слева',
    ko: '널빤지 왼쪽',
    bur: 'ကြီးမားသောပြားဘယ်ဘက်',
    ben: 'বড় তক্তার বাম দিক',
    tr: 'Büyük levhın sol tarafı',
    km: 'ខាងឆ្វេងនៃផ្ទាំងធំ',
    es: 'Lado izquierdo del tablero grande',
    ar: 'الجانب الأيسر من اللوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.plankRight': {
    zh: '大板右侧',
    en: 'Right side of the large plank',
    id: 'Sisi kanan papan',
    kz: 'Үлкен тақтаның оң жағы',
    th: 'ด้านขวาของบอร์ด',
    ug: 'چوڭ تاختىنىڭ ئوڭ تەرىپى',
    vi: 'Mặt phải của tấm ván lớn',
    zh_tc: '大板右側',
    ru: 'Большая доска справа',
    ko: '대판 오른쪽',
    bur: 'ကြီးမားသောပြားညာဘက်',
    ben: 'বড় তক্তার ডান দিক',
    tr: 'Büyük levhın sağ tarafı',
    km: 'ខាងស្តាំនៃផ្ទាំងធំ',
    es: 'Lado derecho del tablero grande',
    ar: 'الجانب الأيمن من اللوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.plankFront': {
    zh: '大板前侧',
    en: 'Front of the large plank',
    id: 'Sisi depan piring besar',
    kz: 'Үлкен тақтаның алдыңғы жағы',
    th: 'ด้านหน้าของแผ่นขนาดใหญ่',
    ug: 'چوڭ تاختىنىڭ ئالدى تەرىپى',
    vi: 'Mặt trước của tấm ván lớn',
    zh_tc: '大板前側',
    ru: 'Большая передняя сторона',
    ko: '널빤지 앞면',
    bur: 'ကြီးမားသောပြားရှေ့ဘက်',
    ben: 'বড় তক্তার সামনের দিক',
    tr: 'Büyük levhın ön tarafı',
    km: 'ខាងមុខនៃផ្ទាំងធំ',
    es: 'Lado frontal de la tabla grande',
    ar: 'الجانب الأمامي للوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.frontSide': {
    zh: '前侧',
    en: 'Front side',
    id: 'Sisi depan',
    kz: 'Алдыңғы жағы',
    th: 'ด้านหน้า',
    ug: 'ئالدى تەرىپ',
    vi: 'Mặt trước',
    zh_tc: '前側',
    ru: 'Передняя сторона',
    ko: '전면',
    bur: 'ရှေ့ဘက်',
    ben: 'সামনের দিক',
    tr: 'Ön taraf',
    km: 'ខាងមុខ',
    es: 'Lado frontal',
    ar: 'الجانب الأمامي',
  },
  'cuttingDock.cuttingParams.backSide': {
    zh: '后侧',
    en: 'Back side',
    id: 'Sisi belakang',
    kz: 'Артқы жағы',
    th: 'ด้านหลัง',
    ug: 'ئارقا تەرىپ',
    vi: 'Mặt sau',
    zh_tc: '後側',
    ru: 'Задняя сторона',
    ko: '후면',
    bur: 'နောက်ဘက်',
    ben: 'পিছনের দিক',
    tr: 'Arka taraf',
    km: 'ខាងក្រោយ',
    es: 'Lado posterior',
    ar: 'الجانب الخلفي',
  },
  'cuttingDock.cuttingParams.rightSide': {
    zh: '右侧',
    en: 'Right side',
    id: 'Sisi kanan',
    kz: 'Оң жағы',
    th: 'ด้านขวา',
    ug: 'ئوڭ تەرىپ',
    vi: 'Mặt phải',
    zh_tc: '右側',
    ru: 'справа',
    ko: '오른쪽',
    bur: 'ညာဘက်',
    ben: 'ডান দিক',
    tr: 'Sağ taraf',
    km: 'ខាងស្តាំ',
    es: 'Lado derecho',
    ar: 'الجانب الأيمن',
  },
  'cuttingDock.cuttingParams.leftSide': {
    zh: '左侧',
    en: 'Left side',
    id: 'Sisi kiri',
    kz: 'Сол жағы',
    th: 'ด้านซ้าย',
    ug: 'سول تەرىپ',
    vi: 'Mặt trái',
    zh_tc: '左側',
    ru: 'слева',
    ko: '왼쪽',
    bur: 'ဘယ်ဘက်',
    ben: 'বাম দিক',
    tr: 'Sol taraf',
    km: 'ខាងឆ្វេង',
    es: 'Lado izquierdo',
    ar: 'الجانب الأيسر',
  },
  'cuttingDock.cuttingParams.singleMachineLimit': {
    zh: '单面加工板正面生成修边路径且先修边',
    en: 'Generate edge trimming path on the front of single-sided processed panels and perform edge trimming first',
    id: 'Bagian depan papan pemesinan satu sisi menghasilkan jalur pemangkasan dan memangkasnya terlebih dahulu',
    kz: 'Бір жақты өңдеу тақтасының алдыңғы бетінде өңдеу жолын құру және алдымен өңдеу',
    th: 'ด้านหน้าของบอร์ดเครื่องจักรกลเดี่ยวสร้างเส้นทางการตัดแต่งและตัดแต่งก่อน',
    ug: 'بىر تەرەپلىك ئىشلەنگەن تاختىنىڭ ئالدى تەرىپىدە چېگرا يولى ھاسىل قىلىنىدۇ ۋە ئالدى بىلەن چېگرىلىنىدۇ',
    vi: 'Tạo đường cắt biên trên mặt trước của bảng gia công đơn và cắt biên trước',
    zh_tc: '單面加工板正面生成修邊路徑且先修邊',
    ru: 'Односторонняя обрабатывающая панель спереди образует путь к обрезке и сначала ремонтирует кромку',
    ko: '단면 가공판 전면은 모서리 수정 경로를 생성하고 모서리를 먼저 수정합니다.',
    bur: 'တစ်ဖက်သားပြားရှေ့တွင်အစွန်းညှိလမ်းဖြစ်စေပြီးဦးစွာအစွန်းညှိပါ',
    ben: 'একপাক্ষিক প্রক্রিয়াকৃত প্যানেলের সামনে প্রান্ত ট্রিমিং পথ তৈরি করুন এবং প্রথমে প্রান্ত ট্রিম করুন',
    tr: 'Tek yüz işlenmiş plakaların önünde kenar düzeltme yolu oluştur ve önce kenar düzelt',
    km: 'បង្កើតផ្លូវកែសម្រួលគែមនៅមុខផ្ទាំងដែលដំណើរការមួយផ្ទៃ ហើយកែសម្រួលគែមមុនគេ',
    es: 'La parte frontal de la placa de procesamiento de un solo lado genera una ruta de recorte y recorta el borde primero',
    ar: 'يقوم الجانب الأمامي للوحة المعالجة أحادية الجانب بإنشاء مسار تشذيب وتشذيب الحافة أولاً',
  },
  'cuttingDock.cuttingParams.singleMachineLimitTip': {
    zh: '一体机、锯片切割不生效该功能',
    en: 'This function does not apply to integrated machines or saw blade cutting',
    id: 'Mesin all-in-one dan pemotongan bilah tidak berlaku.',
    kz: 'Біріккен машиналар мен арамен кесу үшін бұл функция қолданыла алмайды',
    th: 'เครื่องทั้งหมดและการตัดใบมีดไม่มีผล',
    ug: 'بىرلىك ماشىنا، ئارقا كېسىش قېپىش بۇ فۇنكسىيەنى ئىشلەتمەيدۇ',
    vi: 'Chức năng này không áp dụng cho máy tích hợp và cắt bằng lưỡi cưa',
    zh_tc: '一體機、鋸片切割不生效該功能',
    ru: 'Универсальная машина, резка пилы не работает.',
    ko: '올인원 컴퓨터, 앤티앨리어싱 기능은 적용되지 않음',
    bur: 'ဤလုပ်ဆောင်ချက်သည်စနစ်တပ်စက်သို့မဟုတ်ဆားကြိတ်ဖြတ်ခြင်းနှင့်မသက်ဆိုင်ပါ',
    ben: 'একীভূত মেশিন বা করাত ব্লেড কাটিংয়ের জন্য এই ফাংশন প্রযোজ্য নয়',
    tr: 'Bu işlev entegre makineler veya testere bıçağı kesimi için geçerli değildir',
    km: 'មុខងារនេះមិនអនុវត្តសម្រាប់ម៉ាស៊ីនរួម ឬការកាត់ដោយកាំបិទរណ្តៅទេ',
    es: 'La máquina todo en uno y el corte con hoja de sierra no tienen efecto. Esta función',
    ar: 'لا يتم تفعيل الماكينة الشاملة ونصل المنشار. هذه الوظيفة',
  },
  'cuttingDock.cuttingParams.setBatchPositionWaring': {
    zh: '提示：如果需要取消快速修改下刀点模式，请取消勾选右侧修改下刀点按钮',
    en: 'Tip: If you need to cancel the quick modification of the cutting point mode, please uncheck the "Modify Cutting Point" button on the right side',
    id: 'Kiat: Jika Anda perlu membatalkan modifikasi cepat dari mode titik alat, silakan hapus centang modifikasi kanan dari tombol titik alat',
    kz: 'Кеңес: Егер сіз кесу нүктесін жылдам түзету режимін өшіруіңіз қажет болса, оң жақтағы «Кесу нүктесін түзету» түймесін алып тастаңыз',
    th: 'เคล็ดลับ: หากคุณต้องการยกเลิกการปรับเปลี่ยนอย่างรวดเร็วของโหมดจุดเครื่องมือโปรดยกเลิกการตรวจสอบการปรับเปลี่ยนขวาของปุ่มจุดเครื่องมือ',
    ug: 'ئەسكەرتىش: ئەگەر پىچاق چۈشۈش نۇقتىسىنى تېز ئۆزگەرتىش ئۇسۇلىنى ئەمەلدىن قالدۇرماقچى بولسىڭىز، ئوڭ تەرەپتىكى پىچاق چۈشۈش نۇقتىسىنى ئۆزگەرتىش كۇنۇپكىسىنى بېسىپ چىقىڭ',
    vi: 'Gợi ý: Nếu bạn cần hủy chế độ chỉnh sửa nhanh điểm cắt, vui lòng bỏ chọn nút "Chỉnh sửa điểm cắt" ở phía bên phải',
    zh_tc: '提示：如果需要取消快速修改下刀點模式，請取消勾選右側修改下刀點按鈕',
    ru: 'Совет: Если вам нужно отменить быстрое изменение режима точки вниз, отмените галочку и измените кнопку вниз',
    ko: '팁: 빠른 언더포인트 수정 모드를 취소하려면 오른쪽 언더포인트 수정 버튼의 선택을 취소합니다.',
    bur: 'အကြံပြုချက်: ဖြတ်ချက်အမှတ်မုဒ်ပြင်ဆင်ခြင်းပယ်ဖျက်လိုပါကညာဘက်ရှိဖြတ်ချက်အမှတ်ပြင်ဆင်ခလုတ်ကိုဖြည်ပါ',
    ben: 'পরামর্শ: কাটিং পয়েন্ট মোডের দ্রুত পরিবর্তন বাতিল করতে ডান দিকের মোডিফাই কাটিং পয়েন্ট বাটন আনচেক করুন',
    tr: 'İpucu: Kesim noktası hızlı değiştirme modunu iptal etmek için sağdaki «Kesim Noktasını Değiştir» kutusunun işaretini kaldırın',
    km: 'ព័ត៌មានជំនួយ៖ ប្រសិនបើអ្នកត្រូវការលុបចោលម៉ូដកែប្រែចំណុចកាត់រហ័ស សូមដកសម្គាល់ប៊ូតុង «កែប្រែចំណុចកាត់» ខាងស្តាំ',
    es: 'Consejo: Si necesita cancelar la modificación rápida del modo de punta de cuchilla inferior, desmarque el botón de modificación de punta de cuchilla inferior a la derecha',
    ar: 'نصيحة: إذا كنت بحاجة إلى إلغاء التعديل السريع لوضع نقطة السكين السفلية، فيرجى إلغاء تحديد زر تعديل نقطة السكين السفلية الموجود على اليمين',
  },
  'cuttingDock.cuttingParams.setBatchPosition': {
    zh: '批量修改下刀点',
    en: 'Batch modify cutting points',
    id: 'Titik modifikasi batch',
    kz: 'Кесу нүктелерін жаппай өзгерту',
    th: 'จุดดัดแปลงแบทช์',
    ug: 'پىچاق چۈشۈش نۇقتىسىنى بىر تۇتاش ئۆزگەرتىش',
    vi: 'Chỉnh sửa hàng loạt các điểm cắt',
    zh_tc: '批量修改下刀點',
    ru: 'Изменить точку сброса',
    ko: '다음 공구 점 대량 수정',
    bur: 'ဖြတ်ချက်အမှတ်များအစုလိုက်ပြင်ဆင်ပါ',
    ben: 'কাটিং পয়েন্ট ব্যাচ পরিবর্তন করুন',
    tr: 'Kesim noktalarını toplu değiştir',
    km: 'កែប្រែចំណុចកាត់ជាក្រុម',
    es: 'Modifique por lotes la punta de cuchilla inferior',
    ar: 'تعديل دفعة لنقطة السكين السفلية',
  },
  'cuttingDock.cuttingParams.setBatchPositionAs': {
    zh: '修改下刀方向为:',
    en: 'Modify the cutting direction to:',
    id: 'Ubah arah alat berikutnya ke:',
    kz: 'Кесу бағытын өзгерту:',
    th: 'แก้ไขทิศทางเครื่องมือถัดไปเป็น:',
    ug: 'پىچاق چۈشۈش يۆنىلىشىنى ئۆزگەرتىش:',
    vi: 'Chỉnh sửa hướng cắt thành:',
    zh_tc: '修改下刀方向為:',
    ru: 'Изменить направление ножа следующим образом:',
    ko: '다음 공구 방향을 다음과 같이 수정합니다.',
    bur: 'ဖြတ်ချက်ဦးတည်ချက်ပြင်ဆင်ပါ:',
    ben: 'কাটিং দিক পরিবর্তন করুন:',
    tr: 'Kesim yönünü şu şekilde değiştir:',
    km: 'កែប្រែទិសដៅកាត់ទៅជា៖',
    es: 'Modifique la dirección de corte a:',
    ar: 'تعديل اتجاه القطع إلى:',
  },
  'cuttingDock.cuttingParams.activeBatchPosition': {
    zh: '已经选择{activePartCount}块小板',
    en: '{activePartCount}small board has been selected',
    id: '{ActivePartCount} Board telah dipilih',
    kz: '{activePartCount}кішкентай тақта таңдалды',
    th: '{ActivePartCount} ได้รับการคัดเลือกบอร์ด',
    ug: '{activePartCount} دانە كىچىك تاختا تاللاندى',
    vi: 'Đã chọn {activePartCount} tấm ván nhỏ',
    zh_tc: '已經選擇{activePartCount}塊小板',
    ru: 'Выбрано {activePartCount} досок',
    ko: '{activePartCount}개의 작은 보드가 선택되었습니다',
    bur: 'ပြားငယ် {activePartCount}ချပ်ရွေးချယ်ပြီးပါပြီ',
    ben: '{activePartCount}টি ছোট বোর্ড নির্বাচন করা হয়েছে',
    tr: '{activePartCount} küçük levh seçildi',
    km: 'បានជ្រើសរើសផ្ទាំងតូច {activePartCount} សន្លឹក',
    es: '{activePartCount} se han seleccionado placas pequeñas',
    ar: '{activePartCount} تم تحديد لوحات صغيرة',
  },
  'cuttingDock.cuttingParams.specialFrontSide': {
    zh: '孔槽分流中设置的特殊孔槽优先排在大板正面',
    en: 'Special slots set in the slot diversion are prioritized on the front side of the large panel',
    id: 'Slot khusus yang disetel dalam slot diversion didasarkan pada urutan prioritas pada sisi depan panel besar',
    kz: 'Ойық бөлінісінде орнатылған арнайы ойықтар үлкен тақтаның алдыңғы жағында басымдыққа ие',
    th: 'รูและร่องพิเศษที่ตั้งค่าในการแยกรูและร่องจะถูกจัดลำดับความสำคัญที่ด้านหน้าของแผ่นใหญ่',
    ug: 'تەشىك-ئارقا تارقىتىش تەڭشىكىدىكى ئالاھىدە تەشىك-ئارقالار چوڭ تاختىنىڭ ئالدى تەرىپىگە ئالدىنقى قاتاردا تەڭشەيدۇ',
    vi: 'Các rãnh đặc biệt được đặt trong sự phân luồng rãnh được ưu tiên ở mặt trước của tấm lớn',
    zh_tc: '孔槽分流中設置的特殊孔槽優先排在大板正面',
    ru: 'Специальные отверстия, установленные в шунте отверстия, расположены спереди большой пластины.',
    ko: '슬롯 분류에 설정된 특수 슬롯은 대판 전면에 우선적으로 배치됩니다.',
    bur: 'အပိုင်းအခြားသတ်မှတ်ထားသောအထူးအခေါင်းများကိုကြီးမားသောပြားရှေ့တွင်ဦးစားပေးသည်',
    ben: 'স্লট ডাইভার্শনে সেট করা বিশেষ স্লটগুলি বড় প্যানেলের সামনের দিকে অগ্রাধিকার পায়',
    tr: 'Oluk yönlendirmede ayarlanan özel oluklar büyük levhın ön yüzünde önceliklidir',
    km: 'រណ្តៅពិសេសដែលកំណត់ក្នុងការបំបែករណ្តៅ ត្រូវបានដាក់អាទិភាពនៅមុខផ្ទាំងធំ',
    es: 'Los orificios especiales configurados en el desvío de orificios tienen prioridad en el frente de la placa grande',
    ar: 'يتم إعطاء الأولوية للثقوب الخاصة المحددة في تحويل الثقب في مقدمة اللوحة الكبيرة',
  },
  'cuttingDock.cuttingParams.rollCountTip': {
    zh: '启用孔槽分流后按照实际在雕刻机加工的反面孔槽计算翻板次数',
    en: 'Calculate the flip boards based on the actual processing by the engraving machine',
    id: 'Hitung jumlah lembaran berdasarkan pemrosesan sebenarnya oleh mesin pemotong',
    kz: 'Оймашы станоктың нақты өңдеуіне сәйкес аудару тақталарын есептеңіз',
    th: 'หลังจากเปิดใช้งานการแยกรูและร่อง ให้คำนวณจำนวนการพลิกตามรูและร่องด้านหลังที่ประมวลผลจริงบนเครื่องแกะสลัก',
    ug: 'تەشىك-ئارقا تارقىتىشنى قوزغىتىش بىلەن ئۆيۈچۈدە ئىشلەنگەن ئارقا تەرەپ تەشىك-ئارقالارنىڭ ئەمەلىي سانىغا ئاساسەن ئۆرۈلۈش سانى ھېسابلىنىدۇ',
    vi: 'Tính số tấm lật dựa trên quá trình gia công thực tế của máy khắc',
    zh_tc: '啟用孔槽分流後按照實際在雕刻機加工的反面孔槽計算翻板次數',
    ru: 'Расчет количества копий после включения шунтирования в соответствии с количеством обратных отверстий, фактически обработанных гравировальной машиной',
    ko: '구멍 슬롯 분류를 활성화한 후 조각기에서 실제로 가공한 후면 구멍 슬롯에 따라 리플리트 횟수를 계산합니다.',
    bur: 'ထွင်းထုစက်ဖြင့်အမှန်တကယ်ပြုပြင်မှုအရပြားလှန်အရေအတွက်တွက်ချက်ပါ',
    ben: 'খোদাই মেশিন দ্বারা প্রকৃত প্রক্রিয়াকরণের উপর ভিত্তি করে ফ্লিপ বোর্ড গণনা করুন',
    tr: 'Oluk yönlendirme açıldıktan sonra oyma makinesinde gerçekten işlenen arka yüz oluklarına göre çevirme sayısını hesaplayın',
    km: 'បន្ទាប់ពីបើកការបំបែករណ្តៅ គណនាចំនួនដងបត់តាមរណ្តៅខាងក្រោយដែលដំណើរការពិតលើម៉ាស៊ីនចុកចាក់',
    es: 'Después de habilitar el desvío de orificios, el número de Las copias se calculan en función de los orificios inversos reales procesados por la máquina de grabado',
    ar: 'بعد تمكين تحويل الثقب، الرقم يتم حساب عدد النسخ بناءً على الثقوب العكسية الفعلية التي تمت معالجتها بواسطة آلة النقش',
  },
  'cuttingDock.cuttingParams.specialFrontSideTip': {
    zh: '当前生产线因开启【孔槽分流中设置的特殊孔槽优先排在大板正面】或【启用孔槽分流后按照实际在雕刻机加工的反面孔槽计算翻板次数】功能，不支持切换生产线',
    en: 'The current production line does not support switching due to enabling the function of prioritizing special slots on the front side of the large board in slot diversion or calculating the flipping count based on the actual backside slot processing in the engraving machine after enabling slot diversion.',
    id: 'Baris produksi saat ini tidak mendukung pemindahan karena memungkinkan fungsi slot khusus pada sisi depan panel besar dalam slot diversion atau menghitung jumlah lembaran berdasarkan pemrosesan slot belakang sebenarnya dalam mesin pemotong setelah slot diversion diaktifkan.',
    kz: 'Ағымдағы өндірістік желіні ауыстыру қолдау көрсетілмейді, себебі ойықтарды бөлу кезінде арнайы ойықтарды үлкен тақтаның алдыңғы жағына орналастыру немесе ойықтарды бөлу қосылғаннан кейін гравировкалау машинасында өңделген артқы ойықтарға негізделген аудару санын есептеу функциясы қосылған.',
    th: 'สายการผลิตปัจจุบันไม่รองรับการสลับเนื่องจากเปิดใช้ฟังก์ชัน【รูและร่องพิเศษในด้านหน้า】หรือ【คำนวณจำนวนการพลิกตามรูด้านหลัง】',
    ug: 'نۆۋەتتىكى ئىشلەش سېپى «تەشىك-ئارقا تارقىتىش تەڭشىكىدىكى ئالاھىدە تەشىك-ئارقالار چوڭ تاختىنىڭ ئالدى تەرىپىگە ئالدىنقى قاتاردا تەڭشەيدۇ» ياكى «تەشىك-ئارقا تارقىتىشنى قوزغىتىش بىلەن ئۆيۈچۈدە ئىشلەنگەن ئارقا تەرەپ تەشىك-ئارقالارنىڭ ئەمەلىي سانىغا ئاساسەن ئۆرۈلۈش سانى ھېسابلىنىدۇ» فۇنكسىيىسىنى قوزغىتىپ قويغانلىقى ئۈچۈن، ئىشلەش سېپىنى ئالماشتۇرالمايدۇ',
    vi: 'Dây chuyền sản xuất hiện tại không hỗ trợ chuyển đổi do đã bật chức năng ưu tiên rãnh đặc biệt ở mặt trước tấm lớn trong phân luồng rãnh hoặc tính số lần lật dựa trên quá trình gia công rãnh mặt sau thực tế trên máy khắc sau khi kích hoạt phân luồng rãnh.',
    zh_tc:
      '當前生產線因開啟【孔槽分流中設置的特殊孔槽優先排在大板正面】或【啟用孔槽分流後按照實際在雕刻機加工的反面孔槽計算翻版次數】功能，不支持切換生產線',
    ru: 'Текущая производственная линия не поддерживает переключение производственной линии из - за открытия « специального отверстия, установленного в шунте отверстия, приоритетного расположения на передней части большой пластины» или « включения шунта отверстия в соответствии с фактической обработкой обратного отверстия в гравировочной машине»',
    ko: '현재 생산라인은 【구멍 슬롯 분류에 설정된 특수 구멍 슬롯은 대판 전면에 우선적으로 배치】 또는 【구멍 슬롯 분류 사용 후 실제 조각기에서 가공한 뒷면 구멍 슬롯에 따라 리메이크 횟수 계산】기능을 켜기 때문에 생산라인 전환을 지원하지 않습니다.',
    bur: 'အပိုင်းအခြားတွင်ကြီးမားသောပြားရှေ့တွင်အထူးအခေါင်းဦးစားပေးခြင်းသို့မဟုတ်အပိုင်းအခြားဖွင့်ပြီးထွင်းထုစက်တွင်အနောက်ဘက်အခေါင်းပြုပြင်မှုအရလှန်အရေအတွက်တွက်ချက်ခြင်းဖွင့်ထားသောကြောင့်လက်ရှိထုတ်လုပ်မှုလိုင်းပြောင်းခြင်းမပံ့ပိုးပါ',
    ben: 'স্লট ডাইভার্শনে বড় বোর্ডের সামনের দিকে বিশেষ স্লট অগ্রাধিকার বা স্লট ডাইভার্শন সক্ষম করার পর খোদাই মেশিনে প্রকৃত পিছনের স্লট প্রক্রিয়াকরণের উপর ভিত্তি করে ফ্লিপ কাউন্ট গণনা করার ফাংশন সক্ষম করার কারণে বর্তমান উৎপাদন লাইন স্যুইচিং সমর্থন করে না',
    tr: 'Mevcut üretim hattı, oluk yönlendirmede büyük levhın önünde özel oluklara öncelik verme veya oluk yönlendirme açıldıktan sonra oyma makinesindeki gerçek arka yüz oluk işlemesine göre çevirme sayısını hesaplama işlevlerinden biri etkin olduğu için hat değiştirmeyi desteklemez',
    km: 'បណ្តាញផលិតកម្មបច្ចុប្បន្នមិនគាំទ្រការប្តូរបណ្តាញទេ ដោយសារបានបើកមុខងារដាក់រណ្តៅពិសេសនៅមុខផ្ទាំងធំក្នុងការបំបែករណ្តៅ ឬគណនាចំនួនបត់តាមរណ្តៅខាងក្រោយពិតនៅលើម៉ាស៊ីនចុកចាក់បន្ទាប់ពីបើកការបំបែករណ្តៅ',
    es: 'La línea de producción actual no admite el cambio de líneas de producción porque la función 【孔槽分流中设置的特殊孔槽优先排在大板正面】 o 【启用孔槽分流后按照实际在雕刻机加工的反面孔槽计算翻板次数】 está activada',
    ar: 'خط الإنتاج الحالي لا يدعم تبديل خطوط الإنتاج بسبب تشغيل وظيفة 【孔槽分流中设置的特殊孔槽优先排在大板正面】 أو 【启用孔槽分流后按照实际在雕刻机加工的反面孔槽计算翻板次数】',
  },
  'cuttingDock.cuttingParams.doubleTrim': {
    zh: '双面板修边',
    en: 'Double sided panel trimming',
    id: 'Pemotongan panel dua sisi',
    kz: 'Қос жаппақты қысу',
    th: 'การตัดขอบแผ่นสองด้าน',
    ug: 'ئىككى تەرەپلىك تاختا چېگرىلاش',
    vi: 'Cắt tỉa đôi Panel',
    zh_tc: '雙面板修邊',
    ru: 'Двусторонняя обрезка',
    ko: '이중 패널 트림',
    bur: 'နှစ်ဖက်ပြားအစွန်းညှိခြင်း',
    ben: 'দ্বিপাক্ষিক প্যানেল ট্রিমিং',
    tr: 'Çift taraflı panel kenar düzeltme',
    km: 'ការកែសម្រួលគែមផ្ទាំងពីរផ្ទៃ',
    es: 'Recorte de doble panel',
    ar: 'التشذيب المزدوج',
  },
  'cuttingDock.cuttingParams.trim': {
    zh: '修边',
    en: 'Trimming',
    id: 'Pemotongan',
    kz: 'қысу',
    th: 'การตัดขอบ',
    ug: 'چېگرىلاش',
    vi: 'Cắt cạnh',
    zh_tc: '修邊',
    ru: 'Ремонт кромок',
    ko: '테두리를 깎다',
    bur: 'အစွန်းညှိခြင်း',
    ben: 'ট্রিমিং',
    tr: 'Kenar düzeltme',
    km: 'ការកែសម្រួលគែម',
    es: 'Recortar bordes',
    ar: 'تقليم الحواف',
  },
  'cuttingDock.cuttingParams.trimTwoSide': {
    zh: '修两边',
    en: 'Repair both sides',
    id: 'Pemotongan kedua sisi',
    kz: 'ئوق ئالدى жانа қызықты',
    th: 'ตัดสองด้าน',
    ug: 'ئىككى چېگرىنى چېگرىلاش',
    vi: 'Sửa cả hai bên',
    zh_tc: '修兩邊',
    ru: 'Ремонт обеих сторон',
    ko: '양쪽을 고치다',
    bur: 'နှစ်ဘက်ညှိပါ',
    ben: 'উভয় পাশ মেরামত করুন',
    tr: 'İki kenarı düzelt',
    km: 'កែសម្រួលពីរគែម',
    es: 'Recortar dos bordes',
    ar: 'تقليم حافتين',
  },
  'cuttingDock.cuttingParams.trimFourSide': {
    zh: '修四边',
    en: 'Fix the four sides',
    id: 'Pemotongan empat sisi',
    kz: 'төрт бұрышты қысу',
    th: 'ตัดสี่ด้าน',
    ug: 'تۆت چېگرىنى چېگرىلاش',
    vi: 'Sửa bốn mặt',
    zh_tc: '修四邊',
    ru: 'Четыре стороны.',
    ko: '사방을 수리하다',
    bur: 'လေးဘက်ညှိပါ',
    ben: 'চার দিক ঠিক করুন',
    tr: 'Dört kenarı düzelt',
    km: 'កែសម្រួលបួនគែម',
    es: 'Recortar cuatro bordes',
    ar: 'تقليم أربع حواف',
  },
  'cuttingDock.cuttingParams.rightInmShow': {
    zh: '如右图所示',
    en: 'As shown in the figure on the right',
    id: 'Seperti yang ditunjukkan pada gambar di sebelah kanan',
    kz: 'сол жақтағы суретте көрсетілгенінде',
    th: 'ดังแสดงในภาพทางขวา',
    ug: 'ئوڭدىكى رەسىمدە كۆرسىتىلگەندەك',
    vi: 'Như thể hiện trong hình bên phải',
    zh_tc: '如右圖所示',
    ru: 'Как показано на рисунке справа',
    ko: '오른쪽 그림과 같이',
    bur: 'ညာဘက်ပုံတွင်ပြထားသည့်အတိုင်း',
    ben: 'ডানদিকের চিত্রে দেখানো হয়েছে',
    tr: 'Sağdaki şekilde gösterildiği gibi',
    km: 'ដូចបានបង្ហាញនៅក្នុងរូបខាងស្តាំ',
    es: 'Como se muestra en la imagen de la derecha',
    ar: 'كما هو موضح في الصورة على اليمين',
  },
  'cuttingDock.cuttingParams.currentTrimDir': {
    zh: '为当前选中修边方向',
    en: 'for the currently selected trimming direction',
    id: 'untuk arah pemotongan yang saat ini dipilih',
    kz: 'ағымдағы таңдалған қысу жиберу бағытyna',
    th: 'เป็นทิศทางการตัดขอบที่เลือกในปัจจุบัน',
    ug: 'نۆۋەتتىكى تاللانغان چېگرىلاش يۆنىلىشى',
    vi: 'chọn hướng sửa cạnh cho hiện hành',
    zh_tc: '為當前選中修邊方向',
    ru: 'Настройка края для текущего выбора',
    ko: '현재 선택된 모서리 수정 방향',
    bur: 'လက်ရှိရွေးထားသောအစွန်းညှိဦးတည်ချက်အတွက်',
    ben: 'বর্তমানে নির্বাচিত ট্রিমিং দিকের জন্য',
    tr: 'Şu anda seçili kenar düzeltme yönü için',
    km: 'សម្រាប់ទិសដៅកែសម្រួលគែមដែលបានជ្រើសរើសបច្ចុប្បន្ន',
    es: 'es la dirección de corte seleccionada actualmente',
    ar: 'هو اتجاه التشذيب المحدد حاليًا',
  },
  'cuttingDock.cuttingParams.cylinderTip': {
    zh: '为定位气缸',
    en: 'to locate the cylinder',
    id: 'untuk menentukan posisi silinder',
    kz: 'бет атау қызылдыққа арнау',
    th: 'เป็นกระบอกสูบกำหนดตำแหน่ง',
    ug: 'بېسىش سىلىندىرىسى',
    vi: 'Để định vị xi lanh',
    zh_tc: '為定位氣缸',
    ru: 'Для установки цилиндров',
    ko: '실린더 위치 지정',
    bur: 'ဆလင်ဒါတည်နေရာသတ်မှတ်ရန်',
    ben: 'সিলিন্ডার অবস্থান নির্ধারণ করতে',
    tr: 'silindiri konumlandırmak için',
    km: 'ដើម្បីកំណត់ទីតាំងស៊ីលីនឌ័រ',
    es: 'es el cilindro de posicionamiento',
    ar: 'هو أسطوانة تحديد الموضع',
  },
  'cuttingDock.cuttingParams.onlyShort': {
    zh: '只修短边',
    en: 'Only repair the short edges',
    id: 'Hanya memperbaiki tepi pendek',
    kz: 'тек кымыл бұрышты қысу',
    th: 'ตัดเฉพาะด้านสั้น',
    ug: 'پەقەت قىسقا چېگرىنى چېگرىلاش',
    vi: 'chỉ cắt cạnh ngắn',
    zh_tc: '只修短邊',
    ru: 'Только короткие края.',
    ko: '짧은 모서리만 다듬기',
    bur: 'အတိုအစွန်းများကိုသာညှိပါ',
    ben: 'শুধুমাত্র ছোট প্রান্ত মেরামত করুন',
    tr: 'Yalnızca kısa kenarları düzelt',
    km: 'កែសម្រួលតែគែមខ្លី',
    es: 'recorta solo el borde corto',
    ar: 'تقوم بقص الحافة القصيرة فقط',
  },
  'cuttingDock.cuttingParams.singleTrim': {
    zh: '单面板生成修边路径',
    en: 'Single panel generation of trimming path',
    id: 'Pembuatan jalur pemotongan untuk panel tunggal',
    kz: 'бір жаппақты қысу жолын құру',
    th: 'แผ่นเดี่ยวสร้างเส้นทางการตัดขอบ',
    ug: 'بىر تەرەپلىك تاختا چېگرىلاش يولى ھاسىل قىلىش',
    vi: 'Một bảng tạo đường cắt tỉa',
    zh_tc: '單面板生成修邊路徑',
    ru: 'Однопанельный путь к обрезке',
    ko: '단일 패널 모서리 수정 경로 생성',
    bur: 'တစ်ဖက်သားပြားအစွန်းညှိလမ်းဖြစ်စေခြင်း',
    ben: 'একক প্যানেল ট্রিমিং পথ তৈরি',
    tr: 'Tek panel kenar düzeltme yolu oluştur',
    km: 'បង្កើតផ្លូវកែសម្រួលគែមសម្រាប់ផ្ទាំងតែមួយ',
    es: 'genera una ruta de corte para un solo panel',
    ar: 'تنشئ مسار تشذيب للوحة واحدة',
  },
  'cuttingDock.cuttingParams.hierarchyCutTwice': {
    zh: '拉槽铣槽分层切割',
    en: 'Slot milling and slot cutting with layered indexing',
    id: 'Pemotongan slot dan slot dengan indeks berlapis',
    kz: 'Секторлық миллинг және слоттың қаттығына түрленган қиылыс',
    th: 'การตัดแบบแบ่งชั้นสำหรับการกัดร่อง',
    ug: 'ئارقا تارتىش/مىل ئارقا قاتلام قېپىش',
    vi: 'Điện gia có rãnh và cắt rãnh theo lớp',
    zh_tc: '拉槽銑槽分層切割',
    ru: 'Слойная резка с вытяжными канавками',
    ko: '슬롯 밀링 슬롯 계층 컷',
    bur: 'အခေါင်းမြှောင်ခြင်းနှင့်အလွှာညွှန်းဖြတ်ခြင်း',
    ben: 'স্তরযুক্ত সূচীকরণ সহ স্লট মিলিং এবং স্লট কাটিং',
    tr: 'Oluk frezelemeye göre katmanlı kesim',
    km: 'ការកាត់ជាស្រទាប់សម្រាប់រណ្តៅដែលច្រឹករណ្តៅ',
    es: 'ranurado y fresado corte en capas',
    ar: 'حفر وأخاديد طحن وقطع ذات طبقات',
  },
  'cuttingDock.cuttingParams.knifeDia': {
    zh: '刀径小于等于',
    en: 'Knife diameter less than or equal to',
    id: 'Diameter pisau kurang dari atau sama dengan',
    kz: 'нож диаметрі менше немесе сол жоқ',
    th: 'เส้นผ่านศูนย์กลางใบมีดน้อยกว่าหรือเท่ากับ',
    ug: 'پىچاق دىئامېتىرى كىچىك ياكى تەڭ',
    vi: 'Đường kính dao nhỏ hơn hoặc bằng',
    zh_tc: '刀徑小於等於',
    ru: 'Размер ножа меньше равного',
    ko: '공구 길이가 같음보다 작음',
    bur: 'ဓားအချင်းသည်ထက်နည်းသို့မဟုတ်ညီမျှသည်',
    ben: 'ছুরির ব্যাস এর চেয়ে কম বা সমান',
    tr: 'Bıçak çapı şuna eşit veya daha küçük',
    km: 'អង្កត់ផ្ចិតកាំបិទតូចជាងឬស្មើ',
    es: 'Cuando el diámetro de la herramienta es menor o igual a',
    ar: 'عندما يكون قطر الأداة أقل من أو يساوي',
  },
  'cuttingDock.cuttingParams.slotDeep': {
    zh: '且槽深度大于等于',
    en: 'and the slot depth is greater than or equal to',
    id: 'dan kedalaman slot lebih dari atau sama dengan',
    kz: 'және қанат құрылығы көппенемесе сол жоқ',
    th: 'และความลึกของร่องมากกว่าหรือเท่ากับ',
    ug: 'ھەمدە ئارقا چوڭلۇقى چوڭ ياكى تەڭ',
    vi: 'và độ sâu rãnh lớn hơn bằng',
    zh_tc: '且槽深度大於等於',
    ru: 'Глубина канавки больше равной',
    ko: '슬롯 깊이가 같음',
    bur: 'အခေါင်းအနက်သည်ထက်ကြီးသို့မဟုတ်ညီမျှသည်',
    ben: 'এবং স্লট গভীরতা এর চেয়ে বড় বা সমান',
    tr: 've oluk derinliği şuna eşit veya daha büyük',
    km: 'ហើយជម្រៅរណ្តៅធំជាងឬស្មើ',
    es: 'y la profundidad de la ranura es mayor o igual a',
    ar: 'وعمق الأخدود أكبر من أو يساوي',
  },
  'cuttingDock.cuttingParams.cutTwiceSlot': {
    zh: '时，分层切割槽',
    en: 'When performing layered cutting of the slot',
    id: 'Saat melakukan pemotongan berlapis slot',
    kz: 'Уақытында, қаттық секторлық қиылыс',
    th: 'เมื่อ ตัดร่องแบบแบ่งชั้น',
    ug: 'بولغاندا، ئارقا قاتلام قېپىش',
    vi: 'dúng lúc, cắt rãnh theo lớp',
    zh_tc: '時，分層切割槽',
    ru: 'Когда, слоистый режущий желоб',
    ko: '경우 계층형 가공 슬롯',
    bur: 'အလွှာဖြတ်ခြင်းပြုလုပ်သည့်အခါ',
    ben: 'স্লটের স্তরযুক্ত কাটিং করার সময়',
    tr: 'olduğunda, olukta katmanlı kesim',
    km: 'នៅពេលធ្វើការកាត់រណ្តៅជាស្រទាប់',
    es: ', ranuras de corte en capas',
    ar: '، أخاديد القطع ذات الطبقات',
  },
  'cuttingDock.cuttingParams.twiceSlotDeep': {
    zh: '第二层切割深度为',
    en: 'The cutting depth of the second layer is',
    id: 'Kedalaman pemotongan lapisan kedua adalah',
    kz: 'Екінші қатты қиылыс ұзындығы',
    th: 'ความลึกการตัดชั้นที่สองคือ',
    ug: 'ئىككىنچى قاتلام قېپىش چوڭلۇقى',
    vi: 'Độ sâu cắt của lớp thứ hai là',
    zh_tc: '第二層切割深度為',
    ru: 'Глубина разреза второго слоя составляет',
    ko: '두 번째 레벨 가공 깊이는',
    bur: 'ဒုတိယအလွှာဖြတ်ချက်အနက်မှာ',
    ben: 'দ্বিতীয় স্তরের কাটিং গভীরতা',
    tr: 'İkinci katman kesim derinliği',
    km: 'ជម្រៅការកាត់ស្រទាប់ទីពីរ',
    es: 'La profundidad de corte de la segunda capa es',
    ar: 'عمق قطع الطبقة الثانية هو',
  },
  'cuttingDock.cuttingParams.cutTwiceCondition': {
    zh: '切割条件',
    en: 'Cutting conditions',
    id: 'Kondisi pemotongan',
    kz: 'Қиысу шарттары',
    th: 'เงื่อนไขการตัด',
    ug: 'قېپىش شەرتى',
    vi: 'Điều kiện cắt',
    zh_tc: '切割條件',
    ru: 'Условия резки',
    ko: '가공 조건',
    bur: 'ဖြတ်ချက်အခြေအနေ',
    ben: 'কাটিং শর্ত',
    tr: 'Kesim koşulları',
    km: 'លក្ខខណ្ឌកាត់',
    es: 'Condiciones de corte',
    ar: 'ظروف القطع',
  },
  'cuttingDock.cuttingParams.zkPointCustomizeTip': {
    zh: '开启xy轴互换会导致加工方向和基准点相反',
    en: 'Activating the XY axis swap will result in the processing direction and reference point being reversed',
    id: 'Mengaktifkan pertukaran sumbu XY akan menyebabkan arah pemrosesan dan titik referensi menjadi terbalik',
    kz: 'XY артықтарының ауыстыруын іске қосу,әрекеттер жиберу жибынуының жағдайына қарсы ауысады және негізгі нүктесі қарсы ауысады',
    th: 'การเปิดใช้การสลับแกน XY จะทำให้ทิศทางการประมวลผลและจุดอ้างอิงกลับกัน',
    ug: 'xy ئوكۇل ئالماشتۇرۇشنى قوزغىتىش ئىشلەش يۆنىلىشى ۋە ئاساس نۇقتىسىنىڭ قارشى بولۇشىغا سەۋەپ بولىدۇ',
    vi: 'Kích hoạt hoán đổi trục XY sẽ dẫn đến hướng xử lý và điểm tiêu chuẩn ngược lại',
    zh_tc: '開啟xy軸互換會導致加工方向和基準點相反',
    ru: 'Включение XY - осевого свопа приводит к противоположному направлению обработки и точке отсчета',
    ko: 'xy 축 교환을 켜면 가공 방향과 데이텀 점이 반대가 됩니다.',
    bur: 'XY ဝင်ရိုးအပြန်အလှန်ဖွင့်ခြင်းသည်ပြုပြင်မှုဦးတည်ချက်နှင့်ရည်ညွှန်းအမှတ်ပြောင်းပြန်ဖြစ်စေသည်',
    ben: 'XY অক্ষ সোয়াপ সক্রিয় করলে প্রক্রিয়াকরণের দিক এবং রেফারেন্স পয়েন্ট বিপরীত হবে',
    tr: 'XY eksen takasını etkinleştirmek işleme yönünü ve referans noktasını tersine çevirir',
    km: 'ការបើកប្តូរអ័ក្ស XY នឹងធ្វើឱ្យទិសដៅដំណើរការ និងចំណុចយោងផ្ទុយគ្នា',
    es: 'Activar el intercambio del eje xy hará que la dirección de procesamiento sea opuesta al punto de referencia',
    ar: 'سيؤدي تشغيل تبادل المحور xy إلى أن يكون اتجاه المعالجة معاكسًا للنقطة المرجعية',
  },
  'cuttingDock.cuttingParams.zkPointCustomizeTip1': {
    zh: '开启xy轴互换的设备不生效该功能',
    en: 'This function does not work for devices that enable XY axis interchange',
    id: 'Fungsi ini tidak berfungsi untuk perangkat yang mengaktifkan pertukaran sumbu XY',
    kz: 'XY аспạnын ауыстыру функциясы іске қосылған құрылғының осы функциясы іске асырылмайды',
    th: 'อุปกรณ์ที่เปิดใช้การสลับแกน XY ไม่รองรับฟังก์ชันนี้',
    ug: 'xy ئوكۇل ئالماشتۇرۇشنى قوزغىتقان قوراللار بۇ فۇنكسىيەنى ئىشلەتمەيدۇ',
    vi: 'Thiết bị bật hoán đổi trục xy không hoạt động chức năng này',
    zh_tc: '開啟xy軸互換的設備不生效該功能',
    ru: 'Устройство, открывающее своп оси xy, не работает',
    ko: 'xy 축 교환을 켜는 장치에는 이 기능이 적용되지 않습니다.',
    bur: 'XY ဝင်ရိုးအပြန်အလှန်ဖွင့်ထားသောကိရိယာများတွင်ဤလုပ်ဆောင်ချက်အလုပ်မလုပ်ပါ',
    ben: 'XY অক্ষ ইন্টারচেঞ্জ সক্ষম ডিভাইসগুলির জন্য এই ফাংশন কাজ করে না',
    tr: 'XY eksen takası açık olan cihazlarda bu işlev çalışmaz',
    km: 'មុខងារនេះមិនដំណើរការលើឧបករណ៍ដែលបើកការប្តូរអ័ក្ស XY ទេ',
    es: 'Esta función no tendrá efecto en equipos que activan el intercambio del eje xy',
    ar: 'لن تسري هذه الوظيفة على المعدات التي تقوم بتشغيل تبادل المحور xy',
  },
  'cuttingDock.cuttingParams.isCustom': {
    zh: '开启自定义',
    en: 'Enable customization',
    id: 'Aktifkan pengustomisasian',
    kz: 'Таңдаулы мәндетін іске қосу',
    th: 'เปิดใช้งานกำหนดเอง',
    ug: 'ئىختىيارى تەڭشەشنى قوزغىتىش',
    vi: 'Kích hoạt tùy chỉnh',
    zh_tc: '開啟自定義',
    ru: 'Открыть настройку',
    ko: '사용자 정의 열기',
    bur: 'စိတ်ကြိုက်ပြင်ဆင်ခြင်းဖွင့်ပါ',
    ben: 'কাস্টমাইজেশন সক্ষম করুন',
    tr: 'Özelleştirmeyi etkinleştir',
    km: 'បើកការកំណត់ផ្ទាល់ខ្លួន',
    es: 'Activar la personalización',
    ar: 'تشغيل التخصيص',
  },
  'cuttingDock.cuttingParams.useCutCon': {
    zh: '使用锯切条件',
    en: 'Using sawing conditions',
    id: 'Menggunakan kondisi pemotongan',
    kz: 'Қиылыс түрін қолдану шарттары',
    th: 'ใช้เงื่อนไขการเลื่อย',
    ug: 'ئارقا كېسىش شەرتىنى ئىشلىتىش',
    vi: 'Điều kiện sử dụng cắt xi măng',
    zh_tc: '使用鋸切條件',
    ru: 'Условия использования пилы',
    ko: '톱질 조건 사용',
    bur: 'ဆားကြိတ်ဖြတ်ချက်အခြေအနေသုံးပါ',
    ben: 'করাত কাটার শর্ত ব্যবহার করা',
    tr: 'Testere kesim koşullarını kullan',
    km: 'ប្រើលក្ខខណ្ឌកាត់រណ្តៅ',
    es: 'Usar condiciones de aserrado',
    ar: 'استخدام شروط النشر',
  },
  'cuttingDock.cuttingParams.singleSetPlankSizeSpeed': {
    zh: '单独设置小板尺寸范围加工速度',
    en: 'Set Processing Speed for Specific Plank Size Range',
    id: 'Atur Kecepatan Pemrosesan untuk Rentang Ukuran Papan Spesifik',
    kz: 'Арнайы тақтай өлшемдері үшін өңдеу жылдамдығын орнату',
    th: 'ตั้งค่าความเร็วในการประมวลผลสำหรับช่วงขนาดแผ่นเล็กแยกต่างหาก',
    ug: 'قېپىش سۈرئىتى بولمايدىغان',
    vi: 'Đặt tốc độ xử lý cho kích thước ván cụ thể',
    zh_tc: '單獨設置小板尺寸範圍加工速度',
    ru: 'Установите скорость обработки в диапазоне размеров',
    ko: '개별 보드 크기 범위 가공 속도 설정',
    bur: 'ပြားငယ်အရွယ်အစားအတိုင်းအတာအလိုက်ပြုပြင်မှုအမြန်နှုန်းသတ်မှတ်ပါ',
    ben: 'নির্দিষ্ট তক্তার আকারের জন্য প্রক্রিয়াকরণ গতি সেট করুন',
    tr: 'Belirli levha boyutu aralığı için işleme hızını ayarla',
    km: 'កំណត់ល្បឿនដំណើរការសម្រាប់ជួរទំហំផ្ទាំងជាក់លាក់',
    es: 'Configure la velocidad de procesamiento del rango de tamaño de placa pequeña individualmente',
    ar: 'اضبط سرعة المعالجة لنطاق حجم اللوحة الصغيرة بشكل فردي',
  },
  'cuttingDock.cuttingParams.singleSetPlankSizeSpeedTip': {
    zh: '（1.当满足下方设置尺寸的小板会按照设置的加工速度进行加工 2.当小板同时满足多条规则时生效速度最小规则 3.该功能不对锯片切割生效）',
    en: '(1. When the small plank meets the size settings below, it will be processed at the specified speed. 2. If the small plank meets multiple rules simultaneously, the rule with the earlier sequence number takes effect. 3. This feature does not apply to saw blade cutting.)',
    id: '(1. Ketika tepi kecil memenuhi pengaturan ukuran di bawah ini, ia akan diproses dengan kecepatan yang ditentukan. 2. Jika tepi kecil memenuhi beberapa aturan sekaligus, aturan dengan nomor urutan yang lebih awal berlaku. 3. Fitur ini tidak berlaku untuk pemotongan dengan pisau gergaji.)',
    kz: '(1. Төмендегі өлшемдерге сәйкес келетін шағын тақтайлар белгіленген жылдамдықпен өңделеді. 2. Егер шағын тақтай бір уақытта бірнеше ережеге сәйкес келсе, ертерек реттік нөмірі бар ереже қолданылады. 3. Бұл функция ара пышағымен кесуге қолданылмайды.)',
    th: '(1. แผ่นเล็กที่ตรงตามขนาดที่ตั้งไว้จะถูกประมวลผลตามความเร็วที่กำหนด 2. เมื่อแผ่นเล็กตรงตามหลายกฎพร้อมกัน กฎความเร็วต่ำสุดจะมีผล 3. ฟังก์ชันนี้ไม่มีผลกับการตัดใบเลื่อย)',
    ug: 'قېپىش سۈرئىتى بولمايدىغان',
    vi: '(1. Khi tấm nhỏ đáp ứng các kích thước được thiết lập bên dưới, nó sẽ được xử lý với tốc độ đã chỉ định. 2. Nếu tấm nhỏ đồng thời đáp ứng nhiều quy tắc, quy tắc có số thứ tự sớm hơn sẽ được áp dụng. 3. Tính năng này không áp dụng cho cắt bằng lưỡi cưa.)',
    zh_tc:
      '（1.當滿足下方設置尺寸的小板會按照設置的加工速度進行加工 2.當小板同時滿足多條規則時生效速度最小規則 3.該功能不對鋸片切割生效）',
    ru: '(1) При выполнении заданного ниже размера пластина обрабатывается с установленной скоростью обработки. Минимальная скорость вступления в силу, когда пластина соответствует нескольким правилам одновременно.',
    ko: '(1. 아래 설정 치수를 만족하는 보드는 설정된 가공 속도에 따라 가공됩니다. 2. 보드가 여러 규칙을 동시에 만족하는 경우 최소 규칙 적용. 이 기능은 앤티앨리어싱에 적용되지 않습니다.)',
    bur: '(1. အောက်ပါအရွယ်အစားနှင့်ကိုက်ညီသောပြားငယ်ကိုသတ်မှတ်အမြန်နှုန်းဖြင့်ပြုပြင်မည်။ 2. ပြားငယ်သည်တစ်ချိန်တည်းစည်းမျဉ်းများစွာနှင့်ကိုက်ညီပါကအစောပိုင်းအစဉ်လိုက်စည်းမျဉ်းအကျိုးသက်ရောက်သည်။ 3. ဤအင်္ဂါရပ်သည်ဆားကြိတ်ဖြတ်ခြင်းနှင့်မသက်ဆိုင်ပါ။)',
    ben: '(1. ছোট তক্তা নিচের আকার সেটিংস পূরণ করলে নির্দিষ্ট গতিতে প্রক্রিয়া করা হবে। 2. একসাথে একাধিক নিয়ম পূরণ করলে আগের সিকোয়েন্স নম্বরের নিয়ম কার্যকর। 3. করাত ব্লেড কাটিংয়ের জন্য এই ফিচার প্রযোজ্য নয়।)',
    tr: '(1. Aşağıdaki boyut ayarlarını sağlayan küçük levh belirtilen hızda işlenir. 2. Küçük levha aynı anda birden çok kuralı sağlarsa, daha erken sıra numaralı kural geçerlidir. 3. Bu özellik testere bıçağı kesimi için geçerli değildir.)',
    km: '(១. ផ្ទាំងតូចដែលត្រូវទំហំខាងក្រោមនឹងត្រូវដំណើរការតាមល្បឿនដែលបានកំណត់។ ២. ប្រសិនបើផ្ទាំងតូចត្រូវនឹងច្បាប់ច្រើនក្នុងពេលតែមួយ ច្បាប់ដែលមានលេខលំដាប់មុនគេមានប្រសិទ្ធភាព។ ៣. មុខងារនេះមិនអនុវត្តសម្រាប់ការកាត់ដោយកាំបិទរណ្តៅទេ។)',
    es: '(1. Cuando la placa pequeña que cumple con el tamaño establecido a continuación se procesará a la velocidad de procesamiento establecida 2. Cuando la placa pequeña cumple con varias reglas al mismo tiempo, la regla de velocidad mínima entrará en vigor 3. Esta función no tiene efecto en el corte con hoja de sierra)',
    ar: '(1. عندما تكون اللوحة الصغيرة ستتم معالجة الحجم الذي يلبي الحجم المحدد أدناه بسرعة المعالجة المحددة 2. عندما تلبي اللوحة الصغيرة قواعد متعددة في نفس الوقت، ستسري قاعدة الحد الأدنى للسرعة 3. لا تسري هذه الوظيفة على قطع شفرة المنشار)',
  },
  'cuttingDock.cuttingParams.addSpeedRules': {
    zh: '添加规则',
    en: 'Add Rule',
    id: 'Tambahkan Aturan',
    kz: 'Ереже қосу',
    th: 'เพิ่มกฎ',
    ug: 'قائىدە قوشۇش',
    vi: 'Thêm quy tắc',
    zh_tc: '添加規則',
    ru: 'Добавить правило',
    ko: '규칙 추가',
    bur: 'စည်းမျဉ်းထည့်ပါ',
    ben: 'নিয়ম যোগ করুন',
    tr: 'Kural ekle',
    km: 'បន្ថែមច្បាប់',
    es: 'Agregar regla',
    ar: 'أضف قاعدة',
  },
  'cuttingDock.cuttingParams.speedRules': {
    zh: '规则',
    en: 'Rule',
    id: 'Aturan',
    kz: 'Ереже',
    th: 'กฎ',
    ug: 'قائىدە',
    vi: 'Quy tắc',
    zh_tc: '規則',
    ru: 'правило',
    ko: '규칙',
    bur: 'စည်းမျဉ်း',
    ben: 'নিয়ম',
    tr: 'Kural',
    km: 'ច្បាប់',
    es: 'Regla',
    ar: 'القاعدة',
  },
  'cuttingDock.cuttingParams.shortSideSize': {
    zh: '短边尺寸',
    en: 'Short Side Size',
    id: 'Ukuran Tepi Pendek',
    kz: 'Қысқа жағының өлшемі',
    th: 'ขนาดด้านสั้น',
    ug: 'قىسقا ياق ئۆلچىمى',
    vi: 'Kích thước cạnh ngắn',
    zh_tc: '短邊尺寸',
    ru: 'Короткие боковые размеры',
    ko: '짧은 모서리 치수',
    bur: 'အတိုဘက်အရွယ်အစား',
    ben: 'সংক্ষিপ্ত পাশের আকার',
    tr: 'Kısa kenar boyutu',
    km: 'ទំហំគែមខ្លី',
    es: 'Tamaño del lado corto',
    ar: 'حجم الجانب القصير',
  },
  'cuttingDock.cuttingParams.lessThanEqual': {
    zh: '小于等于',
    en: 'Less Than or Equal',
    id: 'Kurang Dari atau Sama Dengan',
    kz: 'Кіші немесе тең',
    th: 'น้อยกว่าหรือเท่ากับ',
    ug: 'كىچىك ياكى تەڭ',
    vi: 'Nhỏ hơn hoặc bằng',
    zh_tc: '小於等於',
    ru: 'Меньше чем равно',
    ko: '보다 작음',
    bur: 'ထက်နည်းသို့မဟုတ်ညီမျှ',
    ben: 'এর চেয়ে কম বা সমান',
    tr: 'Küçük veya eşit',
    km: 'តូចជាងឬស្មើ',
    es: 'Menor o igual a',
    ar: 'أقل من أو يساوي',
  },
  'cuttingDock.cuttingParams.and': {
    zh: '且',
    en: 'And',
    id: 'Dan',
    kz: 'Және',
    th: 'และ',
    ug: 'ۋە',
    vi: 'Và',
    zh_tc: '且',
    ru: 'А',
    ko: '그리고',
    bur: 'နှင့်',
    ben: 'এবং',
    tr: 'Ve',
    km: 'និង',
    es: 'y',
    ar: 'و',
  },
  'cuttingDock.cuttingParams.longSideSize': {
    zh: '长边尺寸',
    en: 'Long Side Size',
    id: 'Ukuran Tepi Panjang',
    kz: 'Ұзын жағының өлшемі',
    th: 'ขนาดด้านยาว',
    ug: 'ئۇزۇن ياق ئۆلچىمى',
    vi: 'Kích thước cạnh dài',
    zh_tc: '長邊尺寸',
    ru: 'Длинный размер',
    ko: '긴 모서리 치수',
    bur: 'အရှည်ဘက်အရွယ်အစား',
    ben: 'দীর্ঘ পাশের আকার',
    tr: 'Uzun kenar boyutu',
    km: 'ទំហំគែមវែង',
    es: 'Tamaño del lado largo',
    ar: 'حجم الجانب الطويل',
  },
  'cuttingDock.cuttingParams.processingSpeed': {
    zh: '加工速度',
    en: 'Processing Speed',
    id: 'Kecepatan Pemrosesan',
    kz: 'Өңдеу жылдамдығы',
    th: 'ความเร็วในการแปรรูป',
    ug: 'ئىشلەش تېزلىكى',
    vi: 'Tốc độ xử lý',
    zh_tc: '加工速度',
    ru: 'Скорость обработки',
    ko: '가공 속도',
    bur: 'ပြုပြင်မှုအမြန်နှုန်း',
    ben: 'প্রক্রিয়াকরণ গতি',
    tr: 'İşleme hızı',
    km: 'ល្បឿនដំណើរការ',
    es: 'Velocidad de procesamiento',
    ar: 'سرعة المعالجة',
  },
  'cuttingDock.cuttingParams.trimLenCompensation': {
    zh: '修边长度补偿：',
    en: 'Trimming length compensation:',
    id: 'Kompensasi panjang pemotongan:',
    kz: 'Қиып түзету ұзындығы:',
    th: 'การชดเชยความยาวการตัด:',
    ug: 'قىراش ئۇزۇنلۇق تۆزەتمىسى:',
    vi: 'Bù chiều dài cắt:',
    zh_tc: '修邊長度補償：',
    ru: 'Компенсация длины обрезки:',
    ko: '모서리 길이 보정:',
    bur: 'အစွန်းညှိအရှည်ပြန်လည်ထူထောင်ခြင်း:',
    ben: 'ট্রিমিং দৈর্ঘ্য ক্ষতিপূরণ:',
    tr: 'Kenar düzeltme uzunluk telafisi:',
    km: 'ការសងសឹងប្រវែងកែសម្រួលគែម៖',
    es: 'Compensación de longitud de recorte:',
    ar: 'تعويض طول القطع:',
  },
  'cuttingDock.cuttingParams.trimGenerateAPath': {
    zh: '修边值为0不生成路径：',
    en: 'A trimming value of 0 does not generate a path:',
    id: 'Nilai potong 0 tidak menghasilkan jalur:',
    kz: '0 мәні жол құрмайды:',
    th: 'ค่าตัด 0 ไม่สร้างเส้นทาง:',
    ug: '0 قىممىتى يول ھاسىل قىلمايدۇ:',
    vi: 'Giá trị cắt 0 không tạo đường dẫn:',
    zh_tc: '修邊值為0不生成路徑：',
    ru: 'Изменить значение границы 0 без создания пути:',
    ko: '수정 모서리 값이 0이면 경로가 생성되지 않습니다.',
    bur: 'အစွန်းညှိတန်ဖိုး 0 သည်လမ်းမဖြစ်စေပါ:',
    ben: 'ট্রিমিং মান 0 পথ তৈরি করে না:',
    tr: 'Kenar düzeltme değeri 0 yol oluşturmaz:',
    km: 'តម្លៃកែសម្រួលគែម ០ មិនបង្កើតផ្លូវទេ៖',
    es: 'No se genera ninguna ruta cuando el valor de recorte es 0:',
    ar: 'لا يتم إنشاء مسار عندما تكون قيمة القطع 0:',
  },
  'cuttingDock.labelingSettings.title': {
    zh: '贴标设置',
    en: 'Label Settings',
    id: 'Pengaturan Pelabelan',
    kz: 'Етикеттерди орнатуу',
    th: 'การตั้งค่าการติดฉลาก',
    ug: 'بەلگە قويۇش تەڭشىكى',
    vi: 'Cài đặt ghi nhãn',
    zh_tc: '貼標設置',
    ru: 'Настройка метки',
    ko: '부착 설정',
    bur: 'အညွှန်းသတ်မှတ်ချက်များ',
    ben: 'লেবেল সেটিংস',
    tr: 'Etiket ayarları',
    km: 'ការកំណត់ស្លាក',
    es: 'Configuración de etiquetado',
    ar: 'إعدادات وضع العلامات',
  },
  'cuttingDock.labelingSettings.output': {
    zh: '输出自动贴标文件',
    en: 'Output Automatic Labeling File',
    id: 'File pelabelan otomatis output',
    kz: 'Автоматтык этикетка файлдарын чыгаруу',
    th: 'ไฟล์การติดฉลากอัตโนมัติเอาต์พุต',
    ug: 'ئاپتوماتىك بەلگە قويۇش ھۆججىتىنى چىقىرىش',
    vi: 'Xuất tệp ghi nhãn tự động',
    zh_tc: '輸出自動貼標文件',
    ru: 'Файл автоматической метки вывода',
    ko: '자동 부착 파일 내보내기',
    bur: 'အလိုအလျောက်အညွှန်းဖိုင်ထုတ်ပါ',
    ben: 'স্বয়ংক্রিয় লেবেলিং ফাইল আউটপুট',
    tr: 'Otomatik etiket dosyasını dışa aktar',
    km: 'នាំចេញឯកសារស្លាកស្វ័យប្រវត្តិ',
    es: 'Archivo de etiquetado automático de salida',
    ar: 'إخراج ملف وضع العلامات التلقائي',
  },
  'cuttingDock.labelingSettings.specification': {
    zh: '贴标文件格式',
    en: 'Label File Format',
    id: 'Format File Label',
    kz: 'Этикетка файл форматы',
    th: 'รูปแบบไฟล์ป้ายกำกับ',
    ug: 'بەلگە قويۇش ھۆججەت فورماتى',
    vi: 'Định dạng tệp ghi nhãn',
    zh_tc: '貼標文件格式',
    ru: 'Формат файла',
    ko: '맵 파일 형식',
    bur: 'အညွှန်းဖိုင်ဖော်မတ်',
    ben: 'লেবেল ফাইল ফরম্যাট',
    tr: 'Etiket dosya biçimi',
    km: 'ទ្រង់ទ្រាយឯកសារស្លាក',
    es: 'Formato de archivo de etiquetado',
    ar: 'تنسيق ملف وضع العلامات',
  },
  'cuttingDock.labelingSettings.codeFrontGenerate': {
    zh: '自动上料代码在贴标代码前面生成',
    en: 'Automatically Generate Feeding Code Before Labeling Code',
    id: 'Kode pemuatan otomatis dihasilkan sebelum kode pelabelan',
    kz: 'Автоматтык этiketка коддор этикетка кодуңдун алдында түзүлөт',
    th: 'รหัสการโหลดอัตโนมัติถูกสร้างขึ้นก่อนรหัสการติดฉลาก',
    ug: 'ئاپتوماتىك ماتېرىيال كودى بەلگە قويۇش كودىدىن بۇرۇن ھاسىل قىلىنىدۇ',
    vi: 'Tự động tạo mã nạp liệu trước mã ghi nhãn',
    zh_tc: '自動上料代碼在貼標代碼前面生成',
    ru: 'Автоматически загрузить код перед кодом метки',
    ko: '자동 소스 코드가 스티커 코드 앞에 생성됨',
    bur: 'အညွှန်းကုဒ်မတိုင်မီအလိုအလျောက်အစာထည့်ကုဒ်ထုတ်ပါ',
    ben: 'লেবেলিং কোডের আগে স্বয়ংক্রিয়ভাবে ফিডিং কোড তৈরি করুন',
    tr: 'Etiket kodundan önce besleme kodunu otomatik oluştur',
    km: 'បង្កើតកូដបំពេញស្វ័យប្រវត្តិមុនកូដស្លាក',
    es: 'El código de carga automática se genera antes que el código de etiquetado',
    ar: 'يتم إنشاء رمز التحميل التلقائي قبل رمز وضع العلامات',
  },
  'cuttingDock.labelingSettings.templateOffline': {
    zh: '所用模板已下线！',
    en: 'The Template Used Is Offline!',
    id: 'Template yang digunakan telah offline!',
    kz: 'Колдонулган шаблон өчірди!',
    th: 'เทมเพลตที่ใช้ออฟไลน์!',
    ug: 'ئىشلىتىلگەن قېلىپ ئۈزۈلگەن!',
    vi: 'Bản mẫu đang sử dụng đã ngừng hoạt động!',
    zh_tc: '所用模板已下線！',
    ru: 'Использовавшийся шаблон вышел из строя!',
    ko: '사용된 템플릿이 오프라인 상태입니다!',
    bur: 'အသုံးပြုထားသောတမ်းပလိတ်အော့ဖ်လိုင်းဖြစ်နေသည်။',
    ben: 'ব্যবহৃত টেমপ্লেট অফলাইন!',
    tr: 'Kullanılan şablon çevrimdışı!',
    km: 'គំរូដែលប្រើមិនមានលើបណ្តាញ!',
    es: '¡La plantilla utilizada está fuera de línea!',
    ar: 'القالب المستخدم غير متصل!',
  },
  'cuttingDock.labelingSettings.templateNotSupport': {
    zh: '该模板不支持，请重新选择！',
    en: 'This template is not supported, please select again!',
    id: 'Template ini tidak didukung, silakan pilih ulang!',
    kz: 'Бұл үлгі қолдау көрсетілмейді, қайта таңдаңыз!',
    th: 'เทมเพลตนี้ไม่รองรับ กรุณาเลือกใหม่!',
    ug: 'بۇ قېلىپ قوللىمايدۇ، قايتا تاللاڭ!',
    vi: 'Mẫu này không được hỗ trợ, vui lòng chọn lại!',
    zh_tc: '該模板不支持，請重新選擇！',
    ru: 'Этот шаблон не поддерживается, выберите другой!',
    ko: '이 템플릿은 지원되지 않습니다. 다시 선택해 주세요!',
    bur: 'ဤတမ်းပလိတ်ကို မပံ့ပိုးပါ၊ ပြန်ရွေးပါ!',
    ben: 'এই টেমপ্লেট সমর্থিত নয়, অনুগ্রহ করে আবার নির্বাচন করুন!',
    tr: 'Bu şablon desteklenmiyor, lütfen yeniden seçin!',
    km: 'គំរូនេះមិនគាំទ្រទេ សូមជ្រើសឡើងវិញ!',
    es: 'Esta plantilla no es compatible, ¡seleccione de nuevo!',
    ar: 'هذا القالب غير مدعوم، يرجى إعادة الاختيار!',
  },
  'cuttingDock.labelingSettings.rollLabelling': {
    zh: '翻面贴标设置',
    en: 'Flip Labeling Settings',
    id: 'Pengaturan pelabelan flip',
    kz: 'Башка бетке этикетка орнотуу',
    th: 'การตั้งค่าการติดฉลากพลิก',
    ug: 'ئۆرۈلۈش بەلگە قويۇش تەڭشىكى',
    vi: 'Cài đặt ghi nhãn mặt sau',
    zh_tc: '翻面貼標設置',
    ru: 'Параметры наклейки',
    ko: '뒤집기 스티커 설정',
    bur: 'ပြန်လှန်အညွှန်းသတ်မှတ်ချက်များ',
    ben: 'ফ্লিপ লেবেলিং সেটিংস',
    tr: 'Çevirmeli etiketleme ayarları',
    km: 'ការកំណត់ស្លាកបត់',
    es: 'Configuración de giro de etiquetado',
    ar: 'إعداد وضع الملصقات على الوجه',
  },
  'cuttingDock.labelingSettings.flipSetting.title': {
    zh: '翻面设置',
    en: 'Flip Settings',
    id: 'Pengaturan flip',
    kz: 'Башка бетке орнотуу',
    th: 'การตั้งค่าพลิก',
    ug: 'ئۆرۈلۈش تەڭشىكى',
    vi: 'Cài đặt mặt sau',
    zh_tc: '翻面設置',
    ru: 'Параметры поворота',
    ko: '뒤집기 설정',
    bur: 'ပြန်လှန်သတ်မှတ်ချက်များ',
    ben: 'ফ্লিপ সেটিংস',
    tr: 'Çevirme ayarları',
    km: 'ការកំណត់បត់',
    es: 'Configuración de giro',
    ar: 'إعداد الدوران',
  },
  'cuttingDock.labelingSettings.flipSetting.engravingFlipProcess': {
    zh: '雕刻机翻面加工贴标模式',
    en: 'Enable Engraving Machine Flip Processing Labeling Mode',
    id: 'Aktifkan mode pelabelan pemrosesan flip mesin ukiran',
    kz: 'Оюш машинасы этикетка орнотуу режимине өңдеуді қосуңыз',
    th: 'เปิดใช้งานโหมดการติดฉลากการประมวลผลแบบพลิกเครื่องแกะสลัก',
    ug: 'ئۆيۈچۈ ئۆرۈلۈش ئىشلەش بەلگە قويۇش ئۇسۇلى',
    vi: 'Bật chế độ ghi nhãn mặt sau cho máy khắc',
    zh_tc: '雕刻機翻面加工貼標模式',
    ru: 'Режим наклейки гравировальной машины',
    ko: '조각기 뒤집기 가공 스티커 모드',
    bur: 'ထွင်းထုစက်ပြန်လှန်ပြုပြင်အညွှန်းမုဒ်ဖွင့်ပါ',
    ben: 'খোদাই মেশিন ফ্লিপ প্রক্রিয়াকরণ লেবেলিং মোড সক্ষম করুন',
    tr: 'Oyma makinesi çevirmeli işleme etiket modunu etkinleştir',
    km: 'បើកម៉ូដស្លាកដំណើរការបត់លើម៉ាស៊ីនចុកចាក់',
    es: 'Modo de giro de etiquetado de la máquina de grabado',
    ar: 'آلة النقش تقلب وضع وضع العلامات',
  },
  'cuttingDock.labelingSettings.flipSetting.flipTip': {
    zh: '雕刻机需要翻面加工时启用此功能',
    en: 'Enable this function when the engraving machine needs to flip for processing',
    id: 'Aktifkan fungsi ini ketika mesin ukiran perlu dibalik.',
    kz: 'Оюш машинада башка бетке орнотуу керек болса, осы функцияны қосуңыз',
    th: 'เปิดใช้งานฟังก์ชั่นนี้เมื่อต้องเปิดเครื่องแกะสลัก',
    ug: 'ئۆيۈچۈ ئۆرۈلۈپ ئىشلەش زۆرۈر بولغاندا بۇ فۇنكسىيەنى قوزغىتىڭ',
    vi: 'Bật chức năng này khi máy khắc cần gia công mặt sau',
    zh_tc: '雕刻機需要翻面加工時啟用此功能',
    ru: 'Включите эту функцию, когда гравировальный станок должен быть перевернут.',
    ko: '조각기에서 뒤집기 가공이 필요할 때 이 기능을 사용합니다',
    bur: 'ထွင်းထုစက်ပြန်လှန်ပြုပြင်လိုသည့်အခါဤလုပ်ဆောင်ချက်ဖွင့်ပါ',
    ben: 'খোদাই মেশিনের প্রক্রিয়াকরণের জন্য ফ্লিপ প্রয়োজন হলে এই ফাংশন সক্ষম করুন',
    tr: 'Oyma makinesinin işlem için çevrilmesi gerektiğinde bu işlevi etkinleştirin',
    km: 'បើកមុខងារនេះនៅពេលម៉ាស៊ីនចុកចាក់ត្រូវការបត់សម្រាប់ដំណើរការ',
    es: 'Habilite esta función cuando la máquina de grabado necesite girar',
    ar: 'تمكين هذه الوظيفة عندما تحتاج آلة النقش إلى الدوران',
  },
  'cuttingDock.labelingSettings.rotateSetting.title': {
    zh: '标签旋转设置',
    en: 'Label Rotation Settings',
    id: 'Pengaturan Rotasi Tag',
    kz: 'Этикеткаларды айналуу',
    th: 'การตั้งค่าการหมุนแท็ก',
    ug: 'بەلگە ئۆرۈلۈش تەڭشىكى',
    vi: 'Cài đặt xoay nhãn',
    zh_tc: '標籤旋轉設置',
    ru: 'Параметры вращения вкладок',
    ko: '레이블 회전 설정',
    bur: 'အညွှန်းလည်ပတ်သတ်မှတ်ချက်များ',
    ben: 'লেবেল রোটেশন সেটিংস',
    tr: 'Etiket döndürme ayarları',
    km: 'ការកំណត់បង្វិលស្លាក',
    es: 'Configuración de rotación de etiquetas',
    ar: 'إعداد دوران الملصق',
  },
  'cuttingDock.labelingSettings.rotateSetting.rotateTip': {
    zh: '根据需求开启旋转条件，如果同时开启，优先生效选择设定值',
    en: 'When the board size is smaller than the set value for the width or height, the label will rotate 90° clockwise',
    id: 'Nyalakan kondisi rotasi sesuai dengan persyaratan. Jika dihidupkan pada saat yang sama, pilih nilai yang ditetapkan untuk pilihan terbaik',
    kz: 'Таختанын көлөмү кескен же тик кескен өлчөмден кичине болсо, этикетка 90° маяттынай дайыма айналат',
    th: 'เปิดเงื่อนไขการหมุนตามข้อกำหนด หากเปิดใช้งานในเวลาเดียวกันให้เลือกค่าที่ตั้งไว้สำหรับตัวเลือกที่ดีที่สุด',
    ug: 'ئېھتىياجغا ئاساسەن ئۆرۈلۈش شەرتىنى قوزغىتىڭ، ئەگەر بىر ۋاقىتتا قوزغىتىلسا، تاللانغان قىممەت ئالدىنقى قاتاردا ئىشلىنىدۇ',
    vi: '(Bật điều kiện xoay theo nhu cầu, nếu đồng thời bật, thì giá trị đã chọn sẽ có hiệu lực ưu tiên)',
    zh_tc: '根據需求開啟旋轉條件，如果同時開啟，優先生效選擇設定值',
    ru: 'Включите условия вращения по требованию, если открывается одновременно, приоритет для вступления в силу выберите заданное значение',
    ko: '필요에 따라 회전 조건을 켜고 동시에 켜면 우선 적용 설정값 선택',
    bur: 'လိုအပ်ချက်အရလည်ပတ်အခြေအနေဖွင့်ပါ၊ တစ်ချိန်တည်းဖွင့်ပါကရွေးထားသောတန်ဖိုးဦးစားပေးအကျိုးသက်ရောက်သည်',
    ben: 'চাহিদা অনুযায়ী রোটেশন শর্ত চালু করুন; একসাথে চালু করলে নির্বাচিত সেট মান অগ্রাধিকার পায়',
    tr: 'Levha genişliği veya yüksekliği ayarlanan değerden küçük olduğunda etiket saat yönünde 90° döner',
    km: 'នៅពេលទំហំផ្ទាំងតូចជាងតម្លៃដែលបានកំណត់សម្រាប់ទទឹងឬកម្ពស់ ស្លាកនឹងបង្វិល ៩០°តាមទិសនាឡិកា',
    es: 'Active la condición de rotación según las necesidades, si se enciende al mismo tiempo, tendrá prioridad para seleccionar el valor de configuración',
    ar: 'قم بتشغيل حالة الدوران وفقًا للاحتياجات، إذا تم تشغيله في نفس الوقت، فستأخذ الأولوية لتحديد قيمة الإعداد',
  },
  'cuttingDock.labelingSettings.rotateSetting.horizontal': {
    zh: '板材横边',
    en: 'Board Width',
    id: 'Tepi horizontal pelat ≤',
    kz: 'Таختанын кескен көлөмү',
    th: 'ขอบแนวนอนของแผ่น≤',
    ug: 'تاختا كەڭ چېگرىسى',
    vi: 'Bên ngang của ván',
    zh_tc: '板材橫邊',
    ru: 'Плита поперечная',
    ko: '판재 가로변',
    bur: 'ပြားအလျားဘက်',
    ben: 'বোর্ডের প্রস্থ',
    tr: 'Levha genişliği',
    km: 'គែមផ្តេកនៃផ្ទាំង',
    es: 'Borde horizontal de la placa',
    ar: 'الحافة الأفقية للوحة',
  },
  'cuttingDock.labelingSettings.rotateSetting.vertical': {
    zh: '板材竖边',
    en: 'Board Height',
    id: 'Tepi vertikal pelat ≤',
    kz: 'Тахтанын тик көлөмү',
    th: 'ขอบแนวตั้งของแผ่น≤',
    ug: 'تاختا ئۇزۇن چېگرىسى',
    vi: 'Bên dọc của ván',
    zh_tc: '板材豎邊',
    ru: 'Вертикальная сторона листов',
    ko: '판재 세로변',
    bur: 'ပြားဒေါင်လိုက်ဘက်',
    ben: 'বোর্ডের উচ্চতা',
    tr: 'Levha yüksekliği',
    km: 'គែមបញ្ឈរនៃផ្ទាំង',
    es: 'Borde vertical de la placa',
    ar: 'الحافة العمودية اللوحة',
  },
  'cuttingDock.labelingSettings.rotateSetting.either': {
    zh: '板材横或竖边',
    en: 'Board Width OR Height',
    id: 'Horizontal Tepi vertikal ≤',
    kz: 'Тахтанын кескен же тик көлөмү',
    th: 'แนวนอน ขอบแนวตั้ง≤',
    ug: 'تاختا كەڭ ياكى ئۇزۇن چېگرىسى',
    vi: 'Bên ngang | Bên dọc của ván',
    zh_tc: '板材橫或豎邊',
    ru: 'Плиты поперечные или вертикальные',
    ko: '판재 가로 혹은 세로 변',
    bur: 'ပြားအလျားသို့မဟုတ်ဒေါင်လိုက်ဘက်',
    ben: 'বোর্ড প্রস্থ অথবা উচ্চতা',
    tr: 'Levha genişliği VEYA yüksekliği',
    km: 'ទទឹងឬកម្ពស់នៃផ្ទាំង',
    es: 'Borde horizontal o vertical de la placa',
    ar: 'الحافة الأفقية أو الرأسية للوحة',
  },
  'cuttingDock.labelingSettings.countertopSetting.title': {
    zh: '台面设置',
    en: 'Workbench Settings',
    id: 'Pengaturan Desktop',
    kz: 'Таختанын орнотуу',
    th: 'การตั้งค่าเดสก์ท็อป',
    ug: 'يۈز تەڭشىكى',
    vi: 'Cài đặt bàn làm việc',
    zh_tc: '台面設置',
    ru: 'Настройка рабочего стола',
    ko: '테이블 설정',
    bur: 'အလုပ်စားပွဲသတ်မှတ်ချက်များ',
    ben: 'ওয়ার্কবেঞ্চ সেটিংস',
    tr: 'Tezgah ayarları',
    km: 'ការកំណត់តុការងារ',
    es: 'Configuración de la mesa',
    ar: 'إعداد الجدول',
  },
  'cuttingDock.labelingSettings.countertopSetting.startPoint': {
    zh: '工位起始点',
    en: 'Workstation Starting Point:',
    id: 'Titik awal stasiun',
    kz: 'Иштетүү орду:',
    th: 'จุดเริ่มต้นของสถานี',
    ug: 'پوچتا باشلانغۇچ نۇقتىسى',
    vi: 'Điểm khởi đầu vị trí:',
    zh_tc: '工位起始點',
    ru: 'начальная точка станции',
    ko: '작업 위치 시작점',
    bur: 'အလုပ်နေရာစတင်အမှတ်:',
    ben: 'ওয়ার্কস্টেশন স্টার্টিং পয়েন্ট:',
    tr: 'İstasyon başlangıç noktası:',
    km: 'ចំណុចចាប់ផ្តើមស្ថានីយ៖',
    es: 'Punto de inicio de la estación de trabajo',
    ar: 'نقطة بداية محطة العمل',
  },
  'cuttingDock.labelingSettings.countertopSetting.upLeft': {
    zh: '左上角',
    en: 'Upper Left',
    id: 'Sudut kiri atas',
    kz: 'Жогору сол',
    th: 'มุมซ้ายบน',
    ug: 'سول ئۈستى بۇلۇڭ',
    vi: 'Trên góc trái',
    zh_tc: '左上角',
    ru: 'левый верхний угол',
    ko: '왼쪽 위',
    bur: 'ဘယ်အပေါ်ထောင့်',
    ben: 'বাম উপরে',
    tr: 'Sol üst',
    km: 'ខាងលើឆ្វេង',
    es: 'Esquina superior izquierda',
    ar: 'الزاوية اليسرى العليا',
  },
  'cuttingDock.labelingSettings.countertopSetting.upRight': {
    zh: '右上角',
    en: 'Upper Right',
    id: 'Sudut kanan atas',
    kz: 'Жогору оң',
    th: 'มุมขวาบน',
    ug: 'ئوڭ ئۈستى بۇلۇڭ',
    vi: 'Trên góc phải',
    zh_tc: '右上角',
    ru: 'Верхний правый угол',
    ko: '오른쪽 위',
    bur: 'ညာအပေါ်ထောင့်',
    ben: 'ডান উপরে',
    tr: 'Sağ üst',
    km: 'ខាងលើស្តាំ',
    es: 'Esquina superior derecha',
    ar: 'الزاوية اليمنى العليا',
  },
  'cuttingDock.labelingSettings.countertopSetting.downLeft': {
    zh: '左下角',
    en: 'Lower Left',
    id: 'Sudut kiri bawah',
    kz: 'Төмен сол',
    th: 'มุมซ้ายล่าง',
    ug: 'سول ئاستى بۇلۇڭ',
    vi: 'Dưới góc trái',
    zh_tc: '左下角',
    ru: 'Нижний левый угол',
    ko: '왼쪽 아래',
    bur: 'ဘယ်အောက်ထောင့်',
    ben: 'বাম নিচে',
    tr: 'Sol alt',
    km: 'ខាងក្រោមឆ្វេង',
    es: 'Esquina inferior izquierda',
    ar: 'الزاوية اليسرى السفلية',
  },
  'cuttingDock.labelingSettings.countertopSetting.downRight': {
    zh: '右下角',
    en: 'Lower Right',
    id: 'Sudut kanan bawah',
    kz: 'Төмен оң',
    th: 'มุมขวาล่าง',
    ug: 'ئوڭ ئاستى بۇلۇڭ',
    vi: 'Dưới góc phải',
    zh_tc: '右下角',
    ru: 'Нижний правый угол',
    ko: '오른쪽 아래',
    bur: 'ညာအောက်ထောင့်',
    ben: 'ডান নিচে',
    tr: 'Sağ alt',
    km: 'ខាងក្រោមស្តាំ',
    es: 'Esquina inferior derecha',
    ar: 'الزاوية اليمنى السفلى',
  },
  'cuttingDock.labelingSettings.countertopSetting.baseExchange': {
    zh: '坐标基准对调',
    en: 'Coordinate Base Exchange:',
    id: 'Koordinat Penyelarasan Referensi',
    kz: 'Координат базасын алмаштуу:',
    th: 'ประสานงานการจัดตำแหน่งอ้างอิง',
    ug: 'كوئوردىنات ئاساسىنى ئالماشتۇرۇش',
    vi: 'Điểm chuẩn trao đổi tọa độ:',
    zh_tc: '坐標基準對調',
    ru: 'Коррекция координат',
    ko: '좌표 데이텀 조정',
    bur: 'ကိုဩဒိနိတ်အခြေအပြန်အလှန်:',
    ben: 'কোঅর্ডিনেট বেস এক্সচেঞ্জ:',
    tr: 'Koordinat tabanı değişimi:',
    km: 'ការប្តូរមូលដ្ឋានកូអរដោនេ៖',
    es: 'Intercambio de datos de coordenadas',
    ar: 'تبديل مسند الإسناد',
  },
  'cuttingDock.labelingSettings.countertopSetting.exchangeX': {
    zh: 'x轴对调',
    en: 'X-axis Exchange',
    id: 'Penyesuaian sumbu x',
    kz: 'X базасын алмаштуу',
    th: 'การปรับแกน x',
    ug: 'x ئوكۇلنى ئالماشتۇرۇش',
    vi: 'Trao đổi trục x',
    zh_tc: 'x軸對調',
    ru: 'Настройка оси X',
    ko: 'x축 조정',
    bur: 'x ဝင်ရိုးအပြန်အလှန်',
    ben: 'X-অক্ষ এক্সচেঞ্জ',
    tr: 'X ekseni değişimi',
    km: 'ប្តូរអ័ក្ស X',
    es: 'Intercambio del eje x',
    ar: 'تبديل المحور السيني',
  },
  'cuttingDock.labelingSettings.countertopSetting.exchangeY': {
    zh: 'y轴对调',
    en: 'Y-axis Exchange',
    id: 'Sakelar sumbu y',
    kz: 'Y базасын алмаштуу',
    th: 'สวิตช์แกน y',
    ug: 'y ئوكۇلنى ئالماشتۇرۇش',
    vi: 'Trao đổi trục y',
    zh_tc: 'y軸對調',
    ru: 'Коррекция оси y',
    ko: 'Y축 조정',
    bur: 'y ဝင်ရိုးအပြန်အလှန်',
    ben: 'Y-অক্ষ এক্সচেঞ্জ',
    tr: 'Y ekseni değişimi',
    km: 'ប្តូរអ័ក្ស Y',
    es: 'Intercambio del eje Y',
    ar: 'تبديل المحور Y',
  },
  'cuttingDock.labelingSettings.offset': {
    zh: '贴标坐标偏移',
    en: 'Label Coordinate Offset',
    id: 'Label Offset Koordinat',
    kz: 'Этикетка координаттардын оффсет',
    th: 'ออฟเซ็ตพิกัดฉลาก',
    ug: 'بەلگە قويۇش كوئوردىنات ئۆزگەرتىش',
    vi: 'Điểm lệch tiêu đề nhãn',
    zh_tc: '貼標坐標偏移',
    ru: 'Смещение координат',
    ko: '부착 좌표 오프셋',
    bur: 'အညွှန်းကိုဩဒိနိတ်ရွေ့ခြင်း',
    ben: 'লেবেল কোঅর্ডিনেট অফসেট',
    tr: 'Etiket koordinat ofseti',
    km: 'ការផ្លាស់ទីកូអរដោនេស្លាក',
    es: 'Desplazamiento de coordenadas de etiquetado',
    ar: 'إزاحة إحداثيات الملصقات',
  },
  'cuttingDock.labelingSettings.offsetTip': {
    zh: '一般贴标坐标是在小板中心，部分设备需要调整',
    en: 'Generally, the labeling coordinate is at the center of the small board, but some devices require adjustment',
    id: 'Secara umum, koordinat label berada di tengah papan kecil, dan beberapa peralatan perlu disesuaikan.',
    kz: 'Адатта этикетка координаттары кичинекей тактанын борборунда, ал эми кээ бир шаймандарда корректирлөө талап кылынат',
    th: 'โดยทั่วไปพิกัดของฉลากอยู่ในใจกลางของบอร์ดขนาดเล็กและต้องปรับอุปกรณ์บางอย่าง',
    ug: 'ئادەتتە بەلگە قويۇش كوئوردىناتى كىچىك تاختا مەركىزىدە، بەزى قوراللار تەڭشەشكە موھتاج',
    vi: 'Thông thường điểm nhãn nằm ở trung tâm của tấm nhỏ, một số thiết bị cần điều chỉnh',
    zh_tc: '一般貼標坐標是在小板中心，部分設備需要調整',
    ru: 'Общие координаты наклейки находятся в центре доски, некоторые устройства должны быть отрегулированы',
    ko: '일반 부착 좌표는 소판 중심에 있으며 일부 장치는 조정이 필요합니다.',
    bur: 'အများအားဖြင့်အညွှန်းကိုဩဒိနိတ်သည်ပြားငယ်အလယ်တွင်ရှိပြီးကိရိယာအချို့ပြင်ဆင်ချို့တဲ့သည်',
    ben: 'সাধারণত লেবেলিং কোঅর্ডিনেট ছোট বোর্ডের কেন্দ্রে থাকে, কিছু ডিভাইসে সামঞ্জস্য প্রয়োজন',
    tr: 'Genellikle etiket koordinatı küçük levhın merkezindedir; bazı cihazlarda ayar gerekir',
    km: 'ជាទូទៅកូអរដោនេស្លាកនៅកណ្តាលផ្ទាំងតូច ឧបករណ៍មួយចំនួនត្រូវការកែតម្រូវ',
    es: 'Generalmente, las coordenadas de etiquetado están en el centro del tablero pequeño y es necesario ajustar algunos equipos',
    ar: 'بشكل عام، تكون إحداثيات الملصقات في مركز اللوحة الصغيرة، وتحتاج بعض المعدات إلى تعديل',
  },
  'cuttingDock.labelingSettings.label_rotate_offset': {
    zh: '标签旋转后坐标偏移',
    en: 'Label Offset After Rotation',
    id: 'Koordinat offset setelah rotasi label',
    kz: 'Белгілердің өтіріктіктері өзгерген соң',
    th: 'ประสานงานออฟเซ็ตหลังจากการหมุนฉลาก',
    ug: 'بەلگە ئۆرۈلگەندىن كېيىن كوئوردىنات ئۆزگەرتىش',
    vi: 'Sai số tọa độ sau khi xoay nhãn',
    zh_tc: '標籤旋轉後坐標偏移',
    ru: 'Смещение координат после вращения вкладки',
    ko: '태그 회전 후 좌표 오프셋',
    bur: 'လည်ပတ်ပြီးနောက်အညွှန်းရွေ့ခြင်း',
    ben: 'রোটেশনের পর লেবেল অফসেট',
    tr: 'Döndürmeden sonra etiket koordinat ofseti',
    km: 'ការផ្លាស់ទីកូអរដោនេស្លាកបន្ទាប់ពីបង្វិល',
    es: 'Desplazamiento de coordenadas después de la rotación de la etiqueta',
    ar: 'إزاحة الإحداثيات بعد تدوير الملصقات',
  },
  'cuttingDock.labelingSettings.label_rotate_offset_tip': {
    zh: '针对标签旋转前后偏移位置相差较大时，需要调整',
    en: 'Adjust when the offset position differs significantly before and after label rotation',
    id: 'Ketika perbedaan posisi offset antara label sebelum dan sesudah rotasi besar, itu perlu disesuaikan.',
    kz: 'Белгілерді өтіріктік позициясы өзгерген соң көп айрылыс болса, өзгерту керек',
    th: 'เมื่อความแตกต่างของตำแหน่งออฟเซ็ตระหว่างฉลากก่อนและหลังการหมุนมีขนาดใหญ่จะต้องมีการปรับ',
    ug: 'بەلگە ئۆرۈلۈشتىن بۇرۇن ۋە كېيىن ئورنى ئوخشاش بولمىغاندا تەڭشەش كېرەك',
    vi: 'Điều chỉnh khi vị trí lệch khác biệt đáng kể trước và sau khi quay nhãn',
    zh_tc: '針對標籤旋轉前後偏移位置相差較大時，需要調整',
    ru: 'При большой разнице в положении смещения до и после вращения вкладки необходимо настроить',
    ko: '레이블 회전의 앞뒤 오프셋 위치 차이가 클 경우 조정 필요',
    bur: 'အညွှန်းလည်ပတ်မတိုင်မီနှင့်ပြီးနောက်ရွေ့ခြင်းတည်နေရာကွာခြားမှုကြီးသည့်အခါပြင်ဆင်ပါ',
    ben: 'লেবেল রোটেশনের আগে ও পরে অফসেট পজিশন যথেষ্ট ভিন্ন হলে অ্যাডজাস্ট করুন',
    tr: 'Döndürme öncesi ve sonrası ofset konumu belirgin şekilde farklıysa ayarlayın',
    km: 'កែតម្រូវនៅពេលទីតាំងផ្លាស់ទីមុននិងបន្ទាប់ពីបង្វិលខុសគ្នាច្រើន',
    es: 'Cuando la posición de desplazamiento antes y después de la rotación de la etiqueta es muy diferente, se requiere ajuste',
    ar: 'عندما يكون موضع الإزاحة قبل تدوير الملصقات وبعده مختلفًا بشكل كبير، يلزم التعديل',
  },
  'cuttingDock.labelingSettings.label_rotate_offset_err_tip': {
    zh: '开启标签旋转后坐标偏移后，X和Y轴坐标偏移量必填',
    en: 'After the label rotation coordinate offset is turned on, the X and Y axis coordinate offsets are required',
    id: 'Setelah offset koordinat dihidupkan setelah label diputar, offset koordinat sumbu X dan Y diperlukan.',
    kz: 'Жапсырманы айналдырғаннан кейін координаталар ығысуын қосқаннан кейін, X және Y осінің координаталық ауытқулары қажет.',
    th: 'หลังจากเปิดออฟเซ็ตพิกัดหลังจากหมุนฉลากแล้วจะต้องมีการออฟเซ็ตพิกัดของแกน x และ y',
    ug: 'بەلگە ئۆرۈلگەندىن كېيىن كوئوردىنات ئۆزگەرتىشنى قوزغىتىش بىلەن، X ۋە Y ئوكۇل كوئوردىنات ئۆزگەرتىش مىقدارى تولدۇرۇش كېرەك',
    vi: 'Sau khi bật bù tọa độ sau khi xoay nhãn, cần phải có bù tọa độ trục X và Y',
    zh_tc: '開啟標籤旋轉後坐標偏移後，X和Y軸坐標偏移量必填',
    ru: 'Открывает вкладку после того, как координаты смещаются, координаты осей X и Y должны быть заполнены',
    ko: '레이블 회전 후 좌표 오프셋을 켜면 X 및 Y축 좌표 오프셋이 필요합니다.',
    bur: 'အညွှန်းလည်ပတ်ကိုဩဒိနိတ်ရွေ့ခြင်းဖွင့်ပြီးနောက် X နှင့် Y ဝင်ရိုးကိုဩဒိနိတ်ရွေ့ခြင်းလိုအပ်သည်',
    ben: 'লেবেল রোটেশন কোঅর্ডিনেট অফসেট চালু করার পর X এবং Y অক্ষ কোঅর্ডিনেট অফসেট আবশ্যক',
    tr: 'Etiket döndürme koordinat ofseti açıldığında X ve Y ekseni koordinat ofsetleri zorunludur',
    km: 'បន្ទាប់ពីបើកការផ្លាស់ទីកូអរដោនេបន្ទាប់ពីបង្វិលស្លាក ត្រូវបំពេញការផ្លាស់ទីអ័ក្ស X និង Y',
    es: 'Después de activar el desplazamiento de coordenadas después de la rotación de la etiqueta, se requieren los desplazamientos de coordenadas de los ejes X y Y',
    ar: 'بعد تشغيل إزاحة الإحداثيات بعد تدوير الملصقات، تكون إزاحات إحداثيات المحور X و Y مطلوبة',
  },
  'cuttingDock.labelingSettings.imgSetting.title': {
    zh: '贴标图片设置',
    en: 'Label Image Settings',
    id: 'Pengaturan gambar pelabelan',
    kz: 'Байнама суреттерін орнату',
    th: 'การตั้งค่ารูปภาพการติดฉลาก',
    ug: 'بەلگە قويۇش رەسىم تەڭشىكى',
    vi: 'Cài đặt hình ảnh nhãn',
    zh_tc: '貼標圖片設置',
    ru: 'Параметры изображения',
    ko: '맵 이미지 설정',
    bur: 'အညွှန်းပုံသတ်မှတ်ချက်များ',
    ben: 'লেবেল ইমেজ সেটিংস',
    tr: 'Etiket görseli ayarları',
    km: 'ការកំណត់រូបភាពស្លាក',
    es: 'Configuración de imagen de etiquetado',
    ar: 'إعدادات صورة الملصقات',
  },
  'cuttingDock.labelingSettings.imgSetting.suffix': {
    zh: '贴标图片后缀：',
    en: 'Label Image Suffix:',
    id: 'Sufiks gambar label:',
    kz: 'Байнама суреттерінің суффикси:',
    th: 'ภาพต่อท้ายภาพฉลาก:',
    ug: 'بەلگە قويۇش رەسىم كېڭەيتىلمىسى:',
    vi: 'Hậu tố hình ảnh nhãn:',
    zh_tc: '貼標圖片後綴：',
    ru: 'Суффикс изображения:',
    ko: '스티커 그림 접미사:',
    bur: 'အညွှန်းပုံနောက်ဆက်တွဲ:',
    ben: 'লেবেল ইমেজ সাফিক্স:',
    tr: 'Etiket görseli son eki:',
    km: 'បច្ច័យរូបភាពស្លាក៖',
    es: 'Sufijo de imagen de etiquetado:',
    ar: 'لاحقة صورة التسمية:',
  },
  'cuttingDock.labelingSettings.imgSetting.code': {
    zh: '图片编码方式：',
    en: 'Image Coding Method:',
    id: 'Metode pengkodean gambar:',
    kz: 'Сурет кодирулеу әдісі:',
    th: 'วิธีการเข้ารหัสภาพ:',
    ug: 'رەسىم كودلاش ئۇسۇلى:',
    vi: 'Định dạng mã hóa hình ảnh:',
    zh_tc: '圖片編碼方式：',
    ru: 'Режим кодирования изображений:',
    ko: '그림 인코딩 방법:',
    bur: 'ပုံကုဒ်နည်းလမ်း:',
    ben: 'ইমেজ কোডিং পদ্ধতি:',
    tr: 'Görüntü kodlama yöntemi:',
    km: 'វិធីសាស្ត្រកូដរូបភាព៖',
    es: 'Método de codificación de imagen:',
    ar: 'طريقة تشفير الصورة:',
  },
  'cuttingDock.labelingSettings.imgSetting.codeTip': {
    zh: 'png、jpeg会同步修改排版图编码格式，且内嵌云排版暂不支持此功能',
    en: 'Png, jpeg will synchronously modify the coding format of the layout image, and the embedded cloud layout does not support this feature',
    id: 'Catatan: PNG dan JPEG akan secara bersamaan memodifikasi format pengkodean diagram tata letak, dan tata letak awan yang tertanam belum mendukung fungsi ini.',
    kz: 'Png, jpeg пішімдеу суреттерінің кодирулеуін сынықтай өзгертеді, бірақ кірікті бұлт пішімдеуі осы функсияны қолданбайды',
    th: 'หมายเหตุ: PNG และ JPEG จะปรับเปลี่ยนรูปแบบการเข้ารหัสของแผนภาพเค้าโครงพร้อมกันและรูปแบบเมฆแบบฝังยังไม่รองรับฟังก์ชั่นนี้',
    ug: 'png، jpeg تەڭشەلگەن رەسىم كودلاش فورماتىنى ئۆزگەرتىدۇ، ھەمدە ئىچكى بۇيرۇق بىلەن تەڭشەلگەن تەڭشەكلەر بۇ فۇنكسىيەنى ئىشلەتمەيدۇ',
    vi: 'Png, jpeg sẽ đồng bộ sửa đổi định dạng mã hóa của bố cục hình ảnh, và tính năng này chưa được hỗ trợ trong sắp xếp đám mây nhúng',
    zh_tc: 'png、jpeg會同步修改排版圖編碼格式，且內嵌雲排版暫不支持此功能',
    ru: 'PNG и JPEG синхронизируют изменения в форматах кодирования типографики, а встроенная облачная типография не поддерживает эту функцию.',
    ko: 'png, jpeg는 조판도 인코딩 형식을 동시에 수정하며, 내장 클라우드 조판은 당분간 이 기능을 지원하지 않습니다',
    bur: 'png၊ jpeg သည်တပ်ဆင်ပုံပုံကုဒ်ဖော်မတ်ကိုတစ်ပြိုင်နက်ပြင်ဆင်မည်၊ ထည့်သွင်းမိုးတိမ်တပ်ဆင်ခြင်းသည်ဤအင်္ဂါရပ်မပံ့ပိုးပါ',
    ben: 'PNG, JPEG লেআউট ইমেজের কোডিং ফরম্যাট একসাথে পরিবর্তন করবে এবং এমবেডেড ক্লাউড লেআউট এই ফিচার সাপোর্ট করে না',
    tr: 'Png ve jpeg düzen görüntüsü kodlama biçimini eşzamanlı değiştirir; gömülü bulut düzeni bu özelliği desteklemez',
    km: 'png និង jpeg កែទ្រង់ទ្រាយកូដរូបចងក្រងរួមគ្នា ការចងក្រងក្នុងពពកខ្ចប់មិនគាំទ្រមុខងារនេះទេ',
    es: 'png y jpeg modificarán el formato de codificación de imagen de composición simultáneamente, y la composición tipográfica en la nube incorporada aún no admite esta función',
    ar: 'سيعمل png و jpeg على تعديل تنسيق ترميز صورة التنضيد في وقت واحد، ولا يدعم التنضيد السحابي المضمن هذه الوظيفة بعد',
  },
  'cuttingDock.labelingSettings.imgSetting.imgRatio': {
    zh: '贴标图片分辨率:',
    en: 'Label Image Resolution:',
    id: 'Labeling Resolusi Gambar:',
    kz: 'Байнама суреттерінің өлшемдері:',
    th: 'การติดฉลากภาพความละเอียด:',
    ug: 'بەلگە قويۇش رەسىم چوڭلۇقى:',
    vi: 'Độ phân giải hình ảnh nhãn:',
    zh_tc: '貼標圖片分辨率:',
    ru: 'Разрешение пиктограммы:',
    ko: '맵 이미지 해상도:',
    bur: 'အညွှန်းပုံအဖြေရှင်းချက်:',
    ben: 'লেবেল ইমেজ রেজোলিউশন:',
    tr: 'Etiket görseli çözünürlüğü:',
    km: 'គុណភាពរូបភាពស្លាក៖',
    es: 'Resolución de imagen de etiquetado:',
    ar: 'دقة صورة التسمية:',
  },
  'cuttingDock.labelingSettings.imgSetting.slowDown': {
    zh: '会降低导出标签图片的效率',
    en: 'Will reduce the efficiency of exporting label images',
    id: 'Akan mengurangi efisiensi mengekspor gambar tag',
    kz: 'Байнама суреттерін шығару ефективділігін төмендетеді',
    th: 'จะลดประสิทธิภาพของการส่งออกภาพแท็ก',
    ug: 'بەلگە رەسىملىرىنى چىقىرىش تېزلىكىنى تۆۋەنلەتەلەيدۇ',
    vi: 'Sẽ làm giảm hiệu suất xuất hình ảnh nhãn',
    zh_tc: '會降低導出標籤圖片的效率',
    ru: 'Это снижает эффективность экспорта изображений с метками.',
    ko: '태그 그림 내보내기 효율성 저하',
    bur: 'အညွှန်းပုံများထုတ်ခြင်းထိရောက်မှုလျော့နည်းစေမည်',
    ben: 'লেবেল ইমেজ এক্সপোর্টের দক্ষতা কমিয়ে দেবে',
    tr: 'Etiket görüntülerini dışa aktarma verimini düşürür',
    km: 'បន្ថយប្រសិទ្ធភាពនាំចេញរូបភាពស្លាក',
    es: 'Reducirá la eficiencia de exportar imágenes de etiquetas',
    ar: 'ستقلل من كفاءة تصدير صور التسمية',
  },
  'cuttingDock.labelingSettings.imgSetting.color': {
    zh: '真彩',
    en: 'True Color',
    id: 'Sangat berwarna',
    kz: 'Нағыз',
    th: 'มีสีสันจริงๆ',
    ug: 'رەڭلىك',
    vi: 'Màu sắc thật',
    zh_tc: '真彩',
    ru: 'Настоящая красота',
    ko: '진채',
    bur: 'အစစ်အရောင်',
    ben: 'ট্রু কালার',
    tr: 'Gerçek renk',
    km: 'ពណ៌ពិត',
    es: 'Color verdadero',
    ar: 'اللون الحقيقي',
  },
  'cuttingDock.labelingSettings.imgSetting.bit': {
    zh: '黑白',
    en: 'Black and White',
    id: 'Hitam dan putih',
    kz: 'Қара-ақ',
    th: 'ขาวดำ',
    ug: 'قارا-ئاق',
    vi: 'Đen trắng',
    zh_tc: '黑白',
    ru: 'чёрно-белый',
    ko: '흑백',
    bur: 'အဖြူအမဲ',
    ben: 'কালো এবং সাদা',
    tr: 'Siyah beyaz',
    km: 'ខ្មៅស',
    es: 'Blanco y negro',
    ar: 'أبيض وأسود',
  },
  'cuttingDock.labelingSettings.imgSetting.resolution': {
    zh: '贴标图片分辨率',
    en: 'Label Image Resolution',
    id: 'Label resolusi gambar',
    kz: 'Байнама суреттерінің өлшемдері',
    th: 'การติดฉลากความละเอียดรูปภาพ',
    ug: 'بەلگە قويۇش رەسىم چوڭلۇقى',
    vi: 'Độ phân giải hình ảnh nhãn',
    zh_tc: '貼標圖片分辨率',
    ru: 'Разрешение пиктограммы',
    ko: '맵 이미지 해상도',
    bur: 'အညွှန်းပုံအဖြေရှင်းချက်',
    ben: 'লেবেল ইমেজ রেজোলিউশন',
    tr: 'Etiket görüntüsü çözünürlüğü',
    km: 'គុណភាពរូបភាពស្លាក',
    es: 'Resolución de imagen de etiquetado',
    ar: 'دقة صورة التسمية',
  },
  'cuttingDock.labelingSettings.imgSetting.resolutionPlaceholder': {
    zh: '分辨率',
    en: 'Resolution',
    id: 'Resolusi',
    kz: 'Өлшем',
    th: 'ปณิธาน',
    ug: 'چوڭلۇق',
    vi: 'Độ phân giải',
    zh_tc: '分辨率',
    ru: 'разрешение',
    ko: '해상도',
    bur: 'အဖြေရှင်းချက်',
    ben: 'রেজোলিউশন',
    tr: 'Çözünürlük',
    km: 'គុណភាព',
    es: 'Resolución',
    ar: 'الدقة',
  },
  'cuttingDock.labelingSettings.imgSetting.labelPool': {
    zh: '数据标签池',
    en: 'Data Label Pool',
    id: 'Kumpulan tag data',
    kz: 'Деректердің бейнамалар қоры',
    th: 'พูลแท็กข้อมูล',
    ug: 'سانلىق مەلۇمات بەلگە سۇ ئامبىرى',
    vi: 'Hồ bơi nhãn dữ liệu',
    zh_tc: '數據標籤池',
    ru: 'Пул тегов данных',
    ko: '데이터 태그 풀',
    bur: 'ဒေတာအညွှန်းကန်ရေကန်',
    ben: 'ডেটা লেবেল পুল',
    tr: 'Veri etiket havuzu',
    km: 'អាងស្លាកទិន្នន័យ',
    es: 'Grupo de etiquetas de datos',
    ar: 'تجمع علامات البيانات',
  },
  'cuttingDock.labelingSettings.imgSetting.showKey': {
    zh: '显示字段',
    en: 'Display Fields',
    id: 'Bidang Tampilan',
    kz: 'өріс көрсету',
    th: 'แสดงฟิลด์',
    ug: 'كۆرسىتىش ئورنى',
    vi: 'Hiện trường',
    zh_tc: '顯示字段',
    ru: 'Показать поле',
    ko: '디스플레이 필드',
    bur: 'ပြသသည့်အကွက်များ',
    ben: 'ডিসপ্লে ফিল্ড',
    tr: 'Alanları göster',
    km: 'បង្ហាញវាល',
    es: 'Mostrar campos',
    ar: 'إظهار الحقول',
  },
  'cuttingDock.labelingSettings.imgSetting.dragTip': {
    zh: '可拖拽标签池内标签',
    en: 'You can drag and drop labels within the label pool',
    id: 'Tag drag-drop di tag pool',
    kz: 'Бейнамалар қорінен бейнамаларды сүйреп тастауға болады',
    th: 'แท็ก Drag-Drop ในพูลแท็ก',
    ug: 'بەلگە سۇ ئامبىرىدىكى بەلگىلەرنى سۆرەپ تاشلىسىڭىز بولىدۇ',
    vi: 'Có thể kéo thả nhãn trong hồ bơi nhãn',
    zh_tc: '可拖拽標籤池內標籤',
    ru: 'Можно перетаскивать вкладки внутри пула',
    ko: '드래그 가능 태그 풀 내 태그',
    bur: 'အညွှန်းကန်ရေကန်အတွင်းအညွှန်းများဆွဲချနိုင်သည်',
    ben: 'লেবেল পুলের মধ্যে লেবেল ড্র্যাগ এবং ড্রপ করতে পারেন',
    tr: 'Etiket havuzundaki etiketleri sürükleyip bırakabilirsiniz',
    km: 'អ្នកអាចអូសទម្លាក់ស្លាកនៅក្នុងអាងស្លាក',
    es: 'Las etiquetas en el grupo de etiquetas se pueden arrastrar y soltar',
    ar: 'يمكن سحب العلامات الموجودة في تجمع العلامات وإسقاطها',
  },
  'cuttingDock.labelingSettings.imgSetting.labelImgName': {
    zh: '贴标图片名',
    en: 'Label Image Name',
    id: 'Nama gambar berlabel',
    kz: 'Байнама суреттерінің атауы',
    th: 'ชื่อรูปภาพที่มีป้ายกำกับ',
    ug: 'بەلگە قويۇش رەسىم ئىسمى',
    vi: 'Tên hình ảnh nhãn',
    zh_tc: '貼標圖片名',
    ru: 'Название изображения',
    ko: '스티커 이미지 이름',
    bur: 'အညွှန်းပုံအမည်',
    ben: 'লেবেল ইমেজ নাম',
    tr: 'Etiket görseli adı',
    km: 'ឈ្មោះរូបភាពស្លាក',
    es: 'Nombre de la imagen de etiquetado',
    ar: 'اسم صورة التسمية',
  },
  'cuttingDock.labelingSettings.imgSetting.labelImgNameErrTip': {
    zh: '标签图片名不能为空',
    en: 'The label image name cannot be empty',
    id: 'Nama gambar label tidak bisa kosong',
    kz: 'Байнама суреттерінің атауы бос болмайды',
    th: 'ชื่อภาพฉลากไม่สามารถว่างเปล่า',
    ug: 'بەلگە رەسىم ئىسمى بوش بولسا بولمايدۇ',
    vi: 'Tên hình ảnh nhãn không được để trống',
    zh_tc: '標籤圖片名不能為空',
    ru: 'Имя метки не может быть пустым',
    ko: '태그 그림 이름은 비워둘 수 없습니다.',
    bur: 'အညွှန်းပုံအမည်ဗလာမဖြစ်ရ',
    ben: 'লেবেল ইমেজের নাম খালি থাকতে পারবে না',
    tr: 'Etiket görseli adı boş olamaz',
    km: 'ឈ្មោះរូបភាពស្លាកមិនអាចទទេ',
    es: 'El nombre de la imagen de etiqueta no puede estar vacío',
    ar: 'لا يمكن أن يكون اسم صورة التسمية فارغًا',
  },
  'cuttingDock.labelingSettings.imgSetting.labelTip1': {
    zh: '自定义时【板件条码】或【标签序号】必须使用其中一项，否则会出现图片覆盖的问题',
    en: 'When customizing, either [Board Barcode] or [Label Sequence Number] must be used, otherwise there may be image overlay issues',
    id: 'Saat menyesuaikan, Anda harus menggunakan salah satu dari "papan barcode papan" atau "nomor seri label", jika tidak akan ada masalah cakupan gambar;',
    kz: '[Бөлшектердің штрих-коды] немесе [Бейнамалардың нөмірі] дегенді өзіңіздің белгіліңізді пайдалануыңыз керек, болмаса суреттердің үстіне қалдыруысы проблема туындайды',
    th: 'เมื่อปรับแต่งคุณต้องใช้หนึ่งใน "บาร์โค้ดบอร์ด" หรือ "หมายเลขซีเรียลฉลาก" มิฉะนั้นจะมีปัญหาเรื่องการครอบคลุมภาพ',
    ug: 'ئەسكەرتىش: 1، ئىختىيارى تەڭشەشتە 【تاختا باركود】 ياكى 【بەلگە تەرتىپ نومۇرى】 نىڭ بىرىنى مەجبۇرىي ئىشلىتىش كېرەك، بولمىسا رەسىملەرنىڭ ئۈستىگە يېزىلىشى مۇمكىن',
    vi: 'Khi tùy chỉnh, phải sử dụng [mã vạch tấm] hoặc [số thứ tự nhãn] làm một trong hai, nếu không sẽ có vấn đề về chồng lên nhau của hình ảnh',
    zh_tc:
      '自定義時【板件條碼】或【標籤序號】必須使用其中一項，否則會出現圖片覆蓋的問題',
    ru: 'При настройке [штрих - код панели] или [серийный номер метки] должен использоваться один из них, иначе возникнут проблемы с покрытием изображения',
    ko: '사용자 정의 시 [보드 바코드] 또는 [태그 번호] 중 하나를 사용해야 합니다. 그렇지 않으면 그림을 덮어쓰는 문제가 발생할 수 있습니다.',
    bur: 'စိတ်ကြိုက်ပြင်ဆင်သည့်အခါ【ပြားဘားကုဒ်】သို့မဟုတ်【အညွှန်းအစဉ်နံပါတ်】တစ်ခုသုံးရမည်၊ သို့မဟုတ်ပုံထပ်ခြင်းပြဿနာဖြစ်နိုင်သည်',
    ben: 'কাস্টমাইজ করার সময় [বোর্ড বারকোড] বা [লেবেল সিকোয়েন্স নম্বর] যেকোনো একটি ব্যবহার করতে হবে, নাহলে ইমেজ ওভারলে সমস্যা হতে পারে',
    tr: 'Özelleştirirken [Levha Barkodu] veya [Etiket Sıra Numarası] değerlerinden biri kullanılmalıdır, aksi halde görüntü üst üste binme sorunları olabilir',
    km: 'ពេលកំណត់ផ្ទាល់ខ្លួន ត្រូវប្រើ [បាកូដផ្ទាំង] ឬ [លេខលំដាប់ស្លាក] មួយក្នុងពីរ បើមិនដូចនោះទេ រូបភាពអាចជាប់គ្នា',
    es: 'Al personalizar, [Board Barcode] o [Label Sequence Number] deben usar uno de ellos, de lo contrario habrá problemas de sobrescritura de imágenes',
    ar: 'عند التخصيص، يجب أن يستخدم [Board Barcode] أو [Label Sequence Number] واحدًا منها، وإلا ستكون هناك مشاكل في الكتابة فوق الصورة',
  },
  'cuttingDock.labelingSettings.imgSetting.labelTip3': {
    zh: '【标签序号】为开料清单小板从上到下的序列号，排版页添加的小板无此数据',
    en: '【Label Sequence Number】 is the serial number of the small board from top to bottom in the cutting list, and the small board added on the layout page has no this data',
    id: '【Nomor Seri Label】 adalah nomor seri papan dari atas ke bawah dalam daftar pemotongan, dan papan yang ditambahkan di halaman pengaturan tidak memiliki data ini',
    kz: '【Бейнамалардың нөмірі】 - бұл кесу тізіміндегі жоғарыдан төмен қарай қатарлардың нөмірі, құжаттың кесу бетіне қосылған қатарларға мүмкін емес',
    th: '【หมายเลขซีเรียลฉลาก】 คือหมายเลขซีเรียลของกระดาษจากบนลงล่างในรายการตัด และกระดาษที่เพิ่มในหน้าตั้งต้นไม่มีข้อมูลนี้',
    ug: '【بەلگە تەرتىپ نومۇرى】 بۇ قاچانچە قۇرۇلۇقىدىن ئاستىگە كەيىنكى قاچانچە ھەرپلەرنىڭ تەرتىپ نومۇرى، قاچانچە قۇرۇلۇقىغا قوشۇلغان قاچانچە كىيىن بۇ مەلۇمات يوق',
    vi: '【Số thứ tự nhãn】 là số thứ tự của tấm nhỏ từ trên xuống dưới trong danh sách cắt, và tấm nhỏ được thêm vào trang bố trí không có dữ liệu này',
    zh_tc:
      '【標籤序號】為開料清單小板從上到下的序列號，排版頁添加的小板無此數據',
    ru: '【Серийный номер метки】 - это серийный номер строки сверху вниз в списке раскроя, и строка, добавленная на страницу компоновки, не имеет этих данных',
    ko: '【태그 일련번호】 는 재료 공급 순서에 따라 표지를 붙이다 페이지에 추가된 작은 판에는 이 데이터가 없습니다',
    bur: '【အညွှန်းအစဉ်နံပါတ်】 သည် ဖြတ်တောက်စာရင်းရှိ ပေါ်ဒ်ငယ်များ၏ အပေါ်မှ အောက်သို့ အစဉ်လိုက် နံပါတ်ဖြစ်ပြီး၊ ပြင်ဆင်မှုစာမျက်နှာတွင် ထည့်သော ပေါ်ဒ်ငယ်များတွင် ဤဒေတာမရှိပါ',
    ben: '【লেবেল সিকোয়েন্স নম্বর】 হল কাটিয়ার তালিকার উপর থেকে নীচে একটি কাটিয়ার সিকোয়েন্স নম্বর, এবং লেবেলিং পেজে যোগ করা কাটিয়ার কোনো এই ডাটা নেই',
    tr: '【Etiket Sıra Numarası】, kesim listesinden yukarıdan aşağıya doğru olan dizin numarasıdır, ve düzenleme sayfasına eklenen küçük levha bu veriye sahip değildir',
    km: '【លេខលំដាប់ស្លាក】 គឺជាលេខលំដាប់ស្លាកពីលើទៅកាន់ខាងក្រោមនៃការផែងផែង និងស្លាកតាមរយៈការបង្កើតផ្ទាល់ខ្លួនមិនមានទិន្ទន៍នេះ',
    es: '【Número de serie de etiqueta】 es el número de serie de la pequeña tabla desde arriba hasta abajo en la lista de corte, y la pequeña tabla añadida en la página de disposición no tiene este dato',
    ar: '【رقم تسلسل العلامة】 هو رقم تسلسل اللوحة الصغيرة من الأعلى إلى الأسفل في قائمة القص، ولا يوجد هذا البيانات في اللوحة الصغيرة المضافة على صفحة التخصيص',
  },
  'cuttingDock.labelingSettings.imgSetting.labelTip2': {
    zh: '3、贴标机系统模板不生效此功能',
    en: '3. This feature does not apply to the labeling machine system template',
    id: '3. Template sistem mesin pelabelan tidak berlaku.',
    kz: '3. Байнама машинасының жүйелік үлгісі осы функсияны қолданбайды',
    th: '3. เทมเพลตระบบการติดฉลากไม่มีผล',
    ug: '3. بەلگە قويغۇچ سىستېما قېلىپى بۇ فۇنكسىيەنى ئىشلەتمەيدۇ',
    vi: '3. Mẫu hệ thống máy nhãn không có hiệu lực cho chức năng này',
    zh_tc: '3、貼標機系統模板不生效此功能',
    ru: '3. Шаблон системы не вступает в силу для этой функции',
    ko: '3. 이 기능은 어댑터 시스템 템플릿에 적용되지 않음',
    bur: '3. အညွှန်းစက်စနစ်တမ်းပလိတ်တွင်ဤအင်္ဂါရပ်အကျိုးမသက်ရောက်ပါ',
    ben: '3. লেবেলিং মেশিন সিস্টেম টেমপ্লেটে এই ফিচার প্রযোজ্য নয়',
    tr: '3. Bu özellik etiketleme makinesi sistem şablonu için geçerli değildir',
    km: '3. មុខងារនេះមិនអនុវត្តសម្រាប់គំរូប្រព័ន្ធម៉ាស៊ីនស្លាកទេ',
    es: '3. Esta función no tiene efecto en la plantilla del sistema de la máquina etiquetadora',
    ar: '3. لا تسري هذه الوظيفة في قالب نظام آلة وضع العلامات',
  },
  'cuttingDock.labelingSettings.imgSetting.delimiter': {
    zh: '分隔符',
    en: 'Delimiter:',
    id: 'Pembatas',
    kz: 'Бөлшегіш:',
    th: 'ตัวคั่น',
    ug: 'ئايرىغۇچ',
    vi: 'Dấu phân cách:',
    zh_tc: '分隔符',
    ru: 'Разделитель',
    ko: '구분자',
    bur: 'ခွဲခြားသင်္ကေတ:',
    ben: 'ডিলিমিটার:',
    tr: 'Ayırıcı:',
    km: 'សញ្ញាបំបែក៖',
    es: 'El separador',
    ar: 'لا يدعم الفاصل',
  },
  'cuttingDock.labelingSettings.imgSetting.inputTip': {
    zh: '不支持输入 / : ? < > | . ” * 等字符',
    en: 'Does not support input of characters such as / : ? < > | . ” *',
    id: 'Input /:? <> . ” * Dan karakter lain tidak didukung',
    kz: '/ : ? < > | . ” * және басқа да символдар енгізілуі мүмкін емес',
    th: 'ป้อนข้อมูล / : ? - - ” * และไม่รองรับอักขระอื่น ๆ',
    ug: 'كىرگۈزۈشكە بولمايدىغان ھەرپلەر: / : ? < > . ” *',
    vi: 'Không hỗ trợ nhập các ký tự như / : ? < > | . ” *',
    zh_tc: '不支持輸入 / : ? < > | . ” * 等字符',
    ru: 'Не поддерживается ввод /: < >. "* Равнозначные символы',
    ko: '입력 /:? 이 (가) 지원되지 않습니다. < > | ."* 등의 문자',
    bur: '/ : ? < > | . ” * စသည့်စာလုံးများထည့်သွင်းမပံ့ပိုးပါ',
    ben: '/ : ? < > | . ” * ইত্যাদি অক্ষর ইনপুট সাপোর্ট করে না',
    tr: '/ : ? < > | . ” * gibi karakterlerin girilmesi desteklenmez',
    km: 'មិនគាំទ្រការវាយបញ្ចូលតួអក្សរដូចជា / : ? < > | . ” *',
    es: 'no admite entrada /:? < > | . ” * Caracteres como',
    ar: 'الإدخال /: ? < > | . " * أحرف مثل',
  },
  'cuttingDock.labelingSettings.imgSetting.numStart': {
    zh: '贴标序号起始数值',
    en: 'Starting Value for Label Sequence Number',
    id: 'Nilai mulai dari nomor seri berlabel',
    kz: 'Байнамалардің нөмірінің бастамақ сан',
    th: 'ค่าเริ่มต้นของหมายเลขซีเรียลที่มีป้ายกำกับ',
    ug: 'بەلگە تەرتىپ نومۇرى باشلانغۇچ قىممىتى',
    vi: 'Giá trị bắt đầu số thứ tự nhãn',
    zh_tc: '貼標序號起始數值',
    ru: 'Начальное значение серийного номера',
    ko: '태그 일련번호 시작 값',
    bur: 'အညွှန်းအစဉ်နံပါတ်စတင်တန်ဖိုး',
    ben: 'লেবেল সিকোয়েন্স নম্বরের জন্য স্টার্টিং মান',
    tr: 'Etiket sıra numarası başlangıç değeri',
    km: 'តម្លៃចាប់ផ្តើមលេខលំដាប់ស្លាក',
    es: 'Valor inicial del número de serie de etiquetado',
    ar: 'القيمة الأولية لتسمية الرقم التسلسلي',
  },
  'cuttingDock.labelingSettings.imgSetting.example': {
    zh: '自定义贴标图片名(示例)',
    en: 'Custom Label Image Name (Example)',
    id: 'Nama Gambar Pelabelan Kustom (Contoh)',
    kz: 'Байнама суреттерінің атауларын өзіңіздің белгілеуіңіз (мисал)',
    th: 'ชื่อภาพการติดฉลากที่กำหนดเอง (ตัวอย่าง)',
    ug: 'ئىختىيارى بەلگە قويۇش رەسىم ئىسمى (مىسال)',
    vi: 'Tên hình ảnh nhãn tùy chỉnh (ví dụ)',
    zh_tc: '自定義貼標圖片名(示例)',
    ru: 'Пользовательское имя изображения наклейки (пример)',
    ko: '사용자 지정 스티커 이미지 이름 (예)',
    bur: 'စိတ်ကြိုက်အညွှန်းပုံအမည် (နမူနာ)',
    ben: 'কাস্টম লেবেল ইমেজ নাম (উদাহরণ)',
    tr: 'Özel etiket görseli adı (örnek)',
    km: 'ឈ្មោះរូបភាពស្លាកផ្ទាល់ខ្លួន (ឧទាហរណ៍)',
    es: 'Nombre de imagen de etiquetado personalizado (ejemplo)',
    ar: 'اسم صورة التسمية المخصصة (مثال)',
  },
  'cuttingDock.labelingSettings.imgSetting.stockNumOffset': {
    zh: '大板序号补偿位数到',
    en: 'The compensation digit of the large board serial number arrives.',
    id: 'Digit kompensasi nomor seri papan besar telah diterima.',
    kz: 'Қарақышқалардың номерларының қосылма бітігі келеді',
    th: 'หมายเลขลำดับแผ่นใหญ่ชดเชยหลักถึง',
    ug: 'چوڭ تاختا تەرتىپ نومۇرىنى تولدۇرۇش بېتى',
    vi: 'Số lượng chữ số bồi thường của số thứ tự bảng lớn đã đến',
    zh_tc: '大板序號補償位數到',
    ru: 'Номер большой доски',
    ko: '대시보드 번호 보상 자릿수',
    bur: 'ကြီးမားသောပြားအစဉ်နံပါတ်ပြန်လည်ထူထောင်သည့်ဂဏန်းသို့ရောက်သည်',
    ben: 'বড় বোর্ড সিরিয়াল নম্বরের ক্ষতিপূরণ অঙ্ক পর্যন্ত',
    tr: 'Büyük levha seri numarası telafi basamak sayısına',
    km: 'ចំនួនខ្ទង់សងសឹងលេខស៊េរីផ្ទាំងធំដល់',
    es: 'Dígitos de compensación del número de serie del tablero grande a',
    ar: 'أرقام تعويض الرقم التسلسلي للوحة الكبيرة إلى',
  },
  'cuttingDock.labelingSettings.imgSetting.divideFolders': {
    zh: '标签图片根据大板分为不同文件夹',
    en: 'Divide label images into different folders based on large boards',
    id: 'Gambar tag dibagi menjadi folder yang berbeda sesuai dengan papan besar',
    kz: 'Байнама суреттері үлкен панельге сәйкес әртүрлі қапшықтарға бөлінуі',
    th: 'แท็กรูปภาพแบ่งออกเป็นโฟลเดอร์ที่แตกต่างกันตามบอร์ดขนาดใหญ่',
    ug: 'بەلگە رەسىملىرىنى چوڭ تاختا بويىچە ئوخشاش بولمىغان قىسقۇچلارغا بۆلۈش',
    vi: 'Hình ảnh nhãn được phân chia thành các thư mục khác nhau theo tấm lớn',
    zh_tc: '標籤圖片根據大板分為不同文件夾',
    ru: 'Изображения метки разделены на разные папки в зависимости от размера доски',
    ko: '태그 이미지는 보드에 따라 다른 폴더로 나뉩니다.',
    bur: 'ကြီးမားသောပြားများအလိုက်အညွှန်းပုံများကိုမတူညီသောဖိုလ်ဒါများခွဲပါ',
    ben: 'বড় বোর্ডের উপর ভিত্তি করে লেবেল ইমেজ বিভিন্ন ফোল্ডারে ভাগ করুন',
    tr: 'Etiket görsellerini büyük levhaya göre farklı klasörlere ayır',
    km: 'បំបែករូបភាពស្លាកទៅថតផ្សេងៗតាមផ្ទាំងធំ',
    es: 'Las imágenes de etiquetas se dividen en diferentes carpetas según el tablero grande',
    ar: 'يتم تقسيم صور التسمية إلى مجلدات مختلفة وفقًا للوحة الكبيرة',
  },
  'cuttingDock.labelingSettings.imgSetting.foldersTip1': {
    zh: '注：1、此功能不支持与【开料机文件合并】功能一起使用',
    en: "Attention: 1. This feature cannot be used together with the 'Merge with Material Cutting Machine Files' feature",
    id: 'Catatan: 1. Fungsi ini tidak mendukung penggunaan dengan fungsi "Spinder File Gabungan";',
    kz: 'Ескерту: 1. Бұл функсия "Кесу машинасының файлдарын біріктіру" функциясымен бірге қолданылмайды',
    th: 'หมายเหตุ: 1. ฟังก์ชั่นนี้ไม่รองรับการใช้งานกับฟังก์ชั่น "File Merge"',
    ug: 'ئەسكەرتىش: 1، بۇ فۇنكسىيە «ئۆيۈچۈ ھۆججەت بىرلەشتۈرۈش» فۇنكسىيىسى بىلەن بىرلىكتە ئىشلىتىلمەيدۇ',
    vi: "Chú ý: 1. Chức năng này không hỗ trợ sử dụng cùng với chức năng 'hợp nhất tệp máy cắt gỗ'",
    zh_tc: '注：1、此功能不支持與【開料機文件合併】功能一起使用',
    ru: 'Примечание: 1 Эта функция не поддерживает использование с функцией « Объединение файлов распылителя »',
    ko: '참고: 1. 이 기능은 [원료 공급기 파일 병합] 기능과 함께 사용할 수 없습니다.',
    bur: 'မှတ်ချက်: 1. ဤအင်္ဂါရပ်ကိုဖြတ်စက်ဖိုင်ပေါင်းခြင်းအင်္ဂါရပ်နှင့်အတူအသုံးမပြုနိုင်ပါ',
    ben: 'নোট: 1. এই ফিচারটি ম্যাটেরিয়াল কাটিং মেশিন ফাইল মার্জ ফিচারের সাথে একসাথে ব্যবহার করা যাবে না',
    tr: 'Dikkat: 1. Bu özellik Malzeme Kesim Makinesi Dosyalarını Birleştir özelliği ile birlikte kullanılamaz',
    km: 'សម្គាល់៖ ១. មិនអាចប្រើមុខងារនេះរួមជាមួយមុខងាររួមឯកសារម៉ាស៊ីនកាត់វត្ថុធាតុ',
    es: 'Nota: 1. Esta función no admite el uso con la función 【开料机文件合并】',
    ar: 'ملاحظة: 1. لا تدعم هذه الوظيفة الاستخدام مع وظيفة 【开料机文件合并】',
  },
  'cuttingDock.labelingSettings.imgSetting.foldersTip2': {
    zh: '2、此功能暂未对内嵌云排版生效',
    en: '2. This feature is not yet effective for the embedded cloud layout',
    id: '2. Fungsi ini belum efektif untuk pengaturan huruf awan tertanam',
    kz: '2. Бұл функсия кірікті булт пішімдеуге әлі қолданылмайды',
    th: '2. ฟังก์ชั่นนี้ยังไม่มีประสิทธิภาพสำหรับการเรียงลำดับเมฆแบบฝังตัว',
    ug: '2، بۇ فۇنكسىيە ئىچكى بۇيرۇق بىلەن تەڭشەلگەن تەڭشەكلەرگە ئىشلەتمەيدۇ',
    vi: '2. Chức năng này chưa có hiệu lực đối với sắp xếp đám mây nhúng',
    zh_tc: '2、此功能暫未對內嵌雲排版生效',
    ru: 'Эта функция еще не вступила в силу для встроенного облачного набора',
    ko: '2. 이 기능은 내장 클라우드 레이아웃에 아직 적용되지 않음',
    bur: '2. ဤအင်္ဂါရပ်သည်ထည့်သွင်းမိုးတိမ်တပ်ဆင်ခြင်းအတွက်အချိန်မတိုင်မီအကျိုးမသက်ရောက်သေးပါ',
    ben: '2. এমবেডেড ক্লাউড লেআউটের জন্য এই ফিচার এখনও কার্যকর নয়',
    tr: '2. Bu özellik gömülü bulut düzeni için henüz geçerli değildir',
    km: '២. មុខងារនេះមិនទាន់មានប្រសិទ្ធភាពសម្រាប់ការចងក្រងក្នុងពពកខ្ចប់ទេ',
    es: '2. Esta función aún no es efectiva para la composición tipográfica en la nube integrada',
    ar: '2. هذه الوظيفة ليست فعالة بعد للتنضيد السحابي المضمن',
  },
  'cuttingDock.labelingSettings.imgSetting.stickIntoFolders': {
    zh: '贴标文件插入到对应大板的贴标图片文件夹中',
    en: "Insert labeling files into the corresponding large board's label image folders:",
    id: 'Masukkan file pelabelan ke dalam folder gambar pelabelan dari papan besar yang sesuai',
    kz: 'Байнама файлдарын тиісті үлкен панельдің байнама суреттері қапшықтарына қосу:',
    th: 'แทรกไฟล์การติดฉลากลงในโฟลเดอร์รูปภาพการติดฉลากของบอร์ดขนาดใหญ่ที่เกี่ยวข้อง',
    ug: 'بەلگە قويۇش ھۆججىتىنى ئوخشاش چوڭ تاختىدىكى بەلگە رەسىم قىسقۇچىغا قىستۇرۇش',
    vi: 'Tệp nhãn được chèn vào thư mục hình ảnh nhãn tương ứng với tấm lớn:',
    zh_tc: '貼標文件插入到對應大板的貼標圖片文件夾中',
    ru: 'Вставить файл метки в папку изображений',
    ko: '태그 파일을 해당 보드의 태그 이미지 폴더에 삽입합니다.',
    bur: 'အညွှန်းဖိုင်များကိုသက်ဆိုင်ရာကြီးမားသောပြား၏အညွှန်းပုံဖိုလ်ဒါထဲထည့်ပါ:',
    ben: 'লেবেলিং ফাইলগুলি সংশ্লিষ্ট বড় বোর্ডের লেবেল ইমেজ ফোল্ডারে সন্নিবেশ করুন:',
    tr: 'Etiketleme dosyalarını ilgili büyük levhın etiket görseli klasörlerine ekleyin:',
    km: 'បញ្ចូលឯកសារស្លាកទៅថតរូបភាពស្លាករបស់ផ្ទាំងធំដែលត្រូវគ្នា៖',
    es: 'El archivo de etiquetado se inserta en la carpeta de imágenes de etiquetado correspondiente al tablero grande',
    ar: 'يتم إدراج ملف الملصقات في مجلد صور الملصقات المطابق للوحة الكبيرة',
  },
  'cuttingDock.labelingSettings.imgSetting.stickTip1': {
    zh: '注意: 1、此功能需要和【下载NC顺带导出标签】功能配合使用',
    en: "Attention: 1. This feature needs to be used in conjunction with the 'Export Labels Along with Downloading NC' feature;",
    id: 'Catatan: 1. Fungsi ini perlu digunakan bersama dengan fungsi "Unduh NC dan Ekspor";',
    kz: 'Ескерту: 1. Бұл функсия "NC жүктемесін бірге бейнамаларды экспорту" функциясымен бірге қолдануыңыз керек;',
    th: 'หมายเหตุ: 1. ฟังก์ชั่นนี้ต้องใช้ร่วมกับฟังก์ชั่น "ดาวน์โหลด NC และ Tags Export";',
    ug: 'دىققەت: 1، بۇ فۇنكسىيە «NC نى چۈشۈرۈش بىلەن بەلگىلەرنى چىقىرىش» فۇنكسىيىسى بىلەن بىرلىكتە ئىشلىتىلىشى كېرەك',
    vi: "Chú ý: 1. Chức năng này cần được sử dụng cùng với chức năng 'tải xuống NC đồng thời xuất nhãn';",
    zh_tc: '注意: 1、此功能需要和"下載NC順帶導出標籤"功能配合使用；',
    ru: 'Примечание: 1, эта функция должна использоваться в сочетании с функцией « Скачать тег попутного экспорта» NC',
    ko: '참고: 1. 이 기능은 [NC 스트립 내보내기 태그 다운로드] 기능과 함께 사용해야 합니다.',
    bur: 'သတိပြုပါ: 1. ဤအင်္ဂါရပ်သည NC ဒေါင်းလုဒ်နှင့်အတူအညွှန်းထုတ်ခြင်းအင်္ဂါရပ်နှင့်အတူအသုံးပြုရမည်',
    ben: 'নোট: 1. এই ফিচারটি NC ডাউনলোডের সাথে লেবেল এক্সপোর্ট ফিচারের সাথে একত্রে ব্যবহার করতে হবে',
    tr: 'Dikkat: 1. Bu özellik NC İndirirken Etiketleri Dışa Aktar özelliği ile birlikte kullanılmalıdır',
    km: 'សម្គាល់៖ ១. មុខងារនេះត្រូវប្រើរួមជាមួយមុខងារទាញយក NC និងនាំចេញស្លាក',
    es: 'Nota: 1. Esta función debe usarse junto con la función 【下载NC顺带导出标签】',
    ar: 'ملاحظة: 1. يجب استخدام هذه الوظيفة جنبًا إلى جنب مع وظيفة 【下载NC顺带导出标签】',
  },
  'cuttingDock.labelingSettings.imgSetting.stickTip2': {
    zh: '2、使用的贴标模板中文件生成规则需要选择“生成单个文件”此功能才生效；',
    en: "2. This feature will only take effect if the file generation rule in the used labeling template selects 'Generate Single File';",
    id: '2. Aturan pembuatan file dalam templat pelabelan yang digunakan perlu memilih "menghasilkan satu file" untuk berlaku;',
    kz: '2. Байнама үлгісінің файлдарды құру әдісіне "Бір файлды құру" дегенді таңдауыңыз, сонда ғана бұл функсия қолданылады;',
    th: '2. กฎการสร้างไฟล์ในเทมเพลตการติดฉลากที่ใช้จำเป็นต้องเลือก "สร้างไฟล์เดียว" เพื่อให้ได้ผล',
    ug: '2، ئىشلىتىلگەن بەلگە قويغۇچ قېلىپىدىكى ھۆججەت ھاسىل قىلىش قائىدىسى «بىر ھۆججەت ھاسىل قىلىش» نى تاللىسىڭىز بۇ فۇنكسىيە ئىشلىنىدۇ؛',
    vi: "2. Quy tắc tạo tệp trong mẫu nhãn cần chọn 'tạo tệp riêng' để chức năng này có hiệu lực;",
    zh_tc:
      '2、使用的貼標模板中文件生成規則需要選擇"生成單個文件"此功能才生效；',
    ru: '2. Правила генерации файлов в используемом шаблоне наклейки должны быть выбраны для того, чтобы функция « Создание одного файла» вступила в силу;',
    ko: '2. 사용된 스티커 템플릿의 파일 생성 규칙은 단일 파일 생성 기능을 선택해야 적용됩니다.',
    bur: '2. အသုံးပြုထားသောအညွှန်းတမ်းပလိတ်ရှိဖိုင်ထုတ်ခြင်းစည်းမျဉ်းတွင် "တစ်ဖိုင်ထုတ်ပါ" ရွေးရမည်မှဤအင်္ဂါရပ်အကျိုးသက်ရောက်မည်',
    ben: '2. ব্যবহৃত লেবেলিং টেমপ্লেটে ফাইল জেনারেশন রুলে "সিঙ্গেল ফাইল জেনারেট করুন" সিলেক্ট করলে এই ফিচার কার্যকর হবে',
    tr: '2. Özellik yalnızca kullanılan etiket şablonunda dosya oluşturma kuralı Tek Dosya Oluştur seçildiğinde geçerlidir',
    km: '២. មុខងារនេះមានប្រសិទ្ធភាពតែនៅពេលគំរូស្លាកដែលប្រើជ្រើសច្បាប់បង្កើតឯកសារជា «បង្កើតឯកសារតែមួយ»',
    es: '2. La regla de generación de archivos en la plantilla de etiquetado utilizada debe seleccionar "Generar un solo archivo" para que esta función surta efecto;',
    ar: '2. تحتاج قاعدة إنشاء الملف في قالب التسمية المستخدم إلى تحديد "إنشاء ملف واحد" حتى تدخل هذه الوظيفة حيز التنفيذ؛',
  },
  'cuttingDock.labelingSettings.imgSetting.stickTip3': {
    zh: '3、此功能暂未对内嵌云排版生效',
    en: '3. This feature is not yet effective for the embedded cloud layout',
    id: '3. Fungsi ini belum efektif untuk pengaturan huruf awan tertanam',
    kz: '3. Бұл функсия кірікті булт пішімдеуге әлі қолданылмайды',
    th: '3. ฟังก์ชั่นนี้ยังไม่มีประสิทธิภาพสำหรับการเรียงลำดับเมฆแบบฝังตัว',
    ug: '3، بۇ فۇنكسىيە ئىچكى بۇيرۇق بىلەن تەڭشەلگەن تەڭشەكلەرگە ئىشلەتمەيدۇ',
    vi: '3. Chức năng này chưa có hiệu lực đối với sắp xếp đám mây nhúng',
    zh_tc: '3、此功能暫未對內嵌雲排版生效',
    ru: 'Эта функция еще не вступила в силу для встроенного облачного набора',
    ko: '3. 이 기능은 내장 클라우드 레이아웃에 아직 적용되지 않음',
    bur: '3. ဤအင်္ဂါရပ်သည်ထည့်သွင်းမိုးတိမ်တပ်ဆင်ခြင်းအတွက်အချိန်မတိုင်မီအကျိုးမသက်ရောက်သေးပါ',
    ben: '3. এমবেডেড ক্লাউড লেআউটের জন্য এই ফিচার এখনও কার্যকর নয়',
    tr: '3. Bu özellik gömülü bulut düzeni için henüz geçerli değildir',
    km: '៣. មុខងារនេះមិនទាន់មានប្រសិទ្ធភាពសម្រាប់ការចងក្រងក្នុងពពកខ្ចប់ទេ',
    es: '3. Esta función aún no es efectiva para la composición tipográfica en la nube integrada',
    ar: '3. هذه الوظيفة ليست فعالة بعد للتنضيد السحابي المضمن',
  },
  'cuttingDock.labelingSettings.pdfSetting.title': {
    zh: '贴标PDF设置',
    en: 'Label PDF Settings',
    id: 'Pengaturan PDF Label',
    kz: 'Жапсырма PDF параметрлері',
    th: 'การตั้งค่า PDF ป้ายกำกับ',
    ug: 'بەلگە PDF تەڭشىكى',
    vi: 'Cài đặt PDF nhãn',
    zh_tc: '貼標PDF設置',
    ru: 'Настройки PDF-этикетки',
    ko: '라벨 PDF 설정',
    bur: 'တံဆိပ် PDF ဆက်တင်များ',
    ben: 'লেবেল PDF সেটিংস',
    es: 'Configuración de etiquetado PDF',
    ar: 'وضع العلامات PDF الإعدادات',
  },
  'cuttingDock.labelingSettings.pdfSetting.pdfLabelName': {
    zh: 'PDF文件名',
    en: 'PDF File Name',
    id: 'Nama File PDF',
    kz: 'PDF ھۆججەت ئىسمى',
    th: 'ชื่อไฟล์ PDF',
    ug: 'PDF ھۆججەت ئىسمى',
    vi: 'Tên tệp PDF',
    zh_tc: 'PDF文件名',
    ru: 'Имя файла PDF',
    ko: 'PDF 파일 이름',
    bur: 'PDF ဖိုင်အမည်',
    ben: 'PDF ফাইল নাম',
    es: 'PDF nombre de archivo',
    ar: 'PDF اسم الملف',
  },
  'cuttingDock.labelingSettings.pdfSetting.example': {
    zh: '自定义PDF文件名（示例）',
    en: 'Custom PDF File Name (Example)',
    id: 'Nama File PDF Kustom (Contoh)',
    kz: 'ئىختىيارىي PDF ھۆججەت ئىسمى (مىسال)',
    th: 'ชื่อไฟล์ PDF ที่กำหนดเอง (ตัวอย่าง)',
    ug: 'ئىختىيارىي PDF ھۆججەت ئىسمى (مىسال)',
    vi: 'Tên tệp PDF tùy chỉnh (ví dụ)',
    zh_tc: '自定義PDF文件名（示例）',
    ru: 'Имя файла PDF с индивидуальными настройками (пример)',
    ko: '사용자 지정 PDF 파일 이름 (예시)',
    bur: 'စိတ်ကြိုက်တပ်ဆင်ပုံဖိုင်အမည် (ဥပမာ)',
    ben: 'কাস্টম PDF ফাইল নাম (উদাহরণ)',
    es: 'Nombre de archivo PDF personalizado (ejemplo)',
    ar: 'اسم الملف المخصص PDF (مثال)',
  },
  'cuttingDock.labelingSettings.pdfSetting.address': {
    zh: '项目地址',
    en: 'Project Address',
    id: 'Alamat Proyek',
    kz: 'Жоба мекенжайы',
    th: 'ที่อยู่โครงการ',
    ug: 'تۈر ئادرىسى',
    vi: 'Địa chỉ dự án',
    zh_tc: '項目地址',
    ru: 'Адрес проекта',
    ko: '프로젝트 주소',
    bur: 'ဆိုင်ရာအကွေးအဝေါ်',
    ben: 'প্রকল্প ঠিকানা',
    es: 'Dirección del proyecto',
    ar: 'عنوان المشروع',
  },
  'cuttingDock.labelingSettings.pdfSetting.orderNo': {
    zh: '订单号',
    en: 'Order No.',
    id: 'No. Pesanan',
    kz: 'زاكاز نومۇرى',
    th: 'หมายเลขคำสั่งซื้อ',
    ug: 'زاكاز نومۇرى',
    vi: 'Số đơn hàng',
    zh_tc: '訂單號',
    ru: 'Номер заказа',
    ko: '주문 번호',
    bur: 'မှာယူသည်းခံစာမျက်နှာအမည်',
    ben: 'ক্রমবাক্য নং',
    es: 'Número de pedido',
    ar: 'رقم الطلب',
  },
  'cuttingDock.labelingSettings.pdfSetting.firstFolder': {
    zh: '一级文件夹',
    en: 'First-level Folder',
    id: 'Folder Level Pertama',
    kz: 'Бірінші деңгейлі қалта',
    th: 'โฟลเดอร์ระดับแรก',
    ug: 'بىرىنچى دەرىجىلىك قىسقۇچ',
    vi: 'Thư mục cấp 1',
    zh_tc: '一級文件夾',
    ru: 'Первый уровень папки',
    ko: '첫 번째 폴더',
    bur: 'တစ်နေရာအထိ အကွေးအဝေါ်',
    ben: 'প্রথম স্তর ফোল্ডার',
    es: 'Carpeta de primer nivel',
    ar: 'مجلد المستوى الأول',
  },
  'cuttingDock.labelingSettings.pdfSetting.customerName': {
    zh: '客户名称',
    en: 'Customer Name',
    id: 'Nama Pelanggan',
    kz: 'Тұтынушы аты',
    th: 'ชื่อลูกค้า',
    ug: 'خېرىدار نامى',
    vi: 'Tên khách hàng',
    zh_tc: '客戶名稱',
    ru: 'Имя клиента',
    ko: '고객 이름',
    bur: 'မှာယူသည်းခံစာမျက်နှာအမည်',
    ben: 'গ্রাহক নাম',
    es: 'Nombre del cliente',
    ar: 'اسم العميل',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.title': {
    zh: '排版图设置',
    en: 'Layout Image Settings',
    id: 'Pengaturan Diagram Pengesahan',
    kz: 'Қалыптастыру суретті орнату',
    th: 'การตั้งค่าแผนภาพเรียงลำดับ',
    ug: 'تەڭشەلگەن رەسىم تەڭشىكى',
    vi: 'Cài đặt sắp xếp hình ảnh',
    zh_tc: '排版圖設置',
    ru: 'Настройка типографики',
    ko: '조판도 설정',
    bur: 'တပ်ဆင်ပုံသတ်မှတ်ချက်များ',
    ben: 'লেআউট ইমেজ সেটিংস',
    tr: 'Düzen görüntüsü ayarları',
    km: 'ការកំណត់រូបភាពចងក្រង',
    es: 'Configuración de diseño',
    ar: 'إعداد التخطيط',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.tip': {
    zh: '开启了导出自定义排版图，下方固定模板不可导出，如需导出请在排版页更多设置里面关闭导出自定义排版图',
    en: 'The export of custom layout diagrams has been enabled. The fixed template below cannot be exported. If you need to export, please turn off exporting custom layout diagrams in the more settings section of the layout page',
    id: 'Ekspor tipografi khusus diaktifkan, template tetap di bawah ini tidak dapat diekspor. Untuk mengekspor, tutup Ekspor tipografi khusus di halaman pengaturan lebih lanjut tipografi',
    kz: 'Өзгертілген пішімді суреттерді экспорттау режимі қосылды. Төмендегі бекітілген үлгі экспортталмайды. Оны экспорттау үшін, пішімдеу бетіндегі «Басқа параметрлер» бөлімінен бұл функцияны өшіріңіз',
    th: 'เปิดการส่งออกแผนภาพการพิมพ์ที่กำหนดเองแม่แบบคงที่ด้านล่างไม่สามารถส่งออกสำหรับการส่งออกโปรดปิดการส่งออกแผนภูมิการพิมพ์ที่กำหนดเองในการตั้งค่าเพิ่มเติมของหน้าการพิมพ์',
    ug: 'ئىختىيارىي جايلاشتۇرۇش رەسىمىنى ئېكسپورت قىلىش ئېچىلدى. تۆۋەندىكى مۇقىم ئەندىزە ئېكسپورت قىلىنمايدۇ. ئۇنى ئېكسپورت قىلىش ئۈچۈن، جايلاشتۇرۇش بېتىدىكى «تېخىمۇ كۆپ تەڭشەك» ئىچىدىن بۇ ئىقتىدارنى ئېتىۋېتىڭ',
    vi: 'Xuất bản đồ sắp chữ tùy chỉnh đã được bật, mẫu cố định bên dưới không thể xuất, để xuất, hãy tắt Xuất bản đồ sắp chữ tùy chỉnh trong trang sắp chữ Thêm cài đặt',
    zh_tc:
      '開啟了匯出自定義排版圖，下方固定範本不可匯出，如需匯出請在排版頁更多設定裡面關閉匯出自定義排版圖',
    ru: 'Открыт экспорт настраиваемой типографики, ниже фиксированный шаблон не может быть экспортирован, если вы хотите экспортировать, закройте экспорт настраиваемой типографики в дополнительных настройках',
    ko: '사용자 지정 조판도 내보내기가 켜져 있습니다. 아래 고정 템플릿은 내보낼 수 없습니다. 내보내려면 조판 페이지의 더 많은 설정에서 사용자 지정 조판도 내보내기를 닫으십시오.',
    bur: 'စိတ်ကြိုက်တပ်ဆင်ပုံထုတ်ခြင်းဖွင့်ပြီးဖြစ်သည်။ အောက်ရှိသတ်မှတ်တမ်းပလိတ်ထုတ်မရပါ။ ထုတ်လိုပါကတပ်ဆင်စာမျက်နှာပိုမိုသတ်မှတ်ချက်တွင်စိတ်ကြိုက်တပ်ဆင်ပုံထုတ်ခြင်းပိတ်ပါ',
    ben: 'কাস্টম লেআউট ডায়াগ্রাম এক্সপোর্ট চালু করা হয়েছে। নিচের ফিক্সড টেমপ্লেট এক্সপোর্ট করা যাবে না। এক্সপোর্ট করতে লেআউট পেজের আরো সেটিংসে কাস্টম লেআউট ডায়াগ্রাম এক্সপোর্ট বন্ধ করুন',
    tr: 'Özel düzen görüntüsü dışa aktarma açık; aşağıdaki sablon dışa aktarılamaz. Dışa aktarmak için düzen sayfasında daha fazla ayarlardan özel düzen dışa aktarmayı kapatın',
    km: 'បើកនាំចេញរូបចងក្រងផ្ទាល់ខ្លួន គំរូថេរខាងក្រោមមិនអាចនាំចេញ។ បើត្រូវការនាំចេញ បិទនាំចេញរូបចងក្រងផ្ទាល់ខ្លួននៅក្នុងការកំណត់បន្ថែមនៃទំព័រចងក្រង',
    es: 'Habilita la exportación de dibujos de diseño personalizados. La plantilla fija a continuación no se puede exportar. Si necesita exportar, desactive la exportación de dibujos de diseño personalizados en más configuraciones en la página de diseño',
    ar: 'يتيح تصدير رسومات التخطيط المخصصة. لا يمكن تصدير القالب الثابت أدناه. إذا كنت بحاجة إلى التصدير، فيرجى إيقاف تصدير رسومات التخطيط المخصصة في المزيد من الإعدادات في صفحة التخطيط',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.reparation': {
    zh: '排版图序号自动补偿到',
    en: 'Automatic Compensation of Layout Image Sequence to',
    id: 'Nomor tata letak akan dikompensasi secara otomatis',
    kz: 'Қалыптастыру суреттерінің нөмірі автоматты түрде толықтыру',
    th: 'หมายเลขเลย์เอาต์จะได้รับการชดเชยโดยอัตโนมัติ',
    ug: 'تەڭشەلگەن رەسىم تەرتىپ نومۇرىنى تولدۇرۇش',
    vi: 'Tự động bù số thứ tự sắp xếp hình ảnh đến',
    zh_tc: '排版圖序號自動補償到',
    ru: 'Серийный номер графика автоматически компенсируется',
    ko: '조판 차트 번호 자동 보상',
    bur: 'တပ်ဆင်ပုံအစဉ်နံပါတ်အလိုအလျောက်ပြန်လည်ထူထောင်ခြင်းသို့',
    ben: 'লেআউট ইমেজ সিকোয়েন্সের স্বয়ংক্রিয় ক্ষতিপূরণ',
    tr: 'Düzen görüntüsü sıra numarası otomatik telafisi',
    km: 'ការសងសឹងស្វ័យប្រវត្តិលេខលំដាប់រូបចងក្រងដល់',
    es: 'El número de serie del dibujo de diseño se compensa automáticamente a',
    ar: 'يتم تعويض الرقم التسلسلي لرسم التخطيط تلقائيًا إلى',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.figure': {
    zh: '位',
    en: 'Position',
    id: 'Sedikit',
    kz: 'Орны',
    th: 'นิดหน่อย',
    ug: 'خانە',
    vi: 'chữ vị',
    zh_tc: '位',
    ru: 'бит',
    ko: '자리',
    bur: 'ဂဏန်းနေရာ',
    ben: 'অবস্থান',
    tr: 'Basamak',
    km: 'ខ្ទង់',
    es: 'dígitos',
    ar: 'أرقام',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.inputTip': {
    zh: '请输入1-99的数字',
    en: 'Please enter a number between 1-99',
    id: 'Harap masukkan nomor dari 1-99',
    kz: '1-99 аралығындағы цифрларді енгізіңіз',
    th: 'กรุณากรอกหมายเลขตั้งแต่ 1-99',
    ug: '1-99 گىچە سان كىرگۈزۈڭ',
    vi: 'Vui lòng nhập số từ 1-99',
    zh_tc: '請輸入1-99的數字',
    ru: 'Введите цифры 1 - 99.',
    ko: '1-99의 숫자를 입력하십시오.',
    bur: '၁-၉၉ ကြားဂဏန်းထည့်ပါ',
    ben: '১-৯৯ এর মধ্যে একটি সংখ্যা লিখুন',
    tr: 'Lütfen 1-99 arası bir sayı girin',
    km: 'សូមបញ្ចូលលេខពី ១ ដល់ ៩៩',
    es: 'Ingrese un número del 1 al 99',
    ar: 'يرجى إدخال رقم من 1 إلى 99',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.export': {
    zh: '导出排版图',
    en: 'Export Layout Image',
    id: 'Tata letak ekspor',
    kz: 'Қалыптастыру суреттерін экспорттау',
    th: 'เค้าโครงส่งออก',
    ug: 'تەڭشەلگەن رەسىم چىقىرىش',
    vi: 'Xuất sắp xếp hình ảnh',
    zh_tc: '導出排版圖',
    ru: 'Экспорт типографики',
    ko: '조판도 내보내기',
    bur: 'တပ်ဆင်ပုံထုတ်ပါ',
    ben: 'লেআউট ইমেজ এক্সপোর্ট করুন',
    tr: 'Düzen görüntüsünü dışa aktar',
    km: 'នាំចេញរូបភាពចងក្រង',
    es: 'Exportar dibujo de diseño',
    ar: 'تصدير رسم التخطيط',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.prefix': {
    zh: '排版图名前缀',
    en: 'Layout Image Name Prefix',
    id: 'Awalan yang mengeset',
    kz: 'Қалыптастыру суреттерінің атау префикси',
    th: 'คำนำหน้าการเรียงพิมพ์',
    ug: 'تەڭشەلگەن رەسىم ئالدى قوشۇمچە',
    vi: 'Tiền tố tên sắp xếp hình ảnh',
    zh_tc: '排版圖名前綴',
    ru: 'Префикс типографии',
    ko: '조판 도명 접두사',
    bur: 'တပ်ဆင်ပုံအမည်ရှေ့ဆက်',
    ben: 'লেআউট ইমেজ নাম প্রিফিক্স',
    tr: 'Düzen görüntüsü adı öneki',
    km: 'បុព្វបទឈ្មោះរូបភាពចងក្រង',
    es: 'Prefijo del nombre del dibujo de diseño',
    ar: 'بادئة اسم رسم التخطيط',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.size': {
    zh: '排版图尺寸',
    en: 'Layout Image Size',
    id: 'Ukuran pengukur huruf',
    kz: 'Қалыптастыру суреттерінің өлшемдері',
    th: 'ขนาดเรียงพิมพ์',
    ug: 'تەڭشەلگەن رەسىم چوڭلۇقى',
    vi: 'Kích thước sắp xếp hình ảnh',
    zh_tc: '排版圖尺寸',
    ru: 'Размер типографики',
    ko: '조판도 크기',
    bur: 'တပ်ဆင်ပုံအရွယ်အစား',
    ben: 'লেআউট ইমেজ সাইজ',
    tr: 'Düzen görüntüsü boyutu',
    km: 'ទំហំរូបភាពចងក្រង',
    es: 'Tamaño de diseño',
    ar: 'حجم التخطيط',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.format': {
    zh: '排版图格式',
    en: 'Layout Image Format',
    id: 'Format pengukur huruf',
    kz: 'Қалыптастыру суреттерінің форматы',
    th: 'รูปแบบการเรียงพิมพ์',
    ug: 'تەڭشەلگەن رەسىم فورماتى',
    vi: 'Định dạng sắp xếp hình ảnh',
    zh_tc: '排版圖格式',
    ru: 'Формат типографики',
    ko: '조판도 형식',
    bur: 'တပ်ဆင်ပုံဖော်မတ်',
    ben: 'লেআউট ইমেজ ফরম্যাট',
    tr: 'Düzen görüntüsü biçimi',
    km: 'ទ្រង់ទ្រាយរូបភាពចងក្រង',
    es: 'Formato de diseño',
    ar: 'تنسيق التخطيط',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.directional': {
    zh: '排版图方向',
    en: 'Layout Direction',
    id: 'Arah diagram yang memetik',
    kz: 'Қалыптастыру бағыты',
    th: 'ทิศทางแผนภาพการเรียงลำดับ',
    ug: 'تەڭشەلگەن رەسىم يۆنىلىشى',
    vi: 'Hướng sắp xếp',
    zh_tc: '排版圖方向',
    ru: 'Направление типографики',
    ko: '조판도 방향',
    bur: 'တပ်ဆင်ပုံဦးတည်ချက်',
    ben: 'লেআউট দিক',
    tr: 'Düzen yönü',
    km: 'ទិសដៅចងក្រង',
    es: 'Dirección de diseño',
    ar: 'اتجاه التخطيط',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.vertical': {
    zh: '竖向',
    en: 'Vertical',
    id: 'Vertikal',
    kz: 'Вертикальді',
    th: 'แนวตั้ง',
    ug: 'تىك',
    vi: 'Dọc',
    zh_tc: '豎向',
    ru: 'вертикальный',
    ko: '세로 방향',
    bur: 'ဒေါင်လိုက်',
    ben: 'উল্লম্ব',
    tr: 'Dikey',
    km: 'បញ្ឈរ',
    es: 'Vertical',
    ar: 'عمودي',
  },
  'cuttingDock.labelingSettings.paibanImgSetting.paibanImg.horizontal': {
    zh: '横向',
    en: 'Horizontal',
    id: 'Horisontal',
    kz: 'Горизонталды',
    th: 'ตามแนวนอน',
    ug: 'توغرا',
    vi: 'Ngang',
    zh_tc: '橫向',
    ru: 'Горизонтальный',
    ko: '가로',
    bur: 'အလျားလိုက်',
    ben: 'অনুভূমিক',
    tr: 'Yatay',
    km: 'ផ្តេក',
    es: 'Horizontal',
    ar: 'أفقي',
  },
  'cuttingDock.labelingSettings.autolabel': {
    zh: '自动贴标顺序设置',
    en: 'Automatic Labeling Order Setting',
    id: 'Pengaturan Pesanan Pelabelan Otomatis',
    kz: 'Автоматты жапсырма реттеу тәртібі',
    th: 'การตั้งค่าลำดับการติดฉลากอัตโนมัติ',
    ug: 'ئاپتوماتىك بەلگە قويۇش تەرتىپى تەڭشىكى',
    vi: 'Cài đặt thứ tự dán nhãn tự động',
    zh_tc: '自動貼標順序設置',
    ru: 'Автоматические настройки последовательности',
    ko: '자동 부착 순서 설정',
    bur: 'အလိုအလျောက်အညွှန်းအစဉ်သတ်မှတ်ချက်',
    ben: 'স্বয়ংক্রিয় লেবেলিং অর্ডার সেটিং',
    tr: 'Otomatik etiketleme sırası ayarı',
    km: 'ការកំណត់លំដាប់ស្លាកស្វ័យប្រវត្តិ',
    es: 'Configuración automática del orden de etiquetado',
    ar: 'إعداد ترتيب وضع العلامات التلقائي',
  },
  'cuttingDock.labelingSettings.customTemp': {
    zh: '仅针对自定义模板生效',
    en: 'Effective Only for Custom Templates',
    id: 'Efektif untuk templat khusus saja',
    kz: 'Тек тапсырыс бойынша шаблондарға қолданылады',
    th: 'มีผลสำหรับเทมเพลตที่กำหนดเองเท่านั้น',
    ug: 'پەقەت ئىختىيارى قېلىپلارغا ئىشلىتىلىدۇ',
    vi: 'Chỉ áp dụng cho mẫu tùy chỉnh',
    zh_tc: '僅針對自定義模板生效',
    ru: 'Вступление в силу только для пользовательских шаблонов',
    ko: '사용자 지정 템플릿에만 적용',
    bur: 'စိတ်ကြိုက်တမ်းပလိတ်များအတွက်သာအကျိုးသက်ရောက်သည်',
    ben: 'শুধুমাত্র কাস্টম টেমপ্লেটের জন্য কার্যকর',
    tr: 'Yalnızca özel şablonlar için geçerlidir',
    km: 'មានប្រសិទ្ធភាពសម្រាប់តែគំរូផ្ទាល់ខ្លួន',
    es: 'Solo válido para plantillas personalizadas',
    ar: 'صالح فقط للقوالب المخصصة',
  },
  'cuttingDock.labelingSettings.cuttingLabelOder': {
    zh: '按照开料顺序贴标',
    en: 'Labeling According to Cutting Order',
    id: 'Label sesuai dengan urutan pemotongan',
    kz: 'Кесу тәртібі бойынша жапсырма қою',
    th: 'ฉลากตามคำสั่งของการตัด',
    ug: 'قېپىش تەرتىپى بويىچە بەلگە قويۇش',
    vi: 'Dán nhãn theo thứ tự cắt',
    zh_tc: '按照開料順序貼標',
    ru: 'Маркировка в порядке вскрытия',
    ko: '재료 공급 순서에 따라 표지를 붙이다.',
    bur: 'ဖြတ်ချက်အစဉ်အတိုင်းအညွှကပ်ပါ',
    ben: 'কাটিং অর্ডার অনুযায়ী লেবেলিং',
    tr: 'Kesim sırasına göre etiketleme',
    km: 'ស្លាកតាមលំដាប់កាត់',
    es: 'Etiqueta según el orden de los materiales de apertura',
    ar: 'التسمية وفقًا لترتيب المواد المفتوحة',
  },
  'cuttingDock.labelingSettings.labelToUp': {
    zh: '按照排版结果从下往上贴标',
    en: 'Labeling from Bottom to Top Based on Layout',
    id: 'Label dari bawah ke atas sesuai dengan hasil tata letak',
    kz: 'Құрастыру нәтижесі бойынша төменнен жоғарыға жапсырма қою',
    th: 'ฉลากจากล่างขึ้นไปด้านบนตามผลลัพธ์ของเค้าโครง',
    ug: 'تەڭشەلگەن نەتىجە بويىچە تۆۋەندىن يۇقىرىغا بەلگە قويۇش',
    vi: 'Dán nhãn từ dưới lên theo kết quả bố trí',
    zh_tc: '按照排版結果從下往上貼標',
    ru: 'Маркировка снизу вверх по результатам набора',
    ko: '조판 결과에 따라 아래에서 위로 표지를 붙이다',
    bur: 'တပ်ဆင်ရလဒ်အရအောက်မှ အပေါ်သို့အညွှကပ်ပါ',
    ben: 'লেআউটের উপর ভিত্তি করে নিচ থেকে উপরে লেবেলিং',
    tr: 'Düzen sonucuna göre alttan üste etiketleme',
    km: 'ស្លាកពីក្រោមឡើងលើតាមលទ្ធផលចងក្រង',
    es: 'Etiqueta de abajo hacia arriba según los resultados del diseño',
    ar: 'التسمية من الأسفل إلى الأعلى وفقًا لنتائج التخطيط',
  },
  'cuttingDock.labelingSettings.labelToDown': {
    zh: '按照排版结果从上往下贴标',
    en: 'Labeling from Top to Bottom Based on Layout',
    id: 'Label dari atas ke bawah sesuai dengan hasil tata letak',
    kz: 'Құрастыру нәтижесі бойынша жоғарыдан төменге жапсырма қою',
    th: 'ฉลากจากบนลงล่างตามผลการจัดวาง',
    ug: 'تەڭشەلگەن نەتىجە بويىچە يۇقىرىدىن تۆۋەنگە بەلگە قويۇش',
    vi: 'Dán nhãn từ trên xuống theo kết quả bố trí',
    zh_tc: '按照排版結果從上往下貼標',
    ru: 'Наклейка сверху вниз по результатам набора',
    ko: '조판 결과에 따라 위에서 아래로 표지를 붙이다',
    bur: 'တပ်ဆင်ရလဒ်အရအပေါ်မှ အောက်သို့အညွှကပ်ပါ',
    ben: 'লেআউটের উপর ভিত্তি করে উপরে থেকে নিচে লেবেলিং',
    tr: 'Düzen sonucuna göre üstten alta etiketleme',
    km: 'ស្លាកពីលើចុះក្រោមតាមលទ្ធផលចងក្រង',
    es: 'Etiqueta de arriba hacia abajo según los resultados del diseño',
    ar: 'التسمية من الأعلى إلى الأسفل وفقًا لنتائج التخطيط',
  },
  'cuttingDock.labelingSettings.labelDodge': {
    zh: '贴标自动避让',
    en: 'Automatic Label Avoidance',
    id: 'Penghindaran pelabelan otomatis',
    kz: 'Жапсырма автоматты түрде кедергілерден қашады',
    th: 'การหลีกเลี่ยงการติดฉลากอัตโนมัติ',
    ug: 'بەلگە ئاپتوماتىك چېكىنىش',
    vi: 'Dán nhãn tự động tránh',
    zh_tc: '貼標自動避讓',
    ru: 'Автоматическое устранение меток',
    ko: '스티커 자동 회피',
    bur: 'အညွှန်းအလိုအလျောက်ရှောင်ခြင်း',
    ben: 'স্বয়ংক্রিয় লেবেল এভয়েডেন্স',
    tr: 'Otomatik etiket kaçınma',
    km: 'ការរួចផុតស្លាកស្វ័យប្រវត្តិ',
    es: 'Evitación automática de etiquetado',
    ar: 'تجنب وضع العلامات التلقائي',
  },
  'cuttingDock.labelingSettings.nolabelForsurplus': {
    zh: '余料大板不生成贴标文件',
    en: 'No labeling file is generated for the remaining material plate',
    id: 'Tidak ada file pelabelan yang dibuat untuk papan sisa',
    kz: 'Қалдық үлкен тақталар жапсырма файлдарын жасамайды',
    th: 'แผ่นใหญ่เศษวัสดุไม่สร้างไฟล์ฉลาก',
    ug: 'قالدۇق چوڭ تاختا بېلگە چاپلاش ھۆججىتى ھاسىل قىلمايدۇ',
    vi: 'Dư liệu tấm không tạo tập tin nhãn',
    zh_tc: '餘料大板不生成貼標文件',
    ru: 'Файл с наклейкой не создается',
    ko: '나머지 대시보드는 부착 파일을 생성하지 않습니다.',
    bur: 'ကျန်ပြားအတွက်အညွှန်းဖိုင်မထုတ်ပါ',
    ben: 'অবশিষ্ট ম্যাটেরিয়াল প্লেটের জন্য লেবেলিং ফাইল তৈরি হয় না',
    tr: 'Kalan malzeme levhası için etiket dosyası oluşturulmaz',
    km: 'មិនបង្កើតឯកសារស្លាកសម្រាប់ផ្ទាំងសម្ភារៈនៅសល់',
    es: 'El material restante, los paneles grandes no generan archivos de etiquetado',
    ar: 'لا تولد اللوحات الكبيرة للمواد المتبقية ملفات ملصقات',
  },
  'cuttingDock.labelingSettings.settingValue': {
    zh: '选择设定值',
    en: 'Select Setting Value',
    id: 'Pilih Nilai Set',
    kz: 'Орнату мәнін таңдаңыз',
    th: 'เลือกค่าที่ตั้งไว้',
    ug: 'تاللانغان قىممەت',
    vi: 'Chọn giá trị thiết lập',
    zh_tc: '選擇設定值',
    ru: 'Выберите заданное значение',
    ko: '설정 값 선택',
    bur: 'သတ်မှတ်တန်ဖိုးရွေးပါ',
    ben: 'সেটিং মান নির্বাচন করুন',
    tr: 'Ayar değerini seç',
    km: 'ជ្រើសតម្លៃកំណត់',
    es: 'Seleccione el valor de configuración',
    ar: 'حدد قيمة الإعداد',
  },
  'cuttingDock.labelingSettings.enabelTip': {
    zh: '开启后，当小板满足下列设定值，则标签旋转',
    en: 'When enabled, the label will rotate if the small board meets the following setting values',
    id: 'Setelah dibuka, saat papan kecil memenuhi nilai pengaturan berikut, label berputar',
    kz: 'Қосылған кезде, кішкене тақтаның көрсетілген мәндерге сәйкес келуі кезінде, жапсырма айналады',
    th: 'หลังจากเปิดเมื่อบอร์ดขนาดเล็กตรงกับค่าการตั้งค่าต่อไปนี้ฉลากจะหมุน',
    ug: 'قوزغىتىلغاندا، كىچىك تاختا تۆۋەندىكى تاللانغان قىممەتكە توغرا كەلگەندە، بەلگە ئۆرۈلىدۇ',
    vi: 'Khi bật, nếu bảng nhỏ đáp ứng các giá trị thiết lập dưới đây, nhãn sẽ xoay',
    zh_tc: '開啟後，當小板滿足下列設定值，則標籤旋轉',
    ru: 'После открытия, когда панель соответствует следующим заданным значениям, вкладка вращается',
    ko: '열면 보드가 다음 설정 값을 충족하면 레이블이 회전합니다.',
    bur: 'ဖွင့်ပြီးပါကပြားငယ်အောက်ပါသတ်မှတ်တန်ဖိုးများနှင့်ကိုက်ညီပါကအညွှန်းလည်ပတ်မည်',
    ben: 'সক্ষম করলে ছোট বোর্ড নিচের সেটিং মান পূরণ করলে লেবেল ঘুরবে',
    tr: 'Açıldığında küçük levha aşağıdaki değerleri sağlarsa etiket döner',
    km: 'បើបើក នៅពេលផ្ទាំងតូចត្រូវតាមតម្លៃខាងក្រោម ស្លាកនឹងបង្វិល',
    es: 'Después de encenderlo, cuando el tablero pequeño cumpla con los siguientes valores de configuración, la etiqueta girará',
    ar: 'بعد التشغيل، عندما تستوفي اللوحة الصغيرة قيم الإعداد التالية، سيتم تدوير الملصق',
  },
  'cuttingDock.labelingSettings.fixedHori': {
    zh: '选择标签横边与小板固定边平行',
    en: 'Select Parallel to the Fixed Edge of the Small Board',
    id: 'Pilih tepi horizontal label agar sejajar dengan tepi tetap dari pelat kecil',
    kz: 'Жапсырманың көлденең шетіне тақтаның бекітілген шетіне параллельді таңдаңыз',
    th: 'เลือกขอบแนวนอนของฉลากให้ขนานกับขอบคงที่ของแผ่นเล็ก ๆ',
    ug: 'بەلگە كەڭ چېگرىسى بىلەن كىچىك تاختا مۇقىم چېگرىسىنىڭ پاراللېللىقىنى تاللاڭ',
    vi: 'Chọn cạnh ngang của nhãn song song với cạnh cố định của bảng nhỏ',
    zh_tc: '選擇標籤橫邊與小板固定邊平行',
    ru: 'Выберите горизонтальную сторону вкладки, параллельную фиксированной стороне панели',
    ko: '탭 가로를 선택하여 보드의 고정 모서리와 평행',
    bur: 'အညွှန်းအလျားဘက်နှင့်ပြားငယ်သတ်မှတ်ဘက်ပြိုင်ရွေးပါ',
    ben: 'লেবেলের অনুভূমিক প্রান্ত ছোট বোর্ডের ফিক্সড প্রান্তের সমান্তরাল নির্বাচন করুন',
    tr: 'Etiket yatay kenarını küçük levhın sabit kenarına paralel seç',
    km: 'ជ្រើសគែមផ្តេកនៃស្លាកស្របនឹងគែមថេរនៃផ្ទាំងតូច',
    es: 'Seleccione el borde horizontal de la etiqueta para que sea paralelo al borde fijo del tablero pequeño',
    ar: 'حدد الحافة الأفقية للملصق لتكون موازية للحافة الثابتة للوحة الصغيرة',
  },
  'cuttingDock.labelingSettings.fixedHoriTip': {
    zh: '仅对无纹理小板生效，开启后，贴标时，标签会旋转到标签横边和小板固定边平行',
    en: 'Effective Only for Non-textured Small Boards. When enabled, the label will rotate to align the horizontal edge of the label with the fixed edge of the small board during labeling',
    id: 'Hanya efektif untuk papan kecil tanpa tekstur. Setelah membuka, saat memberi label, label akan berputar ke paralel ke tepi horizontal label dan tepi tetap dari papan kecil.',
    kz: 'Тек текстурасыз тақталарға қолданылады, қосылған кезде, жапсырма тақтаның бекітілген шетіне параллельді болады',
    th: 'มีประสิทธิภาพสำหรับบอร์ดขนาดเล็กที่ไม่มีข้อความเท่านั้น หลังจากเปิดเมื่อมีการติดฉลากฉลากจะหมุนไปเป็นเส้นขนานกับขอบแนวนอนของฉลากและขอบคงที่ของบอร์ดขนาดเล็ก',
    ug: 'پەقەت تېكىستسىز كىچىك تاختىلارغا ئىشلىتىلىدۇ، قوزغىتىلغاندا، بەلگە قويۇشتا، بەلگە كەڭ چېگرىسى بىلەن كىچىك تاختا مۇقىم چېگرىسى پاراللېل بولۇش ئۈچۈن ئۆرۈلىدۇ',
    vi: 'Chỉ áp dụng cho bảng nhỏ không có kết cấu, khi bật, nhãn sẽ xoay sao cho cạnh ngang của nhãn song song với cạnh cố định của bảng nhỏ',
    zh_tc:
      '僅對無紋理小板生效，開啟後，貼標時，標籤會旋轉到標籤橫邊和小板固定邊平行',
    ru: 'Вступает в силу только для нетактурных панелей, и при открытии этикетка вращается параллельно поперечной стороне этикетки и фиксированной стороне пластины',
    ko: '텍스쳐 없는 보드에만 적용됩니다. 켜지면 태그가 태그 가로 및 보드 고정 모서리에 평행하게 회전합니다.',
    bur: 'အကြောမဲ့ပြားငယ်များအတွက်သာ။ ဖွင့်ပါကအညွှန်းကပ်သည့်အခါအညွှန်းအလျားဘက်နှင့်ပြားငယ်သတ်မှတ်ဘက်ပြိုင်လည်ပတ်မည်',
    ben: 'শুধুমাত্র টেক্সচারবিহীন ছোট বোর্ডের জন্য। সক্ষম করলে লেবেলিংয়ের সময় লেবেলের অনুভূমিক প্রান্ত ছোট বোর্ডের ফিক্সড প্রান্তের সাথে সারিবদ্ধভাবে ঘুরবে',
    tr: 'Yalnızca dokusuz küçük levhalar için geçerlidir. Açıkken etiketlemede etiket yatay kenarı küçük levhın sabit kenarıyla hizalanacak şekilde döner',
    km: 'មានប្រសិទ្ធភាពសម្រាប់តែផ្ទាំងតូចគ្មានវណ្ឌៈ។ បើបើក ពេលស្លាក ស្លាកនឹងបង្វិលឱ្យគែមផ្តេកស្របគែមថេរនៃផ្ទាំងតូច',
    es: 'Solo efectivo para tableros pequeños sin textura. Después de encenderlo, al etiquetar, la etiqueta girará hacia el borde horizontal de la etiqueta para quedar paralela al borde fijo del tablero pequeño',
    ar: 'فعالة فقط للألواح الصغيرة غير المزخرفة. بعد التشغيل، عند وضع الملصق، سيتم تدوير الملصق إلى الحافة الأفقية للملصق ليكون موازيًا للحافة الثابتة للوحة الصغيرة',
  },
  'cuttingDock.labelingSettings.tagHori': {
    zh: '标签横边',
    en: 'Label Horizontal Edge',
    id: 'Tag Border Horizontal',
    kz: 'Жапсырманың көлденең шеті',
    th: 'ติดแท็กเส้นขอบแนวนอน',
    ug: 'بەلگە كەڭ چېگرىسى',
    vi: 'Cạnh ngang của nhãn',
    zh_tc: '標籤橫邊',
    ru: 'Горизонтальная сторона метки',
    ko: '태그 가로변',
    bur: 'အညွှန်းအလျားဘက်',
    ben: 'লেবেল অনুভূমিক প্রান্ত',
    tr: 'Etiket yatay kenarı',
    km: 'គែមផ្តេកនៃស្លាក',
    es: 'Borde horizontal de la etiqueta',
    ar: 'حافة الملصق الأفقية',
  },
  'cuttingDock.labelingSettings.effectiveTarget': {
    zh: '生效对象',
    en: 'Target of Effectiveness',
    id: 'Obyek yang berlaku',
    kz: 'Өрекет ететін нысан',
    th: 'วัตถุประสงค์ที่มีผลบังคับใช้',
    ug: 'تەسىر كۆرسىتىدىگان نەڭ',
    vi: 'Đối tượng hiệu lực',
    zh_tc: '生效對象',
    ru: 'Объект вступления в силу',
    ko: '유효한 객체',
    bur: 'အကျိုးသက်ရောက်သည့်ပစ်မှတ်',
    ben: 'কার্যকারিতার লক্ষ্য',
    tr: 'Geçerlilik hedefi',
    km: 'គោលដៅនៃប្រសិទ្ធភាព',
    es: 'Objeto efectivo',
    ar: 'الكائن الفعال',
  },
  'cuttingDock.labelingSettings.allPlank': {
    zh: '所有小板',
    en: 'All Planks',
    id: 'Semua Papan',
    kz: 'Барлық тақталар',
    th: 'แผ่นไม้ทั้งหมด',
    ug: 'ھەممە تەختىچە',
    vi: 'Tất cả tấm ván',
    zh_tc: '所有小板',
    ru: 'Все доски',
    ko: '모든 보드',
    bur: 'ပြားငယ်အားလုံး',
    ben: 'সমস্ত তক্তা',
    tr: 'Tüm küçük levhalar',
    km: 'ផ្ទាំងតូចទាំងអស់',
    es: 'Todos los tableros pequeños',
    ar: 'جميع الألواح الصغيرة',
  },
  'cuttingDock.labelingSettings.notcarePlank': {
    zh: '仅无纹理小板',
    en: 'Texture-Free Planks Only',
    id: 'Hanya Papan Bebas Tekstur',
    kz: 'Тек ұнтақсыз тақталар',
    th: 'เฉพาะแผ่นไม้ไม่มีพื้นผิว',
    ug: 'پەقەت نەقىشسىز تەختىچە',
    vi: 'Chỉ tấm ván không vân',
    zh_tc: '僅無紋理小板',
    ru: 'Только без текстур.',
    ko: '텍스쳐 보드만 없음',
    bur: 'အကြောမဲ့ပြားငယ်များသာ',
    ben: 'শুধুমাত্র টেক্সচারবিহীন তক্তা',
    tr: 'Yalnızca dokusuz levhalar',
    km: 'តែផ្ទាំងគ្មានវណ្ឌៈ',
    es: 'Solo tableros pequeños sin textura',
    ar: 'فقط الألواح الصغيرة غير المزخرفة',
  },
  'cuttingDock.drillSettings.title': {
    zh: '排钻设置',
    en: 'Drilling Machine Settings',
    id: 'Pengaturan pengeboran',
    kz: 'Қалыптастыру бурғылау',
    th: 'การขุดเจาะ',
    ug: 'تەشىك تەڭشىكى',
    vi: 'Cài đặt khoan hàng',
    zh_tc: '排鑽設置',
    ru: 'Параметры бурения',
    ko: '드릴링 설정',
    bur: 'အပေါက်ဖောက်စက်သတ်မှတ်ချက်များ',
    ben: 'ড্রিলিং মেশিন সেটিংস',
    tr: 'Sıra matkap ayarları',
    km: 'ការកំណត់ម៉ាស៊ីនដោតជួរ',
    es: 'Configuración de perforación',
    ar: 'إعدادات الحفر',
  },
  'cuttingDock.drillSettings.enable': {
    zh: '启用排钻包',
    en: 'Enable Drilling Package',
    id: 'Aktifkan paket pengeboran',
    kz: 'Қалыптастыру бурғылау தொகімін іске қосу',
    th: 'เปิดใช้งานแพ็คเกจการขุดเจาะ',
    ug: 'تەشىك بوغچىسىنى قوزغىتىش',
    vi: 'Kích hoạt khoan hàng',
    zh_tc: '啟用排鑽包',
    ru: 'Включить дренажный пакет',
    ko: '드릴링 패키지 활성화',
    bur: 'အပေါက်ဖောက်ပက်ကေ့ချ်ဖွင့်ပါ',
    ben: 'ড্রিলিং প্যাকেজ সক্ষম করুন',
    tr: 'Sıra matkap paketini etkinleştir',
    km: 'បើកកញ្ចប់ដោតជួរ',
    es: 'Habilitar paquete de perforación',
    ar: 'تمكين حزمة الحفر',
  },
  'cuttingDock.drillSettings.toolTable.use': {
    zh: '启用',
    en: 'Enable',
    id: 'Memungkinkan',
    kz: 'Іске қосу',
    th: 'เปิดใช้งาน',
    ug: 'قوزغىتىش',
    vi: 'Kích hoạt',
    zh_tc: '啟用',
    ru: 'Активировать',
    ko: '활성화',
    bur: 'ဖွင့်ပါ',
    ben: 'সক্ষম করুন',
    tr: 'Etkinleştir',
    km: 'បើក',
    es: 'Habilitar',
    ar: 'تمكين',
  },
  'cuttingDock.drillSettings.toolTable.number2': {
    zh: '工位2排钻编号',
    en: 'Station 2 Drill Number',
    id: 'Workstation 2 Nomor Bor Baris',
    kz: 'Station 2 Drill Number',
    th: 'Workstation 2 แถวหมายเลขเจาะ',
    ug: 'پوچتا 2 تەشىك نومۇرى',
    vi: 'Station 2 Drill Number',
    zh_tc: '工位2排鑽編號',
    ru: 'Номер 2 - рядного бурения',
    ko: '작업 위치 2열 드릴 번호',
    bur: 'အလုပ်နေရာ ၂ အပေါက်ဖောက်နံပါတ်',
    ben: 'স্টেশন ২ ড্রিল নম্বর',
    tr: 'İstasyon 2 sıra matkap numarası',
    km: 'លេខដោតជួរស្ថានីយ៍ ២',
    es: 'Número de broca de fila de estación 2',
    ar: 'رقم حفر الصف الثاني للمحطة',
  },
  'cuttingDock.drillSettings.toolTable.number': {
    zh: '排钻编号',
    en: 'Drilling Machine Number',
    id: 'Nomor pengeboran',
    kz: 'Қалыптастыру бурғылау нөмірі',
    th: 'หมายเลขขุดเจาะ',
    ug: 'تەشىك نومۇرى',
    vi: 'Số khoan hàng',
    zh_tc: '排鑽編號',
    ru: 'Номер бурения',
    ko: '드릴링 번호',
    bur: 'အပေါက်ဖောက်နံပါတ်',
    ben: 'ড্রিলিং মেশিন নম্বর',
    tr: 'Sıra matkap numarası',
    km: 'លេខម៉ាស៊ីនដោតជួរ',
    es: 'Número de broca de fila',
    ar: 'رقم حفر الصف',
  },
  'cuttingDock.drillSettings.toolTable.diameter': {
    zh: '钻头直径',
    en: 'Drill Bit Diameter',
    id: 'Bor sedikit diameter',
    kz: 'Бургылаң діаметрі',
    th: 'เส้นผ่านศูนย์กลางบิตเจาะ',
    ug: 'تەشىك دىئامېتىرى',
    vi: 'Điện tích khoan',
    zh_tc: '鑽頭直徑',
    ru: 'Диаметр долота',
    ko: '드릴 지름',
    bur: 'အပေါက်ဖောက်ချွန်အချင်း',
    ben: 'ড্রিল বিট ব্যাস',
    tr: 'Matkap ucu çapı',
    km: 'អង្កត់ផ្ចិតគ្រាប់ដោត',
    es: 'Diámetro de broca',
    ar: 'قطر الحفر',
  },
  'cuttingDock.drillSettings.toolTable.xOffset': {
    zh: 'X偏移',
    en: 'X Offset',
    id: 'X Offset',
    kz: 'X ауысу',
    th: 'X ออฟเซ็ต',
    ug: 'X ئۆزگەرتىش',
    vi: 'Bị lệch X',
    zh_tc: 'X偏移',
    ru: 'Смещение X',
    ko: 'X 오프셋',
    bur: 'X ရွေ့ခြင်း',
    ben: 'X অফসেট',
    tr: 'X ofseti',
    km: 'ការផ្លាស់ទី X',
    es: 'X Desplazamiento',
    ar: 'X الإزاحة',
  },
  'cuttingDock.drillSettings.toolTable.yOffset': {
    zh: 'Y偏移',
    en: 'Y Offset',
    id: 'Y offset',
    kz: 'Y ауысу',
    th: 'y ชดเชย',
    ug: 'Y ئۆزگەرتىش',
    vi: 'Bị lệch Y',
    zh_tc: 'Y偏移',
    ru: 'Смещение Y',
    ko: 'Y 오프셋',
    bur: 'Y ရွေ့ခြင်း',
    ben: 'Y অফসেট',
    tr: 'Y ofseti',
    km: 'ការផ្លាស់ទី Y',
    es: 'Y Desplazamiento',
    ar: 'Y الإزاحة',
  },
  'cuttingDock.drillSettings.toolTable.moveZF': {
    zh: 'Z轴快速移动速度',
    en: 'Z-Axis Rapid Move Speed',
    id: 'Z-Axis Fast Moving Speed',
    kz: 'Z осьінің жылдам жылжымалы жылдамдығы',
    th: 'Z-Axis ความเร็วในการเคลื่อนที่เร็ว',
    ug: 'Z ئوكۇل تېز يۆتكىلىش سۈرئىتى',
    vi: 'Tốc độ di chuyển nhanh trục Z',
    zh_tc: 'Z軸快速移動速度',
    ru: 'Скорость быстрого перемещения по оси Z',
    ko: 'Z축 빠른 이동 속도',
    bur: 'Z ဝင်ရိုးအမြန်ရွေ့အမြန်နှုန်း',
    ben: 'Z-অক্ষ র্যাপিড মুভ স্পিড',
    tr: 'Z ekseni hızlı hareket hızı',
    km: 'ល្បឿនផ្លាស់ទីរហ័សអ័ក្ស Z',
    es: 'Z Velocidad de movimiento rápido del eje',
    ar: 'Z سرعة الحركة السريعة للمحور',
  },
  'cuttingDock.drillSettings.toolTable.feedRate': {
    zh: 'Z轴加工速度',
    en: 'Z-Axis Machining Speed',
    id: 'Kecepatan pemesinan sumbu Z',
    kz: 'Z осьінің өңдеу жылдамдығы',
    th: 'ความเร็วการตัดเฉือนแกน Z',
    ug: 'Z ئوكۇل ئىشلەش سۈرئىتى',
    vi: 'Tốc độ gia công trục Z',
    zh_tc: 'Z軸加工速度',
    ru: 'Скорость обработки по оси Z',
    ko: 'Z축 가공 속도',
    bur: 'Z ဝင်ရိုးပြုပြင်မှုအမြန်နှုန်း',
    ben: 'Z-অক্ষ মেশিনিং স্পিড',
    tr: 'Z ekseni işleme hızı',
    km: 'ល្បឿនដំណើរការអ័ក្ស Z',
    es: 'Z Velocidad de movimiento rápido del eje',
    ar: 'Z سرعة الحركة السريعة للمحور',
  },
  'cuttingDock.drillSettings.toolTable.moveF': {
    zh: 'XY轴快速移动速度',
    en: 'XY-Axis Rapid Move Speed',
    id: 'Kecepatan Gerakan Cepat Sumbu XY',
    kz: 'XY осьінің жылдам жылжымалы жылдамдығы',
    th: 'ความเร็วในการเคลื่อนที่เร็วของแกน xy',
    ug: 'XY ئوكۇل تېز يۆتكىلىش سۈرئىتى',
    vi: 'Tốc độ di chuyển nhanh trục XY',
    zh_tc: 'XY軸快速移動速度',
    ru: 'Скорость быстрого перемещения оси XY',
    ko: 'XY 축 빠른 이동 속도',
    bur: 'XY ဝင်ရိုးအမြန်ရွေ့အမြန်နှုန်း',
    ben: 'XY-অক্ষ র্যাপিড মুভ স্পিড',
    tr: 'XY ekseni hızlı hareket hızı',
    km: 'ល្បឿនផ្លាស់ទីរហ័សអ័ក្ស XY',
    es: 'XY Velocidad de movimiento rápido del eje',
    ar: 'XY سرعة الحركة السريعة للمحور',
  },
  'cuttingDock.drillSettings.toolTable.benchmarkDrill': {
    zh: '基准钻',
    en: 'Benchmark Drill',
    id: 'BATURAN BENCHMARK',
    kz: 'Бастапқы бурғы',
    th: 'สว่านเกณฑ์มาตรฐาน',
    ug: 'ئاساسلىق تەشىك',
    vi: 'Khoan chuẩn',
    zh_tc: '基準鑽',
    ru: 'Базовое бурение',
    ko: '데이텀 드릴',
    bur: 'အခြေခံအပေါက်ဖောက်',
    ben: 'বেঞ্চমার্ক ড্রিল',
    tr: 'Referans matkap',
    km: 'ដោតយោង',
    es: 'Taladro de referencia',
    ar: 'المثقاب المرجعي',
  },
  'cuttingDock.drillSettings.toolTable.addKnife': {
    zh: '添加刀具',
    en: 'Add Tool',
    id: 'Tambahkan alat',
    kz: 'Құрал қосу',
    th: 'เพิ่มเครื่องมือ',
    ug: 'پىچاق قوشۇش',
    vi: 'Thêm dao',
    zh_tc: '添加刀具',
    ru: 'Добавить нож',
    ko: '공구 추가',
    bur: 'ကိရိယာထည့်ပါ',
    ben: 'টুল যোগ করুন',
    tr: 'Takım ekle',
    km: 'បន្ថែមឧបករណ៍កាត់',
    es: 'Agregar herramienta',
    ar: 'إضافة أداة',
  },
  'cuttingDock.drillSettings.toolTable.deleteKnife': {
    zh: '删除刀具',
    en: 'Delete Tool',
    id: 'Hapus alat',
    kz: 'Құрал жою',
    th: 'ลบเครื่องมือ',
    ug: 'پىچاق ئۆچۈرۈش',
    vi: 'Xóa dao',
    zh_tc: '刪除刀具',
    ru: 'Удалить нож',
    ko: '공구 삭제',
    bur: 'ကိရိယာဖျက်ပါ',
    ben: 'টুল মুছুন',
    tr: 'Takımı sil',
    km: 'លុបឧបករណ៍កាត់',
    es: 'Eliminar herramienta',
    ar: 'أداة الحذف',
  },
  'cuttingDock.drillSettings.prefix': {
    zh: '排钻前缀',
    en: 'Drilling Machine Prefix',
    id: 'Awalan pengeboran',
    kz: 'Қалыптастыру бурғылау префикси',
    th: 'คำนำหน้าการขุดเจาะ',
    ug: 'تەشىك ئالدى قوشۇمچە',
    vi: 'Tiền tố khoan hàng',
    zh_tc: '排鑽前綴',
    ru: 'Префикс дрели',
    ko: '드릴링 접두사',
    bur: 'အပေါက်ဖောက်ရှေ့ဆက်',
    ben: 'ড্রিলিং মেশিন প্রিফিক্স',
    tr: 'Sıra matkap öneki',
    km: 'បុព្វបទដោតជួរ',
    es: 'Prefijo de perforación en fila',
    ar: 'بادئة حفر الصف',
  },
  'cuttingDock.drillSettings.suffix': {
    zh: '排钻后缀',
    en: 'Drilling Machine Suffix',
    id: 'Suffix Pengeboran',
    kz: 'Қалыптастыру бурғылау суффикси',
    th: 'คำต่อท้ายขุดเจาะ',
    ug: 'تەشىك كېڭەيتىلمىسى',
    vi: 'Hậu tố khoan hàng',
    zh_tc: '排鑽後綴',
    ru: 'Суффикс дрели',
    ko: '드릴 접미어 정렬',
    bur: 'အပေါက်ဖောက်နောက်ဆက်',
    ben: 'ড্রিলিং মেশিন সাফিক্স',
    tr: 'Sıra matkap son eki',
    km: 'បច្ច័យដោតជួរ',
    es: 'Sufijo de perforación en fila',
    ar: 'لاحقة حفر الصف',
  },
  'cuttingDock.drillSettings.startCode': {
    zh: '排钻启动代码',
    en: 'Drilling Machine Start Code',
    id: 'Kode Mulai Pengeboran',
    kz: 'Қалыптастыру бурғылау іске қосу коды',
    th: 'รหัสเริ่มการขุดเจาะ',
    ug: 'تەشىك باشلانغۇچ كودى',
    vi: 'Mã khởi động khoan hàng',
    zh_tc: '排鑽啟動代碼',
    ru: 'Код запуска дрели',
    ko: '드릴링 부팅 코드',
    bur: 'အပေါက်ဖောက်စတင်ကုဒ်',
    ben: 'ড্রিলিং মেশিন স্টার্ট কোড',
    tr: 'Sıra matkap başlangıç kodu',
    km: 'កូដចាប់ផ្តើមដោតជួរ',
    es: 'Código de inicio de perforación en fila',
    ar: 'رمز بداية حفر الصف',
  },
  'cuttingDock.drillSettings.endCode': {
    zh: '排钻结束代码',
    en: 'Drilling Machine End Code',
    id: 'Kode akhir pengeboran',
    kz: 'Қалыптастыру бурғылау тоқтату коды',
    th: 'รหัสปลายเจาะ',
    ug: 'تەشىك ئاخىرلاشقۇچ كودى',
    vi: 'Mã kết thúc khoan hàng',
    zh_tc: '排鑽結束代碼',
    ru: 'Код окончания бурения',
    ko: '드릴링 종료 코드',
    bur: 'အပေါက်ဖောက်အဆုံးကုဒ်',
    ben: 'ড্রিলিং মেশিন এন্ড কোড',
    tr: 'Sıra matkap bitiş kodu',
    km: 'កូដបញ្ចប់ដោតជួរ',
    es: 'Código de fin de perforación en fila',
    ar: 'رمز نهاية حفر الصف',
  },
  'cuttingDock.drillSettings.combineKnife': {
    zh: '排钻组合下刀',
    en: 'Combined Drilling Machine Cuts',
    id: 'Pemotong kombinasi pengeboran',
    kz: 'Қалыптастыру бурғылау біріктіру',
    th: 'คัตเตอร์รวมกัน',
    ug: 'تەشىك بىرلەشتۈرۈپ چۈشۈرۈش',
    vi: 'Khoan hàng kết hợp',
    zh_tc: '排鑽組合下刀',
    ru: 'Коллективный нож',
    ko: '드릴링 조합 언더핸드',
    bur: 'အပေါက်ဖောက်ပေါင်းစပ်ဖြတ်ချက်',
    ben: 'কম্বাইন্ড ড্রিলিং মেশিন কাট',
    tr: 'Birleşik sıra matkap kesimi',
    km: 'ការកាត់ដោតជួររួមបញ្ចូល',
    es: 'Corte combinado de perforación en fila',
    ar: 'القطع المشترك لحفر الصف',
  },
  'cuttingDock.drillSettings.combineTable.prefix': {
    zh: '排钻编号前缀',
    en: 'Drilling Machine Number Prefix',
    id: 'Awalan nomor bor',
    kz: 'Қалыптастыру бурғылау нөмірінің префикси',
    th: 'คำนำหน้าหมายเลขเจาะ',
    ug: 'تەشىك نومۇرى ئالدى قوشۇمچە',
    vi: 'Tiền tố số khoan hàng',
    zh_tc: '排鑽編號前綴',
    ru: 'Префикс номера дрели',
    ko: '드릴링 번호 접두사',
    bur: 'အပေါက်ဖောက်နံပါတ်ရှေ့ဆက်',
    ben: 'ড্রিলিং মেশিন নম্বর প্রিফিক্স',
    tr: 'Sıra matkap numarası öneki',
    km: 'បុព្វបទលេខដោតជួរ',
    es: 'Prefijo de número de perforación en fila',
    ar: 'بادئة رقم حفر الصف',
  },
  'cuttingDock.drillSettings.combineTable.suffix': {
    zh: '排钻编号后缀',
    en: 'Drilling Machine Number Suffix',
    id: 'Suffix nomor bor',
    kz: 'Қалыптастыру бурғылау нөмірінің суффикси',
    th: 'สว่านหมายเลขต่อท้าย',
    ug: 'تەشىك نومۇرى كېڭەيتىلمىسى',
    vi: 'Hậu tố số khoan hàng',
    zh_tc: '排鑽編號後綴',
    ru: 'Суффикс номера бурения',
    ko: '드릴링 번호 접미어',
    bur: 'အပေါက်ဖောက်နံပါတ်နောက်ဆက်',
    ben: 'ড্রিলিং মেশিন নম্বর সাফিক্স',
    tr: 'Sıra matkap numarası son eki',
    km: 'បច្ច័យលេខដោតជួរ',
    es: 'Sufijo de número de perforación en fila',
    ar: 'لاحقة رقم حفر الصف',
  },
  'cuttingDock.drillSettings.combineTable.mainHole': {
    zh: '主孔',
    en: 'Main Hole',
    id: 'Lubang utama',
    kz: 'Негізгі тесік',
    th: 'รูหลัก',
    ug: 'ئاساسلىق تەشىك',
    vi: 'Lỗ chính',
    zh_tc: '主孔',
    ru: 'Главное отверстие',
    ko: '주 구멍',
    bur: 'အဓိကအပေါက်',
    ben: 'মেইন হোল',
    tr: 'Ana delik',
    km: 'រន្ធមេ',
    es: 'Agujero principal',
    ar: 'الثقب الرئيسي',
  },
  'cuttingDock.drillSettings.combineTable.extraHole': {
    zh: '从孔',
    en: 'Extra Hole',
    id: 'Dari lubang',
    kz: 'Қосымша тесік',
    th: 'จากหลุม',
    ug: 'قوشۇمچە تەشىك',
    vi: 'Lỗ phụ',
    zh_tc: '從孔',
    ru: 'Из отверстия',
    ko: '구멍에서',
    bur: 'အခြားအပေါက်',
    ben: 'এক্সট্রা হোল',
    tr: 'Yan delik',
    km: 'រន្ធបន្ថែម',
    es: 'Agujero esclavo',
    ar: 'الحفرة التابعة',
  },
  'cuttingDock.drillSettings.combineTable.notes': {
    zh: '组合注释',
    en: 'Combined Notes',
    id: 'Komentar Kombinasi',
    kz: 'Біріктіру туралы ескерту',
    th: 'ความคิดเห็นรวมกัน',
    ug: 'بىرلەشتۈرۈش ئىزاھاتى',
    vi: 'Ghi chú kết hợp',
    zh_tc: '組合註釋',
    ru: 'Комбинированные примечания',
    ko: '주석 조합',
    bur: 'ပေါင်းစပ်မှတ်ချက်',
    ben: 'কম্বাইন্ড নোট',
    tr: 'Birleşik notlar',
    km: 'កំណត់ចំណាំរួម',
    es: 'Comentario de combinación',
    ar: 'تعليق مختلط',
  },
  'cuttingDock.drillSettings.combineTable.firstUseNotes': {
    zh: '首次启用注释',
    en: 'First Use Notes',
    id: 'Aktifkan komentar untuk pertama kalinya',
    kz: 'Біріктіруді алғашқы рет іске қосу туралы ескерту',
    th: 'เปิดใช้งานความคิดเห็นเป็นครั้งแรก',
    ug: 'بىرىنچى قېتىم قوزغىتىش ئىزاھاتى',
    vi: 'Ghi chú kích hoạt lần đầu',
    zh_tc: '首次啟用註釋',
    ru: 'Впервые включено примечание',
    ko: '처음으로 주석 사용',
    bur: 'ပထမအသုံးမှတ်ချက်',
    ben: 'প্রথম ব্যবহার নোট',
    tr: 'İlk kullanım notları',
    km: 'កំណត់ចំណាំប្រើលើកដំបូង',
    es: 'Habilitar anotaciones por primera vez',
    ar: 'تمكين التعليقات التوضيحية لأول مرة',
  },
  'cuttingDock.drillSettings.combineTable.addExtraHole': {
    zh: '添加从孔',
    en: 'Add Extra Hole',
    id: 'Tambahkan dari lubang',
    kz: 'Қосымша тесік қосу',
    th: 'เพิ่มจากหลุม',
    ug: 'قوشۇمچە تەشىك قوشۇش',
    vi: 'Thêm lỗ phụ',
    zh_tc: '添加從孔',
    ru: 'Добавить из отверстия',
    ko: '종동체 구멍 추가',
    bur: 'အခြားအပေါက်ထည့်ပါ',
    ben: 'এক্সট্রা হোল যোগ করুন',
    tr: 'Yan delik ekle',
    km: 'បន្ថែមរន្ធបន្ថែម',
    es: 'Agregar agujeros esclavos',
    ar: 'إضافة ثقوب تابعة',
  },
  'cuttingDock.drillSettings.combineTable.deleteExtraHole': {
    zh: '删除从孔',
    en: 'Delete Extra Hole',
    id: 'Hapus dari lubang',
    kz: 'Қосымша тесік жою',
    th: 'ลบออกจากหลุม',
    ug: 'قوشۇمچە تەشىك ئۆچۈرۈش',
    vi: 'Xóa lỗ phụ',
    zh_tc: '刪除從孔',
    ru: 'Удалить из отверстия',
    ko: '종동체 구멍 삭제',
    bur: 'အခြားအပေါက်ဖျက်ပါ',
    ben: 'এক্সট্রা হোল মুছুন',
    tr: 'Yan deliği sil',
    km: 'លុបរន្ធបន្ថែម',
    es: 'Eliminar agujeros esclavos',
    ar: 'حذف الثقوب التابعة',
  },
  'cuttingDock.drillSettings.combineTable.example': {
    zh: '样例',
    en: 'Example',
    id: 'Mencicipi',
    kz: 'Үлгі',
    th: 'ตัวอย่าง',
    ug: 'مىسال',
    vi: 'Ví dụ',
    zh_tc: '樣例',
    ru: 'Пример',
    ko: '예제',
    bur: 'နမူနာ',
    ben: 'উদাহরণ',
    tr: 'Örnek',
    km: 'ឧទាហរណ៍',
    es: 'Ejemplo',
    ar: 'مثال',
  },
  'cuttingDock.drillSettings.tagPool.drillRowNumber': {
    zh: '排钻编号',
    en: 'Drill row number',
    id: 'Nomor baris bor',
    kz: 'Бұрғылау қатарының нөмірі',
    th: 'หมายเลขแถวเจาะ',
    ug: 'بورغۇ قاتار نومۇرى',
    vi: 'Số hàng khoan',
    zh_tc: '排鑽編號',
    ru: 'Номер бурения',
    ko: '드릴링 번호',
    bur: 'အပေါက်ဖောက်တန်းနံပါတ်',
    ben: 'ড্রিল সারি নম্বর',
    tr: 'Sıra matkap numarası',
    km: 'លេខជួរដោត',
    es: 'Número de broca de fila',
    ar: 'رقم حفر الصف',
  },
  'cuttingDock.drillSettings.processSetting.title': {
    zh: '加工设置',
    en: 'Processing Settings',
    id: 'Pengaturan pemrosesan',
    kz: 'Өңдеу параметрлері',
    th: 'การตั้งค่าการประมวลผล',
    ug: 'ئىشلەش تەڭشىكى',
    vi: 'Cài đặt gia công',
    zh_tc: '加工設定',
    ru: 'Параметры обработки',
    ko: '가공 설정',
    bur: 'ပြုပြင်မှုသတ်မှတ်ချက်များ',
    ben: 'প্রক্রিয়াকরণ সেটিংস',
    tr: 'İşleme ayarları',
    km: 'ការកំណត់ដំណើរការ',
    es: 'Configuraciones de procesamiento',
    ar: 'إعدادات المعالجة',
  },
  'cuttingDock.drillSettings.processSetting.mode': {
    zh: '排钻加工模式',
    en: 'Drilling Machine Processing Mode',
    id: 'Mode Pemrosesan Pengeboran',
    kz: 'Қалыптастыру бурғылау режимі',
    th: 'โหมดการขุดเจาะ',
    ug: 'تەشىك ئىشلەش ئۇسۇلى',
    vi: 'Chế độ gia công khoan hàng',
    zh_tc: '排鑽加工模式',
    ru: 'Режим дренажной обработки',
    ko: '드릴링 가공 모드',
    bur: 'အပေါက်ဖောက်ပြုပြင်မုဒ်',
    ben: 'ড্রিলিং মেশিন প্রক্রিয়াকরণ মোড',
    tr: 'Sıra matkap işleme modu',
    km: 'ម៉ូដដំណើរការដោតជួរ',
    es: 'Modo de procesamiento de perforación en hileras',
    ar: 'وضع معالجة حفر الصف',
  },
  'cuttingDock.drillSettings.processSetting.processTip': {
    zh: '选用此方式后就不生效排钻组合下刀功能',
    en: 'This feature will not be effective when selecting this mode',
    id: 'Setelah memilih metode ini, fungsi pemotongan kombinasi pengeboran dan pengeboran tidak akan berlaku.',
    kz: 'Бұл әдістің іске қосудан кейін қалыптастыру бурғылау біріктіру функциясы іске қосылмайды',
    th: 'หลังจากเลือกวิธีนี้ฟังก์ชั่นการตัดการขุดเจาะและการขุดเจาะจะไม่มีผล',
    ug: 'بۇ ئۇسۇلنى تاللىسىڭىز تەشىك بىرلەشتۈرۈپ چۈشۈرۈش فۇنكسىيىسى ئىشلەتمەيدۇ',
    vi: 'Sau khi chọn phương thức này, chức năng khoan hàng kết hợp sẽ không có hiệu lực',
    zh_tc: '選用此方式後就不生效排鑽組合下刀功能',
    ru: 'После выбора этого способа не вступает в силу функция дренажа',
    ko: '이 방식을 선택하면 드릴링 조합 하도 기능이 적용되지 않습니다',
    bur: 'ဤမုဒ်ရွေးပါကအပေါက်ဖောက်ပေါင်းစပ်ဖြတ်ချက်အင်္ဂါရပ်အကျိုးမသက်ရောက်ပါ',
    ben: 'এই মোড সিলেক্ট করলে এই ফিচার কার্যকর হবে না',
    tr: 'Bu mod seçildiğinde birleşik sıra matkap kesimi özelliği geçerli olmaz',
    km: 'មុខងារកាត់ដោតជួររួមមិនមានប្រសិទ្ធភាពនៅពេលជ្រើសម៉ូដនេះ',
    es: 'La selección de este método no tendrá efecto. La función de corte combinado de perforación en hileras no tendrá efecto',
    ar: 'لن يصبح تحديد هذه الطريقة ساري المفعول. لن يتم تفعيل وظيفة القطع المجمعة لحفر الصف',
  },
  'cuttingDock.drillSettings.processSetting.recentHole': {
    zh: '就近打孔（快速换刀）',
    en: 'Drill Nearby Holes (Rapid Tool Change)',
    id: 'Lubang pukulan di dekatnya (perubahan alat cepat)',
    kz: 'Жақын жерде тесік іздеу (бұрғыларды тез ауыстыру)',
    th: 'เจาะรูใกล้ ๆ (เปลี่ยนเครื่องมือด่วน)',
    ug: 'يېقىن تەشىك (تېز پىچاق ئالماشتۇرۇش)',
    vi: 'Khoan gần (thay dao nhanh)',
    zh_tc: '就近打孔（快速換刀）',
    ru: 'Ближайшая перфорация (быстрая смена ножа)',
    ko: '가까운 곳에서 펀치 (빠른 패스)',
    bur: 'အနီးကပ်အပေါက်ဖောက် (အမြန်ကိရိယာလဲ)',
    ben: 'কাছের গর্ত ড্রিল করুন (দ্রুত টুল পরিবর্তন)',
    tr: 'Yakındaki delikleri del (hızlı takım değişimi)',
    km: 'ដោតរន្ធក្បែរ (ប្តូរឧបករណ៍រហ័ស)',
    es: 'Taladre orificios cerca (cambio rápido de herramienta)',
    ar: 'حفر الثقوب القريبة (تغيير سريع للأداة)',
  },
  'cuttingDock.drillSettings.processSetting.groupHole': {
    zh: '按类打孔（完成一类孔再换刀）',
    en: 'Drill by Category (Change Tool After Completing a Category)',
    id: 'Lubang pukulan berdasarkan kategori (lengkapi jenis lubang pertama dan kemudian ubah alat)',
    kz: 'Топтама тесік іздеу (бір топтың тесіктерді іздегенде бұрғыларды ауыстыру)',
    th: 'เจาะรูตามหมวดหมู่ (ทำหลุมประเภทแรกให้เสร็จแล้วเปลี่ยนเครื่องมือ)',
    ug: 'تۈر بويىچە تەشىك (بىر تۈر تەشىك تاماملىغاندىن كېيىن پىچاق ئالماشتۇرۇش)',
    vi: 'Khoan theo loại (thay dao sau khi hoàn thành một loại lỗ)',
    zh_tc: '按類打孔（完成一類孔再換刀）',
    ru: 'Перфорация по классам (смена ножей после завершения перфорации по классу)',
    ko: '클래스별 구멍 뚫기 (일류 구멍 재교환 완료)',
    bur: 'အမျိုးအစားအလိုက်ဖောက် (တစ်မျိုးပြီးမှကိရိယာလဲ)',
    ben: 'ক্যাটাগরি অনুযায়ী ড্রিল করুন (এক ক্যাটাগরি সম্পূর্ণ করার পর টুল পরিবর্তন)',
    tr: 'Kategoriye göre del (bir kategori bitince takım değiştir)',
    km: 'ដោតតាមប្រភេទ (ប្តូរឧបករណ៍បន្ទាប់ពីបញ្ចប់មួយប្រភេទ)',
    es: 'Taladre orificios por categoría (completa un tipo de orificio antes de cambiar las herramientas)',
    ar: 'حفر الثقوب حسب الفئة (إكمال نوع الثقب قبل تغيير الأدوات)',
  },
  'cuttingDock.drillSettings.processSetting.drill_benchmark': {
    zh: '组合下刀基准',
    en: 'Combination of tool setting benchmarks',
    id: 'Kombinasi pengaturan alat',
    kz: 'Інструменттің бағыттамасы комбинациясы (Instrument direction combination)',
    th: 'จุดอ้างอิงการลงมีดแบบรวม',
    ug: 'بىرلەشتۈرۈپ چۈشۈرۈش ئاساسى',
    vi: 'Tổ hợp các tiêu chuẩn đặt dao',
    zh_tc: '組合下刀基準',
    ru: 'Комбинированная опора под нож',
    ko: '결합된 언더핸드 데이텀',
    bur: 'ကိရိယာသတ်မှတ်အခြေခံပေါင်းစပ်',
    ben: 'টুল সেটিং বেঞ্চমার্কের সংমিশ্রণ',
    tr: 'Birleşik kesim referansı',
    km: 'យោងការកាត់រួមបញ្ចូល',
    es: 'Referencia de corte combinado',
    ar: 'مرجع القطع المدمج',
  },
  'cuttingDock.drillSettings.processSetting.drill_benchmark_Tip': {
    zh: '（注意：选用此方式后就不生效排钻组合下刀功能）',
    en: '（Attention：After selecting this method, the drill combination tool setting function will not take effect）',
    id: '（Perhatian：Setelah memilih metode ini, fungsi pengaturan alat kombinasi pengeboran tidak akan berlaku）',
    kz: '（Диққат：Бу ыкманы танлагандан кейин, бур дрель комбинациясынын аспап бағыттамасы функциясы ишке ашпай калады）',
    th: '(หมายเหตุ: หลังจากเลือกวิธีนี้ ฟังก์ชันการลงมีดแบบรวมของสว่านจะไม่มีผล)',
    ug: '(دىققەت: بۇ ئۇسۇلنى تاللىسىڭىز تەشىك بىرلەشتۈرۈپ چۈشۈرۈش فۇنكسىيىسى ئىشلەتمەيدۇ)',
    vi: '（Chú ý：Sau khi chọn phương pháp này, chức năng thiết lập công cụ kết hợp khoan sẽ không có hiệu lực）',
    zh_tc: '（注意：選用此方式後就不生效排鑽組合下刀功能）',
    ru: '(Примечание: после выбора этого способа не вступает в силу функция бурения в комплекте)',
    ko: '(참고: 이 방법을 선택하면 드릴링 조합 하단 기능이 적용되지 않습니다.)',
    bur: '（သတိပြုပါ：ဤနည်းရွေးပါကအပေါက်ဖောက်ပေါင်းစပ်ကိရိယာသတ်မှတ်အင်္ဂါရပ်အကျိုးမသက်ရောက်ပါ）',
    ben: '（মন দিন：এই পদ্ধতি সিলেক্ট করার পর ড্রিল কম্বিনেশন টুল সেটিং ফাংশন কার্যকর হবে না）',
    tr: '(Dikkat: Bu yöntem seçildiğinde birleşik sıra matkap kesimi özelliği geçerli olmaz)',
    km: '(សម្គាល់៖ បន្ទាប់ពីជ្រើសវិធីនេះ មុខងារកាត់ដោតជួររួមមិនមានប្រសិទ្ធភាពទេ)',
    es: '(Nota: Después de seleccionar este método, la función de corte combinado de perforación en hileras no tendrá efecto)',
    ar: '(ملاحظة: بعد تحديد هذه الطريقة، لن تصبح وظيفة القطع المجمعة لحفر الصف نافذة المفعول)',
  },
  'cuttingDock.drillSettings.processSetting.mainHole': {
    zh: '以主孔',
    en: 'Main hole',
    id: 'Lubang utama',
    kz: 'Бас бөлшек (Base section)',
    th: 'ตามรูหลัก',
    ug: 'ئاساسلىق تەشىك',
    vi: 'Lỗ chính',
    zh_tc: '以主孔',
    ru: 'Главное отверстие',
    ko: '홈 구멍으로',
    bur: 'အဓိကအပေါက်',
    ben: 'মেইন হোল',
    tr: 'Ana delik',
    km: 'រន្ធមេ',
    es: 'Utilice el orificio principal',
    ar: 'استخدم الثقب الرئيسي',
  },
  'cuttingDock.drillSettings.processSetting.secondaryHole': {
    zh: '以从孔（尾孔）',
    en: 'Secondary hole (Tail hole)',
    id: 'Lubang tambahan (Lubang ekor)',
    kz: ' Көмек бөлшек (Auxiliary section)',
    th: 'ตามรูรอง (รูท้าย)',
    ug: 'قوشۇمچە تەشىك (ئاخىرقى تەشىك)',
    vi: 'Lỗ phụ (Lỗ đuôi)',
    zh_tc: '以從孔（尾孔）',
    ru: 'Чтобы из отверстия (хвостовое отверстие)',
    ko: '종속 구멍 (꼬리 구멍)',
    bur: 'အခြားအပေါက် (အမြီးအပေါက်)',
    ben: 'সেকেন্ডারি হোল (টেইল হোল)',
    tr: 'Yan delik (kuyruk deliği)',
    km: 'រន្ធបន្ថែម (រន្ធកន្ទុយ)',
    es: 'Desde el orificio (agujero trasero)',
    ar: 'من الفتحة (ثقب الذيل)',
  },
  'cuttingDock.drillSettings.changeBenchDrillTip': {
    zh: '请输入排钻编号再进行此选择',
    en: 'Please enter the drilling machine number before making this selection',
    id: 'Harap masukkan nomor pengeboran sebelum memilih ini',
    kz: 'Қалыптастыру бурғылау нөміріне енгізіңіз содан кейін таңдау',
    th: 'โปรดป้อนหมายเลขการขุดเจาะก่อนเลือกสิ่งนี้',
    ug: 'تەشىك نومۇرىنى كىرگۈزۈپ بۇ تاللاشنى ئېلىپ بارىڭ',
    vi: 'Vui lòng nhập số khoan hàng trước khi thực hiện lựa chọn này',
    zh_tc: '請輸入排鑽編號再進行此選擇',
    ru: 'Пожалуйста, введите номер бурения для этого выбора.',
    ko: '다이아 번호를 입력하고 선택하십시오.',
    bur: 'ဤရွေးချယ်မှုမပြုမီအပေါက်ဖောက်နံပါတ်ထည့်ပါ',
    ben: 'এই সিলেকশন করার আগে ড্রিলিং মেশিন নম্বর লিখুন',
    tr: 'Bu seçimi yapmadan önce sıra matkap numarasını girin',
    km: 'សូមបញ្ចូលលេខម៉ាស៊ីនដោតជួរមុនពេលធ្វើការជ្រើសនេះ',
    es: 'Ingrese el número de perforación en hilera antes de hacer esta selección',
    ar: 'يرجى إدخال رقم حفر الصف قبل إجراء هذا التحديد',
  },
  'cuttingDock.NCExportSettings.jumpSkipTip2': {
    zh: '根据大板颜色，厚度，材质归为不同文件夹（贴标文件一起），同尺寸大板下料文件放在同一个文件夹',
    en: 'Classify into different folders by large board color, thickness, and material (including labeling files), and place cutting material files of the same size large board in the same folder',
    id: 'Mengklasifikasikan ke dalam folder yang berbeda berdasarkan warna, ketebalan, dan material papan besar (termasuk file pelabelan), dan menempatkan file pemotongan material papan besar dengan ukuran yang sama dalam folder yang sama',
    kz: 'Үлкен тақта түсі, қалыңдығы және материал бойынша әртүрлі қалталарға жіктеу (белгілеу файлдарымен бірге), бірдей өлшемдегі үлкен тақтаның кесу материал файлдарын бір қалтаға орналастыру',
    th: 'จัดหมวดหมู่เป็นโฟลเดอร์ต่างๆ ตามสี ความหนา และวัสดุของบอร์ดใหญ่ (รวมไฟล์ติดป้าย) และวางไฟล์ตัดวัสดุของบอร์ดใหญ่ขนาดเดียวกันในโฟลเดอร์เดียวกัน',
    ug: 'چوڭ تاختا رەڭى، قىلىنلىقى ۋە ماتېرىيالى بويىچە تۈرلۈك مۇندەرىجىلەرگە تەقسىملەش (بەلگە قويۇش ھۆججەتلىرى بىلەن بىللە)، ئوخشاش ئۆلچەمدىكى چوڭ تاختا كېسىش ماتېرىيالى ھۆججەتلىرىنى بىر مۇندەرىجىگە قويۇش',
    vi: 'Phân loại vào các thư mục khác nhau theo màu sắc, độ dày và chất liệu của tấm lớn (bao gồm cả tệp dán nhãn), và đặt các tệp cắt vật liệu của tấm lớn cùng kích thước vào cùng một thư mục',
    zh_tc:
      '根據大板顏色，厚度，材質歸為不同文件夾（貼標文件一起），同尺寸大板下料文件放在同一個文件夾',
    ru: 'В зависимости от цвета и толщины большой доски, материал делится на разные папки (вместе с файлом с наклейкой), а файл с большой доской того же размера помещается в одну и ту же папку',
    ko: '재료는 대시보드 색상, 두께에 따라 다른 폴더로 분류됩니다 (태그 부착 파일과 함께). 동일한 크기의 대시보드 원단 파일은 같은 폴더에 배치됩니다.',
    bur: 'ကြီးမားသောပြားအရောင်၊ ထူအမျိုးအစား၊ ပစ္စည်းအလိုက်မတူညီသောဖိုလ်ဒါများခွဲပါ (အညွှန်းဖိုင်များပါ)၊ အရွယ်တူကြီးပြားဖြတ်စာဖိုင်များကိုတစ်ဖိုလ်ဒါတွင်ထားပါ',
    ben: 'বড় বোর্ড রঙ, বেধ ও ম্যাটেরিয়াল অনুযায়ী বিভিন্ন ফোল্ডারে ভাগ করুন (লেবেলিং ফাইল সহ), একই সাইজের বড় বোর্ডের কাটিং ম্যাটেরিয়াল ফাইল একই ফোল্ডারে রাখুন',
    tr: 'Büyük levha rengi, kalınlığı ve malzemesine göre farklı klasörlere ayırın (etiket dosyaları dahil); aynı boyuttaki büyük levhaların kesim dosyalarını aynı klasöre koyun',
    km: 'ចាត់ថតផ្សេងៗតាមពណ៌ កម្រាស់ និងសម្ភារៈផ្ទាំងធំ (រួមឯកសារស្លាក) ហើយដាក់ឯកសារកាត់ផ្ទាំងធំទំហំដូចគ្នានៅក្នុងថតដូចគ្នា',
    es: 'Según el color, el grosor y el material de la placa grande, se clasifican en diferentes carpetas (etiquetando archivos juntos) y los archivos de corte de placas grandes del mismo tamaño se colocan en la misma carpeta',
    ar: 'وفقًا للون اللوحة الكبيرة وسمكها ومادتها، يتم تصنيفها إلى مجلدات مختلفة (وضع العلامات معًا)، ويتم وضع ملفات تقطيع اللوحة الكبيرة من نفس الحجم في نفس المجلد',
  },
  'cuttingDock.NCExportSettings.title': {
    zh: 'NC导出设置',
    en: 'NC Export Settings',
    id: 'Pengaturan Ekspor NC',
    kz: 'NC экспорттау параметрлері',
    th: 'การตั้งค่าการส่งออก NC',
    ug: 'NC چىقىرىش تەڭشىكى',
    vi: 'Cài đặt Xuất NC',
    zh_tc: 'NC導出設置',
    ru: 'Параметры экспорта NC',
    ko: 'NC 내보내기 설정',
    bur: 'NC ထုတ်သတ်မှတ်ချက်များ',
    ben: 'NC এক্সপোর্ট সেটিংস',
    tr: 'NC dışa aktarma ayarları',
    km: 'ការកំណត់នាំចេញ NC',
    es: 'NC Configuración de exportación',
    ar: 'NC إعدادات التصدير',
  },
  'cuttingDock.NCExportSettings.tab1': {
    zh: '开料机文件名设置',
    en: 'Nesting Machine File Name Settings',
    id: 'Pengaturan Nama File Mesin Pemotongan',
    kz: 'Кескіш машинасының файл атау параметрлері',
    th: 'ตัดการตั้งค่าชื่อไฟล์เครื่อง',
    ug: 'ئۆيۈچۈ ھۆججەت ئىسمى تەڭشىكى',
    vi: 'Cài đặt Tên Tệp Máy Khoan',
    zh_tc: '開料機文件名設置',
    ru: 'Настройка имени файла распылителя',
    ko: '원료 공급기 파일 이름 설정',
    bur: 'ဖြတ်စက်ဖိုင်အမည်သတ်မှတ်ချက်များ',
    ben: 'নেস্টিং মেশিন ফাইল নাম সেটিংস',
    tr: 'Kesim makinesi dosya adı ayarları',
    km: 'ការកំណត់ឈ្មោះឯកសារម៉ាស៊ីនកាត់',
    es: 'Configuración del nombre de archivo de la máquina de corte',
    ar: 'إعدادات اسم ملف آلة القطع',
  },
  'cuttingDock.NCExportSettings.tab2': {
    zh: '开料机文件名合并',
    en: 'Nesting Machine File Name Merging',
    id: 'Gabungkan nama file pemotong',
    kz: 'Кескіш машинасының файл атау біріктіру',
    th: 'รวมชื่อไฟล์ของเครื่องตัด',
    ug: 'ئۆيۈچۈ ھۆججەت بىرلەشتۈرۈش',
    vi: 'Hợp Nhất Tên Tệp Máy Khoan',
    zh_tc: '開料機文件名合併',
    ru: 'Объединение имен файлов распылителя',
    ko: '원료 공급기 파일 이름 병합',
    bur: 'ဖြတ်စက်ဖိုင်အမည်ပေါင်းခြင်း',
    ben: 'নেস্টিং মেশিন ফাইল নাম মার্জিং',
    tr: 'Kesim makinesi dosya adı birleştirme',
    km: 'ការរួមឈ្មោះឯកសារម៉ាស៊ីនកាត់',
    es: 'Los nombres de los archivos de la máquina de corte se fusionan',
    ar: 'دمج أسماء ملفات آلة القطع',
  },
  'cuttingDock.NCExportSettings.tab3': {
    zh: '开料机文件中注释',
    en: 'Nesting Machine File Comments',
    id: 'Catatan dalam file mesin pemotong',
    kz: 'Кескіш машинасының файлындағы ескерту',
    th: 'หมายเหตุในไฟล์เครื่องตัด',
    ug: 'ئۆيۈچۈ ھۆججىتىدىكى ئىزاھات',
    vi: 'Ghi chú Trong Tệp Máy Khoan',
    zh_tc: '開料機文件中註釋',
    ru: 'Примечания в файле распылителя',
    ko: '재료 공급 파일의 주석',
    bur: 'ဖြတ်စက်ဖိုင်မှတ်ချက်များ',
    ben: 'নেস্টিং মেশিন ফাইল কমেন্ট',
    tr: 'Kesim makinesi dosyasındaki yorumlar',
    km: 'កំណត់ចំណាំក្នុងឯកសារម៉ាស៊ីនកាត់',
    es: 'Comentarios en los archivos de la máquina de corte',
    ar: 'التعليقات في ملفات آلة القطع',
  },
  'cuttingDock.NCExportSettings.tab4': {
    zh: '开料机文件中类型',
    en: 'Nesting Machine File Types',
    id: 'Jenis dalam file mesin pemotong',
    kz: 'Кескіш машинасының файлындағы тип',
    th: 'ประเภทในไฟล์เครื่องตัด',
    ug: 'ئۆيۈچۈ ھۆججىتىدىكى تۈر',
    vi: 'Loại Tệp Máy Khoan',
    zh_tc: '開料機文件中類型',
    ru: 'Тип в файле открывателя',
    ko: '재료 공급기 파일의 유형',
    bur: 'ဖြတ်စက်ဖိုင်အမျိုးအစားများ',
    ben: 'নেস্টিং মেশিন ফাইল টাইপ',
    tr: 'Kesim makinesi dosyasındaki türler',
    km: 'ប្រភេទក្នុងឯកសារម៉ាស៊ីនកាត់',
    es: 'El tipo',
    ar: 'النوع',
  },
  'cuttingDock.NCExportSettings.tab5': {
    zh: '开料机文件夹',
    en: 'Nesting Machine File Folders',
    id: 'Folder mesin pemotong',
    kz: 'Кескіш машинасының файл қапшығы',
    th: 'โฟลเดอร์เครื่องตัด',
    ug: 'ئۆيۈچۈ قىسقۇچ',
    vi: 'Thư mục Máy Khoan',
    zh_tc: '開料機文件夾',
    ru: 'Папка открывающего устройства',
    ko: '원료 공급기 폴더',
    bur: 'ဖြတ်စက်ဖိုလ်ဒါများ',
    ben: 'নেস্টিং মেশিন ফাইল ফোল্ডার',
    tr: 'Kesim makinesi klasörleri',
    km: 'ថតឯកសារម៉ាស៊ីនកាត់',
    es: 'en el archivo de apertura es la carpeta de apertura',
    ar: 'في الملف الافتتاحي هو المجلد الافتتاحي',
  },
  'cuttingDock.NCExportSettings.tab6': {
    zh: '加工指令设置',
    en: 'Processing Instruction Settings',
    id: 'Memproses Pengaturan Perintah',
    kz: 'Өңдеу指令 параметрлері',
    th: 'การตั้งค่าคำสั่งประมวลผล',
    ug: 'ئىشلەش بۇيرۇقى تەڭشىكى',
    vi: 'Cài đặt Chỉ Dẫn Gia Công',
    zh_tc: '加工指令設置',
    ru: 'Параметры команды обработки',
    ko: '가공 명령 설정',
    bur: 'ပြုပြင်ညွှန်ကြားချက်သတ်မှတ်ချက်များ',
    ben: 'প্রক্রিয়াকরণ নির্দেশনা সেটিংস',
    tr: 'İşleme komutu ayarları',
    km: 'ការកំណត់ពាក្យបញ្ជាដំណើរការ',
    es: 'Configuración de instrucciones de procesamiento',
    ar: 'إعداد تعليمات المعالجة',
  },
  'cuttingDock.NCExportSettings.tab7': {
    zh: '文件格式设置',
    en: 'File Format Settings',
    id: 'Pengaturan Format File',
    kz: 'Файл пішімі параметрлері',
    th: 'การตั้งค่ารูปแบบไฟล์',
    ug: 'ھۆججەت فورماتى تەڭشىكى',
    vi: 'Cài đặt Định Dạng Tệp',
    zh_tc: '文件格式設置',
    ru: 'Параметры формата файла',
    ko: '파일 형식 설정',
    bur: 'ဖိုင်ဖော်မတ်သတ်မှတ်ချက်များ',
    ben: 'ফাইল ফরম্যাট সেটিংস',
    tr: 'Dosya biçimi ayarları',
    km: 'ការកំណត់ទ្រង់ទ្រាយឯកសារ',
    es: 'Configuración de formato de archivo',
    ar: 'إعداد تنسيق الملف',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.twoStationAutoSort': {
    zh: '双工位自动排序',
    en: 'Automatic Sorting for Dual Stations',
    id: 'Pemilahan Stasiun Ganda Otomatis',
    kz: 'Екі орны автоматты сұрыптау',
    th: 'การเรียงลำดับสองสถานีอัตโนมัติ',
    ug: 'ئىككى پوچتا ئاپتوماتىك تەرتىپلەش',
    vi: 'Tự động Sắp Xếp Đôi Công Vị',
    zh_tc: '雙工位自動排序',
    ru: 'двухпозиционная автоматическая сортировка',
    ko: '이중 비트 자동 정렬',
    bur: 'နှစ်နေရာအလိုအလျောက်စီခြင်း',
    ben: 'দ্বৈত স্টেশনের জন্য স্বয়ংক্রিয় সর্টিং',
    tr: 'Çift istasyon otomatik sıralama',
    km: 'ការតម្រៀបស្វ័យប្រវត្តិសម្រាប់ពីរស្ថានីយ៍',
    es: 'Clasificación automática de estación doble',
    ar: 'الفرز التلقائي لمحطة مزدوجة',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.reparation': {
    zh: '大板序号位数补偿到',
    en: 'Compensate the Number of Digits for Panel Serial Numbers to',
    id: 'Jumlah nomor papan besar dikompensasi',
    kz: 'Болшақтаның нөмірінің цифрліктарды толықтыру',
    th: 'จำนวนบอร์ดจำนวนมากได้รับการชดเชย',
    ug: 'چوڭ تاختا تەرتىپ نومۇرىنى تولدۇرۇش',
    vi: 'Bù Số Thứ Tự Đa Tầng Đến',
    zh_tc: '大板序號位數補償到',
    ru: 'Номера больших номеров компенсируются',
    ko: '대시보드 번호 자릿수 보상',
    bur: 'ပြားအစဉ်နံပါတ်ဂဏန်းအရေအတွက်ပြန်လည်ထူထောင်ခြင်းသို့',
    ben: 'প্যানেল সিরিয়াল নম্বরের অঙ্ক সংখ্যা ক্ষতিপূরণ',
    tr: 'Panel seri numarası basamak telafisi',
    km: 'ការសងសឹងចំនួនខ្ទង់លេខស៊េរីផ្ទាំងដល់',
    es: 'Compensación de dígitos del número de serie de placa grande a',
    ar: 'تعويض أرقام الرقم التسلسلي للوحة الكبيرة',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.figure': {
    zh: '位',
    en: 'Position',
    id: 'Sedikit',
    kz: 'Орны',
    th: 'นิดหน่อย',
    ug: 'خانە',
    vi: 'chữ vị',
    zh_tc: '位',
    ru: 'бит',
    ko: '자리',
    bur: 'ဂဏန်းနေရာ',
    ben: 'অবস্থান',
    tr: 'Basamak',
    km: 'ខ្ទង់',
    es: 'dígitos',
    ar: 'أرقام',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.labelerBegin': {
    zh: '标签机开头',
    en: 'Label Machine Prefix',
    id: 'Mulai mesin label',
    kz: 'Етикеткіштің бастамасы',
    th: 'จุดเริ่มต้นของเครื่องฉลาก',
    ug: 'بەلگە قويغۇچ باشلانغۇچ',
    vi: 'Đầu Máy Dán Nhãn',
    zh_tc: '標籤機開頭',
    ru: 'Начинается маркировка',
    ko: '레이블 시작',
    bur: 'အညွှန်းစက်ရှေ့ဆက်',
    ben: 'লেবেল মেশিন প্রিফিক্স',
    tr: 'Etiket makinesi öneki',
    km: 'បុព្វបទម៉ាស៊ីនស្លាក',
    es: 'Inicio de la máquina de etiquetas',
    ar: 'بداية آلة الملصقات',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.machineCenter': {
    zh: '加工中心开头',
    en: 'Machining Center Prefix',
    id: 'Mulai Pusat Pemesinan',
    kz: 'Өңдеу орталығының бастамасы',
    th: 'จุดเริ่มต้นของศูนย์เครื่องจักรกล',
    ug: 'ئىشلەش مەركىزى باشلانغۇچ',
    vi: 'Đầu Trung Tâm Gia Công',
    zh_tc: '加工中心開頭',
    ru: 'Центр обработки начинается',
    ko: '머시닝 센터 시작',
    bur: 'ပြုပြင်မှုဗဟိုရှေ့ဆက်',
    ben: 'মেশিনিং সেন্টার প্রিফিক্স',
    tr: 'İşleme merkezi öneki',
    km: 'បុព្វបទមជ្ឈមណ្ឌលដំណើរការ',
    es: 'Inicio del centro de mecanizado',
    ar: 'بداية مركز المعالجة',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.front': {
    zh: '正面:',
    en: 'Front Side:',
    id: 'depan:',
    kz: 'Алғыс бет:',
    th: 'ด้านหน้า:',
    ug: 'ئالدى:',
    vi: 'Mặt Trước:',
    zh_tc: '正面:',
    ru: 'Положительный:',
    ko: '전면:',
    bur: 'ရှေ့ဘက်:',
    ben: 'সামনের দিক:',
    tr: 'Ön yüz:',
    km: 'ខាងមុខ៖',
    es: 'Anverso:',
    ar: 'الأمامي:',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.back': {
    zh: '反面:',
    en: 'Back Side:',
    id: 'Balik:',
    kz: 'Арқасы бет:',
    th: 'ย้อนกลับ:',
    ug: 'ئارقا:',
    vi: 'Mặt Sau:',
    zh_tc: '反面:',
    ru: 'Обратная сторона:',
    ko: '후면:',
    bur: 'နောက်ဘက်:',
    ben: 'পিছনের দিক:',
    tr: 'Arka yüz:',
    km: 'ខាងក្រោយ៖',
    es: 'Atrás:',
    ar: 'الخلفي:',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.customizeName': {
    zh: '自定义文件名(格式)：',
    en: 'Custom File Name (Format):',
    id: 'Nama File Kustom (Format):',
    kz: 'Қажетті файл атау (пішім):',
    th: 'ชื่อไฟล์ที่กำหนดเอง (รูปแบบ):',
    ug: 'ئىختىيارى ھۆججەت ئىسمى (فورمات):',
    vi: 'Tên Tệp Tùy Chỉnh (Định Dạng):',
    zh_tc: '自定義文件名(格式)：',
    ru: 'Пользовательское имя файла (формат):',
    ko: '사용자 정의 파일 이름 (형식):',
    bur: 'စိတ်ကြိုက်ဖိုင်အမည် (ဖော်မတ်):',
    ben: 'কাস্টম ফাইল নাম (ফরম্যাট):',
    tr: 'Özel dosya adı (biçim):',
    km: 'ឈ្មោះឯកសារផ្ទាល់ខ្លួន (ទ្រង់ទ្រាយ)៖',
    es: 'Nombre de archivo personalizado (formato):',
    ar: 'اسم الملف المخصص (التنسيق):',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.example': {
    zh: '自定义文件名(示例)：',
    en: 'Custom File Name (Example):',
    id: 'Nama File Kustom (Contoh):',
    kz: 'Қажетті файл атау (мысалы):',
    th: 'ชื่อไฟล์ที่กำหนดเอง (ตัวอย่าง):',
    ug: 'ئىختىيارى ھۆججەت ئىسمى (مىسال):',
    vi: 'Tên Tệp Tùy Chỉnh (Ví Dụ):',
    zh_tc: '自定義文件名(示例)：',
    ru: 'Пользовательское имя файла (пример):',
    ko: '사용자 정의 파일 이름 (예):',
    bur: 'စိတ်ကြိုက်ဖိုင်အမည် (နမူနာ):',
    ben: 'কাস্টম ফাইল নাম (উদাহরণ):',
    tr: 'Özel dosya adı (örnek):',
    km: 'ឈ្មោះឯកសារផ្ទាល់ខ្លួន (ឧទាហរណ៍)៖',
    es: 'Nombre de archivo personalizado (ejemplo):',
    ar: 'اسم الملف المخصص (مثال):',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.emptyTip': {
    zh: '正、反面文件标识不能同时为空',
    en: 'Both front and back file identifiers cannot be empty at the same time',
    id: 'Pengidentifikasi file depan dan belakang tidak dapat kosong pada saat yang sama',
    kz: 'Алғыс және арқасы беттің файл белгілері бір мезгілде бос болушы болмайды',
    th: 'ตัวระบุไฟล์ด้านหน้าและด้านหลังไม่สามารถว่างเปล่าในเวลาเดียวกัน',
    ug: 'ئالدى، ئارقا ھۆججەت بەلگىسى بىر ۋاقىتتا بوش بولسا بولمايدۇ',
    vi: 'Điều Khiển Mặt Trước/Sau Không Được Để Trống Đồng Thời',
    zh_tc: '正、反面文件標識不能同時為空',
    ru: 'Идентификаторы положительных и отрицательных файлов не могут быть пустыми одновременно',
    ko: '양면 및 후면 파일 ID는 동시에 비워둘 수 없습니다.',
    bur: 'ရှေ့နှင့်နောက်ဖိုင်အမှတ်အသားနှစ်ခုလုံးတစ်ချိန်တည်းဗလာမဖြစ်ရ',
    ben: 'সামনে ও পিছনের ফাইল আইডেন্টিফায়ার একসাথে খালি থাকতে পারবে না',
    tr: 'Ön ve arka dosya tanımlayıcıları aynı anda boş olamaz',
    km: 'សម្គាល់ឯកសារខាងមុខ និងខាងក្រោមមិនអាចទទេពេលតែមួយ',
    es: 'Los identificadores de archivo frontal y posterior no pueden estar vacíos al mismo tiempo tiempo.',
    ar: 'لا يمكن أن تكون معرفات الملف الأمامية والخلفية فارغة في نفس الوقت.',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.labelPool': {
    zh: '数据标签池',
    en: 'Data Label Pool',
    id: 'Kumpulan tag data',
    kz: 'Деректердің белгісі топ',
    th: 'พูลแท็กข้อมูล',
    ug: 'سانلىق مەلۇمات بەلگە سۇ ئامبىرى',
    vi: 'Hồ Bơi Dánh Dấu Dữ Liệu',
    zh_tc: '數據標籤池',
    ru: 'Пул тегов данных',
    ko: '데이터 태그 풀',
    bur: 'ဒေတာအညွှန်းကန်ရေကန်',
    ben: 'ডেটা লেবেল পুল',
    tr: 'Veri etiket havuzu',
    km: 'អាងស្លាកទិន្នន័យ',
    es: 'Grupo de etiquetas de datos',
    ar: 'تجمع علامات البيانات',
  },
  'cuttingDock.NCExportSettings.fileNameSettings.dragTip': {
    zh: '可拖拽或点击复制标签池内标签到输入框内',
    en: 'You can drag or click to copy the tags in the tag pool to the input box',
    id: 'Anda dapat menyeret atau mengklik untuk menyalin tag di kumpulan tag ke kotak input',
    kz: 'Белгісі топтағы белгілерді сүйреп немесе шерту арқылы кіріс қанатына көшіріңіз',
    th: 'คุณสามารถลากหรือคลิกเพื่อคัดลอกแท็กในแท็กพูลลงในกล่องอินพุต',
    ug: 'سانلىق مەلۇمات بەلگە سۇ ئامبىرىدىكى بەلگىلەرنى سۆرەپ تاشلىسىڭىز ياكى كۆچۈرۈش كۇنۇپكىسىنى بېسىپ كىرگۈزۈش رامكىسىغا كۆچۈرەلەيسىز',
    vi: 'Có Thể Kéo hoặc Nhấn để Sao Chép Dánh Dấu Từ Hồ Bơi Dánh Dấu Đến Trong Hộp Nhập',
    zh_tc: '可拖拽或點擊複製標籤池內標籤到輸入框內',
    ru: 'Можно перетащить или нажать кнопку Скопировать вкладку в поле ввода',
    ko: '탭 풀에서 탭을 드래그하거나 클릭하여 입력란에 탭 복사 가능',
    bur: 'အညွှန်းကန်ရေကန်မှအညွှန်းများကိုဆွဲသို့မဟုတ်ကလစ်နှင့်ထည့်သွင်းဘောက်စ်သို့ကူးနိုင်သည်',
    ben: 'ট্যাগ পুলের ট্যাগগুলি ড্র্যাগ বা ক্লিক করে ইনপুট বক্সে কপি করতে পারেন',
    tr: 'Etiket havuzundaki etiketleri sürükleyerek veya tıklayarak kopyalayıp giriş kutusuna yapıştırabilirsiniz',
    km: 'អូសឬចុចចម្លងស្លាកពីអាងស្លាកទៅប្រអប់បញ្ចូល',
    es: 'Puede arrastrar o hacer clic para copiar las etiquetas en el conjunto de etiquetas en el cuadro de entrada',
    ar: 'يمكنك السحب أو النقر لنسخ العلامات الموجودة في تجمع العلامات في مربع الإدخال',
  },
  'cuttingDock.NCExportSettings.fileMerge.engravingMerge': {
    zh: '开料机文件合并',
    en: 'Nesting Machine File Merging',
    id: 'Kombinasi file mesin pemotong',
    kz: 'Кескіш машинасының файл біріктіру',
    th: 'การรวมกันของไฟล์เครื่องตัด',
    ug: 'كېسىش ماشىنىسى ھۆججەت بىرلەشتۈرۈش',
    vi: 'Hợp Nhất Tệp Máy Khoan',
    zh_tc: '開料機文件合併',
    ru: 'Объединение файлов распылителя',
    ko: '원료 공급기 파일 병합',
    bur: 'ဖြတ်စက်ဖိုင်ပေါင်းခြင်း',
    ben: 'নেস্টিং মেশিন ফাইল মার্জিং',
    tr: 'Kesim makinesi dosyalarını birleştir',
    km: 'រួមឯកសារម៉ាស៊ីនកាត់',
    es: 'Fusión de archivos de máquina cortadora',
    ar: 'دمج ملفات آلة القطع',
  },
  'cuttingDock.NCExportSettings.fileMerge.zfMerge': {
    zh: '正反面合并',
    en: 'Front and Back Side Merging',
    id: 'Gabungkan depan dan belakang',
    kz: 'Алғыс және арқасы беттің біріктіру',
    th: 'ผสานด้านหน้าและด้านหลัง',
    ug: 'ئالدى-كەينى بىرلەشتۈرۈش',
    vi: 'Hợp Nhất Mặt Trước/Sau',
    zh_tc: '正反面合併',
    ru: 'Положительное и отрицательное слияние',
    ko: '양면 및 후면 결합',
    bur: 'ရှေ့နှင့်နောက်ဘက်ပေါင်းခြင်း',
    ben: 'সামনে ও পিছনের দিক মার্জিং',
    tr: 'Ön ve arka yüz birleştirme',
    km: 'រួមខាងមុខ និងខាងក្រោម',
    es: 'Fusión frontal y posterior',
    ar: 'الدمج الأمامي والخلفي',
  },
  'cuttingDock.NCExportSettings.fileMerge.singleMerge': {
    zh: '单工位合并',
    en: 'Single Station Merging',
    id: 'Penggabungan stasiun tunggal',
    kz: 'Бір орны біріктіру',
    th: 'การควบรวมกิจการของสถานีเดียว',
    ug: 'يەككە ئورۇن بىرلەشتۈرۈش',
    vi: 'Hợp Nhất Đơn Công Vị',
    zh_tc: '單工位合併',
    ru: 'Объединение отдельных рабочих мест',
    ko: '단일 작업 위치 병합',
    bur: 'တစ်နေရာပေါင်းခြင်း',
    ben: 'সিঙ্গেল স্টেশন মার্জিং',
    tr: 'Tek istasyon birleştirme',
    km: 'រួមស្ថានីយ៍តែមួយ',
    es: 'Fusión de estación única',
    ar: 'دمج محطة واحدة',
  },
  'cuttingDock.NCExportSettings.fileMerge.doubleMerge': {
    zh: '双工位合并',
    en: 'Dual Station Merging',
    id: 'Penggabungan Stasiun Ganda',
    kz: 'Екі орны біріктіру',
    th: 'การควบรวมกิจการสองสถานี',
    ug: 'قوش ئورۇن بىرلەشتۈرۈش',
    vi: 'Hợp Nhất Đôi Công Vị',
    zh_tc: '雙工位合併',
    ru: 'Двойное слияние',
    ko: '이중 비트 병합',
    bur: 'နှစ်နေရာပေါင်းခြင်း',
    ben: 'ডুয়াল স্টেশন মার্জিং',
    tr: 'Çift istasyon birleştirme',
    km: 'រួមស្ថានីយ៍ពីរ',
    es: 'Fusión de estación doble',
    ar: 'دمج المحطة المزدوجة',
  },
  'cuttingDock.NCExportSettings.fileMerge.fEndCode': {
    zh: '反面结束代码',
    en: 'Back Side End Code',
    id: 'Kode akhir terbalik',
    kz: 'Арқасы беттің аяқталу коды',
    th: 'รหัสปลายย้อนกลับ',
    ug: 'كەينى يۈزى ئاخىرلىشىش كودى',
    vi: 'Mã Kết Thúc Mặt Sau',
    zh_tc: '反面結束代碼',
    ru: 'Код обратного конца',
    ko: '후면 끝 코드',
    bur: 'နောက်ဘက်အဆုံးကုဒ်',
    ben: 'পিছনের দিক এন্ড কোড',
    tr: 'Arka yüz bitiş kodu',
    km: 'កូដបញ្ចប់ខាងក្រោម',
    es: 'Código de fin inverso',
    ar: 'رمز النهاية العكسية',
  },
  'cuttingDock.NCExportSettings.fileMerge.zBeginCode': {
    zh: '正面开始代码',
    en: 'Front Side Start Code',
    id: 'Kode Mulai Depan',
    kz: 'Алғыс беттің басталу коды',
    th: 'รหัสเริ่มต้น',
    ug: 'ئالدى يۈزى باشلىنىش كودى',
    vi: 'Mã Bắt Đầu Mặt Trước',
    zh_tc: '正面開始代碼',
    ru: 'Положительный код начала',
    ko: '전면 시작 코드',
    bur: 'ရှေ့ဘက်စတင်ကုဒ်',
    ben: 'সামনের দিক স্টার্ট কোড',
    tr: 'Ön yüz başlangıç kodu',
    km: 'កូដចាប់ផ្តើមខាងមុខ',
    es: 'Código inicial frontal',
    ar: 'رمز البداية الأمامية',
  },
  'cuttingDock.NCExportSettings.fileMerge.displayfbInfo': {
    zh: '文件名显示正反面信息',
    en: 'Display Front and Back Side Information in File Name',
    id: 'Nama file menampilkan informasi depan dan belakang',
    kz: 'Файл атауында алғыс және арқасы беттің ақпараті көрсетілу',
    th: 'ชื่อไฟล์แสดงข้อมูลด้านหน้าและด้านหลัง',
    ug: 'ھۆججەت ئىسمى ئالدى-كەينى يۈزى ئۇچۇرىنى كۆرسىتىش',
    vi: 'Tên Tệp Hiển Thị Thông Tin Mặt Trước/Sau',
    zh_tc: '文件名顯示正反面信息',
    ru: 'Имя файла показывает положительную и отрицательную информацию',
    ko: '파일 이름 양의 뒷면 정보 표시',
    bur: 'ဖိုင်အမည်တွင်ရှေ့နှင့်နောက်ဘက်အချက်အလက်ပြပါ',
    ben: 'ফাইল নামে সামনে ও পিছনের দিকের তথ্য প্রদর্শন করুন',
    tr: 'Dosya adında ön ve arka yüz bilgisini göster',
    km: 'បង្ហាញព័ត៌មានខាងមុខ និងខាងក្រោមនៅក្នុងឈ្មោះឯកសារ',
    es: 'El nombre del archivo muestra información frontal y posterior',
    ar: 'يعرض اسم الملف المعلومات الأمامية والخلفية',
  },
  'cuttingDock.NCExportSettings.fileMerge.fBeginCode': {
    zh: '反面开始代码',
    en: 'Back Side Start Code',
    id: 'Kode Mulai Terbalik',
    kz: 'Арқасы беттің басталу коды',
    th: 'รหัสเริ่มย้อนกลับ',
    ug: 'كەينى يۈزى باشلىنىش كودى',
    vi: 'Mã Bắt Đầu Mặt Sau',
    zh_tc: '反面開始代碼',
    ru: 'Код обратного начала',
    ko: '후면 시작 코드',
    bur: 'နောက်ဘက်စတင်ကုဒ်',
    ben: 'পিছনের দিক স্টার্ট কোড',
    tr: 'Arka yüz başlangıç kodu',
    km: 'កូដចាប់ផ្តើមខាងក្រោម',
    es: 'Código inicial inverso',
    ar: 'رمز البداية العكسية',
  },
  'cuttingDock.NCExportSettings.fileMerge.zEndCode': {
    zh: '正面结束代码',
    en: 'Front Side End Code',
    id: 'Kode ujung depan',
    kz: 'Алғыс беттің аяқталу коды',
    th: 'รหัสส่วนหน้า',
    ug: 'ئالدى يۈزى ئاخىرلىشىش كودى',
    vi: 'Mã Kết Thúc Mặt Trước',
    zh_tc: '正面結束代碼',
    ru: 'Код положительного конца',
    ko: '전면 종료 코드',
    bur: 'ရှေ့ဘက်အဆုံးကုဒ်',
    ben: 'সামনের দিক এন্ড কোড',
    tr: 'Ön yüz bitiş kodu',
    km: 'កូដបញ្ចប់ខាងមុខ',
    es: 'Código final frontal',
    ar: 'رمز النهاية الأمامية',
  },
  'cuttingDock.NCExportSettings.marginalNotes.addPlankInfo': {
    zh: '开料文件开头加入当前大板件信息：',
    en: 'Add Current Panel Information to the Beginning of Nesting Files:',
    id: 'Tambahkan informasi pelat besar saat ini di awal file pemotongan:',
    kz: 'Кескіш файл бастамасына қазіргі үлкен тақта туралы ақпарат қосу:',
    th: 'เพิ่มข้อมูลแผ่นขนาดใหญ่ปัจจุบันที่จุดเริ่มต้นของไฟล์ตัด:',
    ug: 'كېسىش ھۆججىتى بېشىغا چوڭ تاختاي ئۇچۇرىنى قوشۇش:',
    vi: 'Thêm Thông Tin Đa Tầng Hiện Tại Đến Đầu Tệp Khoan:',
    zh_tc: '開料文件開頭加入當前大板件信息：',
    ru: 'В начале открытого файла добавить информацию о текущей большой панели:',
    ko: '원본 파일의 시작 부분에 현재 대시보드 정보를 추가합니다.',
    bur: 'ဖြတ်တောက်ဖိုင် အစတွင် လက်ရှိ ကြီးမားပြား ပစ္စည်းအပိုင်း အချက်အလက်များ ထည့်ပါ:',
    ben: 'কাটিং ফাইলের শুরুতে বর্তমান বড় বোর্ডের অংশের তথ্য যোগ করুন:',
    tr: 'Kesim dosyasının başına geçerli büyük levha bilgisini ekle:',
    km: 'បន្ថែមព័ត៌មានផ្ទាំងធំបច្ចុប្បន្ននៅដើមឯកសារកាត់៖',
    es: 'Agregue información de placa grande actual al comienzo del archivo de corte:',
    ar: 'إضافة معلومات اللوحة الكبيرة الحالية في بداية ملف القطع:',
  },
  'cuttingDock.NCExportSettings.marginalNotes.plankInfo': {
    zh: '大板信息：',
    en: 'Panel Information:',
    id: 'Informasi Papan Besar:',
    kz: 'Үлкен тақта туралы ақпарат:',
    th: 'ข้อมูลบอร์ดขนาดใหญ่:',
    ug: 'چوڭ تاختاي ئۇچۇرى:',
    vi: 'Thông Tin Đa Tầng:',
    zh_tc: '大板信息：',
    ru: 'Большая информация:',
    ko: '보드 정보:',
    bur: 'ကြီးမားပြား အချက်အလက်များ:',
    ben: 'বড় বোর্ডের তথ্য:',
    tr: 'Levha bilgisi:',
    km: 'ព័ត៌មានផ្ទាំង៖',
    es: 'Información de placa grande:',
    ar: 'معلومات اللوحة الكبيرة:',
  },
  'cuttingDock.NCExportSettings.marginalNotes.addStationCodeFirst': {
    zh: '开料文件开头加入工位代码：',
    en: 'Add Station Code to the Beginning of Nesting Files:',
    id: 'Tambahkan kode stasiun kerja di awal file pemotongan:',
    kz: 'Кескіш файл бастамасына станс коды қосу:',
    th: 'เพิ่มรหัสสถานีทำงานที่จุดเริ่มต้นของไฟล์ตัด:',
    ug: 'كېسىش ھۆججىتى بېشىغا ئورۇن كودىنى قوشۇش:',
    vi: 'Thêm Mã Công Vị Đến Đầu Tệp Khoan:',
    zh_tc: '開料文件開頭加入工位代碼：',
    ru: 'В начале файла ввода добавить код станции:',
    ko: '원단 파일의 시작 부분에 작업 위치 코드를 추가합니다.',
    bur: 'ဖြတ်စက်ဖိုင်အစတွင်အလုပ်နေရာကုဒ်ထည့်ပါ:',
    ben: 'নেস্টিং ফাইলের শুরুতে স্টেশন কোড যোগ করুন:',
    tr: 'Kesim dosyasının başına istasyon kodu ekle:',
    km: 'បន្ថែមកូដស្ថានីយ៍នៅដើមឯកសារកាត់៖',
    es: 'Agregue la estación de trabajo código al comienzo del archivo de apertura del material:',
    ar: 'إضافة محطة العمل الكود الموجود في بداية ملف فتح المادة:',
  },
  'cuttingDock.NCExportSettings.marginalNotes.addStationCodeSecond': {
    zh: '开料文件换刀前加入工位代码：',
    en: 'Add Station Code Before Tool Change in Nesting Files:',
    id: 'Tambahkan kode stasiun kerja sebelum mengubah alat saat memotong file materi:',
    kz: 'Кескіш файлде зым ауыстыру алдында станс коды қосу:',
    th: 'เพิ่มรหัสสถานีทำงานก่อนเปลี่ยนเครื่องมือเมื่อตัดไฟล์วัสดุ:',
    ug: 'كېسىش ھۆججىتى پىچاق ئالماشتۇرۇشتىن بۇرۇن ئورۇن كودىنى قوشۇش:',
    vi: 'Thêm Mã Công Vị Đến Trước Thay Dao Trong Tệp Khoan:',
    zh_tc: '開料文件換刀前加入工位代碼：',
    ru: 'Добавить код станции перед сменой ножа в открытый файл:',
    ko: '가공 코드를 추가하기 전에 재료 파일을 공구로 교체합니다.',
    bur: 'ဖြတ်တောက်ဖိုင်တွင် ကိရိယာပြောင်းမီ အလုပ်ခုံ(စတေရှင်) ကုဒ် ထည့်ပါ:',
    ben: 'কাটিং ফাইলে টুল বদলানোর আগে ওয়ার্কস্টেশন কোড যোগ করুন:',
    tr: 'Kesim dosyasında takım değişiminden önce istasyon kodu ekle:',
    km: 'បន្ថែមកូដស្ថានីយ៍មុនប្តូរឧបករណ៍ក្នុងឯកសារកាត់៖',
    es: 'Agregue el código de estación antes de cambiar la herramienta en el archivo de corte:',
    ar: 'أضف رمز المحطة قبل تغيير الأداة في ملف القطع:',
  },
  'cuttingDock.NCExportSettings.fileType.zAddtion': {
    zh: 'Z坐标补充：',
    en: 'Z-Axis Addition:',
    id: 'Z Koordinat Suplemen:',
    kz: 'Z координатасының толықтыру:',
    th: 'Z พิกัดส่วนเสริม:',
    ug: 'Z كوئوردېناتى تولۇقلاش:',
    vi: 'Bổ Sung Tọa Độ Z:',
    zh_tc: 'Z坐標補充：',
    ru: 'Z - координаты дополнены:',
    ko: 'Z 좌표 보충:',
    bur: 'Z ကိုဩဒိနိတ် အပိုဖြည့်စွက်ချက်:',
    ben: 'Z স্থানাঙ্কের পরিপূরক:',
    tr: 'Z ekseni eki:',
    km: 'ការបន្ថែមអ័ក្ស Z៖',
    es: 'Z Suplemento de coordenadas:',
    ar: 'Z ملحق الإحداثيات:',
  },
  'cuttingDock.NCExportSettings.fileType.addSemicolon': {
    zh: '每行NC末尾加分号：',
    en: 'Add Semicolon at the End of Each NC Line:',
    id: 'Tambahkan titik koma di akhir setiap baris NC:',
    kz: 'Әрбір NC саптың соңына тоқтау таңбасын қосу:',
    th: 'เพิ่มเครื่องหมายอัฒภาคที่ส่วนท้ายของแต่ละบรรทัด NC:',
    ug: 'ھەر قۇر NC نىڭ ئاخىرىغا چېكىت پەش قوشۇش:',
    vi: 'Thêm Dấu Chấm Phẩy Đến Cuối Mỗi Hàng NC:',
    zh_tc: '每行NC末尾加分號：',
    ru: 'Добавить запятую в конце строки NC:',
    ko: '각 행 NC 끝에 세미콜론:',
    bur: 'NC စာကြောင်းတိုင်းအဆုံးတွင်စီမီကိုလုံထည့်ပါ:',
    ben: 'প্রতিটি NC লাইনের শেষে সেমিকোলন যোগ করুন:',
    tr: 'Her NC satırının sonuna noktalı virgül ekle:',
    km: 'បន្ថែមសញ្ញាចុចក្បៀសនៅចុងបន្ទាត់ NC នីមួយៗ៖',
    es: 'Agregue un punto y coma al final de cada línea NC:',
    ar: 'أضف فاصلة منقوطة في نهاية كل سطر NC:',
  },
  'cuttingDock.NCExportSettings.fileType.semicolonTip': {
    zh: '勾选后牛角拉手的加工文件也会生效',
    en: 'Checking this box will also affect the processing files for horn handles',
    id: 'File pemrosesan pegangan tanduk juga akan berlaku setelah memeriksa',
    kz: 'Таңбашаны таңдағаннан кейін сарық қолтыңның өңдеу файлы де қолданылады',
    th: 'ไฟล์การประมวลผลของมือจับฮอร์นจะมีผลเช่นกันหลังจากตรวจสอบ',
    ug: 'تاللانغاندا كالا مۈڭگۈزى تۇتقۇچنىڭ ئىشلەش ھۆججىتىگىمۇ ئۈنۈملۈك بولىدۇ',
    vi: 'Chọn này sẽ có hiệu lực cho Tệp Gia Công Tay Cọc',
    zh_tc: '勾選後牛角拉手的加工文件也會生效',
    ru: 'После галочки вступят в силу документы по обработке рога.',
    ko: '이 옵션을 선택하면 소뿔이 손잡이는 가공 파일도 적용됩니다.',
    bur: 'ဤခဲတံအမှတ်အသားပါကနွားချိုလက်ကိုင်ပြုပြင်ဖိုင်များလည်းအကျိုးသက်ရောက်မည်',
    ben: 'এই বক্স চেক করলে শিং হ্যান্ডেলের প্রক্রিয়াকরণ ফাইলেও প্রভাব পড়বে',
    tr: 'İşaretlendiğinde boynuz kulplu parçaların işleme dosyaları için de geçerlidir',
    km: 'បើធីក ក៏មានប្រសិទ្ធភាពសម្រាប់ឯកសារដំណើរការដៃចង្កឹះរណ្តៅ',
    es: 'Después de verificar, el archivo de procesamiento del mango de la bocina también tendrá efecto',
    ar: 'بعد التحقق، سيصبح ملف المعالجة لمقبض البوق ساري المفعول أيضًا',
  },
  'cuttingDock.NCExportSettings.fileType.fileName': {
    zh: '文件名',
    en: 'File Name',
    id: 'Nama file',
    kz: 'Файл атау',
    th: 'ชื่อไฟล์',
    ug: 'ھۆججەت ئىسمى',
    vi: 'Tên Tệp',
    zh_tc: '文件名',
    ru: 'имя файла',
    ko: '파일 이름',
    bur: 'ဖိုင်အမည်',
    ben: 'ফাইল নাম',
    tr: 'Dosya adı',
    km: 'ឈ្មោះឯកសារ',
    es: 'Nombre de archivo',
    ar: 'اسم الملف',
  },
  'cuttingDock.NCExportSettings.fileType.defaultName': {
    zh: '默认文件名',
    en: 'Default File Name',
    id: 'Nama file default',
    kz: 'Әдетті файл атау',
    th: 'ชื่อไฟล์เริ่มต้น',
    ug: 'سۈكۈتتىكى ھۆججەت ئىسمى',
    vi: 'Tên Tệp Mặc Định',
    zh_tc: '默認文件名',
    ru: 'Имя файла по умолчанию',
    ko: '기본 파일 이름',
    bur: 'ပုံသေဖိုင်အမည်',
    ben: 'ডিফল্ট ফাইল নাম',
    tr: 'Varsayılan dosya adı',
    km: 'ឈ្មោះឯកសារលំនាំដើម',
    es: 'Nombre de archivo predeterminado',
    ar: 'اسم الملف الافتراضي',
  },
  'cuttingDock.NCExportSettings.fileType.dedicatedName': {
    zh: '星辉设备专用文件名',
    en: 'Dedicated File Name for Xinghui Equipment',
    id: 'Nama file khusus untuk peralatan starlight',
    kz: 'Жұлдызды құрылғыларға арналған файл атау',
    th: 'ชื่อไฟล์พิเศษสำหรับอุปกรณ์ Starlight',
    ug: 'شىڭخۇي ئۈسكۈنىسىگە خاس ھۆججەت ئىسمى',
    vi: 'Tên Tệp Đặc Biệt Thiết Bị Xinghui',
    zh_tc: '星輝設備專用文件名',
    ru: 'Специальное имя файла устройства Starlight',
    ko: '별빛 장치 전용 파일 이름',
    bur: 'ရှင်းဟွေးကိရိယာအတွက်သီးသန့်ဖိုင်အမည်',
    ben: 'জিংহুই সরঞ্জামের জন্য ডেডিকেটেড ফাইল নাম',
    tr: 'Xinghui ekipmanına özel dosya adı',
    km: 'ឈ្មោះឯកសារសម្រាប់ឧបករណ៍ Xinghui',
    es: 'Nombre de archivo especial del equipo Xinghui',
    ar: 'اسم الملف الخاص لمعدات Xinghui',
  },
  'cuttingDock.NCExportSettings.fileType.xhNotes': {
    zh: '星辉E2-9注释',
    en: 'Xinghui E2-9 Notes',
    id: 'Starlight E2-9 Komentar',
    kz: 'Жұлдызды E2-9 ескерту',
    th: 'ความคิดเห็น Starlight E2-9',
    ug: 'شىڭخۇي E2-9 ئىزاھات',
    vi: 'Ghi chú Xinghui E2-9',
    zh_tc: '星輝E2-9註釋',
    ru: 'Звёздный блеск E2 - 9 Комментарии',
    ko: '별빛 E2-9 주석',
    bur: 'ရှင်းဟွေး E2-9 မှတ်ချက်',
    ben: 'জিংহুই E2-9 নোট',
    tr: 'Xinghui E2-9 notları',
    km: 'កំណត់ចំណាំ Xinghui E2-9',
    es: 'Xinghui E2-9 Comentario',
    ar: 'Xinghui E2-9 تعليق',
  },
  'cuttingDock.NCExportSettings.fileType.format': {
    zh: '输出雕刻机文件格式',
    en: 'Output Engraving Machine File Format',
    id: 'Format file mesin ukiran ukiran',
    kz: 'Кескіш машинасының файл пішімі',
    th: 'รูปแบบไฟล์เครื่องแกะสลักเอาต์พุต',
    ug: 'ئويما ماشىنا ھۆججەت فورماتى',
    vi: 'Định Dạng Tệp Máy Khoan Xuất',
    zh_tc: '輸出雕刻機文件格式',
    ru: 'Файл выходной гравировальной машины',
    ko: '조각기 파일 형식 내보내기',
    bur: 'ထုတ်သွင်းမည့် ထွင်းစက် ဖိုင်ဖော်မတ်',
    ben: 'আউটপুট খোদাই মেশিনের ফাইল ফরম্যাট',
    tr: 'Oyma makinesi çıktı dosya biçimi',
    km: 'ទ្រង់ទ្រាយឯកសារទិន្នផលម៉ាស៊ីនចុកចាក់',
    es: 'Salida formato de archivo de la máquina de grabado',
    ar: 'تنسيق ملف آلة نقش الإخراج',
  },
  'cuttingDock.NCExportSettings.fileType.example': {
    zh: '文件样例: NC文件',
    en: 'File Example: NC File',
    id: 'Contoh File: File NC',
    kz: 'Файл үлгі: NC файл',
    th: 'ตัวอย่างไฟล์: ไฟล์ NC',
    ug: 'ھۆججەت مىسالى: NC ھۆججەت',
    vi: 'Ví Dụ Tệp: Tệp NC',
    zh_tc: '文件樣例: NC文件',
    ru: 'Пример файла: NC файл',
    ko: '파일 예: NC 파일',
    bur: 'ဖိုင်နမူနာ: NC ဖိုင်',
    ben: 'ফাইলের নমুনা: NC ফাইল',
    tr: 'Dosya örneği: NC dosyası',
    km: 'ឧទាហរណ៍ឯកសារ៖ ឯកសារ NC',
    es: 'Ejemplo de archivo: archivo NC',
    ar: 'مثال ملف: ملف NC',
  },
  'cuttingDock.NCExportSettings.fileType.stillGenerate': {
    zh: '反面不加工时仍然生成含有反面结束代码的反面NC文件',
    en: 'Generate the back NC file containing the back end code even when the back side is not processed',
    id: 'Ketika sisi terbalik tidak diproses, itu masih menghasilkan file NC terbalik dengan hanya kode ujung terbalik.',
    kz: 'Артқы жағы өңделмеген кезде де артқы аяқтау кодын қамтитын артқы NC файлын жасау',
    th: 'เมื่อด้านย้อนกลับไม่ได้ประมวลผลมันยังคงสร้างไฟล์ย้อนกลับ NC ด้วยรหัสปลายย้อนกลับเท่านั้น',
    ug: 'كەينى يۈزى ئىشلەنمىگەندە يەنىلا كەينى يۈزى ئاخىرلىشىش كودى بار كەينى يۈزى NC ھۆججىتىنى ھاسىل قىلىش',
    vi: 'Tạo tệp NC mặt sau chứa mã kết thúc mặt sau ngay cả khi mặt sau không được gia công',
    zh_tc: '反面不加工時仍然生成含有反面結束代碼的反面NC文件',
    ru: 'Обратный файл NC, содержащий обратный код окончания',
    ko: '후면을 가공하지 않는 경우에도 후면 끝 코드가 있는 후면 NC 파일이 생성됩니다.',
    bur: 'နောက်ဘက်မပြုပြင်သည့်တိုင်နောက်ဘက်အဆုံးကုဒ်ပါသောနောက်ဘက် NC ဖိုင်ထုတ်ပါ',
    ben: 'পিছনের দিক প্রক্রিয়া না করলেও পিছনের এন্ড কোডযুক্ত পিছনের NC ফাইল তৈরি করুন',
    tr: 'Arka yüz işlenmese bile arka bitiş kodunu içeren arka NC dosyasını oluştur',
    km: 'បង្កើតឯកសារ NC ខាងក្រោមដែលមានកូដបញ្ចប់ខាងក្រោម ទោះបីខាងក្រោមមិនដំណើរការ',
    es: 'Cuando no se procesa el reverso, se seguirá generando el archivo NC del reverso que contiene el código final del reverso',
    ar: 'عندما لا تتم معالجة الجانب العكسي، سيتم إنشاء ملف الجانب العكسي NC الذي يحتوي على رمز النهاية العكسية',
  },
  'cuttingDock.NCExportSettings.fileType.generateTip': {
    zh: '该功能不支持与文件合并功能一起使用',
    en: 'This feature is not supported when used together with the file merging feature',
    id: 'Fitur ini tidak mendukung penggunaan dengan fungsi penggabungan file',
    kz: 'Бұл функсия файл біріктіру функциясымен бірге қолданылмайды',
    th: 'คุณสมบัตินี้ไม่รองรับการใช้กับฟังก์ชั่นการรวมไฟล์',
    ug: 'بۇ ئىقتىدار ھۆججەت بىرلەشتۈرۈش ئىقتىدارى بىلەن بىللە ئىشلىتىلمەيدۇ',
    vi: 'Chức Năng Này Không Hỗ Trợ Cùng Sử Dụng Với Chức Năng Hợp Nhất Tệp',
    zh_tc: '該功能不支持與文件合併功能一起使用',
    ru: 'Эта функция не поддерживается с функцией объединения файлов',
    ko: '이 기능은 파일 병합 기능을 지원하지 않습니다.',
    bur: 'ဒီလုပ်ဆောင်ချက်ကို ဖိုင်ပေါင်း (merge) လုပ်ဆောင်ချက်နဲ့ အတူတကွ အသုံးပြုလို့မရပါ',
    ben: 'এই ফিচারটি ফাইল মার্জ (merge) ফাংশনের সাথে একসাথে ব্যবহার করা যাবে না',
    tr: 'Bu özellik dosya birleştirme ile birlikte kullanılamaz',
    km: 'មុខងារនេះមិនគាំទ្ររួមជាមួយការរួមឯកសារ',
    es: 'Esta función no admite el uso con la función de fusión de archivos',
    ar: 'لا تدعم هذه الوظيفة الاستخدام مع وظيفة دمج الملفات',
  },
  'cuttingDock.NCExportSettings.fileType.fileNameErrTip': {
    zh: '文件名不能包含下列任何字符: / : * ? "',
    en: 'File names cannot contain any of the following characters: / : * ? "',
    id: 'Nama file tidak dapat berisi karakter berikut: /: *? "',
    kz: 'Файл атауға келесі символдарды қосуға болмайды: / : * ? "',
    th: 'ชื่อไฟล์ไม่สามารถมีอักขระใด ๆ ต่อไปนี้: /: *? -',
    ug: 'ھۆججەت ئىسمى تۆۋەندىكى ھەرقانداق ھەرپنى ئۆز ئىچىگە ئالالمايدۇ: / : * ? "',
    vi: 'Tên Tệp Không Được Chứa Những Ký Tự Sau: / : * ? "',
    zh_tc: '文件名不能包含下列任何字符: / : * ? "',
    ru: 'Имя файла не может содержать ни одного из следующих символов: /: * "',
    ko: '파일 이름에는 다음 문자를 사용할 수 없습니다: /: *? "',
    bur: 'ဖိုင်အမည်တွင် အောက်ပါ အက္ခရာများထဲက မည်သည့်အက္ခရာမဆို ပါဝင်ခွင့်မရှိပါ: / : * ? "',
    ben: 'ফাইলের নামের মধ্যে নিম্নলিখিত কোনো অক্ষর থাকতে পারবে না: / : * ? "',
    tr: 'Dosya adları şu karakterleri içeremez: / : * ? "',
    km: 'ឈ្មោះឯកសារមិនអាចមានតួអក្សរណាមួយនេះ៖ / : * ? "',
    es: 'El nombre del archivo no puede contener ninguno de los siguientes caracteres: / : * ? "',
    ar: 'لا يمكن أن يحتوي اسم الملف على أي من الأحرف التالية: / : * ? "',
  },
  'cuttingDock.NCExportSettings.categorize': {
    zh: '根据大板颜色、材质、厚度归为不同文件夹(贴标文件一起)：',
    en: 'Categorize into different folders based on panel color, material, and thickness (including labeling files):',
    id: 'Menurut warna, bahan dan ketebalan papan besar, itu diklasifikasikan ke dalam folder yang berbeda (label file bersama):',
    kz: 'Үлкен тақтаның түсі, матеріалды, қалыңдығы қайсы папкада (этикетка файлдарымен бірге) біріктіру:',
    th: 'ตามสีวัสดุและความหนาของบอร์ดขนาดใหญ่มันถูกจัดประเภทเป็นโฟลเดอร์ที่แตกต่างกัน (ไฟล์การติดฉลากเข้าด้วยกัน):',
    ug: 'چوڭ تاختاينىڭ رەڭگى، ماتېرىيالى ۋە قېلىنلىقى بويىچە ھۆججەت قىسقۇچىغا ئايرىش (بەلگە چاپلاش ھۆججىتى بىللە):',
    vi: 'Phân Loại Theo Màu Đa Tầng, Chất Liệu, Độ Dày Đến Khác Nhau Thư Mục (Tệp Dán Nhãn Cùng Múi):',
    zh_tc: '根據大板顏色、材質、厚度歸為不同文件夾(貼標文件一起)：',
    ru: 'В зависимости от цвета, материала и толщины больших панелей классифицируются по различным папкам (вместе с файлами меток):',
    ko: '대시보드 색상, 재료, 두께에 따라 다른 폴더로 분류합니다 (레이블 파일 포함).',
    bur: 'ကြီးမားပြား၏ အရောင်၊ ပစ္စည်းနှင့် အထူအတိုင်း မတူညီသော ဖိုင်တွဲများအဖြစ် ခွဲထားပါ (တပ်ဖဲလ်ဖိုင်များကိုလည်း အတူတကွ):',
    ben: 'বড় বোর্ডের রং, উপাদান এবং পুরুত্ব অনুযায়ী বিভিন্ন ফোল্ডারে ভাগ করুন (লেবেল করা ফাইলগুলো একসাথে):',
    tr: 'Levha rengi, malzeme ve kalınlığına göre farklı klasörlere ayırın (etiket dosyaları dahil):',
    km: 'ចាត់ថតផ្សេងៗតាមពណ៌ សម្ភារៈ និងកម្រាស់ផ្ទាំង (រួមឯកសារស្លាក)៖',
    es: 'Según el color, material y grosor del tablero grande, se clasifica en diferentes carpetas (etiquetando archivos juntos):',
    ar: 'وفقًا للون والمادة وسمك اللوحة الكبيرة، يتم تصنيفها إلى مجلدات مختلفة (تسمية الملفات معًا):',
  },
  'cuttingDock.NCExportSettings.simplifyG': {
    zh: '加工G指令简写',
    en: 'Simplify G-Code Instructions',
    id: 'Memproses singkatan instruksi G',
    kz: 'Өңдеу G инструкциясының қысқаша пішімі',
    th: 'การประมวลผลตัวย่อคำสั่ง G',
    ug: 'G كودىنى ئاددىيلاشتۇرۇش',
    vi: 'Viết Tắt Chỉ Dẫn Gia Công G',
    zh_tc: '加工G指令簡寫',
    ru: 'Краткое описание команды G',
    ko: '가공 G 명령 약어',
    bur: 'လုပ်ဆောင်မှု G-ညွှန်ကြားချက် အတိုကောက်',
    ben: 'প্রসেসিং G-কমান্ডের সংক্ষিপ্ত রূপ',
    tr: 'G kodu komutlarını kısalt',
    km: 'សរសេរខ្លីពាក្យបញ្ជា G',
    es: 'Procesamiento G abreviatura del comando',
    ar: 'اختصار أمر المعالجة G',
  },
  'cuttingDock.NCExportSettings.ZToW': {
    zh: '代码从Z轴换为W轴',
    en: 'Change Code from Z-Axis to W-Axis',
    id: 'Kode diubah dari sumbu z ke sumbu W',
    kz: 'Кодты Z осьінен W осіне ауыстыру',
    th: 'รหัสถูกเปลี่ยนจากแกน z เป็นแกน W',
    ug: 'Z ئوقىدىن W ئوقىغا ئالماشتۇرۇش',
    vi: 'Đổi Mã Từ Trục Z Sang Trục W',
    zh_tc: '代碼從Z軸換為W軸',
    ru: 'Код переключается с оси Z на ось W.',
    ko: 'Z축에서 W축으로 코드 변경',
    bur: 'ကုဒ်ကို Z ဝင်ရိုးမှ W ဝင်ရိုးသို့ပြောင်းပါ',
    ben: 'Z-অক্ষ থেকে W-অক্ষে কোড পরিবর্তন করুন',
    tr: 'Kodu Z ekseninden W eksenine değiştir',
    km: 'ប្តូរកូដពីអ័ក្ស Z ទៅអ័ក្ស W',
    es: 'El código se cambia del eje Z al eje W',
    ar: 'تم تغيير الرمز من محور Z إلى محور W',
  },
  'cuttingDock.NCExportSettings.knives': {
    zh: '排钻刀具',
    en: 'Drilling Tools',
    id: 'Alat pengeboran',
    kz: 'Кескіш зымдары',
    th: 'เครื่องมือขุดเจาะ',
    ug: 'تەرتىپلىك تۆشۈك پىچاقلىرى',
    vi: 'Dao Khoan Đa Bàn',
    zh_tc: '排鑽刀具',
    ru: 'Штурмовой инструмент',
    ko: '드릴링 공구',
    bur: 'အတန်းလိုက် အပေါက်ဖောက်စက် ကိရိယာ',
    ben: 'সারি-ড্রিলের টুল',
    tr: 'Sıra matkap takımları',
    km: 'ឧបករណ៍ដោតជួរ',
    es: 'Herramienta de perforación de filas',
    ar: 'أداة حفر الصفوف',
  },
  'cuttingDock.NCExportSettings.lineBreakSetting': {
    zh: '换行符格式设置',
    en: 'Line Break Format Settings',
    id: 'Pengaturan Format Line Break',
    kz: 'Жаңа саттардың пішімінің параметрлері',
    th: 'การตั้งค่ารูปแบบการแบ่งบรรทัด',
    ug: 'قۇر ئالماشتۇرۇش بەلگىسى فورماتى',
    vi: 'Cài Đặt Định Dạng Dòng Mới',
    zh_tc: '換行符格式設置',
    ru: 'Параметры форматирования строк',
    ko: '줄 바꿈 형식 설정',
    bur: 'အတန်းခွဲဖော်မတ်သတ်မှတ်ချက်များ',
    ben: 'লাইন ব্রেক ফরম্যাট সেটিংস',
    tr: 'Satır sonu biçimi ayarları',
    km: 'ការកំណត់ទ្រង់ទ្រាយបន្ទាត់ថ្មី',
    es: 'Configuración de formato de salto de línea',
    ar: 'إعداد تنسيق فاصل الأسطر',
  },
  'cuttingDock.NCExportSettings.codeFormatSetting': {
    zh: '文件编码格式设置',
    en: 'File Encoding Format Settings',
    id: 'Pengaturan format pengkodean file',
    kz: 'Файл кодтың пішімінің параметрлері',
    th: 'การตั้งค่ารูปแบบการเข้ารหัสไฟล์',
    ug: 'ھۆججەت كودلاش فورماتى',
    vi: 'Cài Đặt Định Dạng Mã Hóa Tệp',
    zh_tc: '文件編碼格式設置',
    ru: 'Параметры формата кодирования файлов',
    ko: '파일 인코딩 형식 설정',
    bur: 'ဖိုင်ကုဒ်ဖော်မတ်သတ်မှတ်ချက်များ',
    ben: 'ফাইল এনকোডিং ফরম্যাট সেটিংস',
    tr: 'Dosya kodlama biçimi ayarları',
    km: 'ការកំណត់ទ្រង់ទ្រាយកូដឯកសារ',
    es: 'Configuración de formato de codificación de archivo',
    ar: 'إعداد تنسيق ترميز الملف',
  },
  'cuttingDock.NCExportSettings.utf8bom': {
    zh: '带bom的UTF-8',
    en: 'UTF-8 with BOM',
    id: 'UTF-8 dengan bom',
    kz: 'BOM бар UTF-8',
    th: 'UTF-8 พร้อม BOM',
    ug: 'BOM لىق UTF-8',
    vi: 'UTF-8 Đeo BOM',
    zh_tc: '帶bom的UTF-8',
    ru: 'UTF - 8 с бомом',
    ko: 'bom 포함 UTF-8',
    bur: 'BOM ပါ UTF-8',
    ben: 'BOM সহ UTF-8',
    tr: 'BOM içeren UTF-8',
    km: 'UTF-8 ជាមួយ BOM',
    es: 'UTF-8 con BOM',
    ar: 'UTF-8 مع BOM',
  },
  'cuttingDock.NCExportSettings.oneCodeSetting': {
    zh: '板件条码设置',
    en: 'Panel Barcode Settings',
    id: 'Pengaturan Barcode Papan',
    kz: 'Тақтаның штрих-кодтың параметрлері',
    th: 'การตั้งค่าบาร์โค้ดบอร์ด',
    ug: 'تاختاي شىفىر تەڭشىكى',
    vi: 'Cài Đặt Mã Vạch Bàn',
    zh_tc: '板件條碼設置',
    ru: 'Настройка штрих - кода',
    ko: '보드 바코드 설정',
    bur: 'ပြားဘားကုဒ်သတ်မှတ်ချက်များ',
    ben: 'প্যানেল বারকোড সেটিংস',
    tr: 'Levha barkod ayarları',
    km: 'ការកំណត់បាកូដផ្ទាំង',
    es: 'Configuración de código de barras de placa',
    ar: 'إعداد الرمز الشريطي للوحة',
  },
  'cuttingDock.NCExportSettings.simplifyOneCode': {
    zh: '生成简易格式标签条码',
    en: 'Generate Simplified Format Label Barcode',
    id: 'Hasilkan Barcode Tag Format Sederhana',
    kz: 'Қарапайым пішімдегі штрих-кодтың генерациясы',
    th: 'สร้างบาร์โค้ดแท็กแบบง่าย ๆ',
    ug: 'ئاددىي فورماتلىق بەلگە شىفىرى ھاسىل قىلىش',
    vi: 'Tạo Mã Vạch Bàn Đơn Giản',
    zh_tc: '生成簡易格式標籤條碼',
    ru: 'Создание штрих - кода для тегов простого формата',
    ko: '간단한 형식 태그 바코드 생성',
    bur: 'အတိုကောက်ဖော်မတ်အညွှန်းဘားကုဒ်ထုတ်ပါ',
    ben: 'সরলীকৃত ফরম্যাট লেবেল বারকোড তৈরি করুন',
    tr: 'Basitleştirilmiş biçimde etiket barkodu oluştur',
    km: 'បង្កើតបាកូដស្លាកទ្រង់ទ្រាយសាមញ្ញ',
    es: 'Generar código de barras de etiqueta de formato simple',
    ar: 'إنشاء رمز شريطي للتسمية بتنسيق بسيط',
  },
  'cuttingDock.NCExportSettings.codeLocation': {
    zh: '代码位置设置',
    en: 'Code Location Settings',
    id: 'Pengaturan Lokasi Kode',
    kz: 'Кодтың орналасуының параметрлері',
    th: 'การตั้งค่าตำแหน่งรหัส',
    ug: 'كود ئورنى تەڭشىكى',
    vi: 'Cài Đặt Vị Trí Mã',
    zh_tc: '代碼位置設置',
    ru: 'Параметры расположения кода',
    ko: '코드 위치 설정',
    bur: 'ကုဒ်တည်နေရာသတ်မှတ်ချက်များ',
    ben: 'কোড লোকেশন সেটিংস',
    tr: 'Kod konumu ayarları',
    km: 'ការកំណត់ទីតាំងកូដ',
    es: 'Configuración de posición de código',
    ar: 'إعداد موضع الرمز',
  },
  'cuttingDock.NCExportSettings.generateLocation': {
    zh: '工位结束代码在反面结束代码前面生成',
    en: 'Generate station end code before the back side end code',
    id: 'Kode akhir stasiun kerja dihasilkan sebelum kode akhir terbalik',
    kz: 'Станс аяқталу коды арқасы беттің аяқталу коды алдында генералады',
    th: 'รหัสปลายสถานีทำงานถูกสร้างขึ้นก่อนรหัสปลายย้อนกลับ',
    ug: 'خىزمەت ئورنى ئاخىرلىشىش كودى ئارقا يۈز ئاخىرلىشىش كودىنىڭ ئالدىدا ھاسىل قىلىنىدۇ',
    vi: 'Tạo Mã Kết Thúc Công Vị Trước Mã Kết Thúc Mặt Sau',
    zh_tc: '工位結束代碼在反面結束代碼前面生成',
    ru: 'Код конца рабочего места генерируется перед кодом конца с обратной стороны.',
    ko: '작업 위치 종료 코드는 후면 종료 코드 앞에서 생성됩니다.',
    bur: 'နောက်ဘက်အဆုံးကုဒ်မတိုင်မီအလုပ်နေရာအဆုံးကုဒ်ထုတ်ပါ',
    ben: 'পিছনের দিকের এন্ড কোডের আগে স্টেশন এন্ড কোড তৈরি করুন',
    tr: 'İstasyon bitiş kodu, arka yüz bitiş kodundan önce oluşturulur',
    km: 'បង្កើតកូដបញ្ចប់ស្ថានីយ៍មុនកូដបញ្ចប់ខាងក្រោម',
    es: 'El código de fin de estación se genera antes que el código de fin inverso',
    ar: 'يتم إنشاء رمز نهاية المحطة قبل رمز النهاية العكسي',
  },
  'cuttingDock.NCExportSettings.emergencySetting': {
    zh: '应急设置',
    en: 'Emergency Settings',
    id: 'Pengaturan darurat',
    kz: 'Шұғылдық параметрлері',
    th: 'การตั้งค่าฉุกเฉิน',
    ug: 'جىددىي تەڭشەك',
    vi: 'Cài Đặt Khẩn Cấp',
    zh_tc: '應急設置',
    ru: 'Настройка на случай непредвиденных обстоятельств',
    ko: '비상 설치',
    bur: 'အရေးပေါ်သတ်မှတ်ချက်များ',
    ben: 'ইমারজেন্সি সেটিংস',
    tr: 'Acil durum ayarları',
    km: 'ការកំណត់សង្គ្រោះ',
    es: 'Configuraciones de emergencia',
    ar: 'إعدادات الطوارئ',
  },
  'cuttingDock.NCExportSettings.show': {
    zh: '显示应急设置',
    en: 'Show Emergency Settings',
    id: 'Tampilkan pengaturan darurat',
    kz: 'Шұғылдық параметрлерін көрсету',
    th: 'แสดงการตั้งค่าฉุกเฉิน',
    ug: 'جىددىي تەڭشەكنى كۆرسىتىش',
    vi: 'Hiển Thị Cài Đặt Khẩn Cấp',
    zh_tc: '顯示應急設置',
    ru: 'Показать параметры аварийности',
    ko: '비상 설정 표시',
    bur: 'အရေးပေါ်သတ်မှတ်ချက်ပြပါ',
    ben: 'ইমারজেন্সি সেটিংস দেখান',
    tr: 'Acil durum ayarlarını göster',
    km: 'បង្ហាញការកំណត់សង្គ្រោះ',
    es: 'Mostrar configuración de emergencia',
    ar: 'عرض إعدادات الطوارئ',
  },
  'cuttingDock.NCExportSettings.emergencyCode': {
    zh: '应急码',
    en: 'Emergency Code',
    id: 'Kode darurat',
    kz: 'Шұғылдық коды',
    th: 'รหัสฉุกเฉิน',
    ug: 'جىددىي كود',
    vi: 'Mã Khẩn Cấp',
    zh_tc: '應急碼',
    ru: 'аварийный код',
    ko: '비상코드',
    bur: 'အရေးပေါ်ကုဒ်',
    ben: 'ইমারজেন্সি কোড',
    tr: 'Acil kod',
    km: 'កូដសង្គ្រោះ',
    es: 'Código de emergencia',
    ar: 'رمز الطوارئ',
  },
  'cuttingDock.NCExportSettings.params': {
    zh: '参数',
    en: 'Parameters',
    id: 'parameter',
    kz: 'Параметрлер',
    th: 'พารามิเตอร์',
    ug: 'پارامېتىر',
    vi: 'Tham Số',
    zh_tc: '參數',
    ru: 'параметр',
    ko: '매개변수',
    bur: 'ပါရာမီတာများ',
    ben: 'প্যারামিটার',
    tr: 'Parametreler',
    km: 'ប៉ារ៉ាម៉ែត្រ',
    es: 'Parámetros',
    ar: 'المعلمات',
  },
  'cuttingDock.NCExportSettings.emergencyTip': {
    zh: '可在售后人员配合下临时实现一些小众功能',
    en: 'Can temporarily implement some niche features with the cooperation of after-sales personnel',
    id: 'Beberapa fungsi niche dapat untuk sementara waktu diimplementasikan dengan kerja sama personel setelah penjualan',
    kz: 'Сатушы қызметкерлермен бірге кейбір азиятты функцияларды уақытша іске асыруға болады',
    th: 'ฟังก์ชั่นเฉพาะบางอย่างสามารถนำไปใช้ชั่วคราวกับความร่วมมือของบุคลากรหลังการขาย',
    ug: 'سېتىشتىن كېيىنكى خىزمەتچىلەر بىلەن بىرلىكتە ۋاقىتلىق بەزى كىچىك ئىقتىدارلارنى ئەمەلگە ئاشۇرغىلى بولىدۇ',
    vi: 'Có Thể Thực Hiện Một Số Chức Năng Khác Nhau Tạm Thời Với Hỗ Trợ Từ Nhân Viên Hậu Mãi',
    zh_tc: '可在售後人員配合下臨時實現一些小眾功能',
    ru: 'Некоторые функции могут быть реализованы в сотрудничестве с персоналом после продажи.',
    ko: '판매 후 직원의 협조하에 임시로 일부 소규모 기능을 실현할 수 있다',
    bur: 'အရောင်းနောက်ပိုင်းဝန်ထမ်းများပူးပေါင်းခြင်းဖြင့်အချို့သောအင်္ဂါရပ်များယာယီအကောင်အထည်ဖော်နိုင်သည်',
    ben: 'আফটার-সেলস কর্মীদের সহযোগিতায় কিছু নিচ ফিচার সাময়িকভাবে বাস্তবায়ন করা যেতে পারে',
    tr: 'Satış sonrası personel iş birliğiyle bazı niş özellikler geçici olarak uygulanabilir',
    km: 'អាចអនុវត្តមុខងារពិសេសខ្លះជាបណ្តោះអាសន្នជាមួយការសហការពីបុគ្គលិកបន្ទាប់ពីលក់',
    es: 'Algunas funciones específicas se pueden implementar temporalmente con la cooperación del personal de posventa',
    ar: 'يمكن تنفيذ بعض الوظائف المتخصصة مؤقتًا بالتعاون مع موظفي ما بعد البيع',
  },
  'cuttingDock.NCExportSettings.holeSetting': {
    zh: '打孔文件设置',
    en: 'Hole punching file settings',
    id: 'Pengaturan file meninju',
    kz: 'Делтірілеу файлдың параметрлері',
    th: 'การตั้งค่าไฟล์',
    ug: 'تۆشۈك ئېچىش ھۆججىتى تەڭشىكى',
    vi: 'Cài Đặt Tệp Khoan Động',
    zh_tc: '打孔文件設置',
    ru: 'Параметры перфорации файла',
    ko: '펀치 파일 설정',
    bur: 'အပေါက်ဖောက်ဖိုင်သတ်မှတ်ချက်များ',
    ben: 'হোল পাঞ্চিং ফাইল সেটিংস',
    tr: 'Delik delme dosyası ayarları',
    km: 'ការកំណត់ឯកសារដោតរន្ធ',
    es: 'Configuración del archivo de perforación',
    ar: 'إعدادات ملف التثقيب',
  },
  'cuttingDock.NCExportSettings.holeFileCategorize': {
    zh: '打孔文件按不同订单分文件夹单独放置',
    en: 'Hole punching files are placed separately in folders according to different orders',
    id: 'File meninju ditempatkan secara terpisah sesuai dengan pesanan yang berbeda',
    kz: 'Делтірілеу файлдарды әрбір тапсырыс бойынша отынша папкада біріктіру',
    th: 'การเจาะไฟล์จะถูกวางแยกต่างหากตามคำสั่งซื้อที่แตกต่างกัน',
    ug: 'تۆشۈك ئېچىش ھۆججىتىنى ئوخشىمىغان بۇيرۇتما بويىچە ئايرىم ھۆججەت قىسقۇچىغا قويۇش',
    vi: 'Tệp Khoan Động Được Phân Loại Đến Khác Nhau Thư Mục Theo Đơn Hàng',
    zh_tc: '打孔文件按不同訂單分文件夾單獨放置',
    ru: 'Размещение перфорированных файлов в отдельных папках по различным заказам',
    ko: '펀치 파일은 주문에 따라 폴더별로 개별적으로 배치됩니다.',
    bur: 'အပေါက်ဖောက်ဖိုင်များကိုမတူညီသောအမိန့်များအလိုက်ဖိုလ်ဒါများတွင်သီးခြားထားပါ',
    ben: 'বিভিন্ন অর্ডার অনুযায়ী হোল পাঞ্চিং ফাইল আলাদা ফোল্ডারে রাখা হয়',
    tr: 'Delik dosyalarını farklı siparişlere göre ayrı klasörlere yerleştir',
    km: 'ដាក់ឯកសារដោតតាមការបញ្ជាទិញផ្សេងៗនៅថតដាច់ដោយឡែក',
    es: 'Los archivos de perforación se colocan por separado en carpetas según diferentes pedidos',
    ar: 'يتم وضع ملفات التثقيب بشكل منفصل في المجلدات حسب ترتيب مختلف',
  },
  'cuttingDock.NCExportSettings.holeTip': {
    zh: '对内嵌柜柜客户端的云排版不生效',
    en: 'Does not take effect on the cloud typesetting of the embedded cabinet client',
    id: 'Tata letak awan klien kabinet tertanam tidak berlaku',
    kz: 'Клиенттің бұлтты тақталар үшін бұл параметрлерің кۈшінеді',
    th: 'รูปแบบเมฆของไคลเอนต์ตู้ฝังไม่มีผลบังคับใช้',
    ug: 'ئىچكى ئورنىتىلغان ئىشكاپ تەرتىپلەش كىلىيېنتىنىڭ بۇلۇت تەرتىپلىشىگە ئۈنۈم كۆرسەتمەيدۇ',
    vi: 'Không Có Hiệu Lực Đối Với Bố Cục Đám Mây Khách Hàng Nội Tính Tủ',
    zh_tc: '對內嵌櫃櫃客戶端的雲排版不生效',
    ru: 'Облачная типография клиента встроенного шкафа не работает',
    ko: '내장 캐비닛 클라이언트에 대한 클라우드 레이아웃은 유효하지 않습니다.',
    bur: 'ထည့်သွင်းအကြံပြုချက်ကိုယ်အမှုဆောင်မိုးတိမ်တပ်ဆင်ခြင်းတွင်အကျိုးမသက်ရောက်ပါ',
    ben: 'এমবেডেড ক্যাবিনেট ক্লায়েন্টের ক্লাউড টাইপসেটিংয়ে প্রযোজ্য নয়',
    tr: 'Gömülü dolap istemcisinin bulut düzeninde geçerli değildir',
    km: 'មិនមានប្រសិទ្ធភាពលើការចងក្រងក្នុងពពកសម្រាប់កម្មវិធីខ្ចប់ទូរស័ព្ទ',
    es: 'La composición tipográfica en la nube para clientes con gabinete integrado no tiene efecto',
    ar: 'التنضيد السحابي لعملاء الخزانة المدمجة لا يسري مفعوله',
  },
  'cuttingDock.NCExportSettings.specialCodeErr': {
    zh: '不支持输入特殊字符!',
    en: 'Special characters are not supported!',
    id: 'Input karakter khusus tidak didukung!',
    kz: 'Арнайы символдар енгізуге болмайды!',
    th: 'ไม่รองรับอินพุตของอักขระพิเศษ!',
    ug: 'ئالاھىدە ھەرپلەرنى كىرگۈزۈشنى قوللىمايدۇ!',
    vi: 'Không Hỗ Trợ Nhập Ký Tự Đặc Biệt!',
    zh_tc: '不支持輸入特殊字符!',
    ru: 'Не поддерживается ввод специальных символов!',
    ko: '특수 문자 입력은 지원되지 않습니다!',
    bur: 'အထူးစာလုံးများမပံ့ပိုးပါ!',
    ben: 'বিশেষ অক্ষর সাপোর্ট করা হয় না!',
    tr: 'Özel karakter girişi desteklenmez!',
    km: 'មិនគាំទ្រការវាយបញ្ចូលតួអក្សរពិសេស!',
    es: '¡No se admiten caracteres especiales!',
    ar: 'الأحرف الخاصة غير مدعومة!',
  },
  'cuttingDock.NCExportSettings.copySuccess': {
    zh: '复制成功!',
    en: 'Copy successful!',
    id: 'Salin dengan sukses!',
    kz: 'Көшіру ішке асырылды!',
    th: 'คัดลอกสำเร็จ!',
    ug: 'كۆچۈرۈش مۇۋەپپەقىيەتلىك بولدى!',
    vi: 'Nhân Thành Công!',
    zh_tc: '複製成功!',
    ru: 'Репликация удалась!',
    ko: '복제 성공!',
    bur: 'ကူးယူအောင်မြင်ပါသည်!',
    ben: 'কপি সফল!',
    tr: 'Kopyalama başarılı!',
    km: 'ចម្លងជោគជ័យ!',
    es: '¡Copia exitosa!',
    ar: 'تم النسخ بنجاح!',
  },
  'cuttingDock.NCExportSettings.copyErr': {
    zh: '复制失败, 请尝试拖拽标签!',
    en: 'Copy failed, please try dragging the tag!',
    id: 'Menyalin gagal, coba seret dan menjatuhkan tag!',
    kz: 'Көшіру сәтсіз болды, Тегі сүйретуді сынап көріңіз!',
    th: 'การคัดลอกล้มเหลวโปรดลองลากและวางแท็ก!',
    ug: 'كۆچۈرۈش مەغلۇپ بولدى، بەلگىنى سۆرەپ سىناڭ!',
    vi: 'Nhân Thất Bại, Vui Lòng Thử Kéo Nhãn!',
    zh_tc: '複製失敗, 請嘗試拖拽標籤!',
    ru: 'Не удалось скопировать, попробуйте перетащить тег!',
    ko: '복사에 실패했습니다. 탭을 드래그해 보십시오!',
    bur: 'ကူးယူမှုမအောင်မြင်ပါ၊ အညွှန်းဆွဲကြည့်ပါ!',
    ben: 'কপি ব্যর্থ, ট্যাগ ড্র্যাগ করে দেখুন!',
    tr: 'Kopyalama başarısız, etiketi sürüklemeyi deneyin!',
    km: 'ចម្លងបរាជ័យ សាកល្បងអូសស្លាក!',
    es: 'La copia falló, intenta arrastrar la etiqueta.',
    ar: 'فشل النسخ، يرجى محاولة سحب الملصق!',
  },
  'cuttingDock.NCExportSettings.lengthLimit': {
    zh: '只支持输入15位!',
    en: 'Only supports input of 15 characters!',
    id: 'Hanya 15 bit yang dimasukkan!',
    kz: '15 цифрлықтар ғана енгізуге болады!',
    th: 'อินพุตเพียง 15 บิต!',
    ug: 'پەقەت 15 خانە كىرگۈزۈشنى قوللايدۇ!',
    vi: 'Chỉ Hỗ Trợ Nhập 15 Chữ Vị!',
    zh_tc: '只支持輸入15位!',
    ru: 'Поддерживается ввод только 15 цифр!',
    ko: '15비트 입력만 지원!',
    bur: '၁၅ လုံးသာထည့်သွင်းပံ့ပိုးသည်!',
    ben: 'শুধুমাত্র ১৫টি অক্ষর ইনপুট সাপোর্ট!',
    tr: 'Yalnızca 15 karakter girişi desteklenir!',
    km: 'គាំទ្រតែការវាយបញ្ចូល ១៥ តួ!',
    es: '¡Solo admite la entrada de 15 dígitos!',
    ar: 'يدعم إدخال 15 رقمًا فقط!',
  },
  'cuttingDock.NCExportSettings.plankInfo': {
    zh: '板件信息',
    en: 'Board information',
    id: 'Informasi papan',
    kz: 'Тақтаның ақпараты',
    th: 'ข้อมูลบอร์ด',
    ug: 'تاختاي ئۇچۇرى',
    vi: 'Thông Tin Bàn',
    zh_tc: '板件信息',
    ru: 'Сведения о панелях',
    ko: '보드 정보',
    bur: 'ပြားအချက်အလက်',
    ben: 'বোর্ড তথ্য',
    tr: 'Levha bilgisi',
    km: 'ព័ត៌មានផ្ទាំង',
    es: 'Información del tablero',
    ar: 'معلومات المجلس',
  },
  'cuttingDock.NCExportSettings.otherInfo': {
    zh: '其他信息',
    en: 'Other information',
    id: 'Informasi tambahan',
    kz: 'Басқа ақпарат',
    th: 'ข้อมูลเพิ่มเติม',
    ug: 'باشقا ئۇچۇرلار',
    vi: 'Thông Tin Khác',
    zh_tc: '其他信息',
    ru: 'другая информация',
    ko: '추가 정보',
    bur: 'အခြားအချက်အလက်',
    ben: 'অন্যান্য তথ্য',
    tr: 'Diğer bilgiler',
    km: 'ព័ត៌មានផ្សេងៗ',
    es: 'Otra información',
    ar: 'معلومات أخرى',
  },
  'cuttingDock.NCExportSettings.uniqueBarCode': {
    zh: '板件条码唯一',
    en: 'Unique barcode for the plate',
    id: 'Barcode yang unik',
    kz: 'Қаптама штрих-коды бірегей',
    th: 'บาร์โค้ดที่ไม่ซ้ำกัน',
    ug: 'تاختاي شىفىرى يەككە',
    vi: 'Mã Vạch Bàn Duy Nhất',
    zh_tc: '板件條碼唯一',
    ru: 'Уникальный штрих - код.',
    ko: '보드 바코드 고유',
    bur: 'ပြားအတွက်ထူးခြားဘားကုဒ်',
    ben: 'প্লেটের জন্য ইউনিক বারকোড',
    tr: 'Levha için benzersiz barkod',
    km: 'បាកូដមួយគត់សម្រាប់ផ្ទាំង',
    es: 'Código de barras de placa único',
    ar: 'لوحة الباركود فريدة من نوعها',
  },
  'cuttingDock.NCExportSettings.uniqueBarCodeForPack': {
    zh: '板件条码唯一(打包专用)',
    en: 'Unique barcode for the plata(Only for packaging)',
    id: 'Barcode papan unik (untuk kemasan)',
    kz: 'Қаптама үшін тақта штрих-коды бірегей',
    th: 'บาร์โค้ดบอร์ดที่ไม่ซ้ำกัน (สำหรับบรรจุภัณฑ์)',
    ug: 'تاختاي شىفىرى يەككە (بوغچىلاشقا خاس)',
    vi: 'Mã vạch của tấm là duy nhất (dành cho đóng gói)',
    zh_tc: '板件條碼唯一(打包專用)',
    ru: 'Уникальный штрих - код для досок (специально для упаковки)',
    ko: '보드 바코드 고유 (패키지 전용)',
    bur: 'ပြားဘားကုဒ်ထူးခြား (ထုပ်ပိုးခြင်းအတွက်သာ)',
    ben: 'প্লেটের ইউনিক বারকোড (শুধুমাত্র প্যাকেজিংয়ের জন্য)',
    tr: 'Levha için benzersiz barkod (yalnızca paketleme)',
    km: 'បាកូដមួយគត់សម្រាប់ផ្ទាំង (សម្រាប់តែការខ្ចប់)',
    es: 'Código de barras de placa único (solo para embalaje)',
    ar: 'لوحة باركود فريدة (للتعبئة فقط)',
  },
  'cuttingDock.NCExportSettings.machineOrder': {
    zh: '下料文件名生成加工序号',
    en: 'Generate processing sequence number from cutting file name',
    id: 'Memotong nama file untuk menghasilkan nomor urutan pemrosesan',
    kz: 'Құрал-сайманның өңдеу нөмірін жасау үшін файл атауы',
    th: 'การตัดชื่อไฟล์เพื่อสร้างหมายเลขลำดับการประมวลผล',
    ug: 'كېسىش ھۆججىتى ئىسمى ئىشلەش تەرتىپ نومۇرى ھاسىل قىلىدۇ',
    vi: 'Tên tệp cắt tạo số thứ tự gia công',
    zh_tc: '下料文件名生成加工序號',
    ru: 'Загрузить имя файла Создать серийный номер обработки',
    ko: '원본 파일 이름 가공 번호 생성',
    bur: 'ဖြတ်စက်ဖိုင်အမည်မှပြုပြင်အစဉ်နံပါတ်ထုတ်ပါ',
    ben: 'কাটিং ফাইল নাম থেকে প্রক্রিয়াকরণ সিকোয়েন্স নম্বর তৈরি করুন',
    tr: 'Kesim dosya adından işleme sıra numarası oluştur',
    km: 'បង្កើតលេខលំដាប់ដំណើរការពីឈ្មោះឯកសារកាត់',
    es: 'Generar número de serie de procesamiento a partir del nombre del archivo de corte',
    ar: 'إنشاء الرقم التسلسلي للمعالجة من اسم الملف الفارغ',
  },
  'cuttingDock.NCExportSettings.folderSetting': {
    zh: '同尺寸大板下料文件放在同一个文件夹',
    en: 'Place cutting files of the same size boards in the same folder',
    id: 'Tempatkan folder yang sama dengan piring besar dengan ukuran yang sama',
    kz: 'Бірдей өлшемдегі үлкен тақталардың файлдарын бір папкада сақтау',
    th: 'วางโฟลเดอร์เดียวกันกับแผ่นขนาดใหญ่ที่มีขนาดเท่ากัน',
    ug: 'ئوخشاش چوڭلۇقتىكى چوڭ تاختاي كېسىش ھۆججىتى ئوخشاش ھۆججەت قىسقۇچىغا قويۇلىدۇ',
    vi: 'Tệp cắt của bảng lớn cùng kích thước đặt trong cùng một thư mục',
    zh_tc: '同尺寸大板下料文件放在同一個文件夾',
    ru: 'Поместить файл в одну папку',
    ko: '동일한 크기의 대시보드 하단 파일을 같은 폴더에 배치',
    bur: 'အရွယ်တူပြားများ၏ဖြတ်စာဖိုင်များကိုတစ်ဖိုလ်ဒါတွင်ထားပါ',
    ben: 'একই সাইজের বোর্ডের কাটিং ফাইল একই ফোল্ডারে রাখুন',
    tr: 'Aynı boyuttaki büyük levhaların kesim dosyalarını aynı klasöre koy',
    km: 'ដាក់ឯកសារកាត់ផ្ទាំងធំទំហំដូចគ្នានៅថតដូចគ្នា',
    es: 'Colocar archivos de corte para placas grandes del mismo tamaño en la misma carpeta',
    ar: 'يتم وضع الملفات الفارغة للوحات الكبيرة ذات الحجم نفسه في نفس المجلد.',
  },
  'cuttingDock.NCExportSettings.labelImageINCFolder': {
    zh: '贴标图片跟随贴标文件放在NC文件夹里',
    en: 'Place the labeled images and accompanying label files in the NC folder',
    id: 'Gambar pelabelan ditempatkan di folder NC dengan file pelabelan',
    kz: 'Қойылған белгілердің сураттарын және біргелескен белгілік файлдарды NC папkasына орналастырыңыз',
    th: 'รูปภาพการติดฉลากจะถูกวางไว้ในโฟลเดอร์ NC พร้อมไฟล์การติดฉลาก',
    ug: 'بەلگە چاپلاش رەسىمى بەلگە چاپلاش ھۆججىتى بىلەن NC ھۆججەت قىسقۇچىسىغا قويۇلىدۇ',
    vi: 'Đặt hình ảnh đã dán nhãn và tệp nhãn đi kèm vào thư mục NC',
    zh_tc: '貼標圖片跟隨貼標文件放在NC文件夾裡',
    ru: 'Изображение с наклейкой следует за файлом с наклейкой в папке NC',
    ko: '맵 이미지는 맵 파일을 따라 NC 폴더에 배치됩니다.',
    bur: 'အညွှန်းပုံများနှင့်အညွှန်းဖိုင်များကို NC ဖိုလ်ဒါတွင်ထားပါ',
    ben: 'লেবেলযুক্ত ইমেজ ও লেবেল ফাইল NC ফোল্ডারে রাখুন',
    tr: 'Etiket görsellerini etiket dosyalarıyla birlikte NC klasörüne koy',
    km: 'ដាក់រូបភាពស្លាកជាមួយឯកសារស្លាកនៅថត NC',
    es: 'Colocar imágenes de etiquetado y archivos de etiquetado en la carpeta NC',
    ar: 'يتم وضع صورة الملصق في المجلد NC مع ملف الملصق.',
  },
  'cuttingDock.NCExportSettings.custom': {
    zh: '定制',
    en: 'Cutsom',
    id: 'dibuat khusus',
    kz: 'сварді',
    th: 'ทำเอง',
    ug: 'خاسلاشتۇرۇش',
    vi: 'đặt hàng riêng',
    zh_tc: '定制',
    ru: 'индивидуальный',
    ko: '커스터마이징',
    bur: 'စိတ်ကြိုက်',
    ben: 'কাস্টম',
    tr: 'Özel sipariş',
    km: 'ការកំណត់ផ្ទាល់ខ្លួន',
    es: 'Personalización',
    ar: 'مصنوع بطريقة مخصصة',
  },
  'cuttingDock.NCExportSettings.folderSettingTip': {
    zh: '注： 内嵌排版暂不支持此功能',
    en: 'Attention: Embedded layout does not support this feature yet',
    id: 'Catatan: Fitur ini belum didukung dalam pengaturan huruf tertanam',
    kz: 'Ескерту: Интеграцияланған орналастыру бұл функцияны қолдамайды',
    th: 'หมายเหตุ: คุณสมบัตินี้ยังไม่รองรับในการเรียงพิมพ์แบบฝังตัว',
    ug: 'دىققەت: ئىچكى ئورنىتىلغان تەرتىپلەش بۇ ئىقتىدارنى قوللىمايدۇ',
    vi: 'Lưu ý: Bố trí tích hợp chưa hỗ trợ chức năng này',
    zh_tc: '注： 內嵌排版暫不支持此功能',
    ru: 'Примечание: Встроенный набор временно не поддерживает эту функцию',
    ko: '참고: 인라인 레이아웃은 이 기능을 지원하지 않습니다.',
    bur: 'မှတ်ချက်: ထည့်သွင်းတပ်ဆင်ခြင်းသည်ဤအင်္ဂါရပ်ကိုအချိန်မတိုင်မီမပံ့ပိုးသေးပါ',
    ben: 'নোট: এমবেডেড লেআউট এখনও এই ফিচার সাপোর্ট করে না',
    tr: 'Not: Gömülü düzen bu özelliği henüz desteklemiyor',
    km: 'សម្គាល់៖ ការចងក្រងខ្ចប់មិនទាន់គាំទ្រមុខងារនេះទេ',
    es: 'Nota: La composición tipográfica en línea actualmente no admite esta función',
    ar: 'ملاحظة: التنضيد المضمن لا يدعم حاليًا هذه الوظيفة',
  },
  'cuttingDock.NCExportSettings.settingMoveTip': {
    zh: '原"{func}"功能已迁移到"{module}"页面中！',
    en: 'The original "{func}" function has been moved to the "{module}" page!',
    id: 'Fungsi "{func}" asli telah dipindahkan ke halaman "{Modul}"!',
    kz: '"{func}" функциясы "{module}" бетіне көшірілді!',
    th: 'ฟังก์ชั่น "{func}" ต้นฉบับถูกย้ายไปยังหน้า "{module}"!',
    ug: 'ئەسلىدىكى "{func}" ئىقتىدارى "{module}" بەتكە يۆتكەلدى!',
    vi: 'Chức năng "{func}" đã được chuyển đến trang "{module}"!',
    zh_tc: '原"{func}"功能已遷移到"{module}"頁面中！',
    ru: 'Исходная функция "{func}" перемещена на страницу "{module}"!',
    ko: '원래 "{func}" 기능은 "{module}" 페이지로 이동했습니다!',
    bur: 'မူရင်း "{func}" လုပ်ဆောင်ချက်ကို "{module}" စာမျက်နှာသို့ရွှေ့ပြီးပါပြီ!',
    ben: 'আসল "{func}" ফাংশন "{module}" পেজে সরানো হয়েছে!',
    tr: 'Orijinal "{func}" işlevi "{module}" sayfasına taşındı!',
    km: 'មុខងារ "{func}" ដើមត្រូវបានផ្លាស់ទីទៅទំព័រ "{module}"!',
    es: 'La función original "{func}" se ha migrado a la ¡Página "{module}"!',
    ar: 'تم ترحيل وظيفة "{func}" الأصلية إلى صفحة "{module}"!',
  },
  'cuttingDock.NCExportSettings.fileManagerFunction': {
    zh: '打孔文件按不同订单文件分文件夹单独放置',
    en: 'Place drilling files in separate folders according to different orders',
    id: 'File meninju ditempatkan secara terpisah sesuai dengan file pesanan yang berbeda',
    kz: 'Тесіктер файлы әр түрлі тапсырыстар бойынша бөлек папкаларда сақталады',
    th: 'การเจาะไฟล์จะถูกวางแยกต่างหากตามไฟล์คำสั่งซื้อที่แตกต่างกัน',
    ug: 'تۆشۈك ئېچىش ھۆججىتى ئوخشىمىغان بۇيرۇتما ھۆججىتى بويىچە ئايرىم ھۆججەت قىسقۇچىغا قويۇلىدۇ',
    vi: 'Tệp khoan được đặt riêng theo từng đơn hàng trong các thư mục khác nhau',
    zh_tc: '打孔文件按不同訂單文件分文件夾單獨放置',
    ru: 'Размещение перфорированных файлов в отдельных папках по различным заказам',
    ko: '펀치 파일은 주문 파일별로 폴더별로 개별적으로 배치됩니다.',
    bur: 'မတူညီသောအမိန့်များအလိုက်အပေါက်ဖောက်ဖိုင်များကိုသီးခြားဖိုလ်ဒါများတွင်ထားပါ',
    ben: 'বিভিন্ন অর্ডার অনুযায়ী ড্রিলিং ফাইল আলাদা ফোল্ডারে রাখুন',
    tr: 'Delik dosyalarını farklı sipariş dosyalarına göre ayrı klasörlere yerleştir',
    km: 'ដាក់ឯកសារដោតតាមឯកសារបញ្ជាទិញផ្សេងៗនៅថតដាច់ដោយឡែក',
    es: 'Los archivos de perforación se colocan por separado en carpetas según el orden de los diferentes archivos',
    ar: 'يتم وضع الملفات المثقوبة بشكل منفصل في مجلدات وفقًا لملفات الطلبات المختلفة.',
  },
  'cuttingDock.NCExportSettings.gotoSetting': {
    zh: '前往设置',
    en: 'Go to settings',
    id: 'Pergi ke Pengaturan',
    kz: 'Бағдарламаларға өту',
    th: 'ไปที่การตั้งค่า',
    ug: 'تەڭشەككە بېرىش',
    vi: 'Đi đến cài đặt',
    zh_tc: '前往設置',
    ru: 'Перейти к настройкам',
    ko: '설정으로 이동',
    bur: 'သတ်မှတ်ချက်သို့သွားပါ',
    ben: 'সেটিংসে যান',
    tr: 'Ayarlara git',
    km: 'ទៅកាន់ការកំណត់',
    es: 'Ir a configuración',
    ar: 'انتقل إلى الإعدادات',
  },
  'cuttingDock.NCExportSettings.singleFileTitle': {
    zh: '单独文件加工设置',
    en: 'Single File Processing Settings',
    id: 'Pengaturan pemrosesan file tunggal',
    kz: 'Жеке файлды өңдеу параметрлері',
    th: 'การตั้งค่าการประมวลผลไฟล์แยกต่างหาก',
    ug: 'ئايرىم ھۆججەت ئىشلەش تەڭشىكى',
    vi: 'Cài đặt xử lý tệp đơn',
    zh_tc: '單獨文件加工設置',
    ru: 'Параметры обработки отдельных файлов',
    ko: '개별 파일 만들기 설정',
    bur: 'တစ်ဖိုင်ပြုပြင်သတ်မှတ်ချက်များ',
    ben: 'সিঙ্গেল ফাইল প্রক্রিয়াকরণ সেটিংস',
    tr: 'Tek dosya işleme ayarları',
    km: 'ការកំណត់ដំណើរការឯកសារតែមួយ',
    es: 'Configuración de procesamiento de archivos individuales',
    ar: 'إعدادات معالجة الملفات الفردية',
  },
  'cuttingDock.NCExportSettings.slectSingleProcess': {
    zh: '选择单独输出工艺',
    en: 'Select single output process',
    id: 'Pilih proses keluaran tunggal',
    kz: 'Жеке шығару процесін таңдау',
    th: 'เลือกกระบวนการส่งออกแยก',
    ug: 'ئايرىم چىقىرىش جەريانىنى تاللاش',
    vi: 'Chọn quy trình xuất riêng',
    zh_tc: '選擇單獨輸出工藝',
    ru: 'Выберите отдельный процесс вывода',
    ko: '단독 출력 공정 선택',
    bur: 'သီးခြားထုတ်လုပ်မှုလုပ်ငန်းစဉ် ရွေးချယ်ပါ',
    ben: 'একক আউটপুট প্রক্রিয়া নির্বাচন করুন',
    tr: 'Tek çıktı sürecini seçin',
    km: 'ជ្រើសរើសដំណើរការនាំចេញតែមួយ',
    es: 'Seleccionar proceso de salida individual',
    ar: 'اختر عملية الإخراج المنفردة',
  },
  'cuttingDock.NCExportSettings.slectSingleProcessTip': {
    zh: '存在付费二次加工工艺，请删除后重新保存',
    en: 'Paid secondary processing processes still exist. Please remove them and save again',
    id: 'Masih ada proses pemrosesan sekunder berbayar, hapus lalu simpan kembali',
    kz: 'Ақылы қайталама өңдеу процестері бар, жойып қайта сақтаңыз',
    th: 'ยังมีกระบวนการแปรรูปทุติยภูมิแบบเสียเงินอยู่ กรุณาลบแล้วบันทึกใหม่',
    ug: 'ھەقلىق ئىككىنچى قېتىم ئىشلەش جەريانى مەۋجۇت، ئۆچۈرۈپ قايتا ساقلاڭ',
    vi: 'Vẫn còn quy trình gia công thứ cấp trả phí, vui lòng xóa rồi lưu lại',
    zh_tc: '存在付費二次加工工藝，請刪除後重新保存',
    ru: 'Есть платные процессы вторичной обработки, удалите их и сохраните снова',
    ko: '유료 2차 가공 공정이 남아 있습니다. 삭제 후 다시 저장하세요',
    bur: 'ငွေပေးရသော ဒုတိယအဆင့် လုပ်ငန်းစဉ်များ ရှိနေပါသည်၊ ဖျက်ပြီး ပြန်သိမ်းပါ',
    ben: 'পেইড সেকেন্ডারি প্রসেসিং প্রক্রিয়া রয়েছে, মুছে ফেলে আবার সংরক্ষণ করুন',
    tr: 'Ücretli ikincil işleme süreçleri mevcut, lütfen silip yeniden kaydedin',
    km: 'នៅតែមានដំណើរការកែច្នៃបន្ទាប់បង់ប្រាក់ សូមលុបហើយរក្សាទុកម្តងទៀត',
    es: 'Aún hay procesos de procesamiento secundario de pago; elimínelos y guarde de nuevo',
    ar: 'لا تزال هناك عمليات معالجة ثانوية مدفوعة، يرجى حذفها ثم الحفظ مرة أخرى',
  },
  'cuttingDock.NCExportSettings.setSingleRegularSize': {
    zh: '设置单独输出常规孔槽尺寸',
    en: 'Set regular hole and slot size for single output',
    id: 'Atur ukuran lubang dan slot reguler untuk keluaran tunggal',
    kz: 'Жеке шығару үшін әдеттегі тесік пен ойық өлшемін орнату',
    th: 'ตั้งค่าขนาดรูและร่องทั่วไปสำหรับการส่งออกแยก',
    ug: 'ئايرىم چىقىرىش ئۈچۈن ئادەتتىكى تۆشۈك/ئويۇق چوڭلۇقىنى تەڭشەش',
    vi: 'Thiết lập kích thước lỗ/rãnh thường cho xuất riêng',
    zh_tc: '設置單獨輸出常規孔槽尺寸',
    ru: 'Задать размер обычных отверстий и пазов для отдельного вывода',
    ko: '단독 출력 일반 홀/슬롯 치수 설정',
    bur: 'သီးခြားထုတ်လုပ်မှုအတွက် ပုံမှန်အပေါက်/အထစ် အရွယ်အစား သတ်မှတ်ပါ',
    ben: 'একক আউটপুটের জন্য সাধারণ গর্ত ও স্লটের আকার সেট করুন',
    tr: 'Tek çıktı için standart delik ve kanal boyutunu ayarlayın',
    km: 'កំណត់ទំហំរន្ធ/រនាំងធម្មតាសម្រាប់នាំចេញតែមួយ',
    es: 'Configurar tamaño de agujeros y ranuras normales para salida individual',
    ar: 'تعيين أبعاد الثقوب والفتحات العادية للإخراج المنفرد',
  },
  'cuttingDock.NCExportSettings.holeRange': {
    zh: '孔生效范围',
    en: 'Hole effective range',
    id: 'Rentang efektif lubang',
    kz: 'Тесіктің қолданылу диапазоны',
    th: 'ช่วงที่มีผลของรู',
    ug: 'تۆشۈكنىڭ كۈچكە ئىگە دائىرىسى',
    vi: 'Phạm vi hiệu lực của lỗ',
    zh_tc: '孔生效範圍',
    ru: 'Диапазон действия отверстия',
    ko: '홀 적용 범위',
    bur: 'အပေါက် သက်ရောက်မှု အပိုင်းအခြား',
    ben: 'গর্তের কার্যকর পরিসর',
    tr: 'Delik geçerli aralığı',
    km: 'ជួរមានប្រសិទ្ធភាពនៃរន្ធ',
    es: 'Rango efectivo del agujero',
    ar: 'نطاق سريان الثقب',
  },
  'cuttingDock.NCExportSettings.slotRange': {
    zh: '槽生效范围',
    en: 'Slot effective range',
    id: 'Rentang efektif slot',
    kz: 'Ойықтың қолданылу диапазоны',
    th: 'ช่วงที่มีผลของร่อง',
    ug: 'ئويۇقنىڭ كۈچكە ئىگە دائىرىسى',
    vi: 'Phạm vi hiệu lực của rãnh',
    zh_tc: '槽生效範圍',
    ru: 'Диапазон действия паза',
    ko: '슬롯 적용 범위',
    bur: 'အထစ် သက်ရောက်မှု အပိုင်းအခြား',
    ben: 'স্লটের কার্যকর পরিসর',
    tr: 'Kanal geçerli aralığı',
    km: 'ជួរមានប្រសិទ្ធភាពនៃរនាំង',
    es: 'Rango efectivo de la ranura',
    ar: 'نطاق سريان الفتحة',
  },
  'cuttingDock.NCExportSettings.holeRangeTip': {
    zh: '孔生效范围不能为空，请填写！',
    en: 'Hole effective range cannot be empty, please fill in!',
    id: 'Rentang efektif lubang tidak boleh kosong, silakan isi!',
    kz: 'Тесіктің қолданылу диапазоны бос болмауы керек, толтырыңыз!',
    th: 'ช่วงที่มีผลของรูต้องไม่เว้นว่าง กรุณากรอก!',
    ug: 'تۆشۈكنىڭ كۈچكە ئىگە دائىرىسى بوش بولماسلىقى كېرەك، تولدۇرۇڭ!',
    vi: 'Phạm vi hiệu lực của lỗ không được để trống, vui lòng nhập!',
    zh_tc: '孔生效範圍不可為空，請填寫！',
    ru: 'Диапазон действия отверстия не может быть пустым, заполните!',
    ko: '홀 적용 범위는 비워 둘 수 없습니다. 입력해 주세요!',
    bur: 'အပေါက် သက်ရောက်မှု အပိုင်းအခြားကို ဗလာမထားရ၊ ဖြည့်ပါ!',
    ben: 'গর্তের কার্যকর পরিসর খালি রাখা যাবে না, অনুগ্রহ করে পূরণ করুন!',
    tr: 'Delik geçerli aralığı boş olamaz, lütfen doldurun!',
    km: 'ជួរមានប្រសិទ្ធភាពនៃរន្ធមិនអាចទទេបានទេ សូមបំពេញ!',
    es: 'El rango efectivo del agujero no puede estar vacío, ¡complételo!',
    ar: 'لا يمكن أن يكون نطاق سريان الثقب فارغًا، يرجى التعبئة!',
  },
  'cuttingDock.NCExportSettings.slotRangeTip': {
    zh: '槽生效范围不能为空，请填写！',
    en: 'Slot effective range cannot be empty, please fill in!',
    id: 'Rentang efektif slot tidak boleh kosong, silakan isi!',
    kz: 'Ойықтың қолданылу диапазоны бос болмауы керек, толтырыңыз!',
    th: 'ช่วงที่มีผลของร่องต้องไม่เว้นว่าง กรุณากรอก!',
    ug: 'ئويۇقنىڭ كۈچكە ئىگە دائىرىسى بوش بولماسلىقى كېرەك، تولدۇرۇڭ!',
    vi: 'Phạm vi hiệu lực của rãnh không được để trống, vui lòng nhập!',
    zh_tc: '槽生效範圍不可留空，請填寫！',
    ru: 'Диапазон действия паза не может быть пустым, заполните!',
    ko: '슬롯 적용 범위는 비워 둘 수 없습니다. 입력해 주세요!',
    bur: 'အထစ် သက်ရောက်မှု အပိုင်းအခြားကို ဗလာမထားရ၊ ဖြည့်ပါ!',
    ben: 'স্লটের কার্যকর পরিসর খালি রাখা যাবে না, অনুগ্রহ করে পূরণ করুন!',
    tr: 'Kanal geçerli aralığı boş olamaz, lütfen doldurun!',
    km: 'ជួរមានប្រសិទ្ធភាពនៃរនាំងមិនអាចទទេបានទេ សូមបំពេញ!',
    es: 'El rango efectivo de la ranura no puede estar vacío, ¡complételo!',
    ar: 'لا يمكن أن يكون نطاق سريان الفتحة فارغًا، يرجى التعبئة!',
  },
  'cuttingDock.NCExportSettings.yhzc': {
    zh: '圆弧折弯部分直槽',
    en: 'Straight slot on arc-bent section',
    id: 'Slot lurus pada bagian lengkungan busur',
    kz: 'Доға иілу бөлігіндегі түзу ойық',
    th: 'ร่องตรงของส่วนโค้งงอแบบส่วนโค้ง',
    ug: 'يېرىم چەمبەر ئەگمە قىسمىدىكى توغرا ئويۇق',
    vi: 'Rãnh thẳng phần uốn cong hình cung',
    zh_tc: '圓弧折彎部分直槽',
    ru: 'Прямой паз на дугообразном участке',
    ko: '원호 절곡부 직선 슬롯',
    bur: 'အကွေးအပိုင်းရှိ တည့်အထစ်',
    ben: 'চাপ-বাঁকানো অংশের সরল স্লট',
    tr: 'Yay bükümlü bölümdeki düz kanal',
    km: 'រនាំងត្រង់នៅផ្នែកពត់រាងធ្នូ',
    es: 'Ranura recta en la sección curvada en arco',
    ar: 'فتحة مستقيمة في الجزء المنحني القوسي',
  },
  'cuttingDock.NCExportSettings.xbgy': {
    zh: '斜边海棠角和斜边拉手',
    en: 'Beveled Haitang corner and beveled handle',
    id: 'Sudut Haitang miring dan handle miring',
    kz: 'Қиғаш Haitang бұрышы және қиғаш тұтқа',
    th: 'มุม Haitang เอียงและที่จับเอียง',
    ug: 'يانتۇ Haitang بۇلۇڭ ۋە يانتۇ تۇتقۇچ',
    vi: 'Góc Haitang vát cạnh và tay nắm vát cạnh',
    zh_tc: '斜邊海棠角和斜邊拉手',
    ru: 'Скошенный угол Haitang и скошенная ручка',
    ko: '경사 해당 코너 및 경사 손잡이',
    bur: 'စောင်း Haitang ထောင့်နှင့် စောင်းလက်ကိုင်',
    ben: 'বেভেল Haitang কোণ ও বেভেল হ্যান্ডেল',
    tr: 'Eğimli Haitang köşesi ve eğimli kulp',
    km: 'មុំ Haitang ទ្រេត និងដៃចង្កឹះទ្រេត',
    es: 'Esquina Haitang biselada y asa biselada',
    ar: 'زاوية Haitang مشطوفة ومقبض مشطوف',
  },
  'cuttingDock.NCExportSettings.nbyx': {
    zh: '内部异形',
    en: 'Internal irregular shape',
    id: 'Bentuk tidak beraturan internal',
    kz: 'Ішкі пішінсіз пішін',
    th: 'รูปทรงผิดปกติภายใน',
    ug: 'ئىچكى ئالاھىدە شەكىل',
    vi: 'Hình dạng bất thường bên trong',
    zh_tc: '內部異形',
    ru: 'Внутренняя нестандартная форма',
    ko: '내부 이형',
    bur: 'အတွင်းပိုင်း ပုံမှန်မဟုတ်သော ပုံသဏ္ဍာန်',
    ben: 'অভ্যন্তরীণ অনিয়মিত আকৃতি',
    tr: 'İç düzensiz şekil',
    km: 'រាងមិនប្រក្រតីខាងក្នុង',
    es: 'Forma irregular interna',
    ar: 'شكل داخلي غير منتظم',
  },
  'cuttingDock.NCExportSettings.secondaryProcessingMerge': {
    zh: '二次加工文件合并',
    en: 'Secondary processing file merge',
    id: 'Penggabungan file pemrosesan sekunder',
    kz: 'Қайталама өңдеу файлдарын біріктіру',
    th: 'การรวมไฟล์การประมวลผลทุติยภูมิ',
    ug: 'ئىككىنچى قېتىم ئىشلەش ھۆججىتىنى بىرلەشتۈرۈش',
    vi: 'Gộp tệp gia công thứ cấp',
    zh_tc: '二次加工文件合併',
    ru: 'Объединение файлов вторичной обработки',
    ko: '2차 가공 파일 병합',
    bur: 'ဒုတိယအဆင့် လုပ်ငန်းဖိုင်များ ပေါင်းစည်းခြင်း',
    ben: 'সেকেন্ডারি প্রসেসিং ফাইল একত্রীকরণ',
    tr: 'İkincil işleme dosya birleştirme',
    km: 'បញ្ចូលឯកសារដំណើរការបន្ទាប់',
    es: 'Fusión de archivos de procesamiento secundario',
    ar: 'دمج ملفات المعالجة الثانوية',
  },
  'cuttingDock.NCExportSettings.secondaryProcessingMergeName': {
    zh: '合并文件名',
    en: 'Merged file name',
    id: 'Nama file gabungan',
    kz: 'Біріктірілген файл атауы',
    th: 'ชื่อไฟล์ที่รวม',
    ug: 'بىرلەشتۈرۈلگەن ھۆججەت نامى',
    vi: 'Tên tệp đã gộp',
    zh_tc: '合併文件名',
    ru: 'Имя объединённого файла',
    ko: '병합 파일명',
    bur: 'ပေါင်းစည်းဖိုင်အမည်',
    ben: 'একত্রিত ফাইলের নাম',
    tr: 'Birleştirilmiş dosya adı',
    km: 'ឈ្មោះឯកសារបញ្ចូល',
    es: 'Nombre del archivo fusionado',
    ar: 'اسم الملف المدمج',
  },
  'cuttingDock.NCExportSettings.secondaryProcessingMergeTip': {
    zh: '开启当导出的板件存在多个二次加工工艺，则会合并到同一个加工文件',
    en: 'When enabled, if the exported panel has multiple secondary processes, they will be merged into one processing file',
    id: 'Jika diaktifkan, saat panel ekspor memiliki beberapa proses sekunder, akan digabung ke satu file pemrosesan',
    kz: 'Қосылғанда, экспортталған тақтада бірнеше қайталама өңдеу процесі болса, бір өңдеу файлына біріктіріледі',
    th: 'เมื่อเปิดใช้งาน หากแผ่นที่ส่งออกมีหลายกระบวนการทุติยภูมิ จะถูกรวมเป็นไฟล์ประมวลผลเดียวกัน',
    ug: 'ئېچىلغاندا، ئېكسپورت قىلىنغان تاختا كۆپ ئىككىنچى قېتىم ئىشلەش جەريانىغا ئىگە بولسا، بىر ئىشلەش ھۆججىتىگە بىرلەشتۈرۈلىدۇ',
    vi: 'Khi bật, nếu tấm xuất có nhiều quy trình gia công thứ cấp sẽ được gộp vào cùng một tệp gia công',
    zh_tc: '開啟後，當導出的板件存在多個二次加工工藝，則會合併到同一個加工文件',
    ru: 'При включении, если у экспортируемой плиты несколько процессов вторичной обработки, они будут объединены в один файл',
    ko: '사용 시 내보낸 판재에 2차 가공 공정이 여러 개 있으면 하나의 가공 파일로 병합됩니다',
    bur: 'ဖွင့်ထားပါက တင်ပို့ဘုတ်တွင် ဒုတိယအဆင့် လုပ်ငန်းစဉ်များစွာရှိလျှင် တစ်ဖိုင်တည်းသို့ ပေါင်းစည်းသည်',
    ben: 'চালু থাকলে, রপ্তানিকৃত প্যানেলে একাধিক সেকেন্ডারি প্রক্রিয়া থাকলে একই প্রসেসিং ফাইলে একত্রিত হবে',
    tr: 'Açıldığında, dışa aktarılan panelde birden fazla ikincil işlem varsa tek bir işleme dosyasında birleştirilir',
    km: 'នៅពេលបើក ប្រសិនបើផ្ទាំងនាំចេញមានដំណើរការបន្ទាប់ច្រើន នឹងត្រូវបញ្ចូលទៅក្នុងឯកសារដំណើរការតែមួយ',
    es: 'Al activarlo, si el tablero exportado tiene varios procesos secundarios, se fusionarán en un mismo archivo de procesamiento',
    ar: 'عند التفعيل، إذا كان اللوح المُصدَّر يحتوي على عدة عمليات معالجة ثانوية، فسيتم دمجها في ملف معالجة واحد',
  },
  'cuttingDock.NCExportSettings.singleFileSetting': {
    zh: '输出单独文件加工斜边款海棠角和斜边拉手',
    en: 'Output single file processing with beveled edges, cherry blossom corners, and slanted handles',
    id: 'Keluaran pemrosesan file tunggal dengan tepi bevel, sudut cherry blossom, dan sisi miring',
    kz: 'Жеке файлды өңдеуді қиғаш жиектермен, шие гүлінің бұрыштарымен және қиғаш тұтқалармен шығару',
    th: 'ส่งออกไฟล์แยกสำหรับการประมวลผลมุมเบโกเนียแบบเอียงและที่จับแบบเอียง',
    ug: 'يانتۇ چەت چاپلاش تۈرىدىكى گۈل بۇلۇڭ ۋە يانتۇ چەت تۇتقۇچنى ئايرىم ھۆججەتتە ئىشلەش',
    vi: 'Xuất tệp xử lý đơn với các cạnh chéo, góc hoa anh đào và tay cầm chéo',
    zh_tc: '輸出單獨文件加工斜邊款海棠角和斜邊拉手',
    ru: 'Выход отдельных файлов обработка наклонной стороны',
    ko: '개별 파일 머시닝 베고니아 코너 내보내기 및 베고니아 손잡이',
    bur: 'ချောမွေ့အစွန်း၊ ပန်းထောင့်နှင့်စောင်းလက်ကိုင်ပါသောတစ်ဖိုင်ပြုပြင်ထုတ်ပါ',
    ben: 'বেভেল এজ, চেরি ব্লসম কর্নার ও স্ল্যান্টেড হ্যান্ডেল সহ সিঙ্গেল ফাইল প্রক্রিয়াকরণ আউটপুট করুন',
    tr: 'Eğimli kenar, begonya köşesi ve eğimli kulp için tek dosya işleme çıktısı',
    km: 'ទិន្នផលដំណើរការឯកសារតែមួយសម្រាប់គែមទ្រេត មុំបេកូនៀ និងដៃចង្កឹះទ្រេត',
    es: 'Generar archivos individuales para procesar esquinas biseladas y manijas de borde biselado',
    ar: 'قم بإخراج ملفات منفصلة لمعالجة زوايا التفاحة المشطوفة والمقابض المشطوفة',
  },
  'cuttingDock.NCExportSettings.straightArcSlot': {
    zh: '输出单独文件加工圆弧折弯部分的直槽',
    en: 'Output single file processing with straight slots in arc-bent parts',
    id: 'Keluaran pemrosesan file tunggal dengan slot lurus dalam bagian yang dibengkokkan',
    kz: 'Жеке файлды өңдеуді көлбеу бұрышты жиектермен шығару',
    th: 'ส่งออกไฟล์แยกสำหรับการประมวลผลร่องตรงของชิ้นส่วนโค้งงอ',
    ug: 'يانتۇ چەت چاپلاش تۈرىدىكى گۈل بۇلۇڭ ۋە يانتۇ چەت تۇتقۇچنى ئايرىم ھۆججەتتە ئىشلەش',
    vi: 'Xuất tệp xử lý đơn với các rãnh thẳng trong các phần uốn cong',
    zh_tc: '輸出單獨文件加工圓弧折彎部分的直槽',
    ru: 'Вывод отдельного файла в прямое отверстие',
    ko: '호 벤드 부분을 가공하는 별도의 파일을 내보내는 직선 슬롯',
    bur: 'ချိုးကွေးအစိတ်အပိုင်းများရှိဖြောင့်အခေါင်းများပါတစ်ဖိုင်ပြုပြင်ထုတ်ပါ',
    ben: 'আর্ক-বেন্ট অংশে স্ট্রেইট স্লট সহ সিঙ্গেল ফাইল প্রক্রিয়াকরণ আউটপুট করুন',
    tr: 'Yay büküm bölgelerinde düz oluklar için tek dosya işleme çıktısı',
    km: 'ទិន្នផលដំណើរការឯកសារតែមួយសម្រាប់រណ្តៅផ្ទាត់នៅផ្នែកបត់រង្វង់',
    es: 'Generar archivos individuales para procesar ranuras rectas de piezas dobladas por arco',
    ar: 'قم بإخراج ملف منفصل لمعالجة الأخدود المستقيم لجزء الانحناء القوسي',
  },
  'cuttingDock.aioMachineSetting.openFunction': {
    zh: '对接需开启以下功能',
    en: 'The following functions need to be enabled for docking',
    id: 'Docking membutuhkan fungsi -fungsi berikut untuk diaktifkan',
    kz: 'Байланыстыру үшін келесі функцияларды қосу қажет',
    th: 'การเชื่อมต่อต้องเปิดใช้งานฟังก์ชั่นต่อไปนี้',
    ug: 'ئۇلىنىشقا تۆۋەندىكى ئىقتىدارلارنى ئېچىش كېرەك',
    vi: 'Cần bật các chức năng sau để kết nối',
    zh_tc: '對接需開啟以下功能',
    ru: 'Стыковка должна включать следующие функции.',
    ko: '도킹은 다음 기능을 켜야 합니다.',
    bur: 'ချိတ်ဆက်ရန်အောက်ပါလုပ်ဆောင်ချက်များဖွင့်ရမည်',
    ben: 'ডকিংয়ের জন্য নিচের ফাংশনগুলো সক্ষম করতে হবে',
    tr: 'Bağlantı için aşağıdaki işlevlerin etkinleştirilmesi gerekir',
    km: 'ត្រូវបើកមុខងារខាងក្រោមសម្រាប់ការភ្ជាប់',
    es: 'Las siguientes funciones deben activarse para el acoplamiento',
    ar: 'يجب تشغيل الوظائف التالية للإرساء',
  },
  'cuttingDock.aioMachineSetting.openCarving': {
    zh: '开启雕刻机',
    en: 'Enable the carving machine',
    id: 'Nyalakan mesin ukiran',
    kz: 'Ою машинасын қосу',
    th: 'เปิดเครื่องแกะสลัก',
    ug: 'ئويما ماشىنىسىنى ئېچىش',
    vi: 'Bật máy chạm khắc',
    zh_tc: '開啟雕刻機',
    ru: 'Включите гравировальную машину.',
    ko: '조각기를 켜다',
    bur: 'ထွင်းထုစက်ဖွင့်ပါ',
    ben: 'খোদাই মেশিন সক্ষম করুন',
    tr: 'Oyma makinesini etkinleştir',
    km: 'បើកម៉ាស៊ីនចុកចាក់',
    es: 'Activar la función de intercambio de ejes de la máquina de grabado',
    ar: 'قم بتشغيل آلة النقش',
  },
  'cuttingDock.aioMachineSetting.xyReverseFunction': {
    zh: 'XY轴互换功能',
    en: 'XY Axis Swap Function',
    id: 'Fungsi pertukaran sumbu xy',
    kz: 'XY осін ауыстыру функциясы',
    th: 'ฟังก์ชั่นการแลกเปลี่ยนแกน xy',
    ug: 'XY ئوقى ئالماشتۇرۇش ئىقتىدارى',
    vi: 'Chức năng hoán đổi trục XY',
    zh_tc: 'XY軸互換功能',
    ru: 'Функция обмена осями XY',
    ko: 'XY 축 교환 기능',
    bur: 'XY ဝင်ရိုးအပြန်အလှန်လုပ်ဆောင်ချက်',
    ben: 'XY অক্ষ সোয়াপ ফাংশন',
    tr: 'XY eksen takası işlevi',
    km: 'មុខងារប្តូរអ័ក្ស XY',
    es: 'XY',
    ar: 'XYوظيفة تبادل المحاور',
  },
  'cuttingDock.aioMachineSetting.carvingStartSet': {
    zh: '雕刻机工位起始点设置为',
    en: 'Set the carving machine start position to',
    id: 'Titik awal stasiun mesin ukiran diatur ke',
    kz: 'Ою машинасының басталу нүктесін орнату',
    th: 'จุดเริ่มต้นของสถานีแกะสลักถูกตั้งค่าเป็น',
    ug: 'ئويما ماشىنىسى خىزمەت ئورنى باشلىنىش نۇقتىسى',
    vi: 'Đặt vị trí bắt đầu của máy chạm khắc thành',
    zh_tc: '雕刻機工位起始點設置為',
    ru: 'Начальная точка установки гравировочной машины установлена как',
    ko: '조각기 작업공간 시작점 설정',
    bur: 'ထွင်းထုစက်စတင်တည်နေရာသတ်မှတ်ပါ',
    ben: 'খোদাই মেশিনের স্টার্ট পজিশন সেট করুন',
    tr: 'Oyma makinesi istasyon başlangıç noktası şu şekilde ayarlansın:',
    km: 'កំណត់ចំណុចចាប់ផ្តើមស្ថានីយ៍ម៉ាស៊ីនចុកចាក់ទៅជា៖',
    es: 'El punto de inicio de la estación de la máquina de grabado se establece en',
    ar: 'تم ضبط نقطة البداية لمحطة آلة النقش على',
  },
  'cuttingDock.aioMachineSetting.rightTop': {
    zh: '右上角',
    en: 'Top Right',
    id: 'Sudut kanan atas',
    kz: 'Жоғарғы оң жақ бұрыш',
    th: 'มุมขวาบน',
    ug: 'ئوڭ ئۈستى بۇلۇڭ',
    vi: 'Góc trên bên phải',
    zh_tc: '右上角',
    ru: 'Верхний правый угол',
    ko: '오른쪽 위',
    bur: 'ညာအပေါ်ထောင့်',
    ben: 'ডান উপরে',
    tr: 'Sağ üst',
    km: 'ខាងលើស្តាំ',
    es: 'Esquina superior derecha',
    ar: 'الزاوية اليمنى العليا',
  },
  'cuttingDock.aioMachineSetting.carvingEdgeSet': {
    zh: '雕刻机正面再修边值调整为',
    en: 'Adjust the front edge trimming value of the carving machine to',
    id: 'Bagian depan mesin ukiran disesuaikan',
    kz: 'Ою машинасының алдыңғы жиегін кесу мәнін реттеу',
    th: 'ด้านหน้าของเครื่องแกะสลักถูกปรับให้เป็น',
    ug: 'ئويما ماشىنىسى ئالدى يۈزى قايتا تۈزىتىش قىممىتى',
    vi: 'Điều chỉnh giá trị cắt cạnh trước của máy chạm khắc thành',
    zh_tc: '雕刻機正面再修邊值調整為',
    ru: 'Перекройка передней части гравировальной машины',
    ko: '조각기 전면 재수리 모서리 값은',
    bur: 'ထွင်းထုစက်ရှေ့ဘက်အစွန်းညှိတန်ဖိုးပြင်ဆင်ပါ',
    ben: 'খোদাই মেশিনের সামনের এজ ট্রিমিং মান অ্যাডজাস্ট করুন',
    tr: 'Oyma makinesi ön yüz ek kenar düzeltme değeri şu şekilde ayarlansın:',
    km: 'កែតម្រូវតម្លៃកែសម្រួលគែមខាងមុខម៉ាស៊ីនចុកចាក់ទៅជា៖',
    es: 'El valor de recorte frontal de la máquina de grabado se ajusta a',
    ar: 'يتم ضبط قيمة إعادة التشذيب الأمامية لآلة النقش على',
  },
  'cuttingDock.aioMachineSetting.finalEdgeSame': {
    zh: '与总修边值相同',
    en: 'Same as the final trimming value',
    id: 'Sama seperti nilai total selesai',
    kz: 'Жалпы жиегін кесу мәнімен бірдей',
    th: 'เช่นเดียวกับค่าเสร็จสิ้นทั้งหมด',
    ug: 'ئومۇمىي تۈزىتىش قىممىتى بىلەن ئوخشاش',
    vi: 'Bằng với giá trị cắt cuối cùng',
    zh_tc: '與總修邊值相同',
    ru: 'То же, что и общий ремонт.',
    ko: '총 트림된 모서리 값과 동일',
    bur: 'စုစုပေါင်းအစွန်းညှိတန်ဖိုးနှင့်တူသည်',
    ben: 'চূড়ান্ত ট্রিমিং মানের মতোই',
    tr: 'Toplam kenar düzeltme değeri ile aynı',
    km: 'ដូចគ្នានឹងតម្លៃកែសម្រួលគែមសរុប',
    es: ', que es el mismo que el valor de recorte total',
    ar: 'وهي نفس قيمة التشذيب الإجمالية',
  },
  'cuttingDock.aioMachineSetting.beginCode': {
    zh: '程序开始代码',
    en: 'Program Start Code',
    id: 'Kode Mulai Program',
    kz: 'Бағдарламаның басталу коды',
    th: 'รหัสเริ่มโปรแกรม',
    ug: 'پروگرامما باشلىنىش كودى',
    vi: 'Mã bắt đầu chương trình',
    zh_tc: '程序開始代碼',
    ru: 'Код начала программы',
    ko: '프로그램 시작 코드',
    bur: 'ပရိုဂရမ်စတင်ကုဒ်',
    ben: 'প্রোগ্রাম স্টার্ট কোড',
    tr: 'Program başlangıç kodu',
    km: 'កូដចាប់ផ្តើមកម្មវិធី',
    es: 'Código de inicio del programa',
    ar: 'رمز بدء البرنامج',
  },
  'cuttingDock.aioMachineSetting.endCode': {
    zh: '程序结束代码',
    en: 'Program End Code',
    id: 'Kode Akhir Program',
    kz: 'Бағдарламаның аяқталу коды',
    th: 'รหัสจบโปรแกรม',
    ug: 'پروگرامما ئاخىرلىشىش كودى',
    vi: 'Mã kết thúc chương trình',
    zh_tc: '程序結束代碼',
    ru: 'Код окончания программы',
    ko: '프로그램 종료 코드',
    bur: 'ပရိုဂရမ်အဆုံးကုဒ်',
    ben: 'প্রোগ্রাম এন্ড কোড',
    tr: 'Program bitiş kodu',
    km: 'កូដបញ្ចប់កម្មវិធី',
    es: 'Código de finalización del programa',
    ar: 'رمز نهاية البرنامج',
  },
  'cuttingDock.aioMachineSetting.drillHole': {
    zh: '打孔',
    en: 'Drill Hole',
    id: 'Lubang meninju',
    kz: 'Тесік бұрғылау',
    th: 'การเจาะรู',
    ug: 'تۆشۈك تېشىش',
    vi: 'Khoan lỗ',
    zh_tc: '打孔',
    ru: 'пробивать отверстие',
    ko: '펀치',
    bur: 'အပေါက်ဖောက်',
    ben: 'ড্রিল হোল',
    tr: 'Delik del',
    km: 'ដោតរន្ធ',
    es: 'Taladrado',
    ar: 'الحفر',
  },
  'cuttingDock.aioMachineSetting.pullTrough': {
    zh: '拉槽',
    en: 'Pull Trough',
    id: 'Tarik slotnya',
    kz: 'Арнаны тарту',
    th: 'ดึงสล็อต',
    ug: 'يوچۇق تارتىش',
    vi: 'Kéo rãnh',
    zh_tc: '拉槽',
    ru: 'Вытягивание канавки',
    ko: '슬롯을 당기다',
    bur: 'အချိုးဆွဲခြင်း',
    ben: 'স্লট টানুন',
    tr: 'Oluk çek',
    km: 'រណ្តៅទាញ',
    es: 'Ranurado',
    ar: 'الحز',
  },
  'cuttingDock.aioMachineSetting.showDataTemp': {
    zh: '显示数据样例',
    en: 'Show Data Sample',
    id: 'Tampilkan sampel data',
    kz: 'Деректер үлгісін көрсету',
    th: 'แสดงตัวอย่างข้อมูล',
    ug: 'سانلىق مەلۇمات ئۈلگىسىنى كۆرسىتىش',
    vi: 'Hiển thị mẫu dữ liệu',
    zh_tc: '顯示數據樣例',
    ru: 'Показать примеры данных',
    ko: '데이터 샘플 표시',
    bur: 'ဒေတာနမူနာပြပါ',
    ben: 'ডেটা নমুনা দেখান',
    tr: 'Veri örneğini göster',
    km: 'បង្ហាញគំរូទិន្នន័យ',
    es: 'Mostrar muestra de datos',
    ar: 'عرض عينة البيانات',
  },
  'cuttingDock.aioMachineSetting.dataTemp': {
    zh: '数据样例',
    en: 'Data Sample',
    id: 'Sampel data',
    kz: 'Деректер үлгісі',
    th: 'ตัวอย่างข้อมูล',
    ug: 'سانلىق مەلۇمات ئۈلگىسى',
    vi: 'Mẫu dữ liệu',
    zh_tc: '數據樣例',
    ru: 'Примеры данных',
    ko: '데이터 샘플',
    bur: 'ဒေတာနမူနာ',
    ben: 'ডেটা নমুনা',
    tr: 'Veri örneği',
    km: 'គំរូទិន្នន័យ',
    es: 'Muestra de datos',
    ar: 'عينة البيانات',
  },
  'cuttingDock.aioMachineSetting.title': {
    zh: '一体机设置',
    en: 'All-in-one machine settings',
    id: 'Pengaturan all-in-one',
    kz: 'Бірліктегі машина параметрлері',
    th: 'การตั้งค่า all-in-one',
    ug: 'بىر گەۋدىلىك ماشىنا تەڭشىكى',
    vi: 'Cài Đặt Máy Một Thân',
    zh_tc: '一體機設置',
    ru: 'Настройка единой машины',
    ko: '올인원 설정',
    bur: 'တစ်ကိုယ်တည်းစက်ဆက်တင်း',
    ben: 'অল-ইন-ওয়ান মেশিন সেটিংস',
    tr: 'Hepsi bir arada makine ayarları',
    km: 'ការកំណត់ម៉ាស៊ីនរួមមួយ',
    es: 'Configuración de la máquina todo en uno',
    ar: 'إعدادات آلة الكل في واحد',
  },
  'cuttingDock.aioMachineSetting.outputFile': {
    zh: '输出一体机加工文件',
    en: 'Output processing file for all-in-one machine',
    id: 'Output file permesinan all-in-one',
    kz: 'Бірліктегі машина өңдеу файлын шығару',
    th: 'เอาต์พุตไฟล์การตัดเฉือนแบบ all-in-one',
    ug: 'بىر گەۋدىلىك ماشىنا ئىشلەش ھۆججىتىنى چىقىرىش',
    vi: 'Xuất Tệp Gia Công Máy Một Thân',
    zh_tc: '輸出一體機加工文件',
    ru: 'Экспорт файлов',
    ko: '올인원 머시닝 파일 내보내기',
    bur: 'တစ်ကိုယ်တည်းစက်အသုံးပြုဖိုင်ထုတ်ပါ',
    ben: 'অল-ইন-ওয়ান মেশিন প্রসেসিং ফাইল আউটপুট',
    tr: 'Hepsi bir arada makine işleme dosyasını dışa aktar',
    km: 'នាំចេញឯកសារដំណើរការម៉ាស៊ីនរួមមួយ',
    es: 'Salida de archivos de procesamiento de la máquina todo en uno',
    ar: 'إخراج ملفات معالجة آلة الكل في واحد',
  },
  'cuttingDock.aioMachineSetting.outputFileTips': {
    zh: '部分品牌的一体机，与XY互换、文件合并、不打穿异形孔不兼容，请谨慎使用',
    en: 'After enabling the all-in-one machine, it is not compatible with XY interchangeable file merging without penetrating the irregular holes. Please use it with caution',
    id: 'Beberapa merek mesin all-in-one tidak sesuai dengan XY Exchange, penggabungan file, dan tidak ada lubang berbentuk khusus yang tertusuk. Harap gunakan dengan hati -hati.',
    kz: 'Бірліктегі машина іске қосілгенде, XY-ді орнамастыру, файлдарды біріктіру, атайын тіркелімді тесіктік шегуімен іске асыру қосымшалар міндетті емес, оқшамауыш пайдалану',
    th: 'เครื่องจักร All-in-One บางยี่ห้อไม่เข้ากันกับ XY Exchange การรวมไฟล์และไม่มีการเจาะรูรูปทรงพิเศษ โปรดใช้พวกเขาด้วยความระมัดระวัง',
    ug: 'قىسمەن ماركىلىق بىر گەۋدىلىك ماشىنا XY ئالماشتۇرۇش، ھۆججەت بىرلەشتۈرۈش، غەيرى شەكىللىك تۆشۈكنى تېشىپ ئۆتمەسلىك بىلەن ماسلاشمايدۇ، دىققەت قىلىڭ',
    vi: 'Một số thương hiệu máy một thân không tương thích với hoán đổi XY, hợp nhất tệp, không khoan hình dạng khác, vui lòng sử dụng thận trọng',
    zh_tc:
      '部分品牌的一體機，與XY互換、文件合併、不打穿異形孔不兼容，請謹慎使用',
    ru: 'Некоторые бренды единой машины, с обменом XY, слияние файлов, не пробивание профиля отверстия несовместимо, пожалуйста, используйте осторожно',
    ko: '일부 브랜드의 올인원 컴퓨터는 XY 교환, 파일 병합, 이형 구멍을 뚫지 않는 것과 호환되지 않으므로 주의해서 사용하십시오',
    bur: 'တစ်ကိုယ်တည်းစက်ဖွင့်ပြီး XY ပြောင်းလဲဖိုင်ပေါင်းခြင်း၊ ပုံမမှန်အပေါက်မထိုးခြင်းနှင့်မကိုက်ညီ၊ သတိဖြင့်သုံးပါ',
    ben: 'অল-ইন-ওয়ান মেশিন চালু করলে XY ইন্টারচেঞ্জ, ফাইল মার্জ ও অনিয়মিত ছিদ্র না ভেদের সাথে সামঞ্জস্যপূর্ণ নয়, সতর্কভাবে ব্যবহার করুন',
    tr: 'Bazı hepsi bir arada markalar XY takası, dosya birleştirme ve düzensiz delikleri delmeme ile uyumlu değildir; dikkatli kullanın',
    km: 'ម៉ាស៊ីនរួមមួយមួយចំនួនមិនសមស្របជាមួយប្តូរ XY រួមឯកសារ និងមិនដោតរន្ធមិនធម្មតា សូមប្រើប្រយ័ត្ន',
    es: 'Algunas marcas de máquinas todo en uno son incompatibles con intercambio XY, fusión de archivos y sin perforar agujeros con formas especiales. Úselo con precaución',
    ar: 'بعض العلامات التجارية للآلات الكل في واحد غير متوافقة مع التبادل XY ودمج الملفات وعدم حفر ثقوب ذات شكل خاص. يرجى الاستخدام بحذر',
  },
  'cuttingDock.aioMachineSetting.fileType': {
    zh: '文件格式',
    en: 'File format',
    id: 'Format file',
    kz: 'Файл пішімі',
    th: 'รูปแบบไฟล์',
    ug: 'ھۆججەت فورماتى',
    vi: 'Định Dạng Tệp',
    zh_tc: '文件格式',
    ru: 'Формат файла',
    ko: '파일 형식',
    bur: 'ဖိုင်ဖော်မတ်',
    ben: 'ফাইল ফরম্যাট',
    tr: 'Dosya biçimi',
    km: 'ទ្រង់ទ្រាយឯកសារ',
    es: 'Formato de archivo',
    ar: 'تنسيق الملف',
  },
  'cuttingDock.aioMachineSetting.select': {
    zh: '请选择',
    en: 'Please select',
    id: 'Pilih',
    kz: 'Таңдау',
    th: 'โปรดเลือก',
    ug: 'تاللاڭ',
    vi: 'Vui lòng chọn',
    zh_tc: '請選擇',
    ru: 'Пожалуйста, выберите',
    ko: '선택해 주세요',
    bur: 'ကျေးဇူးပြု၍ရွေးပါ',
    ben: 'অনুগ্রহ করে নির্বাচন করুন',
    tr: 'Lütfen seçin',
    km: 'សូមជ្រើស',
    es: 'Seleccione',
    ar: 'يرجى تحديد',
  },
  'cuttingDock.aioMachineSetting.diameter': {
    zh: '修边刀具直径',
    en: 'diameter of the trimming tool',
    id: 'Diameter alat pemangkasan',
    kz: 'Кескіш зымнің диаметрі',
    th: 'เส้นผ่านศูนย์กลางเครื่องมือตัดแต่ง',
    ug: 'تۈزىتىش پىچىقىنىڭ دىئامېتىرى',
    vi: 'Đường Kính Dao Chi Trimming',
    zh_tc: '修邊刀具直徑',
    ru: 'Диаметр обрезного инструмента',
    ko: '모서리 고치기 공구 지름',
    bur: 'အစွန်းညှိဓားအချင်း',
    ben: 'ট্রিমিং টুলের ব্যাস',
    tr: 'Kenar düzeltme takımı çapı',
    km: 'អង្កត់ផ្ចិតឧបករណ៍កែសម្រួលគែម',
    es: 'Diámetro de la herramienta de recorte',
    ar: 'قطر أداة التشذيب',
  },
  'cuttingDock.aioMachineSetting.jidongTip': {
    zh: '使用极东一体机请将雕刻机工位起始点设置为右上角，并开启A功能',
    en: 'When using the East-Japan integrated machine, please set the starting point of the engraving machine station to the upper right corner and activate ',
    id: 'Gunakan mesin jidong all-in-one, silakan atur titik awal stasiun mesin ukiran ke sudut kanan atas dan aktifkan fungsi A',
    kz: 'Әржақ шаруашылық машинасын қолдануғанда, тазалоочу станциясының бастауыш нүктесініңызгі жоғарғы бұрышқа орналастырып,',
    th: 'ใช้เครื่อง jidong all-in-one โปรดตั้งจุดเริ่มต้นของสถานีเครื่องแกะสลักไปที่มุมขวาบนและเปิดใช้งานฟังก์ชัน',
    ug: 'جىدوڭ بىر گەۋدىلىك ماشىنىنى ئىشلەتكەندە ئويما ماشىنىسى خىزمەت ئورنى باشلىنىش نۇقتىسىنى ئوڭ ئۈستى بۇلۇڭغا تەڭشەپ، A ئىقتىدارىنى ئېچىڭ',
    vi: 'Vui lòng đặt điểm khởi tạo của máy khắc của Máy Một Thân Jidong ở góc trên phải, và bật chức năng A',
    zh_tc: '使用極東一體機請將雕刻機工位起始點設置為右上角，並開啟A功能',
    ru: 'Используйте полярную машину, пожалуйста, установите точку начала работы гравировальной машины в правом верхнем углу и включите функцию А.',
    ko: '극동 복합기를 사용하려면 조각기 공위 시작점을 오른쪽 상단으로 설정하고 A 기능을 켜십시오',
    bur: 'ဂျီဒုံတစ်ကိုယ်တည်းစက်သုံးပါက ထွင်းစက်အခြေနေကို ညာအပေါ်ထောင့်သတ်မှတ်ပြီး A လုပ်ဆောင်ချက်ဖွင့်ပါ',
    ben: 'ইস্ট-জাপান ইন্টিগ্রেটেড মেশিন ব্যবহারে এনগ্রেভিং স্টেশনের সূচনাবিন্দু উপরের ডান কোণে সেট করুন এবং সক্রিয় করুন',
    tr: 'Jidong hepsi bir arada kullanırken oyma istasyonu başlangıcını sağ üst köşeye ayarlayın ve A işlevini açın',
    km: 'បើប្រើម៉ាស៊ីនរួម Jidong សូមកំណត់ចំណុចចាប់ផ្តើមស្ថានីយ៍ចុកចាក់ទៅជ្រុងខាងលើស្តាំ និងបើកមុខងារ A',
    es: 'Cuando utilice la máquina todo en uno Jidong, establezca el punto de inicio de la estación de la máquina de grabado en la esquina superior derecha y habilite la función A',
    ar: 'عند استخدام آلة Jidong الكل في واحد، يرجى ضبط نقطة البداية لمحطة آلة النقش على الزاوية اليمنى العليا وتمكين وظيفة A',
  },
  'cuttingDock.aioMachineSetting.skill': {
    zh: '功能',
    en: 'Function',
    id: 'Fungsi',
    kz: 'функциясын іске қосыңыз',
    th: 'การทำงาน',
    ug: 'ئىقتىدار',
    vi: 'Chức Năng',
    zh_tc: '功能',
    ru: 'функция',
    ko: '기능',
    bur: 'လုပ်ဆောင်ချက်',
    ben: 'ফাংশন',
    tr: 'İşlev',
    km: 'មុខងារ',
    es: 'Función',
    ar: 'الوظيفة',
  },
  'cuttingDock.aioMachineSetting.clampHandLength': {
    zh: '夹手长度(L)',
    en: 'Gripper length(L)',
    id: 'Panjang klem tangan (l)',
    kz: 'Ұстағыш ұзындығы(L)',
    th: 'ความยาวของแคลมป์มือ (L)',
    ug: 'تۇتقۇچ ئۇزۇنلۇقى(L)',
    vi: 'Chiều dài kẹp tay(L)',
    zh_tc: '夾手長度(L)',
    ru: 'Длина зажима (l)',
    ko: '클립 길이 (L)',
    bur: 'ညှပ်လက်အလျား(L)',
    ben: 'গ্রিপার দৈর্ঘ্য(L)',
    tr: 'Tutucu uzunluğu (L)',
    km: 'ប្រវែងដៃច្របាច់(L)',
    es: 'Longitud de la abrazadera (L)',
    ar: 'طول المشبك (L)',
  },
  'cuttingDock.aioMachineSetting.clampHandWidth': {
    zh: '夹手宽度(W)',
    en: 'Gripper width（W）',
    id: 'Lebar tangan penjepit (w)',
    kz: 'Ұстағыш ені(W)',
    th: 'ความกว้างของมือจับ (W)',
    ug: 'تۇتقۇچ كەڭلىكى(W)',
    vi: 'Chiều rộng kẹp tay(W)',
    zh_tc: '夾手寬度（W）',
    ru: 'Ширина зажима (W)',
    ko: '그립 너비 (W)',
    bur: 'ညှပ်လက်အကျယ်(W)',
    ben: 'গ্রিপার প্রস্থ(W)',
    tr: 'Tutucu genişliği (W)',
    km: 'ទទឹងដៃច្របាច់(W)',
    es: 'Ancho de la pinza (W)',
    ar: 'عرض المقبض (W)',
  },
  'cuttingDock.aioMachineSetting.clampHandMargin1': {
    zh: '夹手1距边(H1)',
    en: 'Clamp hand 1 margin(H1)',
    id: 'Klip Tangan 1 Tepi Jarak (H1)',
    kz: 'Қолды шетінен 1 қашықтықта қысыңыз(H1)',
    th: 'คลิปมือ 1 ขอบระยะไกล (H1)',
    ug: 'تۇتقۇچ1 گىرۋەكتىن ئارىلىقى(H1)',
    vi: 'Kẹp tay cách mép 1(H1)',
    zh_tc: '夾手1距邊(H1)',
    ru: 'Зажим руку 1 от края (H1)',
    ko: '클립 1피치 모서리(H1)',
    bur: 'ညှပ်လက်၁အနားကြား(H1)',
    ben: 'ক্ল্যাম্প হ্যান্ড ১ মার্জিন(H1)',
    tr: 'Tutucu 1 kenar mesafesi (H1)',
    km: 'ចម្ងាយដៃច្របាច់១ពីគែម(H1)',
    es: 'Distancia de la pinza 1 borde (H1)',
    ar: 'مسافة القابض 1 من الحافة (H1)',
  },
  'cuttingDock.aioMachineSetting.clampHandMargin2': {
    zh: '夹手2距边(H2)',
    en: 'Clamp hand 2 margin(H2)',
    id: 'Klip Tangan 2 Tepi Jarak (H2)',
    kz: 'Қолды шетінен 2 қашықтықта қысыңыз(H2)',
    th: 'คลิปมือ 2 ระยะทางไกล (H2)',
    ug: 'تۇتقۇچ2 گىرۋەكتىن ئارىلىقى(H2)',
    vi: 'Kẹp tay cách mép 2(H2)',
    zh_tc: '夾手2距邊(H2)',
    ru: 'Зажим руки 2 от края (H2)',
    ko: '클립 2피치 모서리(H2)',
    bur: 'ညှပ်လက်၂အနားကြား(H2)',
    ben: 'ক্ল্যাম্প হ্যান্ড ২ মার্জিন(H2)',
    tr: 'Tutucu 2 kenar mesafesi (H2)',
    km: 'ចម្ងាយដៃច្របាច់២ពីគែម(H2)',
    es: 'Borde de distancia de la abrazadera 2 (H2)',
    ar: 'حافة مسافة المشبك 2 (H2)',
  },
  'cuttingDock.aioMachineSetting.duchClampHand': {
    zh: '孔槽避让夹手位置',
    en: 'The hole groove avoids the clamping hand position',
    id: 'Slot lubang menghindari posisi penjepit tangan',
    kz: 'Саңылау ұясы қысу күйін болдырмайды',
    th: 'ช่องโหว่หลีกเลี่ยงตำแหน่งที่ยึดด้วยมือ',
    ug: 'تۆشۈك-يوچۇق تۇتقۇچ ئورنىدىن ساقلىنىش',
    vi: 'Vị trí kẹp tránh rãnh',
    zh_tc: '孔槽避讓夾手位置',
    ru: 'Отверстие',
    ko: '구멍 슬롯 피하기 클립 위치',
    bur: 'အပေါက်အချိုးညှပ်လက်နေရာရှောင်ခြင်း',
    ben: 'গর্ত খাঁজ ক্ল্যাম্প হ্যান্ড অবস্থান এড়ায়',
    tr: 'Oluk/rölyef tutucu konumundan kaçın',
    km: 'រណ្តៅរួចផុតទីតាំងដៃច្របាច់',
    es: 'Posición de la abrazadera para evitar la ranura del orificio',
    ar: 'موضع المشبك لتجنب فتحة الثقب',
  },
  'cuttingDock.aioMachineSetting.clampHandDirection': {
    zh: '夹手方向',
    en: 'Hand direction',
    id: 'Arah penjepit tangan',
    kz: 'Қысу бағыты',
    th: 'ทิศทางที่ยึดด้วยมือ',
    ug: 'تۇتقۇچ يۆنىلىشى',
    vi: 'Hướng kẹp tay',
    zh_tc: '夾手方向',
    ru: 'Направление зажима',
    ko: '클립 방향',
    bur: 'ညှပ်လက်ဦးတည်ချက်',
    ben: 'হ্যান্ড দিক',
    tr: 'Tutucu yönü',
    km: 'ទិសដៅដៃច្របាច់',
    es: 'Dirección de la abrazadera',
    ar: 'اتجاه المشبك',
  },
  'cuttingDock.aioMachineSetting.left': {
    zh: '左侧',
    en: 'left',
    id: 'Sisi kiri',
    kz: 'сол жағы',
    th: 'ด้านซ้าย',
    ug: 'سول تەرەپ',
    vi: 'Bên trái',
    zh_tc: '左側',
    ru: 'слева',
    ko: '왼쪽',
    bur: 'ဘယ်ဘက်',
    ben: 'বাম',
    tr: 'sol',
    km: 'ឆ្វេង',
    es: 'Lado izquierdo',
    ar: 'الجانب الأيسر',
  },
  'cuttingDock.aioMachineSetting.right': {
    zh: '右侧',
    en: 'right',
    id: 'Sisi kanan',
    kz: 'оң жағы',
    th: 'ด้านขวา',
    ug: 'ئوڭ تەرەپ',
    vi: 'Bên phải',
    zh_tc: '右側',
    ru: 'справа',
    ko: '오른쪽',
    bur: 'ညာဘက်',
    ben: 'ডান',
    tr: 'sağ',
    km: 'ស្តាំ',
    es: 'Lado derecho',
    ar: 'الجانب الأيمن',
  },
  'cuttingDock.aioMachineSetting.top': {
    zh: '上侧',
    en: 'top',
    id: 'Sisi atas',
    kz: 'жоғарғы жағы',
    th: 'ด้านบน',
    ug: 'ئۈستى تەرەپ',
    vi: 'Phía trên',
    zh_tc: '上側',
    ru: 'Верхняя сторона',
    ko: '위쪽',
    bur: 'အပေါ်ဘက်',
    ben: 'উপরে',
    tr: 'üst',
    km: 'លើ',
    es: 'Lado superior',
    ar: 'الجانب العلوي',
  },
  'cuttingDock.aioMachineSetting.bottom': {
    zh: '下侧',
    en: 'bottom',
    id: 'Sisi bawah',
    kz: 'Төменгі жағы',
    th: 'ด้านล่าง',
    ug: 'ئاستى تەرەپ',
    vi: 'Phía dưới',
    zh_tc: '下側',
    ru: 'Нижняя сторона',
    ko: '아래쪽',
    bur: 'အောက်ဘက်',
    ben: 'নিচে',
    tr: 'alt',
    km: 'ក្រោម',
    es: 'Lado inferior',
    ar: 'الجانب السفلي',
  },
  'cuttingDock.oneDragTwo.title': {
    zh: '一拖二雕刻机',
    en: 'One to two engraving machine',
    id: 'Mesin ukiran satu-ke-dua',
    kz: 'Бірден екі кескіш машина',
    th: 'เครื่องแกะสลักแบบหนึ่งต่อสอง',
    ug: 'بىرنى سۆرەپ ئىككى ئويما ماشىنىسى',
    vi: 'Máy Khắc Một Kéo Hai',
    zh_tc: '一拖二雕刻機',
    ru: 'Два гравировальных станка.',
    ko: '1 끌기 2 조각기',
    bur: 'တစ်ဆွဲနှစ်ထွင်းစက်',
    ben: 'এক টু টু এনগ্রেভিং মেশিন',
    tr: 'Bire iki oyma makinesi',
    km: 'ម៉ាស៊ីនចុកចាក់មួយទាញពីរ',
    es: 'Máquina de grabado uno a dos',
    ar: 'آلة نقش واحد إلى اثنين',
  },
  'cuttingDock.oneDragTwo.outputMachineFile': {
    zh: '输出一拖二雕刻机加工文件',
    en: 'Output the processing file for the one-to-two engraving machine',
    id: 'Output file pemrosesan mesin dua-drag-drag-drag',
    kz: 'Бірден екі кескіш машинаның өңдеу файлын шығару',
    th: 'เอาต์พุตไฟล์การประมวลผลเครื่องเอื้อสองแผ่นสองแผ่น',
    ug: 'بىرنى سۆرەپ ئىككى ئويما ماشىنىسى ئىشلەش ھۆججىتىنى چىقىرىش',
    vi: 'Xuất Tệp Gia Công Máy Khắc Một Kéo Hai',
    zh_tc: '輸出一拖二雕刻機加工文件',
    ru: 'Выход, перетаскивание, обработка документов',
    ko: '1, 2, 조각기 가공 파일 내보내기',
    bur: 'တစ်ဆွဲနှစ်ထွင်းစက်ဖိုင်ထုတ်ပါ',
    ben: 'এক টু টু এনগ্রেভিং মেশিন প্রসেসিং ফাইল আউটপুট',
    tr: 'Bire iki oyma makinesi işleme dosyasını dışa aktar',
    km: 'នាំចេញឯកសារដំណើរការម៉ាស៊ីនចុកចាក់មួយទាញពីរ',
    es: 'Salida de archivos de procesamiento de la máquina de grabado uno a dos',
    ar: 'إخراج ملفات معالجة آلة نقش واحد إلى اثنين',
  },
  'cuttingDock.oneDragTwo.outputMachineFileTips': {
    zh: '启用一拖二雕刻机后与开料机文件合并功能不兼容，请谨慎使用',
    en: 'After enabling the "one-to-two" engraving machine, it is not compatible with the file merging function of the cutting machine. Please use it with caution',
    id: 'Setelah mengaktifkan mesin ukiran satu-ke-dua, tidak kompatibel dengan fungsi penggabungan file pemotong. Harap gunakan dengan hati -hati.',
    kz: 'Бірден екі кескіш машинаны іске қосілгенде, кескіш машинамен файлдарды біріктіру функциясымен іске асыру қосымшалар міндетті емес, оқшамауыш пайдалану',
    th: 'หลังจากเปิดใช้งานเครื่องแกะสลักแบบหนึ่งถึงสองแล้วมันก็เข้ากันไม่ได้กับฟังก์ชั่นการรวมไฟล์ของเครื่องตัด โปรดใช้ด้วยความระมัดระวัง',
    ug: 'بىرنى سۆرەپ ئىككى ئويما ماشىنىسىنى قوزغاتقاندىن كېيىن كېسىش ماشىنىسى ھۆججەت بىرلەشتۈرۈش ئىقتىدارى بىلەن ماسلاشمايدۇ، دىققەت قىلىڭ',
    vi: 'Bật Máy Khắc Một Kéo Hai sau đó không tương thích với chức năng hợp nhất tệp với máy cắt, vui lòng sử dụng thận trọng',
    zh_tc: '啟用一拖二雕刻機後與開料機文件合併功能不兼容，請謹慎使用',
    ru: 'Включите перетаскивание двух гравировочных машин после того, как функция объединения с файлом открывающей машины несовместима, используйте осторожно',
    ko: '1, 2, 조각기 사용 후 원료 공급기 파일 병합 기능과 호환되지 않으므로 주의해서 사용하십시오',
    bur: 'တစ်ဆွဲနှစ်ထွင်းစက်ဖွင့်ပြီး ဖိုင်ပေါင်းခြင်းနှင့်မကိုက်ညီ၊ သတိဖြင့်သုံးပါ',
    ben: 'এক টু টু এনগ্রেভিং মেশিন চালু করলে কাটিং মেশিনের ফাইল মার্জ সামঞ্জস্যপূর্ণ নয়, সতর্কভাবে ব্যবহার করুন',
    tr: 'Bire iki oyma makinesi etkinleştirildikten sonra kesim makinesi dosya birleştirmesi ile uyumlu değildir; dikkatli kullanın',
    km: 'បន្ទាប់ពីបើកម៉ាស៊ីនចុកចាក់មួយទាញពីរ មិនសមស្របជាមួយការរួមឯកសារម៉ាស៊ីនកាត់ សូមប្រើប្រយ័ត្ន',
    es: 'Habilitar la máquina de grabado uno a dos es incompatible con la función de fusión de archivos de la máquina de corte, utilícela con precaución',
    ar: 'تمكين آلة نقش واحد إلى اثنين غير متوافق مع وظيفة دمج ملفات آلة القطع، يرجى استخدامها مع الحذر',
  },
  'cuttingDock.oneDragTwo.fileType': {
    zh: '文件格式',
    en: 'File format',
    id: 'Format file',
    kz: 'Файл пішімі',
    th: 'รูปแบบไฟล์',
    ug: 'ھۆججەت فورماتى',
    vi: 'Định Dạng Tệp',
    zh_tc: '文件格式',
    ru: 'Формат файла',
    ko: '파일 형식',
    bur: 'ဖိုင်ဖော်မတ်',
    ben: 'ফাইল ফরম্যাট',
    tr: 'Dosya biçimi',
    km: 'ទ្រង់ទ្រាយឯកសារ',
    es: 'Formato de archivo',
    ar: 'تنسيق الملف',
  },
  'cuttingDock.oneDragTwo.select': {
    zh: '请选择',
    en: 'Please select',
    id: 'Pilih',
    kz: 'Таңдау',
    th: 'โปรดเลือก',
    ug: 'تاللاڭ',
    vi: 'Vui lòng chọn',
    zh_tc: '請選擇',
    ru: 'Пожалуйста, выберите',
    ko: '선택해 주세요',
    bur: 'ကျေးဇူးပြု၍ရွေးပါ',
    ben: 'অনুগ্রহ করে নির্বাচন করুন',
    tr: 'Lütfen seçin',
    km: 'សូមជ្រើស',
    es: 'Seleccione',
    ar: 'يرجى تحديد',
  },
  'cuttingDock.oneDragTwo.machineStart': {
    zh: '工位起始点',
    en: 'starting point of the workstation',
    id: 'Titik awal stasiun',
    kz: 'Станс басталу нүктесі',
    th: 'จุดเริ่มต้นของสถานี',
    ug: 'خىزمەت ئورنى باشلىنىش نۇقتىسى',
    vi: 'Điểm Khởi Tạo Công Vị',
    zh_tc: '工位起始點',
    ru: 'начальная точка станции',
    ko: '작업 위치 시작점',
    bur: 'အလုပ်ဌာနအစအမှတ်',
    ben: 'ওয়ার্কস্টেশনের সূচনাবিন্দু',
    tr: 'İstasyon başlangıç noktası',
    km: 'ចំណុចចាប់ផ្តើមស្ថានីយ៍',
    es: 'Punto de inicio de la estación de trabajo',
    ar: 'نقطة بداية محطة العمل',
  },
  'cuttingDock.oneDragTwo.positionClose': {
    zh: '关闭时将跟随切割参数中工位起始点设置',
    en: 'When closing, it will follow the starting point setting of the workstation in the cutting parameters',
    id: 'Saat ditutup, pengaturan titik awal stasiun dalam parameter pemotongan akan diikuti.',
    kz: 'Жабу кезінде станс басталу нүктесінің кесу параметрлеріне сәйкес орналастыру',
    th: 'เมื่อปิดการตั้งค่าจุดเริ่มต้นของสถานีในพารามิเตอร์การตัดจะถูกติดตาม',
    ug: 'تاقالغاندا كېسىش پارامېتىرىدىكى خىزمەت ئورنى باشلىنىش نۇقتىسى تەڭشىكىگە ئەگىشىدۇ',
    vi: 'Khi đóng sẽ đi theo thiết đặt điểm khởi tạo công vị trong thông số cắt',
    zh_tc: '關閉時將跟隨切割參數中工位起始點設置',
    ru: 'При закрытии будет следовать настройке начала рабочего места в параметрах резки',
    ko: '닫으면 가공 매개변수의 가공 위치 시작점 설정이 따릅니다.',
    bur: 'ပိတ်သောအခါ ကတ်တင်းပါရာမီတာရှိအလုပ်ဌာနအစအမှတ်အတိုင်းလိုက်မည်',
    ben: 'বন্ধ করার সময় কাটিং প্যারামিটারে ওয়ার্কস্টেশনের সূচনাবিন্দু সেটিং অনুসরণ করবে',
    tr: 'Kapalıyken kesim parametrelerindeki istasyon başlangıç ayarını izler',
    km: 'បិទពេលតាមការកំណត់ចំណុចចាប់ផ្តើមស្ថានីយ៍ក្នុងប៉ារ៉ាម៉ែត្រកាត់',
    es: 'Cuando esté cerrada, seguirá el inicio de la estación configuración del punto en los parámetros de corte',
    ar: 'عند إغلاقه، سيتبع إعداد نقطة بداية المحطة في معلمات القطع',
  },
  'cuttingDock.oneDragTwo.engravingPlus': {
    zh: '速雕雕刻机',
    en: 'Rapid engraving machine',
    id: 'Mesin ukiran cepat',
    kz: 'Жедел кескіш машина',
    th: 'เครื่องแกะสลักอย่างรวดเร็ว',
    ug: 'تېز ئويما ماشىنىسى',
    vi: 'Máy Khắc Tốc Độ',
    zh_tc: '速雕雕刻機',
    ru: 'Скоростная гравировальная машина',
    ko: '속조각기',
    bur: 'အမြန်ထွင်းစက်',
    ben: 'র্যাপিড এনগ্রেভিং মেশিন',
    tr: 'Hızlı oyma makinesi',
    km: 'ម៉ាស៊ីនចុកចាក់លឿន',
    es: 'Máquina de grabado rápido',
    ar: 'آلة النقش السريع',
  },
  'cuttingDock.sawEngraving.title': {
    zh: '锯切雕刻机',
    en: 'Saw and engraving machine',
    id: 'Melihat mesin ukiran pemotongan',
    kz: 'Қайтудық бұрысу және үстіндеу машинасы',
    th: 'เครื่องแกะสลักตัด',
    ug: 'ھەرە ئويما ماشىنىسى',
    vi: 'Máy cắt và carving',
    zh_tc: '鋸切雕刻機',
    ru: 'Пило - гравировальный станок',
    ko: '톱질 조각기',
    bur: 'ဆောက်ထွင်းစက်',
    ben: 'কাট ও এনগ্রেভিং মেশিন',
    tr: 'Testere ve oyma makinesi',
    km: 'ម៉ាស៊ីនកាត់ និងចុកចាក់',
    es: 'Máquina de aserrado y grabado',
    ar: 'آلة النشر والنقش',
  },
  'cuttingDock.sawEngraving.preLayNav': {
    zh: '锯切雕刻机设置',
    en: 'Saw and engraving machine settings',
    id: 'Pengaturan mesin ukiran gergaji',
    kz: 'Қайтару және қатау машинасының баптаулары',
    th: 'การตั้งค่าเครื่องแกะสลักเลื่อย',
    ug: 'ھەرە ئويما ماشىنىسى تەڭشىكى',
    vi: 'Cài đặt máy cắt và carving',
    zh_tc: '鋸切雕刻機設置',
    ru: 'Настройка пилорамы',
    ko: '톱질 조각기 설치',
    bur: 'ဆောက်ထွင်းစက်ဆက်တင်း',
    ben: 'কাট ও এনগ্রেভিং মেশিন সেটিংস',
    tr: 'Testere-oyma makinesi ayarları',
    km: 'ការកំណត់ម៉ាស៊ីនកាត់ និងចុកចាក់',
    es: 'Configuración de la máquina de aserrado y grabado',
    ar: 'إعدادات آلة النشر والنقش',
  },
  'cuttingDock.sawEngraving.preLayKnifeInput': {
    zh: '锯片横切刀直径',
    en: 'Cross cutting blade diameter of saw blade',
    id: 'Diameter pemotong silang blade gergaji',
    kz: 'Құрыш дәңгейінің диаметрі',
    th: 'เส้นผ่านศูนย์กลางของใบมีดเลื่อยข้ามคัตเตอร์',
    ug: 'ھەرە تىغى توغرىسىغا كېسىش پىچىقىنىڭ دىئامېتىرى',
    vi: 'Đường kính lưỡi cưa cắt ngang',
    zh_tc: '鋸片橫切刀直徑',
    ru: 'поперечный диаметр пилы',
    ko: '톱날 횡단 지름',
    bur: 'ဆောက်ဓားအလျားလိုက်ညှပ်ဓားအချင်း',
    ben: 'কাটিং ব্লেডের ক্রস কাটিং ব্লেড ব্যাস',
    tr: 'Testere bıçağı enine kesim çapı',
    km: 'អង្កត់ផ្ចិតកាត់ឆ្លាស់នៃកាំបិទរណ្តៅ',
    es: 'Diámetro de la cuchilla de corte transversal de la hoja de sierra',
    ar: 'قطر سكين القطع العرضي لشفرة المنشار',
  },
  'cuttingDock.sawEngraving.enableSaw': {
    zh: '启用锯切雕刻机',
    en: 'Enable sawing and engraving machine',
    id: 'Aktifkan mesin penggergajian dan ukiran',
    kz: 'Қайта қосу жүктеу және орналастыру машинысы',
    th: 'เปิดใช้งานเครื่องเลื่อยและแกะสลัก',
    ug: 'ھەرە ئويما ماشىنىسىنى قوزغىتىش',
    vi: 'Khởi động máy cắt và carving',
    zh_tc: '啟用鋸切雕刻機',
    ru: 'Включить резьбонарезную машину',
    ko: '조각기 톱질 사용',
    bur: 'ဆောက်ထွင်းစက်ဖွင့်ပါ',
    ben: 'কাট ও এনগ্রেভিং মেশিন সক্ষম করুন',
    tr: 'Testere-oyma makinesini etkinleştir',
    km: 'បើកម៉ាស៊ីនកាត់ និងចុកចាក់',
    es: 'Habilitar la máquina de aserrado y grabado',
    ar: 'تمكين آلة النشر والنقش',
  },
  'cuttingDock.sawEngraving.sawAioTip': {
    zh: '暂无输出焊接板一体机权限，请联系销售开通',
    en: 'You do not have permission to output welding plate AIO data. Please contact sales to enable this feature.',
    id: 'Anda belum memiliki izin keluaran papan las AIO; silakan hubungi tim penjualan untuk mengaktifkan.',
    kz: 'Сізде дәнекерлеу панелі AIO шығару рұқсаты жоқ, қосу үшін сату бөліміне хабарласыңыз.',
    th: 'คุณยังไม่มีสิทธิ์ส่งออกข้อมูลเครื่องเชื่อมแผ่นแบบออลอินวัน (AIO) โปรดติดต่อฝ่ายขายเพื่อเปิดใช้งาน',
    ug: 'سىزدە ھەرە تىغى بىر گۈللۈك ماشىنىسى (AIO) چىقىرىش ھوقۇقى يوق، ئېچىش ئۈچۈن ساتۇش خادىملىرى بىلەن ئالاقىلىشىڭ.',
    vi: 'Bạn chưa có quyền xuất dữ liệu máy AIO tấm hàn; vui lòng liên hệ kinh doanh để được kích hoạt.',
    zh_tc: '暫無輸出焊接板一體機權限，請聯繫銷售開通',
    ru: 'У вас нет разрешения на вывод данных для сварной панели AIO. Обратитесь в отдел продаж для подключения функции.',
    ko: '용접판 일체형(AIO) 출력 권한이 없습니다. 사용을 원하시면 영업팀에 문의해 주세요.',
    bur: 'ချိပ်ပလိတ်တစ်ကိုယ်တည်း AIO ထွက်ခွင့်မရှိပါ၊ ဖွင့်ရန် အရောင်းဌာနကို ဆက်သွယ်ပါ',
    ben: 'আপনার ওয়েল্ডিং প্লেট AIO আউটপুটের অনুমতি নেই, সক্রিয় করতে বিক্রয় বিভাগের সাথে যোগাযোগ করুন',
    tr: 'Kaynaklı plaka AIO çıktısı için izniniz yok; etkinleştirmek için satışla iletişime geçin.',
    km: 'គ្មានសិទ្ធិនាំចេញម៉ាស៊ីន AIO ផ្ទាំងផ្សារ សូមទាក់ទងផ្នែកលក់ដើម្បីបើកប្រើ',
    es: 'No tiene permiso para la salida de datos de la placa de soldadura AIO; póngase en contacto con ventas para activar la función.',
    ar: 'لا يوجد لديك إذن بإخراج بيانات لوحة اللحام AIO؛ يرجى التواصل مع المبيعات للتفعيل.',
  },
  'cuttingDock.sawEngraving.cutSet': {
    zh: '焊接板切割设置',
    en: 'Welding Plate Cutting Settings',
    id: 'Pengaturan pemotongan papan persegi panjang',
    kz: 'Қайтару бұрысын қиысу баптаулары',
    th: 'การตั้งค่าการตัดแผ่นสี่เหลี่ยม',
    ug: 'ھەرە تىغى كېسىش تەڭشىكى',
    vi: 'Cài đặt cắt tấm hàn',
    zh_tc: '焊接板切割設置',
    ru: 'Параметры резки сварных пластин',
    ko: '용접판 가공 설정',
    bur: 'ဂဟေပြားကတ်တင်းဆက်တင်း',
    ben: 'ওয়েল্ডিং প্লেট কাটিং সেটিংস',
    tr: 'Kaynaklı plaka kesim ayarları',
    km: 'ការកំណត់កាត់ផ្ទាំងផ្សារ',
    es: 'Configuración de corte de la placa de soldadura',
    ar: 'إعدادات قطع لوحة اللحام',
  },
  'cuttingDock.sawEngraving.weldingPlank': {
    zh: '焊接板',
    en: 'Welding plate',
    id: 'Papan las',
    kz: 'Қайтару бұрышы',
    th: 'ตัวตะกูลสี่เหลี่ยม',
    ug: 'تىغى بىر گۈللۈك ماشىنىسى',
    vi: 'Cài đặt cắt tấm hàn',
    zh_tc: '焊接板',
    ru: 'Сварная пластина',
    ko: '용접판',
    bur: 'ဂဟေပြားကတ်တင်း',
    ben: 'ওয়েল্ডিং প্লেট',
    tr: 'Kaynaklı plaka',
    km: 'ផ្ទាំងផ្សារ',
    es: 'Placa de soldadura',
    ar: 'لوحة اللحام',
  },
  'cuttingDock.sawEngraving.doorFrame': {
    zh: '门套',
    en: 'Door frame',
    id: 'Frame pintu',
    kz: 'Қабырға рамы',
    th: 'กรอบประตู',
    ug: 'ھەرە تىغى كېسىش تەڭشىكى',
    vi: 'Cài đặt cắt tấm hàn',
    zh_tc: '門套',
    ru: 'Дверной каркас',
    ko: '문 프레임',
    bur: 'ဂဟေပြားကတ်တင်း',
    ben: 'ওয়েল্ডিং প্লেট',
    tr: 'Kaynaklı plaka',
    km: 'ផ្ទាំងផ្សារ',
    es: 'Marco de puerta',
    ar: 'إطار الباب',
  },
  'cuttingDock.sawEngraving.doorFrameTip1': {
    zh: '下料刀半径必须≤锯片厚度',
    en: 'The radius of the cutting blade must be less than or equal to the thickness of the saw blade',
    id: 'Jari-jari pisau pemotong harus kurang dari atau sama dengan ketebalan pisau gergaji',
    kz: 'Қиысу бұрышының радиусы үлкен болмауы керек',
    th: 'รัศมีของดาบตัดต้องน้อยกว่าหรือเท่ากับความหนาของดาบตัด',
    ug: 'تىغى بىر گۈللۈك ماشىنىسى',
    vi: 'Cài đặt cắt tấm hàn',
    zh_tc: '下料刀半徑必須≤鋸片厚度',
    ru: 'Радиус пилы должен быть меньше или равен толщине пилы',
    ko: '톱날 반지름은 톱날 두께보다 작거나 같아야 합니다',
    bur: 'ဆောက်ဓားအသုံးပြုချက်',
    ben: 'কাটিং ব্লেডের ব্যবহার',
    tr: 'Testere bıçağı kullanımı',
    km: 'ការប្រើកាᆔនជាតិរណ្តៅ',
    es: 'Uso de la hoja de sierra',
    ar: 'استخدام شفرة المنشار',
  },
  'cuttingDock.sawEngraving.doorFrameTip2': {
    zh: '2.不支持异形板件排版 3.排版间隙自动为0',
    en: '2.Unsupported irregular plate layout 3.Automatic spacing for layout',
    id: '2.Penyusunan plat tidak teratur tidak didukung 3.Spacing otomatis untuk layout',
    kz: '2.Қабырға рамының қабырғалары үлкен болмауы керек 3.Қабырға рамының қабырғалары үлкен болмауы керек',
    th: '2.การวางตำแหน่งของตัวตะกูลสี่เหลี่ยมไม่รองรับ 3.การวางตำแหน่งของตัวตะกูลสี่เหลี่ยมไม่รองรับ',
    ug: '2.ھەرە تىغى كېسىش تەڭشىكى 3.ھەرە تىغى كېسىش تەڭشىكى',
    vi: '2.Cài đặt cắt tấm hàn 3.Cài đặt cắt tấm hàn',
    zh_tc: '2.不支持异形板件排版3.排版間隙自動為0',
    ru: '2.Не поддерживается нестандартная компоновка пластин 3.Автоматическое пространство для компоновки',
    ko: '2.톱날 반지름은 톱날 두께보다 작거나 같아야 합니다 3.톱날 반지름은 톱날 두께보다 작거나 같아야 합니다',
    bur: '2.ဆောက်ဓားအသုံးပြုချက် 3.ဆောက်ဓားအသုံးပြုချက်',
    ben: '2.কাটিং ব্লেডের ব্যবহার 3.কাটিং ব্লেডের ব্যবহার',
    tr: '2.Testere bıçağı kullanımı 3.Testere bıçağı kullanımı',
    km: '2.ការប្រើកាំបិទរណ្តៅ 3.ការប្រើកាំបិទរណ្តៅ',
    es: '2.Uso de la hoja de sierra 3.Uso de la hoja de sierra',
    ar: '2.استخدام شفرة المنشار 3.استخدام شفرة المنشار',
  },
  'cuttingDock.sawEngraving.sawUsing': {
    zh: '锯片用途',
    en: 'Usage of saw blade',
    id: 'Penggunaan bilah gergaji',
    kz: 'Қайтау бұрыштың қолданысу',
    th: 'การใช้ใบเลื่อย',
    ug: 'ھەرە تىغى ئىشلىتىلىشى',
    vi: 'Công dụng của bẫy cưa',
    zh_tc: '鋸片用途',
    ru: 'Использование пил',
    ko: '톱날 용도',
    bur: 'ဆောက်ဓားအသုံးပြုချက်',
    ben: 'কাটিং ব্লেডের ব্যবহার',
    tr: 'Testere bıçağı kullanımı',
    km: 'ការប្រើកាំបិទរណ្តៅ',
    es: 'Uso de la hoja de sierra',
    ar: 'استخدام شفرة المنشار',
  },
  'cuttingDock.sawEngraving.trim': {
    zh: '修边',
    en: 'Trimming',
    id: 'Pemangkasan Perbatasan',
    kz: 'жиегін өңдеу',
    th: 'การตัดขอบ',
    ug: 'تۈزىتىش',
    vi: 'Làm sạch đường biên',
    zh_tc: '修邊',
    ru: 'Ремонт кромок',
    ko: '테두리를 깎다',
    bur: 'အစွန်းညှိခြင်း',
    ben: 'ট্রিমিং',
    tr: 'Kenar düzeltme',
    km: 'ការកែសម្រួលគែម',
    es: 'Recortar bordes',
    ar: 'تقليم الحواف',
  },
  'cuttingDock.sawEngraving.cutBlank': {
    zh: '切割下料',
    en: 'Cutting and blanking',
    id: 'Memotong',
    kz: 'жылжыту және ауыстыру',
    th: 'ตัดออก',
    ug: 'كېسىپ چۈشۈرۈش',
    vi: 'cắt và phân bổ',
    zh_tc: '切割下料',
    ru: 'Вырезание',
    ko: '원단을 절단하다',
    bur: 'ကတ်တင်းနှင့်အတုံးချခြင်း',
    ben: 'কাটিং ও ব্ল্যাঙ্কিং',
    tr: 'Kesim ve boşaltma',
    km: 'ការកាត់ និងដក',
    es: 'Corte en blanco',
    ar: 'تقطيع القطع',
  },
  'cuttingDock.sawEngraving.backTrimOblique': {
    zh: '反面修边',
    en: 'Back trimming',
    id: 'Pemangkasan sisi belakang',
    kz: 'артқы жиегін өңдеу',
    th: 'การตัดขอบด้านหลัง',
    ug: 'ئارقا يۈز تۈزىتىش',
    vi: 'Làm sạch đường biên mặt sau',
    zh_tc: '反面修邊',
    ru: 'Обработка обратной кромки',
    ko: '뒷면 테두리 깎기',
    bur: 'နောက်မျက်နှာအစွန်းညှိခြင်း',
    ben: 'পিছনের প্রান্ত ট্রিমিং',
    tr: 'Arka kenar düzeltme',
    km: 'ការកែសម្រួលគែមខាងក្រោយ',
    es: 'Recorte de bordes traseros',
    ar: 'تقليم الحواف الخلفية',
  },
  'cuttingDock.sawEngraving.holeSlotOblique': {
    zh: '拉槽/铣孔/铣槽',
    en: 'Hole slot',
    id: 'Slot lubang',
    kz: 'қуышқыштың қуышы',
    th: 'รูรัวร์',
    ug: 'ھەرە تىغى كېسىش تەڭشىكى',
    vi: 'Cài đặt cắt tấm hàn',
    zh_tc: '拉槽/铣孔/铣槽',
    ru: 'Ремонт отверстий',
    ko: '테두리를 깎다',
    bur: 'နောက်မျက်နှာအစွန်းညှိခြင်း',
    ben: 'পিছনের প্রান্ত ট্রিমিং',
    tr: 'Arka kenar düzeltme',
    km: 'ការកែសម្រួលគែមខាងក្រោយ',
    es: 'Recorte de bordes traseros',
    ar: 'تقليم الحواف الخلفية',
  },
  'cuttingDock.sawEngraving.plankThicknessUnit': {
    zh: '表中板厚单位为',
    en: 'Plank thickness unit',
    id: 'Satuan tebal papan',
    kz: 'қабырға қалыңдығы бірлігі',
    th: 'หน่วยความหนาแผ่น',
    ug: 'ھەرە تىغى كېسىش تەڭشىكى',
    vi: 'Cài đặt cắt tấm hàn',
    zh_tc: '表中板厚單位為',
    ru: 'Единица толщины доски',
    ko: '판 두께 단위',
    bur: 'ပြားအရောင်ခြင်းကို အမှန်တကျဆိုးသည်',
    ben: 'প্লেটের পুরুত্ব স্ট্যাকিং',
    tr: 'Tahta kalınlığı yığılması',
    km: 'ការផ្គូរផ្គងការបន្ថែម',
    es: 'Apilamiento de grosor de tablero',
    ar: 'ترتيب سمك اللوحات',
  },
  'cuttingDock.sawEngraving.sawUseCond': {
    zh: '锯片使用条件',
    en: 'Saw blade usage conditions',
    id: 'Kondisi untuk penggunaan bilah gergaji',
    kz: 'Қатау бұйрығының қолдану шарттары',
    th: 'เงื่อนไขสำหรับการใช้ใบมีดเลื่อย',
    ug: 'ھەرە تىغى ئىشلىتىش شەرتى',
    vi: 'Điều kiện sử dụng mài cưa',
    zh_tc: '鋸片使用條件',
    ru: 'Условия использования пилы',
    ko: '톱날 사용 조건',
    bur: 'ဆောက်ဓားသုံးစွဲအခြေအနေ',
    ben: 'কাটিং ব্লেড ব্যবহারের শর্ত',
    tr: 'Testere bıçağı kullanım koşulları',
    km: 'លក្ខខណ្ឌប្រើកាំបិទរណ្តៅ',
    es: 'Condiciones de uso de la hoja de sierra',
    ar: 'شروط استخدام شفرة المنشار',
  },
  'cuttingDock.sawEngraving.exportPartData': {
    zh: '输出小板数据文件(ban、mpr、xml等)',
    en: 'Output small board data file',
    id: 'Keluaran file data papan kecil',
    kz: 'Бірліктегі машина өңдеу файлын шығару',
    th: 'ส่งออกไฟล์ข้อมูลแผ่นขนาดเล็ก',
    ug: 'بىر گەۋدىلىك ماشىنا ئىشلەش ھۆججىتىنى چىقىرىش',
    vi: 'Xuất tệp dữ liệu tấm nhỏ',
    zh_tc: '輸出小板數據文件',
    ru: 'Вывод файлов данных на панели (ban, mpr, xml и т.д.)',
    ko: '보드 데이터 파일 내보내기 (ban, mpr, xml 등)',
    bur: 'ပြားငယ်ဒေတာဖိုင်ထုတ်ပါ(ban၊ mpr၊ xml စသည်)',
    ben: 'ছোট বোর্ড ডেটা ফাইল আউটপুট (ban, mpr, xml ইত্যাদি)',
    tr: 'Küçük levha veri dosyasını dışa aktar (ban, mpr, xml vb.)',
    km: 'នាំចេញឯកសារទិន្នន័យផ្ទាំងតូច (ban, mpr, xml ជាដើម)',
    es: 'Salida de archivos de datos de placas pequeñas (prohibición, mpr, xml, etc.)',
    ar: 'إخراج ملفات بيانات اللوحة الصغيرة (ban، mpr، xml، إلخ.)',
  },
  'cuttingDock.sawEngraving.sawAioTip2': {
    zh: '适用于免翻版款锯切一体机',
    en: 'Applicable to non-flipping data cutting all-in-one machine',
    id: 'Digunakan untuk mesin potong semua-dalam-satu',
    kz: 'Қамалдау үшін қамалдау машинасына қолданылады',
    th: 'ใช้กับเครื่องตัดสลักตัดสลัก',
    ug: 'ھەرە ئويما ماشىنا ئىشلەش ھۆججىتىنى چىقىرىش',
    vi: 'Sử dụng cho máy cắt tốc độ',
    zh_tc: '適用於免翻版數據切一體機',
    ru: 'Подходит для пиломатериалов без копирования',
    ko: '리플리케이션 없는 올인원',
    bur: 'ပြားမလှန်သည့်ဆောက်တစ်ကိုယ်တည်းစက်နှင့်ကိုက်ညီ',
    ben: 'নন-ফ্লিপিং ডেটা কাটিং অল-ইন-ওয়ান মেশিনে প্রযোজ্য',
    tr: 'Çevirmesiz testere kesim hepsi bir arada makinelere uygundur',
    km: 'សមស្របសម្រាប់ម៉ាស៊ីនរួមកាត់រណ្តៅដោយមិនបត់',
    es: 'Adecuado para sierras todo en uno sin copia',
    ar: 'مناسبة لآلات النشر الشاملة الخالية من النسخ',
  },
  'cuttingDock.sawEngraving.hasUsing': {
    zh: '有可用路径便使用',
    en: 'Use available path',
    id: 'Gunakan jika tersedia',
    kz: 'Қол жолына жүктеу',
    th: 'ใช้ถ้ามี',
    ug: 'ئىشلەتكىلى بولىدىغان يول بولسا ئىشلىتىش',
    vi: 'Có đường dẫn khả dụng để sử dụng',
    zh_tc: '有可用路徑便使用',
    ru: 'Используйте доступный путь.',
    ko: '사용 가능한 경로',
    bur: 'အသုံးပြုနိုင်သည့်လမ်းကြောင်းရှိလျှင်သုံးပါ',
    ben: 'উপলব্ধ পথ থাকলে ব্যবহার করুন',
    tr: 'Kullanılabilir yol varsa kullan',
    km: 'ប្រើប្រសិនបើមានផ្លូវ',
    es: 'Úselo solo cuando haya un camino disponible',
    ar: 'استخدم فقط عندما يكون هناك مسار متاح',
  },
  'cuttingDock.sawEngraving.onlyUse': {
    zh: '时才使用',
    en: 'use only when necessary',
    id: 'Gunakan hanya kapan',
    kz: 'қажеттен және қолданыңыз',
    th: 'ใช้เฉพาะเมื่อ',
    ug: 'ۋاقىتتا ئىشلىتىش',
    vi: 'Chỉ sử dụng khi cần thiết',
    zh_tc: '時才使用',
    ru: 'Использовать только тогда',
    ko: '시재 사용',
    bur: 'လိုအပ်မှသာသုံးပါ',
    ben: 'প্রয়োজনে ব্যবহার করুন',
    tr: 'yalnızca gerekli olduğunda kullan',
    km: 'ប្រើតែនៅពេលចាំបាច់',
    es: 'Use',
    ar: 'استخدم',
  },
  'cuttingDock.sawEngraving.cutMethod': {
    zh: '切割方式',
    en: 'Cutting method',
    id: 'Metode pemotongan',
    kz: 'қиылу тәсілі',
    th: 'วิธีการตัด',
    ug: 'كېسىش ئۇسۇلى',
    vi: 'cách cắt',
    zh_tc: '切割方式',
    ru: 'Режим резки',
    ko: '절단 방식',
    bur: 'ကတ်တင်းနည်းလမ်း',
    ben: 'কাটিং পদ্ধতি',
    tr: 'Kesim yöntemi',
    km: 'វិធីសាស្ត្រកាត់',
    es: 'Método de corte',
    ar: 'طريقة القطع',
  },
  'cuttingDock.sawEngraving.oneKnifePull': {
    zh: '一刀拉穿大板',
    en: 'Cut through the large board with one stroke',
    id: 'Tarik melalui papan besar dengan satu pisau',
    kz: 'бір қиындық бұрышты жіберу',
    th: 'ดึงบอร์ดขนาดใหญ่ด้วยมีดหนึ่งใบ',
    ug: 'بىر پىچاق بىلەن چوڭ تاختاينى كېسىپ ئۆتۈش',
    vi: 'một cú cắt trực tiếp qua một bảng lớn',
    zh_tc: '一刀拉穿大板',
    ru: 'Один нож пробил большую доску.',
    ko: '단칼에 널빤지를 꿰뚫다.',
    bur: 'ဓားတစ်ချက်ဖြင့်ကြီးပြားဖြတ်ခြင်း',
    ben: 'এক কোপে বড় বোর্ড কাটা',
    tr: 'Büyük levhayı tek kesimde boyuna kes',
    km: 'កាត់ផ្ទាំងធំឆ្លាស់ក្នុងការកាត់តែមួយ',
    es: 'Atraviese la tabla grande con un cuchillo',
    ar: 'اسحب اللوحة الكبيرة بسكين واحد',
  },
  'cuttingDock.sawEngraving.onlyOneKnifePull': {
    zh: '时才直接一刀拉穿',
    en: 'only then did he directly pull it through with one knife',
    id: 'Tarik saja dengan satu pisau',
    kz: 'Уақытыңызда қалайтын құрт бұрыс қиімдеу',
    th: 'เพียงแค่ดึงด้วยมีดเดียว',
    ug: 'ۋاقىتتا بىۋاسىتە بىر پىچاق بىلەن كېسىپ ئۆتۈش',
    vi: 'vừa đủ thì cắt ngay một cú trực tiếp qua',
    zh_tc: '時才直接一刀拉穿',
    ru: 'И только после этого протянул нож.',
    ko: '그때서야 단칼에 꿰뚫었다',
    bur: 'လိုအပ်မှဓားတစ်ချက်ဖြင့်ဖြတ်မည်',
    ben: 'প্রয়োজনে এক কোপে সরাসরি টানুন',
    tr: 'yalnızca o zaman doğrudan tek kesimde boyuna geçilir',
    km: 'ទើបកាត់ឆ្លាស់ផ្ទាល់ជាមួយការកាត់តែមួយ',
    es: 'Tire directamente con un cuchillo',
    ar: 'اسحب مباشرة من خلال سكين واحد',
  },
  'cuttingDock.sawEngraving.enableSawThick': {
    zh: '启用锯片厚度排版',
    en: 'Enable saw blade thickness layout',
    id: 'Aktifkan tata letak ketebalan blade gergaji',
    kz: 'Серпе түю дейінің қатынауын іске қосу',
    th: 'เปิดใช้งานเค้าโครงความหนาของใบมีด',
    ug: 'ھەرە تىغى قېلىنلىقى تەرتىپلەشنى قوزغىتىش',
    vi: 'Kích hoạt sắp đặt độ dày lưỡi',
    zh_tc: '啟用鋸片厚度排版',
    ru: 'Включить толщину пилы',
    ko: '앤티앨리어싱 두께 레이아웃 사용',
    bur: 'ဆောက်ဓားအထူအစီအစဉ်ဖွင့်ပါ',
    ben: 'কাটিং ব্লেড বেধ লেআউট সক্ষম করুন',
    tr: 'Testere kalınlığına göre yerleşimi etkinleştir',
    km: 'បើកការចងក្រងតាមកម្រាស់កាំបិទរណ្តៅ',
    es: 'Habilite la composición tipográfica del espesor de la hoja de sierra',
    ar: 'تمكين تنضيد سمك شفرة المنشار',
  },
  'cuttingDock.sawEngraving.edgedDir': {
    zh: '已封好不再切的大板边',
    en: 'The edge of the large board that has been sealed and will not be cut again',
    id: 'Tepi pelat besar yang telah disegel dan tidak lagi dipotong',
    kz: 'Едігін қайталмаған, қайталауды жоқ түрде бөгетілген үлкен тақта бұрышы',
    th: 'ขอบของแผ่นขนาดใหญ่ที่ปิดผนึกและไม่ตัดอีกต่อไป',
    ug: 'چەت چاپلاپ بولۇپ قايتا كەسمەيدىغان چوڭ تاختاي گىرۋىكى',
    vi: 'Mặt bên của bảng lớn đã bị phong nặng, không cắt nữa',
    zh_tc: '已封好不再切的大板邊',
    ru: 'Закрытый край',
    ko: '이미 봉하여 다시 자르지 못하는 큰 판자 모서리',
    bur: 'ပိတ်ပြီးပြန်မဖြတ်သည့်ကြီးပြားအစွန်း',
    ben: 'সিল করা বড় বোর্ডের প্রান্ত যা আর কাটা হবে না',
    tr: 'Kenarı kapatılmış ve tekrar kesilmeyecek büyük levha kenarı',
    km: 'គែមផ្ទាំងធំដែលបានបិញ និងមិនកាត់ទៀត',
    es: 'Bordes sellados de las tablas grandes que ya no se cortan',
    ar: 'حواف اللوحة الكبيرة محكمة الغلق التي لم تعد مقطوعة',
  },
  'cuttingDock.sawEngraving.sameWidthPart': {
    zh: '每张大板上只排相同宽度小板',
    en: 'Only small boards of the same width are placed on each large board',
    id: 'Hanya papan kecil dengan lebar yang sama yang ditempatkan di setiap papan besar',
    kz: 'هرһə бир үлкен 판даWidth (көргені) esi бірдей болған кіші панелдерді жинайды',
    th: 'จัดเรียงเฉพาะแผ่นเล็กที่มีความกว้างเท่ากันบนแผ่นใหญ่แต่ละแผ่น',
    ug: 'ھەر بىر چوڭ تاختىغا پەقەت ئوخشاش كەڭلىكتىكى كىچىك تاختىلار تەرتىپلىنىدۇ',
    vi: 'Trên mỗi tấm lớn chỉ có những tấm nhỏ có cùng chiều rộng',
    zh_tc: '每張大板上只排相同寬度小板',
    ru: 'На каждой доске только одна и та же ширина.',
    ko: '각 큰 판 에는 같은 너비 의 작은 판 만 늘어서 있다',
    bur: 'ကြီးပြားတစ်ချပ်တွင်အကျယ်တူပြားငယ်များသာစီပါ',
    ben: 'প্রতিটি বড় বোর্ডে একই প্রস্থের ছোট বোর্ডই রাখুন',
    tr: 'Her büyük levhada yalnızca aynı genişlikte küçük levhalar yerleştir',
    km: 'នៅលើផ្ទាំងធំនីមួយៗដាក់តែផ្ទាំងតូចទទឹងដូចគ្នា',
    es: 'Coloque solo tablas pequeñas del mismo ancho en cada tabla grande',
    ar: 'قم فقط بترتيب الألواح الصغيرة بنفس العرض على كل لوحة كبيرة',
  },
  'cuttingDock.sawEngraving.emptyPath': {
    zh: '切割时不生成空走路径',
    en: 'No empty path is generated when the small plate is cut',
    id: 'Tidak ada jalur kosong yang dihasilkan ketika papan kecil dipotong',
    kz: 'Кӧпірді режелдеу кезінде бос жол жарай алмау',
    th: 'ไม่สร้างเส้นทางวิ่งเปล่าขณะตัด',
    ug: 'كېسىش جەريانىدا بوش يۈرۈش يولى ھاسىل قىلىنمايدۇ',
    vi: 'Không tạo ra đường đi trống khi các tấm nhỏ bị cắt',
    zh_tc: '切割時不生成空走路徑',
    ru: 'При резке не создается пустой путь',
    ko: '가공 시 빈 패스가 생성되지 않음',
    bur: 'ကတ်တင်းစဉ်ဗလာလမ်းကြောင်းမထုတ်ပါ',
    ben: 'ছোট প্লেট কাটার সময় খালি পাথ তৈরি হয় না',
    tr: 'Kesim sırasında boş gezinme yolu oluşturma',
    km: 'កំឡុងពេលកាត់កុំបង្កើតផ្លូវដើរទទេ',
    es: 'No genere una ruta vacía al cortar',
    ar: 'لا تقم بإنشاء مسار فارغ عند القطع',
  },
  'cuttingDock.sawEngraving.sawUsePlank': {
    zh: '焊接板才使用锯片加工',
    en: 'Cutting welded plates with a saw blade',
    id: 'Menggunakan mata gergaji untuk memproses pelat las',
    kz: 'Дәнекерленген болатты ара тақтайшасымен кесу',
    th: 'ตัดแผ่นเหล็กเชื่อมด้วยใบเลื่อย',
    ug: 'جىلغىرىتىلغان تاختىلارنى ئارا تاختا بىلەن كېسىش',
    vi: 'Cắt tấm thép hàn bằng lưỡi cưa',
    zh_tc: '焊接板材使用鋸片加工',
    ru: 'Сварные пластины обрабатываются пилами.',
    ko: '용접판에서만 톱날을 사용하여 가공',
    bur: 'ဂဟေပြားများတွင်သာဆောက်ဓားဖြင့်ကတ်တင်းပါ',
    ben: 'ওয়েল্ডিং প্লেটে কাটিং ব্লেড দিয়ে কাটা',
    tr: 'Kaynaklı levhalar yalnızca testere bıçağı ile işlenir',
    km: 'ផ្ទាំងផ្សារដំណើរការដោយកាំបិទរណ្តៅតែប៉ុណ្ណោះ',
    es: 'Utilice solo el procesamiento con hoja de sierra para tableros soldados',
    ar: 'استخدم معالجة شفرة المنشار فقط لـ الألواح الملحومة',
  },
  'cuttingDock.sawEngraving.paibanGap': {
    zh: '焊接板排版间隙',
    en: 'Layout gap for welded plates',
    id: 'Jarak tata letak pelat las',
    kz: 'Дәнекерленген болатты орналастыру аралығы',
    th: 'ช่องว่างการจัดเรียงแผ่นเหล็กเชื่อม',
    ug: 'جىلغىرىتىلغان تاختىلارنى تەرتىپلەش ئارىلىقى',
    vi: 'Khoảng cách sắp xếp tấm thép hàn',
    zh_tc: '焊接板排版間隙',
    ru: 'Разрыв между наборами сварных пластин',
    ko: '용접판 레이아웃 클리어런스',
    bur: 'ဂဟေပြားအစီအစဉ်ကြားအကွာအဝေး',
    ben: 'ওয়েল্ডিং প্লেট লেআউট ফাঁক',
    tr: 'Kaynaklı levha yerleşim aralığı',
    km: 'គម្លាតចងក្រងផ្ទាំងផ្សារ',
    es: 'Espacio de disposición de la placa soldada',
    ar: 'فجوة تخطيط اللوحة الملحومة',
  },
  'cuttingDock.sawEngraving.minSurplusWidthDiff': {
    zh: '最小余料匹配宽度差',
    en: 'Minimum Scrap Matching Width Difference',
    id: 'Perbedaan Lebar Pemasangan Sisa Minimum',
    kz: 'Ең аз қалдық материалдың ен айырмашылығының сәйкестігі',
    th: 'นาที. ส่วนที่เหลือตรงกับความแตกต่างของความกว้าง',
    ug: 'كەڭلىك پەرقىگە ماس كېلىدىغان ئەڭ تۆۋەن قالدۇق ماتېرىيال',
    vi: 'Tối thiểu dư lượng phù hợp với chiều rộng chênh lệch',
    zh_tc: '最小餘料匹配寬度差',
    ru: 'Минимальная разность по ширине совпадения',
    ko: '최소 남은 재료 일치 너비 차이',
    bur: 'အကြွင်းအကျန်ကိုက်ညီအကျယ်ကွာခြားချက်အနည်းဆုံး',
    ben: 'ন্যূনতম স্ক্র্যাপ ম্যাচিং প্রস্থের পার্থক্য',
    tr: 'Minimum artık parça eşleştirme genişlik farkı',
    km: 'ភាពខុសគ្នានៃទទឹងផ្គូផ្គងសំណល់អប្បបរមា',
    es: 'Diferencia mínima de ancho restante del material restante',
    ar: 'الحد الأدنى لفرق العرض المطابق للمواد المتبقية',
  },
  'cuttingDock.sawEngraving.minSurplusWidthDiffTip': {
    zh: '仅当小板与余料的宽度差小于此值时，小板才会排在余料上',
    en: 'Only when the width difference between the small board and the remaining material is less than this value, will the small board be placed on the remaining material',
    id: 'Lembar kecil hanya akan diatur di atas sisa jika perbedaan lebar antara lembar kecil dan sisa lebih kecil dari nilai ini',
    kz: 'Кішкентай пластина кішкентай пластина мен қалған материал арасындағы ені айырмашылығы осы мәннен аз болса ғана қалған материалға орналастырылады',
    th: 'เฉพาะเมื่อความแตกต่างความกว้างระหว่างแผ่นเล็ก ๆ กับวัสดุที่เหลือน้อยกว่าค่านี้แผ่นเล็ก ๆ จะถูกจัดเรียงในส่วนที่เหลือ',
    ug: 'كىچىك تەخسە پەقەت كىچىك تەخسە بىلەن قالغان ماتېرىيالنىڭ كەڭلىك پەرقى بۇ قىممەتتىن تۆۋەن بولغاندىلا، قالغان ماتېرىيالغا قويۇلىدۇ',
    vi: 'Chỉ khi chênh lệch chiều rộng giữa tấm nhỏ và phần dư nhỏ hơn giá trị này, tấm nhỏ sẽ được xếp trên phần dư',
    zh_tc: '僅當小板與餘料的寬度差小於此值時，小板才會排在餘料上',
    ru: 'Только если разница в ширине между пластиной и остаточным материалом меньше этого значения, пластина будет расположена на остаточном материале',
    ko: '판자와 나머지 재료의 너비 차이가 이 값보다 작을 때만 나머지 재료에 배열됩니다.',
    bur: 'ပြားငယ်နှင့်အကြွင်းအကျန်အကျယ်ကွာခြားချက်ဤတန်ဖိုးထက်နည်းမှသာအကြွင်းပေါ်တွင်ထားမည်',
    ben: 'ছোট বোর্ড ও অবশিষ্ট উপকরণের প্রস্থের পার্থক্য এই মানের চেয়ে কম হলে তবেই ছোট বোর্ড অবশিষ্টে রাখা হবে',
    tr: 'Küçük levha ile artık malzeme genişlik farkı bu değerden küçük olduğunda küçük levha artığa yerleştirilir',
    km: 'ផ្ទាំងតូចត្រូវបានដាក់លើសំណល់តែនៅពេលភាពខុសគ្នានៃទទឹងរវាងផ្ទាំងតូច និងសំណល់តូចជាងតម្លៃនេះ',
    es: 'Solo cuando la diferencia de ancho entre el tablero pequeño y el material restante es menor que este valor, el tablero pequeño se colocará sobre el material restante',
    ar: 'فقط عندما يكون فرق العرض بين اللوح الصغير والمادة المتبقية أقل من هذه القيمة، سيتم ترتيب اللوح الصغير على المادة المتبقية',
  },
  'cuttingDock.sawEngraving.sawReplaceEnable': {
    zh: '开料直刀切割路径主体改用锯片',
    en: 'Cutting path of straight saw replaced with saw blade',
    id: 'Jalur pemotongan gergaji lurus diganti dengan gergaji',
    kz: 'Тік керіткіштің қиылу жолы керіткіш тақтамен алмастырылады',
    th: 'การตัดทางกับวัสดุที่เหลือจะใช้กับวัสดุที่เหลือ',
    ug: 'بىلەن ئىشلەتكىلى بولىدىغان لوخچا قېلىنلىقى تەرتىپلەش',
    vi: 'Hướng cắt của dao thẳng được thay thế bằng dao',
    zh_tc: '開料直刀切割路徑主體改用鋸片',
    ru: 'Путь резания прямой пилой заменен пилой',
    ko: '직봉 나무 절단 경로를 칼로 대체',
    bur: 'ကတ်တင်းဦးတည်ချက်အောက်မှ အပေါ်သို့၊ ပြားများကိုအကျယ်ဖြင့်ဦးစွာစီပြီးအလျားဖြင့်စီပါ',
    ben: 'ছোট বোর্ড ও অবশিষ্ট উপকরণের প্রস্থের পার্থক্য এই মানের চেয়ে কম হলে তবেই ছোট বোর্ড অবশিষ্টে রাখা হবে',
    tr: 'Küçük levha ile artık malzeme genişlik farkı bu değerden küçük olduğunda küçük levha artığa yerleştirilir',
    km: 'ផ្ទាំងតូចត្រូវបានដាក់លើសំណល់តែនៅពេលភាពខុសគ្នានៃទទឹងរវាងផ្ទាំងតូច និងសំណល់តូចជាងតម្លៃនេះ',
    es: 'La dirección de corte de la sierra recta se reemplaza por la sierra',
    ar: 'يتم استبدال المسار القطع بالسيارة المستقيمة بالسيارة',
  },
  'cuttingDock.sawEngraving.minSawLength': {
    zh: '最短改用锯片的距离',
    en: 'Minimum distance to replace with saw blade',
    id: 'Jarak minimum untuk diganti dengan gergaji',
    kz: 'Керіткіш тақтамен алмастыру үшін ең аз қашықтық',
    th: 'ระยะห่างน้อยที่สุดในการใช้กับวัสดุที่เหลือ',
    ug: 'كەڭلىك پەرقىگە ماس كېلىدىغان ئەڭ تۆۋەن قالدۇق ماتېرىيال',
    vi: 'Khoảng cách ngắn nhất để thay thế bằng dao',
    zh_tc: '最短改用鋸片的距離',
    ru: 'Минимальное расстояние для замены пилой',
    ko: '최소 거리로 칼로 대체',
    bur: 'ကတ်တင်းဦးတည်ချက်အောက်မှ အပေါ်သို့၊ ပြားများကိုအကျယ်ဖြင့်ဦးစွာစီပြီးအလျားဖြင့်စီပါ',
    ben: 'ছোট বোর্ড ও অবশিষ্ট উপকরণের প্রস্থের পার্থক্য এই মানের চেয়ে কম হলে তবেই ছোট বোর্ড অবশিষ্টে রাখা হবে',
    tr: 'Küçük levha ile artık malzeme genişlik farkı bu değerden küçük olduğunda küçük levha artığa yerleştirilir',
    km: 'ផ្ទាំងតូចត្រូវបានដាក់លើសំណល់តែនៅពេលភាពខុសគ្នានៃទទឹងរវាងផ្ទាំងតូច និងសំណល់តូចជាងតម្លៃនេះ',
    es: 'La dirección de corte de la sierra recta se reemplaza por la sierra',
    ar: 'يتم استبدال المسار القطع بالسيارة المستقيمة بالسيارة',
  },
  'cuttingDock.sawEngraving.keepDistance': {
    zh: '相邻更宽板间保留的开料直刀切割距离',
    en: 'Keep distance between adjacent wider boards for cutting path of straight saw',
    id: 'Jarak untuk mempertahankan pemotongan gergaji lurus antara papan yang lebih lebar',
    kz: 'Тік керіткіштің қиылу жолында қатарлап орналасқан кең тақталар арасындағы қашықтық',
    th: 'ระยะห่างระหว่างแผ่นเล็กที่อยู่ติดกันเพื่อตัดทางกับวัสดุที่เหลือ',
    ug: 'كەڭلىك پەرقىگە ماس كېلىدىغان ئەڭ تۆۋەن قالدۇق ماتېرىيال',
    vi: 'Khoảng cách giữa các tấm nhỏ liền kề để giữ khoảng cách cắt của dao thẳng',
    zh_tc: '相鄰更寬板間保留的開料直刀切割距離',
    ru: 'Расстояние между последовательно расположенными более широкими листами для пути резания прямой пилой',
    ko: '직봉 나무 절단 경로에서 인접한 넓은 판자 사이의 거리 유지',
    bur: 'ပြားများကိုအကျယ်ဖြင့်ဦးစွာစီပြီးအလျားဖြင့်စီပါ',
    ben: 'ছোট বোর্ড ও অবশিষ্ট উপকরণের প্রস্থের পার্থক্য এই মানের চেয়ে কম হলে তবেই ছোট বোর্ড অবশিষ্টে রাখা হবে',
    tr: 'Küçük levha ile artık malzeme genişlik farkı bu değerden küçük olduğunda küçük levha artığa yerleştirilir',
    km: 'ផ្ទាំងតូចត្រូវបានដាក់លើសំណល់តែនៅពេលភាពខុសគ្នានៃទទឹងរវាងផ្ទាំងតូច និងសំណល់តូចជាងតម្លៃនេះ',
    es: 'Distancia para mantener entre tableros adyacentes más anchos para el corte de la sierra recta',
    ar: 'المسافة بين الألواح الصغيرة المتجاورة للقطع بالسيارة المستقيمة',
  },
  'cuttingDock.sawEngraving.keepDistanceTip': {
    zh: '注意：要留够充足的距离，不然锯片会切到旁边板件',
    en: 'Note: Leave enough space to avoid cutting into adjacent boards',
    id: 'Catatan: Biarkan cukup ruang untuk menghindari memotong papan yang berdekatan',
    kz: 'Керектігі: Керіткіш тақтамен қиылысуын болдырмау үшін қашықтықты қалың етіп қалдыру',
    th: 'หมายเหตุ: ปล่อยพื้นที่เพียงพอเพื่อหลีกเลี่ยงการตัดตอนกับแผ่นที่อยู่ติดกัน',
    ug: 'تۇتۇش: قالدۇق قۇلىنىشقا ئالاق بولغاندىلا، قالدۇق قۇلىنىشقا ئالاق بولمايدۇ',
    vi: 'Lưu ý: Để tránh cắt vào các tấm nhỏ liền kề, hãy để đủ khoảng cách',
    zh_tc: '注意：要留夠充足的距離，不然鋸片會切到旁邊板件',
    ru: 'Примечание: оставьте достаточное пространство, чтобы избежать разрезание соседних досок',
    ko: '주의: 인접한 판자에 잘리지 않도록 충분한 거리를 남겨야 합니다',
    bur: 'မှတ်ချက်: ပြားများကိုအကျယ်ဖြင့်ဦးစွာစီပြီးအလျားဖြင့်စီပါ',
    ben: 'দ্রষ্টব্য: সন্নিহিত বোর্ডকে কাটাতে বাকি থাকা স্থান রাখতে হবে',
    tr: 'Kenar levhalara kesilmemesi için yeterince boşluk bırakın',
    km: 'មានការពិន្ទុចំពោះការបកប្រែបន្ទាប់មកការបកប្រែបន្ទាប់មកការបកប្រែ',
    es: 'Nota: Deje suficiente espacio para evitar cortar entre tableros adyacentes',
    ar: 'ملاحظة: لتجنب قطع الألواح المجاورة، يجب أن يكون هناك مساحة كافية',
  },
  'cuttingDock.sawEngraving.sortByLength': {
    zh: '按板件长度依次排版',
    en: 'Sort by plank length',
    id: 'Mengurutkan berdasarkan panjang papan',
    kz: 'Біліктің ұзындығы бойынша реттеу',
    th: 'จัดเรียงตามความยาวของแผ่น',
    ug: 'بىلەن ئىشلەتكىلى بولىدىغان لوخچا قېلىنلىقى تەرتىپلەش',
    vi: 'Sắp xếp theo chiều dài từng tấm',
    zh_tc: '按板件長度依次排版',
    ru: 'Сортировать по длине листов',
    ko: '판재 길이에 따라 순서대로 조판하다.',
    bur: 'ပြားအလျားအလိုက်စီပါ',
    ben: 'প্ল্যাঙ্ক দৈর্ঘ্য অনুযায়ী সাজান',
    tr: 'Levha uzunluğuna göre sırala',
    km: 'តម្រៀបតាមប្រវែងផ្ទាំង',
    es: 'Disponga en orden de acuerdo con la longitud de los paneles',
    ar: 'الترتيب حسب طول الألواح',
  },
  'cuttingDock.sawEngraving.sortByLengthTip': {
    zh: '切割方向是从下到上依次切割，排板是先按宽度再按长度排',
    en: 'The cutting direction is from bottom to top in sequence. The plates are arranged first by width and then by length',
    id: 'Mengurutkan berdasarkan panjang papan',
    kz: 'Біліктің ұзындығы бойынша реттеу',
    th: 'ทิศทางการตัดคือจากล่างขึ้น จัดเรียงคือก่อนจัดเรียงตามความกว้างแล้วจึงจัดเรียงตามความยาว',
    ug: 'بىلەن ئىشلەتكىلى بولىدىغان لوخچا قېلىنلىقى تەرتىپلەش',
    vi: 'Hướng cắt là từ dưới lên, xếp bảng là trước theo chiều rộng sau đó theo chiều dài',
    zh_tc: '切割方向是從下到上依次切割，排板是先按寬度再按長度排',
    ru: 'Направление разреза - это последовательное разрезание снизу вверх, ряды - сначала по ширине, а затем по длине',
    ko: '절단 방향은 아래쪽에서 위쪽으로 순서대로 절단하고, 배열판은 먼저 너비에 따라 길이에 따라 배열한다',
    bur: 'ကတ်တင်းဦးတည်ချက်အောက်မှ အပေါ်သို့၊ ပြားများကိုအကျယ်ဖြင့်ဦးစွာစီပြီးအလျားဖြင့်စီပါ',
    ben: 'কাটিং দিক নিচ থেকে ওপরে; প্রস্থ দিয়ে আগে, তারপর দৈর্ঘ্য দিয়ে সাজান',
    tr: 'Kesim yönü alttan üste; yerleşim önce genişliğe sonra uzunluğa göre',
    km: 'ទិសកាត់ពីក្រោមឡើងលើ ចងក្រងទទឹងមុន បន្ទាប់មកប្រវែង',
    es: 'La dirección de corte es de abajo hacia arriba, y los tableros se organizan primero por ancho y luego por largo',
    ar: 'يكون اتجاه القطع من الأسفل إلى الأعلى، ويتم ترتيب الألواح حسب العرض أولاً ثم حسب الطول',
  },
  'cuttingDock.sawEngraving.plankAtTop': {
    zh: '小板在上',
    en: 'Small board at the top',
    id: 'Papan kecil di atas',
    kz: 'Біліктің жоғары жағында орналасқан кішкентай тақта',
    th: 'แผ่นเล็กอยู่ด้านบน',
    ug: 'بىلەن ئىشلەتكىلى بولىدىغان لوخچا قېلىنلىقى تەرتىپلەش',
    vi: 'Tấm nhỏ ở trên',
    zh_tc: '小板在上',
    ru: 'Небольшая доска наверху.',
    ko: '널빤지가 위에 있다',
    bur: 'ပြားငယ်အပေါ်တွင်ထားပါ',
    ben: 'ছোট বোর্ড উপরে',
    tr: 'Küçük levha üstte',
    km: 'ផ្ទាំងតូចនៅលើ',
    es: 'Los tableros pequeños se en la parte superior',
    ar: 'يتم ترتيب الألواح الصغيرة في الأعلى',
  },
  'cuttingDock.sawEngraving.plankAtBottom': {
    zh: '小板在下',
    en: 'Small board at the bottom',
    id: 'Papan kecil di bawah',
    kz: 'Біліктің төмен жағында орналасқан кішкентай тақта',
    th: 'แผ่นเล็กอยู่ด้านล่าง',
    ug: 'بىلەن ئىشلەتكىلى بولىدىغان لوخچا قېلىنلىقى تەرتىپلەش',
    vi: 'Tấm nhỏ ở dưới',
    zh_tc: '小板在下',
    ru: 'Маленькая доска внизу.',
    ko: '작은 판자는 아래에 있다',
    bur: 'ပြားငယ်အောက်တွင်ထားပါ',
    ben: 'ছোট বোর্ড নিচে',
    tr: 'Küçük levha altta',
    km: 'ផ្ទាំងតូចនៅក្រោម',
    es: 'Las tablas pequeñas están en la parte inferior',
    ar: 'الألواح الصغيرة في الأسفل',
  },
  'cuttingDock.sawEngraving.useSawTipOne': {
    zh: '启用后仅柜柜中焊接板属性的小板才会使用锯片加工，非焊接板将直刀切割',
    en: 'After activation, only the small plates with welded plate attributes in the cabinet will be processed with saw blades, while non-welded plates will be cut with straight knives',
    id: 'Setelah diaktifkan, hanya papan kecil dengan properti "pelat las" dalam kabinet yang akan diproses menggunakan pisau gergaji, sedangkan papan non-las akan dipotong dengan pisau lurus',
    kz: 'Іске қосқаннан кейін тек қаптамадағы дәнекерленетін тақталардың кішкентай тақталары ғана ара қырқышпен өңделетін болады, дәнекерленбейтін тақталар тікелей пышақпен кесіледі',
    th: 'หลังจากเปิดใช้งานแล้ว แผ่นขนาดเล็กที่มีคุณสมบัติเป็น "แผ่นเชื่อม" ในตู้เท่านั้น จะถูกตัดด้วยใบเลื่อย ส่วนแผ่นที่ไม่ใช่แผ่นเชื่อมจะตัดด้วยมีดตรง',
    ug: 'ئىشلىتىپ بولغاندىن كېيىن، ئىشەنچە قابىدىكى پەس جايچىپ (ئېلېكتر جايچىپ) خاسلىقىدىكى كىچىك لوخچا (تاختا)لا سورۇق تېرە بىلەن ئىشلەيدۇ، پەس جايچىپسىز (ئېلېكتر جايچىپسىز) تاختىلار توغرا كېسىش (مۇستەقىم پىچاق) ئارقىلىق كېسىلىدۇ',
    vi: 'Kích hoạt chỉ thuộc tính hàn trong nội các bảng nhỏ sẽ được xử lý bằng lưỡi cưa, không hàn tấm cắt thẳng',
    zh_tc:
      '啟用後僅櫃體中焊接板屬性的小板才會使用鋸片加工，非焊接板將使用直刀切割',
    ru: 'После включения только небольшие пластины с свойствами сварной пластины в шкафу будут обрабатываться пилой, а не сварной пластиной, чтобы разрезать прямой нож',
    ko: '사용 가능한 경우 캐비닛의 용접판 속성에 있는 보드만 톱날을 사용하여 가공되고 비용접판은 직선으로 가공됩니다.',
    bur: 'ဖွင့်ပြီးနောက် ဂဟေပြားဂုဏ်သတ္တိရှိပြားငယ်များသာဆောက်ဓားဖြင့်ကတ်တင်းမည်၊ ဂဟေမပြားများကိုဖြောင့်ဓားဖြင့်ဖြတ်မည်',
    ben: 'সক্রিয় করার পর কেবল ক্যাবিনেটে ওয়েল্ডিং প্লেট বৈশিষ্ট্যের ছোট প্লেটই কাটিং ব্লেডে প্রসেস হবে, নন-ওয়েল্ডিং প্লেট সোজা চাকুতে কাটা হবে',
    tr: 'Etkinleştirildiğinde yalnızca dolapta kaynaklı levha özelliği olan küçük levhalar testere ile işlenir; kaynaklı olmayanlar düz bıçakla kesilir',
    km: 'បើបើក តែផ្ទាំងតូចដែលមានលក្ខណៈផ្ទាំងផ្សារក្នុងទូទើបប្រើកាំបិទរណ្តៅ ផ្ទាំងមិនផ្សារកាត់ដោយដាវផ្ទាត់',
    es: 'Después de habilitarla, solo las placas pequeñas con propiedades de placa soldada en el gabinete se procesarán con hojas de sierra, y las placas no soldadas se cortarán con un cuchillo recto',
    ar: 'بعد التمكين، ستتم معالجة اللوحات الصغيرة فقط ذات خصائص اللوحة الملحومة في الخزانة باستخدام شفرات المنشار، وسيتم قطع الألواح غير الملحومة بسكين مستقيم',
  },
  'cuttingDock.sawEngraving.useSawTipTwo': {
    zh: '启用后使用"自定义大板排版顺序"时焊接板将不会使用标准大板进行排版，只会使用特殊大板排版',
    en: 'After enabling "Custom Large Board Layout Sequence", standard large boards will not be used for layout. If mixed layout is required, please add the original data of welded boards and honeycomb boards in the special large boards',
    id: 'Setelah diaktifkan, fungsi "Pengurutan Custom Papan Besar" tidak akan menggunakan papan besar standar. Jika ingin pengurutan campuran, tambahkan data material awal pelat las dan papan sarang lebah ke dalam Papan Besar Khusus',
    kz: 'Іске қосқаннан кейін "Үлкен тақталарды өзгеше реттеу" функциясында стандартты үлкен тақталар қолданылмайды. Аралас реттеу қажет болса, ерекше үлкен тақталар бөліміне дәнекерленетін тақталар мен ұялы тақталардың бастапқы деректерін қосыңыз',
    th: 'หลังจากเปิดใช้งานแล้ว ระบบจะไม่ใช้แผ่นมาตรฐานในฟังก์ชัน "การจัดเรียงแผ่นใหญ่แบบกำหนดเอง" หากต้องการจัดเรียงแบบผสม กรุณาเพิ่มข้อมูลแผ่นดิบของ แผ่นเชื่อมและแผ่นรังผึ้ง ในส่วน แผ่นใหญ่พิเศษ',
    ug: 'ئىشلىتىپ بولغاندىن كېيىن، "ئىختىيارى چوڭ لوخچا (تاختا) تەرتىپلەش" ئۆلچەملىك چوڭ تاختىلارنى ئىشلەتمەيدۇ. ئەگەر ئارىلاش تەرتىپلەش قىلماقچى بولسىڭىز، ئالاھىدە چوڭ تاختا تىزىملىكىگە پەس جايچىپ (ئېلېكتر جايچىپ) ۋە ھۇجەيرە تاختا (honeycomb) قاتارلىق ئەسلى ماھىلۇماتلارنى قوشۇڭ',
    vi: 'Sau khi kích hoạt "tùy chỉnh bảng xếp hạng lớn" sẽ không sử dụng bảng tiêu chuẩn để sắp xếp, nếu bạn cần phải phối hợp các bảng xếp hạng, xin vui lòng thêm vào các tấm hàn và các tấm ban đầu của dữ liệu trên một tấm lớn đặc biệt',
    zh_tc:
      '啟用後"自定義大板排版順序"將不會使用標準大板進行排版，如需混合排版請在特殊大板中添加焊接板和蜂窩板原片數據',
    ru: 'При использовании « настраиваемого порядка сортировки больших пластин» после включения сварные пластины не будут печататься с использованием стандартных больших пластин, будут использоваться только специальные большие пластины',
    ko: '사용 후 사용자 정의 보드 레이아웃 순서를 사용할 경우 용접 보드는 표준 보드를 사용하지 않고 특수 보드만 사용됩니다.',
    bur: 'ကြီးပြားအစီအစဉ်ကိုဖွင့်ပြီးနောက် စံကြီးပြားမသုံးပါ၊ ရောစပ်အစီအစဉ်လိုပါက အထူးကြီးပြားတွင်ဂဟေနှင့်ပျားအုံပြားဒေတာထည့်ပါ',
    ben: '"কাস্টম লার্জ বোর্ড লেআউট সিকোয়েন্স" চালু করলে স্ট্যান্ডার্ড বড় বোর্ড লেআউটে ব্যবহার হবে না; মিশ্র লেআউট চাইলে স্পেশাল লার্জ বোর্ডে ওয়েল্ড ও হানিকম্ব বোর্ডের ডেটা যোগ করুন',
    tr: 'Özel büyük levha sırası açıkken kaynaklı levhalar standart büyük levha ile yerleştirilmez; karışık yerleşim için özel büyük levhaya kaynaklı ve petek levha ham verilerini ekleyin',
    km: 'បើប្រើលំដាប់ផ្ទាំងធំផ្ទាល់ខ្លួន ផ្ទាំងផ្សារមិនចងក្រងជាមួយផ្ទាំងធំស្តង់ដារ; ចងលាយ សូមបន្ថែមទិន្នន័យផ្ទាំងផ្សារ និងផ្ទាំងឃ្លុបនៅផ្ទាំងធំពិសេស',
    es: 'Cuando se habilita y se usa la "secuencia de diseño de placa grande personalizada", las placas soldadas no usarán placas grandes estándar para el diseño, solo se usarán placas grandes especiales para el diseño',
    ar: 'عند التمكين واستخدام "تسلسل تخطيط اللوحة الكبيرة المخصص"، لن تستخدم اللوحات الملحومة لوحات كبيرة قياسية للتخطيط، وسيتم استخدام لوحات كبيرة خاصة فقط للتخطيط',
  },
  'cuttingDock.sawEngraving.useSaiTipThree': {
    zh: '启用该功能后排版方案必须使用锯切排板',
    en: 'After enabling this function, the nesting solution must use the sawing layout',
    id: 'Setelah mengaktifkan fungsi ini, solusi tata letak (nesting) harus menggunakan tata letak penggergajian',
    kz: 'Бұл функцияны қосқаннан кейін, орналастыру шешімі ара кесу орналастыруын пайдалануы керек',
    th: 'หลังจากเปิดใช้งานฟังก์ชันนี้ แผนการจัดเรียงชิ้นงาน (nesting) ต้องใช้เลย์เอาต์การตัดเลื่อยเท่านั้น',
    ug: 'بۇ قۇرۇلمىنى قوزغىغاندىن كېيىن، پەسلى قىلىش لايىھىسى ئەگەر يۆنىلىشى پەسلى قىلىش لايىھىسىنى ئىشلىتىشى شەرت',
    vi: 'Sau khi kích hoạt tính năng này, phương án bố trí (nesting) bắt buộc phải sử dụng bố cục cắt cưa',
    zh_tc: '啟用該功能後，排版方案必須使用鋸切排版',
    ru: 'После включения этой функции необходимо использовать пиломатериалы',
    ko: '이 기능이 활성화되면 배열 체계는 반드시 톱으로 배열을 잘라야 한다',
    bur: 'ဤလုပ်ဆောင်ချက်ဖွင့်ပြီးနောက် အစီအစဉ်သည် ဆောက်ဖြတ်အစီအစဉ်ကိုသုံးရမည်',
    ben: 'এই ফাংশন চালু করার পর নেস্টিং সলিউশনে sawing লেআউট ব্যবহার করতে হবে',
    tr: 'Bu işlev açıldıktan sonra yerleşim çözümü testere kesim yerleşimini kullanmalıdır',
    km: 'បន្ទាប់ពីបើកមុខងារនេះ ដំណោះស្រាយចងក្រងត្រូវប្រើការចងក្រងកាត់រណ្តៅ',
    es: 'Después de habilitar esta función, el plan de diseño debe usar corte y diseño con sierra',
    ar: 'بعد تمكين هذه الوظيفة، يجب أن تستخدم خطة التخطيط القطع والتخطيط بالمنشار',
  },
  'cuttingDock.sawEngraving.surplusStoreAndLabeling': {
    zh: '切断后的余料可入库和打印标签',
    en: 'Cut off the remaining material can be stored and printed labels',
    id: 'Sisa material setelah pemotongan dapat disimpan dan dicetak label',
    kz: 'Қалдық материалды кесуден кейін сақтау және таңбалау мүмкін',
    th: 'เศษวัสดุหลังตัดสามารถเก็บเข้าคลังและพิมพ์ฉลากได้',
    ug: 'قالدۇق ماتېرىيالنى ئالدى بىلەن كېسىش يولى',
    vi: 'Phần còn lại sau khi cắt có thể được lưu và in nhãn',
    zh_tc: '切斷後的剩餘材料可以入庫和打印標籤',
    ru: 'Отрезанные остатки могут храниться и печататься на этикетках',
    ko: '절단 후 남은 재료는 입고와 라벨을 인쇄할 수 있다',
    bur: 'ဖြတ်ပြီးအကြွင်းကိုသိုလှောင်ပြီးတံဆိပ်ရိုက်နိုင်သည်',
    ben: 'কাটার পর অবশিষ্ট উপকরণ সংরক্ষণ ও লেবেল প্রিন্ট করা যাবে',
    tr: 'Kesilen artık malzeme depolanabilir ve etiket basılabilir',
    km: 'សំណល់បន្ទាប់ពីកាត់អាចចូលឃ្លាំង និងបោះពុម្ពស្លាក',
    es: 'Los materiales restantes después del corte se pueden almacenar e imprimir con etiquetas',
    ar: 'يمكن تخزين المواد المتبقية بعد القطع وطباعتها باستخدام الملصقات',
  },
  'cuttingDock.sawEngraving.surplusMinLength': {
    zh: '余料最小可用长度',
    en: 'Minimum usable length of remaining material',
    id: 'Panjang minimum material sisa yang dapat digunakan',
    kz: 'Қалдық материалдың ең аз қолдану ұзындығы',
    th: 'ความยาวขั้นต่ำที่ใช้งานได้ของวัสดุเหลือ',
    ug: 'قالدۇق ماتېرىيالنىڭ ئەڭ كىچىك ئىشلىتىشكە بولىدىغان ئۇزۇنلۇقى',
    vi: 'Chiều dài tối thiểu có thể sử dụng của phần còn lại',
    zh_tc: '剩餘材料的最小可用長度',
    ru: 'Минимальная доступная длина остатка',
    ko: '남은 재료의 최소 사용 가능한 길이',
    bur: 'အကြွင်းအကျန်အသုံးပြုနိုင်အနည်းဆုံးအလျား',
    ben: 'অবশিষ্ট উপকরণের ন্যূনতম ব্যবহারযোগ্য দৈর্ঘ্য',
    tr: 'Artık malzeme minimum kullanılabilir uzunluk',
    km: 'ប្រវែងប្រើបានអប្បបរមានៃសំណល់',
    es: 'El mínimo longitud disponible de los materiales restantes',
    ar: 'الحد الأدنى لطول المواد المتبقية',
  },
  'cuttingDock.sawEngraving.surplusMinSize': {
    zh: '余料最小可用尺寸',
    en: 'Minimum usable size of remaining material',
    id: 'Ukuran minimum material sisa yang dapat digunakan',
    kz: 'Қалдық материалдың ең аз қолдану өлшемі',
    th: 'ขนาดขั้นต่ำที่ใช้งานได้ของวัสดุเหลือ',
    ug: 'قالدۇق ماتېرىيالنىڭ ئەڭ كىچىك ئىشلىتىشكە بولىدىغان ئۆلچىمى',
    vi: 'Kích thước tối thiểu có thể sử dụng của phần còn lại',
    zh_tc: '剩餘材料的最小可用尺寸',
    ru: 'Минимальный размер остатка',
    ko: '남은 재료의 최소 사용 가능한 크기',
    bur: 'အကြွင်းအကျန်အသုံးပြုနိုင်အနည်းဆုံးအဝေး',
    ben: 'অবশিষ্ট উপকরণের ন্যূনতম ব্যবহারযোগ্য আকার',
    tr: 'Artık malzeme minimum kullanılabilir boyut',
    km: 'កម្រិតប្រើបានអប្បបរមានៃសំណល់',
    es: 'El tamaño mínimo disponible de los materiales restantes',
    ar: 'الحد الأدنى لحجم المواد المتبقية',
  },
  'cuttingDock.sawEngraving.crossCutOnlyMinSurplusSize': {
    zh: '余料满足最小可用尺寸才生成横切余料路径',
    en: 'Surplus will generate a cross-cutting path only if the minimum usable size is met',
    id: 'Sisa bahan hanya akan dibuat jalur pemotongan silang jika ukuran minimum yang dapat digunakan terpenuhi',
    kz: 'Қалдық материалдың ең аз қолдану өлшемі орындалса ғана көлденең кесу жолы жасалады',
    th: 'จะสร้างเส้นทางตัดขวางเฉพาะเมื่อเศษวัสดุตรงตามขนาดขั้นต่ำที่ใช้งานได้',
    ug: 'قالدۇق ماتېرىيال ئەڭ كىچىك ئىشلىتىشكە بولىدىغان ئۆلچەمگە يېتىشىشى كېرەك، ئۇنداقتا توغرىسىغا كېسىش يولى پەيدا بولىدۇ',
    vi: 'Chỉ tạo đường cắt ngang khi phần còn lại đáp ứng kích thước tối thiểu có thể sử dụng',
    zh_tc: '只有剩餘材料達到最小可用尺寸時才生成橫切剩餘材料路徑',
    ru: 'Путь поперечного реза будет создан только при достижении минимального размера остатка',
    ko: '남은 재료가 최소 사용 가능 크기를 충족해야 횡절 여분 경로가 생성됩니다',
    bur: 'အကြွင်းအကျန်သည် အသုံးပြုနိုင်အနည်းဆုံးအရွယ်အစားကိုဖြစ်မှ မျဉ်းဖြတ်လမ်းကြောင်းကိုဖန်တီးပါမည်',
    ben: 'অবশিষ্ট উপকরণ ন্যূনতম ব্যবহারযোগ্য আকার পূরণ করলেই কেবল ক্রস-কাট পথ তৈরি হবে',
    tr: 'Artık malzeme minimum kullanılabilir boyutu sağladığında yalnızca çapraz kesim yolu oluşturulur',
    km: 'តាមពិតនឹងបង្កើតផ្លូវកាត់ឆ្លងតែបើសំណល់មានទំហំអប្បបរមាដែលអាចប្រើបានត្រូវបំពេញ',
    es: 'Solo se generará una trayectoria de corte transversal si el material restante cumple con el tamaño mínimo utilizable',
    ar: 'يتم إنشاء مسار القطع العرضي فقط إذا تم تحقيق الحد الأدنى للحجم القابل للاستخدام للمواد المتبقية',
  },
  'cuttingDock.sawEngraving.surplusStoreAndLabelingTip': {
    zh: '1、大板顶部或底部将生成蓝色余料区，该余料区可正常入库和打印标签',
    en: '1、The blue surplus area will be generated on the top or bottom of the large board, which can be normally stored and printed labels',
    id: '1、Pada setiap papan besar, sisa material akan dihasilkan di atas atau di bawah, sisa material dapat disimpan dan dicetak label',
    kz: '1、Үлкен тақтадағы жоғары немесе төмен жағында бос қалдық аймағы пайда болады, бұл аймақтың материалы бос болып, сақтау және таңбалау мүмкін',
    th: '1. โซนเศษวัสดุสีน้ำเงินจะถูกสร้างที่ด้านบนหรือด้านล่างของแผ่นใหญ่ โซนนี้สามารถเก็บเข้าคลังและพิมพ์ฉลากได้ตามปกติ',
    ug: '1、قالدۇق ماتېرىيالنى ئالدى بىلەن كېسىش يولى',
    vi: '1、Trên mỗi tấm lớn, phần còn lại sẽ được tạo ra ở trên hoặc dưới, phần còn lại có thể được lưu và in nhãn',
    zh_tc:
      '1、在每張大板上，剩餘材料將生成在上方或下方，剩餘材料可以入庫和打印標籤',
    ru: 'В верхней или нижней части большой пластины образуется голубая зона остаточного материала, которая может быть нормально складирована и напечатана на этикетке',
    ko: '1. 대판 상단 또는 하단에는 파란색 여분 공간이 생성되며 이 여분 공간은 정상적으로 입고되고 라벨을 인쇄할 수 있다',
    bur: '၁、ကြီးပြားအပေါ်/အောက်တွင်အပြာရောင်အကြွင်းနေရာထုတ်မည်၊ ပုံမှန်သိုလှောင်နိုင်ပြီးတံဆိပ်ရိုက်နိုင်သည်',
    ben: '১、বড় বোর্ডের ওপর বা নিচে নীল অবশিষ্ট অঞ্চল তৈরি হবে, স্বাভাবিক সংরক্ষণ ও লেবেল প্রিন্ট করা যাবে',
    tr: '1. Büyük levhada üstte veya altta mavi artık alanı oluşur; bu alan normal şekilde depolanıp etiketlenebilir',
    km: '១. តំបន់សំណល់ពណ៌ខៀវបង្កើតនៅលើឬក្រោមផ្ទាំងធំ អាចចូលឃ្លាំង និងបោះពុម្ពស្លាកបានធម្មតា',
    es: '1. Se generará un área azul de material restante en la parte superior o inferior de la placa grande, que se puede guardar e imprimir etiquetas normalmente',
    ar: '1. سيتم إنشاء منطقة زرقاء من المواد المتبقية في الجزء العلوي أو السفلي من اللوحة الكبيرة، والتي يمكن تخزينها وطباعة الملصقات بشكل طبيعي',
  },
  'cuttingDock.sawEngraving.surplusStoreAndLabelingTip2': {
    zh: '2、焊接板将不生效"余料自动裁剪"功能）',
    en: '2、The "automatic cutting of remaining materials" function will not take effect for welded plates）',
    id: '2、Sisa material setelah pemotongan tidak dapat digunakan untuk papan las）',
    kz: '2、Дәнекерленетін тақталар үшін "Қалдық материалды автоматты түрде кесу" функциясы әсер етпейді）',
    th: '2. แผ่นเชื่อมจะไม่เปิดใช้ฟังก์ชัน "การตัดเศษวัสดุอัตโนมัติ")',
    ug: '2、قالدۇق ماتېرىيالنى ئالدى بىلەن كېسىش يولى',
    vi: '2、Phần còn lại sau khi cắt không thể được sử dụng cho tấm hàn）',
    zh_tc: '2、剩餘材料自動裁剪功能對焊接板不生效）',
    ru: '2, сварочные пластины не вступят в силу функция "автоматической обрезки остатков")',
    ko: '2. 용접판은"여분 재료 자동 재단"기능이 적용되지 않습니다.)',
    bur: '၂、ဂဟေပြားများတွင် "အကြွင်းအလိုအလျောက်ဖြတ်ခြင်း" မအလုပ်မလုပ်ပါ）',
    ben: '২、ওয়েল্ডিং প্লেটে "অবশিষ্ট উপকরণ স্বয়ংক্রিয় কাটিং" কার্যকর হবে না）',
    tr: '2. Kaynaklı levhalar için Artık Otomatik Kırpma işlevi geçerli olmaz',
    km: '២. មុខងារកាត់សំណល់ស្វ័យប្រវត្តិមិនអនុវត្តសម្រាប់ផ្ទាំងផ្សារ',
    es: '2. La función de "corte automático de material remanente" no será efectiva para placas soldadas)',
    ar: '2. لن تكون وظيفة "القطع التلقائي للمواد المتبقية" فعالة بالنسبة للألواح الملحومة)',
  },
  'cuttingDock.sawEngraving.surplusStoreAndLabelingTip3': {
    zh: '（启用后',
    en: '（After activation',
    id: '（Setelah diaktifkan',
    kz: '（Іске қосқаннан кейін',
    th: '(หลังจากเปิดใช้งาน',
    ug: '（ئىشلىتىپ بولغاندىن كېيىن',
    vi: '（Sau khi kích hoạt',
    zh_tc: '（啟用後',
    ru: '(После включения',
    ko: '(활성화 후',
    bur: '（ဖွင့်ပြီးနောက်',
    ben: '（সক্রিয় করার পর',
    tr: '（Etkinleştirme sonrası',
    km: '（បន្ទាប់ពីបើកដំណើរការ',
    es: '(Después de habilitarlo',
    ar: '(بعد التمكين',
  },
  'cuttingDock.sawEngraving.backCutSurplus': {
    zh: '反面截取余料',
    en: 'Cut off the remaining material from the reverse side',
    id: 'Memotong sisa material dari sisi belakang',
    kz: 'Артқы жағынан қалдық материалды кесу',
    th: 'ตัดเศษวัสดุจากด้านหลัง',
    ug: 'ئارقا تەرەپتە قالدۇق ماتېرىيال كېسىش',
    vi: 'Tiếp nhận phần còn lại',
    zh_tc: '從反面截取剩餘材料',
    ru: 'Обратный отсек',
    ko: '뒷면에서 남은 재료를 절취하다.',
    bur: 'ပြောင်းပြန်ဘက်မှအကြွင်းဖြတ်ယူခြင်း',
    ben: 'উল্টো দিক থেকে অবশিষ্ট উপকরণ কেটে নিন',
    tr: 'Arka yüzden artık kes',
    km: 'កាត់សំណល់ពីខាងក្រោម',
    es: 'El material restante se intercepta desde el reverso',
    ar: 'يتم اعتراض المواد المتبقية من الجانب الخلفي',
  },
  'cuttingDock.sawEngraving.cutSurplusTip': {
    zh: '启用后请将反面修边顺序设置为"反面孔槽加工后修边"',
    en: 'After enabling, please set the reverse-side trimming order to "Trim after reverse-side slot machining"',
    id: 'Setelah mengaktifkan, silakan atur urutan pemangkasan sisi belakang ke "Pemangkasan setelah pemesinan alur sisi belakang"',
    kz: 'Қосқаннан кейін, артқы жақты кесу тәртібін "Артқы жақ ойықты өңдеуден кейін кесу" деп орнатыңыз',
    th: 'หลังจากเปิดใช้งานแล้ว โปรดตั้งค่าลำดับการตัดแต่งด้านหลังเป็น "ตัดแต่งหลังจากกัดเซาะร่องด้านหลัง"',
    ug: 'ئىشلەتكەندىن كېيىن، ئارقا تەرەپ قىرپىق كېسىش تەرتىپىنى "ئارقا تەرەپ ئويۇق ئىشلەندىن كېيىن قىرپىق كېسىش" دەپ بەلگىلەڭ',
    vi: 'Sau khi kích hoạt, hãy đặt thứ tự cắt mép mặt sau thành "Cắt mép sau khi gia công rãnh lỗ mặt sau"',
    zh_tc: '啟用後請將反面修邊順序設置為"反面孔槽加工後修邊',
    ru: 'После включения установите порядок обрезки на обратной стороне как "после обработки отверстия на обратной стороне".',
    ko: '활성화되면 뒷면 모서리 수정 순서를 뒷면 구멍 슬롯 머시닝 후 모서리 수정으로 설정합니다.',
    bur: 'ဖွင့်ပြီးနောက် ပြောင်းပြန်ဘက်အစွန်းညှိအစဉ်ကို "ပြောင်းပြန်အချိုးကတ်တင်းပြီးနောက်ညှိပါ" သတ်မှတ်ပါ',
    ben: 'সক্রিয় করার পর রিভার্স সাইড ট্রিমিং অর্ডার "রিভার্স সাইড স্লট মেশিনিং এর পর ট্রিম" এ সেট করুন',
    tr: 'Etkinleştirdikten sonra arka yüz kenar düzeltme sırasını Arka yüz oluk işleminden sonra kenar düzelt olarak ayarlayın',
    km: 'បន្ទាប់ពីបើក កំណត់លំដាប់កែសម្រួលគែមខាងក្រោមជា «កែសម្រួលបន្ទាប់ពីដំណើរការរណ្តៅខាងក្រោម»',
    es: 'Después de habilitarlo, configure la secuencia de recorte inverso en "Recorte después del orificio inverso procesamiento"',
    ar: 'بعد التمكين، يرجى ضبط تسلسل التشذيب العكسي على "التقليم بعد معالجة الثقب العكسي"',
  },
  'cuttingDock.sawEngraving.top': {
    zh: '上边',
    en: 'Top',
    id: 'Di atas',
    kz: 'жоғары жақ',
    th: 'ข้างบน',
    ug: 'ئۈستى گىرۋەك',
    vi: 'bên trên',
    zh_tc: '上邊',
    ru: 'сверху',
    ko: '위쪽',
    bur: 'အပေါ်ဘက်',
    ben: 'উপরে',
    tr: 'üst',
    km: 'លើ',
    es: 'Borde superior',
    ar: 'الحافة العلوية',
  },
  'cuttingDock.sawEngraving.bottom': {
    zh: '下边',
    en: 'Bottom',
    id: 'di bawah',
    kz: 'төмен жақ',
    th: 'ด้านล่าง',
    ug: 'ئاستى گىرۋەك',
    vi: 'bên dưới',
    zh_tc: '下邊',
    ru: 'Внизу.',
    ko: '아래',
    bur: 'အောက်ဘက်',
    ben: 'নিচে',
    tr: 'alt',
    km: 'ក្រោម',
    es: 'Borde inferior',
    ar: 'الحافة السفلية',
  },
  'cuttingDock.sawEngraving.left': {
    zh: '左边',
    en: 'Left',
    id: 'kiri',
    kz: 'сол жақ',
    th: 'ซ้าย',
    ug: 'سول گىرۋەك',
    vi: 'bên trái',
    zh_tc: '左邊',
    ru: 'Слева.',
    ko: '왼쪽',
    bur: 'ဘယ်ဘက်',
    ben: 'বাম',
    tr: 'sol',
    km: 'ឆ្វេង',
    es: 'Izquierda',
    ar: 'اليسرى',
  },
  'cuttingDock.sawEngraving.right': {
    zh: '右边',
    en: 'Right',
    id: 'Kanan',
    kz: 'оң жақ',
    th: 'ขวา',
    ug: 'ئوڭ گىرۋەك',
    vi: 'bên phải',
    zh_tc: '右邊',
    ru: 'справа',
    ko: '오른쪽',
    bur: 'ညာဘက်',
    ben: 'ডান',
    tr: 'sağ',
    km: 'ស្តាំ',
    es: 'Derecha',
    ar: 'اليمنى',
  },
  'cuttingDock.sawEngraving.dockTip': {
    zh: '对接焊接板加工需要矩形板四边封边和总修边一样，且手动操作成单列排版',
    en: 'The processing of butt welded plates requires the sealing of the edges on all four sides of the rectangular plate, similar to the overall trimming, and manual operation in a single row layout',
    id: 'Pemrosesan pelat pengelasan pantat membutuhkan penyegelan empat sisi pelat persegi panjang dan pemangkasan tepi keseluruhan, dan mengoperasikannya secara manual ke tata letak baris tunggal.',
    kz: 'Дүйсенбі тұрау бөлімдерін іске асыру үшін, түтілген тақтаның төрт жиекке түйіп, бүкіл жиекпейісінен айырылуының сәйкес көрсету керек, және қолмен өңдеу арқылы бір жолақты түрлендіру керек',
    th: 'การประมวลผลแผ่นเชื่อมก้นต้องใช้การปิดผนึกสี่ด้านของแผ่นสี่เหลี่ยมและการตัดขอบโดยรวมและดำเนินการด้วยตนเองในรูปแบบแถวเดียว',
    ug: 'پىششىقلانغان تاختاينى ئىشلەشتە تۆت تەرەپ چەت چاپلاش ۋە ئومۇمىي تۈزىتىش ئوخشاش بولۇشى، ھەمدە قولدا بىر قۇر تەرتىپلەش كېرەك',
    vi: 'Gia công tấm Buttweld đòi hỏi bốn cạnh của tấm hình chữ nhật giống như cạnh cắt tổng thể, và hoạt động thủ công thành kiểu chữ cột đơn',
    zh_tc: '對接焊接板加工需要矩形板四邊封邊和總修邊一樣，且手動操作成單列排版',
    ru: 'Для обработки стыковочных сварных пластин требуется прямоугольная пластина с четырехсторонней обшивкой, как и общая обрезка, и ручное управление в однорядном наборе',
    ko: '버트 용접 플레이트 가공을 위해서는 직사각형 플레이트의 네 모서리가 총 수리 모서리와 동일해야 하며, 수동으로 단열 레이아웃으로 조작해야 한다',
    bur: 'ဂဟေပြားကတ်တင်းအတွက် လေးဘက်ပိတ်ပြီးအစွန်းညှိသကဲ့သို့၊ လက်ဖြင့်တစ်တန်းအစီအစဉ်လုပ်ပါ',
    ben: 'বাট ওয়েল্ডিং প্লেট প্রসেসিংয়ের জন্য আয়তক্ষেত্র প্লেটের চার দিক সিলিং ও ট্রিমিংয়ের মত, এবং একক সারি লেআউটে ম্যানুয়াল অপারেশন প্রয়োজন',
    tr: 'Çıkıntı kaynaklı levha işlemi için dikdörtgen levhanın dört kenarı kapatılmalı ve toplam kenar düzeltme ile uyumlu olmalı; tek sıra yerleşim manuel yapılmalıdır',
    km: 'ដំណើរការផ្ទាំងផ្សារបត់ទាមទារការបិទបួនគែមផ្ទាំងចតុកោណ និងស្រដៀងការកែសម្រួលគែមសរុប និងចងក្រងជាជួរតែមួយដោយដៃ',
    es: 'El procesamiento de placas de soldadura a tope requiere el mismo sellado de cuatro lados y recorte total de la placa rectangular, y operación manual en composición tipográfica de una sola fila',
    ar: 'تتطلب معالجة لوحة اللحام التناكبي نفس الختم من الجوانب الأربعة والتشذيب الكلي للوحة المستطيلة، والتشغيل اليدوي في التنضيد في صف واحد',
  },
  'cuttingDock.sawEngraving.sawToLayoutTip': {
    zh: '启用该功能后排版时小板间只会预留等于锯片厚度的切割缝',
    en: 'Saw cutting layout does not currently support specifying the cutting tool',
    id: 'Pemotongan layout sementara tidak mendukung pisau pemotongan yang ditentukan',
    kz: 'Қиындықтың жүктеуін баптау қолдауы жоқ',
    th: 'ยังไม่รองรับการเลือก',
    ug: 'ھەرە تىغى كېسىشنى قوزغاتقاندىن كېيىن تەرتىپلەشتە بىۋاسىتە غەيرى شەكىللىك تاختاي قوشۇشنى قوللىمايدۇ، قوشماقچى بولسىڭىز كېسىش تىزىملىكىگە بېرىپ قوشۇپ تەرتىپلەڭ!',
    vi: 'Cắt và sắp chữ không hỗ trợ chỉ định dao cắt',
    zh_tc: '啟用該功能後，排版時小板間只會預留等於鋸片厚度的切割縫',
    ru: 'При включении этой функции в комплекте между панелями зарезервированы только разрезные швы толщиной пилы.',
    ko: '이 기능을 활성화한 후 레이아웃할 때 보드에는 톱날 두께와 같은 가공만 예약됩니다.',
    bur: 'ဖွင့်ပြီးနောက် အစီအစဉ်တွင်ပြားငယ်များကြားဆောက်ဓားအထူနှင့်ညီသည့်ကတ်တင်းချောင်းသာချန်မည်',
    ben: 'সক্রিয় করার পর লেআউটে ছোট বোর্ডের মাঝে কেবল কাটিং ব্লেড বেধের সমান কাটিং গ্যাপ রাখা হবে',
    tr: 'Bu işlev açıldığında yerleşimde küçük levhalar arasında yalnızca testere kalınlığına eşit kesim payı bırakılır',
    km: 'បើបើកមុខងារនេះ រវាងផ្ទាំងតូចក្នុងចងក្រងមានតែគម្លាតកាត់ស្មើកម្រាស់កាំបិទរណ្តៅ',
    es: 'Después de habilitar esta función, solo se reservará un espacio de corte igual al espesor de la hoja de sierra entre las placas pequeñas durante la composición tipográfica',
    ar: 'بعد تمكين هذه الوظيفة، سيتم حجز فجوة قطع تساوي سمك شفرة المنشار فقط بين الألواح الصغيرة أثناء التنضيد',
  },
  'cuttingDock.sawEngraving.sawToLayoutTip2': {
    zh: '锯切排版暂不支持指定下料刀',
    en: 'The sawing layout function does not currently support specifying a blanking cutter.',
    id: 'Layout pemotongan gergaji untuk sementara tidak mendukung penunjukan pisau potong khusus',
    kz: 'Ара қима орналастыру қазіргі уақытта белгіленген кескіш құралды таңдауды қолдамайды',
    th: 'การจัดเลย์เอาต์การตัดเลื่อยยังไม่รองรับการเลือกมีดตัดชิ้นงานในขณะนี้',
    ug: 'ئەگەر يۆنىلىشى پەسلى قىلىش لايىھىسى ھازىرلاشقا ئېلىش چۆگۈنىنى بەلگىلەشنى قوللىمايدۇ',
    vi: 'Bố cục cắt cưa hiện không hỗ trợ chỉ định dao cắt phôi',
    zh_tc: '鋸切排版暫不支持指定下料刀',
    ru: 'Пильный набор временно не поддерживается',
    ko: '지정된 원단 공구는 조판 톱질에서 일시적으로 지원되지 않습니다.',
    bur: 'ဆောက်ဖြတ်အစီအစဉ်သည် ယခုအချိန်တွင်အတုံးချဓားသတ်မှတ်ခြင်းမပံ့ပိုးပါ',
    ben: 'স sawing লেআউট ফাংশন বর্তমানে ব্ল্যাঙ্কিং কাটার নির্দিষ্ট করা সমর্থন করে না',
    tr: 'Testere yerleşimi şu an belirtilen boşaltma bıçağını desteklemiyor',
    km: 'ការចងក្រងកាត់រណ្តៅមិនទាន់គាំទ្រកាំបិទដកដែលបានកំណត់',
    es: 'La composición tipográfica de aserrado actualmente no admite la cuchilla de corte especificada',
    ar: 'لا يدعم التنضيد بالنشر حاليًا سكين التقطيع المحدد',
  },
  'cuttingDock.sawEngraving.tempPaiabanTip': {
    zh: '启用锯片切割后不支持直接在排版添加异形板件，如需添加请前往开料清单添加并排版！',
    en: 'After enabling saw blade cutting, it is not supported to directly add irregular plates in the layout. If you need to add them, please go to the cutting list to add and layout them!',
    id: 'Setelah mengaktifkan pemotongan bilah gergaji, tidak didukung untuk menambahkan pelat berbentuk khusus secara langsung di tata letak. Jika Anda perlu menambahkan, silakan buka daftar pembuka untuk ditambahkan dan ketik!',
    kz: 'Жылжықты қиылуды іске қосқан соң, түрлі құрылғыларды түрлі өлшемдерді бұтаңдатын пайдалану мүмкін емес. Қосу қажет есінде, алмаз дискі бұтаңдықта қосу үшін, өңдеу тізіміне өту және түрлі құрылғыларды бұтаңдыңыз!',
    th: 'หลังจากเปิดใช้งานการตัดใบมีดไม่ได้รับการสนับสนุนเพื่อเพิ่มแผ่นรูปทรงพิเศษในเค้าโครงโดยตรง หากคุณต้องการเพิ่มโปรดไปที่รายการเปิดเพื่อเพิ่มและพิมพ์!',
    ug: 'ھەرە تىغى كېسىشنى قوزغاتقاندىن كېيىن تەرتىپلەشتە بىۋاسىتە غەيرى شەكىللىك تاختاي قوشۇشنى قوللىمايدۇ، قوشماقچى بولسىڭىز كېسىش تىزىملىكىگە بېرىپ قوشۇپ تەرتىپلەڭ!',
    vi: 'Sau khi kích hoạt cắt lưỡi cưa không hỗ trợ trực tiếp thêm phần bảng đặc biệt vào kiểu chữ, để thêm, hãy vào danh sách mở thêm và sắp chữ!',
    zh_tc:
      '啟用鋸片切割後不支持直接在排版添加異形板件，如需添加請前往開料清單添加並排版！',
    ru: 'После включения резки пилы не поддерживается добавление фасонных панелей непосредственно в набор, если вы хотите добавить, перейдите к списку открытых материалов для добавления и сортировки!',
    ko: '앤티앨리어싱을 활성화한 후에는 레이아웃에 직접 이형 플레이트를 추가할 수 없습니다. 추가하려면 커팅 리스트 추가 및 레이아웃으로 이동하십시오.',
    bur: 'ဆောက်ဓားကတ်တင်းဖွင့်ပြီးနောက် အစီအစဉ်တွင်တိုက်ရိုက်ပုံမမှန်ပြားထည့်ခြင်းမပံ့ပိုးပါ၊ ထည့်လိုပါက ကတ်တင်းစာရင်းသို့သွားပြီးထည့်ပြီးအစီအစဉ်လုပ်ပါ',
    ben: 'কাটিং ব্লেড কাটিং চালু করার পর লেআউটে সরাসরি অনিয়মিত প্লেট যোগ করা সমর্থিত নয়; যোগ করতে চাইলে কাটিং লিস্টে গিয়ে যোগ ও লেআউট করুন',
    tr: 'Testere kesimi etkinleştirildikten sonra yerleşime doğrudan özel şekilli levha eklenemez; eklemek için kesim listesine gidin',
    km: 'បន្ទាប់ពីបើកការកាត់រណ្តៅ មិនអាចបន្ថែមផ្ទាំងរាងពិសេសដោយផ្ទាល់ក្នុងចងក្រង; បន្ថែមនៅបញ្ជីកាត់',
    es: 'Después de habilitar el corte con hoja de sierra, no se admite agregar directamente paneles de formas especiales en la composición tipográfica. Si necesita agregarlo, vaya a la lista de cortes para agregarlo y componerlo.',
    ar: 'بعد تمكين قطع شفرة المنشار، لا يتم دعم إضافة لوحات ذات شكل خاص مباشرة في التنضيد. إذا كنت بحاجة إلى إضافته، يرجى الانتقال إلى قائمة القطع للإضافة والتنضيد!',
  },
  'cuttingDock.sawEngraving.generateCutSurplusPath': {
    zh: '生成先切断余料的横切路径',
    en: 'Generate a crosscut path that cuts off the remaining material first',
    id: 'Hasilkan jalur potong melintang yang terlebih dahulu memotong sisa bahan',
    kz: 'Алдымен қалған материалды кесіп тастайтын көлденең жолды жасаңыз',
    th: 'สร้างเส้นทางตัดขวางโดยตัดเศษวัสดุออกก่อน',
    ug: 'قالدۇق ماتېرىيالنى ئالدى بىلەن كېسىش يولى',
    vi: 'Tạo đường cắt ngang để cắt phần còn lại trước',
    zh_tc: '生成先切斷餘料的橫切路徑',
    ru: 'Создать поперечный путь для первого отсечения остатков',
    ko: '나머지 재료를 먼저 차단하는 횡단 경로 생성하기',
    bur: 'အကြွင်းကိုဦးစွာဖြတ်သည့်အလျားလိုက်ကတ်တင်းလမ်းကြောင်းထုတ်ပါ',
    ben: 'প্রথমে অবশিষ্ট উপকরণ কেটে ফেলার ক্রসকাট পাথ তৈরি করুন',
    tr: 'Önce artığı kesen enine kesim yolu oluştur',
    km: 'បង្កើតផ្លូវកាត់ឆ្លាស់កាត់សំណល់មុន',
    es: 'Genere una ruta de corte transversal que corte primero el material restante',
    ar: 'إنشاء مسار شامل يقطع المواد المتبقية أولاً',
  },
  'cuttingDock.sawEngraving.curSurplusPathTip': {
    zh: '启用后请将反面修边顺序设置为"反面孔槽加工后修边"',
    en: 'After activation, set the reverse trimming order as "trim after reverse hole/slot machining"',
    id: 'Setelah diaktifkan, atur urutan pemotongan sisi belakang dengan "potong setelah proses lubang/alur di sisi belakang"',
    kz: 'Іске қосқан соң, артқы жақты кесу ретін "артқы тесік/олқа өңдеуден кейін кесуді"',
    th: 'หลังเปิดใช้งาน กำหนดลำดับตัดด้านหลังเป็น "ตัดหลังจากการ加工รู/ร่องด้านหลัง"',
    ug: 'ئىشلىتىپ بولغاندىن كېيىن، ئارقا تەرەپنى قىيىش تەرتىپىنى "ئارقا تەرەپتىكى تۆشۈك/يىرىك ئىشلەنگەندىن كېيىن قىيىش" دەپ بەلگىلەڭ.',
    vi: 'Sau khi kích hoạt, xin vui lòng đặt theo thứ tự sửa chữa ngược lại cho "mặt sau khi sửa chữa các cạnh"',
    zh_tc: '啟用後請將反面修邊順序設置為"反面孔槽加工後修邊"',
    ru: 'После включения установите порядок обрезки на обратной стороне как "после обработки отверстия на обратной стороне".',
    ko: '활성화되면 뒷면 모서리 수정 순서를 뒷면 구멍 슬롯 머시닝 후 모서리 수정으로 설정합니다.',
    bur: 'ဖွင့်ပြီးနောက် ပြောင်းပြန်ဘက်အစွန်းညှိအစဉ်ကို "ပြောင်းပြန်အပေါက်/အချိုးကတ်တင်းပြီးနောက်ညှိပါ" သတ်မှတ်ပါ',
    ben: 'সক্রিয় করার পর রিভার্স ট্রিমিং অর্ডার "রিভার্স হোল/স্লট মেশিনিং এর পর ট্রিম" এ সেট করুন',
    tr: 'Etkinleştirdikten sonra arka yüz kenar düzeltme sırasını Arka yüz delik/oluk işleminden sonra kenar düzelt olarak ayarlayın',
    km: 'បន្ទាប់ពីបើក កំណត់លំដាប់កែសម្រួលខាងក្រោមជា «កែបន្ទាប់ពីដំណើរការរន្ធ/រណ្តៅខាងក្រោម»',
    es: 'Después de habilitarlo, configure la secuencia de recorte inverso en "Recorte después del orificio inverso procesamiento"',
    ar: 'بعد التمكين، يرجى ضبط تسلسل التشذيب العكسي على "التقليم بعد معالجة الثقب العكسي"',
  },
  'cuttingDock.robotArmDocking.autoLine': {
    zh: '自动线对接',
    en: 'Automatic line docking',
    id: 'Docking garis otomatis',
    kz: 'Автоматты сызық байланысы',
    th: 'การทำงานร่วมกับสายอัตโนมัติ',
    ug: 'ئاپتوماتىك سىزىق پىچىماق',
    vi: 'Kết nối dòng tự động',
    zh_tc: '自動線對接',
    ru: 'Автоматическая линия стыковка',
    ko: '자동 라인 연결',
    bur: 'အလွန်တော့မြန်ဆန်စက်လက်မောင်းချိတ်ဆက်ခြင်း',
    ben: 'স্বয়ংক্রিয় লাইন ডকিং',
    tr: 'Otomatik çizgi bağlantısı',
    km: 'ការភ្ជាប់ផ្លូវចលនា',
  },
  'cuttingDock.robotArmDocking.autoLineTip': {
    zh: '您没有自动线使用权限或者能开启的自动线数量不足',
    en: 'You do not have permission to use automatic lines or the number of automatic lines you can open is not enough',
    id: 'Anda tidak memiliki izin untuk menggunakan garis otomatis atau jumlah garis otomatis yang dapat dibuka Anda tidak cukup',
    kz: 'Автоматты сызық қолдану үшін рұқсатыңыз жоқ немесе қолдануға рұқсат етілген автоматты сызықтар саны жеткіліксіз',
    th: 'คุณไม่มีสิทธิใช้สายอัตโนมัติหรือจำนวนสายอัตโนมัติที่สามารถเปิดได้ไม่เพียงพอ',
    ug: 'ئاپتوماتىك سىزىقنى ئىشلىتىش ھوقۇقىڭىز يوق ياكى ئاچقىلى بولىدىغان ئاپتوماتىك سىزىق يوق',
    vi: 'Bạn không có quyền truy cập vào đường dây tự động hoặc không đủ số lượng đường dây tự động có thể mở',
    zh_tc: '您沒有自動線使用權限或者能開啟的自動線數量不足',
    ru: 'У вас нет разрешения на использование автоматических линий или количество автоматических линий, которые вы можете открыть, недостаточно',
    ko: '자동 라인 사용 권한이 없거나 열 수 있는 자동 라인 수가 부족합니다',
    bur: 'အလွန်တော့မြန်ဆန်စက်လက်မောင်းချိတ်ဆက်ခြင်းမပံ့ပိုးပါ၊ အလွန်တော့မြန်ဆန်စက်လက်မောင်းချိတ်ဆက်ခြင်းမပံ့ပိုးပါ',
    ben: 'স্বয়ংক্রিয় লাইন সংযোগ ব্যবহারের অনুমতি নেই বা স্বয়ংক্রিয় লাইন সংযোগের সংখ্যা যা আপনি খুলতে পারেন নাই',
    tr: 'Otomatik çizgi kullanma izni yok veya açabileceğiniz otomatik çizgi sayısı yetersiz',
    km: 'មានការអនុញ្ញាតិចូលរួមផ្លូវចលនា ឬ ចំនួនផ្លូវចលនាដែលអ្នកអាចបើកបានគឺមិនកើតឡើងទេ',
  },
  'cuttingDock.robotArmDocking.title': {
    zh: '机械臂对接',
    en: 'Robot arm docking',
    id: 'Lengan Robotik',
    kz: 'Механикалық қолдың байланысуы',
    th: 'การเชื่อมต่อของแขนหุ่นยนต์',
    ug: 'مەكائىنە قولونىنىڭ بىرلىشىشى',
    vi: 'Gắn khớp tay máy',
    zh_tc: '機械臂對接',
    ru: 'стык манипулятора',
    ko: '로봇 암 도킹',
    bur: 'စက်လက်မောင်းချိတ်ဆက်ခြင်း',
    ben: 'রোবট আর্ম ডকিং',
    tr: 'Robot kol bağlantısı',
    km: 'ការភ្ជាប់ដៃរបស់រូបយន្ត',
    es: 'Acoplamiento del brazo robótico',
    ar: 'إرساء الذراع الروبوتية',
  },
  'cuttingDock.robotArmDocking.enable': {
    zh: '启用机械臂对接',
    en: 'Enable robotic arm docking',
    id: 'Aktifkan docking lengan robot',
    kz: 'Механикалық қолдың байланысын іске қосу',
    th: 'เปิดใช้งานการเชื่อมต่อแขนหุ่นยนต์',
    ug: 'مەكائىلىلىق قول باغلىماق',
    vi: 'Kích hoạt việc kết nối cơ chế tay máy',
    zh_tc: '啟用機械臂對接',
    ru: 'Включить стыковку манипулятора',
    ko: '로봇 암 버트 사용',
    bur: 'စက်လက်မောင်းချိတ်ဆက်ခြင်းဖွင့်ပါ',
    ben: 'রোবট আর্ম ডকিং সক্ষম করুন',
    tr: 'Robot kol bağlantısını etkinleştir',
    km: 'បើកការភ្ជាប់ដៃរបស់រូបយន្ត',
    es: 'Habilite el acoplamiento del brazo robótico',
    ar: 'تمكين إرساء ذراع الروبوت',
  },
  'cuttingDock.robotArmDocking.enableTip': {
    zh: '开启后，输出生产文件时，会输出机械臂对接文件',
    en: 'After activation, when outputting production files, the docking file of the robotic arm will be output',
    id: 'Setelah dibuka, saat mengeluarkan dokumen produksi, dokumen docking lengan robot akan dikeluarkan',
    kz: 'Ашылып, өндірістік файл шығарғанда, механикалық қолдың қосылу файлы шығарылады',
    th: 'หลังจากเปิดเมื่อเอกสารการผลิตส่งออกไฟล์เชื่อมต่อแขนกลจะถูกส่งออก',
    ug: 'باشقۇرغاندىن كېيىن، چىقارىلىۇچى ئىشانچسىزلىك فايلىنى چىقارغاندا، مەككىنە ئۇرۇنماق فايلىنى چىقارىدۇ',
    vi: 'Sau khi mở, khi xuất tài liệu sản xuất, tài liệu kết nối cánh tay robot sẽ được xuất ra',
    zh_tc: '開啟後，輸出生產文件時，會輸出機械臂對接文件',
    ru: 'После открытия, при выходе производственного документа, выдается стыковочный файл манипулятора',
    ko: '켜면 프로덕션 파일을 내보낼 때 로봇 암 버트 파일이 내보내집니다.',
    bur: 'ဖွင့်ပြီးနောက် ထုတ်လုပ်မှုဖိုင်ထုတ်သည့်အခါ စက်လက်မောင်းချိတ်ဆက်ဖိုင်ထုတ်မည်',
    ben: 'সক্রিয় করার পর প্রোডাকশন ফাইল আউটপুট করার সময় রোবট আর্ম ডকিং ফাইল আউটপুট হবে',
    tr: 'Açıldığında üretim dosyası çıktısında robot kol bağlantı dosyası da üretilir',
    km: 'បើបើក ពេលនាំចេញឯកសារផលិតកម្ម ឯកសារភ្ជាប់ដៃរបស់រូបយន្តក៏ត្រូវបាននាំចេញ',
    es: 'Después de encender, al generar el archivo de producción, se generará el archivo de acoplamiento del brazo robótico',
    ar: 'بعد التشغيل، عند إخراج ملف الإنتاج، سيتم إخراج ملف إرساء ذراع الروبوت',
  },
  'cuttingDock.laserCuttingMachine.title': {
    zh: '激光一体机',
    en: 'Laser cutting all-in-one machine',
    id: 'Mesin pemotong laser all-in-one',
    kz: 'Лазерлік кесу біріктірілген машинасы',
    th: 'เครื่องตัดเลเซอร์แบบรวม',
    ug: 'لازېر كېسىش بىرلىك ماشىنىسى',
    vi: 'Máy cắt laser tích hợp',
    zh_tc: '激光切割一體機',
    ru: 'лазерная машина',
    ko: '레이저 올인원',
    bur: 'လေဆာကတ်တင်းတစ်ကိုယ်တည်းစက်',
    ben: 'লেজার কাটিং অল-ইন-ওয়ান মেশিন',
    tr: 'Lazer kesim hepsi bir arada',
    km: 'ម៉ាស៊ីនកាត់ឡាស៊ែររួមមួយ',
    es: 'Máquina láser todo en uno',
    ar: 'جهاز ليزر الكل في واحد',
  },
  'cuttingDock.laserCuttingMachine.enable': {
    zh: '启用激光一体机',
    en: 'Enable laser cutting all-in-one machine',
    id: 'Aktifkan mesin pemotong laser all-in-one',
    kz: 'Лазерлік кесу біріктірілген машинасын іске қосу',
    th: 'เปิดใช้งานเครื่องตัดเลเซอร์แบบรวม',
    ug: 'لازېر كېسىش بىرلىك ماشىنىسىنى قوزغىتىش',
    vi: 'Kích hoạt máy cắt laser tích hợp',
    zh_tc: '啟用激光切割一體機',
    ru: 'Включить лазерную машину.',
    ko: '레이저 올인원 사용',
    bur: 'လေဆာတစ်ကိုယ်တည်းစက်ဖွင့်ပါ',
    ben: 'লেজার কাটিং অল-ইন-ওয়ান মেশিন সক্ষম করুন',
    tr: 'Lazer kesim hepsi bir aradayı etkinleştir',
    km: 'បើកម៉ាស៊ីនកាត់ឡាស៊ែររួមមួយ',
    es: 'Habilite la máquina láser todo en uno',
    ar: 'تمكين جهاز ليزر الكل في واحد',
  },
  'cuttingDock.laserCuttingMachine.backSafeHeight': {
    zh: '反面空闲时Z高度(H)',
    en: 'Z height when back side is idle (H)',
    id: 'Tinggi Z saat sisi belakang kosong (H)',
    kz: 'Артқы жағы бос болғанда Z биіктігі (H)',
    th: 'ความสูง Z เมื่อด้านหลังว่าง (H)',
    ug: 'ئارقا بوش بولغاندا Z ئېگىزلىكى (H)',
    vi: 'Chiều cao Z khi mặt sau rảnh (H)',
    zh_tc: '反面空閒時Z高度(H)',
    ru: 'Высота Z при отрицательном свободном режиме (H)',
    ko: '뒷면 유휴 시 Z 높이(H)',
    bur: 'ပြောင်းပြန်ဘက်အလုပ်မလုပ်သည့်အခါ Z အမြင့်(H)',
    ben: 'পিছনের দিক অলস থাকলে Z উচ্চতা(H)',
    tr: 'Arka yüz boşta iken Z yüksekliği (H)',
    km: 'កម្ពស់ Z នៅពេលខាងក្រោមទំនេរ (H)',
    es: 'Cuando la parte posterior está inactiva Z Altura (H)',
    ar: 'عندما يكون الجانب الخلفي خاملاً Z الارتفاع (H)',
  },
  'cuttingDock.laserCuttingMachine.laserDistance': {
    zh: '正/反面激光刀切割时与板材表面的距离',
    en: 'Distance between laser knife and board surface when cutting on front/back',
    id: 'Jarak antara pisau laser dan permukaan papan saat memotong bagian depan/belakang',
    kz: 'Алдыңғы/артқы жағында кескенде лазер пышағы мен тақтай беті арасындағы қашықтық',
    th: 'ระยะห่างระหว่างมีดเลเซอร์กับพื้นผิวแผ่นเมื่อตัดด้านหน้า/หลัง',
    ug: 'ئالدى/ئارقا كېسىشتە لازېر پىچاق بىلەن تاختا يۈزى ئارىسىدىكى ئارىلىق',
    vi: 'Khoảng cách giữa dao laser và bề mặt tấm khi cắt mặt trước/sau',
    zh_tc: '正/反面激光刀切割時與板材表面的距離',
    ru: 'Расстояние между положительным и отрицательным лазерным ножом и поверхностью пластины при резке',
    ko: '양면 / 후면 레이저 커터 가공 시 판재 표면과의 거리',
    bur: 'အရှေ့/ပြောင်းပြန်ဘက်ကတ်တင်းစဉ် လေဆာဓားနှင့်ပြားမျက်နှာပြင်ကြားအကွာအဝေး',
    ben: 'সামনে/পিছনে কাটার সময় লেজার ছুরি ও বোর্ড পৃষ্ঠের মধ্যে দূরত্ব',
    tr: 'Ön/arka lazer bıçağı keserken levha yüzeyine uzaklık',
    km: 'ចម្ងាយពីដាវឡាស៊ែរទៅផ្ទៃផ្ទាំងពេលកាត់ខាងមុខ/ក្រោម',
    es: 'La distancia entre la cuchilla láser frontal/posterior y la superficie de la placa al cortar',
    ar: 'المسافة بين سكين الليزر الأمامي/الخلفي وسطح اللوحة عند القطع',
  },
  'cuttingDock.laserCuttingMachine.coordinateAxis': {
    zh: '坐标轴',
    en: 'Coordinate axis',
    id: 'Sumbu koordinat',
    kz: 'Координаталық ось',
    th: 'แกนพิกัด',
    ug: 'كوئوردىنات ئوكىسى',
    vi: 'Trục tọa độ',
    zh_tc: '坐標軸',
    ru: 'Координатная ось',
    ko: '좌표축',
    bur: 'ကိုဩဒိနိတ်ဝင်ရိုး',
    ben: 'কোঅর্ডিনেট অক্ষ',
    tr: 'Koordinat ekseni',
    km: 'អ័ក្សកូអរដោនេ',
    es: 'Eje de coordenadas',
    ar: 'محور الإحداثيات',
  },
  'cuttingDock.laserCuttingMachine.xAxis': {
    zh: 'X',
    en: 'X',
    id: 'X',
    kz: 'X',
    th: 'X',
    ug: 'X',
    vi: 'X',
    zh_tc: 'X',
    ru: 'X',
    ko: 'X',
    bur: 'X',
    ben: 'X',
    tr: 'X',
    km: 'X',
    es: 'X',
    ar: 'X',
  },
  'cuttingDock.laserCuttingMachine.yAxis': {
    zh: 'Y',
    en: 'Y',
    id: 'Y',
    kz: 'Y',
    th: 'Y',
    ug: 'Y',
    vi: 'Y',
    zh_tc: 'Y',
    ru: 'Y',
    ko: 'Y',
    bur: 'Y',
    ben: 'Y',
    tr: 'Y',
    km: 'Y',
    es: 'Y',
    ar: 'Y',
  },
  'cuttingDock.laserCuttingMachine.zAxis': {
    zh: 'Z',
    en: 'Z',
    id: 'Z',
    kz: 'Z',
    th: 'Z',
    ug: 'Z',
    vi: 'Z',
    zh_tc: 'Z',
    ru: 'Z',
    ko: 'Z',
    bur: 'Z',
    ben: 'Z',
    tr: 'Z',
    km: 'Z',
    es: 'Z',
    ar: 'Z',
  },
  'cuttingDock.laserCuttingMachine.cuttingSettings': {
    zh: '切割设置',
    en: 'Cutting settings',
    id: 'Pengaturan pemotongan',
    kz: 'Кесу параметрлері',
    th: 'การตั้งค่าการตัด',
    ug: 'كېسىش تەڭشىكى',
    vi: 'Cài đặt cắt',
    zh_tc: '切割設置',
    ru: 'Настройки резки',
    ko: '가공 설정',
    bur: 'ကတ်တင်းဆက်တင်း',
    ben: 'কাটিং সেটিংস',
    tr: 'Kesim ayarları',
    km: 'ការកំណត់កាត់',
    es: 'Configuraciones de corte',
    ar: 'إعدادات القطع',
  },
  'cuttingDock.laserCuttingMachine.backKnifeStore': {
    zh: '反面刀库',
    en: 'Back knife store',
    id: 'Kumpulan pisau belakang',
    kz: 'Артқы қиындық сақтау',
    th: 'ส่วนตัดด้านหลัง',
    ug: 'ئارقا پىچاق ئامبىرى',
    vi: 'Kho dao mặt sau',
    zh_tc: '反面刀庫',
    ru: 'Резцовый склад',
    ko: '후면 라이브러리',
    bur: 'ပြောင်းပြန်ဘက်ဓားသိုလှောင်ရုံ',
    ben: 'পিছনের ছুরি স্টোর',
    tr: 'Arka bıçak mağazası',
    km: 'ឃ្លាំងដាវខាងក្រោម',
    es: 'Almacén de herramientas inversas',
    ar: 'مجلة الأداة العكسية',
  },
  'cuttingDock.laserCuttingMachine.noSupportOriginalMaterialKnife': {
    zh: '暂不支持 “原片下料刀选择” 功能',
    en: 'The "Original material cutting knife selection" function is not currently supported',
    id: 'Fungsi "Pemilihan pisau pemotongan bahan asli" belum didukung',
    kz: '"Түпнұсқа материал кесу пышағы таңдау" функциясы әлі қолдау көрсетілмейді',
    th: 'ยังไม่รองรับฟังก์ชัน "การเลือกมีดตัดวัสดุดิบเดิม"',
    ug: '"ئەسلى ماتېرىيال كېسىش پىچاق تاللاش" فۇنكسىيىسىنى ھازىر قوللىمايدۇ',
    vi: 'Chức năng "Chọn dao cắt nguyên liệu gốc" hiện chưa được hỗ trợ',
    zh_tc: '暫不支持 "原片下料刀選擇" 功能',
    ru: 'Временно не поддерживается функция « Выбор оригинального ножа для разгрузки»',
    ko: '원본 원본 공구 선택 기능이 일시적으로 지원되지 않음',
    bur: '"အရင်းအမြစ်အတုံးချဓားရွေးချယ်ခြင်း" လုပ်ဆောင်ချက်ယခုမပံ့ပိုးပါ',
    ben: '"অরিজিনাল ম্যাটেরিয়াল কাটিং নাইফ সিলেকশন" ফাংশন বর্তমানে সমর্থিত নয়',
    tr: 'Ham malzeme kesim bıçağı seçimi şu an desteklenmiyor',
    km: 'មិនទាន់គាំទ្រការជ្រើសដាវកាត់សម្ភារៈដើម',
    es: 'actualmente no admite la función "selección de cuchilla de corte original"',
    ar: 'لا تدعم حاليًا وظيفة "تحديد سكين التقطيع الأصلي"',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip': {
    zh: '开料：用于加工内部未打穿异形',
    en: 'Cutting open: Used for processing internal shapes that have not been pierced',
    id: 'Pemotongan buka: Digunakan untuk memproses bentuk internal yang belum menembus',
    kz: 'Кесу ашу: Ішкі тесілмеген пішіндерді өңдеу үшін қолданылады',
    th: 'การตัดเปิด: ใช้สำหรับการแปรรูปรูปร่างภายในที่ยังไม่เจาะทะลุ',
    ug: 'كېسىش ئېچىش: ئىچكى ئۆتمىگەن شەكىلنى ئىشلەپچىقىرىش ئۈچۈن ئىشلىتىلىدۇ',
    vi: 'Cắt mở: Dùng để gia công hình dạng bên trong chưa xuyên thủng',
    zh_tc: '開料：用於加工內部未打穿異形',
    ru: 'Раскрытие: для обработки непробиваемых форм внутри',
    ko: '원단: 내부 뚫리지 않은 이형 가공에 사용',
    bur: 'အတုံးချခြင်း：အတွင်းမထိုးသည့်ပုံမမှန်များကိုကတ်တင်းရန်သုံးပါ',
    ben: 'কাটিং ওপেন: ভেতরের যে শেপগুলো ছিদ্র করা হয়নি সেগুলো প্রসেস করার জন্য',
    tr: 'Kesim açma: İçte delinmemiş özel şekiller için',
    km: 'កាត់បើក៖ សម្រាប់រាងពិសេសខាងក្នុងដែលមិនទាន់ដោតទិស',
    es: 'Corte: se usa para procesar formas especiales internas no perforadas',
    ar: 'القطع: يستخدم لمعالجة الأشكال الخاصة الداخلية غير المثقوبة',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip2': {
    zh: '激光刀：加工打穿的孔槽、内部异形、外轮廓下料',
    en: 'Laser knife: Processing pierced holes/slots, internal shapes, outer contour cutting',
    id: 'Pisau laser: Memproses lubang/alur yang menembus, bentuk internal, pemotongan kontur luar',
    kz: 'Лазер пышағы: Тесілген тесік/олықтарды, ішкі пішіндерді, сыртқы контур кесуін өңдеу',
    th: 'มีดเลเซอร์: แปรรูปรู/ร่องที่เจาะทะลุ รูปร่างภายใน การตัดขอบนอก',
    ug: 'لازېر پىچاق: ئۆتكەن چاڭ-ئۇيۇق، ئىچكى شەكىل، تاشقى كونتور كېسىش ئېچىش',
    vi: 'Dao laser: Gia công lỗ/rãnh đã xuyên thủng, hình dạng bên trong, cắt ngoại vi',
    zh_tc: '激光刀：加工打穿的孔槽、內部異形、外輪廓下料',
    ru: 'Лазерный нож: обработка пробитого желоба, внутренняя фасада, наружная раскраска профиля колеса',
    ko: '레이저 나이프: 뚫린 구멍 슬롯, 내부 이형, 외부 프로파일 하단 가공',
    bur: 'လေဆာဓား：ထိုးပြီးအပေါက်/အချိုး၊ အတွင်းပုံမမှန်၊ အပြင်ကွေးကြောင်းအတုံးချခြင်း',
    ben: 'লেজার ছুরি: ছিদ্র করা হোল/স্লট, ভেতরের শেপ, বাইরের কনট্যুর কাটিং প্রসেসিং',
    tr: 'Lazer bıçağı: Delinmiş delik/oluklar, iç şekiller, dış kontur kesimi',
    km: 'ដាវឡាស៊ែរ៖ រន្ធដោត/រណ្តៅ រាងខាងក្នុង កាត់គែមខាងក្រៅ',
    es: 'Cuchilla láser: procesa ranuras perforadas, formas especiales internas y corte de contorno externo',
    ar: 'سكين الليزر: معالجة فتحات الثقب المثقوبة والأشكال الخاصة الداخلية وتقطيع الكفاف الخارجي',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip3': {
    zh: '注意：反面Z轴默认使用与台面距离对应的相对坐标',
    en: 'Attention: The back Z-axis uses relative coordinates corresponding to the distance from the table surface by default',
    id: 'Perhatian: Sumbu Z belakang secara default menggunakan koordinat relatif yang sesuai dengan jarak ke permukaan meja',
    kz: 'Назар аударыңыз: Артқы Z осі әдепкі бойынша үстел бетіне дейінгі қашықтыққа сәйкес салыстырмалы координаттарды пайдаланады',
    th: 'หมายเหตุ: แกน Z ด้านหลังใช้พิกัดสัมพัทธ์ที่สอดคล้องกับระยะห่างจากพื้นผิวโต๊ะโดยค่าเริ่มต้น',
    ug: 'دىققەت: ئارقا Z ئوكىسى سۈكۈتتىكى ھالەتتە ئۈستەل يۈزىگە بولغان ئارىلىققا ماس كېلىدىغان نىسبىي كوئوردېناتنى ئىشلىتىدۇ',
    vi: 'Lưu ý: Trục Z mặt sau mặc định sử dụng tọa độ tương đối tương ứng với khoảng cách đến mặt bàn',
    zh_tc: '注意：反面Z軸默認使用與台面距離對應的相對座標',
    ru: 'Примечание: обратная ось Z по умолчанию использует относительные координаты, соответствующие расстоянию от стола',
    ko: '참고: 후면 Z축은 기본적으로 테이블 거리에 해당하는 상대 좌표를 사용합니다.',
    bur: 'မှတ်ချက်：ပြောင်းပြန်ဘက် Z ဝင်ရိုးသည် စားပွဲမျက်နှာပြင်မှအကွာအဝေးနှင့်ကိုက်ညီသည့်ဆက်စပ်ကိုဩဒိနိတ်ကိုပုံမှန်သုံးသည်',
    ben: 'নোট: পিছনের Z অক্ষ ডিফল্টে টেবিল পৃষ্ঠ থেকে দূরত্বের সাথে সঙ্গতিপূর্ণ রিলেটিভ কোঅর্ডিনেট ব্যবহার করে',
    tr: 'Dikkat: Arka Z ekseni varsayılan olarak tezgah yüzeyine göre göreli koordinat kullanır',
    km: 'សម្គាល់៖ អ័ក្ស Z ខាងក្រោមលំនាំដើមប្រើកូអរដោនេធៀបនឹងចម្ងាយទៅផ្ទៃតុ',
    es: 'Nota: De forma predeterminada, el eje inverso Z usa las coordenadas relativas correspondientes a la distancia de la mesa',
    ar: 'ملاحظة: بشكل افتراضي، يستخدم المحور العكسي Z الإحداثيات النسبية المقابلة لمسافة الجدول',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip4': {
    zh: '刀具不能少于1个',
    en: 'The number of knives cannot be less than 1',
    id: 'Jumlah pisau tidak boleh kurang dari 1',
    kz: 'Пышақ саны 1-ден кем болмауы керек',
    th: 'จำนวนมีดต้องไม่น้อยกว่า 1',
    ug: 'پىچاق سانى 1 دىن ئاز بولمايدۇ',
    vi: 'Số lượng dao không được ít hơn 1',
    zh_tc: '刀具不能少於1個',
    ru: 'Нож не может быть меньше одного.',
    ko: '공구는 1 개 미만이어야 합니다.',
    bur: 'ဓားအရေအတွက် ၁ ထက်နည်းမရပါ',
    ben: 'ছুরির সংখ্যা ১ এর কম হতে পারবে না',
    tr: 'Bıçak sayısı 1den az olamaz',
    km: 'ចំនួនដាវមិនអាចតិជាង ១',
    es: 'No puede ser menos de 1 herramienta',
    ar: 'لا يمكن أن يكون هناك أقل من أداة واحدة',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip5': {
    zh: '不能删除开料刀',
    en: 'Cannot delete the cutting open knife',
    id: 'Tidak dapat menghapus pisau pemotongan buka',
    kz: 'Кесу ашу пышағын жоюға болмайды',
    th: 'ไม่สามารถลบมีดตัดเปิดได้',
    ug: 'كېسىش ئېچىش پىچاقنى ئۆچۈرەلمەيدۇ',
    vi: 'Không thể xóa dao cắt mở',
    zh_tc: '不能刪除開料刀',
    ru: 'Нельзя удалить нож.',
    ko: '가공 공구는 삭제할 수 없습니다.',
    bur: 'အတုံးချဓားကိုဖျက်မရပါ',
    ben: 'কাটিং ওপেন ছুরি মুছে ফেলা যাবে না',
    tr: 'Kesim açma bıçağı silinemez',
    km: 'មិនអាចលុបដាវកាត់បើក',
    es: 'Las cuchillas de corte no se pueden eliminar',
    ar: 'لا يمكن حذف سكاكين القطع',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip6': {
    zh: '检测到没有刀具勾选开料，请至少勾选一把刀具',
    en: 'No knife selected for cutting open detected, please select at least one knife',
    id: 'Terdeteksi tidak ada pisau yang dipilih untuk pemotongan buka, harap pilih setidaknya satu pisau',
    kz: 'Кесу ашуды таңдаған пышақ жоқ екендігі анықталды, кем дегенде бір пышақты таңдаңыз',
    th: 'ตรวจพบว่าไม่มีมีดที่เลือกตัดเปิด กรุณาเลือกมีดอย่างน้อย 1 เล่ม',
    ug: 'كېسىش ئېچىشنى تاللىغان پىچاق يوق دەپ بايقالدى، كەم دېگەندە بىر پىچاقنى تاللاڭ',
    vi: 'Phát hiện không có dao nào được chọn cắt mở, vui lòng chọn ít nhất một dao',
    zh_tc: '檢測到沒有刀具勾選開料，請至少勾選一把刀具',
    ru: 'Обнаружено отсутствие крючка, выберите хотя бы один.',
    ko: '공구가 없음 체크 오프닝이 감지되었으므로 하나 이상의 공구를 선택합니다.',
    bur: 'အတုံးချခြင်းအတွက်ဓားရွေးချယ်မထားသည်တွေ့ရှိပါသည်၊ အနည်းဆုံးဓားတစ်ချောင်းရွေးပါ',
    ben: 'কাটিং ওপেনের জন্য কোনো ছুরি নির্বাচিত নেই সনাক্ত করা হয়েছে, অনুগ্রহ করে অন্তত একটি ছুরি নির্বাচন করুন',
    tr: 'Kesim açma için seçili bıçak yok; en az bir bıçak seçin',
    km: 'មិនមានដាវជ្រើសសម្រាប់កាត់បើក សូមជ្រើសយ៉ាងហោចណាស់មួយ',
    es: 'Se detecta que no se ha verificado ninguna herramienta para cortar, verifique al menos una herramienta',
    ar: 'تم الكشف عن عدم فحص أي أداة للقطع، يرجى التحقق من أداة واحدة على الأقل',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip7': {
    zh: '激光刀不可加工内部未切透的异形，已自动取消"开料"项勾选',
    en: 'Laser knife cannot process internal shapes that have not been cut through, the "Cutting open" option has been automatically unchecked',
    id: 'Pisau laser tidak dapat memproses bentuk internal yang belum terpotong menembus, opsi "Pemotongan buka" telah dibatalkan secara otomatis',
    kz: 'Лазер пышағы ішкі тесілмеген пішіндерді өңдей алмайды, "Кесу ашу" таңдауы автоматты түрде жойылды',
    th: 'มีดเลเซอร์ไม่สามารถแปรรูปรูปร่างภายในที่ยังไม่ตัดทะลุได้ ระบบได้ยกเลิกการเลือก "ตัดเปิด" อัตโนมัติ',
    ug: 'لازېر پىچاق ئىچكى ئۆتمىگەن شەكىلنى ئىشلەپچىقىرالمايدۇ، "كېسىش ئېچىش" تاللاش بەلگىسى ئاپتوماتىك ئەمەلدىن قالدۇرۇلدى',
    vi: 'Dao laser không thể gia công hình dạng bên trong chưa cắt xuyên, đã tự động bỏ chọn mục "Cắt mở"',
    zh_tc: '激光刀不可加工內部未切透的異形，已自動取消"開料"項勾選',
    ru: 'Лазерный нож не может обрабатывать внутреннюю непроницаемую форму, автоматически отменяет галочку « раскройки»',
    ko: '레이저 공구는 내부에 비침이 없는 이형을 가공할 수 없으며, 이미 자동으로 "재료 공급" 항목의 선택을 취소했다',
    bur: 'လေဆာဓားသည် အတွင်းမဖြတ်ပြီးပုံမမှန်များကိုမကတ်တင်းနိုင်၊ "အတုံးချခြင်း" ရွေးချယ်မှုကိုအလိုအလျောက်ဖြုတ်ပြီး',
    ben: 'লেজার ছুরি ভেতরের যে শেপগুলো কাটা হয়নি সেগুলো প্রসেস করতে পারে না, "কাটিং ওপেন" অপশন স্বয়ংক্রিয়ভাবে আনচেক করা হয়েছে',
    tr: 'Lazer bıçağı içte tam kesilmemiş özel şekilleri işleyemez; Kesim açma seçimi otomatik kaldırıldı',
    km: 'ដាវឡាស៊ែរមិនអាចដំណើរការរាងពិសេសខាងក្នុងដែលមិនទាន់កាត់ឆ្លង ការជ្រើស «កាត់បើក» ត្រូវបានដកដោយស្វ័យប្រវត្តិ',
    es: 'La cuchilla láser no puede procesar formas especiales que no se hayan cortado en el interior, y el elemento "corte" se ha desmarcado automáticamente',
    ar: 'لا يمكن لسكين الليزر معالجة الأشكال الخاصة التي لم يتم قطعها من الداخل، وتم إلغاء تحديد عنصر "القطع" تلقائيًا',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip8': {
    zh: '刀库中请勾选“开料”选项的刀具，不然无法加工内部未切透异形',
    en: 'Please select knives with the "Cutting open" option in the knife store, otherwise internal shapes that have not been cut through cannot be processed',
    id: 'Harap pilih pisau dengan opsi "Pemotongan buka" di gudang pisau, jika tidak tidak dapat memproses bentuk internal yang belum terpotong menembus',
    kz: 'Пышақ қоймасында "Кесу ашу" опциясы бар пышақты таңдаңыз, әйтпесе ішкі тесілмеген пішіндерді өңдей алмайсыз',
    th: 'กรุณาเลือกมีดที่มีตัวเลือก "ตัดเปิด" ในคลังมีด มิฉะนั้นจะไม่สามารถแปรรูปรูปร่างภายในที่ยังไม่ตัดทะลุได้',
    ug: 'پىچاق ئامبىرىدا "كېسىش ئېچىش" تاللانمىسى بار پىچاقنى تاللاڭ، بولمىسا ئىچكى ئۆتمىگەن شەكىلنى ئىشلەپچىقىرالمايدۇ',
    vi: 'Vui lòng chọn dao có tùy chọn "Cắt mở" trong kho dao, nếu không sẽ không thể gia công hình dạng bên trong chưa cắt xuyên',
    zh_tc: '刀庫中請勾選"開料"選項的刀具，不然無法加工內部未切透異形',
    ru: 'В ножевой библиотеке выберите инструмент с опцией « открывать», иначе невозможно обработать внутреннюю непрорезанную фасон',
    ko: '라이브러리에서 재료 공급 옵션의 공구를 선택하십시오. 그렇지 않으면 내부의 비투과 이형을 가공할 수 없습니다.',
    bur: 'ဓားသိုလှောင်ရုံတွင် "အတုံးချခြင်း" ရွေးချယ်မှုရှိဓားများရွေးပါ၊ မဟုတ်ပါကအတွင်းမဖြတ်ပြီးပုံမမှန်များကိုမကတ်တင်းနိုင်',
    ben: 'ছুরি স্টোরে "কাটিং ওপেন" অপশন সহ ছুরি নির্বাচন করুন, অন্যথায় ভেতরের যে শেপগুলো কাটা হয়নি সেগুলো প্রসেস করা যাবে না',
    tr: 'Bıçak kütüphanesinde Kesim açma seçeneği işaretli bıçakları seçin; aksi halde içte tam kesilmemiş şekiller işlenemez',
    km: 'នៅឃ្លាំងដាវ សូមជ្រើសដាវដែលមានជម្រើស «កាត់បើក» បើមិនដូចនោះមិនអាចដំណើរការរាងខាងក្នុងដែលមិនទាន់កាត់ឆ្លង',
    es: 'Verifique la herramienta con la opción "corte" en la biblioteca de herramientas; de lo contrario, no podrá procesar formas especiales que no se hayan cortado en el interior',
    ar: 'يرجى التحقق من الأداة باستخدام خيار "القطع" في مكتبة الأدوات، وإلا فلن تتمكن من معالجة الأشكال الخاصة التي لم يتم قطعها من الداخل',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip9': {
    zh: '开料刀库激光刀径和激光一体机激光刀径不一致，请检查',
    en: 'The laser knife diameter in the cutting open knife store is inconsistent with the laser knife diameter of the integrated laser machine, please check',
    id: 'Diameter pisau laser di gudang pisau pemotongan buka tidak konsisten dengan diameter pisau laser mesin laser terintegrasi, harap periksa',
    kz: 'Кесу ашу пышақ қоймасындағы лазер пышағы диаметрі мен лазер біріктірілген машинаның лазер пышағы диаметрі сәйкес келмейді, тексеріңіз',
    th: 'เส้นผ่านศูนย์กลางมีดเลเซอร์ในคลังมีดตัดเปิดไม่ตรงกับเส้นผ่านศูนย์กลางมีดเลเซอร์ของเครื่องเลเซอร์แบบรวม กรุณาตรวจสอบ',
    ug: 'كېسىش ئېچىش پىچاق ئامبىرىدىكى لازېر پىچاق قۇتىسى بىلەن لازېر بىرلىكتە ماشىنىسىدىكى لازېر پىچاق قۇتىسى بىردەك ئەمەس، تەكشۈرۈڭ',
    vi: 'Đường kính dao laser trong kho dao cắt mở không khớp với đường kính dao laser của máy laser tích hợp, vui lòng kiểm tra',
    zh_tc: '開料刀庫激光刀徑和激光一體機激光刀徑不一致，請檢查',
    ru: 'диаметр лазерного ножа и диаметр лазерного ножа лазерного блока не совпадают, проверьте',
    ko: '원료 공급 칼 라이브러리 레이저 칼날과 레이저 올인원 레이저 칼날이 일치하지 않습니다. 검사하십시오.',
    bur: 'အတုံးချဓားသိုလှောင်ရုံလေဆာဓားအချင်းနှင့် လေဆာတစ်ကိုယ်တည်းစက်လေဆာဓားအချင်းမကိုက်ညီ၊ စစ်ဆေးပါ',
    ben: 'কাটিং ওপেন ছুরি স্টোরের লেজার ছুরির ব্যাস ইন্টিগ্রেটেড লেজার মেশিনের লেজার ছুরির ব্যাসের সাথে সামঞ্জস্যপূর্ণ নয়, অনুগ্রহ করে পরীক্ষা করুন',
    tr: 'Kesim açma kütüphanesindeki lazer bıçak çapı ile lazer hepsi bir aradaki uyuşmuyor; kontrol edin',
    km: 'អង្កត់ផ្ចិតដាវឡាស៊ែរនៅឃ្លាំងកាត់បើក និងម៉ាស៊ីនឡាស៊ែររួមមួយមិនដូចគ្នា សូមពិនិត្យ',
    es: 'El diámetro de la herramienta láser del cargador de herramientas de corte y la máquina láser todo en uno no son consistentes, verifique',
    ar: 'قطر أداة الليزر لمخزن أداة القطع وآلة الليزر المتكاملة غير متناسقين، يرجى التحقق',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip10': {
    zh: '开料刀库下料刀径和激光一体机下料刀径不一致，请检查',
    en: 'The cutting open knife diameter in the cutting open knife store is inconsistent with the cutting open knife diameter of the integrated laser machine, please check',
    id: 'Diameter pisau pemotongan buka di gudang pisau pemotongan buka tidak konsisten dengan diameter pisau pemotongan buka mesin laser terintegrasi, harap periksa',
    kz: 'Кесу ашу пышақ қоймасындағы пышақ диаметрі мен лазер біріктірілген машинаның пышақ диаметрі сәйкес келмейді, тексеріңіз',
    th: 'เส้นผ่านศูนย์กลางมีดตัดเปิดในคลังมีดตัดเปิดไม่ตรงกับเส้นผ่านศูนย์กลางมีดตัดเปิดของเครื่องเลเซอร์แบบรวม กรุณาตรวจสอบ',
    ug: 'كېسىش ئېچىش پىچاق ئامبىرىدىكى كېسىش ئېچىش پىچاق قۇتىسى بىلەن لازېر بىرلىكتە ماشىنىسىدىكى كېسىش ئېچىش پىچاق قۇتىسى بىردەك ئەمەس، تەكشۈرۈڭ',
    vi: 'Đường kính dao cắt mở trong kho dao cắt mở không khớp với đường kính dao cắt mở của máy laser tích hợp, vui lòng kiểm tra',
    zh_tc: '開料刀庫下料刀徑和激光一體機下料刀徑不一致，請檢查',
    ru: 'диаметр разгрузочного ножа и диаметр разрезного ножа лазерной машины не совпадают, проверьте',
    ko: '원료 공급 칼 창고의 원료 칼 지름과 레이저 일체형 기계의 원료 칼 지름이 일치하지 않으니, 검사해 주십시오',
    bur: 'အတုံးချဓားသိုလှောင်ရုံအတုံးချဓားအချင်းနှင့် လေဆာတစ်ကိုယ်တည်းစက်အတုံးချဓားအချင်းမကိုက်ညီ၊ စစ်ဆေးပါ',
    ben: 'কাটিং ওপেন ছুরি স্টোরের কাটিং ওপেন ছুরির ব্যাস ইন্টিগ্রেটেড লেজার মেশিনের কাটিং ওপেন ছুরির ব্যাসের সাথে সামঞ্জস্যপূর্ণ নয়, অনুগ্রহ করে পরীক্ষা করুন',
    tr: 'Kesim açma kütüphanesindeki boşaltma bıçak çapı ile lazer hepsi bir aradaki uyuşmuyor; kontrol edin',
    km: 'អង្កត់ផ្ចិតដាវដកនៅឃ្លាំងកាត់បើក និងម៉ាស៊ីនឡាស៊ែររួមមួយមិនដូចគ្នា សូមពិនិត្យ',
    es: 'El diámetro de la herramienta de corte del almacén de herramientas de corte no coincide con el diámetro de la herramienta de corte de la máquina láser todo en uno, verifique',
    ar: 'قطر أداة القطع في مجلة أداة القطع غير متوافق مع قطر أداة القطع بالليزر الكل في واحد، يرجى التحقق من',
  },
  'cuttingDock.laserCuttingMachine.laserKnifeTip11': {
    zh: '设备对接参数已修改，请重新排版',
    en: 'Equipment docking parameters have been modified, please re-layout',
    id: 'Parameter docking peralatan telah dimodifikasi, harap tata ulang',
    kz: 'Жабдықты қосу параметрлері өзгертілді, қайта орналастырыңыз',
    th: 'พารามิเตอร์การเชื่อมต่ออุปกรณ์ได้รับการแก้ไข กรุณาจัดเรียงใหม่',
    ug: 'قورال باغلاش پارامېتىرلىرى ئۆزگەرتىلدى، قايتا تەرتىپلەڭ',
    vi: 'Tham số kết nối thiết bị đã được sửa đổi, vui lòng sắp xếp lại',
    zh_tc: '設備對接參數已修改，請重新排版',
    ru: 'Параметры стыковки оборудования изменены, пожалуйста, переформатируйте',
    ko: '장치 버트 매개 변수가 수정되었습니다. 다시 조판하십시오.',
    bur: 'ပစ္စည်းချိတ်ဆက်ပါရာမီတာပြင်ဆင်ပြီး၊ ပြန်အစီအစဉ်လုပ်ပါ',
    ben: 'সরঞ্জাম ডকিং প্যারামিটার পরিবর্তন করা হয়েছে, অনুগ্রহ করে পুনরায় লেআউট করুন',
    tr: 'Cihaz bağlantı parametreleri değişti; lütfen yeniden yerleştirin',
    km: 'ប៉ារ៉ាម៉ែត្រភ្ជាប់ឧបករណ៍ត្រូវបានកែ សូមចងក្រងឡើងវិញ',
    es: 'Los parámetros de acoplamiento del equipo han sido modificados, reorganícelos',
    ar: 'تم تعديل معلمات إرساء المعدات، يرجى إعادة ترتيبها',
  },
  'cuttingDock.laserCuttingMachine.noLaserPermission': {
    zh: '没有激光一体机使用权限，请联系销售购买激光一体机使用权限后使用',
    en: 'You do not have permission to use the integrated laser machine. Please contact sales to purchase the integrated laser machine usage permission before using',
    id: 'Tidak memiliki izin penggunaan mesin laser terintegrasi, silakan hubungi penjualan untuk membeli izin penggunaan mesin laser terintegrasi sebelum menggunakan',
    kz: 'Лазер біріктірілген машинаны пайдалану рұқсаты жоқ, пайдаланбас бұрын сату бөлімімен байланысып лазер біріктірілген машинаны пайдалану рұқсатын сатып алыңыз',
    th: 'ไม่มีสิทธิ์ใช้งานเครื่องเลเซอร์แบบรวม กรุณาติดต่อฝ่ายขายเพื่อซื้อสิทธิ์ใช้งานเครื่องเลเซอร์แบบรวมก่อนใช้งาน',
    ug: 'لازېر بىرلىكتە ماشىنىسىنى ئىشلىتىش ھوقۇقى يوق، ئىشلىتىشتىن بۇرۇن ساتۇش بۆلۈمى بىلەن ئالاقىلىشىپ لازېر بىرلىكتە ماشىنىسىنى ئىشلىتىش ھوقۇقىنى سېتىۋېلىڭ',
    vi: 'Không có quyền sử dụng máy laser tích hợp, vui lòng liên hệ bộ phận bán hàng để mua quyền sử dụng máy laser tích hợp trước khi sử dụng',
    zh_tc: '沒有激光一體機使用權限，請聯繫銷售購買激光一體機使用權限後使用',
    ru: 'Без разрешения на использование лазерной машины, пожалуйста, свяжитесь с продавцом, чтобы купить разрешение на использование лазерной машины после использования',
    ko: '레이저 올인원 사용 권한이 없습니다. 레이저 올인원 사용 권한을 구입한 후 사용하려면 판매에 문의하십시오.',
    bur: 'လေဆာတစ်ကိုယ်တည်းစက်သုံးခွင့်မရှိပါ၊ သုံးမည့်အချိန်မတိုင်မီ ရောင်းချရေးနှင့်ဆက်သွယ်ပြီးအသုံးပြုခွင့်ဝယ်ပါ',
    ben: 'ইন্টিগ্রেটেড লেজার মেশিন ব্যবহারের অনুমতি নেই, ব্যবহারের আগে সেলসের সাথে যোগাযোগ করে লেজার মেশিন ব্যবহারের অনুমতি কিনুন',
    tr: 'Lazer hepsi bir arada kullanım izniniz yok; kullanmak için satın alın',
    km: 'គ្មានសិទ្ធិប្រើម៉ាស៊ីនឡាស៊ែររួមមួយ សូមទាក់ទងលក់ដើម្បីទិញសិទ្ធិ',
    es: 'No tiene permiso para usar la máquina láser todo en uno, comuníquese con ventas para comprar el permiso de la máquina láser todo en uno antes de usarla',
    ar: 'ليس لديك إذن باستخدام آلة الليزر الكل في واحد، يرجى الاتصال بالمبيعات لشراء إذن آلة الليزر الكل في واحد قبل الاستخدام',
  },
  'cuttingDock.laserCuttingMachine.laserOpenCode': {
    zh: '激光开启代码',
    en: 'Laser Open Code',
    id: 'Kode Pembukaan Laser',
    kz: 'Лазерлік ашылу коды',
    th: 'รหัสเปิดเลเซอร์',
    ug: 'لازېر پىچاق ئېچىش كىدى',
    vi: 'Mã Mở Laser',
    zh_tc: '激光開啟代碼',
    ru: 'Код открытия лазера',
    ko: '레이저 오픈 코드',
    bur: 'လေဆာအပြင်အဆင်ခံကုဒ်',
    ben: 'লেজার খোলন কোড',
    tr: 'Lazer açma kodu',
    km: 'កូដបើកឡាស៊ែរ',
    es: 'Código de encendido del láser',
    ar: 'رمز تشغيل الليزر',
  },
  'cuttingDock.laserCuttingMachine.laserCloseCode': {
    zh: '激光关闭代码',
    en: 'Laser Close Code',
    id: 'Kode Penutupan Laser',
    kz: 'Лазерлік жабу коды',
    th: 'รหัสปิดเลเซอร์',
    ug: 'لازېر پىچاق باشىش كىدى',
    vi: 'Mã Đóng Laser',
    zh_tc: '激光關閉代碼',
    ru: 'Код закрытия лазера',
    ko: '레이저 클로즈 코드',
    bur: 'လေဆာအပြင်အဆင်ခံကုဒ်',
    ben: 'লেজার বন্ধ কোড',
    tr: 'Lazer kapatma kodu',
    km: 'កូដបិទឡាស៊ែរ',
    es: 'Código de apagado del láser',
    ar: 'رمز إيقاف تشغيل الليزر',
  },
  'cuttingDock.laserCuttingMachine.laserToolSettings': {
    zh: '正/反面激光刀设置',
    en: 'Laser Tool Settings',
    id: 'Pengaturan Alat Laser',
    kz: 'Лазерлік пышақтардың параметрлері',
    th: 'ตั้งค่ามีดเลเซอร์',
    ug: 'لازېر پىچاق پىچاقلىر پارامېتىرلىرى',
    vi: 'Cài đặt Dao Laser',
    zh_tc: '正/反面激光刀設置',
    ru: 'Параметры лазерных ножей',
    ko: '레이저 도구 설정',
    bur: 'လေဆာအပြင်အဆင်ခံကုဒ်',
    ben: 'লেজার টুল সেটিংস',
    tr: 'Ön/arka lazer bıçağı ayarları',
    km: 'ការកំណត់ដាវឡាស៊ែរខាងមុខ/ក្រោម',
    es: 'Configuración de la cuchilla láser frontal/inversa',
    ar: 'إعدادات سكين الليزر الأمامي/الخلفي',
  },
  'cuttingDock.firstSave': {
    zh: '检测到用户是第一次使用云排版，保存设置后请注意文件中的修边方向是否合理，避免不必要的损失',
    en: 'It is detected that the user is using cloud typesetting for the first time. After saving the settings, please pay attention to whether the trimming direction in the file is reasonable to avoid unnecessary losses',
    id: 'Terdeteksi bahwa ini adalah pertama kalinya pengguna menggunakan tata letak cloud. Setelah menyimpan pengaturan, harap perhatikan apakah arah pemangkasan dalam file tersebut masuk akal untuk menghindari kerugian yang tidak perlu.',
    kz: 'Қолданушыған бұлшырымды тағйырламаңыз: Бұл қолданушыған ilkіші реттін buluт тағйырламамен жұмыс істеуде. Параметрлерді сақталғаннан кейін файлдардағы кескіш бағытының орынды екендігіне назар аударыңыз, заңылмайтын шығындардан сақтану үшін',
    th: 'ตรวจพบว่านี่เป็นครั้งแรกที่ผู้ใช้ใช้เลย์เอาต์คลาวด์ หลังจากบันทึกการตั้งค่าโปรดให้ความสนใจว่าทิศทางการตัดแต่งในไฟล์นั้นสมเหตุสมผลเพื่อหลีกเลี่ยงการสูญเสียที่ไม่จำเป็นหรือไม่',
    ug: 'ئىشلەتكۈچىنىڭ تۇنجى قېتىم بۇلۇت تەرتىپلەشنى ئىشلىتىۋاتقانلىقى بايقالدى، تەڭشەكنى ساقلىغاندىن كېيىن ھۆججەتتىكى تۈزىتىش يۆنىلىشىنىڭ توغرا-خاتالىقىغا دىققەت قىلىڭ، بىھۇدە زىياننىڭ ئالدىنى ئېلىڭ',
    vi: 'Detected that this is the first time the user uses cloud layout. After saving the settings, please check if the trimming direction in the file is reasonable to avoid unnecessary losses.',
    zh_tc:
      '檢測到用戶是第一次使用雲排版，保存設置後請注意文件中的修邊方向是否合理，避免不必要的損失',
    ru: 'Убедитесь, что пользователь впервые использует облачную типографию, после сохранения настроек обратите внимание, является ли направление ремонта в файле разумным, чтобы избежать ненужных потерь',
    ko: '사용자가 클라우드 레이아웃을 처음 사용하는 것을 감지했습니다. 설정을 저장한 후 파일의 테두리 수정 방향이 합리적인지 주의하여 불필요한 손실을 피하십시오.',
    bur: 'အသုံးပြုသူပထမဆုံးကမ္ဘာလုံးဆိုင်ရာအစီအစဉ်သုံးနေသည်တွေ့ရှိပါသည်၊ ဆက်တင်သိမ်းပြီးနောက် ဖိုင်ရှိအစွန်းညှိဦးတည်ချက်သင့်မသင့်သတိပြုပြီးမလိုအပ်သည့်ဆုံးရှုံးမှုရှောင်ပါ',
    ben: 'ব্যবহারকারী প্রথমবার ক্লাউড টাইপসেটিং ব্যবহার করছেন সনাক্ত করা হয়েছে, সেটিংস সংরক্ষণের পর ফাইলে ট্রিমিং দিক যুক্তিসঙ্গত কিনা খেয়াল করুন যাতে অপ্রয়োজনীয় ক্ষতি এড়ানো যায়',
    tr: 'Bulut yerleşimi ilk kullanımınız tespit edildi; ayarları kaydettikten sonra dosyadaki kenar düzeltme yönünün makul olup olmadığını kontrol edin',
    km: 'រកឃើញថានេះជាលើកដំបូងដែលប្រើចងក្រងក្នុងពពក ក្រោយរក្សាទុកសូមពិនិត្យទិសកែសម្រួលគែមក្នុងឯកសារឱ្យសមស្រប',
    es: 'Se detecta que el usuario está utilizando la composición tipográfica en la nube por primera vez. Después de guardar la configuración, preste atención a si la dirección de recorte en el archivo es razonable para evitar pérdidas innecesarias',
    ar: 'إنه كذلك اكتشف أن المستخدم يستخدم التنضيد السحابي لأول مرة. بعد حفظ الإعدادات، يرجى الانتباه إلى ما إذا كان اتجاه التشذيب في الملف معقولًا لتجنب الخسائر غير الضرورية',
  },
  'cuttingDock.knives.xOffset1': {
    zh: 'X坐标偏移',
    en: 'X Coordinate Offset',
    id: 'X Offset Koordinat',
    kz: 'X Coordinate Offset',
    th: 'x ประสานงาน',
    ug: 'X كوئوردېنات يۆتكىلىشى',
    vi: 'X Coordinate Offset',
    zh_tc: 'X座標偏移',
    ru: 'Смещение координат X',
    ko: 'X 좌표 오프셋',
    bur: 'X ကိုဩဒိနိတ်ရွေ့ခြင်း',
    ben: 'X কোঅর্ডিনেট অফসেট',
    tr: 'X koordinat ofseti',
    km: 'ការផ្លាស់ទីកូអរដោនេ X',
    es: 'X Compensación de coordenadas',
    ar: 'X إزاحة الإحداثيات',
  },
  'cuttingDock.knives.yOffset1': {
    zh: 'Y坐标偏移',
    en: 'Y Coordinate Offset',
    id: 'Y Offset Koordinat',
    kz: 'Y Coordinate Offset',
    th: 'y ประสานงาน',
    ug: 'Y كوئوردېنات يۆتكىلىشى',
    vi: 'Y Coordinate Offset',
    zh_tc: 'Y座標偏移',
    ru: 'Смещение Y - координат',
    ko: 'Y 좌표 오프셋',
    bur: 'Y ကိုဩဒိနိတ်ရွေ့ခြင်း',
    ben: 'Y কোঅর্ডিনেট অফসেট',
    tr: 'Y koordinat ofseti',
    km: 'ការផ្លាស់ទីកូអរដោនេ Y',
    es: 'Y Compensación de coordenadas',
    ar: 'Y إزاحة الإحداثيات',
  },
  'cuttingDock.knives.zOffset1': {
    zh: 'Z坐标偏移',
    en: 'Z Coordinate Offset',
    id: 'Z Offset Koordinat',
    kz: 'Z Coordinate Offset',
    th: 'Z Offset',
    ug: 'Z كوئوردېنات يۆتكىلىشى',
    vi: 'Z Coordinate Offset',
    zh_tc: 'Z座標偏移',
    ru: 'Смещение координат Z',
    ko: 'Z 좌표 오프셋',
    bur: 'Z ကိုဩဒိနိတ်ရွေ့ခြင်း',
    ben: 'Z কোঅর্ডিনেট অফসেট',
    tr: 'Z koordinat ofseti',
    km: 'ការផ្លាស់ទីកូអរដោនេ Z',
    es: 'Z Compensación de coordenadas',
    ar: 'Z إزاحة الإحداثيات',
  },
  'cuttingDock.knives.insert': {
    zh: '插入行',
    en: 'Insert a row',
    id: 'Masukkan baris',
    kz: 'Қатарды енгізу',
    th: 'แทรกแถว',
    ug: 'قۇر قوشۇش',
    vi: 'Chèn Hàng',
    zh_tc: '插入行',
    ru: 'Вставить строку',
    ko: '행 삽입',
    bur: 'အတန်းထည့်ပါ',
    ben: 'একটি সারি সন্নিবেশ করুন',
    tr: 'Satır ekle',
    km: 'បន្ថែមជួរ',
    es: 'Insertar fila',
    ar: 'إدراج صف',
  },
  'cuttingDock.knives.delete': {
    zh: '删除行',
    en: 'Delete the row',
    id: 'Hapus baris',
    kz: 'Қатарды өшіру',
    th: 'ลบแถว',
    ug: 'قۇر ئۆچۈرۈش',
    vi: 'Xóa Hàng',
    zh_tc: '刪除行',
    ru: 'Удалить строку',
    ko: '행 삭제',
    bur: 'အတန်းဖျက်ပါ',
    ben: 'সারিটি মুছুন',
    tr: 'Satırı sil',
    km: 'លុបជួរ',
    es: 'Eliminar fila',
    ar: 'حذف صف',
  },
  'cuttingDock.knives.tip': {
    zh: '（注：完成刀库信息的修改或设置的调整后，在柜柜排版生产的用户需要重启柜柜客户端，以应用最新的变更！）',
    en: '（Note: After modifying the tool library information or adjusting settings, users producing cabinet layouts need to restart the cabinet client to apply the latest changes!）',
    id: '(Catatan: Setelah menyelesaikan modifikasi atau penyesuaian informasi majalah alat, pengguna yang berada dalam produksi tata letak kabinet perlu memulai kembali klien kabinet untuk menerapkan perubahan terbaru!)',
    kz: '（Ескерту: Қырлық тақырыбының мағлуматын немесе настройкаларды өзгерткен кейін, кабинеттердің жобаларын жасайтын пайдаланушылар кабинет клиентін қайта бастыруы керек, сондықтан жаңғы өзгерістер қолданылады!）',
    th: '(หมายเหตุ: หลังจากเสร็จสิ้นการปรับเปลี่ยนหรือปรับข้อมูลนิตยสารเครื่องมือผู้ใช้ที่อยู่ในการผลิตเค้าโครงของคณะรัฐมนตรีจำเป็นต้องรีสตาร์ทไคลเอนต์ตู้เพื่อใช้การเปลี่ยนแปลงล่าสุด!)',
    ug: '(دىققەت: پىچاق ئامبىرى ئۇچۇرىنى ئۆزگەرتىش ياكى تەڭشەكنى تەڭشىگەندىن كېيىن، ئىشكاپ تەرتىپلەش ئىشلەپچىقىرىشتىكى ئىشلەتكۈچىلەر ئىشكاپ كىلىيېنتىنى قايتا قوزغىتىشى كېرەك، ئەڭ يېڭى ئۆزگەرتىشنى قوللىنىش ئۈچۈن!)',
    vi: '（Lưu ý: Sau khi chỉnh sửa thông tin thư viện dao hoặc điều chỉnh cài đặt, người dùng sản xuất bố cục tủ cần khởi động lại ứng dụng tủ để áp dụng các thay đổi mới nhất!）',
    zh_tc:
      '（註：完成刀庫信息的修改或設置的調整後，在櫃櫃排版生產的用戶需要重啓櫃櫃客戶端，以應用最新的變更！）',
    ru: '(Примечание: После внесения изменений в информацию о библиотеке ножей или настройки настроек пользователям, производящим типографию в шкафу, необходимо перезагрузить клиент шкафа, чтобы применить последние изменения!)',
    ko: '(참고: 라이브러리 정보 수정 또는 설정 조정이 완료되면 캐비닛 레이아웃에서 생산되는 사용자는 캐비닛 클라이언트를 재부팅하여 최신 변경 사항을 적용해야 합니다!)',
    bur: '（မှတ်ချက်：ဓားသိုလှောင်ရုံအချက်အလက်ပြင်ဆင်ပြီး ဆက်တင်ညှိပြီးနောက် ကန်တင်းအစီအစဉ်ထုတ်လုပ်သူများသည် နောက်ဆုံးပြောင်းလဲမှုအသုံးပြုရန် ကန်တင်းကလိုင်းယင့်ပြန်စပါ）',
    ben: '（নোট: টুল লাইব্রেরি তথ্য পরিবর্তন বা সেটিংস সামঞ্জস্য করার পর ক্যাবিনেট লেআউট প্রোডিউসিং ব্যবহারকারীদের সর্বশেষ পরিবর্তন প্রয়োগ করতে ক্যাবিনেট ক্লায়েন্ট রিস্টার্ট করতে হবে）',
    tr: '(Not: Bıçak kütüphanesi bilgisini veya ayarları değiştirdikten sonra dolap yerleşimi üreten kullanıcıların değişiklikleri uygulamak için dolap istemcisini yeniden başlatması gerekir.)',
    km: '(សម្គាល់៖ បន្ទាប់ពីកែព័ត៌មានឃ្លាំងដាវ ឬការកំណត់ អ្នកប្រើដែលផលិតចងក្រងទូត្រូវចាប់ផ្តើមកម្មវិធីទូឡើងវិញដើម្បីអនុវត្តការផ្លាស់ប្តូរ)',
    es: '(Nota: después de completar la modificación de la información del almacén de herramientas o el ajuste de la configuración, los usuarios en la producción del diseño del gabinete deben reiniciar el cliente del gabinete para aplicar la última cambios!)',
    ar: '(ملاحظة: بعد إكمال تعديل معلومات مجلة الأداة أو تعديل الإعدادات، يحتاج المستخدمون في إنتاج تخطيط الخزانة إلى إعادة تشغيل عميل الخزانة لتطبيق الأحدث التغييرات!)',
  },
  'cuttingDock.knives.number': {
    zh: '编号',
    en: 'number',
    id: 'nomor seri',
    kz: 'Нөмір',
    th: 'หมายเลขซีเรียล',
    ug: 'نومۇر',
    vi: 'Biên Hiệu',
    zh_tc: '編號',
    ru: 'номер',
    ko: '번호',
    bur: 'နံပါတ်',
    ben: 'নম্বর',
    tr: 'numara',
    km: 'លេខ',
    es: 'Número',
    ar: 'الرقم',
  },
  'cuttingDock.knives.name': {
    zh: '名称',
    en: 'Name',
    id: 'nama',
    kz: 'Атау',
    th: 'ชื่อ',
    ug: 'ئىسىم',
    vi: 'Tên',
    zh_tc: '名稱',
    ru: 'название',
    ko: '이름',
    bur: 'အမည်',
    ben: 'নাম',
    tr: 'Ad',
    km: 'ឈ្មោះ',
    es: 'Nombre',
    ar: 'اسم',
  },
  'cuttingDock.knives.diameter': {
    zh: '刀直径Φ',
    en: 'Blade DiameterΦ',
    id: 'Diameter pisau φ',
    kz: 'Зым диаметріΦ',
    th: 'เส้นผ่านศูนย์กลางมีดφ',
    ug: 'پىچاق دىئامېتىرىΦ',
    vi: 'Đường Kính DaoΦ',
    zh_tc: '刀直徑Φ',
    ru: 'Диаметр ножа',
    ko: '칼 지름 Φ',
    bur: 'ဓားအချင်းΦ',
    ben: 'ব্লেড ব্যাসΦ',
    tr: 'Bıçak çapı Φ',
    km: 'អង្កត់ផ្ចិតដាវ Φ',
    es: 'Diámetro de herramienta Φ',
    ar: 'قطر الأداة Φ',
  },
  'cuttingDock.knives.sawDiameter': {
    zh: '锯片厚度Φ',
    en: 'Saw Blade ThicknessΦ',
    id: 'Ketebalan Pisau GergajiΦ',
    kz: 'Ара Қылыш ҚалыңдығыΦ',
    th: 'ความหนาของใบเลื่อยΦ',
    ug: 'ئەگەر يۆنىلىشى قېلىنلىقىΦ',
    vi: 'Độ dày lưỡi cưaΦ',
    zh_tc: '鋸片厚度Φ',
    ru: 'Толщина пилы',
    ko: '톱날 두께 Φ',
    bur: 'ဆောက်ဓားအထူΦ',
    ben: 'কাটিং ব্লেড বেধΦ',
    tr: 'Testere kalınlığı Φ',
    km: 'កម្រាស់កាំបិទរណ្តៅ Φ',
    es: 'Espesor de la hoja de sierra Φ',
    ar: 'سمك شفرة المنشار Φ',
  },
  'cuttingDock.knives.cutting': {
    zh: '开料',
    en: 'Cutting Material',
    id: 'Pembukaan',
    kz: 'Кесу',
    th: 'การเปิด',
    ug: 'كېسىش',
    vi: 'Cắt Nguyên Liệu',
    zh_tc: '開料',
    ru: 'Раскрой.',
    ko: '절단',
    bur: 'အတုံးချခြင်း',
    ben: 'কাটিং ম্যাটেরিয়াল',
    tr: 'Malzeme kesimi',
    km: 'ការកាត់សម្ភារៈ',
    es: 'Corte',
    ar: 'القطع',
  },
  'cuttingDock.knives.use': {
    zh: '用途',
    en: 'Purpose',
    id: 'menggunakan',
    kz: 'Пайдалану',
    th: 'ใช้',
    ug: 'ئىشلىتىش',
    vi: 'Mục Đích Sử Dụng',
    zh_tc: '用途',
    ru: 'использование',
    ko: '용도',
    bur: 'အသုံးပြုချက်',
    ben: 'উদ্দেশ্য',
    tr: 'Amaç',
    km: 'គោលបំណង',
    es: 'Propósito',
    ar: 'الغرض',
  },
  'cuttingDock.knives.moveZF': {
    zh: 'Z轴快速移动速度',
    en: 'Z-axis fast movement speed',
    id: 'Z-Axis Fast Moving Speed',
    kz: 'Z осьдің жылдам жылдамдығы',
    th: 'Z-Axis ความเร็วในการเคลื่อนที่เร็ว',
    ug: 'Z ئوقى تېز يۆتكىلىش سۈرئىتى',
    vi: 'Tốc Độ Di chuyển Trục Z',
    zh_tc: 'Z軸快速移動速度',
    ru: 'Скорость быстрого перемещения по оси Z',
    ko: 'Z축 빠른 이동 속도',
    bur: 'Z ဝင်ရိုးအမြန်ရွေ့အမြန်နှုန်း',
    ben: 'Z অক্ষ দ্রুত চলাচলের গতি',
    tr: 'Z ekseni hızlı hareket hızı',
    km: 'ល្បឿនផ្លាស់ទីរហ័សអ័ក្ស Z',
    es: 'Z Velocidad de movimiento rápido del eje',
    ar: 'Z سرعة الحركة السريعة للمحور',
  },
  'cuttingDock.knives.axis_offset': {
    zh: '轴偏移',
    en: 'Axis Offset Setting',
    id: 'Pengaturan Sumbu Offset',
    kz: 'Оси координатасының ауытқуы',
    th: 'ประสานงานการยกพิกัด',
    ug: 'ئۇلاش كوئوردېنات يۆتكىلىشى',
    vi: 'Trục Offset',
    zh_tc: '軸偏移',
    ru: 'Смещение оси',
    ko: '축 오프셋',
    bur: 'ဝင်ရိုးရွေ့ခြင်းဆက်တင်',
    ben: 'অক্ষ অফসেট সেটিং',
    tr: 'Eksen ofseti',
    km: 'ការផ្លាស់ទីអ័ក្ស',
    es: 'Desplazamiento del eje',
    ar: 'إزاحة المحور',
  },
  'cuttingDock.knives.arc_radius': {
    zh: '圆弧半径',
    en: 'Arc Radius Setting',
    id: 'Pengaturan Radius Busur',
    kz: 'Доғаның радиусы',
    th: 'รัศมีวงกลม',
    ug: 'بۇيرۇق ئەسلى',
    vi: 'Bán Kính Cung',
    zh_tc: '圓弧半徑',
    ru: 'радиус дуги',
    ko: '호 반지름',
    bur: 'ချိုးကွေးအချင်းဝက်ဆက်တင်',
    ben: 'আর্ক রেডিয়াস সেটিং',
    tr: 'Yay yarıçapı ayarı',
    km: 'ការកំណត់កាំរង្វង់',
    es: 'Radio del arco',
    ar: 'نصف قطر القوس',
  },
  'cuttingDock.knives.cutZF': {
    zh: 'Z轴加工速度',
    en: 'Z-axis processing speed',
    id: 'Kecepatan pemesinan sumbu Z',
    kz: 'Z осьдің өңдеу жылдамдығы',
    th: 'ความเร็วการตัดเฉือนแกน Z',
    ug: 'Z ئوقى ئىشلەش سۈرئىتى',
    vi: 'Tốc Độ Gia Công Trục Z',
    zh_tc: 'Z軸加工速度',
    ru: 'Скорость обработки по оси Z',
    ko: 'Z축 가공 속도',
    bur: 'Z ဝင်ရိုးကတ်တင်းအမြန်နှုန်း',
    ben: 'Z অক্ষ প্রসেসিং গতি',
    tr: 'Z ekseni işleme hızı',
    km: 'ល្បឿនដំណើរការអ័ក្ស Z',
    es: 'Z Velocidad de movimiento rápido del eje',
    ar: 'Z سرعة الحركة السريعة للمحور',
  },
  'cuttingDock.knives.moveF': {
    zh: 'XY轴快速移动速度',
    en: 'XY axis fast movement speed',
    id: 'Kecepatan Gerakan Cepat Sumbu XY',
    kz: 'XY осьдің жылдам жылдамдығы',
    th: 'ความเร็วในการเคลื่อนที่เร็วของแกน xy',
    ug: 'XY ئوقى تېز يۆتكىلىش سۈرئىتى',
    vi: 'Tốc Độ Di chuyển Trục XY',
    zh_tc: 'XY軸快速移動速度',
    ru: 'Скорость быстрого перемещения оси XY',
    ko: 'XY 축 빠른 이동 속도',
    bur: 'XY ဝင်ရိုးအမြန်ရွေ့အမြန်နှုန်း',
    ben: 'XY অক্ষ দ্রুত চলাচলের গতি',
    tr: 'XY ekseni hızlı hareket hızı',
    km: 'ល្បឿនផ្លាស់ទីរហ័សអ័ក្ស XY',
    es: 'XY Velocidad de movimiento rápido del eje',
    ar: 'XY سرعة الحركة السريعة للمحور',
  },
  'cuttingDock.knives.cutF': {
    zh: 'XY轴加工速度',
    en: 'XY axis processing speed',
    id: 'Kecepatan permesinan sumbu xy',
    kz: 'XY осьдің өңдеу жылдамдығы',
    th: 'ความเร็วการตัดเฉือนแกน xy',
    ug: 'XY ئوقى ئىشلەش سۈرئىتى',
    vi: 'Tốc Độ Gia Công Trục XY',
    zh_tc: 'XY軸加工速度',
    ru: 'Скорость обработки оси XY',
    ko: 'XY 축 가공 속도',
    bur: 'XY ဝင်ရိုးကတ်တင်းအမြန်နှုန်း',
    ben: 'XY অক্ষ প্রসেসিং গতি',
    tr: 'XY ekseni işleme hızı',
    km: 'ល្បឿនដំណើរការអ័ក្ស XY',
    es: 'XY Velocidad de procesamiento del eje',
    ar: 'XY سرعة معالجة المحور',
  },
  'cuttingDock.knives.startCode': {
    zh: '换刀开始代码',
    en: 'Start code for tool change',
    id: 'Kode Mulai Perubahan Alat',
    kz: 'Зым ауыстыру бастау коды',
    th: 'เครื่องมือเริ่มต้นเปลี่ยนรหัส',
    ug: 'پىچاق ئالماشتۇرۇش باشلىنىش كودى',
    vi: 'Mã Bắt Đầu Thay Dao',
    zh_tc: '換刀開始代碼',
    ru: 'Код начала смены ножей.',
    ko: '스왑 시작 코드',
    bur: 'ဓားလဲခြင်းစတင်ကုဒ်',
    ben: 'টুল চেঞ্জের জন্য স্টার্ট কোড',
    tr: 'Takım değiştirme başlangıç kodu',
    km: 'កូដចាប់ផ្តើមដូរឧបករណ៍កាត់',
    es: 'Código de inicio de cambio de herramienta',
    ar: 'رمز بدء تغيير الأداة',
  },
  'cuttingDock.knives.stopCode': {
    zh: '换刀结束代码',
    en: 'Tool change end code',
    id: 'Kode Akhir Perubahan Alat',
    kz: 'Зым ауыстыру аяқталу коды',
    th: 'เครื่องมือเปลี่ยนเครื่องมือ',
    ug: 'پىچاق ئالماشتۇرۇش ئاخىرلىشىش كودى',
    vi: 'Mã Kết Thúc Thay Dao',
    zh_tc: '換刀結束代碼',
    ru: 'Код окончания смены ножа',
    ko: '패스 종료 코드',
    bur: 'ဓားလဲခြင်းပြီးဆုံးကုဒ်',
    ben: 'টুল চেঞ্জ এন্ড কোড',
    tr: 'Takım değiştirme bitiş kodu',
    km: 'កូដបញ្ចប់ដូរឧបករណ៍កាត់',
    es: 'Código de fin de cambio de herramienta',
    ar: 'رمز نهاية تغيير الأداة',
  },
  'cuttingDock.knives.startCode2': {
    zh: '工位2换刀开始代码',
    en: 'Code for starting tool change',
    id: 'Kode Mulai Perubahan Alat Workstation 2',
    kz: '工位2换刀开始代码',
    th: 'Workstation 2 เครื่องมือเปลี่ยนรหัสเริ่มต้น',
    ug: 'خىزمەت ئورنى2 پىچاق ئالماشتۇرۇش باشلىنىش كودى',
    vi: 'Mã Bắt Đầu Thay Dao',
    zh_tc: '工位2換刀開始代碼',
    ru: 'Код начала смены ножа 2.',
    ko: '작업 위치 2 스위치 시작 코드',
    bur: 'အလုပ်ဌာန၂ဓားလဲခြင်းစတင်ကုဒ်',
    ben: 'টুল চেঞ্জ শুরু করার জন্য কোড',
    tr: 'İstasyon 2 takım değiştirme başlangıç kodu',
    km: 'កូដចាប់ផ្តើមដូរឧបករណ៍កាត់ ស្ថានីយ៍ ២',
    es: 'Código de inicio de cambio de herramienta de estación 2',
    ar: 'رمز بدء تغيير أداة المحطة 2',
  },
  'cuttingDock.knives.stopCode2': {
    zh: '工位2换刀结束代码',
    en: 'Tool change end code',
    id: 'Workstation 2 Alat Ubah Kode Akhir',
    kz: '工位2换刀结束代码',
    th: 'Workstation 2 เครื่องมือเปลี่ยนรหัสสิ้นสุด',
    ug: 'خىزمەت ئورنى2 پىچاق ئالماشتۇرۇش ئاخىرلىشىش كودى',
    vi: 'Mã Kết Thúc Thay Dao',
    zh_tc: '工位2換刀結束代碼',
    ru: 'Код окончания смены ножа 2.',
    ko: '작업 위치 2 패스 종료 코드',
    bur: 'အလုပ်ဌာန၂ဓားလဲခြင်းပြီးဆုံးကုဒ်',
    ben: 'টুল চেঞ্জ এন্ড কোড',
    tr: 'İstasyon 2 takım değiştirme bitiş kodu',
    km: 'កូដបញ្ចប់ដូរឧបករណ៍កាត់ ស្ថានីយ៍ ២',
    es: 'Código de fin de cambio de herramienta de estación 2',
    ar: 'رمز نهاية تغيير أداة المحطة 2',
  },
  'cuttingDock.knives.knifeLength': {
    zh: '刀具长度',
    en: 'Knife length',
    id: 'Ketebalan Pisau GergajiΦ',
    kz: 'Зым ұзындығы',
    th: 'ความยาวของมีด',
    ug: 'ھەرە تىغى',
    vi: 'Chiều Dài Dao Cưa',
    zh_tc: '刀具長度',
    ru: 'Длина ножа',
    ko: '공구 길이',
    bur: 'ဓားအလျား',
    ben: 'ছুরির দৈর্ঘ্য',
    tr: 'Bıçak uzunluğu',
    km: 'ប្រវែងដាវ',
    es: 'Longitud de herramienta',
    ar: 'طول الأداة',
  },
  'cuttingDock.knives.maximum_single_depth': {
    zh: '单次最大加工深度',
    en: 'Maximum depth of machining in a single run',
    id: 'Kedalaman maksimum per pisau',
    kz: 'Зым қатауының ең үлкен бір реттік қатауы',
    th: 'ความลึกสูงสุดของการประมวลผลเดียว',
    ug: 'پىچاق ئالماشتۇرۇش قېلىنلىقى',
    vi: 'Chiều Sâu Gia Công Tối Đa',
    zh_tc: '單次最大加工深度',
    ru: 'Максимальная глубина однократной обработки',
    ko: '1회 최대 가공 깊이',
    bur: 'တစ်ကြိမ်ကတ်တင်းအများဆုံးအနက်',
    ben: 'একবারে প্রসেসিংয়ের সর্বোচ্চ গভীরতা',
    tr: 'Tek seferde maksimum işleme derinliği',
    km: 'ជម្រៅដំណើរការអតិបរមាក្នុងមួយលើក',
    es: 'Profundidad de procesamiento máxima única',
    ar: 'الحد الأقصى لعمق المعالجة الفردي',
  },
  'cuttingDock.knives.specialShapeKnifeTip': {
    zh: '仅对内部异形生效',
    en: 'Only for internal irregular shapes',
    id: 'Hanya untuk bentuk internal yang tidak teratur',
    kz: 'Толық ішкі құрылымдар үшін',
    th: 'เฉพาะสำหรับรูปทรงภายในที่ไม่ตรงกัน',
    ug: 'ئىشلەتكىلى بولىدىغان يول بولسا ئىشلىتىش',
    vi: 'Chỉ dành cho hình dạng bên trong không đều',
    zh_tc: '僅對內部異形生效',
    ru: 'Действует только для внутренних инопланетян.',
    ko: '내부 이형에만 적용',
    bur: 'အတွင်းပုံမမှန်များအတွက်သာသက်ရောက်သည်',
    ben: 'কেবল ভেতরের অনিয়মিত শেপের জন্য প্রযোজ্য',
    tr: 'Yalnızca içteki düzensiz şekiller için geçerlidir',
    km: 'មានប្រសិទ្ធភាពតែសម្រាប់រូបរាងមិនទៀងខាងក្នុង',
    es: 'Solamente efectivo para formas especiales internas',
    ar: 'فعال فقط للأشكال الخاصة الداخلية',
  },
  'cuttingDock.knives.preStartCode': {
    zh: '预启动代码',
    en: 'pre-start code',
    id: 'Kode pra-awal',
    kz: 'Алдын ала іске қосу коды',
    th: 'รหัสก่อนเริ่ม',
    ug: 'ئالدىن قوزغىتىش كودى',
    vi: 'Mã Khởi Động Trước',
    zh_tc: '預啓動代碼',
    ru: 'Код предварительного запуска',
    ko: '사전 부팅 코드',
    bur: 'ကြိုတင်စတင်ကုဒ်',
    ben: 'প্রি-স্টার্ট কোড',
    tr: 'Ön başlatma kodu',
    km: 'កូដចាប់ផ្តើមមុន',
    es: 'Código de inicio previo',
    ar: 'رمز البدء المسبق',
  },
  'cuttingDock.knives.punchHoles': {
    zh: '打孔',
    en: 'Punch Holes',
    id: 'Lubang meninju',
    kz: 'Тырнақ ішу',
    th: 'การเจาะรู',
    ug: 'تۆشۈك تېشىش',
    vi: 'Khoan Động',
    zh_tc: '打孔',
    ru: 'пробивать отверстие',
    ko: '펀치',
    bur: 'အပေါက်ဖောက်ခြင်း',
    ben: 'পাঞ্চ হোল',
    tr: 'Delik delme',
    km: 'រន្ធដោត',
    es: 'Taladrado',
    ar: 'الحفر',
  },
  'cuttingDock.knives.pullSlots': {
    zh: '拉槽',
    en: 'Pull Slot',
    id: 'Tarik slotnya',
    kz: 'Слоттарды ішу',
    th: 'ดึงสล็อต',
    ug: 'يوچۇق تارتىش',
    vi: 'Kéo Khay',
    zh_tc: '拉槽',
    ru: 'Вытягивание канавки',
    ko: '슬롯을 당기다',
    bur: 'Pull Slot',
    ben: 'Pull Slot',
    tr: 'Kanal çekme',
    km: 'ទាញរណ្តៅ',
    es: 'Ranurado',
    ar: 'الحز',
  },
  'cuttingDock.knives.millHoles': {
    zh: '铣孔',
    en: 'Milling Holes',
    id: 'Lubang penggilingan',
    kz: 'Тырнақтарды фрезерлеу',
    th: 'โม่',
    ug: 'تۆشۈك ئويۇش',
    vi: 'Máy Xí Khoan Động',
    zh_tc: '銑孔',
    ru: 'Фрезерное отверстие',
    ko: '밀링 구멍',
    bur: 'အပေါက်မေးလ်လင်းခြင်း',
    ben: 'মিলিং হোল',
    tr: 'Freze delikleri',
    km: 'រន្ធហ្វ្រីស',
    es: 'Fresado de orificios',
    ar: 'الطحن بالثقب',
  },
  'cuttingDock.knives.millSlots': {
    zh: '铣槽',
    en: 'Milling slot',
    id: 'Slot penggilingan',
    kz: 'Слоттарды фрезерлеу',
    th: 'ช่องโหว่',
    ug: 'يوچۇق ئويۇش',
    vi: 'Máy Xí Khay',
    zh_tc: '銑槽',
    ru: 'Фрезерный желоб',
    ko: '밀링 슬롯',
    bur: 'ချောင်းဖရီးဇ်ခြင်း',
    ben: 'মিলিং স্লট',
    tr: 'Freze yuvası',
    km: 'រណ្តៅហ្វ្រីស',
    es: 'Fresado de ranuras',
    ar: 'الطحن الشق',
  },
  'cuttingDock.knives.sawBlade': {
    zh: '锯片',
    en: 'saw blade',
    id: 'Saw blade',
    kz: 'Кескіш',
    th: 'ใบมีดเห็น',
    ug: 'ھەرە تىغى',
    vi: 'Dao Cưa',
    zh_tc: '鋸片',
    ru: 'Пильное полотно',
    ko: '톱날',
    bur: 'လွှဓားပြား',
    ben: 'করাতের ব্লেড',
    tr: 'Testere bıçağı',
    km: 'កាំបិទរណ្តៅ',
    es: 'Hoja de sierra',
    ar: 'شفرة المنشار',
  },
  'cuttingDock.knives.doubleSaw': {
    zh: '启用双工位不同换刀开始代码',
    en: 'Enable double-bit different tool change start code',
    id: 'Aktifkan kode start perubahan alat yang berbeda untuk stasiun ganda',
    kz: 'Дуплексті станциялар үшін әртүрлі құралды өзгерту бастау кодтарын қосыңыз',
    th: 'เปิดใช้งานรหัสเริ่มต้นการเปลี่ยนเครื่องมือที่แตกต่างกันสำหรับ Dual-Station',
    ug: 'قوش خىزمەت ئورنى ئوخشىمىغان پىچاق ئالماشتۇرۇش باشلىنىش كودىنى قوزغىتىش',
    vi: 'Bật mã bắt đầu thay dao khác nhau cho hai trạm làm việc',
    zh_tc: '啓用雙工位不同換刀開始代碼',
    ru: 'Включить двухпозиционный код начала смены ножей',
    ko: '이중 비트 다른 패스 시작 코드 사용',
    bur: 'နှစ်စခန်း မတူညီသော ကိရိယာပြောင်း စတင်ကုဒ်ကို ဖွင့်ပါ',
    ben: 'দুই স্টেশনের ভিন্ন টুল চেঞ্জ স্টার্ট কোড সক্রিয় করুন',
    tr: 'Çift istasyon için farklı takım değiştirme başlangıç kodunu etkinleştir',
    km: 'បើកកូដចាប់ផ្តើមដូរឧបករណ៍ខុសគ្នាសម្រាប់ស្ថានីយ៍ពីរ',
    es: 'Habilita diferentes códigos de inicio de cambio de herramienta para estaciones duales',
    ar: 'تمكين رموز بدء تغيير الأداة المختلفة للمحطات المزدوجة',
  },
  'cuttingDock.knives.singleStation': {
    zh: '单工位',
    en: 'Single-station',
    id: 'Ruang kerja tunggal',
    kz: 'Бір станция',
    th: 'พื้นที่ทำงานเดี่ยว',
    ug: 'يەككە خىزمەت ئورنى',
    vi: 'Chỗ làm việc đơn',
    zh_tc: '單工位',
    ru: 'Единый пост',
    ko: '단일 작업 공간',
    bur: 'တစ်ဌာန',
    ben: 'সিঙ্গেল স্টেশন',
    tr: 'Tek istasyon',
    km: 'ស្ថានីយ៍តែមួយ',
    es: 'Estación única',
    ar: 'محطة واحدة',
  },
  'cuttingDock.knives.doubleStation': {
    zh: '双工位',
    en: 'Two-station',
    id: 'Rangkap',
    kz: 'Дуплекс',
    th: 'เพล็กซ์',
    ug: 'قوش خىزمەت ئورنى',
    vi: 'Bàn làm việc đôi',
    zh_tc: '雙工位',
    ru: 'Двойной пост',
    ko: '이중 작업 비트',
    bur: 'နှစ်စခန်း',
    ben: 'দুই স্টেশন',
    tr: 'Çift istasyon',
    km: 'ស្ថានីយ៍ពីរ',
    es: 'Estación doble',
    ar: 'محطة مزدوجة',
  },
  'cuttingDock.knives.sawBladeTip': {
    zh: '该功能不对一拖二雕刻机和一体机生效',
    en: 'This function does not work for 1-to-2 engraving machines and all-in-one machines',
    id: 'Fungsi ini tidak berlaku pada mesin ukiran satu-ke-dua dan mesin all-in-one',
    kz: 'Бұл функсия бірден екі кескіш машинасы мен бірлік машинасына қолданылмайды',
    th: 'ฟังก์ชั่นนี้ไม่มีผลกับเครื่องแกะสลักแบบหนึ่งต่อสองและเครื่องจักรแบบ all-in-one',
    ug: 'بۇ ئىقتىدار بىرنى سۆرەپ ئىككى ئويما ماشىنىسى ۋە بىر گەۋدىلىك ماشىنىغا ئۈنۈم كۆرسەتمەيدۇ',
    vi: 'Chức năng này không có hiệu lực với Máy Khắc Một Kéo Hai và Máy Một Thân',
    zh_tc: '該功能不對一拖二雕刻機和一體機生效',
    ru: 'Эта функция не работает для буксировки двух гравировочных машин и одной машины.',
    ko: '이 기능은 1, 2, 조각기 및 올인원 장치에 적용되지 않습니다.',
    bur: 'ဤလုပ်ဆောင်ချက်သည် ၁-မှ-၂ ထွင်းထုစက်များနှင့် အော်လ်-အင်-ဝန် စက်များတွင် မအလုပ်လုပ်ပါ',
    ben: 'এই ফিচারটি ১-টু-২ এনগ্রেভিং মেশিন এবং অল-ইন-ওয়ান মেশিনে কাজ করে না',
    tr: 'Bu işlev bire iki oyma makineleri ve hepsi bir arada makinelerde geçerli değildir',
    km: 'មុខងារនេះមិនអនុវត្តសម្រាប់ម៉ាស៊ីនចុកចាក់ប៉េរេពីរ និងម៉ាស៊ីនរួមមួយ',
    es: 'Esta función no tiene efecto en máquinas de grabado de uno a dos y máquinas todo en uno',
    ar: 'لا تسري هذه الوظيفة على آلات النقش الفردية والآلات المتكاملة',
  },
  'cuttingDock.knives.serialNum': {
    zh: '编号',
    en: 'serial number',
    id: 'nomor seri',
    kz: 'Серіалік нөмір',
    th: 'หมายเลขซีเรียล',
    ug: 'نومۇر',
    vi: 'Biên Hiệu',
    zh_tc: '編號',
    ru: 'номер',
    ko: '번호',
    bur: 'အမှတ်စဉ်',
    ben: 'ক্রমিক নম্বর',
    tr: 'Seri numarası',
    km: 'លេខសម្គាល់',
    es: 'Número',
    ar: 'الرقم',
  },
  'cuttingDock.knives.sawWidth': {
    zh: '刀宽度',
    en: 'Knife width',
    id: 'Lebar pisau',
    kz: 'Зым қашықтығы',
    th: 'ความกว้างของมีด',
    ug: 'پىچاق كەڭلىكى',
    vi: 'Chiều Rộng Dao Cưa',
    zh_tc: '刀寬度',
    ru: 'Ширина ножа',
    ko: '칼 너비',
    bur: 'ဓားအကျယ်',
    ben: 'ছুরির প্রস্থ',
    tr: 'Bıçak genişliği',
    km: 'ទទឹងដាវ',
    es: 'Ancho de herramienta',
    ar: 'عرض الأداة',
  },
  'cuttingDock.knives.sawType': {
    zh: '锯片类型',
    en: 'Saw blade type',
    id: 'Jenis pisau gergaji',
    kz: 'Кескіш түрі',
    th: 'เลื่อยใบมีด',
    ug: 'ئارا تىپى',
    vi: 'Loại Dao Cưa',
    zh_tc: '鋸片類型',
    ru: 'Тип пилы',
    ko: '톱날 유형',
    bur: 'ဆောက်ဓားအမျိုးအစား',
    ben: 'কাটিং ব্লেড টাইপ',
    tr: 'Testere bıçağı tipi',
    km: 'ប្រភេទកាំបិទរណ្តៅ',
    es: 'Tipo de hoja de sierra',
    ar: 'نوع شفرة المنشار',
  },
  'cuttingDock.knives.cutDirection': {
    zh: '切割方向',
    en: 'Cutting Direction',
    id: 'Arah pemotongan',
    kz: 'Кесу бағыты',
    th: 'ทิศทางการตัด',
    ug: 'كېسىش يۆنىلىشى',
    vi: 'Hướng Cắt',
    zh_tc: '切割方向',
    ru: 'Направление резания',
    ko: '가공 방향',
    bur: 'ကတ်တင်းဦးတည်ချက်',
    ben: 'কাটিং দিক',
    tr: 'Kesim yönü',
    km: 'ទិសកាត់',
    es: 'Dirección de corte',
    ar: 'اتجاه القطع',
  },
  'cuttingDock.knives.moveSpeed': {
    zh: '空走速度',
    en: 'empty speed',
    id: 'Kecepatan kosong',
    kz: 'Бос жүру жылдамдығы',
    th: 'ความเร็วเปล่า',
    ug: 'بوش يۈرۈش تېزلىكى',
    vi: 'Tốc Độ Di chuyển Không Gia Công',
    zh_tc: '空走速度',
    ru: 'Пустая скорость',
    ko: '헛걸음 속도',
    bur: 'ဗလာသွားအမြန်နှုန်း',
    ben: 'খালি গতি',
    tr: 'Boşta hız',
    km: 'ល្បឿនគ្មានការកាត់',
    es: 'Velocidad de ralentí',
    ar: 'سرعة الخمول',
  },
  'cuttingDock.knives.cutSpeed': {
    zh: '加工速度',
    en: 'processing speed',
    id: 'Kecepatan pemrosesan',
    kz: 'Өңдеу жылдамдығы',
    th: 'ความเร็วในการประมวลผล',
    ug: 'ئىشلەش تېزلىكى',
    vi: 'Tốc Độ Gia Công',
    zh_tc: '加工速度',
    ru: 'Скорость обработки',
    ko: '가공 속도',
    bur: 'ကတ်တင်းအမြန်နှုန်း',
    ben: 'প্রসেসিং গতি',
    tr: 'İşleme hızı',
    km: 'ល្បឿនដំណើរការ',
    es: 'Velocidad de procesamiento',
    ar: 'سرعة المعالجة',
  },
  'cuttingDock.knives.endCode': {
    zh: '换刀结束代码',
    en: 'End code for tool change',
    id: 'Kode Akhir Perubahan Alat',
    kz: 'Зым ауыстыру аяқталу коды',
    th: 'เครื่องมือเปลี่ยนเครื่องมือ',
    ug: 'پىچاق ئالماشتۇرۇش ئاخىرلىق كودى',
    vi: 'Mã Kết Thúc Thay Dao',
    zh_tc: '換刀結束代碼',
    ru: 'Код окончания смены ножа',
    ko: '패스 종료 코드',
    bur: 'ဓားလဲခြင်းပြီးဆုံးကုဒ်',
    ben: 'টুল চেঞ্জের জন্য এন্ড কোড',
    tr: 'Takım değiştirme bitiş kodu',
    km: 'កូដបញ្ចប់ដូរឧបករណ៍កាត់',
    es: 'Código de fin de cambio de herramienta',
    ar: 'رمز نهاية تغيير الأداة',
  },
  'cuttingDock.knives.sawDownCode': {
    zh: '下刀代码',
    en: 'Lowering code',
    id: 'Kode Potongan',
    kz: 'Зым ішу коды',
    th: 'รหัสของการตัด',
    ug: 'پىچاق چۈشۈرۈش كودى',
    vi: 'Mã Dao Xuống',
    zh_tc: '下刀代碼',
    ru: 'Код ножа',
    ko: '언더핸드 코드',
    bur: 'ဓားချကုဒ်',
    ben: 'নামানোর কোড',
    tr: 'Bıçak indirme kodu',
    km: 'កូដចុះដាវ',
    es: 'Código de corte',
    ar: 'رمز القطع',
  },
  'cuttingDock.knives.sawUpCode': {
    zh: '收刀代码',
    en: 'Tool-off code',
    id: 'Kode pisau',
    kz: 'Зым ішудан шығу коды',
    th: 'รหัสมีด',
    ug: 'پىچاق يىغىش كودى',
    vi: 'Mã Dao Lên',
    zh_tc: '收刀代碼',
    ru: 'Код захвата',
    ko: '수신 코드',
    bur: 'ဓားရုပ်သိမ်းကုဒ်',
    ben: 'টুল-অফ কোড',
    tr: 'Bıçağı toplama kodu',
    km: 'កូដដកដាវ',
    es: 'Código de retroceso',
    ar: 'رمز التراجع',
  },
  'cuttingDock.knives.abscissa': {
    zh: '横坐标前缀',
    en: 'prefix of the abscissa',
    id: 'Awalan absis',
    kz: 'Жакшы координаттың алдынкісі',
    th: 'คำนำหน้า abscissor',
    ug: 'X كوئوردىنات ئالدى قوشۇمچىسى',
    vi: 'Tiền tố Tọa Độ Ngang',
    zh_tc: '橫座標前綴',
    ru: 'Префикс горизонтальных координат',
    ko: '가로 좌표 접두사',
    bur: 'အလျားကိုဩဒိနိတ်ရှေ့ဆက်',
    ben: 'অ্যাবসিসার উপসর্গ',
    tr: 'Apsis (yatay) ön eki',
    km: 'បុព្វបទអាប់ស៊ីស',
    es: 'Prefijo de coordenadas de abscisa',
    ar: 'بادئة الإحداثيات الإحداثية',
  },
  'cuttingDock.knives.ordinate': {
    zh: '纵坐标前缀',
    en: 'The prefix of the vertical coordinate',
    id: 'Awalan ordinat',
    kz: 'Жакшы координаттың ортасы',
    th: 'คำนำหน้า',
    ug: 'Y كوئوردىنات ئالدى قوشۇمچىسى',
    vi: 'Tiền tố Tọa Độ Dọc',
    zh_tc: '縱座標前綴',
    ru: 'Префикс продольных координат',
    ko: '누진 접두사',
    bur: 'ဒေါင်လိုက်ကိုဩဒိနိတ်ရှေ့ဆက်',
    ben: 'অর্ডিনেটের উপসর্গ',
    tr: 'Ordinat (dikey) ön eki',
    km: 'បុព្វបទកូអរដោនេបញ្ឈរ',
    es: 'Prefijo de coordenadas verticales',
    ar: 'بادئة الإحداثيات العمودية',
  },
  'cuttingDock.knives.sawHor': {
    zh: '横切锯片',
    en: 'cross-cutting saw blade',
    id: 'Pisau gergaji silang',
    kz: 'Жақшы кескіш',
    th: 'ใบเลื่อยข้ามตัด',
    ug: 'كەندىكى ئارا',
    vi: 'Dao Cưa Ngang',
    zh_tc: '橫切鋸片',
    ru: 'Поперечная пила',
    ko: '횡단 톱날',
    bur: 'အလျားလိုက်ဆောက်ဓား',
    ben: 'ক্রস-কাটিং কাটিং ব্লেড',
    tr: 'Enine kesim testere bıçağı',
    km: 'កាំបិទរណ្តៅកាត់ឆ្លាស់',
    es: 'Hoja de sierra para corte transversal',
    ar: 'شفرة منشار القطع المتقاطع',
  },
  'cuttingDock.knives.sawVer': {
    zh: '纵切锯片',
    en: 'vertical cutting blade',
    id: 'Pisau gergaji longitudinal',
    kz: 'Вертикаль кескіш',
    th: 'ใบเลื่อยตามยาว',
    ug: 'تىك كەسكۈچ ئارا',
    vi: 'Dao Cưa Dọc',
    zh_tc: '縱切鋸片',
    ru: 'Продольная пила',
    ko: '세로 톱날',
    bur: 'ဒေါင်လိုက်ဆောက်ဓား',
    ben: 'ভার্টিক্যাল কাটিং ব্লেড',
    tr: 'Boyuna kesim testere bıçağı',
    km: 'កាំបិទរណ្តៅកាត់បញ្ឈរ',
    es: 'Hoja de sierra para corte vertical',
    ar: 'شفرة منشار القطع العمودي',
  },
  'cuttingDock.knives.towardsZero': {
    zh: '向0点坐标切割',
    en: 'Cut towards the 0 point coordinate',
    id: 'Potong ke 0 koordinat titik',
    kz: '0 координатасына қарай кесу',
    th: 'ตัดเป็น 0 จุดพิกัด',
    ug: '0 نۇقتا كوئوردىناتىغا قاراپ كېسىش',
    vi: 'Cắt Hướng Điểm 0',
    zh_tc: '向0點座標切割',
    ru: 'Вырезать 0 координат',
    ko: '0점 좌표로 가공하기',
    bur: '၀အမှတ်ကိုဩဒိနိတ်ဆီကတ်တင်းပါ',
    ben: '০ পয়েন্ট কোঅর্ডিনেটের দিকে কাটুন',
    tr: '0 noktası koordinatına doğru kes',
    km: 'កាត់ទៅរកកូអរដោនេចំណុច ០',
    es: 'Corte hacia la coordenada del punto 0',
    ar: 'القطع باتجاه إحداثي 0 نقطة',
  },
  'cuttingDock.knives.awayFromZero': {
    zh: '远离0点坐标切割',
    en: 'Cut away from the 0 coordinate',
    id: 'Jauh dari pemotongan koordinat 0-poin',
    kz: '0 координатасынан алыс кесу',
    th: 'ห่างจากการตัดพิกัด 0 จุด',
    ug: '0 نۇقتا كوئوردىناتىدىن يىراقلاپ كېسىش',
    vi: 'Cắt Từ Điểm 0',
    zh_tc: '遠離0點座標切割',
    ru: 'Удаление от 0 координат',
    ko: '0점 좌표 컷 멀리하기',
    bur: '၀ကိုဩဒိနိတ်မှဝေးရာသို့ကတ်တင်းပါ',
    ben: '০ কোঅর্ডিনেট থেকে দূরে কাটুন',
    tr: '0 koordinatından uzağa kes',
    km: 'កាត់ឱ្យឆ្ងាយពីកូអរដោនេ ០',
    es: 'Corte alejándose de la coordenada del punto 0',
    ar: 'القطع بعيدًا عن إحداثي النقطة 0',
  },
  'cuttingDock.knives.diameterDesc': {
    zh: '刀直径Φ',
    en: 'diameter of the knife Φ',
    id: 'Diameter pisau φ',
    kz: 'Зым диаметрі Φ',
    th: 'เส้นผ่านศูนย์กลางมีดφ',
    ug: 'پىچاق دىئامېتىرى Φ',
    vi: 'Đường Kính Dao Φ',
    zh_tc: '刀直徑Φ',
    ru: 'Диаметр ножа',
    ko: '칼 지름 Φ',
    bur: 'ဓားအချင်းΦ',
    ben: 'ছুরির ব্যাস Φ',
    tr: 'Bıçak çapı Φ',
    km: 'អង្កត់ផ្ចិតដាវ Φ',
    es: 'Diámetro de herramienta Φ',
    ar: 'قطر الأداة Φ',
  },
  'cuttingDock.knives.xOffset': {
    zh: '横向坐标偏移',
    en: 'Horizontal coordinate offset',
    id: 'Offset koordinat horizontal',
    kz: 'Жакшы координатасының ауытқу',
    th: 'ออฟเซ็ตพิกัดแนวนอน',
    ug: 'ئەرزانى يۆنىلىشتىكى كوئوردىنات يۆتكىلىشى',
    vi: 'Biến Chuyển Tọa Độ Ngang',
    zh_tc: '橫向座標偏移',
    ru: 'Горизонтальное смещение координат',
    ko: '가로 좌표 오프셋',
    bur: 'အလျားလိုက်ကိုဩဒိနိတ်ရွေ့ခြင်း',
    ben: 'হরাইজন্টাল কোঅর্ডিনেট অফসেট',
    tr: 'Yatay koordinat ofseti',
    km: 'ការផ្លាស់ទីកូអរដោនេផ្ដេក',
    es: 'Desplazamiento de las coordenadas horizontales',
    ar: 'إزاحة الإحداثيات الأفقية',
  },
  'cuttingDock.knives.yOffset': {
    zh: '纵向坐标偏移',
    en: 'Vertical coordinate offset',
    id: 'Offset koordinat vertikal',
    kz: 'Орталық координатасының ауытқу',
    th: 'ออฟเซ็ตพิกัดแนวตั้ง',
    ug: 'تىك يۆنىلىشتىكى كوئوردىنات يۆتكىلىشى',
    vi: 'Biến Chuyển Tọa Độ Dọc',
    zh_tc: '縱向座標偏移',
    ru: 'Продольный сдвиг координат',
    ko: '세로 좌표 오프셋',
    bur: 'ဒေါင်လိုက်ကိုဩဒိနိတ်ရွေ့ခြင်း',
    ben: 'ভার্টিক্যাল কোঅর্ডিনেট অফসেট',
    tr: 'Dikey koordinat ofseti',
    km: 'ការផ្លាស់ទីកូអរដោនេបញ្ឈរ',
    es: 'Desplazamiento de las coordenadas longitudinales',
    ar: 'إزاحة الإحداثيات الطولية',
  },
  'cuttingDock.knives.zOffset': {
    zh: '升降坐标偏移',
    en: 'offset of the elevation coordinate',
    id: 'Mengangkat Offset Koordinat',
    kz: 'Жоғарғы-төмен координатасының ауытқу',
    th: 'การยกพิกัดออฟเซ็ต',
    ug: 'كۆتۈرۈلۈش كوئوردىناتى يۆتكىلىشى',
    vi: 'Biến Chuyển Tọa Độ Thăng Hạ',
    zh_tc: '升降座標偏移',
    ru: 'Смещение координат высоты',
    ko: '승강 좌표 오프셋',
    bur: 'အမြင့်ကိုဩဒိနိတ်ရွေ့ခြင်း',
    ben: 'এলিভেশন কোঅর্ডিনেট অফসেট',
    tr: 'Yükselti koordinatı ofseti',
    km: 'ការផ្លាស់ទីកូអរដោនេឡើងចុះ',
    es: 'Desplazamiento de las coordenadas de elevación',
    ar: 'إزاحة إحداثيات الرفع',
  },
  'cuttingDock.knives.offsetX': {
    zh: '偏移X',
    en: 'Offset X',
    id: 'Offset x',
    kz: 'X ауытқу',
    th: 'ชดเชย x',
    ug: 'X يۆتكىلىشى',
    vi: 'Biến Chuyển X',
    zh_tc: '偏移X',
    ru: 'Смещение X',
    ko: '오프셋 X',
    bur: 'ရွေ့ခြင်း X',
    ben: 'অফসেট X',
    tr: 'Ofset X',
    km: 'ផ្លាស់ទី X',
    es: 'Desplazamiento X',
    ar: 'الإزاحة X',
  },
  'cuttingDock.knives.offsetY': {
    zh: '偏移Y',
    en: 'Offset Y',
    id: 'Mengimbangi y',
    kz: 'Y ауытқу',
    th: 'ชดเชย y',
    ug: 'Y يۆتكىلىشى',
    vi: 'Biến Chuyển Y',
    zh_tc: '偏移Y',
    ru: 'Смещение Y',
    ko: 'Y 오프셋',
    bur: 'ရွေ့ခြင်း Y',
    ben: 'অফসেট Y',
    tr: 'Ofset Y',
    km: 'ផ្លាស់ទី Y',
    es: 'Compensación Y',
    ar: 'الإزاحة Y',
  },
  'cuttingDock.knives.offsetZ': {
    zh: '偏移Z',
    en: 'Offset Z',
    id: 'Offset Z.',
    kz: 'Z ауытқу',
    th: 'ชดเชย Z',
    ug: 'Z يۆتكىلىشى',
    vi: 'Biến Chuyển Z',
    zh_tc: '偏移Z',
    ru: 'Смещение Z',
    ko: '오프셋 Z',
    bur: 'ရွေ့ခြင်း Z',
    ben: 'অফসেট Z',
    tr: 'Ofset Z',
    km: 'ផ្លាស់ទី Z',
    es: 'Compensación Z',
    ar: 'الإزاحة Z',
  },
  'cuttingDock.knives.offsetNo': {
    zh: '偏移号',
    en: 'Offset number',
    id: 'Nomor offset',
    kz: 'Ауытқу нөмірі',
    th: 'หมายเลขออฟเซ็ต',
    ug: 'يۆتكىلىش نومۇرى',
    vi: 'Biến Chuyển Mã',
    zh_tc: '偏移號',
    ru: 'Номер смещения',
    ko: '오프셋 번호',
    bur: 'ရွေ့ခြင်းနံပါတ်',
    ben: 'অফসেট নম্বর',
    tr: 'Ofset numarası',
    km: 'លេខផ្លាស់ទី',
    es: 'Número de compensación',
    ar: 'رقم الإزاحة',
  },
  'cuttingDock.knives.knifeWidth': {
    zh: '刀宽',
    en: 'knife width',
    id: 'Lebar pisau',
    kz: 'Зым қашықтығы',
    th: 'ความกว้างของมีด',
    ug: 'پىچاق كەڭلىكى',
    vi: 'Chiều Rộng Dao',
    zh_tc: '刀寬',
    ru: 'Ширина ножа',
    ko: '칼폭',
    bur: 'ဓားအကျယ်',
    ben: 'ছুরির প্রস্থ',
    tr: 'Bıçak genişliği',
    km: 'ទទឹងដាវ',
    es: 'Ancho de herramienta',
    ar: 'عرض الأداة',
  },
  'cuttingDock.knives.drill': {
    zh: '下刀',
    en: 'cut',
    id: 'Melepaskan pisau',
    kz: 'Зым ішу',
    th: 'ออกจากมีด',
    ug: 'پىچاق چۈشۈرۈش',
    vi: 'Dao Xuống',
    zh_tc: '下刀',
    ru: 'Нож.',
    ko: '칼을 빼다',
    bur: 'ဓားချခြင်း',
    ben: 'নামানো',
    tr: 'Bıçak indirme',
    km: 'ចុះដាវ',
    es: 'Corte',
    ar: 'القطع',
  },
  'cuttingDock.knives.cut': {
    zh: '加工',
    en: 'processing',
    id: 'Pengolahan',
    kz: 'Өңдеу',
    th: 'กำลังประมวลผล',
    ug: 'ئىشلەش',
    vi: 'Gia Công',
    zh_tc: '加工',
    ru: 'обработка',
    ko: '가공',
    bur: 'ကတ်တင်းခြင်း',
    ben: 'প্রসেসিং',
    tr: 'İşleme',
    km: 'ដំណើរការ',
    es: 'Procesamiento',
    ar: 'المعالجة',
  },
  'cuttingDock.knives.speed': {
    zh: '转速',
    en: 'Speed',
    id: 'Kecepatan',
    kz: 'Айналым ылдамдығы',
    th: 'ความเร็ว',
    ug: 'ئايلىنىش تېزلىكى',
    vi: 'Tốc Độ',
    zh_tc: '轉速',
    ru: 'скорость вращения',
    ko: '회전 속도',
    bur: 'အမြန်နှုန်း',
    ben: 'গতি',
    tr: 'Devir hızı',
    km: 'ល្បឿនវិល',
    es: 'Velocidad',
    ar: 'السرعة',
  },
  'cuttingDock.knives.type': {
    zh: '类型',
    en: 'Type',
    id: 'jenis',
    kz: 'Түрі',
    th: 'พิมพ์',
    ug: 'تىپ',
    vi: 'Loại',
    zh_tc: '類型',
    ru: 'тип',
    ko: '유형',
    bur: 'အမျိုးအစား',
    ben: 'টাইপ',
    tr: 'Tür',
    km: 'ប្រភេទ',
    es: 'Tipo',
    ar: 'النوع',
  },
  'cuttingDock.knives.millHoleSlot': {
    zh: '铣孔/槽',
    en: 'Milling hole/slot',
    id: 'Lubang/slot penggilingan',
    kz: 'Тырнақ/слот фрезерлеу',
    th: 'โม่/สล็อต',
    ug: 'تېشىك/ئوچۇق فرېزىرلاش',
    vi: 'Máy Xí Khoan Động/Khay',
    zh_tc: '銑孔/槽',
    ru: 'Фрезерные отверстия / пазы',
    ko: '밀링 구멍 / 슬롯',
    bur: 'အပေါက်/အချိုးမေးလ်လင်းခြင်း',
    ben: 'মিলিং হোল/স্লট',
    tr: 'Freze delik/yuva',
    km: 'រន្ធ/រណ្តៅហ្វ្រីស',
    es: 'Fresado de orificio/ranura',
    ar: 'فتحة/فتحة الطحن',
  },
  'cuttingDock.knives.rapidFeedSpeed': {
    zh: '快速进给速度',
    en: 'Rapid feed speed',
    id: 'Kecepatan umpan cepat',
    kz: 'Жылдам жеткізу жылдамдығы',
    th: 'ความเร็วฟีดเร็ว',
    ug: 'تېز ئوزۇقلاندۇرۇش تېزلىكى',
    vi: 'Tốc Độ Tiến Khoáng Nhanh',
    zh_tc: '快速進給速度',
    ru: 'Скорость быстрой подачи',
    ko: '빠른 이송 속도',
    bur: 'အမြန်ကျွေးအမြန်နှုန်း',
    ben: 'র্যাপিড ফিড স্পিড',
    tr: 'Hızlı ilerleme hızı',
    km: 'ល្បឿនមុខទៅលឿន',
    es: 'Avance rápido',
    ar: 'معدل التغذية السريع',
  },
  'cuttingDock.knives.typeOption1': {
    zh: '钻头',
    en: 'Bit',
    id: 'Bor',
    kz: 'бұрғы тұмсығы ',
    th: 'ดอกสว่าน',
    ug: 'چۈزگۈچ تۈگەك',
    vi: 'Mũi khoan',
    zh_tc: '鑽頭',
    ru: 'сверло',
    ko: '드릴',
    bur: 'အပ်ချွန်',
    ben: 'বিট',
    tr: 'Matkap ucu',
    km: 'ក្បួនដោត',
    es: 'Broca',
    ar: 'لقمة الحفر',
  },
  'cuttingDock.knives.typeOption2': {
    zh: '铣刀',
    en: 'Milling cutter',
    id: 'Pemotong penggilingan',
    kz: 'Түзеткіш аспап',
    th: 'เครื่องตัดมิลลิ่ง',
    ug: 'چۈشىك',
    vi: 'Mũi phay',
    zh_tc: '銑刀',
    ru: 'фреза',
    ko: '밀링 커터',
    bur: 'မေးလ်လင်းဓား',
    ben: 'মিলিং কাটার',
    tr: 'Freze ucu',
    km: 'ដាវហ្វ្រីស',
    es: 'Fresa',
    ar: 'الطحن القاطع',
  },
  'cuttingDock.knives.typeOption3': {
    zh: '造型刀',
    en: 'Styling knife',
    id: 'Pisau Bentuk',
    kz: 'Құрылымдық пышақ',
    th: 'มีดจัดแต่งทรงผม',
    ug: 'ئەسلىي قىلىش قۇرى',
    vi: 'Dao tạo hình',
    zh_tc: '造型刀',
    ru: 'Стильный нож',
    ko: '조형칼',
    bur: 'ပုံသဏ္ဍာန်ဓား',
    ben: 'স্টাইলিং ছুরি',
    tr: 'Profil bıçağı',
    km: 'ដាវបង់រូប',
    es: 'cortador de forma',
    ar: 'قاطع التشكيل',
  },
  'cuttingDock.knives.typeTip': {
    zh: '设置刀具类型后孔槽会匹配对应类型的刀具进行加工',
    en: 'After setting the tool type, the hole slot will match the corresponding type of tool for machining',
    id: 'Pengaturan jenis alat lubang belakang akan cocok dengan jenis alat yang sesuai untuk pemrosesan',
    kz: 'Сараптай салынған соқпақ түріне сәйкес, ойықтар сәйкес соқпақпен өңделеді',
    th: 'การตั้งค่าประเภทเครื่องมือ ช่องเสียบรูด้านหลังจะจับคู่เครื่องมือประเภทที่สอดคล้องกันสำหรับการตัดเฉือน',
    ug: 'قازق تىپىنى تەڭشەپ بولۇشىدىن كېيىن، تۈرلىلىق تەپسىلاتلىق تۇرغۇزما بىلەن ئىشلىنىدۇ',
    vi: 'Sau khi thiết lập loại dao cạo, rãnh sẽ được gia công phù hợp với loại dao đó',
    zh_tc: '設置刀具類型後孔槽會匹配對應類型的刀具進行加工',
    ru: 'Установите тип инструмента, задний отверстие будет соответствовать соответствующему типу инструмента для обработки',
    ko: '공구 유형을 설정하면 구멍 슬롯이 해당 유형의 공구와 일치하여 가공됩니다.',
    bur: 'ဓားအမျိုးအစားသတ်မှတ်ပြီးနောက် အပေါက်/အချိုးသည် ကတ်တင်းရန်သက်ဆိုင်ရာဓားအမျိုးနှင့်ကိုက်ညီမည်',
    ben: 'টুল টাইপ সেট করার পর হোল স্লট মেশিনিংয়ের জন্য সংশ্লিষ্ট টাইপের টুলের সাথে মিলবে',
    tr: 'Takım türü ayarlandıktan sonra delik ve yuvalar ilgili türdeki takımla işlenir',
    km: 'បន្ទាប់ពីកំណត់ប្រភេទឧបករណ៍ រន្ធនិងរណ្តៅត្រូវដំណើរការដោយឧបករណ៍ត្រូវប្រភេទ',
    es: 'Después de configurar el tipo de herramienta, la ranura del orificio coincidirá con el tipo de herramienta correspondiente para el procesamiento',
    ar: 'بعد تعيين نوع الأداة، سوف تتطابق فتحة الثقب مع نوع الأداة المقابل للمعالجة',
  },
  'cuttingDock.other.title': {
    zh: '其他',
    en: 'Others',
    id: 'lainnya',
    kz: 'Басқа',
    th: 'อื่น',
    ug: 'باشقىلار',
    vi: 'Khác',
    zh_tc: '其他',
    ru: 'другие',
    ko: '기타',
    bur: 'အခြား',
    ben: 'অন্যান্য',
    tr: 'Diğer',
    km: 'ផ្សេងៗ',
    es: 'Otros',
    ar: 'أخرى',
  },
  'cuttingDock.other.tip': {
    zh: '（注意：单工位设备需要将工位1和工位2都填上相同的自动上料代码）',
    en: 'For single-station equipment, both Station 1 and Station 2 must be assigned the same automatic feeding code',
    id: '(Catatan: Peralatan stasiun tunggal memerlukan kode pemuatan otomatis yang sama untuk mengisi stasiun 1 dan stasiun 2)',
    kz: '（Ескерту: Бирлектегі станс құрылғысы үшін 1 және 2 станстарын автоматтық тіркелім кодымен толтыру керек)',
    th: '(หมายเหตุ: อุปกรณ์สถานีเดียวต้องใช้รหัสโหลดอัตโนมัติเดียวกันเพื่อเติมทั้งสถานี 1 และสถานี 2)',
    ug: '(دىققەت: يەككە خىزمەت ئورنى ئۈسكۈنىسى خىزمەت ئورنى1 ۋە خىزمەت ئورنى2 گە ئوخشاش ئاپتوماتىك ماتېرىيال يۈكلەش كودىنى تولدۇرۇشى كېرەك)',
    vi: '（Chú ý: Thiết bị một vị trí cần điền mã tự động tải liệu cho vị trí 1 và vị trí 2 đều giống nhau）',
    zh_tc: '（注意：單工位設備需要將工位1和工位2都填上相同的自動上料代碼）',
    ru: '(Примечание: однопозиционное оборудование должно заполнять один и тот же код автоматической загрузки как для рабочего места 1, так и для рабочего места 2)',
    ko: '(참고: 단일 작업 비트 장치는 작업 비트 1과 작업 비트 2를 동일한 자동 공급 코드로 채워야 합니다.)',
    bur: 'တစ်ဌာနပစ္စည်းအတွက် ဌာန၁နှင့်ဌာန၂နှစ်ခုလုံးတွင် တူညီသည့်အလိုအလျောက်အစာထည့်ကုဒ်ထည့်ရမည်',
    ben: 'সিঙ্গেল স্টেশন সরঞ্জামের জন্য স্টেশন ১ ও স্টেশন ২ উভয়েই একই অটো ফিডিং কোড দেওয়া আবশ্যক',
    tr: '(Not: Tek istasyonlu cihazlarda İstasyon 1 ve İstasyon 2 için aynı otomatik besleme kodunu girin)',
    km: '(សម្គាល់៖ ឧបករណ៍ស្ថានីយ៍តែមួយត្រូវបញ្ចូលកូដបំពេញស្វ័យប្រវត្តិដូចគ្នាសម្រាប់ស្ថានីយ៍ ១ និង ២)',
    es: '(Nota: el equipo de estación única debe completar el mismo código de carga automática para la estación 1 y la estación 2)',
    ar: '(ملاحظة: تحتاج معدات المحطة الواحدة إلى ملء نفس رمز التحميل التلقائي للمحطة 1 والمحطة 2)',
  },
  'sideHoleMachine.moreSetting': {
    zh: '更多设置',
    en: 'More Settings',
    id: 'Pengaturan tambahan',
    kz: 'Қосымша параметрлер',
    th: 'การตั้งค่าเพิ่มเติม',
    ug: 'تېخىمۇ كۆپ تەڭشەك',
    vi: 'Cài đặt thêm',
    zh_tc: '更多設定',
    ru: 'Больше настроек',
    ko: '추가 설정',
    bur: 'ပိုမိုပေါ်ပေါက်များ',
    ben: 'আরও সেটিংস',
    tr: 'Daha fazla ayar',
    km: 'ការកំណត់បន្ថែម',
    es: 'Más configuraciones',
    ar: 'المزيد من الإعدادات',
  },
  'sideHoleMachine.sideStartCode': {
    zh: '正面加工生成换面代码',
    en: 'Front processing generates face change code',
    id: 'Pemrosesan depan menghasilkan kode perubahan muka',
    kz: 'Алдыңғы өңдеуде бет ауысу кодын жасау',
    th: 'การประมวลผลด้านหน้าสร้างโค้ดเปลี่ยนหน้า',
    ug: 'ئالدى يۈزى ئىشلەشتە يۈز ئالماشتۇرۇش كودى ھاسىل قىلىش',
    vi: 'Xử lý mặt trước tạo mã thay đổi mặt',
    zh_tc: '正面加工生成換面代碼',
    ru: 'Обработка спереди для создания кода переключения',
    ko: '정면 가공 생성 환면 코드',
    bur: 'မြင်ခြင်းစနစ်ကို မြင်ခြင်းစနစ်သို့ ပြောင်းလဲသည့် ကုဒ်ကို ဖန်တီးသည်',
    ben: 'প্রান্ত প্রসেসিং ফেস চেঞ্জ কোড জেনারেট করে',
    tr: 'Ön yüz işleme yüz değiştirme kodu üretir',
    km: 'ដំណើរការខាងមុខបង្កើតកូដប្តូរមុខ',
    es: 'Generar código de cambio de cara para el procesamiento frontal',
    ar: 'إنشاء رمز تغيير الوجه للمعالجة الأمامية',
  },
  'sideHoleMachine.useArcCode': {
    zh: '圆弧插补指令切割弧形',
    en: 'Arc interpolation command for cutting arcs',
    id: 'Perintah interpolasi busur untuk memotong busur',
    kz: 'Доға кесуге арналған доғалық интерполяция командасы',
    th: 'คำสั่งการแทรกแซงส่วนโค้งสำหรับตัดส่วนโค้ง',
    ug: 'يېرىم چەمبەر تولۇقلاش بۇيرۇقى بىلەن يېرىم چەمبەر كېسىش',
    vi: 'Lệnh nội suy cung để cắt hình cung',
    zh_tc: '圓弧插補指令切割弧形',
    ru: 'Директива о вставке дуги',
    ko: '호 보간 명령 절단 호형',
    bur: 'ဝိုင်းကွေးဖြတ်ရန် အာ့ခ် အင်တာပိုလေးရှင်း အမိန့်ကို အသုံးပြုပါ',
    ben: 'আর্ক ইন্টারপোলেশন নির্দেশ দিয়ে আর্ক কাটুন',
    tr: 'Yay interpolasyonu ile yay kesimi',
    km: 'កាត់រង្វង់ដោយបញ្ជារមស់រង្វង់',
    es: 'Comando de interpolación de arco para cortar el arco',
    ar: 'أمر الاستيفاء القوسي لقطع القوس',
  },
  'sideHoleMachine.coordSwitch': {
    zh: '坐标基准对调',
    en: 'Coordinate Reference Switch',
    id: 'Koordinat Penyelarasan Referensi',
    kz: 'Координаталық Негізді Ауыстыру',
    th: 'ประสานงานการจัดตำแหน่งอ้างอิง',
    ug: 'كوئوردېنات ئاساسى ئالماشتۇرۇش',
    vi: 'Chuyển Đổi Tham Chiếu Tọa Độ',
    zh_tc: '座標基準對調',
    ru: 'Коррекция координат',
    ko: '좌표 데이텀 조정',
    bur: 'ကိုဩဒိနိတ် အခြေခံအမှတ် ပြောင်းလဲခြင်း',
    ben: 'কোঅর্ডিনেট রেফারেন্স সোয়াপ',
    tr: 'Koordinat referansını değiştir',
    km: 'ប្តូរយោងកូអរដោនេ',
    es: 'Intercambio de datos de coordenadas',
    ar: 'تبديل مسند الإسناد',
  },
  'sideHoleMachine.updownCoordSwitch': {
    zh: '升降坐标基准对调',
    en: 'Lifting Coordinate Reference Switch',
    id: 'Mengangkat penyesuaian referensi koordinat',
    kz: 'Көтеру Координаталық Негізді Ауыстыру',
    th: 'การปรับการอ้างอิงพิกัดการยก',
    ug: 'كۆتۈرۈش-چۈشۈرۈش كوئوردېنات ئاساسى ئالماشتۇرۇش',
    vi: 'Chuyển Đổi Tham Chiếu Tọa Độ Nâng',
    zh_tc: '升降座標基準對調',
    ru: 'Коррекция координат высоты',
    ko: '승강 좌표 데이텀 쌍',
    bur: 'အမြင့်-အနိမ့် ကိုဩဒိနိတ် အခြေခံအမှတ် ပြောင်းလဲခြင်း',
    ben: 'লিফটিং কোঅর্ডিনেট রেফারেন্স সোয়াপ',
    tr: 'Yükselti koordinatı referansını değiştir',
    km: 'ប្តូរយោងកូអរដោនេឡើងចុះ',
    es: 'Intercambio de datos de coordenadas de elevación y descenso',
    ar: 'مبادلة مرجعية الإحداثيات للرفع والخفض',
  },
  'sideHoleMachine.xCoordSwitch': {
    zh: '横向坐标基准对调',
    en: 'Swap the benchmarks of the horizontal coordinates',
    id: 'Tukar acuan koordinat horizontal',
    kz: 'Горизонтальды координаттардың негіздерінің алмастыруы',
    th: 'สลับมาตรฐานของพิกัดแนวนอน',
    ug: 'گورىزۆنتال كۆرنىتتىكى ئاساسلارنى ئالماشتۇرۇش',
    vi: 'Đổi chỗ các chuẩn của tọa độ ngang',
    zh_tc: '橫向座標基準對調',
    ru: 'Горизонтальная настройка координат',
    ko: '가로 좌표 데이텀 조정',
    bur: 'အလျားလိုက် ကိုဩဒိနိတ် အခြေခံအမှတ်များကို လဲလှယ်ပါ',
    ben: 'হরাইজন্টাল কোঅর্ডিনেট রেফারেন্স সোয়াপ',
    tr: 'Yatay koordinat referanslarını değiştir',
    km: 'ប្តូរយោងកូអរដោនេផ្ដេក',
    es: 'Intercambio de datos de coordenadas transversales',
    ar: 'مبادلة مرجعية الإحداثيات المستعرضة',
  },
  'sideHoleMachine.yCoordSwitch': {
    zh: '纵向坐标基准对调',
    en: 'Swap the benchmarks of the vertical coordinates',
    id: 'Tukar acuan koordinat vertikal ',
    kz: 'Вертикальды координаттардың негіздерінің алмастыруы',
    th: 'สลับมาตรฐานของพิกัดแนวตั้ง',
    ug: 'وېرېتىكال كۆرنىتتىكى ئاساسلارنى ئالماشتۇرۇش',
    vi: 'Đổi chỗ các chuẩn của tọa độ dọc',
    zh_tc: '縱向座標基準對調',
    ru: 'Вертикальная коррекция координат',
    ko: '수직 좌표 데이텀 조정',
    bur: 'ဒေါင်လိုက် ကိုဩဒိနိတ် အခြေခံအမှတ်များကို လဲလှယ်ပါ',
    ben: 'ভার্টিক্যাল কোঅর্ডিনেট রেফারেন্স সোয়াপ',
    tr: 'Dikey koordinat referanslarını değiştir',
    km: 'ប្តូរយោងកូអរដោនេបញ្ឈរ',
    es: 'Intercambio de datos de coordenadas longitudinales',
    ar: 'مبادلة مرجعية الإحداثيات الطولية',
  },
  'sideHoleMachine.knifes.number': {
    zh: '编号',
    en: 'Number',
    id: 'nomor seri',
    kz: 'Номер',
    th: 'หมายเลขซีเรียล',
    ug: 'نومۇر',
    vi: 'Số hiệu',
    zh_tc: '編號',
    ru: 'номер',
    ko: '번호',
    bur: 'အမှတ်',
    ben: 'নম্বর',
    tr: 'Numara',
    km: 'លេខ',
    es: 'Número',
    ar: 'الرقم',
  },
  'sideHoleMachine.knifes.diameter': {
    zh: '刀宽',
    en: 'Blade Width',
    id: 'Lebar pisau',
    kz: 'Қасақ ені',
    th: 'ความกว้างของมีด',
    ug: 'پىچاق كەڭلىكى',
    vi: 'Chiều rộng dao',
    zh_tc: '刀寬',
    ru: 'Ширина ножа',
    ko: '칼폭',
    bur: 'ဓားအကျယ်',
    ben: 'ব্লেডের প্রস্থ',
    tr: 'Bıçak genişliği',
    km: 'ទទឹងដាវ',
    es: 'Ancho de herramienta',
    ar: 'عرض الأداة',
  },
  'sideHoleMachine.knifes.type': {
    zh: '类型',
    en: 'Type',
    id: 'jenis',
    kz: 'Түрі',
    th: 'พิมพ์',
    ug: 'تىپى',
    vi: 'Loại',
    zh_tc: '類型',
    ru: 'тип',
    ko: '유형',
    bur: 'အမျိုးအစား',
    ben: 'টাইপ',
    tr: 'Tür',
    km: 'ប្រភេទ',
    es: 'Tipo',
    ar: 'النوع',
  },
  'sideHoleMachine.knifes.moveSpeed': {
    zh: '快速进给速度',
    en: 'Rapid Feed Speed',
    id: 'Kecepatan umpan cepat',
    kz: 'Жылдамдықпен жылдамдық',
    th: 'ความเร็วฟีดเร็ว',
    ug: 'تېز يۆتكىلىش سۈرئىتى',
    vi: 'Tốc độ tiến nhanh',
    zh_tc: '快速進給速度',
    ru: 'Скорость быстрой подачи',
    ko: '빠른 이송 속도',
    bur: 'အမြန်ထိုးကျွေး အမြန်နှုန်း',
    ben: 'র্যাপিড ফিড স্পিড',
    tr: 'Hızlı ilerleme hızı',
    km: 'ល្បឿនមុខទៅលឿន',
    es: 'Avance rápido',
    ar: 'معدل التغذية السريع',
  },
  'sideHoleMachine.knifes.doSpeed': {
    zh: '加工速度',
    en: 'Processing Speed',
    id: 'Kecepatan pemrosesan',
    kz: 'Өңдеу жылдамдығы',
    th: 'ความเร็วในการประมวลผล',
    ug: 'ئىشلەش سۈرئىتى',
    vi: 'Tốc độ gia công',
    zh_tc: '加工速度',
    ru: 'Скорость обработки',
    ko: '가공 속도',
    bur: 'ပြုပြင်မှု အမြန်နှုန်း',
    ben: 'মেশিনিং স্পিড',
    tr: 'İşleme hızı',
    km: 'ល្បឿនដំណើរការ',
    es: 'Velocidad de procesamiento',
    ar: 'سرعة المعالجة',
  },
  'sideHoleMachine.knifes.startCode': {
    zh: '换刀开始代码',
    en: 'Tool Change Start Code',
    id: 'Kode Mulai Perubahan Alat',
    kz: 'Қасақ ауыстыру бастау коды',
    th: 'เครื่องมือเริ่มต้นเปลี่ยนรหัส',
    ug: 'پىچاق ئالماشتۇرۇش باشلىنىش كودى',
    vi: 'Mã bắt đầu đổi dao',
    zh_tc: '換刀開始代碼',
    ru: 'Код начала смены ножей.',
    ko: '스왑 시작 코드',
    bur: 'ဓားလဲခြင်း စတင်ကုဒ်',
    ben: 'টুল চেঞ্জ স্টার্ট কোড',
    tr: 'Takım değiştirme başlangıç kodu',
    km: 'កូដចាប់ផ្តើមដូរឧបករណ៍កាត់',
    es: 'Código de inicio de cambio de herramienta',
    ar: 'رمز بدء تغيير الأداة',
  },
  'sideHoleMachine.knifes.endCode': {
    zh: '换刀结束代码',
    en: 'Tool Change End Code',
    id: 'Kode Akhir Perubahan Alat',
    kz: 'Қасақ ауыстыру аяқтау коды',
    th: 'เครื่องมือเปลี่ยนเครื่องมือ',
    ug: 'پىچاق ئالماشتۇرۇش ئاخىرلىشىش كودى',
    vi: 'Mã kết thúc đổi dao',
    zh_tc: '換刀結束代碼',
    ru: 'Код окончания смены ножа',
    ko: '패스 종료 코드',
    bur: 'ဓားလဲခြင်း ပြီးဆုံးကုဒ်',
    ben: 'টুল চেঞ্জ এন্ড কোড',
    tr: 'Takım değiştirme bitiş kodu',
    km: 'កូដបញ្ចប់ដូរឧបករណ៍កាត់',
    es: 'Código de fin de cambio de herramienta',
    ar: 'رمز نهاية تغيير الأداة',
  },
  'sideHoleMachine.ymSetting': {
    zh: '易木连接设置',
    en: 'Yimu Connection Settings',
    id: 'Pengaturan Koneksi Easy-Mu',
    kz: 'Yimu байланыс настройкасы',
    th: 'การตั้งค่าการเชื่อมต่อ Easy-MU',
    ug: 'ئاسان ياغاچ ئۇلىنىش تەڭشىكى',
    vi: 'Cài đặt kết nối Yimu',
    zh_tc: '易木連接設置',
    ru: 'Параметры подключения',
    ko: '나무 연결 설정',
    bur: 'Yimu ချိတ်ဆက်မှု ဆက်တင်များ',
    ben: 'Yimu কানেকশন সেটিংস',
    tr: 'Yimu bağlantı ayarları',
    km: 'ការកំណត់តភ្ជាប់ Yimu',
    es: 'Conexión Yimu',
    ar: 'إعدادات اتصال Yimu',
  },
  'sideHoleMachine.flanking': {
    zh: '侧面加工',
    en: 'side processing',
    id: 'Pemrosesan samping',
    kz: 'Сірткі өңдеу',
    th: 'การประมวลผลด้านข้าง',
    ug: 'يان تەرەپ ئىشلەش',
    vi: 'Công tác cạnh',
    zh_tc: '側面加工',
    ru: 'Боковая обработка',
    ko: '측면 가공',
    bur: 'ဘေးဖက် ပြုပြင်မှု',
    ben: 'সাইড প্রসেসিং',
    tr: 'Yan yüz işleme',
    km: 'ដំណើរការចំហៀង',
    es: 'Procesamiento lateral',
    ar: 'المعالجة الجانبية',
  },
  'sideHoleMachine.frontProcess': {
    zh: '正面加工',
    en: 'front processing',
    id: 'Pemrosesan frontal',
    kz: 'Алдыңғы өңдеу',
    th: 'การประมวลผลด้านหน้า',
    ug: 'ئالدى يۈزى ئىشلەش',
    vi: 'Công tác mặt trước',
    zh_tc: '正面加工',
    ru: 'Положительная обработка',
    ko: '전면 가공',
    bur: 'အရှေ့ဖက် ပြုပြင်မှု',
    ben: 'ফ্রন্ট প্রসেসিং',
    tr: 'Ön yüz işleme',
    km: 'ដំណើរការខាងមុខ',
    es: 'Procesamiento frontal',
    ar: 'المعالجة الأمامية',
  },
  'sideHoleMachine.oldSetting': {
    zh: '旧版设置',
    en: 'Old version setting',
    id: 'Pengaturan versi lama',
    kz: 'Ескі параметрлер',
    th: 'การตั้งค่าเวอร์ชันเก่า',
    ug: 'كونا نەشرى تەڭشىكى',
    vi: 'Cài đặt cũ',
    zh_tc: '舊版設置',
    ru: 'Настройки старой версии',
    ko: '레거시 설정',
    bur: 'ဗားရှင်းဟောင်း ဆက်တင်များ',
    ben: 'পুরোনো সংস্করণের সেটিংস',
    tr: 'Eski sürüm ayarları',
    km: 'ការកំណត់កំណែចាស់',
    es: 'Configuración de versión antigua',
    ar: 'إعداد الإصدار القديم',
  },
  'sideHoleMachine.equipParamsSetting': {
    zh: '设备参数设置',
    en: 'Equipment parameter setting',
    id: 'Pengaturan Parameter Perangkat',
    kz: 'Құрылғы параметрлерін орнату',
    th: 'การตั้งค่าพารามิเตอร์อุปกรณ์',
    ug: 'ئۈسكۈنە پارامېتىر تەڭشىكى',
    vi: 'Cài đặt thông số thiết bị',
    zh_tc: '設備參數設置',
    ru: 'Параметры устройства',
    ko: '장치 매개 변수 설정',
    bur: 'စက်ပစ္စည်း ပါရာမီတာ ဆက်တင်များ',
    ben: 'ইকুইপমেন্ট প্যারামিটার সেটিংস',
    tr: 'Cihaz parametre ayarları',
    km: 'ការកំណត់ប៉ារ៉ាម៉ែត្រឧបករណ៍',
    es: 'Configuración de parámetros del equipo',
    ar: 'إعداد معلمة المعدات',
  },
  'sideHoleMachine.holeSetting': {
    zh: '打孔设置',
    en: 'Hole setting',
    id: 'Pengaturan meninju',
    kz: 'Тырнақ параметрлерін орнату',
    th: 'การตั้งค่าการเจาะ',
    ug: 'تۆشۈك تېشىش تەڭشىكى',
    vi: 'Cài đặt khoan động',
    zh_tc: '打孔設置',
    ru: 'Параметры перфорации',
    ko: '펀치 설정',
    bur: 'အပေါက်ထိုး ဆက်တင်များ',
    ben: 'হোল সেটিংস',
    tr: 'Delik ayarları',
    km: 'ការកំណត់រន្ធ',
    es: 'Configuración de orificios',
    ar: 'إعداد الثقب',
  },
  'sideHoleMachine.raminoSetting': {
    zh: '拉米诺连接设置',
    en: 'Ramino connection setting',
    id: 'Pengaturan Koneksi Lamino',
    kz: 'Lamino қосылу параметрлерін орнату',
    th: 'การตั้งค่าการเชื่อมต่อ Lamino',
    ug: 'رامىنو ئۇلىنىش تەڭشىكى',
    vi: 'Cài đặt kết nối Ramino',
    zh_tc: '拉米諾連接設置',
    ru: 'Параметры подключения Ramino',
    ko: '라미노 연결 설정',
    bur: 'Ramino ချိတ်ဆက်မှု ဆက်တင်များ',
    ben: 'Ramino কানেকশন সেটিংস',
    tr: 'Ramino bağlantı ayarları',
    km: 'ការកំណត់តភ្ជាប់ Ramino',
    es: 'Configuración de conexión lamino',
    ar: 'إعداد اتصال Lamino',
  },
  'sideHoleMachine.mortiseTenonSetting': {
    zh: '榫卯连接设置',
    en: 'Tenon and mortise connection setting',
    id: 'Pengaturan Koneksi Monolitik dan Tenon',
    kz: 'Mortise и Tenon қосылу параметрлерін орнату',
    th: 'การตั้งค่าการเชื่อมต่อเสาหินและเดือย',
    ug: 'ئۇلاش-چاپلاش تەڭشىكى',
    vi: 'Cài đặt kết nối móc',
    zh_tc: '榫卯連接設置',
    ru: 'Параметры соединения',
    ko: '장부 연결 설정',
    bur: 'တံချောင်း-အပေါက် (Mortise & Tenon) ချိတ်ဆက်မှု ဆက်တင်များ',
    ben: 'মর্টিস-টেনন কানেকশন সেটিংস',
    tr: 'Çıkıntı ve oyuk bağlantı ayarları',
    km: 'ការកំណត់តភ្ជាប់ mortise និង tenon',
    es: 'Configuración de conexión de mortaja y espiga',
    ar: 'إعداد اتصال نقر ولسان',
  },
  'sideHoleMachine.straight': {
    zh: '直款',
    en: 'Straight Type',
    id: 'Langsung',
    kz: 'Түз сызық',
    th: 'โดยตรง',
    ug: 'تۈز تىپى',
    vi: 'Mẫu thẳng',
    zh_tc: '直款',
    ru: 'Прямая сумма',
    ko: '직불',
    bur: 'တန်းပုံစံ',
    ben: 'স্ট্রেইট টাইপ',
    tr: 'Düz tip',
    km: 'ប្រភេទត្រង់',
    es: 'Estilo recto',
    ar: 'النمط المستقيم',
  },
  'sideHoleMachine.eccentric': {
    zh: '偏心款',
    en: 'eccentric Type',
    id: 'Model ekstrasentrik',
    kz: 'Эксцентрлік модель',
    th: 'โมเดล Extracentric',
    ug: 'مەركەزدىن قاچقان تىپى',
    vi: 'Mẫu lệch tâm',
    zh_tc: '偏心款',
    ru: 'Эксцентричность',
    ko: '편파적인 돈',
    bur: 'ဗဟိုလွဲ ပုံစံ',
    ben: 'একসেন্ট্রিক টাইপ',
    tr: 'Eksantrik tip',
    km: 'ប្រភេទអ៊ិចសង់ត្រិក',
    es: 'Estilo excéntrico',
    ar: 'النمط غريب الأطوار',
  },
  'sideHoleMachine.pbSize': {
    zh: '上下破板尺寸',
    en: 'Upper and lower breaking board size',
    id: 'Ukuran pelat pemecah atas dan bawah',
    kz: 'Жоғарғы және төменгі сыну тақтасының өлшемі',
    th: 'ขนาดของแผ่นแตกบนและล่าง',
    ug: 'ئۈستى-ئاستى تاختا سۇندۇرۇش ئۆلچىمى',
    vi: 'Kích thước bảng phá trên và dưới',
    zh_tc: '上下破板尺寸',
    ru: 'Размер верхней и нижней поломки',
    ko: '상하 파판 크기',
    bur: 'အပေါ်/အောက် ပျက်ဘုတ် အရွယ်အစား',
    ben: 'উপর/নিচ ব্রেকিং বোর্ডের সাইজ',
    tr: 'Üst ve alt kırma levhası boyutu',
    km: 'ទំហំផ្ទាំងបំបែកលើ និងក្រោម',
    es: 'Tamaño de placa rota superior e inferior',
    ar: 'حجم اللوحة المكسورة العلوية والسفلية',
  },
  'sideHoleMachine.slotOverlapRate': {
    zh: '铣槽重叠率',
    en: 'Overlap ratio of milling groove',
    id: 'Tumpang Tindih Pemotongan Milling',
    kz: 'Слоттардың қабаттасу мөлшері',
    th: 'ค่าที่ซ้อนทับการตัดสล็อต',
    ug: 'تۈز يوچۇق ئىشلەش قايتۇرۇش قاتتىقى',
    vi: 'Tumpang Tindih Pemotongan Milling',
    zh_tc: '銑槽重疊率',
    ru: 'перекрытие фрезерных пазов',
    ko: '밀링 슬롯 중첩률',
    bur: 'ချောင်းဖရီးဇ် ထပ်ဆင့်နှုန်း',
    ben: 'মিলিং স্লট ওভারল্যাপ রেট',
    tr: 'Freze yuvası örtüşme oranı',
    km: 'អត្រាស្ទូចគ្នានៃរណ្តៅហ្វ្រីស',
    es: 'Tasa de superposición de ranuras de fresado',
    ar: 'معدل تداخل فتحة الطحن',
  },
  'sideHoleMachine.breakingBoardDirection': {
    zh: '上下破板方向',
    en: 'Direction of upper and lower plate breaking',
    id: 'Arah Papan yang Rusak (Vertikal dan Horizontal)',
    kz: 'Сыну тақтасының бағыты (Тік және горизонталь)',
    th: 'ทิศทางของแผ่นที่ถูกทำลาย (ตั้งฉากและนอน)',
    ug: 'ئۈستى-ئاستى تاختا سۇندۇرۇش بۇيرۇقى',
    vi: 'Arah Papan yang Rusak (Vertikal dan Horizontal)',
    zh_tc: '上下破板方向',
    ru: 'Вверх - вниз',
    ko: '상하 파판 방향',
    bur: 'အပေါ်/အောက် ပျက်ဘုတ် ဦးတည်ချက်',
    ben: 'উপর/নিচ ব্রেকিং বোর্ডের দিক',
    tr: 'Üst ve alt kırma levhası yönü',
    km: 'ទិសផ្ទាំងបំបែកលើ និងក្រោម',
    es: 'Dirección de rotura de placa hacia arriba y hacia abajo',
    ar: 'اتجاه كسر اللوحة لأعلى ولأسفل',
  },
  'sideHoleMachine.coordinateValue': {
    zh: '坐标值',
    en: 'coordinate value',
    id: 'Nilai koordinat',
    kz: 'Координаталық мән',
    th: 'ค่าประสานงาน',
    ug: 'كوئوردېنات قىممىتى',
    vi: 'Giá trị tọa độ',
    zh_tc: '座標值',
    ru: 'Значение координат',
    ko: '좌표값',
    bur: 'ကိုဩဒိနိတ် တန်ဖိုး',
    ben: 'কোঅর্ডিনেট ভ্যালু',
    tr: 'Koordinat değeri',
    km: 'តម្លៃកូអរដោនេ',
    es: 'Valor de coordenadas',
    ar: 'قيمة الإحداثيات',
  },
  'sideHoleMachine.codeFormat': {
    zh: '文件编码格式',
    en: 'File encoding format',
    id: 'Format Pengkodean File',
    kz: 'Файл кодирлеу форматы',
    th: 'รูปแบบการเข้ารหัสไฟล์',
    ug: 'ھۆججەت كودلاش فورماتى',
    vi: 'Định dạng mã hóa tập tin',
    zh_tc: '文件編碼格式',
    ru: 'Формат кодирования файлов',
    ko: '파일 인코딩 형식',
    bur: 'ဖိုင် အင်ကုဒ်ဖော်မတ်',
    ben: 'ফাইল এনকোডিং ফরম্যাট',
    tr: 'Dosya kodlama biçimi',
    km: 'ទ្រង់ទ្រាយកូដឯកសារ',
    es: 'Formato de codificación de archivo',
    ar: 'تنسيق ترميز الملف',
  },
  'sideHoleMachine.suffixSetting': {
    zh: '文件后缀设置',
    en: 'File suffix setting',
    id: 'Pengaturan Suffix File',
    kz: 'Файл суффиксін орнату',
    th: 'การตั้งค่าไฟล์ต่อท้าย',
    ug: 'ھۆججەت قوشۇمچە نامى تەڭشىكى',
    vi: 'Cài đặt hậu tố tập tin',
    zh_tc: '文件後綴設置',
    ru: 'Параметры суффикса файла',
    ko: '파일 접미어 설정',
    bur: 'ဖိုင် နောက်ဆက် ဆက်တင်များ',
    ben: 'ফাইল সাফিক্স সেটিংস',
    tr: 'Dosya uzantısı ayarı',
    km: 'ការកំណត់បន្ទាប់ឯកសារ',
    es: 'Configuración de sufijo de archivo',
    ar: 'إعداد لاحقة الملف',
  },
  'sideHoleMachine.insertRow': {
    zh: '插入行',
    en: 'Insert Row',
    id: 'Masukkan baris',
    kz: 'Қатар енгізу',
    th: 'แทรกแถว',
    ug: 'قۇر قوشۇش',
    vi: 'Chèn hàng',
    zh_tc: '插入行',
    ru: 'Вставить строку',
    ko: '행 삽입',
    bur: 'အတန်း ထည့်ရန်',
    ben: 'সারি যোগ করুন',
    tr: 'Satır ekle',
    km: 'បន្ថែមជួរ',
    es: 'Insertar fila',
    ar: 'إدراج صف',
  },
  'sideHoleMachine.deleteRow': {
    zh: '删除行',
    en: 'Delete Row',
    id: 'Hapus baris',
    kz: 'Қатар өшіру',
    th: 'ลบแถว',
    ug: 'قۇر ئۆچۈرۈش',
    vi: 'Xóa hàng',
    zh_tc: '刪除行',
    ru: 'Удалить строку',
    ko: '행 삭제',
    bur: 'အတန်း ဖျက်ရန်',
    ben: 'সারি মুছুন',
    tr: 'Satır sil',
    km: 'លុបជួរ',
    es: 'Eliminar fila',
    ar: 'حذف صف',
  },
  'sideHoleMachine.equipmentParams.equipPauseCode': {
    zh: '设备暂停代码',
    en: 'Equipment Pause Code',
    id: 'Kode jeda perangkat',
    kz: 'Жабдықтар тоқтату коды',
    th: 'รหัสหยุดอุปกรณ์ชั่วคราว',
    ug: 'ئۈسكۈنە توختاش كودى',
    vi: 'Mã tạm dừng thiết bị',
    zh_tc: '設備暫停代碼',
    ru: 'Код остановки устройства',
    ko: '장치 일시 중지 코드',
    bur: 'စက်ပစ္စည်း ရပ်နားကုဒ်',
    ben: 'ইকুইপমেন্ট পজ কোড',
    tr: 'Cihaz duraklatma kodu',
    km: 'កូដផ្អាកឧបករណ៍',
    es: 'Código de pausa del equipo',
    ar: 'رمز إيقاف المعدات',
  },
  'sideHoleMachine.equipmentParams.wiggleCode': {
    zh: '摆动代码',
    en: 'Wiggle Code',
    id: 'Kode ayunan',
    kz: 'Сілкіту коды',
    th: 'รหัสสวิง',
    ug: 'تەۋرىنىش كودى',
    vi: 'Mã dao động',
    zh_tc: '擺動代碼',
    ru: 'Колебание кода',
    ko: '스윙 코드',
    bur: 'လှုပ်ယမ်းကုဒ်',
    ben: 'দোলন কোড',
    tr: 'Salınım kodu',
    km: 'កូដរមួល',
    es: 'Código de giro',
    ar: 'رمز التأرجح',
  },
  'sideHoleMachine.equipmentParams.equipStartCode': {
    zh: '设备启动代码',
    en: 'Equipment start code:',
    id: 'Kode startup perangkat',
    kz: 'Құрылғы іске қосу коды:',
    th: 'รหัสเริ่มต้นอุปกรณ์',
    ug: 'ئۈسكۈنە قوزغىتىش كودى',
    vi: 'Mã khởi động thiết bị:',
    zh_tc: '設備啟動代碼',
    ru: 'Код запуска устройства',
    ko: '장치 부트 코드',
    bur: 'စက်ပစ္စည်း စတင်ကုဒ်:',
    ben: 'যন্ত্র চালু করার কোড:',
    tr: 'Cihaz başlatma kodu:',
    km: 'កូដចាប់ផ្តើមឧបករណ៍៖',
    es: 'Código de inicio del equipo',
    ar: 'رمز بدء تشغيل المعدات',
  },
  'sideHoleMachine.equipmentParams.flipPauseCode': {
    zh: '翻面暂停代码',
    en: 'Pause code for flipping',
    id: 'Balikkan kode',
    kz: 'Өңделгені туқтату коды:',
    th: 'พลิกรหัส',
    ug: 'يۈز ئۆرۈش توختاش كودى',
    vi: 'Mã tạm dừng khi lật mặt:',
    zh_tc: '翻面暫停代碼',
    ru: 'Перевернутый код паузы',
    ko: '뒤집기 일시정지 코드',
    bur: 'လှန်ရာတွင် ရပ်နားကုဒ်',
    ben: 'ফ্লিপের জন্য পজ কোড',
    tr: 'Yüz çevirme duraklatma kodu',
    km: 'កូដផ្អាកពេលបត់មុខ',
    es: 'Código de pausa de giro',
    ar: 'رمز إيقاف الإيقاف المؤقت',
  },
  'sideHoleMachine.equipmentParams.equipEndCode': {
    zh: '设备结束代码',
    en: 'Equipment end code:',
    id: 'Kode Akhir Perangkat',
    kz: 'Құрылғы іске қою коды:',
    th: 'รหัสปลายอุปกรณ์',
    ug: 'ئۈسكۈنە ئاخىرلىشىش كودى',
    vi: 'Mã kết thúc thiết bị:',
    zh_tc: '設備結束代碼',
    ru: 'Код окончания устройства',
    ko: '장치 종료 코드',
    bur: 'စက်ပစ္စည်း အဆုံးကုဒ်:',
    ben: 'যন্ত্র শেষ করার কোড:',
    tr: 'Cihaz bitiş kodu:',
    km: 'កូដបញ្ចប់ឧបករណ៍៖',
    es: 'Código de fin del equipo',
    ar: 'رمز نهاية المعدات',
  },
  'sideHoleMachine.equipmentParams.equipStartCodePlaceholder': {
    zh: '输入设备启动代码',
    en: 'Enter the device start code',
    id: 'Masukkan kode startup perangkat',
    kz: 'Құрылғы іске қосу коды енгізу',
    th: 'ป้อนรหัสเริ่มต้นอุปกรณ์',
    ug: 'ئۈسكۈنە قوزغىتىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã khởi động thiết bị',
    zh_tc: '輸入設備啟動代碼',
    ru: 'Введите код запуска устройства',
    ko: '장치 부트 코드 입력',
    bur: 'စက်ပစ္စည်း စတင်ကုဒ်ကို ထည့်ပါ',
    ben: 'ডিভাইস স্টার্ট কোড লিখুন',
    tr: 'Cihaz başlatma kodunu girin',
    km: 'បញ្ចូលកូដចាប់ផ្តើមឧបករណ៍',
    es: 'Ingrese el código de inicio de equipo',
    ar: 'إدخال رمز بدء تشغيل المعدات',
  },
  'sideHoleMachine.equipmentParams.retractingCode': {
    zh: '收刀指令代码',
    en: 'Tool retraction command code',
    id: 'Kode perintah penarikan alat',
    kz: 'Құралды қайтару командаларының коды',
    th: 'โค้ดคำสั่งเก็บมีด',
    ug: 'پىچاق يىغىش بۇيرۇق كودى',
    vi: 'Mã lệnh rút dao',
    zh_tc: '收刀指令代碼',
    ru: 'Код команды захвата',
    ko: '수신 명령 코드',
    bur: 'ဓားပြန်ဆုတ် အမိန့်ကုဒ်',
    ben: 'টুল রিট্র্যাকশন কমান্ড কোড',
    tr: 'Bıçağı geri çekme komut kodu',
    km: 'កូដបញ្ជាដកដាវ',
    es: 'Código de comando de cierre de herramienta',
    ar: 'رمز أمر إغلاق الأداة',
  },
  'sideHoleMachine.equipmentParams.retractingCodePlaceholder': {
    zh: '输入收刀指令代码',
    en: 'Enter the tool retraction command code',
    id: 'Masukkan kode perintah penarikan alat',
    kz: 'Құралды қайтару командасының кодын енгізіңіз',
    th: 'ป้อนโค้ดคำสั่งเก็บมีด',
    ug: 'پىچاق يىغىش بۇيرۇق كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã lệnh rút dao',
    zh_tc: '輸入收刀指令代碼',
    ru: 'Введите код команды захвата.',
    ko: '수신 명령 코드 입력',
    bur: 'ဓားပြန်ဆုတ် အမိန့်ကုဒ်ကို ထည့်ပါ',
    ben: 'টুল রিট্র্যাকশন কমান্ড কোড লিখুন',
    tr: 'Bıçağı geri çekme komut kodunu girin',
    km: 'បញ្ចូលកូដបញ្ជាដកដាវ',
    es: 'Ingrese el código de comando de retracción de la herramienta',
    ar: 'رمز أمر سحب أداة الإدخال',
  },
  'sideHoleMachine.equipmentParams.flipPauseCodePlaceholder': {
    zh: '输入翻面暂停代码',
    en: 'Enter the flip pause code',
    id: 'Masukkan kode jeda flip',
    kz: 'Өңделгені туқтату коды енгізу',
    th: 'ป้อนรหัสหยุดชั่วคราว',
    ug: 'يۈز ئۆرۈش توختاش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã tạm dừng khi lật mặt',
    zh_tc: '輸入翻面暫停代碼',
    ru: 'Введите код паузы опрокидывания',
    ko: '뒤집기 일시정지 코드 입력',
    bur: 'လှန်ရာတွင် ရပ်နားကုဒ်ကို ထည့်ပါ',
    ben: 'ফ্লিপ পজ কোড লিখুন',
    tr: 'Yüz çevirme duraklatma kodunu girin',
    km: 'បញ្ចូលកូដផ្អាកពេលបត់មុខ',
    es: 'Ingrese el código de pausa de vuelco',
    ar: 'رمز الإيقاف المؤقت لقلب الإدخال',
  },
  'sideHoleMachine.equipmentParams.equipEndCodeTip': {
    zh: '输入设备结束代码',
    en: 'Enter the equipment end code',
    id: 'Masukkan Kode Akhir Perangkat',
    kz: 'Құрылғы іске қою коды енгізу',
    th: 'ป้อนรหัสปลายอุปกรณ์',
    ug: 'ئۈسكۈنە ئاخىرلىشىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã kết thúc thiết bị',
    zh_tc: '輸入設備結束代碼',
    ru: 'Введите код конца устройства',
    ko: '장치 종료 코드 입력',
    bur: 'စက်ပစ္စည်း အဆုံးကုဒ်ကို ထည့်ပါ',
    ben: 'ইকুইপমেন্ট এন্ড কোড লিখুন',
    tr: 'Cihaz bitiş kodunu girin',
    km: 'បញ្ចូលកូដបញ្ចប់ឧបករណ៍',
    es: 'Ingrese el código de fin del equipo',
    ar: 'إدخال رمز نهاية المعدات',
  },
  'sideHoleMachine.equipmentParams.sideChangeSetting': {
    zh: '侧面换面设置',
    en: 'Side change setting',
    id: 'Pengaturan facelift samping',
    kz: 'Сіделік ауыстыру орнату',
    th: 'การตั้งค่าด้านข้าง',
    ug: 'يان تەرەپ يۈز ئالماشتۇرۇش تەڭشىكى',
    vi: 'Cài đặt đổi mặt bên',
    zh_tc: '側面換面設置',
    ru: 'Параметры бокового переключения',
    ko: '측면 면 변환 설정',
    bur: 'ဘေးဖက် မျက်နှာပြောင်း ဆက်တင်',
    ben: 'সাইড ফেস চেঞ্জ সেটিং',
    tr: 'Yan yüz değiştirme ayarı',
    km: 'ការកំណត់ប្តូរមុខចំហៀង',
    es: 'Configuración de cambio lateral',
    ar: 'التغيير الجانبي الإعدادات',
  },
  'sideHoleMachine.equipmentParams.workTip': {
    zh: '默认从左侧①开始沿逆时针方向加工',
    en: 'By default, processing starts from the left side ① and proceeds in a counter-clockwise direction',
    id: 'Secara default, itu dimulai dari kiri ① di arah berlawanan arah jarum jam.',
    kz: 'Әдетте сол жақтан ① бастап, шымал бұраншқа қарай өңдеу істеу',
    th: 'โดยค่าเริ่มต้นจะเริ่มต้นจากซ้าย①ในทิศทางทวนเข็มนาฬิกา',
    ug: 'سۈكۈتتىكى ھالەتتە سول تەرەپ ①دىن باشلاپ سائەت ئىستىرېلكىسىغا قارشى يۆنىلىشتە ئىشلەش',
    vi: 'Mặc định bắt đầu từ bên trái ① theo hướng nghịch hành tròn',
    zh_tc: '默認從左側①開始沿逆時針方向加工',
    ru: 'Начать обработку по умолчанию слева ① против часовой стрелки',
    ko: '기본값은 왼쪽 ①부터 반시계 방향으로 가공',
    bur: 'စံသတ်မှတ်အနေဖြင့် ဘယ်ဘက် ① မှ စ၍ နာရီလက်တံပြန် ဦးတည်ချက်အတိုင်း ပြုပြင်သည်',
    ben: 'ডিফল্টভাবে বাম পাশে ① থেকে শুরু করে ঘড়ির কাঁটার বিপরীত দিকে প্রসেস করা হয়',
    tr: 'Varsayılan olarak soldan ① başlayarak saat yönünün tersine işler',
    km: 'លំនាំដើមចាប់ពីឆ្វេង ① ដំណើរការតាមទិសច្រាសនាឡិកា',
    es: 'De forma predeterminada, el procesamiento comienza desde la izquierda ① en el sentido contrario a las agujas del reloj',
    ar: 'افتراضيًا، تبدأ المعالجة من اليسار ① في اتجاه عكس عقارب الساعة',
  },
  'sideHoleMachine.equipmentParams.frontTurnCode': {
    zh: '上面开始代码',
    en: 'Start code above:',
    id: 'Mulai kode di atas',
    kz: 'Жоғарғы бет басталу коды:',
    th: 'เริ่มรหัสด้านบน',
    ug: 'ئۈستى يۈزى باشلىنىش كودى',
    vi: 'Mã bắt đầu mặt trên:',
    zh_tc: '上面開始代碼',
    ru: 'Сверху начинается код.',
    ko: '위 시작 코드',
    bur: 'အပေါ်ဘက် စတင်ကုဒ်:',
    ben: 'উপরের শুরু কোড:',
    tr: 'Üst yüz başlangıç kodu:',
    km: 'កូដចាប់ផ្តើមមុខលើ៖',
    es: 'Código de inicio superior',
    ar: 'رمز البداية العلوية',
  },
  'sideHoleMachine.equipmentParams.frontTurnEndCode': {
    zh: '上面结束代码',
    en: 'End code above',
    id: 'Kode akhir di atas',
    kz: 'Жоғары бет аяқталу коды:',
    th: 'รหัสปลายทางข้างต้น',
    ug: 'ئۈستى يۈزى ئاخىرلىشىش كودى',
    vi: 'Mã kết thúc mặt trên',
    zh_tc: '上面結束代碼',
    ru: 'Код окончания сверху',
    ko: '위 끝 코드',
    bur: 'အပေါ်ဘက် အဆုံးကုဒ်',
    ben: 'উপরের শেষ কোড',
    tr: 'Üst yüz bitiş kodu',
    km: 'កូដបញ្ចប់មុខលើ',
    es: 'Código de fin superior',
    ar: 'رمز النهاية العلوية',
  },
  'sideHoleMachine.equipmentParams.frontTurnCodePlaceholder': {
    zh: '输入上面开始代码',
    en: 'Enter the start code above',
    id: 'Masukkan kode mulai di atas',
    kz: 'Жоғары бет басталу коды енгізу',
    th: 'ป้อนรหัสเริ่มต้นด้านบน',
    ug: 'ئۈستى يۈزى باشلىنىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã bắt đầu mặt trên',
    zh_tc: '輸入上面開始代碼',
    ru: 'Введите код начала.',
    ko: '위 시작 코드 입력',
    bur: 'အပေါ်ဘက် စတင်ကုဒ်ကို ထည့်ပါ',
    ben: 'উপরের শুরু কোড লিখুন',
    tr: 'Üst yüz başlangıç kodunu girin',
    km: 'បញ្ចូលកូដចាប់ផ្តើមមុខលើ',
    es: 'Ingrese el código de inicio superior',
    ar: 'أدخل رمز البداية العلوية',
  },
  'sideHoleMachine.equipmentParams.frontTurnEndCodePlaceholder': {
    zh: '输入上面结束代码',
    en: 'Enter the end code above',
    id: 'Masukkan kode akhir di atas',
    kz: 'Жоғары бет аяқталу коды енгізу',
    th: 'ป้อนรหัสท้ายด้านบน',
    ug: 'ئۈستى يۈزى ئاخىرلىشىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã kết thúc mặt trên',
    zh_tc: '輸入上面結束代碼',
    ru: 'Введите код конца.',
    ko: '위 종료 코드 입력',
    bur: 'အပေါ်ဘက် အဆုံးကုဒ်ကို ထည့်ပါ',
    ben: 'উপরের শেষ কোড লিখুন',
    tr: 'Üst yüz bitiş kodunu girin',
    km: 'បញ្ចូលកូដបញ្ចប់មុខលើ',
    es: 'Ingrese el código de inicio izquierdo',
    ar: 'أدخل رمز النهاية العلوية',
  },
  'sideHoleMachine.equipmentParams.leftTurnCode': {
    zh: '左面开始代码',
    en: 'Left start code:',
    id: 'Mulai kode di sebelah kiri',
    kz: 'Сол бет басталу коды:',
    th: 'เริ่มรหัสทางด้านซ้าย',
    ug: 'سول يۈزى باشلىنىش كودى',
    vi: 'Mã bắt đầu mặt trái:',
    zh_tc: '左面開始代碼',
    ru: 'Код начала слева',
    ko: '왼쪽 시작 코드',
    bur: 'ဘယ်ဘက် စတင်ကုဒ်:',
    ben: 'বাম পাশের শুরু কোড:',
    tr: 'Sol yüz başlangıç kodu:',
    km: 'កូដចាប់ផ្តើមមុខឆ្វេង៖',
    es: 'Código de inicio izquierdo',
    ar: 'رمز البداية اليسرى',
  },
  'sideHoleMachine.equipmentParams.leftTurnEndCode': {
    zh: '左面结束代码',
    en: 'Left end code:',
    id: 'Kode akhir di sebelah kiri',
    kz: 'Сол бет аяқталу коды:',
    th: 'รหัสสิ้นสุดทางด้านซ้าย',
    ug: 'سول يۈزى ئاخىرلىشىش كودى',
    vi: 'Mã kết thúc mặt trái:',
    zh_tc: '左面結束代碼',
    ru: 'Код конца слева',
    ko: '왼쪽 끝 코드',
    bur: 'ဘယ်ဘက် အဆုံးကုဒ်:',
    ben: 'বাম পাশের শেষ কোড:',
    tr: 'Sol yüz bitiş kodu:',
    km: 'កូដបញ្ចប់មុខឆ្វេង៖',
    es: 'Código de fin izquierdo',
    ar: 'رمز النهاية اليسرى',
  },
  'sideHoleMachine.equipmentParams.leftTurnCodePlaceholder': {
    zh: '输入左面开始代码',
    en: 'Enter the left start code',
    id: 'Masukkan kode start di sebelah kiri',
    kz: 'Сол бет басталу коды енгізу',
    th: 'ป้อนรหัสเริ่มด้านซ้าย',
    ug: 'سول يۈزى باشلىنىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã bắt đầu mặt trái',
    zh_tc: '輸入左面開始代碼',
    ru: 'Введите код начала слева',
    ko: '왼쪽 시작 코드 입력',
    bur: 'ဘယ်ဘက် စတင်ကုဒ်ကို ထည့်ပါ',
    ben: 'বাম পাশের শুরু কোড লিখুন',
    tr: 'Sol yüz başlangıç kodunu girin',
    km: 'បញ្ចូលកូដចាប់ផ្តើមមុខឆ្វេង',
    es: 'Ingrese el código de inicio izquierdo',
    ar: 'أدخل رمز البداية اليسرى',
  },
  'sideHoleMachine.equipmentParams.leftTurnEndCodePlaceholder': {
    zh: '输入左面结束代码',
    en: 'Enter the left end code',
    id: 'Masukkan kode akhir di sebelah kiri',
    kz: 'Сол бет аяқталу коды енгізу',
    th: 'ป้อนรหัสสิ้นสุดทางด้านซ้าย',
    ug: 'سول يۈزى ئاخىرلىشىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã kết thúc mặt trái',
    zh_tc: '輸入左面結束代碼',
    ru: 'Введите код конца слева',
    ko: '왼쪽 끝 코드 입력',
    bur: 'ဘယ်ဘက် အဆုံးကုဒ်ကို ထည့်ပါ',
    ben: 'বাম পাশের শেষ কোড লিখুন',
    tr: 'Sol yüz bitiş kodunu girin',
    km: 'បញ្ចូលកូដបញ្ចប់មុខឆ្វេង',
    es: 'Ingrese el código de fin izquierdo',
    ar: 'أدخل رمز النهاية اليسرى',
  },
  'sideHoleMachine.equipmentParams.downTurnCode': {
    zh: '下面开始代码',
    en: 'The following is the code:',
    id: 'Mulai kode di bawah ini',
    kz: 'Төменгі бет басталу коды:',
    th: 'เริ่มรหัสด้านล่าง',
    ug: 'ئاستى يۈزى باشلىنىش كودى',
    vi: 'Mã bắt đầu mặt dưới:',
    zh_tc: '下面開始代碼',
    ru: 'Ниже начинается код.',
    ko: '다음 시작 코드',
    bur: 'အောက်ဘက် စတင်ကုဒ်:',
    ben: 'নিচের শুরু কোড:',
    tr: 'Alt yüz başlangıç kodu:',
    km: 'កូដចាប់ផ្តើមមុខក្រោម៖',
    es: 'Código inicial a continuación',
    ar: 'رمز البداية أدناه',
  },
  'sideHoleMachine.equipmentParams.downTurnEndCode': {
    zh: '下面结束代码',
    en: 'End code below:',
    id: 'Kode akhir berikut',
    kz: 'Төменгі бет аяқталу коды:',
    th: 'รหัสสิ้นสุดต่อไปนี้',
    ug: 'ئاستى يۈزى ئاخىرلىشىش كودى',
    vi: 'Mã kết thúc mặt dưới:',
    zh_tc: '下面結束代碼',
    ru: 'Конец кода ниже',
    ko: '다음 종료 코드',
    bur: 'အောက်ဘက် အဆုံးကုဒ်:',
    ben: 'নিচের শেষ কোড:',
    tr: 'Alt yüz bitiş kodu:',
    km: 'កូដបញ្ចប់មុខក្រោម៖',
    es: 'Código final a continuación',
    ar: 'رمز النهاية أدناه',
  },
  'sideHoleMachine.equipmentParams.downTurnCodePlaceholder': {
    zh: '输入下面开始代码',
    en: 'Enter the following start code',
    id: 'Masukkan kode mulai berikut',
    kz: 'Төменгі бет басталу коды енгізу',
    th: 'ป้อนรหัสเริ่มต้นต่อไปนี้',
    ug: 'ئاستى يۈزى باشلىنىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã bắt đầu mặt dưới',
    zh_tc: '輸入下面開始代碼',
    ru: 'Введите начальный код ниже',
    ko: '다음 시작 코드 입력',
    bur: 'အောက်ဘက် စတင်ကုဒ်ကို ထည့်ပါ',
    ben: 'নিচের শুরু কোড লিখুন',
    tr: 'Alt yüz başlangıç kodunu girin',
    km: 'បញ្ចូលកូដចាប់ផ្តើមមុខក្រោម',
    es: 'Ingrese el código inicial a continuación',
    ar: 'أدخل رمز البداية أدناه',
  },
  'sideHoleMachine.equipmentParams.downTurnEndCodePlaceholder': {
    zh: '输入下面结束代码',
    en: 'Enter the following end code',
    id: 'Masukkan kode akhir berikut',
    kz: 'Төменгі бет аяқталу коды енгізу',
    th: 'ป้อนรหัสสิ้นสุดต่อไปนี้',
    ug: 'ئاستى يۈزى ئاخىرلىشىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã kết thúc mặt dưới',
    zh_tc: '輸入下面結束代碼',
    ru: 'Введите код конца',
    ko: '다음 종료 코드 입력',
    bur: 'အောက်ဘက် အဆုံးကုဒ်ကို ထည့်ပါ',
    ben: 'নিচের শেষ কোড লিখুন',
    tr: 'Alt yüz bitiş kodunu girin',
    km: 'បញ្ចូលកូដបញ្ចប់មុខក្រោម',
    es: 'Ingrese el código final a continuación',
    ar: 'أدخل رمز النهاية أدناه',
  },
  'sideHoleMachine.equipmentParams.rightTurnCode': {
    zh: '右面开始代码',
    en: 'Right-hand start code:',
    id: 'Mulai kode di sebelah kanan',
    kz: 'Уң бет басталу коды:',
    th: 'เริ่มรหัสทางด้านขวา',
    ug: 'ئوڭ يۈزى باشلىنىش كودى',
    vi: 'Mã bắt đầu mặt phải:',
    zh_tc: '右面開始代碼',
    ru: 'Код начала справа',
    ko: '오른쪽 시작 코드',
    bur: 'ညာဘက် စတင်ကုဒ်:',
    ben: 'ডান পাশের শুরু কোড:',
    tr: 'Sağ yüz başlangıç kodu:',
    km: 'កូដចាប់ផ្តើមមុខស្តាំ៖',
    es: 'Código inicial derecho',
    ar: 'رمز البداية اليمنى',
  },
  'sideHoleMachine.equipmentParams.rightTurnEndCode': {
    zh: '右面结束代码',
    en: 'Right end code:',
    id: 'Kode akhir di sebelah kanan',
    kz: 'Уң бет аяқталу коды:',
    th: 'รหัสสิ้นสุดทางด้านขวา',
    ug: 'ئوڭ يۈزى ئاخىرلىشىش كودى',
    vi: 'Mã kết thúc mặt phải:',
    zh_tc: '右面結束代碼',
    ru: 'Код конца справа',
    ko: '오른쪽 끝 코드',
    bur: 'ညာဘက် အဆုံးကုဒ်:',
    ben: 'ডান পাশের শেষ কোড:',
    tr: 'Sağ yüz bitiş kodu:',
    km: 'កូដបញ្ចប់មុខស្តាំ៖',
    es: 'Código final derecho',
    ar: 'رمز النهاية اليمنى',
  },
  'sideHoleMachine.equipmentParams.rightTurnCodePlaceholder': {
    zh: '输入右面开始代码',
    en: 'Enter the right start code',
    id: 'Masukkan kode start di sebelah kanan',
    kz: 'Уң бет басталу коды енгізу',
    th: 'ป้อนรหัสเริ่มทางด้านขวา',
    ug: 'ئوڭ يۈزى باشلىنىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã bắt đầu mặt phải',
    zh_tc: '輸入右面開始代碼',
    ru: 'Введите код начала справа',
    ko: '오른쪽 시작 코드 입력',
    bur: 'ညာဘက် စတင်ကုဒ်ကို ထည့်ပါ',
    ben: 'ডান পাশের শুরু কোড লিখুন',
    tr: 'Sağ yüz başlangıç kodunu girin',
    km: 'បញ្ចូលកូដចាប់ផ្តើមមុខស្តាំ',
    es: 'Ingrese el código inicial derecho',
    ar: 'أدخل رمز البداية اليمنى',
  },
  'sideHoleMachine.equipmentParams.rightTurnEndCodePlaceholder': {
    zh: '输入右面结束代码',
    en: 'Enter the right end code',
    id: 'Masukkan kode akhir di sebelah kanan',
    kz: 'Уң бет аяқталу коды енгізу',
    th: 'ป้อนรหัสสิ้นสุดทางด้านขวา',
    ug: 'ئوڭ يۈزى ئاخىرلىشىش كودىنى كىرگۈزۈڭ',
    vi: 'Nhập mã kết thúc mặt phải',
    zh_tc: '輸入右面結束代碼',
    ru: 'Введите код конца справа',
    ko: '오른쪽 끝 코드 입력',
    bur: 'ညာဘက် အဆုံးကုဒ်ကို ထည့်ပါ',
    ben: 'ডান পাশের শেষ কোড লিখুন',
    tr: 'Sağ yüz bitiş kodunu girin',
    km: 'បញ្ចូលកូដបញ្ចប់មុខស្តាំ',
    es: 'Ingrese el código final derecho',
    ar: 'أدخل رمز النهاية اليمنى',
  },
  'sideHoleMachine.equipmentParams.topFlipCode': {
    zh: '翻面代码 - 上',
    en: 'Flip Code - Top',
    id: 'Kode Flip - Top',
    kz: 'Өңделгені коды - жоғары',
    th: 'รหัสพลิก - ด้านบน',
    ug: 'يۈز ئۆرۈش كودى - ئۈستى',
    vi: 'Mã lật mặt - trên',
    zh_tc: '翻面代碼 - 上',
    ru: 'Код опрокидывания - вверх',
    ko: '뒤집기 코드. - 위.',
    bur: 'လှန်ကုဒ် - အပေါ်',
    ben: 'ফ্লিপ কোড - উপর',
    tr: 'Yüz çevirme kodu - üst',
    km: 'កូដបត់មុខ - លើ',
    es: 'Código invertido - superior',
    ar: 'رمز الوجه - العلوي',
  },
  'sideHoleMachine.equipmentParams.downFlipCode': {
    zh: '翻面代码 - 下',
    en: 'Flip Code - Down',
    id: 'Kode Flip - Berikutnya',
    kz: 'Өңделгені коды - төмен',
    th: 'รหัสพลิก - ถัดไป',
    ug: 'يۈز ئۆرۈش كودى - ئاستى',
    vi: 'Mã lật mặt - dưới',
    zh_tc: '翻面代碼 - 下',
    ru: 'Код поворота - вниз',
    ko: '코드 뒤집기 - 아래',
    bur: 'လှန်ကုဒ် - အောက်',
    ben: 'ফ্লিপ কোড - নিচ',
    tr: 'Yüz çevirme kodu - alt',
    km: 'កូដបត់មុខ - ក្រោម',
    es: 'Código invertido - inferior',
    ar: 'رمز الوجه - السفلي',
  },
  'sideHoleMachine.equipmentParams.leftFlipCode': {
    zh: '翻面代码 - 左',
    en: 'Flip Code - Left',
    id: 'Kode flip - kiri',
    kz: 'Өңделгені коды - сол',
    th: 'รหัสพลิก - ซ้าย',
    ug: 'يۈز ئۆرۈش كودى - سول',
    vi: 'Mã lật mặt - trái',
    zh_tc: '翻面代碼 - 左',
    ru: 'Код поворота - слева',
    ko: '뒤집기 코드 - 왼쪽',
    bur: 'လှန်ကုဒ် - ဘယ်',
    ben: 'ফ্লিপ কোড - বাম',
    tr: 'Yüz çevirme kodu - sol',
    km: 'កូដបត់មុខ - ឆ្វេង',
    es: 'Código invertido - izquierda',
    ar: 'رمز الوجه - اليسار',
  },
  'sideHoleMachine.equipmentParams.rightFlipCode': {
    zh: '翻面代码 - 右',
    en: 'Flip Code - Right',
    id: 'Kode Flip - Benar',
    kz: 'Өңделгені коды - уң',
    th: 'รหัสพลิก - ขวา',
    ug: 'يۈز ئۆرۈش كودى - ئوڭ',
    vi: 'Mã lật mặt - phải',
    zh_tc: '翻面代碼 - 右',
    ru: 'Код поворота - справа',
    ko: '뒤집기 코드 - 오른쪽',
    bur: 'လှန်ကုဒ် - ညာ',
    ben: 'ফ্লিপ কোড - ডান',
    tr: 'Yüz çevirme kodu - sağ',
    km: 'កូដបត់មុខ - ស្តាំ',
    es: 'Código invertido - derecho',
    ar: 'رمز الدوران - اليمين',
  },
  'sideHoleMachine.equipmentParams.cylinderOutCode': {
    zh: '气缸推出代码',
    en: 'cylinder out code',
    id: 'Kode peluncuran silinder',
    kz: 'Цилиндр шығус коды',
    th: 'รหัสเปิดตัวทรงกระบอก',
    ug: 'سىلىندىر ئىتتىرىش كودى',
    vi: 'Mã tung xi lanh',
    zh_tc: '氣缸推出代碼',
    ru: 'Код выпуска цилиндра',
    ko: '실린더 출시 코드',
    bur: 'ဆီလင်ဒါ ထုတ်ကုဒ်',
    ben: 'সিলিন্ডার আউট কোড',
    tr: 'Silindir çıkarma kodu',
    km: 'កូដរុញស៊ីលីនដែរចេញ',
    es: 'Código de extracción del cilindro',
    ar: 'رمز دفع الأسطوانة',
  },
  'sideHoleMachine.equipmentParams.cylinderbackCode': {
    zh: '气缸收回代码',
    en: 'Cylinder retract code',
    id: 'Kode Pengambilan Silinder',
    kz: 'Цилиндр қайтару коды',
    th: 'รหัสดึงกระบอกสูบ',
    ug: 'سىلىندىر قايتۇرۇش كودى',
    vi: 'Mã thu xi lanh',
    zh_tc: '氣缸收回代碼',
    ru: 'Код возврата цилиндров',
    ko: '실린더 회수 코드',
    bur: 'ဆီလင်ဒါ ပြန်ဆုတ်ကုဒ်',
    ben: 'সিলিন্ডার রিট্র্যাক্ট কোড',
    tr: 'Silindir geri çekme kodu',
    km: 'កូដដកស៊ីលីនដែរត្រឡប់',
    es: 'Código de retracción del cilindro',
    ar: 'رمز تراجع الأسطوانة',
  },
  'sideHoleMachine.equipmentParams.cylinderbackDirective': {
    zh: '气缸收回指令',
    en: 'Cylinder retract command',
    id: 'Instruksi retraksi silinder',
    kz: 'Цилиндр қайтару нұсқаулығы',
    th: 'คำแนะนำในการหดตัวของกระบอกสูบ',
    ug: 'سىلىندىر قايتۇرۇش بۇيرۇقى',
    vi: 'Chỉ thị thu xi lanh',
    zh_tc: '氣缸收回指令',
    ru: 'команда возврата цилиндров',
    ko: '실린더 회수 명령',
    bur: 'ဆီလင်ဒါ ပြန်ဆုတ် အမိန့်',
    ben: 'সিলিন্ডার রিট্র্যাক্ট কমান্ড',
    tr: 'Silindir geri çekme komutu',
    km: 'បញ្ជាដកស៊ីលីនដែរត្រឡប់',
    es: 'Comando de retracción del cilindro',
    ar: 'أمر تراجع الأسطوانة',
  },
  'sideHoleMachine.equipmentParams.moveDirective': {
    zh: '移动指令',
    en: 'Move Instruction',
    id: 'Pindahkan perintah',
    kz: 'Қозғалыс нұсқаулығы',
    th: 'ย้ายคำสั่ง',
    ug: 'يۆتكەش بۇيرۇقى',
    vi: 'Chỉ thị di chuyển',
    zh_tc: '移動指令',
    ru: 'Переместить команду',
    ko: '이동 명령',
    bur: 'ရွှေ့ရန် အမိန့်',
    ben: 'মুভ নির্দেশ',
    tr: 'Hareket komutu',
    km: 'បញ្ជាផ្លាស់ទី',
    es: 'Comando de movimiento',
    ar: 'أمر الحركة',
  },
  'sideHoleMachine.equipmentParams.moveAxisCode': {
    zh: '移动轴',
    en: 'Move Axis',
    id: 'Pindahkan sumbu',
    kz: 'Қозғалыс ось',
    th: 'เลื่อนแกน',
    ug: 'يۆتكىلىش ئوقى',
    vi: 'Trục di chuyển',
    zh_tc: '移動軸',
    ru: 'Переместить ось',
    ko: '축 이동',
    bur: 'ရွှေ့ အက်ဆစ်',
    ben: 'মুভ অ্যাক্সিস',
    tr: 'Eksen hareketi',
    km: 'ចលនាអ័ក្ស',
    es: 'Eje de movimiento',
    ar: 'محور الحركة',
  },
  'sideHoleMachine.equipmentParams.pushAxisCode': {
    zh: '气缸推动轴',
    en: 'Cylinder push axis',
    id: 'Poros dorong silinder',
    kz: 'Цилиндр қозғалту ось',
    th: 'เพลาดันกระบอกสูบ',
    ug: 'سىلىندىر ئىتتىرىش ئوقى',
    vi: 'Trục đẩy xi lanh',
    zh_tc: '氣缸推動軸',
    ru: 'вал толкателя цилиндра',
    ko: '실린더 추진축',
    bur: 'ဆီလင်ဒါ တွန်းအက်ဆစ်',
    ben: 'সিলিন্ডার পুশ অ্যাক্সিস',
    tr: 'Silindir itme ekseni',
    km: 'អ័ក្សរុញស៊ីលីនដែរ',
    es: 'Eje de empuje del cilindro',
    ar: 'محور دفع الأسطوانة',
  },
  'sideHoleMachine.equipmentParams.swingAxisCode': {
    zh: '摆动轴',
    en: 'swing axis',
    id: 'Poros ayunan',
    kz: 'Кыймылдан ось',
    th: 'เพลาแกว่ง',
    ug: 'تەۋرىنىش ئوقى',
    vi: 'Trục dao động',
    zh_tc: '擺動軸',
    ru: 'Колебательный вал',
    ko: '진동축',
    bur: 'လှုပ်ယမ်းအက်ဆစ်',
    ben: 'সুইং অ্যাক্সিস',
    tr: 'Salınım ekseni',
    km: 'អ័ក្សរមួល',
    es: 'Eje de giro',
    ar: 'محور التأرجح',
  },
  'sideHoleMachine.equipmentParams.moveCode': {
    zh: '移动代码',
    en: 'Move Code',
    id: 'Kode seluler',
    kz: 'Қозғалыс коды',
    th: 'รหัสมือถือ',
    ug: 'يۆتكىلىش كودى',
    vi: 'Mã di chuyển',
    zh_tc: '移動代碼',
    ru: 'Мобильный код',
    ko: '코드 이동',
    bur: 'ရွှေ့ကုဒ်',
    ben: 'মুভ কোড',
    tr: 'Hareket kodu',
    km: 'កូដផ្លាស់ទី',
    es: 'Código de movimiento',
    ar: 'رمز الحركة',
  },
  'sideHoleMachine.equipmentParams.punchCode': {
    zh: '加工代码',
    en: 'Processing Code',
    id: 'Kode pemrosesan',
    kz: 'Өңдеу коды',
    th: 'รหัสประมวลผล',
    ug: 'ئىشلەش كودى',
    vi: 'Mã gia công',
    zh_tc: '加工代碼',
    ru: 'Код обработки',
    ko: '가공 코드',
    bur: 'ပြုပြင်မှုကုဒ်',
    ben: 'মেশিনিং কোড',
    tr: 'İşleme kodu',
    km: 'កូដដំណើរការ',
    es: 'Código de procesamiento',
    ar: 'رمز المعالجة',
  },
  'sideHoleMachine.equipmentParams.free': {
    zh: '空走',
    en: 'free walk',
    id: 'Jalan kosong',
    kz: 'Бос жүру',
    th: 'เดินว่างเปล่า',
    ug: 'قۇرۇق يۈرۈش',
    vi: 'Di chuyển không gia công',
    zh_tc: '空走',
    ru: 'Пусто.',
    ko: '헛걸음',
    bur: 'ဗလာသွား',
    ben: 'খালি চলাচল',
    tr: 'Boşta gezinme',
    km: 'ដើរទទេ',
    es: 'Movimiento inactivo',
    ar: 'حركة الخمول',
  },
  'sideHoleMachine.equipmentParams.punchPart': {
    zh: '加工部分',
    en: 'Processing part',
    id: 'Bagian pemrosesan',
    kz: 'Өңдеу бөлім',
    th: 'การประมวลผล',
    ug: 'ئىشلەش قىسمى',
    vi: 'Phần gia công',
    zh_tc: '加工部分',
    ru: 'Обрабатывающая часть',
    ko: '가공 부분',
    bur: 'ပြုပြင်မှု အပိုင်း',
    ben: 'মেশিনিং অংশ',
    tr: 'İşleme bölümü',
    km: 'ផ្នែកដំណើរការ',
    es: 'Pieza de procesamiento',
    ar: 'جزء المعالجة',
  },
  'sideHoleMachine.equipmentParams.cutFaceCode': {
    zh: '加工平面代码',
    en: 'Processing plane code',
    id: 'Memproses kode pesawat',
    kz: 'Тасқышты оңдеу коды',
    th: 'ประมวลผลรหัสเครื่องบิน',
    ug: 'ئىشلەش تەكشىلىك كودى',
    vi: 'Mã gia công mặt phẳng',
    zh_tc: '加工平面代碼',
    ru: 'Обработка плоского кода',
    ko: '가공 평면 코드',
    bur: 'ပြုပြင် ပလိန်းကုဒ်',
    ben: 'প্রসেসিং প্লেন কোড',
    tr: 'İşleme düzlemi kodu',
    km: 'កូដប្លង់ដំណើរការ',
    es: 'Código de plano de procesamiento',
    ar: 'رمز مستوى المعالجة',
  },
  'sideHoleMachine.equipmentParams.horVerCutFace': {
    zh: '横向纵向平面',
    en: 'Horizontal and vertical plane',
    id: 'Bidang horizontal',
    kz: 'Кері-жұмысқышты тасы',
    th: 'ระนาบแนวนอน',
    ug: 'توغرىسىغا-بويىغا تەكشىلىكى',
    vi: 'Mặt phẳng ngang và dọc',
    zh_tc: '橫向縱向平面',
    ru: 'Горизонтальная продольная плоскость',
    ko: '가로 세로 평면',
    bur: 'အလျားလိုက်/ဒေါင်လိုက် ပလိန်း',
    ben: 'হরাইজন্টাল ও ভার্টিক্যাল প্লেন',
    tr: 'Yatay ve dikey düzlem',
    km: 'ប្លង់ផ្ដេក និងបញ្ឈរ',
    es: 'Plano longitudinal horizontal',
    ar: 'المستوى الطولي الأفقي',
  },
  'sideHoleMachine.equipmentParams.horCutFace': {
    zh: '横向升降平面',
    en: 'Horizontal lifting plane',
    id: 'Pesawat pengangkat silang',
    kz: 'Кері-тұру тасы',
    th: 'ระนาบข้าม',
    ug: 'توغرىسىغا-كۆتۈرۈش تەكشىلىكى',
    vi: 'Mặt phẳng ngang',
    zh_tc: '橫向升降平面',
    ru: 'плоскость поперечного подъёма',
    ko: '가로 리프트 평면',
    bur: 'အလျားလိုက်/အမြင့်-အနိမ့် ပလိန်း',
    ben: 'হরাইজন্টাল লিফটিং প্লেন',
    tr: 'Yatay yükselti düzlemi',
    km: 'ប្លង់ផ្ដេក និងឡើងចុះ',
    es: 'Plano de elevación horizontal',
    ar: 'مستوى الرفع الأفقي',
  },
  'sideHoleMachine.equipmentParams.verCutFace': {
    zh: '纵向升降平面',
    en: 'Vertical lifting plane',
    id: 'Pesawat pengangkat longitudinal',
    kz: 'Жұмысқышты-тұру тасы',
    th: 'ระนาบยกยาว',
    ug: 'بويىغا-كۆتۈرۈش تەكشىلىكى',
    vi: 'Mặt phẳng dọc',
    zh_tc: '縱向升降平面',
    ru: 'Вертикальная плоскость подъёма',
    ko: '수직 승강 평면',
    bur: 'ဒေါင်လိုက်/အမြင့်-အနိမ့် ပလိန်း',
    ben: 'ভার্টিক্যাল লিফটিং প্লেন',
    tr: 'Dikey yükselti düzlemi',
    km: 'ប្លង់បញ្ឈរ និងឡើងចុះ',
    es: 'Plano de elevación longitudinal',
    ar: 'مستوى الرفع الطولي',
  },
  'sideHoleMachine.equipmentParams.specifySmallBoardMaterialNoCut': {
    zh: '指定小板材质不下料',
    en: 'Specify small board material no cutting',
    id: 'Tentukan bahan papan kecil tidak memotong',
    kz: 'Кіші тақта материалын кесуге белгілеу',
    th: 'ระบุวัสดุแผ่นเล็กไม่ตัด',
    ug: 'كىچىك تاختا ماتېرىيالىنى كەسمەسلىككە بەلگىلەش',
    vi: 'Chỉ định vật liệu tấm nhỏ không cắt',
    zh_tc: '指定小板材質不下料',
    ru: 'Выберите материал без',
    ko: '판넬 재료가 재료가 들어가지 않도록 지정',
    bur: 'သတ်မှတ်ထားသော သေးငယ်ဘုတ် ပစ္စည်း မဖြတ်တောက်',
    ben: 'নির্দিষ্ট ছোট বোর্ড মেটেরিয়াল কাটবে না',
    tr: 'Belirtilen küçük levha malzemesinde kesim yok',
    km: 'សម្ភារៈផ្ទាំងតូចដែលបានកំណត់មិនកាត់',
    es: 'Especifique el material de placa pequeña y no lo deje en blanco',
    ar: 'حدد مادة اللوحة الصغيرة ولا تكون فارغة',
  },
  'sideHoleMachine.equipmentParams.specifySmallBoardMaterialNoCutTip': {
    zh: '板件材质中含有对应关键词的板件便只会生成五六面钻加工的孔槽文件，不会下料',
    en: 'Planks containing corresponding keywords in the material will only generate hole and slot files processed by 5/6-sided drill, no cutting',
    id: 'Papan yang mengandung kata kunci yang sesuai dalam bahan hanya akan menghasilkan file lubang dan slot yang diproses oleh bor 5/6 sisi, tidak memotong',
    kz: 'Материалда сәйкес кілт сөздері бар тақта тек 5/6 жақты бұрғылаумен өңделген тесік және ойық файлдарын ғана жасайды, кесбейді',
    th: 'แผ่นที่มีคำหลักที่สอดคล้องกันในวัสดุจะสร้างไฟล์รูและช่องที่ประมวลผลโดยสว่าน 5/6 ด้านเท่านั้น ไม่ตัด',
    ug: 'ماتېرىيالدا مۇناسىۋەتلىك ئاچقۇچ سۆز بار بولغان تاختا پەقەت 5/6 يۈزلۈك پارمان بىلەن بىر تەرەپ قىلىنغان تۆشۈك ۋە ئۇيۇق ھۆججىتىنى ھاسىل قىلىدۇ، كەسمەيدۇ',
    vi: 'Tấm có từ khóa tương ứng trong vật liệu sẽ chỉ tạo file lỗ và rãnh được xử lý bởi khoan 5/6 mặt, không cắt',
    zh_tc:
      '板件材質中含有對應關鍵詞的板件便只會生成五六面鑽加工的孔槽文件，不會下料',
    ru: 'Пластина, содержащая соответствующие ключевые слова в материале пластины, будет генерировать только пять или шесть поверхностей для обработки файла отверстия, без раскрутки',
    ko: '판재 재료에 해당하는 키워드가 포함된 판재는 5, 6면 드릴로 가공된 구멍 슬롯 파일만 생성되며 재료를 넣지 않습니다.',
    bur: 'ပစ္စည်းအမျိုးအစားတွင် သက်ဆိုင်ရာ ကီးဝေါ့ဒ် ပါရှိသော ဘုတ်များသည် ၅/၆ မျက်နှာဒရင်ဖြင့် ပြုပြင်ထားသော အပေါက်/ချောင်း ဖိုင်များသာ ထုတ်ပေးမည်၊ မဖြတ်တောက်ပါ',
    ben: 'মেটেরিয়ালে সংশ্লিষ্ট কীওয়ার্ড থাকা বোর্ডগুলোতে শুধু ৫/৬-ফেস ড্রিল দিয়ে মেশিনিং করা হোল/স্লট ফাইল তৈরি হবে, কাটিং হবে না',
    tr: 'Malzeme içinde ilgili anahtar kelimeler bulunan levhalar yalnızca 5/6 yüz delik işleminden delik ve yuva dosyası üretir, kesim olmaz',
    km: 'ផ្ទាំងដែលមានពាក្យគន្លឹះត្រូវនៅក្នុងសម្ភារៈ បង្កើតតែឯកសាររន្ធ/រណ្តៅដោយដ្រូល ៥/៦ មុខ គ្មានការកាត់',
    es: 'Los paneles con las palabras clave correspondientes en el material de la placa solo generarán archivos de ranuras para perforación de cinco o seis lados y no dejarán en blanco',
    ar: 'الألواح التي تحتوي على كلمات رئيسية مقابلة في مادة اللوحة سوف تولد فقط ملفات فتحة ثقب للحفر بخمسة أو ستة جوانب ولن تكون فارغة',
  },
  'sideHoleMachine.equipmentParams.addMaterialKeyword': {
    zh: '添加材质关键词',
    en: 'Add material keyword',
    id: 'Tambah kata kunci bahan',
    kz: 'Материал кілт сөзін қосу',
    th: 'เพิ่มคำหลักวัสดุ',
    ug: 'ماتېرىيال ئاچقۇچ سۆزى قوشۇش',
    vi: 'Thêm từ khóa vật liệu',
    zh_tc: '添加材質關鍵詞',
    ru: 'Добавить ключевые слова материала',
    ko: '재료 키워드 추가',
    bur: 'ပစ္စည်း ကီးဝေါ့ဒ် ထည့်ပါ',
    ben: 'মেটেরিয়াল কীওয়ার্ড যোগ করুন',
    tr: 'Malzeme anahtar kelimesi ekle',
    km: 'បន្ថែមពាក្យគន្លឹះសម្ភារៈ',
    es: 'Agregar palabras clave de material',
    ar: 'إضافة كلمات رئيسية للمادة',
  },
  'sideHoleMachine.equipmentParams.keyword': {
    zh: '关键词',
    en: 'Keyword',
    id: 'Kata kunci',
    kz: 'Кілт сөз',
    th: 'คำหลัก',
    ug: 'ئاچقۇچ سۆز',
    vi: 'Từ khóa',
    zh_tc: '關鍵詞',
    ru: 'ключевые слова',
    ko: '키워드',
    bur: 'ကီးဝေါ့ဒ်',
    ben: 'কীওয়ার্ড',
    tr: 'Anahtar kelime',
    km: 'ពាក្យគន្លឹះ',
    es: 'Palabras clave',
    ar: 'الكلمات الرئيسية',
  },
  'sideHoleMachine.tagPool': {
    zh: '数据标签池',
    en: 'Data tag pool',
    id: 'Kumpulan tag data',
    kz: 'Деректеріңіздің белгілері',
    th: 'พูลแท็กข้อมูล',
    ug: 'سانلىق مەلۇمات بەلگە ئامبىرى',
    vi: 'Hồ bơi nhãn dữ liệu',
    zh_tc: '數據標籤池',
    ru: 'Пул тегов данных',
    ko: '데이터 태그 풀',
    bur: 'ဒေတာ တက်ဂ် အစု',
    ben: 'ডেটা ট্যাগ পুল',
    tr: 'Veri etiket havuzu',
    km: 'អាងស្លាកទិន្នន័យ',
    es: 'Grupo de etiquetas de datos',
    ar: 'تجمع علامات البيانات',
  },
  'sideHoleMachine.dragTip': {
    zh: '可拖拽标签池内标签',
    en: 'Drag the label in the label pool',
    id: 'Tag drag-drop di tag pool',
    kz: 'Белгілерді сүйреп таңдау',
    th: 'แท็ก Drag-Drop ในพูลแท็ก',
    ug: 'بەلگە ئامبىرىدىكى بەلگىلەرنى سۆرەپ يۆتكىگىلى بولىدۇ',
    vi: 'Có thể kéo nhãn từ hồ bơi nhãn dữ liệu',
    zh_tc: '可拖拽標籤池內標籤',
    ru: 'Можно перетаскивать вкладки внутри пула',
    ko: '드래그 가능 태그 풀 내 태그',
    bur: 'တက်ဂ်အစုအတွင်းရှိ တက်ဂ်များကို ဆွဲယူနိုင်သည်',
    ben: 'ট্যাগ পুলের ট্যাগগুলো ড্র্যাগ করা যাবে',
    tr: 'Etiket havuzundaki etiketleri sürükleyin',
    km: 'អាចអូសស្លាកក្នុងអាងស្លាក',
    es: 'Las etiquetas en el grupo de etiquetas se pueden arrastrar y soltar',
    ar: 'يمكن سحب العلامات الموجودة في تجمع العلامات وإسقاطها',
  },
  'sideHoleMachine.knives': {
    zh: '加工刀具：',
    en: 'Processing tools:',
    id: 'Alat pemrosesan:',
    kz: 'Өңдеу құрал:',
    th: 'เครื่องมือการประมวลผล:',
    ug: 'ئىشلەش پىچىقى:',
    vi: 'Công cụ gia công:',
    zh_tc: '加工刀具：',
    ru: 'Обрабатывающий нож:',
    ko: '가공 공구:',
    bur: 'ပြုပြင် ဓားကိရိယာ:',
    ben: 'মেশিনিং টুলস:',
    tr: 'İşleme takımları:',
    km: 'ឧបករណ៍ដំណើរការ៖',
    es: 'Herramienta de procesamiento:',
    ar: 'أداة المعالجة:',
  },
  'sideHoleMachine.directives': {
    zh: '加工指令：',
    en: 'Processing instructions:',
    id: 'Instruksi Pemrosesan:',
    kz: 'Өңдеу нұсқаулығы:',
    th: 'คำแนะนำในการประมวลผล:',
    ug: 'ئىشلەش بۇيرۇقى:',
    vi: 'Chỉ thị gia công:',
    zh_tc: '加工指令：',
    ru: 'Директива по обработке:',
    ko: '가공 명령:',
    bur: 'ပြုပြင် အမိန့်များ:',
    ben: 'মেশিনিং নির্দেশ:',
    tr: 'İşleme komutları:',
    km: 'បញ្ជាដំណើរការ៖',
    es: 'Instrucciones de procesamiento:',
    ar: 'تعليمات المعالجة:',
  },
  'sideHoleMachine.slot': {
    zh: '直槽加工',
    en: 'Straight slot processing',
    id: 'Pemrosesan alur lurus',
    kz: 'Тік оңдеу',
    th: 'การแปรรูปร่องตรง',
    ug: 'تۈز يوچۇق ئىشلەش',
    vi: 'Gia công khe thẳng',
    zh_tc: '直槽加工',
    ru: 'Прямая обработка',
    ko: '직선 슬롯 가공',
    bur: 'တည့်တည့်ချောင်း ပြုပြင်မှု',
    ben: 'স্ট্রেইট স্লট মেশিনিং',
    tr: 'Düz kanal işleme',
    km: 'ដំណើរការរណ្តៅត្រង់',
    es: 'Procesamiento de ranura recta',
    ar: 'معالجة الأخدود المستقيم',
  },
  'sideHoleMachine.cirWork': {
    zh: '圆弧加工',
    en: 'arc machining',
    id: 'Permesinan busur',
    kz: 'Кемерлі оңдеу',
    th: 'เครื่องตัดเฉือนโค้ง',
    ug: 'يېرىم چەمبەر ئىشلەش',
    vi: 'Gia công vòng tròn',
    zh_tc: '圓弧加工',
    ru: 'Дуговая обработка',
    ko: '호 가공',
    bur: 'ဝိုင်းကွေး ပြုပြင်မှု',
    ben: 'আর্ক মেশিনিং',
    tr: 'Yay işleme',
    km: 'ដំណើរការរង្វង់',
    es: 'Procesamiento de arco',
    ar: 'معالجة القوس',
  },
  'sideHoleMachine.cirInter': {
    zh: '圆弧插补',
    en: 'circular interpolation',
    id: 'Interpolasi busur',
    kz: 'Кемерлі оңдеудің толтыру',
    th: 'การแก้ไขอาร์ค',
    ug: 'يېرىم چەمبەر تولۇقلاش',
    vi: 'Chèn bù vòng tròn',
    zh_tc: '圓弧插補',
    ru: 'дуговая вставка',
    ko: '호 보간',
    bur: 'ဝိုင်းကွေး အင်တာပိုလေးရှင်း',
    ben: 'সার্কুলার ইন্টারপোলেশন',
    tr: 'Dairesel interpolasyon',
    km: 'រមស់រង្វង់',
    es: 'Interpolación de arco',
    ar: 'استيفاء القوس',
  },
  'sideHoleMachine.cirOption1': {
    zh: '顺时针：G03 逆时针：G02',
    en: 'Clockwise: G03 Counterclockwise: G02',
    id: 'Searah jarum jam: g03 berlawanan arah jarum jam: g02',
    kz: 'Кемерлі: G03 Кемерлі: G02',
    th: 'ตามเข็มนาฬิกา: G03 ทวนเข็มนาฬิกา: G02',
    ug: 'سائەت ئىستىرېلكىسى بويىچە:G03 سائەت ئىستىرېلكىسىغا قارشى:G02',
    vi: 'Thoáng tay: G03 Ngược thoáng tay: G02',
    zh_tc: '順時針：G03 逆時針：G02',
    ru: 'По часовой стрелке: G03 против часовой стрелки: G02',
    ko: '시계 방향: G03 반시계 방향: G02',
    bur: 'နာရီလက်တံလိုက်: G03 နာရီလက်တံပြန်: G02',
    ben: 'ঘড়ির কাঁটার দিকে: G03 বিপরীত দিকে: G02',
    tr: 'Saat yönü: G03 Saat yönünün tersi: G02',
    km: 'តាមនាឡិកា៖ G03 ច្រាសនាឡិកា៖ G02',
    es: 'Sentido horario: G03 Sentido antihorario: G02',
    ar: 'في اتجاه عقارب الساعة: G03 عكس اتجاه عقارب الساعة: G02',
  },
  'sideHoleMachine.cirOption2': {
    zh: '顺时针：G02 逆时针：G03',
    en: 'Clockwise: G02 Counterclockwise: G03',
    id: 'Searah jarum jam: G02 berlawanan arah jarum jam: G03',
    kz: 'Кемерлі: G02 Кемерлі: G03',
    th: 'ตามเข็มนาฬิกา: G02 ทวนเข็มนาฬิกา: G03',
    ug: 'سائەت ئىستىرېلكىسى بويىچە:G02 سائەت ئىستىرېلكىسىغا قارشى:G03',
    vi: 'Thoáng tay: G02 Ngược thoáng tay: G03',
    zh_tc: '順時針：G02 逆時針：G03',
    ru: 'По часовой стрелке: G02 против часовой стрелки: G03',
    ko: '시계 방향: G02 반시계 방향: G03',
    bur: 'နာရီလက်တံလိုက်: G02 နာရီလက်တံပြန်: G03',
    ben: 'ঘড়ির কাঁটার দিকে: G02 বিপরীত দিকে: G03',
    tr: 'Saat yönü: G02 Saat yönünün tersi: G03',
    km: 'តាមនាឡិកា៖ G02 ច្រាសនាឡិកា៖ G03',
    es: 'Sentido horario: G02 Sentido antihorario: G03',
    ar: 'في اتجاه عقارب الساعة: G02 عكس اتجاه عقارب الساعة: G03',
  },
  'sideHoleMachine.coordinate.xPointSymbol': {
    zh: '横向坐标：',
    en: 'X-coordinate:',
    id: 'Koordinat horizontal:',
    kz: 'Көлденең координаты:',
    th: 'พิกัดแนวนอน:',
    ug: 'توغرىسىغا كوئوردېناتى:',
    vi: 'Tọa độ ngang:',
    zh_tc: '橫向座標：',
    ru: 'Горизонтальные координаты:',
    ko: '가로 좌표:',
    bur: 'အလျားလိုက် ကိုဩဒိနိတ်:',
    ben: 'X কোঅর্ডিনেট:',
    tr: 'X koordinatı:',
    km: 'កូអរដោនេ X៖',
    es: 'Coordenada horizontal:',
    ar: 'الإحداثي الأفقي:',
  },
  'sideHoleMachine.coordinate.yPointSymbol': {
    zh: '纵向坐标：',
    en: 'Y-coordinate:',
    id: 'Koordinat vertikal:',
    kz: 'Жұмысқышты координаты:',
    th: 'พิกัดแนวตั้ง:',
    ug: 'بويىغا كوئوردېناتى:',
    vi: 'Tọa độ dọc:',
    zh_tc: '縱向座標：',
    ru: 'Продольные координаты:',
    ko: '세로 좌표:',
    bur: 'ဒေါင်လိုက် ကိုဩဒိနိတ်:',
    ben: 'Y কোঅর্ডিনেট:',
    tr: 'Y koordinatı:',
    km: 'កូអរដោនេ Y៖',
    es: 'Coordenada longitudinal:',
    ar: 'الإحداثي الطولي:',
  },
  'sideHoleMachine.coordinate.zPointSymbol': {
    zh: '升降坐标：',
    en: 'Z-coordinate:',
    id: 'Koordinat pengangkat:',
    kz: 'Жүкілу координаты:',
    th: 'การยกพิกัด:',
    ug: 'كۆتۈرۈش كوئوردېناتى:',
    vi: 'Tọa độ thăng hạ:',
    zh_tc: '升降座標：',
    ru: 'Координаты подъема:',
    ko: '승강 좌표:',
    bur: 'အမြင့်-အနိမ့် ကိုဩဒိနိတ်:',
    ben: 'Z কোঅর্ডিনেট:',
    tr: 'Z koordinatı:',
    km: 'កូអរដោនេ Z៖',
    es: 'Coordenada de elevación:',
    ar: 'إحداثي الرفع:',
  },
  'sideHoleMachine.coordinate.upright': {
    zh: '正值',
    en: 'Positive value',
    id: 'Nilai positif',
    kz: 'Қостар',
    th: 'ค่าบวก',
    ug: 'مۇسبەت قىممەت',
    vi: 'Giá trị dương',
    zh_tc: '正值',
    ru: 'Положительное значение',
    ko: '양수 값',
    bur: 'အပေါင်းတန်ဖိုး',
    ben: 'ধনাত্মক মান',
    tr: 'Pozitif değer',
    km: 'តម្លៃវិជ្ជមាន',
    es: 'Valor positivo',
    ar: 'القيمة الموجبة',
  },
  'sideHoleMachine.coordinate.negative': {
    zh: '负值',
    en: 'Negative value',
    id: 'Nilai negatif',
    kz: 'Кемерлі',
    th: 'ค่าลบ',
    ug: 'مەنپىي قىممەت',
    vi: 'Giá trị âm',
    zh_tc: '負值',
    ru: 'Отрицательное значение',
    ko: '음수 값',
    bur: 'အနုတ်တန်ဖိုး',
    ben: 'ঋণাত্মক মান',
    tr: 'Negatif değer',
    km: 'តម្លៃអវិជ្ជមាន',
    es: 'Valores negativos',
    ar: 'القيم السالبة',
  },
  'sideHoleMachine.encodeFormat.format': {
    zh: '文件编码格式：',
    en: 'File encoding format:',
    id: 'Format pengkodean file:',
    kz: 'Файл кодирлеу пішімі:',
    th: 'รูปแบบการเข้ารหัสไฟล์:',
    ug: 'ھۆججەت كودلاش فورماتى:',
    vi: 'Định dạng mã hóa tệp:',
    zh_tc: '文件編碼格式：',
    ru: 'Формат кодирования файла:',
    ko: '파일 인코딩 형식:',
    bur: 'ဖိုင် အင်ကုဒ် ဖော်မတ်:',
    ben: 'ফাইল এনকোডিং ফরম্যাট:',
    tr: 'Dosya kodlama biçimi:',
    km: 'ទ្រង់ទ្រាយកូដឯកសារ៖',
    es: 'Formato de codificación de archivo:',
    ar: 'تنسيق ترميز الملف:',
  },
  'sideHoleMachine.encodeFormat.wrap': {
    zh: '换行符格式设置：',
    en: 'Line wrap format setting:',
    id: 'Pengaturan Format Line Break:',
    kz: 'Жаңу шаруашылым пішімі:',
    th: 'การตั้งค่ารูปแบบการแบ่งบรรทัด:',
    ug: 'قۇر ئالماشتۇرۇش بەلگىسى فورماتى تەڭشىكى:',
    vi: 'Cài đặt định dạng ký tự xuống dòng:',
    zh_tc: '換行符格式設置：',
    ru: 'Параметры формата переноса строк:',
    ko: '줄 바꿈 형식:',
    bur: 'လိုင်းပြောင်း အက္ခရာ ဖော်မတ် ဆက်တင်:',
    ben: 'লাইন ব্রেক ফরম্যাট সেটিং:',
    tr: 'Satır sonu biçimi ayarı:',
    km: 'ការកំណត់ទ្រង់ទ្រាយបន្ទាត់ថ្មី៖',
    es: 'Configuración de formato de salto de línea:',
    ar: 'إعدادات تنسيق فاصل الأسطر:',
  },
  'sideHoleMachine.encodeFormat.formatOption1': {
    zh: 'UTF-8格式',
    en: 'UTF-8 format',
    id: 'Format UTF-8',
    kz: 'UTF-8 пішімі',
    th: 'รูปแบบ UTF-8',
    ug: 'UTF-8 فورماتى',
    vi: 'Định dạng UTF-8',
    zh_tc: 'UTF-8格式',
    ru: 'Формат UTF - 8',
    ko: 'UTF-8 형식',
    bur: 'UTF-8 ဖော်မတ်',
    ben: 'UTF-8 ফরম্যাট',
    tr: 'UTF-8 biçimi',
    km: 'ទ្រង់ទ្រាយ UTF-8',
    es: 'UTF-8 formato',
    ar: 'UTF-8 التنسيق',
  },
  'sideHoleMachine.encodeFormat.formatOption2': {
    zh: 'ANSI格式',
    en: 'ANSI format',
    id: 'Format ANSI',
    kz: 'ANSI пішімі',
    th: 'รูปแบบ ANSI',
    ug: 'ANSI فورماتى',
    vi: 'Định dạng ANSI',
    zh_tc: 'ANSI格式',
    ru: 'Формат ANSI',
    ko: 'ANSI 형식',
    bur: 'ANSI ဖော်မတ်',
    ben: 'ANSI ফরম্যাট',
    tr: 'ANSI biçimi',
    km: 'ទ្រង់ទ្រាយ ANSI',
    es: 'ANSI formato',
    ar: 'ANSI التنسيق',
  },
  'sideHoleMachine.suffix': {
    zh: '文件后缀设定：',
    en: 'File suffix setting:',
    id: 'Pengaturan Suffix File:',
    kz: 'Файлдің суффиксін орнату:',
    th: 'การตั้งค่าไฟล์ต่อท้าย:',
    ug: 'ھۆججەت قوشۇمچە نامى بەلگىلەش:',
    vi: 'Định dạng hậu tố tệp:',
    zh_tc: '文件後綴設定：',
    ru: 'Суффикс файла установлен:',
    ko: '파일 접미어 설정:',
    bur: 'ဖိုင် နောက်ဆက် (suffix) ဆက်တင်:',
    ben: 'ফাইল সাফিক্স সেটিং:',
    tr: 'Dosya uzantısı ayarı:',
    km: 'ការកំណត់បន្ទាប់ឯកសារ៖',
    es: 'Configuración de sufijo de archivo:',
    ar: 'إعدادات لاحقة الملف:',
  },
  'sideHoleMachine.enableFP': {
    zh: '启用正面加工',
    en: 'Enable front processing',
    id: 'Aktifkan pemrosesan frontal',
    kz: 'Өңдеудің алдыңғы бетін іске қосу',
    th: 'เปิดใช้งานการประมวลผลด้านหน้า',
    ug: 'ئالدى يۈزى ئىشلەشنى قوزغىتىش',
    vi: 'Kích hoạt gia công mặt trước',
    zh_tc: '啓用正面加工',
    ru: 'Включить фронтальную обработку',
    ko: '전면 머시닝 사용',
    bur: 'ရှေ့မျက်နှာ ပြုပြင်မှုကို ဖွင့်ပါ',
    ben: 'ফ্রন্ট প্রসেসিং চালু করুন',
    tr: 'Ön yüz işlemeyi etkinleştir',
    km: 'បើកដំណើរការខាងមុខ',
    es: 'Habilitar procesamiento frontal',
    ar: 'تمكين المعالجة الأمامية',
  },
  'sideHoleMachine.slotSetting': {
    zh: '拉槽设置',
    en: 'Slot setting',
    id: 'Tarik pengaturan slot',
    kz: 'Керектендіру орнату',
    th: 'ดึงการตั้งค่าสล็อต',
    ug: 'يوچۇق تارتىش تەڭشىكى',
    vi: 'Cài đặt khe nhú',
    zh_tc: '拉槽設置',
    ru: 'Настройка лотка',
    ko: '슬롯 설정',
    bur: 'ချောင်းဆွဲ ဆက်တင်',
    ben: 'স্লট সেটিং',
    tr: 'Kanal çekme ayarı',
    km: 'ការកំណត់ទាញរណ្តៅ',
    es: 'Configuración de ranurado',
    ar: 'إعدادات الحز',
  },
  'sideHoleMachine.slotMillSetting': {
    zh: '拉槽/铣孔铣槽设置',
    en: 'Groove pulling / milling / drilling setup',
    id: 'Pengaturan tarik alur / penggilingan / pengeboran',
    kz: 'Канал тарту / фрезерлеу орнатулары',
    th: 'ดึงการตั้งค่าสล็อต/การตั้งค่าการตัดสล็อต/การตั้งค่าการตัดสล็อต',
    ug: 'يوچۇق تارتىش/ئويۇش تەڭشىكى',
    vi: 'Cài đặt rãnh kéo / phay khoan',
    zh_tc: '拉槽/銑孔銑槽設置',
    ru: 'Настройка вытяжных канавок / фрезерных отверстий',
    ko: '슬롯 / 밀링 구멍 밀링 슬롯 설정',
    bur: 'ချောင်းဆွဲ/အပေါက်-ချောင်းဖရီးဇ် ဆက်တင်',
    ben: 'স্লট টানা/মিলিং হোল-স্লট সেটিং',
    tr: 'Kanal çekme / freze delik ve kanal ayarı',
    km: 'ការកំណត់ទាញរណ្តៅ/រន្ធ និងរណ្តៅហ្វ្រីស',
    es: 'Ranurado/fresado y configuración de ranuras de fresado',
    ar: 'إعدادات الحز/الطحن وفتحة الطحن',
  },
  'sideHoleMachine.millSlot': {
    zh: '支持铣孔铣槽',
    en: 'Supports milling holes and grooves',
    id: 'Mendukung penggilingan lubang dan alur',
    kz: 'Тесу және фрезерлеу арналарын қолдайды',
    th: 'รองรับการตัดรูและสล็อต',
    ug: 'تېشىش ۋە يوچۇق ئويۇشنى قوللاش',
    vi: 'Hỗ trợ phay lỗ và rãnh',
    zh_tc: '支持銑孔銑槽',
    ru: 'Поддержка фрезерных отверстий',
    ko: '밀링 구멍 밀링 슬롯 지원',
    bur: 'အပေါက်နှင့် ချောင်း ဖရီးဇ်ခြင်းကို ထောက်ပံ့သည်',
    ben: 'মিলিং হোল ও গ্রুভ সাপোর্ট করে',
    tr: 'Freze delik ve kanalı destekler',
    km: 'គាំទ្ររន្ធ និងរណ្តៅហ្វ្រីស',
    es: 'Admite fresado y ranuras de fresado',
    ar: 'دعم فتحات الطحن والطحن',
  },
  'sideHoleMachine.millingSlotOverlapRate': {
    zh: '铣槽重叠率',
    en: 'Milling groove overlap rate',
    id: 'Tingkat tumpang tindih alur penggilingan',
    kz: 'Фрезерлеу арналарындағы қабаттасу мөлшері',
    th: 'อัตราการทับซ้อนของร่องกัด',
    ug: 'يوچۇق ئويۇش قاپلىشىش نىسبىتى',
    vi: 'Фрезерлеу арналарын қолдайды',
    zh_tc: '銑槽重疊率',
    ru: 'перекрытие фрезерных пазов',
    ko: '밀링 슬롯 중첩률',
    bur: 'ချောင်းဖရီးဇ် ထပ်နေမှုနှုန်း',
    ben: 'মিলিং স্লট ওভারল্যাপ রেট',
    tr: 'Freze kanalı örtüşme oranı',
    km: 'អត្រាស្ទូចគ្នានៃរណ្តៅហ្វ្រីស',
    es: 'Tasa de superposición de ranuras de fresado',
    ar: 'معدل تداخل فتحة الطحن',
  },
  'sideHoleMachine.millingHoleSlotOverlapRate': {
    zh: '铣孔铣槽重叠率',
    en: 'Milling hole and groove overlap rate',
    id: 'Tingkat tumpang tindih lubang dan alur penggilingan',
    kz: 'Тесу және фрезерлеу арналарының қабаттасу мөлшері',
    th: 'อัตราการทับซ้อนของรูและร่องกัด',
    ug: 'تېشىش ۋە يوچۇق ئويۇش قاپلىشىش نىسبىتى',
    vi: 'Tỷ lệ chồng lấp lỗ và rãnh phay',
    zh_tc: '銑孔銑槽重疊率',
    ru: 'коэффициент перекрытия фрезерных пазов',
    ko: '밀링 구멍 밀링 슬롯 중첩률',
    bur: 'အပေါက်/ချောင်းဖရီးဇ် ထပ်နေမှုနှုန်း',
    ben: 'মিলিং হোল/স্লট ওভারল্যাপ রেট',
    tr: 'Freze delik ve kanal örtüşme oranı',
    km: 'អត្រាស្ទូចគ្នារន្ធ និងរណ្តៅហ្វ្រីស',
    es: 'Fresado y tasa de superposición de ranuras de fresado',
    ar: 'معدل تداخل فتحة الطحن والطحن',
  },
  'sideHoleMachine.takeUpDirective': {
    zh: '收刀指令',
    en: 'Knife retraction command',
    id: 'Perintah Knife-Collection',
    kz: 'Қырғышты алу нұсқаулығы',
    th: 'คำสั่งการรวบรวมมีด',
    ug: 'پىچاق يىغىش بۇيرۇقى',
    vi: 'Chỉ thị thu dao',
    zh_tc: '收刀指令',
    ru: 'Приказ о приёме ножей',
    ko: '칼을 거두는 명령',
    bur: 'ဓားပြန်ဆုတ် အမိန့်',
    ben: 'টুল রিট্র্যাকশন কমান্ড',
    tr: 'Bıçağı toplama komutu',
    km: 'បញ្ជាដកដាវ',
    es: 'Comando de cierre de herramienta',
    ar: 'أمر إغلاق الأداة',
  },
  'sideHoleMachine.workSeparately': {
    zh: '正/反面通槽分两段加工',
    en: 'Process the through slot on the front and back separately',
    id: 'Alur maju/terbalik diproses dalam dua bagian',
    kz: 'Алдыңғы/ артқы беттің керектіңдірілім екі бөлімге бөліну',
    th: 'ร่องไปข้างหน้า/ย้อนกลับจะถูกประมวลผลในสองส่วน',
    ug: 'ئالدى/كەينى يۈزى ئۆتمە يوچۇقنى ئىككى قىسىمغا بۆلۈپ ئىشلەش',
    vi: 'Gia công khe thông hai mặt thành hai đoạn',
    zh_tc: '正/反面通槽分兩段加工',
    ru: 'Положительный / отрицательный проход в два этапа',
    ko: '양면 / 후면 슬롯은 두 세그먼트로 가공됩니다.',
    bur: 'ရှေ့/နောက် မျက်နှာ ထိုးဖောက်ချောင်းကို အပိုင်း၂ပိုင်း ခွဲ၍ ပြုပြင်သည်',
    ben: 'ফ্রন্ট/ব্যাক থ্রু স্লট দুই ভাগে প্রসেস করুন',
    tr: 'Ön ve arka yüzdeki geçiş kanalını iki aşamada işle',
    km: 'ដំណើរការរណ្តៅឆ្លងខាងមុខ/ក្រោមជាពីរដំណាក់កាល',
    es: 'El la ranura lateral delantera/trasera se procesa en dos secciones',
    ar: 'تتم معالجة الفتحة الجانبية الأمامية/الخلفية في قسمين',
  },
  'sideHoleMachine.secondSlotLong': {
    zh: '第二段槽长度',
    en: 'Length of the second slot',
    id: 'Panjang slot kedua',
    kz: 'Екінші керектіңдірілімнің ұзындығы',
    th: 'ความยาวสล็อตที่สอง',
    ug: 'ئىككىنچى قىسىم يوچۇق ئۇزۇنلۇقى',
    vi: 'Độ dài khe đoạn thứ hai',
    zh_tc: '第二段槽長度',
    ru: 'Длина второго лотка',
    ko: '두 번째 슬롯 길이',
    bur: 'ဒုတိယ အပိုင်း ချောင်းအရှည်',
    ben: 'দ্বিতীয় অংশের স্লট দৈর্ঘ্য',
    tr: 'İkinci kanal parçası uzunluğu',
    km: 'ប្រវែងរណ្តៅផ្នែកទីពីរ',
    es: 'La longitud de la segunda ranura',
    ar: 'طول الفتحة الثانية',
  },
  'sideHoleMachine.enableOld': {
    zh: '启用旧版侧孔机设置',
    en: 'Enable the old version of the side hole machine setting',
    id: 'Aktifkan Pengaturan Mesin Lubang Sisi Lama',
    kz: 'Ескі версияның жанбалау орнатуын іске қосу',
    th: 'เปิดใช้งานการตั้งค่าเครื่องหลุมด้านเก่า',
    ug: 'كونا نەشرى يان تۆشۈك ماشىنىسى تەڭشىكىنى قوزغىتىش',
    vi: 'Kích hoạt cài đặt máy khoan bên cũ',
    zh_tc: '啓用舊版側孔機設置',
    ru: 'Включить настройки старых боковых отверстий',
    ko: '이전 버전의 측면 구멍 기계 설정 사용',
    bur: 'ဘေးအပေါက်စက် ဆက်တင်အဟောင်းကို ဖွင့်ပါ',
    ben: 'পুরোনো সাইড হোল মেশিন সেটিং চালু করুন',
    tr: 'Eski yan delik makinesi ayarlarını etkinleştir',
    km: 'បើកការកំណត់ម៉ាស៊ីនរន្ធចំហៀងកំណែចាស់',
    es: 'Habilita la configuración anterior de la máquina perforadora lateral',
    ar: 'تمكين إعدادات آلة الفتحة الجانبية القديمة',
  },
  'sideHoleMachine.default': {
    zh: '默认设置',
    en: 'Default setting',
    id: 'Pengaturan default',
    kz: 'Әдетті орнату',
    th: 'การตั้งค่าเริ่มต้น',
    ug: 'سۈكۈتتىكى تەڭشەك',
    vi: 'Cài đặt mặc định',
    zh_tc: '默認設置',
    ru: 'Настройки по умолчанию',
    ko: '기본 설정',
    bur: 'စံသတ်မှတ် ဆက်တင်',
    ben: 'ডিফল্ট সেটিং',
    tr: 'Varsayılan ayar',
    km: 'ការកំណត់លំនាំដើម',
    es: 'Configuración predeterminada',
    ar: 'الإعدادات الافتراضية',
  },
  'sideHoleMachine.customizable1': {
    zh: '自定义一',
    en: 'Custom 1',
    id: 'Sesuaikan satu',
    kz: 'Бірінші жеке орнату',
    th: 'ปรับแต่งหนึ่ง',
    ug: 'ئۆزى بەلگىلەش بىر',
    vi: 'Tùy chỉnh 1',
    zh_tc: '自定義一',
    ru: 'Настройка 1',
    ko: '사용자 정의 1',
    bur: 'စိတ်ကြိုက် ၁',
    ben: 'কাস্টম ১',
    tr: 'Özel 1',
    km: 'ប្ដូរតាមបំណង ១',
    es: 'Personalizada una',
    ar: 'واحدة مخصصة',
  },
  'sideHoleMachine.customizable2': {
    zh: '自定义二',
    en: 'Custom 2',
    id: 'Kustom Dua',
    kz: 'Екінші жеке орнату',
    th: 'กำหนดเองสอง',
    ug: 'ئۆزى بەلگىلەش ئىككى',
    vi: 'Tùy chỉnh 2',
    zh_tc: '自定義二',
    ru: 'Настройка 2',
    ko: '사용자 정의 2',
    bur: 'စိတ်ကြိုက် ၂',
    ben: 'কাস্টম ২',
    tr: 'Özel 2',
    km: 'ប្ដូរតាមបំណង ២',
    es: 'Personalizada dos',
    ar: 'مخصصة اثنين',
  },
  'sideHoleMachine.customizable3': {
    zh: '自定义三',
    en: 'Custom 3',
    id: 'Tiga Kustom',
    kz: 'Үшінші жеке орнату',
    th: 'กำหนดเองสาม',
    ug: 'ئۆزى بەلگىلەش ئۈچ',
    vi: 'Tùy chỉnh 3',
    zh_tc: '自定義三',
    ru: 'Настройка 3',
    ko: '사용자 지정 3',
    bur: 'စိတ်ကြိုက် ၃',
    ben: 'কাস্টম ৩',
    tr: 'Özel 3',
    km: 'ប្ដូរតាមបំណង ៣',
    es: 'Personalizada tres',
    ar: 'ثلاثة مخصصة',
  },
  'sideHoleMachine.customizable4': {
    zh: '自定义四',
    en: 'Custom 4',
    id: 'Kustom empat',
    kz: 'Төртінші жеке орнату',
    th: 'กำหนดเองสี่',
    ug: 'ئۆزى بەلگىلەش تۆت',
    vi: 'Tùy chỉnh 4',
    zh_tc: '自定義四',
    ru: 'Настройка 4',
    ko: '사용자 지정 4',
    bur: 'စိတ်ကြိုက် ၄',
    ben: 'কাস্টম ৪',
    tr: 'Özel 4',
    km: 'ប្ដូរតាមបំណង ៤',
    es: 'Personalizada cuatro',
    ar: 'أربعة مخصصة',
  },
  'sideHoleMachine.knifeSetting': {
    zh: '刀具设置',
    en: 'Knife setting',
    id: 'Pengaturan Alat',
    kz: 'Қырғышты орнату',
    th: 'การตั้งค่าเครื่องมือ',
    ug: 'پىچاق تەڭشىكى',
    vi: 'Cài đặt dao',
    zh_tc: '刀具設置',
    ru: 'Настройка ножа',
    ko: '공구 설정',
    bur: 'ဓားကိရိယာ ဆက်တင်',
    ben: 'টুল সেটিং',
    tr: 'Takım ayarı',
    km: 'ការកំណត់ឧបករណ៍កាត់',
    es: 'Configuraciones de herramientas',
    ar: 'إعدادات الأداة',
  },
  'sideHoleMachine.soltTip': {
    zh: '(包括铣孔/槽)',
    en: '(Including milling holes/slots)',
    id: '(Termasuk lubang/slot penggilingan)',
    kz: '(Керектендіру/ керектіңдірілімді қосу)',
    th: '(รวมถึงรู/สล็อต)',
    ug: '(تۆشۈك ئويۇش/يوچۇق ئويۇشنى ئۆز ئىچىگە ئالىدۇ)',
    vi: '(Bao gồm khai khoan/khe)',
    zh_tc: '(包括銑孔/槽)',
    ru: '(Включая фрезерные отверстия / пазы)',
    ko: '(밀링 구멍 / 슬롯 포함)',
    bur: '(အပေါက်/ချောင်းဖရီးဇ် ပါဝင်သည်)',
    ben: '(মিলিং হোল/স্লটসহ)',
    tr: '(Freze delik/kanal dahil)',
    km: '(រួមទាំងរន្ធ/រណ្តៅហ្វ្រីស)',
    es: '(incluyendo fresado de agujeros/ranuras)',
    ar: '(بما في ذلك فتحات/فتحات الطحن)',
  },
  'sideHoleMachine.specialSetting': {
    zh: '特殊设置',
    en: 'Special setting',
    id: 'Pengaturan Khusus',
    kz: 'Арнайы орнату',
    th: 'การตั้งค่าพิเศษ',
    ug: 'ئالاھىدە تەڭشەك',
    vi: 'Cài đặt đặc biệt',
    zh_tc: '特殊設置',
    ru: 'Специальные параметры',
    ko: '특수 설정',
    bur: 'အထူး ဆက်တင်',
    ben: 'বিশেষ সেটিং',
    tr: 'Özel ayar',
    km: 'ការកំណត់ពិសេស',
    es: 'Configuraciones especiales',
    ar: 'إعدادات خاصة',
  },
  'sideHoleMachine.ramino': {
    zh: '拉米诺',
    en: 'Ramino',
    id: 'RAMINO',
    kz: 'Рамино',
    th: 'อะมิโน',
    ug: 'رامىنو',
    vi: 'Ramino',
    zh_tc: '拉米諾',
    ru: 'Ламино',
    ko: '라미노',
    bur: 'Ramino',
    ben: 'Ramino',
    tr: 'Ramino',
    km: 'Ramino',
    es: 'Lamino',
    ar: 'لامينو',
  },
  'sideHoleMachine.sun': {
    zh: '榫卯',
    en: 'Mortise and tenon',
    id: 'Raja dan mortise',
    kz: 'Суньмау',
    th: 'พระมหากษัตริย์',
    ug: 'سۇن ماۋ',
    vi: 'Sūn Mǎo',
    zh_tc: '榫卯',
    ru: 'Шип',
    ko: '장부',
    bur: 'တံဆစ်-ချောင်း (Mortise & Tenon)',
    ben: 'মর্টিস-টেনন',
    tr: 'Çıkıntı ve oyuk',
    km: 'Mortise និង tenon',
    es: 'Mortaja y espiga',
    ar: 'نقر ولسان',
  },
  'sideHoleMachine.please': {
    zh: '敬请期待',
    en: 'Stay tuned',
    id: 'Pantau terus',
    kz: 'Күтініңіз',
    th: 'คอยติดตาม',
    ug: 'تەقەززا بولۇڭ',
    vi: 'Xin vui lòng chờ đợi',
    zh_tc: '敬請期待',
    ru: 'С нетерпением жду',
    ko: '기대해 주세요',
    bur: 'မကြာမီ လာမည်',
    ben: 'শিগগিরই আসছে',
    tr: 'Yakında',
    km: 'សូមរង់ចាំ',
    es: 'Estén atentos',
    ar: 'ترقبوا',
  },
  'sideHoleMachine.designatedKnives': {
    zh: '指定用刀',
    en: 'Designated knives',
    id: 'Pisau yang ditunjuk',
    kz: 'Белгіленген қырғыш',
    th: 'มีดกำหนด',
    ug: 'بەلگىلەنگەن پىچاق',
    vi: 'Dao chỉ định',
    zh_tc: '指定用刀',
    ru: 'Назначить нож',
    ko: '지정된 칼',
    bur: 'သတ်မှတ်ဓား',
    ben: 'নির্দিষ্ট টুল',
    tr: 'Belirtilen takım',
    km: 'ឧបករណ៍ដែលបានកំណត់',
    es: 'Especificar herramienta',
    ar: 'تحديد الأداة',
  },
  'sideHoleMachine.designated': {
    zh: '指定',
    en: 'Designated',
    id: 'Menentukan',
    kz: 'Белгіленген',
    th: 'ระบุ',
    ug: 'بەلگىلەش',
    vi: 'Chỉ định',
    zh_tc: '指定',
    ru: 'указанный',
    ko: '지정',
    bur: 'သတ်မှတ်',
    ben: 'নির্দিষ্ট',
    tr: 'Belirtilen',
    km: 'បានកំណត់',
    es: 'Especificar',
    ar: 'تحديد',
  },
  'sideHoleMachine.workOrder': {
    zh: '加工命令',
    en: 'Processing command',
    id: 'Perintah pemrosesan',
    kz: 'Өңдеу нұсқаулығы',
    th: 'คำสั่งประมวลผล',
    ug: 'ئىشلەش بۇيرۇقى',
    vi: 'Lệnh gia công',
    zh_tc: '加工命令',
    ru: 'Команда обработки',
    ko: '머시닝 명령',
    bur: 'ပြုပြင် အမိန့်',
    ben: 'মেশিনিং কমান্ড',
    tr: 'İşleme komutu',
    km: 'បញ្ជាដំណើរការ',
    es: 'Comando de procesamiento',
    ar: 'أمر المعالجة',
  },
  'sideHoleMachine.other': {
    zh: '其他',
    en: 'Others',
    id: 'lainnya',
    kz: 'Басқа',
    th: 'อื่น',
    ug: 'باشقىلار',
    vi: 'Khác',
    zh_tc: '其他',
    ru: 'другие',
    ko: '기타',
    bur: 'အခြား',
    ben: 'অন্যান্য',
    tr: 'Diğer',
    km: 'ផ្សេងៗ',
    es: 'Otros',
    ar: 'أخرى',
  },
  'sideHoleMachine.nameSetting': {
    zh: '后缀名设置',
    en: 'Suffix name setting',
    id: 'Pengaturan Nama Suffix',
    kz: 'Суффикс орнату',
    th: 'การตั้งค่าชื่อต่อท้าย',
    ug: 'قوشۇمچە نام تەڭشىكى',
    vi: 'Cài đặt tên hậu tố',
    zh_tc: '後綴名設置',
    ru: 'Параметры суффикса',
    ko: '접미어 이름 설정',
    bur: 'နောက်ဆက်အမည် (suffix) ဆက်တင်',
    ben: 'সাফিক্স নাম সেটিং',
    tr: 'Uzantı adı ayarı',
    km: 'ការកំណត់ឈ្មោះបន្ទាប់',
    es: 'Configuración de nombre de sufijo',
    ar: 'إعداد اسم اللاحقة',
  },
  'sideHoleMachine.repeatErr': {
    zh: '编号重复，请重新设置',
    en: 'The number is duplicate. Please reset it.',
    id: 'Ulangi nomor, harap setel ulang',
    kz: 'Номер қайталанды, қайтадан орнатуіңіз керек',
    th: 'หมายเลขซ้ำโปรดรีเซ็ต',
    ug: 'نومۇر تەكرارلانغان، قايتا تەڭشەڭ',
    vi: 'Số biên hiệu trùng lặp, vui lòng cài đặt lại',
    zh_tc: '編號重複，請重新設置',
    ru: 'Номер повторяется, пожалуйста, переустановите',
    ko: '번호가 반복됩니다. 다시 설정하십시오.',
    bur: 'နံပါတ် ထပ်နေသည်၊ ပြန်လည်သတ်မှတ်ပါ',
    ben: 'নম্বর ডুপ্লিকেট, দয়া করে পুনরায় সেট করুন',
    tr: 'Numara tekrarlı, lütfen yeniden ayarlayın',
    km: 'លេខស្ទួន សូមកំណត់ឡើងវិញ',
    es: 'Número duplicado, restablecer',
    ar: 'رقم مكرر، يرجى إعادة تعيين',
  },
  'electronicSaw.importMaterial': {
    zh: '导入原料单',
    en: 'Import Material List',
    id: 'Impor Daftar Bahan Baku',
    kz: 'Материалдар тізімін імпорттау',
    th: 'นำเข้ารายการวัตถุดิบ',
    ug: 'ماتېرىيال تىزىملىكىنى كىرگۈزۈش',
    vi: 'Nhập danh sách nguyên liệu',
    zh_tc: '導入原料單',
    ru: 'Импорт исходного листа',
    ko: '원단 가져오기',
    bur: 'ကုန်ကြမ်းစာရင်း တင်သွင်းပါ',
    ben: 'ম্যাটেরিয়াল লিস্ট ইমপোর্ট করুন',
    tr: 'Ham malzeme listesini içe aktar',
    km: 'នាំចូលបញ្ជីសម្ភារៈដើម',
    es: 'Importar lista de materias primas',
    ar: 'قائمة استيراد المواد الخام',
  },
  'electronicSaw.formSetting': {
    zh: '电子锯表单设置',
    en: 'Electronic Saw Form Setting',
    id: 'Pengaturan bentuk gergaji elektronik',
    kz: 'Электронды пісіру машинасының нысандар орнату',
    th: 'การตั้งค่าแบบฟอร์มเลื่อยอิเล็กทรอนิกส์',
    ug: 'ئېلېكترونلۇق ھەرە جەدۋەل تەڭشىكى',
    vi: 'Cài đặt biểu mẫu máy cưa điện tử',
    zh_tc: '電子鋸表單設置',
    ru: 'Параметры формы электронной пилы',
    ko: '전자 톱 양식 설정',
    bur: 'အီလက်ထရွန်းနစ် လွှ ဖောင် ဆက်တင်',
    ben: 'ইলেকট্রনিক স’ ফর্ম সেটিং',
    tr: 'Elektronik testere form ayarı',
    km: 'ការកំណត់ទម្រង់រណ្តៅអេឡិចត្រូនិច',
    es: 'Configuración de forma de sierra electrónica',
    ar: 'إعداد نموذج المنشار الإلكتروني',
  },
  'electronicSaw.fileFormat': {
    zh: '输出开料清单文件格式：',
    en: 'Output File Format for Cutting List:',
    id: 'Bill output Format file daftar material:',
    kz: 'Выходні форматі файлів для список материалдар:',
    th: 'รูปแบบไฟล์รายการวัสดุรายการวัสดุ:',
    ug: 'كېسىش تىزىملىكى ھۆججەت فورماتى چىقىرىش:',
    vi: 'Định dạng tệp danh sách tài liệu màu cắt:',
    zh_tc: '輸出開料清單文件格式：',
    ru: 'Формат файла выходного листа:',
    ko: '출력 커팅 리스트 파일 형식:',
    bur: 'ဖြတ်တောက်စာရင်း အထွက်ဖိုင် ဖော်မတ်:',
    ben: 'কাটিং লিস্ট আউটপুট ফাইল ফরম্যাট:',
    tr: 'Kesim listesi çıktı dosya biçimi:',
    km: 'ទ្រង់ទ្រាយឯកសារបញ្ជីកាត់ចេញ៖',
    es: 'Formato de archivo de lista de corte de salida:',
    ar: 'تنسيق ملف قائمة قطع الإخراج:',
  },
  'electronicSaw.isSmallFile': {
    zh: '导出小板图片文件：',
    en: 'Export Small Board Image File:',
    id: 'Ekspor File Gambar Papan Kecil:',
    kz: 'Экспорттау шағын пікір файл:',
    th: 'ส่งออกไฟล์รูปภาพบอร์ดขนาดเล็ก:',
    ug: 'كىچىك تاختا رەسىم ھۆججىتىنى چىقىرىش:',
    vi: 'Xuất tệp hình ảnh tấm nhỏ:',
    zh_tc: '導出小板圖片文件：',
    ru: 'Экспорт файлов изображений:',
    ko: '보드 그림 파일을 내보내려면 다음과 같이 하십시오.',
    bur: 'သေးငယ်ဘုတ် ရုပ်ပုံဖိုင် ထုတ်ပါ:',
    ben: 'ছোট বোর্ড ইমেজ ফাইল এক্সপোর্ট করুন:',
    tr: 'Küçük levha görüntü dosyasını dışa aktar:',
    km: 'នាំចេញឯកសាររូបភាពផ្ទាំងតូច៖',
    es: 'Exportar archivo de imagen de placa pequeña:',
    ar: 'تصدير ملف صورة لوحة صغيرة:',
  },
  'electronicSaw.fileGroupRule': {
    zh: '电子锯文件根据颜色、材质、板厚分不同表格：',
    en: 'Divide Electronic Saw Files into Different Tables Based Color on, Material, and Thickness:',
    id: 'File gergaji elektronik dibagi menjadi tabel yang berbeda sesuai dengan warna, material, dan ketebalan papan:',
    kz: 'Электронды пісіру машинасының файлдарі бойынша түс, материал және қалыңдықтық бойынша әртүрлі кестелерде:',
    th: 'ไฟล์เลื่อยอิเล็กทรอนิกส์แบ่งออกเป็นตารางต่าง ๆ ตามสีวัสดุและความหนาของบอร์ด:',
    ug: 'ئېلېكترونلۇق ھەرە ھۆججىتى رەڭ، ماتېرىيال، قېلىنلىق بويىچە ئوخشىمىغان جەدۋەلگە ئايرىلىدۇ:',
    vi: 'Tệp máy cưa điện tử được phân chia thành các biểu mẫu khác nhau dựa trên màu sắc, chất liệu, độ dày tấm:',
    zh_tc: '電子鋸文件根據顏色、材質、板厚分不同表格：',
    ru: 'Файлы электронной пилы в зависимости от цвета, материала, толщины пластины различных таблиц:',
    ko: '전자톱 파일은 색상, 재료, 두께에 따라 테이블을 다릅니다.',
    bur: 'အီလက်ထရွန်းနစ်လွှ ဖိုင်များကို အရောင်/ပစ္စည်း/ဘုတ်အထူအလိုက် ဇယားခွဲပါ:',
    ben: 'ইলেকট্রনিক স’ ফাইল রঙ/মেটেরিয়াল/বোর্ডের পুরুত্ব অনুযায়ী আলাদা টেবিলে ভাগ করুন:',
    tr: 'Elektronik testere dosyalarını renk, malzeme ve levha kalınlığına göre ayrı tablolara böl:',
    km: 'បំបែកឯកសាររណ្តៅអេឡិចត្រូនិចជាតារាងខុសគ្នាតាមពណ៌ សម្ភារៈ និងកម្រាស់ផ្ទាំង៖',
    es: 'El archivo de sierra electrónica se divide en diferentes tablas según el color, el material y el espesor de la placa:',
    ar: 'ملف المنشار الإلكتروني مقسم إلى جداول مختلفة وفقًا للون والمادة وسمك اللوحة:',
  },
  'electronicSaw.roomsByCategory': {
    zh: '电子锯文件根据房间分不同表格：',
    en: 'Divide Electronic Saw files into Different Tables Based on Rooms:',
    id: 'File gergaji elektronik dibagi menjadi berbagai tabel sesuai dengan ruangan:',
    kz: 'Электрондық жаттығу файлдары бөлмелерге бөлінген тақырыпта:',
    th: 'ไฟล์เลื่อยอิเล็กทรอนิกส์แบ่งออกเป็นตารางต่าง ๆ ตามห้อง:',
    ug: 'ئېلېكترونلۇق ھەرە ھۆججىتى ئۆي بويىچە ئوخشىمىغان جەدۋەلگە ئايرىلىدۇ:',
    vi: 'Máy cưa điện tử tập tin theo các hình thức khác nhau của phòng:',
    zh_tc: '電子鋸文件根據房間分不同表格：',
    ru: 'Файлы электронной пилы делятся на разные таблицы в зависимости от комнаты:',
    ko: '전자 톱 파일은 공간에 따라 다른 테이블로 나뉩니다.',
    bur: 'အီလက်ထရွန်းနစ်လွှ ဖိုင်များကို အခန်းအလိုက် ဇယားခွဲပါ:',
    ben: 'ইলেকট্রনিক স’ ফাইল রুম অনুযায়ী আলাদা টেবিলে ভাগ করুন:',
    tr: 'Elektronik testere dosyalarını odaya göre ayrı tablolara böl:',
    km: 'បំបែកឯកសាររណ្តៅអេឡិចត្រូនិចជាតារាងខុសគ្នាតាមបន្ទប់៖',
    es: 'El archivo de sierra electrónica se divide en diferentes tablas según la habitación:',
    ar: 'ملف المنشار الإلكتروني مقسم إلى جداول مختلفة الجداول حسب الغرفة:',
  },
  'electronicSaw.delimiter': {
    zh: '分隔符：',
    en: 'Delimiter:',
    id: 'Pembatas:',
    kz: 'бөлімші:',
    th: 'ตัวคั่น:',
    ug: 'ئايرىغۇچ بەلگە:',
    vi: 'Dấu phân cách:',
    zh_tc: '分隔符：',
    ru: 'Разделитель:',
    ko: '구분자:',
    bur: 'ခွဲခြားအမှတ်:',
    ben: 'ডিলিমিটার:',
    tr: 'Ayırıcı:',
    km: 'តួខ្សែញែក៖',
    es: 'Separador:',
    ar: 'الفاصل:',
  },
  'electronicSaw.fileName': {
    zh: '开料清单文件名：',
    en: 'Cutting List File NameEncoding:',
    id: 'Nama file Bill of Material:',
    kz: 'Файл атауы для список материалдар:',
    th: 'ชื่อไฟล์ของ Bill of Material:',
    ug: 'كېسىش تىزىملىكى ھۆججەت نامى:',
    vi: 'Tên tệp danh sách tài liệu màu cắt:',
    zh_tc: '開料清單文件名：',
    ru: 'Имя файла открытого списка:',
    ko: '커팅 리스트 파일 이름:',
    bur: 'ဖြတ်တောက်စာရင်း ဖိုင်အမည်:',
    ben: 'কাটিং লিস্ট ফাইল নাম:',
    tr: 'Kesim listesi dosya adı:',
    km: 'ឈ្មោះឯកសារបញ្ជីកាត់៖',
    es: 'Nombre del archivo de la lista de corte de material:',
    ar: 'اسم ملف قائمة قطع المواد:',
  },
  'electronicSaw.fineNameTip': {
    zh: '开料清单文件名不能为空！',
    en: 'Open list file name cannot be empty!',
    id: 'Nama file Bill of Material tidak bisa kosong!',
    kz: 'Tên tệp danh sách cắt không được để trống!',
    th: 'ชื่อไฟล์ของใบเรียกเก็บเงินไม่สามารถว่างเปล่าได้!',
    ug: 'كېسىش تىزىملىكى ھۆججەت نامى قۇرۇق قالسا بولمايدۇ!',
    vi: 'Mở danh sách tập tin tên không phải là trống rỗng!',
    zh_tc: '開料清單文件名不能為空！',
    ru: 'Имя файла открытого списка не может быть пустым!',
    ko: '커팅 리스트 파일 이름은 비워둘 수 없습니다.',
    bur: 'ဖြတ်တောက်စာရင်း ဖိုင်အမည် မဗလာဖြစ်ရပါ!',
    ben: 'কাটিং লিস্ট ফাইল নাম খালি হতে পারে না!',
    tr: 'Kesim listesi dosya adı boş olamaz!',
    km: 'ឈ្មោះឯកសារបញ្ជីកាត់មិនអាចទទេ!',
    es: '¡El nombre del archivo de la lista de corte de material no puede estar vacío!',
    ar: 'لا يمكن أن يكون اسم ملف قائمة قطع المواد فارغًا!',
  },
  'electronicSaw.fileNamePlaceholder': {
    zh: '自定义开料清单',
    en: 'Custom Cutting List',
    id: 'Kustomisasi Bill of Material',
    kz: 'Өзіңіздің материалдар тізімі',
    th: 'ปรับแต่งบิลวัสดุ',
    ug: 'ئۆزى بەلگىلىگەن كېسىش تىزىملىكى',
    vi: 'Tên tùy chỉnh danh sách tài liệu màu cắt',
    zh_tc: '自定義開料清單',
    ru: 'Настройка списка открытых материалов',
    ko: '사용자 정의 커팅 리스트',
    bur: 'စိတ်ကြိုက် ဖြတ်တောက်စာရင်း',
    ben: 'কাস্টম কাটিং লিস্ট',
    tr: 'Özel kesim listesi',
    km: 'បញ្ជីកាត់តាមបំណង',
    es: 'Lista de materiales personalizada',
    ar: 'قائمة المواد المخصصة',
  },
  'electronicSaw.outputFileEncoding': {
    zh: '输出清单编码格式：',
    en: 'Output list encoding format:',
    id: 'Format Pengkodean Daftar Output:',
    kz: 'Выходні кодирування формату:',
    th: 'รูปแบบการเข้ารหัสรายการเอาต์พุต:',
    ug: 'چىقىرىش تىزىملىكى كودلاش فورماتى:',
    vi: 'Định dạng mã hóa tệp đầu ra:',
    zh_tc: '輸出清單編碼格式：',
    ru: 'Формат кодирования выходного списка:',
    ko: '출력 인벤토리 인코딩 형식:',
    bur: 'အထွက်စာရင်း အင်ကုဒ် ဖော်မတ်:',
    ben: 'আউটপুট লিস্ট এনকোডিং ফরম্যাট:',
    tr: 'Çıktı listesi kodlama biçimi:',
    km: 'ទ្រង់ទ្រាយកូដបញ្ជីចេញ៖',
    es: 'Formato de codificación de lista de salida:',
    ar: 'تنسيق ترميز قائمة المخرجات:',
  },
  'electronicSaw.utf8': {
    zh: 'UTF-8带BOM',
    en: 'UTF-8 with BOM',
    id: 'UTF-8 dengan bom',
    kz: 'UTF-8 боммен',
    th: 'UTF-8 พร้อม BOM',
    ug: 'BOM لىق UTF-8',
    vi: 'UTF-8 với BOM',
    zh_tc: 'UTF-8帶BOM',
    ru: 'UTF - 8 с BOM',
    ko: 'UTF-8 및 BOM',
    bur: 'BOM ပါသော UTF-8',
    ben: 'BOMসহ UTF-8',
    tr: 'UTF-8 BOM ile',
    km: 'UTF-8 មាន BOM',
    es: 'UTF-8 con BOM',
    ar: 'UTF-8 مع BOM',
  },
  'electronicSaw.cellTab': {
    zh: '生成单元格制表符：',
    en: 'Generate Cell Tabulators:',
    id: 'Hasilkan Tab Sel:',
    kz: 'Ұяшаларды табулатура қалыптастыру:',
    th: 'สร้างแท็บเซลล์:',
    ug: 'كاتەكچە بەلگىسى ھاسىل قىلىش:',
    vi: 'Tạo dấu tab ô biểu:',
    zh_tc: '生成單元格制表符：',
    ru: 'Создать табуляцию ячеек:',
    ko: '셀 탭을 생성하려면 다음과 같이 하십시오.',
    bur: 'ဆဲလ် တැබ်(\t) ကို ဖန်တီးပါ:',
    ben: 'সেল ট্যাব(\t) তৈরি করুন:',
    tr: 'Hücre sekme oluştur:',
    km: 'បង្កើតថេបក្រឡា៖',
    es: 'Generar pestaña de celda:',
    ar: 'إنشاء علامة تبويب خلية:',
  },
  'electronicSaw.texture': {
    zh: '纹理表示：',
    en: 'Texture Representation:',
    id: 'Representasi Tekstur:',
    kz: 'Текстурасын көрсету:',
    th: 'การแสดงพื้นผิว:',
    ug: 'تېكىستۇرا كۆرسىتىش:',
    vi: 'Biểu diễn kết cấu:',
    zh_tc: '紋理表示：',
    ru: 'Текстура означает:',
    ko: '텍스쳐 표현:',
    bur: 'အရုပ်အဆင်း(纹理) ဖော်ပြပုံ:',
    ben: 'টেক্সচার প্রদর্শন:',
    tr: 'Doku gösterimi:',
    km: 'ការបង្ហាញវាល៖',
    es: 'Representación de textura:',
    ar: 'تمثيل الملمس:',
  },
  'electronicSaw.special': {
    zh: '异形表示：',
    en: 'Special Shape Representation:',
    id: 'Representasi ekstra berbentuk:',
    kz: 'Арнайы пішіру:',
    th: 'การแสดงรูปพิเศษ:',
    ug: 'ئالاھىدە شەكىل كۆرسىتىش:',
    vi: 'Biểu diễn hình không đều:',
    zh_tc: '異形表示：',
    ru: 'Инородное представление:',
    ko: '이형 표현:',
    bur: 'အထူးပုံစံ(异形) ဖော်ပြပုံ:',
    ben: 'বিশেষ আকৃতি (ইরেগুলার) প্রদর্শন:',
    tr: 'Özel şekil gösterimi:',
    km: 'ការបង្ហាញរូបរាងពិសេស៖',
    es: 'Representación con forma especial:',
    ar: 'تمثيل ذو شكل خاص:',
  },
  'electronicSaw.notSpecial': {
    zh: '不是异形',
    en: 'Not a Special Shape',
    id: 'Bukan alien',
    kz: 'Арнайы емес',
    th: 'ไม่ใช่คนต่างด้าว',
    ug: 'ئالاھىدە شەكىل ئەمەس',
    vi: 'Không phải hình không đều',
    zh_tc: '不是異形',
    ru: 'Не чужеродный.',
    ko: '이형이 아니다',
    bur: 'အထူးပုံစံ မဟုတ်ပါ',
    ben: 'বিশেষ আকৃতি নয়',
    tr: 'Özel şekil değil',
    km: 'មិនមែនរូបរាងពិសេស',
    es: 'Sin forma especial',
    ar: 'ليس ذو شكل خاص',
  },
  'electronicSaw.genSimpleLabelBarcode': {
    zh: '生成简易格式标签条码',
    en: 'Generate Simple Format Label Barcode',
    id: 'Hasilkan Barcode Tag Format Sederhana',
    kz: 'Қарапайым форматтағы тегтер мен штрих-кодтарды генерау',
    th: 'สร้างบาร์โค้ดแท็กแบบง่าย ๆ',
    ug: 'ئاددىي فورماتلىق بەلگە شتىرىخ كودى ھاسىل قىلىش',
    vi: 'Tạo mã vạch nhãn mãc đơn giản',
    zh_tc: '生成簡易格式標籤條碼',
    ru: 'Создание штрих - кода для тегов простого формата',
    ko: '간단한 형식 태그 바코드 생성',
    bur: 'ရိုးရှင်းဖော်မတ် တက်ဂ် ဘားကုဒ် ဖန်တီး',
    ben: 'সহজ ফরম্যাট লেবেল বারকোড তৈরি করুন',
    tr: 'Basit biçimli etiket barkodu oluştur',
    km: 'បង្កើតបារកូដស្លាកទ្រង់ទ្រាយសាមញ្ញ',
    es: 'Generar código de barras de etiqueta de formato simple',
    ar: 'إنشاء رمز شريطي للتسمية بتنسيق بسيط',
  },
  'electronicSaw.uniqueBarCode': {
    zh: '板件条码唯一',
    en: 'Unique barcode for the plate',
    id: 'Barcode yang unik',
    kz: 'Қаптама штрих-коды бірегей',
    th: 'บาร์โค้ดที่ไม่ซ้ำกัน',
    ug: 'تاختا شتىرىخ كودى يەككە',
    vi: 'Mã Vạch Bàn Duy Nhất',
    zh_tc: '板件條碼唯一',
    ru: 'Уникальный штрих - код.',
    ko: '보드 바코드 고유',
    bur: 'ဘုတ်အစိတ်အပိုင်း ဘားကုဒ် တစ်မူထူးခြား',
    ben: 'বোর্ডের বারকোড ইউনিক',
    tr: 'Levha için benzersiz barkod',
    km: 'បារកូដតែមួយសម្រាប់ផ្ទាំង',
    es: 'Código de barras de placa único',
    ar: 'لوحة الباركود فريدة من نوعها',
  },
  'electronicSaw.uniqueBarCodeTip': {
    zh: '开启后生成简易格式标签条码功能不生效',
    en: 'Generate simple format label barcode function does not work after enabled',
    id: 'Fungsi menghasilkan barcode tag format sederhana setelah pembukaan tidak berlaku',
    kz: 'Активталғаннан кейін жалпы пішіндік тег баркод функциясы қолданылмайды',
    th: 'ฟังก์ชั่นของการสร้างบาร์โค้ดแท็กรูปแบบง่าย ๆ หลังจากเปิดไม่มีผล',
    ug: 'قوزغاتقاندىن كېيىن ئاددىي فورماتلىق بەلگە شتىرىخ كودى ھاسىل قىلىش ئىقتىدارى ئۈنۈمسىز',
    vi: 'Khi được kích hoạt, chức năng tạo mã vạch nhãn mãc đơn giản sẽ không được kích hoạt',
    zh_tc: '開啟後生成簡易格式標籤條碼功能不生效',
    ru: 'Создать простой формат после открытия функции штрих - кода не работает',
    ko: '오픈 후 간이 형식 태그 바코드 생성 기능이 적용되지 않음',
    bur: 'ဖွင့်ပြီးနောက် “ရိုးရှင်းဖော်မတ် တက်ဂ် ဘားကုဒ်ဖန်တီး” လုပ်ဆောင်ချက် မအလုပ်လုပ်တော့ပါ',
    ben: 'এটি চালু করলে “সহজ ফরম্যাট লেবেল বারকোড তৈরি” ফিচারটি কাজ করবে না',
    tr: 'Açıldığında basit biçimli etiket barkodu oluşturma çalışmaz',
    km: 'បន្ទាប់ពីបើក មុខងារបង្កើតបារកូដស្លាកទ្រង់ទ្រាយសាមញ្ញមិនដំណើរការ',
    es: 'La función de generar código de barras de etiqueta de formato simple no tiene efecto después de activarla',
    ar: 'لا تصبح وظيفة إنشاء باركود تسمية بسيط التنسيق سارية المفعول بعد تشغيلها',
  },
  'electronicSaw.roboticArmDocking': {
    zh: '机械臂对接',
    en: 'Robotic Arm Docking',
    id: 'Robotic Arm Docking',
    kz: 'Роботтық қолдағышты орнату',
    th: 'การติดต่อกับมอลเลอร์หุ่นยนต์',
    ug: 'روبوت ھەرە ئالماشتۇرۇش',
    vi: 'Kết nối cơ cấu robot',
    zh_tc: '機械臂對接',
    ru: 'стык манипулятора',
    ko: '로봇 암 도킹',
    bur: 'စက်လက်မောင်း ချိတ်ဆက်မှု',
    ben: 'রোবটিক আর্ম ডকিং',
    tr: 'Robot kol bağlantısı',
    km: 'ការភ្ជាប់ដៃរបស់រូបយន្ត',
    es: 'Acoplamiento del brazo robótico',
    ar: 'إرساء الذراع الروبوتية',
  },
  'electronicSaw.customeForm': {
    zh: '自定义表单',
    en: 'Custom Form',
    id: 'Formulir Kustom',
    kz: 'Өзіңіздің нысандар',
    th: 'รูปแบบที่กำหนดเอง',
    ug: 'ئۆزى بەلگىلىگەن جەدۋەل',
    vi: 'Biểu mẫu tùy chỉnh',
    zh_tc: '自定義表單',
    ru: 'Настройка формы',
    ko: '사용자 지정 양식',
    bur: 'စိတ်ကြိုက် ဖောင်',
    ben: 'কাস্টম ফর্ম',
    tr: 'Özel form',
    km: 'ទម្រង់តាមបំណង',
    es: 'Formulario personalizado',
    ar: 'نموذج مخصص',
  },
  'electronicSaw.tagPool': {
    zh: '数据标签池',
    en: 'Data Tag Pool',
    id: 'Kumpulan tag data',
    kz: 'Деректер тегтер жинағы',
    th: 'พูลแท็กข้อมูล',
    ug: 'سانلىق مەلۇمات بەلگە ئامبىرى',
    vi: 'Hồ bơi nhãn dữ liệu',
    zh_tc: '數據標籤池',
    ru: 'Пул тегов данных',
    ko: '데이터 태그 풀',
    bur: 'ဒေတာ တက်ဂ် အစု',
    ben: 'ডেটা ট্যাগ পুল',
    tr: 'Veri etiket havuzu',
    km: 'អាងស្លាកទិន្នន័យ',
    es: 'Grupo de etiquetas de datos',
    ar: 'تجمع علامات البيانات',
  },
  'electronicSaw.tagPoolTips': {
    zh: '可拖拽或点击复制标签池内标签',
    en: 'Drag and Drop or Click to Copy Tags from the Tag Pool',
    id: 'Anda dapat menyeret atau mengklik untuk menyalin tag di pool',
    kz: 'Тегтер жинағынан тегтерді сүйрету немесе көшірмелеуге басыңыз',
    th: 'คุณสามารถลากหรือคลิกเพื่อคัดลอกแท็กในพูล',
    ug: 'بەلگە ئامبىرىدىكى بەلگىلەرنى سۆرەپ ياكى چېكىپ كۆچۈرگىلى بولىدۇ',
    vi: 'Có thể kéo hoặc nhấn để sao chép nhãn từ hồ bơi nhãn dữ liệu',
    zh_tc: '可拖拽或點擊複製標籤池內標籤',
    ru: 'Можно перетаскивать или нажимать кнопку Скопировать вкладки внутри пула',
    ko: '태그 풀의 태그를 드래그하거나 클릭하여 복사할 수 있습니다.',
    bur: 'တက်ဂ်အစုမှ တက်ဂ်များကို ဆွဲယူရန် သို့မဟုတ် နှိပ်၍ ကူးယူနိုင်သည်',
    ben: 'ট্যাগ পুলের ট্যাগগুলো ড্র্যাগ করুন বা ক্লিক করে কপি করুন',
    tr: 'Etiket havuzundan etiketleri sürükleyin veya kopyalamak için tıklayın',
    km: 'អូសឬចុចដើម្បីចម្លងស្លាកពីអាងស្លាក',
    es: 'Puede arrastrar o hacer clic para copiar la etiqueta en el grupo de etiquetas',
    ar: 'يمكنك السحب أو النقر لنسخ الملصق في مجموعة الملصقات',
  },
  'electronicSaw.displayHead': {
    zh: '不显示表头',
    en: 'Hide Table Header',
    id: 'Jangan menampilkan header',
    kz: 'Кестенің бастысын көрсетпеу',
    th: 'อย่าแสดงส่วนหัว',
    ug: 'جەدۋەل بېشىنى كۆرسەتمەسلىك',
    vi: 'Không hiển thị tiêu đề biểu',
    zh_tc: '不顯示表頭',
    ru: 'Не показывать заголовок',
    ko: '머리글 표시 안 함',
    bur: 'ဇယားခေါင်းစီး မပြပါ',
    ben: 'টেবিল হেডার দেখাবেন না',
    tr: 'Tablo başlığını gizle',
    km: 'មិនបង្ហាញក្បាលតារាង',
    es: 'No mostrar el encabezado',
    ar: 'لا تعرض الرأس',
  },
  'electronicSaw.addTableHead': {
    zh: '添加表头',
    en: 'Add Table Header',
    id: 'Tambahkan header',
    kz: 'Кестенің бастысын қосу',
    th: 'เพิ่มส่วนหัว',
    ug: 'جەدۋەل بېشى قوشۇش',
    vi: 'Thêm tiêu đề biểu',
    zh_tc: '添加表頭',
    ru: 'Добавить заголовок',
    ko: '헤더 추가',
    bur: 'ဇယားခေါင်းစီး ထည့်ပါ',
    ben: 'টেবিল হেডার যোগ করুন',
    tr: 'Tablo başlığı ekle',
    km: 'បន្ថែមក្បាលតារាង',
    es: 'Agregar encabezado',
    ar: 'إضافة رأس',
  },
  'electronicSaw.deleteTableHead': {
    zh: '删除表头',
    en: 'Delete Table Header',
    id: 'Hapus tajuk meja',
    kz: 'Кестенің бастысын жою',
    th: 'ลบส่วนหัวของตาราง',
    ug: 'جەدۋەل بېشىنى ئۆچۈرۈش',
    vi: 'Xóa tiêu đề biểu',
    zh_tc: '刪除表頭',
    ru: 'Удалить заголовок',
    ko: '헤더 삭제',
    bur: 'ဇယားခေါင်းစီး ဖျက်ပါ',
    ben: 'টেবিল হেডার মুছুন',
    tr: 'Tablo başlığını sil',
    km: 'លុបក្បាលតារាង',
    es: 'Eliminar encabezado',
    ar: 'حذف رأس',
  },
  'electronicSaw.generateExample': {
    zh: '生成输出表单样例',
    en: 'Generate Output Form Example',
    id: 'Menghasilkan sampel formulir output',
    kz: 'Выходні нысандар үлгісіні генерау',
    th: 'สร้างตัวอย่างแบบฟอร์มเอาต์พุต',
    ug: 'چىقىرىش جەدۋىلى مىسالى ھاسىل قىلىش',
    vi: 'Tạo mẫu biểu mẫu đầu ra',
    zh_tc: '生成輸出表單樣例',
    ru: 'Создать образец формы вывода',
    ko: '출력 양식 샘플 생성하기',
    bur: 'အထွက်ဖောင် နမူနာ ဖန်တီး',
    ben: 'আউটপুট ফর্ম নমুনা তৈরি করুন',
    tr: 'Çıktı formu örneği oluştur',
    km: 'បង្កើតគំរូទម្រង់ចេញ',
    es: 'Generar muestra de formulario de salida',
    ar: 'إنشاء عينة نموذج الإخراج',
  },
  'electronicSaw.importExample': {
    zh: '导入表单样例',
    en: 'Import Form Example',
    id: 'Sampel bentuk impor',
    kz: 'Нысандар үлгісін імпорттау',
    th: 'ตัวอย่างแบบฟอร์มนำเข้า',
    ug: 'جەدۋەل مىسالى كىرگۈزۈش',
    vi: 'Nhập mẫu biểu mẫu',
    zh_tc: '導入表單樣例',
    ru: 'Импорт образца формы',
    ko: '양식 샘플 가져오기',
    bur: 'ဖောင် နမူနာ တင်သွင်း',
    ben: 'ফর্ম নমুনা ইমপোর্ট করুন',
    tr: 'Form örneğini içe aktar',
    km: 'នាំចូលគំរូទម្រង់',
    es: 'Importar muestra de formulario',
    ar: 'عينة نموذج الاستيراد',
  },
  'electronicSaw.importExampleTip': {
    zh: '导入的表单样例，仅供自定义电子锯参考',
    en: 'The imported form example is only for reference when customizing the electronic saw',
    id: 'Contoh bentuk yang diimpor, hanya untuk referensi gergaji elektronik khusus',
    kz: 'Імпортталған нысандар үлгісі электронды пісіру машинасының өзіңіздің нысандарыңызға референс болып табылады',
    th: 'ตัวอย่างแบบฟอร์มนำเข้าสำหรับการอ้างอิงเลื่อยอิเล็กทรอนิกส์แบบกำหนดเองเท่านั้น',
    ug: 'كىرگۈزۈلگەن جەدۋەل مىسالى پەقەت ئۆزى بەلگىلىگەن ئېلېكترونلۇق ھەرە ئۈچۈن پايدىلىنىش',
    vi: 'Mẫu biểu mẫu nhập, chỉ dùng làm tham khảo cho máy cưa điện tử tùy chỉnh',
    zh_tc: '導入的表單樣例，僅供自定義電子鋸參考',
    ru: 'Импортировать образец формы только для ссылки на пользовательскую электронную пилу',
    ko: '사용자 정의 전자 톱에서만 참조할 수 있는 가져온 양식 예제',
    bur: 'တင်သွင်းထားသော ဖောင်နမူနာသည် အီလက်ထရွန်းနစ်လွှ စိတ်ကြိုက်ပြုလုပ်ရာတွင် ကိုးကားရန်သာ ဖြစ်သည်',
    ben: 'ইমপোর্ট করা ফর্ম নমুনা শুধুমাত্র ইলেকট্রনিক স’ কাস্টমাইজ করার জন্য রেফারেন্স',
    tr: 'İçe aktarılan form örneği yalnızca elektronik testere özelleştirme için referanstır',
    km: 'គំរូទម្រង់ដែលនាំចូលសម្រាប់យោងតែប៉ុណ្ណោះពេលកំណត់រណ្តៅអេឡិចត្រូនិច',
    es: 'Muestra de formulario importada, solo como referencia para sierras electrónicas personalizadas',
    ar: 'عينة نموذج مستوردة، كمرجع فقط للمناشير الإلكترونية المخصصة',
  },
  'electronicSaw.importExampleErrTip': {
    zh: '还没有导入原料单，请导入原料单',
    en: 'No material list has been imported, please import the material list first',
    id: 'Daftar bahan baku belum diimpor, harap impor daftar bahan baku',
    kz: 'Материалдар тізімі әлі імпортталмаған, материалдар тізімін імпорттау',
    th: 'รายการวัตถุดิบยังไม่ได้นำเข้าโปรดนำเข้ารายการวัตถุดิบ',
    ug: 'تېخى ماتېرىيال تىزىملىكى كىرگۈزۈلمىدى، ماتېرىيال تىزىملىكىنى كىرگۈزۈڭ',
    vi: 'Chưa nhập danh sách nguyên liệu, vui lòng nhập danh sách nguyên liệu',
    zh_tc: '還沒有導入原料單，請導入原料單',
    ru: 'Пока нет списка импортируемого сырья, пожалуйста, импортируйте список сырья',
    ko: '아직 원단을 가져오지 않았습니다. 원단을 가져오십시오.',
    bur: 'ကုန်ကြမ်းစာရင်းကို မတင်သွင်းရသေးပါ၊ အရင်ဆုံး ကုန်ကြမ်းစာရင်းကို တင်သွင်းပါ',
    ben: 'এখনো ম্যাটেরিয়াল লিস্ট ইমপোর্ট করা হয়নি, আগে ম্যাটেরিয়াল লিস্ট ইমপোর্ট করুন',
    tr: 'Ham malzeme listesi içe aktarılmadı; lütfen önce içe aktarın',
    km: 'មិនទាន់នាំចូលបញ្ជីសម្ភារៈដើម សូមនាំចូលមុន',
    es: 'La lista de materiales no ha sido importada aún, importe la lista de materiales',
    ar: 'تحتوي قائمة المواد على لم يتم استيرادها بعد، يرجى استيراد قائمة المواد',
  },
  'electronicSaw.outputExample': {
    zh: '输出表单样例',
    en: 'Output Form Example',
    id: 'Sampel formulir output',
    kz: 'Выходні нысандар үлгісі',
    th: 'ตัวอย่างแบบฟอร์มเอาต์พุต',
    ug: 'چىقىرىش جەدۋىلى مىسالى',
    vi: 'Mẫu biểu mẫu đầu ra',
    zh_tc: '輸出表單樣例',
    ru: 'Пример формы вывода',
    ko: '샘플 출력 양식',
    bur: 'အထွက်ဖောင် နမူနာ',
    ben: 'আউটপুট ফর্ম নমুনা',
    tr: 'Çıktı formu örneği',
    km: 'គំរូទម្រង់ចេញ',
    es: 'Muestra de formulario de salida',
    ar: 'نموذج نموذج الإخراج',
  },
  'electronicSaw.outputExampleTip': {
    zh: '自定义表单的输出样例',
    en: 'Output example of the custom form',
    id: 'Contoh output formulir khusus',
    kz: 'Өзіңіздің нысандарыңыздың выходні үлгісі',
    th: 'ตัวอย่างผลลัพธ์ของแบบฟอร์มที่กำหนดเอง',
    ug: 'ئۆزى بەلگىلىگەن جەدۋەلنىڭ چىقىرىش مىسالى',
    vi: 'Mẫu đầu ra của biểu mẫu tùy chỉnh',
    zh_tc: '自定義表單的輸出樣例',
    ru: 'Настройка шаблона вывода формы',
    ko: '사용자 정의 양식의 출력 예제',
    bur: 'စိတ်ကြိုက်ဖောင်၏ အထွက် နမူနာ',
    ben: 'কাস্টম ফর্মের আউটপুট নমুনা',
    tr: 'Özel formun çıktı örneği',
    km: 'គំរូចេញនៃទម្រង់តាមបំណង',
    es: 'Muestra de salida de formulario personalizado',
    ar: 'نموذج إخراج النموذج المخصص',
  },
  'electronicSaw.outputExampleErrTip': {
    zh: '还没有生成输出表单样例，请生成输出表单样例',
    en: 'No output form example has been generated, please generate one first',
    id: 'Sampel formulir output belum dihasilkan, harap hasilkan sampel formulir output',
    kz: 'Выходні нысандар үлгісі әлі генералмаған, выходні нысандар үлгісі генерау',
    th: 'ตัวอย่างแบบฟอร์มเอาต์พุตยังไม่ได้รับการสร้างโปรดสร้างตัวอย่างแบบฟอร์มเอาต์พุต',
    ug: 'تېخى چىقىرىش جەدۋىلى مىسالى ھاسىل قىلىنمىدى، چىقىرىش جەدۋىلى مىسالى ھاسىل قىلىڭ',
    vi: 'Chưa tạo mẫu biểu mẫu đầu ra, vui lòng tạo mẫu biểu mẫu đầu ra',
    zh_tc: '還沒有生成輸出表單樣例，請生成輸出表單樣例',
    ru: 'Образец формы вывода еще не создан, создайте образец формы вывода',
    ko: '출력 양식 샘플이 생성되지 않았습니다. 출력 양식 샘플을 생성하십시오.',
    bur: 'အထွက်ဖောင် နမူနာကို မဖန်တီးရသေးပါ၊ အရင်ဆုံး ဖန်တီးပါ',
    ben: 'আউটপুট ফর্ম নমুনা এখনো তৈরি হয়নি, আগে তৈরি করুন',
    tr: 'Çıktı formu örneği henüz oluşturulmadı; lütfen oluşturun',
    km: 'មិនទាន់បង្កើតគំរូទម្រង់ចេញ សូមបង្កើត',
    es: 'La muestra de formulario de salida aún no se ha generado, genere la muestra de formulario de salida',
    ar: 'لم يتم إنشاء نموذج نموذج الإخراج بعد، يرجى إنشاء نموذج نموذج الإخراج',
  },
  'electronicSaw.defaultTableHead': {
    zh: '默认表头',
    en: 'Default Table Header',
    id: 'Header default',
    kz: 'Кестенің әдетті бастысы',
    th: 'ส่วนหัวเริ่มต้น',
    ug: 'سۈكۈتتىكى جەدۋەل بېشى',
    vi: 'Tiêu đề biểu mặc định',
    zh_tc: '默認表頭',
    ru: 'Заголовок таблицы по умолчанию',
    ko: '기본 헤더',
    bur: 'စံသတ်မှတ် ဇယားခေါင်းစီး',
    ben: 'ডিফল্ট টেবিল হেডার',
    tr: 'Varsayılan tablo başlığı',
    km: 'ក្បាលតារាងលំនាំដើម',
    es: 'Encabezado predeterminado',
    ar: 'الرأس الافتراضي',
  },
  'electronicSaw.deleteHeadErrTip': {
    zh: '没有可以删除的表头!',
    en: 'No table header to delete!',
    id: 'Tidak ada header untuk dihapus!',
    kz: 'Жоюға болатын кестенің бастысы жоқ!',
    th: 'ไม่มีส่วนหัวที่จะลบ!',
    ug: 'ئۆچۈرگىلى بولىدىغان جەدۋەل بېشى يوق!',
    vi: 'Không có tiêu đề biểu để xóa!',
    zh_tc: '沒有可以刪除的表頭!',
    ru: 'Нет заголовков, которые можно удалить!',
    ko: '삭제할 수 있는 헤더가 없습니다!',
    bur: 'ဖျက်ရန် ဇယားခေါင်းစီး မရှိပါ!',
    ben: 'মুছার মতো কোনো টেবিল হেডার নেই!',
    tr: 'Silinecek tablo başlığı yok!',
    km: 'គ្មានក្បាលតារាងដើម្បីលុប!',
    es: '¡No hay ningún encabezado que pueda eliminarse!',
    ar: 'لا يوجد رأس يمكن حذفه!',
  },
  'electronicSaw.genNonString': {
    zh: '生成非文本格式数据类型',
    en: 'Generate non-text data type',
    id: 'Menghasilkan tipe data format non-teks',
    kz: 'Мәтіндік емес деректер түрін жасау',
    th: 'สร้างประเภทข้อมูลรูปแบบที่ไม่ใช่ข้อความ',
    ug: 'تېكىست فورماتى بولمىغان سانلىق مەلۇمات تىپى ھاسىل قىلىش',
    vi: 'Tạo loại dữ liệu không phải văn bản',
    zh_tc: '生成非文本格式數據類型',
    ru: 'Создание типов данных в нетекстовых форматах',
    ko: '텍스트 형식이 아닌 데이터 형식 생성하기',
    bur: 'စာသားမဟုတ်သော ဒေတာအမျိုးအစား ဖန်တီး',
    ben: 'নন-টেক্সট ডাটা টাইপ তৈরি করুন',
    tr: 'Metin olmayan veri türü oluştur',
    km: 'បង្កើតប្រភេទទិន្នន័យមិនមែនអត្ថបទ',
    es: 'Generar tipo de datos en formato sin texto',
    ar: 'إنشاء نوع بيانات بتنسيق غير نصي',
  },
  'electronicSaw.genNonStringTip': {
    zh: '生成的表格数据电子锯无法识别时可以尝试启用',
    en: 'Try enabling this when the generated table data cannot be recognized by the electronic saw',
    id: 'Anda dapat mencoba mengaktifkan data tabel yang dihasilkan jika gergaji elektronik tidak dikenali.',
    kz: 'Жасалған кесте деректері электронды арамен танылмай жатса, қосып көруге болады',
    th: 'คุณสามารถลองเปิดใช้งานข้อมูลตารางที่สร้างขึ้นหากไม่รู้จักเลื่อยอิเล็กทรอนิกส์',
    ug: 'ھاسىل قىلىنغان جەدۋەل سانلىق مەلۇماتىنى ئېلېكترونلۇق ھەرە تونۇيالمىغاندا قوزغىتىپ سىناپ بېقىڭ',
    vi: 'Thử bật tính năng này khi dữ liệu bảng được tạo ra không thể nhận diện bởi cưa điện',
    zh_tc: '生成的表格數據電子鋸無法識別時可以嘗試啟用',
    ru: 'Созданная таблица данных Электронная пила не может быть идентифицирована, если вы можете попытаться включить',
    ko: '생성된 테이블 데이터 전자톱이 인식되지 않을 경우 사용 가능',
    bur: 'ဖန်တီးထားသော ဇယားဒေတာကို အီလက်ထရွန်းနစ်လွှ မဖတ်နိုင်ပါက ဤကို ဖွင့်၍ စမ်းကြည့်ပါ',
    ben: 'তৈরি করা টেবিল ডাটা ইলেকট্রনিক স’ চিনতে না পারলে এটি চালু করে দেখুন',
    tr: 'Oluşturulan tablo verisini elektronik testere okuyamıyorsa etkinleştirmeyi deneyin',
    km: 'សាកល្បងបើកនៅពេលទិន្នន័យតារាងដែលបានបង្កើតមិនត្រូវបានរណ្តៅអេឡិចត្រូនិចស្គាល់',
    es: 'Si la sierra electrónica no puede reconocer los datos de la tabla generada, puede intentar habilitarlos.',
    ar: 'إذا لم يتمكن المنشار الإلكتروني من التعرف على بيانات الجدول التي تم إنشاؤها، فيمكنك محاولة تمكينها.',
  },
  'electronicSaw.revertWidth': {
    zh: '横纹板件长宽对调',
    en: 'Horizontal panel length and width adjustment',
    id: 'Penyesuaian Panjang dan Lebar',
    kz: 'Жолақты қабырға ұзындығы мен енін ауыстыру',
    th: 'แผ่นลายเส้นข้ามส่วนความยาวและความกว้างสอดคล้องกัน',
    ug: 'ئەرەك بارماق چېكىنىڭ ئۇزۇنلىقى بىلەن كېڭلىقىنى ئالماشتۇرۇش',
    vi: 'Vân dọc tấm đổi chiều dài và chiều rộng',
    zh_tc: '橫紋板件長寬對調',
    ru: 'Длина и ширина поперечных пластин',
    ko: '가로무늬 판재 너비 조정',
    bur: 'အလျား纹(横纹) ဘုတ်၏ အလျား/အနံ ကို လဲလှယ်',
    ben: 'আড়াআড়ি দানাযুক্ত বোর্ডের দৈর্ঘ্য/প্রস্থ সোয়াপ',
    tr: 'Dokulu levhanın uzunluk ve genişliğini değiştir',
    km: 'ប្តូរប្រវែង និងទទឹងផ្ទាំងក្បាលររង់',
    es: 'Intercambiar el largo y el ancho de los paneles con rayas horizontales',
    ar: 'تبديل طول وعرض الألواح المخططة الأفقية',
  },
  'lockModal.passwordInput': {
    zh: '请输入密码',
    en: 'Please enter the password',
    id: 'Harap masukkan kata sandi Anda',
    kz: 'Құпия сөзді енгізу',
    th: 'กรุณากรอกรหัสผ่านของคุณ',
    ug: 'پارولنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập mật khẩu',
    zh_tc: '請輸入密碼',
    ru: 'Введите пароль',
    ko: '비밀번호를 입력하세요',
    bur: 'စကားဝှက်ကို ထည့်ပါ',
    ben: 'পাসওয়ার্ড লিখুন',
    tr: 'Parolayı girin',
    km: 'បញ្ចូលពាក្យសម្ងាត់',
    es: 'Por favor ingrese la contraseña',
    ar: 'الرجاء إدخال كلمة المرور',
  },
  'lockModal.lockPassword': {
    zh: '锁定密码',
    en: 'Unlock Password',
    id: 'Kata sandi buka kunci',
    kz: 'Құпия сөзді ашу ұсын',
    th: 'รหัสผ่านปลดล็อก',
    ug: 'قۇلۇپ ئېچىش پارولى',
    vi: 'Mật khẩu khóa',
    zh_tc: '鎖定密碼',
    ru: 'Блокировать пароль',
    ko: '잠금 암호',
    bur: 'သော့ဖွင့် စကားဝှက်',
    ben: 'আনলক পাসওয়ার্ড',
    tr: 'Kilit parolası',
    km: 'ពាក្យសម្ងាត់ចាក់សោ',
    es: 'Contraseña de bloqueo',
    ar: 'كلمة مرور القفل',
  },
  'lockModal.lockPasswordInput': {
    zh: '请输入解锁密码',
    en: 'Please enter the unlock password',
    id: 'Harap masukkan kata sandi buka kunci',
    kz: 'Құпия сөзді ашу ұсын',
    th: 'กรุณากรอกรหัสผ่านปลดล็อค',
    ug: 'قۇلۇپ ئېچىش پارولىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập mật khẩu mở khóa',
    zh_tc: '請輸入解鎖密碼',
    ru: 'Введите пароль разблокировки',
    ko: '잠금 해제 암호를 입력하십시오.',
    bur: 'သော့ဖွင့် စကားဝှက်ကို ထည့်ပါ',
    ben: 'আনলক পাসওয়ার্ড লিখুন',
    tr: 'Kilidi açma parolasını girin',
    km: 'បញ្ចូលពាក្យសម្ងាត់បើកសោ',
    es: 'Ingrese la contraseña de desbloqueo',
    ar: 'يرجى إدخال كلمة مرور إلغاء القفل',
  },
  'lockModal.passwordInputPlaceholder': {
    zh: '请输入四位数密码',
    en: 'Please enter a four-digit password',
    id: 'Harap masukkan kata sandi empat digit',
    kz: 'Төрт таңбалық құпия сөзді енгізу',
    th: 'โปรดป้อนรหัสผ่านสี่หลัก',
    ug: 'تۆت خانىلىق پارولنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập mật khẩu bốn chữ số',
    zh_tc: '請輸入四位數密碼',
    ru: 'Введите четырехзначный код.',
    ko: '네 자리 비밀번호를 입력하십시오.',
    bur: 'ဂဏန်း ၄ လုံး စကားဝှက်ကို ထည့်ပါ',
    ben: '৪ সংখ্যার পাসওয়ার্ড লিখুন',
    tr: 'Dört haneli parola girin',
    km: 'បញ្ចូលពាក្យសម្ងាត់ ៤ ខ្ទង់',
    es: 'Ingrese la contraseña de cuatro dígitos',
    ar: 'يرجى إدخال كلمة المرور المكونة من أربعة أرقام',
  },
  'lockModal.editPassword': {
    zh: '修改密码',
    en: 'Change password',
    id: 'Ubah Kata Sandi',
    kz: 'Құпия сөзіні өңдеу',
    th: 'แก้ไขรหัสผ่าน',
    ug: 'پارولنى ئۆزگەرتىش',
    vi: 'Chỉnh sửa mật khẩu',
    zh_tc: '修改密碼',
    ru: 'изменить пароль',
    ko: '암호 수정',
    bur: 'စကားဝှက် ပြောင်းရန်',
    ben: 'পাসওয়ার্ড পরিবর্তন করুন',
    tr: 'Parolayı değiştir',
    km: 'ផ្លាស់ប្តូរពាក្យសម្ងាត់',
    es: 'Cambiar contraseña',
    ar: 'تغيير كلمة المرور',
  },
  'lockModal.confirmPassword': {
    zh: '确认密码',
    en: 'Confirm password',
    id: 'Konfirmasi Kata Sandi',
    kz: 'Құпия сөзіні растау',
    th: 'ยืนยันรหัสผ่าน',
    ug: 'پارولنى جەزملەش',
    vi: 'Xác nhận mật khẩu',
    zh_tc: '確認密碼',
    ru: 'Подтверждение пароля',
    ko: '암호 확인',
    bur: 'စကားဝှက် အတည်ပြုရန်',
    ben: 'পাসওয়ার্ড নিশ্চিত করুন',
    tr: 'Parolayı onayla',
    km: 'បញ្ជាក់ពាក្យសម្ងាត់',
    es: 'Confirmar contraseña',
    ar: 'تأكيد كلمة المرور',
  },
  'lockModal.setLockPwd': {
    zh: '设置解锁密码',
    en: 'Set Unlock Password',
    id: 'Setel Kata Sandi Buka Kunci',
    kz: 'Құпия сөзді ашу ұсын',
    th: 'ตั้งค่ารหัสผ่านปลดล็อก',
    ug: 'قۇلۇپ ئېچىش پارولىنى بەلگىلەش',
    vi: 'Đặt mật khẩu mở khóa',
    zh_tc: '設定解鎖密碼',
    ru: 'Настройка пароля разблокировки',
    ko: '잠금 해제 암호 설정',
    bur: 'သော့ဖွင့် စကားဝှက် သတ်မှတ်ရန်',
    ben: 'আনলক পাসওয়ার্ড সেট করুন',
    tr: 'Kilidi açma parolasını ayarla',
    km: 'កំណត់ពាក្យសម្ងាត់បើកសោ',
    es: 'Establezca la contraseña de desbloqueo',
    ar: 'تعيين كلمة مرور إلغاء القفل',
  },
  'lockModal.pwdFormatErr': {
    zh: '密码格式错误',
    en: 'Incorrect password format',
    id: 'Kesalahan format kata sandi',
    kz: 'Құпия сөздің пішімі дұрыс емес',
    th: 'ข้อผิดพลาดรูปแบบรหัสผ่าน',
    ug: 'پارول فورماتى خاتا',
    vi: 'Định dạng mật khẩu không đúng',
    zh_tc: '密碼格式錯誤',
    ru: 'Ошибка формата пароля',
    ko: '암호 형식 오류',
    bur: 'စကားဝှက် ဖော်မတ် မမှန်ပါ',
    ben: 'পাসওয়ার্ড ফরম্যাট ভুল',
    tr: 'Parola biçimi hatalı',
    km: 'ទ្រង់ទ្រាយពាក្យសម្ងាត់មិនត្រឹមត្រូវ',
    es: 'Formato de contraseña incorrecto',
    ar: 'تنسيق كلمة مرور خاطئة',
  },
  'lockModal.sendMessageTo': {
    zh: '短信验证码将发送至',
    en: 'SMS verification code will be sent to',
    id: 'Kode verifikasi SMS akan dikirim ke',
    kz: 'Кодты смс-хабарламашы',
    th: 'รหัสการตรวจสอบ SMS จะถูกส่งไปยัง',
    ug: 'قىسقا ئۇچۇر دەلىللەش كودى ئەۋەتىلىدىغان نومۇر',
    vi: 'Mã xác nhận SMS sẽ được gửi đến',
    zh_tc: '簡訊驗證碼將發送至',
    ru: 'Код проверки SMS будет отправлен',
    ko: '문자 인증 코드가 다음으로 전송됩니다.',
    bur: 'SMS အတည်ပြုကုဒ်ကို ပို့မည့်နေရာ',
    ben: 'SMS যাচাই কোড পাঠানো হবে',
    tr: 'SMS doğrulama kodu şu adrese gönderilecek:',
    km: 'កូដផ្ទៀងផ្ទាត់ SMS នឹងត្រូវបានផ្ញើទៅ',
    es: 'El código de verificación por SMS se enviará a',
    ar: 'سيتم إرسال رمز التحقق عبر الرسائل القصيرة إلى',
  },
  'lockModal.captchaPlaceholder': {
    zh: '请输入验证码',
    en: 'Please enter the verification code',
    id: 'Harap masukkan kode verifikasi',
    kz: 'Кодты енгізу',
    th: 'โปรดป้อนรหัสการยืนยัน',
    ug: 'دەلىللەش كودىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập mã xác nhận',
    zh_tc: '請輸入驗證碼',
    ru: 'Введите код проверки.',
    ko: '인증 코드를 입력하십시오.',
    bur: 'အတည်ပြုကုဒ်ကို ထည့်ပါ',
    ben: 'যাচাই কোড লিখুন',
    tr: 'Doğrulama kodunu girin',
    km: 'បញ្ចូលកូដផ្ទៀងផ្ទាត់',
    es: 'Ingrese el código de verificación',
    ar: 'يرجى إدخال رمز التحقق',
  },
  'lockModal.sendCaptcha': {
    zh: '发送验证码',
    en: 'Send Verification Code',
    id: 'Kirim kode verifikasi',
    kz: 'Кодты жіберу',
    th: 'ส่งรหัสยืนยัน',
    ug: 'دەلىللەش كودىنى ئەۋەتىش',
    vi: 'Gửi mã xác nhận',
    zh_tc: '發送驗證碼',
    ru: 'Отправить код подтверждения',
    ko: '인증 코드 보내기',
    bur: 'အတည်ပြုကုဒ် ပို့ရန်',
    ben: 'যাচাই কোড পাঠান',
    tr: 'Doğrulama kodu gönder',
    km: 'ផ្ញើកូដផ្ទៀងផ្ទាត់',
    es: 'Enviar código de verificación',
    ar: 'إرسال رمز التحقق',
  },
  'lockModal.sendSeccess': {
    zh: '短信发送成功',
    en: 'SMS sent successfully',
    id: 'SMS berhasil dikirim',
    kz: 'Смс-хабарлама жіберілді',
    th: 'SMS ส่งสำเร็จ',
    ug: 'قىسقا ئۇچۇر ئەۋەتىلدى',
    vi: 'SMS đã được gửi thành công',
    zh_tc: '簡訊發送成功',
    ru: 'Сообщение отправлено успешно',
    ko: '문자 발송 성공',
    bur: 'SMS ပို့ခြင်း အောင်မြင်သည်',
    ben: 'SMS পাঠানো সফল',
    tr: 'SMS başarıyla gönderildi',
    km: 'ផ្ញើ SMS ដោយជោគជ័យ',
    es: 'SMS enviado exitosamente',
    ar: 'تم إرسال الرسائل القصيرة بنجاح',
  },
  'lockModal.sendFail': {
    zh: '短信发送失败，请稍后重试',
    en: 'SMS failed to send, please try again later',
    id: 'SMS gagal, coba lagi nanti',
    kz: 'Смс-хабарлама жіберуге сәтсіз, кейінгіре тексеріңіз',
    th: 'SMS ล้มเหลวโปรดลองอีกครั้งในภายหลัง',
    ug: 'قىسقا ئۇچۇر ئەۋەتىش مەغلۇپ بولدى، قايتا سىناڭ',
    vi: 'Gửi SMS thất bại, vui lòng thử lại sau',
    zh_tc: '簡訊發送失敗，請稍後重試',
    ru: 'Ошибка отправки SMS, попробуйте позже',
    ko: '문자 발송 실패, 나중에 다시 시도하십시오.',
    bur: 'SMS ပို့၍မရပါ၊ နောက်မှ ပြန်စမ်းပါ',
    ben: 'SMS পাঠানো ব্যর্থ, পরে আবার চেষ্টা করুন',
    tr: 'SMS gönderilemedi, sonra tekrar deneyin',
    km: 'ផ្ញើ SMS បរាជ័យ សូមព្យាយាមម្តងទៀតក្រោយមក',
    es: 'SMS enviado fallido, inténtelo nuevamente más tarde',
    ar: 'فشل إرسال الرسائل القصيرة، يرجى المحاولة مرة أخرى لاحقًا',
  },
  'lockModal.updateSeccess': {
    zh: '密码设置成功',
    en: 'Password set successfully',
    id: 'Pengaturan kata sandi berhasil',
    kz: 'Құпия сөздің орнатылуы сәтті',
    th: 'การตั้งค่ารหัสผ่านสำเร็จ',
    ug: 'پارول تەڭشەش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Đã thành công trong đặt mật khẩu',
    zh_tc: '密碼設定成功',
    ru: 'Параметры успешно установлены',
    ko: '암호 설정 성공',
    bur: 'စကားဝှက် သတ်မှတ်မှု အောင်မြင်သည်',
    ben: 'পাসওয়ার্ড সেট করা সফল',
    tr: 'Parola başarıyla ayarlandı',
    km: 'កំណត់ពាក្យសម្ងាត់ដោយជោគជ័យ',
    es: 'Contraseña establecida exitosamente',
    ar: 'تم تعيين كلمة المرور بنجاح',
  },
  'lockModal.editSuccess': {
    zh: '密码修改成功',
    en: 'Password changed successfully',
    id: 'Modifikasi kata sandi berhasil',
    kz: 'Құпия сөздің өзгерісі сәтті',
    th: 'การปรับเปลี่ยนรหัสผ่านสำเร็จ',
    ug: 'پارول ئۆزگەرتىش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Đã thành công trong chỉnh sửa mật khẩu',
    zh_tc: '密碼修改成功',
    ru: 'Изменение пароля успешно',
    ko: '암호 수정 성공',
    bur: 'စကားဝှက် ပြောင်းလဲမှု အောင်မြင်သည်',
    ben: 'পাসওয়ার্ড পরিবর্তন সফল',
    tr: 'Parola başarıyla değiştirildi',
    km: 'ផ្លាស់ប្តូរពាក្យសម្ងាត់ដោយជោគជ័យ',
    es: 'Contraseña modificada exitosamente',
    ar: 'تم تعديلها بنجاح',
  },
  'lockModal.lockSeccess': {
    zh: '解锁成功',
    en: 'Unlock successful',
    id: 'Tidak terkunci dengan sukses',
    kz: 'Құпия сөзден ашу сәтті',
    th: 'ปลดล็อคสำเร็จ',
    ug: 'قۇلۇپ ئېچىش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Mở khóa thành công',
    zh_tc: '解鎖成功',
    ru: 'Удалось разблокировать',
    ko: '잠금 해제 성공',
    bur: 'သော့ဖွင့် အောင်မြင်သည်',
    ben: 'আনলক সফল',
    tr: 'Kilit açma başarılı',
    km: 'បើកសោដោយជោគជ័យ',
    es: 'Desbloqueado exitosamente',
    ar: 'كلمة المرور] تم القفل بنجاح',
  },
  'lockModal.lock': {
    zh: '解锁',
    en: 'Unlock',
    id: 'Membuka kunci',
    kz: 'Ашу',
    th: 'ปลดล็อค',
    ug: 'قۇلۇپ ئېچىش',
    vi: 'Mở khóa',
    zh_tc: '解鎖',
    ru: 'разблокировать',
    ko: '잠금 해제',
    bur: 'သော့ဖွင့်',
    ben: 'আনলক',
    tr: 'Kilidi aç',
    km: 'បើកសោ',
    es: 'Desbloquear',
    ar: 'فتح القفل',
  },
  'lockModal.lockSeccessTip': {
    zh: '锁定成功',
    en: 'Lock successful',
    id: 'Terkunci dengan sukses',
    kz: 'Бекіту сәтті',
    th: 'ล็อคสำเร็จ',
    ug: 'قۇلۇپلاش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Đã thành công trong khóa',
    zh_tc: '鎖定成功',
    ru: 'Удалось заблокировать',
    ko: '잠금 성공',
    bur: 'သော့ခတ် အောင်မြင်သည်',
    ben: 'লক সফল',
    tr: 'Kilitleme başarılı',
    km: 'ចាក់សោដោយជោគជ័យ',
    es: 'Bloqueado exitosamente',
    ar: 'تم القفل بنجاح',
  },
  'lockModal.inputErrLimit': {
    zh: '当前错误次数已达限制，请重新设置解锁密码！',
    en: 'The current number of errors has reached the limit, please reset the unlock password!',
    id: 'Jumlah kesalahan saat ini telah mencapai batas, silakan atur ulang kata sandi buka kunci!',
    kz: 'Қазіргі қатетіңіздің шегіні ашу, қайтадан құпия сөздің орнатылуын орнату!',
    th: 'จำนวนข้อผิดพลาดปัจจุบันถึงขีด จำกัด โปรดรีเซ็ตรหัสผ่านปลดล็อค!',
    ug: 'نۆۋەتتىكى خاتالىق سانى چەكتىن ئېشىپ كەتتى، قايتا قۇلۇپ ئېچىش پارولىنى بەلگىلەڭ!',
    vi: 'Đã đạt giới hạn lỗi hiện tại, vui lòng đặt lại mật khẩu mở khóa!',
    zh_tc: '當前錯誤次數已達限制，請重新設定解鎖密碼！',
    ru: 'Количество ошибок в настоящее время ограничено, пожалуйста, переустановите пароль разблокировки!',
    ko: '현재 오류 횟수가 제한되었습니다. 잠금 해제 비밀번호를 다시 설정하십시오!',
    bur: 'လက်ရှိ မှားယွင်းမှုအကြိမ်ရေ ကန့်သတ်ချက်သို့ ရောက်ပြီးပါပြီ၊ သော့ဖွင့် စကားဝှက်ကို ပြန်သတ်မှတ်ပါ!',
    ben: 'বর্তমান ভুলের সংখ্যা সীমায় পৌঁছেছে, আনলক পাসওয়ার্ড পুনরায় সেট করুন!',
    tr: 'Hata sayısı sınıra ulaştı; kilidi açma parolasını sıfırlayın!',
    km: 'ចំនួនកំហុសដល់ដែនកំណត់ សូមកំណត់ពាក្យសម្ងាត់បើកសោឡើងវិញ!',
    es: 'El número actual de errores ha alcanzado el límite, ¡restablezca la contraseña de desbloqueo!',
    ar: 'لقد وصل العدد الحالي من الأخطاء إلى الحد الأقصى، يرجى إعادة تعيين كلمة مرور إلغاء القفل!',
  },
  'dock56Drill.equipType': {
    zh: '设备类型',
    en: 'Equipment Type',
    id: 'Jenis peralatan',
    kz: 'Құрылғы түрі',
    th: 'ประเภทอุปกรณ์',
    ug: 'ئۈسكۈنە تىپى',
    vi: 'Loại thiết bị',
    zh_tc: '設備類型',
    ru: 'тип устройства',
    ko: '장비 유형',
    bur: 'စက်ပစ္စည်း အမျိုးအစား',
    ben: 'ডিভাইস টাইপ',
    tr: 'Cihaz türü',
    km: 'ប្រភេទឧបករណ៍',
    es: 'Tipo de equipo',
    ar: 'نوع المعدات',
  },
  'dock56Drill.equipment': {
    zh: '设备',
    en: 'Equipment',
    id: 'peralatan',
    kz: 'Устройство',
    th: 'อุปกรณ์',
    ug: 'ئۈسكۈنە',
    vi: 'жабдық',
    zh_tc: '設備',
    ru: 'оборудование',
    ko: '장비',
    bur: 'စက်ပစ္စည်း',
    ben: 'ডিভাইস',
    tr: 'Cihaz',
    km: 'ឧបករណ៍',
    es: 'Equipo',
    ar: 'المعدات',
  },
  'dock56Drill.fiveDock': {
    zh: '五面钻',
    en: 'Five-Sided Drill',
    id: 'Berlian lima sisi',
    kz: 'Бес жақты бұрғылау машина',
    th: 'เพชรห้าด้าน',
    ug: 'بەش يۈزلۈك تۆشۈك ماشىنىسى',
    vi: 'Boring machine 5 mặt',
    zh_tc: '五面鑽',
    ru: 'пятигранное сверло',
    ko: '오면드릴',
    bur: '၅ မျက်နှာ ဒရိလ်',
    ben: '৫-পাশ ড্রিল',
    tr: 'Beş yüz delik',
    km: 'ដ្រូល ៥ មុខ',
    es: 'Taladro de cinco lados',
    ar: 'المثقاب الخماسي الجوانب',
  },
  'dock56Drill.sixDock': {
    zh: '六面钻',
    en: 'Six-Sided Drill',
    id: 'Berlian enam sisi',
    kz: 'Алты жақты бұрғылау машина',
    th: 'เพชรหกด้าน',
    ug: 'ئالتە يۈزلۈك تۆشۈك ماشىنىسى',
    vi: 'Boring machine 6 mặt',
    zh_tc: '六面鑽',
    ru: 'Шестиугольное сверло',
    ko: '육면드릴',
    bur: '၆ မျက်နှာ ဒရိလ်',
    ben: '৬-পাশ ড্রিল',
    tr: 'Altı yüz delik',
    km: 'ដ្រូល ៦ មុខ',
    es: 'Taladro de seis lados',
    ar: 'المثقاب سداسي الجوانب',
  },
  'dock56Drill.fileType': {
    zh: '生成文件类型',
    en: 'Generated File Type',
    id: 'Menghasilkan jenis file',
    kz: 'Құрылған файл түрі',
    th: 'สร้างประเภทไฟล์',
    ug: 'ھاسىل قىلىنغان ھۆججەت تىپى',
    vi: 'Loại tệp tạo ra',
    zh_tc: '生成文件類型',
    ru: 'Тип генерируемого файла',
    ko: '파일 유형 생성',
    bur: 'ဖန်တီးမည့် ဖိုင်အမျိုးအစား',
    ben: 'জেনারেট হওয়া ফাইল টাইপ',
    tr: 'Oluşturulan dosya türü',
    km: 'ប្រភេទឯកសារដែលបានបង្កើត',
    es: 'Tipo de archivo generado',
    ar: 'نوع الملف المُنشأ',
  },
  'dock56Drill.templateOffline': {
    zh: '所用模板已下线！',
    en: 'The template used has been discontinued!',
    id: 'Template yang digunakan telah offline!',
    kz: 'Қолданылатын шаблондыңыз қызметтілігі тоқтатылды!',
    th: 'เทมเพลตที่ใช้ออฟไลน์!',
    ug: 'ئىشلىتىلگەن قېلىپ توردىن چۈشۈرۈلدى!',
    vi: 'Mẫu đã ngừng sử dụng!',
    zh_tc: '所用模板已下線！',
    ru: 'Использовавшийся шаблон вышел из строя!',
    ko: '사용된 템플릿이 오프라인 상태입니다!',
    bur: 'အသုံးပြုနေသော တမ်းပလိတ်ကို ရပ်ဆိုင်းထားပြီးပါပြီ!',
    ben: 'ব্যবহৃত টেমপ্লেটটি বন্ধ/অফলাইনে নেওয়া হয়েছে!',
    tr: 'Kullanılan şablon devre dışı bırakıldı!',
    km: 'គំរូដែលប្រើត្រូវបានផ្អាក!',
    es: '¡La plantilla utilizada está fuera de línea!',
    ar: 'القالب المستخدم غير متصل!',
  },
  'dock56Drill.showExample': {
    zh: '显示数据样例',
    en: 'Show Data Example',
    id: 'Tampilkan sampel data',
    kz: 'Деректер үлгісін көрсету',
    th: 'แสดงตัวอย่างข้อมูล',
    ug: 'سانلىق مەلۇمات مىسالىنى كۆرسىتىش',
    vi: 'Hiển thị mẫu dữ liệu',
    zh_tc: '顯示數據樣例',
    ru: 'Показать примеры данных',
    ko: '데이터 샘플 표시',
    bur: 'ဒေတာ နမူနာ ပြရန်',
    ben: 'ডাটা নমুনা দেখান',
    tr: 'Veri örneğini göster',
    km: 'បង្ហាញគំរូទិន្នន័យ',
    es: 'Mostrar muestra de datos',
    ar: 'عرض عينة البيانات',
  },
  'dock56Drill.conNoticeTip': {
    zh: '对接注意事项：',
    en: 'Connection Notes:',
    id: 'Tindakan Pencegahan Docking:',
    kz: 'Қосымша ескерту:',
    th: 'ข้อควรระวังในการเชื่อมต่อ:',
    ug: 'ئۇلاش دىققەت قىلىدىغان ئىشلار:',
    vi: 'Chú ý khi đối tiếp:',
    zh_tc: '對接注意事項：',
    ru: 'Внимание при стыковке:',
    ko: '도킹 고려 사항:',
    bur: 'ချိတ်ဆက်ရာတွင် သတိပြုရန်:',
    ben: 'ডকিং নোটস:',
    tr: 'Bağlantı notları:',
    km: 'កំណត់ចំណាំភ្ជាប់៖',
    es: 'Notas de acoplamiento:',
    ar: 'ملاحظات الإرساء:',
  },
  'dock56Drill.conNoticeTip1': {
    zh: '1、启用了"XY轴互换"的雕刻机需开启雕刻机中的"孔槽加工设备自动适配互换"功能',
    en: '1. Engraving machines with "XY Axis Swap" enabled need to enable the "Hole and Slot Processing Device Automatic Adaptation Swap" function in the engraving machine.',
    id: '1. Mesin ukiran dengan "XY Axis Swap" yang diaktifkan perlu mengaktifkan fungsi "Pengaturan Perangkat Pengolahan Lubang dan Slot Otomatis Sesuai Pertukaran" di mesin ukiran.',
    kz: '"XY осьтері алмастыру" қолданылған оюу машинасында "Торғай және Сөре Өңдеу Құралы Автоматикалық Қатынас Алмастыру" функциясын қолдану қажет',
    th: '1. เครื่องแกะสลักที่เปิดใช้งาน "XY Axis Swap" จำเป็นต้องเปิดฟังก์ชัน "การปรับเพิ่มเติมอุปกรณ์การทำรูและช่องว่างอัตโนมัติตามการแลกเปลี่ยน" ในเครื่องแกะสลัก',
    ug: '"XY ئوقى ئالماشتۇرۇش" قوزغىتىلغان نەقىشلەش ماشىنىسىدا "تۇنجى ۋە يوچۇقلارنىڭ ئىشلەش ئالماشتۇرۇش قۇرۇلىسى ئوتوماتىك ئالماشتۇرۇش" فانكسىيەسىنى ئىشلىتىش كېرەك',
    vi: "1. Máy điêu khắc có 'Hoán đổi trục XY' cần bật chức năng 'Tự động thích ứng thiết bị xử lý lỗ và rãnh' trong máy điêu khắc",
    zh_tc:
      '1、啟用了「XY軸互換」的雕刻機需開啟雕刻機中的「孔槽加工設備自動適配互換」功能',
    ru: '1. Скульптурные машины, включившие « XY - осевой своп», должны включить функцию «Автоматическая адаптация оборудования для обработки отверстий и канавок с переключением» в скульптурной машине.',
    ko: '1,"XY축 교환"이 활성화된 조각기는 조각기에서 "구멍과 슬롯 가공 장치 자동 적응 교환" 기능을 활성화해야 합니다.',
    bur: '1、"XY အက်ဆစ်လဲလှယ်" ကို ဖွင့်ထားသော ထွင်းထုစက်များတွင် ရှေ့/နောက် မျက်နှာလဲလှယ် ၅/၆ မျက်နှာဒရိလ် အထူးတမ်းပလိတ်ကို သုံးရမည်',
    ben: '1) "XY অক্ষ সোয়াপ" চালু থাকলে ৫/৬-পাশ ড্রিলের বিশেষ টেমপ্লেট ব্যবহার করতে হবে',
    tr: '1. “XY ekseni takası” açık oyma makinelerinde ön-arka yüz değişimli 5/6 yüz delik özel şablonu kullanılmalıdır',
    km: '១) ម៉ាស៊ីនចុកចាក់ដႇលក្រូវបានបើក “ប្តូរអ័ក្ស XY” នោះគឺត្រូវបានបើកកម្មវិធី “ការកំណត់ស្ថានភាពសិក្សាប្រសិទ្ធភាពការលង់គ្រូតែងគ្រូបន្ថែមបានការលង់គ្រូតែងគ្រូ” នៅក្នុងម៉ាស៊ីនចុកចាក់',
    es: '1. La máquina de grabado con "XY intercambio de ejes habilitado" necesita activar la función "adaptación e intercambio automático del equipo de procesamiento de orificios" en la máquina de grabado',
    ar: '1. آلة النقش مع تمكين "XY تبادل المحاور" تحتاج إلى تشغيل وظيفة "التكيف التلقائي وتبادل معدات معالجة الثقب" في آلة النقش',
  },
  'dock56Drill.conNoticeTip2': {
    zh: '2、要在五六面钻上显示或加工板件异形部分需要在模板中配置异形部分的数据',
    en: '2. To display or process special parts of the board on the five/six-sided drill, special part data needs to be configured in the template.',
    id: '2. Untuk menampilkan atau memproses bagian berbentuk pelat pada latihan lima dan enam sisi, data bagian yang dibentuk perlu dikonfigurasi dalam templat.',
    kz: '2. Бес/алты жақты бұрғылау машинасында панельдің арнайы бөліктерді көрсету немесе өңдеу үшін шаблонда арнайы бөліктердің деректерін конфигурациялау керек',
    th: '2. ในการแสดงหรือประมวลผลส่วนที่มีรูปร่างของแผ่นบนการฝึกซ้อมห้าและหกด้านข้อมูลของชิ้นส่วนรูปทรงจะต้องกำหนดค่าในเทมเพลต',
    ug: '2、بەش-ئالتە يۈزلۈك تۆشۈك ماشىنىسىدا تاختاينىڭ ئالاھىدە شەكىللىك قىسمىنى كۆرسىتىش ياكى ئىشلەش ئۈچۈن قېلىپتا ئالاھىدە شەكىللىك قىسىمنىڭ سانلىق مەلۇماتىنى سەپلەش كېرەك',
    vi: '2. Để hiển thị hoặc gia công phần hình không đều của tấm, cần cấu hình dữ liệu phần hình không đều trong mẫu',
    zh_tc:
      '2、要在五六面鑽上顯示或加工板件異形部分需要在模板中配置異形部分的數據',
    ru: '2. Для отображения или обработки фасонной части пластины на пятигранном бурении требуется конфигурация данных фасонной части в шаблоне',
    ko: '2. 5, 6면 드릴에 판재 이형 부분을 표시하거나 가공하려면 템플릿에 이형 부분을 배치해야 하는 데이터',
    bur: '2、၅/၆ မျက်နှာဒရိလ်တွင် ဘုတ်၏ အထူးပုံစံ(异形) ကို ပြရန်/ပြုပြင်ရန် တမ်းပလိတ်ထဲတွင် အထူးပုံစံဒေတာကို သတ်မှတ်ရမည်',
    ben: '2) ৫/৬-পাশ ড্রিলে বোর্ডের বিশেষ আকৃতি দেখাতে/মেশিনিং করতে টেমপ্লেটে বিশেষ আকৃতির ডাটা কনফিগার করতে হবে',
    tr: '2. Beş/altı yüz delikte levha özel şekil kısmını göstermek veya işlemek için şablonda özel şekil verilerini yapılandırın',
    km: '២) ដើម្បីបង្ហាញ/ដំណើរការផ្នែករូបរាងពិសេសនៅលើដ្រូល ៥/៦ មុខ ត្រូវកំណត់រចនាទិន្នន័យរូបរាងពិសេសក្នុងគំរូ',
    es: '2. Para mostrar o procesar la parte con forma especial del panel en el taladro de cinco y seis lados, los datos de la pieza con forma especial deben configurarse en la plantilla',
    ar: '2. لعرض أو معالجة الجزء ذو الشكل الخاص من اللوحة على المثقاب ذي الخمسة ستة جوانب، يجب تكوين بيانات الجزء ذي الشكل الخاص في القالب',
  },
  'dock56Drill.conNoticeTip3': {
    zh: '3、首次使用五六面钻或更换模板后请<span style="color:#f00">进行柜体试生产</span>，在确认无误后再进行常规生产',
    en: '3. After first using the five/six-sided drill or changing the template, please conduct a test production of the cabinet and confirm its correctness before regular production.',
    id: '3. Setelah menggunakan bor lima dan enam untuk pertama kalinya atau mengganti templat, silakan <span style = "Color:#f00"> Untuk produksi uji coba kabinet </span>, dan kemudian melakukan produksi reguler setelah mengkonfirmasi bahwa itu benar.',
    kz: '3. Бес/алты жақты бұрғылау машинасын алғашқы қолдану кезінде немесе шаблонды ауыстырғаннан кейін, қаптамасының сынақтық өндірісі істеуіш, содан кейін қалыпты өндіріске кіріңіз',
    th: '3. หลังจากใช้สว่านห้าและหกด้านเป็นครั้งแรกหรือเปลี่ยนเทมเพลตโปรด <span style = "สี:#f00"> สำหรับการผลิตทดลองใช้ตู้ </span> จากนั้นทำการผลิตปกติหลังจากยืนยันว่าถูกต้อง',
    ug: '3、تۇنجى قېتىم بەش-ئالتە يۈزلۈك تۆشۈك ماشىنىسىنى ئىشلىتىش ياكى قېلىپنى ئالماشتۇرغاندىن كېيىن <span style="color:#f00">ئىشكاپ سىناق ئىشلەپچىقىرىشى</span> ئېلىپ بېرىڭ، خاتالىق يوقلۇقىنى جەزملىگەندىن كېيىن ئاندىن نورمال ئىشلەپچىقىرىشنى باشلاڭ',
    vi: '3. Khi sử dụng boring machine 5/6 mặt lần đầu hoặc thay đổi mẫu, vui lòng <span class="note">thử sản xuất tủ thử nghiệm</span>, sau đó tiến hành sản xuất thông thường khi đã xác nhận không có lỗi',
    zh_tc:
      '3、首次使用五六面鑽或更換模板後請<span style="color:#f00">進行櫃體試生產</span>，在確認無誤後再進行常規生產',
    ru: 'После первого использования пятигранного бурения или замены шаблона выполните пробное производство шкафа < / span > < span style = "color: # f00", а затем выполните обычное производство после подтверждения правильности',
    ko: '3. 5, 6면 드릴을 처음 사용하거나 템플릿을 교체한 후 <span style="color:#f00">을 사용하여 캐비닛 시험 생산</span>을 진행하고, 오류가 없음을 확인한 후 일반 생산을 진행하십시오.',
    bur: '3、၅/၆ မျက်နှာဒရိလ်ကို ပထမဆုံး သုံးသည့်အခါ သို့မဟုတ် တမ်းပလိတ်ပြောင်းပြီးနောက် <span style="color:#f00">ကဘီနက် စမ်းသပ်ထုတ်လုပ်မှု</span> ပြုလုပ်ပြီး မှန်ကန်မှုကို အတည်ပြုပြီးမှ ပုံမှန်ထုတ်လုပ်ပါ',
    ben: '3) ৫/৬-পাশ ড্রিল প্রথমবার ব্যবহার বা টেমপ্লেট বদলানোর পর <span style="color:#f00">ক্যাবিনেট টেস্ট প্রোডাকশন</span> করুন, ঠিক আছে নিশ্চিত হলে পরে নিয়মিত প্রোডাকশন করুন',
    tr: '3. Beş/altı yüz deliği ilk kez kullandıktan veya şablonu değiştirdikten sonra lütfen <span style="color:#f00">dolap deneme üretimi</span> yapın; hatasız doğruladıktan sonra rutin üretime geçin',
    km: '៣) បន្ទាប់ពីប្រើដ្រូល ៥/៦ មុខលើកដំបូង ឬផ្លាស់គំរូ សូម <span style="color:#f00">ធ្វើការផលិតសាកល្បងទូ</span> ហើយបន្ទាប់ពីផ្ទៀងផ្ទាត់គ្មានកំហុស ទើបផលិតកម្មធម្មតា',
    es: '3. Después de usar el taladro de cinco y seis lados o cambiar la plantilla por primera vez, por favor <span style="color:#f00"> realice una producción de prueba del gabinete </span> y luego continúe con la producción regular después de la confirmación',
    ar: '3. بعد استخدام المثقاب ذو الشكل الخاص ذو الخمسة ستة جوانب أو تغيير القالب للمرة الأولى الوقت، يرجى <span style="color:#f00"> إجراء الإنتاج التجريبي للخزانة </span>، ثم المتابعة إلى الإنتاج المنتظم بعد التأكيد',
  },
  'dock56Drill.conNoticeTip4': {
    zh: '4、试生产时请仔细检测正反面孔槽的大小、深度、所在面、以及所在位置是否正确，<span style="color:#f00" >避免出现柜体镜像</span>的问题',
    en: '4. During test production, carefully inspect the size, depth, location, and face of the holes and slots on the front and back. Avoid issues with cabinet mirroring.',
    id: '4. Selama produksi percobaan, silakan periksa apakah ukuran, kedalaman, permukaan, dan lokasi slot wajah depan dan belakang benar, dan hindari masalah mirroring kabinet.',
    kz: '4. Сынақтық өндіріске кіріп, панельдің алдыңғы және артқы бетіндегі тесіктің, тереңдің, орналасқан бетің және орналасуың дұрыс екендігіне мұқайық бақылау,қаптамалардің зергілікті көрінісі болмау үшін',
    th: '4. ในระหว่างการผลิตทดลองใช้โปรดตรวจสอบอย่างระมัดระวังว่าขนาดความลึกพื้นผิวและที่ตั้งของช่องด้านหน้าและด้านหลังนั้นถูกต้องและหลีกเลี่ยงปัญหาการมิเรอร์ของตู้',
    ug: '4、سىناق ئىشلەپچىقىرىشتا ئالدى-كەينى يۈزىدىكى تۆشۈك ۋە يوچۇقلارنىڭ چوڭ-كىچىكلىكى، چوڭقۇرلۇقى، ئورنى ۋە جايلىشىشىنىڭ توغرا-خاتالىقىنى تەپسىلىي تەكشۈرۈڭ، <span style="color:#f00">ئىشكاپ كۆزگۈ سۈرىتى</span> مەسىلىسىنىڭ كېلىپ چىقىشىدىن ساقلىنىڭ',
    vi: '4. Khi thử sản xuất, vui lòng kiểm tra kỹ kích thước, độ sâu, mặt, và vị trí của lỗ và khe trên mặt trước và mặt sau, <span class="note">để tránh lỗi hình ảnh phản chiếu của tủ</span>',
    zh_tc:
      '4、試生產時請仔細檢測正反面孔槽的大小、深度、所在面、以及所在位置是否正確，<span style="color:#f00" >避免出現櫃體鏡像</span>的問題',
    ru: 'При пробном производстве тщательно проверьте размер, глубину, расположение и правильное расположение канавки с положительным и отрицательным отверстием, < span style = "color: # f00" > Избегайте проблем с зеркалом шкафа < / span >',
    ko: '4. 시험 생산 시 양면 슬롯의 크기, 깊이, 소재 및 위치가 정확한지 자세히 검사하십시오. <span style="color:#f00">캐비닛 미러링 </span>의 문제가 발생하지 않도록 합니다.',
    bur: '4、စမ်းသပ်ထုတ်လုပ်ရာတွင် ရှေ့/နောက် အပေါက်-ချောင်းများ၏ အရွယ်/အနက်/မျက်နှာ/တည်နေရာ မှန်ကန်မှုကို သေချာစစ်ဆေးပါ၊ <span style="color:#f00">ကဘီနက် မီရ러(ပြန်ပုံ)</span> ဖြစ်ခြင်းကို ရှောင်ပါ',
    ben: '4) টেস্ট প্রোডাকশনে সামনের/পিছনের হোল-স্লটের সাইজ, গভীরতা, কোন ফেসে আছে এবং অবস্থান ঠিক কিনা ভালোভাবে পরীক্ষা করুন, <span style="color:#f00">ক্যাবিনেট মিররিং</span> সমস্যা এড়ান',
    tr: '4. Deneme üretiminde ön ve arka yüzdeki delik ve kanalların boyut, derinlik, yüz ve konumunu dikkatle kontrol edin; <span style="color:#f00">dolap ayna görüntüsü</span> sorunundan kaçının',
    km: '៤) កំឡុងផលិតសាកល្បង ពិនិត្យទំហំ ជម្រៅ មុខ និងទីតាំងរន្ធ/រណ្តៅខាងមុខ និងក្រោមឱ្យបានល្អិត ដើម្បីជៀសវាង <span style="color:#f00">បញ្ហាបញ្ចាំងទូ</span>',
    es: '4. Durante la producción de prueba, verifique cuidadosamente si el tamaño, la profundidad, la superficie y la posición de las ranuras frontal y posterior son correctos, <span style="color:#f00" > para evitar el problema de duplicación del gabinete </span>',
    ar: '4. أثناء الإنتاج التجريبي، يرجى التحقق بعناية مما إذا كان حجم الفتحات الأمامية والخلفية وعمقها وسطحها وموضعها صحيحًا، <span style="color:#f00" > لتجنب مشكلة انعكاس الخزانة </span>',
  },
  'dock56Drill.example': {
    zh: '数据样例',
    en: 'Data Example',
    id: 'Sampel data',
    kz: 'Деректер үлгісі',
    th: 'ตัวอย่างข้อมูล',
    ug: 'سانلىق مەلۇمات مىسالى',
    vi: 'Mẫu dữ liệu',
    zh_tc: '數據樣例',
    ru: 'Примеры данных',
    ko: '데이터 샘플',
    bur: 'ဒေတာ နမူနာ',
    ben: 'ডাটা নমুনা',
    tr: 'Veri örneği',
    km: 'គំរូទិន្នន័យ',
    es: 'Muestra de datos',
    ar: 'عينة البيانات',
  },
  'dock56Drill.commonSetting': {
    zh: '通用参数设置',
    en: 'Common Parameter Settings',
    id: 'Pengaturan Parameter Umum',
    kz: 'Жалпы параметрлерді орнату',
    th: 'การตั้งค่าพารามิเตอร์ทั่วไป',
    ug: 'ئورتاق پارامېتىر تەڭشىكى',
    vi: 'Cài đặt thông thường',
    zh_tc: '通用參數設置',
    ru: 'Общие параметры',
    ko: '일반 매개변수 설정',
    bur: 'အထွေထွေ ပါရာမီတာ ဆက်တင်',
    ben: 'কমন প্যারামিটার সেটিংস',
    tr: 'Genel parametre ayarları',
    km: 'ការកំណត់ប៉ារ៉ាម៉ែត្រទូទៅ',
    es: 'Configuración de parámetros generales',
    ar: 'إعدادات المعلمات العامة',
  },
  'dock56Drill.throughHoleSetting': {
    zh: '通孔分双面打通',
    en: 'Through-Hole Drilling on Both Sides',
    id: 'Lubang melalui dibuka di kedua sisi',
    kz: 'Толық тесіктің екі бетіне дейін ішкірілу',
    th: 'ผ่านรูผ่านทั้งสองด้าน',
    ug: 'ئۆتمە تۆشۈكنى ئىككى يۈزگە بۆلۈپ تېشىش',
    vi: 'Lỗ thông điền hai mặt',
    zh_tc: '通孔分雙面打通',
    ru: 'Прорыв с двух сторон.',
    ko: '구멍 뚫기 양면으로 나누기',
    bur: 'ထိုးဖောက်အပေါက်ကို နှစ်ဖက်မှ ခွဲ၍ ထိုးဖောက်',
    ben: 'থ্রু-হোল দুই পাশে ভাগ করে ড্রিল',
    tr: 'Geçiş deliği iki yüzden delinir',
    km: 'រន្ធឆ្លងដោតពីរមុខ',
    es: 'Los orificios pasantes se abren en ambos lados',
    ar: 'يتم فتح الفتحات من خلال الجانبين',
  },
  'dock56Drill.throughSlotSetting': {
    zh: '通槽分双面打通',
    en: 'Through-Slot Drilling on Both Sides',
    id: 'Buka slot di kedua sisi',
    kz: 'Толық слоттің екі бетіне дейін ішкірілу',
    th: 'เปิดช่องทั้งสองด้าน',
    ug: 'ئۆتمە يوچۇقنى ئىككى يۈزگە بۆلۈپ تارتىش',
    vi: 'Khe thông điền hai mặt',
    zh_tc: '通槽分雙面打通',
    ru: 'Двойной проход.',
    ko: '슬롯을 양면으로 나누어 뚫다',
    bur: 'ထိုးဖောက်ချောင်းကို နှစ်ဖက်မှ ခွဲ၍ ထိုးဖောက်/တိုင်',
    ben: 'থ্রু-স্লট দুই পাশে ভাগ করে ড্রিল/কাট',
    tr: 'Geçiş kanalı iki yüzden açılır',
    km: 'រណ្តៅឆ្លងដោតពីរមុខ',
    es: 'Las ranuras pasantes se abren en ambos lados',
    ar: 'يتم فتح الفتحات على كلا الجانبين',
  },
  'dock56Drill.nonHolesNotFiles': {
    zh: '矩形板没有孔槽不输出文件：',
    en: 'No hole or slot data, no file output for rectangular boards:',
    id: 'Pelat persegi panjang tidak memiliki lubang dan tidak ada file output:',
    kz: 'Квадраттық панельде тесіктер мен слоттары болмаса, файл ішкірілмейді:',
    th: 'แผ่นสี่เหลี่ยมไม่มีรูและไม่มีไฟล์เอาต์พุต:',
    ug: 'تۆت بۇلۇڭلۇق تاختايدا تۆشۈك-يوچۇق بولمىسا ھۆججەت چىقارماسلىق:',
    vi: 'Tấm hình chữ nhật không có lỗ hoặc khe không xuất tệp:',
    zh_tc: '矩形板沒有孔槽不輸出文件：',
    ru: 'Прямоугольная пластина без отверстий не выводит файл:',
    ko: '직사각형 보드에 구멍 슬롯이 없으면 파일을 내보내지 않습니다.',
    bur: 'စတုဂံဘုတ်တွင် အပေါက်/ချောင်းမရှိပါက ဖိုင်မထုတ်ပါ:',
    ben: 'রেক্ট্যাঙ্গুলার বোর্ডে হোল/স্লট না থাকলে ফাইল আউটপুট হবে না:',
    tr: 'Dikdörtgen levha delik/kanalsızsa dosya çıktısı yok:',
    km: 'ផ្ទាំងចតុកោណគ្មានរន្ធ/រណ្តៅមិនមានឯកសារចេញ៖',
    es: 'Si la placa rectangular no tiene agujeros, el archivo no se generará:',
    ar: 'إذا كانت اللوحة المستطيلة لا تحتوي على ثقوب، فلن يتم إخراج الملف:',
  },
  'dock56Drill.frontFileIdentifier': {
    zh: '正面文件标识：',
    en: 'Front File Identifier:',
    id: 'Identifikasi file depan:',
    kz: 'Алдыңғы беттің файл белгісі:',
    th: 'การระบุไฟล์ด้านหน้า:',
    ug: 'ئالدى يۈزى ھۆججەت بەلگىسى:',
    vi: 'Đánh dấu tệp mặt trước:',
    zh_tc: '正面文件標識：',
    ru: 'Идентификатор положительного файла:',
    ko: '정면 파일 ID:',
    bur: 'ရှေ့မျက်နှာ ဖိုင်အမှတ်အသား:',
    ben: 'ফ্রন্ট ফাইল আইডেন্টিফায়ার:',
    tr: 'Ön yüz dosya tanımlayıcısı:',
    km: 'សម្គាល់ឯកសារមុខមុខ៖',
    es: 'Identificación frontal del archivo:',
    ar: 'تعريف الملف الأمامي:',
  },
  'dock56Drill.oppositeFileIdentifier': {
    zh: '反面文件标识：',
    en: 'Opposite File Identifier:',
    id: 'Pengidentifikasi File Terbalik:',
    kz: 'Артқы беттің файл белгісі:',
    th: 'ตัวระบุไฟล์ย้อนกลับ:',
    ug: 'كەينى يۈزى ھۆججەت بەلگىسى:',
    vi: 'Đánh dấu tệp mặt sau:',
    zh_tc: '反面文件標識：',
    ru: 'Идентификатор отрицательного файла:',
    ko: '뒷면 파일 ID:',
    bur: 'နောက်မျက်နှာ ဖိုင်အမှတ်အသား:',
    ben: 'ব্যাক ফাইল আইডেন্টিফায়ার:',
    tr: 'Arka yüz dosya tanımlayıcısı:',
    km: 'សម្គាល់ឯកសារមុខក្រោម៖',
    es: 'Identificación inversa del archivo:',
    ar: 'تعريف الملف العكسي:',
  },
  'dock56Drill.oppositeFileIdentifierTips': {
    zh: '生成方式为：原13位板件编码+标识字符',
    en: 'Generated as: Original 13-digit part code + identifier character',
    id: 'Metode pembuatan adalah: Kode papan 13-bit asli + karakter identifikasi',
    kz: 'Қалыптастыру әдісі: алғашқы 13-шілікті панельдің кодты + белгілікі метін',
    th: 'วิธีการสร้างคือ: รหัสบอร์ด 13 บิตดั้งเดิม + อักขระการระบุตัวตน',
    ug: 'ھاسىل قىلىش ئۇسۇلى: ئەسلى 13 خانىلىق تاختاي كودى + بەلگە ھەرپى',
    vi: 'Định dạng tạo: Mã tấm 13 chữ số gốc + ký tự đánh dấu',
    zh_tc: '生成方式為：原13位板件編碼+標識字符',
    ru: 'Способ генерации: оригинальный 13 - битный код панели + символ идентификации',
    ko: '생성 방식: 원래 13비트 보드 인코딩 + 식별 문자',
    bur: 'ဖန်တီးပုံ: မူလ 13 လုံး ဘုတ်ကုဒ် + အမှတ်အသားအက္ခရာ',
    ben: 'জেনারেট হবে: মূল ১৩-সংখ্যার পার্ট কোড + আইডেন্টিফায়ার ক্যারেক্টার',
    tr: 'Oluşturma: Orijinal 13 haneli parça kodu + tanımlayıcı karakter',
    km: 'របៀបបង្កើត៖ កូដផ្ទាំង ១៣ ខ្ទង់ដើម + តួអក្សរសម្គាល់',
    es: 'El método de generación es: código de placa original de 13 bits + carácter de identificación',
    ar: 'طريقة التوليد هي: رمز اللوحة الأصلي 13 بت + حرف التعريف',
  },
  'dock56Drill.arcDescription': {
    zh: '圆弧描述方式',
    en: 'Arc Description Method',
    id: 'Metode deskripsi busur',
    kz: 'Кемердің сипаттама әдісі',
    th: 'วิธีคำอธิบายส่วนโค้ง',
    ug: 'يېرىم چەمبەر تەسۋىرلەش ئۇسۇلى',
    vi: 'Cách tả vòng tròn',
    zh_tc: '圓弧描述方式',
    ru: 'Описание дуги',
    ko: '호 설명 방법',
    bur: 'ဝိုင်းကွေး ဖော်ပြပုံ',
    ben: 'আর্ক বর্ণনার পদ্ধতি',
    tr: 'Yay tanımlama yöntemi',
    km: 'វិធីពិពណ៌នារង្វង់',
    es: 'Método de descripción del arco',
    ar: 'طريقة وصف القوس',
  },
  'dock56Drill.linePoints': {
    zh: '线段成型描述',
    en: 'Line Segment Formation Description',
    id: 'Deskripsi cetakan segmen garis',
    kz: 'Сызықтық пішірудің сипаттамасы',
    th: 'คำอธิบายการปั้นส่วนของเส้น',
    ug: 'سىزىق شەكىللەندۈرۈش تەسۋىرى',
    vi: 'Cách tả hình thành đoạn thẳng',
    zh_tc: '線段成型描述',
    ru: 'Описание формирования отрезка',
    ko: '세그먼트 형 설명',
    bur: 'မျဉ်းပိုင်းဖွဲ့စည်းပုံ ဖော်ပြချက်',
    ben: 'লাইন সেগমেন্ট ফর্মেশন বর্ণনা',
    tr: 'Doğru parçası oluşum tanımı',
    km: 'ពិពណ៌នាការបង្កើតជួរកំណត់',
    es: 'Descripción de formación de segmento de línea',
    ar: 'وصف تشكيل مقطع الخط',
  },
  'dock56Drill.arcCommand': {
    zh: '圆弧指令描述',
    en: 'Arc Command Description',
    id: 'Deskripsi instruksi busur',
    kz: 'Кемердің командалық сипаттамасы',
    th: 'คำสั่งคำสั่งอาร์ค',
    ug: 'يېرىم چەمبەر بۇيرۇقى تەسۋىرى',
    vi: 'Cách tả chỉ lệnh vòng tròn',
    zh_tc: '圓弧指令描述',
    ru: 'Описание дуговой команды',
    ko: '호 명령 설명',
    bur: 'ဝိုင်းကွေး အမိန့် ဖော်ပြချက်',
    ben: 'আর্ক কমান্ড বর্ণনা',
    tr: 'Yay komutu tanımı',
    km: 'ពិពណ៌នាបញ្ជារង្វង់',
    es: 'Descripción del comando de arco',
    ar: 'وصف أمر القوس',
  },
  'dock56Drill.slotWidthSplit': {
    zh: '宽槽拆解为多条窄槽加工：',
    en: 'Split wide slots into multiple narrow slots for processing:',
    id: 'Alur lebar dibongkar menjadi beberapa alur sempit untuk diproses:',
    kz: 'Кең слоттың бірнеше жіңілік слоттарына айырылуы:',
    th: 'ร่องกว้างจะถูกถอดออกเป็นร่องแคบ ๆ หลายตัวสำหรับการประมวลผล:',
    ug: 'كەڭ يوچۇقنى كۆپ تار يوچۇققا بۆلۈپ ئىشلەش:',
    vi: 'Phân giải khe rộng thành nhiều khe hẹp để gia công:',
    zh_tc: '寬槽拆解為多條窄槽加工：',
    ru: 'Широкий слот разбит на несколько узких слотов обработки:',
    ko: '와이드 슬롯을 여러 개의 좁은 슬롯 머시닝으로 분해합니다.',
    bur: 'ကျယ်သောချောင်းကို ကျဉ်းချောင်းများ အများအပြားအဖြစ် ခွဲ၍ ပြုပြင်:',
    ben: 'চওড়া স্লটকে একাধিক সরু স্লটে ভাগ করে প্রসেস করুন:',
    tr: 'Geniş kanalı işlem için birden çok dar kanala böl:',
    km: 'បំបែករណ្តៅទទឹងជារណ្តៅចង្អៀតច្រើនសម្រាប់ដំណើរការ៖',
    es: 'Desarme una ranura ancha en múltiples ranuras estrechas para su procesamiento:',
    ar: 'تفكيك أخدود عريض إلى أخاديد ضيقة متعددة للمعالجة:',
  },
  'dock56Drill.slotSplitWidth': {
    zh: '拆解后单条槽宽度：',
    en: 'Width of single slot after splitting:',
    id: 'Lebar slot tunggal setelah pembongkaran:',
    kz: 'Айырылғаннан кейінгі жіңілік слоттың ені:',
    th: 'ความกว้างของสล็อตเดี่ยวหลังจากถอดชิ้นส่วน:',
    ug: 'بۆلۈنگەندىن كېيىنكى تاق يوچۇق كەڭلىكى:',
    vi: 'Khe đơn sau khi phân giải có chiều rộng:',
    zh_tc: '拆解後單條槽寬度：',
    ru: 'Ширина ячейки после демонтажа:',
    ko: '분해 후 단일 슬롯 너비:',
    bur: 'ခွဲပြီးနောက် တစ်ချောင်းချင်း အကျယ်:',
    ben: 'ভাগ করার পরে একক স্লটের প্রস্থ:',
    tr: 'Bölme sonrası tek kanal genişliği:',
    km: 'ទទឹងរណ្តៅតែមួយបន្ទាប់ពីបំបែក៖',
    es: 'Ancho de ranura única después del desmontaje:',
    ar: 'عرض أخدود فردي بعد التفكيك:',
  },
  'dock56Drill.mm': {
    zh: '注：拆解对象为普通矩形槽',
    en: 'Attention: The splitting target is for regular rectangular slots',
    id: 'CATATAN: Objek yang dibongkar adalah slot persegi panjang normal',
    kz: 'Ескерту: Айырыланатын нысандар қалыпты ректангульікті слоттар',
    th: 'หมายเหตุ: วัตถุที่ถอดประกอบเป็นช่องสี่เหลี่ยมปกติ',
    ug: 'دىققەت: بۆلۈش نىشانى ئادەتتىكى تۆت بۇلۇڭلۇق يوچۇق',
    vi: 'Chú ý: Đối tượng phân giải là khe hình chữ nhật thông thường',
    zh_tc: '註：拆解對象為普通矩形槽',
    ru: 'Примечание: Объект демонтажа - обычный прямоугольник',
    ko: '참고: 분해 객체는 일반 사각형 슬롯입니다.',
    bur: 'မှတ်ချက်: ခွဲသည့်အရာသည် ပုံမှန် စတုဂံချောင်းများသာ ဖြစ်သည်',
    ben: 'নোট: স্প্লিট টার্গেট হলো সাধারণ রেক্ট্যাঙ্গুলার স্লট',
    tr: 'Not: Bölme hedefi normal dikdörtgen kanaldır',
    km: 'សម្គាល់៖ គោលដៅបំបែកគឺរណ្តៅចតុកោណធម្មតា',
    es: 'Nota: El objeto de desmontaje es una ranura rectangular ordinaria',
    ar: 'ملاحظة: كائن التفكيك هو أخدود مستطيل عادي',
  },
  'dock56Drill.isNotMergeSlot': {
    zh: '相邻的等宽等深槽拉通处理：',
    en: 'Merge adjacent slots with the same width and depth:',
    id: 'Proses penarik lebaran dan kedalaman yang sama berdekatan:',
    kz: 'Үшіншісің бар кенітті және терең слоттарды біріктіру:',
    th: 'กระบวนการดึงความกว้างและความลึกที่อยู่ติดกัน: กระบวนการดึงร่อง:',
    ug: 'يانداش تەڭ كەڭلىك تەڭ چوڭقۇرلۇقتىكى يوچۇقنى بىرلەشتۈرۈپ تارتىش:',
    vi: 'Kết nối khe có cùng chiều rộng và cùng chiều sâu:',
    zh_tc: '相鄰的等寬等深槽拉通處理：',
    ru: 'Соседние равноширинные вытяжные канавки:',
    ko: '인접한 등폭 등심조 당김 처리:',
    bur: 'အနီးချင်း အကျယ်/အနက် တူညီသောချောင်းများကို တစ်ချောင်းတည်းအဖြစ် ဆက်တိုင်ပြုလုပ်:',
    ben: 'একই প্রস্থ/গভীরতার পাশের স্লটগুলো মার্জ করে থ্রু করুন:',
    tr: 'Bitişik eş genişlik ve derinlikteki kanalları birleştir:',
    km: 'បញ្ចូលរណ្តៅជាប់គ្នាដែលមានទទឹង និងជម្រៅដូចគ្នា៖',
    es: 'Se extraen ranuras adyacentes de igual ancho y profundidad:',
    ar: 'يتم سحب الأخاديد المتساوية العرض والعمق المتساوي من خلال:',
  },
  'dock56Drill.slotPunchTip': {
    zh: '此功能仅对使用自定义模板的背板槽和抽屉底板槽生效',
    en: 'This function only applies to backboard slots and drawer bottom slots using custom templates',
    id: 'Fitur ini hanya berfungsi untuk slot panel belakang dan slot panel bawah laci menggunakan templat khusus',
    kz: 'Бұл функциясы тек жеке шаблондыңыздың артқы панель слоттары мен сандықтің астынары слоттарына ғана қолданылады',
    th: 'คุณสมบัตินี้ใช้ได้เฉพาะกับช่องด้านหลังและช่องด้านล่างของลิ้นชักโดยใช้เทมเพลตที่กำหนดเอง',
    ug: 'بۇ ئىقتىدار پەقەت ئۆزى بەلگىلىگەن قېلىپتىكى ئارقا تاختا يوچۇقى ۋە تارتما تېگى تاختىسى يوچۇقىغا ئۈنۈملۈك',
    vi: 'Chức năng này chỉ có hiệu lực với khe backboard và khe đáy tủ kéo sử dụng mẫu tùy chỉnh',
    zh_tc: '此功能僅對使用自定義模板的背板槽和抽屜底板槽生效',
    ru: 'Эта функция работает только для лотков задней панели и ящиков, использующих пользовательские шаблоны',
    ko: '이 기능은 사용자 정의 템플릿을 사용하는 후면판 슬롯 및 서랍 바닥판 슬롯에만 적용됩니다.',
    bur: 'ဤလုပ်ဆောင်ချက်သည် စိတ်ကြိုက်တမ်းပလိတ်သုံးသော နောက်ဘုတ်ချောင်းနှင့် အံဆွဲအောက်ဘုတ်ချောင်းများတွင်သာ သက်ရောက်သည်',
    ben: 'এই ফিচারটি শুধু কাস্টম টেমপ্লেট ব্যবহার করা ব্যাকবোর্ড স্লট ও ড্রয়ার বটম স্লটে প্রযোজ্য',
    tr: 'Bu işlev yalnızca özel şablon kullanan arka panel ve çekmece tabanı kanalları için geçerlidir',
    km: 'មុខងារនេះមានប្រសិទ្ធភាពតែសម្រាប់រណ្តៅផ្ទាំងខាងក្រោយ និងរណ្តៅផ្ទាំងបាតរដេកដែលប្រើគំរូតាមបំណង',
    es: 'Esta función solo es efectiva para las ranuras del panel posterior y las ranuras del fondo del cajón usando plantillas personalizadas',
    ar: 'هذه الوظيفة فعالة فقط لأخاديد اللوحة الخلفية وأخاديد أسفل الدرج باستخدام قوالب مخصصة',
  },
  'dock56Drill.sizeRange': {
    zh: '相邻尺寸小于等于',
    en: 'Adjacent sizes less than or equal to',
    id: 'Ukuran yang berdekatan kurang dari atau sama dengan',
    kz: 'Үшіншісің бар кенітті және тереңсіздің кішісі',
    th: 'ขนาดที่อยู่ติดกันน้อยกว่าหรือเท่ากับ',
    ug: 'يانداش ئۆلچەم كىچىك ياكى تەڭ',
    vi: 'Kích thước liền kề nhỏ hơn hoặc bằng',
    zh_tc: '相鄰尺寸小於等於',
    ru: 'Соседние размеры меньше равны',
    ko: '인접 치수가 같음보다 작음',
    bur: 'အနီးချင်း အရွယ်အစား ≤',
    ben: 'পাশের সাইজ ≤',
    tr: 'Bitişik ölçü şundan küçük veya eşit',
    km: 'ទំហំជាប់គ្នា ≤',
    es: 'Las dimensiones adyacentes son menores o iguales a',
    ar: 'الأبعاد المجاورة أقل من أو تساوي',
  },
  'dock56Drill.enableWorningTip': {
    zh: '此功能与前封边摆放方向不能同时开启',
    en: 'This function cannot be enabled simultaneously with the front edge placement direction',
    id: 'Fungsi ini tidak dapat dihidupkan pada saat yang sama dengan arah penempatan tepi depan',
    kz: 'Бұл функциясы алдыңғы шеттің орналасу бағытымен бір мезгілде іске қосылмайды',
    th: 'ฟังก์ชั่นนี้ไม่สามารถเปิดได้ในเวลาเดียวกันกับทิศทางการวางขอบด้านหน้า',
    ug: 'بۇ ئىقتىدار بىلەن ئالدى گىرۋەك قويۇش يۆنىلىشىنى تەڭلا قوزغاتقىلى بولمايدۇ',
    vi: 'Chức năng này không thể đồng thời kích hoạt với hướng đặt cạnh trước',
    zh_tc: '此功能與前封邊擺放方向不能同時開啟',
    ru: 'Эта функция не может быть включена одновременно с направлением расположения передней крышки.',
    ko: '이 기능은 전면 모서리 배치 방향과 동시에 켜지지 않음',
    bur: 'ဤလုပ်ဆောင်ချက်နှင့် “ရှေ့ဖက်အနား တင်ထားရာဦးတည်ချက်” ကို တပြိုင်နက်မဖွင့်နိုင်ပါ',
    ben: 'এই ফিচারটি “ফ্রন্ট এজ প্লেসমেন্ট ডিরেকশন”-এর সাথে একসাথে চালু করা যাবে না',
    tr: 'Bu işlev ön bant yerleştirme yönü ile aynı anda açılamaz',
    km: 'មិនអាចបើកមុខងារនេះជាមួយទិសដាក់គែមមុខក្នុងពេលតែមួយ',
    es: 'Esta función y la dirección de colocación del borde frontal no se pueden activar al mismo tiempo',
    ar: 'لا يمكن تشغيل هذه الوظيفة واتجاه وضع نطاق الحافة الأمامية في نفس الوقت',
  },
  'dock56Drill.longDirection': {
    zh: '板件长边摆放方向',
    en: 'Board Length Placement Direction',
    id: 'Arah penempatan sisi yang panjang',
    kz: 'Панельдің ұзын бағытының орналасу бағыты',
    th: 'ทิศทางการจัดวางด้านข้างยาว',
    ug: 'تاختاي ئۇزۇن تەرىپىنىڭ قويۇلۇش يۆنىلىشى',
    vi: 'Hướng đặt cạnh dài tấm',
    zh_tc: '板件長邊擺放方向',
    ru: 'Направление размещения листов на длинные края',
    ko: '판재 장변 배치 방향',
    bur: 'ဘုတ် အရှည်ဘက် တင်ထားရာဦးတည်ချက်',
    ben: 'বোর্ডের দীর্ঘ পাশ প্লেসমেন্ট দিক',
    tr: 'Levha uzun kenar yerleştirme yönü',
    km: 'ទិសដាក់គែមវែងរបស់ផ្ទាំង',
    es: 'Dirección de colocación del lado largo de los paneles',
    ar: 'اتجاه وضع الجانب الطويل للألواح',
  },
  'dock56Drill.horizontal': {
    zh: '横向',
    en: 'Horizontal',
    id: 'Horisontal',
    kz: 'Кеңдегі',
    th: 'ตามแนวนอน',
    ug: 'توغرىسىغا',
    vi: 'Ngang',
    zh_tc: '橫向',
    ru: 'Горизонтальный',
    ko: '가로',
    bur: 'အလျားလိုက်',
    ben: 'অনুভূমিক',
    tr: 'Yatay',
    km: 'ផ្ដេក',
    es: 'Horizontal',
    ar: 'أفقي',
  },
  'dock56Drill.vertical': {
    zh: '纵向',
    en: 'Vertical',
    id: 'Vertikal',
    kz: 'Вертикалды',
    th: 'แนวตั้ง',
    ug: 'بويىغا',
    vi: 'Dọc',
    zh_tc: '縱向',
    ru: 'вертикальный',
    ko: '세로',
    bur: 'ဒေါင်လိုက်',
    ben: 'উল্লম্ব',
    tr: 'Dikey',
    km: 'បញ្ឈរ',
    es: 'Longitudinal',
    ar: 'طولي',
  },
  'dock56Drill.slotDirection': {
    zh: '五/六面钻槽或异形放置方向',
    en: 'Five/Six-Sided Drill Slot or Special Placement Direction',
    id: 'Lima/enam sisi pengeboran atau arah penempatan berbentuk khusus',
    kz: 'Бес/алты жақты бұрғылау машинасының слоттарының немесе арнайы пішірудің орналасу бағыты',
    th: 'ร่องเจาะห้า/หกด้านหรือทิศทางการจัดวางรูปทรงพิเศษ',
    ug: 'بەش/ئالتە يۈزلۈك تۆشۈك ماشىنىسى يوچۇقى ياكى ئالاھىدە شەكىل قويۇلۇش يۆنىلىشى',
    vi: 'Hướng đặt khe hoặc hình không đều của boring machine 5/6 mặt',
    zh_tc: '五/六面鑽槽或異形放置方向',
    ru: 'Направление расположения пяти / шестигранных желобов или фасонов',
    ko: '5 / 6면 드릴링 또는 이형 배치 방향',
    bur: '၅/၆ မျက်နှာဒရိလ် ချောင်း သို့မဟုတ် အထူးပုံစံ တင်ထားရာဦးတည်ချက်',
    ben: '৫/৬-পাশ ড্রিল স্লট বা বিশেষ আকৃতি প্লেসমেন্ট দিক',
    tr: '5/6 yüz delik kanalı veya özel şekil yerleştirme yönü',
    km: 'ទិសដាក់រណ្តៅដ្រូល ៥/៦ មុខ ឬរូបរាងពិសេស',
    es: 'Ranura de perforación de cinco/seis lados o dirección de colocación de forma especial',
    ar: 'أخدود حفر خماسي/ستة جوانب أو اتجاه وضع ذو شكل خاص',
  },
  'dock56Drill.default': {
    zh: '系统默认',
    en: 'System Default',
    id: 'Default Sistem',
    kz: 'Системаның әдетті параметрлері',
    th: 'ค่าเริ่มต้นของระบบ',
    ug: 'سىستېما سۈكۈتتىكى',
    vi: 'Mặc định hệ thống',
    zh_tc: '系統默認',
    ru: 'Система по умолчанию',
    ko: '시스템 기본',
    bur: 'စနစ် စံသတ်မှတ်',
    ben: 'সিস্টেম ডিফল্ট',
    tr: 'Sistem varsayılanı',
    km: 'លំនាំដើមប្រព័ន្ធ',
    es: 'Predeterminado del sistema',
    ar: 'النظام الافتراضي',
  },
  'dock56Drill.frontLeft': {
    zh: '前和左',
    en: 'Front and Left',
    id: 'Depan dan kiri',
    kz: 'Алдыңғы және сол жақ',
    th: 'ด้านหน้าและซ้าย',
    ug: 'ئالدى ۋە سول',
    vi: 'Trước và trái',
    zh_tc: '前和左',
    ru: 'Передний и левый',
    ko: '전면 및 왼쪽',
    bur: 'ရှေ့ နှင့် ဘယ်',
    ben: 'ফ্রন্ট ও বাম',
    tr: 'Ön ve sol',
    km: 'មុខ និងឆ្វេង',
    es: 'Frontal e izquierda',
    ar: 'أمامي ويسار',
  },
  'dock56Drill.frontRight': {
    zh: '前和右',
    en: 'Front and Right',
    id: 'Depan dan kanan',
    kz: 'Алдыңғы және оң жақ',
    th: 'ด้านหน้าและขวา',
    ug: 'ئالدى ۋە ئوڭ',
    vi: 'Trước và phải',
    zh_tc: '前和右',
    ru: 'Предыдущая и правая',
    ko: '전면 및 오른쪽',
    bur: 'ရှေ့ နှင့် ညာ',
    ben: 'ফ্রন্ট ও ডান',
    tr: 'Ön ve sağ',
    km: 'មុខ និងស្តាំ',
    es: 'Frontal y derecha',
    ar: 'أمامي ويمين',
  },
  'dock56Drill.backLeft': {
    zh: '后和左',
    en: 'Back and Left',
    id: 'Kembali dan kiri',
    kz: 'артқы және сол',
    th: 'ด้านหลังและซ้าย',
    ug: 'كەينى ۋە سول',
    vi: 'Hậu và trái',
    zh_tc: '後和左',
    ru: 'После и слева',
    ko: '후면 및 왼쪽',
    bur: 'နောက် နှင့် ဘယ်',
    ben: 'ব্যাক ও বাম',
    tr: 'Arka ve sol',
    km: 'ខាងក្រោយ និងឆ្វេង',
    es: 'Atrás e izquierda',
    ar: 'خلفي ويسار',
  },
  'dock56Drill.backRight': {
    zh: '后和右',
    en: 'Back and Right',
    id: 'Kembali dan kanan',
    kz: 'артқы және оң',
    th: 'กลับและขวา',
    ug: 'كەينى ۋە ئوڭ',
    vi: 'Hậu và phải',
    zh_tc: '後和右',
    ru: 'После и справа',
    ko: '후면 및 오른쪽',
    bur: 'နောက် နှင့် ညာ',
    ben: 'ব্যাক ও ডান',
    tr: 'Arka ve sağ',
    km: 'ខាងក្រោយ និងស្តាំ',
    es: 'Atrás y derecha',
    ar: 'خلفي ويمين',
  },
  'dock56Drill.frontDirection': {
    zh: '前封边摆放方向',
    en: 'Front Edge Placement Direction',
    id: 'Arah penempatan tepi depan',
    kz: 'Алдыңғы шеттің орналасу юнітелі',
    th: 'ทิศทางการจัดตำแหน่งขอบด้านหน้า',
    ug: 'ئالدى گىرۋەك قويۇلۇش يۆنىلىشى',
    vi: 'Hướng đặt cạnh trước',
    zh_tc: '前封邊擺放方向',
    ru: 'Направление расположения передней кромки',
    ko: '전면 모서리 배치 방향',
    bur: 'ရှေ့ဖက်အနား တင်ထားရာဦးတည်ချက်',
    ben: 'ফ্রন্ট এজ প্লেসমেন্ট দিক',
    tr: 'Ön bant yerleştirme yönü',
    km: 'ទិសដាក់គែមមុខ',
    es: 'Dirección de colocación de las bandas del borde frontal',
    ar: 'اتجاه موضع نطاق الحافة الأمامية',
  },
  'dock56Drill.enableTip': {
    zh: '注：仅对云排版生效',
    en: 'Attention: Only effective for Cloud Layout',
    id: 'Catatan: Hanya efektif untuk pengaturan huruf cloud',
    kz: 'Ескерту: Бұл функциясы тек бұлтты нұсқадау үшін қолданылады',
    th: 'หมายเหตุ: มีผลเฉพาะสำหรับการเรียงพิมพ์คลาวด์เท่านั้น',
    ug: 'دىققەت: پەقەت بۇلۇتلۇق تەرتىپلەشكە ئۈنۈملۈك',
    vi: 'Chú ý: Chỉ có hiệu lực với bố cục đám mây',
    zh_tc: '註：僅對雲排版生效',
    ru: 'Примечание: Действует только для облачной типографии',
    ko: '참고: 클라우드 레이아웃에만 적용',
    bur: 'မှတ်ချက်: Cloud Layout တွင်သာ သက်ရောက်သည်',
    ben: 'নোট: শুধু ক্লাউড লেআউটে কার্যকর',
    tr: 'Not: Yalnızca bulut yerleşiminde geçerlidir',
    km: 'សម្គាល់៖ មានប្រសិទ្ធភាពតែសម្រាប់ការចងក្រងក្នុងពពក',
    es: 'Nota: Solo efectivo para composición tipográfica en la nube',
    ar: 'ملاحظة: فعال فقط في التنضيد السحابي',
  },
  'dock56Drill.fixedOn': {
    zh: '固定在：',
    en: 'Fixed On:',
    id: 'Diperbaiki di:',
    kz: 'Қаталды:',
    th: 'แก้ไขใน:',
    ug: 'مۇقىملاشتۇرۇش ئورنى:',
    vi: 'Định vị trên:',
    zh_tc: '固定在：',
    ru: 'Закреплены в:',
    ko: '고정 위치:',
    bur: 'တပ်ဆင်ထားရာ:',
    ben: 'স্থির থাকবে:',
    tr: 'Sabitlenmiş:',
    km: 'រឹងមាំនៅ៖',
    es: 'Fijado delante de:',
    ar: 'تم التثبيت أمام:',
  },
  'dock56Drill.front': {
    zh: '前边',
    en: 'Front',
    id: 'Sebelum',
    kz: 'Алдыңғы бет',
    th: 'ก่อน',
    ug: 'ئالدى تەرەپ',
    vi: 'Mặt trước',
    zh_tc: '前邊',
    ru: 'Впереди.',
    ko: '앞쪽',
    bur: 'ရှေ့ဘက်',
    ben: 'সামনে',
    tr: 'Ön',
    km: 'មុខ',
    es: 'Front',
    ar: 'Front',
  },
  'dock56Drill.back': {
    zh: '后边',
    en: 'Back',
    id: 'di belakang',
    kz: 'Артқы бет',
    th: 'ด้านหลัง',
    ug: 'كەينى تەرەپ',
    vi: 'Mặt sau',
    zh_tc: '後邊',
    ru: 'Сзади.',
    ko: '뒤쪽',
    bur: 'နောက်ဘက်',
    ben: 'পিছনে',
    tr: 'Arka',
    km: 'ខាងក្រោយ',
    es: 'El siguiente valor de coordenadas',
    ar: 'تحتفظ قيمة الإحداثيات',
  },
  'dock56Drill.left': {
    zh: '左边',
    en: 'Left',
    id: 'kiri',
    kz: 'Сол жақ',
    th: 'ซ้าย',
    ug: 'سول تەرەپ',
    vi: 'Trái',
    zh_tc: '左邊',
    ru: 'Слева.',
    ko: '왼쪽',
    bur: 'ဘယ်ဘက်',
    ben: 'বাম',
    tr: 'Sol',
    km: 'ឆ្វេង',
    es: 'Izquierda',
    ar: 'اليسرى',
  },
  'dock56Drill.right': {
    zh: '右边',
    en: 'Right',
    id: 'Kanan',
    kz: 'Оң жақ',
    th: 'ขวา',
    ug: 'ئوڭ تەرەپ',
    vi: 'Phải',
    zh_tc: '右邊',
    ru: 'справа',
    ko: '오른쪽',
    bur: 'ညာဘက်',
    ben: 'ডান',
    tr: 'Sağ',
    km: 'ស្តាំ',
    es: 'Derecha',
    ar: 'اليمنى',
  },
  'dock56Drill.coordinateValue': {
    zh: '坐标值保留位数：',
    en: 'Number of Decimal Places for Coordinate Values:',
    id: 'Jumlah digit yang ditahan dari nilai koordinat:',
    kz: 'Координаттардың сақталған цифрлар саны:',
    th: 'จำนวนตัวเลขที่เก็บไว้ของค่าพิกัด:',
    ug: 'كوئوردېنات قىممىتى ساقلاش خانە سانى:',
    vi: 'Số chữ số giữ lại trong giá trị tọa độ:',
    zh_tc: '座標值保留位數：',
    ru: 'Количество зарезервированных координат:',
    ko: '좌표값 예약된 자릿수:',
    bur: 'ကိုဩဒိနိတ်တန်ဖိုး ဒသမထားမည့် အရေအတွက်:',
    ben: 'কোঅর্ডিনেট ভ্যালুর দশমিক ঘর সংখ্যা:',
    tr: 'Koordinat değeri ondalık basamak sayısı:',
    km: 'ចំនួនខ្ទង់ទសភាគនៃតម្លៃកូអរដោនេ៖',
    es: 'retiene el número de dígitos:',
    ar: 'التالية بعدد الأرقام:',
  },
  'dock56Drill.decimalPlaces': {
    zh: '位',
    en: 'Decimal Places',
    id: 'Sedikit',
    kz: 'Цифрлар',
    th: 'นิดหน่อย',
    ug: 'خانە',
    vi: 'chữ số',
    zh_tc: '位',
    ru: 'бит',
    ko: '자리',
    bur: 'ဒသမနေရာ',
    ben: 'দশমিক ঘর',
    tr: 'Basamak',
    km: 'ខ្ទង់ទសភាគ',
    es: 'dígitos',
    ar: 'أرقام',
  },
  'dock56Drill.slotLengthCompensation': {
    zh: '槽长度补偿',
    en: 'Slot Length Compensation',
    id: 'Kompensasi panjang slot',
    kz: 'Ойық ұзындығының өтемақысы',
    th: 'การชดเชยความยาวร่อง',
    ug: 'ئويۇق ئۇزۇنلۇقىنىڭ تولۇقلىمىسى',
    vi: 'Bù đắp chiều dài rãnh',
    zh_tc: '槽長度補償',
    ru: 'компенсация длины паза',
    ko: '슬롯 길이 보상',
    bur: 'ချောင်းအရှည် ထပ်ဖြည့် (補偿)',
    ben: 'স্লট দৈর্ঘ্য কম্পেনসেশন',
    tr: 'Kanal uzunluğu telafisi',
    km: 'ការសងវិញប្រវែងរណ្តៅ',
    es: 'Compensación de longitud de ranura',
    ar: 'تعويض طول الأخدود',
  },
  'dock56Drill.curveholesLengthCompensation': {
    zh: '内部异形清角',
    en: 'Internal Special Shape Length Compensation',
    id: 'Kompensasi bentuk dalam',
    kz: 'Ішкі ерекше пішіндердің өтемақысы',
    th: 'การชดเชยรูปทรงภายใน',
    ug: 'ئىچكى ئالاھىدە شەكىللىك قويۇلۇش يۆنىلىشى تولۇقلىمىسى',
    vi: 'Nội dạng bù đắp',
    zh_tc: '內部異形補償',
    ru: 'угол расчистки внутренней фасии',
    ko: '내부 이형 청각',
    bur: 'အတွင်းပိုင်း အပြားမညီ ပုံသဏ္ဍာန် ချွန်ထောင့်သန့်စင် (清角)',
    ben: 'ইনার স্পেশাল শেপ ক্লিয়ার কর্নার',
    tr: 'İç özel şekil köşe temizliği',
    km: 'ការសម្អាតមុមរូបរាងពិសេសខាងក្នុង',
    es: 'Limpieza de esquina interna con forma especial',
    ar: 'مسح الزاوية الداخلية ذات الشكل الخاص',
  },
  'dock56Drill.slotCompensationEqualZero': {
    zh: '距边为0的槽边补偿',
    en: 'Slot Edge Compensation When Distance is Zero',
    id: 'Kompensasi tepi slot ketika jarak adalah nol',
    kz: 'Қашықтық нөл болған кезде ойық жиегінің өтемақысы',
    th: 'การชดเชยขอบร่องเมื่อระยะห่างเป็นศูนย์',
    ug: 'گىرۋەك ئارىلىقى نۆل بولغاندىكى ئويۇق گىرۋەك تولۇقلىمىسى',
    vi: 'Bù đắp cạnh rãnh khi khoảng cách bằng không',
    zh_tc: '距邊為0的槽邊補償',
    ru: 'Компенсация кромки канавки до 0',
    ko: '슬롯 모서리에 대한 피치 0의 보정',
    bur: 'အနားကွာအဝေး 0 ဖြစ်သော ချောင်းအနား ထပ်ဖြည့် (补偿)',
    ben: 'দূরত্ব ০ হলে স্লট এজ কম্পেনসেশন',
    tr: 'Kenara mesafe 0 iken kanal kenarı telafisi',
    km: 'ការសងវិញគែមរណ្តៅនៅពេលចម្ងាយទៅគែមគឺ ០',
    es: 'Compensación de borde de ranura con una distancia de 0',
    ar: 'تعويض حافة الأخدود بمسافة 0',
  },
  'dock56Drill.slotCompensationNotEqualZero': {
    zh: '距边不为0的槽边补偿',
    en: 'Slot Edge Compensation When Distance is Not Zero',
    id: 'Kompensasi tepi slot ketika jarak tidak nol',
    kz: 'Қашықтық нөл болмаған кезде ойық жиегінің өтемақысы',
    th: 'การชดเชยขอบร่องเมื่อระยะห่างไม่เป็นศูนย์',
    ug: 'گىرۋەك ئارىلىقى نۆل بولمىغاندىكى ئويۇق گىرۋەك تولۇقلىمىسى',
    vi: 'Bù đắp cạnh rãnh khi khoảng cách không bằng không',
    zh_tc: '距邊不為0的槽邊補償',
    ru: 'Компенсация кромки канавки с расстоянием до 0',
    ko: '슬롯 모서리에서 0이 아닌 경우 모서리 보정',
    bur: 'အနားကွာအဝေး 0 မဟုတ်သော ချောင်းအနား ထပ်ဖြည့် (补偿)',
    ben: 'দূরত্ব ০ নয় হলে স্লট এজ কম্পেনসেশন',
    tr: 'Kenara mesafe 0 değilken kanal kenarı telafisi',
    km: 'ការសងវិញគែមរណ្តៅនៅពេលចម្ងាយទៅគែមមិនមែន ០',
    es: 'Compensación de borde de ranura con una distancia distinta de 0',
    ar: 'تعويض حافة الأخدود بمسافة غير 0',
  },
  'dock56Drill.slotCompensationTip': {
    zh: '加工出现未切干净的小圆角或长度不够时使用此功能',
    en: 'Use this function when processing shows incomplete small rounded corners or insufficient length',
    id: 'Gunakan fungsi ini ketika pemrosesan menunjukkan sudut bulat kecil yang tidak lengkap atau panjang yang tidak mencukupi',
    kz: 'Өңдеу кезінде толық емес кішкентай дөңгелек бұрыштар немесе жеткіліксіз ұзындық байқалған кезде осы функцияны пайдаланыңыз',
    th: 'ใช้ฟังก์ชันนี้เมื่อการประมวลผลแสดงมุมโค้งเล็กที่ไม่สมบูรณ์หรือความยาวไม่เพียงพอ',
    ug: 'ئىشلەپچىقىرىشتا كىچىك يۇمۇلاق بۇلۇڭ تولۇق كېسىلمىگەن ياكى ئۇزۇنلۇقى يېتەرسىز بولغاندا بۇ ئىقتىدارنى ئىشلىتىڭ',
    vi: 'Sử dụng chức năng này khi quá trình gia công xuất hiện góc tròn nhỏ chưa cắt sạch hoặc chiều dài không đủ',
    zh_tc: '加工出現未切乾淨的小圓角或長度不夠時使用此功能',
    ru: 'Использовать эту функцию при возникновении небольшого неочищенного угла или недостаточной длины',
    ko: '이 기능은 가공에서 잘리지 않은 작은 필렛이나 길이가 부족한 경우 사용됩니다.',
    bur: 'ဖြတ်တောက်ပြီးနောက် မပြတ်သန့်သော သေးငယ်ဝိုင်းထောင့် သို့မဟုတ် အရှည်မလုံလောက်ပါက ဤလုပ်ဆောင်ချက်ကို သုံးပါ',
    ben: 'গোলো কর্নার ঠিকমতো না কাটলে বা দৈর্ঘ্য কম হলে এই ফিচার ব্যবহার করুন',
    tr: 'İşlemde küçük yuvarlatılmamış köşeler veya yetersiz uzunluk olduğunda kullanın',
    km: 'ប្រើនៅពេលមានមុមរង្វង់តូចមិនទាន់កាត់ស្អាត ឬប្រវែងមិនគ្រប់',
    es: 'Utilice esta función cuando procese un pequeño filete que no se ha cortado limpiamente o la longitud no es suficiente',
    ar: 'استخدم هذه الوظيفة عند معالجة شريحة صغيرة لم يتم قطعها بشكل نظيف أو الطول غير كافٍ',
  },
  'dock56Drill.curveholesCompensationEqualZero': {
    zh: '距边为0的内部异形边补偿',
    en: 'Corner length compensation when distance is zero',
    id: 'Kompensasi panjang tepi siku ketika jarak adalah nol',
    kz: 'Қашықтық нөл болған кезде ойық жиегінің өтемақысы',
    th: 'การชดเชยความยาวขอบร่องเมื่อระยะห่างเป็นศูนย์',
    ug: 'گىرۋەك ئارىلىقى نۆل بولغاندىكى ئويۇق گىرۋەك تولۇقلىمىسى',
    vi: 'Khoảng cách cạnh bằng 0 của góc vuông bù đắp',
    zh_tc: '距邊為0的直角長度補償',
    ru: 'Компенсация внутренней асимметрии до нуля',
    ko: '오프셋 모서리가 0인 내부 이형 모서리 보정',
    bur: 'အနားကွာအဝေး 0 ဖြစ်သော အတွင်းပိုင်း အပြားမညီ အနား ထပ်ဖြည့် (补偿)',
    ben: 'দূরত্ব ০ হলে ইনার স্পেশাল এজ কম্পেনসেশন',
    tr: 'Kenara mesafe 0 iken iç özel şekil kenarı telafisi',
    km: 'ការសងវិញគែមរូបរាងពិសេសខាងក្នុងនៅពេលចម្ងាយ ០',
    es: 'Compensación de borde interno de forma especial con una distancia de 0',
    ar: 'تعويض الحافة الداخلية ذات الشكل الخاص بمسافة 0',
  },
  'dock56Drill.curveholesCompensationTip': {
    zh: '建议输入：铣内部异形刀具的半径值',
    en: 'Enter the value: Radius of the internal special-shaped cutting tool',
    id: 'Masukkan nilai: Jari-jari alat pemotongan bentuk khusus',
    kz: 'Тақтайдың ішіндегі ерекше пішіндерді фрезерлеу құралының радиусын енгізу қажет:',
    th: 'ป้อนค่า: รัศมีเครื่องมือการกัดภายในรูปทรงพิเศษ',
    ug: 'تاللانغان بەش-ئالتە يۈزلۈك تۆشۈك ماشىنىسى ھۆججەت تىپى توردىن چۈشۈرۈلدى، جەزملەڭ!',
    vi: 'Nhập giá trị: Bán kính dao cắt hình đặc biệt',
    zh_tc: '建議輸入：銑內部異形刀具的半徑值',
    ru: 'Рекомендуемый вход: радиус внутреннего фасонного инструмента фрезерования',
    ko: '권장 입력: 밀링 내부 이형 공구의 반지름 값',
    bur: 'အကြံပြုထည့်ရန်: အတွင်းပိုင်း အပြားမညီ ဖရီးဇ်ဓား၏ အချင်းဝက်တန်ဖိုး',
    ben: 'প্রস্তাবিত ইনপুট: ইনার স্পেশাল শেপ কাটার টুলের রেডিয়াস',
    tr: 'Önerilen giriş: İç özel şekil freze takımı yarıçapı',
    km: 'បញ្ចូលដែលបានស្នើ៖ កាំឧបករណ៍ហ្វ្រីសរូបរាងពិសេសខាងក្នុង',
    es: 'Entrada recomendada: valor del radio de la herramienta interna de fresado con forma especial',
    ar: 'الإدخال الموصى به: قيمة نصف القطر لأداة الطحن الداخلية ذات الشكل الخاص',
  },
  'dock56Drill.curveholesCompensationTip2': {
    zh: '在板件轮廓外接矩形边加工的内部异形出现未切干净的小圆角时使用此功能',
    en: 'When cutting internal alien outside the rectangular edge of the board, all sides containing the alien will be cut simultaneously',
    id: 'Ketika memotong internal alien di luar sisi persegi panjang, semua sisi yang berisi alien akan dipotong secara bersamaan',
    kz: 'Тақтайдың ішіндегі ерекше пішіндерді фрезерлеу құралының радиусын енгізу қажет:',
    th: 'เมื่อการประมวลผลภายในรูปทรงที่ผิดปกติอยู่นอกขอบรูปทรงที่ผิดปกติ จะถูกประมวลผลพร้อมกัน',
    ug: 'تاختاي ئۇزۇن تەرىپىنى قويۇش قوزغىتىلغان ۋە تاختاينىڭ ئۇزۇن تەرىپى بۇ ئۈنۈم دائىرىسى ئىچىدە بولغاندا، يوچۇق ۋە ئالاھىدە شەكىل قويۇلۇش ئورنىنى ئالدىن بەلگىلەيدۇ',
    vi: 'Khi gia công hình dạng đặc biệt bên ngoài cạnh ngoài của bảng, toàn bộ cạnh chứa hình dạng sẽ được cắt đồng thời',
    zh_tc: '在板件輪廓外接矩形邊加工的內部異形出現未切乾淨的小圓角時使用此功能',
    ru: 'Использовать эту функцию при появлении небольших незарезанных углов во внутренних фасонах прямоугольной обработки наружного контура пластины',
    ko: '이 기능은 판넬 외곽선 직사각형 모서리에서 가공된 내부 이형에 잘리지 않은 작은 필렛이 나타나는 경우에 사용됩니다.',
    bur: 'ဘုတ်အပြင်ဘက် အစွန်းရေခဲတန်း (rectangular edge) အတိုင်း အတွင်းအပြားမညီကို ပြုပြင်ရာတွင် မပြတ်သန့်သော သေးငယ်ဝိုင်းထောင့် ထွက်လာပါက ဤလုပ်ဆောင်ချက်ကို သုံးပါ',
    ben: 'বোর্ড কনট্যুরের বাইরের রেক্ট্যাঙ্গুলার এজ অনুযায়ী ইনার স্পেশাল শেপ কাটার সময় ছোট গোল কর্নার ঠিকমতো না কাটলে এই ফিচার ব্যবহার করুন',
    tr: 'Levha dış dikdörtgen kenarı boyunca işlenen iç özel şekilde temiz kesilmemiş küçük yuvarlak köşe olduğunda kullanın',
    km: 'ប្រើនៅពេលរូបរាងពិសេសខាងក្នុងតាមគែមចតុកោណខាងក្រៅនៃផ្ទាំងមានមុមរង្វង់តូចមិនទាន់កាត់ស្អាត',
    es: 'Utilice esta función cuando la forma especial interna procesada por el borde rectangular del contorno de la placa tenga pequeños filetes sin cortar',
    ar: 'استخدم هذه الوظيفة عندما يكون الشكل الداخلي الخاص المعالج بواسطة الحافة المستطيلة لمخطط اللوحة يحتوي على شرائح صغيرة غير مقطوعة',
  },
  'dock56Drill.specialParameter': {
    zh: '特殊参数设置',
    en: 'Special Parameter Settings',
    id: 'Pengaturan Parameter Khusus',
    kz: 'Арнайы параметрлерді орнату',
    th: 'การตั้งค่าพารามิเตอร์พิเศษ',
    ug: 'ئالاھىدە پارامېتىر تەڭشىكى',
    vi: 'Cài đặt tham số đặc biệt',
    zh_tc: '特殊參數設置',
    ru: 'Специальные параметры',
    ko: '특수 매개변수 설정',
    bur: 'အထူး ပါရာမီတာ ဆက်တင်',
    ben: 'বিশেষ প্যারামিটার সেটিংস',
    tr: 'Özel parametre ayarları',
    km: 'ការកំណត់ប៉ារ៉ាម៉ែត្រពិសេស',
    es: 'Configuración de parámetros especiales',
    ar: 'إعدادات المعلمات الخاصة',
  },
  'dock56Drill.output5FDrillSlotKnifeCode': {
    zh: 'XML2铣槽刀具编号',
    en: 'XML2 Milling Slot Tool Code',
    id: 'XML2 Slot Milling Alat Nomor',
    kz: 'XML2 фрезерлік слоттың құрал коді',
    th: 'หมายเลขเครื่องมือมิลลิ่งสล็อต XML2',
    ug: 'XML2 يوچۇق ئويۇش پىچاق نومۇرى',
    vi: 'Mã dao cắt khe XML2',
    zh_tc: 'XML2銑槽刀具編號',
    ru: 'Номер XML2',
    ko: 'XML2 밀링 슬롯 공구 번호',
    bur: 'XML2 ချောင်းဖရီးဇ် ဓားကိရိယာ နံပါတ်',
    ben: 'XML2 মিলিং স্লট টুল নম্বর',
    tr: 'XML2 freze kanalı takım numarası',
    km: 'លេខឧបករណ៍រណ្តៅហ្វ្រីស XML2',
    es: 'XML2 Número de herramienta de fresado',
    ar: 'XML2 رقم أداة الطحن',
  },
  'dock56Drill.output5FDrillShapeKnifeCode': {
    zh: 'XML2铣型刀具编号',
    en: 'XML2 Milling Shape Tool Code',
    id: 'Nomor alat penggilingan xml2',
    kz: 'XML2 фрезерлік пішірудің құрал коды',
    th: 'หมายเลขเครื่องมือการกัด XML2',
    ug: 'XML2 شەكىل ئويۇش پىچاق نومۇرى',
    vi: 'Mã dao cắt hình XML2',
    zh_tc: 'XML2銑型刀具編號',
    ru: 'Номер фрезерного инструмента XML2',
    ko: 'XML2 밀링 공구 번호',
    bur: 'XML2 ပုံဖရီးဇ် ဓားကိရိယာ နံပါတ်',
    ben: 'XML2 মিলিং শেপ টুল নম্বর',
    tr: 'XML2 freze şekil takım numarası',
    km: 'លេខឧបករណ៍ហ្វ្រីសរូបរាង XML2',
    es: 'XML2 Número de herramienta de fresado',
    ar: 'XML2 رقم أداة الطحن',
  },
  'dock56Drill.plankTexture': {
    zh: 'XML2板件纹理',
    en: 'XML2 Board Texture',
    id: 'Tekstur papan XML2',
    kz: 'XML2 панельдің текстурасы',
    th: 'พื้นผิวบอร์ด XML2',
    ug: 'XML2 تاختاي تېكىستۇرىسى',
    vi: 'Kết cấu bảng XML2',
    zh_tc: 'XML2板件紋理',
    ru: 'Тексты панелей XML2',
    ko: 'XML2 보드 텍스쳐',
    bur: 'XML2 ဘုတ် အထည်အသား (纹理)',
    ben: 'XML2 বোর্ড টেক্সচার',
    tr: 'XML2 levha dokusu',
    km: 'វាលផ្ទាំង XML2',
    es: 'XML2Textura de placa',
    ar: 'XML2نسيج اللوحة',
  },
  'dock56Drill.offset': {
    zh: 'XML2铣型刀具补偿',
    en: 'XML2 Milling Shape Tool Compensation',
    id: 'Kompensasi Alat Penggilingan XML2',
    kz: 'XML2 фрезерлік пішірудің құралдарының компенсациясы',
    th: 'การชดเชยเครื่องมือการกัด XML2',
    ug: 'XML2 شەكىل ئويۇش پىچاق تولۇقلىمىسى',
    vi: 'Bù trù dao cắt hình XML2',
    zh_tc: 'XML2銑型刀具補償',
    ru: 'Компенсация фрезерных инструментов XML2',
    ko: 'XML2 밀링 공구 보정',
    bur: 'XML2 ပုံဖရီးဇ် ဓားကိရိယာ ထပ်ဖြည့် (补偿)',
    ben: 'XML2 মিলিং শেপ টুল কম্পেনসেশন',
    tr: 'XML2 şekil frezeleme takım telafisi',
    km: 'ការកែសម្រួលឧបករណ៍កាត់រាង XML2',
    es: 'XML2 Compensación de herramienta de fresado',
    ar: 'XML2 تعويض أداة الطحن',
  },
  'dock56Drill.mprConHoleDir': {
    zh: '五/六面钻MPR文件侧面孔Z坐标基准面',
    en: 'Five/Six-Sided Drill MPR File Side Hole Z-Coordinate Reference Plane',
    id: 'Lima/Enam Sisi Pengeboran Sisi File MPR Wajah Z Koordinat Permukaan Referensi',
    kz: 'Бес/алты жақты бұрғылау машинасының MPR файлінің сыртқы жанбалардағы тесіктің Z координатасының базалық плоскості',
    th: 'ห้า/หกด้านการขุดเจาะไฟล์ด้านข้างหน้า z พิกัดพื้นผิวอ้างอิง',
    ug: 'بەش/ئالتە يۈزلۈك تۆشۈك ماشىنىسى MPR ھۆججىتى يان تۆشۈكنىڭ Z كوئوردېنات ئاساسى يۈزى',
    vi: 'Mặt chuẩn Z của các lỗ bên của tập tin MPR 5/6 mặt khoan',
    zh_tc: '五/六面鑽MPR文件側面孔Z座標基準面',
    ru: 'Пять / шесть сторон бурения MPR файл боковое отверстие Z координатная база',
    ko: '5 / 6면 드릴링 MPR 파일 측면 구멍 Z 좌표 데이텀 면',
    bur: '၅/၆ မျက်နှာဒရင် MPR ဖိုင် ဘေးအပေါက် Z ကိုဩဒိနိတ် အခြေခံမျက်နှာပြင်',
    ben: '৫/৬-ফেস ড্রিল MPR ফাইলের সাইড হোল Z কোঅর্ডিনেট রেফারেন্স প্লেন',
    tr: 'Beş/altı yüzlü matkap MPR dosyası yan delik Z ekseni referans düzlemi',
    km: 'ផ្ទៃយោង Z សម្រាប់រន្ធចិញ្ចឹមនៅក្នុងឯកសារ MPR ម៉ាស៊ីនខ្នាត 5/6 ផ្នែក',
    es: 'Perforación de cinco/seis lados MPR Orificio lateral de lima Z Plano de referencia de coordenadas',
    ar: 'الحفر بخمسة/ستة جوانب MPR فتحة جانبية للملف Z مستوى مسند الإسناد',
  },
  'dock56Drill.plankTop': {
    zh: '板件上表面',
    en: 'Board Upper Surface',
    id: 'Permukaan atas pelat',
    kz: 'Панельдің жоғарғы беті',
    th: 'พื้นผิวด้านบนของแผ่น',
    ug: 'تاختاي ئۈستى يۈزى',
    vi: 'Mặt trên của bảng',
    zh_tc: '板件上表面',
    ru: 'Верхняя поверхность пластины',
    ko: '판재 상단면',
    bur: 'ဘုတ် အပေါ်မျက်နှာပြင်',
    ben: 'বোর্ডের উপরের পৃষ্ঠ',
    tr: 'Levha üst yüzeyi',
    km: 'ផ្ទៃខាងលើនៃផ្ទាំង',
    es: 'Superficie superior del panel',
    ar: 'السطح العلوي للوحة',
  },
  'dock56Drill.plankBottom': {
    zh: '板件下表面',
    en: 'Board Lower Surface',
    id: 'Permukaan pelat bawah',
    kz: 'Панельдің төменгі беті',
    th: 'พื้นผิวด้านล่างของแผ่น',
    ug: 'تاختاي ئاستى يۈزى',
    vi: 'Mặt dưới của bảng',
    zh_tc: '板件下表面',
    ru: 'Нижняя поверхность пластины',
    ko: '플레이트 부품 하단 서피스',
    bur: 'ဘုတ် အောက်မျက်နှာပြင်',
    ben: 'বোর্ডের নিচের পৃষ্ঠ',
    tr: 'Levha alt yüzeyi',
    km: 'ផ្ទៃខាងក្រោមនៃផ្ទាំង',
    es: 'Superficie inferior del panel',
    ar: 'السطح السفلي للوحة',
  },
  'dock56Drill.codeInfo': {
    zh: 'ban格式文件包含Code信息：',
    en: 'ban Format File Includes Code Information:',
    id: 'File format larangan berisi informasi kode:',
    kz: 'ban форматты файл Code ақпаратты қамтиды:',
    th: 'ไฟล์รูปแบบแบนมีข้อมูลรหัส:',
    ug: 'ban فورماتلىق ھۆججەت Code ئۇچۇرىنى ئۆز ئىچىگە ئالىدۇ:',
    vi: 'Tập tin định dạng ban chứa thông tin Mã:',
    zh_tc: 'ban格式文件包含Code信息：',
    ru: 'Файл формата ban содержит Code информацию:',
    ko: 'ban 형식 파일에는 Code 정보가 포함되어 있습니다.',
    bur: 'ban ဖော်မတ်ဖိုင်တွင် Code အချက်အလက် ပါဝင်သည်:',
    ben: 'ban ফরম্যাট ফাইলে Code তথ্য থাকবে:',
    tr: 'ban biçimli dosya Code bilgisini içerir:',
    km: 'ឯកសារទ្រង់ទ្រាយ ban មានព័ត៌មាន Code៖',
    es: 'El archivo de formato prohibido contiene Code información:',
    ar: 'يحتوي ملف تنسيق الحظر على معلومات Code:',
  },
  'dock56Drill.bomFile': {
    zh: '输出bom格式文件：',
    en: 'Output bom Format File:',
    id: 'File format BOM output:',
    kz: 'bom форматты файл шығару:',
    th: 'ไฟล์รูปแบบ BOM เอาท์พุท:',
    ug: 'bom فورماتلىق ھۆججەت چىقىرىش:',
    vi: 'Xuất tập tin định dạng bom:',
    zh_tc: '輸出bom格式文件：',
    ru: 'Вывод файла в формате bom:',
    ko: 'bom 형식 파일을 내보내려면 다음과 같이 하십시오.',
    bur: 'bom ဖော်မတ်ဖိုင် ထုတ်ပါ:',
    ben: 'bom ফরম্যাট ফাইল আউটপুট করুন:',
    tr: 'bom biçimli dosyayı dışa aktar:',
    km: 'បញ្ចេញឯកសារទ្រង់ទ្រាយ bom៖',
    es: 'Archivo de formato bom de salida:',
    ar: 'ملف تنسيق بوم الإخراج:',
  },
  'dock56Drill.plankHeight': {
    zh: '板件高度描述：',
    en: 'Board Height Description:',
    id: 'Deskripsi Tinggi Piring:',
    kz: 'Панельдің биіктігінің сипаттамасы:',
    th: 'คำอธิบายความสูงของแผ่นแผ่น:',
    ug: 'تاختاي ئېگىزلىكى چۈشەندۈرۈلۈشى:',
    vi: 'Mô tả chiều cao của bảng:',
    zh_tc: '板件高度描述：',
    ru: 'Описание высоты панели:',
    ko: '보드 높이 설명:',
    bur: 'ဘုတ်အမြင့် ဖော်ပြချက်:',
    ben: 'বোর্ড উচ্চতার বর্ণনা:',
    tr: 'Levha yüksekliği açıklaması:',
    km: 'ការពិពណ៌នាកម្ពស់ផ្ទាំង៖',
    es: 'Descripción de la altura del panel:',
    ar: 'وصف ارتفاع اللوحة:',
  },
  'dock56Drill.plankNum': {
    zh: '板号描述：',
    en: 'Board Number Description:',
    id: 'Nomor Dewan Deskripsi:',
    kz: 'Панельдің нөмірінің сипаттамасы:',
    th: 'คำอธิบายหมายเลขบอร์ด:',
    ug: 'تاختاي نومۇرى چۈشەندۈرۈلۈشى:',
    vi: 'Mô tả số hiệu bảng:',
    zh_tc: '板號描述：',
    ru: 'Описание номера доски:',
    ko: '보드 번호 설명:',
    bur: 'ဘုတ်နံပါတ် ဖော်ပြချက်:',
    ben: 'বোর্ড নম্বরের বর্ণনা:',
    tr: 'Levha numarası açıklaması:',
    km: 'ការពិពណ៌នាលេខផ្ទាំង៖',
    es: 'Descripción del número de placa:',
    ar: 'وصف رقم اللوحة:',
  },
  'dock56Drill.backZpoint': {
    zh: '反面槽Z坐标：',
    en: 'Back Slot Z-Coordinate:',
    id: 'Reverse Groove Z Koordinat:',
    kz: 'Артқы слоттың Z координатасы:',
    th: 'Reverse Groove Z พิกัด:',
    ug: 'كەينى يۈزى يوچۇق Z كوئوردېناتى:',
    vi: 'Tọa độ Z của khe sau:',
    zh_tc: '反面槽Z座標：',
    ru: 'Отрицательные координаты Z:',
    ko: '리버스 슬롯 Z 좌표:',
    bur: 'နောက်မျက်နှာ ချောင်း Z ကိုဩဒိနိတ်:',
    ben: 'ব্যাক স্লট Z কোঅর্ডিনেট:',
    tr: 'Arka oluk Z koordinatı:',
    km: 'កូអរដោនេ Z របស់រយៈស្នឹងខាងក្រោយ៖',
    es: 'Ranura inversa Z coordenadas:',
    ar: 'إحداثيات الأخدود العكسي Z:',
  },
  'dock56Drill.plankThick': {
    zh: '板厚',
    en: 'Board Thickness',
    id: 'Ketebalan',
    kz: 'Панельдің қалыңдығы',
    th: 'ความหนาของบอร์ด',
    ug: 'تاختاي قېلىنلىقى',
    vi: 'Độ dày của bảng',
    zh_tc: '板厚',
    ru: 'Толщина пластины',
    ko: '판 두께',
    bur: 'ဘုတ်အထူ',
    ben: 'বোর্ডের পুরুত্ব',
    tr: 'Levha kalınlığı',
    km: 'កម្រាស់ផ្ទាំង',
    es: 'Espesor de la placa',
    ar: 'سمك اللوحة',
  },
  'dock56Drill.slotDeep': {
    zh: '槽深',
    en: 'Slot Depth',
    id: 'Kedalaman alur',
    kz: 'Слоттің тереңдігі',
    th: 'ความลึกของร่อง',
    ug: 'يوچۇق چوڭقۇرلۇقى',
    vi: 'Độ sâu của khe',
    zh_tc: '槽深',
    ru: 'Глубина паза',
    ko: '슬롯 깊이',
    bur: 'ချောင်းအနက်',
    ben: 'স্লট গভীরতা',
    tr: 'Oluk derinliği',
    km: 'ជម្រៅរយៈស្នឹង',
    es: 'Profundidad de ranura',
    ar: 'عمق الأخدود',
  },
  'dock56Drill.outputMprFile': {
    zh: '文件类型',
    en: 'File Type',
    id: 'Jenis file',
    kz: 'Файл түрі',
    th: 'ประเภทไฟล์',
    ug: 'ھۆججەت تىپى',
    vi: 'Loại tập tin',
    zh_tc: '文件類型',
    ru: 'Тип документа',
    ko: '파일 유형',
    bur: 'ဖိုင်အမျိုးအစား',
    ben: 'ফাইল টাইপ',
    tr: 'Dosya türü',
    km: 'ប្រភេទឯកសារ',
    es: 'Tipo de archivo',
    ar: 'نوع الملف',
  },
  'dock56Drill.oldMPR': {
    zh: '旧版MPR',
    en: 'Old MPR',
    id: 'Versi lama MPR',
    kz: 'Ескі MPR',
    th: 'MPR เวอร์ชันเก่า',
    ug: 'كونا نەشرى MPR',
    vi: 'MPR cũ',
    zh_tc: '舊版MPR',
    ru: 'Старая версия MPR',
    ko: '구형 MPR',
    bur: 'MPR အဟောင်း',
    ben: 'পুরোনো MPR',
    tr: 'Eski MPR',
    km: 'MPR ចាស់',
    es: 'Versión anterior MPR',
    ar: 'الإصدار القديم MPR',
  },
  'dock56Drill.newMPR': {
    zh: '新版MPR',
    en: 'New MPR',
    id: 'Versi baru MPR',
    kz: 'Жаңа MPR',
    th: 'MPR เวอร์ชันใหม่',
    ug: 'يېڭى نەشرى MPR',
    vi: 'MPR mới',
    zh_tc: '新版MPR',
    ru: 'Новая версия MPR',
    ko: '새로운 MPR',
    bur: 'MPR အသစ်',
    ben: 'নতুন MPR',
    tr: 'Yeni MPR',
    km: 'MPR ថ្មី',
    es: 'Nueva versión MPR',
    ar: 'الإصدار الجديد MPR',
  },
  'dock56Drill.mprFileZside': {
    zh: '五/六面钻MPR文件侧面孔Z坐标基准面',
    en: 'Z-axis Reference Plane for Side Holes in Five/Six-Sided Drill MPR File',
    id: 'Lima/Enam Sisi Pengeboran Sisi File MPR Wajah Z Koordinat Permukaan Referensi',
    kz: 'Бес/алты жақты бұрғылау машинасының MPR файлінің сыртқы жанбалардағы тесіктің Z координатасының базалық плоскості',
    th: 'ห้า/หกด้านการขุดเจาะไฟล์ด้านข้างหน้า z พิกัดพื้นผิวอ้างอิง',
    ug: 'بەش/ئالتە يۈزلۈك تۆشۈك ماشىنىسى MPR ھۆججىتى يان تۆشۈكنىڭ Z كوئوردېنات ئاساسى يۈزى',
    vi: 'Mặt chuẩn Z của các lỗ bên của tập tin MPR 5/6 mặt khoan',
    zh_tc: '五/六面鑽MPR文件側面孔Z座標基準面',
    ru: 'Пять / шесть сторон бурения MPR файл боковое отверстие Z координатная база',
    ko: '5 / 6면 드릴링 MPR 파일 측면 구멍 Z 좌표 데이텀 면',
    bur: '၅/၆ မျက်နှာဒရင် MPR ဖိုင် ဘေးအပေါက် Z အက်ဆစ် အခြေခံမျက်နှာပြင်',
    ben: '৫/৬-ফেস ড্রিল MPR ফাইলে সাইড হোলের Z-অ্যাক্সিস রেফারেন্স প্লেন',
    tr: 'Beş/altı yüzlü matkap MPR dosyasında yan delikler için Z ekseni referans düzlemi',
    km: 'ផ្ទៃយោង Z សម្រាប់រន្ធចិញ្ចឹមនៅក្នុងឯកសារ MPR ម៉ាស៊ីន 5/6 ផ្នែក',
    es: 'Perforación de cinco/seis lados MPR Orificio lateral de lima Z Plano de referencia de coordenadas',
    ar: 'الحفر بخمسة/ستة جوانب MPR فتحة جانبية للملف Z مستوى مسند الإسناد',
  },
  'dock56Drill.fileTypeOffline': {
    zh: '当前选择的五六面钻文件类型已下线, 请确认!',
    en: 'The currently selected file type for the five/six-sided drill has been discontinued. Please confirm!',
    id: 'Jenis file bor lima dan enam sisi yang saat ini dipilih telah offline, harap konfirmasi!',
    kz: 'Қазіргі таңдаулықты бес/алты жақты бұрғылау машинасының файл түрі қызметтілігі тоқтатылды. Ескертуіш!',
    th: 'ประเภทไฟล์สว่านห้าและหกด้านที่เลือกในปัจจุบันได้รับการออฟไลน์โปรดยืนยัน!',
    ug: 'نۆۋەتتە تاللانغان بەش-ئالتە يۈزلۈك تۆشۈك ماشىنىسى ھۆججەت تىپى توردىن چۈشۈرۈلدى، جەزملەڭ!',
    vi: 'Loại tập tin khoan 5/6 mặt đã ngừng sử dụng, vui lòng xác nhận!',
    zh_tc: '當前選擇的五六面鑽文件類型已下線, 請確認!',
    ru: 'Текущий выбранный тип файла с пятью или шестью сторонами сверления отключен, пожалуйста, убедитесь!',
    ko: '현재 선택한 5, 6면 드릴 파일 형식이 오프라인 상태입니다. 확인하세요!',
    bur: 'လက်ရှိရွေးထားသော ၅/၆ မျက်နှာဒရင် ဖိုင်အမျိုးအစားကို ပိတ်သိမ်းထားပြီးဖြစ်သည်၊ အတည်ပြုပါ!',
    ben: 'বর্তমান নির্বাচিত ৫/৬-ফেস ড্রিল ফাইল টাইপটি অফলাইন হয়েছে, দয়া করে নিশ্চিত করুন!',
    tr: 'Seçili beş/altı yüzlü matkap dosya türü kullanımdan kaldırıldı, lütfen onaylayın!',
    km: 'ប្រភេទឯកសារម៉ាស៊ីនខ្នាត 5/6 ដែលបានជ្រើសត្រូវបានផ្ដាច់ចេញ សូមផ្ទៀងផ្ទាត់!',
    es: 'El tipo de archivo de diamante de cinco y seis lados seleccionado actualmente ha estado fuera de línea, ¡confírmelo!',
    ar: 'نوع الملف الماسي ذو الخمسة جوانب المحدد حاليًا غير متصل بالإنترنت، يرجى التأكيد!',
  },
  'dock56Drill.permissionErr': {
    zh: '身份信息已丢失, 请重新从柜柜中打开此页面!',
    en: 'Identity information has been lost. Please reopen this page from the cabinet!',
    id: 'Informasi identitas telah hilang, buka halaman ini lagi dari kabinet!',
    kz: 'Қызметтеріңіз жоғалды, шаблоннан қайтадан осы бетті ашуіш!',
    th: 'ข้อมูลประจำตัวหายไปโปรดเปิดหน้านี้อีกครั้งจากคณะรัฐมนตรี!',
    ug: 'كىملىك ئۇچۇرى يوقالدى، بۇ بەتنى قايتا ئىشكاپتىن ئېچىڭ!',
    vi: 'Thông tin nhận dạng đã mất, vui lòng mở lại trang này từ cabine!',
    zh_tc: '身份信息已丟失, 請重新從櫃櫃中打開此頁面!',
    ru: 'Личные данные утеряны, пожалуйста, откройте эту страницу снова из шкафа!',
    ko: '신원 정보가 분실되었습니다. 이 페이지를 캐비닛에서 다시 열어 주십시오!',
    bur: 'ကိုယ်ရေးအချက်အလက် ပျောက်ဆုံးသွားသည်၊ ဤစာမျက်နှာကို Guigui မှ ပြန်ဖွင့်ပါ!',
    ben: 'পরিচয় তথ্য হারিয়ে গেছে, দয়া করে Guigui থেকে এই পৃষ্ঠাটি আবার খুলুন!',
    tr: 'Kimlik bilgileri kayboldu, lütfen bu sayfayı Guigui üzerinden yeniden açın!',
    km: 'ព័ត៌មានអត្តសញ្ញាណបាត់ សូមបើកទំព័រនេះឡើងវិញពី Guigui!',
    es: 'La información de identidad se ha perdido. ¡Vuelva a abrir esta página desde el gabinete!',
    ar: 'لقد فقدت المعلومات الشخصية، يرجى إعادة فتح هذه الصفحة من مجلس الوزراء!',
  },
  'dock56Drill.banFileSetting': {
    zh: 'ban格式文件设置',
    en: 'ban Format File Settings',
    id: 'Pengaturan file format larangan',
    kz: 'ban форматты файлды орнату',
    th: 'แบนการตั้งค่าไฟล์รูปแบบ',
    ug: 'ban فورماتلىق ھۆججەت تەڭشىكى',
    vi: 'Cài đặt tập tin định dạng ban',
    zh_tc: 'ban格式文件設置',
    ru: 'Параметры файла формата ban',
    ko: 'ban 형식 파일 설정',
    bur: 'ban ဖော်မတ်ဖိုင် ဆက်တင်',
    ben: 'ban ফরম্যাট ফাইল সেটিংস',
    tr: 'ban biçimli dosya ayarları',
    km: 'ការកំណត់ឯកសារទ្រង់ទ្រាយ ban',
    es: 'configuración de archivo de formato prohibido',
    ar: 'إعدادات ملف تنسيق الحظر',
  },
  'dock56Drill.banFileCodeInfo': {
    zh: 'ban格式文件包含Code信息：',
    en: 'ban Format File Contains Code Information:',
    id: 'File format larangan berisi informasi kode:',
    kz: 'ban форматты файл Code ақпаратты қамтиды:',
    th: 'ไฟล์รูปแบบแบนมีข้อมูลรหัส:',
    ug: 'ban فورماتلىق ھۆججەت Code ئۇچۇرىنى ئۆز ئىچىگە ئالىدۇ:',
    vi: 'Tập tin định dạng ban chứa thông tin Mã:',
    zh_tc: 'ban格式文件包含Code信息：',
    ru: 'Файл формата ban содержит Code информацию:',
    ko: 'ban 형식 파일에는 Code 정보가 포함되어 있습니다.',
    bur: 'ban ဖော်မတ်ဖိုင်တွင် Code အချက်အလက် ပါဝင်သည်:',
    ben: 'ban ফরম্যাট ফাইলে Code তথ্য অন্তর্ভুক্ত থাকে:',
    tr: 'ban biçimli dosya Code bilgisini içerir:',
    km: 'ឯកសារទ្រង់ទ្រាយ ban រួមមានព័ត៌មាន Code៖',
    es: 'El archivo de formato prohibido contiene Code información:',
    ar: 'يحتوي ملف تنسيق الحظر على معلومات Code:',
  },
  'dock56Drill.huahuaLine': {
    zh: '桦桦自动线',
    en: 'Huahua Automatic Line',
    id: 'Birch Automatic Line',
    kz: 'Хуахуа автоматты желісі',
    th: 'สายเบิร์ชอัตโนมัติ',
    ug: 'خۇاخۇا ئاپتوماتىك لىنىيەسى',
    vi: 'Dây chuyền tự động Huahua',
    zh_tc: '樺樺自動線',
    ru: 'Березовый автомат',
    ko: '자작나무 자동선',
    bur: 'Huahua အလိုအလျောက် လိုင်း',
    ben: 'Huahua অটোমেটিক লাইন',
    tr: 'Huahua otomatik hat',
    km: 'ខ្សែសង្វាក់ស្វ័យប្រវត្តិ Huahua',
    es: 'Línea automática Huahua',
    ar: 'خط Huahua التلقائي',
  },
  'dock56Drill.huahuaLineTip': {
    zh: '（不兼容标签放板基准）',
    en: '(Incompatible with label placement standard)',
    id: '(Tidak kompatibel dengan standar penempatan label)',
    kz: '(Қамтамасыз етілмейді: кесу кезіндегі қалдық кесімі)',
    th: '(ไม่สามารถใช้งานได้: ความสูญเสียของการตัด)',
    ug: '(Қамтамасыз етілмейді: Кесу кезіндегі қалдық кесімі)',
    vi: '(Không tương thích: Bù phần trả về)',
    zh_tc: '（不兼容標籤放板基準）',
    ru: '(Несовместимо с базовым стандартом размещения этикетки)',
    ko: '(라벨 배치 기준과 호환되지 않음)',
    bur: '(တံဆိပ်ပေါ်တွင် သက်ဆိုင်ရာဒေတာကို အလိုအလျောက် ထည့်ပေးမည်）',
    ben: '(লেবেল রাখার মান স্থানীয় স্ট্যান্ডার্ড সাথে অসমর্থ)',
    tr: '(Etiket konumlandırma standartıyla uyumsuz)',
    km: '(មិនត្រូវបានប្រើ: កាត់លើកលើកការផ្ទាល់ខ្ទង់)',
    es: '(No compatible con el estándar de ubicación de la etiqueta)',
    ar: '(غير متوافق مع المعيار المرجعي لوضع التسمية)',
  },
  'dock56Drill.huahuaPartFlag.longSide': {
    zh: '长边小于',
    en: 'Long side less than',
    id: 'Sisi panjang kurang dari',
    kz: 'Ұзын жағы кіші',
    th: 'ด้านยาวน้อยกว่า',
    ug: 'ئۇزۇن تەرىپى كىچىك',
    vi: 'Cạnh dài nhỏ hơn',
    zh_tc: '長邊小於',
    ru: 'Длинная сторона меньше',
    ko: '길이가 작음',
    bur: 'ရှည်ဘက် <',
    ben: 'দীর্ঘ পাশ <',
    tr: 'Uzun kenar <',
    km: 'ជ្រុងវែង <',
    es: 'El lado largo es más pequeño que',
    ar: 'الجانب الطويل أصغر من',
  },
  'dock56Drill.huahuaPartFlag.shortSide': {
    zh: '或短边小于',
    en: 'or short side less than',
    id: 'atau sisi pendek kurang dari',
    kz: 'немесе қысқа жағы кіші',
    th: 'หรือด้านสั้นน้อยกว่า',
    ug: 'ياكى قىسقا تەرىپى كىچىك',
    vi: 'hoặc cạnh ngắn nhỏ hơn',
    zh_tc: '或短邊小於',
    ru: 'Или короткая сторона меньше',
    ko: '또는 짧은 모서리가',
    bur: 'သို့မဟုတ် တိုဘက် <',
    ben: 'অথবা ছোট পাশ <',
    tr: 'veya kısa kenar <',
    km: 'ឬជ្រុងខ្លី <',
    es: 'o el lado corto es más pequeño que',
    ar: 'أو الجانب القصير أصغر من',
  },
  'dock56Drill.huahuaPartFlag.partFlag': {
    zh: '的板件生成小板标识',
    en: 'generate small board identifier for boards',
    id: 'menghasilkan penanda papan kecil untuk papan',
    kz: 'панельдің кішкентай тақта белгісін жасау',
    th: 'สร้างเครื่องหมายแผ่นเล็กสำหรับแผ่นกระดาน',
    ug: 'تاختاينىڭ كىچىك تاختا بەلگىسىنى ھاسىل قىلىش',
    vi: 'tạo nhãn bảng nhỏ cho các tấm',
    zh_tc: '的板件生成小板標識',
    ru: 'Создать идентификатор панели',
    ko: '의 보드 부품에 대한 작은 보드 ID 생성',
    bur: 'ရှိသော ဘုတ်များအတွက် သေးဘုတ်အမှတ်အသား ထုတ်ပေးပါ',
    ben: 'এর বোর্ডগুলোর জন্য ছোট বোর্ড আইডি তৈরি করুন',
    tr: 'levhalar için küçük levha kimliği oluştur',
    km: 'បង្កើតសម្គាល់ផ្ទាំងតូចសម្រាប់ផ្ទាំង',
    es: 'Generar identificación de tablero pequeño para las partes del tablero',
    ar: 'إنشاء تعريف صغير للوحة لأجزاء اللوحة',
  },
  'dock56Drill.huahuaPartFlag.tip': {
    zh: '（标签上展示需添加“板件标识-小板标记”数据，桦桦自动线文件中会自动添加对应数据）',
    en: '（Label display requires adding "board identifier-small board marker" data, and the Huahua automatic line file will automatically add corresponding data）',
    id: '（Tampilan pada label perlu menambahkan data "papan identifikasi - papan tanda", data yang sesuai akan secara otomatis ditambahkan ke berkas baris tersinggung）',
    kz: 'Жапсыруда «Панель белгісі-кіші панель белгісі» деректерін көрсету қажет, Ха-ха автоматты желі файлында тиісті деректер автоматты түрде қосылады.',
    th: '"แท็บจะแสดงข้อมูล ที่สอดคล้องกันโดยอัตโนมัติในการเพิ่ม" "การแสดงตัวของบอร์ด - ป้ายกระดานเล็ก ๆ"',
    ug: '（بەلگىدە «تاختا بەلگىسى-كىچىك تاختا بەلگىسى» سانلىق مەلۇماتىنى كۆرسىتىش كېرەك، خارا خارا ئاپتوماتىك سىزىق ھۆججىتىدە مۇناسىۋەتلىك سانلىق مەلۇمات ئاپتوماتىك قوشۇلىدۇ.）',
    vi: 'Hiển thị trên nhãn cần phải thêm "bảng nhận dạng - thẻ nhỏ" dữ liệu, các tập tin dòng tự động của cây sẽ tự động thêm dữ liệu tương ứng',
    zh_tc:
      '（標籤上展示需添加「板件標識-小板標記」數據，樺樺自動線文件中會自動添加對應數據）',
    ru: '(На этикетке показано, что необходимо добавить данные « Идентификация панели - разметка доски», соответствующие данные будут автоматически добавлены в файл березовой автоматической линии)',
    ko: '(라벨에 표시된 내용은"판재 표식-소판 표식"데이터를 추가해야 하며 자작나무 자동선 파일에는 자동으로 해당 데이터가 추가된다.)',
    bur: '（တံဆိပ်ပေါ်တွင် “ဘုတ်အမှတ်အသား-သေးဘုတ်မှတ်တံဆိပ်” ဒေတာကို ထည့်ရမည်၊ Huahua အလိုအလျောက်လိုင်း ဖိုင်တွင် သက်ဆိုင်ရာဒေတာကို အလိုအလျောက် ထည့်ပေးမည်）',
    ben: '（লেবেলে দেখাতে “বোর্ড আইডি-ছোট বোর্ড মার্ক” ডেটা যোগ করতে হবে, Huahua অটোমেটিক লাইন ফাইলে সংশ্লিষ্ট ডেটা স্বয়ংক্রিয়ভাবে যোগ হবে）',
    tr: '(Etikette göstermek için "levha kimliği-küçük levha işareti" verisi eklenmelidir; Huahua otomatik hat dosyasında ilgili veriler otomatik eklenir)',
    km: '（ដើម្បីបង្ហាញលើស្លាក ត្រូវបន្ថែមទិន្នន័យ «សម្គាល់ផ្ទាំង-សម្គាល់ផ្ទាំងតូច» ហើយក្នុងឯកសារខ្សែសង្វាក់ស្វ័យប្រវត្តិ Huahua ទិន្នន័យដែលពាក់ព័ន្ធនឹងត្រូវបានបន្ថែមដោយស្វ័យប្រវត្តិ）',
    es: '(Es necesario agregar datos de "identificación de placa-marca de placa pequeña" para mostrar en la etiqueta, y los datos correspondientes se agregarán automáticamente al archivo de línea automática de Huahua)',
    ar: '(من الضروري إضافة بيانات "تحديد اللوحة - علامة اللوحة الصغيرة" لعرضها على الملصق، وستتم إضافة البيانات المقابلة تلقائيًا إلى ملف خط Huahua التلقائي)',
  },
  'dock56Drill.plankPutWay': {
    zh: '板件摆放方式',
    en: 'Plank Placement Method',
    id: 'Metode penempatan papan',
    kz: 'Тақтайды орналастыру тәсілі',
    th: 'วิธีการวางแผ่นไม้',
    ug: 'تاختاي قويۇش ئۇسۇلى',
    vi: 'Cách đặt ván',
    zh_tc: '板件擺放方式',
    ru: 'Режим размещения листов',
    ko: '판재 배치 방식',
    bur: 'ဘုတ်ထားပုံ နည်းလမ်း',
    ben: 'বোর্ড রাখার পদ্ধতি',
    tr: 'Levha yerleştirme yöntemi',
    km: 'របៀបដាក់ផ្ទាំង',
    es: 'Método de colocación del panel',
    ar: 'طريقة وضع اللوحة',
  },
  'dock56Drill.plankPutWayTip': {
    zh: '若当前生产线开启桦桦自动线则不支持单独设置板件摆放方式',
    en: 'If the current production line is enabled Huahua automatic line, the setting of plank placement method is not supported',
    id: 'Jika jalur produksi saat ini membuka jalur otomatis birch, tidak didukung untuk mengatur metode penempatan panel secara terpisah',
    kz: 'Ако текущата производствена линия е включена, автоматичната линия Huahua не поддържа отделното разположение на панелите',
    th: 'ถ้าสายการผลิตปัจจุบันเปิดใช้งาน การตั้งค่าวิธีการวางแผ่นไม้ไม่รองรับ',
    ug: 'ھۇچۇر سىزىق ھۆججىتىدە مۇناسىۋەتلىك سانلىق مەلۇمات ئاپتوماتىك قوشۇلىدۇ.',
    vi: 'Nếu đường sản xuất hiện tại được bật, việc đặt ván không được hỗ trợ',
    zh_tc: '若當前生產線開啟樺樺自動線則不支持單獨設置板件擺放方式',
    ru: 'Если текущая производственная линия включена, настройка метода размещения листов не поддерживается',
    ko: '현재 생산 라인이 활성화되어 있으면 판재 배치 방식 설정이 지원되지 않습니다',
    bur: 'လက်ရှိထုတ်လုပ်မှုလိုင်းသည် အလိုအလျောက်လိုင်းဖွင့်ထားပါက ပလင်းကို သီးခြားစီမံခြင်းမထောက်ပံ့ပါ',
    ben: 'যদি বর্তমান উন্নতি লাইন সক্রিয় করা হয়, তবে বোর্ড রাখার পদ্ধতি সেটিং সমর্থিত নয়',
    tr: 'Eğer mevcut üretim hattı açıksa, levha yerleştirme yöntemi ayarı desteklenmez',
    km: 'បើការវិភាគផ្ទាំងសង្វាក់នៅខាងស្តាំមានប្រសិទ្ធភាពសម្រាប់ការផ្ទាំងផ្ទាំងបានបង្ហាញ',
    es: 'Si la línea de producción actual está habilitada, no se admite la configuración del método de colocación de la tabla',
    ar: 'إذا كانت خط الإنتاج الحالي مفعلًا ، فلا يتم دعم ضبط طريقة وضع اللوحة',
  },
  'dock56Drill.autoHandle': {
    zh: '自动避让夹手',
    en: 'Automatic Avoidance of Clamp',
    id: 'Pengelakan otomatis klem',
    kz: 'Қысқышты автоматты түрде айналып өту',
    th: 'หลีกเลี่ยงที่หนีบอัตโนมัติ',
    ug: 'تۇتقۇچتىن ئاپتوماتىك ساقلىنىش',
    vi: 'Tự động tránh kẹp',
    zh_tc: '自動避讓夾手',
    ru: 'Автоматический предохранитель',
    ko: '자동으로 클립 피하기',
    bur: 'ကလမ်ကို အလိုအလျောက် ရှောင်ရန်',
    ben: 'ক্ল্যাম্প স্বয়ংক্রিয় এভয়েড',
    tr: 'Kıskaca otomatik kaçınma',
    km: 'ការជៀសវាងឧបករណ៍ចាប់ដោយស្វ័យប្រវត្តិ',
    es: 'Evitación automática de las manos de sujeción',
    ar: 'التجنب التلقائي لتشابك الأيدي',
  },
  'dock56Drill.manualHandle': {
    zh: '手动设置避让',
    en: 'Manual Avoidance Setting',
    id: 'Pengaturan pengelakan manual',
    kz: 'Қолмен айналып өту параметрі',
    th: 'ตั้งค่าการหลีกเลี่ยงด้วยตนเอง',
    ug: 'قولدا ساقلىنىش تەڭشىكى',
    vi: 'Cài đặt tránh kẹp thủ công',
    zh_tc: '手動設置避讓',
    ru: 'Установить вручную',
    ko: '수동으로 회피 설정',
    bur: 'လက်ဖြင့် ရှောင်ရန် ဆက်တင်',
    ben: 'ম্যানুয়াল এভয়েড সেটিং',
    tr: 'Manuel kaçınma ayarı',
    km: 'ការកំណត់ការជៀសវាងដោយដៃ',
    es: 'Configuración manual de evitación',
    ar: 'الإعداد اليدوي للتجنب',
  },
  'dock56Drill.fixedFront': {
    zh: '固定前封边',
    en: 'Fixed Front Edge Banding',
    id: 'Pengelakan tetap muka',
    kz: 'Тұрақты алдыңғы жиектеу',
    th: 'ขอบหน้าตายตัว',
    ug: 'ئالدى گىرۋەكنى مۇقىملاشتۇرۇش',
    vi: 'Cố định mép trước',
    zh_tc: '固定前封邊',
    ru: 'Закрытие передней кромки',
    ko: '전면 모서리 고정',
    bur: 'ရှေ့ အပြီးသတ်အနား (封边) ကို တည်ငြိမ်ထား',
    ben: 'ফ্রন্ট এজ ব্যান্ডিং ফিক্সড',
    tr: 'Ön kenar bantlaması sabit',
    km: 'ការរុំគែមខាងមុខជាប់ថេរ',
    es: 'Banda de borde frontal fija',
    ar: 'نطاق الحافة الأمامية الثابتة',
  },
  'dock56Drill.plankNamePlacement': {
    zh: '指定板件名摆放',
    en: 'Placement by Plank Name',
    id: 'Penempatan berdasarkan nama papan',
    kz: 'Тақта атауы бойынша орналастыру',
    th: 'จัดวางตามชื่อแผ่น',
    ug: 'بەلگىلەنگەن تاختاي ئىسمى بويىچە قويۇش',
    vi: 'Đặt tấm theo tên tấm',
    zh_tc: '指定板件名擺放',
    ru: 'Размещение по имени плиты',
    ko: '판재명 지정 배치',
    bur: 'ဘုတ်အမည်အလိုက် ထားရှိခြင်း',
    ben: 'বোর্ড নাম অনুযায়ী স্থাপন',
    tr: 'Levha adına göre yerleştirme',
    km: 'ដាក់ផ្ទាំងតាមឈ្មោះផ្ទាំង',
    es: 'Colocación por nombre de panel',
    ar: 'الوضع حسب اسم اللوحة',
  },
  'dock56Drill.plankNamePlacementTip1': {
    zh: '1、设置后，当板件名称中包含所设字段时，该板件将按对应设置固定对应边在设备的指定侧',
    en: '1. After setting, when the plank name contains the configured field, the corresponding edge of the plank will be fixed to the specified side of the device according to the settings',
    id: '1. Setelah diatur, jika nama papan mengandung field yang ditetapkan, sisi papan yang sesuai akan dipasang ke sisi perangkat yang ditentukan sesuai pengaturan',
    kz: '1. Бапталғаннан кейін, тақта атауында берілген өріс болса, тақтаның сәйкес қабырғасы құрылғының көрсетілген жағына бекітіледі',
    th: '1. หลังตั้งค่า เมื่อชื่อแผ่นมีฟิลด์ที่กำหนด ขอบแผ่นที่เกี่ยวข้องจะถูกยึดไว้ด้านที่ระบุของอุปกรณ์ตามการตั้งค่า',
    ug: '1. تەڭشەلگەندىن كېيىن، تاختاي ئىسمىدا بەلگىلەنگەن مەزمۇن بولسا، تاختاينىڭ مۇناسىۋەتلىك گىرۋىكى ئۈسكۈنىنىڭ بەلگىلەنگەن تەرىپىگە مۇقىملاشتۇرۇلىدۇ',
    vi: '1. Sau khi thiết lập, khi tên tấm chứa trường đã đặt, cạnh tương ứng của tấm sẽ được cố định vào phía chỉ định của thiết bị theo cấu hình',
    zh_tc:
      '1、設置後，當板件名稱中包含所設字段時，該板件將按對應設置固定對應邊在設備的指定側',
    ru: '1. После настройки, если имя плиты содержит заданное поле, соответствующая сторона плиты будет зафиксирована на указанной стороне устройства',
    ko: '1. 설정 후 판재명에 지정한 필드가 포함되면, 해당 판재의 대응 모서리가 설정에 따라 장비의 지정 측에 고정됩니다',
    bur: '1. ဆက်တင်ပြီးနောက် ဘုတ်အမည်တွင် သတ်မှတ်ထားသော အကွက်ပါပါက ထိုဘုတ်၏ သက်ဆိုင်ရာ အနားကို စက်၏ သတ်မှတ်ထားသော ဘက်တွင် ချိတ်ထားမည်',
    ben: '1. সেট করার পর, বোর্ড নামে নির্ধারিত ফিল্ড থাকলে সংশ্লিষ্ট বোর্ড প্রান্ত সেটিং অনুযায়ী ডিভাইসের নির্দিষ্ট পাশে স্থির হবে',
    tr: '1. Ayarlandıktan sonra levha adı belirlenen alanı içeriyorsa, levhanın ilgili kenarı ayara göre cihazın belirtilen tarafına sabitlenir',
    km: '1. បន្ទាប់ពីកំណត់ នៅពេលឈ្មោះផ្ទាំងមានវាលដែលបានកំណត់ គែមផ្ទាំងដែលពាក់ព័ន្ធនឹងត្រូវបានជាប់ថេរនៅផ្នែកដែលបានបញ្ជាក់នៃឧបករណ៍តាមការកំណត់',
    es: '1. Tras la configuración, si el nombre del panel contiene el campo definido, el borde correspondiente se fijará en el lado indicado del equipo según la configuración',
    ar: '1. بعد الإعداد، عندما يحتوي اسم اللوحة على الحقل المحدد، سيتم تثبيت الحافة المقابلة للوحة على الجانب المحدد من الجهاز وفقًا للإعدادات',
  },
  'dock56Drill.plankNamePlacementTip2': {
    zh: '2、此处设置的优先级大于上方的板件摆放方式设置',
    en: '2. The priority of this setting is higher than the plank placement method setting above',
    id: '2. Prioritas pengaturan ini lebih tinggi daripada pengaturan metode penempatan papan di atas',
    kz: '2. Бұл баптаудың басымдығы жоғарыдағы тақтаны орналастыру тәсілі баптауынан жоғары',
    th: '2. ลำดับความสำคัญของการตั้งค่านี้สูงกว่าการตั้งค่าวิธีการวางแผ่นด้านบน',
    ug: '2. بۇ تەڭشەكنىڭ ئالدىنقىلىق دەرىجىسى ئۈستىدىكى تاختاي قويۇش ئۇسۇلى تەڭشىكىدىن يۇقىرى',
    vi: '2. Độ ưu tiên của cài đặt này cao hơn cài đặt cách đặt tấm phía trên',
    zh_tc: '2、此處設置的優先級大於上方的板件擺放方式設置',
    ru: '2. Приоритет этой настройки выше, чем у настройки способа размещения плит выше',
    ko: '2. 이 설정의 우선순위는 위의 판재 배치 방식 설정보다 높습니다',
    bur: '2. ဤဆက်တင်၏ ဦးစားပေးအဆင့်သည် အပေါ်ရှိ ဘုတ်ထားပုံ နည်းလမ်း ဆက်တင်ထက် မြင့်သည်',
    ben: '2. এই সেটিংয়ের অগ্রাধিকার উপরের বোর্ড রাখার পদ্ধতি সেটিংয়ের চেয়ে বেশি',
    tr: '2. Bu ayarın önceliği, yukarıdaki levha yerleştirme yöntemi ayarından daha yüksektir',
    km: '2. អាទិភាពនៃការកំណត់នេះខ្ពស់ជាងការកំណត់របៀបដាក់ផ្ទាំងខាងលើ',
    es: '2. La prioridad de esta configuración es mayor que la del método de colocación del panel de arriba',
    ar: '2. أولوية هذا الإعداد أعلى من إعداد طريقة وضع اللوحة أعلاه',
  },
  'dock56Drill.plankNamePlacementTip3': {
    zh: '3、该功能仅对云排版生效，若当前生产线开启桦桦自动线则不支持单独设置板件摆放方式',
    en: '3. This function is only effective for cloud layout; if the current production line has Huahua automatic line enabled, separate plank placement settings are not supported',
    id: '3. Fitur ini hanya berlaku untuk tata letak cloud; jika jalur produksi saat ini mengaktifkan jalur otomatis Huahua, pengaturan penempatan papan terpisah tidak didukung',
    kz: '3. Бұл мүмкіндік тек бұлттық орналастыру үшін жарамды; ағымдағы өндіріс жолында Huahua автоматты сызығы қосылса, тақтаны бөлек орналастыру баптауы қолдау көрсетілмейді',
    th: '3. ฟังก์ชันนี้มีผลเฉพาะกับการจัดวางบนคลาวด์ หากสายการผลิตปัจจุบันเปิดใช้งานเส้นอัตโนมัติ Huahua จะไม่รองรับการตั้งค่าการวางแผ่นแยกต่างหาก',
    ug: '3. بۇ ئىقتىدار پەقەت بۇلۇتلۇق تەرتىپلەشكە ئۈنۈملۈك؛ نۆۋەتتىكى ئىشلەپچىقىرىش لىنىيەسى Huahua ئاپتوماتىك لىنىيەسىنى ئاچسا، تاختاينى ئايرىم قويۇش تەڭشىكىنى قوللىمايدۇ',
    vi: '3. Chức năng này chỉ có hiệu lực với bố cục đám mây; nếu dây chuyền hiện tại bật dòng tự động Huahua thì không hỗ trợ cài đặt cách đặt tấm riêng',
    zh_tc:
      '3、該功能僅對雲排版生效，若當前生產線開啟樺樺自動線則不支持單獨設置板件擺放方式',
    ru: '3. Функция действует только для облачной вёрстки; если на текущей производственной линии включена автоматическая линия Huahua, отдельная настройка размещения плит не поддерживается',
    ko: '3. 이 기능은 클라우드 배치에만 적용되며, 현재 생산 라인에서 Huahua 자동라인이 켜져 있으면 판재 배치 방식을 따로 설정할 수 없습니다',
    bur: '3. ဤလုပ်ဆောင်ချက်သည် cloud တင်ဆက်မှုအတွက်သာ အကျိုးသက်ရောက်ပြီး လက်ရှိထုတ်လုပ်မှုလိုင်းတွင် Huahua အလိုအလျောက်လိုင်း ဖွင့်ထားပါက ဘုတ်ထားပုံကို သီးခြား ဆက်တင်ခြင်း မထောက်ပံ့ပါ',
    ben: '3. এই ফাংশন শুধুমাত্র ক্লাউড লেআউটে কার্যকর; বর্তমান প্রোডাকশন লাইনে Huahua অটোমেটিক লাইন চালু থাকলে আলাদা বোর্ড স্থাপন সেটিং সমর্থিত নয়',
    tr: '3. Bu özellik yalnızca bulut yerleşimi için geçerlidir; mevcut üretim hattında Huahua otomatik hat açıksa ayrı levha yerleştirme ayarı desteklenmez',
    km: '3. មុខងារនេះមានប្រសិទ្ធភាពសម្រាប់តែការរៀបចំលើក្លោដប៉ុណ្ណោះ ប្រសិនបើខ្សែសង្វាក់ផលិតបច្ចុប្បន្នបើកខ្សែស្វ័យប្រវត្តិ Huahua នឹងមិនគាំទ្រការកំណត់របៀបដាក់ផ្ទាំងដាច់ដោយឡែកទេ',
    es: '3. Esta función solo aplica al diseño en la nube; si la línea de producción actual tiene habilitada la línea automática Huahua, no se admite configurar por separado la colocación del panel',
    ar: '3. هذه الميزة فعّالة فقط للتخطيط السحابي؛ إذا كان خط الإنتاج الحالي مفعّلًا لخط Huahua التلقائي، فلن يتم دعم إعداد وضع اللوحة بشكل منفصل',
  },
  'dock56Drill.addRow': {
    zh: '添加行',
    en: 'Add Row',
    id: 'Tambah baris',
    kz: 'Қатар қосу',
    th: 'เพิ่มแถว',
    ug: 'قۇر قوشۇش',
    vi: 'Thêm hàng',
    zh_tc: '添加行',
    ru: 'Добавить строку',
    ko: '행 추가',
    bur: 'အတန်း ထည့်ရန်',
    ben: 'সারি যোগ করুন',
    tr: 'Satır ekle',
    km: 'បន្ថែមជួរ',
    es: 'Añadir fila',
    ar: 'إضافة صف',
  },
  'dock56Drill.plankNameTip': {
    zh: '请输入板件名',
    en: 'Please enter the plank name',
    id: 'Silakan masukkan nama papan',
    kz: 'Тақтаның атауын енгізіңіз',
    th: 'กรุณากรอกชื่อแผ่น',
    ug: 'تاختاي ئىسمىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập tên tấm',
    zh_tc: '請輸入板件名',
    ru: 'Пожалуйста, введите название плиты',
    ko: '판재 이름을 입력해주세요',
    bur: 'ဘုတ်အမည်ကို ထည့်သွင်းပါ',
    ben: 'বোর্ডের নাম লিখুন',
    tr: 'Lütfen levha adını girin',
    km: 'សូមបញ្ចូលឈ្មោះផ្ទាំង',
    es: 'Por favor, introduzca el nombre del panel',
    ar: 'يرجى إدخال اسم اللوحة',
  },
  'dock56Drill.plankSide': {
    zh: '板件边',
    en: 'Plank Edge',
    id: 'Sisi papan',
    kz: 'Тақта қабырғасы',
    th: 'ขอบแผ่น',
    ug: 'تاختاي گىرۋىكى',
    vi: 'Cạnh tấm',
    zh_tc: '板件邊',
    ru: 'Кромка плиты',
    ko: '판재 모서리',
    bur: 'ဘုတ်အနား',
    ben: 'বোর্ড প্রান্ত',
    tr: 'Levha kenarı',
    km: 'គែមផ្ទាំង',
    es: 'Borde del panel',
    ar: 'حافة اللوحة',
  },
  'dock56Drill.deviceSide': {
    zh: '固定在设备',
    en: 'Fixed on Device',
    id: 'Tetap di perangkat',
    kz: 'Құрылғыға бекіту',
    th: 'ยึดกับอุปกรณ์',
    ug: 'ئۈسكۈنىگە مۇقىملاشتۇرۇش',
    vi: 'Cố định trên thiết bị',
    zh_tc: '固定在設備',
    ru: 'Фиксация на устройстве',
    ko: '장비에 고정',
    bur: 'စက်တွင် ချိတ်ထားခြင်း',
    ben: 'ডিভাইসে স্থির',
    tr: 'Cihazda sabit',
    km: 'ជាប់ថេរនៅលើឧបករណ៍',
    es: 'Fijado en el equipo',
    ar: 'تثبيت على الجهاز',
  },
  'dock56Drill.weldingPlatePlacementEnable': {
    zh: '焊接板原边固定靠夹手',
    en: 'Welding Plate Placement Enable',
    id: 'Pengelakan papan las tetap klem',
    kz: 'Тұрақты қысқыштың жағындағы қысқыш',
    th: 'ตั้งค่าการติดตั้งแผ่นลวดตายตัว',
    ug: 'قولدا لاس پلېت پلېسمېنت ئېنېبل',
    vi: 'Cài đặt vị trí cố định của kẹp',
    zh_tc: '焊接板原邊固定靠夾手',
    ru: 'Закрепление плиты на клемме',
    ko: '웨이딩 보드 원면 고정 클립',
    bur: 'ဘုတ်ပြုပြင်မှုအခြေခံကို တည်ငြိမ်ထား',
    ben: 'ওয়েডিং বোর্ড ফ্রন্ট সফট ক্ল্যাম্প',
    tr: 'Kıskaca sabit tutma',
    km: 'ការរុំគែមខាងមុខជាប់ថេរ',
    es: 'Fijación de la placa de soldadura fija',
    ar: 'تثبيت اللوحة الملحومة ثابت',
  },
  'dock56Drill.onlyBluen': {
    zh: '仅对云排版生效',
    en: 'Only Effective for Cloud Layout',
    id: 'Hanya efektif untuk tata letak awan',
    kz: 'Тек бұлттық орналастыру үшін жарамды',
    th: 'มีผลเฉพาะกับการจัดวางบนคลาวด์',
    ug: 'پەقەت بۇلۇتلۇق تەرتىپلەشكە ئۈنۈملۈك',
    vi: 'Chỉ có hiệu lực với bố cục đám mây',
    zh_tc: '僅對雲排版生效',
    ru: 'Действует только для облачной версии',
    ko: '클라우드 레이아웃에만 적용',
    bur: 'Cloud Layout တွင်သာ သက်ရောက်သည်',
    ben: 'শুধুমাত্র ক্লাউড লেআউটে কার্যকর',
    tr: 'Yalnızca bulut dizilimi için geçerlidir',
    km: 'មានប្រសិទ្ធភាពតែសម្រាប់ការរៀបចំក្នុងពពក',
    es: 'Solo efectivo para composición tipográfica de nubes',
    ar: 'فعال فقط في التنضيد السحابي',
  },
  'dock56Drill.fixedEdge': {
    zh: '固定长封边靠夹手边',
    en: 'Fixed Long Edge Clamp',
    id: 'Pengelakan panjang tetap klem',
    kz: 'Тұрақты ұзындықтық қысқыш',
    th: 'ขอบหน้าตายตัว',
    ug: 'ئالدى گىرۋەكنى مۇقىملاشتۇرۇش',
    vi: 'Cố định mép trước',
    zh_tc: '固定前封邊',
    ru: 'Закрытие передней кромки',
    ko: '전면 모서리 고정',
    bur: 'ရှေ့ အပြီးသတ်အနား (封边) ကို တည်ငြိမ်ထား',
    ben: 'ফ্রন্ট এজ ব্যান্ডিং ফিক্সড',
    tr: 'Ön kenar bantlaması sabit',
    km: 'ការរុំគែមខាងមុខជាប់ថេរ',
    es: 'Banda de borde frontal fija',
    ar: 'نطاق الحافة الأمامية الثابتة',
  },
  'dock56Drill.fixedEdgeRule': {
    zh: '规则说明：判断板件摆放情况',
    en: 'Rule: Determine the placement of the board',
    id: 'Aturan: Tentukan penempatan papan',
    kz: 'Қағида: Тақтайдың орналасуын анықтау',
    th: 'ข้อกำหนด: กำหนดการวางแผ่น',
    ug: 'قانون: تەرتىپلەشتۈرۈش قانونى',
    vi: 'Quy tắc: Xác định vị trí của tấm gỗ',
    zh_tc: '規則說明：判斷板件擺放情況',
    ru: 'Правило: Определить расположение плиты',
    ko: '규칙: 판재의 배치를 결정',
    bur: 'မှတ်ချက်: ဘုတ်ပြုပြင်မှုအခြေခံကို သတ်မှတ်ပါ',
    ben: 'নিয়ম: বোর্ড প্রসেসিং ক্ষেত্রে বিকল্প নির্বাচন করা',
    tr: 'Kural: Levhanın konumunu belirleme',
    km: 'គ្រប់គ្រង: បង្ហាញការរៀបចំផ្ទាំងងាយ',
    es: 'Regla: Determinar la ubicación de la placa',
    ar: 'القاعدة: تحديد موضع اللوحة',
  },
  'dock56Drill.fixedEdgeRuleItem1': {
    zh: '长边靠夹手',
    en: 'Long edge close to clamp',
    id: 'Panjang tepi dekat dengan klem',
    kz: 'Қысқыштың жағындағы ұзындықтық қысқыш',
    th: 'ขอบยาวที่มีที่หนีบ',
    ug: 'تۇتقۇچ ئارقىلىق گىرۋەكنى مۇقىملاشتۇرۇش',
    vi: 'Mép dài gần với kẹp',
    zh_tc: '長邊靠夾手',
    ru: 'Длинное ребро близко к зажиму',
    ko: '긴 변이 클립에 가까움',
    bur: 'ကလမ်ရှိသောဘက်ကို အလိုအလျောက် ရှောင်ရှားပြီး ဘုတ်ပြုပြင်မှုကို လွယ်ကူစေသည်',
    ben: 'দীর্ঘ পাশ ক্ল্যাম্পের কাছাকাছি',
    tr: 'Uzun kenar kıskacıya yakın',
    km: 'ការរុំគែមខាងមុខជាប់ថេរ',
    es: 'Lado largo cerca de la abrazadera',
    ar: 'الحافة الطويلة تقريباً بالقرب من المشبك',
  },
  'dock56Drill.fixedEdgeRuleItem2': {
    zh: '封边靠夹手',
    en: 'Edge close to clamp',
    id: 'Tepi dekat dengan klem',
    kz: 'Қысқыштың жағындағы қысқыш',
    th: 'ขอบที่มีที่หนีบ',
    ug: 'تۇتقۇچ ئارقىلىق گىرۋەكنى مۇقىملاشتۇرۇش',
    zh_tc: '封邊靠夾手',
    ru: 'Закрытие края близко к зажиму',
    ko: '클립 옆 모서리 고정',
    bur: 'အပြီးသတ်အနား (封边) ကို အလိုအလျောက် ရှောင်ရှားပြီး ဘုတ်ပြုပြင်မှုကို လွယ်ကူစေသည်',
    ben: 'ফ্রন্ট এজ ব্যান্ডিং ফিক্সড',
    tr: 'Ön kenar bantlaması sabit',
    km: 'ការរុំគែមខាងមុខជាប់ថេរ',
    es: 'Banda de borde frontal fija',
    ar: 'نطاق الحافة الأمامية الثابتة',
  },
  'dock56Drill.fixedEdgeRuleItem3': {
    zh: '孔槽避让',
    en: 'Hole slot avoid',
    id: 'Slot lubang menghindari',
    kz: 'Ойықтар мен ерекше пішіндер қысқыштың жағынан автоматты түрде айналып өтеді, бұл тақтайды өңдеуді жеңілдетеді',
    th: 'รูและร่องและรูปทรงพิเศษจะหลีกเลี่ยงด้านที่มีที่หนีบโดยอัตโนมัติ เพื่อความสะดวกในการประมวลผลแผ่น',
    ug: 'ئايلاندۇرۇش ئارقىلىق تۆشۈك-يوچۇق ۋە ئالاھىدە شەكىللەرنى تۇتقۇچ تەرەپتىن ئاپتوماتىك ساقلىنىش، تاختاينى ئىشلەشكە قۇلايلىق يارىتىش',
    vi: 'Rãnh và hình dạng đặc biệt sẽ tự động tránh phía kẹp, giúp gia công ván dễ dàng hơn',
    zh_tc: '孔槽避讓',
    ru: 'Избегание отверстий и специальных форм у зажима',
    ko: '클립 옆 모서리 고정',
    bur: 'အပြီးသတ်အနား (封边) ကို အလိုအလျောက် ရှောင်ရှားပြီး ဘုတ်ပြုပြင်မှုကို လွယ်ကူစေသည်',
    ben: 'ফ্রন্ট এজ ব্যান্ডিং ফিক্সড',
    tr: 'Ön kenar bantlaması sabit',
    km: 'ការរុំគែមខាងមុខជាប់ថេរ',
    es: 'Banda de borde frontal fija',
    ar: 'نطاق الحافة الأمامية الثابتة',
  },
  'dock56Drill.fixedEdgeRuleItem4': {
    zh: '优先级顺序',
    en: 'Priority order',
    id: 'Urutan prioritas',
    kz: 'Приоритеттілік реті',
    th: 'ลำดับความสำคัญ',
    ug: 'تۇتقۇچ قىممەت قىسقۇچى',
    vi: 'Thứ tự ưu tiên',
    zh_tc: '優先順序',
    ru: 'Приоритетный порядок',
    ko: '우선순위',
    bur: 'အောင်မြင်သည့် အခြေခံကို သတ်မှတ်ပါ',
    ben: 'প্রাথমিক ক্রম',
    tr: 'Öncelik sırası',
    km: 'ការរុំគែមខាងមុខជាប់ថេរ',
    es: 'Orden de prioridad',
    ar: 'ترتيب الأولوية',
  },
  'dock56Drill.satisfiedCondition': {
    zh: '满足条件',
    en: 'Condition met',
    id: 'Kondisi terpenuhi',
    kz: 'Шарт орындалды',
    th: 'สะดวกในการประมวลผลแผ่น',
    ug: 'تۇتقۇچ قىممەت قىسقۇچى',
    vi: 'Thứ tự ưu tiên',
    zh_tc: '滿足條件',
    ru: 'Условие выполнено',
    ko: '조건 충족',
    bur: 'အောင်မြင်သည့် အခြေခံကို သတ်မှတ်ပါ',
    ben: 'প্রাথমিক ক্রম',
    tr: 'Öncelik sırası',
    km: 'ការរុំគែមខាងមុខជាប់ថេរ',
    es: 'Orden de prioridad',
    ar: 'ترتيب الأولوية',
  },
  'dock56Drill.handDirection': {
    zh: '夹手所在方向',
    en: 'Clamp Position Direction',
    id: 'Arah posisi klem',
    kz: 'Қысқыштың орналасу бағыты',
    th: 'ทิศทางของที่หนีบ',
    ug: 'تۇتقۇچ ئورنى يۆنىلىشى',
    vi: 'Hướng của kẹp',
    zh_tc: '夾手所在方向',
    ru: 'Направление зажима.',
    ko: '클립이 있는 방향',
    bur: 'ကလမ် တည်နေရာ ဦးတည်ချက်',
    ben: 'ক্ল্যাম্পের অবস্থানের দিক',
    tr: 'Kıskacın bulunduğu yön',
    km: 'ទិសដៅនៃឧបករណ៍ចាប់',
    es: 'Dirección de las manos de sujeción',
    ar: 'اتجاه أيدي التثبيت',
  },
  'dock56Drill.handleMachineTip': {
    zh: '通过旋转的方式让孔槽和异形自动避让夹手所在侧，便于板件加工',
    en: 'By rotating, the groove and special shapes automatically avoid the clamp side, making board processing easier',
    id: 'Dengan memutar, slot dan bentuk khusus akan secara otomatis menghindari sisi klem, memudahkan pemrosesan papan',
    kz: 'Айналдыру арқылы ойықтар мен ерекше пішіндер қысқыштың жағынан автоматты түрде айналып өтеді, бұл тақтайды өңдеуді жеңілдетеді',
    th: 'ด้วยการหมุน รูและร่องและรูปทรงพิเศษจะหลีกเลี่ยงด้านที่มีที่หนีบโดยอัตโนมัติ เพื่อความสะดวกในการประมวลผลแผ่น',
    ug: 'ئايلاندۇرۇش ئارقىلىق تۆشۈك-يوچۇق ۋە ئالاھىدە شەكىللەرنى تۇتقۇچ تەرەپتىن ئاپتوماتىك ساقلىنىش، تاختاينى ئىشلەشكە قۇلايلىق يارىتىش',
    vi: 'Bằng cách xoay, rãnh và hình dạng đặc biệt sẽ tự động tránh phía kẹp, giúp gia công ván dễ dàng hơn',
    zh_tc: '通過旋轉的方式讓孔槽和異形自動避讓夾手所在側，便於板件加工',
    ru: 'Сделайте отверстие и фасон вращающимся способом, чтобы автоматически избежать стороны зажима, чтобы облегчить обработку листов',
    ko: '회전 방식을 통해 구멍 슬롯과 이형이 자동으로 클립의 위치를 피하여 판재 가공을 편리하게 한다',
    bur: 'လှည့်ပတ်ခြင်းဖြင့် အပေါက်/ချောင်းနှင့် အပြားမညီပုံသဏ္ဍာန်များသည် ကလမ်ရှိသောဘက်ကို အလိုအလျောက် ရှောင်ရှားပြီး ဘုတ်ပြုပြင်မှုကို လွယ်ကူစေသည်',
    ben: 'ঘোরানোর মাধ্যমে হোল/স্লট ও স্পেশাল শেপ স্বয়ংক্রিয়ভাবে ক্ল্যাম্প থাকা পাশ এড়িয়ে চলে, ফলে বোর্ড প্রসেসিং সহজ হয়',
    tr: 'Döndürme ile oluk ve özel şekiller, kıskacın bulunduğu tarafa otomatik kaçınır; levha işlemeyi kolaylaştırır',
    km: 'តាមរយៈការបង្វិល រយៈស្នឹងនិងរាងពិសេសជៀសវាងឧបករណ៍ចាប់ដោយស្វ័យប្រវត្តិ ធ្វើឱ្យការដំណើរការផ្ទាំងងាយស្រួល',
    es: 'Al girar, las ranuras y las formas especiales evitan automáticamente el lado donde se encuentra la abrazadera, lo que facilita el procesamiento del panel',
    ar: 'عن طريق الدوران، والفتحات والخاصة تتجنب الأشكال تلقائيًا الجانب الذي يوجد فيه المشبك، مما يسهل معالجة اللوحة',
  },
  'dock56Drill.handleWidth': {
    zh: '夹手宽度',
    en: 'Clamp Width',
    id: 'Lebar klem',
    kz: 'Қысқыштың ені',
    th: 'ความกว้างของที่หนีบ',
    ug: 'تۇتقۇچ كەڭلىكى',
    vi: 'Chiều rộng kẹp',
    zh_tc: '夾手寬度',
    ru: 'Ширина зажима',
    ko: '클립 너비',
    bur: 'ကလမ် အကျယ်',
    ben: 'ক্ল্যাম্পের প্রস্থ',
    tr: 'Kıskıç genişliği',
    km: 'ទទឹងឧបករណ៍ចាប់',
    es: 'Ancho de la abrazadera',
    ar: 'عرض المشبك',
  },
  'dock56Drill.handleLength': {
    zh: '夹手长度',
    en: 'Clamp Length',
    id: 'Panjang klem',
    kz: 'Қысқыштың ұзындығы',
    th: 'ความยาวของที่หนีบ',
    ug: 'تۇتقۇچ ئۇزۇنلۇقى',
    vi: 'Chiều dài kẹp',
    zh_tc: '夾手長度',
    ru: 'Длина зажима',
    ko: '클립 길이',
    bur: 'ကလမ် အရှည်',
    ben: 'ক্ল্যাম্পের দৈর্ঘ্য',
    tr: 'Kıskıç uzunluğu',
    km: 'បណ្ដោយឧបករណ៍ចាប់',
    es: 'Longitud de la abrazadera',
    ar: 'طول المشبك',
  },
  'dock56Drill.handleMaxWidth': {
    zh: '设备可加工的最大宽度',
    en: 'Maximum Processable Width',
    id: 'Lebar maksimum yang dapat diproses',
    kz: 'Жабдықтың өңдей алатын ең үлкен ені',
    th: 'ความกว้างสูงสุดที่อุปกรณ์สามารถประมวลผลได้',
    ug: 'ئۈسكۈنە ئىشلىيەلەيدىغان ئەڭ چوڭ كەڭلىك',
    vi: 'Chiều rộng tối đa có thể gia công',
    zh_tc: '設備可加工的最大寬度',
    ru: 'Максимальная ширина обработки оборудования',
    ko: '장비 가공 가능 최대 너비',
    bur: 'စက်က ပြုပြင်နိုင်သော အများဆုံး အကျယ်',
    ben: 'সর্বোচ্চ প্রসেসযোগ্য প্রস্থ',
    tr: 'İşlenebilir maksimum genişlik',
    km: 'ទទឹងអតិបរមាដែលអាចដំណើរការបាន',
    es: 'Ancho máximo que el equipo puede procesar',
    ar: 'الحد الأقصى للعرض الذي يمكن للمعدات معالجته',
  },
  'dock56Drill.usefulRange': {
    zh: '生效范围',
    en: 'Effective Range',
    id: 'Rentang efektif',
    kz: 'Жарамды диапазон',
    th: 'ช่วงที่มีผล',
    ug: 'ئۈنۈم دائىرىسى',
    vi: 'Phạm vi hiệu lực',
    zh_tc: '生效範圍',
    ru: 'Сфера действия',
    ko: '적용 범위',
    bur: 'သက်ရောက်မည့် အကွာအဝေး',
    ben: 'কার্যকর পরিসর',
    tr: 'Geçerli aralık',
    km: 'ជួរដែលមានប្រសិទ្ធភាព',
    es: 'Rango efectivo',
    ar: 'النطاق الفعال',
  },
  'dock56Drill.plankLongSide': {
    zh: '板件长边',
    en: 'Plank Long Side',
    id: 'Sisi panjang papan',
    kz: 'Тақтайдың ұзын жағы',
    th: 'ด้านยาวของแผ่นไม้',
    ug: 'تاختاي ئۇزۇن تەرىپى',
    vi: 'Cạnh dài của ván',
    zh_tc: '板件長邊',
    ru: 'Длинный край пластины',
    ko: '보드 부품 긴 모서리',
    bur: 'ဘုတ် ရှည်ဘက်',
    ben: 'বোর্ডের দীর্ঘ পাশ',
    tr: 'Levha uzun kenarı',
    km: 'ជ្រុងវែងនៃផ្ទាំង',
    es: 'Lado largo del tablero',
    ar: 'الجانب الطويل من اللوحة',
  },
  'dock56Drill.usefulRangeTip': {
    zh: '当开启板件长边摆放且板子长边在该生效范围内会优先判断槽和异形放置位置',
    en: "When plank long-side placement is enabled and the board's long side is within this effective range, the groove and special shape placement will be prioritized",
    id: 'Ketika pemposisi papan sisi panjang diaktifkan dan sisi panjang papan berada dalam rentang efektif ini, pemposisi slot dan bentuk khusus akan diprioritaskan',
    kz: 'Егер тақтайдың ұзын жағын орналастыру қосылып, оның ұзын жағы осы жарамды диапазонда болса, ойық пен ерекше пішіннің орналасуы басымдыққа ие болады',
    th: 'เมื่อการวางตำแหน่งของแผ่นกระดานด้านยาวเปิดใช้งานและด้านยาวของแผ่นกระดานอยู่ในช่วงที่ใช้งานนี้ การวางตำแหน่งของร่องและรูปร่างที่ไม่ปกติจะถูกนำไปใช้ก่อน',
    ug: 'تاختاي ئۇزۇن تەرىپىنى قويۇش قوزغىتىلغان ۋە تاختاينىڭ ئۇزۇن تەرىپى بۇ ئۈنۈم دائىرىسى ئىچىدە بولغاندا، يوچۇق ۋە ئالاھىدە شەكىل قويۇلۇش ئورنىنى ئالدىن بەلگىلەيدۇ',
    vi: 'Khi bật chế độ đặt theo cạnh dài và cạnh dài của ván nằm trong phạm vi hiệu lực này, vị trí đặt rãnh và hình dạng đặc biệt sẽ được ưu tiên',
    zh_tc:
      '當開啟板件長邊擺放且板子長邊在該生效範圍內會優先判斷槽和異形放置位置',
    ru: 'Когда открывающая пластина размещена с длинным краем и длинный край пластины находится в пределах этого диапазона действия, приоритет отдается расположению канавки и фасона.',
    ko: '슬롯 및 이형의 배치 위치는 슬롯 및 이형의 배치 위치를 결정하기 위해 슬롯의 긴 모서리를 열어 놓습니다.',
    bur: 'ဘုတ် ရှည်ဘက်ထားခြင်းကို ဖွင့်ထားပြီး ဘုတ်၏ ရှည်ဘက်သည် ဤသက်ရောက်မည့် အကွာအဝေးအတွင်း ရှိပါက ချောင်းနှင့် အပြားမညီထားရာနေရာကို ဦးစွာ ဆုံးဖြတ်မည်',
    ben: 'বোর্ডের দীর্ঘ পাশ প্লেসমেন্ট চালু থাকলে এবং দীর্ঘ পাশ এই কার্যকর পরিসরের মধ্যে থাকলে স্লট ও স্পেশাল শেপের অবস্থানকে আগে নির্ধারণ করা হবে',
    tr: 'Uzun kenar yerleştirme açıkken ve levhanın uzun kenarı bu geçerli aralıktaysa, oluk ve özel şekil konumu önceliklendirilir',
    km: 'នៅពេលបើកការដាក់តាមជ្រុងវែង និងជ្រុងវែងនៃផ្ទាំងស្ថិតក្នុងជួរនេះ ទីតាំងរយៈស្នឹងនិងរាងពិសេសនឹងត្រូវបានផ្តល់អាទិភាព',
    es: 'Cuando el lado largo del tablero está habilitado y el lado largo del tablero está dentro del rango efectivo, se priorizarán las posiciones de colocación de ranuras y formas especiales',
    ar: 'عندما يتم تمكين الجانب الطويل من اللوحة ويكون الجانب الطويل من اللوحة ضمن النطاق الفعال، سيتم إعطاء الأولوية للفتحة ومواضع الموضع ذات الشكل الخاص',
  },
  'dock56Drill.moveTip': {
    zh: '正反面文件标识功能已迁移至',
    en: 'The function of the front and back file identifier has been moved to',
    id: 'Pengaturan identifikasi file depan dan belakang telah dipindahkan ke',
    kz: 'Бұлттық орналастырудағы файл белгісінің функциясы қайта орнатуға жылжиды',
    th: 'การเลือกไฟล์ที่เกี่ยวข้องกับการตั้งค่าได้ถูกย้าย',
    ug: 'تاختاي ئۇچۇرىنىڭ پۈتۈن تەرتىپلەشكە ئۈنۈملۈك',
    vi: 'Chức năng đánh dấu tệp trước và sau đã được chuyển đến',
    zh_tc: '正反面文件標識功能已遷移至',
    ru: 'Функция распознавания положительных и отрицательных файлов перенесена',
    ko: '양면 및 후면 파일 식별 기능이 마이그레이션됨',
    bur: 'ရှေ့/နောက် ဖိုင်အမှတ်အသား လုပ်ဆောင်ချက်ကို အောက်ပါနေရာသို့ ပြောင်းရွှေ့ပြီးဖြစ်သည်',
    ben: 'ফ্রন্ট/ব্যাক ফাইল আইডেন্টিফায়ারের ফিচারটি এখানে স্থানান্তর করা হয়েছে',
    tr: 'Ön/arka dosya tanımlayıcı işlevi şuraya taşındı',
    km: 'មុខងារសម្គាល់ឯកសារខាងមុខ/ខាងក្រោយត្រូវបានផ្លាស់ទីទៅ',
    es: 'La función de marcado de documentos frontal y posterior se ha migrado a',
    ar: 'تكون وظيفة وضع علامات على المستندات الأمامية والخلفية تم الانتقال إلى',
  },
  'dock56Drill.millingOuter': {
    zh: '铣外异形',
    en: 'Milling external irregular shapes',
    id: 'Penggilingan Alien',
    kz: 'сыртқы формалық фрезерлеу',
    th: 'การกัดภายนอกรูปพิเศษ',
    ug: 'تاشقىرى نامۇنتەۋىز فريزيرلىق',
    vi: 'Phay bên ngoài Alien',
    zh_tc: '銑外異形',
    ru: 'Фрезерная экзопланета',
    ko: '외이형 밀링',
    bur: 'ပြင်ပ အပြားမညီသာ ချောင်းဖရီးဇ်ခြင်း',
    ben: 'বাইরের স্পেশাল শেপ মিলিং',
    tr: 'Dış özel şekil frezeleme',
    km: 'កាត់រាងពិសេសខាងក្រៅ',
    es: 'Fresado de formas especiales exteriores',
    ar: 'طحن الأشكال الخاصة الخارجية',
  },
  'dock56Drill.millingInner': {
    zh: '铣内异形',
    en: 'Milling internal irregular shapes',
    id: 'Alien dalam penggilingan',
    kz: '‌Ішкі ерекше пішінді фрезерлеу',
    th: 'โปรไฟล์ภายในมิลลิ่ง',
    ug: 'ئىچكىرى نامۇنتەۋىز فريزيرلىق',
    vi: 'Phay bên trong hình dạng đặc biệt',
    zh_tc: '銑內異形',
    ru: 'Фрезерная гетероморфность',
    ko: '밀링 내부 이형',
    bur: 'အတွင်းပိုင်း အပြားမညီပုံသဏ္ဍာန် ဖရီးဇ်ခြင်း',
    ben: 'ভেতরের স্পেশাল শেপ মিলিং',
    tr: 'İç özel şekil frezeleme',
    km: 'កាត់រាងពិសេសខាងក្នុង',
    es: 'Fresado de formas especiales interiores',
    ar: 'طحن الأشكال الخاصة الداخلية',
  },
  'dock56Drill.drilling': {
    zh: '加工孔',
    en: 'Machining holes',
    id: 'Pemrosesan lubang',
    kz: 'Тесік істеу',
    th: 'การประมวลผลหลุม',
    ug: 'تۆشۈك ئىشلەش',
    vi: 'Gia công lỗ',
    zh_tc: '加工孔',
    ru: 'Обрабатывающее отверстие',
    ko: '구멍 가공하기',
    bur: 'အပေါက် ပြုလုပ်ခြင်း',
    ben: 'হোল মেশিনিং',
    tr: 'Delik işleme',
    km: 'ការដំណើរការរន្ធ',
    es: 'Mecanizado de agujeros',
    ar: 'تجهيز الثقوب',
  },
  'dock56Drill.slotting': {
    zh: '加工槽',
    en: 'Machining groove',
    id: 'Slot pemrosesan',
    kz: 'Орық жасау',
    th: 'สล็อตการประมวลผล',
    ug: 'ئوراق ئىشلەش',
    vi: 'Gia công rãnh',
    zh_tc: '加工槽',
    ru: 'Обрабатывающая ванна',
    ko: '가공 슬롯',
    bur: 'ချောင်း ပြုလုပ်ခြင်း',
    ben: 'স্লট মেশিনিং',
    tr: 'Oluk işleme',
    km: 'ការដំណើរការរយៈស្នឹង',
    es: 'Mecanizado de ranuras',
    ar: 'فتحات المعالجة',
  },
  'dock56Drill.knivesTip1': {
    zh: '1、设置铣异形刀后切割路径将补偿其刀半径',
    en: '1. After setting the milling cutter, the cutting path will compensate for its blade radius',
    id: '1, Mengatur jalur pemotongan setelah penggilingan pisau asing akan mengkompensasi radius pisau',
    kz: '1. Фрезерлеуге арналған арнайы пышақты орнатқаннан кейін, кесу траекториясы пышақ радиусына қарай коррекцияланады',
    th: '1 เส้นทางการตัดหลังจากการตั้งค่าเครื่องตัดรูปพิเศษจะชดเชยรัศมีของมีด',
    ug: '1. فورمىلىق فرېزا كەسكۈچنى بەلگىلىگەندىن كېيىن، كېسىش يولى كەسكۈچ رادىئۇسىغا تەڭپۇڭلاشتۇرۇلىدۇ',
    vi: '1, Đường cắt sau khi thiết lập dao phay đặc biệt sẽ bù cho bán kính dao của nó',
    zh_tc: '1、設置銑異形刀後切割路徑將補償其刀半徑',
    ru: 'Установите путь резки после фрезы, чтобы компенсировать радиус ее ножа',
    ko: '1. 밀링 이형 공구 설정 후 가공 경로는 공구 반지름을 보상합니다.',
    bur: '1၊ အပြားမညီ ဖရီးဇ်ဓားကို သတ်မှတ်ပြီးနောက် ဖြတ်တောက်လမ်းကြောင်းသည် ဓား၏ အချင်းဝက်ကို အလိုအလျောက်补偿 လုပ်ပေးမည်',
    ben: '1) স্পেশাল শেপ মিলিং টুল সেট করার পর কাটিং পাথ টুলের রেডিয়াস অনুযায়ী কম্পেনসেট করবে',
    tr: '1. Özel şekil freze takımı ayarlandıktan sonra kesim yolu bıçak yarıçapını telafi eder',
    km: '១. បន្ទាប់ពីកំណត់មុខកាត់រាងពិសេស ផ្លូវកាត់នឹងកែសម្រួលតាមកាំរបស់មុខកាត់',
    es: '1. Después de configurar la fresa de forma especial, la trayectoria de corte compensará su radio de corte',
    ar: '1. بعد إعداد قاطعة الطحن ذات الشكل الخاص، سيعوض مسار القطع نصف قطر القاطع الخاص بها',
  },
  'dock56Drill.knivesTip2': {
    zh: '2、异形切割暂不支持xy轴互换的雕刻机',
    en: '2. Alien cutting carving machines that currently do not support xy axis exchange',
    id: '2, Pemotongan asing sementara tidak mendukung mesin ukiran pertukaran sumbu xy',
    kz: '2. Формалық кесу қазіргі уақытта X-Y осьтерін ауыстыру функциясы бар ою станоктарын қолдамайды',
    th: '2, การตัดรูปพิเศษชั่วคราวไม่สนับสนุนเครื่องแกะสลักสำหรับการแลกเปลี่ยนแกน xy',
    ug: '2. فورمىلىق كېسىش ھازىرچە X-Y ئوكلارنى ئالماشتۇرۇش ئىقتىدارىغا ئىگە ئەمەس كېسىش ماشىنىلىرىنى قوللىمايدۇ',
    vi: '2. Cắt hình đặc biệt tạm thời không hỗ trợ máy khắc trục xy hoán đổi',
    zh_tc: '2、異形切割暫不支持xy軸互換的雕刻機',
    ru: 'Инопланетная резка временно не поддерживает XY осевой обмен гравировальных машин',
    ko: '2. 이형 절단은 xy축 교환을 지원하지 않는 조각기',
    bur: '2၊ အပြားမညီ ဖြတ်တောက်မှုသည် XY ဝင်ရိုး အပြန်အလှန် ပြောင်းလဲနိုင်သော ကတ်တင်/雕刻စက်များကို ယာယီ မထောက်ပံ့သေးပါ',
    ben: '2) স্পেশাল শেপ কাটিং বর্তমানে XY অক্ষ অদলবদল সমর্থনকারী এনগ্রেভিং মেশিনে সাপোর্ট করে না',
    tr: '2. Özel şekil kesim şu an XY eksen değişimini desteklemeyen oyma makinelerinde desteklenmez',
    km: '២. ការកាត់រាងពិសេសបច្ចុប្បន្នមិនគាំទ្រម៉ាស៊ីនចាក់រូបដែលប្តូរអ័ក្ស XY ទេ',
    es: '2. El corte de forma especial actualmente no admite la máquina de grabado intercambiable del eje xy',
    ar: '2. لا يدعم القطع ذو الشكل الخاص حاليًا آلة النقش القابلة للتبديل على المحور xy',
  },
  'dock56Drill.internalCutting': {
    zh: '内部异形切割下刀和收刀均在板件内侧',
    en: 'Internal special-shaped cutting under the knife and knife are in the board inside',
    id: 'Pemotongan bentuk tidak beraturan internal, baik pemotongan awal maupun akhir, dilakukan di bagian dalam pelat.',
    kz: 'Ішкі бітімі бейқим кесу кезінде, кескіш құралдың түсуі де, алынуы да ішкі жағында болуы керек. тақта.',
    th: 'การตัดเฉือนภายในรูปทรงที่ผิดปกติ ทั้งการลงและการยกมีดจะอยู่ด้านในบอร์ด',
    ug: 'ئىچكى قىيپاش كېسىش ئىشلىتىدىغان قورالنى باشلاش ۋە ئاخىرلاشتۇرۇش ئىككىسىلا ئىچكى تەرەپتە بولۇشى كېرەك. تاختاي',
    vi: 'Cắt hình dạng bên trong với điểm xuống dao và thu dao ở phía trong bảng',
    zh_tc: '內部異形切割下刀和收刀均在板件內側',
    ru: 'Внутренняя фасонная резка, нож и нож находятся внутри пластины.',
    ko: '내부 이형 가공 하부 및 커터 모두 보드 내부에 있음',
    bur: 'အတွင်းပိုင်း အပြားမညီ ဖြတ်တောက်ရာတွင် ဓားချခြင်းနှင့် ဓားပြန်ယူခြင်းတို့သည် ဘုတ်အတွင်းဘက်တွင်ပင် ဖြစ်သည်',
    ben: 'ইনার স্পেশাল শেপ কাটিংয়ে টুল ডাউন ও টুল রিট্র্যাক্ট—দুটোই বোর্ডের ভেতরের দিকে হয়',
    tr: 'İç özel şekil kesimde bıçak inişi ve kalkışı levhanın içindedir',
    km: 'ការកាត់រាងពិសេសខាងក្នុង ការចុះនិងដកមុខកាត់សុទ្ធតែនៅខាងក្នុងផ្ទាំង',
    es: 'El corte interno de forma especial y la apertura y cierre de la cuchilla están en el interior de la placa',
    ar: 'يوجد القطع الداخلي ذو الشكل الخاص وفتح وإغلاق السكين داخل اللوحة',
  },
  'dock56Drill.externalCutting': {
    zh: '外部异形切割下刀和收刀均在板件外侧',
    en: 'External special-shaped cutting under the knife and knife are in the board outside',
    id: 'Pemotongan bentuk tidak beraturan eksternal, baik pemotongan awal maupun akhir, dilakukan di bagian luar pelat.',
    kz: 'Сыртқы ерекше пішіндердің қырқықтары мен қырқықтары қысқыштың ішінде орналасады. тақта.',
    th: 'การตัดเฉือนภายนอกรูปทรงที่ผิดปกติ ทั้งการลงและการยกมีดจะอยู่ด้านนอกบอร์ด',
    ug: 'سىرتقى شەكىلسىز كېسىشتە پىچاق چۈشۈرۈش ۋە كۆتۈرۈش سىرتقى تەرەپتە بولىدۇ. تاختاي',
    vi: 'Cắt hình dạng bên ngoài với điểm xuống dao và thu dao ở phía ngoài bảng',
    zh_tc: '外部異形切割下刀和收刀均在板件外側',
    ru: 'Внешний фасонный резец и нож расположены на внешней стороне пластины.',
    ko: '외부 이형 가공 하단 및 커터 모두 보드 부품 바깥쪽에 있음',
    bur: 'ပြင်ပ အပြားမညီ ဖြတ်တောက်ရာတွင် ဓားချခြင်းနှင့် ဓားပြန်ယူခြင်းတို့သည် ဘုတ်အပြင်ဘက်တွင် ဖြစ်သည်',
    ben: 'আউটার স্পেশাল শেপ কাটিংয়ে টুল ডাউন ও টুল রিট্র্যাক্ট—দুটোই বোর্ডের বাইরের দিকে হয়',
    tr: 'Dış özel şekil kesimde bıçak inişi ve kalkışı levhanın dışındadır',
    km: 'ការកាត់រាងពិសេសខាងក្រៅ ការចុះនិងដកមុខកាត់សុទ្ធតែនៅខាងក្រៅផ្ទាំង',
    es: 'El corte externo de forma especial y el corte externo de forma especial están en el exterior de la placa',
    ar: 'يوجد القطع الخارجي ذو الشكل الخاص والقطع الخارجي ذو الشكل الخاص على الجزء الخارجي من اللوحة',
  },
  'dock56Drill.externalCuttingDirection': {
    zh: '外部异形切割时，包含异形的整条边缘将同步切割',
    en: 'When external special-shaped cutting, the entire edge including the special shape will be cut synchronously',
    id: 'Pemotongan bentuk tidak beraturan eksternal, termasuk semua tepi bentuk tidak beraturan, akan diproses secara bersamaan.',
    kz: 'Сыртқы ерекше пішіндердің қырқықтары мен қырқықтары қысқыштың ішінде орналасады',
    th: 'การตัดเฉือนภายนอกรูปทรงที่ผิดปกติ รวมถึงทั้งหมดของขอบรูปทรงที่ผิดปกติ จะถูกประมวลผลพร้อมกัน',
    ug: 'سىرتقى شەكىلسىز كېسىشتە، شەكىلسىز گىرۋەكنىڭ پۈتۈن چېتى تەڭ كېسىلىدۇ',
    vi: 'Khi cắt hình dạng bên ngoài, toàn bộ cạnh chứa hình dạng sẽ được cắt đồng thời',
    zh_tc: '外部異形切割時，包含異形的整條邊緣將同步切割',
    ru: 'При внешней фасонной резке весь край, содержащий фасон, будет вырезан синхронно',
    ko: '외부 이형 컷에서는 이형이 포함된 전체 모서리가 동시에 컷됩니다.',
    bur: 'ပြင်ပ အပြားမညီ ဖြတ်တောက်ရာတွင် အပြားမညီ ပါဝင်သော ဘက်အစွန်းတစ်လျှောက်လုံးကို တပြိုင်နက် ဖြတ်တောက်မည်',
    ben: 'আউটার স্পেশাল শেপ কাটিংয়ে স্পেশাল শেপ থাকা পুরো এজ একসাথে কাট হবে',
    tr: 'Dış özel şekil kesimde, özel şekli de içeren tüm kenar eşzamanlı kesilir',
    km: 'នៅពេលកាត់រាងពិសេសខាងក្រៅ គែមទាំងមូលរួមទាំងរាងពិសេសនឹងត្រូវកាត់ព្រមគ្នា',
    es: 'Cuando se realiza el corte externo de forma especial, el todo el borde que contiene la forma especial se cortará simultáneamente',
    ar: 'عندما يكون خارجيًا القطع على شكل خاص، سيتم قطع الحافة بأكملها التي تحتوي على الشكل ذو الشكل الخاص في وقت واحد',
  },
  'dock56Drill.allExternalCutting': {
    zh: '所有外异形',
    en: 'All external shapes',
    id: 'Semua bentuk luar',
    kz: 'Барлық сыртқы пішіндер',
    th: 'ทั้งหมดของขอบรูปทรงที่ผิดปกติ',
    ug: 'بارلىق سىرتقى شەكىلسىز',
    vi: 'Tất cả hình dạng bên ngoài',
    zh_tc: '所有外異形',
    ru: 'Все внешние',
    ko: '모든 외이형',
    bur: 'ပြင်ပ အပြားမညီ အားလုံး',
    ben: 'সব আউটার স্পেশাল শেপ',
    tr: 'Tüm dış özel şekiller',
    km: 'រាងពិសេសខាងក្រៅទាំងអស់',
    es: 'Todas las formas externas con formas especiales',
    ar: 'جميع الأشكال ذات الشكل الخاص الخارجي',
  },
  'dock56Drill.onlyArcExternalCutting': {
    zh: '仅外圆弧异形',
    en: 'Only external circular shapes',
    id: 'Hanya bentuk lingkaran luar',
    kz: 'Тік бұрышты сыртқы пішіндер тік бұрышты',
    th: 'มีขอบรูปทรงที่ผิดปกติเป็นวงกลมภายนอก',
    ug: 'پەقەت يېرىم چەمبەر شەكىلسىز ئىچكى',
    vi: 'Chỉ hình dạng cong bên ngoài',
    zh_tc: '僅外圓弧異形',
    ru: 'Только внешняя дуга',
    ko: '외부 호 이형만',
    bur: 'ပြင်ပ ဝိုင်းကွေး (အာ့ခ်) အပြားမညီသာ',
    ben: 'শুধু বাইরের আর্ক স্পেশাল শেপ',
    tr: 'Yalnızca dış yay özel şekli',
    km: 'មានតែរាងពិសេសខាងក្រៅជារង្វង់',
    es: 'Solo la forma especial del arco exterior',
    ar: 'شكل القوس الخارجي الخاص فقط',
  },
  'doorWallCabinet.tempErrTip': {
    zh: '检测到您未添加门墙柜一体机所用模板，从而无法导出门墙柜一体机加工文件，注意：添加完成后需要重新排版',
    en: 'No template for the Door-Wall-Cabinet machine was added, so the processing file cannot be exported. Note: after adding, you need to re-layout.',
    id: 'Terdeteksi bahwa Anda belum menambahkan template yang digunakan oleh mesin pintu-dinding-lemari, sehingga file pemrosesan tidak dapat diekspor. Catatan: setelah menambahkan, Anda perlu melakukan tata letak ulang.',
    kz: 'Есік-қабырға-шкаф біріктірілген машинасына арналған үлгі қосылмағаны анықталды, сондықтан өңдеу файлын экспорттау мүмкін емес. Ескерту: қосқаннан кейін қайта орналастыру қажет.',
    th: 'ตรวจพบว่าคุณยังไม่ได้เพิ่มเทมเพลตสำหรับเครื่องรวมประตู-ผนัง-ตู้ จึงไม่สามารถส่งออกไฟล์การประมวลผลได้ หมายเหตุ: หลังจากเพิ่มแล้วต้องจัดวางใหม่อีกครั้ง',
    ug: 'ئىشىك-تام-ئىشكاپ بىر گەۋدىلەشكەن ماشىنىغا ئىشلىتىدىغان قېلىپ قوشۇلمىغانلىقى بايقالدى، شۇڭا ئىشلەش ھۆججىتىنى چىقارغىلى بولمايدۇ. دىققەت: قوشۇپ بولغاندىن كېيىن قايتا تىزمىلاش كېرەك.',
    vi: 'Phát hiện bạn chưa thêm mẫu dùng cho máy cửa-tường-tủ tích hợp, nên không thể xuất tệp gia công. Lưu ý: sau khi thêm xong, cần bố trí lại.',
    zh_tc:
      '檢測到您未添加門牆櫃一體機所用模板，從而無法導出門牆櫃一體機加工文件，注意：添加完成後需要重新排版',
    ru: 'Обнаружено, что вы не добавили шаблон для станка «дверь-стена-шкаф», поэтому экспортировать файл обработки невозможно. Примечание: после добавления необходимо заново выполнить раскладку.',
    ko: '문-벽-장 일체형 기계에 사용할 템플릿이 추가되지 않아 가공 파일을 내보낼 수 없습니다. 참고: 추가 완료 후 다시 배치해야 합니다.',
    bur: 'တံခါး-နံရံ-ဗီရို ပေါင်းစည်းစက်အတွက် အသုံးပြုမည့် ပုံစံ(template) ကို မထည့်ထားသောကြောင့် လုပ်ငန်းဖိုင်ကို ထုတ်မရပါ။ မှတ်ချက် - ထည့်သွင်းပြီးနောက် ပြန်လည် အပြင်အဆင်ချရန် လိုအပ်သည်။',
    ben: 'আপনি দরজা-দেয়াল-ক্যাবিনেট একীভূত মেশিনের ব্যবহৃত টেমপ্লেট যোগ করেননি, তাই প্রক্রিয়াকরণ ফাইল এক্সপোর্ট করা যাচ্ছে না। নোট: যোগ করার পর পুনরায় লেআউট করতে হবে।',
    tr: 'Kapı-duvar-dolap entegre makinesi için kullanılan şablonun eklenmediği tespit edildi, bu nedenle işleme dosyası dışa aktarılamıyor. Not: ekleme tamamlandıktan sonra yeniden yerleştirme yapılmalıdır.',
    km: 'បានរកឃើញថាអ្នកមិនទាន់បន្ថែមគំរូដែលប្រើសម្រាប់ម៉ាស៊ីនបញ្ចូលទ្វារ-ជញ្ជាំង-ទូទេ ដូច្នេះមិនអាចនាំចេញឯកសារដំណើរការបានទេ។ ចំណាំ៖ បន្ទាប់ពីបន្ថែមរួច ត្រូវរៀបប្លង់ឡើងវិញ។',
    es: 'Se detectó que no ha agregado la plantilla utilizada por la máquina integrada de puerta, pared y gabinete, por lo que no se puede exportar el archivo de procesamiento. Nota: después de agregarla, debe volver a realizar la composición.',
    ar: 'تم اكتشاف أنك لم تضف القالب المستخدم لآلة الأبواب والجدران والخزائن المتكاملة، لذلك لا يمكن تصدير ملف المعالجة. ملاحظة: بعد الإضافة، يجب إعادة التنضيد.',
  },
  'doorWallCabinet.title': {
    zh: '门墙柜一体机',
    en: 'Door Wall Cabinet',
    id: 'Mesin pintu dinding lemari',
    kz: 'Қабырға және шкафты құрастыру машинасы',
    th: 'เครื่องปรับปรุงผนังและตู้',
    ug: 'ئىشىك-تام-ئىشكاپ بىر گەۋدىلەشكەن ماشىنا',
    vi: 'Máy điều chỉnh tường và tủ',
    zh_tc: '門牆櫃一體機',
    ru: 'Машина для изготовления стен и шкафов',
    ko: '벽과 장롱을 만드는 기계',
    bur: 'တံခါး၊ နံရံနှင့် ဘီရို ပေါင်းစည်းစက်',
    ben: 'দরজা-দেয়াল-ক্যাবিনেট একীভূত মেশিন',
    tr: 'Duvar ve dolap yapan makine',
    km: 'ម៉ាស៊ីនរួមបញ្ចូលទ្វារ ជញ្ជាំង និងទូ',
    es: 'Máquina integrada de puerta, pared y gabinete',
    ar: 'آلة الأبواب والجدران والخزائن المتكاملة',
  },
  'doorWallCabinet.guifang': {
    zh: '归方',
    en: 'Squaring',
    id: 'Penguadratan',
    kz: 'Қосымша квадраттау',
    th: 'การกลับรูปสี่เหลี่ยมผืนผ้า',
    ug: 'تۆت بۇلۇڭلاشتۇرۇش',
    vi: 'Căn vuông',
    zh_tc: '歸方',
    ru: 'Квадраттание',
    ko: '정사각형화',
    bur: 'စတုရန်းညှိခြင်း',
    ben: 'বর্গাকরণ',
    tr: 'Kareleme',
    km: 'ការធ្វើឱ្យជាមុំកែង',
    es: 'Escuadrado',
    ar: 'التربيع',
  },
  'doorWallCabinet.processingTechnology': {
    zh: '加工工艺',
    en: 'Processing Technology',
    id: 'Teknologi Pengolahan',
    kz: 'Өндеу технологиясы',
    th: 'เทคโนโลยีการปรับปรุง',
    ug: 'ئىشىك-تام-ئىشكاپ بىر گەۋدىلەشكەن ماشىنا',
    vi: 'Công nghệ chế tạo',
    zh_tc: '加工工藝',
    ru: 'Технология обработки',
    ko: '처리 기술',
    bur: 'ပြင်ပနိုင်ငံရေး ဆိုင်ရာ',
    ben: 'প্রক্রিয়া প্রযুক্তি',
    tr: 'İşlem Teknolojisi',
    km: 'ការធ្វើឱ្យជាមុំកែង',
    es: 'Tecnología de procesamiento',
    ar: 'تقنية المعالجة',
  },
  'doorWallCabinet.longPlateSecondarySquaring': {
    zh: '长板二次归方',
    en: 'Long Plate Secondary Squaring',
    id: 'Pemotongan kedua',
    kz: 'Қосымша квадраттау',
    th: 'การกลับรูปสี่เหลี่ยมผืนผ้า',
    ug: 'ئىشىك-تام-ئىشكاپ بىر گەۋدىلەشكەن ماشىنا',
    vi: 'Điều chỉnh tường và tủ',
    zh_tc: '長板二次歸方',
    ru: 'Длинная пластина вторичная квадратура',
    ko: '긴 판 이차 정사각형화',
    bur: 'မူရင်း ဖော်မတ်ဖြင့် ဖိုင်ထုတ်ပါ',
    ben: 'ডিফল্ট ফরম্যাট ফাইল আউটপুট করুন',
    tr: 'Varsayılan biçimde dosya dışa aktar',
    km: 'បញ្ចេញឯកសារទ្រង់ទ្រាយលំនាំដើម',
    es: 'Escuadrado secundario de placa larga',
    ar: 'التربيع الثانوي للوحة الطويلة',
  },
  'doorWallCabinet.slotOnDoorPlate': {
    zh: '门板上的槽',
    en: 'Slot on Door Plate',
    id: 'Lubang pada papan pintu',
    kz: 'Slot on Door Plate',
    th: 'ลูกรับบนแผ่นประตู',
    ug: 'ئىشىك-تام-ئىشكاپ بىر گەۋدىلەشكەن ماشىنا',
    vi: 'Lỗ trên tấm cửa',
    zh_tc: '門板上的槽',
    ru: 'Отверстия на дверной панели',
    ko: '문 판 위의 구멍',
    bur: 'တံခါးပြင်ပီးမညီသာ အာ့ခ်ကွေးကွေးပီးမညီသာ',
    ben: 'দরজা প্লেটের লাল',
    tr: 'Kapı panosundaki delikler',
    km: 'បញ្ចេញឯកសារទ្រង់ទ្រាយលំនាំដើម',
    es: 'Ranura en la placa de puerta',
    ar: 'فتحة في لوحة الباب',
  },
  'doorWallCabinet.setting': {
    zh: '门墙柜一体机设置',
    en: 'Door Wall Cabinet Setting',
    id: 'Pengaturan Mesin Pintu Dinding Lemari',
    kz: 'Қабырға және шкафты құрастыру машинасын баптау',
    th: 'ตั้งค่ามีดพื้นผิวประตูกับประตู',
    ug: 'ئىشىك-تام-ئىشكاپ بىر گەۋدىلەشكەن ماشىنا تەڭشىكى',
    vi: 'Cài đặt máy điều chỉnh tường và tủ',
    zh_tc: '門牆櫃一體機設置',
    ru: 'Настройка машины для изготовления стен и шкафов',
    ko: '벽과 장롱을 만드는 기계 설정',
    bur: 'တံခါး၊ နံရံနှင့် ဘီရို ပေါင်းစည်းစက် ဆက်တင်',
    ben: 'দরজা-দেয়াল-ক্যাবিনেট একীভূত মেশিন সেটিং',
    tr: 'Duvar ve dolap yapan makine ayarları',
    km: 'ការកំណត់ម៉ាស៊ីនរួមបញ្ចូលទ្វារ ជញ្ជាំង និងទូ',
    es: 'Configuración de la máquina integrada de puerta, pared y gabinete',
    ar: 'إعدادات آلة الأبواب والجدران والخزائن المتكاملة',
  },

  'PTP.title': {
    zh: 'PTP',
    en: 'PTP',
    id: 'PTP',
    kz: 'PTP',
    th: 'PTP',
    ug: 'PTP',
    vi: 'PTP',
    zh_tc: 'PTP',
    ru: 'PTP',
    ko: 'PTP',
    bur: 'PTP',
    ben: 'PTP',
    tr: 'PTP',
    km: 'PTP',
    es: 'PTP',
    ar: 'PTP',
  },
  'PTP.outputFileFormat': {
    zh: '输出文件格式',
    en: 'Output File Format',
    id: 'Format file output',
    kz: 'Чықару файл пішімі',
    th: 'รูปแบบไฟล์เอาต์พุต',
    ug: 'ھۆججەت فورماتى چىقىرىش',
    vi: 'Định dạng tập tin đầu ra',
    zh_tc: '輸出文件格式',
    ru: 'Формат выходного файла',
    ko: '출력 파일 형식',
    bur: 'ထုတ်ဖိုင် ဖော်မတ်',
    ben: 'আউটপুট ফাইল ফরম্যাট',
    tr: 'Çıktı dosya biçimi',
    km: 'ទ្រង់ទ្រាយឯកសារបញ្ចេញ',
    es: 'Formato de archivo de salida',
    ar: 'تنسيق ملف الإخراج',
  },
  'PTP.outputDefaultFileFormat': {
    zh: '输出默认格式文件',
    en: 'Output Default File Format',
    id: 'File format default output',
    kz: 'Қалыпты файлды шығару',
    th: 'ไฟล์รูปแบบเริ่มต้นเอาต์พุต',
    ug: 'سۈكۈتتىكى فورماتلىق ھۆججەت چىقىرىش',
    vi: 'Đầu ra tập tin định dạng mặc định',
    zh_tc: '輸出默認格式文件',
    ru: 'Вывод файлов формата по умолчанию',
    ko: '기본 형식 파일 내보내기',
    bur: 'မူရင်း ဖော်မတ်ဖြင့် ဖိုင်ထုတ်ပါ',
    ben: 'ডিফল্ট ফরম্যাটের ফাইল আউটপুট করুন',
    tr: 'Varsayılan biçimde dosya dışa aktar',
    km: 'បញ្ចេញឯកសារទ្រង់ទ្រាយលំនាំដើម',
    es: 'Archivo de formato predeterminado de salida',
    ar: 'ملف التنسيق الافتراضي للإخراج',
  },
  'PTP.outputMPRFormat': {
    zh: '输出MPR格式文件',
    en: 'Output MPR File Format',
    id: 'File format MPR output',
    kz: 'MPR пішімді файлды чыгару',
    th: 'ไฟล์รูปแบบ MPR เอาท์พุท',
    ug: 'MPR فورماتلىق ھۆججەت چىقىرىش',
    vi: 'Đầu ra tập tin định dạng MPR',
    zh_tc: '輸出MPR格式文件',
    ru: 'Экспорт файлов формата MPR',
    ko: 'PR 형식 파일 내보내기',
    bur: 'MPR ဖော်မတ်ဖိုင် ထုတ်ပါ',
    ben: 'MPR ফরম্যাট ফাইল আউটপুট করুন',
    tr: 'MPR biçiminde dosya dışa aktar',
    km: 'បញ្ចេញឯកសារទ្រង់ទ្រាយ MPR',
    es: 'Archivo de formato de salida MPR',
    ar: 'ملف تنسيق الإخراج MPR',
  },
  'PTP.fileFormatSettings': {
    zh: '文件格式设置',
    en: 'File Format Settings',
    id: 'Pengaturan Format File',
    kz: 'Файл пішімінің параметрлері',
    th: 'การตั้งค่ารูปแบบไฟล์',
    ug: 'ھۆججەت فورماتى تەڭشىكى',
    vi: 'Cài đặt định dạng tập tin',
    zh_tc: '文件格式設置',
    ru: 'Параметры формата файла',
    ko: '파일 형식 설정',
    bur: 'ဖိုင်ဖော်မတ် ဆက်တင်',
    ben: 'ফাইল ফরম্যাট সেটিংস',
    tr: 'Dosya biçimi ayarları',
    km: 'ការកំណត់ទ្រង់ទ្រាយឯកសារ',
    es: 'Configuración de formato de archivo',
    ar: 'إعداد تنسيق الملف',
  },
  'PTP.wrapSettings': {
    zh: '换行符格式设置：',
    en: 'Line Wrap Format Settings:',
    id: 'Pengaturan Format Line Break:',
    kz: 'Қайта бастау белгісінің пішімі:',
    th: 'การตั้งค่ารูปแบบการแบ่งบรรทัด:',
    ug: 'قۇر ئالماشتۇرۇش بەلگىسى فورماتى تەڭشىكى:',
    vi: 'Cài đặt định dạng dòng mới:',
    zh_tc: '換行符格式設置：',
    ru: 'Параметры формата переноса строк:',
    ko: '줄 바꿈 형식:',
    bur: 'လိုင်းအဆုံးသတ် (newline) ဖော်မတ် ဆက်တင်:',
    ben: 'লাইন ব্রেক ফরম্যাট সেটিংস:',
    tr: 'Satır sonu biçimi ayarları:',
    km: 'ការកំណត់ទ្រង់ទ្រាយបន្ទាត់ថ្មី៖',
    es: 'Configuración de formato de salto de línea:',
    ar: 'إعدادات تنسيق فاصل الأسطر:',
  },
  'PTP.enCodeSettings': {
    zh: '文件编码格式设置：',
    en: 'File Encoding Format Settings:',
    id: 'Pengaturan Format Pengkodean File:',
    kz: 'Файл кодлау пішімі:',
    th: 'การตั้งค่ารูปแบบการเข้ารหัสไฟล์:',
    ug: 'ھۆججەت كودلاش فورماتى تەڭشىكى:',
    vi: 'Cài đặt định dạng mã hóa tập tin:',
    zh_tc: '文件編碼格式設置：',
    ru: 'Настройка формата кодирования файлов:',
    ko: '파일 인코딩 형식 설정:',
    bur: 'ဖိုင် Encoding ဖော်မတ် ဆက်တင်:',
    ben: 'ফাইল এনকোডিং ফরম্যাট সেটিংস:',
    tr: 'Dosya kodlama biçimi ayarları:',
    km: 'ការកំណត់ទ្រង់ទ្រាយកូដឯកសារ៖',
    es: 'Configuración de formato de codificación de archivo:',
    ar: 'إعدادات تنسيق ترميز الملف:',
  },
  'PTP.utf8bom': {
    zh: '带bom的UTF-8',
    en: 'UTF-8 with BOM',
    id: 'UTF-8 dengan bom',
    kz: 'BOM бар UTF-8',
    th: 'UTF-8 พร้อม BOM',
    ug: 'BOM لىق UTF-8',
    vi: 'UTF-8 với BOM',
    zh_tc: '帶bom的UTF-8',
    ru: 'UTF - 8 с бомом',
    ko: 'bom 포함 UTF-8',
    bur: 'BOM ပါသော UTF-8',
    ben: 'BOM সহ UTF-8',
    tr: 'BOM ile UTF-8',
    km: 'UTF-8 ជាមួយ BOM',
    es: 'UTF-8 con BOM',
    ar: 'UTF-8 مع BOM',
  },
  'PTP.partCoordinate': {
    zh: '小板坐标',
    en: 'Part Coordinate',
    id: 'Koordinat papan kecil',
    kz: 'Кишіктік панельдің координатасы',
    th: 'บอร์ดขนาดเล็กพิกัด',
    ug: 'كىچىك تاختاي كوئوردېناتى',
    vi: 'Tọa độ phẳng nhỏ',
    zh_tc: '小板座標',
    ru: 'Маленькие координаты',
    ko: '소판 좌표',
    bur: 'သေးဘုတ် ကိုဩဒိနိတ်',
    ben: 'ছোট বোর্ডের কোঅর্ডিনেট',
    tr: 'Parça koordinatı',
    km: 'កូអរដោនេផ្ទាំងតូច',
    es: 'Coordenadas de placa pequeña',
    ar: 'إحداثيات اللوحة الصغيرة',
  },
  'PTP.xPointSymbol': {
    zh: '横向坐标：',
    en: 'X-Axis Coordinate:',
    id: 'Koordinat horizontal:',
    kz: 'Жақыстық координата:',
    th: 'พิกัดแนวนอน:',
    ug: 'توغرىسىغا كوئوردېناتى:',
    vi: 'Tọa độ ngang:',
    zh_tc: '橫向座標：',
    ru: 'Горизонтальные координаты:',
    ko: '가로 좌표:',
    bur: 'အလျားတန်း (X) ကိုဩဒိနိတ်:',
    ben: 'অনুভূমিক (X) কোঅর্ডিনেট:',
    tr: 'Yatay (X) koordinat:',
    km: 'កូអរដោនេ X (ផ្ដេក)៖',
    es: 'Coordenada horizontal:',
    ar: 'الإحداثي الأفقي:',
  },
  'PTP.yPointSymbol': {
    zh: '纵向坐标：',
    en: 'Y-Axis Coordinate:',
    id: 'Koordinat vertikal:',
    kz: 'Жүзілік координата:',
    th: 'พิกัดแนวตั้ง:',
    ug: 'بويىغا كوئوردېناتى:',
    vi: 'Tọa độ dọc:',
    zh_tc: '縱向座標：',
    ru: 'Продольные координаты:',
    ko: '세로 좌표:',
    bur: 'ဒေါင်လိုက် (Y) ကိုဩဒိနိတ်:',
    ben: 'উল্লম্ব (Y) কোঅর্ডিনেট:',
    tr: 'Dikey (Y) koordinat:',
    km: 'កូអរដោនេ Y (បញ្ឈរ)៖',
    es: 'Coordenada longitudinal:',
    ar: 'الإحداثي الطولي:',
  },
  'PTP.zPointSymbol': {
    zh: '升降坐标：',
    en: 'Z-Axis Coordinate:',
    id: 'Koordinat pengangkat:',
    kz: 'Көтеру координата:',
    th: 'การยกพิกัด:',
    ug: 'كۆتۈرۈش كوئوردېناتى:',
    vi: 'Tọa độ thang máy:',
    zh_tc: '升降座標：',
    ru: 'Координаты подъема:',
    ko: '승강 좌표:',
    bur: 'မြှောက်/ချ (Z) ကိုဩဒိနိတ်:',
    ben: 'লিফট (Z) কোঅর্ডিনেট:',
    tr: 'Z ekseni koordinatı:',
    km: 'កូអរដោនេ Z (លើក/ចុះ)៖',
    es: 'Coordenada de elevación:',
    ar: 'إحداثي الرفع:',
  },
  'PTP.upRight': {
    zh: '正值',
    en: 'Positive Value',
    id: 'Nilai positif',
    kz: 'Қостар',
    th: 'ค่าบวก',
    ug: 'مۇسبەت قىممەت',
    vi: 'Giá trị dương',
    zh_tc: '正值',
    ru: 'Положительное значение',
    ko: '양수 값',
    bur: 'အပြုတန်ဖိုး',
    ben: 'ধনাত্মক মান',
    tr: 'Pozitif değer',
    km: 'តម្លៃវិជ្ជមាន',
    es: 'Valor positivo',
    ar: 'القيمة الموجبة',
  },
  'PTP.negative': {
    zh: '负值',
    en: 'Negative Value',
    id: 'Nilai negatif',
    kz: 'Қайтар',
    th: 'ค่าลบ',
    ug: 'مەنپىي قىممەت',
    vi: 'Giá trị âm',
    zh_tc: '負值',
    ru: 'Отрицательное значение',
    ko: '음수 값',
    bur: 'အနှုတ်တန်ဖိုး',
    ben: 'ঋণাত্মক মান',
    tr: 'Negatif değer',
    km: 'តម្លៃអវិជ្ជមាន',
    es: 'Valores negativos',
    ar: 'القيم السالبة',
  },
  'PTP.plankMirroring': {
    zh: '板件镜像',
    en: 'Board Mirroring',
    id: 'Cermin papan',
    kz: 'Панельдің көрінісі',
    th: 'กระจกกระดาน',
    ug: 'تاختاي كۆزگۈ سۈرىتى',
    vi: 'Hình ảnh phản chiếu phẳng',
    zh_tc: '板件鏡像',
    ru: 'Отражение панелей',
    ko: '보드 대칭복사',
    bur: 'ဘုတ် မီရರ್/ပြန်လှန်',
    ben: 'বোর্ড মিররিং',
    tr: 'Levha aynalama',
    km: 'ការបញ្ចាំងផ្ទាំង',
    es: 'Espejo de placa',
    ar: 'مرآة اللوحة',
  },
  'PTP.plankMirrorSetting': {
    zh: '板件镜像设置：',
    en: 'Board Mirroring Settings:',
    id: 'Pengaturan Mirroring Papan:',
    kz: 'Панельдің көрінісінің параметрлері:',
    th: 'การตั้งค่าบอร์ดมิเรอร์:',
    ug: 'تاختاي كۆزگۈ سۈرىتى تەڭشىكى:',
    vi: 'Cài đặt hình ảnh phản chiếu phẳng:',
    zh_tc: '板件鏡像設置：',
    ru: 'Настройка зеркала панели:',
    ko: '보드 부품 대칭복사 설정:',
    bur: 'ဘုတ် မီရರ್ ဆက်တင်:',
    ben: 'বোর্ড মিররিং সেটিংস:',
    tr: 'Levha aynalama ayarları:',
    km: 'ការកំណត់ការបញ្ចាំងផ្ទាំង៖',
    es: 'Configuración de espejo de placa:',
    ar: 'إعدادات مرآة اللوحة:',
  },
  'PTP.xAxis': {
    zh: 'X轴镜像',
    en: 'X-Axis Mirroring',
    id: 'Mirroring X-Axis',
    kz: 'X осьсінің көрінісі',
    th: 'มิเรอร์แกน x',
    ug: 'X ئوقى كۆزگۈ سۈرىتى',
    vi: 'Hình ảnh phản chiếu trục X',
    zh_tc: 'X軸鏡像',
    ru: 'Отражение оси X',
    ko: 'X축 대칭복사',
    bur: 'X ဝင်ရိုး မီရರ್',
    ben: 'X-অ্যাক্সিস মিরর',
    tr: 'X ekseni aynalama',
    km: 'ការបញ្ចាំងតាមអ័ក្ស X',
    es: 'X Espejo del eje',
    ar: 'X مرآة المحور',
  },
  'PTP.yAxis': {
    zh: 'Y轴镜像',
    en: 'Y-Axis Mirroring',
    id: 'Cermin sumbu y',
    kz: 'Y осьсінің көрінісі',
    th: 'กระจกแกน y',
    ug: 'Y ئوقى كۆزگۈ سۈرىتى',
    vi: 'Hình ảnh phản chiếu trục Y',
    zh_tc: 'Y軸鏡像',
    ru: 'зеркало оси Y',
    ko: 'Y축 대칭복사',
    bur: 'Y ဝင်ရိုး မီရರ್',
    ben: 'Y-অ্যাক্সিস মিরর',
    tr: 'Y ekseni aynalama',
    km: 'ការបញ្ចាំងតាមអ័ក្ស Y',
    es: 'YReflejo del eje',
    ar: 'Yانعكاس المحور',
  },
  'PTP.mirrorTip': {
    zh: '（板件镜像时使用此功能）',
    en: '(Use this feature when mirroring the board)',
    id: '(Fungsi ini digunakan saat mencerminkan papan)',
    kz: '（Панельдің көрінісіде осы функцияны қолдану）',
    th: '(ฟังก์ชั่นนี้ใช้เมื่อทำมิเรอร์บอร์ด)',
    ug: '(تاختاي كۆزگۈ سۈرىتى ۋاقتىدا بۇ ئىقتىدارنى ئىشلىتىڭ)',
    vi: '（Sử dụng chức năng này khi hình ảnh phản chiếu phẳng）',
    zh_tc: '（板件鏡像時使用此功能）',
    ru: '(Использовать эту функцию при зеркальном отображении панели)',
    ko: '(보드를 대칭복사할 때 이 기능 사용)',
    bur: '（ဘုတ်ကို မီရರ್/ပြန်လှန် လုပ်သည့်အခါ ဤလုပ်ဆောင်ချက်ကို သုံးပါ）',
    ben: '（বোর্ড মিরর করার সময় এই ফিচারটি ব্যবহার করুন）',
    tr: '(Levhayı aynalarken bu özelliği kullanın)',
    km: '（ប្រើមុខងារនេះនៅពេលបញ្ចាំងផ្ទាំង）',
    es: '(use esta función al reflejar la placa)',
    ar: '(استخدم هذه الوظيفة عند عكس اللوحة)',
  },
  'PTP.knifeTable.type': {
    zh: '类型',
    en: 'Type',
    id: 'jenis',
    kz: 'Түрі',
    th: 'พิมพ์',
    ug: 'تىپى',
    vi: 'Loại',
    zh_tc: '類型',
    ru: 'тип',
    ko: '유형',
    bur: 'အမျိုးအစား',
    ben: 'ধরন',
    tr: 'Tür',
    km: 'ប្រភេទ',
    es: 'Tipo',
    ar: 'النوع',
  },
  'PTP.knifeTable.diameter': {
    zh: '直径Φ',
    en: 'Diameter Φ',
    id: 'Diameter φ',
    kz: 'Диаметр Φ',
    th: 'เส้นผ่านศูนย์กลางφ',
    ug: 'دىئامېتىرى Φ',
    vi: 'Đường kính Φ',
    zh_tc: '直徑Φ',
    ru: 'Диаметр',
    ko: '지름 Φ',
    bur: 'အချင်းΦ',
    ben: 'ব্যাস Φ',
    tr: 'Çap Φ',
    km: 'អង្កត់ផ្ចិត Φ',
    es: 'Diámetro Φ',
    ar: 'القطرΦ',
  },
  'PTP.knifeTable.offsetX': {
    zh: '偏移X',
    en: 'Offset X',
    id: 'Offset x',
    kz: 'X ауысу',
    th: 'ชดเชย x',
    ug: 'X يۆتكىلىش',
    vi: 'Điểm dịch chuyển X',
    zh_tc: '偏移X',
    ru: 'Смещение X',
    ko: '오프셋 X',
    bur: 'အော့ဖ်ဆက် X',
    ben: 'অফসেট X',
    tr: 'Ofset X',
    km: 'អុហ្វសិត X',
    es: 'Desplazamiento X',
    ar: 'الإزاحة X',
  },
  'PTP.knifeTable.offsetY': {
    zh: '偏移Y',
    en: 'Offset Y',
    id: 'Mengimbangi y',
    kz: 'Y ауысу',
    th: 'ชดเชย y',
    ug: 'Y يۆتكىلىش',
    vi: 'Điểm dịch chuyển Y',
    zh_tc: '偏移Y',
    ru: 'Смещение Y',
    ko: 'Y 오프셋',
    bur: 'အော့ဖ်ဆက် Y',
    ben: 'অফসেট Y',
    tr: 'Ofset Y',
    km: 'អុហ្វសិត Y',
    es: 'Compensación Y',
    ar: 'الإزاحة Y',
  },
  'PTP.knifeTable.offsetZ': {
    zh: '偏移Z',
    en: 'Offset Z',
    id: 'Offset Z.',
    kz: 'Z ауысу',
    th: 'ชดเชย Z',
    ug: 'Z يۆتكىلىش',
    vi: 'Điểm dịch chuyển Z',
    zh_tc: '偏移Z',
    ru: 'Смещение Z',
    ko: '오프셋 Z',
    bur: 'အော့ဖ်ဆက် Z',
    ben: 'অফসেট Z',
    tr: 'Ofset Z',
    km: 'អុហ្វសិត Z',
    es: 'Compensación Z',
    ar: 'الإزاحة Z',
  },
  'PTP.knifeTable.offsetNo': {
    zh: '偏移号',
    en: 'Offset Number',
    id: 'Nomor offset',
    kz: 'Ауысу нөмірі',
    th: 'หมายเลขออฟเซ็ต',
    ug: 'يۆتكىلىش نومۇرى',
    vi: 'Số hiệu dịch chuyển',
    zh_tc: '偏移號',
    ru: 'Номер смещения',
    ko: '오프셋 번호',
    bur: 'အော့ဖ်ဆက် နံပါတ်',
    ben: 'অফসেট নম্বর',
    tr: 'Ofset numarası',
    km: 'លេខអុហ្វសិត',
    es: 'Número de compensación',
    ar: 'رقم الإزاحة',
  },
  'PTP.knifeTable.drillVelocity': {
    zh: '下刀[F]mm/min',
    en: 'Drilling Velocity [F] mm/min',
    id: 'Memotong [f] mm/mnt',
    kz: 'Қырқық ату [F]mm/min',
    th: 'ตัด [F] มม./นาที',
    ug: 'پىچاق چۈشۈرۈش [F]mm/min',
    vi: 'Tốc độ xuống dao [F] mm/phút',
    zh_tc: '下刀[F]mm/min',
    ru: 'Снять нож [F] mm / min',
    ko: '내려치기 [F]mm/min',
    bur: 'ဓားချနှုန်း [F]mm/min',
    ben: 'ডাউন কাট গতি [F]mm/min',
    tr: 'İniş hızı [F] mm/dk',
    km: 'ល្បឿនចុះមុខកាត់ [F] mm/នាទី',
    es: 'Corte [F]mm/min',
    ar: 'قطع [F] مم/دقيقة',
  },
  'PTP.knifeTable.cutVelocity': {
    zh: '加工[F]mm/min',
    en: 'Cutting Velocity [F] mm/min',
    id: 'Memproses [f] mm/mnt',
    kz: 'Қыру [F]mm/min',
    th: 'การประมวลผล [F] มม./นาที',
    ug: 'ئىشلەش [F]mm/min',
    vi: 'Tốc độ gia công [F] mm/phút',
    zh_tc: '加工[F]mm/min',
    ru: 'Обработка [F] mm / min',
    ko: '가공 [F]mm/min',
    bur: 'ပြုပြင်နှုန်း [F]mm/min',
    ben: 'মেশিনিং গতি [F]mm/min',
    tr: 'İşleme hızı [F] mm/dk',
    km: 'ល្បឿនដំណើរការ [F] mm/នាទី',
    es: 'Procesamiento [F]mm/min',
    ar: 'معالجة [F] مم/دقيقة',
  },
  'PTP.knifeTable.rotationSeep': {
    zh: '转速[S]r/min',
    en: 'Rotation Speed [S] r/min',
    id: 'Kecepatan R/Min',
    kz: 'Айналу шығымы [S]r/min',
    th: 'ความเร็ว [s] r/min',
    ug: 'ئايلىنىش سۈرئىتى [S]r/min',
    vi: 'Tốc độ quay [S] vòng/phút',
    zh_tc: '轉速[S]r/min',
    ru: 'Скорость вращения [S] r / min',
    ko: '회전 속도 [S]r/min',
    bur: 'လည်ပတ်နှုန်း [S]r/min',
    ben: 'ঘূর্ণন গতি [S]r/min',
    tr: 'Dönüş hızı [S] dev/dk',
    km: 'ល្បឿនបង្វិល [S] ជុំ/នាទី',
    es: 'Velocidad de rotación [S]r/min',
    ar: 'السرعة[S]ص/دقيقة',
  },
  'PTP.knifeTable.insertRow': {
    zh: '插入行',
    en: 'Insert Row',
    id: 'Masukkan baris',
    kz: 'Сатыр енгізу',
    th: 'แทรกแถว',
    ug: 'قۇر قوشۇش',
    vi: 'Chèn hàng',
    zh_tc: '插入行',
    ru: 'Вставить строку',
    ko: '행 삽입',
    bur: 'အတန်း ထည့်ပါ',
    ben: 'রো ইনসার্ট করুন',
    tr: 'Satır ekle',
    km: 'បញ្ចូលជួរដេក',
    es: 'Insertar fila',
    ar: 'إدراج صف',
  },
  'PTP.knifeTable.deleteRow': {
    zh: '删除行',
    en: 'Delete Row',
    id: 'Hapus baris',
    kz: 'Сатыр жою',
    th: 'ลบแถว',
    ug: 'قۇر ئۆچۈرۈش',
    vi: 'Xóa hàng',
    zh_tc: '刪除行',
    ru: 'Удалить строку',
    ko: '행 삭제',
    bur: 'အတန်း ဖျက်ပါ',
    ben: 'রো ডিলিট করুন',
    tr: 'Satır sil',
    km: 'លុបជួរដេក',
    es: 'Eliminar fila',
    ar: 'حذف صف',
  },
  'PTP.labelPool': {
    zh: '数据标签池',
    en: 'Data Label Pool',
    id: 'Kumpulan tag data',
    kz: 'Деректердің белгісі топ',
    th: 'พูลแท็กข้อมูล',
    ug: 'سانلىق مەلۇمات بەلگە ئامبىرى',
    vi: 'Hồ bể nhãn mã dữ liệu',
    zh_tc: '數據標籤池',
    ru: 'Пул тегов данных',
    ko: '데이터 태그 풀',
    bur: 'ဒေတာ တံဆိပ်စု',
    ben: 'ডেটা লেবেল পুল',
    tr: 'Veri etiket havuzu',
    km: 'អាងស្លាកទិន្នន័យ',
    es: 'Grupo de etiquetas de datos',
    ar: 'تجمع علامات البيانات',
  },
  'PTP.dragTip': {
    zh: '可拖拽或点击复制标签池内标签到输入框内',
    en: 'Drag or click to copy labels from the label pool to the input box',
    id: 'Anda dapat menyeret atau mengklik untuk menyalin tag di kumpulan tag ke kotak input',
    kz: 'Белгісі топтағы белгілерді сүйреп же шерту арқылы шығу ісіне көшіріңіз',
    th: 'คุณสามารถลากหรือคลิกเพื่อคัดลอกแท็กในแท็กพูลลงในกล่องอินพุต',
    ug: 'بەلگە ئامبىرىدىكى بەلگىلەرنى كىرگۈزۈش رامكىسىغا سۆرەپ ياكى چېكىپ كۆچۈرگىلى بولىدۇ',
    vi: 'Có thể kéo hoặc nhấn để sao chép nhãn từ hồ bể nhãn mã dữ liệu vào ô đầu vào',
    zh_tc: '可拖拽或點擊複製標籤池內標籤到輸入框內',
    ru: 'Можно перетащить или нажать кнопку Скопировать вкладку в поле ввода',
    ko: '탭 풀에서 탭을 드래그하거나 클릭하여 입력란에 탭 복사 가능',
    bur: 'တံဆိပ်စုထဲမှ တံဆိပ်들을 Input box ထဲသို့ ဆွဲချ သို့မဟုတ် နှိပ်၍ ကူးယူနိုင်သည်',
    ben: 'লেবেল পুল থেকে ইনপুট বক্সে লেবেল ড্র্যাগ করুন বা ক্লিক করে কপি করুন',
    tr: 'Etiket havuzundan etiketi sürükleyin veya tıklayarak giriş kutusuna kopyalayın',
    km: 'អូសឬចុចដើម្បីចម្លងស្លាកពីអាងស្លាកទៅប្រអប់បញ្ចូល',
    es: 'Puede arrastrar o hacer clic para copiar las etiquetas en el conjunto de etiquetas en el cuadro de entrada',
    ar: 'يمكنك السحب أو النقر لنسخ العلامات الموجودة في تجمع العلامات في مربع الإدخال',
  },
  'PTP.procedure': {
    zh: '程序',
    en: 'Procedure',
    id: 'program',
    kz: 'Процедура',
    th: 'โปรแกรม',
    ug: 'پروگرامما',
    vi: 'Chương trình',
    zh_tc: '程序',
    ru: 'Процедуры',
    ko: '프로그램',
    bur: 'ပရိုဂရမ်',
    ben: 'প্রোগ্রাম',
    tr: 'Program',
    km: 'កម្មវិធី',
    es: 'Programa',
    ar: 'برنامج',
  },
  'PTP.beginCode': {
    zh: '程序开始代码：',
    en: 'Procedure Start Code:',
    id: 'Kode Mulai Program:',
    kz: 'Процедура басталу коды:',
    th: 'รหัสเริ่มโปรแกรม:',
    ug: 'پروگرامما باشلاش كودى:',
    vi: 'Mã bắt đầu chương trình:',
    zh_tc: '程序開始代碼：',
    ru: 'Код начала программы:',
    ko: '프로그램 시작 코드:',
    bur: 'ပရိုဂရမ် စတင်ကုဒ်:',
    ben: 'প্রোগ্রাম শুরুর কোড:',
    tr: 'Program başlangıç kodu:',
    km: 'កូដចាប់ផ្តើមកម្មវិធី៖',
    es: 'Código inicio programa:',
    ar: 'رمز بدء البرنامج:',
  },
  'PTP.endCode': {
    zh: '程序结束代码：',
    en: 'Procedure End Code:',
    id: 'Kode Akhir Program:',
    kz: 'Процедура аяқталу коды:',
    th: 'รหัสสิ้นสุดโปรแกรม:',
    ug: 'پروگرامما ئاخىرلىشىش كودى:',
    vi: 'Mã kết thúc chương trình:',
    zh_tc: '程序結束代碼：',
    ru: 'Код окончания программы:',
    ko: '프로그램 종료 코드:',
    bur: 'ပရိုဂရမ် အဆုံးကုဒ်:',
    ben: 'প্রোগ্রাম শেষের কোড:',
    tr: 'Program bitiş kodu:',
    km: 'កូដបញ្ចប់កម្មវិធី៖',
    es: 'Código fin programa:',
    ar: 'رمز نهاية البرنامج:',
  },
  'PTP.zzdKnifeBeginCode': {
    zh: '主轴刀换刀开始代码：',
    en: 'Spindle Knife Change Start Code:',
    id: 'SPINDLE TOOD Ubah Kode Mulai:',
    kz: 'Негізгі қырқық алмастыру басталу коды:',
    th: 'เครื่องมือ Spindle เปลี่ยนรหัสเริ่มต้น:',
    ug: 'باش ئوق پىچىقى ئالماشتۇرۇش باشلاش كودى:',
    vi: 'Mã bắt đầu thay dao trục chính:',
    zh_tc: '主軸刀換刀開始代碼：',
    ru: 'Код начала смены ножа шпинделя:',
    ko: '스핀들 스왑 시작 코드:',
    bur: 'ပင်မဝင်ရိုးဓား လဲစတင်ကုဒ်:',
    ben: 'স্পিন্ডল টুল চেঞ্জ শুরুর কোড:',
    tr: 'Ana mil takım değişimi başlangıç kodu:',
    km: 'កូដចាប់ផ្តើមប្តូរមុខកាត់ស្ពីនឌែល៖',
    es: 'Código inicio cambio herramienta husillo:',
    ar: 'تغيير رمز البدء لأداة المغزل:',
  },
  'PTP.spindleCutter': {
    zh: '主轴刀',
    en: 'Spindle Cutter',
    id: 'Alat spindel',
    kz: 'Негізгі қырқық',
    th: 'เครื่องมือแกนหมุน',
    ug: 'باش ئوق پىچىقى',
    vi: 'Dao trục chính',
    zh_tc: '主軸刀',
    ru: 'шпиндельный нож',
    ko: '스핀들 나이프',
    bur: 'ပင်မဝင်ရိုးဓား',
    ben: 'স্পিন্ডল কাটার',
    tr: 'Ana mil takımı',
    km: 'មុខកាត់ស្ពីនឌែល',
    es: 'Herramienta husillo',
    ar: 'القاطع المغزل',
  },
  'PTP.zzdKnifeEndCode': {
    zh: '主轴刀换刀结束代码：',
    en: 'Spindle Knife Change End Code:',
    id: 'Alat spindle mengubah kode akhir:',
    kz: 'Негізгі қырқық алмастыру аяқталу коды:',
    th: 'เครื่องมือ Spindle เปลี่ยนรหัสสิ้นสุด:',
    ug: 'باش ئوق پىچىقى ئالماشتۇرۇش ئاخىرلىشىش كودى:',
    vi: 'Mã kết thúc thay dao trục chính:',
    zh_tc: '主軸刀換刀結束代碼：',
    ru: 'Код окончания смены шпинделя:',
    ko: '스핀들 스왑 종료 코드:',
    bur: 'ပင်မဝင်ရိုးဓား လဲအဆုံးကုဒ်:',
    ben: 'স্পিন্ডল টুল চেঞ্জ শেষের কোড:',
    tr: 'Ana mil takım değişimi bitiş kodu:',
    km: 'កូដបញ្ចប់ប្តូរមុខកាត់ស្ពីនឌែល៖',
    es: 'Código fin cambio herramienta husillo:',
    ar: 'تغيير رمز النهاية لأداة المغزل:',
  },
  'PTP.verticalDrill': {
    zh: '垂直钻',
    en: 'Vertical Drill',
    id: 'Bor vertikal',
    kz: 'Тік қырқық',
    th: 'สว่านแนวตั้ง',
    ug: 'تىك تۆشۈك',
    vi: 'Khoan thẳng đứng',
    zh_tc: '垂直鑽',
    ru: 'Вертикальное сверло',
    ko: '수직 드릴',
    bur: 'တည်တံ့ဒရင်',
    ben: 'ভার্টিক্যাল ড্রিল',
    tr: 'Dikey matkap',
    km: 'ម៉ាស៊ីនខ្នាតបញ្ឈរ',
    es: 'Perforación vertical',
    ar: 'الحفر العمودي',
  },
  'PTP.czzBeginCode': {
    zh: '垂直钻启动代码：',
    en: 'Vertical Drill Startup Code:',
    id: 'Kode startup bor vertikal:',
    kz: 'Тік қырқық іске қосу коды:',
    th: 'รหัสเริ่มต้นการเจาะแนวตั้ง:',
    ug: 'تىك تۆشۈك قوزغىتىش كودى:',
    vi: 'Mã khởi động khoan thẳng đứng:',
    zh_tc: '垂直鑽啟動代碼：',
    ru: 'Код запуска вертикального бурения:',
    ko: '수직 드릴 부팅 코드:',
    bur: 'တည်တံ့ဒရင် စတင်ကုဒ်:',
    ben: 'ভার্টিক্যাল ড্রিল স্টার্টআপ কোড:',
    tr: 'Dikey matkap başlatma kodu:',
    km: 'កូដចាប់ផ្តើមម៉ាស៊ីនខ្នាតបញ្ឈរ៖',
    es: 'Código inicio perforación vertical:',
    ar: 'رمز بدء الحفر العمودي:',
  },
  'PTP.czzEndCode': {
    zh: '垂直钻结束代码：',
    en: 'Vertical Drill Shutdown Code:',
    id: 'Kode ujung bor vertikal:',
    kz: 'Тік қырқық іске тоқтау коды:',
    th: 'รหัสปลายเจาะแนวตั้ง:',
    ug: 'تىك تۆشۈك ئاخىرلىشىش كودى:',
    vi: 'Mã kết thúc khoan thẳng đứng:',
    zh_tc: '垂直鑽結束代碼：',
    ru: 'Код окончания вертикального бурения:',
    ko: '수직 드릴 종료 코드:',
    bur: 'တည်တံ့ဒရင် အဆုံးကုဒ်:',
    ben: 'ভার্টিক্যাল ড্রিল শাটডাউন কোড:',
    tr: 'Dikey matkap kapatma kodu:',
    km: 'កូដបិទម៉ាស៊ីនខ្នាតបញ្ឈរ៖',
    es: 'Código fin perforación vertical:',
    ar: 'رمز نهاية الحفر العمودي:',
  },
  'PTP.czzKnifeBeginCode': {
    zh: '垂直钻换刀开始代码：',
    en: 'Vertical Drill Knife Change Start Code:',
    id: 'Alat bor vertikal Ubah Kode Mulai:',
    kz: 'Тік қырқық алмастыру басталу коды:',
    th: 'เครื่องมือเจาะแนวตั้งเปลี่ยนรหัสเริ่มต้น:',
    ug: 'تىك تۆشۈك پىچىقى ئالماشتۇرۇش باشلاش كودى:',
    vi: 'Mã bắt đầu thay dao khoan thẳng đứng:',
    zh_tc: '垂直鑽換刀開始代碼：',
    ru: 'Код начала вертикальной смены бриллианта:',
    ko: '수직 드릴 패스 시작 코드:',
    bur: 'တည်တံ့ဒရင် ဓားလဲ စတင်ကုဒ်:',
    ben: 'ভার্টিক্যাল ড্রিল টুল চেঞ্জ শুরুর কোড:',
    tr: 'Dikey matkap takım değişimi başlangıç kodu:',
    km: 'កូដចាប់ផ្តើមប្តូរមុខកាត់ម៉ាស៊ីនខ្នាតបញ្ឈរ៖',
    es: 'Código inicio cambio herramienta perforación vertical:',
    ar: 'أداة الحفر العمودي تغير رمز البدء:',
  },
  'PTP.czzKnifeEndCode': {
    zh: '垂直钻换刀结束代码：',
    en: 'Vertical Drill Knife Change End Code:',
    id: 'Alat bor vertikal Ubah kode akhir:',
    kz: 'Тік қырқық алмастыру аяқталу коды:',
    th: 'เครื่องมือสว่านแนวตั้งเปลี่ยนรหัสสิ้นสุด:',
    ug: 'تىك تۆشۈك پىچىقى ئالماشتۇرۇش ئاخىرلىشىش كودى:',
    vi: 'Mã kết thúc thay dao khoan thẳng đứng:',
    zh_tc: '垂直鑽換刀結束代碼：',
    ru: 'Код окончания вертикальной смены бриллианта:',
    ko: '수직 드릴 끝 코드:',
    bur: 'တည်တံ့ဒရင် ဓားလဲ အဆုံးကုဒ်:',
    ben: 'ভার্টিক্যাল ড্রিল টুল চেঞ্জ শেষের কোড:',
    tr: 'Dikey matkap takım değişimi bitiş kodu:',
    km: 'កូដបញ្ចប់ប្តូរមុខកាត់ម៉ាស៊ីនខ្នាតបញ្ឈរ៖',
    es: 'Código fin cambio herramienta perforación vertical:',
    ar: 'أداة الحفر العمودية تغير رمز النهاية:',
  },
  'PTP.sidetrack': {
    zh: '侧钻',
    en: 'Side Drill',
    id: 'Bor samping',
    kz: 'Сіде трак',
    th: 'การฝึกซ้อมด้านข้าง',
    ug: 'يان تۆشۈك',
    vi: 'Khoan bên',
    zh_tc: '側鑽',
    ru: 'Боковое сверло',
    ko: '사이드 드릴',
    bur: 'ဘေးဒရင်',
    ben: 'সাইড ড্রিল',
    tr: 'Yan matkap',
    km: 'ម៉ាស៊ីនខ្នាតចិញ្ចឹម',
    es: 'Código inicio perforación lateral',
    ar: 'الحفر الجانبي',
  },
  'PTP.czBeginCode': {
    zh: '侧钻启动代码：',
    en: 'Side Drill Startup Code:',
    id: 'Kode startup bor samping:',
    kz: 'Сіде трак іске қосу коды:',
    th: 'รหัสเริ่มต้นสว่านด้านข้าง:',
    ug: 'يان تۆشۈك قوزغىتىش كودى:',
    vi: 'Mã khởi động khoan bên:',
    zh_tc: '側鑽啟動代碼：',
    ru: 'Код запуска бокового бурения:',
    ko: '사이드 드릴 부트 코드:',
    bur: 'ဘေးဒရင် စတင်ကုဒ်:',
    ben: 'সাইড ড্রিল স্টার্টআপ কোড:',
    tr: 'Yan matkap başlatma kodu:',
    km: 'កូដចាប់ផ្តើមម៉ាស៊ីនខ្នាតចិញ្ចឹម៖',
    es: 'Código inicio perforación lateral:',
    ar: 'رمز بدء التشغيل Sidetrack:',
  },
  'PTP.czEndCode': {
    zh: '侧钻结束代码：',
    en: 'Side Drill Shutdown Code:',
    id: 'Kode akhir pengeboran samping:',
    kz: 'Сіде трак іске тоқтау коды:',
    th: 'รหัสปลายขุดด้านข้าง:',
    ug: 'يان تۆشۈك ئاخىرلىشىش كودى:',
    vi: 'Mã kết thúc khoan bên:',
    zh_tc: '側鑽結束代碼：',
    ru: 'Код окончания бокового бурения:',
    ko: '사이드 드릴 종료 코드:',
    bur: 'ဘေးဒရင် အဆုံးကုဒ်:',
    ben: 'সাইড ড্রিল শাটডাউন কোড:',
    tr: 'Yan matkap kapatma kodu:',
    km: 'កូដបិទម៉ាស៊ីនខ្នាតចិញ្ចឹម៖',
    es: 'Código fin perforación lateral:',
    ar: 'رمز نهاية الحفر الجانبي:',
  },
  'PTP.czKnifeBeginCode': {
    zh: '侧钻换刀开始代码：',
    en: 'Side Drill Knife Change Start Code:',
    id: 'Perubahan Alat Bor Samping Kode Mulai:',
    kz: 'Сіде трак алмастыру басталу коды:',
    th: 'เครื่องมือสว่านด้านข้างเปลี่ยนรหัสเริ่มต้น:',
    ug: 'يان تۆشۈك پىچىقى ئالماشتۇرۇش باشلاش كودى:',
    vi: 'Mã bắt đầu thay dao khoan bên:',
    zh_tc: '側鑽換刀開始代碼：',
    ru: 'Код начала смены ножа бокового бурения:',
    ko: '사이드 드릴 교환기 시작 코드:',
    bur: 'ဘေးဒရင် ဓားလဲ စတင်ကုဒ်:',
    ben: 'সাইড ড্রিল টুল চেঞ্জ শুরুর কোড:',
    tr: 'Yan matkap takım değişimi başlangıç kodu:',
    km: 'កូដចាប់ផ្តើមប្តូរមុខកាត់ម៉ាស៊ីនខ្នាតចិញ្ចឹម៖',
    es: 'Código inicio cambio herramienta perforación lateral:',
    ar: 'تغيير رمز البدء لأداة الحفر الجانبية:',
  },
  'PTP.czKnifeEndCode': {
    zh: '侧钻换刀结束代码：',
    en: 'Side Drill Knife Change End Code:',
    id: 'Alat bor samping Ubah Kode Akhir:',
    kz: 'Сіде трак алмастыру аяқталу коды:',
    th: 'เครื่องมือสว่านด้านข้างเปลี่ยนรหัสสิ้นสุด:',
    ug: 'يان تۆشۈك پىچىقى ئالماشتۇرۇش ئاخىرلىشىش كودى:',
    vi: 'Mã kết thúc thay dao khoan bên:',
    zh_tc: '側鑽換刀結束代碼：',
    ru: 'Код окончания бокового бурения:',
    ko: '측면 드릴 패스 종료 코드:',
    bur: 'ဘေးဒရင် ဓားလဲ အဆုံးကုဒ်:',
    ben: 'সাইড ড্রিল টুল চেঞ্জ শেষের কোড:',
    tr: 'Yan matkap takım değişimi bitiş kodu:',
    km: 'កូដបញ្ចប់ប្តូរមុខកាត់ម៉ាស៊ីនខ្នាតចិញ្ចឹម៖',
    es: 'Código fin cambio herramienta perforación lateral:',
    ar: 'أداة الحفر الجانبية تغير رمز النهاية:',
  },
  'PTP.pauseCode': {
    zh: '暂停代码：',
    en: 'Pause Code:',
    id: 'Kode jeda:',
    kz: 'Тынықтау коды:',
    th: 'รหัสหยุดชั่วคราว:',
    ug: 'توختاش كودى:',
    vi: 'Mã tạm dừng:',
    zh_tc: '暫停代碼：',
    ru: 'Код паузы:',
    ko: '코드 일시정지:',
    bur: 'ရပ်နားကုဒ်:',
    ben: 'পজ কোড:',
    tr: 'Duraklatma kodu:',
    km: 'កូដផ្អាក៖',
    es: 'Código de pausa:',
    ar: 'رمز الإيقاف المؤقت:',
  },
  'PTP.zSafeHeight': {
    zh: '安全距离',
    en: 'Safe distance',
    id: 'Jarak yang aman',
    kz: 'қауіпсіз аралық',
    th: 'ระยะทางปลอดภัย',
    ug: 'بىخەتەر ئارىلىق',
    vi: 'Khoảng cách an toàn',
    zh_tc: '安全距離',
    ru: 'Безопасное расстояние',
    ko: '안전 거리',
    bur: 'ဘေးကင်းအကွာအဝေး',
    ben: 'নিরাপদ দূরত্ব',
    tr: 'Güvenli mesafe',
    km: 'ចម្ងាយសុវត្ថិភាព',
    es: 'Distancia de seguridad',
    ar: 'مسافة الأمان',
  },
  'PTP.spindleKnife': {
    zh: '主轴刀和垂直钻Z轴安全高度',
    en: 'Main spindle cutter and vertical drill Z-axis safety height',
    id: 'Alat spindle dan bor vertikal ketinggian keamanan sumbu z',
    kz: 'Нұрлық бұрыштың және вертикалды құрылғының Z арқатаның қауіпсіз бұрышты',
    th: 'เครื่องมือ Spindle และความสูงความปลอดภัยของแนวแนวตั้ง Z-Axis Safety',
    ug: 'باش ئوق پىچىقى ۋە تىك تۆشۈك Z ئوقى بىخەتەر ئېگىزلىكى',
    vi: 'Trục chính và dọc khoan Z trục chiều cao an toàn',
    zh_tc: '主軸刀和垂直鑽Z軸安全高度',
    ru: 'Безопасная высота шпинделя и вертикального бурения по оси Z',
    ko: '스핀들 및 수직 드릴 Z축 안전 높이',
    bur: 'ပင်မစပင်ဒယ်ဓားနှင့် တည်တံ့ဒရင် Z အက်ဆစ် ဘေးကင်းအမြင့်',
    ben: 'মেইন স্পিন্ডল কাটার ও ভার্টিক্যাল ড্রিলের Z-অ্যাক্সিস সেফটি হাইট',
    tr: 'Ana mil takımı ve dikey matkap Z ekseni güvenlik yüksekliği',
    km: 'កម្ពស់សុវត្ថិភាពអ័ក្ស Z របស់មុខកាត់ស្ពីនឌែលនិងម៉ាស៊ីនខ្នាតបញ្ឈរ',
    es: 'Herramienta de husillo y perforación vertical Z altura de seguridad del eje',
    ar: 'أداة المغزل والحفر العمودي Z ارتفاع أمان المحور',
  },
  'PTP.sideDrillZ': {
    zh: '侧钻Z轴安全高度',
    en: 'Sidedrill Z-axis safety height',
    id: 'Pengeboran samping ketinggian keamanan sumbu z',
    kz: 'Бұрыштың Z арқатаның қауіпсіз бұрышты',
    th: 'ความสูงด้านความปลอดภัยของแกน Z-Axis',
    ug: 'يان تۆشۈك Z ئوقى بىخەتەر ئېگىزلىكى',
    vi: 'Chiều cao an toàn của trục Z khoan bên',
    zh_tc: '側鑽Z軸安全高度',
    ru: 'Безопасная высота оси Z бокового бурения',
    ko: '측면 드릴 Z축 안전 높이',
    bur: 'ဘေးဒရင် Z အက်ဆစ် ဘေးကင်းအမြင့်',
    ben: 'সাইড ড্রিল Z-অ্যাক্সিস সেফটি হাইট',
    tr: 'Yan matkap Z ekseni güvenlik yüksekliği',
    km: 'កម្ពស់សុវត្ថិភាពអ័ក្ស Z របស់ម៉ាស៊ីនខ្នាតចិញ្ចឹម',
    es: 'Perforación lateral Z altura de seguridad del eje',
    ar: 'ارتفاع أمان المحور Z الحفر الجانبي',
  },
  'PTP.sideDrillXY': {
    zh: '侧钻X/Y轴安全距离',
    en: 'Side drilling X/Y-axis safety distance',
    id: 'Pengeboran samping X/Y Jarak Keselamatan Sumbu',
    kz: 'Бұрыштың X/Y арқатаның қауіпсіз аралығы',
    th: 'ระยะทางความปลอดภัยแกน x/y ด้านข้าง',
    ug: 'يان تۆشۈك X/Y ئوقى بىخەتەر ئارىلىقى',
    vi: 'Khoảng cách an toàn trục X/Y cho khoan bên',
    zh_tc: '側鑽X/Y軸安全距離',
    ru: 'Безопасное расстояние по оси X / Y бокового бурения',
    ko: '측면 드릴X/Y축 안전거리',
    bur: 'ဘေးဒရင် X/Y အက်ဆစ် ဘေးကင်းအကွာအဝေး',
    ben: 'সাইড ড্রিল X/Y-অ্যাক্সিস সেফটি ডিস্ট্যান্স',
    tr: 'Yan matkap X/Y ekseni güvenli mesafesi',
    km: 'ចម្ងាយសុវត្ថិភាពអ័ក្ស X/Y របស់ម៉ាស៊ីនខ្នាតចិញ្ចឹម',
    es: 'Perforación lateral X/Y distancia de seguridad del eje',
    ar: 'مسافة أمان المحور X/Y مسافة أمان المحور',
  },
  'PTP.auxiliaryFunction': {
    zh: '辅助功能',
    en: 'Auxiliary Function',
    id: 'Fungsi tambahan',
    kz: 'Қосымша функсия',
    th: 'ฟังก์ชั่นเสริม',
    ug: 'ياردەمچى ئىقتىدار',
    vi: 'Chức năng phụ trợ',
    zh_tc: '輔助功能',
    ru: 'Вспомогательные функции',
    ko: '보조 기능',
    bur: 'အကူအညီ လုပ်ဆောင်ချက်',
    ben: 'সহায়ক ফাংশন',
    tr: 'Yardımcı işlev',
    km: 'មុខងារជំនួយ',
    es: 'Función auxiliar',
    ar: 'الوظيفة المساعدة',
  },
  'PTP.xhDedicatedInfo': {
    zh: '生成星辉设备专用信息',
    en: 'Generate Dedicated Information for Xinghui Devices',
    id: 'Hasilkan Informasi Khusus untuk Peralatan Starlight',
    kz: 'Жұлдызды құрылғыларға арналған ақпаратты жасау',
    th: 'สร้างข้อมูลพิเศษสำหรับอุปกรณ์ Starlight',
    ug: 'شىڭخۇي ئۈسكۈنىسى مەخسۇس ئۇچۇرىنى ھاسىل قىلىش',
    vi: 'Tạo thông tin chuyên dụng cho thiết bị Xinghui',
    zh_tc: '生成星輝設備專用信息',
    ru: 'Создание специальной информации об устройствах & quot; Старлайт & quot;',
    ko: '별빛 장치 전용 정보 생성',
    bur: 'Xinghui စက်များအတွက် သီးသန့် အချက်အလက် ထုတ်ပေးခြင်း',
    ben: 'Xinghui ডিভাইসের জন্য ডেডিকেটেড তথ্য তৈরি করুন',
    tr: 'Xinghui cihazları için özel bilgi oluştur',
    km: 'បង្កើតព័ត៌មានពិសេសសម្រាប់ឧបករណ៍ Xinghui',
    es: 'Generar información específica del equipo Xinghui',
    ar: 'إنشاء معلومات محددة لمعدات Xinghui',
  },
  'PTP.xhCheckBox': {
    zh: '数据：',
    en: 'Data:',
    id: 'data:',
    kz: 'Деректер:',
    th: 'ข้อมูล:',
    ug: 'سانلىق مەلۇمات:',
    vi: 'Dữ liệu:',
    zh_tc: '數據：',
    ru: 'данные',
    ko: '데이터:',
    bur: 'ဒေတာ:',
    ben: 'ডেটা:',
    tr: 'Veri:',
    km: 'ទិន្នន័យ៖',
    es: 'Datos:',
    ar: 'البيانات:',
  },
  'PTP.outputSettings': {
    zh: '输出设置：',
    en: 'Output Settings:',
    id: 'Pengaturan Output:',
    kz: 'Чыгару параметрлері:',
    th: 'การตั้งค่าเอาต์พุต:',
    ug: 'چىقىرىش تەڭشىكى:',
    vi: 'Cài đặt đầu ra:',
    zh_tc: '輸出設置：',
    ru: 'Параметры вывода:',
    ko: '출력 설정:',
    bur: 'ထုတ်ရန် ဆက်တင်:',
    ben: 'আউটপুট সেটিংস:',
    tr: 'Çıktı ayarları:',
    km: 'ការកំណត់បញ្ចេញ៖',
    es: 'Configuraciones de salida:',
    ar: 'إعدادات الإخراج:',
  },
  'PTP.partExegesis': {
    zh: '文件中生成小板尺寸注释',
    en: 'Generate Part Size Annotations in the File',
    id: 'Menghasilkan komentar ukuran papan kecil dalam file',
    kz: 'Файлда кішіктік панельдің өлшемдері туралы түсініктемелерді жасау',
    th: 'สร้างความคิดเห็นขนาดบอร์ดขนาดเล็กในไฟล์',
    ug: 'ھۆججەتتە كىچىك تاختاي ئۆلچىمى چۈشەندۈرۈشىنى ھاسىل قىلىش',
    vi: 'Tạo chú thích kích thước phẳng nhỏ trong tập tin',
    zh_tc: '文件中生成小板尺寸註釋',
    ru: 'Создать комментарий размера панели в файле',
    ko: '파일에 작은 보드 치수 주석 생성하기',
    bur: 'ဖိုင်အတွင်း သေးဘုတ် အရွယ်အစား မှတ်ချက် ထုတ်ပေး',
    ben: 'ফাইলে ছোট বোর্ড সাইজের নোট/কমেন্ট তৈরি করুন',
    tr: 'Dosyada parça boyutu açıklamaları oluştur',
    km: 'បង្កើតកំណត់ចំណាំទំហំផ្ទាំងតូចក្នុងឯកសារ',
    es: 'Generar comentarios de tamaño de placa pequeña en el archivo',
    ar: 'إنشاء تعليقات بحجم لوحة صغيرة في ملف',
  },
  'PTP.knifeNo': {
    zh: '刀具编号',
    en: 'Knife Number',
    id: 'Nomor Alat',
    kz: 'Қырқық нөмірі',
    th: 'หมายเลขเครื่องมือ',
    ug: 'پىچاق نومۇرى',
    vi: 'Số hiệu dao',
    zh_tc: '刀具編號',
    ru: 'Номер ножа',
    ko: '공구 번호',
    bur: 'ဓားကိရိယာ နံပါတ်',
    ben: 'টুল নম্বর',
    tr: 'Takım numarası',
    km: 'លេខមុខកាត់',
    es: 'Herramienta número',
    ar: 'رقم الأداة',
  },
  'PTP.specailKnifeNo': {
    zh: '加工异形刀具编号：',
    en: 'Special Knife Number for Processing Unusual Shapes:',
    id: 'Memproses Nomor Alat Berbentuk Khusus:',
    kz: 'Арнайы пішіруінші қырқық нөмірі:',
    th: 'การประมวลผลหมายเลขเครื่องมือรูปทรงพิเศษ:',
    ug: 'ئالاھىدە شەكىل ئىشلەش پىچاق نومۇرى:',
    vi: 'Số hiệu dao gia công hình dị:',
    zh_tc: '加工異形刀具編號：',
    ru: 'Номер обработанного ножа:',
    ko: '머시닝 이형 공구 번호:',
    bur: 'အပြားမညီ ပြုပြင်ဓား နံပါတ်:',
    ben: 'স্পেশাল শেপ মেশিনিং টুল নম্বর:',
    tr: 'Özel şekil işleme takım numarası:',
    km: 'លេខមុខកាត់សម្រាប់ដំណើរការរាងពិសេស៖',
    es: 'Número de herramienta de forma especial:',
    ar: 'رقم الأداة ذات الشكل الخاص:',
  },
  'PTP.slotKnifeNo': {
    zh: '开槽刀具编号：',
    en: 'Slot Cutting Knife Number:',
    id: 'Nomor Alat Grooving:',
    kz: 'Слот қырқық нөмірі:',
    th: 'หมายเลขเครื่องมือการนั่งร้าน:',
    ug: 'يوچۇق ئېچىش پىچاق نومۇرى:',
    vi: 'Số hiệu dao khoan khe:',
    zh_tc: '開槽刀具編號：',
    ru: 'Номер режущего инструмента:',
    ko: '슬롯 공구 번호:',
    bur: 'ချောင်းဖြတ်ဓား နံပါတ်:',
    ben: 'স্লট কাটিং টুল নম্বর:',
    tr: 'Oluk açma takım numarası:',
    km: 'លេខមុខកាត់កាត់រយៈស្នឹង៖',
    es: 'Número de herramienta de ranurado:',
    ar: 'رقم أداة الحز:',
  },
  'PTP.fileNamePlaceholder': {
    zh: '自定义开料清单',
    en: 'Custom Cutting List',
    id: 'Kustomisasi Bill of Material',
    kz: 'Өзіңіздің іске кіріс тізіміңіз',
    th: 'ปรับแต่งบิลวัสดุ',
    ug: 'ئۆزى بەلگىلىگەن كېسىش تىزىملىكى',
    vi: 'Tên tự định danh sách nguyên liệu cắt',
    zh_tc: '自定義開料清單',
    ru: 'Настройка списка открытых материалов',
    ko: '사용자 정의 커팅 리스트',
    bur: 'စိတ်ကြိုက် ဖြတ်တောက်စာရင်း',
    ben: 'কাস্টম কাটিং লিস্ট',
    tr: 'Özel kesim listesi',
    km: 'បញ្ជីកាត់តាមតម្រូវការ',
    es: 'Lista de materiales personalizada',
    ar: 'قائمة المواد المخصصة',
  },
  'PTP.slotDrill': {
    zh: '拉直器刀',
    en: 'Straightener Knife',
    id: 'Pisau pelurus',
    kz: 'Сыртқа тікеуіш қырқық',
    th: 'มีดแบบตรง',
    ug: 'يوچۇق تارتىش پىچىقى',
    vi: 'Dao kéo thẳng',
    zh_tc: '拉直器刀',
    ru: 'нож выпрямителя',
    ko: '스트레이트 나이프',
    bur: 'တည့်ညှိဓား',
    ben: 'স্ট্রেইটেনার নাইফ',
    tr: 'Düzleştirici takım',
    km: 'មុខកាត់ឧបករណ៍រួចស្រដិត',
    es: 'Cuchilla enderezadora',
    ar: 'سكين فرد',
  },
  'glassEquip.title': {
    zh: '玻璃切割机',
    en: 'Glass Cutting Machine',
    id: 'Mesin pemotong kaca',
    kz: 'Шыны кескіш машина',
    th: 'เครื่องตัดแก้ว',
    ug: 'ئەينەك كېسىش ماشىنىسى',
    vi: 'Máy cắt kính',
    zh_tc: '玻璃切割機',
    ru: 'Стеклорезка',
    ko: '유리 절단기',
    bur: 'မှန်ဖြတ်စက်',
    ben: 'গ্লাস কাটিং মেশিন',
    tr: 'Cam kesim makinesi',
    km: 'ម៉ាស៊ីនកាត់កញ្ចក់',
    es: 'Máquina cortadora de vidrio',
    ar: 'آلة قطع الزجاج',
  },
  'glassEquip.fileType': {
    zh: '加工文件类型：',
    en: 'Processing File Type:',
    id: 'Memproses Jenis File:',
    kz: 'Құрастыру файл түрі:',
    th: 'ประเภทการประมวลผลไฟล์:',
    ug: 'ئىشلەش ھۆججەت تىپى:',
    vi: 'Loại tập tin gia công:',
    zh_tc: '加工文件類型：',
    ru: 'Тип документа обработки:',
    ko: '가공 파일 유형:',
    bur: 'ပြုပြင်ဖိုင် အမျိုးအစား:',
    ben: 'প্রসেসিং ফাইল টাইপ:',
    tr: 'İşleme dosya türü:',
    km: 'ប្រភេទឯកសារដំណើរការ៖',
    es: 'Tipo de archivo de procesamiento:',
    ar: 'نوع ملف المعالجة:',
  },
  'glassEquip.sizeReparation': {
    zh: '板材尺寸补偿：',
    en: 'Board Size Compensation:',
    id: 'Kompensasi Ukuran Plat:',
    kz: 'Панельдің өлшемдеріні толықтыру:',
    th: 'การชดเชยขนาดแผ่น:',
    ug: 'تاختاي ئۆلچىمى تولۇقلىمىسى:',
    vi: 'Bù đắp kích thước tấm:',
    zh_tc: '板材尺寸補償：',
    ru: 'Компенсация размеров листов:',
    ko: '판재 사이즈 보상:',
    bur: 'ပြားအရွယ်အစား ထပ်ဖြည့် (补偿):',
    ben: 'বোর্ড সাইজ কম্পেনসেশন:',
    tr: 'Levha boyutu telafisi:',
    km: 'ការកែសម្រួលទំហំផ្ទាំង៖',
    es: 'Compensación del tamaño de la placa:',
    ar: 'تعويض حجم اللوحة:',
  },
  'glassEquip.cutPreSpace': {
    zh: '板件切割预留间距：',
    en: 'Reserved Spacing for Board Cutting:',
    id: 'Jarak yang dipesan untuk cutting piring:',
    kz: 'Панельдерді кесу алдын ала аралық:',
    th: 'ระยะห่างที่สงวนไว้สำหรับการตัดแผ่น:',
    ug: 'تاختاي كېسىش قالدۇرۇش ئارىلىقى:',
    vi: 'Khoảng cách dự trữ cắt phẳng:',
    zh_tc: '板件切割預留間距：',
    ru: 'Предусмотренное расстояние для резки листов:',
    ko: '보드 부품 가공 예약 간격:',
    bur: 'ဖြတ်တောက်ရန် ကြိုတင်ထားသော အကွာအဝေး:',
    ben: 'বোর্ড কাটিংয়ের জন্য রিজার্ভড স্পেসিং:',
    tr: 'Levha kesimi için ayrılmış boşluk:',
    km: 'គម្លាតធានាសម្រាប់ការកាត់ផ្ទាំង៖',
    es: 'Espaciado de reserva de corte de la placa:',
    ar: 'المسافة الاحتياطية لقطع اللوحة:',
  },
  'glassEquip.divideIntoFolders': {
    zh: '根据玻璃颜色、材质、厚度归为不同文件夹：',
    en: 'Organize Files into Different Folders Based on Glass Color, Material, and Thickness:',
    id: 'Mengklasifikasikannya menjadi folder yang berbeda sesuai dengan warna, bahan, dan ketebalan kaca:',
    kz: 'Шыны түсі, материалы және қалыңдығы бойынша файлдар қапшығына жіктелу:',
    th: 'แบ่งออกเป็นโฟลเดอร์ที่แตกต่างกันตามสีวัสดุและความหนาของแก้ว:',
    ug: 'ئەينەكنىڭ رەڭگى، ماتېرىيالى، قېلىنلىقى بويىچە ئوخشىمىغان قىسقۇچقا ئايرىش:',
    vi: 'Phân loại vào các thư mục khác nhau dựa trên màu sắc, chất liệu, độ dày của kính:',
    zh_tc: '根據玻璃顏色、材質、厚度歸為不同文件夾：',
    ru: 'В зависимости от цвета, материала и толщины стекла классифицируются по различным папкам:',
    ko: '유리 색상, 재료, 두께에 따라 다른 폴더로 분류:',
    bur: 'မှန်၏ အရောင်/ပစ္စည်း/အထူ အလိုက် ဖိုင်များကို မတူညီသော ဖိုလ်ဒါများသို့ ခွဲပါ:',
    ben: 'কাচের রঙ/মেটেরিয়াল/পুরুত্ব অনুযায়ী ফাইলগুলো আলাদা ফোল্ডারে ভাগ করুন:',
    tr: 'Cam rengi, malzeme ve kalınlığa göre farklı klasörlere ayırın:',
    km: 'ចាត់ថ្នាក់ឯកសារទៅថតផ្សេងៗតាមពណ៌ សម្ភារៈ និងកម្រាស់កញ្ចក់៖',
    es: 'Clasificado en diferentes carpetas según el color, material y espesor del vidrio:',
    ar: 'مصنفة في مجلدات مختلفة وفقًا للون الزجاج والمادة والسمك:',
  },
  'translate.search': {
    zh: '请输入中文或者官方翻译寻找词条',
    en: 'Please enter the Chinese or official translation to find the entry',
    id: 'Harap masukkan terjemahan Cina atau resmi untuk menemukan entri',
    kz: 'Терминді табу үшін қытай тіліне немесе ресми аудармасына енгізуіңізді сұраймын',
    th: 'โปรดป้อนการแปลภาษาจีนหรืออย่างเป็นทางการเพื่อค้นหารายการ',
    ug: 'خەنزۇچە ياكى رەسمىي تەرجىمىنى كىرگۈزۈپ تۈر ئىزدەڭ',
    vi: 'Nhập tiếng Trung hoặc dịch chính thức để tìm từ điển',
    zh_tc: '請輸入中文或者官方翻譯尋找詞條',
    ru: 'Пожалуйста, введите китайский или официальный перевод для поиска слов',
    ko: '중국어 또는 공식 번역을 입력하여 단어를 찾으십시오.',
    bur: 'စကားလုံးရှာရန် တရုတ်စာ သို့မဟုတ် တရားဝင်ဘာသာပြန်ကို ထည့်ပါ',
    ben: 'এন্ট্রি খুঁজতে চীনা বা অফিসিয়াল অনুবাদ লিখুন',
    tr: 'Girişi bulmak için Çince veya resmi çeviriyi girin',
    km: 'សូមបញ្ចូលភាសាចិនឬការបកប្រែផ្លូវការដើម្បីស្វែងរកធាតុ',
    es: 'Ingrese chino o traducción oficial para encontrar la entrada',
    ar: 'يرجى إدخال الترجمة الصينية أو الرسمية للعثور على الإدخال',
  },
  'translate.en': {
    zh: '英文',
    en: 'English',
    id: 'Bahasa inggris',
    kz: 'Ағылшынша',
    th: 'ภาษาอังกฤษ',
    ug: 'ئىنگلىزچە',
    vi: 'Tiếng Anh',
    zh_tc: '英文',
    ru: 'английский',
    ko: '영어',
    bur: 'အင်္ဂလိပ်',
    ben: 'ইংরেজি',
    tr: 'İngilizce',
    km: 'ភាសាអង់គ្លេស',
    es: 'Inglés',
    ar: 'إنجليزي',
  },
  'translate.es': {
    zh: '西班牙语',
    en: 'Spanish',
    id: 'Spanyol',
    kz: 'Испан тілі',
    th: 'ภาษาสเปน',
    ug: 'ئىسپانچە',
    vi: 'Tiếng Tây Ban Nha',
    zh_tc: '西班牙語',
    ru: 'Испанский',
    ko: '스페인어',
    bur: 'စပိန်ဘာသာ',
    ben: 'স্প্যানিশ',
    tr: 'İspanyolca',
    km: 'ភាសាអេស្ប៉ាញ',
    es: 'Español',
    ar: 'الإسبانية',
  },
  'translate.ar': {
    zh: '阿拉伯语',
    en: 'Arabic',
    id: 'Arab',
    kz: 'Араб тілі',
    th: 'ภาษาอาหรับ',
    ug: 'ئەرەبچە',
    vi: 'Tiếng Ả Rập',
    zh_tc: '阿拉伯語',
    ru: 'Арабский',
    ko: '아랍어',
    bur: 'အာရဗီဘာသာ',
    ben: 'আরবি',
    tr: 'Arapça',
    km: 'ភាសាអារ៉ាប់',
    es: 'Árabe',
    ar: 'العربية',
  },
  'translate.kz': {
    zh: '哈萨克语',
    en: 'Kazak',
    id: 'Kazakh',
    kz: 'Қазақша',
    th: 'คาซัค',
    ug: 'قازاقچە',
    vi: 'Tiếng Kazakh',
    zh_tc: '哈薩克語',
    ru: 'Казахский язык',
    ko: '카자흐어',
    bur: 'ကာဇက်',
    ben: 'কাজাখ',
    tr: 'Kazakça',
    km: 'ភាសាកាសាក់',
    es: 'Kazajo',
    ar: 'الكازاخستانية',
  },
  'translate.vi': {
    zh: '越南语',
    en: 'Vietnamese',
    id: 'Vietnam',
    kz: 'Вьетнам тілі',
    th: 'เวียดนาม',
    ug: 'ۋيېتنامچە',
    vi: 'Tiếng Việt',
    zh_tc: '越南語',
    ru: 'вьетнамский язык',
    ko: '베트남어',
    bur: 'ဗီယက်နမ်',
    ben: 'ভিয়েতনামি',
    tr: 'Vietnamca',
    km: 'ភាសាវៀតណាម',
    es: 'Vietnamita',
    ar: 'الفيتنامية',
  },
  'translate.th': {
    zh: '泰语',
    en: 'thai',
    id: 'Bahasa Thailand',
    kz: 'Тайский язык',
    th: 'ภาษาไทย',
    ug: 'تايلاندچە',
    vi: 'Tiếng Thái',
    zh_tc: '泰語',
    ru: 'тайский',
    ko: '태국어',
    bur: 'ထိုင်း',
    ben: 'থাই',
    tr: 'Tayca',
    km: 'ភាសាថៃ',
    es: 'Tailandés',
    ar: 'التايلاندية',
  },
  'translate.id': {
    zh: '印尼语',
    en: 'Indonesian',
    id: 'Indonesian',
    kz: 'Индонезийский язык',
    th: 'ภาษาอินโดนีเซีย',
    ug: 'ھىندونېزىيەچە',
    vi: 'Tiếng Indonesia',
    zh_tc: '印尼語',
    ru: 'Индонезийский язык',
    ko: '인도네시아어',
    bur: 'အင်ဒိုနီးရှား',
    ben: 'ইন্দোনেশীয়',
    tr: 'Endonezce',
    km: 'ភាសាឥណ្ឌូនេស៊ី',
    es: 'Indonesio',
    ar: 'الإندونيسية',
  },
  'translate.ug': {
    zh: '维吾尔语',
    en: 'Uyghur',
    id: 'Bahasa Uyghur',
    kz: 'Ұйғыр',
    th: 'ภาษาอุยกูร์',
    ug: 'ئۇيغۇر تىلى',
    vi: 'Tiếng Uyghur',
    zh_tc: '維吾爾語',
    ru: 'Уйгурский язык',
    ko: '위구르어',
    bur: 'ဝီဂါ',
    ben: 'উইঘুর',
    tr: 'Uygurca',
    km: 'ភាសាអ៊ូយ៉ឺរ',
    es: 'Uigur',
    ar: 'الأويغور',
  },
  'translate.customTranslate': {
    zh: '点击可添加自定义翻译',
    en: 'Click to add a custom translation',
    id: 'Klik untuk menambahkan terjemahan khusus',
    kz: 'Реттелетін аударманы қосу үшін басыңыз',
    th: 'คลิกเพื่อเพิ่มการแปลที่กำหนดเอง',
    ug: 'چەكسىڭىز ئۆزى بەلگىلىگەن تەرجىمە قوشالايسىز',
    vi: 'Nhấn để thêm dịch tùy chỉnh',
    zh_tc: '點擊可添加自定義翻譯',
    ru: 'Нажмите, чтобы добавить пользовательский перевод',
    ko: '사용자 정의 번역을 추가하려면 클릭하십시오.',
    bur: 'နှိပ်၍ စိတ်ကြိုက်ဘာသာပြန် ထည့်နိုင်သည်',
    ben: 'ক্লিক করে কাস্টম অনুবাদ যোগ করুন',
    tr: 'Özel çeviri eklemek için tıklayın',
    km: 'ចុចដើម្បីបន្ថែមការបកប្រែតាមតម្រូវការ',
    es: 'Haga clic para agregar una traducción personalizada',
    ar: 'انقر لإضافة ترجمة مخصصة',
  },
  'translate.customText': {
    zh: '自定义翻译',
    en: 'Custom translation',
    id: 'Terjemahan khusus',
    kz: 'Реттелетін аударма',
    th: 'การแปลที่กำหนดเอง',
    ug: 'ئۆزى بەلگىلىگەن تەرجىمە',
    vi: 'Dịch tùy chỉnh',
    zh_tc: '自定義翻譯',
    ru: 'Пользовательский перевод',
    ko: '사용자 정의 번역',
    bur: 'စိတ်ကြိုက်ဘာသာပြန်',
    ben: 'কাস্টম অনুবাদ',
    tr: 'Özel çeviri',
    km: 'ការបកប្រែតាមតម្រូវការ',
    es: 'Traducción personalizada',
    ar: 'ترجمة مخصصة',
  },
  'translate.text': {
    zh: '中文',
    en: 'Chinese',
    id: 'Cina',
    kz: 'Қытай тілі',
    th: 'ชาวจีน',
    ug: 'خەنزۇچە',
    vi: 'Tiếng Trung',
    zh_tc: '中文',
    ru: 'китайский',
    ko: '중국어',
    bur: 'တရုတ်',
    ben: 'চীনা',
    tr: 'Çince',
    km: 'ភាសាចិន',
    es: 'Chino',
    ar: 'الصينية',
  },
  'translate.targetLang': {
    zh: '官方翻译',
    en: 'official translation',
    id: 'Terjemahan resmi',
    kz: 'Ресми аудармасы',
    th: 'การแปลอย่างเป็นทางการ',
    ug: 'رەسمىي تەرجىمە',
    vi: 'Dịch chính thức',
    zh_tc: '官方翻譯',
    ru: 'Официальный перевод',
    ko: '공식 번역',
    bur: 'တရားဝင်ဘာသာပြန်',
    ben: 'অফিসিয়াল অনুবাদ',
    tr: 'Resmi çeviri',
    km: 'ការបកប្រែផ្លូវការ',
    es: 'Traducción oficial',
    ar: 'الترجمة الرسمية',
  },
  'translate.zh_hant': {
    zh: '中文繁体',
    en: 'Traditional Chinese',
    id: 'Cina Tradisional',
    kz: 'Дәстүрлі қытай',
    th: 'จีนแบบดั้งเดิม',
    ug: 'ئەنئەنەۋىي جۇڭگو',
    vi: 'Tiếng Trung truyền thống',
    zh_tc: '中文繁體',
    ru: 'Китайский стиль',
    ko: '중국어 번체',
    bur: 'တရုတ်(ရိုးရာ)',
    ben: 'চীনা (ট্র্যাডিশনাল)',
    tr: 'Geleneksel Çince',
    km: 'ភាសាចិនបុរាណ',
    es: 'Chino tradicional',
    ar: 'الصينية التقليدية',
  },
  'preLayoutSetting.title': {
    zh: '预排版设置',
    en: 'Pre‑Nest Settings',
    id: 'Pengaturan pra-tipe',
    kz: 'Алдын ала орналастыру баптаулары',
    th: 'การตั้งค่าก่อนประเภท',
    ug: 'ئالدىن تەرتىپلەش تەڭشىكى',
    vi: 'Cài đặt bố trí trước',
    zh_tc: '預排版設置',
    ru: 'Параметры предварительного набора',
    ko: '사전 조판 설정',
    bur: 'ကြိုတင်အပြင်အဆင် ဆက်တင်',
    ben: 'প্রি-লেআউট সেটিংস',
    tr: 'Ön yerleşim ayarları',
    km: 'ការកំណត់រៀបចំជាមុន',
    es: 'Ajustes preestablecidos',
    ar: 'الإعدادات المسبقة',
  },
  'preLayoutSetting.titleTip': {
    zh: '可以先预设排版参数，先排版，后选生产线',
    en: 'You can preset layout parameters first, layout first, and then select the production line',
    id: 'Anda dapat mengatur parameter tata letak terlebih dahulu, ketik terlebih dahulu, dan kemudian pilih jalur produksi.',
    kz: 'Алдын ала орналасу параметрлерін алдын ала орнатуға болады, алдымен орналастырып, содан кейін өндіріс желісін таңдаңыз',
    th: 'คุณสามารถตั้งค่าพารามิเตอร์เลย์เอาต์ก่อนพิมพ์ก่อนจากนั้นเลือกสายการผลิต',
    ug: 'ئالدىن تەرتىپلەش پارامېتىرلىرىنى تەڭشەپ، ئاۋۋال تەرتىپلەپ، ئاندىن ئىشلەپچىقىرىش لىنىيەسىنى تاللىيالايسىز',
    vi: 'Có thể thiết lập trước các thông số bố trí, trước tiên bố trí, sau đó chọn dây chuyền sản xuất',
    zh_tc: '可以先預設排版參數，先排版，後選生產線',
    ru: 'Можно предварительно установить параметры типографии, сначала типографии, затем выбрать производственную линию',
    ko: '먼저 조판 파라미터를 미리 설정하고, 먼저 조판하고, 후에 생산 라인을 선택할 수 있다',
    bur: 'အပြင်အဆင် ပါရာမီတာ들을 အရင်ကြိုတင်သတ်မှတ်ပြီး အရင်အပြင်အဆင်လုပ်ကာ နောက်မှ ထုတ်လုပ်မှုလိုင်းကို ရွေးနိုင်သည်',
    ben: 'আগে লেআউট প্যারামিটার প্রিসেট করে লেআউট করুন, তারপর প্রোডাকশন লাইন নির্বাচন করুন',
    tr: 'Önce yerleşim parametrelerini önayarlayabilir, önce yerleşim yapıp ardından üretim hattını seçebilirsiniz',
    km: 'អ្នកអាចកំណត់ប៉ារ៉ាម៉ែត្ររៀបចំជាមុន រៀបចំជាមុន រួចជ្រើសខ្សែផលិតកម្ម',
    es: 'Puede preestablecer los parámetros de composición primero, componer primero y luego seleccionar la línea de producción',
    ar: 'يمكنك ضبط معلمات التنضيد أولاً، والتنضيد أولاً، ثم تحديد خط الإنتاج',
  },
  'preLayoutSetting.settingTip': {
    zh: '在生产线内设置的参数需要和以下预排版参数一致才能输出生产文件，仅对开料机生效',
    en: 'The parameters set within the production line need to be consistent with the following pre-layout parameters to output the production file, applicable only to cutting machines',
    id: 'Parameter yang diatur dalam jalur produksi harus konsisten dengan parameter pra-tipe berikut sebelum mengeluarkan file produksi, dan hanya akan efektif untuk mesin pemotong',
    kz: 'Өндіріс желісінде орнатылған параметрлер төмендегі алдын ала орналастыру параметрлерімен сәйкес келуі керек, сонда ғана өндірістік файлдарды шығару мүмкін болады, тек кесу машинасына қолданылады',
    th: 'พารามิเตอร์ที่ตั้งไว้ในสายการผลิตจะต้องสอดคล้องกับพารามิเตอร์ pre-type ต่อไปนี้ก่อนที่จะส่งออกไฟล์การผลิตและจะมีประสิทธิภาพสำหรับเครื่องตัดเฉพาะ',
    ug: 'ئىشلەپچىقىرىش لىنىيەسىدىكى پارامېتىرلار تۆۋەندىكى ئالدىن تەرتىپلەش پارامېتىرلىرى بىلەن ئوخشاش بولغاندىلا ئىشلەپچىقىرىش ھۆججىتىنى چىقارغىلى بولىدۇ، پەقەت كېسىش ماشىنىسىغا ئۈنۈملۈك',
    vi: 'Các thông số thiết lập trong dây chuyền sản xuất cần phải phù hợp với các thông số bố trí trước dưới đây để có thể xuất tệp sản xuất, chỉ áp dụng cho máy cắt',
    zh_tc:
      '在生產線內設置的參數需要和以下預排版參數一致才能輸出生產文件，僅對開料機生效',
    ru: 'Параметры, установленные в производственной линии, должны соответствовать следующим параметрам предварительной типографии, чтобы вывести производственную документацию, только для открывающей машины',
    ko: '생산 라인 내에 설정된 매개변수는 다음 사전 조판 매개변수와 일치해야 생산 파일을 출력할 수 있으며 원료 공급기에만 적용됩니다.',
    bur: 'ထုတ်လုပ်မှုဖိုင်ကို ထုတ်ရန် ထုတ်လုပ်မှုလိုင်းအတွင်း သတ်မှတ်ထားသော ပါရာမီတာများသည် အောက်ပါ ကြိုတင်အပြင်အဆင် ပါရာမီတာများနှင့် တစ်လျှောက်တည်း ဖြစ်ရမည်၊ ကတ်တင်းစက်တွင်သာ သက်ရောက်သည်',
    ben: 'প্রোডাকশন ফাইল এক্সপোর্ট করতে উৎপাদন লাইনে সেট করা প্যারামিটারগুলো নিচের প্রি-লেআউট প্যারামিটারগুলোর সাথে一致 হতে হবে, শুধুমাত্র কাটিং মেশিনে প্রযোজ্য',
    tr: 'Üretim hattında ayarlanan parametreler, üretim dosyasını çıkarmak için aşağıdaki ön yerleşim parametreleriyle uyumlu olmalıdır; yalnızca kesim makineleri için geçerlidir',
    km: 'ប៉ារ៉ាម៉ែត្រដែលកំណត់ក្នុងខ្សែផលិតកម្មត្រូវស្របនឹងប៉ារ៉ាម៉ែត្ររៀបចំជាមុនខាងក្រោមដើម្បីបញ្ចេញឯកសារផលិតកម្ម មានប្រសិទ្ធិតែសម្រាប់ម៉ាស៊ីនកាត់',
    es: 'Los parámetros configurado en la línea de producción debe ser consistente con los siguientes parámetros de composición previa para generar el archivo de producción, lo cual solo es efectivo para la máquina de corte',
    ar: 'يجب أن تكون المعلمات المحددة في خط الإنتاج متسقة مع معلمات التنضيد المسبق التالية لإخراج ملف الإنتاج، وهو فعال فقط لآلة القطع',
  },
  'preLayoutSetting.emptyKnife': {
    zh: '刀具未填写',
    en: 'Tool not filled',
    id: 'Alat tidak diisi',
    kz: 'Құрал көрсетілмеген',
    th: 'เครื่องมือที่ไม่ได้กรอก',
    ug: 'پىچاق تولدۇرۇلمىغان',
    vi: 'Chưa điền dao cắt',
    zh_tc: '刀具未填寫',
    ru: 'Нож не заполнен.',
    ko: '공구가 채워지지 않았습니다.',
    bur: 'ဓားကိရိယာ မဖြည့်ထားပါ',
    ben: 'টুল পূরণ করা হয়নি',
    tr: 'Takım doldurulmadı',
    km: 'មិនបានបំពេញមុខកាត់',
    es: 'La herramienta no está completa',
    ar: 'لم يتم ملء الأداة',
  },
  'preLayoutSetting.noModify': {
    zh: '设置没有修改，无需保存',
    en: 'No changes in settings, no need to save',
    id: 'Pengaturan tidak dimodifikasi dan tidak perlu menyimpannya',
    kz: 'Параметрлер өзгертілмеген, сақтаудың қажеті жоқ',
    th: 'การตั้งค่าไม่ได้รับการแก้ไขและไม่จำเป็นต้องบันทึกไว้',
    ug: 'تەڭشەك ئۆزگەرتىلمىگەن، ساقلاش ھاجەتسىز',
    vi: 'Thiết lập không có thay đổi, không cần lưu',
    zh_tc: '設置沒有修改，無需保存',
    ru: 'Настройки Не изменяется, не нужно сохранять',
    ko: '설정을 수정하지 않고 저장할 필요 없음',
    bur: 'ဆက်တင်များ မပြောင်းလဲပါ၊ သိမ်းရန်မလိုပါ',
    ben: 'সেটিংসে কোনো পরিবর্তন নেই, সংরক্ষণ প্রয়োজন নেই',
    tr: 'Ayarlarda değişiklik yok, kaydetmeye gerek yok',
    km: 'គ្មានការផ្លាស់ប្តូរក្នុងការកំណត់ មិនចាំបាច់រក្សាទុក',
    es: 'La configuración no ha sido modificada, no es necesario guardar',
    ar: 'لم يتم تعديل الإعداد، لا حاجة لحفظ',
  },
  'preLayoutSetting.reSet': {
    zh: '复原',
    en: 'Reset',
    id: 'pemulihan',
    kz: 'Қалпына келтіру',
    th: 'การกู้คืน',
    ug: 'ئەسلىگە قايتۇرۇش',
    vi: 'Khôi phục',
    zh_tc: '復原',
    ru: 'Восстановление',
    ko: '복원',
    bur: 'ပြန်လည်သတ်မှတ်ရန်',
    ben: 'পুনরুদ্ধার',
    tr: 'Sıfırla',
    km: 'កំណត់ឡើងវិញ',
    es: 'Restaurar',
    ar: 'استعادة',
  },
  'preLayoutSetting.gayPosition': {
    zh: '灰色方块可切换余料摆放位置',
    en: 'Gray squares can switch surplus material placement position',
    id: 'Kotak abu -abu dapat mengganti penempatan bahan residu',
    kz: 'Сұр блок артық материалдың орнын ауыстыру үшін ауыстырылуы мүмкін',
    th: 'สี่เหลี่ยมสีเทาสามารถสลับตำแหน่งของวัสดุตกค้างได้',
    ug: 'كۈلرەڭ كاتەكچە قالدۇق ماتېرىيال قويۇش ئورنىنى ئالماشتۇرالايدۇ',
    vi: 'Khối màu xám có thể chuyển đổi vị trí đặt dư liệu',
    zh_tc: '灰色方塊可切換餘料擺放位置',
    ru: 'Серый квадрат может переключать место размещения',
    ko: '회색 네모난 블록은 여분의 재료 배치 위치를 전환할 수 있다',
    bur: 'မီးခိုးရောင် စတုရန်းကွက်များဖြင့် ကျန်ပစ္စည်း တင်ထားရာနေရာကို ပြောင်းနိုင်သည်',
    ben: 'ধূসর স্কোয়ার দিয়ে উদ্বৃত্ত উপকরণ রাখার অবস্থান বদলানো যায়',
    tr: 'Gri kareler fazla malzeme yerleşim konumunu değiştirebilir',
    km: 'ការ៉េប្រផេះអាចប្តូរទីតាំងដាក់សម្ភារៈលើស',
    es: 'El cuadrado gris puede cambiar la posición de colocación del material restante',
    ar: 'يمكن للمربع الرمادي تبديل موضع وضع المواد المتبقية',
  },
  'preLayoutSetting.surplusPosition': {
    zh: '为当前余料摆放位置',
    en: 'Current surplus material placement position',
    id: 'Penempatan bahan residu saat ini',
    kz: 'Ағымдағы артық материалдың орны',
    th: 'ตำแหน่งปัจจุบันของวัสดุตกค้าง',
    ug: 'نۆۋەتتىكى قالدۇق ماتېرىيال قويۇلۇش ئورنى',
    vi: 'Là vị trí đặt dư liệu hiện tại',
    zh_tc: '為當前餘料擺放位置',
    ru: 'Расположение текущего остатка',
    ko: '현재 남은 재료의 배치 위치',
    bur: 'လက်ရှိ ကျန်ပစ္စည်း တင်ထားရာနေရာ ဖြစ်သည်',
    ben: 'এটি বর্তমান উদ্বৃত্ত উপকরণ রাখার অবস্থান',
    tr: 'Mevcut fazla malzeme yerleşim konumu',
    km: 'ទីតាំងដាក់សម្ភារៈលើសបច្ចុប្បន្ន',
    es: 'es la posición de colocación del material restante actual',
    ar: 'هو موضع وضع المواد المتبقي الحالي',
  },
  'preLayoutSetting.click': {
    zh: '点击',
    en: 'Click',
    id: 'Klik',
    kz: 'Басыңыз',
    th: 'คลิก',
    ug: 'چېكىش',
    vi: 'Nhấn vào',
    zh_tc: '點擊',
    ru: 'нажать',
    ko: '클릭',
    bur: 'နှိပ်ပါ',
    ben: 'ক্লিক করুন',
    tr: 'Tıklayın',
    km: 'ចុច',
    es: 'Haga clic en',
    ar: 'انقر فوق',
  },
  'preLayoutSetting.grayStart': {
    zh: '灰色方块可切换工位起始点',
    en: 'Gray squares can switch the starting point of the workstation',
    id: 'Kotak abu -abu dapat mengganti titik awal stasiun',
    kz: 'Сұр блок жұмыс орнын бастауды ауыстыру үшін ауыстырылуы мүмкін',
    th: 'สี่เหลี่ยมสีเทาสามารถสลับจุดเริ่มต้นของสถานี',
    ug: 'كۈلرەڭ كاتەكچە خىزمەت ئورنى باشلىنىش نۇقتىسىنى ئالماشتۇرالايدۇ',
    vi: 'Khối màu xám có thể chuyển đổi điểm bắt đầu của công đoạn',
    zh_tc: '灰色方塊可切換工位起始點',
    ru: 'Серый квадрат может переключать начальную точку станции',
    ko: '회색 사각형은 가공 위치의 시작점을 전환합니다.',
    bur: 'မီးခိုးရောင် စတုရန်းကွက်များဖြင့် စခန်း၏ စတင်မှတ်ကို ပြောင်းနိုင်သည်',
    ben: 'ধূসর স্কোয়ার দিয়ে ওয়ার্কস্টেশনের শুরু পয়েন্ট বদলানো যায়',
    tr: 'Gri kareler istasyon başlangıç noktasını değiştirebilir',
    km: 'ការ៉េប្រផេះអាចប្តូរចំណុចចាប់ផ្តើមកន្លែងធ្វើការ',
    es: 'El cuadrado gris puede cambiar la posición inicial punto de la estación de trabajo',
    ar: 'يمكن للمربع الرمادي التبديل نقطة البداية لمحطة العمل',
  },
  'preLayoutSetting.currentStart': {
    zh: '为当前工位起始点',
    en: 'Current workstation starting point',
    id: 'Ini adalah titik awal dari stasiun saat ini',
    kz: 'Ағымдағы жұмыс орнының басталуы',
    th: 'มันเป็นจุดเริ่มต้นของสถานีปัจจุบัน',
    ug: 'نۆۋەتتىكى خىزمەت ئورنى باشلىنىش نۇقتىسى',
    vi: 'Là điểm bắt đầu của công đoạn hiện tại',
    zh_tc: '為當前工位起始點',
    ru: 'Начало текущей позиции',
    ko: '현재 작업공간 시작점',
    bur: 'လက်ရှိ စခန်း၏ စတင်မှတ် ဖြစ်သည်',
    ben: 'এটি বর্তমান ওয়ার্কস্টেশনের শুরু পয়েন্ট',
    tr: 'Mevcut istasyon başlangıç noktası',
    km: 'ចំណុចចាប់ផ្តើមកន្លែងធ្វើការបច្ចុប្បន្ន',
    es: 'Para el punto de inicio de la estación actual',
    ar: 'لنقطة انطلاق المحطة الحالية',
  },
  'preLayoutSetting.holeSlotSetting': {
    zh: '打穿孔槽加工设置',
    en: 'Punching slot processing settings',
    id: 'Pengaturan pemrosesan slot pelurus dan lubang',
    kz: 'Тишек сондырау бассейни ишлеу настройкалары',
    th: 'การตั้งค่าการประมวลผลช่องเสียบแบบเส้นตรงและรู',
    ug: 'تۆشۈك-يوچۇقنى ئۆتكۈزۈپ ئىشلەش تەڭشىكى',
    vi: 'Cài đặt xử lý rãnh khoan',
    zh_tc: '拉直器、孔槽加工設置',
    ru: 'Параметры обработки в прорезях',
    ko: '구멍 뚫기 슬롯 가공 설정',
    bur: 'အပေါက်/ချောင်း ထိုးဖောက်လုပ်ငန်း ဆက်တင်များ',
    ben: 'থ্রু হোল/স্লট মেশিনিং সেটিংস',
    tr: 'Delik ve oluk işleme ayarları',
    km: 'ការកំណត់ដំណើរការរន្ធនិងរយៈស្នឹង',
    es: 'Configuración de procesamiento de ranuras de perforación y perforación',
    ar: 'إعدادات معالجة فتحة التثقيب والتثقيب',
  },
  'preLayoutSetting.knifeDiameter': {
    zh: '开料刀直径',
    en: 'Cutting tool diameter',
    id: 'Diameter alat pemotongan',
    kz: 'Кесу құралының диаметрі',
    th: 'เส้นผ่านศูนย์กลางเครื่องมือตัด',
    ug: 'كېسىش پىچىقى دىئامېتىرى',
    vi: 'Đường kính dao cắt',
    zh_tc: '開料刀直徑',
    ru: 'диаметр разреза',
    ko: '커터 지름',
    bur: 'ဖြတ်တောက်ဓား အချင်း',
    ben: 'কাটিং টুলের ব্যাস',
    tr: 'Kesim takımı çapı',
    km: 'អង្កត់ផ្ចិតមុខកាត់',
    es: 'Diámetro de la cuchilla de corte',
    ar: 'قطر سكين القطع',
  },
  'preLayoutSetting.currentVersion': {
    zh: '当前版本',
    en: 'Current version',
    id: 'Versi saat ini',
    kz: 'Ағымдағы нұсқа',
    th: 'เวอร์ชันปัจจุบัน',
    ug: 'نۆۋەتتىكى نەشرى',
    vi: 'Phiên bản hiện tại',
    zh_tc: '當前版本',
    ru: 'Текущая версия',
    ko: '현재 버전',
    bur: 'လက်ရှိဗားရှင်း',
    ben: 'বর্তমান সংস্করণ',
    tr: 'Mevcut sürüm',
    km: 'កំណែបច្ចុប្បន្ន',
    es: 'Versión actual',
    ar: 'الإصدار الحالي',
  },
  'preLayoutSetting.on': {
    zh: '开启',
    en: 'On',
    id: 'Membuka',
    kz: 'Қосу',
    th: 'เปิด',
    ug: 'قوزغىتىش',
    vi: 'Bật',
    zh_tc: '開啟',
    ru: 'открыть',
    ko: '오픈',
    bur: 'ဖွင့်',
    ben: 'চালু',
    tr: 'Açık',
    km: 'បើក',
    es: 'Encendido',
    ar: 'تشغيل',
  },
  'preLayoutSetting.off': {
    zh: '关闭',
    en: 'Off',
    id: 'penutup',
    kz: 'Өшіру',
    th: 'การปิด',
    ug: 'تاقاش',
    vi: 'Tắt',
    zh_tc: '關閉',
    ru: 'закрыть',
    ko: '닫기',
    bur: 'ပိတ်',
    ben: 'বন্ধ',
    tr: 'Kapalı',
    km: 'បិទ',
    es: 'Apagado',
    ar: 'إيقاف',
  },
  'preLayoutSetting.firstShort': {
    zh: '首次切割-短边放量',
    en: 'First Cut - Short Edge Allowance',
    id: 'Volume tepi tiang pangkas pertama',
    kz: 'Алғашқы кесу - қысқа жағын кесу',
    th: 'ปริมาตรขอบสั้นตัดครั้งแรก',
    ug: 'تۇنجى كېسىش-قىسقا تەرەپ قويۇش',
    vi: 'Cắt lần đầu - Dự phòng cạnh ngắn',
    zh_tc: '首次切割-短邊放量',
    ru: 'Первая резка - короткий боковой выброс',
    ko: '첫 번째 컷 - 짧은 모서리 배치',
    bur: 'ပထမဆုံးဖြတ်တောက်ခြင်း-တိုဘက် ထည့်ပမာဏ',
    ben: 'প্রথম কাট-ছোট পাশে অতিরিক্ত মার্জিন',
    tr: 'İlk kesim - kısa kenar payı',
    km: 'ការកាត់ដំបូង - កម្រាលជ្រុងខ្លី',
    es: 'Primer corte - sobrecarga del lado corto',
    ar: 'القطع الأول - التحميل الزائد على الجانب القصير',
  },
  'preLayoutSetting.firstLong': {
    zh: '首次切割-长边放量',
    en: 'First Cut - Long Edge Allowance',
    id: 'Beban samping cut-length pertama',
    kz: 'Алғашқы кесу - ұзын жағын кесу',
    th: 'โหลดด้านข้างที่มีความยาวครั้งแรก',
    ug: 'تۇنجى كېسىش-ئۇزۇن تەرەپ قويۇش',
    vi: 'Cắt lần đầu - Dự phòng cạnh dài',
    zh_tc: '首次切割-長邊放量',
    ru: 'Первоначальная резка - объемный выброс',
    ko: '첫 번째 컷 - 긴 모서리 배치',
    bur: 'ပထမဆုံးဖြတ်တောက်ခြင်း-ရှည်ဘက် ထည့်ပမာဏ',
    ben: 'প্রথম কাট-দীর্ঘ পাশে অতিরিক্ত মার্জিন',
    tr: 'İlk kesim - uzun kenar payı',
    km: 'ការកាត់ដំបូង - កម្រាលជ្រុងវែង',
    es: 'Primer corte - sobrecarga del lado largo',
    ar: 'القطع الأول - التحميل الزائد على الجانب الطويل',
  },
  'preLayoutSetting.cuttingSplitLong': {
    zh: '长板分两次切割-长边超过',
    en: 'Cutting Long Boards in Two Passes - Long Edge Exceeds',
    id: 'Piring panjang dipotong dalam dua kali - sisi panjang melebihi',
    kz: 'Ұзын тақтаны екі рет кесу - ұзын жағының артықтығы',
    th: 'แผ่นยาวจะถูกตัดเป็นสองครั้ง - ด้านยาวเกินกว่า',
    ug: 'ئۇزۇن تاختاينى ئىككى قېتىم كېسىش-ئۇزۇن تەرىپى ئېشىپ كەتسە',
    vi: 'Cắt bảng dài làm hai lần - Cạnh dài vượt quá',
    zh_tc: '長板分兩次切割-長邊超過',
    ru: 'Длинная пластина разрезается дважды - длинная сторона превышает',
    ko: '장판을 두 번에 걸쳐 절단합니다. - 긴 모서리 초과.',
    bur: 'ရှည်ဘုတ်ကို နှစ်ကြိမ်ဖြတ်တောက်ခြင်း-ရှည်ဘက် ကျော်လွန်',
    ben: 'দীর্ঘ বোর্ড দুইবার কাট-দীর্ঘ পাশ অতিক্রম',
    tr: 'Uzun levha iki geçişte kesim - uzun kenar aşımı',
    km: 'កាត់ផ្ទាំងវែងពីរដង - ជ្រុងវែងលើស',
    es: 'La placa larga se corta en dos veces - el lado largo excede',
    ar: 'يتم قطع اللوحة الطويلة مرتين - يتجاوز الجانب الطويل',
  },
  'preLayoutSetting.cuttingSplitShort': {
    zh: '长板分两次切割-短边超过',
    en: 'Cutting Long Boards in Two Passes - Short Edge Exceeds',
    id: 'Piring panjang dipotong dalam dua kali - sisi pendek melebihi',
    kz: 'Ұзын тақтаны екі рет кесу - қысқа жағының артықтығы',
    th: 'แผ่นยาวจะถูกตัดเป็นสองครั้ง - ด้านสั้นเกินกว่า',
    ug: 'ئۇزۇن تاختاينى ئىككى قېتىم كېسىش-قىسقا تەرىپى ئېشىپ كەتسە',
    vi: 'Cắt bảng dài làm hai lần - Cạnh ngắn vượt quá',
    zh_tc: '長板分兩次切割-短邊超過',
    ru: 'Длинная пластина разрезается дважды - короткая сторона превышает',
    ko: '장판을 두 번에 걸쳐 절단 - 짧은 모서리 초과',
    bur: 'ရှည်ဘုတ်ကို နှစ်ကြိမ်ဖြတ်တောက်ခြင်း-တိုဘက် ကျော်လွန်',
    ben: 'দীর্ঘ বোর্ড দুইবার কাট-ছোট পাশ অতিক্রম',
    tr: 'Uzun levha iki geçişte kesim - kısa kenar aşımı',
    km: 'កាត់ផ្ទាំងវែងពីរដង - ជ្រុងខ្លីលើស',
    es: 'La placa larga se corta en dos veces - el lado corto excede',
    ar: 'يتم قطع اللوحة الطويلة مرتين - يتجاوز الجانب القصير',
  },
  'preLayoutSetting.plankThick': {
    zh: '非门板厚度 ≥ ',
    en: 'Non-door board thickness ≥ ',
    id: 'Ketebalan panel non-pintu ≥ ',
    kz: 'Кәдімгі тақтаның қалыңдығы ≥ ',
    th: 'ความหนาของแผ่นปกติ≥',
    ug: 'نورمال تاختاي قېلىنلىقى ≥ ',
    vi: 'Độ dày bảng thông thường ≥ ',
    zh_tc: '非門板厚度 ≥ ',
    ru: 'Толщина не дверной панели ≥ ',
    ko: '일반 보드 두께 ≥',
    bur: 'ပုံမှန်ဘုတ် အထူ ≥ ',
    ben: 'সাধারণ বোর্ডের পুরুত্ব ≥ ',
    tr: 'Normal levha kalınlığı ≥ ',
    km: 'កម្រាស់ផ្ទាំងធម្មតា ≥ ',
    es: 'Espesor de la placa convencional ≥',
    ar: 'سمك اللوحة التقليدية ≥',
  },
  'preLayoutSetting.singleDoorThick': {
    zh: '门板厚度 ≥ ',
    en: 'Door Board Thickness ≥ ',
    id: 'Ketebalan panel pintu ≥ ',
    kz: 'Есік тақтасының қалыңдығы ≥ ',
    th: 'ความหนาของแผ่นประตู≥',
    ug: 'ئىشىك تاختاي قېلىنلىقى ≥ ',
    vi: 'Độ dày bảng cửa ≥ ',
    zh_tc: '門板厚度 ≥ ',
    ru: 'Толщина дверной панели ≥ ',
    ko: '문짝 두께 ≥ ',
    bur: 'တံခါးဘုတ် အထူ ≥ ',
    ben: 'দরজার বোর্ডের পুরুত্ব ≥ ',
    tr: 'Kapı paneli kalınlığı ≥ ',
    km: 'កម្រាស់បន្ទះទ្វារ ≥ ',
    es: 'Espesor de la placa de puerta ≥ ',
    ar: 'سمك لوحة الباب ≥ ',
  },
  'preLayoutSetting.normalPlank': {
    zh: '常规板',
    en: 'Regular Board',
    id: 'Dewan reguler',
    kz: 'Кәдімгі тақта',
    th: 'บอร์ดทั่วไป',
    ug: 'نورمال تاختاي',
    vi: 'Bảng thông thường',
    zh_tc: '常規板',
    ru: 'Обычная доска',
    ko: '일반 보드',
    bur: 'ပုံမှန်ဘုတ်',
    ben: 'সাধারণ বোর্ড',
    tr: 'Normal levha',
    km: 'ផ្ទាំងធម្មតា',
    es: 'Placa convencional',
    ar: 'اللوحة التقليدية',
  },
  'preLayoutSetting.confilictTip': {
    zh: '存在设置冲突项：{confilictTotal}个',
    en: 'There are setting conflicts: {confilictTotal} items',
    id: 'Ada konflik dalam pengaturan: {confilicttotal}',
    kz: 'Қондырғылардың қайшылығы бар: {confilictTotal} элемент',
    th: 'มีความขัดแย้งในการตั้งค่า: {ConvilictTotal}',
    ug: 'تەڭشەك توقۇنۇش تۈرى مەۋجۇت: {confilictTotal} دانە',
    vi: 'Có xung đột cài đặt: {confilictTotal} mục',
    zh_tc: '存在設置衝突項：{confilictTotal}個',
    ru: 'Существуют конфликтные настройки: {confilictTotal} элементов',
    ko: '설정 충돌이 있습니다: {confilictTotal}개',
    bur: 'ဆက်တင် ထိခိုက်မှုများ ရှိသည်: {confilictTotal} ခု',
    ben: 'সেটিংস কনফ্লিক্ট আছে: {confilictTotal}টি',
    tr: 'Ayar çakışması var: {confilictTotal} öğe',
    km: 'មានប៉ារ៉ាម៉ែត្រប៉ះទង្គិច៖ {confilictTotal} ធាតុ',
    es: 'Hay elementos de conflicto de configuración: {confilictTotal}',
    ar: 'هناك عناصر تعارض في الإعداد: {confilictTotal}',
  },
  'preLayoutSetting.selectLine': {
    zh: '选择生产线',
    en: 'Select production line',
    id: 'Pilih Jalur Produksi',
    kz: 'Өндіріс желісін таңдаңыз',
    th: 'เลือกสายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيەسىنى تاللاش',
    vi: 'Chọn dây chuyền sản xuất',
    zh_tc: '選擇生產線',
    ru: 'Выбор производственной линии',
    ko: '생산 라인 선택',
    bur: 'ထုတ်လုပ်မှုလိုင်းကို ရွေးပါ',
    ben: 'প্রোডাকশন লাইন নির্বাচন করুন',
    tr: 'Üretim hattını seçin',
    km: 'ជ្រើសខ្សែផលិតកម្ម',
    es: 'Seleccionar línea de producción',
    ar: 'حدد خط الإنتاج',
  },
  'preLayoutSetting.selectLinePlaceholder': {
    zh: '请选择生产线',
    en: 'Please select a production line',
    id: 'Pilih jalur produksi',
    kz: 'Өндіріс желісін таңдаңыз',
    th: 'โปรดเลือกสายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيەسىنى تاللاڭ',
    vi: 'Vui lòng chọn dây chuyền sản xuất',
    zh_tc: '請選擇生產線',
    ru: 'Пожалуйста, выберите производственную линию.',
    ko: '생산 라인을 선택하십시오.',
    bur: 'ထုတ်လုပ်မှုလိုင်းကို ရွေးချယ်ပါ',
    ben: 'দয়া করে প্রোডাকশন লাইন নির্বাচন করুন',
    tr: 'Lütfen bir üretim hattı seçin',
    km: 'សូមជ្រើសខ្សែផលិតកម្ម',
    es: 'Seleccione la línea de producción',
    ar: 'يرجى تحديد خط الإنتاج',
  },
  'preLayoutSetting.lineConfilictTip': {
    zh: '选择生产线和{line}存在冲突',
    en: 'The selected production line conflicts with {line}',
    id: 'Ada konflik antara memilih jalur produksi dan {line}',
    kz: 'Өндіріс желісін таңдау {line} мен қайшылыққа әкеледі',
    th: 'มีความขัดแย้งระหว่างการเลือกสายการผลิตและ {line}',
    ug: 'تاللانغان ئىشلەپچىقىرىش لىنىيەسى بىلەن {line} توقۇنۇشىدۇ',
    vi: 'Lựa chọn dây chuyền sản xuất có xung đột với {line}',
    zh_tc: '選擇生產線和{line}存在衝突',
    ru: 'Выбранная производственная линия конфликтует с {line}',
    ko: '선택한 생산 라인과 {line}이 충돌합니다',
    bur: 'ရွေးထားသော ထုတ်လုပ်မှုလိုင်းသည် {line} နှင့် ထိခိုက်နေသည်',
    ben: 'নির্বাচিত প্রোডাকশন লাইনটি {line} এর সাথে কনফ্লিক্ট করছে',
    tr: 'Seçilen üretim hattı {line} ile çakışıyor',
    km: 'ខ្សែផលិតកម្មដែលបានជ្រើសប៉ះទង្គិចនឹង {line}',
    es: 'Hay un conflicto entre la línea de producción seleccionada y {line}',
    ar: 'هناك تعارض بين خط الإنتاج المحدد و {line}',
  },
  'preLayoutSetting.preWay': {
    zh: '预排版方案',
    en: 'Pre-layout Scheme',
    id: 'Solusi pra-typesetting',
    kz: 'Алдын ала орналасу жоспары',
    th: 'โซลูชัน pre-typesetting',
    ug: 'ئالدىن تەرتىپلەش پىلانى',
    vi: 'Phương án bố trí trước',
    zh_tc: '預排版方案',
    ru: 'Предварительный вариант',
    ko: '사전 조판 시나리오',
    bur: 'ကြိုတင်အပြင်အဆင် ပုံစံ',
    ben: 'প্রি-লেআউট পরিকল্পনা',
    tr: 'Ön yerleşim şeması',
    km: 'របៀបរៀបចំជាមុន',
    es: 'Plan de diseño previo',
    ar: 'خطة التخطيط المسبق',
  },
  'preLayoutSetting.paibanErrTip': {
    zh: '长板加工的【长、短边放量】有变化时，可能导致排版失败',
    en: 'Changes in the [length and short edge volume] for long board processing may lead to layout failure',
    id: 'Ketika ada perubahan dalam pemrosesan papan panjang [tepi panjang dan pendek meningkatkan volume], itu dapat menyebabkan kegagalan tata letak.',
    kz: 'Ұзын тақтаны өңдеу кезінде [ұзын және қысқа жақтарының кеңеюі] өзгерсе, орналасу сәтсіз болуы мүмкін',
    th: 'เมื่อมีการเปลี่ยนแปลงในการประมวลผลบอร์ดที่ยาว [ขอบยาวและสั้นเพิ่มปริมาณ] มันอาจนำไปสู่ความล้มเหลวของการจัดวาง',
    ug: 'ئۇزۇن تاختاي ئىشلەشتىكى【ئۇزۇن، قىسقا تەرەپ قويۇش】ئۆزگەرگەندە، تەرتىپلەش مەغلۇپ بولۇشى مۇمكىن',
    vi: 'Khi thay đổi lượng dư của cạnh dài và cạnh ngắn của bảng dài, có thể dẫn đến thất bại trong bố trí',
    zh_tc: '長板加工的【長、短邊放量】有變化時，可能導致排版失敗',
    ru: 'При изменении « длинного, короткостороннего объема» обработки длинных пластин это может привести к сбою типографии',
    ko: '장판 가공의 [장, 단변 방량]에 변화가 있을 경우, 조판 실패를 초래할 수 있다',
    bur: 'ရှည်ဘုတ် ပြုပြင်ရာတွင်【ရှည်/တိုဘက် ထည့်ပမာဏ】ပြောင်းလဲပါက အပြင်အဆင် မအောင်မြင်နိုင်သည်',
    ben: 'দীর্ঘ বোর্ড প্রসেসিংয়ের 【দীর্ঘ/ছোট পাশে মার্জিন】 পরিবর্তন হলে লেআউট ব্যর্থ হতে পারে',
    tr: 'Uzun levha işlemede [uzun ve kısa kenar payı] değişiklikleri yerleşim hatasına yol açabilir',
    km: 'ការផ្លាស់ប្តូរ [កម្រាលជ្រុងវែងនិងខ្លី] សម្រាប់ដំណើរការផ្ទាំងវែងអាចបរាជ័យក្នុងការរៀបចំ',
    es: 'Cuando se cambia el 【长、短边放量】 del procesamiento de placas largas, puede causar que el diseño falle',
    ar: 'عندما يتغير 【长、短边放量】 لمعالجة اللوحة الطويلة، قد يتسبب ذلك في فشل التخطيط',
  },
  'preLayoutSetting.paibanTip': {
    zh: '本次排版存在大板材质指定下料刀，需要重新排版',
    en: 'The current layout requires re-layout due to the specified cutting tool for large board material',
    id: 'Tata letak ini memiliki pemotong yang ditunjuk untuk bahan pelat besar, sehingga perlu diketik ulang',
    kz: 'Бұл жолғы орналасуда үлкен тақта материалының кесу пышағы белгіленген, қайта орналасу қажет',
    th: 'เค้าโครงนี้มีเครื่องตัดที่กำหนดสำหรับวัสดุแผ่นขนาดใหญ่ดังนั้นจึงจำเป็นต้องพิมพ์ใหม่',
    ug: 'بۇ قېتىملىق تەرتىپلەشتە چوڭ تاختاي ماتېرىيالى بەلگىلەنگەن كېسىش پىچىقى بار، قايتا تەرتىپلەش كېرەك',
    vi: 'Bố trí lần này có sử dụng dao cắt vật liệu lớn, cần bố trí lại',
    zh_tc: '本次排版存在大板材質指定下料刀，需要重新排版',
    ru: 'В этой типографии есть большой материал, указанный для раскройки ножа, необходимо переформатировать',
    ko: '이번 조판에는 대판 재질 지정 원료 칼이 존재하므로 다시 조판해야 한다',
    bur: 'ယခုအပြင်အဆင်တွင် ဘုတ်ကြီးပစ္စည်းအတွက် ဖြတ်တောက်ဓားကို သတ်မှတ်ထားသဖြင့် ပြန်လည်အပြင်အဆင်လုပ်ရန်လိုသည်',
    ben: 'এই লেআউটে বড় বোর্ডের মেটেরিয়ালের জন্য কাটিং টুল নির্দিষ্ট আছে, পুনরায় লেআউট করতে হবে',
    tr: 'Büyük levha malzemesi için belirtilen kesim takımı nedeniyle yerleşimin yenilenmesi gerekir',
    km: 'ដោយសារមានការកំណត់មុខកាត់សម្រាប់សម្ភារៈផ្ទាំងធំ ត្រូវការរៀបចំឡើងវិញ',
    es: 'Hay una cuchilla de corte designada para el material de placa grande en este diseño, y debe ser re-diseño',
    ar: 'هناك سكين قطع مخصص لمواد اللوحة الكبيرة في هذا التخطيط، ويجب أن يكون إعادة التخطيط',
  },
  'preLayoutSetting.reLayout': {
    zh: '以当前生产线重新排版',
    en: 'Re-layout with the current production line',
    id: 'Diatur ulang dengan jalur produksi saat ini',
    kz: 'Ағымдағы өндіріс желісі бойынша қайта орналасу',
    th: 'จัดขึ้นใหม่ด้วยสายการผลิตปัจจุบัน',
    ug: 'نۆۋەتتىكى ئىشلەپچىقىرىش لىنىيەسى بويىچە قايتا تەرتىپلەش',
    vi: 'Bố trí lại theo dây chuyền sản xuất hiện tại',
    zh_tc: '以當前生產線重新排版',
    ru: 'Переформатировать текущую производственную линию',
    ko: '현재 생산 라인으로 재조판',
    bur: 'လက်ရှိ ထုတ်လုပ်မှုလိုင်းဖြင့် ပြန်လည်အပြင်အဆင်လုပ်ပါ',
    ben: 'বর্তমান প্রোডাকশন লাইন দিয়ে পুনরায় লেআউট করুন',
    tr: 'Mevcut üretim hattıyla yeniden yerleşim',
    km: 'រៀបចំឡើងវិញជាមួយខ្សែផលិតកម្មបច្ចុប្បន្ន',
    es: 'Re-diseño con la línea de producción actual',
    ar: 'إعادة التخطيط باستخدام خط الإنتاج الحالي',
  },
  'preLayoutSetting.fetchErr': {
    zh: '获取预排版设置失败',
    en: 'Failed to fetch pre-layout settings',
    id: 'Gagal mendapatkan pengaturan pra-tipe',
    kz: 'Алдын ала орналастыру параметрлерін алу сәтсіз аяқталды',
    th: 'ไม่ได้รับการตั้งค่าก่อนประเภท',
    ug: 'ئالدىن تەرتىپلەش تەڭشىكىنى ئېلىش مەغلۇپ بولدى',
    vi: 'Lấy cài đặt bố trí trước thất bại',
    zh_tc: '獲取預排版設置失敗',
    ru: 'Ошибка получения предварительных настроек',
    ko: '사전 조판 설정 가져오기 실패',
    bur: 'ကြိုတင်အပြင်အဆင် ဆက်တင်များကို ရယူ၍မရပါ',
    ben: 'প্রি-লেআউট সেটিংস আনতে ব্যর্থ হয়েছে',
    tr: 'Ön yerleşim ayarları alınamadı',
    km: 'មិនអាចទាញយកការកំណត់រៀបចំជាមុនបានទេ',
    es: 'No se pudo obtener la configuración de diseño previo',
    ar: 'فشل الحصول على إعدادات التخطيط المسبق',
  },
  'preLayoutSetting.resetSuccess': {
    zh: '还原成功',
    en: 'Reset successful',
    id: 'Kembalikan dengan sukses',
    kz: 'Қалпына келтіру сәтті аяқталды',
    th: 'ฟื้นฟูได้สำเร็จ',
    ug: 'ئەسلىگە قايتۇرۇش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Khôi phục thành công',
    zh_tc: '還原成功',
    ru: 'Восстановление успешно',
    ko: '복원 성공',
    bur: 'ပြန်လည်သတ်မှတ်မှု အောင်မြင်သည်',
    ben: 'পুনরুদ্ধার সফল',
    tr: 'Sıfırlama başarılı',
    km: 'កំណត់ឡើងវិញជោគជ័យ',
    es: 'Restauración exitosa',
    ar: 'تمت الاستعادة بنجاح',
  },
  'preLayoutSetting.resetConfirm': {
    zh: '确定复原到历史版本？',
    en: 'Are you sure you want to revert to the historical version?',
    id: 'Konfirmasi untuk memulihkan ke versi historis?',
    kz: 'Тарихи нұсқаға қайтару үшін растайсыз ба?',
    th: 'ยืนยันว่าจะคืนค่าเป็นเวอร์ชันประวัติศาสตร์หรือไม่?',
    ug: 'تارىخىي نەشرىگە ئەسلىگە قايتۇرۇشنى جەزملەمسىز؟',
    vi: 'Bạn có chắc chắn muốn khôi phục về phiên bản lịch sử không?',
    zh_tc: '確定復原到歷史版本？',
    ru: 'Вернуться к исторической версии?',
    ko: '역사 버전으로 복원하시겠습니까?',
    bur: 'သမိုင်းဗားရှင်းသို့ ပြန်လည်ပြောင်းမည်မှာ သေချာပါသလား？',
    ben: 'আপনি কি নিশ্চিতভাবে ইতিহাসের সংস্করণে ফিরিয়ে নিতে চান?',
    tr: 'Geçmiş sürüme dönmek istediğinizden emin misiniz?',
    km: 'តើអ្នកប្រាកដជាចង់ត្រឡប់ទៅកំណែប្រវត្តិវិញ?',
    es: '¿Está seguro de que desea restaurar a la versión histórica?',
    ar: 'هل أنت متأكد من رغبتك في الاستعادة إلى الإصدار التاريخي؟',
  },
  'preLayoutSetting.prolineName': {
    zh: '生产线名称',
    en: 'Production Line Name',
    id: 'Nama Jalur Produksi',
    kz: 'Өндіріс желісінің атауы',
    th: 'ชื่อสายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيەسى نامى',
    vi: 'Tên dây chuyền sản xuất',
    zh_tc: '生產線名稱',
    ru: 'Название производственной линии',
    ko: '라인 이름',
    bur: 'ထုတ်လုပ်မှုလိုင်း အမည်',
    ben: 'প্রোডাকশন লাইনের নাম',
    tr: 'Üretim hattı adı',
    km: 'ឈ្មោះខ្សែផលិតកម្ម',
    es: 'Nombre de la línea de producción',
    ar: 'اسم خط الإنتاج',
  },
  'preLayoutSetting.layoutGap': {
    zh: '排版间隙',
    en: 'Layout Gap',
    id: 'Kesenjangan pengaturan huruf',
    kz: 'Орналастыру аралығы',
    th: 'ช่องว่างการเรียงพิมพ์',
    ug: 'تەرتىپلەش ئارىلىقى',
    vi: 'Khoảng cách bố trí',
    zh_tc: '排版間隙',
    ru: 'Разрыв между наборами',
    ko: '조판 간격',
    bur: 'အပြင်အဆင် အကွာအဝေး',
    ben: 'লেআউট গ্যাপ',
    tr: 'Yerleşim boşluğu',
    km: 'គម្លាតរៀបចំ',
    es: 'Espacio de composición tipográfica',
    ar: 'فجوة التنضيد',
  },
  'preLayoutSetting.generalThickness': {
    zh: '二次切割对象-常规板厚度',
    en: 'Secondary Cutting Object - Regular Board Thickness',
    id: 'Ketebalan pelat objek pemotongan sekunder',
    kz: 'Екінші кесу нысаны - Әдеттегі тақтаның қалыңдығы',
    th: 'ความหนาของแผ่นความหนาของแผ่นรอง',
    ug: 'ئىككىنچى قېتىم كېسىش نىشانى-نورمال تاختاي قېلىنلىقى',
    vi: 'Độ dày bảng thông thường - Đối tượng cắt lần hai',
    zh_tc: '二次切割對象-常規板厚度',
    ru: 'Объект вторичной резки - обычная толщина пластины',
    ko: '2차 가공 객체 - 일반 보드 두께',
    bur: 'ဒုတိယဖြတ်တောက် 대상-ပုံမှန်ဘုတ် အထူ',
    ben: 'দ্বিতীয় কাটিং অবজেক্ট-সাধারণ বোর্ডের পুরুত্ব',
    tr: 'İkincil kesim nesnesi - normal levha kalınlığı',
    km: 'វត្ថុកាត់ដើម្បីទីពីរ - កម្រាស់ផ្ទាំងធម្មតា',
    es: 'Objeto de corte secundario - espesor de placa normal',
    ar: 'أداة القطع الثانوية - سمك اللوحة العادية',
  },
  'preLayoutSetting.cutGeneralPlank': {
    zh: '二次切割对象-常规板',
    en: 'Secondary Cutting Object - Regular Board',
    id: 'Papan Pengaturan Objek Pemotongan Sekunder',
    kz: 'Екінші кесу нысаны - Әдеттегі тақта',
    th: 'บอร์ดการตัดทุติยภูมิ',
    ug: 'ئىككىنچى قېتىم كېسىش نىشانى-نورمال تاختاي',
    vi: 'Cắt bảng thông thường - Đối tượng cắt lần hai',
    zh_tc: '二次切割對象-常規板',
    ru: 'Объект вторичной резки - обычная доска',
    ko: '2차 가공 객체 - 일반 보드',
    bur: 'ဒုတိယဖြတ်တောက် 대상-ပုံမှန်ဘုတ်',
    ben: 'দ্বিতীয় কাটিং অবজেক্ট-সাধারণ বোর্ড',
    tr: 'İkincil kesim nesnesi - normal levha',
    km: 'វត្ថុកាត់ដើម្បីទីពីរ - ផ្ទាំងធម្មតា',
    es: 'Objeto de corte secundario - placa normal',
    ar: 'أداة القطع الثانوية - اللوحة العادية',
  },
  'preLayoutSetting.cutSingleDoor': {
    zh: '二次切割对象-门板',
    en: 'Secondary Cutting Object - Door Panel',
    id: 'Panel pintu objek pemotongan sekunder',
    kz: 'Екінші кесу нысаны - Есіктің панелі',
    th: 'แผงการตัดสองประตู',
    ug: 'ئىككىنچى قېتىم كېسىش نىشانى-ئىشىك تاختىسى',
    vi: 'Cắt cửa đơn - Đối tượng cắt lần hai',
    zh_tc: '二次切割對象-門板',
    ru: 'Объект вторичной резки - дверная панель',
    ko: '2차 컷 객체 - 도어 패널',
    bur: 'ဒုတိယဖြတ်တောက် 대상-တံခါးပြား',
    ben: 'দ্বিতীয় কাটিং অবজেক্ট-ডোর প্যানেল',
    tr: 'İkincil kesim nesnesi - kapı paneli',
    km: 'វត្ថុកាត់ដើម្បីទីពីរ - បន្ទះទ្វារ',
    es: 'Objeto de corte secundario - panel de puerta',
    ar: 'أداة القطع الثانوية - لوحة الباب',
  },
  'preLayoutSetting.secondary_cutting_board_list': {
    zh: '指定板名切割板件名列表',
    en: 'List of specified board names and cutting board names',
    id: 'Tentukan nama papan Daftar nama potongan papan',
    kz: 'Тақта атауын кесу тақтасының бөлігінің атау тізімін көрсетіңіз',
    th: 'ระบุชื่อบอร์ด ตัดชื่อบอร์ด',
    ug: 'تاختاي نامىنى كېسىش تاختىسىنىڭ قىسمەن ئىسىم تىزىملىكىنى بەلگىلەڭ',
    vi: 'Chỉ định tên bảng Danh sách các tên bảng cắt',
    zh_tc: '指定板件名切割板件名清單',
    ru: 'Укажите имя панели',
    ko: '보드 이름 가공판 부품 이름 목록 지정',
    bur: 'သတ်မှတ်ထားသော ဘုတ်အမည်များနှင့် ဖြတ်တောက်မည့် ဘုတ်အပိုင်းအမည်များ စာရင်း',
    ben: 'নির্দিষ্ট বোর্ড নাম ও কাটিং বোর্ড পিসের নামের তালিকা',
    tr: 'Belirtilen levha adları ve kesim levha adları listesi',
    km: 'បញ្ជីឈ្មោះផ្ទាំងដែលកំណត់និងឈ្មោះផ្ទាំងកាត់',
    es: 'Especifique el nombre de la placa para cortar la lista de nombres del panel',
    ar: 'تحديد اسم اللوحة لقطع قائمة أسماء اللوحة',
  },
  'preLayoutSetting.changeProline': {
    zh: '切换生产线',
    en: 'Switch Production Line',
    id: 'Beralih Jalur Produksi',
    kz: 'Өндіріс желісін ауыстыру',
    th: 'สวิตช์สายการผลิต',
    ug: 'ئىشلەپچىقىرىش لىنىيەسىنى ئالماشتۇرۇش',
    vi: 'Chuyển đổi dây chuyền sản xuất',
    zh_tc: '切換生產線',
    ru: 'Переключить производственную линию',
    ko: '생산 라인 전환',
    bur: 'ထုတ်လုပ်မှုလိုင်းကို ပြောင်းပါ',
    ben: 'প্রোডাকশন লাইন পরিবর্তন করুন',
    tr: 'Üretim hattını değiştir',
    km: 'ប្តូរខ្សែផលិតកម្ម',
    es: 'Cambiar línea de producción',
    ar: 'تبديل خط الإنتاج',
  },
  'preLayoutSetting.backTip': {
    zh: '请返回全局排版选择生产线',
    en: 'Please return to global layout to select a production line',
    id: 'Harap kembali ke jalur produksi seleksi tata letak global',
    kz: 'Өндіріс желісін таңдау үшін глобалды орналастыруға оралыңыз',
    th: 'โปรดกลับไปที่สายการผลิตการเลือกเค้าโครงทั่วโลก',
    ug: 'ئومۇمىي تەرتىپلەشكە قايتىپ ئىشلەپچىقىرىش لىنىيەسىنى تاللاڭ',
    vi: 'Vui lòng quay lại bố trí tổng thể để chọn dây chuyền sản xuất',
    zh_tc: '請返回全局排版選擇生產線',
    ru: 'Пожалуйста, вернитесь к глобальному форматированию и выберите производственную линию',
    ko: '글로벌 조판으로 돌아가 생산라인을 선택하십시오.',
    bur: 'ထုတ်လုပ်မှုလိုင်းရွေးရန် အလုံးစုံအပြင်အဆင်သို့ ပြန်သွားပါ',
    ben: 'প্রোডাকশন লাইন নির্বাচন করতে গ্লোবাল লেআউটে ফিরে যান',
    tr: 'Üretim hattı seçmek için genel yerleşime dönün',
    km: 'សូមត្រឡប់ទៅការរៀបចំទូទៅដើម្បីជ្រើសខ្សែផលិតកម្ម',
    es: 'Regrese a la composición tipográfica global para seleccionar la línea de producción',
    ar: 'يرجى العودة إلى التنضيد العالمي لتحديد خط الإنتاج',
  },
  'preLayoutSetting.preLayout': {
    zh: '按预排版方案排版',
    en: 'Nest‑by Pre‑scheme',
    id: 'Ketik sesuai dengan skema tata letak pra-tipe',
    kz: 'Алдын ала орналастыру схемасына сәйкес орналастыру',
    th: 'พิมพ์ตามรูปแบบเค้าโครงก่อนประเภท',
    ug: 'ئالدىن تەرتىپلەش پىلانى بويىچە تەرتىپلەش',
    vi: 'Bố trí theo kế hoạch bố trí trước',
    zh_tc: '按預排版方案排版',
    ru: 'Разбивка по предварительной схеме',
    ko: '사전 조판 체계에 따라 조판하다.',
    bur: 'ကြိုတင်အပြင်အဆင် ပုံစံအတိုင်း အပြင်အဆင်လုပ်ပါ',
    ben: 'প্রি-লেআউট পরিকল্পনা অনুযায়ী লেআউট করুন',
    tr: 'Ön yerleşim şemasına göre yerleşim',
    km: 'រៀបចំតាមរបៀបរៀបចំជាមុន',
    es: 'Composición tipográfica según el esquema de composición tipográfica previa',
    ar: 'التنضيد وفقًا لنظام التنضيد المسبق',
  },
  'preLayoutSetting.preWayEmpty': {
    zh: '(空)预排版方案',
    en: '(Empty)Pre-layout Scheme',
    id: '(Kosong) Skema Pra-Jenis',
    kz: '(Бос)Алдын ала орналастыру схемасы',
    th: '(ว่าง) โครงการประเภทก่อน',
    ug: '(قۇرۇق)ئالدىن تەرتىپلەش پىلانى',
    vi: '(Trống)Kế hoạch bố trí trước',
    zh_tc: '(空)預排版方案',
    ru: '(Пустой) Предварительный вариант',
    ko: '(비어 있음) 사전 조판 체계',
    bur: '(ဗလာ)ကြိုတင်အပြင်အဆင် ပုံစံ',
    ben: '(খালি) প্রি-লেআউট পরিকল্পনা',
    tr: '(Boş) Ön yerleşim şeması',
    km: '(ទទេ) របៀបរៀបចំជាមុន',
    es: 'Esquema de precomposición (vacío)',
    ar: 'مخطط التنضيد المسبق (فارغ)',
  },
  'preLayoutSetting.specialConfilictTip': {
    zh: '圆弧铣底工艺影响了排版结果，需要重新排版',
    en: 'The selected production line affects the arc milling bottom process parameters, re-layout is required',
    id: 'Proses penggilingan bawah busur mempengaruhi hasil tata letak dan perlu diketik ulang',
    kz: 'Таңдалған өндіріс желісі доға фрезерлеу процесінің параметрлеріне әсер етеді, қайта орналасу қажет',
    th: 'กระบวนการกัดส่วนโค้งด้านล่างมีผลต่อผลการจัดวางและจำเป็นต้องพิมพ์ใหม่อีกครั้ง',
    ug: 'يېرىم چەمبەر تېگى ئويۇش تېخنىكىسى تەرتىپلەش نەتىجىسىگە تەسىر قىلدى، قايتا تەرتىپلەش كېرەك',
    vi: 'Dây chuyền sản xuất đã chọn ảnh hưởng đến các thông số quy trình phay đáy cung, cần bố trí lại',
    zh_tc: '圓弧銑底工藝影響了排版結果，需要重新排版',
    ru: 'Процесс дугового фрезерного основания повлиял на результаты типографии и требует переформатирования',
    ko: '호 밀링 베이스 프로세스는 레이아웃 결과에 영향을 미치므로 다시 레이아웃해야 합니다.',
    bur: 'ဝိုင်းကွေး ဖရီးဇ်အောက် လုပ်ငန်းစဉ်သည် အပြင်အဆင်ရလဒ်ကို သက်ရောက်သဖြင့် ပြန်လည်အပြင်အဆင်လုပ်ရန်လိုသည်',
    ben: 'আর্ক মিলিং বটম প্রক্রিয়া লেআউট ফলাফলে প্রভাব ফেলেছে, পুনরায় লেআউট করতে হবে',
    tr: 'Yay taban frezeleme süreci yerleşim sonucunu etkiledi; yeniden yerleşim gerekir',
    km: 'ដំណើរការកាត់បាតរង្វង់ប៉ះពាល់លទ្ធផលរៀបចំ ត្រូវការរៀបចំឡើងវិញ',
    es: 'El proceso de fresado en arco afecta los resultados de la composición tipográfica y es necesario volver a componerlo',
    ar: 'تؤثر عملية الطحن القوسي على نتائج التنضيد وتحتاج إلى إعادة التنضيد',
  },
  'lunbo.tips': {
    zh: '操作小技巧',
    en: 'Operating Skills',
    id: 'Tip Operasi',
    kz: 'Қолдану шетіктері',
    th: 'เคล็ดลับการดำเนินงาน',
    ug: 'مەشغۇلات كىچىك ئامال',
    vi: 'Kỹ năng thao tác',
    zh_tc: '操作小技巧',
    ru: 'Маленькие навыки работы',
    ko: '조작 팁',
    bur: 'အသုံးပြုရန် အကြံဉာဏ်များ',
    ben: 'অপারেটিং টিপস',
    tr: 'İşletme ipuçları',
    km: 'គន្លឹះប្រតិបត្តិការ',
    es: 'Consejos de operación',
    ar: 'نصائح التشغيل',
  },
  'lunbo.introduction': {
    zh: '功能介绍',
    en: 'Function Introduction',
    id: 'Pendahuluan Fungsional',
    kz: 'Функциялық сипаттама',
    th: 'การแนะนำการทำงาน',
    ug: 'ئىقتىدار تونۇشتۇرۇش',
    vi: 'Giới thiệu chức năng',
    zh_tc: '功能介紹',
    ru: 'функции',
    ko: '기능 소개',
    bur: 'လုပ်ဆောင်ချက် မိတ်ဆက်',
    ben: 'ফিচার পরিচিতি',
    tr: 'İşlev tanıtımı',
    km: 'សេចក្តីណែនាំមុខងារ',
    es: 'Introducción a la función',
    ar: 'مقدمة الوظيفة',
  },
  'lunbo.qtDownloadText': {
    zh: '温馨提示：如果出现下载文件不全的情况，请前往云排版网页端进行下载！',
    en: 'Warm reminder: If the downloaded file is incomplete, please go to the cloud typesetting webpage to download it!',
    id: 'Warm Reminder: Jika ada file unduhan yang tidak lengkap, silakan buka halaman web Cloud Layout untuk diunduh!',
    kz: 'Ескерту: Егер файл толық жүктелмесе, онда бұл файлды бұлтты пішімдеу веб-сайтынан жүктеуге болады!',
    th: 'การแจ้งเตือนที่อบอุ่น: หากมีไฟล์ดาวน์โหลดที่ไม่สมบูรณ์โปรดไปที่หน้าเว็บคลาวด์เลย์เอาต์เพื่อดาวน์โหลด!',
    ug: 'ئەسكەرتىش: ھۆججەت تولۇق چۈشمىگەن ئەھۋال كۆرۈلسە، بۇلۇتلۇق تەرتىپلەش تور بېتىگە بېرىپ چۈشۈرۈڭ!',
    vi: 'Lời nhắc ấm áp: Nếu xảy ra trường hợp tải xuống tập tin không đầy đủ, vui lòng truy cập vào trang web trình biên soạn đám mây để tải xuống!',
    zh_tc: '溫馨提示：如果出現下載文件不全的情況，請前往雲排版網頁端進行下載！',
    ru: 'Теплый совет: если есть неполная загрузка файла, пожалуйста, перейдите на облачную страницу для загрузки!',
    ko: '따뜻한 힌트: 만약 다운로드 파일이 완전하지 않은 상황이 발생하면, 클라우드 조판 웹 페이지로 가서 다운로드하세요!',
    bur: 'နွေးထွေးသော သတိပေးချက်: ဒေါင်းလုဒ်ဖိုင် မပြည့်စုံပါက Cloud Layout ဝဘ်ဆိုဒ်သို့ သွားပြီး ဒေါင်းလုဒ်လုပ်ပါ!',
    ben: 'সৌজন্যমূলক স্মরণ: ডাউনলোড করা ফাইল অসম্পূর্ণ হলে ক্লাউড লেআউট ওয়েবপেজে গিয়ে ডাউনলোড করুন!',
    tr: 'Hatırlatma: İndirilen dosya eksikse lütfen bulut dizilimi web sayfasından indirin!',
    km: 'សូមរំលឹក៖ ប្រសិនបើឯកសារទាញយកមិនគ្រប់គ្រាន់ សូមទៅកាន់គេហទំព័ររៀបចំក្នុងពពកដើម្បីទាញយក!',
    es: 'Recordatorio: si el archivo descargado está incompleto, vaya a la página web de composición tipográfica en la nube para descargarlo.',
    ar: 'تذكير دافئ: إذا كان الملف الذي تم تنزيله غير مكتمل، فيرجى الانتقال إلى صفحة ويب التنضيد السحابي للتنزيل!',
  },
  'sendModal.paibanImgType': {
    zh: '排版图文件类型',
    en: 'Types of layout file formats',
    id: 'Jenis file tata letak grafis',
    kz: 'Теру диаграммасының файл түрі',
    th: 'ประเภทไฟล์แผนภูมิการพิมพ์',
    ug: 'دىئاگرامما ھۆججەت تىپى',
    vi: 'Loại tệp bản vẽ bố cục',
    zh_tc: '排版圖檔案類型',
    ru: 'Тип файла',
    ko: '조판도 파일 유형',
    bur: 'အပြင်အဆင်ပုံ ဖိုင်အမျိုးအစား',
    ben: 'লেআউট ইমেজ ফাইলের ধরন',
    tr: 'Yerleşim dosya biçim türleri',
    km: 'ប្រភេទទ្រង់ទ្រាយឯកសាររៀបចំ',
    es: 'Tipo de archivo de diseño',
    ar: 'نوع ملف التخطيط',
  },
  'authenticationModal.title': {
    zh: '扫码授权验证',
    en: 'Scan QR Code for verification',
    id: 'Pemindaian QR Code untuk verifikasi',
    kz: 'QR Code темінліш қылыш',
    th: 'การตรวจสอบการสแกน QR Code',
    ug: 'QR Code تەمىنلىش قىلىش',
    vi: 'Quét mã QR để xác thực',
    zh_tc: '掃碼授權驗證',
    ru: 'Проверка авторизации сканирования',
    ko: '스캔 인증',
    bur: 'QR ကုဒ်စကင်ဖတ်၍ ခွင့်ပြုချက် အတည်ပြုခြင်း',
    ben: 'স্ক্যান করে অনুমোদন যাচাই',
    tr: 'Doğrulama için QR kodunu tarayın',
    km: 'ស្កេនកូដ QR ដើម្បីផ្ទៀងផ្ទាត់',
    es: 'Escanee el código para verificar la autorización',
    ar: 'مسح الرمز للتحقق من التفويض',
  },
  'authenticationModal.tip': {
    zh: '授权成功前请勿关闭弹框！',
    en: 'Please do not close the dialog before verification is successful!',
    id: 'Harap jangan menutup kotak dialog sebelum verifikasi berhasil!',
    kz: 'Темінліш қылыш аяқталғанша қаптамасыз қалыңыз!',
    th: 'กรุณาอย่าปิดหน้าต่างก่อนที่จะตรวจสอบสำเร็จ!',
    ug: 'تەمىنلىش قىلىش ئاخىرلىنىشىغا قايتۇرۇلمايدۇ!',
    vi: 'Vui lòng không đóng hộp thoại trước khi xác thực thành công!',
    zh_tc: '授權成功前請勿關閉彈框！',
    ru: 'Не закрывайте рамку, пока не будет выполнена лицензия!',
    ko: '허가가 성공하기 전에 탄창을 닫지 마십시오!',
    bur: 'ခွင့်ပြုချက်အောင်မြင်မီ ဒိုင်ယာလော့ကို မပိတ်ပါနှင့်！',
    ben: 'অনুমোদন সফল হওয়ার আগে ডায়ালগটি বন্ধ করবেন না!',
    tr: 'Doğrulama başarılı olmadan iletişim kutusunu kapatmayın!',
    km: 'សូមកុំបិទប្រអប់មុនពេលផ្ទៀងផ្ទាត់ជោគជ័យ!',
    es: '¡No cierre el cuadro emergente antes de que la autorización sea exitosa!',
    ar: 'لا تغلق المربع المنبثق قبل نجاح التفويض!',
  },
  'authenticationModal.countdownTip': {
    zh: '{countdown} 后过期',
    en: '{countdown} after expiration',
    id: '{countdown} setelah kedaluwarsa',
    kz: '{countdown} аяқталғаннан кейін',
    th: '{countdown} หลังจากหมดอายุ',
    ug: '{countdown} ئاخىرلىنىشىغا قايتۇرۇلمايدۇ',
    vi: '{countdown} sau khi hết hạn',
    zh_tc: '{countdown} 後過期',
    ru: '{countdown} после истечения срока действия',
    ko: '{countdown} 후 만료',
    bur: '{countdown} အပြီး သက်တမ်းကုန်မည်',
    ben: '{countdown} পরে মেয়াদ শেষ হবে',
    tr: '{countdown} sonra süresi dolacak',
    km: 'ផុតកំណត់បន្ទាប់ពី {countdown}',
    es: 'Caduca después de {countdown}',
    ar: 'تنتهي صلاحيته بعد {countdown}',
  },
  'authenticationModal.refreshTip': {
    zh: '刷新二维码',
    en: 'Refresh QR Code',
    id: 'Segarkan QR Code',
    kz: 'QR Code темінліш қылыш',
    th: 'รีเฟรช QR Code',
    ug: 'QR Code تەمىنلىش قىلىش',
    vi: 'Làm mới mã QR',
    zh_tc: '刷新二維碼',
    ru: 'Обновить QR - код',
    ko: 'QR코드 새로 고침',
    bur: 'QR ကုဒ်ကို အသစ်ပြန်တင်ပါ',
    ben: 'QR কোড রিফ্রেশ করুন',
    tr: 'QR kodunu yenile',
    km: 'ធ្វើឱ្យកូដ QR ឡើងវិញ',
    es: 'Actualizar el código QR',
    ar: 'تحديث رمز الاستجابة السريعة',
  },
  'authenticationModal.qrcodeTip': {
    zh: '请用微信扫码完成操作',
    en: 'Please scan the QR Code with WeChat to complete the operation',
    id: 'Silakan pemindaian QR Code dengan WeChat untuk menyelesaikan operasi',
    kz: 'Өндіріс жұмысын аяқтау үшін QR Code темінліш қылыш',
    th: 'กรุณาสแกน QR Code ด้วย WeChat เพื่อทำงาน',
    ug: 'ئىشلەشتىكى ئىقتىدارنى قىلىش ئارقىلىق QR Code تەمىنلىش قىلىڭ',
    vi: 'Vui lòng quét mã QR bằng WeChat để hoàn thành thao tác',
    zh_tc: '請用微信掃碼完成操作',
    ru: 'Выполните операцию с помощью микрокода.',
    ko: '위챗으로 코드를 스캔하여 조작을 완성하십시오.',
    bur: 'WeChat ဖြင့် QR ကုဒ်ကို စကင်ဖတ်ပြီး လုပ်ဆောင်ချက်ကို ပြီးစီးပါ',
    ben: 'অপারেশন সম্পন্ন করতে WeChat দিয়ে QR কোড স্ক্যান করুন',
    tr: 'İşlemi tamamlamak için QR kodunu WeChat ile tarayın',
    km: 'សូមស្កេនកូដ QR ជាមួយ WeChat ដើម្បីបញ្ចប់ប្រតិបត្តិការ',
    es: 'Utilice WeChat para escanear el código QR y completar la operación',
    ar: 'يرجى استخدام WeChat لمسح رمز الاستجابة السريعة ضوئيًا لإكمال العملية',
  },
  'authenticationModal.qrcodeTip2': {
    zh: '如果扫码保存失败则需要在柜柜通用设置-用户授权设置中授权您修改系统的权限。',
    en: 'If the QR Code scanning fails, please allow access to the system in the general settings of the cabinet - user access settings.',
    id: 'Jika pemindaian QR Code gagal, silakan izinkan akses ke sistem dalam pengaturan umum kabinet - pengaturan izin akses pengguna.',
    kz: 'QR Code темінліш қылыш мүмкін емес болса, қаптамасыз қалыңыз',
    th: 'หากการสแกน QR Code ไม่สำเร็จโปรดอนุญาตให้เข้าถึงระบบในการตั้งค่าทั่วไปของห้อง - การตั้งค่าการอนุญาตการเข้าถึงผู้ใช้งาน.',
    ug: 'QR Code تەمىنلىش قىلىش مەغلۇپ بولسا، ئالدىن تەرتىپلەش تەڭشىكىدە قايتۇرۇلغان قىلىمىغان قىلىش ئارقىلىق QR Code تەمىنلىش قىلىڭ.',
    vi: 'Nếu quét mã QR không thành công, vui lòng cấp quyền truy cập để sửa đổi hệ thống trong cài đặt chung của kệ - Cài đặt quyền truy cập người dùng.',
    zh_tc:
      '如果掃碼保存失敗則需要在櫃櫃通用設置-用戶授權設置中授權您修改系統的權限。',
    ru: 'Если сканирование не удается сохранить, вам нужно будет разрешить изменить права системы в общих настройках шкафа - настройках пользовательской авторизации.',
    ko: '스캔 저장에 실패하면 캐비닛 일반 설정 - 사용자 인증 설정에서 시스템을 수정할 수 있는 권한을 부여해야 합니다.',
    bur: 'စကင်ဖတ်ပြီး သိမ်းဆည်းမှု မအောင်မြင်ပါက “Guigui အထွေထွေ ဆက်တင်များ - အသုံးပြုသူ ခွင့်ပြုချက် ဆက်တင်များ” တွင် စနစ်ပြင်ဆင်ခွင့်ကို သင့်အား ခွင့်ပြုပေးရပါမည်။',
    ben: 'স্ক্যান করে সংরক্ষণ ব্যর্থ হলে “Guigui সাধারণ সেটিংস - ব্যবহারকারী অনুমোদন সেটিংস”-এ আপনাকে সিস্টেম পরিবর্তনের অনুমতি দিতে হবে।',
    tr: 'Tarama kaydı başarısız olursa Guigui genel ayarlar - kullanıcı yetkilendirme ayarlarından sistem düzenleme iznini verin.',
    km: 'ប្រសិនបើស្កេនរក្សាទុកមិនបានជោគជ័យ សូមផ្តល់សិទ្ធិកែប្រែប្រព័ន្ធក្នុងការកំណត់ទូទៅ Guigui - ការកំណត់អនុញ្ញាតអ្នកប្រើ។',
    es: 'Si el código QR escaneado no se guarda, debe estar autorizado para modificar los permisos del sistema en la configuración general del gabinete - configuración de autorización de usuario.',
    ar: 'إذا فشل حفظ رمز الاستجابة السريعة المسح الضوئي، فستحتاج إلى الحصول على تصريح لتعديل أذونات النظام في الإعدادات العامة للخزانة - إعدادات ترخيص المستخدم.',
  },
  'authenticationModal.waiting': {
    zh: '等待扫码',
    en: 'Waiting for QR Code scanning',
    id: 'Menunggu pemindaian QR Code',
    kz: 'QR Code темінліш қылыш тартасыз',
    th: 'กำลังรอการสแกน QR Code',
    ug: 'QR Code تەمىنلىش قىلىش تارتىشى',
    vi: 'Đang chờ quét mã QR',
    zh_tc: '等待掃碼',
    ru: 'Код ожидания',
    ko: '스캔 대기 중',
    bur: 'စကင်ဖတ်ရန် စောင့်နေသည်',
    ben: 'স্ক্যানের জন্য অপেক্ষা করছে',
    tr: 'Tarama bekleniyor',
    km: 'កំពុងរង់ចាំការស្កេន',
    es: 'Esperando escaneo',
    ar: 'في انتظار المسح',
  },
  'authenticationModal.scanning': {
    zh: '已扫码，等待确认',
    en: 'Scanning QR Code, waiting for verification',
    id: 'Sedang memindaian QR Code, menunggu verifikasi',
    kz: 'QR Code темінліш қылыш тартасыз, темінліш қылыш тартасыз',
    th: 'กำลังสแกน QR Code, กำลังรอการตรวจสอบ',
    ug: 'QR Code تەمىنلىش قىلىنغان، ئىقتىدارنى قىلىش تارتىشى',
    vi: 'Đã quét mã QR, đang chờ xác thực',
    zh_tc: '已掃碼，等待確認',
    ru: 'Подсчитывается код, ожидая подтверждения',
    ko: '코드 스캔, 확인 대기 중',
    bur: 'စကင်ပြီးပြီး၊ အတည်ပြုရန် စောင့်နေသည်',
    ben: 'স্ক্যান হয়েছে, নিশ্চিতকরণের অপেক্ষা করছে',
    tr: 'Kod tarandı, doğrulama bekleniyor',
    km: 'បានស្កេនរួច កំពុងរង់ចាំការផ្ទៀងផ្ទាត់',
    es: 'Código escaneado, esperando confirmación',
    ar: 'الرمز الممسوح ضوئيًا، في انتظار التأكيد',
  },
  'authenticationModal.success': {
    zh: '验证成功',
    en: 'Verification successful',
    id: 'Verifikasi berhasil',
    kz: 'Темінліш қылыш мүмкін емес болса, темінліш қылыш тартасыз',
    th: 'การตรวจสอบสำเร็จ',
    ug: 'تەمىنلىش قىلىش مۇۋەپپەقىيەتلىك بولدى',
    vi: 'Xác thực thành công',
    zh_tc: '驗證成功',
    ru: 'Проверка прошла успешно',
    ko: '인증 성공',
    bur: 'အတည်ပြုမှု အောင်မြင်သည်',
    ben: 'যাচাই সফল হয়েছে',
    tr: 'Doğrulama başarılı',
    km: 'ផ្ទៀងផ្ទាត់ជោគជ័យ',
    es: 'Verificación exitosa',
    ar: 'نجح التحقق',
  },
  'authenticationModal.error': {
    zh: '验证失败',
    en: 'Verification failed',
    id: 'Verifikasi gagal',
    kz: 'Темінліш қылыш мүмкін емес болса, темінліш қылыш тартасыз',
    th: 'การตรวจสอบไม่สำเร็จ',
    ug: 'تەمىنلىش قىلىش مەغلۇپ بولدى',
    vi: 'Xác thực thất bại',
    zh_tc: '驗證失敗',
    ru: 'Не удалось проверить',
    ko: '검증 실패',
    bur: 'အတည်ပြုမှု မအောင်မြင်ပါ',
    ben: 'যাচাই ব্যর্থ হয়েছে',
    tr: 'Doğrulama başarısız',
    km: 'ផ្ទៀងផ្ទាត់បរាជ័យ',
    es: 'Verificación fallida',
    ar: 'فشل التحقق',
  },
  'authenticationModal.expired': {
    zh: '二维码已过期',
    en: 'QR Code has expired',
    id: 'QR Code telah kedaluwarsa',
    kz: 'QR Code темінліш қылыш аяқталғаннан кейін',
    th: 'QR Code หมดอายุ',
    ug: 'QR Code تەمىنلىش قىلىش ئاخىرلىنىشىغا قايتۇرۇلمايدۇ',
    vi: 'Mã QR đã hết hạn',
    zh_tc: '二維碼已過期',
    ru: 'Срок действия QR - кода истек.',
    ko: 'QR코드가 만료되었습니다.',
    bur: 'QR ကုဒ် သက်တမ်းကုန်ပြီးပြီ',
    ben: 'QR কোডের মেয়াদ শেষ হয়ে গেছে',
    tr: 'QR kodunun süresi doldu',
    km: 'កូដ QR ផុតកំណត់ហើយ',
    es: 'El código QR ha caducado',
    ar: 'انتهت صلاحية رمز الاستجابة السريعة',
  },
  'authenticationModal.tip2': {
    zh: '为了您的账号数据安全，需验证当前操作人员信息',
    en: 'For the security of your account data, please verify the current operator information',
    id: 'Demi keamanan data akun Anda, harap verifikasi informasi operator yang sedang melakukan tindakan',
    kz: 'Тіркелгі деректеріңіздің қауіпсіздігі үшін қазіргі операцияны орындайтын қызметкердің ақпаратын растаңыз',
    th: 'เพื่อความปลอดภัยของข้อมูลบัญชีของคุณ กรุณายืนยันข้อมูลผู้ปฏิบัติงานปัจจุบัน',
    ug: 'ھېسابىڭىز سانلىق مەلۇمات بىخەتەرلىكى ئۈچۈن، نۆۋەتتە مەشغۇلات ئېلىپ بېرىۋاتقان ئادەمنىڭ ئۇچۇرىنى دەلىللەپ تاسقلاڭ',
    vi: 'Để đảm bảo an toàn dữ liệu tài khoản của bạn, vui lòng xác minh thông tin người đang thao tác',
    zh_tc: '為了您的帳號數據安全，需驗證當前操作人員信息',
    ru: 'Для безопасности данных вашей учетной записи необходимо проверить текущую информацию оператора.',
    ko: '귀하의 계정 데이터의 안전을 위해 현재 운영자 정보를 검증해야 합니다',
    bur: 'သင့်အကောင့်ဒေတာ လုံခြုံရေးအတွက် လက်ရှိ လုပ်ဆောင်သူ အချက်အလက်ကို အတည်ပြုရန် လိုအပ်သည်',
    ben: 'আপনার অ্যাকাউন্ট ডেটার নিরাপত্তার জন্য বর্তমান অপারেটরের তথ্য যাচাই করা প্রয়োজন',
    tr: 'Hesap verilerinizin güvenliği için lütfen mevcut operatör bilgilerini doğrulayın',
    km: 'ដើម្បីសុវត្ថិភាពទិន្នន័យគណនី សូមផ្ទៀងផ្ទាត់ព័ត៌មានអ្នកប្រតិបត្តិបច្ចុប្បន្ន',
    es: 'Para la seguridad de los datos de su cuenta, la información del operador actual debe ser verificada',
    ar: 'لأمان بيانات حسابك، يجب التحقق من معلومات المشغل الحالية',
  },
  'authenticationModal.tip3': {
    zh: '试生产的柜子须为{fontStyleStart}不对称的柜体，以避免出现柜体镜像{fontStyleEnd}的问题',
    en: 'The cabinet for trial production must be, {fontStyleStart}asymmetric, to avoid the problem of cabinet mirroring{fontStyleEnd}',
    id: 'Kabinet untuk produksi uji harus, {fontStyleStart}tidak simetris, untuk menghindari masalah pencerminan kabinet{fontStyleEnd}',
    kz: 'Өндіріс тестілеу үшін қаптамасыз қалыңыз, {fontStyleStart}қаптамасыз қалыңыз, қаптамасыз қалыңыз{fontStyleEnd}',
    th: 'ห้องสำหรับการผลิตทดสอบต้องเป็น, {fontStyleStart}ไม่สมมาตร, เพื่อหลีกเลี่ยงปัญหาการสะท้อนหน้าต่าง{fontStyleEnd}',
    ug: 'سىناق ئىشلەپچىقىرىشتىكى ئىشكاپ {fontStyleStart}ئاسىممېترىك ئىشكاپ گەۋدىسى{fontStyleEnd} بولۇشى كېرەك، ئىشكاپ گەۋدىسىنىڭ ئاينە تەسۋىرى كۆرۈنۈپ قېلىش مەسىلىسىدىن ساقلىنىش ئۈچۈن',
    vi: 'Kệ cho sản xuất thử phải là, {fontStyleStart}không đối xứng, để tránh vấn đề về ảnh phản chiếu phẳng{fontStyleEnd}',
    zh_tc:
      '試生產的櫃子須為，{fontStyleStart}不對稱的櫃體，以避免出現櫃體鏡像{fontStyleEnd}的問題',
    ru: 'Для производства образцов шкаф должен быть, {fontStyleStart}несимметричным, чтобы избежать проблем с отражением{fontStyleEnd}',
    ko: '시험 생산을 위한 캐비닛은, {fontStyleStart}비대칭적이어야 하며, 캐비닛 반사 문제를 피하기 위해{fontStyleEnd}',
    bur: 'စမ်းသပ် ထုတ်လုပ်ရေးဗီရိုသည် ဖြစ်ရမည်၊ {fontStyleStart}မမျှတသော ဗီရိုခန္ဓာကိုယ်၊ ဗီရို ကြေးပြန်ချိန်မှု ရှောင်ရှားရန်{fontStyleEnd} ပြဿနာ',
    ben: 'পরীক্ষামূলক উৎপাদনের ক্যাবিনেটটি হতে হবে, {fontStyleStart}অসমমিত ক্যাবিনেট বডি, ক্যাবিনেট মিররিং এড়াতে{fontStyleEnd} সমস্যা',
    es: 'Los gabinetes de producción de prueba deben ser {fontStyleStart} gabinetes asimétricos para evitar problemas de duplicación de gabinetes {fontStyleEnd}',
    ar: 'يجب أن تكون خزانات الإنتاج التجريبي {fontStyleStart} خزانات غير متماثلة لتجنب انعكاس الخزانة {fontStyleEnd} مشاكل',
  },
  'printTag.dualLanguageTip': {
    zh: '您暂无中英双语标签生成权限，当前仅可预览；如需正式使用，请联系销售开通~',
    en: 'You do not have permission to generate Chinese-English bilingual labels. Preview only for now—contact sales to enable full access~',
    id: 'Anda belum memiliki izin untuk membuat label dwibahasa Tionghoa-Inggris; saat ini hanya dapat pratinjau. Hubungi tim penjualan untuk mengaktifkan penggunaan penuh~',
    kz: 'Сізде қытай-ағылшын қос тілді жапсырмаларды жасауға рұқсат жоқ, қазір тек алдын ала көру қолжетімді; толық пайдалану үшін сату бөліміне хабарласыңыз~',
    th: 'คุณยังไม่มีสิทธิ์สร้างป้ายกำกับสองภาษาจีน-อังกฤษ ขณะนี้ดูตัวอย่างได้เท่านั้น หากต้องการใช้งานจริง โปรดติดต่อฝ่ายขายเพื่อเปิดใช้งาน~',
    ug: 'سىزدە خىتايچە-ئىنگلىزچە قوش تىللىق بەلگىلەرنى ھاسىل قىلىش ھوقۇقى يوق، ھازىر پەقەت ئالدىن كۆرۈشقىلا بولىدۇ؛ رەسمىي ئىشلىتىش ئۈچۈن سېتىش خادىملىرى بىلەن ئالاقىلىشىپ ئېچىڭ~',
    vi: 'Bạn chưa có quyền tạo nhãn song ngữ Trung–Anh, hiện chỉ xem trước; cần dùng chính thức vui lòng liên hệ kinh doanh để được kích hoạt~',
    zh_tc:
      '您暫無中英雙語標籤生成權限，當前僅可預覽；如需正式使用，請聯繫銷售開通~',
    ru: 'У вас нет прав на создание двуязычных китайско-английских этикеток; сейчас доступен только предпросмотр. Для полноценного использования обратитесь в отдел продаж~',
    ko: '중영 이중 언어 라벨 생성 권한이 없습니다. 현재는 미리보기만 가능합니다. 정식 사용이 필요하면 영업팀에 문의해 주세요~',
    bur: 'တရုတ်-အင်္ဂလိပ် နှစ်ဘာသာ လေဘယ်လ် ဖန်တီးခွင့်မရှိပါ၊ လက်ရှိတွင် ကြည့်ရှုမှုသာ ရနိုင်သည်။ တရားဝင် အသုံးပြုလိုပါက အရောင်းဌာနကို ဆက်သွယ်ပါ~',
    ben: 'আপনার চীনা-ইংরেজি দ্বিভাষিক লেবেল তৈরির অনুমতি নেই, বর্তমানে শুধু প্রিভিউ সম্ভব; স্থায়ী ব্যবহারের জন্য সেলসের সঙ্গে যোগাযোগ করে চালু করুন~',
    es: 'No tiene permiso para generar Etiquetas bilingües en chino e inglés. Actualmente, sólo puedes obtener una vista previa de ellos. Si desea utilizarlos oficialmente, comuníquese con ventas para activarlos ~',
    ar: 'ليس لديك إذن بالإنشاء تسميات ثنائية اللغة باللغتين الصينية والإنجليزية. حاليًا، يمكنك فقط معاينتها. إذا كنت تريد استخدامها رسميًا، فيرجى الاتصال بالمبيعات لتنشيطها ~',
  },
  'printTag.generateDualLanguageTagTip': {
    zh: '生成中英双语标签',
    en: 'Generate Chinese-English bilingual labels',
    id: 'Buat label dwibahasa Tionghoa-Inggris',
    kz: 'Қытай-ағылшын қос тілді жапсырмаларды жасау',
    th: 'สร้างป้ายกำกับสองภาษา จีน-อังกฤษ',
    ug: 'خىتايچە-ئىنگلىزچە قوش تىللىق بەلگىلەرنى ھاسىل قىلىش',
    vi: 'Tạo nhãn song ngữ Trung-Anh',
    zh_tc: '生成中英雙語標籤',
    ru: 'Создать китайско-английские двуязычные ярлыки',
    ko: '중영 이중 언어 라벨 생성',
    bur: 'တရုတ်-အင်္ဂလိပ် နှစ်ဘာသာ လေဘယ်လ်များ ဖန်တီးရန်',
    ben: 'চীনা-ইংরেজি দ্বিভাষিক লেবেল তৈরি করুন',
    es: 'Generar etiquetas bilingües en chino e inglés',
    ar: 'إنشاء ملصقات ثنائية اللغة باللغتين الصينية والإنجليزية',
  },
  'printTag.dualLanguageTip2': {
    zh: '该功能为付费功能，请联系销售开通后使用~',
    en: 'This feature is paid. Please contact sales to enable it before use~',
    id: 'Fitur ini berbayar. Silakan hubungi tim sales untuk mengaktifkannya sebelum digunakan~',
    kz: 'Бұл ақылы функция. Пайдаланбас бұрын қосу үшін сату бөліміне хабарласыңыз~',
    th: 'ฟีเจอร์นี้เป็นฟีเจอร์แบบชำระเงิน โปรดติดต่อฝ่ายขายเพื่อเปิดใช้งานก่อนใช้งาน~',
    ug: 'بۇ ئىقتىدار ھەقلىق. ئىشلىتىشتىن بۇرۇن سېتىش خادىملىرى بىلەن ئالاقىلىشىپ ئېچىڭ~',
    vi: 'Đây là tính năng trả phí, vui lòng liên hệ bộ phận kinh doanh để mở trước khi sử dụng~',
    zh_tc: '該功能為付費功能，請聯繫銷售開通後使用~',
    ru: 'Эта функция платная. Перед использованием обратитесь в отдел продаж для активации~',
    ko: '해당 기능은 유료 기능입니다. 사용 전 영업팀에 문의해 개통해 주세요~',
    bur: 'ဤလုပ်ဆောင်ချက်သည် အခပေးဖြစ်သည်။ အသုံးမပြုမီ ဖွင့်လှစ်ရန် အရောင်းဌာနကို ဆက်သွယ်ပါ~',
    ben: 'এই ফিচারটি পেইড। ব্যবহারের আগে চালু করতে সেলস টিমের সঙ্গে যোগাযোগ করুন~',
    es: 'Esta función es una función paga. Comuníquese con ventas para activarlo ~',
    ar: 'هذه الوظيفة مدفوعة الأجر. يرجى الاتصال بالمبيعات لتنشيطه ~',
  },
  'printTag.effectiveDataSource': {
    zh: '生效数据源',
    en: 'Effective Data Source',
    id: 'Sumber Data yang Efektif',
    kz: 'Эффективные данные источника',
    th: 'ข้อมูลที่มีผลกระทบ',
    ug: 'Эффективные данные источника',
    vi: 'Nguồn dữ liệu hiệu quả',
    zh_tc: '生效數據源',
    ru: 'Эффективные источники данных',
    ko: '효과적인 데이터 소스',
    bur: 'အကျိုးပြုသည့် ဒေတာအခြေခံ',
    ben: 'প্রভাবশালী ডেটা উত্স',
    es: 'Fuente de datos efectiva',
    ar: 'مصدر البيانات الفعال',
  },
  'cuttingDock.cuttingParams.cuttingMethod': {
    zh: '裁切方式',
    en: 'Cutting method',
    id: 'Metode pemotongan',
    kz: 'Кесу әдісі',
    th: 'วิธีการตัด',
    ug: 'قېپىش ئۇسۇلى',
    vi: 'Phương thức cắt',
    zh_tc: '裁切方式',
    ru: 'Способ резки',
    ko: '절단 방식',
    bur: 'ဖြတ်နည်း',
    ben: 'কাটিং পদ্ধতি',
    tr: 'Kesim yöntemi',
    km: 'វិធីកាត់',
    es: 'Método de corte',
    ar: 'طريقة القطع',
  },
  'cuttingDock.cuttingParams.horizontalCutting': {
    zh: '横向裁切',
    en: 'Horizontal cutting',
    id: 'Pemotongan horizontal',
    kz: 'Көлденең кесу',
    th: 'การตัดแนวนอน',
    ug: 'توغرا يۆنىلىشتە قېپىش',
    vi: 'Cắt ngang',
    zh_tc: '橫向裁切',
    ru: 'Горизонтальная резка',
    ko: '가로 절단',
    bur: 'အလျားလိုက်ဖြတ်',
    ben: 'অনুভূমিক কাটিং',
    tr: 'Yatay kesim',
    km: 'កាត់ផ្តេក',
    es: 'Corte horizontal',
    ar: 'القطع الأفقي',
  },
  'cuttingDock.cuttingParams.verticalCutting': {
    zh: '竖向裁切',
    en: 'Vertical cutting',
    id: 'Pemotongan vertikal',
    kz: 'Тік кесу',
    th: 'การตัดแนวตั้ง',
    ug: 'بويىغا قېپىش',
    vi: 'Cắt dọc',
    zh_tc: '豎向裁切',
    ru: 'Вертикальная резка',
    ko: '세로 절단',
    bur: 'ဒေါင့်လိုက်ဖြတ်',
    ben: 'উল্লম্ব কাটিং',
    tr: 'Dikey kesim',
    km: 'កាត់បញ្ឈរ',
    es: 'Corte vertical',
    ar: 'القطع العمودي',
  },
  'printTag.partName': {
    zh: '板件名',
    en: 'Panel Name',
    id: 'Nama papan',
    kz: 'Тақта атауы',
    th: 'ชื่อแผ่น',
    ug: 'تاختاي ئىسمى',
    vi: 'Tên tấm',
    zh_tc: '板件名',
    ru: 'Название плиты',
    ko: '판재명',
    bur: 'ဘုတ်အမည်',
    ben: 'বোর্ডের নাম',
    tr: 'Levha adı',
    km: 'ឈ្មោះផ្ទាំង',
    es: 'Nombre del panel',
    ar: 'اسم اللوحة',
  },
  'userAccessToken.createTime': {
    zh: '创建时间',
    en: 'Creation time',
    id: 'Waktu pembuatan',
    kz: 'Жасалу уақыты',
    th: 'เวลาที่สร้าง',
    ug: 'قۇرۇلغان ۋاقىت',
    vi: 'Thời gian tạo',
    zh_tc: '創建時間',
    ru: 'Время создания',
    ko: '생성 시간',
    bur: 'ဖန်တီးသည့်အချိန်',
    ben: 'তৈরির সময়',
    tr: 'Oluşturulma zamanı',
    km: 'ពេលវេលាបង្កើត',
    es: 'Hora de creación',
    ar: 'وقت الإنشاء',
  },
  'userAccessToken.lastUsedTime': {
    zh: '最近使用时间',
    en: 'Last used time',
    id: 'Waktu terakhir digunakan',
    kz: 'Соңғы пайдалану уақыты',
    th: 'เวลาที่ใช้ล่าสุด',
    ug: 'ئاخىرقى ئىشلىتىش ۋاقىتى',
    vi: 'Lần sử dụng cuối',
    zh_tc: '最近使用時間',
    ru: 'Время последнего использования',
    ko: '마지막 사용 시간',
    bur: 'နောက်ဆုံးအသုံးပြုချိန်',
    ben: 'সর্বশেষ ব্যবহারের সময়',
    tr: 'Son kullanım zamanı',
    km: 'ពេលវេលាប្រើប្រាស់ចុងក្រោយ',
    es: 'Hora de último uso',
    ar: 'وقت آخر استخدام',
  },
  'userAccessToken.expireTime': {
    zh: '过期时间',
    en: 'Expiration time',
    id: 'Waktu kedaluwarsa',
    kz: 'Мерзімі өту уақыты',
    th: 'เวลาหมดอายุ',
    ug: 'مۇددىتى ئۆتۈش ۋاقىتى',
    vi: 'Thời gian hết hạn',
    zh_tc: '過期時間',
    ru: 'Время истечения',
    ko: '만료 시간',
    bur: 'သက်တမ်းကုန်ဆုံးချိန်',
    ben: 'মেয়াদ শেষের সময়',
    tr: 'Son kullanma zamanı',
    km: 'ពេលវេលាផុតកំណត់',
    es: 'Hora de caducidad',
    ar: 'وقت انتهاء الصلاحية',
  },
  'userAccessToken.status': {
    zh: '状态',
    en: 'Status',
    id: 'Status',
    kz: 'Күй',
    th: 'สถานะ',
    ug: 'ھالەت',
    vi: 'Trạng thái',
    zh_tc: '狀態',
    ru: 'Статус',
    ko: '상태',
    bur: 'အခြေအနေ',
    ben: 'স্ট্যাটাস',
    tr: 'Durum',
    km: 'ស្ថានភាព',
    es: 'Estado',
    ar: 'الحالة',
  },
  'userAccessToken.tokenNamePlaceholder': {
    zh: '请输入令牌名称',
    en: 'Please enter token name',
    id: 'Harap masukkan nama token',
    kz: 'Токен атын енгізіңіз',
    th: 'โปรดป้อนชื่อโทเค็น',
    ug: 'توقەن ئاتىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập tên mã thông báo',
    zh_tc: '請輸入令牌名稱',
    ru: 'Введите имя токена',
    ko: '토큰 이름을 입력하세요',
    bur: 'တိုကင်အမည်ထည့်ပါ',
    ben: 'টোকেনের নাম লিখুন',
    tr: 'Lütfen jeton adını girin',
    km: 'សូមបញ្ចូលឈ្មោះថូខឹន',
    es: 'Introduzca el nombre del token',
    ar: 'أدخل اسم الرمز المميز',
  },
  'userAccessToken.expireTimeSelectPlaceholder': {
    zh: '请选择过期时间',
    en: 'Please select expiration time',
    id: 'Harap pilih waktu kedaluwarsa',
    kz: 'Мерзімі өту уақытын таңдаңыз',
    th: 'โปรดเลือกเวลาหมดอายุ',
    ug: 'مۇددىتى ئۆتۈش ۋاقتىنى تاللاڭ',
    vi: 'Vui lòng chọn thời gian hết hạn',
    zh_tc: '請選擇過期時間',
    ru: 'Пожалуйста, выберите время истечения',
    ko: '만료 시간을 선택하세요',
    bur: 'သက်တမ်းကုန်ဆုံးချိန်ကို ရွေးချယ်ပါ',
    ben: 'মেয়াদ শেষের সময় নির্বাচন করুন',
    tr: 'Lütfen son kullanma zamanını seçin',
    km: 'សូមជ្រើសរើសពេលវេលាផុតកំណត់',
    es: 'Seleccione la hora de caducidad',
    ar: 'حدد وقت انتهاء الصلاحية',
  },
  'userAccessToken.securityBannerTip': {
    zh: '不要与他人共享您的个人访问令牌，也不要在浏览器或其他客户端代码中暴露它，以保护您的账户安全，若在公开场合发现任何泄露的个人访问令牌，该令牌可能会被自动禁用',
    en: 'Do not share your personal access token with others or expose it in browser or other client code. To protect your account, leaked tokens found in public may be disabled automatically.',
    id: 'Jangan bagikan token akses pribadi Anda kepada orang lain atau mengeksposnya di browser atau kode klien lain. Untuk keamanan akun, token yang bocor di tempat umum dapat dinonaktifkan secara otomatis.',
    kz: 'Жеке кіру токеніңізді басқалармен бөліспеңіз немесе браузерде немесе басқа клиент кодында ашып көрсетпеңіз. Аккаунтыңызды қорғау үшін, жария орында ашылған токендер автоматты түрде өшірілуі мүмкін.',
    th: 'อย่าแชร์โทเค็นการเข้าถึงส่วนตัวของคุณกับผู้อื่นหรือเปิดเผยในเบราว์เซอร์หรือโค้ดไคลเอนต์อื่น เพื่อความปลอดภัยของบัญชี หากพบโทเค็นรั่วไหลในที่สาธารณะ โทเค็นนั้นอาจถูกปิดการใช้งานโดยอัตโนมัติ',
    ug: 'شەخسىي زىيارەت ئىجازىتىنى باشقىلار بىلەن ھەمبەھىر قىلماڭ ياكى توركۆرگۈچ ياكى باشقا كىلىيەنت كودىدا ئاشكارىلىماڭ. ھېساباتىڭىزنى قوغداش ئۈچۈن، ئومۇمىي جايدا ئاشكارىلانغان ئىجازەت ئاپتوماتىك چەكلىنىشى مۇمكىن.',
    vi: 'Không chia sẻ mã truy cập cá nhân của bạn với người khác hoặc để lộ trong trình duyệt hoặc mã khách hàng khác. Để bảo vệ tài khoản, mã bị lộ trên nơi công khai có thể bị vô hiệu hóa tự động.',
    zh_tc:
      '請勿與他人共享您的個人存取權杖，也不要在瀏覽器或其他用戶端程式碼中暴露它，以保護您的帳戶安全；若在公開場合發現任何外洩的個人存取權杖，該權杖可能會被自動停用。',
    ru: 'Не передавайте личный токен доступа другим и не раскрывайте его в браузере или другом клиентском коде. Для защиты учётной записи утекшие токены, обнаруженные публично, могут быть автоматически отключены.',
    ko: '개인 액세스 토큰을 다른 사람과 공유하거나 브라우저나 다른 클라이언트 코드에 노출하지 마세요. 계정 보호를 위해 공개적으로 유출된 토큰은 자동으로 비활성화될 수 있습니다.',
    bur: 'သင့် ကိုယ်ပိုင်ဝင်ရောက်မှတ်တမ်းကို အခြားသူများနှင့် မျှဝေမထားပါနှင့် သို့မဟုတ် ဘရောက်ဖာတွင် သို့မဟုတ် အခြားကလိုင်ကုဒ်တွင် အထွက်မပေးပါနှင့်။ အကောင့်လုံခြုံရေးအတွက် လူသိရှင်ကြား ပေါက်ကြားသော မှတ်တမ်းများကို တွေ့ရှိပါက အလိုအလျောက် ပိတ်သွားနိုင်သည်။',
    ben: 'আপনার ব্যক্তিগত অ্যাক্সেস টোকেন অন্যদের সাথে শেয়ার করবেন না বা ব্রাউজার বা অন্যান্য ক্লায়েন্ট কোডে প্রকাশ করবেন না। আপনার অ্যাকাউন্ট সুরক্ষার জন্য, প্রকাশ্যে ফাঁস হওয়া টোকেন স্বয়ংক্রিয়ভাবে নিষ্ক্রিয় করা হতে পারে।',
    tr: 'Kişisel erişim jetonunuzu başkalarıyla paylaşmayın veya tarayıcıda veya diğer istemci kodunda açığa çıkarmayın. Hesabınızı korumak için herkese açık yerde sızdırılan jetonlar otomatik olarak devre dışı bırakılabilir.',
    km: 'កុំចែករំលែកថូខឹនចូលប្រើផ្ទាល់ខ្លួនរបស់អ្នកជាមួយអ្នកដទៃ ឬបង្ហាញនៅក្នុងកម្មវិធីរុករក ឬកូដអតិថិជនផ្សេងទៀត។ ដើម្បីការពារគណនី ថូខឹនដែលរលយដោយចៃដន្យអាចត្រូវបានបិទដោយស្វ័យប្រវត្តិ។',
    es: 'No comparta su token de acceso personal con otras personas ni lo exponga en el navegador u otro código de cliente. Para proteger su cuenta, cualquier token filtrado públicamente puede deshabilitarse automáticamente.',
    ar: 'لا تشارك رمز الوصول الشخصي الخاص بك مع الآخرين ولا تكشفه في المتصفح أو أي كود عميل آخر. لحماية حسابك، قد يتم تعطيل أي رمز مسرب علنًا تلقائيًا.',
  },
  'userAccessToken.expired': {
    zh: '已过期',
    en: 'Expired',
    id: 'Kedaluwarsa',
    kz: 'Мерзімі өткен',
    th: 'หมดอายุแล้ว',
    ug: 'مۇددىتى ئۆتكەن',
    vi: 'Đã hết hạn',
    zh_tc: '已過期',
    ru: 'Истёк',
    ko: '만료됨',
    bur: 'သက်တမ်းကုန်ပြီ',
    ben: 'মেয়াদ শেষ',
    tr: 'Süresi doldu',
    km: 'ផុតកំណត់',
    es: 'Caducado',
    ar: 'منتهي الصلاحية',
  },
  'userAccessToken.valid': {
    zh: '有效',
    en: 'Valid',
    id: 'Berlaku',
    kz: 'Жарамды',
    th: 'ใช้งานได้',
    ug: 'ئىناۋەتلىك',
    vi: 'Hiệu lực',
    zh_tc: '有效',
    ru: 'Действителен',
    ko: '유효',
    bur: 'အာမခံ',
    ben: 'বৈধ',
    tr: 'Geçerli',
    km: 'មានសុពលភាព',
    es: 'Válido',
    ar: 'صالح',
  },
  'userAccessToken.remove': {
    zh: '移除',
    en: 'Remove',
    id: 'Hapus',
    kz: 'Жою',
    th: 'ลบ',
    ug: 'چىقىرىۋېتىش',
    vi: 'Gỡ bỏ',
    zh_tc: '移除',
    ru: 'Удалить',
    ko: '제거',
    bur: 'ဖယ်ရှားပါ',
    ben: 'সরান',
    tr: 'Kaldır',
    km: 'យកចេញ',
    es: 'Eliminar',
    ar: 'إزالة',
  },
  'userAccessToken.previewOnceWarning': {
    zh: '此令牌仅显示一次，请将此密钥保存在安全且可获取的地方。不要与他人共享，也不要在浏览器或其他客户端代码中暴露它。',
    en: 'This token is shown only once. Save this secret in a safe, accessible place. Do not share it with others or expose it in browser or other client code.',
    id: 'Token ini hanya ditampilkan sekali. Simpan rahasia ini di tempat yang aman dan dapat diakses. Jangan bagikan kepada orang lain atau mengeksposnya di browser atau kode klien lain.',
    kz: 'Бұл токен тек бір рет көрсетіледі. Құпияны қауіпсіз, қолжетімді жерде сақтаңыз. Басқалармен бөліспеңіз немесе браузерде немесе басқа клиент кодында ашып көрсетпеңіз.',
    th: 'โทเค็นนี้แสดงเพียงครั้งเดียว เก็บรหัสลับในที่ปลอดภัยและเข้าถึงได้ อย่าแชร์กับผู้อื่นหรือเปิดเผยในเบราว์เซอร์หรือโค้ดไคลเอนต์อื่น',
    ug: 'بۇ ئىجازەت پەقەت بىر قېتىم كۆرسىتىلىدۇ. بۇ مەخپىيەتنى بىخەتەر ۋە ئېرىشكىلى بولىدىغان جايدا ساقلاڭ. باشقىلار بىلەن ھەمبەھىر قىلماڭ ياكى توركۆرگۈچ ياكى باشقا كىلىيەنت كودىدا ئاشكارىلىماڭ.',
    vi: 'Mã này chỉ hiển thị một lần. Lưu bí mật này ở nơi an toàn và dễ truy cập. Không chia sẻ với người khác hoặc để lộ trong trình duyệt hoặc mã khách hàng khác.',
    zh_tc:
      '此權杖僅顯示一次，請將此金鑰保存在安全且可取得之處。請勿與他人共享，也不要在瀏覽器或其他用戶端程式碼中暴露它。',
    ru: 'Этот токен показывается только один раз. Сохраните секрет в безопасном и доступном месте. Не передавайте другим и не раскрывайте в браузере или другом клиентском коде.',
    ko: '이 토큰은 한 번만 표시됩니다. 이 비밀을 안전하고 접근 가능한 곳에 저장하세요. 다른 사람과 공유하거나 브라우저나 다른 클라이언트 코드에 노출하지 마세요.',
    bur: 'ဤတိုကင်ကို တစ်ကြိမ်သာ ပြသပါသည်။ ဤလျှို့ဝှက်ချက်ကို လုံခြုံ၍ ရယူနိုင်သော နေရာတွင် သိမ်းပေးပါ။ အခြားသူများနှင့် မျှဝေမထားပါနှင့် သို့မဟုတ် ဘရောက်ဖာတွင် သို့မဟုတ် အခြားကလိုင်ကုဒ်တွင် အထွက်မပေးပါနှင့်။',
    ben: 'এই টোকেন শুধুমাত্র একবার দেখানো হয়। এই গোপনীয়তা নিরাপদে সহজলভ্য জায়গায় সংরক্ষণ করুন। অন্যদের সাথে শেয়ার করবেন না বা ব্রাউজার বা অন্যান্য ক্লায়েন্ট কোডে প্রকাশ করবেন না।',
    tr: 'Bu jeton yalnızca bir kez gösterilir. Bu sırrı güvenli ve erişilebilir bir yerde saklayın. Başkalarıyla paylaşmayın veya tarayıcıda veya diğer istemci kodunda açığa çıkarmayın.',
    km: 'ថូខឹននេះបង្ហាញតែម្តងប៉ុណ្ណោះ។ រក្សាទុករក្សាសម្ងាត់នេះនៅកន្លែងសុវត្ថិភាព និងអាចចូលប្រើបាន។ កុំចែករំលែកជាមួយអ្នកដទៃ ឬបង្ហាញនៅក្នុងកម្មវិធីរុករក ឬកូដអតិថិជនផ្សេងទៀត។',
    es: 'Este token solo se muestra una vez. Guarde este secreto en un lugar seguro y accesible. No lo comparta con otras personas ni lo exponga en el navegador u otro código de cliente.',
    ar: 'يتم عرض هذا الرمز مرة واحدة فقط. احفظ هذا السر في مكان آمن ويمكن الوصول إليه. لا تشاركه مع الآخرين ولا تكشفه في المتصفح أو أي كود عميل آخر.',
  },
  'userAccessToken.token': {
    zh: '令牌',
    en: 'Token',
    id: 'Token',
    kz: 'Токен',
    th: 'โทเค็น',
    ug: 'توقەن',
    vi: 'Mã thông báo',
    zh_tc: '權杖',
    ru: 'Токен',
    ko: '토큰',
    bur: 'တိုကင်',
    ben: 'টোকেন',
    tr: 'Jeton',
    km: 'ថូខឹន',
    es: 'Token',
    ar: 'الرمز المميز',
  },
  'userAccessToken.deleteConfirm': {
    zh: '确定要删除该令牌吗？',
    en: 'Are you sure you want to delete this token?',
    id: 'Yakin ingin menghapus token ini?',
    kz: 'Бұл токенді жоюға сенімдісіз бе?',
    th: 'แน่ใจหรือไม่ว่าต้องการลบโทเค็นนี้?',
    ug: 'بۇ توقەننى ئۆچۈرۈشكە جەزىم قىلامسىز؟',
    vi: 'Bạn có chắc muốn xóa mã này không?',
    zh_tc: '確定要刪除此權杖嗎？',
    ru: 'Удалить этот токен?',
    ko: '이 토큰을 삭제하시겠습니까?',
    bur: 'ဤတိုကင်ကို ဖျက်မည်လား?',
    ben: 'আপনি কি নিশ্চিত যে এই টোকেনটি মুছে ফেলতে চান?',
    tr: 'Bu jetonu silmek istediğinizden emin misiniz?',
    km: 'តើអ្នកប្រាកដថាចង់លុបថូខឹននេះមែនទេ?',
    es: '¿Seguro que desea eliminar este token?',
    ar: 'هل أنت متأكد أنك تريد حذف هذا الرمز المميز؟',
  },
  'userAccessToken.userAccessToken': {
    zh: '用户访问令牌',
    en: 'User Access Token',
    id: 'Token Akses Pengguna',
    kz: 'Пайдаланушының кіру токені',
    th: 'โทเค็นการเข้าถึงของผู้ใช้',
    ug: 'ئىشلەتكۈچى زىيارەت توقىنى',
    vi: 'Token truy cập người dùng',
    zh_tc: '用戶存取權杖',
    ru: 'Токен доступа пользователя',
    ko: '사용자 액세스 토큰',
    bur: 'အသုံးပြုသူ ဝင်ရောက်တိုကင်',
    ben: 'ব্যবহারকারী অ্যাক্সেস টোকেন',
    tr: 'Kullanıcı erişim jetonu',
    km: 'ថូខឹនចូលប្រើរបស់អ្នកប្រើ',
    es: 'Token de acceso de usuario',
    ar: 'رمز وصول المستخدم',
  },
  'userAccessToken.dayUnit': {
    zh: '天',
    en: 'd',
    id: 'hari',
    kz: 'күн',
    th: 'วัน',
    ug: 'كۈن',
    vi: 'ngày',
    zh_tc: '天',
    ru: 'дн.',
    ko: '일',
    bur: 'ရက်',
    ben: 'দিন',
    tr: 'gün',
    km: 'ថ្ងៃ',
    es: 'd',
    ar: 'يوم',
  },
  'userAccessToken.custom': {
    zh: '自定义',
    en: 'Custom',
    id: 'Kustom',
    kz: 'Реттелетін',
    th: 'กำหนดเอง',
    ug: 'ئۆزلۈك بەلگىلەنگەن',
    vi: 'Tùy chỉnh',
    zh_tc: '自訂',
    ru: 'Пользовательский',
    ko: '사용자 지정',
    bur: 'စိတ်ကြိုက်',
    ben: 'কাস্টম',
    tr: 'Özel',
    km: 'តាមបំណង',
    es: 'Personalizado',
    ar: 'مخصص',
  },
  'userAccessToken.previewModalTitle': {
    zh: '新的个人访问令牌',
    en: 'New personal access token',
    id: 'Token akses pribadi baru',
    kz: 'Жаңа жеке кіру токені',
    th: 'โทเค็นการเข้าถึงส่วนตัวใหม่',
    ug: 'يېڭى شەخسىي زىيارەت توقىنى',
    vi: 'Mã truy cập cá nhân mới',
    zh_tc: '新的個人存取權杖',
    ru: 'Новый личный токен доступа',
    ko: '새 개인 액세스 토큰',
    bur: 'ကိုယ်ပိုင်ဝင်ရောက်မှတ်တမ်း အသစ်',
    ben: 'নতুন ব্যক্তিগত অ্যাক্সেস টোকেন',
    tr: 'Yeni kişisel erişim jetonu',
    km: 'ថូខឹនចូលប្រើផ្ទាល់ខ្លួនថ្មី',
    es: 'Nuevo token de acceso personal',
    ar: 'رمز وصول شخصي جديد',
  },
  'userAccessToken.addModalTitle': {
    zh: '添加新的个人访问令牌',
    en: 'Add new personal access token',
    id: 'Tambahkan token akses pribadi baru',
    kz: 'Жаңа жеке кіру токенін қосу',
    th: 'เพิ่มโทเค็นการเข้าถึงส่วนตัวใหม่',
    ug: 'يېڭى شەخسىي زىيارەت توقىنى قوشۇش',
    vi: 'Thêm mã truy cập cá nhân mới',
    zh_tc: '新增個人存取權杖',
    ru: 'Добавить новый личный токен доступа',
    ko: '새 개인 액세스 토큰 추가',
    bur: 'ကိုယ်ပိုင်ဝင်ရောက်မှတ်တမ်း အသစ်ထည့်ပါ',
    ben: 'নতুন ব্যক্তিগত অ্যাক্সেস টোকেন যোগ করুন',
    tr: 'Yeni kişisel erişim jetonu ekle',
    km: 'បន្ថែមថូខឹនចូលប្រើផ្ទាល់ខ្លួនថ្មី',
    es: 'Agregar nuevo token de acceso personal',
    ar: 'إضافة رمز وصول شخصي جديد',
  },
  'materialPage.paibanSetting.stackingMethod.title': {
    zh: '排版堆叠方式',
    en: 'Stack Align',
    id: 'Metode Pengaturan Tumpukan',
    kz: 'Тексеру әдісі',
    th: 'วิธีการตั้งค่าตำแหน่ง',
    ug: 'تەرتىپلەش ۋەيتى',
    vi: 'Cách sắp xếp',
    zh_tc: '排版堆疊方式',
    ru: 'Метод укладки',
    ko: '레이아웃 쌓기 방법',
    bur: 'ပေါ်ဒ်ပိုင်းပြင်ဆင်ခြင်းမှာယူသည့်နည်းလမ်း',
    ben: 'লেআউট স্ট্যাকিং পদ্ধতি',
    tr: 'Yığma Yöntemi',
    km: 'កម្មវិធីរៀបចំផ្ទាំង',
    es: 'Método de apilamiento',
    ar: 'طريقة التجميع',
  },
  'materialPage.paibanSetting.seniorShapeTip': {
    zh: '【高级嵌套】限免体验已到期，当前可预览高级嵌套排版结果（也可切换普通嵌套进行正常排产），如需导出高级嵌套排产文件，请联系销售人员购买~',
    en: '【Advanced Nesting】Free trial period has expired, you can preview the advanced nesting layout result (you can also switch to normal nesting for normal production); if you need to export the advanced nesting production file, please contact the sales staff to purchase~',
    id: '【Pengaturan Anak Lantai Lanjutan】Batas percobaan gratis telah berakhir, Anda dapat melihat hasil tata letak anak lantai lanjutan (Anda juga dapat beralih ke anak lantai normal untuk produksi normal); jika Anda perlu mengekspor file produksi anak lantai lanjutan, silakan hubungi staf penjualan untuk membeli~',
    kz: '【Қосымша қалыптау】Бос мүмкіндік мөлшері шектелген, сіз қалыптау нәтижесін қарауға болады (қалыптау өндірісін орындау үшін қалыптау өндірісін орындауға ауыса аласыз); егер сіз қосымша қалыптау өндіріс файлын шығару керек болса, сатушылармен байланысыңыз~',
    th: '【การตั้งค่าพื้นฐานของพื้น】ระยะเวลาการทดลองฟรีได้สิ้นสุด คุณสามารถดูผลลัพธ์การตั้งค่าพื้นฐานของพื้นได้ หากคุณต้องการส่งออกไฟล์การผลิตพื้นฐานของพื้น โปรดติดต่อทีมขายเพื่อซื้อ~',
    ug: '【تەرتىپلەش ۋەيتى】بوش مۇمكىنلىك مەلەمات ھەغلىتىلىنىش قوللانغان، سىز تەرتىپلەش نەتىجىسىنى قاراشقان قوللاپ بولىدۇ؛ ئىف سىز تەرتىپلەش ۋەيتى ۋەيتى پرودۇكتىيە فايلنى ئېلىش كىرىش قوللانغان، بىرىكى قۇرىلمىش كىتابچىسىغا مۇلازىمىتە بىرىلىپ بولىدۇ~',
    vi: '【Cách sắp xếp】Giới hạn thử nghiệm miễn phí đã hết hạn, bạn có thể xem trước kết quả bố trí nâng cao; nếu bạn cần xuất file sản xuất bố trí nâng cao, vui lòng liên hệ nhân viên bán hàng để mua~',
    zh_tc:
      '【高級嵌套】限免體驗已到期，當前可預覽高級嵌套排版結果（也可切換普通嵌套進行正常排產），如需導出高級嵌套排產文件，請聯繫銷售人員購買~',
    ru: '【Расширенное вложение】Срок бесплатной пробы истек, вы можете предварительно просмотреть результаты раскладки расширенного вложения; если вам нужно экспортировать файл производства расширенного вложения, свяжитесь с отделом продаж для покупки~',
    ko: '【고급 중첩】무료 평가판 기간이 만료되었습니다. 레이아웃 결과를 미리 확인할 수 있습니다. (일반 중첩으로 전환하여 정상 생산을 진행할 수 있습니다.) 고급 중첩 생산 파일을 내보내려면 판매 담당자에게 문의하세요.~',
    bur: '【Advanced Nesting】အခမဲ့စမ်းသပ်မှုသက်တမ်းကုန်သွားပါပြီ၊ လက်ရှိတွင် advanced nesting layout ရလဒ်ကို ကြိုတင်ကြည့်ရှုနိုင်ပါသည် (သာမန် nesting သို့ ပြောင်းလဲ၍ ပုံမှန်ထုတ်လုပ်မှုလုပ်ဆောင်နိုင်ပါသည်)။ advanced nesting ထုတ်လုပ်မှုဖိုင်ထုတ်ယူဖို့ လိုပါက အရောင်းဝန်ထမ်းကို ဆက်သွယ်ဝယ်ယူပါ~',
    ben: '【উন্নত নেস্টিং】বিনামূল্যে ট্রায়ালের মেয়াদ শেষ হয়েছে, আপনি উন্নত নেস্টিং লেআউটের ফলাফল প্রিভিউ করতে পারেন (সাধারণ উৎপাদনের জন্য সাধারণ নেস্টিংয়েও স্যুইচ করতে পারেন); উন্নত নেস্টিং উৎপাদন ফাইল এক্সপোর্ট করতে চাইলে বিক্রয় কর্মীর সাথে যোগাযোগ করে কিনুন~',
    tr: '【Gelişmiş İç İçe Yerleşim】Ücretsiz deneme süresi doldu, gelişmiş iç içe yerleşim sonucunu önizleyebilirsiniz (normal üretim için normal iç içe yerleşime de geçebilirsiniz); gelişmiş iç içe yerleşim üretim dosyasını dışa aktarmanız gerekiyorsa, satın almak için satış ekibiyle iletişime geçin~',
    km: '【ការរួមបញ្ចូលកម្រិតខ្ពស់】ការសាកល្បងឥតគិតថ្លៃបានផុតកំណត់แล้ว អ្នកអាចមើលលទ្ធផលការរៀបចំការរួមបញ្ចូលកម្រិតខ្ពស់ជាមុន (អ្នកក៏អាចប្តូរទៅការរួមបញ្ចូលធម្មតាសម្រាប់ការផលិតធម្មតា)។ ប្រសិនបើអ្នកត្រូវការនាំចេញឯកសារផលិតកម្មការរួមបញ្ចូលកម្រិតខ្ពស់ សូមទាក់ទងបុគ្គលិកលក់ដើម្បីទិញ~',
    es: '【Anidamiento avanzado】El periodo de prueba gratuito ha expirado, puede previsualizar el resultado del diseño de anidamiento avanzado (también puede cambiar al anidamiento normal para la producción normal); si necesita exportar el archivo de producción de anidamiento avanzado, póngase en contacto con el personal de ventas para comprar~',
    ar: '【التداخل المتقدم】انتهت فترة التجربة المجانية، يمكنك معاينة نتيجة تخطيط التداخل المتقدم (يمكنك أيضًا التبديل إلى التداخل العادي للإنتاج العادي)؛ إذا كنت بحاجة إلى تصدير ملف إنتاج التداخل المتقدم، يرجى الاتصال بموظفي المبيعات للشراء~',
  },
  'materialPage.paibanSetting.stackingMethod.long': {
    zh: '靠长边排版',
    en: 'Long Edge First',
    id: 'Tumpukkan oleh Panjang',
    kz: 'Ұзын қабырға бойынша төсеу',
    th: 'ตั้งค่าตำแหน่งตามขอบยาว',
    ug: 'تەرتىپلەش لونىيە قېتىم',
    vi: 'Sắp xếp theo cạnh dài',
    zh_tc: '靠長邊排版',
    ru: 'Укладка по длинной стороне',
    ko: '긴 변을 따라 레이아웃',
    bur: 'အကြီးဆုံးကြောင်းမှာယူသည့်နည်းလမ်း',
    ben: 'দীর্ঘ বাহু অনুসারে লেআউট করুন',
    tr: 'Uzun kenarına göre yığınla',
    km: 'កម្មវិធីរៀបចំផ្ទាំងតូចគឺចង់រៀបចំជាក្រុម',
    es: 'Apilar por el lado largo',
    ar: 'تجميع بالجانب الطويل',
  },
  'materialPage.paibanSetting.stackingMethod.short': {
    zh: '靠短边排版',
    en: 'Short Edge First',
    id: 'Tumpukkan oleh Panjang Pendek',
    kz: 'Қысқа қабырға бойынша төсеу',
    th: 'ตั้งค่าตำแหน่งตามขอบสั้น',
    ug: 'تەرتىپلەش قېتىيە قېتىم',
    vi: 'Sắp xếp theo cạnh ngắn',
    zh_tc: '靠短邊排版',
    ru: 'Укладка по короткой стороне',
    ko: '짧은 변을 따라 레이아웃',
    bur: 'အနီးဆုံးကြောင်းမှာယူသည့်နည်းလမ်း',
    ben: 'কর্মকার বাহু অনুসারে লেআউট করুন',
    tr: 'Kısa kenarına göre yığınla',
    km: 'កម្មវិធីរៀបចំផ្ទាំងតូចគឺចង់រៀបចំជាក្រុម',
    es: 'Apilar por el lado corto',
    ar: 'تجميع بالجانب القصير',
  },
  'bujianStore.inputPlaceholder': {
    zh: '输入板件条码搜索补件小板',
    en: 'Search replacement by part barcode',
    id: 'Masukkan kode plank untuk mencari papan tambahan',
    kz: 'Тақта штрих-кодын енгізіп, толықтыруға арналған шағын тақтаны іздеу',
    th: 'ป้อนรหัสกระดานเพื่อค้นหากระดานเสริม',
    ug: 'ھېسابىڭىز سانلىق مەلۇمات بىخەتەرلىكى ئۈچۈن، نۆۋەتتە مەشغۇلات ئېلىپ بېرىۋاتقان ئادەمنىڭ ئۇچۇرىنى دەلىللەپ تاسقلاڭ',
    vi: 'Nhập mã plank để tìm kiếm tấm gỗ bổ sung',
    zh_tc: '輸入板件條碼搜索補件小板',
    ru: 'Введите код платформы для поиска дополнительных малых досок',
    ko: '플랜크 바코드를 입력하여 보완 소판 검색',
    bur: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    ben: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    tr: 'Panoya eklemek için pano barkodunu girin',
    km: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    es: 'Ingrese el código de la tabla para buscar tableros pequeños de repuestos',
    ar: 'أدخل رمز الجدار للبحث عن لوحات صغيرة للإصلاح',
  },
  'bujianStore.noData': {
    zh: '暂无数据',
    en: 'No data',
    id: 'Tidak ada data',
    kz: 'Дерек жоқ',
    th: 'ไม่มีข้อมูล',
    ug: 'ھېسابىڭىز سانلىق مەلۇمات بىخەتەرلىكى ئۈچۈن، نۆۋەتتە مەشغۇلات ئېلىپ بېرىۋاتقان ئادەمنىڭ ئۇچۇرىنى دەلىللەپ تاسقلاڭ',
    vi: 'Không có dữ liệu',
    zh_tc: '暫無數據',
    ru: 'Нет данных',
    ko: '데이터가 없습니다.',
    bur: 'မှတ်ချက်များမရှိပါ',
    ben: 'কোন ডেটা নেই',
    tr: 'Veri yok',
    km: 'មិនមានទិន្នន័យ',
    es: 'No hay datos',
    ar: 'لا يوجد بيانات',
  },
  'bujianStore.loadingErr': {
    zh: '补件板件加载失败',
    en: 'Supplement plank loading failed',
    id: 'Pembangunan papan tambahan gagal',
    kz: 'Толықтыру тақталарын жүктеу сәтсіз аяқталды',
    th: 'การโหลดกระดานเสริมไม่สำเร็จ',
    ug: 'ھېسابىڭىز سانلىق مەلۇمات بىخەتەرلىكى ئۈچۈن، نۆۋەتتە مەشغۇلات ئېلىپ بېرىۋاتقان ئادەمنىڭ ئۇچۇرىنى دەلىللەپ تاسقلاڭ',
    vi: 'Tải tấm gỗ bổ sung thất bại',
    zh_tc: '補件板件加載失敗',
    ru: 'Загрузка дополнительных малых досок не удалась',
    ko: '보완 소판 로딩 실패',
    bur: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    ben: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    tr: 'Panoya eklemek için pano barkodunu girin',
    km: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    es: 'Carga de paneles de repuestos fallida',
    ar: 'فشل تحميل الورق المطبوع',
  },
  'bujianStore.bujianStore': {
    zh: '补件库',
    en: 'Replacement Parts',
    id: 'Toko papan tambahan',
    kz: 'Толықтыру қоймасы',
    th: 'สำหรับการโหลดกระดานเสริม',
    ug: 'ھېسابىڭىز سانلىق مەلۇمات بىخەتەرلىكى ئۈچۈن، نۆۋەتتە مەشغۇلات ئېلىپ بېرىۋاتقان ئادەمنىڭ ئۇچۇرىنى دەلىللەپ تاسقلاڭ',
    vi: 'Tải tấm gỗ bổ sung thất bại',
    ru: 'Библиотека дополнительных малых досок',
    ko: '보완 소판 라이브러리',
    bur: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    ben: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    tr: 'Panoya eklemek için pano barkodunu girin',
    km: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    es: 'Biblioteca de papeles impresos',
    ar: 'مكتبة الورق المطبوع',
  },
  'bujianStore.awaitStore': {
    zh: '待排版库',
    en: 'Nest Pool',
    id: 'Toko papan tambahan',
    kz: 'Орналастыруды күту қоймасы',
    th: 'สำหรับการโหลดกระดานเสริม',
    ug: 'ھېسابىڭىز سانلىق مەلۇمات بىخەتەرلىكى ئۈچۈن، نۆۋەتتە مەشغۇلات ئېلىپ بېرىۋاتقان ئادەمنىڭ ئۇچۇرىنى دەلىللەپ تاسقلاڭ',
    vi: 'Tải tấm gỗ bổ sung thất bại',
    ru: 'Библиотека печатных материалов',
    ko: '보완 소판 라이브러리',
    bur: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    ben: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    tr: 'Panoya eklemek için pano barkodunu girin',
    km: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    es: 'Biblioteca de materiales impresos',
    ar: 'مكتبة المواد المطبوعة',
  },
  'bujianStore.noDrag': {
    zh: '无法放置，请点击补件按钮将板件放入补件库',
    en: 'Cannot be placed, please click the button to place the board into the supplement library',
    id: 'Tidak dapat ditempatkan, klik tombol untuk meletakkan papan ke dalam toko papan tambahan',
    kz: 'Тақта орналастыруды күту қоймасына салу сәтсіз аяқталды',
    th: 'ไม่สามารถวางได้, กรุณาคลิกปุ่มเพื่อวางกระดานเข้าไปในสำหรับการโหลดกระดานเสริม',
    ug: 'ھېسابىڭىز سانلىق مەلۇمات بىخەتەرلىكى ئۈچۈن، نۆۋەتتە مەشغۇلات ئېلىپ بېرىۋاتقان ئادەمنىڭ ئۇچۇرىنى دەلىللەپ تاسقلاڭ',
    vi: 'Không thể đặt, vui lòng nhấn nút để đặt tấm gỗ vào thư viện tấm gỗ bổ sung',
    zh_tc: '無法放置，請點擊補件按鈕將板件放入補件庫',
    ru: 'Невозможно разместить, нажмите кнопку, чтобы разместить доску в библиотеку дополнительных малых досок',
    ko: '배치할 수 없습니다, 보완 소판 라이브러리에 넣기 위해 버튼을 클릭하세요',
    bur: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    ben: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    tr: 'Panoya eklemek için pano barkodunu girin',
    km: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    es: 'No se puede colocar, por favor, verifique las propiedades de material, color y espesor del panel',
    ar: 'لا يمكن تعيين, يرجى التحقق من خصائص المواد واللون والسمك الخاص باللوحة',
  },
  'bujianStore.outOfCanvas': {
    zh: '无法放置, 请核对板件材质、颜色和厚度属性!',
    en: 'Cannot be placed, please check the material, color and thickness properties of the board',
    id: 'Tidak dapat ditempatkan, silakan periksa properti material, warna dan ketebalan papan',
    kz: 'Тақта материалы, түсті және қалыңдығы қалай жазылғанын тексеріңіз',
    th: 'ไม่สามารถวางได้, กรุณาตรวจสอบคุณสมบัติของกระดานเช่นวัสดุ, สี และความหนา',
    ug: 'ئورۇنلاشتۇرغىلى بولمايدۇ، تاختا ماتېرىيالى، رەڭگى ۋە قېلىنلىق خاسلىقىنى تەكشۈرۈپ بېقىڭ!',
    vi: 'Không thể đặt, vui lòng kiểm tra thuộc tính vật liệu, màu sắc và độ dày của tấm gỗ',
    zh_tc: '無法放置，請核對板件材質、顏色和厚度屬性!',
    ru: 'Невозможно разместить, пожалуйста, проверьте свойства материала, цвета и толщины доски',
    ko: '배치할 수 없습니다, 보드의 재료, 색상 및 두께 속성을 확인하세요',
    bur: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    ben: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    tr: 'Panoya eklemek için pano barkodunu girin',
    km: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    es: 'No se puede colocar, por favor, verifique las propiedades de material, color y espesor del panel',
    ar: 'لا يمكن تعيين, يرجى التحقق من خصائص المواد واللون والسمك الخاص باللوحة',
  },
  'cuttingDock.cuttingParams.openKnifeDistance': {
    zh: '减速距离',
    en: 'Slow distance',
    id: 'Jarak pelambatan',
    kz: 'Қайтарудың баяу жылдамдығы',
    th: 'ระยะลดความเร็วของการขีดสัน',
    ug: 'ھېسابىڭىز سانلىق مەلۇمات بىخەتەرلىكى ئۈچۈن، نۆۋەتتە مەشغۇلات ئېلىپ بېرىۋاتقان ئادەمنىڭ ئۇچۇرىنى دەلىللەپ تاسقلاڭ',
    vi: 'Khoảng cách giảm tốc khi thái',
    zh_tc: '減速距離',
    ru: 'Замедление расстояния',
    ko: '감속 거리',
    bur: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    ben: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    tr: 'Panoya eklemek için pano barkodunu girin',
    km: 'បង្ហាញកូដកម្មវិធីកម្មវិធីស្កេនរួច ស្កេនរួច ស្កេនរួច',
    es: 'Seleccione un panel remanente cortado',
    ar: 'يرجى تحديد لوحة القطع المتبقية',
  },
  'lineManager.onlyNoSideHoleSlotSmallPlank': {
    zh: '仅无侧孔侧槽小板',
    en: 'Only Small Boards Without Side Holes/Slots',
    id: 'Hanya papan kecil tanpa lubang/slot samping',
    kz: 'Бүйірлік тесіктер мен қапықтары жоқ кішкентай тақталар ғана',
    th: 'เฉพาะแผ่นเล็กที่ไม่มีรู/ร่องด้านข้าง',
    ug: 'پەقەت يان تەرەپ تېشىك/ئويۇقى يوق كىچىك تاختا',
    vi: 'Chỉ tấm nhỏ không có lỗ/khe bên',
    zh_tc: '僅無側孔側槽小板',
    ru: 'Только маленькие доски без боковых отверстий и пазов',
    ko: '측면 구멍/슬롯이 없는 소판만',
    bur: 'ဘေးအပေါက်/ဘေးချောင်းမရှိသောပြားငယ်များသာ',
    ben: 'শুধুমাত্র পার্শ্ব ছিদ্র/স্লটবিহীন ছোট বোর্ড',
    tr: 'Yalnızca yan delik/oluk olmayan küçük plakalar',
    km: 'មានតែផ្ទាំងតូចគ្មានរណ្តៅ/រណ្តៅចំហៀង',
    es: 'Solo tableros pequeños sin orificios/ranuras laterales',
    ar: 'الألواح الصغيرة فقط بدون ثقوب/فتحات جانبية',
  },
  'arrangedPage.clearReuseRelation': {
    zh: '点击清除复用关系',
    en: 'Click to clear reuse relationship',
    id: 'Klik untuk menghapus hubungan penggunaan ulang',
    kz: 'Қайта пайдалану байланысын тазалау үшін басыңыз',
    th: 'คลิกเพื่อล้างความสัมพันธ์การใช้ซ้ำ',
    ug: 'قايتا ئىشلىتىش مۇناسىۋىتىنى تازىlash ئۈچۈن چېكىڭ',
    vi: 'Nhấp để xóa mối quan hệ tái sử dụng',
    zh_tc: '點擊清除複用關係',
    ru: 'Нажмите, чтобы очистить связь повторного использования',
    ko: '재사용 관계를 해제하려면 클릭하세요',
    bur: 'ပြန်လည်အသုံးပြုမှုဆက်ဆံရေးကို ရှင်းလင်းရန် နှိပ်ပါ',
    ben: 'পুনরায় ব্যবহারের সম্পর্ক মুছতে ক্লিক করুন',
    tr: 'Yeniden kullanım ilişkisini temizlemek için tıklayın',
    km: 'ចុចដើម្បីលុបទំនាក់ទំនងការប្រើប្រាស់ម្តងទៀត',
    es: 'Haga clic para borrar la relación de reutilización',
    ar: 'انقر لمسح علاقة إعادة الاستخدام',
  },
  'arrangedPage.layoutReuseTip': {
    zh: '快速复刻大板排版布局，板件变动自动解除复用关系',
    en: 'Quickly replicate large board layout; board changes automatically clear the reuse relationship',
    id: 'Replikasi cepat tata letak papan besar; perubahan papan otomatis menghapus hubungan penggunaan ulang',
    kz: 'Үлкен тақта орналасуын тез көшіру; тақта өзгергенде қайта пайдалану байланысы автоматты түрде жойылады',
    th: 'คัดลอกเลย์เอาต์แผ่นใหญ่อย่างรวดเร็ว การเปลี่ยนแปลงแผ่นจะยกเลิกความสัมพันธ์การใช้ซ้ำโดยอัตโนมัติ',
    ug: 'چوڭ تاختا تەرتىپلەش ئورنىتىشنى تېز كۆچۈرۈش، تاختا ئۆزگەرگەندە قايتا ئىشلىتىش مۇناسىۋىتى ئاپتوماتىك بىكار قىلىنىدۇ',
    vi: 'Sao chép nhanh bố cục tấm lớn; thay đổi tấm sẽ tự động hủy mối quan hệ tái sử dụng',
    zh_tc: '快速複刻大板排版布局，板件變動自動解除複用關係',
    ru: 'Быстрое копирование раскладки большой панели; изменения панели автоматически снимают связь повторного использования',
    ko: '대판 레이아웃을 빠르게 복제하며, 판재 변경 시 재사용 관계가 자동 해제됩니다',
    bur: 'ကြီးမားသော ပေါ်ဒ်အပြင်အဆင်ကို အမြန်ပုံတူကူးပါ၊ ပေါ်ဒ်ပြောင်းလဲမှုသည် ပြန်လည်အသုံးပြုမှုဆက်ဆံရေးကို အလိုအလျောက်ဖယ်ရှားသည်',
    ben: 'বড় বোর্ডের লেআউট দ্রুত অনুলিপি করুন, বোর্ড পরিবর্তন হলে পুনরায় ব্যবহারের সম্পর্ক স্বয়ংক্রিয়ভাবে মুছে যাবে',
    tr: 'Büyük panel yerleşimini hızla kopyalayın; panel değişiklikleri yeniden kullanım ilişkisini otomatik kaldırır',
    km: 'ចម្លងប្លង់បន្ទះធំយ៉ាងលឿន ការផ្លាស់ប្តូរបន្ទះនឹងលុបទំនាក់ទំនងការប្រើប្រាស់ម្តងទៀតដោយស្វ័យប្រវត្តិ',
    es: 'Replique rápidamente el diseño del panel grande; los cambios en el panel eliminan automáticamente la relación de reutilización',
    ar: 'انسخ تخطيط اللوحة الكبيرة بسرعة؛ تغييرات اللوحة تلغي علاقة إعادة الاستخدام تلقائياً',
  },
  'arrangedPage.hasBeenReused': {
    zh: '已被复用',
    en: 'Already reused',
    id: 'Sudah digunakan ulang',
    kz: 'Қайта пайдаланылған',
    th: 'ถูกใช้ซ้ำแล้ว',
    ug: 'قايتا ئىشلىتىلگەن',
    vi: 'Đã được tái sử dụng',
    zh_tc: '已被複用',
    ru: 'Уже использовано повторно',
    ko: '재사용됨',
    bur: 'ပြန်လည်အသုံးပြုပြီး',
    ben: 'ইতিমধ্যে পুনরায় ব্যবহৃত',
    tr: 'Yeniden kullanıldı',
    km: 'បានប្រើប្រាស់ម្តងទៀតរួចហើយ',
    es: 'Ya reutilizado',
    ar: 'تمت إعادة الاستخدام',
  },
  'arrangedPage.layoutReuse': {
    zh: '布局复用',
    en: 'Layout reuse',
    id: 'Penggunaan ulang tata letak',
    kz: 'Орналасуды қайта пайдалану',
    th: 'ใช้เลย์เอาต์ซ้ำ',
    ug: 'ئورنىتىشنى قايتا ئىشلىتىش',
    vi: 'Tái sử dụng bố cục',
    zh_tc: '布局複用',
    ru: 'Повторное использование раскладки',
    ko: '레이아웃 재사용',
    bur: 'အပြင်အဆင် ပြန်လည်အသုံးပြုခြင်း',
    ben: 'লেআউট পুনরায় ব্যবহার',
    tr: 'Yerleşim yeniden kullanımı',
    km: 'ប្រើប្រាស់ប្លង់ម្តងទៀត',
    es: 'Reutilización de diseño',
    ar: 'إعادة استخدام التخطيط',
  },
  'arrangedPage.specialProcessNotSupported': {
    zh: '板件存在特殊工艺，不支持此操作',
    en: 'The board has special processes and this operation is not supported',
    id: 'Papan memiliki proses khusus, operasi ini tidak didukung',
    kz: 'Тақтада арнайы процестер бар, бұл операция қолдау көрсетілмейді',
    th: 'แผ่นมีกระบวนการพิเศษ ไม่รองรับการดำเนินการนี้',
    ug: 'تاختا ئالاھىدە ئىشلەش جەريانىغا ئىگە، بۇ مەشغۇلاتنى قوللىمايدۇ',
    vi: 'Tấm có quy trình đặc biệt, không hỗ trợ thao tác này',
    zh_tc: '板件存在特殊工藝，不支持此操作',
    ru: 'На панели есть специальные процессы, эта операция не поддерживается',
    ko: '판재에 특수 공정이 있어 이 작업을 지원하지 않습니다',
    bur: 'ပေါ်ဒ်တွင် အထူးလုပ်ငန်းစဉ်ရှိပြီး ဤလုပ်ဆောင်ချက်ကို မပံ့ပိုးပါ',
    ben: 'বোর্ডে বিশেষ প্রক্রিয়া আছে, এই অপারেশন সমর্থিত নয়',
    tr: 'Panelde özel işlem var, bu işlem desteklenmiyor',
    km: 'បន្ទះមានដំណើរការពិសេស មិនគាំទ្រប្រតិបត្តិការនេះទេ',
    es: 'El panel tiene procesos especiales, esta operación no es compatible',
    ar: 'اللوحة تحتوي على عمليات خاصة، هذه العملية غير مدعومة',
  },
  'arrangedPage.conflictNotSupported': {
    zh: '板件存在冲突，不支持此操作',
    en: 'Board conflict detected, this operation is not supported',
    id: 'Terjadi konflik papan, operasi ini tidak didukung',
    kz: 'Тақта қақтығысы бар, бұл операция қолдау көрсетілмейді',
    th: 'แผ่นมีความขัดแย้ง ไม่รองรับการดำเนินการนี้',
    ug: 'تاختا زىددىيەتلىك، بۇ مەشغۇلاتنى قوللىمايدۇ',
    vi: 'Tấm bị xung đột, không hỗ trợ thao tác này',
    zh_tc: '板件存在衝突，不支持此操作',
    ru: 'Обнаружен конфликт панелей, эта операция не поддерживается',
    ko: '판재 충돌이 있어 이 작업을 지원하지 않습니다',
    bur: 'ပေါ်ဒ်တွင် conflic ရှိပြီး ဤလုပ်ဆောင်ချက်ကို မပံ့ပိုးပါ',
    ben: 'বোর্ডে দ্বন্দ্ব আছে, এই অপারেশন সমর্থিত নয়',
    tr: 'Panel çakışması var, bu işlem desteklenmiyor',
    km: 'បន្ទះមានជម្លោះ មិនគាំទ្រប្រតិបត្តិការនេះទេ',
    es: 'Conflicto de panel detectado, esta operación no es compatible',
    ar: 'يوجد تعارض في اللوحة، هذه العملية غير مدعومة',
  },
  'arrangedPage.noAvailablePlankForReuse': {
    zh: '没有可用的板件进行复用',
    en: 'No available boards for reuse',
    id: 'Tidak ada papan yang tersedia untuk digunakan ulang',
    kz: 'Қайта пайдалануға болатын тақта жоқ',
    th: 'ไม่มีแผ่นที่ใช้ซ้ำได้',
    ug: 'قايتا ئىشلىتىشكە بولىدىغان تاختا يوق',
    vi: 'Không có tấm nào khả dụng để tái sử dụng',
    zh_tc: '沒有可用的板件進行複用',
    ru: 'Нет доступных панелей для повторного использования',
    ko: '재사용할 수 있는 판재가 없습니다',
    bur: 'ပြန်လည်အသုံးပြုရန် ရရှိနိုင်သော ပေါ်ဒ်မရှိပါ',
    ben: 'পুনরায় ব্যবহারের জন্য কোনো উপলব্ধ বোর্ড নেই',
    tr: 'Yeniden kullanım için uygun panel yok',
    km: 'មិនមានបន្ទះដែលអាចប្រើប្រាស់ម្តងទៀតបានទេ',
    es: 'No hay paneles disponibles para reutilizar',
    ar: 'لا توجد ألواح متاحة لإعادة الاستخدام',
  },
  'arrangedPage.noMatchingPlankFound': {
    zh: '未找到匹配的板件',
    en: 'No matching board found',
    id: 'Tidak ditemukan papan yang cocok',
    kz: 'Сәйкес тақта табылмады',
    th: 'ไม่พบแผ่นที่ตรงกัน',
    ug: 'ماس كېلىدىغان تاختا تېپىلمىدى',
    vi: 'Không tìm thấy tấm phù hợp',
    zh_tc: '未找到匹配的板件',
    ru: 'Подходящая панель не найдена',
    ko: '일치하는 판재를 찾을 수 없습니다',
    bur: 'ကိုက်ညီသော ပေါ်ဒ်ကို မတွေ့ပါ',
    ben: 'মিলে যাওয়া বোর্ড পাওয়া যায়নি',
    tr: 'Eşleşen panel bulunamadı',
    km: 'រកមិនឃើញបន្ទះដែលត្រូវគ្នាទេ',
    es: 'No se encontró un panel coincidente',
    ar: 'لم يتم العثور على لوحة مطابقة',
  },
  'arrangedPage.reuseBoard': {
    zh: '{number}号大板复用',
    en: 'Reuse {number}th board',
    id: 'Gunakan papan ke-{number}',
    kz: '{number} қатарындағы тақта қайта пайдалану',
    th: 'ใช้แผ่นที่ {number} อันดับ',
    ug: '{number} قەتتە ئىشلىتىش',
    vi: 'Sử dụng tấm {number}',
    zh_tc: '{number}號大板複用',
    ru: 'Повторное использование {number} панели',
    ko: '{number}번째 판재 재사용',
    bur: '{number} ပေါ်ဒ်ပြန်လည်အသုံးပြုခြင်း',
    ben: '{number} নং বোর্ড পুনরায় ব্যবহার',
    tr: '{number} numaralı panel yeniden kullanım',
    km: '{number} បន្ទះប្រើប្រាស់ម្តងទៀត',
    es: 'Reutilizar panel {number}',
    ar: 'إعادة استخدام اللوحة {number}',
  },
  'arrangedPage.influenceTip.title': {
    zh: '影响优化率的功能',
    en: 'Features affecting optimization rate',
    id: 'Fitur yang memengaruhi tingkat optimasi',
    kz: 'Оңтайландыру шығырлылыгіне әсер ететін функциялар',
    th: 'ฟังก์ชันที่ส่งผลต่ออัตราการเพิ่มประสิทธิภาพ',
    ug: 'ئۈنۈملۈك نىسبىتىگە تەسىر يەتكۈزىدىغان ئىقتىدارلار',
    vi: 'Tính năng ảnh hưởng đến tỷ lệ tối ưu hóa',
    zh_tc: '影響優化率功能',
    ru: 'Функции, влияющие на коэффициент оптимизации',
    ko: '최적화율에 영향을 주는 기능',
    bur: 'ကောင်းမွန်မှုနှုန်းအပေါ်သက်ရောက်သောလုပ်ဆောင်ချက်များ',
    ben: 'অপ্টিমাইজেশন হারকে প্রভাবিত করে এমন বৈশিষ্ট্য',
    tr: 'Optimizasyon oranını etkileyen özellikler',
    km: 'មុខងារដែលមានឥទ្ធិពលលើអត្រាប្រសើរឡើង',
    es: 'Funciones que afectan la tasa de optimización',
    ar: 'الميزات التي تؤثر على معدل التحسين',
  },
  'arrangedPage.influenceTip.empty': {
    zh: '暂无',
    en: 'None',
    id: 'Tidak ada',
    kz: 'Жоқ',
    th: 'ไม่มี',
    ug: 'يوق',
    vi: 'Không có',
    zh_tc: '暫無',
    ru: 'Нет',
    ko: '없음',
    bur: 'မရှိပါ',
    ben: 'নেই',
    tr: 'Yok',
    km: 'គ្មាន',
    es: 'Ninguno',
    ar: 'لا يوجد',
  },
  'arrangedPage.influenceTip.groupParams': {
    zh: '排版参数',
    en: 'Layout parameters',
    id: 'Parameter tata letak',
    kz: 'Орналастыру параметрлері',
    th: 'พารามิเตอร์การจัดวาง',
    ug: 'ئورۇنلاشتۇرۇش پارامېتىرلىرى',
    vi: 'Tham số bố cục',
    zh_tc: '排版參數',
    ru: 'Параметры раскладки',
    ko: '레이아웃 매개변수',
    bur: 'အစီအစဉ်ချမှုအညွှန်းများ',
    ben: 'বিন্যাস প্যারামিটার',
    tr: 'Yerleşim parametreleri',
    km: 'ប៉ារ៉ាម៉ែត្រនៃការរៀបចំ',
    es: 'Parámetros de disposición',
    ar: 'معايير التخطيط',
  },
  'arrangedPage.influenceTip.surplusNoRoll': {
    zh: '余料不翻板',
    en: 'Surplus material no flip',
    id: 'Sisa tidak dibalik',
    kz: 'Артық материал аудармалаусыз',
    th: 'วัสดุคงเหลือไม่พลิกแผ่น',
    ug: 'ئارتۇق ماتېرىيال ئۆرۈلمەسلىك',
    vi: 'Vật liệu dư không lật tấm',
    zh_tc: '餘料不翻板',
    ru: 'Остатки без переворота',
    ko: '잔재 미뒤집기',
    bur: 'ကျန်ရှိပစ္စည်းများ မလှန်ပါ',
    ben: 'অবশিষ্ট উপাদান উল্টানো হয় না',
    tr: 'Artık malzeme çevrilmez',
    km: 'សម្ភារៈសល់មិនត្រឡប់',
    es: 'Sin volteo de material sobrante',
    ar: 'لا قلب للمواد الفائضة',
  },
  'arrangedPage.influenceTip.surplusCustomTrim': {
    zh: '单独设置修边值',
    en: 'Individual trim value',
    id: 'Nilai potong tepi individual',
    kz: 'Жеке шеттеу мәні',
    th: 'ค่าตัดขอบเฉพาะ',
    ug: 'ئايرىم گىرۋەك كېسىش قىممىتى',
    vi: 'Giá trị cắt viền riêng',
    zh_tc: '單獨設定修邊值',
    ru: 'Индивидуальное значение обрезки',
    ko: '개별 마감 값 설정',
    bur: 'သီးခြားအနားညှိတန်ဖိုး',
    ben: 'পৃথক ট্রিম মান',
    tr: 'Ayrı kenar kesim değeri',
    km: 'តម្លៃកាត់គែមដាច់ដោយឡែក',
    es: 'Valor de recorte individual',
    ar: 'قيمة تشذيب فردية',
  },
  'arrangedPage.influenceTip.otherPlateCustomTrim': {
    zh: '特殊大板单独修边值',
    en: 'Special board individual trim value',
    id: 'Nilai potong tepi khusus papan besar',
    kz: 'Арнайы тақтаның жеке шеттеу мәні',
    th: 'ค่าตัดขอบเฉพาะแผ่นใหญ่พิเศษ',
    ug: 'ئالاھىدە چوڭ تاختاي ئايرىم گىرۋەك كېسىش قىممىتى',
    vi: 'Giá trị cắt viền riêng tấm đặc biệt',
    zh_tc: '特殊大板單獨修邊值',
    ru: 'Индивидуальная обрезка для специальной панели',
    ko: '특수 대판 개별 마감 값',
    bur: 'အထူးဘုတ်အတွက်သီးခြားအနားညှိတန်ဖိုး',
    ben: 'বিশেষ বোর্ডের পৃথক ট্রিম মান',
    tr: 'Özel büyük panel için ayrı kenar değeri',
    km: 'តម្លៃកាត់គែមដាច់ដោយឡែកសម្រាប់ផ្ទាំងពិសេស',
    es: 'Valor de recorte individual para panel especial',
    ar: 'قيمة تشذيب فردية للوحة خاصة',
  },
  'arrangedPage.influenceTip.knifeDiameter': {
    zh: '下料刀',
    en: 'Knife diameter',
    id: 'Diameter pisau',
    kz: 'Кесуші қаттың диаметрі',
    th: 'เส้นผ่าศูนย์กลางของเครื่องตัด',
    ug: 'قىم قىمىتى',
    vi: 'Đường kính dao cắt',
    zh_tc: '下料刀',
    ru: 'Диаметр пилы',
    ko: '커터 지름',
    bur: 'ပန်းချိုးအလျား',
    ben: 'কেসার ব্যাস',
    tr: 'Kesici disk çapı',
    km: 'កាត់គែមកាត់គែម',
    es: 'Diámetro de la sierra',
    ar: 'قطر المنشار',
  },
  'arrangedPage.influenceTip.surplusNoFlip': {
    zh: '余料不翻板',
    en: 'Surplus material no flip',
    id: 'Sisa tidak dibalik',
    kz: 'Артық материал аудармалаусыз',
    th: 'วัสดุคงเหลือไม่พลิกแผ่น',
    ug: 'ئارتۇق ماتېرىيال ئۆرۈلمەسلىك',
    vi: 'Vật liệu dư không lật tấm',
    zh_tc: '餘料不翻板',
    ru: 'Остатки без переворота',
    ko: '잔재 미뒤집기',
    bur: 'ကျန်ရှိပစ္စည်းများ မလှန်ပါ',
    ben: 'অবশিষ্ট উপাদান উল্টানো হয় না',
    tr: 'Artık malzeme çevrilmez',
    km: 'សម្ភារៈសល់មិនត្រឡប់',
    es: 'Sin volteo de material sobrante',
    ar: 'لا قلب للمواد الفائضة',
  },
  'arrangedPage.influenceTip.surplusNotLayout': {
    zh: '余料大板不排指定板件',
    en: 'Surplus board not layout specified board',
    id: 'Papan sisa tidak diatur papan tertentu',
    kz: 'Артық тақтаның белгілі тақтасыз құрастыру',
    th: 'แผ่นคงเหลือไม่จัดวางตัวแผ่นที่ระบุ',
    ug: 'ئارتۇق تاختا ئۆرۈلمەسلىك قىلمىدىغان بىر قىلمىدىغان تاختا تېپىلمىدى',
    vi: 'Tấm dư không sắp xếp tấm được chỉ định',
    zh_tc: '餘料大板不排指定板件',
    ru: 'Остатки не размещаются на указанных пластинах',
    ko: '잔재 대판은 지정된 판재를 배치하지 않습니다',
    bur: 'ကျန်ရှိပစ္စည်းများ မလှန်ပါ',
    ben: 'অবশিষ্ট বোর্ড নির্দিষ্ট বোর্ড বিন্যাস করা হয় না',
    tr: 'Artık malzeme belirtilen panelleri yerleştirmez',
    km: 'សម្ភារៈសល់មិនត្រឡប់មិនបង្កើតកាត់គែមដាច់ដោយឡែក',
    es: 'Panel sobrante no se dispone en placas especificadas',
    ar: 'لا يتم تخطيط الوحات الفائضة للوحات المحددة',
  },
  'arrangedPage.influenceTip.plankEdgeOff': {
    zh: '修边',
    en: 'Trim',
    id: 'Potong tepi',
    kz: 'Шеттеу',
    th: 'ตัดขอบ',
    ug: 'گىرۋەك',
    vi: 'Cắt viền',
    zh_tc: '修邊',
    ru: 'Обрезка',
    ko: '마감',
    bur: 'အနားညှိတန်ဖိုး',
    ben: 'ট্রিম',
    tr: 'Kenar kesim',
    km: 'កាត់គែមដាច់ដោយឡែក',
    es: 'Recorte',
    ar: 'تشذيب',
  },
  'alginTexture.tip': {
    zh: '当前操作会清除板件对纹信息，请确认是否继续？',
    en: 'This operation will clear the texture alignment info, are you sure?',
    id: 'Operasi ini akan menghapus informasi penyelarasan tekstur papan. Apakah Anda yakin ingin melanjutkan?',
    kz: 'Бұл әрекет тақта кездестіру деректерін тазалайды, жалғастыруды растайсыз ба?',
    th: 'การดำเนินการนี้จะล้างข้อมูลการจัดแนวลายไม้ของแผ่น โปรดยืนยันว่าจะดำเนินการต่อหรือไม่?',
    ug: 'نۆۋەتتىكى مەشغۇلات تاختا تېكىستۇرا ماسلاشتۇرۇش ئۇچۇرىنى ئۆچۈرىدۇ، داۋاملاشتۇرۇشنى جەزملەشتۈرەمسىز؟',
    vi: 'Thao tác này sẽ xóa thông tin căn chỉnh vân gỗ của tấm ván. Bạn có chắc chắn muốn tiếp tục không?',
    zh_tc: '當前操作會清除板件對紋信息，請確認是否繼續？',
    ru: 'Эта операция удалит информацию о совмещении текстуры плиты. Подтвердите, хотите ли вы продолжить?',
    ko: '현재 작업은 판재의 텍스처 정렬 정보를 삭제합니다. 계속하시겠습니까?',
    bur: 'လက်ရှိလုပ်ဆောင်ချက်သည် ပေါ်ဒ်၏ အမျက်အသားညီညွတ်မှု အချက်အလက်ကို ဖျက်ပစ်မည်။ ဆက်လုပ်မည်လား အတည်ပြုပါ။',
    ben: 'এই কার্যকলাপটি বোর্ডের টেক্সচার অ্যালাইনমেন্ট তথ্য মুছে ফেলবে। আপনি কি চালিয়ে যেতে চান?',
    tr: 'Bu işlem parçanın doku hizalama bilgisini temizleyecektir. Devam etmek istediğinizi onaylıyor musunuz?',
    km: 'ប្រតិបត្តិការនេះនឹងលុបព័ត៌មានការតំរឹមលំនាំវាយនភាពរបស់បន្ទះ។ សូមបញ្ជាក់ថាតើចង់បន្តឬទេ?',
    es: 'Esta operación borrará la información de alineación de textura de la pieza. ¿Confirma que desea continuar?',
    ar: 'ستؤدي هذه العملية إلى مسح معلومات محاذاة نسيج اللوحة. يرجى تأكيد ما إذا كنت تريد المتابعة؟',
  },
  'alginTexture.tip2': {
    zh: '当前操作会影响板件间隙，导致加工问题，请确认是否继续？',
    en: 'This operation will affect the gap between the parts, causing processing problems, are you sure?',
    id: 'Operasi ini akan mempengaruhi celah antara bagian, menyebabkan masalah pemrosesan. Apakah Anda yakin ingin melanjutkan?',
    kz: 'Бұл әрекет тақталар арасындағы аралықты өзгертеді, өңдеу мәселелерін тудырады. Жалғастыруды растайсыз ба?',
    th: 'การดำเนินการนี้จะส่งผลกระทบต่อระยะห่างระหว่างแผ่น ทำให้เกิดปัญหาในการประมวลผล โปรดยืนยันว่าจะดำเนินการต่อหรือไม่?',
    ug: 'نۆۋەتتىكى مەشغۇلات ئارتۇقىنى ئۆزگەرتىدۇ، چوڭ ئورۇنلاشتۇرۇش قىلىش ئۇچۇرىنى ئۆچۈرىدۇ، داۋاملاشتۇرۇشنى جەزملەشتۈرەمسىز؟',
    vi: 'Thao tác này sẽ ảnh hưởng đến khoảng cách giữa các tấm ván, dẫn đến vấn đề trong quá trình gia công. Bạn có chắc chắn muốn tiếp tục không?',
    zh_tc: '當前操作會影響板件間距，導致加工問題，請確認是否繼續？',
    ru: 'Эта операция повлияет на расстояние между плитами, вызвав проблемы в обработке. Подтвердите, хотите ли вы продолжить?',
    ko: '현재 작업은 판재 간격을 변경하여 가공 문제를 발생시킵니다. 계속하시겠습니까?',
    bur: 'လက်ရှိလုပ်ဆောင်ချက်သည် ပေါ်ဒ်များကြားရှိ အနံ့ကို ပြောင်းလဲပေးပြီး အရင်းအမြစ်များကို ဖြစ်ပေါ်စေပါမည်။ ဆက်လုပ်မည်လား အတည်ပြုပါ။',
    ben: 'এই কার্যকলাপটি প্যানেলগুলির মধ্যে দূরত্ব পরিবর্তন করবে এবং প্রক্রিয়াজাত সমস্যা সৃষ্টি করবে। আপনি কি চালিয়ে যেতে চান?',
    tr: 'Bu işlem parçalar arasındaki mesafeyi değiştirecek ve işleme sorunlarına yol açacaktır. Devam etmek istediğinizi onaylıyor musunuz?',
    km: 'ប្រតិបត្តិការនេះនឹងប្រាកដិតិចម្ងាយរវាងបន្ទះ ដែលបង្ហាញលាខណៈសម្រាប់ការលើកឡើង។ សូមបញ្ជាក់ថាតើចង់បន្តឬទេ?',
    es: 'Esta operación afectará la distancia entre las piezas, causando problemas en el procesamiento. ¿Confirma que desea continuar?',
    ar: 'ستؤدي هذه العملية إلى تأثير المسافة بين الألواح ، مما يؤدي إلى مشاكل في التصنيع. يرجى تأكيد ما إذا كنت تريد المتابعة؟',
  },
  'alginTexture.group': {
    zh: '对纹组',
    en: 'Texture Group',
    id: 'Grup Teks',
    kz: 'Технологиялық топ',
    th: 'กลุ่มที่สัมพันธ์',
    ug: 'تەرتىپلەش گۇرۇپپا',
    vi: 'Nhóm vân gỗ',
    zh_tc: '對紋組',
    ru: 'Группа текстуры',
    ko: '텍스처 그룹',
    bur: 'အမျက်အသားညီညွတ်မှု အစု',
    ben: 'টেক্সচার গোরুপ',
    tr: 'Tekstür Grubu',
    km: 'ក្រុមសិក្សារភាព',
    es: 'Grupo de textura',
    ar: 'مجموعة النسيج',
  },
  'alginTexture.groupTemp': {
    zh: '对纹组一',
    en: 'Texture Group One',
    id: 'Grup Teks Satu',
    kz: 'Технологиялық топ бірінші',
    th: 'กลุ่มที่สัมพันธ์หนึ่ง',
    ug: 'تەرتىپلەش گۇرۇپپا بىرىنшى',
    vi: 'Nhóm vân gỗ một',
    zh_tc: '對紋組一',
    ru: 'Группа текстуры первая',
    ko: '텍스처 그룹 첫 번째',
    bur: 'အမျက်အသားညီညွတ်မှု အစု တစ်ခု',
    ben: 'টেক্সচার গোরুপ এক',
    tr: 'Tekstür Grubu Bir',
    km: 'ក្រុមសិក្សារភាពមួយ',
    es: 'Grupo de textura uno',
    ar: 'مجموعة النسيج واحدة',
  },
  'common.permissionTipExportDxf': {
    zh: '导出样式二孔槽图DXF',
    en: 'Export DXF Hole Slot Diagram',
    id: 'Ekspor Diagram Slot Lubang DXF',
    kz: 'DXF тесік слот диаграммасын экспорттау',
    th: 'ส่งออกแผนภาพช่องเจาะ DXF',
    ug: 'DXF تۆشۈك ئوقۇر دىئاگراممىسىنى چىقىرىش',
    vi: 'Xuất sơ đồ lỗ rãnh DXF',
    zh_tc: '導出樣式二孔槽圖DXF',
    ru: 'Экспорт схемы отверстий и пазов DXF',
    ko: 'DXF 홀 슬롯 다이어그램 내보내기',
    bur: 'DXF အပေါက် slot ပုံစံထုတ်ယူပါ',
    ben: 'DXF হোল স্লট ডায়াগ্রাম রপ্তানি',
    tr: 'DXF Delik Yuvası Diyagramını Dışa Aktar',
    km: 'នាំចេញដ្យាក្រាមប្រហោងឆ្អឹង DXF',
    es: 'Exportar diagrama de agujeros y ranuras DXF',
    ar: 'تصدير مخطط الثقوب والفتحات DXF',
  },
  'common.permissionTipSurplusRecycleBin': {
    zh: '余料回收站',
    en: 'Surplus Recycle Bin',
    id: 'Tempat Daur Ulang Sisa',
    kz: 'Қалдықтарды қайта өңдеу станциясы',
    th: 'ถังรีไซเคิลเศษวัสดุ',
    ug: 'قالدۇق ماتېرىيالنى يىغىۋېلىش پونكىتى',
    vi: 'Trạm tái chế vật thừa',
    zh_tc: '餘料回收站',
    ru: 'Станция переработки остатков',
    ko: '잔여 재료 재활용함',
    bur: 'ကြွင်းဆည်းပစ္စည်းပြန်လည်သုံးစွဲရေးစခန်း',
    ben: 'অবশিষ্ট উপাদান পুনর্ব্যবহার কেন্দ্র',
    tr: 'Artık Geri Dönüşüm Kutusu',
    km: 'ស្ថានីយ៍ប្រមូលផ្តុំសំណល់',
    es: 'Estación de reciclaje de sobras',
    ar: 'محطة إعادة تدوير المخلفات',
  },
  'common.permissionTipAdvancedNesting': {
    zh: '高级异形嵌套',
    en: 'Advanced Irregular Nesting',
    id: 'Penggabungan Tidak Beraturan Tingkat Lanjut',
    kz: 'Жетілдірілген бірегей ұяластыру',
    th: 'การซ้อนทับรูปทรงไม่สม่ำเสมอขั้นสูง',
    ug: 'يۇقىرى دەرىجىلىك غەيرىي شەكىللىك ئورۇنلاشتۇرۇش',
    vi: 'Lồng ghép hình dáng không đều nâng cao',
    zh_tc: '高級異形嵌套',
    ru: 'Продвинутое вложение неправильных форм',
    ko: '고급 불규칙 중첩',
    bur: 'အဆင့်မြင့်မညီသဏ္ဍာန်ထပ်တွက်ခြင်း',
    ben: 'উন্নত অনিয়মিত নেস্টিং',
    tr: 'Gelişmiş Düzensiz Yuvalama',
    km: 'ការរួមបញ្ចូលរូបរាងមិនទៀងទាត់កម្រិតខ្ពស់',
    es: 'Anidación irregular avanzada',
    ar: 'التداخل غير المنتظم المتقدم',
  },
  'common.permissionTipPanelGrainAlign': {
    zh: '板件对纹',
    en: 'Panel Grain Align',
    id: 'Penyelarasan Bijian Panel',
    kz: 'Тақта дәнін туралау',
    th: 'การจัดเรียงเสี้ยนแผ่น',
    ug: 'تاختا تالاسا تەكشۈرۈش',
    vi: 'Căn chỉnh thớ ván',
    zh_tc: '板件對紋',
    ru: 'Выравнивание волокон панели',
    ko: '판재 결 정렬',
    bur: 'ပေါ်ဒ်ဖွဲ့စည်းမှုတန်းညှပ်ခြင်း',
    ben: 'প্যানেল দানা সারিবদ্ধকরণ',
    tr: 'Panel Daneli Hizalama',
    km: 'តម្រឹមមុនពង្រីកផ្ទាំង',
    es: 'Alineación de grano del panel',
    ar: 'محاذاية خشب اللوحة',
  },
  'common.permissionSeparator': {
    zh: '、',
    en: ', ',
    id: ', ',
    kz: ', ',
    th: ', ',
    ug: ', ',
    vi: ', ',
    zh_tc: '、',
    ru: ', ',
    ko: ', ',
    bur: ', ',
    ben: ', ',
    tr: ', ',
    km: ', ',
    es: ', ',
    ar: ', ',
  },
  'common.missingPermissionTip': {
    zh: '缺少以下权限：{permissions}',
    en: 'Missing permissions: {permissions}',
    id: 'Izin berikut tidak tersedia: {permissions}',
    kz: 'Келесі рұқсаттар жоқ: {permissions}',
    th: 'ไม่มีสิทธิ์ดังต่อไปนี้: {permissions}',
    ug: 'تۆۋەندىكى ئىجازەتلەر كەمچىل: {permissions}',
    vi: 'Thiếu các quyền sau: {permissions}',
    zh_tc: '缺少以下權限：{permissions}',
    ru: 'Отсутствуют следующие разрешения: {permissions}',
    ko: '다음 권한이 없습니다: {permissions}',
    bur: 'အောက်ပါခွင့်များမရှိပါ: {permissions}',
    ben: 'নিম্নলিখিত অনুমতিগুলি অনুপস্থিত: {permissions}',
    tr: 'Şu izinler eksik: {permissions}',
    km: 'អវត្តមានសិទ្ធិដូចខាងក្រោម: {permissions}',
    es: 'Faltan los siguientes permisos: {permissions}',
    ar: 'الأذونات التالية مفقودة: {permissions}',
  },
  'alginTexture.textureAlignmentPlank': {
    zh: '对纹板件无法移动',
    en: 'Cannot move texture alignment plank',
    id: 'Tidak dapat memindahkan plang perataan tekstur',
    kz: 'Текстурасы теңестірілген тақтаны жылжыту мүмкін емес',
    th: 'ไม่สามารถย้ายแผ่นจัดเรียงลายผิวได้',
    ug: 'تېكستۇرا تەكشىلىكى تاختاينى يۆتكىگىلى بولمايدۇ',
    vi: 'Không thể di chuyển ván căn chỉnh vân',
    zh_tc: '對紋板件無法移動',
    ru: 'Невозможно переместить панель выравнивания текстуры',
    ko: '무늬 정렬 판재를 이동할 수 없습니다',
    bur: 'အရောင်ရင်းညှိပြားကို ရွှေ့၍ မရပါ',
    ben: 'টেক্সচার অ্যালাইনমেন্ট প্যানেল সরানো যাচ্ছে না',
    tr: 'Doku hizalama paneli taşınamaz',
    km: 'មិនអាចផ្លាស់ទីស្បែកតម្រឹមបានទេ',
    es: 'No se puede mover el panel de alineación de textura',
    ar: 'لا يمكن نقل لوحة محاذاة النسيج',
  },
  'customizeFolder.customizeFolder': {
    zh: '文件夹自定义',
    en: 'Folder Customization',
    id: 'Kustomisasi Folder',
    kz: 'Қаптамады баптау',
    th: 'การปรับแต่งโฟลเดอร์',
    ug: 'قىسقۇچنى ئۆزگەرتىش',
    vi: 'Tùy chỉnh thư mục',
    zh_tc: '文件夾自定義',
    ru: 'Настройка папки',
    ko: '폴더 사용자 정의',
    bur: 'ဖိုင်ဆောင်ကို စိတ်ကြိုက်ပြုလုပ်မည်',
    ben: 'ফোল্ডার কাস্টমাইজেশন',
    tr: 'Klasör Özelleştirme',
    km: 'ការកែសម្រួលថត',
    es: 'Personalización de carpeta',
    ar: 'تخصيص المجلد',
  },
  'customizeFolder.customizeFolderTip': {
    zh: '注意：开启文件夹自定义后，之前设置的分文件夹规则将不再生效',
    en: 'Note: After enabling folder customization, the previously set folder division rules will no longer take effect',
    id: 'Catatan: Setelah mengaktifkan kustomisasi folder, aturan pembagian folder yang diatur sebelumnya tidak akan berlaku lagi',
    kz: 'Ескерту: Қаптамаларды баптауды қосуғаннан кейін, бұрын орнатылған қаптамалар бөлінуы ережелері басылымын жоғалтады',
    th: 'หมายเหตุ: หลังจากเปิดการปรับแต่งโฟลเดอร์ กฎการแบ่งโฟลเดอร์ที่ตั้งไว้ก่อนหน้านี้จะไม่เป็นผลที่ได้',
    ug: 'ئەسكەرتىش: قىسقۇچنى ئۆزگەرتىشنى قوزغىتكەندىن кейін، بۇرۇنلىق بەلگىلەنگەن قىسقۇچ بەلگىلىمىلىرى ئەركىنلىك قىلمىغان',
    vi: 'Lưu ý: Sau khi bật tùy chỉnh thư mục, các quy tắc phân thư mục được thiết lập trước đó sẽ không còn hiệu lực',
    zh_tc: '注意：開啟文件夾自定義後，之前設定的分文件夾規則將不再生效',
    ru: 'Примечание: После включения настройки папки, ранее установленные правила разделения папок перестанут действовать',
    ko: '참고: 폴더 사용자 정의를 활성화한 후 이전에 설정된 폴더 분할 규칙이 더 이상 적용되지 않습니다',
    bur: 'သတိပြုပါ-ဖိုင်ဆောင်ကို စိတ်ကြိုက်ပြုလုပ်ပြီးနောက် ယခင်ကသတ်မှတ်ထားသည့်ဖိုင်ဆောင်ခွဲခြားမှုစည်းမျဉ်းများသည် ပါဝင်မည်မဟုတ်ပါ',
    ben: 'নোট: ফোল্ডার কাস্টমাইজেশন সক্রিয় করার পর, আগে সেট করা ফোল্ডার বিভাজন নিয়মগুলো আর কার্যকর হবে না',
    tr: 'Not: Klasör özelleştirmesini etkinleştirdikten sonra, daha önce ayarlanan klasör bölme kuralları artık geçerli olmayacaktır',
    km: 'ចំណាំ៖ បន្ទាប់ពីបើកការកែសម្រួលថត តម្រូវការបែងចែកថតដែលបានកំណត់ពីមុននឹងមិនមានប្រសិទ្ធិភាពទៀតទេ',
    es: 'Nota: Después de activar la personalización de la carpeta, las reglas de división de carpetas establecidas anteriormente ya no tendrán efecto',
    ar: 'ملاحظة: بعد تمكين التخصيص المجلدي، لن يعمل القواعد السابقة لتقسيم المجلدات',
  },
  'customizeFolder.processingFilesTitle': {
    zh: '加工文件数据',
    en: 'Processing file data',
    id: 'Memproses data file',
    kz: 'Файлдардың деректерін өңдеу',
    th: 'ประมวลผลข้อมูลไฟล์',
    ug: 'ھۆججەت سانلىق مەلۇماتنى ئىşلىۋېتىش',
    vi: 'Xử lý dữ liệu tệp',
    zh_tc: '加工文件數據',
    ru: 'Обработка данных файла',
    ko: '파일 데이터 처리',
    bur: 'ဖိုင်ဒေတာကိုအလုပ်လုပ်သည်',
    ben: 'ফাইল ডেটা প্রসেসিং',
    tr: 'Dosya verilerini işleme',
    km: 'ដំណើរការទិន្នន័យឯកសារ',
    es: 'Procesamiento de datos de archivo',
    ar: 'معالجة البيانات الملفية',
  },
  'customizeFolder.dragToFolderTip': {
    zh: '可拖拽到左侧文件夹中作为子文件夹或文件',
    en: 'Can be dragged to the left folder as a subfolder or file',
    id: 'Bisa diseret ke folder kiri sebagai subfolder atau file',
    kz: 'Сол жақ қаптамаға көрілек немесе файл ретінде көтеруге болады',
    th: 'สามารถลากไปยังโฟลเดอร์ด้านซ้ายเป็นโฟลเดอร์ย่อยหรือไฟล์',
    ug: 'سول تەرەپتىكى قىسقۇچقا ئاپتۇق قىسقۇچ ياكى ھۆججەت ретىدا سۈيرىشكە بولىدۇ',
    vi: 'Có thể kéo vào thư mục bên trái làm thư mục con hoặc tệp',
    zh_tc: '可拖拽到左側文件夾中作為子文件夾或文件',
    ru: 'Можно перетащить в левую папку как подпапку или файл',
    ko: '왼쪽 폴더로 드래그하여 하위 폴더 또는 파일로 만들 수 있습니다',
    bur: 'ဘယ်ဘက်ရှိဖိုင်ဆောင်သို့ဆွဲပြီးဆွဲတင်ခြင်းဖြင့် subfolder သို့မဟုတ် file အဖြစ်သတ်မှတ်နိုင်သည်',
    ben: 'বাম ফোল্ডারে সাবফোল্ডার বা ফাইল হিসেবে টেনে নিয়ে যাওয়া যেতে পারে',
    tr: 'Sol klasöre alt klasör veya dosya olarak sürüklenebilir',
    km: 'អាចអូសទៅថតខាងឆ្វេងជាថតរង ឬឯកសារ',
    es: 'Puede arrastrarse a la carpeta izquierda como subcarpeta o archivo',
    ar: 'يمكن سحبه إلى المجلد الأيسر كمجلد فرعي أو ملف',
  },
  'customizeFolder.folderNameEmpty': {
    zh: '文件夹名称不能为空',
    en: 'Folder name cannot be empty',
    id: 'Nama folder tidak boleh kosong',
    kz: 'Қаптаmanın атауы бос болмауы керек',
    th: 'ชื่อโฟลเดอร์ไม่สามารถว่างเปล่าได้',
    ug: 'قىسقۇچ ئاتى بос بولمايدۇ',
    vi: 'Tên thư mục không được để trống',
    zh_tc: '文件夾名稱不能為空',
    ru: 'Имя папки не может быть пустым',
    ko: '폴더 이름은 비워둘 수 없습니다',
    bur: 'ဖိုင်ဆောင်အမည်က ცარიနေခြင်းမရနိုင်ပါ',
    ben: 'ফোল্ডারের নাম ফাঁকা রাখা যাবে না',
    tr: 'Klasör adı boş olamaz',
    km: 'ឈ្មោះថតមិនអាចទទេ为空',
    es: 'El nombre de la carpeta no puede estar vacío',
    ar: 'اسم المجلد لا يمكن أن يكون فارغ',
  },
  'customizeFolder.folderNameExists': {
    zh: '存在同名文件夹',
    en: 'Folder with the same name exists',
    id: 'Folder dengan nama yang sama sudah ada',
    kz: 'Ол边塞 атауы бар қаптама бар',
    th: 'มีโฟลเดอร์ชื่อเดียวกัน',
    ug: 'ئوخشاش ئاتتىكى قىسقۇچ بار',
    vi: 'Thư mục cùng tên đã tồn tại',
    zh_tc: '存在同名文件夾',
    ru: 'Существует папка с таким же именем',
    ko: '동일한 이름의 폴더가 존재합니다',
    bur: 'တူညီသောအမည်ရှိသည့်ဖိုင်ဆောင်ရှိသည်',
    ben: 'একই নামের ফোল্ডার বিদ্যমান',
    tr: 'Aynı ada sahip bir klasör var',
    km: 'មានថតដែលមានឈ្មោះដូចគ្នា',
    es: 'Existe una carpeta con el mismo nombre',
    ar: 'يوجد مجلد بنفس الاسم',
  },
  'customizeFolder.fileNotFound': {
    zh: '未能获取到正确的文件',
    en: 'Failed to get the correct file',
    id: 'Gagal mendapatkan file yang benar',
    kz: 'Дұрыс файлды алу сәтсіз болды',
    th: 'ไม่สามารถรับไฟล์ที่ถูกต้อง',
    ug: 'دۇرست ھۆججەتلىرىنى ئېلىش مەغلۇپ بولدى',
    vi: 'Không thể lấy được tệp đúng',
    zh_tc: '未能獲取到正確的文件',
    ru: 'Не удалось получить правильный файл',
    ko: '올바른 파일을 가져오지 못했습니다',
    bur: 'မှန်ကန်သောဖိုင်ကိုရယူရန်မအောင်မြင်ပါ',
    ben: 'সঠিক ফাইল প্রাপ্ত করতে ব্যর্থ',
    tr: 'Doğru dosya alınamadı',
    km: 'មិនអាចទទួលបានឯកសារត្រឹមត្រូវ',
    es: 'No se pudo obtener el archivo correcto',
    ar: 'فشل في الحصول على الملف الصحيح',
  },
  'customizeFolder.fileCannotBeClassified': {
    zh: '该类型文件不能放在任何分类文件夹下',
    en: 'This type of file cannot be placed under any classification folder',
    id: 'Jenis file ini tidak dapat ditempatkan di bawah folder klasifikasi apa pun',
    kz: 'Бұл типтік файлдар ешқандай классификация қаптамалары астында орналасуы мүмкін емес',
    th: 'ประเภทไฟล์นี้ไม่สามารถวางไว้ภายใต้โฟลเดอร์หมวดหมู่ใด ๆ',
    ug: 'بۇ تىپتىكى ھۆججەت ھەرhangi بىر كاتىگورىيە قىسقۇچى астىغا قويغىلى بولمايدۇ',
    vi: 'Loại tệp này không thể đặt dưới bất kỳ thư mục phân loại nào',
    zh_tc: '該類型文件不能放在任何分類文件夾下',
    ru: 'Этот тип файла не может быть помещен в любую категоризационную папку',
    ko: '이 유형의 파일은 어떤 분류 폴더에도 배치할 수 없습니다',
    bur: 'ဤအမျိုးအစားဖိုင်ကို အမျိုးအစားခွဲထားသည့်ဖိုင်ဆောင်တစ်ခုစီအောက်တွင်ထားရန်မရနိုင်ပါ',
    ben: 'এই ধরনের ফাইলটি কোনো শ্রেণীবিভাগ ফোল্ডারের নীচে রাখা যায় না',
    tr: 'Bu dosya türü herhangi bir sınıflandırma klasörü altında yerleştirilemez',
    km: 'ប្រភេទឯកសារនេះមិនអាចដាក់ក្រោមថតចំណាត់ថ្នាក់ណាមួយ',
    es: 'Este tipo de archivo no puede colocarse en ningún carpeta de clasificación',
    ar: 'هذا النوع من الملفات لا يمكن وضعه في أي مجلد تصنيف',
  },
  'customizeFolder.cannotAddAtThisPosition': {
    zh: '不可添加在此位置',
    en: 'Cannot add at this position',
    id: 'Tidak dapat menambahkan di posisi ini',
    kz: 'Бұл орналасу жерінде қосуға болмайды',
    th: 'ไม่สามารถเพิ่มในตำแหน่งนี้',
    ug: 'بۇ ئورنىدا قوشقان بولمايدۇ',
    vi: 'Không thể thêm vào vị trí này',
    zh_tc: '不可添加在此位置',
    ru: 'Невозможно добавить в это место',
    ko: '이 위치에 추가할 수 없습니다',
    bur: 'ဒီနေရာတွင်ထည့်ရန်မရနိုင်ပါ',
    ben: 'এই অবস্থানে যোগ করা যায় না',
    tr: 'Bu konuma ekleyemezsiniz',
    km: 'មិនអាចបន្ថែមនៅទីតាំងនេះ',
    es: 'No se puede agregar en esta posición',
    ar: 'لا يمكن إضافة في هذا الموضع',
  },
  'customizeFolder.fileAlreadyExists': {
    zh: '【{name}】在此文件夹中已存在',
    en: '【{name}】already exists in this folder',
    id: '【{name}】sudah ada di folder ini',
    kz: '【{name}】бұл қаптамada бұрыннан бар',
    th: '【{name}】มีอยู่ในโฟลเดอร์นี้แล้ว',
    ug: '【{name}】بۇ قىسقۇچتا ئەلєردе بار',
    vi: '【{name}】đã tồn tại trong thư mục này',
    zh_tc: '【{name}】在此文件夾中已存在',
    ru: '【{name}】уже существует в этой папке',
    ko: '【{name}】이 폴더에 이미 존재합니다',
    bur: '【{name}】သည်ဤဖိုင်ဆောင်၌ရှိပြီးဖြစ်သည်',
    ben: '【{name}】এই ফোল্ডারে ইতিমধ্যে বিদ্যমান',
    tr: '【{name}】bu klasörde zaten var',
    km: '【{name}】មានស្រាប់នៅក្នុងថតនេះ',
    es: '【{name}】ya existe en esta carpeta',
    ar: '【{name}】يوجد بالفعل في هذا المجلد',
  },
  'customizeFolder.confirmDeleteFolder': {
    zh: '是否确定删除该文件夹？',
    en: 'Are you sure you want to delete this folder?',
    id: 'Apakah Anda yakin ingin menghapus folder ini?',
    kz: 'Бұл қаптаманы жоюға сенімдісіз бе?',
    th: 'คุณแน่ใจหรือไม่ว่าต้องการลบโฟลเดอร์นี้?',
    ug: 'بۇ قىسقۇچنى ئۆچۈرۈشكە مىڭبارمۇ?',
    vi: 'Bạn có chắc chắn muốn xóa thư mục này không?',
    zh_tc: '是否確定刪除該文件夾？',
    ru: 'Вы уверены, что хотите удалить эту папку?',
    ko: '이 폴더를 삭제하시겠습니까?',
    bur: 'ဤဖိုင်ဆောင်ကိုဖျက်ရန်သေချာပါသလား?',
    ben: 'আপনি কি এই ফোল্ডারটি মুছতে চান?',
    tr: 'Bu klasörü silmek istediğinizden emin misiniz?',
    km: 'តើអ្នកប្រាកដថាចង់លុបថតនេះទេ?',
    es: '¿Está seguro de querer eliminar esta carpeta?',
    ar: 'هل أنت متأكد من أنك تريد حذف هذا المجلد؟',
  },
  'customizeFolder.confirmDeleteItem': {
    zh: '是否确定删除【{name}】？',
    en: 'Are you sure you want to delete 【{name}】?',
    id: 'Apakah Anda yakin ingin menghapus 【{name}】?',
    kz: '【{name}】-ды жоюға сенімдісіз бе?',
    th: 'คุณแน่ใจหรือไม่ว่าต้องการลบ【{name}】?',
    ug: '【{name}】نى ئۆچۈرۈشكە مىڭبارمۇ?',
    vi: 'Bạn có chắc chắn muốn xóa 【{name}】 không?',
    zh_tc: '是否確定刪除【{name}】？',
    ru: 'Вы уверены, что хотите удалить 【{name}】?',
    ko: '【{name}】을 삭제하시겠습니까?',
    bur: '【{name}】ကိုဖျက်ရန်သေချာပါသလား?',
    ben: 'আপনি কি 【{name}】 মুছতে চান?',
    tr: '【{name}】 silmek istediğinizden emin misiniz?',
    km: 'តើអ្នកប្រាកដថាចង់លុប【{name}】ទេ?',
    es: '¿Está seguro de querer eliminar 【{name}】?',
    ar: 'هل أنت متأكد من أنك تريد حذف 【{name}】؟',
  },
  'customizeFolder.confirmDeleteFolderWithChildren': {
    zh: '此文件夹下存在其他文件夹/文件，是否确定删除？',
    en: 'There are other folders/files under this folder, are you sure you want to delete it?',
    id: 'Ada folder/file lain di bawah folder ini, apakah Anda yakin ingin menghapusnya?',
    kz: 'Бұл қаптаманың астында басқа қаптамалар/файлдар бар, оны жоюға сенімдісіз бе?',
    th: 'มีโฟลเดอร์/ไฟล์อื่น ๆ ภายใต้โฟลเดอร์นี้ คุณแน่ใจหรือไม่ว่าต้องการลบ',
    ug: 'بۇ قىسقۇچنىڭ астында башқа قىسقۇچلار/ھۆججەتلەر بار، ئۇنى ئۆچۈرۈشكە مىڭبارمۇ?',
    vi: 'Có các thư mục/tệp khác dưới thư mục này, bạn có chắc chắn muốn xóa nó không?',
    zh_tc: '此文件夾下存在其他文件夾/文件，是否確定刪除？',
    ru: 'Под этой папкой есть другие папки/файлы, вы уверены, что хотите удалить ее?',
    ko: '이 폴더 아래에 다른 폴더/파일이 있습니다. 삭제하시겠습니까?',
    bur: 'ဤဖိုင်ဆောင်အောက်တွင် အခြားဖိုင်ဆောင်များ/ဖိုင်များရှိသည်၊ ၎င်းကိုဖျက်ရန်သေချာပါသလား?',
    ben: 'এই ফোল্ডারের নীচে অন্যান্য ফোল্ডার/ফাইল আছে, আপনি কি এটি মুছতে চান?',
    tr: 'Bu klasörün altında başka klasörler/dosyalar var, silmek istediğinizden emin misiniz?',
    km: 'មានថត/ឯកសារផ្សេងទៀតនៅក្រោមថតនេះ តើអ្នកប្រាកដថាចង់លុបវាទេ?',
    es: 'Hay otras carpetas/archivos bajo esta carpeta, ¿está seguro de querer eliminarlos?',
    ar: 'هناك مجلدات/ملفات أخرى تحت هذا المجلد، هل أنت متأكد من أنك تريد حذفها؟',
  },
  'customizeFolder.deleteFile': {
    zh: '删除文件',
    en: 'Delete file',
    id: 'Hapus file',
    kz: 'Файлды жою',
    th: 'ลบไฟล์',
    ug: 'ھۆججەت ئۆچۈرۈش',
    vi: 'Xóa tệp',
    zh_tc: '刪除文件',
    ru: 'Удалить файл',
    ko: '파일 삭제',
    bur: 'ဖိုင်ဖျက်ပါ',
    ben: 'ফাইল মুছুন',
    tr: 'Dosya sil',
    km: 'លុបឯកសារ',
    es: 'Eliminar archivo',
    ar: 'حذف الملف',
  },
  'customizeFolder.addSubFolder': {
    zh: '添加子文件夹',
    en: 'Add subfolder',
    id: 'Tambahkan subfolder',
    kz: 'Қол қаптама қосу',
    th: 'เพิ่มโฟลเดอร์ย่อย',
    ug: 'ئاپتۇق قىسقۇچ قوشۇش',
    vi: 'Thêm thư mục con',
    zh_tc: '添加子文件夾',
    ru: 'Добавить подпапку',
    ko: '하위 폴더 추가',
    bur: 'ဖိုင်ဆောင်ခွဲထည့်ပါ',
    ben: 'সাবফোল্ডার যোগ করুন',
    tr: 'Alt klasör ekle',
    km: 'បន្ថែមថតរង',
    es: 'Agregar subcarpeta',
    ar: 'إضافة مجلد فرعي',
  },
  'customizeFolder.editFolder': {
    zh: '编辑文件夹',
    en: 'Edit folder',
    id: 'Edit folder',
    kz: 'Қаптаманы өңдеу',
    th: 'แก้ไขโฟลเดอร์',
    ug: 'قىسقۇچنى ئۆزگەرتىش',
    vi: 'Chỉnh sửa thư mục',
    zh_tc: '編輯文件夾',
    ru: 'Редактировать папку',
    ko: '폴더 편집',
    bur: 'ဖိုင်ဆောင်ကိုတည်းဖြတ်ပါ',
    ben: 'ফোল্ডার সম্পাদনা করুন',
    tr: 'Klasörü düzenle',
    km: 'កែសម្រួលថត',
    es: 'Editar carpeta',
    ar: 'تحرير المجلد',
  },
  'customizeFolder.deleteFolder': {
    zh: '删除文件夹',
    en: 'Delete folder',
    id: 'Hapus folder',
    kz: 'Қаптаманы жою',
    th: 'ลบโฟลเดอร์',
    ug: 'قىسقۇچ ئۆچۈرۈش',
    vi: 'Xóa thư mục',
    zh_tc: '刪除文件夾',
    ru: 'Удалить папку',
    ko: '폴더 삭제',
    bur: 'ဖိုင်ဆောင်ဖျက်ပါ',
    ben: 'ফোল্ডার মুছুন',
    tr: 'Klasörü sil',
    km: 'លុបថត',
    es: 'Eliminar carpeta',
    ar: 'حذف المجلد',
  },
  'customizeFolder.rootCannotDelete': {
    zh: '根目录无法被删除',
    en: 'Root directory cannot be deleted',
    id: 'Direktori root tidak dapat dihapus',
    kz: 'Коренеу каталогы жойыла алмайды',
    th: 'ไดเรกทอรีรูทไม่สามารถลบได้',
    ug: 'جەدۇدىي قىسقۇچ ئۆچۈرۈلەلمەيدۇ',
    vi: 'Thư mục gốc không thể xóa',
    zh_tc: '根目錄無法被刪除',
    ru: 'Корневой каталог не может быть удален',
    ko: '루트 디렉토리는 삭제할 수 없습니다',
    bur: 'အမြစ်ဒါရိုက်တိုရီကိုဖျက်ဆီးရန်မရနိုင်ပါ',
    ben: 'রুট ডিরেক্টরি মুছে ফেলা যায় না',
    tr: 'Kök dizini silinemez',
    km: 'ថតအမြစ်မអាចលុបបាន',
    es: 'El directorio raíz no se puede eliminar',
    ar: 'لا يمكن حذف الدليل الجذري',
  },
  'customizeFolder.newFolder': {
    zh: '新建文件夹',
    en: 'New folder',
    id: 'Folder baru',
    kz: 'Жаңа қаптама',
    th: 'โฟลเดอร์ใหม่',
    ug: 'يېڭى قىسقۇچ',
    vi: 'Thư mục mới',
    zh_tc: '新建文件夾',
    ru: 'Новая папка',
    ko: '새 폴더',
    bur: 'ဖိုင်ဆောင်အသစ်',
    ben: 'নতুন ফোল্ডার',
    tr: 'Yeni klasör',
    km: 'ថតថ្មី',
    es: 'Carpeta nueva',
    ar: 'مجلد جديد',
  },
  'customizeFolder.fileUsedCanDrag': {
    zh: '已使用 - 可重复拖拽',
    en: 'Used - Can be dragged repeatedly',
    id: 'Digunakan - Bisa diseret berulang kali',
    kz: 'Қолданылған - Кейін-жайысы көтеруге болады',
    th: 'ใช้แล้ว - สามารถลากซ้ำได้',
    ug: 'ئىشلىتىلغان - قайтала ئاپتۇrukە بولىدۇ',
    vi: 'Đã sử dụng - Có thể kéo lặp lại',
    zh_tc: '已使用 - 可重複拖拽',
    ru: 'Использовано - Можно перетаскивать многократно',
    ko: '사용됨 - 반복해서 드래그할 수 있음',
    bur: 'အသုံးပြုပြီး - ထပ်ခါထပ်ခါဆွဲပနိုင်သည်',
    ben: 'ব্যবহার করা হয়েছে - বারবার টেনে নিয়ে যাওয়া যেতে পারে',
    tr: 'Kullanıldı - Tekrar tekrar sürüklenebilir',
    km: 'បានប្រើប្រាស់ - អាចអូសច្រើនដង',
    es: 'Usado - Puede ser arrastrado repetidamente',
    ar: 'مستخدم - يمكن سحبه مرات متعددة',
  },
  'customizeFolder.fileDraggable': {
    zh: '可拖拽',
    en: 'Draggable',
    id: 'Bisa diseret',
    kz: 'Көтеруге болады',
    th: 'สามารถลากได้',
    ug: 'سۈيرىشكە بولىدۇ',
    vi: 'Có thể kéo',
    zh_tc: '可拖拽',
    ru: 'Перетаскиваемый',
    ko: '드래그 가능',
    bur: 'ဆွဲတင်နိုင်သည်',
    ben: 'টেনে নিতে পারে',
    tr: 'Sürüklenebilir',
    km: 'អាចអូស',
    es: 'Arrastrable',
    ar: 'قابل للسحب',
  },
  'customizeFolder.addFileToFolder': {
    zh: '将 【{fileName}】 添加到 {folderName}',
    en: 'Add 【{fileName}】 to {folderName}',
    id: 'Tambahkan 【{fileName}】 ke {folderName}',
    kz: '【{fileName}】-ды {folderName}-ға қосу',
    th: 'เพิ่ม 【{fileName}】 ไปยัง {folderName}',
    ug: '【{fileName}】نى {folderName} گە قوشۇش',
    vi: 'Thêm 【{fileName}】 vào {folderName}',
    zh_tc: '將 【{fileName}】 添加到 {folderName}',
    ru: 'Добавить 【{fileName}】 в {folderName}',
    ko: '【{fileName}】을 {folderName}에 추가',
    bur: '【{fileName}】 ကို {folderName} သို့ထည့်ပါ',
    ben: '【{fileName}】কে {folderName} এ যোগ করুন',
    tr: '【{fileName}】 {folderName} ekle',
    km: 'បន្ថែម 【{fileName}】 ទៅ {folderName}',
    es: 'Agregar 【{fileName}】 a {folderName}',
    ar: 'إضافة 【{fileName}】 إلى {folderName}',
  },
  'customizeFolder.addFolderTitle': {
    zh: '添加文件夹',
    en: 'Add folder',
    id: 'Tambahkan folder',
    kz: 'Қаптама қосу',
    th: 'เพิ่มโฟลเดอร์',
    ug: 'قىسقۇچ قوشۇش',
    vi: 'Thêm thư mục',
    zh_tc: '添加文件夾',
    ru: 'Добавить папку',
    ko: '폴더 추가',
    bur: 'ဖိုင်ဆောင်ထည့်ပါ',
    ben: 'ফোল্ডার যোগ করুন',
    tr: 'Klasör ekle',
    km: 'បន្ថែមថត',
    es: 'Agregar carpeta',
    ar: 'إضافة مجلد',
  },
  'customizeFolder.editFolderTitle': {
    zh: '编辑文件夹',
    en: 'Edit folder',
    id: 'Edit folder',
    kz: 'Қаптаманы өңдеу',
    th: 'แก้ไขโฟลเดอร์',
    ug: 'قىسقۇچنى ئۆزگەرتىش',
    vi: 'Chỉnh sửa thư mục',
    zh_tc: '編輯文件夾',
    ru: 'Редактировать папку',
    ko: '폴더 편집',
    bur: 'ဖိုင်ဆောင်ကိုတည်းဖြတ်ပါ',
    ben: 'ফোল্ডার সম্পাদনা করুন',
    tr: 'Klasörü düzenle',
    km: 'កែសម្រួលថត',
    es: 'Editar carpeta',
    ar: 'تحرير المجلد',
  },
  'customizeFolder.folderNameLabel': {
    zh: '文件夹名称',
    en: 'Folder name',
    id: 'Nama folder',
    kz: 'Қаптаmanın атауы',
    th: 'ชื่อโฟลเดอร์',
    ug: 'قىسقۇچ ئاتى',
    vi: 'Tên thư mục',
    zh_tc: '文件夾名稱',
    ru: 'Имя папки',
    ko: '폴더 이름',
    bur: 'ဖိုင်ဆောင်အမည်',
    ben: 'ফোল্ডারের নাম',
    tr: 'Klasör adı',
    km: 'ឈ្មោះថត',
    es: 'Nombre de la carpeta',
    ar: 'اسم المجلد',
  },
  'customizeFolder.folderNamePlaceholder': {
    zh: '请输入文件夹名称',
    en: 'Please enter folder name',
    id: 'Silakan masukkan nama folder',
    kz: 'Қаптаmanın атауын енгізіңіз',
    th: 'โปรดป้อนชื่อโฟลเดอร์',
    ug: 'قىسقۇچ ئاتىنى كىرگۈزۈڭ',
    vi: 'Vui lòng nhập tên thư mục',
    zh_tc: '請輸入文件夾名稱',
    ru: 'Пожалуйста, введите имя папки',
    ko: '폴더 이름을 입력하세요',
    bur: 'ဖိုင်ဆောင်အမည်ကိုထည့်ပါ',
    ben: 'ফোল্ডারের নাম লিখুন',
    tr: 'Lütfen klasör adını girin',
    km: 'សូមបញ្ចូលឈ្មោះថត',
    es: 'Por favor, introduzca el nombre de la carpeta',
    ar: 'الرجاء إدخال اسم المجلد',
  },
  'customizeFolder.sequenceStartLabel': {
    zh: '递增序号起始值',
    en: 'Incremental sequence start value',
    id: 'Nilai awal urutan bertambah',
    kz: 'Жуылу секвенциясының бастау мәні',
    th: 'ค่าตั้งต้นของลำดับเพิ่ม',
    ug: 'تۇزۈڭىش كىتابلۇق باشلانغان دىئە',
    vi: 'Giá trị bắt đầu của dãy tăng',
    zh_tc: '遞增序號起始值',
    ru: 'Начальное значение последовательного увеличения',
    ko: '증분 시퀀스 시작 값',
    bur: 'တိုးလာသော序号စတင်တန်ဖိုး',
    ben: 'বর্ধমান ক্রম শুরুর মান',
    tr: 'Artan dizi başlangıç ​​değeri',
    km: 'តម្លៃចាប់ផ្តើមលំដាប់បង្កើន',
    es: 'Valor inicial de secuencia incremental',
    ar: 'قيمة البدء للتسلسل الزائد',
  },
  'customizeFolder.classifyMethodLabel': {
    zh: '分类方式',
    en: 'Classification method',
    id: 'Metode klasifikasi',
    kz: 'Классификация әдісі',
    th: 'วิธีการจำแนก',
    ug: 'كاتىگورىيەلىش ھەرىكىتى',
    vi: 'Phương pháp phân loại',
    zh_tc: '分類方式',
    ru: 'Метод классификации',
    ko: '분류 방법',
    bur: 'ခွဲခြားနည်းလမ်း',
    ben: 'শ্রেণীবিভাগ পদ্ধতি',
    tr: 'Sınıflandırma yöntemi',
    km: 'វិធីសាស្ត្រចំណាត់ថ្នាក់',
    es: 'Método de clasificación',
    ar: 'طريقة التصنيف',
  },
  'customizeFolder.nameLengthLimitLabel': {
    zh: '字符长度限制',
    en: 'Character length limit',
    id: 'Batas panjang karakter',
    kz: 'Символдар ұзындығы սауырымы',
    th: 'ขีด จำกัดความยาวตัวอักษร',
    ug: 'ھەرپلىرىڭ ұзынلىقى چەكلىك',
    vi: 'Giới hạn độ dài ký tự',
    zh_tc: '字符長度限制',
    ru: 'Ограничение длины символов',
    ko: '문자 길이 제한',
    bur: 'အက္ခရာအရှည်ကန့်သတ်ချက်',
    ben: 'ক্যারেক্টার দৈর্ঘ্য সীমা',
    tr: 'Karakter uzunluğu sınırı',
    km: 'កម្រិតកំណត់ប្រវែងអក្សរ',
    es: 'Límite de longitud de caracteres',
    ar: 'حد الطول الحرفي',
  },
  'customizeFolder.tagInsertTip': {
    zh: '点击标签可插入到文件夹名称中',
    en: 'Click the tag to insert into the folder name',
    id: 'Klik tag untuk memasukkan ke nama folder',
    kz: 'Қаптаmanın атауына кирүү үшін теги басыңыз',
    th: 'คลิกแท็กเพื่อแทรกลงในชื่อโฟลเดอร์',
    ug: 'قىسقۇچ ئاتىга كىرگۈزۈش ئۈچۈن بېلگىنى چېكىڭ',
    vi: 'Nhấp vào thẻ để chèn vào tên thư mục',
    zh_tc: '點擊標籤可插入到文件夾名稱中',
    ru: 'Нажмите на тег, чтобы вставить его в имя папки',
    ko: '태그를 클릭하여 폴더 이름에 삽입하세요',
    bur: 'ဖိုင်ဆောင်အမည်ထဲသို့ထည့်ရန် tag ကိုနှိပ်ပါ',
    ben: 'ফোল্ডারের নামে প্রবেশ করার জন্য ট্যাগটি ক্লিক করুন',
    tr: 'Klasör adına eklemek için etiketi tıklayın',
    km: 'ចុចស្លាក ដើម្បីបញ្ចូលទៅក្នុងឈ្មោះថត',
    es: 'Haga clic en la etiqueta para insertar en el nombre de la carpeta',
    ar: 'اضغط على العلامة لإدخالها في اسم المجلد',
  },
  'customizeFolder.classifyTagInsertTip': {
    zh: '点击标签可插入到文件夹名称中，文件将按照指定标签进行分类',
    en: 'Click the tag to insert into the folder name, files will be classified according to the specified tag',
    id: 'Klik tag untuk memasukkan ke nama folder, file akan diklasifikasikan sesuai tag yang ditentukan',
    kz: 'Қаптаmanın атауына кирүү үшін теги басыңыз, файлдар бекітілген тег бойынша классифицируется',
    th: 'คลิกแท็กเพื่อแทรกลงในชื่อโฟลเดอร์ ไฟล์จะถูกจำแนกตามแท็กที่ระบุ',
    ug: 'قىسقۇچ ئاتىга كىرگۈزۈش ئۈچۈن بېلگىنى چېكىڭ، ھۆججەتلەر بەلگىلەنگەن بېلگى بويىچە كاتىگورىيەلىنىدۇ',
    vi: 'Nhấp vào thẻ để chèn vào tên thư mục, các tệp sẽ được phân loại theo thẻ được chỉ định',
    zh_tc: '點擊標籤可插入到文件夾名稱中，文件將按照指定標籤進行分類',
    ru: 'Нажмите на тег, чтобы вставить его в имя папки, файлы будут классифицированы в соответствии с указанным тегом',
    ko: '태그를 클릭하여 폴더 이름에 삽입하세요. 파일은 지정된 태그에 따라 분류됩니다',
    bur: 'ဖိုင်ဆောင်အမည်ထဲသို့ထည့်ရန် tag ကိုနှိပ်ပါ၊ ဖိုင်များကို သတ်မှတ်ထားသည့် tag အရ ခွဲခြားမည်',
    ben: 'ফোল্ডারের নামে প্রবেশ করার জন্য ট্যাগটি ক্লিক করুন, ফাইলগুলো নির্দিষ্ট ট্যাগ অনুসারে শ্রেণীবিভাগ করা হবে',
    tr: 'Klasör adına eklemek için etiketi tıklayın, dosyalar belirtilen etikete göre sınıflandırılacaktır',
    km: 'ចុចស្លាក ដើម្បីបញ្ចូលទៅក្នុងឈ្មោះថត ឯកសារនឹងត្រូវបានចំណាត់ថ្នាក់តាមស្លាកដែលបានកំណត់',
    es: 'Haga clic en la etiqueta para insertar en el nombre de la carpeta, los archivos se clasificarán según la etiqueta especificada',
    ar: 'اضغط على العلامة لإدخالها في اسم المجلد، سيتم تصنيف الملفات بناءً على العلامة المحددة',
  },
  'customizeFolder.engraving_front': {
    zh: '雕刻机正面文件',
    en: 'Engraving machine front file',
    id: 'File depan mesin ukir',
    kz: 'Ортақ машинаның алдыңғы файлы',
    th: 'ไฟล์ด้านหน้าของเครื่องแกะสลัก',
    ug: 'بەرگە تېزىش ماشىنىنىڭ ئولتۇق بەت ھۆججەتى',
    vi: 'Tệp mặt trước máy khắc',
    zh_tc: '雕刻機正面文件',
    ru: 'Файл передней части граверной машины',
    ko: '조각기 전면 파일',
    bur: 'မှနှင်းစက်၏ရှေ့ဘက်ဖိုင်',
    ben: 'খোদাই মেশিনের সামনের ফাইল',
    tr: 'Oymak makinesi ön dosyası',
    km: 'ឯកសារមុខម៉ាស៊ីនការឆ្លាក់',
    es: 'Archivo frontal de la máquina de grabado',
    ar: 'ملف أمامي لآلة الحفر',
  },
  'customizeFolder.engraving_opposite': {
    zh: '雕刻机反面文件',
    en: 'Engraving machine reverse file',
    id: 'File reverse mesin ukir',
    kz: 'Ортақ машинаның қарсы файлы',
    th: 'ไฟล์ด้านหลังของเครื่องแกะสลัก',
    ug: 'بەرگە تېزىش ماشىنىنىڭ ئۆتكەن بەت ھۆججەتى',
    vi: 'Tệp mặt sau máy khắc',
    zh_tc: '雕刻機反面文件',
    ru: 'Файл обратной стороны граверной машины',
    ko: '조각기 후면 파일',
    bur: 'မှနှင်းစက်၏နောက်ဘက်ဖိုင်',
    ben: 'খোদাই মেশিনের পিছনের ফাইল',
    tr: 'Oymak makinesi ters dosyası',
    km: 'ឯកសារខាងក្រោយម៉ាស៊ីនការឆ្លាក់',
    es: 'Archivo posterior de la máquina de grabado',
    ar: 'ملف خلفي لآلة الحفر',
  },
  'customizeFolder.engraving_merge': {
    zh: '雕刻机合并文件',
    en: 'Engraving machine merge file',
    id: 'File gabungan mesin ukir',
    kz: 'Ортақ машинаның біріктірілген файлы',
    th: 'ไฟล์รวมของเครื่องแกะสลัก',
    ug: 'بەرگە تېزىش ماشىنىنىڭ birləşdirilən faylı',
    vi: 'Tệp hợp nhất máy khắc',
    zh_tc: '雕刻機合併文件',
    ru: 'Файл объединения граверной машины',
    ko: '조각기 병합 파일',
    bur: 'မှနှင်းစက်၏ပေါင်းစည်းထားသည့်ဖိုင်',
    ben: 'খোদাই মেশিনের মার্জ ফাইল',
    tr: 'Oymak makinesi birleştirme dosyası',
    km: 'ឯកសារបញ្ចូលគ្នានៃម៉ាស៊ីនការឆ្លាក់',
    es: 'Archivo de fusión de la máquina de grabado',
    ar: 'ملف مدمج لآلة الحفر',
  },
  'customizeFolder.engraving_mill': {
    zh: '二次加工牛角槽铣槽',
    en: 'Secondary processing horn groove milling',
    id: 'Pemotongan alur tanduk pengolahan sekunder',
    kz: 'Екінші рет өңделген мінеқ жолақсының фрезкасы',
    th: 'การเจาะรูร่องแฮร์นประมวลผลขั้นที่สอง',
    ug: 'ئىككىلىك ئىşلىتىلگەن مەسىلە تىزىقىنى مىللىمەك',
    vi: 'Milling groove sừng xử lý thứ cấp',
    zh_tc: '二次加工牛角槽銑槽',
    ru: 'Вторичная обработка фрезеровки роговых канавок',
    ko: '이차 가공牛角槽 밀링',
    bur: 'ဒုတိယအလုပ်လုပ်မှုနွားခွေးနှေးရာနေရာ',
    ben: 'দ্বিতীয় প্রক্রিয়াকরণ শিংকে গ্রুভ মিলিং',
    tr: 'İkincil işleme boynuz oluk frezeleme',
    km: 'ការគេង槽ស៊ីសេងដំណើរការទីពីរ',
    es: 'Molienda de canaletas de cuerno secundaria',
    ar: 'تشغيل مخرطة قنوات القرن الثاني',
  },
  'customizeFolder.engraving_haitang': {
    zh: '二次加工斜边海棠角和斜边拉手文件',
    en: 'Secondary processing beveled Haitang corner and handle file',
    id: 'File sudut Haitang miring pengolahan sekunder',
    kz: 'Екінші рет өңделген қиялы Haitang бұрышының файлы',
    th: 'ไฟล์มุม Haitang ที่เอียงประมวลผลขั้นที่สอง',
    ug: 'ئىككىلىك ئىşلىتىلگەن ئۆچۈرۈلگەن ھەيتاڭ بەكلىك ھۆججەتى',
    vi: 'Tệp góc Haitang bevelled xử lý thứ cấp',
    zh_tc: '二次加工斜邊海棠角和斜邊拉手文件',
    ru: 'Файл со скосным углом Haitang вторичной обработки',
    ko: '이차 가공 경사진 해당 각 파일',
    bur: 'ဒုတိယအလုပ်လုပ်မှုဘက်ထောင့်Haitangဖိုင်',
    ben: 'দ্বিতীয় প্রক্রিয়াকরণ বেল্ড Haitang কোণ ফাইল',
    tr: 'İkincil işleme eğimli Haitang köşesi dosyası',
    km: 'ឯកសារមុំ Haitang bevelled ដំណើរការទីពីរ',
    es: 'Archivo de ángulo Haitang bevelado procesado secundario',
    ar: 'ملف زاوية Haitang معالجة فرعية منحنية',
  },
  'customizeFolder.engraving_arc_slot': {
    zh: '二次加工铣底圆弧槽',
    en: 'Secondary processing milling bottom arc slot',
    id: 'Slot busur dasar penggilingan pengolahan sekunder',
    kz: 'Екінші рет өңделген төменгі дairesel жолақының фрезкасы',
    th: 'ช่องโค้งขอบล่างการเจาะของประมวลผลขั้นที่สอง',
    ug: 'ئىككىلىك ئىşلىتىلگەن ئىşıۋەتلىك تۆۋەندىكى دائىرە تىزىقى',
    vi: 'Slot arc đáy milling xử lý thứ cấp',
    zh_tc: '二次加工銑底圓弧槽',
    ru: 'Вторичная обработка фрезеровки донной дуговой канавки',
    ko: '이차 가공 밀링 바닥 원호 슬롯',
    bur: 'ဒုတိယအလုပ်လုပ်မှု milling fundus arc slot',
    ben: 'দ্বিতীয় প্রক্রিয়াকরণ মিলিং বোতল চাপ বৃত্তাকার স্লট',
    tr: 'İkincil işleme freze taban yay aralığı',
    km: 'Slot arc ថ្មីដំណើរការទីពីរ',
    es: 'Molienda de slot circular inferior procesado secundario',
    ar: 'تشغيل مخرطة قنوات دائرية معالجة فرعية منحنية',
  },
  'customizeFolder.engraving_line_slot': {
    zh: '二次加工自定义刀路',
    en: 'Secondary processing custom tool path',
    id: 'Pemrosesan sekunder jalur alat kustom',
    kz: 'Екінші рет өңделген қалаулы аспап жолы',
    th: 'การประมวลผลทุติยภูมิเส้นทางเครื่องมือแบบกำหนดเอง',
    ug: 'ئىككىلىك ئىşلىتىلگەن خاس قورال يولى',
    vi: 'Xử lý thứ cấp đường công cụ tùy chỉnh',
    zh_tc: '二次加工自定義刀路',
    ru: 'Вторичная обработка пользовательского пути инструмента',
    ko: '이차 가공 사용자 정의 도구 경로',
    bur: 'ဒုတိယအလုပ်လုပ်မှုကိုယ်ပိုင်သတ်မှတ်ဓားလမ်း',
    ben: 'দ্বিতীয় প্রক্রিয়াকরণ কাস্টম টুল পাথ',
    tr: 'İkincil işleme özel araç yolu',
    km: 'ដំណើរការទីពីរផ្លូវឧបករណ៍ផ្ទាល់ខ្លួន',
    es: 'Xử lý thứ cấp đường công cụ tùy chỉnh',
    ar: 'معالجة فرعية مسار công cụ tùy chỉnh',
  },
  'customizeFolder.engraving_straight_arc_slot': {
    zh: '二次加工圆弧折弯部分直槽',
    en: 'Secondary processing arc bending part straight slot',
    id: 'Pemrosesan sekunder bagian tikungan busur slot lurus',
    kz: 'Екінші рет өңделген дairesel ийілуы бөлігі түз жолақы',
    th: 'การประมวลผลทุติยภูมิส่วนโค้งของศอกสตรีทสлот',
    ug: 'ئىككىلىك ئىşلىتىلگەن دائىرە ئېگىلگەن بىشىملىك توغرا چاقچاق',
    vi: 'Xử lý thứ cấp phần uốn cong hình cung slot thẳng',
    zh_tc: '二次加工圓弧折弯部分直槽',
    ru: 'Вторичная обработка дуговой гибки части прямой паз',
    ko: '이차 가공 원호 절곡 부분 직선 슬롯',
    bur: 'ဒုတိယအလုပ်လုပ်မှု arc bending ပိုင်း straight slot',
    ben: 'দ্বিতীয় প্রক্রিয়াকরণ চাপ বাঁকা অংশ স্ট্রেইট স্লট',
    tr: 'İkincil işleme yay bükülme parça düz aralığı',
    km: 'ដំណើរការទីពីរផ្នែកពត៌មានផ្លូវឈរ',
    es: 'Xử lý thứ cấp phần uốn cong hình cung slot thẳng',
    ar: 'معالجة فرعية منحنية من قسم uốn cong hình cung slot thẳng',
  },
  'customizeFolder.engraving_frame_door': {
    zh: '二次加工骨骼门文件',
    en: 'Secondary processing bone door file',
    id: 'Pemrosesan sekunder file pintu tulang',
    kz: 'Екінші рет өңделген сүйектік есік файлы',
    th: 'การประมวลผลทุติยภูมิประตูของกระดูก',
    ug: 'ئىككىلىك ئىşلىتىلگەن سۈيەكتىك پۇر ھۆججەت',
    vi: 'Xử lý thứ cấp cửa xương file',
    zh_tc: '二次加工骨骼門文件',
    ru: 'Вторичная обработка скелетной двери файл',
    ko: '이차 가공 뼈 문 파일',
    bur: 'ဒုတိယအလုပ်လုပ်မှု bone door ဖိုင်',
    ben: 'দ্বিতীয় প্রক্রিয়াকরণ কাচ দরজা ফাইল',
    tr: 'İkincil işleme kemik kapı dosyası',
    km: 'ឯកសារកាត់កញ្ចក់ពួកជ្រុង',
    es: 'Archivo de puerta de huesos procesado secundario',
    ar: 'ملف درابزين معالجة فرعية منحنية',
  },
  'customizeFolder.engraving_inner_shape': {
    zh: '二次加工内部异形',
    en: 'Secondary processing inner shape',
    id: 'Pemrosesan sekunder bagian dalam bentuk',
    kz: 'Екінші рет өңделген ішкі пішімі',
    th: 'การประมวลผลทุติยภูมิส่วนในของรูปร่าง',
    ug: 'ئىككىلىك ئىşلىتىلگەن داخلى ئۇچۇق پۇل',
    vi: 'Xử lý thứ cấp phần trong hình dạng',
    zh_tc: '二次加工內部異形',
    ru: 'Вторичная обработка внутренней формы',
    ko: '이차 가공 내부 형상',
    bur: 'ဒုတိယအလုပ်လုပ်မှု inner shape',
    ben: 'দ্বিতীয় প্রক্রিয়াকরণ অভ্যন্তরীণ আকার',
    tr: 'İkincil işleme iç şekil',
    km: 'ដំណើរការទីពីរផ្នែកក្នុងសំបុត្រ',
    es: 'Xử lý thứ cấp parte interior de forma',
    ar: 'معالجة فرعية من الشكل الداخلي',
  },
  'customizeFolder.engraving_hole': {
    zh: '二次加工常规孔',
    en: 'Secondary processing regular hole',
    id: 'Pemrosesan sekunder lubang biasa',
    kz: 'Екінші рет өңделген үнсіз дыбыл',
    th: 'การประมวลผลทุติยภูมิรูปร่างปกติ',
    ug: 'ئىككىلىك ئىşلىتىلگەن үнсіз چاقچاق',
    vi: 'Xử lý thứ cấp lỗ thường',
    zh_tc: '二次加工常規孔',
    ru: 'Вторичная обработка обычного отверстия',
    ko: '이차 가공 일반 구멍',
    bur: 'ဒုတိယအလုပ်လုပ်မှု regular hole',
    ben: 'দ্বিতীয় প্রক্রিয়াকরণ সাধারণ গর্ত',
    tr: 'İkincil işleme düz aralığı',
    km: 'ដំណើរការទីពីរផ្នែកឈរ',
    es: 'Xử lý thứ cấp lỗ thường',
    ar: 'معالجة فرعية من الثقب العادي',
  },
  'customizeFolder.engraving_slot': {
    zh: '二次加工常规槽',
    en: 'Secondary processing regular slot',
    id: 'Pemrosesan sekunder slot biasa',
    kz: 'Екінші рет өңделген үнсіз قنوات',
    th: 'การประมวลผลทุติยภูมิส่วนโค้งของศอกสตรีทสлот',
    ug: 'ئىككىلىك ئىşلىتىلگەن үнсіз چاقچاق',
    vi: 'Xử lý thứ cấp lỗ thường',
    zh_tc: '二次加工常規槽',
    ru: 'Вторичная обработка обычного паза',
    ko: '이차 가공 일반 슬롯',
    bur: 'ဒုတိယအလုပ်လုပ်မှု regular slot',
    ben: 'দ্বিতীয় প্রক্রিয়াকরণ সাধারণ স্লট',
    tr: 'İkincil işleme düz aralığı',
    km: 'ដំណើរការទីពីរផ្នែកឈរ',
    es: 'Xử lý thứ cấp lỗ thường',
    ar: 'معالجة فرعية من الثقب العادي',
  },
  'customizeFolder.engraving_single_file_merge': {
    zh: '二次加工合并文件',
    en: 'Secondary processing single file merge',
    id: 'Pemrosesan sekunder file merge',
    kz: 'Екінші рет өңделген файл біріктіру',
    th: 'การประมวลผลทุติยภูมิการรวมไฟล์',
    ug: 'ئىككىلىك ئىşلىتىلگەن ھۆججەت بىرىكتىلىش',
    vi: 'Xử lý thứ cấp file merge',
    zh_tc: '二次加工合併文件',
    ru: 'Вторичная обработка объединения файлов',
    ko: '이차 가공 파일 병합',
    bur: 'ဒုတိယအလုပ်လုပ်မှု file merge',
    ben: 'দ্বিতীয় প্রক্রিয়াকরণ ফাইল এম্বেড',
    tr: 'İkincil işleme dosya birleştirme',
    km: 'ដំណើរការទីពីរផ្នែកកាត់កញ្ចក់',
    es: 'Xử lý thứ cấp archivo de fusión',
    ar: 'معالجة فرعية من الدمج الملف',
  },
  'customizeFolder.electronic_saw': {
    zh: '电子锯文件',
    en: 'Electronic saw file',
    id: 'File gergaji elektronik',
    kz: 'Электронды пилка файлы',
    th: 'ไฟล์เลื่อยไฟฟ้า',
    ug: 'ئېلېكترونىك пилە ھۆججەت',
    vi: 'Tệp cưa điện tử',
    zh_tc: '電子鋸文件',
    ru: 'Электронный пилочный файл',
    ko: '전자 톱 파일',
    bur: 'အီလက်ထရွန်းစောက်ဖိုင်',
    ben: 'ইলেকট্রনিক করাতা ফাইল',
    tr: 'Elektronik testere dosyası',
    km: 'ឯកសារកាន់អេឡិចត្រូនិច',
    es: 'Archivo de sierra eléctrica procesado secundario',
    ar: 'ملف سيارة الكهرباء معالجة فرعية منحنية',
  },
  'customizeFolder.glass': {
    zh: '玻璃切割机文件',
    en: 'Glass cutting machine file',
    id: 'File mesin potong kaca',
    kz: 'Шиша қесу машинасының файлы',
    th: 'ไฟล์เครื่องตัดแก้ว',
    ug: 'شیشە قىرىش ماشىنىسى ھۆججەت',
    vi: 'Tệp máy cắt kính',
    zh_tc: '玻璃切割機文件',
    ru: 'Файл стеклорезающей машины',
    ko: '유리 절단기 파일',
    bur: 'ဖန်ခွက်ဖြတ်စက်ဖိုင်',
    ben: 'কাচ কাটার মেশিন ফাইল',
    tr: 'Cam kesme makinesi dosyası',
    km: 'ឯកសារម៉ាស៊ីនកាត់កញ្ចក់',
    es: 'Archivo de máquina de corte de vidrio procesado secundario',
    ar: 'ملف ماكينة قص الزجاج معالجة فرعية منحنية',
  },
  'customizeFolder.glass_machine': {
    zh: '玻璃切割机',
    en: 'Glass cutting machine',
    id: 'Mesin potong kaca',
    kz: 'Шиша қесу машинасы',
    th: 'เครื่องตัดแก้ว',
    ug: 'شیشە قىرىش ماشىنىسى',
    vi: 'Máy cắt kính',
    zh_tc: '玻璃切割機',
    ru: 'Стеклорезающая машина',
    ko: '유리 절단기',
    bur: 'ဖန်ခွက်ဖြတ်စက်',
    ben: 'কাচ কাটার মেশিন',
    tr: 'Cam kesme makinesi',
    km: 'ម៉ាស៊ីនកាត់កញ្ចក់',
    es: 'Máquina de corte de vidrio procesado secundario',
    ar: 'ماكينة قص الزجاج معالجة فرعية منحنية',
  },
  'customizeFolder.side_machine': {
    zh: '侧孔机文件',
    en: 'Side hole machine file',
    id: 'File mesin lubang samping',
    kz: 'Ж kylы дыбыл машинасының файлы',
    th: 'ไฟล์เครื่องเจาะด้าน',
    ug: 'كىيىم ئۆچۈك ماشىنىسى ھۆججەت',
    vi: 'Tệp máy khoan bên',
    zh_tc: '側孔機文件',
    ru: 'Файл боковой дробилки',
    ko: '사이드 홀 머신 파일',
    bur: 'ဘေးတွင်းတူးစက်ဖိုင်',
    ben: 'পার্শ্ব গর্ত মেশিন ফাইল',
    tr: 'Kenar delik makinesi dosyası',
    km: 'ឯកសារម៉ាស៊ីនរន្ធជ្រុង',
    es: 'Archivo de máquina de perforación lateral procesado secundario',
    ar: 'ملف ماكينة الحفر الجانبي معالجة فرعية منحنية',
  },
  'customizeFolder.side_machine_xml3': {
    zh: '旧版侧孔机XML3文件',
    en: 'Old version side hole machine XML3 file',
    id: 'File XML3 mesin lubang samping versi lama',
    kz: 'Ескі нұсқасы ж kylы дыбыл машинасының XML3 файлы',
    th: 'ไฟล์ XML3 เครื่องเจาะด้านรุ่นเก่า',
    ug: 'قەدیمى كىيىم ئۆچۈك ماشىنىسى XML3 ھۆججەت',
    vi: 'Tệp XML3 máy khoan bên phiên bản cũ',
    zh_tc: '舊版側孔機XML3文件',
    ru: 'Файл XML3 боковой дробилки старой версии',
    ko: '구 버전 사이드 홀 머신 XML3 파일',
    bur: 'ဗားရှင်းဟောင်းဘေးတွင်းတူးစက် XML3 ဖိုင်',
    ben: 'পুরানো সংস্করণ পার্শ্ব গর্ত মেশিন XML3 ফাইল',
    tr: 'Eski sürüm kenar delik makinesi XML3 dosyası',
    km: 'ឯកសារ XML3 ម៉ាស៊ីនរន្ធជ្រុងរចនាសម្ព័ន្ធខែមី',
    es: 'Archivo de máquina de perforación lateral XML3 procesado secundario',
    ar: 'ملف ماكينة الحفر الجانبي XML3 معالجة فرعية منحنية',
  },
  'customizeFolder.side_machine_txt': {
    zh: '旧版侧孔机TXT文件',
    en: 'Old version side hole machine TXT file',
    id: 'File TXT mesin lubang samping versi lama',
    kz: 'Ескі нұсқасы ж kylы дыбыл машинасының TXT файлы',
    th: 'ไฟล์ TXT เครื่องเจาะด้านรุ่นเก่า',
    ug: 'قەدیمى كىيىم ئۆچۈك ماشىنىسى TXT ھۆججەت',
    vi: 'Tệp TXT máy khoan bên phiên bản cũ',
    zh_tc: '舊版側孔機TXT文件',
    ru: 'Файл TXT боковой дробилки старой версии',
    ko: '구 버전 사이드 홀 머신 TXT 파일',
    bur: 'ဗားရှင်းဟောင်းဘေးတွင်းတူးစက် TXT ဖိုင်',
    ben: 'পুরানো সংস্করণ পার্শ্ব গর্ত মেশিন TXT ফাইল',
    tr: 'Eski sürüm kenar delik makinesi TXT dosyası',
    km: 'ឯកសារ TXT ម៉ាស៊ីនរន្ធជ្រុងរចនាសម្ព័ន្ធខែមី',
    es: 'Archivo de máquina de perforación lateral TXT procesado secundario',
    ar: 'ملف ماكينة الحفر الجانبي TXT معالجة فرعية منحنية',
  },
  'customizeFolder.side_machine_nc': {
    zh: '旧版侧孔机nc文件',
    en: 'Old version side hole machine NC file',
    id: 'File NC mesin lubang samping versi lama',
    kz: 'Ескі нұсқасы ж kylы дыбыл машинасының NC файлы',
    th: 'ไฟล์ NC เครื่องเจาะด้านรุ่นเก่า',
    ug: 'قەدیمى كىيىم ئۆچۈك ماشىنىسى NC ھۆججەت',
    vi: 'Tệp NC máy khoan bên phiên bản cũ',
    zh_tc: '舊版側孔機nc文件',
    ru: 'Файл NC боковой дробилки старой версии',
    ko: '구 버전 사이드 홀 머신 NC 파일',
    bur: 'ဗားရှင်းဟောင်းဘေးတွင်းတူးစက် NC ဖိုင်',
    ben: 'পুরানো সংস্করণ পার্শ্ব গর্ত মেশিন NC ফাইল',
    tr: 'Eski sürüm kenar delik makinesi NC dosyası',
    km: 'ឯកសារ NC ម៉ាស៊ីនរន្ធជ្រុងរចនាសម្ព័ន្ធខែមី',
    es: 'Archivo de máquina de perforación lateral NC procesado secundario',
    ar: 'ملف ماكينة الحفر الجانبي NC معالجة فرعية منحنية',
  },
  'customizeFolder.dock56F': {
    zh: '五/六面钻文件',
    en: 'Five/six-sided drilling file',
    id: 'File bor lima/enam sisi',
    kz: 'Бес/алты жаңбақлым дыбыл файлы',
    th: 'ไฟล์เจาะห้าสี่เหลี่ยมหกด้าน',
    ug: 'بەش/ئالتى يېڭىلىك ئۆچۈك ھۆججەت',
    vi: 'Tệp khoan năm/sáu mặt',
    zh_tc: '五/六面鑽文件',
    ru: 'Файл пяти/шестигранного сверления',
    ko: '5/6면 드릴 파일',
    bur: 'ငါး/ခြောက်ဘက်တူးဖိုင်',
    ben: 'পাঁচ/ছয় পার্শ্ব বোরিং ফাইল',
    tr: 'Beş/altı taraflı delme dosyası',
    km: 'ឯកសារខួងប្រាំ/ប្រាំមួយភាគ',
    es: 'Archivo de perforación cinco/seis lados procesado secundario',
    ar: 'ملف الحفر cinco/seis lados معالجة فرعية منحنية',
  },
  'customizeFolder.ptp': {
    zh: 'PTP文件',
    en: 'PTP file',
    id: 'File PTP',
    kz: 'PTP файлы',
    th: 'ไฟล์ PTP',
    ug: 'PTP ھۆججەت',
    vi: 'Tệp PTP',
    zh_tc: 'PTP文件',
    ru: 'Файл PTP',
    ko: 'PTP 파일',
    bur: 'PTP ဖိုင်',
    ben: 'PTP ফাইল',
    tr: 'PTP dosyası',
    km: 'ឯកសារ PTP',
    es: 'Archivo PTP procesado secundario',
    ar: 'ملف PTP معالجة فرعية منحنية',
  },
  'customizeFolder.aio': {
    zh: '一体机文件',
    en: 'All-in-one machine file',
    id: 'File mesin all-in-one',
    kz: 'Біріктірген машинасының файлы',
    th: 'ไฟล์เครื่องแบบรวมเดียว',
    ug: 'بىرلىك ماشىنى ھۆججەت',
    vi: 'Tệp máy all-in-one',
    zh_tc: '一體機文件',
    ru: 'Файл многофункциональной машины',
    ko: '일체기 파일',
    bur: 'all-in-one စက်ဖိုင်',
    ben: 'অল-ইন-ওয়ান মেশিন ফাইল',
    tr: 'Tüm-in-bir makine dosyası',
    km: 'ឯកសារម៉ាស៊ីនអាល់-ইন-វ៉ាន់',
    es: 'Archivo de máquina all-in-one procesado secundario',
    ar: 'ملف ماكينة all-in-one معالجة فرعية منحنية',
  },
  'customizeFolder.aio_anc': {
    zh: '一体机正面anc文件',
    en: 'All-in-one machine front ANC file',
    id: 'File ANC bagian depan mesin serba guna',
    kz: 'Көп функциялы машинаның алдыңғы ANC файлы',
    th: 'ไฟล์ ANC ด้านหน้าเครื่องแบบรวมเดียว',
    ug: 'بىر گەۋدىلەشكەن ماشىنىنىڭ ئالدى تەرەپتىكى ANC ھۆججىتى',
    vi: 'Tệp ANC mặt trước máy đa chức năng',
    zh_tc: '一體機正面anc文件',
    ru: 'Файл ANC фронтальной многофункциональной машины',
    ko: '일체기 전면 ANC 파일',
    bur: 'အရာအားလုံးပေါင်းစပ် စက်၏ ရှေ့ဘက် ANC ဖိုင်',
    ben: 'বহুমুখী মেশিনের সামনের ANC ফাইল',
    tr: 'Çok işlevli makinenin ön ANC dosyası',
    km: 'ឯកសារ ANC ផ្នែកខាងមុខម៉ាស៊ីនរួមមុខងារ',
    es: 'Archivo ANC frontal de la máquina all-in-one procesado secundario',
    ar: 'ملف ANC frontal de la máquina all-in-one معالجة فرعية منحنية',
  },
  'customizeFolder.labeling_1': {
    zh: '贴标机文件1',
    en: 'Labeling machine file 1',
    id: 'File mesin pelabelan 1',
    kz: 'Белгілеу машинасының 1-ші файлы',
    th: 'ไฟล์เครื่องปักฉลาก 1',
    ug: 'بەلگەلەش ماشىنىسى ھۆججەت 1',
    vi: 'Tệp máy dán nhãn 1',
    zh_tc: '貼標機文件1',
    ru: 'Файл этикеткирующей машины 1',
    ko: '라벨링 머신 파일 1',
    bur: 'တံဆိပ်ကပ်စက်ဖိုင် 1',
    ben: 'লেবেলিং মেশিন ফাইল 1',
    tr: 'Etiketleme makinesi dosyası 1',
    km: 'ឯកសារម៉ាស៊ីនបិទស្លាក 1',
    es: 'Archivo de máquina de etiquetado 1 procesado secundario',
    ar: 'ملف ماكينة التسمية 1 معالجة فرعية منحنية',
  },
  'customizeFolder.labeling_2': {
    zh: '贴标机文件2',
    en: 'Labeling machine file 2',
    id: 'File mesin pelabelan 2',
    kz: 'Белгілеу машинасының 2-ші файлы',
    th: 'ไฟล์เครื่องปักฉลาก 2',
    ug: 'بەلگەلەش ماشىنىسى ھۆججەت 2',
    vi: 'Tệp máy dán nhãn 2',
    zh_tc: '貼標機文件2',
    ru: 'Файл этикеткирующей машины 2',
    ko: '라벨링 머신 파일 2',
    bur: 'တံဆိပ်ကပ်စက်ဖိုင် 2',
    ben: 'লেবেলিং মেশিন ফাইল 2',
    tr: 'Etiketleme makinesi dosyası 2',
    km: 'ឯកសារម៉ាស៊ីនបិទស្លាក 2',
    es: 'Archivo de máquina de etiquetado 2 procesado secundario',
    ar: 'ملف ماكينة التسمية 2 معالجة فرعية منحنية',
  },
  'customizeFolder.labeling_3': {
    zh: '贴标机文件3',
    en: 'Labeling machine file 3',
    id: 'File mesin pelabelan 3',
    kz: 'Белгілеу машинасының 3-ші файлы',
    th: 'ไฟล์เครื่องปักฉลาก 3',
    ug: 'بەلگەلەش ماشىنىسى ھۆججەت 3',
    vi: 'Tệp máy dán nhãn 3',
    zh_tc: '貼標機文件3',
    ru: 'Файл этикеткирующей машины 3',
    ko: '라벨링 머신 파일 3',
    bur: 'တံဆိပ်ကပ်စက်ဖိုင် 3',
    ben: 'লেবেলিং মেশিন ফাইল 3',
    tr: 'Etiketleme makinesi dosyası 3',
    km: 'ឯកសារម៉ាស៊ីនបិទស្លាក 3',
    es: 'Archivo de máquina de etiquetado 3 procesado secundario',
    ar: 'ملف ماكينة التسمية 3 معالجة فرعية منحنية',
  },
  'customizeFolder.robotic_arm': {
    zh: '机械臂文件',
    en: 'Robotic arm file',
    id: 'File lengan robot',
    kz: 'Роботік қолының файлы',
    th: 'ไฟล์แขนหุ่นยนต์',
    ug: 'روبوپىيىلىك كول ھۆججەت',
    vi: 'Tệp cánh tay robot',
    zh_tc: '機械臂文件',
    ru: 'Файл роботизованного манипулятора',
    ko: '로봇 암 파일',
    bur: 'စက်လက်ဖိုင်',
    ben: 'রোবোটিক আর্ম ফাইল',
    tr: 'Robot kolu dosyası',
    km: 'ឯកសារដៃមនុស្សយន្ត',
    es: 'Archivo de brazo robot procesado secundario',
    ar: 'ملف يد روبوت معالجة فرعية منحنية',
  },
  'customizeFolder.label_image': {
    zh: '标签图片文件',
    en: 'Label image file',
    id: 'File gambar label',
    kz: 'Бейнес суретінің файлы',
    th: 'ไฟล์รูปภาพฉลาก',
    ug: 'بەلگە сурет ھۆججەت',
    vi: 'Tệp ảnh nhãn',
    zh_tc: '標籤圖片文件',
    ru: 'Файл изображения этикетки',
    ko: '라벨 이미지 파일',
    bur: 'တံဆိပ်ပုံဖိုင်',
    ben: 'লেবেল চিত্র ফাইল',
    tr: 'Etiket resim dosyası',
    km: 'ឯកសាររូបភាពស្លាក',
    es: 'Archivo de imagen de etiqueta procesado secundario',
    ar: 'ملف صورة التسمية معالجة فرعية منحنية',
  },
  'customizeFolder.label_pdf': {
    zh: '标签PDF文件',
    en: 'Label PDF file',
    id: 'File PDF label',
    kz: 'Бейнес PDF файлы',
    th: 'ไฟล์ PDF ฉลาก',
    ug: 'بەلگە PDF ھۆججەت',
    vi: 'Tệp PDF nhãn',
    zh_tc: '標籤PDF文件',
    ru: 'Файл PDF этикетки',
    ko: '라벨 PDF 파일',
    bur: 'တံဆိပ် PDF ဖိုင်',
    ben: 'লেবেল PDF ফাইল',
    tr: 'Etiket PDF dosyası',
    km: 'ឯកសារ PDF ស្លាក',
    es: 'Archivo PDF de etiqueta procesado secundario',
    ar: 'ملف PDF de etiqueta معالجة فرعية منحنية',
  },
  'customizeFolder.paiban_image': {
    zh: '排版图图片文件',
    en: 'Typesetting image file',
    id: 'File gambar penataan',
    kz: 'Типографиялық сурет файлы',
    th: 'ไฟล์รูปการเรียงพิมพ์',
    ug: 'بەت تەرتىپلەش سۈرىتى ھۆججەت',
    vi: 'Tệp ảnh sắp chữ',
    zh_tc: '排版圖圖片文件',
    ru: 'Файл типографского изображения',
    ko: '타이포그래피 이미지 파일',
    bur: 'ပုံစီချထားသော ပုံဖိုင်',
    ben: 'টাইপসেটিং চিত্র ফাইল',
    tr: 'Tipografi görüntü dosyası',
    km: 'ឯកសាររូបភាពរៀបចំបោះពុម្ព',
    es: 'Archivo de imagen de tiposetting procesado secundario',
    ar: 'ملف صورة التصميم الصناعي معالجة فرعية منحنية',
  },
  'customizeFolder.paiban_pdf': {
    zh: '排版图PDF文件',
    en: 'Typesetting image PDF file',
    id: 'File PDF gambar penataan',
    kz: 'Типографиялық сурет PDF файлы',
    th: 'ไฟล์ PDF รูปการเรียงพิมพ์',
    ug: 'بەت تەرتىپلەش سۈرىتى PDF ھۆججەت',
    vi: 'Tệp PDF ảnh sắp chữ',
    zh_tc: '排版圖PDF文件',
    ru: 'Файл PDF типографского изображения',
    ko: '타이포그래피 이미지 PDF 파일',
    bur: 'ပုံစီချထားသော ပုံ PDF ဖိုင်',
    ben: 'টাইপসেটিং চিত্র PDF ফাইল',
    tr: 'Tipografi görüntü PDF dosyası',
    km: 'ឯកសារ PDF រូបភាពរៀបចំបោះពុម្ព',
    es: 'Archivo PDF de tiposetting procesado secundario',
    ar: 'ملف PDF للتصميم الصناعي معالجة فرعية منحنية',
  },
  'customizeFolder.engraving': {
    zh: '雕刻机',
    en: 'Engraving machine',
    id: 'Mesin ukir',
    kz: 'Қорытынды машинасы',
    th: 'เครื่องแกะสลัก',
    ug: 'بۇزۇلۇش ماشىنىسى',
    vi: 'Máy khắc',
    zh_tc: '雕刻機',
    ru: 'Гравировальная машина',
    ko: '조각 기계',
    bur: 'မှနှင်းစက်',
    ben: 'খোদাই মেশিন',
    tr: 'Oyma makinesi',
    km: 'ម៉ាស៊ីនឆ្លាក់',
    es: 'Máquina de grabado procesado secundario',
    ar: 'آلة الحفر معالجة فرعية منحنية',
  },
  'customizeFolder.electronic': {
    zh: '电子锯',
    en: 'Electronic saw',
    id: 'Gergaji elektronik',
    kz: 'Электронды пилка',
    th: 'เลื่อยไฟฟ้า',
    ug: 'ئېلېكترونىك пилە',
    vi: 'Cưa điện tử',
    zh_tc: '電子鋸',
    ru: 'Электронная пила',
    ko: '전자 톱',
    bur: 'အီလက်ထရွန်းစောက်',
    ben: 'ইলেকট্রনিক করাতা',
    tr: 'Elektronik testere',
    km: 'កាន់អេឡិចត្រូនិច',
    es: 'Sierra eléctrica procesada secundaria',
    ar: 'سيارة الكهرباء معالجة فرعية منحنية',
  },
  'customizeFolder.side_hole': {
    zh: '侧孔机',
    en: 'Side hole machine',
    id: 'Mesin lubang samping',
    kz: 'Ж kylы дыбыл машинасы',
    th: 'เครื่องเจาะด้าน',
    ug: 'كىيىم ئۆچۈك ماشىنىسى',
    vi: 'Máy khoan bên',
    zh_tc: '側孔機',
    ru: 'Боковая дробилка',
    ko: '사이드 홀 머신',
    bur: 'ဘေးတွင်းတူးစက်',
    ben: 'পার্শ্ব গর্ত মেশিন',
    tr: 'Kenar delik makinesi',
    km: 'ម៉ាស៊ីនរន្ធជ្រុង',
    es: 'Máquina de perforación lateral procesada secundaria',
    ar: 'ماكينة الحفر الجانبي معالجة فرعية منحنية',
  },
  'customizeFolder.drilling': {
    zh: '五/六面钻',
    en: 'Five/six-sided drilling',
    id: 'Pengeboran lima/enam sisi',
    kz: 'Бес/алты жаңбақлым дыбыл',
    th: 'การเจาะห้าสี่เหลี่ยมหกด้าน',
    ug: 'بەش/ئالتى يېڭىلىك ئۆچۈك',
    vi: 'Khoan năm/sáu mặt',
    zh_tc: '五/六面鑽',
    ru: 'Пяти/шестигранное сверление',
    ko: '5/6면 드릴',
    bur: 'ငါး/ခြောက်ဘက်တူး',
    ben: 'পাঁচ/ছয় পার্শ্ব বোরিং',
    tr: 'Beş/altı taraflı delme',
    km: 'ខួងប្រាំ/ប្រាំមួយភាគ',
    es: 'Perforación cinco/seis lados procesada secundaria',
    ar: 'الحفر cinco/seis lados معالجة فرعية منحنية',
  },
  'customizeFolder.labeling': {
    zh: '贴标机',
    en: 'Labeling machine',
    id: 'Mesin pelabelan',
    kz: 'Белгілеу машинасы',
    th: 'เครื่องปักฉลาก',
    ug: 'بەلگەلەش ماشىنىسى',
    vi: 'Máy dán nhãn',
    zh_tc: '貼標機',
    ru: 'Этикеткирующая машина',
    ko: '라벨링 머신',
    bur: 'တံဆိပ်ကပ်စက်',
    ben: 'লেবেলিং মেশিন',
    tr: 'Etiketleme makinesi',
    km: 'ម៉ាស៊ីនបិទស្លាក',
    es: 'Máquina de etiquetado procesada secundaria',
    ar: 'ماكينة التسمية معالجة فرعية منحنية',
  },
  'customizeFolder.robotic': {
    zh: '机械臂',
    en: 'Robotic arm',
    id: 'Lengan robot',
    kz: 'Роботік қолы',
    th: 'แขนหุ่นยนต์',
    ug: 'روبوپىيىلىك كول',
    vi: 'Cánh tay robot',
    zh_tc: '機械臂',
    ru: 'Роботизованный манипулятор',
    ko: '로봇 암',
    bur: 'စက်လက်',
    ben: 'রোবোটিক আর্ম',
    tr: 'Robot kolu',
    km: 'ដៃមនុស្សយន្ត',
    es: 'Brazo robot procesado secundario',
    ar: 'يد روبوت معالجة فرعية منحنية',
  },
  'customizeFolder.label': {
    zh: '标签',
    en: 'Label',
    id: 'Label',
    kz: 'Бейнес',
    th: 'ฉลาก',
    ug: 'بەلگە',
    vi: 'Nhãn',
    zh_tc: '標籤',
    ru: 'Этикетка',
    ko: '라벨',
    bur: 'တံဆိပ်',
    ben: 'লেবেল',
    tr: 'Etiket',
    km: 'ស្លាក',
    es: 'Etiqueta',
    ar: 'التسمية',
  },
  'customizeFolder.warningTip': {
    zh: '请注意: 花括号【{}】及其内容需保证完整性，请勿手动删除/增加!',
    en: 'Please note: The curly braces 【{}】 and their contents must be kept intact, do not manually delete/add!',
    id: 'Harap catat: Kurung kurawal 【{}】 dan isinya harus tetap utuh, jangan hapus/tambah secara manual!',
    kz: 'Ескерту: Фигуралық жақшалар 【{}】 және олардың ішіндегі мазмұн бүтін болуы керек, қолмен жоймаңыз немесе қоспаңыз!',
    th: 'โปรดทราบ: วงเล็บปีกกา 【{}】 และเนื้อหาภายในต้องคงความสมบูรณ์ ห้ามลบหรือเพิ่มด้วยตนเอง!',
    ug: 'ئەسكەرتىش: سۈرلۈك قاۋۇس 【{}】 ۋە ئىچىدىكى مەزمۇننىڭ مۇتلەق بىر پۈتۈن بولۇشىنى ساقلاڭ، قول بىلەن ئۆچۈرمەڭ ياكى قوشماڭ!',
    vi: 'Lưu ý: Dấu ngoặc nhọn 【{}】 và nội dung của chúng phải giữ nguyên vẹn, không được xóa/thêm thủ công!',
    zh_tc: '請注意: 花括號【{}】及其內容需保證完整性，請勿手動刪除/增加!',
    ru: 'Обратите внимание: Фигурные скобки 【{}】 и их содержимое должны оставаться нетронутыми, не удаляйте/не добавляйте вручную!',
    ko: '참고: 중괄호 【{}】 및 내용은 완전성을 유지해야 하며 수동으로 삭제/추가하지 마세요!',
    bur: 'သတိပြုပါ-ကွင်းချုပ်ကွင်း 【{}】 နှင့်၎င်းတို့၏အကြောင်းအရာများကို မပြတ်သားစေရပါ၊ လက်ဖြင့်ဖျက်ခြင်း သို့မဟုတ် ထပ်ထည့်ခြင်း မပြုပါနှင့်!',
    ben: 'মনে রাখবেন: বক্র বন্ধনী 【{}】 এবং এর ভিতরের বিষয়বস্তু অক্ষত রাখতে হবে, নিজে থেকে মুছে ফেলবেন না বা যোগ করবেন না!',
    tr: 'Lütfen dikkat edin: Süslü parantezler 【{}】 ve içerikleri eksiksiz kalmalıdır; elle silmeyin veya eklemeyin!',
    km: 'សូមចំណាំ៖ ស្រោមគ្រាប់ 【{}】 និងខ្លឹមសាររបស់ពួកគេត្រូវតែរក្សាឱ្យបានពេញលេញ កុំលុប ឬបន្ថែមដោយដៃ!',
    es: 'Por favor, tenga en cuenta: Los corchetes 【{}】 y su contenido deben mantenerse intactos, no se debe eliminar/agregar manualmente!',
    ar: 'يرجى الانتباه: يجب أن يبقى الأقواس المنحنية 【{}】 ومحتواها سليمًا، لا يجب حذف/إضافتها بشكل منطقي!',
  },
  'customizeFolder.fileClassifyError': {
    zh: '此文件不能按照{classifyNames}分类',
    en: 'This file cannot be classified according to {classifyNames}',
    id: 'File ini tidak dapat diklasifikasikan menurut {classifyNames}',
    kz: 'Бұл файл {classifyNames} бойынша классификациялауы мүмкін емес',
    th: 'ไฟล์นี้ไม่สามารถจำแนกตาม {classifyNames}',
    ug: 'بۇ ھۆججەت {classifyNames} بويىچە كاتىگورىيەلەندۈرۈلىشى مۇمكىن ئەمەس',
    vi: 'Tệp này không thể được phân loại theo {classifyNames}',
    zh_tc: '此文件不能按照{classifyNames}分類',
    ru: 'Этот файл не может быть классифицирован по {classifyNames}',
    ko: '이 파일은 {classifyNames}에 따라 분류할 수 없습니다',
    bur: 'ဤဖိုင်ကို {classifyNames} အရခွဲခြား၍မရနိုင်ပါ',
    ben: 'এই ফাইলটি {classifyNames} অনুসারে শ্রেণীবদ্ধ করা যায় না',
    tr: 'Bu dosya {classifyNames} göre sınıflandırılamaz',
    km: 'ឯកសារនេះមិនអាចចាត់ថ្នាក់តាម {classifyNames}',
    es: 'Este archivo no puede clasificarse según {classifyNames}',
    ar: 'هذا الملف لا يمكن تصنيفه بناع {classifyNames}',
  },
  'customizeFolder.folderClassifyByTextureColorThickSize': {
    zh: '根据颜色、材质、厚度、大板尺寸归为不同文件夹(贴标文件一起)',
    en: 'Classify into different folders according to color, material, thickness, and large board size (label files together)',
    id: 'Klasifikasikan ke dalam folder berbeda menurut warna, material, ketebalan, dan ukuran papan besar (file label bersama)',
    kz: 'Түс, материал, қалыңдығы және үлкен доска ölçі бойынша әр түрлі қаптамаларға классификациялау (белгілер файлдары бірге)',
    th: 'จำแนกเป็นโฟลเดอร์ต่างๆ ตามสี วัสดุ ความหนา และขนาดของบอร์ดขนาดใหญ่ (ไฟล์ป้ายรวมกัน)',
    ug: 'رەڭ، مادە، قىسىقلىقى، چوڭ تاختا ölçى بويىچە بەشكەل قىسقۇچلارга كاتىگورىيەلەندۈرۈش (بەلگە ھۆججەتلەر بىلەن بىرلىكە)',
    vi: 'Phân loại vào các thư mục khác nhau theo màu, vật liệu, độ dày và kích thước bảng lớn (các tệp nhãn cùng nhau)',
    zh_tc: '根據顏色、材質、厚度、大板尺寸歸為不同文件夾(貼標文件一起)',
    ru: 'Классифицировать в разные папки по цвету, материалу, толщине и размеру большого щита (файлы этикеток вместе)',
    ko: '색상, 재질, 두께, 대판 크기에 따라 다른 폴더로 분류(라벨 파일 함께)',
    bur: 'အရောင်၊ ပစ္စည်း၊ အထူ၊ ကြီးမားသောဘုတ်အရွယ်အစားအရ မတူညီသောဖိုင်ဆောင်များအဖြစ်ခွဲခြားပါ (တံဆိပ်ဖိုင်များအတူတကွ)',
    ben: 'রঙ, পদার্থ, বেধ, এবং বড় বোর্ড আকার অনুসারে বিভিন্ন ফোল্ডারে শ্রেণীবদ্ধ করুন (লেবেল ফাইল একসাথে)',
    tr: 'Renk, malzeme, kalınlık ve büyük tahta boyutuna göre farklı klasörlere sınıflandırın (etiket dosyaları birlikte)',
    km: 'ចាត់ថ្នាក់ទៅថតផ្សេងៗទៀតតាមពណ៌ សម្ភារៈ កម្រាស់ និងទំហំបន្ទះធំ (ឯកសារស្លាកមួយគ្នា)',
    es: 'Clasificar en diferentes carpetas según color, material, grosor y tamaño de la placa (archivos de etiqueta juntos)',
    ar: 'تصنيف في مجلدات مختلفة بناع color, material, grosor y tamaño de la placa (archivos de etiqueta juntos)',
  },
  'customizeFolder.unnamed': {
    zh: '未命名',
    en: 'Unnamed',
    id: 'Tanpa nama',
    kz: 'Атыңыз жоқ',
    th: 'ไม่มีชื่อ',
    ug: 'ئاتى жوق',
    vi: 'Chưa đặt tên',
    zh_tc: '未命名',
    ru: 'Безымянный',
    ko: '이름 없음',
    bur: 'မည无闻',
    ben: 'অনাম',
    tr: 'İsimsiz',
    km: 'មិនមានឈ្មោះ',
    es: 'Sin nombre',
    ar: 'بدون اسم',
  },
  'customizeFolder.specialText': {
    zh: '特殊',
    en: 'Special',
    id: 'Khusus',
    kz: 'Арнайы',
    th: 'พิเศษ',
    ug: 'ئالاھىدە',
    vi: 'Đặc biệt',
    zh_tc: '特殊',
    ru: 'Специальный',
    ko: '특별한',
    bur: 'အထူး',
    ben: 'বিশেষ',
    tr: 'Özel',
    km: 'ពិសេស',
    es: 'Especial',
    ar: 'خاص',
  },
  'customizeFolder.surplusText': {
    zh: '余料',
    en: 'Offcuts',
    id: 'Bahan surplus',
    kz: 'Ашық материал',
    th: 'วัสดุส่วนเกิน',
    ug: 'ئازاد مادە',
    vi: 'Vật liệu thặng dư',
    zh_tc: '餘料',
    ru: 'Излишковый материал',
    ko: '잉여 자재',
    bur: 'ပစ္စည်းပိုလျှံ',
    ben: 'অতিরিক্ত উপাদান',
    tr: 'Fazla malzeme',
    km: 'សម្ភារៈលើស',
    es: 'Material excedente',
    ar: 'مادة زائدة',
  },
  'customizeFolder.normalText': {
    zh: '常规',
    en: 'Normal',
    id: 'Normal',
    kz: 'Қалыпты',
    th: 'ปกติ',
    ug: 'ئادەتتىكى',
    vi: 'Bình thường',
    zh_tc: '常規',
    ru: 'Обычный',
    ko: '일반적인',
    bur: 'ပုံမှန်',
    ben: 'স্বাভাবিক',
    tr: 'Normal',
    km: 'ធម្មតា',
    es: 'Normal',
    ar: 'عادي',
  },
  'customizeFolder.plankText1': {
    zh: '板',
    en: 'Board',
    id: 'Papan',
    kz: 'Тақта',
    th: 'แผ่นไม้',
    ug: 'تاختا',
    vi: 'Tấm ván',
    zh_tc: '板',
    ru: 'Доска',
    ko: '판재',
    bur: 'ပေါ်ဒ်',
    ben: 'বোর্ড',
    tr: 'Panel',
    km: 'បន្ទះ',
    es: 'Tablero',
    ar: 'لوح',
  },
  'customizeFolder.resetTemplate': {
    zh: '模板重置',
    en: 'Reset template',
    id: 'Reset template',
    kz: 'Қалпына келтіру үлгісі',
    th: 'รีเซ็ตเทมเพลต',
    ug: 'قاۋۇس قايтарاش',
    vi: 'Đặt lại mẫu',
    zh_tc: '模板重置',
    ru: 'Сброс шаблона',
    ko: '템플릿 초기화',
    bur: 'ပစ္စည်းပိုလျှံ',
    ben: 'স্বাভাবিক',
    tr: 'Normal',
    km: 'ធម្មតា',
    es: 'Restablecer plantilla',
    ar: 'إعادة تعيين القالب',
  },
  'customizeFolder.resetTemplateConfirm': {
    zh: '是否确认重置模板?',
    en: 'Are you sure you want to reset the template?',
    id: 'Apakah Anda yakin ingin mereset template?',
    kz: 'Үлгіні қалпына келтіруге сенімдісіз бе?',
    th: 'คุณต้องการรีเซ็ตเทมเพลตหรือไม่?',
    ug: 'قېلىپنى ئەسلىگە كەلتۈرەمسىز؟',
    vi: 'Bạn có chắc chắn muốn đặt lại mẫu không?',
    zh_tc: '是否確認重置模板?',
    ru: 'Вы уверены, что хотите сбросить шаблон?',
    ko: '템플릿을 초기화하시겠습니까?',
    bur: 'ပုံစံခွက်ကို ပြန်ချိန်ထားကြောင်း အတည်ပြုခဲ့ပြီလား။',
    ben: 'আপনি কি টেমপ্লেটটি রিসেট করতে চান?',
    tr: 'Şablonu sıfırlamak istediğinizden emin misiniz?',
    km: 'តើអ្នកប្រាកដថាចង់កំណត់គំរូឡើងវិញទេ?',
    es: '¿Está seguro de querer restablecer la plantilla?',
    ar: 'هل أنت متأكد من أنك تريد إعادة تعيين القالب؟',
  },
  'customizeFolder.clearTemplate': {
    zh: '模板清空',
    en: 'Clear template',
    id: 'Hapus template',
    kz: 'Үлгіні тазалау',
    th: 'ล้างเทมเพลต',
    ug: 'قېلىپنى تازىلاش',
    vi: 'Xóa mẫu',
    zh_tc: '模板清空',
    ru: 'Очистить шаблон',
    ko: '템플릿 비우기',
    bur: 'ပုံစံခွက်ကို ရှင်းလင်းပါ',
    ben: 'টেমপ্লেট মুছুন',
    tr: 'Şablonu temizle',
    km: 'សម្អាតគំរូ',
    es: 'Vaciar plantilla',
    ar: 'مسح القالب',
  },
  'customizeFolder.clearTemplateConfirm': {
    zh: '是否确认清空模板?',
    en: 'Are you sure you want to clear the template?',
    id: 'Apakah Anda yakin ingin menghapus template?',
    kz: 'Үлгіні тазалауға сенімдісіз бе?',
    th: 'คุณต้องการล้างเทมเพลตหรือไม่?',
    ug: 'قېلىپنى تازىلامسىز؟',
    vi: 'Bạn có chắc chắn muốn xóa mẫu không?',
    zh_tc: '是否確認清空模板?',
    ru: 'Вы уверены, что хотите очистить шаблон?',
    ko: '템플릿을 비우시겠습니까?',
    bur: 'ပုံစံခွက်ကို ရှင်းလင်းရန် သေချာပါသလား။',
    ben: 'আপনি কি টেমপ্লেট মুছতে চান?',
    tr: 'Şablonu temizlemek istediğinizden emin misiniz?',
    km: 'តើអ្នកប្រាកដថាចង់សម្អាតគំរូទេ?',
    es: '¿Está seguro de querer vaciar la plantilla?',
    ar: 'هل أنت متأكد من أنك تريد مسح القالب؟',
  },
  'customizeFolder.legendFixedFolder': {
    zh: '固定文件夹',
    en: 'Fixed folder',
    id: 'Folder tetap',
    kz: 'Бекітілген қаптама',
    th: 'โฟลเดอร์คงที่',
    ug: 'مۇقىم ھۆججەت قىسقۇچ',
    vi: 'Thư mục cố định',
    zh_tc: '固定文件夾',
    ru: 'Фиксированная папка',
    ko: '고정 폴더',
    bur: 'သတ်မှတ်ဖိုင်ဆောင်',
    ben: 'নির্দিষ্ট ফোল্ডার',
    tr: 'Sabit klasör',
    km: 'ថតថេរ',
    es: 'Carpeta fija',
    ar: 'مجلد ثابت',
  },
  'customizeFolder.legendClassifyFolder': {
    zh: '分类文件夹',
    en: 'Classified folder',
    id: 'Folder klasifikasi',
    kz: 'Жіктеу қаптамасы',
    th: 'โฟลเดอร์ที่จำแนกประเภท',
    ug: 'كاتىگورىيىلەنگەن ھۆججەت قىسقۇچ',
    vi: 'Thư mục phân loại',
    zh_tc: '分類文件夾',
    ru: 'Классифицированная папка',
    ko: '분류 폴더',
    bur: 'အမျိုးအစားခွဲထားသော ဖိုင်ဆောင်',
    ben: 'শ্রেণীবদ্ধ ফোল্ডার',
    tr: 'Sınıflandırılmış klasör',
    km: 'ថតដែលបានចំណាត់ថ្នាក់',
    es: 'Carpeta clasificada',
    ar: 'مجلد مصنف',
  },
  'customizeFolder.legendFixedTag': {
    zh: '固定数据',
    en: 'Fixed data',
    id: 'Data tetap',
    kz: 'Бекітілген деректер',
    th: 'ข้อมูลคงที่',
    ug: 'مۇقىم سانلىق مەلۇمات',
    vi: 'Dữ liệu cố định',
    zh_tc: '固定數據',
    ru: 'Фиксированные данные',
    ko: '고정 데이터',
    bur: 'သတ်မှတ်ဒေတာ',
    ben: 'নির্দিষ্ট ডেটা',
    tr: 'Sabit veri',
    km: 'ទិន្នន័យថេរ',
    es: 'Datos fijos',
    ar: 'بيانات ثابتة',
  },
  'customizeFolder.legendNormalTag': {
    zh: '动态数据',
    en: 'Dynamic data',
    id: 'Data dinamis',
    kz: 'Динамикалық деректер',
    th: 'ข้อมูลไดนามิก',
    ug: 'ھەرىكەتچان سانلىق مەلۇمات',
    vi: 'Dữ liệu động',
    zh_tc: '動態數據',
    ru: 'Динамические данные',
    ko: '동적 데이터',
    bur: 'ဒိုင်နမစ်ဒေတာ',
    ben: 'ডায়নামিক ডেটা',
    tr: 'Dinamik veri',
    km: 'ទិន្នន័យថមថយ',
    es: 'Datos dinámicos',
    ar: 'بيانات ديناميكية',
  },
  'customizeFolder.legendClassifyTag': {
    zh: '分类动态数据',
    en: 'Classified dynamic data',
    id: 'Data dinamis klasifikasi',
    kz: 'Жіктеу динамикалық деректері',
    th: 'ข้อมูลไดนามิกที่จำแนกประเภท',
    ug: 'كاتىگورىيىلەنگەن ھەرىكەتچان سانلىق مەلۇمات',
    vi: 'Dữ liệu động phân loại',
    zh_tc: '分類動態數據',
    ru: 'Классифицированные динамические данные',
    ko: '분류 동적 데이터',
    bur: 'အမျိုးအစားခွဲထားသော ဒိုင်နမစ်ဒေတာ',
    ben: 'শ্রেণীবদ্ধ ডায়নামিক ডেটা',
    tr: 'Sınıflandırılmış dinamik veri',
    km: 'ទិន្នន័យថមថយដែលបានចំណាត់ថ្នាក់',
    es: 'Datos dinámicos clasificados',
    ar: 'بيانات ديناميكية مصنفة',
  },
  'customizeFolder.door_wall_aio': {
    zh: '门墙柜一体机',
    en: 'Door Wall Cabinet',
    id: 'Mesin pintu dinding lemari',
    kz: 'Қабырға және шкафты құрастыру машинасы',
    th: 'เครื่องปรับปรุงผนังและตู้',
    ug: 'ئىشىك-تام-ئىشكاپ بىر گەۋدىلەشكەن ماشىنا',
    vi: 'Máy điều chỉnh tường và tủ',
    zh_tc: '門牆櫃一體機',
    ru: 'Машина для изготовления стен и шкафов',
    ko: '벽과 장롱을 만드는 기계',
    bur: 'တံခါး၊ နံရံနှင့် ဘီရို ပေါင်းစည်းစက်',
    ben: 'দরজা-দেয়াল-ক্যাবিনেট একীভূত মেশিন',
    tr: 'Duvar ve dolap yapan makine',
    km: 'ម៉ាស៊ីនរួមបញ្ចូលទ្វារ ជញ្ជាំង និងទូ',
    es: 'Máquina integrada de puerta, pared y gabinete',
    ar: 'آلة الأبواب والجدران والخزائن المتكاملة',
  },
  'customizeFolder.noPermission': {
    zh: '您当前无自定义文件夹权限，请联系销售购买后使用',
    en: 'You do not have permission to use custom folders. Please contact sales to purchase this feature before using it.',
    id: 'Anda belum memiliki izin folder kustom. Silakan hubungi tim sales untuk membeli fitur ini sebelum digunakan.',
    kz: 'Сізде қазір реттелетін қалталарды пайдалану рұқсаты жоқ. Пайдаланбас бұрын бұл функцияны сатып алу үшін сату бөліміне хабарласыңыз.',
    th: 'ขณะนี้คุณไม่มีสิทธิ์ใช้งานโฟลเดอร์แบบกำหนดเอง โปรดติดต่อฝ่ายขายเพื่อซื้อก่อนใช้งาน',
    ug: 'نۆۋەتتە سىزدە خاسلاشتۇرۇلغان ھۆججەت قىسقۇچ ئىشلىتىش ھوقۇقى يوق. ئىشلىتىشتىن بۇرۇن سېتىش خادىملىرى بىلەن ئالاقىلىشىپ سېتىۋېلىڭ.',
    vi: 'Hiện bạn không có quyền sử dụng thư mục tùy chỉnh. Vui lòng liên hệ bộ phận kinh doanh để mua trước khi sử dụng.',
    zh_tc: '您目前無自訂資料夾權限，請聯繫銷售購買後使用',
    ru: 'У вас нет разрешения на использование пользовательских папок. Перед использованием обратитесь в отдел продаж для покупки этой функции.',
    ko: '현재 사용자 지정 폴더 권한이 없습니다. 사용 전 영업팀에 문의하여 구매해 주세요.',
    bur: 'လက်ရှိတွင် စိတ်ကြိုက်ဖိုင်တွဲ အသုံးပြုခွင့် မရှိပါ။ အသုံးမပြုမီ ဝယ်ယူရန် အရောင်းဌာနကို ဆက်သွယ်ပါ။',
    ben: 'বর্তমানে আপনার কাস্টম ফোল্ডার ব্যবহারের অনুমতি নেই। ব্যবহারের আগে এটি কিনতে সেলস টিমের সঙ্গে যোগাযোগ করুন।',
    tr: 'Şu anda özel klasör kullanma izniniz yok. Kullanmadan önce satın almak için lütfen satış ekibiyle iletişime geçin.',
    km: 'បច្ចុប្បន្នអ្នកមិនមានសិទ្ធិប្រើថតផ្ទាល់ខ្លួនទេ។ សូមទាក់ទងផ្នែកលក់ដើម្បីទិញមុនពេលប្រើ។',
    es: 'No tienes permiso para usar carpetas personalizadas. Comunícate con ventas para comprar esta función antes de usarla.',
    ar: 'ليس لديك حاليًا صلاحية استخدام المجلدات المخصصة. يرجى الاتصال بالمبيعات لشراء هذه الميزة قبل استخدامها.',
  },
  'customizeFolder.enableCustomFolder': {
    zh: '开启文件夹自定义',
    en: 'Enable custom folders',
    id: 'Aktifkan folder kustom',
    kz: 'Қалталарды өзгерту рұқсатын қосу',
    th: 'เปิดใช้งานโฟลเดอร์แบบกำหนดเอง',
    ug: 'خاسلاشتۇرۇلغان ھۆججەت قىسقۇچ ئىشلىتىش قوشۇش',
    vi: 'Bật thư mục tùy chỉnh',
    zh_tc: '開啟文件夾自定義',
    ru: 'Включить пользовательские папки',
    ko: '사용자 지정 폴더 활성화',
    bur: 'စိတ်ကြိုက်ဖိုင်တွဲ ဖွင့်ပါ',
    ben: 'কাস্টম ফোল্ডার সক্ষম করুন',
    tr: 'Özel klasörleri etkinleştir',
    km: 'ថតផ្ទាល់ខ្លួនទៅសាកល្បង',
    es: 'Habilitar carpetas personalizadas',
    ar: 'تمكين المجلدات المخصصة',
  },
  'paibanTask.pausedTip': {
    zh: '已暂停任务',
    en: 'Paused Task',
    id: 'Tugas yang Ditangguhkan',
    kz: 'Geciktirilgen Veziyyet',
    th: 'งานที่หยุดชั่วคราว',
    ug: 'توقف شدۇق ھەقلىق',
    vi: 'Tác vụ đã dừng',
    zh_tc: '已暫停任務',
    ru: 'Приостановленные задачи',
    ko: '일시 중지된 작업',
    bur: 'ပိတ်ထားသော အလုပ်',
    ben: 'বন্ধ করা কাজ',
    tr: 'Duraklatılmış Görevler',
    km: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    es: 'Máquina integrada de puerta, pared y gabinete',
    ar: 'آلة الأبواب والجدران والخزائن المتكاملة',
  },
  'paibanTask.deleteTip': {
    zh: '确定删除任务「{taskBatch}」吗？删除后不可恢复。',
    en: 'Are you sure you want to delete the task "{taskBatch}"? It cannot be recovered after deletion.',
    id: 'Apakah Anda yakin ingin menghapus tugas "{taskBatch}"? Tugas ini tidak dapat dipulihkan setelah dihapus.',
    kz: '«{taskBatch}» тапсырмасын өшіруге қандай да бір қате жіберілді. Өшіруді қайтару мүмкін емес.',
    th: 'คุณต้องการลบงาน «{taskBatch}» หรือไม่? งานนี้ไม่สามารถดำเนินการได้อีกหลังจากลบ',
    ug: '«{taskBatch}» ھەقلىقنى ئۆچۈرۈشكە قانداق بىر قاتتىق ئەڭگە بولىدۇ. ئۆچۈرۈشدىن كېيىن ئۆچۈرۈلمەيدىغان.',
    vi: 'Bạn có chắc chắn muốn xóa tác vụ "{taskBatch}"? Tác vụ này không thể được khôi phục sau khi xóa',
    zh_tc: '確定刪除任務「{taskBatch}」嗎？刪除後不可恢復。',
    ru: 'Вы уверены, что хотите удалить задачу «{taskBatch}»? После удаления восстановление невозможно.',
    ko: '«{taskBatch}» 작업을 삭제하시겠습니까? 삭제 후에는 복구할 수 없습니다.',
    ben: '«{taskBatch}» কাজটি মুছে ফেলা আপনার চেষ্টা করবেন কি? মুছে ফেলার পরে পুনরুদ্ধার করা সম্ভব নয়।',
    tr: '«{taskBatch}» görevini silmek istediğinize emin misiniz? Silindiğinden sonra geri alınamaz.',
    km: 'តើអ្នកប្រាកដថាចង់លុបភារកិច្ច «{taskBatch}» ទេ? បន្ទាប់ពីលុបហើយ មិនអាចស្ដារឡើងវិញបានទេ។',
    es: '¿Está seguro de querer eliminar la tarea «{taskBatch}»? No se puede recuperar después de la eliminación.',
    ar: 'هل أنت متأكد من أنك تريد حذف المهمة «{taskBatch}»؟ لا يمكن استرجاعها بعد الحذف.',
  },
  'paibanTask.continueTip': {
    zh: '继续排版任务',
    en: 'Continue Task',
    id: 'Lanjutkan Tugas',
    kz: 'Veziyyeti davam ettir',
    th: 'งานต่อไป',
    ug: 'توقف شدۇق ھەقلىقنى ئۈچۈرۈش',
    vi: 'Tiếp tục tác vụ',
    zh_tc: '繼續排版任務',
    ru: 'Продолжить задачу',
    ko: '작업 계속',
    bur: 'အလုပ်ကို ဆက်သွယ်ပါ',
    ben: 'কাজ চালু করুন',
    tr: 'Görevi sürdür',
    km: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    es: 'Continuar con la tarea',
    ar: 'استمرار المهمة',
  },
  'paibanTask.completed': {
    zh: '已完成',
    en: 'Completed',
    id: 'Selesai',
    kz: 'Tamamlandı',
    th: 'เสร็จสิ้น',
    ug: 'تۇتۇلدى',
    vi: 'Hoàn thành',
    zh_tc: '已完成',
    ru: 'Выполнено',
    ko: '완료',
    bur: 'အောင်မြင်ခဲ့သည်',
    ben: 'সমাপ্ত',
    tr: 'Tamamlandı',
    km: 'បានសិក្សាសិទ្ធ',
    es: 'Completado',
    ar: 'مكتمل',
  },
  'paibanTask.failed': {
    zh: '任务失败',
    en: 'Task Failed',
    id: 'Tugas Gagal',
    kz: 'Veziyyet sığıncaqlandı',
    th: 'งานล้มเหลว',
    ug: 'ھەقلىق ئەڭگە بولىدۇ',
    vi: 'Tác vụ thất bại',
    zh_tc: '任務失敗',
    ru: 'Задача не выполнена',
    ko: '작업 실패',
    bur: 'အလုပ်မအောင်မြင်ခဲ့သည်',
    ben: 'কাজ ব্যর্থ',
    tr: 'Görev başarısız',
    km: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    es: 'Tarea fallida',
    ar: 'مهمة فاشلة',
  },
  'paibanTask.paused': {
    zh: '暂停中',
    en: 'Paused',
    id: 'Ditangguhkan',
    kz: 'Geciktirilgen Veziyyet',
    th: 'งานที่หยุดชั่วคราว',
    ug: 'توقف شدۇق ھەقلىق',
    vi: 'Tác vụ đã dừng',
    zh_tc: '暫停中',
    ru: 'Приостановленные задачи',
    ko: '일시 중지된 작업',
    bur: 'ပိတ်ထားသော အလုပ်',
    ben: 'বন্ধ করা কাজ',
    tr: 'Duraklatılmış Görevler',
    km: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    es: 'Pausado',
    ar: 'مهمة موقوفة',
  },
  'paibanTask.pending': {
    zh: '等待中',
    en: 'Pending',
    id: 'Menunggu',
    kz: 'Kelgen Veziyyet',
    th: 'งานที่รอการดำเนินการ',
    ug: 'تۇتۇلمايدىغان ھەقلىق',
    vi: 'Tác vụ đang chờ',
    zh_tc: '等待中',
    ru: 'Ожидание задачи',
    ko: '대기 중인 작업',
    bur: 'အလုပ်ကို ဆက်သွယ်ပါ',
    ben: 'কাজ চালু করুন',
    tr: 'Görevi sürdür',
    km: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    es: 'Pendiente',
    ar: 'معلق',
  },
  'paibanTask.running': {
    zh: '排版中',
    en: 'Running',
    id: 'Berjalan',
    kz: 'Davom ettirilgen Veziyyet',
    th: 'งานที่กำลังดำเนินการ',
    ug: 'ئۈچۈرۈشكە ھەقلىق',
    vi: 'Tác vụ đang chạy',
    zh_tc: '排版中',
    ru: 'Выполнение задачи',
    ko: '작업 진행 중',
    bur: 'အလုပ်ကို ဆက်သွယ်ပါ',
    ben: 'কাজ চালু করুন',
    tr: 'Görevi sürdür',
    km: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    es: 'En ejecución',
    ar: 'في التشغيل',
  },
  'paibanTask.extraTip': {
    zh: '排版任务仅展示最近一周的数据，请完成任务后手动将任务保存至历史！',
    en: 'The layout task only shows the data of the past week. Please manually save the task to history after completion!',
    id: 'Tugas tata letak hanya menampilkan data minggu lalu. Silakan simpan tugas ke riwayat setelah selesai!',
    kz: 'Макет тапсырмасы тек өткен аптаға ғана көрсетіледі. Тапсырманы аяқтаңыздан кейін оны өтінішке қойыңыз!',
    th: 'งานการจัดวางแผนที่แสดงเฉพาะข้อมูลสำหรับสัปดาห์ที่แล้ว โปรดบันทึกงานเป็นประวัติหลังจากการสำเร็จ!',
    ug: 'پۇل ھەقلىق ئىچىدىن ئالاقى كىيىن ئىشلىتىشتىن قبل ھەقلىقنى تۇتۇلمايدىغان كىيىكى ئايدىلار ئىچىدىن كېيىن قوشۇلغان. ئىشلىتىشتىن قبل ھەقلىقنى تۇتۇلمايدىغان كىيىكى ئايدىلار ئىچىدىن كېيىن قوشۇلغان.',
    vi: 'Nhiệm vụ bố trí chỉ hiển thị dữ liệu của tuần trước. Vui lòng lưu nhiệm vụ vào lịch sử sau khi hoàn thành!',
    zh_tc: '排版任務僅展示最近一周的數據，請完成任務後手動將任務保存至歷史！',
    ru: 'Задача компоновки показывает данные только за прошедшую неделю. Пожалуйста, сохраните задачу в историю после завершения!',
    ko: '배치 작업은 지난 일주일 데이터만 표시됩니다. 작업을 완료한 후 수동으로 작업을 저장하십시오!',
    bur: 'ပုံတည်ချက်သည် အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    ben: 'প্ল্যানিং টাস্ক শুধুমাত্র গত সপ্তাহের ডেটা দেখায়। টাস্ক সম্পন্ন করার পর এটি হাতের হাতে সংরক্ষণ করুন!',
    tr: 'Düzenleme görevleri sadece geçen haftanın verilerini gösterir. Görev tamamlandıktan sonra el ile görevi geçmişe kaydedin!',
    km: 'ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    es: 'La tarea de disposición solo muestra los datos de la semana pasada. Por favor, guarde la tarea en el historial después de completarla!',
    ar: 'مهمة التخطيط فقط تعرض البيانات للأسبوع الماضي. يرجى حفظ المهمة في السجل بعد الانتهاء!',
  },
  'paibanTask.taskStatus': {
    zh: '任务状态',
    en: 'Task Status',
    id: 'Status Tugas',
    kz: 'Veziyyet statusi',
    th: 'สถานะงาน',
    ug: 'ھەقلىق سىناقى',
    vi: 'Trạng thái tác vụ',
    zh_tc: '任務狀態',
    ru: 'Статус задачи',
    ko: '작업 상태',
    bur: 'အလုပ်အခြေခံ',
    ben: 'কাজের অবস্থা',
    tr: 'Görev durumu',
    km: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    es: 'Estado de la tarea',
    ar: 'حالة المهمة',
  },
  'paibanTask.createTaskTip': {
    zh: '创建排版任务，进入后台排版',
    en: 'Create layout task, enter backend layout',
    id: 'Buat tugas tata letak, masuk ke tata letak belakang',
    kz: 'Макет тапсырмасын құру, макеттен кіру',
    th: 'สร้างงานการจัดวางแผนที่, เข้าสู่การจัดวางแผนที่หลัง',
    ug: 'پۇل ھەقلىقنى ئىشلىتىشتىن قبل ھەقلىقنى تۇتۇلمايدىغان كىيىكى ئايدىلار ئىچىدىن كېيىن قوشۇلغان.',
    vi: 'Tạo tác vụ bố trí, vào bố trí sau',
    zh_tc: '創建排版任務，進入後台排版',
    ru: 'Создать задачу компоновки, перейти в компоновку',
    ko: '배치 작업 생성, 배치 후크로 이동',
    bur: 'ပုံတည်ချက်သည် အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    ben: 'প্ল্যানিং টাস্ক তৈরি করুন, প্ল্যানিং পরে যান',
    tr: 'Düzenleme görevini oluştur, düzenlemeye git',
    km: 'សាកលវិញគ្រប់គ្រងសម្រាប់គ្រប់គ្រង',
    es: 'Crear tarea de disposición, entrar a disposición',
    ar: 'إنشاء مهمة التخطيط، الدخول إلى التخطيط',
  },
  'paibanTask.taskBatchTitle': {
    zh: '任务批次',
    en: 'Task batch',
    id: 'Batch tugas',
    kz: 'Тапсырма партиясы',
    th: 'ชุดงาน',
    ug: 'ۋەزىپە تۈركۈمى',
    vi: 'Lô nhiệm vụ',
    zh_tc: '任務批次',
    ru: 'Партия задач',
    ko: '작업 배치',
    bur: 'တာဝန်အစုအဝေး',
    ben: 'টাস্ক ব্যাচ',
    tr: 'Görev partisi',
    km: 'ករណីការងារ',
    es: 'Lote de tareas',
    ar: 'مجموعة مهام',
  },
  'paibanTask.relatedOrderNosTitle': {
    zh: '关联订单号',
    en: 'Related order numbers',
    id: 'Nomor pesanan terkait',
    kz: 'Байланысты тапсырыс нөмірлері',
    th: 'หมายเลขคำสั่งซื้อที่เกี่ยวข้อง',
    ug: 'مۇناسىۋەتلىك زاكاز نومۇرى',
    vi: 'Số đơn hàng liên quan',
    zh_tc: '關聯訂單號',
    ru: 'Связанные номера заказов',
    ko: '관련 주문 번호',
    bur: 'ဆက်စပ်အော်ဒါနံပါတ်များ',
    ben: 'সম্পর্কিত অর্ডার নম্বর',
    tr: 'İlgili sipariş numaraları',
    km: 'លេខបញ្ជាទាក់ទង',
    es: 'Números de pedido relacionados',
    ar: 'أرقام الطلبات المرتبطة',
  },
  'paibanTask.progressTitle': {
    zh: '排版进度',
    en: 'Layout progress',
    id: 'Kemajuan tata letak',
    kz: 'Орналастыру прогрессі',
    th: 'ความคืบหน้าการจัดวาง',
    ug: 'تەرتىپلەش جەريانى',
    vi: 'Tiến độ bố trí',
    zh_tc: '排版進度',
    ru: 'Прогресс компоновки',
    ko: '배치 진행률',
    bur: 'အပြင်အဆင်တိုးတက်မှု',
    ben: 'লেআউট অগ্রগতি',
    tr: 'Düzenleme ilerlemesi',
    km: 'ដំណើរការប្លង់',
    es: 'Progreso de disposición',
    ar: 'تقدم التخطيط',
  },
  'paibanTask.boardCountTitle': {
    zh: '大板用量估算',
    en: 'Board usage estimation',
    id: 'Estimasi penggunaan papan',
    kz: 'Тақта мөлшеріны бағалау',
    th: 'ประมาณการการใช้แผ่น',
    ug: 'چوڭ تاختا ئىشلىتىلىشى پارامېترلىرى بويىڭان',
    vi: 'Lượng tấm lớn tính toán',
    zh_tc: '大板用量估算',
    ru: 'Расход плит оценивается',
    ko: '보드 사용량 추정',
    bur: 'ဘုတ်အသုံးပြုမှု ဗဟိုင်းစွာပြုလုပ်ထားသောဧရိယာ',
    ben: 'বোর্ড ব্যবহার গণনা করা হয়নি။',
    tr: 'Levha kullanımı tahmini',
    km: 'ការប្រើប្រាស់ក្តារធំជាក់លាក់',
    es: 'Uso de tablero estimado',
    ar: 'استخدام اللوح المحدد',
  },
  'paibanTask.optimizedAreaTitle': {
    zh: '优化面积估算',
    en: 'Optimized area estimation',
    id: 'Estimasi area yang dioptimalkan',
    kz: 'Оптимизацияланған ауданны бағалау',
    th: 'ประมาณการพื้นที่ที่เพิ่มประสิทธิภาพแล้ว',
    ug: 'optimizatsiya قىلىنغان رايون پارامېترلىرى بويىڭان',
    vi: 'Diện tích đã tối ưu tính toán',
    zh_tc: '優化面積估算',
    ru: 'Оценка оптимизированной площади',
    ko: '최적화된 면적 추정',
    bur: 'ဘုတ်အကောင်းဆုံးဖြစ်အောင်လုပ်ထားသောဧရိယာ',
    ben: 'অপ্টিমাইজড এলাকা গণনা করা হয়নি။',
    tr: 'Optimize edilmiş alan tahmini',
    km: 'ការបង្កើនប្រសិទ្ធភាពក្តារធំ',
    es: 'Área optimizada estimada',
    ar: 'مساحة التحسين المحددة',
  },
  'paibanTask.productionLineTitle': {
    zh: '生产线',
    en: 'Line',
    id: 'Lini produksi',
    kz: 'Өндіріс желісі',
    th: 'สายการผลิต',
    ug: 'ئىshlab چىقىرىش لىنىيەسى',
    vi: 'Dây chuyền sản xuất',
    zh_tc: '生產線',
    ru: 'Производственная линия',
    ko: '생산 라인',
    bur: 'ထုတ်လုပ်ရေးလိုင်း',
    ben: 'উৎপাদন লাইন',
    tr: 'Üretim hattı',
    km: 'ខ្សែសង្វាក់ផលិត',
    es: 'Línea de producción',
    ar: 'خط الإنتاج',
  },
  'paibanTask.operationTitle': {
    zh: '操作',
    en: 'Actions',
    id: 'Operasi',
    kz: 'Әрекет',
    th: 'การดำเนินการ',
    ug: 'مەشغۇلات',
    vi: 'Thao tác',
    zh_tc: '操作',
    ru: 'Действия',
    ko: '작업',
    bur: 'လုပ်ဆောင်ချက်',
    ben: 'অপারেশন',
    tr: 'İşlem',
    km: 'ប្រតិបត្តិការ',
    es: 'Acciones',
    ar: 'الإجراءات',
  },
  'paibanTask.optimizeRateTitle': {
    zh: '优化率估算',
    en: 'Optimization rate estimation',
    id: 'Estimasi tingkat optimasi',
    kz: 'Оптимизация деңгейін бағалау',
    th: 'ประมาณการอัตราการเพิ่มประสิทธิภาพ',
    ug: 'ئۈنۈملۈك نىسبىتى باھالاش',
    vi: 'Ước tính tỷ lệ tối ưu',
    zh_tc: '优化率估算',
    ru: 'Оценка коэффициента оптимизации',
    ko: '최적화율 추정',
    bur: 'ဘုတ်အကောင်းဆုံးဖြစ်အောင်လုပ်ခြင်းနှုန်းကို ရှင်းလင်းစစ်ဆေးပါ',
    ben: 'বোর্ড অপ্টিমাইজেশন হার গণনা করা হয়নি။',
    tr: 'Levha optimizasyon oranını tahmin et',
    km: 'បង្កើនប្រសិទ្ធភាពក្តារធំការបង្កើនប្រសិទ្ធភាពក្តារធំ',
    es: 'Estimación de tasa de optimización',
    ar: 'تقدير معدل التحسين',
  },
  'paibanTask.optimizeRateTip': {
    zh: '未计算自动裁剪余料利用率',
    en: 'The optimization rate of automatically cut surplus material is not calculated.',
    id: 'Tingkat optimasi material sisa yang dipotong secara otomatis tidak dihitung.',
    kz: 'Автоматтық қиылысқан материалдың оптимизация деңгейі есептелмейді.',
    th: 'อัตราการเพิ่มประสิทธิภาพของวัสดุส่วนเกินที่ตัดอัตโนมัติไม่ถูกคำนวณ',
    ug: 'ئىشلىتىشتىن قبل ھەقلىقنى تۇتۇلمايدىغان كىيىكى ئايدىلار ئىچىدىن كېيىن قوشۇلغان.',
    vi: 'Tỷ lệ tối ưu của vật liệu dư thừa được cắt tự động không được tính toán.',
    zh_tc: '未計算自動裁剪餘料利用率',
    ru: 'Оптимизация автоматически вырезанных излишков материала не учитывается.',
    ko: '자동으로 잘린 낭비 자재의 최적화 비율이 계산되지 않습니다.',
    bur: 'အလုပ်ကို ဆက်သွယ်ပါမှားသည်။အလုပ်ကို ဆက်သွယ်ပါမှားသည်။',
    ben: 'স্থানান্তর করা উপাদানের অপ্টিমাইজেশন হার গণনা করা হয়নি။',
    tr: 'Kesim artıklaması kullanımı hesaplanmamaktadır.',
    km: 'អត្រាបង្កើនប្រសិទ្ធភាពក្តារធំគឺមិនត្រូវបានគូរបាន។',
    es: 'La tasa de optimización de materiales sobrantes cortados automáticamente no se calcula.',
    ar: 'معدل التحسين للمواد الزائدة المقصوصة تلقائيًا لا يتم حسابه.',
  },
  'paibanTask.optimizeRateTip2': {
    zh: '具体优化率以排版页为准',
    en: 'The specific optimization rate is based on the layout page',
    id: 'Tingkat optimasi yang spesifik didasarkan pada halaman tata letak',
    kz: 'Орналастыру параметрлері бойынша жекеленген оптимизация деңгейі',
    th: 'อัตราการเพิ่มประสิทธิภาพที่เฉพาะเจาะจงตามหน้าจัดวาง',
    ug: 'تەرتىپلەش پارامېترلىرى بويىڭان optimizatsiya deңгейى',
    vi: 'Tỷ lệ tối ưu cụ thể dựa trên trang bố trí',
    zh_tc: '具體優化率以排版頁為準',
    ru: 'Оценка коэффициента оптимизации конкретная на основе страницы компоновки',
    ko: '특정 최적화율은 배치 페이지를 기반으로 합니다.',
    bur: 'အပြင်အဆင်တိုးတက်မှုကို အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    ben: 'প্ল্যানিং পেজ ভিত্তিক নির্দিষ্ট অপ্টিমাইজেশন হার',
    tr: 'Düzenleme sayfasına dayalı özel optimizasyon oranı',
    km: 'ការពិន្ទុ: ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    es: 'La tasa de optimización específica se basa en la página de disposición',
    ar: 'معدل التحسين المحدد يعتمد على الصفحة التخطيطية',
  },
  'paibanTask.boardCountTip': {
    zh: '具体大板用量以排版页为准',
    en: 'The specific board usage is based on the layout page',
    id: 'Penggunaan papan yang spesifik didasarkan pada halaman tata letak',
    kz: 'Тақта мөлшері параметрлері бойынша жекеленген',
    th: 'การใช้แผ่นที่เฉพาะเจาะจงตามหน้าจัดวาง',
    ug: 'تاختا ئىشلىتىلىش پارامېترلىرى بويىڭان',
    vi: 'Lượng tấm lớn cụ thể dựa trên trang bố trí',
    zh_tc: '具體大板用量以排版頁為準',
    ru: 'Количество досок конкретное на основе страницы компоновки',
    ko: '배치 페이지를 기반으로 하는 특정 데크 사용량',
    bur: 'အပြင်အဆင်တိုးတက်မှုကို အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    ben: 'প্ল্যানিং পেজ ভিত্তিক নির্দিষ্ট ডেক ব্যবহার',
    tr: 'Düzenleme sayfasına dayalı özel levha kullanımı',
    km: 'បរិមាណប្រើប្រាស់ក្តារធំជាក់លាក់គឺផ្អែកលើទំព័រប្លង់',
    es: 'El uso específico de tableros se basa en la página de disposición',
    ar: 'كمية استخدام اللوح الكبير المحددة تعتمد على صفحة التخطيط',
  },
  'paibanTask.optimizedAreaTip': {
    zh: '具体优化面积以排版页为准',
    en: 'The specific optimized area is based on the layout page',
    id: 'Area yang dioptimalkan yang spesifik didasarkan pada halaman tata letak',
    kz: 'Оптимизацияланған аудан параметрлері бойынша жекеленген',
    th: 'พื้นที่ที่เพิ่มประสิทธิภาพที่เฉพาะเจาะจงตามหน้าจัดวาง',
    ug: 'optimizatsiya قىلىنغان رايون پارامېترلىرى بويىڭان',
    vi: 'Diện tích đã tối ưu cụ thể dựa trên trang bố trí',
    zh_tc: '具體優化面積以排版頁為準',
    ru: 'Оптимизированная площадь конкретная на основе страницы компоновки',
    ko: '최적화된 면적이 배치 페이지를 기반으로 합니다.',
    bur: 'အကောင်းဆုံးဖြစ်အောင်လုပ်ထားသောဧရိယာကို အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    ben: 'প্ল্যানিং পেজ ভিত্তিক নির্দিষ্ট অপ্টিমাইজেশন এলাকা',
    tr: 'Düzenleme sayfasına dayalı özel optimize edilmiş alan',
    km: 'ផ្ទៃដែលបានបង្កើនប្រសិទ្ធភាពក្តារធំការបង្កើនប្រសិទ្ធភាពក្តារធំ',
    es: 'Área optimizada específica se basa en la página de disposición',
    ar: 'المساحة المصممة المحددة يعتمد على الصفحة التخطيطية',
  },
  'paibanTask.paibanSettingTip': {
    zh: '查询到当前任务生产线设置发生过修改，当前排版结果和实际导出生产文件可能存在冲突，建议重新排版生产',
    en: 'The production line settings for the current task have been modified. The current layout results may conflict with the actual production export files. It is recommended to re-layout the production.',
    id: 'Pengaturan produksi garis untuk tugas saat ini telah diubah. Hasil tata letak saat ini mungkin bertentangan dengan file ekspor produksi yang sebenarnya. Disarankan untuk meletakkan ulang produksi.',
    kz: 'Өнім құрылымының параметрлері өзгерген. Текущие результаты компоновки могут конфликтовать с фактическими файлами экспорта производства. Рекомендуется повторная компоновка производства.',
    th: 'การตั้งค่าผลิตภัณฑ์สายการผลิตปัจจุบันได้ถูกแก้ไข ผลลัพธ์การจัดวางแผนปัจจุบันอาจมีปัญหากับไฟล์ส่งออกผลิตภัณฑ์จริง คำแนะนำคือการจัดวางแผนผลิตอีกครั้ง',
    ug: 'ھەقلىق ھەقلىق ئىشلىتىشتىن قبل ھەقلىقنى تۇتۇلمايدىغان كىيىكى ئايدىلار ئىچىدىن كېيىن قوشۇلغان.',
    vi: 'Cấu hình sản xuất dòng sản xuất hiện tại đã bị thay đổi. Kết quả bố trí hiện tại có thể không phù hợp với tệp xuất khẩu sản xuất thực tế. Việc bố trí lại sản xuất được khuyến nghị.',
    zh_tc:
      '查詢到當前任務生產線設置發生過修改，當前排版結果和實際導出生產文件可能存在衝突，建議重新排版生產',
    ru: 'Производственные настройки для текущей задачи были изменены. Текущие результаты компоновки могут конфликтовать с фактическими файлами экспорта производства. Рекомендуется повторная компоновка производства.',
    ko: '현재 작업 생산 라인 설정이 수정되었습니다. 현재 배치 결과는 실제 생산 내보내기 파일과 충돌할 수 있습니다. 생산 재배치를 권장합니다.',
    bur: 'ပုံတည်ချက်သည် အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    ben: 'বর্তমান কাজের প্রোডাকশন লাইন সেটিংস পরিবর্তন করা হয়েছে। বর্তমান লেআউট ফলাফল প্রকৃত উৎপাদন রপ্তানি ফাইলের সাথে দ্বন্দ্বে থাকতে পারে। উৎপাদন পুনরায় লেআউট করার পরামর্শ দেওয়া হচ্ছে।',
    tr: 'Mevcut görev üretim hatının ayarları değişti. Mevcut düzenleme sonuçları üretim dışa aktarım dosyalarıyla çakışabilir. Üretimi yeniden düzenlemeyi öneririz.',
    km: 'ការពិន្ទុ: ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    es: 'Las configuraciones de la línea de producción para la tarea actual han sido modificadas. Los resultados de la disposición actual pueden conflictuar con los archivos de exportación de producción reales. Se recomienda volver a organizar la producción.',
    ar: 'تم تعديل إعدادات خط الإنتاج للمهمة الحالية. قد تتعارض نتائج التخطيط الحالي مع ملفات التصدير الفعلية للإنتاج. يوصى بإعادة تخطيط الإنتاج.',
  },
  'paibanTask.dataException': {
    zh: '数据异常，请刷新页面重试',
    en: 'Data exception, please refresh the page and try again',
    id: 'Kesalahan data, silakan perbarui halaman dan coba lagi',
    kz: 'Деректер аномалиясы, өңдеуді қайта қарап көріңіз',
    th: 'ข้อมูลผิดพลาด โปรดรีเฟรชหน้าและลองใหม่อีกครั้ง',
    ug: 'ئايدىلار ئىچىدىن كېيىن قوشۇلغان.',
    vi: 'Lỗi dữ liệu, vui lòng cập nhật trang và thử lại',
    zh_tc: '數據異常，請刷新頁面重試',
    ru: 'Ошибка данных, пожалуйста, обновите страницу и попробуйте снова',
    ko: '데이터 예외, 페이지를 새로 고치고 다시 시도하십시오.',
    bur: 'အလုပ်ကို ဆက်သွယ်ပါမှားသည်။အလုပ်ကို ဆက်သွယ်ပါမှားသည်။',
    ben: 'ডেটা অসামগ্য, দয়া করে পৃষ্ঠা রিফ্র্যাশ করুন এবং আবার চেষ্টা করুন',
    tr: 'Veri hatası, lütfen sayfayı yenileyin ve tekrar deneyin',
    km: 'ការបង្ហាញទិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    es: 'Excepción de datos, por favor actualice la página y vuelva a intentarlo',
    ar: 'استثناء البيانات، يرجى تحديث الصفحة وإعادة المحاولة',
  },
  'customizeFolder.exporttagTip': {
    zh: '顺带导出标签PDF、图片同时勾选时，默认选择PDF进行发送',
    en: 'When exporting tag PDF and image simultaneously, PDF is sent by default',
    id: 'Saat mengekspor tag PDF dan gambar secara bersamaan, PDF dikirim secara default',
    kz: 'Тег PDF және суретті бір уақытта экспорттағанда, әдепкі бойынша PDF жіберіледі',
    th: 'เมื่อส่งออกแท็ก PDF และรูปภาพพร้อมกัน จะส่ง PDF เป็นค่าเริ่มต้น',
    ug: 'بەلگە PDF ۋە رەسىمنى تەڭ ئېكسپورت قىلغاندا، سۈكۈتتىكى ھالدا PDF نى ئەۋەتىدۇ',
    vi: 'Khi xuất nhãn PDF và hình ảnh đồng thời, PDF được gửi theo mặc định',
    zh_tc: '順帶導出標籤PDF、圖片同時勾選時，預設選擇PDF進行傳送',
    ru: 'При одновременном экспорте тегов PDF и изображений, по умолчанию отправляется PDF',
    ko: '태그 PDF와 이미지를 동시에 내보낼 때, 기본적으로 PDF가 전송됩니다',
    bur: 'တက် PDF နှင့် ပုံတို့ကို တစ်ပြိုင်နက်တည်း တင်ပို့သည့်အခါ၊ PDF ကို မူရင်းအားဖြင့် ပေးပို့သည်',
    ben: 'ট্যাগ পিডিএফ এবং ছবি একসাথে রপ্তানি করার সময়, ডিফল্টভাবে পিডিএফ পাঠানো হয়',
    tr: "Etiket PDF'i ve görüntüyü aynı anda dışa aktarırken, varsayılan olarak PDF gönderilir",
    km: 'នៅពេលនាំចេញស្លាក PDF និងរូបភាពក្នុងពេលតែមួយ PDF ត្រូវបានផ្ញើតាមលំនាំដើម',
    es: 'Al exportar etiqueta PDF e imagen simultáneamente, se envía PDF por defecto',
    ar: 'عند تصدير علامة PDF والصورة في نفس الوقت، يتم إرسال PDF افتراضيًا',
  },
  'moreSettings.reuseMatchingPlankName': {
    zh: '布局复用匹配板件名称',
    en: 'Reuse matching by plank name',
    id: 'Pencocokan kembali berdasarkan nama papan',
    kz: 'Қайта пайдалануда тақтай атауы бойынша сәйкестендіру',
    th: 'จับคู่การนำกลับมาใช้ใหม่ตามชื่อแผ่น',
    ug: 'تاختا نامى بويىچە قايتا ئىشلىتىپ ماسلاشتۇرۇش',
    vi: 'Khớp tái sử dụng theo tên tấm',
    zh_tc: '布局復用匹配板件名稱',
    ru: 'Повторное использование по названию доски',
    ko: '보드 이름으로 재사용 매칭',
    bur: 'ပြားအမည်အရ ပြန်လည်အသုံးပြု ကိုက်ညီခြင်း',
    ben: 'নাম অনুযায়ী পুনঃব্যবহার মিলানো',
    tr: 'Tahta adına göre yeniden kullanım eşleştirme',
    km: 'ការផ្គូរផ្គងការប្រើឡើងវិញតាមឈ្មោះក្ដារ',
    es: 'Reutilización coincidente por nombre de placa',
    ar: 'إعادة استخدام المطابقة حسب اسم اللوحة',
  },
  'moreSettings.reuseMatchingPlankNameTip1': {
    zh: '此功能关闭时，布局复用功能匹配材质、颜色、厚度、长宽、纹理、高光属性相同的小板',
    en: 'When this feature is disabled, layout reuse matches panels with the same material, color, thickness, dimensions, texture, and high-gloss properties',
    id: 'Saat fitur ini dinonaktifkan, guna ulang tata letak mencocokkan panel dengan material, warna, ketebalan, dimensi, tekstur, dan properti kilau tinggi yang sama',
    kz: 'Бұл функция өшірулі кезде, орналастыруды қайта пайдалану материал, түс, қалыңдық, өлшемдер, текстура және жоғары жылтырдық қасиеттері бірдей тақталарды сәйкестендіреді',
    th: 'เมื่อปิดฟีเจอร์นี้ การใช้เลย์เอาต์ซ้ำจะจับคู่แผ่นที่มีวัสดุ สี ความหนา ขนาด พื้นผิว และคุณสมบัติเงาสูงเหมือนกัน',
    ug: 'بۇ فۇنكسىيە تاقالغاندا، ئورۇنلاشتۇرۇشنى قايتا ئىشلىتىش ماتېرىيال، رەڭ، قېلىنلىق، ئۆلچەم، تېكستۇرا ۋە يۇقىرى پارقىراقلىق خۇسۇسىيىتى ئوخشاش تاختايلارنى ماسلاشتۇرىدۇ',
    vi: 'Khi tính năng này tắt, tái sử dụng bố cục khớp các tấm có cùng vật liệu, màu sắc, độ dày, kích thước, vân và thuộc tính bóng cao',
    zh_tc:
      '此功能關閉時，佈局復用功能匹配材質、顏色、厚度、長寬、紋理、高光屬性相同的小板',
    ru: 'При отключении этой функции повторное использование раскладки сопоставляет панели с одинаковыми материалом, цветом, толщиной, размерами, текстурой и свойствами высокого глянца',
    ko: '이 기능이 비활성화되면, 레이아웃 재사용은 재질, 색상, 두께, 크기, 질감 및 고광택 속성이 같은 패널을 매칭합니다',
    bur: 'ဤဝန်ဆောင်မှုပိတ်ထားသောအခါ၊ အခင်းအကျင်း ပြန်လည်အသုံးပြုခြင်းသည် ပစ္စည်း၊ အရောင်၊ အထူ၊ အတိုင်းအတာ၊ အရောင်သန်းနှင့် အမြင့်ပြောင်းဂုဏ်သတ္တိများတူညီသော ပြားများကို ကိုက်ညီမည်',
    ben: 'এই বৈশিষ্ট্যটি নিষ্ক্রিয় থাকলে, লেআউট পুনঃব্যবহার একই উপাদান, রঙ, পুরুত্ব, মাত্রা, টেক্সচার এবং উচ্চ-গ্লস বৈশিষ্ট্য সহ প্যানেল মিলায়',
    tr: 'Bu özellik devre dışı bırakıldığında, düzen yeniden kullanımı aynı malzeme, renk, kalınlık, boyutlar, doku ve yüksek parlaklık özelliklerine sahip panelleri eşleştirir',
    km: 'នៅពេលបិទមុខងារនេះ ការប្រើឡើងវិញនៃប្លង់ផ្គូរផ្គងក្ដារដែលមានសម្ភារៈ ពណ៌ កម្រាស់ ទំហំ វាយនភាព និងលក្ខណៈស្ទន់ខ្ពស់ដូចគ្នា',
    es: 'Cuando esta función está desactivada, la reutilización de diseño coincide con paneles que tienen el mismo material, color, grosor, dimensiones, textura y propiedades de alto brillo',
    ar: 'عند تعطيل هذه الميزة، تطابق إعادة استخدام التخطيط الألواح التي لها نفس المادة واللون والسماكة والأبعاد والملمس وخصائص اللمعان العالي',
  },
  'moreSettings.reuseMatchingPlankNameTip2': {
    zh: '开启此功能时，除上述的匹配条件外，还将增加板件名称的匹配',
    en: 'When this feature is enabled, in addition to the above matching conditions, plank name matching is also added',
    id: 'Saat fitur ini diaktifkan, selain kondisi pencocokan di atas, pencocokan nama papan juga ditambahkan',
    kz: 'Бұл функция қосулы кезде, жоғарыдағы сәйкестендіру шарттарынан басқа, тақтай атауы бойынша сәйкестендіру де қосылады',
    th: 'เมื่อเปิดฟีเจอร์นี้ นอกจากเงื่อนไขการจับคู่ข้างต้นแล้ว ยังเพิ่มการจับคู่ตามชื่อแผ่นอีกด้วย',
    ug: 'بۇ فۇنكسىيە ئوچۇق ۋاقتىدا، يۇقىرىقى ماسلاشتۇرۇش شەرتلىرىدىن سىرت، يەنە تاختا نامى بويىچە ماسلاشتۇرۇش قوشۇلىدۇ',
    vi: 'Khi bật tính năng này, ngoài các điều kiện khớp ở trên, còn thêm khớp theo tên tấm',
    zh_tc: '開啟此功能時，除上述的匹配條件外，還將增加板件名稱的匹配',
    ru: 'При включении этой функции, помимо вышеуказанных условий сопоставления, также добавляется сопоставление по названию доски',
    ko: '이 기능을 활성화하면, 위의 매칭 조건 외에 보드 이름 매칭도 추가됩니다',
    bur: 'ဤဝန်ဆောင်မှုကို ဖွင့်သောအခါ၊ အထက်ပါ ကိုက်ညီမှု စည်းမျဉ်းများအပြင်၊ ပြားအမည် ကိုက်ညီမှုကိုလည်း ထည့်သွင်းမည်',
    ben: 'এই বৈশিষ্ট্যটি সক্রিয় করলে, উপরিউক্ত মিলানোর শর্তগুলি ছাড়াও, প্লেটের নাম মিলানোও যোগ করা হবে',
    tr: 'Bu özellik etkinleştirildiğinde, yukarıdaki eşleştirme koşullarına ek olarak, tahta adı eşleştirme de eklenir',
    km: 'នៅពេលបើកមុខងារនេះ លើសពីលក្ខខណ្ឌផ្គូរផ្គងខាងលើ ការផ្គូរផ្គងតាមឈ្មោះក្ដារក៏ត្រូវបានបន្ថែមផងដែរ',
    es: 'Al activar esta función, además de las condiciones de coincidencia anteriores, también se añade la coincidencia por nombre de placa',
    ar: 'عند تمكين هذه الميزة، بالإضافة إلى شروط التطابق المذكورة أعلاه، يُضاف أيضاً التطابق حسب اسم اللوحة',
  },
  'arrangedPage.influenceTip.surplusCustomTrim2': {
    zh: '余料自定义修边',
    en: 'Surplus custom trim',
    id: 'Pemangkasan kustom surplus',
    kz: 'Қалдықтарды қайта құрастыру',
    th: 'ปรับปรุงการตัดประกอบของส่วนเกิน',
    ug: 'قايتا ئورۇنلاشتۇرۇش ماسلاشتۇرۇش',
    vi: 'Chỉnh sửa cắt thừa',
    zh_tc: '余料自定義修邊',
    ru: 'Изменение размера обрезки остатков',
    ko: '나머지 사용자 정의 가공',
    bur: 'ကျန်းမာရှင်းခြင်းကို အမှန်တကျဆိုးသည်',
    ben: 'অবশিষ্ট কাস্টম ট্রিম',
    tr: 'Artık kalanı özel ayarla',
    km: 'ការកែប្រែការផ្គូរផ្គងការបន្ថែម',
    es: 'Ajuste de corte de sobras personalizado',
    ar: 'تعديل القص الزائد المخصص',
  },
  'arrangedPage.influenceTip.other': {
    zh: '其他可能影响的功能',
    en: 'Other features that may be affected',
    id: 'Fitur lain yang mungkin terpengaruh',
    kz: 'Әсер етуі мүмкін басқа функциялар',
    th: 'ฟังก์ชันอื่นๆ ที่อาจได้รับผลกระทบ',
    ug: 'تەسىرگە ئۇچرىشى مۇمكىن باشقا ئىقتىدارلار',
    vi: 'Các tính năng khác có thể bị ảnh hưởng',
    zh_tc: '其他可能受影響的功能',
    ru: 'Другие функции, которые могут быть затронуты',
    ko: '영향을 받을 수 있는 기타 기능',
    bur: 'အကျိုးသက်ရောက်နိုင်သည့် အခြားလုပ်ဆောင်ချက်များ',
    ben: 'অন্যান্য বৈশিষ্ট্য যা প্রভাবিত হতে পারে',
    tr: 'Etkilenebilecek diğer özellikler',
    km: 'មុខងារផ្សេងទៀតដែលអាចរងផលប៉ះពាល់',
    es: 'Otras funciones que pueden verse afectadas',
    ar: 'ميزات أخرى قد تتأثر',
  },
  'arrangedPage.influenceTip.enabled': {
    zh: '已开启',
    en: 'Enabled',
    id: 'Diaktifkan',
    kz: 'Іске қосылған',
    th: 'เปิดใช้งาน',
    ug: 'ئوچۇق قىلىنغان',
    vi: 'Đã bật',
    zh_tc: '已開啟',
    ru: 'Включено',
    ko: '활성화됨',
    bur: 'ဖွင့်ထားသည်',
    ben: 'সক্রিয় করা হয়েছে',
    tr: 'Etkin',
    km: 'បើកបាន',
    es: 'Activado',
    ar: 'مفعل',
  },
  'arrangedPage.influenceTip.plankThicknessStacking': {
    zh: '锯片厚度排版',
    en: 'Plank thickness stacking',
    id: 'Pemangkasan tebal papan',
    kz: 'Тақта қалыңдығы қайта құрастыру',
    th: 'การตัดประกอบของส่วนเกิน',
    ug: 'قايتا ئورۇنلاشتۇرۇش ماسلاشتۇرۇش',
    vi: 'Chỉnh sửa cắt thừa',
    zh_tc: '锯片厚度排版',
    ru: 'Складывание толщины досок',
    ko: '두께 높이 배치',
    bur: 'ပြားအရောင်ခြင်းကို အမှန်တကျဆိုးသည်',
    ben: 'প্লেটের পুরুত্ব স্ট্যাকিং',
    tr: 'Tahta kalınlığı yığılması',
    km: 'ការផ្គូរផ្គងការបន្ថែម',
    es: 'Apilamiento de grosor de tablero',
    ar: 'ترتيب سمك اللوحات',
  },
  'arrangedPage.influenceTip.edgePreMilling': {
    zh: '封边预铣',
    en: 'Edge banding pre-milling',
    id: 'Pemangkasan tepi papan',
    kz: 'Тақта қабырғасын қайта құрастыру',
    th: 'การตัดประกอบของส่วนเกิน',
    ug: 'قايتا ئورۇنلاشتۇرۇش ماسلاشتۇرۇش',
    vi: 'Chỉnh sửa cắt thừa',
    zh_tc: '封邊預銑',
    ru: 'Предрезка кромок досок',
    ko: '끝면 예제 가공',
    bur: 'ပြားအရောင်ခြင်းကို အမှန်တကျဆိုးသည်',
    ben: 'প্লেটের পুরুত্ব স্ট্যাকিং',
    tr: 'Tahta kalınlığı yığılması',
    km: 'ការផ្គូរផ្គងការបន្ថែម',
    es: 'Apilamiento de grosor de tablero',
    ar: 'ترتيب سمك اللوحات',
  },
  'arrangedPage.influenceTip.multiMaterialCuttingBlade': {
    zh: '多材质下料刀',
    en: 'Multi-material cutting blade',
    id: 'Pisau pemotong multi-material',
    kz: 'Көп материалды қайта құрастыру',
    th: 'การตัดประกอบของส่วนเกิน',
    ug: 'قايتا ئورۇنلاشتۇرۇش ماسلاشتۇرۇش',
    vi: 'Chỉnh sửa cắt thừa',
    zh_tc: '多材質下料刀',
    ru: 'Многоматериальный режущий инструмент',
    ko: '다중 재료 절단 도구',
    bur: 'ပြားအရောင်ခြင်းကို အမှန်တကျဆိုးသည်',
    ben: 'প্লেটের পুরুত্ব স্ট্যাকিং',
    tr: 'Tahta kalınlığı yığılması',
    km: 'ការផ្គូរផ្គងការបន្ថែម',
    es: 'Apilamiento de grosor de tablero',
    ar: 'ترتيب سمك اللوحات',
  },
  'arrangedPage.influenceTip.sawSpecialShapePart': {
    zh: '锯切雕刻机的异形缺口板',
    en: 'Irregular notch panels for saw cutting and engraving machines',
    id: 'Panel takik berbentuk khusus untuk mesin gergaji dan ukir',
    kz: 'Аралау және ою машиналарына арналған пішінді ойықты тақталар',
    th: 'แผ่นรอยบากรูปทรงพิเศษสำหรับเครื่องเลื่อยและแกะสลัก',
    ug: 'ئارلاش ۋە ئويۇش ماشىنىلىرىغا ئىشلىتىلىدىغان ھەر خىل شەكىللىك ئويۇق تاختىلار',
    vi: 'Tấm có rãnh khuyết hình dạng đặc biệt cho máy cưa và khắc',
    zh_tc: '鋸切雕刻機的異形缺口板',
    ru: 'Панели с фигурными вырезами для пильных и гравировальных станков',
    ko: '톱 절단 및 조각기의 특수 형상 노치 판재',
    bur: 'လွှဖြတ်နှင့် ထွင်းစက်များအတွက် ပုံသဏ္ဍာန်မမှန် အပေါက်ပါပြားများ',
    ben: 'করাত কাটা ও খোদাই মেশিনের জন্য বিশেষ আকৃতির খাঁজযুক্ত বোর্ড',
    tr: 'Testere kesim ve oyma makineleri için özel şekilli çentikli levhalar',
    km: 'បន្ទះមានស្នាមកាត់រាងពិសេសសម្រាប់ម៉ាស៊ីនកាត់ និងឆ្លាក់',
    es: 'Tableros con muescas de forma especial para sierras y grabadoras',
    ar: 'ألواح ذات شقوق غير منتظمة لماكينات النشر والنقش',
  },
  'arrangedPage.influenceTip.longPlankCutting': {
    zh: '长板二次加工',
    en: 'Long plank secondary processing',
    id: 'Pemangkasan papan panjang kedua',
    kz: 'Ұзын тақта екінші өңдеу',
    th: 'การตัดประกอบของส่วนเกิน',
    ug: 'قايتا ئورۇنلاشتۇرۇش ماسلاشتۇرۇش',
    vi: 'Chỉnh sửa cắt thừa',
    zh_tc: '長板二次加工',
    ru: 'Двухэтапное обработка длинных досок',
    ko: '긴 판재 이차 가공',
    bur: 'ပြားအရောင်ခြင်းကို အမှန်တကျဆိုးသည်',
    ben: 'দীর্ঘ প্লেটের দ্বিতীয় প্রক্রিয়া',
    tr: 'Uzun tahta ikinci işleme',
    km: 'ការផ្គូរផ្គងការបន្ថែម',
    es: 'Procesamiento secundario de tableros largos',
    ar: 'تعديل ثاني للوحات طويلة',
  },

  'paibanSetting.advancedSetting': {
    zh: '高级设置',
    en: 'Advanced setting',
    id: 'Pengaturan lanjutan',
    kz: 'Қосымша параметрлер',
    th: 'ตั้งค่าขั้นสูง',
    ug: 'ئاددى ئاددى',
    vi: 'Cấu hình nâng cao',
    zh_tc: '高級設置',
    ru: 'Расширенные настройки',
    ko: '고급 설정',
    bur: 'မြင့်မားသော ပုံတည်ချက်များ',
    ben: 'উন্নত সেটিংস',
    tr: 'Gelişmiş ayarlar',
    km: 'ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    es: 'Configuración avanzada',
    ar: 'الإعدادات المتقدمة',
  },
  // 高级功能
  'paibanSetting.advancedFeature': {
    zh: '高级功能',
    en: 'Advanced feature',
    id: 'Fitur lanjutan',
    kz: 'Қосымша құралдар',
    th: 'คุณสมบัติขั้นสูง',
    ug: 'ئاددى ئاددى',
    vi: 'Tính năng nâng cao',
    zh_tc: '高級功能',
    ru: 'Расширенные функции',
    ko: '고급 기능',
    bur: 'မြင့်မားသော ပုံတည်ချက်များ',
    ben: 'উন্নত সেটিংস',
    tr: 'Gelişmiş özellikler',
    km: 'ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    es: 'Características avanzadas',
    ar: 'الميزات المتقدمة',
  },
  // 余料切割智能提速
  'paibanSetting.surplusCutSpeedUp': {
    zh: '余料切割智能提速',
    en: 'Surplus cut speed up',
    id: 'Peningkatan kecepatan potongan sisa',
    kz: 'Қалдық қиылудың автоматтық жылдамдауы',
    th: 'การเพิ่มความเร็วการตัดของวัสดุส่วนเกิน',
    ug: 'ئايدىلار ئىچىدىن كېيىن قوشۇلغان.',
    vi: 'Tăng tốc độ cắt vật liệu dư thừa',
    zh_tc: '余料切割智能提速',
    ru: 'Автоматическое ускорение резки остатков',
    ko: '자동 속도 증가 잔여 재료 절단',
    bur: 'အလုပ်ကို ဆက်သွယ်ပါမှားသည်။အလုပ်ကို ဆက်သွယ်ပါမှားသည်။',
    ben: 'বর্তমান কাজের প্রোডাকশন লাইন সেটিংস পরিবর্তন করা হয়েছে। বর্তমান লেআউট ফলাফল প্রকৃত উৎপাদন রপ্তানি ফাইলের সাথে দ্বন্দ্বে থাকতে পারে। উৎপাদন পুনরায় লেআউট করার পরামর্শ দেওয়া হচ্ছে।',
    tr: 'Kalan malzeme kesiminin otomatik hızlandırılması',
    km: 'ការពិន្ទុ: ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    es: 'Aceleración automática de corte de sobras',
    ar: 'تسريع القص الآلي للمواد الزائدة',
  },
  // 功能开发中，敬请期待
  'paibanSetting.surplusCutSpeedUpTip4': {
    zh: '功能开发中，敬请期待',
    en: 'Feature development in progress, please wait',
    id: 'Pengembangan fitur sedang berlangsung, mohon tunggu',
    kz: 'Құралдарын дамытуда, күте тұрыңыз',
    th: 'การพัฒนาคุณสมบัติกำลังดำเนินการ โปรดรอ',
    ug: 'ئاددى ئاددى قىلىشىدە كىتىپ كېلىپ بولۇپ, كىتىپ كېلىپ بولۇپ.',
    vi: 'Tính năng đang phát triển, vui lòng chờ',
    zh_tc: '功能開發中,敬請期待',
    ru: 'Разработка функции в процессе, пожалуйста, подождите',
    ko: '기능 개발 중, 잠시 후 다시 시도해주세요',
    bur: 'လုပ်ဆောင်ချက်ဖြစ်စေရန် အဆင့်မြှင့်တင်နေပါသည်။ မကြာခင်တွေ့ရအောင်မြင်ပါစေ။',
    ben: 'ফিচার ডেভেলপমেন্ট চলছে, দয়া করে অপেক্ষা করুন',
    tr: 'Özellik geliştirme sürecinde, lütfen bekleyin',
    km: 'ការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។ សម្រាប់បង្ហាញការពិន្ទុទិនបង្ហាញទិន្ទុនាក់ចាប់ផ្ដើមពីសប្តាហ៍ដំបូងទៀត។',
    es: 'La funcionalidad está en desarrollo, por favor espere',
    ar: 'الميزة قيد التطوير، يرجى الإنتظار',
  },
  // 余料排版间隙自动为0
  'paibanSetting.surplusCutSpeedUpTip': {
    zh: '余料排版间隙自动为0',
    en: 'Surplus layout gap is automatically set to 0',
    id: 'Jarak tata letak sisa secara otomatis diatur ke 0',
    kz: 'Қалдық орналастыру аралығы автоматты түрде 0 болады',
    th: 'ช่องว่างการจัดวางวัสดุส่วนเกินถูกตั้งค่าเป็น 0 โดยอัตโนมัติ',
    ug: 'قالدۇق ئورۇنلاشتۇرۇش ئارىلىقى ئاپتوماتىك 0 بولىدۇ',
    vi: 'Khoảng cách bố trí vật liệu dư tự động đặt thành 0',
    zh_tc: '余料排版間距自動為0',
    ru: 'Зазор при раскладке остатков автоматически устанавливается в 0',
    ko: '자투리 배치 간격이 자동으로 0으로 설정됩니다',
    bur: 'ပိုလျှံပစ္စည်း အပြင်အဆင် အကွာအဝေးကို အလိုအလျောက် 0 သတ်မှတ်သည်',
    ben: 'অবশিষ্ট উপাদানের লেআউট ফাঁক স্বয়ংক্রিয়ভাবে 0 সেট হয়',
    tr: 'Artık malzeme yerleşim aralığı otomatik olarak 0 yapılır',
    km: 'ចន្លោះប្លង់សម្ភារៈសល់ត្រូវបានកំណត់ជា 0 ដោយស្វ័យប្រវត្តិ',
    es: 'El espacio de disposición de sobras se establece automáticamente en 0',
    ar: 'يتم ضبط فجوة تخطيط المواد المتبقية تلقائيًا على 0',
  },
  // 余料切割自动跳过已切及修边路径，提升余料裁剪效率
  'paibanSetting.surplusCutSpeedUpTip2': {
    zh: '余料切割自动跳过已切及修边路径，提升余料裁剪效率',
    en: 'Surplus cutting automatically skips already-cut and edge-trimming paths to improve cutting efficiency',
    id: 'Pemotongan sisa secara otomatis melewati jalur yang sudah dipotong dan jalur trimming tepi untuk meningkatkan efisiensi',
    kz: 'Қалдық кесу автоматты түрде кесілген және жиектеу жолдарын өткізіп, кесу тиімділігін арттырады',
    th: 'การตัดวัสดุส่วนเกินจะข้ามเส้นทางที่ตัดแล้วและเส้นทางแต่งขอบโดยอัตโนมัติ เพื่อเพิ่มประสิทธิภาพการตัด',
    ug: 'قالدۇق كېسىش ئاپتوماتىك كېسىلگەن ۋە گىرۋەك ئاشۇرۇش يولىنى ئاتلاپ، كېسىش ئۈنۈمىنى ئۆستۈرىدۇ',
    vi: 'Cắt vật liệu dư tự động bỏ qua đường đã cắt và đường xén cạnh để nâng cao hiệu suất cắt',
    zh_tc: '余料切割自動跳過已切及修邊路徑，提升余料裁剪效率',
    ru: 'Резка остатков автоматически пропускает уже прорезанные и подкроечные траектории, повышая эффективность',
    ko: '자투리 절단 시 이미 절단된 경로와 마감 경로를 자동으로 건너뛰어 절단 효율을 높입니다',
    bur: 'ပိုလျှံပစ္စည်းဖြတ်တောက်မှုသည် ဖြတ်ပြီးသားနှင့် အနားသတ်လမ်းကြောင်းများကို အလိုအလျောက်ကျော်၍ ထိရောက်မှုကို မြှင့်တင်သည်',
    ben: 'অবশিষ্ট কাটিং ইতিমধ্যে কাটা ও কিনারা পরিষ্কারের পথ স্বয়ংক্রিয়ভাবে এড়িয়ে কাটার দক্ষতা বাড়ায়',
    tr: 'Artık malzeme kesimi, verimliliği artırmak için kesilmiş ve kenar düzeltme yollarını otomatik olarak atlar',
    km: 'ការកាត់សម្ភារៈសល់នឹងរំលងផ្លូវដែលបានកាត់ និងផ្លូវច្នៃគែមដោយស្វ័យប្រវត្តិ ដើម្បីបង្កើនប្រសិទ្ធភាព',
    es: 'El corte de sobras omite automáticamente rutas ya cortadas y de refilado para mejorar la eficiencia',
    ar: 'قص المواد المتبقية يتجاوز تلقائيًا المسارات المقطوعة ومسارات تشذيب الحواف لتحسين الكفاءة',
  },
  // 该功能仅对雕刻机与一拖二雕刻机生效（请勿与共边切割，共边加速功能一起使用）
  'paibanSetting.surplusCutSpeedUpTip3': {
    zh: '该功能仅对雕刻机与一拖二雕刻机生效（请勿与共边切割，共边加速功能一起使用）',
    en: 'This feature only works for engraving machines and one-turn engraving machines (do not use with common-edge cutting or common-edge acceleration)',
    id: 'Fitur ini hanya berfungsi untuk mesin engraving dan mesin engraving satu putaran (jangan gunakan bersama dengan pemotongan tepi umum atau percepatan tepi umum)',
    kz: 'Бұл функция тек гравировальдық машиналар мен бір айналым гравировальдық машиналар үшін әрекет етеді (ортақ кесу және ортақ кесу жылдамдығымен бірге қолдануды қолдамайды)',
    th: 'ฟังก์ชันนี้สำหรับเครื่องกลึงอักษรและเครื่องกลึงอักษรหนึ่งรอบเท่านั้น (ไม่ให้ใช้ร่วมกับการตัดขอบทั่วไปหรือการเร่งความเร็วขอบทั่วไป)',
    ug: 'بۇ ئىقتىدار ھازىرچە لازېر بىرلىك ماشىنىسى، ۋە ھەرە ئويما ماشىنىسى بىلەن قوللىنىدۇ (ئورتاق چېگرا قېپىش ۋە ئورتاق تېزلىتىش ئىقتىدارلىرى بىلەن بىللە ئىشلىتىشنى قوللىمايدۇ)',
    vi: 'Tính năng này chỉ hoạt động cho máy cắt khắc và máy cắt khắc một vòng (không sử dụng cùng với cắt cạnh chung hoặc tăng tốc cạnh chung)',
    zh_tc:
      '該功能僅對雕刻機與一拖二雕刻機生效（請勿與共邊切割，共邊加速功能一起使用）',
    ru: 'Эта функция работает только для гравировальных машин и машин гравирования с одним поворотом (не используйте вместе с общим резом или общим ускорением)',
    ko: '이 기능은 조각기와 한 바퀴 조각기에만 적용됩니다 (공통 모서리 컷 및 공통 모서리 가속과 함께 사용하지 마세요)',
    bur: 'ဤလုပ်ဆောင်ချက်သည် အောင်မြင်သည်အထိုင်းအမှတ်များအတွက်ထားသည် (အပြိုင်အစွန်းဖြတ်နှင့်အပြိုင်အစွန်းအရှိန်မြှင့်လုပ်ဆောင်ချက်များနှင့်အတူအသုံးမပြုနိုင်သေးပါ)',
    ben: 'করাত এনগ্রেভিং মেশিন এবং একটি ঘূর্ণন করাত এনগ্রেভিং মেশিনের জন্য উপযোগিতার জন্য',
    tr: 'Bu özellik yalnızca işleme makineleri ve bir dönüş işleme makineleri için geçerlidir (ortak kenar kesim ve ortak kenar hızlandırma ile birlikte kullanmayın)',
    km: 'មុខងារនេះបច្ចុប្បន្នមិនគាំទ្រការប្រើជាមួយម៉ាស៊ីនឡាស៊ែររួមមួយ ម៉ាស៊ីនកាត់និងចុកចាក់ ការកាត់គែមរួម និងការបង្កើនល្បឿនគែមរួមទេ',
    es: 'Esta función solo funciona para máquinas de grabado y máquinas de grabado de una vuelta (no use con corte de borde común o aceleración de borde común)',
    ar: 'هذه الميزة لا تعمل مع الآلات التشغيلية والآلات التشغيلية ذات الدورة الواحدة (لا تستخدم مع القص المشترك أو التسريع المشترك)',
  },
  // 仅对雕刻机与一拖二雕刻机生效
  'paibanSetting.surplusCutSpeedUpTip5': {
    zh: '仅对雕刻机与一拖二雕刻机生效',
    en: 'Only effective for engraving machines and one-turn engraving machines',
    id: 'Hanya efektif untuk mesin engraving dan mesin engraving satu putaran',
    kz: 'Только эффективно для машин гравирования и машин гравирования с одним поворотом',
    th: 'เฉพาะสำหรับเครื่องกลึงอักษรและเครื่องกลึงอักษรหนึ่งรอบ',
    ug: 'ئويما ماشىنىسى ۋە ھەرە ئويما ماشىنىسى بىلەن قوللىنىدۇ',
    vi: 'Chỉ hiệu quả cho máy cắt khắc và máy cắt khắc một vòng',
    zh_tc: '僅對雕刻機與一拖二雕刻機生效',
    ru: 'Эффективно только для гравировальных машин и машин гравирования с одним поворотом',
    ko: '조각기 및 한 바퀴 조각기에만 효과가 있습니다',
    bur: 'အောင်မြင်သည်အထိုင်းအမှတ်များအတွက်ထားသည်',
    ben: 'করাত এনগ্রেভিং মেশিন এবং একটি ঘূর্ণন করাত এনগ্রেভিং মেশিনের জন্য উপযোগিতার জন্য',
    tr: 'Yalnızca işleme makineleri ve bir dönüş işleme makineleri için geçerlidir',
    km: 'មុខងារនេះបច្ចុប្បន្នមិនគាំទ្រការប្រើជាមួយម៉ាស៊ីនឡាស៊ែររួមមួយ ម៉ាស៊ីនកាត់និងចុកចាក់ ការកាត់គែមរួម និងការបង្កើនល្បឿនគែមរួមទេ',
    es: 'Solo efectivo para máquinas de grabado y máquinas de grabado de una vuelta',
    ar: 'فقط فعال لآلات الحفر وآلات الحفر ذات الدورة الواحدة',
  },
  // 功能显示
  'paibanSetting.featureDisplay': {
    zh: '功能显示',
    en: 'Feature display',
    id: 'Tampilan fitur',
    kz: 'Функция көрінісі',
    th: 'การแสดงฟังก์ชัน',
    ug: 'ئىقتىدار كۆرسىتىش',
    vi: 'Hiển thị tính năng',
    zh_tc: '功能顯示',
    ru: 'Отображение функций',
    ko: '기능 표시',
    bur: 'လုပ်ဆောင်ချက် ပြသခြင်း',
    ben: 'বৈশিষ্ট্য প্রদর্শন',
    tr: 'Özellik görünümü',
    km: 'ការបង្ហាញមុខងារ',
    es: 'Visualización de funciones',
    ar: 'عرض الوظائف',
  },
  // 本页面仅控制功能入口是否显示，不修改功能本身的启用状态与参数配置
  'paibanSetting.featureDisplayTip': {
    zh: '本页面仅控制功能入口是否显示，不修改功能本身的启用状态与参数配置',
    en: 'This page only controls whether feature entries are displayed; it does not change whether features are enabled or their parameter settings',
    id: 'Halaman ini hanya mengontrol apakah pintu masuk fitur ditampilkan, tidak mengubah status aktif maupun konfigurasi parameter fitur itu sendiri',
    kz: 'Бұл бет тек функция кіру нүктелерінің көрсетілуін басқарады, функцияның қосу күйі мен параметр конфигурациясын өзгертпейді',
    th: 'หน้านี้ควบคุมเฉพาะการแสดงทางเข้าฟังก์ชันเท่านั้น ไม่แก้ไขสถานะการเปิดใช้งานและการตั้งค่าพารามิเตอร์ของฟังก์ชันเอง',
    ug: 'بۇ بەت پەقەت ئىقتىدار كىرىش ئېغىزىنىڭ كۆرسىتىلىش-كۆرسىتىلمەسلىكىنى كونترول قىلىدۇ، ئىقتىدارنىڭ ئۆزىنىڭ قوزغىتىش ھالىتى ۋە پارامېتىر سەپلىمىسىنى ئۆزگەرتمەيدۇ',
    vi: 'Trang này chỉ kiểm soát việc hiển thị lối vào chức năng, không thay đổi trạng thái bật/tắt và cấu hình tham số của chính chức năng',
    zh_tc: '本頁面僅控制功能入口是否顯示，不修改功能本身的啟用狀態與參數配置',
    ru: 'Эта страница только управляет отображением входов функций и не изменяет состояние включения и параметры самих функций',
    ko: '이 페이지는 기능 진입점 표시 여부만 제어하며, 기능 자체의 사용 여부 및 파라미터 설정은 변경하지 않습니다',
    bur: 'ဤစာမျက်နှာသည် လုပ်ဆောင်ချက်ဝင်ပေါက် ပြသခြင်းကိုသာ ထိန်းချုပ်ပြီး လုပ်ဆောင်ချက်ကိုယ်တိုင်၏ ဖွင့်ထားမှုနှင့် ပါရာမီတာ ဆက်တင်များကို မပြောင်းလဲပါ',
    ben: 'এই পৃষ্ঠা শুধুমাত্র ফিচার এন্ট্রি প্রদর্শন নিয়ন্ত্রণ করে; ফিচারের সক্রিয় অবস্থা ও প্যারামিটার কনফিগারেশন পরিবর্তন করে না',
    tr: 'Bu sayfa yalnızca özellik girişlerinin görüntülenmesini kontrol eder; özelliğin kendisinin etkin durumunu ve parametre yapılandırmasını değiştirmez',
    km: 'ទំព័រនេះគ្រប់គ្រងតែការបង្ហាញច្រកចូលមុខងារប៉ុណ្ណោះ ហើយមិនផ្លាស់ប្តូរស្ថានភាពបើកដំណើរការ និងការកំណត់ប៉ារ៉ាម៉ែត្ររបស់មុខងារខ្លួនឯងទេ',
    es: 'Esta página solo controla si se muestran las entradas de funciones; no modifica el estado de activación ni la configuración de parámetros de la propia función',
    ar: 'تتحكم هذه الصفحة فقط في عرض مداخل الميزات، ولا تعدل حالة التمكين وإعدادات المعلمات للميزة نفسها',
  },
  'alignedPlan.deepSearch': {
    zh: '深度计算',
    en: 'Deep Search',
    id: 'Pencarian Mendalam',
    kz: 'Толық талдау',
    th: 'ค้นหาลึก',
    ug: 'تاللاش',
    vi: 'Tìm kiếm sâu',
    zh_tc: '深度計算',
    ru: 'Глубокий поиск',
    ko: '깊은 검색',
    bur: 'အောင်မြင်သည်အထိုင်းအမှတ်များအတွက်ထားသည်',
    ben: 'গভীর অনুসন্ধান',
    tr: 'Derin Arama',
    km: 'ការស្វែងរកចម្បង',
    es: 'Búsqueda profunda',
    ar: 'بحث عميق',
  },
  'alignedPlan.deepSearchTip': {
    zh: '专属功能，可通过重新排版增加计算深度，以获取更优排版结果',
    en: 'Exclusive feature: increase calculation depth by re-nesting to get better layout results',
    id: 'Fitur eksklusif: tingkatkan kedalaman perhitungan dengan menyusun ulang untuk hasil nesting yang lebih baik',
    kz: 'Арнайы функция: қайта орналастыру арқылы есептеу тереңдігін арттырып, жақсырақ нәтиже алыңыз',
    th: 'ฟีเจอร์พิเศษ: เพิ่มความลึกการคำนวณด้วยการจัดเรียงใหม่เพื่อผลลัพธ์ที่ดีกว่า',
    ug: 'ئالاھىدە ئىقتىدار، قايتا ئورۇنلاشتۇرۇش ئارقىلىق ھېسابلاش چوڭقۇرلۇقىنى ئاشۇرۇپ تېخىمۇ ياخشى نەتىجە ئالالايسىز',
    vi: 'Tính năng độc quyền: tăng độ sâu tính toán bằng cách xếp lại để có kết quả bố trí tốt hơn',
    zh_tc: '專屬功能，可通過重新排版增加計算深度，以獲取更優排版結果',
    ru: 'Эксклюзивная функция: увеличьте глубину расчёта повторной раскладкой для лучшего результата',
    ko: '전용 기능: 재배자를 통해 계산 깊이를 높여 더 나은 배자 결과를 얻을 수 있습니다',
    bur: 'အထူးလုပ်ဆောင်ချက်- ပြန်လည်စီစဉ်ခြင်းဖြင့် တွက်ချက်မှုအနက်ကို တိုးမြှင့်၍ ပိုကောင်းသော ရလဒ်ရယူနိုင်သည်',
    ben: 'এক্সক্লুসিভ ফিচার: পুনরায় লেআউট করে গণনার গভীরতা বাড়িয়ে আরও ভালো ফল পান',
    tr: 'Özel özellik: yeniden yerleşimle hesaplama derinliğini artırarak daha iyi sonuç alın',
    km: 'មុខងារផ្តាច់មុខ៖ បង្កើនជម្រៅគណនាតាមរយៈការរៀបចំឡើងវិញដើម្បីទទួលបានលទ្ធផលល្អជាង',
    es: 'Función exclusiva: aumente la profundidad de cálculo reorganizando para obtener mejores resultados',
    ar: 'ميزة حصرية: زد عمق الحساب بإعادة الترتيب للحصول على نتائج أفضل',
  },
  'alignedPlan.deepSearchTip2': {
    zh: '升级深度计算后，可通过重新排版增加计算深度，以获取更优排版结果，当前可试用',
    en: 'After upgrading Deep Search, re-nest to increase calculation depth for better results. Available for trial now',
    id: 'Setelah upgrade Deep Search, susun ulang untuk meningkatkan kedalaman perhitungan. Saat ini dapat dicoba',
    kz: 'Толық талдауды жаңартқаннан кейін қайта орналастыру арқылы есептеу тереңдігін арттырыңыз. Қазір сынап көруге болады',
    th: 'หลังจากอัปเกรด Deep Search สามารถจัดเรียงใหม่เพื่อเพิ่มความลึกการคำนวณ ขณะนี้ทดลองใช้ได้',
    ug: 'چوڭقۇر ھېسابلاشنى يېڭىلىغاندىن كېيىن، قايتا ئورۇنلاشتۇرۇش ئارقىلىق تېخىمۇ ياخشى نەتىجە ئالالايسىز، ھازىر سىناپ باقسىڭىز بولىدۇ',
    vi: 'Sau khi nâng cấp Deep Search, xếp lại để tăng độ sâu tính toán. Hiện có thể dùng thử',
    zh_tc:
      '升級深度計算後，可通過重新排版增加計算深度，以獲取更優排版結果，當前可試用',
    ru: 'После обновления Deep Search повторная раскладка увеличит глубину расчёта. Сейчас доступен пробный режим',
    ko: 'Deep Search 업그레이드 후 재배자로 계산 깊이를 높여 더 나은 결과를 얻을 수 있습니다. 현재 체험 가능',
    bur: 'Deep Search အဆင့်မြှင့်ပြီးနောက် ပြန်စီစဉ်၍ တွက်ချက်မှုအနက် တိုးနိုင်သည်။ ယခု စမ်းသုံးနိုင်သည်',
    ben: 'Deep Search আপগ্রেডের পর পুনরায় লেআউট করে গণনার গভীরতা বাড়ান। এখন ট্রায়াল করা যায়',
    tr: 'Deep Search yükseltmesinden sonra yeniden yerleşimle hesaplama derinliğini artırın. Şu an denenebilir',
    km: 'បន្ទាប់ពីធ្វើឱ្យ Deep Search ប្រសើរឡើង អាចរៀបចំឡើងវិញដើម្បីបង្កើនជម្រៅគណនា។ បច្ចុប្បន្នអាចសាកល្បង',
    es: 'Tras actualizar Deep Search, reorganice para aumentar la profundidad de cálculo. Ahora disponible en prueba',
    ar: 'بعد ترقية البحث العميق، أعد الترتيب لزيادة عمق الحساب. متاح للتجربة حالياً',
  },
  'alignedPlan.deepSearchTip3': {
    zh: '深度计算给出更省板方案',
    en: 'Deep Search provides a more board-efficient layout',
    id: 'Deep Search memberikan skema nesting yang lebih hemat papan',
    kz: 'Толық талдау тақтаны үнемдейтін жақсырақ нұсқаны ұсынады',
    th: 'Deep Search ให้แผนที่ใช้แผ่นน้อยกว่า',
    ug: 'چوڭقۇر ھېسابلاش تېخىمۇ تەخسە تېجەيدىغان لايىھە بېرىدۇ',
    vi: 'Deep Search đưa ra phương án tiết kiệm tấm hơn',
    zh_tc: '深度計算給出更省板方案',
    ru: 'Deep Search предлагает более экономную по плитам раскладку',
    ko: 'Deep Search가 더 판재를 절약하는 방안을 제시합니다',
    bur: 'Deep Search က ပိုချွေတာသော အစီအစဉ် ပေးသည်',
    ben: 'Deep Search আরও বোর্ড-সাশ্রয়ী পরিকল্পনা দেয়',
    tr: 'Deep Search daha az levha kullanan bir yerleşim sunar',
    km: 'Deep Search ផ្តល់ផែនការដែលសន្សំសំចៃក្តារជាង',
    es: 'Deep Search ofrece un esquema que ahorra más tableros',
    ar: 'البحث العميق يقدم مخططاً أوفر للألواح',
  },
  'alignedPlan.deepSearchTip4': {
    zh: '当前暂无深度计算排版权限，请联系销售购买后使用。',
    en: 'You currently do not have Deep Search nesting permission. Please contact sales to purchase.',
    id: 'Anda belum memiliki izin nesting Deep Search. Silakan hubungi sales untuk membeli.',
    kz: 'Қазір Толық талдау орналастыру рұқсаты жоқ. Сатып алу үшін сатушыға хабарласыңыз.',
    th: 'ขณะนี้ยังไม่มีสิทธิ Deep Search โปรดติดต่อฝ่ายขายเพื่อซื้อ',
    ug: 'ھازىرچە چوڭقۇر ھېسابلاش ئورۇنلاشتۇرۇش ھوقۇقىڭىز يوق، سېتىش خادىمى بىلەن ئالاقىلىشىپ سېتىۋېلىڭ.',
    vi: 'Hiện chưa có quyền xếp Deep Search. Vui lòng liên hệ bộ phận bán hàng để mua.',
    zh_tc: '當前暫無深度計算排版權限，請聯繫銷售購買後使用。',
    ru: 'Сейчас нет прав на раскладку Deep Search. Свяжитесь с отделом продаж для покупки.',
    ko: '현재 Deep Search 배자 권한이 없습니다. 구매를 위해 영업팀에 문의하세요.',
    bur: 'Deep Search စီစဉ်ခွင့် မရှိသေးပါ။ ဝယ်ယူရန် အရောင်းနှင့် ဆက်သွယ်ပါ။',
    ben: 'বর্তমানে Deep Search লেআউট অনুমতি নেই। কিনতে সেলসের সাথে যোগাযোগ করুন।',
    tr: 'Şu an Deep Search yerleşim yetkiniz yok. Satın almak için satış ile iletişime geçin.',
    km: 'បច្ចុប្បន្នមិនទាន់មានសិទ្ធិរៀបចំ Deep Search។ សូមទាក់ទងការលក់ដើម្បីទិញ។',
    es: 'Actualmente no tiene permiso de nesting Deep Search. Contacte a ventas para comprar.',
    ar: 'لا تملك حالياً صلاحية ترتيب البحث العميق. يرجى التواصل مع المبيعات للشراء.',
  },
  'alignedPlan.deepSearchTip5': {
    zh: '升级深度计算后，享有专属服务器算力支持，进一步提升排版质量，当前可预览',
    en: 'After upgrading Deep Search, enjoy dedicated server computing power for better nesting quality. Preview available now',
    id: 'Setelah upgrade Deep Search, nikmati daya komputasi server khusus untuk kualitas nesting lebih baik. Saat ini dapat dipratinjau',
    kz: 'Толық талдауды жаңартқаннан кейін арнайы сервер есептеу қуатын пайдаланып, сапаны арттырыңыз. Қазір алдын ала қарауға болады',
    th: 'หลังจากอัปเกรด Deep Search จะได้พลังประมวลผลเซิร์ฟเวอร์เฉพาะ คุณภาพดีขึ้น ขณะนี้ดูตัวอย่างได้',
    ug: 'چوڭقۇر ھېسابلاشنى يېڭىلىغاندىن كېيىن، ئالاھىدە مۇلازىمېتىر ھېسابلاش كۈچىگە ئېرىشىپ سۈپەتنى يۇقىرى كۆتۈرەلەيسىز، ھازىر كۆرۈپ باقسىڭىز بولىدۇ',
    vi: 'Sau khi nâng cấp Deep Search, được hỗ trợ sức mạnh máy chủ riêng để nâng chất lượng. Hiện có thể xem trước',
    zh_tc:
      '升級深度計算後，享有專屬伺服器算力支持，進一步提升排版質量，當前可預覽',
    ru: 'После обновления Deep Search доступна выделенная серверная мощность для лучшего качества. Сейчас можно просмотреть',
    ko: 'Deep Search 업그레이드 후 전용 서버 연산력으로 배자 품질을 높일 수 있습니다. 현재 미리보기 가능',
    bur: 'Deep Search အဆင့်မြှင့်ပြီးနောက် သီးသန့်ဆာဗာတွက်ချက်အား ရရှိပြီး အရည်အသွေး တိုးတက်သည်။ ယခု ကြိုတင်ကြည့်နိုင်သည်',
    ben: 'Deep Search আপগ্রেডের পর নিবেদিত সার্ভার কম্পিউটিং পাবেন। এখন প্রিভিউ করা যায়',
    tr: 'Deep Search yükseltmesinden sonra özel sunucu hesaplama gücüyle kalite artar. Şu an önizlenebilir',
    km: 'បន្ទាប់ពីធ្វើឱ្យ Deep Search ប្រសើរឡើង ទទួលបានថាមពលម៉ាស៊ីនមេផ្តាច់មុខ។ បច្ចុប្បន្នអាចមើលជាមុន',
    es: 'Tras actualizar Deep Search, disfrute de potencia de servidor dedicada para mejor calidad. Vista previa disponible ahora',
    ar: 'بعد ترقية البحث العميق، استمتع بقوة حوسبة خادم مخصصة لجودة أفضل. المعاينة متاحة حالياً',
  },
} as const
